var kre = Object.defineProperty;
var xre = (t, e, n) => e in t ? kre(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var ua = (t, e, n) => xre(t, typeof e != "symbol" ? e + "" : e, n);
import * as N from "react";
import Ce, { createContext as xn, useContext as Mt, useRef as Ue, useState as De, useDebugValue as Uk, useEffect as ze, forwardRef as en, createElement as Ee, useCallback as nt, useLayoutEffect as us, memo as QO, Children as Ws, isValidElement as N1, cloneElement as vd, useMemo as Ft, useId as bd, Fragment as ds, useInsertionEffect as fg, useReducer as Mre, createRef as Dl, Suspense as Cre, Component as Wk, useImperativeHandle as XO } from "react";
import * as wd from "react-dom";
import hg, { flushSync as Zk, createPortal as eB } from "react-dom";
var Pr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function kd(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Qb = { exports: {} }, Qd = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var GL;
function Are() {
  if (GL) return Qd;
  GL = 1;
  var t = Ce, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, c) {
    var u, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l) r.call(l, u) && !a.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps) for (u in l = s.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: e, type: s, key: f, ref: h, props: d, _owner: i.current };
  }
  return Qd.Fragment = n, Qd.jsx = o, Qd.jsxs = o, Qd;
}
var Xd = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var YL;
function Sre() {
  return YL || (YL = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Ce, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, m = "@@iterator";
    function g(R) {
      if (R === null || typeof R != "object")
        return null;
      var ue = p && R[p] || R[m];
      return typeof ue == "function" ? ue : null;
    }
    var v = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(R) {
      {
        for (var ue = arguments.length, Ae = new Array(ue > 1 ? ue - 1 : 0), Ve = 1; Ve < ue; Ve++)
          Ae[Ve - 1] = arguments[Ve];
        w("error", R, Ae);
      }
    }
    function w(R, ue, Ae) {
      {
        var Ve = v.ReactDebugCurrentFrame, ct = Ve.getStackAddendum();
        ct !== "" && (ue += "%s", Ae = Ae.concat([ct]));
        var yt = Ae.map(function(rt) {
          return String(rt);
        });
        yt.unshift("Warning: " + ue), Function.prototype.apply.call(console[R], console, yt);
      }
    }
    var b = !1, x = !1, A = !1, L = !1, M = !1, j;
    j = Symbol.for("react.module.reference");
    function D(R) {
      return !!(typeof R == "string" || typeof R == "function" || R === r || R === a || M || R === i || R === c || R === u || L || R === h || b || x || A || typeof R == "object" && R !== null && (R.$$typeof === f || R.$$typeof === d || R.$$typeof === o || R.$$typeof === s || R.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      R.$$typeof === j || R.getModuleId !== void 0));
    }
    function z(R, ue, Ae) {
      var Ve = R.displayName;
      if (Ve)
        return Ve;
      var ct = ue.displayName || ue.name || "";
      return ct !== "" ? Ae + "(" + ct + ")" : Ae;
    }
    function H(R) {
      return R.displayName || "Context";
    }
    function V(R) {
      if (R == null)
        return null;
      if (typeof R.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof R == "function")
        return R.displayName || R.name || null;
      if (typeof R == "string")
        return R;
      switch (R) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof R == "object")
        switch (R.$$typeof) {
          case s:
            var ue = R;
            return H(ue) + ".Consumer";
          case o:
            var Ae = R;
            return H(Ae._context) + ".Provider";
          case l:
            return z(R, R.render, "ForwardRef");
          case d:
            var Ve = R.displayName || null;
            return Ve !== null ? Ve : V(R.type) || "Memo";
          case f: {
            var ct = R, yt = ct._payload, rt = ct._init;
            try {
              return V(rt(yt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var F = Object.assign, _ = 0, W, G, Y, Z, oe, ee, ae;
    function fe() {
    }
    fe.__reactDisabledLog = !0;
    function me() {
      {
        if (_ === 0) {
          W = console.log, G = console.info, Y = console.warn, Z = console.error, oe = console.group, ee = console.groupCollapsed, ae = console.groupEnd;
          var R = {
            configurable: !0,
            enumerable: !0,
            value: fe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: R,
            log: R,
            warn: R,
            error: R,
            group: R,
            groupCollapsed: R,
            groupEnd: R
          });
        }
        _++;
      }
    }
    function ge() {
      {
        if (_--, _ === 0) {
          var R = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: F({}, R, {
              value: W
            }),
            info: F({}, R, {
              value: G
            }),
            warn: F({}, R, {
              value: Y
            }),
            error: F({}, R, {
              value: Z
            }),
            group: F({}, R, {
              value: oe
            }),
            groupCollapsed: F({}, R, {
              value: ee
            }),
            groupEnd: F({}, R, {
              value: ae
            })
          });
        }
        _ < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var $ = v.ReactCurrentDispatcher, se;
    function xe(R, ue, Ae) {
      {
        if (se === void 0)
          try {
            throw Error();
          } catch (ct) {
            var Ve = ct.stack.trim().match(/\n( *(at )?)/);
            se = Ve && Ve[1] || "";
          }
        return `
` + se + R;
      }
    }
    var Oe = !1, je;
    {
      var Me = typeof WeakMap == "function" ? WeakMap : Map;
      je = new Me();
    }
    function he(R, ue) {
      if (!R || Oe)
        return "";
      {
        var Ae = je.get(R);
        if (Ae !== void 0)
          return Ae;
      }
      var Ve;
      Oe = !0;
      var ct = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var yt;
      yt = $.current, $.current = null, me();
      try {
        if (ue) {
          var rt = function() {
            throw Error();
          };
          if (Object.defineProperty(rt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(rt, []);
            } catch (Dt) {
              Ve = Dt;
            }
            Reflect.construct(R, [], rt);
          } else {
            try {
              rt.call();
            } catch (Dt) {
              Ve = Dt;
            }
            R.call(rt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Dt) {
            Ve = Dt;
          }
          R();
        }
      } catch (Dt) {
        if (Dt && Ve && typeof Dt.stack == "string") {
          for (var tt = Dt.stack.split(`
`), Te = Ve.stack.split(`
`), Q = tt.length - 1, Se = Te.length - 1; Q >= 1 && Se >= 0 && tt[Q] !== Te[Se]; )
            Se--;
          for (; Q >= 1 && Se >= 0; Q--, Se--)
            if (tt[Q] !== Te[Se]) {
              if (Q !== 1 || Se !== 1)
                do
                  if (Q--, Se--, Se < 0 || tt[Q] !== Te[Se]) {
                    var Fe = `
` + tt[Q].replace(" at new ", " at ");
                    return R.displayName && Fe.includes("<anonymous>") && (Fe = Fe.replace("<anonymous>", R.displayName)), typeof R == "function" && je.set(R, Fe), Fe;
                  }
                while (Q >= 1 && Se >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, $.current = yt, ge(), Error.prepareStackTrace = ct;
      }
      var Rt = R ? R.displayName || R.name : "", Qt = Rt ? xe(Rt) : "";
      return typeof R == "function" && je.set(R, Qt), Qt;
    }
    function pe(R, ue, Ae) {
      return he(R, !1);
    }
    function J(R) {
      var ue = R.prototype;
      return !!(ue && ue.isReactComponent);
    }
    function K(R, ue, Ae) {
      if (R == null)
        return "";
      if (typeof R == "function")
        return he(R, J(R));
      if (typeof R == "string")
        return xe(R);
      switch (R) {
        case c:
          return xe("Suspense");
        case u:
          return xe("SuspenseList");
      }
      if (typeof R == "object")
        switch (R.$$typeof) {
          case l:
            return pe(R.render);
          case d:
            return K(R.type, ue, Ae);
          case f: {
            var Ve = R, ct = Ve._payload, yt = Ve._init;
            try {
              return K(yt(ct), ue, Ae);
            } catch {
            }
          }
        }
      return "";
    }
    var X = Object.prototype.hasOwnProperty, re = {}, Ie = v.ReactDebugCurrentFrame;
    function q(R) {
      if (R) {
        var ue = R._owner, Ae = K(R.type, R._source, ue ? ue.type : null);
        Ie.setExtraStackFrame(Ae);
      } else
        Ie.setExtraStackFrame(null);
    }
    function S(R, ue, Ae, Ve, ct) {
      {
        var yt = Function.call.bind(X);
        for (var rt in R)
          if (yt(R, rt)) {
            var tt = void 0;
            try {
              if (typeof R[rt] != "function") {
                var Te = Error((Ve || "React class") + ": " + Ae + " type `" + rt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof R[rt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Te.name = "Invariant Violation", Te;
              }
              tt = R[rt](ue, rt, Ve, Ae, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Q) {
              tt = Q;
            }
            tt && !(tt instanceof Error) && (q(ct), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ve || "React class", Ae, rt, typeof tt), q(null)), tt instanceof Error && !(tt.message in re) && (re[tt.message] = !0, q(ct), k("Failed %s type: %s", Ae, tt.message), q(null));
          }
      }
    }
    var P = Array.isArray;
    function O(R) {
      return P(R);
    }
    function ne(R) {
      {
        var ue = typeof Symbol == "function" && Symbol.toStringTag, Ae = ue && R[Symbol.toStringTag] || R.constructor.name || "Object";
        return Ae;
      }
    }
    function le(R) {
      try {
        return de(R), !1;
      } catch {
        return !0;
      }
    }
    function de(R) {
      return "" + R;
    }
    function Pe(R) {
      if (le(R))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ne(R)), de(R);
    }
    var ve = v.ReactCurrentOwner, Le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Re, Ke;
    function mt(R) {
      if (X.call(R, "ref")) {
        var ue = Object.getOwnPropertyDescriptor(R, "ref").get;
        if (ue && ue.isReactWarning)
          return !1;
      }
      return R.ref !== void 0;
    }
    function pt(R) {
      if (X.call(R, "key")) {
        var ue = Object.getOwnPropertyDescriptor(R, "key").get;
        if (ue && ue.isReactWarning)
          return !1;
      }
      return R.key !== void 0;
    }
    function Nt(R, ue) {
      typeof R.ref == "string" && ve.current;
    }
    function ye(R, ue) {
      {
        var Ae = function() {
          Re || (Re = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
        };
        Ae.isReactWarning = !0, Object.defineProperty(R, "key", {
          get: Ae,
          configurable: !0
        });
      }
    }
    function _e(R, ue) {
      {
        var Ae = function() {
          Ke || (Ke = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
        };
        Ae.isReactWarning = !0, Object.defineProperty(R, "ref", {
          get: Ae,
          configurable: !0
        });
      }
    }
    var we = function(R, ue, Ae, Ve, ct, yt, rt) {
      var tt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: R,
        key: ue,
        ref: Ae,
        props: rt,
        // Record the component responsible for creating this element.
        _owner: yt
      };
      return tt._store = {}, Object.defineProperty(tt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(tt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ve
      }), Object.defineProperty(tt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ct
      }), Object.freeze && (Object.freeze(tt.props), Object.freeze(tt)), tt;
    };
    function $e(R, ue, Ae, Ve, ct) {
      {
        var yt, rt = {}, tt = null, Te = null;
        Ae !== void 0 && (Pe(Ae), tt = "" + Ae), pt(ue) && (Pe(ue.key), tt = "" + ue.key), mt(ue) && (Te = ue.ref, Nt(ue, ct));
        for (yt in ue)
          X.call(ue, yt) && !Le.hasOwnProperty(yt) && (rt[yt] = ue[yt]);
        if (R && R.defaultProps) {
          var Q = R.defaultProps;
          for (yt in Q)
            rt[yt] === void 0 && (rt[yt] = Q[yt]);
        }
        if (tt || Te) {
          var Se = typeof R == "function" ? R.displayName || R.name || "Unknown" : R;
          tt && ye(rt, Se), Te && _e(rt, Se);
        }
        return we(R, tt, Te, ct, Ve, ve.current, rt);
      }
    }
    var Xe = v.ReactCurrentOwner, Be = v.ReactDebugCurrentFrame;
    function et(R) {
      if (R) {
        var ue = R._owner, Ae = K(R.type, R._source, ue ? ue.type : null);
        Be.setExtraStackFrame(Ae);
      } else
        Be.setExtraStackFrame(null);
    }
    var dt;
    dt = !1;
    function ut(R) {
      return typeof R == "object" && R !== null && R.$$typeof === e;
    }
    function Pt() {
      {
        if (Xe.current) {
          var R = V(Xe.current.type);
          if (R)
            return `

Check the render method of \`` + R + "`.";
        }
        return "";
      }
    }
    function Vt(R) {
      return "";
    }
    var kt = {};
    function sn(R) {
      {
        var ue = Pt();
        if (!ue) {
          var Ae = typeof R == "string" ? R : R.displayName || R.name;
          Ae && (ue = `

Check the top-level render call using <` + Ae + ">.");
        }
        return ue;
      }
    }
    function Sn(R, ue) {
      {
        if (!R._store || R._store.validated || R.key != null)
          return;
        R._store.validated = !0;
        var Ae = sn(ue);
        if (kt[Ae])
          return;
        kt[Ae] = !0;
        var Ve = "";
        R && R._owner && R._owner !== Xe.current && (Ve = " It was passed a child from " + V(R._owner.type) + "."), et(R), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ae, Ve), et(null);
      }
    }
    function ht(R, ue) {
      {
        if (typeof R != "object")
          return;
        if (O(R))
          for (var Ae = 0; Ae < R.length; Ae++) {
            var Ve = R[Ae];
            ut(Ve) && Sn(Ve, ue);
          }
        else if (ut(R))
          R._store && (R._store.validated = !0);
        else if (R) {
          var ct = g(R);
          if (typeof ct == "function" && ct !== R.entries)
            for (var yt = ct.call(R), rt; !(rt = yt.next()).done; )
              ut(rt.value) && Sn(rt.value, ue);
        }
      }
    }
    function gn(R) {
      {
        var ue = R.type;
        if (ue == null || typeof ue == "string")
          return;
        var Ae;
        if (typeof ue == "function")
          Ae = ue.propTypes;
        else if (typeof ue == "object" && (ue.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ue.$$typeof === d))
          Ae = ue.propTypes;
        else
          return;
        if (Ae) {
          var Ve = V(ue);
          S(Ae, R.props, "prop", Ve, R);
        } else if (ue.PropTypes !== void 0 && !dt) {
          dt = !0;
          var ct = V(ue);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ct || "Unknown");
        }
        typeof ue.getDefaultProps == "function" && !ue.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Jn(R) {
      {
        for (var ue = Object.keys(R.props), Ae = 0; Ae < ue.length; Ae++) {
          var Ve = ue[Ae];
          if (Ve !== "children" && Ve !== "key") {
            et(R), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ve), et(null);
            break;
          }
        }
        R.ref !== null && (et(R), k("Invalid attribute `ref` supplied to `React.Fragment`."), et(null));
      }
    }
    var Er = {};
    function ca(R, ue, Ae, Ve, ct, yt) {
      {
        var rt = D(R);
        if (!rt) {
          var tt = "";
          (R === void 0 || typeof R == "object" && R !== null && Object.keys(R).length === 0) && (tt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Te = Vt();
          Te ? tt += Te : tt += Pt();
          var Q;
          R === null ? Q = "null" : O(R) ? Q = "array" : R !== void 0 && R.$$typeof === e ? (Q = "<" + (V(R.type) || "Unknown") + " />", tt = " Did you accidentally export a JSX literal instead of a component?") : Q = typeof R, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Q, tt);
        }
        var Se = $e(R, ue, Ae, ct, yt);
        if (Se == null)
          return Se;
        if (rt) {
          var Fe = ue.children;
          if (Fe !== void 0)
            if (Ve)
              if (O(Fe)) {
                for (var Rt = 0; Rt < Fe.length; Rt++)
                  ht(Fe[Rt], R);
                Object.freeze && Object.freeze(Fe);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ht(Fe, R);
        }
        if (X.call(ue, "key")) {
          var Qt = V(R), Dt = Object.keys(ue).filter(function(xs) {
            return xs !== "key";
          }), Ln = Dt.length > 0 ? "{key: someKey, " + Dt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Er[Qt + Ln]) {
            var vi = Dt.length > 0 ? "{" + Dt.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ln, Qt, vi, Qt), Er[Qt + Ln] = !0;
          }
        }
        return R === r ? Jn(Se) : gn(Se), Se;
      }
    }
    function ur(R, ue, Ae) {
      return ca(R, ue, Ae, !0);
    }
    function Co(R, ue, Ae) {
      return ca(R, ue, Ae, !1);
    }
    var jl = Co, Nl = ur;
    Xd.Fragment = r, Xd.jsx = jl, Xd.jsxs = Nl;
  }()), Xd;
}
process.env.NODE_ENV === "production" ? Qb.exports = Are() : Qb.exports = Sre();
var C = Qb.exports;
function Nr(t) {
  this.content = t;
}
Nr.prototype = {
  constructor: Nr,
  find: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === t) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(t) {
    var e = this.find(t);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(t, e, n) {
    var r = n && n != t ? this.remove(n) : this, i = r.find(t), a = r.content.slice();
    return i == -1 ? a.push(n || t, e) : (a[i + 1] = e, n && (a[i] = n)), new Nr(a);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(t) {
    var e = this.find(t);
    if (e == -1) return this;
    var n = this.content.slice();
    return n.splice(e, 2), new Nr(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(t, e) {
    return new Nr([t, e].concat(this.remove(t).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(t, e) {
    var n = this.remove(t).content.slice();
    return n.push(t, e), new Nr(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(t, e, n) {
    var r = this.remove(e), i = r.content.slice(), a = r.find(t);
    return i.splice(a == -1 ? i.length : a, 0, e, n), new Nr(i);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      t(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(t) {
    return t = Nr.from(t), t.size ? new Nr(t.content.concat(this.subtract(t).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(t) {
    return t = Nr.from(t), t.size ? new Nr(this.subtract(t).content.concat(t.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(t) {
    var e = this;
    t = Nr.from(t);
    for (var n = 0; n < t.content.length; n += 2)
      e = e.remove(t.content[n]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var t = {};
    return this.forEach(function(e, n) {
      t[e] = n;
    }), t;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Nr.from = function(t) {
  if (t instanceof Nr) return t;
  var e = [];
  if (t) for (var n in t) e.push(n, t[n]);
  return new Nr(e);
};
function tB(t, e, n) {
  for (let r = 0; ; r++) {
    if (r == t.childCount || r == e.childCount)
      return t.childCount == e.childCount ? null : n;
    let i = t.child(r), a = e.child(r);
    if (i == a) {
      n += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(a))
      return n;
    if (i.isText && i.text != a.text) {
      for (let o = 0; i.text[o] == a.text[o]; o++)
        n++;
      return n;
    }
    if (i.content.size || a.content.size) {
      let o = tB(i.content, a.content, n + 1);
      if (o != null)
        return o;
    }
    n += i.nodeSize;
  }
}
function nB(t, e, n, r) {
  for (let i = t.childCount, a = e.childCount; ; ) {
    if (i == 0 || a == 0)
      return i == a ? null : { a: n, b: r };
    let o = t.child(--i), s = e.child(--a), l = o.nodeSize;
    if (o == s) {
      n -= l, r -= l;
      continue;
    }
    if (!o.sameMarkup(s))
      return { a: n, b: r };
    if (o.isText && o.text != s.text) {
      let c = 0, u = Math.min(o.text.length, s.text.length);
      for (; c < u && o.text[o.text.length - c - 1] == s.text[s.text.length - c - 1]; )
        c++, n--, r--;
      return { a: n, b: r };
    }
    if (o.content.size || s.content.size) {
      let c = nB(o.content, s.content, n - 1, r - 1);
      if (c)
        return c;
    }
    n -= l, r -= l;
  }
}
class Ne {
  /**
  @internal
  */
  constructor(e, n) {
    if (this.content = e, this.size = n || 0, n == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, n, r, i = 0, a) {
    for (let o = 0, s = 0; s < n; o++) {
      let l = this.content[o], c = s + l.nodeSize;
      if (c > e && r(l, i + s, a || null, o) !== !1 && l.content.size) {
        let u = s + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, n - u), r, i + u);
      }
      s = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, n, r, i) {
    let a = "", o = !0;
    return this.nodesBetween(e, n, (s, l) => {
      let c = s.isText ? s.text.slice(Math.max(e, l) - l, n - l) : s.isLeaf ? i ? typeof i == "function" ? i(s) : i : s.type.spec.leafText ? s.type.spec.leafText(s) : "" : "";
      s.isBlock && (s.isLeaf && c || s.isTextblock) && r && (o ? o = !1 : a += r), a += c;
    }, 0), a;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let n = this.lastChild, r = e.firstChild, i = this.content.slice(), a = 0;
    for (n.isText && n.sameMarkup(r) && (i[i.length - 1] = n.withText(n.text + r.text), a = 1); a < e.content.length; a++)
      i.push(e.content[a]);
    return new Ne(i, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, n = this.size) {
    if (e == 0 && n == this.size)
      return this;
    let r = [], i = 0;
    if (n > e)
      for (let a = 0, o = 0; o < n; a++) {
        let s = this.content[a], l = o + s.nodeSize;
        l > e && ((o < e || l > n) && (s.isText ? s = s.cut(Math.max(0, e - o), Math.min(s.text.length, n - o)) : s = s.cut(Math.max(0, e - o - 1), Math.min(s.content.size, n - o - 1))), r.push(s), i += s.nodeSize), o = l;
      }
    return new Ne(r, i);
  }
  /**
  @internal
  */
  cutByIndex(e, n) {
    return e == n ? Ne.empty : e == 0 && n == this.content.length ? this : new Ne(this.content.slice(e, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, n) {
    let r = this.content[e];
    if (r == n)
      return this;
    let i = this.content.slice(), a = this.size + n.nodeSize - r.nodeSize;
    return i[e] = n, new Ne(i, a);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new Ne([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new Ne(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(e.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let n = this.content[e];
    if (!n)
      throw new RangeError("Index " + e + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let n = 0, r = 0; n < this.content.length; n++) {
      let i = this.content[n];
      e(i, r, n), r += i.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, n = 0) {
    return tB(this, e, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, n = this.size, r = e.size) {
    return nB(this, e, n, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e, n = -1) {
    if (e == 0)
      return um(0, e);
    if (e == this.size)
      return um(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let r = 0, i = 0; ; r++) {
      let a = this.child(r), o = i + a.nodeSize;
      if (o >= e)
        return o == e || n > 0 ? um(r + 1, o) : um(r, i);
      i = o;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return Ne.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new Ne(n.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return Ne.empty;
    let n, r = 0;
    for (let i = 0; i < e.length; i++) {
      let a = e[i];
      r += a.nodeSize, i && a.isText && e[i - 1].sameMarkup(a) ? (n || (n = e.slice(0, i)), n[n.length - 1] = a.withText(n[n.length - 1].text + a.text)) : n && n.push(a);
    }
    return new Ne(n || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return Ne.empty;
    if (e instanceof Ne)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new Ne([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
Ne.empty = new Ne([], 0);
const I5 = { index: 0, offset: 0 };
function um(t, e) {
  return I5.index = t, I5.offset = e, I5;
}
function fy(t, e) {
  if (t === e)
    return !0;
  if (!(t && typeof t == "object") || !(e && typeof e == "object"))
    return !1;
  let n = Array.isArray(t);
  if (Array.isArray(e) != n)
    return !1;
  if (n) {
    if (t.length != e.length)
      return !1;
    for (let r = 0; r < t.length; r++)
      if (!fy(t[r], e[r]))
        return !1;
  } else {
    for (let r in t)
      if (!(r in e) || !fy(t[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in t))
        return !1;
  }
  return !0;
}
let dn = class Xb {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let n, r = !1;
    for (let i = 0; i < e.length; i++) {
      let a = e[i];
      if (this.eq(a))
        return e;
      if (this.type.excludes(a.type))
        n || (n = e.slice(0, i));
      else {
        if (a.type.excludes(this.type))
          return e;
        !r && a.type.rank > this.type.rank && (n || (n = e.slice(0, i)), n.push(this), r = !0), n && n.push(a);
      }
    }
    return n || (n = e.slice()), r || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return e.slice(0, n).concat(e.slice(n + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && fy(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[n.type];
    if (!r)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    let i = r.create(n.attrs);
    return r.checkAttrs(i.attrs), i;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, n) {
    if (e == n)
      return !0;
    if (e.length != n.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(n[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return Xb.none;
    if (e instanceof Xb)
      return [e];
    let n = e.slice();
    return n.sort((r, i) => r.type.rank - i.type.rank), n;
  }
};
dn.none = [];
class hy extends Error {
}
class Je {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, n, r) {
    this.content = e, this.openStart = n, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, n) {
    let r = iB(this.content, e + this.openStart, n);
    return r && new Je(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, n) {
    return new Je(rB(this.content, e + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return Je.empty;
    let r = n.openStart || 0, i = n.openEnd || 0;
    if (typeof r != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Je(Ne.fromJSON(e, n.content), r, i);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, n = !0) {
    let r = 0, i = 0;
    for (let a = e.firstChild; a && !a.isLeaf && (n || !a.type.spec.isolating); a = a.firstChild)
      r++;
    for (let a = e.lastChild; a && !a.isLeaf && (n || !a.type.spec.isolating); a = a.lastChild)
      i++;
    return new Je(e, r, i);
  }
}
Je.empty = new Je(Ne.empty, 0, 0);
function rB(t, e, n) {
  let { index: r, offset: i } = t.findIndex(e), a = t.maybeChild(r), { index: o, offset: s } = t.findIndex(n);
  if (i == e || a.isText) {
    if (s != n && !t.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return t.cut(0, e).append(t.cut(n));
  }
  if (r != o)
    throw new RangeError("Removing non-flat range");
  return t.replaceChild(r, a.copy(rB(a.content, e - i - 1, n - i - 1)));
}
function iB(t, e, n, r) {
  let { index: i, offset: a } = t.findIndex(e), o = t.maybeChild(i);
  if (a == e || o.isText)
    return t.cut(0, e).append(n).append(t.cut(e));
  let s = iB(o.content, e - a - 1, n);
  return s && t.replaceChild(i, o.copy(s));
}
function Lre(t, e, n) {
  if (n.openStart > t.depth)
    throw new hy("Inserted content deeper than insertion position");
  if (t.depth - n.openStart != e.depth - n.openEnd)
    throw new hy("Inconsistent open depths");
  return aB(t, e, n, 0);
}
function aB(t, e, n, r) {
  let i = t.index(r), a = t.node(r);
  if (i == e.index(r) && r < t.depth - n.openStart) {
    let o = aB(t, e, n, r + 1);
    return a.copy(a.content.replaceChild(i, o));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && t.depth == r && e.depth == r) {
      let o = t.parent, s = o.content;
      return Nu(o, s.cut(0, t.parentOffset).append(n.content).append(s.cut(e.parentOffset)));
    } else {
      let { start: o, end: s } = Tre(n, t);
      return Nu(a, sB(t, o, s, e, r));
    }
  else return Nu(a, py(t, e, r));
}
function oB(t, e) {
  if (!e.type.compatibleContent(t.type))
    throw new hy("Cannot join " + e.type.name + " onto " + t.type.name);
}
function e7(t, e, n) {
  let r = t.node(n);
  return oB(r, e.node(n)), r;
}
function ju(t, e) {
  let n = e.length - 1;
  n >= 0 && t.isText && t.sameMarkup(e[n]) ? e[n] = t.withText(e[n].text + t.text) : e.push(t);
}
function Uf(t, e, n, r) {
  let i = (e || t).node(n), a = 0, o = e ? e.index(n) : i.childCount;
  t && (a = t.index(n), t.depth > n ? a++ : t.textOffset && (ju(t.nodeAfter, r), a++));
  for (let s = a; s < o; s++)
    ju(i.child(s), r);
  e && e.depth == n && e.textOffset && ju(e.nodeBefore, r);
}
function Nu(t, e) {
  return t.type.checkContent(e), t.copy(e);
}
function sB(t, e, n, r, i) {
  let a = t.depth > i && e7(t, e, i + 1), o = r.depth > i && e7(n, r, i + 1), s = [];
  return Uf(null, t, i, s), a && o && e.index(i) == n.index(i) ? (oB(a, o), ju(Nu(a, sB(t, e, n, r, i + 1)), s)) : (a && ju(Nu(a, py(t, e, i + 1)), s), Uf(e, n, i, s), o && ju(Nu(o, py(n, r, i + 1)), s)), Uf(r, null, i, s), new Ne(s);
}
function py(t, e, n) {
  let r = [];
  if (Uf(null, t, n, r), t.depth > n) {
    let i = e7(t, e, n + 1);
    ju(Nu(i, py(t, e, n + 1)), r);
  }
  return Uf(e, null, n, r), new Ne(r);
}
function Tre(t, e) {
  let n = e.depth - t.openStart, i = e.node(n).copy(t.content);
  for (let a = n - 1; a >= 0; a--)
    i = e.node(a).copy(Ne.from(i));
  return {
    start: i.resolveNoCache(t.openStart + n),
    end: i.resolveNoCache(i.content.size - t.openEnd - n)
  };
}
class Ch {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.pos = e, this.path = n, this.parentOffset = r, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, n = this.index(this.depth);
    if (n == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], i = e.child(n);
    return r ? e.child(n).cut(r) : i;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(e).cut(0, n) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, n) {
    n = this.resolveDepth(n);
    let r = this.path[n * 3], i = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let a = 0; a < e; a++)
      i += r.child(a).nodeSize;
    return i;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, n = this.index();
    if (e.content.size == 0)
      return dn.none;
    if (this.textOffset)
      return e.child(n).marks;
    let r = e.maybeChild(n - 1), i = e.maybeChild(n);
    if (!r) {
      let s = r;
      r = i, i = s;
    }
    let a = r.marks;
    for (var o = 0; o < a.length; o++)
      a[o].type.spec.inclusive === !1 && (!i || !a[o].isInSet(i.marks)) && (a = a[o--].removeFromSet(a));
    return a;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let r = n.marks, i = e.parent.maybeChild(e.index());
    for (var a = 0; a < r.length; a++)
      r[a].type.spec.inclusive === !1 && (!i || !r[a].isInSet(i.marks)) && (r = r[a--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= e && this.end(n) >= e)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, n) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!n || n(this.node(r))))
        return new my(this, e, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let n = 1; n <= this.depth; n++)
      e += (e ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, n) {
    if (!(n >= 0 && n <= e.content.size))
      throw new RangeError("Position " + n + " out of range");
    let r = [], i = 0, a = n;
    for (let o = e; ; ) {
      let { index: s, offset: l } = o.content.findIndex(a), c = a - l;
      if (r.push(o, s, i + l), !c || (o = o.child(s), o.isText))
        break;
      a = c - 1, i += l + 1;
    }
    return new Ch(n, r, a);
  }
  /**
  @internal
  */
  static resolveCached(e, n) {
    let r = KL.get(e);
    if (r)
      for (let a = 0; a < r.elts.length; a++) {
        let o = r.elts[a];
        if (o.pos == n)
          return o;
      }
    else
      KL.set(e, r = new Ere());
    let i = r.elts[r.i] = Ch.resolve(e, n);
    return r.i = (r.i + 1) % jre, i;
  }
}
class Ere {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const jre = 12, KL = /* @__PURE__ */ new WeakMap();
class my {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const Nre = /* @__PURE__ */ Object.create(null);
let cc = class t7 {
  /**
  @internal
  */
  constructor(e, n, r, i = dn.none) {
    this.type = e, this.attrs = n, this.marks = i, this.content = r || Ne.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, n, r, i = 0) {
    this.content.nodesBetween(e, n, r, i, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(e, n, r, i) {
    return this.content.textBetween(e, n, r, i);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, n, r) {
    return this.type == e && fy(this.attrs, n || e.defaultAttrs || Nre) && dn.sameSet(this.marks, r || dn.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new t7(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new t7(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, n = this.content.size) {
    return e == 0 && n == this.content.size ? this : this.copy(this.content.cut(e, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, n = this.content.size, r = !1) {
    if (e == n)
      return Je.empty;
    let i = this.resolve(e), a = this.resolve(n), o = r ? 0 : i.sharedDepth(n), s = i.start(o), c = i.node(o).content.cut(i.pos - s, a.pos - s);
    return new Je(c, i.depth - o, a.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, n, r) {
    return Lre(this.resolve(e), this.resolve(n), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let n = this; ; ) {
      let { index: r, offset: i } = n.content.findIndex(e);
      if (n = n.maybeChild(r), !n)
        return null;
      if (i == e || n.isText)
        return n;
      e -= i + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: n, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(n), index: n, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(n), index: n, offset: r };
    let i = this.content.child(n - 1);
    return { node: i, index: n - 1, offset: r - i.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return Ch.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return Ch.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, n, r) {
    let i = !1;
    return n > e && this.nodesBetween(e, n, (a) => (r.isInSet(a.marks) && (i = !0), !i)), i;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), lB(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, n, r = Ne.empty, i = 0, a = r.childCount) {
    let o = this.contentMatchAt(e).matchFragment(r, i, a), s = o && o.matchFragment(this.content, n);
    if (!s || !s.validEnd)
      return !1;
    for (let l = i; l < a; l++)
      if (!this.type.allowsMarks(r.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, n, r, i) {
    if (i && !this.type.allowsMarks(i))
      return !1;
    let a = this.contentMatchAt(e).matchType(r), o = a && a.matchFragment(this.content, n);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = dn.none;
    for (let n = 0; n < this.marks.length; n++) {
      let r = this.marks[n];
      r.type.checkAttrs(r.attrs), e = r.addToSet(e);
    }
    if (!dn.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((n) => n.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = n.marks.map(e.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(n.text, r);
    }
    let i = Ne.fromJSON(e, n.content), a = e.nodeType(n.type).create(n.attrs, i, r);
    return a.type.checkAttrs(a.attrs), a;
  }
};
cc.prototype.text = void 0;
let Dre = class n7 extends cc {
  /**
  @internal
  */
  constructor(e, n, r, i) {
    if (super(e, n, null, i), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : lB(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, n) {
    return this.text.slice(e, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new n7(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new n7(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, n = this.text.length) {
    return e == 0 && n == this.text.length ? this : this.withText(this.text.slice(e, n));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
};
function lB(t, e) {
  for (let n = t.length - 1; n >= 0; n--)
    e = t[n].type.name + "(" + e + ")";
  return e;
}
class Wu {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, n) {
    let r = new Ire(e, n);
    if (r.next == null)
      return Wu.empty;
    let i = cB(r);
    r.next && r.err("Unexpected trailing text");
    let a = Fre(Hre(i));
    return _re(a, r), a;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == e)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, n = 0, r = e.childCount) {
    let i = this;
    for (let a = n; i && a < r; a++)
      i = i.matchType(e.child(a).type);
    return i;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: n } = this.next[e];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let n = 0; n < this.next.length; n++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[n].type == e.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, n = !1, r = 0) {
    let i = [this];
    function a(o, s) {
      let l = o.matchFragment(e, r);
      if (l && (!n || l.validEnd))
        return Ne.from(s.map((c) => c.createAndFill()));
      for (let c = 0; c < o.next.length; c++) {
        let { type: u, next: d } = o.next[c];
        if (!(u.isText || u.hasRequiredAttrs()) && i.indexOf(d) == -1) {
          i.push(d);
          let f = a(d, s.concat(u));
          if (f)
            return f;
        }
      }
      return null;
    }
    return a(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let n = this.computeWrapping(e);
    return this.wrapCache.push(e, n), n;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let n = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let i = r.shift(), a = i.match;
      if (a.matchType(e)) {
        let o = [];
        for (let s = i; s.type; s = s.via)
          o.push(s.type);
        return o.reverse();
      }
      for (let o = 0; o < a.next.length; o++) {
        let { type: s, next: l } = a.next[o];
        !s.isLeaf && !s.hasRequiredAttrs() && !(s.name in n) && (!i.type || l.validEnd) && (r.push({ match: s.contentMatch, type: s, via: i }), n[s.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function n(r) {
      e.push(r);
      for (let i = 0; i < r.next.length; i++)
        e.indexOf(r.next[i].next) == -1 && n(r.next[i].next);
    }
    return n(this), e.map((r, i) => {
      let a = i + (r.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < r.next.length; o++)
        a += (o ? ", " : "") + r.next[o].type.name + "->" + e.indexOf(r.next[o].next);
      return a;
    }).join(`
`);
  }
}
Wu.empty = new Wu(!0);
class Ire {
  constructor(e, n) {
    this.string = e, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function cB(t) {
  let e = [];
  do
    e.push(Pre(t));
  while (t.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function Pre(t) {
  let e = [];
  do
    e.push(zre(t));
  while (t.next && t.next != ")" && t.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function zre(t) {
  let e = Bre(t);
  for (; ; )
    if (t.eat("+"))
      e = { type: "plus", expr: e };
    else if (t.eat("*"))
      e = { type: "star", expr: e };
    else if (t.eat("?"))
      e = { type: "opt", expr: e };
    else if (t.eat("{"))
      e = Rre(t, e);
    else
      break;
  return e;
}
function $L(t) {
  /\D/.test(t.next) && t.err("Expected number, got '" + t.next + "'");
  let e = Number(t.next);
  return t.pos++, e;
}
function Rre(t, e) {
  let n = $L(t), r = n;
  return t.eat(",") && (t.next != "}" ? r = $L(t) : r = -1), t.eat("}") || t.err("Unclosed braced range"), { type: "range", min: n, max: r, expr: e };
}
function Ore(t, e) {
  let n = t.nodeTypes, r = n[e];
  if (r)
    return [r];
  let i = [];
  for (let a in n) {
    let o = n[a];
    o.isInGroup(e) && i.push(o);
  }
  return i.length == 0 && t.err("No node type or group '" + e + "' found"), i;
}
function Bre(t) {
  if (t.eat("(")) {
    let e = cB(t);
    return t.eat(")") || t.err("Missing closing paren"), e;
  } else if (/\W/.test(t.next))
    t.err("Unexpected token '" + t.next + "'");
  else {
    let e = Ore(t, t.next).map((n) => (t.inline == null ? t.inline = n.isInline : t.inline != n.isInline && t.err("Mixing inline and block content"), { type: "name", value: n }));
    return t.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function Hre(t) {
  let e = [[]];
  return i(a(t, 0), n()), e;
  function n() {
    return e.push([]) - 1;
  }
  function r(o, s, l) {
    let c = { term: l, to: s };
    return e[o].push(c), c;
  }
  function i(o, s) {
    o.forEach((l) => l.to = s);
  }
  function a(o, s) {
    if (o.type == "choice")
      return o.exprs.reduce((l, c) => l.concat(a(c, s)), []);
    if (o.type == "seq")
      for (let l = 0; ; l++) {
        let c = a(o.exprs[l], s);
        if (l == o.exprs.length - 1)
          return c;
        i(c, s = n());
      }
    else if (o.type == "star") {
      let l = n();
      return r(s, l), i(a(o.expr, l), l), [r(l)];
    } else if (o.type == "plus") {
      let l = n();
      return i(a(o.expr, s), l), i(a(o.expr, l), l), [r(l)];
    } else {
      if (o.type == "opt")
        return [r(s)].concat(a(o.expr, s));
      if (o.type == "range") {
        let l = s;
        for (let c = 0; c < o.min; c++) {
          let u = n();
          i(a(o.expr, l), u), l = u;
        }
        if (o.max == -1)
          i(a(o.expr, l), l);
        else
          for (let c = o.min; c < o.max; c++) {
            let u = n();
            r(l, u), i(a(o.expr, l), u), l = u;
          }
        return [r(l)];
      } else {
        if (o.type == "name")
          return [r(s, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function uB(t, e) {
  return e - t;
}
function JL(t, e) {
  let n = [];
  return r(e), n.sort(uB);
  function r(i) {
    let a = t[i];
    if (a.length == 1 && !a[0].term)
      return r(a[0].to);
    n.push(i);
    for (let o = 0; o < a.length; o++) {
      let { term: s, to: l } = a[o];
      !s && n.indexOf(l) == -1 && r(l);
    }
  }
}
function Fre(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return n(JL(t, 0));
  function n(r) {
    let i = [];
    r.forEach((o) => {
      t[o].forEach(({ term: s, to: l }) => {
        if (!s)
          return;
        let c;
        for (let u = 0; u < i.length; u++)
          i[u][0] == s && (c = i[u][1]);
        JL(t, l).forEach((u) => {
          c || i.push([s, c = []]), c.indexOf(u) == -1 && c.push(u);
        });
      });
    });
    let a = e[r.join(",")] = new Wu(r.indexOf(t.length - 1) > -1);
    for (let o = 0; o < i.length; o++) {
      let s = i[o][1].sort(uB);
      a.next.push({ type: i[o][0], next: e[s.join(",")] || n(s) });
    }
    return a;
  }
}
function _re(t, e) {
  for (let n = 0, r = [t]; n < r.length; n++) {
    let i = r[n], a = !i.validEnd, o = [];
    for (let s = 0; s < i.next.length; s++) {
      let { type: l, next: c } = i.next[s];
      o.push(l.name), a && !(l.isText || l.hasRequiredAttrs()) && (a = !1), r.indexOf(c) == -1 && r.push(c);
    }
    a && e.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function dB(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let r = t[n];
    if (!r.hasDefault)
      return null;
    e[n] = r.default;
  }
  return e;
}
function fB(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r in t) {
    let i = e && e[r];
    if (i === void 0) {
      let a = t[r];
      if (a.hasDefault)
        i = a.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    n[r] = i;
  }
  return n;
}
function hB(t, e, n, r) {
  for (let i in e)
    if (!(i in t))
      throw new RangeError(`Unsupported attribute ${i} for ${n} of type ${i}`);
  for (let i in t) {
    let a = t[i];
    a.validate && a.validate(e[i]);
  }
}
function pB(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      n[r] = new qre(t, r, e[r]);
  return n;
}
let QL = class mB {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.name = e, this.schema = n, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = pB(e, r.attrs), this.defaultAttrs = dB(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == Wu.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : fB(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, n, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new cc(this, this.computeAttrs(e), Ne.from(n), dn.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, n, r) {
    return n = Ne.from(n), this.checkContent(n), new cc(this, this.computeAttrs(e), n, dn.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, n, r) {
    if (e = this.computeAttrs(e), n = Ne.from(n), n.size) {
      let o = this.contentMatch.fillBefore(n);
      if (!o)
        return null;
      n = o.append(n);
    }
    let i = this.contentMatch.matchFragment(n), a = i && i.fillBefore(Ne.empty, !0);
    return a ? new cc(this, e, n.append(a), dn.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let n = this.contentMatch.matchFragment(e);
    if (!n || !n.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    hB(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < e.length; n++)
      if (!this.allowsMarkType(e[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let n;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? n && n.push(e[r]) : n || (n = e.slice(0, r));
    return n ? n.length ? n : dn.none : e;
  }
  /**
  @internal
  */
  static compile(e, n) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((a, o) => r[a] = new mB(a, n, o));
    let i = n.spec.topNode || "doc";
    if (!r[i])
      throw new RangeError("Schema is missing its top node type ('" + i + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let a in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function Vre(t, e, n) {
  let r = n.split("|");
  return (i) => {
    let a = i === null ? "null" : typeof i;
    if (r.indexOf(a) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${e} on type ${t}, got ${a}`);
  };
}
class qre {
  constructor(e, n, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? Vre(e, n, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class pg {
  /**
  @internal
  */
  constructor(e, n, r, i) {
    this.name = e, this.rank = n, this.schema = r, this.spec = i, this.attrs = pB(e, i.attrs), this.excluded = null;
    let a = dB(this.attrs);
    this.instance = a ? new dn(this, a) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new dn(this, fB(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, n) {
    let r = /* @__PURE__ */ Object.create(null), i = 0;
    return e.forEach((a, o) => r[a] = new pg(a, i++, n, o)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var n = 0; n < e.length; n++)
      e[n].type == this && (e = e.slice(0, n).concat(e.slice(n + 1)), n--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (e[n].type == this)
        return e[n];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    hB(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class mg {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let i in e)
      n[i] = e[i];
    n.nodes = Nr.from(e.nodes), n.marks = Nr.from(e.marks || {}), this.nodes = QL.compile(this.spec.nodes, this), this.marks = pg.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in this.nodes) {
      if (i in this.marks)
        throw new RangeError(i + " can not be both a node and a mark");
      let a = this.nodes[i], o = a.spec.content || "", s = a.spec.marks;
      if (a.contentMatch = r[o] || (r[o] = Wu.parse(o, this.nodes)), a.inlineContent = a.contentMatch.inlineContent, a.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!a.isInline || !a.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = a;
      }
      a.markSet = s == "_" ? null : s ? XL(this, s.split(" ")) : s == "" || !a.inlineContent ? [] : null;
    }
    for (let i in this.marks) {
      let a = this.marks[i], o = a.spec.excludes;
      a.excluded = o == null ? [a] : o == "" ? [] : XL(this, o.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, n = null, r, i) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof QL) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(n, r, i);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, n) {
    let r = this.nodes.text;
    return new Dre(r, r.defaultAttrs, e, dn.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, n) {
    return typeof e == "string" && (e = this.marks[e]), e.create(n);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(e) {
    return cc.fromJSON(this, e);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(e) {
    return dn.fromJSON(this, e);
  }
  /**
  @internal
  */
  nodeType(e) {
    let n = this.nodes[e];
    if (!n)
      throw new RangeError("Unknown node type: " + e);
    return n;
  }
}
function XL(t, e) {
  let n = [];
  for (let r = 0; r < e.length; r++) {
    let i = e[r], a = t.marks[i], o = a;
    if (a)
      n.push(a);
    else
      for (let s in t.marks) {
        let l = t.marks[s];
        (i == "_" || l.spec.group && l.spec.group.split(" ").indexOf(i) > -1) && n.push(o = l);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return n;
}
function Ure(t) {
  return t.tag != null;
}
function Wre(t) {
  return t.style != null;
}
let Uo = class r7 {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, n) {
    this.schema = e, this.rules = n, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    n.forEach((i) => {
      if (Ure(i))
        this.tags.push(i);
      else if (Wre(i)) {
        let a = /[^=]*/.exec(i.style)[0];
        r.indexOf(a) < 0 && r.push(a), this.styles.push(i);
      }
    }), this.normalizeLists = !this.tags.some((i) => {
      if (!/^(ul|ol)\b/.test(i.tag) || !i.node)
        return !1;
      let a = e.nodes[i.node];
      return a.contentMatch.matchType(a);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, n = {}) {
    let r = new tT(this, n, !1);
    return r.addAll(e, dn.none, n.from, n.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, n = {}) {
    let r = new tT(this, n, !0);
    return r.addAll(e, dn.none, n.from, n.to), Je.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(e, n, r) {
    for (let i = r ? this.tags.indexOf(r) + 1 : 0; i < this.tags.length; i++) {
      let a = this.tags[i];
      if (Yre(e, a.tag) && (a.namespace === void 0 || e.namespaceURI == a.namespace) && (!a.context || n.matchesContext(a.context))) {
        if (a.getAttrs) {
          let o = a.getAttrs(e);
          if (o === !1)
            continue;
          a.attrs = o || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, n, r, i) {
    for (let a = i ? this.styles.indexOf(i) + 1 : 0; a < this.styles.length; a++) {
      let o = this.styles[a], s = o.style;
      if (!(s.indexOf(e) != 0 || o.context && !r.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      s.length > e.length && (s.charCodeAt(e.length) != 61 || s.slice(e.length + 1) != n))) {
        if (o.getAttrs) {
          let l = o.getAttrs(n);
          if (l === !1)
            continue;
          o.attrs = l || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let n = [];
    function r(i) {
      let a = i.priority == null ? 50 : i.priority, o = 0;
      for (; o < n.length; o++) {
        let s = n[o];
        if ((s.priority == null ? 50 : s.priority) < a)
          break;
      }
      n.splice(o, 0, i);
    }
    for (let i in e.marks) {
      let a = e.marks[i].spec.parseDOM;
      a && a.forEach((o) => {
        r(o = nT(o)), o.mark || o.ignore || o.clearMark || (o.mark = i);
      });
    }
    for (let i in e.nodes) {
      let a = e.nodes[i].spec.parseDOM;
      a && a.forEach((o) => {
        r(o = nT(o)), o.node || o.ignore || o.mark || (o.node = i);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new r7(e, r7.schemaRules(e)));
  }
};
const yB = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, Zre = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, gB = { ol: !0, ul: !0 }, Ah = 1, i7 = 2, P4 = 4;
function eT(t, e, n) {
  return e != null ? (e ? Ah : 0) | (e === "full" ? i7 : 0) : t && t.whitespace == "pre" ? Ah | i7 : n & -5;
}
class dm {
  constructor(e, n, r, i, a, o) {
    this.type = e, this.attrs = n, this.marks = r, this.solid = i, this.options = o, this.content = [], this.activeMarks = dn.none, this.match = a || (o & P4 ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(Ne.from(e));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let r = this.type.contentMatch, i;
        return (i = r.findWrapping(e.type)) ? (this.match = r, i) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & Ah)) {
      let r = this.content[this.content.length - 1], i;
      if (r && r.isText && (i = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let a = r;
        r.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = a.withText(a.text.slice(0, a.text.length - i[0].length));
      }
    }
    let n = Ne.from(this.content);
    return !e && this.match && (n = n.append(this.match.fillBefore(Ne.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !yB.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class tT {
  constructor(e, n, r) {
    this.parser = e, this.options = n, this.isOpen = r, this.open = 0, this.localPreserveWS = !1;
    let i = n.topNode, a, o = eT(null, n.preserveWhitespace, 0) | (r ? P4 : 0);
    i ? a = new dm(i.type, i.attrs, dn.none, !0, n.topMatch || i.type.contentMatch, o) : r ? a = new dm(null, null, dn.none, !0, null, o) : a = new dm(e.schema.topNodeType, null, dn.none, !0, null, o), this.nodes = [a], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, n) {
    e.nodeType == 3 ? this.addTextNode(e, n) : e.nodeType == 1 && this.addElement(e, n);
  }
  addTextNode(e, n) {
    let r = e.nodeValue, i = this.top, a = i.options & i7 ? "full" : this.localPreserveWS || (i.options & Ah) > 0;
    if (a === "full" || i.inlineContext(e) || /[^ \t\r\n\u000c]/.test(r)) {
      if (a)
        a !== "full" ? r = r.replace(/\r?\n|\r/g, " ") : r = r.replace(/\r\n?/g, `
`);
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let o = i.content[i.content.length - 1], s = e.previousSibling;
        (!o || s && s.nodeName == "BR" || o.isText && /[ \t\r\n\u000c]$/.test(o.text)) && (r = r.slice(1));
      }
      r && this.insertNode(this.parser.schema.text(r), n), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, n, r) {
    let i = this.localPreserveWS, a = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let o = e.nodeName.toLowerCase(), s;
    gB.hasOwnProperty(o) && this.parser.normalizeLists && Gre(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (s = this.parser.matchTag(e, this, r));
    e: if (l ? l.ignore : Zre.hasOwnProperty(o))
      this.findInside(e), this.ignoreFallback(e, n);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let c, u = this.needsBlock;
      if (yB.hasOwnProperty(o))
        a.content.length && a.content[0].isInline && this.open && (this.open--, a = this.top), c = !0, a.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, n);
        break e;
      }
      let d = l && l.skip ? n : this.readStyles(e, n);
      d && this.addAll(e, d), c && this.sync(a), this.needsBlock = u;
    } else {
      let c = this.readStyles(e, n);
      c && this.addElementByRule(e, l, c, l.consuming === !1 ? s : void 0);
    }
    this.localPreserveWS = i;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, n) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), n);
  }
  // Called for ignored nodes
  ignoreFallback(e, n) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), n);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, n) {
    let r = e.style;
    if (r && r.length)
      for (let i = 0; i < this.parser.matchedStyles.length; i++) {
        let a = this.parser.matchedStyles[i], o = r.getPropertyValue(a);
        if (o)
          for (let s = void 0; ; ) {
            let l = this.parser.matchStyle(a, o, this, s);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? n = n.filter((c) => !l.clearMark(c)) : n = n.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              s = l;
            else
              break;
          }
      }
    return n;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, n, r, i) {
    let a, o;
    if (n.node)
      if (o = this.parser.schema.nodes[n.node], o.isLeaf)
        this.insertNode(o.create(n.attrs), r) || this.leafFallback(e, r);
      else {
        let l = this.enter(o, n.attrs || null, r, n.preserveWhitespace);
        l && (a = !0, r = l);
      }
    else {
      let l = this.parser.schema.marks[n.mark];
      r = r.concat(l.create(n.attrs));
    }
    let s = this.top;
    if (o && o.isLeaf)
      this.findInside(e);
    else if (i)
      this.addElement(e, r, i);
    else if (n.getContent)
      this.findInside(e), n.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, r));
    else {
      let l = e;
      typeof n.contentElement == "string" ? l = e.querySelector(n.contentElement) : typeof n.contentElement == "function" ? l = n.contentElement(e) : n.contentElement && (l = n.contentElement), this.findAround(e, l, !0), this.addAll(l, r), this.findAround(e, l, !1);
    }
    a && this.sync(s) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, n, r, i) {
    let a = r || 0;
    for (let o = r ? e.childNodes[r] : e.firstChild, s = i == null ? null : e.childNodes[i]; o != s; o = o.nextSibling, ++a)
      this.findAtPoint(e, a), this.addDOM(o, n);
    this.findAtPoint(e, a);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, n) {
    let r, i;
    for (let a = this.open; a >= 0; a--) {
      let o = this.nodes[a], s = o.findWrapping(e);
      if (s && (!r || r.length > s.length) && (r = s, i = o, !s.length) || o.solid)
        break;
    }
    if (!r)
      return null;
    this.sync(i);
    for (let a = 0; a < r.length; a++)
      n = this.enterInner(r[a], null, n, !1);
    return n;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, n) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let i = this.textblockFromContext();
      i && (n = this.enterInner(i, null, n));
    }
    let r = this.findPlace(e, n);
    if (r) {
      this.closeExtra();
      let i = this.top;
      i.match && (i.match = i.match.matchType(e.type));
      let a = dn.none;
      for (let o of r.concat(e.marks))
        (i.type ? i.type.allowsMarkType(o.type) : rT(o.type, e.type)) && (a = o.addToSet(a));
      return i.content.push(e.mark(a)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, n, r, i) {
    let a = this.findPlace(e.create(n), r);
    return a && (a = this.enterInner(e, n, r, !0, i)), a;
  }
  // Open a node of the given type
  enterInner(e, n, r, i = !1, a) {
    this.closeExtra();
    let o = this.top;
    o.match = o.match && o.match.matchType(e);
    let s = eT(e, a, o.options);
    o.options & P4 && o.content.length == 0 && (s |= P4);
    let l = dn.none;
    return r = r.filter((c) => (o.type ? o.type.allowsMarkType(c.type) : rT(c.type, e)) ? (l = c.addToSet(l), !1) : !0), this.nodes.push(new dm(e, n, l, i, null, s)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let n = this.open; n >= 0; n--) {
      if (this.nodes[n] == e)
        return this.open = n, !0;
      this.localPreserveWS && (this.nodes[n].options |= Ah);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let n = this.open; n >= 0; n--) {
      let r = this.nodes[n].content;
      for (let i = r.length - 1; i >= 0; i--)
        e += r[i].nodeSize;
      n && e++;
    }
    return e;
  }
  findAtPoint(e, n) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == n && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && e.nodeType == 1 && e.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(e, n, r) {
    if (e != n && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && e.nodeType == 1 && e.contains(this.find[i].node) && n.compareDocumentPosition(this.find[i].node) & (r ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == e && (this.find[n].pos = this.currentPos - (e.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = e.split("/"), r = this.options.context, i = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), a = -(r ? r.depth + 1 : 0) + (i ? 0 : 1), o = (s, l) => {
      for (; s >= 0; s--) {
        let c = n[s];
        if (c == "") {
          if (s == n.length - 1 || s == 0)
            continue;
          for (; l >= a; l--)
            if (o(s - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && i ? this.nodes[l].type : r && l >= a ? r.node(l - a).type : null;
          if (!u || u.name != c && !u.isInGroup(c))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return o(n.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let n = e.depth; n >= 0; n--) {
        let r = e.node(n).contentMatchAt(e.indexAfter(n)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let n in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[n];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
}
function Gre(t) {
  for (let e = t.firstChild, n = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && gB.hasOwnProperty(r) && n ? (n.appendChild(e), e = n) : r == "li" ? n = e : r && (n = null);
  }
}
function Yre(t, e) {
  return (t.matches || t.msMatchesSelector || t.webkitMatchesSelector || t.mozMatchesSelector).call(t, e);
}
function nT(t) {
  let e = {};
  for (let n in t)
    e[n] = t[n];
  return e;
}
function rT(t, e) {
  let n = e.schema.nodes;
  for (let r in n) {
    let i = n[r];
    if (!i.allowsMarkType(t))
      continue;
    let a = [], o = (s) => {
      a.push(s);
      for (let l = 0; l < s.edgeCount; l++) {
        let { type: c, next: u } = s.edge(l);
        if (c == e || a.indexOf(u) < 0 && o(u))
          return !0;
      }
    };
    if (o(i.contentMatch))
      return !0;
  }
}
class v0 {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, n) {
    this.nodes = e, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, n = {}, r) {
    r || (r = P5(n).createDocumentFragment());
    let i = r, a = [];
    return e.forEach((o) => {
      if (a.length || o.marks.length) {
        let s = 0, l = 0;
        for (; s < a.length && l < o.marks.length; ) {
          let c = o.marks[l];
          if (!this.marks[c.type.name]) {
            l++;
            continue;
          }
          if (!c.eq(a[s][0]) || c.type.spec.spanning === !1)
            break;
          s++, l++;
        }
        for (; s < a.length; )
          i = a.pop()[1];
        for (; l < o.marks.length; ) {
          let c = o.marks[l++], u = this.serializeMark(c, o.isInline, n);
          u && (a.push([c, i]), i.appendChild(u.dom), i = u.contentDOM || u.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(o, n));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(e, n) {
    let { dom: r, contentDOM: i } = z4(P5(n), this.nodes[e.type.name](e), null, e.attrs);
    if (i) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, n, i);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, n = {}) {
    let r = this.serializeNodeInner(e, n);
    for (let i = e.marks.length - 1; i >= 0; i--) {
      let a = this.serializeMark(e.marks[i], e.isInline, n);
      a && ((a.contentDOM || a.dom).appendChild(r), r = a.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(e, n, r = {}) {
    let i = this.marks[e.type.name];
    return i && z4(P5(r), i(e, n), null, e.attrs);
  }
  static renderSpec(e, n, r = null, i) {
    return z4(e, n, r, i);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new v0(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let n = iT(e.nodes);
    return n.text || (n.text = (r) => r.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return iT(e.marks);
  }
}
function iT(t) {
  let e = {};
  for (let n in t) {
    let r = t[n].spec.toDOM;
    r && (e[n] = r);
  }
  return e;
}
function P5(t) {
  return t.document || window.document;
}
const aT = /* @__PURE__ */ new WeakMap();
function Kre(t) {
  let e = aT.get(t);
  return e === void 0 && aT.set(t, e = $re(t)), e;
}
function $re(t) {
  let e = null;
  function n(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          e || (e = []), e.push(r);
        else
          for (let i = 0; i < r.length; i++)
            n(r[i]);
      else
        for (let i in r)
          n(r[i]);
  }
  return n(t), e;
}
function z4(t, e, n, r) {
  if (typeof e == "string")
    return { dom: t.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let i = e[0], a;
  if (typeof i != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (a = Kre(r)) && a.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let o = i.indexOf(" ");
  o > 0 && (n = i.slice(0, o), i = i.slice(o + 1));
  let s, l = n ? t.createElementNS(n, i) : t.createElement(i), c = e[1], u = 1;
  if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
    u = 2;
    for (let d in c)
      if (c[d] != null) {
        let f = d.indexOf(" ");
        f > 0 ? l.setAttributeNS(d.slice(0, f), d.slice(f + 1), c[d]) : l.setAttribute(d, c[d]);
      }
  }
  for (let d = u; d < e.length; d++) {
    let f = e[d];
    if (f === 0) {
      if (d < e.length - 1 || d > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: h, contentDOM: p } = z4(t, f, n, r);
      if (l.appendChild(h), p) {
        if (s)
          throw new RangeError("Multiple content holes");
        s = p;
      }
    }
  }
  return { dom: l, contentDOM: s };
}
const vB = 65535, bB = Math.pow(2, 16);
function Jre(t, e) {
  return t + e * bB;
}
function oT(t) {
  return t & vB;
}
function Qre(t) {
  return (t - (t & vB)) / bB;
}
const wB = 1, kB = 2, R4 = 4, xB = 8;
class a7 {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.pos = e, this.delInfo = n, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & xB) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (wB | R4)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (kB | R4)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & R4) > 0;
  }
}
class Gi {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, n = !1) {
    if (this.ranges = e, this.inverted = n, !e.length && Gi.empty)
      return Gi.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let n = 0, r = oT(e);
    if (!this.inverted)
      for (let i = 0; i < r; i++)
        n += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[r * 3] + n + Qre(e);
  }
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  map(e, n = 1) {
    return this._map(e, n, !0);
  }
  /**
  @internal
  */
  _map(e, n, r) {
    let i = 0, a = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? i : 0);
      if (l > e)
        break;
      let c = this.ranges[s + a], u = this.ranges[s + o], d = l + c;
      if (e <= d) {
        let f = c ? e == l ? -1 : e == d ? 1 : n : n, h = l + i + (f < 0 ? 0 : u);
        if (r)
          return h;
        let p = e == (n < 0 ? l : d) ? null : Jre(s / 3, e - l), m = e == l ? kB : e == d ? wB : R4;
        return (n < 0 ? e != l : e != d) && (m |= xB), new a7(h, m, p);
      }
      i += u - c;
    }
    return r ? e + i : new a7(e + i, 0, null);
  }
  /**
  @internal
  */
  touches(e, n) {
    let r = 0, i = oT(n), a = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let c = this.ranges[s + a], u = l + c;
      if (e <= u && s == i * 3)
        return !0;
      r += this.ranges[s + o] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let n = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let i = 0, a = 0; i < this.ranges.length; i += 3) {
      let o = this.ranges[i], s = o - (this.inverted ? a : 0), l = o + (this.inverted ? 0 : a), c = this.ranges[i + n], u = this.ranges[i + r];
      e(s, s + c, l, l + u), a += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new Gi(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? Gi.empty : new Gi(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
Gi.empty = new Gi([]);
class Sh {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, n, r = 0, i = e ? e.length : 0) {
    this.mirror = n, this.from = r, this.to = i, this._maps = e || [], this.ownData = !(e || n);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, n = this.maps.length) {
    return new Sh(this._maps, this.mirror, e, n);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, n) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), n != null && this.setMirror(this._maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let n = 0, r = this._maps.length; n < e._maps.length; n++) {
      let i = e.getMirror(n);
      this.appendMap(e._maps[n], i != null && i < n ? r + i : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == e)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, n) {
    this.mirror || (this.mirror = []), this.mirror.push(e, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let n = e.maps.length - 1, r = this._maps.length + e._maps.length; n >= 0; n--) {
      let i = e.getMirror(n);
      this.appendMap(e._maps[n].invert(), i != null && i > n ? r - i - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new Sh();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, n = 1) {
    if (this.mirror)
      return this._map(e, n, !0);
    for (let r = this.from; r < this.to; r++)
      e = this._maps[r].map(e, n);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  /**
  @internal
  */
  _map(e, n, r) {
    let i = 0;
    for (let a = this.from; a < this.to; a++) {
      let o = this._maps[a], s = o.mapResult(e, n);
      if (s.recover != null) {
        let l = this.getMirror(a);
        if (l != null && l > a && l < this.to) {
          a = l, e = this._maps[l].recover(s.recover);
          continue;
        }
      }
      i |= s.delInfo, e = s.pos;
    }
    return r ? e : new a7(e, i, null);
  }
}
const z5 = /* @__PURE__ */ Object.create(null);
class Xr {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return Gi.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = z5[n.stepType];
    if (!r)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, n) {
    if (e in z5)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return z5[e] = n, n.prototype.jsonID = e, n;
  }
}
class sr {
  /**
  @internal
  */
  constructor(e, n) {
    this.doc = e, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new sr(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new sr(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, n, r, i) {
    try {
      return sr.ok(e.replace(n, r, i));
    } catch (a) {
      if (a instanceof hy)
        return sr.fail(a.message);
      throw a;
    }
  }
}
function Gk(t, e, n) {
  let r = [];
  for (let i = 0; i < t.childCount; i++) {
    let a = t.child(i);
    a.content.size && (a = a.copy(Gk(a.content, e, a))), a.isInline && (a = e(a, n, i)), r.push(a);
  }
  return Ne.fromArray(r);
}
class nc extends Xr {
  /**
  Create a mark step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = e.resolve(this.from), i = r.node(r.sharedDepth(this.to)), a = new Je(Gk(n.content, (o, s) => !o.isAtom || !s.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), i), n.openStart, n.openEnd);
    return sr.fromReplace(e, this.from, this.to, a);
  }
  invert() {
    return new Ro(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new nc(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof nc && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new nc(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new nc(n.from, n.to, e.markFromJSON(n.mark));
  }
}
Xr.jsonID("addMark", nc);
class Ro extends Xr {
  /**
  Create a mark-removing step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = new Je(Gk(n.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), e), n.openStart, n.openEnd);
    return sr.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new nc(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new Ro(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Ro && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Ro(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Ro(n.from, n.to, e.markFromJSON(n.mark));
  }
}
Xr.jsonID("removeMark", Ro);
class rc extends Xr {
  /**
  Create a node mark step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return sr.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return sr.fromReplace(e, this.pos, this.pos + 1, new Je(Ne.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    if (n) {
      let r = this.mark.addToSet(n.marks);
      if (r.length == n.marks.length) {
        for (let i = 0; i < n.marks.length; i++)
          if (!n.marks[i].isInSet(r))
            return new rc(this.pos, n.marks[i]);
        return new rc(this.pos, this.mark);
      }
    }
    return new D1(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new rc(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new rc(n.pos, e.markFromJSON(n.mark));
  }
}
Xr.jsonID("addNodeMark", rc);
class D1 extends Xr {
  /**
  Create a mark-removing step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return sr.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return sr.fromReplace(e, this.pos, this.pos + 1, new Je(Ne.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new rc(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new D1(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new D1(n.pos, e.markFromJSON(n.mark));
  }
}
Xr.jsonID("removeNodeMark", D1);
class fr extends Xr {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, n, r, i = !1) {
    super(), this.from = e, this.to = n, this.slice = r, this.structure = i;
  }
  apply(e) {
    return this.structure && o7(e, this.from, this.to) ? sr.fail("Structure replace would overwrite content") : sr.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new Gi([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new fr(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deletedAcross && r.deletedAcross ? null : new fr(n.pos, Math.max(n.pos, r.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof fr) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let n = this.slice.size + e.slice.size == 0 ? Je.empty : new Je(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new fr(this.from, this.to + (e.to - e.from), n, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let n = this.slice.size + e.slice.size == 0 ? Je.empty : new Je(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new fr(e.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new fr(n.from, n.to, Je.fromJSON(e, n.slice), !!n.structure);
  }
}
Xr.jsonID("replace", fr);
class pr extends Xr {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, n, r, i, a, o, s = !1) {
    super(), this.from = e, this.to = n, this.gapFrom = r, this.gapTo = i, this.slice = a, this.insert = o, this.structure = s;
  }
  apply(e) {
    if (this.structure && (o7(e, this.from, this.gapFrom) || o7(e, this.gapTo, this.to)))
      return sr.fail("Structure gap-replace would overwrite content");
    let n = e.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return sr.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, n.content);
    return r ? sr.fromReplace(e, this.from, this.to, r) : sr.fail("Content does not fit in gap");
  }
  getMap() {
    return new Gi([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let n = this.gapTo - this.gapFrom;
    return new pr(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), i = this.from == this.gapFrom ? n.pos : e.map(this.gapFrom, -1), a = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return n.deletedAcross && r.deletedAcross || i < n.pos || a > r.pos ? null : new pr(n.pos, r.pos, i, a, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new pr(n.from, n.to, n.gapFrom, n.gapTo, Je.fromJSON(e, n.slice), n.insert, !!n.structure);
  }
}
Xr.jsonID("replaceAround", pr);
function o7(t, e, n) {
  let r = t.resolve(e), i = n - e, a = r.depth;
  for (; i > 0 && a > 0 && r.indexAfter(a) == r.node(a).childCount; )
    a--, i--;
  if (i > 0) {
    let o = r.node(a).maybeChild(r.indexAfter(a));
    for (; i > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, i--;
    }
  }
  return !1;
}
function Xre(t, e, n, r) {
  let i = [], a = [], o, s;
  t.doc.nodesBetween(e, n, (l, c, u) => {
    if (!l.isInline)
      return;
    let d = l.marks;
    if (!r.isInSet(d) && u.type.allowsMarkType(r.type)) {
      let f = Math.max(c, e), h = Math.min(c + l.nodeSize, n), p = r.addToSet(d);
      for (let m = 0; m < d.length; m++)
        d[m].isInSet(p) || (o && o.to == f && o.mark.eq(d[m]) ? o.to = h : i.push(o = new Ro(f, h, d[m])));
      s && s.to == f ? s.to = h : a.push(s = new nc(f, h, r));
    }
  }), i.forEach((l) => t.step(l)), a.forEach((l) => t.step(l));
}
function eie(t, e, n, r) {
  let i = [], a = 0;
  t.doc.nodesBetween(e, n, (o, s) => {
    if (!o.isInline)
      return;
    a++;
    let l = null;
    if (r instanceof pg) {
      let c = o.marks, u;
      for (; u = r.isInSet(c); )
        (l || (l = [])).push(u), c = u.removeFromSet(c);
    } else r ? r.isInSet(o.marks) && (l = [r]) : l = o.marks;
    if (l && l.length) {
      let c = Math.min(s + o.nodeSize, n);
      for (let u = 0; u < l.length; u++) {
        let d = l[u], f;
        for (let h = 0; h < i.length; h++) {
          let p = i[h];
          p.step == a - 1 && d.eq(i[h].style) && (f = p);
        }
        f ? (f.to = c, f.step = a) : i.push({ style: d, from: Math.max(s, e), to: c, step: a });
      }
    }
  }), i.forEach((o) => t.step(new Ro(o.from, o.to, o.style)));
}
function Yk(t, e, n, r = n.contentMatch, i = !0) {
  let a = t.doc.nodeAt(e), o = [], s = e + 1;
  for (let l = 0; l < a.childCount; l++) {
    let c = a.child(l), u = s + c.nodeSize, d = r.matchType(c.type);
    if (!d)
      o.push(new fr(s, u, Je.empty));
    else {
      r = d;
      for (let f = 0; f < c.marks.length; f++)
        n.allowsMarkType(c.marks[f].type) || t.step(new Ro(s, u, c.marks[f]));
      if (i && c.isText && n.whitespace != "pre") {
        let f, h = /\r?\n|\r/g, p;
        for (; f = h.exec(c.text); )
          p || (p = new Je(Ne.from(n.schema.text(" ", n.allowedMarks(c.marks))), 0, 0)), o.push(new fr(s + f.index, s + f.index + f[0].length, p));
      }
    }
    s = u;
  }
  if (!r.validEnd) {
    let l = r.fillBefore(Ne.empty, !0);
    t.replace(s, s, new Je(l, 0, 0));
  }
  for (let l = o.length - 1; l >= 0; l--)
    t.step(o[l]);
}
function tie(t, e, n) {
  return (e == 0 || t.canReplace(e, t.childCount)) && (n == t.childCount || t.canReplace(0, n));
}
function b0(t) {
  let n = t.parent.content.cutByIndex(t.startIndex, t.endIndex);
  for (let r = t.depth; ; --r) {
    let i = t.$from.node(r), a = t.$from.index(r), o = t.$to.indexAfter(r);
    if (r < t.depth && i.canReplace(a, o, n))
      return r;
    if (r == 0 || i.type.spec.isolating || !tie(i, a, o))
      break;
  }
  return null;
}
function nie(t, e, n) {
  let { $from: r, $to: i, depth: a } = e, o = r.before(a + 1), s = i.after(a + 1), l = o, c = s, u = Ne.empty, d = 0;
  for (let p = a, m = !1; p > n; p--)
    m || r.index(p) > 0 ? (m = !0, u = Ne.from(r.node(p).copy(u)), d++) : l--;
  let f = Ne.empty, h = 0;
  for (let p = a, m = !1; p > n; p--)
    m || i.after(p + 1) < i.end(p) ? (m = !0, f = Ne.from(i.node(p).copy(f)), h++) : c++;
  t.step(new pr(l, c, o, s, new Je(u.append(f), d, h), u.size - d, !0));
}
function yg(t, e, n = null, r = t) {
  let i = rie(t, e), a = i && iie(r, e);
  return a ? i.map(sT).concat({ type: e, attrs: n }).concat(a.map(sT)) : null;
}
function sT(t) {
  return { type: t, attrs: null };
}
function rie(t, e) {
  let { parent: n, startIndex: r, endIndex: i } = t, a = n.contentMatchAt(r).findWrapping(e);
  if (!a)
    return null;
  let o = a.length ? a[0] : e;
  return n.canReplaceWith(r, i, o) ? a : null;
}
function iie(t, e) {
  let { parent: n, startIndex: r, endIndex: i } = t, a = n.child(r), o = e.contentMatch.findWrapping(a.type);
  if (!o)
    return null;
  let l = (o.length ? o[o.length - 1] : e).contentMatch;
  for (let c = r; l && c < i; c++)
    l = l.matchType(n.child(c).type);
  return !l || !l.validEnd ? null : o;
}
function aie(t, e, n) {
  let r = Ne.empty;
  for (let o = n.length - 1; o >= 0; o--) {
    if (r.size) {
      let s = n[o].type.contentMatch.matchFragment(r);
      if (!s || !s.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = Ne.from(n[o].type.create(n[o].attrs, r));
  }
  let i = e.start, a = e.end;
  t.step(new pr(i, a, i, a, new Je(r, 0, 0), n.length, !0));
}
function oie(t, e, n, r, i) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let a = t.steps.length;
  t.doc.nodesBetween(e, n, (o, s) => {
    let l = typeof i == "function" ? i(o) : i;
    if (o.isTextblock && !o.hasMarkup(r, l) && sie(t.doc, t.mapping.slice(a).map(s), r)) {
      let c = null;
      if (r.schema.linebreakReplacement) {
        let h = r.whitespace == "pre", p = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        h && !p ? c = !1 : !h && p && (c = !0);
      }
      c === !1 && CB(t, o, s, a), Yk(t, t.mapping.slice(a).map(s, 1), r, void 0, c === null);
      let u = t.mapping.slice(a), d = u.map(s, 1), f = u.map(s + o.nodeSize, 1);
      return t.step(new pr(d, f, d + 1, f - 1, new Je(Ne.from(r.create(l, null, o.marks)), 0, 0), 1, !0)), c === !0 && MB(t, o, s, a), !1;
    }
  });
}
function MB(t, e, n, r) {
  e.forEach((i, a) => {
    if (i.isText) {
      let o, s = /\r?\n|\r/g;
      for (; o = s.exec(i.text); ) {
        let l = t.mapping.slice(r).map(n + 1 + a + o.index);
        t.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function CB(t, e, n, r) {
  e.forEach((i, a) => {
    if (i.type == i.type.schema.linebreakReplacement) {
      let o = t.mapping.slice(r).map(n + 1 + a);
      t.replaceWith(o, o + 1, e.type.schema.text(`
`));
    }
  });
}
function sie(t, e, n) {
  let r = t.resolve(e), i = r.index();
  return r.parent.canReplaceWith(i, i + 1, n);
}
function lie(t, e, n, r, i) {
  let a = t.doc.nodeAt(e);
  if (!a)
    throw new RangeError("No node at given position");
  n || (n = a.type);
  let o = n.create(r, null, i || a.marks);
  if (a.isLeaf)
    return t.replaceWith(e, e + a.nodeSize, o);
  if (!n.validContent(a.content))
    throw new RangeError("Invalid content for node type " + n.name);
  t.step(new pr(e, e + a.nodeSize, e + 1, e + a.nodeSize - 1, new Je(Ne.from(o), 0, 0), 1, !0));
}
function Ji(t, e, n = 1, r) {
  let i = t.resolve(e), a = i.depth - n, o = r && r[r.length - 1] || i.parent;
  if (a < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !o.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let c = i.depth - 1, u = n - 2; c > a; c--, u--) {
    let d = i.node(c), f = i.index(c);
    if (d.type.spec.isolating)
      return !1;
    let h = d.content.cutByIndex(f, d.childCount), p = r && r[u + 1];
    p && (h = h.replaceChild(0, p.type.create(p.attrs)));
    let m = r && r[u] || d;
    if (!d.canReplace(f + 1, d.childCount) || !m.type.validContent(h))
      return !1;
  }
  let s = i.indexAfter(a), l = r && r[0];
  return i.node(a).canReplaceWith(s, s, l ? l.type : i.node(a + 1).type);
}
function cie(t, e, n = 1, r) {
  let i = t.doc.resolve(e), a = Ne.empty, o = Ne.empty;
  for (let s = i.depth, l = i.depth - n, c = n - 1; s > l; s--, c--) {
    a = Ne.from(i.node(s).copy(a));
    let u = r && r[c];
    o = Ne.from(u ? u.type.create(u.attrs, o) : i.node(s).copy(o));
  }
  t.step(new fr(e, e, new Je(a.append(o), n, n), !0));
}
function po(t, e) {
  let n = t.resolve(e), r = n.index();
  return AB(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function uie(t, e) {
  e.content.size || t.type.compatibleContent(e.type);
  let n = t.contentMatchAt(t.childCount), { linebreakReplacement: r } = t.type.schema;
  for (let i = 0; i < e.childCount; i++) {
    let a = e.child(i), o = a.type == r ? t.type.schema.nodes.text : a.type;
    if (n = n.matchType(o), !n || !t.type.allowsMarks(a.marks))
      return !1;
  }
  return n.validEnd;
}
function AB(t, e) {
  return !!(t && e && !t.isLeaf && uie(t, e));
}
function xd(t, e, n = -1) {
  let r = t.resolve(e);
  for (let i = r.depth; ; i--) {
    let a, o, s = r.index(i);
    if (i == r.depth ? (a = r.nodeBefore, o = r.nodeAfter) : n > 0 ? (a = r.node(i + 1), s++, o = r.node(i).maybeChild(s)) : (a = r.node(i).maybeChild(s - 1), o = r.node(i + 1)), a && !a.isTextblock && AB(a, o) && r.node(i).canReplace(s, s + 1))
      return e;
    if (i == 0)
      break;
    e = n < 0 ? r.before(i) : r.after(i);
  }
}
function die(t, e, n) {
  let r = null, { linebreakReplacement: i } = t.doc.type.schema, a = t.doc.resolve(e - n), o = a.node().type;
  if (i && o.inlineContent) {
    let u = o.whitespace == "pre", d = !!o.contentMatch.matchType(i);
    u && !d ? r = !1 : !u && d && (r = !0);
  }
  let s = t.steps.length;
  if (r === !1) {
    let u = t.doc.resolve(e + n);
    CB(t, u.node(), u.before(), s);
  }
  o.inlineContent && Yk(t, e + n - 1, o, a.node().contentMatchAt(a.index()), r == null);
  let l = t.mapping.slice(s), c = l.map(e - n);
  if (t.step(new fr(c, l.map(e + n, -1), Je.empty, !0)), r === !0) {
    let u = t.doc.resolve(c);
    MB(t, u.node(), u.before(), t.steps.length);
  }
  return t;
}
function fie(t, e, n) {
  let r = t.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), n))
    return e;
  if (r.parentOffset == 0)
    for (let i = r.depth - 1; i >= 0; i--) {
      let a = r.index(i);
      if (r.node(i).canReplaceWith(a, a, n))
        return r.before(i + 1);
      if (a > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let i = r.depth - 1; i >= 0; i--) {
      let a = r.indexAfter(i);
      if (r.node(i).canReplaceWith(a, a, n))
        return r.after(i + 1);
      if (a < r.node(i).childCount)
        return null;
    }
  return null;
}
function SB(t, e, n) {
  let r = t.resolve(e);
  if (!n.content.size)
    return e;
  let i = n.content;
  for (let a = 0; a < n.openStart; a++)
    i = i.firstChild.content;
  for (let a = 1; a <= (n.openStart == 0 && n.size ? 2 : 1); a++)
    for (let o = r.depth; o >= 0; o--) {
      let s = o == r.depth ? 0 : r.pos <= (r.start(o + 1) + r.end(o + 1)) / 2 ? -1 : 1, l = r.index(o) + (s > 0 ? 1 : 0), c = r.node(o), u = !1;
      if (a == 1)
        u = c.canReplace(l, l, i);
      else {
        let d = c.contentMatchAt(l).findWrapping(i.firstChild.type);
        u = d && c.canReplaceWith(l, l, d[0]);
      }
      if (u)
        return s == 0 ? r.pos : s < 0 ? r.before(o + 1) : r.after(o + 1);
    }
  return null;
}
function gg(t, e, n = e, r = Je.empty) {
  if (e == n && !r.size)
    return null;
  let i = t.resolve(e), a = t.resolve(n);
  return LB(i, a, r) ? new fr(e, n, r) : new hie(i, a, r).fit();
}
function LB(t, e, n) {
  return !n.openStart && !n.openEnd && t.start() == e.start() && t.parent.canReplace(t.index(), e.index(), n.content);
}
class hie {
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.unplaced = r, this.frontier = [], this.placed = Ne.empty;
    for (let i = 0; i <= e.depth; i++) {
      let a = e.node(i);
      this.frontier.push({
        type: a.type,
        match: a.contentMatchAt(e.indexAfter(i))
      });
    }
    for (let i = e.depth; i > 0; i--)
      this.placed = Ne.from(e.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, r = this.$from, i = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!i)
      return null;
    let a = this.placed, o = r.depth, s = i.depth;
    for (; o && s && a.childCount == 1; )
      a = a.firstChild.content, o--, s--;
    let l = new Je(a, o, s);
    return e > -1 ? new pr(r.pos, e, this.$to.pos, this.$to.end(), l, n) : l.size || r.pos != this.$to.pos ? new fr(r.pos, i.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let n = this.unplaced.content, r = 0, i = this.unplaced.openEnd; r < e; r++) {
      let a = n.firstChild;
      if (n.childCount > 1 && (i = 0), a.type.spec.isolating && i <= r) {
        e = r;
        break;
      }
      n = a.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let r = n == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let i, a = null;
        r ? (a = R5(this.unplaced.content, r - 1).firstChild, i = a.content) : i = this.unplaced.content;
        let o = i.firstChild;
        for (let s = this.depth; s >= 0; s--) {
          let { type: l, match: c } = this.frontier[s], u, d = null;
          if (n == 1 && (o ? c.matchType(o.type) || (d = c.fillBefore(Ne.from(o), !1)) : a && l.compatibleContent(a.type)))
            return { sliceDepth: r, frontierDepth: s, parent: a, inject: d };
          if (n == 2 && o && (u = c.findWrapping(o.type)))
            return { sliceDepth: r, frontierDepth: s, parent: a, wrap: u };
          if (a && c.matchType(a.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, i = R5(e, n);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new Je(e, n + 1, Math.max(r, i.size + n >= e.size - r ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, i = R5(e, n);
    if (i.childCount <= 1 && n > 0) {
      let a = e.size - n <= n + i.size;
      this.unplaced = new Je(Ef(e, n - 1, 1), n - 1, a ? n - 1 : r);
    } else
      this.unplaced = new Je(Ef(e, n, 1), n, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: n, parent: r, inject: i, wrap: a }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (a)
      for (let m = 0; m < a.length; m++)
        this.openFrontierNode(a[m]);
    let o = this.unplaced, s = r ? r.content : o.content, l = o.openStart - e, c = 0, u = [], { match: d, type: f } = this.frontier[n];
    if (i) {
      for (let m = 0; m < i.childCount; m++)
        u.push(i.child(m));
      d = d.matchFragment(i);
    }
    let h = s.size + e - (o.content.size - o.openEnd);
    for (; c < s.childCount; ) {
      let m = s.child(c), g = d.matchType(m.type);
      if (!g)
        break;
      c++, (c > 1 || l == 0 || m.content.size) && (d = g, u.push(TB(m.mark(f.allowedMarks(m.marks)), c == 1 ? l : 0, c == s.childCount ? h : -1)));
    }
    let p = c == s.childCount;
    p || (h = -1), this.placed = jf(this.placed, n, Ne.from(u)), this.frontier[n].match = d, p && h < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let m = 0, g = s; m < h; m++) {
      let v = g.lastChild;
      this.frontier.push({ type: v.type, match: v.contentMatchAt(v.childCount) }), g = v.content;
    }
    this.unplaced = p ? e == 0 ? Je.empty : new Je(Ef(o.content, e - 1, 1), e - 1, h < 0 ? o.openEnd : e - 1) : new Je(Ef(o.content, e, c), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], n;
    if (!e.type.isTextblock || !O5(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, i = this.$to.after(r);
    for (; r > 1 && i == this.$to.end(--r); )
      ++i;
    return i;
  }
  findCloseLevel(e) {
    e: for (let n = Math.min(this.depth, e.depth); n >= 0; n--) {
      let { match: r, type: i } = this.frontier[n], a = n < e.depth && e.end(n + 1) == e.pos + (e.depth - (n + 1)), o = O5(e, n, i, r, a);
      if (o) {
        for (let s = n - 1; s >= 0; s--) {
          let { match: l, type: c } = this.frontier[s], u = O5(e, s, c, l, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: n, fit: o, move: a ? e.doc.resolve(e.after(n + 1)) : e };
      }
    }
  }
  close(e) {
    let n = this.findCloseLevel(e);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = jf(this.placed, n.depth, n.fit)), e = n.move;
    for (let r = n.depth + 1; r <= e.depth; r++) {
      let i = e.node(r), a = i.type.contentMatch.fillBefore(i.content, !0, e.index(r));
      this.openFrontierNode(i.type, i.attrs, a);
    }
    return e;
  }
  openFrontierNode(e, n = null, r) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(e), this.placed = jf(this.placed, this.depth, Ne.from(e.create(n, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(Ne.empty, !0);
    n.childCount && (this.placed = jf(this.placed, this.frontier.length, n));
  }
}
function Ef(t, e, n) {
  return e == 0 ? t.cutByIndex(n, t.childCount) : t.replaceChild(0, t.firstChild.copy(Ef(t.firstChild.content, e - 1, n)));
}
function jf(t, e, n) {
  return e == 0 ? t.append(n) : t.replaceChild(t.childCount - 1, t.lastChild.copy(jf(t.lastChild.content, e - 1, n)));
}
function R5(t, e) {
  for (let n = 0; n < e; n++)
    t = t.firstChild.content;
  return t;
}
function TB(t, e, n) {
  if (e <= 0)
    return t;
  let r = t.content;
  return e > 1 && (r = r.replaceChild(0, TB(r.firstChild, e - 1, r.childCount == 1 ? n - 1 : 0))), e > 0 && (r = t.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(t.type.contentMatch.matchFragment(r).fillBefore(Ne.empty, !0)))), t.copy(r);
}
function O5(t, e, n, r, i) {
  let a = t.node(e), o = i ? t.indexAfter(e) : t.index(e);
  if (o == a.childCount && !n.compatibleContent(a.type))
    return null;
  let s = r.fillBefore(a.content, !0, o);
  return s && !pie(n, a.content, o) ? s : null;
}
function pie(t, e, n) {
  for (let r = n; r < e.childCount; r++)
    if (!t.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function mie(t) {
  return t.spec.defining || t.spec.definingForContent;
}
function yie(t, e, n, r) {
  if (!r.size)
    return t.deleteRange(e, n);
  let i = t.doc.resolve(e), a = t.doc.resolve(n);
  if (LB(i, a, r))
    return t.step(new fr(e, n, r));
  let o = jB(i, t.doc.resolve(n));
  o[o.length - 1] == 0 && o.pop();
  let s = -(i.depth + 1);
  o.unshift(s);
  for (let f = i.depth, h = i.pos - 1; f > 0; f--, h--) {
    let p = i.node(f).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    o.indexOf(f) > -1 ? s = f : i.before(f) == h && o.splice(1, 0, -f);
  }
  let l = o.indexOf(s), c = [], u = r.openStart;
  for (let f = r.content, h = 0; ; h++) {
    let p = f.firstChild;
    if (c.push(p), h == r.openStart)
      break;
    f = p.content;
  }
  for (let f = u - 1; f >= 0; f--) {
    let h = c[f], p = mie(h.type);
    if (p && !h.sameMarkup(i.node(Math.abs(s) - 1)))
      u = f;
    else if (p || !h.type.isTextblock)
      break;
  }
  for (let f = r.openStart; f >= 0; f--) {
    let h = (f + u + 1) % (r.openStart + 1), p = c[h];
    if (p)
      for (let m = 0; m < o.length; m++) {
        let g = o[(m + l) % o.length], v = !0;
        g < 0 && (v = !1, g = -g);
        let k = i.node(g - 1), w = i.index(g - 1);
        if (k.canReplaceWith(w, w, p.type, p.marks))
          return t.replace(i.before(g), v ? a.after(g) : n, new Je(EB(r.content, 0, r.openStart, h), h, r.openEnd));
      }
  }
  let d = t.steps.length;
  for (let f = o.length - 1; f >= 0 && (t.replace(e, n, r), !(t.steps.length > d)); f--) {
    let h = o[f];
    h < 0 || (e = i.before(h), n = a.after(h));
  }
}
function EB(t, e, n, r, i) {
  if (e < n) {
    let a = t.firstChild;
    t = t.replaceChild(0, a.copy(EB(a.content, e + 1, n, r, a)));
  }
  if (e > r) {
    let a = i.contentMatchAt(0), o = a.fillBefore(t).append(t);
    t = o.append(a.matchFragment(o).fillBefore(Ne.empty, !0));
  }
  return t;
}
function gie(t, e, n, r) {
  if (!r.isInline && e == n && t.doc.resolve(e).parent.content.size) {
    let i = fie(t.doc, e, r.type);
    i != null && (e = n = i);
  }
  t.replaceRange(e, n, new Je(Ne.from(r), 0, 0));
}
function vie(t, e, n) {
  let r = t.doc.resolve(e), i = t.doc.resolve(n), a = jB(r, i);
  for (let o = 0; o < a.length; o++) {
    let s = a[o], l = o == a.length - 1;
    if (l && s == 0 || r.node(s).type.contentMatch.validEnd)
      return t.delete(r.start(s), i.end(s));
    if (s > 0 && (l || r.node(s - 1).canReplace(r.index(s - 1), i.indexAfter(s - 1))))
      return t.delete(r.before(s), i.after(s));
  }
  for (let o = 1; o <= r.depth && o <= i.depth; o++)
    if (e - r.start(o) == r.depth - o && n > r.end(o) && i.end(o) - n != i.depth - o && r.start(o - 1) == i.start(o - 1) && r.node(o - 1).canReplace(r.index(o - 1), i.index(o - 1)))
      return t.delete(r.before(o), n);
  t.delete(e, n);
}
function jB(t, e) {
  let n = [], r = Math.min(t.depth, e.depth);
  for (let i = r; i >= 0; i--) {
    let a = t.start(i);
    if (a < t.pos - (t.depth - i) || e.end(i) > e.pos + (e.depth - i) || t.node(i).type.spec.isolating || e.node(i).type.spec.isolating)
      break;
    (a == e.start(i) || i == t.depth && i == e.depth && t.parent.inlineContent && e.parent.inlineContent && i && e.start(i - 1) == a - 1) && n.push(i);
  }
  return n;
}
class m1 extends Xr {
  /**
  Construct an attribute step.
  */
  constructor(e, n, r) {
    super(), this.pos = e, this.attr = n, this.value = r;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return sr.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let a in n.attrs)
      r[a] = n.attrs[a];
    r[this.attr] = this.value;
    let i = n.type.create(r, null, n.marks);
    return sr.fromReplace(e, this.pos, this.pos + 1, new Je(Ne.from(i), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return Gi.empty;
  }
  invert(e) {
    return new m1(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new m1(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new m1(n.pos, n.attr, n.value);
  }
}
Xr.jsonID("attr", m1);
class Lh extends Xr {
  /**
  Construct an attribute step.
  */
  constructor(e, n) {
    super(), this.attr = e, this.value = n;
  }
  apply(e) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let i in e.attrs)
      n[i] = e.attrs[i];
    n[this.attr] = this.value;
    let r = e.type.create(n, e.content, e.marks);
    return sr.ok(r);
  }
  getMap() {
    return Gi.empty;
  }
  invert(e) {
    return new Lh(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Lh(n.attr, n.value);
  }
}
Xr.jsonID("docAttr", Lh);
let I1 = class extends Error {
};
I1 = function t(e) {
  let n = Error.call(this, e);
  return n.__proto__ = t.prototype, n;
};
I1.prototype = Object.create(Error.prototype);
I1.prototype.constructor = I1;
I1.prototype.name = "TransformError";
class Kk {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new Sh();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let n = this.maybeStep(e);
    if (n.failed)
      throw new I1(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let n = e.apply(this.doc);
    return n.failed || this.addStep(e, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, n) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, n = e, r = Je.empty) {
    let i = gg(this.doc, e, n, r);
    return i && this.step(i), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, n, r) {
    return this.replace(e, n, new Je(Ne.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, n) {
    return this.replace(e, n, Je.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, n) {
    return this.replaceWith(e, e, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, n, r) {
    return yie(this, e, n, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, n, r) {
    return gie(this, e, n, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, n) {
    return vie(this, e, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, n) {
    return nie(this, e, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, n = 1) {
    return die(this, e, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, n) {
    return aie(this, e, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, n = e, r, i = null) {
    return oie(this, e, n, r, i), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, n, r = null, i) {
    return lie(this, e, n, r, i), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, n, r) {
    return this.step(new m1(e, n, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, n) {
    return this.step(new Lh(e, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, n) {
    return this.step(new rc(e, n)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, n) {
    if (!(n instanceof dn)) {
      let r = this.doc.nodeAt(e);
      if (!r)
        throw new RangeError("No node at position " + e);
      if (n = n.isInSet(r.marks), !n)
        return this;
    }
    return this.step(new D1(e, n)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, n = 1, r) {
    return cie(this, e, n, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, n, r) {
    return Xre(this, e, n, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, n, r) {
    return eie(this, e, n, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, n, r) {
    return Yk(this, e, n, r), this;
  }
}
const B5 = /* @__PURE__ */ Object.create(null);
class vt {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, n, r) {
    this.$anchor = e, this.$head = n, this.ranges = r || [new $k(e.min(n), e.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let n = 0; n < e.length; n++)
      if (e[n].$from.pos != e[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, n = Je.empty) {
    let r = n.content.lastChild, i = null;
    for (let s = 0; s < n.openEnd; s++)
      i = r, r = r.lastChild;
    let a = e.steps.length, o = this.ranges;
    for (let s = 0; s < o.length; s++) {
      let { $from: l, $to: c } = o[s], u = e.mapping.slice(a);
      e.replaceRange(u.map(l.pos), u.map(c.pos), s ? Je.empty : n), s == 0 && uT(e, a, (r ? r.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, n) {
    let r = e.steps.length, i = this.ranges;
    for (let a = 0; a < i.length; a++) {
      let { $from: o, $to: s } = i[a], l = e.mapping.slice(r), c = l.map(o.pos), u = l.map(s.pos);
      a ? e.deleteRange(c, u) : (e.replaceRangeWith(c, u, n), uT(e, r, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, n, r = !1) {
    let i = e.parent.inlineContent ? new ot(e) : Y0(e.node(0), e.parent, e.pos, e.index(), n, r);
    if (i)
      return i;
    for (let a = e.depth - 1; a >= 0; a--) {
      let o = n < 0 ? Y0(e.node(0), e.node(a), e.before(a + 1), e.index(a), n, r) : Y0(e.node(0), e.node(a), e.after(a + 1), e.index(a) + 1, n, r);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, n = 1) {
    return this.findFrom(e, n) || this.findFrom(e, -n) || new Li(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return Y0(e, e, 0, 0, 1) || new Li(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return Y0(e, e, e.content.size, e.childCount, -1) || new Li(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = B5[n.type];
    if (!r)
      throw new RangeError(`No selection type ${n.type} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, n) {
    if (e in B5)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return B5[e] = n, n.prototype.jsonID = e, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return ot.between(this.$anchor, this.$head).getBookmark();
  }
}
vt.prototype.visible = !0;
class $k {
  /**
  Create a range.
  */
  constructor(e, n) {
    this.$from = e, this.$to = n;
  }
}
let lT = !1;
function cT(t) {
  !lT && !t.parent.inlineContent && (lT = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + t.parent.type.name + ")"));
}
class ot extends vt {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, n = e) {
    cT(e), cT(n), super(e, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    if (!r.parent.inlineContent)
      return vt.near(r);
    let i = e.resolve(n.map(this.anchor));
    return new ot(i.parent.inlineContent ? i : r, r);
  }
  replace(e, n = Je.empty) {
    if (super.replace(e, n), n == Je.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof ot && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new vg(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new ot(e.resolve(n.anchor), e.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, n, r = n) {
    let i = e.resolve(n);
    return new this(i, r == n ? i : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, n, r) {
    let i = e.pos - n.pos;
    if ((!r || i) && (r = i >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let a = vt.findFrom(n, r, !0) || vt.findFrom(n, -r, !0);
      if (a)
        n = a.$head;
      else
        return vt.near(n, r);
    }
    return e.parent.inlineContent || (i == 0 ? e = n : (e = (vt.findFrom(e, -r, !0) || vt.findFrom(e, r, !0)).$anchor, e.pos < n.pos != i < 0 && (e = n))), new ot(e, n);
  }
}
vt.jsonID("text", ot);
class vg {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new vg(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return ot.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class gt extends vt {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let n = e.nodeAfter, r = e.node(0).resolve(e.pos + n.nodeSize);
    super(e, r), this.node = n;
  }
  map(e, n) {
    let { deleted: r, pos: i } = n.mapResult(this.anchor), a = e.resolve(i);
    return r ? vt.near(a) : new gt(a);
  }
  content() {
    return new Je(Ne.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof gt && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new Jk(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new gt(e.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, n) {
    return new gt(e.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
gt.prototype.visible = !1;
vt.jsonID("node", gt);
class Jk {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: n, pos: r } = e.mapResult(this.anchor);
    return n ? new vg(r, r) : new Jk(r);
  }
  resolve(e) {
    let n = e.resolve(this.anchor), r = n.nodeAfter;
    return r && gt.isSelectable(r) ? new gt(n) : vt.near(n);
  }
}
class Li extends vt {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, n = Je.empty) {
    if (n == Je.empty) {
      e.delete(0, e.doc.content.size);
      let r = vt.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new Li(e);
  }
  map(e) {
    return new Li(e);
  }
  eq(e) {
    return e instanceof Li;
  }
  getBookmark() {
    return bie;
  }
}
vt.jsonID("all", Li);
const bie = {
  map() {
    return this;
  },
  resolve(t) {
    return new Li(t);
  }
};
function Y0(t, e, n, r, i, a = !1) {
  if (e.inlineContent)
    return ot.create(t, n);
  for (let o = r - (i > 0 ? 0 : 1); i > 0 ? o < e.childCount : o >= 0; o += i) {
    let s = e.child(o);
    if (s.isAtom) {
      if (!a && gt.isSelectable(s))
        return gt.create(t, n - (i < 0 ? s.nodeSize : 0));
    } else {
      let l = Y0(t, s, n + i, i < 0 ? s.childCount : 0, i, a);
      if (l)
        return l;
    }
    n += s.nodeSize * i;
  }
  return null;
}
function uT(t, e, n) {
  let r = t.steps.length - 1;
  if (r < e)
    return;
  let i = t.steps[r];
  if (!(i instanceof fr || i instanceof pr))
    return;
  let a = t.mapping.maps[r], o;
  a.forEach((s, l, c, u) => {
    o == null && (o = u);
  }), t.setSelection(vt.near(t.doc.resolve(o), n));
}
const dT = 1, fT = 2, hT = 4;
let wie = class extends Kk {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | dT) & -3, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & dT) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= fT, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return dn.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & fT) > 0;
  }
  /**
  @internal
  */
  addStep(e, n) {
    super.addStep(e, n), this.updated = this.updated & -3, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, n = !0) {
    let r = this.selection;
    return n && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || dn.none))), r.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, n, r) {
    let i = this.doc.type.schema;
    if (n == null)
      return e ? this.replaceSelectionWith(i.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = n), r = r ?? n, !e)
        return this.deleteRange(n, r);
      let a = this.storedMarks;
      if (!a) {
        let o = this.doc.resolve(n);
        a = r == n ? o.marks() : o.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(n, r, i.text(e, a)), this.selection.empty || this.setSelection(vt.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, n) {
    return this.meta[typeof e == "string" ? e : e.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= hT, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & hT) > 0;
  }
};
function pT(t, e) {
  return !e || !t ? t : t.bind(e);
}
class Nf {
  constructor(e, n, r) {
    this.name = e, this.init = pT(n.init, r), this.apply = pT(n.apply, r);
  }
}
const kie = [
  new Nf("doc", {
    init(t) {
      return t.doc || t.schema.topNodeType.createAndFill();
    },
    apply(t) {
      return t.doc;
    }
  }),
  new Nf("selection", {
    init(t, e) {
      return t.selection || vt.atStart(e.doc);
    },
    apply(t) {
      return t.selection;
    }
  }),
  new Nf("storedMarks", {
    init(t) {
      return t.storedMarks || null;
    },
    apply(t, e, n, r) {
      return r.selection.$cursor ? t.storedMarks : null;
    }
  }),
  new Nf("scrollToSelection", {
    init() {
      return 0;
    },
    apply(t, e) {
      return t.scrolledIntoView ? e + 1 : e;
    }
  })
];
class H5 {
  constructor(e, n) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = kie.slice(), n && n.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new Nf(r.key, r.spec.state, r));
    });
  }
}
class X0 {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, n = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != n) {
        let i = this.config.plugins[r];
        if (i.spec.filterTransaction && !i.spec.filterTransaction.call(i, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let n = [e], r = this.applyInner(e), i = null;
    for (; ; ) {
      let a = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let s = this.config.plugins[o];
        if (s.spec.appendTransaction) {
          let l = i ? i[o].n : 0, c = i ? i[o].state : this, u = l < n.length && s.spec.appendTransaction.call(s, l ? n.slice(l) : n, c, r);
          if (u && r.filterTransaction(u, o)) {
            if (u.setMeta("appendedTransaction", e), !i) {
              i = [];
              for (let d = 0; d < this.config.plugins.length; d++)
                i.push(d < o ? { state: r, n: n.length } : { state: this, n: 0 });
            }
            n.push(u), r = r.applyInner(u), a = !0;
          }
          i && (i[o] = { state: r, n: n.length });
        }
      }
      if (!a)
        return { state: r, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new X0(this.config), r = this.config.fields;
    for (let i = 0; i < r.length; i++) {
      let a = r[i];
      n[a.name] = a.apply(e, this[a.name], this, n);
    }
    return n;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new wie(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let n = new H5(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new X0(n);
    for (let i = 0; i < n.fields.length; i++)
      r[n.fields[i].name] = n.fields[i].init(e, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let n = new H5(this.schema, e.plugins), r = n.fields, i = new X0(n);
    for (let a = 0; a < r.length; a++) {
      let o = r[a].name;
      i[o] = this.hasOwnProperty(o) ? this[o] : r[a].init(e, i);
    }
    return i;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let i = e[r], a = i.spec.state;
        a && a.toJSON && (n[r] = a.toJSON.call(i, this[i.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, n, r) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let i = new H5(e.schema, e.plugins), a = new X0(i);
    return i.fields.forEach((o) => {
      if (o.name == "doc")
        a.doc = cc.fromJSON(e.schema, n.doc);
      else if (o.name == "selection")
        a.selection = vt.fromJSON(a.doc, n.selection);
      else if (o.name == "storedMarks")
        n.storedMarks && (a.storedMarks = n.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let s in r) {
            let l = r[s], c = l.spec.state;
            if (l.key == o.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(n, s)) {
              a[o.name] = c.fromJSON.call(l, e, n[s], a);
              return;
            }
          }
        a[o.name] = o.init(e, a);
      }
    }), a;
  }
}
function NB(t, e, n) {
  for (let r in t) {
    let i = t[r];
    i instanceof Function ? i = i.bind(e) : r == "handleDOMEvents" && (i = NB(i, e, {})), n[r] = i;
  }
  return n;
}
class Wt {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && NB(e.props, this, this.props), this.key = e.key ? e.key.key : DB("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const F5 = /* @__PURE__ */ Object.create(null);
function DB(t) {
  return t in F5 ? t + "$" + ++F5[t] : (F5[t] = 0, t + "$");
}
class tn {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = DB(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const zr = function(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}, P1 = function(t) {
  let e = t.assignedSlot || t.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let s7 = null;
const Is = function(t, e, n) {
  let r = s7 || (s7 = document.createRange());
  return r.setEnd(t, n ?? t.nodeValue.length), r.setStart(t, e || 0), r;
}, xie = function() {
  s7 = null;
}, Zu = function(t, e, n, r) {
  return n && (mT(t, e, n, r, -1) || mT(t, e, n, r, 1));
}, Mie = /^(img|br|input|textarea|hr)$/i;
function mT(t, e, n, r, i) {
  for (; ; ) {
    if (t == n && e == r)
      return !0;
    if (e == (i < 0 ? 0 : ka(t))) {
      let a = t.parentNode;
      if (!a || a.nodeType != 1 || X2(t) || Mie.test(t.nodeName) || t.contentEditable == "false")
        return !1;
      e = zr(t) + (i < 0 ? 0 : 1), t = a;
    } else if (t.nodeType == 1) {
      if (t = t.childNodes[e + (i < 0 ? -1 : 0)], t.contentEditable == "false")
        return !1;
      e = i < 0 ? ka(t) : 0;
    } else
      return !1;
  }
}
function ka(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function Cie(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e)
      return t;
    if (t.nodeType == 1 && e > 0) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e - 1], e = ka(t);
    } else if (t.parentNode && !X2(t))
      e = zr(t), t = t.parentNode;
    else
      return null;
  }
}
function Aie(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e < t.nodeValue.length)
      return t;
    if (t.nodeType == 1 && e < t.childNodes.length) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e], e = 0;
    } else if (t.parentNode && !X2(t))
      e = zr(t) + 1, t = t.parentNode;
    else
      return null;
  }
}
function Sie(t, e, n) {
  for (let r = e == 0, i = e == ka(t); r || i; ) {
    if (t == n)
      return !0;
    let a = zr(t);
    if (t = t.parentNode, !t)
      return !1;
    r = r && a == 0, i = i && a == ka(t);
  }
}
function X2(t) {
  let e;
  for (let n = t; n && !(e = n.pmViewDesc); n = n.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == t || e.contentDOM == t);
}
const bg = function(t) {
  return t.focusNode && Zu(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset);
};
function mu(t, e) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = t, n.key = n.code = e, n;
}
function Lie(t) {
  let e = t.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function Tie(t, e, n) {
  if (t.caretPositionFromPoint)
    try {
      let r = t.caretPositionFromPoint(e, n);
      if (r)
        return { node: r.offsetNode, offset: Math.min(ka(r.offsetNode), r.offset) };
    } catch {
    }
  if (t.caretRangeFromPoint) {
    let r = t.caretRangeFromPoint(e, n);
    if (r)
      return { node: r.startContainer, offset: Math.min(ka(r.startContainer), r.startOffset) };
  }
}
const Xo = typeof navigator < "u" ? navigator : null, yT = typeof document < "u" ? document : null, Rc = Xo && Xo.userAgent || "", l7 = /Edge\/(\d+)/.exec(Rc), IB = /MSIE \d/.exec(Rc), c7 = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Rc), Ti = !!(IB || c7 || l7), uc = IB ? document.documentMode : c7 ? +c7[1] : l7 ? +l7[1] : 0, io = !Ti && /gecko\/(\d+)/i.test(Rc);
io && +(/Firefox\/(\d+)/.exec(Rc) || [0, 0])[1];
const u7 = !Ti && /Chrome\/(\d+)/.exec(Rc), Zr = !!u7, PB = u7 ? +u7[1] : 0, di = !Ti && !!Xo && /Apple Computer/.test(Xo.vendor), z1 = di && (/Mobile\/\w+/.test(Rc) || !!Xo && Xo.maxTouchPoints > 2), wa = z1 || (Xo ? /Mac/.test(Xo.platform) : !1), Eie = Xo ? /Win/.test(Xo.platform) : !1, Fs = /Android \d/.test(Rc), ep = !!yT && "webkitFontSmoothing" in yT.documentElement.style, jie = ep ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function Nie(t) {
  let e = t.defaultView && t.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: t.documentElement.clientWidth,
    top: 0,
    bottom: t.documentElement.clientHeight
  };
}
function Ms(t, e) {
  return typeof t == "number" ? t : t[e];
}
function Die(t) {
  let e = t.getBoundingClientRect(), n = e.width / t.offsetWidth || 1, r = e.height / t.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + t.clientWidth * n,
    top: e.top,
    bottom: e.top + t.clientHeight * r
  };
}
function gT(t, e, n) {
  let r = t.someProp("scrollThreshold") || 0, i = t.someProp("scrollMargin") || 5, a = t.dom.ownerDocument;
  for (let o = n || t.dom; o; ) {
    if (o.nodeType != 1) {
      o = P1(o);
      continue;
    }
    let s = o, l = s == a.body, c = l ? Nie(a) : Die(s), u = 0, d = 0;
    if (e.top < c.top + Ms(r, "top") ? d = -(c.top - e.top + Ms(i, "top")) : e.bottom > c.bottom - Ms(r, "bottom") && (d = e.bottom - e.top > c.bottom - c.top ? e.top + Ms(i, "top") - c.top : e.bottom - c.bottom + Ms(i, "bottom")), e.left < c.left + Ms(r, "left") ? u = -(c.left - e.left + Ms(i, "left")) : e.right > c.right - Ms(r, "right") && (u = e.right - c.right + Ms(i, "right")), u || d)
      if (l)
        a.defaultView.scrollBy(u, d);
      else {
        let h = s.scrollLeft, p = s.scrollTop;
        d && (s.scrollTop += d), u && (s.scrollLeft += u);
        let m = s.scrollLeft - h, g = s.scrollTop - p;
        e = { left: e.left - m, top: e.top - g, right: e.right - m, bottom: e.bottom - g };
      }
    let f = l ? "fixed" : getComputedStyle(o).position;
    if (/^(fixed|sticky)$/.test(f))
      break;
    o = f == "absolute" ? o.offsetParent : P1(o);
  }
}
function Iie(t) {
  let e = t.dom.getBoundingClientRect(), n = Math.max(0, e.top), r, i;
  for (let a = (e.left + e.right) / 2, o = n + 1; o < Math.min(innerHeight, e.bottom); o += 5) {
    let s = t.root.elementFromPoint(a, o);
    if (!s || s == t.dom || !t.dom.contains(s))
      continue;
    let l = s.getBoundingClientRect();
    if (l.top >= n - 20) {
      r = s, i = l.top;
      break;
    }
  }
  return { refDOM: r, refTop: i, stack: zB(t.dom) };
}
function zB(t) {
  let e = [], n = t.ownerDocument;
  for (let r = t; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), t != n); r = P1(r))
    ;
  return e;
}
function Pie({ refDOM: t, refTop: e, stack: n }) {
  let r = t ? t.getBoundingClientRect().top : 0;
  RB(n, r == 0 ? 0 : r - e);
}
function RB(t, e) {
  for (let n = 0; n < t.length; n++) {
    let { dom: r, top: i, left: a } = t[n];
    r.scrollTop != i + e && (r.scrollTop = i + e), r.scrollLeft != a && (r.scrollLeft = a);
  }
}
let D0 = null;
function zie(t) {
  if (t.setActive)
    return t.setActive();
  if (D0)
    return t.focus(D0);
  let e = zB(t);
  t.focus(D0 == null ? {
    get preventScroll() {
      return D0 = { preventScroll: !0 }, !0;
    }
  } : void 0), D0 || (D0 = !1, RB(e, 0));
}
function OB(t, e) {
  let n, r = 2e8, i, a = 0, o = e.top, s = e.top, l, c;
  for (let u = t.firstChild, d = 0; u; u = u.nextSibling, d++) {
    let f;
    if (u.nodeType == 1)
      f = u.getClientRects();
    else if (u.nodeType == 3)
      f = Is(u).getClientRects();
    else
      continue;
    for (let h = 0; h < f.length; h++) {
      let p = f[h];
      if (p.top <= o && p.bottom >= s) {
        o = Math.max(p.bottom, o), s = Math.min(p.top, s);
        let m = p.left > e.left ? p.left - e.left : p.right < e.left ? e.left - p.right : 0;
        if (m < r) {
          n = u, r = m, i = m && n.nodeType == 3 ? {
            left: p.right < e.left ? p.right : p.left,
            top: e.top
          } : e, u.nodeType == 1 && m && (a = d + (e.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > e.top && !l && p.left <= e.left && p.right >= e.left && (l = u, c = { left: Math.max(p.left, Math.min(p.right, e.left)), top: p.top });
      !n && (e.left >= p.right && e.top >= p.top || e.left >= p.left && e.top >= p.bottom) && (a = d + 1);
    }
  }
  return !n && l && (n = l, i = c, r = 0), n && n.nodeType == 3 ? Rie(n, i) : !n || r && n.nodeType == 1 ? { node: t, offset: a } : OB(n, i);
}
function Rie(t, e) {
  let n = t.nodeValue.length, r = document.createRange();
  for (let i = 0; i < n; i++) {
    r.setEnd(t, i + 1), r.setStart(t, i);
    let a = Fl(r, 1);
    if (a.top != a.bottom && Qk(e, a))
      return { node: t, offset: i + (e.left >= (a.left + a.right) / 2 ? 1 : 0) };
  }
  return { node: t, offset: 0 };
}
function Qk(t, e) {
  return t.left >= e.left - 1 && t.left <= e.right + 1 && t.top >= e.top - 1 && t.top <= e.bottom + 1;
}
function Oie(t, e) {
  let n = t.parentNode;
  return n && /^li$/i.test(n.nodeName) && e.left < t.getBoundingClientRect().left ? n : t;
}
function Bie(t, e, n) {
  let { node: r, offset: i } = OB(e, n), a = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let o = r.getBoundingClientRect();
    a = o.left != o.right && n.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return t.docView.posFromDOM(r, i, a);
}
function Hie(t, e, n, r) {
  let i = -1;
  for (let a = e, o = !1; a != t.dom; ) {
    let s = t.docView.nearestDesc(a, !0), l;
    if (!s)
      return null;
    if (s.dom.nodeType == 1 && (s.node.isBlock && s.parent || !s.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = s.dom.getBoundingClientRect()).width || l.height) && (s.node.isBlock && s.parent && (!o && l.left > r.left || l.top > r.top ? i = s.posBefore : (!o && l.right < r.left || l.bottom < r.top) && (i = s.posAfter), o = !0), !s.contentDOM && i < 0 && !s.node.isText))
      return (s.node.isBlock ? r.top < (l.top + l.bottom) / 2 : r.left < (l.left + l.right) / 2) ? s.posBefore : s.posAfter;
    a = s.dom.parentNode;
  }
  return i > -1 ? i : t.docView.posFromDOM(e, n, -1);
}
function BB(t, e, n) {
  let r = t.childNodes.length;
  if (r && n.top < n.bottom)
    for (let i = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - n.top) / (n.bottom - n.top)) - 2)), a = i; ; ) {
      let o = t.childNodes[a];
      if (o.nodeType == 1) {
        let s = o.getClientRects();
        for (let l = 0; l < s.length; l++) {
          let c = s[l];
          if (Qk(e, c))
            return BB(o, e, c);
        }
      }
      if ((a = (a + 1) % r) == i)
        break;
    }
  return t;
}
function Fie(t, e) {
  let n = t.dom.ownerDocument, r, i = 0, a = Tie(n, e.left, e.top);
  a && ({ node: r, offset: i } = a);
  let o = (t.root.elementFromPoint ? t.root : n).elementFromPoint(e.left, e.top), s;
  if (!o || !t.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let c = t.dom.getBoundingClientRect();
    if (!Qk(e, c) || (o = BB(t.dom, e, c), !o))
      return null;
  }
  if (di)
    for (let c = o; r && c; c = P1(c))
      c.draggable && (r = void 0);
  if (o = Oie(o, e), r) {
    if (io && r.nodeType == 1 && (i = Math.min(i, r.childNodes.length), i < r.childNodes.length)) {
      let u = r.childNodes[i], d;
      u.nodeName == "IMG" && (d = u.getBoundingClientRect()).right <= e.left && d.bottom > e.top && i++;
    }
    let c;
    ep && i && r.nodeType == 1 && (c = r.childNodes[i - 1]).nodeType == 1 && c.contentEditable == "false" && c.getBoundingClientRect().top >= e.top && i--, r == t.dom && i == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? s = t.state.doc.content.size : (i == 0 || r.nodeType != 1 || r.childNodes[i - 1].nodeName != "BR") && (s = Hie(t, r, i, e));
  }
  s == null && (s = Bie(t, o, e));
  let l = t.docView.nearestDesc(o, !0);
  return { pos: s, inside: l ? l.posAtStart - l.border : -1 };
}
function vT(t) {
  return t.top < t.bottom || t.left < t.right;
}
function Fl(t, e) {
  let n = t.getClientRects();
  if (n.length) {
    let r = n[e < 0 ? 0 : n.length - 1];
    if (vT(r))
      return r;
  }
  return Array.prototype.find.call(n, vT) || t.getBoundingClientRect();
}
const _ie = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function HB(t, e, n) {
  let { node: r, offset: i, atom: a } = t.docView.domFromPos(e, n < 0 ? -1 : 1), o = ep || io;
  if (r.nodeType == 3)
    if (o && (_ie.test(r.nodeValue) || (n < 0 ? !i : i == r.nodeValue.length))) {
      let l = Fl(Is(r, i, i), n);
      if (io && i && /\s/.test(r.nodeValue[i - 1]) && i < r.nodeValue.length) {
        let c = Fl(Is(r, i - 1, i - 1), -1);
        if (c.top == l.top) {
          let u = Fl(Is(r, i, i + 1), -1);
          if (u.top != l.top)
            return ef(u, u.left < c.left);
        }
      }
      return l;
    } else {
      let l = i, c = i, u = n < 0 ? 1 : -1;
      return n < 0 && !i ? (c++, u = -1) : n >= 0 && i == r.nodeValue.length ? (l--, u = 1) : n < 0 ? l-- : c++, ef(Fl(Is(r, l, c), u), u < 0);
    }
  if (!t.state.doc.resolve(e - (a || 0)).parent.inlineContent) {
    if (a == null && i && (n < 0 || i == ka(r))) {
      let l = r.childNodes[i - 1];
      if (l.nodeType == 1)
        return _5(l.getBoundingClientRect(), !1);
    }
    if (a == null && i < ka(r)) {
      let l = r.childNodes[i];
      if (l.nodeType == 1)
        return _5(l.getBoundingClientRect(), !0);
    }
    return _5(r.getBoundingClientRect(), n >= 0);
  }
  if (a == null && i && (n < 0 || i == ka(r))) {
    let l = r.childNodes[i - 1], c = l.nodeType == 3 ? Is(l, ka(l) - (o ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (c)
      return ef(Fl(c, 1), !1);
  }
  if (a == null && i < ka(r)) {
    let l = r.childNodes[i];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let c = l ? l.nodeType == 3 ? Is(l, 0, o ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (c)
      return ef(Fl(c, -1), !0);
  }
  return ef(Fl(r.nodeType == 3 ? Is(r) : r, -n), n >= 0);
}
function ef(t, e) {
  if (t.width == 0)
    return t;
  let n = e ? t.left : t.right;
  return { top: t.top, bottom: t.bottom, left: n, right: n };
}
function _5(t, e) {
  if (t.height == 0)
    return t;
  let n = e ? t.top : t.bottom;
  return { top: n, bottom: n, left: t.left, right: t.right };
}
function FB(t, e, n) {
  let r = t.state, i = t.root.activeElement;
  r != e && t.updateState(e), i != t.dom && t.focus();
  try {
    return n();
  } finally {
    r != e && t.updateState(r), i != t.dom && i && i.focus();
  }
}
function Vie(t, e, n) {
  let r = e.selection, i = n == "up" ? r.$from : r.$to;
  return FB(t, e, () => {
    let { node: a } = t.docView.domFromPos(i.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let s = t.docView.nearestDesc(a, !0);
      if (!s)
        break;
      if (s.node.isBlock) {
        a = s.contentDOM || s.dom;
        break;
      }
      a = s.dom.parentNode;
    }
    let o = HB(t, i.pos, 1);
    for (let s = a.firstChild; s; s = s.nextSibling) {
      let l;
      if (s.nodeType == 1)
        l = s.getClientRects();
      else if (s.nodeType == 3)
        l = Is(s, 0, s.nodeValue.length).getClientRects();
      else
        continue;
      for (let c = 0; c < l.length; c++) {
        let u = l[c];
        if (u.bottom > u.top + 1 && (n == "up" ? o.top - u.top > (u.bottom - o.top) * 2 : u.bottom - o.bottom > (o.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const qie = /[\u0590-\u08ac]/;
function Uie(t, e, n) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let i = r.parentOffset, a = !i, o = i == r.parent.content.size, s = t.domSelection();
  return s ? !qie.test(r.parent.textContent) || !s.modify ? n == "left" || n == "backward" ? a : o : FB(t, e, () => {
    let { focusNode: l, focusOffset: c, anchorNode: u, anchorOffset: d } = t.domSelectionRange(), f = s.caretBidiLevel;
    s.modify("move", n, "character");
    let h = r.depth ? t.docView.domAfterPos(r.before()) : t.dom, { focusNode: p, focusOffset: m } = t.domSelectionRange(), g = p && !h.contains(p.nodeType == 1 ? p : p.parentNode) || l == p && c == m;
    try {
      s.collapse(u, d), l && (l != u || c != d) && s.extend && s.extend(l, c);
    } catch {
    }
    return f != null && (s.caretBidiLevel = f), g;
  }) : r.pos == r.start() || r.pos == r.end();
}
let bT = null, wT = null, kT = !1;
function Wie(t, e, n) {
  return bT == e && wT == n ? kT : (bT = e, wT = n, kT = n == "up" || n == "down" ? Vie(t, e, n) : Uie(t, e, n));
}
const Ta = 0, xT = 1, ku = 2, es = 3;
class tp {
  constructor(e, n, r, i) {
    this.parent = e, this.children = n, this.dom = r, this.contentDOM = i, this.dirty = Ta, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, n, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let n = 0; n < this.children.length; n++)
      e += this.children[n].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let n = 0, r = this.posAtStart; ; n++) {
      let i = this.children[n];
      if (i == e)
        return r;
      r += i.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, n, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let a, o;
        if (e == this.contentDOM)
          a = e.childNodes[n - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          a = e.previousSibling;
        }
        for (; a && !((o = a.pmViewDesc) && o.parent == this); )
          a = a.previousSibling;
        return a ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let a, o;
        if (e == this.contentDOM)
          a = e.childNodes[n];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          a = e.nextSibling;
        }
        for (; a && !((o = a.pmViewDesc) && o.parent == this); )
          a = a.nextSibling;
        return a ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let i;
    if (e == this.dom && this.contentDOM)
      i = n > zr(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      i = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let a = e; ; a = a.parentNode) {
          if (a == this.dom) {
            i = !1;
            break;
          }
          if (a.previousSibling)
            break;
        }
      if (i == null && n == e.childNodes.length)
        for (let a = e; ; a = a.parentNode) {
          if (a == this.dom) {
            i = !0;
            break;
          }
          if (a.nextSibling)
            break;
        }
    }
    return i ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, n = !1) {
    for (let r = !0, i = e; i; i = i.parentNode) {
      let a = this.getDesc(i), o;
      if (a && (!n || a.node))
        if (r && (o = a.nodeDOM) && !(o.nodeType == 1 ? o.contains(e.nodeType == 1 ? e : e.parentNode) : o == e))
          r = !1;
        else
          return a;
    }
  }
  getDesc(e) {
    let n = e.pmViewDesc;
    for (let r = n; r; r = r.parent)
      if (r == this)
        return n;
  }
  posFromDOM(e, n, r) {
    for (let i = e; i; i = i.parentNode) {
      let a = this.getDesc(i);
      if (a)
        return a.localPosFromDOM(e, n, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let n = 0, r = 0; n < this.children.length; n++) {
      let i = this.children[n], a = r + i.size;
      if (r == e && a != r) {
        for (; !i.border && i.children.length; )
          for (let o = 0; o < i.children.length; o++) {
            let s = i.children[o];
            if (s.size) {
              i = s;
              break;
            }
          }
        return i;
      }
      if (e < a)
        return i.descAt(e - r - i.border);
      r = a;
    }
  }
  domFromPos(e, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, i = 0;
    for (let a = 0; r < this.children.length; r++) {
      let o = this.children[r], s = a + o.size;
      if (s > e || o instanceof VB) {
        i = e - a;
        break;
      }
      a = s;
    }
    if (i)
      return this.children[r].domFromPos(i - this.children[r].border, n);
    for (let a; r && !(a = this.children[r - 1]).size && a instanceof _B && a.side >= 0; r--)
      ;
    if (n <= 0) {
      let a, o = !0;
      for (; a = r ? this.children[r - 1] : null, !(!a || a.dom.parentNode == this.contentDOM); r--, o = !1)
        ;
      return a && n && o && !a.border && !a.domAtom ? a.domFromPos(a.size, n) : { node: this.contentDOM, offset: a ? zr(a.dom) + 1 : 0 };
    } else {
      let a, o = !0;
      for (; a = r < this.children.length ? this.children[r] : null, !(!a || a.dom.parentNode == this.contentDOM); r++, o = !1)
        ;
      return a && o && !a.border && !a.domAtom ? a.domFromPos(0, n) : { node: this.contentDOM, offset: a ? zr(a.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, n, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let i = -1, a = -1;
    for (let o = r, s = 0; ; s++) {
      let l = this.children[s], c = o + l.size;
      if (i == -1 && e <= c) {
        let u = o + l.border;
        if (e >= u && n <= c - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, n, u);
        e = o;
        for (let d = s; d > 0; d--) {
          let f = this.children[d - 1];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(1)) {
            i = zr(f.dom) + 1;
            break;
          }
          e -= f.size;
        }
        i == -1 && (i = 0);
      }
      if (i > -1 && (c > n || s == this.children.length - 1)) {
        n = c;
        for (let u = s + 1; u < this.children.length; u++) {
          let d = this.children[u];
          if (d.size && d.dom.parentNode == this.contentDOM && !d.emptyChildAt(-1)) {
            a = zr(d.dom);
            break;
          }
          n += d.size;
        }
        a == -1 && (a = this.contentDOM.childNodes.length);
        break;
      }
      o = c;
    }
    return { node: this.contentDOM, from: e, to: n, fromOffset: i, toOffset: a };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[e < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: n, offset: r } = this.domFromPos(e, 0);
    if (n.nodeType != 1 || r == n.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return n.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, n, r, i = !1) {
    let a = Math.min(e, n), o = Math.max(e, n);
    for (let h = 0, p = 0; h < this.children.length; h++) {
      let m = this.children[h], g = p + m.size;
      if (a > p && o < g)
        return m.setSelection(e - p - m.border, n - p - m.border, r, i);
      p = g;
    }
    let s = this.domFromPos(e, e ? -1 : 1), l = n == e ? s : this.domFromPos(n, n ? -1 : 1), c = r.root.getSelection(), u = r.domSelectionRange(), d = !1;
    if ((io || di) && e == n) {
      let { node: h, offset: p } = s;
      if (h.nodeType == 3) {
        if (d = !!(p && h.nodeValue[p - 1] == `
`), d && p == h.nodeValue.length)
          for (let m = h, g; m; m = m.parentNode) {
            if (g = m.nextSibling) {
              g.nodeName == "BR" && (s = l = { node: g.parentNode, offset: zr(g) + 1 });
              break;
            }
            let v = m.pmViewDesc;
            if (v && v.node && v.node.isBlock)
              break;
          }
      } else {
        let m = h.childNodes[p - 1];
        d = m && (m.nodeName == "BR" || m.contentEditable == "false");
      }
    }
    if (io && u.focusNode && u.focusNode != l.node && u.focusNode.nodeType == 1) {
      let h = u.focusNode.childNodes[u.focusOffset];
      h && h.contentEditable == "false" && (i = !0);
    }
    if (!(i || d && di) && Zu(s.node, s.offset, u.anchorNode, u.anchorOffset) && Zu(l.node, l.offset, u.focusNode, u.focusOffset))
      return;
    let f = !1;
    if ((c.extend || e == n) && !d) {
      c.collapse(s.node, s.offset);
      try {
        e != n && c.extend(l.node, l.offset), f = !0;
      } catch {
      }
    }
    if (!f) {
      if (e > n) {
        let p = s;
        s = l, l = p;
      }
      let h = document.createRange();
      h.setEnd(l.node, l.offset), h.setStart(s.node, s.offset), c.removeAllRanges(), c.addRange(h);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, n) {
    for (let r = 0, i = 0; i < this.children.length; i++) {
      let a = this.children[i], o = r + a.size;
      if (r == o ? e <= o && n >= r : e < o && n > r) {
        let s = r + a.border, l = o - a.border;
        if (e >= s && n <= l) {
          this.dirty = e == r || n == o ? ku : xT, e == s && n == l && (a.contentLost || a.dom.parentNode != this.contentDOM) ? a.dirty = es : a.markDirty(e - s, n - s);
          return;
        } else
          a.dirty = a.dom == a.contentDOM && a.dom.parentNode == this.contentDOM && !a.children.length ? ku : es;
      }
      r = o;
    }
    this.dirty = ku;
  }
  markParentsDirty() {
    let e = 1;
    for (let n = this.parent; n; n = n.parent, e++) {
      let r = e == 1 ? ku : xT;
      n.dirty < r && (n.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class _B extends tp {
  constructor(e, n, r, i) {
    let a, o = n.type.toDOM;
    if (typeof o == "function" && (o = o(r, () => {
      if (!a)
        return i;
      if (a.parent)
        return a.parent.posBeforeChild(a);
    })), !n.type.spec.raw) {
      if (o.nodeType != 1) {
        let s = document.createElement("span");
        s.appendChild(o), o = s;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(e, [], o, null), this.widget = n, this.widget = n, a = this;
  }
  matchesWidget(e) {
    return this.dirty == Ta && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let n = this.widget.spec.stopEvent;
    return n ? n(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class Zie extends tp {
  constructor(e, n, r, i) {
    super(e, [], n, null), this.textDOM = r, this.text = i;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, n) {
    return e != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class Gu extends tp {
  constructor(e, n, r, i, a) {
    super(e, [], r, i), this.mark = n, this.spec = a;
  }
  static create(e, n, r, i) {
    let a = i.nodeViews[n.type.name], o = a && a(n, i, r);
    return (!o || !o.dom) && (o = v0.renderSpec(document, n.type.spec.toDOM(n, r), null, n.attrs)), new Gu(e, n, o.dom, o.contentDOM || o.dom, o);
  }
  parseRule() {
    return this.dirty & es || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != es && this.mark.eq(e);
  }
  markDirty(e, n) {
    if (super.markDirty(e, n), this.dirty != Ta) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = Ta;
    }
  }
  slice(e, n, r) {
    let i = Gu.create(this.parent, this.mark, !0, r), a = this.children, o = this.size;
    n < o && (a = f7(a, n, o, r)), e > 0 && (a = f7(a, 0, e, r));
    for (let s = 0; s < a.length; s++)
      a[s].parent = i;
    return i.children = a, i;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class dc extends tp {
  constructor(e, n, r, i, a, o, s, l, c) {
    super(e, [], a, o), this.node = n, this.outerDeco = r, this.innerDeco = i, this.nodeDOM = s;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, n, r, i, a, o) {
    let s = a.nodeViews[n.type.name], l, c = s && s(n, a, () => {
      if (!l)
        return o;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, r, i), u = c && c.dom, d = c && c.contentDOM;
    if (n.isText) {
      if (!u)
        u = document.createTextNode(n.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: d } = v0.renderSpec(document, n.type.spec.toDOM(n), null, n.attrs));
    !d && !n.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), n.type.spec.draggable && (u.draggable = !0));
    let f = u;
    return u = WB(u, r, n), c ? l = new Gie(e, n, r, i, u, d || null, f, c, a, o + 1) : n.isText ? new wg(e, n, r, i, u, f, a) : new dc(e, n, r, i, u, d || null, f, a, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let r = this.children[n];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => Ne.empty);
    }
    return e;
  }
  matchesNode(e, n, r) {
    return this.dirty == Ta && e.eq(this.node) && yy(n, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, n) {
    let r = this.node.inlineContent, i = n, a = e.composing ? this.localCompositionInfo(e, n) : null, o = a && a.pos > -1 ? a : null, s = a && a.pos < 0, l = new Kie(this, o && o.node, e);
    Qie(this.node, this.innerDeco, (c, u, d) => {
      c.spec.marks ? l.syncToMarks(c.spec.marks, r, e) : c.type.side >= 0 && !d && l.syncToMarks(u == this.node.childCount ? dn.none : this.node.child(u).marks, r, e), l.placeWidget(c, e, i);
    }, (c, u, d, f) => {
      l.syncToMarks(c.marks, r, e);
      let h;
      l.findNodeMatch(c, u, d, f) || s && e.state.selection.from > i && e.state.selection.to < i + c.nodeSize && (h = l.findIndexWithChild(a.node)) > -1 && l.updateNodeAt(c, u, d, h, e) || l.updateNextNode(c, u, d, e, f, i) || l.addNode(c, u, d, e, i), i += c.nodeSize;
    }), l.syncToMarks([], r, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == ku) && (o && this.protectLocalComposition(e, o), qB(this.contentDOM, this.children, e), z1 && Xie(this.dom));
  }
  localCompositionInfo(e, n) {
    let { from: r, to: i } = e.state.selection;
    if (!(e.state.selection instanceof ot) || r < n || i > n + this.node.content.size)
      return null;
    let a = e.input.compositionNode;
    if (!a || !this.dom.contains(a.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = a.nodeValue, s = eae(this.node.content, o, r - n, i - n);
      return s < 0 ? null : { node: a, pos: s, text: o };
    } else
      return { node: a, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: n, pos: r, text: i }) {
    if (this.getDesc(n))
      return;
    let a = n;
    for (; a.parentNode != this.contentDOM; a = a.parentNode) {
      for (; a.previousSibling; )
        a.parentNode.removeChild(a.previousSibling);
      for (; a.nextSibling; )
        a.parentNode.removeChild(a.nextSibling);
      a.pmViewDesc && (a.pmViewDesc = void 0);
    }
    let o = new Zie(this, a, n, i);
    e.input.compositionNodes.push(o), this.children = f7(this.children, r, r + i.length, e, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, n, r, i) {
    return this.dirty == es || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, n, r, i), !0);
  }
  updateInner(e, n, r, i) {
    this.updateOuterDeco(n), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(i, this.posAtStart), this.dirty = Ta;
  }
  updateOuterDeco(e) {
    if (yy(e, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = UB(this.dom, this.nodeDOM, d7(this.outerDeco, this.node, n), d7(e, this.node, n)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function MT(t, e, n, r, i) {
  WB(r, e, t);
  let a = new dc(void 0, t, e, n, r, r, r, i, 0);
  return a.contentDOM && a.updateChildren(i, 0), a;
}
class wg extends dc {
  constructor(e, n, r, i, a, o, s) {
    super(e, n, r, i, a, null, o, s, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, n, r, i) {
    return this.dirty == es || this.dirty != Ta && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != Ta || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, i.trackWrites == this.nodeDOM && (i.trackWrites = null)), this.node = e, this.dirty = Ta, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, n, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(e, n, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, n, r) {
    let i = this.node.cut(e, n), a = document.createTextNode(i.text);
    return new wg(this.parent, i, this.outerDeco, this.innerDeco, a, a, r);
  }
  markDirty(e, n) {
    super.markDirty(e, n), this.dom != this.nodeDOM && (e == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = es);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class VB extends tp {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == Ta && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class Gie extends dc {
  constructor(e, n, r, i, a, o, s, l, c, u) {
    super(e, n, r, i, a, o, s, c, u), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, n, r, i) {
    if (this.dirty == es)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let a = this.spec.update(e, n, r);
      return a && this.updateInner(e, n, r, i), a;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, n, r, i);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, n, r, i) {
    this.spec.setSelection ? this.spec.setSelection(e, n, r.root) : super.setSelection(e, n, r, i);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function qB(t, e, n) {
  let r = t.firstChild, i = !1;
  for (let a = 0; a < e.length; a++) {
    let o = e[a], s = o.dom;
    if (s.parentNode == t) {
      for (; s != r; )
        r = CT(r), i = !0;
      r = r.nextSibling;
    } else
      i = !0, t.insertBefore(s, r);
    if (o instanceof Gu) {
      let l = r ? r.previousSibling : t.lastChild;
      qB(o.contentDOM, o.children, n), r = l ? l.nextSibling : t.firstChild;
    }
  }
  for (; r; )
    r = CT(r), i = !0;
  i && n.trackWrites == t && (n.trackWrites = null);
}
const Wf = function(t) {
  t && (this.nodeName = t);
};
Wf.prototype = /* @__PURE__ */ Object.create(null);
const xu = [new Wf()];
function d7(t, e, n) {
  if (t.length == 0)
    return xu;
  let r = n ? xu[0] : new Wf(), i = [r];
  for (let a = 0; a < t.length; a++) {
    let o = t[a].type.attrs;
    if (o) {
      o.nodeName && i.push(r = new Wf(o.nodeName));
      for (let s in o) {
        let l = o[s];
        l != null && (n && i.length == 1 && i.push(r = new Wf(e.isInline ? "span" : "div")), s == "class" ? r.class = (r.class ? r.class + " " : "") + l : s == "style" ? r.style = (r.style ? r.style + ";" : "") + l : s != "nodeName" && (r[s] = l));
      }
    }
  }
  return i;
}
function UB(t, e, n, r) {
  if (n == xu && r == xu)
    return e;
  let i = e;
  for (let a = 0; a < r.length; a++) {
    let o = r[a], s = n[a];
    if (a) {
      let l;
      s && s.nodeName == o.nodeName && i != t && (l = i.parentNode) && l.nodeName.toLowerCase() == o.nodeName || (l = document.createElement(o.nodeName), l.pmIsDeco = !0, l.appendChild(i), s = xu[0]), i = l;
    }
    Yie(i, s || xu[0], o);
  }
  return i;
}
function Yie(t, e, n) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in n) && t.removeAttribute(r);
  for (let r in n)
    r != "class" && r != "style" && r != "nodeName" && n[r] != e[r] && t.setAttribute(r, n[r]);
  if (e.class != n.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], i = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let a = 0; a < r.length; a++)
      i.indexOf(r[a]) == -1 && t.classList.remove(r[a]);
    for (let a = 0; a < i.length; a++)
      r.indexOf(i[a]) == -1 && t.classList.add(i[a]);
    t.classList.length == 0 && t.removeAttribute("class");
  }
  if (e.style != n.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, i;
      for (; i = r.exec(e.style); )
        t.style.removeProperty(i[1]);
    }
    n.style && (t.style.cssText += n.style);
  }
}
function WB(t, e, n) {
  return UB(t, t, xu, d7(e, n, t.nodeType != 1));
}
function yy(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (!t[n].type.eq(e[n].type))
      return !1;
  return !0;
}
function CT(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class Kie {
  constructor(e, n, r) {
    this.lock = n, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = $ie(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, n) {
    if (e != n) {
      for (let r = e; r < n; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, n - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, n, r) {
    let i = 0, a = this.stack.length >> 1, o = Math.min(a, e.length);
    for (; i < o && (i == a - 1 ? this.top : this.stack[i + 1 << 1]).matchesMark(e[i]) && e[i].type.spec.spanning !== !1; )
      i++;
    for (; i < a; )
      this.destroyRest(), this.top.dirty = Ta, this.index = this.stack.pop(), this.top = this.stack.pop(), a--;
    for (; a < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let s = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let c = this.top.children[l];
        if (c.matchesMark(e[a]) && !this.isLocked(c.dom)) {
          s = l;
          break;
        }
      }
      if (s > -1)
        s > this.index && (this.changed = !0, this.destroyBetween(this.index, s)), this.top = this.top.children[this.index];
      else {
        let l = Gu.create(this.top, e[a], n, r);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, a++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, n, r, i) {
    let a = -1, o;
    if (i >= this.preMatch.index && (o = this.preMatch.matches[i - this.preMatch.index]).parent == this.top && o.matchesNode(e, n, r))
      a = this.top.children.indexOf(o, this.index);
    else
      for (let s = this.index, l = Math.min(this.top.children.length, s + 5); s < l; s++) {
        let c = this.top.children[s];
        if (c.matchesNode(e, n, r) && !this.preMatch.matched.has(c)) {
          a = s;
          break;
        }
      }
    return a < 0 ? !1 : (this.destroyBetween(this.index, a), this.index++, !0);
  }
  updateNodeAt(e, n, r, i, a) {
    let o = this.top.children[i];
    return o.dirty == es && o.dom == o.contentDOM && (o.dirty = ku), o.update(e, n, r, a) ? (this.destroyBetween(this.index, i), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let n = e.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let i = this.index; i < this.top.children.length; i++)
            if (this.top.children[i] == r)
              return i;
        }
        return -1;
      }
      e = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, n, r, i, a, o) {
    for (let s = this.index; s < this.top.children.length; s++) {
      let l = this.top.children[s];
      if (l instanceof dc) {
        let c = this.preMatch.matched.get(l);
        if (c != null && c != a)
          return !1;
        let u = l.dom, d, f = this.isLocked(u) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != es && yy(n, l.outerDeco));
        if (!f && l.update(e, n, r, i))
          return this.destroyBetween(this.index, s), l.dom != u && (this.changed = !0), this.index++, !0;
        if (!f && (d = this.recreateWrapper(l, e, n, r, i, o)))
          return this.destroyBetween(this.index, s), this.top.children[this.index] = d, d.contentDOM && (d.dirty = ku, d.updateChildren(i, o + 1), d.dirty = Ta), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, n, r, i, a, o) {
    if (e.dirty || n.isAtom || !e.children.length || !e.node.content.eq(n.content) || !yy(r, e.outerDeco) || !i.eq(e.innerDeco))
      return null;
    let s = dc.create(this.top, n, r, i, a, o);
    if (s.contentDOM) {
      s.children = e.children, e.children = [];
      for (let l of s.children)
        l.parent = s;
    }
    return e.destroy(), s;
  }
  // Insert the node as a newly created node desc.
  addNode(e, n, r, i, a) {
    let o = dc.create(this.top, e, n, r, i, a);
    o.contentDOM && o.updateChildren(i, a + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(e, n, r) {
    let i = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (i && i.matchesWidget(e) && (e == i.widget || !i.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let a = new _B(this.top, e, n, r);
      this.top.children.splice(this.index++, 0, a), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], n = this.top;
    for (; e instanceof Gu; )
      n = e, e = n.children[n.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof wg) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((di || Zr) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(e, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let i = new VB(this.top, [], r, null);
      n != this.top ? n.children.push(i) : n.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function $ie(t, e) {
  let n = e, r = n.children.length, i = t.childCount, a = /* @__PURE__ */ new Map(), o = [];
  e: for (; i > 0; ) {
    let s;
    for (; ; )
      if (r) {
        let c = n.children[r - 1];
        if (c instanceof Gu)
          n = c, r = c.children.length;
        else {
          s = c, r--;
          break;
        }
      } else {
        if (n == e)
          break e;
        r = n.parent.children.indexOf(n), n = n.parent;
      }
    let l = s.node;
    if (l) {
      if (l != t.child(i - 1))
        break;
      --i, a.set(s, i), o.push(s);
    }
  }
  return { index: i, matched: a, matches: o.reverse() };
}
function Jie(t, e) {
  return t.type.side - e.type.side;
}
function Qie(t, e, n, r) {
  let i = e.locals(t), a = 0;
  if (i.length == 0) {
    for (let c = 0; c < t.childCount; c++) {
      let u = t.child(c);
      r(u, i, e.forChild(a, u), c), a += u.nodeSize;
    }
    return;
  }
  let o = 0, s = [], l = null;
  for (let c = 0; ; ) {
    let u, d;
    for (; o < i.length && i[o].to == a; ) {
      let g = i[o++];
      g.widget && (u ? (d || (d = [u])).push(g) : u = g);
    }
    if (u)
      if (d) {
        d.sort(Jie);
        for (let g = 0; g < d.length; g++)
          n(d[g], c, !!l);
      } else
        n(u, c, !!l);
    let f, h;
    if (l)
      h = -1, f = l, l = null;
    else if (c < t.childCount)
      h = c, f = t.child(c++);
    else
      break;
    for (let g = 0; g < s.length; g++)
      s[g].to <= a && s.splice(g--, 1);
    for (; o < i.length && i[o].from <= a && i[o].to > a; )
      s.push(i[o++]);
    let p = a + f.nodeSize;
    if (f.isText) {
      let g = p;
      o < i.length && i[o].from < g && (g = i[o].from);
      for (let v = 0; v < s.length; v++)
        s[v].to < g && (g = s[v].to);
      g < p && (l = f.cut(g - a), f = f.cut(0, g - a), p = g, h = -1);
    } else
      for (; o < i.length && i[o].to < p; )
        o++;
    let m = f.isInline && !f.isLeaf ? s.filter((g) => !g.inline) : s.slice();
    r(f, m, e.forChild(a, f), h), a = p;
  }
}
function Xie(t) {
  if (t.nodeName == "UL" || t.nodeName == "OL") {
    let e = t.style.cssText;
    t.style.cssText = e + "; list-style: square !important", window.getComputedStyle(t).listStyle, t.style.cssText = e;
  }
}
function eae(t, e, n, r) {
  for (let i = 0, a = 0; i < t.childCount && a <= r; ) {
    let o = t.child(i++), s = a;
    if (a += o.nodeSize, !o.isText)
      continue;
    let l = o.text;
    for (; i < t.childCount; ) {
      let c = t.child(i++);
      if (a += c.nodeSize, !c.isText)
        break;
      l += c.text;
    }
    if (a >= n) {
      if (a >= r && l.slice(r - e.length - s, r - s) == e)
        return r - e.length;
      let c = s < r ? l.lastIndexOf(e, r - s - 1) : -1;
      if (c >= 0 && c + e.length + s >= n)
        return s + c;
      if (n == r && l.length >= r + e.length - s && l.slice(r - s, r - s + e.length) == e)
        return r;
    }
  }
  return -1;
}
function f7(t, e, n, r, i) {
  let a = [];
  for (let o = 0, s = 0; o < t.length; o++) {
    let l = t[o], c = s, u = s += l.size;
    c >= n || u <= e ? a.push(l) : (c < e && a.push(l.slice(0, e - c, r)), i && (a.push(i), i = void 0), u > n && a.push(l.slice(n - c, l.size, r)));
  }
  return a;
}
function Xk(t, e = null) {
  let n = t.domSelectionRange(), r = t.state.doc;
  if (!n.focusNode)
    return null;
  let i = t.docView.nearestDesc(n.focusNode), a = i && i.size == 0, o = t.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (o < 0)
    return null;
  let s = r.resolve(o), l, c;
  if (bg(n)) {
    for (l = o; i && !i.node; )
      i = i.parent;
    let d = i.node;
    if (i && d.isAtom && gt.isSelectable(d) && i.parent && !(d.isInline && Sie(n.focusNode, n.focusOffset, i.dom))) {
      let f = i.posBefore;
      c = new gt(o == f ? s : r.resolve(f));
    }
  } else {
    if (n instanceof t.dom.ownerDocument.defaultView.Selection && n.rangeCount > 1) {
      let d = o, f = o;
      for (let h = 0; h < n.rangeCount; h++) {
        let p = n.getRangeAt(h);
        d = Math.min(d, t.docView.posFromDOM(p.startContainer, p.startOffset, 1)), f = Math.max(f, t.docView.posFromDOM(p.endContainer, p.endOffset, -1));
      }
      if (d < 0)
        return null;
      [l, o] = f == t.state.selection.anchor ? [f, d] : [d, f], s = r.resolve(o);
    } else
      l = t.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let u = r.resolve(l);
  if (!c) {
    let d = e == "pointer" || t.state.selection.head < s.pos && !a ? 1 : -1;
    c = ex(t, u, s, d);
  }
  return c;
}
function ZB(t) {
  return t.editable ? t.hasFocus() : YB(t) && document.activeElement && document.activeElement.contains(t.dom);
}
function Zs(t, e = !1) {
  let n = t.state.selection;
  if (GB(t, n), !!ZB(t)) {
    if (!e && t.input.mouseDown && t.input.mouseDown.allowDefault && Zr) {
      let r = t.domSelectionRange(), i = t.domObserver.currentSelection;
      if (r.anchorNode && i.anchorNode && Zu(r.anchorNode, r.anchorOffset, i.anchorNode, i.anchorOffset)) {
        t.input.mouseDown.delayedSelectionSync = !0, t.domObserver.setCurSelection();
        return;
      }
    }
    if (t.domObserver.disconnectSelection(), t.cursorWrapper)
      nae(t);
    else {
      let { anchor: r, head: i } = n, a, o;
      AT && !(n instanceof ot) && (n.$from.parent.inlineContent || (a = ST(t, n.from)), !n.empty && !n.$from.parent.inlineContent && (o = ST(t, n.to))), t.docView.setSelection(r, i, t, e), AT && (a && LT(a), o && LT(o)), n.visible ? t.dom.classList.remove("ProseMirror-hideselection") : (t.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && tae(t));
    }
    t.domObserver.setCurSelection(), t.domObserver.connectSelection();
  }
}
const AT = di || Zr && PB < 63;
function ST(t, e) {
  let { node: n, offset: r } = t.docView.domFromPos(e, 0), i = r < n.childNodes.length ? n.childNodes[r] : null, a = r ? n.childNodes[r - 1] : null;
  if (di && i && i.contentEditable == "false")
    return V5(i);
  if ((!i || i.contentEditable == "false") && (!a || a.contentEditable == "false")) {
    if (i)
      return V5(i);
    if (a)
      return V5(a);
  }
}
function V5(t) {
  return t.contentEditable = "true", di && t.draggable && (t.draggable = !1, t.wasDraggable = !0), t;
}
function LT(t) {
  t.contentEditable = "false", t.wasDraggable && (t.draggable = !0, t.wasDraggable = null);
}
function tae(t) {
  let e = t.dom.ownerDocument;
  e.removeEventListener("selectionchange", t.input.hideSelectionGuard);
  let n = t.domSelectionRange(), r = n.anchorNode, i = n.anchorOffset;
  e.addEventListener("selectionchange", t.input.hideSelectionGuard = () => {
    (n.anchorNode != r || n.anchorOffset != i) && (e.removeEventListener("selectionchange", t.input.hideSelectionGuard), setTimeout(() => {
      (!ZB(t) || t.state.selection.visible) && t.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function nae(t) {
  let e = t.domSelection(), n = document.createRange();
  if (!e)
    return;
  let r = t.cursorWrapper.dom, i = r.nodeName == "IMG";
  i ? n.setStart(r.parentNode, zr(r) + 1) : n.setStart(r, 0), n.collapse(!0), e.removeAllRanges(), e.addRange(n), !i && !t.state.selection.visible && Ti && uc <= 11 && (r.disabled = !0, r.disabled = !1);
}
function GB(t, e) {
  if (e instanceof gt) {
    let n = t.docView.descAt(e.from);
    n != t.lastSelectedViewDesc && (TT(t), n && n.selectNode(), t.lastSelectedViewDesc = n);
  } else
    TT(t);
}
function TT(t) {
  t.lastSelectedViewDesc && (t.lastSelectedViewDesc.parent && t.lastSelectedViewDesc.deselectNode(), t.lastSelectedViewDesc = void 0);
}
function ex(t, e, n, r) {
  return t.someProp("createSelectionBetween", (i) => i(t, e, n)) || ot.between(e, n, r);
}
function ET(t) {
  return t.editable && !t.hasFocus() ? !1 : YB(t);
}
function YB(t) {
  let e = t.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return t.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (t.editable || t.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function rae(t) {
  let e = t.docView.domFromPos(t.state.selection.anchor, 0), n = t.domSelectionRange();
  return Zu(e.node, e.offset, n.anchorNode, n.anchorOffset);
}
function h7(t, e) {
  let { $anchor: n, $head: r } = t.selection, i = e > 0 ? n.max(r) : n.min(r), a = i.parent.inlineContent ? i.depth ? t.doc.resolve(e > 0 ? i.after() : i.before()) : null : i;
  return a && vt.findFrom(a, e);
}
function Zl(t, e) {
  return t.dispatch(t.state.tr.setSelection(e).scrollIntoView()), !0;
}
function jT(t, e, n) {
  let r = t.state.selection;
  if (r instanceof ot)
    if (n.indexOf("s") > -1) {
      let { $head: i } = r, a = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter;
      if (!a || a.isText || !a.isLeaf)
        return !1;
      let o = t.state.doc.resolve(i.pos + a.nodeSize * (e < 0 ? -1 : 1));
      return Zl(t, new ot(r.$anchor, o));
    } else if (r.empty) {
      if (t.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let i = h7(t.state, e);
        return i && i instanceof gt ? Zl(t, i) : !1;
      } else if (!(wa && n.indexOf("m") > -1)) {
        let i = r.$head, a = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter, o;
        if (!a || a.isText)
          return !1;
        let s = e < 0 ? i.pos - a.nodeSize : i.pos;
        return a.isAtom || (o = t.docView.descAt(s)) && !o.contentDOM ? gt.isSelectable(a) ? Zl(t, new gt(e < 0 ? t.state.doc.resolve(i.pos - a.nodeSize) : i)) : ep ? Zl(t, new ot(t.state.doc.resolve(e < 0 ? s : s + a.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof gt && r.node.isInline)
      return Zl(t, new ot(e > 0 ? r.$to : r.$from));
    {
      let i = h7(t.state, e);
      return i ? Zl(t, i) : !1;
    }
  }
}
function gy(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function Zf(t, e) {
  let n = t.pmViewDesc;
  return n && n.size == 0 && (e < 0 || t.nextSibling || t.nodeName != "BR");
}
function I0(t, e) {
  return e < 0 ? iae(t) : aae(t);
}
function iae(t) {
  let e = t.domSelectionRange(), n = e.focusNode, r = e.focusOffset;
  if (!n)
    return;
  let i, a, o = !1;
  for (io && n.nodeType == 1 && r < gy(n) && Zf(n.childNodes[r], -1) && (o = !0); ; )
    if (r > 0) {
      if (n.nodeType != 1)
        break;
      {
        let s = n.childNodes[r - 1];
        if (Zf(s, -1))
          i = n, a = --r;
        else if (s.nodeType == 3)
          n = s, r = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (KB(n))
        break;
      {
        let s = n.previousSibling;
        for (; s && Zf(s, -1); )
          i = n.parentNode, a = zr(s), s = s.previousSibling;
        if (s)
          n = s, r = gy(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = 0;
        }
      }
    }
  o ? p7(t, n, r) : i && p7(t, i, a);
}
function aae(t) {
  let e = t.domSelectionRange(), n = e.focusNode, r = e.focusOffset;
  if (!n)
    return;
  let i = gy(n), a, o;
  for (; ; )
    if (r < i) {
      if (n.nodeType != 1)
        break;
      let s = n.childNodes[r];
      if (Zf(s, 1))
        a = n, o = ++r;
      else
        break;
    } else {
      if (KB(n))
        break;
      {
        let s = n.nextSibling;
        for (; s && Zf(s, 1); )
          a = s.parentNode, o = zr(s) + 1, s = s.nextSibling;
        if (s)
          n = s, r = 0, i = gy(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = i = 0;
        }
      }
    }
  a && p7(t, a, o);
}
function KB(t) {
  let e = t.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function oae(t, e) {
  for (; t && e == t.childNodes.length && !X2(t); )
    e = zr(t) + 1, t = t.parentNode;
  for (; t && e < t.childNodes.length; ) {
    let n = t.childNodes[e];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = 0;
  }
}
function sae(t, e) {
  for (; t && !e && !X2(t); )
    e = zr(t), t = t.parentNode;
  for (; t && e; ) {
    let n = t.childNodes[e - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = t.childNodes.length;
  }
}
function p7(t, e, n) {
  if (e.nodeType != 3) {
    let a, o;
    (o = oae(e, n)) ? (e = o, n = 0) : (a = sae(e, n)) && (e = a, n = a.nodeValue.length);
  }
  let r = t.domSelection();
  if (!r)
    return;
  if (bg(r)) {
    let a = document.createRange();
    a.setEnd(e, n), a.setStart(e, n), r.removeAllRanges(), r.addRange(a);
  } else r.extend && r.extend(e, n);
  t.domObserver.setCurSelection();
  let { state: i } = t;
  setTimeout(() => {
    t.state == i && Zs(t);
  }, 50);
}
function NT(t, e) {
  let n = t.state.doc.resolve(e);
  if (!(Zr || Eie) && n.parent.inlineContent) {
    let i = t.coordsAtPos(e);
    if (e > n.start()) {
      let a = t.coordsAtPos(e - 1), o = (a.top + a.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(a.left - i.left) > 1)
        return a.left < i.left ? "ltr" : "rtl";
    }
    if (e < n.end()) {
      let a = t.coordsAtPos(e + 1), o = (a.top + a.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(a.left - i.left) > 1)
        return a.left > i.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(t.dom).direction == "rtl" ? "rtl" : "ltr";
}
function DT(t, e, n) {
  let r = t.state.selection;
  if (r instanceof ot && !r.empty || n.indexOf("s") > -1 || wa && n.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: a } = r;
  if (!i.parent.inlineContent || t.endOfTextblock(e < 0 ? "up" : "down")) {
    let o = h7(t.state, e);
    if (o && o instanceof gt)
      return Zl(t, o);
  }
  if (!i.parent.inlineContent) {
    let o = e < 0 ? i : a, s = r instanceof Li ? vt.near(o, e) : vt.findFrom(o, e);
    return s ? Zl(t, s) : !1;
  }
  return !1;
}
function IT(t, e) {
  if (!(t.state.selection instanceof ot))
    return !0;
  let { $head: n, $anchor: r, empty: i } = t.state.selection;
  if (!n.sameParent(r))
    return !0;
  if (!i)
    return !1;
  if (t.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let a = !n.textOffset && (e < 0 ? n.nodeBefore : n.nodeAfter);
  if (a && !a.isText) {
    let o = t.state.tr;
    return e < 0 ? o.delete(n.pos - a.nodeSize, n.pos) : o.delete(n.pos, n.pos + a.nodeSize), t.dispatch(o), !0;
  }
  return !1;
}
function PT(t, e, n) {
  t.domObserver.stop(), e.contentEditable = n, t.domObserver.start();
}
function lae(t) {
  if (!di || t.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: n } = t.domSelectionRange();
  if (e && e.nodeType == 1 && n == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    PT(t, r, "true"), setTimeout(() => PT(t, r, "false"), 20);
  }
  return !1;
}
function cae(t) {
  let e = "";
  return t.ctrlKey && (e += "c"), t.metaKey && (e += "m"), t.altKey && (e += "a"), t.shiftKey && (e += "s"), e;
}
function uae(t, e) {
  let n = e.keyCode, r = cae(e);
  if (n == 8 || wa && n == 72 && r == "c")
    return IT(t, -1) || I0(t, -1);
  if (n == 46 && !e.shiftKey || wa && n == 68 && r == "c")
    return IT(t, 1) || I0(t, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || wa && n == 66 && r == "c") {
    let i = n == 37 ? NT(t, t.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return jT(t, i, r) || I0(t, i);
  } else if (n == 39 || wa && n == 70 && r == "c") {
    let i = n == 39 ? NT(t, t.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return jT(t, i, r) || I0(t, i);
  } else {
    if (n == 38 || wa && n == 80 && r == "c")
      return DT(t, -1, r) || I0(t, -1);
    if (n == 40 || wa && n == 78 && r == "c")
      return lae(t) || DT(t, 1, r) || I0(t, 1);
    if (r == (wa ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function tx(t, e) {
  t.someProp("transformCopied", (h) => {
    e = h(e, t);
  });
  let n = [], { content: r, openStart: i, openEnd: a } = e;
  for (; i > 1 && a > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    i--, a--;
    let h = r.firstChild;
    n.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), r = h.content;
  }
  let o = t.someProp("clipboardSerializer") || v0.fromSchema(t.state.schema), s = tH(), l = s.createElement("div");
  l.appendChild(o.serializeFragment(r, { document: s }));
  let c = l.firstChild, u, d = 0;
  for (; c && c.nodeType == 1 && (u = eH[c.nodeName.toLowerCase()]); ) {
    for (let h = u.length - 1; h >= 0; h--) {
      let p = s.createElement(u[h]);
      for (; l.firstChild; )
        p.appendChild(l.firstChild);
      l.appendChild(p), d++;
    }
    c = l.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${i} ${a}${d ? ` -${d}` : ""} ${JSON.stringify(n)}`);
  let f = t.someProp("clipboardTextSerializer", (h) => h(e, t)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: f, slice: e };
}
function $B(t, e, n, r, i) {
  let a = i.parent.type.spec.code, o, s;
  if (!n && !e)
    return null;
  let l = e && (r || a || !n);
  if (l) {
    if (t.someProp("transformPastedText", (f) => {
      e = f(e, a || r, t);
    }), a)
      return e ? new Je(Ne.from(t.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : Je.empty;
    let d = t.someProp("clipboardTextParser", (f) => f(e, i, r, t));
    if (d)
      s = d;
    else {
      let f = i.marks(), { schema: h } = t.state, p = v0.fromSchema(h);
      o = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((m) => {
        let g = o.appendChild(document.createElement("p"));
        m && g.appendChild(p.serializeNode(h.text(m, f)));
      });
    }
  } else
    t.someProp("transformPastedHTML", (d) => {
      n = d(n, t);
    }), o = pae(n), ep && mae(o);
  let c = o && o.querySelector("[data-pm-slice]"), u = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let d = +u[3]; d > 0; d--) {
      let f = o.firstChild;
      for (; f && f.nodeType != 1; )
        f = f.nextSibling;
      if (!f)
        break;
      o = f;
    }
  if (s || (s = (t.someProp("clipboardParser") || t.someProp("domParser") || Uo.fromSchema(t.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(l || u),
    context: i,
    ruleFromNode(f) {
      return f.nodeName == "BR" && !f.nextSibling && f.parentNode && !dae.test(f.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    s = yae(zT(s, +u[1], +u[2]), u[4]);
  else if (s = Je.maxOpen(fae(s.content, i), !0), s.openStart || s.openEnd) {
    let d = 0, f = 0;
    for (let h = s.content.firstChild; d < s.openStart && !h.type.spec.isolating; d++, h = h.firstChild)
      ;
    for (let h = s.content.lastChild; f < s.openEnd && !h.type.spec.isolating; f++, h = h.lastChild)
      ;
    s = zT(s, d, f);
  }
  return t.someProp("transformPasted", (d) => {
    s = d(s, t);
  }), s;
}
const dae = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function fae(t, e) {
  if (t.childCount < 2)
    return t;
  for (let n = e.depth; n >= 0; n--) {
    let i = e.node(n).contentMatchAt(e.index(n)), a, o = [];
    if (t.forEach((s) => {
      if (!o)
        return;
      let l = i.findWrapping(s.type), c;
      if (!l)
        return o = null;
      if (c = o.length && a.length && QB(l, a, s, o[o.length - 1], 0))
        o[o.length - 1] = c;
      else {
        o.length && (o[o.length - 1] = XB(o[o.length - 1], a.length));
        let u = JB(s, l);
        o.push(u), i = i.matchType(u.type), a = l;
      }
    }), o)
      return Ne.from(o);
  }
  return t;
}
function JB(t, e, n = 0) {
  for (let r = e.length - 1; r >= n; r--)
    t = e[r].create(null, Ne.from(t));
  return t;
}
function QB(t, e, n, r, i) {
  if (i < t.length && i < e.length && t[i] == e[i]) {
    let a = QB(t, e, n, r.lastChild, i + 1);
    if (a)
      return r.copy(r.content.replaceChild(r.childCount - 1, a));
    if (r.contentMatchAt(r.childCount).matchType(i == t.length - 1 ? n.type : t[i + 1]))
      return r.copy(r.content.append(Ne.from(JB(n, t, i + 1))));
  }
}
function XB(t, e) {
  if (e == 0)
    return t;
  let n = t.content.replaceChild(t.childCount - 1, XB(t.lastChild, e - 1)), r = t.contentMatchAt(t.childCount).fillBefore(Ne.empty, !0);
  return t.copy(n.append(r));
}
function m7(t, e, n, r, i, a) {
  let o = e < 0 ? t.firstChild : t.lastChild, s = o.content;
  return t.childCount > 1 && (a = 0), i < r - 1 && (s = m7(s, e, n, r, i + 1, a)), i >= n && (s = e < 0 ? o.contentMatchAt(0).fillBefore(s, a <= i).append(s) : s.append(o.contentMatchAt(o.childCount).fillBefore(Ne.empty, !0))), t.replaceChild(e < 0 ? 0 : t.childCount - 1, o.copy(s));
}
function zT(t, e, n) {
  return e < t.openStart && (t = new Je(m7(t.content, -1, e, t.openStart, 0, t.openEnd), e, t.openEnd)), n < t.openEnd && (t = new Je(m7(t.content, 1, n, t.openEnd, 0, 0), t.openStart, n)), t;
}
const eH = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let RT = null;
function tH() {
  return RT || (RT = document.implementation.createHTMLDocument("title"));
}
let q5 = null;
function hae(t) {
  let e = window.trustedTypes;
  return e ? (q5 || (q5 = e.createPolicy("ProseMirrorClipboard", { createHTML: (n) => n })), q5.createHTML(t)) : t;
}
function pae(t) {
  let e = /^(\s*<meta [^>]*>)*/.exec(t);
  e && (t = t.slice(e[0].length));
  let n = tH().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(t), i;
  if ((i = r && eH[r[1].toLowerCase()]) && (t = i.map((a) => "<" + a + ">").join("") + t + i.map((a) => "</" + a + ">").reverse().join("")), n.innerHTML = hae(t), i)
    for (let a = 0; a < i.length; a++)
      n = n.querySelector(i[a]) || n;
  return n;
}
function mae(t) {
  let e = t.querySelectorAll(Zr ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < e.length; n++) {
    let r = e[n];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(t.ownerDocument.createTextNode(" "), r);
  }
}
function yae(t, e) {
  if (!t.size)
    return t;
  let n = t.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return t;
  }
  let { content: i, openStart: a, openEnd: o } = t;
  for (let s = r.length - 2; s >= 0; s -= 2) {
    let l = n.nodes[r[s]];
    if (!l || l.hasRequiredAttrs())
      break;
    i = Ne.from(l.create(r[s + 1], i)), a++, o++;
  }
  return new Je(i, a, o);
}
const fi = {}, hi = {}, gae = { touchstart: !0, touchmove: !0 };
class vae {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function bae(t) {
  for (let e in fi) {
    let n = fi[e];
    t.dom.addEventListener(e, t.input.eventHandlers[e] = (r) => {
      kae(t, r) && !nx(t, r) && (t.editable || !(r.type in hi)) && n(t, r);
    }, gae[e] ? { passive: !0 } : void 0);
  }
  di && t.dom.addEventListener("input", () => null), y7(t);
}
function ic(t, e) {
  t.input.lastSelectionOrigin = e, t.input.lastSelectionTime = Date.now();
}
function wae(t) {
  t.domObserver.stop();
  for (let e in t.input.eventHandlers)
    t.dom.removeEventListener(e, t.input.eventHandlers[e]);
  clearTimeout(t.input.composingTimeout), clearTimeout(t.input.lastIOSEnterFallbackTimeout);
}
function y7(t) {
  t.someProp("handleDOMEvents", (e) => {
    for (let n in e)
      t.input.eventHandlers[n] || t.dom.addEventListener(n, t.input.eventHandlers[n] = (r) => nx(t, r));
  });
}
function nx(t, e) {
  return t.someProp("handleDOMEvents", (n) => {
    let r = n[e.type];
    return r ? r(t, e) || e.defaultPrevented : !1;
  });
}
function kae(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let n = e.target; n != t.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function xae(t, e) {
  !nx(t, e) && fi[e.type] && (t.editable || !(e.type in hi)) && fi[e.type](t, e);
}
hi.keydown = (t, e) => {
  let n = e;
  if (t.input.shiftKey = n.keyCode == 16 || n.shiftKey, !rH(t, n) && (t.input.lastKeyCode = n.keyCode, t.input.lastKeyCodeTime = Date.now(), !(Fs && Zr && n.keyCode == 13)))
    if (n.keyCode != 229 && t.domObserver.forceFlush(), z1 && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let r = Date.now();
      t.input.lastIOSEnter = r, t.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        t.input.lastIOSEnter == r && (t.someProp("handleKeyDown", (i) => i(t, mu(13, "Enter"))), t.input.lastIOSEnter = 0);
      }, 200);
    } else t.someProp("handleKeyDown", (r) => r(t, n)) || uae(t, n) ? n.preventDefault() : ic(t, "key");
};
hi.keyup = (t, e) => {
  e.keyCode == 16 && (t.input.shiftKey = !1);
};
hi.keypress = (t, e) => {
  let n = e;
  if (rH(t, n) || !n.charCode || n.ctrlKey && !n.altKey || wa && n.metaKey)
    return;
  if (t.someProp("handleKeyPress", (i) => i(t, n))) {
    n.preventDefault();
    return;
  }
  let r = t.state.selection;
  if (!(r instanceof ot) || !r.$from.sameParent(r.$to)) {
    let i = String.fromCharCode(n.charCode);
    !/[\r\n]/.test(i) && !t.someProp("handleTextInput", (a) => a(t, r.$from.pos, r.$to.pos, i)) && t.dispatch(t.state.tr.insertText(i).scrollIntoView()), n.preventDefault();
  }
};
function kg(t) {
  return { left: t.clientX, top: t.clientY };
}
function Mae(t, e) {
  let n = e.x - t.clientX, r = e.y - t.clientY;
  return n * n + r * r < 100;
}
function rx(t, e, n, r, i) {
  if (r == -1)
    return !1;
  let a = t.state.doc.resolve(r);
  for (let o = a.depth + 1; o > 0; o--)
    if (t.someProp(e, (s) => o > a.depth ? s(t, n, a.nodeAfter, a.before(o), i, !0) : s(t, n, a.node(o), a.before(o), i, !1)))
      return !0;
  return !1;
}
function y1(t, e, n) {
  if (t.focused || t.focus(), t.state.selection.eq(e))
    return;
  let r = t.state.tr.setSelection(e);
  r.setMeta("pointer", !0), t.dispatch(r);
}
function Cae(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.doc.resolve(e), r = n.nodeAfter;
  return r && r.isAtom && gt.isSelectable(r) ? (y1(t, new gt(n)), !0) : !1;
}
function Aae(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.selection, r, i;
  n instanceof gt && (r = n.node);
  let a = t.state.doc.resolve(e);
  for (let o = a.depth + 1; o > 0; o--) {
    let s = o > a.depth ? a.nodeAfter : a.node(o);
    if (gt.isSelectable(s)) {
      r && n.$from.depth > 0 && o >= n.$from.depth && a.before(n.$from.depth + 1) == n.$from.pos ? i = a.before(n.$from.depth) : i = a.before(o);
      break;
    }
  }
  return i != null ? (y1(t, gt.create(t.state.doc, i)), !0) : !1;
}
function Sae(t, e, n, r, i) {
  return rx(t, "handleClickOn", e, n, r) || t.someProp("handleClick", (a) => a(t, e, r)) || (i ? Aae(t, n) : Cae(t, n));
}
function Lae(t, e, n, r) {
  return rx(t, "handleDoubleClickOn", e, n, r) || t.someProp("handleDoubleClick", (i) => i(t, e, r));
}
function Tae(t, e, n, r) {
  return rx(t, "handleTripleClickOn", e, n, r) || t.someProp("handleTripleClick", (i) => i(t, e, r)) || Eae(t, n, r);
}
function Eae(t, e, n) {
  if (n.button != 0)
    return !1;
  let r = t.state.doc;
  if (e == -1)
    return r.inlineContent ? (y1(t, ot.create(r, 0, r.content.size)), !0) : !1;
  let i = r.resolve(e);
  for (let a = i.depth + 1; a > 0; a--) {
    let o = a > i.depth ? i.nodeAfter : i.node(a), s = i.before(a);
    if (o.inlineContent)
      y1(t, ot.create(r, s + 1, s + 1 + o.content.size));
    else if (gt.isSelectable(o))
      y1(t, gt.create(r, s));
    else
      continue;
    return !0;
  }
}
function ix(t) {
  return vy(t);
}
const nH = wa ? "metaKey" : "ctrlKey";
fi.mousedown = (t, e) => {
  let n = e;
  t.input.shiftKey = n.shiftKey;
  let r = ix(t), i = Date.now(), a = "singleClick";
  i - t.input.lastClick.time < 500 && Mae(n, t.input.lastClick) && !n[nH] && (t.input.lastClick.type == "singleClick" ? a = "doubleClick" : t.input.lastClick.type == "doubleClick" && (a = "tripleClick")), t.input.lastClick = { time: i, x: n.clientX, y: n.clientY, type: a };
  let o = t.posAtCoords(kg(n));
  o && (a == "singleClick" ? (t.input.mouseDown && t.input.mouseDown.done(), t.input.mouseDown = new jae(t, o, n, !!r)) : (a == "doubleClick" ? Lae : Tae)(t, o.pos, o.inside, n) ? n.preventDefault() : ic(t, "pointer"));
};
class jae {
  constructor(e, n, r, i) {
    this.view = e, this.pos = n, this.event = r, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[nH], this.allowDefault = r.shiftKey;
    let a, o;
    if (n.inside > -1)
      a = e.state.doc.nodeAt(n.inside), o = n.inside;
    else {
      let u = e.state.doc.resolve(n.pos);
      a = u.parent, o = u.depth ? u.before() : 0;
    }
    const s = i ? null : r.target, l = s ? e.docView.nearestDesc(s, !0) : null;
    this.target = l && l.dom.nodeType == 1 ? l.dom : null;
    let { selection: c } = e.state;
    (r.button == 0 && a.type.spec.draggable && a.type.spec.selectable !== !1 || c instanceof gt && c.from <= o && c.to > o) && (this.mightDrag = {
      node: a,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && io && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), ic(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => Zs(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(kg(e))), this.updateAllowDefault(e), this.allowDefault || !n ? ic(this.view, "pointer") : Sae(this.view, n.pos, n.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    di && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Zr && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (y1(this.view, vt.near(this.view.state.doc.resolve(n.pos))), e.preventDefault()) : ic(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), ic(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
fi.touchstart = (t) => {
  t.input.lastTouch = Date.now(), ix(t), ic(t, "pointer");
};
fi.touchmove = (t) => {
  t.input.lastTouch = Date.now(), ic(t, "pointer");
};
fi.contextmenu = (t) => ix(t);
function rH(t, e) {
  return t.composing ? !0 : di && Math.abs(e.timeStamp - t.input.compositionEndedAt) < 500 ? (t.input.compositionEndedAt = -2e8, !0) : !1;
}
const Nae = Fs ? 5e3 : -1;
hi.compositionstart = hi.compositionupdate = (t) => {
  if (!t.composing) {
    t.domObserver.flush();
    let { state: e } = t, n = e.selection.$to;
    if (e.selection instanceof ot && (e.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      t.markCursor = t.state.storedMarks || n.marks(), vy(t, !0), t.markCursor = null;
    else if (vy(t, !e.selection.empty), io && e.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let r = t.domSelectionRange();
      for (let i = r.focusNode, a = r.focusOffset; i && i.nodeType == 1 && a != 0; ) {
        let o = a < 0 ? i.lastChild : i.childNodes[a - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          let s = t.domSelection();
          s && s.collapse(o, o.nodeValue.length);
          break;
        } else
          i = o, a = -1;
      }
    }
    t.input.composing = !0;
  }
  iH(t, Nae);
};
hi.compositionend = (t, e) => {
  t.composing && (t.input.composing = !1, t.input.compositionEndedAt = e.timeStamp, t.input.compositionPendingChanges = t.domObserver.pendingRecords().length ? t.input.compositionID : 0, t.input.compositionNode = null, t.input.compositionPendingChanges && Promise.resolve().then(() => t.domObserver.flush()), t.input.compositionID++, iH(t, 20));
};
function iH(t, e) {
  clearTimeout(t.input.composingTimeout), e > -1 && (t.input.composingTimeout = setTimeout(() => vy(t), e));
}
function aH(t) {
  for (t.composing && (t.input.composing = !1, t.input.compositionEndedAt = Iae()); t.input.compositionNodes.length > 0; )
    t.input.compositionNodes.pop().markParentsDirty();
}
function Dae(t) {
  let e = t.domSelectionRange();
  if (!e.focusNode)
    return null;
  let n = Cie(e.focusNode, e.focusOffset), r = Aie(e.focusNode, e.focusOffset);
  if (n && r && n != r) {
    let i = r.pmViewDesc, a = t.domObserver.lastChangedTextNode;
    if (n == a || r == a)
      return a;
    if (!i || !i.isText(r.nodeValue))
      return r;
    if (t.input.compositionNode == r) {
      let o = n.pmViewDesc;
      if (!(!o || !o.isText(n.nodeValue)))
        return r;
    }
  }
  return n || r;
}
function Iae() {
  let t = document.createEvent("Event");
  return t.initEvent("event", !0, !0), t.timeStamp;
}
function vy(t, e = !1) {
  if (!(Fs && t.domObserver.flushingSoon >= 0)) {
    if (t.domObserver.forceFlush(), aH(t), e || t.docView && t.docView.dirty) {
      let n = Xk(t);
      return n && !n.eq(t.state.selection) ? t.dispatch(t.state.tr.setSelection(n)) : (t.markCursor || e) && !t.state.selection.empty ? t.dispatch(t.state.tr.deleteSelection()) : t.updateState(t.state), !0;
    }
    return !1;
  }
}
function Pae(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(e), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), i = document.createRange();
  i.selectNodeContents(e), t.dom.blur(), r.removeAllRanges(), r.addRange(i), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), t.focus();
  }, 50);
}
const Th = Ti && uc < 15 || z1 && jie < 604;
fi.copy = hi.cut = (t, e) => {
  let n = e, r = t.state.selection, i = n.type == "cut";
  if (r.empty)
    return;
  let a = Th ? null : n.clipboardData, o = r.content(), { dom: s, text: l } = tx(t, o);
  a ? (n.preventDefault(), a.clearData(), a.setData("text/html", s.innerHTML), a.setData("text/plain", l)) : Pae(t, s), i && t.dispatch(t.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function zae(t) {
  return t.openStart == 0 && t.openEnd == 0 && t.content.childCount == 1 ? t.content.firstChild : null;
}
function Rae(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.input.shiftKey || t.state.selection.$from.parent.type.spec.code, r = t.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let i = t.input.shiftKey && t.input.lastKeyCode != 45;
  setTimeout(() => {
    t.focus(), r.parentNode && r.parentNode.removeChild(r), n ? Eh(t, r.value, null, i, e) : Eh(t, r.textContent, r.innerHTML, i, e);
  }, 50);
}
function Eh(t, e, n, r, i) {
  let a = $B(t, e, n, r, t.state.selection.$from);
  if (t.someProp("handlePaste", (l) => l(t, i, a || Je.empty)))
    return !0;
  if (!a)
    return !1;
  let o = zae(a), s = o ? t.state.tr.replaceSelectionWith(o, r) : t.state.tr.replaceSelection(a);
  return t.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function oH(t) {
  let e = t.getData("text/plain") || t.getData("Text");
  if (e)
    return e;
  let n = t.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
hi.paste = (t, e) => {
  let n = e;
  if (t.composing && !Fs)
    return;
  let r = Th ? null : n.clipboardData, i = t.input.shiftKey && t.input.lastKeyCode != 45;
  r && Eh(t, oH(r), r.getData("text/html"), i, n) ? n.preventDefault() : Rae(t, n);
};
class sH {
  constructor(e, n, r) {
    this.slice = e, this.move = n, this.node = r;
  }
}
const lH = wa ? "altKey" : "ctrlKey";
fi.dragstart = (t, e) => {
  let n = e, r = t.input.mouseDown;
  if (r && r.done(), !n.dataTransfer)
    return;
  let i = t.state.selection, a = i.empty ? null : t.posAtCoords(kg(n)), o;
  if (!(a && a.pos >= i.from && a.pos <= (i instanceof gt ? i.to - 1 : i.to))) {
    if (r && r.mightDrag)
      o = gt.create(t.state.doc, r.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let d = t.docView.nearestDesc(n.target, !0);
      d && d.node.type.spec.draggable && d != t.docView && (o = gt.create(t.state.doc, d.posBefore));
    }
  }
  let s = (o || t.state.selection).content(), { dom: l, text: c, slice: u } = tx(t, s);
  (!n.dataTransfer.files.length || !Zr || PB > 120) && n.dataTransfer.clearData(), n.dataTransfer.setData(Th ? "Text" : "text/html", l.innerHTML), n.dataTransfer.effectAllowed = "copyMove", Th || n.dataTransfer.setData("text/plain", c), t.dragging = new sH(u, !n[lH], o);
};
fi.dragend = (t) => {
  let e = t.dragging;
  window.setTimeout(() => {
    t.dragging == e && (t.dragging = null);
  }, 50);
};
hi.dragover = hi.dragenter = (t, e) => e.preventDefault();
hi.drop = (t, e) => {
  let n = e, r = t.dragging;
  if (t.dragging = null, !n.dataTransfer)
    return;
  let i = t.posAtCoords(kg(n));
  if (!i)
    return;
  let a = t.state.doc.resolve(i.pos), o = r && r.slice;
  o ? t.someProp("transformPasted", (p) => {
    o = p(o, t);
  }) : o = $B(t, oH(n.dataTransfer), Th ? null : n.dataTransfer.getData("text/html"), !1, a);
  let s = !!(r && !n[lH]);
  if (t.someProp("handleDrop", (p) => p(t, n, o || Je.empty, s))) {
    n.preventDefault();
    return;
  }
  if (!o)
    return;
  n.preventDefault();
  let l = o ? SB(t.state.doc, a.pos, o) : a.pos;
  l == null && (l = a.pos);
  let c = t.state.tr;
  if (s) {
    let { node: p } = r;
    p ? p.replace(c) : c.deleteSelection();
  }
  let u = c.mapping.map(l), d = o.openStart == 0 && o.openEnd == 0 && o.content.childCount == 1, f = c.doc;
  if (d ? c.replaceRangeWith(u, u, o.content.firstChild) : c.replaceRange(u, u, o), c.doc.eq(f))
    return;
  let h = c.doc.resolve(u);
  if (d && gt.isSelectable(o.content.firstChild) && h.nodeAfter && h.nodeAfter.sameMarkup(o.content.firstChild))
    c.setSelection(new gt(h));
  else {
    let p = c.mapping.map(l);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((m, g, v, k) => p = k), c.setSelection(ex(t, h, c.doc.resolve(p)));
  }
  t.focus(), t.dispatch(c.setMeta("uiEvent", "drop"));
};
fi.focus = (t) => {
  t.input.lastFocus = Date.now(), t.focused || (t.domObserver.stop(), t.dom.classList.add("ProseMirror-focused"), t.domObserver.start(), t.focused = !0, setTimeout(() => {
    t.docView && t.hasFocus() && !t.domObserver.currentSelection.eq(t.domSelectionRange()) && Zs(t);
  }, 20));
};
fi.blur = (t, e) => {
  let n = e;
  t.focused && (t.domObserver.stop(), t.dom.classList.remove("ProseMirror-focused"), t.domObserver.start(), n.relatedTarget && t.dom.contains(n.relatedTarget) && t.domObserver.currentSelection.clear(), t.focused = !1);
};
fi.beforeinput = (t, e) => {
  if (Zr && Fs && e.inputType == "deleteContentBackward") {
    t.domObserver.flushSoon();
    let { domChangeCount: r } = t.input;
    setTimeout(() => {
      if (t.input.domChangeCount != r || (t.dom.blur(), t.focus(), t.someProp("handleKeyDown", (a) => a(t, mu(8, "Backspace")))))
        return;
      let { $cursor: i } = t.state.selection;
      i && i.pos > 0 && t.dispatch(t.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let t in hi)
  fi[t] = hi[t];
function jh(t, e) {
  if (t == e)
    return !0;
  for (let n in t)
    if (t[n] !== e[n])
      return !1;
  for (let n in e)
    if (!(n in t))
      return !1;
  return !0;
}
class by {
  constructor(e, n) {
    this.toDOM = e, this.spec = n || Du, this.side = this.spec.side || 0;
  }
  map(e, n, r, i) {
    let { pos: a, deleted: o } = e.mapResult(n.from + i, this.side < 0 ? -1 : 1);
    return o ? null : new hr(a - r, a - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof by && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && jh(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class fc {
  constructor(e, n) {
    this.attrs = e, this.spec = n || Du;
  }
  map(e, n, r, i) {
    let a = e.map(n.from + i, this.spec.inclusiveStart ? -1 : 1) - r, o = e.map(n.to + i, this.spec.inclusiveEnd ? 1 : -1) - r;
    return a >= o ? null : new hr(a, o, this);
  }
  valid(e, n) {
    return n.from < n.to;
  }
  eq(e) {
    return this == e || e instanceof fc && jh(this.attrs, e.attrs) && jh(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof fc;
  }
  destroy() {
  }
}
class ax {
  constructor(e, n) {
    this.attrs = e, this.spec = n || Du;
  }
  map(e, n, r, i) {
    let a = e.mapResult(n.from + i, 1);
    if (a.deleted)
      return null;
    let o = e.mapResult(n.to + i, -1);
    return o.deleted || o.pos <= a.pos ? null : new hr(a.pos - r, o.pos - r, this);
  }
  valid(e, n) {
    let { index: r, offset: i } = e.content.findIndex(n.from), a;
    return i == n.from && !(a = e.child(r)).isText && i + a.nodeSize == n.to;
  }
  eq(e) {
    return this == e || e instanceof ax && jh(this.attrs, e.attrs) && jh(this.spec, e.spec);
  }
  destroy() {
  }
}
class hr {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.from = e, this.to = n, this.type = r;
  }
  /**
  @internal
  */
  copy(e, n) {
    return new hr(e, n, this.type);
  }
  /**
  @internal
  */
  eq(e, n = 0) {
    return this.type.eq(e.type) && this.from + n == e.from && this.to + n == e.to;
  }
  /**
  @internal
  */
  map(e, n, r) {
    return this.type.map(e, this, n, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, n, r) {
    return new hr(e, e, new by(n, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, n, r, i) {
    return new hr(e, n, new fc(r, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, n, r, i) {
    return new hr(e, n, new ax(r, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof fc;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof by;
  }
}
const K0 = [], Du = {};
class vn {
  /**
  @internal
  */
  constructor(e, n) {
    this.local = e.length ? e : K0, this.children = n.length ? n : K0;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, n) {
    return n.length ? wy(n, e, 0, Du) : Vr;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, n, r) {
    let i = [];
    return this.findInner(e ?? 0, n ?? 1e9, i, 0, r), i;
  }
  findInner(e, n, r, i, a) {
    for (let o = 0; o < this.local.length; o++) {
      let s = this.local[o];
      s.from <= n && s.to >= e && (!a || a(s.spec)) && r.push(s.copy(s.from + i, s.to + i));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < n && this.children[o + 1] > e) {
        let s = this.children[o] + 1;
        this.children[o + 2].findInner(e - s, n - s, r, i + s, a);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, n, r) {
    return this == Vr || e.maps.length == 0 ? this : this.mapInner(e, n, 0, 0, r || Du);
  }
  /**
  @internal
  */
  mapInner(e, n, r, i, a) {
    let o;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s].map(e, r, i);
      l && l.type.valid(n, l) ? (o || (o = [])).push(l) : a.onRemove && a.onRemove(this.local[s].spec);
    }
    return this.children.length ? Oae(this.children, o || [], e, n, r, i, a) : o ? new vn(o.sort(Iu), K0) : Vr;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, n) {
    return n.length ? this == Vr ? vn.create(e, n) : this.addInner(e, n, 0) : this;
  }
  addInner(e, n, r) {
    let i, a = 0;
    e.forEach((s, l) => {
      let c = l + r, u;
      if (u = uH(n, s, c)) {
        for (i || (i = this.children.slice()); a < i.length && i[a] < l; )
          a += 3;
        i[a] == l ? i[a + 2] = i[a + 2].addInner(s, u, c + 1) : i.splice(a, 0, l, l + s.nodeSize, wy(u, s, c + 1, Du)), a += 3;
      }
    });
    let o = cH(a ? dH(n) : n, -r);
    for (let s = 0; s < o.length; s++)
      o[s].type.valid(e, o[s]) || o.splice(s--, 1);
    return new vn(o.length ? this.local.concat(o).sort(Iu) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == Vr ? this : this.removeInner(e, 0);
  }
  removeInner(e, n) {
    let r = this.children, i = this.local;
    for (let a = 0; a < r.length; a += 3) {
      let o, s = r[a] + n, l = r[a + 1] + n;
      for (let u = 0, d; u < e.length; u++)
        (d = e[u]) && d.from > s && d.to < l && (e[u] = null, (o || (o = [])).push(d));
      if (!o)
        continue;
      r == this.children && (r = this.children.slice());
      let c = r[a + 2].removeInner(o, s + 1);
      c != Vr ? r[a + 2] = c : (r.splice(a, 3), a -= 3);
    }
    if (i.length) {
      for (let a = 0, o; a < e.length; a++)
        if (o = e[a])
          for (let s = 0; s < i.length; s++)
            i[s].eq(o, n) && (i == this.local && (i = this.local.slice()), i.splice(s--, 1));
    }
    return r == this.children && i == this.local ? this : i.length || r.length ? new vn(i, r) : Vr;
  }
  forChild(e, n) {
    if (this == Vr)
      return this;
    if (n.isLeaf)
      return vn.empty;
    let r, i;
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] >= e) {
        this.children[s] == e && (r = this.children[s + 2]);
        break;
      }
    let a = e + 1, o = a + n.content.size;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s];
      if (l.from < o && l.to > a && l.type instanceof fc) {
        let c = Math.max(a, l.from) - a, u = Math.min(o, l.to) - a;
        c < u && (i || (i = [])).push(l.copy(c, u));
      }
    }
    if (i) {
      let s = new vn(i.sort(Iu), K0);
      return r ? new Jl([s, r]) : s;
    }
    return r || Vr;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof vn) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(e.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != e.children[n] || this.children[n + 1] != e.children[n + 1] || !this.children[n + 2].eq(e.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return ox(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == Vr)
      return K0;
    if (e.inlineContent || !this.local.some(fc.is))
      return this.local;
    let n = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof fc || n.push(this.local[r]);
    return n;
  }
  forEachSet(e) {
    e(this);
  }
}
vn.empty = new vn([], []);
vn.removeOverlap = ox;
const Vr = vn.empty;
class Jl {
  constructor(e) {
    this.members = e;
  }
  map(e, n) {
    const r = this.members.map((i) => i.map(e, n, Du));
    return Jl.from(r);
  }
  forChild(e, n) {
    if (n.isLeaf)
      return vn.empty;
    let r = [];
    for (let i = 0; i < this.members.length; i++) {
      let a = this.members[i].forChild(e, n);
      a != Vr && (a instanceof Jl ? r = r.concat(a.members) : r.push(a));
    }
    return Jl.from(r);
  }
  eq(e) {
    if (!(e instanceof Jl) || e.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(e.members[n]))
        return !1;
    return !0;
  }
  locals(e) {
    let n, r = !0;
    for (let i = 0; i < this.members.length; i++) {
      let a = this.members[i].localsInner(e);
      if (a.length)
        if (!n)
          n = a;
        else {
          r && (n = n.slice(), r = !1);
          for (let o = 0; o < a.length; o++)
            n.push(a[o]);
        }
    }
    return n ? ox(r ? n : n.sort(Iu)) : K0;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return Vr;
      case 1:
        return e[0];
      default:
        return new Jl(e.every((n) => n instanceof vn) ? e : e.reduce((n, r) => n.concat(r instanceof vn ? r : r.members), []));
    }
  }
  forEachSet(e) {
    for (let n = 0; n < this.members.length; n++)
      this.members[n].forEachSet(e);
  }
}
function Oae(t, e, n, r, i, a, o) {
  let s = t.slice();
  for (let c = 0, u = a; c < n.maps.length; c++) {
    let d = 0;
    n.maps[c].forEach((f, h, p, m) => {
      let g = m - p - (h - f);
      for (let v = 0; v < s.length; v += 3) {
        let k = s[v + 1];
        if (k < 0 || f > k + u - d)
          continue;
        let w = s[v] + u - d;
        h >= w ? s[v + 1] = f <= w ? -2 : -1 : f >= u && g && (s[v] += g, s[v + 1] += g);
      }
      d += g;
    }), u = n.maps[c].map(u, -1);
  }
  let l = !1;
  for (let c = 0; c < s.length; c += 3)
    if (s[c + 1] < 0) {
      if (s[c + 1] == -2) {
        l = !0, s[c + 1] = -1;
        continue;
      }
      let u = n.map(t[c] + a), d = u - i;
      if (d < 0 || d >= r.content.size) {
        l = !0;
        continue;
      }
      let f = n.map(t[c + 1] + a, -1), h = f - i, { index: p, offset: m } = r.content.findIndex(d), g = r.maybeChild(p);
      if (g && m == d && m + g.nodeSize == h) {
        let v = s[c + 2].mapInner(n, g, u + 1, t[c] + a + 1, o);
        v != Vr ? (s[c] = d, s[c + 1] = h, s[c + 2] = v) : (s[c + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let c = Bae(s, t, e, n, i, a, o), u = wy(c, r, 0, o);
    e = u.local;
    for (let d = 0; d < s.length; d += 3)
      s[d + 1] < 0 && (s.splice(d, 3), d -= 3);
    for (let d = 0, f = 0; d < u.children.length; d += 3) {
      let h = u.children[d];
      for (; f < s.length && s[f] < h; )
        f += 3;
      s.splice(f, 0, u.children[d], u.children[d + 1], u.children[d + 2]);
    }
  }
  return new vn(e.sort(Iu), s);
}
function cH(t, e) {
  if (!e || !t.length)
    return t;
  let n = [];
  for (let r = 0; r < t.length; r++) {
    let i = t[r];
    n.push(new hr(i.from + e, i.to + e, i.type));
  }
  return n;
}
function Bae(t, e, n, r, i, a, o) {
  function s(l, c) {
    for (let u = 0; u < l.local.length; u++) {
      let d = l.local[u].map(r, i, c);
      d ? n.push(d) : o.onRemove && o.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      s(l.children[u + 2], l.children[u] + c + 1);
  }
  for (let l = 0; l < t.length; l += 3)
    t[l + 1] == -1 && s(t[l + 2], e[l] + a + 1);
  return n;
}
function uH(t, e, n) {
  if (e.isLeaf)
    return null;
  let r = n + e.nodeSize, i = null;
  for (let a = 0, o; a < t.length; a++)
    (o = t[a]) && o.from > n && o.to < r && ((i || (i = [])).push(o), t[a] = null);
  return i;
}
function dH(t) {
  let e = [];
  for (let n = 0; n < t.length; n++)
    t[n] != null && e.push(t[n]);
  return e;
}
function wy(t, e, n, r) {
  let i = [], a = !1;
  e.forEach((s, l) => {
    let c = uH(t, s, l + n);
    if (c) {
      a = !0;
      let u = wy(c, s, n + l + 1, r);
      u != Vr && i.push(l, l + s.nodeSize, u);
    }
  });
  let o = cH(a ? dH(t) : t, -n).sort(Iu);
  for (let s = 0; s < o.length; s++)
    o[s].type.valid(e, o[s]) || (r.onRemove && r.onRemove(o[s].spec), o.splice(s--, 1));
  return o.length || i.length ? new vn(o, i) : Vr;
}
function Iu(t, e) {
  return t.from - e.from || t.to - e.to;
}
function ox(t) {
  let e = t;
  for (let n = 0; n < e.length - 1; n++) {
    let r = e[n];
    if (r.from != r.to)
      for (let i = n + 1; i < e.length; i++) {
        let a = e[i];
        if (a.from == r.from) {
          a.to != r.to && (e == t && (e = t.slice()), e[i] = a.copy(a.from, r.to), OT(e, i + 1, a.copy(r.to, a.to)));
          continue;
        } else {
          a.from < r.to && (e == t && (e = t.slice()), e[n] = r.copy(r.from, a.from), OT(e, i, r.copy(a.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function OT(t, e, n) {
  for (; e < t.length && Iu(n, t[e]) > 0; )
    e++;
  t.splice(e, 0, n);
}
function U5(t) {
  let e = [];
  return t.someProp("decorations", (n) => {
    let r = n(t.state);
    r && r != Vr && e.push(r);
  }), t.cursorWrapper && e.push(vn.create(t.state.doc, [t.cursorWrapper.deco])), Jl.from(e);
}
const Hae = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, Fae = Ti && uc <= 11;
class _ae {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class Vae {
  constructor(e, n) {
    this.view = e, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new _ae(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let i = 0; i < r.length; i++)
        this.queue.push(r[i]);
      Ti && uc <= 11 && r.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), Fae && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, Hae)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let n = 0; n < e.length; n++)
          this.queue.push(e[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (ET(this.view)) {
      if (this.suppressingSelectionUpdates)
        return Zs(this.view);
      if (Ti && uc <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && Zu(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), r;
    for (let a = e.focusNode; a; a = P1(a))
      n.add(a);
    for (let a = e.anchorNode; a; a = P1(a))
      if (n.has(a)) {
        r = a;
        break;
      }
    let i = r && this.view.docView.nearestDesc(r);
    if (i && i.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let r = e.domSelectionRange(), i = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && ET(e) && !this.ignoreSelectionChange(r), a = -1, o = -1, s = !1, l = [];
    if (e.editable)
      for (let u = 0; u < n.length; u++) {
        let d = this.registerMutation(n[u], l);
        d && (a = a < 0 ? d.from : Math.min(d.from, a), o = o < 0 ? d.to : Math.max(d.to, o), d.typeOver && (s = !0));
      }
    if (io && l.length) {
      let u = l.filter((d) => d.nodeName == "BR");
      if (u.length == 2) {
        let [d, f] = u;
        d.parentNode && d.parentNode.parentNode == f.parentNode ? f.remove() : d.remove();
      } else {
        let { focusNode: d } = this.currentSelection;
        for (let f of u) {
          let h = f.parentNode;
          h && h.nodeName == "LI" && (!d || Wae(e, d) != h) && f.remove();
        }
      }
    }
    let c = null;
    a < 0 && i && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && bg(r) && (c = Xk(e)) && c.eq(vt.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, Zs(e), this.currentSelection.set(r), e.scrollToSelection()) : (a > -1 || i) && (a > -1 && (e.docView.markDirty(a, o), qae(e)), this.handleDOMChange(a, o, s, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || Zs(e), this.currentSelection.set(r));
  }
  registerMutation(e, n) {
    if (n.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let u = 0; u < e.addedNodes.length; u++) {
        let d = e.addedNodes[u];
        n.push(d), d.nodeType == 3 && (this.lastChangedTextNode = d);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let i = e.previousSibling, a = e.nextSibling;
      if (Ti && uc <= 11 && e.addedNodes.length)
        for (let u = 0; u < e.addedNodes.length; u++) {
          let { previousSibling: d, nextSibling: f } = e.addedNodes[u];
          (!d || Array.prototype.indexOf.call(e.addedNodes, d) < 0) && (i = d), (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (a = f);
        }
      let o = i && i.parentNode == e.target ? zr(i) + 1 : 0, s = r.localPosFromDOM(e.target, o, -1), l = a && a.parentNode == e.target ? zr(a) : e.target.childNodes.length, c = r.localPosFromDOM(e.target, l, 1);
      return { from: s, to: c };
    } else return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = e.target, {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let BT = /* @__PURE__ */ new WeakMap(), HT = !1;
function qae(t) {
  if (!BT.has(t) && (BT.set(t, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(t.dom).whiteSpace) !== -1)) {
    if (t.requiresGeckoHackNode = io, HT)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), HT = !0;
  }
}
function FT(t, e) {
  let n = e.startContainer, r = e.startOffset, i = e.endContainer, a = e.endOffset, o = t.domAtPos(t.state.selection.anchor);
  return Zu(o.node, o.offset, i, a) && ([n, r, i, a] = [i, a, n, r]), { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: a };
}
function Uae(t, e) {
  if (e.getComposedRanges) {
    let i = e.getComposedRanges(t.root)[0];
    if (i)
      return FT(t, i);
  }
  let n;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), n = i.getTargetRanges()[0];
  }
  return t.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), t.dom.removeEventListener("beforeinput", r, !0), n ? FT(t, n) : null;
}
function Wae(t, e) {
  for (let n = e.parentNode; n && n != t.dom; n = n.parentNode) {
    let r = t.docView.nearestDesc(n, !0);
    if (r && r.node.isBlock)
      return n;
  }
  return null;
}
function Zae(t, e, n) {
  let { node: r, fromOffset: i, toOffset: a, from: o, to: s } = t.docView.parseRange(e, n), l = t.domSelectionRange(), c, u = l.anchorNode;
  if (u && t.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (c = [{ node: u, offset: l.anchorOffset }], bg(l) || c.push({ node: l.focusNode, offset: l.focusOffset })), Zr && t.input.lastKeyCode === 8)
    for (let g = a; g > i; g--) {
      let v = r.childNodes[g - 1], k = v.pmViewDesc;
      if (v.nodeName == "BR" && !k) {
        a = g;
        break;
      }
      if (!k || k.size)
        break;
    }
  let d = t.state.doc, f = t.someProp("domParser") || Uo.fromSchema(t.state.schema), h = d.resolve(o), p = null, m = f.parse(r, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: i,
    to: a,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: c,
    ruleFromNode: Gae,
    context: h
  });
  if (c && c[0].pos != null) {
    let g = c[0].pos, v = c[1] && c[1].pos;
    v == null && (v = g), p = { anchor: g + o, head: v + o };
  }
  return { doc: m, sel: p, from: o, to: s };
}
function Gae(t) {
  let e = t.pmViewDesc;
  if (e)
    return e.parseRule();
  if (t.nodeName == "BR" && t.parentNode) {
    if (di && /^(ul|ol)$/i.test(t.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (t.parentNode.lastChild == t || di && /^(tr|table)$/i.test(t.parentNode.nodeName))
      return { ignore: !0 };
  } else if (t.nodeName == "IMG" && t.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const Yae = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function Kae(t, e, n, r, i) {
  let a = t.input.compositionPendingChanges || (t.composing ? t.input.compositionID : 0);
  if (t.input.compositionPendingChanges = 0, e < 0) {
    let j = t.input.lastSelectionTime > Date.now() - 50 ? t.input.lastSelectionOrigin : null, D = Xk(t, j);
    if (D && !t.state.selection.eq(D)) {
      if (Zr && Fs && t.input.lastKeyCode === 13 && Date.now() - 100 < t.input.lastKeyCodeTime && t.someProp("handleKeyDown", (H) => H(t, mu(13, "Enter"))))
        return;
      let z = t.state.tr.setSelection(D);
      j == "pointer" ? z.setMeta("pointer", !0) : j == "key" && z.scrollIntoView(), a && z.setMeta("composition", a), t.dispatch(z);
    }
    return;
  }
  let o = t.state.doc.resolve(e), s = o.sharedDepth(n);
  e = o.before(s + 1), n = t.state.doc.resolve(n).after(s + 1);
  let l = t.state.selection, c = Zae(t, e, n), u = t.state.doc, d = u.slice(c.from, c.to), f, h;
  t.input.lastKeyCode === 8 && Date.now() - 100 < t.input.lastKeyCodeTime ? (f = t.state.selection.to, h = "end") : (f = t.state.selection.from, h = "start"), t.input.lastKeyCode = null;
  let p = Qae(d.content, c.doc.content, c.from, f, h);
  if (p && t.input.domChangeCount++, (z1 && t.input.lastIOSEnter > Date.now() - 225 || Fs) && i.some((j) => j.nodeType == 1 && !Yae.test(j.nodeName)) && (!p || p.endA >= p.endB) && t.someProp("handleKeyDown", (j) => j(t, mu(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (!p)
    if (r && l instanceof ot && !l.empty && l.$head.sameParent(l.$anchor) && !t.composing && !(c.sel && c.sel.anchor != c.sel.head))
      p = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (c.sel) {
        let j = _T(t, t.state.doc, c.sel);
        if (j && !j.eq(t.state.selection)) {
          let D = t.state.tr.setSelection(j);
          a && D.setMeta("composition", a), t.dispatch(D);
        }
      }
      return;
    }
  t.state.selection.from < t.state.selection.to && p.start == p.endB && t.state.selection instanceof ot && (p.start > t.state.selection.from && p.start <= t.state.selection.from + 2 && t.state.selection.from >= c.from ? p.start = t.state.selection.from : p.endA < t.state.selection.to && p.endA >= t.state.selection.to - 2 && t.state.selection.to <= c.to && (p.endB += t.state.selection.to - p.endA, p.endA = t.state.selection.to)), Ti && uc <= 11 && p.endB == p.start + 1 && p.endA == p.start && p.start > c.from && c.doc.textBetween(p.start - c.from - 1, p.start - c.from + 1) == "  " && (p.start--, p.endA--, p.endB--);
  let m = c.doc.resolveNoCache(p.start - c.from), g = c.doc.resolveNoCache(p.endB - c.from), v = u.resolve(p.start), k = m.sameParent(g) && m.parent.inlineContent && v.end() >= p.endA, w;
  if ((z1 && t.input.lastIOSEnter > Date.now() - 225 && (!k || i.some((j) => j.nodeName == "DIV" || j.nodeName == "P")) || !k && m.pos < c.doc.content.size && !m.sameParent(g) && (w = vt.findFrom(c.doc.resolve(m.pos + 1), 1, !0)) && w.head == g.pos) && t.someProp("handleKeyDown", (j) => j(t, mu(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (t.state.selection.anchor > p.start && Jae(u, p.start, p.endA, m, g) && t.someProp("handleKeyDown", (j) => j(t, mu(8, "Backspace")))) {
    Fs && Zr && t.domObserver.suppressSelectionUpdates();
    return;
  }
  Zr && p.endB == p.start && (t.input.lastChromeDelete = Date.now()), Fs && !k && m.start() != g.start() && g.parentOffset == 0 && m.depth == g.depth && c.sel && c.sel.anchor == c.sel.head && c.sel.head == p.endA && (p.endB -= 2, g = c.doc.resolveNoCache(p.endB - c.from), setTimeout(() => {
    t.someProp("handleKeyDown", function(j) {
      return j(t, mu(13, "Enter"));
    });
  }, 20));
  let b = p.start, x = p.endA, A, L, M;
  if (k) {
    if (m.pos == g.pos)
      Ti && uc <= 11 && m.parentOffset == 0 && (t.domObserver.suppressSelectionUpdates(), setTimeout(() => Zs(t), 20)), A = t.state.tr.delete(b, x), L = u.resolve(p.start).marksAcross(u.resolve(p.endA));
    else if (
      // Adding or removing a mark
      p.endA == p.endB && (M = $ae(m.parent.content.cut(m.parentOffset, g.parentOffset), v.parent.content.cut(v.parentOffset, p.endA - v.start())))
    )
      A = t.state.tr, M.type == "add" ? A.addMark(b, x, M.mark) : A.removeMark(b, x, M.mark);
    else if (m.parent.child(m.index()).isText && m.index() == g.index() - (g.textOffset ? 0 : 1)) {
      let j = m.parent.textBetween(m.parentOffset, g.parentOffset);
      if (t.someProp("handleTextInput", (D) => D(t, b, x, j)))
        return;
      A = t.state.tr.insertText(j, b, x);
    }
  }
  if (A || (A = t.state.tr.replace(b, x, c.doc.slice(p.start - c.from, p.endB - c.from))), c.sel) {
    let j = _T(t, A.doc, c.sel);
    j && !(Zr && t.composing && j.empty && (p.start != p.endB || t.input.lastChromeDelete < Date.now() - 100) && (j.head == b || j.head == A.mapping.map(x) - 1) || Ti && j.empty && j.head == b) && A.setSelection(j);
  }
  L && A.ensureMarks(L), a && A.setMeta("composition", a), t.dispatch(A.scrollIntoView());
}
function _T(t, e, n) {
  return Math.max(n.anchor, n.head) > e.content.size ? null : ex(t, e.resolve(n.anchor), e.resolve(n.head));
}
function $ae(t, e) {
  let n = t.firstChild.marks, r = e.firstChild.marks, i = n, a = r, o, s, l;
  for (let u = 0; u < r.length; u++)
    i = r[u].removeFromSet(i);
  for (let u = 0; u < n.length; u++)
    a = n[u].removeFromSet(a);
  if (i.length == 1 && a.length == 0)
    s = i[0], o = "add", l = (u) => u.mark(s.addToSet(u.marks));
  else if (i.length == 0 && a.length == 1)
    s = a[0], o = "remove", l = (u) => u.mark(s.removeFromSet(u.marks));
  else
    return null;
  let c = [];
  for (let u = 0; u < e.childCount; u++)
    c.push(l(e.child(u)));
  if (Ne.from(c).eq(t))
    return { mark: s, type: o };
}
function Jae(t, e, n, r, i) {
  if (
    // The content must have shrunk
    n - e <= i.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    W5(r, !0, !1) < i.pos
  )
    return !1;
  let a = t.resolve(e);
  if (!r.parent.isTextblock) {
    let s = a.nodeAfter;
    return s != null && n == e + s.nodeSize;
  }
  if (a.parentOffset < a.parent.content.size || !a.parent.isTextblock)
    return !1;
  let o = t.resolve(W5(a, !0, !0));
  return !o.parent.isTextblock || o.pos > n || W5(o, !0, !1) < n ? !1 : r.parent.content.cut(r.parentOffset).eq(o.parent.content);
}
function W5(t, e, n) {
  let r = t.depth, i = e ? t.end() : t.pos;
  for (; r > 0 && (e || t.indexAfter(r) == t.node(r).childCount); )
    r--, i++, e = !1;
  if (n) {
    let a = t.node(r).maybeChild(t.indexAfter(r));
    for (; a && !a.isLeaf; )
      a = a.firstChild, i++;
  }
  return i;
}
function Qae(t, e, n, r, i) {
  let a = t.findDiffStart(e, n);
  if (a == null)
    return null;
  let { a: o, b: s } = t.findDiffEnd(e, n + t.size, n + e.size);
  if (i == "end") {
    let l = Math.max(0, a - Math.min(o, s));
    r -= o + l - a;
  }
  if (o < a && t.size < e.size) {
    let l = r <= a && r >= o ? a - r : 0;
    a -= l, a && a < e.size && VT(e.textBetween(a - 1, a + 1)) && (a += l ? 1 : -1), s = a + (s - o), o = a;
  } else if (s < a) {
    let l = r <= a && r >= s ? a - r : 0;
    a -= l, a && a < t.size && VT(t.textBetween(a - 1, a + 1)) && (a += l ? 1 : -1), o = a + (o - s), s = a;
  }
  return { start: a, endA: o, endB: s };
}
function VT(t) {
  if (t.length != 2)
    return !1;
  let e = t.charCodeAt(0), n = t.charCodeAt(1);
  return e >= 56320 && e <= 57343 && n >= 55296 && n <= 56319;
}
class Xae {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new vae(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(GT), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = WT(this), UT(this), this.nodeViews = ZT(this), this.docView = MT(this.state.doc, qT(this), U5(this), this.dom, this), this.domObserver = new Vae(this, (r, i, a, o) => Kae(this, r, i, a, o)), this.domObserver.start(), bae(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let n in e)
        this._props[n] = e[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && y7(this);
    let n = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(GT), this.directPlugins = e.plugins), this.updateStateInner(e.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let n = {};
    for (let r in this._props)
      n[r] = this._props[r];
    n.state = this.state;
    for (let r in e)
      n[r] = e[r];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, n) {
    var r;
    let i = this.state, a = !1, o = !1;
    e.storedMarks && this.composing && (aH(this), o = !0), this.state = e;
    let s = i.plugins != e.plugins || this._props.plugins != n.plugins;
    if (s || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let h = ZT(this);
      toe(h, this.nodeViews) && (this.nodeViews = h, a = !0);
    }
    (s || n.handleDOMEvents != this._props.handleDOMEvents) && y7(this), this.editable = WT(this), UT(this);
    let l = U5(this), c = qT(this), u = i.plugins != e.plugins && !i.doc.eq(e.doc) ? "reset" : e.scrollToSelection > i.scrollToSelection ? "to selection" : "preserve", d = a || !this.docView.matchesNode(e.doc, c, l);
    (d || !e.selection.eq(i.selection)) && (o = !0);
    let f = u == "preserve" && o && this.dom.style.overflowAnchor == null && Iie(this);
    if (o) {
      this.domObserver.stop();
      let h = d && (Ti || Zr) && !this.composing && !i.selection.empty && !e.selection.empty && eoe(i.selection, e.selection);
      if (d) {
        let p = Zr ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = Dae(this)), (a || !this.docView.update(e.doc, c, l, this)) && (this.docView.updateOuterDeco(c), this.docView.destroy(), this.docView = MT(e.doc, c, l, this.dom, this)), p && !this.trackWrites && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && rae(this)) ? Zs(this, h) : (GB(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(i), !((r = this.dragging) === null || r === void 0) && r.node && !i.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, i), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : f && Pie(f);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (n) => n(this))) if (this.state.selection instanceof gt) {
        let n = this.docView.domAfterPos(this.state.selection.from);
        n.nodeType == 1 && gT(this, n.getBoundingClientRect(), e);
      } else
        gT(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let r = this.directPlugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let r = this.state.plugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let r = this.pluginViews[n];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, n) {
    let r = e.node, i = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      i = r.from;
    else {
      let a = r.from + (this.state.doc.content.size - n.doc.content.size);
      (a > 0 && this.state.doc.nodeAt(a)) == r.node && (i = a);
    }
    this.dragging = new sH(e.slice, e.move, i < 0 ? void 0 : gt.create(this.state.doc, i));
  }
  someProp(e, n) {
    let r = this._props && this._props[e], i;
    if (r != null && (i = n ? n(r) : r))
      return i;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let s = this.directPlugins[o].props[e];
      if (s != null && (i = n ? n(s) : s))
        return i;
    }
    let a = this.state.plugins;
    if (a)
      for (let o = 0; o < a.length; o++) {
        let s = a[o].props[e];
        if (s != null && (i = n ? n(s) : s))
          return i;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Ti) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && zie(this.dom), Zs(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return Fie(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, n = 1) {
    return HB(this, e, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, n = 0) {
    return this.docView.domFromPos(e, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let n = this.docView.descAt(e);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, n, r = -1) {
    let i = this.docView.posFromDOM(e, n, r);
    if (i == null)
      throw new RangeError("DOM position not inside the editor");
    return i;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, n) {
    return Wie(this, n || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, n) {
    return Eh(this, "", e, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, n) {
    return Eh(this, e, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return tx(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (wae(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], U5(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, xie());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return xae(this, e);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(e) {
    let n = this._props.dispatchTransaction;
    n ? n.call(this, e) : this.updateState(this.state.apply(e));
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? di && this.root.nodeType === 11 && Lie(this.dom.ownerDocument) == this.dom && Uae(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function qT(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(t.editable), t.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(t.state)), n)
      for (let r in n)
        r == "class" ? e.class += " " + n[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + n[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(n[r]));
  }), e.translate || (e.translate = "no"), [hr.node(0, t.state.doc.content.size, e)];
}
function UT(t) {
  if (t.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), t.cursorWrapper = { dom: e, deco: hr.widget(t.state.selection.from, e, { raw: !0, marks: t.markCursor }) };
  } else
    t.cursorWrapper = null;
}
function WT(t) {
  return !t.someProp("editable", (e) => e(t.state) === !1);
}
function eoe(t, e) {
  let n = Math.min(t.$anchor.sharedDepth(t.head), e.$anchor.sharedDepth(e.head));
  return t.$anchor.start(n) != e.$anchor.start(n);
}
function ZT(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function n(r) {
    for (let i in r)
      Object.prototype.hasOwnProperty.call(e, i) || (e[i] = r[i]);
  }
  return t.someProp("nodeViews", n), t.someProp("markViews", n), e;
}
function toe(t, e) {
  let n = 0, r = 0;
  for (let i in t) {
    if (t[i] != e[i])
      return !0;
    n++;
  }
  for (let i in e)
    r++;
  return n != r;
}
function GT(t) {
  if (t.spec.state || t.spec.filterTransaction || t.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var yc = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, ky = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, noe = typeof navigator < "u" && /Mac/.test(navigator.platform), roe = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Rr = 0; Rr < 10; Rr++) yc[48 + Rr] = yc[96 + Rr] = String(Rr);
for (var Rr = 1; Rr <= 24; Rr++) yc[Rr + 111] = "F" + Rr;
for (var Rr = 65; Rr <= 90; Rr++)
  yc[Rr] = String.fromCharCode(Rr + 32), ky[Rr] = String.fromCharCode(Rr);
for (var Z5 in yc) ky.hasOwnProperty(Z5) || (ky[Z5] = yc[Z5]);
function ioe(t) {
  var e = noe && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || roe && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", n = !e && t.key || (t.shiftKey ? ky : yc)[t.keyCode] || t.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const aoe = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function ooe(t) {
  let e = t.split(/-(?!$)/), n = e[e.length - 1];
  n == "Space" && (n = " ");
  let r, i, a, o;
  for (let s = 0; s < e.length - 1; s++) {
    let l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      a = !0;
    else if (/^mod$/i.test(l))
      aoe ? o = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return r && (n = "Alt-" + n), i && (n = "Ctrl-" + n), o && (n = "Meta-" + n), a && (n = "Shift-" + n), n;
}
function soe(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t)
    e[ooe(n)] = t[n];
  return e;
}
function G5(t, e, n = !0) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), n && e.shiftKey && (t = "Shift-" + t), t;
}
function loe(t) {
  return new Wt({ props: { handleKeyDown: sx(t) } });
}
function sx(t) {
  let e = soe(t);
  return function(n, r) {
    let i = ioe(r), a, o = e[G5(i, r)];
    if (o && o(n.state, n.dispatch, n))
      return !0;
    if (i.length == 1 && i != " ") {
      if (r.shiftKey) {
        let s = e[G5(i, r, !1)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
      if ((r.shiftKey || r.altKey || r.metaKey || i.charCodeAt(0) > 127) && (a = yc[r.keyCode]) && a != i) {
        let s = e[G5(a, r)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
const xg = (t, e) => t.selection.empty ? !1 : (e && e(t.tr.deleteSelection().scrollIntoView()), !0);
function fH(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("backward", t) : n.parentOffset > 0) ? null : n;
}
const lx = (t, e, n) => {
  let r = fH(t, n);
  if (!r)
    return !1;
  let i = ux(r);
  if (!i) {
    let o = r.blockRange(), s = o && b0(o);
    return s == null ? !1 : (e && e(t.tr.lift(o, s).scrollIntoView()), !0);
  }
  let a = i.nodeBefore;
  if (xH(t, i, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (R1(a, "end") || gt.isSelectable(a)))
    for (let o = r.depth; ; o--) {
      let s = gg(t.doc, r.before(o), r.after(o), Je.empty);
      if (s && s.slice.size < s.to - s.from) {
        if (e) {
          let l = t.tr.step(s);
          l.setSelection(R1(a, "end") ? vt.findFrom(l.doc.resolve(l.mapping.map(i.pos, -1)), -1) : gt.create(l.doc, i.pos - a.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || r.node(o - 1).childCount > 1)
        break;
    }
  return a.isAtom && i.depth == r.depth - 1 ? (e && e(t.tr.delete(i.pos - a.nodeSize, i.pos).scrollIntoView()), !0) : !1;
}, hH = (t, e, n) => {
  let r = fH(t, n);
  if (!r)
    return !1;
  let i = ux(r);
  return i ? mH(t, i, e) : !1;
}, pH = (t, e, n) => {
  let r = yH(t, n);
  if (!r)
    return !1;
  let i = hx(r);
  return i ? mH(t, i, e) : !1;
};
function mH(t, e, n) {
  let r = e.nodeBefore, i = r, a = e.pos - 1;
  for (; !i.isTextblock; a--) {
    if (i.type.spec.isolating)
      return !1;
    let u = i.lastChild;
    if (!u)
      return !1;
    i = u;
  }
  let o = e.nodeAfter, s = o, l = e.pos + 1;
  for (; !s.isTextblock; l++) {
    if (s.type.spec.isolating)
      return !1;
    let u = s.firstChild;
    if (!u)
      return !1;
    s = u;
  }
  let c = gg(t.doc, a, l, Je.empty);
  if (!c || c.from != a || c instanceof fr && c.slice.size >= l - a)
    return !1;
  if (n) {
    let u = t.tr.step(c);
    u.setSelection(ot.create(u.doc, a)), n(u.scrollIntoView());
  }
  return !0;
}
function R1(t, e, n = !1) {
  for (let r = t; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (n && r.childCount != 1)
      return !1;
  }
  return !1;
}
const cx = (t, e, n) => {
  let { $head: r, empty: i } = t.selection, a = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", t) : r.parentOffset > 0)
      return !1;
    a = ux(r);
  }
  let o = a && a.nodeBefore;
  return !o || !gt.isSelectable(o) ? !1 : (e && e(t.tr.setSelection(gt.create(t.doc, a.pos - o.nodeSize)).scrollIntoView()), !0);
};
function ux(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      if (t.index(e) > 0)
        return t.doc.resolve(t.before(e + 1));
      if (t.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function yH(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("forward", t) : n.parentOffset < n.parent.content.size) ? null : n;
}
const dx = (t, e, n) => {
  let r = yH(t, n);
  if (!r)
    return !1;
  let i = hx(r);
  if (!i)
    return !1;
  let a = i.nodeAfter;
  if (xH(t, i, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (R1(a, "start") || gt.isSelectable(a))) {
    let o = gg(t.doc, r.before(), r.after(), Je.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let s = t.tr.step(o);
        s.setSelection(R1(a, "start") ? vt.findFrom(s.doc.resolve(s.mapping.map(i.pos)), 1) : gt.create(s.doc, s.mapping.map(i.pos))), e(s.scrollIntoView());
      }
      return !0;
    }
  }
  return a.isAtom && i.depth == r.depth - 1 ? (e && e(t.tr.delete(i.pos, i.pos + a.nodeSize).scrollIntoView()), !0) : !1;
}, fx = (t, e, n) => {
  let { $head: r, empty: i } = t.selection, a = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", t) : r.parentOffset < r.parent.content.size)
      return !1;
    a = hx(r);
  }
  let o = a && a.nodeAfter;
  return !o || !gt.isSelectable(o) ? !1 : (e && e(t.tr.setSelection(gt.create(t.doc, a.pos)).scrollIntoView()), !0);
};
function hx(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      let n = t.node(e);
      if (t.index(e) + 1 < n.childCount)
        return t.doc.resolve(t.after(e + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const gH = (t, e) => {
  let n = t.selection, r = n instanceof gt, i;
  if (r) {
    if (n.node.isTextblock || !po(t.doc, n.from))
      return !1;
    i = n.from;
  } else if (i = xd(t.doc, n.from, -1), i == null)
    return !1;
  if (e) {
    let a = t.tr.join(i);
    r && a.setSelection(gt.create(a.doc, i - t.doc.resolve(i).nodeBefore.nodeSize)), e(a.scrollIntoView());
  }
  return !0;
}, vH = (t, e) => {
  let n = t.selection, r;
  if (n instanceof gt) {
    if (n.node.isTextblock || !po(t.doc, n.to))
      return !1;
    r = n.to;
  } else if (r = xd(t.doc, n.to, 1), r == null)
    return !1;
  return e && e(t.tr.join(r).scrollIntoView()), !0;
}, bH = (t, e) => {
  let { $from: n, $to: r } = t.selection, i = n.blockRange(r), a = i && b0(i);
  return a == null ? !1 : (e && e(t.tr.lift(i, a).scrollIntoView()), !0);
}, px = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (e && e(t.tr.insertText(`
`).scrollIntoView()), !0);
};
function mx(t) {
  for (let e = 0; e < t.edgeCount; e++) {
    let { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const wH = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  if (!n.parent.type.spec.code || !n.sameParent(r))
    return !1;
  let i = n.node(-1), a = n.indexAfter(-1), o = mx(i.contentMatchAt(a));
  if (!o || !i.canReplaceWith(a, a, o))
    return !1;
  if (e) {
    let s = n.after(), l = t.tr.replaceWith(s, s, o.createAndFill());
    l.setSelection(vt.near(l.doc.resolve(s), 1)), e(l.scrollIntoView());
  }
  return !0;
}, yx = (t, e) => {
  let n = t.selection, { $from: r, $to: i } = n;
  if (n instanceof Li || r.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let a = mx(i.parent.contentMatchAt(i.indexAfter()));
  if (!a || !a.isTextblock)
    return !1;
  if (e) {
    let o = (!r.parentOffset && i.index() < i.parent.childCount ? r : i).pos, s = t.tr.insert(o, a.createAndFill());
    s.setSelection(ot.create(s.doc, o + 1)), e(s.scrollIntoView());
  }
  return !0;
}, gx = (t, e) => {
  let { $cursor: n } = t.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let a = n.before();
    if (Ji(t.doc, a))
      return e && e(t.tr.split(a).scrollIntoView()), !0;
  }
  let r = n.blockRange(), i = r && b0(r);
  return i == null ? !1 : (e && e(t.tr.lift(r, i).scrollIntoView()), !0);
};
function coe(t) {
  return (e, n) => {
    let { $from: r, $to: i } = e.selection;
    if (e.selection instanceof gt && e.selection.node.isBlock)
      return !r.parentOffset || !Ji(e.doc, r.pos) ? !1 : (n && n(e.tr.split(r.pos).scrollIntoView()), !0);
    if (!r.depth)
      return !1;
    let a = [], o, s, l = !1, c = !1;
    for (let h = r.depth; ; h--)
      if (r.node(h).isBlock) {
        l = r.end(h) == r.pos + (r.depth - h), c = r.start(h) == r.pos - (r.depth - h), s = mx(r.node(h - 1).contentMatchAt(r.indexAfter(h - 1))), a.unshift(l && s ? { type: s } : null), o = h;
        break;
      } else {
        if (h == 1)
          return !1;
        a.unshift(null);
      }
    let u = e.tr;
    (e.selection instanceof ot || e.selection instanceof Li) && u.deleteSelection();
    let d = u.mapping.map(r.pos), f = Ji(u.doc, d, a.length, a);
    if (f || (a[0] = s ? { type: s } : null, f = Ji(u.doc, d, a.length, a)), u.split(d, a.length, a), !l && c && r.node(o).type != s) {
      let h = u.mapping.map(r.before(o)), p = u.doc.resolve(h);
      s && r.node(o - 1).canReplaceWith(p.index(), p.index() + 1, s) && u.setNodeMarkup(u.mapping.map(r.before(o)), s);
    }
    return n && n(u.scrollIntoView()), !0;
  };
}
const uoe = coe(), kH = (t, e) => {
  let { $from: n, to: r } = t.selection, i, a = n.sharedDepth(r);
  return a == 0 ? !1 : (i = n.before(a), e && e(t.tr.setSelection(gt.create(t.doc, i))), !0);
};
function doe(t, e, n) {
  let r = e.nodeBefore, i = e.nodeAfter, a = e.index();
  return !r || !i || !r.type.compatibleContent(i.type) ? !1 : !r.content.size && e.parent.canReplace(a - 1, a) ? (n && n(t.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(a, a + 1) || !(i.isTextblock || po(t.doc, e.pos)) ? !1 : (n && n(t.tr.join(e.pos).scrollIntoView()), !0);
}
function xH(t, e, n, r) {
  let i = e.nodeBefore, a = e.nodeAfter, o, s, l = i.type.spec.isolating || a.type.spec.isolating;
  if (!l && doe(t, e, n))
    return !0;
  let c = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (o = (s = i.contentMatchAt(i.childCount)).findWrapping(a.type)) && s.matchType(o[0] || a.type).validEnd) {
    if (n) {
      let h = e.pos + a.nodeSize, p = Ne.empty;
      for (let v = o.length - 1; v >= 0; v--)
        p = Ne.from(o[v].create(null, p));
      p = Ne.from(i.copy(p));
      let m = t.tr.step(new pr(e.pos - 1, h, e.pos, h, new Je(p, 1, 0), o.length, !0)), g = m.doc.resolve(h + 2 * o.length);
      g.nodeAfter && g.nodeAfter.type == i.type && po(m.doc, g.pos) && m.join(g.pos), n(m.scrollIntoView());
    }
    return !0;
  }
  let u = a.type.spec.isolating || r > 0 && l ? null : vt.findFrom(e, 1), d = u && u.$from.blockRange(u.$to), f = d && b0(d);
  if (f != null && f >= e.depth)
    return n && n(t.tr.lift(d, f).scrollIntoView()), !0;
  if (c && R1(a, "start", !0) && R1(i, "end")) {
    let h = i, p = [];
    for (; p.push(h), !h.isTextblock; )
      h = h.lastChild;
    let m = a, g = 1;
    for (; !m.isTextblock; m = m.firstChild)
      g++;
    if (h.canReplace(h.childCount, h.childCount, m.content)) {
      if (n) {
        let v = Ne.empty;
        for (let w = p.length - 1; w >= 0; w--)
          v = Ne.from(p[w].copy(v));
        let k = t.tr.step(new pr(e.pos - p.length, e.pos + a.nodeSize, e.pos + g, e.pos + a.nodeSize - g, new Je(v, p.length, 0), 0, !0));
        n(k.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function MH(t) {
  return function(e, n) {
    let r = e.selection, i = t < 0 ? r.$from : r.$to, a = i.depth;
    for (; i.node(a).isInline; ) {
      if (!a)
        return !1;
      a--;
    }
    return i.node(a).isTextblock ? (n && n(e.tr.setSelection(ot.create(e.doc, t < 0 ? i.start(a) : i.end(a)))), !0) : !1;
  };
}
const CH = MH(-1), AH = MH(1);
function SH(t, e = null) {
  return function(n, r) {
    let { $from: i, $to: a } = n.selection, o = i.blockRange(a), s = o && yg(o, t, e);
    return s ? (r && r(n.tr.wrap(o, s).scrollIntoView()), !0) : !1;
  };
}
function xy(t, e = null) {
  return function(n, r) {
    let i = !1;
    for (let a = 0; a < n.selection.ranges.length && !i; a++) {
      let { $from: { pos: o }, $to: { pos: s } } = n.selection.ranges[a];
      n.doc.nodesBetween(o, s, (l, c) => {
        if (i)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(t, e)))
          if (l.type == t)
            i = !0;
          else {
            let u = n.doc.resolve(c), d = u.index();
            i = u.parent.canReplaceWith(d, d + 1, t);
          }
      });
    }
    if (!i)
      return !1;
    if (r) {
      let a = n.tr;
      for (let o = 0; o < n.selection.ranges.length; o++) {
        let { $from: { pos: s }, $to: { pos: l } } = n.selection.ranges[o];
        a.setBlockType(s, l, t, e);
      }
      r(a.scrollIntoView());
    }
    return !0;
  };
}
function vx(...t) {
  return function(e, n, r) {
    for (let i = 0; i < t.length; i++)
      if (t[i](e, n, r))
        return !0;
    return !1;
  };
}
vx(xg, lx, cx);
vx(xg, dx, fx);
vx(px, yx, gx, uoe);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function LH(t, e = null) {
  return function(n, r) {
    let { $from: i, $to: a } = n.selection, o = i.blockRange(a);
    if (!o)
      return !1;
    let s = r ? n.tr : null;
    return foe(s, o, t, e) ? (r && r(s.scrollIntoView()), !0) : !1;
  };
}
function foe(t, e, n, r = null) {
  let i = !1, a = e, o = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(n) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = o.resolve(e.start - 2);
    a = new my(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new my(e.$from, o.resolve(e.$to.end(e.depth)), e.depth)), i = !0;
  }
  let s = yg(a, n, r, e);
  return s ? (t && hoe(t, e, s, i, n), !0) : !1;
}
function hoe(t, e, n, r, i) {
  let a = Ne.empty;
  for (let u = n.length - 1; u >= 0; u--)
    a = Ne.from(n[u].type.create(n[u].attrs, a));
  t.step(new pr(e.start - (r ? 2 : 0), e.end, e.start, e.end, new Je(a, 0, 0), n.length, !0));
  let o = 0;
  for (let u = 0; u < n.length; u++)
    n[u].type == i && (o = u + 1);
  let s = n.length - o, l = e.start + n.length - (r ? 2 : 0), c = e.parent;
  for (let u = e.startIndex, d = e.endIndex, f = !0; u < d; u++, f = !1)
    !f && Ji(t.doc, l, s) && (t.split(l, s), l += 2 * s), l += c.child(u).nodeSize;
  return t;
}
function TH(t) {
  return function(e, n) {
    let { $from: r, $to: i } = e.selection, a = r.blockRange(i, (o) => o.childCount > 0 && o.firstChild.type == t);
    return a ? n ? r.node(a.depth - 1).type == t ? poe(e, n, t, a) : moe(e, n, a) : !0 : !1;
  };
}
function poe(t, e, n, r) {
  let i = t.tr, a = r.end, o = r.$to.end(r.depth);
  a < o && (i.step(new pr(a - 1, o, a, o, new Je(Ne.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new my(i.doc.resolve(r.$from.pos), i.doc.resolve(o), r.depth));
  const s = b0(r);
  if (s == null)
    return !1;
  i.lift(r, s);
  let l = i.doc.resolve(i.mapping.map(a, -1) - 1);
  return po(i.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && i.join(l.pos), e(i.scrollIntoView()), !0;
}
function moe(t, e, n) {
  let r = t.tr, i = n.parent;
  for (let h = n.end, p = n.endIndex - 1, m = n.startIndex; p > m; p--)
    h -= i.child(p).nodeSize, r.delete(h - 1, h + 1);
  let a = r.doc.resolve(n.start), o = a.nodeAfter;
  if (r.mapping.map(n.end) != n.start + a.nodeAfter.nodeSize)
    return !1;
  let s = n.startIndex == 0, l = n.endIndex == i.childCount, c = a.node(-1), u = a.index(-1);
  if (!c.canReplace(u + (s ? 0 : 1), u + 1, o.content.append(l ? Ne.empty : Ne.from(i))))
    return !1;
  let d = a.pos, f = d + o.nodeSize;
  return r.step(new pr(d - (s ? 1 : 0), f + (l ? 1 : 0), d + 1, f - 1, new Je((s ? Ne.empty : Ne.from(i.copy(Ne.empty))).append(l ? Ne.empty : Ne.from(i.copy(Ne.empty))), s ? 0 : 1, l ? 0 : 1), s ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function EH(t) {
  return function(e, n) {
    let { $from: r, $to: i } = e.selection, a = r.blockRange(i, (c) => c.childCount > 0 && c.firstChild.type == t);
    if (!a)
      return !1;
    let o = a.startIndex;
    if (o == 0)
      return !1;
    let s = a.parent, l = s.child(o - 1);
    if (l.type != t)
      return !1;
    if (n) {
      let c = l.lastChild && l.lastChild.type == s.type, u = Ne.from(c ? t.create() : null), d = new Je(Ne.from(t.create(null, Ne.from(s.type.create(null, u)))), c ? 3 : 1, 0), f = a.start, h = a.end;
      n(e.tr.step(new pr(f - (c ? 3 : 1), h, f, h, d, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function Mg(t) {
  const { state: e, transaction: n } = t;
  let { selection: r } = n, { doc: i } = n, { storedMarks: a } = n;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return a;
    },
    get selection() {
      return r;
    },
    get doc() {
      return i;
    },
    get tr() {
      return r = n.selection, i = n.doc, a = n.storedMarks, n;
    }
  };
}
let Cg = class {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: n, state: r } = this, { view: i } = n, { tr: a } = r, o = this.buildProps(a);
    return Object.fromEntries(Object.entries(e).map(([s, l]) => [s, (...u) => {
      const d = l(...u)(o);
      return !a.getMeta("preventDispatch") && !this.hasCustomState && i.dispatch(a), d;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, n = !0) {
    const { rawCommands: r, editor: i, state: a } = this, { view: o } = i, s = [], l = !!e, c = e || a.tr, u = () => (!l && n && !c.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(c), s.every((f) => f === !0)), d = {
      ...Object.fromEntries(Object.entries(r).map(([f, h]) => [f, (...m) => {
        const g = this.buildProps(c, n), v = h(...m)(g);
        return s.push(v), d;
      }])),
      run: u
    };
    return d;
  }
  createCan(e) {
    const { rawCommands: n, state: r } = this, i = !1, a = e || r.tr, o = this.buildProps(a, i);
    return {
      ...Object.fromEntries(Object.entries(n).map(([l, c]) => [l, (...u) => c(...u)({ ...o, dispatch: void 0 })])),
      chain: () => this.createChain(a, i)
    };
  }
  buildProps(e, n = !0) {
    const { rawCommands: r, editor: i, state: a } = this, { view: o } = i, s = {
      tr: e,
      editor: i,
      view: o,
      state: Mg({
        state: a,
        transaction: e
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(e, n),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([l, c]) => [l, (...u) => c(...u)(s)]));
      }
    };
    return s;
  }
};
class yoe {
  constructor() {
    this.callbacks = {};
  }
  on(e, n) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(n), this;
  }
  emit(e, ...n) {
    const r = this.callbacks[e];
    return r && r.forEach((i) => i.apply(this, n)), this;
  }
  off(e, n) {
    const r = this.callbacks[e];
    return r && (n ? this.callbacks[e] = r.filter((i) => i !== n) : delete this.callbacks[e]), this;
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function ft(t, e, n) {
  return t.config[e] === void 0 && t.parent ? ft(t.parent, e, n) : typeof t.config[e] == "function" ? t.config[e].bind({
    ...n,
    parent: t.parent ? ft(t.parent, e, n) : null
  }) : t.config[e];
}
function Ag(t) {
  const e = t.filter((i) => i.type === "extension"), n = t.filter((i) => i.type === "node"), r = t.filter((i) => i.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: n,
    markExtensions: r
  };
}
function jH(t) {
  const e = [], { nodeExtensions: n, markExtensions: r } = Ag(t), i = [...n, ...r], a = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return t.forEach((o) => {
    const s = {
      name: o.name,
      options: o.options,
      storage: o.storage,
      extensions: i
    }, l = ft(o, "addGlobalAttributes", s);
    if (!l)
      return;
    l().forEach((u) => {
      u.types.forEach((d) => {
        Object.entries(u.attributes).forEach(([f, h]) => {
          e.push({
            type: d,
            name: f,
            attribute: {
              ...a,
              ...h
            }
          });
        });
      });
    });
  }), i.forEach((o) => {
    const s = {
      name: o.name,
      options: o.options,
      storage: o.storage
    }, l = ft(o, "addAttributes", s);
    if (!l)
      return;
    const c = l();
    Object.entries(c).forEach(([u, d]) => {
      const f = {
        ...a,
        ...d
      };
      typeof (f == null ? void 0 : f.default) == "function" && (f.default = f.default()), f != null && f.isRequired && (f == null ? void 0 : f.default) === void 0 && delete f.default, e.push({
        type: o.name,
        name: u,
        attribute: f
      });
    });
  }), e;
}
function Tr(t, e) {
  if (typeof t == "string") {
    if (!e.nodes[t])
      throw Error(`There is no node type named '${t}'. Maybe you forgot to add the extension?`);
    return e.nodes[t];
  }
  return t;
}
function _t(...t) {
  return t.filter((e) => !!e).reduce((e, n) => {
    const r = { ...e };
    return Object.entries(n).forEach(([i, a]) => {
      if (!r[i]) {
        r[i] = a;
        return;
      }
      if (i === "class") {
        const s = a ? a.split(" ") : [], l = r[i] ? r[i].split(" ") : [], c = s.filter((u) => !l.includes(u));
        r[i] = [...l, ...c].join(" ");
      } else if (i === "style") {
        const s = a ? a.split(";").map((u) => u.trim()).filter(Boolean) : [], l = r[i] ? r[i].split(";").map((u) => u.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [d, f] = u.split(":").map((h) => h.trim());
          c.set(d, f);
        }), s.forEach((u) => {
          const [d, f] = u.split(":").map((h) => h.trim());
          c.set(d, f);
        }), r[i] = Array.from(c.entries()).map(([u, d]) => `${u}: ${d}`).join("; ");
      } else
        r[i] = a;
    }), r;
  }, {});
}
function My(t, e) {
  return e.filter((n) => n.type === t.type.name).filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(t.attrs) || {} : {
    [n.name]: t.attrs[n.name]
  }).reduce((n, r) => _t(n, r), {});
}
function NH(t) {
  return typeof t == "function";
}
function Gt(t, e = void 0, ...n) {
  return NH(t) ? e ? t.bind(e)(...n) : t(...n) : t;
}
function goe(t = {}) {
  return Object.keys(t).length === 0 && t.constructor === Object;
}
function voe(t) {
  return typeof t != "string" ? t : t.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(t) : t === "true" ? !0 : t === "false" ? !1 : t;
}
function YT(t, e) {
  return "style" in t ? t : {
    ...t,
    getAttrs: (n) => {
      const r = t.getAttrs ? t.getAttrs(n) : t.attrs;
      if (r === !1)
        return !1;
      const i = e.reduce((a, o) => {
        const s = o.attribute.parseHTML ? o.attribute.parseHTML(n) : voe(n.getAttribute(o.name));
        return s == null ? a : {
          ...a,
          [o.name]: s
        };
      }, {});
      return { ...r, ...i };
    }
  };
}
function KT(t) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(t).filter(([e, n]) => e === "attrs" && goe(n) ? !1 : n != null)
  );
}
function boe(t, e) {
  var n;
  const r = jH(t), { nodeExtensions: i, markExtensions: a } = Ag(t), o = (n = i.find((c) => ft(c, "topNode"))) === null || n === void 0 ? void 0 : n.name, s = Object.fromEntries(i.map((c) => {
    const u = r.filter((v) => v.type === c.name), d = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, f = t.reduce((v, k) => {
      const w = ft(k, "extendNodeSchema", d);
      return {
        ...v,
        ...w ? w(c) : {}
      };
    }, {}), h = KT({
      ...f,
      content: Gt(ft(c, "content", d)),
      marks: Gt(ft(c, "marks", d)),
      group: Gt(ft(c, "group", d)),
      inline: Gt(ft(c, "inline", d)),
      atom: Gt(ft(c, "atom", d)),
      selectable: Gt(ft(c, "selectable", d)),
      draggable: Gt(ft(c, "draggable", d)),
      code: Gt(ft(c, "code", d)),
      whitespace: Gt(ft(c, "whitespace", d)),
      defining: Gt(ft(c, "defining", d)),
      isolating: Gt(ft(c, "isolating", d)),
      attrs: Object.fromEntries(u.map((v) => {
        var k;
        return [v.name, { default: (k = v == null ? void 0 : v.attribute) === null || k === void 0 ? void 0 : k.default }];
      }))
    }), p = Gt(ft(c, "parseHTML", d));
    p && (h.parseDOM = p.map((v) => YT(v, u)));
    const m = ft(c, "renderHTML", d);
    m && (h.toDOM = (v) => m({
      node: v,
      HTMLAttributes: My(v, u)
    }));
    const g = ft(c, "renderText", d);
    return g && (h.toText = g), [c.name, h];
  })), l = Object.fromEntries(a.map((c) => {
    const u = r.filter((g) => g.type === c.name), d = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, f = t.reduce((g, v) => {
      const k = ft(v, "extendMarkSchema", d);
      return {
        ...g,
        ...k ? k(c) : {}
      };
    }, {}), h = KT({
      ...f,
      inclusive: Gt(ft(c, "inclusive", d)),
      excludes: Gt(ft(c, "excludes", d)),
      group: Gt(ft(c, "group", d)),
      spanning: Gt(ft(c, "spanning", d)),
      code: Gt(ft(c, "code", d)),
      attrs: Object.fromEntries(u.map((g) => {
        var v;
        return [g.name, { default: (v = g == null ? void 0 : g.attribute) === null || v === void 0 ? void 0 : v.default }];
      }))
    }), p = Gt(ft(c, "parseHTML", d));
    p && (h.parseDOM = p.map((g) => YT(g, u)));
    const m = ft(c, "renderHTML", d);
    return m && (h.toDOM = (g) => m({
      mark: g,
      HTMLAttributes: My(g, u)
    })), [c.name, h];
  }));
  return new mg({
    topNode: o,
    nodes: s,
    marks: l
  });
}
function Y5(t, e) {
  return e.nodes[t] || e.marks[t] || null;
}
function $T(t, e) {
  return Array.isArray(e) ? e.some((n) => (typeof n == "string" ? n : n.name) === t.name) : e;
}
const woe = (t, e = 500) => {
  let n = "";
  const r = t.parentOffset;
  return t.parent.nodesBetween(Math.max(0, r - e), r, (i, a, o, s) => {
    var l, c;
    const u = ((c = (l = i.type.spec).toText) === null || c === void 0 ? void 0 : c.call(l, {
      node: i,
      pos: a,
      parent: o,
      index: s
    })) || i.textContent || "%leaf%";
    n += i.isAtom && !i.isText ? u : u.slice(0, Math.max(0, r - a));
  }), n;
};
function bx(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}
let Wi = class {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
};
const koe = (t, e) => {
  if (bx(e))
    return e.exec(t);
  const n = e(t);
  if (!n)
    return null;
  const r = [n.text];
  return r.index = n.index, r.input = t, r.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(n.replaceWith)), r;
};
function fm(t) {
  var e;
  const { editor: n, from: r, to: i, text: a, rules: o, plugin: s } = t, { view: l } = n;
  if (l.composing)
    return !1;
  const c = l.state.doc.resolve(r);
  if (
    // check for code node
    c.parent.type.spec.code || !((e = c.nodeBefore || c.nodeAfter) === null || e === void 0) && e.marks.find((f) => f.type.spec.code)
  )
    return !1;
  let u = !1;
  const d = woe(c) + a;
  return o.forEach((f) => {
    if (u)
      return;
    const h = koe(d, f.find);
    if (!h)
      return;
    const p = l.state.tr, m = Mg({
      state: l.state,
      transaction: p
    }), g = {
      from: r - (h[0].length - a.length),
      to: i
    }, { commands: v, chain: k, can: w } = new Cg({
      editor: n,
      state: m
    });
    f.handler({
      state: m,
      range: g,
      match: h,
      commands: v,
      chain: k,
      can: w
    }) === null || !p.steps.length || (p.setMeta(s, {
      transform: p,
      from: r,
      to: i,
      text: a
    }), l.dispatch(p), u = !0);
  }), u;
}
function xoe(t) {
  const { editor: e, rules: n } = t, r = new Wt({
    state: {
      init() {
        return null;
      },
      apply(i, a) {
        const o = i.getMeta(r);
        if (o)
          return o;
        const s = i.getMeta("applyInputRules");
        return !!s && setTimeout(() => {
          const { from: c, text: u } = s, d = c + u.length;
          fm({
            editor: e,
            from: c,
            to: d,
            text: u,
            rules: n,
            plugin: r
          });
        }), i.selectionSet || i.docChanged ? null : a;
      }
    },
    props: {
      handleTextInput(i, a, o, s) {
        return fm({
          editor: e,
          from: a,
          to: o,
          text: s,
          rules: n,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (i) => (setTimeout(() => {
          const { $cursor: a } = i.state.selection;
          a && fm({
            editor: e,
            from: a.pos,
            to: a.pos,
            text: "",
            rules: n,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(i, a) {
        if (a.key !== "Enter")
          return !1;
        const { $cursor: o } = i.state.selection;
        return o ? fm({
          editor: e,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: n,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function Moe(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function hm(t) {
  return Moe(t) !== "Object" ? !1 : t.constructor === Object && Object.getPrototypeOf(t) === Object.prototype;
}
function Sg(t, e) {
  const n = { ...t };
  return hm(t) && hm(e) && Object.keys(e).forEach((r) => {
    hm(e[r]) && hm(t[r]) ? n[r] = Sg(t[r], e[r]) : n[r] = e[r];
  }), n;
}
class ir {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Gt(ft(this, "addOptions", {
      name: this.name
    }))), this.storage = Gt(ft(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new ir(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Sg(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new ir(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Gt(ft(n, "addOptions", {
      name: n.name
    })), n.storage = Gt(ft(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  static handleExit({ editor: e, mark: n }) {
    const { tr: r } = e.state, i = e.state.selection.$from;
    if (i.pos === i.end()) {
      const o = i.marks();
      if (!!!o.find((c) => (c == null ? void 0 : c.type.name) === n.name))
        return !1;
      const l = o.find((c) => (c == null ? void 0 : c.type.name) === n.name);
      return l && r.removeStoredMark(l), r.insertText(" ", i.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
}
function Coe(t) {
  return typeof t == "number";
}
class g7 {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const Aoe = (t, e, n) => {
  if (bx(e))
    return [...t.matchAll(e)];
  const r = e(t, n);
  return r ? r.map((i) => {
    const a = [i.text];
    return a.index = i.index, a.input = t, a.data = i.data, i.replaceWith && (i.text.includes(i.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), a.push(i.replaceWith)), a;
  }) : [];
};
function Soe(t) {
  const { editor: e, state: n, from: r, to: i, rule: a, pasteEvent: o, dropEvent: s } = t, { commands: l, chain: c, can: u } = new Cg({
    editor: e,
    state: n
  }), d = [];
  return n.doc.nodesBetween(r, i, (h, p) => {
    if (!h.isTextblock || h.type.spec.code)
      return;
    const m = Math.max(r, p), g = Math.min(i, p + h.content.size), v = h.textBetween(m - p, g - p, void 0, "￼");
    Aoe(v, a.find, o).forEach((w) => {
      if (w.index === void 0)
        return;
      const b = m + w.index + 1, x = b + w[0].length, A = {
        from: n.tr.mapping.map(b),
        to: n.tr.mapping.map(x)
      }, L = a.handler({
        state: n,
        range: A,
        match: w,
        commands: l,
        chain: c,
        can: u,
        pasteEvent: o,
        dropEvent: s
      });
      d.push(L);
    });
  }), d.every((h) => h !== null);
}
const Loe = (t) => {
  var e;
  const n = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = n.clipboardData) === null || e === void 0 || e.setData("text/html", t), n;
};
function Toe(t) {
  const { editor: e, rules: n } = t;
  let r = null, i = !1, a = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  const l = ({ state: u, from: d, to: f, rule: h, pasteEvt: p }) => {
    const m = u.tr, g = Mg({
      state: u,
      transaction: m
    });
    if (!(!Soe({
      editor: e,
      state: g,
      from: Math.max(d - 1, 0),
      to: f.b - 1,
      rule: h,
      pasteEvent: p,
      dropEvent: s
    }) || !m.steps.length))
      return s = typeof DragEvent < "u" ? new DragEvent("drop") : null, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, m;
  };
  return n.map((u) => new Wt({
    // we register a global drag handler to track the current drag source element
    view(d) {
      const f = (h) => {
        var p;
        r = !((p = d.dom.parentElement) === null || p === void 0) && p.contains(h.target) ? d.dom.parentElement : null;
      };
      return window.addEventListener("dragstart", f), {
        destroy() {
          window.removeEventListener("dragstart", f);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (d, f) => (a = r === d.dom.parentElement, s = f, !1),
        paste: (d, f) => {
          var h;
          const p = (h = f.clipboardData) === null || h === void 0 ? void 0 : h.getData("text/html");
          return o = f, i = !!(p != null && p.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (d, f, h) => {
      const p = d[0], m = p.getMeta("uiEvent") === "paste" && !i, g = p.getMeta("uiEvent") === "drop" && !a, v = p.getMeta("applyPasteRules"), k = !!v;
      if (!m && !g && !k)
        return;
      if (k) {
        const { from: x, text: A } = v, L = x + A.length, M = Loe(A);
        return l({
          rule: u,
          state: h,
          from: x,
          to: { b: L },
          pasteEvt: M
        });
      }
      const w = f.doc.content.findDiffStart(h.doc.content), b = f.doc.content.findDiffEnd(h.doc.content);
      if (!(!Coe(w) || !b || w === b.b))
        return l({
          rule: u,
          state: h,
          from: w,
          to: b,
          pasteEvt: o
        });
    }
  }));
}
function Eoe(t) {
  const e = t.filter((n, r) => t.indexOf(n) !== r);
  return Array.from(new Set(e));
}
class e1 {
  constructor(e, n) {
    this.splittableMarks = [], this.editor = n, this.extensions = e1.resolve(e), this.schema = boe(this.extensions, n), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const n = e1.sort(e1.flatten(e)), r = Eoe(n.map((i) => i.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((i) => `'${i}'`).join(", ")}]. This can lead to issues.`), n;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage
      }, i = ft(n, "addExtensions", r);
      return i ? [n, ...this.flatten(i())] : n;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((r, i) => {
      const a = ft(r, "priority") || 100, o = ft(i, "priority") || 100;
      return a > o ? -1 : a < o ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage,
        editor: this.editor,
        type: Y5(n.name, this.schema)
      }, i = ft(n, "addCommands", r);
      return i ? {
        ...e,
        ...i()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, n = e1.sort([...this.extensions].reverse()), r = [], i = [], a = n.map((o) => {
      const s = {
        name: o.name,
        options: o.options,
        storage: o.storage,
        editor: e,
        type: Y5(o.name, this.schema)
      }, l = [], c = ft(o, "addKeyboardShortcuts", s);
      let u = {};
      if (o.type === "mark" && ft(o, "exitable", s) && (u.ArrowRight = () => ir.handleExit({ editor: e, mark: o })), c) {
        const m = Object.fromEntries(Object.entries(c()).map(([g, v]) => [g, () => v({ editor: e })]));
        u = { ...u, ...m };
      }
      const d = loe(u);
      l.push(d);
      const f = ft(o, "addInputRules", s);
      $T(o, e.options.enableInputRules) && f && r.push(...f());
      const h = ft(o, "addPasteRules", s);
      $T(o, e.options.enablePasteRules) && h && i.push(...h());
      const p = ft(o, "addProseMirrorPlugins", s);
      if (p) {
        const m = p();
        l.push(...m);
      }
      return l;
    }).flat();
    return [
      xoe({
        editor: e,
        rules: r
      }),
      ...Toe({
        editor: e,
        rules: i
      }),
      ...a
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return jH(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: n } = Ag(this.extensions);
    return Object.fromEntries(n.filter((r) => !!ft(r, "addNodeView")).map((r) => {
      const i = this.attributes.filter((l) => l.type === r.name), a = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: e,
        type: Tr(r.name, this.schema)
      }, o = ft(r, "addNodeView", a);
      if (!o)
        return [];
      const s = (l, c, u, d, f) => {
        const h = My(l, i);
        return o()({
          // pass-through
          node: l,
          view: c,
          getPos: u,
          decorations: d,
          innerDecorations: f,
          // tiptap-specific
          editor: e,
          extension: r,
          HTMLAttributes: h
        });
      };
      return [r.name, s];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var n;
      this.editor.extensionStorage[e.name] = e.storage;
      const r = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: Y5(e.name, this.schema)
      };
      e.type === "mark" && (!((n = Gt(ft(e, "keepOnSplit", r))) !== null && n !== void 0) || n) && this.splittableMarks.push(e.name);
      const i = ft(e, "onBeforeCreate", r), a = ft(e, "onCreate", r), o = ft(e, "onUpdate", r), s = ft(e, "onSelectionUpdate", r), l = ft(e, "onTransaction", r), c = ft(e, "onFocus", r), u = ft(e, "onBlur", r), d = ft(e, "onDestroy", r);
      i && this.editor.on("beforeCreate", i), a && this.editor.on("create", a), o && this.editor.on("update", o), s && this.editor.on("selectionUpdate", s), l && this.editor.on("transaction", l), c && this.editor.on("focus", c), u && this.editor.on("blur", u), d && this.editor.on("destroy", d);
    });
  }
}
let ln = class v7 {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Gt(ft(this, "addOptions", {
      name: this.name
    }))), this.storage = Gt(ft(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new v7(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Sg(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new v7({ ...this.config, ...e });
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Gt(ft(n, "addOptions", {
      name: n.name
    })), n.storage = Gt(ft(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
};
function DH(t, e, n) {
  const { from: r, to: i } = e, { blockSeparator: a = `

`, textSerializers: o = {} } = n || {};
  let s = "";
  return t.nodesBetween(r, i, (l, c, u, d) => {
    var f;
    l.isBlock && c > r && (s += a);
    const h = o == null ? void 0 : o[l.type.name];
    if (h)
      return u && (s += h({
        node: l,
        pos: c,
        parent: u,
        index: d,
        range: e
      })), !1;
    l.isText && (s += (f = l == null ? void 0 : l.text) === null || f === void 0 ? void 0 : f.slice(Math.max(r, c) - c, i - c));
  }), s;
}
function IH(t) {
  return Object.fromEntries(Object.entries(t.nodes).filter(([, e]) => e.spec.toText).map(([e, n]) => [e, n.spec.toText]));
}
const PH = ln.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Wt({
        key: new tn("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: t } = this, { state: e, schema: n } = t, { doc: r, selection: i } = e, { ranges: a } = i, o = Math.min(...a.map((u) => u.$from.pos)), s = Math.max(...a.map((u) => u.$to.pos)), l = IH(n);
            return DH(r, { from: o, to: s }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), joe = () => ({ editor: t, view: e }) => (requestAnimationFrame(() => {
  var n;
  t.isDestroyed || (e.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), Noe = (t = !1) => ({ commands: e }) => e.setContent("", t), Doe = () => ({ state: t, tr: e, dispatch: n }) => {
  const { selection: r } = e, { ranges: i } = r;
  return n && i.forEach(({ $from: a, $to: o }) => {
    t.doc.nodesBetween(a.pos, o.pos, (s, l) => {
      if (s.type.isText)
        return;
      const { doc: c, mapping: u } = e, d = c.resolve(u.map(l)), f = c.resolve(u.map(l + s.nodeSize)), h = d.blockRange(f);
      if (!h)
        return;
      const p = b0(h);
      if (s.type.isTextblock) {
        const { defaultType: m } = d.parent.contentMatchAt(d.index());
        e.setNodeMarkup(h.start, m);
      }
      (p || p === 0) && e.lift(h, p);
    });
  }), !0;
}, Ioe = (t) => (e) => t(e), Poe = () => ({ state: t, dispatch: e }) => yx(t, e), zoe = (t, e) => ({ editor: n, tr: r }) => {
  const { state: i } = n, a = i.doc.slice(t.from, t.to);
  r.deleteRange(t.from, t.to);
  const o = r.mapping.map(e);
  return r.insert(o, a.content), r.setSelection(new ot(r.doc.resolve(o - 1))), !0;
}, Roe = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const i = t.selection.$anchor;
  for (let a = i.depth; a > 0; a -= 1)
    if (i.node(a).type === r.type) {
      if (e) {
        const s = i.before(a), l = i.after(a);
        t.delete(s, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, Ooe = (t) => ({ tr: e, state: n, dispatch: r }) => {
  const i = Tr(t, n.schema), a = e.selection.$anchor;
  for (let o = a.depth; o > 0; o -= 1)
    if (a.node(o).type === i) {
      if (r) {
        const l = a.before(o), c = a.after(o);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, Boe = (t) => ({ tr: e, dispatch: n }) => {
  const { from: r, to: i } = t;
  return n && e.delete(r, i), !0;
}, Hoe = () => ({ state: t, dispatch: e }) => xg(t, e), Foe = () => ({ commands: t }) => t.keyboardShortcut("Enter"), _oe = () => ({ state: t, dispatch: e }) => wH(t, e);
function Cy(t, e, n = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((i) => n.strict ? e[i] === t[i] : bx(e[i]) ? e[i].test(t[i]) : e[i] === t[i]) : !0;
}
function b7(t, e, n = {}) {
  return t.find((r) => r.type === e && Cy(r.attrs, n));
}
function Voe(t, e, n = {}) {
  return !!b7(t, e, n);
}
function wx(t, e, n = {}) {
  if (!t || !e)
    return;
  let r = t.parent.childAfter(t.parentOffset);
  if ((!r.node || !r.node.marks.some((c) => c.type === e)) && (r = t.parent.childBefore(t.parentOffset)), !r.node || !r.node.marks.some((c) => c.type === e))
    return;
  const i = b7([...r.node.marks], e, n);
  if (!i)
    return;
  let a = r.index, o = t.start() + r.offset, s = a + 1, l = o + r.node.nodeSize;
  for (b7([...r.node.marks], e, n); a > 0 && i.isInSet(t.parent.child(a - 1).marks); )
    a -= 1, o -= t.parent.child(a).nodeSize;
  for (; s < t.parent.childCount && Voe([...t.parent.child(s).marks], e, n); )
    l += t.parent.child(s).nodeSize, s += 1;
  return {
    from: o,
    to: l
  };
}
function Oc(t, e) {
  if (typeof t == "string") {
    if (!e.marks[t])
      throw Error(`There is no mark type named '${t}'. Maybe you forgot to add the extension?`);
    return e.marks[t];
  }
  return t;
}
const qoe = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const a = Oc(t, r.schema), { doc: o, selection: s } = n, { $from: l, from: c, to: u } = s;
  if (i) {
    const d = wx(l, a, e);
    if (d && d.from <= c && d.to >= u) {
      const f = ot.create(o, d.from, d.to);
      n.setSelection(f);
    }
  }
  return !0;
}, Uoe = (t) => (e) => {
  const n = typeof t == "function" ? t(e) : t;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](e))
      return !0;
  return !1;
};
function Lg(t) {
  return t instanceof ot;
}
function _s(t = 0, e = 0, n = 0) {
  return Math.min(Math.max(t, e), n);
}
function zH(t, e = null) {
  if (!e)
    return null;
  const n = vt.atStart(t), r = vt.atEnd(t);
  if (e === "start" || e === !0)
    return n;
  if (e === "end")
    return r;
  const i = n.from, a = r.to;
  return e === "all" ? ot.create(t, _s(0, i, a), _s(t.content.size, i, a)) : ot.create(t, _s(e, i, a), _s(e, i, a));
}
function Tg() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const Woe = (t = null, e = {}) => ({ editor: n, view: r, tr: i, dispatch: a }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const o = () => {
    Tg() && r.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), e != null && e.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && t === null || t === !1)
    return !0;
  if (a && t === null && !Lg(n.state.selection))
    return o(), !0;
  const s = zH(i.doc, t) || n.state.selection, l = n.state.selection.eq(s);
  return a && (l || i.setSelection(s), l && i.storedMarks && i.setStoredMarks(i.storedMarks), o()), !0;
}, Zoe = (t, e) => (n) => t.every((r, i) => e(r, { ...n, index: i })), Goe = (t, e) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, t, e), RH = (t) => {
  const e = t.childNodes;
  for (let n = e.length - 1; n >= 0; n -= 1) {
    const r = e[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? t.removeChild(r) : r.nodeType === 1 && RH(r);
  }
  return t;
};
function pm(t) {
  const e = `<body>${t}</body>`, n = new window.DOMParser().parseFromString(e, "text/html").body;
  return RH(n);
}
function Ay(t, e, n) {
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof t == "object" && t !== null, i = typeof t == "string";
  if (r)
    try {
      if (Array.isArray(t) && t.length > 0)
        return Ne.fromArray(t.map((s) => e.nodeFromJSON(s)));
      const o = e.nodeFromJSON(t);
      return n.errorOnInvalidContent && o.check(), o;
    } catch (a) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: a });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", t, "Error:", a), Ay("", e, n);
    }
  if (i) {
    if (n.errorOnInvalidContent) {
      let o = !1, s = "";
      const l = new mg({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (o = !0, s = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? Uo.fromSchema(l).parseSlice(pm(t), n.parseOptions) : Uo.fromSchema(l).parse(pm(t), n.parseOptions), n.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${s}`) });
    }
    const a = Uo.fromSchema(e);
    return n.slice ? a.parseSlice(pm(t), n.parseOptions).content : a.parse(pm(t), n.parseOptions);
  }
  return Ay("", e, n);
}
function Yoe(t, e, n) {
  const r = t.steps.length - 1;
  if (r < e)
    return;
  const i = t.steps[r];
  if (!(i instanceof fr || i instanceof pr))
    return;
  const a = t.mapping.maps[r];
  let o = 0;
  a.forEach((s, l, c, u) => {
    o === 0 && (o = u);
  }), t.setSelection(vt.near(t.doc.resolve(o), n));
}
const Koe = (t) => !("type" in t), $oe = (t, e, n) => ({ tr: r, dispatch: i, editor: a }) => {
  var o;
  if (i) {
    n = {
      parseOptions: a.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let s;
    try {
      s = Ay(e, a.schema, {
        parseOptions: {
          preserveWhitespace: "full",
          ...n.parseOptions
        },
        errorOnInvalidContent: (o = n.errorOnInvalidContent) !== null && o !== void 0 ? o : a.options.enableContentCheck
      });
    } catch (p) {
      return a.emit("contentError", {
        editor: a,
        error: p,
        disableCollaboration: () => {
          a.storage.collaboration && (a.storage.collaboration.isDisabled = !0);
        }
      }), !1;
    }
    let { from: l, to: c } = typeof t == "number" ? { from: t, to: t } : { from: t.from, to: t.to }, u = !0, d = !0;
    if ((Koe(s) ? s : [s]).forEach((p) => {
      p.check(), u = u ? p.isText && p.marks.length === 0 : !1, d = d ? p.isBlock : !1;
    }), l === c && d) {
      const { parent: p } = r.doc.resolve(l);
      p.isTextblock && !p.type.spec.code && !p.childCount && (l -= 1, c += 1);
    }
    let h;
    u ? (Array.isArray(e) ? h = e.map((p) => p.text || "").join("") : typeof e == "object" && e && e.text ? h = e.text : h = e, r.insertText(h, l, c)) : (h = s, r.replaceWith(l, c, h)), n.updateSelection && Yoe(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: l, text: h }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: l, text: h });
  }
  return !0;
}, Joe = () => ({ state: t, dispatch: e }) => gH(t, e), Qoe = () => ({ state: t, dispatch: e }) => vH(t, e), Xoe = () => ({ state: t, dispatch: e }) => lx(t, e), ese = () => ({ state: t, dispatch: e }) => dx(t, e), tse = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = xd(t.doc, t.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, nse = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = xd(t.doc, t.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, rse = () => ({ state: t, dispatch: e }) => hH(t, e), ise = () => ({ state: t, dispatch: e }) => pH(t, e);
function OH() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function ase(t) {
  const e = t.split(/-(?!$)/);
  let n = e[e.length - 1];
  n === "Space" && (n = " ");
  let r, i, a, o;
  for (let s = 0; s < e.length - 1; s += 1) {
    const l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      a = !0;
    else if (/^mod$/i.test(l))
      Tg() || OH() ? o = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (n = `Alt-${n}`), i && (n = `Ctrl-${n}`), o && (n = `Meta-${n}`), a && (n = `Shift-${n}`), n;
}
const ose = (t) => ({ editor: e, view: n, tr: r, dispatch: i }) => {
  const a = ase(t).split(/-(?!$)/), o = a.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), s = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: a.includes("Alt"),
    ctrlKey: a.includes("Ctrl"),
    metaKey: a.includes("Meta"),
    shiftKey: a.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    n.someProp("handleKeyDown", (c) => c(n, s));
  });
  return l == null || l.steps.forEach((c) => {
    const u = c.map(r.mapping);
    u && i && r.maybeStep(u);
  }), !0;
};
function Nh(t, e, n = {}) {
  const { from: r, to: i, empty: a } = t.selection, o = e ? Tr(e, t.schema) : null, s = [];
  t.doc.nodesBetween(r, i, (d, f) => {
    if (d.isText)
      return;
    const h = Math.max(r, f), p = Math.min(i, f + d.nodeSize);
    s.push({
      node: d,
      from: h,
      to: p
    });
  });
  const l = i - r, c = s.filter((d) => o ? o.name === d.node.type.name : !0).filter((d) => Cy(d.node.attrs, n, { strict: !1 }));
  return a ? !!c.length : c.reduce((d, f) => d + f.to - f.from, 0) >= l;
}
const sse = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = Tr(t, n.schema);
  return Nh(n, i, e) ? bH(n, r) : !1;
}, lse = () => ({ state: t, dispatch: e }) => gx(t, e), cse = (t) => ({ state: e, dispatch: n }) => {
  const r = Tr(t, e.schema);
  return TH(r)(e, n);
}, use = () => ({ state: t, dispatch: e }) => px(t, e);
function Eg(t, e) {
  return e.nodes[t] ? "node" : e.marks[t] ? "mark" : null;
}
function JT(t, e) {
  const n = typeof e == "string" ? [e] : e;
  return Object.keys(t).reduce((r, i) => (n.includes(i) || (r[i] = t[i]), r), {});
}
const dse = (t, e) => ({ tr: n, state: r, dispatch: i }) => {
  let a = null, o = null;
  const s = Eg(typeof t == "string" ? t : t.name, r.schema);
  return s ? (s === "node" && (a = Tr(t, r.schema)), s === "mark" && (o = Oc(t, r.schema)), i && n.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      a && a === c.type && n.setNodeMarkup(u, void 0, JT(c.attrs, e)), o && c.marks.length && c.marks.forEach((d) => {
        o === d.type && n.addMark(u, u + c.nodeSize, o.create(JT(d.attrs, e)));
      });
    });
  }), !0) : !1;
}, fse = () => ({ tr: t, dispatch: e }) => (e && t.scrollIntoView(), !0), hse = () => ({ tr: t, commands: e }) => e.setTextSelection({
  from: 0,
  to: t.doc.content.size
}), pse = () => ({ state: t, dispatch: e }) => cx(t, e), mse = () => ({ state: t, dispatch: e }) => fx(t, e), yse = () => ({ state: t, dispatch: e }) => kH(t, e), gse = () => ({ state: t, dispatch: e }) => AH(t, e), vse = () => ({ state: t, dispatch: e }) => CH(t, e);
function w7(t, e, n = {}, r = {}) {
  return Ay(t, e, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
const bse = (t, e = !1, n = {}, r = {}) => ({ editor: i, tr: a, dispatch: o, commands: s }) => {
  var l, c;
  const { doc: u } = a;
  if (n.preserveWhitespace !== "full") {
    const d = w7(t, i.schema, n, {
      errorOnInvalidContent: (l = r.errorOnInvalidContent) !== null && l !== void 0 ? l : i.options.enableContentCheck
    });
    return o && a.replaceWith(0, u.content.size, d).setMeta("preventUpdate", !e), !0;
  }
  return o && a.setMeta("preventUpdate", !e), s.insertContentAt({ from: 0, to: u.content.size }, t, {
    parseOptions: n,
    errorOnInvalidContent: (c = r.errorOnInvalidContent) !== null && c !== void 0 ? c : i.options.enableContentCheck
  });
};
function kx(t, e) {
  const n = Oc(e, t.schema), { from: r, to: i, empty: a } = t.selection, o = [];
  a ? (t.storedMarks && o.push(...t.storedMarks), o.push(...t.selection.$head.marks())) : t.doc.nodesBetween(r, i, (l) => {
    o.push(...l.marks);
  });
  const s = o.find((l) => l.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function wse(t, e) {
  const n = new Kk(t);
  return e.forEach((r) => {
    r.steps.forEach((i) => {
      n.step(i);
    });
  }), n;
}
function kse(t) {
  for (let e = 0; e < t.edgeCount; e += 1) {
    const { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function xse(t, e, n) {
  const r = [];
  return t.nodesBetween(e.from, e.to, (i, a) => {
    n(i) && r.push({
      node: i,
      pos: a
    });
  }), r;
}
function xx(t, e) {
  for (let n = t.depth; n > 0; n -= 1) {
    const r = t.node(n);
    if (e(r))
      return {
        pos: n > 0 ? t.before(n) : 0,
        start: t.start(n),
        depth: n,
        node: r
      };
  }
}
function Mx(t) {
  return (e) => xx(e.$from, t);
}
function Cx(t, e) {
  const n = v0.fromSchema(e).serializeFragment(t), i = document.implementation.createHTMLDocument().createElement("div");
  return i.appendChild(n), i.innerHTML;
}
function Mse(t, e) {
  const n = {
    from: 0,
    to: t.content.size
  };
  return DH(t, n, e);
}
function Cse(t, e) {
  const n = Tr(e, t.schema), { from: r, to: i } = t.selection, a = [];
  t.doc.nodesBetween(r, i, (s) => {
    a.push(s);
  });
  const o = a.reverse().find((s) => s.type.name === n.name);
  return o ? { ...o.attrs } : {};
}
function BH(t, e) {
  const n = Eg(typeof e == "string" ? e : e.name, t.schema);
  return n === "node" ? Cse(t, e) : n === "mark" ? kx(t, e) : {};
}
function Ase(t, e = JSON.stringify) {
  const n = {};
  return t.filter((r) => {
    const i = e(r);
    return Object.prototype.hasOwnProperty.call(n, i) ? !1 : n[i] = !0;
  });
}
function Sse(t) {
  const e = Ase(t);
  return e.length === 1 ? e : e.filter((n, r) => !e.filter((a, o) => o !== r).some((a) => n.oldRange.from >= a.oldRange.from && n.oldRange.to <= a.oldRange.to && n.newRange.from >= a.newRange.from && n.newRange.to <= a.newRange.to));
}
function Lse(t) {
  const { mapping: e, steps: n } = t, r = [];
  return e.maps.forEach((i, a) => {
    const o = [];
    if (i.ranges.length)
      i.forEach((s, l) => {
        o.push({ from: s, to: l });
      });
    else {
      const { from: s, to: l } = n[a];
      if (s === void 0 || l === void 0)
        return;
      o.push({ from: s, to: l });
    }
    o.forEach(({ from: s, to: l }) => {
      const c = e.slice(a).map(s, -1), u = e.slice(a).map(l), d = e.invert().map(c, -1), f = e.invert().map(u);
      r.push({
        oldRange: {
          from: d,
          to: f
        },
        newRange: {
          from: c,
          to: u
        }
      });
    });
  }), Sse(r);
}
function Ax(t, e, n) {
  const r = [];
  return t === e ? n.resolve(t).marks().forEach((i) => {
    const a = n.resolve(t), o = wx(a, i.type);
    o && r.push({
      mark: i,
      ...o
    });
  }) : n.nodesBetween(t, e, (i, a) => {
    !i || (i == null ? void 0 : i.nodeSize) === void 0 || r.push(...i.marks.map((o) => ({
      from: a,
      to: a + i.nodeSize,
      mark: o
    })));
  }), r;
}
function O4(t, e, n) {
  return Object.fromEntries(Object.entries(n).filter(([r]) => {
    const i = t.find((a) => a.type === e && a.name === r);
    return i ? i.attribute.keepOnSplit : !1;
  }));
}
function k7(t, e, n = {}) {
  const { empty: r, ranges: i } = t.selection, a = e ? Oc(e, t.schema) : null;
  if (r)
    return !!(t.storedMarks || t.selection.$from.marks()).filter((d) => a ? a.name === d.type.name : !0).find((d) => Cy(d.attrs, n, { strict: !1 }));
  let o = 0;
  const s = [];
  if (i.forEach(({ $from: d, $to: f }) => {
    const h = d.pos, p = f.pos;
    t.doc.nodesBetween(h, p, (m, g) => {
      if (!m.isText && !m.marks.length)
        return;
      const v = Math.max(h, g), k = Math.min(p, g + m.nodeSize), w = k - v;
      o += w, s.push(...m.marks.map((b) => ({
        mark: b,
        from: v,
        to: k
      })));
    });
  }), o === 0)
    return !1;
  const l = s.filter((d) => a ? a.name === d.mark.type.name : !0).filter((d) => Cy(d.mark.attrs, n, { strict: !1 })).reduce((d, f) => d + f.to - f.from, 0), c = s.filter((d) => a ? d.mark.type !== a && d.mark.type.excludes(a) : !0).reduce((d, f) => d + f.to - f.from, 0);
  return (l > 0 ? l + c : l) >= o;
}
function Tse(t, e, n = {}) {
  if (!e)
    return Nh(t, null, n) || k7(t, null, n);
  const r = Eg(e, t.schema);
  return r === "node" ? Nh(t, e, n) : r === "mark" ? k7(t, e, n) : !1;
}
function QT(t, e) {
  const { nodeExtensions: n } = Ag(e), r = n.find((o) => o.name === t);
  if (!r)
    return !1;
  const i = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, a = Gt(ft(r, "group", i));
  return typeof a != "string" ? !1 : a.split(" ").includes("list");
}
function jg(t, { checkChildren: e = !0, ignoreWhitespace: n = !1 } = {}) {
  var r;
  if (n) {
    if (t.type.name === "hardBreak")
      return !0;
    if (t.isText)
      return /^\s*$/m.test((r = t.text) !== null && r !== void 0 ? r : "");
  }
  if (t.isText)
    return !t.text;
  if (t.isAtom || t.isLeaf)
    return !1;
  if (t.content.childCount === 0)
    return !0;
  if (e) {
    let i = !0;
    return t.content.forEach((a) => {
      i !== !1 && (jg(a, { ignoreWhitespace: n, checkChildren: e }) || (i = !1));
    }), i;
  }
  return !1;
}
function HH(t) {
  return t instanceof gt;
}
function Ese(t, e, n) {
  const i = t.state.doc.content.size, a = _s(e, 0, i), o = _s(n, 0, i), s = t.coordsAtPos(a), l = t.coordsAtPos(o, -1), c = Math.min(s.top, l.top), u = Math.max(s.bottom, l.bottom), d = Math.min(s.left, l.left), f = Math.max(s.right, l.right), h = f - d, p = u - c, v = {
    top: c,
    bottom: u,
    left: d,
    right: f,
    width: h,
    height: p,
    x: d,
    y: c
  };
  return {
    ...v,
    toJSON: () => v
  };
}
function jse(t, e, n) {
  var r;
  const { selection: i } = e;
  let a = null;
  if (Lg(i) && (a = i.$cursor), a) {
    const s = (r = t.storedMarks) !== null && r !== void 0 ? r : a.marks();
    return !!n.isInSet(s) || !s.some((l) => l.type.excludes(n));
  }
  const { ranges: o } = i;
  return o.some(({ $from: s, $to: l }) => {
    let c = s.depth === 0 ? t.doc.inlineContent && t.doc.type.allowsMarkType(n) : !1;
    return t.doc.nodesBetween(s.pos, l.pos, (u, d, f) => {
      if (c)
        return !1;
      if (u.isInline) {
        const h = !f || f.type.allowsMarkType(n), p = !!n.isInSet(u.marks) || !u.marks.some((m) => m.type.excludes(n));
        c = h && p;
      }
      return !c;
    }), c;
  });
}
const Nse = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const { selection: a } = n, { empty: o, ranges: s } = a, l = Oc(t, r.schema);
  if (i)
    if (o) {
      const c = kx(r, l);
      n.addStoredMark(l.create({
        ...c,
        ...e
      }));
    } else
      s.forEach((c) => {
        const u = c.$from.pos, d = c.$to.pos;
        r.doc.nodesBetween(u, d, (f, h) => {
          const p = Math.max(h, u), m = Math.min(h + f.nodeSize, d);
          f.marks.find((v) => v.type === l) ? f.marks.forEach((v) => {
            l === v.type && n.addMark(p, m, l.create({
              ...v.attrs,
              ...e
            }));
          }) : n.addMark(p, m, l.create(e));
        });
      });
  return jse(r, n, l);
}, Dse = (t, e) => ({ tr: n }) => (n.setMeta(t, e), !0), Ise = (t, e = {}) => ({ state: n, dispatch: r, chain: i }) => {
  const a = Tr(t, n.schema);
  return a.isTextblock ? i().command(({ commands: o }) => xy(a, e)(n) ? !0 : o.clearNodes()).command(({ state: o }) => xy(a, e)(o, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, Pse = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, i = _s(t, 0, r.content.size), a = gt.create(r, i);
    e.setSelection(a);
  }
  return !0;
}, zse = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, { from: i, to: a } = typeof t == "number" ? { from: t, to: t } : t, o = ot.atStart(r).from, s = ot.atEnd(r).to, l = _s(i, o, s), c = _s(a, o, s), u = ot.create(r, l, c);
    e.setSelection(u);
  }
  return !0;
}, Rse = (t) => ({ state: e, dispatch: n }) => {
  const r = Tr(t, e.schema);
  return EH(r)(e, n);
};
function XT(t, e) {
  const n = t.storedMarks || t.selection.$to.parentOffset && t.selection.$from.marks();
  if (n) {
    const r = n.filter((i) => e == null ? void 0 : e.includes(i.type.name));
    t.tr.ensureMarks(r);
  }
}
const Ose = ({ keepMarks: t = !0 } = {}) => ({ tr: e, state: n, dispatch: r, editor: i }) => {
  const { selection: a, doc: o } = e, { $from: s, $to: l } = a, c = i.extensionManager.attributes, u = O4(c, s.node().type.name, s.node().attrs);
  if (a instanceof gt && a.node.isBlock)
    return !s.parentOffset || !Ji(o, s.pos) ? !1 : (r && (t && XT(n, i.extensionManager.splittableMarks), e.split(s.pos).scrollIntoView()), !0);
  if (!s.parent.isBlock)
    return !1;
  const d = l.parentOffset === l.parent.content.size, f = s.depth === 0 ? void 0 : kse(s.node(-1).contentMatchAt(s.indexAfter(-1)));
  let h = d && f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0, p = Ji(e.doc, e.mapping.map(s.pos), 1, h);
  if (!h && !p && Ji(e.doc, e.mapping.map(s.pos), 1, f ? [{ type: f }] : void 0) && (p = !0, h = f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0), r) {
    if (p && (a instanceof ot && e.deleteSelection(), e.split(e.mapping.map(s.pos), 1, h), f && !d && !s.parentOffset && s.parent.type !== f)) {
      const m = e.mapping.map(s.before()), g = e.doc.resolve(m);
      s.node(-1).canReplaceWith(g.index(), g.index() + 1, f) && e.setNodeMarkup(e.mapping.map(s.before()), f);
    }
    t && XT(n, i.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, Bse = (t, e = {}) => ({ tr: n, state: r, dispatch: i, editor: a }) => {
  var o;
  const s = Tr(t, r.schema), { $from: l, $to: c } = r.selection, u = r.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const d = l.node(-1);
  if (d.type !== s)
    return !1;
  const f = a.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== s || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (i) {
      let v = Ne.empty;
      const k = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let M = l.depth - k; M >= l.depth - 3; M -= 1)
        v = Ne.from(l.node(M).copy(v));
      const w = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, b = {
        ...O4(f, l.node().type.name, l.node().attrs),
        ...e
      }, x = ((o = s.contentMatch.defaultType) === null || o === void 0 ? void 0 : o.createAndFill(b)) || void 0;
      v = v.append(Ne.from(s.createAndFill(null, x) || void 0));
      const A = l.before(l.depth - (k - 1));
      n.replace(A, l.after(-w), new Je(v, 4 - k, 0));
      let L = -1;
      n.doc.nodesBetween(A, n.doc.content.size, (M, j) => {
        if (L > -1)
          return !1;
        M.isTextblock && M.content.size === 0 && (L = j + 1);
      }), L > -1 && n.setSelection(ot.near(n.doc.resolve(L))), n.scrollIntoView();
    }
    return !0;
  }
  const h = c.pos === l.end() ? d.contentMatchAt(0).defaultType : null, p = {
    ...O4(f, d.type.name, d.attrs),
    ...e
  }, m = {
    ...O4(f, l.node().type.name, l.node().attrs),
    ...e
  };
  n.delete(l.pos, c.pos);
  const g = h ? [
    { type: s, attrs: p },
    { type: h, attrs: m }
  ] : [{ type: s, attrs: p }];
  if (!Ji(n.doc, l.pos, 2))
    return !1;
  if (i) {
    const { selection: v, storedMarks: k } = r, { splittableMarks: w } = a.extensionManager, b = k || v.$to.parentOffset && v.$from.marks();
    if (n.split(l.pos, 2, g).scrollIntoView(), !b || !i)
      return !0;
    const x = b.filter((A) => w.includes(A.type.name));
    n.ensureMarks(x);
  }
  return !0;
}, K5 = (t, e) => {
  const n = Mx((o) => o.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const i = t.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && po(t.doc, n.pos) && t.join(n.pos), !0;
}, $5 = (t, e) => {
  const n = Mx((o) => o.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const i = t.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && po(t.doc, r) && t.join(r), !0;
}, Hse = (t, e, n, r = {}) => ({ editor: i, tr: a, state: o, dispatch: s, chain: l, commands: c, can: u }) => {
  const { extensions: d, splittableMarks: f } = i.extensionManager, h = Tr(t, o.schema), p = Tr(e, o.schema), { selection: m, storedMarks: g } = o, { $from: v, $to: k } = m, w = v.blockRange(k), b = g || m.$to.parentOffset && m.$from.marks();
  if (!w)
    return !1;
  const x = Mx((A) => QT(A.type.name, d))(m);
  if (w.depth >= 1 && x && w.depth - x.depth <= 1) {
    if (x.node.type === h)
      return c.liftListItem(p);
    if (QT(x.node.type.name, d) && h.validContent(x.node.content) && s)
      return l().command(() => (a.setNodeMarkup(x.pos, h), !0)).command(() => K5(a, h)).command(() => $5(a, h)).run();
  }
  return !n || !b || !s ? l().command(() => u().wrapInList(h, r) ? !0 : c.clearNodes()).wrapInList(h, r).command(() => K5(a, h)).command(() => $5(a, h)).run() : l().command(() => {
    const A = u().wrapInList(h, r), L = b.filter((M) => f.includes(M.type.name));
    return a.ensureMarks(L), A ? !0 : c.clearNodes();
  }).wrapInList(h, r).command(() => K5(a, h)).command(() => $5(a, h)).run();
}, Fse = (t, e = {}, n = {}) => ({ state: r, commands: i }) => {
  const { extendEmptyMarkRange: a = !1 } = n, o = Oc(t, r.schema);
  return k7(r, o, e) ? i.unsetMark(o, { extendEmptyMarkRange: a }) : i.setMark(o, e);
}, _se = (t, e, n = {}) => ({ state: r, commands: i }) => {
  const a = Tr(t, r.schema), o = Tr(e, r.schema), s = Nh(r, a, n);
  let l;
  return r.selection.$anchor.sameParent(r.selection.$head) && (l = r.selection.$anchor.parent.attrs), s ? i.setNode(o, l) : i.setNode(a, { ...l, ...n });
}, Vse = (t, e = {}) => ({ state: n, commands: r }) => {
  const i = Tr(t, n.schema);
  return Nh(n, i, e) ? r.lift(i) : r.wrapIn(i, e);
}, qse = () => ({ state: t, dispatch: e }) => {
  const n = t.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const i = n[r];
    let a;
    if (i.spec.isInputRules && (a = i.getState(t))) {
      if (e) {
        const o = t.tr, s = a.transform;
        for (let l = s.steps.length - 1; l >= 0; l -= 1)
          o.step(s.steps[l].invert(s.docs[l]));
        if (a.text) {
          const l = o.doc.resolve(a.from).marks();
          o.replaceWith(a.from, a.to, t.schema.text(a.text, l));
        } else
          o.delete(a.from, a.to);
      }
      return !0;
    }
  }
  return !1;
}, Use = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, { empty: r, ranges: i } = n;
  return r || e && i.forEach((a) => {
    t.removeMark(a.$from.pos, a.$to.pos);
  }), !0;
}, Wse = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  var a;
  const { extendEmptyMarkRange: o = !1 } = e, { selection: s } = n, l = Oc(t, r.schema), { $from: c, empty: u, ranges: d } = s;
  if (!i)
    return !0;
  if (u && o) {
    let { from: f, to: h } = s;
    const p = (a = c.marks().find((g) => g.type === l)) === null || a === void 0 ? void 0 : a.attrs, m = wx(c, l, p);
    m && (f = m.from, h = m.to), n.removeMark(f, h, l);
  } else
    d.forEach((f) => {
      n.removeMark(f.$from.pos, f.$to.pos, l);
    });
  return n.removeStoredMark(l), !0;
}, Zse = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  let a = null, o = null;
  const s = Eg(typeof t == "string" ? t : t.name, r.schema);
  return s ? (s === "node" && (a = Tr(t, r.schema)), s === "mark" && (o = Oc(t, r.schema)), i && n.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    r.doc.nodesBetween(c, u, (d, f) => {
      a && a === d.type && n.setNodeMarkup(f, void 0, {
        ...d.attrs,
        ...e
      }), o && d.marks.length && d.marks.forEach((h) => {
        if (o === h.type) {
          const p = Math.max(f, c), m = Math.min(f + d.nodeSize, u);
          n.addMark(p, m, o.create({
            ...h.attrs,
            ...e
          }));
        }
      });
    });
  }), !0) : !1;
}, Gse = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = Tr(t, n.schema);
  return SH(i, e)(n, r);
}, Yse = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = Tr(t, n.schema);
  return LH(i, e)(n, r);
};
var Kse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: joe,
  clearContent: Noe,
  clearNodes: Doe,
  command: Ioe,
  createParagraphNear: Poe,
  cut: zoe,
  deleteCurrentNode: Roe,
  deleteNode: Ooe,
  deleteRange: Boe,
  deleteSelection: Hoe,
  enter: Foe,
  exitCode: _oe,
  extendMarkRange: qoe,
  first: Uoe,
  focus: Woe,
  forEach: Zoe,
  insertContent: Goe,
  insertContentAt: $oe,
  joinBackward: Xoe,
  joinDown: Qoe,
  joinForward: ese,
  joinItemBackward: tse,
  joinItemForward: nse,
  joinTextblockBackward: rse,
  joinTextblockForward: ise,
  joinUp: Joe,
  keyboardShortcut: ose,
  lift: sse,
  liftEmptyBlock: lse,
  liftListItem: cse,
  newlineInCode: use,
  resetAttributes: dse,
  scrollIntoView: fse,
  selectAll: hse,
  selectNodeBackward: pse,
  selectNodeForward: mse,
  selectParentNode: yse,
  selectTextblockEnd: gse,
  selectTextblockStart: vse,
  setContent: bse,
  setMark: Nse,
  setMeta: Dse,
  setNode: Ise,
  setNodeSelection: Pse,
  setTextSelection: zse,
  sinkListItem: Rse,
  splitBlock: Ose,
  splitListItem: Bse,
  toggleList: Hse,
  toggleMark: Fse,
  toggleNode: _se,
  toggleWrap: Vse,
  undoInputRule: qse,
  unsetAllMarks: Use,
  unsetMark: Wse,
  updateAttributes: Zse,
  wrapIn: Gse,
  wrapInList: Yse
});
const FH = ln.create({
  name: "commands",
  addCommands() {
    return {
      ...Kse
    };
  }
}), _H = ln.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Wt({
        key: new tn("tiptapDrop"),
        props: {
          handleDrop: (t, e, n, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: n,
              moved: r
            });
          }
        }
      })
    ];
  }
}), VH = ln.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Wt({
        key: new tn("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), qH = ln.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: t } = this;
    return [
      new Wt({
        key: new tn("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (e, n) => {
              t.isFocused = !0;
              const r = t.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, n) => {
              t.isFocused = !1;
              const r = t.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), UH = ln.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const t = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: s }) => {
        const { selection: l, doc: c } = s, { empty: u, $anchor: d } = l, { pos: f, parent: h } = d, p = d.parent.isTextblock && f > 0 ? s.doc.resolve(f - 1) : d, m = p.parent.type.spec.isolating, g = d.pos - d.parentOffset, v = m && p.parent.childCount === 1 ? g === d.pos : vt.atStart(c).from === f;
        return !u || !h.type.isTextblock || h.textContent.length || !v || v && d.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: t,
      "Mod-Backspace": t,
      "Shift-Backspace": t,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...r
    }, a = {
      ...r,
      "Ctrl-h": t,
      "Alt-Backspace": t,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return Tg() || OH() ? a : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Wt({
        key: new tn("clearDocument"),
        appendTransaction: (t, e, n) => {
          const r = t.some((m) => m.docChanged) && !e.doc.eq(n.doc), i = t.some((m) => m.getMeta("preventClearDocument"));
          if (!r || i)
            return;
          const { empty: a, from: o, to: s } = e.selection, l = vt.atStart(e.doc).from, c = vt.atEnd(e.doc).to;
          if (a || !(o === l && s === c) || !jg(n.doc))
            return;
          const f = n.tr, h = Mg({
            state: n,
            transaction: f
          }), { commands: p } = new Cg({
            editor: this.editor,
            state: h
          });
          if (p.clearNodes(), !!f.steps.length)
            return f;
        }
      })
    ];
  }
}), WH = ln.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Wt({
        key: new tn("tiptapPaste"),
        props: {
          handlePaste: (t, e, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: n
            });
          }
        }
      })
    ];
  }
}), ZH = ln.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Wt({
        key: new tn("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
var $se = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ClipboardTextSerializer: PH,
  Commands: FH,
  Drop: _H,
  Editable: VH,
  FocusEvents: qH,
  Keymap: UH,
  Paste: WH,
  Tabindex: ZH
});
class yu {
  get name() {
    return this.node.type.name;
  }
  constructor(e, n, r = !1, i = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = e, this.editor = n, this.currentNode = i;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let n = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: r }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(e);
    return new yu(n, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new yu(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new yu(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((n, r) => {
      const i = n.isBlock && !n.isTextblock, a = n.isAtom && !n.isText, o = this.pos + r + (a ? 0 : 1), s = this.resolvedPos.doc.resolve(o);
      if (!i && s.depth <= this.depth)
        return;
      const l = new yu(s, this.editor, i, i ? n : null);
      i && (l.actualDepth = this.depth + 1), e.push(new yu(s, this.editor, i, i ? n : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, n = {}) {
    let r = null, i = this.parent;
    for (; i && !r; ) {
      if (i.node.type.name === e)
        if (Object.keys(n).length > 0) {
          const a = i.node.attrs, o = Object.keys(n);
          for (let s = 0; s < o.length; s += 1) {
            const l = o[s];
            if (a[l] !== n[l])
              break;
          }
        } else
          r = i;
      i = i.parent;
    }
    return r;
  }
  querySelector(e, n = {}) {
    return this.querySelectorAll(e, n, !0)[0] || null;
  }
  querySelectorAll(e, n = {}, r = !1) {
    let i = [];
    if (!this.children || this.children.length === 0)
      return i;
    const a = Object.keys(n);
    return this.children.forEach((o) => {
      r && i.length > 0 || (o.node.type.name === e && a.every((l) => n[l] === o.node.attrs[l]) && i.push(o), !(r && i.length > 0) && (i = i.concat(o.querySelectorAll(e, n, r))));
    }), i;
  }
  setAttribute(e) {
    const { tr: n } = this.editor.state;
    n.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(n);
  }
}
const Jse = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function Qse(t, e, n) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const i = document.createElement("style");
  return e && i.setAttribute("nonce", e), i.setAttribute("data-tiptap-style", ""), i.innerHTML = t, document.getElementsByTagName("head")[0].appendChild(i), i;
}
class np extends yoe {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: n }) => {
        throw n;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: n, slice: r, moved: i }) => this.options.onDrop(n, r, i)), this.on("paste", ({ event: n, slice: r }) => this.options.onPaste(n, r)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = Qse(Jse, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, n = !0) {
    this.setOptions({ editable: e }), n && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, n) {
    const r = NH(n) ? n(e, [...this.state.plugins]) : [...this.state.plugins, e], i = this.state.reconfigure({ plugins: r });
    return this.view.updateState(i), i;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const n = this.state.plugins;
    let r = n;
    if ([].concat(e).forEach((a) => {
      const o = typeof a == "string" ? `${a}$` : a.key;
      r = n.filter((s) => !s.key.startsWith(o));
    }), n.length === r.length)
      return;
    const i = this.state.reconfigure({
      plugins: r
    });
    return this.view.updateState(i), i;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, n;
    const i = [...this.options.enableCoreExtensions ? [
      VH,
      PH.configure({
        blockSeparator: (n = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || n === void 0 ? void 0 : n.blockSeparator
      }),
      FH,
      qH,
      UH,
      ZH,
      _H,
      WH
    ].filter((a) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[a.name] !== !1 : !0) : [], ...this.options.extensions].filter((a) => ["extension", "node", "mark"].includes(a == null ? void 0 : a.type));
    this.extensionManager = new e1(i, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new Cg({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    let e;
    try {
      e = w7(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (a) {
      if (!(a instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(a.message))
        throw a;
      this.emit("contentError", {
        editor: this,
        error: a,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((o) => o.name !== "collaboration"), this.createExtensionManager();
        }
      }), e = w7(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const n = zH(e, this.options.autofocus);
    this.view = new Xae(this.options.element, {
      ...this.options.editorProps,
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: X0.create({
        doc: e,
        selection: n || void 0
      })
    }), this.view.dom.setAttribute("role", "textbox"), this.view.dom.getAttribute("aria-label") || this.view.dom.setAttribute("aria-label", "Rich-Text Editor");
    const r = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(r), this.createNodeViews(), this.prependClass();
    const i = this.view.dom;
    i.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const n = this.capturedTransaction;
    return this.capturedTransaction = null, n;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((o) => {
        var s;
        return (s = this.capturedTransaction) === null || s === void 0 ? void 0 : s.step(o);
      });
      return;
    }
    const n = this.state.apply(e), r = !this.state.selection.eq(n.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: n
    }), this.view.updateState(n), this.emit("transaction", {
      editor: this,
      transaction: e
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const i = e.getMeta("focus"), a = e.getMeta("blur");
    i && this.emit("focus", {
      editor: this,
      event: i.event,
      transaction: e
    }), a && this.emit("blur", {
      editor: this,
      event: a.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return BH(this.state, e);
  }
  isActive(e, n) {
    const r = typeof e == "string" ? e : null, i = typeof e == "string" ? n : e;
    return Tse(this.state, r, i);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return Cx(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: n = `

`, textSerializers: r = {} } = e || {};
    return Mse(this.state.doc, {
      blockSeparator: n,
      textSerializers: {
        ...IH(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return jg(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const e = this.view.dom;
      e && e.editor && delete e.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelector(e, n)) || null;
  }
  $nodes(e, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelectorAll(e, n)) || null;
  }
  $pos(e) {
    const n = this.state.doc.resolve(e);
    return new yu(n, this);
  }
  get $doc() {
    return this.$pos(0);
  }
}
function Yu(t) {
  return new Wi({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const i = Gt(t.getAttributes, void 0, r);
      if (i === !1 || i === null)
        return null;
      const { tr: a } = e, o = r[r.length - 1], s = r[0];
      if (o) {
        const l = s.search(/\S/), c = n.from + s.indexOf(o), u = c + o.length;
        if (Ax(n.from, n.to, e.doc).filter((h) => h.mark.type.excluded.find((m) => m === t.type && m !== h.mark.type)).filter((h) => h.to > c).length)
          return null;
        u < n.to && a.delete(u, n.to), c > n.from && a.delete(n.from + l, c);
        const f = n.from + l + o.length;
        a.addMark(n.from + l, f, t.type.create(i || {})), a.removeStoredMark(t.type);
      }
    }
  });
}
function x7(t) {
  return new Wi({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const i = Gt(t.getAttributes, void 0, r) || {}, { tr: a } = e, o = n.from;
      let s = n.to;
      const l = t.type.create(i);
      if (r[1]) {
        const c = r[0].lastIndexOf(r[1]);
        let u = o + c;
        u > s ? u = s : s = u + r[1].length;
        const d = r[0][r[0].length - 1];
        a.insertText(d, o + r[0].length - 1), a.replaceWith(u, s, l);
      } else if (r[0]) {
        const c = t.type.isInline ? o : o - 1;
        a.insert(c, t.type.create(i)).delete(a.mapping.map(o), a.mapping.map(s));
      }
      a.scrollIntoView();
    }
  });
}
function M7(t) {
  return new Wi({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const i = e.doc.resolve(n.from), a = Gt(t.getAttributes, void 0, r) || {};
      if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), t.type))
        return null;
      e.tr.delete(n.from, n.to).setBlockType(n.from, n.from, t.type, a);
    }
  });
}
function xt(t) {
  return new Wi({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      let i = t.replace, a = n.from;
      const o = n.to;
      if (r[1]) {
        const s = r[0].lastIndexOf(r[1]);
        i += r[0].slice(s + r[1].length), a += s;
        const l = a - o;
        l > 0 && (i = r[0].slice(s - l, s) + i, a = o);
      }
      e.tr.insertText(i, a, o);
    }
  });
}
function O1(t) {
  return new Wi({
    find: t.find,
    handler: ({ state: e, range: n, match: r, chain: i }) => {
      const a = Gt(t.getAttributes, void 0, r) || {}, o = e.tr.delete(n.from, n.to), l = o.doc.resolve(n.from).blockRange(), c = l && yg(l, t.type, a);
      if (!c)
        return null;
      if (o.wrap(l, c), t.keepMarks && t.editor) {
        const { selection: d, storedMarks: f } = e, { splittableMarks: h } = t.editor.extensionManager, p = f || d.$to.parentOffset && d.$from.marks();
        if (p) {
          const m = p.filter((g) => h.includes(g.type.name));
          o.ensureMarks(m);
        }
      }
      if (t.keepAttributes) {
        const d = t.type.name === "bulletList" || t.type.name === "orderedList" ? "listItem" : "taskList";
        i().updateAttributes(d, a).run();
      }
      const u = o.doc.resolve(n.from - 1).nodeBefore;
      u && u.type === t.type && po(o.doc, n.from - 1) && (!t.joinPredicate || t.joinPredicate(r, u)) && o.join(n.from - 1);
    }
  });
}
let Ht = class C7 {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Gt(ft(this, "addOptions", {
      name: this.name
    }))), this.storage = Gt(ft(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new C7(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Sg(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new C7(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Gt(ft(n, "addOptions", {
      name: n.name
    })), n.storage = Gt(ft(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
};
function Xse() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
class ele {
  constructor(e, n, r) {
    this.isDragging = !1, this.component = e, this.editor = n.editor, this.options = {
      stopEvent: null,
      ignoreMutation: null,
      ...r
    }, this.extension = n.extension, this.node = n.node, this.decorations = n.decorations, this.innerDecorations = n.innerDecorations, this.view = n.view, this.HTMLAttributes = n.HTMLAttributes, this.getPos = n.getPos, this.mount();
  }
  mount() {
  }
  get dom() {
    return this.editor.view.dom;
  }
  get contentDOM() {
    return null;
  }
  onDragStart(e) {
    var n, r, i, a, o, s, l;
    const { view: c } = this.editor, u = e.target, d = u.nodeType === 3 ? (n = u.parentElement) === null || n === void 0 ? void 0 : n.closest("[data-drag-handle]") : u.closest("[data-drag-handle]");
    if (!this.dom || !((r = this.contentDOM) === null || r === void 0) && r.contains(u) || !d)
      return;
    let f = 0, h = 0;
    if (this.dom !== d) {
      const v = this.dom.getBoundingClientRect(), k = d.getBoundingClientRect(), w = (i = e.offsetX) !== null && i !== void 0 ? i : (a = e.nativeEvent) === null || a === void 0 ? void 0 : a.offsetX, b = (o = e.offsetY) !== null && o !== void 0 ? o : (s = e.nativeEvent) === null || s === void 0 ? void 0 : s.offsetY;
      f = k.x - v.x + w, h = k.y - v.y + b;
    }
    (l = e.dataTransfer) === null || l === void 0 || l.setDragImage(this.dom, f, h);
    const p = this.getPos();
    if (typeof p != "number")
      return;
    const m = gt.create(c.state.doc, p), g = c.state.tr.setSelection(m);
    c.dispatch(g);
  }
  stopEvent(e) {
    var n;
    if (!this.dom)
      return !1;
    if (typeof this.options.stopEvent == "function")
      return this.options.stopEvent({ event: e });
    const r = e.target;
    if (!(this.dom.contains(r) && !(!((n = this.contentDOM) === null || n === void 0) && n.contains(r))))
      return !1;
    const a = e.type.startsWith("drag"), o = e.type === "drop";
    if ((["INPUT", "BUTTON", "SELECT", "TEXTAREA"].includes(r.tagName) || r.isContentEditable) && !o && !a)
      return !0;
    const { isEditable: l } = this.editor, { isDragging: c } = this, u = !!this.node.type.spec.draggable, d = gt.isSelectable(this.node), f = e.type === "copy", h = e.type === "paste", p = e.type === "cut", m = e.type === "mousedown";
    if (!u && d && a && e.preventDefault(), u && a && !c)
      return e.preventDefault(), !1;
    if (u && l && !c && m) {
      const g = r.closest("[data-drag-handle]");
      g && (this.dom === g || this.dom.contains(g)) && (this.isDragging = !0, document.addEventListener("dragend", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("drop", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("mouseup", () => {
        this.isDragging = !1;
      }, { once: !0 }));
    }
    return !(c || o || f || h || p || m && d);
  }
  /**
   * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
   * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
   * @return `true` if it can safely be ignored.
   */
  ignoreMutation(e) {
    return !this.dom || !this.contentDOM ? !0 : typeof this.options.ignoreMutation == "function" ? this.options.ignoreMutation({ mutation: e }) : this.node.isLeaf || this.node.isAtom ? !0 : e.type === "selection" || this.dom.contains(e.target) && e.type === "childList" && (Tg() || Xse()) && this.editor.isFocused && [
      ...Array.from(e.addedNodes),
      ...Array.from(e.removedNodes)
    ].every((r) => r.isContentEditable) ? !1 : this.contentDOM === e.target && e.type === "attributes" ? !0 : !this.contentDOM.contains(e.target);
  }
  /**
   * Update the attributes of the prosemirror node.
   */
  updateAttributes(e) {
    this.editor.commands.command(({ tr: n }) => {
      const r = this.getPos();
      return typeof r != "number" ? !1 : (n.setNodeMarkup(r, void 0, {
        ...this.node.attrs,
        ...e
      }), !0);
    });
  }
  /**
   * Delete the node.
   */
  deleteNode() {
    const e = this.getPos();
    if (typeof e != "number")
      return;
    const n = e + this.node.nodeSize;
    this.editor.commands.deleteRange({ from: e, to: n });
  }
}
function gc(t) {
  return new g7({
    find: t.find,
    handler: ({ state: e, range: n, match: r, pasteEvent: i }) => {
      const a = Gt(t.getAttributes, void 0, r, i);
      if (a === !1 || a === null)
        return null;
      const { tr: o } = e, s = r[r.length - 1], l = r[0];
      let c = n.to;
      if (s) {
        const u = l.search(/\S/), d = n.from + l.indexOf(s), f = d + s.length;
        if (Ax(n.from, n.to, e.doc).filter((p) => p.mark.type.excluded.find((g) => g === t.type && g !== p.mark.type)).filter((p) => p.to > d).length)
          return null;
        f < n.to && o.delete(f, n.to), d > n.from && o.delete(n.from + u, d), c = n.from + u + s.length, o.addMark(n.from + u, c, t.type.create(a || {})), o.removeStoredMark(t.type);
      }
    }
  });
}
function tle(t) {
  return t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var Ei = "top", Na = "bottom", Da = "right", ji = "left", Sx = "auto", rp = [Ei, Na, Da, ji], B1 = "start", Dh = "end", nle = "clippingParents", GH = "viewport", tf = "popper", rle = "reference", eE = /* @__PURE__ */ rp.reduce(function(t, e) {
  return t.concat([e + "-" + B1, e + "-" + Dh]);
}, []), YH = /* @__PURE__ */ [].concat(rp, [Sx]).reduce(function(t, e) {
  return t.concat([e, e + "-" + B1, e + "-" + Dh]);
}, []), ile = "beforeRead", ale = "read", ole = "afterRead", sle = "beforeMain", lle = "main", cle = "afterMain", ule = "beforeWrite", dle = "write", fle = "afterWrite", hle = [ile, ale, ole, sle, lle, cle, ule, dle, fle];
function ts(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function ta(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function Ku(t) {
  var e = ta(t).Element;
  return t instanceof e || t instanceof Element;
}
function Ea(t) {
  var e = ta(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function Lx(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = ta(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function ple(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, i = e.attributes[n] || {}, a = e.elements[n];
    !Ea(a) || !ts(a) || (Object.assign(a.style, r), Object.keys(i).forEach(function(o) {
      var s = i[o];
      s === !1 ? a.removeAttribute(o) : a.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function mle(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var i = e.elements[r], a = e.attributes[r] || {}, o = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), s = o.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Ea(i) || !ts(i) || (Object.assign(i.style, s), Object.keys(a).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const KH = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: ple,
  effect: mle,
  requires: ["computeStyles"]
};
function Wo(t) {
  return t.split("-")[0];
}
var Pu = Math.max, Sy = Math.min, H1 = Math.round;
function A7() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function $H() {
  return !/^((?!chrome|android).)*safari/i.test(A7());
}
function F1(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var r = t.getBoundingClientRect(), i = 1, a = 1;
  e && Ea(t) && (i = t.offsetWidth > 0 && H1(r.width) / t.offsetWidth || 1, a = t.offsetHeight > 0 && H1(r.height) / t.offsetHeight || 1);
  var o = Ku(t) ? ta(t) : window, s = o.visualViewport, l = !$H() && n, c = (r.left + (l && s ? s.offsetLeft : 0)) / i, u = (r.top + (l && s ? s.offsetTop : 0)) / a, d = r.width / i, f = r.height / a;
  return {
    width: d,
    height: f,
    top: u,
    right: c + d,
    bottom: u + f,
    left: c,
    x: c,
    y: u
  };
}
function Tx(t) {
  var e = F1(t), n = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: r
  };
}
function JH(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && Lx(n)) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function il(t) {
  return ta(t).getComputedStyle(t);
}
function yle(t) {
  return ["table", "td", "th"].indexOf(ts(t)) >= 0;
}
function Bc(t) {
  return ((Ku(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function Ng(t) {
  return ts(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (Lx(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Bc(t)
  );
}
function tE(t) {
  return !Ea(t) || // https://github.com/popperjs/popper-core/issues/837
  il(t).position === "fixed" ? null : t.offsetParent;
}
function gle(t) {
  var e = /firefox/i.test(A7()), n = /Trident/i.test(A7());
  if (n && Ea(t)) {
    var r = il(t);
    if (r.position === "fixed")
      return null;
  }
  var i = Ng(t);
  for (Lx(i) && (i = i.host); Ea(i) && ["html", "body"].indexOf(ts(i)) < 0; ) {
    var a = il(i);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || e && a.willChange === "filter" || e && a.filter && a.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function ip(t) {
  for (var e = ta(t), n = tE(t); n && yle(n) && il(n).position === "static"; )
    n = tE(n);
  return n && (ts(n) === "html" || ts(n) === "body" && il(n).position === "static") ? e : n || gle(t) || e;
}
function Ex(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function Gf(t, e, n) {
  return Pu(t, Sy(e, n));
}
function vle(t, e, n) {
  var r = Gf(t, e, n);
  return r > n ? n : r;
}
function QH() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function XH(t) {
  return Object.assign({}, QH(), t);
}
function eF(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
var ble = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, XH(typeof e != "number" ? e : eF(e, rp));
};
function wle(t) {
  var e, n = t.state, r = t.name, i = t.options, a = n.elements.arrow, o = n.modifiersData.popperOffsets, s = Wo(n.placement), l = Ex(s), c = [ji, Da].indexOf(s) >= 0, u = c ? "height" : "width";
  if (!(!a || !o)) {
    var d = ble(i.padding, n), f = Tx(a), h = l === "y" ? Ei : ji, p = l === "y" ? Na : Da, m = n.rects.reference[u] + n.rects.reference[l] - o[l] - n.rects.popper[u], g = o[l] - n.rects.reference[l], v = ip(a), k = v ? l === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, w = m / 2 - g / 2, b = d[h], x = k - f[u] - d[p], A = k / 2 - f[u] / 2 + w, L = Gf(b, A, x), M = l;
    n.modifiersData[r] = (e = {}, e[M] = L, e.centerOffset = L - A, e);
  }
}
function kle(t) {
  var e = t.state, n = t.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = e.elements.popper.querySelector(i), !i) || JH(e.elements.popper, i) && (e.elements.arrow = i));
}
const xle = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: wle,
  effect: kle,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function _1(t) {
  return t.split("-")[1];
}
var Mle = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Cle(t, e) {
  var n = t.x, r = t.y, i = e.devicePixelRatio || 1;
  return {
    x: H1(n * i) / i || 0,
    y: H1(r * i) / i || 0
  };
}
function nE(t) {
  var e, n = t.popper, r = t.popperRect, i = t.placement, a = t.variation, o = t.offsets, s = t.position, l = t.gpuAcceleration, c = t.adaptive, u = t.roundOffsets, d = t.isFixed, f = o.x, h = f === void 0 ? 0 : f, p = o.y, m = p === void 0 ? 0 : p, g = typeof u == "function" ? u({
    x: h,
    y: m
  }) : {
    x: h,
    y: m
  };
  h = g.x, m = g.y;
  var v = o.hasOwnProperty("x"), k = o.hasOwnProperty("y"), w = ji, b = Ei, x = window;
  if (c) {
    var A = ip(n), L = "clientHeight", M = "clientWidth";
    if (A === ta(n) && (A = Bc(n), il(A).position !== "static" && s === "absolute" && (L = "scrollHeight", M = "scrollWidth")), A = A, i === Ei || (i === ji || i === Da) && a === Dh) {
      b = Na;
      var j = d && A === x && x.visualViewport ? x.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        A[L]
      );
      m -= j - r.height, m *= l ? 1 : -1;
    }
    if (i === ji || (i === Ei || i === Na) && a === Dh) {
      w = Da;
      var D = d && A === x && x.visualViewport ? x.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        A[M]
      );
      h -= D - r.width, h *= l ? 1 : -1;
    }
  }
  var z = Object.assign({
    position: s
  }, c && Mle), H = u === !0 ? Cle({
    x: h,
    y: m
  }, ta(n)) : {
    x: h,
    y: m
  };
  if (h = H.x, m = H.y, l) {
    var V;
    return Object.assign({}, z, (V = {}, V[b] = k ? "0" : "", V[w] = v ? "0" : "", V.transform = (x.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + m + "px)" : "translate3d(" + h + "px, " + m + "px, 0)", V));
  }
  return Object.assign({}, z, (e = {}, e[b] = k ? m + "px" : "", e[w] = v ? h + "px" : "", e.transform = "", e));
}
function Ale(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, a = n.adaptive, o = a === void 0 ? !0 : a, s = n.roundOffsets, l = s === void 0 ? !0 : s, c = {
    placement: Wo(e.placement),
    variation: _1(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: i,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, nE(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, nE(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const Sle = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Ale,
  data: {}
};
var mm = {
  passive: !0
};
function Lle(t) {
  var e = t.state, n = t.instance, r = t.options, i = r.scroll, a = i === void 0 ? !0 : i, o = r.resize, s = o === void 0 ? !0 : o, l = ta(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return a && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, mm);
  }), s && l.addEventListener("resize", n.update, mm), function() {
    a && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, mm);
    }), s && l.removeEventListener("resize", n.update, mm);
  };
}
const Tle = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Lle,
  data: {}
};
var Ele = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function B4(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return Ele[e];
  });
}
var jle = {
  start: "end",
  end: "start"
};
function rE(t) {
  return t.replace(/start|end/g, function(e) {
    return jle[e];
  });
}
function jx(t) {
  var e = ta(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Nx(t) {
  return F1(Bc(t)).left + jx(t).scrollLeft;
}
function Nle(t, e) {
  var n = ta(t), r = Bc(t), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, o = i.height;
    var c = $H();
    (c || !c && e === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s + Nx(t),
    y: l
  };
}
function Dle(t) {
  var e, n = Bc(t), r = jx(t), i = (e = t.ownerDocument) == null ? void 0 : e.body, a = Pu(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), o = Pu(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), s = -r.scrollLeft + Nx(t), l = -r.scrollTop;
  return il(i || n).direction === "rtl" && (s += Pu(n.clientWidth, i ? i.clientWidth : 0) - a), {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function Dx(t) {
  var e = il(t), n = e.overflow, r = e.overflowX, i = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function tF(t) {
  return ["html", "body", "#document"].indexOf(ts(t)) >= 0 ? t.ownerDocument.body : Ea(t) && Dx(t) ? t : tF(Ng(t));
}
function Yf(t, e) {
  var n;
  e === void 0 && (e = []);
  var r = tF(t), i = r === ((n = t.ownerDocument) == null ? void 0 : n.body), a = ta(r), o = i ? [a].concat(a.visualViewport || [], Dx(r) ? r : []) : r, s = e.concat(o);
  return i ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Yf(Ng(o)))
  );
}
function S7(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function Ile(t, e) {
  var n = F1(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function iE(t, e, n) {
  return e === GH ? S7(Nle(t, n)) : Ku(e) ? Ile(e, n) : S7(Dle(Bc(t)));
}
function Ple(t) {
  var e = Yf(Ng(t)), n = ["absolute", "fixed"].indexOf(il(t).position) >= 0, r = n && Ea(t) ? ip(t) : t;
  return Ku(r) ? e.filter(function(i) {
    return Ku(i) && JH(i, r) && ts(i) !== "body";
  }) : [];
}
function zle(t, e, n, r) {
  var i = e === "clippingParents" ? Ple(t) : [].concat(e), a = [].concat(i, [n]), o = a[0], s = a.reduce(function(l, c) {
    var u = iE(t, c, r);
    return l.top = Pu(u.top, l.top), l.right = Sy(u.right, l.right), l.bottom = Sy(u.bottom, l.bottom), l.left = Pu(u.left, l.left), l;
  }, iE(t, o, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function nF(t) {
  var e = t.reference, n = t.element, r = t.placement, i = r ? Wo(r) : null, a = r ? _1(r) : null, o = e.x + e.width / 2 - n.width / 2, s = e.y + e.height / 2 - n.height / 2, l;
  switch (i) {
    case Ei:
      l = {
        x: o,
        y: e.y - n.height
      };
      break;
    case Na:
      l = {
        x: o,
        y: e.y + e.height
      };
      break;
    case Da:
      l = {
        x: e.x + e.width,
        y: s
      };
      break;
    case ji:
      l = {
        x: e.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = i ? Ex(i) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (a) {
      case B1:
        l[c] = l[c] - (e[u] / 2 - n[u] / 2);
        break;
      case Dh:
        l[c] = l[c] + (e[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function Ih(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, i = r === void 0 ? t.placement : r, a = n.strategy, o = a === void 0 ? t.strategy : a, s = n.boundary, l = s === void 0 ? nle : s, c = n.rootBoundary, u = c === void 0 ? GH : c, d = n.elementContext, f = d === void 0 ? tf : d, h = n.altBoundary, p = h === void 0 ? !1 : h, m = n.padding, g = m === void 0 ? 0 : m, v = XH(typeof g != "number" ? g : eF(g, rp)), k = f === tf ? rle : tf, w = t.rects.popper, b = t.elements[p ? k : f], x = zle(Ku(b) ? b : b.contextElement || Bc(t.elements.popper), l, u, o), A = F1(t.elements.reference), L = nF({
    reference: A,
    element: w,
    placement: i
  }), M = S7(Object.assign({}, w, L)), j = f === tf ? M : A, D = {
    top: x.top - j.top + v.top,
    bottom: j.bottom - x.bottom + v.bottom,
    left: x.left - j.left + v.left,
    right: j.right - x.right + v.right
  }, z = t.modifiersData.offset;
  if (f === tf && z) {
    var H = z[i];
    Object.keys(D).forEach(function(V) {
      var F = [Da, Na].indexOf(V) >= 0 ? 1 : -1, _ = [Ei, Na].indexOf(V) >= 0 ? "y" : "x";
      D[V] += H[_] * F;
    });
  }
  return D;
}
function Rle(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, i = n.boundary, a = n.rootBoundary, o = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? YH : l, u = _1(r), d = u ? s ? eE : eE.filter(function(p) {
    return _1(p) === u;
  }) : rp, f = d.filter(function(p) {
    return c.indexOf(p) >= 0;
  });
  f.length === 0 && (f = d);
  var h = f.reduce(function(p, m) {
    return p[m] = Ih(t, {
      placement: m,
      boundary: i,
      rootBoundary: a,
      padding: o
    })[Wo(m)], p;
  }, {});
  return Object.keys(h).sort(function(p, m) {
    return h[p] - h[m];
  });
}
function Ole(t) {
  if (Wo(t) === Sx)
    return [];
  var e = B4(t);
  return [rE(t), e, rE(e)];
}
function Ble(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var i = n.mainAxis, a = i === void 0 ? !0 : i, o = n.altAxis, s = o === void 0 ? !0 : o, l = n.fallbackPlacements, c = n.padding, u = n.boundary, d = n.rootBoundary, f = n.altBoundary, h = n.flipVariations, p = h === void 0 ? !0 : h, m = n.allowedAutoPlacements, g = e.options.placement, v = Wo(g), k = v === g, w = l || (k || !p ? [B4(g)] : Ole(g)), b = [g].concat(w).reduce(function(me, ge) {
      return me.concat(Wo(ge) === Sx ? Rle(e, {
        placement: ge,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: p,
        allowedAutoPlacements: m
      }) : ge);
    }, []), x = e.rects.reference, A = e.rects.popper, L = /* @__PURE__ */ new Map(), M = !0, j = b[0], D = 0; D < b.length; D++) {
      var z = b[D], H = Wo(z), V = _1(z) === B1, F = [Ei, Na].indexOf(H) >= 0, _ = F ? "width" : "height", W = Ih(e, {
        placement: z,
        boundary: u,
        rootBoundary: d,
        altBoundary: f,
        padding: c
      }), G = F ? V ? Da : ji : V ? Na : Ei;
      x[_] > A[_] && (G = B4(G));
      var Y = B4(G), Z = [];
      if (a && Z.push(W[H] <= 0), s && Z.push(W[G] <= 0, W[Y] <= 0), Z.every(function(me) {
        return me;
      })) {
        j = z, M = !1;
        break;
      }
      L.set(z, Z);
    }
    if (M)
      for (var oe = p ? 3 : 1, ee = function(ge) {
        var $ = b.find(function(se) {
          var xe = L.get(se);
          if (xe)
            return xe.slice(0, ge).every(function(Oe) {
              return Oe;
            });
        });
        if ($)
          return j = $, "break";
      }, ae = oe; ae > 0; ae--) {
        var fe = ee(ae);
        if (fe === "break") break;
      }
    e.placement !== j && (e.modifiersData[r]._skip = !0, e.placement = j, e.reset = !0);
  }
}
const Hle = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Ble,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function aE(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function oE(t) {
  return [Ei, Da, Na, ji].some(function(e) {
    return t[e] >= 0;
  });
}
function Fle(t) {
  var e = t.state, n = t.name, r = e.rects.reference, i = e.rects.popper, a = e.modifiersData.preventOverflow, o = Ih(e, {
    elementContext: "reference"
  }), s = Ih(e, {
    altBoundary: !0
  }), l = aE(o, r), c = aE(s, i, a), u = oE(l), d = oE(c);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const _le = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Fle
};
function Vle(t, e, n) {
  var r = Wo(t), i = [ji, Ei].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, o = a[0], s = a[1];
  return o = o || 0, s = (s || 0) * i, [ji, Da].indexOf(r) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function qle(t) {
  var e = t.state, n = t.options, r = t.name, i = n.offset, a = i === void 0 ? [0, 0] : i, o = YH.reduce(function(u, d) {
    return u[d] = Vle(d, e.rects, a), u;
  }, {}), s = o[e.placement], l = s.x, c = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[r] = o;
}
const Ule = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: qle
};
function Wle(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = nF({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
const Zle = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Wle,
  data: {}
};
function Gle(t) {
  return t === "x" ? "y" : "x";
}
function Yle(t) {
  var e = t.state, n = t.options, r = t.name, i = n.mainAxis, a = i === void 0 ? !0 : i, o = n.altAxis, s = o === void 0 ? !1 : o, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, d = n.padding, f = n.tether, h = f === void 0 ? !0 : f, p = n.tetherOffset, m = p === void 0 ? 0 : p, g = Ih(e, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), v = Wo(e.placement), k = _1(e.placement), w = !k, b = Ex(v), x = Gle(b), A = e.modifiersData.popperOffsets, L = e.rects.reference, M = e.rects.popper, j = typeof m == "function" ? m(Object.assign({}, e.rects, {
    placement: e.placement
  })) : m, D = typeof j == "number" ? {
    mainAxis: j,
    altAxis: j
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, j), z = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, H = {
    x: 0,
    y: 0
  };
  if (A) {
    if (a) {
      var V, F = b === "y" ? Ei : ji, _ = b === "y" ? Na : Da, W = b === "y" ? "height" : "width", G = A[b], Y = G + g[F], Z = G - g[_], oe = h ? -M[W] / 2 : 0, ee = k === B1 ? L[W] : M[W], ae = k === B1 ? -M[W] : -L[W], fe = e.elements.arrow, me = h && fe ? Tx(fe) : {
        width: 0,
        height: 0
      }, ge = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : QH(), $ = ge[F], se = ge[_], xe = Gf(0, L[W], me[W]), Oe = w ? L[W] / 2 - oe - xe - $ - D.mainAxis : ee - xe - $ - D.mainAxis, je = w ? -L[W] / 2 + oe + xe + se + D.mainAxis : ae + xe + se + D.mainAxis, Me = e.elements.arrow && ip(e.elements.arrow), he = Me ? b === "y" ? Me.clientTop || 0 : Me.clientLeft || 0 : 0, pe = (V = z == null ? void 0 : z[b]) != null ? V : 0, J = G + Oe - pe - he, K = G + je - pe, X = Gf(h ? Sy(Y, J) : Y, G, h ? Pu(Z, K) : Z);
      A[b] = X, H[b] = X - G;
    }
    if (s) {
      var re, Ie = b === "x" ? Ei : ji, q = b === "x" ? Na : Da, S = A[x], P = x === "y" ? "height" : "width", O = S + g[Ie], ne = S - g[q], le = [Ei, ji].indexOf(v) !== -1, de = (re = z == null ? void 0 : z[x]) != null ? re : 0, Pe = le ? O : S - L[P] - M[P] - de + D.altAxis, ve = le ? S + L[P] + M[P] - de - D.altAxis : ne, Le = h && le ? vle(Pe, S, ve) : Gf(h ? Pe : O, S, h ? ve : ne);
      A[x] = Le, H[x] = Le - S;
    }
    e.modifiersData[r] = H;
  }
}
const Kle = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Yle,
  requiresIfExists: ["offset"]
};
function $le(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function Jle(t) {
  return t === ta(t) || !Ea(t) ? jx(t) : $le(t);
}
function Qle(t) {
  var e = t.getBoundingClientRect(), n = H1(e.width) / t.offsetWidth || 1, r = H1(e.height) / t.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function Xle(t, e, n) {
  n === void 0 && (n = !1);
  var r = Ea(e), i = Ea(e) && Qle(e), a = Bc(e), o = F1(t, i, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((ts(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Dx(a)) && (s = Jle(e)), Ea(e) ? (l = F1(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : a && (l.x = Nx(a))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function ece(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(a) {
    e.set(a.name, a);
  });
  function i(a) {
    n.add(a.name);
    var o = [].concat(a.requires || [], a.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var l = e.get(s);
        l && i(l);
      }
    }), r.push(a);
  }
  return t.forEach(function(a) {
    n.has(a.name) || i(a);
  }), r;
}
function tce(t) {
  var e = ece(t);
  return hle.reduce(function(n, r) {
    return n.concat(e.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function nce(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function rce(t) {
  var e = t.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var sE = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function lE() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function ice(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, i = e.defaultOptions, a = i === void 0 ? sE : i;
  return function(s, l, c) {
    c === void 0 && (c = a);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, sE, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, h = {
      state: u,
      setOptions: function(v) {
        var k = typeof v == "function" ? v(u.options) : v;
        m(), u.options = Object.assign({}, a, u.options, k), u.scrollParents = {
          reference: Ku(s) ? Yf(s) : s.contextElement ? Yf(s.contextElement) : [],
          popper: Yf(l)
        };
        var w = tce(rce([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = w.filter(function(b) {
          return b.enabled;
        }), p(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var v = u.elements, k = v.reference, w = v.popper;
          if (lE(k, w)) {
            u.rects = {
              reference: Xle(k, ip(w), u.options.strategy === "fixed"),
              popper: Tx(w)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(D) {
              return u.modifiersData[D.name] = Object.assign({}, D.data);
            });
            for (var b = 0; b < u.orderedModifiers.length; b++) {
              if (u.reset === !0) {
                u.reset = !1, b = -1;
                continue;
              }
              var x = u.orderedModifiers[b], A = x.fn, L = x.options, M = L === void 0 ? {} : L, j = x.name;
              typeof A == "function" && (u = A({
                state: u,
                options: M,
                name: j,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: nce(function() {
        return new Promise(function(g) {
          h.forceUpdate(), g(u);
        });
      }),
      destroy: function() {
        m(), f = !0;
      }
    };
    if (!lE(s, l))
      return h;
    h.setOptions(c).then(function(g) {
      !f && c.onFirstUpdate && c.onFirstUpdate(g);
    });
    function p() {
      u.orderedModifiers.forEach(function(g) {
        var v = g.name, k = g.options, w = k === void 0 ? {} : k, b = g.effect;
        if (typeof b == "function") {
          var x = b({
            state: u,
            name: v,
            instance: h,
            options: w
          }), A = function() {
          };
          d.push(x || A);
        }
      });
    }
    function m() {
      d.forEach(function(g) {
        return g();
      }), d = [];
    }
    return h;
  };
}
var ace = [Tle, Zle, Sle, KH, Ule, Hle, Kle, xle, _le], oce = /* @__PURE__ */ ice({
  defaultModifiers: ace
}), sce = "tippy-box", rF = "tippy-content", lce = "tippy-backdrop", iF = "tippy-arrow", aF = "tippy-svg-arrow", ou = {
  passive: !0,
  capture: !0
}, oF = function() {
  return document.body;
};
function cce(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function J5(t, e, n) {
  if (Array.isArray(t)) {
    var r = t[e];
    return r ?? (Array.isArray(n) ? n[e] : n);
  }
  return t;
}
function Ix(t, e) {
  var n = {}.toString.call(t);
  return n.indexOf("[object") === 0 && n.indexOf(e + "]") > -1;
}
function sF(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function cE(t, e) {
  if (e === 0)
    return t;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      t(r);
    }, e);
  };
}
function uce(t, e) {
  var n = Object.assign({}, t);
  return e.forEach(function(r) {
    delete n[r];
  }), n;
}
function dce(t) {
  return t.split(/\s+/).filter(Boolean);
}
function $0(t) {
  return [].concat(t);
}
function uE(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function fce(t) {
  return t.filter(function(e, n) {
    return t.indexOf(e) === n;
  });
}
function hce(t) {
  return t.split("-")[0];
}
function Ly(t) {
  return [].slice.call(t);
}
function dE(t) {
  return Object.keys(t).reduce(function(e, n) {
    return t[n] !== void 0 && (e[n] = t[n]), e;
  }, {});
}
function Kf() {
  return document.createElement("div");
}
function Ph(t) {
  return ["Element", "Fragment"].some(function(e) {
    return Ix(t, e);
  });
}
function pce(t) {
  return Ix(t, "NodeList");
}
function mce(t) {
  return Ix(t, "MouseEvent");
}
function yce(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function gce(t) {
  return Ph(t) ? [t] : pce(t) ? Ly(t) : Array.isArray(t) ? t : Ly(document.querySelectorAll(t));
}
function Q5(t, e) {
  t.forEach(function(n) {
    n && (n.style.transitionDuration = e + "ms");
  });
}
function fE(t, e) {
  t.forEach(function(n) {
    n && n.setAttribute("data-state", e);
  });
}
function vce(t) {
  var e, n = $0(t), r = n[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function bce(t, e) {
  var n = e.clientX, r = e.clientY;
  return t.every(function(i) {
    var a = i.popperRect, o = i.popperState, s = i.props, l = s.interactiveBorder, c = hce(o.placement), u = o.modifiersData.offset;
    if (!u)
      return !0;
    var d = c === "bottom" ? u.top.y : 0, f = c === "top" ? u.bottom.y : 0, h = c === "right" ? u.left.x : 0, p = c === "left" ? u.right.x : 0, m = a.top - r + d > l, g = r - a.bottom - f > l, v = a.left - n + h > l, k = n - a.right - p > l;
    return m || g || v || k;
  });
}
function X5(t, e, n) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(i) {
    t[r](i, n);
  });
}
function hE(t, e) {
  for (var n = e; n; ) {
    var r;
    if (t.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var No = {
  isTouch: !1
}, pE = 0;
function wce() {
  No.isTouch || (No.isTouch = !0, window.performance && document.addEventListener("mousemove", lF));
}
function lF() {
  var t = performance.now();
  t - pE < 20 && (No.isTouch = !1, document.removeEventListener("mousemove", lF)), pE = t;
}
function kce() {
  var t = document.activeElement;
  if (yce(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function xce() {
  document.addEventListener("touchstart", wce, ou), window.addEventListener("blur", kce);
}
var Mce = typeof window < "u" && typeof document < "u", Cce = Mce ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function P0(t) {
  var e = t === "destroy" ? "n already-" : " ";
  return [t + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function mE(t) {
  var e = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return t.replace(e, " ").replace(n, "").trim();
}
function Ace(t) {
  return mE(`
  %ctippy.js

  %c` + mE(t) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function cF(t) {
  return [
    Ace(t),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var zh;
process.env.NODE_ENV !== "production" && Sce();
function Sce() {
  zh = /* @__PURE__ */ new Set();
}
function Ps(t, e) {
  if (t && !zh.has(e)) {
    var n;
    zh.add(e), (n = console).warn.apply(n, cF(e));
  }
}
function L7(t, e) {
  if (t && !zh.has(e)) {
    var n;
    zh.add(e), (n = console).error.apply(n, cF(e));
  }
}
function Lce(t) {
  var e = !t, n = Object.prototype.toString.call(t) === "[object Object]" && !t.addEventListener;
  L7(e, ["tippy() was passed", "`" + String(t) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), L7(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var uF = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, Tce = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Yi = Object.assign({
  appendTo: oF,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, uF, Tce), Ece = Object.keys(Yi), jce = function(e) {
  process.env.NODE_ENV !== "production" && fF(e, []);
  var n = Object.keys(e);
  n.forEach(function(r) {
    Yi[r] = e[r];
  });
};
function dF(t) {
  var e = t.plugins || [], n = e.reduce(function(r, i) {
    var a = i.name, o = i.defaultValue;
    if (a) {
      var s;
      r[a] = t[a] !== void 0 ? t[a] : (s = Yi[a]) != null ? s : o;
    }
    return r;
  }, {});
  return Object.assign({}, t, n);
}
function Nce(t, e) {
  var n = e ? Object.keys(dF(Object.assign({}, Yi, {
    plugins: e
  }))) : Ece, r = n.reduce(function(i, a) {
    var o = (t.getAttribute("data-tippy-" + a) || "").trim();
    if (!o)
      return i;
    if (a === "content")
      i[a] = o;
    else
      try {
        i[a] = JSON.parse(o);
      } catch {
        i[a] = o;
      }
    return i;
  }, {});
  return r;
}
function yE(t, e) {
  var n = Object.assign({}, e, {
    content: sF(e.content, [t])
  }, e.ignoreAttributes ? {} : Nce(t, e.plugins));
  return n.aria = Object.assign({}, Yi.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? e.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? e.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function fF(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = []);
  var n = Object.keys(t);
  n.forEach(function(r) {
    var i = uce(Yi, Object.keys(uF)), a = !cce(i, r);
    a && (a = e.filter(function(o) {
      return o.name === r;
    }).length === 0), Ps(a, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var Dce = function() {
  return "innerHTML";
};
function T7(t, e) {
  t[Dce()] = e;
}
function gE(t) {
  var e = Kf();
  return t === !0 ? e.className = iF : (e.className = aF, Ph(t) ? e.appendChild(t) : T7(e, t)), e;
}
function vE(t, e) {
  Ph(e.content) ? (T7(t, ""), t.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? T7(t, e.content) : t.textContent = e.content);
}
function E7(t) {
  var e = t.firstElementChild, n = Ly(e.children);
  return {
    box: e,
    content: n.find(function(r) {
      return r.classList.contains(rF);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(iF) || r.classList.contains(aF);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(lce);
    })
  };
}
function hF(t) {
  var e = Kf(), n = Kf();
  n.className = sce, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = Kf();
  r.className = rF, r.setAttribute("data-state", "hidden"), vE(r, t.props), e.appendChild(n), n.appendChild(r), i(t.props, t.props);
  function i(a, o) {
    var s = E7(e), l = s.box, c = s.content, u = s.arrow;
    o.theme ? l.setAttribute("data-theme", o.theme) : l.removeAttribute("data-theme"), typeof o.animation == "string" ? l.setAttribute("data-animation", o.animation) : l.removeAttribute("data-animation"), o.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof o.maxWidth == "number" ? o.maxWidth + "px" : o.maxWidth, o.role ? l.setAttribute("role", o.role) : l.removeAttribute("role"), (a.content !== o.content || a.allowHTML !== o.allowHTML) && vE(c, t.props), o.arrow ? u ? a.arrow !== o.arrow && (l.removeChild(u), l.appendChild(gE(o.arrow))) : l.appendChild(gE(o.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: e,
    onUpdate: i
  };
}
hF.$$tippy = !0;
var Ice = 1, ym = [], e8 = [];
function Pce(t, e) {
  var n = yE(t, Object.assign({}, Yi, dF(dE(e)))), r, i, a, o = !1, s = !1, l = !1, c = !1, u, d, f, h = [], p = cE(J, n.interactiveDebounce), m, g = Ice++, v = null, k = fce(n.plugins), w = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, b = {
    // properties
    id: g,
    reference: t,
    popper: Kf(),
    popperInstance: v,
    props: n,
    state: w,
    plugins: k,
    // methods
    clearDelayTimeouts: Pe,
    setProps: ve,
    setContent: Le,
    show: Re,
    hide: Ke,
    hideWithInteractivity: mt,
    enable: le,
    disable: de,
    unmount: pt,
    destroy: Nt
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && L7(!0, "render() function has not been supplied."), b;
  var x = n.render(b), A = x.popper, L = x.onUpdate;
  A.setAttribute("data-tippy-root", ""), A.id = "tippy-" + b.id, b.popper = A, t._tippy = b, A._tippy = b;
  var M = k.map(function(ye) {
    return ye.fn(b);
  }), j = t.hasAttribute("aria-expanded");
  return Me(), oe(), G(), Y("onCreate", [b]), n.showOnCreate && O(), A.addEventListener("mouseenter", function() {
    b.props.interactive && b.state.isVisible && b.clearDelayTimeouts();
  }), A.addEventListener("mouseleave", function() {
    b.props.interactive && b.props.trigger.indexOf("mouseenter") >= 0 && F().addEventListener("mousemove", p);
  }), b;
  function D() {
    var ye = b.props.touch;
    return Array.isArray(ye) ? ye : [ye, 0];
  }
  function z() {
    return D()[0] === "hold";
  }
  function H() {
    var ye;
    return !!((ye = b.props.render) != null && ye.$$tippy);
  }
  function V() {
    return m || t;
  }
  function F() {
    var ye = V().parentNode;
    return ye ? vce(ye) : document;
  }
  function _() {
    return E7(A);
  }
  function W(ye) {
    return b.state.isMounted && !b.state.isVisible || No.isTouch || u && u.type === "focus" ? 0 : J5(b.props.delay, ye ? 0 : 1, Yi.delay);
  }
  function G(ye) {
    ye === void 0 && (ye = !1), A.style.pointerEvents = b.props.interactive && !ye ? "" : "none", A.style.zIndex = "" + b.props.zIndex;
  }
  function Y(ye, _e, we) {
    if (we === void 0 && (we = !0), M.forEach(function(Xe) {
      Xe[ye] && Xe[ye].apply(Xe, _e);
    }), we) {
      var $e;
      ($e = b.props)[ye].apply($e, _e);
    }
  }
  function Z() {
    var ye = b.props.aria;
    if (ye.content) {
      var _e = "aria-" + ye.content, we = A.id, $e = $0(b.props.triggerTarget || t);
      $e.forEach(function(Xe) {
        var Be = Xe.getAttribute(_e);
        if (b.state.isVisible)
          Xe.setAttribute(_e, Be ? Be + " " + we : we);
        else {
          var et = Be && Be.replace(we, "").trim();
          et ? Xe.setAttribute(_e, et) : Xe.removeAttribute(_e);
        }
      });
    }
  }
  function oe() {
    if (!(j || !b.props.aria.expanded)) {
      var ye = $0(b.props.triggerTarget || t);
      ye.forEach(function(_e) {
        b.props.interactive ? _e.setAttribute("aria-expanded", b.state.isVisible && _e === V() ? "true" : "false") : _e.removeAttribute("aria-expanded");
      });
    }
  }
  function ee() {
    F().removeEventListener("mousemove", p), ym = ym.filter(function(ye) {
      return ye !== p;
    });
  }
  function ae(ye) {
    if (!(No.isTouch && (l || ye.type === "mousedown"))) {
      var _e = ye.composedPath && ye.composedPath()[0] || ye.target;
      if (!(b.props.interactive && hE(A, _e))) {
        if ($0(b.props.triggerTarget || t).some(function(we) {
          return hE(we, _e);
        })) {
          if (No.isTouch || b.state.isVisible && b.props.trigger.indexOf("click") >= 0)
            return;
        } else
          Y("onClickOutside", [b, ye]);
        b.props.hideOnClick === !0 && (b.clearDelayTimeouts(), b.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), b.state.isMounted || $());
      }
    }
  }
  function fe() {
    l = !0;
  }
  function me() {
    l = !1;
  }
  function ge() {
    var ye = F();
    ye.addEventListener("mousedown", ae, !0), ye.addEventListener("touchend", ae, ou), ye.addEventListener("touchstart", me, ou), ye.addEventListener("touchmove", fe, ou);
  }
  function $() {
    var ye = F();
    ye.removeEventListener("mousedown", ae, !0), ye.removeEventListener("touchend", ae, ou), ye.removeEventListener("touchstart", me, ou), ye.removeEventListener("touchmove", fe, ou);
  }
  function se(ye, _e) {
    Oe(ye, function() {
      !b.state.isVisible && A.parentNode && A.parentNode.contains(A) && _e();
    });
  }
  function xe(ye, _e) {
    Oe(ye, _e);
  }
  function Oe(ye, _e) {
    var we = _().box;
    function $e(Xe) {
      Xe.target === we && (X5(we, "remove", $e), _e());
    }
    if (ye === 0)
      return _e();
    X5(we, "remove", d), X5(we, "add", $e), d = $e;
  }
  function je(ye, _e, we) {
    we === void 0 && (we = !1);
    var $e = $0(b.props.triggerTarget || t);
    $e.forEach(function(Xe) {
      Xe.addEventListener(ye, _e, we), h.push({
        node: Xe,
        eventType: ye,
        handler: _e,
        options: we
      });
    });
  }
  function Me() {
    z() && (je("touchstart", pe, {
      passive: !0
    }), je("touchend", K, {
      passive: !0
    })), dce(b.props.trigger).forEach(function(ye) {
      if (ye !== "manual")
        switch (je(ye, pe), ye) {
          case "mouseenter":
            je("mouseleave", K);
            break;
          case "focus":
            je(Cce ? "focusout" : "blur", X);
            break;
          case "focusin":
            je("focusout", X);
            break;
        }
    });
  }
  function he() {
    h.forEach(function(ye) {
      var _e = ye.node, we = ye.eventType, $e = ye.handler, Xe = ye.options;
      _e.removeEventListener(we, $e, Xe);
    }), h = [];
  }
  function pe(ye) {
    var _e, we = !1;
    if (!(!b.state.isEnabled || re(ye) || s)) {
      var $e = ((_e = u) == null ? void 0 : _e.type) === "focus";
      u = ye, m = ye.currentTarget, oe(), !b.state.isVisible && mce(ye) && ym.forEach(function(Xe) {
        return Xe(ye);
      }), ye.type === "click" && (b.props.trigger.indexOf("mouseenter") < 0 || o) && b.props.hideOnClick !== !1 && b.state.isVisible ? we = !0 : O(ye), ye.type === "click" && (o = !we), we && !$e && ne(ye);
    }
  }
  function J(ye) {
    var _e = ye.target, we = V().contains(_e) || A.contains(_e);
    if (!(ye.type === "mousemove" && we)) {
      var $e = P().concat(A).map(function(Xe) {
        var Be, et = Xe._tippy, dt = (Be = et.popperInstance) == null ? void 0 : Be.state;
        return dt ? {
          popperRect: Xe.getBoundingClientRect(),
          popperState: dt,
          props: n
        } : null;
      }).filter(Boolean);
      bce($e, ye) && (ee(), ne(ye));
    }
  }
  function K(ye) {
    var _e = re(ye) || b.props.trigger.indexOf("click") >= 0 && o;
    if (!_e) {
      if (b.props.interactive) {
        b.hideWithInteractivity(ye);
        return;
      }
      ne(ye);
    }
  }
  function X(ye) {
    b.props.trigger.indexOf("focusin") < 0 && ye.target !== V() || b.props.interactive && ye.relatedTarget && A.contains(ye.relatedTarget) || ne(ye);
  }
  function re(ye) {
    return No.isTouch ? z() !== ye.type.indexOf("touch") >= 0 : !1;
  }
  function Ie() {
    q();
    var ye = b.props, _e = ye.popperOptions, we = ye.placement, $e = ye.offset, Xe = ye.getReferenceClientRect, Be = ye.moveTransition, et = H() ? E7(A).arrow : null, dt = Xe ? {
      getBoundingClientRect: Xe,
      contextElement: Xe.contextElement || V()
    } : t, ut = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(kt) {
        var sn = kt.state;
        if (H()) {
          var Sn = _(), ht = Sn.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(gn) {
            gn === "placement" ? ht.setAttribute("data-placement", sn.placement) : sn.attributes.popper["data-popper-" + gn] ? ht.setAttribute("data-" + gn, "") : ht.removeAttribute("data-" + gn);
          }), sn.attributes.popper = {};
        }
      }
    }, Pt = [{
      name: "offset",
      options: {
        offset: $e
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Be
      }
    }, ut];
    H() && et && Pt.push({
      name: "arrow",
      options: {
        element: et,
        padding: 3
      }
    }), Pt.push.apply(Pt, (_e == null ? void 0 : _e.modifiers) || []), b.popperInstance = oce(dt, A, Object.assign({}, _e, {
      placement: we,
      onFirstUpdate: f,
      modifiers: Pt
    }));
  }
  function q() {
    b.popperInstance && (b.popperInstance.destroy(), b.popperInstance = null);
  }
  function S() {
    var ye = b.props.appendTo, _e, we = V();
    b.props.interactive && ye === oF || ye === "parent" ? _e = we.parentNode : _e = sF(ye, [we]), _e.contains(A) || _e.appendChild(A), b.state.isMounted = !0, Ie(), process.env.NODE_ENV !== "production" && Ps(b.props.interactive && ye === Yi.appendTo && we.nextElementSibling !== A, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function P() {
    return Ly(A.querySelectorAll("[data-tippy-root]"));
  }
  function O(ye) {
    b.clearDelayTimeouts(), ye && Y("onTrigger", [b, ye]), ge();
    var _e = W(!0), we = D(), $e = we[0], Xe = we[1];
    No.isTouch && $e === "hold" && Xe && (_e = Xe), _e ? r = setTimeout(function() {
      b.show();
    }, _e) : b.show();
  }
  function ne(ye) {
    if (b.clearDelayTimeouts(), Y("onUntrigger", [b, ye]), !b.state.isVisible) {
      $();
      return;
    }
    if (!(b.props.trigger.indexOf("mouseenter") >= 0 && b.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(ye.type) >= 0 && o)) {
      var _e = W(!1);
      _e ? i = setTimeout(function() {
        b.state.isVisible && b.hide();
      }, _e) : a = requestAnimationFrame(function() {
        b.hide();
      });
    }
  }
  function le() {
    b.state.isEnabled = !0;
  }
  function de() {
    b.hide(), b.state.isEnabled = !1;
  }
  function Pe() {
    clearTimeout(r), clearTimeout(i), cancelAnimationFrame(a);
  }
  function ve(ye) {
    if (process.env.NODE_ENV !== "production" && Ps(b.state.isDestroyed, P0("setProps")), !b.state.isDestroyed) {
      Y("onBeforeUpdate", [b, ye]), he();
      var _e = b.props, we = yE(t, Object.assign({}, _e, dE(ye), {
        ignoreAttributes: !0
      }));
      b.props = we, Me(), _e.interactiveDebounce !== we.interactiveDebounce && (ee(), p = cE(J, we.interactiveDebounce)), _e.triggerTarget && !we.triggerTarget ? $0(_e.triggerTarget).forEach(function($e) {
        $e.removeAttribute("aria-expanded");
      }) : we.triggerTarget && t.removeAttribute("aria-expanded"), oe(), G(), L && L(_e, we), b.popperInstance && (Ie(), P().forEach(function($e) {
        requestAnimationFrame($e._tippy.popperInstance.forceUpdate);
      })), Y("onAfterUpdate", [b, ye]);
    }
  }
  function Le(ye) {
    b.setProps({
      content: ye
    });
  }
  function Re() {
    process.env.NODE_ENV !== "production" && Ps(b.state.isDestroyed, P0("show"));
    var ye = b.state.isVisible, _e = b.state.isDestroyed, we = !b.state.isEnabled, $e = No.isTouch && !b.props.touch, Xe = J5(b.props.duration, 0, Yi.duration);
    if (!(ye || _e || we || $e) && !V().hasAttribute("disabled") && (Y("onShow", [b], !1), b.props.onShow(b) !== !1)) {
      if (b.state.isVisible = !0, H() && (A.style.visibility = "visible"), G(), ge(), b.state.isMounted || (A.style.transition = "none"), H()) {
        var Be = _(), et = Be.box, dt = Be.content;
        Q5([et, dt], 0);
      }
      f = function() {
        var Pt;
        if (!(!b.state.isVisible || c)) {
          if (c = !0, A.offsetHeight, A.style.transition = b.props.moveTransition, H() && b.props.animation) {
            var Vt = _(), kt = Vt.box, sn = Vt.content;
            Q5([kt, sn], Xe), fE([kt, sn], "visible");
          }
          Z(), oe(), uE(e8, b), (Pt = b.popperInstance) == null || Pt.forceUpdate(), Y("onMount", [b]), b.props.animation && H() && xe(Xe, function() {
            b.state.isShown = !0, Y("onShown", [b]);
          });
        }
      }, S();
    }
  }
  function Ke() {
    process.env.NODE_ENV !== "production" && Ps(b.state.isDestroyed, P0("hide"));
    var ye = !b.state.isVisible, _e = b.state.isDestroyed, we = !b.state.isEnabled, $e = J5(b.props.duration, 1, Yi.duration);
    if (!(ye || _e || we) && (Y("onHide", [b], !1), b.props.onHide(b) !== !1)) {
      if (b.state.isVisible = !1, b.state.isShown = !1, c = !1, o = !1, H() && (A.style.visibility = "hidden"), ee(), $(), G(!0), H()) {
        var Xe = _(), Be = Xe.box, et = Xe.content;
        b.props.animation && (Q5([Be, et], $e), fE([Be, et], "hidden"));
      }
      Z(), oe(), b.props.animation ? H() && se($e, b.unmount) : b.unmount();
    }
  }
  function mt(ye) {
    process.env.NODE_ENV !== "production" && Ps(b.state.isDestroyed, P0("hideWithInteractivity")), F().addEventListener("mousemove", p), uE(ym, p), p(ye);
  }
  function pt() {
    process.env.NODE_ENV !== "production" && Ps(b.state.isDestroyed, P0("unmount")), b.state.isVisible && b.hide(), b.state.isMounted && (q(), P().forEach(function(ye) {
      ye._tippy.unmount();
    }), A.parentNode && A.parentNode.removeChild(A), e8 = e8.filter(function(ye) {
      return ye !== b;
    }), b.state.isMounted = !1, Y("onHidden", [b]));
  }
  function Nt() {
    process.env.NODE_ENV !== "production" && Ps(b.state.isDestroyed, P0("destroy")), !b.state.isDestroyed && (b.clearDelayTimeouts(), b.unmount(), he(), delete t._tippy, b.state.isDestroyed = !0, Y("onDestroy", [b]));
  }
}
function w0(t, e) {
  e === void 0 && (e = {});
  var n = Yi.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (Lce(t), fF(e, n)), xce();
  var r = Object.assign({}, e, {
    plugins: n
  }), i = gce(t);
  if (process.env.NODE_ENV !== "production") {
    var a = Ph(r.content), o = i.length > 1;
    Ps(a && o, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = i.reduce(function(l, c) {
    var u = c && Pce(c, r);
    return u && l.push(u), l;
  }, []);
  return Ph(t) ? s[0] : s;
}
w0.defaultProps = Yi;
w0.setDefaultProps = jce;
w0.currentInput = No;
Object.assign({}, KH, {
  effect: function(e) {
    var n = e.state, r = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow);
  }
});
var zce = {
  name: "sticky",
  defaultValue: !1,
  fn: function(e) {
    var n = e.reference, r = e.popper;
    function i() {
      return e.popperInstance ? e.popperInstance.state.elements.reference : n;
    }
    function a(c) {
      return e.props.sticky === !0 || e.props.sticky === c;
    }
    var o = null, s = null;
    function l() {
      var c = a("reference") ? i().getBoundingClientRect() : null, u = a("popper") ? r.getBoundingClientRect() : null;
      (c && bE(o, c) || u && bE(s, u)) && e.popperInstance && e.popperInstance.update(), o = c, s = u, e.state.isMounted && requestAnimationFrame(l);
    }
    return {
      onMount: function() {
        e.props.sticky && l();
      }
    };
  }
};
function bE(t, e) {
  return t && e ? t.top !== e.top || t.right !== e.right || t.bottom !== e.bottom || t.left !== e.left : !0;
}
w0.setDefaultProps({
  render: hF
});
class Rce {
  constructor({ editor: e, element: n, view: r, tippyOptions: i = {}, updateDelay: a = 250, shouldShow: o }) {
    this.preventHide = !1, this.shouldShow = ({ view: s, state: l, from: c, to: u }) => {
      const { doc: d, selection: f } = l, { empty: h } = f, p = !d.textBetween(c, u).length && Lg(l.selection), m = this.element.contains(document.activeElement);
      return !(!(s.hasFocus() || m) || h || p || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: s }) => {
      var l;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      s != null && s.relatedTarget && (!((l = this.element.parentNode) === null || l === void 0) && l.contains(s.relatedTarget)) || (s == null ? void 0 : s.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.tippyBlurHandler = (s) => {
      this.blurHandler({ event: s });
    }, this.handleDebouncedUpdate = (s, l) => {
      const c = !(l != null && l.selection.eq(s.state.selection)), u = !(l != null && l.doc.eq(s.state.doc));
      !c && !u || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(s, c, u, l);
      }, this.updateDelay));
    }, this.updateHandler = (s, l, c, u) => {
      var d, f, h;
      const { state: p, composing: m } = s, { selection: g } = p;
      if (m || !l && !c)
        return;
      this.createTooltip();
      const { ranges: k } = g, w = Math.min(...k.map((A) => A.$from.pos)), b = Math.max(...k.map((A) => A.$to.pos));
      if (!((d = this.shouldShow) === null || d === void 0 ? void 0 : d.call(this, {
        editor: this.editor,
        element: this.element,
        view: s,
        state: p,
        oldState: u,
        from: w,
        to: b
      }))) {
        this.hide();
        return;
      }
      (f = this.tippy) === null || f === void 0 || f.setProps({
        getReferenceClientRect: ((h = this.tippyOptions) === null || h === void 0 ? void 0 : h.getReferenceClientRect) || (() => {
          if (HH(p.selection)) {
            let A = s.nodeDOM(w);
            if (A) {
              const L = A.dataset.nodeViewWrapper ? A : A.querySelector("[data-node-view-wrapper]");
              if (L && (A = L.firstChild), A)
                return A.getBoundingClientRect();
            }
          }
          return Ese(s, w, b);
        })
      }), this.show();
    }, this.editor = e, this.element = n, this.view = r, this.updateDelay = a, o && (this.shouldShow = o), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = i, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, n = !!e.parentElement;
    this.tippy || !n || (this.tippy = w0(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, n) {
    const { state: r } = e, i = r.selection.from !== r.selection.to;
    if (this.updateDelay > 0 && i) {
      this.handleDebouncedUpdate(e, n);
      return;
    }
    const a = !(n != null && n.selection.eq(e.state.selection)), o = !(n != null && n.doc.eq(e.state.doc));
    this.updateHandler(e, a, o, n);
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, n;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (n = this.tippy) === null || n === void 0 || n.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const pF = (t) => new Wt({
  key: typeof t.pluginKey == "string" ? new tn(t.pluginKey) : t.pluginKey,
  view: (e) => new Rce({ view: e, ...t })
});
ln.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      pF({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
function Oce(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var j7 = { exports: {} }, t8 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wE;
function Bce() {
  if (wE) return t8;
  wE = 1;
  var t = Ce;
  function e(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, i = t.useEffect, a = t.useLayoutEffect, o = t.useDebugValue;
  function s(d, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), m = p[0].inst, g = p[1];
    return a(function() {
      m.value = h, m.getSnapshot = f, l(m) && g({ inst: m });
    }, [d, h, f]), i(function() {
      return l(m) && g({ inst: m }), d(function() {
        l(m) && g({ inst: m });
      });
    }, [d]), o(h), h;
  }
  function l(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return t8.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, t8;
}
var n8 = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kE;
function Hce() {
  return kE || (kE = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Ce, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(w) {
      {
        for (var b = arguments.length, x = new Array(b > 1 ? b - 1 : 0), A = 1; A < b; A++)
          x[A - 1] = arguments[A];
        r("error", w, x);
      }
    }
    function r(w, b, x) {
      {
        var A = e.ReactDebugCurrentFrame, L = A.getStackAddendum();
        L !== "" && (b += "%s", x = x.concat([L]));
        var M = x.map(function(j) {
          return String(j);
        });
        M.unshift("Warning: " + b), Function.prototype.apply.call(console[w], console, M);
      }
    }
    function i(w, b) {
      return w === b && (w !== 0 || 1 / w === 1 / b) || w !== w && b !== b;
    }
    var a = typeof Object.is == "function" ? Object.is : i, o = t.useState, s = t.useEffect, l = t.useLayoutEffect, c = t.useDebugValue, u = !1, d = !1;
    function f(w, b, x) {
      u || t.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var A = b();
      if (!d) {
        var L = b();
        a(A, L) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var M = o({
        inst: {
          value: A,
          getSnapshot: b
        }
      }), j = M[0].inst, D = M[1];
      return l(function() {
        j.value = A, j.getSnapshot = b, h(j) && D({
          inst: j
        });
      }, [w, A, b]), s(function() {
        h(j) && D({
          inst: j
        });
        var z = function() {
          h(j) && D({
            inst: j
          });
        };
        return w(z);
      }, [w]), c(A), A;
    }
    function h(w) {
      var b = w.getSnapshot, x = w.value;
      try {
        var A = b();
        return !a(x, A);
      } catch {
        return !0;
      }
    }
    function p(w, b, x) {
      return b();
    }
    var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", g = !m, v = g ? p : f, k = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : v;
    n8.useSyncExternalStore = k, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), n8;
}
process.env.NODE_ENV === "production" ? j7.exports = Bce() : j7.exports = Hce();
var Dg = j7.exports;
const Fce = (...t) => (e) => {
  t.forEach((n) => {
    typeof n == "function" ? n(e) : n && (n.current = e);
  });
}, _ce = ({ contentComponent: t }) => {
  const e = Dg.useSyncExternalStore(t.subscribe, t.getSnapshot, t.getServerSnapshot);
  return Ce.createElement(Ce.Fragment, null, Object.values(e));
};
function Vce() {
  const t = /* @__PURE__ */ new Set();
  let e = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(n) {
      return t.add(n), () => {
        t.delete(n);
      };
    },
    getSnapshot() {
      return e;
    },
    getServerSnapshot() {
      return e;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(n, r) {
      e = {
        ...e,
        [n]: hg.createPortal(r.reactElement, r.element, n)
      }, t.forEach((i) => i());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(n) {
      const r = { ...e };
      delete r[n], e = r, t.forEach((i) => i());
    }
  };
}
class qce extends Ce.Component {
  constructor(e) {
    var n;
    super(e), this.editorContentRef = Ce.createRef(), this.initialized = !1, this.state = {
      hasContentComponentInitialized: !!(!((n = e.editor) === null || n === void 0) && n.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const e = this.props.editor;
    if (e && !e.isDestroyed && e.options.element) {
      if (e.contentComponent)
        return;
      const n = this.editorContentRef.current;
      n.append(...e.options.element.childNodes), e.setOptions({
        element: n
      }), e.contentComponent = Vce(), this.state.hasContentComponentInitialized || (this.unsubscribeToContentComponent = e.contentComponent.subscribe(() => {
        this.setState((r) => r.hasContentComponentInitialized ? r : {
          hasContentComponentInitialized: !0
        }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent();
      })), e.createNodeViews(), this.initialized = !0;
    }
  }
  componentWillUnmount() {
    const e = this.props.editor;
    if (!e || (this.initialized = !1, e.isDestroyed || e.view.setProps({
      nodeViews: {}
    }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent(), e.contentComponent = null, !e.options.element.firstChild))
      return;
    const n = document.createElement("div");
    n.append(...e.options.element.childNodes), e.setOptions({
      element: n
    });
  }
  render() {
    const { editor: e, innerRef: n, ...r } = this.props;
    return Ce.createElement(
      Ce.Fragment,
      null,
      Ce.createElement("div", { ref: Fce(n, this.editorContentRef), ...r }),
      (e == null ? void 0 : e.contentComponent) && Ce.createElement(_ce, { contentComponent: e.contentComponent })
    );
  }
}
const Uce = en((t, e) => {
  const n = Ce.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [t.editor]);
  return Ce.createElement(qce, {
    key: n,
    innerRef: e,
    ...t
  });
}), Px = Ce.memo(Uce);
var Wce = function t(e, n) {
  if (e === n) return !0;
  if (e && n && typeof e == "object" && typeof n == "object") {
    if (e.constructor !== n.constructor) return !1;
    var r, i, a;
    if (Array.isArray(e)) {
      if (r = e.length, r != n.length) return !1;
      for (i = r; i-- !== 0; )
        if (!t(e[i], n[i])) return !1;
      return !0;
    }
    if (e instanceof Map && n instanceof Map) {
      if (e.size !== n.size) return !1;
      for (i of e.entries())
        if (!n.has(i[0])) return !1;
      for (i of e.entries())
        if (!t(i[1], n.get(i[0]))) return !1;
      return !0;
    }
    if (e instanceof Set && n instanceof Set) {
      if (e.size !== n.size) return !1;
      for (i of e.entries())
        if (!n.has(i[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(n)) {
      if (r = e.length, r != n.length) return !1;
      for (i = r; i-- !== 0; )
        if (e[i] !== n[i]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === n.source && e.flags === n.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === n.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === n.toString();
    if (a = Object.keys(e), r = a.length, r !== Object.keys(n).length) return !1;
    for (i = r; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, a[i])) return !1;
    for (i = r; i-- !== 0; ) {
      var o = a[i];
      if (!(o === "_owner" && e.$$typeof) && !t(e[o], n[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}, Zce = /* @__PURE__ */ Oce(Wce), N7 = { exports: {} }, r8 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xE;
function Gce() {
  if (xE) return r8;
  xE = 1;
  var t = Ce, e = Dg;
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = e.useSyncExternalStore, a = t.useRef, o = t.useEffect, s = t.useMemo, l = t.useDebugValue;
  return r8.useSyncExternalStoreWithSelector = function(c, u, d, f, h) {
    var p = a(null);
    if (p.current === null) {
      var m = { hasValue: !1, value: null };
      p.current = m;
    } else m = p.current;
    p = s(function() {
      function v(A) {
        if (!k) {
          if (k = !0, w = A, A = f(A), h !== void 0 && m.hasValue) {
            var L = m.value;
            if (h(L, A)) return b = L;
          }
          return b = A;
        }
        if (L = b, r(w, A)) return L;
        var M = f(A);
        return h !== void 0 && h(L, M) ? L : (w = A, b = M);
      }
      var k = !1, w, b, x = d === void 0 ? null : d;
      return [function() {
        return v(u());
      }, x === null ? void 0 : function() {
        return v(x());
      }];
    }, [u, d, f, h]);
    var g = i(c, p[0], p[1]);
    return o(function() {
      m.hasValue = !0, m.value = g;
    }, [g]), l(g), g;
  }, r8;
}
var i8 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ME;
function Yce() {
  return ME || (ME = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Ce, e = Dg;
    function n(u, d) {
      return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
    }
    var r = typeof Object.is == "function" ? Object.is : n, i = e.useSyncExternalStore, a = t.useRef, o = t.useEffect, s = t.useMemo, l = t.useDebugValue;
    function c(u, d, f, h, p) {
      var m = a(null), g;
      m.current === null ? (g = {
        hasValue: !1,
        value: null
      }, m.current = g) : g = m.current;
      var v = s(function() {
        var x = !1, A, L, M = function(H) {
          if (!x) {
            x = !0, A = H;
            var V = h(H);
            if (p !== void 0 && g.hasValue) {
              var F = g.value;
              if (p(F, V))
                return L = F, F;
            }
            return L = V, V;
          }
          var _ = A, W = L;
          if (r(_, H))
            return W;
          var G = h(H);
          return p !== void 0 && p(W, G) ? W : (A = H, L = G, G);
        }, j = f === void 0 ? null : f, D = function() {
          return M(d());
        }, z = j === null ? void 0 : function() {
          return M(j());
        };
        return [D, z];
      }, [d, f, h, p]), k = v[0], w = v[1], b = i(u, k, w);
      return o(function() {
        g.hasValue = !0, g.value = b;
      }, [b]), l(b), b;
    }
    i8.useSyncExternalStoreWithSelector = c, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), i8;
}
process.env.NODE_ENV === "production" ? N7.exports = Gce() : N7.exports = Yce();
var Kce = N7.exports;
class $ce {
  constructor(e) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = e, this.lastSnapshot = { editor: e, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscribers.add(e), () => {
      this.subscribers.delete(e);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(e) {
    if (this.editor = e, this.editor) {
      const n = () => {
        this.transactionNumber += 1, this.subscribers.forEach((i) => i());
      }, r = this.editor;
      return r.on("transaction", n), () => {
        r.off("transaction", n);
      };
    }
  }
}
function Jce(t) {
  var e;
  const [n] = De(() => new $ce(t.editor)), r = Kce.useSyncExternalStoreWithSelector(n.subscribe, n.getSnapshot, n.getServerSnapshot, t.selector, (e = t.equalityFn) !== null && e !== void 0 ? e : Zce);
  return ze(() => n.watch(t.editor), [t.editor, n]), Uk(r), r;
}
const CE = process.env.NODE_ENV !== "production", D7 = typeof window > "u", Qce = D7 || !!(typeof window < "u" && window.next);
class Xce {
  constructor(e) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = e, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(e) {
    this.editor = e, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((n) => n());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0)
      return D7 || Qce ? (CE && console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."), null) : this.createEditor();
    if (this.options.current.immediatelyRender && D7 && CE)
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const e = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...r) => {
        var i, a;
        return (a = (i = this.options.current).onBeforeCreate) === null || a === void 0 ? void 0 : a.call(i, ...r);
      },
      onBlur: (...r) => {
        var i, a;
        return (a = (i = this.options.current).onBlur) === null || a === void 0 ? void 0 : a.call(i, ...r);
      },
      onCreate: (...r) => {
        var i, a;
        return (a = (i = this.options.current).onCreate) === null || a === void 0 ? void 0 : a.call(i, ...r);
      },
      onDestroy: (...r) => {
        var i, a;
        return (a = (i = this.options.current).onDestroy) === null || a === void 0 ? void 0 : a.call(i, ...r);
      },
      onFocus: (...r) => {
        var i, a;
        return (a = (i = this.options.current).onFocus) === null || a === void 0 ? void 0 : a.call(i, ...r);
      },
      onSelectionUpdate: (...r) => {
        var i, a;
        return (a = (i = this.options.current).onSelectionUpdate) === null || a === void 0 ? void 0 : a.call(i, ...r);
      },
      onTransaction: (...r) => {
        var i, a;
        return (a = (i = this.options.current).onTransaction) === null || a === void 0 ? void 0 : a.call(i, ...r);
      },
      onUpdate: (...r) => {
        var i, a;
        return (a = (i = this.options.current).onUpdate) === null || a === void 0 ? void 0 : a.call(i, ...r);
      },
      onContentError: (...r) => {
        var i, a;
        return (a = (i = this.options.current).onContentError) === null || a === void 0 ? void 0 : a.call(i, ...r);
      },
      onDrop: (...r) => {
        var i, a;
        return (a = (i = this.options.current).onDrop) === null || a === void 0 ? void 0 : a.call(i, ...r);
      },
      onPaste: (...r) => {
        var i, a;
        return (a = (i = this.options.current).onPaste) === null || a === void 0 ? void 0 : a.call(i, ...r);
      }
    };
    return new np(e);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscriptions.add(e), () => {
      this.subscriptions.delete(e);
    };
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(e) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && e.length === 0 ? this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(e), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(e) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = e;
        return;
      }
      if (this.previousDeps.length === e.length && this.previousDeps.every((r, i) => r === e[i]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = e;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const e = this.instanceId, n = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === e) {
        n && n.setOptions(this.options.current);
        return;
      }
      n && !n.isDestroyed && (n.destroy(), this.instanceId === e && this.setEditor(null));
    }, 1);
  }
}
function mF(t = {}, e = []) {
  const n = Ue(t);
  n.current = t;
  const [r] = De(() => new Xce(n)), i = Dg.useSyncExternalStore(r.subscribe, r.getEditor, r.getServerSnapshot);
  return Uk(i), ze(r.onRender(e)), Jce({
    editor: i,
    selector: ({ transactionNumber: a }) => t.shouldRerenderOnTransaction === !1 ? null : t.immediatelyRender && a === 0 ? 0 : a + 1
  }), i;
}
const yF = xn({
  editor: null
});
yF.Consumer;
const eue = () => Mt(yF), zx = (t) => {
  const [e, n] = De(null), { editor: r } = eue();
  return ze(() => {
    var i;
    if (!e || !((i = t.editor) === null || i === void 0) && i.isDestroyed || r != null && r.isDestroyed)
      return;
    const { pluginKey: a = "bubbleMenu", editor: o, tippyOptions: s = {}, updateDelay: l, shouldShow: c = null } = t, u = o || r;
    if (!u) {
      console.warn("BubbleMenu component is not rendered inside of an editor component or does not have editor prop.");
      return;
    }
    const d = pF({
      updateDelay: l,
      editor: u,
      element: e,
      pluginKey: a,
      shouldShow: c,
      tippyOptions: s
    });
    return u.registerPlugin(d), () => {
      u.unregisterPlugin(a);
    };
  }, [t.editor, r, e]), Ce.createElement("div", { ref: n, className: t.className, style: { visibility: "hidden" } }, t.children);
}, gF = xn({
  onDragStart: void 0
}), vF = () => Mt(gF), I7 = (t) => {
  const e = t.as || "div", { nodeViewContentRef: n } = vF();
  return (
    // @ts-ignore
    Ce.createElement(e, { ...t, ref: n, "data-node-view-content": "", style: {
      whiteSpace: "pre-wrap",
      ...t.style
    } })
  );
}, $u = Ce.forwardRef((t, e) => {
  const { onDragStart: n } = vF(), r = t.as || "div";
  return (
    // @ts-ignore
    Ce.createElement(r, { ...t, ref: e, "data-node-view-wrapper": "", onDragStart: n, style: {
      whiteSpace: "normal",
      ...t.style
    } })
  );
});
function tue(t) {
  return !!(typeof t == "function" && t.prototype && t.prototype.isReactComponent);
}
function nue(t) {
  var e;
  return typeof t == "object" && ((e = t.$$typeof) === null || e === void 0 ? void 0 : e.toString()) === "Symbol(react.forward_ref)";
}
class bF {
  /**
   * Immediately creates element and renders the provided React component.
   */
  constructor(e, { editor: n, props: r = {}, as: i = "div", className: a = "" }) {
    this.ref = null, this.id = Math.floor(Math.random() * 4294967295).toString(), this.component = e, this.editor = n, this.props = r, this.element = document.createElement(i), this.element.classList.add("react-renderer"), a && this.element.classList.add(...a.split(" ")), this.editor.isInitialized ? Zk(() => {
      this.render();
    }) : this.render();
  }
  /**
   * Render the React component.
   */
  render() {
    var e;
    const n = this.component, r = this.props, i = this.editor;
    (tue(n) || nue(n)) && (r.ref = (a) => {
      this.ref = a;
    }), this.reactElement = Ce.createElement(n, r), (e = i == null ? void 0 : i.contentComponent) === null || e === void 0 || e.setRenderer(this.id, this);
  }
  /**
   * Re-renders the React component with new props.
   */
  updateProps(e = {}) {
    this.props = {
      ...this.props,
      ...e
    }, this.render();
  }
  /**
   * Destroy the React component.
   */
  destroy() {
    var e;
    const n = this.editor;
    (e = n == null ? void 0 : n.contentComponent) === null || e === void 0 || e.removeRenderer(this.id);
  }
  /**
   * Update the attributes of the element that holds the React component.
   */
  updateAttributes(e) {
    Object.keys(e).forEach((n) => {
      this.element.setAttribute(n, e[n]);
    });
  }
}
class rue extends ele {
  /**
   * Setup the React component.
   * Called on initialization.
   */
  mount() {
    const e = {
      editor: this.editor,
      node: this.node,
      decorations: this.decorations,
      innerDecorations: this.innerDecorations,
      view: this.view,
      selected: !1,
      extension: this.extension,
      HTMLAttributes: this.HTMLAttributes,
      getPos: () => this.getPos(),
      updateAttributes: (c = {}) => this.updateAttributes(c),
      deleteNode: () => this.deleteNode()
    };
    if (!this.component.displayName) {
      const c = (u) => u.charAt(0).toUpperCase() + u.substring(1);
      this.component.displayName = c(this.extension.name);
    }
    const i = { onDragStart: this.onDragStart.bind(this), nodeViewContentRef: (c) => {
      c && this.contentDOMElement && c.firstChild !== this.contentDOMElement && c.appendChild(this.contentDOMElement);
    } }, a = this.component, o = Ce.memo((c) => Ce.createElement(gF.Provider, { value: i }, Ce.createElement(a, c)));
    o.displayName = "ReactNodeView", this.node.isLeaf ? this.contentDOMElement = null : this.options.contentDOMElementTag ? this.contentDOMElement = document.createElement(this.options.contentDOMElementTag) : this.contentDOMElement = document.createElement(this.node.isInline ? "span" : "div"), this.contentDOMElement && (this.contentDOMElement.dataset.nodeViewContentReact = "", this.contentDOMElement.style.whiteSpace = "inherit");
    let s = this.node.isInline ? "span" : "div";
    this.options.as && (s = this.options.as);
    const { className: l = "" } = this.options;
    this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this), this.editor.on("selectionUpdate", this.handleSelectionUpdate), this.renderer = new bF(o, {
      editor: this.editor,
      props: e,
      as: s,
      className: `node-${this.node.type.name} ${l}`.trim()
    }), this.updateElementAttributes();
  }
  /**
   * Return the DOM element.
   * This is the element that will be used to display the node view.
   */
  get dom() {
    var e;
    if (this.renderer.element.firstElementChild && !(!((e = this.renderer.element.firstElementChild) === null || e === void 0) && e.hasAttribute("data-node-view-wrapper")))
      throw Error("Please use the NodeViewWrapper component for your node view.");
    return this.renderer.element;
  }
  /**
   * Return the content DOM element.
   * This is the element that will be used to display the rich-text content of the node.
   */
  get contentDOM() {
    return this.node.isLeaf ? null : this.contentDOMElement;
  }
  /**
   * On editor selection update, check if the node is selected.
   * If it is, call `selectNode`, otherwise call `deselectNode`.
   */
  handleSelectionUpdate() {
    const { from: e, to: n } = this.editor.state.selection, r = this.getPos();
    if (typeof r == "number")
      if (e <= r && n >= r + this.node.nodeSize) {
        if (this.renderer.props.selected)
          return;
        this.selectNode();
      } else {
        if (!this.renderer.props.selected)
          return;
        this.deselectNode();
      }
  }
  /**
   * On update, update the React component.
   * To prevent unnecessary updates, the `update` option can be used.
   */
  update(e, n, r) {
    const i = (a) => {
      this.renderer.updateProps(a), typeof this.options.attrs == "function" && this.updateElementAttributes();
    };
    if (e.type !== this.node.type)
      return !1;
    if (typeof this.options.update == "function") {
      const a = this.node, o = this.decorations, s = this.innerDecorations;
      return this.node = e, this.decorations = n, this.innerDecorations = r, this.options.update({
        oldNode: a,
        oldDecorations: o,
        newNode: e,
        newDecorations: n,
        oldInnerDecorations: s,
        innerDecorations: r,
        updateProps: () => i({ node: e, decorations: n, innerDecorations: r })
      });
    }
    return e === this.node && this.decorations === n && this.innerDecorations === r || (this.node = e, this.decorations = n, this.innerDecorations = r, i({ node: e, decorations: n, innerDecorations: r })), !0;
  }
  /**
   * Select the node.
   * Add the `selected` prop and the `ProseMirror-selectednode` class.
   */
  selectNode() {
    this.renderer.updateProps({
      selected: !0
    }), this.renderer.element.classList.add("ProseMirror-selectednode");
  }
  /**
   * Deselect the node.
   * Remove the `selected` prop and the `ProseMirror-selectednode` class.
   */
  deselectNode() {
    this.renderer.updateProps({
      selected: !1
    }), this.renderer.element.classList.remove("ProseMirror-selectednode");
  }
  /**
   * Destroy the React component instance.
   */
  destroy() {
    this.renderer.destroy(), this.editor.off("selectionUpdate", this.handleSelectionUpdate), this.contentDOMElement = null;
  }
  /**
   * Update the attributes of the top-level element that holds the React component.
   * Applying the attributes defined in the `attrs` option.
   */
  updateElementAttributes() {
    if (this.options.attrs) {
      let e = {};
      if (typeof this.options.attrs == "function") {
        const n = this.editor.extensionManager.attributes, r = My(this.node, n);
        e = this.options.attrs({ node: this.node, HTMLAttributes: r });
      } else
        e = this.options.attrs;
      this.renderer.updateAttributes(e);
    }
  }
}
function Hc(t, e) {
  return (n) => n.editor.contentComponent ? new rue(t, n, e) : {};
}
var wF = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function n() {
      for (var a = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (a = i(a, r(s)));
      }
      return a;
    }
    function r(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return n.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var o = "";
      for (var s in a)
        e.call(a, s) && a[s] && (o = i(o, s));
      return o;
    }
    function i(a, o) {
      return o ? a ? a + " " + o : a + o : a;
    }
    t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
  })();
})(wF);
var iue = wF.exports;
const Lt = /* @__PURE__ */ kd(iue);
var gm = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function aue(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var P7 = { exports: {} }, nf = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var AE;
function oue() {
  if (AE) return nf;
  AE = 1;
  var t = Ce, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, c) {
    var u, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l) r.call(l, u) && !a.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps) for (u in l = s.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: e, type: s, key: f, ref: h, props: d, _owner: i.current };
  }
  return nf.Fragment = n, nf.jsx = o, nf.jsxs = o, nf;
}
var vm = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var SE;
function sue() {
  return SE || (SE = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Ce, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, m = "@@iterator";
    function g(R) {
      if (R === null || typeof R != "object")
        return null;
      var ue = p && R[p] || R[m];
      return typeof ue == "function" ? ue : null;
    }
    var v = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(R) {
      {
        for (var ue = arguments.length, Ae = new Array(ue > 1 ? ue - 1 : 0), Ve = 1; Ve < ue; Ve++)
          Ae[Ve - 1] = arguments[Ve];
        w("error", R, Ae);
      }
    }
    function w(R, ue, Ae) {
      {
        var Ve = v.ReactDebugCurrentFrame, ct = Ve.getStackAddendum();
        ct !== "" && (ue += "%s", Ae = Ae.concat([ct]));
        var yt = Ae.map(function(rt) {
          return String(rt);
        });
        yt.unshift("Warning: " + ue), Function.prototype.apply.call(console[R], console, yt);
      }
    }
    var b = !1, x = !1, A = !1, L = !1, M = !1, j;
    j = Symbol.for("react.module.reference");
    function D(R) {
      return !!(typeof R == "string" || typeof R == "function" || R === r || R === a || M || R === i || R === c || R === u || L || R === h || b || x || A || typeof R == "object" && R !== null && (R.$$typeof === f || R.$$typeof === d || R.$$typeof === o || R.$$typeof === s || R.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      R.$$typeof === j || R.getModuleId !== void 0));
    }
    function z(R, ue, Ae) {
      var Ve = R.displayName;
      if (Ve)
        return Ve;
      var ct = ue.displayName || ue.name || "";
      return ct !== "" ? Ae + "(" + ct + ")" : Ae;
    }
    function H(R) {
      return R.displayName || "Context";
    }
    function V(R) {
      if (R == null)
        return null;
      if (typeof R.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof R == "function")
        return R.displayName || R.name || null;
      if (typeof R == "string")
        return R;
      switch (R) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof R == "object")
        switch (R.$$typeof) {
          case s:
            var ue = R;
            return H(ue) + ".Consumer";
          case o:
            var Ae = R;
            return H(Ae._context) + ".Provider";
          case l:
            return z(R, R.render, "ForwardRef");
          case d:
            var Ve = R.displayName || null;
            return Ve !== null ? Ve : V(R.type) || "Memo";
          case f: {
            var ct = R, yt = ct._payload, rt = ct._init;
            try {
              return V(rt(yt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var F = Object.assign, _ = 0, W, G, Y, Z, oe, ee, ae;
    function fe() {
    }
    fe.__reactDisabledLog = !0;
    function me() {
      {
        if (_ === 0) {
          W = console.log, G = console.info, Y = console.warn, Z = console.error, oe = console.group, ee = console.groupCollapsed, ae = console.groupEnd;
          var R = {
            configurable: !0,
            enumerable: !0,
            value: fe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: R,
            log: R,
            warn: R,
            error: R,
            group: R,
            groupCollapsed: R,
            groupEnd: R
          });
        }
        _++;
      }
    }
    function ge() {
      {
        if (_--, _ === 0) {
          var R = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: F({}, R, {
              value: W
            }),
            info: F({}, R, {
              value: G
            }),
            warn: F({}, R, {
              value: Y
            }),
            error: F({}, R, {
              value: Z
            }),
            group: F({}, R, {
              value: oe
            }),
            groupCollapsed: F({}, R, {
              value: ee
            }),
            groupEnd: F({}, R, {
              value: ae
            })
          });
        }
        _ < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var $ = v.ReactCurrentDispatcher, se;
    function xe(R, ue, Ae) {
      {
        if (se === void 0)
          try {
            throw Error();
          } catch (ct) {
            var Ve = ct.stack.trim().match(/\n( *(at )?)/);
            se = Ve && Ve[1] || "";
          }
        return `
` + se + R;
      }
    }
    var Oe = !1, je;
    {
      var Me = typeof WeakMap == "function" ? WeakMap : Map;
      je = new Me();
    }
    function he(R, ue) {
      if (!R || Oe)
        return "";
      {
        var Ae = je.get(R);
        if (Ae !== void 0)
          return Ae;
      }
      var Ve;
      Oe = !0;
      var ct = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var yt;
      yt = $.current, $.current = null, me();
      try {
        if (ue) {
          var rt = function() {
            throw Error();
          };
          if (Object.defineProperty(rt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(rt, []);
            } catch (Dt) {
              Ve = Dt;
            }
            Reflect.construct(R, [], rt);
          } else {
            try {
              rt.call();
            } catch (Dt) {
              Ve = Dt;
            }
            R.call(rt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Dt) {
            Ve = Dt;
          }
          R();
        }
      } catch (Dt) {
        if (Dt && Ve && typeof Dt.stack == "string") {
          for (var tt = Dt.stack.split(`
`), Te = Ve.stack.split(`
`), Q = tt.length - 1, Se = Te.length - 1; Q >= 1 && Se >= 0 && tt[Q] !== Te[Se]; )
            Se--;
          for (; Q >= 1 && Se >= 0; Q--, Se--)
            if (tt[Q] !== Te[Se]) {
              if (Q !== 1 || Se !== 1)
                do
                  if (Q--, Se--, Se < 0 || tt[Q] !== Te[Se]) {
                    var Fe = `
` + tt[Q].replace(" at new ", " at ");
                    return R.displayName && Fe.includes("<anonymous>") && (Fe = Fe.replace("<anonymous>", R.displayName)), typeof R == "function" && je.set(R, Fe), Fe;
                  }
                while (Q >= 1 && Se >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, $.current = yt, ge(), Error.prepareStackTrace = ct;
      }
      var Rt = R ? R.displayName || R.name : "", Qt = Rt ? xe(Rt) : "";
      return typeof R == "function" && je.set(R, Qt), Qt;
    }
    function pe(R, ue, Ae) {
      return he(R, !1);
    }
    function J(R) {
      var ue = R.prototype;
      return !!(ue && ue.isReactComponent);
    }
    function K(R, ue, Ae) {
      if (R == null)
        return "";
      if (typeof R == "function")
        return he(R, J(R));
      if (typeof R == "string")
        return xe(R);
      switch (R) {
        case c:
          return xe("Suspense");
        case u:
          return xe("SuspenseList");
      }
      if (typeof R == "object")
        switch (R.$$typeof) {
          case l:
            return pe(R.render);
          case d:
            return K(R.type, ue, Ae);
          case f: {
            var Ve = R, ct = Ve._payload, yt = Ve._init;
            try {
              return K(yt(ct), ue, Ae);
            } catch {
            }
          }
        }
      return "";
    }
    var X = Object.prototype.hasOwnProperty, re = {}, Ie = v.ReactDebugCurrentFrame;
    function q(R) {
      if (R) {
        var ue = R._owner, Ae = K(R.type, R._source, ue ? ue.type : null);
        Ie.setExtraStackFrame(Ae);
      } else
        Ie.setExtraStackFrame(null);
    }
    function S(R, ue, Ae, Ve, ct) {
      {
        var yt = Function.call.bind(X);
        for (var rt in R)
          if (yt(R, rt)) {
            var tt = void 0;
            try {
              if (typeof R[rt] != "function") {
                var Te = Error((Ve || "React class") + ": " + Ae + " type `" + rt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof R[rt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Te.name = "Invariant Violation", Te;
              }
              tt = R[rt](ue, rt, Ve, Ae, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Q) {
              tt = Q;
            }
            tt && !(tt instanceof Error) && (q(ct), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ve || "React class", Ae, rt, typeof tt), q(null)), tt instanceof Error && !(tt.message in re) && (re[tt.message] = !0, q(ct), k("Failed %s type: %s", Ae, tt.message), q(null));
          }
      }
    }
    var P = Array.isArray;
    function O(R) {
      return P(R);
    }
    function ne(R) {
      {
        var ue = typeof Symbol == "function" && Symbol.toStringTag, Ae = ue && R[Symbol.toStringTag] || R.constructor.name || "Object";
        return Ae;
      }
    }
    function le(R) {
      try {
        return de(R), !1;
      } catch {
        return !0;
      }
    }
    function de(R) {
      return "" + R;
    }
    function Pe(R) {
      if (le(R))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ne(R)), de(R);
    }
    var ve = v.ReactCurrentOwner, Le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Re, Ke;
    function mt(R) {
      if (X.call(R, "ref")) {
        var ue = Object.getOwnPropertyDescriptor(R, "ref").get;
        if (ue && ue.isReactWarning)
          return !1;
      }
      return R.ref !== void 0;
    }
    function pt(R) {
      if (X.call(R, "key")) {
        var ue = Object.getOwnPropertyDescriptor(R, "key").get;
        if (ue && ue.isReactWarning)
          return !1;
      }
      return R.key !== void 0;
    }
    function Nt(R, ue) {
      typeof R.ref == "string" && ve.current;
    }
    function ye(R, ue) {
      {
        var Ae = function() {
          Re || (Re = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
        };
        Ae.isReactWarning = !0, Object.defineProperty(R, "key", {
          get: Ae,
          configurable: !0
        });
      }
    }
    function _e(R, ue) {
      {
        var Ae = function() {
          Ke || (Ke = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
        };
        Ae.isReactWarning = !0, Object.defineProperty(R, "ref", {
          get: Ae,
          configurable: !0
        });
      }
    }
    var we = function(R, ue, Ae, Ve, ct, yt, rt) {
      var tt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: R,
        key: ue,
        ref: Ae,
        props: rt,
        // Record the component responsible for creating this element.
        _owner: yt
      };
      return tt._store = {}, Object.defineProperty(tt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(tt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ve
      }), Object.defineProperty(tt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ct
      }), Object.freeze && (Object.freeze(tt.props), Object.freeze(tt)), tt;
    };
    function $e(R, ue, Ae, Ve, ct) {
      {
        var yt, rt = {}, tt = null, Te = null;
        Ae !== void 0 && (Pe(Ae), tt = "" + Ae), pt(ue) && (Pe(ue.key), tt = "" + ue.key), mt(ue) && (Te = ue.ref, Nt(ue, ct));
        for (yt in ue)
          X.call(ue, yt) && !Le.hasOwnProperty(yt) && (rt[yt] = ue[yt]);
        if (R && R.defaultProps) {
          var Q = R.defaultProps;
          for (yt in Q)
            rt[yt] === void 0 && (rt[yt] = Q[yt]);
        }
        if (tt || Te) {
          var Se = typeof R == "function" ? R.displayName || R.name || "Unknown" : R;
          tt && ye(rt, Se), Te && _e(rt, Se);
        }
        return we(R, tt, Te, ct, Ve, ve.current, rt);
      }
    }
    var Xe = v.ReactCurrentOwner, Be = v.ReactDebugCurrentFrame;
    function et(R) {
      if (R) {
        var ue = R._owner, Ae = K(R.type, R._source, ue ? ue.type : null);
        Be.setExtraStackFrame(Ae);
      } else
        Be.setExtraStackFrame(null);
    }
    var dt;
    dt = !1;
    function ut(R) {
      return typeof R == "object" && R !== null && R.$$typeof === e;
    }
    function Pt() {
      {
        if (Xe.current) {
          var R = V(Xe.current.type);
          if (R)
            return `

Check the render method of \`` + R + "`.";
        }
        return "";
      }
    }
    function Vt(R) {
      return "";
    }
    var kt = {};
    function sn(R) {
      {
        var ue = Pt();
        if (!ue) {
          var Ae = typeof R == "string" ? R : R.displayName || R.name;
          Ae && (ue = `

Check the top-level render call using <` + Ae + ">.");
        }
        return ue;
      }
    }
    function Sn(R, ue) {
      {
        if (!R._store || R._store.validated || R.key != null)
          return;
        R._store.validated = !0;
        var Ae = sn(ue);
        if (kt[Ae])
          return;
        kt[Ae] = !0;
        var Ve = "";
        R && R._owner && R._owner !== Xe.current && (Ve = " It was passed a child from " + V(R._owner.type) + "."), et(R), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ae, Ve), et(null);
      }
    }
    function ht(R, ue) {
      {
        if (typeof R != "object")
          return;
        if (O(R))
          for (var Ae = 0; Ae < R.length; Ae++) {
            var Ve = R[Ae];
            ut(Ve) && Sn(Ve, ue);
          }
        else if (ut(R))
          R._store && (R._store.validated = !0);
        else if (R) {
          var ct = g(R);
          if (typeof ct == "function" && ct !== R.entries)
            for (var yt = ct.call(R), rt; !(rt = yt.next()).done; )
              ut(rt.value) && Sn(rt.value, ue);
        }
      }
    }
    function gn(R) {
      {
        var ue = R.type;
        if (ue == null || typeof ue == "string")
          return;
        var Ae;
        if (typeof ue == "function")
          Ae = ue.propTypes;
        else if (typeof ue == "object" && (ue.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ue.$$typeof === d))
          Ae = ue.propTypes;
        else
          return;
        if (Ae) {
          var Ve = V(ue);
          S(Ae, R.props, "prop", Ve, R);
        } else if (ue.PropTypes !== void 0 && !dt) {
          dt = !0;
          var ct = V(ue);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ct || "Unknown");
        }
        typeof ue.getDefaultProps == "function" && !ue.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Jn(R) {
      {
        for (var ue = Object.keys(R.props), Ae = 0; Ae < ue.length; Ae++) {
          var Ve = ue[Ae];
          if (Ve !== "children" && Ve !== "key") {
            et(R), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ve), et(null);
            break;
          }
        }
        R.ref !== null && (et(R), k("Invalid attribute `ref` supplied to `React.Fragment`."), et(null));
      }
    }
    var Er = {};
    function ca(R, ue, Ae, Ve, ct, yt) {
      {
        var rt = D(R);
        if (!rt) {
          var tt = "";
          (R === void 0 || typeof R == "object" && R !== null && Object.keys(R).length === 0) && (tt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Te = Vt();
          Te ? tt += Te : tt += Pt();
          var Q;
          R === null ? Q = "null" : O(R) ? Q = "array" : R !== void 0 && R.$$typeof === e ? (Q = "<" + (V(R.type) || "Unknown") + " />", tt = " Did you accidentally export a JSX literal instead of a component?") : Q = typeof R, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Q, tt);
        }
        var Se = $e(R, ue, Ae, ct, yt);
        if (Se == null)
          return Se;
        if (rt) {
          var Fe = ue.children;
          if (Fe !== void 0)
            if (Ve)
              if (O(Fe)) {
                for (var Rt = 0; Rt < Fe.length; Rt++)
                  ht(Fe[Rt], R);
                Object.freeze && Object.freeze(Fe);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ht(Fe, R);
        }
        if (X.call(ue, "key")) {
          var Qt = V(R), Dt = Object.keys(ue).filter(function(xs) {
            return xs !== "key";
          }), Ln = Dt.length > 0 ? "{key: someKey, " + Dt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Er[Qt + Ln]) {
            var vi = Dt.length > 0 ? "{" + Dt.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ln, Qt, vi, Qt), Er[Qt + Ln] = !0;
          }
        }
        return R === r ? Jn(Se) : gn(Se), Se;
      }
    }
    function ur(R, ue, Ae) {
      return ca(R, ue, Ae, !0);
    }
    function Co(R, ue, Ae) {
      return ca(R, ue, Ae, !1);
    }
    var jl = Co, Nl = ur;
    vm.Fragment = r, vm.jsx = jl, vm.jsxs = Nl;
  }()), vm;
}
process.env.NODE_ENV === "production" ? P7.exports = oue() : P7.exports = sue();
var T = P7.exports;
function kF(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number") r += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var i = t.length;
    for (e = 0; e < i; e++) t[e] && (n = kF(t[e])) && (r && (r += " "), r += n);
  } else for (n in t) t[n] && (r && (r += " "), r += n);
  return r;
}
function un() {
  for (var t, e, n = 0, r = "", i = arguments.length; n < i; n++) (t = arguments[n]) && (e = kF(t)) && (r && (r += " "), r += e);
  return r;
}
const Rx = "-";
function lue(t) {
  const e = uue(t), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = t;
  function i(o) {
    const s = o.split(Rx);
    return s[0] === "" && s.length !== 1 && s.shift(), xF(s, e) || cue(o);
  }
  function a(o, s) {
    const l = n[o] || [];
    return s && r[o] ? [...l, ...r[o]] : l;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: a
  };
}
function xF(t, e) {
  var n;
  if (t.length === 0)
    return e.classGroupId;
  const r = t[0], i = e.nextPart.get(r), a = i ? xF(t.slice(1), i) : void 0;
  if (a)
    return a;
  if (e.validators.length === 0)
    return;
  const o = t.join(Rx);
  return (n = e.validators.find(({
    validator: s
  }) => s(o))) == null ? void 0 : n.classGroupId;
}
const LE = /^\[(.+)\]$/;
function cue(t) {
  if (LE.test(t)) {
    const e = LE.exec(t)[1], n = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function uue(t) {
  const {
    theme: e,
    prefix: n
  } = t, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return fue(Object.entries(t.classGroups), n).forEach(([i, a]) => {
    z7(a, r, i, e);
  }), r;
}
function z7(t, e, n, r) {
  t.forEach((i) => {
    if (typeof i == "string") {
      const a = i === "" ? e : TE(e, i);
      a.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (due(i)) {
        z7(i(r), e, n, r);
        return;
      }
      e.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([a, o]) => {
      z7(o, TE(e, a), n, r);
    });
  });
}
function TE(t, e) {
  let n = t;
  return e.split(Rx).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function due(t) {
  return t.isThemeGetter;
}
function fue(t, e) {
  return e ? t.map(([n, r]) => {
    const i = r.map((a) => typeof a == "string" ? e + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([o, s]) => [e + o, s])) : a);
    return [n, i];
  }) : t;
}
function hue(t) {
  if (t < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function i(a, o) {
    n.set(a, o), e++, e > t && (e = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get(a) {
      let o = n.get(a);
      if (o !== void 0)
        return o;
      if ((o = r.get(a)) !== void 0)
        return i(a, o), o;
    },
    set(a, o) {
      n.has(a) ? n.set(a, o) : i(a, o);
    }
  };
}
const MF = "!";
function pue(t) {
  const {
    separator: e,
    experimentalParseClassName: n
  } = t, r = e.length === 1, i = e[0], a = e.length;
  function o(s) {
    const l = [];
    let c = 0, u = 0, d;
    for (let g = 0; g < s.length; g++) {
      let v = s[g];
      if (c === 0) {
        if (v === i && (r || s.slice(g, g + a) === e)) {
          l.push(s.slice(u, g)), u = g + a;
          continue;
        }
        if (v === "/") {
          d = g;
          continue;
        }
      }
      v === "[" ? c++ : v === "]" && c--;
    }
    const f = l.length === 0 ? s : s.substring(u), h = f.startsWith(MF), p = h ? f.substring(1) : f, m = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: p,
      maybePostfixModifierPosition: m
    };
  }
  return n ? function(s) {
    return n({
      className: s,
      parseClassName: o
    });
  } : o;
}
function mue(t) {
  if (t.length <= 1)
    return t;
  const e = [];
  let n = [];
  return t.forEach((r) => {
    r[0] === "[" ? (e.push(...n.sort(), r), n = []) : n.push(r);
  }), e.push(...n.sort()), e;
}
function yue(t) {
  return {
    cache: hue(t.cacheSize),
    parseClassName: pue(t),
    ...lue(t)
  };
}
const gue = /\s+/;
function vue(t, e) {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i
  } = e, a = /* @__PURE__ */ new Set();
  return t.trim().split(gue).map((o) => {
    const {
      modifiers: s,
      hasImportantModifier: l,
      baseClassName: c,
      maybePostfixModifierPosition: u
    } = n(o);
    let d = !!u, f = r(d ? c.substring(0, u) : c);
    if (!f) {
      if (!d)
        return {
          isTailwindClass: !1,
          originalClassName: o
        };
      if (f = r(c), !f)
        return {
          isTailwindClass: !1,
          originalClassName: o
        };
      d = !1;
    }
    const h = mue(s).join(":");
    return {
      isTailwindClass: !0,
      modifierId: l ? h + MF : h,
      classGroupId: f,
      originalClassName: o,
      hasPostfixModifier: d
    };
  }).reverse().filter((o) => {
    if (!o.isTailwindClass)
      return !0;
    const {
      modifierId: s,
      classGroupId: l,
      hasPostfixModifier: c
    } = o, u = s + l;
    return a.has(u) ? !1 : (a.add(u), i(l, c).forEach((d) => a.add(s + d)), !0);
  }).reverse().map((o) => o.originalClassName).join(" ");
}
function bue() {
  let t = 0, e, n, r = "";
  for (; t < arguments.length; )
    (e = arguments[t++]) && (n = CF(e)) && (r && (r += " "), r += n);
  return r;
}
function CF(t) {
  if (typeof t == "string")
    return t;
  let e, n = "";
  for (let r = 0; r < t.length; r++)
    t[r] && (e = CF(t[r])) && (n && (n += " "), n += e);
  return n;
}
function wue(t, ...e) {
  let n, r, i, a = o;
  function o(l) {
    const c = e.reduce((u, d) => d(u), t());
    return n = yue(c), r = n.cache.get, i = n.cache.set, a = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const u = vue(l, n);
    return i(l, u), u;
  }
  return function() {
    return a(bue.apply(null, arguments));
  };
}
function Mn(t) {
  const e = (n) => n[t] || [];
  return e.isThemeGetter = !0, e;
}
const AF = /^\[(?:([a-z-]+):)?(.+)\]$/i, kue = /^\d+\/\d+$/, xue = /* @__PURE__ */ new Set(["px", "full", "screen"]), Mue = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Cue = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Aue = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Sue = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Lue = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function Cs(t) {
  return Mu(t) || xue.has(t) || kue.test(t);
}
function Il(t) {
  return Md(t, "length", zue);
}
function Mu(t) {
  return !!t && !Number.isNaN(Number(t));
}
function bm(t) {
  return Md(t, "number", Mu);
}
function rf(t) {
  return !!t && Number.isInteger(Number(t));
}
function Tue(t) {
  return t.endsWith("%") && Mu(t.slice(0, -1));
}
function qt(t) {
  return AF.test(t);
}
function Pl(t) {
  return Mue.test(t);
}
const Eue = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function jue(t) {
  return Md(t, Eue, SF);
}
function Nue(t) {
  return Md(t, "position", SF);
}
const Due = /* @__PURE__ */ new Set(["image", "url"]);
function Iue(t) {
  return Md(t, Due, Oue);
}
function Pue(t) {
  return Md(t, "", Rue);
}
function af() {
  return !0;
}
function Md(t, e, n) {
  const r = AF.exec(t);
  return r ? r[1] ? typeof e == "string" ? r[1] === e : e.has(r[1]) : n(r[2]) : !1;
}
function zue(t) {
  return Cue.test(t) && !Aue.test(t);
}
function SF() {
  return !1;
}
function Rue(t) {
  return Sue.test(t);
}
function Oue(t) {
  return Lue.test(t);
}
function Bue() {
  const t = Mn("colors"), e = Mn("spacing"), n = Mn("blur"), r = Mn("brightness"), i = Mn("borderColor"), a = Mn("borderRadius"), o = Mn("borderSpacing"), s = Mn("borderWidth"), l = Mn("contrast"), c = Mn("grayscale"), u = Mn("hueRotate"), d = Mn("invert"), f = Mn("gap"), h = Mn("gradientColorStops"), p = Mn("gradientColorStopPositions"), m = Mn("inset"), g = Mn("margin"), v = Mn("opacity"), k = Mn("padding"), w = Mn("saturate"), b = Mn("scale"), x = Mn("sepia"), A = Mn("skew"), L = Mn("space"), M = Mn("translate"), j = () => ["auto", "contain", "none"], D = () => ["auto", "hidden", "clip", "visible", "scroll"], z = () => ["auto", qt, e], H = () => [qt, e], V = () => ["", Cs, Il], F = () => ["auto", Mu, qt], _ = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], W = () => ["solid", "dashed", "dotted", "double", "none"], G = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], Y = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], Z = () => ["", "0", qt], oe = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], ee = () => [Mu, bm], ae = () => [Mu, qt];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [af],
      spacing: [Cs, Il],
      blur: ["none", "", Pl, qt],
      brightness: ee(),
      borderColor: [t],
      borderRadius: ["none", "", "full", Pl, qt],
      borderSpacing: H(),
      borderWidth: V(),
      contrast: ee(),
      grayscale: Z(),
      hueRotate: ae(),
      invert: Z(),
      gap: H(),
      gradientColorStops: [t],
      gradientColorStopPositions: [Tue, Il],
      inset: z(),
      margin: z(),
      opacity: ee(),
      padding: H(),
      saturate: ee(),
      scale: ee(),
      sepia: Z(),
      skew: ae(),
      space: H(),
      translate: H()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", qt]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Pl]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": oe()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": oe()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [..._(), qt]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: D()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": D()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": D()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: j()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": j()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": j()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", rf, qt]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: z()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", qt]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Z()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Z()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", rf, qt]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [af]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", rf, qt]
        }, qt]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": F()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": F()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [af]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [rf, qt]
        }, qt]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": F()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": F()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", qt]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", qt]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...Y()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...Y(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...Y(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [k]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [k]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [k]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [k]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [k]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [k]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [k]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [k]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [k]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [g]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [g]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [g]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [g]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [g]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [g]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [g]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [g]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [g]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [L]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [L]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", qt, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [qt, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [qt, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [Pl]
        }, Pl]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [qt, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [qt, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [qt, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [qt, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Pl, Il]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", bm]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [af]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", qt]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Mu, bm]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Cs, qt]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", qt]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", qt]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...W(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Cs, Il]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Cs, qt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: H()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", qt]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", qt]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [..._(), Nue]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", jue]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Iue]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...W(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: W()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...W()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Cs, qt]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Cs, Il]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: V()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Cs, Il]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Pl, Pue]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [af]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...G(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": G()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Pl, qt]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [x]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [x]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", qt]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: ae()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", qt]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: ae()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", qt]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [b]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [b]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [b]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [rf, qt]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [M]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [M]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [A]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [A]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", qt]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", qt]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": H()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": H()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": H()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": H()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": H()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": H()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": H()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": H()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": H()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": H()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": H()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": H()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": H()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": H()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": H()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": H()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": H()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": H()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", qt]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Cs, Il, bm]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const Hue = /* @__PURE__ */ wue(Bue);
function be(...t) {
  return Hue(un(t));
}
const Fue = (t) => {
  const e = t.replace("#", ""), n = parseInt(e.substr(0, 2), 16), r = parseInt(e.substr(2, 2), 16), i = parseInt(e.substr(4, 2), 16);
  return (n * 299 + r * 587 + i * 114) / 1e3 < 128;
};
function LF(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number") r += t;
  else if (typeof t == "object") if (Array.isArray(t)) for (e = 0; e < t.length; e++) t[e] && (n = LF(t[e])) && (r && (r += " "), r += n);
  else for (e in t) t[e] && (r && (r += " "), r += e);
  return r;
}
function _ue() {
  for (var t, e, n = 0, r = ""; n < arguments.length; ) (t = arguments[n++]) && (e = LF(t)) && (r && (r += " "), r += e);
  return r;
}
const EE = (t) => typeof t == "boolean" ? "".concat(t) : t === 0 ? "0" : t, jE = _ue, Ha = (t, e) => (n) => {
  var r;
  if ((e == null ? void 0 : e.variants) == null) return jE(t, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: i, defaultVariants: a } = e, o = Object.keys(i).map((c) => {
    const u = n == null ? void 0 : n[c], d = a == null ? void 0 : a[c];
    if (u === null) return null;
    const f = EE(u) || EE(d);
    return i[c][f];
  }), s = n && Object.entries(n).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = e == null || (r = e.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...h } = u;
    return Object.entries(h).every((p) => {
      let [m, g] = p;
      return Array.isArray(g) ? g.includes({
        ...a,
        ...s
      }[m]) : {
        ...a,
        ...s
      }[m] === g;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return jE(t, o, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Vue = "data:image/jpeg;base64,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", que = (t) => t.charAt(0).toUpperCase(), NE = Ha("object-cover aspect-square", {
  variants: {
    variant: {
      rounded: "rounded-full drop-shadow",
      square: ""
    },
    size: {
      sm: "w-4 avatar-sm text-[10px]",
      md: "w-6 avatar-sm text-[14px]",
      lg: "w-10 avatar-sm text-[16px]",
      xl: "w-16 avatar-lg text-[20px]",
      "2xl": "w-24 avatar-lg text-[24px]",
      "3xl": "w-32 avatar-lg text-[32px]"
    },
    bordered: {
      border: "border-[#ffffff]",
      none: "border-none"
    },
    content: {
      image: "",
      text: "color-bg-tertiary color-text-secondary flex items-center justify-center"
    }
  },
  defaultVariants: {
    variant: "rounded",
    size: "md",
    bordered: "none",
    content: "image"
  }
}), ap = Ce.forwardRef(
  ({ src: t, alt: e, className: n, variant: r, size: i, bordered: a, content: o = "image", ...s }, l) => o === "image" ? /* @__PURE__ */ T.jsx(
    "img",
    {
      src: t || Vue,
      alt: e,
      className: be(NE({ variant: r, size: i, bordered: a }), n),
      ref: l,
      ...s
    }
  ) : /* @__PURE__ */ T.jsx(
    "div",
    {
      className: be(
        "font-[700]",
        NE({ variant: r, size: i, bordered: a, content: o }),
        n
      ),
      ref: l,
      ...s,
      children: que(e || "")
    }
  )
);
ap.displayName = "Avatar";
en(
  ({
    avatars: t,
    size: e = "lg",
    variant: n = "rounded",
    bordered: r = "none",
    className: i,
    content: a,
    showCounter: o = !0
  }, s) => {
    const l = t.slice(0, 5), c = t.length;
    return /* @__PURE__ */ T.jsxs("div", { ref: s, className: be("flex items-center gap-3", i), children: [
      /* @__PURE__ */ T.jsx(
        "div",
        {
          className: be("flex overflow-hidden p-0.5", {
            "-space-x-1": e === "sm",
            "-space-x-2": e === "md" || e === "lg",
            "-space-x-4": e === "xl" || e === "2xl" || e === "3xl"
          }),
          children: l.map((u, d) => /* @__PURE__ */ T.jsx(
            ap,
            {
              ...u,
              content: a,
              alt: u.alt || "",
              size: u.size || e,
              variant: u.variant || n,
              bordered: u.bordered || r,
              className: be("inline-flex items-center", u.className)
            },
            d
          ))
        }
      ),
      o && c > 5 && /* @__PURE__ */ T.jsxs(
        "div",
        {
          className: be("color-text-secondary", {
            "text-helper-text-sm": e === "sm" || e === "md",
            "text-body-sm": e === "lg",
            "text-body-md": e === "xl",
            "text-heading-md": e === "2xl" || e === "3xl"
          }),
          children: [
            c,
            " members"
          ]
        }
      )
    ] });
  }
);
const Uue = {
  File3d: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M6 23H18C19.6569 23 21 21.6569 21 20V7L15 1H6C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23Z",
            fill: "#E77B24",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M9.02615 13.0426C9.13756 13.0518 9.25623 13.0518 9.38217 13.0426C9.50811 13.0335 9.62435 13.0083 9.73092 12.967C9.84232 12.9211 9.93193 12.8569 9.99974 12.7744C10.0724 12.6919 10.1087 12.5818 10.1087 12.4443C10.1087 12.238 10.0361 12.0798 9.89076 11.9697C9.74545 11.8597 9.57834 11.8047 9.38943 11.8047C9.12787 11.8047 8.92928 11.8872 8.79366 12.0523C8.66288 12.2127 8.59991 12.4168 8.60475 12.6644H7.6239C7.63358 12.4168 7.6796 12.1921 7.76194 11.9904C7.84913 11.784 7.9678 11.6075 8.11796 11.4608C8.27296 11.3141 8.45702 11.2017 8.67014 11.1238C8.88327 11.0413 9.12061 11 9.38217 11C9.58561 11 9.78904 11.0298 9.99248 11.0894C10.1959 11.1444 10.3776 11.2293 10.5374 11.3439C10.7021 11.4585 10.8353 11.5983 10.937 11.7634C11.0387 11.9285 11.0896 12.1188 11.0896 12.3343C11.0896 12.5681 11.029 12.7744 10.9079 12.9532C10.7917 13.132 10.6149 13.2536 10.3776 13.3177V13.3315C10.6585 13.3911 10.8789 13.5195 11.0387 13.7166C11.1986 13.9138 11.2785 14.1499 11.2785 14.425C11.2785 14.6772 11.2252 14.9019 11.1186 15.099C11.0169 15.2962 10.8789 15.4613 10.7045 15.5942C10.5301 15.7272 10.3291 15.8281 10.1015 15.8968C9.87381 15.9656 9.63646 16 9.38943 16C9.10365 16 8.84209 15.961 8.60475 15.8831C8.37225 15.8051 8.17366 15.6928 8.00897 15.5461C7.84429 15.3948 7.71593 15.2114 7.6239 14.9959C7.53671 14.7804 7.49554 14.5328 7.50038 14.2531H8.48124C8.48608 14.3815 8.50788 14.5053 8.54663 14.6245C8.58538 14.7391 8.64108 14.84 8.71373 14.9271C8.78639 15.0096 8.876 15.0761 8.98256 15.1265C9.09397 15.177 9.22475 15.2022 9.3749 15.2022C9.6074 15.2022 9.80357 15.1357 9.96342 15.0028C10.1233 14.8652 10.2032 14.6795 10.2032 14.4457C10.2032 14.2623 10.1644 14.1224 10.0869 14.0261C10.0143 13.9298 9.91982 13.8611 9.80357 13.8198C9.68732 13.774 9.55896 13.7487 9.4185 13.7442C9.28287 13.735 9.15209 13.7304 9.02615 13.7304V13.0426Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M13.0488 15.0028H14.066C14.2307 15.0028 14.3906 14.9775 14.5456 14.9271C14.7006 14.8767 14.8386 14.7941 14.9597 14.6795C15.0808 14.5603 15.1777 14.4067 15.2503 14.2187C15.323 14.0307 15.3593 13.8015 15.3593 13.5309C15.3593 13.2834 15.3327 13.061 15.2794 12.8638C15.2309 12.6621 15.1486 12.4901 15.0324 12.348C14.9161 12.2059 14.7611 12.0981 14.5674 12.0248C14.3784 11.9468 14.1435 11.9078 13.8626 11.9078H13.0488V15.0028ZM11.9082 11H14.146C14.4802 11 14.7902 11.0504 15.0759 11.1513C15.3666 11.2522 15.616 11.4035 15.8243 11.6052C16.0374 11.807 16.2021 12.0591 16.3184 12.3618C16.4395 12.6644 16.5 13.0197 16.5 13.4278C16.5 13.7854 16.4516 14.1155 16.3547 14.4182C16.2578 14.7208 16.1101 14.9821 15.9115 15.2022C15.7177 15.4223 15.4731 15.5965 15.1777 15.7249C14.887 15.8487 14.5431 15.9106 14.146 15.9106H11.9082V11Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "#E77B24",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "black",
            fillOpacity: "0.2",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  FileWord: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M6 23H18C19.6569 23 21 21.6569 21 20V7L15 1H6C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23Z",
            fill: "#0067CD",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "#0067CD",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "black",
            fillOpacity: "0.2",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M6.87484 15.0094H7.65496C7.78126 15.0094 7.90385 14.9848 8.02272 14.9357C8.1416 14.8867 8.24747 14.8063 8.34034 14.6948C8.43321 14.5788 8.50751 14.4293 8.56323 14.2463C8.61895 14.0634 8.64682 13.8403 8.64682 13.577C8.64682 13.336 8.62638 13.1196 8.58552 12.9277C8.54837 12.7314 8.48522 12.564 8.39606 12.4257C8.30691 12.2874 8.18803 12.1825 8.03944 12.1111C7.89456 12.0353 7.71439 11.9973 7.49893 11.9973H6.87484V15.0094ZM6 11.1138H7.71625C7.97257 11.1138 8.21032 11.1629 8.4295 11.261C8.65239 11.3592 8.8437 11.5065 9.00344 11.7028C9.16689 11.8992 9.2932 12.1446 9.38235 12.4391C9.47522 12.7336 9.52166 13.0794 9.52166 13.4766C9.52166 13.8246 9.48451 14.1459 9.41021 14.4404C9.33592 14.7349 9.22261 14.9893 9.07031 15.2035C8.92171 15.4177 8.73411 15.5872 8.50751 15.7122C8.28462 15.8327 8.02087 15.8929 7.71625 15.8929H6V11.1138Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M10.8323 13.5234C10.8323 13.7242 10.8509 13.9206 10.888 14.1124C10.9289 14.2999 10.992 14.4694 11.0775 14.6212C11.1629 14.7729 11.2744 14.8956 11.4118 14.9893C11.5493 15.0785 11.7164 15.1232 11.9133 15.1232C12.1102 15.1232 12.2774 15.0785 12.4148 14.9893C12.5523 14.8956 12.6637 14.7729 12.7492 14.6212C12.8346 14.4694 12.8959 14.2999 12.933 14.1124C12.9739 13.9206 12.9943 13.7242 12.9943 13.5234C12.9943 13.3137 12.9739 13.1107 12.933 12.9143C12.8959 12.718 12.8346 12.544 12.7492 12.3922C12.6637 12.2361 12.5523 12.1133 12.4148 12.0241C12.2774 11.9304 12.1102 11.8835 11.9133 11.8835C11.7164 11.8835 11.5493 11.9304 11.4118 12.0241C11.2744 12.1133 11.1629 12.2361 11.0775 12.3922C10.992 12.544 10.9289 12.718 10.888 12.9143C10.8509 13.1107 10.8323 13.3137 10.8323 13.5234ZM9.95747 13.5234C9.95747 13.1664 10.002 12.8362 10.0912 12.5328C10.1804 12.2249 10.3085 11.9572 10.4757 11.7296C10.6429 11.502 10.8472 11.3235 11.0886 11.1941C11.3338 11.0647 11.6087 11 11.9133 11C12.2217 11 12.4966 11.0647 12.738 11.1941C12.9795 11.3235 13.1838 11.502 13.351 11.7296C13.5181 11.9572 13.6463 12.2249 13.7354 12.5328C13.8246 12.8362 13.8692 13.1664 13.8692 13.5234C13.8692 13.8715 13.8246 14.1972 13.7354 14.5007C13.6463 14.7996 13.5181 15.0607 13.351 15.2838C13.1838 15.5069 12.9795 15.6832 12.738 15.8126C12.4966 15.9375 12.2217 16 11.9133 16C11.6087 16 11.3338 15.9375 11.0886 15.8126C10.8472 15.6832 10.6429 15.5069 10.4757 15.2838C10.3085 15.0607 10.1804 14.7996 10.0912 14.5007C10.002 14.1972 9.95747 13.8715 9.95747 13.5234Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M17.1196 12.7202C17.1047 12.5997 17.0713 12.4904 17.0193 12.3922C16.9673 12.2896 16.9023 12.2004 16.8243 12.1245C16.7462 12.0486 16.6571 11.9906 16.5568 11.9505C16.4602 11.9058 16.358 11.8835 16.2503 11.8835C16.0534 11.8835 15.8863 11.9304 15.7488 12.0241C15.6114 12.1133 15.4999 12.2361 15.4145 12.3922C15.329 12.544 15.2659 12.718 15.225 12.9143C15.1879 13.1107 15.1693 13.3137 15.1693 13.5234C15.1693 13.7242 15.1879 13.9206 15.225 14.1124C15.2659 14.2999 15.329 14.4694 15.4145 14.6212C15.4999 14.7729 15.6114 14.8956 15.7488 14.9893C15.8863 15.0785 16.0534 15.1232 16.2503 15.1232C16.5178 15.1232 16.7258 15.025 16.8744 14.8286C17.0267 14.6323 17.1196 14.3735 17.153 14.0522H18C17.9777 14.3512 17.9201 14.6212 17.8273 14.8621C17.7344 15.1031 17.6118 15.3083 17.4595 15.4779C17.3072 15.6475 17.1289 15.7769 16.9246 15.8661C16.7202 15.9554 16.4955 16 16.2503 16C15.9457 16 15.6708 15.9375 15.4256 15.8126C15.1842 15.6832 14.9798 15.5069 14.8127 15.2838C14.6455 15.0607 14.5173 14.7996 14.4282 14.5007C14.339 14.1972 14.2945 13.8715 14.2945 13.5234C14.2945 13.1664 14.339 12.8362 14.4282 12.5328C14.5173 12.2249 14.6455 11.9572 14.8127 11.7296C14.9798 11.502 15.1842 11.3235 15.4256 11.1941C15.6708 11.0647 15.9457 11 16.2503 11C16.4695 11 16.6757 11.0379 16.8688 11.1138C17.0657 11.1896 17.2403 11.3012 17.3926 11.4485C17.5486 11.5913 17.6768 11.7697 17.7771 11.9839C17.8774 12.1981 17.9406 12.4436 17.9666 12.7202H17.1196Z",
            fill: "white",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  FilePdf: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M6 23H18C19.6569 23 21 21.6569 21 20V7L15 1H6C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23Z",
            fill: "#FB3449",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "#C41124",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M6.98628 13.3529H7.75269C7.86577 13.3529 7.97466 13.3436 8.07936 13.3249C8.18406 13.3063 8.2762 13.2712 8.35577 13.2199C8.43534 13.1639 8.49816 13.0868 8.54423 12.9888C8.59449 12.8908 8.61962 12.7624 8.61962 12.6036C8.61962 12.4449 8.59449 12.3165 8.54423 12.2185C8.49816 12.1204 8.43534 12.0458 8.35577 11.9944C8.2762 11.9384 8.18406 11.901 8.07936 11.8824C7.97466 11.8637 7.86577 11.8543 7.75269 11.8543H6.98628V13.3529ZM6 11H8.02282C8.30342 11 8.54214 11.0467 8.73898 11.1401C8.93581 11.2288 9.09496 11.3478 9.21641 11.4972C9.34205 11.6466 9.4321 11.817 9.48654 12.0084C9.54517 12.1998 9.57449 12.3982 9.57449 12.6036C9.57449 12.8044 9.54517 13.0028 9.48654 13.1989C9.4321 13.3903 9.34205 13.5607 9.21641 13.7101C9.09496 13.8595 8.93581 13.9809 8.73898 14.0742C8.54214 14.1629 8.30342 14.2073 8.02282 14.2073H6.98628V16H6V11Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M11.1764 15.0756H12.0559C12.1982 15.0756 12.3365 15.05 12.4705 14.9986C12.6045 14.9472 12.7238 14.8632 12.8285 14.7465C12.9332 14.6251 13.017 14.4687 13.0798 14.2773C13.1426 14.0859 13.1741 13.8525 13.1741 13.577C13.1741 13.3249 13.151 13.0985 13.105 12.8978C13.0631 12.6923 12.9919 12.5173 12.8914 12.3725C12.7909 12.2278 12.6568 12.1181 12.4893 12.0434C12.326 11.9641 12.1229 11.9244 11.88 11.9244H11.1764V15.0756ZM10.1901 11H12.125C12.4139 11 12.682 11.0514 12.9291 11.1541C13.1803 11.2568 13.396 11.4108 13.5761 11.6162C13.7604 11.8217 13.9028 12.0784 14.0033 12.3866C14.108 12.6947 14.1603 13.0565 14.1603 13.472C14.1603 13.8361 14.1185 14.1723 14.0347 14.4804C13.9509 14.7885 13.8232 15.0546 13.6515 15.2787C13.484 15.5028 13.2725 15.6802 13.017 15.8109C12.7657 15.937 12.4684 16 12.125 16H10.1901V11Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M14.8464 11H18V11.9244H15.8327V13.0798H17.711V13.9342H15.8327V16H14.8464V11Z",
            fill: "white",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  FilePpt: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M6 23H18C19.6569 23 21 21.6569 21 20V7L15 1H6C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23Z",
            fill: "#DF3114",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "#DF3114",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "black",
            fillOpacity: "0.2",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M7.01128 13.3529H7.79712C7.91306 13.3529 8.02471 13.3436 8.13206 13.3249C8.23942 13.3063 8.33389 13.2712 8.41548 13.2199C8.49707 13.1639 8.56148 13.0868 8.60872 12.9888C8.66025 12.8908 8.68601 12.7624 8.68601 12.6036C8.68601 12.4449 8.66025 12.3165 8.60872 12.2185C8.56148 12.1204 8.49707 12.0458 8.41548 11.9944C8.33389 11.9384 8.23942 11.901 8.13206 11.8824C8.02471 11.8637 7.91306 11.8543 7.79712 11.8543H7.01128V13.3529ZM6 11H8.07409C8.3618 11 8.60657 11.0467 8.8084 11.1401C9.01022 11.2288 9.1734 11.3478 9.29793 11.4972C9.42676 11.6466 9.51908 11.817 9.57491 12.0084C9.63503 12.1998 9.66509 12.3982 9.66509 12.6036C9.66509 12.8044 9.63503 13.0028 9.57491 13.1989C9.51908 13.3903 9.42676 13.5607 9.29793 13.7101C9.1734 13.8595 9.01022 13.9809 8.8084 14.0742C8.60657 14.1629 8.3618 14.2073 8.07409 14.2073H7.01128V16H6V11Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M11.3076 13.3529H12.0934C12.2093 13.3529 12.321 13.3436 12.4283 13.3249C12.5357 13.3063 12.6302 13.2712 12.7118 13.2199C12.7934 13.1639 12.8578 13.0868 12.905 12.9888C12.9565 12.8908 12.9823 12.7624 12.9823 12.6036C12.9823 12.4449 12.9565 12.3165 12.905 12.2185C12.8578 12.1204 12.7934 12.0458 12.7118 11.9944C12.6302 11.9384 12.5357 11.901 12.4283 11.8824C12.321 11.8637 12.2093 11.8543 12.0934 11.8543H11.3076V13.3529ZM10.2963 11H12.3704C12.6581 11 12.9029 11.0467 13.1047 11.1401C13.3065 11.2288 13.4697 11.3478 13.5942 11.4972C13.723 11.6466 13.8154 11.817 13.8712 12.0084C13.9313 12.1998 13.9614 12.3982 13.9614 12.6036C13.9614 12.8044 13.9313 13.0028 13.8712 13.1989C13.8154 13.3903 13.723 13.5607 13.5942 13.7101C13.4697 13.8595 13.3065 13.9809 13.1047 14.0742C12.9029 14.1629 12.6581 14.2073 12.3704 14.2073H11.3076V16H10.2963V11Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M15.6103 11.9244H14.2319V11H18V11.9244H16.6216V16H15.6103V11.9244Z",
            fill: "white",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  FileExcel: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M6 23H18C19.6569 23 21 21.6569 21 20V7L15 1H6C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23Z",
            fill: "#317C38",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M7.58115 13.3896L6.12065 11.1138H7.27635L8.16535 12.6399L9.0861 11.1138H10.1783L8.72415 13.3963L10.3053 15.8929H9.11785L8.12725 14.2396L7.1176 15.8929H6L7.58115 13.3896Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M10.7053 11.1138H11.7022V15.0094H13.912V15.8929H10.7053V11.1138Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M15.1489 14.3066C15.1489 14.4672 15.1764 14.6033 15.2314 14.7149C15.2864 14.8264 15.3584 14.9179 15.4473 14.9893C15.5404 15.0562 15.6484 15.1075 15.7712 15.1432C15.8939 15.1745 16.0209 15.1901 16.1522 15.1901C16.2411 15.1901 16.3363 15.1834 16.4379 15.17C16.5395 15.1522 16.6348 15.1209 16.7237 15.0763C16.8126 15.0317 16.8866 14.9714 16.9459 14.8956C17.0052 14.8153 17.0348 14.7149 17.0348 14.5944C17.0348 14.465 16.9946 14.3601 16.9142 14.2798C16.838 14.1995 16.7364 14.1325 16.6094 14.079C16.4824 14.0254 16.3384 13.9786 16.1776 13.9384C16.0167 13.8983 15.8537 13.8536 15.6886 13.8046C15.5193 13.7599 15.3542 13.7064 15.1933 13.6439C15.0324 13.577 14.8885 13.4922 14.7615 13.3896C14.6345 13.2869 14.5308 13.1597 14.4504 13.008C14.3742 12.8519 14.3361 12.6644 14.3361 12.4458C14.3361 12.2004 14.3847 11.9884 14.4821 11.8099C14.5837 11.627 14.7149 11.4752 14.8758 11.3548C15.0367 11.2343 15.2187 11.145 15.4219 11.087C15.6251 11.029 15.8283 11 16.0315 11C16.2686 11 16.4951 11.029 16.711 11.087C16.9311 11.1406 17.1258 11.2298 17.2952 11.3548C17.4645 11.4797 17.5978 11.6403 17.6952 11.8367C17.7968 12.0286 17.8476 12.2628 17.8476 12.5395H16.8824C16.8739 12.3967 16.8443 12.2784 16.7935 12.1847C16.7469 12.091 16.6834 12.0174 16.603 11.9639C16.5226 11.9103 16.4294 11.8724 16.3236 11.8501C16.222 11.8278 16.1098 11.8166 15.9871 11.8166C15.9066 11.8166 15.8262 11.8255 15.7458 11.8434C15.6653 11.8612 15.5912 11.8925 15.5235 11.9371C15.46 11.9817 15.4071 12.0375 15.3648 12.1044C15.3224 12.1714 15.3013 12.2561 15.3013 12.3588C15.3013 12.4525 15.3182 12.5283 15.3521 12.5863C15.3859 12.6444 15.4515 12.6979 15.5489 12.747C15.6505 12.7961 15.7881 12.8452 15.9617 12.8942C16.1395 12.9433 16.3702 13.0058 16.6538 13.0817C16.7385 13.0995 16.8549 13.133 17.0031 13.1821C17.1555 13.2267 17.3057 13.3003 17.4539 13.4029C17.6021 13.5056 17.7291 13.6439 17.8349 13.8179C17.945 13.9875 18 14.2062 18 14.4739C18 14.6925 17.9598 14.8956 17.8794 15.083C17.7989 15.2704 17.6783 15.4333 17.5174 15.5716C17.3608 15.7055 17.1639 15.8104 16.9269 15.8862C16.694 15.9621 16.4231 16 16.1141 16C15.8643 16 15.6209 15.9665 15.3838 15.8996C15.151 15.8371 14.9435 15.7367 14.7615 15.5984C14.5837 15.4601 14.4419 15.2838 14.3361 15.0696C14.2302 14.8554 14.1794 14.6011 14.1837 14.3066H15.1489Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "#27632D",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  Section: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M4 2C2.89543 2 2 2.89543 2 4V9C2 10.1046 2.89543 11 4 11H20C21.1046 11 22 10.1046 22 9V4C22 2.89543 21.1046 2 20 2H4Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2 15C2 13.8954 2.89543 13 4 13H9C10.1046 13 11 13.8954 11 15V20C11 21.1046 10.1046 22 9 22H4C2.89543 22 2 21.1046 2 20V15ZM9 15H4V20H9V15Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 13C13.8954 13 13 13.8954 13 15V20C13 21.1046 13.8954 22 15 22H20C21.1046 22 22 21.1046 22 20V15C22 13.8954 21.1046 13 20 13H15ZM15 15H20V20H15V15Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  XSocial: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          d: "M18.244 2.25H21.552L14.325 10.51L22.827 21.75H16.17L10.956 14.933L4.99 21.75H1.68L9.41 12.915L1.254 2.25H8.08L12.793 8.481L18.244 2.25ZM17.083 19.77H18.916L7.084 4.126H5.117L17.083 19.77Z",
          fill: "currentColor",
          stroke: "transparent"
        }
      )
    }
  ),
  Farcaster: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.94205 24.0001H18.0579C21.3344 24.0001 24 21.3347 24 18.0581V5.94228C24 2.66575 21.3344 0.00012207 18.0579 0.00012207H5.94205C2.66561 0.00012207 0 2.66575 0 5.94228V18.0581C0 21.3347 2.66561 24.0001 5.94205 24.0001Z",
            fill: "#9C7BD2",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M6.74561 5H17.0654V6.98676H20L19.385 8.97401H18.8643V17.0132C19.1254 17.0132 19.3374 17.2151 19.3374 17.4644V18.0064H19.4321C19.6938 18.0064 19.9058 18.2087 19.9058 18.4581V19H14.6035V18.4581C14.6035 18.2087 14.8155 18.0064 15.0772 18.0064H15.1719V17.4644C15.1719 17.2476 15.3323 17.0666 15.5458 17.0229L15.5358 12.5871C15.3684 10.8147 13.8071 9.4257 11.9055 9.4257C10.0039 9.4257 8.44269 10.8147 8.27529 12.5871L8.26526 17.0191C8.51787 17.055 8.82862 17.2408 8.82862 17.4644V18.0064H8.92335C9.18448 18.0064 9.39648 18.2087 9.39648 18.4581V19H4.09473V18.4581C4.09473 18.2087 4.30674 18.0064 4.56787 18.0064H4.66259V17.4644C4.66259 17.2151 4.8746 17.0132 5.13623 17.0132V8.97401H4.61548L4 6.98676H6.74561V5Z",
            fill: "white",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  Farcaster2: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsxs("g", { clipPath: "url(#clip0_2230_11557)", children: [
          /* @__PURE__ */ T.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M4.95171 20.0001H15.0483C17.7787 20.0001 20 17.7789 20 15.0484V4.95192C20 2.22148 17.7787 0.00012207 15.0483 0.00012207H4.95171C2.22134 0.00012207 0 2.22148 0 4.95192V15.0484C0 17.7789 2.22134 20.0001 4.95171 20.0001Z",
              fill: "#363B3F",
              stroke: "transparent"
            }
          ),
          /* @__PURE__ */ T.jsx(
            "path",
            {
              d: "M5.62004 4.16667H14.2199V5.8223H16.6654L16.1529 7.47834H15.7189V14.1777C15.9365 14.1777 16.1132 14.3459 16.1132 14.5537V15.0053H16.1921C16.4102 15.0053 16.5868 15.1739 16.5868 15.3817V15.8333H12.1683V15.3817C12.1683 15.1739 12.345 15.0053 12.563 15.0053H12.6419V14.5537C12.6419 14.373 12.7756 14.2222 12.9535 14.1858L12.9452 10.4892C12.8057 9.01228 11.5046 7.85475 9.91997 7.85475C8.33532 7.85475 7.03427 9.01228 6.89477 10.4892L6.88642 14.1825C7.09692 14.2125 7.35588 14.3673 7.35588 14.5537V15.0053H7.43482C7.65243 15.0053 7.8291 15.1739 7.8291 15.3817V15.8333H3.41097V15.3817C3.41097 15.1739 3.58765 15.0053 3.80525 15.0053H3.88419V14.5537C3.88419 14.3459 4.06087 14.1777 4.27889 14.1777V7.47834H3.84493L3.33203 5.8223H5.62004V4.16667Z",
              fill: "white",
              stroke: "transparent"
            }
          )
        ] }),
        /* @__PURE__ */ T.jsx("defs", { children: /* @__PURE__ */ T.jsx("clipPath", { id: "clip0_2230_11557", children: /* @__PURE__ */ T.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  ),
  Warpcast: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.94021 23.9926H18.0523C21.3278 23.9926 23.9926 21.328 23.9926 18.0524V5.94042C23.9926 2.66491 21.3278 0.00012207 18.0523 0.00012207H5.94021C2.66478 0.00012207 0 2.66491 0 5.94042V18.0524C0 21.328 2.66478 23.9926 5.94021 23.9926ZM14.5601 12.036L15.7431 7.59302H18.8537L15.9693 17.4164H13.2796L11.9963 12.8548L10.713 17.4164H8.02911L5.13837 7.59302H8.24928L9.4436 12.0687L10.6419 7.59302H13.3732L14.5601 12.036Z",
          fill: "#472A91",
          stroke: "transparent"
        }
      )
    }
  ),
  Orb: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          d: "M17.796 17.765C16.8878 17.765 16.1515 17.0161 16.1515 16.0923C16.1515 15.1685 16.8878 14.4197 17.796 14.4197C18.7043 14.4197 19.4406 15.1685 19.4406 16.0923C19.4406 17.0161 18.7043 17.765 17.796 17.765ZM11.8973 17.0568C9.21939 17.0508 7.05352 14.8308 7.05974 12.0986C7.06596 9.36629 9.24192 7.15626 11.9198 7.16239C14.5978 7.16847 16.7636 9.38842 16.7574 12.1207C16.7512 14.853 14.5752 17.063 11.8973 17.0568ZM11.9086 2C6.43623 2 2 6.52623 2 12.1096C2 17.693 6.43623 22.2192 11.9086 22.2192C17.3809 22.2192 21.8172 17.693 21.8172 12.1096C21.8172 6.52623 17.3809 2 11.9086 2Z",
          fill: "currentColor",
          stroke: "transparent"
        }
      )
    }
  ),
  Lens: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.13345 6.00367C8.43578 6.59243 7.94215 7.42741 7.7944 8.48231C6.92985 7.83972 5.97908 7.59271 5.06155 7.66165C4.00699 7.74088 3.03594 8.23368 2.31314 8.94462C1.59027 9.65561 1.091 10.609 1.01119 11.642C0.930416 12.6875 1.28297 13.7784 2.19955 14.7294L2.20052 14.7304C2.28214 14.8146 2.36504 14.8984 2.44923 14.9817L2.45048 14.9829C6.53742 19.0001 11.964 19 11.9998 19C12.0356 19 17.4625 19.0001 21.5493 14.9835C21.635 14.8997 21.7192 14.8147 21.8017 14.7285C22.7176 13.7768 23.0698 12.6858 22.9887 11.6403C22.9087 10.6071 22.4091 9.65386 21.686 8.94311C20.9629 8.23242 19.9918 7.74002 18.9373 7.66112C18.0199 7.59246 17.0693 7.83976 16.2052 8.48259C16.0575 7.42756 15.5639 6.59248 14.8661 6.00366C14.0647 5.32733 13.0238 5 11.9998 5C10.9758 5 9.93489 5.32733 9.13345 6.00367ZM15.6995 9.24238C15.6998 9.28481 15.6998 9.32661 15.6998 9.36687C15.6998 9.32798 15.6998 9.28765 15.6995 9.24671L15.6995 9.24238ZM8.07645 9.45821C8.04533 9.42788 8.01375 9.39733 7.98198 9.36687C7.93118 9.31816 7.87989 9.26964 7.82917 9.22252C7.81547 9.20978 7.80173 9.19717 7.78798 9.18469C7.7745 9.17246 7.76099 9.16035 7.74747 9.14837C7.7748 9.17258 7.80204 9.1973 7.82917 9.22252C7.91162 9.29912 7.99556 9.37939 8.07645 9.45821Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.7388 13.5351C14.6387 13.5351 14.6044 13.6804 14.6683 13.7571C14.7804 13.8917 14.8479 14.065 14.8479 14.254C14.8479 14.6827 14.5008 15.0302 14.0727 15.0302C13.6447 15.0302 13.2976 14.6827 13.2976 14.254C13.2976 14.2303 13.2667 14.2184 13.2527 14.2377C13.1313 14.4055 13.0492 14.5938 13.0156 14.7915C12.9967 14.9025 12.9065 14.9945 12.7932 14.9945H12.7294C12.5808 14.9945 12.4582 14.8739 12.4802 14.7278C12.6305 13.7263 13.6161 13 14.7388 13C15.8614 13 16.8472 13.7263 16.9975 14.7278C17.0193 14.8739 16.8968 14.9945 16.7482 14.9945C16.5997 14.9945 16.482 14.8733 16.4498 14.7291C16.3028 14.0727 15.6216 13.5351 14.7388 13.5351ZM7.856 14.254C7.856 14.2225 7.81516 14.2055 7.79606 14.2306C7.66637 14.401 7.57807 14.5938 7.54077 14.7969C7.51878 14.9165 7.42165 15.0159 7.29939 15.0159H7.25177C7.1032 15.0159 6.98064 14.8953 7.00255 14.7491C7.15278 13.7471 8.13857 13.0213 9.26121 13.0213C10.3839 13.0213 11.3696 13.7471 11.5199 14.7491C11.5418 14.8953 11.4192 15.0159 11.2707 15.0159C11.1221 15.0159 11.0044 14.8947 10.9722 14.7504C10.8253 14.0936 10.1441 13.5564 9.26121 13.5564C9.17959 13.5564 9.15007 13.6718 9.20477 13.732C9.32992 13.8699 9.40621 14.053 9.40621 14.254C9.40621 14.6827 9.05917 15.0302 8.6311 15.0302C8.20304 15.0302 7.856 14.6827 7.856 14.254ZM13.2751 16.0413C13.1447 15.9704 12.9824 16.0212 12.8775 16.1258C12.675 16.3273 12.3682 16.4649 12.0131 16.4649C11.6571 16.4649 11.3506 16.3287 11.1486 16.127C11.0438 16.0223 10.8818 15.9709 10.7511 16.0413C10.6205 16.1116 10.5704 16.276 10.6641 16.3907C10.9705 16.7663 11.467 17 12.0131 17C12.5595 17 13.0549 16.7638 13.361 16.391C13.4549 16.2766 13.4055 16.1121 13.2751 16.0413Z",
            fill: "white",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  Hey: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          d: "M21.3805 7.95042C21.1362 7.7597 20.6589 7.50905 19.9941 7.78695C20.6703 6.32118 21.0793 4.62109 20.0112 4.14703C19.0737 3.73291 18.2215 4.41948 17.5226 5.27497C17.9203 4.21242 18.2441 2.7085 17.2953 2.21809C16.1647 1.63505 14.8579 2.28348 14.2158 3.42232C14.1022 3.62393 13.7386 4.17973 13.1648 5.29677C13.3466 4.41403 13.1648 3.58034 12.6193 3.17711C12.1591 2.83383 11.5398 2.81203 10.9716 3.11718C10.6648 3.28064 9.52277 4.23966 7.66486 9.68319C7.57963 9.92839 7.72168 10.19 7.97735 10.2717C8.23303 10.3534 8.50575 10.2172 8.59098 9.97199C9.50005 7.31288 10.8523 4.24511 11.4489 3.92907C11.5795 3.85824 11.8295 3.76016 12.0284 3.90728C12.2329 4.05984 12.3977 4.49577 12.1989 5.22593C11.767 6.77344 11.4375 8.69693 11.4205 8.77866C11.3807 9.00752 11.5227 9.23093 11.7557 9.30177C11.9886 9.3726 12.2329 9.26907 12.3409 9.05656C13.3466 7.04589 14.6476 4.49032 14.9147 4.0217C15.3806 3.19891 16.1022 2.59952 16.801 2.93735C17.6532 3.35148 16.801 5.53652 15.0681 9.30722C14.9601 9.54152 15.0681 9.81397 15.3125 9.92295C15.551 10.0319 15.8408 9.92839 15.9544 9.69954C17.5169 6.55003 18.784 4.2887 19.7441 4.96983C20.3521 5.40574 18.8975 7.89593 18.1078 9.40529C17.7953 9.99924 17.4999 10.5605 17.2556 11.0781C17.1192 11.3397 17.0113 11.574 16.9431 11.7647C16.926 11.8083 16.909 11.8355 16.9033 11.8464L16.9147 11.8519C16.8692 11.999 16.8465 12.1135 16.8635 12.1734C16.9147 12.3695 17.0851 12.5112 17.2953 12.5276C17.5453 12.5494 17.659 12.4676 17.7897 12.2224C17.7897 12.217 17.7953 12.2115 17.7953 12.2061C17.8521 12.1025 17.909 11.9664 17.9828 11.7974C18.5056 10.7512 19.6816 8.79501 20.4884 8.5934C20.5964 8.56615 20.6759 8.5825 20.7668 8.65334C21.6646 9.3617 20.2271 12.8164 18.9715 14.9306C18.9374 14.9959 15.3181 20.8209 11.2102 21.0443C9.92617 21.1479 8.7387 20.3033 8.72733 20.2978C8.72165 20.2923 8.71029 20.2869 8.70461 20.2815C7.38646 19.4369 6.28421 18.2381 5.14787 16.1239C2.8752 11.9227 2.69338 10.555 3.13655 10.2117C3.28428 10.0973 3.52291 10.081 3.78427 10.2226C5.50581 11.1653 6.7217 13.9443 6.73874 13.9824C6.81261 14.1459 6.98306 14.2549 7.17055 14.2604C7.35805 14.2658 7.53419 14.1677 7.61941 14.0042C7.62509 13.9934 8.22167 12.8981 9.11938 12.849C9.81254 12.8055 10.608 13.4158 11.4205 14.5927C12.4489 16.0803 13.4658 16.7778 14.4545 16.6633C15.8238 16.5053 16.4601 14.8325 16.4885 14.7616C16.4999 14.7289 16.5056 14.7071 16.5226 14.669L15.6079 14.3584C15.5965 14.3911 15.5908 14.4129 15.5738 14.4456C15.4488 14.778 14.9772 15.6661 14.3351 15.737C13.7613 15.8024 13.017 15.2139 12.2329 14.075C11.2045 12.5821 10.1364 11.8574 9.06256 11.9173C8.26712 11.9608 7.65918 12.4349 7.27282 12.8654C6.64784 11.683 5.75013 10.228 4.26721 9.41074C3.70472 9.10015 3.01155 9.1165 2.52861 9.47613C1.48886 10.2553 1.93771 12.217 4.27857 16.5598C5.51718 18.8593 6.6592 20.1017 8.14781 21.0607C8.28984 21.1642 9.46596 21.9598 10.8807 21.9979C11.0114 22.0033 11.142 21.9979 11.2727 21.987C15.8976 21.7363 19.6532 15.6771 19.8124 15.4046C20.3975 14.4129 23.2327 9.41619 21.3805 7.95042Z",
          fill: "currentColor",
          stroke: "transparent"
        }
      )
    }
  ),
  Markdown: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 18 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.00065 0.833496C4.33761 0.833496 3.70173 1.09689 3.23288 1.56573C2.76404 2.03457 2.50065 2.67045 2.50065 3.3335V6.66683C2.50065 7.12707 2.87375 7.50016 3.33398 7.50016C3.79422 7.50016 4.16732 7.12707 4.16732 6.66683V3.3335C4.16732 3.11248 4.25511 2.90052 4.4114 2.74424C4.56768 2.58796 4.77964 2.50016 5.00065 2.50016H10.834V5.00016C10.834 5.6632 11.0974 6.29909 11.5662 6.76793C12.0351 7.23677 12.6709 7.50016 13.334 7.50016H15.834V16.6668C15.834 16.8878 15.7462 17.0998 15.5899 17.2561C15.4336 17.4124 15.2217 17.5002 15.0007 17.5002H3.33398C2.87375 17.5002 2.50065 17.8733 2.50065 18.3335C2.50065 18.7937 2.87375 19.1668 3.33398 19.1668H15.0007C15.6637 19.1668 16.2996 18.9034 16.7684 18.4346C17.2373 17.9658 17.5007 17.3299 17.5007 16.6668V5.8335C17.5007 5.61248 17.4129 5.40052 17.2566 5.24424L13.0899 1.07757C12.9336 0.921293 12.7217 0.833496 12.5007 0.833496H5.00065ZM12.5007 2.84534V5.00016C12.5007 5.22118 12.5884 5.43314 12.7447 5.58942C12.901 5.7457 13.113 5.8335 13.334 5.8335H15.4888L12.5007 2.84534Z",
            fill: "#363B3F",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M2.50065 12.429V15.0002C2.50065 15.4604 2.12755 15.8335 1.66732 15.8335C1.20708 15.8335 0.833984 15.4604 0.833984 15.0002V10.2431C0.833984 9.37027 1.93837 8.99133 2.47422 9.68029L4.58398 12.3928L6.69374 9.68029C7.2296 8.99134 8.33398 9.37026 8.33398 10.2431V15.0002C8.33398 15.4604 7.96089 15.8335 7.50065 15.8335C7.04041 15.8335 6.66732 15.4604 6.66732 15.0002V12.429L5.37334 14.0927C4.97298 14.6074 4.19499 14.6074 3.79463 14.0927L2.50065 12.429Z",
            fill: "#363B3F",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.584 12.5001C14.584 11.6863 14.4079 11.0087 14.0522 10.4719C13.6932 9.93013 13.1998 9.60493 12.6973 9.41559C11.8646 9.10182 10.9028 9.13741 10.3398 9.15824C10.2684 9.16089 10.2032 9.1633 10.1457 9.16472C9.60667 9.17805 9.16732 9.61753 9.16732 10.1668V14.8335C9.16732 15.3828 9.60667 15.8223 10.1457 15.8356C10.2032 15.837 10.2681 15.8394 10.3395 15.842C10.9024 15.8629 11.8646 15.8985 12.6973 15.5847C13.1998 15.3954 13.6932 15.0702 14.0522 14.5284C14.4079 13.9916 14.584 13.314 14.584 12.5001ZM12.1097 10.9752C11.7306 10.8324 11.2899 10.8094 10.834 10.8145V14.1858C11.2899 14.1909 11.7306 14.1679 12.1097 14.0251C12.3549 13.9327 12.5351 13.8005 12.6628 13.6078C12.7937 13.4103 12.9173 13.0764 12.9173 12.5001C12.9173 11.9239 12.7937 11.59 12.6628 11.3925C12.5351 11.1998 12.3549 11.0676 12.1097 10.9752Z",
            fill: "#363B3F",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  Telegram: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.3749 8.84156C6.74359 6.48951 10.3236 4.93889 12.1148 4.18971C17.2292 2.05065 18.2919 1.67907 18.9846 1.6668C19.1369 1.6641 19.4776 1.70206 19.6982 1.8821C19.8845 2.03412 19.9358 2.23947 19.9603 2.3836C19.9848 2.52773 20.0154 2.85607 19.9911 3.11262C19.714 6.04083 18.5147 13.1468 17.9046 16.4265C17.6465 17.8142 17.1382 18.2795 16.6461 18.3251C15.5766 18.424 14.7645 17.6144 13.7287 16.9316C12.1078 15.8632 11.1921 15.1981 9.61879 14.1556C7.80053 12.9507 8.97923 12.2885 10.0154 11.2062C10.2866 10.923 14.9987 6.6132 15.0899 6.22224C15.1013 6.17334 15.1119 5.99107 15.0042 5.89483C14.8965 5.79859 14.7376 5.8315 14.6229 5.85767C14.4604 5.89478 11.871 7.61575 6.85486 11.0206C6.11988 11.5281 5.45416 11.7754 4.8577 11.7624C4.20015 11.7481 2.93528 11.3886 1.99498 11.0812C0.84166 10.7042 -0.074973 10.5049 0.00484519 9.86468C0.0464194 9.53121 0.503103 9.19017 1.3749 8.84156Z",
          fill: "#363B3F",
          stroke: "transparent"
        }
      )
    }
  ),
  Github2: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx("g", { clipPath: "url(#clip0_2230_11561)", children: /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10 0C4.475 0 0 4.39702 0 9.82573C0 14.1736 2.8625 17.846 6.8375 19.1479C7.3375 19.2339 7.525 18.9391 7.525 18.6812C7.525 18.4478 7.5125 17.674 7.5125 16.8511C5 17.3056 4.35 16.2493 4.15 15.6966C4.0375 15.4141 3.55 14.5421 3.125 14.3087C2.775 14.1245 2.275 13.67 3.1125 13.6578C3.9 13.6455 4.4625 14.3701 4.65 14.6649C5.55 16.151 6.9875 15.7335 7.5625 15.4755C7.65 14.8369 7.9125 14.407 8.2 14.1613C5.975 13.9157 3.65 13.0682 3.65 9.30988C3.65 8.24133 4.0375 7.35702 4.675 6.66922C4.575 6.42357 4.225 5.41643 4.775 4.0654C4.775 4.0654 5.6125 3.80747 7.525 5.07253C8.325 4.85146 9.175 4.74092 10.025 4.74092C10.875 4.74092 11.725 4.85146 12.525 5.07253C14.4375 3.79519 15.275 4.0654 15.275 4.0654C15.825 5.41643 15.475 6.42357 15.375 6.66922C16.0125 7.35702 16.4 8.22905 16.4 9.30988C16.4 13.0805 14.0625 13.9157 11.8375 14.1613C12.2 14.4684 12.5125 15.0579 12.5125 15.9791C12.5125 17.2933 12.5 18.3496 12.5 18.6812C12.5 18.9391 12.6875 19.2462 13.1875 19.1479C17.1375 17.846 20 14.1613 20 9.82573C20 4.39702 15.525 0 10 0Z",
            fill: "#363B3F",
            stroke: "transparent"
          }
        ) }),
        /* @__PURE__ */ T.jsx("defs", { children: /* @__PURE__ */ T.jsx("clipPath", { id: "clip0_2230_11561", children: /* @__PURE__ */ T.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  ),
  PageBreak: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 18 18",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5C2.66421 1.5 3 1.83579 3 2.25V4.25C3 4.80228 3.44772 5.25 4 5.25H14C14.5523 5.25 15 4.80228 15 4.25V2.25C15 1.83579 15.3358 1.5 15.75 1.5C16.1642 1.5 16.5 1.83579 16.5 2.25V4.75C16.5 5.85457 15.6046 6.75 14.5 6.75H3.5C2.39543 6.75 1.5 5.85457 1.5 4.75V2.25Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M1.5 13.25C1.5 12.1454 2.39543 11.25 3.5 11.25H14.5C15.6046 11.25 16.5 12.1454 16.5 13.25V15.75C16.5 16.1642 16.1642 16.5 15.75 16.5C15.3358 16.5 15 16.1642 15 15.75V13.75C15 13.1977 14.5523 12.75 14 12.75H4C3.44772 12.75 3 13.1977 3 13.75V15.75C3 16.1642 2.66421 16.5 2.25 16.5C1.83579 16.5 1.5 16.1642 1.5 15.75V13.25Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M0.75 9C0.75 8.58579 1.08579 8.25 1.5 8.25H3C3.41421 8.25 3.75 8.58579 3.75 9C3.75 9.41421 3.41421 9.75 3 9.75H1.5C1.08579 9.75 0.75 9.41421 0.75 9Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M5.25 9C5.25 8.58579 5.58579 8.25 6 8.25H7.5C7.91421 8.25 8.25 8.58579 8.25 9C8.25 9.41421 7.91421 9.75 7.5 9.75H6C5.58579 9.75 5.25 9.41421 5.25 9Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M12.75 9C12.75 8.58579 12.4142 8.25 12 8.25H10.5C10.0858 8.25 9.75 8.58579 9.75 9C9.75 9.41421 10.0858 9.75 10.5 9.75H12C12.4142 9.75 12.75 9.41421 12.75 9Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M14.25 9C14.25 8.58579 14.5858 8.25 15 8.25H16.5C16.9142 8.25 17.25 8.58579 17.25 9C17.25 9.41421 16.9142 9.75 16.5 9.75H15C14.5858 9.75 14.25 9.41421 14.25 9Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  PageBreakRemove: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M1.33398 1.99998C1.33398 1.63179 1.63246 1.33331 2.00065 1.33331C2.36884 1.33331 2.66732 1.63179 2.66732 1.99998V3.66665C2.66732 4.21893 3.11503 4.66665 3.66732 4.66665H12.334C12.8863 4.66665 13.334 4.21893 13.334 3.66665V1.99998C13.334 1.63179 13.6325 1.33331 14.0007 1.33331C14.3688 1.33331 14.6673 1.63179 14.6673 1.99998V3.99998C14.6673 5.10455 13.7719 5.99998 12.6673 5.99998H3.33398C2.22942 5.99998 1.33398 5.10455 1.33398 3.99998V1.99998Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M1.33398 12C1.33398 10.8954 2.22941 9.99998 3.33398 9.99998H12.6673C13.7719 9.99998 14.6673 10.8954 14.6673 12V14C14.6673 14.3682 14.3688 14.6666 14.0007 14.6666C13.6325 14.6666 13.334 14.3682 13.334 14V11.3333H2.66732V14C2.66732 14.3682 2.36884 14.6666 2.00065 14.6666C1.63246 14.6666 1.33398 14.3682 1.33398 14V12Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.46712 6.46645C6.64463 6.28894 6.93243 6.28894 7.10994 6.46645L8.00065 7.35716L8.89136 6.46645C9.06887 6.28894 9.35667 6.28894 9.53418 6.46645C9.7117 6.64396 9.7117 6.93176 9.53418 7.10927L8.64348 7.99998L9.53418 8.89069C9.7117 9.0682 9.7117 9.356 9.53418 9.53351C9.35667 9.71102 9.06887 9.71102 8.89136 9.53351L8.00065 8.6428L7.10994 9.53351C6.93243 9.71102 6.64463 9.71102 6.46712 9.53351C6.28961 9.356 6.28961 9.0682 6.46712 8.89069L7.35783 7.99998L6.46712 7.10927C6.28961 6.93176 6.28961 6.64396 6.46712 6.46645Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  CircleCheck2: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx("g", { clipPath: "url(#clip0_3331_2680)", children: /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.1654 10.0002C19.1654 15.0628 15.0613 19.1668 9.9987 19.1668C4.93609 19.1668 0.832031 15.0628 0.832031 10.0002C0.832031 4.93755 4.93609 0.833496 9.9987 0.833496C15.0613 0.833496 19.1654 4.93755 19.1654 10.0002ZM13.088 8.92275C13.4134 8.59731 13.4134 8.06968 13.088 7.74424C12.7625 7.4188 12.2349 7.4188 11.9094 7.74424L9.16536 10.4883L8.08795 9.41091C7.76252 9.08547 7.23488 9.08547 6.90944 9.41091C6.584 9.73634 6.584 10.264 6.90944 10.5894L8.57611 12.2561C8.90154 12.5815 9.42918 12.5815 9.75462 12.2561L13.088 8.92275Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ) }),
        /* @__PURE__ */ T.jsx("defs", { children: /* @__PURE__ */ T.jsx("clipPath", { id: "clip0_3331_2680", children: /* @__PURE__ */ T.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  ),
  FileExport: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 19 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.16797 0.833496C2.50493 0.833496 1.86904 1.09689 1.4002 1.56573C0.931361 2.03457 0.667969 2.67045 0.667969 3.3335V16.6668C0.667969 17.3299 0.931361 17.9658 1.4002 18.4346C1.86904 18.9034 2.50493 19.1668 3.16797 19.1668H9.83463C10.2949 19.1668 10.668 18.7937 10.668 18.3335C10.668 17.8733 10.2949 17.5002 9.83463 17.5002H3.16797C2.94696 17.5002 2.73499 17.4124 2.57871 17.2561C2.42243 17.0998 2.33464 16.8878 2.33464 16.6668V3.3335C2.33464 3.11248 2.42243 2.90052 2.57871 2.74424C2.73499 2.58796 2.94695 2.50016 3.16797 2.50016H9.0013V5.00016C9.0013 5.6632 9.2647 6.29909 9.73354 6.76793C10.2024 7.23677 10.8383 7.50016 11.5013 7.50016H14.0013V10.0002C14.0013 10.4604 14.3744 10.8335 14.8346 10.8335C15.2949 10.8335 15.668 10.4604 15.668 10.0002V5.8335C15.668 5.61248 15.5802 5.40052 15.4239 5.24424L11.2572 1.07757C11.1009 0.921293 10.889 0.833496 10.668 0.833496H3.16797ZM10.668 2.84534V5.00016C10.668 5.22118 10.7558 5.43314 10.912 5.58942C11.0683 5.7457 11.2803 5.8335 11.5013 5.8335H13.6561L10.668 2.84534Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.8346 12.5002C15.2949 12.5002 15.668 12.8733 15.668 13.3335V18.3335C15.668 18.7937 15.2949 19.1668 14.8346 19.1668C14.3744 19.1668 14.0013 18.7937 14.0013 18.3335V13.3335C14.0013 12.8733 14.3744 12.5002 14.8346 12.5002Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.7454 15.2442C12.0708 14.9188 12.5985 14.9188 12.9239 15.2442L14.8346 17.155L16.7454 15.2442C17.0708 14.9188 17.5985 14.9188 17.9239 15.2442C18.2493 15.5697 18.2493 16.0973 17.9239 16.4228L15.4239 18.9228C15.0985 19.2482 14.5708 19.2482 14.2454 18.9228L11.7454 16.4228C11.4199 16.0973 11.4199 15.5697 11.7454 15.2442Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  FileImport: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.75 0.75C3.15326 0.75 2.58097 0.987053 2.15901 1.40901C1.73705 1.83097 1.5 2.40326 1.5 3V15C1.5 15.5967 1.73705 16.169 2.15901 16.591C2.58097 17.0129 3.15326 17.25 3.75 17.25H9.75C10.1642 17.25 10.5 16.9142 10.5 16.5C10.5 16.0858 10.1642 15.75 9.75 15.75H3.75C3.55109 15.75 3.36032 15.671 3.21967 15.5303C3.07902 15.3897 3 15.1989 3 15V3C3 2.80109 3.07902 2.61032 3.21967 2.46967C3.36032 2.32902 3.55109 2.25 3.75 2.25H9V4.5C9 5.09674 9.23705 5.66903 9.65901 6.09099C10.081 6.51295 10.6533 6.75 11.25 6.75H13.5V9C13.5 9.41421 13.8358 9.75 14.25 9.75C14.6642 9.75 15 9.41421 15 9V5.25C15 5.05109 14.921 4.86032 14.7803 4.71967L11.0303 0.96967C10.8897 0.829018 10.6989 0.75 10.5 0.75H3.75ZM10.5 2.56066V4.5C10.5 4.69891 10.579 4.88968 10.7197 5.03033C10.8603 5.17098 11.0511 5.25 11.25 5.25H13.1893L10.5 2.56066Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.25 17.25C13.8358 17.25 13.5 16.9142 13.5 16.5V12C13.5 11.5858 13.8358 11.25 14.25 11.25C14.6642 11.25 15 11.5858 15 12V16.5C15 16.9142 14.6642 17.25 14.25 17.25Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.0303 14.7803C16.7374 15.0732 16.2626 15.0732 15.9697 14.7803L14.25 13.0607L12.5303 14.7803C12.2374 15.0732 11.7626 15.0732 11.4697 14.7803C11.1768 14.4874 11.1768 14.0126 11.4697 13.7197L13.7197 11.4697C14.0126 11.1768 14.4874 11.1768 14.7803 11.4697L17.0303 13.7197C17.3232 14.0126 17.3232 14.4874 17.0303 14.7803Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  BookQuestion: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 14 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M6.17502 9.73251C6.17502 9.3183 6.5108 8.98251 6.92502 8.98251H6.93252C7.34673 8.98251 7.68252 9.3183 7.68252 9.73251C7.68252 10.1467 7.34673 10.4825 6.93252 10.4825H6.92502C6.5108 10.4825 6.17502 10.1467 6.17502 9.73251Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M6.54617 5.35656C6.70927 5.26429 6.90272 5.22984 7.09177 5.26147C7.28068 5.29307 7.44822 5.38773 7.56706 5.52396C7.68465 5.65875 7.74776 5.82599 7.75 5.9964C7.74867 6.09135 7.66232 6.27123 7.31844 6.49447C7.17044 6.59056 7.01695 6.66583 6.89736 6.71758C6.83865 6.74299 6.79074 6.7616 6.75922 6.77329C6.74353 6.77912 6.73208 6.78315 6.72561 6.78539L6.71982 6.78737C6.32728 6.91613 6.11263 7.33832 6.24027 7.73155C6.36815 8.12553 6.7912 8.34124 7.18518 8.21336L6.95363 7.5C7.18518 8.21336 7.18585 8.21314 7.18607 8.21307L7.18711 8.21273L7.18962 8.21191L7.19634 8.20967L7.21638 8.20284C7.23256 8.19724 7.25434 8.18951 7.28093 8.17965C7.33398 8.15997 7.40688 8.13152 7.49314 8.09419C7.66351 8.02045 7.89661 7.90749 8.13521 7.75261C8.5618 7.47566 9.25004 6.9037 9.25004 5.99416L9.25 5.98818C9.24574 5.4536 9.04854 4.94041 8.6974 4.53789C8.34665 4.13583 7.86525 3.87003 7.33931 3.78203C6.81351 3.69406 6.27169 3.78845 5.80761 4.05098C5.34315 4.31373 4.98374 4.7298 4.79723 5.23033C4.6526 5.61848 4.85 6.05038 5.23814 6.19501C5.62629 6.33964 6.05818 6.14223 6.20282 5.75409C6.26371 5.59068 6.38346 5.4486 6.54617 5.35656Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.75 2.25C13.75 1.85218 13.592 1.47065 13.3107 1.18934C13.0294 0.908035 12.6478 0.75 12.25 0.75H2.875C2.17881 0.75 1.51113 1.02656 1.01884 1.51884C0.526562 2.01113 0.25 2.67881 0.25 3.375V14.625C0.25 15.3212 0.526562 15.9889 1.01884 16.4812C1.51113 16.9734 2.17881 17.25 2.875 17.25H12.25C12.6478 17.25 13.0294 17.092 13.3107 16.8107C13.592 16.5294 13.75 16.1478 13.75 15.75V2.25ZM2.875 2.25C2.57663 2.25 2.29048 2.36853 2.0795 2.5795C1.86853 2.79048 1.75 3.07663 1.75 3.375V12.2533C2.09832 12.0881 2.48212 12 2.875 12H12.25V2.25H2.875ZM12.25 13.5H2.875C2.57663 13.5 2.29048 13.6185 2.0795 13.8295C1.86853 14.0405 1.75 14.3266 1.75 14.625C1.75 14.9234 1.86853 15.2095 2.0795 15.4205C2.29048 15.6315 2.57663 15.75 2.875 15.75H12.25V13.5Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        )
      ]
    }
  )
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wue = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), TF = (...t) => t.filter((e, n, r) => !!e && e.trim() !== "" && r.indexOf(e) === n).join(" ").trim();
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Zue = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gue = en(
  ({
    color: t = "currentColor",
    size: e = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: i = "",
    children: a,
    iconNode: o,
    ...s
  }, l) => Ee(
    "svg",
    {
      ref: l,
      ...Zue,
      width: e,
      height: e,
      stroke: t,
      strokeWidth: r ? Number(n) * 24 / Number(e) : n,
      className: TF("lucide", i),
      ...s
    },
    [
      ...o.map(([c, u]) => Ee(c, u)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y = (t, e) => {
  const n = en(
    ({ className: r, ...i }, a) => Ee(Gue, {
      ref: a,
      iconNode: e,
      className: TF(`lucide-${Wue(t)}`, r),
      ...i
    })
  );
  return n.displayName = `${t}`, n;
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yue = [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 7v9", key: "pknjwm" }],
  ["path", { d: "m14 12 4 4 4-4", key: "buelq4" }]
], Kue = y("AArrowDown", Yue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ue = [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 16V7", key: "ty0viw" }],
  ["path", { d: "m14 11 4-4 4 4", key: "1pu57t" }]
], Jue = y("AArrowUp", $ue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Que = [
  ["path", { d: "M21 14h-5", key: "1vh23k" }],
  ["path", { d: "M16 16v-3.5a2.5 2.5 0 0 1 5 0V16", key: "1wh10o" }],
  ["path", { d: "M4.5 13h6", key: "dfilno" }],
  ["path", { d: "m3 16 4.5-9 4.5 9", key: "2dxa0e" }]
], Xue = y("ALargeSmall", Que);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e0e = [
  ["circle", { cx: "16", cy: "4", r: "1", key: "1grugj" }],
  ["path", { d: "m18 19 1-7-6 1", key: "r0i19z" }],
  ["path", { d: "m5 8 3-3 5.5 3-2.36 3.5", key: "9ptxx2" }],
  ["path", { d: "M4.24 14.5a5 5 0 0 0 6.88 6", key: "10kmtu" }],
  ["path", { d: "M13.76 17.5a5 5 0 0 0-6.88-6", key: "2qq6rc" }]
], t0e = y("Accessibility", e0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n0e = [
  [
    "path",
    {
      d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
      key: "169zse"
    }
  ]
], r0e = y("Activity", n0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i0e = [
  [
    "path",
    {
      d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "larmp2"
    }
  ],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12", key: "1bo8pg" }],
  ["path", { d: "M6.6 15.6A2 2 0 1 0 10 17v-5", key: "t9h90c" }]
], a0e = y("AirVent", i0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o0e = [
  [
    "path",
    {
      d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1",
      key: "ns4c3b"
    }
  ],
  ["path", { d: "m12 15 5 6H7Z", key: "14qnn2" }]
], s0e = y("Airplay", o0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l0e = [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
], c0e = y("AlarmClockCheck", l0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u0e = [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
], d0e = y("AlarmClockMinus", u0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f0e = [
  ["path", { d: "M6.87 6.87a8 8 0 1 0 11.26 11.26", key: "3on8tj" }],
  ["path", { d: "M19.9 14.25a8 8 0 0 0-9.15-9.15", key: "15ghsc" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.26 18.67 4 21", key: "yzmioq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M4 4 2 6", key: "1ycko6" }]
], h0e = y("AlarmClockOff", f0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p0e = [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
], m0e = y("AlarmClockPlus", p0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y0e = [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M12 9v4l2 2", key: "1c63tq" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }]
], g0e = y("AlarmClock", y0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v0e = [
  ["path", { d: "M11 21c0-2.5 2-2.5 2-5", key: "1sicvv" }],
  ["path", { d: "M16 21c0-2.5 2-2.5 2-5", key: "1o3eny" }],
  ["path", { d: "m19 8-.8 3a1.25 1.25 0 0 1-1.2 1H7a1.25 1.25 0 0 1-1.2-1L5 8", key: "1bvca4" }],
  [
    "path",
    { d: "M21 3a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1z", key: "x3qr1j" }
  ],
  ["path", { d: "M6 21c0-2.5 2-2.5 2-5", key: "i3w1gp" }]
], b0e = y("AlarmSmoke", v0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w0e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["polyline", { points: "11 3 11 11 14 8 17 11 17 3", key: "1wcwz3" }]
], k0e = y("Album", w0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x0e = [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
  ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
  ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
  ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
], M0e = y("AlignCenterHorizontal", x0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C0e = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", key: "14d6g8" }],
  ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", key: "1e2lrw" }],
  ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", key: "1fkdwx" }],
  ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", key: "1euafb" }]
], A0e = y("AlignCenterVertical", C0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S0e = [
  ["path", { d: "M17 12H7", key: "16if0g" }],
  ["path", { d: "M19 18H5", key: "18s9l3" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
], L0e = y("AlignCenter", S0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T0e = [
  ["rect", { width: "6", height: "16", x: "4", y: "2", rx: "2", key: "z5wdxg" }],
  ["rect", { width: "6", height: "9", x: "14", y: "9", rx: "2", key: "um7a8w" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }]
], E0e = y("AlignEndHorizontal", T0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j0e = [
  ["rect", { width: "16", height: "6", x: "2", y: "4", rx: "2", key: "10wcwx" }],
  ["rect", { width: "9", height: "6", x: "9", y: "14", rx: "2", key: "4p5bwg" }],
  ["path", { d: "M22 22V2", key: "12ipfv" }]
], N0e = y("AlignEndVertical", j0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D0e = [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M17 22v-5", key: "4b6g73" }],
  ["path", { d: "M17 7V2", key: "hnrr36" }],
  ["path", { d: "M7 22v-3", key: "1r4jpn" }],
  ["path", { d: "M7 5V2", key: "liy1u9" }]
], I0e = y(
  "AlignHorizontalDistributeCenter",
  D0e
);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P0e = [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M10 2v20", key: "uyc634" }],
  ["path", { d: "M20 2v20", key: "1tx262" }]
], z0e = y("AlignHorizontalDistributeEnd", P0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R0e = [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M4 2v20", key: "gtpd5x" }],
  ["path", { d: "M14 2v20", key: "tg6bpw" }]
], O0e = y(
  "AlignHorizontalDistributeStart",
  R0e
);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B0e = [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
], H0e = y("AlignHorizontalJustifyCenter", B0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F0e = [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "12", y: "7", rx: "2", key: "1ht384" }],
  ["path", { d: "M22 2v20", key: "40qfg1" }]
], _0e = y("AlignHorizontalJustifyEnd", F0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V0e = [
  ["rect", { width: "6", height: "14", x: "6", y: "5", rx: "2", key: "hsirpf" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
], q0e = y("AlignHorizontalJustifyStart", V0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U0e = [
  ["rect", { width: "6", height: "10", x: "9", y: "7", rx: "2", key: "yn7j0q" }],
  ["path", { d: "M4 22V2", key: "tsjzd3" }],
  ["path", { d: "M20 22V2", key: "1bnhr8" }]
], W0e = y("AlignHorizontalSpaceAround", U0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z0e = [
  ["rect", { width: "6", height: "14", x: "3", y: "5", rx: "2", key: "j77dae" }],
  ["rect", { width: "6", height: "10", x: "15", y: "7", rx: "2", key: "bq30hj" }],
  ["path", { d: "M3 2v20", key: "1d2pfg" }],
  ["path", { d: "M21 2v20", key: "p059bm" }]
], G0e = y("AlignHorizontalSpaceBetween", Z0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y0e = [
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }]
], K0e = y("AlignJustify", Y0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $0e = [
  ["path", { d: "M15 12H3", key: "6jk70r" }],
  ["path", { d: "M17 18H3", key: "1amg6g" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
], J0e = y("AlignLeft", $0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q0e = [
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M21 18H7", key: "1ygte8" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
], X0e = y("AlignRight", Q0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e1e = [
  ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }],
  ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }],
  ["path", { d: "M22 2H2", key: "fhrpnj" }]
], t1e = y("AlignStartHorizontal", e1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n1e = [
  ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
  ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
], r1e = y("AlignStartVertical", n1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i1e = [
  ["path", { d: "M22 17h-3", key: "1lwga1" }],
  ["path", { d: "M22 7h-5", key: "o2endc" }],
  ["path", { d: "M5 17H2", key: "1gx9xc" }],
  ["path", { d: "M7 7H2", key: "6bq26l" }],
  ["rect", { x: "5", y: "14", width: "14", height: "6", rx: "2", key: "1qrzuf" }],
  ["rect", { x: "7", y: "4", width: "10", height: "6", rx: "2", key: "we8e9z" }]
], a1e = y("AlignVerticalDistributeCenter", i1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o1e = [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
], s1e = y("AlignVerticalDistributeEnd", o1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l1e = [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M2 4h20", key: "mda7wb" }]
], c1e = y("AlignVerticalDistributeStart", l1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u1e = [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
], d1e = y("AlignVerticalJustifyCenter", u1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f1e = [
  ["rect", { width: "14", height: "6", x: "5", y: "12", rx: "2", key: "4l4tp2" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 22h20", key: "272qi7" }]
], h1e = y("AlignVerticalJustifyEnd", f1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p1e = [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "6", rx: "2", key: "13squh" }],
  ["path", { d: "M2 2h20", key: "1ennik" }]
], m1e = y("AlignVerticalJustifyStart", p1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y1e = [
  ["rect", { width: "10", height: "6", x: "7", y: "9", rx: "2", key: "b1zbii" }],
  ["path", { d: "M22 20H2", key: "1p1f7z" }],
  ["path", { d: "M22 4H2", key: "1b7qnq" }]
], g1e = y("AlignVerticalSpaceAround", y1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v1e = [
  ["rect", { width: "14", height: "6", x: "5", y: "15", rx: "2", key: "1w91an" }],
  ["rect", { width: "10", height: "6", x: "7", y: "3", rx: "2", key: "17wqzy" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M2 3h20", key: "91anmk" }]
], b1e = y("AlignVerticalSpaceBetween", v1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w1e = [
  ["path", { d: "M10 10H6", key: "1bsnug" }],
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14",
      key: "lrkjwd"
    }
  ],
  ["path", { d: "M8 8v4", key: "1fwk8c" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
], k1e = y("Ambulance", w1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x1e = [
  [
    "path",
    {
      d: "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13",
      key: "1o9ehi"
    }
  ],
  ["path", { d: "M16 12h3", key: "4uvgyw" }]
], M1e = y("Ampersand", x1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C1e = [
  [
    "path",
    {
      d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "12lh1k"
    }
  ],
  [
    "path",
    {
      d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "173c68"
    }
  ]
], A1e = y("Ampersands", C1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S1e = [
  [
    "path",
    { d: "M10 2v5.632c0 .424-.272.795-.653.982A6 6 0 0 0 6 14c.006 4 3 7 5 8", key: "1h8rid" }
  ],
  ["path", { d: "M10 5H8a2 2 0 0 0 0 4h.68", key: "3ezsi6" }],
  ["path", { d: "M14 2v5.632c0 .424.272.795.652.982A6 6 0 0 1 18 14c0 4-3 7-5 8", key: "yt6q09" }],
  ["path", { d: "M14 5h2a2 2 0 0 1 0 4h-.68", key: "8f95yk" }],
  ["path", { d: "M18 22H6", key: "mg6kv4" }],
  ["path", { d: "M9 2h6", key: "1jrp98" }]
], L1e = y("Amphora", S1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T1e = [
  ["path", { d: "M12 22V8", key: "qkxhtm" }],
  ["path", { d: "M5 12H2a10 10 0 0 0 20 0h-3", key: "1hv3nh" }],
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }]
], E1e = y("Anchor", T1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j1e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["path", { d: "M7.5 8 10 9", key: "olxxln" }],
  ["path", { d: "m14 9 2.5-1", key: "1j6cij" }],
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }]
], N1e = y("Angry", j1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D1e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M14 9h2", key: "116p9w" }]
], I1e = y("Annoyed", D1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P1e = [
  ["path", { d: "M2 12 7 2", key: "117k30" }],
  ["path", { d: "m7 12 5-10", key: "1tvx22" }],
  ["path", { d: "m12 12 5-10", key: "ev1o1a" }],
  ["path", { d: "m17 12 5-10", key: "1e4ti3" }],
  ["path", { d: "M4.5 7h15", key: "vlsxkz" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
], z1e = y("Antenna", P1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R1e = [
  ["path", { d: "M7 10H6a4 4 0 0 1-4-4 1 1 0 0 1 1-1h4", key: "1hjpb6" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1 7 7 0 0 1-7 7H8a1 1 0 0 1-1-1z", key: "1qn45f" }
  ],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  [
    "path",
    { d: "M5 20a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1", key: "1fi4x8" }
  ]
], O1e = y("Anvil", R1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B1e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14.31 8 5.74 9.94", key: "1y6ab4" }],
  ["path", { d: "M9.69 8h11.48", key: "1wxppr" }],
  ["path", { d: "m7.38 12 5.74-9.94", key: "1grp0k" }],
  ["path", { d: "M9.69 16 3.95 6.06", key: "libnyf" }],
  ["path", { d: "M14.31 16H2.83", key: "x5fava" }],
  ["path", { d: "m16.62 12-5.74 9.94", key: "1vwawt" }]
], H1e = y("Aperture", B1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F1e = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M14 8h.01", key: "1primd" }]
], _1e = y("AppWindowMac", F1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V1e = [
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }],
  ["path", { d: "M10 4v4", key: "pp8u80" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["path", { d: "M6 4v4", key: "1svtjw" }]
], q1e = y("AppWindow", V1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U1e = [
  [
    "path",
    {
      d: "M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z",
      key: "3s7exb"
    }
  ],
  ["path", { d: "M10 2c1 .5 2 2 2 5", key: "fcco2y" }]
], W1e = y("Apple", U1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z1e = [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h2", key: "tvwodi" }],
  ["path", { d: "M20 8v11a2 2 0 0 1-2 2h-2", key: "1gkqxj" }],
  ["path", { d: "m9 15 3-3 3 3", key: "1pd0qc" }],
  ["path", { d: "M12 12v9", key: "192myk" }]
], G1e = y("ArchiveRestore", Z1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y1e = [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "m9.5 17 5-5", key: "nakeu6" }],
  ["path", { d: "m9.5 12 5 5", key: "1hccrj" }]
], K1e = y("ArchiveX", Y1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $1e = [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "M10 12h4", key: "a56b0p" }]
], J1e = y("Archive", $1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q1e = [
  ["path", { d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3", key: "irtipd" }],
  [
    "path",
    {
      d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
      key: "1qyhux"
    }
  ],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
], X1e = y("Armchair", Q1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ede = [
  ["path", { d: "M15 5H9", key: "1tp3ed" }],
  ["path", { d: "M15 9v3h4l-7 7-7-7h4V9z", key: "ncdc4b" }]
], tde = y("ArrowBigDownDash", ede);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nde = [["path", { d: "M15 6v6h4l-7 7-7-7h4V6h6z", key: "1thax2" }]], rde = y("ArrowBigDown", nde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ide = [
  ["path", { d: "M19 15V9", key: "1hci5f" }],
  ["path", { d: "M15 15h-3v4l-7-7 7-7v4h3v6z", key: "16tjna" }]
], ade = y("ArrowBigLeftDash", ide);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ode = [["path", { d: "M18 15h-6v4l-7-7 7-7v4h6v6z", key: "lbrdak" }]], sde = y("ArrowBigLeft", ode);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lde = [
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["path", { d: "M9 9h3V5l7 7-7 7v-4H9V9z", key: "1sg2xn" }]
], cde = y("ArrowBigRightDash", lde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ude = [["path", { d: "M6 9h6V5l7 7-7 7v-4H6V9z", key: "7fvt9c" }]], dde = y("ArrowBigRight", ude);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fde = [
  ["path", { d: "M9 19h6", key: "456am0" }],
  ["path", { d: "M9 15v-3H5l7-7 7 7h-4v3H9z", key: "1r2uve" }]
], hde = y("ArrowBigUpDash", fde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pde = [["path", { d: "M9 18v-6H5l7-7 7 7h-4v6H9z", key: "1x06kx" }]], mde = y("ArrowBigUp", pde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yde = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
], gde = y("ArrowDown01", yde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vde = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
], bde = y("ArrowDown10", vde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wde = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
], kde = y("ArrowDownAZ", wde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xde = [
  ["path", { d: "M19 3H5", key: "1236rx" }],
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m6 15 6 6 6-6", key: "h15q88" }]
], Mde = y("ArrowDownFromLine", xde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cde = [
  ["path", { d: "M17 7 7 17", key: "15tmo1" }],
  ["path", { d: "M17 17H7V7", key: "1org7z" }]
], Ade = y("ArrowDownLeft", Cde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sde = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h4", key: "6d7r33" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h10", key: "1438ji" }]
], Lde = y("ArrowDownNarrowWide", Sde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tde = [
  ["path", { d: "m7 7 10 10", key: "1fmybs" }],
  ["path", { d: "M17 7v10H7", key: "6fjiku" }]
], Ede = y("ArrowDownRight", Tde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jde = [
  ["path", { d: "M12 2v14", key: "jyx4ut" }],
  ["path", { d: "m19 9-7 7-7-7", key: "1oe3oy" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
], Nde = y("ArrowDownToDot", jde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dde = [
  ["path", { d: "M12 17V3", key: "1cwfxf" }],
  ["path", { d: "m6 11 6 6 6-6", key: "12ii2o" }],
  ["path", { d: "M19 21H5", key: "150jfl" }]
], Ide = y("ArrowDownToLine", Dde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pde = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "m21 8-4-4-4 4", key: "1c9v7m" }],
  ["path", { d: "M17 4v16", key: "7dpous" }]
], zde = y("ArrowDownUp", Pde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rde = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h10", key: "1w87gc" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }]
], Ode = y("ArrowDownWideNarrow", Rde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bde = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
], Hde = y("ArrowDownZA", Bde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fde = [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
], _de = y("ArrowDown", Fde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vde = [
  ["path", { d: "m9 6-6 6 6 6", key: "7v63n9" }],
  ["path", { d: "M3 12h14", key: "13k4hi" }],
  ["path", { d: "M21 19V5", key: "b4bplr" }]
], qde = y("ArrowLeftFromLine", Vde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ude = [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
], Wde = y("ArrowLeftRight", Ude);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zde = [
  ["path", { d: "M3 19V5", key: "rwsyhb" }],
  ["path", { d: "m13 6-6 6 6 6", key: "1yhaz7" }],
  ["path", { d: "M7 12h14", key: "uoisry" }]
], Gde = y("ArrowLeftToLine", Zde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yde = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
], Kde = y("ArrowLeft", Yde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $de = [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M21 12H7", key: "13ipq5" }],
  ["path", { d: "m15 18 6-6-6-6", key: "6tx3qv" }]
], Jde = y("ArrowRightFromLine", $de);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qde = [
  ["path", { d: "m16 3 4 4-4 4", key: "1x1c3m" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "m8 21-4-4 4-4", key: "h9nckh" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
], Xde = y("ArrowRightLeft", Qde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const efe = [
  ["path", { d: "M17 12H3", key: "8awo09" }],
  ["path", { d: "m11 18 6-6-6-6", key: "8c2y43" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
], tfe = y("ArrowRightToLine", efe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nfe = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
], rfe = y("ArrowRight", nfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ife = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
], afe = y("ArrowUp01", ife);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ofe = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
], sfe = y("ArrowUp10", ofe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lfe = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
], cfe = y("ArrowUpAZ", lfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ufe = [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
], dfe = y("ArrowUpDown", ufe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ffe = [
  ["path", { d: "m5 9 7-7 7 7", key: "1hw5ic" }],
  ["path", { d: "M12 16V2", key: "ywoabb" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
], hfe = y("ArrowUpFromDot", ffe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pfe = [
  ["path", { d: "m18 9-6-6-6 6", key: "kcunyi" }],
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
], mfe = y("ArrowUpFromLine", pfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yfe = [
  ["path", { d: "M7 17V7h10", key: "11bw93" }],
  ["path", { d: "M17 17 7 7", key: "2786uv" }]
], gfe = y("ArrowUpLeft", yfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vfe = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h10", key: "jvxblo" }]
], bfe = y("ArrowUpNarrowWide", vfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wfe = [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
], kfe = y("ArrowUpRight", wfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xfe = [
  ["path", { d: "M5 3h14", key: "7usisc" }],
  ["path", { d: "m18 13-6-6-6 6", key: "1kf1n9" }],
  ["path", { d: "M12 7v14", key: "1akyts" }]
], Mfe = y("ArrowUpToLine", xfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cfe = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h10", key: "1438ji" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h4", key: "1krc32" }]
], Afe = y("ArrowUpWideNarrow", Cfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sfe = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
], Lfe = y("ArrowUpZA", Sfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tfe = [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
], Efe = y("ArrowUp", Tfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jfe = [
  ["path", { d: "m4 6 3-3 3 3", key: "9aidw8" }],
  ["path", { d: "M7 17V3", key: "19qxw1" }],
  ["path", { d: "m14 6 3-3 3 3", key: "6iy689" }],
  ["path", { d: "M17 17V3", key: "o0fmgi" }],
  ["path", { d: "M4 21h16", key: "1h09gz" }]
], Nfe = y("ArrowsUpFromLine", jfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dfe = [
  ["path", { d: "M12 6v12", key: "1vza4d" }],
  ["path", { d: "M17.196 9 6.804 15", key: "1ah31z" }],
  ["path", { d: "m6.804 9 10.392 6", key: "1b6pxd" }]
], Ife = y("Asterisk", Dfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pfe = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }]
], zfe = y("AtSign", Pfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rfe = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z",
      key: "1l2ple"
    }
  ],
  [
    "path",
    {
      d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z",
      key: "1wam0m"
    }
  ]
], Ofe = y("Atom", Rfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bfe = [
  ["path", { d: "M2 10v3", key: "1fnikh" }],
  ["path", { d: "M6 6v11", key: "11sgs0" }],
  ["path", { d: "M10 3v18", key: "yhl04a" }],
  ["path", { d: "M14 8v7", key: "3a1oy3" }],
  ["path", { d: "M18 5v13", key: "123xd1" }],
  ["path", { d: "M22 10v3", key: "154ddg" }]
], Hfe = y("AudioLines", Bfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ffe = [
  [
    "path",
    {
      d: "M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2",
      key: "57tc96"
    }
  ]
], _fe = y("AudioWaveform", Ffe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vfe = [
  [
    "path",
    {
      d: "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
      key: "1yiouv"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "6", key: "1vp47v" }]
], qfe = y("Award", Vfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ufe = [
  ["path", { d: "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9", key: "csbz4o" }],
  ["path", { d: "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z", key: "113wfo" }]
], Wfe = y("Axe", Ufe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zfe = [
  ["path", { d: "M4 4v16h16", key: "1s015l" }],
  ["path", { d: "m4 20 7-7", key: "17qe9y" }]
], Gfe = y("Axis3d", Zfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yfe = [
  ["path", { d: "M9 12h.01", key: "157uk2" }],
  ["path", { d: "M15 12h.01", key: "1k8ypt" }],
  ["path", { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5", key: "1u7htd" }],
  [
    "path",
    {
      d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
      key: "5yv0yz"
    }
  ]
], Kfe = y("Baby", Yfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $fe = [
  [
    "path",
    { d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z", key: "1ol0lm" }
  ],
  ["path", { d: "M8 10h8", key: "c7uz4u" }],
  ["path", { d: "M8 18h8", key: "1no2b1" }],
  ["path", { d: "M8 22v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6", key: "1fr6do" }],
  ["path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2", key: "donm21" }]
], Jfe = y("Backpack", $fe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qfe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], Xfe = y("BadgeAlert", Qfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ehe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M15.4 10a4 4 0 1 0 0 4", key: "2eqtx8" }]
], the = y("BadgeCent", ehe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nhe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], rhe = y("BadgeCheck", nhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ihe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
], ahe = y("BadgeDollarSign", ihe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ohe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M7 12h5", key: "gblrwe" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
], she = y("BadgeEuro", ohe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lhe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["line", { x1: "12", x2: "12.01", y1: "17", y2: "17", key: "io3f8k" }]
], che = y("BadgeHelp", lhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uhe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 8h8", key: "1bis0t" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m13 17-5-1h1a4 4 0 0 0 0-8", key: "nu2bwa" }]
], dhe = y("BadgeIndianRupee", uhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fhe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "12", key: "1y1yb1" }],
  ["line", { x1: "12", x2: "12.01", y1: "8", y2: "8", key: "110wyk" }]
], hhe = y("BadgeInfo", fhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const phe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 8 3 3v7", key: "17yadx" }],
  ["path", { d: "m12 11 3-3", key: "p4cfq1" }],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M9 16h6", key: "8wimt3" }]
], mhe = y("BadgeJapaneseYen", phe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yhe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], ghe = y("BadgeMinus", yhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vhe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
], bhe = y("BadgePercent", vhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const whe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "16", key: "10p56q" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], khe = y("BadgePlus", whe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xhe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 12h4", key: "qz6y1c" }],
  ["path", { d: "M10 16V9.5a2.5 2.5 0 0 1 5 0", key: "3mlbjk" }],
  ["path", { d: "M8 16h7", key: "sbedsn" }]
], Mhe = y("BadgePoundSterling", xhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Che = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9 16h5", key: "1syiyw" }],
  ["path", { d: "M9 12h5a2 2 0 1 0 0-4h-3v9", key: "1ge9c1" }]
], Ahe = y("BadgeRussianRuble", Che);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const She = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M11 17V8h4", key: "1bfq6y" }],
  ["path", { d: "M11 12h3", key: "2eqnfz" }],
  ["path", { d: "M9 16h4", key: "1skf3a" }]
], Lhe = y("BadgeSwissFranc", She);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const The = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
], Ehe = y("BadgeX", The);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jhe = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ]
], Nhe = y("Badge", jhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dhe = [
  ["path", { d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2", key: "4irg2o" }],
  ["path", { d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10", key: "14fcyx" }],
  ["rect", { width: "13", height: "8", x: "8", y: "6", rx: "1", key: "o6oiis" }],
  ["circle", { cx: "18", cy: "20", r: "2", key: "t9985n" }],
  ["circle", { cx: "9", cy: "20", r: "2", key: "e5v82j" }]
], Ihe = y("BaggageClaim", Dhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Phe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.9 4.9 14.2 14.2", key: "1m5liu" }]
], zhe = y("Ban", Phe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rhe = [
  ["path", { d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5", key: "1cscit" }],
  [
    "path",
    {
      d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z",
      key: "1y1nbv"
    }
  ]
], Ohe = y("Banana", Rhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bhe = [
  ["path", { d: "M10 10.01h.01", key: "1e9xi7" }],
  ["path", { d: "M10 14.01h.01", key: "ac23bv" }],
  ["path", { d: "M14 10.01h.01", key: "2wfrvf" }],
  ["path", { d: "M14 14.01h.01", key: "8tw8yn" }],
  ["path", { d: "M18 6v11.5", key: "dkbidh" }],
  ["path", { d: "M6 6v12", key: "vkc79e" }],
  ["rect", { x: "2", y: "6", width: "20", height: "12", rx: "2", key: "1wpnh2" }]
], Hhe = y("Bandage", Bhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fhe = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M6 12h.01M18 12h.01", key: "113zkx" }]
], _he = y("Banknote", Fhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vhe = [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M8 5v14", key: "1ybrkv" }],
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "M17 5v14", key: "ycjyhj" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
], qhe = y("Barcode", Vhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uhe = [
  ["path", { d: "M4 20h16", key: "14thso" }],
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], Whe = y("Baseline", Uhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zhe = [
  ["path", { d: "M10 4 8 6", key: "1rru8s" }],
  ["path", { d: "M17 19v2", key: "ts1sot" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M7 19v2", key: "12npes" }],
  [
    "path",
    {
      d: "M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5",
      key: "14ym8i"
    }
  ]
], Ghe = y("Bath", Zhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yhe = [
  ["path", { d: "M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1sdynx" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1", key: "1gkd3k" }],
  ["path", { d: "m11 7-3 5h4l-3 5", key: "b4a64w" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
], Khe = y("BatteryCharging", Yhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $he = [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "13", key: "c6fn6x" }]
], Jhe = y("BatteryFull", $he);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qhe = [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }]
], Xhe = y("BatteryLow", Qhe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e2e = [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }]
], t2e = y("BatteryMedium", e2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n2e = [
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["path", { d: "M13.5 7H16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2.5", key: "jzl4pj" }],
  ["path", { d: "M22 11v2", key: "1wo06k" }],
  ["path", { d: "M6.5 17H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2.5", key: "1ar5vp" }],
  ["path", { d: "M7 12h6", key: "iekk3h" }]
], r2e = y("BatteryPlus", n2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i2e = [
  ["path", { d: "M10 17h.01", key: "nbq80n" }],
  ["path", { d: "M10 7v6", key: "nne03l" }],
  ["path", { d: "M14 7h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1x5o8m" }],
  ["path", { d: "M22 11v2", key: "1wo06k" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "1mdjgh" }]
], a2e = y("BatteryWarning", i2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o2e = [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
], s2e = y("Battery", o2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l2e = [
  ["path", { d: "M4.5 3h15", key: "c7n0jr" }],
  ["path", { d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3", key: "m1uhx7" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }]
], c2e = y("Beaker", l2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u2e = [
  [
    "path",
    {
      d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1",
      key: "bq3udt"
    }
  ],
  ["path", { d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66", key: "17ccse" }],
  [
    "path",
    {
      d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04",
      key: "18zqgq"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], d2e = y("BeanOff", u2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f2e = [
  [
    "path",
    {
      d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z",
      key: "1tvzk7"
    }
  ],
  ["path", { d: "M5.341 10.62a4 4 0 1 0 5.279-5.28", key: "2cyri2" }]
], h2e = y("Bean", f2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p2e = [
  ["path", { d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8", key: "1k78r4" }],
  ["path", { d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "fb3tl2" }],
  ["path", { d: "M12 4v6", key: "1dcgq2" }],
  ["path", { d: "M2 18h20", key: "ajqnye" }]
], m2e = y("BedDouble", p2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y2e = [
  ["path", { d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8", key: "1wm6mi" }],
  ["path", { d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4", key: "4k93s5" }],
  ["path", { d: "M3 18h18", key: "1h113x" }]
], g2e = y("BedSingle", y2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v2e = [
  ["path", { d: "M2 4v16", key: "vw9hq8" }],
  ["path", { d: "M2 8h18a2 2 0 0 1 2 2v10", key: "1dgv2r" }],
  ["path", { d: "M2 17h20", key: "18nfp3" }],
  ["path", { d: "M6 8v9", key: "1yriud" }]
], b2e = y("Bed", v2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w2e = [
  ["circle", { cx: "12.5", cy: "8.5", r: "2.5", key: "9738u8" }],
  [
    "path",
    {
      d: "M12.5 2a6.5 6.5 0 0 0-6.22 4.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3A6.5 6.5 0 0 0 12.5 2Z",
      key: "o0f6za"
    }
  ],
  [
    "path",
    {
      d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1 .31 2 6.49 6.49 0 0 1-2.6 5.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5",
      key: "k7p6i0"
    }
  ]
], k2e = y("Beef", w2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x2e = [
  ["path", { d: "M13 13v5", key: "igwfh0" }],
  ["path", { d: "M17 11.47V8", key: "16yw0g" }],
  ["path", { d: "M17 11h1a3 3 0 0 1 2.745 4.211", key: "1xbt65" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3", key: "c55o3e" }],
  [
    "path",
    { d: "M7.536 7.535C6.766 7.649 6.154 8 5.5 8a2.5 2.5 0 0 1-1.768-4.268", key: "1ydug7" }
  ],
  [
    "path",
    {
      d: "M8.727 3.204C9.306 2.767 9.885 2 11 2c1.56 0 2 1.5 3 1.5s1.72-.5 2.5-.5a1 1 0 1 1 0 5c-.78 0-1.5-.5-2.5-.5a3.149 3.149 0 0 0-.842.12",
      key: "q81o7q"
    }
  ],
  ["path", { d: "M9 14.6V18", key: "20ek98" }]
], M2e = y("BeerOff", x2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C2e = [
  ["path", { d: "M17 11h1a3 3 0 0 1 0 6h-1", key: "1yp76v" }],
  ["path", { d: "M9 12v6", key: "1u1cab" }],
  ["path", { d: "M13 12v6", key: "1sugkk" }],
  [
    "path",
    {
      d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
      key: "1510fo"
    }
  ],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8", key: "19jb7n" }]
], A2e = y("Beer", C2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S2e = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M13.916 2.314A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.74 7.327A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673 9 9 0 0 1-.585-.665",
      key: "1tip0g"
    }
  ],
  ["circle", { cx: "18", cy: "8", r: "3", key: "1g0gzu" }]
], L2e = y("BellDot", S2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T2e = [
  ["path", { d: "M18.8 4A6.3 8.7 0 0 1 20 9", key: "xve1fh" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["rect", { width: "10", height: "6", x: "4", y: "16", rx: "2", key: "17f3te" }],
  ["path", { d: "M14 19c3 0 4.6-1.6 4.6-1.6", key: "n7odp6" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }]
], E2e = y("BellElectric", T2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j2e = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  [
    "path",
    {
      d: "M16.243 3.757A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673A9.4 9.4 0 0 1 18.667 12",
      key: "bdwj86"
    }
  ]
], N2e = y("BellMinus", j2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D2e = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742",
      key: "178tsu"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05", key: "1hqiys" }]
], I2e = y("BellOff", D2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P2e = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  ["path", { d: "M18 5v6", key: "g5ayrv" }],
  [
    "path",
    {
      d: "M20.002 14.464a9 9 0 0 0 .738.863A1 1 0 0 1 20 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 8.75-5.332",
      key: "1abcvy"
    }
  ]
], z2e = y("BellPlus", P2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R2e = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M22 8c0-2.3-.8-4.3-2-6", key: "5bb3ad" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ],
  ["path", { d: "M4 2C2.8 3.7 2 5.7 2 8", key: "tap9e0" }]
], O2e = y("BellRing", R2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B2e = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ]
], H2e = y("Bell", B2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F2e = [
  ["rect", { width: "13", height: "7", x: "3", y: "3", rx: "1", key: "11xb64" }],
  ["path", { d: "m22 15-3-3 3-3", key: "26chmm" }],
  ["rect", { width: "13", height: "7", x: "3", y: "14", rx: "1", key: "k6ky7n" }]
], _2e = y("BetweenHorizontalEnd", F2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V2e = [
  ["rect", { width: "13", height: "7", x: "8", y: "3", rx: "1", key: "pkso9a" }],
  ["path", { d: "m2 9 3 3-3 3", key: "1agib5" }],
  ["rect", { width: "13", height: "7", x: "8", y: "14", rx: "1", key: "1q5fc1" }]
], q2e = y("BetweenHorizontalStart", V2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U2e = [
  ["rect", { width: "7", height: "13", x: "3", y: "3", rx: "1", key: "1fdu0f" }],
  ["path", { d: "m9 22 3-3 3 3", key: "17z65a" }],
  ["rect", { width: "7", height: "13", x: "14", y: "3", rx: "1", key: "1squn4" }]
], W2e = y("BetweenVerticalEnd", U2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z2e = [
  ["rect", { width: "7", height: "13", x: "3", y: "8", rx: "1", key: "1fjrkv" }],
  ["path", { d: "m15 2-3 3-3-3", key: "1uh6eb" }],
  ["rect", { width: "7", height: "13", x: "14", y: "8", rx: "1", key: "w3fjg8" }]
], G2e = y("BetweenVerticalStart", Z2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y2e = [
  [
    "path",
    {
      d: "M12.409 13.017A5 5 0 0 1 22 15c0 3.866-4 7-9 7-4.077 0-8.153-.82-10.371-2.462-.426-.316-.631-.832-.62-1.362C2.118 12.723 2.627 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.105 0-1.64-.444-2-1",
      key: "1pmlyh"
    }
  ],
  ["path", { d: "M15 14a5 5 0 0 0-7.584 2", key: "5rb254" }],
  ["path", { d: "M9.964 6.825C8.019 7.977 9.5 13 8 15", key: "kbvsx9" }]
], K2e = y("BicepsFlexed", Y2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $2e = [
  ["circle", { cx: "18.5", cy: "17.5", r: "3.5", key: "15x4ox" }],
  ["circle", { cx: "5.5", cy: "17.5", r: "3.5", key: "1noe27" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["path", { d: "M12 17.5V14l-3-3 4-3 2 3h2", key: "1npguv" }]
], J2e = y("Bike", $2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q2e = [
  ["rect", { x: "14", y: "14", width: "4", height: "6", rx: "2", key: "p02svl" }],
  ["rect", { x: "6", y: "4", width: "4", height: "6", rx: "2", key: "xm4xkj" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 10h4", key: "ru81e7" }],
  ["path", { d: "M6 14h2v6", key: "16z9wg" }],
  ["path", { d: "M14 4h2v6", key: "1idq9u" }]
], X2e = y("Binary", Q2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const epe = [
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M19 7V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3", key: "3apit1" }],
  [
    "path",
    {
      d: "M20 21a2 2 0 0 0 2-2v-3.851c0-1.39-2-2.962-2-4.829V8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2z",
      key: "rhpgnw"
    }
  ],
  ["path", { d: "M 22 16 L 2 16", key: "14lkq7" }],
  [
    "path",
    {
      d: "M4 21a2 2 0 0 1-2-2v-3.851c0-1.39 2-2.962 2-4.829V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2z",
      key: "104b3k"
    }
  ],
  ["path", { d: "M9 7V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3", key: "14fczp" }]
], tpe = y("Binoculars", epe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const npe = [
  ["circle", { cx: "12", cy: "11.9", r: "2", key: "e8h31w" }],
  ["path", { d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6", key: "17bolr" }],
  ["path", { d: "m8.9 10.1 1.4.8", key: "15ezny" }],
  ["path", { d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5", key: "wtwa5u" }],
  ["path", { d: "m15.1 10.1-1.4.8", key: "1r0b28" }],
  ["path", { d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2", key: "m7qszh" }],
  ["path", { d: "M12 13.9v1.6", key: "zfyyim" }],
  ["path", { d: "M13.5 5.4c-1-.2-2-.2-3 0", key: "1bi9q0" }],
  ["path", { d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5", key: "1rhjqw" }],
  ["path", { d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5", key: "8gsud3" }]
], rpe = y("Biohazard", npe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ipe = [
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20", key: "oj1oa8" }],
  ["path", { d: "m20 7 2 .5-2 .5", key: "12nv4d" }],
  ["path", { d: "M10 18v3", key: "1yea0a" }],
  ["path", { d: "M14 17.75V21", key: "1pymcb" }],
  ["path", { d: "M7 18a6 6 0 0 0 3.84-10.61", key: "1npnn0" }]
], ape = y("Bird", ipe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ope = [
  [
    "path",
    {
      d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727",
      key: "yr8idg"
    }
  ]
], spe = y("Bitcoin", ope);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lpe = [
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["circle", { cx: "15", cy: "15", r: "7", key: "19ennj" }]
], cpe = y("Blend", lpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const upe = [
  ["path", { d: "M3 3h18", key: "o7r712" }],
  ["path", { d: "M20 7H8", key: "gd2fo2" }],
  ["path", { d: "M20 11H8", key: "1ynp89" }],
  ["path", { d: "M10 19h10", key: "19hjk5" }],
  ["path", { d: "M8 15h12", key: "1yqzne" }],
  ["path", { d: "M4 3v14", key: "fggqzn" }],
  ["circle", { cx: "4", cy: "19", r: "2", key: "p3m9r0" }]
], dpe = y("Blinds", upe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fpe = [
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  [
    "path",
    {
      d: "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3",
      key: "1fpvtg"
    }
  ]
], hpe = y("Blocks", fpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ppe = [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "12", key: "1rsjjs" }],
  ["line", { x1: "3", x2: "6", y1: "12", y2: "12", key: "11yl8c" }]
], mpe = y("BluetoothConnected", ppe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ype = [
  ["path", { d: "m17 17-5 5V12l-5 5", key: "v5aci6" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M14.5 9.5 17 7l-5-5v4.5", key: "1kddfz" }]
], gpe = y("BluetoothOff", ype);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vpe = [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["path", { d: "M20.83 14.83a4 4 0 0 0 0-5.66", key: "k8tn1j" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
], bpe = y("BluetoothSearching", vpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wpe = [["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }]], kpe = y("Bluetooth", wpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xpe = [
  [
    "path",
    { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8", key: "mg9rjx" }
  ]
], Mpe = y("Bold", xpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cpe = [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
], Ape = y("Bolt", Cpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Spe = [
  ["circle", { cx: "11", cy: "13", r: "9", key: "hd149" }],
  [
    "path",
    {
      d: "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95",
      key: "jp4j1b"
    }
  ],
  ["path", { d: "m22 2-1.5 1.5", key: "ay92ug" }]
], Lpe = y("Bomb", Spe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tpe = [
  [
    "path",
    {
      d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z",
      key: "w610uw"
    }
  ]
], Epe = y("Bone", Tpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jpe = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m8 13 4-7 4 7", key: "4rari8" }],
  ["path", { d: "M9.1 11h5.7", key: "1gkovt" }]
], Npe = y("BookA", jpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dpe = [
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8v3", key: "gejaml" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 8v3", key: "1qzp49" }]
], Ipe = y("BookAudio", Dpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ppe = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 9.5 2 2 4-4", key: "1dth82" }]
], zpe = y("BookCheck", Ppe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rpe = [
  ["path", { d: "M2 16V4a2 2 0 0 1 2-2h11", key: "spzkk5" }],
  [
    "path",
    {
      d: "M22 18H11a2 2 0 1 0 0 4h10.5a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5H11a2 2 0 0 0-2 2v12",
      key: "1wz07i"
    }
  ],
  ["path", { d: "M5 14H4a2 2 0 1 0 0 4h1", key: "16gqf9" }]
], Ope = y("BookCopy", Rpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bpe = [
  ["path", { d: "M12 17h1.5", key: "1gkc67" }],
  ["path", { d: "M12 22h1.5", key: "1my7sn" }],
  ["path", { d: "M12 2h1.5", key: "19tvb7" }],
  ["path", { d: "M17.5 22H19a1 1 0 0 0 1-1", key: "10akbh" }],
  ["path", { d: "M17.5 2H19a1 1 0 0 1 1 1v1.5", key: "1vrfjs" }],
  ["path", { d: "M20 14v3h-2.5", key: "1naeju" }],
  ["path", { d: "M20 8.5V10", key: "1ctpfu" }],
  ["path", { d: "M4 10V8.5", key: "1o3zg5" }],
  ["path", { d: "M4 19.5V14", key: "ob81pf" }],
  ["path", { d: "M4 4.5A2.5 2.5 0 0 1 6.5 2H8", key: "s8vcyb" }],
  ["path", { d: "M8 22H6.5a1 1 0 0 1 0-5H8", key: "1cu73q" }]
], Hpe = y("BookDashed", Bpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fpe = [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 10 3 3 3-3", key: "zt5b4y" }]
], _pe = y("BookDown", Fpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vpe = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 12v-2a4 4 0 0 1 8 0v2", key: "1vsqkj" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }]
], qpe = y("BookHeadphones", Vpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Upe = [
  [
    "path",
    {
      d: "M16 8.2A2.22 2.22 0 0 0 13.8 6c-.8 0-1.4.3-1.8.9-.4-.6-1-.9-1.8-.9A2.22 2.22 0 0 0 8 8.2c0 .6.3 1.2.7 1.6A226.652 226.652 0 0 0 12 13a404 404 0 0 0 3.3-3.1 2.413 2.413 0 0 0 .7-1.7",
      key: "1t75a8"
    }
  ],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
], Wpe = y("BookHeart", Upe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zpe = [
  ["path", { d: "m20 13.7-2.1-2.1a2 2 0 0 0-2.8 0L9.7 17", key: "q6ojf0" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["circle", { cx: "10", cy: "8", r: "2", key: "2qkj4p" }]
], Gpe = y("BookImage", Zpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ype = [
  ["path", { d: "m19 3 1 1", key: "ze14oc" }],
  ["path", { d: "m20 2-4.5 4.5", key: "1sppr8" }],
  ["path", { d: "M20 8v13a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "1ocbpn" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14", key: "1gfsgw" }],
  ["circle", { cx: "14", cy: "8", r: "2", key: "u49eql" }]
], Kpe = y("BookKey", Ype);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $pe = [
  ["path", { d: "M18 6V4a2 2 0 1 0-4 0v2", key: "1aquzs" }],
  ["path", { d: "M20 15v6a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "1rkj32" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10", key: "18wgow" }],
  ["rect", { x: "12", y: "6", width: "8", height: "5", rx: "1", key: "73l30o" }]
], Jpe = y("BookLock", $pe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qpe = [
  ["path", { d: "M10 2v8l3-3 3 3V2", key: "sqw3rj" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
], Xpe = y("BookMarked", Qpe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eme = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], tme = y("BookMinus", eme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nme = [
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m16 12 2 2 4-4", key: "mdajum" }],
  [
    "path",
    {
      d: "M22 6V4a1 1 0 0 0-1-1h-5a4 4 0 0 0-4 4 4 4 0 0 0-4-4H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h6a3 3 0 0 1 3 3 3 3 0 0 1 3-3h6a1 1 0 0 0 1-1v-1.3",
      key: "8arnkb"
    }
  ]
], rme = y("BookOpenCheck", nme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ime = [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  ["path", { d: "M16 12h2", key: "7q9ll5" }],
  ["path", { d: "M16 8h2", key: "msurwy" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ],
  ["path", { d: "M6 12h2", key: "32wvfc" }],
  ["path", { d: "M6 8h2", key: "30oboj" }]
], ame = y("BookOpenText", ime);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ome = [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ]
], sme = y("BookOpen", ome);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lme = [
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], cme = y("BookPlus", lme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ume = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 11h8", key: "vwpz6n" }],
  ["path", { d: "M8 7h6", key: "1f0q6e" }]
], dme = y("BookText", ume);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fme = [
  ["path", { d: "M10 13h4", key: "ytezjc" }],
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8V6H8v2", key: "x8j6u4" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
], hme = y("BookType", fme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pme = [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M18 2h1a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "161d7n" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2", key: "1lorq7" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
], mme = y("BookUp2", pme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yme = [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
], gme = y("BookUp", yme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vme = [
  ["path", { d: "M15 13a3 3 0 1 0-6 0", key: "10j68g" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }]
], bme = y("BookUser", vme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wme = [
  ["path", { d: "m14.5 7-5 5", key: "dy991v" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9.5 7 5 5", key: "s45iea" }]
], kme = y("BookX", wme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xme = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
], Mme = y("Book", xme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cme = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
], Ame = y("BookmarkCheck", Cme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sme = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
], Lme = y("BookmarkMinus", Sme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tme = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "12", x2: "12", y1: "7", y2: "13", key: "1cppfj" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
], Eme = y("BookmarkPlus", Tme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jme = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
], Nme = y("BookmarkX", jme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dme = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }]
], Ime = y("Bookmark", Dme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pme = [
  ["path", { d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "vvzvr1" }],
  ["path", { d: "M8 8v1", key: "xcqmfk" }],
  ["path", { d: "M12 8v1", key: "1rj8u4" }],
  ["path", { d: "M16 8v1", key: "1q12zr" }],
  ["rect", { width: "20", height: "12", x: "2", y: "9", rx: "2", key: "igpb89" }],
  ["circle", { cx: "8", cy: "15", r: "2", key: "fa4a8s" }],
  ["circle", { cx: "16", cy: "15", r: "2", key: "14c3ya" }]
], zme = y("BoomBox", Pme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rme = [
  ["path", { d: "M12 6V2H8", key: "1155em" }],
  ["path", { d: "m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z", key: "w2lp3e" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M9 11v2", key: "1ueba0" }],
  ["path", { d: "M15 11v2", key: "i11awn" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }]
], Ome = y("BotMessageSquare", Rme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bme = [
  ["path", { d: "M13.67 8H18a2 2 0 0 1 2 2v4.33", key: "7az073" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }],
  ["path", { d: "M8 8H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 1.414-.586", key: "s09a7a" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }],
  ["path", { d: "M9.67 4H12v2.33", key: "110xot" }]
], Hme = y("BotOff", Bme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fme = [
  ["path", { d: "M12 8V4H8", key: "hb8ula" }],
  ["rect", { width: "16", height: "12", x: "4", y: "8", rx: "2", key: "enze0r" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M15 13v2", key: "1xurst" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }]
], _me = y("Bot", Fme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vme = [
  [
    "path",
    {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
      key: "hh9hay"
    }
  ],
  ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
  ["path", { d: "M12 22V12", key: "d0xqtd" }]
], qme = y("Box", Vme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ume = [
  [
    "path",
    {
      d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
      key: "lc1i9w"
    }
  ],
  ["path", { d: "m7 16.5-4.74-2.85", key: "1o9zyk" }],
  ["path", { d: "m7 16.5 5-3", key: "va8pkn" }],
  ["path", { d: "M7 16.5v5.17", key: "jnp8gn" }],
  [
    "path",
    {
      d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
      key: "8zsnat"
    }
  ],
  ["path", { d: "m17 16.5-5-3", key: "8arw3v" }],
  ["path", { d: "m17 16.5 4.74-2.85", key: "8rfmw" }],
  ["path", { d: "M17 16.5v5.17", key: "k6z78m" }],
  [
    "path",
    {
      d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
      key: "1xygjf"
    }
  ],
  ["path", { d: "M12 8 7.26 5.15", key: "1vbdud" }],
  ["path", { d: "m12 8 4.74-2.85", key: "3rx089" }],
  ["path", { d: "M12 13.5V8", key: "1io7kd" }]
], Wme = y("Boxes", Ume);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zme = [
  [
    "path",
    { d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1", key: "ezmyqa" }
  ],
  [
    "path",
    {
      d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1",
      key: "e1hn23"
    }
  ]
], Gme = y("Braces", Zme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yme = [
  ["path", { d: "M16 3h3v18h-3", key: "1yor1f" }],
  ["path", { d: "M8 21H5V3h3", key: "1qrfwo" }]
], Kme = y("Brackets", Yme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $me = [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  ["path", { d: "M9 13a4.5 4.5 0 0 0 3-4", key: "10igwf" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M12 13h4", key: "1ku699" }],
  ["path", { d: "M12 18h6a2 2 0 0 1 2 2v1", key: "105ag5" }],
  ["path", { d: "M12 8h8", key: "1lhi5i" }],
  ["path", { d: "M16 8V5a2 2 0 0 1 2-2", key: "u6izg6" }],
  ["circle", { cx: "16", cy: "13", r: ".5", key: "ry7gng" }],
  ["circle", { cx: "18", cy: "3", r: ".5", key: "1aiba7" }],
  ["circle", { cx: "20", cy: "21", r: ".5", key: "yhc1fs" }],
  ["circle", { cx: "20", cy: "8", r: ".5", key: "1e43v0" }]
], Jme = y("BrainCircuit", $me);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qme = [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.142 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588 4 4 0 0 0 7.636 2.106 3.2 3.2 0 0 0 .164-.546c.028-.13.306-.13.335 0a3.2 3.2 0 0 0 .163.546 4 4 0 0 0 7.636-2.106 4 4 0 0 0 .556-6.588 4 4 0 0 0-2.526-5.77A3 3 0 1 0 12 5",
      key: "1kgmhc"
    }
  ],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m15.7 10.4-.9.4", key: "ayzo6p" }],
  ["path", { d: "m9.2 13.2-.9.4", key: "1uzb3g" }],
  ["path", { d: "m13.6 15.7-.4-.9", key: "11ifqf" }],
  ["path", { d: "m10.8 9.2-.4-.9", key: "1pmk2v" }],
  ["path", { d: "m15.7 13.5-.9-.4", key: "7ng02m" }],
  ["path", { d: "m9.2 10.9-.9-.4", key: "1x66zd" }],
  ["path", { d: "m10.5 15.7.4-.9", key: "3js94g" }],
  ["path", { d: "m13.1 9.2.4-.9", key: "18n7mc" }]
], Xme = y("BrainCog", Qme);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e4e = [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z",
      key: "ep3f8r"
    }
  ],
  ["path", { d: "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4", key: "1p4c4q" }],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }]
], t4e = y("Brain", e4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n4e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 9v6", key: "199k2o" }],
  ["path", { d: "M16 15v6", key: "8rj2es" }],
  ["path", { d: "M16 3v6", key: "1j6rpj" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M8 15v6", key: "1stoo3" }],
  ["path", { d: "M8 3v6", key: "vlvjmk" }]
], r4e = y("BrickWall", n4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i4e = [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M22 13a18.15 18.15 0 0 1-20 0", key: "12hx5q" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
], a4e = y("BriefcaseBusiness", i4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o4e = [
  ["path", { d: "M10 20v2", key: "1n8e1g" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M18 20v2", key: "10uadw" }],
  ["path", { d: "M21 20H3", key: "kdqkdp" }],
  ["path", { d: "M6 20v2", key: "a9bc87" }],
  ["path", { d: "M8 16V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v12", key: "17n9tx" }],
  ["rect", { x: "4", y: "6", width: "16", height: "10", rx: "2", key: "1097i5" }]
], s4e = y("BriefcaseConveyorBelt", o4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l4e = [
  ["path", { d: "M12 11v4", key: "a6ujw6" }],
  ["path", { d: "M14 13h-4", key: "1pl8zg" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M18 6v14", key: "1mu4gy" }],
  ["path", { d: "M6 6v14", key: "1s15cj" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
], c4e = y("BriefcaseMedical", l4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u4e = [
  ["path", { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16", key: "jecpp" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
], d4e = y("Briefcase", u4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f4e = [
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2", key: "yj20xf" }],
  ["path", { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2", key: "1ltk23" }],
  ["path", { d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2", key: "1q24h9" }]
], h4e = y("BringToFront", f4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p4e = [
  ["path", { d: "m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08", key: "1styjt" }],
  [
    "path",
    {
      d: "M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z",
      key: "z0l1mu"
    }
  ]
], m4e = y("Brush", p4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y4e = [
  ["path", { d: "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2", key: "vl8zik" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M22 13h-4v-2a4 4 0 0 0-4-4h-1.3", key: "1ou0bd" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13", key: "1njkjs" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }]
], g4e = y("BugOff", y4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v4e = [
  [
    "path",
    {
      d: "M12.765 21.522a.5.5 0 0 1-.765-.424v-8.196a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "17shqo"
    }
  ],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M18 11a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6.1 6.1 0 0 0 2 4.5", key: "1tjixy" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }]
], b4e = y("BugPlay", v4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w4e = [
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }],
  [
    "path",
    {
      d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6",
      key: "xs1cw7"
    }
  ],
  ["path", { d: "M12 20v-9", key: "1qisl0" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M22 13h-4", key: "1jl80f" }],
  ["path", { d: "M17.2 17c2.1.1 3.8 1.9 3.8 4", key: "k3fwyw" }]
], k4e = y("Bug", w4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x4e = [
  ["path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z", key: "1b4qmf" }],
  ["path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "i71pzd" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2", key: "10jefs" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M10 14h4", key: "kelpxr" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
], M4e = y("Building2", x4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C4e = [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["path", { d: "M9 22v-4h6v4", key: "r93iot" }],
  ["path", { d: "M8 6h.01", key: "1dz90k" }],
  ["path", { d: "M16 6h.01", key: "1x0f13" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }]
], A4e = y("Building", C4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S4e = [
  ["path", { d: "M4 6 2 7", key: "1mqr15" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "m22 7-2-1", key: "1umjhc" }],
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 21v-2", key: "sqyl04" }]
], L4e = y("BusFront", S4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T4e = [
  ["path", { d: "M8 6v6", key: "18i7km" }],
  ["path", { d: "M15 6v6", key: "1sg6z9" }],
  ["path", { d: "M2 12h19.6", key: "de5uta" }],
  [
    "path",
    {
      d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
      key: "1wwztk"
    }
  ],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }],
  ["path", { d: "M9 18h5", key: "lrx6i" }],
  ["circle", { cx: "16", cy: "18", r: "2", key: "1v4tcr" }]
], E4e = y("Bus", T4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j4e = [
  ["path", { d: "M10 3h.01", key: "lbucoy" }],
  ["path", { d: "M14 2h.01", key: "1k8aa1" }],
  ["path", { d: "m2 9 20-5", key: "1kz0j5" }],
  ["path", { d: "M12 12V6.5", key: "1vbrij" }],
  ["rect", { width: "16", height: "10", x: "4", y: "12", rx: "3", key: "if91er" }],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
], N4e = y("CableCar", j4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D4e = [
  [
    "path",
    {
      d: "M17 21v-2a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1",
      key: "10bnsj"
    }
  ],
  ["path", { d: "M19 15V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V9", key: "1eqmu1" }],
  ["path", { d: "M21 21v-2h-4", key: "14zm7j" }],
  ["path", { d: "M3 5h4V3", key: "z442eg" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1V3", key: "ebdjd7" }
  ]
], I4e = y("Cable", D4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P4e = [
  ["circle", { cx: "9", cy: "7", r: "2", key: "1305pl" }],
  [
    "path",
    { d: "M7.2 7.9 3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6", key: "xle13f" }
  ],
  ["path", { d: "M16 13H3", key: "1wpj08" }],
  ["path", { d: "M16 17H3", key: "3lvfcd" }]
], z4e = y("CakeSlice", P4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R4e = [
  ["path", { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8", key: "1w3rig" }],
  ["path", { d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1", key: "n2jgmb" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M7 8v3", key: "1qtyvj" }],
  ["path", { d: "M12 8v3", key: "hwp4zt" }],
  ["path", { d: "M17 8v3", key: "1i6e5u" }],
  ["path", { d: "M7 4h.01", key: "1bh4kh" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M17 4h.01", key: "1upcoc" }]
], O4e = y("Cake", R4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B4e = [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["line", { x1: "8", x2: "16", y1: "6", y2: "6", key: "x4nwl0" }],
  ["line", { x1: "16", x2: "16", y1: "14", y2: "18", key: "wjye3r" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
], H4e = y("Calculator", B4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F4e = [
  ["path", { d: "M11 14h1v4", key: "fy54vd" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
], _4e = y("Calendar1", F4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V4e = [
  ["path", { d: "m14 18 4 4 4-4", key: "1waygx" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M18 14v8", key: "irew45" }],
  [
    "path",
    { d: "M21 11.354V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.343", key: "bse4f3" }
  ],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
], q4e = y("CalendarArrowDown", V4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U4e = [
  ["path", { d: "m14 18 4-4 4 4", key: "ftkppy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M18 22v-8", key: "su0gjh" }],
  ["path", { d: "M21 11.343V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9", key: "1exg90" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
], W4e = y("CalendarArrowUp", U4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z4e = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "bce9hv" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
], G4e = y("CalendarCheck2", Z4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y4e = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m9 16 2 2 4-4", key: "19s6y9" }]
], K4e = y("CalendarCheck", Y4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $4e = [
  ["path", { d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5", key: "1osxxc" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h5", key: "r794hk" }],
  ["path", { d: "M17.5 17.5 16 16.3V14", key: "akvzfd" }],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }]
], J4e = y("CalendarClock", $4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q4e = [
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "M21 10.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "11kmuh" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
], X4e = y("CalendarCog", Q4e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eye = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
], tye = y("CalendarDays", eye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nye = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 17V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11Z", key: "kg77oy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M15 22v-4a2 2 0 0 1 2-2h4", key: "1gnbqr" }]
], rye = y("CalendarFold", nye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iye = [
  ["path", { d: "M3 10h18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7", key: "136lmk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  [
    "path",
    {
      d: "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1t7hil"
    }
  ]
], aye = y("CalendarHeart", iye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oye = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }]
], sye = y("CalendarMinus2", oye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lye = [
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 15V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.5", key: "1scpom" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
], cye = y("CalendarMinus", lye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uye = [
  ["path", { d: "M4.2 4.2A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18", key: "16swn3" }],
  ["path", { d: "M21 15.5V6a2 2 0 0 0-2-2H9.5", key: "yhw86o" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h7", key: "1wap6i" }],
  ["path", { d: "M21 10h-5.5", key: "quycpq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], dye = y("CalendarOff", uye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fye = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }],
  ["path", { d: "M12 14v4", key: "1thi36" }]
], hye = y("CalendarPlus2", fye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pye = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }]
], mye = y("CalendarPlus", pye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yye = [
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M17 14h-6", key: "bkmgh3" }],
  ["path", { d: "M13 18H7", key: "bb0bb7" }],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 18h.01", key: "1bdyru" }]
], gye = y("CalendarRange", yye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vye = [
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 11.75V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.25", key: "1jrsq6" }],
  ["path", { d: "m22 22-1.875-1.875", key: "13zax7" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
], bye = y("CalendarSearch", vye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wye = [
  ["path", { d: "M11 10v4h4", key: "172dkj" }],
  ["path", { d: "m11 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "vu0qm5" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "m21 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "1qgeyt" }],
  ["path", { d: "M21 22v-4h-4", key: "hrummi" }],
  ["path", { d: "M21 8.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.3", key: "mctw84" }],
  ["path", { d: "M3 10h4", key: "1el30a" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
], kye = y("CalendarSync", wye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xye = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m17 22 5-5", key: "1k6ppv" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }]
], Mye = y("CalendarX2", xye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cye = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m14 14-4 4", key: "rymu2i" }],
  ["path", { d: "m10 14 4 4", key: "3sz06r" }]
], Aye = y("CalendarX", Cye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sye = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], Lye = y("Calendar", Sye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tye = [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16", key: "qmtpty" }],
  ["path", { d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5", key: "1ufyfc" }],
  ["path", { d: "M14.121 15.121A3 3 0 1 1 9.88 10.88", key: "11zox6" }]
], Eye = y("CameraOff", Tye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jye = [
  [
    "path",
    {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
      key: "1tc9qg"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
], Nye = y("Camera", jye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dye = [
  [
    "path",
    {
      d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z",
      key: "isaq8g"
    }
  ],
  ["path", { d: "M17.75 7 15 2.1", key: "12x7e8" }],
  ["path", { d: "M10.9 4.8 13 9", key: "100a87" }],
  ["path", { d: "m7.9 9.7 2 4.4", key: "ntfhaj" }],
  ["path", { d: "M4.9 14.7 7 18.9", key: "1x43jy" }]
], Iye = y("CandyCane", Dye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pye = [
  ["path", { d: "m8.5 8.5-1 1a4.95 4.95 0 0 0 7 7l1-1", key: "1ff4ui" }],
  [
    "path",
    { d: "M11.843 6.187A4.947 4.947 0 0 1 16.5 7.5a4.947 4.947 0 0 1 1.313 4.657", key: "1sbrv4" }
  ],
  ["path", { d: "M14 16.5V14", key: "1maf8j" }],
  ["path", { d: "M14 6.5v1.843", key: "1a6u6t" }],
  ["path", { d: "M10 10v7.5", key: "80pj65" }],
  [
    "path",
    {
      d: "m16 7 1-5 1.367.683A3 3 0 0 0 19.708 3H21v1.292a3 3 0 0 0 .317 1.341L22 7l-5 1",
      key: "11a9mt"
    }
  ],
  [
    "path",
    {
      d: "m8 17-1 5-1.367-.683A3 3 0 0 0 4.292 21H3v-1.292a3 3 0 0 0-.317-1.341L2 17l5-1",
      key: "3mjmon"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], zye = y("CandyOff", Pye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rye = [
  ["path", { d: "m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z", key: "ue6khb" }],
  ["path", { d: "M14 6.5v10", key: "5xnk7c" }],
  ["path", { d: "M10 7.5v10", key: "1uew51" }],
  [
    "path",
    { d: "m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1", key: "b9cp6k" }
  ],
  [
    "path",
    { d: "m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1", key: "5lney8" }
  ]
], Oye = y("Candy", Rye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bye = [
  ["path", { d: "M12 22v-4", key: "1utk9m" }],
  [
    "path",
    {
      d: "M7 12c-1.5 0-4.5 1.5-5 3 3.5 1.5 6 1 6 1-1.5 1.5-2 3.5-2 5 2.5 0 4.5-1.5 6-3 1.5 1.5 3.5 3 6 3 0-1.5-.5-3.5-2-5 0 0 2.5.5 6-1-.5-1.5-3.5-3-5-3 1.5-1 4-4 4-6-2.5 0-5.5 1.5-7 3 0-2.5-.5-5-2-7-1.5 2-2 4.5-2 7-1.5-1.5-4.5-3-7-3 0 2 2.5 5 4 6",
      key: "1mezod"
    }
  ]
], Hye = y("Cannabis", Bye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fye = [
  ["path", { d: "M10.5 5H19a2 2 0 0 1 2 2v8.5", key: "jqtk4d" }],
  ["path", { d: "M17 11h-.5", key: "1961ue" }],
  ["path", { d: "M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2", key: "1keqsi" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7 11h4", key: "1o1z6v" }],
  ["path", { d: "M7 15h2.5", key: "1ina1g" }]
], _ye = y("CaptionsOff", Fye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vye = [
  ["rect", { width: "18", height: "14", x: "3", y: "5", rx: "2", ry: "2", key: "12ruh7" }],
  ["path", { d: "M7 15h4M15 15h2M7 11h2M13 11h4", key: "1ueiar" }]
], qye = y("Captions", Vye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uye = [
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
], Wye = y("CarFront", Uye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zye = [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
], Gye = y("CarTaxiFront", Zye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yye = [
  [
    "path",
    {
      d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
      key: "5owen"
    }
  ],
  ["circle", { cx: "7", cy: "17", r: "2", key: "u2ysq9" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }],
  ["circle", { cx: "17", cy: "17", r: "2", key: "axvx0g" }]
], Kye = y("Car", Yye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ye = [
  ["path", { d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2", key: "19jm3t" }],
  ["path", { d: "M2 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2", key: "13hakp" }],
  ["path", { d: "M22 17v1a1 1 0 0 1-1 1H10v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9", key: "1crci8" }],
  ["circle", { cx: "8", cy: "19", r: "2", key: "t8fc5s" }]
], Jye = y("Caravan", $ye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qye = [
  [
    "path",
    {
      d: "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46",
      key: "rfqxbe"
    }
  ],
  ["path", { d: "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z", key: "6b25w4" }],
  ["path", { d: "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z", key: "fn65lo" }]
], Xye = y("Carrot", Qye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e3e = [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }]
], t3e = y("CaseLower", e3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n3e = [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["circle", { cx: "18", cy: "12", r: "3", key: "1kchzo" }],
  ["path", { d: "M21 9v6", key: "anns31" }]
], r3e = y("CaseSensitive", n3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i3e = [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["path", { d: "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4", key: "1sqfas" }]
], a3e = y("CaseUpper", i3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o3e = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["circle", { cx: "8", cy: "10", r: "2", key: "1xl4ub" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "10", r: "2", key: "r14t7q" }],
  ["path", { d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3", key: "l01ucn" }]
], s3e = y("CassetteTape", o3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l3e = [
  ["path", { d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6", key: "3zrzxg" }],
  ["path", { d: "M2 12a9 9 0 0 1 8 8", key: "g6cvee" }],
  ["path", { d: "M2 16a5 5 0 0 1 4 4", key: "1y1dii" }],
  ["line", { x1: "2", x2: "2.01", y1: "20", y2: "20", key: "xu2jvo" }]
], c3e = y("Cast", l3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u3e = [
  ["path", { d: "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z", key: "109fe4" }],
  ["path", { d: "M18 11V4H6v7", key: "mon5oj" }],
  ["path", { d: "M15 22v-4a3 3 0 0 0-3-3a3 3 0 0 0-3 3v4", key: "1k4jtn" }],
  ["path", { d: "M22 11V9", key: "3zbp94" }],
  ["path", { d: "M2 11V9", key: "1x5rnq" }],
  ["path", { d: "M6 4V2", key: "1rsq15" }],
  ["path", { d: "M18 4V2", key: "1jsdo1" }],
  ["path", { d: "M10 4V2", key: "75d9ly" }],
  ["path", { d: "M14 4V2", key: "8nj3z6" }]
], d3e = y("Castle", u3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f3e = [
  [
    "path",
    {
      d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z",
      key: "x6xyqk"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }]
], h3e = y("Cat", f3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p3e = [
  [
    "path",
    {
      d: "M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97",
      key: "ir91b5"
    }
  ],
  [
    "path",
    {
      d: "M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z",
      key: "jlp8i1"
    }
  ],
  ["path", { d: "M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15", key: "19bib8" }],
  ["path", { d: "M2 21v-4", key: "l40lih" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }]
], m3e = y("Cctv", p3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y3e = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  [
    "path",
    {
      d: "M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z",
      key: "q0gr47"
    }
  ]
], g3e = y("ChartArea", y3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v3e = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1", key: "1iip1u" }],
  ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1", key: "1anskk" }]
], b3e = y("ChartBarBig", v3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w3e = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 11h8", key: "1feolt" }],
  ["path", { d: "M7 16h3", key: "ur6vzw" }],
  ["path", { d: "M7 6h12", key: "sz5b0d" }]
], k3e = y("ChartBarDecreasing", w3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x3e = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 11h8", key: "1feolt" }],
  ["path", { d: "M7 16h12", key: "wsnu98" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
], M3e = y("ChartBarIncreasing", x3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C3e = [
  ["path", { d: "M11 13v4", key: "vyy2rb" }],
  ["path", { d: "M15 5v4", key: "1gx88a" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1", key: "1iip1u" }],
  ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1", key: "1anskk" }]
], A3e = y("ChartBarStacked", C3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S3e = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 16h8", key: "srdodz" }],
  ["path", { d: "M7 11h12", key: "127s9w" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
], L3e = y("ChartBar", S3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T3e = [
  ["path", { d: "M9 5v4", key: "14uxtq" }],
  ["rect", { width: "4", height: "6", x: "7", y: "9", rx: "1", key: "f4fvz0" }],
  ["path", { d: "M9 15v2", key: "r5rk32" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["rect", { width: "4", height: "8", x: "15", y: "5", rx: "1", key: "z38je5" }],
  ["path", { d: "M17 13v3", key: "5l0wba" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }]
], E3e = y("ChartCandlestick", T3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j3e = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1", key: "q8uenq" }],
  ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1", key: "sr5ea" }]
], N3e = y("ChartColumnBig", j3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D3e = [
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17v-3", key: "1sqioe" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 17V5", key: "1wzmnc" }]
], I3e = y("ChartColumnDecreasing", D3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P3e = [
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17V5", key: "sfb6ij" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
], z3e = y("ChartColumnIncreasing", P3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R3e = [
  ["path", { d: "M11 13H7", key: "t0o9gq" }],
  ["path", { d: "M19 9h-4", key: "rera1j" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1", key: "q8uenq" }],
  ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1", key: "sr5ea" }]
], O3e = y("ChartColumnStacked", R3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B3e = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M18 17V9", key: "2bz60n" }],
  ["path", { d: "M13 17V5", key: "1frdt8" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
], H3e = y("ChartColumn", B3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F3e = [
  ["path", { d: "M10 6h8", key: "zvc2xc" }],
  ["path", { d: "M12 16h6", key: "yi5mkt" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 11h7", key: "wz2hg0" }]
], _3e = y("ChartGantt", F3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V3e = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "m19 9-5 5-4-4-3 3", key: "2osh9i" }]
], q3e = y("ChartLine", V3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U3e = [
  ["path", { d: "m13.11 7.664 1.78 2.672", key: "go2gg9" }],
  ["path", { d: "m14.162 12.788-3.324 1.424", key: "11x848" }],
  ["path", { d: "m20 4-6.06 1.515", key: "1wxxh7" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["circle", { cx: "12", cy: "6", r: "2", key: "1jj5th" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }],
  ["circle", { cx: "9", cy: "15", r: "2", key: "lf2ghp" }]
], W3e = y("ChartNetwork", U3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z3e = [
  ["path", { d: "M12 20V10", key: "g8npz5" }],
  ["path", { d: "M18 20v-4", key: "8uic4z" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }]
], G3e = y("ChartNoAxesColumnDecreasing", Z3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y3e = [
  ["line", { x1: "12", x2: "12", y1: "20", y2: "10", key: "1vz5eb" }],
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "16", key: "hq0ia6" }]
], K3e = y("ChartNoAxesColumnIncreasing", Y3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $3e = [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "10", key: "1xfpm4" }],
  ["line", { x1: "12", x2: "12", y1: "20", y2: "4", key: "be30l9" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "14", key: "1r4le6" }]
], J3e = y("ChartNoAxesColumn", $3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q3e = [
  ["path", { d: "M12 16v5", key: "zza2cw" }],
  ["path", { d: "M16 14v7", key: "1g90b9" }],
  ["path", { d: "M20 10v11", key: "1iqoj0" }],
  [
    "path",
    { d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15", key: "1fw8x9" }
  ],
  ["path", { d: "M4 18v3", key: "1yp0dc" }],
  ["path", { d: "M8 14v7", key: "n3cwzv" }]
], X3e = y("ChartNoAxesCombined", Q3e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ege = [
  ["path", { d: "M8 6h10", key: "9lnwnk" }],
  ["path", { d: "M6 12h9", key: "1g9pqf" }],
  ["path", { d: "M11 18h7", key: "c8dzvl" }]
], tge = y("ChartNoAxesGantt", ege);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nge = [
  [
    "path",
    {
      d: "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z",
      key: "pzmjnu"
    }
  ],
  ["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83", key: "k2fpak" }]
], rge = y("ChartPie", nge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ige = [
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["circle", { cx: "18.5", cy: "5.5", r: ".5", fill: "currentColor", key: "lysivs" }],
  ["circle", { cx: "11.5", cy: "11.5", r: ".5", fill: "currentColor", key: "byv1b8" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["circle", { cx: "17.5", cy: "14.5", r: ".5", fill: "currentColor", key: "1gjh6j" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }]
], age = y("ChartScatter", ige);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oge = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 16c.5-2 1.5-7 4-7 2 0 2 3 4 3 2.5 0 4.5-5 5-7", key: "lw07rv" }]
], sge = y("ChartSpline", oge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lge = [
  ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
  ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
], cge = y("CheckCheck", lge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uge = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Ox = y("Check", uge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dge = [
  [
    "path",
    {
      d: "M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z",
      key: "1qvrer"
    }
  ],
  ["path", { d: "M6 17h12", key: "1jwigz" }]
], fge = y("ChefHat", dge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hge = [
  ["path", { d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "cvxqlc" }],
  ["path", { d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "1ostrc" }],
  ["path", { d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12", key: "hqx58h" }],
  ["path", { d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z", key: "eykp1o" }]
], pge = y("Cherry", hge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mge = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], Ig = y("ChevronDown", mge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yge = [
  ["path", { d: "m17 18-6-6 6-6", key: "1yerx2" }],
  ["path", { d: "M7 6v12", key: "1p53r6" }]
], gge = y("ChevronFirst", yge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vge = [
  ["path", { d: "m7 18 6-6-6-6", key: "lwmzdw" }],
  ["path", { d: "M17 6v12", key: "1o0aio" }]
], bge = y("ChevronLast", vge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wge = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], kge = y("ChevronLeft", wge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xge = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], Mge = y("ChevronRight", xge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cge = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], EF = y("ChevronUp", Cge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Age = [
  ["path", { d: "m7 20 5-5 5 5", key: "13a0gw" }],
  ["path", { d: "m7 4 5 5 5-5", key: "1kwcof" }]
], Sge = y("ChevronsDownUp", Age);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lge = [
  ["path", { d: "m7 6 5 5 5-5", key: "1lc07p" }],
  ["path", { d: "m7 13 5 5 5-5", key: "1d48rs" }]
], Tge = y("ChevronsDown", Lge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ege = [
  ["path", { d: "m18 8 4 4-4 4", key: "1ak13k" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
], jge = y("ChevronsLeftRightEllipsis", Ege);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nge = [
  ["path", { d: "m9 7-5 5 5 5", key: "j5w590" }],
  ["path", { d: "m15 7 5 5-5 5", key: "1bl6da" }]
], Dge = y("ChevronsLeftRight", Nge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ige = [
  ["path", { d: "m11 17-5-5 5-5", key: "13zhaf" }],
  ["path", { d: "m18 17-5-5 5-5", key: "h8a8et" }]
], Pge = y("ChevronsLeft", Ige);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zge = [
  ["path", { d: "m20 17-5-5 5-5", key: "30x0n2" }],
  ["path", { d: "m4 17 5-5-5-5", key: "16spf4" }]
], Rge = y("ChevronsRightLeft", zge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oge = [
  ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
  ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }]
], Bge = y("ChevronsRight", Oge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hge = [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
], Fge = y("ChevronsUpDown", Hge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ge = [
  ["path", { d: "m17 11-5-5-5 5", key: "e8nh98" }],
  ["path", { d: "m17 18-5-5-5 5", key: "2avn1x" }]
], Vge = y("ChevronsUp", _ge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qge = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["line", { x1: "21.17", x2: "12", y1: "8", y2: "8", key: "a0cw5f" }],
  ["line", { x1: "3.95", x2: "8.54", y1: "6.06", y2: "14", key: "1kftof" }],
  ["line", { x1: "10.88", x2: "15.46", y1: "21.94", y2: "14", key: "1ymyh8" }]
], Uge = y("Chrome", qge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wge = [
  ["path", { d: "M10 9h4", key: "u4k05v" }],
  ["path", { d: "M12 7v5", key: "ma6bk" }],
  ["path", { d: "M14 22v-4a2 2 0 0 0-4 0v4", key: "1pdhuj" }],
  [
    "path",
    {
      d: "M18 22V5.618a1 1 0 0 0-.553-.894l-4.553-2.277a2 2 0 0 0-1.788 0L6.553 4.724A1 1 0 0 0 6 5.618V22",
      key: "1rkokr"
    }
  ],
  [
    "path",
    {
      d: "m18 7 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.618a1 1 0 0 1 .553-.894L6 7",
      key: "1w6esw"
    }
  ]
], Zge = y("Church", Wge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gge = [
  ["path", { d: "M12 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h13", key: "1gdiyg" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 12a1 1 0 0 1 1 1v2a1 1 0 0 1-.5.866", key: "166zjj" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ["path", { d: "M7 12v4", key: "jqww69" }]
], Yge = y("CigaretteOff", Gge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kge = [
  ["path", { d: "M17 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h14", key: "1mb5g1" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "M21 16a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1", key: "1yl5r7" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ["path", { d: "M7 12v4", key: "jqww69" }]
], $ge = y("Cigarette", Kge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jge = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], Qge = y("CircleAlert", Jge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xge = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
], e6e = y("CircleArrowDown", Xge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }]
], n6e = y("CircleArrowLeft", t6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r6e = [
  ["path", { d: "M2 12a10 10 0 1 1 10 10", key: "1yn6ov" }],
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "M8 22H2v-6", key: "sulq54" }]
], i6e = y("CircleArrowOutDownLeft", r6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a6e = [
  ["path", { d: "M12 22a10 10 0 1 1 10-10", key: "130bv5" }],
  ["path", { d: "M22 22 12 12", key: "131aw7" }],
  ["path", { d: "M22 16v6h-6", key: "1gvm70" }]
], o6e = y("CircleArrowOutDownRight", a6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s6e = [
  ["path", { d: "M2 8V2h6", key: "hiwtdz" }],
  ["path", { d: "m2 2 10 10", key: "1oh8rs" }],
  ["path", { d: "M12 2A10 10 0 1 1 2 12", key: "rrk4fa" }]
], l6e = y("CircleArrowOutUpLeft", s6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c6e = [
  ["path", { d: "M22 12A10 10 0 1 1 12 2", key: "1fm58d" }],
  ["path", { d: "M22 2 12 12", key: "yg2myt" }],
  ["path", { d: "M16 2h6v6", key: "zan5cs" }]
], u6e = y("CircleArrowOutUpRight", c6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
], f6e = y("CircleArrowRight", d6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
], p6e = y("CircleArrowUp", h6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m6e = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], y6e = y("CircleCheckBig", m6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], v6e = y("CircleCheck", g6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
], w6e = y("CircleChevronDown", b6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
], x6e = y("CircleChevronLeft", k6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
], C6e = y("CircleChevronRight", M6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
], S6e = y("CircleChevronUp", A6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L6e = [
  ["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0", key: "5ilxe3" }],
  ["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0", key: "11zvb9" }],
  ["path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7", key: "1iw5b2" }],
  ["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8", key: "c0bmvh" }],
  ["path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69", key: "1ruxm7" }],
  ["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8", key: "qkgqxc" }],
  ["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69", key: "1mcia2" }],
  ["path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7", key: "1fvljs" }]
], T6e = y("CircleDashed", L6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E6e = [
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], j6e = y("CircleDivide", E6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
], D6e = y("CircleDollarSign", N6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I6e = [
  ["path", { d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0", key: "1qdqn0" }],
  ["path", { d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7", key: "1bq7p6" }],
  ["path", { d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8", key: "1rlaqf" }],
  ["path", { d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69", key: "1xk03u" }],
  ["path", { d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0", key: "l7re25" }],
  ["path", { d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7", key: "1v18p6" }],
  ["path", { d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8", key: "xdo6bj" }],
  ["path", { d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69", key: "1jjmaz" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], P6e = y("CircleDotDashed", I6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], R6e = y("CircleDot", z6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
], B6e = y("CircleEllipsis", O6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H6e = [
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], F6e = y("CircleEqual", H6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _6e = [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
], V6e = y("CircleFadingArrowUp", _6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q6e = [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
], U6e = y("CircleFadingPlus", q6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W6e = [
  ["path", { d: "M15.6 2.7a10 10 0 1 0 5.7 5.7", key: "1e0p6d" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M13.4 10.6 19 5", key: "1kr7tw" }]
], Z6e = y("CircleGauge", W6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], Y6e = y("CircleHelp", G6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], $6e = y("CircleMinus", K6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J6e = [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65", key: "1pfsoa" }],
  ["path", { d: "M19.08 19.08A10 10 0 1 1 4.92 4.92", key: "1ablyi" }]
], Q6e = y("CircleOff", J6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X6e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.34", key: "a9qo08" }]
], e5e = y("CircleParkingOff", X6e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t5e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
], n5e = y("CircleParking", t5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r5e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "10", x2: "10", y1: "15", y2: "9", key: "c1nkhi" }],
  ["line", { x1: "14", x2: "14", y1: "15", y2: "9", key: "h65svq" }]
], i5e = y("CirclePause", r5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a5e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
], o5e = y("CirclePercent", a5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s5e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polygon", { points: "10 8 16 12 10 16 10 8", key: "1cimsy" }]
], l5e = y("CirclePlay", s5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c5e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], u5e = y("CirclePlus", c5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d5e = [
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005", key: "1pek45" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], f5e = y("CirclePower", d5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h5e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M22 2 2 22", key: "y4kqgn" }]
], p5e = y("CircleSlash2", h5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m5e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
], y5e = y("CircleSlash", m5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g5e = [["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }]], v5e = y("CircleSmall", g5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b5e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1", key: "1ssd4o" }]
], w5e = y("CircleStop", b5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k5e = [
  ["path", { d: "M18 20a6 6 0 0 0-12 0", key: "1qehca" }],
  ["circle", { cx: "12", cy: "10", r: "4", key: "1h16sb" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], x5e = y("CircleUserRound", k5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M5e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662", key: "154egf" }]
], C5e = y("CircleUser", M5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A5e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], S5e = y("CircleX", A5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L5e = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], T5e = y("Circle", L5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E5e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M11 9h4a2 2 0 0 0 2-2V3", key: "1ve2rv" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "M7 21v-4a2 2 0 0 1 2-2h4", key: "1fwkro" }],
  ["circle", { cx: "15", cy: "15", r: "2", key: "3i40o0" }]
], j5e = y("CircuitBoard", E5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N5e = [
  [
    "path",
    {
      d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
      key: "4ite01"
    }
  ],
  ["path", { d: "M19.65 15.66A8 8 0 0 1 8.35 4.34", key: "1gxipu" }],
  ["path", { d: "m14 10-5.5 5.5", key: "92pfem" }],
  ["path", { d: "M14 17.85V10H6.15", key: "xqmtsk" }]
], D5e = y("Citrus", N5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I5e = [
  [
    "path",
    { d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z", key: "1tn4o7" }
  ],
  ["path", { d: "m6.2 5.3 3.1 3.9", key: "iuk76l" }],
  ["path", { d: "m12.4 3.4 3.1 4", key: "6hsd6n" }],
  ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z", key: "ltgou9" }]
], P5e = y("Clapperboard", I5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z5e = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m9 14 2 2 4-4", key: "df797q" }]
], R5e = y("ClipboardCheck", z5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O5e = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2", key: "4jdomd" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v4", key: "3hqy98" }],
  ["path", { d: "M21 14H11", key: "1bme5i" }],
  ["path", { d: "m15 10-4 4 4 4", key: "5dvupr" }]
], B5e = y("ClipboardCopy", O5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H5e = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M12 11h4", key: "1jrz19" }],
  ["path", { d: "M12 16h4", key: "n85exb" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
], F5e = y("ClipboardList", H5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _5e = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }]
], V5e = y("ClipboardMinus", _5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q5e = [
  [
    "path",
    { d: "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z", key: "1pp7kr" }
  ],
  [
    "path",
    {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10",
      key: "2ik1ml"
    }
  ],
  ["path", { d: "m17 10 4 4-4 4", key: "vp2hj1" }]
], U5e = y("ClipboardPaste", q5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W5e = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5", key: "1but9f" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 1.73 1", key: "1p8n7l" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ]
], Z5e = y("ClipboardPenLine", W5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G5e = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5", key: "cereej" }],
  ["path", { d: "M4 13.5V6a2 2 0 0 1 2-2h2", key: "5ua5vh" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
], Y5e = y("ClipboardPen", G5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K5e = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }],
  ["path", { d: "M12 17v-6", key: "1y8rbf" }]
], $5e = y("ClipboardPlus", K5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J5e = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 12v-1h6v1", key: "iehl6m" }],
  ["path", { d: "M11 17h2", key: "12w5me" }],
  ["path", { d: "M12 11v6", key: "1bwqyc" }]
], Q5e = y("ClipboardType", J5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X5e = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m15 11-6 6", key: "1toa9n" }],
  ["path", { d: "m9 11 6 6", key: "wlibny" }]
], e8e = y("ClipboardX", X5e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t8e = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ]
], n8e = y("Clipboard", t8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r8e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 8", key: "12zbmj" }]
], i8e = y("Clock1", r8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a8e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 10", key: "atfzqc" }]
], o8e = y("Clock10", a8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s8e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 8", key: "l5bg6f" }]
], l8e = y("Clock11", s8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c8e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12", key: "1fub01" }]
], u8e = y("Clock12", c8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d8e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 10", key: "1g230d" }]
], f8e = y("Clock2", d8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h8e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16.5 12", key: "1aq6pp" }]
], p8e = y("Clock3", h8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m8e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
], y8e = y("Clock4", m8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g8e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 16", key: "1pcbox" }]
], v8e = y("Clock5", g8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b8e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 12 16.5", key: "hb2qv6" }]
], w8e = y("Clock6", b8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k8e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 16", key: "ka3394" }]
], x8e = y("Clock7", k8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M8e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 14", key: "tmc9b4" }]
], C8e = y("Clock8", M8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A8e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 7.5 12", key: "1k60p0" }]
], S8e = y("Clock9", A8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L8e = [
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }],
  ["path", { d: "M16 21.16a10 10 0 1 1 5-13.516", key: "cxo92l" }],
  ["path", { d: "M20 11.5v6", key: "2ei3xq" }],
  ["path", { d: "M20 21.5h.01", key: "1r2dzp" }]
], T8e = y("ClockAlert", L8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E8e = [
  ["path", { d: "M12.338 21.994A10 10 0 1 1 21.925 13.227", key: "1i7shu" }],
  ["path", { d: "M12 6v6l2 1", key: "19cm8n" }],
  ["path", { d: "m14 18 4 4 4-4", key: "1waygx" }],
  ["path", { d: "M18 14v8", key: "irew45" }]
], j8e = y("ClockArrowDown", E8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N8e = [
  ["path", { d: "M13.228 21.925A10 10 0 1 1 21.994 12.338", key: "1fzlyi" }],
  ["path", { d: "M12 6v6l1.562.781", key: "1ujuk9" }],
  ["path", { d: "m14 18 4-4 4 4", key: "ftkppy" }],
  ["path", { d: "M18 22v-8", key: "su0gjh" }]
], D8e = y("ClockArrowUp", N8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I8e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
], P8e = y("Clock", I8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z8e = [
  ["path", { d: "M12 12v4", key: "tww15h" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M17 18h.5a1 1 0 0 0 0-9h-1.79A7 7 0 1 0 7 17.708", key: "xsb5ju" }]
], R8e = y("CloudAlert", z8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O8e = [
  ["circle", { cx: "12", cy: "17", r: "3", key: "1spfwm" }],
  ["path", { d: "M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2", key: "zaobp" }],
  ["path", { d: "m15.7 18.4-.9-.3", key: "4qxpbn" }],
  ["path", { d: "m9.2 15.9-.9-.3", key: "17q7o2" }],
  ["path", { d: "m10.6 20.7.3-.9", key: "1pf4s2" }],
  ["path", { d: "m13.1 14.2.3-.9", key: "1mnuqm" }],
  ["path", { d: "m13.6 20.7-.4-1", key: "1jpd1m" }],
  ["path", { d: "m10.8 14.3-.4-1", key: "17ugyy" }],
  ["path", { d: "m8.3 18.6 1-.4", key: "s42vdx" }],
  ["path", { d: "m14.7 15.8 1-.4", key: "2wizun" }]
], B8e = y("CloudCog", O8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H8e = [
  ["path", { d: "M12 13v8l-4-4", key: "1f5nwf" }],
  ["path", { d: "m12 21 4-4", key: "1lfcce" }],
  ["path", { d: "M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284", key: "ui1hmy" }]
], F8e = y("CloudDownload", H8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _8e = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 19v1", key: "1dk2by" }],
  ["path", { d: "M8 14v1", key: "84yxot" }],
  ["path", { d: "M16 19v1", key: "v220m7" }],
  ["path", { d: "M16 14v1", key: "g12gj6" }],
  ["path", { d: "M12 21v1", key: "q8vafk" }],
  ["path", { d: "M12 16v1", key: "1mx6rx" }]
], V8e = y("CloudDrizzle", _8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q8e = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 17H7", key: "pygtm1" }],
  ["path", { d: "M17 21H9", key: "1u2q02" }]
], U8e = y("CloudFog", q8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W8e = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v2", key: "a1is7l" }],
  ["path", { d: "M8 14v2", key: "1e9m6t" }],
  ["path", { d: "M16 20h.01", key: "xwek51" }],
  ["path", { d: "M8 20h.01", key: "1vjney" }],
  ["path", { d: "M12 16v2", key: "z66u1j" }],
  ["path", { d: "M12 22h.01", key: "1urd7a" }]
], Z8e = y("CloudHail", W8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G8e = [
  ["path", { d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973", key: "1cez44" }],
  ["path", { d: "m13 12-3 5h4l-3 5", key: "1t22er" }]
], Y8e = y("CloudLightning", G8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K8e = [
  ["path", { d: "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "erj67n" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
], $8e = y("CloudMoonRain", K8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J8e = [
  ["path", { d: "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "erj67n" }],
  ["path", { d: "M13 16a3 3 0 1 1 0 6H7a5 5 0 1 1 4.9-6Z", key: "p44pc9" }]
], Q8e = y("CloudMoon", J8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X8e = [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193", key: "yfwify" }],
  [
    "path",
    { d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07", key: "jlfiyv" }
  ]
], eve = y("CloudOff", X8e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tve = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m9.2 22 3-7", key: "sb5f6j" }],
  ["path", { d: "m9 13-3 7", key: "500co5" }],
  ["path", { d: "m17 13-3 7", key: "8t2fiy" }]
], nve = y("CloudRainWind", tve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rve = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v6", key: "1j4efv" }],
  ["path", { d: "M8 14v6", key: "17c4r9" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
], ive = y("CloudRain", rve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ave = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M8 19h.01", key: "puxtts" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M12 21h.01", key: "h35vbk" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M16 19h.01", key: "1vcnzz" }]
], ove = y("CloudSnow", ave);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sve = [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
], lve = y("CloudSunRain", sve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cve = [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z", key: "s09mg5" }]
], uve = y("CloudSun", cve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dve = [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m8 17 4-4 4 4", key: "1quai1" }]
], fve = y("CloudUpload", dve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hve = [
  ["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "p7xjir" }]
], pve = y("Cloud", hve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mve = [
  ["path", { d: "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "gqqjvc" }],
  ["path", { d: "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5", key: "1p2s76" }]
], yve = y("Cloudy", mve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gve = [
  ["path", { d: "M16.17 7.83 2 22", key: "t58vo8" }],
  [
    "path",
    {
      d: "M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12",
      key: "17k36q"
    }
  ],
  ["path", { d: "m7.83 7.83 8.34 8.34", key: "1d7sxk" }]
], vve = y("Clover", gve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bve = [
  [
    "path",
    {
      d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z",
      key: "27yuqz"
    }
  ],
  ["path", { d: "M12 17.66L12 22", key: "ogfahf" }]
], wve = y("Club", bve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kve = [
  ["path", { d: "m18 16 4-4-4-4", key: "1inbqp" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "m14.5 4-5 16", key: "e7oirm" }]
], xve = y("CodeXml", kve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mve = [
  ["polyline", { points: "16 18 22 12 16 6", key: "z7tu5w" }],
  ["polyline", { points: "8 6 2 12 8 18", key: "1eg1df" }]
], Cve = y("Code", Mve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ave = [
  ["polygon", { points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2", key: "srzb37" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "15.5", key: "1t73f2" }],
  ["polyline", { points: "22 8.5 12 15.5 2 8.5", key: "ajlxae" }],
  ["polyline", { points: "2 15.5 12 8.5 22 15.5", key: "susrui" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "8.5", key: "2cldga" }]
], Sve = y("Codepen", Ave);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lve = [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["polyline", { points: "7.5 4.21 12 6.81 16.5 4.21", key: "fabo96" }],
  ["polyline", { points: "7.5 19.79 7.5 14.6 3 12", key: "z377f1" }],
  ["polyline", { points: "21 12 16.5 14.6 16.5 19.79", key: "9nrev1" }],
  ["polyline", { points: "3.27 6.96 12 12.01 20.73 6.96", key: "1180pa" }],
  ["line", { x1: "12", x2: "12", y1: "22.08", y2: "12", key: "3z3uq6" }]
], Tve = y("Codesandbox", Lve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eve = [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  [
    "path",
    {
      d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
      key: "pwadti"
    }
  ],
  ["path", { d: "M6 2v2", key: "colzsn" }]
], jve = y("Coffee", Eve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nve = [
  ["path", { d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", key: "sobvz5" }],
  ["path", { d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", key: "11i496" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 22v-2", key: "1osdcq" }],
  ["path", { d: "m17 20.66-1-1.73", key: "eq3orb" }],
  ["path", { d: "M11 10.27 7 3.34", key: "16pf9h" }],
  ["path", { d: "m20.66 17-1.73-1", key: "sg0v6f" }],
  ["path", { d: "m3.34 7 1.73 1", key: "1ulond" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "m20.66 7-1.73 1", key: "1ow05n" }],
  ["path", { d: "m3.34 17 1.73-1", key: "nuk764" }],
  ["path", { d: "m17 3.34-1 1.73", key: "2wel8s" }],
  ["path", { d: "m11 13.73-4 6.93", key: "794ttg" }]
], Dve = y("Cog", Nve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ive = [
  ["circle", { cx: "8", cy: "8", r: "6", key: "3yglwk" }],
  ["path", { d: "M18.09 10.37A6 6 0 1 1 10.34 18", key: "t5s6rm" }],
  ["path", { d: "M7 6h1v4", key: "1obek4" }],
  ["path", { d: "m16.71 13.88.7.71-2.82 2.82", key: "1rbuyh" }]
], Pve = y("Coins", Ive);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zve = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 3v18", key: "108xh3" }]
], Rve = y("Columns2", zve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ove = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], Bve = y("Columns3", Ove);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hve = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7.5 3v18", key: "w0wo6v" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M16.5 3v18", key: "10tjh1" }]
], Fve = y("Columns4", Hve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ve = [
  ["path", { d: "M10 18H5a3 3 0 0 1-3-3v-1", key: "ru65g8" }],
  ["path", { d: "M14 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "e30een" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "2ahx8o" }],
  ["path", { d: "m7 21 3-3-3-3", key: "127cv2" }],
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }]
], Vve = y("Combine", _ve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qve = [
  [
    "path",
    { d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3", key: "11bfej" }
  ]
], Uve = y("Command", qve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wve = [
  [
    "path",
    {
      d: "m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z",
      key: "9ktpf1"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], Zve = y("Compass", Wve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gve = [
  [
    "path",
    {
      d: "M15.536 11.293a1 1 0 0 0 0 1.414l2.376 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
      key: "1uwlt4"
    }
  ],
  [
    "path",
    {
      d: "M2.297 11.293a1 1 0 0 0 0 1.414l2.377 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414L6.088 8.916a1 1 0 0 0-1.414 0z",
      key: "10291m"
    }
  ],
  [
    "path",
    {
      d: "M8.916 17.912a1 1 0 0 0 0 1.415l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.415l-2.377-2.376a1 1 0 0 0-1.414 0z",
      key: "1tqoq1"
    }
  ],
  [
    "path",
    {
      d: "M8.916 4.674a1 1 0 0 0 0 1.414l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
      key: "1x6lto"
    }
  ]
], Yve = y("Component", Gve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kve = [
  ["rect", { width: "14", height: "8", x: "5", y: "2", rx: "2", key: "wc9tft" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h2", key: "rwmk9e" }],
  ["path", { d: "M12 18h6", key: "aqd8w3" }]
], $ve = y("Computer", Kve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jve = [
  [
    "path",
    { d: "M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z", key: "1pvr1r" }
  ],
  ["path", { d: "M20 16a8 8 0 1 0-16 0", key: "1pa543" }],
  ["path", { d: "M12 4v4", key: "1bq03y" }],
  ["path", { d: "M10 4h4", key: "1xpv9s" }]
], Qve = y("ConciergeBell", Jve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xve = [
  ["path", { d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98", key: "53pte7" }],
  ["ellipse", { cx: "12", cy: "19", rx: "9", ry: "3", key: "1ji25f" }]
], ebe = y("Cone", Xve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tbe = [
  ["rect", { x: "2", y: "6", width: "20", height: "8", rx: "1", key: "1estib" }],
  ["path", { d: "M17 14v7", key: "7m2elx" }],
  ["path", { d: "M7 14v7", key: "1cm7wv" }],
  ["path", { d: "M17 3v3", key: "1v4jwn" }],
  ["path", { d: "M7 3v3", key: "7o6guu" }],
  ["path", { d: "M10 14 2.3 6.3", key: "1023jk" }],
  ["path", { d: "m14 6 7.7 7.7", key: "1s8pl2" }],
  ["path", { d: "m8 6 8 8", key: "hl96qh" }]
], nbe = y("Construction", tbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rbe = [
  ["path", { d: "M16 2v2", key: "scm5qe" }],
  ["path", { d: "M17.915 22a6 6 0 0 0-12 0", key: "suqz9p" }],
  ["path", { d: "M8 2v2", key: "pbkmx" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
], ibe = y("ContactRound", rbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const abe = [
  ["path", { d: "M16 2v2", key: "scm5qe" }],
  ["path", { d: "M7 22v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1waht3" }],
  ["path", { d: "M8 2v2", key: "pbkmx" }],
  ["circle", { cx: "12", cy: "11", r: "3", key: "itu57m" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
], obe = y("Contact", abe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sbe = [
  [
    "path",
    {
      d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z",
      key: "1t2lqe"
    }
  ],
  ["path", { d: "M10 21.9V14L2.1 9.1", key: "o7czzq" }],
  ["path", { d: "m10 14 11.9-6.9", key: "zm5e20" }],
  ["path", { d: "M14 19.8v-8.1", key: "159ecu" }],
  ["path", { d: "M18 17.5V9.4", key: "11uown" }]
], lbe = y("Container", sbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cbe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 18a6 6 0 0 0 0-12v12z", key: "j4l70d" }]
], ube = y("Contrast", cbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dbe = [
  ["path", { d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5", key: "laymnq" }],
  ["path", { d: "M8.5 8.5v.01", key: "ue8clq" }],
  ["path", { d: "M16 15.5v.01", key: "14dtrp" }],
  ["path", { d: "M12 12v.01", key: "u5ubse" }],
  ["path", { d: "M11 17v.01", key: "1hyl5a" }],
  ["path", { d: "M7 14v.01", key: "uct60s" }]
], fbe = y("Cookie", dbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hbe = [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8", key: "u0tga0" }],
  ["path", { d: "m4 8 16-4", key: "16g0ng" }],
  [
    "path",
    {
      d: "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8",
      key: "12cejc"
    }
  ]
], pbe = y("CookingPot", hbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mbe = [
  ["path", { d: "m12 15 2 2 4-4", key: "2c609p" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], ybe = y("CopyCheck", mbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gbe = [
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], vbe = y("CopyMinus", gbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bbe = [
  ["line", { x1: "15", x2: "15", y1: "12", y2: "18", key: "1p7wdc" }],
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], wbe = y("CopyPlus", bbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kbe = [
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], xbe = y("CopySlash", kbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mbe = [
  ["line", { x1: "12", x2: "18", y1: "12", y2: "18", key: "1rg63v" }],
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], Cbe = y("CopyX", Mbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Abe = [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], Sbe = y("Copy", Abe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lbe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.17 14.83a4 4 0 1 0 0-5.66", key: "1sveal" }]
], Tbe = y("Copyleft", Lbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ebe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M14.83 14.83a4 4 0 1 1 0-5.66", key: "1i56pz" }]
], jbe = y("Copyright", Ebe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nbe = [
  ["polyline", { points: "9 10 4 15 9 20", key: "r3jprv" }],
  ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }]
], Dbe = y("CornerDownLeft", Nbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ibe = [
  ["polyline", { points: "15 10 20 15 15 20", key: "1q7qjw" }],
  ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12", key: "z08zvw" }]
], Pbe = y("CornerDownRight", Ibe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zbe = [
  ["polyline", { points: "14 15 9 20 4 15", key: "nkc4i" }],
  ["path", { d: "M20 4h-7a4 4 0 0 0-4 4v12", key: "nbpdq2" }]
], Rbe = y("CornerLeftDown", zbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Obe = [
  ["polyline", { points: "14 9 9 4 4 9", key: "m9oyvo" }],
  ["path", { d: "M20 20h-7a4 4 0 0 1-4-4V4", key: "1blwi3" }]
], Bbe = y("CornerLeftUp", Obe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hbe = [
  ["polyline", { points: "10 15 15 20 20 15", key: "axus6l" }],
  ["path", { d: "M4 4h7a4 4 0 0 1 4 4v12", key: "wcbgct" }]
], Fbe = y("CornerRightDown", Hbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _be = [
  ["polyline", { points: "10 9 15 4 20 9", key: "1lr6px" }],
  ["path", { d: "M4 20h7a4 4 0 0 0 4-4V4", key: "1plgdj" }]
], Vbe = y("CornerRightUp", _be);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qbe = [
  ["polyline", { points: "9 14 4 9 9 4", key: "881910" }],
  ["path", { d: "M20 20v-7a4 4 0 0 0-4-4H4", key: "1nkjon" }]
], Ube = y("CornerUpLeft", qbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wbe = [
  ["polyline", { points: "15 14 20 9 15 4", key: "1tbx3s" }],
  ["path", { d: "M4 20v-7a4 4 0 0 1 4-4h12", key: "1lu4f8" }]
], Zbe = y("CornerUpRight", Wbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gbe = [
  ["rect", { width: "16", height: "16", x: "4", y: "4", rx: "2", key: "14l7u7" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", rx: "1", key: "5aljv4" }],
  ["path", { d: "M15 2v2", key: "13l42r" }],
  ["path", { d: "M15 20v2", key: "15mkzm" }],
  ["path", { d: "M2 15h2", key: "1gxd5l" }],
  ["path", { d: "M2 9h2", key: "1bbxkp" }],
  ["path", { d: "M20 15h2", key: "19e6y8" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M9 2v2", key: "165o2o" }],
  ["path", { d: "M9 20v2", key: "i2bqo8" }]
], Ybe = y("Cpu", Gbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kbe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  [
    "path",
    { d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1ss3eq" }
  ],
  [
    "path",
    { d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1od56t" }
  ]
], $be = y("CreativeCommons", Kbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jbe = [
  ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "ynyp8z" }],
  ["line", { x1: "2", x2: "22", y1: "10", y2: "10", key: "1b3vmo" }]
], Qbe = y("CreditCard", Jbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xbe = [
  [
    "path",
    {
      d: "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z",
      key: "1ozxlb"
    }
  ],
  [
    "path",
    {
      d: "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83",
      key: "ffuyb5"
    }
  ],
  ["path", { d: "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4", key: "osnpzi" }],
  [
    "path",
    {
      d: "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2",
      key: "1vubaw"
    }
  ],
  ["path", { d: "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5", key: "wxr772" }]
], e7e = y("Croissant", Xbe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t7e = [
  ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14", key: "ron5a4" }],
  ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2", key: "7s9ehn" }]
], n7e = y("Crop", t7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r7e = [
  [
    "path",
    {
      d: "M4 9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4a1 1 0 0 1 1 1v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a1 1 0 0 1 1-1h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-4a1 1 0 0 1-1-1V4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4a1 1 0 0 1-1 1z",
      key: "1xbrqy"
    }
  ]
], i7e = y("Cross", r7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a7e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "22", x2: "18", y1: "12", y2: "12", key: "l9bcsi" }],
  ["line", { x1: "6", x2: "2", y1: "12", y2: "12", key: "13hhkx" }],
  ["line", { x1: "12", x2: "12", y1: "6", y2: "2", key: "10w3f3" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "18", key: "15g9kq" }]
], o7e = y("Crosshair", a7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s7e = [
  [
    "path",
    {
      d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
      key: "1vdc57"
    }
  ],
  ["path", { d: "M5 21h14", key: "11awu3" }]
], l7e = y("Crown", s7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c7e = [
  [
    "path",
    {
      d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z",
      key: "1u2ovd"
    }
  ],
  ["path", { d: "M10 22v-8L2.25 9.15", key: "11pn4q" }],
  ["path", { d: "m10 14 11.77-6.87", key: "1kt1wh" }]
], u7e = y("Cuboid", c7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d7e = [
  ["path", { d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8", key: "8166m8" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "yjz344" }],
  ["path", { d: "m12 8 1-6h2", key: "3ybfa4" }]
], f7e = y("CupSoda", d7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h7e = [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["line", { x1: "3", x2: "6", y1: "3", y2: "6", key: "1jkytn" }],
  ["line", { x1: "21", x2: "18", y1: "3", y2: "6", key: "14zfjt" }],
  ["line", { x1: "3", x2: "6", y1: "21", y2: "18", key: "iusuec" }],
  ["line", { x1: "21", x2: "18", y1: "21", y2: "18", key: "yj2dd7" }]
], p7e = y("Currency", h7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m7e = [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 18 0V5", key: "aqi0yr" }]
], y7e = y("Cylinder", m7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g7e = [
  [
    "path",
    { d: "M11 11.31c1.17.56 1.54 1.69 3.5 1.69 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1", key: "157kva" }
  ],
  ["path", { d: "M11.75 18c.35.5 1.45 1 2.75 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1", key: "d7q6m6" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  [
    "path",
    { d: "M7 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1L10 4a1 1 0 0 0-1-1z", key: "pr6s65" }
  ]
], v7e = y("Dam", g7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b7e = [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 12a9 3 0 0 0 5 2.69", key: "1ui2ym" }],
  ["path", { d: "M21 9.3V5", key: "6k6cib" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 6.47 2.88", key: "i62tjy" }],
  ["path", { d: "M12 12v4h4", key: "1bxaet" }],
  [
    "path",
    {
      d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16",
      key: "1f4ei9"
    }
  ]
], w7e = y("DatabaseBackup", b7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k7e = [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 15 21.84", key: "14ibmq" }],
  ["path", { d: "M21 5V8", key: "1marbg" }],
  ["path", { d: "M21 12L18 17H22L19 22", key: "zafso" }],
  ["path", { d: "M3 12A9 3 0 0 0 14.59 14.87", key: "1y4wr8" }]
], x7e = y("DatabaseZap", k7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M7e = [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 21 19V5", key: "1wlel7" }],
  ["path", { d: "M3 12A9 3 0 0 0 21 12", key: "mv7ke4" }]
], C7e = y("Database", M7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A7e = [
  [
    "path",
    {
      d: "M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
      key: "1yo7s0"
    }
  ],
  ["path", { d: "m12 9 6 6", key: "anjzzh" }],
  ["path", { d: "m18 9-6 6", key: "1fp51s" }]
], S7e = y("Delete", A7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L7e = [
  ["circle", { cx: "12", cy: "4", r: "2", key: "muu5ef" }],
  [
    "path",
    {
      d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8",
      key: "lfo06j"
    }
  ],
  ["path", { d: "M3.2 14.8a9 9 0 0 0 17.6 0", key: "12xarc" }]
], T7e = y("Dessert", L7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E7e = [
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
  ["path", { d: "M6.48 3.66a10 10 0 0 1 13.86 13.86", key: "xr8kdq" }],
  ["path", { d: "m6.41 6.41 11.18 11.18", key: "uhpjw7" }],
  ["path", { d: "M3.66 6.48a10 10 0 0 0 13.86 13.86", key: "cldpwv" }]
], j7e = y("Diameter", E7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N7e = [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], D7e = y("DiamondMinus", N7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I7e = [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z",
      key: "1tpxz2"
    }
  ],
  ["path", { d: "M9.2 9.2h.01", key: "1b7bvt" }],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "M14.7 14.8h.01", key: "17nsh4" }]
], P7e = y("DiamondPercent", I7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z7e = [
  ["path", { d: "M12 8v8", key: "napkw2" }],
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], R7e = y("DiamondPlus", z7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O7e = [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z",
      key: "1f1r0c"
    }
  ]
], B7e = y("Diamond", O7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H7e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
], F7e = y("Dice1", H7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _7e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M9 15h.01", key: "fzyn71" }]
], V7e = y("Dice2", _7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q7e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
], U7e = y("Dice3", q7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W7e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }]
], Z7e = y("Dice4", W7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G7e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
], Y7e = y("Dice5", G7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K7e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
], $7e = y("Dice6", K7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J7e = [
  ["rect", { width: "12", height: "12", x: "2", y: "10", rx: "2", ry: "2", key: "6agr2n" }],
  [
    "path",
    { d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6", key: "1o487t" }
  ],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 14h.01", key: "ssrbsk" }],
  ["path", { d: "M15 6h.01", key: "cblpky" }],
  ["path", { d: "M18 9h.01", key: "2061c0" }]
], Q7e = y("Dices", J7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X7e = [
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
], e9e = y("Diff", X7e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t9e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
], n9e = y("Disc2", t9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r9e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M6 12c0-1.7.7-3.2 1.8-4.2", key: "oqkarx" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M18 12c0 1.7-.7 3.2-1.8 4.2", key: "1eah9h" }]
], i9e = y("Disc3", r9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a9e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "5", key: "nd82uf" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
], o9e = y("DiscAlbum", a9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s9e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
], l9e = y("Disc", s9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c9e = [
  ["circle", { cx: "12", cy: "6", r: "1", key: "1bh7o1" }],
  ["line", { x1: "5", x2: "19", y1: "12", y2: "12", key: "13b5wn" }],
  ["circle", { cx: "12", cy: "18", r: "1", key: "lqb9t5" }]
], u9e = y("Divide", c9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d9e = [
  ["path", { d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5L14 8", key: "1bivrr" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c3.333-3 6.667-3 10-3", key: "nxix30" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M22 9c-1.5 1.35-3 2.092-4.5 2.5l-1-1", key: "18cutr" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.35-1.5 2.092-3 2.5-4.5L10 16", key: "rlvei3" }]
], f9e = y("DnaOff", d9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h9e = [
  ["path", { d: "m10 16 1.5 1.5", key: "11lckj" }],
  ["path", { d: "m14 8-1.5-1.5", key: "1ohn8i" }],
  ["path", { d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993", key: "80uv8i" }],
  ["path", { d: "m16.5 10.5 1 1", key: "696xn5" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c6.667-6 13.333 0 20-6", key: "1pyr53" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993", key: "q3hbxp" }]
], p9e = y("Dna", h9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m9e = [
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 16h12", key: "u522kt" }]
], y9e = y("Dock", m9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g9e = [
  ["path", { d: "M11.25 16.25h1.5L12 17z", key: "w7jh35" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  [
    "path",
    {
      d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444a11.702 11.702 0 0 0-.493-3.309",
      key: "u7s9ue"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  [
    "path",
    {
      d: "M8.5 8.5c-.384 1.05-1.083 2.028-2.344 2.5-1.931.722-3.576-.297-3.656-1-.113-.994 1.177-6.53 4-7 1.923-.321 3.651.845 3.651 2.235A7.497 7.497 0 0 1 14 5.277c0-1.39 1.844-2.598 3.767-2.277 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
      key: "v8hric"
    }
  ]
], v9e = y("Dog", g9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b9e = [
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ["path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6", key: "1b0p4s" }]
], w9e = y("DollarSign", b9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k9e = [
  [
    "path",
    {
      d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3",
      key: "19sr3x"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], x9e = y("Donut", k9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M9e = [
  ["path", { d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14", key: "36qu9e" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M14 12v.01", key: "xfcn54" }]
], C9e = y("DoorClosed", M9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A9e = [
  ["path", { d: "M13 4h3a2 2 0 0 1 2 2v14", key: "hrm0s9" }],
  ["path", { d: "M2 20h3", key: "1gaodv" }],
  ["path", { d: "M13 20h9", key: "s90cdi" }],
  ["path", { d: "M10 12v.01", key: "vx6srw" }],
  [
    "path",
    {
      d: "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z",
      key: "199qr4"
    }
  ]
], S9e = y("DoorOpen", A9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L9e = [["circle", { cx: "12.1", cy: "12.1", r: "1", key: "18d7e5" }]], T9e = y("Dot", L9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E9e = [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
], j9e = y("Download", E9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N9e = [
  ["path", { d: "m12.99 6.74 1.93 3.44", key: "iwagvd" }],
  ["path", { d: "M19.136 12a10 10 0 0 1-14.271 0", key: "ppmlo4" }],
  ["path", { d: "m21 21-2.16-3.84", key: "vylbct" }],
  ["path", { d: "m3 21 8.02-14.26", key: "1ssaw4" }],
  ["circle", { cx: "12", cy: "5", r: "2", key: "f1ur92" }]
], D9e = y("DraftingCompass", N9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I9e = [
  ["path", { d: "M10 11h.01", key: "d2at3l" }],
  ["path", { d: "M14 6h.01", key: "k028ub" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6.5 13.1h.01", key: "1748ia" }],
  ["path", { d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3", key: "172yzv" }],
  ["path", { d: "M17.4 9.9c-.8.8-2 .8-2.8 0", key: "1obv0w" }],
  [
    "path",
    {
      d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7",
      key: "rqjl8i"
    }
  ],
  ["path", { d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4", key: "1mr6wy" }]
], P9e = y("Drama", I9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z9e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94", key: "hpej1" }],
  ["path", { d: "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32", key: "1tr44o" }],
  ["path", { d: "M8.56 2.75c4.37 6 6 9.42 8 17.72", key: "kbh691" }]
], R9e = y("Dribbble", z9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O9e = [
  [
    "path",
    { d: "M10 18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3 1 1 0 0 1 1-1z", key: "ioqxb1" }
  ],
  [
    "path",
    {
      d: "M13 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1l-.81 3.242a1 1 0 0 1-.97.758H8",
      key: "1rs59n"
    }
  ],
  ["path", { d: "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3", key: "105ega" }],
  ["path", { d: "M18 6h4", key: "66u95g" }],
  ["path", { d: "m5 10-2 8", key: "xt2lic" }],
  ["path", { d: "m7 18 2-8", key: "1bzku2" }]
], B9e = y("Drill", O9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H9e = [
  [
    "path",
    {
      d: "M18.715 13.186C18.29 11.858 17.384 10.607 16 9.5c-2-1.6-3.5-4-4-6.5a10.7 10.7 0 0 1-.884 2.586",
      key: "8suz2t"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    { d: "M8.795 8.797A11 11 0 0 1 8 9.5C6 11.1 5 13 5 15a7 7 0 0 0 13.222 3.208", key: "19dw9m" }
  ]
], F9e = y("DropletOff", H9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _9e = [
  [
    "path",
    {
      d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
      key: "c7niix"
    }
  ]
], V9e = y("Droplet", _9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q9e = [
  [
    "path",
    {
      d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
      key: "1ptgy4"
    }
  ],
  [
    "path",
    {
      d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
      key: "1sl1rz"
    }
  ]
], U9e = y("Droplets", q9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W9e = [
  ["path", { d: "m2 2 8 8", key: "1v6059" }],
  ["path", { d: "m22 2-8 8", key: "173r8a" }],
  ["ellipse", { cx: "12", cy: "9", rx: "10", ry: "5", key: "liohsx" }],
  ["path", { d: "M7 13.4v7.9", key: "1yi6u9" }],
  ["path", { d: "M12 14v8", key: "1tn2tj" }],
  ["path", { d: "M17 13.4v7.9", key: "eqz2v3" }],
  ["path", { d: "M2 9v8a10 5 0 0 0 20 0V9", key: "1750ul" }]
], Z9e = y("Drum", W9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G9e = [
  [
    "path",
    { d: "M15.4 15.63a7.875 6 135 1 1 6.23-6.23 4.5 3.43 135 0 0-6.23 6.23", key: "1dtqwm" }
  ],
  [
    "path",
    {
      d: "m8.29 12.71-2.6 2.6a2.5 2.5 0 1 0-1.65 4.65A2.5 2.5 0 1 0 8.7 18.3l2.59-2.59",
      key: "1oq1fw"
    }
  ]
], Y9e = y("Drumstick", G9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K9e = [
  ["path", { d: "M14.4 14.4 9.6 9.6", key: "ic80wn" }],
  [
    "path",
    {
      d: "M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z",
      key: "nnl7wr"
    }
  ],
  ["path", { d: "m21.5 21.5-1.4-1.4", key: "1f1ice" }],
  ["path", { d: "M3.9 3.9 2.5 2.5", key: "1evmna" }],
  [
    "path",
    {
      d: "M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z",
      key: "yhosts"
    }
  ]
], $9e = y("Dumbbell", K9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J9e = [
  ["path", { d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46", key: "1qngmn" }],
  ["path", { d: "M6 8.5c0-.75.13-1.47.36-2.14", key: "b06bma" }],
  ["path", { d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76", key: "g10hsz" }],
  ["path", { d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18", key: "ygzou7" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], Q9e = y("EarOff", J9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X9e = [
  ["path", { d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0", key: "1dfaln" }],
  ["path", { d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4", key: "1qnva7" }]
], ewe = y("Ear", X9e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const twe = [
  ["path", { d: "M7 3.34V5a3 3 0 0 0 3 3", key: "w732o8" }],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2 2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "f02343" }],
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  ["path", { d: "M12 2a10 10 0 1 0 9.54 13", key: "zjsr6q" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
], nwe = y("EarthLock", twe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rwe = [
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  [
    "path",
    {
      d: "M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17",
      key: "1tzkfa"
    }
  ],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "14pb5j" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], iwe = y("Earth", rwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const awe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a7 7 0 1 0 10 10", key: "1yuj32" }]
], owe = y("Eclipse", awe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const swe = [
  ["circle", { cx: "11.5", cy: "12.5", r: "3.5", key: "1cl1mi" }],
  [
    "path",
    {
      d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z",
      key: "165ef9"
    }
  ]
], lwe = y("EggFried", swe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cwe = [
  [
    "path",
    {
      d: "M6.399 6.399C5.362 8.157 4.65 10.189 4.5 12c-.37 4.43 1.27 9.95 7.5 10 3.256-.026 5.259-1.547 6.375-3.625",
      key: "6et380"
    }
  ],
  [
    "path",
    {
      d: "M19.532 13.875A14.07 14.07 0 0 0 19.5 12c-.36-4.34-3.95-9.96-7.5-10-1.04.012-2.082.502-3.046 1.297",
      key: "gcdc3f"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], uwe = y("EggOff", cwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dwe = [
  [
    "path",
    {
      d: "M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z",
      key: "1c39pg"
    }
  ]
], fwe = y("Egg", dwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hwe = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], pwe = y("EllipsisVertical", hwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mwe = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
], ywe = y("Ellipsis", mwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gwe = [
  ["path", { d: "M5 15a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0", key: "yrdkhy" }],
  ["path", { d: "M5 9a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0", key: "gzkvyz" }]
], vwe = y("EqualApproximately", gwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bwe = [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }],
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }]
], wwe = y("EqualNot", bwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kwe = [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }]
], xwe = y("Equal", kwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mwe = [
  [
    "path",
    {
      d: "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21",
      key: "182aya"
    }
  ],
  ["path", { d: "M22 21H7", key: "t4ddhn" }],
  ["path", { d: "m5 11 9 9", key: "1mo9qw" }]
], Cwe = y("Eraser", Mwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Awe = [
  [
    "path",
    {
      d: "m15 20 3-3h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h2l3 3z",
      key: "rbahqx"
    }
  ],
  ["path", { d: "M6 8v1", key: "1636ez" }],
  ["path", { d: "M10 8v1", key: "1talb4" }],
  ["path", { d: "M14 8v1", key: "1rsfgr" }],
  ["path", { d: "M18 8v1", key: "gnkwox" }]
], Swe = y("EthernetPort", Awe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lwe = [
  ["path", { d: "M4 10h12", key: "1y6xl8" }],
  ["path", { d: "M4 14h9", key: "1loblj" }],
  [
    "path",
    {
      d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2",
      key: "1j6lzo"
    }
  ]
], Twe = y("Euro", Lwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ewe = [
  ["path", { d: "m15 15 6 6", key: "1s409w" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }],
  ["path", { d: "M21 16.2V21h-4.8", key: "1hrera" }],
  ["path", { d: "M21 7.8V3h-4.8", key: "ul1q53" }],
  ["path", { d: "M3 16.2V21h4.8", key: "1x04uo" }],
  ["path", { d: "m3 21 6-6", key: "wwnumi" }],
  ["path", { d: "M3 7.8V3h4.8", key: "1ijppm" }],
  ["path", { d: "M9 9 3 3", key: "v551iv" }]
], jwe = y("Expand", Ewe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nwe = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
], Dwe = y("ExternalLink", Nwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iwe = [
  ["path", { d: "m15 18-.722-3.25", key: "1j64jw" }],
  ["path", { d: "M2 8a10.645 10.645 0 0 0 20 0", key: "1e7gxb" }],
  ["path", { d: "m20 15-1.726-2.05", key: "1cnuld" }],
  ["path", { d: "m4 15 1.726-2.05", key: "1dsqqd" }],
  ["path", { d: "m9 18 .722-3.25", key: "ypw2yx" }]
], Pwe = y("EyeClosed", Iwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zwe = [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Rwe = y("EyeOff", zwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Owe = [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], Bwe = y("Eye", Owe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hwe = [
  [
    "path",
    { d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z", key: "1jg4f8" }
  ]
], Fwe = y("Facebook", Hwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _we = [
  [
    "path",
    {
      d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "159hny"
    }
  ],
  ["path", { d: "M17 18h1", key: "uldtlt" }],
  ["path", { d: "M12 18h1", key: "s9uhes" }],
  ["path", { d: "M7 18h1", key: "1neino" }]
], Vwe = y("Factory", _we);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qwe = [
  [
    "path",
    {
      d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z",
      key: "484a7f"
    }
  ],
  ["path", { d: "M12 12v.01", key: "u5ubse" }]
], Uwe = y("Fan", qwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wwe = [
  ["polygon", { points: "13 19 22 12 13 5 13 19", key: "587y9g" }],
  ["polygon", { points: "2 19 11 12 2 5 2 19", key: "3pweh0" }]
], Zwe = y("FastForward", Wwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gwe = [
  [
    "path",
    {
      d: "M12.67 19a2 2 0 0 0 1.416-.588l6.154-6.172a6 6 0 0 0-8.49-8.49L5.586 9.914A2 2 0 0 0 5 11.328V18a1 1 0 0 0 1 1z",
      key: "18jl4k"
    }
  ],
  ["path", { d: "M16 8 2 22", key: "vp34q" }],
  ["path", { d: "M17.5 15H9", key: "1oz8nu" }]
], Ywe = y("Feather", Gwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kwe = [
  ["path", { d: "M4 3 2 5v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "1n2rgs" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M6 18h4", key: "12yh4b" }],
  ["path", { d: "m12 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "3ha7mj" }],
  ["path", { d: "M14 8h4", key: "1r8wg2" }],
  ["path", { d: "M14 18h4", key: "1t3kbu" }],
  ["path", { d: "m20 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "dfd4e2" }]
], $we = y("Fence", Kwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jwe = [
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m6.8 15-3.5 2", key: "hjy98k" }],
  ["path", { d: "m20.7 7-3.5 2", key: "f08gto" }],
  ["path", { d: "M6.8 9 3.3 7", key: "1aevh4" }],
  ["path", { d: "m20.7 17-3.5-2", key: "1liqo3" }],
  ["path", { d: "m9 22 3-8 3 8", key: "wees03" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M18 18.7a9 9 0 1 0-12 0", key: "dhzg4g" }]
], Qwe = y("FerrisWheel", Jwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xwe = [
  ["path", { d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z", key: "1340ok" }],
  ["path", { d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z", key: "1hz3m3" }],
  ["path", { d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z", key: "1oz8n2" }],
  ["path", { d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z", key: "1ff65i" }],
  ["path", { d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z", key: "pdip6e" }]
], eke = y("Figma", Xwe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tke = [
  ["path", { d: "M10 12v-1", key: "v7bkov" }],
  ["path", { d: "M10 18v-2", key: "1cjy8d" }],
  ["path", { d: "M10 7V6", key: "dljcrl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01", key: "gkbcor" }
  ],
  ["circle", { cx: "10", cy: "20", r: "2", key: "1xzdoj" }]
], nke = y("FileArchive", tke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rke = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "3", cy: "17", r: "1", key: "vo6nti" }],
  ["path", { d: "M2 17v-3a4 4 0 0 1 8 0v3", key: "1ggdre" }],
  ["circle", { cx: "9", cy: "17", r: "1", key: "bc1fq4" }]
], ike = y("FileAudio2", rke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ake = [
  ["path", { d: "M17.5 22h.5a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "rslqgf" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M2 19a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 1 1-4 0v-1a2 2 0 1 1 4 0",
      key: "9f7x3i"
    }
  ]
], oke = y("FileAudio", ake);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ske = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 18 4-4", key: "12zab0" }],
  ["path", { d: "M8 10v8h8", key: "tlaukw" }]
], lke = y("FileAxis3d", ske);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cke = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14 12.5 1 5.5-3-1-3 1 1-5.5", key: "14xlky" }]
], uke = y("FileBadge2", cke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dke = [
  ["path", { d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "12ixgl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "u0c8gj" }],
  ["path", { d: "M7 16.5 8 22l-3-1-3 1 1-5.5", key: "5gm2nr" }]
], fke = y("FileBadge", dke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hke = [
  ["path", { d: "M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "16lz6z" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z",
      key: "99pj1s"
    }
  ],
  ["path", { d: "M7 17v5", key: "1yj1jh" }],
  ["path", { d: "M11.7 14.2 7 17l-4.7-2.8", key: "1yk8tc" }]
], pke = y("FileBox", hke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mke = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-2", key: "qcmpov" }],
  ["path", { d: "M12 18v-4", key: "q1q25u" }],
  ["path", { d: "M16 18v-6", key: "15y0np" }]
], yke = y("FileChartColumnIncreasing", mke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gke = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-1", key: "zg0ygc" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "M16 18v-3", key: "j5jt4h" }]
], vke = y("FileChartColumn", gke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bke = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m16 13-3.5 3.5-2-2L8 17", key: "zz7yod" }]
], wke = y("FileChartLine", bke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kke = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3.5", key: "13ddob" }],
  ["path", { d: "M4.017 11.512a6 6 0 1 0 8.466 8.475", key: "s6vs5t" }],
  [
    "path",
    {
      d: "M9 16a1 1 0 0 1-1-1v-4c0-.552.45-1.008.995-.917a6 6 0 0 1 4.922 4.922c.091.544-.365.995-.917.995z",
      key: "1dl6s6"
    }
  ]
], xke = y("FileChartPie", kke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mke = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3 15 2 2 4-4", key: "1lhrkk" }]
], Cke = y("FileCheck2", Mke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ake = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m9 15 2 2 4-4", key: "1grp1n" }]
], Ske = y("FileCheck", Ake);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lke = [
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "37hlfg" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "8", cy: "16", r: "6", key: "10v15b" }],
  ["path", { d: "M9.5 17.5 8 16.25V14", key: "1o80t2" }]
], Tke = y("FileClock", Lke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eke = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m5 12-3 3 3 3", key: "oke12k" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
], jke = y("FileCode2", Eke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nke = [
  ["path", { d: "M10 12.5 8 15l2 2.5", key: "1tg20x" }],
  ["path", { d: "m14 12.5 2 2.5-2 2.5", key: "yinavb" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }]
], Dke = y("FileCode", Nke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ike = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3.2 12.9-.9-.4", key: "1i3dj5" }],
  ["path", { d: "m3.2 15.1-.9.4", key: "1fvgj0" }],
  [
    "path",
    {
      d: "M4.677 21.5a2 2 0 0 0 1.313.5H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2.5",
      key: "1yo3oz"
    }
  ],
  ["path", { d: "m4.9 11.2-.4-.9", key: "otmhb9" }],
  ["path", { d: "m4.9 16.8-.4.9", key: "1b8z07" }],
  ["path", { d: "m7.5 10.3-.4.9", key: "11k65u" }],
  ["path", { d: "m7.5 17.7-.4-.9", key: "431x55" }],
  ["path", { d: "m9.7 12.5-.9.4", key: "87sjan" }],
  ["path", { d: "m9.7 15.5-.9-.4", key: "khqm91" }],
  ["circle", { cx: "6", cy: "14", r: "3", key: "a1xfv6" }]
], Pke = y("FileCog", Ike);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zke = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
], Rke = y("FileDiff", zke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oke = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "4", height: "6", x: "2", y: "12", rx: "2", key: "jm304g" }],
  ["path", { d: "M10 12h2v6", key: "12zw74" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
], Bke = y("FileDigit", Oke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hke = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "m9 15 3 3 3-3", key: "1npd3o" }]
], Fke = y("FileDown", Hke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ke = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M10.29 10.7a2.43 2.43 0 0 0-2.66-.52c-.29.12-.56.3-.78.53l-.35.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L6.5 18l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1c1fso"
    }
  ]
], Vke = y("FileHeart", _ke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qke = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "10", cy: "12", r: "2", key: "737tya" }],
  ["path", { d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22", key: "wt3hpn" }]
], Uke = y("FileImage", qke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wke = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 15h10", key: "jfw4w8" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
], Zke = y("FileInput", Wke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gke = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "fq0c9t" }
  ],
  [
    "path",
    { d: "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "4gibmv" }
  ]
], Yke = y("FileJson2", Gke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kke = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "1oajmo" }
  ],
  [
    "path",
    { d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "mpwhp6" }
  ]
], $ke = y("FileJson", Kke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jke = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v6", key: "rc0qvx" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "m10 10-4.5 4.5", key: "7fwrp6" }],
  ["path", { d: "m9 11 1 1", key: "wa6s5q" }]
], Qke = y("FileKey2", Jke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xke = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "10", cy: "16", r: "2", key: "4ckbqe" }],
  ["path", { d: "m16 10-4.5 4.5", key: "7p3ebg" }],
  ["path", { d: "m15 11 1 1", key: "1bsyx3" }]
], exe = y("FileKey", Xke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const txe = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v1", key: "jmtmu2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "5", x: "2", y: "13", rx: "1", key: "10y5wo" }],
  ["path", { d: "M8 13v-2a2 2 0 1 0-4 0v2", key: "1pdxzg" }]
], nxe = y("FileLock2", txe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rxe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["rect", { width: "8", height: "6", x: "8", y: "12", rx: "1", key: "3yr8at" }],
  ["path", { d: "M10 12v-2a2 2 0 1 1 4 0v2", key: "j4i8d" }]
], ixe = y("FileLock", rxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const axe = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }]
], oxe = y("FileMinus2", axe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sxe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
], lxe = y("FileMinus", sxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cxe = [
  ["path", { d: "M10.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v8.4", key: "1d3kfm" }],
  ["path", { d: "M8 18v-7.7L16 9v7", key: "1oie6o" }],
  ["circle", { cx: "14", cy: "16", r: "2", key: "1bzzi3" }],
  ["circle", { cx: "6", cy: "18", r: "2", key: "1fncim" }]
], uxe = y("FileMusic", cxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dxe = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M4 7V4a2 2 0 0 1 2-2 2 2 0 0 0-2 2", key: "1vk7w2" }],
  ["path", { d: "M4.063 20.999a2 2 0 0 0 2 1L18 22a2 2 0 0 0 2-2V7l-5-5H6", key: "1jink5" }],
  ["path", { d: "m5 11-3 3", key: "1dgrs4" }],
  ["path", { d: "m5 17-3-3h10", key: "1mvvaf" }]
], fxe = y("FileOutput", dxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hxe = [
  [
    "path",
    {
      d: "m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2",
      key: "142zxg"
    }
  ],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ],
  ["path", { d: "M8 18h1", key: "13wk12" }]
], pxe = y("FilePenLine", hxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mxe = [
  ["path", { d: "M12.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v9.5", key: "1couwa" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
], yxe = y("FilePen", mxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gxe = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }],
  ["path", { d: "M6 12v6", key: "1u72j0" }]
], vxe = y("FilePlus2", gxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bxe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }]
], wxe = y("FilePlus", bxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kxe = [
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }]
], xxe = y("FileQuestion", kxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mxe = [
  ["path", { d: "M20 10V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4", key: "1rdf37" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 14a2 2 0 0 0-2 2", key: "ceaadl" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2", key: "1ny6zw" }],
  ["path", { d: "M20 22a2 2 0 0 0 2-2", key: "1l9q4k" }],
  ["path", { d: "M16 22a2 2 0 0 1-2-2", key: "1wqh5n" }]
], Cxe = y("FileScan", Mxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Axe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "11.5", cy: "14.5", r: "2.5", key: "1bq0ko" }],
  ["path", { d: "M13.3 16.3 15 18", key: "2quom7" }]
], Sxe = y("FileSearch2", Axe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lxe = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "ms7g94" }
  ],
  ["path", { d: "m9 18-1.5-1.5", key: "1j6qii" }],
  ["circle", { cx: "5", cy: "14", r: "3", key: "ufru5t" }]
], Txe = y("FileSearch", Lxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Exe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M10 11v2", key: "1s651w" }],
  ["path", { d: "M8 17h8", key: "wh5c61" }],
  ["path", { d: "M14 16v2", key: "12fp5e" }]
], jxe = y("FileSliders", Exe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nxe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 13h2", key: "yr2amv" }],
  ["path", { d: "M14 13h2", key: "un5t4a" }],
  ["path", { d: "M8 17h2", key: "2yhykz" }],
  ["path", { d: "M14 17h2", key: "10kma7" }]
], Dxe = y("FileSpreadsheet", Nxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ixe = [
  ["path", { d: "M21 7h-3a2 2 0 0 1-2-2V2", key: "9rb54x" }],
  [
    "path",
    {
      d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z",
      key: "1059l0"
    }
  ],
  ["path", { d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15", key: "16874u" }],
  ["path", { d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11", key: "k2ox98" }]
], Pxe = y("FileStack", Ixe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zxe = [
  ["path", { d: "m10 18 3-3-3-3", key: "18f6ys" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M4 11V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "50q2rw"
    }
  ]
], Rxe = y("FileSymlink", zxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oxe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 16 2-2-2-2", key: "10vzyd" }],
  ["path", { d: "M12 18h4", key: "1wd2n7" }]
], Bxe = y("FileTerminal", Oxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hxe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
], Fxe = y("FileText", Hxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _xe = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 13v-1h6v1", key: "1dh9dg" }],
  ["path", { d: "M5 12v6", key: "150t9c" }],
  ["path", { d: "M4 18h2", key: "1xrofg" }]
], Vxe = y("FileType2", _xe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qxe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 13v-1h6v1", key: "1bb014" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M11 18h2", key: "12mj7e" }]
], Uxe = y("FileType", qxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wxe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "m15 15-3-3-3 3", key: "15xj92" }]
], Zxe = y("FileUp", Wxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gxe = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M15 18a3 3 0 1 0-6 0", key: "16awa0" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
], Yxe = y("FileUser", Gxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kxe = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "6", x: "2", y: "12", rx: "1", key: "1a6c1e" }],
  ["path", { d: "m10 15.5 4 2.5v-6l-4 2.5", key: "t7cp39" }]
], $xe = y("FileVideo2", Kxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jxe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m10 11 5 3-5 3v-6Z", key: "7ntvm4" }]
], Qxe = y("FileVideo", Jxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xxe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M11.5 13.5a2.5 2.5 0 0 1 0 3", key: "1fccat" }],
  ["path", { d: "M15 12a5 5 0 0 1 0 6", key: "ps46cm" }]
], eMe = y("FileVolume2", Xxe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tMe = [
  ["path", { d: "M11 11a5 5 0 0 1 0 6", key: "193qb2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 6.765V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-.93-.23", key: "ifyjnl" }
  ],
  [
    "path",
    {
      d: "M7 10.51a.5.5 0 0 0-.826-.38l-1.893 1.628A1 1 0 0 1 3.63 12H2.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1.129a1 1 0 0 1 .652.242l1.893 1.63a.5.5 0 0 0 .826-.38z",
      key: "mk8rxu"
    }
  ]
], nMe = y("FileVolume", tMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rMe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], iMe = y("FileWarning", rMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aMe = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 12.5-5 5", key: "b853mi" }],
  ["path", { d: "m3 12.5 5 5", key: "1qls4r" }]
], oMe = y("FileX2", aMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sMe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14.5 12.5-5 5", key: "b62r18" }],
  ["path", { d: "m9.5 12.5 5 5", key: "1rk7el" }]
], lMe = y("FileX", sMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cMe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }]
], uMe = y("File", cMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dMe = [
  ["path", { d: "M20 7h-3a2 2 0 0 1-2-2V2", key: "x099mo" }],
  ["path", { d: "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z", key: "18t6ie" }],
  ["path", { d: "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8", key: "1nja0z" }]
], fMe = y("Files", dMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hMe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  ["path", { d: "M3 7.5h4", key: "zfgn84" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 16.5h4", key: "1230mu" }],
  ["path", { d: "M17 3v18", key: "in4fa5" }],
  ["path", { d: "M17 7.5h4", key: "myr1c1" }],
  ["path", { d: "M17 16.5h4", key: "go4c1d" }]
], pMe = y("Film", hMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mMe = [
  ["path", { d: "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055", key: "1fi1da" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
], yMe = y("FilterX", mMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gMe = [
  ["polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3", key: "1yg77f" }]
], vMe = y("Filter", gMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bMe = [
  ["path", { d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4", key: "1nerag" }],
  ["path", { d: "M14 13.12c0 2.38 0 6.38-1 8.88", key: "o46ks0" }],
  ["path", { d: "M17.29 21.02c.12-.6.43-2.3.5-3.02", key: "ptglia" }],
  ["path", { d: "M2 12a10 10 0 0 1 18-6", key: "ydlgp0" }],
  ["path", { d: "M2 16h.01", key: "1gqxmh" }],
  ["path", { d: "M21.8 16c.2-2 .131-5.354 0-6", key: "drycrb" }],
  ["path", { d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2", key: "1tidbn" }],
  ["path", { d: "M8.65 22c.21-.66.45-1.32.57-2", key: "13wd9y" }],
  ["path", { d: "M9 6.8a6 6 0 0 1 9 5.2v2", key: "1fr1j5" }]
], wMe = y("Fingerprint", bMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kMe = [
  ["path", { d: "M15 6.5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3.5", key: "sqyvz" }],
  ["path", { d: "M9 18h8", key: "i7pszb" }],
  ["path", { d: "M18 3h-3", key: "7idoqj" }],
  ["path", { d: "M11 3a6 6 0 0 0-6 6v11", key: "1v5je3" }],
  ["path", { d: "M5 13h4", key: "svpcxo" }],
  ["path", { d: "M17 10a4 4 0 0 0-8 0v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2Z", key: "vsjego" }]
], xMe = y("FireExtinguisher", kMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MMe = [
  [
    "path",
    {
      d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058",
      key: "1j1hse"
    }
  ],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618",
      key: "1q46z8"
    }
  ],
  [
    "path",
    {
      d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20",
      key: "1407gh"
    }
  ]
], CMe = y("FishOff", MMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AMe = [
  ["path", { d: "M2 16s9-15 20-4C11 23 2 8 2 8", key: "h4oh4o" }]
], SMe = y("FishSymbol", AMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LMe = [
  [
    "path",
    {
      d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z",
      key: "15baut"
    }
  ],
  ["path", { d: "M18 12v.5", key: "18hhni" }],
  ["path", { d: "M16 17.93a9.77 9.77 0 0 1 0-11.86", key: "16dt7o" }],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33",
      key: "l9di03"
    }
  ],
  [
    "path",
    { d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4", key: "1kjonw" }
  ],
  [
    "path",
    { d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98", key: "1zlm23" }
  ]
], TMe = y("Fish", LMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EMe = [
  ["path", { d: "M8 2c3 0 5 2 8 2s4-1 4-1v11", key: "9rwyz9" }],
  ["path", { d: "M4 22V4", key: "1plyxx" }],
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2", key: "1myooe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], jMe = y("FlagOff", EMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NMe = [["path", { d: "M17 22V2L7 7l10 5", key: "1rmf0r" }]], DMe = y("FlagTriangleLeft", NMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IMe = [["path", { d: "M7 22V2l10 5-10 5", key: "17n18y" }]], PMe = y("FlagTriangleRight", IMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zMe = [
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z", key: "i9b6wo" }],
  ["line", { x1: "4", x2: "4", y1: "22", y2: "15", key: "1cm3nv" }]
], RMe = y("Flag", zMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OMe = [
  [
    "path",
    {
      d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z",
      key: "1ir223"
    }
  ],
  ["path", { d: "m5 22 14-4", key: "1brv4h" }],
  ["path", { d: "m5 18 14 4", key: "lgyyje" }]
], BMe = y("FlameKindling", OMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HMe = [
  [
    "path",
    {
      d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
      key: "96xj49"
    }
  ]
], FMe = y("Flame", HMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Me = [
  ["path", { d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4", key: "1r120k" }],
  ["path", { d: "M7 2h11v4c0 2-2 2-2 4v1", key: "dz1920" }],
  ["line", { x1: "11", x2: "18", y1: "6", y2: "6", key: "bi1vpe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], VMe = y("FlashlightOff", _Me);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qMe = [
  [
    "path",
    {
      d: "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z",
      key: "1orkel"
    }
  ],
  ["line", { x1: "6", x2: "18", y1: "6", y2: "6", key: "1z11jq" }],
  ["line", { x1: "12", x2: "12", y1: "12", y2: "12", key: "1f4yc1" }]
], UMe = y("Flashlight", qMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WMe = [
  ["path", { d: "M10 2v2.343", key: "15t272" }],
  ["path", { d: "M14 2v6.343", key: "sxr80q" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20 20a2 2 0 0 1-2 2H6a2 2 0 0 1-1.755-2.96l5.227-9.563", key: "k0duyd" }],
  ["path", { d: "M6.453 15H15", key: "1f0z33" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
], ZMe = y("FlaskConicalOff", WMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GMe = [
  [
    "path",
    {
      d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2",
      key: "18mbvz"
    }
  ],
  ["path", { d: "M6.453 15h11.094", key: "3shlmq" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
], YMe = y("FlaskConical", GMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KMe = [
  ["path", { d: "M10 2v6.292a7 7 0 1 0 4 0V2", key: "1s42pc" }],
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
], $Me = y("FlaskRound", KMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JMe = [
  ["path", { d: "m3 7 5 5-5 5V7", key: "couhi7" }],
  ["path", { d: "m21 7-5 5 5 5V7", key: "6ouia7" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
], QMe = y("FlipHorizontal2", JMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XMe = [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3", key: "1i73f7" }],
  ["path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3", key: "saxlbk" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
], eCe = y("FlipHorizontal", XMe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tCe = [
  ["path", { d: "m17 3-5 5-5-5h10", key: "1ftt6x" }],
  ["path", { d: "m17 21-5-5-5 5h10", key: "1m0wmu" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
], nCe = y("FlipVertical2", tCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rCe = [
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3", key: "14bfxa" }],
  ["path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3", key: "14rx03" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
], iCe = y("FlipVertical", rCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aCe = [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1",
      key: "3pnvol"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["path", { d: "M12 10v12", key: "6ubwww" }],
  ["path", { d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z", key: "9hd38g" }],
  ["path", { d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z", key: "ufn41s" }]
], oCe = y("Flower2", aCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sCe = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5",
      key: "14wa3c"
    }
  ],
  ["path", { d: "M12 7.5V9", key: "1oy5b0" }],
  ["path", { d: "M7.5 12H9", key: "eltsq1" }],
  ["path", { d: "M16.5 12H15", key: "vk5kw4" }],
  ["path", { d: "M12 16.5V15", key: "k7eayi" }],
  ["path", { d: "m8 8 1.88 1.88", key: "nxy4qf" }],
  ["path", { d: "M14.12 9.88 16 8", key: "1lst6k" }],
  ["path", { d: "m8 16 1.88-1.88", key: "h2eex1" }],
  ["path", { d: "M14.12 14.12 16 16", key: "uqkrx3" }]
], lCe = y("Flower", sCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cCe = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
], uCe = y("Focus", cCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dCe = [
  ["path", { d: "M2 12h6", key: "1wqiqv" }],
  ["path", { d: "M22 12h-6", key: "1eg9hc" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 9-3 3 3 3", key: "12ol22" }],
  ["path", { d: "m5 15 3-3-3-3", key: "1kdhjc" }]
], fCe = y("FoldHorizontal", dCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hCe = [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3-3-3 3", key: "e37ymu" }],
  ["path", { d: "m15 5-3 3-3-3", key: "19d6lf" }]
], pCe = y("FoldVertical", hCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mCe = [
  ["circle", { cx: "15", cy: "19", r: "2", key: "u2pros" }],
  [
    "path",
    {
      d: "M20.9 19.8A2 2 0 0 0 22 18V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5.1",
      key: "1jj40k"
    }
  ],
  ["path", { d: "M15 11v-1", key: "cntcp" }],
  ["path", { d: "M15 17v-2", key: "1279jj" }]
], yCe = y("FolderArchive", mCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gCe = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
], vCe = y("FolderCheck", gCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bCe = [
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  [
    "path",
    {
      d: "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2",
      key: "1urifu"
    }
  ],
  ["path", { d: "M16 14v2l1 1", key: "xth2jh" }]
], wCe = y("FolderClock", bCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kCe = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
], xCe = y("FolderClosed", kCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MCe = [
  ["path", { d: "M10 10.5 8 13l2 2.5", key: "m4t9c1" }],
  ["path", { d: "m14 10.5 2 2.5-2 2.5", key: "14w2eb" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z",
      key: "1u1bxd"
    }
  ]
], CCe = y("FolderCode", MCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ACe = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  [
    "path",
    {
      d: "M10.3 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.3",
      key: "1k8050"
    }
  ],
  ["path", { d: "m21.7 19.4-.9-.3", key: "1qgwi9" }],
  ["path", { d: "m15.2 16.9-.9-.3", key: "1t7mvx" }],
  ["path", { d: "m16.6 21.7.3-.9", key: "1j67ps" }],
  ["path", { d: "m19.1 15.2.3-.9", key: "18r7jp" }],
  ["path", { d: "m19.6 21.7-.4-1", key: "z2vh2" }],
  ["path", { d: "m16.8 15.3-.4-1", key: "1ei7r6" }],
  ["path", { d: "m14.3 19.6 1-.4", key: "11sv9r" }],
  ["path", { d: "m20.7 16.8 1-.4", key: "19m87a" }]
], SCe = y("FolderCog", ACe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LCe = [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "1", key: "49l61u" }]
], TCe = y("FolderDot", LCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ECe = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m15 13-3 3-3-3", key: "6j2sf0" }]
], jCe = y("FolderDown", ECe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NCe = [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5",
      key: "1w6njk"
    }
  ],
  ["circle", { cx: "13", cy: "12", r: "2", key: "1j92g6" }],
  ["path", { d: "M18 19c-2.8 0-5-2.2-5-5v8", key: "pkpw2h" }],
  ["circle", { cx: "20", cy: "19", r: "2", key: "1obnsp" }]
], DCe = y("FolderGit2", NCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ICe = [
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M14 13h3", key: "1dgedf" }],
  ["path", { d: "M7 13h3", key: "1pygq7" }]
], PCe = y("FolderGit", ICe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zCe = [
  [
    "path",
    {
      d: "M11 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1.5",
      key: "6hud8k"
    }
  ],
  [
    "path",
    {
      d: "M13.9 17.45c-1.2-1.2-1.14-2.8-.2-3.73a2.43 2.43 0 0 1 3.44 0l.36.34.34-.34a2.43 2.43 0 0 1 3.45-.01c.95.95 1 2.53-.2 3.74L17.5 21Z",
      key: "wpff58"
    }
  ]
], RCe = y("FolderHeart", zCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OCe = [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1",
      key: "fm4g5t"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m9 16 3-3-3-3", key: "6m91ic" }]
], BCe = y("FolderInput", OCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HCe = [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "M8 10v4", key: "tgpxqk" }],
  ["path", { d: "M12 10v2", key: "hh53o1" }],
  ["path", { d: "M16 10v6", key: "1d6xys" }]
], FCe = y("FolderKanban", HCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Ce = [
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2",
      key: "3hgo9p"
    }
  ],
  ["path", { d: "m22 14-4.5 4.5", key: "1ef6z8" }],
  ["path", { d: "m21 15 1 1", key: "1ejcpy" }]
], VCe = y("FolderKey", _Ce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qCe = [
  ["rect", { width: "8", height: "5", x: "14", y: "17", rx: "1", key: "19aais" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2.5",
      key: "1w6v7t"
    }
  ],
  ["path", { d: "M20 17v-2a2 2 0 1 0-4 0v2", key: "pwaxnr" }]
], UCe = y("FolderLock", qCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WCe = [
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
], ZCe = y("FolderMinus", WCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GCe = [
  [
    "path",
    {
      d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2",
      key: "1nmvlm"
    }
  ],
  ["circle", { cx: "14", cy: "15", r: "1", key: "1gm4qj" }]
], YCe = y("FolderOpenDot", GCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KCe = [
  [
    "path",
    {
      d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
      key: "usdka0"
    }
  ]
], $Ce = y("FolderOpen", KCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JCe = [
  [
    "path",
    {
      d: "M2 7.5V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-1.5",
      key: "1yk7aj"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m5 10-3 3 3 3", key: "1r8ie0" }]
], QCe = y("FolderOutput", JCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XCe = [
  [
    "path",
    {
      d: "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5",
      key: "a8xqs0"
    }
  ],
  [
    "path",
    {
      d: "M11.378 13.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1saktj"
    }
  ]
], eAe = y("FolderPen", XCe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tAe = [
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
], nAe = y("FolderPlus", tAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rAe = [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  ["path", { d: "M12 15v5", key: "11xva1" }]
], iAe = y("FolderRoot", rAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aAe = [
  ["circle", { cx: "11.5", cy: "12.5", r: "2.5", key: "1ea5ju" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M13.3 14.3 15 16", key: "1y4v1n" }]
], oAe = y("FolderSearch2", aAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sAe = [
  [
    "path",
    {
      d: "M10.7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v4.1",
      key: "1bw5m7"
    }
  ],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }]
], lAe = y("FolderSearch", sAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cAe = [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "x1c07l"
    }
  ],
  ["path", { d: "m8 16 3-3-3-3", key: "rlqrt1" }]
], uAe = y("FolderSymlink", cAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dAe = [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5",
      key: "1dkoa9"
    }
  ],
  ["path", { d: "M12 10v4h4", key: "1czhmt" }],
  ["path", { d: "m12 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "lvuxfi" }],
  ["path", { d: "M22 22v-4h-4", key: "1ewp4q" }],
  ["path", { d: "m22 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "14ync0" }]
], fAe = y("FolderSync", dAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hAe = [
  [
    "path",
    {
      d: "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "hod4my"
    }
  ],
  [
    "path",
    {
      d: "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "w4yl2u"
    }
  ],
  ["path", { d: "M3 5a2 2 0 0 0 2 2h3", key: "f2jnh7" }],
  ["path", { d: "M3 3v13a2 2 0 0 0 2 2h3", key: "k8epm1" }]
], pAe = y("FolderTree", hAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mAe = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m9 13 3-3 3 3", key: "1pxg3c" }]
], yAe = y("FolderUp", mAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gAe = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9.5 10.5 5 5", key: "ra9qjz" }],
  ["path", { d: "m14.5 10.5-5 5", key: "l2rkpq" }]
], vAe = y("FolderX", gAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bAe = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
], wAe = y("Folder", bAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kAe = [
  [
    "path",
    {
      d: "M20 17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H8a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2Z",
      key: "4u7rpt"
    }
  ],
  ["path", { d: "M2 8v11a2 2 0 0 0 2 2h14", key: "1eicx1" }]
], xAe = y("Folders", kAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MAe = [
  [
    "path",
    {
      d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
      key: "1dudjm"
    }
  ],
  [
    "path",
    {
      d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
      key: "l2t8xc"
    }
  ],
  ["path", { d: "M16 17h4", key: "1dejxt" }],
  ["path", { d: "M4 13h4", key: "1bwh8b" }]
], CAe = y("Footprints", MAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AAe = [
  ["path", { d: "M12 12H5a2 2 0 0 0-2 2v5", key: "7zsz91" }],
  ["circle", { cx: "13", cy: "19", r: "2", key: "wjnkru" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5", key: "13bk1p" }]
], SAe = y("Forklift", AAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LAe = [
  ["polyline", { points: "15 17 20 12 15 7", key: "1w3sku" }],
  ["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12", key: "jmiej9" }]
], TAe = y("Forward", LAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EAe = [
  ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
  ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
  ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
  ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }]
], jAe = y("Frame", EAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NAe = [
  ["path", { d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7", key: "1a2nng" }]
], DAe = y("Framer", NAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IAe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], PAe = y("Frown", IAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zAe = [
  ["line", { x1: "3", x2: "15", y1: "22", y2: "22", key: "xegly4" }],
  ["line", { x1: "4", x2: "14", y1: "9", y2: "9", key: "xcnuvu" }],
  ["path", { d: "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18", key: "16j0yd" }],
  [
    "path",
    {
      d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5",
      key: "7cu91f"
    }
  ]
], RAe = y("Fuel", zAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OAe = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { width: "10", height: "8", x: "7", y: "8", rx: "1", key: "vys8me" }]
], BAe = y("Fullscreen", OAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HAe = [
  ["path", { d: "M2 7v10", key: "a2pl2d" }],
  ["path", { d: "M6 5v14", key: "1kq3d7" }],
  ["rect", { width: "12", height: "18", x: "10", y: "3", rx: "2", key: "13i7bc" }]
], FAe = y("GalleryHorizontalEnd", HAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Ae = [
  ["path", { d: "M2 3v18", key: "pzttux" }],
  ["rect", { width: "12", height: "18", x: "6", y: "3", rx: "2", key: "btr8bg" }],
  ["path", { d: "M22 3v18", key: "6jf3v" }]
], VAe = y("GalleryHorizontal", _Ae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qAe = [
  ["rect", { width: "18", height: "14", x: "3", y: "3", rx: "2", key: "74y24f" }],
  ["path", { d: "M4 21h1", key: "16zlid" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M19 21h1", key: "edywat" }]
], UAe = y("GalleryThumbnails", qAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WAe = [
  ["path", { d: "M7 2h10", key: "nczekb" }],
  ["path", { d: "M5 6h14", key: "u2x4p" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }]
], ZAe = y("GalleryVerticalEnd", WAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GAe = [
  ["path", { d: "M3 2h18", key: "15qxfx" }],
  ["rect", { width: "18", height: "12", x: "3", y: "6", rx: "2", key: "1439r6" }],
  ["path", { d: "M3 22h18", key: "8prr45" }]
], YAe = y("GalleryVertical", GAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KAe = [
  ["line", { x1: "6", x2: "10", y1: "11", y2: "11", key: "1gktln" }],
  ["line", { x1: "8", x2: "8", y1: "9", y2: "13", key: "qnk9ow" }],
  ["line", { x1: "15", x2: "15.01", y1: "12", y2: "12", key: "krot7o" }],
  ["line", { x1: "18", x2: "18.01", y1: "10", y2: "10", key: "1lcuu1" }],
  [
    "path",
    {
      d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z",
      key: "mfqc10"
    }
  ]
], $Ae = y("Gamepad2", KAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JAe = [
  ["line", { x1: "6", x2: "10", y1: "12", y2: "12", key: "161bw2" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "15", x2: "15.01", y1: "13", y2: "13", key: "dqpgro" }],
  ["line", { x1: "18", x2: "18.01", y1: "11", y2: "11", key: "meh2c" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
], QAe = y("Gamepad", JAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XAe = [
  ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
  ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }]
], eSe = y("Gauge", XAe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tSe = [
  ["path", { d: "m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8", key: "15492f" }],
  ["path", { d: "m16 16 6-6", key: "vzrcl6" }],
  ["path", { d: "m8 8 6-6", key: "18bi4p" }],
  ["path", { d: "m9 7 8 8", key: "5jnvq1" }],
  ["path", { d: "m21 11-8-8", key: "z4y7zo" }]
], nSe = y("Gavel", tSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rSe = [
  ["path", { d: "M6 3h12l4 6-10 13L2 9Z", key: "1pcd5k" }],
  ["path", { d: "M11 3 8 9l4 13 4-13-3-6", key: "1fcu3u" }],
  ["path", { d: "M2 9h20", key: "16fsjt" }]
], iSe = y("Gem", rSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aSe = [
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }],
  [
    "path",
    {
      d: "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z",
      key: "uwwb07"
    }
  ]
], oSe = y("Ghost", aSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sSe = [
  ["rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", key: "bkv52" }],
  ["path", { d: "M12 8v13", key: "1c76mn" }],
  ["path", { d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7", key: "6wjy6b" }],
  [
    "path",
    {
      d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
      key: "1ihvrl"
    }
  ]
], lSe = y("Gift", sSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cSe = [
  ["path", { d: "M6 3v12", key: "qpgusn" }],
  ["path", { d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "1d02ji" }],
  ["path", { d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "chk6ph" }],
  ["path", { d: "M15 6a9 9 0 0 0-9 9", key: "or332x" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
], uSe = y("GitBranchPlus", cSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dSe = [
  ["line", { x1: "6", x2: "6", y1: "3", y2: "15", key: "17qcm7" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M18 9a9 9 0 0 1-9 9", key: "n2h4wq" }]
], fSe = y("GitBranch", dSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hSe = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["line", { x1: "3", x2: "9", y1: "12", y2: "12", key: "1dyftd" }],
  ["line", { x1: "15", x2: "21", y1: "12", y2: "12", key: "oup4p8" }]
], pSe = y("GitCommitHorizontal", hSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mSe = [
  ["path", { d: "M12 3v6", key: "1holv5" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M12 15v6", key: "a9ows0" }]
], ySe = y("GitCommitVertical", mSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gSe = [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "M12 18H7a2 2 0 0 1-2-2V9", key: "16sdep" }],
  ["path", { d: "m9 15 3 3-3 3", key: "1m3kbl" }]
], vSe = y("GitCompareArrows", gSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bSe = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["path", { d: "M11 18H8a2 2 0 0 1-2-2V9", key: "19pyzm" }]
], wSe = y("GitCompare", bSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kSe = [
  ["circle", { cx: "12", cy: "18", r: "3", key: "1mpf1b" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["path", { d: "M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9", key: "1uq4wg" }],
  ["path", { d: "M12 12v3", key: "158kv8" }]
], xSe = y("GitFork", kSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MSe = [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["circle", { cx: "5", cy: "18", r: "3", key: "104gr9" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M16 15.7A9 9 0 0 0 19 9", key: "1e3vqb" }]
], CSe = y("GitGraph", MSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ASe = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 21V9a9 9 0 0 0 9 9", key: "7kw0sc" }]
], SSe = y("GitMerge", ASe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LSe = [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }]
], TSe = y("GitPullRequestArrow", LSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ESe = [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "m21 3-6 6", key: "16nqsk" }],
  ["path", { d: "m21 9-6-6", key: "9j17rh" }],
  ["path", { d: "M18 11.5V15", key: "65xf6f" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
], jSe = y("GitPullRequestClosed", ESe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NSe = [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v3", key: "1rbwk6" }],
  ["path", { d: "M19 15v6", key: "10aioa" }],
  ["path", { d: "M22 18h-6", key: "1d5gi5" }]
], DSe = y("GitPullRequestCreateArrow", NSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ISe = [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v3", key: "1jb6z3" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
], PSe = y("GitPullRequestCreate", ISe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zSe = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M18 6V5", key: "1oao2s" }],
  ["path", { d: "M18 11v-1", key: "11c8tz" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
], RSe = y("GitPullRequestDraft", zSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OSe = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
], BSe = y("GitPullRequest", OSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HSe = [
  [
    "path",
    {
      d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4",
      key: "tonef"
    }
  ],
  ["path", { d: "M9 18c-4.51 2-5-2-7-2", key: "9comsn" }]
], FSe = y("Github", HSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Se = [
  [
    "path",
    {
      d: "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z",
      key: "148pdi"
    }
  ]
], VSe = y("Gitlab", _Se);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qSe = [
  [
    "path",
    {
      d: "M5.116 4.104A1 1 0 0 1 6.11 3h11.78a1 1 0 0 1 .994 1.105L17.19 20.21A2 2 0 0 1 15.2 22H8.8a2 2 0 0 1-2-1.79z",
      key: "p55z4y"
    }
  ],
  ["path", { d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0", key: "mjntcy" }]
], USe = y("GlassWater", qSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WSe = [
  ["circle", { cx: "6", cy: "15", r: "4", key: "vux9w4" }],
  ["circle", { cx: "18", cy: "15", r: "4", key: "18o8ve" }],
  ["path", { d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2", key: "1ag4bs" }],
  ["path", { d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2", key: "1hm1gs" }],
  ["path", { d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2", key: "1r31ai" }]
], ZSe = y("Glasses", WSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GSe = [
  [
    "path",
    {
      d: "M15.686 15A14.5 14.5 0 0 1 12 22a14.5 14.5 0 0 1 0-20 10 10 0 1 0 9.542 13",
      key: "qkt0x6"
    }
  ],
  ["path", { d: "M2 12h8.5", key: "ovaggd" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
], YSe = y("GlobeLock", GSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KSe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
], $Se = y("Globe", KSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JSe = [
  ["path", { d: "M12 13V2l8 4-8 4", key: "5wlwwj" }],
  ["path", { d: "M20.561 10.222a9 9 0 1 1-12.55-5.29", key: "1c0wjv" }],
  ["path", { d: "M8.002 9.997a5 5 0 1 0 8.9 2.02", key: "gb1g7m" }]
], QSe = y("Goal", JSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XSe = [
  ["path", { d: "M18 11.5V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "edstyy" }],
  ["path", { d: "M14 10V8a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "19wdwo" }],
  ["path", { d: "M10 9.9V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "1lugqo" }],
  ["path", { d: "M6 14a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1hbeus" }],
  [
    "path",
    { d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0", key: "1etffm" }
  ]
], eLe = y("Grab", XSe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tLe = [
  [
    "path",
    {
      d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
      key: "j76jl0"
    }
  ],
  ["path", { d: "M22 10v6", key: "1lu8f3" }],
  ["path", { d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5", key: "1r8lef" }]
], nLe = y("GraduationCap", tLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rLe = [
  ["path", { d: "M22 5V2l-5.89 5.89", key: "1eenpo" }],
  ["circle", { cx: "16.6", cy: "15.89", r: "3", key: "xjtalx" }],
  ["circle", { cx: "8.11", cy: "7.4", r: "3", key: "u2fv6i" }],
  ["circle", { cx: "12.35", cy: "11.65", r: "3", key: "i6i8g7" }],
  ["circle", { cx: "13.91", cy: "5.85", r: "3", key: "6ye0dv" }],
  ["circle", { cx: "18.15", cy: "10.09", r: "3", key: "snx9no" }],
  ["circle", { cx: "6.56", cy: "13.2", r: "3", key: "17x4xg" }],
  ["circle", { cx: "10.8", cy: "17.44", r: "3", key: "1hogw9" }],
  ["circle", { cx: "5", cy: "19", r: "3", key: "1sn6vo" }]
], iLe = y("Grape", rLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aLe = [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
], oLe = y("Grid2x2Check", aLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sLe = [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 22v-6", key: "qhmiwi" }]
], lLe = y("Grid2x2Plus", sLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cLe = [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 16 5 5", key: "8tpb07" }],
  ["path", { d: "m16 21 5-5", key: "193jll" }]
], uLe = y("Grid2x2X", cLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dLe = [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
], fLe = y("Grid2x2", dLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hLe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], pLe = y("Grid3x3", hLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mLe = [
  ["circle", { cx: "12", cy: "9", r: "1", key: "124mty" }],
  ["circle", { cx: "19", cy: "9", r: "1", key: "1ruzo2" }],
  ["circle", { cx: "5", cy: "9", r: "1", key: "1a8b28" }],
  ["circle", { cx: "12", cy: "15", r: "1", key: "1e56xg" }],
  ["circle", { cx: "19", cy: "15", r: "1", key: "1a92ep" }],
  ["circle", { cx: "5", cy: "15", r: "1", key: "5r1jwy" }]
], yLe = y("GripHorizontal", mLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gLe = [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
], vLe = y("GripVertical", gLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bLe = [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "19", cy: "5", r: "1", key: "w8mnmm" }],
  ["circle", { cx: "5", cy: "5", r: "1", key: "lttvr7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }],
  ["circle", { cx: "19", cy: "19", r: "1", key: "shf9b7" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
], wLe = y("Grip", bLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kLe = [
  ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2", key: "adw53z" }],
  ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2", key: "an4l38" }],
  ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2", key: "144t0e" }],
  ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", key: "rtnfgi" }],
  ["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1", key: "1eyiv7" }],
  ["rect", { width: "7", height: "5", x: "10", y: "12", rx: "1", key: "1qlmkx" }]
], xLe = y("Group", kLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MLe = [
  ["path", { d: "m11.9 12.1 4.514-4.514", key: "109xqo" }],
  [
    "path",
    {
      d: "M20.1 2.3a1 1 0 0 0-1.4 0l-1.114 1.114A2 2 0 0 0 17 4.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 17.828 7h1.344a2 2 0 0 0 1.414-.586L21.7 5.3a1 1 0 0 0 0-1.4z",
      key: "txyc8t"
    }
  ],
  ["path", { d: "m6 16 2 2", key: "16qmzd" }],
  [
    "path",
    {
      d: "M8.2 9.9C8.7 8.8 9.8 8 11 8c2.8 0 5 2.2 5 5 0 1.2-.8 2.3-1.9 2.8l-.9.4A2 2 0 0 0 12 18a4 4 0 0 1-4 4c-3.3 0-6-2.7-6-6a4 4 0 0 1 4-4 2 2 0 0 0 1.8-1.2z",
      key: "1u8q3z"
    }
  ],
  ["circle", { cx: "11.5", cy: "12.5", r: ".5", fill: "currentColor", key: "16onso" }]
], CLe = y("Guitar", MLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ALe = [
  ["path", { d: "M13.144 21.144A7.274 10.445 45 1 0 2.856 10.856", key: "1k1t7q" }],
  [
    "path",
    {
      d: "M13.144 21.144A7.274 4.365 45 0 0 2.856 10.856a7.274 4.365 45 0 0 10.288 10.288",
      key: "153t1g"
    }
  ],
  [
    "path",
    {
      d: "M16.565 10.435 18.6 8.4a2.501 2.501 0 1 0 1.65-4.65 2.5 2.5 0 1 0-4.66 1.66l-2.024 2.025",
      key: "gzrt0n"
    }
  ],
  ["path", { d: "m8.5 16.5-1-1", key: "otr954" }]
], SLe = y("Ham", ALe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LLe = [
  ["path", { d: "m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9", key: "eefl8a" }],
  ["path", { d: "m18 15 4-4", key: "16gjal" }],
  [
    "path",
    {
      d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
      key: "b7pghm"
    }
  ]
], TLe = y("Hammer", LLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ELe = [
  ["path", { d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17", key: "geh8rc" }],
  [
    "path",
    {
      d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "1fto5m"
    }
  ],
  ["path", { d: "m2 16 6 6", key: "1pfhp9" }],
  ["circle", { cx: "16", cy: "9", r: "2.9", key: "1n0dlu" }],
  ["circle", { cx: "6", cy: "5", r: "3", key: "151irh" }]
], jLe = y("HandCoins", ELe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NLe = [
  ["path", { d: "M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16", key: "1ifwr1" }],
  [
    "path",
    {
      d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "17abbs"
    }
  ],
  ["path", { d: "m2 15 6 6", key: "10dquu" }],
  [
    "path",
    {
      d: "M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z",
      key: "1h3036"
    }
  ]
], DLe = y("HandHeart", NLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ILe = [
  ["path", { d: "M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14", key: "1j4xps" }],
  [
    "path",
    {
      d: "m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "uospg8"
    }
  ],
  ["path", { d: "m2 13 6 6", key: "16e5sb" }]
], PLe = y("HandHelping", ILe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zLe = [
  ["path", { d: "M18 12.5V10a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "wc6myp" }],
  ["path", { d: "M14 11V9a2 2 0 1 0-4 0v2", key: "94qvcw" }],
  ["path", { d: "M10 10.5V5a2 2 0 1 0-4 0v9", key: "m1ah89" }],
  [
    "path",
    {
      d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5",
      key: "t1skq1"
    }
  ]
], RLe = y("HandMetal", zLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OLe = [
  ["path", { d: "M12 3V2", key: "ar7q03" }],
  [
    "path",
    {
      d: "m15.4 17.4 3.2-2.8a2 2 0 1 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2l-1.302-1.464A1 1 0 0 0 6.151 19H5",
      key: "n2g93r"
    }
  ],
  ["path", { d: "M2 14h12a2 2 0 0 1 0 4h-2", key: "1o2jem" }],
  ["path", { d: "M4 10h16", key: "img6z1" }],
  ["path", { d: "M5 10a7 7 0 0 1 14 0", key: "1ega1o" }],
  ["path", { d: "M5 14v6a1 1 0 0 1-1 1H2", key: "1hescx" }]
], BLe = y("HandPlatter", OLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HLe = [
  ["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1fvzgz" }],
  ["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "1kc0my" }],
  ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8", key: "10h0bg" }],
  [
    "path",
    {
      d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "1s1gnw"
    }
  ]
], FLe = y("Hand", HLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Le = [
  ["path", { d: "m11 17 2 2a1 1 0 1 0 3-3", key: "efffak" }],
  [
    "path",
    {
      d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
      key: "9pr0kb"
    }
  ],
  ["path", { d: "m21 3 1 11h-2", key: "1tisrp" }],
  ["path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3", key: "1uvwmv" }],
  ["path", { d: "M3 4h8", key: "1ep09j" }]
], VLe = y("Handshake", _Le);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qLe = [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
], ULe = y("HardDriveDownload", qLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WLe = [
  ["path", { d: "m16 6-4-4-4 4", key: "13yo43" }],
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
], ZLe = y("HardDriveUpload", WLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GLe = [
  ["line", { x1: "22", x2: "2", y1: "12", y2: "12", key: "1y58io" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ],
  ["line", { x1: "6", x2: "6.01", y1: "16", y2: "16", key: "sgf278" }],
  ["line", { x1: "10", x2: "10.01", y1: "16", y2: "16", key: "1l4acy" }]
], YLe = y("HardDrive", GLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KLe = [
  ["path", { d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5", key: "1p9q5i" }],
  ["path", { d: "M14 6a6 6 0 0 1 6 6v3", key: "1hnv84" }],
  ["path", { d: "M4 15v-3a6 6 0 0 1 6-6", key: "9ciidu" }],
  ["rect", { x: "2", y: "15", width: "20", height: "4", rx: "1", key: "g3x8cw" }]
], $Le = y("HardHat", KLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JLe = [
  ["line", { x1: "4", x2: "20", y1: "9", y2: "9", key: "4lhtct" }],
  ["line", { x1: "4", x2: "20", y1: "15", y2: "15", key: "vyu0kd" }],
  ["line", { x1: "10", x2: "8", y1: "3", y2: "21", key: "1ggp8o" }],
  ["line", { x1: "16", x2: "14", y1: "3", y2: "21", key: "weycgp" }]
], QLe = y("Hash", JLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XLe = [
  ["path", { d: "m5.2 6.2 1.4 1.4", key: "17imol" }],
  ["path", { d: "M2 13h2", key: "13gyu8" }],
  ["path", { d: "M20 13h2", key: "16rner" }],
  ["path", { d: "m17.4 7.6 1.4-1.4", key: "t4xlah" }],
  ["path", { d: "M22 17H2", key: "1gtaj3" }],
  ["path", { d: "M22 21H2", key: "1gy6en" }],
  ["path", { d: "M16 13a4 4 0 0 0-8 0", key: "1dyczq" }],
  ["path", { d: "M12 5V2.5", key: "1vytko" }]
], eTe = y("Haze", XLe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tTe = [
  [
    "path",
    {
      d: "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z",
      key: "2128wb"
    }
  ],
  ["path", { d: "M7.5 12h9", key: "1t0ckc" }]
], nTe = y("HdmiPort", tTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rTe = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "m17 12 3-2v8", key: "1hhhft" }]
], iTe = y("Heading1", rTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aTe = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1", key: "9jr5yi" }]
], oTe = y("Heading2", aTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sTe = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2", key: "68ncm8" }],
  ["path", { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2", key: "1ejuhz" }]
], lTe = y("Heading3", sTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cTe = [
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 10v3a1 1 0 0 0 1 1h3", key: "tj5zdr" }],
  ["path", { d: "M21 10v8", key: "1kdml4" }],
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }]
], uTe = y("Heading4", cTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dTe = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 13v-3h4", key: "1nvgqp" }],
  [
    "path",
    { d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17", key: "2nebdn" }
  ]
], fTe = y("Heading5", dTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hTe = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["circle", { cx: "19", cy: "16", r: "2", key: "15mx69" }],
  ["path", { d: "M20 10c-2 2-3 3.5-3 6", key: "f35dl0" }]
], pTe = y("Heading6", hTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mTe = [
  ["path", { d: "M6 12h12", key: "8npq4p" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }],
  ["path", { d: "M18 20V4", key: "o2hl4u" }]
], yTe = y("Heading", mTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gTe = [
  ["path", { d: "M21 14h-1.343", key: "1jdnxi" }],
  ["path", { d: "M9.128 3.47A9 9 0 0 1 21 12v3.343", key: "6kipu2" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20.414 20.414A2 2 0 0 1 19 21h-1a2 2 0 0 1-2-2v-3", key: "9x50f4" }],
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 2.636-6.364",
      key: "1bkxnm"
    }
  ]
], vTe = y("HeadphoneOff", gTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bTe = [
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
      key: "1xhozi"
    }
  ]
], wTe = y("Headphones", bTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kTe = [
  [
    "path",
    {
      d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z",
      key: "12oyoe"
    }
  ],
  ["path", { d: "M21 16v2a4 4 0 0 1-4 4h-5", key: "1x7m43" }]
], xTe = y("Headset", kTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MTe = [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "m12 13-1-1 2-2-3-3 2-2", key: "xjdxli" }]
], CTe = y("HeartCrack", MTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ATe = [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  [
    "path",
    {
      d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66",
      key: "4oyue0"
    }
  ],
  ["path", { d: "m18 15-2-2", key: "60u0ii" }],
  ["path", { d: "m15 18-2-2", key: "6p76be" }]
], STe = y("HeartHandshake", ATe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LTe = [
  ["line", { x1: "2", y1: "2", x2: "22", y2: "22", key: "1w4vcy" }],
  [
    "path",
    { d: "M16.5 16.5 12 21l-7-7c-1.5-1.45-3-3.2-3-5.5a5.5 5.5 0 0 1 2.14-4.35", key: "3mpagl" }
  ],
  [
    "path",
    {
      d: "M8.76 3.1c1.15.22 2.13.78 3.24 1.9 1.5-1.5 2.74-2 4.5-2A5.5 5.5 0 0 1 22 8.5c0 2.12-1.3 3.78-2.67 5.17",
      key: "1gh3v3"
    }
  ]
], TTe = y("HeartOff", LTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ETe = [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27", key: "1uw2ng" }]
], jTe = y("HeartPulse", ETe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NTe = [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
], DTe = y("Heart", NTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ITe = [
  ["path", { d: "M11 8c2-3-2-3 0-6", key: "1ldv5m" }],
  ["path", { d: "M15.5 8c2-3-2-3 0-6", key: "1otqoz" }],
  ["path", { d: "M6 10h.01", key: "1lbq93" }],
  ["path", { d: "M6 14h.01", key: "zudwn7" }],
  ["path", { d: "M10 16v-4", key: "1c25yv" }],
  ["path", { d: "M14 16v-4", key: "1dkbt8" }],
  ["path", { d: "M18 16v-4", key: "1yg9me" }],
  [
    "path",
    { d: "M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3", key: "1ubg90" }
  ],
  ["path", { d: "M5 20v2", key: "1abpe8" }],
  ["path", { d: "M19 20v2", key: "kqn6ft" }]
], PTe = y("Heater", ITe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zTe = [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ]
], RTe = y("Hexagon", zTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OTe = [
  ["path", { d: "m9 11-6 6v3h9l3-3", key: "1a3l36" }],
  ["path", { d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4", key: "14a9rk" }]
], BTe = y("Highlighter", OTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HTe = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
], FTe = y("History", HTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Te = [
  ["path", { d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.28.01.53-.09.7-.27", key: "qyzcap" }],
  [
    "path",
    {
      d: "M11.14 20.57c.52.24 2.44 1.12 4.08 1.37.46.06.86-.25.9-.71.12-1.52-.3-3.43-.5-4.28",
      key: "y078lb"
    }
  ],
  ["path", { d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .7-.26", key: "1utre3" }],
  [
    "path",
    {
      d: "M17.99 5.52a20.83 20.83 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-1.17.1-2.5.02-3.9-.25",
      key: "17o9hm"
    }
  ],
  ["path", { d: "M20.57 11.14c.24.52 1.12 2.44 1.37 4.08.04.3-.08.59-.31.75", key: "1d1n4p" }],
  [
    "path",
    {
      d: "M4.93 4.93a10 10 0 0 0-.67 13.4c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.85.85 0 0 0 .48-.24",
      key: "9uv3tt"
    }
  ],
  [
    "path",
    {
      d: "M5.52 17.99c1.05.95 2.91 2.42 4.5 3.15a.8.8 0 0 0 1.13-.68c.2-2.34-.33-5.3-1.57-8.28",
      key: "1292wz"
    }
  ],
  [
    "path",
    {
      d: "M8.35 2.68a10 10 0 0 1 9.98 1.58c.43.35.4.96-.12 1.17-1.5.6-4.3.98-6.07 1.05",
      key: "7ozu9p"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], VTe = y("HopOff", _Te);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qTe = [
  [
    "path",
    {
      d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18",
      key: "18lxf1"
    }
  ],
  [
    "path",
    {
      d: "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88",
      key: "vtfxrw"
    }
  ],
  [
    "path",
    {
      d: "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36",
      key: "13hl71"
    }
  ],
  [
    "path",
    {
      d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87",
      key: "1sl8oj"
    }
  ],
  [
    "path",
    {
      d: "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08",
      key: "19c6kt"
    }
  ],
  [
    "path",
    {
      d: "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57",
      key: "85ghs3"
    }
  ],
  ["path", { d: "M4.93 4.93 3 3a.7.7 0 0 1 0-1", key: "x087yj" }],
  [
    "path",
    {
      d: "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15",
      key: "11xdqo"
    }
  ]
], UTe = y("Hop", qTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WTe = [
  ["path", { d: "M12 6v4", key: "16clxf" }],
  ["path", { d: "M14 14h-4", key: "esezmu" }],
  ["path", { d: "M14 18h-4", key: "16mqa2" }],
  ["path", { d: "M14 8h-4", key: "z8ypaz" }],
  [
    "path",
    {
      d: "M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2",
      key: "b1k337"
    }
  ],
  ["path", { d: "M18 22V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v18", key: "16g51d" }]
], ZTe = y("Hospital", WTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GTe = [
  ["path", { d: "M10 22v-6.57", key: "1wmca3" }],
  ["path", { d: "M12 11h.01", key: "z322tv" }],
  ["path", { d: "M12 7h.01", key: "1ivr5q" }],
  ["path", { d: "M14 15.43V22", key: "1q2vjd" }],
  ["path", { d: "M15 16a5 5 0 0 0-6 0", key: "o9wqvi" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }],
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 7h.01", key: "1vti4s" }],
  ["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2", key: "1uxh74" }]
], YTe = y("Hotel", GTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KTe = [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  ["path", { d: "M5 2h14", key: "pdyrp9" }],
  [
    "path",
    {
      d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
      key: "1d314k"
    }
  ],
  [
    "path",
    { d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2", key: "1vvvr6" }
  ]
], $Te = y("Hourglass", KTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JTe = [
  ["path", { d: "M10 12V8.964", key: "1vll13" }],
  ["path", { d: "M14 12V8.964", key: "1x3qvg" }],
  [
    "path",
    { d: "M15 12a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1z", key: "ppykja" }
  ],
  [
    "path",
    {
      d: "M8.5 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2",
      key: "1gvg2z"
    }
  ]
], QTe = y("HousePlug", JTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XTe = [
  [
    "path",
    {
      d: "M13.22 2.416a2 2 0 0 0-2.511.057l-7 5.999A2 2 0 0 0 3 10v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7.354",
      key: "5phn05"
    }
  ],
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "M18 3v6", key: "x1uolp" }]
], eEe = y("HousePlus", XTe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tEe = [
  ["path", { d: "M9.5 13.866a4 4 0 0 1 5 .01", key: "1wy54i" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ],
  ["path", { d: "M7 10.754a8 8 0 0 1 10 0", key: "exoy2g" }]
], nEe = y("HouseWifi", tEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rEe = [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ]
], iEe = y("House", rEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aEe = [
  [
    "path",
    {
      d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6m-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0",
      key: "1uxfcu"
    }
  ],
  ["path", { d: "M12.14 11a3.5 3.5 0 1 1 6.71 0", key: "4k3m1s" }],
  ["path", { d: "M15.5 6.5a3.5 3.5 0 1 0-7 0", key: "zmuahr" }]
], oEe = y("IceCreamBowl", aEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sEe = [
  ["path", { d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11", key: "1v6356" }],
  ["path", { d: "M17 7A5 5 0 0 0 7 7", key: "151p3v" }],
  ["path", { d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4", key: "1sdaij" }]
], lEe = y("IceCreamCone", sEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cEe = [
  ["path", { d: "M16 10h2", key: "8sgtl7" }],
  ["path", { d: "M16 14h2", key: "epxaof" }],
  ["path", { d: "M6.17 15a3 3 0 0 1 5.66 0", key: "n6f512" }],
  ["circle", { cx: "9", cy: "11", r: "2", key: "yxgjnd" }],
  ["rect", { x: "2", y: "5", width: "20", height: "14", rx: "2", key: "qneu4z" }]
], uEe = y("IdCard", cEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dEe = [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19 3 3v-5.5", key: "9ldu5r" }],
  ["path", { d: "m17 22 3-3", key: "1nkfve" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
], fEe = y("ImageDown", dEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hEe = [
  ["path", { d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "m87ecr" }],
  ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
], pEe = y("ImageMinus", hEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mEe = [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
  ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
  [
    "path",
    {
      d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
      key: "mmje98"
    }
  ],
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
], yEe = y("ImageOff", mEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gEe = [
  ["path", { d: "m11 16-5 5", key: "j5f7ct" }],
  ["path", { d: "M11 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6.5", key: "7s81lt" }],
  [
    "path",
    {
      d: "M15.765 22a.5.5 0 0 1-.765-.424V13.38a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "1omb6s"
    }
  ],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
], vEe = y("ImagePlay", gEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bEe = [
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }],
  ["path", { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5", key: "1ue2ih" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
], wEe = y("ImagePlus", bEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kEe = [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19.5 3-3 3 3", key: "9vmjn0" }],
  ["path", { d: "M17 22v-5.5", key: "1aa6fl" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
], xEe = y("ImageUp", kEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MEe = [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M17 21h2a2 2 0 0 0 2-2", key: "130fy9" }],
  ["path", { d: "M21 12v3", key: "1wzk3p" }],
  ["path", { d: "m21 3-5 5", key: "1g5oa7" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2", key: "kk3yz1" }],
  ["path", { d: "m5 21 4.144-4.144a1.21 1.21 0 0 1 1.712 0L13 19", key: "fyekpt" }],
  ["path", { d: "M9 3h3", key: "d52fa" }],
  ["rect", { x: "3", y: "11", width: "10", height: "10", rx: "1", key: "1wpmix" }]
], CEe = y("ImageUpscale", MEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AEe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
], SEe = y("Image", AEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LEe = [
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  ["path", { d: "m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18", key: "nf6bnh" }],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["rect", { width: "16", height: "16", x: "6", y: "2", rx: "2", key: "12espp" }]
], TEe = y("Images", LEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EEe = [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m8 11 4 4 4-4", key: "1dohi6" }],
  [
    "path",
    {
      d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
      key: "1ywtjm"
    }
  ]
], jEe = y("Import", EEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NEe = [
  ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ]
], DEe = y("Inbox", NEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IEe = [
  ["path", { d: "M21 12H11", key: "wd7e0v" }],
  ["path", { d: "M21 18H11", key: "4wu86t" }],
  ["path", { d: "M21 6H11", key: "6dy1d6" }],
  ["path", { d: "m7 8-4 4 4 4", key: "o5hrat" }]
], PEe = y("IndentDecrease", IEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zEe = [
  ["path", { d: "M21 12H11", key: "wd7e0v" }],
  ["path", { d: "M21 18H11", key: "4wu86t" }],
  ["path", { d: "M21 6H11", key: "6dy1d6" }],
  ["path", { d: "m3 8 4 4-4 4", key: "1a3j6y" }]
], REe = y("IndentIncrease", zEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OEe = [
  ["path", { d: "M6 3h12", key: "ggurg9" }],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "m6 13 8.5 8", key: "u1kupk" }],
  ["path", { d: "M6 13h3", key: "wdp6ag" }],
  ["path", { d: "M9 13c6.667 0 6.667-10 0-10", key: "1nkvk2" }]
], BEe = y("IndianRupee", OEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HEe = [
  [
    "path",
    {
      d: "M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z",
      key: "1z0uae"
    }
  ]
], FEe = y("Infinity", HEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Ee = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], VEe = y("Info", _Ee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qEe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h.01", key: "7u93v4" }],
  ["path", { d: "M17 7h.01", key: "14a9sn" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M17 17h.01", key: "1sd3ek" }]
], UEe = y("InspectionPanel", qEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WEe = [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "5", ry: "5", key: "2e1cvw" }],
  ["path", { d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z", key: "9exkf1" }],
  ["line", { x1: "17.5", x2: "17.51", y1: "6.5", y2: "6.5", key: "r4j83e" }]
], ZEe = y("Instagram", WEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GEe = [
  ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
  ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
  ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }]
], YEe = y("Italic", GEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KEe = [
  ["path", { d: "M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8", key: "4znkd0" }],
  ["polyline", { points: "16 14 20 18 16 22", key: "11njsm" }]
], $Ee = y("IterationCcw", KEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JEe = [
  ["path", { d: "M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4", key: "tuf4su" }],
  ["polyline", { points: "8 22 4 18 8 14", key: "evkj9s" }]
], QEe = y("IterationCw", JEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XEe = [
  ["path", { d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3", key: "2ej80x" }],
  ["path", { d: "M6 15h12", key: "1hwgt5" }],
  ["path", { d: "M6 11h12", key: "wf4gp6" }]
], eje = y("JapaneseYen", XEe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tje = [
  [
    "path",
    {
      d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z",
      key: "jg2n2t"
    }
  ],
  ["path", { d: "M6 15v-2", key: "gd6mvg" }],
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["circle", { cx: "12", cy: "6", r: "3", key: "1gm2ql" }]
], nje = y("Joystick", tje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rje = [
  ["path", { d: "M6 5v11", key: "mdvv1e" }],
  ["path", { d: "M12 5v6", key: "14ar3b" }],
  ["path", { d: "M18 5v14", key: "7ji314" }]
], ije = y("Kanban", rje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aje = [
  [
    "path",
    {
      d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z",
      key: "1s6t7t"
    }
  ],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }]
], oje = y("KeyRound", aje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sje = [
  [
    "path",
    {
      d: "M12.4 2.7a2.5 2.5 0 0 1 3.4 0l5.5 5.5a2.5 2.5 0 0 1 0 3.4l-3.7 3.7a2.5 2.5 0 0 1-3.4 0L8.7 9.8a2.5 2.5 0 0 1 0-3.4z",
      key: "165ttr"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  [
    "path",
    {
      d: "m9.4 10.6-6.814 6.814A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814",
      key: "1ubxi2"
    }
  ]
], lje = y("KeySquare", sje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cje = [
  ["path", { d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4", key: "g0fldk" }],
  ["path", { d: "m21 2-9.6 9.6", key: "1j0ho8" }],
  ["circle", { cx: "7.5", cy: "15.5", r: "5.5", key: "yqb3hr" }]
], uje = y("Key", cje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dje = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M6 12v4", key: "dy92yo" }],
  ["path", { d: "M10 12v4", key: "1fxnav" }],
  ["path", { d: "M14 12v4", key: "1hft58" }],
  ["path", { d: "M18 12v4", key: "tjjnbz" }]
], fje = y("KeyboardMusic", dje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hje = [
  ["path", { d: "M 20 4 A2 2 0 0 1 22 6", key: "1g1fkt" }],
  ["path", { d: "M 22 6 L 22 16.41", key: "1qjg3w" }],
  ["path", { d: "M 7 16 L 16 16", key: "n0yqwb" }],
  ["path", { d: "M 9.69 4 L 20 4", key: "kbpcgx" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2", key: "s23sx2" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }]
], pje = y("KeyboardOff", hje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mje = [
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M7 16h10", key: "wp8him" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }]
], yje = y("Keyboard", mje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gje = [
  ["path", { d: "M12 2v5", key: "nd4vlx" }],
  ["path", { d: "M6 7h12l4 9H2l4-9Z", key: "123d64" }],
  ["path", { d: "M9.17 16a3 3 0 1 0 5.66 0", key: "1061mw" }]
], vje = y("LampCeiling", gje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bje = [
  ["path", { d: "m14 5-3 3 2 7 8-8-7-2Z", key: "1b0msb" }],
  ["path", { d: "m14 5-3 3-3-3 3-3 3 3Z", key: "1uemms" }],
  ["path", { d: "M9.5 6.5 4 12l3 6", key: "1bx08v" }],
  ["path", { d: "M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z", key: "wap775" }]
], wje = y("LampDesk", bje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kje = [
  ["path", { d: "M9 2h6l3 7H6l3-7Z", key: "wcx6mj" }],
  ["path", { d: "M12 9v13", key: "3n1su1" }],
  ["path", { d: "M9 22h6", key: "1rlq3v" }]
], xje = y("LampFloor", kje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mje = [
  ["path", { d: "M11 13h6l3 7H8l3-7Z", key: "9n3qlo" }],
  ["path", { d: "M14 13V8a2 2 0 0 0-2-2H8", key: "1hu4hb" }],
  ["path", { d: "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z", key: "s053bc" }]
], Cje = y("LampWallDown", Mje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aje = [
  ["path", { d: "M11 4h6l3 7H8l3-7Z", key: "11x1ee" }],
  ["path", { d: "M14 11v5a2 2 0 0 1-2 2H8", key: "eutp5o" }],
  ["path", { d: "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z", key: "1iuthr" }]
], Sje = y("LampWallUp", Aje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lje = [
  ["path", { d: "M8 2h8l4 10H4L8 2Z", key: "9dma5w" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z", key: "mwf4oh" }]
], Tje = y("Lamp", Lje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eje = [
  ["path", { d: "m12 8 6-3-6-3v10", key: "mvpnpy" }],
  [
    "path",
    {
      d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12",
      key: "ek95tt"
    }
  ],
  ["path", { d: "m6.49 12.85 11.02 6.3", key: "1kt42w" }],
  ["path", { d: "M17.51 12.85 6.5 19.15", key: "v55bdg" }]
], jje = y("LandPlot", Eje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nje = [
  ["line", { x1: "3", x2: "21", y1: "22", y2: "22", key: "j8o0r" }],
  ["line", { x1: "6", x2: "6", y1: "18", y2: "11", key: "10tf0k" }],
  ["line", { x1: "10", x2: "10", y1: "18", y2: "11", key: "54lgf6" }],
  ["line", { x1: "14", x2: "14", y1: "18", y2: "11", key: "380y" }],
  ["line", { x1: "18", x2: "18", y1: "18", y2: "11", key: "1kevvc" }],
  ["polygon", { points: "12 2 20 7 4 7", key: "jkujk7" }]
], Dje = y("Landmark", Nje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ije = [
  ["path", { d: "m5 8 6 6", key: "1wu5hv" }],
  ["path", { d: "m4 14 6-6 2-3", key: "1k1g8d" }],
  ["path", { d: "M2 5h12", key: "or177f" }],
  ["path", { d: "M7 2h1", key: "1t2jsx" }],
  ["path", { d: "m22 22-5-10-5 10", key: "don7ne" }],
  ["path", { d: "M14 18h6", key: "1m8k6r" }]
], Pje = y("Languages", Ije);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zje = [
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ["rect", { x: "3", y: "4", width: "18", height: "12", rx: "2", key: "8ur36m" }]
], Rje = y("LaptopMinimalCheck", zje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oje = [
  ["rect", { width: "18", height: "12", x: "3", y: "4", rx: "2", ry: "2", key: "1qhy41" }],
  ["line", { x1: "2", x2: "22", y1: "20", y2: "20", key: "ni3hll" }]
], Bje = y("LaptopMinimal", Oje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hje = [
  [
    "path",
    {
      d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16",
      key: "tarvll"
    }
  ]
], Fje = y("Laptop", Hje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _je = [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91", key: "ybbtv3" }],
  [
    "path",
    {
      d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
      key: "gt5e1w"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
  [
    "path",
    {
      d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14z",
      key: "72q637"
    }
  ]
], Vje = y("LassoSelect", _je);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qje = [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  [
    "path",
    {
      d: "M3.3 14A6.8 6.8 0 0 1 2 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 0 1-5-1",
      key: "146dds"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }]
], Uje = y("Lasso", qje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wje = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z", key: "b2q4dd" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], Zje = y("Laugh", Wje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gje = [
  [
    "path",
    {
      d: "m16.02 12 5.48 3.13a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74L7.98 12",
      key: "1cuww1"
    }
  ],
  [
    "path",
    {
      d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74Z",
      key: "pdlvxu"
    }
  ]
], Yje = y("Layers2", Gje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kje = [
  [
    "path",
    {
      d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
      key: "zw3jo"
    }
  ],
  [
    "path",
    {
      d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
      key: "1wduqc"
    }
  ],
  [
    "path",
    {
      d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
      key: "kqbvx6"
    }
  ]
], $je = y("Layers", Kje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jje = [
  ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
  ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }],
  ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }],
  ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }]
], Qje = y("LayoutDashboard", Jje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xje = [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
], eNe = y("LayoutGrid", Xje);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tNe = [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["path", { d: "M14 4h7", key: "3xa0d5" }],
  ["path", { d: "M14 9h7", key: "1icrd9" }],
  ["path", { d: "M14 15h7", key: "1mj8o2" }],
  ["path", { d: "M14 20h7", key: "11slyb" }]
], nNe = y("LayoutList", tNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rNe = [
  ["rect", { width: "7", height: "18", x: "3", y: "3", rx: "1", key: "2obqm" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
], iNe = y("LayoutPanelLeft", rNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aNe = [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
], oNe = y("LayoutPanelTop", aNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sNe = [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
  ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
], lNe = y("LayoutTemplate", sNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cNe = [
  [
    "path",
    {
      d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z",
      key: "nnexq3"
    }
  ],
  ["path", { d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12", key: "mt58a7" }]
], uNe = y("Leaf", cNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dNe = [
  [
    "path",
    {
      d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22",
      key: "1134nt"
    }
  ],
  ["path", { d: "M2 22 17 7", key: "1q7jp2" }]
], fNe = y("LeafyGreen", dNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hNe = [
  [
    "path",
    {
      d: "M16 12h3a2 2 0 0 0 1.902-1.38l1.056-3.333A1 1 0 0 0 21 6H3a1 1 0 0 0-.958 1.287l1.056 3.334A2 2 0 0 0 5 12h3",
      key: "13jjxg"
    }
  ],
  ["path", { d: "M18 6V3a1 1 0 0 0-1-1h-3", key: "1550fe" }],
  ["rect", { width: "8", height: "12", x: "8", y: "10", rx: "1", key: "qmu8b6" }]
], pNe = y("Lectern", hNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mNe = [
  ["path", { d: "M15 12h6", key: "upa0zy" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "m3 13 3.553-7.724a.5.5 0 0 1 .894 0L11 13", key: "blevx4" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M4 11h6", key: "olkgv1" }]
], yNe = y("LetterText", mNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gNe = [
  ["rect", { width: "8", height: "18", x: "3", y: "3", rx: "1", key: "oynpb5" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  [
    "path",
    {
      d: "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z",
      key: "1qboyk"
    }
  ]
], vNe = y("LibraryBig", gNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bNe = [
  ["path", { d: "m16 6 4 14", key: "ji33uf" }],
  ["path", { d: "M12 6v14", key: "1n7gus" }],
  ["path", { d: "M8 8v12", key: "1gg7y9" }],
  ["path", { d: "M4 4v16", key: "6qkkli" }]
], wNe = y("Library", bNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kNe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.93 4.93 4.24 4.24", key: "1ymg45" }],
  ["path", { d: "m14.83 9.17 4.24-4.24", key: "1cb5xl" }],
  ["path", { d: "m14.83 14.83 4.24 4.24", key: "q42g0n" }],
  ["path", { d: "m9.17 14.83-4.24 4.24", key: "bqpfvv" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
], xNe = y("LifeBuoy", kNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MNe = [
  ["path", { d: "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2", key: "1rtphz" }],
  ["path", { d: "M6 12h4", key: "a4o3ry" }],
  ["path", { d: "M14 12h2v8", key: "c1fccl" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 20h4", key: "lzx1xo" }]
], CNe = y("Ligature", MNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ANe = [
  ["path", { d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5", key: "1fkcox" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5", key: "10m8kw" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
], SNe = y("LightbulbOff", ANe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LNe = [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
], TNe = y("Lightbulb", LNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ENe = [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7", key: "10o201" }],
  ["path", { d: "M15 7h2a5 5 0 0 1 4 8", key: "1d3206" }],
  ["line", { x1: "8", x2: "12", y1: "12", y2: "12", key: "rvw6j4" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], jNe = y("Link2Off", ENe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NNe = [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], DNe = y("Link2", NNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const INe = [
  ["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key: "1cjeqo" }],
  ["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key: "19qd67" }]
], PNe = y("Link", INe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zNe = [
  [
    "path",
    {
      d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
      key: "c2jq9f"
    }
  ],
  ["rect", { width: "4", height: "12", x: "2", y: "9", key: "mk3on5" }],
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }]
], RNe = y("Linkedin", zNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ONe = [
  ["path", { d: "M11 18H3", key: "n3j2dh" }],
  ["path", { d: "m15 18 2 2 4-4", key: "1szwhi" }],
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }]
], BNe = y("ListCheck", ONe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HNe = [
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "m3 7 2 2 4-4", key: "1obspn" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
], FNe = y("ListChecks", HNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Ne = [
  ["path", { d: "m3 10 2.5-2.5L3 5", key: "i6eama" }],
  ["path", { d: "m3 19 2.5-2.5L3 14", key: "w2gmor" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }]
], VNe = y("ListCollapse", _Ne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qNe = [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["path", { d: "M21 6v10a2 2 0 0 1-2 2h-5", key: "ilrcs8" }],
  ["path", { d: "m16 16-2 2 2 2", key: "kkc6pm" }]
], UNe = y("ListEnd", qNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WNe = [
  ["path", { d: "M10 18h4", key: "1ulq68" }],
  ["path", { d: "M11 6H3", key: "1u26ik" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "M18 9V3", key: "xwwp7m" }],
  ["path", { d: "M7 12h8", key: "7a1bxv" }]
], ZNe = y("ListFilterPlus", WNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GNe = [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
], YNe = y("ListFilter", GNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KNe = [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
], $Ne = y("ListMinus", KNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JNe = [
  ["path", { d: "M21 15V6", key: "h1cx4g" }],
  ["path", { d: "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", key: "8saifv" }],
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }]
], QNe = y("ListMusic", JNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XNe = [
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M4 10h2", key: "16xx2s" }],
  ["path", { d: "M4 6h1v4", key: "cnovpq" }],
  ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1", key: "m9a95d" }]
], eDe = y("ListOrdered", XNe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tDe = [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M18 9v6", key: "1twb98" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
], nDe = y("ListPlus", tDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rDe = [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M7 12H3", key: "13ou7f" }],
  ["path", { d: "M7 18H3", key: "1sijw9" }],
  [
    "path",
    {
      d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14",
      key: "qth677"
    }
  ],
  ["path", { d: "M11 10v4h4", key: "172dkj" }]
], iDe = y("ListRestart", rDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aDe = [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M10 6H3", key: "lf8lx7" }],
  ["path", { d: "M21 18V8a2 2 0 0 0-2-2h-5", key: "1hghli" }],
  ["path", { d: "m16 8-2-2 2-2", key: "160uvd" }]
], oDe = y("ListStart", aDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sDe = [
  ["rect", { x: "3", y: "5", width: "6", height: "6", rx: "1", key: "1defrl" }],
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
], lDe = y("ListTodo", sDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cDe = [
  ["path", { d: "M21 12h-8", key: "1bmf0i" }],
  ["path", { d: "M21 6H8", key: "1pqkrb" }],
  ["path", { d: "M21 18h-8", key: "1tm79t" }],
  ["path", { d: "M3 6v4c0 1.1.9 2 2 2h3", key: "1ywdgy" }],
  ["path", { d: "M3 10v6c0 1.1.9 2 2 2h3", key: "2wc746" }]
], uDe = y("ListTree", cDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dDe = [
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }],
  ["path", { d: "m16 12 5 3-5 3v-6Z", key: "zpskkp" }]
], fDe = y("ListVideo", dDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hDe = [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "m19 10-4 4", key: "1tz659" }],
  ["path", { d: "m15 10 4 4", key: "1n7nei" }]
], pDe = y("ListX", hDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mDe = [
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M3 18h.01", key: "1tta3j" }],
  ["path", { d: "M3 6h.01", key: "1rqtza" }],
  ["path", { d: "M8 12h13", key: "1za7za" }],
  ["path", { d: "M8 18h13", key: "1lx6n3" }],
  ["path", { d: "M8 6h13", key: "ik3vkj" }]
], yDe = y("List", mDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gDe = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], vDe = y("LoaderCircle", gDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bDe = [
  ["path", { d: "M22 12a1 1 0 0 1-10 0 1 1 0 0 0-10 0", key: "1lzz15" }],
  ["path", { d: "M7 20.7a1 1 0 1 1 5-8.7 1 1 0 1 0 5-8.6", key: "1gnrpi" }],
  ["path", { d: "M7 3.3a1 1 0 1 1 5 8.6 1 1 0 1 0 5 8.6", key: "u9yy5q" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], wDe = y("LoaderPinwheel", bDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kDe = [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
], xDe = y("Loader", kDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MDe = [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], CDe = y("LocateFixed", MDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ADe = [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  [
    "path",
    {
      d: "M7.11 7.11C5.83 8.39 5 10.1 5 12c0 3.87 3.13 7 7 7 1.9 0 3.61-.83 4.89-2.11",
      key: "1oh7ia"
    }
  ],
  [
    "path",
    {
      d: "M18.71 13.96c.19-.63.29-1.29.29-1.96 0-3.87-3.13-7-7-7-.67 0-1.33.1-1.96.29",
      key: "3qdecy"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], SDe = y("LocateOff", ADe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LDe = [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }]
], TDe = y("Locate", LDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EDe = [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5", key: "car5b7" }]
], jDe = y("LockKeyholeOpen", EDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NDe = [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { x: "3", y: "10", width: "18", height: "12", rx: "2", key: "6s8ecr" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 10 0v3", key: "1pqi11" }]
], DDe = y("LockKeyhole", NDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IDe = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
], PDe = y("LockOpen", IDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zDe = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
], RDe = y("Lock", zDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ODe = [
  ["path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4", key: "u53s6r" }],
  ["polyline", { points: "10 17 15 12 10 7", key: "1ail0h" }],
  ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }]
], BDe = y("LogIn", ODe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HDe = [
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }],
  ["polyline", { points: "16 17 21 12 16 7", key: "1gabdz" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }]
], FDe = y("LogOut", HDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _De = [
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M3 18h1", key: "1eiwyy" }],
  ["path", { d: "M3 6h1", key: "rgxa97" }],
  ["path", { d: "M8 12h1", key: "1con00" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  ["path", { d: "M8 6h1", key: "tn6mkg" }]
], VDe = y("Logs", _De);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qDe = [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0", key: "107gwy" }]
], UDe = y("Lollipop", qDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WDe = [
  [
    "path",
    { d: "M6 20a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1m57jg" }
  ],
  ["path", { d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14", key: "1l99gc" }],
  ["path", { d: "M10 20h4", key: "ni2waw" }],
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  ["circle", { cx: "8", cy: "20", r: "2", key: "ckkr5m" }]
], ZDe = y("Luggage", WDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GDe = [
  [
    "path",
    {
      d: "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15",
      key: "1i3lhw"
    }
  ],
  ["path", { d: "m5 8 4 4", key: "j6kj7e" }],
  ["path", { d: "m12 15 4 4", key: "lnac28" }]
], YDe = y("Magnet", GDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KDe = [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
], $De = y("MailCheck", KDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JDe = [
  ["path", { d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "fuxbkv" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
], QDe = y("MailMinus", JDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XDe = [
  [
    "path",
    {
      d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
      key: "1jhwl8"
    }
  ],
  ["path", { d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10", key: "1qfld7" }]
], eIe = y("MailOpen", XDe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tIe = [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
], nIe = y("MailPlus", tIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rIe = [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  [
    "path",
    {
      d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
      key: "7z9rxb"
    }
  ],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
], iIe = y("MailQuestion", rIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aIe = [
  ["path", { d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5", key: "w80f2v" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "8lzu5m" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }]
], oIe = y("MailSearch", aIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sIe = [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M20 14v4", key: "1hm744" }],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
], lIe = y("MailWarning", sIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cIe = [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9", key: "1j9vog" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m17 17 4 4", key: "1b3523" }],
  ["path", { d: "m21 17-4 4", key: "uinynz" }]
], uIe = y("MailX", cIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dIe = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
], fIe = y("Mail", dIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hIe = [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z",
      key: "1lbycx"
    }
  ],
  ["polyline", { points: "15,9 18,9 18,11", key: "1pm9c0" }],
  ["path", { d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2", key: "15i455" }],
  ["line", { x1: "6", x2: "7", y1: "10", y2: "10", key: "1e2scm" }]
], pIe = y("Mailbox", hIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mIe = [
  ["rect", { width: "16", height: "13", x: "6", y: "4", rx: "2", key: "1drq3f" }],
  ["path", { d: "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7", key: "xn252p" }],
  ["path", { d: "M2 8v11c0 1.1.9 2 2 2h14", key: "n13cji" }]
], yIe = y("Mails", mIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gIe = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
], vIe = y("MapPinCheckInside", gIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bIe = [
  [
    "path",
    {
      d: "M19.43 12.935c.357-.967.57-1.955.57-2.935a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32.197 32.197 0 0 0 .813-.728",
      key: "1dq61d"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "m16 18 2 2 4-4", key: "1mkfmb" }]
], wIe = y("MapPinCheck", bIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kIe = [
  [
    "path",
    {
      d: "M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z",
      key: "1p1rcz"
    }
  ],
  [
    "path",
    {
      d: "M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2",
      key: "mcbcs9"
    }
  ],
  ["path", { d: "M18 22v-3", key: "1t1ugv" }],
  ["circle", { cx: "10", cy: "10", r: "3", key: "1ns7v1" }]
], xIe = y("MapPinHouse", kIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MIe = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], CIe = y("MapPinMinusInside", MIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AIe = [
  [
    "path",
    {
      d: "M18.977 14C19.6 12.701 20 11.343 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
      key: "11uxia"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M16 18h6", key: "987eiv" }]
], SIe = y("MapPinMinus", AIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LIe = [
  ["path", { d: "M12.75 7.09a3 3 0 0 1 2.16 2.16", key: "1d4wjd" }],
  [
    "path",
    {
      d: "M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568",
      key: "12yil7"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533", key: "lhrkcz" }],
  ["path", { d: "M9.13 9.13a3 3 0 0 0 3.74 3.74", key: "13wojd" }]
], TIe = y("MapPinOff", LIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EIe = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], jIe = y("MapPinPlusInside", EIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NIe = [
  [
    "path",
    {
      d: "M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
      key: "fcdtly"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M16 18h6", key: "987eiv" }],
  ["path", { d: "M19 15v6", key: "10aioa" }]
], DIe = y("MapPinPlus", NIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IIe = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
], PIe = y("MapPinXInside", IIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zIe = [
  [
    "path",
    {
      d: "M19.752 11.901A7.78 7.78 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 19 19 0 0 0 .09-.077",
      key: "y0ewhp"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "m21.5 15.5-5 5", key: "11iqnx" }],
  ["path", { d: "m21.5 20.5-5-5", key: "1bylgx" }]
], RIe = y("MapPinX", zIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OIe = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
], BIe = y("MapPin", OIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HIe = [
  [
    "path",
    {
      d: "M18 8c0 3.613-3.869 7.429-5.393 8.795a1 1 0 0 1-1.214 0C9.87 15.429 6 11.613 6 8a6 6 0 0 1 12 0",
      key: "11u0oz"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  [
    "path",
    {
      d: "M8.714 14h-3.71a1 1 0 0 0-.948.683l-2.004 6A1 1 0 0 0 3 22h18a1 1 0 0 0 .948-1.316l-2-6a1 1 0 0 0-.949-.684h-3.712",
      key: "q8zwxj"
    }
  ]
], FIe = y("MapPinned", HIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Ie = [
  [
    "path",
    {
      d: "m11 19-1.106-.552a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V12",
      key: "svfegj"
    }
  ],
  ["path", { d: "M15 5.764V12", key: "1ocw4k" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }],
  ["path", { d: "M9 3.236v15", key: "1uimfh" }]
], VIe = y("MapPlus", _Ie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qIe = [
  [
    "path",
    {
      d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
      key: "169xi5"
    }
  ],
  ["path", { d: "M15 5.764v15", key: "1pn4in" }],
  ["path", { d: "M9 3.236v15", key: "1uimfh" }]
], UIe = y("Map", qIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WIe = [
  ["path", { d: "m14 6 4 4", key: "1q72g9" }],
  ["path", { d: "M17 3h4v4", key: "19p9u1" }],
  ["path", { d: "m21 3-7.75 7.75", key: "1cjbfd" }],
  ["circle", { cx: "9", cy: "15", r: "6", key: "bx5svt" }]
], ZIe = y("MarsStroke", WIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GIe = [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "m21 3-6.75 6.75", key: "pv0uzu" }],
  ["circle", { cx: "10", cy: "14", r: "6", key: "1qwbdc" }]
], YIe = y("Mars", GIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KIe = [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M12 11v11", key: "ur9y6a" }],
  ["path", { d: "m19 3-7 8-7-8Z", key: "1sgpiw" }]
], $Ie = y("Martini", KIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JIe = [
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
  ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
], QIe = y("Maximize2", JIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XIe = [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v3", key: "1dcmit" }],
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2h-3", key: "1e4gt3" }],
  ["path", { d: "M3 16v3a2 2 0 0 0 2 2h3", key: "wsl5sc" }],
  ["path", { d: "M16 21h3a2 2 0 0 0 2-2v-3", key: "18trek" }]
], ePe = y("Maximize", XIe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tPe = [
  [
    "path",
    {
      d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
      key: "143lza"
    }
  ],
  ["path", { d: "M11 12 5.12 2.2", key: "qhuxz6" }],
  ["path", { d: "m13 12 5.88-9.8", key: "hbye0f" }],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }],
  ["path", { d: "M12 18v-2h-.5", key: "fawc4q" }]
], nPe = y("Medal", tPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rPe = [
  ["path", { d: "M9.26 9.26 3 11v3l14.14 3.14", key: "3429n" }],
  ["path", { d: "M21 15.34V6l-7.31 2.03", key: "4o1dh8" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], iPe = y("MegaphoneOff", rPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aPe = [
  ["path", { d: "m3 11 18-5v12L3 14v-3z", key: "n962bs" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }]
], oPe = y("Megaphone", aPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sPe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "8", x2: "16", y1: "15", y2: "15", key: "1xb1d9" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], lPe = y("Meh", sPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cPe = [
  ["path", { d: "M6 19v-3", key: "1nvgqn" }],
  ["path", { d: "M10 19v-3", key: "iu8nkm" }],
  ["path", { d: "M14 19v-3", key: "kcehxu" }],
  ["path", { d: "M18 19v-3", key: "1vh91z" }],
  ["path", { d: "M8 11V9", key: "63erz4" }],
  ["path", { d: "M16 11V9", key: "fru6f3" }],
  ["path", { d: "M12 11V9", key: "ha00sb" }],
  ["path", { d: "M2 15h20", key: "16ne18" }],
  [
    "path",
    {
      d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z",
      key: "lhddv3"
    }
  ]
], uPe = y("MemoryStick", cPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dPe = [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
], fPe = y("Menu", dPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hPe = [
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22", key: "1hyw0i" }],
  ["path", { d: "m20 22-5-5", key: "1m27yz" }]
], pPe = y("Merge", hPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mPe = [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22z", key: "k85zhp" }]
], yPe = y("MessageCircleCode", mPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gPe = [
  ["path", { d: "M13.5 3.1c-.5 0-1-.1-1.5-.1s-1 .1-1.5.1", key: "16ll65" }],
  ["path", { d: "M19.3 6.8a10.45 10.45 0 0 0-2.1-2.1", key: "1nq77a" }],
  ["path", { d: "M20.9 13.5c.1-.5.1-1 .1-1.5s-.1-1-.1-1.5", key: "1sf7wn" }],
  ["path", { d: "M17.2 19.3a10.45 10.45 0 0 0 2.1-2.1", key: "x1hs5g" }],
  ["path", { d: "M10.5 20.9c.5.1 1 .1 1.5.1s1-.1 1.5-.1", key: "19m18z" }],
  ["path", { d: "M3.5 17.5 2 22l4.5-1.5", key: "1f36qi" }],
  ["path", { d: "M3.1 10.5c0 .5-.1 1-.1 1.5s.1 1 .1 1.5", key: "1vz3ju" }],
  ["path", { d: "M6.8 4.7a10.45 10.45 0 0 0-2.1 2.1", key: "19f9do" }]
], vPe = y("MessageCircleDashed", gPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bPe = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  [
    "path",
    {
      d: "M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7",
      key: "43lnbm"
    }
  ]
], wPe = y("MessageCircleHeart", bPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kPe = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
], xPe = y("MessageCircleMore", kPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MPe = [
  ["path", { d: "M20.5 14.9A9 9 0 0 0 9.1 3.5", key: "1iebmn" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.6 5.6C3 8.3 2.2 12.5 4 16l-2 6 6-2c3.4 1.8 7.6 1.1 10.3-1.7", key: "1ov8ce" }]
], CPe = y("MessageCircleOff", MPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const APe = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], SPe = y("MessageCirclePlus", APe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LPe = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], TPe = y("MessageCircleQuestion", LPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EPe = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }],
  ["path", { d: "M7 12h7a2 2 0 0 1 2 2v1", key: "1gheu4" }]
], jPe = y("MessageCircleReply", EPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NPe = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
], DPe = y("MessageCircleWarning", NPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IPe = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], PPe = y("MessageCircleX", IPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zPe = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }]
], RPe = y("MessageCircle", zPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OPe = [
  ["path", { d: "M10 7.5 8 10l2 2.5", key: "xb17xw" }],
  ["path", { d: "m14 7.5 2 2.5-2 2.5", key: "5rap1v" }],
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
], BPe = y("MessageSquareCode", OPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HPe = [
  ["path", { d: "M10 17H7l-4 4v-7", key: "1r71xu" }],
  ["path", { d: "M14 17h1", key: "nufu4t" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 14v1a2 2 0 0 1-2 2", key: "29akq3" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }]
], FPe = y("MessageSquareDashed", HPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Pe = [
  ["path", { d: "m5 19-2 2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1xuzuj" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
], VPe = y("MessageSquareDiff", _Pe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qPe = [
  ["path", { d: "M11.7 3H5a2 2 0 0 0-2 2v16l4-4h12a2 2 0 0 0 2-2v-2.7", key: "uodpkb" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
], UPe = y("MessageSquareDot", qPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WPe = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  [
    "path",
    {
      d: "M14.8 7.5a1.84 1.84 0 0 0-2.6 0l-.2.3-.3-.3a1.84 1.84 0 1 0-2.4 2.8L12 13l2.7-2.7c.9-.9.8-2.1.1-2.8",
      key: "1blaws"
    }
  ]
], ZPe = y("MessageSquareHeart", WPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GPe = [
  ["path", { d: "M19 15v-2a2 2 0 1 0-4 0v2", key: "h3d1vz" }],
  ["path", { d: "M9 17H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3.5", key: "xsnnhn" }],
  ["rect", { x: "13", y: "15", width: "8", height: "5", rx: "1", key: "1ccwuk" }]
], YPe = y("MessageSquareLock", GPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KPe = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }]
], $Pe = y("MessageSquareMore", KPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JPe = [
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M3.6 3.6c-.4.3-.6.8-.6 1.4v16l4-4h10", key: "pwpm4a" }]
], QPe = y("MessageSquareOff", JPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XPe = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], eze = y("MessageSquarePlus", XPe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tze = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 12a2 2 0 0 0 2-2V8H8", key: "1jfesj" }],
  ["path", { d: "M14 12a2 2 0 0 0 2-2V8h-2", key: "1dq9mh" }]
], nze = y("MessageSquareQuote", tze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rze = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m10 7-3 3 3 3", key: "1eugdv" }],
  ["path", { d: "M17 13v-1a2 2 0 0 0-2-2H7", key: "ernfh3" }]
], ize = y("MessageSquareReply", rze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aze = [
  ["path", { d: "M21 12v3a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h7", key: "tqtdkg" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "m16 8 5-5", key: "15mbrl" }]
], oze = y("MessageSquareShare", aze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sze = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M13 8H7", key: "14i4kc" }],
  ["path", { d: "M17 12H7", key: "16if0g" }]
], lze = y("MessageSquareText", sze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cze = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v2", key: "stiyo7" }],
  ["path", { d: "M12 13h.01", key: "y0uutt" }]
], uze = y("MessageSquareWarning", cze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dze = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
], fze = y("MessageSquareX", dze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hze = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
], pze = y("MessageSquare", hze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mze = [
  ["path", { d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z", key: "p1xzt8" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1", key: "1cx29u" }]
], yze = y("MessagesSquare", mze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gze = [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2", key: "80xlxr" }],
  ["path", { d: "M5 10v2a7 7 0 0 0 12 5", key: "p2k8kg" }],
  ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", key: "1gzdoj" }],
  ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12", key: "r2i35w" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
], vze = y("MicOff", gze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bze = [
  [
    "path",
    {
      d: "m11 7.601-5.994 8.19a1 1 0 0 0 .1 1.298l.817.818a1 1 0 0 0 1.314.087L15.09 12",
      key: "80a601"
    }
  ],
  [
    "path",
    {
      d: "M16.5 21.174C15.5 20.5 14.372 20 13 20c-2.058 0-3.928 2.356-6 2-2.072-.356-2.775-3.369-1.5-4.5",
      key: "j0ngtp"
    }
  ],
  ["circle", { cx: "16", cy: "7", r: "5", key: "d08jfb" }]
], wze = y("MicVocal", bze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kze = [
  ["path", { d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z", key: "131961" }],
  ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
], xze = y("Mic", kze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mze = [
  ["path", { d: "M18 12h2", key: "quuxs7" }],
  ["path", { d: "M18 16h2", key: "zsn3lv" }],
  ["path", { d: "M18 20h2", key: "9x5y9y" }],
  ["path", { d: "M18 4h2", key: "1luxfb" }],
  ["path", { d: "M18 8h2", key: "nxqzg" }],
  ["path", { d: "M4 12h2", key: "1ltxp0" }],
  ["path", { d: "M4 16h2", key: "8a5zha" }],
  ["path", { d: "M4 20h2", key: "27dk57" }],
  ["path", { d: "M4 4h2", key: "10groj" }],
  ["path", { d: "M4 8h2", key: "18vq6w" }],
  [
    "path",
    {
      d: "M8 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1.5c-.276 0-.494.227-.562.495a2 2 0 0 1-3.876 0C9.994 2.227 9.776 2 9.5 2z",
      key: "1681fp"
    }
  ]
], Cze = y("Microchip", Mze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aze = [
  ["path", { d: "M6 18h8", key: "1borvv" }],
  ["path", { d: "M3 22h18", key: "8prr45" }],
  ["path", { d: "M14 22a7 7 0 1 0 0-14h-1", key: "1jwaiy" }],
  ["path", { d: "M9 14h2", key: "197e7h" }],
  ["path", { d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z", key: "1bmzmy" }],
  ["path", { d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3", key: "1drr47" }]
], Sze = y("Microscope", Aze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lze = [
  ["rect", { width: "20", height: "15", x: "2", y: "4", rx: "2", key: "2no95f" }],
  ["rect", { width: "8", height: "7", x: "6", y: "8", rx: "1", key: "zh9wx" }],
  ["path", { d: "M18 8v7", key: "o5zi4n" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 19v2", key: "1dawf0" }]
], Tze = y("Microwave", Lze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eze = [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  [
    "path",
    {
      d: "M4 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h13a2 2 0 0 0 1.152-.365l3.424-2.317a1 1 0 0 0 0-1.635l-3.424-2.318A2 2 0 0 0 17 6z",
      key: "1btarq"
    }
  ]
], jze = y("Milestone", Eze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nze = [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3",
      key: "y0ejgx"
    }
  ],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435", key: "iaxqsy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], Dze = y("MilkOff", Nze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ize = [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2",
      key: "qtp12x"
    }
  ],
  ["path", { d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "ygeh44" }]
], Pze = y("Milk", Ize);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zze = [
  ["polyline", { points: "4 14 10 14 10 20", key: "11kfnr" }],
  ["polyline", { points: "20 10 14 10 14 4", key: "rlmsce" }],
  ["line", { x1: "14", x2: "21", y1: "10", y2: "3", key: "o5lafz" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
], Rze = y("Minimize2", zze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oze = [
  ["path", { d: "M8 3v3a2 2 0 0 1-2 2H3", key: "hohbtr" }],
  ["path", { d: "M21 8h-3a2 2 0 0 1-2-2V3", key: "5jw1f3" }],
  ["path", { d: "M3 16h3a2 2 0 0 1 2 2v3", key: "198tvr" }],
  ["path", { d: "M16 21v-3a2 2 0 0 1 2-2h3", key: "ph8mxp" }]
], Bze = y("Minimize", Oze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hze = [["path", { d: "M5 12h14", key: "1ays0h" }]], Fze = y("Minus", Hze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ze = [
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], Vze = y("MonitorCheck", _ze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qze = [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m15.2 4.9-.9-.4", key: "12wd2u" }],
  ["path", { d: "m15.2 7.1-.9.4", key: "1r2vl7" }],
  ["path", { d: "m16.9 3.2-.4-.9", key: "3zbo91" }],
  ["path", { d: "m16.9 8.8-.4.9", key: "1qr2dn" }],
  ["path", { d: "m19.5 2.3-.4.9", key: "1rjrkq" }],
  ["path", { d: "m19.5 9.7-.4-.9", key: "heryx5" }],
  ["path", { d: "m21.7 4.5-.9.4", key: "17fqt1" }],
  ["path", { d: "m21.7 7.5-.9-.4", key: "14zyni" }],
  ["path", { d: "M22 13v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "1tnzv8" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
], Uze = y("MonitorCog", qze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wze = [
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M22 12v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9", key: "1fet9y" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], Zze = y("MonitorDot", Wze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gze = [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m15 10-3 3-3-3", key: "lzhmyn" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], Yze = y("MonitorDown", Gze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kze = [
  ["path", { d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2", key: "k0q8oc" }],
  ["path", { d: "M22 15V5a2 2 0 0 0-2-2H9", key: "cp1ac0" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], $ze = y("MonitorOff", Kze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jze = [
  ["path", { d: "M10 13V7", key: "1u13u9" }],
  ["path", { d: "M14 13V7", key: "1vj9om" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], Qze = y("MonitorPause", Jze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xze = [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }]
], eRe = y("MonitorPlay", Xze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tRe = [
  ["path", { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8", key: "10dyio" }],
  ["path", { d: "M10 19v-3.96 3.15", key: "1irgej" }],
  ["path", { d: "M7 19h5", key: "qswx4l" }],
  ["rect", { width: "6", height: "10", x: "16", y: "12", rx: "2", key: "1egngj" }]
], nRe = y("MonitorSmartphone", tRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rRe = [
  ["path", { d: "M5.5 20H8", key: "1k40s5" }],
  ["path", { d: "M17 9h.01", key: "1j24nn" }],
  ["rect", { width: "10", height: "16", x: "12", y: "4", rx: "2", key: "ixliua" }],
  ["path", { d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4", key: "1mp6e1" }],
  ["circle", { cx: "17", cy: "15", r: "1", key: "tqvash" }]
], iRe = y("MonitorSpeaker", rRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aRe = [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }],
  ["rect", { x: "9", y: "7", width: "6", height: "6", rx: "1", key: "5m2oou" }]
], oRe = y("MonitorStop", aRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sRe = [
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], lRe = y("MonitorUp", sRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cRe = [
  ["path", { d: "m14.5 12.5-5-5", key: "1jahn5" }],
  ["path", { d: "m9.5 12.5 5-5", key: "1k2t7b" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], uRe = y("MonitorX", cRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dRe = [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
], fRe = y("Monitor", dRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hRe = [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9", key: "4ay0iu" }],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }]
], pRe = y("MoonStar", hRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mRe = [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
], yRe = y("Moon", mRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gRe = [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }],
  [
    "path",
    { d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19", key: "1pvmmp" }
  ]
], vRe = y("MountainSnow", gRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bRe = [["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]], wRe = y("Mountain", bRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kRe = [
  ["path", { d: "M12 6v.343", key: "1gyhex" }],
  ["path", { d: "M18.218 18.218A7 7 0 0 1 5 15V9a7 7 0 0 1 .782-3.218", key: "ukzz01" }],
  ["path", { d: "M19 13.343V9A7 7 0 0 0 8.56 2.902", key: "104jy9" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
], xRe = y("MouseOff", kRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MRe = [
  [
    "path",
    {
      d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
      key: "edeuup"
    }
  ]
], CRe = y("MousePointer2", MRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ARe = [
  [
    "path",
    {
      d: "M2.034 2.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.944L8.204 7.545a1 1 0 0 0-.66.66l-1.066 3.443a.5.5 0 0 1-.944.033z",
      key: "11pp1i"
    }
  ],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  ["path", { d: "m11.8 11.8 8.4 8.4", key: "oogvdj" }]
], SRe = y("MousePointerBan", ARe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LRe = [
  ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
  ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
  ["path", { d: "m6 12-1.9 2", key: "mnht97" }],
  ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
  [
    "path",
    {
      d: "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z",
      key: "s0h3yz"
    }
  ]
], TRe = y("MousePointerClick", LRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ERe = [
  ["path", { d: "M12.586 12.586 19 19", key: "ea5xo7" }],
  [
    "path",
    {
      d: "M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z",
      key: "277e5u"
    }
  ]
], jRe = y("MousePointer", ERe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NRe = [
  ["rect", { x: "5", y: "2", width: "14", height: "20", rx: "7", key: "11ol66" }],
  ["path", { d: "M12 6v4", key: "16clxf" }]
], DRe = y("Mouse", NRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IRe = [
  ["path", { d: "M5 3v16h16", key: "1mqmf9" }],
  ["path", { d: "m5 19 6-6", key: "jh6hbb" }],
  ["path", { d: "m2 6 3-3 3 3", key: "tkyvxa" }],
  ["path", { d: "m18 16 3 3-3 3", key: "1d4glt" }]
], PRe = y("Move3d", IRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zRe = [
  ["path", { d: "M19 13v6h-6", key: "1hxl6d" }],
  ["path", { d: "M5 11V5h6", key: "12e2xe" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }]
], RRe = y("MoveDiagonal2", zRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ORe = [
  ["path", { d: "M11 19H5v-6", key: "8awifj" }],
  ["path", { d: "M13 5h6v6", key: "7voy1q" }],
  ["path", { d: "M19 5 5 19", key: "wwaj1z" }]
], BRe = y("MoveDiagonal", ORe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HRe = [
  ["path", { d: "M11 19H5V13", key: "1akmht" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
], FRe = y("MoveDownLeft", HRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Re = [
  ["path", { d: "M19 13V19H13", key: "10vkzq" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
], VRe = y("MoveDownRight", _Re);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qRe = [
  ["path", { d: "M8 18L12 22L16 18", key: "cskvfv" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
], URe = y("MoveDown", qRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WRe = [
  ["path", { d: "m18 8 4 4-4 4", key: "1ak13k" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }]
], ZRe = y("MoveHorizontal", WRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GRe = [
  ["path", { d: "M6 8L2 12L6 16", key: "kyvwex" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
], YRe = y("MoveLeft", GRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KRe = [
  ["path", { d: "M18 8L22 12L18 16", key: "1r0oui" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
], $Re = y("MoveRight", KRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JRe = [
  ["path", { d: "M5 11V5H11", key: "3q78g9" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
], QRe = y("MoveUpLeft", JRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XRe = [
  ["path", { d: "M13 5H19V11", key: "1n1gyv" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
], eOe = y("MoveUpRight", XRe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tOe = [
  ["path", { d: "M8 6L12 2L16 6", key: "1yvkyx" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
], nOe = y("MoveUp", tOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rOe = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m8 18 4 4 4-4", key: "bh5tu3" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }]
], iOe = y("MoveVertical", rOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aOe = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m19 9 3 3-3 3", key: "1mg7y2" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
], oOe = y("Move", aOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sOe = [
  ["circle", { cx: "8", cy: "18", r: "4", key: "1fc0mg" }],
  ["path", { d: "M12 18V2l7 4", key: "g04rme" }]
], lOe = y("Music2", sOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cOe = [
  ["circle", { cx: "12", cy: "18", r: "4", key: "m3r9ws" }],
  ["path", { d: "M16 18V2", key: "40x2m5" }]
], uOe = y("Music3", cOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dOe = [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["path", { d: "m9 9 12-2", key: "1e64n2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
], fOe = y("Music4", dOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hOe = [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
], pOe = y("Music", hOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mOe = [
  ["path", { d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17", key: "qoq2o2" }],
  ["path", { d: "M14.53 8.88 12 2l-1.17 3.17", key: "k3sjzy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], yOe = y("Navigation2Off", mOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gOe = [
  ["polygon", { points: "12 2 19 21 12 17 5 21 12 2", key: "x8c0qg" }]
], vOe = y("Navigation2", gOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bOe = [
  ["path", { d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43", key: "1vdtb7" }],
  ["path", { d: "M17.39 11.73 22 2l-9.73 4.61", key: "tya3r6" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], wOe = y("NavigationOff", bOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kOe = [
  ["polygon", { points: "3 11 22 2 13 21 11 13 3 11", key: "1ltx0t" }]
], xOe = y("Navigation", kOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MOe = [
  ["rect", { x: "16", y: "16", width: "6", height: "6", rx: "1", key: "4q2zg0" }],
  ["rect", { x: "2", y: "16", width: "6", height: "6", rx: "1", key: "8cvhb9" }],
  ["rect", { x: "9", y: "2", width: "6", height: "6", rx: "1", key: "1egb70" }],
  ["path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3", key: "1jsf9p" }],
  ["path", { d: "M12 12V8", key: "2874zd" }]
], COe = y("Network", MOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AOe = [
  [
    "path",
    {
      d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2",
      key: "7pis2x"
    }
  ],
  ["path", { d: "M18 14h-8", key: "sponae" }],
  ["path", { d: "M15 18h-5", key: "95g1m2" }],
  ["path", { d: "M10 6h8v4h-8V6Z", key: "smlsk5" }]
], SOe = y("Newspaper", AOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LOe = [
  ["path", { d: "M6 8.32a7.43 7.43 0 0 1 0 7.36", key: "9iaqei" }],
  ["path", { d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "1yha7l" }],
  ["path", { d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "4iu2gk" }],
  ["path", { d: "M16.37 2a20.16 20.16 0 0 1 0 20", key: "sap9u2" }]
], TOe = y("Nfc", LOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EOe = [
  ["path", { d: "M12 2v10", key: "mnfbl" }],
  ["path", { d: "m9 4 6 4", key: "t8piew" }],
  ["path", { d: "m9 8 6-4", key: "sndyih" }],
  ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }]
], jOe = y("NonBinary", EOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NOe = [
  ["path", { d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4", key: "re6nr2" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  [
    "path",
    {
      d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "pqwjuv"
    }
  ]
], DOe = y("NotebookPen", NOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IOe = [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M15 2v20", key: "dcj49h" }],
  ["path", { d: "M15 7h5", key: "1xj5lc" }],
  ["path", { d: "M15 12h5", key: "w5shd9" }],
  ["path", { d: "M15 17h5", key: "1qaofu" }]
], POe = y("NotebookTabs", IOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zOe = [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M9.5 8h5", key: "11mslq" }],
  ["path", { d: "M9.5 12H16", key: "ktog6x" }],
  ["path", { d: "M9.5 16H14", key: "p1seyn" }]
], ROe = y("NotebookText", zOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OOe = [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M16 2v20", key: "rotuqe" }]
], BOe = y("Notebook", OOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HOe = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v2", key: "j91f56" }],
  ["path", { d: "M20 12v2", key: "w8o0tu" }],
  ["path", { d: "M20 18v2a2 2 0 0 1-2 2h-1", key: "1c9ggx" }],
  ["path", { d: "M13 22h-2", key: "191ugt" }],
  ["path", { d: "M7 22H6a2 2 0 0 1-2-2v-2", key: "1rt9px" }],
  ["path", { d: "M4 14v-2", key: "1v0sqh" }],
  ["path", { d: "M4 8V6a2 2 0 0 1 2-2h2", key: "1mwabg" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
], FOe = y("NotepadTextDashed", HOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Oe = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "16", height: "18", x: "4", y: "4", rx: "2", key: "1u9h20" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
], VOe = y("NotepadText", _Oe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qOe = [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939",
      key: "1xcvy9"
    }
  ],
  ["path", { d: "M19 10v3.343", key: "163tfc" }],
  [
    "path",
    {
      d: "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192",
      key: "17914v"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], UOe = y("NutOff", qOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WOe = [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4",
      key: "1tgyif"
    }
  ],
  [
    "path",
    {
      d: "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z",
      key: "tnsqj"
    }
  ]
], ZOe = y("Nut", WOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GOe = [
  ["path", { d: "M12 16h.01", key: "1drbdi" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  [
    "path",
    {
      d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
      key: "1fd625"
    }
  ]
], YOe = y("OctagonAlert", GOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KOe = [
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], $Oe = y("OctagonMinus", KOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JOe = [
  ["path", { d: "M10 15V9", key: "1lckn7" }],
  ["path", { d: "M14 15V9", key: "1muqhk" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ]
], QOe = y("OctagonPause", JOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XOe = [
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], eBe = y("OctagonX", XOe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tBe = [
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ]
], nBe = y("Octagon", tBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rBe = [
  [
    "path",
    {
      d: "M3 20h4.5a.5.5 0 0 0 .5-.5v-.282a.52.52 0 0 0-.247-.437 8 8 0 1 1 8.494-.001.52.52 0 0 0-.247.438v.282a.5.5 0 0 0 .5.5H21",
      key: "1x94xo"
    }
  ]
], iBe = y("Omega", rBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aBe = [
  ["path", { d: "M3 3h6l6 18h6", key: "ph9rgk" }],
  ["path", { d: "M14 3h7", key: "16f0ms" }]
], oBe = y("Option", aBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sBe = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M10.4 21.9a10 10 0 0 0 9.941-15.416", key: "eohfx2" }],
  ["path", { d: "M13.5 2.1a10 10 0 0 0-9.841 15.416", key: "19pvbm" }]
], lBe = y("Orbit", sBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cBe = [
  ["path", { d: "M12 12V4a1 1 0 0 1 1-1h6.297a1 1 0 0 1 .651 1.759l-4.696 4.025", key: "1bx4vc" }],
  [
    "path",
    {
      d: "m12 21-7.414-7.414A2 2 0 0 1 4 12.172V6.415a1.002 1.002 0 0 1 1.707-.707L20 20.009",
      key: "1h3km6"
    }
  ],
  [
    "path",
    {
      d: "m12.214 3.381 8.414 14.966a1 1 0 0 1-.167 1.199l-1.168 1.163a1 1 0 0 1-.706.291H6.351a1 1 0 0 1-.625-.219L3.25 18.8a1 1 0 0 1 .631-1.781l4.165.027",
      key: "1hj4wg"
    }
  ]
], uBe = y("Origami", cBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dBe = [
  ["path", { d: "M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z", key: "1ront0" }],
  ["path", { d: "m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9", key: "19h2x1" }],
  ["path", { d: "M12 3v6", key: "1holv5" }]
], fBe = y("Package2", dBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hBe = [
  ["path", { d: "m16 16 2 2 4-4", key: "gfu2re" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
], pBe = y("PackageCheck", hBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mBe = [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
], yBe = y("PackageMinus", mBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gBe = [
  ["path", { d: "M12 22v-9", key: "x3hkom" }],
  [
    "path",
    {
      d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z",
      key: "2ntwy6"
    }
  ],
  [
    "path",
    {
      d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13",
      key: "1pmm1c"
    }
  ],
  [
    "path",
    {
      d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z",
      key: "12ttoo"
    }
  ]
], vBe = y("PackageOpen", gBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bBe = [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  ["path", { d: "M19 13v6", key: "85cyf1" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
], wBe = y("PackagePlus", bBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kBe = [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["circle", { cx: "18.5", cy: "15.5", r: "2.5", key: "b5zd12" }],
  ["path", { d: "M20.27 17.27 22 19", key: "1l4muz" }]
], xBe = y("PackageSearch", kBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MBe = [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["path", { d: "m17 13 5 5m-5 0 5-5", key: "im3w4b" }]
], CBe = y("PackageX", MBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ABe = [
  [
    "path",
    {
      d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
      key: "1a0edw"
    }
  ],
  ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }]
], SBe = y("Package", ABe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LBe = [
  [
    "path",
    { d: "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z", key: "irua1i" }
  ],
  ["path", { d: "m5 2 5 5", key: "1lls2c" }],
  ["path", { d: "M2 13h15", key: "1hkzvu" }],
  ["path", { d: "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z", key: "xk76lq" }]
], TBe = y("PaintBucket", LBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EBe = [
  ["rect", { width: "16", height: "6", x: "2", y: "2", rx: "2", key: "jcyz7m" }],
  ["path", { d: "M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1b9h7c" }],
  ["rect", { width: "4", height: "6", x: "8", y: "16", rx: "1", key: "d6e7yl" }]
], jBe = y("PaintRoller", EBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NBe = [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v4", key: "qmzblu" }],
  ["path", { d: "M17 2a1 1 0 0 1 1 1v9H6V3a1 1 0 0 1 1-1z", key: "ycvu00" }],
  [
    "path",
    {
      d: "M6 12a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h2a1 1 0 0 1 1 1v2.9a2 2 0 1 0 4 0V17a1 1 0 0 1 1-1h2a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1",
      key: "iw4wnp"
    }
  ]
], DBe = y("PaintbrushVertical", NBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IBe = [
  ["path", { d: "m14.622 17.897-10.68-2.913", key: "vj2p1u" }],
  [
    "path",
    {
      d: "M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z",
      key: "18tc5c"
    }
  ],
  [
    "path",
    {
      d: "M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15",
      key: "ytzfxy"
    }
  ]
], PBe = y("Paintbrush", IBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zBe = [
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  [
    "path",
    {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
      key: "12rzf8"
    }
  ]
], RBe = y("Palette", zBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OBe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m15 8-3 3-3-3", key: "1oxy1z" }]
], BBe = y("PanelBottomClose", OBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HBe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 15h1", key: "171nev" }],
  ["path", { d: "M19 15h2", key: "1vnucp" }],
  ["path", { d: "M3 15h2", key: "8bym0q" }],
  ["path", { d: "M9 15h1", key: "1tg3ks" }]
], FBe = y("PanelBottomDashed", HBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Be = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
], VBe = y("PanelBottomOpen", _Be);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qBe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
], UBe = y("PanelBottom", qBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WBe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
], ZBe = y("PanelLeftClose", WBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GBe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 14v1", key: "askpd8" }],
  ["path", { d: "M9 19v2", key: "16tejx" }],
  ["path", { d: "M9 3v2", key: "1noubl" }],
  ["path", { d: "M9 9v1", key: "19ebxg" }]
], YBe = y("PanelLeftDashed", GBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KBe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m14 9 3 3-3 3", key: "8010ee" }]
], $Be = y("PanelLeftOpen", KBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JBe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
], QBe = y("PanelLeft", JBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XBe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }]
], eHe = y("PanelRightClose", XBe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tHe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 14v1", key: "ilsfch" }],
  ["path", { d: "M15 19v2", key: "1fst2f" }],
  ["path", { d: "M15 3v2", key: "z204g4" }],
  ["path", { d: "M15 9v1", key: "z2a8b1" }]
], nHe = y("PanelRightDashed", tHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rHe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }]
], iHe = y("PanelRightOpen", rHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aHe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], oHe = y("PanelRight", aHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sHe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m9 16 3-3 3 3", key: "1idcnm" }]
], lHe = y("PanelTopClose", sHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cHe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 9h1", key: "l0svgy" }],
  ["path", { d: "M19 9h2", key: "te2zfg" }],
  ["path", { d: "M3 9h2", key: "1h4ldw" }],
  ["path", { d: "M9 9h1", key: "15jzuz" }]
], uHe = y("PanelTopDashed", cHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dHe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m15 14-3 3-3-3", key: "g215vf" }]
], fHe = y("PanelTopOpen", dHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hHe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }]
], pHe = y("PanelTop", hHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mHe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M9 15h12", key: "5ijen5" }]
], yHe = y("PanelsLeftBottom", mHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gHe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h12", key: "1wkqb3" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], vHe = y("PanelsRightBottom", gHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bHe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M9 21V9", key: "1oto5p" }]
], wHe = y("PanelsTopLeft", bHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kHe = [
  ["path", { d: "M13.234 20.252 21 12.3", key: "1cbrk9" }],
  [
    "path",
    {
      d: "m16 6-8.414 8.586a2 2 0 0 0 0 2.828 2 2 0 0 0 2.828 0l8.414-8.586a4 4 0 0 0 0-5.656 4 4 0 0 0-5.656 0l-8.415 8.585a6 6 0 1 0 8.486 8.486",
      key: "1pkts6"
    }
  ]
], xHe = y("Paperclip", kHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MHe = [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }]
], CHe = y("Parentheses", MHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AHe = [
  ["path", { d: "M11 15h2", key: "199qp6" }],
  ["path", { d: "M12 12v3", key: "158kv8" }],
  ["path", { d: "M12 19v3", key: "npa21l" }],
  [
    "path",
    {
      d: "M15.282 19a1 1 0 0 0 .948-.68l2.37-6.988a7 7 0 1 0-13.2 0l2.37 6.988a1 1 0 0 0 .948.68z",
      key: "1jofit"
    }
  ],
  ["path", { d: "M9 9a3 3 0 1 1 6 0", key: "jdoeu8" }]
], SHe = y("ParkingMeter", AHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LHe = [
  ["path", { d: "M5.8 11.3 2 22l10.7-3.79", key: "gwxi1d" }],
  ["path", { d: "M4 3h.01", key: "1vcuye" }],
  ["path", { d: "M22 8h.01", key: "1mrtc2" }],
  ["path", { d: "M15 2h.01", key: "1cjtqr" }],
  ["path", { d: "M22 20h.01", key: "1mrys2" }],
  [
    "path",
    {
      d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10",
      key: "hbicv8"
    }
  ],
  [
    "path",
    { d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17", key: "1i94pl" }
  ],
  ["path", { d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7", key: "1cofks" }],
  [
    "path",
    {
      d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z",
      key: "4kbmks"
    }
  ]
], THe = y("PartyPopper", LHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EHe = [
  ["rect", { x: "14", y: "4", width: "4", height: "16", rx: "1", key: "zuxfzm" }],
  ["rect", { x: "6", y: "4", width: "4", height: "16", rx: "1", key: "1okwgv" }]
], jHe = y("Pause", EHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NHe = [
  ["circle", { cx: "11", cy: "4", r: "2", key: "vol9p0" }],
  ["circle", { cx: "18", cy: "8", r: "2", key: "17gozi" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }],
  [
    "path",
    {
      d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z",
      key: "1ydw1z"
    }
  ]
], DHe = y("PawPrint", NHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IHe = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", key: "1uq1d7" }],
  ["path", { d: "M15 14h.01", key: "1kp3bh" }],
  ["path", { d: "M9 6h6", key: "dgm16u" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], PHe = y("PcCase", IHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zHe = [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ]
], RHe = y("PenLine", zHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OHe = [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], BHe = y("PenOff", OHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HHe = [
  [
    "path",
    {
      d: "M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z",
      key: "nt11vn"
    }
  ],
  [
    "path",
    {
      d: "m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18",
      key: "15qc1e"
    }
  ],
  ["path", { d: "m2.3 2.3 7.286 7.286", key: "1wuzzi" }],
  ["circle", { cx: "11", cy: "11", r: "2", key: "xmgehs" }]
], FHe = y("PenTool", HHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _He = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ]
], VHe = y("Pen", _He);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qHe = [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ],
  ["path", { d: "m15 5 3 3", key: "1w25hb" }]
], UHe = y("PencilLine", qHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WHe = [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], ZHe = y("PencilOff", WHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GHe = [
  [
    "path",
    { d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13", key: "orapub" }
  ],
  ["path", { d: "m8 6 2-2", key: "115y1s" }],
  ["path", { d: "m18 16 2-2", key: "ee94s4" }],
  [
    "path",
    {
      d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17",
      key: "cfq27r"
    }
  ],
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], YHe = y("PencilRuler", GHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KHe = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], $He = y("Pencil", KHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JHe = [
  [
    "path",
    {
      d: "M10.83 2.38a2 2 0 0 1 2.34 0l8 5.74a2 2 0 0 1 .73 2.25l-3.04 9.26a2 2 0 0 1-1.9 1.37H7.04a2 2 0 0 1-1.9-1.37L2.1 10.37a2 2 0 0 1 .73-2.25z",
      key: "2hea0t"
    }
  ]
], QHe = y("Pentagon", JHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XHe = [
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }],
  ["circle", { cx: "6.5", cy: "6.5", r: "2.5", key: "4mh3h7" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "2.5", key: "1mdrzq" }]
], eFe = y("Percent", XHe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tFe = [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["path", { d: "m9 20 3-6 3 6", key: "se2kox" }],
  ["path", { d: "m6 8 6 2 6-2", key: "4o3us4" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }]
], nFe = y("PersonStanding", tFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rFe = [
  ["path", { d: "M20 11H4", key: "6ut86h" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "M7 21V4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 12H7", key: "1ana5r" }]
], iFe = y("PhilippinePeso", rFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aFe = [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ],
  ["path", { d: "M14.05 2a9 9 0 0 1 8 7.94", key: "vmijpz" }],
  ["path", { d: "M14.05 6A5 5 0 0 1 18 10", key: "13nbpp" }]
], oFe = y("PhoneCall", aFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sFe = [
  ["polyline", { points: "18 2 22 6 18 10", key: "6vjanh" }],
  ["line", { x1: "14", x2: "22", y1: "6", y2: "6", key: "1jsywh" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], lFe = y("PhoneForwarded", sFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cFe = [
  ["polyline", { points: "16 2 16 8 22 8", key: "1ygljm" }],
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], uFe = y("PhoneIncoming", cFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dFe = [
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  ["line", { x1: "16", x2: "22", y1: "2", y2: "8", key: "13zxdn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], fFe = y("PhoneMissed", dFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hFe = [
  [
    "path",
    {
      d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91",
      key: "z86iuo"
    }
  ],
  ["line", { x1: "22", x2: "2", y1: "2", y2: "22", key: "11kh81" }]
], pFe = y("PhoneOff", hFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mFe = [
  ["polyline", { points: "22 8 22 2 16 2", key: "1g204g" }],
  ["line", { x1: "16", x2: "22", y1: "8", y2: "2", key: "1ggias" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], yFe = y("PhoneOutgoing", mFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gFe = [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], vFe = y("Phone", gFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bFe = [
  ["line", { x1: "9", x2: "9", y1: "4", y2: "20", key: "ovs5a5" }],
  ["path", { d: "M4 7c0-1.7 1.3-3 3-3h13", key: "10pag4" }],
  ["path", { d: "M18 20c-1.7 0-3-1.3-3-3V4", key: "1gaosr" }]
], wFe = y("Pi", bFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kFe = [
  [
    "path",
    {
      d: "M18.5 8c-1.4 0-2.6-.8-3.2-2A6.87 6.87 0 0 0 2 9v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8.5C22 9.6 20.4 8 18.5 8",
      key: "lag0yf"
    }
  ],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M6 14v4", key: "9ng0ue" }],
  ["path", { d: "M10 14v4", key: "1v8uk5" }],
  ["path", { d: "M14 14v4", key: "1tqops" }],
  ["path", { d: "M18 14v4", key: "18uqwm" }]
], xFe = y("Piano", kFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MFe = [
  ["path", { d: "M14.531 12.469 6.619 20.38a1 1 0 1 1-3-3l7.912-7.912", key: "we99rg" }],
  [
    "path",
    {
      d: "M15.686 4.314A12.5 12.5 0 0 0 5.461 2.958 1 1 0 0 0 5.58 4.71a22 22 0 0 1 6.318 3.393",
      key: "1w6hck"
    }
  ],
  [
    "path",
    {
      d: "M17.7 3.7a1 1 0 0 0-1.4 0l-4.6 4.6a1 1 0 0 0 0 1.4l2.6 2.6a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4z",
      key: "15hgfx"
    }
  ],
  [
    "path",
    {
      d: "M19.686 8.314a12.501 12.501 0 0 1 1.356 10.225 1 1 0 0 1-1.751-.119 22 22 0 0 0-3.393-6.319",
      key: "452b4h"
    }
  ]
], CFe = y("Pickaxe", MFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AFe = [
  ["path", { d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4", key: "daa4of" }],
  ["rect", { width: "10", height: "7", x: "12", y: "13", rx: "2", key: "1nb8gs" }]
], SFe = y("PictureInPicture2", AFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LFe = [
  ["path", { d: "M2 10h6V4", key: "zwrco" }],
  ["path", { d: "m2 4 6 6", key: "ug085t" }],
  ["path", { d: "M21 10V7a2 2 0 0 0-2-2h-7", key: "git5jr" }],
  ["path", { d: "M3 14v2a2 2 0 0 0 2 2h3", key: "1f7fh3" }],
  ["rect", { x: "12", y: "14", width: "10", height: "7", rx: "1", key: "1wjs3o" }]
], TFe = y("PictureInPicture", LFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EFe = [
  [
    "path",
    {
      d: "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2V5z",
      key: "1ivx2i"
    }
  ],
  ["path", { d: "M2 9v1c0 1.1.9 2 2 2h1", key: "nm575m" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }]
], jFe = y("PiggyBank", EFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NFe = [
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "M14 9h-3a3 3 0 0 1 0-6h9", key: "1ulc19" }],
  ["path", { d: "M18 3v11", key: "1phi0r" }],
  ["path", { d: "M22 18H2l4-4", key: "yt65j9" }],
  ["path", { d: "m6 22-4-4", key: "6jgyf5" }]
], DFe = y("PilcrowLeft", NFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IFe = [
  ["path", { d: "M10 3v11", key: "o3l5kj" }],
  ["path", { d: "M10 9H7a1 1 0 0 1 0-6h8", key: "1wb1nc" }],
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "m18 14 4 4H2", key: "4r8io1" }],
  ["path", { d: "m22 18-4 4", key: "1hjjrd" }]
], PFe = y("PilcrowRight", IFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zFe = [
  ["path", { d: "M13 4v16", key: "8vvj80" }],
  ["path", { d: "M17 4v16", key: "7dpous" }],
  ["path", { d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13", key: "sh4n9v" }]
], RFe = y("Pilcrow", zFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OFe = [
  ["path", { d: "M18 11h-4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4", key: "17ldeb" }],
  ["path", { d: "M6 7v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7", key: "nc37y6" }],
  ["rect", { width: "16", height: "5", x: "4", y: "2", rx: "1", key: "3jeezo" }]
], BFe = y("PillBottle", OFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HFe = [
  [
    "path",
    { d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z", key: "wa1lgi" }
  ],
  ["path", { d: "m8.5 8.5 7 7", key: "rvfmvr" }]
], FFe = y("Pill", HFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Fe = [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89", key: "znwnzq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11",
      key: "c9qhm2"
    }
  ]
], VFe = y("PinOff", _Fe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qFe = [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  [
    "path",
    {
      d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
      key: "1nkz8b"
    }
  ]
], UFe = y("Pin", qFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WFe = [
  ["path", { d: "m2 22 1-1h3l9-9", key: "1sre89" }],
  ["path", { d: "M3 21v-3l9-9", key: "hpe2y6" }],
  [
    "path",
    {
      d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z",
      key: "196du1"
    }
  ]
], ZFe = y("Pipette", WFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GFe = [
  ["path", { d: "m12 14-1 1", key: "11onhr" }],
  ["path", { d: "m13.75 18.25-1.25 1.42", key: "1yisr3" }],
  ["path", { d: "M17.775 5.654a15.68 15.68 0 0 0-12.121 12.12", key: "1qtqk6" }],
  ["path", { d: "M18.8 9.3a1 1 0 0 0 2.1 7.7", key: "fbbbr2" }],
  [
    "path",
    {
      d: "M21.964 20.732a1 1 0 0 1-1.232 1.232l-18-5a1 1 0 0 1-.695-1.232A19.68 19.68 0 0 1 15.732 2.037a1 1 0 0 1 1.232.695z",
      key: "1hyfdd"
    }
  ]
], YFe = y("Pizza", GFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KFe = [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z",
      key: "1ma21e"
    }
  ]
], $Fe = y("PlaneLanding", KFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JFe = [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z",
      key: "fkigj9"
    }
  ]
], QFe = y("PlaneTakeoff", JFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XFe = [
  [
    "path",
    {
      d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
      key: "1v9wt8"
    }
  ]
], e_e = y("Plane", XFe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t_e = [["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]], R7 = y("Play", t_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n_e = [
  ["path", { d: "M9 2v6", key: "17ngun" }],
  ["path", { d: "M15 2v6", key: "s7yy2p" }],
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M6 11V8h12v3a6 6 0 1 1-12 0Z", key: "wtfw2c" }]
], r_e = y("Plug2", n_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i_e = [
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  ["path", { d: "m18 3-4 4h6l-4 4", key: "16psg9" }]
], a_e = y("PlugZap", i_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o_e = [
  ["path", { d: "M12 22v-5", key: "1ega77" }],
  ["path", { d: "M9 8V2", key: "14iosj" }],
  ["path", { d: "M15 8V2", key: "18g5xt" }],
  ["path", { d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z", key: "osxo6l" }]
], s_e = y("Plug", o_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l_e = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], c_e = y("Plus", l_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u_e = [
  ["path", { d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2", key: "19w3oe" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z", key: "6fykxj" }],
  ["path", { d: "M18 11.66V22a4 4 0 0 0 4-4V6", key: "1utzek" }]
], d_e = y("PocketKnife", u_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f_e = [
  [
    "path",
    {
      d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z",
      key: "1mz881"
    }
  ],
  ["polyline", { points: "8 10 12 14 16 10", key: "w4mbv5" }]
], h_e = y("Pocket", f_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p_e = [
  ["path", { d: "M16.85 18.58a9 9 0 1 0-9.7 0", key: "d71mpg" }],
  ["path", { d: "M8 14a5 5 0 1 1 8 0", key: "fc81rn" }],
  ["circle", { cx: "12", cy: "11", r: "1", key: "1gvufo" }],
  ["path", { d: "M13 17a1 1 0 1 0-2 0l.5 4.5a.5.5 0 1 0 1 0Z", key: "za5kbj" }]
], m_e = y("Podcast", p_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y_e = [
  ["path", { d: "M10 4.5V4a2 2 0 0 0-2.41-1.957", key: "jsi14n" }],
  ["path", { d: "M13.9 8.4a2 2 0 0 0-1.26-1.295", key: "hirc7f" }],
  [
    "path",
    { d: "M21.7 16.2A8 8 0 0 0 22 14v-3a2 2 0 1 0-4 0v-1a2 2 0 0 0-3.63-1.158", key: "1jxb2e" }
  ],
  [
    "path",
    {
      d: "m7 15-1.8-1.8a2 2 0 0 0-2.79 2.86L6 19.7a7.74 7.74 0 0 0 6 2.3h2a8 8 0 0 0 5.657-2.343",
      key: "10r7hm"
    }
  ],
  ["path", { d: "M6 6v8", key: "tv5xkp" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], g_e = y("PointerOff", y_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v_e = [
  ["path", { d: "M22 14a8 8 0 0 1-8 8", key: "56vcr3" }],
  ["path", { d: "M18 11v-1a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1agjmk" }],
  ["path", { d: "M14 10V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1", key: "wdbh2u" }],
  ["path", { d: "M10 9.5V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v10", key: "1ibuk9" }],
  [
    "path",
    {
      d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "g6ys72"
    }
  ]
], b_e = y("Pointer", v_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w_e = [
  [
    "path",
    {
      d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4",
      key: "10td1f"
    }
  ],
  ["path", { d: "M10 22 9 8", key: "yjptiv" }],
  ["path", { d: "m14 22 1-14", key: "8jwc8b" }],
  [
    "path",
    {
      d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z",
      key: "1qo33t"
    }
  ]
], k_e = y("Popcorn", w_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x_e = [
  [
    "path",
    {
      d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z",
      key: "1o68ps"
    }
  ],
  ["path", { d: "m22 22-5.5-5.5", key: "17o70y" }]
], M_e = y("Popsicle", x_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C_e = [
  ["path", { d: "M18 7c0-5.333-8-5.333-8 0", key: "1prm2n" }],
  ["path", { d: "M10 7v14", key: "18tmcs" }],
  ["path", { d: "M6 21h12", key: "4dkmi1" }],
  ["path", { d: "M6 13h10", key: "ybwr4a" }]
], A_e = y("PoundSterling", C_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S_e = [
  ["path", { d: "M18.36 6.64A9 9 0 0 1 20.77 15", key: "dxknvb" }],
  ["path", { d: "M6.16 6.16a9 9 0 1 0 12.68 12.68", key: "1x7qb5" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], L_e = y("PowerOff", S_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T_e = [
  ["path", { d: "M12 2v10", key: "mnfbl" }],
  ["path", { d: "M18.4 6.6a9 9 0 1 1-12.77.04", key: "obofu9" }]
], E_e = y("Power", T_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j_e = [
  ["path", { d: "M2 3h20", key: "91anmk" }],
  ["path", { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3", key: "2k9sn8" }],
  ["path", { d: "m7 21 5-5 5 5", key: "bip4we" }]
], N_e = y("Presentation", j_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D_e = [
  ["path", { d: "M13.5 22H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v.5", key: "qeb09x" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }],
  ["path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2", key: "1md90i" }],
  ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6", key: "1itne7" }]
], I_e = y("PrinterCheck", D_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P_e = [
  [
    "path",
    {
      d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "143wyd"
    }
  ],
  ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6", key: "1itne7" }],
  ["rect", { x: "6", y: "14", width: "12", height: "8", rx: "1", key: "1ue0tg" }]
], z_e = y("Printer", P_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R_e = [
  ["path", { d: "M5 7 3 5", key: "1yys58" }],
  ["path", { d: "M9 6V3", key: "1ptz9u" }],
  ["path", { d: "m13 7 2-2", key: "1w3vmq" }],
  ["circle", { cx: "9", cy: "13", r: "3", key: "1mma13" }],
  [
    "path",
    {
      d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17",
      key: "2frwzc"
    }
  ],
  ["path", { d: "M16 16h2", key: "dnq2od" }]
], O_e = y("Projector", R_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B_e = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M12 9v11", key: "1fnkrn" }],
  ["path", { d: "M2 9h13a2 2 0 0 1 2 2v9", key: "11z3ex" }]
], H_e = y("Proportions", B_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F_e = [
  [
    "path",
    {
      d: "M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z",
      key: "w46dr5"
    }
  ]
], __e = y("Puzzle", F_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V_e = [
  [
    "path",
    {
      d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z",
      key: "aenxs0"
    }
  ],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
], q_e = y("Pyramid", V_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U_e = [
  ["rect", { width: "5", height: "5", x: "3", y: "3", rx: "1", key: "1tu5fj" }],
  ["rect", { width: "5", height: "5", x: "16", y: "3", rx: "1", key: "1v8r4q" }],
  ["rect", { width: "5", height: "5", x: "3", y: "16", rx: "1", key: "1x03jg" }],
  ["path", { d: "M21 16h-3a2 2 0 0 0-2 2v3", key: "177gqh" }],
  ["path", { d: "M21 21v.01", key: "ents32" }],
  ["path", { d: "M12 7v3a2 2 0 0 1-2 2H7", key: "8crl2c" }],
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M12 3h.01", key: "n36tog" }],
  ["path", { d: "M12 16v.01", key: "133mhm" }],
  ["path", { d: "M16 12h1", key: "1slzba" }],
  ["path", { d: "M21 12v.01", key: "1lwtk9" }],
  ["path", { d: "M12 21v-1", key: "1880an" }]
], W_e = y("QrCode", U_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z_e = [
  [
    "path",
    {
      d: "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "rib7q0"
    }
  ],
  [
    "path",
    {
      d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "1ymkrd"
    }
  ]
], G_e = y("Quote", Z_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y_e = [
  ["path", { d: "M13 16a3 3 0 0 1 2.24 5", key: "1epib5" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }],
  [
    "path",
    {
      d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3",
      key: "ue9ozu"
    }
  ],
  ["path", { d: "M20 8.54V4a2 2 0 1 0-4 0v3", key: "49iql8" }],
  ["path", { d: "M7.612 12.524a3 3 0 1 0-1.6 4.3", key: "1e33i0" }]
], K_e = y("Rabbit", Y_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $_e = [
  ["path", { d: "M19.07 4.93A10 10 0 0 0 6.99 3.34", key: "z3du51" }],
  ["path", { d: "M4 6h.01", key: "oypzma" }],
  ["path", { d: "M2.29 9.62A10 10 0 1 0 21.31 8.35", key: "qzzz0" }],
  ["path", { d: "M16.24 7.76A6 6 0 1 0 8.23 16.67", key: "1yjesh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M17.99 11.66A6 6 0 0 1 15.77 16.67", key: "1u2y91" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "m13.41 10.59 5.66-5.66", key: "mhq4k0" }]
], J_e = y("Radar", $_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q_e = [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  [
    "path",
    {
      d: "M7.5 4.2c-.3-.5-.9-.7-1.3-.4C3.9 5.5 2.3 8.1 2 11c-.1.5.4 1 1 1h5c0-1.5.8-2.8 2-3.4-1.1-1.9-2-3.5-2.5-4.4z",
      key: "wy49g3"
    }
  ],
  [
    "path",
    {
      d: "M21 12c.6 0 1-.4 1-1-.3-2.9-1.8-5.5-4.1-7.1-.4-.3-1.1-.2-1.3.3-.6.9-1.5 2.5-2.6 4.3 1.2.7 2 2 2 3.5h5z",
      key: "vklnvr"
    }
  ],
  [
    "path",
    {
      d: "M7.5 19.8c-.3.5-.1 1.1.4 1.3 2.6 1.2 5.6 1.2 8.2 0 .5-.2.7-.8.4-1.3-.5-.9-1.4-2.5-2.5-4.3-1.2.7-2.8.7-4 0-1.1 1.8-2 3.4-2.5 4.3z",
      key: "wkdf1o"
    }
  ]
], X_e = y("Radiation", Q_e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eVe = [
  [
    "path",
    {
      d: "M3 12h3.28a1 1 0 0 1 .948.684l2.298 7.934a.5.5 0 0 0 .96-.044L13.82 4.771A1 1 0 0 1 14.792 4H21",
      key: "1mqj8i"
    }
  ]
], tVe = y("Radical", eVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nVe = [
  ["path", { d: "M5 16v2", key: "g5qcv5" }],
  ["path", { d: "M19 16v2", key: "1gbaio" }],
  ["rect", { width: "20", height: "8", x: "2", y: "8", rx: "2", key: "vjsjur" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
], rVe = y("RadioReceiver", nVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iVe = [
  ["path", { d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9", key: "s0qx1y" }],
  ["path", { d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5", key: "1idnkw" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }],
  ["path", { d: "M16.2 4.8c2 2 2.26 5.11.8 7.47", key: "ojru2q" }],
  ["path", { d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1", key: "rhi7fg" }],
  ["path", { d: "M9.5 18h5", key: "mfy3pd" }],
  ["path", { d: "m8 22 4-11 4 11", key: "25yftu" }]
], aVe = y("RadioTower", iVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oVe = [
  ["path", { d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9", key: "1vaf9d" }],
  ["path", { d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5", key: "u1ii0m" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5", key: "1j5fej" }],
  ["path", { d: "M19.1 4.9C23 8.8 23 15.1 19.1 19", key: "10b0cb" }]
], sVe = y("Radio", oVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lVe = [
  ["path", { d: "M20.34 17.52a10 10 0 1 0-2.82 2.82", key: "fydyku" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["path", { d: "m13.41 13.41 4.18 4.18", key: "1gqbwc" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
], cVe = y("Radius", lVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uVe = [
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M5 9h14", key: "7tsvo6" }],
  ["path", { d: "m14 20-5-5 6-6-5-5", key: "1jo42i" }]
], dVe = y("RailSymbol", uVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fVe = [
  ["path", { d: "M22 17a10 10 0 0 0-20 0", key: "ozegv" }],
  ["path", { d: "M6 17a6 6 0 0 1 12 0", key: "5giftw" }],
  ["path", { d: "M10 17a2 2 0 0 1 4 0", key: "gnsikk" }]
], hVe = y("Rainbow", fVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pVe = [
  ["path", { d: "M13 22H4a2 2 0 0 1 0-4h12", key: "bt3f23" }],
  ["path", { d: "M13.236 18a3 3 0 0 0-2.2-5", key: "1tbvmo" }],
  ["path", { d: "M16 9h.01", key: "1bdo4e" }],
  [
    "path",
    {
      d: "M16.82 3.94a3 3 0 1 1 3.237 4.868l1.815 2.587a1.5 1.5 0 0 1-1.5 2.1l-2.872-.453a3 3 0 0 0-3.5 3",
      key: "9ch7kn"
    }
  ],
  ["path", { d: "M17 4.988a3 3 0 1 0-5.2 2.052A7 7 0 0 0 4 14.015 4 4 0 0 0 8 18", key: "3s7e9i" }]
], mVe = y("Rat", pVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yVe = [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
], gVe = y("Ratio", yVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vVe = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M12 6.5v11", key: "ecfhkf" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
], bVe = y("ReceiptCent", vVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wVe = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 12h5", key: "1g6qi8" }],
  ["path", { d: "M16 9.5a4 4 0 1 0 0 5.2", key: "b2px4r" }]
], kVe = y("ReceiptEuro", wVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xVe = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["path", { d: "M12 17.5 8 15h1a4 4 0 0 0 0-8", key: "grpkl4" }],
  ["path", { d: "M8 11h8", key: "vwpz6n" }]
], MVe = y("ReceiptIndianRupee", xVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CVe = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "m12 10 3-3", key: "1mc12w" }],
  ["path", { d: "m9 7 3 3v7.5", key: "39i0xv" }],
  ["path", { d: "M9 11h6", key: "1fldmi" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
], AVe = y("ReceiptJapaneseYen", CVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SVe = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 13h5", key: "1k9z8w" }],
  ["path", { d: "M10 17V9.5a2.5 2.5 0 0 1 5 0", key: "1dzgp0" }],
  ["path", { d: "M8 17h7", key: "8mjdqu" }]
], LVe = y("ReceiptPoundSterling", SVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TVe = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 15h5", key: "vxg57a" }],
  ["path", { d: "M8 11h5a2 2 0 1 0 0-4h-3v10", key: "1usi5u" }]
], EVe = y("ReceiptRussianRuble", TVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jVe = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M10 17V7h5", key: "k7jq18" }],
  ["path", { d: "M10 11h4", key: "1i0mka" }],
  ["path", { d: "M8 15h5", key: "vxg57a" }]
], NVe = y("ReceiptSwissFranc", jVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DVe = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M14 8H8", key: "1l3xfs" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M13 16H8", key: "wsln4y" }]
], IVe = y("ReceiptText", DVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PVe = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 17.5v-11", key: "1jc1ny" }]
], zVe = y("Receipt", PVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RVe = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
], OVe = y("RectangleEllipsis", RVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BVe = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
], HVe = y("RectangleHorizontal", BVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FVe = [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }]
], _Ve = y("RectangleVertical", FVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VVe = [
  [
    "path",
    {
      d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5",
      key: "x6z5xu"
    }
  ],
  [
    "path",
    {
      d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12",
      key: "1x4zh5"
    }
  ],
  ["path", { d: "m14 16-3 3 3 3", key: "f6jyew" }],
  ["path", { d: "M8.293 13.596 7.196 9.5 3.1 10.598", key: "wf1obh" }],
  [
    "path",
    {
      d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843",
      key: "9tzpgr"
    }
  ],
  ["path", { d: "m13.378 9.633 4.096 1.098 1.097-4.096", key: "1oe83g" }]
], qVe = y("Recycle", VVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UVe = [
  ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
  ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13", key: "6uklza" }]
], WVe = y("Redo2", UVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZVe = [
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
], GVe = y("RedoDot", ZVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YVe = [
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
], KVe = y("Redo", YVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $Ve = [
  ["path", { d: "M3 2v6h6", key: "18ldww" }],
  ["path", { d: "M21 12A9 9 0 0 0 6 5.3L3 8", key: "1pbrqz" }],
  ["path", { d: "M21 22v-6h-6", key: "usdfbe" }],
  ["path", { d: "M3 12a9 9 0 0 0 15 6.7l3-2.7", key: "1hosoe" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], JVe = y("RefreshCcwDot", $Ve);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QVe = [
  ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "14sxne" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16", key: "1hlbsb" }],
  ["path", { d: "M16 16h5v5", key: "ccwih5" }]
], XVe = y("RefreshCcw", QVe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eqe = [
  ["path", { d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47", key: "1krf6h" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }],
  ["path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64", key: "ruvoct" }],
  ["path", { d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64", key: "19q130" }],
  ["path", { d: "M21 12c0 1-.16 1.97-.47 2.87", key: "4w8emr" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
], tqe = y("RefreshCwOff", eqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nqe = [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
], rqe = y("RefreshCw", nqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iqe = [
  [
    "path",
    { d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z", key: "fpq118" }
  ],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M15 7v6", key: "1nx30x" }]
], aqe = y("Refrigerator", iqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oqe = [
  ["path", { d: "M17 3v10", key: "15fgeh" }],
  ["path", { d: "m12.67 5.5 8.66 5", key: "1gpheq" }],
  ["path", { d: "m12.67 10.5 8.66-5", key: "1dkfa6" }],
  [
    "path",
    { d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z", key: "swwfx4" }
  ]
], sqe = y("Regex", oqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lqe = [
  ["path", { d: "M4 7V4h16v3", key: "9msm58" }],
  ["path", { d: "M5 20h6", key: "1h6pxn" }],
  ["path", { d: "M13 4 8 20", key: "kqq6aj" }],
  ["path", { d: "m15 15 5 5", key: "me55sn" }],
  ["path", { d: "m20 15-5 5", key: "11p7ol" }]
], cqe = y("RemoveFormatting", lqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uqe = [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }],
  ["path", { d: "M11 10h1v4", key: "70cz1p" }]
], dqe = y("Repeat1", uqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fqe = [
  ["path", { d: "m2 9 3-3 3 3", key: "1ltn5i" }],
  ["path", { d: "M13 18H7a2 2 0 0 1-2-2V6", key: "1r6tfw" }],
  ["path", { d: "m22 15-3 3-3-3", key: "4rnwn2" }],
  ["path", { d: "M11 6h6a2 2 0 0 1 2 2v10", key: "2f72bc" }]
], hqe = y("Repeat2", fqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pqe = [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }]
], mqe = y("Repeat", pqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yqe = [
  ["path", { d: "M14 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "1yyzbs" }],
  ["path", { d: "M14 4a2 2 0 0 1 2-2", key: "1w2hp7" }],
  ["path", { d: "M16 10a2 2 0 0 1-2-2", key: "shjach" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "zfj4xr" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2", key: "188mtx" }],
  ["path", { d: "M22 8a2 2 0 0 1-2 2", key: "ddf4tu" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5a 3 3 0 0 1 3-3h1", key: "1ageje" }],
  ["rect", { x: "2", y: "14", width: "8", height: "8", rx: "2", key: "4rksxw" }]
], gqe = y("ReplaceAll", yqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vqe = [
  ["path", { d: "M14 4a2 2 0 0 1 2-2", key: "1w2hp7" }],
  ["path", { d: "M16 10a2 2 0 0 1-2-2", key: "shjach" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2", key: "188mtx" }],
  ["path", { d: "M22 8a2 2 0 0 1-2 2", key: "ddf4tu" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5a3 3 0 0 1 3-3h1", key: "3y3t5z" }],
  ["rect", { x: "2", y: "14", width: "8", height: "8", rx: "2", key: "4rksxw" }]
], bqe = y("Replace", vqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wqe = [
  ["polyline", { points: "7 17 2 12 7 7", key: "t83bqg" }],
  ["polyline", { points: "12 17 7 12 12 7", key: "1g4ajm" }],
  ["path", { d: "M22 18v-2a4 4 0 0 0-4-4H7", key: "1fcyog" }]
], kqe = y("ReplyAll", wqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xqe = [
  ["polyline", { points: "9 17 4 12 9 7", key: "hvgpf2" }],
  ["path", { d: "M20 18v-2a4 4 0 0 0-4-4H4", key: "5vmcpk" }]
], Mqe = y("Reply", xqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cqe = [
  ["polygon", { points: "11 19 2 12 11 5 11 19", key: "14yba5" }],
  ["polygon", { points: "22 19 13 12 22 5 22 19", key: "1pi1cj" }]
], Aqe = y("Rewind", Cqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sqe = [
  [
    "path",
    { d: "M12 11.22C11 9.997 10 9 10 8a2 2 0 0 1 4 0c0 1-.998 2.002-2.01 3.22", key: "1rnhq3" }
  ],
  ["path", { d: "m12 18 2.57-3.5", key: "116vt7" }],
  ["path", { d: "M6.243 9.016a7 7 0 0 1 11.507-.009", key: "10dq0b" }],
  ["path", { d: "M9.35 14.53 12 11.22", key: "tdsyp2" }],
  [
    "path",
    {
      d: "M9.35 14.53C7.728 12.246 6 10.221 6 7a6 5 0 0 1 12 0c-.005 3.22-1.778 5.235-3.43 7.5l3.557 4.527a1 1 0 0 1-.203 1.43l-1.894 1.36a1 1 0 0 1-1.384-.215L12 18l-2.679 3.593a1 1 0 0 1-1.39.213l-1.865-1.353a1 1 0 0 1-.203-1.422z",
      key: "nmifey"
    }
  ]
], Lqe = y("Ribbon", Sqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tqe = [
  [
    "path",
    {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
      key: "m3kijz"
    }
  ],
  [
    "path",
    {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
      key: "1fmvmk"
    }
  ],
  ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
  ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }]
], Eqe = y("Rocket", Tqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jqe = [
  ["polyline", { points: "3.5 2 6.5 12.5 18 12.5", key: "y3iy52" }],
  ["line", { x1: "9.5", x2: "5.5", y1: "12.5", y2: "20", key: "19vg5i" }],
  ["line", { x1: "15", x2: "18.5", y1: "12.5", y2: "20", key: "1inpmv" }],
  ["path", { d: "M2.75 18a13 13 0 0 0 18.5 0", key: "1nquas" }]
], Nqe = y("RockingChair", jqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dqe = [
  ["path", { d: "M6 19V5", key: "1r845m" }],
  ["path", { d: "M10 19V6.8", key: "9j2tfs" }],
  ["path", { d: "M14 19v-7.8", key: "10s8qv" }],
  ["path", { d: "M18 5v4", key: "1tajlv" }],
  ["path", { d: "M18 19v-6", key: "ielfq3" }],
  ["path", { d: "M22 19V9", key: "158nzp" }],
  ["path", { d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65", key: "1930oh" }]
], Iqe = y("RollerCoaster", Dqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pqe = [
  [
    "path",
    {
      d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2",
      key: "10n0gc"
    }
  ],
  ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814", key: "16shm9" }],
  [
    "path",
    {
      d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4",
      key: "1lxi77"
    }
  ]
], zqe = y("Rotate3d", Pqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rqe = [
  ["path", { d: "M20 9V7a2 2 0 0 0-2-2h-6", key: "19z8uc" }],
  ["path", { d: "m15 2-3 3 3 3", key: "177bxs" }],
  ["path", { d: "M20 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2", key: "d36hnl" }]
], Oqe = y("RotateCcwSquare", Rqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bqe = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
], Hqe = y("RotateCcw", Bqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fqe = [
  ["path", { d: "M12 5H6a2 2 0 0 0-2 2v3", key: "l96uqu" }],
  ["path", { d: "m9 8 3-3-3-3", key: "1gzgc3" }],
  ["path", { d: "M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1w2k5h" }]
], _qe = y("RotateCwSquare", Fqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vqe = [
  ["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }]
], qqe = y("RotateCw", Vqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uqe = [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5c.4 0 .9-.1 1.3-.2", key: "1effex" }],
  ["path", { d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12", key: "k9y2ds" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3", key: "11nlu2" }],
  ["path", { d: "M15 5h-4.3", key: "6537je" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
], Wqe = y("RouteOff", Uqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zqe = [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15", key: "1d8sl" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
], Gqe = y("Route", Zqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yqe = [
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6.01 18H6", key: "19vcac" }],
  ["path", { d: "M10.01 18H10", key: "uamcmx" }],
  ["path", { d: "M15 10v4", key: "qjz1xs" }],
  ["path", { d: "M17.84 7.17a4 4 0 0 0-5.66 0", key: "1rif40" }],
  ["path", { d: "M20.66 4.34a8 8 0 0 0-11.31 0", key: "6a5xfq" }]
], Kqe = y("Router", Yqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $qe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }]
], Jqe = y("Rows2", $qe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qqe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
], Xqe = y("Rows3", Qqe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eUe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 7.5H3", key: "1hm9pq" }],
  ["path", { d: "M21 12H3", key: "2avoz0" }],
  ["path", { d: "M21 16.5H3", key: "n7jzkj" }]
], tUe = y("Rows4", eUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nUe = [
  ["path", { d: "M4 11a9 9 0 0 1 9 9", key: "pv89mb" }],
  ["path", { d: "M4 4a16 16 0 0 1 16 16", key: "k0647b" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
], rUe = y("Rss", nUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iUe = [
  [
    "path",
    {
      d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
      key: "icamh8"
    }
  ],
  ["path", { d: "m14.5 12.5 2-2", key: "inckbg" }],
  ["path", { d: "m11.5 9.5 2-2", key: "fmmyf7" }],
  ["path", { d: "m8.5 6.5 2-2", key: "vc6u1g" }],
  ["path", { d: "m17.5 15.5 2-2", key: "wo5hmg" }]
], aUe = y("Ruler", iUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oUe = [
  ["path", { d: "M6 11h8a4 4 0 0 0 0-8H9v18", key: "18ai8t" }],
  ["path", { d: "M6 15h8", key: "1y8f6l" }]
], sUe = y("RussianRuble", oUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lUe = [
  ["path", { d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z", key: "1404fh" }],
  ["path", { d: "M21 14 10 2 3 14h18Z", key: "1nzg7v" }],
  ["path", { d: "M10 2v16", key: "1labyt" }]
], cUe = y("Sailboat", lUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uUe = [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  [
    "path",
    {
      d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1",
      key: "10xrj0"
    }
  ],
  ["path", { d: "m13 12 4-4", key: "1hckqy" }],
  ["path", { d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2", key: "1p4srx" }]
], dUe = y("Salad", uUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fUe = [
  ["path", { d: "m2.37 11.223 8.372-6.777a2 2 0 0 1 2.516 0l8.371 6.777", key: "f1wd0e" }],
  ["path", { d: "M21 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.25", key: "1pfu07" }],
  ["path", { d: "M3 15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h9", key: "1oq9qw" }],
  ["path", { d: "m6.67 15 6.13 4.6a2 2 0 0 0 2.8-.4l3.15-4.2", key: "1fnwu5" }],
  ["rect", { width: "20", height: "4", x: "2", y: "11", rx: "1", key: "itshg" }]
], hUe = y("Sandwich", fUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pUe = [
  ["path", { d: "M4 10a7.31 7.31 0 0 0 10 10Z", key: "1fzpp3" }],
  ["path", { d: "m9 15 3-3", key: "88sc13" }],
  ["path", { d: "M17 13a6 6 0 0 0-6-6", key: "15cc6u" }],
  ["path", { d: "M21 13A10 10 0 0 0 11 3", key: "11nf8s" }]
], mUe = y("SatelliteDish", pUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yUe = [
  ["path", { d: "M13 7 9 3 5 7l4 4", key: "vyckw6" }],
  ["path", { d: "m17 11 4 4-4 4-4-4", key: "rchckc" }],
  ["path", { d: "m8 12 4 4 6-6-4-4Z", key: "1sshf7" }],
  ["path", { d: "m16 8 3-3", key: "x428zp" }],
  ["path", { d: "M9 21a6 6 0 0 0-6-6", key: "1iajcf" }]
], gUe = y("Satellite", yUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vUe = [
  ["path", { d: "M10 2v3a1 1 0 0 0 1 1h5", key: "1xspal" }],
  ["path", { d: "M18 18v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6", key: "1ra60u" }],
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  [
    "path",
    {
      d: "M8 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9.172a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 22 6.828V16a2 2 0 0 1-2.01 2z",
      key: "1yve0x"
    }
  ]
], bUe = y("SaveAll", vUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wUe = [
  ["path", { d: "M13 13H8a1 1 0 0 0-1 1v7", key: "h8g396" }],
  ["path", { d: "M14 8h1", key: "1lfen6" }],
  ["path", { d: "M17 21v-4", key: "1yknxs" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    { d: "M20.41 20.41A2 2 0 0 1 19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 .59-1.41", key: "1t4vdl" }
  ],
  ["path", { d: "M29.5 11.5s5 5 4 5", key: "zzn4i6" }],
  ["path", { d: "M9 3h6.2a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V15", key: "24cby9" }]
], kUe = y("SaveOff", wUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xUe = [
  [
    "path",
    {
      d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
      key: "1c8476"
    }
  ],
  ["path", { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7", key: "1ydtos" }],
  ["path", { d: "M7 3v4a1 1 0 0 0 1 1h7", key: "t51u73" }]
], MUe = y("Save", xUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CUe = [
  ["path", { d: "M5 7v11a1 1 0 0 0 1 1h11", key: "13dt1j" }],
  ["path", { d: "M5.293 18.707 11 13", key: "ezgbsx" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }]
], AUe = y("Scale3d", CUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SUe = [
  ["path", { d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "7g6ntu" }],
  ["path", { d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "ijws7r" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2", key: "3gwbw2" }]
], LUe = y("Scale", SUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TUe = [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  ["path", { d: "M14 15H9v-5", key: "pi4jk9" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M21 3 9 15", key: "15kdhq" }]
], EUe = y("Scaling", TUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jUe = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 7v10", key: "23sfjj" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M17 7v10", key: "578dap" }]
], NUe = y("ScanBarcode", jUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DUe = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
      key: "11ak4c"
    }
  ]
], IUe = y("ScanEye", DUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PUe = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }]
], zUe = y("ScanFace", PUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RUe = [
  [
    "path",
    {
      d: "M11.246 16.657a1 1 0 0 0 1.508 0l3.57-4.101A2.75 2.75 0 1 0 12 9.168a2.75 2.75 0 1 0-4.324 3.388z",
      key: "1algrk"
    }
  ],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
], OUe = y("ScanHeart", RUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BUe = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }]
], HUe = y("ScanLine", BUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FUe = [
  ["path", { d: "M17 12v4a1 1 0 0 1-1 1h-4", key: "uk4fdo" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M17 8V7", key: "q2g9wo" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { x: "7", y: "7", width: "5", height: "5", rx: "1", key: "m9kyts" }]
], _Ue = y("ScanQrCode", FUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VUe = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m16 16-1.9-1.9", key: "1dq9hf" }]
], qUe = y("ScanSearch", VUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UUe = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 8h8", key: "1jbsf9" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h6", key: "1vyc9m" }]
], WUe = y("ScanText", UUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZUe = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
], GUe = y("Scan", ZUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YUe = [
  ["path", { d: "M14 22v-4a2 2 0 1 0-4 0v4", key: "hhkicm" }],
  [
    "path",
    {
      d: "m18 10 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7.382a1 1 0 0 1 .553-.894L6 10",
      key: "1xqip1"
    }
  ],
  ["path", { d: "M18 5v17", key: "1sw6gf" }],
  ["path", { d: "m4 6 7.106-3.553a2 2 0 0 1 1.788 0L20 6", key: "9d2mlk" }],
  ["path", { d: "M6 5v17", key: "1xfsm0" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }]
], KUe = y("School", YUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $Ue = [
  ["path", { d: "M5.42 9.42 8 12", key: "12pkuq" }],
  ["circle", { cx: "4", cy: "8", r: "2", key: "107mxr" }],
  ["path", { d: "m14 6-8.58 8.58", key: "gvzu5l" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "M10.8 14.8 14 18", key: "ax7m9r" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
], JUe = y("ScissorsLineDashed", $Ue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QUe = [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M8.12 8.12 12 12", key: "1alkpv" }],
  ["path", { d: "M20 4 8.12 15.88", key: "xgtan2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M14.8 14.8 20 20", key: "ptml3r" }]
], XUe = y("Scissors", QUe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eWe = [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
], tWe = y("ScreenShareOff", eWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nWe = [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m17 8 5-5", key: "fqif7o" }],
  ["path", { d: "M17 3h5v5", key: "1o3tu8" }]
], rWe = y("ScreenShare", nWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iWe = [
  ["path", { d: "M15 12h-5", key: "r7krc0" }],
  ["path", { d: "M15 8h-5", key: "1khuty" }],
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
], aWe = y("ScrollText", iWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oWe = [
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
], sWe = y("Scroll", oWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lWe = [
  ["path", { d: "m8 11 2 2 4-4", key: "1sed1v" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], cWe = y("SearchCheck", lWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uWe = [
  ["path", { d: "m13 13.5 2-2.5-2-2.5", key: "1rvxrh" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M9 8.5 7 11l2 2.5", key: "6ffwbx" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], dWe = y("SearchCode", uWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fWe = [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], hWe = y("SearchSlash", fWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pWe = [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["path", { d: "m8.5 8.5 5 5", key: "a8mexj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], mWe = y("SearchX", pWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yWe = [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], jF = y("Search", yWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gWe = [
  ["path", { d: "M16 5a4 3 0 0 0-8 0c0 4 8 3 8 7a4 3 0 0 1-8 0", key: "vqan6v" }],
  ["path", { d: "M8 19a4 3 0 0 0 8 0c0-4-8-3-8-7a4 3 0 0 1 8 0", key: "wdjd8o" }]
], vWe = y("Section", gWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bWe = [
  [
    "path",
    {
      d: "M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z",
      key: "117uat"
    }
  ],
  ["path", { d: "M6 12h16", key: "s4cdu5" }]
], wWe = y("SendHorizontal", bWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kWe = [
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }],
  ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1", key: "pao6x6" }],
  ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1", key: "19tdru" }]
], xWe = y("SendToBack", kWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MWe = [
  [
    "path",
    {
      d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
      key: "1ffxy3"
    }
  ],
  ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
], CWe = y("Send", MWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AWe = [
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
  ["polyline", { points: "8 8 12 4 16 8", key: "zo8t4w" }],
  ["polyline", { points: "16 16 12 20 8 16", key: "1oyrid" }]
], SWe = y("SeparatorHorizontal", AWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LWe = [
  ["line", { x1: "12", x2: "12", y1: "3", y2: "21", key: "1efggb" }],
  ["polyline", { points: "8 8 4 12 8 16", key: "bnfmv4" }],
  ["polyline", { points: "16 16 20 12 16 8", key: "u90052" }]
], TWe = y("SeparatorVertical", LWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EWe = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5",
      key: "tn8das"
    }
  ],
  [
    "path",
    {
      d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5",
      key: "1g2pve"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m15.7 13.4-.9-.3", key: "1jwmzr" }],
  ["path", { d: "m9.2 10.9-.9-.3", key: "qapnim" }],
  ["path", { d: "m10.6 15.7.3-.9", key: "quwk0k" }],
  ["path", { d: "m13.6 15.7-.4-1", key: "cb9xp7" }],
  ["path", { d: "m10.8 9.3-.4-1", key: "1uaiz5" }],
  ["path", { d: "m8.3 13.6 1-.4", key: "s6srou" }],
  ["path", { d: "m14.7 10.8 1-.4", key: "4d31cq" }],
  ["path", { d: "m13.4 8.3-.3.9", key: "1bm987" }]
], jWe = y("ServerCog", EWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NWe = [
  [
    "path",
    {
      d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2",
      key: "4b9dqc"
    }
  ],
  [
    "path",
    {
      d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2",
      key: "22nnkd"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m13 6-4 6h6l-4 6", key: "14hqih" }]
], DWe = y("ServerCrash", NWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IWe = [
  ["path", { d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5", key: "bt2siv" }],
  ["path", { d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z", key: "1hjrv1" }],
  ["path", { d: "M22 17v-1a2 2 0 0 0-2-2h-1", key: "1iynyr" }],
  ["path", { d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z", key: "161ggg" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], PWe = y("ServerOff", IWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zWe = [
  ["rect", { width: "20", height: "8", x: "2", y: "2", rx: "2", ry: "2", key: "ngkwjq" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", ry: "2", key: "iecqi9" }],
  ["line", { x1: "6", x2: "6.01", y1: "6", y2: "6", key: "16zg32" }],
  ["line", { x1: "6", x2: "6.01", y1: "18", y2: "18", key: "nzw8ys" }]
], RWe = y("Server", zWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OWe = [
  ["path", { d: "M20 7h-9", key: "3s1dr2" }],
  ["path", { d: "M14 17H5", key: "gfn3mx" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
], BWe = y("Settings2", OWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HWe = [
  [
    "path",
    {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
      key: "1qme2f"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], FWe = y("Settings", HWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _We = [
  [
    "path",
    {
      d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
      key: "1bo67w"
    }
  ],
  ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "3.5", key: "w3z12y" }]
], VWe = y("Shapes", _We);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qWe = [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
], UWe = y("Share2", qWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WWe = [
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["polyline", { points: "16 6 12 2 8 6", key: "m901s6" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "15", key: "1p0rca" }]
], ZWe = y("Share", WWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GWe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }],
  ["line", { x1: "3", x2: "21", y1: "15", y2: "15", key: "o2sbyz" }],
  ["line", { x1: "9", x2: "9", y1: "9", y2: "21", key: "1ib60c" }],
  ["line", { x1: "15", x2: "15", y1: "9", y2: "21", key: "1n26ft" }]
], YWe = y("Sheet", GWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KWe = [
  [
    "path",
    {
      d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44",
      key: "1cn552"
    }
  ]
], $We = y("Shell", KWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JWe = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
], QWe = y("ShieldAlert", JWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XWe = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m4.243 5.21 14.39 12.472", key: "1c9a7c" }]
], eZe = y("ShieldBan", XWe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tZe = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], nZe = y("ShieldCheck", tZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rZe = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
], iZe = y("ShieldEllipsis", rZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aZe = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 22V2", key: "zs6s6o" }]
], oZe = y("ShieldHalf", aZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sZe = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
], lZe = y("ShieldMinus", sZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cZe = [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
      key: "1jlk70"
    }
  ],
  [
    "path",
    {
      d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
      key: "18rp1v"
    }
  ]
], uZe = y("ShieldOff", cZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dZe = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
], fZe = y("ShieldPlus", dZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hZe = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], pZe = y("ShieldQuestion", hZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mZe = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
], yZe = y("ShieldX", mZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gZe = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
], vZe = y("Shield", gZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bZe = [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["path", { d: "M12 2v7.5", key: "1e5rl5" }],
  ["path", { d: "m19 5-5.23 5.23", key: "1ezxxf" }],
  ["path", { d: "M22 12h-7.5", key: "le1719" }],
  ["path", { d: "m19 19-5.23-5.23", key: "p3fmgn" }],
  ["path", { d: "M12 14.5V22", key: "dgcmos" }],
  ["path", { d: "M10.23 13.77 5 19", key: "qwopd4" }],
  ["path", { d: "M9.5 12H2", key: "r7bup8" }],
  ["path", { d: "M10.23 10.23 5 5", key: "k2y7lj" }],
  ["circle", { cx: "12", cy: "12", r: "2.5", key: "ix0uyj" }]
], wZe = y("ShipWheel", bZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kZe = [
  ["path", { d: "M12 10.189V14", key: "1p8cqu" }],
  ["path", { d: "M12 2v3", key: "qbqxhf" }],
  ["path", { d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6", key: "qpkstq" }],
  [
    "path",
    {
      d: "M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76",
      key: "7tigtc"
    }
  ],
  [
    "path",
    {
      d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "1924j5"
    }
  ]
], xZe = y("Ship", kZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MZe = [
  [
    "path",
    {
      d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
      key: "1wgbhj"
    }
  ]
], CZe = y("Shirt", MZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AZe = [
  ["path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z", key: "hou9p0" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }]
], SZe = y("ShoppingBag", AZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LZe = [
  ["path", { d: "m15 11-1 9", key: "5wnq3a" }],
  ["path", { d: "m19 11-4-7", key: "cnml18" }],
  ["path", { d: "M2 11h20", key: "3eubbj" }],
  ["path", { d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4", key: "yiazzp" }],
  ["path", { d: "M4.5 15.5h15", key: "13mye1" }],
  ["path", { d: "m5 11 4-7", key: "116ra9" }],
  ["path", { d: "m9 11 1 9", key: "1ojof7" }]
], TZe = y("ShoppingBasket", LZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EZe = [
  ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
  ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
  [
    "path",
    {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
      key: "9zh506"
    }
  ]
], jZe = y("ShoppingCart", EZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NZe = [
  ["path", { d: "M2 22v-5l5-5 5 5-5 5z", key: "1fh25c" }],
  ["path", { d: "M9.5 14.5 16 8", key: "1smz5x" }],
  [
    "path",
    { d: "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2", key: "1q8uv5" }
  ]
], DZe = y("Shovel", NZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IZe = [
  ["path", { d: "m4 4 2.5 2.5", key: "uv2vmf" }],
  ["path", { d: "M13.5 6.5a4.95 4.95 0 0 0-7 7", key: "frdkwv" }],
  ["path", { d: "M15 5 5 15", key: "1ag8rq" }],
  ["path", { d: "M14 17v.01", key: "eokfpp" }],
  ["path", { d: "M10 16v.01", key: "14uyyl" }],
  ["path", { d: "M13 13v.01", key: "1v1k97" }],
  ["path", { d: "M16 10v.01", key: "5169yg" }],
  ["path", { d: "M11 20v.01", key: "cj92p8" }],
  ["path", { d: "M17 14v.01", key: "11cswd" }],
  ["path", { d: "M20 11v.01", key: "19e0od" }]
], PZe = y("ShowerHead", IZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zZe = [
  ["path", { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8", key: "17vawe" }],
  ["path", { d: "M9 19.8V15m0 0H4.2M9 15l-6 6", key: "chjx8e" }],
  ["path", { d: "M15 4.2V9m0 0h4.8M15 9l6-6", key: "lav6yq" }],
  ["path", { d: "M9 4.2V9m0 0H4.2M9 9 3 3", key: "1pxi2q" }]
], RZe = y("Shrink", zZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OZe = [
  ["path", { d: "M12 22v-7l-2-2", key: "eqv9mc" }],
  ["path", { d: "M17 8v.8A6 6 0 0 1 13.8 20H10A6.5 6.5 0 0 1 7 8a5 5 0 0 1 10 0Z", key: "ubcgy" }],
  ["path", { d: "m14 14-2 2", key: "847xa2" }]
], BZe = y("Shrub", OZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HZe = [
  ["path", { d: "m18 14 4 4-4 4", key: "10pe0f" }],
  ["path", { d: "m18 2 4 4-4 4", key: "pucp1d" }],
  ["path", { d: "M2 18h1.973a4 4 0 0 0 3.3-1.7l5.454-8.6a4 4 0 0 1 3.3-1.7H22", key: "1ailkh" }],
  ["path", { d: "M2 6h1.972a4 4 0 0 1 3.6 2.2", key: "km57vx" }],
  ["path", { d: "M22 18h-6.041a4 4 0 0 1-3.3-1.8l-.359-.45", key: "os18l9" }]
], FZe = y("Shuffle", HZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Ze = [
  [
    "path",
    {
      d: "M18 7V5a1 1 0 0 0-1-1H6.5a.5.5 0 0 0-.4.8l4.5 6a2 2 0 0 1 0 2.4l-4.5 6a.5.5 0 0 0 .4.8H17a1 1 0 0 0 1-1v-2",
      key: "wuwx1p"
    }
  ]
], VZe = y("Sigma", _Ze);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qZe = [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }]
], UZe = y("SignalHigh", qZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WZe = [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }]
], ZZe = y("SignalLow", WZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GZe = [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }]
], YZe = y("SignalMedium", GZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KZe = [["path", { d: "M2 20h.01", key: "4haj6o" }]], $Ze = y("SignalZero", KZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JZe = [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }],
  ["path", { d: "M22 4v16", key: "sih9yq" }]
], QZe = y("Signal", JZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XZe = [
  [
    "path",
    {
      d: "m21 17-2.156-1.868A.5.5 0 0 0 18 15.5v.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1c0-2.545-3.991-3.97-8.5-4a1 1 0 0 0 0 5c4.153 0 4.745-11.295 5.708-13.5a2.5 2.5 0 1 1 3.31 3.284",
      key: "y32ogt"
    }
  ],
  ["path", { d: "M3 21h18", key: "itz85i" }]
], eGe = y("Signature", XZe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tGe = [
  ["path", { d: "M10 9H4L2 7l2-2h6", key: "1hq7x2" }],
  ["path", { d: "M14 5h6l2 2-2 2h-6", key: "bv62ej" }],
  ["path", { d: "M10 22V4a2 2 0 1 1 4 0v18", key: "eqpcf2" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }]
], nGe = y("SignpostBig", tGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rGe = [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  [
    "path",
    {
      d: "M18 6a2 2 0 0 1 1.387.56l2.307 2.22a1 1 0 0 1 0 1.44l-2.307 2.22A2 2 0 0 1 18 13H6a2 2 0 0 1-1.387-.56l-2.306-2.22a1 1 0 0 1 0-1.44l2.306-2.22A2 2 0 0 1 6 6z",
      key: "gqqp9m"
    }
  ]
], iGe = y("Signpost", rGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aGe = [
  ["path", { d: "M7 18v-6a5 5 0 1 1 10 0v6", key: "pcx96s" }],
  [
    "path",
    { d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z", key: "1b4s83" }
  ],
  ["path", { d: "M21 12h1", key: "jtio3y" }],
  ["path", { d: "M18.5 4.5 18 5", key: "g5sp9y" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "m4.929 4.929.707.707", key: "1i51kw" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }]
], oGe = y("Siren", aGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sGe = [
  ["polygon", { points: "19 20 9 12 19 4 19 20", key: "o2sva" }],
  ["line", { x1: "5", x2: "5", y1: "19", y2: "5", key: "1ocqjk" }]
], lGe = y("SkipBack", sGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cGe = [
  ["polygon", { points: "5 4 15 12 5 20 5 4", key: "16p6eg" }],
  ["line", { x1: "19", x2: "19", y1: "5", y2: "19", key: "futhcm" }]
], uGe = y("SkipForward", cGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dGe = [
  ["path", { d: "m12.5 17-.5-1-.5 1h1z", key: "3me087" }],
  [
    "path",
    {
      d: "M15 22a1 1 0 0 0 1-1v-1a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20v1a1 1 0 0 0 1 1z",
      key: "1o5pge"
    }
  ],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }]
], fGe = y("Skull", dGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hGe = [
  ["rect", { width: "3", height: "8", x: "13", y: "2", rx: "1.5", key: "diqz80" }],
  ["path", { d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5", key: "183iwg" }],
  ["rect", { width: "3", height: "8", x: "8", y: "14", rx: "1.5", key: "hqg7r1" }],
  ["path", { d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5", key: "76g71w" }],
  ["rect", { width: "8", height: "3", x: "14", y: "13", rx: "1.5", key: "1kmz0a" }],
  ["path", { d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5", key: "jc4sz0" }],
  ["rect", { width: "8", height: "3", x: "2", y: "8", rx: "1.5", key: "1omvl4" }],
  ["path", { d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5", key: "16f3cl" }]
], pGe = y("Slack", hGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mGe = [["path", { d: "M22 2 2 22", key: "y4kqgn" }]], yGe = y("Slash", mGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gGe = [
  [
    "path",
    {
      d: "M11 16.586V19a1 1 0 0 1-1 1H2L18.37 3.63a1 1 0 1 1 3 3l-9.663 9.663a1 1 0 0 1-1.414 0L8 14",
      key: "1sllp5"
    }
  ]
], vGe = y("Slice", gGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bGe = [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
], wGe = y("SlidersHorizontal", bGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kGe = [
  ["line", { x1: "4", x2: "4", y1: "21", y2: "14", key: "1p332r" }],
  ["line", { x1: "4", x2: "4", y1: "10", y2: "3", key: "gb41h5" }],
  ["line", { x1: "12", x2: "12", y1: "21", y2: "12", key: "hf2csr" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "3", key: "1kfi7u" }],
  ["line", { x1: "20", x2: "20", y1: "21", y2: "16", key: "1lhrwl" }],
  ["line", { x1: "20", x2: "20", y1: "12", y2: "3", key: "16vvfq" }],
  ["line", { x1: "2", x2: "6", y1: "14", y2: "14", key: "1uebub" }],
  ["line", { x1: "10", x2: "14", y1: "8", y2: "8", key: "1yglbp" }],
  ["line", { x1: "18", x2: "22", y1: "16", y2: "16", key: "1jxqpz" }]
], xGe = y("SlidersVertical", kGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MGe = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12.667 8 10 12h4l-2.667 4", key: "h9lk2d" }]
], CGe = y("SmartphoneCharging", MGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AGe = [
  ["rect", { width: "7", height: "12", x: "2", y: "6", rx: "1", key: "5nje8w" }],
  ["path", { d: "M13 8.32a7.43 7.43 0 0 1 0 7.36", key: "1g306n" }],
  ["path", { d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "uqvjvo" }],
  ["path", { d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "ujntz3" }]
], SGe = y("SmartphoneNfc", AGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LGe = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
], TGe = y("Smartphone", LGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EGe = [
  ["path", { d: "M22 11v1a10 10 0 1 1-9-10", key: "ew0xw9" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }]
], jGe = y("SmilePlus", EGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NGe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], DGe = y("Smile", NGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IGe = [
  ["path", { d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0", key: "hneq2s" }],
  ["circle", { cx: "10", cy: "13", r: "8", key: "194lz3" }],
  ["path", { d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6", key: "ixqyt7" }],
  ["path", { d: "M18 3 19.1 5.2", key: "9tjm43" }],
  ["path", { d: "M22 3 20.9 5.2", key: "j3odrs" }]
], PGe = y("Snail", IGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zGe = [
  ["path", { d: "m10 20-1.25-2.5L6 18", key: "18frcb" }],
  ["path", { d: "M10 4 8.75 6.5 6 6", key: "7mghy3" }],
  ["path", { d: "m14 20 1.25-2.5L18 18", key: "1chtki" }],
  ["path", { d: "m14 4 1.25 2.5L18 6", key: "1b4wsy" }],
  ["path", { d: "m17 21-3-6h-4", key: "15hhxa" }],
  ["path", { d: "m17 3-3 6 1.5 3", key: "11697g" }],
  ["path", { d: "M2 12h6.5L10 9", key: "kv9z4n" }],
  ["path", { d: "m20 10-1.5 2 1.5 2", key: "1swlpi" }],
  ["path", { d: "M22 12h-6.5L14 15", key: "1mxi28" }],
  ["path", { d: "m4 10 1.5 2L4 14", key: "k9enpj" }],
  ["path", { d: "m7 21 3-6-1.5-3", key: "j8hb9u" }],
  ["path", { d: "m7 3 3 6h4", key: "1otusx" }]
], RGe = y("Snowflake", zGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OGe = [
  ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3", key: "1dgpiv" }],
  [
    "path",
    {
      d: "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
      key: "xacw8m"
    }
  ],
  ["path", { d: "M4 18v2", key: "jwo5n2" }],
  ["path", { d: "M20 18v2", key: "1ar1qi" }],
  ["path", { d: "M12 4v9", key: "oqhhn3" }]
], BGe = y("Sofa", OGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HGe = [
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M19.5 12 22 6", key: "shfsr5" }],
  [
    "path",
    {
      d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
      key: "rpc6vp"
    }
  ],
  [
    "path",
    {
      d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
      key: "1lf63m"
    }
  ],
  [
    "path",
    { d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62", key: "97tijn" }
  ]
], FGe = y("Soup", HGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Ge = [
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
], VGe = y("Space", _Ge);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qGe = [
  [
    "path",
    {
      d: "M5 9c-1.5 1.5-3 3.2-3 5.5A5.5 5.5 0 0 0 7.5 20c1.8 0 3-.5 4.5-2 1.5 1.5 2.7 2 4.5 2a5.5 5.5 0 0 0 5.5-5.5c0-2.3-1.5-4-3-5.5l-7-7-7 7Z",
      key: "40bo9n"
    }
  ],
  ["path", { d: "M12 18v4", key: "jadmvz" }]
], UGe = y("Spade", qGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WGe = [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ]
], ZGe = y("Sparkle", WGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GGe = [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }],
  ["path", { d: "M4 17v2", key: "vumght" }],
  ["path", { d: "M5 18H3", key: "zchphs" }]
], YGe = y("Sparkles", GGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KGe = [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["circle", { cx: "12", cy: "14", r: "4", key: "1jruaj" }],
  ["path", { d: "M12 14h.01", key: "1etili" }]
], $Ge = y("Speaker", KGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JGe = [
  [
    "path",
    {
      d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20",
      key: "11atix"
    }
  ],
  ["path", { d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603", key: "yol142" }],
  ["path", { d: "M17 15a3.5 3.5 0 0 0-.025-4.975", key: "ssbmkc" }]
], QGe = y("Speech", JGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XGe = [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  [
    "path",
    {
      d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1",
      key: "8mdmtu"
    }
  ]
], eYe = y("SpellCheck2", XGe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tYe = [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
], nYe = y("SpellCheck", tYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rYe = [
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M5 17A12 12 0 0 1 17 5", key: "1okkup" }]
], iYe = y("Spline", rYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aYe = [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M8 3H3v5", key: "15dfkv" }],
  ["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3", key: "1qrqzj" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }]
], oYe = y("Split", aYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sYe = [
  ["path", { d: "M3 3h.01", key: "159qn6" }],
  ["path", { d: "M7 5h.01", key: "1hq22a" }],
  ["path", { d: "M11 7h.01", key: "1osv80" }],
  ["path", { d: "M3 7h.01", key: "1xzrh3" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }],
  ["path", { d: "M3 11h.01", key: "1eifu7" }],
  ["rect", { width: "4", height: "4", x: "15", y: "5", key: "mri9e4" }],
  ["path", { d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2", key: "aib6hk" }],
  ["path", { d: "m13 14 8-2", key: "1d7bmk" }],
  ["path", { d: "m13 19 8-2", key: "1y2vml" }]
], lYe = y("SprayCan", sYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cYe = [
  ["path", { d: "M7 20h10", key: "e6iznv" }],
  ["path", { d: "M10 20c5.5-2.5.8-6.4 3-10", key: "161w41" }],
  [
    "path",
    {
      d: "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z",
      key: "9gtqwd"
    }
  ],
  [
    "path",
    {
      d: "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z",
      key: "bkxnd2"
    }
  ]
], uYe = y("Sprout", cYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M17 12h-2l-2 5-2-10-2 5H7", key: "15hlnc" }]
], fYe = y("SquareActivity", dYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 8-8 8", key: "166keh" }],
  ["path", { d: "M16 16H8V8", key: "1w2ppm" }]
], pYe = y("SquareArrowDownLeft", hYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "M16 8v8H8", key: "1lbpgo" }]
], yYe = y("SquareArrowDownRight", mYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
], vYe = y("SquareArrowDown", gYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }]
], wYe = y("SquareArrowLeft", bYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kYe = [
  ["path", { d: "M13 21h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6", key: "14qz4y" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], xYe = y("SquareArrowOutDownLeft", kYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MYe = [
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }],
  ["path", { d: "m21 21-9-9", key: "1et2py" }],
  ["path", { d: "M21 15v6h-6", key: "1jko0i" }]
], CYe = y("SquareArrowOutDownRight", MYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AYe = [
  ["path", { d: "M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6", key: "14mv1t" }],
  ["path", { d: "m3 3 9 9", key: "rks13r" }],
  ["path", { d: "M3 9V3h6", key: "ira0h2" }]
], SYe = y("SquareArrowOutUpLeft", AYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LYe = [
  ["path", { d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6", key: "y09zxi" }],
  ["path", { d: "m21 3-9 9", key: "mpx6sq" }],
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }]
], TYe = y("SquareArrowOutUpRight", LYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
], jYe = y("SquareArrowRight", EYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8h8", key: "19xb1h" }],
  ["path", { d: "M16 16 8 8", key: "1qdy8n" }]
], DYe = y("SquareArrowUpLeft", NYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 8h8v8", key: "b65dnt" }],
  ["path", { d: "m8 16 8-8", key: "13b9ih" }]
], PYe = y("SquareArrowUpRight", IYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
], RYe = y("SquareArrowUp", zYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8.5 14 7-4", key: "12hpby" }],
  ["path", { d: "m8.5 10 7 4", key: "wwy2dy" }]
], BYe = y("SquareAsterisk", OYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HYe = [
  [
    "path",
    { d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2", key: "1vzg26" }
  ],
  ["path", { d: "M10 22H8", key: "euku7a" }],
  ["path", { d: "M16 22h-2", key: "18d249" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
], FYe = y("SquareBottomDashedScissors", HYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Ye = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 8h7", key: "kbo1nt" }],
  ["path", { d: "M8 12h6", key: "ikassy" }],
  ["path", { d: "M11 16h5", key: "oq65wt" }]
], VYe = y("SquareChartGantt", _Ye);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qYe = [
  ["path", { d: "M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5", key: "1uzm8b" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], UYe = y("SquareCheckBig", qYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], ZYe = y("SquareCheck", WYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
], YYe = y("SquareChevronDown", GYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
], $Ye = y("SquareChevronLeft", KYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
], QYe = y("SquareChevronRight", JYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XYe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
], eKe = y("SquareChevronUp", XYe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tKe = [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], nKe = y("SquareCode", tKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rKe = [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }]
], iKe = y("SquareDashedBottomCode", rKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aKe = [
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }]
], oKe = y("SquareDashedBottom", aKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sKe = [
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }]
], lKe = y("SquareDashedKanban", sKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cKe = [
  [
    "path",
    {
      d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
      key: "xwnzip"
    }
  ],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h2", key: "1qve2z" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v2", key: "p14lih" }],
  ["path", { d: "M3 14v1", key: "vnatye" }]
], uKe = y("SquareDashedMousePointer", cKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dKe = [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }]
], fKe = y("SquareDashed", dKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }]
], pKe = y("SquareDivide", hKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], yKe = y("SquareDot", mKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }]
], vKe = y("SquareEqual", gKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3", key: "m1af9g" }],
  ["path", { d: "M9 11.2h5.7", key: "3zgcl2" }]
], wKe = y("SquareFunction", bKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }]
], xKe = y("SquareKanban", kKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7v10", key: "d5nglc" }],
  ["path", { d: "M11 7v10", key: "pptsnr" }],
  ["path", { d: "m15 7 2 10", key: "1m7qm5" }]
], CKe = y("SquareLibrary", MKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8l4 4 4-4v8", key: "141u4e" }]
], SKe = y("SquareM", AKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 8h10", key: "1jw688" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
], TKe = y("SquareMenu", LKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], jKe = y("SquareMinus", EKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NKe = [
  [
    "path",
    {
      d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
      key: "xwnzip"
    }
  ],
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }]
], DKe = y("SquareMousePointer", NKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IKe = [
  ["path", { d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41", key: "9l1ft6" }],
  ["path", { d: "M3 8.7V19a2 2 0 0 0 2 2h10.3", key: "17knke" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.3", key: "1jxgo2" }]
], PKe = y("SquareParkingOff", IKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
], RKe = y("SquareParking", zKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OKe = [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  [
    "path",
    {
      d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
      key: "ohrbg2"
    }
  ]
], BKe = y("SquarePen", OKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
], FKe = y("SquarePercent", HKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Ke = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h10", key: "udp07y" }],
  ["path", { d: "M10 7v10", key: "i1d9ee" }],
  ["path", { d: "M16 17a2 2 0 0 1-2-2V7", key: "ftwdc7" }]
], VKe = y("SquarePi", _Ke);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17", key: "1l9586" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M16 7v10", key: "lavkr4" }]
], UKe = y("SquarePilcrow", qKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 8 6 4-6 4Z", key: "f1r3lt" }]
], ZKe = y("SquarePlay", WKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GKe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], YKe = y("SquarePlus", GKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KKe = [
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005", key: "1pek45" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
], $Ke = y("SquarePower", KKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JKe = [
  ["path", { d: "M7 12h2l2 5 2-10h4", key: "1fxv6h" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
], QKe = y("SquareRadical", JKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XKe = [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "2", key: "1btzen" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
], e$e = y("SquareScissors", XKe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t$e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M16 8.9V7H8l4 5-4 5h8v-1.9", key: "9nih0i" }]
], n$e = y("SquareSigma", t$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r$e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
], i$e = y("SquareSlash", r$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a$e = [
  ["path", { d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3", key: "lubmu8" }],
  ["path", { d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3", key: "1ag34g" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
], o$e = y("SquareSplitHorizontal", a$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s$e = [
  ["path", { d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3", key: "1pi83i" }],
  ["path", { d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3", key: "ido5k7" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
], l$e = y("SquareSplitVertical", s$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c$e = [
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }],
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "1", key: "z9xiuo" }]
], u$e = y("SquareSquare", c$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d$e = [
  ["path", { d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "4i38lg" }],
  ["path", { d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "mlte4a" }],
  ["rect", { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" }]
], f$e = y("SquareStack", d$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h$e = [
  ["path", { d: "m7 11 2-2-2-2", key: "1lz0vl" }],
  ["path", { d: "M11 13h4", key: "1p7l4v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }]
], p$e = y("SquareTerminal", h$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m$e = [
  ["path", { d: "M18 21a6 6 0 0 0-12 0", key: "kaz2du" }],
  ["circle", { cx: "12", cy: "11", r: "4", key: "1gt34v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], y$e = y("SquareUserRound", m$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g$e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1m6ac2" }]
], v$e = y("SquareUser", g$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b$e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], w$e = y("SquareX", b$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k$e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], x$e = y("Square", k$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M$e = [
  ["path", { d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9-9-1.8-9-9 1.8-9 9-9", key: "garfkc" }]
], C$e = y("Squircle", M$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A$e = [
  ["path", { d: "M15.236 22a3 3 0 0 0-2.2-5", key: "21bitc" }],
  ["path", { d: "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4", key: "oh0fg0" }],
  ["path", { d: "M18 13h.01", key: "9veqaj" }],
  [
    "path",
    {
      d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10",
      key: "980v8a"
    }
  ]
], S$e = y("Squirrel", A$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L$e = [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  [
    "path",
    {
      d: "M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z",
      key: "1sy9ra"
    }
  ],
  [
    "path",
    { d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1-3 3s1 2 1 3.5V13", key: "cnxgux" }
  ]
], T$e = y("Stamp", L$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E$e = [
  [
    "path",
    {
      d: "M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2",
      key: "2ksp49"
    }
  ]
], j$e = y("StarHalf", E$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N$e = [
  ["path", { d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43", key: "16m0ql" }],
  ["path", { d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91", key: "1vt8nq" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], D$e = y("StarOff", N$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I$e = [
  [
    "path",
    {
      d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
      key: "r04s7s"
    }
  ]
], P$e = y("Star", I$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z$e = [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["polygon", { points: "14,20 4,12 14,4", key: "ypakod" }]
], R$e = y("StepBack", z$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O$e = [
  ["line", { x1: "6", x2: "6", y1: "4", y2: "20", key: "fy8qot" }],
  ["polygon", { points: "10,4 20,12 10,20", key: "1mc1pf" }]
], B$e = y("StepForward", O$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H$e = [
  ["path", { d: "M11 2v2", key: "1539x4" }],
  ["path", { d: "M5 2v2", key: "1yf1q8" }],
  ["path", { d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1", key: "rb5t3r" }],
  ["path", { d: "M8 15a6 6 0 0 0 12 0v-3", key: "x18d4x" }],
  ["circle", { cx: "20", cy: "10", r: "2", key: "ts1r5v" }]
], F$e = y("Stethoscope", H$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _$e = [
  [
    "path",
    { d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z", key: "1wis1t" }
  ],
  ["path", { d: "M14 3v4a2 2 0 0 0 2 2h4", key: "36rjfy" }],
  ["path", { d: "M8 13h.01", key: "1sbv64" }],
  ["path", { d: "M16 13h.01", key: "wip0gl" }],
  ["path", { d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1", key: "1vvgv3" }]
], V$e = y("Sticker", _$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q$e = [
  ["path", { d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z", key: "qazsjp" }],
  ["path", { d: "M15 3v4a2 2 0 0 0 2 2h4", key: "40519r" }]
], U$e = y("StickyNote", q$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W$e = [
  ["path", { d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7", key: "ztvudi" }],
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["path", { d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4", key: "2ebpfo" }],
  ["path", { d: "M2 7h20", key: "1fcdvo" }],
  [
    "path",
    {
      d: "M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7",
      key: "6c3vgh"
    }
  ]
], Z$e = y("Store", W$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G$e = [
  ["rect", { width: "20", height: "6", x: "2", y: "4", rx: "2", key: "qdearl" }],
  ["rect", { width: "20", height: "6", x: "2", y: "14", rx: "2", key: "1xrn6j" }]
], Y$e = y("StretchHorizontal", G$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K$e = [
  ["rect", { width: "6", height: "20", x: "4", y: "2", rx: "2", key: "19qu7m" }],
  ["rect", { width: "6", height: "20", x: "14", y: "2", rx: "2", key: "24v0nk" }]
], $$e = y("StretchVertical", K$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J$e = [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4", key: "43sutm" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6", key: "nlfj13" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
], Q$e = y("Strikethrough", J$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X$e = [
  ["path", { d: "m4 5 8 8", key: "1eunvl" }],
  ["path", { d: "m12 5-8 8", key: "1ah0jp" }],
  [
    "path",
    {
      d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07",
      key: "e8ta8j"
    }
  ]
], eJe = y("Subscript", X$e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tJe = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M20 12h.01", key: "1ykeid" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M4 12h.01", key: "158zrr" }],
  ["path", { d: "M17.657 6.343h.01", key: "31pqzk" }],
  ["path", { d: "M17.657 17.657h.01", key: "jehnf4" }],
  ["path", { d: "M6.343 17.657h.01", key: "gdk6ow" }],
  ["path", { d: "M6.343 6.343h.01", key: "1uurf0" }]
], nJe = y("SunDim", tJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rJe = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 3v1", key: "1asbbs" }],
  ["path", { d: "M12 20v1", key: "1wcdkc" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M20 12h1", key: "1vloll" }],
  ["path", { d: "m18.364 5.636-.707.707", key: "1hakh0" }],
  ["path", { d: "m6.343 17.657-.707.707", key: "18m9nf" }],
  ["path", { d: "m5.636 5.636.707.707", key: "1xv1c5" }],
  ["path", { d: "m17.657 17.657.707.707", key: "vl76zb" }]
], iJe = y("SunMedium", rJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aJe = [
  ["path", { d: "M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4", key: "1fu5g2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.9 4.9 1.4 1.4", key: "b9915j" }],
  ["path", { d: "m17.7 17.7 1.4 1.4", key: "qc3ed3" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.3 17.7-1.4 1.4", key: "5gca6" }],
  ["path", { d: "m19.1 4.9-1.4 1.4", key: "wpu9u6" }]
], oJe = y("SunMoon", aJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sJe = [
  ["path", { d: "M10 21v-1", key: "1u8rkd" }],
  ["path", { d: "M10 4V3", key: "pkzwkn" }],
  ["path", { d: "M10 9a3 3 0 0 0 0 6", key: "gv75dk" }],
  ["path", { d: "m14 20 1.25-2.5L18 18", key: "1chtki" }],
  ["path", { d: "m14 4 1.25 2.5L18 6", key: "1b4wsy" }],
  ["path", { d: "m17 21-3-6 1.5-3H22", key: "o5qa3v" }],
  ["path", { d: "m17 3-3 6 1.5 3", key: "11697g" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "m20 10-1.5 2 1.5 2", key: "1swlpi" }],
  ["path", { d: "m3.64 18.36.7-.7", key: "105rm9" }],
  ["path", { d: "m4.34 6.34-.7-.7", key: "d3unjp" }]
], lJe = y("SunSnow", sJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cJe = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
], uJe = y("Sun", cJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dJe = [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
], fJe = y("Sunrise", dJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hJe = [
  ["path", { d: "M12 10V2", key: "16sf7g" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
], pJe = y("Sunset", hJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mJe = [
  ["path", { d: "m4 19 8-8", key: "hr47gm" }],
  ["path", { d: "m12 19-8-8", key: "1dhhmo" }],
  [
    "path",
    {
      d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06",
      key: "1dfcux"
    }
  ]
], yJe = y("Superscript", mJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gJe = [
  ["path", { d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z", key: "1ldrpk" }],
  ["path", { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7", key: "11i5po" }],
  ["path", { d: "M 7 17h.01", key: "1euzgo" }],
  [
    "path",
    {
      d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8",
      key: "o2gii7"
    }
  ]
], vJe = y("SwatchBook", gJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bJe = [
  ["path", { d: "M10 21V3h8", key: "br2l0g" }],
  ["path", { d: "M6 16h9", key: "2py0wn" }],
  ["path", { d: "M10 9.5h7", key: "13dmhz" }]
], wJe = y("SwissFranc", bJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kJe = [
  ["path", { d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5", key: "mtk2lu" }],
  ["path", { d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5", key: "120jsl" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m18 22-3-3 3-3", key: "kgdoj7" }],
  ["path", { d: "m6 2 3 3-3 3", key: "1fnbkv" }]
], xJe = y("SwitchCamera", kJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MJe = [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }]
], CJe = y("Sword", MJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AJe = [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }],
  ["polyline", { points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5", key: "hbey2j" }],
  ["line", { x1: "5", x2: "9", y1: "14", y2: "18", key: "1hf58s" }],
  ["line", { x1: "7", x2: "4", y1: "17", y2: "20", key: "pidxm4" }],
  ["line", { x1: "3", x2: "5", y1: "19", y2: "21", key: "1pehsh" }]
], SJe = y("Swords", AJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LJe = [
  ["path", { d: "m18 2 4 4", key: "22kx64" }],
  ["path", { d: "m17 7 3-3", key: "1w1zoj" }],
  ["path", { d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5", key: "1exhtz" }],
  ["path", { d: "m9 11 4 4", key: "rovt3i" }],
  ["path", { d: "m5 19-3 3", key: "59f2uf" }],
  ["path", { d: "m14 4 6 6", key: "yqp9t2" }]
], TJe = y("Syringe", LJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EJe = [
  [
    "path",
    {
      d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
      key: "gugj83"
    }
  ]
], jJe = y("Table2", EJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NJe = [
  ["path", { d: "M12 21v-6", key: "lihzve" }],
  ["path", { d: "M12 9V3", key: "da5inc" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], DJe = y("TableCellsMerge", NJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IJe = [
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], PJe = y("TableCellsSplit", IJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zJe = [
  ["path", { d: "M14 14v2", key: "w2a1xv" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  ["path", { d: "M14 8v2", key: "i67w9a" }],
  ["path", { d: "M2 15h8", key: "82wtch" }],
  ["path", { d: "M2 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2", key: "up0l64" }],
  ["path", { d: "M2 9h8", key: "yelfik" }],
  ["path", { d: "M22 15h-4", key: "1es58f" }],
  ["path", { d: "M22 3h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2", key: "pdjoqf" }],
  ["path", { d: "M22 9h-4", key: "1luja7" }],
  ["path", { d: "M5 3v18", key: "14hmio" }]
], RJe = y("TableColumnsSplit", zJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OJe = [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M21 12h.01", key: "msek7k" }],
  ["path", { d: "M21 18h.01", key: "1e8rq1" }],
  ["path", { d: "M21 6h.01", key: "1koanj" }]
], BJe = y("TableOfContents", OJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HJe = [
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
], FJe = y("TableProperties", HJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Je = [
  ["path", { d: "M14 10h2", key: "1lstlu" }],
  ["path", { d: "M15 22v-8", key: "1fwwgm" }],
  ["path", { d: "M15 2v4", key: "1044rn" }],
  ["path", { d: "M2 10h2", key: "1r8dkt" }],
  ["path", { d: "M20 10h2", key: "1ug425" }],
  ["path", { d: "M3 19h18", key: "awlh7x" }],
  ["path", { d: "M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6", key: "ibqhof" }],
  ["path", { d: "M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2", key: "1uenja" }],
  ["path", { d: "M8 10h2", key: "66od0" }],
  ["path", { d: "M9 22v-8", key: "fmnu31" }],
  ["path", { d: "M9 2v4", key: "j1yeou" }]
], VJe = y("TableRowsSplit", _Je);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qJe = [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
], UJe = y("Table", qJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WJe = [
  ["rect", { width: "10", height: "14", x: "3", y: "8", rx: "2", key: "1vrsiq" }],
  ["path", { d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4", key: "1j4zmg" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
], ZJe = y("TabletSmartphone", WJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GJe = [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["line", { x1: "12", x2: "12.01", y1: "18", y2: "18", key: "1dp563" }]
], YJe = y("Tablet", GJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KJe = [
  ["circle", { cx: "7", cy: "7", r: "5", key: "x29byf" }],
  ["circle", { cx: "17", cy: "17", r: "5", key: "1op1d2" }],
  ["path", { d: "M12 17h10", key: "ls21zv" }],
  ["path", { d: "m3.46 10.54 7.08-7.08", key: "1rehiu" }]
], $Je = y("Tablets", KJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JJe = [
  [
    "path",
    {
      d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
      key: "vktsd0"
    }
  ],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }]
], QJe = y("Tag", JJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XJe = [
  ["path", { d: "m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19", key: "1cbfv1" }],
  [
    "path",
    {
      d: "M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z",
      key: "135mg7"
    }
  ],
  ["circle", { cx: "6.5", cy: "9.5", r: ".5", fill: "currentColor", key: "5pm5xn" }]
], eQe = y("Tags", XJe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tQe = [["path", { d: "M4 4v16", key: "6qkkli" }]], nQe = y("Tally1", tQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rQe = [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }]
], iQe = y("Tally2", rQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aQe = [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }]
], oQe = y("Tally3", aQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sQe = [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }]
], lQe = y("Tally4", sQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cQe = [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }],
  ["path", { d: "M22 6 2 18", key: "h9moai" }]
], uQe = y("Tally5", cQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dQe = [
  ["circle", { cx: "17", cy: "4", r: "2", key: "y5j2s2" }],
  ["path", { d: "M15.59 5.41 5.41 15.59", key: "l0vprr" }],
  ["circle", { cx: "4", cy: "17", r: "2", key: "9p4efm" }],
  ["path", { d: "M12 22s-4-9-1.5-11.5S22 12 22 12", key: "1twk4o" }]
], fQe = y("Tangent", dQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hQe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
], pQe = y("Target", hQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mQe = [
  [
    "path",
    {
      d: "m10.065 12.493-6.18 1.318a.934.934 0 0 1-1.108-.702l-.537-2.15a1.07 1.07 0 0 1 .691-1.265l13.504-4.44",
      key: "k4qptu"
    }
  ],
  ["path", { d: "m13.56 11.747 4.332-.924", key: "19l80z" }],
  ["path", { d: "m16 21-3.105-6.21", key: "7oh9d" }],
  [
    "path",
    {
      d: "M16.485 5.94a2 2 0 0 1 1.455-2.425l1.09-.272a1 1 0 0 1 1.212.727l1.515 6.06a1 1 0 0 1-.727 1.213l-1.09.272a2 2 0 0 1-2.425-1.455z",
      key: "m7xp4m"
    }
  ],
  ["path", { d: "m6.158 8.633 1.114 4.456", key: "74o979" }],
  ["path", { d: "m8 21 3.105-6.21", key: "1fvxut" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
], yQe = y("Telescope", mQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gQe = [
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }],
  ["path", { d: "m14 5 3-3 3 3", key: "1sorif" }],
  ["path", { d: "m14 10 3-3 3 3", key: "1jyi9h" }],
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  ["path", { d: "M17 14H7l-5 8h20Z", key: "13ar7p" }],
  ["path", { d: "M8 14v8", key: "1ghmqk" }],
  ["path", { d: "m9 14 5 8", key: "13pgi6" }]
], vQe = y("TentTree", gQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bQe = [
  ["path", { d: "M3.5 21 14 3", key: "1szst5" }],
  ["path", { d: "M20.5 21 10 3", key: "1310c3" }],
  ["path", { d: "M15.5 21 12 15l-3.5 6", key: "1ddtfw" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }]
], wQe = y("Tent", bQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kQe = [
  ["polyline", { points: "4 17 10 11 4 5", key: "akl6gq" }],
  ["line", { x1: "12", x2: "20", y1: "19", y2: "19", key: "q2wloq" }]
], xQe = y("Terminal", kQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MQe = [
  [
    "path",
    { d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01a2.83 2.83 0 0 1 0-4L17 3", key: "1ub6xw" }
  ],
  ["path", { d: "m16 2 6 6", key: "1gw87d" }],
  ["path", { d: "M12 16H4", key: "1cjfip" }]
], CQe = y("TestTubeDiagonal", MQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AQe = [
  ["path", { d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5V2", key: "125lnx" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14.5 16h-5", key: "1ox875" }]
], SQe = y("TestTube", AQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LQe = [
  ["path", { d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22A2.5 2.5 0 0 1 4 19.5V2", key: "1hjrqt" }],
  ["path", { d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5V2", key: "16lc8n" }],
  ["path", { d: "M3 2h7", key: "7s29d5" }],
  ["path", { d: "M14 2h7", key: "7sicin" }],
  ["path", { d: "M9 16H4", key: "1bfye3" }],
  ["path", { d: "M20 16h-5", key: "ddnjpe" }]
], TQe = y("TestTubes", LQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EQe = [
  ["path", { d: "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1", key: "18xjzo" }],
  ["path", { d: "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5", key: "fj48gi" }],
  ["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1", key: "1n9rhb" }],
  ["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7", key: "13ksps" }],
  ["path", { d: "M9 7v10", key: "1vc8ob" }]
], jQe = y("TextCursorInput", EQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NQe = [
  ["path", { d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1", key: "uvaxm9" }],
  ["path", { d: "M7 22h1a4 4 0 0 0 4-4v-1", key: "11xy8d" }],
  ["path", { d: "M7 2h1a4 4 0 0 1 4 4v1", key: "1uw06m" }]
], DQe = y("TextCursor", NQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IQe = [
  ["path", { d: "M17 6H3", key: "16j9eg" }],
  ["path", { d: "M21 12H8", key: "scolzb" }],
  ["path", { d: "M21 18H8", key: "1wfozv" }],
  ["path", { d: "M3 12v6", key: "fv4c87" }]
], PQe = y("TextQuote", IQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zQe = [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M10 12H3", key: "1ulcyk" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["circle", { cx: "17", cy: "15", r: "3", key: "1upz2a" }],
  ["path", { d: "m21 19-1.9-1.9", key: "dwi7p8" }]
], RQe = y("TextSearch", zQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OQe = [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["line", { x1: "7", x2: "15", y1: "8", y2: "8", key: "1758g8" }],
  ["line", { x1: "7", x2: "17", y1: "12", y2: "12", key: "197423" }],
  ["line", { x1: "7", x2: "13", y1: "16", y2: "16", key: "37cgm6" }]
], BQe = y("TextSelect", OQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HQe = [
  ["path", { d: "M17 6.1H3", key: "wptmhv" }],
  ["path", { d: "M21 12.1H3", key: "1j38uz" }],
  ["path", { d: "M15.1 18H3", key: "1nb16a" }]
], FQe = y("Text", HQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Qe = [
  ["path", { d: "M2 10s3-3 3-8", key: "3xiif0" }],
  ["path", { d: "M22 10s-3-3-3-8", key: "ioaa5q" }],
  ["path", { d: "M10 2c0 4.4-3.6 8-8 8", key: "16fkpi" }],
  ["path", { d: "M14 2c0 4.4 3.6 8 8 8", key: "b9eulq" }],
  ["path", { d: "M2 10s2 2 2 5", key: "1au1lb" }],
  ["path", { d: "M22 10s-2 2-2 5", key: "qi2y5e" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "1vsc2m" }],
  ["path", { d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "hrha4u" }]
], VQe = y("Theater", _Qe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qQe = [
  ["path", { d: "m10 20-1.25-2.5L6 18", key: "18frcb" }],
  ["path", { d: "M10 4 8.75 6.5 6 6", key: "7mghy3" }],
  ["path", { d: "M10.585 15H10", key: "4nqulp" }],
  ["path", { d: "M2 12h6.5L10 9", key: "kv9z4n" }],
  ["path", { d: "M20 14.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z", key: "yu0u2z" }],
  ["path", { d: "m4 10 1.5 2L4 14", key: "k9enpj" }],
  ["path", { d: "m7 21 3-6-1.5-3", key: "j8hb9u" }],
  ["path", { d: "m7 3 3 6h2", key: "1bbqgq" }]
], UQe = y("ThermometerSnowflake", qQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WQe = [
  ["path", { d: "M12 9a4 4 0 0 0-2 7.5", key: "1jvsq6" }],
  ["path", { d: "M12 3v2", key: "1w22ol" }],
  ["path", { d: "m6.6 18.4-1.4 1.4", key: "w2yidj" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }],
  ["path", { d: "M4 13H2", key: "118le4" }],
  ["path", { d: "M6.34 7.34 4.93 5.93", key: "1brd51" }]
], ZQe = y("ThermometerSun", WQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GQe = [
  ["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "17jzev" }]
], YQe = y("Thermometer", GQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KQe = [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ]
], $Qe = y("ThumbsDown", KQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JQe = [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ]
], QQe = y("ThumbsUp", JQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XQe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], eXe = y("TicketCheck", XQe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tXe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
], nXe = y("TicketMinus", tXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rXe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "1l48ns"
    }
  ],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
], iXe = y("TicketPercent", rXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aXe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
], oXe = y("TicketPlus", aXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sXe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }]
], lXe = y("TicketSlash", sXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cXe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
], uXe = y("TicketX", cXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dXe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M13 5v2", key: "dyzc3o" }],
  ["path", { d: "M13 17v2", key: "1ont0d" }],
  ["path", { d: "M13 11v2", key: "1wjjxi" }]
], fXe = y("Ticket", dXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hXe = [
  ["path", { d: "M10.5 17h1.227a2 2 0 0 0 1.345-.52L18 12", key: "16muxl" }],
  ["path", { d: "m12 13.5 3.75.5", key: "1i9qhk" }],
  ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8", key: "12lg5p" }],
  ["path", { d: "M6 10V8", key: "1y41hn" }],
  ["path", { d: "M6 14v1", key: "cao2tf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2", key: "p3bz5l" }]
], pXe = y("TicketsPlane", hXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mXe = [
  ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8", key: "12lg5p" }],
  ["path", { d: "M6 10V8", key: "1y41hn" }],
  ["path", { d: "M6 14v1", key: "cao2tf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2", key: "p3bz5l" }]
], yXe = y("Tickets", mXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gXe = [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7", key: "10he05" }],
  ["path", { d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2", key: "15f7sh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M12 12v-2", key: "fwoke6" }]
], vXe = y("TimerOff", gXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bXe = [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M12 14v-4", key: "1evpnu" }],
  ["path", { d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6", key: "1ts96g" }],
  ["path", { d: "M9 17H4v5", key: "8t5av" }]
], wXe = y("TimerReset", bXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kXe = [
  ["line", { x1: "10", x2: "14", y1: "2", y2: "2", key: "14vaq8" }],
  ["line", { x1: "12", x2: "15", y1: "14", y2: "11", key: "17fdiu" }],
  ["circle", { cx: "12", cy: "14", r: "8", key: "1e1u0o" }]
], xXe = y("Timer", kXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MXe = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "8", cy: "12", r: "2", key: "1nvbw3" }]
], CXe = y("ToggleLeft", MXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AXe = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }]
], SXe = y("ToggleRight", AXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LXe = [
  [
    "path",
    {
      d: "M7 12h13a1 1 0 0 1 1 1 5 5 0 0 1-5 5h-.598a.5.5 0 0 0-.424.765l1.544 2.47a.5.5 0 0 1-.424.765H5.402a.5.5 0 0 1-.424-.765L7 18",
      key: "kc4kqr"
    }
  ],
  ["path", { d: "M8 18a5 5 0 0 1-5-5V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8", key: "1tqs57" }]
], TXe = y("Toilet", LXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EXe = [
  ["path", { d: "M21 4H3", key: "1hwok0" }],
  ["path", { d: "M18 8H6", key: "41n648" }],
  ["path", { d: "M19 12H9", key: "1g4lpz" }],
  ["path", { d: "M16 16h-6", key: "1j5d54" }],
  ["path", { d: "M11 20H9", key: "39obr8" }]
], jXe = y("Tornado", EXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NXe = [
  ["ellipse", { cx: "12", cy: "11", rx: "3", ry: "2", key: "1b2qxu" }],
  ["ellipse", { cx: "12", cy: "12.5", rx: "10", ry: "8.5", key: "h8emeu" }]
], DXe = y("Torus", NXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IXe = [
  ["path", { d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16", key: "lnt0bk" }],
  ["path", { d: "M2 14h12", key: "d8icqz" }],
  ["path", { d: "M22 14h-2", key: "jrx26d" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M22 16V6a2 2 0 0 0-2-2H10", key: "11y8e4" }]
], PXe = y("TouchpadOff", IXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zXe = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }]
], RXe = y("Touchpad", zXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OXe = [
  [
    "path",
    { d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z", key: "1pledb" }
  ],
  ["path", { d: "M8 13v9", key: "hmv0ci" }],
  ["path", { d: "M16 22v-9", key: "ylnf1u" }],
  ["path", { d: "m9 6 1 7", key: "dpdgam" }],
  ["path", { d: "m15 6-1 7", key: "ls7zgu" }],
  ["path", { d: "M12 6V2", key: "1pj48d" }],
  ["path", { d: "M13 2h-2", key: "mj6ths" }]
], BXe = y("TowerControl", OXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HXe = [
  ["rect", { width: "18", height: "12", x: "3", y: "8", rx: "1", key: "158fvp" }],
  ["path", { d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3", key: "s0042v" }],
  ["path", { d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3", key: "9wmeh2" }]
], FXe = y("ToyBrick", HXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Xe = [
  ["path", { d: "m10 11 11 .9a1 1 0 0 1 .8 1.1l-.665 4.158a1 1 0 0 1-.988.842H20", key: "she1j9" }],
  ["path", { d: "M16 18h-5", key: "bq60fd" }],
  ["path", { d: "M18 5a1 1 0 0 0-1 1v5.573", key: "1kv8ia" }],
  ["path", { d: "M3 4h8.129a1 1 0 0 1 .99.863L13 11.246", key: "1q1ert" }],
  ["path", { d: "M4 11V4", key: "9ft8pt" }],
  ["path", { d: "M7 15h.01", key: "k5ht0j" }],
  ["path", { d: "M8 10.1V4", key: "1jgyzo" }],
  ["circle", { cx: "18", cy: "18", r: "2", key: "1emm8v" }],
  ["circle", { cx: "7", cy: "15", r: "5", key: "ddtuc" }]
], VXe = y("Tractor", _Xe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qXe = [
  ["path", { d: "M9.3 6.2a4.55 4.55 0 0 0 5.4 0", key: "flyxqv" }],
  ["path", { d: "M7.9 10.7c.9.8 2.4 1.3 4.1 1.3s3.2-.5 4.1-1.3", key: "1nlxxg" }],
  [
    "path",
    {
      d: "M13.9 3.5a1.93 1.93 0 0 0-3.8-.1l-3 10c-.1.2-.1.4-.1.6 0 1.7 2.2 3 5 3s5-1.3 5-3c0-.2 0-.4-.1-.5Z",
      key: "vz7x1l"
    }
  ],
  [
    "path",
    {
      d: "m7.5 12.2-4.7 2.7c-.5.3-.8.7-.8 1.1s.3.8.8 1.1l7.6 4.5c.9.5 2.1.5 3 0l7.6-4.5c.7-.3 1-.7 1-1.1s-.3-.8-.8-1.1l-4.7-2.8",
      key: "1xfzlw"
    }
  ]
], UXe = y("TrafficCone", qXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WXe = [
  ["path", { d: "M2 22V12a10 10 0 1 1 20 0v10", key: "o0fyp0" }],
  ["path", { d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8", key: "m8q3n9" }],
  ["path", { d: "M10 15h.01", key: "44in9x" }],
  ["path", { d: "M14 15h.01", key: "5mohn5" }],
  ["path", { d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z", key: "hckbmu" }],
  ["path", { d: "m9 19-2 3", key: "iij7hm" }],
  ["path", { d: "m15 19 2 3", key: "npx8sa" }]
], ZXe = y("TrainFrontTunnel", WXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GXe = [
  ["path", { d: "M8 3.1V7a4 4 0 0 0 8 0V3.1", key: "1v71zp" }],
  ["path", { d: "m9 15-1-1", key: "1yrq24" }],
  ["path", { d: "m15 15 1-1", key: "1t0d6s" }],
  ["path", { d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z", key: "1p0hjs" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m16 19 2 3", key: "xo31yx" }]
], YXe = y("TrainFront", GXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KXe = [
  ["path", { d: "M2 17 17 2", key: "18b09t" }],
  ["path", { d: "m2 14 8 8", key: "1gv9hu" }],
  ["path", { d: "m5 11 8 8", key: "189pqp" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "m11 5 8 8", key: "ummqn6" }],
  ["path", { d: "m14 2 8 8", key: "1vk7dn" }],
  ["path", { d: "M7 22 22 7", key: "15mb1i" }]
], $Xe = y("TrainTrack", KXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JXe = [
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M12 3v8", key: "1h2ygw" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m18 22-2-3", key: "1p0ohu" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }]
], QXe = y("TramFront", JXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XXe = [
  ["path", { d: "M12 16v6", key: "c8a4gj" }],
  ["path", { d: "M14 20h-4", key: "m8m19d" }],
  ["path", { d: "M18 2h4v4", key: "1341mj" }],
  ["path", { d: "m2 2 7.17 7.17", key: "13q8l2" }],
  ["path", { d: "M2 5.355V2h3.357", key: "18136r" }],
  ["path", { d: "m22 2-7.17 7.17", key: "1epvy4" }],
  ["path", { d: "M8 5 5 8", key: "mgbjhz" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
], eet = y("Transgender", XXe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tet = [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
], net = y("Trash2", tet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ret = [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }]
], iet = y("Trash", ret);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aet = [
  [
    "path",
    {
      d: "M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z",
      key: "oadzkq"
    }
  ],
  ["path", { d: "M12 19v3", key: "npa21l" }]
], oet = y("TreeDeciduous", aet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const set = [
  ["path", { d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4", key: "foxbe7" }],
  [
    "path",
    { d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3", key: "18arnh" }
  ],
  [
    "path",
    {
      d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35",
      key: "ywahnh"
    }
  ],
  ["path", { d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14", key: "ft0feo" }]
], cet = y("TreePalm", set);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uet = [
  [
    "path",
    {
      d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z",
      key: "cpyugq"
    }
  ],
  ["path", { d: "M12 22v-3", key: "kmzjlo" }]
], det = y("TreePine", uet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fet = [
  ["path", { d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z", key: "1l6gj6" }],
  ["path", { d: "M7 16v6", key: "1a82de" }],
  ["path", { d: "M13 19v3", key: "13sx9i" }],
  [
    "path",
    {
      d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
      key: "1sj9kv"
    }
  ]
], het = y("Trees", fet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pet = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["rect", { width: "3", height: "9", x: "7", y: "7", key: "14n3xi" }],
  ["rect", { width: "3", height: "5", x: "14", y: "7", key: "s4azjd" }]
], met = y("Trello", pet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yet = [
  ["polyline", { points: "22 17 13.5 8.5 8.5 13.5 2 7", key: "1r2t7k" }],
  ["polyline", { points: "16 17 22 17 22 11", key: "11uiuu" }]
], get = y("TrendingDown", yet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vet = [
  ["path", { d: "M14.828 14.828 21 21", key: "ar5fw7" }],
  ["path", { d: "M21 16v5h-5", key: "1ck2sf" }],
  ["path", { d: "m21 3-9 9-4-4-6 6", key: "1h02xo" }],
  ["path", { d: "M21 8V3h-5", key: "1qoq8a" }]
], bet = y("TrendingUpDown", vet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wet = [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
], ket = y("TrendingUp", wet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xet = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], Met = y("TriangleAlert", xet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cet = [
  ["path", { d: "M10.17 4.193a2 2 0 0 1 3.666.013", key: "pltmmw" }],
  ["path", { d: "M14 21h2", key: "v4qezv" }],
  ["path", { d: "m15.874 7.743 1 1.732", key: "10m0iw" }],
  ["path", { d: "m18.849 12.952 1 1.732", key: "zadnam" }],
  ["path", { d: "M21.824 18.18a2 2 0 0 1-1.835 2.824", key: "fvwuk4" }],
  ["path", { d: "M4.024 21a2 2 0 0 1-1.839-2.839", key: "1e1kah" }],
  ["path", { d: "m5.136 12.952-1 1.732", key: "1u4ldi" }],
  ["path", { d: "M8 21h2", key: "i9zjee" }],
  ["path", { d: "m8.102 7.743-1 1.732", key: "1zzo4u" }]
], Aet = y("TriangleDashed", Cet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Let = [
  [
    "path",
    {
      d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z",
      key: "183wce"
    }
  ]
], Tet = y("TriangleRight", Let);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eet = [
  [
    "path",
    { d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z", key: "14u9p9" }
  ]
], jet = y("Triangle", Eet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Net = [
  ["path", { d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6", key: "17hqa7" }],
  ["path", { d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18", key: "lmptdp" }],
  ["path", { d: "M4 22h16", key: "57wxv0" }],
  ["path", { d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22", key: "1nw9bq" }],
  ["path", { d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22", key: "1np0yb" }],
  ["path", { d: "M18 2H6v7a6 6 0 0 0 12 0V2Z", key: "u46fv3" }]
], Det = y("Trophy", Net);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iet = [
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  ["path", { d: "M15 18H9", key: "1lyqi6" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
      key: "lysw3i"
    }
  ],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
], Pet = y("Truck", Iet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zet = [
  [
    "path",
    {
      d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z",
      key: "1lbbv7"
    }
  ],
  ["path", { d: "M4.82 7.9 8 10", key: "m9wose" }],
  ["path", { d: "M15.18 7.9 12 10", key: "p8dp2u" }],
  ["path", { d: "M16.93 10H20a2 2 0 0 1 0 4H2", key: "12nsm7" }]
], Ret = y("Turtle", zet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oet = [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
], Bet = y("TvMinimalPlay", Oet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Het = [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
], Fet = y("TvMinimal", Het);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _et = [
  ["rect", { width: "20", height: "15", x: "2", y: "7", rx: "2", ry: "2", key: "10ag99" }],
  ["polyline", { points: "17 2 12 7 7 2", key: "11pgbg" }]
], Vet = y("Tv", _et);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qet = [
  ["path", { d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7", key: "c0yzno" }]
], Uet = y("Twitch", qet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wet = [
  [
    "path",
    {
      d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
      key: "pff0z6"
    }
  ]
], Zet = y("Twitter", Wet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Get = [
  [
    "path",
    {
      d: "M14 16.5a.5.5 0 0 0 .5.5h.5a2 2 0 0 1 0 4H9a2 2 0 0 1 0-4h.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V8a2 2 0 0 1-4 0V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 1-4 0v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z",
      key: "1reda3"
    }
  ]
], Yet = y("TypeOutline", Get);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ket = [
  ["polyline", { points: "4 7 4 4 20 4 20 7", key: "1nosan" }],
  ["line", { x1: "9", x2: "15", y1: "20", y2: "20", key: "swin9y" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
], $et = y("Type", Ket);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jet = [
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "M15.5 21a1.85 1.85 0 0 1-3.5-1v-8H2a10 10 0 0 1 3.428-6.575", key: "eki10q" }],
  ["path", { d: "M17.5 12H22A10 10 0 0 0 9.004 3.455", key: "n2ayka" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Qet = y("UmbrellaOff", Jet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xet = [
  ["path", { d: "M22 12a10.06 10.06 1 0 0-20 0Z", key: "1teyop" }],
  ["path", { d: "M12 12v8a2 2 0 0 0 4 0", key: "ulpmoc" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }]
], ett = y("Umbrella", Xet);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ttt = [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }]
], ntt = y("Underline", ttt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rtt = [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
], itt = y("Undo2", rtt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const att = [
  ["path", { d: "M21 17a9 9 0 0 0-15-6.7L3 13", key: "8mp6z9" }],
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }]
], ott = y("UndoDot", att);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const stt = [
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }]
], ltt = y("Undo", stt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ctt = [
  ["path", { d: "M16 12h6", key: "15xry1" }],
  ["path", { d: "M8 12H2", key: "1jqql6" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 15 3-3-3-3", key: "wjy7rq" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }]
], utt = y("UnfoldHorizontal", ctt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dtt = [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m15 5-3-3-3 3", key: "itvq4r" }]
], ftt = y("UnfoldVertical", dtt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const htt = [
  ["rect", { width: "8", height: "6", x: "5", y: "4", rx: "1", key: "nzclkv" }],
  ["rect", { width: "8", height: "6", x: "11", y: "14", rx: "1", key: "4tytwb" }]
], ptt = y("Ungroup", htt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mtt = [
  ["circle", { cx: "12", cy: "10", r: "1", key: "1gnqs8" }],
  ["path", { d: "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2", key: "1qj5sn" }],
  ["path", { d: "M6 17v.01", key: "roodi6" }],
  ["path", { d: "M6 13v.01", key: "67c122" }],
  ["path", { d: "M18 17v.01", key: "12ktxm" }],
  ["path", { d: "M18 13v.01", key: "tn1rt1" }],
  ["path", { d: "M14 22v-5a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "11g7fi" }]
], ytt = y("University", mtt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gtt = [
  ["path", { d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2", key: "1re2ne" }]
], vtt = y("Unlink2", gtt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const btt = [
  [
    "path",
    {
      d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
      key: "yqzxt4"
    }
  ],
  [
    "path",
    {
      d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
      key: "4qinb0"
    }
  ],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "5", key: "1041cp" }],
  ["line", { x1: "2", x2: "5", y1: "8", y2: "8", key: "14m1p5" }],
  ["line", { x1: "16", x2: "16", y1: "19", y2: "22", key: "rzdirn" }],
  ["line", { x1: "19", x2: "22", y1: "16", y2: "16", key: "ox905f" }]
], wtt = y("Unlink", btt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ktt = [
  ["path", { d: "m19 5 3-3", key: "yk6iyv" }],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  [
    "path",
    { d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z", key: "1snsnr" }
  ]
], xtt = y("Unplug", ktt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mtt = [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
], Ctt = y("Upload", Mtt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Att = [
  ["circle", { cx: "10", cy: "7", r: "1", key: "dypaad" }],
  ["circle", { cx: "4", cy: "20", r: "1", key: "22iqad" }],
  ["path", { d: "M4.7 19.3 19 5", key: "1enqfc" }],
  ["path", { d: "m21 3-3 1 2 2Z", key: "d3ov82" }],
  ["path", { d: "M9.26 7.68 5 12l2 5", key: "1esawj" }],
  ["path", { d: "m10 14 5 2 3.5-3.5", key: "v8oal5" }],
  ["path", { d: "m18 12 1-1 1 1-1 1Z", key: "1bh22v" }]
], Stt = y("Usb", Att);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ltt = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["polyline", { points: "16 11 18 13 22 9", key: "1pwet4" }]
], Ttt = y("UserCheck", Ltt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ett = [
  ["circle", { cx: "18", cy: "15", r: "3", key: "gjjjvw" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M10 15H6a4 4 0 0 0-4 4v2", key: "1nfge6" }],
  ["path", { d: "m21.7 16.4-.9-.3", key: "12j9ji" }],
  ["path", { d: "m15.2 13.9-.9-.3", key: "1fdjdi" }],
  ["path", { d: "m16.6 18.7.3-.9", key: "heedtr" }],
  ["path", { d: "m19.1 12.2.3-.9", key: "1af3ki" }],
  ["path", { d: "m19.6 18.7-.4-1", key: "1x9vze" }],
  ["path", { d: "m16.8 12.3-.4-1", key: "vqeiwj" }],
  ["path", { d: "m14.3 16.6 1-.4", key: "1qlj63" }],
  ["path", { d: "m20.7 13.8 1-.4", key: "1v5t8k" }]
], jtt = y("UserCog", Ett);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ntt = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
], Dtt = y("UserMinus", Ntt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Itt = [
  ["path", { d: "M11.5 15H7a4 4 0 0 0-4 4v2", key: "15lzij" }],
  [
    "path",
    {
      d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1817ys"
    }
  ],
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }]
], Ptt = y("UserPen", Itt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ztt = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
], Rtt = y("UserPlus", ztt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ott = [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
], Btt = y("UserRoundCheck", Ott);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Htt = [
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }]
], Ftt = y("UserRoundCog", Htt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _tt = [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
], Vtt = y("UserRoundMinus", _tt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qtt = [
  ["path", { d: "M2 21a8 8 0 0 1 10.821-7.487", key: "1c8h7z" }],
  [
    "path",
    {
      d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1817ys"
    }
  ],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }]
], Utt = y("UserRoundPen", qtt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wtt = [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
], Ztt = y("UserRoundPlus", Wtt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gtt = [
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.9-1.9", key: "1e5ubv" }]
], Ytt = y("UserRoundSearch", Gtt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ktt = [
  ["path", { d: "M2 21a8 8 0 0 1 11.873-7", key: "74fkxq" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }],
  ["path", { d: "m22 17-5 5", key: "gqnmv0" }]
], $tt = y("UserRoundX", Ktt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jtt = [
  ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
  ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }]
], Qtt = y("UserRound", Jtt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xtt = [
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }],
  ["path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2", key: "3bnktk" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }]
], ent = y("UserSearch", Xtt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tnt = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "17", x2: "22", y1: "8", y2: "13", key: "3nzzx3" }],
  ["line", { x1: "22", x2: "17", y1: "8", y2: "13", key: "1swrse" }]
], nnt = y("UserX", tnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rnt = [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
], int = y("User", rnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ant = [
  ["path", { d: "M18 21a8 8 0 0 0-16 0", key: "3ypg7q" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3", key: "10s06x" }]
], ont = y("UsersRound", ant);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const snt = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
], lnt = y("Users", snt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cnt = [
  ["path", { d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8", key: "n7qcjb" }],
  [
    "path",
    { d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7", key: "d0u48b" }
  ],
  ["path", { d: "m2.1 21.8 6.4-6.3", key: "yn04lh" }],
  ["path", { d: "m19 5-7 7", key: "194lzd" }]
], unt = y("UtensilsCrossed", cnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dnt = [
  ["path", { d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2", key: "cjf0a3" }],
  ["path", { d: "M7 2v20", key: "1473qp" }],
  ["path", { d: "M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7", key: "j28e5" }]
], fnt = y("Utensils", dnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hnt = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M2 5h20", key: "1fs1ex" }],
  ["path", { d: "M3 3v2", key: "9imdir" }],
  ["path", { d: "M7 3v2", key: "n0os7" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["path", { d: "M21 3v2", key: "1duuac" }],
  ["path", { d: "m19 5-7 7-7-7", key: "133zxf" }]
], pnt = y("UtilityPole", hnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mnt = [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
], ynt = y("Variable", mnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gnt = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["path", { d: "m7.9 7.9 2.7 2.7", key: "hpeyl3" }],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }],
  ["path", { d: "m13.4 10.6 2.7-2.7", key: "264c1n" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["path", { d: "m7.9 16.1 2.7-2.7", key: "p81g5e" }],
  ["circle", { cx: "16.5", cy: "16.5", r: ".5", fill: "currentColor", key: "fubopw" }],
  ["path", { d: "m13.4 13.4 2.7 2.7", key: "abhel3" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
], vnt = y("Vault", gnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bnt = [
  ["path", { d: "M16 8q6 0 6-6-6 0-6 6", key: "qsyyc4" }],
  ["path", { d: "M17.41 3.59a10 10 0 1 0 3 3", key: "41m9h7" }],
  ["path", { d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14", key: "qiv7li" }]
], wnt = y("Vegan", bnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const knt = [
  ["path", { d: "M18 11c-1.5 0-2.5.5-3 2", key: "1fod00" }],
  [
    "path",
    {
      d: "M4 6a2 2 0 0 0-2 2v4a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-3a8 8 0 0 0-5 2 8 8 0 0 0-5-2z",
      key: "d70hit"
    }
  ],
  ["path", { d: "M6 11c1.5 0 2.5.5 3 2", key: "136fht" }]
], xnt = y("VenetianMask", knt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mnt = [
  ["path", { d: "M10 20h4", key: "ni2waw" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }],
  ["path", { d: "M17 2h4v4", key: "vhe59" }],
  ["path", { d: "m21 2-5.46 5.46", key: "19kypf" }],
  ["circle", { cx: "12", cy: "11", r: "5", key: "16gxyc" }]
], Cnt = y("VenusAndMars", Mnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ant = [
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  ["path", { d: "M9 19h6", key: "456am0" }],
  ["circle", { cx: "12", cy: "9", r: "6", key: "1nw4tq" }]
], Snt = y("Venus", Ant);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lnt = [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["path", { d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2", key: "1hbad5" }],
  ["path", { d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34", key: "1x5tf0" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], Tnt = y("VibrateOff", Lnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ent = [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["rect", { width: "8", height: "14", x: "8", y: "5", rx: "1", key: "1oyrl4" }]
], jnt = y("Vibrate", Ent);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nnt = [
  [
    "path",
    { d: "M10.66 6H14a2 2 0 0 1 2 2v2.5l5.248-3.062A.5.5 0 0 1 22 7.87v8.196", key: "w8jjjt" }
  ],
  ["path", { d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2", key: "1xawa7" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Dnt = y("VideoOff", Nnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Int = [
  [
    "path",
    {
      d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
      key: "ftymec"
    }
  ],
  ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
], Pnt = y("Video", Int);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const znt = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["circle", { cx: "8", cy: "14", r: "2", key: "1k2qr5" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "14", r: "2", key: "14k7lr" }]
], Rnt = y("Videotape", znt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ont = [
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2", key: "mrq65r" }],
  ["path", { d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2", key: "be3xqs" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
      key: "11ak4c"
    }
  ]
], Bnt = y("View", Ont);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hnt = [
  ["circle", { cx: "6", cy: "12", r: "4", key: "1ehtga" }],
  ["circle", { cx: "18", cy: "12", r: "4", key: "4vafl8" }],
  ["line", { x1: "6", x2: "18", y1: "16", y2: "16", key: "pmt8us" }]
], Fnt = y("Voicemail", Hnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _nt = [
  ["path", { d: "M11.1 7.1a16.55 16.55 0 0 1 10.9 4", key: "2880wi" }],
  ["path", { d: "M12 12a12.6 12.6 0 0 1-8.7 5", key: "113sja" }],
  ["path", { d: "M16.8 13.6a16.55 16.55 0 0 1-9 7.5", key: "1qmsgl" }],
  ["path", { d: "M20.7 17a12.8 12.8 0 0 0-8.7-5 13.3 13.3 0 0 1 0-10", key: "1bmeqp" }],
  ["path", { d: "M6.3 3.8a16.55 16.55 0 0 0 1.9 11.5", key: "iekzv9" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], Vnt = y("Volleyball", _nt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qnt = [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["path", { d: "M16 9a5 5 0 0 1 0 6", key: "1q6k2b" }]
], Unt = y("Volume1", qnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wnt = [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["path", { d: "M16 9a5 5 0 0 1 0 6", key: "1q6k2b" }],
  ["path", { d: "M19.364 18.364a9 9 0 0 0 0-12.728", key: "ijwkga" }]
], Znt = y("Volume2", Wnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gnt = [
  ["path", { d: "M16 9a5 5 0 0 1 .95 2.293", key: "1fgyg8" }],
  ["path", { d: "M19.364 5.636a9 9 0 0 1 1.889 9.96", key: "l3zxae" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11",
      key: "1gbwow"
    }
  ],
  ["path", { d: "M9.828 4.172A.686.686 0 0 1 11 4.657v.686", key: "s2je0y" }]
], Ynt = y("VolumeOff", Gnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Knt = [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["line", { x1: "22", x2: "16", y1: "9", y2: "15", key: "1ewh16" }],
  ["line", { x1: "16", x2: "22", y1: "9", y2: "15", key: "5ykzw1" }]
], $nt = y("VolumeX", Knt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jnt = [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ]
], Qnt = y("Volume", Jnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xnt = [
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ["path", { d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z", key: "1ezoue" }],
  ["path", { d: "M22 19H2", key: "nuriw5" }]
], ert = y("Vote", Xnt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const trt = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2", key: "4125el" }],
  [
    "path",
    {
      d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21",
      key: "1dpki6"
    }
  ]
], nrt = y("WalletCards", trt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rrt = [
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  [
    "path",
    {
      d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14",
      key: "u1rqew"
    }
  ]
], irt = y("WalletMinimal", rrt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const art = [
  [
    "path",
    {
      d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
      key: "18etb6"
    }
  ],
  ["path", { d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4", key: "xoc0q4" }]
], ort = y("Wallet", art);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const srt = [
  ["circle", { cx: "8", cy: "9", r: "2", key: "gjzl9d" }],
  [
    "path",
    {
      d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2",
      key: "69xh40"
    }
  ],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }]
], lrt = y("Wallpaper", srt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const crt = [
  [
    "path",
    {
      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
      key: "ul74o6"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M5 6v4", key: "ilb8ba" }],
  ["path", { d: "M19 14v4", key: "blhpug" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M7 8H3", key: "zfb6yr" }],
  ["path", { d: "M21 16h-4", key: "1cnmox" }],
  ["path", { d: "M11 3H9", key: "1obp7u" }]
], urt = y("WandSparkles", crt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const drt = [
  ["path", { d: "M15 4V2", key: "z1p9b7" }],
  ["path", { d: "M15 16v-2", key: "px0unx" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M17.8 11.8 19 13", key: "yihg8r" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M17.8 6.2 19 5", key: "fd4us0" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M12.2 6.2 11 5", key: "i3da3b" }]
], frt = y("Wand", drt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hrt = [
  [
    "path",
    {
      d: "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z",
      key: "gksnxg"
    }
  ],
  ["path", { d: "M6 18h12", key: "9pbo8z" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }],
  ["rect", { width: "12", height: "12", x: "6", y: "10", key: "apd30q" }]
], prt = y("Warehouse", hrt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mrt = [
  ["path", { d: "M3 6h3", key: "155dbl" }],
  ["path", { d: "M17 6h.01", key: "e2y6kg" }],
  ["rect", { width: "18", height: "20", x: "3", y: "2", rx: "2", key: "od3kk9" }],
  ["circle", { cx: "12", cy: "13", r: "5", key: "nlbqau" }],
  ["path", { d: "M12 18a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 1 0-5", key: "17lach" }]
], yrt = y("WashingMachine", mrt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const grt = [
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["polyline", { points: "12 10 12 12 13 13", key: "19dquz" }],
  [
    "path",
    { d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05", key: "18k57s" }
  ],
  ["path", { d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05", key: "16ny36" }]
], vrt = y("Watch", grt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const brt = [
  ["path", { d: "M19 5a2 2 0 0 0-2 2v11", key: "s41o68" }],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ],
  ["path", { d: "M7 13h10", key: "1rwob1" }],
  ["path", { d: "M7 9h10", key: "12czzb" }],
  ["path", { d: "M9 5a2 2 0 0 0-2 2v11", key: "x0q4gh" }]
], wrt = y("WavesLadder", brt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const krt = [
  [
    "path",
    {
      d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "knzxuh"
    }
  ],
  [
    "path",
    {
      d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "2jd2cc"
    }
  ],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ]
], xrt = y("Waves", krt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mrt = [
  ["circle", { cx: "12", cy: "4.5", r: "2.5", key: "r5ysbb" }],
  ["path", { d: "m10.2 6.3-3.9 3.9", key: "1nzqf6" }],
  ["circle", { cx: "4.5", cy: "12", r: "2.5", key: "jydg6v" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["circle", { cx: "19.5", cy: "12", r: "2.5", key: "1piiel" }],
  ["path", { d: "m13.8 17.7 3.9-3.9", key: "1wyg1y" }],
  ["circle", { cx: "12", cy: "19.5", r: "2.5", key: "13o1pw" }]
], Crt = y("Waypoints", Mrt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Art = [
  ["circle", { cx: "12", cy: "10", r: "8", key: "1gshiw" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 22h10", key: "10w4w3" }],
  ["path", { d: "M12 22v-4", key: "1utk9m" }]
], Srt = y("Webcam", Art);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lrt = [
  ["path", { d: "M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3 3 0 1 1 2.57 15", key: "1tvl6x" }],
  ["path", { d: "M9 3.4a4 4 0 0 1 6.52.66", key: "q04jfq" }],
  ["path", { d: "m6 17 3.1-5.8a2.5 2.5 0 0 0 .057-2.05", key: "azowf0" }],
  ["path", { d: "M20.3 20.3a4 4 0 0 1-2.3.7", key: "5joiws" }],
  ["path", { d: "M18.6 13a4 4 0 0 1 3.357 3.414", key: "cangb8" }],
  ["path", { d: "m12 6 .6 1", key: "tpjl1n" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Trt = y("WebhookOff", Lrt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ert = [
  [
    "path",
    {
      d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
      key: "q3hayz"
    }
  ],
  ["path", { d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06", key: "1go1hn" }],
  ["path", { d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8", key: "qlwsc0" }]
], jrt = y("Webhook", Ert);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nrt = [
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }],
  [
    "path",
    {
      d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z",
      key: "56o5sh"
    }
  ]
], Drt = y("Weight", Nrt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Irt = [
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "m16 8-1.17 1.17", key: "1qqm82" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    { d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97", key: "4wz8re" }
  ],
  [
    "path",
    { d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62", key: "rves66" }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98",
      key: "ak46r"
    }
  ],
  [
    "path",
    {
      d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28",
      key: "1tw520"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], Prt = y("WheatOff", Irt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zrt = [
  ["path", { d: "M2 22 16 8", key: "60hf96" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    {
      d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1sdzmb"
    }
  ],
  [
    "path",
    {
      d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "eoatbi"
    }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "2m8kc5"
    }
  ],
  [
    "path",
    {
      d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "vex3ng"
    }
  ]
], Rrt = y("Wheat", zrt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ort = [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }],
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
], Brt = y("WholeWord", Ort);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hrt = [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
], Frt = y("WifiHigh", Hrt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _rt = [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
], Vrt = y("WifiLow", _rt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qrt = [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 5.17-2.69", key: "1dl1wf" }],
  ["path", { d: "M19 12.859a10 10 0 0 0-2.007-1.523", key: "4k23kn" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 4.177-2.643", key: "1grhjp" }],
  ["path", { d: "M22 8.82a15 15 0 0 0-11.288-3.764", key: "z3jwby" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Urt = y("WifiOff", qrt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wrt = [["path", { d: "M12 20h.01", key: "zekei9" }]], Zrt = y("WifiZero", Wrt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Grt = [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 20 0", key: "dnpr2z" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
], Yrt = y("Wifi", Grt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Krt = [
  ["path", { d: "M10 2v8", key: "d4bbey" }],
  ["path", { d: "M12.8 21.6A2 2 0 1 0 14 18H2", key: "19kp1d" }],
  ["path", { d: "M17.5 10a2.5 2.5 0 1 1 2 4H2", key: "19kpjc" }],
  ["path", { d: "m6 6 4 4 4-4", key: "k13n16" }]
], $rt = y("WindArrowDown", Krt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jrt = [
  ["path", { d: "M12.8 19.6A2 2 0 1 0 14 16H2", key: "148xed" }],
  ["path", { d: "M17.5 8a2.5 2.5 0 1 1 2 4H2", key: "1u4tom" }],
  ["path", { d: "M9.8 4.4A2 2 0 1 1 11 8H2", key: "75valh" }]
], Qrt = y("Wind", Jrt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xrt = [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h3m7 0h-1.343", key: "v48bem" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    {
      d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198",
      key: "1ymjlu"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], eit = y("WineOff", Xrt);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tit = [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    { d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z", key: "10ffi3" }
  ]
], nit = y("Wine", tit);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rit = [
  ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" }],
  ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
  ["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" }]
], iit = y("Workflow", rit);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ait = [
  ["path", { d: "m19 12-1.5 3", key: "9bcu4o" }],
  ["path", { d: "M19.63 18.81 22 20", key: "121v98" }],
  [
    "path",
    {
      d: "M6.47 8.23a1.68 1.68 0 0 1 2.44 1.93l-.64 2.08a6.76 6.76 0 0 0 10.16 7.67l.42-.27a1 1 0 1 0-2.73-4.21l-.42.27a1.76 1.76 0 0 1-2.63-1.99l.64-2.08A6.66 6.66 0 0 0 3.94 3.9l-.7.4a1 1 0 1 0 2.55 4.34z",
      key: "1tij6q"
    }
  ]
], oit = y("Worm", ait);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sit = [
  ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
  ["path", { d: "M3 12h15a3 3 0 1 1 0 6h-4", key: "1cl7v7" }],
  ["polyline", { points: "16 16 14 18 16 20", key: "1jznyi" }],
  ["line", { x1: "3", x2: "10", y1: "18", y2: "18", key: "1h33wv" }]
], lit = y("WrapText", sit);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cit = [
  [
    "path",
    {
      d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
      key: "cbrjhi"
    }
  ]
], uit = y("Wrench", cit);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dit = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], fit = y("X", dit);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hit = [
  [
    "path",
    {
      d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17",
      key: "1q2vi4"
    }
  ],
  ["path", { d: "m10 15 5-3-5-3z", key: "1jp15x" }]
], pit = y("Youtube", hit);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mit = [
  ["path", { d: "M10.513 4.856 13.12 2.17a.5.5 0 0 1 .86.46l-1.377 4.317", key: "193nxd" }],
  ["path", { d: "M15.656 10H20a1 1 0 0 1 .78 1.63l-1.72 1.773", key: "27a7lr" }],
  [
    "path",
    {
      d: "M16.273 16.273 10.88 21.83a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14H4a1 1 0 0 1-.78-1.63l4.507-4.643",
      key: "1e0qe9"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], yit = y("ZapOff", mit);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const git = [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
], vit = y("Zap", git);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bit = [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
], wit = y("ZoomIn", bit);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kit = [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
], xit = y("ZoomOut", kit);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mit = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AArrowDown: Kue,
  AArrowUp: Jue,
  ALargeSmall: Xue,
  Accessibility: t0e,
  Activity: r0e,
  AirVent: a0e,
  Airplay: s0e,
  AlarmClock: g0e,
  AlarmClockCheck: c0e,
  AlarmClockMinus: d0e,
  AlarmClockOff: h0e,
  AlarmClockPlus: m0e,
  AlarmSmoke: b0e,
  Album: k0e,
  AlignCenter: L0e,
  AlignCenterHorizontal: M0e,
  AlignCenterVertical: A0e,
  AlignEndHorizontal: E0e,
  AlignEndVertical: N0e,
  AlignHorizontalDistributeCenter: I0e,
  AlignHorizontalDistributeEnd: z0e,
  AlignHorizontalDistributeStart: O0e,
  AlignHorizontalJustifyCenter: H0e,
  AlignHorizontalJustifyEnd: _0e,
  AlignHorizontalJustifyStart: q0e,
  AlignHorizontalSpaceAround: W0e,
  AlignHorizontalSpaceBetween: G0e,
  AlignJustify: K0e,
  AlignLeft: J0e,
  AlignRight: X0e,
  AlignStartHorizontal: t1e,
  AlignStartVertical: r1e,
  AlignVerticalDistributeCenter: a1e,
  AlignVerticalDistributeEnd: s1e,
  AlignVerticalDistributeStart: c1e,
  AlignVerticalJustifyCenter: d1e,
  AlignVerticalJustifyEnd: h1e,
  AlignVerticalJustifyStart: m1e,
  AlignVerticalSpaceAround: g1e,
  AlignVerticalSpaceBetween: b1e,
  Ambulance: k1e,
  Ampersand: M1e,
  Ampersands: A1e,
  Amphora: L1e,
  Anchor: E1e,
  Angry: N1e,
  Annoyed: I1e,
  Antenna: z1e,
  Anvil: O1e,
  Aperture: H1e,
  AppWindow: q1e,
  AppWindowMac: _1e,
  Apple: W1e,
  Archive: J1e,
  ArchiveRestore: G1e,
  ArchiveX: K1e,
  Armchair: X1e,
  ArrowBigDown: rde,
  ArrowBigDownDash: tde,
  ArrowBigLeft: sde,
  ArrowBigLeftDash: ade,
  ArrowBigRight: dde,
  ArrowBigRightDash: cde,
  ArrowBigUp: mde,
  ArrowBigUpDash: hde,
  ArrowDown: _de,
  ArrowDown01: gde,
  ArrowDown10: bde,
  ArrowDownAZ: kde,
  ArrowDownFromLine: Mde,
  ArrowDownLeft: Ade,
  ArrowDownNarrowWide: Lde,
  ArrowDownRight: Ede,
  ArrowDownToDot: Nde,
  ArrowDownToLine: Ide,
  ArrowDownUp: zde,
  ArrowDownWideNarrow: Ode,
  ArrowDownZA: Hde,
  ArrowLeft: Kde,
  ArrowLeftFromLine: qde,
  ArrowLeftRight: Wde,
  ArrowLeftToLine: Gde,
  ArrowRight: rfe,
  ArrowRightFromLine: Jde,
  ArrowRightLeft: Xde,
  ArrowRightToLine: tfe,
  ArrowUp: Efe,
  ArrowUp01: afe,
  ArrowUp10: sfe,
  ArrowUpAZ: cfe,
  ArrowUpDown: dfe,
  ArrowUpFromDot: hfe,
  ArrowUpFromLine: mfe,
  ArrowUpLeft: gfe,
  ArrowUpNarrowWide: bfe,
  ArrowUpRight: kfe,
  ArrowUpToLine: Mfe,
  ArrowUpWideNarrow: Afe,
  ArrowUpZA: Lfe,
  ArrowsUpFromLine: Nfe,
  Asterisk: Ife,
  AtSign: zfe,
  Atom: Ofe,
  AudioLines: Hfe,
  AudioWaveform: _fe,
  Award: qfe,
  Axe: Wfe,
  Axis3d: Gfe,
  Baby: Kfe,
  Backpack: Jfe,
  Badge: Nhe,
  BadgeAlert: Xfe,
  BadgeCent: the,
  BadgeCheck: rhe,
  BadgeDollarSign: ahe,
  BadgeEuro: she,
  BadgeHelp: che,
  BadgeIndianRupee: dhe,
  BadgeInfo: hhe,
  BadgeJapaneseYen: mhe,
  BadgeMinus: ghe,
  BadgePercent: bhe,
  BadgePlus: khe,
  BadgePoundSterling: Mhe,
  BadgeRussianRuble: Ahe,
  BadgeSwissFranc: Lhe,
  BadgeX: Ehe,
  BaggageClaim: Ihe,
  Ban: zhe,
  Banana: Ohe,
  Bandage: Hhe,
  Banknote: _he,
  Barcode: qhe,
  Baseline: Whe,
  Bath: Ghe,
  Battery: s2e,
  BatteryCharging: Khe,
  BatteryFull: Jhe,
  BatteryLow: Xhe,
  BatteryMedium: t2e,
  BatteryPlus: r2e,
  BatteryWarning: a2e,
  Beaker: c2e,
  Bean: h2e,
  BeanOff: d2e,
  Bed: b2e,
  BedDouble: m2e,
  BedSingle: g2e,
  Beef: k2e,
  Beer: A2e,
  BeerOff: M2e,
  Bell: H2e,
  BellDot: L2e,
  BellElectric: E2e,
  BellMinus: N2e,
  BellOff: I2e,
  BellPlus: z2e,
  BellRing: O2e,
  BetweenHorizontalEnd: _2e,
  BetweenHorizontalStart: q2e,
  BetweenVerticalEnd: W2e,
  BetweenVerticalStart: G2e,
  BicepsFlexed: K2e,
  Bike: J2e,
  Binary: X2e,
  Binoculars: tpe,
  Biohazard: rpe,
  Bird: ape,
  Bitcoin: spe,
  Blend: cpe,
  Blinds: dpe,
  Blocks: hpe,
  Bluetooth: kpe,
  BluetoothConnected: mpe,
  BluetoothOff: gpe,
  BluetoothSearching: bpe,
  Bold: Mpe,
  Bolt: Ape,
  Bomb: Lpe,
  Bone: Epe,
  Book: Mme,
  BookA: Npe,
  BookAudio: Ipe,
  BookCheck: zpe,
  BookCopy: Ope,
  BookDashed: Hpe,
  BookDown: _pe,
  BookHeadphones: qpe,
  BookHeart: Wpe,
  BookImage: Gpe,
  BookKey: Kpe,
  BookLock: Jpe,
  BookMarked: Xpe,
  BookMinus: tme,
  BookOpen: sme,
  BookOpenCheck: rme,
  BookOpenText: ame,
  BookPlus: cme,
  BookText: dme,
  BookType: hme,
  BookUp: gme,
  BookUp2: mme,
  BookUser: bme,
  BookX: kme,
  Bookmark: Ime,
  BookmarkCheck: Ame,
  BookmarkMinus: Lme,
  BookmarkPlus: Eme,
  BookmarkX: Nme,
  BoomBox: zme,
  Bot: _me,
  BotMessageSquare: Ome,
  BotOff: Hme,
  Box: qme,
  Boxes: Wme,
  Braces: Gme,
  Brackets: Kme,
  Brain: t4e,
  BrainCircuit: Jme,
  BrainCog: Xme,
  BrickWall: r4e,
  Briefcase: d4e,
  BriefcaseBusiness: a4e,
  BriefcaseConveyorBelt: s4e,
  BriefcaseMedical: c4e,
  BringToFront: h4e,
  Brush: m4e,
  Bug: k4e,
  BugOff: g4e,
  BugPlay: b4e,
  Building: A4e,
  Building2: M4e,
  Bus: E4e,
  BusFront: L4e,
  Cable: I4e,
  CableCar: N4e,
  Cake: O4e,
  CakeSlice: z4e,
  Calculator: H4e,
  Calendar: Lye,
  Calendar1: _4e,
  CalendarArrowDown: q4e,
  CalendarArrowUp: W4e,
  CalendarCheck: K4e,
  CalendarCheck2: G4e,
  CalendarClock: J4e,
  CalendarCog: X4e,
  CalendarDays: tye,
  CalendarFold: rye,
  CalendarHeart: aye,
  CalendarMinus: cye,
  CalendarMinus2: sye,
  CalendarOff: dye,
  CalendarPlus: mye,
  CalendarPlus2: hye,
  CalendarRange: gye,
  CalendarSearch: bye,
  CalendarSync: kye,
  CalendarX: Aye,
  CalendarX2: Mye,
  Camera: Nye,
  CameraOff: Eye,
  Candy: Oye,
  CandyCane: Iye,
  CandyOff: zye,
  Cannabis: Hye,
  Captions: qye,
  CaptionsOff: _ye,
  Car: Kye,
  CarFront: Wye,
  CarTaxiFront: Gye,
  Caravan: Jye,
  Carrot: Xye,
  CaseLower: t3e,
  CaseSensitive: r3e,
  CaseUpper: a3e,
  CassetteTape: s3e,
  Cast: c3e,
  Castle: d3e,
  Cat: h3e,
  Cctv: m3e,
  ChartArea: g3e,
  ChartBar: L3e,
  ChartBarBig: b3e,
  ChartBarDecreasing: k3e,
  ChartBarIncreasing: M3e,
  ChartBarStacked: A3e,
  ChartCandlestick: E3e,
  ChartColumn: H3e,
  ChartColumnBig: N3e,
  ChartColumnDecreasing: I3e,
  ChartColumnIncreasing: z3e,
  ChartColumnStacked: O3e,
  ChartGantt: _3e,
  ChartLine: q3e,
  ChartNetwork: W3e,
  ChartNoAxesColumn: J3e,
  ChartNoAxesColumnDecreasing: G3e,
  ChartNoAxesColumnIncreasing: K3e,
  ChartNoAxesCombined: X3e,
  ChartNoAxesGantt: tge,
  ChartPie: rge,
  ChartScatter: age,
  ChartSpline: sge,
  Check: Ox,
  CheckCheck: cge,
  ChefHat: fge,
  Cherry: pge,
  ChevronDown: Ig,
  ChevronFirst: gge,
  ChevronLast: bge,
  ChevronLeft: kge,
  ChevronRight: Mge,
  ChevronUp: EF,
  ChevronsDown: Tge,
  ChevronsDownUp: Sge,
  ChevronsLeft: Pge,
  ChevronsLeftRight: Dge,
  ChevronsLeftRightEllipsis: jge,
  ChevronsRight: Bge,
  ChevronsRightLeft: Rge,
  ChevronsUp: Vge,
  ChevronsUpDown: Fge,
  Chrome: Uge,
  Church: Zge,
  Cigarette: $ge,
  CigaretteOff: Yge,
  Circle: T5e,
  CircleAlert: Qge,
  CircleArrowDown: e6e,
  CircleArrowLeft: n6e,
  CircleArrowOutDownLeft: i6e,
  CircleArrowOutDownRight: o6e,
  CircleArrowOutUpLeft: l6e,
  CircleArrowOutUpRight: u6e,
  CircleArrowRight: f6e,
  CircleArrowUp: p6e,
  CircleCheck: v6e,
  CircleCheckBig: y6e,
  CircleChevronDown: w6e,
  CircleChevronLeft: x6e,
  CircleChevronRight: C6e,
  CircleChevronUp: S6e,
  CircleDashed: T6e,
  CircleDivide: j6e,
  CircleDollarSign: D6e,
  CircleDot: R6e,
  CircleDotDashed: P6e,
  CircleEllipsis: B6e,
  CircleEqual: F6e,
  CircleFadingArrowUp: V6e,
  CircleFadingPlus: U6e,
  CircleGauge: Z6e,
  CircleHelp: Y6e,
  CircleMinus: $6e,
  CircleOff: Q6e,
  CircleParking: n5e,
  CircleParkingOff: e5e,
  CirclePause: i5e,
  CirclePercent: o5e,
  CirclePlay: l5e,
  CirclePlus: u5e,
  CirclePower: f5e,
  CircleSlash: y5e,
  CircleSlash2: p5e,
  CircleSmall: v5e,
  CircleStop: w5e,
  CircleUser: C5e,
  CircleUserRound: x5e,
  CircleX: S5e,
  CircuitBoard: j5e,
  Citrus: D5e,
  Clapperboard: P5e,
  Clipboard: n8e,
  ClipboardCheck: R5e,
  ClipboardCopy: B5e,
  ClipboardList: F5e,
  ClipboardMinus: V5e,
  ClipboardPaste: U5e,
  ClipboardPen: Y5e,
  ClipboardPenLine: Z5e,
  ClipboardPlus: $5e,
  ClipboardType: Q5e,
  ClipboardX: e8e,
  Clock: P8e,
  Clock1: i8e,
  Clock10: o8e,
  Clock11: l8e,
  Clock12: u8e,
  Clock2: f8e,
  Clock3: p8e,
  Clock4: y8e,
  Clock5: v8e,
  Clock6: w8e,
  Clock7: x8e,
  Clock8: C8e,
  Clock9: S8e,
  ClockAlert: T8e,
  ClockArrowDown: j8e,
  ClockArrowUp: D8e,
  Cloud: pve,
  CloudAlert: R8e,
  CloudCog: B8e,
  CloudDownload: F8e,
  CloudDrizzle: V8e,
  CloudFog: U8e,
  CloudHail: Z8e,
  CloudLightning: Y8e,
  CloudMoon: Q8e,
  CloudMoonRain: $8e,
  CloudOff: eve,
  CloudRain: ive,
  CloudRainWind: nve,
  CloudSnow: ove,
  CloudSun: uve,
  CloudSunRain: lve,
  CloudUpload: fve,
  Cloudy: yve,
  Clover: vve,
  Club: wve,
  Code: Cve,
  CodeXml: xve,
  Codepen: Sve,
  Codesandbox: Tve,
  Coffee: jve,
  Cog: Dve,
  Coins: Pve,
  Columns2: Rve,
  Columns3: Bve,
  Columns4: Fve,
  Combine: Vve,
  Command: Uve,
  Compass: Zve,
  Component: Yve,
  Computer: $ve,
  ConciergeBell: Qve,
  Cone: ebe,
  Construction: nbe,
  Contact: obe,
  ContactRound: ibe,
  Container: lbe,
  Contrast: ube,
  Cookie: fbe,
  CookingPot: pbe,
  Copy: Sbe,
  CopyCheck: ybe,
  CopyMinus: vbe,
  CopyPlus: wbe,
  CopySlash: xbe,
  CopyX: Cbe,
  Copyleft: Tbe,
  Copyright: jbe,
  CornerDownLeft: Dbe,
  CornerDownRight: Pbe,
  CornerLeftDown: Rbe,
  CornerLeftUp: Bbe,
  CornerRightDown: Fbe,
  CornerRightUp: Vbe,
  CornerUpLeft: Ube,
  CornerUpRight: Zbe,
  Cpu: Ybe,
  CreativeCommons: $be,
  CreditCard: Qbe,
  Croissant: e7e,
  Crop: n7e,
  Cross: i7e,
  Crosshair: o7e,
  Crown: l7e,
  Cuboid: u7e,
  CupSoda: f7e,
  Currency: p7e,
  Cylinder: y7e,
  Dam: v7e,
  Database: C7e,
  DatabaseBackup: w7e,
  DatabaseZap: x7e,
  Delete: S7e,
  Dessert: T7e,
  Diameter: j7e,
  Diamond: B7e,
  DiamondMinus: D7e,
  DiamondPercent: P7e,
  DiamondPlus: R7e,
  Dice1: F7e,
  Dice2: V7e,
  Dice3: U7e,
  Dice4: Z7e,
  Dice5: Y7e,
  Dice6: $7e,
  Dices: Q7e,
  Diff: e9e,
  Disc: l9e,
  Disc2: n9e,
  Disc3: i9e,
  DiscAlbum: o9e,
  Divide: u9e,
  Dna: p9e,
  DnaOff: f9e,
  Dock: y9e,
  Dog: v9e,
  DollarSign: w9e,
  Donut: x9e,
  DoorClosed: C9e,
  DoorOpen: S9e,
  Dot: T9e,
  Download: j9e,
  DraftingCompass: D9e,
  Drama: P9e,
  Dribbble: R9e,
  Drill: B9e,
  Droplet: V9e,
  DropletOff: F9e,
  Droplets: U9e,
  Drum: Z9e,
  Drumstick: Y9e,
  Dumbbell: $9e,
  Ear: ewe,
  EarOff: Q9e,
  Earth: iwe,
  EarthLock: nwe,
  Eclipse: owe,
  Egg: fwe,
  EggFried: lwe,
  EggOff: uwe,
  Ellipsis: ywe,
  EllipsisVertical: pwe,
  Equal: xwe,
  EqualApproximately: vwe,
  EqualNot: wwe,
  Eraser: Cwe,
  EthernetPort: Swe,
  Euro: Twe,
  Expand: jwe,
  ExternalLink: Dwe,
  Eye: Bwe,
  EyeClosed: Pwe,
  EyeOff: Rwe,
  Facebook: Fwe,
  Factory: Vwe,
  Fan: Uwe,
  FastForward: Zwe,
  Feather: Ywe,
  Fence: $we,
  FerrisWheel: Qwe,
  Figma: eke,
  File: uMe,
  FileArchive: nke,
  FileAudio: oke,
  FileAudio2: ike,
  FileAxis3d: lke,
  FileBadge: fke,
  FileBadge2: uke,
  FileBox: pke,
  FileChartColumn: vke,
  FileChartColumnIncreasing: yke,
  FileChartLine: wke,
  FileChartPie: xke,
  FileCheck: Ske,
  FileCheck2: Cke,
  FileClock: Tke,
  FileCode: Dke,
  FileCode2: jke,
  FileCog: Pke,
  FileDiff: Rke,
  FileDigit: Bke,
  FileDown: Fke,
  FileHeart: Vke,
  FileImage: Uke,
  FileInput: Zke,
  FileJson: $ke,
  FileJson2: Yke,
  FileKey: exe,
  FileKey2: Qke,
  FileLock: ixe,
  FileLock2: nxe,
  FileMinus: lxe,
  FileMinus2: oxe,
  FileMusic: uxe,
  FileOutput: fxe,
  FilePen: yxe,
  FilePenLine: pxe,
  FilePlus: wxe,
  FilePlus2: vxe,
  FileQuestion: xxe,
  FileScan: Cxe,
  FileSearch: Txe,
  FileSearch2: Sxe,
  FileSliders: jxe,
  FileSpreadsheet: Dxe,
  FileStack: Pxe,
  FileSymlink: Rxe,
  FileTerminal: Bxe,
  FileText: Fxe,
  FileType: Uxe,
  FileType2: Vxe,
  FileUp: Zxe,
  FileUser: Yxe,
  FileVideo: Qxe,
  FileVideo2: $xe,
  FileVolume: nMe,
  FileVolume2: eMe,
  FileWarning: iMe,
  FileX: lMe,
  FileX2: oMe,
  Files: fMe,
  Film: pMe,
  Filter: vMe,
  FilterX: yMe,
  Fingerprint: wMe,
  FireExtinguisher: xMe,
  Fish: TMe,
  FishOff: CMe,
  FishSymbol: SMe,
  Flag: RMe,
  FlagOff: jMe,
  FlagTriangleLeft: DMe,
  FlagTriangleRight: PMe,
  Flame: FMe,
  FlameKindling: BMe,
  Flashlight: UMe,
  FlashlightOff: VMe,
  FlaskConical: YMe,
  FlaskConicalOff: ZMe,
  FlaskRound: $Me,
  FlipHorizontal: eCe,
  FlipHorizontal2: QMe,
  FlipVertical: iCe,
  FlipVertical2: nCe,
  Flower: lCe,
  Flower2: oCe,
  Focus: uCe,
  FoldHorizontal: fCe,
  FoldVertical: pCe,
  Folder: wAe,
  FolderArchive: yCe,
  FolderCheck: vCe,
  FolderClock: wCe,
  FolderClosed: xCe,
  FolderCode: CCe,
  FolderCog: SCe,
  FolderDot: TCe,
  FolderDown: jCe,
  FolderGit: PCe,
  FolderGit2: DCe,
  FolderHeart: RCe,
  FolderInput: BCe,
  FolderKanban: FCe,
  FolderKey: VCe,
  FolderLock: UCe,
  FolderMinus: ZCe,
  FolderOpen: $Ce,
  FolderOpenDot: YCe,
  FolderOutput: QCe,
  FolderPen: eAe,
  FolderPlus: nAe,
  FolderRoot: iAe,
  FolderSearch: lAe,
  FolderSearch2: oAe,
  FolderSymlink: uAe,
  FolderSync: fAe,
  FolderTree: pAe,
  FolderUp: yAe,
  FolderX: vAe,
  Folders: xAe,
  Footprints: CAe,
  Forklift: SAe,
  Forward: TAe,
  Frame: jAe,
  Framer: DAe,
  Frown: PAe,
  Fuel: RAe,
  Fullscreen: BAe,
  GalleryHorizontal: VAe,
  GalleryHorizontalEnd: FAe,
  GalleryThumbnails: UAe,
  GalleryVertical: YAe,
  GalleryVerticalEnd: ZAe,
  Gamepad: QAe,
  Gamepad2: $Ae,
  Gauge: eSe,
  Gavel: nSe,
  Gem: iSe,
  Ghost: oSe,
  Gift: lSe,
  GitBranch: fSe,
  GitBranchPlus: uSe,
  GitCommitHorizontal: pSe,
  GitCommitVertical: ySe,
  GitCompare: wSe,
  GitCompareArrows: vSe,
  GitFork: xSe,
  GitGraph: CSe,
  GitMerge: SSe,
  GitPullRequest: BSe,
  GitPullRequestArrow: TSe,
  GitPullRequestClosed: jSe,
  GitPullRequestCreate: PSe,
  GitPullRequestCreateArrow: DSe,
  GitPullRequestDraft: RSe,
  Github: FSe,
  Gitlab: VSe,
  GlassWater: USe,
  Glasses: ZSe,
  Globe: $Se,
  GlobeLock: YSe,
  Goal: QSe,
  Grab: eLe,
  GraduationCap: nLe,
  Grape: iLe,
  Grid2x2: fLe,
  Grid2x2Check: oLe,
  Grid2x2Plus: lLe,
  Grid2x2X: uLe,
  Grid3x3: pLe,
  Grip: wLe,
  GripHorizontal: yLe,
  GripVertical: vLe,
  Group: xLe,
  Guitar: CLe,
  Ham: SLe,
  Hammer: TLe,
  Hand: FLe,
  HandCoins: jLe,
  HandHeart: DLe,
  HandHelping: PLe,
  HandMetal: RLe,
  HandPlatter: BLe,
  Handshake: VLe,
  HardDrive: YLe,
  HardDriveDownload: ULe,
  HardDriveUpload: ZLe,
  HardHat: $Le,
  Hash: QLe,
  Haze: eTe,
  HdmiPort: nTe,
  Heading: yTe,
  Heading1: iTe,
  Heading2: oTe,
  Heading3: lTe,
  Heading4: uTe,
  Heading5: fTe,
  Heading6: pTe,
  HeadphoneOff: vTe,
  Headphones: wTe,
  Headset: xTe,
  Heart: DTe,
  HeartCrack: CTe,
  HeartHandshake: STe,
  HeartOff: TTe,
  HeartPulse: jTe,
  Heater: PTe,
  Hexagon: RTe,
  Highlighter: BTe,
  History: FTe,
  Hop: UTe,
  HopOff: VTe,
  Hospital: ZTe,
  Hotel: YTe,
  Hourglass: $Te,
  House: iEe,
  HousePlug: QTe,
  HousePlus: eEe,
  HouseWifi: nEe,
  IceCreamBowl: oEe,
  IceCreamCone: lEe,
  IdCard: uEe,
  Image: SEe,
  ImageDown: fEe,
  ImageMinus: pEe,
  ImageOff: yEe,
  ImagePlay: vEe,
  ImagePlus: wEe,
  ImageUp: xEe,
  ImageUpscale: CEe,
  Images: TEe,
  Import: jEe,
  Inbox: DEe,
  IndentDecrease: PEe,
  IndentIncrease: REe,
  IndianRupee: BEe,
  Infinity: FEe,
  Info: VEe,
  InspectionPanel: UEe,
  Instagram: ZEe,
  Italic: YEe,
  IterationCcw: $Ee,
  IterationCw: QEe,
  JapaneseYen: eje,
  Joystick: nje,
  Kanban: ije,
  Key: uje,
  KeyRound: oje,
  KeySquare: lje,
  Keyboard: yje,
  KeyboardMusic: fje,
  KeyboardOff: pje,
  Lamp: Tje,
  LampCeiling: vje,
  LampDesk: wje,
  LampFloor: xje,
  LampWallDown: Cje,
  LampWallUp: Sje,
  LandPlot: jje,
  Landmark: Dje,
  Languages: Pje,
  Laptop: Fje,
  LaptopMinimal: Bje,
  LaptopMinimalCheck: Rje,
  Lasso: Uje,
  LassoSelect: Vje,
  Laugh: Zje,
  Layers: $je,
  Layers2: Yje,
  LayoutDashboard: Qje,
  LayoutGrid: eNe,
  LayoutList: nNe,
  LayoutPanelLeft: iNe,
  LayoutPanelTop: oNe,
  LayoutTemplate: lNe,
  Leaf: uNe,
  LeafyGreen: fNe,
  Lectern: pNe,
  LetterText: yNe,
  Library: wNe,
  LibraryBig: vNe,
  LifeBuoy: xNe,
  Ligature: CNe,
  Lightbulb: TNe,
  LightbulbOff: SNe,
  Link: PNe,
  Link2: DNe,
  Link2Off: jNe,
  Linkedin: RNe,
  List: yDe,
  ListCheck: BNe,
  ListChecks: FNe,
  ListCollapse: VNe,
  ListEnd: UNe,
  ListFilter: YNe,
  ListFilterPlus: ZNe,
  ListMinus: $Ne,
  ListMusic: QNe,
  ListOrdered: eDe,
  ListPlus: nDe,
  ListRestart: iDe,
  ListStart: oDe,
  ListTodo: lDe,
  ListTree: uDe,
  ListVideo: fDe,
  ListX: pDe,
  Loader: xDe,
  LoaderCircle: vDe,
  LoaderPinwheel: wDe,
  Locate: TDe,
  LocateFixed: CDe,
  LocateOff: SDe,
  Lock: RDe,
  LockKeyhole: DDe,
  LockKeyholeOpen: jDe,
  LockOpen: PDe,
  LogIn: BDe,
  LogOut: FDe,
  Logs: VDe,
  Lollipop: UDe,
  Luggage: ZDe,
  Magnet: YDe,
  Mail: fIe,
  MailCheck: $De,
  MailMinus: QDe,
  MailOpen: eIe,
  MailPlus: nIe,
  MailQuestion: iIe,
  MailSearch: oIe,
  MailWarning: lIe,
  MailX: uIe,
  Mailbox: pIe,
  Mails: yIe,
  Map: UIe,
  MapPin: BIe,
  MapPinCheck: wIe,
  MapPinCheckInside: vIe,
  MapPinHouse: xIe,
  MapPinMinus: SIe,
  MapPinMinusInside: CIe,
  MapPinOff: TIe,
  MapPinPlus: DIe,
  MapPinPlusInside: jIe,
  MapPinX: RIe,
  MapPinXInside: PIe,
  MapPinned: FIe,
  MapPlus: VIe,
  Mars: YIe,
  MarsStroke: ZIe,
  Martini: $Ie,
  Maximize: ePe,
  Maximize2: QIe,
  Medal: nPe,
  Megaphone: oPe,
  MegaphoneOff: iPe,
  Meh: lPe,
  MemoryStick: uPe,
  Menu: fPe,
  Merge: pPe,
  MessageCircle: RPe,
  MessageCircleCode: yPe,
  MessageCircleDashed: vPe,
  MessageCircleHeart: wPe,
  MessageCircleMore: xPe,
  MessageCircleOff: CPe,
  MessageCirclePlus: SPe,
  MessageCircleQuestion: TPe,
  MessageCircleReply: jPe,
  MessageCircleWarning: DPe,
  MessageCircleX: PPe,
  MessageSquare: pze,
  MessageSquareCode: BPe,
  MessageSquareDashed: FPe,
  MessageSquareDiff: VPe,
  MessageSquareDot: UPe,
  MessageSquareHeart: ZPe,
  MessageSquareLock: YPe,
  MessageSquareMore: $Pe,
  MessageSquareOff: QPe,
  MessageSquarePlus: eze,
  MessageSquareQuote: nze,
  MessageSquareReply: ize,
  MessageSquareShare: oze,
  MessageSquareText: lze,
  MessageSquareWarning: uze,
  MessageSquareX: fze,
  MessagesSquare: yze,
  Mic: xze,
  MicOff: vze,
  MicVocal: wze,
  Microchip: Cze,
  Microscope: Sze,
  Microwave: Tze,
  Milestone: jze,
  Milk: Pze,
  MilkOff: Dze,
  Minimize: Bze,
  Minimize2: Rze,
  Minus: Fze,
  Monitor: fRe,
  MonitorCheck: Vze,
  MonitorCog: Uze,
  MonitorDot: Zze,
  MonitorDown: Yze,
  MonitorOff: $ze,
  MonitorPause: Qze,
  MonitorPlay: eRe,
  MonitorSmartphone: nRe,
  MonitorSpeaker: iRe,
  MonitorStop: oRe,
  MonitorUp: lRe,
  MonitorX: uRe,
  Moon: yRe,
  MoonStar: pRe,
  Mountain: wRe,
  MountainSnow: vRe,
  Mouse: DRe,
  MouseOff: xRe,
  MousePointer: jRe,
  MousePointer2: CRe,
  MousePointerBan: SRe,
  MousePointerClick: TRe,
  Move: oOe,
  Move3d: PRe,
  MoveDiagonal: BRe,
  MoveDiagonal2: RRe,
  MoveDown: URe,
  MoveDownLeft: FRe,
  MoveDownRight: VRe,
  MoveHorizontal: ZRe,
  MoveLeft: YRe,
  MoveRight: $Re,
  MoveUp: nOe,
  MoveUpLeft: QRe,
  MoveUpRight: eOe,
  MoveVertical: iOe,
  Music: pOe,
  Music2: lOe,
  Music3: uOe,
  Music4: fOe,
  Navigation: xOe,
  Navigation2: vOe,
  Navigation2Off: yOe,
  NavigationOff: wOe,
  Network: COe,
  Newspaper: SOe,
  Nfc: TOe,
  NonBinary: jOe,
  Notebook: BOe,
  NotebookPen: DOe,
  NotebookTabs: POe,
  NotebookText: ROe,
  NotepadText: VOe,
  NotepadTextDashed: FOe,
  Nut: ZOe,
  NutOff: UOe,
  Octagon: nBe,
  OctagonAlert: YOe,
  OctagonMinus: $Oe,
  OctagonPause: QOe,
  OctagonX: eBe,
  Omega: iBe,
  Option: oBe,
  Orbit: lBe,
  Origami: uBe,
  Package: SBe,
  Package2: fBe,
  PackageCheck: pBe,
  PackageMinus: yBe,
  PackageOpen: vBe,
  PackagePlus: wBe,
  PackageSearch: xBe,
  PackageX: CBe,
  PaintBucket: TBe,
  PaintRoller: jBe,
  Paintbrush: PBe,
  PaintbrushVertical: DBe,
  Palette: RBe,
  PanelBottom: UBe,
  PanelBottomClose: BBe,
  PanelBottomDashed: FBe,
  PanelBottomOpen: VBe,
  PanelLeft: QBe,
  PanelLeftClose: ZBe,
  PanelLeftDashed: YBe,
  PanelLeftOpen: $Be,
  PanelRight: oHe,
  PanelRightClose: eHe,
  PanelRightDashed: nHe,
  PanelRightOpen: iHe,
  PanelTop: pHe,
  PanelTopClose: lHe,
  PanelTopDashed: uHe,
  PanelTopOpen: fHe,
  PanelsLeftBottom: yHe,
  PanelsRightBottom: vHe,
  PanelsTopLeft: wHe,
  Paperclip: xHe,
  Parentheses: CHe,
  ParkingMeter: SHe,
  PartyPopper: THe,
  Pause: jHe,
  PawPrint: DHe,
  PcCase: PHe,
  Pen: VHe,
  PenLine: RHe,
  PenOff: BHe,
  PenTool: FHe,
  Pencil: $He,
  PencilLine: UHe,
  PencilOff: ZHe,
  PencilRuler: YHe,
  Pentagon: QHe,
  Percent: eFe,
  PersonStanding: nFe,
  PhilippinePeso: iFe,
  Phone: vFe,
  PhoneCall: oFe,
  PhoneForwarded: lFe,
  PhoneIncoming: uFe,
  PhoneMissed: fFe,
  PhoneOff: pFe,
  PhoneOutgoing: yFe,
  Pi: wFe,
  Piano: xFe,
  Pickaxe: CFe,
  PictureInPicture: TFe,
  PictureInPicture2: SFe,
  PiggyBank: jFe,
  Pilcrow: RFe,
  PilcrowLeft: DFe,
  PilcrowRight: PFe,
  Pill: FFe,
  PillBottle: BFe,
  Pin: UFe,
  PinOff: VFe,
  Pipette: ZFe,
  Pizza: YFe,
  Plane: e_e,
  PlaneLanding: $Fe,
  PlaneTakeoff: QFe,
  Play: R7,
  Plug: s_e,
  Plug2: r_e,
  PlugZap: a_e,
  Plus: c_e,
  Pocket: h_e,
  PocketKnife: d_e,
  Podcast: m_e,
  Pointer: b_e,
  PointerOff: g_e,
  Popcorn: k_e,
  Popsicle: M_e,
  PoundSterling: A_e,
  Power: E_e,
  PowerOff: L_e,
  Presentation: N_e,
  Printer: z_e,
  PrinterCheck: I_e,
  Projector: O_e,
  Proportions: H_e,
  Puzzle: __e,
  Pyramid: q_e,
  QrCode: W_e,
  Quote: G_e,
  Rabbit: K_e,
  Radar: J_e,
  Radiation: X_e,
  Radical: tVe,
  Radio: sVe,
  RadioReceiver: rVe,
  RadioTower: aVe,
  Radius: cVe,
  RailSymbol: dVe,
  Rainbow: hVe,
  Rat: mVe,
  Ratio: gVe,
  Receipt: zVe,
  ReceiptCent: bVe,
  ReceiptEuro: kVe,
  ReceiptIndianRupee: MVe,
  ReceiptJapaneseYen: AVe,
  ReceiptPoundSterling: LVe,
  ReceiptRussianRuble: EVe,
  ReceiptSwissFranc: NVe,
  ReceiptText: IVe,
  RectangleEllipsis: OVe,
  RectangleHorizontal: HVe,
  RectangleVertical: _Ve,
  Recycle: qVe,
  Redo: KVe,
  Redo2: WVe,
  RedoDot: GVe,
  RefreshCcw: XVe,
  RefreshCcwDot: JVe,
  RefreshCw: rqe,
  RefreshCwOff: tqe,
  Refrigerator: aqe,
  Regex: sqe,
  RemoveFormatting: cqe,
  Repeat: mqe,
  Repeat1: dqe,
  Repeat2: hqe,
  Replace: bqe,
  ReplaceAll: gqe,
  Reply: Mqe,
  ReplyAll: kqe,
  Rewind: Aqe,
  Ribbon: Lqe,
  Rocket: Eqe,
  RockingChair: Nqe,
  RollerCoaster: Iqe,
  Rotate3d: zqe,
  RotateCcw: Hqe,
  RotateCcwSquare: Oqe,
  RotateCw: qqe,
  RotateCwSquare: _qe,
  Route: Gqe,
  RouteOff: Wqe,
  Router: Kqe,
  Rows2: Jqe,
  Rows3: Xqe,
  Rows4: tUe,
  Rss: rUe,
  Ruler: aUe,
  RussianRuble: sUe,
  Sailboat: cUe,
  Salad: dUe,
  Sandwich: hUe,
  Satellite: gUe,
  SatelliteDish: mUe,
  Save: MUe,
  SaveAll: bUe,
  SaveOff: kUe,
  Scale: LUe,
  Scale3d: AUe,
  Scaling: EUe,
  Scan: GUe,
  ScanBarcode: NUe,
  ScanEye: IUe,
  ScanFace: zUe,
  ScanHeart: OUe,
  ScanLine: HUe,
  ScanQrCode: _Ue,
  ScanSearch: qUe,
  ScanText: WUe,
  School: KUe,
  Scissors: XUe,
  ScissorsLineDashed: JUe,
  ScreenShare: rWe,
  ScreenShareOff: tWe,
  Scroll: sWe,
  ScrollText: aWe,
  Search: jF,
  SearchCheck: cWe,
  SearchCode: dWe,
  SearchSlash: hWe,
  SearchX: mWe,
  Section: vWe,
  Send: CWe,
  SendHorizontal: wWe,
  SendToBack: xWe,
  SeparatorHorizontal: SWe,
  SeparatorVertical: TWe,
  Server: RWe,
  ServerCog: jWe,
  ServerCrash: DWe,
  ServerOff: PWe,
  Settings: FWe,
  Settings2: BWe,
  Shapes: VWe,
  Share: ZWe,
  Share2: UWe,
  Sheet: YWe,
  Shell: $We,
  Shield: vZe,
  ShieldAlert: QWe,
  ShieldBan: eZe,
  ShieldCheck: nZe,
  ShieldEllipsis: iZe,
  ShieldHalf: oZe,
  ShieldMinus: lZe,
  ShieldOff: uZe,
  ShieldPlus: fZe,
  ShieldQuestion: pZe,
  ShieldX: yZe,
  Ship: xZe,
  ShipWheel: wZe,
  Shirt: CZe,
  ShoppingBag: SZe,
  ShoppingBasket: TZe,
  ShoppingCart: jZe,
  Shovel: DZe,
  ShowerHead: PZe,
  Shrink: RZe,
  Shrub: BZe,
  Shuffle: FZe,
  Sigma: VZe,
  Signal: QZe,
  SignalHigh: UZe,
  SignalLow: ZZe,
  SignalMedium: YZe,
  SignalZero: $Ze,
  Signature: eGe,
  Signpost: iGe,
  SignpostBig: nGe,
  Siren: oGe,
  SkipBack: lGe,
  SkipForward: uGe,
  Skull: fGe,
  Slack: pGe,
  Slash: yGe,
  Slice: vGe,
  SlidersHorizontal: wGe,
  SlidersVertical: xGe,
  Smartphone: TGe,
  SmartphoneCharging: CGe,
  SmartphoneNfc: SGe,
  Smile: DGe,
  SmilePlus: jGe,
  Snail: PGe,
  Snowflake: RGe,
  Sofa: BGe,
  Soup: FGe,
  Space: VGe,
  Spade: UGe,
  Sparkle: ZGe,
  Sparkles: YGe,
  Speaker: $Ge,
  Speech: QGe,
  SpellCheck: nYe,
  SpellCheck2: eYe,
  Spline: iYe,
  Split: oYe,
  SprayCan: lYe,
  Sprout: uYe,
  Square: x$e,
  SquareActivity: fYe,
  SquareArrowDown: vYe,
  SquareArrowDownLeft: pYe,
  SquareArrowDownRight: yYe,
  SquareArrowLeft: wYe,
  SquareArrowOutDownLeft: xYe,
  SquareArrowOutDownRight: CYe,
  SquareArrowOutUpLeft: SYe,
  SquareArrowOutUpRight: TYe,
  SquareArrowRight: jYe,
  SquareArrowUp: RYe,
  SquareArrowUpLeft: DYe,
  SquareArrowUpRight: PYe,
  SquareAsterisk: BYe,
  SquareBottomDashedScissors: FYe,
  SquareChartGantt: VYe,
  SquareCheck: ZYe,
  SquareCheckBig: UYe,
  SquareChevronDown: YYe,
  SquareChevronLeft: $Ye,
  SquareChevronRight: QYe,
  SquareChevronUp: eKe,
  SquareCode: nKe,
  SquareDashed: fKe,
  SquareDashedBottom: oKe,
  SquareDashedBottomCode: iKe,
  SquareDashedKanban: lKe,
  SquareDashedMousePointer: uKe,
  SquareDivide: pKe,
  SquareDot: yKe,
  SquareEqual: vKe,
  SquareFunction: wKe,
  SquareKanban: xKe,
  SquareLibrary: CKe,
  SquareM: SKe,
  SquareMenu: TKe,
  SquareMinus: jKe,
  SquareMousePointer: DKe,
  SquareParking: RKe,
  SquareParkingOff: PKe,
  SquarePen: BKe,
  SquarePercent: FKe,
  SquarePi: VKe,
  SquarePilcrow: UKe,
  SquarePlay: ZKe,
  SquarePlus: YKe,
  SquarePower: $Ke,
  SquareRadical: QKe,
  SquareScissors: e$e,
  SquareSigma: n$e,
  SquareSlash: i$e,
  SquareSplitHorizontal: o$e,
  SquareSplitVertical: l$e,
  SquareSquare: u$e,
  SquareStack: f$e,
  SquareTerminal: p$e,
  SquareUser: v$e,
  SquareUserRound: y$e,
  SquareX: w$e,
  Squircle: C$e,
  Squirrel: S$e,
  Stamp: T$e,
  Star: P$e,
  StarHalf: j$e,
  StarOff: D$e,
  StepBack: R$e,
  StepForward: B$e,
  Stethoscope: F$e,
  Sticker: V$e,
  StickyNote: U$e,
  Store: Z$e,
  StretchHorizontal: Y$e,
  StretchVertical: $$e,
  Strikethrough: Q$e,
  Subscript: eJe,
  Sun: uJe,
  SunDim: nJe,
  SunMedium: iJe,
  SunMoon: oJe,
  SunSnow: lJe,
  Sunrise: fJe,
  Sunset: pJe,
  Superscript: yJe,
  SwatchBook: vJe,
  SwissFranc: wJe,
  SwitchCamera: xJe,
  Sword: CJe,
  Swords: SJe,
  Syringe: TJe,
  Table: UJe,
  Table2: jJe,
  TableCellsMerge: DJe,
  TableCellsSplit: PJe,
  TableColumnsSplit: RJe,
  TableOfContents: BJe,
  TableProperties: FJe,
  TableRowsSplit: VJe,
  Tablet: YJe,
  TabletSmartphone: ZJe,
  Tablets: $Je,
  Tag: QJe,
  Tags: eQe,
  Tally1: nQe,
  Tally2: iQe,
  Tally3: oQe,
  Tally4: lQe,
  Tally5: uQe,
  Tangent: fQe,
  Target: pQe,
  Telescope: yQe,
  Tent: wQe,
  TentTree: vQe,
  Terminal: xQe,
  TestTube: SQe,
  TestTubeDiagonal: CQe,
  TestTubes: TQe,
  Text: FQe,
  TextCursor: DQe,
  TextCursorInput: jQe,
  TextQuote: PQe,
  TextSearch: RQe,
  TextSelect: BQe,
  Theater: VQe,
  Thermometer: YQe,
  ThermometerSnowflake: UQe,
  ThermometerSun: ZQe,
  ThumbsDown: $Qe,
  ThumbsUp: QQe,
  Ticket: fXe,
  TicketCheck: eXe,
  TicketMinus: nXe,
  TicketPercent: iXe,
  TicketPlus: oXe,
  TicketSlash: lXe,
  TicketX: uXe,
  Tickets: yXe,
  TicketsPlane: pXe,
  Timer: xXe,
  TimerOff: vXe,
  TimerReset: wXe,
  ToggleLeft: CXe,
  ToggleRight: SXe,
  Toilet: TXe,
  Tornado: jXe,
  Torus: DXe,
  Touchpad: RXe,
  TouchpadOff: PXe,
  TowerControl: BXe,
  ToyBrick: FXe,
  Tractor: VXe,
  TrafficCone: UXe,
  TrainFront: YXe,
  TrainFrontTunnel: ZXe,
  TrainTrack: $Xe,
  TramFront: QXe,
  Transgender: eet,
  Trash: iet,
  Trash2: net,
  TreeDeciduous: oet,
  TreePalm: cet,
  TreePine: det,
  Trees: het,
  Trello: met,
  TrendingDown: get,
  TrendingUp: ket,
  TrendingUpDown: bet,
  Triangle: jet,
  TriangleAlert: Met,
  TriangleDashed: Aet,
  TriangleRight: Tet,
  Trophy: Det,
  Truck: Pet,
  Turtle: Ret,
  Tv: Vet,
  TvMinimal: Fet,
  TvMinimalPlay: Bet,
  Twitch: Uet,
  Twitter: Zet,
  Type: $et,
  TypeOutline: Yet,
  Umbrella: ett,
  UmbrellaOff: Qet,
  Underline: ntt,
  Undo: ltt,
  Undo2: itt,
  UndoDot: ott,
  UnfoldHorizontal: utt,
  UnfoldVertical: ftt,
  Ungroup: ptt,
  University: ytt,
  Unlink: wtt,
  Unlink2: vtt,
  Unplug: xtt,
  Upload: Ctt,
  Usb: Stt,
  User: int,
  UserCheck: Ttt,
  UserCog: jtt,
  UserMinus: Dtt,
  UserPen: Ptt,
  UserPlus: Rtt,
  UserRound: Qtt,
  UserRoundCheck: Btt,
  UserRoundCog: Ftt,
  UserRoundMinus: Vtt,
  UserRoundPen: Utt,
  UserRoundPlus: Ztt,
  UserRoundSearch: Ytt,
  UserRoundX: $tt,
  UserSearch: ent,
  UserX: nnt,
  Users: lnt,
  UsersRound: ont,
  Utensils: fnt,
  UtensilsCrossed: unt,
  UtilityPole: pnt,
  Variable: ynt,
  Vault: vnt,
  Vegan: wnt,
  VenetianMask: xnt,
  Venus: Snt,
  VenusAndMars: Cnt,
  Vibrate: jnt,
  VibrateOff: Tnt,
  Video: Pnt,
  VideoOff: Dnt,
  Videotape: Rnt,
  View: Bnt,
  Voicemail: Fnt,
  Volleyball: Vnt,
  Volume: Qnt,
  Volume1: Unt,
  Volume2: Znt,
  VolumeOff: Ynt,
  VolumeX: $nt,
  Vote: ert,
  Wallet: ort,
  WalletCards: nrt,
  WalletMinimal: irt,
  Wallpaper: lrt,
  Wand: frt,
  WandSparkles: urt,
  Warehouse: prt,
  WashingMachine: yrt,
  Watch: vrt,
  Waves: xrt,
  WavesLadder: wrt,
  Waypoints: Crt,
  Webcam: Srt,
  Webhook: jrt,
  WebhookOff: Trt,
  Weight: Drt,
  Wheat: Rrt,
  WheatOff: Prt,
  WholeWord: Brt,
  Wifi: Yrt,
  WifiHigh: Frt,
  WifiLow: Vrt,
  WifiOff: Urt,
  WifiZero: Zrt,
  Wind: Qrt,
  WindArrowDown: $rt,
  Wine: nit,
  WineOff: eit,
  Workflow: iit,
  Worm: oit,
  WrapText: lit,
  Wrench: uit,
  X: fit,
  Youtube: pit,
  Zap: vit,
  ZapOff: yit,
  ZoomIn: wit,
  ZoomOut: xit
}, Symbol.toStringTag, { value: "Module" })), NF = Object.assign({}, Mit, Uue), Cit = Ha("object-contain", {
  variants: {
    size: {
      sm: "w-4 h-4",
      md: "w-5 h-5",
      lg: "w-8 h-8"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Ye = en(
  ({ name: t, className: e, size: n, strokeWidth: r, fill: i, stroke: a, ...o }, s) => {
    const l = NF[t];
    return l ? /* @__PURE__ */ T.jsx(
      l,
      {
        name: t,
        ref: s,
        className: be(Cit({ size: n }), e),
        strokeWidth: r || 2,
        fill: i || "none",
        stroke: a || "currentColor",
        ...o
      }
    ) : null;
  }
);
Ye.displayName = "LucideIcon";
const Ait = Ha(
  "inline-flex items-center justify-center whitespace-nowrap rounded ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:color-button-disabled",
  {
    variants: {
      variant: {
        default: "color-button-default color-text-inverse hover:color-button-default-hover",
        danger: "color-button-danger color-text-inverse hover:color-button-danger-hover",
        secondary: "color-button-secondary color-text-default hover:color-button-secondary-hover",
        ghost: "color-text-default hover:color-button-secondary-hover"
      },
      size: {
        sm: "h-[30px] px-3 min-w-[108px] text-helper-text-sm",
        md: "h-9 px-4 py-2 min-w-[129px] text-body-sm-bold",
        lg: "h-10 px-8 min-w-[145px] text-body-sm-bold"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "md"
    }
  }
), Kt = N.forwardRef(
  ({
    className: t,
    variant: e,
    size: n,
    toggleLeftIcon: r,
    toggleRightIcon: i,
    leftIcon: a,
    rightIcon: o,
    onClick: s,
    isLoading: l = !1,
    elevation: c,
    ...u
  }, d) => /* @__PURE__ */ T.jsx(
    "button",
    {
      className: be(Ait({ variant: e, size: n, className: t }), {
        "shadow-elevation-1": c === 1,
        "shadow-elevation-2": c === 2,
        "shadow-elevation-3": c === 3,
        "shadow-elevation-4": c === 4
      }),
      ref: d,
      onClick: s,
      ...u,
      children: l ? /* @__PURE__ */ T.jsx(
        Ye,
        {
          name: "LoaderCircle",
          size: n === "sm" ? "sm" : "md",
          className: "animate-spin",
          fill: "transparent",
          stroke: "currentColor"
        }
      ) : /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
        r && /* @__PURE__ */ T.jsx("span", { className: "start-adornment", children: /* @__PURE__ */ T.jsx(
          Ye,
          {
            size: n === "sm" ? "sm" : "md",
            name: a,
            fill: "transparent",
            stroke: e === "default" || e === "danger" ? "white" : "currentColor",
            className: "mr-2"
          }
        ) }),
        u.children,
        i && /* @__PURE__ */ T.jsx("span", { className: "end-adornment", children: /* @__PURE__ */ T.jsx(
          Ye,
          {
            size: n === "sm" ? "sm" : "md",
            name: o,
            fill: "transparent",
            stroke: e === "default" || e === "danger" ? "white" : "currentColor",
            className: "ml-2"
          }
        ) })
      ] })
    }
  )
);
Kt.displayName = "Button";
const Bx = ({ children: t, className: e }) => {
  const n = be("flex space-x-2", e);
  return /* @__PURE__ */ T.jsx("div", { className: n, children: t });
}, mn = en(
  ({
    icon: t,
    variant: e,
    size: n = "sm",
    className: r,
    elevation: i,
    rounded: a = !1,
    isActive: o,
    fill: s,
    ...l
  }, c) => /* @__PURE__ */ T.jsx(
    Kt,
    {
      ref: c,
      variant: e,
      className: be(
        "px-0",
        {
          "h-[30px] min-w-[30px]": n === "sm",
          "h-9 min-w-[36px] ": n === "md",
          "h-10 min-w-[40px]": n === "lg"
        },
        {
          "shadow-elevation-1": i === 1,
          "shadow-elevation-2": i === 2,
          "shadow-elevation-3": i === 3,
          "shadow-elevation-4": i === 4
        },
        {
          "rounded-full": a,
          rounded: !a
        },
        {
          "color-bg-brand hover:!color-bg-brand xl:hover:!color-bg-brand-hover": o && e === "ghost"
        },
        r
      ),
      size: n,
      ...l,
      children: /* @__PURE__ */ T.jsx(
        Ye,
        {
          "data-testid": "icon",
          "data-role": "icon",
          name: t,
          size: n === "sm" ? "sm" : "md",
          fill: s || "transparent",
          stroke: o && e === "ghost" ? "black" : e === "default" || e === "danger" ? "white" : "currentColor"
        }
      )
    }
  )
);
function Sit(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function DF(...t) {
  return (e) => t.forEach((n) => Sit(n, e));
}
function Jt(...t) {
  return N.useCallback(DF(...t), t);
}
var ns = N.forwardRef((t, e) => {
  const { children: n, ...r } = t, i = N.Children.toArray(n), a = i.find(Lit);
  if (a) {
    const o = a.props.children, s = i.map((l) => l === a ? N.Children.count(o) > 1 ? N.Children.only(null) : N.isValidElement(o) ? o.props.children : null : l);
    return /* @__PURE__ */ T.jsx(O7, { ...r, ref: e, children: N.isValidElement(o) ? N.cloneElement(o, void 0, s) : null });
  }
  return /* @__PURE__ */ T.jsx(O7, { ...r, ref: e, children: n });
});
ns.displayName = "Slot";
var O7 = N.forwardRef((t, e) => {
  const { children: n, ...r } = t;
  if (N.isValidElement(n)) {
    const i = Eit(n);
    return N.cloneElement(n, {
      ...Tit(r, n.props),
      // @ts-ignore
      ref: e ? DF(e, i) : i
    });
  }
  return N.Children.count(n) > 1 ? N.Children.only(null) : null;
});
O7.displayName = "SlotClone";
var Hx = ({ children: t }) => /* @__PURE__ */ T.jsx(T.Fragment, { children: t });
function Lit(t) {
  return N.isValidElement(t) && t.type === Hx;
}
function Tit(t, e) {
  const n = { ...e };
  for (const r in e) {
    const i = t[r], a = e[r];
    /^on[A-Z]/.test(r) ? i && a ? n[r] = (...o) => {
      a(...o), i(...o);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...a } : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function Eit(t) {
  var e, n;
  let r = (e = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : e.get, i = r && "isReactWarning" in r && r.isReactWarning;
  return i ? t.ref : (r = (n = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : n.get, i = r && "isReactWarning" in r && r.isReactWarning, i ? t.props.ref : t.props.ref || t.ref);
}
var jit = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ct = jit.reduce((t, e) => {
  const n = N.forwardRef((r, i) => {
    const { asChild: a, ...o } = r, s = a ? ns : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ T.jsx(s, { ...o, ref: i });
  });
  return n.displayName = `Primitive.${e}`, { ...t, [e]: n };
}, {});
function IF(t, e) {
  t && wd.flushSync(() => t.dispatchEvent(e));
}
var Nit = "Label", PF = N.forwardRef((t, e) => /* @__PURE__ */ T.jsx(
  Ct.label,
  {
    ...t,
    ref: e,
    onMouseDown: (n) => {
      var r;
      n.target.closest("button, input, select, textarea") || ((r = t.onMouseDown) == null || r.call(t, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
PF.displayName = Nit;
var zF = PF;
const Dit = Ha(
  "text-body-sm leading-none color-text-default peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), k0 = N.forwardRef(({ className: t, required: e, children: n, ...r }, i) => /* @__PURE__ */ T.jsxs(
  zF,
  {
    ref: i,
    className: be(Dit(), t),
    ...r,
    children: [
      n,
      e && /* @__PURE__ */ T.jsx("span", { className: "ml-1 text-red-500", children: "*" })
    ]
  }
));
k0.displayName = zF.displayName;
const Rh = N.forwardRef(
  ({
    className: t,
    label: e,
    required: n,
    isValid: r = !0,
    message: i,
    placeholder: a,
    onChange: o,
    leftIcon: s,
    rightIcon: l,
    ...c
  }, u) => {
    const d = N.useRef(null), f = Jt(u, d), h = N.useCallback(() => {
      var g;
      (g = d.current) == null || g.focus();
    }, []), p = N.useMemo(() => {
      if (s == null)
        return;
      const g = N.Children.only(s);
      if (N.isValidElement(g))
        return N.cloneElement(g, {
          ...g.props,
          onClick: (v) => {
            var k, w;
            (w = (k = g.props).onClick) == null || w.call(k, v), h();
          },
          className: be("absolute left-3 color-text-disabled", {
            "cursor-not-allowed": c.disabled
          })
        });
    }, [h, s, c.disabled]), m = N.useMemo(() => {
      if (l == null)
        return;
      const g = N.Children.only(l);
      if (N.isValidElement(g))
        return N.cloneElement(g, {
          ...g.props,
          onClick: (v) => {
            var k, w;
            (w = (k = g.props).onClick) == null || w.call(k, v), h();
          },
          className: be(
            "absolute right-3 cursor-pointer color-text-disabled",
            {
              "cursor-not-allowed": c.disabled
            },
            {
              "color-text-danger": !r
            }
          )
        });
    }, [h, l, c.disabled, r]);
    return /* @__PURE__ */ T.jsxs("div", { className: "flex flex-col w-full", children: [
      e ? /* @__PURE__ */ T.jsx(k0, { required: n, className: "mb-2 text-body-sm", children: e }) : null,
      /* @__PURE__ */ T.jsxs("div", { className: "relative flex items-center group", children: [
        p,
        /* @__PURE__ */ T.jsx(
          "textarea",
          {
            className: be(
              "flex h-9 w-full rounded-md border color-border-default hover:color-border-hover bg-transparent px-3 py-2 text-body-sm color-text-default transition-colors file:border-0 file:bg-transparent file:text-body-sm placeholder:color-text-disabled focus-visible:outline-none focus-visible:color-border-hover overflow-hidden text-ellipsis",
              { "pr-3 pl-10": p },
              { "pr-10": m },
              { "color-border-danger": !r },
              {
                "disabled:cursor-not-allowed disabled:color-bg-disabled disabled:border-disabled disabled:color-text-disabled": c.disabled
              },
              t
            ),
            onInput: (g) => {
              g.currentTarget.style.height = "auto", g.currentTarget.style.height = `${g.currentTarget.scrollHeight}px`;
            },
            onChange: o,
            placeholder: a || "Placeholder",
            ref: f,
            ...c
          }
        ),
        m
      ] }),
      i ? /* @__PURE__ */ T.jsx(
        "p",
        {
          className: be("text-body-sm mt-2 text-wrap text-justify", {
            "color-text-danger": !r,
            "color-text-secondary": r
          }),
          children: i
        }
      ) : null
    ] });
  }
);
Rh.displayName = "TextAreaFieldV2";
const Iit = N.forwardRef(
  ({ className: t, label: e, required: n, message: r, placeholder: i, isValid: a = !0, ...o }, s) => {
    const l = be(
      "flex min-h-[80px] w-full rounded-sm border color-border-default hover:color-border-hover color-bg-default transition-colors px-3 py-2 text-body-sm color-text-default placeholder:color-text-disabled disabled:color-text-disabled focus-visible:outline-none focus-visible:color-border-hover disabled:cursor-not-allowed disabled:color-bg-disabled disabled:border-disabled",
      { "color-border-danger": !a },
      t
    );
    return /* @__PURE__ */ T.jsxs("div", { className: "flex flex-col h-full", children: [
      e ? /* @__PURE__ */ T.jsx(k0, { required: n, className: "mb-2 text-body-sm", children: e }) : null,
      /* @__PURE__ */ T.jsx(
        "textarea",
        {
          className: l,
          placeholder: i || "Placeholder",
          ref: s,
          ...o
        }
      ),
      r ? /* @__PURE__ */ T.jsx(
        "p",
        {
          className: be("text-body-sm font-normal mt-2 text-wrap text-justify", {
            "color-text-danger": !a,
            "color-text-secondary": a
          }),
          children: r
        }
      ) : null
    ] });
  }
);
Iit.displayName = "TextAreaField";
const al = N.forwardRef(
  ({
    className: t,
    label: e,
    required: n,
    type: r = "text",
    isValid: i = !0,
    message: a,
    onChange: o,
    leftIcon: s,
    rightIcon: l,
    ...c
  }, u) => {
    const d = N.useRef(null), f = Jt(u, d), h = N.useCallback(() => {
      var g;
      (g = d.current) == null || g.focus();
    }, []), p = N.useMemo(() => {
      if (s == null)
        return;
      const g = N.Children.only(s);
      if (N.isValidElement(g))
        return N.cloneElement(g, {
          ...g.props,
          onClick: (v) => {
            var k, w;
            (w = (k = g.props).onClick) == null || w.call(k, v), h();
          },
          className: be("absolute left-3 color-text-disabled", {
            "cursor-not-allowed": c.disabled
          })
        });
    }, [h, s, c.disabled]), m = N.useMemo(() => {
      if (l == null)
        return;
      const g = N.Children.only(l);
      if (N.isValidElement(g))
        return N.cloneElement(g, {
          ...g.props,
          onClick: (v) => {
            var k, w;
            (w = (k = g.props).onClick) == null || w.call(k, v), h();
          },
          className: be(
            "absolute right-3 cursor-pointer color-text-disabled",
            {
              "cursor-not-allowed": c.disabled
            },
            {
              "color-text-danger": !i
            }
          )
        });
    }, [h, l, c.disabled, i]);
    return /* @__PURE__ */ T.jsxs("div", { className: "flex flex-col w-full", children: [
      e ? /* @__PURE__ */ T.jsx(k0, { required: n, className: "mb-2 text-body-sm", children: e }) : null,
      /* @__PURE__ */ T.jsxs("div", { className: "relative flex items-center group", children: [
        p,
        /* @__PURE__ */ T.jsx(
          "input",
          {
            type: r,
            className: be(
              "flex h-9 w-full rounded-md border color-border-default hover:color-border-hover bg-transparent px-3 py-2 text-body-sm  color-text-default transition-colors file:border-0 file:bg-transparent file:text-body-sm placeholder:color-text-disabled focus-visible:outline-none focus-visible:color-border-hover",
              { "pr-3 pl-10": p },
              { "pr-10": m },
              { "color-border-danger": !i },
              {
                "disabled:cursor-not-allowed disabled:color-bg-disabled disabled:border-disabled disabled:color-text-disabled": c.disabled
              },
              t
            ),
            onChange: o,
            ref: f,
            ...c
          }
        ),
        m
      ] }),
      a ? /* @__PURE__ */ T.jsx(
        "p",
        {
          className: be("text-body-sm mt-2 text-wrap text-justify", {
            "color-text-danger": !i,
            "color-text-secondary": i
          }),
          children: a
        }
      ) : null
    ] });
  }
);
al.displayName = "TextField";
function it(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (t == null || t(r), n === !1 || !r.defaultPrevented)
      return e == null ? void 0 : e(r);
  };
}
function Pit(t, e) {
  const n = N.createContext(e);
  function r(a) {
    const { children: o, ...s } = a, l = N.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ T.jsx(n.Provider, { value: l, children: o });
  }
  function i(a) {
    const o = N.useContext(n);
    if (o) return o;
    if (e !== void 0) return e;
    throw new Error(`\`${a}\` must be used within \`${t}\``);
  }
  return r.displayName = t + "Provider", [r, i];
}
function ei(t, e = []) {
  let n = [];
  function r(a, o) {
    const s = N.createContext(o), l = n.length;
    n = [...n, o];
    function c(d) {
      const { scope: f, children: h, ...p } = d, m = (f == null ? void 0 : f[t][l]) || s, g = N.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ T.jsx(m.Provider, { value: g, children: h });
    }
    function u(d, f) {
      const h = (f == null ? void 0 : f[t][l]) || s, p = N.useContext(h);
      if (p) return p;
      if (o !== void 0) return o;
      throw new Error(`\`${d}\` must be used within \`${a}\``);
    }
    return c.displayName = a + "Provider", [c, u];
  }
  const i = () => {
    const a = n.map((o) => N.createContext(o));
    return function(o) {
      const s = (o == null ? void 0 : o[t]) || a;
      return N.useMemo(
        () => ({ [`__scope${t}`]: { ...o, [t]: s } }),
        [o, s]
      );
    };
  };
  return i.scopeName = t, [r, zit(i, ...e)];
}
function zit(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const r = t.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(i) {
      const a = r.reduce((o, { useScope: s, scopeName: l }) => {
        const c = s(i)[`__scope${l}`];
        return { ...o, ...c };
      }, {});
      return N.useMemo(() => ({ [`__scope${e.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
function Di(t) {
  const e = N.useRef(t);
  return N.useEffect(() => {
    e.current = t;
  }), N.useMemo(() => (...n) => {
    var r;
    return (r = e.current) == null ? void 0 : r.call(e, ...n);
  }, []);
}
function mo({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  }
}) {
  const [r, i] = Rit({ defaultProp: e, onChange: n }), a = t !== void 0, o = a ? t : r, s = Di(n), l = N.useCallback(
    (c) => {
      if (a) {
        const u = typeof c == "function" ? c(t) : c;
        u !== t && s(u);
      } else
        i(c);
    },
    [a, t, i, s]
  );
  return [o, l];
}
function Rit({
  defaultProp: t,
  onChange: e
}) {
  const n = N.useState(t), [r] = n, i = N.useRef(r), a = Di(e);
  return N.useEffect(() => {
    i.current !== r && (a(r), i.current = r);
  }, [r, i, a]), n;
}
function Fx(t) {
  const e = N.useRef({ value: t, previous: t });
  return N.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
var Fr = globalThis != null && globalThis.document ? N.useLayoutEffect : () => {
};
function _x(t) {
  const [e, n] = N.useState(void 0);
  return Fr(() => {
    if (t) {
      n({ width: t.offsetWidth, height: t.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const a = i[0];
        let o, s;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          o = c.inlineSize, s = c.blockSize;
        } else
          o = t.offsetWidth, s = t.offsetHeight;
        n({ width: o, height: s });
      });
      return r.observe(t, { box: "border-box" }), () => r.unobserve(t);
    } else
      n(void 0);
  }, [t]), e;
}
var Vx = "Switch", [Oit, oGt] = ei(Vx), [Bit, Hit] = Oit(Vx), RF = N.forwardRef(
  (t, e) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: i,
      defaultChecked: a,
      required: o,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      ...u
    } = t, [d, f] = N.useState(null), h = Jt(e, (k) => f(k)), p = N.useRef(!1), m = d ? !!d.closest("form") : !0, [g = !1, v] = mo({
      prop: i,
      defaultProp: a,
      onChange: c
    });
    return /* @__PURE__ */ T.jsxs(Bit, { scope: n, checked: g, disabled: s, children: [
      /* @__PURE__ */ T.jsx(
        Ct.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": g,
          "aria-required": o,
          "data-state": HF(g),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...u,
          ref: h,
          onClick: it(t.onClick, (k) => {
            v((w) => !w), m && (p.current = k.isPropagationStopped(), p.current || k.stopPropagation());
          })
        }
      ),
      m && /* @__PURE__ */ T.jsx(
        Fit,
        {
          control: d,
          bubbles: !p.current,
          name: r,
          value: l,
          checked: g,
          required: o,
          disabled: s,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
RF.displayName = Vx;
var OF = "SwitchThumb", BF = N.forwardRef(
  (t, e) => {
    const { __scopeSwitch: n, ...r } = t, i = Hit(OF, n);
    return /* @__PURE__ */ T.jsx(
      Ct.span,
      {
        "data-state": HF(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: e
      }
    );
  }
);
BF.displayName = OF;
var Fit = (t) => {
  const { control: e, checked: n, bubbles: r = !0, ...i } = t, a = N.useRef(null), o = Fx(n), s = _x(e);
  return N.useEffect(() => {
    const l = a.current, c = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (o !== n && u) {
      const d = new Event("click", { bubbles: r });
      u.call(l, n), l.dispatchEvent(d);
    }
  }, [o, n, r]), /* @__PURE__ */ T.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...i,
      tabIndex: -1,
      ref: a,
      style: {
        ...t.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function HF(t) {
  return t ? "checked" : "unchecked";
}
var FF = RF, _it = BF;
const Vit = Ha("", {
  variants: {
    variant: {
      default: "",
      hover: "data-[state=unchecked]:color-bg-default-hover data-[state=checked]:color-bg-brand-hover",
      focus: "outline-none ring-2 ring-focused ring-offset-2 ring-offset-white"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), _F = N.forwardRef(({ className: t, variant: e, disabled: n, ...r }, i) => /* @__PURE__ */ T.jsx(
  FF,
  {
    className: be(
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:cursor-not-allowed data-[state=checked]:toggle-active data-[state=unchecked]:toggle-default data-[state=unchecked]:hover:enabled:color-bg-default-hover data-[state=checked]:hover:enabled:color-bg-brand-hover data-[state=checked]:disabled:toggle-default",
      Vit({ variant: e, className: t })
    ),
    disabled: n,
    ...r,
    ref: i,
    "data-testid": "toggle",
    children: /* @__PURE__ */ T.jsx(
      _it,
      {
        "data-testid": "toggle-thumb",
        className: be(
          "pointer-events-none block h-5 w-5 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0",
          n ? "color-icon-disabled" : "color-icon-default"
        )
      }
    )
  }
));
_F.displayName = FF.displayName;
function qit(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Di(t);
  N.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return e.addEventListener("keydown", r, { capture: !0 }), () => e.removeEventListener("keydown", r, { capture: !0 });
  }, [n, e]);
}
var Uit = "DismissableLayer", B7 = "dismissableLayer.update", Wit = "dismissableLayer.pointerDownOutside", Zit = "dismissableLayer.focusOutside", DE, VF = N.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Fc = N.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: a,
      onInteractOutside: o,
      onDismiss: s,
      ...l
    } = t, c = N.useContext(VF), [u, d] = N.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = N.useState({}), p = Jt(e, (L) => d(L)), m = Array.from(c.layers), [g] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), v = m.indexOf(g), k = u ? m.indexOf(u) : -1, w = c.layersWithOutsidePointerEventsDisabled.size > 0, b = k >= v, x = Yit((L) => {
      const M = L.target, j = [...c.branches].some((D) => D.contains(M));
      !b || j || (i == null || i(L), o == null || o(L), L.defaultPrevented || s == null || s());
    }, f), A = Kit((L) => {
      const M = L.target;
      [...c.branches].some((j) => j.contains(M)) || (a == null || a(L), o == null || o(L), L.defaultPrevented || s == null || s());
    }, f);
    return qit((L) => {
      k === c.layers.size - 1 && (r == null || r(L), !L.defaultPrevented && s && (L.preventDefault(), s()));
    }, f), N.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (DE = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), IE(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = DE);
        };
    }, [u, f, n, c]), N.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), IE());
    }, [u, c]), N.useEffect(() => {
      const L = () => h({});
      return document.addEventListener(B7, L), () => document.removeEventListener(B7, L);
    }, []), /* @__PURE__ */ T.jsx(
      Ct.div,
      {
        ...l,
        ref: p,
        style: {
          pointerEvents: w ? b ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: it(t.onFocusCapture, A.onFocusCapture),
        onBlurCapture: it(t.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: it(
          t.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
Fc.displayName = Uit;
var Git = "DismissableLayerBranch", qF = N.forwardRef((t, e) => {
  const n = N.useContext(VF), r = N.useRef(null), i = Jt(e, r);
  return N.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ T.jsx(Ct.div, { ...t, ref: i });
});
qF.displayName = Git;
function Yit(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Di(t), r = N.useRef(!1), i = N.useRef(() => {
  });
  return N.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          UF(
            Wit,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = l, e.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        e.removeEventListener("click", i.current);
      r.current = !1;
    }, o = window.setTimeout(() => {
      e.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(o), e.removeEventListener("pointerdown", a), e.removeEventListener("click", i.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Kit(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Di(t), r = N.useRef(!1);
  return N.useEffect(() => {
    const i = (a) => {
      a.target && !r.current && UF(Zit, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [e, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function IE() {
  const t = new CustomEvent(B7);
  document.dispatchEvent(t);
}
function UF(t, e, n, { discrete: r }) {
  const i = n.originalEvent.target, a = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && i.addEventListener(t, e, { once: !0 }), r ? IF(i, a) : i.dispatchEvent(a);
}
var $it = Fc, Jit = qF, Qit = N.useId || (() => {
}), Xit = 0;
function Xa(t) {
  const [e, n] = N.useState(Qit());
  return Fr(() => {
    n((r) => r ?? String(Xit++));
  }, [t]), e ? `radix-${e}` : "";
}
const eat = ["top", "right", "bottom", "left"], Oo = Math.min, Zi = Math.max, Ty = Math.round, wm = Math.floor, vc = (t) => ({
  x: t,
  y: t
}), tat = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, nat = {
  start: "end",
  end: "start"
};
function H7(t, e, n) {
  return Zi(t, Oo(e, n));
}
function ol(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function sl(t) {
  return t.split("-")[0];
}
function Cd(t) {
  return t.split("-")[1];
}
function qx(t) {
  return t === "x" ? "y" : "x";
}
function Ux(t) {
  return t === "y" ? "height" : "width";
}
function bc(t) {
  return ["top", "bottom"].includes(sl(t)) ? "y" : "x";
}
function Wx(t) {
  return qx(bc(t));
}
function rat(t, e, n) {
  n === void 0 && (n = !1);
  const r = Cd(t), i = Wx(t), a = Ux(i);
  let o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[a] > e.floating[a] && (o = Ey(o)), [o, Ey(o)];
}
function iat(t) {
  const e = Ey(t);
  return [F7(t), e, F7(e)];
}
function F7(t) {
  return t.replace(/start|end/g, (e) => nat[e]);
}
function aat(t, e, n) {
  const r = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? i : r : e ? r : i;
    case "left":
    case "right":
      return e ? a : o;
    default:
      return [];
  }
}
function oat(t, e, n, r) {
  const i = Cd(t);
  let a = aat(sl(t), n === "start", r);
  return i && (a = a.map((o) => o + "-" + i), e && (a = a.concat(a.map(F7)))), a;
}
function Ey(t) {
  return t.replace(/left|right|bottom|top/g, (e) => tat[e]);
}
function sat(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function WF(t) {
  return typeof t != "number" ? sat(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function jy(t) {
  const {
    x: e,
    y: n,
    width: r,
    height: i
  } = t;
  return {
    width: r,
    height: i,
    top: n,
    left: e,
    right: e + r,
    bottom: n + i,
    x: e,
    y: n
  };
}
function PE(t, e, n) {
  let {
    reference: r,
    floating: i
  } = t;
  const a = bc(e), o = Wx(e), s = Ux(o), l = sl(e), c = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (Cd(e)) {
    case "start":
      h[o] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[o] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const lat = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = n, s = a.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(e));
  let c = await o.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: u,
    y: d
  } = PE(c, r, l), f = r, h = {}, p = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: g,
      fn: v
    } = s[m], {
      x: k,
      y: w,
      data: b,
      reset: x
    } = await v({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: i,
      middlewareData: h,
      rects: c,
      platform: o,
      elements: {
        reference: t,
        floating: e
      }
    });
    u = k ?? u, d = w ?? d, h = {
      ...h,
      [g]: {
        ...h[g],
        ...b
      }
    }, x && p <= 50 && (p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (c = x.rects === !0 ? await o.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : x.rects), {
      x: u,
      y: d
    } = PE(c, f, l)), m = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: i,
    middlewareData: h
  };
};
async function Oh(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: i,
    platform: a,
    rects: o,
    elements: s,
    strategy: l
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = ol(e, t), p = WF(h), m = s[f ? d === "floating" ? "reference" : "floating" : d], g = jy(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(m))) == null || n ? m : m.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), v = d === "floating" ? {
    x: r,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, k = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), w = await (a.isElement == null ? void 0 : a.isElement(k)) ? await (a.getScale == null ? void 0 : a.getScale(k)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = jy(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: v,
    offsetParent: k,
    strategy: l
  }) : v);
  return {
    top: (g.top - b.top + p.top) / w.y,
    bottom: (b.bottom - g.bottom + p.bottom) / w.y,
    left: (g.left - b.left + p.left) / w.x,
    right: (b.right - g.right + p.right) / w.x
  };
}
const cat = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: a,
      platform: o,
      elements: s,
      middlewareData: l
    } = e, {
      element: c,
      padding: u = 0
    } = ol(t, e) || {};
    if (c == null)
      return {};
    const d = WF(u), f = {
      x: n,
      y: r
    }, h = Wx(i), p = Ux(h), m = await o.getDimensions(c), g = h === "y", v = g ? "top" : "left", k = g ? "bottom" : "right", w = g ? "clientHeight" : "clientWidth", b = a.reference[p] + a.reference[h] - f[h] - a.floating[p], x = f[h] - a.reference[h], A = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c));
    let L = A ? A[w] : 0;
    (!L || !await (o.isElement == null ? void 0 : o.isElement(A))) && (L = s.floating[w] || a.floating[p]);
    const M = b / 2 - x / 2, j = L / 2 - m[p] / 2 - 1, D = Oo(d[v], j), z = Oo(d[k], j), H = D, V = L - m[p] - z, F = L / 2 - m[p] / 2 + M, _ = H7(H, F, V), W = !l.arrow && Cd(i) != null && F !== _ && a.reference[p] / 2 - (F < H ? D : z) - m[p] / 2 < 0, G = W ? F < H ? F - H : F - V : 0;
    return {
      [h]: f[h] + G,
      data: {
        [h]: _,
        centerOffset: F - _ - G,
        ...W && {
          alignmentOffset: G
        }
      },
      reset: W
    };
  }
}), uat = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, r;
      const {
        placement: i,
        middlewareData: a,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: c
      } = e, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: m = !0,
        ...g
      } = ol(t, e);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const v = sl(i), k = bc(s), w = sl(s) === s, b = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), x = f || (w || !m ? [Ey(s)] : iat(s)), A = p !== "none";
      !f && A && x.push(...oat(s, m, p, b));
      const L = [s, ...x], M = await Oh(e, g), j = [];
      let D = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (u && j.push(M[v]), d) {
        const F = rat(i, o, b);
        j.push(M[F[0]], M[F[1]]);
      }
      if (D = [...D, {
        placement: i,
        overflows: j
      }], !j.every((F) => F <= 0)) {
        var z, H;
        const F = (((z = a.flip) == null ? void 0 : z.index) || 0) + 1, _ = L[F];
        if (_)
          return {
            data: {
              index: F,
              overflows: D
            },
            reset: {
              placement: _
            }
          };
        let W = (H = D.filter((G) => G.overflows[0] <= 0).sort((G, Y) => G.overflows[1] - Y.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!W)
          switch (h) {
            case "bestFit": {
              var V;
              const G = (V = D.filter((Y) => {
                if (A) {
                  const Z = bc(Y.placement);
                  return Z === k || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Z === "y";
                }
                return !0;
              }).map((Y) => [Y.placement, Y.overflows.filter((Z) => Z > 0).reduce((Z, oe) => Z + oe, 0)]).sort((Y, Z) => Y[1] - Z[1])[0]) == null ? void 0 : V[0];
              G && (W = G);
              break;
            }
            case "initialPlacement":
              W = s;
              break;
          }
        if (i !== W)
          return {
            reset: {
              placement: W
            }
          };
      }
      return {};
    }
  };
};
function zE(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function RE(t) {
  return eat.some((e) => t[e] >= 0);
}
const dat = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: r = "referenceHidden",
        ...i
      } = ol(t, e);
      switch (r) {
        case "referenceHidden": {
          const a = await Oh(e, {
            ...i,
            elementContext: "reference"
          }), o = zE(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: RE(o)
            }
          };
        }
        case "escaped": {
          const a = await Oh(e, {
            ...i,
            altBoundary: !0
          }), o = zE(a, n.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: RE(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function fat(t, e) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = t, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = sl(n), s = Cd(n), l = bc(n) === "y", c = ["left", "top"].includes(o) ? -1 : 1, u = a && l ? -1 : 1, d = ol(e, t);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return s && typeof p == "number" && (h = s === "end" ? p * -1 : p), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const hat = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, r;
      const {
        x: i,
        y: a,
        placement: o,
        middlewareData: s
      } = e, l = await fat(e, t);
      return o === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, pat = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: i
      } = e, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (g) => {
            let {
              x: v,
              y: k
            } = g;
            return {
              x: v,
              y: k
            };
          }
        },
        ...l
      } = ol(t, e), c = {
        x: n,
        y: r
      }, u = await Oh(e, l), d = bc(sl(i)), f = qx(d);
      let h = c[f], p = c[d];
      if (a) {
        const g = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", k = h + u[g], w = h - u[v];
        h = H7(k, h, w);
      }
      if (o) {
        const g = d === "y" ? "top" : "left", v = d === "y" ? "bottom" : "right", k = p + u[g], w = p - u[v];
        p = H7(k, p, w);
      }
      const m = s.fn({
        ...e,
        [f]: h,
        [d]: p
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r
        }
      };
    }
  };
}, mat = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: a,
        middlewareData: o
      } = e, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = ol(t, e), u = {
        x: n,
        y: r
      }, d = bc(i), f = qx(d);
      let h = u[f], p = u[d];
      const m = ol(s, e), g = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const w = f === "y" ? "height" : "width", b = a.reference[f] - a.floating[w] + g.mainAxis, x = a.reference[f] + a.reference[w] - g.mainAxis;
        h < b ? h = b : h > x && (h = x);
      }
      if (c) {
        var v, k;
        const w = f === "y" ? "width" : "height", b = ["top", "left"].includes(sl(i)), x = a.reference[d] - a.floating[w] + (b && ((v = o.offset) == null ? void 0 : v[d]) || 0) + (b ? 0 : g.crossAxis), A = a.reference[d] + a.reference[w] + (b ? 0 : ((k = o.offset) == null ? void 0 : k[d]) || 0) - (b ? g.crossAxis : 0);
        p < x ? p = x : p > A && (p = A);
      }
      return {
        [f]: h,
        [d]: p
      };
    }
  };
}, yat = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      const {
        placement: n,
        rects: r,
        platform: i,
        elements: a
      } = e, {
        apply: o = () => {
        },
        ...s
      } = ol(t, e), l = await Oh(e, s), c = sl(n), u = Cd(n), d = bc(n) === "y", {
        width: f,
        height: h
      } = r.floating;
      let p, m;
      c === "top" || c === "bottom" ? (p = c, m = u === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (m = c, p = u === "end" ? "top" : "bottom");
      const g = h - l.top - l.bottom, v = f - l.left - l.right, k = Oo(h - l[p], g), w = Oo(f - l[m], v), b = !e.middlewareData.shift;
      let x = k, A = w;
      if (d ? A = u || b ? Oo(w, v) : v : x = u || b ? Oo(k, g) : g, b && !u) {
        const M = Zi(l.left, 0), j = Zi(l.right, 0), D = Zi(l.top, 0), z = Zi(l.bottom, 0);
        d ? A = f - 2 * (M !== 0 || j !== 0 ? M + j : Zi(l.left, l.right)) : x = h - 2 * (D !== 0 || z !== 0 ? D + z : Zi(l.top, l.bottom));
      }
      await o({
        ...e,
        availableWidth: A,
        availableHeight: x
      });
      const L = await i.getDimensions(a.floating);
      return f !== L.width || h !== L.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ad(t) {
  return ZF(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Qi(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Ml(t) {
  var e;
  return (e = (ZF(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function ZF(t) {
  return t instanceof Node || t instanceof Qi(t).Node;
}
function ao(t) {
  return t instanceof Element || t instanceof Qi(t).Element;
}
function rs(t) {
  return t instanceof HTMLElement || t instanceof Qi(t).HTMLElement;
}
function OE(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Qi(t).ShadowRoot;
}
function op(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: i
  } = oo(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(i);
}
function gat(t) {
  return ["table", "td", "th"].includes(Ad(t));
}
function Pg(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function Zx(t) {
  const e = Gx(), n = ao(t) ? oo(t) : t;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function vat(t) {
  let e = wc(t);
  for (; rs(e) && !V1(e); ) {
    if (Zx(e))
      return e;
    if (Pg(e))
      return null;
    e = wc(e);
  }
  return null;
}
function Gx() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function V1(t) {
  return ["html", "body", "#document"].includes(Ad(t));
}
function oo(t) {
  return Qi(t).getComputedStyle(t);
}
function zg(t) {
  return ao(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function wc(t) {
  if (Ad(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    OE(t) && t.host || // Fallback.
    Ml(t)
  );
  return OE(e) ? e.host : e;
}
function GF(t) {
  const e = wc(t);
  return V1(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : rs(e) && op(e) ? e : GF(e);
}
function Bh(t, e, n) {
  var r;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = GF(t), a = i === ((r = t.ownerDocument) == null ? void 0 : r.body), o = Qi(i);
  return a ? e.concat(o, o.visualViewport || [], op(i) ? i : [], o.frameElement && n ? Bh(o.frameElement) : []) : e.concat(i, Bh(i, [], n));
}
function YF(t) {
  const e = oo(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const i = rs(t), a = i ? t.offsetWidth : n, o = i ? t.offsetHeight : r, s = Ty(n) !== a || Ty(r) !== o;
  return s && (n = a, r = o), {
    width: n,
    height: r,
    $: s
  };
}
function Yx(t) {
  return ao(t) ? t : t.contextElement;
}
function g1(t) {
  const e = Yx(t);
  if (!rs(e))
    return vc(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: i,
    $: a
  } = YF(e);
  let o = (a ? Ty(n.width) : n.width) / r, s = (a ? Ty(n.height) : n.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const bat = /* @__PURE__ */ vc(0);
function KF(t) {
  const e = Qi(t);
  return !Gx() || !e.visualViewport ? bat : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function wat(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== Qi(t) ? !1 : e;
}
function Ju(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), a = Yx(t);
  let o = vc(1);
  e && (r ? ao(r) && (o = g1(r)) : o = g1(t));
  const s = wat(a, n, r) ? KF(a) : vc(0);
  let l = (i.left + s.x) / o.x, c = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
  if (a) {
    const f = Qi(a), h = r && ao(r) ? Qi(r) : r;
    let p = f, m = p.frameElement;
    for (; m && r && h !== p; ) {
      const g = g1(m), v = m.getBoundingClientRect(), k = oo(m), w = v.left + (m.clientLeft + parseFloat(k.paddingLeft)) * g.x, b = v.top + (m.clientTop + parseFloat(k.paddingTop)) * g.y;
      l *= g.x, c *= g.y, u *= g.x, d *= g.y, l += w, c += b, p = Qi(m), m = p.frameElement;
    }
  }
  return jy({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function kat(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: r,
    strategy: i
  } = t;
  const a = i === "fixed", o = Ml(r), s = e ? Pg(e.floating) : !1;
  if (r === o || s && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = vc(1);
  const u = vc(0), d = rs(r);
  if ((d || !d && !a) && ((Ad(r) !== "body" || op(o)) && (l = zg(r)), rs(r))) {
    const f = Ju(r);
    c = g1(r), u.x = f.x + r.clientLeft, u.y = f.y + r.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y
  };
}
function xat(t) {
  return Array.from(t.getClientRects());
}
function $F(t) {
  return Ju(Ml(t)).left + zg(t).scrollLeft;
}
function Mat(t) {
  const e = Ml(t), n = zg(t), r = t.ownerDocument.body, i = Zi(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), a = Zi(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + $F(t);
  const s = -n.scrollTop;
  return oo(r).direction === "rtl" && (o += Zi(e.clientWidth, r.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
function Cat(t, e) {
  const n = Qi(t), r = Ml(t), i = n.visualViewport;
  let a = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, o = i.height;
    const c = Gx();
    (!c || c && e === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function Aat(t, e) {
  const n = Ju(t, !0, e === "fixed"), r = n.top + t.clientTop, i = n.left + t.clientLeft, a = rs(t) ? g1(t) : vc(1), o = t.clientWidth * a.x, s = t.clientHeight * a.y, l = i * a.x, c = r * a.y;
  return {
    width: o,
    height: s,
    x: l,
    y: c
  };
}
function BE(t, e, n) {
  let r;
  if (e === "viewport")
    r = Cat(t, n);
  else if (e === "document")
    r = Mat(Ml(t));
  else if (ao(e))
    r = Aat(e, n);
  else {
    const i = KF(t);
    r = {
      ...e,
      x: e.x - i.x,
      y: e.y - i.y
    };
  }
  return jy(r);
}
function JF(t, e) {
  const n = wc(t);
  return n === e || !ao(n) || V1(n) ? !1 : oo(n).position === "fixed" || JF(n, e);
}
function Sat(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = Bh(t, [], !1).filter((s) => ao(s) && Ad(s) !== "body"), i = null;
  const a = oo(t).position === "fixed";
  let o = a ? wc(t) : t;
  for (; ao(o) && !V1(o); ) {
    const s = oo(o), l = Zx(o);
    !l && s.position === "fixed" && (i = null), (a ? !l && !i : !l && s.position === "static" && i && ["absolute", "fixed"].includes(i.position) || op(o) && !l && JF(t, o)) ? r = r.filter((c) => c !== o) : i = s, o = wc(o);
  }
  return e.set(t, r), r;
}
function Lat(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = t;
  const a = [...n === "clippingAncestors" ? Pg(e) ? [] : Sat(e, this._c) : [].concat(n), r], o = a[0], s = a.reduce((l, c) => {
    const u = BE(e, c, i);
    return l.top = Zi(u.top, l.top), l.right = Oo(u.right, l.right), l.bottom = Oo(u.bottom, l.bottom), l.left = Zi(u.left, l.left), l;
  }, BE(e, o, i));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function Tat(t) {
  const {
    width: e,
    height: n
  } = YF(t);
  return {
    width: e,
    height: n
  };
}
function Eat(t, e, n) {
  const r = rs(e), i = Ml(e), a = n === "fixed", o = Ju(t, !0, a, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = vc(0);
  if (r || !r && !a)
    if ((Ad(e) !== "body" || op(i)) && (s = zg(e)), r) {
      const d = Ju(e, !0, a, e);
      l.x = d.x + e.clientLeft, l.y = d.y + e.clientTop;
    } else i && (l.x = $F(i));
  const c = o.left + s.scrollLeft - l.x, u = o.top + s.scrollTop - l.y;
  return {
    x: c,
    y: u,
    width: o.width,
    height: o.height
  };
}
function a8(t) {
  return oo(t).position === "static";
}
function HE(t, e) {
  return !rs(t) || oo(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function QF(t, e) {
  const n = Qi(t);
  if (Pg(t))
    return n;
  if (!rs(t)) {
    let i = wc(t);
    for (; i && !V1(i); ) {
      if (ao(i) && !a8(i))
        return i;
      i = wc(i);
    }
    return n;
  }
  let r = HE(t, e);
  for (; r && gat(r) && a8(r); )
    r = HE(r, e);
  return r && V1(r) && a8(r) && !Zx(r) ? n : r || vat(t) || n;
}
const jat = async function(t) {
  const e = this.getOffsetParent || QF, n = this.getDimensions, r = await n(t.floating);
  return {
    reference: Eat(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Nat(t) {
  return oo(t).direction === "rtl";
}
const Dat = {
  convertOffsetParentRelativeRectToViewportRelativeRect: kat,
  getDocumentElement: Ml,
  getClippingRect: Lat,
  getOffsetParent: QF,
  getElementRects: jat,
  getClientRects: xat,
  getDimensions: Tat,
  getScale: g1,
  isElement: ao,
  isRTL: Nat
};
function Iat(t, e) {
  let n = null, r;
  const i = Ml(t);
  function a() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const {
      left: c,
      top: u,
      width: d,
      height: f
    } = t.getBoundingClientRect();
    if (s || e(), !d || !f)
      return;
    const h = wm(u), p = wm(i.clientWidth - (c + d)), m = wm(i.clientHeight - (u + f)), g = wm(c), v = {
      rootMargin: -h + "px " + -p + "px " + -m + "px " + -g + "px",
      threshold: Zi(0, Oo(1, l)) || 1
    };
    let k = !0;
    function w(b) {
      const x = b[0].intersectionRatio;
      if (x !== l) {
        if (!k)
          return o();
        x ? o(!1, x) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      k = !1;
    }
    try {
      n = new IntersectionObserver(w, {
        ...v,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(w, v);
    }
    n.observe(t);
  }
  return o(!0), a;
}
function Pat(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = Yx(t), u = i || a ? [...c ? Bh(c) : [], ...Bh(e)] : [];
  u.forEach((v) => {
    i && v.addEventListener("scroll", n, {
      passive: !0
    }), a && v.addEventListener("resize", n);
  });
  const d = c && s ? Iat(c, n) : null;
  let f = -1, h = null;
  o && (h = new ResizeObserver((v) => {
    let [k] = v;
    k && k.target === c && h && (h.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var w;
      (w = h) == null || w.observe(e);
    })), n();
  }), c && !l && h.observe(c), h.observe(e));
  let p, m = l ? Ju(t) : null;
  l && g();
  function g() {
    const v = Ju(t);
    m && (v.x !== m.x || v.y !== m.y || v.width !== m.width || v.height !== m.height) && n(), m = v, p = requestAnimationFrame(g);
  }
  return n(), () => {
    var v;
    u.forEach((k) => {
      i && k.removeEventListener("scroll", n), a && k.removeEventListener("resize", n);
    }), d == null || d(), (v = h) == null || v.disconnect(), h = null, l && cancelAnimationFrame(p);
  };
}
const zat = hat, Rat = pat, Oat = uat, Bat = yat, Hat = dat, FE = cat, Fat = mat, _at = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Dat,
    ...n
  }, a = {
    ...i.platform,
    _c: r
  };
  return lat(t, e, {
    ...i,
    platform: a
  });
};
var H4 = typeof document < "u" ? us : ze;
function Ny(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, r, i;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Ny(t[r], e[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(t), n = i.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(e, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = i[r];
      if (!(a === "_owner" && t.$$typeof) && !Ny(t[a], e[a]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function XF(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function _E(t, e) {
  const n = XF(t);
  return Math.round(e * n) / n;
}
function VE(t) {
  const e = N.useRef(t);
  return H4(() => {
    e.current = t;
  }), e;
}
function Vat(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: a,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = t, [u, d] = N.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = N.useState(r);
  Ny(f, r) || h(r);
  const [p, m] = N.useState(null), [g, v] = N.useState(null), k = N.useCallback((G) => {
    G !== A.current && (A.current = G, m(G));
  }, []), w = N.useCallback((G) => {
    G !== L.current && (L.current = G, v(G));
  }, []), b = a || p, x = o || g, A = N.useRef(null), L = N.useRef(null), M = N.useRef(u), j = l != null, D = VE(l), z = VE(i), H = N.useCallback(() => {
    if (!A.current || !L.current)
      return;
    const G = {
      placement: e,
      strategy: n,
      middleware: f
    };
    z.current && (G.platform = z.current), _at(A.current, L.current, G).then((Y) => {
      const Z = {
        ...Y,
        isPositioned: !0
      };
      V.current && !Ny(M.current, Z) && (M.current = Z, wd.flushSync(() => {
        d(Z);
      }));
    });
  }, [f, e, n, z]);
  H4(() => {
    c === !1 && M.current.isPositioned && (M.current.isPositioned = !1, d((G) => ({
      ...G,
      isPositioned: !1
    })));
  }, [c]);
  const V = N.useRef(!1);
  H4(() => (V.current = !0, () => {
    V.current = !1;
  }), []), H4(() => {
    if (b && (A.current = b), x && (L.current = x), b && x) {
      if (D.current)
        return D.current(b, x, H);
      H();
    }
  }, [b, x, H, D, j]);
  const F = N.useMemo(() => ({
    reference: A,
    floating: L,
    setReference: k,
    setFloating: w
  }), [k, w]), _ = N.useMemo(() => ({
    reference: b,
    floating: x
  }), [b, x]), W = N.useMemo(() => {
    const G = {
      position: n,
      left: 0,
      top: 0
    };
    if (!_.floating)
      return G;
    const Y = _E(_.floating, u.x), Z = _E(_.floating, u.y);
    return s ? {
      ...G,
      transform: "translate(" + Y + "px, " + Z + "px)",
      ...XF(_.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: Y,
      top: Z
    };
  }, [n, s, _.floating, u.x, u.y]);
  return N.useMemo(() => ({
    ...u,
    update: H,
    refs: F,
    elements: _,
    floatingStyles: W
  }), [u, H, F, _, W]);
}
const qat = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof t == "function" ? t(n) : t;
      return r && e(r) ? r.current != null ? FE({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? FE({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, Uat = (t, e) => ({
  ...zat(t),
  options: [t, e]
}), Wat = (t, e) => ({
  ...Rat(t),
  options: [t, e]
}), Zat = (t, e) => ({
  ...Fat(t),
  options: [t, e]
}), Gat = (t, e) => ({
  ...Oat(t),
  options: [t, e]
}), Yat = (t, e) => ({
  ...Bat(t),
  options: [t, e]
}), Kat = (t, e) => ({
  ...Hat(t),
  options: [t, e]
}), $at = (t, e) => ({
  ...qat(t),
  options: [t, e]
});
var Jat = "Arrow", e_ = N.forwardRef((t, e) => {
  const { children: n, width: r = 10, height: i = 5, ...a } = t;
  return /* @__PURE__ */ T.jsx(
    Ct.svg,
    {
      ...a,
      ref: e,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: t.asChild ? n : /* @__PURE__ */ T.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
e_.displayName = Jat;
var Qat = e_, Kx = "Popper", [t_, fs] = ei(Kx), [Xat, n_] = t_(Kx), r_ = (t) => {
  const { __scopePopper: e, children: n } = t, [r, i] = N.useState(null);
  return /* @__PURE__ */ T.jsx(Xat, { scope: e, anchor: r, onAnchorChange: i, children: n });
};
r_.displayName = Kx;
var i_ = "PopperAnchor", a_ = N.forwardRef(
  (t, e) => {
    const { __scopePopper: n, virtualRef: r, ...i } = t, a = n_(i_, n), o = N.useRef(null), s = Jt(e, o);
    return N.useEffect(() => {
      a.onAnchorChange((r == null ? void 0 : r.current) || o.current);
    }), r ? null : /* @__PURE__ */ T.jsx(Ct.div, { ...i, ref: s });
  }
);
a_.displayName = i_;
var $x = "PopperContent", [eot, tot] = t_($x), o_ = N.forwardRef(
  (t, e) => {
    var n, r, i, a, o, s;
    const {
      __scopePopper: l,
      side: c = "bottom",
      sideOffset: u = 0,
      align: d = "center",
      alignOffset: f = 0,
      arrowPadding: h = 0,
      avoidCollisions: p = !0,
      collisionBoundary: m = [],
      collisionPadding: g = 0,
      sticky: v = "partial",
      hideWhenDetached: k = !1,
      updatePositionStrategy: w = "optimized",
      onPlaced: b,
      ...x
    } = t, A = n_($x, l), [L, M] = N.useState(null), j = Jt(e, (pe) => M(pe)), [D, z] = N.useState(null), H = _x(D), V = (H == null ? void 0 : H.width) ?? 0, F = (H == null ? void 0 : H.height) ?? 0, _ = c + (d !== "center" ? "-" + d : ""), W = typeof g == "number" ? g : { top: 0, right: 0, bottom: 0, left: 0, ...g }, G = Array.isArray(m) ? m : [m], Y = G.length > 0, Z = {
      padding: W,
      boundary: G.filter(rot),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: Y
    }, { refs: oe, floatingStyles: ee, placement: ae, isPositioned: fe, middlewareData: me } = Vat({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: _,
      whileElementsMounted: (...pe) => Pat(...pe, {
        animationFrame: w === "always"
      }),
      elements: {
        reference: A.anchor
      },
      middleware: [
        Uat({ mainAxis: u + F, alignmentAxis: f }),
        p && Wat({
          mainAxis: !0,
          crossAxis: !1,
          limiter: v === "partial" ? Zat() : void 0,
          ...Z
        }),
        p && Gat({ ...Z }),
        Yat({
          ...Z,
          apply: ({ elements: pe, rects: J, availableWidth: K, availableHeight: X }) => {
            const { width: re, height: Ie } = J.reference, q = pe.floating.style;
            q.setProperty("--radix-popper-available-width", `${K}px`), q.setProperty("--radix-popper-available-height", `${X}px`), q.setProperty("--radix-popper-anchor-width", `${re}px`), q.setProperty("--radix-popper-anchor-height", `${Ie}px`);
          }
        }),
        D && $at({ element: D, padding: h }),
        iot({ arrowWidth: V, arrowHeight: F }),
        k && Kat({ strategy: "referenceHidden", ...Z })
      ]
    }), [ge, $] = c_(ae), se = Di(b);
    Fr(() => {
      fe && (se == null || se());
    }, [fe, se]);
    const xe = (n = me.arrow) == null ? void 0 : n.x, Oe = (r = me.arrow) == null ? void 0 : r.y, je = ((i = me.arrow) == null ? void 0 : i.centerOffset) !== 0, [Me, he] = N.useState();
    return Fr(() => {
      L && he(window.getComputedStyle(L).zIndex);
    }, [L]), /* @__PURE__ */ T.jsx(
      "div",
      {
        ref: oe.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...ee,
          transform: fe ? ee.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Me,
          "--radix-popper-transform-origin": [
            (a = me.transformOrigin) == null ? void 0 : a.x,
            (o = me.transformOrigin) == null ? void 0 : o.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((s = me.hide) == null ? void 0 : s.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ T.jsx(
          eot,
          {
            scope: l,
            placedSide: ge,
            onArrowChange: z,
            arrowX: xe,
            arrowY: Oe,
            shouldHideArrow: je,
            children: /* @__PURE__ */ T.jsx(
              Ct.div,
              {
                "data-side": ge,
                "data-align": $,
                ...x,
                ref: j,
                style: {
                  ...x.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: fe ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
o_.displayName = $x;
var s_ = "PopperArrow", not = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, l_ = N.forwardRef(function(t, e) {
  const { __scopePopper: n, ...r } = t, i = tot(s_, n), a = not[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ T.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ T.jsx(
          Qat,
          {
            ...r,
            ref: e,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
l_.displayName = s_;
function rot(t) {
  return t !== null;
}
var iot = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var n, r, i;
    const { placement: a, rects: o, middlewareData: s } = e, l = ((n = s.arrow) == null ? void 0 : n.centerOffset) !== 0, c = l ? 0 : t.arrowWidth, u = l ? 0 : t.arrowHeight, [d, f] = c_(a), h = { start: "0%", center: "50%", end: "100%" }[f], p = (((r = s.arrow) == null ? void 0 : r.x) ?? 0) + c / 2, m = (((i = s.arrow) == null ? void 0 : i.y) ?? 0) + u / 2;
    let g = "", v = "";
    return d === "bottom" ? (g = l ? h : `${p}px`, v = `${-u}px`) : d === "top" ? (g = l ? h : `${p}px`, v = `${o.floating.height + u}px`) : d === "right" ? (g = `${-u}px`, v = l ? h : `${m}px`) : d === "left" && (g = `${o.floating.width + u}px`, v = l ? h : `${m}px`), { data: { x: g, y: v } };
  }
});
function c_(t) {
  const [e, n = "center"] = t.split("-");
  return [e, n];
}
var u_ = r_, Sd = a_, sp = o_, lp = l_, aot = "Portal", Ld = N.forwardRef((t, e) => {
  var n;
  const { container: r, ...i } = t, [a, o] = N.useState(!1);
  Fr(() => o(!0), []);
  const s = r || a && ((n = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : n.body);
  return s ? hg.createPortal(/* @__PURE__ */ T.jsx(Ct.div, { ...i, ref: e }), s) : null;
});
Ld.displayName = aot;
function oot(t, e) {
  return N.useReducer((n, r) => e[n][r] ?? n, t);
}
var zi = (t) => {
  const { present: e, children: n } = t, r = sot(e), i = typeof n == "function" ? n({ present: r.isPresent }) : N.Children.only(n), a = Jt(r.ref, lot(i));
  return typeof n == "function" || r.isPresent ? N.cloneElement(i, { ref: a }) : null;
};
zi.displayName = "Presence";
function sot(t) {
  const [e, n] = N.useState(), r = N.useRef({}), i = N.useRef(t), a = N.useRef("none"), o = t ? "mounted" : "unmounted", [s, l] = oot(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return N.useEffect(() => {
    const c = km(r.current);
    a.current = s === "mounted" ? c : "none";
  }, [s]), Fr(() => {
    const c = r.current, u = i.current;
    if (u !== t) {
      const d = a.current, f = km(c);
      t ? l("MOUNT") : f === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && d !== f ? "ANIMATION_OUT" : "UNMOUNT"), i.current = t;
    }
  }, [t, l]), Fr(() => {
    if (e) {
      const c = (d) => {
        const f = km(r.current).includes(d.animationName);
        d.target === e && f && wd.flushSync(() => l("ANIMATION_END"));
      }, u = (d) => {
        d.target === e && (a.current = km(r.current));
      };
      return e.addEventListener("animationstart", u), e.addEventListener("animationcancel", c), e.addEventListener("animationend", c), () => {
        e.removeEventListener("animationstart", u), e.removeEventListener("animationcancel", c), e.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [e, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: N.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function km(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function lot(t) {
  var e, n;
  let r = (e = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : e.get, i = r && "isReactWarning" in r && r.isReactWarning;
  return i ? t.ref : (r = (n = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : n.get, i = r && "isReactWarning" in r && r.isReactWarning, i ? t.props.ref : t.props.ref || t.ref);
}
var cot = "VisuallyHidden", cp = N.forwardRef(
  (t, e) => /* @__PURE__ */ T.jsx(
    Ct.span,
    {
      ...t,
      ref: e,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...t.style
      }
    }
  )
);
cp.displayName = cot;
var d_ = cp, [Rg, sGt] = ei("Tooltip", [
  fs
]), Og = fs(), f_ = "TooltipProvider", uot = 700, _7 = "tooltip.open", [dot, Jx] = Rg(f_), h_ = (t) => {
  const {
    __scopeTooltip: e,
    delayDuration: n = uot,
    skipDelayDuration: r = 300,
    disableHoverableContent: i = !1,
    children: a
  } = t, [o, s] = N.useState(!0), l = N.useRef(!1), c = N.useRef(0);
  return N.useEffect(() => {
    const u = c.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ T.jsx(
    dot,
    {
      scope: e,
      isOpenDelayed: o,
      delayDuration: n,
      onOpen: N.useCallback(() => {
        window.clearTimeout(c.current), s(!1);
      }, []),
      onClose: N.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => s(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: l,
      onPointerInTransitChange: N.useCallback((u) => {
        l.current = u;
      }, []),
      disableHoverableContent: i,
      children: a
    }
  );
};
h_.displayName = f_;
var Bg = "Tooltip", [fot, up] = Rg(Bg), p_ = (t) => {
  const {
    __scopeTooltip: e,
    children: n,
    open: r,
    defaultOpen: i = !1,
    onOpenChange: a,
    disableHoverableContent: o,
    delayDuration: s
  } = t, l = Jx(Bg, t.__scopeTooltip), c = Og(e), [u, d] = N.useState(null), f = Xa(), h = N.useRef(0), p = o ?? l.disableHoverableContent, m = s ?? l.delayDuration, g = N.useRef(!1), [v = !1, k] = mo({
    prop: r,
    defaultProp: i,
    onChange: (L) => {
      L ? (l.onOpen(), document.dispatchEvent(new CustomEvent(_7))) : l.onClose(), a == null || a(L);
    }
  }), w = N.useMemo(() => v ? g.current ? "delayed-open" : "instant-open" : "closed", [v]), b = N.useCallback(() => {
    window.clearTimeout(h.current), g.current = !1, k(!0);
  }, [k]), x = N.useCallback(() => {
    window.clearTimeout(h.current), k(!1);
  }, [k]), A = N.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      g.current = !0, k(!0);
    }, m);
  }, [m, k]);
  return N.useEffect(() => () => window.clearTimeout(h.current), []), /* @__PURE__ */ T.jsx(u_, { ...c, children: /* @__PURE__ */ T.jsx(
    fot,
    {
      scope: e,
      contentId: f,
      open: v,
      stateAttribute: w,
      trigger: u,
      onTriggerChange: d,
      onTriggerEnter: N.useCallback(() => {
        l.isOpenDelayed ? A() : b();
      }, [l.isOpenDelayed, A, b]),
      onTriggerLeave: N.useCallback(() => {
        p ? x() : window.clearTimeout(h.current);
      }, [x, p]),
      onOpen: b,
      onClose: x,
      disableHoverableContent: p,
      children: n
    }
  ) });
};
p_.displayName = Bg;
var V7 = "TooltipTrigger", m_ = N.forwardRef(
  (t, e) => {
    const { __scopeTooltip: n, ...r } = t, i = up(V7, n), a = Jx(V7, n), o = Og(n), s = N.useRef(null), l = Jt(e, s, i.onTriggerChange), c = N.useRef(!1), u = N.useRef(!1), d = N.useCallback(() => c.current = !1, []);
    return N.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ T.jsx(Sd, { asChild: !0, ...o, children: /* @__PURE__ */ T.jsx(
      Ct.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: it(t.onPointerMove, (f) => {
          f.pointerType !== "touch" && !u.current && !a.isPointerInTransitRef.current && (i.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: it(t.onPointerLeave, () => {
          i.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: it(t.onPointerDown, () => {
          c.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: it(t.onFocus, () => {
          c.current || i.onOpen();
        }),
        onBlur: it(t.onBlur, i.onClose),
        onClick: it(t.onClick, i.onClose)
      }
    ) });
  }
);
m_.displayName = V7;
var Qx = "TooltipPortal", [hot, pot] = Rg(Qx, {
  forceMount: void 0
}), y_ = (t) => {
  const { __scopeTooltip: e, forceMount: n, children: r, container: i } = t, a = up(Qx, e);
  return /* @__PURE__ */ T.jsx(hot, { scope: e, forceMount: n, children: /* @__PURE__ */ T.jsx(zi, { present: n || a.open, children: /* @__PURE__ */ T.jsx(Ld, { asChild: !0, container: i, children: r }) }) });
};
y_.displayName = Qx;
var q1 = "TooltipContent", g_ = N.forwardRef(
  (t, e) => {
    const n = pot(q1, t.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...a } = t, o = up(q1, t.__scopeTooltip);
    return /* @__PURE__ */ T.jsx(zi, { present: r || o.open, children: o.disableHoverableContent ? /* @__PURE__ */ T.jsx(v_, { side: i, ...a, ref: e }) : /* @__PURE__ */ T.jsx(mot, { side: i, ...a, ref: e }) });
  }
), mot = N.forwardRef((t, e) => {
  const n = up(q1, t.__scopeTooltip), r = Jx(q1, t.__scopeTooltip), i = N.useRef(null), a = Jt(e, i), [o, s] = N.useState(null), { trigger: l, onClose: c } = n, u = i.current, { onPointerInTransitChange: d } = r, f = N.useCallback(() => {
    s(null), d(!1);
  }, [d]), h = N.useCallback(
    (p, m) => {
      const g = p.currentTarget, v = { x: p.clientX, y: p.clientY }, k = vot(v, g.getBoundingClientRect()), w = bot(v, k), b = wot(m.getBoundingClientRect()), x = xot([...w, ...b]);
      s(x), d(!0);
    },
    [d]
  );
  return N.useEffect(() => () => f(), [f]), N.useEffect(() => {
    if (l && u) {
      const p = (g) => h(g, u), m = (g) => h(g, l);
      return l.addEventListener("pointerleave", p), u.addEventListener("pointerleave", m), () => {
        l.removeEventListener("pointerleave", p), u.removeEventListener("pointerleave", m);
      };
    }
  }, [l, u, h, f]), N.useEffect(() => {
    if (o) {
      const p = (m) => {
        const g = m.target, v = { x: m.clientX, y: m.clientY }, k = (l == null ? void 0 : l.contains(g)) || (u == null ? void 0 : u.contains(g)), w = !kot(v, o);
        k ? f() : w && (f(), c());
      };
      return document.addEventListener("pointermove", p), () => document.removeEventListener("pointermove", p);
    }
  }, [l, u, o, c, f]), /* @__PURE__ */ T.jsx(v_, { ...t, ref: a });
}), [yot, got] = Rg(Bg, { isInside: !1 }), v_ = N.forwardRef(
  (t, e) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": i,
      onEscapeKeyDown: a,
      onPointerDownOutside: o,
      ...s
    } = t, l = up(q1, n), c = Og(n), { onClose: u } = l;
    return N.useEffect(() => (document.addEventListener(_7, u), () => document.removeEventListener(_7, u)), [u]), N.useEffect(() => {
      if (l.trigger) {
        const d = (f) => {
          const h = f.target;
          h != null && h.contains(l.trigger) && u();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [l.trigger, u]), /* @__PURE__ */ T.jsx(
      Fc,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: o,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ T.jsxs(
          sp,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...s,
            ref: e,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ T.jsx(Hx, { children: r }),
              /* @__PURE__ */ T.jsx(yot, { scope: n, isInside: !0, children: /* @__PURE__ */ T.jsx(d_, { id: l.contentId, role: "tooltip", children: i || r }) })
            ]
          }
        )
      }
    );
  }
);
g_.displayName = q1;
var b_ = "TooltipArrow", w_ = N.forwardRef(
  (t, e) => {
    const { __scopeTooltip: n, ...r } = t, i = Og(n);
    return got(
      b_,
      n
    ).isInside ? null : /* @__PURE__ */ T.jsx(lp, { ...i, ...r, ref: e });
  }
);
w_.displayName = b_;
function vot(t, e) {
  const n = Math.abs(e.top - t.y), r = Math.abs(e.bottom - t.y), i = Math.abs(e.right - t.x), a = Math.abs(e.left - t.x);
  switch (Math.min(n, r, i, a)) {
    case a:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function bot(t, e, n = 5) {
  const r = [];
  switch (e) {
    case "top":
      r.push(
        { x: t.x - n, y: t.y + n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x + n, y: t.y - n }
      );
      break;
    case "left":
      r.push(
        { x: t.x + n, y: t.y - n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "right":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x - n, y: t.y + n }
      );
      break;
  }
  return r;
}
function wot(t) {
  const { top: e, right: n, bottom: r, left: i } = t;
  return [
    { x: i, y: e },
    { x: n, y: e },
    { x: n, y: r },
    { x: i, y: r }
  ];
}
function kot(t, e) {
  const { x: n, y: r } = t;
  let i = !1;
  for (let a = 0, o = e.length - 1; a < e.length; o = a++) {
    const s = e[a].x, l = e[a].y, c = e[o].x, u = e[o].y;
    l > r != u > r && n < (c - s) * (r - l) / (u - l) + s && (i = !i);
  }
  return i;
}
function xot(t) {
  const e = t.slice();
  return e.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), Mot(e);
}
function Mot(t) {
  if (t.length <= 1) return t.slice();
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    for (; e.length >= 2; ) {
      const a = e[e.length - 1], o = e[e.length - 2];
      if ((a.x - o.x) * (i.y - o.y) >= (a.y - o.y) * (i.x - o.x)) e.pop();
      else break;
    }
    e.push(i);
  }
  e.pop();
  const n = [];
  for (let r = t.length - 1; r >= 0; r--) {
    const i = t[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], o = n[n.length - 2];
      if ((a.x - o.x) * (i.y - o.y) >= (a.y - o.y) * (i.x - o.x)) n.pop();
      else break;
    }
    n.push(i);
  }
  return n.pop(), e.length === 1 && n.length === 1 && e[0].x === n[0].x && e[0].y === n[0].y ? e : e.concat(n);
}
var Cot = h_, Aot = p_, Sot = m_, Lot = y_, Tot = g_, Eot = w_;
const Xx = xn({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
}), Hg = xn({}), Fg = xn(null), eM = typeof window < "u", tM = eM ? us : ze, k_ = xn({ strict: !1 }), _g = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), jot = "framerAppearId", x_ = "data-" + _g(jot), Not = {
  useManualTiming: !1
};
function Dot(t) {
  let e = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet();
  let o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function s(c) {
    a.has(c) && (l.schedule(c), t()), c(o);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, u = !1, d = !1) => {
      const f = d && r ? e : n;
      return u && a.add(c), f.has(c) || f.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      n.delete(c), a.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (o = c, r) {
        i = !0;
        return;
      }
      r = !0, [e, n] = [n, e], n.clear(), e.forEach(s), r = !1, i && (i = !1, l.process(c));
    }
  };
  return l;
}
const xm = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], Iot = 40;
function M_(t, e) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, a = () => n = !0, o = xm.reduce((m, g) => (m[g] = Dot(a), m), {}), { read: s, resolveKeyframes: l, update: c, preRender: u, render: d, postRender: f } = o, h = () => {
    const m = performance.now();
    n = !1, i.delta = r ? 1e3 / 60 : Math.max(Math.min(m - i.timestamp, Iot), 1), i.timestamp = m, i.isProcessing = !0, s.process(i), l.process(i), c.process(i), u.process(i), d.process(i), f.process(i), i.isProcessing = !1, n && e && (r = !1, t(h));
  }, p = () => {
    n = !0, r = !0, i.isProcessing || t(h);
  };
  return { schedule: xm.reduce((m, g) => {
    const v = o[g];
    return m[g] = (k, w = !1, b = !1) => (n || p(), v.schedule(k, w, b)), m;
  }, {}), cancel: (m) => {
    for (let g = 0; g < xm.length; g++)
      o[xm[g]].cancel(m);
  }, state: i, steps: o };
}
const { schedule: nM } = M_(queueMicrotask, !1);
function t1(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
const C_ = xn({});
let qE = !1;
function Pot(t, e, n, r, i) {
  const { visualElement: a } = Mt(Hg), o = Mt(k_), s = Mt(Fg), l = Mt(Xx).reducedMotion, c = Ue();
  r = r || o.renderer, !c.current && r && (c.current = r(t, {
    visualState: e,
    parent: a,
    props: n,
    presenceContext: s,
    blockInitialAnimation: s ? s.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const u = c.current, d = Mt(C_);
  u && !u.projection && i && (u.type === "html" || u.type === "svg") && Rot(c.current, n, i, d), fg(() => {
    u && u.update(n, s);
  });
  const f = Ue(!!(n[x_] && !window.HandoffComplete));
  return tM(() => {
    u && (u.updateFeatures(), nM.render(u.render), f.current && u.animationState && u.animationState.animateChanges());
  }), ze(() => {
    u && (!f.current && u.animationState && u.animationState.animateChanges(), f.current && (f.current = !1, qE || (qE = !0, queueMicrotask(zot))));
  }), u;
}
function zot() {
  window.HandoffComplete = !0;
}
function Rot(t, e, n, r) {
  const { layoutId: i, layout: a, drag: o, dragConstraints: s, layoutScroll: l, layoutRoot: c } = e;
  t.projection = new n(t.latestValues, e["data-framer-portal-id"] ? void 0 : A_(t.parent)), t.projection.setOptions({
    layoutId: i,
    layout: a,
    alwaysMeasureLayout: !!o || s && t1(s),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: r,
    layoutScroll: l,
    layoutRoot: c
  });
}
function A_(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : A_(t.parent);
}
function Oot(t, e, n) {
  return nt(
    (r) => {
      r && t.mount && t.mount(r), e && (r ? e.mount(r) : e.unmount()), n && (typeof n == "function" ? n(r) : t1(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
function Hh(t) {
  return typeof t == "string" || Array.isArray(t);
}
function Fh(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
const rM = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], iM = ["initial", ...rM];
function Vg(t) {
  return Fh(t.animate) || iM.some((e) => Hh(t[e]));
}
function S_(t) {
  return !!(Vg(t) || t.variants);
}
function Bot(t, e) {
  if (Vg(t)) {
    const { initial: n, animate: r } = t;
    return {
      initial: n === !1 || Hh(n) ? n : void 0,
      animate: Hh(r) ? r : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function Hot(t) {
  const { initial: e, animate: n } = Bot(t, Mt(Hg));
  return Ft(() => ({ initial: e, animate: n }), [UE(e), UE(n)]);
}
function UE(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const WE = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, U1 = {};
for (const t in WE)
  U1[t] = {
    isEnabled: (e) => WE[t].some((n) => !!e[n])
  };
function Fot(t) {
  for (const e in t)
    U1[e] = {
      ...U1[e],
      ...t[e]
    };
}
const aM = xn({}), _ot = Symbol.for("motionComponentSymbol"), Br = (t) => t;
let Td = Br, ll = Br;
process.env.NODE_ENV !== "production" && (Td = (t, e) => {
  !t && typeof console < "u" && console.warn(e);
}, ll = (t, e) => {
  if (!t)
    throw new Error(e);
});
function Vot({ preloadedFeatures: t, createVisualElement: e, useRender: n, useVisualState: r, Component: i }) {
  t && Fot(t);
  function a(s, l) {
    let c;
    const u = {
      ...Mt(Xx),
      ...s,
      layoutId: qot(s)
    }, { isStatic: d } = u, f = Hot(s), h = r(s, d);
    if (!d && eM) {
      Uot(u, t);
      const p = Wot(u);
      c = p.MeasureLayout, f.visualElement = Pot(i, h, u, e, p.ProjectionNode);
    }
    return T.jsxs(Hg.Provider, { value: f, children: [c && f.visualElement ? T.jsx(c, { visualElement: f.visualElement, ...u }) : null, n(i, s, Oot(h, f.visualElement, l), h, d, f.visualElement)] });
  }
  const o = en(a);
  return o[_ot] = i, o;
}
function qot({ layoutId: t }) {
  const e = Mt(aM).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function Uot(t, e) {
  const n = Mt(k_).strict;
  if (process.env.NODE_ENV !== "production" && e && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? Td(!1, r) : ll(!1, r);
  }
}
function Wot(t) {
  const { drag: e, layout: n } = U1;
  if (!e && !n)
    return {};
  const r = { ...e, ...n };
  return {
    MeasureLayout: e != null && e.isEnabled(t) || n != null && n.isEnabled(t) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
function Zot(t) {
  function e(r, i = {}) {
    return Vot(t(r, i));
  }
  if (typeof Proxy > "u")
    return e;
  const n = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, i) => (n.has(i) || n.set(i, e(i)), n.get(i))
  });
}
const Got = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function oM(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
    * If it contains a dash, the element is a custom HTML webcomponent.
    */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Got.indexOf(t) > -1 || /**
      * If it contains a capital letter, it's an SVG component
      */
      /[A-Z]/u.test(t))
    )
  );
}
const Dy = {};
function Yot(t) {
  Object.assign(Dy, t);
}
const dp = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], _c = new Set(dp);
function L_(t, { layout: e, layoutId: n }) {
  return _c.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!Dy[t] || t === "opacity");
}
const Gr = (t) => !!(t && t.getVelocity), Kot = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, $ot = dp.length;
function Jot(t, e, n) {
  let r = "";
  for (let i = 0; i < $ot; i++) {
    const a = dp[i];
    if (t[a] !== void 0) {
      const o = Kot[a] || a;
      r += `${o}(${t[a]}) `;
    }
  }
  return r = r.trim(), n ? r = n(t, e ? "" : r) : e && (r = "none"), r;
}
const T_ = (t) => (e) => typeof e == "string" && e.startsWith(t), E_ = T_("--"), Qot = T_("var(--"), sM = (t) => Qot(t) ? Xot.test(t.split("/*")[0].trim()) : !1, Xot = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, est = (t, e) => e && typeof t == "number" ? e.transform(t) : t, kc = (t, e, n) => n > e ? e : n < t ? t : n, Ed = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, $f = {
  ...Ed,
  transform: (t) => kc(0, 1, t)
}, Mm = {
  ...Ed,
  default: 1
}, Jf = (t) => Math.round(t * 1e5) / 1e5, lM = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu, tst = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu, nst = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function fp(t) {
  return typeof t == "string";
}
function rst(t) {
  return t == null;
}
const hp = (t) => ({
  test: (e) => fp(e) && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), _l = hp("deg"), Zo = hp("%"), Tt = hp("px"), ist = hp("vh"), ast = hp("vw"), ZE = {
  ...Zo,
  parse: (t) => Zo.parse(t) / 100,
  transform: (t) => Zo.transform(t * 100)
}, GE = {
  ...Ed,
  transform: Math.round
}, j_ = {
  // Border props
  borderWidth: Tt,
  borderTopWidth: Tt,
  borderRightWidth: Tt,
  borderBottomWidth: Tt,
  borderLeftWidth: Tt,
  borderRadius: Tt,
  radius: Tt,
  borderTopLeftRadius: Tt,
  borderTopRightRadius: Tt,
  borderBottomRightRadius: Tt,
  borderBottomLeftRadius: Tt,
  // Positioning props
  width: Tt,
  maxWidth: Tt,
  height: Tt,
  maxHeight: Tt,
  size: Tt,
  top: Tt,
  right: Tt,
  bottom: Tt,
  left: Tt,
  // Spacing props
  padding: Tt,
  paddingTop: Tt,
  paddingRight: Tt,
  paddingBottom: Tt,
  paddingLeft: Tt,
  margin: Tt,
  marginTop: Tt,
  marginRight: Tt,
  marginBottom: Tt,
  marginLeft: Tt,
  // Transform props
  rotate: _l,
  rotateX: _l,
  rotateY: _l,
  rotateZ: _l,
  scale: Mm,
  scaleX: Mm,
  scaleY: Mm,
  scaleZ: Mm,
  skew: _l,
  skewX: _l,
  skewY: _l,
  distance: Tt,
  translateX: Tt,
  translateY: Tt,
  translateZ: Tt,
  x: Tt,
  y: Tt,
  z: Tt,
  perspective: Tt,
  transformPerspective: Tt,
  opacity: $f,
  originX: ZE,
  originY: ZE,
  originZ: Tt,
  // Misc
  zIndex: GE,
  backgroundPositionX: Tt,
  backgroundPositionY: Tt,
  // SVG
  fillOpacity: $f,
  strokeOpacity: $f,
  numOctaves: GE
};
function cM(t, e, n) {
  const { style: r, vars: i, transform: a, transformOrigin: o } = t;
  let s = !1, l = !1, c = !0;
  for (const u in e) {
    const d = e[u];
    if (E_(u)) {
      i[u] = d;
      continue;
    }
    const f = j_[u], h = est(d, f);
    if (_c.has(u)) {
      if (s = !0, a[u] = h, !c)
        continue;
      d !== (f.default || 0) && (c = !1);
    } else u.startsWith("origin") ? (l = !0, o[u] = h) : r[u] = h;
  }
  if (e.transform || (s || n ? r.transform = Jot(t.transform, c, n) : r.transform && (r.transform = "none")), l) {
    const { originX: u = "50%", originY: d = "50%", originZ: f = 0 } = o;
    r.transformOrigin = `${u} ${d} ${f}`;
  }
}
const uM = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function N_(t, e, n) {
  for (const r in e)
    !Gr(e[r]) && !L_(r, n) && (t[r] = e[r]);
}
function ost({ transformTemplate: t }, e) {
  return Ft(() => {
    const n = uM();
    return cM(n, e, t), Object.assign({}, n.vars, n.style);
  }, [e]);
}
function sst(t, e) {
  const n = t.style || {}, r = {};
  return N_(r, n, t), Object.assign(r, ost(t, e)), r;
}
function lst(t, e) {
  const n = {}, r = sst(t, e);
  return t.drag && t.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const cst = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Iy(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || cst.has(t);
}
let D_ = (t) => !Iy(t);
function ust(t) {
  t && (D_ = (e) => e.startsWith("on") ? !Iy(e) : t(e));
}
try {
  ust(require("@emotion/is-prop-valid").default);
} catch {
}
function dst(t, e, n) {
  const r = {};
  for (const i in t)
    i === "values" && typeof t.values == "object" || (D_(i) || n === !0 && Iy(i) || !e && !Iy(i) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && i.startsWith("onDrag")) && (r[i] = t[i]);
  return r;
}
function YE(t, e, n) {
  return typeof t == "string" ? t : Tt.transform(e + n * t);
}
function fst(t, e, n) {
  const r = YE(e, t.x, t.width), i = YE(n, t.y, t.height);
  return `${r} ${i}`;
}
const hst = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, pst = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function mst(t, e, n = 1, r = 0, i = !0) {
  t.pathLength = 1;
  const a = i ? hst : pst;
  t[a.offset] = Tt.transform(-r);
  const o = Tt.transform(e), s = Tt.transform(n);
  t[a.array] = `${o} ${s}`;
}
function dM(t, {
  attrX: e,
  attrY: n,
  attrScale: r,
  originX: i,
  originY: a,
  pathLength: o,
  pathSpacing: s = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, u, d) {
  if (cM(t, c, d), u) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: f, style: h, dimensions: p } = t;
  f.transform && (p && (h.transform = f.transform), delete f.transform), p && (i !== void 0 || a !== void 0 || h.transform) && (h.transformOrigin = fst(p, i !== void 0 ? i : 0.5, a !== void 0 ? a : 0.5)), e !== void 0 && (f.x = e), n !== void 0 && (f.y = n), r !== void 0 && (f.scale = r), o !== void 0 && mst(f, o, s, l, !1);
}
const I_ = () => ({
  ...uM(),
  attrs: {}
}), fM = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function yst(t, e, n, r) {
  const i = Ft(() => {
    const a = I_();
    return dM(a, e, fM(r), t.transformTemplate), {
      ...a.attrs,
      style: { ...a.style }
    };
  }, [e]);
  if (t.style) {
    const a = {};
    N_(a, t.style, t), i.style = { ...a, ...i.style };
  }
  return i;
}
function gst(t = !1) {
  return (e, n, r, { latestValues: i }, a) => {
    const o = (oM(e) ? yst : lst)(n, i, a, e), s = dst(n, typeof e == "string", t), l = e !== ds ? { ...s, ...o, ref: r } : {}, { children: c } = n, u = Ft(() => Gr(c) ? c.get() : c, [c]);
    return Ee(e, {
      ...l,
      children: u
    });
  };
}
function P_(t, { style: e, vars: n }, r, i) {
  Object.assign(t.style, e, i && i.getProjectionStyles(r));
  for (const a in n)
    t.style.setProperty(a, n[a]);
}
const z_ = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function R_(t, e, n, r) {
  P_(t, e, void 0, r);
  for (const i in e.attrs)
    t.setAttribute(z_.has(i) ? i : _g(i), e.attrs[i]);
}
function hM(t, e, n) {
  var r;
  const { style: i } = t, a = {};
  for (const o in i)
    (Gr(i[o]) || e.style && Gr(e.style[o]) || L_(o, t) || ((r = n == null ? void 0 : n.getValue(o)) === null || r === void 0 ? void 0 : r.liveStyle) !== void 0) && (a[o] = i[o]);
  return n && i && typeof i.willChange == "string" && (n.applyWillChange = !1), a;
}
function O_(t, e, n) {
  const r = hM(t, e, n);
  for (const i in t)
    if (Gr(t[i]) || Gr(e[i])) {
      const a = dp.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[a] = t[i];
    }
  return r;
}
function KE(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((n, r) => {
    e[0][r] = n.get(), e[1][r] = n.getVelocity();
  }), e;
}
function pM(t, e, n, r) {
  if (typeof e == "function") {
    const [i, a] = KE(r);
    e = e(n !== void 0 ? n : t.custom, i, a);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [i, a] = KE(r);
    e = e(n !== void 0 ? n : t.custom, i, a);
  }
  return e;
}
function B_(t) {
  const e = Ue(null);
  return e.current === null && (e.current = t()), e.current;
}
const q7 = (t) => Array.isArray(t), vst = (t) => !!(t && typeof t == "object" && t.mix && t.toValue), bst = (t) => q7(t) ? t[t.length - 1] || 0 : t;
function F4(t) {
  const e = Gr(t) ? t.get() : t;
  return vst(e) ? e.toValue() : e;
}
const H_ = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
function F_(t) {
  if (_c.has(t))
    return "transform";
  if (H_.has(t))
    return _g(t);
}
function qg(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Ug(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
function wst({ applyWillChange: t = !1, scrapeMotionValuesFromProps: e, createRenderState: n, onMount: r }, i, a, o, s) {
  const l = {
    latestValues: xst(i, a, o, s ? !1 : t, e),
    renderState: n()
  };
  return r && (l.mount = (c) => r(i, c, l)), l;
}
const __ = (t) => (e, n) => {
  const r = Mt(Hg), i = Mt(Fg), a = () => wst(t, e, r, i, n);
  return n ? a() : B_(a);
};
function kst(t, e) {
  const n = F_(e);
  n && qg(t, n);
}
function $E(t, e, n) {
  const r = Array.isArray(e) ? e : [e];
  for (let i = 0; i < r.length; i++) {
    const a = pM(t, r[i]);
    if (a) {
      const { transitionEnd: o, transition: s, ...l } = a;
      n(l, o);
    }
  }
}
function xst(t, e, n, r, i) {
  var a;
  const o = {}, s = [], l = r && ((a = t.style) === null || a === void 0 ? void 0 : a.willChange) === void 0, c = i(t, {});
  for (const g in c)
    o[g] = F4(c[g]);
  let { initial: u, animate: d } = t;
  const f = Vg(t), h = S_(t);
  e && h && !f && t.inherit !== !1 && (u === void 0 && (u = e.initial), d === void 0 && (d = e.animate));
  let p = n ? n.initial === !1 : !1;
  p = p || u === !1;
  const m = p ? d : u;
  return m && typeof m != "boolean" && !Fh(m) && $E(t, m, (g, v) => {
    for (const k in g) {
      let w = g[k];
      if (Array.isArray(w)) {
        const b = p ? w.length - 1 : 0;
        w = w[b];
      }
      w !== null && (o[k] = w);
    }
    for (const k in v)
      o[k] = v[k];
  }), l && (d && u !== !1 && !Fh(d) && $E(t, d, (g) => {
    for (const v in g)
      kst(s, v);
  }), s.length && (o.willChange = s.join(","))), o;
}
const { schedule: fn, cancel: cl, state: Dr, steps: o8 } = M_(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Br, !0), Mst = {
  useVisualState: __({
    scrapeMotionValuesFromProps: O_,
    createRenderState: I_,
    onMount: (t, e, { renderState: n, latestValues: r }) => {
      fn.read(() => {
        try {
          n.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), fn.render(() => {
        dM(n, r, fM(e.tagName), t.transformTemplate), R_(e, n);
      });
    }
  })
}, Cst = {
  useVisualState: __({
    applyWillChange: !0,
    scrapeMotionValuesFromProps: hM,
    createRenderState: uM
  })
};
function Ast(t, { forwardMotionProps: e = !1 }, n, r) {
  return {
    ...oM(t) ? Mst : Cst,
    preloadedFeatures: n,
    useRender: gst(e),
    createVisualElement: r,
    Component: t
  };
}
function Vs(t, e, n, r = { passive: !0 }) {
  return t.addEventListener(e, n, r), () => t.removeEventListener(e, n);
}
const V_ = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1;
function Wg(t, e = "page") {
  return {
    point: {
      x: t[`${e}X`],
      y: t[`${e}Y`]
    }
  };
}
const Sst = (t) => (e) => V_(e) && t(e, Wg(e));
function Gs(t, e, n, r) {
  return Vs(t, e, Sst(n), r);
}
const Lst = (t, e) => (n) => e(t(n)), Ys = (...t) => t.reduce(Lst);
function q_(t) {
  let e = null;
  return () => {
    const n = () => {
      e = null;
    };
    return e === null ? (e = t, n) : !1;
  };
}
const JE = q_("dragHorizontal"), QE = q_("dragVertical");
function U_(t) {
  let e = !1;
  if (t === "y")
    e = QE();
  else if (t === "x")
    e = JE();
  else {
    const n = JE(), r = QE();
    n && r ? e = () => {
      n(), r();
    } : (n && n(), r && r());
  }
  return e;
}
function W_() {
  const t = U_(!0);
  return t ? (t(), !1) : !0;
}
class Vc {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
function XE(t, e) {
  const n = e ? "pointerenter" : "pointerleave", r = e ? "onHoverStart" : "onHoverEnd", i = (a, o) => {
    if (a.pointerType === "touch" || W_())
      return;
    const s = t.getProps();
    t.animationState && s.whileHover && t.animationState.setActive("whileHover", e);
    const l = s[r];
    l && fn.postRender(() => l(a, o));
  };
  return Gs(t.current, n, i, {
    passive: !t.getProps()[r]
  });
}
class Tst extends Vc {
  mount() {
    this.unmount = Ys(XE(this.node, !0), XE(this.node, !1));
  }
  unmount() {
  }
}
class Est extends Vc {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Ys(Vs(this.node.current, "focus", () => this.onFocus()), Vs(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const Z_ = (t, e) => e ? t === e ? !0 : Z_(t, e.parentElement) : !1;
function s8(t, e) {
  if (!e)
    return;
  const n = new PointerEvent("pointer" + t);
  e(n, Wg(n));
}
class jst extends Vc {
  constructor() {
    super(...arguments), this.removeStartListeners = Br, this.removeEndListeners = Br, this.removeAccessibleListeners = Br, this.startPointerPress = (e, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const r = this.node.getProps(), i = Gs(window, "pointerup", (o, s) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: l, onTapCancel: c, globalTapTarget: u } = this.node.getProps(), d = !u && !Z_(this.node.current, o.target) ? c : l;
        d && fn.update(() => d(o, s));
      }, {
        passive: !(r.onTap || r.onPointerUp)
      }), a = Gs(window, "pointercancel", (o, s) => this.cancelPress(o, s), {
        passive: !(r.onTapCancel || r.onPointerCancel)
      });
      this.removeEndListeners = Ys(i, a), this.startPress(e, n);
    }, this.startAccessiblePress = () => {
      const e = (a) => {
        if (a.key !== "Enter" || this.isPressing)
          return;
        const o = (s) => {
          s.key !== "Enter" || !this.checkPressEnd() || s8("up", (l, c) => {
            const { onTap: u } = this.node.getProps();
            u && fn.postRender(() => u(l, c));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = Vs(this.node.current, "keyup", o), s8("down", (s, l) => {
          this.startPress(s, l);
        });
      }, n = Vs(this.node.current, "keydown", e), r = () => {
        this.isPressing && s8("cancel", (a, o) => this.cancelPress(a, o));
      }, i = Vs(this.node.current, "blur", r);
      this.removeAccessibleListeners = Ys(n, i);
    };
  }
  startPress(e, n) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: i } = this.node.getProps();
    i && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && fn.postRender(() => r(e, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !W_();
  }
  cancelPress(e, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && fn.postRender(() => r(e, n));
  }
  mount() {
    const e = this.node.getProps(), n = Gs(e.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
      passive: !(e.onTapStart || e.onPointerStart)
    }), r = Vs(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = Ys(n, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const U7 = /* @__PURE__ */ new WeakMap(), l8 = /* @__PURE__ */ new WeakMap(), Nst = (t) => {
  const e = U7.get(t.target);
  e && e(t);
}, Dst = (t) => {
  t.forEach(Nst);
};
function Ist({ root: t, ...e }) {
  const n = t || document;
  l8.has(n) || l8.set(n, {});
  const r = l8.get(n), i = JSON.stringify(e);
  return r[i] || (r[i] = new IntersectionObserver(Dst, { root: t, ...e })), r[i];
}
function Pst(t, e, n) {
  const r = Ist(e);
  return U7.set(t, n), r.observe(t), () => {
    U7.delete(t), r.unobserve(t);
  };
}
const zst = {
  some: 0,
  all: 1
};
class Rst extends Vc {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: a } = e, o = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : zst[i]
    }, s = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, a && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: u, onViewportLeave: d } = this.node.getProps(), f = c ? u : d;
      f && f(l);
    };
    return Pst(this.node.current, o, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(Ost(e, n)) && this.startObserver();
  }
  unmount() {
  }
}
function Ost({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const Bst = {
  inView: {
    Feature: Rst
  },
  tap: {
    Feature: jst
  },
  focus: {
    Feature: Est
  },
  hover: {
    Feature: Tst
  }
};
function G_(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function Zg(t, e, n) {
  const r = t.getProps();
  return pM(r, e, n !== void 0 ? n : r.custom, t);
}
const Ks = (t) => t * 1e3, $s = (t) => t / 1e3, Hst = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Fst = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), _st = {
  type: "keyframes",
  duration: 0.8
}, Vst = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, qst = (t, { keyframes: e }) => e.length > 2 ? _st : _c.has(t) ? t.startsWith("scale") ? Fst(e[1]) : Hst : Vst;
function Ust({ when: t, delay: e, delayChildren: n, staggerChildren: r, staggerDirection: i, repeat: a, repeatType: o, repeatDelay: s, from: l, elapsed: c, ...u }) {
  return !!Object.keys(u).length;
}
function mM(t, e) {
  return t[e] || t.default || t;
}
const Wst = (t) => t !== null;
function Gg(t, { repeat: e, repeatType: n = "loop" }, r) {
  const i = t.filter(Wst), a = e && n !== "loop" && e % 2 === 1 ? 0 : i.length - 1;
  return !a || r === void 0 ? i[a] : r;
}
let _4;
function Zst() {
  _4 = void 0;
}
const hc = {
  now: () => (_4 === void 0 && hc.set(Dr.isProcessing || Not.useManualTiming ? Dr.timestamp : performance.now()), _4),
  set: (t) => {
    _4 = t, queueMicrotask(Zst);
  }
}, Y_ = (t) => /^0[^.\s]+$/u.test(t);
function Gst(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || Y_(t) : !0;
}
const K_ = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t), Yst = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function Kst(t) {
  const e = Yst.exec(t);
  if (!e)
    return [,];
  const [, n, r, i] = e;
  return [`--${n ?? r}`, i];
}
const $st = 4;
function $_(t, e, n = 1) {
  ll(n <= $st, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
  const [r, i] = Kst(t);
  if (!r)
    return;
  const a = window.getComputedStyle(e).getPropertyValue(r);
  if (a) {
    const o = a.trim();
    return K_(o) ? parseFloat(o) : o;
  }
  return sM(i) ? $_(i, e, n + 1) : i;
}
const Jst = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), ej = (t) => t === Ed || t === Tt, tj = (t, e) => parseFloat(t.split(", ")[e]), nj = (t, e) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const i = r.match(/^matrix3d\((.+)\)$/u);
  if (i)
    return tj(i[1], e);
  {
    const a = r.match(/^matrix\((.+)\)$/u);
    return a ? tj(a[1], t) : 0;
  }
}, Qst = /* @__PURE__ */ new Set(["x", "y", "z"]), Xst = dp.filter((t) => !Qst.has(t));
function elt(t) {
  const e = [];
  return Xst.forEach((n) => {
    const r = t.getValue(n);
    r !== void 0 && (e.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const W1 = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: nj(4, 13),
  y: nj(5, 14)
};
W1.translateX = W1.x;
W1.translateY = W1.y;
const J_ = (t) => (e) => e.test(t), tlt = {
  test: (t) => t === "auto",
  parse: (t) => t
}, Q_ = [Ed, Tt, Zo, _l, ast, ist, tlt], rj = (t) => Q_.find(J_(t)), zu = /* @__PURE__ */ new Set();
let W7 = !1, Z7 = !1;
function X_() {
  if (Z7) {
    const t = Array.from(zu).filter((r) => r.needsMeasurement), e = new Set(t.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    e.forEach((r) => {
      const i = elt(r);
      i.length && (n.set(r, i), r.render());
    }), t.forEach((r) => r.measureInitialState()), e.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([a, o]) => {
        var s;
        (s = r.getValue(a)) === null || s === void 0 || s.set(o);
      });
    }), t.forEach((r) => r.measureEndState()), t.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  Z7 = !1, W7 = !1, zu.forEach((t) => t.complete()), zu.clear();
}
function eV() {
  zu.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (Z7 = !0);
  });
}
function nlt() {
  eV(), X_();
}
class yM {
  constructor(e, n, r, i, a, o = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = r, this.motionValue = i, this.element = a, this.isAsync = o;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (zu.add(this), W7 || (W7 = !0, fn.read(eV), fn.resolveKeyframes(X_))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: r, motionValue: i } = this;
    for (let a = 0; a < e.length; a++)
      if (e[a] === null)
        if (a === 0) {
          const o = i == null ? void 0 : i.get(), s = e[e.length - 1];
          if (o !== void 0)
            e[0] = o;
          else if (r && n) {
            const l = r.readValue(n, s);
            l != null && (e[0] = l);
          }
          e[0] === void 0 && (e[0] = s), i && o === void 0 && i.set(e[0]);
        } else
          e[a] = e[a - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), zu.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, zu.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const gM = (t, e) => (n) => !!(fp(n) && nst.test(n) && n.startsWith(t) || e && !rst(n) && Object.prototype.hasOwnProperty.call(n, e)), tV = (t, e, n) => (r) => {
  if (!fp(r))
    return r;
  const [i, a, o, s] = r.match(lM);
  return {
    [t]: parseFloat(i),
    [e]: parseFloat(a),
    [n]: parseFloat(o),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, rlt = (t) => kc(0, 255, t), c8 = {
  ...Ed,
  transform: (t) => Math.round(rlt(t))
}, Cu = {
  test: gM("rgb", "red"),
  parse: tV("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: r = 1 }) => "rgba(" + c8.transform(t) + ", " + c8.transform(e) + ", " + c8.transform(n) + ", " + Jf($f.transform(r)) + ")"
};
function ilt(t) {
  let e = "", n = "", r = "", i = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7), i = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), r = t.substring(3, 4), i = t.substring(4, 5), e += e, n += n, r += r, i += i), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const G7 = {
  test: gM("#"),
  parse: ilt,
  transform: Cu.transform
}, n1 = {
  test: gM("hsl", "hue"),
  parse: tV("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(t) + ", " + Zo.transform(Jf(e)) + ", " + Zo.transform(Jf(n)) + ", " + Jf($f.transform(r)) + ")"
}, qr = {
  test: (t) => Cu.test(t) || G7.test(t) || n1.test(t),
  parse: (t) => Cu.test(t) ? Cu.parse(t) : n1.test(t) ? n1.parse(t) : G7.parse(t),
  transform: (t) => fp(t) ? t : t.hasOwnProperty("red") ? Cu.transform(t) : n1.transform(t)
};
function alt(t) {
  var e, n;
  return isNaN(t) && fp(t) && (((e = t.match(lM)) === null || e === void 0 ? void 0 : e.length) || 0) + (((n = t.match(tst)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const nV = "number", rV = "color", olt = "var", slt = "var(", ij = "${}", llt = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function _h(t) {
  const e = t.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let a = 0;
  const o = e.replace(llt, (s) => (qr.test(s) ? (r.color.push(a), i.push(rV), n.push(qr.parse(s))) : s.startsWith(slt) ? (r.var.push(a), i.push(olt), n.push(s)) : (r.number.push(a), i.push(nV), n.push(parseFloat(s))), ++a, ij)).split(ij);
  return { values: n, split: o, indexes: r, types: i };
}
function iV(t) {
  return _h(t).values;
}
function aV(t) {
  const { split: e, types: n } = _h(t), r = e.length;
  return (i) => {
    let a = "";
    for (let o = 0; o < r; o++)
      if (a += e[o], i[o] !== void 0) {
        const s = n[o];
        s === nV ? a += Jf(i[o]) : s === rV ? a += qr.transform(i[o]) : a += i[o];
      }
    return a;
  };
}
const clt = (t) => typeof t == "number" ? 0 : t;
function ult(t) {
  const e = iV(t);
  return aV(t)(e.map(clt));
}
const xc = {
  test: alt,
  parse: iV,
  createTransformer: aV,
  getAnimatableNone: ult
}, dlt = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function flt(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [r] = n.match(lM) || [];
  if (!r)
    return t;
  const i = n.replace(r, "");
  let a = dlt.has(e) ? 1 : 0;
  return r !== n && (a *= 100), e + "(" + a + i + ")";
}
const hlt = /\b([a-z-]*)\(.*?\)/gu, Y7 = {
  ...xc,
  getAnimatableNone: (t) => {
    const e = t.match(hlt);
    return e ? e.map(flt).join(" ") : t;
  }
}, plt = {
  ...j_,
  // Color props
  color: qr,
  backgroundColor: qr,
  outlineColor: qr,
  fill: qr,
  stroke: qr,
  // Border props
  borderColor: qr,
  borderTopColor: qr,
  borderRightColor: qr,
  borderBottomColor: qr,
  borderLeftColor: qr,
  filter: Y7,
  WebkitFilter: Y7
}, vM = (t) => plt[t];
function oV(t, e) {
  let n = vM(t);
  return n !== Y7 && (n = xc), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const mlt = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function ylt(t, e, n) {
  let r = 0, i;
  for (; r < t.length && !i; ) {
    const a = t[r];
    typeof a == "string" && !mlt.has(a) && _h(a).values.length && (i = t[r]), r++;
  }
  if (i && n)
    for (const a of e)
      t[a] = oV(n, i);
}
class sV extends yM {
  constructor(e, n, r, i) {
    super(e, n, r, i, i == null ? void 0 : i.owner, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: r } = this;
    if (!n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < e.length; l++) {
      let c = e[l];
      if (typeof c == "string" && (c = c.trim(), sM(c))) {
        const u = $_(c, n.current);
        u !== void 0 && (e[l] = u), l === e.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !Jst.has(r) || e.length !== 2)
      return;
    const [i, a] = e, o = rj(i), s = rj(a);
    if (o !== s)
      if (ej(o) && ej(s))
        for (let l = 0; l < e.length; l++) {
          const c = e[l];
          typeof c == "string" && (e[l] = parseFloat(c));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this, r = [];
    for (let i = 0; i < e.length; i++)
      Gst(e[i]) && r.push(i);
    r.length && ylt(e, r, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: r } = this;
    if (!e.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = W1[r](e.measureViewportBox(), window.getComputedStyle(e.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && e.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    var e;
    const { element: n, name: r, unresolvedKeyframes: i } = this;
    if (!n.current)
      return;
    const a = n.getValue(r);
    a && a.jump(this.measuredOrigin, !1);
    const o = i.length - 1, s = i[o];
    i[o] = W1[r](n.measureViewportBox(), window.getComputedStyle(n.current)), s !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = s), !((e = this.removedTransforms) === null || e === void 0) && e.length && this.removedTransforms.forEach(([l, c]) => {
      n.getValue(l).set(c);
    }), this.resolveNoneKeyframes();
  }
}
function lV(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const aj = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(xc.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function glt(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function vlt(t, e, n, r) {
  const i = t[0];
  if (i === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const a = t[t.length - 1], o = aj(i, e), s = aj(a, e);
  return Td(o === s, `You are trying to animate ${e} from "${i}" to "${a}". ${i} is not an animatable value - to enable this animation set ${i} to a value animatable to ${a} via the \`style\` property.`), !o || !s ? !1 : glt(t) || n === "spring" && r;
}
class cV {
  constructor({ autoplay: e = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: a = 0, repeatType: o = "loop", ...s }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.options = {
      autoplay: e,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: a,
      repeatType: o,
      ...s
    }, this.updateFinishedPromise();
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && nlt(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(e, n) {
    this.hasAttemptedResolve = !0;
    const { name: r, type: i, velocity: a, delay: o, onComplete: s, onUpdate: l, isGenerator: c } = this.options;
    if (!c && !vlt(e, r, i, a))
      if (o)
        this.options.duration = 0;
      else {
        l == null || l(Gg(e, this.options, n)), s == null || s(), this.resolveFinishedPromise();
        return;
      }
    const u = this.initPlayback(e, n);
    u !== !1 && (this._resolved = {
      keyframes: e,
      finalKeyframe: n,
      ...u
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.currentFinishedPromise.then(e, n);
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((e) => {
      this.resolveFinishedPromise = e;
    });
  }
}
function uV(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const blt = 5;
function dV(t, e, n) {
  const r = Math.max(e - blt, 0);
  return uV(n - t(r), e - r);
}
const oj = 1e-3, wlt = 0.01, sj = 10, klt = 0.05, xlt = 1;
function Mlt({ duration: t = 800, bounce: e = 0.25, velocity: n = 0, mass: r = 1 }) {
  let i, a;
  Td(t <= Ks(sj), "Spring duration must be 10 seconds or less");
  let o = 1 - e;
  o = kc(klt, xlt, o), t = kc(wlt, sj, $s(t)), o < 1 ? (i = (c) => {
    const u = c * o, d = u * t, f = u - n, h = K7(c, o), p = Math.exp(-d);
    return oj - f / h * p;
  }, a = (c) => {
    const u = c * o * t, d = u * n + n, f = Math.pow(o, 2) * Math.pow(c, 2) * t, h = Math.exp(-u), p = K7(Math.pow(c, 2), o);
    return (-i(c) + oj > 0 ? -1 : 1) * ((d - f) * h) / p;
  }) : (i = (c) => {
    const u = Math.exp(-c * t), d = (c - n) * t + 1;
    return -1e-3 + u * d;
  }, a = (c) => {
    const u = Math.exp(-c * t), d = (n - c) * (t * t);
    return u * d;
  });
  const s = 5 / t, l = Alt(i, a, s);
  if (t = Ks(t), isNaN(l))
    return {
      stiffness: 100,
      damping: 10,
      duration: t
    };
  {
    const c = Math.pow(l, 2) * r;
    return {
      stiffness: c,
      damping: o * 2 * Math.sqrt(r * c),
      duration: t
    };
  }
}
const Clt = 12;
function Alt(t, e, n) {
  let r = n;
  for (let i = 1; i < Clt; i++)
    r = r - t(r) / e(r);
  return r;
}
function K7(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const Slt = ["duration", "bounce"], Llt = ["stiffness", "damping", "mass"];
function lj(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function Tlt(t) {
  let e = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!lj(t, Llt) && lj(t, Slt)) {
    const n = Mlt(t);
    e = {
      ...e,
      ...n,
      mass: 1
    }, e.isResolvedFromDuration = !0;
  }
  return e;
}
function fV({ keyframes: t, restDelta: e, restSpeed: n, ...r }) {
  const i = t[0], a = t[t.length - 1], o = { done: !1, value: i }, { stiffness: s, damping: l, mass: c, duration: u, velocity: d, isResolvedFromDuration: f } = Tlt({
    ...r,
    velocity: -$s(r.velocity || 0)
  }), h = d || 0, p = l / (2 * Math.sqrt(s * c)), m = a - i, g = $s(Math.sqrt(s / c)), v = Math.abs(m) < 5;
  n || (n = v ? 0.01 : 2), e || (e = v ? 5e-3 : 0.5);
  let k;
  if (p < 1) {
    const w = K7(g, p);
    k = (b) => {
      const x = Math.exp(-p * g * b);
      return a - x * ((h + p * g * m) / w * Math.sin(w * b) + m * Math.cos(w * b));
    };
  } else if (p === 1)
    k = (w) => a - Math.exp(-g * w) * (m + (h + g * m) * w);
  else {
    const w = g * Math.sqrt(p * p - 1);
    k = (b) => {
      const x = Math.exp(-p * g * b), A = Math.min(w * b, 300);
      return a - x * ((h + p * g * m) * Math.sinh(A) + w * m * Math.cosh(A)) / w;
    };
  }
  return {
    calculatedDuration: f && u || null,
    next: (w) => {
      const b = k(w);
      if (f)
        o.done = w >= u;
      else {
        let x = h;
        w !== 0 && (p < 1 ? x = dV(k, w, b) : x = 0);
        const A = Math.abs(x) <= n, L = Math.abs(a - b) <= e;
        o.done = A && L;
      }
      return o.value = o.done ? a : b, o;
    }
  };
}
function cj({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: a = 500, modifyTarget: o, min: s, max: l, restDelta: c = 0.5, restSpeed: u }) {
  const d = t[0], f = {
    done: !1,
    value: d
  }, h = (M) => s !== void 0 && M < s || l !== void 0 && M > l, p = (M) => s === void 0 ? l : l === void 0 || Math.abs(s - M) < Math.abs(l - M) ? s : l;
  let m = n * e;
  const g = d + m, v = o === void 0 ? g : o(g);
  v !== g && (m = v - d);
  const k = (M) => -m * Math.exp(-M / r), w = (M) => v + k(M), b = (M) => {
    const j = k(M), D = w(M);
    f.done = Math.abs(j) <= c, f.value = f.done ? v : D;
  };
  let x, A;
  const L = (M) => {
    h(f.value) && (x = M, A = fV({
      keyframes: [f.value, p(f.value)],
      velocity: dV(w, M, f.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: a,
      restDelta: c,
      restSpeed: u
    }));
  };
  return L(0), {
    calculatedDuration: null,
    next: (M) => {
      let j = !1;
      return !A && x === void 0 && (j = !0, b(M), L(M)), x !== void 0 && M >= x ? A.next(M - x) : (!j && b(M), f);
    }
  };
}
const hV = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, Elt = 1e-7, jlt = 12;
function Nlt(t, e, n, r, i) {
  let a, o, s = 0;
  do
    o = e + (n - e) / 2, a = hV(o, r, i) - t, a > 0 ? n = o : e = o;
  while (Math.abs(a) > Elt && ++s < jlt);
  return o;
}
function pp(t, e, n, r) {
  if (t === e && n === r)
    return Br;
  const i = (a) => Nlt(a, 0, 1, t, n);
  return (a) => a === 0 || a === 1 ? a : hV(i(a), e, r);
}
const Dlt = pp(0.42, 0, 1, 1), Ilt = pp(0, 0, 0.58, 1), pV = pp(0.42, 0, 0.58, 1), Plt = (t) => Array.isArray(t) && typeof t[0] != "number", mV = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, yV = (t) => (e) => 1 - t(1 - e), bM = (t) => 1 - Math.sin(Math.acos(t)), gV = yV(bM), zlt = mV(bM), vV = pp(0.33, 1.53, 0.69, 0.99), wM = yV(vV), Rlt = mV(wM), Olt = (t) => (t *= 2) < 1 ? 0.5 * wM(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), uj = {
  linear: Br,
  easeIn: Dlt,
  easeInOut: pV,
  easeOut: Ilt,
  circIn: bM,
  circInOut: zlt,
  circOut: gV,
  backIn: wM,
  backInOut: Rlt,
  backOut: vV,
  anticipate: Olt
}, dj = (t) => {
  if (Array.isArray(t)) {
    ll(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [e, n, r, i] = t;
    return pp(e, n, r, i);
  } else if (typeof t == "string")
    return ll(uj[t] !== void 0, `Invalid easing type '${t}'`), uj[t];
  return t;
}, Vh = (t, e, n) => {
  const r = e - t;
  return r === 0 ? 1 : (n - t) / r;
}, Hn = (t, e, n) => t + (e - t) * n;
function u8(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function Blt({ hue: t, saturation: e, lightness: n, alpha: r }) {
  t /= 360, e /= 100, n /= 100;
  let i = 0, a = 0, o = 0;
  if (!e)
    i = a = o = n;
  else {
    const s = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - s;
    i = u8(l, s, t + 1 / 3), a = u8(l, s, t), o = u8(l, s, t - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(a * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
function Py(t, e) {
  return (n) => n > 0 ? e : t;
}
const d8 = (t, e, n) => {
  const r = t * t, i = n * (e * e - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, Hlt = [G7, Cu, n1], Flt = (t) => Hlt.find((e) => e.test(t));
function fj(t) {
  const e = Flt(t);
  if (Td(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`), !e)
    return !1;
  let n = e.parse(t);
  return e === n1 && (n = Blt(n)), n;
}
const hj = (t, e) => {
  const n = fj(t), r = fj(e);
  if (!n || !r)
    return Py(t, e);
  const i = { ...n };
  return (a) => (i.red = d8(n.red, r.red, a), i.green = d8(n.green, r.green, a), i.blue = d8(n.blue, r.blue, a), i.alpha = Hn(n.alpha, r.alpha, a), Cu.transform(i));
}, $7 = /* @__PURE__ */ new Set(["none", "hidden"]);
function _lt(t, e) {
  return $7.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
function Vlt(t, e) {
  return (n) => Hn(t, e, n);
}
function kM(t) {
  return typeof t == "number" ? Vlt : typeof t == "string" ? sM(t) ? Py : qr.test(t) ? hj : Wlt : Array.isArray(t) ? bV : typeof t == "object" ? qr.test(t) ? hj : qlt : Py;
}
function bV(t, e) {
  const n = [...t], r = n.length, i = t.map((a, o) => kM(a)(a, e[o]));
  return (a) => {
    for (let o = 0; o < r; o++)
      n[o] = i[o](a);
    return n;
  };
}
function qlt(t, e) {
  const n = { ...t, ...e }, r = {};
  for (const i in n)
    t[i] !== void 0 && e[i] !== void 0 && (r[i] = kM(t[i])(t[i], e[i]));
  return (i) => {
    for (const a in r)
      n[a] = r[a](i);
    return n;
  };
}
function Ult(t, e) {
  var n;
  const r = [], i = { color: 0, var: 0, number: 0 };
  for (let a = 0; a < e.values.length; a++) {
    const o = e.types[a], s = t.indexes[o][i[o]], l = (n = t.values[s]) !== null && n !== void 0 ? n : 0;
    r[a] = l, i[o]++;
  }
  return r;
}
const Wlt = (t, e) => {
  const n = xc.createTransformer(e), r = _h(t), i = _h(e);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? $7.has(t) && !i.values.length || $7.has(e) && !r.values.length ? _lt(t, e) : Ys(bV(Ult(r, i), i.values), n) : (Td(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), Py(t, e));
};
function wV(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? Hn(t, e, n) : kM(t)(t, e);
}
function Zlt(t, e, n) {
  const r = [], i = n || wV, a = t.length - 1;
  for (let o = 0; o < a; o++) {
    let s = i(t[o], t[o + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[o] || Br : e;
      s = Ys(l, s);
    }
    r.push(s);
  }
  return r;
}
function Glt(t, e, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const a = t.length;
  if (ll(a === e.length, "Both input and output ranges must be the same length"), a === 1)
    return () => e[0];
  if (a === 2 && t[0] === t[1])
    return () => e[1];
  t[0] > t[a - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const o = Zlt(e, r, i), s = o.length, l = (c) => {
    let u = 0;
    if (s > 1)
      for (; u < t.length - 2 && !(c < t[u + 1]); u++)
        ;
    const d = Vh(t[u], t[u + 1], c);
    return o[u](d);
  };
  return n ? (c) => l(kc(t[0], t[a - 1], c)) : l;
}
function Ylt(t, e) {
  const n = t[t.length - 1];
  for (let r = 1; r <= e; r++) {
    const i = Vh(0, e, r);
    t.push(Hn(n, 1, i));
  }
}
function Klt(t) {
  const e = [0];
  return Ylt(e, t.length - 1), e;
}
function $lt(t, e) {
  return t.map((n) => n * e);
}
function Jlt(t, e) {
  return t.map(() => e || pV).splice(0, t.length - 1);
}
function zy({ duration: t = 300, keyframes: e, times: n, ease: r = "easeInOut" }) {
  const i = Plt(r) ? r.map(dj) : dj(r), a = {
    done: !1,
    value: e[0]
  }, o = $lt(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : Klt(e),
    t
  ), s = Glt(o, e, {
    ease: Array.isArray(i) ? i : Jlt(e, i)
  });
  return {
    calculatedDuration: t,
    next: (l) => (a.value = s(l), a.done = l >= t, a)
  };
}
const pj = 2e4;
function Qlt(t) {
  let e = 0;
  const n = 50;
  let r = t.next(e);
  for (; !r.done && e < pj; )
    e += n, r = t.next(e);
  return e >= pj ? 1 / 0 : e;
}
const Xlt = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: () => fn.update(e, !0),
    stop: () => cl(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Dr.isProcessing ? Dr.timestamp : hc.now()
  };
}, ect = {
  decay: cj,
  inertia: cj,
  tween: zy,
  keyframes: zy,
  spring: fV
}, tct = (t) => t / 100;
class xM extends cV {
  constructor({ KeyframeResolver: e = yM, ...n }) {
    super(n), this.holdTime = null, this.startTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: s } = this.options;
      s && s();
    };
    const { name: r, motionValue: i, keyframes: a } = this.options, o = (s, l) => this.onKeyframesResolved(s, l);
    r && i && i.owner ? this.resolver = i.owner.resolveKeyframes(a, o, r, i) : this.resolver = new e(a, o, r, i), this.resolver.scheduleResolve();
  }
  initPlayback(e) {
    const { type: n = "keyframes", repeat: r = 0, repeatDelay: i = 0, repeatType: a, velocity: o = 0 } = this.options, s = ect[n] || zy;
    let l, c;
    s !== zy && typeof e[0] != "number" && (process.env.NODE_ENV !== "production" && ll(e.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${e}`), l = Ys(tct, wV(e[0], e[1])), e = [0, 100]);
    const u = s({ ...this.options, keyframes: e });
    a === "mirror" && (c = s({
      ...this.options,
      keyframes: [...e].reverse(),
      velocity: -o
    })), u.calculatedDuration === null && (u.calculatedDuration = Qlt(u));
    const { calculatedDuration: d } = u, f = d + i, h = f * (r + 1) - i;
    return {
      generator: u,
      mirroredGenerator: c,
      mapPercentToKeyframes: l,
      calculatedDuration: d,
      resolvedDuration: f,
      totalDuration: h
    };
  }
  onPostResolved() {
    const { autoplay: e = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !e ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(e, n = !1) {
    const { resolved: r } = this;
    if (!r) {
      const { keyframes: M } = this.options;
      return { done: !0, value: M[M.length - 1] };
    }
    const { finalKeyframe: i, generator: a, mirroredGenerator: o, mapPercentToKeyframes: s, keyframes: l, calculatedDuration: c, totalDuration: u, resolvedDuration: d } = r;
    if (this.startTime === null)
      return a.next(0);
    const { delay: f, repeat: h, repeatType: p, repeatDelay: m, onUpdate: g } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - u / this.speed, this.startTime)), n ? this.currentTime = e : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(e - this.startTime) * this.speed;
    const v = this.currentTime - f * (this.speed >= 0 ? 1 : -1), k = this.speed >= 0 ? v < 0 : v > u;
    this.currentTime = Math.max(v, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = u);
    let w = this.currentTime, b = a;
    if (h) {
      const M = Math.min(this.currentTime, u) / d;
      let j = Math.floor(M), D = M % 1;
      !D && M >= 1 && (D = 1), D === 1 && j--, j = Math.min(j, h + 1), j % 2 && (p === "reverse" ? (D = 1 - D, m && (D -= m / d)) : p === "mirror" && (b = o)), w = kc(0, 1, D) * d;
    }
    const x = k ? { done: !1, value: l[0] } : b.next(w);
    s && (x.value = s(x.value));
    let { done: A } = x;
    !k && c !== null && (A = this.speed >= 0 ? this.currentTime >= u : this.currentTime <= 0);
    const L = this.holdTime === null && (this.state === "finished" || this.state === "running" && A);
    return L && i !== void 0 && (x.value = Gg(l, this.options, i)), g && g(x.value), L && this.finish(), x;
  }
  get duration() {
    const { resolved: e } = this;
    return e ? $s(e.calculatedDuration) : 0;
  }
  get time() {
    return $s(this.currentTime);
  }
  set time(e) {
    e = Ks(e), this.currentTime = e, this.holdTime !== null || this.speed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    const n = this.playbackSpeed !== e;
    this.playbackSpeed = e, n && (this.time = $s(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: e = Xlt, onPlay: n } = this.options;
    this.driver || (this.driver = e((i) => this.tick(i))), n && n();
    const r = this.driver.now();
    this.holdTime !== null ? this.startTime = r - this.holdTime : (!this.startTime || this.state === "finished") && (this.startTime = r), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var e;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (e = this.currentTime) !== null && e !== void 0 ? e : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: e } = this.options;
    e && e();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
}
const kV = (t) => Array.isArray(t) && typeof t[0] == "number";
function xV(t) {
  return !!(!t || typeof t == "string" && t in MM || kV(t) || Array.isArray(t) && t.every(xV));
}
const Df = ([t, e, n, r]) => `cubic-bezier(${t}, ${e}, ${n}, ${r})`, MM = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: Df([0, 0.65, 0.55, 1]),
  circOut: Df([0.55, 0, 1, 0.45]),
  backIn: Df([0.31, 0.01, 0.66, -0.59]),
  backOut: Df([0.33, 1.53, 0.69, 0.99])
};
function nct(t) {
  return MV(t) || MM.easeOut;
}
function MV(t) {
  if (t)
    return kV(t) ? Df(t) : Array.isArray(t) ? t.map(nct) : MM[t];
}
function rct(t, e, n, { delay: r = 0, duration: i = 300, repeat: a = 0, repeatType: o = "loop", ease: s, times: l } = {}) {
  const c = { [e]: n };
  l && (c.offset = l);
  const u = MV(s);
  return Array.isArray(u) && (c.easing = u), t.animate(c, {
    delay: r,
    duration: i,
    easing: Array.isArray(u) ? "linear" : u,
    fill: "both",
    iterations: a + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  });
}
const ict = lV(() => Object.hasOwnProperty.call(Element.prototype, "animate")), Ry = 10, act = 2e4;
function oct(t) {
  return t.type === "spring" || !xV(t.ease);
}
function sct(t, e) {
  const n = new xM({
    ...e,
    keyframes: t,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let r = { done: !1, value: t[0] };
  const i = [];
  let a = 0;
  for (; !r.done && a < act; )
    r = n.sample(a), i.push(r.value), a += Ry;
  return {
    times: void 0,
    keyframes: i,
    duration: a - Ry,
    ease: "linear"
  };
}
class mj extends cV {
  constructor(e) {
    super(e);
    const { name: n, motionValue: r, keyframes: i } = this.options;
    this.resolver = new sV(i, (a, o) => this.onKeyframesResolved(a, o), n, r), this.resolver.scheduleResolve();
  }
  initPlayback(e, n) {
    var r;
    let { duration: i = 300, times: a, ease: o, type: s, motionValue: l, name: c } = this.options;
    if (!(!((r = l.owner) === null || r === void 0) && r.current))
      return !1;
    if (oct(this.options)) {
      const { onComplete: d, onUpdate: f, motionValue: h, ...p } = this.options, m = sct(e, p);
      e = m.keyframes, e.length === 1 && (e[1] = e[0]), i = m.duration, a = m.times, o = m.ease, s = "keyframes";
    }
    const u = rct(l.owner.current, c, e, { ...this.options, duration: i, times: a, ease: o });
    return u.startTime = hc.now(), this.pendingTimeline ? (u.timeline = this.pendingTimeline, this.pendingTimeline = void 0) : u.onfinish = () => {
      const { onComplete: d } = this.options;
      l.set(Gg(e, this.options, n)), d && d(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: u,
      duration: i,
      times: a,
      type: s,
      ease: o,
      keyframes: e
    };
  }
  get duration() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { duration: n } = e;
    return $s(n);
  }
  get time() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { animation: n } = e;
    return $s(n.currentTime || 0);
  }
  set time(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.currentTime = Ks(e);
  }
  get speed() {
    const { resolved: e } = this;
    if (!e)
      return 1;
    const { animation: n } = e;
    return n.playbackRate;
  }
  set speed(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.playbackRate = e;
  }
  get state() {
    const { resolved: e } = this;
    if (!e)
      return "idle";
    const { animation: n } = e;
    return n.playState;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(e) {
    if (!this._resolved)
      this.pendingTimeline = e;
    else {
      const { resolved: n } = this;
      if (!n)
        return Br;
      const { animation: r } = n;
      r.timeline = e, r.onfinish = null;
    }
    return Br;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n, keyframes: r, duration: i, type: a, ease: o, times: s } = e;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: c, onUpdate: u, onComplete: d, ...f } = this.options, h = new xM({
        ...f,
        keyframes: r,
        duration: i,
        type: a,
        ease: o,
        times: s,
        isGenerator: !0
      }), p = Ks(this.time);
      c.setWithVelocity(h.sample(p - Ry).value, h.sample(p).value, Ry);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: e } = this;
    e && e.animation.finish();
  }
  cancel() {
    const { resolved: e } = this;
    e && e.animation.cancel();
  }
  static supports(e) {
    const { motionValue: n, name: r, repeatDelay: i, repeatType: a, damping: o, type: s } = e;
    return ict() && r && H_.has(r) && n && n.owner && n.owner.current instanceof HTMLElement && /**
    * If we're outputting values to onUpdate then we can't use WAAPI as there's
    * no way to read the value from WAAPI every frame.
    */
    !n.owner.getProps().onUpdate && !i && a !== "mirror" && o !== 0 && s !== "inertia";
  }
}
function lct(t, e) {
  let n;
  const r = () => {
    const { currentTime: i } = e, a = (i === null ? 0 : i.value) / 100;
    n !== a && t(a), n = a;
  };
  return fn.update(r, !0), () => cl(r);
}
const cct = lV(() => window.ScrollTimeline !== void 0);
class uct {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  then(e, n) {
    return Promise.all(this.animations).then(e).catch(n);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][e] = n;
  }
  attachTimeline(e) {
    const n = this.animations.map((r) => {
      if (cct() && r.attachTimeline)
        r.attachTimeline(e);
      else
        return r.pause(), lct((i) => {
          r.time = r.duration * i;
        }, e);
    });
    return () => {
      n.forEach((r, i) => {
        r && r(), this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get duration() {
    let e = 0;
    for (let n = 0; n < this.animations.length; n++)
      e = Math.max(e, this.animations[n].duration);
    return e;
  }
  runAll(e) {
    this.animations.forEach((n) => n[e]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
const CM = (t, e, n, r = {}, i, a, o) => (s) => {
  const l = mM(r, t) || {}, c = l.delay || r.delay || 0;
  let { elapsed: u = 0 } = r;
  u = u - Ks(c);
  let d = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...l,
    delay: -u,
    onUpdate: (h) => {
      e.set(h), l.onUpdate && l.onUpdate(h);
    },
    onComplete: () => {
      s(), l.onComplete && l.onComplete(), o && o();
    },
    onStop: o,
    name: t,
    motionValue: e,
    element: a ? void 0 : i
  };
  Ust(l) || (d = {
    ...d,
    ...qst(t, d)
  }), d.duration && (d.duration = Ks(d.duration)), d.repeatDelay && (d.repeatDelay = Ks(d.repeatDelay)), d.from !== void 0 && (d.keyframes[0] = d.from);
  let f = !1;
  if ((d.type === !1 || d.duration === 0 && !d.repeatDelay) && (d.duration = 0, d.delay === 0 && (f = !0)), f && !a && e.get() !== void 0) {
    const h = Gg(d.keyframes, l);
    if (h !== void 0)
      return fn.update(() => {
        d.onUpdate(h), d.onComplete();
      }), new uct([]);
  }
  return !a && mj.supports(d) ? new mj(d) : new xM(d);
};
class AM {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return qg(this.subscriptions, e), () => Ug(this.subscriptions, e);
  }
  notify(e, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](e, n, r);
      else
        for (let a = 0; a < i; a++) {
          const o = this.subscriptions[a];
          o && o(e, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const yj = /* @__PURE__ */ new Set();
function SM(t, e, n) {
  t || yj.has(e) || (console.warn(e), yj.add(e));
}
const gj = 30, dct = (t) => !isNaN(parseFloat(t));
class CV {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(e, n = {}) {
    this.version = "11.3.17", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, i = !0) => {
      const a = hc.now();
      this.updatedAt !== a && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), i && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = hc.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = dct(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && SM(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new AM());
    const r = this.events[e].add(n);
    return e === "change" ? () => {
      r(), fn.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(e, n) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = hc.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > gj)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, gj);
    return uV(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function qh(t, e) {
  return new CV(t, e);
}
function fct(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, qh(n));
}
function hct(t, e) {
  const n = Zg(t, e);
  let { transitionEnd: r = {}, transition: i = {}, ...a } = n || {};
  a = { ...a, ...r };
  for (const o in a) {
    const s = bst(a[o]);
    fct(t, o, s);
  }
}
function AV(t) {
  return t.getProps()[x_];
}
class pct extends CV {
  constructor() {
    super(...arguments), this.output = [], this.counts = /* @__PURE__ */ new Map();
  }
  add(e) {
    const n = F_(e);
    if (!n)
      return;
    const r = this.counts.get(n) || 0;
    this.counts.set(n, r + 1), r === 0 && (this.output.push(n), this.update());
    let i = !1;
    return () => {
      if (i)
        return;
      i = !0;
      const a = this.counts.get(n) - 1;
      this.counts.set(n, a), a === 0 && (Ug(this.output, n), this.update());
    };
  }
  update() {
    this.set(this.output.length ? this.output.join(", ") : "auto");
  }
}
function mct(t) {
  return !!(Gr(t) && t.add);
}
function J7(t, e) {
  var n;
  if (!t.applyWillChange)
    return;
  let r = t.getValue("willChange");
  if (!r && !(!((n = t.props.style) === null || n === void 0) && n.willChange) && (r = new pct("auto"), t.addValue("willChange", r)), mct(r))
    return r.add(e);
}
function yct({ protectedKeys: t, needsAnimating: e }, n) {
  const r = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, r;
}
function SV(t, e, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  var a;
  let { transition: o = t.getDefaultTransition(), transitionEnd: s, ...l } = e;
  r && (o = r);
  const c = [], u = i && t.animationState && t.animationState.getState()[i];
  for (const d in l) {
    const f = t.getValue(d, (a = t.latestValues[d]) !== null && a !== void 0 ? a : null), h = l[d];
    if (h === void 0 || u && yct(u, d))
      continue;
    const p = {
      delay: n,
      elapsed: 0,
      ...mM(o || {}, d)
    };
    let m = !1;
    if (window.HandoffAppearAnimations) {
      const v = AV(t);
      if (v) {
        const k = window.HandoffAppearAnimations(v, d, f, fn);
        k !== null && (p.elapsed = k, m = !0);
      }
    }
    f.start(CM(d, f, h, t.shouldReduceMotion && _c.has(d) ? { type: !1 } : p, t, m, J7(t, d)));
    const g = f.animation;
    g && c.push(g);
  }
  return s && Promise.all(c).then(() => {
    fn.update(() => {
      s && hct(t, s);
    });
  }), c;
}
function Q7(t, e, n = {}) {
  var r;
  const i = Zg(t, e, n.type === "exit" ? (r = t.presenceContext) === null || r === void 0 ? void 0 : r.custom : void 0);
  let { transition: a = t.getDefaultTransition() || {} } = i || {};
  n.transitionOverride && (a = n.transitionOverride);
  const o = i ? () => Promise.all(SV(t, i, n)) : () => Promise.resolve(), s = t.variantChildren && t.variantChildren.size ? (c = 0) => {
    const { delayChildren: u = 0, staggerChildren: d, staggerDirection: f } = a;
    return gct(t, e, u + c, d, f, n);
  } : () => Promise.resolve(), { when: l } = a;
  if (l) {
    const [c, u] = l === "beforeChildren" ? [o, s] : [s, o];
    return c().then(() => u());
  } else
    return Promise.all([o(), s(n.delay)]);
}
function gct(t, e, n = 0, r = 0, i = 1, a) {
  const o = [], s = (t.variantChildren.size - 1) * r, l = i === 1 ? (c = 0) => c * r : (c = 0) => s - c * r;
  return Array.from(t.variantChildren).sort(vct).forEach((c, u) => {
    c.notify("AnimationStart", e), o.push(Q7(c, e, {
      ...a,
      delay: n + l(u)
    }).then(() => c.notify("AnimationComplete", e)));
  }), Promise.all(o);
}
function vct(t, e) {
  return t.sortNodePosition(e);
}
function bct(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let r;
  if (Array.isArray(e)) {
    const i = e.map((a) => Q7(t, a, n));
    r = Promise.all(i);
  } else if (typeof e == "string")
    r = Q7(t, e, n);
  else {
    const i = typeof e == "function" ? Zg(t, e, n.custom) : e;
    r = Promise.all(SV(t, i, n));
  }
  return r.then(() => {
    fn.postRender(() => {
      t.notify("AnimationComplete", e);
    });
  });
}
const wct = [...rM].reverse(), kct = rM.length;
function xct(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: r }) => bct(t, n, r)));
}
function Mct(t) {
  let e = xct(t), n = vj(), r = !0;
  const i = (l) => (c, u) => {
    var d;
    const f = Zg(t, u, l === "exit" ? (d = t.presenceContext) === null || d === void 0 ? void 0 : d.custom : void 0);
    if (f) {
      const { transition: h, transitionEnd: p, ...m } = f;
      c = { ...c, ...m, ...p };
    }
    return c;
  };
  function a(l) {
    e = l(t);
  }
  function o(l) {
    const c = t.getProps(), u = t.getVariantContext(!0) || {}, d = [], f = /* @__PURE__ */ new Set();
    let h = {}, p = 1 / 0;
    for (let g = 0; g < kct; g++) {
      const v = wct[g], k = n[v], w = c[v] !== void 0 ? c[v] : u[v], b = Hh(w), x = v === l ? k.isActive : null;
      x === !1 && (p = g);
      let A = w === u[v] && w !== c[v] && b;
      if (A && r && t.manuallyAnimateOnMount && (A = !1), k.protectedKeys = { ...h }, // If it isn't active and hasn't *just* been set as inactive
      !k.isActive && x === null || // If we didn't and don't have any defined prop for this animation type
      !w && !k.prevProp || // Or if the prop doesn't define an animation
      Fh(w) || typeof w == "boolean")
        continue;
      let L = Cct(k.prevProp, w) || // If we're making this variant active, we want to always make it active
      v === l && k.isActive && !A && b || // If we removed a higher-priority variant (i is in reverse order)
      g > p && b, M = !1;
      const j = Array.isArray(w) ? w : [w];
      let D = j.reduce(i(v), {});
      x === !1 && (D = {});
      const { prevResolvedValues: z = {} } = k, H = {
        ...z,
        ...D
      }, V = (F) => {
        L = !0, f.has(F) && (M = !0, f.delete(F)), k.needsAnimating[F] = !0;
        const _ = t.getValue(F);
        _ && (_.liveStyle = !1);
      };
      for (const F in H) {
        const _ = D[F], W = z[F];
        if (h.hasOwnProperty(F))
          continue;
        let G = !1;
        q7(_) && q7(W) ? G = !G_(_, W) : G = _ !== W, G ? _ != null ? V(F) : f.add(F) : _ !== void 0 && f.has(F) ? V(F) : k.protectedKeys[F] = !0;
      }
      k.prevProp = w, k.prevResolvedValues = D, k.isActive && (h = { ...h, ...D }), r && t.blockInitialAnimation && (L = !1), L && (!A || M) && d.push(...j.map((F) => ({
        animation: F,
        options: { type: v }
      })));
    }
    if (f.size) {
      const g = {};
      f.forEach((v) => {
        const k = t.getBaseTarget(v), w = t.getValue(v);
        w && (w.liveStyle = !0), g[v] = k ?? null;
      }), d.push({ animation: g });
    }
    let m = !!d.length;
    return r && (c.initial === !1 || c.initial === c.animate) && !t.manuallyAnimateOnMount && (m = !1), r = !1, m ? e(d) : Promise.resolve();
  }
  function s(l, c) {
    var u;
    if (n[l].isActive === c)
      return Promise.resolve();
    (u = t.variantChildren) === null || u === void 0 || u.forEach((f) => {
      var h;
      return (h = f.animationState) === null || h === void 0 ? void 0 : h.setActive(l, c);
    }), n[l].isActive = c;
    const d = o(l);
    for (const f in n)
      n[f].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: o,
    setActive: s,
    setAnimateFunction: a,
    getState: () => n,
    reset: () => {
      n = vj(), r = !0;
    }
  };
}
function Cct(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !G_(e, t) : !1;
}
function Xc(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function vj() {
  return {
    animate: Xc(!0),
    whileInView: Xc(),
    whileHover: Xc(),
    whileTap: Xc(),
    whileDrag: Xc(),
    whileFocus: Xc(),
    exit: Xc()
  };
}
class Act extends Vc {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = Mct(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    Fh(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) === null || e === void 0 || e.call(this);
  }
}
let Sct = 0;
class Lct extends Vc {
  constructor() {
    super(...arguments), this.id = Sct++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === r)
      return;
    const i = this.node.animationState.setActive("exit", !e);
    n && !e && i.then(() => n(this.id));
  }
  mount() {
    const { register: e } = this.node.presenceContext || {};
    e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const Tct = {
  animation: {
    Feature: Act
  },
  exit: {
    Feature: Lct
  }
}, bj = (t, e) => Math.abs(t - e);
function Ect(t, e) {
  const n = bj(t.x, e.x), r = bj(t.y, e.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class LV {
  constructor(e, n, { transformPagePoint: r, contextWindow: i, dragSnapToOrigin: a = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = h8(this.lastMoveEventInfo, this.history), f = this.startEvent !== null, h = Ect(d.offset, { x: 0, y: 0 }) >= 3;
      if (!f && !h)
        return;
      const { point: p } = d, { timestamp: m } = Dr;
      this.history.push({ ...p, timestamp: m });
      const { onStart: g, onMove: v } = this.handlers;
      f || (g && g(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), v && v(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, f) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = f8(f, this.transformPagePoint), fn.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, f) => {
      this.end();
      const { onEnd: h, onSessionEnd: p, resumeAnimation: m } = this.handlers;
      if (this.dragSnapToOrigin && m && m(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const g = h8(d.type === "pointercancel" ? this.lastMoveEventInfo : f8(f, this.transformPagePoint), this.history);
      this.startEvent && h && h(d, g), p && p(d, g);
    }, !V_(e))
      return;
    this.dragSnapToOrigin = a, this.handlers = n, this.transformPagePoint = r, this.contextWindow = i || window;
    const o = Wg(e), s = f8(o, this.transformPagePoint), { point: l } = s, { timestamp: c } = Dr;
    this.history = [{ ...l, timestamp: c }];
    const { onSessionStart: u } = n;
    u && u(e, h8(s, this.history)), this.removeListeners = Ys(Gs(this.contextWindow, "pointermove", this.handlePointerMove), Gs(this.contextWindow, "pointerup", this.handlePointerUp), Gs(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), cl(this.updatePoint);
  }
}
function f8(t, e) {
  return e ? { point: e(t.point) } : t;
}
function wj(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function h8({ point: t }, e) {
  return {
    point: t,
    delta: wj(t, TV(e)),
    offset: wj(t, jct(e)),
    velocity: Nct(e, 0.1)
  };
}
function jct(t) {
  return t[0];
}
function TV(t) {
  return t[t.length - 1];
}
function Nct(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let n = t.length - 1, r = null;
  const i = TV(t);
  for (; n >= 0 && (r = t[n], !(i.timestamp - r.timestamp > Ks(e))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const a = $s(i.timestamp - r.timestamp);
  if (a === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (i.x - r.x) / a,
    y: (i.y - r.y) / a
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
const EV = 1e-4, Dct = 1 - EV, Ict = 1 + EV, jV = 0.01, Pct = 0 - jV, zct = 0 + jV;
function na(t) {
  return t.max - t.min;
}
function Rct(t, e, n) {
  return Math.abs(t - e) <= n;
}
function kj(t, e, n, r = 0.5) {
  t.origin = r, t.originPoint = Hn(e.min, e.max, t.origin), t.scale = na(n) / na(e), t.translate = Hn(n.min, n.max, t.origin) - t.originPoint, (t.scale >= Dct && t.scale <= Ict || isNaN(t.scale)) && (t.scale = 1), (t.translate >= Pct && t.translate <= zct || isNaN(t.translate)) && (t.translate = 0);
}
function Qf(t, e, n, r) {
  kj(t.x, e.x, n.x, r ? r.originX : void 0), kj(t.y, e.y, n.y, r ? r.originY : void 0);
}
function xj(t, e, n) {
  t.min = n.min + e.min, t.max = t.min + na(e);
}
function Oct(t, e, n) {
  xj(t.x, e.x, n.x), xj(t.y, e.y, n.y);
}
function Mj(t, e, n) {
  t.min = e.min - n.min, t.max = t.min + na(e);
}
function Xf(t, e, n) {
  Mj(t.x, e.x, n.x), Mj(t.y, e.y, n.y);
}
function Bct(t, { min: e, max: n }, r) {
  return e !== void 0 && t < e ? t = r ? Hn(e, t, r.min) : Math.max(t, e) : n !== void 0 && t > n && (t = r ? Hn(n, t, r.max) : Math.min(t, n)), t;
}
function Cj(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function Hct(t, { top: e, left: n, bottom: r, right: i }) {
  return {
    x: Cj(t.x, n, i),
    y: Cj(t.y, e, r)
  };
}
function Aj(t, e) {
  let n = e.min - t.min, r = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([n, r] = [r, n]), { min: n, max: r };
}
function Fct(t, e) {
  return {
    x: Aj(t.x, e.x),
    y: Aj(t.y, e.y)
  };
}
function _ct(t, e) {
  let n = 0.5;
  const r = na(t), i = na(e);
  return i > r ? n = Vh(e.min, e.max - r, t.min) : r > i && (n = Vh(t.min, t.max - i, e.min)), kc(0, 1, n);
}
function Vct(t, e) {
  const n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
const X7 = 0.35;
function qct(t = X7) {
  return t === !1 ? t = 0 : t === !0 && (t = X7), {
    x: Sj(t, "left", "right"),
    y: Sj(t, "top", "bottom")
  };
}
function Sj(t, e, n) {
  return {
    min: Lj(t, e),
    max: Lj(t, n)
  };
}
function Lj(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const Tj = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), r1 = () => ({
  x: Tj(),
  y: Tj()
}), Ej = () => ({ min: 0, max: 0 }), Qn = () => ({
  x: Ej(),
  y: Ej()
});
function ya(t) {
  return [t("x"), t("y")];
}
function NV({ top: t, left: e, right: n, bottom: r }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: r }
  };
}
function Uct({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function Wct(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), r = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function p8(t) {
  return t === void 0 || t === 1;
}
function e9({ scale: t, scaleX: e, scaleY: n }) {
  return !p8(t) || !p8(e) || !p8(n);
}
function su(t) {
  return e9(t) || DV(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function DV(t) {
  return jj(t.x) || jj(t.y);
}
function jj(t) {
  return t && t !== "0%";
}
function Oy(t, e, n) {
  const r = t - n, i = e * r;
  return n + i;
}
function Nj(t, e, n, r, i) {
  return i !== void 0 && (t = Oy(t, i, r)), Oy(t, n, r) + e;
}
function t9(t, e = 0, n = 1, r, i) {
  t.min = Nj(t.min, e, n, r, i), t.max = Nj(t.max, e, n, r, i);
}
function IV(t, { x: e, y: n }) {
  t9(t.x, e.translate, e.scale, e.originPoint), t9(t.y, n.translate, n.scale, n.originPoint);
}
const Dj = 0.999999999999, Ij = 1.0000000000001;
function Zct(t, e, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  e.x = e.y = 1;
  let a, o;
  for (let s = 0; s < i; s++) {
    a = n[s], o = a.projectionDelta;
    const { visualElement: l } = a.options;
    l && l.props.style && l.props.style.display === "contents" || (r && a.options.layoutScroll && a.scroll && a !== a.root && a1(t, {
      x: -a.scroll.offset.x,
      y: -a.scroll.offset.y
    }), o && (e.x *= o.x.scale, e.y *= o.y.scale, IV(t, o)), r && su(a.latestValues) && a1(t, a.latestValues));
  }
  e.x < Ij && e.x > Dj && (e.x = 1), e.y < Ij && e.y > Dj && (e.y = 1);
}
function i1(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function Pj(t, e, n, r, i = 0.5) {
  const a = Hn(t.min, t.max, i);
  t9(t, e, n, a, r);
}
function a1(t, e) {
  Pj(t.x, e.x, e.scaleX, e.scale, e.originX), Pj(t.y, e.y, e.scaleY, e.scale, e.originY);
}
function PV(t, e) {
  return NV(Wct(t.getBoundingClientRect(), e));
}
function Gct(t, e, n) {
  const r = PV(t, n), { scroll: i } = e;
  return i && (i1(r.x, i.offset.x), i1(r.y, i.offset.y)), r;
}
const zV = ({ current: t }) => t ? t.ownerDocument.defaultView : null, Yct = /* @__PURE__ */ new WeakMap();
class Kct {
  constructor(e) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Qn(), this.visualElement = e;
  }
  start(e, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const i = (u) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(Wg(u, "page").point);
    }, a = (u, d) => {
      var f;
      const { drag: h, dragPropagation: p, onDragStart: m } = this.getProps();
      if (h && !p && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = U_(h), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), ya((v) => {
        let k = this.getAxisMotionValue(v).get() || 0;
        if (Zo.test(k)) {
          const { projection: w } = this.visualElement;
          if (w && w.layout) {
            const b = w.layout.layoutBox[v];
            b && (k = na(b) * (parseFloat(k) / 100));
          }
        }
        this.originPoint[v] = k;
      }), m && fn.postRender(() => m(u, d)), (f = this.removeWillChange) === null || f === void 0 || f.call(this), this.removeWillChange = J7(this.visualElement, "transform");
      const { animationState: g } = this.visualElement;
      g && g.setActive("whileDrag", !0);
    }, o = (u, d) => {
      const { dragPropagation: f, dragDirectionLock: h, onDirectionLock: p, onDrag: m } = this.getProps();
      if (!f && !this.openGlobalLock)
        return;
      const { offset: g } = d;
      if (h && this.currentDirection === null) {
        this.currentDirection = $ct(g), this.currentDirection !== null && p && p(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, g), this.updateAxis("y", d.point, g), this.visualElement.render(), m && m(u, d);
    }, s = (u, d) => this.stop(u, d), l = () => ya((u) => {
      var d;
      return this.getAnimationState(u) === "paused" && ((d = this.getAxisMotionValue(u).animation) === null || d === void 0 ? void 0 : d.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new LV(e, {
      onSessionStart: i,
      onStart: a,
      onMove: o,
      onSessionEnd: s,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      contextWindow: zV(this.visualElement)
    });
  }
  stop(e, n) {
    var r;
    (r = this.removeWillChange) === null || r === void 0 || r.call(this);
    const i = this.isDragging;
    if (this.cancel(), !i)
      return;
    const { velocity: a } = n;
    this.startAnimation(a);
    const { onDragEnd: o } = this.getProps();
    o && fn.postRender(() => o(e, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: n } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(e, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !Cm(e, i, this.currentDirection))
      return;
    const a = this.getAxisMotionValue(e);
    let o = this.originPoint[e] + r[e];
    this.constraints && this.constraints[e] && (o = Bct(o, this.constraints[e], this.elastic[e])), a.set(o);
  }
  resolveConstraints() {
    var e;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (e = this.visualElement.projection) === null || e === void 0 ? void 0 : e.layout, a = this.constraints;
    n && t1(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && i ? this.constraints = Hct(i.layoutBox, n) : this.constraints = !1, this.elastic = qct(r), a !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && ya((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = Vct(i.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: n } = this.getProps();
    if (!e || !t1(e))
      return !1;
    const r = e.current;
    ll(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const a = Gct(r, i.root, this.visualElement.getTransformPagePoint());
    let o = Fct(i.layout.layoutBox, a);
    if (n) {
      const s = n(Uct(o));
      this.hasMutatedConstraints = !!s, s && (o = NV(s));
    }
    return o;
  }
  startAnimation(e) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: a, dragSnapToOrigin: o, onDragTransitionEnd: s } = this.getProps(), l = this.constraints || {}, c = ya((u) => {
      if (!Cm(u, n, this.currentDirection))
        return;
      let d = l && l[u] || {};
      o && (d = { min: 0, max: 0 });
      const f = i ? 200 : 1e6, h = i ? 40 : 1e7, p = {
        type: "inertia",
        velocity: r ? e[u] : 0,
        bounceStiffness: f,
        bounceDamping: h,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...a,
        ...d
      };
      return this.startAxisValueAnimation(u, p);
    });
    return Promise.all(c).then(s);
  }
  startAxisValueAnimation(e, n) {
    const r = this.getAxisMotionValue(e);
    return r.start(CM(e, r, 0, n, this.visualElement, !1, J7(this.visualElement, e)));
  }
  stopAnimation() {
    ya((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    ya((e) => {
      var n;
      return (n = this.getAxisMotionValue(e).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(e) {
    var n;
    return (n = this.getAxisMotionValue(e).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const n = `_drag${e.toUpperCase()}`, r = this.visualElement.getProps();
    return r[n] || this.visualElement.getValue(e, (r.initial ? r.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    ya((n) => {
      const { drag: r } = this.getProps();
      if (!Cm(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, a = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: o, max: s } = i.layout.layoutBox[n];
        a.set(e[n] - Hn(o, s, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!t1(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    ya((o) => {
      const s = this.getAxisMotionValue(o);
      if (s && this.constraints !== !1) {
        const l = s.get();
        i[o] = _ct({ min: l, max: l }, this.constraints[o]);
      }
    });
    const { transformTemplate: a } = this.visualElement.getProps();
    this.visualElement.current.style.transform = a ? a({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), ya((o) => {
      if (!Cm(o, e, null))
        return;
      const s = this.getAxisMotionValue(o), { min: l, max: c } = this.constraints[o];
      s.set(Hn(l, c, i[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    Yct.set(this.visualElement, this);
    const e = this.visualElement.current, n = Gs(e, "pointerdown", (l) => {
      const { drag: c, dragListener: u = !0 } = this.getProps();
      c && u && this.start(l);
    }), r = () => {
      const { dragConstraints: l } = this.getProps();
      t1(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, a = i.addEventListener("measure", r);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), fn.read(r);
    const o = Vs(window, "resize", () => this.scalePositionWithinConstraints()), s = i.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && (ya((u) => {
        const d = this.getAxisMotionValue(u);
        d && (this.originPoint[u] += l[u].translate, d.set(d.get() + l[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), n(), a(), s && s();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: a = !1, dragElastic: o = X7, dragMomentum: s = !0 } = e;
    return {
      ...e,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: a,
      dragElastic: o,
      dragMomentum: s
    };
  }
}
function Cm(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function $ct(t, e = 10) {
  let n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
class Jct extends Vc {
  constructor(e) {
    super(e), this.removeGroupControls = Br, this.removeListeners = Br, this.controls = new Kct(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Br;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const zj = (t) => (e, n) => {
  t && fn.postRender(() => t(e, n));
};
class Qct extends Vc {
  constructor() {
    super(...arguments), this.removePointerDownListener = Br;
  }
  onPointerDown(e) {
    this.session = new LV(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: zV(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: zj(e),
      onStart: zj(n),
      onMove: r,
      onEnd: (a, o) => {
        delete this.session, i && fn.postRender(() => i(a, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Gs(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function Xct() {
  const t = Mt(Fg);
  if (t === null)
    return [!0, null];
  const { isPresent: e, onExitComplete: n, register: r } = t, i = bd();
  ze(() => r(i), []);
  const a = nt(() => n && n(i), [i, n]);
  return !e && n ? [!1, a] : [!0];
}
const V4 = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function Rj(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const of = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (Tt.test(t))
        t = parseFloat(t);
      else
        return t;
    const n = Rj(t, e.target.x), r = Rj(t, e.target.y);
    return `${n}% ${r}%`;
  }
}, eut = {
  correct: (t, { treeScale: e, projectionDelta: n }) => {
    const r = t, i = xc.parse(t);
    if (i.length > 5)
      return r;
    const a = xc.createTransformer(t), o = typeof i[0] != "number" ? 1 : 0, s = n.x.scale * e.x, l = n.y.scale * e.y;
    i[0 + o] /= s, i[1 + o] /= l;
    const c = Hn(s, l, 0.5);
    return typeof i[2 + o] == "number" && (i[2 + o] /= c), typeof i[3 + o] == "number" && (i[3 + o] /= c), a(i);
  }
};
class tut extends Wk {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: a } = e;
    Yot(nut), a && (n.group && n.group.add(a), r && r.register && i && r.register(a), a.root.didUpdate(), a.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), a.setOptions({
      ...a.options,
      onExitComplete: () => this.safeToRemove()
    })), V4.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: a } = this.props, o = r.projection;
    return o && (o.isPresent = a, i || e.layoutDependency !== n || n === void 0 ? o.willUpdate() : this.safeToRemove(), e.isPresent !== a && (a ? o.promote() : o.relegate() || fn.postRender(() => {
      const s = o.getStack();
      (!s || !s.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), nM.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = e;
    i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function RV(t) {
  const [e, n] = Xct(), r = Mt(aM);
  return T.jsx(tut, { ...t, layoutGroup: r, switchLayoutGroup: Mt(C_), isPresent: e, safeToRemove: n });
}
const nut = {
  borderRadius: {
    ...of,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: of,
  borderTopRightRadius: of,
  borderBottomLeftRadius: of,
  borderBottomRightRadius: of,
  boxShadow: eut
}, OV = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], rut = OV.length, Oj = (t) => typeof t == "string" ? parseFloat(t) : t, Bj = (t) => typeof t == "number" || Tt.test(t);
function iut(t, e, n, r, i, a) {
  i ? (t.opacity = Hn(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    aut(r)
  ), t.opacityExit = Hn(e.opacity !== void 0 ? e.opacity : 1, 0, out(r))) : a && (t.opacity = Hn(e.opacity !== void 0 ? e.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let o = 0; o < rut; o++) {
    const s = `border${OV[o]}Radius`;
    let l = Hj(e, s), c = Hj(n, s);
    l === void 0 && c === void 0 || (l || (l = 0), c || (c = 0), l === 0 || c === 0 || Bj(l) === Bj(c) ? (t[s] = Math.max(Hn(Oj(l), Oj(c), r), 0), (Zo.test(c) || Zo.test(l)) && (t[s] += "%")) : t[s] = c);
  }
  (e.rotate || n.rotate) && (t.rotate = Hn(e.rotate || 0, n.rotate || 0, r));
}
function Hj(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const aut = BV(0, 0.5, gV), out = BV(0.5, 0.95, Br);
function BV(t, e, n) {
  return (r) => r < t ? 0 : r > e ? 1 : n(Vh(t, e, r));
}
function Fj(t, e) {
  t.min = e.min, t.max = e.max;
}
function da(t, e) {
  Fj(t.x, e.x), Fj(t.y, e.y);
}
function _j(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
function Vj(t, e, n, r, i) {
  return t -= e, t = Oy(t, 1 / n, r), i !== void 0 && (t = Oy(t, 1 / i, r)), t;
}
function sut(t, e = 0, n = 1, r = 0.5, i, a = t, o = t) {
  if (Zo.test(e) && (e = parseFloat(e), e = Hn(o.min, o.max, e / 100) - o.min), typeof e != "number")
    return;
  let s = Hn(a.min, a.max, r);
  t === a && (s -= e), t.min = Vj(t.min, e, n, s, i), t.max = Vj(t.max, e, n, s, i);
}
function qj(t, e, [n, r, i], a, o) {
  sut(t, e[n], e[r], e[i], e.scale, a, o);
}
const lut = ["x", "scaleX", "originX"], cut = ["y", "scaleY", "originY"];
function Uj(t, e, n, r) {
  qj(t.x, e, lut, n ? n.x : void 0, r ? r.x : void 0), qj(t.y, e, cut, n ? n.y : void 0, r ? r.y : void 0);
}
function Wj(t) {
  return t.translate === 0 && t.scale === 1;
}
function HV(t) {
  return Wj(t.x) && Wj(t.y);
}
function Zj(t, e) {
  return t.min === e.min && t.max === e.max;
}
function uut(t, e) {
  return Zj(t.x, e.x) && Zj(t.y, e.y);
}
function Gj(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function FV(t, e) {
  return Gj(t.x, e.x) && Gj(t.y, e.y);
}
function Yj(t) {
  return na(t.x) / na(t.y);
}
function Kj(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
class dut {
  constructor() {
    this.members = [];
  }
  add(e) {
    qg(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (Ug(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(e) {
    const n = this.members.findIndex((i) => e === i);
    if (n === 0)
      return !1;
    let r;
    for (let i = n; i >= 0; i--) {
      const a = this.members[i];
      if (a.isPresent !== !1) {
        r = a;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(e, n) {
    const r = this.lead;
    if (e !== r && (this.prevLead = r, this.lead = e, e.show(), r)) {
      r.instance && r.scheduleRender(), e.scheduleRender(), e.resumeFrom = r, n && (e.resumeFrom.preserveOpacity = !0), r.snapshot && (e.snapshot = r.snapshot, e.snapshot.latestValues = r.animationValues || r.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: i } = e.options;
      i === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: n, resumingFrom: r } = e;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function fut(t, e, n) {
  let r = "";
  const i = t.x.translate / e.x, a = t.y.translate / e.y, o = (n == null ? void 0 : n.z) || 0;
  if ((i || a || o) && (r = `translate3d(${i}px, ${a}px, ${o}px) `), (e.x !== 1 || e.y !== 1) && (r += `scale(${1 / e.x}, ${1 / e.y}) `), n) {
    const { transformPerspective: c, rotate: u, rotateX: d, rotateY: f, skewX: h, skewY: p } = n;
    c && (r = `perspective(${c}px) ${r}`), u && (r += `rotate(${u}deg) `), d && (r += `rotateX(${d}deg) `), f && (r += `rotateY(${f}deg) `), h && (r += `skewX(${h}deg) `), p && (r += `skewY(${p}deg) `);
  }
  const s = t.x.scale * e.x, l = t.y.scale * e.y;
  return (s !== 1 || l !== 1) && (r += `scale(${s}, ${l})`), r || "none";
}
const hut = (t, e) => t.depth - e.depth;
class put {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    qg(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    Ug(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(hut), this.isDirty = !1, this.children.forEach(e);
  }
}
function mut(t, e) {
  const n = hc.now(), r = ({ timestamp: i }) => {
    const a = i - n;
    a >= e && (cl(r), t(a - e));
  };
  return fn.read(r, !0), () => cl(r);
}
function yut(t) {
  return t instanceof SVGElement && t.tagName !== "svg";
}
function gut(t, e, n) {
  const r = Gr(t) ? t : qh(t);
  return r.start(CM("", r, e, n)), r.animation;
}
const lu = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
}, If = typeof window < "u" && window.MotionDebug !== void 0, m8 = ["", "X", "Y", "Z"], vut = { visibility: "hidden" }, $j = 1e3;
let but = 0;
function y8(t, e, n, r) {
  const { latestValues: i } = e;
  i[t] && (n[t] = i[t], e.setStaticValue(t, 0), r && (r[t] = 0));
}
function _V(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t)
    return !1;
  const { visualElement: e } = t.options;
  return e ? AV(e) ? !0 : t.parent && !t.parent.hasCheckedOptimisedAppear ? _V(t.parent) : !1 : !1;
}
function VV({ attachResizeListener: t, defaultParent: e, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(a = {}, o = e == null ? void 0 : e()) {
      this.id = but++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, If && (lu.totalNodes = lu.resolvedTargetDeltas = lu.recalculatedProjection = 0), this.nodes.forEach(xut), this.nodes.forEach(Lut), this.nodes.forEach(Tut), this.nodes.forEach(Mut), If && window.MotionDebug.record(lu);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = a, this.root = o ? o.root || o : this, this.path = o ? [...o.path, o] : [], this.parent = o, this.depth = o ? o.depth + 1 : 0;
      for (let s = 0; s < this.path.length; s++)
        this.path[s].shouldResetTransform = !0;
      this.root === this && (this.nodes = new put());
    }
    addEventListener(a, o) {
      return this.eventHandlers.has(a) || this.eventHandlers.set(a, new AM()), this.eventHandlers.get(a).add(o);
    }
    notifyListeners(a, ...o) {
      const s = this.eventHandlers.get(a);
      s && s.notify(...o);
    }
    hasListeners(a) {
      return this.eventHandlers.has(a);
    }
    /**
     * Lifecycles
     */
    mount(a, o = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = yut(a), this.instance = a;
      const { layoutId: s, layout: l, visualElement: c } = this.options;
      if (c && !c.current && c.mount(a), this.root.nodes.add(this), this.parent && this.parent.children.add(this), o && (l || s) && (this.isLayoutDirty = !0), t) {
        let u;
        const d = () => this.root.updateBlockedByResize = !1;
        t(a, () => {
          this.root.updateBlockedByResize = !0, u && u(), u = mut(d, 250), V4.hasAnimatedSinceResize && (V4.hasAnimatedSinceResize = !1, this.nodes.forEach(Qj));
        });
      }
      s && this.root.registerSharedNode(s, this), this.options.animate !== !1 && c && (s || l) && this.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: d, hasRelativeTargetChanged: f, layout: h }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const p = this.options.transition || c.getDefaultTransition() || Iut, { onLayoutAnimationStart: m, onLayoutAnimationComplete: g } = c.getProps(), v = !this.targetLayout || !FV(this.targetLayout, h) || f, k = !d && f;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || k || d && (v || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(u, k);
          const w = {
            ...mM(p, "layout"),
            onPlay: m,
            onComplete: g
          };
          (c.shouldReduceMotion || this.options.layoutRoot) && (w.delay = 0, w.type = !1), this.startAnimation(w);
        } else
          d || Qj(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = h;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const a = this.getStack();
      a && a.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, cl(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(Eut), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: a } = this.options;
      return a && a.getProps().transformTemplate;
    }
    willUpdate(a = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.HandoffCancelAllAnimations && _V(this) && window.HandoffCancelAllAnimations(), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        u.shouldResetTransform = !0, u.updateScroll("snapshot"), u.options.layoutRoot && u.willUpdate(!1);
      }
      const { layoutId: o, layout: s } = this.options;
      if (o === void 0 && !s)
        return;
      const l = this.getTransformTemplate();
      this.prevTransformTemplateValue = l ? l(this.latestValues, "") : void 0, this.updateSnapshot(), a && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Jj);
        return;
      }
      this.isUpdating || this.nodes.forEach(Aut), this.isUpdating = !1, this.nodes.forEach(Sut), this.nodes.forEach(wut), this.nodes.forEach(kut), this.clearAllSnapshots();
      const a = hc.now();
      Dr.delta = kc(0, 1e3 / 60, a - Dr.timestamp), Dr.timestamp = a, Dr.isProcessing = !0, o8.update.process(Dr), o8.preRender.process(Dr), o8.render.process(Dr), Dr.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, nM.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(Cut), this.sharedNodes.forEach(jut);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, fn.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      fn.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let s = 0; s < this.path.length; s++)
          this.path[s].updateScroll();
      const a = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = Qn(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: o } = this.options;
      o && o.notify("LayoutMeasure", this.layout.layoutBox, a ? a.layoutBox : void 0);
    }
    updateScroll(a = "measure") {
      let o = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === a && (o = !1), o) {
        const s = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: a,
          isRoot: s,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : s
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const a = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, o = this.projectionDelta && !HV(this.projectionDelta), s = this.getTransformTemplate(), l = s ? s(this.latestValues, "") : void 0, c = l !== this.prevTransformTemplateValue;
      a && (o || su(this.latestValues) || c) && (i(this.instance, l), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(a = !0) {
      const o = this.measurePageBox();
      let s = this.removeElementScroll(o);
      return a && (s = this.removeTransform(s)), Put(s), {
        animationId: this.root.animationId,
        measuredBox: o,
        layoutBox: s,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var a;
      const { visualElement: o } = this.options;
      if (!o)
        return Qn();
      const s = o.measureViewportBox();
      if (!(!((a = this.scroll) === null || a === void 0) && a.wasRoot || this.path.some(zut))) {
        const { scroll: l } = this.root;
        l && (i1(s.x, l.offset.x), i1(s.y, l.offset.y));
      }
      return s;
    }
    removeElementScroll(a) {
      var o;
      const s = Qn();
      if (da(s, a), !((o = this.scroll) === null || o === void 0) && o.wasRoot)
        return s;
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l], { scroll: u, options: d } = c;
        c !== this.root && u && d.layoutScroll && (u.wasRoot && da(s, a), i1(s.x, u.offset.x), i1(s.y, u.offset.y));
      }
      return s;
    }
    applyTransform(a, o = !1) {
      const s = Qn();
      da(s, a);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        !o && c.options.layoutScroll && c.scroll && c !== c.root && a1(s, {
          x: -c.scroll.offset.x,
          y: -c.scroll.offset.y
        }), su(c.latestValues) && a1(s, c.latestValues);
      }
      return su(this.latestValues) && a1(s, this.latestValues), s;
    }
    removeTransform(a) {
      const o = Qn();
      da(o, a);
      for (let s = 0; s < this.path.length; s++) {
        const l = this.path[s];
        if (!l.instance || !su(l.latestValues))
          continue;
        e9(l.latestValues) && l.updateSnapshot();
        const c = Qn(), u = l.measurePageBox();
        da(c, u), Uj(o, l.latestValues, l.snapshot ? l.snapshot.layoutBox : void 0, c);
      }
      return su(this.latestValues) && Uj(o, this.latestValues), o;
    }
    setTargetDelta(a) {
      this.targetDelta = a, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(a) {
      this.options = {
        ...this.options,
        ...a,
        crossfade: a.crossfade !== void 0 ? a.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Dr.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(a = !1) {
      var o;
      const s = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = s.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = s.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = s.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== s;
      if (!(a || l && this.isSharedProjectionDirty || this.isProjectionDirty || !((o = this.parent) === null || o === void 0) && o.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: c, layoutId: u } = this.options;
      if (!(!this.layout || !(c || u))) {
        if (this.resolvedRelativeTargetAt = Dr.timestamp, !this.targetDelta && !this.relativeTarget) {
          const d = this.getClosestProjectingParent();
          d && d.layout && this.animationProgress !== 1 ? (this.relativeParent = d, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Qn(), this.relativeTargetOrigin = Qn(), Xf(this.relativeTargetOrigin, this.layout.layoutBox, d.layout.layoutBox), da(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = Qn(), this.targetWithTransforms = Qn()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), Oct(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : da(this.target, this.layout.layoutBox), IV(this.target, this.targetDelta)) : da(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const d = this.getClosestProjectingParent();
            d && !!d.resumingFrom == !!this.resumingFrom && !d.options.layoutScroll && d.target && this.animationProgress !== 1 ? (this.relativeParent = d, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Qn(), this.relativeTargetOrigin = Qn(), Xf(this.relativeTargetOrigin, this.target, d.target), da(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          If && lu.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || e9(this.parent.latestValues) || DV(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var a;
      const o = this.getLead(), s = !!this.resumingFrom || this !== o;
      let l = !0;
      if ((this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty) && (l = !1), s && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === Dr.timestamp && (l = !1), l)
        return;
      const { layout: c, layoutId: u } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(c || u))
        return;
      da(this.layoutCorrected, this.layout.layoutBox);
      const d = this.treeScale.x, f = this.treeScale.y;
      Zct(this.layoutCorrected, this.treeScale, this.path, s), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = Qn());
      const { target: h } = o;
      if (!h) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (_j(this.prevProjectionDelta.x, this.projectionDelta.x), _j(this.prevProjectionDelta.y, this.projectionDelta.y)), Qf(this.projectionDelta, this.layoutCorrected, h, this.latestValues), (this.treeScale.x !== d || this.treeScale.y !== f || !Kj(this.projectionDelta.x, this.prevProjectionDelta.x) || !Kj(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", h)), If && lu.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(a = !0) {
      var o;
      if ((o = this.options.visualElement) === null || o === void 0 || o.scheduleRender(), a) {
        const s = this.getStack();
        s && s.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = r1(), this.projectionDelta = r1(), this.projectionDeltaWithTransform = r1();
    }
    setAnimationOrigin(a, o = !1) {
      const s = this.snapshot, l = s ? s.latestValues : {}, c = { ...this.latestValues }, u = r1();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !o;
      const d = Qn(), f = s ? s.source : void 0, h = this.layout ? this.layout.source : void 0, p = f !== h, m = this.getStack(), g = !m || m.members.length <= 1, v = !!(p && !g && this.options.crossfade === !0 && !this.path.some(Dut));
      this.animationProgress = 0;
      let k;
      this.mixTargetDelta = (w) => {
        const b = w / 1e3;
        Xj(u.x, a.x, b), Xj(u.y, a.y, b), this.setTargetDelta(u), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Xf(d, this.layout.layoutBox, this.relativeParent.layout.layoutBox), Nut(this.relativeTarget, this.relativeTargetOrigin, d, b), k && uut(this.relativeTarget, k) && (this.isProjectionDirty = !1), k || (k = Qn()), da(k, this.relativeTarget)), p && (this.animationValues = c, iut(c, l, this.latestValues, b, v, g)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = b;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(a) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (cl(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = fn.update(() => {
        V4.hasAnimatedSinceResize = !0, this.currentAnimation = gut(0, $j, {
          ...a,
          onUpdate: (o) => {
            this.mixTargetDelta(o), a.onUpdate && a.onUpdate(o);
          },
          onComplete: () => {
            a.onComplete && a.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const a = this.getStack();
      a && a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta($j), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const a = this.getLead();
      let { targetWithTransforms: o, target: s, layout: l, latestValues: c } = a;
      if (!(!o || !s || !l)) {
        if (this !== a && this.layout && l && qV(this.options.animationType, this.layout.layoutBox, l.layoutBox)) {
          s = this.target || Qn();
          const u = na(this.layout.layoutBox.x);
          s.x.min = a.target.x.min, s.x.max = s.x.min + u;
          const d = na(this.layout.layoutBox.y);
          s.y.min = a.target.y.min, s.y.max = s.y.min + d;
        }
        da(o, s), a1(o, c), Qf(this.projectionDeltaWithTransform, this.layoutCorrected, o, c);
      }
    }
    registerSharedNode(a, o) {
      this.sharedNodes.has(a) || this.sharedNodes.set(a, new dut()), this.sharedNodes.get(a).add(o);
      const s = o.options.initialPromotionConfig;
      o.promote({
        transition: s ? s.transition : void 0,
        preserveFollowOpacity: s && s.shouldPreserveFollowOpacity ? s.shouldPreserveFollowOpacity(o) : void 0
      });
    }
    isLead() {
      const a = this.getStack();
      return a ? a.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? ((a = this.getStack()) === null || a === void 0 ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? (a = this.getStack()) === null || a === void 0 ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: a } = this.options;
      if (a)
        return this.root.sharedNodes.get(a);
    }
    promote({ needsReset: a, transition: o, preserveFollowOpacity: s } = {}) {
      const l = this.getStack();
      l && l.promote(this, s), a && (this.projectionDelta = void 0, this.needsReset = !0), o && this.setOptions({ transition: o });
    }
    relegate() {
      const a = this.getStack();
      return a ? a.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: a } = this.options;
      if (!a)
        return;
      let o = !1;
      const { latestValues: s } = a;
      if ((s.z || s.rotate || s.rotateX || s.rotateY || s.rotateZ || s.skewX || s.skewY) && (o = !0), !o)
        return;
      const l = {};
      s.z && y8("z", a, l, this.animationValues);
      for (let c = 0; c < m8.length; c++)
        y8(`rotate${m8[c]}`, a, l, this.animationValues), y8(`skew${m8[c]}`, a, l, this.animationValues);
      a.render();
      for (const c in l)
        a.setStaticValue(c, l[c]), this.animationValues && (this.animationValues[c] = l[c]);
      a.scheduleRender();
    }
    getProjectionStyles(a) {
      var o, s;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return vut;
      const l = {
        visibility: ""
      }, c = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, l.opacity = "", l.pointerEvents = F4(a == null ? void 0 : a.pointerEvents) || "", l.transform = c ? c(this.latestValues, "") : "none", l;
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        const p = {};
        return this.options.layoutId && (p.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, p.pointerEvents = F4(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !su(this.latestValues) && (p.transform = c ? c({}, "") : "none", this.hasProjected = !1), p;
      }
      const d = u.animationValues || u.latestValues;
      this.applyTransformsToTarget(), l.transform = fut(this.projectionDeltaWithTransform, this.treeScale, d), c && (l.transform = c(d, l.transform));
      const { x: f, y: h } = this.projectionDelta;
      l.transformOrigin = `${f.origin * 100}% ${h.origin * 100}% 0`, u.animationValues ? l.opacity = u === this ? (s = (o = d.opacity) !== null && o !== void 0 ? o : this.latestValues.opacity) !== null && s !== void 0 ? s : 1 : this.preserveOpacity ? this.latestValues.opacity : d.opacityExit : l.opacity = u === this ? d.opacity !== void 0 ? d.opacity : "" : d.opacityExit !== void 0 ? d.opacityExit : 0;
      for (const p in Dy) {
        if (d[p] === void 0)
          continue;
        const { correct: m, applyTo: g } = Dy[p], v = l.transform === "none" ? d[p] : m(d[p], u);
        if (g) {
          const k = g.length;
          for (let w = 0; w < k; w++)
            l[g[w]] = v;
        } else
          l[p] = v;
      }
      return this.options.layoutId && (l.pointerEvents = u === this ? F4(a == null ? void 0 : a.pointerEvents) || "" : "none"), l;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((a) => {
        var o;
        return (o = a.currentAnimation) === null || o === void 0 ? void 0 : o.stop();
      }), this.root.nodes.forEach(Jj), this.root.sharedNodes.clear();
    }
  };
}
function wut(t) {
  t.updateLayout();
}
function kut(t) {
  var e;
  const n = ((e = t.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && n && t.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: i } = t.layout, { animationType: a } = t.options, o = n.source !== t.layout.source;
    a === "size" ? ya((d) => {
      const f = o ? n.measuredBox[d] : n.layoutBox[d], h = na(f);
      f.min = r[d].min, f.max = f.min + h;
    }) : qV(a, n.layoutBox, r) && ya((d) => {
      const f = o ? n.measuredBox[d] : n.layoutBox[d], h = na(r[d]);
      f.max = f.min + h, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[d].max = t.relativeTarget[d].min + h);
    });
    const s = r1();
    Qf(s, r, n.layoutBox);
    const l = r1();
    o ? Qf(l, t.applyTransform(i, !0), n.measuredBox) : Qf(l, r, n.layoutBox);
    const c = !HV(s);
    let u = !1;
    if (!t.resumeFrom) {
      const d = t.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: f, layout: h } = d;
        if (f && h) {
          const p = Qn();
          Xf(p, n.layoutBox, f.layoutBox);
          const m = Qn();
          Xf(m, r, h.layoutBox), FV(p, m) || (u = !0), d.options.layoutRoot && (t.relativeTarget = m, t.relativeTargetOrigin = p, t.relativeParent = d);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: l,
      layoutDelta: s,
      hasLayoutChanged: c,
      hasRelativeTargetChanged: u
    });
  } else if (t.isLead()) {
    const { onExitComplete: r } = t.options;
    r && r();
  }
  t.options.transition = void 0;
}
function xut(t) {
  If && lu.totalNodes++, t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function Mut(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function Cut(t) {
  t.clearSnapshot();
}
function Jj(t) {
  t.clearMeasurements();
}
function Aut(t) {
  t.isLayoutDirty = !1;
}
function Sut(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function Qj(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function Lut(t) {
  t.resolveTargetDelta();
}
function Tut(t) {
  t.calcProjection();
}
function Eut(t) {
  t.resetSkewAndRotation();
}
function jut(t) {
  t.removeLeadSnapshot();
}
function Xj(t, e, n) {
  t.translate = Hn(e.translate, 0, n), t.scale = Hn(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function eN(t, e, n, r) {
  t.min = Hn(e.min, n.min, r), t.max = Hn(e.max, n.max, r);
}
function Nut(t, e, n, r) {
  eN(t.x, e.x, n.x, r), eN(t.y, e.y, n.y, r);
}
function Dut(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const Iut = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, tN = (t) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t), nN = tN("applewebkit/") && !tN("chrome/") ? Math.round : Br;
function rN(t) {
  t.min = nN(t.min), t.max = nN(t.max);
}
function Put(t) {
  rN(t.x), rN(t.y);
}
function qV(t, e, n) {
  return t === "position" || t === "preserve-aspect" && !Rct(Yj(e), Yj(n), 0.2);
}
function zut(t) {
  var e;
  return t !== t.root && ((e = t.scroll) === null || e === void 0 ? void 0 : e.wasRoot);
}
const Rut = VV({
  attachResizeListener: (t, e) => Vs(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), g8 = {
  current: void 0
}, UV = VV({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!g8.current) {
      const t = new Rut({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), g8.current = t;
    }
    return g8.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), Out = {
  pan: {
    Feature: Qct
  },
  drag: {
    Feature: Jct,
    ProjectionNode: UV,
    MeasureLayout: RV
  }
}, n9 = { current: null }, WV = { current: !1 };
function But() {
  if (WV.current = !0, !!eM)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => n9.current = t.matches;
      t.addListener(e), e();
    } else
      n9.current = !1;
}
function Hut(t, e, n) {
  for (const r in e) {
    const i = e[r], a = n[r];
    if (Gr(i))
      t.addValue(r, i), process.env.NODE_ENV === "development" && SM(i.version === "11.3.17", `Attempting to mix Framer Motion versions ${i.version} with 11.3.17 may not work as expected.`);
    else if (Gr(a))
      t.addValue(r, qh(i, { owner: t }));
    else if (a !== i)
      if (t.hasValue(r)) {
        const o = t.getValue(r);
        o.liveStyle === !0 ? o.jump(i) : o.hasAnimated || o.set(i);
      } else {
        const o = t.getStaticValue(r);
        t.addValue(r, qh(o !== void 0 ? o : i, { owner: t }));
      }
  }
  for (const r in n)
    e[r] === void 0 && t.removeValue(r);
  return e;
}
const iN = /* @__PURE__ */ new WeakMap(), Fut = [...Q_, qr, xc], _ut = (t) => Fut.find(J_(t)), aN = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], Vut = iM.length;
class qut {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n, r) {
    return {};
  }
  constructor({ parent: e, props: n, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: a, visualState: o }, s = {}) {
    this.applyWillChange = !1, this.resolveKeyframes = (f, h, p, m) => new this.KeyframeResolver(f, h, p, m, this), this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = yM, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.isRenderScheduled = !1, this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.isRenderScheduled = !1, this.scheduleRender = () => {
      this.isRenderScheduled || (this.isRenderScheduled = !0, fn.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: c } = o;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = c, this.parent = e, this.props = n, this.presenceContext = r, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = i, this.options = s, this.blockInitialAnimation = !!a, this.isControllingVariants = Vg(n), this.isVariantNode = S_(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: u, ...d } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const f in d) {
      const h = d[f];
      l[f] !== void 0 && Gr(h) && h.set(l[f], !1);
    }
  }
  mount(e) {
    this.current = e, iN.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), WV.current || But(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : n9.current, process.env.NODE_ENV !== "production" && SM(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    iN.delete(this.current), this.projection && this.projection.unmount(), cl(this.notifyUpdate), cl(this.render), this.valueSubscriptions.forEach((e) => e()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features) {
      const n = this.features[e];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(e, n) {
    const r = _c.has(e), i = n.on("change", (o) => {
      this.latestValues[e] = o, this.props.onUpdate && fn.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), a = n.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(e, () => {
      i(), a(), n.owner && n.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in U1) {
      const n = U1[e];
      if (!n)
        continue;
      const { isEnabled: r, Feature: i } = n;
      if (!this.features[e] && i && r(this.props) && (this.features[e] = new i(this)), this.features[e]) {
        const a = this.features[e];
        a.isMounted ? a.update() : (a.mount(), a.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Qn();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < aN.length; r++) {
      const i = aN[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const a = "on" + i, o = e[a];
      o && (this.propEventSubscriptions[i] = this.on(i, o));
    }
    this.prevMotionValues = Hut(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(e = !1) {
    if (e)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const r = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (r.initial = this.props.initial), r;
    }
    const n = {};
    for (let r = 0; r < Vut; r++) {
      const i = iM[r], a = this.props[i];
      (Hh(a) || a === !1) && (n[i] = a);
    }
    return n;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    const r = this.values.get(e);
    n !== r && (r && this.removeValue(e), this.bindToMotionValue(e, n), this.values.set(e, n), this.latestValues[e] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let r = this.values.get(e);
    return r === void 0 && n !== void 0 && (r = qh(n === null ? void 0 : n, { owner: this }), this.addValue(e, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, n) {
    var r;
    let i = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : (r = this.getBaseTargetFromProps(this.props, e)) !== null && r !== void 0 ? r : this.readValueFromInstance(this.current, e, this.options);
    return i != null && (typeof i == "string" && (K_(i) || Y_(i)) ? i = parseFloat(i) : !_ut(i) && xc.test(n) && (i = oV(e, n)), this.setBaseTarget(e, Gr(i) ? i.get() : i)), Gr(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var n;
    const { initial: r } = this.props;
    let i;
    if (typeof r == "string" || typeof r == "object") {
      const o = pM(this.props, r, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      o && (i = o[e]);
    }
    if (r && i !== void 0)
      return i;
    const a = this.getBaseTargetFromProps(this.props, e);
    return a !== void 0 && !Gr(a) ? a : this.initialValues[e] !== void 0 && i === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new AM()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
}
class ZV extends qut {
  constructor() {
    super(...arguments), this.KeyframeResolver = sV;
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: r }) {
    delete n[e], delete r[e];
  }
}
function Uut(t) {
  return window.getComputedStyle(t);
}
class Wut extends ZV {
  constructor() {
    super(...arguments), this.type = "html", this.applyWillChange = !0, this.renderInstance = P_;
  }
  readValueFromInstance(e, n) {
    if (_c.has(n)) {
      const r = vM(n);
      return r && r.default || 0;
    } else {
      const r = Uut(e), i = (E_(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return PV(e, n);
  }
  build(e, n, r) {
    cM(e, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, r) {
    return hM(e, n, r);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    Gr(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class Zut extends ZV {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = Qn;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (_c.has(n)) {
      const r = vM(n);
      return r && r.default || 0;
    }
    return n = z_.has(n) ? n : _g(n), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, r) {
    return O_(e, n, r);
  }
  build(e, n, r) {
    dM(e, n, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(e, n, r, i) {
    R_(e, n, r, i);
  }
  mount(e) {
    this.isSVGTag = fM(e.tagName), super.mount(e);
  }
}
const Gut = (t, e) => oM(t) ? new Zut(e) : new Wut(e, {
  allowProjection: t !== ds
}), Yut = {
  layout: {
    ProjectionNode: UV,
    MeasureLayout: RV
  }
}, Kut = {
  ...Tct,
  ...Bst,
  ...Out,
  ...Yut
}, Ru = /* @__PURE__ */ Zot((t, e) => Ast(t, e, Kut, Gut));
function GV() {
  const t = Ue(!1);
  return tM(() => (t.current = !0, () => {
    t.current = !1;
  }), []), t;
}
function $ut() {
  const t = GV(), [e, n] = De(0), r = nt(() => {
    t.current && n(e + 1);
  }, [e]);
  return [nt(() => fn.postRender(r), [r]), e];
}
class Jut extends N.Component {
  getSnapshotBeforeUpdate(e) {
    const n = this.props.childRef.current;
    if (n && e.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function Qut({ children: t, isPresent: e }) {
  const n = bd(), r = Ue(null), i = Ue({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), { nonce: a } = Mt(Xx);
  return fg(() => {
    const { width: o, height: s, top: l, left: c } = i.current;
    if (e || !r.current || !o || !s)
      return;
    r.current.dataset.motionPopId = n;
    const u = document.createElement("style");
    return a && (u.nonce = a), document.head.appendChild(u), u.sheet && u.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${o}px !important;
            height: ${s}px !important;
            top: ${l}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(u);
    };
  }, [e]), T.jsx(Jut, { isPresent: e, childRef: r, sizeRef: i, children: N.cloneElement(t, { ref: r }) });
}
const v8 = ({ children: t, initial: e, isPresent: n, onExitComplete: r, custom: i, presenceAffectsLayout: a, mode: o }) => {
  const s = B_(Xut), l = bd(), c = Ft(
    () => ({
      id: l,
      initial: e,
      isPresent: n,
      custom: i,
      onExitComplete: (u) => {
        s.set(u, !0);
        for (const d of s.values())
          if (!d)
            return;
        r && r();
      },
      register: (u) => (s.set(u, !1), () => s.delete(u))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    a ? [Math.random()] : [n]
  );
  return Ft(() => {
    s.forEach((u, d) => s.set(d, !1));
  }, [n]), N.useEffect(() => {
    !n && !s.size && r && r();
  }, [n]), o === "popLayout" && (t = T.jsx(Qut, { isPresent: n, children: t })), T.jsx(Fg.Provider, { value: c, children: t });
};
function Xut() {
  return /* @__PURE__ */ new Map();
}
function e0t(t) {
  return ze(() => () => t(), []);
}
const cu = (t) => t.key || "";
function t0t(t, e) {
  t.forEach((n) => {
    const r = cu(n);
    e.set(r, n);
  });
}
function n0t(t) {
  const e = [];
  return Ws.forEach(t, (n) => {
    N1(n) && e.push(n);
  }), e;
}
const r0t = ({ children: t, custom: e, initial: n = !0, onExitComplete: r, exitBeforeEnter: i, presenceAffectsLayout: a = !0, mode: o = "sync" }) => {
  ll(!i, "Replace exitBeforeEnter with mode='wait'");
  const s = Mt(aM).forceRender || $ut()[0], l = GV(), c = n0t(t);
  let u = c;
  const d = Ue(/* @__PURE__ */ new Map()).current, f = Ue(u), h = Ue(/* @__PURE__ */ new Map()).current, p = Ue(!0);
  if (tM(() => {
    p.current = !1, t0t(c, h), f.current = u;
  }), e0t(() => {
    p.current = !0, h.clear(), d.clear();
  }), p.current)
    return T.jsx(T.Fragment, { children: u.map((k) => T.jsx(v8, { isPresent: !0, initial: n ? void 0 : !1, presenceAffectsLayout: a, mode: o, children: k }, cu(k))) });
  u = [...u];
  const m = f.current.map(cu), g = c.map(cu), v = m.length;
  for (let k = 0; k < v; k++) {
    const w = m[k];
    g.indexOf(w) === -1 && !d.has(w) && d.set(w, void 0);
  }
  return o === "wait" && d.size && (u = []), d.forEach((k, w) => {
    if (g.indexOf(w) !== -1)
      return;
    const b = h.get(w);
    if (!b)
      return;
    const x = m.indexOf(w);
    let A = k;
    if (!A) {
      const L = () => {
        d.delete(w);
        const M = Array.from(h.keys()).filter((j) => !g.includes(j));
        if (M.forEach((j) => h.delete(j)), f.current = c.filter((j) => {
          const D = cu(j);
          return (
            // filter out the node exiting
            D === w || // filter out the leftover children
            M.includes(D)
          );
        }), !d.size) {
          if (l.current === !1)
            return;
          s(), r && r();
        }
      };
      A = T.jsx(v8, { isPresent: !1, onExitComplete: L, custom: e, presenceAffectsLayout: a, mode: o, children: b }, cu(b)), d.set(w, A);
    }
    u.splice(x, 0, A);
  }), u = u.map((k) => {
    const w = k.key;
    return d.has(w) ? k : T.jsx(v8, { isPresent: !0, presenceAffectsLayout: a, mode: o, children: k }, cu(k));
  }), process.env.NODE_ENV !== "production" && o === "wait" && u.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), T.jsx(T.Fragment, { children: d.size ? u : u.map((k) => vd(k)) });
}, i0t = Cot, a0t = Aot, o0t = Sot, s0t = Eot, l0t = Lot, c0t = Tot, u0t = Ha("", {
  variants: {
    position: {
      bottom: "-my-1",
      top: "-my-1",
      right: "-mx-1",
      left: "-mx-1"
    },
    beakAlignment: {
      start: "start",
      center: "center",
      end: "end"
    },
    defaultVariants: {
      variant: "bottom",
      beakPosition: "center"
    }
  }
}), b8 = {
  top: {
    initial: { opacity: 0 },
    animate: { opacity: 1, y: -5 },
    exit: { opacity: 0, y: 0, transition: { ease: "easeInOut", duration: 0.1 } }
  },
  bottom: {
    initial: { opacity: 0 },
    animate: { opacity: 1, y: 5 },
    exit: { opacity: 0, y: 0, transition: { ease: "easeInOut", duration: 0.1 } }
  },
  left: {
    initial: { opacity: 0 },
    animate: { opacity: 1, x: -5 },
    exit: { opacity: 0, x: 0, transition: { ease: "easeInOut", duration: 0.1 } }
  },
  right: {
    initial: { opacity: 0 },
    animate: { opacity: 1, x: 5 },
    exit: { opacity: 0, x: 0, transition: { ease: "easeInOut", duration: 0.1 } }
  }
}, En = N.forwardRef(
  ({ children: t, className: e, text: n, position: r, beakAlignment: i, sideOffset: a = 5, ...o }, s) => {
    const l = ({
      position: c,
      beakAlignment: u
    }) => {
      const d = c === "bottom" || c === "top", f = c === "right" || c === "left";
      return d && u === "start" ? "[&>span]:!left-[10%]" : f && u === "start" ? "[&>span]:!top-[20%]" : d && u === "end" ? "[&>span]:!left-[80%]" : f && u === "end" ? "[&>span]:!top-[60%]" : f && u === "center" ? "my-0 -mx-1" : "-my-1";
    };
    return /* @__PURE__ */ T.jsx(i0t, { children: /* @__PURE__ */ T.jsxs(a0t, { children: [
      /* @__PURE__ */ T.jsx(o0t, { "data-testid": "tooltip-trigger", children: t }),
      /* @__PURE__ */ T.jsx(l0t, { children: /* @__PURE__ */ T.jsx(
        Ru.div,
        {
          ref: s,
          initial: b8[r || "top"].initial,
          animate: b8[r || "top"].animate,
          exit: b8[r || "top"].exit,
          transition: {
            duration: 0.1,
            ease: "easeInOut"
          },
          className: be("z-[999] absolute", {
            hidden: !n
          }),
          children: /* @__PURE__ */ T.jsxs(
            c0t,
            {
              sideOffset: a,
              className: be(
                "max-w-sm min-h-[2vh] overflow-hidden rounded color-bg-default-inverse dark:bg-[#000] p-2 text-helper-text-sm color-text-inverse",
                u0t({ position: r, className: e }),
                l({ position: r, beakAlignment: i }),
                e
              ),
              ...o,
              side: r || "top",
              align: i || "center",
              children: [
                /* @__PURE__ */ T.jsx(N.Fragment, { children: n }),
                /* @__PURE__ */ T.jsx(s0t, { width: 18, height: 9 })
              ]
            }
          )
        }
      ) })
    ] }) });
  }
);
En.displayName = "Tooltip";
const d0t = Ha(
  "inline-flex items-center rounded-sm border px-2 py-1 h-8 text-helper-text-sm color-text-default transition-colors focus:outline-none focus:ring-2 focus:ring-focused focus:ring-offset-2",
  {
    variants: {
      variant: {
        gray: "border-transparent color-bg-tertiary hover:brightness-95",
        brand: "border-transparent color-bg-brand hover:color-bg-brand-hover",
        transparent: "border-transparent bg-transparent hover:color-bg-secondary-hover color-text-secondary",
        success: "border-transparent color-bg-success-light hover:brightness-95 color-text-success font-medium",
        danger: "border-transparent color-bg-danger-light hover:brightness-95 color-text-danger font-medium"
      }
    },
    defaultVariants: {
      variant: "gray"
    }
  }
), Uh = N.forwardRef(
  ({ className: t, variant: e, color: n, ...r }, i) => /* @__PURE__ */ T.jsxs(
    "div",
    {
      className: be(d0t({ variant: e }), t),
      role: "tag",
      ...r,
      ref: i,
      children: [
        r.icon && /* @__PURE__ */ T.jsx(
          Ye,
          {
            name: r.icon,
            size: "sm",
            fill: "transparent",
            className: "mr-2"
          }
        ),
        r.children,
        r.isRemovable && /* @__PURE__ */ T.jsx(
          mn,
          {
            icon: "X",
            variant: "ghost",
            size: "sm",
            className: be(
              "ml-1 p-0 min-w-4 hover:bg-transparent",
              e === "transparent" && "color-text-secondary",
              n && Fue(n) && "text-white"
            ),
            onClick: r.onRemove,
            "aria-label": "Remove tag"
          }
        )
      ]
    }
  )
);
Uh.displayName = "Tag";
const YV = ({
  tags: t,
  selectedTags: e,
  onAddTag: n,
  isPreviewMode: r
}) => {
  const [i, a] = De(""), [o, s] = De(!1), l = Ue(null), c = (h) => {
    a(h), s(!0);
  }, u = (h) => {
    const p = t.find(
      (m) => m.name.toLowerCase() === h.toLowerCase()
    );
    p && n(p), a(""), s(!1);
  }, d = () => {
    if (i.trim()) {
      const h = t.find(
        (p) => p.name.toLowerCase() === i.toLowerCase()
      );
      h && n(h), a("");
    }
    s(!1);
  }, f = (h) => e.some(
    (p) => p.name.toLowerCase() === h.toLowerCase()
  );
  return r ? null : /* @__PURE__ */ T.jsx("div", { ref: l, children: /* @__PURE__ */ T.jsxs(h6, { open: o, onOpenChange: s, children: [
    /* @__PURE__ */ T.jsx(p6, { asChild: !0, children: /* @__PURE__ */ T.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ T.jsxs(
      Kt,
      {
        onClick: d,
        size: "md",
        variant: "ghost",
        className: "min-w-fit !h-6 px-2",
        children: [
          /* @__PURE__ */ T.jsx(Ye, { name: "Plus", size: "sm", className: "mr-1 text-[#77818A]" }),
          /* @__PURE__ */ T.jsx("span", { className: "text-[#77818A] text-helper-text-sm", children: "Add Tag" })
        ]
      }
    ) }) }),
    /* @__PURE__ */ T.jsx(
      xp,
      {
        className: "w-52",
        align: "center",
        container: l.current,
        children: /* @__PURE__ */ T.jsxs(UG, { children: [
          /* @__PURE__ */ T.jsx(
            WG,
            {
              placeholder: "Search tags...",
              value: i,
              onValueChange: c
            }
          ),
          /* @__PURE__ */ T.jsxs(ZG, { className: "overflow-y-auto max-h-40", children: [
            /* @__PURE__ */ T.jsx(GG, { children: "No tags found" }),
            /* @__PURE__ */ T.jsx(YG, { children: t.filter(
              (h) => h.name.toLowerCase().includes(i.toLowerCase())
            ).map((h, p) => /* @__PURE__ */ T.jsx(
              KG,
              {
                value: h.name,
                onSelect: u,
                className: be(
                  f(h.name) ? "opacity-50 pointer-events-none" : ""
                ),
                children: h.name
              },
              p
            )) })
          ] })
        ] })
      }
    )
  ] }) });
}, f0t = {
  Camera: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9ZM10 13C10 11.8954 10.8954 11 12 11C13.1046 11 14 11.8954 14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.5 3C9.20322 3 8.92177 3.13182 8.73178 3.35982L6.53162 6H4C3.20435 6 2.44129 6.31607 1.87868 6.87868C1.31607 7.44129 1 8.20435 1 9V18C1 18.7956 1.31607 19.5587 1.87868 20.1213C2.44129 20.6839 3.20435 21 4 21H20C20.7957 21 21.5587 20.6839 22.1213 20.1213C22.6839 19.5587 23 18.7957 23 18V9C23 8.20435 22.6839 7.44129 22.1213 6.87868C21.5587 6.31607 20.7957 6 20 6H17.4684L15.2682 3.35982C15.0782 3.13182 14.7968 3 14.5 3H9.5ZM7.76822 7.64018L9.96837 5H14.0316L16.2318 7.64018C16.4218 7.86818 16.7032 8 17 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V18C21 18.2652 20.8946 18.5196 20.7071 18.7071C20.5196 18.8946 20.2652 19 20 19H4C3.73478 19 3.48043 18.8946 3.29289 18.7071C3.10536 18.5196 3 18.2652 3 18V9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H7C7.29678 8 7.57823 7.86818 7.76822 7.64018Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Check: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.7071 5.29289C21.0976 5.68342 21.0976 6.31658 20.7071 6.70711L9.70711 17.7071C9.31658 18.0976 8.68342 18.0976 8.29289 17.7071L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929C3.68342 10.9024 4.31658 10.9024 4.70711 11.2929L9 15.5858L19.2929 5.29289C19.6834 4.90237 20.3166 4.90237 20.7071 5.29289Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  CheckboxEmpty: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5ZM2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  Comment: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V18.5858L6.29289 16.2929C6.48043 16.1054 6.73478 16 7 16H19C19.2652 16 19.5196 15.8946 19.7071 15.7071C19.8946 15.5196 20 15.2652 20 15V5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4H5ZM2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H19C19.7957 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V15C22 15.7957 21.6839 16.5587 21.1213 17.1213C20.5587 17.6839 19.7957 18 19 18H7.41421L3.70711 21.7071C3.42111 21.9931 2.99099 22.0787 2.61732 21.9239C2.24364 21.7691 2 21.4045 2 21V5C2 4.20435 2.31607 3.44129 2.87868 2.87868ZM6 8C6 7.44772 6.44772 7 7 7H13C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9H7C6.44772 9 6 8.55228 6 8ZM7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H7Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  ExternalLink: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14 3C14 2.44772 14.4477 2 15 2H21C21.5523 2 22 2.44772 22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V4H15C14.4477 4 14 3.55228 14 3Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5 7C4.73478 7 4.48043 7.10536 4.29289 7.29289C4.10536 7.48043 4 7.73478 4 8V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H16C16.2652 20 16.5196 19.8946 16.7071 19.7071C16.8946 19.5196 17 19.2652 17 19V13C17 12.4477 17.4477 12 18 12C18.5523 12 19 12.4477 19 13V19C19 19.7957 18.6839 20.5587 18.1213 21.1213C17.5587 21.6839 16.7957 22 16 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V8C2 7.20435 2.31607 6.44129 2.87868 5.87868C3.44129 5.31607 4.20435 5 5 5H11C11.5523 5 12 5.44772 12 6C12 6.55228 11.5523 7 11 7H5Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  FilePlus: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 1C5.20435 1 4.44129 1.31607 3.87868 1.87868C3.31607 2.44129 3 3.20435 3 4V8C3 8.55228 3.44772 9 4 9C4.55228 9 5 8.55228 5 8V4C5 3.73478 5.10536 3.48043 5.29289 3.29289C5.48043 3.10536 5.73478 3 6 3H13V6C13 6.79565 13.3161 7.55871 13.8787 8.12132C14.4413 8.68393 15.2044 9 16 9H19V20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H4C3.44772 21 3 21.4477 3 22C3 22.5523 3.44772 23 4 23H18C18.7957 23 19.5587 22.6839 20.1213 22.1213C20.6839 21.5587 21 20.7957 21 20V7C21 6.73478 20.8946 6.48043 20.7071 6.29289L15.7071 1.29289C15.5196 1.10536 15.2652 1 15 1H6ZM15 3.41421V6C15 6.26522 15.1054 6.51957 15.2929 6.70711C15.4804 6.89464 15.7348 7 16 7H18.5858L15 3.41421Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M2 15C2 14.4477 2.44772 14 3 14H5V12C5 11.4477 5.44772 11 6 11C6.55228 11 7 11.4477 7 12V14H9C9.55228 14 10 14.4477 10 15C10 15.5523 9.55228 16 9 16H7V18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18V16H3C2.44772 16 2 15.5523 2 15Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  FileText: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M8 8C7.44772 8 7 8.44772 7 9C7 9.55229 7.44772 10 8 10H10C10.5523 10 11 9.55229 11 9C11 8.44772 10.5523 8 10 8H8Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M7 13C7 12.4477 7.44772 12 8 12H16C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H8C7.44772 14 7 13.5523 7 13Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H16C16.5523 18 17 17.5523 17 17C17 16.4477 16.5523 16 16 16H8Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.87868 1.87868C4.44129 1.31607 5.20435 1 6 1H15C15.2652 1 15.5196 1.10536 15.7071 1.29289L20.7071 6.29289C20.8946 6.48043 21 6.73478 21 7V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H6C5.20435 23 4.44129 22.6839 3.87868 22.1213C3.31607 21.5587 3 20.7957 3 20V4C3 3.20435 3.31607 2.44129 3.87868 1.87868ZM6 3H13V6C13 6.79565 13.3161 7.55871 13.8787 8.12132C14.4413 8.68393 15.2044 9 16 9H19V20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H6C5.73478 21 5.48043 20.8946 5.29289 20.7071C5.10536 20.5196 5 20.2652 5 20V4C5 3.73478 5.10536 3.48043 5.29289 3.29289C5.48043 3.10536 5.73478 3 6 3ZM16 7H18.5858L15 3.41421V6C15 6.26522 15.1054 6.51957 15.2929 6.70711C15.4804 6.89464 15.7348 7 16 7Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Download: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V12.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L11.2922 15.7064C11.2946 15.7088 11.297 15.7112 11.2995 15.7136C11.3938 15.8063 11.502 15.8764 11.6172 15.9241C11.7343 15.9727 11.8625 15.9996 11.997 16L12 16L12.003 16C12.2746 15.9992 12.5208 15.8901 12.7005 15.7136C12.703 15.7112 12.7054 15.7088 12.7078 15.7064L17.7071 10.7071C18.0976 10.3166 18.0976 9.68342 17.7071 9.29289C17.3166 8.90237 16.6834 8.90237 16.2929 9.29289L13 12.5858V3Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M3 14C3.55228 14 4 14.4477 4 15V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V15C2 14.4477 2.44772 14 3 14Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Grid: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 2C2.89543 2 2 2.89543 2 4V9C2 10.1046 2.89543 11 4 11H9C10.1046 11 11 10.1046 11 9V4C11 2.89543 10.1046 2 9 2H4ZM4 4H9V9H4V4Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 2C13.8954 2 13 2.89543 13 4V9C13 10.1046 13.8954 11 15 11H20C21.1046 11 22 10.1046 22 9V4C22 2.89543 21.1046 2 20 2H15ZM15 4H20V9H15V4Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13 15C13 13.8954 13.8954 13 15 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22H15C13.8954 22 13 21.1046 13 20V15ZM20 15H15V20H20V15Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 13C2.89543 13 2 13.8954 2 15V20C2 21.1046 2.89543 22 4 22H9C10.1046 22 11 21.1046 11 20V15C11 13.8954 10.1046 13 9 13H4ZM4 15H9V20H4V15Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Heart: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.90381 3.90381C4.12279 2.68482 5.77609 2 7.5 2C8.48018 2 9.37318 2.14018 10.2468 2.52068C10.8597 2.78762 11.4321 3.15937 12 3.63935C12.5679 3.15937 13.1403 2.78762 13.7532 2.52068C14.6268 2.14018 15.5198 2 16.5 2C18.2239 2 19.8772 2.68482 21.0962 3.90381C22.3152 5.12279 23 6.77609 23 8.5C23 11.2418 21.1906 13.2531 19.7035 14.7107L12.7071 21.7071C12.3166 22.0976 11.6834 22.0976 11.2929 21.7071L4.29885 14.7131C2.79442 13.258 1 11.2494 1 8.5C1 6.77609 1.68482 5.12279 2.90381 3.90381ZM7.5 4C6.30653 4 5.16193 4.47411 4.31802 5.31802C3.47411 6.16193 3 7.30653 3 8.5C3 10.3469 4.2007 11.8365 5.69502 13.281L5.70711 13.2929L12 19.5858L18.3001 13.2857C19.7923 11.8235 21 10.3359 21 8.5C21 7.30653 20.5259 6.16193 19.682 5.31802C18.8381 4.47411 17.6935 4 16.5 4C15.7202 4 15.1132 4.10982 14.5518 4.35432C13.984 4.60163 13.4001 5.0141 12.7071 5.70711C12.3166 6.09763 11.6834 6.09763 11.2929 5.70711C10.5999 5.0141 10.016 4.60163 9.44819 4.35432C8.88682 4.10982 8.27982 4 7.5 4Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  HeartBeat: ({ width: t, height: e, ...n }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: t,
      height: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx("rect", { y: "1", width: "24", height: "22", fill: "url(#pattern0_246_1680)" }),
        /* @__PURE__ */ T.jsxs("defs", { children: [
          /* @__PURE__ */ T.jsx(
            "pattern",
            {
              id: "pattern0_246_1680",
              patternContentUnits: "objectBoundingBox",
              width: "1",
              height: "1",
              children: /* @__PURE__ */ T.jsx(
                "use",
                {
                  xlinkHref: "#image0_246_1680",
                  transform: "matrix(0.0139394 0 0 0.0152066 -0.545455 -0.640496)"
                }
              )
            }
          ),
          /* @__PURE__ */ T.jsx(
            "image",
            {
              id: "image0_246_1680",
              width: "150",
              height: "150",
              xlinkHref: "data:image/png;base64,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"
            }
          )
        ] })
      ]
    }
  ),
  ImagePlus: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M20 2C20 1.44772 19.5523 1 19 1C18.4477 1 18 1.44772 18 2V4H16C15.4477 4 15 4.44772 15 5C15 5.55228 15.4477 6 16 6H18V8C18 8.55228 18.4477 9 19 9C19.5523 9 20 8.55228 20 8V6H22C22.5523 6 23 5.55228 23 5C23 4.44772 22.5523 4 22 4H20V2Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H5.58579L14.379 11.2068C14.9416 10.6444 15.7045 10.3284 16.5 10.3284C17.2955 10.3284 18.0584 10.6444 18.621 11.2068L20 12.5858V12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H12C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4H5ZM8.41422 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V15.4142L17.207 12.6212C17.0195 12.4338 16.7651 12.3284 16.5 12.3284C16.2349 12.3284 15.9806 12.4337 15.7931 12.6211L8.41422 20Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 9C6 7.34315 7.34315 6 9 6C10.6569 6 12 7.34315 12 9C12 10.6569 10.6569 12 9 12C7.34315 12 6 10.6569 6 9ZM9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10C9.55228 10 10 9.55228 10 9C10 8.44772 9.55228 8 9 8Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  InfoCircle: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9H12.01C12.5623 9 13.01 8.55228 13.01 8C13.01 7.44772 12.5623 7 12.01 7H12Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Dashboard: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 2C2.89543 2 2 2.89543 2 4V11C2 12.1046 2.89543 13 4 13H9C10.1046 13 11 12.1046 11 11V4C11 2.89543 10.1046 2 9 2H4ZM4 4H9V11H4V4Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 2C13.8954 2 13 2.89543 13 4V7C13 8.10457 13.8954 9 15 9H20C21.1046 9 22 8.10457 22 7V4C22 2.89543 21.1046 2 20 2H15ZM15 4H20V7H15V4Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13 13C13 11.8954 13.8954 11 15 11H20C21.1046 11 22 11.8954 22 13V20C22 21.1046 21.1046 22 20 22H15C13.8954 22 13 21.1046 13 20V13ZM20 13H15V20H20V13Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 15C2.89543 15 2 15.8954 2 17V20C2 21.1046 2.89543 22 4 22H9C10.1046 22 11 21.1046 11 20V17C11 15.8954 10.1046 15 9 15H4ZM4 17H9V20H4V17Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Link: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M16.9957 1.06666C15.4225 1.05299 13.9069 1.65776 12.7753 2.75071L12.765 2.76083L11.045 4.47083C10.6533 4.86021 10.6514 5.49338 11.0408 5.88504C11.4302 6.2767 12.0634 6.27855 12.455 5.88916L14.1696 4.18453C14.9235 3.4589 15.9318 3.05749 16.9783 3.06659C18.0271 3.0757 19.0304 3.49638 19.772 4.23801C20.5136 4.97964 20.9343 5.98289 20.9434 7.03168C20.9525 8.07773 20.5514 9.0856 19.8264 9.83937L16.8329 12.8329C16.4274 13.2385 15.9392 13.5524 15.4018 13.7528C14.8644 13.9533 14.2902 14.0359 13.7181 13.9949C13.146 13.9539 12.5894 13.7904 12.086 13.5154C11.5826 13.2404 11.1443 12.8603 10.8008 12.401C10.47 11.9588 9.84327 11.8684 9.40102 12.1992C8.95877 12.53 8.86843 13.1567 9.19923 13.599C9.71458 14.2879 10.3721 14.858 11.1271 15.2705C11.8821 15.683 12.717 15.9283 13.5752 15.9898C14.4334 16.0512 15.2947 15.9274 16.1008 15.6267C16.907 15.326 17.639 14.8555 18.2472 14.247L21.2471 11.2471L21.2593 11.2347C22.3522 10.1031 22.957 8.58748 22.9433 7.0143C22.9297 5.44112 22.2986 3.93624 21.1862 2.8238C20.0737 1.71135 18.5689 1.08033 16.9957 1.06666Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M10.4248 8.01023C9.56663 7.94877 8.70528 8.07259 7.89917 8.3733C7.09311 8.67398 6.36102 9.14461 5.75278 9.75303L2.75291 12.7529L2.74073 12.7653C1.64778 13.8969 1.04301 15.4125 1.05668 16.9857C1.07035 18.5589 1.70137 20.0638 2.81382 21.1762C3.92627 22.2887 5.43114 22.9197 7.00432 22.9333C8.5775 22.947 10.0931 22.3422 11.2247 21.2493L11.2371 21.2371L12.9471 19.5271C13.3376 19.1366 13.3376 18.5034 12.9471 18.1129C12.5566 17.7224 11.9234 17.7224 11.5329 18.1129L9.82938 19.8164C9.07561 20.5415 8.06775 20.9425 7.0217 20.9334C5.97291 20.9243 4.96966 20.5036 4.22803 19.762C3.4864 19.0204 3.06572 18.0171 3.05661 16.9683C3.04752 15.9223 3.44857 14.9144 4.17361 14.1606L7.16725 11.167C7.57276 10.7613 8.06077 10.4476 8.59818 10.2472C9.13558 10.0467 9.70982 9.96415 10.2819 10.0051C10.854 10.0461 11.4107 10.2096 11.914 10.4846C12.4174 10.7596 12.8557 11.1397 13.1993 11.599C13.5301 12.0412 14.1567 12.1316 14.599 11.8008C15.0412 11.47 15.1316 10.8433 14.8008 10.401C14.2854 9.71208 13.628 9.14201 12.8729 8.72951C12.1179 8.317 11.283 8.07169 10.4248 8.01023Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  List: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M3 5C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7H3.01C3.56228 7 4.01 6.55228 4.01 6C4.01 5.44772 3.56228 5 3.01 5H3Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H8Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H8Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M7 18C7 17.4477 7.44772 17 8 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H8C7.44772 19 7 18.5523 7 18Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M2 12C2 11.4477 2.44772 11 3 11H3.01C3.56228 11 4.01 11.4477 4.01 12C4.01 12.5523 3.56228 13 3.01 13H3C2.44772 13 2 12.5523 2 12Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M3 17C2.44772 17 2 17.4477 2 18C2 18.5523 2.44772 19 3 19H3.01C3.56228 19 4.01 18.5523 4.01 18C4.01 17.4477 3.56228 17 3.01 17H3Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Notification: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3C10.6739 3 9.40215 3.52678 8.46447 4.46447C7.52679 5.40215 7 6.67392 7 8C7 11.6473 6.21707 14.0654 5.3779 15.6039C5.3018 15.7434 5.22541 15.8753 5.14933 16H18.8507C18.7746 15.8753 18.6982 15.7434 18.6221 15.6039C17.7829 14.0654 17 11.6473 17 8C17 6.67392 16.4732 5.40215 15.5355 4.46447C14.5979 3.52678 13.3261 3 12 3ZM21.5663 16.1758C21.5656 16.1753 21.5647 16.1746 21.5635 16.1737C21.5558 16.168 21.5379 16.1544 21.5113 16.1322C21.4581 16.0878 21.3697 16.0091 21.2572 15.8904C21.0328 15.6535 20.7097 15.2544 20.3779 14.6461C19.7171 13.4346 19 11.3527 19 8C19 6.14349 18.2625 4.36301 16.9497 3.05025C15.637 1.7375 13.8565 1 12 1C10.1435 1 8.36301 1.7375 7.05025 3.05025C5.7375 4.36301 5 6.14348 5 8C5 11.3527 4.28293 13.4346 3.62211 14.6461C3.29031 15.2544 2.96723 15.6535 2.7428 15.8904C2.63032 16.0091 2.54194 16.0878 2.48872 16.1322C2.4621 16.1544 2.44425 16.168 2.43655 16.1737C2.43535 16.1746 2.43439 16.1753 2.43369 16.1758C2.07521 16.4221 1.91657 16.8725 2.04291 17.2898C2.17061 17.7115 2.55933 18 3 18H21C21.4407 18 21.8294 17.7115 21.9571 17.2898C22.0834 16.8725 21.9248 16.4221 21.5663 16.1758Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.81822 20.1237C10.3022 19.8576 10.9102 20.0343 11.1763 20.5182C11.2574 20.6657 11.3766 20.7887 11.5215 20.8744C11.6664 20.9601 11.8317 21.0053 12 21.0053C12.1683 21.0053 12.3336 20.9601 12.4785 20.8744C12.6234 20.7887 12.7426 20.6657 12.8237 20.5182C13.0898 20.0343 13.6978 19.8576 14.1818 20.1237C14.6657 20.3898 14.8424 20.9978 14.5763 21.4818C14.3226 21.9432 13.9497 22.3279 13.4965 22.5959C13.0434 22.8639 12.5265 23.0053 12 23.0053C11.4735 23.0053 10.9567 22.8639 10.5035 22.5959C10.0503 22.3279 9.67738 21.9432 9.42371 21.4818C9.15763 20.9978 9.33425 20.3898 9.81822 20.1237Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  PanelLeft: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 22C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5ZM5 4C4.44772 4 4 4.44772 4 5V8H20V5C20 4.44772 19.5523 4 19 4H5ZM8 10H4V19C4 19.5523 4.44772 20 5 20H8V10ZM10 20V10H20V19C20 19.5523 19.5523 20 19 20H10Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  Paperclip: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.2885 3.88273C16.7243 3.31954 15.9595 3.00354 15.1623 3.00424C14.3652 3.00495 13.6009 3.3223 13.0377 3.88649L4.46709 12.4571C3.52878 13.3954 3.00165 14.668 3.00165 15.995C3.00165 17.322 3.52878 18.5946 4.46709 19.5329C5.4054 20.4712 6.67802 20.9983 8.00498 20.9983C9.33195 20.9983 10.6046 20.4712 11.5429 19.5329L20.7329 10.3429C21.1234 9.95237 21.7566 9.95237 22.1471 10.3429C22.5376 10.7334 22.5376 11.3666 22.1471 11.7571L12.9571 20.9471C11.6437 22.2605 9.86238 22.9983 8.00498 22.9983C6.14758 22.9983 4.36626 22.2605 3.05288 20.9471C1.7395 19.6337 1.00165 17.8524 1.00165 15.995C1.00165 14.1376 1.7395 12.3563 3.05288 11.0429L11.6223 2.47352C12.5601 1.53432 13.8333 1.00542 15.1606 1.00424C16.4882 1.00307 17.7619 1.52934 18.7015 2.46727C19.6411 3.40521 20.1696 4.67798 20.1707 6.00559C20.1719 7.33319 19.6456 8.60689 18.7077 9.54649L10.1171 18.1171C9.55427 18.6799 8.79093 18.9961 7.99498 18.9961C7.19904 18.9961 6.43569 18.6799 5.87288 18.1171C5.31006 17.5543 4.99387 16.7909 4.99387 15.995C4.99387 15.1991 5.31006 14.4357 5.87288 13.8729L14.3633 5.39248C14.754 5.00219 15.3872 5.00256 15.7775 5.39331C16.1678 5.78407 16.1674 6.41723 15.7767 6.80753L7.28709 15.2871C7.09961 15.4748 6.99387 15.7297 6.99387 15.995C6.99387 16.2605 7.09935 16.5152 7.28709 16.7029C7.47484 16.8906 7.72947 16.9961 7.99498 16.9961C8.2605 16.9961 8.51513 16.8906 8.70288 16.7029L17.2923 8.13352L17.2931 8.13266C17.8558 7.56856 18.1714 6.80412 18.1707 6.00735C18.17 5.21017 17.8527 4.44593 17.2885 3.88273Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  PenLine: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 20C11 19.4477 11.4477 19 12 19H21C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H12C11.4477 21 11 20.5523 11 20Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18 3.87869C17.7026 3.87869 17.4174 3.99683 17.2071 4.20712L4.90299 16.5113L4.37439 18.6256L6.48877 18.097L18.7929 5.79291C18.897 5.68878 18.9796 5.56517 19.036 5.42912C19.0923 5.29308 19.1213 5.14727 19.1213 5.00001C19.1213 4.85276 19.0923 4.70695 19.036 4.5709C18.9796 4.43486 18.897 4.31124 18.7929 4.20712C18.6888 4.103 18.5652 4.0204 18.4291 3.96405C18.2931 3.9077 18.1473 3.87869 18 3.87869ZM15.7929 2.79291C16.3783 2.20754 17.1722 1.87869 18 1.87869C18.4099 1.87869 18.8158 1.95943 19.1945 2.11629C19.5732 2.27315 19.9173 2.50306 20.2071 2.79291C20.497 3.08275 20.7269 3.42684 20.8837 3.80554C21.0406 4.18423 21.1213 4.59011 21.1213 5.00001C21.1213 5.40991 21.0406 5.81579 20.8837 6.19449C20.7269 6.57319 20.497 6.91728 20.2071 7.20712L7.70713 19.7071C7.57897 19.8353 7.41839 19.9262 7.24256 19.9702L3.24256 20.9702C2.90178 21.0553 2.54129 20.9555 2.29291 20.7071C2.04453 20.4587 1.94468 20.0983 2.02988 19.7575L3.02988 15.7575C3.07384 15.5816 3.16476 15.4211 3.29291 15.2929L15.7929 2.79291Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Pencil: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.2893 4.29655L14.2929 4.29289L14.2965 4.28926L16.2657 2.32007C16.605 1.92848 17.0203 1.60944 17.4865 1.38197C17.9661 1.14796 18.4891 1.01587 19.0224 0.993861C19.5557 0.971855 20.088 1.0604 20.5852 1.25403C21.0825 1.44766 21.5343 1.74225 21.9114 2.11941C22.2886 2.49659 22.5829 2.94809 22.7752 3.44534C22.9676 3.94261 23.0535 4.47445 23.0274 5.00687C23.0014 5.53929 22.8639 6.06023 22.624 6.53643C22.392 6.99707 22.0692 7.40589 21.6754 7.73886L8.20713 21.2071C8.08407 21.3302 7.93104 21.419 7.76314 21.4648L2.26314 22.9648C1.91693 23.0592 1.54667 22.9609 1.29292 22.7071C1.03917 22.4534 0.940838 22.0831 1.03526 21.7369L2.53526 16.2369C2.58105 16.069 2.66986 15.9159 2.79292 15.7929L14.2893 4.29655ZM19.1049 2.99216C19.3627 2.98152 19.6197 3.02435 19.8596 3.11774C20.0994 3.21112 20.3165 3.35289 20.4972 3.53362C20.6779 3.71434 20.8183 3.93003 20.9099 4.16673C21.0014 4.40342 21.0422 4.65621 21.0298 4.90908C21.0174 5.16195 20.9522 5.40974 20.8378 5.63669C20.7235 5.86367 20.5625 6.06504 20.3648 6.22768C20.3398 6.24824 20.3158 6.27 20.2929 6.29289L19 7.58579L16.4142 5.00001L17.7071 3.7071C17.7267 3.68751 17.7455 3.66711 17.7634 3.64596C17.9282 3.45116 18.1325 3.29212 18.3636 3.17939C18.5946 3.06665 18.8471 3.0028 19.1049 2.99216ZM17.5858 9.00001L6.9807 19.6051L3.42524 20.5748L4.39491 17.0193L15 6.41422L17.5858 9.00001Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  Placeholder: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22.7906 14.1468L20.8286 13.7586C20.9409 13.1915 21 12.6036 21 12C21 11.3964 20.9409 10.8085 20.8286 10.2414L22.7906 9.85322C22.928 10.5475 23 11.2654 23 12C23 12.7346 22.928 13.4525 22.7906 14.1468ZM21.1472 5.88823L19.4853 7.00087C18.8276 6.01854 17.9815 5.17237 16.9991 4.51472L18.1118 2.85278C19.3113 3.65587 20.3441 4.68866 21.1472 5.88823ZM14.1468 1.20937C13.4525 1.07202 12.7346 1 12 1C11.2654 1 10.5475 1.07202 9.85322 1.20937L10.2414 3.17135C10.8085 3.05914 11.3964 3 12 3C12.6036 3 13.1915 3.05914 13.7586 3.17135L14.1468 1.20937ZM5.88823 2.85278L7.00087 4.51472C6.01854 5.17237 5.17237 6.01854 4.51472 7.00087L2.85278 5.88823C3.65587 4.68866 4.68866 3.65587 5.88823 2.85278ZM1.20937 9.85322C1.07202 10.5475 1 11.2654 1 12C1 12.7346 1.07202 13.4525 1.20937 14.1468L3.17135 13.7586C3.05914 13.1915 3 12.6036 3 12C3 11.3964 3.05914 10.8085 3.17135 10.2414L1.20937 9.85322ZM2.85278 18.1118L4.51472 16.9991C5.17237 17.9815 6.01854 18.8276 7.00087 19.4853L5.88823 21.1472C4.68866 20.3441 3.65587 19.3113 2.85278 18.1118ZM9.85322 22.7906L10.2414 20.8286C10.8085 20.9409 11.3964 21 12 21C12.6036 21 13.1915 20.9409 13.7586 20.8286L14.1468 22.7906C13.4525 22.928 12.7346 23 12 23C11.2654 23 10.5475 22.928 9.85322 22.7906ZM18.1118 21.1472L16.9991 19.4853C17.9815 18.8276 18.8276 17.9815 19.4853 16.9991L21.1472 18.1118C20.3441 19.3113 19.3113 20.3441 18.1118 21.1472Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  Play: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          d: "M6.54076 2.15882C6.23305 1.96101 5.84189 1.947 5.52081 2.12229C5.19974 2.29758 5 2.63419 5 3V21C5 21.3658 5.19974 21.7024 5.52081 21.8777C5.84189 22.053 6.23305 22.039 6.54076 21.8412L20.5408 12.8412C20.827 12.6572 21 12.3403 21 12C21 11.6597 20.827 11.3428 20.5408 11.1588L6.54076 2.15882Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  Plus: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          d: "M13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13V5Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  Question: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M12.2581 8.02434C11.7926 7.94449 11.3138 8.03197 10.9066 8.27129C10.4994 8.5106 10.1901 8.88631 10.0333 9.33187C9.85006 9.85286 9.27914 10.1266 8.75815 9.94336C8.23716 9.76008 7.96339 9.18917 8.14666 8.66818C8.46013 7.77707 9.07886 7.02565 9.89327 6.54702C10.7077 6.06839 11.6652 5.89343 12.5962 6.05313C13.5273 6.21283 14.3717 6.69688 14.9801 7.41955C15.5883 8.14207 15.9213 9.0565 15.92 10.0009C15.9195 11.5313 14.7849 12.5419 13.9747 13.0821C13.5391 13.3725 13.1105 13.586 12.7949 13.7263C12.6356 13.7971 12.5015 13.8508 12.4049 13.8876C12.3565 13.9061 12.3173 13.9204 12.2887 13.9305L12.254 13.9427L12.2429 13.9465L12.239 13.9478L12.2375 13.9483C12.2375 13.9483 12.2362 13.9487 11.92 13L12.2362 13.9487C11.7123 14.1234 11.146 13.8402 10.9713 13.3162C10.7968 12.7927 11.0794 12.2267 11.6027 12.0517L11.6187 12.0461C11.6341 12.0406 11.6593 12.0315 11.6929 12.0187C11.7603 11.993 11.8606 11.9529 11.9826 11.8987C12.2294 11.789 12.5509 11.6276 12.8653 11.418C13.5549 10.9582 13.92 10.4692 13.92 10L13.92 9.99853C13.9207 9.52621 13.7542 9.06889 13.45 8.70755C13.1459 8.34622 12.7236 8.10419 12.2581 8.02434Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18H12.01C12.5623 18 13.01 17.5523 13.01 17C13.01 16.4477 12.5623 16 12.01 16H12Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Search: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.9929 15.9929C16.3834 15.6024 17.0166 15.6024 17.4071 15.9929L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L15.9929 17.4071C15.6024 17.0166 15.6024 16.3834 15.9929 15.9929Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Section: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M4 2C2.89543 2 2 2.89543 2 4V9C2 10.1046 2.89543 11 4 11H20C21.1046 11 22 10.1046 22 9V4C22 2.89543 21.1046 2 20 2H4Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2 15C2 13.8954 2.89543 13 4 13H9C10.1046 13 11 13.8954 11 15V20C11 21.1046 10.1046 22 9 22H4C2.89543 22 2 21.1046 2 20V15ZM9 15H4V20H9V15Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 13C13.8954 13 13 13.8954 13 15V20C13 21.1046 13.8954 22 15 22H20C21.1046 22 22 21.1046 22 20V15C22 13.8954 21.1046 13 20 13H15ZM15 15H20V20H15V15Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Settings: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 3C4.79086 3 3 4.79086 3 7C3 9.20914 4.79086 11 7 11C8.86658 11 10.4345 9.72147 10.8759 7.99238C10.9166 7.99741 10.958 8 11 8H20C20.5523 8 21 7.55228 21 7C21 6.44772 20.5523 6 20 6H11C10.958 6 10.9166 6.00259 10.8759 6.00762C10.4345 4.27853 8.86658 3 7 3ZM5 7C5 5.89543 5.89543 5 7 5C8.10457 5 9 5.89543 9 7C9 8.10457 8.10457 9 7 9C5.89543 9 5 8.10457 5 7Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5 16C4.44772 16 4 16.4477 4 17C4 17.5523 4.44772 18 5 18H13.126C13.5701 19.7252 15.1362 21 17 21C19.2091 21 21 19.2091 21 17C21 14.7909 19.2091 13 17 13C15.1362 13 13.5701 14.2748 13.126 16H5ZM17 19C15.8954 19 15 18.1046 15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17C19 18.1046 18.1046 19 17 19Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Share2: Ce.forwardRef(
    ({ fill: t, width: e, height: n, ...r }, i) => /* @__PURE__ */ T.jsxs(
      "svg",
      {
        ref: i,
        width: e,
        height: n,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        ...r,
        children: [
          /* @__PURE__ */ T.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M4 11C4.55228 11 5 11.4477 5 12V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H18C18.2652 21 18.5196 20.8946 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V12C19 11.4477 19.4477 11 20 11C20.5523 11 21 11.4477 21 12V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H6C5.20435 23 4.44129 22.6839 3.87868 22.1213C3.31607 21.5587 3 20.7957 3 20V12C3 11.4477 3.44772 11 4 11Z",
              fill: t,
              stroke: "none"
            }
          ),
          /* @__PURE__ */ T.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.2929 1.29289C11.6834 0.902369 12.3166 0.902369 12.7071 1.29289L16.7071 5.29289C17.0976 5.68342 17.0976 6.31658 16.7071 6.70711C16.3166 7.09763 15.6834 7.09763 15.2929 6.70711L12 3.41421L8.70711 6.70711C8.31658 7.09763 7.68342 7.09763 7.29289 6.70711C6.90237 6.31658 6.90237 5.68342 7.29289 5.29289L11.2929 1.29289Z",
              fill: t,
              stroke: "none"
            }
          ),
          /* @__PURE__ */ T.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12 1C12.5523 1 13 1.44772 13 2V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V2C11 1.44772 11.4477 1 12 1Z",
              fill: t,
              stroke: "none"
            }
          )
        ]
      }
    )
  ),
  Share: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.1581 7.81486C15.883 8.54668 16.8885 9 18 9C20.2091 9 22 7.20914 22 5C22 2.79086 20.2091 1 18 1C15.7909 1 14 2.79086 14 5C14 5.37702 14.0522 5.74186 14.1497 6.08769L8.84194 9.18515C8.11704 8.45332 7.11146 8 6 8C3.79086 8 2 9.79086 2 12C2 14.2091 3.79086 16 6 16C7.11166 16 8.11741 15.5465 8.84234 14.8145L14.1509 17.9079C14.0526 18.255 14 18.6214 14 19C14 21.2091 15.7909 23 18 23C20.2091 23 22 21.2091 22 19C22 16.7909 20.2091 15 18 15C16.8902 15 15.886 15.452 15.1613 16.1819L9.8505 13.0871C9.94789 12.7415 10 12.3768 10 12C10 11.623 9.94784 11.2582 9.85034 10.9123L15.1581 7.81486ZM18 3C16.8954 3 16 3.89543 16 5C16 5.34734 16.0885 5.674 16.2443 5.95864C16.2545 5.97406 16.2643 5.98984 16.2737 6.00598C16.283 6.02201 16.2919 6.03818 16.3003 6.05449C16.6531 6.62211 17.2824 7 18 7C19.1046 7 20 6.10457 20 5C20 3.89543 19.1046 3 18 3ZM7.69965 10.9454C7.70804 10.9617 7.71692 10.978 7.72631 10.994C7.73576 11.0102 7.7456 11.0261 7.7558 11.0415C7.91149 11.3261 8 11.6527 8 12C8 12.3473 7.91147 12.6739 7.75575 12.9586C7.74545 12.9742 7.73552 12.9902 7.72599 13.0065C7.71674 13.0224 7.70798 13.0384 7.69971 13.0546C7.34681 13.6221 6.71753 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10C6.71749 10 7.34674 10.3778 7.69965 10.9454ZM16 19C16 18.6749 16.0776 18.3678 16.2153 18.0965C16.24 18.064 16.2629 18.0296 16.284 17.9935C16.3042 17.9588 16.3221 17.9235 16.3377 17.8875C16.6966 17.3523 17.3072 17 18 17C19.1046 17 20 17.8954 20 19C20 20.1046 19.1046 21 18 21C16.8954 21 16 20.1046 16 19Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  Facebook: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.7574 2.75736C11.8826 1.63214 13.4087 1 15 1H18C18.5523 1 19 1.44772 19 2V6C19 6.55228 18.5523 7 18 7H15V9H18C18.3079 9 18.5987 9.14187 18.7882 9.38459C18.9777 9.6273 19.0448 9.94379 18.9701 10.2425L17.9701 14.2425C17.8589 14.6877 17.4589 15 17 15H15V22C15 22.5523 14.5523 23 14 23H10C9.44772 23 9 22.5523 9 22V15H7C6.44772 15 6 14.5523 6 14V10C6 9.44772 6.44772 9 7 9H9V7C9 5.4087 9.63214 3.88258 10.7574 2.75736ZM15 3C13.9391 3 12.9217 3.42143 12.1716 4.17157C11.4214 4.92172 11 5.93913 11 7V10C11 10.5523 10.5523 11 10 11H8V13H10C10.5523 13 11 13.4477 11 14V21H13V14C13 13.4477 13.4477 13 14 13H16.2192L16.7192 11H14C13.4477 11 13 10.5523 13 10V7C13 6.46957 13.2107 5.96086 13.5858 5.58579C13.9609 5.21071 14.4696 5 15 5H17V3H15Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  Instagram: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.74012 7.51843C10.6736 7.03406 11.7361 6.85637 12.7764 7.01063C13.8375 7.16799 14.82 7.66246 15.5785 8.42101C16.3371 9.17957 16.8315 10.162 16.9889 11.2231C17.1432 12.2634 16.9655 13.3259 16.4811 14.2594C15.9967 15.1929 15.2303 15.9499 14.2909 16.4227C13.3515 16.8955 12.287 17.0601 11.2486 16.893C10.2103 16.726 9.25109 16.2357 8.50744 15.4921C7.76379 14.7484 7.27356 13.7892 7.10648 12.7509C6.9394 11.7126 7.10397 10.648 7.5768 9.7086C8.04963 8.7692 8.80662 8.00281 9.74012 7.51843ZM12.483 8.989C11.8588 8.89644 11.2214 9.00305 10.6613 9.29368C10.1012 9.5843 9.64697 10.0441 9.36327 10.6078C9.07957 11.1714 8.98083 11.8102 9.08108 12.4332C9.18132 13.0562 9.47546 13.6317 9.92165 14.0779C10.3678 14.5241 10.9434 14.8182 11.5664 14.9184C12.1894 15.0187 12.8281 14.9199 13.3917 14.6363C13.9554 14.3526 14.4152 13.8984 14.7058 13.3383C14.9965 12.7782 15.1031 12.1407 15.0105 11.5165C14.9161 10.8798 14.6194 10.2904 14.1643 9.83523C13.7092 9.3801 13.1197 9.08341 12.483 8.989Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M17.5 5.5C16.9477 5.5 16.5 5.94772 16.5 6.5C16.5 7.05228 16.9477 7.5 17.5 7.5H17.51C18.0623 7.5 18.51 7.05228 18.51 6.5C18.51 5.94772 18.0623 5.5 17.51 5.5H17.5Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 7C1 3.68629 3.68629 1 7 1H17C20.3137 1 23 3.68629 23 7V17C23 20.3137 20.3137 23 17 23H7C3.68629 23 1 20.3137 1 17V7ZM7 3C4.79086 3 3 4.79086 3 7V17C3 19.2091 4.79086 21 7 21H17C19.2091 21 21 19.2091 21 17V7C21 4.79086 19.2091 3 17 3H7Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Linkedin: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 1C2.34315 1 1 2.34315 1 4C1 5.65685 2.34315 7 4 7C5.65685 7 7 5.65685 7 4C7 2.34315 5.65685 1 4 1ZM3 4C3 3.44772 3.44772 3 4 3C4.55228 3 5 3.44772 5 4C5 4.55228 4.55228 5 4 5C3.44772 5 3 4.55228 3 4Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.0503 9.05025C12.363 7.7375 14.1435 7 16 7C17.8565 7 19.637 7.7375 20.9497 9.05025C22.2625 10.363 23 12.1435 23 14V21C23 21.5523 22.5523 22 22 22H18C17.4477 22 17 21.5523 17 21V14C17 13.7348 16.8946 13.4804 16.7071 13.2929C16.5196 13.1054 16.2652 13 16 13C15.7348 13 15.4804 13.1054 15.2929 13.2929C15.1054 13.4804 15 13.7348 15 14V21C15 21.5523 14.5523 22 14 22H10C9.44771 22 9 21.5523 9 21V14C9 12.1435 9.7375 10.363 11.0503 9.05025ZM16 9C14.6739 9 13.4021 9.52678 12.4645 10.4645C11.5268 11.4021 11 12.6739 11 14V20H13V14C13 13.2043 13.3161 12.4413 13.8787 11.8787C14.4413 11.3161 15.2043 11 16 11C16.7957 11 17.5587 11.3161 18.1213 11.8787C18.6839 12.4413 19 13.2043 19 14V20H21V14C21 12.6739 20.4732 11.4021 19.5355 10.4645C18.5979 9.52678 17.3261 9 16 9Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 9C1 8.44772 1.44772 8 2 8H6C6.55228 8 7 8.44772 7 9V21C7 21.5523 6.55228 22 6 22H2C1.44772 22 1 21.5523 1 21V9ZM3 10V20H5V10H3Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  X: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          d: "M18.244 2.25H21.552L14.325 10.51L22.827 21.75H16.17L10.956 14.933L4.99 21.75H1.68L9.41 12.915L1.254 2.25H8.08L12.793 8.481L18.244 2.25ZM17.083 19.77H18.916L7.084 4.126H5.117L17.083 19.77Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  Trash: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M10 10C10.5523 10 11 10.4477 11 11V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V11C9 10.4477 9.44772 10 10 10Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11V17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V11Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 5V4C7 3.17477 7.40255 2.43324 7.91789 1.91789C8.43324 1.40255 9.17477 1 10 1H14C14.8252 1 15.5668 1.40255 16.0821 1.91789C16.5975 2.43324 17 3.17477 17 4V5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H20V20C20 20.8252 19.5975 21.5668 19.0821 22.0821C18.5668 22.5975 17.8252 23 17 23H7C6.17477 23 5.43324 22.5975 4.91789 22.0821C4.40255 21.5668 4 20.8252 4 20V7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H7ZM9 4C9 3.82523 9.09745 3.56676 9.33211 3.33211C9.56676 3.09745 9.82523 3 10 3H14C14.1748 3 14.4332 3.09745 14.6679 3.33211C14.9025 3.56676 15 3.82523 15 4V5H9V4ZM6 7V20C6 20.1748 6.09745 20.4332 6.33211 20.6679C6.56676 20.9025 6.82523 21 7 21H17C17.1748 21 17.4332 20.9025 17.6679 20.6679C17.9025 20.4332 18 20.1748 18 20V7H6Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Type: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          d: "M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V7C21 7.55228 20.5523 8 20 8C19.4477 8 19 7.55228 19 7V5H13V19H15C15.5523 19 16 19.4477 16 20C16 20.5523 15.5523 21 15 21H9C8.44772 21 8 20.5523 8 20C8 19.4477 8.44772 19 9 19H11V5H5V7C5 7.55228 4.55228 8 4 8C3.44772 8 3 7.55228 3 7V4Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  ),
  Upload: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 14C3.55228 14 4 14.4477 4 15V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V15C2 14.4477 2.44772 14 3 14Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.2929 2.29289C11.6834 1.90237 12.3166 1.90237 12.7071 2.29289L17.7071 7.29289C18.0976 7.68342 18.0976 8.31658 17.7071 8.70711C17.3166 9.09763 16.6834 9.09763 16.2929 8.70711L12 4.41421L7.70711 8.70711C7.31658 9.09763 6.68342 9.09763 6.29289 8.70711C5.90237 8.31658 5.90237 7.68342 6.29289 7.29289L11.2929 2.29289Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 2C12.5523 2 13 2.44772 13 3V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V3C11 2.44772 11.4477 2 12 2Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Users: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsxs(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ T.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 8C16 9.94452 15.075 11.673 13.641 12.7694C14.6465 13.2142 15.5715 13.8436 16.364 14.636C18.0518 16.3239 19 18.6131 19 21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21C17 19.1435 16.2625 17.363 14.9497 16.0503C13.637 14.7375 11.8565 14 10 14C8.14348 14 6.36301 14.7375 5.05025 16.0503C3.7375 17.363 3 19.1435 3 21C3 21.5523 2.55228 22 2 22C1.44772 22 1 21.5523 1 21C1 18.6131 1.94821 16.3239 3.63604 14.636C4.4285 13.8436 5.35354 13.2142 6.35901 12.7694C4.92501 11.673 4 9.94452 4 8C4 4.68629 6.68629 2 10 2C13.3137 2 16 4.68629 16 8ZM10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4Z",
            fill: t,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "path",
          {
            d: "M18.0601 2.83989C17.5851 2.55815 16.9716 2.71484 16.6899 3.18986C16.4082 3.66487 16.5648 4.27835 17.0399 4.56008C17.6054 4.89549 18.0795 5.36513 18.4202 5.92744C18.761 6.48975 18.9579 7.12739 18.9935 7.78392C19.0291 8.44046 18.9023 9.09564 18.6243 9.6915C18.3464 10.2874 17.9258 10.8055 17.3999 11.2001C17.1481 11.389 17 11.6853 17 12.0001C17 12.3148 17.1482 12.6111 17.4 12.8C19.186 14.1395 21 16.9892 21 20C21 20.5523 21.4477 21 22 21C22.5523 21 23 20.5523 23 20C23 16.7784 21.3686 13.7948 19.4971 11.9717C19.876 11.5425 20.193 11.0597 20.4368 10.537C20.8537 9.64323 21.0439 8.66045 20.9905 7.67565C20.9372 6.69085 20.6418 5.73439 20.1307 4.89093C19.6196 4.04746 18.9084 3.343 18.0601 2.83989Z",
            fill: t,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Close: ({ fill: t, width: e, height: n, ...r }) => /* @__PURE__ */ T.jsx(
    "svg",
    {
      width: e,
      height: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ T.jsx(
        "path",
        {
          d: "M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z",
          fill: t,
          stroke: "none"
        }
      )
    }
  )
}, h0t = Ha("object-contain", {
  variants: {
    size: {
      sm: "w-4",
      md: "w-6",
      lg: "w-8"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), p0t = en(
  ({
    name: t,
    size: e = "md",
    // Default size
    fill: n = "none",
    // Default fill
    stroke: r = "none",
    // Default stroke
    className: i,
    ...a
  }, o) => {
    const s = f0t[t];
    if (!s)
      return console.error(`Icon "${t}" not found`), null;
    const l = e === "sm" ? 16 : e === "md" ? 24 : e === "lg" ? 32 : 24, c = {
      width: l,
      height: l,
      fill: n,
      name: t,
      stroke: r,
      className: be(h0t({ size: e }), i),
      ref: o,
      // Attach the ref here
      ...a
    };
    return /* @__PURE__ */ T.jsx(s, { ...c, ref: o });
  }
);
p0t.displayName = "Icon";
function Yg(t) {
  const e = t + "CollectionProvider", [n, r] = ei(e), [i, a] = n(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), o = (h) => {
    const { scope: p, children: m } = h, g = Ce.useRef(null), v = Ce.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ T.jsx(i, { scope: p, itemMap: v, collectionRef: g, children: m });
  };
  o.displayName = e;
  const s = t + "CollectionSlot", l = Ce.forwardRef(
    (h, p) => {
      const { scope: m, children: g } = h, v = a(s, m), k = Jt(p, v.collectionRef);
      return /* @__PURE__ */ T.jsx(ns, { ref: k, children: g });
    }
  );
  l.displayName = s;
  const c = t + "CollectionItemSlot", u = "data-radix-collection-item", d = Ce.forwardRef(
    (h, p) => {
      const { scope: m, children: g, ...v } = h, k = Ce.useRef(null), w = Jt(p, k), b = a(c, m);
      return Ce.useEffect(() => (b.itemMap.set(k, { ref: k, ...v }), () => void b.itemMap.delete(k))), /* @__PURE__ */ T.jsx(ns, { [u]: "", ref: w, children: g });
    }
  );
  d.displayName = c;
  function f(h) {
    const p = a(t + "CollectionConsumer", h);
    return Ce.useCallback(() => {
      const m = p.collectionRef.current;
      if (!m) return [];
      const g = Array.from(m.querySelectorAll(`[${u}]`));
      return Array.from(p.itemMap.values()).sort(
        (v, k) => g.indexOf(v.ref.current) - g.indexOf(k.ref.current)
      );
    }, [p.collectionRef, p.itemMap]);
  }
  return [
    { Provider: o, Slot: l, ItemSlot: d },
    f,
    r
  ];
}
var KV = N.createContext(void 0), m0t = (t) => {
  const { dir: e, children: n } = t;
  return /* @__PURE__ */ T.jsx(KV.Provider, { value: e, children: n });
};
function Kg(t) {
  const e = N.useContext(KV);
  return t || e || "ltr";
}
var w8 = "rovingFocusGroup.onEntryFocus", y0t = { bubbles: !1, cancelable: !0 }, $g = "RovingFocusGroup", [r9, $V, g0t] = Yg($g), [v0t, Jg] = ei(
  $g,
  [g0t]
), [b0t, w0t] = v0t($g), JV = N.forwardRef(
  (t, e) => /* @__PURE__ */ T.jsx(r9.Provider, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ T.jsx(r9.Slot, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ T.jsx(k0t, { ...t, ref: e }) }) })
);
JV.displayName = $g;
var k0t = N.forwardRef((t, e) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: i = !1,
    dir: a,
    currentTabStopId: o,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = t, f = N.useRef(null), h = Jt(e, f), p = Kg(a), [m = null, g] = mo({
    prop: o,
    defaultProp: s,
    onChange: l
  }), [v, k] = N.useState(!1), w = Di(c), b = $V(n), x = N.useRef(!1), [A, L] = N.useState(0);
  return N.useEffect(() => {
    const M = f.current;
    if (M)
      return M.addEventListener(w8, w), () => M.removeEventListener(w8, w);
  }, [w]), /* @__PURE__ */ T.jsx(
    b0t,
    {
      scope: n,
      orientation: r,
      dir: p,
      loop: i,
      currentTabStopId: m,
      onItemFocus: N.useCallback(
        (M) => g(M),
        [g]
      ),
      onItemShiftTab: N.useCallback(() => k(!0), []),
      onFocusableItemAdd: N.useCallback(
        () => L((M) => M + 1),
        []
      ),
      onFocusableItemRemove: N.useCallback(
        () => L((M) => M - 1),
        []
      ),
      children: /* @__PURE__ */ T.jsx(
        Ct.div,
        {
          tabIndex: v || A === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: h,
          style: { outline: "none", ...t.style },
          onMouseDown: it(t.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: it(t.onFocus, (M) => {
            const j = !x.current;
            if (M.target === M.currentTarget && j && !v) {
              const D = new CustomEvent(w8, y0t);
              if (M.currentTarget.dispatchEvent(D), !D.defaultPrevented) {
                const z = b().filter((_) => _.focusable), H = z.find((_) => _.active), V = z.find((_) => _.id === m), F = [H, V, ...z].filter(
                  Boolean
                ).map((_) => _.ref.current);
                eq(F, u);
              }
            }
            x.current = !1;
          }),
          onBlur: it(t.onBlur, () => k(!1))
        }
      )
    }
  );
}), QV = "RovingFocusGroupItem", XV = N.forwardRef(
  (t, e) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: i = !1,
      tabStopId: a,
      ...o
    } = t, s = Xa(), l = a || s, c = w0t(QV, n), u = c.currentTabStopId === l, d = $V(n), { onFocusableItemAdd: f, onFocusableItemRemove: h } = c;
    return N.useEffect(() => {
      if (r)
        return f(), () => h();
    }, [r, f, h]), /* @__PURE__ */ T.jsx(
      r9.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: i,
        children: /* @__PURE__ */ T.jsx(
          Ct.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": c.orientation,
            ...o,
            ref: e,
            onMouseDown: it(t.onMouseDown, (p) => {
              r ? c.onItemFocus(l) : p.preventDefault();
            }),
            onFocus: it(t.onFocus, () => c.onItemFocus(l)),
            onKeyDown: it(t.onKeyDown, (p) => {
              if (p.key === "Tab" && p.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (p.target !== p.currentTarget) return;
              const m = C0t(p, c.orientation, c.dir);
              if (m !== void 0) {
                if (p.metaKey || p.ctrlKey || p.altKey || p.shiftKey) return;
                p.preventDefault();
                let g = d().filter((v) => v.focusable).map((v) => v.ref.current);
                if (m === "last") g.reverse();
                else if (m === "prev" || m === "next") {
                  m === "prev" && g.reverse();
                  const v = g.indexOf(p.currentTarget);
                  g = c.loop ? A0t(g, v + 1) : g.slice(v + 1);
                }
                setTimeout(() => eq(g));
              }
            })
          }
        )
      }
    );
  }
);
XV.displayName = QV;
var x0t = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function M0t(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function C0t(t, e, n) {
  const r = M0t(t.key, n);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return x0t[r];
}
function eq(t, e = !1) {
  const n = document.activeElement;
  for (const r of t)
    if (r === n || (r.focus({ preventScroll: e }), document.activeElement !== n)) return;
}
function A0t(t, e) {
  return t.map((n, r) => t[(e + r) % t.length]);
}
var tq = JV, nq = XV, LM = "Tabs", [S0t, lGt] = ei(LM, [
  Jg
]), rq = Jg(), [L0t, TM] = S0t(LM), iq = N.forwardRef(
  (t, e) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: i,
      defaultValue: a,
      orientation: o = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = t, u = Kg(s), [d, f] = mo({
      prop: r,
      onChange: i,
      defaultProp: a
    });
    return /* @__PURE__ */ T.jsx(
      L0t,
      {
        scope: n,
        baseId: Xa(),
        value: d,
        onValueChange: f,
        orientation: o,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ T.jsx(
          Ct.div,
          {
            dir: u,
            "data-orientation": o,
            ...c,
            ref: e
          }
        )
      }
    );
  }
);
iq.displayName = LM;
var aq = "TabsList", oq = N.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, loop: r = !0, ...i } = t, a = TM(aq, n), o = rq(n);
    return /* @__PURE__ */ T.jsx(
      tq,
      {
        asChild: !0,
        ...o,
        orientation: a.orientation,
        dir: a.dir,
        loop: r,
        children: /* @__PURE__ */ T.jsx(
          Ct.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...i,
            ref: e
          }
        )
      }
    );
  }
);
oq.displayName = aq;
var sq = "TabsTrigger", lq = N.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, value: r, disabled: i = !1, ...a } = t, o = TM(sq, n), s = rq(n), l = dq(o.baseId, r), c = fq(o.baseId, r), u = r === o.value;
    return /* @__PURE__ */ T.jsx(
      nq,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: u,
        children: /* @__PURE__ */ T.jsx(
          Ct.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": i ? "" : void 0,
            disabled: i,
            id: l,
            ...a,
            ref: e,
            onMouseDown: it(t.onMouseDown, (d) => {
              !i && d.button === 0 && d.ctrlKey === !1 ? o.onValueChange(r) : d.preventDefault();
            }),
            onKeyDown: it(t.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && o.onValueChange(r);
            }),
            onFocus: it(t.onFocus, () => {
              const d = o.activationMode !== "manual";
              !u && !i && d && o.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
lq.displayName = sq;
var cq = "TabsContent", uq = N.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, value: r, forceMount: i, children: a, ...o } = t, s = TM(cq, n), l = dq(s.baseId, r), c = fq(s.baseId, r), u = r === s.value, d = N.useRef(u);
    return N.useEffect(() => {
      const f = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(f);
    }, []), /* @__PURE__ */ T.jsx(zi, { present: i || u, children: ({ present: f }) => /* @__PURE__ */ T.jsx(
      Ct.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !f,
        id: c,
        tabIndex: 0,
        ...o,
        ref: e,
        style: {
          ...t.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: f && a
      }
    ) });
  }
);
uq.displayName = cq;
function dq(t, e) {
  return `${t}-trigger-${e}`;
}
function fq(t, e) {
  return `${t}-content-${e}`;
}
var T0t = iq, hq = oq, pq = lq, mq = uq;
const E0t = T0t, yq = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  hq,
  {
    ref: n,
    className: be(
      "inline-flex h-9 items-center justify-center bg-none p-1 color-text-secondary",
      t
    ),
    ...e
  }
));
yq.displayName = hq.displayName;
const i9 = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  pq,
  {
    ref: n,
    className: be(
      "inline-flex items-center justify-center whitespace-nowrap h-[38px] px-3 py-1 text-heading-xsm color-text-secondary ring-offset-2 transition-all focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused disabled:pointer-events-none disabled:color-text-disabled hover:color-bg-default-hover data-[state=active]:color-text-default border-b-2 border-transparent data-[state=active]:color-border-active dark:data-[state=active]:color-border-light",
      t
    ),
    "data-testid": "tabs-trigger",
    ...e
  }
));
i9.displayName = pq.displayName;
const gq = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  mq,
  {
    ref: n,
    className: be(
      "mt-2 color-text-default ring-offset-2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused",
      t
    ),
    ...e
  }
));
gq.displayName = mq.displayName;
const j0t = N.forwardRef(
  ({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
    "div",
    {
      ref: n,
      className: be(
        "rounded-xl color-bg-secondary hover:color-bg-default-hover color-text-default p-5 transition-colors w-full h-full",
        t
      ),
      ...e
    }
  )
);
j0t.displayName = "Card";
const N0t = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx("div", { ref: n, className: be("flex flex-col space-y-4", t), ...e }));
N0t.displayName = "CardHeader";
const D0t = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx("h3", { ref: n, className: be("", t), ...e }));
D0t.displayName = "CardTitle";
const I0t = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx("p", { ref: n, className: be("text-body-sm", t), ...e }));
I0t.displayName = "CardDescription";
const P0t = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx("div", { ref: n, className: be("p-6 pt-0", t), ...e }));
P0t.displayName = "CardContent";
const z0t = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx("div", { ref: n, className: be("flex items-center", t), ...e }));
z0t.displayName = "CardFooter";
const Qg = Ce.forwardRef(
  ({
    options: t,
    container: e,
    setCurrentState: n,
    currentState: r,
    showActiveState: i = !0,
    disabled: a,
    contentType: o = "icon",
    ...s
  }, l) => {
    const [c, u] = De(r), d = (f) => {
      !a && u(f), !a && n(f);
    };
    return /* @__PURE__ */ T.jsx(
      "div",
      {
        ref: l,
        className: be(
          "h-[52px] p-2 color-bg-default flex justify-center items-center gap-1 rounded-xl",
          {
            "color-border-default border-[0.5px] shadow-elevation-3": e
          }
        ),
        ...s,
        children: t.map((f, h) => /* @__PURE__ */ T.jsx(
          "div",
          {
            onClick: () => d(h),
            className: be(
              "h-9 flex justify-center items-center rounded cursor-pointer transition-colors",
              {
                "color-bg-brand hover:color-bg-brand-hover color-text-inverse": i && c === h,
                "hover:color-bg-default-hover color-text-default": i && c !== h,
                "cursor-not-allowed color-bg-disabled color-text-disabled": a,
                "w-9": o === "icon",
                "w-fit px-2": o === "text"
              }
            ),
            children: f
          },
          h
        ))
      }
    );
  }
);
Qg.displayName = "SegmentedControl";
var vq = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var a = arguments[i];
        if (a) {
          var o = typeof a;
          if (o === "string" || o === "number")
            r.push(a);
          else if (Array.isArray(a)) {
            if (a.length) {
              var s = n.apply(null, a);
              s && r.push(s);
            }
          } else if (o === "object") {
            if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]")) {
              r.push(a.toString());
              continue;
            }
            for (var l in a)
              e.call(a, l) && a[l] && r.push(l);
          }
        }
      }
      return r.join(" ");
    }
    t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
  })();
})(vq);
var R0t = vq.exports;
const Au = /* @__PURE__ */ aue(R0t);
var k8 = "focusScope.autoFocusOnMount", x8 = "focusScope.autoFocusOnUnmount", oN = { bubbles: !1, cancelable: !0 }, O0t = "FocusScope", jd = N.forwardRef((t, e) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: a,
    ...o
  } = t, [s, l] = N.useState(null), c = Di(i), u = Di(a), d = N.useRef(null), f = Jt(e, (m) => l(m)), h = N.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  N.useEffect(() => {
    if (r) {
      let m = function(w) {
        if (h.paused || !s) return;
        const b = w.target;
        s.contains(b) ? d.current = b : Vl(d.current, { select: !0 });
      }, g = function(w) {
        if (h.paused || !s) return;
        const b = w.relatedTarget;
        b !== null && (s.contains(b) || Vl(d.current, { select: !0 }));
      }, v = function(w) {
        if (document.activeElement === document.body)
          for (const b of w)
            b.removedNodes.length > 0 && Vl(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", g);
      const k = new MutationObserver(v);
      return s && k.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", g), k.disconnect();
      };
    }
  }, [r, s, h.paused]), N.useEffect(() => {
    if (s) {
      lN.add(h);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const g = new CustomEvent(k8, oN);
        s.addEventListener(k8, c), s.dispatchEvent(g), g.defaultPrevented || (B0t(q0t(bq(s)), { select: !0 }), document.activeElement === m && Vl(s));
      }
      return () => {
        s.removeEventListener(k8, c), setTimeout(() => {
          const g = new CustomEvent(x8, oN);
          s.addEventListener(x8, u), s.dispatchEvent(g), g.defaultPrevented || Vl(m ?? document.body, { select: !0 }), s.removeEventListener(x8, u), lN.remove(h);
        }, 0);
      };
    }
  }, [s, c, u, h]);
  const p = N.useCallback(
    (m) => {
      if (!n && !r || h.paused) return;
      const g = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, v = document.activeElement;
      if (g && v) {
        const k = m.currentTarget, [w, b] = H0t(k);
        w && b ? !m.shiftKey && v === b ? (m.preventDefault(), n && Vl(w, { select: !0 })) : m.shiftKey && v === w && (m.preventDefault(), n && Vl(b, { select: !0 })) : v === k && m.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ T.jsx(Ct.div, { tabIndex: -1, ...o, ref: f, onKeyDown: p });
});
jd.displayName = O0t;
function B0t(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (Vl(r, { select: e }), document.activeElement !== n) return;
}
function H0t(t) {
  const e = bq(t), n = sN(e, t), r = sN(e.reverse(), t);
  return [n, r];
}
function bq(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function sN(t, e) {
  for (const n of t)
    if (!F0t(n, { upTo: e })) return n;
}
function F0t(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden") return !0;
  for (; t; ) {
    if (e !== void 0 && t === e) return !1;
    if (getComputedStyle(t).display === "none") return !0;
    t = t.parentElement;
  }
  return !1;
}
function _0t(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Vl(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== n && _0t(t) && e && t.select();
  }
}
var lN = V0t();
function V0t() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = cN(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = cN(t, e), (n = t[0]) == null || n.resume();
    }
  };
}
function cN(t, e) {
  const n = [...t], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function q0t(t) {
  return t.filter((e) => e.tagName !== "A");
}
var M8 = 0;
function EM() {
  N.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? uN()), document.body.insertAdjacentElement("beforeend", t[1] ?? uN()), M8++, () => {
      M8 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), M8--;
    };
  }, []);
}
function uN() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", t;
}
var Wr = function() {
  return Wr = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      e = arguments[n];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, Wr.apply(this, arguments);
};
function jM(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function wq(t, e, n) {
  for (var r = 0, i = e.length, a; r < i; r++)
    (a || !(r in e)) && (a || (a = Array.prototype.slice.call(e, 0, r)), a[r] = e[r]);
  return t.concat(a || Array.prototype.slice.call(e));
}
var eh = "right-scroll-bar-position", th = "width-before-scroll-bar", U0t = "with-scroll-bars-hidden", W0t = "--removed-body-scroll-bar-size";
function C8(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function Z0t(t, e) {
  var n = De(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
var G0t = typeof window < "u" ? N.useLayoutEffect : N.useEffect, dN = /* @__PURE__ */ new WeakMap();
function kq(t, e) {
  var n = Z0t(null, function(r) {
    return t.forEach(function(i) {
      return C8(i, r);
    });
  });
  return G0t(function() {
    var r = dN.get(n);
    if (r) {
      var i = new Set(r), a = new Set(t), o = n.current;
      i.forEach(function(s) {
        a.has(s) || C8(s, null);
      }), a.forEach(function(s) {
        i.has(s) || C8(s, o);
      });
    }
    dN.set(n, t);
  }, [t]), n;
}
function Y0t(t) {
  return t;
}
function K0t(t, e) {
  e === void 0 && (e = Y0t);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(a) {
      var o = e(a, r);
      return n.push(o), function() {
        n = n.filter(function(s) {
          return s !== o;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var o = n;
        n = [], o.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var o = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), o = n;
      }
      var l = function() {
        var u = o;
        o = [], u.forEach(a);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          o.push(u), c();
        },
        filter: function(u) {
          return o = o.filter(u), n;
        }
      };
    }
  };
  return i;
}
function xq(t) {
  t === void 0 && (t = {});
  var e = K0t(null);
  return e.options = Wr({ async: !0, ssr: !1 }, t), e;
}
var Mq = function(t) {
  var e = t.sideCar, n = jM(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = e.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return N.createElement(r, Wr({}, n));
};
Mq.isSideCarExport = !0;
function Cq(t, e) {
  return t.useMedium(e), Mq;
}
var Aq = xq(), A8 = function() {
}, Xg = N.forwardRef(function(t, e) {
  var n = N.useRef(null), r = N.useState({
    onScrollCapture: A8,
    onWheelCapture: A8,
    onTouchMoveCapture: A8
  }), i = r[0], a = r[1], o = t.forwardProps, s = t.children, l = t.className, c = t.removeScrollBar, u = t.enabled, d = t.shards, f = t.sideCar, h = t.noIsolation, p = t.inert, m = t.allowPinchZoom, g = t.as, v = g === void 0 ? "div" : g, k = t.gapMode, w = jM(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), b = f, x = kq([n, e]), A = Wr(Wr({}, w), i);
  return N.createElement(
    N.Fragment,
    null,
    u && N.createElement(b, { sideCar: Aq, removeScrollBar: c, shards: d, noIsolation: h, inert: p, setCallbacks: a, allowPinchZoom: !!m, lockRef: n, gapMode: k }),
    o ? N.cloneElement(N.Children.only(s), Wr(Wr({}, A), { ref: x })) : N.createElement(v, Wr({}, A, { className: l, ref: x }), s)
  );
});
Xg.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Xg.classNames = {
  fullWidth: th,
  zeroRight: eh
};
var $0t = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function J0t() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = $0t();
  return e && t.setAttribute("nonce", e), t;
}
function Q0t(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function X0t(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var e1t = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = J0t()) && (Q0t(e, n), X0t(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, t1t = function() {
  var t = e1t();
  return function(e, n) {
    N.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, NM = function() {
  var t = t1t(), e = function(n) {
    var r = n.styles, i = n.dynamic;
    return t(r, i), null;
  };
  return e;
}, n1t = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, S8 = function(t) {
  return parseInt(t || "", 10) || 0;
}, r1t = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], r = e[t === "padding" ? "paddingTop" : "marginTop"], i = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [S8(n), S8(r), S8(i)];
}, i1t = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return n1t;
  var e = r1t(t), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, r - n + e[2] - e[0])
  };
}, a1t = NM(), o1t = function(t, e, n, r) {
  var i = t.left, a = t.top, o = t.right, s = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(U0t, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(eh, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(th, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(eh, " .").concat(eh, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(th, " .").concat(th, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(W0t, ": ").concat(s, `px;
  }
`);
}, Sq = function(t) {
  var e = t.noRelative, n = t.noImportant, r = t.gapMode, i = r === void 0 ? "margin" : r, a = N.useMemo(function() {
    return i1t(i);
  }, [i]);
  return N.createElement(a1t, { styles: o1t(a, !e, i, n ? "" : "!important") });
}, a9 = !1;
if (typeof window < "u")
  try {
    var Am = Object.defineProperty({}, "passive", {
      get: function() {
        return a9 = !0, !0;
      }
    });
    window.addEventListener("test", Am, Am), window.removeEventListener("test", Am, Am);
  } catch {
    a9 = !1;
  }
var z0 = a9 ? { passive: !1 } : !1, s1t = function(t) {
  return t.tagName === "TEXTAREA";
}, Lq = function(t, e) {
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !s1t(t) && n[e] === "visible")
  );
}, l1t = function(t) {
  return Lq(t, "overflowY");
}, c1t = function(t) {
  return Lq(t, "overflowX");
}, fN = function(t, e) {
  var n = e.ownerDocument, r = e;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = Tq(t, r);
    if (i) {
      var a = Eq(t, r), o = a[1], s = a[2];
      if (o > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, u1t = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, r = t.clientHeight;
  return [
    e,
    n,
    r
  ];
}, d1t = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, r = t.clientWidth;
  return [
    e,
    n,
    r
  ];
}, Tq = function(t, e) {
  return t === "v" ? l1t(e) : c1t(e);
}, Eq = function(t, e) {
  return t === "v" ? u1t(e) : d1t(e);
}, f1t = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, h1t = function(t, e, n, r, i) {
  var a = f1t(t, window.getComputedStyle(e).direction), o = a * r, s = n.target, l = e.contains(s), c = !1, u = o > 0, d = 0, f = 0;
  do {
    var h = Eq(t, s), p = h[0], m = h[1], g = h[2], v = m - g - a * p;
    (p || v) && Tq(t, s) && (d += v, f += p), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (e.contains(s) || e === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(f) < 1) && (c = !0), c;
}, Sm = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, hN = function(t) {
  return [t.deltaX, t.deltaY];
}, pN = function(t) {
  return t && "current" in t ? t.current : t;
}, p1t = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, m1t = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, y1t = 0, R0 = [];
function g1t(t) {
  var e = N.useRef([]), n = N.useRef([0, 0]), r = N.useRef(), i = N.useState(y1t++)[0], a = N.useState(NM)[0], o = N.useRef(t);
  N.useEffect(function() {
    o.current = t;
  }, [t]), N.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var m = wq([t.lockRef.current], (t.shards || []).map(pN)).filter(Boolean);
      return m.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), m.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var s = N.useCallback(function(m, g) {
    if ("touches" in m && m.touches.length === 2)
      return !o.current.allowPinchZoom;
    var v = Sm(m), k = n.current, w = "deltaX" in m ? m.deltaX : k[0] - v[0], b = "deltaY" in m ? m.deltaY : k[1] - v[1], x, A = m.target, L = Math.abs(w) > Math.abs(b) ? "h" : "v";
    if ("touches" in m && L === "h" && A.type === "range")
      return !1;
    var M = fN(L, A);
    if (!M)
      return !0;
    if (M ? x = L : (x = L === "v" ? "h" : "v", M = fN(L, A)), !M)
      return !1;
    if (!r.current && "changedTouches" in m && (w || b) && (r.current = x), !x)
      return !0;
    var j = r.current || x;
    return h1t(j, g, m, j === "h" ? w : b);
  }, []), l = N.useCallback(function(m) {
    var g = m;
    if (!(!R0.length || R0[R0.length - 1] !== a)) {
      var v = "deltaY" in g ? hN(g) : Sm(g), k = e.current.filter(function(x) {
        return x.name === g.type && (x.target === g.target || g.target === x.shadowParent) && p1t(x.delta, v);
      })[0];
      if (k && k.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!k) {
        var w = (o.current.shards || []).map(pN).filter(Boolean).filter(function(x) {
          return x.contains(g.target);
        }), b = w.length > 0 ? s(g, w[0]) : !o.current.noIsolation;
        b && g.cancelable && g.preventDefault();
      }
    }
  }, []), c = N.useCallback(function(m, g, v, k) {
    var w = { name: m, delta: g, target: v, should: k, shadowParent: v1t(v) };
    e.current.push(w), setTimeout(function() {
      e.current = e.current.filter(function(b) {
        return b !== w;
      });
    }, 1);
  }, []), u = N.useCallback(function(m) {
    n.current = Sm(m), r.current = void 0;
  }, []), d = N.useCallback(function(m) {
    c(m.type, hN(m), m.target, s(m, t.lockRef.current));
  }, []), f = N.useCallback(function(m) {
    c(m.type, Sm(m), m.target, s(m, t.lockRef.current));
  }, []);
  N.useEffect(function() {
    return R0.push(a), t.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, z0), document.addEventListener("touchmove", l, z0), document.addEventListener("touchstart", u, z0), function() {
      R0 = R0.filter(function(m) {
        return m !== a;
      }), document.removeEventListener("wheel", l, z0), document.removeEventListener("touchmove", l, z0), document.removeEventListener("touchstart", u, z0);
    };
  }, []);
  var h = t.removeScrollBar, p = t.inert;
  return N.createElement(
    N.Fragment,
    null,
    p ? N.createElement(a, { styles: m1t(i) }) : null,
    h ? N.createElement(Sq, { gapMode: t.gapMode }) : null
  );
}
function v1t(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const b1t = Cq(Aq, g1t);
var e6 = N.forwardRef(function(t, e) {
  return N.createElement(Xg, Wr({}, t, { ref: e, sideCar: b1t }));
});
e6.classNames = Xg.classNames;
var w1t = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, O0 = /* @__PURE__ */ new WeakMap(), Lm = /* @__PURE__ */ new WeakMap(), Tm = {}, L8 = 0, jq = function(t) {
  return t && (t.host || jq(t.parentNode));
}, k1t = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var r = jq(n);
    return r && t.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, x1t = function(t, e, n, r) {
  var i = k1t(e, Array.isArray(t) ? t : [t]);
  Tm[n] || (Tm[n] = /* @__PURE__ */ new WeakMap());
  var a = Tm[n], o = [], s = /* @__PURE__ */ new Set(), l = new Set(i), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  i.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (s.has(f))
        u(f);
      else
        try {
          var h = f.getAttribute(r), p = h !== null && h !== "false", m = (O0.get(f) || 0) + 1, g = (a.get(f) || 0) + 1;
          O0.set(f, m), a.set(f, g), o.push(f), m === 1 && p && Lm.set(f, !0), g === 1 && f.setAttribute(n, "true"), p || f.setAttribute(r, "true");
        } catch (v) {
          console.error("aria-hidden: cannot operate on ", f, v);
        }
    });
  };
  return u(e), s.clear(), L8++, function() {
    o.forEach(function(d) {
      var f = O0.get(d) - 1, h = a.get(d) - 1;
      O0.set(d, f), a.set(d, h), f || (Lm.has(d) || d.removeAttribute(r), Lm.delete(d)), h || d.removeAttribute(n);
    }), L8--, L8 || (O0 = /* @__PURE__ */ new WeakMap(), O0 = /* @__PURE__ */ new WeakMap(), Lm = /* @__PURE__ */ new WeakMap(), Tm = {});
  };
}, t6 = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(t) ? t : [t]), i = w1t(t);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), x1t(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, DM = "Dialog", [Nq, cGt] = ei(DM), [M1t, yo] = Nq(DM), Dq = (t) => {
  const {
    __scopeDialog: e,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    modal: o = !0
  } = t, s = N.useRef(null), l = N.useRef(null), [c = !1, u] = mo({
    prop: r,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ T.jsx(
    M1t,
    {
      scope: e,
      triggerRef: s,
      contentRef: l,
      contentId: Xa(),
      titleId: Xa(),
      descriptionId: Xa(),
      open: c,
      onOpenChange: u,
      onOpenToggle: N.useCallback(() => u((d) => !d), [u]),
      modal: o,
      children: n
    }
  );
};
Dq.displayName = DM;
var Iq = "DialogTrigger", Pq = N.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = yo(Iq, n), a = Jt(e, i.triggerRef);
    return /* @__PURE__ */ T.jsx(
      Ct.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": zM(i.open),
        ...r,
        ref: a,
        onClick: it(t.onClick, i.onOpenToggle)
      }
    );
  }
);
Pq.displayName = Iq;
var IM = "DialogPortal", [C1t, zq] = Nq(IM, {
  forceMount: void 0
}), Rq = (t) => {
  const { __scopeDialog: e, forceMount: n, children: r, container: i } = t, a = yo(IM, e);
  return /* @__PURE__ */ T.jsx(C1t, { scope: e, forceMount: n, children: N.Children.map(r, (o) => /* @__PURE__ */ T.jsx(zi, { present: n || a.open, children: /* @__PURE__ */ T.jsx(Ld, { asChild: !0, container: i, children: o }) })) });
};
Rq.displayName = IM;
var By = "DialogOverlay", Oq = N.forwardRef(
  (t, e) => {
    const n = zq(By, t.__scopeDialog), { forceMount: r = n.forceMount, ...i } = t, a = yo(By, t.__scopeDialog);
    return a.modal ? /* @__PURE__ */ T.jsx(zi, { present: r || a.open, children: /* @__PURE__ */ T.jsx(A1t, { ...i, ref: e }) }) : null;
  }
);
Oq.displayName = By;
var A1t = N.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = yo(By, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ T.jsx(e6, { as: ns, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ T.jsx(
        Ct.div,
        {
          "data-state": zM(i.open),
          ...r,
          ref: e,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Qu = "DialogContent", Bq = N.forwardRef(
  (t, e) => {
    const n = zq(Qu, t.__scopeDialog), { forceMount: r = n.forceMount, ...i } = t, a = yo(Qu, t.__scopeDialog);
    return /* @__PURE__ */ T.jsx(zi, { present: r || a.open, children: a.modal ? /* @__PURE__ */ T.jsx(S1t, { ...i, ref: e }) : /* @__PURE__ */ T.jsx(L1t, { ...i, ref: e }) });
  }
);
Bq.displayName = Qu;
var S1t = N.forwardRef(
  (t, e) => {
    const n = yo(Qu, t.__scopeDialog), r = N.useRef(null), i = Jt(e, n.contentRef, r);
    return N.useEffect(() => {
      const a = r.current;
      if (a) return t6(a);
    }, []), /* @__PURE__ */ T.jsx(
      Hq,
      {
        ...t,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: it(t.onCloseAutoFocus, (a) => {
          var o;
          a.preventDefault(), (o = n.triggerRef.current) == null || o.focus();
        }),
        onPointerDownOutside: it(t.onPointerDownOutside, (a) => {
          const o = a.detail.originalEvent, s = o.button === 0 && o.ctrlKey === !0;
          (o.button === 2 || s) && a.preventDefault();
        }),
        onFocusOutside: it(
          t.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), L1t = N.forwardRef(
  (t, e) => {
    const n = yo(Qu, t.__scopeDialog), r = N.useRef(!1), i = N.useRef(!1);
    return /* @__PURE__ */ T.jsx(
      Hq,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var o, s;
          (o = t.onCloseAutoFocus) == null || o.call(t, a), a.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), a.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (a) => {
          var o, s;
          (o = t.onInteractOutside) == null || o.call(t, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const l = a.target;
          (s = n.triggerRef.current) != null && s.contains(l) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && i.current && a.preventDefault();
        }
      }
    );
  }
), Hq = N.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...o } = t, s = yo(Qu, n), l = N.useRef(null), c = Jt(e, l);
    return EM(), /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
      /* @__PURE__ */ T.jsx(
        jd,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ T.jsx(
            Fc,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": zM(s.open),
              ...o,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
        /* @__PURE__ */ T.jsx(T1t, { titleId: s.titleId }),
        /* @__PURE__ */ T.jsx(j1t, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), PM = "DialogTitle", Fq = N.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = yo(PM, n);
    return /* @__PURE__ */ T.jsx(Ct.h2, { id: i.titleId, ...r, ref: e });
  }
);
Fq.displayName = PM;
var _q = "DialogDescription", Vq = N.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = yo(_q, n);
    return /* @__PURE__ */ T.jsx(Ct.p, { id: i.descriptionId, ...r, ref: e });
  }
);
Vq.displayName = _q;
var qq = "DialogClose", Uq = N.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = yo(qq, n);
    return /* @__PURE__ */ T.jsx(
      Ct.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: it(t.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
Uq.displayName = qq;
function zM(t) {
  return t ? "open" : "closed";
}
var Wq = "DialogTitleWarning", [uGt, Zq] = Pit(Wq, {
  contentName: Qu,
  titleName: PM,
  docsSlug: "dialog"
}), T1t = ({ titleId: t }) => {
  const e = Zq(Wq), n = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return N.useEffect(() => {
    t && (document.getElementById(t) || console.error(n));
  }, [n, t]), null;
}, E1t = "DialogDescriptionWarning", j1t = ({ contentRef: t, descriptionId: e }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Zq(E1t).contentName}}.`;
  return N.useEffect(() => {
    var r;
    const i = (r = t.current) == null ? void 0 : r.getAttribute("aria-describedby");
    e && i && (document.getElementById(e) || console.warn(n));
  }, [n, t, e]), null;
}, RM = Dq, N1t = Pq, OM = Rq, mp = Oq, yp = Bq, gp = Fq, vp = Vq, n6 = Uq;
const Gq = { asChild: { type: "boolean" } }, D1t = { width: { type: "string", className: "rt-r-w", customProperties: ["--width"], responsive: !0 }, minWidth: { type: "string", className: "rt-r-min-w", customProperties: ["--min-width"], responsive: !0 }, maxWidth: { type: "string", className: "rt-r-max-w", customProperties: ["--max-width"], responsive: !0 } }, I1t = { height: { type: "string", className: "rt-r-h", customProperties: ["--height"], responsive: !0 }, minHeight: { type: "string", className: "rt-r-min-h", customProperties: ["--min-height"], responsive: !0 }, maxHeight: { type: "string", className: "rt-r-max-h", customProperties: ["--max-height"], responsive: !0 } }, BM = ["initial", "xs", "sm", "md", "lg", "xl"];
function Yq(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function nh(t) {
  return typeof t == "object" && Object.keys(t).some((e) => BM.includes(e));
}
function P1t({ className: t, customProperties: e, ...n }) {
  const r = Kq({ allowArbitraryValues: !0, className: t, ...n }), i = z1t({ customProperties: e, ...n });
  return [r, i];
}
function Kq({ allowArbitraryValues: t, value: e, className: n, propValues: r, parseValue: i = (a) => a }) {
  const a = [];
  if (e) {
    if (typeof e == "string" && r.includes(e)) return mN(n, e, i);
    if (nh(e)) {
      const o = e;
      for (const s in o) {
        if (!Yq(o, s) || !BM.includes(s)) continue;
        const l = o[s];
        if (l !== void 0) {
          if (r.includes(l)) {
            const c = mN(n, l, i), u = s === "initial" ? c : `${s}:${c}`;
            a.push(u);
          } else if (t) {
            const c = s === "initial" ? n : `${s}:${n}`;
            a.push(c);
          }
        }
      }
      return a.join(" ");
    }
    if (t) return n;
  }
}
function mN(t, e, n) {
  const r = t ? "-" : "", i = n(e), a = i == null ? void 0 : i.startsWith("-"), o = a ? "-" : "", s = a ? i == null ? void 0 : i.substring(1) : i;
  return `${o}${t}${r}${s}`;
}
function z1t({ customProperties: t, value: e, propValues: n, parseValue: r = (i) => i }) {
  let i = {};
  if (!(!e || typeof e == "string" && n.includes(e))) {
    if (typeof e == "string" && (i = Object.fromEntries(t.map((a) => [a, e]))), nh(e)) {
      const a = e;
      for (const o in a) {
        if (!Yq(a, o) || !BM.includes(o)) continue;
        const s = a[o];
        if (!n.includes(s)) for (const l of t) i = { [o === "initial" ? l : `${l}-${o}`]: s, ...i };
      }
    }
    for (const a in i) {
      const o = i[a];
      o !== void 0 && (i[a] = r(o));
    }
    return i;
  }
}
function yN(...t) {
  let e = {};
  for (const n of t) n && (e = { ...e, ...n });
  return Object.keys(e).length ? e : void 0;
}
function R1t(...t) {
  return Object.assign({}, ...t);
}
function $q(t, ...e) {
  let n, r;
  const i = { ...t }, a = R1t(...e);
  for (const o in a) {
    let s = i[o];
    const l = a[o];
    if (l.default !== void 0 && s === void 0 && (s = l.default), l.type === "enum" && ![l.default, ...l.values].includes(s) && !nh(s) && (s = l.default), i[o] = s, "className" in l && l.className) {
      delete i[o];
      const c = "responsive" in l;
      if (!s || nh(s) && !c) continue;
      if (nh(s) && (l.default !== void 0 && s.initial === void 0 && (s.initial = l.default), l.type === "enum" && ([l.default, ...l.values].includes(s.initial) || (s.initial = l.default))), l.type === "enum") {
        const u = Kq({ allowArbitraryValues: !1, value: s, className: l.className, propValues: l.values, parseValue: l.parseValue });
        n = Au(n, u);
        continue;
      }
      if (l.type === "string" || l.type === "enum | string") {
        const u = l.type === "string" ? [] : l.values, [d, f] = P1t({ className: l.className, customProperties: l.customProperties, propValues: u, parseValue: l.parseValue, value: s });
        r = yN(r, f), n = Au(n, d);
        continue;
      }
      if (l.type === "boolean" && s) {
        n = Au(n, l.className);
        continue;
      }
    }
  }
  return i.className = Au(n, t.className), i.style = yN(r, t.style), i;
}
const eu = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "-1", "-2", "-3", "-4", "-5", "-6", "-7", "-8", "-9"], Jq = { m: { type: "enum | string", values: eu, responsive: !0, className: "rt-r-m", customProperties: ["--m"] }, mx: { type: "enum | string", values: eu, responsive: !0, className: "rt-r-mx", customProperties: ["--ml", "--mr"] }, my: { type: "enum | string", values: eu, responsive: !0, className: "rt-r-my", customProperties: ["--mt", "--mb"] }, mt: { type: "enum | string", values: eu, responsive: !0, className: "rt-r-mt", customProperties: ["--mt"] }, mr: { type: "enum | string", values: eu, responsive: !0, className: "rt-r-mr", customProperties: ["--mr"] }, mb: { type: "enum | string", values: eu, responsive: !0, className: "rt-r-mb", customProperties: ["--mb"] }, ml: { type: "enum | string", values: eu, responsive: !0, className: "rt-r-ml", customProperties: ["--ml"] } };
var [r6, dGt] = ei("Tooltip", [
  fs
]), HM = fs(), Qq = "TooltipProvider", O1t = 700, gN = "tooltip.open", [B1t, Xq] = r6(Qq), eU = (t) => {
  const {
    __scopeTooltip: e,
    delayDuration: n = O1t,
    skipDelayDuration: r = 300,
    disableHoverableContent: i = !1,
    children: a
  } = t, [o, s] = N.useState(!0), l = N.useRef(!1), c = N.useRef(0);
  return N.useEffect(() => {
    const u = c.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ T.jsx(
    B1t,
    {
      scope: e,
      isOpenDelayed: o,
      delayDuration: n,
      onOpen: N.useCallback(() => {
        window.clearTimeout(c.current), s(!1);
      }, []),
      onClose: N.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => s(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: l,
      onPointerInTransitChange: N.useCallback((u) => {
        l.current = u;
      }, []),
      disableHoverableContent: i,
      children: a
    }
  );
};
eU.displayName = Qq;
var tU = "Tooltip", [fGt, i6] = r6(tU), o9 = "TooltipTrigger", H1t = N.forwardRef(
  (t, e) => {
    const { __scopeTooltip: n, ...r } = t, i = i6(o9, n), a = Xq(o9, n), o = HM(n), s = N.useRef(null), l = Jt(e, s, i.onTriggerChange), c = N.useRef(!1), u = N.useRef(!1), d = N.useCallback(() => c.current = !1, []);
    return N.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ T.jsx(Sd, { asChild: !0, ...o, children: /* @__PURE__ */ T.jsx(
      Ct.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: it(t.onPointerMove, (f) => {
          f.pointerType !== "touch" && !u.current && !a.isPointerInTransitRef.current && (i.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: it(t.onPointerLeave, () => {
          i.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: it(t.onPointerDown, () => {
          c.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: it(t.onFocus, () => {
          c.current || i.onOpen();
        }),
        onBlur: it(t.onBlur, i.onClose),
        onClick: it(t.onClick, i.onClose)
      }
    ) });
  }
);
H1t.displayName = o9;
var F1t = "TooltipPortal", [hGt, _1t] = r6(F1t, {
  forceMount: void 0
}), Z1 = "TooltipContent", V1t = N.forwardRef(
  (t, e) => {
    const n = _1t(Z1, t.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...a } = t, o = i6(Z1, t.__scopeTooltip);
    return /* @__PURE__ */ T.jsx(zi, { present: r || o.open, children: o.disableHoverableContent ? /* @__PURE__ */ T.jsx(nU, { side: i, ...a, ref: e }) : /* @__PURE__ */ T.jsx(q1t, { side: i, ...a, ref: e }) });
  }
), q1t = N.forwardRef((t, e) => {
  const n = i6(Z1, t.__scopeTooltip), r = Xq(Z1, t.__scopeTooltip), i = N.useRef(null), a = Jt(e, i), [o, s] = N.useState(null), { trigger: l, onClose: c } = n, u = i.current, { onPointerInTransitChange: d } = r, f = N.useCallback(() => {
    s(null), d(!1);
  }, [d]), h = N.useCallback(
    (p, m) => {
      const g = p.currentTarget, v = { x: p.clientX, y: p.clientY }, k = G1t(v, g.getBoundingClientRect()), w = Y1t(v, k), b = K1t(m.getBoundingClientRect()), x = J1t([...w, ...b]);
      s(x), d(!0);
    },
    [d]
  );
  return N.useEffect(() => () => f(), [f]), N.useEffect(() => {
    if (l && u) {
      const p = (g) => h(g, u), m = (g) => h(g, l);
      return l.addEventListener("pointerleave", p), u.addEventListener("pointerleave", m), () => {
        l.removeEventListener("pointerleave", p), u.removeEventListener("pointerleave", m);
      };
    }
  }, [l, u, h, f]), N.useEffect(() => {
    if (o) {
      const p = (m) => {
        const g = m.target, v = { x: m.clientX, y: m.clientY }, k = (l == null ? void 0 : l.contains(g)) || (u == null ? void 0 : u.contains(g)), w = !$1t(v, o);
        k ? f() : w && (f(), c());
      };
      return document.addEventListener("pointermove", p), () => document.removeEventListener("pointermove", p);
    }
  }, [l, u, o, c, f]), /* @__PURE__ */ T.jsx(nU, { ...t, ref: a });
}), [U1t, W1t] = r6(tU, { isInside: !1 }), nU = N.forwardRef(
  (t, e) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": i,
      onEscapeKeyDown: a,
      onPointerDownOutside: o,
      ...s
    } = t, l = i6(Z1, n), c = HM(n), { onClose: u } = l;
    return N.useEffect(() => (document.addEventListener(gN, u), () => document.removeEventListener(gN, u)), [u]), N.useEffect(() => {
      if (l.trigger) {
        const d = (f) => {
          const h = f.target;
          h != null && h.contains(l.trigger) && u();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [l.trigger, u]), /* @__PURE__ */ T.jsx(
      Fc,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: o,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ T.jsxs(
          sp,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...s,
            ref: e,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ T.jsx(Hx, { children: r }),
              /* @__PURE__ */ T.jsx(U1t, { scope: n, isInside: !0, children: /* @__PURE__ */ T.jsx(d_, { id: l.contentId, role: "tooltip", children: i || r }) })
            ]
          }
        )
      }
    );
  }
);
V1t.displayName = Z1;
var rU = "TooltipArrow", Z1t = N.forwardRef(
  (t, e) => {
    const { __scopeTooltip: n, ...r } = t, i = HM(n);
    return W1t(
      rU,
      n
    ).isInside ? null : /* @__PURE__ */ T.jsx(lp, { ...i, ...r, ref: e });
  }
);
Z1t.displayName = rU;
function G1t(t, e) {
  const n = Math.abs(e.top - t.y), r = Math.abs(e.bottom - t.y), i = Math.abs(e.right - t.x), a = Math.abs(e.left - t.x);
  switch (Math.min(n, r, i, a)) {
    case a:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Y1t(t, e, n = 5) {
  const r = [];
  switch (e) {
    case "top":
      r.push(
        { x: t.x - n, y: t.y + n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x + n, y: t.y - n }
      );
      break;
    case "left":
      r.push(
        { x: t.x + n, y: t.y - n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "right":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x - n, y: t.y + n }
      );
      break;
  }
  return r;
}
function K1t(t) {
  const { top: e, right: n, bottom: r, left: i } = t;
  return [
    { x: i, y: e },
    { x: n, y: e },
    { x: n, y: r },
    { x: i, y: r }
  ];
}
function $1t(t, e) {
  const { x: n, y: r } = t;
  let i = !1;
  for (let a = 0, o = e.length - 1; a < e.length; o = a++) {
    const s = e[a].x, l = e[a].y, c = e[o].x, u = e[o].y;
    l > r != u > r && n < (c - s) * (r - l) / (u - l) + s && (i = !i);
  }
  return i;
}
function J1t(t) {
  const e = t.slice();
  return e.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), Q1t(e);
}
function Q1t(t) {
  if (t.length <= 1) return t.slice();
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    for (; e.length >= 2; ) {
      const a = e[e.length - 1], o = e[e.length - 2];
      if ((a.x - o.x) * (i.y - o.y) >= (a.y - o.y) * (i.x - o.x)) e.pop();
      else break;
    }
    e.push(i);
  }
  e.pop();
  const n = [];
  for (let r = t.length - 1; r >= 0; r--) {
    const i = t[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], o = n[n.length - 2];
      if ((a.x - o.x) * (i.y - o.y) >= (a.y - o.y) * (i.x - o.x)) n.pop();
      else break;
    }
    n.push(i);
  }
  return n.pop(), e.length === 1 && n.length === 1 && e[0].x === n[0].x && e[0].y === n[0].y ? e : e.concat(n);
}
var X1t = eU;
function edt(t) {
  switch (t) {
    case "tomato":
    case "red":
    case "ruby":
    case "crimson":
    case "pink":
    case "plum":
    case "purple":
    case "violet":
      return "mauve";
    case "iris":
    case "indigo":
    case "blue":
    case "sky":
    case "cyan":
      return "slate";
    case "teal":
    case "jade":
    case "mint":
    case "green":
      return "sage";
    case "grass":
    case "lime":
      return "olive";
    case "yellow":
    case "amber":
    case "orange":
    case "brown":
    case "gold":
    case "bronze":
      return "sand";
    case "gray":
      return "gray";
  }
}
const qi = { hasBackground: { default: !0 }, appearance: { default: "inherit" }, accentColor: { default: "indigo" }, grayColor: { default: "auto" }, panelBackground: { default: "translucent" }, radius: { default: "medium" }, scaling: { default: "100%" } }, B0 = () => {
}, s9 = N.createContext(void 0), tdt = N.forwardRef((t, e) => N.useContext(s9) === void 0 ? N.createElement(X1t, { delayDuration: 200 }, N.createElement(m0t, { dir: "ltr" }, N.createElement(iU, { ...t, ref: e }))) : N.createElement(FM, { ...t, ref: e }));
tdt.displayName = "Theme";
const iU = N.forwardRef((t, e) => {
  const { appearance: n = qi.appearance.default, accentColor: r = qi.accentColor.default, grayColor: i = qi.grayColor.default, panelBackground: a = qi.panelBackground.default, radius: o = qi.radius.default, scaling: s = qi.scaling.default, hasBackground: l = qi.hasBackground.default, ...c } = t, [u, d] = N.useState(n);
  N.useEffect(() => d(n), [n]);
  const [f, h] = N.useState(r);
  N.useEffect(() => h(r), [r]);
  const [p, m] = N.useState(i);
  N.useEffect(() => m(i), [i]);
  const [g, v] = N.useState(a);
  N.useEffect(() => v(a), [a]);
  const [k, w] = N.useState(o);
  N.useEffect(() => w(o), [o]);
  const [b, x] = N.useState(s);
  return N.useEffect(() => x(s), [s]), N.createElement(FM, { ...c, ref: e, isRoot: !0, hasBackground: l, appearance: u, accentColor: f, grayColor: p, panelBackground: g, radius: k, scaling: b, onAppearanceChange: d, onAccentColorChange: h, onGrayColorChange: m, onPanelBackgroundChange: v, onRadiusChange: w, onScalingChange: x });
});
iU.displayName = "ThemeRoot";
const FM = N.forwardRef((t, e) => {
  const n = N.useContext(s9), { asChild: r, isRoot: i, hasBackground: a, appearance: o = (n == null ? void 0 : n.appearance) ?? qi.appearance.default, accentColor: s = (n == null ? void 0 : n.accentColor) ?? qi.accentColor.default, grayColor: l = (n == null ? void 0 : n.resolvedGrayColor) ?? qi.grayColor.default, panelBackground: c = (n == null ? void 0 : n.panelBackground) ?? qi.panelBackground.default, radius: u = (n == null ? void 0 : n.radius) ?? qi.radius.default, scaling: d = (n == null ? void 0 : n.scaling) ?? qi.scaling.default, onAppearanceChange: f = B0, onAccentColorChange: h = B0, onGrayColorChange: p = B0, onPanelBackgroundChange: m = B0, onRadiusChange: g = B0, onScalingChange: v = B0, ...k } = t, w = r ? ns : "div", b = l === "auto" ? edt(s) : l, x = t.appearance === "light" || t.appearance === "dark", A = a === void 0 ? i || x : a;
  return N.createElement(s9.Provider, { value: N.useMemo(() => ({ appearance: o, accentColor: s, grayColor: l, resolvedGrayColor: b, panelBackground: c, radius: u, scaling: d, onAppearanceChange: f, onAccentColorChange: h, onGrayColorChange: p, onPanelBackgroundChange: m, onRadiusChange: g, onScalingChange: v }), [o, s, l, b, c, u, d, f, h, p, m, g, v]) }, N.createElement(w, { "data-is-root-theme": i ? "true" : "false", "data-accent-color": s, "data-gray-color": b, "data-has-background": A ? "true" : "false", "data-panel-background": c, "data-radius": u, "data-scaling": d, ref: e, ...k, className: Au("radix-themes", { light: o === "light", dark: o === "dark" }, k.className) }));
});
FM.displayName = "ThemeImpl";
const ndt = ["div", "span"], rdt = ["none", "inline", "inline-block", "block"], idt = { as: { type: "enum", values: ndt, default: "div" }, ...Gq, display: { type: "enum", className: "rt-r-display", values: rdt, responsive: !0 } }, tu = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], adt = { p: { type: "enum | string", className: "rt-r-p", customProperties: ["--p"], values: tu, responsive: !0 }, px: { type: "enum | string", className: "rt-r-px", customProperties: ["--pl", "--pr"], values: tu, responsive: !0 }, py: { type: "enum | string", className: "rt-r-py", customProperties: ["--pt", "--pb"], values: tu, responsive: !0 }, pt: { type: "enum | string", className: "rt-r-pt", customProperties: ["--pt"], values: tu, responsive: !0 }, pr: { type: "enum | string", className: "rt-r-pr", customProperties: ["--pr"], values: tu, responsive: !0 }, pb: { type: "enum | string", className: "rt-r-pb", customProperties: ["--pb"], values: tu, responsive: !0 }, pl: { type: "enum | string", className: "rt-r-pl", customProperties: ["--pl"], values: tu, responsive: !0 } }, T8 = ["visible", "hidden", "clip", "scroll", "auto"], odt = ["static", "relative", "absolute", "fixed", "sticky"], sf = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "-1", "-2", "-3", "-4", "-5", "-6", "-7", "-8", "-9"], sdt = ["0", "1"], ldt = ["0", "1"], aU = { ...adt, ...D1t, ...I1t, position: { type: "enum", className: "rt-r-position", values: odt, responsive: !0 }, inset: { type: "enum | string", className: "rt-r-inset", customProperties: ["--inset"], values: sf, responsive: !0 }, top: { type: "enum | string", className: "rt-r-top", customProperties: ["--top"], values: sf, responsive: !0 }, right: { type: "enum | string", className: "rt-r-right", customProperties: ["--right"], values: sf, responsive: !0 }, bottom: { type: "enum | string", className: "rt-r-bottom", customProperties: ["--bottom"], values: sf, responsive: !0 }, left: { type: "enum | string", className: "rt-r-left", customProperties: ["--left"], values: sf, responsive: !0 }, overflow: { type: "enum", className: "rt-r-overflow", values: T8, responsive: !0 }, overflowX: { type: "enum", className: "rt-r-ox", values: T8, responsive: !0 }, overflowY: { type: "enum", className: "rt-r-oy", values: T8, responsive: !0 }, flexBasis: { type: "string", className: "rt-r-fb", customProperties: ["--flex-basis"], responsive: !0 }, flexShrink: { type: "enum | string", className: "rt-r-fs", customProperties: ["--flex-shrink"], values: sdt, responsive: !0 }, flexGrow: { type: "enum | string", className: "rt-r-fg", customProperties: ["--flex-grow"], values: ldt, responsive: !0 }, gridColumn: { type: "string", className: "rt-r-gc", customProperties: ["--grid-column"], responsive: !0 }, gridColumnStart: { type: "string", className: "rt-r-gcs", customProperties: ["--grid-column-start"], responsive: !0 }, gridColumnEnd: { type: "string", className: "rt-r-gce", customProperties: ["--grid-column-end"], responsive: !0 }, gridRow: { type: "string", className: "rt-r-gr", customProperties: ["--grid-row"], responsive: !0 }, gridRowStart: { type: "string", className: "rt-r-grs", customProperties: ["--grid-row-start"], responsive: !0 }, gridRowEnd: { type: "string", className: "rt-r-gre", customProperties: ["--grid-row-end"], responsive: !0 } }, _M = N.forwardRef((t, e) => {
  const { className: n, asChild: r, as: i = "div", ...a } = $q(t, idt, aU, Jq);
  return N.createElement(r ? ns : i, { ...a, ref: e, className: Au("rt-Box", n) });
});
_M.displayName = "Box";
const E8 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], cdt = { gap: { type: "enum | string", className: "rt-r-gap", customProperties: ["--gap"], values: E8, responsive: !0 }, gapX: { type: "enum | string", className: "rt-r-cg", customProperties: ["--column-gap"], values: E8, responsive: !0 }, gapY: { type: "enum | string", className: "rt-r-rg", customProperties: ["--row-gap"], values: E8, responsive: !0 } }, udt = ["div", "span"], ddt = ["none", "inline-grid", "grid"], fdt = ["1", "2", "3", "4", "5", "6", "7", "8", "9"], hdt = ["1", "2", "3", "4", "5", "6", "7", "8", "9"], pdt = ["row", "column", "dense", "row-dense", "column-dense"], mdt = ["start", "center", "end", "baseline", "stretch"], ydt = ["start", "center", "end", "between"], oU = { as: { type: "enum", values: udt, default: "div" }, ...Gq, display: { type: "enum", className: "rt-r-display", values: ddt, responsive: !0 }, columns: { type: "enum | string", className: "rt-r-gtc", customProperties: ["--grid-template-columns"], values: fdt, parseValue: vN, responsive: !0 }, rows: { type: "enum | string", className: "rt-r-gtr", customProperties: ["--grid-template-rows"], values: hdt, parseValue: vN, responsive: !0 }, flow: { type: "enum", className: "rt-r-gaf", values: pdt, responsive: !0 }, align: { type: "enum", className: "rt-r-ai", values: mdt, responsive: !0 }, justify: { type: "enum", className: "rt-r-jc", values: ydt, parseValue: gdt, responsive: !0 }, ...cdt };
function vN(t) {
  return oU.columns.values.includes(t) ? t : t != null && t.match(/^\d+$/) ? `repeat(${t}, minmax(0, 1fr))` : t;
}
function gdt(t) {
  return t === "between" ? "space-between" : t;
}
const vdt = N.forwardRef((t, e) => {
  const { className: n, asChild: r, as: i = "div", ...a } = $q(t, oU, aU, Jq);
  return N.createElement(r ? ns : i, { ...a, ref: e, className: Au("rt-Grid", n) });
});
vdt.displayName = "Grid";
function bN(t, [e, n]) {
  return Math.min(n, Math.max(e, t));
}
var j8, sU = "HoverCard", [lU, pGt] = ei(sU, [
  fs
]), VM = fs(), [mGt, qM] = lU(sU), cU = "HoverCardTrigger", bdt = N.forwardRef(
  (t, e) => {
    const { __scopeHoverCard: n, ...r } = t, i = qM(cU, n), a = VM(n);
    return /* @__PURE__ */ T.jsx(Sd, { asChild: !0, ...a, children: /* @__PURE__ */ T.jsx(
      Ct.a,
      {
        "data-state": i.open ? "open" : "closed",
        ...r,
        ref: e,
        onPointerEnter: it(t.onPointerEnter, Fy(i.onOpen)),
        onPointerLeave: it(t.onPointerLeave, Fy(i.onClose)),
        onFocus: it(t.onFocus, i.onOpen),
        onBlur: it(t.onBlur, i.onClose),
        onTouchStart: it(t.onTouchStart, (o) => o.preventDefault())
      }
    ) });
  }
);
bdt.displayName = cU;
var wdt = "HoverCardPortal", [yGt, kdt] = lU(wdt, {
  forceMount: void 0
}), Hy = "HoverCardContent", uU = N.forwardRef(
  (t, e) => {
    const n = kdt(Hy, t.__scopeHoverCard), { forceMount: r = n.forceMount, ...i } = t, a = qM(Hy, t.__scopeHoverCard);
    return /* @__PURE__ */ T.jsx(zi, { present: r || a.open, children: /* @__PURE__ */ T.jsx(
      xdt,
      {
        "data-state": a.open ? "open" : "closed",
        ...i,
        onPointerEnter: it(t.onPointerEnter, Fy(a.onOpen)),
        onPointerLeave: it(t.onPointerLeave, Fy(a.onClose)),
        ref: e
      }
    ) });
  }
);
uU.displayName = Hy;
var xdt = N.forwardRef((t, e) => {
  const {
    __scopeHoverCard: n,
    onEscapeKeyDown: r,
    onPointerDownOutside: i,
    onFocusOutside: a,
    onInteractOutside: o,
    ...s
  } = t, l = qM(Hy, n), c = VM(n), u = N.useRef(null), d = Jt(e, u), [f, h] = N.useState(!1);
  return N.useEffect(() => {
    if (f) {
      const p = document.body;
      return j8 = p.style.userSelect || p.style.webkitUserSelect, p.style.userSelect = "none", p.style.webkitUserSelect = "none", () => {
        p.style.userSelect = j8, p.style.webkitUserSelect = j8;
      };
    }
  }, [f]), N.useEffect(() => {
    if (u.current) {
      const p = () => {
        h(!1), l.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var m;
          ((m = document.getSelection()) == null ? void 0 : m.toString()) !== "" && (l.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", p), () => {
        document.removeEventListener("pointerup", p), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [l.isPointerDownOnContentRef, l.hasSelectionRef]), N.useEffect(() => {
    u.current && Adt(u.current).forEach((p) => p.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ T.jsx(
    Fc,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: o,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: it(a, (p) => {
        p.preventDefault();
      }),
      onDismiss: l.onDismiss,
      children: /* @__PURE__ */ T.jsx(
        sp,
        {
          ...c,
          ...s,
          onPointerDown: it(s.onPointerDown, (p) => {
            p.currentTarget.contains(p.target) && h(!0), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !0;
          }),
          ref: d,
          style: {
            ...s.style,
            userSelect: f ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: f ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), Mdt = "HoverCardArrow", Cdt = N.forwardRef(
  (t, e) => {
    const { __scopeHoverCard: n, ...r } = t, i = VM(n);
    return /* @__PURE__ */ T.jsx(lp, { ...i, ...r, ref: e });
  }
);
Cdt.displayName = Mdt;
function Fy(t) {
  return (e) => e.pointerType === "touch" ? void 0 : t();
}
function Adt(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
var dU = uU, UM = "Popover", [fU, gGt] = ei(UM, [
  fs
]), bp = fs(), [Sdt, qc] = fU(UM), hU = (t) => {
  const {
    __scopePopover: e,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    modal: o = !1
  } = t, s = bp(e), l = N.useRef(null), [c, u] = N.useState(!1), [d = !1, f] = mo({
    prop: r,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ T.jsx(u_, { ...s, children: /* @__PURE__ */ T.jsx(
    Sdt,
    {
      scope: e,
      contentId: Xa(),
      triggerRef: l,
      open: d,
      onOpenChange: f,
      onOpenToggle: N.useCallback(() => f((h) => !h), [f]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: N.useCallback(() => u(!0), []),
      onCustomAnchorRemove: N.useCallback(() => u(!1), []),
      modal: o,
      children: n
    }
  ) });
};
hU.displayName = UM;
var pU = "PopoverAnchor", Ldt = N.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, i = qc(pU, n), a = bp(n), { onCustomAnchorAdd: o, onCustomAnchorRemove: s } = i;
    return N.useEffect(() => (o(), () => s()), [o, s]), /* @__PURE__ */ T.jsx(Sd, { ...a, ...r, ref: e });
  }
);
Ldt.displayName = pU;
var mU = "PopoverTrigger", yU = N.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, i = qc(mU, n), a = bp(n), o = Jt(e, i.triggerRef), s = /* @__PURE__ */ T.jsx(
      Ct.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": xU(i.open),
        ...r,
        ref: o,
        onClick: it(t.onClick, i.onOpenToggle)
      }
    );
    return i.hasCustomAnchor ? s : /* @__PURE__ */ T.jsx(Sd, { asChild: !0, ...a, children: s });
  }
);
yU.displayName = mU;
var WM = "PopoverPortal", [Tdt, Edt] = fU(WM, {
  forceMount: void 0
}), gU = (t) => {
  const { __scopePopover: e, forceMount: n, children: r, container: i } = t, a = qc(WM, e);
  return /* @__PURE__ */ T.jsx(Tdt, { scope: e, forceMount: n, children: /* @__PURE__ */ T.jsx(zi, { present: n || a.open, children: /* @__PURE__ */ T.jsx(Ld, { asChild: !0, container: i, children: r }) }) });
};
gU.displayName = WM;
var G1 = "PopoverContent", vU = N.forwardRef(
  (t, e) => {
    const n = Edt(G1, t.__scopePopover), { forceMount: r = n.forceMount, ...i } = t, a = qc(G1, t.__scopePopover);
    return /* @__PURE__ */ T.jsx(zi, { present: r || a.open, children: a.modal ? /* @__PURE__ */ T.jsx(jdt, { ...i, ref: e }) : /* @__PURE__ */ T.jsx(Ndt, { ...i, ref: e }) });
  }
);
vU.displayName = G1;
var jdt = N.forwardRef(
  (t, e) => {
    const n = qc(G1, t.__scopePopover), r = N.useRef(null), i = Jt(e, r), a = N.useRef(!1);
    return N.useEffect(() => {
      const o = r.current;
      if (o) return t6(o);
    }, []), /* @__PURE__ */ T.jsx(e6, { as: ns, allowPinchZoom: !0, children: /* @__PURE__ */ T.jsx(
      bU,
      {
        ...t,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: it(t.onCloseAutoFocus, (o) => {
          var s;
          o.preventDefault(), a.current || (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: it(
          t.onPointerDownOutside,
          (o) => {
            const s = o.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0, c = s.button === 2 || l;
            a.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: it(
          t.onFocusOutside,
          (o) => o.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Ndt = N.forwardRef(
  (t, e) => {
    const n = qc(G1, t.__scopePopover), r = N.useRef(!1), i = N.useRef(!1);
    return /* @__PURE__ */ T.jsx(
      bU,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var o, s;
          (o = t.onCloseAutoFocus) == null || o.call(t, a), a.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), a.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (a) => {
          var o, s;
          (o = t.onInteractOutside) == null || o.call(t, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const l = a.target;
          (s = n.triggerRef.current) != null && s.contains(l) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && i.current && a.preventDefault();
        }
      }
    );
  }
), bU = N.forwardRef(
  (t, e) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: i,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: o,
      onEscapeKeyDown: s,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: u,
      ...d
    } = t, f = qc(G1, n), h = bp(n);
    return EM(), /* @__PURE__ */ T.jsx(
      jd,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: i,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ T.jsx(
          Fc,
          {
            asChild: !0,
            disableOutsidePointerEvents: o,
            onInteractOutside: u,
            onEscapeKeyDown: s,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => f.onOpenChange(!1),
            children: /* @__PURE__ */ T.jsx(
              sp,
              {
                "data-state": xU(f.open),
                role: "dialog",
                id: f.contentId,
                ...h,
                ...d,
                ref: e,
                style: {
                  ...d.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), wU = "PopoverClose", kU = N.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, i = qc(wU, n);
    return /* @__PURE__ */ T.jsx(
      Ct.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: it(t.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
kU.displayName = wU;
var Ddt = "PopoverArrow", Idt = N.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, i = bp(n);
    return /* @__PURE__ */ T.jsx(lp, { ...i, ...r, ref: e });
  }
);
Idt.displayName = Ddt;
function xU(t) {
  return t ? "open" : "closed";
}
var Pdt = hU, zdt = yU, Rdt = gU, MU = vU, Odt = kU, ZM = "Radio", [Bdt, CU] = ei(ZM), [Hdt, Fdt] = Bdt(ZM), AU = N.forwardRef(
  (t, e) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: i = !1,
      required: a,
      disabled: o,
      value: s = "on",
      onCheck: l,
      ...c
    } = t, [u, d] = N.useState(null), f = Jt(e, (m) => d(m)), h = N.useRef(!1), p = u ? !!u.closest("form") : !0;
    return /* @__PURE__ */ T.jsxs(Hdt, { scope: n, checked: i, disabled: o, children: [
      /* @__PURE__ */ T.jsx(
        Ct.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": i,
          "data-state": TU(i),
          "data-disabled": o ? "" : void 0,
          disabled: o,
          value: s,
          ...c,
          ref: f,
          onClick: it(t.onClick, (m) => {
            i || l == null || l(), p && (h.current = m.isPropagationStopped(), h.current || m.stopPropagation());
          })
        }
      ),
      p && /* @__PURE__ */ T.jsx(
        _dt,
        {
          control: u,
          bubbles: !h.current,
          name: r,
          value: s,
          checked: i,
          required: a,
          disabled: o,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
AU.displayName = ZM;
var SU = "RadioIndicator", LU = N.forwardRef(
  (t, e) => {
    const { __scopeRadio: n, forceMount: r, ...i } = t, a = Fdt(SU, n);
    return /* @__PURE__ */ T.jsx(zi, { present: r || a.checked, children: /* @__PURE__ */ T.jsx(
      Ct.span,
      {
        "data-state": TU(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...i,
        ref: e
      }
    ) });
  }
);
LU.displayName = SU;
var _dt = (t) => {
  const { control: e, checked: n, bubbles: r = !0, ...i } = t, a = N.useRef(null), o = Fx(n), s = _x(e);
  return N.useEffect(() => {
    const l = a.current, c = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (o !== n && u) {
      const d = new Event("click", { bubbles: r });
      u.call(l, n), l.dispatchEvent(d);
    }
  }, [o, n, r]), /* @__PURE__ */ T.jsx(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: n,
      ...i,
      tabIndex: -1,
      ref: a,
      style: {
        ...t.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function TU(t) {
  return t ? "checked" : "unchecked";
}
var Vdt = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], GM = "RadioGroup", [qdt, vGt] = ei(GM, [
  Jg,
  CU
]), EU = Jg(), jU = CU(), [Udt, Wdt] = qdt(GM), NU = N.forwardRef(
  (t, e) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: i,
      value: a,
      required: o = !1,
      disabled: s = !1,
      orientation: l,
      dir: c,
      loop: u = !0,
      onValueChange: d,
      ...f
    } = t, h = EU(n), p = Kg(c), [m, g] = mo({
      prop: a,
      defaultProp: i,
      onChange: d
    });
    return /* @__PURE__ */ T.jsx(
      Udt,
      {
        scope: n,
        name: r,
        required: o,
        disabled: s,
        value: m,
        onValueChange: g,
        children: /* @__PURE__ */ T.jsx(
          tq,
          {
            asChild: !0,
            ...h,
            orientation: l,
            dir: p,
            loop: u,
            children: /* @__PURE__ */ T.jsx(
              Ct.div,
              {
                role: "radiogroup",
                "aria-required": o,
                "aria-orientation": l,
                "data-disabled": s ? "" : void 0,
                dir: p,
                ...f,
                ref: e
              }
            )
          }
        )
      }
    );
  }
);
NU.displayName = GM;
var DU = "RadioGroupItem", IU = N.forwardRef(
  (t, e) => {
    const { __scopeRadioGroup: n, disabled: r, ...i } = t, a = Wdt(DU, n), o = a.disabled || r, s = EU(n), l = jU(n), c = N.useRef(null), u = Jt(e, c), d = a.value === i.value, f = N.useRef(!1);
    return N.useEffect(() => {
      const h = (m) => {
        Vdt.includes(m.key) && (f.current = !0);
      }, p = () => f.current = !1;
      return document.addEventListener("keydown", h), document.addEventListener("keyup", p), () => {
        document.removeEventListener("keydown", h), document.removeEventListener("keyup", p);
      };
    }, []), /* @__PURE__ */ T.jsx(
      nq,
      {
        asChild: !0,
        ...s,
        focusable: !o,
        active: d,
        children: /* @__PURE__ */ T.jsx(
          AU,
          {
            disabled: o,
            required: a.required,
            checked: d,
            ...l,
            ...i,
            name: a.name,
            ref: u,
            onCheck: () => a.onValueChange(i.value),
            onKeyDown: it((h) => {
              h.key === "Enter" && h.preventDefault();
            }),
            onFocus: it(i.onFocus, () => {
              var h;
              f.current && ((h = c.current) == null || h.click());
            })
          }
        )
      }
    );
  }
);
IU.displayName = DU;
var Zdt = "RadioGroupIndicator", PU = N.forwardRef(
  (t, e) => {
    const { __scopeRadioGroup: n, ...r } = t, i = jU(n);
    return /* @__PURE__ */ T.jsx(LU, { ...i, ...r, ref: e });
  }
);
PU.displayName = Zdt;
var zU = NU, RU = IU, Gdt = PU, Ydt = [" ", "Enter", "ArrowUp", "ArrowDown"], Kdt = [" ", "Enter"], a6 = "Select", [YM, o6, $dt] = Yg(a6), [Nd, bGt] = ei(a6, [
  $dt,
  fs
]), KM = fs(), [wGt, Uc] = Nd(a6), [kGt, Jdt] = Nd(a6), OU = "SelectTrigger", BU = N.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, disabled: r = !1, ...i } = t, a = KM(n), o = Uc(OU, n), s = o.disabled || r, l = Jt(e, o.onTriggerChange), c = o6(n), [u, d, f] = oW((p) => {
      const m = c().filter((k) => !k.disabled), g = m.find((k) => k.value === o.value), v = sW(m, p, g);
      v !== void 0 && o.onValueChange(v.value);
    }), h = () => {
      s || (o.onOpenChange(!0), f());
    };
    return /* @__PURE__ */ T.jsx(Sd, { asChild: !0, ...a, children: /* @__PURE__ */ T.jsx(
      Ct.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": o.contentId,
        "aria-expanded": o.open,
        "aria-required": o.required,
        "aria-autocomplete": "none",
        dir: o.dir,
        "data-state": o.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": aW(o.value) ? "" : void 0,
        ...i,
        ref: l,
        onClick: it(i.onClick, (p) => {
          p.currentTarget.focus();
        }),
        onPointerDown: it(i.onPointerDown, (p) => {
          const m = p.target;
          m.hasPointerCapture(p.pointerId) && m.releasePointerCapture(p.pointerId), p.button === 0 && p.ctrlKey === !1 && (h(), o.triggerPointerDownPosRef.current = {
            x: Math.round(p.pageX),
            y: Math.round(p.pageY)
          }, p.preventDefault());
        }),
        onKeyDown: it(i.onKeyDown, (p) => {
          const m = u.current !== "";
          !(p.ctrlKey || p.altKey || p.metaKey) && p.key.length === 1 && d(p.key), !(m && p.key === " ") && Ydt.includes(p.key) && (h(), p.preventDefault());
        })
      }
    ) });
  }
);
BU.displayName = OU;
var HU = "SelectValue", Qdt = N.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, className: r, style: i, children: a, placeholder: o = "", ...s } = t, l = Uc(HU, n), { onValueNodeHasChildrenChange: c } = l, u = a !== void 0, d = Jt(e, l.onValueNodeChange);
    return Fr(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ T.jsx(
      Ct.span,
      {
        ...s,
        ref: d,
        style: { pointerEvents: "none" },
        children: aW(l.value) ? /* @__PURE__ */ T.jsx(T.Fragment, { children: o }) : a
      }
    );
  }
);
Qdt.displayName = HU;
var Xdt = "SelectIcon", FU = N.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, children: r, ...i } = t;
    return /* @__PURE__ */ T.jsx(Ct.span, { "aria-hidden": !0, ...i, ref: e, children: r || "▼" });
  }
);
FU.displayName = Xdt;
var eft = "SelectPortal", _U = (t) => /* @__PURE__ */ T.jsx(Ld, { asChild: !0, ...t });
_U.displayName = eft;
var Xu = "SelectContent", VU = N.forwardRef(
  (t, e) => {
    const n = Uc(Xu, t.__scopeSelect), [r, i] = N.useState();
    if (Fr(() => {
      i(new DocumentFragment());
    }, []), !n.open) {
      const a = r;
      return a ? wd.createPortal(
        /* @__PURE__ */ T.jsx(qU, { scope: t.__scopeSelect, children: /* @__PURE__ */ T.jsx(YM.Slot, { scope: t.__scopeSelect, children: /* @__PURE__ */ T.jsx("div", { children: t.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ T.jsx(UU, { ...t, ref: e });
  }
);
VU.displayName = Xu;
var zs = 10, [qU, Wc] = Nd(Xu), tft = "SelectContentImpl", UU = N.forwardRef(
  (t, e) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: i,
      onEscapeKeyDown: a,
      onPointerDownOutside: o,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: h,
      sticky: p,
      hideWhenDetached: m,
      avoidCollisions: g,
      //
      ...v
    } = t, k = Uc(Xu, n), [w, b] = N.useState(null), [x, A] = N.useState(null), L = Jt(e, (se) => b(se)), [M, j] = N.useState(null), [D, z] = N.useState(
      null
    ), H = o6(n), [V, F] = N.useState(!1), _ = N.useRef(!1);
    N.useEffect(() => {
      if (w) return t6(w);
    }, [w]), EM();
    const W = N.useCallback(
      (se) => {
        const [xe, ...Oe] = H().map((he) => he.ref.current), [je] = Oe.slice(-1), Me = document.activeElement;
        for (const he of se)
          if (he === Me || (he == null || he.scrollIntoView({ block: "nearest" }), he === xe && x && (x.scrollTop = 0), he === je && x && (x.scrollTop = x.scrollHeight), he == null || he.focus(), document.activeElement !== Me)) return;
      },
      [H, x]
    ), G = N.useCallback(
      () => W([M, w]),
      [W, M, w]
    );
    N.useEffect(() => {
      V && G();
    }, [V, G]);
    const { onOpenChange: Y, triggerPointerDownPosRef: Z } = k;
    N.useEffect(() => {
      if (w) {
        let se = { x: 0, y: 0 };
        const xe = (je) => {
          var Me, he;
          se = {
            x: Math.abs(Math.round(je.pageX) - (((Me = Z.current) == null ? void 0 : Me.x) ?? 0)),
            y: Math.abs(Math.round(je.pageY) - (((he = Z.current) == null ? void 0 : he.y) ?? 0))
          };
        }, Oe = (je) => {
          se.x <= 10 && se.y <= 10 ? je.preventDefault() : w.contains(je.target) || Y(!1), document.removeEventListener("pointermove", xe), Z.current = null;
        };
        return Z.current !== null && (document.addEventListener("pointermove", xe), document.addEventListener("pointerup", Oe, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", xe), document.removeEventListener("pointerup", Oe, { capture: !0 });
        };
      }
    }, [w, Y, Z]), N.useEffect(() => {
      const se = () => Y(!1);
      return window.addEventListener("blur", se), window.addEventListener("resize", se), () => {
        window.removeEventListener("blur", se), window.removeEventListener("resize", se);
      };
    }, [Y]);
    const [oe, ee] = oW((se) => {
      const xe = H().filter((Me) => !Me.disabled), Oe = xe.find((Me) => Me.ref.current === document.activeElement), je = sW(xe, se, Oe);
      je && setTimeout(() => je.ref.current.focus());
    }), ae = N.useCallback(
      (se, xe, Oe) => {
        const je = !_.current && !Oe;
        (k.value !== void 0 && k.value === xe || je) && (j(se), je && (_.current = !0));
      },
      [k.value]
    ), fe = N.useCallback(() => w == null ? void 0 : w.focus(), [w]), me = N.useCallback(
      (se, xe, Oe) => {
        const je = !_.current && !Oe;
        (k.value !== void 0 && k.value === xe || je) && z(se);
      },
      [k.value]
    ), ge = r === "popper" ? l9 : WU, $ = ge === l9 ? {
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: h,
      sticky: p,
      hideWhenDetached: m,
      avoidCollisions: g
    } : {};
    return /* @__PURE__ */ T.jsx(
      qU,
      {
        scope: n,
        content: w,
        viewport: x,
        onViewportChange: A,
        itemRefCallback: ae,
        selectedItem: M,
        onItemLeave: fe,
        itemTextRefCallback: me,
        focusSelectedItem: G,
        selectedItemText: D,
        position: r,
        isPositioned: V,
        searchRef: oe,
        children: /* @__PURE__ */ T.jsx(e6, { as: ns, allowPinchZoom: !0, children: /* @__PURE__ */ T.jsx(
          jd,
          {
            asChild: !0,
            trapped: k.open,
            onMountAutoFocus: (se) => {
              se.preventDefault();
            },
            onUnmountAutoFocus: it(i, (se) => {
              var xe;
              (xe = k.trigger) == null || xe.focus({ preventScroll: !0 }), se.preventDefault();
            }),
            children: /* @__PURE__ */ T.jsx(
              Fc,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: o,
                onFocusOutside: (se) => se.preventDefault(),
                onDismiss: () => k.onOpenChange(!1),
                children: /* @__PURE__ */ T.jsx(
                  ge,
                  {
                    role: "listbox",
                    id: k.contentId,
                    "data-state": k.open ? "open" : "closed",
                    dir: k.dir,
                    onContextMenu: (se) => se.preventDefault(),
                    ...v,
                    ...$,
                    onPlaced: () => F(!0),
                    ref: L,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...v.style
                    },
                    onKeyDown: it(v.onKeyDown, (se) => {
                      const xe = se.ctrlKey || se.altKey || se.metaKey;
                      if (se.key === "Tab" && se.preventDefault(), !xe && se.key.length === 1 && ee(se.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(se.key)) {
                        let Oe = H().filter((je) => !je.disabled).map((je) => je.ref.current);
                        if (["ArrowUp", "End"].includes(se.key) && (Oe = Oe.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(se.key)) {
                          const je = se.target, Me = Oe.indexOf(je);
                          Oe = Oe.slice(Me + 1);
                        }
                        setTimeout(() => W(Oe)), se.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
UU.displayName = tft;
var nft = "SelectItemAlignedPosition", WU = N.forwardRef((t, e) => {
  const { __scopeSelect: n, onPlaced: r, ...i } = t, a = Uc(Xu, n), o = Wc(Xu, n), [s, l] = N.useState(null), [c, u] = N.useState(null), d = Jt(e, (L) => u(L)), f = o6(n), h = N.useRef(!1), p = N.useRef(!0), { viewport: m, selectedItem: g, selectedItemText: v, focusSelectedItem: k } = o, w = N.useCallback(() => {
    if (a.trigger && a.valueNode && s && c && m && g && v) {
      const L = a.trigger.getBoundingClientRect(), M = c.getBoundingClientRect(), j = a.valueNode.getBoundingClientRect(), D = v.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const je = D.left - M.left, Me = j.left - je, he = L.left - Me, pe = L.width + he, J = Math.max(pe, M.width), K = window.innerWidth - zs, X = bN(Me, [zs, K - J]);
        s.style.minWidth = pe + "px", s.style.left = X + "px";
      } else {
        const je = M.right - D.right, Me = window.innerWidth - j.right - je, he = window.innerWidth - L.right - Me, pe = L.width + he, J = Math.max(pe, M.width), K = window.innerWidth - zs, X = bN(Me, [zs, K - J]);
        s.style.minWidth = pe + "px", s.style.right = X + "px";
      }
      const z = f(), H = window.innerHeight - zs * 2, V = m.scrollHeight, F = window.getComputedStyle(c), _ = parseInt(F.borderTopWidth, 10), W = parseInt(F.paddingTop, 10), G = parseInt(F.borderBottomWidth, 10), Y = parseInt(F.paddingBottom, 10), Z = _ + W + V + Y + G, oe = Math.min(g.offsetHeight * 5, Z), ee = window.getComputedStyle(m), ae = parseInt(ee.paddingTop, 10), fe = parseInt(ee.paddingBottom, 10), me = L.top + L.height / 2 - zs, ge = H - me, $ = g.offsetHeight / 2, se = g.offsetTop + $, xe = _ + W + se, Oe = Z - xe;
      if (xe <= me) {
        const je = g === z[z.length - 1].ref.current;
        s.style.bottom = "0px";
        const Me = c.clientHeight - m.offsetTop - m.offsetHeight, he = Math.max(
          ge,
          $ + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (je ? fe : 0) + Me + G
        ), pe = xe + he;
        s.style.height = pe + "px";
      } else {
        const je = g === z[0].ref.current;
        s.style.top = "0px";
        const Me = Math.max(
          me,
          _ + m.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (je ? ae : 0) + $
        ) + Oe;
        s.style.height = Me + "px", m.scrollTop = xe - me + m.offsetTop;
      }
      s.style.margin = `${zs}px 0`, s.style.minHeight = oe + "px", s.style.maxHeight = H + "px", r == null || r(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    f,
    a.trigger,
    a.valueNode,
    s,
    c,
    m,
    g,
    v,
    a.dir,
    r
  ]);
  Fr(() => w(), [w]);
  const [b, x] = N.useState();
  Fr(() => {
    c && x(window.getComputedStyle(c).zIndex);
  }, [c]);
  const A = N.useCallback(
    (L) => {
      L && p.current === !0 && (w(), k == null || k(), p.current = !1);
    },
    [w, k]
  );
  return /* @__PURE__ */ T.jsx(
    ift,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: A,
      children: /* @__PURE__ */ T.jsx(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: b
          },
          children: /* @__PURE__ */ T.jsx(
            Ct.div,
            {
              ...i,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...i.style
              }
            }
          )
        }
      )
    }
  );
});
WU.displayName = nft;
var rft = "SelectPopperPosition", l9 = N.forwardRef((t, e) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: i = zs,
    ...a
  } = t, o = KM(n);
  return /* @__PURE__ */ T.jsx(
    sp,
    {
      ...o,
      ...a,
      ref: e,
      align: r,
      collisionPadding: i,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
l9.displayName = rft;
var [ift, $M] = Nd(Xu, {}), c9 = "SelectViewport", ZU = N.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, nonce: r, ...i } = t, a = Wc(c9, n), o = $M(c9, n), s = Jt(e, a.onViewportChange), l = N.useRef(0);
    return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
      /* @__PURE__ */ T.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ T.jsx(YM.Slot, { scope: n, children: /* @__PURE__ */ T.jsx(
        Ct.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...i,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            overflow: "auto",
            ...i.style
          },
          onScroll: it(i.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: f } = o;
            if (f != null && f.current && d) {
              const h = Math.abs(l.current - u.scrollTop);
              if (h > 0) {
                const p = window.innerHeight - zs * 2, m = parseFloat(d.style.minHeight), g = parseFloat(d.style.height), v = Math.max(m, g);
                if (v < p) {
                  const k = v + h, w = Math.min(p, k), b = k - w;
                  d.style.height = w + "px", d.style.bottom === "0px" && (u.scrollTop = b > 0 ? b : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
ZU.displayName = c9;
var GU = "SelectGroup", [aft, oft] = Nd(GU), sft = N.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t, i = Xa();
    return /* @__PURE__ */ T.jsx(aft, { scope: n, id: i, children: /* @__PURE__ */ T.jsx(Ct.div, { role: "group", "aria-labelledby": i, ...r, ref: e }) });
  }
);
sft.displayName = GU;
var YU = "SelectLabel", KU = N.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t, i = oft(YU, n);
    return /* @__PURE__ */ T.jsx(Ct.div, { id: i.id, ...r, ref: e });
  }
);
KU.displayName = YU;
var _y = "SelectItem", [lft, $U] = Nd(_y), JU = N.forwardRef(
  (t, e) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: i = !1,
      textValue: a,
      ...o
    } = t, s = Uc(_y, n), l = Wc(_y, n), c = s.value === r, [u, d] = N.useState(a ?? ""), [f, h] = N.useState(!1), p = Jt(
      e,
      (v) => {
        var k;
        return (k = l.itemRefCallback) == null ? void 0 : k.call(l, v, r, i);
      }
    ), m = Xa(), g = () => {
      i || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ T.jsx(
      lft,
      {
        scope: n,
        value: r,
        disabled: i,
        textId: m,
        isSelected: c,
        onItemTextChange: N.useCallback((v) => {
          d((k) => k || ((v == null ? void 0 : v.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ T.jsx(
          YM.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: i,
            textValue: u,
            children: /* @__PURE__ */ T.jsx(
              Ct.div,
              {
                role: "option",
                "aria-labelledby": m,
                "data-highlighted": f ? "" : void 0,
                "aria-selected": c && f,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": i || void 0,
                "data-disabled": i ? "" : void 0,
                tabIndex: i ? void 0 : -1,
                ...o,
                ref: p,
                onFocus: it(o.onFocus, () => h(!0)),
                onBlur: it(o.onBlur, () => h(!1)),
                onPointerUp: it(o.onPointerUp, g),
                onPointerMove: it(o.onPointerMove, (v) => {
                  var k;
                  i ? (k = l.onItemLeave) == null || k.call(l) : v.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: it(o.onPointerLeave, (v) => {
                  var k;
                  v.currentTarget === document.activeElement && ((k = l.onItemLeave) == null || k.call(l));
                }),
                onKeyDown: it(o.onKeyDown, (v) => {
                  var k;
                  ((k = l.searchRef) == null ? void 0 : k.current) !== "" && v.key === " " || (Kdt.includes(v.key) && g(), v.key === " " && v.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
JU.displayName = _y;
var Pf = "SelectItemText", QU = N.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, className: r, style: i, ...a } = t, o = Uc(Pf, n), s = Wc(Pf, n), l = $U(Pf, n), c = Jdt(Pf, n), [u, d] = N.useState(null), f = Jt(
      e,
      (v) => d(v),
      l.onItemTextChange,
      (v) => {
        var k;
        return (k = s.itemTextRefCallback) == null ? void 0 : k.call(s, v, l.value, l.disabled);
      }
    ), h = u == null ? void 0 : u.textContent, p = N.useMemo(
      () => /* @__PURE__ */ T.jsx("option", { value: l.value, disabled: l.disabled, children: h }, l.value),
      [l.disabled, l.value, h]
    ), { onNativeOptionAdd: m, onNativeOptionRemove: g } = c;
    return Fr(() => (m(p), () => g(p)), [m, g, p]), /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
      /* @__PURE__ */ T.jsx(Ct.span, { id: l.textId, ...a, ref: f }),
      l.isSelected && o.valueNode && !o.valueNodeHasChildren ? wd.createPortal(a.children, o.valueNode) : null
    ] });
  }
);
QU.displayName = Pf;
var XU = "SelectItemIndicator", eW = N.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t;
    return $U(XU, n).isSelected ? /* @__PURE__ */ T.jsx(Ct.span, { "aria-hidden": !0, ...r, ref: e }) : null;
  }
);
eW.displayName = XU;
var u9 = "SelectScrollUpButton", tW = N.forwardRef((t, e) => {
  const n = Wc(u9, t.__scopeSelect), r = $M(u9, t.__scopeSelect), [i, a] = N.useState(!1), o = Jt(e, r.onScrollButtonChange);
  return Fr(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        a(c);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ T.jsx(
    rW,
    {
      ...t,
      ref: o,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
tW.displayName = u9;
var d9 = "SelectScrollDownButton", nW = N.forwardRef((t, e) => {
  const n = Wc(d9, t.__scopeSelect), r = $M(d9, t.__scopeSelect), [i, a] = N.useState(!1), o = Jt(e, r.onScrollButtonChange);
  return Fr(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        a(u);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ T.jsx(
    rW,
    {
      ...t,
      ref: o,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
nW.displayName = d9;
var rW = N.forwardRef((t, e) => {
  const { __scopeSelect: n, onAutoScroll: r, ...i } = t, a = Wc("SelectScrollButton", n), o = N.useRef(null), s = o6(n), l = N.useCallback(() => {
    o.current !== null && (window.clearInterval(o.current), o.current = null);
  }, []);
  return N.useEffect(() => () => l(), [l]), Fr(() => {
    var c;
    const u = s().find((d) => d.ref.current === document.activeElement);
    (c = u == null ? void 0 : u.ref.current) == null || c.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ T.jsx(
    Ct.div,
    {
      "aria-hidden": !0,
      ...i,
      ref: e,
      style: { flexShrink: 0, ...i.style },
      onPointerDown: it(i.onPointerDown, () => {
        o.current === null && (o.current = window.setInterval(r, 50));
      }),
      onPointerMove: it(i.onPointerMove, () => {
        var c;
        (c = a.onItemLeave) == null || c.call(a), o.current === null && (o.current = window.setInterval(r, 50));
      }),
      onPointerLeave: it(i.onPointerLeave, () => {
        l();
      })
    }
  );
}), cft = "SelectSeparator", iW = N.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t;
    return /* @__PURE__ */ T.jsx(Ct.div, { "aria-hidden": !0, ...r, ref: e });
  }
);
iW.displayName = cft;
var f9 = "SelectArrow", uft = N.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t, i = KM(n), a = Uc(f9, n), o = Wc(f9, n);
    return a.open && o.position === "popper" ? /* @__PURE__ */ T.jsx(lp, { ...i, ...r, ref: e }) : null;
  }
);
uft.displayName = f9;
function aW(t) {
  return t === "" || t === void 0;
}
var dft = N.forwardRef(
  (t, e) => {
    const { value: n, ...r } = t, i = N.useRef(null), a = Jt(e, i), o = Fx(n);
    return N.useEffect(() => {
      const s = i.current, l = window.HTMLSelectElement.prototype, c = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (o !== n && c) {
        const u = new Event("change", { bubbles: !0 });
        c.call(s, n), s.dispatchEvent(u);
      }
    }, [o, n]), /* @__PURE__ */ T.jsx(cp, { asChild: !0, children: /* @__PURE__ */ T.jsx("select", { ...r, ref: a, defaultValue: n }) });
  }
);
dft.displayName = "BubbleSelect";
function oW(t) {
  const e = Di(t), n = N.useRef(""), r = N.useRef(0), i = N.useCallback(
    (o) => {
      const s = n.current + o;
      e(s), function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [e]
  ), a = N.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return N.useEffect(() => () => window.clearTimeout(r.current), []), [n, i, a];
}
function sW(t, e, n) {
  const r = e.length > 1 && Array.from(e).every((s) => s === e[0]) ? e[0] : e, i = n ? t.indexOf(n) : -1;
  let a = fft(t, Math.max(i, 0));
  r.length === 1 && (a = a.filter((s) => s !== n));
  const o = a.find(
    (s) => s.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return o !== n ? o : void 0;
}
function fft(t, e) {
  return t.map((n, r) => t[(e + r) % t.length]);
}
var lW = BU, hft = FU, pft = _U, cW = VU, mft = ZU, uW = KU, dW = JU, yft = QU, gft = eW, fW = tW, hW = nW, pW = iW;
const vft = Ce.forwardRef(({ children: t, size: e, liked: n, onLike: r, onClick: i, ...a }, o) => {
  const s = [
    /* @__PURE__ */ T.jsx("div", { children: /* @__PURE__ */ T.jsx(Ye, { name: "Share", size: "md" }) }),
    /* @__PURE__ */ T.jsx("div", { onClick: r, children: /* @__PURE__ */ T.jsx(
      Ye,
      {
        name: "Heart",
        size: "md",
        fill: n ? "red" : "none",
        stroke: n ? "red" : "currentColor"
      }
    ) })
  ];
  return /* @__PURE__ */ T.jsx(
    _M,
    {
      onClick: i,
      ref: o,
      className: "w-full h-full",
      gridColumn: {
        initial: e === "sm" ? "span 2" : "span 4",
        md: e === "sm" ? "span 1" : e === "md" ? "span 2" : "span 3"
      },
      gridRow: {
        initial: e === "sm" || e === "md" ? "span 2" : "span 4",
        md: e === "sm" || e === "md" ? "span 2" : "span 4"
      },
      style: {
        minWidth: e === "sm" ? "156px" : "328px",
        minHeight: e === "sm" || e === "md" ? "212px" : "440px",
        maxHeight: e === "sm" || e === "md" ? "212px" : "440px"
      },
      ...a,
      children: /* @__PURE__ */ T.jsxs("div", { className: "w-full h-full relative cursor-pointer group", children: [
        t,
        /* @__PURE__ */ T.jsx(
          "div",
          {
            onClick: (l) => {
              l.stopPropagation();
            },
            className: be(
              " absolute z-10 -bottom-6 left-1/2 transform -translate-x-1/2 hover:cursor-pointer group-hover:opacity-100 opacity-0 transition-opacity duration-300"
            ),
            children: /* @__PURE__ */ T.jsx(
              Qg,
              {
                showActiveState: !1,
                options: s,
                container: !0,
                setCurrentState: () => null
              }
            )
          }
        )
      ] })
    }
  );
});
vft.displayName = "CardInteractionWrapper";
const Em = {
  0: "sm",
  1: "md",
  2: "lg"
}, N8 = {
  initial: { scale: 0.8, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: { scale: 0.8, opacity: 0 },
  transition: {
    type: "spring",
    damping: 30,
    stiffness: 200,
    duration: 0.1
  }
}, bft = Ce.forwardRef(
  ({
    defaultSize: t,
    deleteFunction: e,
    children: n,
    isDragging: r = !1,
    onSizeChange: i,
    isAnimated: a = !1,
    ...o
  }, s) => {
    const [l, c] = De(t), [u, d] = De(
      Object.keys(Em).findIndex(
        (h) => Em[h] === t
      )
    ), f = [
      /* @__PURE__ */ T.jsx("div", { children: /* @__PURE__ */ T.jsx(Ye, { fill: "none", name: "Square", size: "sm" }) }),
      /* @__PURE__ */ T.jsx("div", { children: /* @__PURE__ */ T.jsx(Ye, { fill: "none", name: "RectangleHorizontal" }) }),
      /* @__PURE__ */ T.jsx("div", { children: /* @__PURE__ */ T.jsx(Ye, { fill: "none", name: "Square", size: "md" }) })
    ];
    return ze(() => {
      c(Em[u]), i == null || i(Em[u]);
    }, [u]), /* @__PURE__ */ T.jsxs(
      _M,
      {
        ref: s,
        className: "w-full h-full relative group",
        gridColumn: {
          initial: l === "sm" ? "span 2" : "span 4",
          md: l === "sm" ? "span 1" : l === "md" ? "span 2" : "span 3"
        },
        gridRow: {
          initial: l === "sm" || l === "md" ? "span 2" : "span 4",
          md: l === "sm" || l === "md" ? "span 2" : "span 4"
        },
        style: {
          minWidth: l === "sm" ? "156px" : "328px",
          minHeight: l === "sm" || l === "md" ? "212px" : "440px",
          maxHeight: l === "sm" || l === "md" ? "212px" : "440px"
        },
        ...o,
        children: [
          /* @__PURE__ */ T.jsx(
            Ru.div,
            {
              ...N8,
              layout: a,
              className: "w-full h-full relative",
              children: n(l)
            }
          ),
          /* @__PURE__ */ T.jsx(
            Ru.div,
            {
              ...N8,
              layout: "size",
              className: be(
                "absolute -top-4 -left-4 group-hover:visible invisible group-hover:opacity-100 opacity-0 transition-opacity duration-300",
                r && "invisible"
              ),
              children: /* @__PURE__ */ T.jsx(
                mn,
                {
                  onClick: e,
                  icon: "Trash2",
                  variant: "ghost",
                  size: "md",
                  rounded: !0,
                  elevation: 3,
                  className: "color-bg-default"
                }
              )
            }
          ),
          /* @__PURE__ */ T.jsx(
            Ru.div,
            {
              ...N8,
              layout: "size",
              className: be(
                "absolute z-10 -bottom-6 left-1/2 transform invisible -translate-x-1/2 group-hover:visible group-hover:opacity-100 opacity-0 transition-opacity duration-300",
                r && "invisible"
              ),
              children: /* @__PURE__ */ T.jsx(
                Qg,
                {
                  options: f,
                  container: !0,
                  currentState: u,
                  setCurrentState: d
                }
              )
            }
          )
        ]
      }
    );
  }
);
bft.displayName = "CardControlWrapper";
const wft = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ T.jsx(
  "table",
  {
    ref: n,
    className: be(
      "w-full caption-bottom text-body-sm color-text-default",
      t
    ),
    ...e
  }
) }));
wft.displayName = "Table";
const kft = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  "thead",
  {
    ref: n,
    className: be("[&_tr]:border-b [&_tr]:color-border-default", t),
    ...e
  }
));
kft.displayName = "TableHeader";
const xft = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  "tbody",
  {
    ref: n,
    className: be("[&_tr:last-child]:border-0", t),
    ...e
  }
));
xft.displayName = "TableBody";
const Mft = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  "tfoot",
  {
    ref: n,
    className: be(
      "border-t color-border-default color-bg-secondary color-text-secondary [&>tr]:last:border-b-0",
      t
    ),
    ...e
  }
));
Mft.displayName = "TableFooter";
const Cft = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  "tr",
  {
    ref: n,
    className: be(
      "border-b color-border-default transition-colors hover:color-bg-default-hover data-[state=selected]:color-bg-default-selected",
      t
    ),
    ...e
  }
));
Cft.displayName = "TableRow";
const Aft = N.forwardRef(
  ({ className: t, children: e, enableSorting: n, sortOrder: r, ...i }, a) => /* @__PURE__ */ T.jsx(
    "th",
    {
      ref: a,
      className: be(
        "h-12 py-4 px-2 text-left align-middle text-heading-xsm color-text-secondary color-border-default border-b [&:has([role=checkbox])]:pr-0",
        {
          "cursor-pointer": n
        },
        t
      ),
      ...i,
      children: /* @__PURE__ */ T.jsxs("div", { className: "flex justify-start items-center gap-2", children: [
        e,
        n && /* @__PURE__ */ T.jsxs("div", { className: "flex flex-col justify-center items-center", children: [
          /* @__PURE__ */ T.jsx(
            R7,
            {
              size: 7,
              className: be(
                "-rotate-90 color-icon-secondary",
                r === "asc" && "color-icon-default"
              )
            }
          ),
          /* @__PURE__ */ T.jsx(
            R7,
            {
              size: 7,
              className: be(
                "rotate-90 color-icon-secondary",
                r === "desc" && "color-icon-default"
              )
            }
          )
        ] })
      ] })
    }
  )
);
Aft.displayName = "TableHead";
const Sft = N.forwardRef(({ className: t, children: e, ...n }, r) => {
  const i = typeof e == "string" ? "min-w-[200px]" : "w-fit";
  return /* @__PURE__ */ T.jsx(
    "td",
    {
      ref: r,
      className: be(
        "h-12 py-4 px-2 align-middle text-body-sm color-text-default [&:has([role=checkbox])]:pr-0",
        i,
        t
      ),
      ...n,
      children: e
    }
  );
});
Sft.displayName = "TableCell";
const Lft = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  "caption",
  {
    ref: n,
    className: be("mt-4 text-body-sm color-text-secondary", t),
    ...e
  }
));
Lft.displayName = "TableCaption";
const Tft = "data:image/gif;base64,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", Eft = ({ text: t = "Loading..." }) => /* @__PURE__ */ T.jsxs("div", { className: "flex flex-col items-center justify-center h-full gap-4 color-text-default", children: [
  /* @__PURE__ */ T.jsx("img", { src: Tft, height: 140, width: 140, alt: "fileverse logo" }),
  /* @__PURE__ */ T.jsx("p", { className: "text-heading-sm-bold", children: t })
] }), jft = Ce.forwardRef(
  ({
    children: t,
    className: e,
    title: n,
    setTitle: r,
    setCurrentLayoutMode: i,
    viewMode: a,
    isDragging: o,
    onRemoveSection: s,
    ...l
  }, c) => {
    const u = [
      /* @__PURE__ */ T.jsx(
        "div",
        {
          onClick: () => i(I9.LIST),
          "data-testid": "list-mode-button",
          className: "color-text-default",
          children: /* @__PURE__ */ T.jsx(
            Ye,
            {
              fill: "none",
              name: "List",
              className: "color-text-default hover:color-text-default-hover transition-colors"
            }
          )
        }
      ),
      /* @__PURE__ */ T.jsx(
        "div",
        {
          onClick: () => i(I9.CARD),
          "data-testid": "card-mode-button",
          className: "color-text-default",
          children: /* @__PURE__ */ T.jsx(
            Ye,
            {
              fill: "none",
              name: "LayoutGrid",
              className: "color-text-default hover:color-text-default-hover transition-colors"
            }
          )
        }
      )
    ], { onMouseEnter: d, onMouseLeave: f, isActive: h } = j3t({});
    return /* @__PURE__ */ T.jsxs(
      "section",
      {
        ref: c,
        className: be(
          "relative w-full color-bg-default p-4 flex flex-col gap-6 rounded-xl",
          e
        ),
        ...l,
        children: [
          !o && /* @__PURE__ */ T.jsxs(
            "div",
            {
              className: be(
                "w-full flex justify-between items-center py-2 px-5 rounded-xl border border-dashed transition-colors duration-200 ease-in-out",
                !a && h ? "border-default" : "border-transparent"
              ),
              onMouseEnter: d,
              onMouseLeave: f,
              children: [
                a ? /* @__PURE__ */ T.jsx("p", { className: "text-heading-md", children: n }) : r && /* @__PURE__ */ T.jsx(
                  al,
                  {
                    className: "text-heading-md border-none outline-none",
                    defaultValue: n,
                    onChange: (p) => r(p.target.value)
                  }
                ),
                /* @__PURE__ */ T.jsx("div", { children: /* @__PURE__ */ T.jsx(
                  Qg,
                  {
                    options: u,
                    container: !1,
                    currentState: 1,
                    setCurrentState: () => null
                  }
                ) }),
                !a && h && /* @__PURE__ */ T.jsx("div", { className: be("absolute -top-1 -left-1"), children: /* @__PURE__ */ T.jsx(
                  mn,
                  {
                    onClick: s,
                    icon: "Trash2",
                    variant: "ghost",
                    size: "md",
                    rounded: !0,
                    elevation: 3,
                    className: "color-bg-default"
                  }
                ) })
              ]
            }
          ),
          t
        ]
      }
    );
  }
);
jft.displayName = "Section";
const Nft = Ce.forwardRef(({ options: t, alignment: e = "vertical", className: n, ...r }, i) => /* @__PURE__ */ T.jsx(
  "div",
  {
    ref: i,
    className: be(
      "p-2 color-bg-default flex justify-center items-center gap-4 rounded-xl color-border-default border-[0.5px] shadow-elevation-4",
      { "flex-col w-[68px] px-6 py-4": e === "horizontal" },
      { "h-[68px] py-6 px-4": e === "vertical" },
      n
    ),
    ...r,
    children: t.map((a, o) => /* @__PURE__ */ T.jsxs(
      "div",
      {
        className: be("flex justify-center items-center gap-4", {
          "flex-col": e === "horizontal"
        }),
        children: [
          /* @__PURE__ */ T.jsx(
            "div",
            {
              className: be("flex gap-2", {
                "flex-col": e === "horizontal"
              }),
              children: a.map((s, l) => /* @__PURE__ */ T.jsx(
                "span",
                {
                  className: "min-w-9 min-h-9 hover:color-button-secondary-hover hover:cursor-pointer transition-colors rounded-[4px]",
                  children: s
                },
                l
              ))
            }
          ),
          o !== t.length - 1 && /* @__PURE__ */ T.jsx(r0, { direction: e, size: "lg" })
        ]
      },
      o
    ))
  }
));
Nft.displayName = "FloatingToolbar";
function Dft(t) {
  if (typeof document > "u") return;
  let e = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", e.appendChild(n), n.styleSheet ? n.styleSheet.cssText = t : n.appendChild(document.createTextNode(t));
}
const mW = Ce.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), wp = () => {
  const t = Ce.useContext(mW);
  if (!t)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return t;
};
Dft(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function Ift() {
  const t = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(t) && /Mobile/.test(t) || // Android Firefox
  /FxiOS/.test(t));
}
function Pft() {
  return JM(/^Mac/);
}
function zft() {
  return JM(/^iPhone/);
}
function wN() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function Rft() {
  return JM(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Pft() && navigator.maxTouchPoints > 1;
}
function yW() {
  return zft() || Rft();
}
function JM(t) {
  return typeof window < "u" && window.navigator != null ? t.test(window.navigator.platform) : void 0;
}
const Oft = 24, Bft = typeof window < "u" ? us : ze;
function kN(...t) {
  return (...e) => {
    for (let n of t)
      typeof n == "function" && n(...e);
  };
}
const D8 = typeof document < "u" && window.visualViewport;
function xN(t) {
  let e = window.getComputedStyle(t);
  return /(auto|scroll)/.test(e.overflow + e.overflowX + e.overflowY);
}
function gW(t) {
  for (xN(t) && (t = t.parentElement); t && !xN(t); )
    t = t.parentElement;
  return t || document.scrollingElement || document.documentElement;
}
const Hft = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let jm = 0, I8;
function Fft(t = {}) {
  let { isDisabled: e } = t;
  Bft(() => {
    if (!e)
      return jm++, jm === 1 && yW() && (I8 = _ft()), () => {
        jm--, jm === 0 && (I8 == null || I8());
      };
  }, [
    e
  ]);
}
function _ft() {
  let t, e = 0, n = (d) => {
    t = gW(d.target), !(t === document.documentElement && t === document.body) && (e = d.changedTouches[0].pageY);
  }, r = (d) => {
    if (!t || t === document.documentElement || t === document.body) {
      d.preventDefault();
      return;
    }
    let f = d.changedTouches[0].pageY, h = t.scrollTop, p = t.scrollHeight - t.clientHeight;
    p !== 0 && ((h <= 0 && f > e || h >= p && f < e) && d.preventDefault(), e = f);
  }, i = (d) => {
    let f = d.target;
    h9(f) && f !== document.activeElement && (d.preventDefault(), f.style.transform = "translateY(-2000px)", f.focus(), requestAnimationFrame(() => {
      f.style.transform = "";
    }));
  }, a = (d) => {
    let f = d.target;
    h9(f) && (f.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      f.style.transform = "", D8 && (D8.height < window.innerHeight ? requestAnimationFrame(() => {
        MN(f);
      }) : D8.addEventListener("resize", () => MN(f), {
        once: !0
      }));
    }));
  }, o = () => {
    window.scrollTo(0, 0);
  }, s = window.pageXOffset, l = window.pageYOffset, c = kN(Vft(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let u = kN(lf(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), lf(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), lf(document, "touchend", i, {
    passive: !1,
    capture: !0
  }), lf(document, "focus", a, !0), lf(window, "scroll", o));
  return () => {
    c(), u(), window.scrollTo(s, l);
  };
}
function Vft(t, e, n) {
  let r = t.style[e];
  return t.style[e] = n, () => {
    t.style[e] = r;
  };
}
function lf(t, e, n, r) {
  return t.addEventListener(e, n, r), () => {
    t.removeEventListener(e, n, r);
  };
}
function MN(t) {
  let e = document.scrollingElement || document.documentElement;
  for (; t && t !== e; ) {
    let n = gW(t);
    if (n !== document.documentElement && n !== document.body && n !== t) {
      let r = n.getBoundingClientRect().top, i = t.getBoundingClientRect().top, a = t.getBoundingClientRect().bottom;
      const o = n.getBoundingClientRect().bottom + Oft;
      a > o && (n.scrollTop += i - r);
    }
    t = n.parentElement;
  }
}
function h9(t) {
  return t instanceof HTMLInputElement && !Hft.has(t.type) || t instanceof HTMLTextAreaElement || t instanceof HTMLElement && t.isContentEditable;
}
function qft(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function Uft(...t) {
  return (e) => t.forEach((n) => qft(n, e));
}
function vW(...t) {
  return N.useCallback(Uft(...t), t);
}
const bW = /* @__PURE__ */ new WeakMap();
function dr(t, e, n = !1) {
  if (!t || !(t instanceof HTMLElement)) return;
  let r = {};
  Object.entries(e).forEach(([i, a]) => {
    if (i.startsWith("--")) {
      t.style.setProperty(i, a);
      return;
    }
    r[i] = t.style[i], t.style[i] = a;
  }), !n && bW.set(t, r);
}
function Wft(t, e) {
  if (!t || !(t instanceof HTMLElement)) return;
  let n = bW.get(t);
  n && (t.style[e] = n[e]);
}
const ar = (t) => {
  switch (t) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return t;
  }
};
function Nm(t, e) {
  if (!t)
    return null;
  const n = window.getComputedStyle(t), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let i = r.match(/^matrix3d\((.+)\)$/);
  return i ? parseFloat(i[1].split(", ")[ar(e) ? 13 : 12]) : (i = r.match(/^matrix\((.+)\)$/), i ? parseFloat(i[1].split(", ")[ar(e) ? 5 : 4]) : null);
}
function Zft(t) {
  return 8 * (Math.log(t + 1) - 2);
}
function P8(t, e) {
  if (!t) return () => {
  };
  const n = t.style.cssText;
  return Object.assign(t.style, e), () => {
    t.style.cssText = n;
  };
}
function Gft(...t) {
  return (...e) => {
    for (const n of t)
      typeof n == "function" && n(...e);
  };
}
const Pn = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, wW = 0.4, Yft = 0.25, Kft = 100, kW = 8, Dm = 16, p9 = 26, z8 = "vaul-dragging";
function xW(t) {
  const e = Ce.useRef(t);
  return Ce.useEffect(() => {
    e.current = t;
  }), Ce.useMemo(() => (...n) => e.current == null ? void 0 : e.current.call(e, ...n), []);
}
function $ft({ defaultProp: t, onChange: e }) {
  const n = Ce.useState(t), [r] = n, i = Ce.useRef(r), a = xW(e);
  return Ce.useEffect(() => {
    i.current !== r && (a(r), i.current = r);
  }, [
    r,
    i,
    a
  ]), n;
}
function MW({ prop: t, defaultProp: e, onChange: n = () => {
} }) {
  const [r, i] = $ft({
    defaultProp: e,
    onChange: n
  }), a = t !== void 0, o = a ? t : r, s = xW(n), l = Ce.useCallback((c) => {
    if (a) {
      const u = typeof c == "function" ? c(t) : c;
      u !== t && s(u);
    } else
      i(c);
  }, [
    a,
    t,
    i,
    s
  ]);
  return [
    o,
    l
  ];
}
function Jft({ activeSnapPointProp: t, setActiveSnapPointProp: e, snapPoints: n, drawerRef: r, overlayRef: i, fadeFromIndex: a, onSnapPointChange: o, direction: s = "bottom", container: l, snapToSequentialPoint: c }) {
  const [u, d] = MW({
    prop: t,
    defaultProp: n == null ? void 0 : n[0],
    onChange: e
  }), [f, h] = Ce.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  Ce.useEffect(() => {
    function L() {
      h({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", L), () => window.removeEventListener("resize", L);
  }, []);
  const p = Ce.useMemo(() => u === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    u
  ]), m = Ce.useMemo(() => {
    var L;
    return (L = n == null ? void 0 : n.findIndex((M) => M === u)) != null ? L : null;
  }, [
    n,
    u
  ]), g = n && n.length > 0 && (a || a === 0) && !Number.isNaN(a) && n[a] === u || !n, v = Ce.useMemo(() => {
    const L = l ? {
      width: l.getBoundingClientRect().width,
      height: l.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var M;
    return (M = n == null ? void 0 : n.map((j) => {
      const D = typeof j == "string";
      let z = 0;
      if (D && (z = parseInt(j, 10)), ar(s)) {
        const V = D ? z : f ? j * L.height : 0;
        return f ? s === "bottom" ? L.height - V : -L.height + V : V;
      }
      const H = D ? z : f ? j * L.width : 0;
      return f ? s === "right" ? L.width - H : -L.width + H : H;
    })) != null ? M : [];
  }, [
    n,
    f,
    l
  ]), k = Ce.useMemo(() => m !== null ? v == null ? void 0 : v[m] : null, [
    v,
    m
  ]), w = Ce.useCallback((L) => {
    var M;
    const j = (M = v == null ? void 0 : v.findIndex((D) => D === L)) != null ? M : null;
    o(j), dr(r.current, {
      transition: `transform ${Pn.DURATION}s cubic-bezier(${Pn.EASE.join(",")})`,
      transform: ar(s) ? `translate3d(0, ${L}px, 0)` : `translate3d(${L}px, 0, 0)`
    }), v && j !== v.length - 1 && a !== void 0 && j !== a && j < a ? dr(i.current, {
      transition: `opacity ${Pn.DURATION}s cubic-bezier(${Pn.EASE.join(",")})`,
      opacity: "0"
    }) : dr(i.current, {
      transition: `opacity ${Pn.DURATION}s cubic-bezier(${Pn.EASE.join(",")})`,
      opacity: "1"
    }), d(n == null ? void 0 : n[Math.max(j, 0)]);
  }, [
    r.current,
    n,
    v,
    a,
    i,
    d
  ]);
  Ce.useEffect(() => {
    if (u || t) {
      var L;
      const M = (L = n == null ? void 0 : n.findIndex((j) => j === t || j === u)) != null ? L : -1;
      v && M !== -1 && typeof v[M] == "number" && w(v[M]);
    }
  }, [
    u,
    t,
    n,
    v,
    w
  ]);
  function b({ draggedDistance: L, closeDrawer: M, velocity: j, dismissible: D }) {
    if (a === void 0) return;
    const z = s === "bottom" || s === "right" ? (k ?? 0) - L : (k ?? 0) + L, H = m === a - 1, V = m === 0, F = L > 0;
    if (H && dr(i.current, {
      transition: `opacity ${Pn.DURATION}s cubic-bezier(${Pn.EASE.join(",")})`
    }), !c && j > 2 && !F) {
      D ? M() : w(v[0]);
      return;
    }
    if (!c && j > 2 && F && v && n) {
      w(v[n.length - 1]);
      return;
    }
    const _ = v == null ? void 0 : v.reduce((G, Y) => typeof G != "number" || typeof Y != "number" ? G : Math.abs(Y - z) < Math.abs(G - z) ? Y : G), W = ar(s) ? window.innerHeight : window.innerWidth;
    if (j > wW && Math.abs(L) < W * 0.4) {
      const G = F ? 1 : -1;
      if (G > 0 && p && n) {
        w(v[n.length - 1]);
        return;
      }
      if (V && G < 0 && D && M(), m === null) return;
      w(v[m + G]);
      return;
    }
    w(_);
  }
  function x({ draggedDistance: L }) {
    if (k === null) return;
    const M = s === "bottom" || s === "right" ? k - L : k + L;
    (s === "bottom" || s === "right") && M < v[v.length - 1] || (s === "top" || s === "left") && M > v[v.length - 1] || dr(r.current, {
      transform: ar(s) ? `translate3d(0, ${M}px, 0)` : `translate3d(${M}px, 0, 0)`
    });
  }
  function A(L, M) {
    if (!n || typeof m != "number" || !v || a === void 0) return null;
    const j = m === a - 1;
    if (m >= a && M)
      return 0;
    if (j && !M) return 1;
    if (!g && !j) return null;
    const D = j ? m + 1 : m - 1, z = j ? v[D] - v[D - 1] : v[D + 1] - v[D], H = L / Math.abs(z);
    return j ? 1 - H : H;
  }
  return {
    isLastSnapPoint: p,
    activeSnapPoint: u,
    shouldFade: g,
    getPercentageDragged: A,
    setActiveSnapPoint: d,
    activeSnapPointIndex: m,
    onRelease: b,
    onDrag: x,
    snapPointsOffset: v
  };
}
const Qft = () => () => {
};
function Xft() {
  const { direction: t, isOpen: e, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: i } = wp(), a = Ce.useRef(null), o = Ft(() => document.body.style.backgroundColor, []);
  function s() {
    return (window.innerWidth - p9) / window.innerWidth;
  }
  Ce.useEffect(() => {
    if (e && n) {
      a.current && clearTimeout(a.current);
      const l = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!l) return;
      Gft(r && !i ? P8(document.body, {
        background: "black"
      }) : Qft, P8(l, {
        transformOrigin: ar(t) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${Pn.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${Pn.EASE.join(",")})`
      }));
      const c = P8(l, {
        borderRadius: `${kW}px`,
        overflow: "hidden",
        ...ar(t) ? {
          transform: `scale(${s()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${s()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        c(), a.current = window.setTimeout(() => {
          o ? document.body.style.background = o : document.body.style.removeProperty("background");
        }, Pn.DURATION * 1e3);
      };
    }
  }, [
    e,
    n,
    o
  ]);
}
let cf = null;
function eht({ isOpen: t, modal: e, nested: n, hasBeenOpened: r, preventScrollRestoration: i, noBodyStyles: a }) {
  const [o, s] = Ce.useState(() => typeof window < "u" ? window.location.href : ""), l = Ce.useRef(0), c = Ce.useCallback(() => {
    if (wN() && cf === null && t && !a) {
      cf = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: d, innerHeight: f } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-l.current}px`,
        left: `${-d}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const h = f - window.innerHeight;
        h && l.current >= f && (document.body.style.top = `${-(l.current + h)}px`);
      }), 300);
    }
  }, [
    t
  ]), u = Ce.useCallback(() => {
    if (wN() && cf !== null && !a) {
      const d = -parseInt(document.body.style.top, 10), f = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, cf), window.requestAnimationFrame(() => {
        if (i && o !== window.location.href) {
          s(window.location.href);
          return;
        }
        window.scrollTo(f, d);
      }), cf = null;
    }
  }, [
    o
  ]);
  return Ce.useEffect(() => {
    function d() {
      l.current = window.scrollY;
    }
    return d(), window.addEventListener("scroll", d), () => {
      window.removeEventListener("scroll", d);
    };
  }, []), Ce.useEffect(() => {
    if (e)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || u();
      };
  }, [
    e,
    u
  ]), Ce.useEffect(() => {
    n || !r || (t ? (!window.matchMedia("(display-mode: standalone)").matches && c(), e || window.setTimeout(() => {
      u();
    }, 500)) : u());
  }, [
    t,
    r,
    o,
    e,
    n,
    c,
    u
  ]), {
    restorePositionSetting: u
  };
}
function tht({ open: t, onOpenChange: e, children: n, onDrag: r, onRelease: i, snapPoints: a, shouldScaleBackground: o = !1, setBackgroundColorOnScale: s = !0, closeThreshold: l = Yft, scrollLockTimeout: c = Kft, dismissible: u = !0, handleOnly: d = !1, fadeFromIndex: f = a && a.length - 1, activeSnapPoint: h, setActiveSnapPoint: p, fixed: m, modal: g = !0, onClose: v, nested: k, noBodyStyles: w = !1, direction: b = "bottom", defaultOpen: x = !1, disablePreventScroll: A = !0, snapToSequentialPoint: L = !1, preventScrollRestoration: M = !1, repositionInputs: j = !0, onAnimationEnd: D, container: z, autoFocus: H = !1 }) {
  var V, F;
  const [_ = !1, W] = MW({
    defaultProp: x,
    prop: t,
    onChange: (Be) => {
      e == null || e(Be), !Be && !k && ve(), setTimeout(() => {
        D == null || D(Be);
      }, Pn.DURATION * 1e3), Be && !g && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), Be || (document.body.style.pointerEvents = "auto");
    }
  }), [G, Y] = Ce.useState(!1), [Z, oe] = Ce.useState(!1), [ee, ae] = Ce.useState(!1), fe = Ce.useRef(null), me = Ce.useRef(null), ge = Ce.useRef(null), $ = Ce.useRef(null), se = Ce.useRef(null), xe = Ce.useRef(!1), Oe = Ce.useRef(null), je = Ce.useRef(0), Me = Ce.useRef(!1), he = Ce.useRef(!x), pe = Ce.useRef(0), J = Ce.useRef(null), K = Ce.useRef(((V = J.current) == null ? void 0 : V.getBoundingClientRect().height) || 0), X = Ce.useRef(((F = J.current) == null ? void 0 : F.getBoundingClientRect().width) || 0), re = Ce.useRef(0), Ie = Ce.useCallback((Be) => {
    a && Be === ne.length - 1 && (me.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: q, activeSnapPointIndex: S, setActiveSnapPoint: P, onRelease: O, snapPointsOffset: ne, onDrag: le, shouldFade: de, getPercentageDragged: Pe } = Jft({
    snapPoints: a,
    activeSnapPointProp: h,
    setActiveSnapPointProp: p,
    drawerRef: J,
    fadeFromIndex: f,
    overlayRef: fe,
    onSnapPointChange: Ie,
    direction: b,
    container: z,
    snapToSequentialPoint: L
  });
  Fft({
    isDisabled: !_ || Z || !g || ee || !G || !j || !A
  });
  const { restorePositionSetting: ve } = eht({
    isOpen: _,
    modal: g,
    nested: k ?? !1,
    hasBeenOpened: G,
    preventScrollRestoration: M,
    noBodyStyles: w
  });
  function Le() {
    return (window.innerWidth - p9) / window.innerWidth;
  }
  function Re(Be) {
    var et, dt;
    !u && !a || J.current && !J.current.contains(Be.target) || (K.current = ((et = J.current) == null ? void 0 : et.getBoundingClientRect().height) || 0, X.current = ((dt = J.current) == null ? void 0 : dt.getBoundingClientRect().width) || 0, oe(!0), ge.current = /* @__PURE__ */ new Date(), yW() && window.addEventListener("touchend", () => xe.current = !1, {
      once: !0
    }), Be.target.setPointerCapture(Be.pointerId), je.current = ar(b) ? Be.pageY : Be.pageX);
  }
  function Ke(Be, et) {
    var dt;
    let ut = Be;
    const Pt = (dt = window.getSelection()) == null ? void 0 : dt.toString(), Vt = J.current ? Nm(J.current, b) : null, kt = /* @__PURE__ */ new Date();
    if (ut.tagName === "SELECT" || ut.hasAttribute("data-vaul-no-drag") || ut.closest("[data-vaul-no-drag]"))
      return !1;
    if (b === "right" || b === "left")
      return !0;
    if (me.current && kt.getTime() - me.current.getTime() < 500)
      return !1;
    if (Vt !== null && (b === "bottom" ? Vt > 0 : Vt < 0))
      return !0;
    if (Pt && Pt.length > 0)
      return !1;
    if (se.current && kt.getTime() - se.current.getTime() < c && Vt === 0 || et)
      return se.current = kt, !1;
    for (; ut; ) {
      if (ut.scrollHeight > ut.clientHeight) {
        if (ut.scrollTop !== 0)
          return se.current = /* @__PURE__ */ new Date(), !1;
        if (ut.getAttribute("role") === "dialog")
          return !0;
      }
      ut = ut.parentNode;
    }
    return !0;
  }
  function mt(Be) {
    if (J.current && Z) {
      const et = b === "bottom" || b === "right" ? 1 : -1, dt = (je.current - (ar(b) ? Be.pageY : Be.pageX)) * et, ut = dt > 0, Pt = a && !u && !ut;
      if (Pt && S === 0) return;
      const Vt = Math.abs(dt), kt = document.querySelector("[data-vaul-drawer-wrapper]"), sn = b === "bottom" || b === "top" ? K.current : X.current;
      let Sn = Vt / sn;
      const ht = Pe(Vt, ut);
      if (ht !== null && (Sn = ht), Pt && Sn >= 1 || !xe.current && !Ke(Be.target, ut)) return;
      if (J.current.classList.add(z8), xe.current = !0, dr(J.current, {
        transition: "none"
      }), dr(fe.current, {
        transition: "none"
      }), a && le({
        draggedDistance: dt
      }), ut && !a) {
        const Jn = Zft(dt), Er = Math.min(Jn * -1, 0) * et;
        dr(J.current, {
          transform: ar(b) ? `translate3d(0, ${Er}px, 0)` : `translate3d(${Er}px, 0, 0)`
        });
        return;
      }
      const gn = 1 - Sn;
      if ((de || f && S === f - 1) && (r == null || r(Be, Sn), dr(fe.current, {
        opacity: `${gn}`,
        transition: "none"
      }, !0)), kt && fe.current && o) {
        const Jn = Math.min(Le() + Sn * (1 - Le()), 1), Er = 8 - Sn * 8, ca = Math.max(0, 14 - Sn * 14);
        dr(kt, {
          borderRadius: `${Er}px`,
          transform: ar(b) ? `scale(${Jn}) translate3d(0, ${ca}px, 0)` : `scale(${Jn}) translate3d(${ca}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!a) {
        const Jn = Vt * et;
        dr(J.current, {
          transform: ar(b) ? `translate3d(0, ${Jn}px, 0)` : `translate3d(${Jn}px, 0, 0)`
        });
      }
    }
  }
  Ce.useEffect(() => {
    window.requestAnimationFrame(() => {
      he.current = !0;
    });
  }, []), Ce.useEffect(() => {
    var Be;
    function et() {
      if (!J.current || !j) return;
      const dt = document.activeElement;
      if (h9(dt) || Me.current) {
        var ut;
        const Pt = ((ut = window.visualViewport) == null ? void 0 : ut.height) || 0, Vt = window.innerHeight;
        let kt = Vt - Pt;
        const sn = J.current.getBoundingClientRect().height || 0, Sn = sn > Vt * 0.8;
        re.current || (re.current = sn);
        const ht = J.current.getBoundingClientRect().top;
        if (Math.abs(pe.current - kt) > 60 && (Me.current = !Me.current), a && a.length > 0 && ne && S) {
          const gn = ne[S] || 0;
          kt += gn;
        }
        if (pe.current = kt, sn > Pt || Me.current) {
          const gn = J.current.getBoundingClientRect().height;
          let Jn = gn;
          gn > Pt && (Jn = Pt - (Sn ? ht : p9)), m ? J.current.style.height = `${gn - Math.max(kt, 0)}px` : J.current.style.height = `${Math.max(Jn, Pt - ht)}px`;
        } else Ift() || (J.current.style.height = `${re.current}px`);
        a && a.length > 0 && !Me.current ? J.current.style.bottom = "0px" : J.current.style.bottom = `${Math.max(kt, 0)}px`;
      }
    }
    return (Be = window.visualViewport) == null || Be.addEventListener("resize", et), () => {
      var dt;
      return (dt = window.visualViewport) == null ? void 0 : dt.removeEventListener("resize", et);
    };
  }, [
    S,
    a,
    ne
  ]);
  function pt(Be) {
    ye(), v == null || v(), Be || W(!1), setTimeout(() => {
      a && P(a[0]);
    }, Pn.DURATION * 1e3);
  }
  function Nt() {
    if (!J.current) return;
    const Be = document.querySelector("[data-vaul-drawer-wrapper]"), et = Nm(J.current, b);
    dr(J.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${Pn.DURATION}s cubic-bezier(${Pn.EASE.join(",")})`
    }), dr(fe.current, {
      transition: `opacity ${Pn.DURATION}s cubic-bezier(${Pn.EASE.join(",")})`,
      opacity: "1"
    }), o && et && et > 0 && _ && dr(Be, {
      borderRadius: `${kW}px`,
      overflow: "hidden",
      ...ar(b) ? {
        transform: `scale(${Le()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Le()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${Pn.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${Pn.EASE.join(",")})`
    }, !0);
  }
  function ye() {
    !Z || !J.current || (J.current.classList.remove(z8), xe.current = !1, oe(!1), $.current = /* @__PURE__ */ new Date());
  }
  function _e(Be) {
    if (!Z || !J.current) return;
    J.current.classList.remove(z8), xe.current = !1, oe(!1), $.current = /* @__PURE__ */ new Date();
    const et = Nm(J.current, b);
    if (!Be || !Ke(Be.target, !1) || !et || Number.isNaN(et) || ge.current === null) return;
    const dt = $.current.getTime() - ge.current.getTime(), ut = je.current - (ar(b) ? Be.pageY : Be.pageX), Pt = Math.abs(ut) / dt;
    if (Pt > 0.05 && (ae(!0), setTimeout(() => {
      ae(!1);
    }, 200)), a) {
      O({
        draggedDistance: ut * (b === "bottom" || b === "right" ? 1 : -1),
        closeDrawer: pt,
        velocity: Pt,
        dismissible: u
      }), i == null || i(Be, !0);
      return;
    }
    if (b === "bottom" || b === "right" ? ut > 0 : ut < 0) {
      Nt(), i == null || i(Be, !0);
      return;
    }
    if (Pt > wW) {
      pt(), i == null || i(Be, !1);
      return;
    }
    var Vt;
    const kt = Math.min((Vt = J.current.getBoundingClientRect().height) != null ? Vt : 0, window.innerHeight);
    var sn;
    const Sn = Math.min((sn = J.current.getBoundingClientRect().width) != null ? sn : 0, window.innerWidth), ht = b === "left" || b === "right";
    if (Math.abs(et) >= (ht ? Sn : kt) * l) {
      pt(), i == null || i(Be, !1);
      return;
    }
    i == null || i(Be, !0), Nt();
  }
  Ce.useEffect(() => (_ && (dr(document.documentElement, {
    scrollBehavior: "auto"
  }), me.current = /* @__PURE__ */ new Date()), () => {
    Wft(document.documentElement, "scrollBehavior");
  }), [
    _
  ]);
  function we(Be) {
    const et = Be ? (window.innerWidth - Dm) / window.innerWidth : 1, dt = Be ? -16 : 0;
    Oe.current && window.clearTimeout(Oe.current), dr(J.current, {
      transition: `transform ${Pn.DURATION}s cubic-bezier(${Pn.EASE.join(",")})`,
      transform: ar(b) ? `scale(${et}) translate3d(0, ${dt}px, 0)` : `scale(${et}) translate3d(${dt}px, 0, 0)`
    }), !Be && J.current && (Oe.current = setTimeout(() => {
      const ut = Nm(J.current, b);
      dr(J.current, {
        transition: "none",
        transform: ar(b) ? `translate3d(0, ${ut}px, 0)` : `translate3d(${ut}px, 0, 0)`
      });
    }, 500));
  }
  function $e(Be, et) {
    if (et < 0) return;
    const dt = (window.innerWidth - Dm) / window.innerWidth, ut = dt + et * (1 - dt), Pt = -16 + et * Dm;
    dr(J.current, {
      transform: ar(b) ? `scale(${ut}) translate3d(0, ${Pt}px, 0)` : `scale(${ut}) translate3d(${Pt}px, 0, 0)`,
      transition: "none"
    });
  }
  function Xe(Be, et) {
    const dt = ar(b) ? window.innerHeight : window.innerWidth, ut = et ? (dt - Dm) / dt : 1, Pt = et ? -16 : 0;
    et && dr(J.current, {
      transition: `transform ${Pn.DURATION}s cubic-bezier(${Pn.EASE.join(",")})`,
      transform: ar(b) ? `scale(${ut}) translate3d(0, ${Pt}px, 0)` : `scale(${ut}) translate3d(${Pt}px, 0, 0)`
    });
  }
  return Ce.useEffect(() => {
    g || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    g
  ]), /* @__PURE__ */ Ce.createElement(RM, {
    defaultOpen: x,
    onOpenChange: (Be) => {
      !u && !Be || (Be ? Y(!0) : pt(!0), W(Be));
    },
    open: _
  }, /* @__PURE__ */ Ce.createElement(mW.Provider, {
    value: {
      activeSnapPoint: q,
      snapPoints: a,
      setActiveSnapPoint: P,
      drawerRef: J,
      overlayRef: fe,
      onOpenChange: e,
      onPress: Re,
      onRelease: _e,
      onDrag: mt,
      dismissible: u,
      shouldAnimate: he,
      handleOnly: d,
      isOpen: _,
      isDragging: Z,
      shouldFade: de,
      closeDrawer: pt,
      onNestedDrag: $e,
      onNestedOpenChange: we,
      onNestedRelease: Xe,
      keyboardIsOpen: Me,
      modal: g,
      snapPointsOffset: ne,
      activeSnapPointIndex: S,
      direction: b,
      shouldScaleBackground: o,
      setBackgroundColorOnScale: s,
      noBodyStyles: w,
      container: z,
      autoFocus: H
    }
  }, n));
}
const CW = /* @__PURE__ */ Ce.forwardRef(function({ ...t }, e) {
  const { overlayRef: n, snapPoints: r, onRelease: i, shouldFade: a, isOpen: o, modal: s, shouldAnimate: l } = wp(), c = vW(e, n), u = r && r.length > 0;
  if (!s)
    return null;
  const d = Ce.useCallback((f) => i(f), [
    i
  ]);
  return /* @__PURE__ */ Ce.createElement(mp, {
    onMouseUp: d,
    ref: c,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": o && u ? "true" : "false",
    "data-vaul-snap-points-overlay": o && a ? "true" : "false",
    "data-vaul-animate": l != null && l.current ? "true" : "false",
    ...t
  });
});
CW.displayName = "Drawer.Overlay";
const AW = /* @__PURE__ */ Ce.forwardRef(function({ onPointerDownOutside: t, style: e, onOpenAutoFocus: n, ...r }, i) {
  const { drawerRef: a, onPress: o, onRelease: s, onDrag: l, keyboardIsOpen: c, snapPointsOffset: u, activeSnapPointIndex: d, modal: f, isOpen: h, direction: p, snapPoints: m, container: g, handleOnly: v, shouldAnimate: k, autoFocus: w } = wp(), [b, x] = Ce.useState(!1), A = vW(i, a), L = Ce.useRef(null), M = Ce.useRef(null), j = Ce.useRef(!1), D = m && m.length > 0;
  Xft();
  const z = (V, F, _ = 0) => {
    if (j.current) return !0;
    const W = Math.abs(V.y), G = Math.abs(V.x), Y = G > W, Z = [
      "bottom",
      "right"
    ].includes(F) ? 1 : -1;
    if (F === "left" || F === "right") {
      if (!(V.x * Z < 0) && G >= 0 && G <= _)
        return Y;
    } else if (!(V.y * Z < 0) && W >= 0 && W <= _)
      return !Y;
    return j.current = !0, !0;
  };
  Ce.useEffect(() => {
    D && window.requestAnimationFrame(() => {
      x(!0);
    });
  }, []);
  function H(V) {
    L.current = null, j.current = !1, s(V);
  }
  return /* @__PURE__ */ Ce.createElement(yp, {
    "data-vaul-drawer-direction": p,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": b ? "true" : "false",
    "data-vaul-snap-points": h && D ? "true" : "false",
    "data-vaul-custom-container": g ? "true" : "false",
    "data-vaul-animate": k != null && k.current ? "true" : "false",
    ...r,
    ref: A,
    style: u && u.length > 0 ? {
      "--snap-point-height": `${u[d ?? 0]}px`,
      ...e
    } : e,
    onPointerDown: (V) => {
      v || (r.onPointerDown == null || r.onPointerDown.call(r, V), L.current = {
        x: V.pageX,
        y: V.pageY
      }, o(V));
    },
    onOpenAutoFocus: (V) => {
      n == null || n(V), w || V.preventDefault();
    },
    onPointerDownOutside: (V) => {
      if (t == null || t(V), !f || V.defaultPrevented) {
        V.preventDefault();
        return;
      }
      c.current && (c.current = !1);
    },
    onFocusOutside: (V) => {
      if (!f) {
        V.preventDefault();
        return;
      }
    },
    onPointerMove: (V) => {
      if (M.current = V, v || (r.onPointerMove == null || r.onPointerMove.call(r, V), !L.current)) return;
      const F = V.pageY - L.current.y, _ = V.pageX - L.current.x, W = V.pointerType === "touch" ? 10 : 2;
      z({
        x: _,
        y: F
      }, p, W) ? l(V) : (Math.abs(_) > W || Math.abs(F) > W) && (L.current = null);
    },
    onPointerUp: (V) => {
      r.onPointerUp == null || r.onPointerUp.call(r, V), L.current = null, j.current = !1, s(V);
    },
    onPointerOut: (V) => {
      r.onPointerOut == null || r.onPointerOut.call(r, V), H(M.current);
    },
    onContextMenu: (V) => {
      r.onContextMenu == null || r.onContextMenu.call(r, V), M.current && H(M.current);
    }
  });
});
AW.displayName = "Drawer.Content";
const nht = 250, rht = 120, iht = /* @__PURE__ */ Ce.forwardRef(function({ preventCycle: t = !1, children: e, ...n }, r) {
  const { closeDrawer: i, isDragging: a, snapPoints: o, activeSnapPoint: s, setActiveSnapPoint: l, dismissible: c, handleOnly: u, isOpen: d, onPress: f, onDrag: h } = wp(), p = Ce.useRef(null), m = Ce.useRef(!1);
  function g() {
    if (m.current) {
      w();
      return;
    }
    window.setTimeout(() => {
      v();
    }, rht);
  }
  function v() {
    if (a || t || m.current) {
      w();
      return;
    }
    if (w(), !o || o.length === 0) {
      c || i();
      return;
    }
    if (s === o[o.length - 1] && c) {
      i();
      return;
    }
    const b = o.findIndex((A) => A === s);
    if (b === -1) return;
    const x = o[b + 1];
    l(x);
  }
  function k() {
    p.current = window.setTimeout(() => {
      m.current = !0;
    }, nht);
  }
  function w() {
    p.current && window.clearTimeout(p.current), m.current = !1;
  }
  return /* @__PURE__ */ Ce.createElement("div", {
    onClick: g,
    onPointerCancel: w,
    onPointerDown: (b) => {
      u && f(b), k();
    },
    onPointerMove: (b) => {
      u && h(b);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": d ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ Ce.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, e));
});
iht.displayName = "Drawer.Handle";
function aht(t) {
  const e = wp(), { container: n = e.container, ...r } = t;
  return /* @__PURE__ */ Ce.createElement(OM, {
    container: n,
    ...r
  });
}
const go = {
  Root: tht,
  Content: AW,
  Overlay: CW,
  Trigger: N1t,
  Portal: aht,
  Close: n6,
  Title: gp,
  Description: vp
}, oht = RM, sht = OM, SW = n6, LW = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  mp,
  {
    ref: n,
    className: un(
      "fixed inset-0 z-50 color-utility-overlay data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      t
    ),
    ...e
  }
));
LW.displayName = mp.displayName;
const TW = N.forwardRef(
  ({
    className: t,
    children: e,
    hasCloseIcon: n,
    dismissable: r = !0,
    overlayClasses: i,
    ...a
  }, o) => /* @__PURE__ */ T.jsxs(sht, { children: [
    /* @__PURE__ */ T.jsx(LW, { className: i }),
    /* @__PURE__ */ T.jsx(jd, { trapped: !1, children: /* @__PURE__ */ T.jsxs(
      yp,
      {
        ref: o,
        onInteractOutside: (s) => {
          r || s.preventDefault();
        },
        className: un(
          "max-w-lg fixed left-[50%] top-[50%] z-50 grid w-full translate-x-[-50%] translate-y-[-50%] gap-3 border color-bg-default shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] rounded sm:rounded-lg",
          t
        ),
        ...a,
        children: [
          e,
          n && /* @__PURE__ */ T.jsx(SW, { className: "absolute top-3 right-4 rounded-sm ring-offset-white hover:color-bg-default-hover p-1 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused focus-visible:ring-offset-2 disabled:pointer-events-none data-[state=open]:color-bg-default-selected data-[state=open]:color-text-default", children: /* @__PURE__ */ T.jsx(Ye, { name: "X", className: "h-5 w-5" }) })
        ]
      }
    ) })
  ] })
);
TW.displayName = yp.displayName;
const EW = ({
  className: t,
  ...e
}) => /* @__PURE__ */ T.jsx("div", { className: un("flex flex-col space-y-1.5 text-left", t), ...e });
EW.displayName = "DialogHeader";
const jW = ({
  className: t,
  ...e
}) => /* @__PURE__ */ T.jsx(
  "div",
  {
    className: un(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      t
    ),
    ...e
  }
);
jW.displayName = "DialogFooter";
const NW = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  gp,
  {
    ref: n,
    className: un("text-heading-md", t),
    ...e
  }
));
NW.displayName = gp.displayName;
const DW = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  vp,
  {
    ref: n,
    className: un("text-body-sm color-text-secondary", t),
    ...e
  }
));
DW.displayName = vp.displayName;
const kp = ({
  shouldScaleBackground: t = !0,
  ...e
}) => /* @__PURE__ */ T.jsx(go.Root, { shouldScaleBackground: t, ...e });
kp.displayName = "Drawer";
const CN = go.Trigger, lht = go.Portal, s6 = go.Close, IW = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  go.Overlay,
  {
    ref: n,
    className: un(
      "fixed inset-0 z-50 color-utility-overlay data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      t
    ),
    ...e
  }
));
IW.displayName = go.Overlay.displayName;
const l6 = N.forwardRef(
  ({ className: t, children: e, hasCloseIcon: n, overlayClasses: r, onClose: i, ...a }, o) => /* @__PURE__ */ T.jsxs(lht, { children: [
    /* @__PURE__ */ T.jsx(IW, { className: r }),
    /* @__PURE__ */ T.jsx(jd, { trapped: !1, children: /* @__PURE__ */ T.jsxs(
      go.Content,
      {
        ref: o,
        className: un(
          "fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col gap-4 rounded-t-[10px] border color-bg-default",
          t
        ),
        ...a,
        children: [
          e,
          n && /* @__PURE__ */ T.jsx(
            s6,
            {
              onClick: () => i == null ? void 0 : i(!1),
              className: "absolute top-3 right-4 rounded-sm ring-offset-white hover:color-bg-default-hover p-1 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused focus-visible:ring-offset-2 disabled:pointer-events-none data-[state=open]:color-bg-default-selected data-[state=open]:color-text-default",
              children: /* @__PURE__ */ T.jsx(Ye, { name: "X", className: "h-5 w-5" })
            }
          )
        ]
      }
    ) })
  ] })
);
l6.displayName = "DrawerContent";
const c6 = ({
  className: t,
  ...e
}) => /* @__PURE__ */ T.jsx("div", { className: un("flex flex-col space-y-1.5 text-left", t), ...e });
c6.displayName = "DrawerHeader";
const QM = ({
  className: t,
  ...e
}) => /* @__PURE__ */ T.jsx("div", { className: un("flex gap-2", t), ...e });
QM.displayName = "DrawerFooter";
const u6 = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  go.Title,
  {
    ref: n,
    className: un("text-heading-md", t),
    ...e
  }
));
u6.displayName = go.Title.displayName;
const XM = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  go.Description,
  {
    ref: n,
    className: un("text-body-sm color-text-secondary", t),
    ...e
  }
));
XM.displayName = go.Description.displayName;
var cht = typeof gm == "object" && gm && gm.Object === Object && gm, uht = typeof self == "object" && self && self.Object === Object && self;
cht || uht || Function("return this")();
var dht = typeof window < "u" ? us : ze, fht = typeof window > "u";
function hht(t, {
  defaultValue: e = !1,
  initializeWithValue: n = !0
} = {}) {
  const r = (s) => fht ? e : window.matchMedia(s).matches, [i, a] = De(() => n ? r(t) : e);
  function o() {
    a(r(t));
  }
  return dht(() => {
    const s = window.matchMedia(t);
    return o(), s.addListener ? s.addListener(o) : s.addEventListener("change", o), () => {
      s.removeListener ? s.removeListener(o) : s.removeEventListener("change", o);
    };
  }, [t]), i;
}
const PW = ({
  open: t,
  onOpenChange: e,
  title: n,
  description: r,
  content: i,
  primaryAction: a,
  secondaryAction: o,
  className: s,
  contentClassName: l,
  disableOutsideClick: c,
  hasCloseIcon: u,
  overlayClasses: d,
  noOverlay: f
}) => hht("(max-width: 768px)") ? /* @__PURE__ */ T.jsx(
  kp,
  {
    dismissible: !c,
    open: t,
    onOpenChange: (h) => {
      c || e(h);
    },
    children: /* @__PURE__ */ T.jsxs(
      l6,
      {
        className: un("w-full pb-4", s),
        hasCloseIcon: u,
        onClose: e,
        overlayClasses: un(d, { "bg-transparent": f }),
        children: [
          n && /* @__PURE__ */ T.jsx(c6, { className: "px-4 pt-4", children: /* @__PURE__ */ T.jsx(u6, { className: "text-left text-heading-md", children: n }) }),
          /* @__PURE__ */ T.jsxs(
            "div",
            {
              className: un(
                "flex flex-col gap-4 w-full h-full border-t-[1px] text-body-sm color-text-default",
                {
                  "px-4 pt-4 pb-2": !l
                },
                l
              ),
              children: [
                /* @__PURE__ */ T.jsx(XM, { className: "hidden" }),
                r && /* @__PURE__ */ T.jsx("p", { children: r }),
                i && i
              ]
            }
          ),
          (o || a) && /* @__PURE__ */ T.jsxs(QM, { className: "px-6 gap-2 w-full", children: [
            o && /* @__PURE__ */ T.jsx(s6, { asChild: !0, children: /* @__PURE__ */ T.jsx(
              Kt,
              {
                disabled: o == null ? void 0 : o.isLoading,
                isLoading: o == null ? void 0 : o.isLoading,
                className: o == null ? void 0 : o.className,
                variant: (o == null ? void 0 : o.variant) || "ghost",
                onClick: o == null ? void 0 : o.onClick,
                children: o == null ? void 0 : o.label
              }
            ) }),
            a && /* @__PURE__ */ T.jsx(
              Kt,
              {
                disabled: a == null ? void 0 : a.isLoading,
                isLoading: a == null ? void 0 : a.isLoading,
                className: a == null ? void 0 : a.className,
                variant: (a == null ? void 0 : a.variant) || "default",
                onClick: a == null ? void 0 : a.onClick,
                children: a == null ? void 0 : a.label
              }
            )
          ] })
        ]
      }
    )
  }
) : /* @__PURE__ */ T.jsx(oht, { open: t, onOpenChange: e, children: /* @__PURE__ */ T.jsxs(
  TW,
  {
    className: un("pb-4", s),
    dismissable: !c,
    hasCloseIcon: u,
    overlayClasses: un(d, { "bg-transparent": f }),
    children: [
      n && /* @__PURE__ */ T.jsx(EW, { className: "px-4 pt-4", children: /* @__PURE__ */ T.jsx(NW, { className: "text-heading-md", children: n }) }),
      /* @__PURE__ */ T.jsxs(
        "div",
        {
          className: un(
            "flex flex-col gap-2 w-full h-full border-t-[1px] text-body-sm color-text-default",
            {
              "px-4 pt-4 pb-2": !l
            },
            l
          ),
          children: [
            /* @__PURE__ */ T.jsx(DW, { className: "hidden" }),
            r && /* @__PURE__ */ T.jsx("p", { children: r }),
            i && i
          ]
        }
      ),
      (o || a) && /* @__PURE__ */ T.jsxs(jW, { className: "px-4 gap-2", children: [
        o && /* @__PURE__ */ T.jsx(SW, { asChild: !0, children: /* @__PURE__ */ T.jsx(
          Kt,
          {
            disabled: o == null ? void 0 : o.isLoading,
            isLoading: o == null ? void 0 : o.isLoading,
            className: o == null ? void 0 : o.className,
            variant: (o == null ? void 0 : o.variant) || "ghost",
            onClick: o == null ? void 0 : o.onClick,
            children: o == null ? void 0 : o.label
          }
        ) }),
        a && /* @__PURE__ */ T.jsx(
          Kt,
          {
            disabled: a == null ? void 0 : a.isLoading,
            isLoading: a == null ? void 0 : a.isLoading,
            className: a == null ? void 0 : a.className,
            variant: (a == null ? void 0 : a.variant) || "default",
            onClick: a == null ? void 0 : a.onClick,
            children: a == null ? void 0 : a.label
          }
        )
      ] })
    ]
  }
) });
var eC = "Collapsible", [pht, zW] = ei(eC), [mht, tC] = pht(eC), RW = N.forwardRef(
  (t, e) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: i,
      disabled: a,
      onOpenChange: o,
      ...s
    } = t, [l = !1, c] = mo({
      prop: r,
      defaultProp: i,
      onChange: o
    });
    return /* @__PURE__ */ T.jsx(
      mht,
      {
        scope: n,
        disabled: a,
        contentId: Xa(),
        open: l,
        onOpenToggle: N.useCallback(() => c((u) => !u), [c]),
        children: /* @__PURE__ */ T.jsx(
          Ct.div,
          {
            "data-state": rC(l),
            "data-disabled": a ? "" : void 0,
            ...s,
            ref: e
          }
        )
      }
    );
  }
);
RW.displayName = eC;
var OW = "CollapsibleTrigger", BW = N.forwardRef(
  (t, e) => {
    const { __scopeCollapsible: n, ...r } = t, i = tC(OW, n);
    return /* @__PURE__ */ T.jsx(
      Ct.button,
      {
        type: "button",
        "aria-controls": i.contentId,
        "aria-expanded": i.open || !1,
        "data-state": rC(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        disabled: i.disabled,
        ...r,
        ref: e,
        onClick: it(t.onClick, i.onOpenToggle)
      }
    );
  }
);
BW.displayName = OW;
var nC = "CollapsibleContent", HW = N.forwardRef(
  (t, e) => {
    const { forceMount: n, ...r } = t, i = tC(nC, t.__scopeCollapsible);
    return /* @__PURE__ */ T.jsx(zi, { present: n || i.open, children: ({ present: a }) => /* @__PURE__ */ T.jsx(yht, { ...r, ref: e, present: a }) });
  }
);
HW.displayName = nC;
var yht = N.forwardRef((t, e) => {
  const { __scopeCollapsible: n, present: r, children: i, ...a } = t, o = tC(nC, n), [s, l] = N.useState(r), c = N.useRef(null), u = Jt(e, c), d = N.useRef(0), f = d.current, h = N.useRef(0), p = h.current, m = o.open || s, g = N.useRef(m), v = N.useRef();
  return N.useEffect(() => {
    const k = requestAnimationFrame(() => g.current = !1);
    return () => cancelAnimationFrame(k);
  }, []), Fr(() => {
    const k = c.current;
    if (k) {
      v.current = v.current || {
        transitionDuration: k.style.transitionDuration,
        animationName: k.style.animationName
      }, k.style.transitionDuration = "0s", k.style.animationName = "none";
      const w = k.getBoundingClientRect();
      d.current = w.height, h.current = w.width, g.current || (k.style.transitionDuration = v.current.transitionDuration, k.style.animationName = v.current.animationName), l(r);
    }
  }, [o.open, r]), /* @__PURE__ */ T.jsx(
    Ct.div,
    {
      "data-state": rC(o.open),
      "data-disabled": o.disabled ? "" : void 0,
      id: o.contentId,
      hidden: !m,
      ...a,
      ref: u,
      style: {
        "--radix-collapsible-content-height": f ? `${f}px` : void 0,
        "--radix-collapsible-content-width": p ? `${p}px` : void 0,
        ...t.style
      },
      children: m && i
    }
  );
});
function rC(t) {
  return t ? "open" : "closed";
}
var ght = RW, vht = BW, bht = HW, Cl = "Accordion", wht = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [iC, kht, xht] = Yg(Cl), [d6, xGt] = ei(Cl, [
  xht,
  zW
]), aC = zW(), FW = Ce.forwardRef(
  (t, e) => {
    const { type: n, ...r } = t, i = r, a = r;
    return /* @__PURE__ */ T.jsx(iC.Provider, { scope: t.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ T.jsx(Sht, { ...a, ref: e }) : /* @__PURE__ */ T.jsx(Aht, { ...i, ref: e }) });
  }
);
FW.displayName = Cl;
var [_W, Mht] = d6(Cl), [VW, Cht] = d6(
  Cl,
  { collapsible: !1 }
), Aht = Ce.forwardRef(
  (t, e) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: i = () => {
      },
      collapsible: a = !1,
      ...o
    } = t, [s, l] = mo({
      prop: n,
      defaultProp: r,
      onChange: i
    });
    return /* @__PURE__ */ T.jsx(
      _W,
      {
        scope: t.__scopeAccordion,
        value: s ? [s] : [],
        onItemOpen: l,
        onItemClose: Ce.useCallback(() => a && l(""), [a, l]),
        children: /* @__PURE__ */ T.jsx(VW, { scope: t.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ T.jsx(qW, { ...o, ref: e }) })
      }
    );
  }
), Sht = Ce.forwardRef((t, e) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: i = () => {
    },
    ...a
  } = t, [o = [], s] = mo({
    prop: n,
    defaultProp: r,
    onChange: i
  }), l = Ce.useCallback(
    (u) => s((d = []) => [...d, u]),
    [s]
  ), c = Ce.useCallback(
    (u) => s((d = []) => d.filter((f) => f !== u)),
    [s]
  );
  return /* @__PURE__ */ T.jsx(
    _W,
    {
      scope: t.__scopeAccordion,
      value: o,
      onItemOpen: l,
      onItemClose: c,
      children: /* @__PURE__ */ T.jsx(VW, { scope: t.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ T.jsx(qW, { ...a, ref: e }) })
    }
  );
}), [Lht, f6] = d6(Cl), qW = Ce.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, disabled: r, dir: i, orientation: a = "vertical", ...o } = t, s = Ce.useRef(null), l = Jt(s, e), c = kht(n), u = Kg(i) === "ltr", d = it(t.onKeyDown, (f) => {
      var h;
      if (!wht.includes(f.key)) return;
      const p = f.target, m = c().filter((M) => {
        var j;
        return !((j = M.ref.current) != null && j.disabled);
      }), g = m.findIndex((M) => M.ref.current === p), v = m.length;
      if (g === -1) return;
      f.preventDefault();
      let k = g;
      const w = 0, b = v - 1, x = () => {
        k = g + 1, k > b && (k = w);
      }, A = () => {
        k = g - 1, k < w && (k = b);
      };
      switch (f.key) {
        case "Home":
          k = w;
          break;
        case "End":
          k = b;
          break;
        case "ArrowRight":
          a === "horizontal" && (u ? x() : A());
          break;
        case "ArrowDown":
          a === "vertical" && x();
          break;
        case "ArrowLeft":
          a === "horizontal" && (u ? A() : x());
          break;
        case "ArrowUp":
          a === "vertical" && A();
          break;
      }
      const L = k % v;
      (h = m[L].ref.current) == null || h.focus();
    });
    return /* @__PURE__ */ T.jsx(
      Lht,
      {
        scope: n,
        disabled: r,
        direction: i,
        orientation: a,
        children: /* @__PURE__ */ T.jsx(iC.Slot, { scope: n, children: /* @__PURE__ */ T.jsx(
          Ct.div,
          {
            ...o,
            "data-orientation": a,
            ref: l,
            onKeyDown: r ? void 0 : d
          }
        ) })
      }
    );
  }
), Vy = "AccordionItem", [Tht, oC] = d6(Vy), UW = Ce.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, value: r, ...i } = t, a = f6(Vy, n), o = Mht(Vy, n), s = aC(n), l = Xa(), c = r && o.value.includes(r) || !1, u = a.disabled || t.disabled;
    return /* @__PURE__ */ T.jsx(
      Tht,
      {
        scope: n,
        open: c,
        disabled: u,
        triggerId: l,
        children: /* @__PURE__ */ T.jsx(
          ght,
          {
            "data-orientation": a.orientation,
            "data-state": $W(c),
            ...s,
            ...i,
            ref: e,
            disabled: u,
            open: c,
            onOpenChange: (d) => {
              d ? o.onItemOpen(r) : o.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
UW.displayName = Vy;
var WW = "AccordionHeader", ZW = Ce.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, ...r } = t, i = f6(Cl, n), a = oC(WW, n);
    return /* @__PURE__ */ T.jsx(
      Ct.h3,
      {
        "data-orientation": i.orientation,
        "data-state": $W(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: e
      }
    );
  }
);
ZW.displayName = WW;
var m9 = "AccordionTrigger", GW = Ce.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, ...r } = t, i = f6(Cl, n), a = oC(m9, n), o = Cht(m9, n), s = aC(n);
    return /* @__PURE__ */ T.jsx(iC.ItemSlot, { scope: n, children: /* @__PURE__ */ T.jsx(
      vht,
      {
        "aria-disabled": a.open && !o.collapsible || void 0,
        "data-orientation": i.orientation,
        id: a.triggerId,
        ...s,
        ...r,
        ref: e
      }
    ) });
  }
);
GW.displayName = m9;
var YW = "AccordionContent", KW = Ce.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, ...r } = t, i = f6(Cl, n), a = oC(YW, n), o = aC(n);
    return /* @__PURE__ */ T.jsx(
      bht,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": i.orientation,
        ...o,
        ...r,
        ref: e,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...t.style
        }
      }
    );
  }
);
KW.displayName = YW;
function $W(t) {
  return t ? "open" : "closed";
}
var Eht = FW, jht = UW, Nht = ZW, JW = GW, QW = KW;
const Dht = Ha("", {
  variants: {
    size: {
      sm: "py-1",
      md: "py-2",
      lg: "py-3"
    },
    disabled: {
      true: "cursor-not-allowed disabled:color-text-disabled",
      false: ""
    }
  },
  defaultVariants: {
    size: "md",
    disabled: !1
  }
}), Iht = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  Eht,
  {
    ref: n,
    className: be("w-[400px]", t),
    ...e
  }
));
Iht.displayName = "Accordion";
const Pht = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  jht,
  {
    ref: n,
    className: be("border-b", t),
    ...e
  }
));
Pht.displayName = "AccordionItem";
const zht = N.forwardRef(({ className: t, children: e, size: n, disabled: r, ...i }, a) => /* @__PURE__ */ T.jsx(Nht, { className: "flex", children: /* @__PURE__ */ T.jsxs(
  JW,
  {
    ref: a,
    className: be(
      "flex flex-1 items-center justify-between px-4 color-text-default text-heading-xsm transition-all hover:color-bg-default-hover [&[data-state=open]>svg]:rotate-180",
      Dht({ size: n, disabled: r }),
      t
    ),
    disabled: r,
    ...i,
    children: [
      e,
      /* @__PURE__ */ T.jsx(
        Ig,
        {
          className: be(
            "h-4 w-4 shrink-0 color-text-default transition-transform duration-200",
            r ? "color-text-disabled" : "color-text-default"
          )
        }
      )
    ]
  }
) }));
zht.displayName = JW.displayName;
const Rht = N.forwardRef(({ className: t, children: e, ...n }, r) => /* @__PURE__ */ T.jsx(
  QW,
  {
    ref: r,
    className: "px-4 overflow-hidden text-body-sm color-text-default data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
    ...n,
    children: /* @__PURE__ */ T.jsx("div", { className: be("pb-6 pt-2", t), children: e })
  }
));
Rht.displayName = QW.displayName;
const XW = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  zU,
  {
    className: be("grid gap-2", t),
    ...e,
    ref: n
  }
));
XW.displayName = zU.displayName;
const eZ = N.forwardRef(({ className: t, disabled: e, size: n, ...r }, i) => /* @__PURE__ */ T.jsx(
  RU,
  {
    ref: i,
    className: be(
      "flex items-center justify-center aspect-square rounded-full border-2 color-border-active color-text-default hover:color-bg-default-hover transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-focused focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:color-border-disabled",
      {
        "w-[16px]": n === "sm",
        "w-[20px]": n === "lg"
      },
      t
    ),
    disabled: e,
    ...r,
    children: /* @__PURE__ */ T.jsx(
      Gdt,
      {
        className: be(
          "rounded-full aspect-square flex items-center justify-center",
          e ? "color-icon-disabled dark:color-bg-disabled" : "color-bg-default-inverse",
          {
            "w-[8px]": n === "sm",
            "w-[12px]": n === "lg"
          }
        )
      }
    )
  }
));
eZ.displayName = RU.displayName;
const Oht = ({
  id: t,
  label: e,
  description: n,
  selectedValue: r,
  value: i,
  content: a,
  size: o
}) => {
  const s = Ue(null), l = () => {
    s.current && s.current.click();
  };
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(
      Ru.div,
      {
        initial: !1,
        className: be(
          "flex items-center p-4 border color-border-default rounded-lg cursor-pointer transition-colors",
          r === i ? "color-bg-default-selected" : "color-bg-default"
        ),
        onClick: l,
        children: /* @__PURE__ */ T.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ T.jsxs(
            "span",
            {
              className: be(
                "inline-flex items-center",
                o === "lg" ? "gap-2" : "gap-1"
              ),
              children: [
                /* @__PURE__ */ T.jsx(
                  eZ,
                  {
                    ref: s,
                    id: `rc-item-${t}`,
                    value: i,
                    size: o
                  }
                ),
                /* @__PURE__ */ T.jsx(
                  k0,
                  {
                    htmlFor: `rc-item-${t}`,
                    className: be({
                      "text-helper-text-sm": o === "sm",
                      "text-heading-xsm": o === "lg"
                    }),
                    children: e
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ T.jsx(
            "p",
            {
              className: be(
                "color-text-secondary color-text-default",
                o === "lg" ? "text-body-sm" : "text-helper-text-sm"
              ),
              children: n
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ T.jsx(r0t, { initial: !1, children: a && r === i && /* @__PURE__ */ T.jsx(Bht, { content: a }) })
  ] });
};
en(
  ({ items: t, className: e, size: n = "lg", content: r, selectedValue: i, setSelectedValue: a }, o) => !t || t.length === 0 ? null : /* @__PURE__ */ T.jsx(
    XW,
    {
      ref: o,
      defaultValue: i,
      className: be("space-y-2 h-full", e),
      onValueChange: (s) => a(s),
      children: t.map((s, l) => /* @__PURE__ */ T.jsx("div", { children: /* @__PURE__ */ T.jsx(
        Oht,
        {
          id: s.id,
          value: s.value,
          description: s.description,
          label: s.label,
          selectedValue: i,
          size: n,
          content: r ? r(i) : null
        }
      ) }, l))
    }
  )
);
const Bht = ({ content: t }) => {
  const [e, n] = De(0), r = Ue(null);
  return ze(() => {
    t && r.current ? n(r.current.scrollHeight) : n(0);
  }, [t]), /* @__PURE__ */ T.jsx(
    Ru.div,
    {
      ref: r,
      initial: { height: 0, opacity: 0 },
      animate: { height: t ? e : 0, opacity: t ? 1 : 0 },
      exit: { height: 0, opacity: 0 },
      transition: { duration: 0.3 },
      className: "overflow-hidden",
      children: /* @__PURE__ */ T.jsx("div", { className: "p-4 flex flex-col gap-4", children: t })
    }
  );
};
en(({ label: t, description: e, checked: n, onChange: r, size: i = "lg" }, a) => /* @__PURE__ */ T.jsxs("div", { className: "flex flex-col gap-2 w-full", ref: a, children: [
  /* @__PURE__ */ T.jsxs("div", { className: "flex justify-between items-center", children: [
    /* @__PURE__ */ T.jsx(
      k0,
      {
        htmlFor: "dynamic-content",
        className: be({
          "text-helper-text-sm": i === "sm",
          "text-heading-xsm": i === "lg"
        }),
        children: t
      }
    ),
    /* @__PURE__ */ T.jsx(
      _F,
      {
        id: "dynamic-content",
        defaultChecked: n,
        onCheckedChange: r
      }
    )
  ] }),
  /* @__PURE__ */ T.jsx(
    "p",
    {
      className: be(
        "color-text-secondary color-text-default w-[85%]",
        i === "lg" ? "text-body-sm" : "text-helper-text-sm"
      ),
      children: e
    }
  )
] }));
Ce.forwardRef(
  ({
    isActive: t,
    isCompleted: e,
    firstStep: n,
    lastStep: r,
    stepNumber: i,
    title: a,
    className: o,
    type: s,
    layout: l,
    stepContent: c,
    isLoading: u,
    ...d
  }, f) => /* @__PURE__ */ T.jsxs(
    "div",
    {
      className: un(
        "flex w-full h-full justify-center gap-2",
        l === "vertical" ? "flex-row relative items-start" : "flex-col items-center",
        o
      ),
      ref: f,
      ...d,
      children: [
        /* @__PURE__ */ T.jsxs(
          "div",
          {
            className: un("flex w-full items-center justify-center", {
              "flex-col flex-[0.05] relative h-full": l === "vertical",
              "!h-[4rem]": l === "vertical" && e,
              "translate-x-1/2 right-4 relative": l === "horizontal"
            }),
            children: [
              /* @__PURE__ */ T.jsx(
                "div",
                {
                  className: un(
                    "flex h-8 w-8 flex-none flex-col items-center justify-center gap-2 rounded-full",
                    { "color-bg-default-inverse": e || t || n },
                    { "color-bg-tertiary": !e || !t }
                  ),
                  children: i ? /* @__PURE__ */ T.jsx(
                    "span",
                    {
                      className: un("text-body-md-bold", {
                        "color-icon-inverse": e || t || n,
                        "color-icon-secondary": !e || !t
                      }),
                      children: e ? /* @__PURE__ */ T.jsx(Ox, { size: "16px", className: "color-icon-inverse" }) : i
                    }
                  ) : null
                }
              ),
              /* @__PURE__ */ T.jsx(
                "div",
                {
                  id: "step-line",
                  className: un(
                    "flex grow shrink-0 basis-0 flex-col items-center gap-2 border",
                    {
                      "border-transparent": r && l === "horizontal" || l === "vertical" && r && e,
                      "color-border-active": e,
                      "color-border-default": !e,
                      "border-solid": s === "solid",
                      "border-dashed": s === "dashed",
                      "h-full": l === "vertical"
                    }
                  )
                }
              )
            ]
          }
        ),
        a ? /* @__PURE__ */ T.jsx(
          "div",
          {
            id: "step-content",
            className: un("text-heading-xsm flex flex-col w-full h-full", {
              "color-text-default": e || t || n,
              "color-text-secondary": !t && !e,
              "flex-1 text-left relative gap-4 py-2": l === "vertical",
              "text-center": l === "horizontal",
              "opacity-50 pointer-events-none": !t && !n && !e
            }),
            children: l === "vertical" ? /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
              /* @__PURE__ */ T.jsxs("span", { className: "inline-flex gap-2 items-center", children: [
                a,
                u && /* @__PURE__ */ T.jsx(
                  Ye,
                  {
                    name: "LoaderCircle",
                    size: "sm",
                    className: "animate-spin",
                    fill: "transparent",
                    stroke: "currentColor"
                  }
                )
              ] }),
              c && !e && t ? c : null
            ] }) : /* @__PURE__ */ T.jsx(
              "div",
              {
                className: un(
                  "absolute flex flex-col gap-4 top-1/2 left-1/2 -translate-x-1/2 translate-y-1/4 transform max-w-sm",
                  {
                    hidden: !t && !e
                  }
                ),
                children: c && !e ? /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
                  a,
                  c
                ] }) : null
              }
            )
          }
        ) : null
      ]
    }
  )
);
Ce.forwardRef(
  ({ children: t, className: e, layout: n = "horizontal", ...r }, i) => t ? /* @__PURE__ */ T.jsx(
    "div",
    {
      className: un(
        "flex items-center justify-center",
        {
          "flex-col w-full max-w-sm": n === "vertical",
          "w-full": n === "horizontal"
        },
        e
      ),
      ref: i,
      ...r,
      children: Ce.Children.map(
        t,
        (a) => Ce.isValidElement(a) ? Ce.cloneElement(a, { layout: n }) : a
      )
    }
  ) : null
);
const Hht = RM, Fht = n6, _ht = OM, tZ = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  mp,
  {
    className: be(
      "fixed inset-0 z-50 color-utility-overlay data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      t
    ),
    ...e,
    ref: n
  }
));
tZ.displayName = mp.displayName;
const Vht = Ha(
  "fixed z-50 gap-4 color-bg-default p-4 shadow-elevation-4 transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), nZ = N.forwardRef(
  ({
    side: t = "right",
    className: e,
    overlayClasses: n,
    dismissible: r = !0,
    hideCloseButton: i = !1,
    children: a,
    ...o
  }, s) => {
    const l = N.useRef(null), c = N.useRef(0), u = N.useRef(0), d = (h) => {
      c.current = h.touches[0].clientX, u.current = h.touches[0].clientY;
    }, f = (h) => {
      var p, m, g, v;
      const k = h.changedTouches[0].clientX, w = h.changedTouches[0].clientY, b = k - c.current, x = w - u.current;
      t === "left" && b < -50 ? (p = l.current) == null || p.click() : t === "right" && b > 50 ? (m = l.current) == null || m.click() : t === "bottom" && x > 50 ? (g = l.current) == null || g.click() : t === "top" && x < -50 && ((v = l.current) == null || v.click());
    };
    return /* @__PURE__ */ T.jsxs(_ht, { children: [
      /* @__PURE__ */ T.jsx(tZ, { className: n }),
      /* @__PURE__ */ T.jsxs(
        yp,
        {
          ref: s,
          className: be(Vht({ side: t }), e),
          ...o,
          onTouchStart: d,
          onTouchEnd: f,
          children: [
            !i && /* @__PURE__ */ T.jsx(
              n6,
              {
                ref: l,
                className: "absolute right-4 top-3 rounded-sm ring-offset-white hover:color-bg-default-hover p-1 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused focus-visible:ring-offset-2 disabled:pointer-events-none data-[state=open]:color-bg-default-selected data-[state=open]:color-text-default",
                children: r && /* @__PURE__ */ T.jsx(Ye, { name: "X", className: "h-5 w-5" })
              }
            ),
            a
          ]
        }
      )
    ] });
  }
);
nZ.displayName = yp.displayName;
const rZ = ({
  className: t,
  ...e
}) => /* @__PURE__ */ T.jsx("div", { className: be("flex flex-col space-y-4 text-left", t), ...e });
rZ.displayName = "SheetHeader";
const iZ = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  gp,
  {
    ref: n,
    className: be("text-heading-md", t),
    ...e
  }
));
iZ.displayName = gp.displayName;
const qht = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  vp,
  {
    ref: n,
    className: be("text-body-sm color-text-secondary", t),
    ...e
  }
));
qht.displayName = vp.displayName;
const Uht = ({
  open: t,
  onOpenChange: e,
  title: n,
  titleIcon: r,
  content: i,
  className: a,
  headerClassName: o,
  side: s = "left",
  noOverlay: l = !1,
  overlayClasses: c,
  rounded: u = !1,
  dismissible: d
}) => /* @__PURE__ */ T.jsx(Hht, { open: t, onOpenChange: e, children: /* @__PURE__ */ T.jsxs(
  nZ,
  {
    className: un(
      {
        "rounded-b-lg": u && s === "top",
        "rounded-l-lg": u && s === "right",
        "rounded-t-lg": u && s === "bottom",
        "rounded-r-lg": u && s === "left"
      },
      a
    ),
    side: s,
    overlayClasses: un(c, { "bg-transparent": l }),
    dismissible: d,
    hideCloseButton: r === "X",
    children: [
      n && /* @__PURE__ */ T.jsx(rZ, { className: o, children: /* @__PURE__ */ T.jsxs(iZ, { className: "text-heading-sm inline-flex gap-2 items-center", children: [
        r && (r !== "X" ? /* @__PURE__ */ T.jsx(Ye, { name: r, size: "md" }) : /* @__PURE__ */ T.jsx(Fht, { className: "rounded-sm ring-offset-white hover:color-bg-default-hover p-1 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused focus-visible:ring-offset-2 disabled:pointer-events-none data-[state=open]:color-bg-default-selected data-[state=open]:color-text-default", children: /* @__PURE__ */ T.jsx(Ye, { name: r, size: "md" }) })),
        n
      ] }) }),
      i
    ]
  }
) }), Wht = ({
  title: t,
  open: e = !1,
  onOpenChange: n,
  content: r,
  className: i,
  headerClassName: a,
  contentClassName: o,
  side: s = "right",
  rounded: l = !1,
  dismissible: c = !0
}) => {
  const u = () => {
    n && n(!1);
  };
  return /* @__PURE__ */ T.jsx(
    "div",
    {
      className: be(
        `fixed z-10 transition-transform duration-300 ${e ? "translate-x-0" : "translate-x-full"} ${s === "right" ? "right-0 top-0 bottom-0" : ""} ${s === "left" ? "left-0 top-0 bottom-0" : ""} ${s === "top" ? "top-0 left-0 right-0" : ""} ${s === "bottom" ? "bottom-0 left-0 right-0" : ""} min-w-[300px] ${l ? "rounded-[16px]" : ""}`,
        i
      ),
      children: /* @__PURE__ */ T.jsxs(
        "div",
        {
          className: be(
            "color-bg-default h-full w-full p-4 flex flex-col",
            o
          ),
          children: [
            t && /* @__PURE__ */ T.jsx("div", { className: a, children: /* @__PURE__ */ T.jsx("h2", { className: "text-heading-sm color-text-default flex items-center gap-2", children: t }) }),
            c && /* @__PURE__ */ T.jsx(
              mn,
              {
                onClick: u,
                className: "absolute right-4 top-3 rounded-sm min-w-7 min-h-7 h-7 w-7 p-1",
                icon: "X",
                variant: "ghost",
                size: "md"
              }
            ),
            /* @__PURE__ */ T.jsx("div", { className: "color-text-default", children: r })
          ]
        }
      )
    }
  );
}, h6 = Pdt, p6 = zdt, Im = Odt, xp = N.forwardRef(
  ({ className: t, align: e = "center", sideOffset: n = 4, elevation: r, container: i, ...a }, o) => /* @__PURE__ */ T.jsx(Rdt, { container: i, children: /* @__PURE__ */ T.jsx(
    MU,
    {
      ref: o,
      align: e,
      sideOffset: n,
      className: be(
        "z-50 rounded-md color-bg-default color-text-default outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        r ? `shadow-elevation-${r}` : "border",
        t
      ),
      ...a
    }
  ) })
);
xp.displayName = MU.displayName;
const Mi = ({
  content: t,
  anchorTrigger: e,
  className: n,
  triggerClassName: r,
  ...i
}) => {
  const a = (o) => {
    Ce.isValidElement(e) && e.props.onClick && e.props.onClick(o);
  };
  return /* @__PURE__ */ T.jsxs(h6, { children: [
    /* @__PURE__ */ T.jsx(p6, { onClick: a, className: r, children: e }),
    /* @__PURE__ */ T.jsx(xp, { ...i, className: n, children: t })
  ] });
}, y9 = ({
  content: t,
  anchorTrigger: e,
  controlled: n = !1,
  isOpen: r,
  onClose: i,
  ...a
}) => {
  const [o, s] = De(!1), l = nt(
    (d) => {
      n || (s((f) => !f), Ce.isValidElement(e) && e.props.onClick && e.props.onClick(d));
    },
    [n, e]
  ), c = nt(
    (d) => {
      const f = d.target;
      !f.closest(".popover-trigger") && !f.closest(".popover-content") && (n || s(!1), i == null || i());
    },
    [n, i]
  );
  Ce.useEffect(() => (document.addEventListener("click", c), () => {
    document.removeEventListener("click", c);
  }), [c]);
  const u = n ? r : o;
  return /* @__PURE__ */ T.jsxs(h6, { open: u, onOpenChange: s, children: [
    /* @__PURE__ */ T.jsx(p6, { className: "popover-trigger", onClick: l, children: e }),
    /* @__PURE__ */ T.jsx(xp, { className: "popover-content", ...a, children: t })
  ] });
}, Zht = N.forwardRef(({ className: t, children: e, ...n }, r) => /* @__PURE__ */ T.jsxs(
  lW,
  {
    ref: r,
    className: be(
      "flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border color-border-default color-bg-default color-text-default px-3 py-2 text-body-sm ring-offset-2 placeholder:color-text-disabled focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 [&[data-state=open]>svg]:rotate-180 transition-all hover:color-border-hover",
      t
    ),
    ...n,
    children: [
      e,
      /* @__PURE__ */ T.jsx(hft, { asChild: !0, children: /* @__PURE__ */ T.jsx(Ig, { className: "h-4 w-4 shrink-0 color-text-secondary transition-transform duration-200" }) })
    ]
  }
));
Zht.displayName = lW.displayName;
const aZ = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  fW,
  {
    ref: n,
    className: be("flex cursor-default items-center justify-center py-1", t),
    ...e,
    children: /* @__PURE__ */ T.jsx(EF, { className: "h-4 w-4 shrink-0 color-text-default" })
  }
));
aZ.displayName = fW.displayName;
const oZ = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  hW,
  {
    ref: n,
    className: be("flex cursor-default items-center justify-center py-1", t),
    ...e,
    children: /* @__PURE__ */ T.jsx(Ig, { className: "h-4 w-4 shrink-0 color-text-default" })
  }
));
oZ.displayName = hW.displayName;
const Ght = N.forwardRef(
  ({ className: t, children: e, position: n = "popper", sideOffset: r, alignOffset: i, ...a }, o) => /* @__PURE__ */ T.jsx(pft, { children: /* @__PURE__ */ T.jsxs(
    cW,
    {
      ref: o,
      className: be(
        "relative z-50 max-h-96 overflow-hidden rounded-md border color-border-default color-bg-default color-text-default shadow-elevation-3 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        t
      ),
      position: n,
      sideOffset: r,
      alignOffset: i,
      ...a,
      children: [
        /* @__PURE__ */ T.jsx(aZ, {}),
        /* @__PURE__ */ T.jsx(
          mft,
          {
            className: be(
              "p-1",
              n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
            ),
            children: e
          }
        ),
        /* @__PURE__ */ T.jsx(oZ, {})
      ]
    }
  ) })
);
Ght.displayName = cW.displayName;
const Yht = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  uW,
  {
    ref: n,
    className: be(
      "px-1 py-1.5 color-text-disabled text-helper-text-sm font-medium",
      t
    ),
    ...e
  }
));
Yht.displayName = uW.displayName;
const Kht = N.forwardRef(({ className: t, children: e, ...n }, r) => /* @__PURE__ */ T.jsxs(
  dW,
  {
    ref: r,
    className: be(
      "relative flex w-full cursor-pointer select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-body-sm outline-none color-text-default data-[disabled]:color-text-disabled data-[disabled]:pointer-events-none data-[highlighted]:color-bg-default-selected data-[highlighted]:color-text-default",
      t
    ),
    ...n,
    children: [
      /* @__PURE__ */ T.jsx("span", { className: "absolute right-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ T.jsx(gft, { children: /* @__PURE__ */ T.jsx(Ox, { className: "h-4 w-4 color-text-default" }) }) }),
      /* @__PURE__ */ T.jsx(yft, { children: e })
    ]
  }
));
Kht.displayName = dW.displayName;
const $ht = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  pW,
  {
    ref: n,
    className: be("-mx-1 my-1 h-px color-bg-disabled", t),
    ...e
  }
));
$ht.displayName = pW.displayName;
const Jht = Ha(
  "relative w-full rounded-md px-4 py-2 text-body-sm flex gap-4 items-center [&>svg]:color-text-default",
  {
    variants: {
      variant: {
        default: "border color-border-default color-bg-default color-text-default",
        danger: "color-bg-danger-light color-text-danger [&>svg]:color-text-danger"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Qht = N.forwardRef(({ className: t, variant: e, ...n }, r) => /* @__PURE__ */ T.jsx(
  "div",
  {
    ref: r,
    role: "alert",
    className: be(Jht({ variant: e }), t),
    ...n
  }
));
Qht.displayName = "Alert";
const Xht = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx("h5", { ref: n, className: be("mb-1 text-heading-xsm", t), ...e }));
Xht.displayName = "AlertTitle";
const e2t = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  "div",
  {
    ref: n,
    className: be("text-body-sm [&_p]:leading-relaxed", t),
    ...e
  }
));
e2t.displayName = "AlertDescription";
function g9(t) {
  return [].concat(t);
}
function sC(t) {
  return t.startsWith(":");
}
function sZ(t) {
  return m6(t) && (t === "*" || t.length > 1 && ":>~.+*".includes(t.slice(0, 1)) || dZ(t));
}
function lZ(t, e) {
  return (m6(e) || typeof e == "number") && !uZ(t) && !sC(t) && !cZ(t);
}
function cZ(t) {
  return t.startsWith("@media");
}
function t2t(t) {
  return t === ".";
}
function uZ(t) {
  return t === "--";
}
function m6(t) {
  return t + "" === t;
}
function dZ(t) {
  return m6(t) && (t.startsWith("&") || sC(t));
}
function qy(t, e = "") {
  return t.filter(Boolean).join(e);
}
function fZ(t, e) {
  let n = 0;
  if (e.length === 0)
    return n.toString();
  for (let r = 0; r < e.length; r++) {
    const i = e.charCodeAt(r);
    n = (n << 5) - n + i, n = n & n;
  }
  return `${t ?? "cl"}_${n.toString(36)}`;
}
function n2t(t, e) {
  return t === "content" ? `"${e}"` : e;
}
function r2t(t) {
  return t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function AN(t, e) {
  return `${t}:${e}`;
}
function i2t(t) {
  return t ? `.${t}` : "";
}
function a2t(t, e) {
  return t ? `${t}
${e}` : e;
}
var hZ = class pZ {
  constructor(e, n, r, i) {
    this.sheet = e, this.property = n, this.value = r, this.selector = i, this.property = n, this.value = r, this.joined = AN(n, r);
    const a = this.selector.preconditions.concat(
      this.selector.postconditions
    );
    this.hash = this.selector.hasConditions ? this.selector.scopeClassName : fZ(this.sheet.name, this.joined), this.key = qy([this.joined, a, this.hash]);
  }
  toString() {
    let e = v9(this.selector.preconditions, {
      right: this.hash
    });
    return e = v9(this.selector.postconditions, {
      left: e
    }), `${e} {${pZ.genRule(this.property, this.value)}}`;
  }
  static genRule(e, n) {
    const r = r2t(e);
    return AN(
      r,
      n2t(e, n)
    ) + ";";
  }
};
function v9(t, { left: e = "", right: n = "" } = {}) {
  const r = t.reduce((i, a) => sC(a) ? i + a : dZ(a) ? i + a.slice(1) : qy([i, a], " "), e);
  return qy([r, i2t(n)], " ");
}
var o2t = class q4 {
  constructor(e, n = null, {
    preconditions: r,
    postconditions: i
  } = {}) {
    this.sheet = e, this.preconditions = [], this.scopeClassName = null, this.scopeName = null, this.postconditions = [], this.preconditions = r ? g9(r) : [], this.postconditions = i ? g9(i) : [], this.setScope(n);
  }
  setScope(e) {
    return e ? (this.scopeClassName || (this.scopeName = e, this.scopeClassName = fZ(
      this.sheet.name,
      // adding the count guarantees uniqueness across style.create calls
      e + this.sheet.count
    )), this) : this;
  }
  get hasConditions() {
    return this.preconditions.length > 0 || this.postconditions.length > 0;
  }
  addScope(e) {
    return new q4(this.sheet, e, {
      preconditions: this.preconditions,
      postconditions: this.postconditions
    });
  }
  addPrecondition(e) {
    return new q4(this.sheet, this.scopeClassName, {
      postconditions: this.postconditions,
      preconditions: this.preconditions.concat(e)
    });
  }
  addPostcondition(e) {
    return new q4(this.sheet, this.scopeClassName, {
      preconditions: this.preconditions,
      postconditions: this.postconditions.concat(e)
    });
  }
  createRule(e, n) {
    return new hZ(this.sheet, e, n, this);
  }
}, s2t = class {
  constructor(t, e) {
    this.name = t, this.rootNode = e, this.storedStyles = {}, this.storedClasses = {}, this.style = "", this.count = 0, this.id = `flairup-${t}`, this.styleTag = this.createStyleTag();
  }
  getStyle() {
    return this.style;
  }
  append(t) {
    this.style = a2t(this.style, t);
  }
  apply() {
    this.count++, this.styleTag && (this.styleTag.innerHTML = this.style);
  }
  isApplied() {
    return !!this.styleTag;
  }
  createStyleTag() {
    if (typeof document > "u" || this.isApplied() || // Explicitly disallow mounting to the DOM
    this.rootNode === null)
      return this.styleTag;
    const t = document.createElement("style");
    return t.type = "text/css", t.id = this.id, (this.rootNode ?? document.head).appendChild(t), t;
  }
  addRule(t) {
    const e = this.storedClasses[t.key];
    return m6(e) ? e : (this.storedClasses[t.key] = t.hash, this.storedStyles[t.hash] = [t.property, t.value], this.append(t.toString()), t.hash);
  }
};
function lC(t, e) {
  for (const n in t)
    e(n.trim(), t[n]);
}
function nn(...t) {
  const e = t.reduce((n, r) => (r instanceof Set ? n.push(...r) : typeof r == "string" ? n.push(r) : Array.isArray(r) ? n.push(nn(...r)) : typeof r == "object" && Object.entries(r).forEach(([i, a]) => {
    a && n.push(i);
  }), n), []);
  return qy(e, " ").trim();
}
function l2t(t, e) {
  const n = new s2t(t, e);
  return {
    create: r,
    getStyle: n.getStyle.bind(n),
    isApplied: n.isApplied.bind(n)
  };
  function r(i) {
    const a = {};
    return mZ(n, i, new o2t(n)).forEach(
      ([s, l, c]) => {
        y6(n, l, c).forEach(
          (u) => {
            o(s, u);
          }
        );
      }
    ), n.apply(), a;
    function o(s, l) {
      a[s] = a[s] ?? /* @__PURE__ */ new Set(), a[s].add(l);
    }
  }
}
function mZ(t, e, n) {
  const r = [];
  return lC(e, (i, a) => {
    if (sZ(i))
      return mZ(
        t,
        a,
        n.addPrecondition(i)
      ).forEach((o) => r.push(o));
    r.push([i, e[i], n.addScope(i)]);
  }), r;
}
function y6(t, e, n) {
  const r = /* @__PURE__ */ new Set();
  return lC(e, (i, a) => {
    let o = [];
    if (sZ(i))
      o = y6(
        t,
        a,
        n.addPostcondition(i)
      );
    else if (t2t(i))
      o = g9(a);
    else if (cZ(i))
      o = u2t(t, a, i, n);
    else if (uZ(i))
      o = c2t(t, a, n);
    else if (lZ(i, a)) {
      const s = n.createRule(i, a);
      t.addRule(s), r.add(s.hash);
    }
    return yZ(o, r);
  }), r;
}
function yZ(t, e) {
  return t.forEach((n) => e.add(n)), e;
}
function c2t(t, e, n) {
  const r = /* @__PURE__ */ new Set(), i = [];
  if (lC(e, (a, o) => {
    if (lZ(a, o)) {
      i.push(hZ.genRule(a, o));
      return;
    }
    const s = y6(t, o ?? {}, n);
    yZ(s, r);
  }), !n.scopeClassName)
    return r;
  if (i.length) {
    const a = i.join(" ");
    t.append(
      `${v9(n.preconditions, {
        right: n.scopeClassName
      })} {${a}}`
    );
  }
  return r.add(n.scopeClassName), r;
}
function u2t(t, e, n, r) {
  t.append(n + " {");
  const i = y6(t, e, r);
  return t.append("}"), i;
}
function Vn() {
  return Vn = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Vn.apply(this, arguments);
}
function d2t(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, b9(t, e);
}
function b9(t, e) {
  return b9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, b9(t, e);
}
function gZ(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
function f2t(t, e) {
  if (t) {
    if (typeof t == "string") return SN(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SN(t, e);
  }
}
function SN(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function h2t(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = f2t(t)) || e) {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[r++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var $t;
(function(t) {
  t.hiddenOnSearch = "epr-hidden-on-search", t.searchActive = "epr-search-active", t.hidden = "epr-hidden", t.visible = "epr-visible", t.active = "epr-active", t.emoji = "epr-emoji", t.category = "epr-emoji-category", t.label = "epr-emoji-category-label", t.categoryContent = "epr-emoji-category-content", t.emojiHasVariations = "epr-emoji-has-variations", t.scrollBody = "epr-body", t.emojiList = "epr-emoji-list", t.external = "__EmojiPicker__", t.emojiPicker = "EmojiPickerReact", t.open = "epr-open", t.vertical = "epr-vertical", t.horizontal = "epr-horizontal", t.variationPicker = "epr-emoji-variation-picker", t.darkTheme = "epr-dark-theme", t.autoTheme = "epr-auto-theme";
})($t || ($t = {}));
function $r() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return e.map(function(r) {
    return "." + r;
  }).join("");
}
var Nn = /* @__PURE__ */ l2t("epr", null), U4 = {
  display: "none",
  opacity: "0",
  pointerEvents: "none",
  visibility: "hidden",
  overflow: "hidden"
}, cC = /* @__PURE__ */ Nn.create({
  hidden: /* @__PURE__ */ Vn({
    ".": $t.hidden
  }, U4)
}), p2t = /* @__PURE__ */ QO(function() {
  return Ee("style", {
    suppressHydrationWarning: !0,
    dangerouslySetInnerHTML: {
      __html: Nn.getStyle()
    }
  });
}), x0 = /* @__PURE__ */ Nn.create({
  ".epr-main": {
    ":has(input:not(:placeholder-shown))": {
      categoryBtn: {
        ":hover": {
          opacity: "1",
          backgroundPositionY: "var(--epr-category-navigation-button-size)"
        }
      },
      hiddenOnSearch: /* @__PURE__ */ Vn({
        ".": $t.hiddenOnSearch
      }, U4)
    },
    ":has(input(:placeholder-shown))": {
      visibleOnSearchOnly: U4
    }
  },
  hiddenOnReactions: {
    transition: "all 0.5s ease-in-out"
  },
  ".epr-reactions": {
    hiddenOnReactions: {
      height: "0px",
      width: "0px",
      opacity: "0",
      pointerEvents: "none",
      overflow: "hidden"
    }
  },
  ".EmojiPickerReact:not(.epr-search-active)": {
    categoryBtn: {
      ":hover": {
        opacity: "1",
        backgroundPositionY: "var(--epr-category-navigation-button-size)"
      },
      "&.epr-active": {
        opacity: "1",
        backgroundPositionY: "var(--epr-category-navigation-button-size)"
      }
    },
    visibleOnSearchOnly: /* @__PURE__ */ Vn({
      ".": "epr-visible-on-search-only"
    }, U4)
  }
});
function Mc(t, e) {
  var n, r;
  return {
    ".epr-dark-theme": (n = {}, n[t] = e, n),
    ".epr-auto-theme": (r = {}, r[t] = {
      "@media (prefers-color-scheme: dark)": e
    }, r)
  };
}
function vZ(t, e) {
  var n, r, i = (n = t.customEmojis) != null ? n : [], a = (r = e.customEmojis) != null ? r : [];
  return t.open === e.open && t.emojiVersion === e.emojiVersion && t.reactionsDefaultOpen === e.reactionsDefaultOpen && t.searchPlaceHolder === e.searchPlaceHolder && t.searchPlaceholder === e.searchPlaceholder && t.defaultSkinTone === e.defaultSkinTone && t.skinTonesDisabled === e.skinTonesDisabled && t.autoFocusSearch === e.autoFocusSearch && t.emojiStyle === e.emojiStyle && t.theme === e.theme && t.suggestedEmojisMode === e.suggestedEmojisMode && t.lazyLoadEmojis === e.lazyLoadEmojis && t.className === e.className && t.height === e.height && t.width === e.width && t.style === e.style && t.searchDisabled === e.searchDisabled && t.skinTonePickerLocation === e.skinTonePickerLocation && i.length === a.length;
}
var m2t = [
  "1f44d",
  "2764-fe0f",
  "1f603",
  "1f622",
  "1f64f",
  "1f44e",
  "1f621"
  // 😡
], Wh;
(function(t) {
  t.RECENT = "recent", t.FREQUENT = "frequent";
})(Wh || (Wh = {}));
var Si;
(function(t) {
  t.NATIVE = "native", t.APPLE = "apple", t.TWITTER = "twitter", t.GOOGLE = "google", t.FACEBOOK = "facebook";
})(Si || (Si = {}));
var Zh;
(function(t) {
  t.DARK = "dark", t.LIGHT = "light", t.AUTO = "auto";
})(Zh || (Zh = {}));
var Ga;
(function(t) {
  t.NEUTRAL = "neutral", t.LIGHT = "1f3fb", t.MEDIUM_LIGHT = "1f3fc", t.MEDIUM = "1f3fd", t.MEDIUM_DARK = "1f3fe", t.DARK = "1f3ff";
})(Ga || (Ga = {}));
var Yt;
(function(t) {
  t.SUGGESTED = "suggested", t.CUSTOM = "custom", t.SMILEYS_PEOPLE = "smileys_people", t.ANIMALS_NATURE = "animals_nature", t.FOOD_DRINK = "food_drink", t.TRAVEL_PLACES = "travel_places", t.ACTIVITIES = "activities", t.OBJECTS = "objects", t.SYMBOLS = "symbols", t.FLAGS = "flags";
})(Yt || (Yt = {}));
var Y1;
(function(t) {
  t.SEARCH = "SEARCH", t.PREVIEW = "PREVIEW";
})(Y1 || (Y1 = {}));
var fa, y2t = [Yt.SUGGESTED, Yt.CUSTOM, Yt.SMILEYS_PEOPLE, Yt.ANIMALS_NATURE, Yt.FOOD_DRINK, Yt.TRAVEL_PLACES, Yt.ACTIVITIES, Yt.OBJECTS, Yt.SYMBOLS, Yt.FLAGS], g2t = {
  name: "Recently Used",
  category: Yt.SUGGESTED
}, bZ = (fa = {}, fa[Yt.SUGGESTED] = {
  category: Yt.SUGGESTED,
  name: "Frequently Used"
}, fa[Yt.CUSTOM] = {
  category: Yt.CUSTOM,
  name: "Custom Emojis"
}, fa[Yt.SMILEYS_PEOPLE] = {
  category: Yt.SMILEYS_PEOPLE,
  name: "Smileys & People"
}, fa[Yt.ANIMALS_NATURE] = {
  category: Yt.ANIMALS_NATURE,
  name: "Animals & Nature"
}, fa[Yt.FOOD_DRINK] = {
  category: Yt.FOOD_DRINK,
  name: "Food & Drink"
}, fa[Yt.TRAVEL_PLACES] = {
  category: Yt.TRAVEL_PLACES,
  name: "Travel & Places"
}, fa[Yt.ACTIVITIES] = {
  category: Yt.ACTIVITIES,
  name: "Activities"
}, fa[Yt.OBJECTS] = {
  category: Yt.OBJECTS,
  name: "Objects"
}, fa[Yt.SYMBOLS] = {
  category: Yt.SYMBOLS,
  name: "Symbols"
}, fa[Yt.FLAGS] = {
  category: Yt.FLAGS,
  name: "Flags"
}, fa);
function wZ(t) {
  return y2t.map(function(e) {
    return Vn({}, bZ[e], t && t[e] && t[e]);
  });
}
function uC(t) {
  return t.category;
}
function kZ(t) {
  return t.name;
}
function v2t(t, e) {
  var n;
  t === void 0 && (t = []), e === void 0 && (e = {});
  var r = {};
  e.suggestionMode === Wh.RECENT && (r[Yt.SUGGESTED] = g2t);
  var i = wZ(r);
  return (n = t) != null && n.length ? t.map(function(a) {
    return typeof a == "string" ? LN(a, r[a]) : Vn({}, LN(a.category, r[a.category]), a);
  }) : i;
}
function LN(t, e) {
  return e === void 0 && (e = {}), Object.assign(bZ[t], e);
}
var b2t = "https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/", w2t = "https://cdn.jsdelivr.net/npm/emoji-datasource-facebook/img/facebook/64/", k2t = "https://cdn.jsdelivr.net/npm/emoji-datasource-twitter/img/twitter/64/", x2t = "https://cdn.jsdelivr.net/npm/emoji-datasource-google/img/google/64/";
function M2t(t) {
  switch (t) {
    case Si.TWITTER:
      return k2t;
    case Si.GOOGLE:
      return x2t;
    case Si.FACEBOOK:
      return w2t;
    case Si.APPLE:
    default:
      return b2t;
  }
}
var C2t = [], A2t = [
  {
    n: [
      "grinning",
      "grinning face"
    ],
    u: "1f600",
    a: "1.0"
  },
  {
    n: [
      "smiley",
      "smiling face with open mouth"
    ],
    u: "1f603",
    a: "0.6"
  },
  {
    n: [
      "smile",
      "smiling face with open mouth and smiling eyes"
    ],
    u: "1f604",
    a: "0.6"
  },
  {
    n: [
      "grin",
      "grinning face with smiling eyes"
    ],
    u: "1f601",
    a: "0.6"
  },
  {
    n: [
      "laughing",
      "satisfied",
      "smiling face with open mouth and tightly-closed eyes"
    ],
    u: "1f606",
    a: "0.6"
  },
  {
    n: [
      "sweat smile",
      "smiling face with open mouth and cold sweat"
    ],
    u: "1f605",
    a: "0.6"
  },
  {
    n: [
      "rolling on the floor laughing"
    ],
    u: "1f923",
    a: "3.0"
  },
  {
    n: [
      "joy",
      "face with tears of joy"
    ],
    u: "1f602",
    a: "0.6"
  },
  {
    n: [
      "slightly smiling face"
    ],
    u: "1f642",
    a: "1.0"
  },
  {
    n: [
      "upside-down face",
      "upside down face"
    ],
    u: "1f643",
    a: "1.0"
  },
  {
    n: [
      "melting face"
    ],
    u: "1fae0",
    a: "14.0"
  },
  {
    n: [
      "wink",
      "winking face"
    ],
    u: "1f609",
    a: "0.6"
  },
  {
    n: [
      "blush",
      "smiling face with smiling eyes"
    ],
    u: "1f60a",
    a: "0.6"
  },
  {
    n: [
      "innocent",
      "smiling face with halo"
    ],
    u: "1f607",
    a: "1.0"
  },
  {
    n: [
      "smiling face with 3 hearts",
      "smiling face with smiling eyes and three hearts"
    ],
    u: "1f970",
    a: "11.0"
  },
  {
    n: [
      "heart eyes",
      "smiling face with heart-shaped eyes"
    ],
    u: "1f60d",
    a: "0.6"
  },
  {
    n: [
      "star-struck",
      "grinning face with star eyes"
    ],
    u: "1f929",
    a: "5.0"
  },
  {
    n: [
      "kissing heart",
      "face throwing a kiss"
    ],
    u: "1f618",
    a: "0.6"
  },
  {
    n: [
      "kissing",
      "kissing face"
    ],
    u: "1f617",
    a: "1.0"
  },
  {
    n: [
      "relaxed",
      "white smiling face"
    ],
    u: "263a-fe0f",
    a: "0.6"
  },
  {
    n: [
      "kissing closed eyes",
      "kissing face with closed eyes"
    ],
    u: "1f61a",
    a: "0.6"
  },
  {
    n: [
      "kissing smiling eyes",
      "kissing face with smiling eyes"
    ],
    u: "1f619",
    a: "1.0"
  },
  {
    n: [
      "smiling face with tear"
    ],
    u: "1f972",
    a: "13.0"
  },
  {
    n: [
      "yum",
      "face savouring delicious food"
    ],
    u: "1f60b",
    a: "0.6"
  },
  {
    n: [
      "stuck out tongue",
      "face with stuck-out tongue"
    ],
    u: "1f61b",
    a: "1.0"
  },
  {
    n: [
      "stuck out tongue winking eye",
      "face with stuck-out tongue and winking eye"
    ],
    u: "1f61c",
    a: "0.6"
  },
  {
    n: [
      "zany face",
      "grinning face with one large and one small eye"
    ],
    u: "1f92a",
    a: "5.0"
  },
  {
    n: [
      "stuck out tongue closed eyes",
      "face with stuck-out tongue and tightly-closed eyes"
    ],
    u: "1f61d",
    a: "0.6"
  },
  {
    n: [
      "money-mouth face",
      "money mouth face"
    ],
    u: "1f911",
    a: "1.0"
  },
  {
    n: [
      "hugging face"
    ],
    u: "1f917",
    a: "1.0"
  },
  {
    n: [
      "face with hand over mouth",
      "smiling face with smiling eyes and hand covering mouth"
    ],
    u: "1f92d",
    a: "5.0"
  },
  {
    n: [
      "face with open eyes and hand over mouth"
    ],
    u: "1fae2",
    a: "14.0"
  },
  {
    n: [
      "face with peeking eye"
    ],
    u: "1fae3",
    a: "14.0"
  },
  {
    n: [
      "shushing face",
      "face with finger covering closed lips"
    ],
    u: "1f92b",
    a: "5.0"
  },
  {
    n: [
      "thinking face"
    ],
    u: "1f914",
    a: "1.0"
  },
  {
    n: [
      "saluting face"
    ],
    u: "1fae1",
    a: "14.0"
  },
  {
    n: [
      "zipper-mouth face",
      "zipper mouth face"
    ],
    u: "1f910",
    a: "1.0"
  },
  {
    n: [
      "face with raised eyebrow",
      "face with one eyebrow raised"
    ],
    u: "1f928",
    a: "5.0"
  },
  {
    n: [
      "neutral face"
    ],
    u: "1f610",
    a: "0.7"
  },
  {
    n: [
      "expressionless",
      "expressionless face"
    ],
    u: "1f611",
    a: "1.0"
  },
  {
    n: [
      "no mouth",
      "face without mouth"
    ],
    u: "1f636",
    a: "1.0"
  },
  {
    n: [
      "dotted line face"
    ],
    u: "1fae5",
    a: "14.0"
  },
  {
    n: [
      "face in clouds"
    ],
    u: "1f636-200d-1f32b-fe0f",
    a: "13.1"
  },
  {
    n: [
      "smirk",
      "smirking face"
    ],
    u: "1f60f",
    a: "0.6"
  },
  {
    n: [
      "unamused",
      "unamused face"
    ],
    u: "1f612",
    a: "0.6"
  },
  {
    n: [
      "face with rolling eyes"
    ],
    u: "1f644",
    a: "1.0"
  },
  {
    n: [
      "grimacing",
      "grimacing face"
    ],
    u: "1f62c",
    a: "1.0"
  },
  {
    n: [
      "face exhaling"
    ],
    u: "1f62e-200d-1f4a8",
    a: "13.1"
  },
  {
    n: [
      "lying face"
    ],
    u: "1f925",
    a: "3.0"
  },
  {
    n: [
      "relieved",
      "relieved face"
    ],
    u: "1f60c",
    a: "0.6"
  },
  {
    n: [
      "pensive",
      "pensive face"
    ],
    u: "1f614",
    a: "0.6"
  },
  {
    n: [
      "sleepy",
      "sleepy face"
    ],
    u: "1f62a",
    a: "0.6"
  },
  {
    n: [
      "drooling face"
    ],
    u: "1f924",
    a: "3.0"
  },
  {
    n: [
      "sleeping",
      "sleeping face"
    ],
    u: "1f634",
    a: "1.0"
  },
  {
    n: [
      "mask",
      "face with medical mask"
    ],
    u: "1f637",
    a: "0.6"
  },
  {
    n: [
      "face with thermometer"
    ],
    u: "1f912",
    a: "1.0"
  },
  {
    n: [
      "face with head-bandage",
      "face with head bandage"
    ],
    u: "1f915",
    a: "1.0"
  },
  {
    n: [
      "nauseated face"
    ],
    u: "1f922",
    a: "3.0"
  },
  {
    n: [
      "face vomiting",
      "face with open mouth vomiting"
    ],
    u: "1f92e",
    a: "5.0"
  },
  {
    n: [
      "sneezing face"
    ],
    u: "1f927",
    a: "3.0"
  },
  {
    n: [
      "hot face",
      "overheated face"
    ],
    u: "1f975",
    a: "11.0"
  },
  {
    n: [
      "cold face",
      "freezing face"
    ],
    u: "1f976",
    a: "11.0"
  },
  {
    n: [
      "woozy face",
      "face with uneven eyes and wavy mouth"
    ],
    u: "1f974",
    a: "11.0"
  },
  {
    n: [
      "dizzy face"
    ],
    u: "1f635",
    a: "0.6"
  },
  {
    n: [
      "face with spiral eyes"
    ],
    u: "1f635-200d-1f4ab",
    a: "13.1"
  },
  {
    n: [
      "exploding head",
      "shocked face with exploding head"
    ],
    u: "1f92f",
    a: "5.0"
  },
  {
    n: [
      "face with cowboy hat"
    ],
    u: "1f920",
    a: "3.0"
  },
  {
    n: [
      "partying face",
      "face with party horn and party hat"
    ],
    u: "1f973",
    a: "11.0"
  },
  {
    n: [
      "disguised face"
    ],
    u: "1f978",
    a: "13.0"
  },
  {
    n: [
      "sunglasses",
      "smiling face with sunglasses"
    ],
    u: "1f60e",
    a: "1.0"
  },
  {
    n: [
      "nerd face"
    ],
    u: "1f913",
    a: "1.0"
  },
  {
    n: [
      "face with monocle"
    ],
    u: "1f9d0",
    a: "5.0"
  },
  {
    n: [
      "confused",
      "confused face"
    ],
    u: "1f615",
    a: "1.0"
  },
  {
    n: [
      "face with diagonal mouth"
    ],
    u: "1fae4",
    a: "14.0"
  },
  {
    n: [
      "worried",
      "worried face"
    ],
    u: "1f61f",
    a: "1.0"
  },
  {
    n: [
      "slightly frowning face"
    ],
    u: "1f641",
    a: "1.0"
  },
  {
    n: [
      "frowning face",
      "white frowning face"
    ],
    u: "2639-fe0f",
    a: "0.7"
  },
  {
    n: [
      "open mouth",
      "face with open mouth"
    ],
    u: "1f62e",
    a: "1.0"
  },
  {
    n: [
      "hushed",
      "hushed face"
    ],
    u: "1f62f",
    a: "1.0"
  },
  {
    n: [
      "astonished",
      "astonished face"
    ],
    u: "1f632",
    a: "0.6"
  },
  {
    n: [
      "flushed",
      "flushed face"
    ],
    u: "1f633",
    a: "0.6"
  },
  {
    n: [
      "pleading face",
      "face with pleading eyes"
    ],
    u: "1f97a",
    a: "11.0"
  },
  {
    n: [
      "face holding back tears"
    ],
    u: "1f979",
    a: "14.0"
  },
  {
    n: [
      "frowning",
      "frowning face with open mouth"
    ],
    u: "1f626",
    a: "1.0"
  },
  {
    n: [
      "anguished",
      "anguished face"
    ],
    u: "1f627",
    a: "1.0"
  },
  {
    n: [
      "fearful",
      "fearful face"
    ],
    u: "1f628",
    a: "0.6"
  },
  {
    n: [
      "cold sweat",
      "face with open mouth and cold sweat"
    ],
    u: "1f630",
    a: "0.6"
  },
  {
    n: [
      "disappointed relieved",
      "disappointed but relieved face"
    ],
    u: "1f625",
    a: "0.6"
  },
  {
    n: [
      "cry",
      "crying face"
    ],
    u: "1f622",
    a: "0.6"
  },
  {
    n: [
      "sob",
      "loudly crying face"
    ],
    u: "1f62d",
    a: "0.6"
  },
  {
    n: [
      "scream",
      "face screaming in fear"
    ],
    u: "1f631",
    a: "0.6"
  },
  {
    n: [
      "confounded",
      "confounded face"
    ],
    u: "1f616",
    a: "0.6"
  },
  {
    n: [
      "persevere",
      "persevering face"
    ],
    u: "1f623",
    a: "0.6"
  },
  {
    n: [
      "disappointed",
      "disappointed face"
    ],
    u: "1f61e",
    a: "0.6"
  },
  {
    n: [
      "sweat",
      "face with cold sweat"
    ],
    u: "1f613",
    a: "0.6"
  },
  {
    n: [
      "weary",
      "weary face"
    ],
    u: "1f629",
    a: "0.6"
  },
  {
    n: [
      "tired face"
    ],
    u: "1f62b",
    a: "0.6"
  },
  {
    n: [
      "yawning face"
    ],
    u: "1f971",
    a: "12.0"
  },
  {
    n: [
      "triumph",
      "face with look of triumph"
    ],
    u: "1f624",
    a: "0.6"
  },
  {
    n: [
      "rage",
      "pouting face"
    ],
    u: "1f621",
    a: "0.6"
  },
  {
    n: [
      "angry",
      "angry face"
    ],
    u: "1f620",
    a: "0.6"
  },
  {
    n: [
      "face with symbols on mouth",
      "serious face with symbols covering mouth"
    ],
    u: "1f92c",
    a: "5.0"
  },
  {
    n: [
      "smiling imp",
      "smiling face with horns"
    ],
    u: "1f608",
    a: "1.0"
  },
  {
    n: [
      "imp"
    ],
    u: "1f47f",
    a: "0.6"
  },
  {
    n: [
      "skull"
    ],
    u: "1f480",
    a: "0.6"
  },
  {
    n: [
      "skull and crossbones"
    ],
    u: "2620-fe0f",
    a: "1.0"
  },
  {
    n: [
      "poop",
      "shit",
      "hankey",
      "pile of poo"
    ],
    u: "1f4a9",
    a: "0.6"
  },
  {
    n: [
      "clown face"
    ],
    u: "1f921",
    a: "3.0"
  },
  {
    n: [
      "japanese ogre"
    ],
    u: "1f479",
    a: "0.6"
  },
  {
    n: [
      "japanese goblin"
    ],
    u: "1f47a",
    a: "0.6"
  },
  {
    n: [
      "ghost"
    ],
    u: "1f47b",
    a: "0.6"
  },
  {
    n: [
      "alien",
      "extraterrestrial alien"
    ],
    u: "1f47d",
    a: "0.6"
  },
  {
    n: [
      "alien monster",
      "space invader"
    ],
    u: "1f47e",
    a: "0.6"
  },
  {
    n: [
      "robot face"
    ],
    u: "1f916",
    a: "1.0"
  },
  {
    n: [
      "smiley cat",
      "smiling cat face with open mouth"
    ],
    u: "1f63a",
    a: "0.6"
  },
  {
    n: [
      "smile cat",
      "grinning cat face with smiling eyes"
    ],
    u: "1f638",
    a: "0.6"
  },
  {
    n: [
      "joy cat",
      "cat face with tears of joy"
    ],
    u: "1f639",
    a: "0.6"
  },
  {
    n: [
      "heart eyes cat",
      "smiling cat face with heart-shaped eyes"
    ],
    u: "1f63b",
    a: "0.6"
  },
  {
    n: [
      "smirk cat",
      "cat face with wry smile"
    ],
    u: "1f63c",
    a: "0.6"
  },
  {
    n: [
      "kissing cat",
      "kissing cat face with closed eyes"
    ],
    u: "1f63d",
    a: "0.6"
  },
  {
    n: [
      "scream cat",
      "weary cat face"
    ],
    u: "1f640",
    a: "0.6"
  },
  {
    n: [
      "crying cat face"
    ],
    u: "1f63f",
    a: "0.6"
  },
  {
    n: [
      "pouting cat",
      "pouting cat face"
    ],
    u: "1f63e",
    a: "0.6"
  },
  {
    n: [
      "see no evil",
      "see-no-evil monkey"
    ],
    u: "1f648",
    a: "0.6"
  },
  {
    n: [
      "hear no evil",
      "hear-no-evil monkey"
    ],
    u: "1f649",
    a: "0.6"
  },
  {
    n: [
      "speak no evil",
      "speak-no-evil monkey"
    ],
    u: "1f64a",
    a: "0.6"
  },
  {
    n: [
      "kiss",
      "kiss mark"
    ],
    u: "1f48b",
    a: "0.6"
  },
  {
    n: [
      "love letter"
    ],
    u: "1f48c",
    a: "0.6"
  },
  {
    n: [
      "cupid",
      "heart with arrow"
    ],
    u: "1f498",
    a: "0.6"
  },
  {
    n: [
      "gift heart",
      "heart with ribbon"
    ],
    u: "1f49d",
    a: "0.6"
  },
  {
    n: [
      "sparkling heart"
    ],
    u: "1f496",
    a: "0.6"
  },
  {
    n: [
      "heartpulse",
      "growing heart"
    ],
    u: "1f497",
    a: "0.6"
  },
  {
    n: [
      "heartbeat",
      "beating heart"
    ],
    u: "1f493",
    a: "0.6"
  },
  {
    n: [
      "revolving hearts"
    ],
    u: "1f49e",
    a: "0.6"
  },
  {
    n: [
      "two hearts"
    ],
    u: "1f495",
    a: "0.6"
  },
  {
    n: [
      "heart decoration"
    ],
    u: "1f49f",
    a: "0.6"
  },
  {
    n: [
      "heart exclamation",
      "heavy heart exclamation mark ornament"
    ],
    u: "2763-fe0f",
    a: "1.0"
  },
  {
    n: [
      "broken heart"
    ],
    u: "1f494",
    a: "0.6"
  },
  {
    n: [
      "heart on fire"
    ],
    u: "2764-fe0f-200d-1f525",
    a: "13.1"
  },
  {
    n: [
      "mending heart"
    ],
    u: "2764-fe0f-200d-1fa79",
    a: "13.1"
  },
  {
    n: [
      "heart",
      "heavy black heart"
    ],
    u: "2764-fe0f",
    a: "0.6"
  },
  {
    n: [
      "orange heart"
    ],
    u: "1f9e1",
    a: "5.0"
  },
  {
    n: [
      "yellow heart"
    ],
    u: "1f49b",
    a: "0.6"
  },
  {
    n: [
      "green heart"
    ],
    u: "1f49a",
    a: "0.6"
  },
  {
    n: [
      "blue heart"
    ],
    u: "1f499",
    a: "0.6"
  },
  {
    n: [
      "purple heart"
    ],
    u: "1f49c",
    a: "0.6"
  },
  {
    n: [
      "brown heart"
    ],
    u: "1f90e",
    a: "12.0"
  },
  {
    n: [
      "black heart"
    ],
    u: "1f5a4",
    a: "3.0"
  },
  {
    n: [
      "white heart"
    ],
    u: "1f90d",
    a: "12.0"
  },
  {
    n: [
      "100",
      "hundred points symbol"
    ],
    u: "1f4af",
    a: "0.6"
  },
  {
    n: [
      "anger",
      "anger symbol"
    ],
    u: "1f4a2",
    a: "0.6"
  },
  {
    n: [
      "boom",
      "collision",
      "collision symbol"
    ],
    u: "1f4a5",
    a: "0.6"
  },
  {
    n: [
      "dizzy",
      "dizzy symbol"
    ],
    u: "1f4ab",
    a: "0.6"
  },
  {
    n: [
      "sweat drops",
      "splashing sweat symbol"
    ],
    u: "1f4a6",
    a: "0.6"
  },
  {
    n: [
      "dash",
      "dash symbol"
    ],
    u: "1f4a8",
    a: "0.6"
  },
  {
    n: [
      "hole"
    ],
    u: "1f573-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bomb"
    ],
    u: "1f4a3",
    a: "0.6"
  },
  {
    n: [
      "speech balloon"
    ],
    u: "1f4ac",
    a: "0.6"
  },
  {
    n: [
      "eye in speech bubble",
      "eye-in-speech-bubble"
    ],
    u: "1f441-fe0f-200d-1f5e8-fe0f",
    a: "2.0"
  },
  {
    n: [
      "left speech bubble"
    ],
    u: "1f5e8-fe0f",
    a: "2.0"
  },
  {
    n: [
      "right anger bubble"
    ],
    u: "1f5ef-fe0f",
    a: "0.7"
  },
  {
    n: [
      "thought balloon"
    ],
    u: "1f4ad",
    a: "1.0"
  },
  {
    n: [
      "zzz",
      "sleeping symbol"
    ],
    u: "1f4a4",
    a: "0.6"
  },
  {
    n: [
      "wave",
      "waving hand sign"
    ],
    u: "1f44b",
    v: [
      "1f44b-1f3fb",
      "1f44b-1f3fc",
      "1f44b-1f3fd",
      "1f44b-1f3fe",
      "1f44b-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "raised back of hand"
    ],
    u: "1f91a",
    v: [
      "1f91a-1f3fb",
      "1f91a-1f3fc",
      "1f91a-1f3fd",
      "1f91a-1f3fe",
      "1f91a-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "hand with fingers splayed",
      "raised hand with fingers splayed"
    ],
    u: "1f590-fe0f",
    v: [
      "1f590-1f3fb",
      "1f590-1f3fc",
      "1f590-1f3fd",
      "1f590-1f3fe",
      "1f590-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "hand",
      "raised hand"
    ],
    u: "270b",
    v: [
      "270b-1f3fb",
      "270b-1f3fc",
      "270b-1f3fd",
      "270b-1f3fe",
      "270b-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "spock-hand",
      "raised hand with part between middle and ring fingers"
    ],
    u: "1f596",
    v: [
      "1f596-1f3fb",
      "1f596-1f3fc",
      "1f596-1f3fd",
      "1f596-1f3fe",
      "1f596-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "rightwards hand"
    ],
    u: "1faf1",
    v: [
      "1faf1-1f3fb",
      "1faf1-1f3fc",
      "1faf1-1f3fd",
      "1faf1-1f3fe",
      "1faf1-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "leftwards hand"
    ],
    u: "1faf2",
    v: [
      "1faf2-1f3fb",
      "1faf2-1f3fc",
      "1faf2-1f3fd",
      "1faf2-1f3fe",
      "1faf2-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "palm down hand"
    ],
    u: "1faf3",
    v: [
      "1faf3-1f3fb",
      "1faf3-1f3fc",
      "1faf3-1f3fd",
      "1faf3-1f3fe",
      "1faf3-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "palm up hand"
    ],
    u: "1faf4",
    v: [
      "1faf4-1f3fb",
      "1faf4-1f3fc",
      "1faf4-1f3fd",
      "1faf4-1f3fe",
      "1faf4-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "ok hand",
      "ok hand sign"
    ],
    u: "1f44c",
    v: [
      "1f44c-1f3fb",
      "1f44c-1f3fc",
      "1f44c-1f3fd",
      "1f44c-1f3fe",
      "1f44c-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "pinched fingers"
    ],
    u: "1f90c",
    v: [
      "1f90c-1f3fb",
      "1f90c-1f3fc",
      "1f90c-1f3fd",
      "1f90c-1f3fe",
      "1f90c-1f3ff"
    ],
    a: "13.0"
  },
  {
    n: [
      "pinching hand"
    ],
    u: "1f90f",
    v: [
      "1f90f-1f3fb",
      "1f90f-1f3fc",
      "1f90f-1f3fd",
      "1f90f-1f3fe",
      "1f90f-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "v",
      "victory hand"
    ],
    u: "270c-fe0f",
    v: [
      "270c-1f3fb",
      "270c-1f3fc",
      "270c-1f3fd",
      "270c-1f3fe",
      "270c-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "crossed fingers",
      "hand with index and middle fingers crossed"
    ],
    u: "1f91e",
    v: [
      "1f91e-1f3fb",
      "1f91e-1f3fc",
      "1f91e-1f3fd",
      "1f91e-1f3fe",
      "1f91e-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "hand with index finger and thumb crossed"
    ],
    u: "1faf0",
    v: [
      "1faf0-1f3fb",
      "1faf0-1f3fc",
      "1faf0-1f3fd",
      "1faf0-1f3fe",
      "1faf0-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "i love you hand sign"
    ],
    u: "1f91f",
    v: [
      "1f91f-1f3fb",
      "1f91f-1f3fc",
      "1f91f-1f3fd",
      "1f91f-1f3fe",
      "1f91f-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "the horns",
      "sign of the horns"
    ],
    u: "1f918",
    v: [
      "1f918-1f3fb",
      "1f918-1f3fc",
      "1f918-1f3fd",
      "1f918-1f3fe",
      "1f918-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "call me hand"
    ],
    u: "1f919",
    v: [
      "1f919-1f3fb",
      "1f919-1f3fc",
      "1f919-1f3fd",
      "1f919-1f3fe",
      "1f919-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "point left",
      "white left pointing backhand index"
    ],
    u: "1f448",
    v: [
      "1f448-1f3fb",
      "1f448-1f3fc",
      "1f448-1f3fd",
      "1f448-1f3fe",
      "1f448-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "point right",
      "white right pointing backhand index"
    ],
    u: "1f449",
    v: [
      "1f449-1f3fb",
      "1f449-1f3fc",
      "1f449-1f3fd",
      "1f449-1f3fe",
      "1f449-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "point up 2",
      "white up pointing backhand index"
    ],
    u: "1f446",
    v: [
      "1f446-1f3fb",
      "1f446-1f3fc",
      "1f446-1f3fd",
      "1f446-1f3fe",
      "1f446-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "middle finger",
      "reversed hand with middle finger extended"
    ],
    u: "1f595",
    v: [
      "1f595-1f3fb",
      "1f595-1f3fc",
      "1f595-1f3fd",
      "1f595-1f3fe",
      "1f595-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "point down",
      "white down pointing backhand index"
    ],
    u: "1f447",
    v: [
      "1f447-1f3fb",
      "1f447-1f3fc",
      "1f447-1f3fd",
      "1f447-1f3fe",
      "1f447-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "point up",
      "white up pointing index"
    ],
    u: "261d-fe0f",
    v: [
      "261d-1f3fb",
      "261d-1f3fc",
      "261d-1f3fd",
      "261d-1f3fe",
      "261d-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "index pointing at the viewer"
    ],
    u: "1faf5",
    v: [
      "1faf5-1f3fb",
      "1faf5-1f3fc",
      "1faf5-1f3fd",
      "1faf5-1f3fe",
      "1faf5-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "+1",
      "thumbsup",
      "thumbs up sign"
    ],
    u: "1f44d",
    v: [
      "1f44d-1f3fb",
      "1f44d-1f3fc",
      "1f44d-1f3fd",
      "1f44d-1f3fe",
      "1f44d-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "-1",
      "thumbsdown",
      "thumbs down sign"
    ],
    u: "1f44e",
    v: [
      "1f44e-1f3fb",
      "1f44e-1f3fc",
      "1f44e-1f3fd",
      "1f44e-1f3fe",
      "1f44e-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "fist",
      "raised fist"
    ],
    u: "270a",
    v: [
      "270a-1f3fb",
      "270a-1f3fc",
      "270a-1f3fd",
      "270a-1f3fe",
      "270a-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "punch",
      "facepunch",
      "fisted hand sign"
    ],
    u: "1f44a",
    v: [
      "1f44a-1f3fb",
      "1f44a-1f3fc",
      "1f44a-1f3fd",
      "1f44a-1f3fe",
      "1f44a-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "left-facing fist"
    ],
    u: "1f91b",
    v: [
      "1f91b-1f3fb",
      "1f91b-1f3fc",
      "1f91b-1f3fd",
      "1f91b-1f3fe",
      "1f91b-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "right-facing fist"
    ],
    u: "1f91c",
    v: [
      "1f91c-1f3fb",
      "1f91c-1f3fc",
      "1f91c-1f3fd",
      "1f91c-1f3fe",
      "1f91c-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "clap",
      "clapping hands sign"
    ],
    u: "1f44f",
    v: [
      "1f44f-1f3fb",
      "1f44f-1f3fc",
      "1f44f-1f3fd",
      "1f44f-1f3fe",
      "1f44f-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "raised hands",
      "person raising both hands in celebration"
    ],
    u: "1f64c",
    v: [
      "1f64c-1f3fb",
      "1f64c-1f3fc",
      "1f64c-1f3fd",
      "1f64c-1f3fe",
      "1f64c-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "heart hands"
    ],
    u: "1faf6",
    v: [
      "1faf6-1f3fb",
      "1faf6-1f3fc",
      "1faf6-1f3fd",
      "1faf6-1f3fe",
      "1faf6-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "open hands",
      "open hands sign"
    ],
    u: "1f450",
    v: [
      "1f450-1f3fb",
      "1f450-1f3fc",
      "1f450-1f3fd",
      "1f450-1f3fe",
      "1f450-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "palms up together"
    ],
    u: "1f932",
    v: [
      "1f932-1f3fb",
      "1f932-1f3fc",
      "1f932-1f3fd",
      "1f932-1f3fe",
      "1f932-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "handshake"
    ],
    u: "1f91d",
    v: [
      "1f91d-1f3fb",
      "1f91d-1f3fc",
      "1f91d-1f3fd",
      "1f91d-1f3fe",
      "1f91d-1f3ff",
      "1faf1-1f3fb-200d-1faf2-1f3fc",
      "1faf1-1f3fb-200d-1faf2-1f3fd",
      "1faf1-1f3fb-200d-1faf2-1f3fe",
      "1faf1-1f3fb-200d-1faf2-1f3ff",
      "1faf1-1f3fc-200d-1faf2-1f3fb",
      "1faf1-1f3fc-200d-1faf2-1f3fd",
      "1faf1-1f3fc-200d-1faf2-1f3fe",
      "1faf1-1f3fc-200d-1faf2-1f3ff",
      "1faf1-1f3fd-200d-1faf2-1f3fb",
      "1faf1-1f3fd-200d-1faf2-1f3fc",
      "1faf1-1f3fd-200d-1faf2-1f3fe",
      "1faf1-1f3fd-200d-1faf2-1f3ff",
      "1faf1-1f3fe-200d-1faf2-1f3fb",
      "1faf1-1f3fe-200d-1faf2-1f3fc",
      "1faf1-1f3fe-200d-1faf2-1f3fd",
      "1faf1-1f3fe-200d-1faf2-1f3ff",
      "1faf1-1f3ff-200d-1faf2-1f3fb",
      "1faf1-1f3ff-200d-1faf2-1f3fc",
      "1faf1-1f3ff-200d-1faf2-1f3fd",
      "1faf1-1f3ff-200d-1faf2-1f3fe"
    ],
    a: "3.0"
  },
  {
    n: [
      "pray",
      "person with folded hands"
    ],
    u: "1f64f",
    v: [
      "1f64f-1f3fb",
      "1f64f-1f3fc",
      "1f64f-1f3fd",
      "1f64f-1f3fe",
      "1f64f-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "writing hand"
    ],
    u: "270d-fe0f",
    v: [
      "270d-1f3fb",
      "270d-1f3fc",
      "270d-1f3fd",
      "270d-1f3fe",
      "270d-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "nail care",
      "nail polish"
    ],
    u: "1f485",
    v: [
      "1f485-1f3fb",
      "1f485-1f3fc",
      "1f485-1f3fd",
      "1f485-1f3fe",
      "1f485-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "selfie"
    ],
    u: "1f933",
    v: [
      "1f933-1f3fb",
      "1f933-1f3fc",
      "1f933-1f3fd",
      "1f933-1f3fe",
      "1f933-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "muscle",
      "flexed biceps"
    ],
    u: "1f4aa",
    v: [
      "1f4aa-1f3fb",
      "1f4aa-1f3fc",
      "1f4aa-1f3fd",
      "1f4aa-1f3fe",
      "1f4aa-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "mechanical arm"
    ],
    u: "1f9be",
    a: "12.0"
  },
  {
    n: [
      "mechanical leg"
    ],
    u: "1f9bf",
    a: "12.0"
  },
  {
    n: [
      "leg"
    ],
    u: "1f9b5",
    v: [
      "1f9b5-1f3fb",
      "1f9b5-1f3fc",
      "1f9b5-1f3fd",
      "1f9b5-1f3fe",
      "1f9b5-1f3ff"
    ],
    a: "11.0"
  },
  {
    n: [
      "foot"
    ],
    u: "1f9b6",
    v: [
      "1f9b6-1f3fb",
      "1f9b6-1f3fc",
      "1f9b6-1f3fd",
      "1f9b6-1f3fe",
      "1f9b6-1f3ff"
    ],
    a: "11.0"
  },
  {
    n: [
      "ear"
    ],
    u: "1f442",
    v: [
      "1f442-1f3fb",
      "1f442-1f3fc",
      "1f442-1f3fd",
      "1f442-1f3fe",
      "1f442-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "ear with hearing aid"
    ],
    u: "1f9bb",
    v: [
      "1f9bb-1f3fb",
      "1f9bb-1f3fc",
      "1f9bb-1f3fd",
      "1f9bb-1f3fe",
      "1f9bb-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "nose"
    ],
    u: "1f443",
    v: [
      "1f443-1f3fb",
      "1f443-1f3fc",
      "1f443-1f3fd",
      "1f443-1f3fe",
      "1f443-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "brain"
    ],
    u: "1f9e0",
    a: "5.0"
  },
  {
    n: [
      "anatomical heart"
    ],
    u: "1fac0",
    a: "13.0"
  },
  {
    n: [
      "lungs"
    ],
    u: "1fac1",
    a: "13.0"
  },
  {
    n: [
      "tooth"
    ],
    u: "1f9b7",
    a: "11.0"
  },
  {
    n: [
      "bone"
    ],
    u: "1f9b4",
    a: "11.0"
  },
  {
    n: [
      "eyes"
    ],
    u: "1f440",
    a: "0.6"
  },
  {
    n: [
      "eye"
    ],
    u: "1f441-fe0f",
    a: "0.7"
  },
  {
    n: [
      "tongue"
    ],
    u: "1f445",
    a: "0.6"
  },
  {
    n: [
      "lips",
      "mouth"
    ],
    u: "1f444",
    a: "0.6"
  },
  {
    n: [
      "biting lip"
    ],
    u: "1fae6",
    a: "14.0"
  },
  {
    n: [
      "baby"
    ],
    u: "1f476",
    v: [
      "1f476-1f3fb",
      "1f476-1f3fc",
      "1f476-1f3fd",
      "1f476-1f3fe",
      "1f476-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "child"
    ],
    u: "1f9d2",
    v: [
      "1f9d2-1f3fb",
      "1f9d2-1f3fc",
      "1f9d2-1f3fd",
      "1f9d2-1f3fe",
      "1f9d2-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "boy"
    ],
    u: "1f466",
    v: [
      "1f466-1f3fb",
      "1f466-1f3fc",
      "1f466-1f3fd",
      "1f466-1f3fe",
      "1f466-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "girl"
    ],
    u: "1f467",
    v: [
      "1f467-1f3fb",
      "1f467-1f3fc",
      "1f467-1f3fd",
      "1f467-1f3fe",
      "1f467-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "adult"
    ],
    u: "1f9d1",
    v: [
      "1f9d1-1f3fb",
      "1f9d1-1f3fc",
      "1f9d1-1f3fd",
      "1f9d1-1f3fe",
      "1f9d1-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "person with blond hair"
    ],
    u: "1f471",
    v: [
      "1f471-1f3fb",
      "1f471-1f3fc",
      "1f471-1f3fd",
      "1f471-1f3fe",
      "1f471-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man"
    ],
    u: "1f468",
    v: [
      "1f468-1f3fb",
      "1f468-1f3fc",
      "1f468-1f3fd",
      "1f468-1f3fe",
      "1f468-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "bearded person"
    ],
    u: "1f9d4",
    v: [
      "1f9d4-1f3fb",
      "1f9d4-1f3fc",
      "1f9d4-1f3fd",
      "1f9d4-1f3fe",
      "1f9d4-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man: beard",
      "man with beard"
    ],
    u: "1f9d4-200d-2642-fe0f",
    v: [
      "1f9d4-1f3fb-200d-2642-fe0f",
      "1f9d4-1f3fc-200d-2642-fe0f",
      "1f9d4-1f3fd-200d-2642-fe0f",
      "1f9d4-1f3fe-200d-2642-fe0f",
      "1f9d4-1f3ff-200d-2642-fe0f"
    ],
    a: "13.1"
  },
  {
    n: [
      "woman: beard",
      "woman with beard"
    ],
    u: "1f9d4-200d-2640-fe0f",
    v: [
      "1f9d4-1f3fb-200d-2640-fe0f",
      "1f9d4-1f3fc-200d-2640-fe0f",
      "1f9d4-1f3fd-200d-2640-fe0f",
      "1f9d4-1f3fe-200d-2640-fe0f",
      "1f9d4-1f3ff-200d-2640-fe0f"
    ],
    a: "13.1"
  },
  {
    n: [
      "man: red hair",
      "red haired man"
    ],
    u: "1f468-200d-1f9b0",
    v: [
      "1f468-1f3fb-200d-1f9b0",
      "1f468-1f3fc-200d-1f9b0",
      "1f468-1f3fd-200d-1f9b0",
      "1f468-1f3fe-200d-1f9b0",
      "1f468-1f3ff-200d-1f9b0"
    ],
    a: "11.0"
  },
  {
    n: [
      "man: curly hair",
      "curly haired man"
    ],
    u: "1f468-200d-1f9b1",
    v: [
      "1f468-1f3fb-200d-1f9b1",
      "1f468-1f3fc-200d-1f9b1",
      "1f468-1f3fd-200d-1f9b1",
      "1f468-1f3fe-200d-1f9b1",
      "1f468-1f3ff-200d-1f9b1"
    ],
    a: "11.0"
  },
  {
    n: [
      "man: white hair",
      "white haired man"
    ],
    u: "1f468-200d-1f9b3",
    v: [
      "1f468-1f3fb-200d-1f9b3",
      "1f468-1f3fc-200d-1f9b3",
      "1f468-1f3fd-200d-1f9b3",
      "1f468-1f3fe-200d-1f9b3",
      "1f468-1f3ff-200d-1f9b3"
    ],
    a: "11.0"
  },
  {
    n: [
      "bald man",
      "man: bald"
    ],
    u: "1f468-200d-1f9b2",
    v: [
      "1f468-1f3fb-200d-1f9b2",
      "1f468-1f3fc-200d-1f9b2",
      "1f468-1f3fd-200d-1f9b2",
      "1f468-1f3fe-200d-1f9b2",
      "1f468-1f3ff-200d-1f9b2"
    ],
    a: "11.0"
  },
  {
    n: [
      "woman"
    ],
    u: "1f469",
    v: [
      "1f469-1f3fb",
      "1f469-1f3fc",
      "1f469-1f3fd",
      "1f469-1f3fe",
      "1f469-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "woman: red hair",
      "red haired woman"
    ],
    u: "1f469-200d-1f9b0",
    v: [
      "1f469-1f3fb-200d-1f9b0",
      "1f469-1f3fc-200d-1f9b0",
      "1f469-1f3fd-200d-1f9b0",
      "1f469-1f3fe-200d-1f9b0",
      "1f469-1f3ff-200d-1f9b0"
    ],
    a: "11.0"
  },
  {
    n: [
      "person: red hair",
      "red haired person"
    ],
    u: "1f9d1-200d-1f9b0",
    v: [
      "1f9d1-1f3fb-200d-1f9b0",
      "1f9d1-1f3fc-200d-1f9b0",
      "1f9d1-1f3fd-200d-1f9b0",
      "1f9d1-1f3fe-200d-1f9b0",
      "1f9d1-1f3ff-200d-1f9b0"
    ],
    a: "12.1"
  },
  {
    n: [
      "woman: curly hair",
      "curly haired woman"
    ],
    u: "1f469-200d-1f9b1",
    v: [
      "1f469-1f3fb-200d-1f9b1",
      "1f469-1f3fc-200d-1f9b1",
      "1f469-1f3fd-200d-1f9b1",
      "1f469-1f3fe-200d-1f9b1",
      "1f469-1f3ff-200d-1f9b1"
    ],
    a: "11.0"
  },
  {
    n: [
      "person: curly hair",
      "curly haired person"
    ],
    u: "1f9d1-200d-1f9b1",
    v: [
      "1f9d1-1f3fb-200d-1f9b1",
      "1f9d1-1f3fc-200d-1f9b1",
      "1f9d1-1f3fd-200d-1f9b1",
      "1f9d1-1f3fe-200d-1f9b1",
      "1f9d1-1f3ff-200d-1f9b1"
    ],
    a: "12.1"
  },
  {
    n: [
      "woman: white hair",
      "white haired woman"
    ],
    u: "1f469-200d-1f9b3",
    v: [
      "1f469-1f3fb-200d-1f9b3",
      "1f469-1f3fc-200d-1f9b3",
      "1f469-1f3fd-200d-1f9b3",
      "1f469-1f3fe-200d-1f9b3",
      "1f469-1f3ff-200d-1f9b3"
    ],
    a: "11.0"
  },
  {
    n: [
      "person: white hair",
      "white haired person"
    ],
    u: "1f9d1-200d-1f9b3",
    v: [
      "1f9d1-1f3fb-200d-1f9b3",
      "1f9d1-1f3fc-200d-1f9b3",
      "1f9d1-1f3fd-200d-1f9b3",
      "1f9d1-1f3fe-200d-1f9b3",
      "1f9d1-1f3ff-200d-1f9b3"
    ],
    a: "12.1"
  },
  {
    n: [
      "bald woman",
      "woman: bald"
    ],
    u: "1f469-200d-1f9b2",
    v: [
      "1f469-1f3fb-200d-1f9b2",
      "1f469-1f3fc-200d-1f9b2",
      "1f469-1f3fd-200d-1f9b2",
      "1f469-1f3fe-200d-1f9b2",
      "1f469-1f3ff-200d-1f9b2"
    ],
    a: "11.0"
  },
  {
    n: [
      "bald person",
      "person: bald"
    ],
    u: "1f9d1-200d-1f9b2",
    v: [
      "1f9d1-1f3fb-200d-1f9b2",
      "1f9d1-1f3fc-200d-1f9b2",
      "1f9d1-1f3fd-200d-1f9b2",
      "1f9d1-1f3fe-200d-1f9b2",
      "1f9d1-1f3ff-200d-1f9b2"
    ],
    a: "12.1"
  },
  {
    n: [
      "woman: blond hair",
      "blond-haired-woman"
    ],
    u: "1f471-200d-2640-fe0f",
    v: [
      "1f471-1f3fb-200d-2640-fe0f",
      "1f471-1f3fc-200d-2640-fe0f",
      "1f471-1f3fd-200d-2640-fe0f",
      "1f471-1f3fe-200d-2640-fe0f",
      "1f471-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "man: blond hair",
      "blond-haired-man"
    ],
    u: "1f471-200d-2642-fe0f",
    v: [
      "1f471-1f3fb-200d-2642-fe0f",
      "1f471-1f3fc-200d-2642-fe0f",
      "1f471-1f3fd-200d-2642-fe0f",
      "1f471-1f3fe-200d-2642-fe0f",
      "1f471-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "older adult"
    ],
    u: "1f9d3",
    v: [
      "1f9d3-1f3fb",
      "1f9d3-1f3fc",
      "1f9d3-1f3fd",
      "1f9d3-1f3fe",
      "1f9d3-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "older man"
    ],
    u: "1f474",
    v: [
      "1f474-1f3fb",
      "1f474-1f3fc",
      "1f474-1f3fd",
      "1f474-1f3fe",
      "1f474-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "older woman"
    ],
    u: "1f475",
    v: [
      "1f475-1f3fb",
      "1f475-1f3fc",
      "1f475-1f3fd",
      "1f475-1f3fe",
      "1f475-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "person frowning"
    ],
    u: "1f64d",
    v: [
      "1f64d-1f3fb",
      "1f64d-1f3fc",
      "1f64d-1f3fd",
      "1f64d-1f3fe",
      "1f64d-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man frowning",
      "man-frowning"
    ],
    u: "1f64d-200d-2642-fe0f",
    v: [
      "1f64d-1f3fb-200d-2642-fe0f",
      "1f64d-1f3fc-200d-2642-fe0f",
      "1f64d-1f3fd-200d-2642-fe0f",
      "1f64d-1f3fe-200d-2642-fe0f",
      "1f64d-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman frowning",
      "woman-frowning"
    ],
    u: "1f64d-200d-2640-fe0f",
    v: [
      "1f64d-1f3fb-200d-2640-fe0f",
      "1f64d-1f3fc-200d-2640-fe0f",
      "1f64d-1f3fd-200d-2640-fe0f",
      "1f64d-1f3fe-200d-2640-fe0f",
      "1f64d-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person with pouting face"
    ],
    u: "1f64e",
    v: [
      "1f64e-1f3fb",
      "1f64e-1f3fc",
      "1f64e-1f3fd",
      "1f64e-1f3fe",
      "1f64e-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man pouting",
      "man-pouting"
    ],
    u: "1f64e-200d-2642-fe0f",
    v: [
      "1f64e-1f3fb-200d-2642-fe0f",
      "1f64e-1f3fc-200d-2642-fe0f",
      "1f64e-1f3fd-200d-2642-fe0f",
      "1f64e-1f3fe-200d-2642-fe0f",
      "1f64e-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman pouting",
      "woman-pouting"
    ],
    u: "1f64e-200d-2640-fe0f",
    v: [
      "1f64e-1f3fb-200d-2640-fe0f",
      "1f64e-1f3fc-200d-2640-fe0f",
      "1f64e-1f3fd-200d-2640-fe0f",
      "1f64e-1f3fe-200d-2640-fe0f",
      "1f64e-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "no good",
      "face with no good gesture"
    ],
    u: "1f645",
    v: [
      "1f645-1f3fb",
      "1f645-1f3fc",
      "1f645-1f3fd",
      "1f645-1f3fe",
      "1f645-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man gesturing no",
      "man-gesturing-no"
    ],
    u: "1f645-200d-2642-fe0f",
    v: [
      "1f645-1f3fb-200d-2642-fe0f",
      "1f645-1f3fc-200d-2642-fe0f",
      "1f645-1f3fd-200d-2642-fe0f",
      "1f645-1f3fe-200d-2642-fe0f",
      "1f645-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman gesturing no",
      "woman-gesturing-no"
    ],
    u: "1f645-200d-2640-fe0f",
    v: [
      "1f645-1f3fb-200d-2640-fe0f",
      "1f645-1f3fc-200d-2640-fe0f",
      "1f645-1f3fd-200d-2640-fe0f",
      "1f645-1f3fe-200d-2640-fe0f",
      "1f645-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "ok woman",
      "face with ok gesture"
    ],
    u: "1f646",
    v: [
      "1f646-1f3fb",
      "1f646-1f3fc",
      "1f646-1f3fd",
      "1f646-1f3fe",
      "1f646-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man gesturing ok",
      "man-gesturing-ok"
    ],
    u: "1f646-200d-2642-fe0f",
    v: [
      "1f646-1f3fb-200d-2642-fe0f",
      "1f646-1f3fc-200d-2642-fe0f",
      "1f646-1f3fd-200d-2642-fe0f",
      "1f646-1f3fe-200d-2642-fe0f",
      "1f646-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman gesturing ok",
      "woman-gesturing-ok"
    ],
    u: "1f646-200d-2640-fe0f",
    v: [
      "1f646-1f3fb-200d-2640-fe0f",
      "1f646-1f3fc-200d-2640-fe0f",
      "1f646-1f3fd-200d-2640-fe0f",
      "1f646-1f3fe-200d-2640-fe0f",
      "1f646-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "information desk person"
    ],
    u: "1f481",
    v: [
      "1f481-1f3fb",
      "1f481-1f3fc",
      "1f481-1f3fd",
      "1f481-1f3fe",
      "1f481-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man tipping hand",
      "man-tipping-hand"
    ],
    u: "1f481-200d-2642-fe0f",
    v: [
      "1f481-1f3fb-200d-2642-fe0f",
      "1f481-1f3fc-200d-2642-fe0f",
      "1f481-1f3fd-200d-2642-fe0f",
      "1f481-1f3fe-200d-2642-fe0f",
      "1f481-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman tipping hand",
      "woman-tipping-hand"
    ],
    u: "1f481-200d-2640-fe0f",
    v: [
      "1f481-1f3fb-200d-2640-fe0f",
      "1f481-1f3fc-200d-2640-fe0f",
      "1f481-1f3fd-200d-2640-fe0f",
      "1f481-1f3fe-200d-2640-fe0f",
      "1f481-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "raising hand",
      "happy person raising one hand"
    ],
    u: "1f64b",
    v: [
      "1f64b-1f3fb",
      "1f64b-1f3fc",
      "1f64b-1f3fd",
      "1f64b-1f3fe",
      "1f64b-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man raising hand",
      "man-raising-hand"
    ],
    u: "1f64b-200d-2642-fe0f",
    v: [
      "1f64b-1f3fb-200d-2642-fe0f",
      "1f64b-1f3fc-200d-2642-fe0f",
      "1f64b-1f3fd-200d-2642-fe0f",
      "1f64b-1f3fe-200d-2642-fe0f",
      "1f64b-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman raising hand",
      "woman-raising-hand"
    ],
    u: "1f64b-200d-2640-fe0f",
    v: [
      "1f64b-1f3fb-200d-2640-fe0f",
      "1f64b-1f3fc-200d-2640-fe0f",
      "1f64b-1f3fd-200d-2640-fe0f",
      "1f64b-1f3fe-200d-2640-fe0f",
      "1f64b-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "deaf person"
    ],
    u: "1f9cf",
    v: [
      "1f9cf-1f3fb",
      "1f9cf-1f3fc",
      "1f9cf-1f3fd",
      "1f9cf-1f3fe",
      "1f9cf-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "deaf man"
    ],
    u: "1f9cf-200d-2642-fe0f",
    v: [
      "1f9cf-1f3fb-200d-2642-fe0f",
      "1f9cf-1f3fc-200d-2642-fe0f",
      "1f9cf-1f3fd-200d-2642-fe0f",
      "1f9cf-1f3fe-200d-2642-fe0f",
      "1f9cf-1f3ff-200d-2642-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "deaf woman"
    ],
    u: "1f9cf-200d-2640-fe0f",
    v: [
      "1f9cf-1f3fb-200d-2640-fe0f",
      "1f9cf-1f3fc-200d-2640-fe0f",
      "1f9cf-1f3fd-200d-2640-fe0f",
      "1f9cf-1f3fe-200d-2640-fe0f",
      "1f9cf-1f3ff-200d-2640-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "bow",
      "person bowing deeply"
    ],
    u: "1f647",
    v: [
      "1f647-1f3fb",
      "1f647-1f3fc",
      "1f647-1f3fd",
      "1f647-1f3fe",
      "1f647-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man bowing",
      "man-bowing"
    ],
    u: "1f647-200d-2642-fe0f",
    v: [
      "1f647-1f3fb-200d-2642-fe0f",
      "1f647-1f3fc-200d-2642-fe0f",
      "1f647-1f3fd-200d-2642-fe0f",
      "1f647-1f3fe-200d-2642-fe0f",
      "1f647-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman bowing",
      "woman-bowing"
    ],
    u: "1f647-200d-2640-fe0f",
    v: [
      "1f647-1f3fb-200d-2640-fe0f",
      "1f647-1f3fc-200d-2640-fe0f",
      "1f647-1f3fd-200d-2640-fe0f",
      "1f647-1f3fe-200d-2640-fe0f",
      "1f647-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "face palm"
    ],
    u: "1f926",
    v: [
      "1f926-1f3fb",
      "1f926-1f3fc",
      "1f926-1f3fd",
      "1f926-1f3fe",
      "1f926-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man facepalming",
      "man-facepalming"
    ],
    u: "1f926-200d-2642-fe0f",
    v: [
      "1f926-1f3fb-200d-2642-fe0f",
      "1f926-1f3fc-200d-2642-fe0f",
      "1f926-1f3fd-200d-2642-fe0f",
      "1f926-1f3fe-200d-2642-fe0f",
      "1f926-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman facepalming",
      "woman-facepalming"
    ],
    u: "1f926-200d-2640-fe0f",
    v: [
      "1f926-1f3fb-200d-2640-fe0f",
      "1f926-1f3fc-200d-2640-fe0f",
      "1f926-1f3fd-200d-2640-fe0f",
      "1f926-1f3fe-200d-2640-fe0f",
      "1f926-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "shrug"
    ],
    u: "1f937",
    v: [
      "1f937-1f3fb",
      "1f937-1f3fc",
      "1f937-1f3fd",
      "1f937-1f3fe",
      "1f937-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man shrugging",
      "man-shrugging"
    ],
    u: "1f937-200d-2642-fe0f",
    v: [
      "1f937-1f3fb-200d-2642-fe0f",
      "1f937-1f3fc-200d-2642-fe0f",
      "1f937-1f3fd-200d-2642-fe0f",
      "1f937-1f3fe-200d-2642-fe0f",
      "1f937-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman shrugging",
      "woman-shrugging"
    ],
    u: "1f937-200d-2640-fe0f",
    v: [
      "1f937-1f3fb-200d-2640-fe0f",
      "1f937-1f3fc-200d-2640-fe0f",
      "1f937-1f3fd-200d-2640-fe0f",
      "1f937-1f3fe-200d-2640-fe0f",
      "1f937-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "health worker"
    ],
    u: "1f9d1-200d-2695-fe0f",
    v: [
      "1f9d1-1f3fb-200d-2695-fe0f",
      "1f9d1-1f3fc-200d-2695-fe0f",
      "1f9d1-1f3fd-200d-2695-fe0f",
      "1f9d1-1f3fe-200d-2695-fe0f",
      "1f9d1-1f3ff-200d-2695-fe0f"
    ],
    a: "12.1"
  },
  {
    n: [
      "male-doctor",
      "man health worker"
    ],
    u: "1f468-200d-2695-fe0f",
    v: [
      "1f468-1f3fb-200d-2695-fe0f",
      "1f468-1f3fc-200d-2695-fe0f",
      "1f468-1f3fd-200d-2695-fe0f",
      "1f468-1f3fe-200d-2695-fe0f",
      "1f468-1f3ff-200d-2695-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "female-doctor",
      "woman health worker"
    ],
    u: "1f469-200d-2695-fe0f",
    v: [
      "1f469-1f3fb-200d-2695-fe0f",
      "1f469-1f3fc-200d-2695-fe0f",
      "1f469-1f3fd-200d-2695-fe0f",
      "1f469-1f3fe-200d-2695-fe0f",
      "1f469-1f3ff-200d-2695-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "student"
    ],
    u: "1f9d1-200d-1f393",
    v: [
      "1f9d1-1f3fb-200d-1f393",
      "1f9d1-1f3fc-200d-1f393",
      "1f9d1-1f3fd-200d-1f393",
      "1f9d1-1f3fe-200d-1f393",
      "1f9d1-1f3ff-200d-1f393"
    ],
    a: "12.1"
  },
  {
    n: [
      "man student",
      "male-student"
    ],
    u: "1f468-200d-1f393",
    v: [
      "1f468-1f3fb-200d-1f393",
      "1f468-1f3fc-200d-1f393",
      "1f468-1f3fd-200d-1f393",
      "1f468-1f3fe-200d-1f393",
      "1f468-1f3ff-200d-1f393"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman student",
      "female-student"
    ],
    u: "1f469-200d-1f393",
    v: [
      "1f469-1f3fb-200d-1f393",
      "1f469-1f3fc-200d-1f393",
      "1f469-1f3fd-200d-1f393",
      "1f469-1f3fe-200d-1f393",
      "1f469-1f3ff-200d-1f393"
    ],
    a: "4.0"
  },
  {
    n: [
      "teacher"
    ],
    u: "1f9d1-200d-1f3eb",
    v: [
      "1f9d1-1f3fb-200d-1f3eb",
      "1f9d1-1f3fc-200d-1f3eb",
      "1f9d1-1f3fd-200d-1f3eb",
      "1f9d1-1f3fe-200d-1f3eb",
      "1f9d1-1f3ff-200d-1f3eb"
    ],
    a: "12.1"
  },
  {
    n: [
      "man teacher",
      "male-teacher"
    ],
    u: "1f468-200d-1f3eb",
    v: [
      "1f468-1f3fb-200d-1f3eb",
      "1f468-1f3fc-200d-1f3eb",
      "1f468-1f3fd-200d-1f3eb",
      "1f468-1f3fe-200d-1f3eb",
      "1f468-1f3ff-200d-1f3eb"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman teacher",
      "female-teacher"
    ],
    u: "1f469-200d-1f3eb",
    v: [
      "1f469-1f3fb-200d-1f3eb",
      "1f469-1f3fc-200d-1f3eb",
      "1f469-1f3fd-200d-1f3eb",
      "1f469-1f3fe-200d-1f3eb",
      "1f469-1f3ff-200d-1f3eb"
    ],
    a: "4.0"
  },
  {
    n: [
      "judge"
    ],
    u: "1f9d1-200d-2696-fe0f",
    v: [
      "1f9d1-1f3fb-200d-2696-fe0f",
      "1f9d1-1f3fc-200d-2696-fe0f",
      "1f9d1-1f3fd-200d-2696-fe0f",
      "1f9d1-1f3fe-200d-2696-fe0f",
      "1f9d1-1f3ff-200d-2696-fe0f"
    ],
    a: "12.1"
  },
  {
    n: [
      "man judge",
      "male-judge"
    ],
    u: "1f468-200d-2696-fe0f",
    v: [
      "1f468-1f3fb-200d-2696-fe0f",
      "1f468-1f3fc-200d-2696-fe0f",
      "1f468-1f3fd-200d-2696-fe0f",
      "1f468-1f3fe-200d-2696-fe0f",
      "1f468-1f3ff-200d-2696-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman judge",
      "female-judge"
    ],
    u: "1f469-200d-2696-fe0f",
    v: [
      "1f469-1f3fb-200d-2696-fe0f",
      "1f469-1f3fc-200d-2696-fe0f",
      "1f469-1f3fd-200d-2696-fe0f",
      "1f469-1f3fe-200d-2696-fe0f",
      "1f469-1f3ff-200d-2696-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "farmer"
    ],
    u: "1f9d1-200d-1f33e",
    v: [
      "1f9d1-1f3fb-200d-1f33e",
      "1f9d1-1f3fc-200d-1f33e",
      "1f9d1-1f3fd-200d-1f33e",
      "1f9d1-1f3fe-200d-1f33e",
      "1f9d1-1f3ff-200d-1f33e"
    ],
    a: "12.1"
  },
  {
    n: [
      "man farmer",
      "male-farmer"
    ],
    u: "1f468-200d-1f33e",
    v: [
      "1f468-1f3fb-200d-1f33e",
      "1f468-1f3fc-200d-1f33e",
      "1f468-1f3fd-200d-1f33e",
      "1f468-1f3fe-200d-1f33e",
      "1f468-1f3ff-200d-1f33e"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman farmer",
      "female-farmer"
    ],
    u: "1f469-200d-1f33e",
    v: [
      "1f469-1f3fb-200d-1f33e",
      "1f469-1f3fc-200d-1f33e",
      "1f469-1f3fd-200d-1f33e",
      "1f469-1f3fe-200d-1f33e",
      "1f469-1f3ff-200d-1f33e"
    ],
    a: "4.0"
  },
  {
    n: [
      "cook"
    ],
    u: "1f9d1-200d-1f373",
    v: [
      "1f9d1-1f3fb-200d-1f373",
      "1f9d1-1f3fc-200d-1f373",
      "1f9d1-1f3fd-200d-1f373",
      "1f9d1-1f3fe-200d-1f373",
      "1f9d1-1f3ff-200d-1f373"
    ],
    a: "12.1"
  },
  {
    n: [
      "man cook",
      "male-cook"
    ],
    u: "1f468-200d-1f373",
    v: [
      "1f468-1f3fb-200d-1f373",
      "1f468-1f3fc-200d-1f373",
      "1f468-1f3fd-200d-1f373",
      "1f468-1f3fe-200d-1f373",
      "1f468-1f3ff-200d-1f373"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman cook",
      "female-cook"
    ],
    u: "1f469-200d-1f373",
    v: [
      "1f469-1f3fb-200d-1f373",
      "1f469-1f3fc-200d-1f373",
      "1f469-1f3fd-200d-1f373",
      "1f469-1f3fe-200d-1f373",
      "1f469-1f3ff-200d-1f373"
    ],
    a: "4.0"
  },
  {
    n: [
      "mechanic"
    ],
    u: "1f9d1-200d-1f527",
    v: [
      "1f9d1-1f3fb-200d-1f527",
      "1f9d1-1f3fc-200d-1f527",
      "1f9d1-1f3fd-200d-1f527",
      "1f9d1-1f3fe-200d-1f527",
      "1f9d1-1f3ff-200d-1f527"
    ],
    a: "12.1"
  },
  {
    n: [
      "man mechanic",
      "male-mechanic"
    ],
    u: "1f468-200d-1f527",
    v: [
      "1f468-1f3fb-200d-1f527",
      "1f468-1f3fc-200d-1f527",
      "1f468-1f3fd-200d-1f527",
      "1f468-1f3fe-200d-1f527",
      "1f468-1f3ff-200d-1f527"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman mechanic",
      "female-mechanic"
    ],
    u: "1f469-200d-1f527",
    v: [
      "1f469-1f3fb-200d-1f527",
      "1f469-1f3fc-200d-1f527",
      "1f469-1f3fd-200d-1f527",
      "1f469-1f3fe-200d-1f527",
      "1f469-1f3ff-200d-1f527"
    ],
    a: "4.0"
  },
  {
    n: [
      "factory worker"
    ],
    u: "1f9d1-200d-1f3ed",
    v: [
      "1f9d1-1f3fb-200d-1f3ed",
      "1f9d1-1f3fc-200d-1f3ed",
      "1f9d1-1f3fd-200d-1f3ed",
      "1f9d1-1f3fe-200d-1f3ed",
      "1f9d1-1f3ff-200d-1f3ed"
    ],
    a: "12.1"
  },
  {
    n: [
      "man factory worker",
      "male-factory-worker"
    ],
    u: "1f468-200d-1f3ed",
    v: [
      "1f468-1f3fb-200d-1f3ed",
      "1f468-1f3fc-200d-1f3ed",
      "1f468-1f3fd-200d-1f3ed",
      "1f468-1f3fe-200d-1f3ed",
      "1f468-1f3ff-200d-1f3ed"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman factory worker",
      "female-factory-worker"
    ],
    u: "1f469-200d-1f3ed",
    v: [
      "1f469-1f3fb-200d-1f3ed",
      "1f469-1f3fc-200d-1f3ed",
      "1f469-1f3fd-200d-1f3ed",
      "1f469-1f3fe-200d-1f3ed",
      "1f469-1f3ff-200d-1f3ed"
    ],
    a: "4.0"
  },
  {
    n: [
      "office worker"
    ],
    u: "1f9d1-200d-1f4bc",
    v: [
      "1f9d1-1f3fb-200d-1f4bc",
      "1f9d1-1f3fc-200d-1f4bc",
      "1f9d1-1f3fd-200d-1f4bc",
      "1f9d1-1f3fe-200d-1f4bc",
      "1f9d1-1f3ff-200d-1f4bc"
    ],
    a: "12.1"
  },
  {
    n: [
      "man office worker",
      "male-office-worker"
    ],
    u: "1f468-200d-1f4bc",
    v: [
      "1f468-1f3fb-200d-1f4bc",
      "1f468-1f3fc-200d-1f4bc",
      "1f468-1f3fd-200d-1f4bc",
      "1f468-1f3fe-200d-1f4bc",
      "1f468-1f3ff-200d-1f4bc"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman office worker",
      "female-office-worker"
    ],
    u: "1f469-200d-1f4bc",
    v: [
      "1f469-1f3fb-200d-1f4bc",
      "1f469-1f3fc-200d-1f4bc",
      "1f469-1f3fd-200d-1f4bc",
      "1f469-1f3fe-200d-1f4bc",
      "1f469-1f3ff-200d-1f4bc"
    ],
    a: "4.0"
  },
  {
    n: [
      "scientist"
    ],
    u: "1f9d1-200d-1f52c",
    v: [
      "1f9d1-1f3fb-200d-1f52c",
      "1f9d1-1f3fc-200d-1f52c",
      "1f9d1-1f3fd-200d-1f52c",
      "1f9d1-1f3fe-200d-1f52c",
      "1f9d1-1f3ff-200d-1f52c"
    ],
    a: "12.1"
  },
  {
    n: [
      "man scientist",
      "male-scientist"
    ],
    u: "1f468-200d-1f52c",
    v: [
      "1f468-1f3fb-200d-1f52c",
      "1f468-1f3fc-200d-1f52c",
      "1f468-1f3fd-200d-1f52c",
      "1f468-1f3fe-200d-1f52c",
      "1f468-1f3ff-200d-1f52c"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman scientist",
      "female-scientist"
    ],
    u: "1f469-200d-1f52c",
    v: [
      "1f469-1f3fb-200d-1f52c",
      "1f469-1f3fc-200d-1f52c",
      "1f469-1f3fd-200d-1f52c",
      "1f469-1f3fe-200d-1f52c",
      "1f469-1f3ff-200d-1f52c"
    ],
    a: "4.0"
  },
  {
    n: [
      "technologist"
    ],
    u: "1f9d1-200d-1f4bb",
    v: [
      "1f9d1-1f3fb-200d-1f4bb",
      "1f9d1-1f3fc-200d-1f4bb",
      "1f9d1-1f3fd-200d-1f4bb",
      "1f9d1-1f3fe-200d-1f4bb",
      "1f9d1-1f3ff-200d-1f4bb"
    ],
    a: "12.1"
  },
  {
    n: [
      "man technologist",
      "male-technologist"
    ],
    u: "1f468-200d-1f4bb",
    v: [
      "1f468-1f3fb-200d-1f4bb",
      "1f468-1f3fc-200d-1f4bb",
      "1f468-1f3fd-200d-1f4bb",
      "1f468-1f3fe-200d-1f4bb",
      "1f468-1f3ff-200d-1f4bb"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman technologist",
      "female-technologist"
    ],
    u: "1f469-200d-1f4bb",
    v: [
      "1f469-1f3fb-200d-1f4bb",
      "1f469-1f3fc-200d-1f4bb",
      "1f469-1f3fd-200d-1f4bb",
      "1f469-1f3fe-200d-1f4bb",
      "1f469-1f3ff-200d-1f4bb"
    ],
    a: "4.0"
  },
  {
    n: [
      "singer"
    ],
    u: "1f9d1-200d-1f3a4",
    v: [
      "1f9d1-1f3fb-200d-1f3a4",
      "1f9d1-1f3fc-200d-1f3a4",
      "1f9d1-1f3fd-200d-1f3a4",
      "1f9d1-1f3fe-200d-1f3a4",
      "1f9d1-1f3ff-200d-1f3a4"
    ],
    a: "12.1"
  },
  {
    n: [
      "man singer",
      "male-singer"
    ],
    u: "1f468-200d-1f3a4",
    v: [
      "1f468-1f3fb-200d-1f3a4",
      "1f468-1f3fc-200d-1f3a4",
      "1f468-1f3fd-200d-1f3a4",
      "1f468-1f3fe-200d-1f3a4",
      "1f468-1f3ff-200d-1f3a4"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman singer",
      "female-singer"
    ],
    u: "1f469-200d-1f3a4",
    v: [
      "1f469-1f3fb-200d-1f3a4",
      "1f469-1f3fc-200d-1f3a4",
      "1f469-1f3fd-200d-1f3a4",
      "1f469-1f3fe-200d-1f3a4",
      "1f469-1f3ff-200d-1f3a4"
    ],
    a: "4.0"
  },
  {
    n: [
      "artist"
    ],
    u: "1f9d1-200d-1f3a8",
    v: [
      "1f9d1-1f3fb-200d-1f3a8",
      "1f9d1-1f3fc-200d-1f3a8",
      "1f9d1-1f3fd-200d-1f3a8",
      "1f9d1-1f3fe-200d-1f3a8",
      "1f9d1-1f3ff-200d-1f3a8"
    ],
    a: "12.1"
  },
  {
    n: [
      "man artist",
      "male-artist"
    ],
    u: "1f468-200d-1f3a8",
    v: [
      "1f468-1f3fb-200d-1f3a8",
      "1f468-1f3fc-200d-1f3a8",
      "1f468-1f3fd-200d-1f3a8",
      "1f468-1f3fe-200d-1f3a8",
      "1f468-1f3ff-200d-1f3a8"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman artist",
      "female-artist"
    ],
    u: "1f469-200d-1f3a8",
    v: [
      "1f469-1f3fb-200d-1f3a8",
      "1f469-1f3fc-200d-1f3a8",
      "1f469-1f3fd-200d-1f3a8",
      "1f469-1f3fe-200d-1f3a8",
      "1f469-1f3ff-200d-1f3a8"
    ],
    a: "4.0"
  },
  {
    n: [
      "pilot"
    ],
    u: "1f9d1-200d-2708-fe0f",
    v: [
      "1f9d1-1f3fb-200d-2708-fe0f",
      "1f9d1-1f3fc-200d-2708-fe0f",
      "1f9d1-1f3fd-200d-2708-fe0f",
      "1f9d1-1f3fe-200d-2708-fe0f",
      "1f9d1-1f3ff-200d-2708-fe0f"
    ],
    a: "12.1"
  },
  {
    n: [
      "man pilot",
      "male-pilot"
    ],
    u: "1f468-200d-2708-fe0f",
    v: [
      "1f468-1f3fb-200d-2708-fe0f",
      "1f468-1f3fc-200d-2708-fe0f",
      "1f468-1f3fd-200d-2708-fe0f",
      "1f468-1f3fe-200d-2708-fe0f",
      "1f468-1f3ff-200d-2708-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman pilot",
      "female-pilot"
    ],
    u: "1f469-200d-2708-fe0f",
    v: [
      "1f469-1f3fb-200d-2708-fe0f",
      "1f469-1f3fc-200d-2708-fe0f",
      "1f469-1f3fd-200d-2708-fe0f",
      "1f469-1f3fe-200d-2708-fe0f",
      "1f469-1f3ff-200d-2708-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "astronaut"
    ],
    u: "1f9d1-200d-1f680",
    v: [
      "1f9d1-1f3fb-200d-1f680",
      "1f9d1-1f3fc-200d-1f680",
      "1f9d1-1f3fd-200d-1f680",
      "1f9d1-1f3fe-200d-1f680",
      "1f9d1-1f3ff-200d-1f680"
    ],
    a: "12.1"
  },
  {
    n: [
      "man astronaut",
      "male-astronaut"
    ],
    u: "1f468-200d-1f680",
    v: [
      "1f468-1f3fb-200d-1f680",
      "1f468-1f3fc-200d-1f680",
      "1f468-1f3fd-200d-1f680",
      "1f468-1f3fe-200d-1f680",
      "1f468-1f3ff-200d-1f680"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman astronaut",
      "female-astronaut"
    ],
    u: "1f469-200d-1f680",
    v: [
      "1f469-1f3fb-200d-1f680",
      "1f469-1f3fc-200d-1f680",
      "1f469-1f3fd-200d-1f680",
      "1f469-1f3fe-200d-1f680",
      "1f469-1f3ff-200d-1f680"
    ],
    a: "4.0"
  },
  {
    n: [
      "firefighter"
    ],
    u: "1f9d1-200d-1f692",
    v: [
      "1f9d1-1f3fb-200d-1f692",
      "1f9d1-1f3fc-200d-1f692",
      "1f9d1-1f3fd-200d-1f692",
      "1f9d1-1f3fe-200d-1f692",
      "1f9d1-1f3ff-200d-1f692"
    ],
    a: "12.1"
  },
  {
    n: [
      "man firefighter",
      "male-firefighter"
    ],
    u: "1f468-200d-1f692",
    v: [
      "1f468-1f3fb-200d-1f692",
      "1f468-1f3fc-200d-1f692",
      "1f468-1f3fd-200d-1f692",
      "1f468-1f3fe-200d-1f692",
      "1f468-1f3ff-200d-1f692"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman firefighter",
      "female-firefighter"
    ],
    u: "1f469-200d-1f692",
    v: [
      "1f469-1f3fb-200d-1f692",
      "1f469-1f3fc-200d-1f692",
      "1f469-1f3fd-200d-1f692",
      "1f469-1f3fe-200d-1f692",
      "1f469-1f3ff-200d-1f692"
    ],
    a: "4.0"
  },
  {
    n: [
      "cop",
      "police officer"
    ],
    u: "1f46e",
    v: [
      "1f46e-1f3fb",
      "1f46e-1f3fc",
      "1f46e-1f3fd",
      "1f46e-1f3fe",
      "1f46e-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man police officer",
      "male-police-officer"
    ],
    u: "1f46e-200d-2642-fe0f",
    v: [
      "1f46e-1f3fb-200d-2642-fe0f",
      "1f46e-1f3fc-200d-2642-fe0f",
      "1f46e-1f3fd-200d-2642-fe0f",
      "1f46e-1f3fe-200d-2642-fe0f",
      "1f46e-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman police officer",
      "female-police-officer"
    ],
    u: "1f46e-200d-2640-fe0f",
    v: [
      "1f46e-1f3fb-200d-2640-fe0f",
      "1f46e-1f3fc-200d-2640-fe0f",
      "1f46e-1f3fd-200d-2640-fe0f",
      "1f46e-1f3fe-200d-2640-fe0f",
      "1f46e-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "detective",
      "sleuth or spy"
    ],
    u: "1f575-fe0f",
    v: [
      "1f575-1f3fb",
      "1f575-1f3fc",
      "1f575-1f3fd",
      "1f575-1f3fe",
      "1f575-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "man detective",
      "male-detective"
    ],
    u: "1f575-fe0f-200d-2642-fe0f",
    v: [
      "1f575-1f3fb-200d-2642-fe0f",
      "1f575-1f3fc-200d-2642-fe0f",
      "1f575-1f3fd-200d-2642-fe0f",
      "1f575-1f3fe-200d-2642-fe0f",
      "1f575-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman detective",
      "female-detective"
    ],
    u: "1f575-fe0f-200d-2640-fe0f",
    v: [
      "1f575-1f3fb-200d-2640-fe0f",
      "1f575-1f3fc-200d-2640-fe0f",
      "1f575-1f3fd-200d-2640-fe0f",
      "1f575-1f3fe-200d-2640-fe0f",
      "1f575-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "guardsman"
    ],
    u: "1f482",
    v: [
      "1f482-1f3fb",
      "1f482-1f3fc",
      "1f482-1f3fd",
      "1f482-1f3fe",
      "1f482-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man guard",
      "male-guard"
    ],
    u: "1f482-200d-2642-fe0f",
    v: [
      "1f482-1f3fb-200d-2642-fe0f",
      "1f482-1f3fc-200d-2642-fe0f",
      "1f482-1f3fd-200d-2642-fe0f",
      "1f482-1f3fe-200d-2642-fe0f",
      "1f482-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman guard",
      "female-guard"
    ],
    u: "1f482-200d-2640-fe0f",
    v: [
      "1f482-1f3fb-200d-2640-fe0f",
      "1f482-1f3fc-200d-2640-fe0f",
      "1f482-1f3fd-200d-2640-fe0f",
      "1f482-1f3fe-200d-2640-fe0f",
      "1f482-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "ninja"
    ],
    u: "1f977",
    v: [
      "1f977-1f3fb",
      "1f977-1f3fc",
      "1f977-1f3fd",
      "1f977-1f3fe",
      "1f977-1f3ff"
    ],
    a: "13.0"
  },
  {
    n: [
      "construction worker"
    ],
    u: "1f477",
    v: [
      "1f477-1f3fb",
      "1f477-1f3fc",
      "1f477-1f3fd",
      "1f477-1f3fe",
      "1f477-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man construction worker",
      "male-construction-worker"
    ],
    u: "1f477-200d-2642-fe0f",
    v: [
      "1f477-1f3fb-200d-2642-fe0f",
      "1f477-1f3fc-200d-2642-fe0f",
      "1f477-1f3fd-200d-2642-fe0f",
      "1f477-1f3fe-200d-2642-fe0f",
      "1f477-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman construction worker",
      "female-construction-worker"
    ],
    u: "1f477-200d-2640-fe0f",
    v: [
      "1f477-1f3fb-200d-2640-fe0f",
      "1f477-1f3fc-200d-2640-fe0f",
      "1f477-1f3fd-200d-2640-fe0f",
      "1f477-1f3fe-200d-2640-fe0f",
      "1f477-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person with crown"
    ],
    u: "1fac5",
    v: [
      "1fac5-1f3fb",
      "1fac5-1f3fc",
      "1fac5-1f3fd",
      "1fac5-1f3fe",
      "1fac5-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "prince"
    ],
    u: "1f934",
    v: [
      "1f934-1f3fb",
      "1f934-1f3fc",
      "1f934-1f3fd",
      "1f934-1f3fe",
      "1f934-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "princess"
    ],
    u: "1f478",
    v: [
      "1f478-1f3fb",
      "1f478-1f3fc",
      "1f478-1f3fd",
      "1f478-1f3fe",
      "1f478-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man with turban"
    ],
    u: "1f473",
    v: [
      "1f473-1f3fb",
      "1f473-1f3fc",
      "1f473-1f3fd",
      "1f473-1f3fe",
      "1f473-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man wearing turban",
      "man-wearing-turban"
    ],
    u: "1f473-200d-2642-fe0f",
    v: [
      "1f473-1f3fb-200d-2642-fe0f",
      "1f473-1f3fc-200d-2642-fe0f",
      "1f473-1f3fd-200d-2642-fe0f",
      "1f473-1f3fe-200d-2642-fe0f",
      "1f473-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman wearing turban",
      "woman-wearing-turban"
    ],
    u: "1f473-200d-2640-fe0f",
    v: [
      "1f473-1f3fb-200d-2640-fe0f",
      "1f473-1f3fc-200d-2640-fe0f",
      "1f473-1f3fd-200d-2640-fe0f",
      "1f473-1f3fe-200d-2640-fe0f",
      "1f473-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "man with gua pi mao"
    ],
    u: "1f472",
    v: [
      "1f472-1f3fb",
      "1f472-1f3fc",
      "1f472-1f3fd",
      "1f472-1f3fe",
      "1f472-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "person with headscarf"
    ],
    u: "1f9d5",
    v: [
      "1f9d5-1f3fb",
      "1f9d5-1f3fc",
      "1f9d5-1f3fd",
      "1f9d5-1f3fe",
      "1f9d5-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man in tuxedo",
      "person in tuxedo"
    ],
    u: "1f935",
    v: [
      "1f935-1f3fb",
      "1f935-1f3fc",
      "1f935-1f3fd",
      "1f935-1f3fe",
      "1f935-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man in tuxedo"
    ],
    u: "1f935-200d-2642-fe0f",
    v: [
      "1f935-1f3fb-200d-2642-fe0f",
      "1f935-1f3fc-200d-2642-fe0f",
      "1f935-1f3fd-200d-2642-fe0f",
      "1f935-1f3fe-200d-2642-fe0f",
      "1f935-1f3ff-200d-2642-fe0f"
    ],
    a: "13.0"
  },
  {
    n: [
      "woman in tuxedo"
    ],
    u: "1f935-200d-2640-fe0f",
    v: [
      "1f935-1f3fb-200d-2640-fe0f",
      "1f935-1f3fc-200d-2640-fe0f",
      "1f935-1f3fd-200d-2640-fe0f",
      "1f935-1f3fe-200d-2640-fe0f",
      "1f935-1f3ff-200d-2640-fe0f"
    ],
    a: "13.0"
  },
  {
    n: [
      "bride with veil"
    ],
    u: "1f470",
    v: [
      "1f470-1f3fb",
      "1f470-1f3fc",
      "1f470-1f3fd",
      "1f470-1f3fe",
      "1f470-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man with veil"
    ],
    u: "1f470-200d-2642-fe0f",
    v: [
      "1f470-1f3fb-200d-2642-fe0f",
      "1f470-1f3fc-200d-2642-fe0f",
      "1f470-1f3fd-200d-2642-fe0f",
      "1f470-1f3fe-200d-2642-fe0f",
      "1f470-1f3ff-200d-2642-fe0f"
    ],
    a: "13.0"
  },
  {
    n: [
      "woman with veil"
    ],
    u: "1f470-200d-2640-fe0f",
    v: [
      "1f470-1f3fb-200d-2640-fe0f",
      "1f470-1f3fc-200d-2640-fe0f",
      "1f470-1f3fd-200d-2640-fe0f",
      "1f470-1f3fe-200d-2640-fe0f",
      "1f470-1f3ff-200d-2640-fe0f"
    ],
    a: "13.0"
  },
  {
    n: [
      "pregnant woman"
    ],
    u: "1f930",
    v: [
      "1f930-1f3fb",
      "1f930-1f3fc",
      "1f930-1f3fd",
      "1f930-1f3fe",
      "1f930-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "pregnant man"
    ],
    u: "1fac3",
    v: [
      "1fac3-1f3fb",
      "1fac3-1f3fc",
      "1fac3-1f3fd",
      "1fac3-1f3fe",
      "1fac3-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "pregnant person"
    ],
    u: "1fac4",
    v: [
      "1fac4-1f3fb",
      "1fac4-1f3fc",
      "1fac4-1f3fd",
      "1fac4-1f3fe",
      "1fac4-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "breast-feeding"
    ],
    u: "1f931",
    v: [
      "1f931-1f3fb",
      "1f931-1f3fc",
      "1f931-1f3fd",
      "1f931-1f3fe",
      "1f931-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman feeding baby"
    ],
    u: "1f469-200d-1f37c",
    v: [
      "1f469-1f3fb-200d-1f37c",
      "1f469-1f3fc-200d-1f37c",
      "1f469-1f3fd-200d-1f37c",
      "1f469-1f3fe-200d-1f37c",
      "1f469-1f3ff-200d-1f37c"
    ],
    a: "13.0"
  },
  {
    n: [
      "man feeding baby"
    ],
    u: "1f468-200d-1f37c",
    v: [
      "1f468-1f3fb-200d-1f37c",
      "1f468-1f3fc-200d-1f37c",
      "1f468-1f3fd-200d-1f37c",
      "1f468-1f3fe-200d-1f37c",
      "1f468-1f3ff-200d-1f37c"
    ],
    a: "13.0"
  },
  {
    n: [
      "person feeding baby"
    ],
    u: "1f9d1-200d-1f37c",
    v: [
      "1f9d1-1f3fb-200d-1f37c",
      "1f9d1-1f3fc-200d-1f37c",
      "1f9d1-1f3fd-200d-1f37c",
      "1f9d1-1f3fe-200d-1f37c",
      "1f9d1-1f3ff-200d-1f37c"
    ],
    a: "13.0"
  },
  {
    n: [
      "angel",
      "baby angel"
    ],
    u: "1f47c",
    v: [
      "1f47c-1f3fb",
      "1f47c-1f3fc",
      "1f47c-1f3fd",
      "1f47c-1f3fe",
      "1f47c-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "santa",
      "father christmas"
    ],
    u: "1f385",
    v: [
      "1f385-1f3fb",
      "1f385-1f3fc",
      "1f385-1f3fd",
      "1f385-1f3fe",
      "1f385-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "mrs claus",
      "mother christmas"
    ],
    u: "1f936",
    v: [
      "1f936-1f3fb",
      "1f936-1f3fc",
      "1f936-1f3fd",
      "1f936-1f3fe",
      "1f936-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "mx claus"
    ],
    u: "1f9d1-200d-1f384",
    v: [
      "1f9d1-1f3fb-200d-1f384",
      "1f9d1-1f3fc-200d-1f384",
      "1f9d1-1f3fd-200d-1f384",
      "1f9d1-1f3fe-200d-1f384",
      "1f9d1-1f3ff-200d-1f384"
    ],
    a: "13.0"
  },
  {
    n: [
      "superhero"
    ],
    u: "1f9b8",
    v: [
      "1f9b8-1f3fb",
      "1f9b8-1f3fc",
      "1f9b8-1f3fd",
      "1f9b8-1f3fe",
      "1f9b8-1f3ff"
    ],
    a: "11.0"
  },
  {
    n: [
      "man superhero",
      "male superhero"
    ],
    u: "1f9b8-200d-2642-fe0f",
    v: [
      "1f9b8-1f3fb-200d-2642-fe0f",
      "1f9b8-1f3fc-200d-2642-fe0f",
      "1f9b8-1f3fd-200d-2642-fe0f",
      "1f9b8-1f3fe-200d-2642-fe0f",
      "1f9b8-1f3ff-200d-2642-fe0f"
    ],
    a: "11.0"
  },
  {
    n: [
      "woman superhero",
      "female superhero"
    ],
    u: "1f9b8-200d-2640-fe0f",
    v: [
      "1f9b8-1f3fb-200d-2640-fe0f",
      "1f9b8-1f3fc-200d-2640-fe0f",
      "1f9b8-1f3fd-200d-2640-fe0f",
      "1f9b8-1f3fe-200d-2640-fe0f",
      "1f9b8-1f3ff-200d-2640-fe0f"
    ],
    a: "11.0"
  },
  {
    n: [
      "supervillain"
    ],
    u: "1f9b9",
    v: [
      "1f9b9-1f3fb",
      "1f9b9-1f3fc",
      "1f9b9-1f3fd",
      "1f9b9-1f3fe",
      "1f9b9-1f3ff"
    ],
    a: "11.0"
  },
  {
    n: [
      "man supervillain",
      "male supervillain"
    ],
    u: "1f9b9-200d-2642-fe0f",
    v: [
      "1f9b9-1f3fb-200d-2642-fe0f",
      "1f9b9-1f3fc-200d-2642-fe0f",
      "1f9b9-1f3fd-200d-2642-fe0f",
      "1f9b9-1f3fe-200d-2642-fe0f",
      "1f9b9-1f3ff-200d-2642-fe0f"
    ],
    a: "11.0"
  },
  {
    n: [
      "woman supervillain",
      "female supervillain"
    ],
    u: "1f9b9-200d-2640-fe0f",
    v: [
      "1f9b9-1f3fb-200d-2640-fe0f",
      "1f9b9-1f3fc-200d-2640-fe0f",
      "1f9b9-1f3fd-200d-2640-fe0f",
      "1f9b9-1f3fe-200d-2640-fe0f",
      "1f9b9-1f3ff-200d-2640-fe0f"
    ],
    a: "11.0"
  },
  {
    n: [
      "mage"
    ],
    u: "1f9d9",
    v: [
      "1f9d9-1f3fb",
      "1f9d9-1f3fc",
      "1f9d9-1f3fd",
      "1f9d9-1f3fe",
      "1f9d9-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man mage",
      "male mage"
    ],
    u: "1f9d9-200d-2642-fe0f",
    v: [
      "1f9d9-1f3fb-200d-2642-fe0f",
      "1f9d9-1f3fc-200d-2642-fe0f",
      "1f9d9-1f3fd-200d-2642-fe0f",
      "1f9d9-1f3fe-200d-2642-fe0f",
      "1f9d9-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman mage",
      "female mage"
    ],
    u: "1f9d9-200d-2640-fe0f",
    v: [
      "1f9d9-1f3fb-200d-2640-fe0f",
      "1f9d9-1f3fc-200d-2640-fe0f",
      "1f9d9-1f3fd-200d-2640-fe0f",
      "1f9d9-1f3fe-200d-2640-fe0f",
      "1f9d9-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "fairy"
    ],
    u: "1f9da",
    v: [
      "1f9da-1f3fb",
      "1f9da-1f3fc",
      "1f9da-1f3fd",
      "1f9da-1f3fe",
      "1f9da-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man fairy",
      "male fairy"
    ],
    u: "1f9da-200d-2642-fe0f",
    v: [
      "1f9da-1f3fb-200d-2642-fe0f",
      "1f9da-1f3fc-200d-2642-fe0f",
      "1f9da-1f3fd-200d-2642-fe0f",
      "1f9da-1f3fe-200d-2642-fe0f",
      "1f9da-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman fairy",
      "female fairy"
    ],
    u: "1f9da-200d-2640-fe0f",
    v: [
      "1f9da-1f3fb-200d-2640-fe0f",
      "1f9da-1f3fc-200d-2640-fe0f",
      "1f9da-1f3fd-200d-2640-fe0f",
      "1f9da-1f3fe-200d-2640-fe0f",
      "1f9da-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "vampire"
    ],
    u: "1f9db",
    v: [
      "1f9db-1f3fb",
      "1f9db-1f3fc",
      "1f9db-1f3fd",
      "1f9db-1f3fe",
      "1f9db-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man vampire",
      "male vampire"
    ],
    u: "1f9db-200d-2642-fe0f",
    v: [
      "1f9db-1f3fb-200d-2642-fe0f",
      "1f9db-1f3fc-200d-2642-fe0f",
      "1f9db-1f3fd-200d-2642-fe0f",
      "1f9db-1f3fe-200d-2642-fe0f",
      "1f9db-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman vampire",
      "female vampire"
    ],
    u: "1f9db-200d-2640-fe0f",
    v: [
      "1f9db-1f3fb-200d-2640-fe0f",
      "1f9db-1f3fc-200d-2640-fe0f",
      "1f9db-1f3fd-200d-2640-fe0f",
      "1f9db-1f3fe-200d-2640-fe0f",
      "1f9db-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "merperson"
    ],
    u: "1f9dc",
    v: [
      "1f9dc-1f3fb",
      "1f9dc-1f3fc",
      "1f9dc-1f3fd",
      "1f9dc-1f3fe",
      "1f9dc-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "merman"
    ],
    u: "1f9dc-200d-2642-fe0f",
    v: [
      "1f9dc-1f3fb-200d-2642-fe0f",
      "1f9dc-1f3fc-200d-2642-fe0f",
      "1f9dc-1f3fd-200d-2642-fe0f",
      "1f9dc-1f3fe-200d-2642-fe0f",
      "1f9dc-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "mermaid"
    ],
    u: "1f9dc-200d-2640-fe0f",
    v: [
      "1f9dc-1f3fb-200d-2640-fe0f",
      "1f9dc-1f3fc-200d-2640-fe0f",
      "1f9dc-1f3fd-200d-2640-fe0f",
      "1f9dc-1f3fe-200d-2640-fe0f",
      "1f9dc-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "elf"
    ],
    u: "1f9dd",
    v: [
      "1f9dd-1f3fb",
      "1f9dd-1f3fc",
      "1f9dd-1f3fd",
      "1f9dd-1f3fe",
      "1f9dd-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man elf",
      "male elf"
    ],
    u: "1f9dd-200d-2642-fe0f",
    v: [
      "1f9dd-1f3fb-200d-2642-fe0f",
      "1f9dd-1f3fc-200d-2642-fe0f",
      "1f9dd-1f3fd-200d-2642-fe0f",
      "1f9dd-1f3fe-200d-2642-fe0f",
      "1f9dd-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman elf",
      "female elf"
    ],
    u: "1f9dd-200d-2640-fe0f",
    v: [
      "1f9dd-1f3fb-200d-2640-fe0f",
      "1f9dd-1f3fc-200d-2640-fe0f",
      "1f9dd-1f3fd-200d-2640-fe0f",
      "1f9dd-1f3fe-200d-2640-fe0f",
      "1f9dd-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "genie"
    ],
    u: "1f9de",
    a: "5.0"
  },
  {
    n: [
      "man genie",
      "male genie"
    ],
    u: "1f9de-200d-2642-fe0f",
    a: "5.0"
  },
  {
    n: [
      "woman genie",
      "female genie"
    ],
    u: "1f9de-200d-2640-fe0f",
    a: "5.0"
  },
  {
    n: [
      "zombie"
    ],
    u: "1f9df",
    a: "5.0"
  },
  {
    n: [
      "man zombie",
      "male zombie"
    ],
    u: "1f9df-200d-2642-fe0f",
    a: "5.0"
  },
  {
    n: [
      "woman zombie",
      "female zombie"
    ],
    u: "1f9df-200d-2640-fe0f",
    a: "5.0"
  },
  {
    n: [
      "troll"
    ],
    u: "1f9cc",
    a: "14.0"
  },
  {
    n: [
      "massage",
      "face massage"
    ],
    u: "1f486",
    v: [
      "1f486-1f3fb",
      "1f486-1f3fc",
      "1f486-1f3fd",
      "1f486-1f3fe",
      "1f486-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man getting massage",
      "man-getting-massage"
    ],
    u: "1f486-200d-2642-fe0f",
    v: [
      "1f486-1f3fb-200d-2642-fe0f",
      "1f486-1f3fc-200d-2642-fe0f",
      "1f486-1f3fd-200d-2642-fe0f",
      "1f486-1f3fe-200d-2642-fe0f",
      "1f486-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman getting massage",
      "woman-getting-massage"
    ],
    u: "1f486-200d-2640-fe0f",
    v: [
      "1f486-1f3fb-200d-2640-fe0f",
      "1f486-1f3fc-200d-2640-fe0f",
      "1f486-1f3fd-200d-2640-fe0f",
      "1f486-1f3fe-200d-2640-fe0f",
      "1f486-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "haircut"
    ],
    u: "1f487",
    v: [
      "1f487-1f3fb",
      "1f487-1f3fc",
      "1f487-1f3fd",
      "1f487-1f3fe",
      "1f487-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man getting haircut",
      "man-getting-haircut"
    ],
    u: "1f487-200d-2642-fe0f",
    v: [
      "1f487-1f3fb-200d-2642-fe0f",
      "1f487-1f3fc-200d-2642-fe0f",
      "1f487-1f3fd-200d-2642-fe0f",
      "1f487-1f3fe-200d-2642-fe0f",
      "1f487-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman getting haircut",
      "woman-getting-haircut"
    ],
    u: "1f487-200d-2640-fe0f",
    v: [
      "1f487-1f3fb-200d-2640-fe0f",
      "1f487-1f3fc-200d-2640-fe0f",
      "1f487-1f3fd-200d-2640-fe0f",
      "1f487-1f3fe-200d-2640-fe0f",
      "1f487-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "walking",
      "pedestrian"
    ],
    u: "1f6b6",
    v: [
      "1f6b6-1f3fb",
      "1f6b6-1f3fc",
      "1f6b6-1f3fd",
      "1f6b6-1f3fe",
      "1f6b6-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man walking",
      "man-walking"
    ],
    u: "1f6b6-200d-2642-fe0f",
    v: [
      "1f6b6-1f3fb-200d-2642-fe0f",
      "1f6b6-1f3fc-200d-2642-fe0f",
      "1f6b6-1f3fd-200d-2642-fe0f",
      "1f6b6-1f3fe-200d-2642-fe0f",
      "1f6b6-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman walking",
      "woman-walking"
    ],
    u: "1f6b6-200d-2640-fe0f",
    v: [
      "1f6b6-1f3fb-200d-2640-fe0f",
      "1f6b6-1f3fc-200d-2640-fe0f",
      "1f6b6-1f3fd-200d-2640-fe0f",
      "1f6b6-1f3fe-200d-2640-fe0f",
      "1f6b6-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "standing person"
    ],
    u: "1f9cd",
    v: [
      "1f9cd-1f3fb",
      "1f9cd-1f3fc",
      "1f9cd-1f3fd",
      "1f9cd-1f3fe",
      "1f9cd-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "man standing"
    ],
    u: "1f9cd-200d-2642-fe0f",
    v: [
      "1f9cd-1f3fb-200d-2642-fe0f",
      "1f9cd-1f3fc-200d-2642-fe0f",
      "1f9cd-1f3fd-200d-2642-fe0f",
      "1f9cd-1f3fe-200d-2642-fe0f",
      "1f9cd-1f3ff-200d-2642-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman standing"
    ],
    u: "1f9cd-200d-2640-fe0f",
    v: [
      "1f9cd-1f3fb-200d-2640-fe0f",
      "1f9cd-1f3fc-200d-2640-fe0f",
      "1f9cd-1f3fd-200d-2640-fe0f",
      "1f9cd-1f3fe-200d-2640-fe0f",
      "1f9cd-1f3ff-200d-2640-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "kneeling person"
    ],
    u: "1f9ce",
    v: [
      "1f9ce-1f3fb",
      "1f9ce-1f3fc",
      "1f9ce-1f3fd",
      "1f9ce-1f3fe",
      "1f9ce-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "man kneeling"
    ],
    u: "1f9ce-200d-2642-fe0f",
    v: [
      "1f9ce-1f3fb-200d-2642-fe0f",
      "1f9ce-1f3fc-200d-2642-fe0f",
      "1f9ce-1f3fd-200d-2642-fe0f",
      "1f9ce-1f3fe-200d-2642-fe0f",
      "1f9ce-1f3ff-200d-2642-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman kneeling"
    ],
    u: "1f9ce-200d-2640-fe0f",
    v: [
      "1f9ce-1f3fb-200d-2640-fe0f",
      "1f9ce-1f3fc-200d-2640-fe0f",
      "1f9ce-1f3fd-200d-2640-fe0f",
      "1f9ce-1f3fe-200d-2640-fe0f",
      "1f9ce-1f3ff-200d-2640-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "person with white cane",
      "person with probing cane"
    ],
    u: "1f9d1-200d-1f9af",
    v: [
      "1f9d1-1f3fb-200d-1f9af",
      "1f9d1-1f3fc-200d-1f9af",
      "1f9d1-1f3fd-200d-1f9af",
      "1f9d1-1f3fe-200d-1f9af",
      "1f9d1-1f3ff-200d-1f9af"
    ],
    a: "12.1"
  },
  {
    n: [
      "man with white cane",
      "man with probing cane"
    ],
    u: "1f468-200d-1f9af",
    v: [
      "1f468-1f3fb-200d-1f9af",
      "1f468-1f3fc-200d-1f9af",
      "1f468-1f3fd-200d-1f9af",
      "1f468-1f3fe-200d-1f9af",
      "1f468-1f3ff-200d-1f9af"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman with white cane",
      "woman with probing cane"
    ],
    u: "1f469-200d-1f9af",
    v: [
      "1f469-1f3fb-200d-1f9af",
      "1f469-1f3fc-200d-1f9af",
      "1f469-1f3fd-200d-1f9af",
      "1f469-1f3fe-200d-1f9af",
      "1f469-1f3ff-200d-1f9af"
    ],
    a: "12.0"
  },
  {
    n: [
      "person in motorized wheelchair"
    ],
    u: "1f9d1-200d-1f9bc",
    v: [
      "1f9d1-1f3fb-200d-1f9bc",
      "1f9d1-1f3fc-200d-1f9bc",
      "1f9d1-1f3fd-200d-1f9bc",
      "1f9d1-1f3fe-200d-1f9bc",
      "1f9d1-1f3ff-200d-1f9bc"
    ],
    a: "12.1"
  },
  {
    n: [
      "man in motorized wheelchair"
    ],
    u: "1f468-200d-1f9bc",
    v: [
      "1f468-1f3fb-200d-1f9bc",
      "1f468-1f3fc-200d-1f9bc",
      "1f468-1f3fd-200d-1f9bc",
      "1f468-1f3fe-200d-1f9bc",
      "1f468-1f3ff-200d-1f9bc"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman in motorized wheelchair"
    ],
    u: "1f469-200d-1f9bc",
    v: [
      "1f469-1f3fb-200d-1f9bc",
      "1f469-1f3fc-200d-1f9bc",
      "1f469-1f3fd-200d-1f9bc",
      "1f469-1f3fe-200d-1f9bc",
      "1f469-1f3ff-200d-1f9bc"
    ],
    a: "12.0"
  },
  {
    n: [
      "person in manual wheelchair"
    ],
    u: "1f9d1-200d-1f9bd",
    v: [
      "1f9d1-1f3fb-200d-1f9bd",
      "1f9d1-1f3fc-200d-1f9bd",
      "1f9d1-1f3fd-200d-1f9bd",
      "1f9d1-1f3fe-200d-1f9bd",
      "1f9d1-1f3ff-200d-1f9bd"
    ],
    a: "12.1"
  },
  {
    n: [
      "man in manual wheelchair"
    ],
    u: "1f468-200d-1f9bd",
    v: [
      "1f468-1f3fb-200d-1f9bd",
      "1f468-1f3fc-200d-1f9bd",
      "1f468-1f3fd-200d-1f9bd",
      "1f468-1f3fe-200d-1f9bd",
      "1f468-1f3ff-200d-1f9bd"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman in manual wheelchair"
    ],
    u: "1f469-200d-1f9bd",
    v: [
      "1f469-1f3fb-200d-1f9bd",
      "1f469-1f3fc-200d-1f9bd",
      "1f469-1f3fd-200d-1f9bd",
      "1f469-1f3fe-200d-1f9bd",
      "1f469-1f3ff-200d-1f9bd"
    ],
    a: "12.0"
  },
  {
    n: [
      "runner",
      "running"
    ],
    u: "1f3c3",
    v: [
      "1f3c3-1f3fb",
      "1f3c3-1f3fc",
      "1f3c3-1f3fd",
      "1f3c3-1f3fe",
      "1f3c3-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man running",
      "man-running"
    ],
    u: "1f3c3-200d-2642-fe0f",
    v: [
      "1f3c3-1f3fb-200d-2642-fe0f",
      "1f3c3-1f3fc-200d-2642-fe0f",
      "1f3c3-1f3fd-200d-2642-fe0f",
      "1f3c3-1f3fe-200d-2642-fe0f",
      "1f3c3-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman running",
      "woman-running"
    ],
    u: "1f3c3-200d-2640-fe0f",
    v: [
      "1f3c3-1f3fb-200d-2640-fe0f",
      "1f3c3-1f3fc-200d-2640-fe0f",
      "1f3c3-1f3fd-200d-2640-fe0f",
      "1f3c3-1f3fe-200d-2640-fe0f",
      "1f3c3-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "dancer"
    ],
    u: "1f483",
    v: [
      "1f483-1f3fb",
      "1f483-1f3fc",
      "1f483-1f3fd",
      "1f483-1f3fe",
      "1f483-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man dancing"
    ],
    u: "1f57a",
    v: [
      "1f57a-1f3fb",
      "1f57a-1f3fc",
      "1f57a-1f3fd",
      "1f57a-1f3fe",
      "1f57a-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "person in suit levitating",
      "man in business suit levitating"
    ],
    u: "1f574-fe0f",
    v: [
      "1f574-1f3fb",
      "1f574-1f3fc",
      "1f574-1f3fd",
      "1f574-1f3fe",
      "1f574-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "dancers",
      "woman with bunny ears"
    ],
    u: "1f46f",
    a: "0.6"
  },
  {
    n: [
      "men with bunny ears",
      "men-with-bunny-ears-partying",
      "man-with-bunny-ears-partying"
    ],
    u: "1f46f-200d-2642-fe0f",
    a: "4.0"
  },
  {
    n: [
      "women with bunny ears",
      "women-with-bunny-ears-partying",
      "woman-with-bunny-ears-partying"
    ],
    u: "1f46f-200d-2640-fe0f",
    a: "4.0"
  },
  {
    n: [
      "person in steamy room"
    ],
    u: "1f9d6",
    v: [
      "1f9d6-1f3fb",
      "1f9d6-1f3fc",
      "1f9d6-1f3fd",
      "1f9d6-1f3fe",
      "1f9d6-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man in steamy room"
    ],
    u: "1f9d6-200d-2642-fe0f",
    v: [
      "1f9d6-1f3fb-200d-2642-fe0f",
      "1f9d6-1f3fc-200d-2642-fe0f",
      "1f9d6-1f3fd-200d-2642-fe0f",
      "1f9d6-1f3fe-200d-2642-fe0f",
      "1f9d6-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman in steamy room"
    ],
    u: "1f9d6-200d-2640-fe0f",
    v: [
      "1f9d6-1f3fb-200d-2640-fe0f",
      "1f9d6-1f3fc-200d-2640-fe0f",
      "1f9d6-1f3fd-200d-2640-fe0f",
      "1f9d6-1f3fe-200d-2640-fe0f",
      "1f9d6-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "person climbing"
    ],
    u: "1f9d7",
    v: [
      "1f9d7-1f3fb",
      "1f9d7-1f3fc",
      "1f9d7-1f3fd",
      "1f9d7-1f3fe",
      "1f9d7-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man climbing"
    ],
    u: "1f9d7-200d-2642-fe0f",
    v: [
      "1f9d7-1f3fb-200d-2642-fe0f",
      "1f9d7-1f3fc-200d-2642-fe0f",
      "1f9d7-1f3fd-200d-2642-fe0f",
      "1f9d7-1f3fe-200d-2642-fe0f",
      "1f9d7-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman climbing"
    ],
    u: "1f9d7-200d-2640-fe0f",
    v: [
      "1f9d7-1f3fb-200d-2640-fe0f",
      "1f9d7-1f3fc-200d-2640-fe0f",
      "1f9d7-1f3fd-200d-2640-fe0f",
      "1f9d7-1f3fe-200d-2640-fe0f",
      "1f9d7-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "fencer"
    ],
    u: "1f93a",
    a: "3.0"
  },
  {
    n: [
      "horse racing"
    ],
    u: "1f3c7",
    v: [
      "1f3c7-1f3fb",
      "1f3c7-1f3fc",
      "1f3c7-1f3fd",
      "1f3c7-1f3fe",
      "1f3c7-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "skier"
    ],
    u: "26f7-fe0f",
    a: "0.7"
  },
  {
    n: [
      "snowboarder"
    ],
    u: "1f3c2",
    v: [
      "1f3c2-1f3fb",
      "1f3c2-1f3fc",
      "1f3c2-1f3fd",
      "1f3c2-1f3fe",
      "1f3c2-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "golfer",
      "person golfing"
    ],
    u: "1f3cc-fe0f",
    v: [
      "1f3cc-1f3fb",
      "1f3cc-1f3fc",
      "1f3cc-1f3fd",
      "1f3cc-1f3fe",
      "1f3cc-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "man golfing",
      "man-golfing"
    ],
    u: "1f3cc-fe0f-200d-2642-fe0f",
    v: [
      "1f3cc-1f3fb-200d-2642-fe0f",
      "1f3cc-1f3fc-200d-2642-fe0f",
      "1f3cc-1f3fd-200d-2642-fe0f",
      "1f3cc-1f3fe-200d-2642-fe0f",
      "1f3cc-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman golfing",
      "woman-golfing"
    ],
    u: "1f3cc-fe0f-200d-2640-fe0f",
    v: [
      "1f3cc-1f3fb-200d-2640-fe0f",
      "1f3cc-1f3fc-200d-2640-fe0f",
      "1f3cc-1f3fd-200d-2640-fe0f",
      "1f3cc-1f3fe-200d-2640-fe0f",
      "1f3cc-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "surfer"
    ],
    u: "1f3c4",
    v: [
      "1f3c4-1f3fb",
      "1f3c4-1f3fc",
      "1f3c4-1f3fd",
      "1f3c4-1f3fe",
      "1f3c4-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man surfing",
      "man-surfing"
    ],
    u: "1f3c4-200d-2642-fe0f",
    v: [
      "1f3c4-1f3fb-200d-2642-fe0f",
      "1f3c4-1f3fc-200d-2642-fe0f",
      "1f3c4-1f3fd-200d-2642-fe0f",
      "1f3c4-1f3fe-200d-2642-fe0f",
      "1f3c4-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman surfing",
      "woman-surfing"
    ],
    u: "1f3c4-200d-2640-fe0f",
    v: [
      "1f3c4-1f3fb-200d-2640-fe0f",
      "1f3c4-1f3fc-200d-2640-fe0f",
      "1f3c4-1f3fd-200d-2640-fe0f",
      "1f3c4-1f3fe-200d-2640-fe0f",
      "1f3c4-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "rowboat"
    ],
    u: "1f6a3",
    v: [
      "1f6a3-1f3fb",
      "1f6a3-1f3fc",
      "1f6a3-1f3fd",
      "1f6a3-1f3fe",
      "1f6a3-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "man rowing boat",
      "man-rowing-boat"
    ],
    u: "1f6a3-200d-2642-fe0f",
    v: [
      "1f6a3-1f3fb-200d-2642-fe0f",
      "1f6a3-1f3fc-200d-2642-fe0f",
      "1f6a3-1f3fd-200d-2642-fe0f",
      "1f6a3-1f3fe-200d-2642-fe0f",
      "1f6a3-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman rowing boat",
      "woman-rowing-boat"
    ],
    u: "1f6a3-200d-2640-fe0f",
    v: [
      "1f6a3-1f3fb-200d-2640-fe0f",
      "1f6a3-1f3fc-200d-2640-fe0f",
      "1f6a3-1f3fd-200d-2640-fe0f",
      "1f6a3-1f3fe-200d-2640-fe0f",
      "1f6a3-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "swimmer"
    ],
    u: "1f3ca",
    v: [
      "1f3ca-1f3fb",
      "1f3ca-1f3fc",
      "1f3ca-1f3fd",
      "1f3ca-1f3fe",
      "1f3ca-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man swimming",
      "man-swimming"
    ],
    u: "1f3ca-200d-2642-fe0f",
    v: [
      "1f3ca-1f3fb-200d-2642-fe0f",
      "1f3ca-1f3fc-200d-2642-fe0f",
      "1f3ca-1f3fd-200d-2642-fe0f",
      "1f3ca-1f3fe-200d-2642-fe0f",
      "1f3ca-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman swimming",
      "woman-swimming"
    ],
    u: "1f3ca-200d-2640-fe0f",
    v: [
      "1f3ca-1f3fb-200d-2640-fe0f",
      "1f3ca-1f3fc-200d-2640-fe0f",
      "1f3ca-1f3fd-200d-2640-fe0f",
      "1f3ca-1f3fe-200d-2640-fe0f",
      "1f3ca-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person with ball",
      "person bouncing ball"
    ],
    u: "26f9-fe0f",
    v: [
      "26f9-1f3fb",
      "26f9-1f3fc",
      "26f9-1f3fd",
      "26f9-1f3fe",
      "26f9-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "man bouncing ball",
      "man-bouncing-ball"
    ],
    u: "26f9-fe0f-200d-2642-fe0f",
    v: [
      "26f9-1f3fb-200d-2642-fe0f",
      "26f9-1f3fc-200d-2642-fe0f",
      "26f9-1f3fd-200d-2642-fe0f",
      "26f9-1f3fe-200d-2642-fe0f",
      "26f9-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman bouncing ball",
      "woman-bouncing-ball"
    ],
    u: "26f9-fe0f-200d-2640-fe0f",
    v: [
      "26f9-1f3fb-200d-2640-fe0f",
      "26f9-1f3fc-200d-2640-fe0f",
      "26f9-1f3fd-200d-2640-fe0f",
      "26f9-1f3fe-200d-2640-fe0f",
      "26f9-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "weight lifter",
      "person lifting weights"
    ],
    u: "1f3cb-fe0f",
    v: [
      "1f3cb-1f3fb",
      "1f3cb-1f3fc",
      "1f3cb-1f3fd",
      "1f3cb-1f3fe",
      "1f3cb-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "man lifting weights",
      "man-lifting-weights"
    ],
    u: "1f3cb-fe0f-200d-2642-fe0f",
    v: [
      "1f3cb-1f3fb-200d-2642-fe0f",
      "1f3cb-1f3fc-200d-2642-fe0f",
      "1f3cb-1f3fd-200d-2642-fe0f",
      "1f3cb-1f3fe-200d-2642-fe0f",
      "1f3cb-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman lifting weights",
      "woman-lifting-weights"
    ],
    u: "1f3cb-fe0f-200d-2640-fe0f",
    v: [
      "1f3cb-1f3fb-200d-2640-fe0f",
      "1f3cb-1f3fc-200d-2640-fe0f",
      "1f3cb-1f3fd-200d-2640-fe0f",
      "1f3cb-1f3fe-200d-2640-fe0f",
      "1f3cb-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "bicyclist"
    ],
    u: "1f6b4",
    v: [
      "1f6b4-1f3fb",
      "1f6b4-1f3fc",
      "1f6b4-1f3fd",
      "1f6b4-1f3fe",
      "1f6b4-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "man biking",
      "man-biking"
    ],
    u: "1f6b4-200d-2642-fe0f",
    v: [
      "1f6b4-1f3fb-200d-2642-fe0f",
      "1f6b4-1f3fc-200d-2642-fe0f",
      "1f6b4-1f3fd-200d-2642-fe0f",
      "1f6b4-1f3fe-200d-2642-fe0f",
      "1f6b4-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman biking",
      "woman-biking"
    ],
    u: "1f6b4-200d-2640-fe0f",
    v: [
      "1f6b4-1f3fb-200d-2640-fe0f",
      "1f6b4-1f3fc-200d-2640-fe0f",
      "1f6b4-1f3fd-200d-2640-fe0f",
      "1f6b4-1f3fe-200d-2640-fe0f",
      "1f6b4-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "mountain bicyclist"
    ],
    u: "1f6b5",
    v: [
      "1f6b5-1f3fb",
      "1f6b5-1f3fc",
      "1f6b5-1f3fd",
      "1f6b5-1f3fe",
      "1f6b5-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "man mountain biking",
      "man-mountain-biking"
    ],
    u: "1f6b5-200d-2642-fe0f",
    v: [
      "1f6b5-1f3fb-200d-2642-fe0f",
      "1f6b5-1f3fc-200d-2642-fe0f",
      "1f6b5-1f3fd-200d-2642-fe0f",
      "1f6b5-1f3fe-200d-2642-fe0f",
      "1f6b5-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman mountain biking",
      "woman-mountain-biking"
    ],
    u: "1f6b5-200d-2640-fe0f",
    v: [
      "1f6b5-1f3fb-200d-2640-fe0f",
      "1f6b5-1f3fc-200d-2640-fe0f",
      "1f6b5-1f3fd-200d-2640-fe0f",
      "1f6b5-1f3fe-200d-2640-fe0f",
      "1f6b5-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person doing cartwheel"
    ],
    u: "1f938",
    v: [
      "1f938-1f3fb",
      "1f938-1f3fc",
      "1f938-1f3fd",
      "1f938-1f3fe",
      "1f938-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man cartwheeling",
      "man-cartwheeling"
    ],
    u: "1f938-200d-2642-fe0f",
    v: [
      "1f938-1f3fb-200d-2642-fe0f",
      "1f938-1f3fc-200d-2642-fe0f",
      "1f938-1f3fd-200d-2642-fe0f",
      "1f938-1f3fe-200d-2642-fe0f",
      "1f938-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman cartwheeling",
      "woman-cartwheeling"
    ],
    u: "1f938-200d-2640-fe0f",
    v: [
      "1f938-1f3fb-200d-2640-fe0f",
      "1f938-1f3fc-200d-2640-fe0f",
      "1f938-1f3fd-200d-2640-fe0f",
      "1f938-1f3fe-200d-2640-fe0f",
      "1f938-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "wrestlers"
    ],
    u: "1f93c",
    a: "3.0"
  },
  {
    n: [
      "men wrestling",
      "man-wrestling"
    ],
    u: "1f93c-200d-2642-fe0f",
    a: "4.0"
  },
  {
    n: [
      "women wrestling",
      "woman-wrestling"
    ],
    u: "1f93c-200d-2640-fe0f",
    a: "4.0"
  },
  {
    n: [
      "water polo"
    ],
    u: "1f93d",
    v: [
      "1f93d-1f3fb",
      "1f93d-1f3fc",
      "1f93d-1f3fd",
      "1f93d-1f3fe",
      "1f93d-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man playing water polo",
      "man-playing-water-polo"
    ],
    u: "1f93d-200d-2642-fe0f",
    v: [
      "1f93d-1f3fb-200d-2642-fe0f",
      "1f93d-1f3fc-200d-2642-fe0f",
      "1f93d-1f3fd-200d-2642-fe0f",
      "1f93d-1f3fe-200d-2642-fe0f",
      "1f93d-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman playing water polo",
      "woman-playing-water-polo"
    ],
    u: "1f93d-200d-2640-fe0f",
    v: [
      "1f93d-1f3fb-200d-2640-fe0f",
      "1f93d-1f3fc-200d-2640-fe0f",
      "1f93d-1f3fd-200d-2640-fe0f",
      "1f93d-1f3fe-200d-2640-fe0f",
      "1f93d-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "handball"
    ],
    u: "1f93e",
    v: [
      "1f93e-1f3fb",
      "1f93e-1f3fc",
      "1f93e-1f3fd",
      "1f93e-1f3fe",
      "1f93e-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man playing handball",
      "man-playing-handball"
    ],
    u: "1f93e-200d-2642-fe0f",
    v: [
      "1f93e-1f3fb-200d-2642-fe0f",
      "1f93e-1f3fc-200d-2642-fe0f",
      "1f93e-1f3fd-200d-2642-fe0f",
      "1f93e-1f3fe-200d-2642-fe0f",
      "1f93e-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman playing handball",
      "woman-playing-handball"
    ],
    u: "1f93e-200d-2640-fe0f",
    v: [
      "1f93e-1f3fb-200d-2640-fe0f",
      "1f93e-1f3fc-200d-2640-fe0f",
      "1f93e-1f3fd-200d-2640-fe0f",
      "1f93e-1f3fe-200d-2640-fe0f",
      "1f93e-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "juggling"
    ],
    u: "1f939",
    v: [
      "1f939-1f3fb",
      "1f939-1f3fc",
      "1f939-1f3fd",
      "1f939-1f3fe",
      "1f939-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man juggling",
      "man-juggling"
    ],
    u: "1f939-200d-2642-fe0f",
    v: [
      "1f939-1f3fb-200d-2642-fe0f",
      "1f939-1f3fc-200d-2642-fe0f",
      "1f939-1f3fd-200d-2642-fe0f",
      "1f939-1f3fe-200d-2642-fe0f",
      "1f939-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman juggling",
      "woman-juggling"
    ],
    u: "1f939-200d-2640-fe0f",
    v: [
      "1f939-1f3fb-200d-2640-fe0f",
      "1f939-1f3fc-200d-2640-fe0f",
      "1f939-1f3fd-200d-2640-fe0f",
      "1f939-1f3fe-200d-2640-fe0f",
      "1f939-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person in lotus position"
    ],
    u: "1f9d8",
    v: [
      "1f9d8-1f3fb",
      "1f9d8-1f3fc",
      "1f9d8-1f3fd",
      "1f9d8-1f3fe",
      "1f9d8-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man in lotus position"
    ],
    u: "1f9d8-200d-2642-fe0f",
    v: [
      "1f9d8-1f3fb-200d-2642-fe0f",
      "1f9d8-1f3fc-200d-2642-fe0f",
      "1f9d8-1f3fd-200d-2642-fe0f",
      "1f9d8-1f3fe-200d-2642-fe0f",
      "1f9d8-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman in lotus position"
    ],
    u: "1f9d8-200d-2640-fe0f",
    v: [
      "1f9d8-1f3fb-200d-2640-fe0f",
      "1f9d8-1f3fc-200d-2640-fe0f",
      "1f9d8-1f3fd-200d-2640-fe0f",
      "1f9d8-1f3fe-200d-2640-fe0f",
      "1f9d8-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "bath"
    ],
    u: "1f6c0",
    v: [
      "1f6c0-1f3fb",
      "1f6c0-1f3fc",
      "1f6c0-1f3fd",
      "1f6c0-1f3fe",
      "1f6c0-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "sleeping accommodation"
    ],
    u: "1f6cc",
    v: [
      "1f6cc-1f3fb",
      "1f6cc-1f3fc",
      "1f6cc-1f3fd",
      "1f6cc-1f3fe",
      "1f6cc-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "people holding hands"
    ],
    u: "1f9d1-200d-1f91d-200d-1f9d1",
    v: [
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "women holding hands",
      "two women holding hands"
    ],
    u: "1f46d",
    v: [
      "1f46d-1f3fb",
      "1f46d-1f3fc",
      "1f46d-1f3fd",
      "1f46d-1f3fe",
      "1f46d-1f3ff",
      "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",
      "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",
      "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",
      "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",
      "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",
      "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",
      "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",
      "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",
      "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",
      "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",
      "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",
      "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",
      "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",
      "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",
      "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",
      "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",
      "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",
      "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",
      "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",
      "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe"
    ],
    a: "1.0"
  },
  {
    n: [
      "couple",
      "man and woman holding hands",
      "woman and man holding hands"
    ],
    u: "1f46b",
    v: [
      "1f46b-1f3fb",
      "1f46b-1f3fc",
      "1f46b-1f3fd",
      "1f46b-1f3fe",
      "1f46b-1f3ff",
      "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",
      "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",
      "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",
      "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",
      "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",
      "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",
      "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",
      "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",
      "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",
      "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",
      "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",
      "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",
      "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",
      "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",
      "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",
      "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",
      "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",
      "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",
      "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",
      "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe"
    ],
    a: "0.6"
  },
  {
    n: [
      "men holding hands",
      "two men holding hands"
    ],
    u: "1f46c",
    v: [
      "1f46c-1f3fb",
      "1f46c-1f3fc",
      "1f46c-1f3fd",
      "1f46c-1f3fe",
      "1f46c-1f3ff",
      "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",
      "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",
      "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",
      "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",
      "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",
      "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",
      "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",
      "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",
      "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",
      "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",
      "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",
      "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",
      "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",
      "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",
      "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",
      "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",
      "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",
      "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",
      "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",
      "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe"
    ],
    a: "1.0"
  },
  {
    n: [
      "kiss",
      "couplekiss"
    ],
    u: "1f48f",
    v: [
      "1f48f-1f3fb",
      "1f48f-1f3fc",
      "1f48f-1f3fd",
      "1f48f-1f3fe",
      "1f48f-1f3ff",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe"
    ],
    a: "0.6"
  },
  {
    n: [
      "woman-kiss-man",
      "kiss: woman, man"
    ],
    u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
    v: [
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "man-kiss-man",
      "kiss: man, man"
    ],
    u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
    v: [
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "woman-kiss-woman",
      "kiss: woman, woman"
    ],
    u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
    v: [
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "couple with heart"
    ],
    u: "1f491",
    v: [
      "1f491-1f3fb",
      "1f491-1f3fc",
      "1f491-1f3fd",
      "1f491-1f3fe",
      "1f491-1f3ff",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe"
    ],
    a: "0.6"
  },
  {
    n: [
      "woman-heart-man",
      "couple with heart: woman, man"
    ],
    u: "1f469-200d-2764-fe0f-200d-1f468",
    v: [
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "man-heart-man",
      "couple with heart: man, man"
    ],
    u: "1f468-200d-2764-fe0f-200d-1f468",
    v: [
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "woman-heart-woman",
      "couple with heart: woman, woman"
    ],
    u: "1f469-200d-2764-fe0f-200d-1f469",
    v: [
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "family"
    ],
    u: "1f46a",
    a: "0.6"
  },
  {
    n: [
      "man-woman-boy",
      "family: man, woman, boy"
    ],
    u: "1f468-200d-1f469-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-woman-girl",
      "family: man, woman, girl"
    ],
    u: "1f468-200d-1f469-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "man-woman-girl-boy",
      "family: man, woman, girl, boy"
    ],
    u: "1f468-200d-1f469-200d-1f467-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-woman-boy-boy",
      "family: man, woman, boy, boy"
    ],
    u: "1f468-200d-1f469-200d-1f466-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-woman-girl-girl",
      "family: man, woman, girl, girl"
    ],
    u: "1f468-200d-1f469-200d-1f467-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "man-man-boy",
      "family: man, man, boy"
    ],
    u: "1f468-200d-1f468-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-man-girl",
      "family: man, man, girl"
    ],
    u: "1f468-200d-1f468-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "man-man-girl-boy",
      "family: man, man, girl, boy"
    ],
    u: "1f468-200d-1f468-200d-1f467-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-man-boy-boy",
      "family: man, man, boy, boy"
    ],
    u: "1f468-200d-1f468-200d-1f466-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-man-girl-girl",
      "family: man, man, girl, girl"
    ],
    u: "1f468-200d-1f468-200d-1f467-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-boy",
      "family: woman, woman, boy"
    ],
    u: "1f469-200d-1f469-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-girl",
      "family: woman, woman, girl"
    ],
    u: "1f469-200d-1f469-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-girl-boy",
      "family: woman, woman, girl, boy"
    ],
    u: "1f469-200d-1f469-200d-1f467-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-boy-boy",
      "family: woman, woman, boy, boy"
    ],
    u: "1f469-200d-1f469-200d-1f466-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-girl-girl",
      "family: woman, woman, girl, girl"
    ],
    u: "1f469-200d-1f469-200d-1f467-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "man-boy",
      "family: man, boy"
    ],
    u: "1f468-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "man-boy-boy",
      "family: man, boy, boy"
    ],
    u: "1f468-200d-1f466-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "man-girl",
      "family: man, girl"
    ],
    u: "1f468-200d-1f467",
    a: "4.0"
  },
  {
    n: [
      "man-girl-boy",
      "family: man, girl, boy"
    ],
    u: "1f468-200d-1f467-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "man-girl-girl",
      "family: man, girl, girl"
    ],
    u: "1f468-200d-1f467-200d-1f467",
    a: "4.0"
  },
  {
    n: [
      "woman-boy",
      "family: woman, boy"
    ],
    u: "1f469-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "woman-boy-boy",
      "family: woman, boy, boy"
    ],
    u: "1f469-200d-1f466-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "woman-girl",
      "family: woman, girl"
    ],
    u: "1f469-200d-1f467",
    a: "4.0"
  },
  {
    n: [
      "woman-girl-boy",
      "family: woman, girl, boy"
    ],
    u: "1f469-200d-1f467-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "woman-girl-girl",
      "family: woman, girl, girl"
    ],
    u: "1f469-200d-1f467-200d-1f467",
    a: "4.0"
  },
  {
    n: [
      "speaking head",
      "speaking head in silhouette"
    ],
    u: "1f5e3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bust in silhouette"
    ],
    u: "1f464",
    a: "0.6"
  },
  {
    n: [
      "busts in silhouette"
    ],
    u: "1f465",
    a: "1.0"
  },
  {
    n: [
      "people hugging"
    ],
    u: "1fac2",
    a: "13.0"
  },
  {
    n: [
      "footprints"
    ],
    u: "1f463",
    a: "0.6"
  }
], S2t = [
  {
    n: [
      "monkey face"
    ],
    u: "1f435",
    a: "0.6"
  },
  {
    n: [
      "monkey"
    ],
    u: "1f412",
    a: "0.6"
  },
  {
    n: [
      "gorilla"
    ],
    u: "1f98d",
    a: "3.0"
  },
  {
    n: [
      "orangutan"
    ],
    u: "1f9a7",
    a: "12.0"
  },
  {
    n: [
      "dog",
      "dog face"
    ],
    u: "1f436",
    a: "0.6"
  },
  {
    n: [
      "dog",
      "dog2"
    ],
    u: "1f415",
    a: "0.7"
  },
  {
    n: [
      "guide dog"
    ],
    u: "1f9ae",
    a: "12.0"
  },
  {
    n: [
      "service dog"
    ],
    u: "1f415-200d-1f9ba",
    a: "12.0"
  },
  {
    n: [
      "poodle"
    ],
    u: "1f429",
    a: "0.6"
  },
  {
    n: [
      "wolf",
      "wolf face"
    ],
    u: "1f43a",
    a: "0.6"
  },
  {
    n: [
      "fox face"
    ],
    u: "1f98a",
    a: "3.0"
  },
  {
    n: [
      "raccoon"
    ],
    u: "1f99d",
    a: "11.0"
  },
  {
    n: [
      "cat",
      "cat face"
    ],
    u: "1f431",
    a: "0.6"
  },
  {
    n: [
      "cat",
      "cat2"
    ],
    u: "1f408",
    a: "0.7"
  },
  {
    n: [
      "black cat"
    ],
    u: "1f408-200d-2b1b",
    a: "13.0"
  },
  {
    n: [
      "lion face"
    ],
    u: "1f981",
    a: "1.0"
  },
  {
    n: [
      "tiger",
      "tiger face"
    ],
    u: "1f42f",
    a: "0.6"
  },
  {
    n: [
      "tiger",
      "tiger2"
    ],
    u: "1f405",
    a: "1.0"
  },
  {
    n: [
      "leopard"
    ],
    u: "1f406",
    a: "1.0"
  },
  {
    n: [
      "horse",
      "horse face"
    ],
    u: "1f434",
    a: "0.6"
  },
  {
    n: [
      "horse",
      "racehorse"
    ],
    u: "1f40e",
    a: "0.6"
  },
  {
    n: [
      "unicorn face"
    ],
    u: "1f984",
    a: "1.0"
  },
  {
    n: [
      "zebra face"
    ],
    u: "1f993",
    a: "5.0"
  },
  {
    n: [
      "deer"
    ],
    u: "1f98c",
    a: "3.0"
  },
  {
    n: [
      "bison"
    ],
    u: "1f9ac",
    a: "13.0"
  },
  {
    n: [
      "cow",
      "cow face"
    ],
    u: "1f42e",
    a: "0.6"
  },
  {
    n: [
      "ox"
    ],
    u: "1f402",
    a: "1.0"
  },
  {
    n: [
      "water buffalo"
    ],
    u: "1f403",
    a: "1.0"
  },
  {
    n: [
      "cow",
      "cow2"
    ],
    u: "1f404",
    a: "1.0"
  },
  {
    n: [
      "pig",
      "pig face"
    ],
    u: "1f437",
    a: "0.6"
  },
  {
    n: [
      "pig",
      "pig2"
    ],
    u: "1f416",
    a: "1.0"
  },
  {
    n: [
      "boar"
    ],
    u: "1f417",
    a: "0.6"
  },
  {
    n: [
      "pig nose"
    ],
    u: "1f43d",
    a: "0.6"
  },
  {
    n: [
      "ram"
    ],
    u: "1f40f",
    a: "1.0"
  },
  {
    n: [
      "sheep"
    ],
    u: "1f411",
    a: "0.6"
  },
  {
    n: [
      "goat"
    ],
    u: "1f410",
    a: "1.0"
  },
  {
    n: [
      "dromedary camel"
    ],
    u: "1f42a",
    a: "1.0"
  },
  {
    n: [
      "camel",
      "bactrian camel"
    ],
    u: "1f42b",
    a: "0.6"
  },
  {
    n: [
      "llama"
    ],
    u: "1f999",
    a: "11.0"
  },
  {
    n: [
      "giraffe face"
    ],
    u: "1f992",
    a: "5.0"
  },
  {
    n: [
      "elephant"
    ],
    u: "1f418",
    a: "0.6"
  },
  {
    n: [
      "mammoth"
    ],
    u: "1f9a3",
    a: "13.0"
  },
  {
    n: [
      "rhinoceros"
    ],
    u: "1f98f",
    a: "3.0"
  },
  {
    n: [
      "hippopotamus"
    ],
    u: "1f99b",
    a: "11.0"
  },
  {
    n: [
      "mouse",
      "mouse face"
    ],
    u: "1f42d",
    a: "0.6"
  },
  {
    n: [
      "mouse",
      "mouse2"
    ],
    u: "1f401",
    a: "1.0"
  },
  {
    n: [
      "rat"
    ],
    u: "1f400",
    a: "1.0"
  },
  {
    n: [
      "hamster",
      "hamster face"
    ],
    u: "1f439",
    a: "0.6"
  },
  {
    n: [
      "rabbit",
      "rabbit face"
    ],
    u: "1f430",
    a: "0.6"
  },
  {
    n: [
      "rabbit",
      "rabbit2"
    ],
    u: "1f407",
    a: "1.0"
  },
  {
    n: [
      "chipmunk"
    ],
    u: "1f43f-fe0f",
    a: "0.7"
  },
  {
    n: [
      "beaver"
    ],
    u: "1f9ab",
    a: "13.0"
  },
  {
    n: [
      "hedgehog"
    ],
    u: "1f994",
    a: "5.0"
  },
  {
    n: [
      "bat"
    ],
    u: "1f987",
    a: "3.0"
  },
  {
    n: [
      "bear",
      "bear face"
    ],
    u: "1f43b",
    a: "0.6"
  },
  {
    n: [
      "polar bear"
    ],
    u: "1f43b-200d-2744-fe0f",
    a: "13.0"
  },
  {
    n: [
      "koala"
    ],
    u: "1f428",
    a: "0.6"
  },
  {
    n: [
      "panda face"
    ],
    u: "1f43c",
    a: "0.6"
  },
  {
    n: [
      "sloth"
    ],
    u: "1f9a5",
    a: "12.0"
  },
  {
    n: [
      "otter"
    ],
    u: "1f9a6",
    a: "12.0"
  },
  {
    n: [
      "skunk"
    ],
    u: "1f9a8",
    a: "12.0"
  },
  {
    n: [
      "kangaroo"
    ],
    u: "1f998",
    a: "11.0"
  },
  {
    n: [
      "badger"
    ],
    u: "1f9a1",
    a: "11.0"
  },
  {
    n: [
      "feet",
      "paw prints"
    ],
    u: "1f43e",
    a: "0.6"
  },
  {
    n: [
      "turkey"
    ],
    u: "1f983",
    a: "1.0"
  },
  {
    n: [
      "chicken"
    ],
    u: "1f414",
    a: "0.6"
  },
  {
    n: [
      "rooster"
    ],
    u: "1f413",
    a: "1.0"
  },
  {
    n: [
      "hatching chick"
    ],
    u: "1f423",
    a: "0.6"
  },
  {
    n: [
      "baby chick"
    ],
    u: "1f424",
    a: "0.6"
  },
  {
    n: [
      "hatched chick",
      "front-facing baby chick"
    ],
    u: "1f425",
    a: "0.6"
  },
  {
    n: [
      "bird"
    ],
    u: "1f426",
    a: "0.6"
  },
  {
    n: [
      "penguin"
    ],
    u: "1f427",
    a: "0.6"
  },
  {
    n: [
      "dove",
      "dove of peace"
    ],
    u: "1f54a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "eagle"
    ],
    u: "1f985",
    a: "3.0"
  },
  {
    n: [
      "duck"
    ],
    u: "1f986",
    a: "3.0"
  },
  {
    n: [
      "swan"
    ],
    u: "1f9a2",
    a: "11.0"
  },
  {
    n: [
      "owl"
    ],
    u: "1f989",
    a: "3.0"
  },
  {
    n: [
      "dodo"
    ],
    u: "1f9a4",
    a: "13.0"
  },
  {
    n: [
      "feather"
    ],
    u: "1fab6",
    a: "13.0"
  },
  {
    n: [
      "flamingo"
    ],
    u: "1f9a9",
    a: "12.0"
  },
  {
    n: [
      "peacock"
    ],
    u: "1f99a",
    a: "11.0"
  },
  {
    n: [
      "parrot"
    ],
    u: "1f99c",
    a: "11.0"
  },
  {
    n: [
      "frog",
      "frog face"
    ],
    u: "1f438",
    a: "0.6"
  },
  {
    n: [
      "crocodile"
    ],
    u: "1f40a",
    a: "1.0"
  },
  {
    n: [
      "turtle"
    ],
    u: "1f422",
    a: "0.6"
  },
  {
    n: [
      "lizard"
    ],
    u: "1f98e",
    a: "3.0"
  },
  {
    n: [
      "snake"
    ],
    u: "1f40d",
    a: "0.6"
  },
  {
    n: [
      "dragon face"
    ],
    u: "1f432",
    a: "0.6"
  },
  {
    n: [
      "dragon"
    ],
    u: "1f409",
    a: "1.0"
  },
  {
    n: [
      "sauropod"
    ],
    u: "1f995",
    a: "5.0"
  },
  {
    n: [
      "t-rex"
    ],
    u: "1f996",
    a: "5.0"
  },
  {
    n: [
      "whale",
      "spouting whale"
    ],
    u: "1f433",
    a: "0.6"
  },
  {
    n: [
      "whale",
      "whale2"
    ],
    u: "1f40b",
    a: "1.0"
  },
  {
    n: [
      "dolphin",
      "flipper"
    ],
    u: "1f42c",
    a: "0.6"
  },
  {
    n: [
      "seal"
    ],
    u: "1f9ad",
    a: "13.0"
  },
  {
    n: [
      "fish"
    ],
    u: "1f41f",
    a: "0.6"
  },
  {
    n: [
      "tropical fish"
    ],
    u: "1f420",
    a: "0.6"
  },
  {
    n: [
      "blowfish"
    ],
    u: "1f421",
    a: "0.6"
  },
  {
    n: [
      "shark"
    ],
    u: "1f988",
    a: "3.0"
  },
  {
    n: [
      "octopus"
    ],
    u: "1f419",
    a: "0.6"
  },
  {
    n: [
      "shell",
      "spiral shell"
    ],
    u: "1f41a",
    a: "0.6"
  },
  {
    n: [
      "coral"
    ],
    u: "1fab8",
    a: "14.0"
  },
  {
    n: [
      "snail"
    ],
    u: "1f40c",
    a: "0.6"
  },
  {
    n: [
      "butterfly"
    ],
    u: "1f98b",
    a: "3.0"
  },
  {
    n: [
      "bug"
    ],
    u: "1f41b",
    a: "0.6"
  },
  {
    n: [
      "ant"
    ],
    u: "1f41c",
    a: "0.6"
  },
  {
    n: [
      "bee",
      "honeybee"
    ],
    u: "1f41d",
    a: "0.6"
  },
  {
    n: [
      "beetle"
    ],
    u: "1fab2",
    a: "13.0"
  },
  {
    n: [
      "ladybug",
      "lady beetle"
    ],
    u: "1f41e",
    a: "0.6"
  },
  {
    n: [
      "cricket"
    ],
    u: "1f997",
    a: "5.0"
  },
  {
    n: [
      "cockroach"
    ],
    u: "1fab3",
    a: "13.0"
  },
  {
    n: [
      "spider"
    ],
    u: "1f577-fe0f",
    a: "0.7"
  },
  {
    n: [
      "spider web"
    ],
    u: "1f578-fe0f",
    a: "0.7"
  },
  {
    n: [
      "scorpion"
    ],
    u: "1f982",
    a: "1.0"
  },
  {
    n: [
      "mosquito"
    ],
    u: "1f99f",
    a: "11.0"
  },
  {
    n: [
      "fly"
    ],
    u: "1fab0",
    a: "13.0"
  },
  {
    n: [
      "worm"
    ],
    u: "1fab1",
    a: "13.0"
  },
  {
    n: [
      "microbe"
    ],
    u: "1f9a0",
    a: "11.0"
  },
  {
    n: [
      "bouquet"
    ],
    u: "1f490",
    a: "0.6"
  },
  {
    n: [
      "cherry blossom"
    ],
    u: "1f338",
    a: "0.6"
  },
  {
    n: [
      "white flower"
    ],
    u: "1f4ae",
    a: "0.6"
  },
  {
    n: [
      "lotus"
    ],
    u: "1fab7",
    a: "14.0"
  },
  {
    n: [
      "rosette"
    ],
    u: "1f3f5-fe0f",
    a: "0.7"
  },
  {
    n: [
      "rose"
    ],
    u: "1f339",
    a: "0.6"
  },
  {
    n: [
      "wilted flower"
    ],
    u: "1f940",
    a: "3.0"
  },
  {
    n: [
      "hibiscus"
    ],
    u: "1f33a",
    a: "0.6"
  },
  {
    n: [
      "sunflower"
    ],
    u: "1f33b",
    a: "0.6"
  },
  {
    n: [
      "blossom"
    ],
    u: "1f33c",
    a: "0.6"
  },
  {
    n: [
      "tulip"
    ],
    u: "1f337",
    a: "0.6"
  },
  {
    n: [
      "seedling"
    ],
    u: "1f331",
    a: "0.6"
  },
  {
    n: [
      "potted plant"
    ],
    u: "1fab4",
    a: "13.0"
  },
  {
    n: [
      "evergreen tree"
    ],
    u: "1f332",
    a: "1.0"
  },
  {
    n: [
      "deciduous tree"
    ],
    u: "1f333",
    a: "1.0"
  },
  {
    n: [
      "palm tree"
    ],
    u: "1f334",
    a: "0.6"
  },
  {
    n: [
      "cactus"
    ],
    u: "1f335",
    a: "0.6"
  },
  {
    n: [
      "ear of rice"
    ],
    u: "1f33e",
    a: "0.6"
  },
  {
    n: [
      "herb"
    ],
    u: "1f33f",
    a: "0.6"
  },
  {
    n: [
      "shamrock"
    ],
    u: "2618-fe0f",
    a: "1.0"
  },
  {
    n: [
      "four leaf clover"
    ],
    u: "1f340",
    a: "0.6"
  },
  {
    n: [
      "maple leaf"
    ],
    u: "1f341",
    a: "0.6"
  },
  {
    n: [
      "fallen leaf"
    ],
    u: "1f342",
    a: "0.6"
  },
  {
    n: [
      "leaves",
      "leaf fluttering in wind"
    ],
    u: "1f343",
    a: "0.6"
  },
  {
    n: [
      "empty nest"
    ],
    u: "1fab9",
    a: "14.0"
  },
  {
    n: [
      "nest with eggs"
    ],
    u: "1faba",
    a: "14.0"
  }
], L2t = [
  {
    n: [
      "grapes"
    ],
    u: "1f347",
    a: "0.6"
  },
  {
    n: [
      "melon"
    ],
    u: "1f348",
    a: "0.6"
  },
  {
    n: [
      "watermelon"
    ],
    u: "1f349",
    a: "0.6"
  },
  {
    n: [
      "tangerine"
    ],
    u: "1f34a",
    a: "0.6"
  },
  {
    n: [
      "lemon"
    ],
    u: "1f34b",
    a: "1.0"
  },
  {
    n: [
      "banana"
    ],
    u: "1f34c",
    a: "0.6"
  },
  {
    n: [
      "pineapple"
    ],
    u: "1f34d",
    a: "0.6"
  },
  {
    n: [
      "mango"
    ],
    u: "1f96d",
    a: "11.0"
  },
  {
    n: [
      "apple",
      "red apple"
    ],
    u: "1f34e",
    a: "0.6"
  },
  {
    n: [
      "green apple"
    ],
    u: "1f34f",
    a: "0.6"
  },
  {
    n: [
      "pear"
    ],
    u: "1f350",
    a: "1.0"
  },
  {
    n: [
      "peach"
    ],
    u: "1f351",
    a: "0.6"
  },
  {
    n: [
      "cherries"
    ],
    u: "1f352",
    a: "0.6"
  },
  {
    n: [
      "strawberry"
    ],
    u: "1f353",
    a: "0.6"
  },
  {
    n: [
      "blueberries"
    ],
    u: "1fad0",
    a: "13.0"
  },
  {
    n: [
      "kiwifruit"
    ],
    u: "1f95d",
    a: "3.0"
  },
  {
    n: [
      "tomato"
    ],
    u: "1f345",
    a: "0.6"
  },
  {
    n: [
      "olive"
    ],
    u: "1fad2",
    a: "13.0"
  },
  {
    n: [
      "coconut"
    ],
    u: "1f965",
    a: "5.0"
  },
  {
    n: [
      "avocado"
    ],
    u: "1f951",
    a: "3.0"
  },
  {
    n: [
      "eggplant",
      "aubergine"
    ],
    u: "1f346",
    a: "0.6"
  },
  {
    n: [
      "potato"
    ],
    u: "1f954",
    a: "3.0"
  },
  {
    n: [
      "carrot"
    ],
    u: "1f955",
    a: "3.0"
  },
  {
    n: [
      "corn",
      "ear of maize"
    ],
    u: "1f33d",
    a: "0.6"
  },
  {
    n: [
      "hot pepper"
    ],
    u: "1f336-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bell pepper"
    ],
    u: "1fad1",
    a: "13.0"
  },
  {
    n: [
      "cucumber"
    ],
    u: "1f952",
    a: "3.0"
  },
  {
    n: [
      "leafy green"
    ],
    u: "1f96c",
    a: "11.0"
  },
  {
    n: [
      "broccoli"
    ],
    u: "1f966",
    a: "5.0"
  },
  {
    n: [
      "garlic"
    ],
    u: "1f9c4",
    a: "12.0"
  },
  {
    n: [
      "onion"
    ],
    u: "1f9c5",
    a: "12.0"
  },
  {
    n: [
      "mushroom"
    ],
    u: "1f344",
    a: "0.6"
  },
  {
    n: [
      "peanuts"
    ],
    u: "1f95c",
    a: "3.0"
  },
  {
    n: [
      "beans"
    ],
    u: "1fad8",
    a: "14.0"
  },
  {
    n: [
      "chestnut"
    ],
    u: "1f330",
    a: "0.6"
  },
  {
    n: [
      "bread"
    ],
    u: "1f35e",
    a: "0.6"
  },
  {
    n: [
      "croissant"
    ],
    u: "1f950",
    a: "3.0"
  },
  {
    n: [
      "baguette bread"
    ],
    u: "1f956",
    a: "3.0"
  },
  {
    n: [
      "flatbread"
    ],
    u: "1fad3",
    a: "13.0"
  },
  {
    n: [
      "pretzel"
    ],
    u: "1f968",
    a: "5.0"
  },
  {
    n: [
      "bagel"
    ],
    u: "1f96f",
    a: "11.0"
  },
  {
    n: [
      "pancakes"
    ],
    u: "1f95e",
    a: "3.0"
  },
  {
    n: [
      "waffle"
    ],
    u: "1f9c7",
    a: "12.0"
  },
  {
    n: [
      "cheese wedge"
    ],
    u: "1f9c0",
    a: "1.0"
  },
  {
    n: [
      "meat on bone"
    ],
    u: "1f356",
    a: "0.6"
  },
  {
    n: [
      "poultry leg"
    ],
    u: "1f357",
    a: "0.6"
  },
  {
    n: [
      "cut of meat"
    ],
    u: "1f969",
    a: "5.0"
  },
  {
    n: [
      "bacon"
    ],
    u: "1f953",
    a: "3.0"
  },
  {
    n: [
      "hamburger"
    ],
    u: "1f354",
    a: "0.6"
  },
  {
    n: [
      "fries",
      "french fries"
    ],
    u: "1f35f",
    a: "0.6"
  },
  {
    n: [
      "pizza",
      "slice of pizza"
    ],
    u: "1f355",
    a: "0.6"
  },
  {
    n: [
      "hotdog",
      "hot dog"
    ],
    u: "1f32d",
    a: "1.0"
  },
  {
    n: [
      "sandwich"
    ],
    u: "1f96a",
    a: "5.0"
  },
  {
    n: [
      "taco"
    ],
    u: "1f32e",
    a: "1.0"
  },
  {
    n: [
      "burrito"
    ],
    u: "1f32f",
    a: "1.0"
  },
  {
    n: [
      "tamale"
    ],
    u: "1fad4",
    a: "13.0"
  },
  {
    n: [
      "stuffed flatbread"
    ],
    u: "1f959",
    a: "3.0"
  },
  {
    n: [
      "falafel"
    ],
    u: "1f9c6",
    a: "12.0"
  },
  {
    n: [
      "egg"
    ],
    u: "1f95a",
    a: "3.0"
  },
  {
    n: [
      "cooking",
      "fried egg"
    ],
    u: "1f373",
    a: "0.6"
  },
  {
    n: [
      "shallow pan of food"
    ],
    u: "1f958",
    a: "3.0"
  },
  {
    n: [
      "stew",
      "pot of food"
    ],
    u: "1f372",
    a: "0.6"
  },
  {
    n: [
      "fondue"
    ],
    u: "1fad5",
    a: "13.0"
  },
  {
    n: [
      "bowl with spoon"
    ],
    u: "1f963",
    a: "5.0"
  },
  {
    n: [
      "green salad"
    ],
    u: "1f957",
    a: "3.0"
  },
  {
    n: [
      "popcorn"
    ],
    u: "1f37f",
    a: "1.0"
  },
  {
    n: [
      "butter"
    ],
    u: "1f9c8",
    a: "12.0"
  },
  {
    n: [
      "salt",
      "salt shaker"
    ],
    u: "1f9c2",
    a: "11.0"
  },
  {
    n: [
      "canned food"
    ],
    u: "1f96b",
    a: "5.0"
  },
  {
    n: [
      "bento",
      "bento box"
    ],
    u: "1f371",
    a: "0.6"
  },
  {
    n: [
      "rice cracker"
    ],
    u: "1f358",
    a: "0.6"
  },
  {
    n: [
      "rice ball"
    ],
    u: "1f359",
    a: "0.6"
  },
  {
    n: [
      "rice",
      "cooked rice"
    ],
    u: "1f35a",
    a: "0.6"
  },
  {
    n: [
      "curry",
      "curry and rice"
    ],
    u: "1f35b",
    a: "0.6"
  },
  {
    n: [
      "ramen",
      "steaming bowl"
    ],
    u: "1f35c",
    a: "0.6"
  },
  {
    n: [
      "spaghetti"
    ],
    u: "1f35d",
    a: "0.6"
  },
  {
    n: [
      "sweet potato",
      "roasted sweet potato"
    ],
    u: "1f360",
    a: "0.6"
  },
  {
    n: [
      "oden"
    ],
    u: "1f362",
    a: "0.6"
  },
  {
    n: [
      "sushi"
    ],
    u: "1f363",
    a: "0.6"
  },
  {
    n: [
      "fried shrimp"
    ],
    u: "1f364",
    a: "0.6"
  },
  {
    n: [
      "fish cake",
      "fish cake with swirl design"
    ],
    u: "1f365",
    a: "0.6"
  },
  {
    n: [
      "moon cake"
    ],
    u: "1f96e",
    a: "11.0"
  },
  {
    n: [
      "dango"
    ],
    u: "1f361",
    a: "0.6"
  },
  {
    n: [
      "dumpling"
    ],
    u: "1f95f",
    a: "5.0"
  },
  {
    n: [
      "fortune cookie"
    ],
    u: "1f960",
    a: "5.0"
  },
  {
    n: [
      "takeout box"
    ],
    u: "1f961",
    a: "5.0"
  },
  {
    n: [
      "crab"
    ],
    u: "1f980",
    a: "1.0"
  },
  {
    n: [
      "lobster"
    ],
    u: "1f99e",
    a: "11.0"
  },
  {
    n: [
      "shrimp"
    ],
    u: "1f990",
    a: "3.0"
  },
  {
    n: [
      "squid"
    ],
    u: "1f991",
    a: "3.0"
  },
  {
    n: [
      "oyster"
    ],
    u: "1f9aa",
    a: "12.0"
  },
  {
    n: [
      "icecream",
      "soft ice cream"
    ],
    u: "1f366",
    a: "0.6"
  },
  {
    n: [
      "shaved ice"
    ],
    u: "1f367",
    a: "0.6"
  },
  {
    n: [
      "ice cream"
    ],
    u: "1f368",
    a: "0.6"
  },
  {
    n: [
      "doughnut"
    ],
    u: "1f369",
    a: "0.6"
  },
  {
    n: [
      "cookie"
    ],
    u: "1f36a",
    a: "0.6"
  },
  {
    n: [
      "birthday",
      "birthday cake"
    ],
    u: "1f382",
    a: "0.6"
  },
  {
    n: [
      "cake",
      "shortcake"
    ],
    u: "1f370",
    a: "0.6"
  },
  {
    n: [
      "cupcake"
    ],
    u: "1f9c1",
    a: "11.0"
  },
  {
    n: [
      "pie"
    ],
    u: "1f967",
    a: "5.0"
  },
  {
    n: [
      "chocolate bar"
    ],
    u: "1f36b",
    a: "0.6"
  },
  {
    n: [
      "candy"
    ],
    u: "1f36c",
    a: "0.6"
  },
  {
    n: [
      "lollipop"
    ],
    u: "1f36d",
    a: "0.6"
  },
  {
    n: [
      "custard"
    ],
    u: "1f36e",
    a: "0.6"
  },
  {
    n: [
      "honey pot"
    ],
    u: "1f36f",
    a: "0.6"
  },
  {
    n: [
      "baby bottle"
    ],
    u: "1f37c",
    a: "1.0"
  },
  {
    n: [
      "glass of milk"
    ],
    u: "1f95b",
    a: "3.0"
  },
  {
    n: [
      "coffee",
      "hot beverage"
    ],
    u: "2615",
    a: "0.6"
  },
  {
    n: [
      "teapot"
    ],
    u: "1fad6",
    a: "13.0"
  },
  {
    n: [
      "tea",
      "teacup without handle"
    ],
    u: "1f375",
    a: "0.6"
  },
  {
    n: [
      "sake",
      "sake bottle and cup"
    ],
    u: "1f376",
    a: "0.6"
  },
  {
    n: [
      "champagne",
      "bottle with popping cork"
    ],
    u: "1f37e",
    a: "1.0"
  },
  {
    n: [
      "wine glass"
    ],
    u: "1f377",
    a: "0.6"
  },
  {
    n: [
      "cocktail",
      "cocktail glass"
    ],
    u: "1f378",
    a: "0.6"
  },
  {
    n: [
      "tropical drink"
    ],
    u: "1f379",
    a: "0.6"
  },
  {
    n: [
      "beer",
      "beer mug"
    ],
    u: "1f37a",
    a: "0.6"
  },
  {
    n: [
      "beers",
      "clinking beer mugs"
    ],
    u: "1f37b",
    a: "0.6"
  },
  {
    n: [
      "clinking glasses"
    ],
    u: "1f942",
    a: "3.0"
  },
  {
    n: [
      "tumbler glass"
    ],
    u: "1f943",
    a: "3.0"
  },
  {
    n: [
      "pouring liquid"
    ],
    u: "1fad7",
    a: "14.0"
  },
  {
    n: [
      "cup with straw"
    ],
    u: "1f964",
    a: "5.0"
  },
  {
    n: [
      "bubble tea"
    ],
    u: "1f9cb",
    a: "13.0"
  },
  {
    n: [
      "beverage box"
    ],
    u: "1f9c3",
    a: "12.0"
  },
  {
    n: [
      "mate drink"
    ],
    u: "1f9c9",
    a: "12.0"
  },
  {
    n: [
      "ice cube"
    ],
    u: "1f9ca",
    a: "12.0"
  },
  {
    n: [
      "chopsticks"
    ],
    u: "1f962",
    a: "5.0"
  },
  {
    n: [
      "knife fork plate",
      "fork and knife with plate"
    ],
    u: "1f37d-fe0f",
    a: "0.7"
  },
  {
    n: [
      "fork and knife"
    ],
    u: "1f374",
    a: "0.6"
  },
  {
    n: [
      "spoon"
    ],
    u: "1f944",
    a: "3.0"
  },
  {
    n: [
      "hocho",
      "knife"
    ],
    u: "1f52a",
    a: "0.6"
  },
  {
    n: [
      "jar"
    ],
    u: "1fad9",
    a: "14.0"
  },
  {
    n: [
      "amphora"
    ],
    u: "1f3fa",
    a: "1.0"
  }
], T2t = [
  {
    n: [
      "earth africa",
      "earth globe europe-africa"
    ],
    u: "1f30d",
    a: "0.7"
  },
  {
    n: [
      "earth americas",
      "earth globe americas"
    ],
    u: "1f30e",
    a: "0.7"
  },
  {
    n: [
      "earth asia",
      "earth globe asia-australia"
    ],
    u: "1f30f",
    a: "0.6"
  },
  {
    n: [
      "globe with meridians"
    ],
    u: "1f310",
    a: "1.0"
  },
  {
    n: [
      "world map"
    ],
    u: "1f5fa-fe0f",
    a: "0.7"
  },
  {
    n: [
      "japan",
      "silhouette of japan"
    ],
    u: "1f5fe",
    a: "0.6"
  },
  {
    n: [
      "compass"
    ],
    u: "1f9ed",
    a: "11.0"
  },
  {
    n: [
      "snow-capped mountain",
      "snow capped mountain"
    ],
    u: "1f3d4-fe0f",
    a: "0.7"
  },
  {
    n: [
      "mountain"
    ],
    u: "26f0-fe0f",
    a: "0.7"
  },
  {
    n: [
      "volcano"
    ],
    u: "1f30b",
    a: "0.6"
  },
  {
    n: [
      "mount fuji"
    ],
    u: "1f5fb",
    a: "0.6"
  },
  {
    n: [
      "camping"
    ],
    u: "1f3d5-fe0f",
    a: "0.7"
  },
  {
    n: [
      "beach with umbrella"
    ],
    u: "1f3d6-fe0f",
    a: "0.7"
  },
  {
    n: [
      "desert"
    ],
    u: "1f3dc-fe0f",
    a: "0.7"
  },
  {
    n: [
      "desert island"
    ],
    u: "1f3dd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "national park"
    ],
    u: "1f3de-fe0f",
    a: "0.7"
  },
  {
    n: [
      "stadium"
    ],
    u: "1f3df-fe0f",
    a: "0.7"
  },
  {
    n: [
      "classical building"
    ],
    u: "1f3db-fe0f",
    a: "0.7"
  },
  {
    n: [
      "building construction"
    ],
    u: "1f3d7-fe0f",
    a: "0.7"
  },
  {
    n: [
      "brick",
      "bricks"
    ],
    u: "1f9f1",
    a: "11.0"
  },
  {
    n: [
      "rock"
    ],
    u: "1faa8",
    a: "13.0"
  },
  {
    n: [
      "wood"
    ],
    u: "1fab5",
    a: "13.0"
  },
  {
    n: [
      "hut"
    ],
    u: "1f6d6",
    a: "13.0"
  },
  {
    n: [
      "houses",
      "house buildings"
    ],
    u: "1f3d8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "derelict house",
      "derelict house building"
    ],
    u: "1f3da-fe0f",
    a: "0.7"
  },
  {
    n: [
      "house",
      "house building"
    ],
    u: "1f3e0",
    a: "0.6"
  },
  {
    n: [
      "house with garden"
    ],
    u: "1f3e1",
    a: "0.6"
  },
  {
    n: [
      "office",
      "office building"
    ],
    u: "1f3e2",
    a: "0.6"
  },
  {
    n: [
      "post office",
      "japanese post office"
    ],
    u: "1f3e3",
    a: "0.6"
  },
  {
    n: [
      "european post office"
    ],
    u: "1f3e4",
    a: "1.0"
  },
  {
    n: [
      "hospital"
    ],
    u: "1f3e5",
    a: "0.6"
  },
  {
    n: [
      "bank"
    ],
    u: "1f3e6",
    a: "0.6"
  },
  {
    n: [
      "hotel"
    ],
    u: "1f3e8",
    a: "0.6"
  },
  {
    n: [
      "love hotel"
    ],
    u: "1f3e9",
    a: "0.6"
  },
  {
    n: [
      "convenience store"
    ],
    u: "1f3ea",
    a: "0.6"
  },
  {
    n: [
      "school"
    ],
    u: "1f3eb",
    a: "0.6"
  },
  {
    n: [
      "department store"
    ],
    u: "1f3ec",
    a: "0.6"
  },
  {
    n: [
      "factory"
    ],
    u: "1f3ed",
    a: "0.6"
  },
  {
    n: [
      "japanese castle"
    ],
    u: "1f3ef",
    a: "0.6"
  },
  {
    n: [
      "european castle"
    ],
    u: "1f3f0",
    a: "0.6"
  },
  {
    n: [
      "wedding"
    ],
    u: "1f492",
    a: "0.6"
  },
  {
    n: [
      "tokyo tower"
    ],
    u: "1f5fc",
    a: "0.6"
  },
  {
    n: [
      "statue of liberty"
    ],
    u: "1f5fd",
    a: "0.6"
  },
  {
    n: [
      "church"
    ],
    u: "26ea",
    a: "0.6"
  },
  {
    n: [
      "mosque"
    ],
    u: "1f54c",
    a: "1.0"
  },
  {
    n: [
      "hindu temple"
    ],
    u: "1f6d5",
    a: "12.0"
  },
  {
    n: [
      "synagogue"
    ],
    u: "1f54d",
    a: "1.0"
  },
  {
    n: [
      "shinto shrine"
    ],
    u: "26e9-fe0f",
    a: "0.7"
  },
  {
    n: [
      "kaaba"
    ],
    u: "1f54b",
    a: "1.0"
  },
  {
    n: [
      "fountain"
    ],
    u: "26f2",
    a: "0.6"
  },
  {
    n: [
      "tent"
    ],
    u: "26fa",
    a: "0.6"
  },
  {
    n: [
      "foggy"
    ],
    u: "1f301",
    a: "0.6"
  },
  {
    n: [
      "night with stars"
    ],
    u: "1f303",
    a: "0.6"
  },
  {
    n: [
      "cityscape"
    ],
    u: "1f3d9-fe0f",
    a: "0.7"
  },
  {
    n: [
      "sunrise over mountains"
    ],
    u: "1f304",
    a: "0.6"
  },
  {
    n: [
      "sunrise"
    ],
    u: "1f305",
    a: "0.6"
  },
  {
    n: [
      "city sunset",
      "cityscape at dusk"
    ],
    u: "1f306",
    a: "0.6"
  },
  {
    n: [
      "city sunrise",
      "sunset over buildings"
    ],
    u: "1f307",
    a: "0.6"
  },
  {
    n: [
      "bridge at night"
    ],
    u: "1f309",
    a: "0.6"
  },
  {
    n: [
      "hotsprings",
      "hot springs"
    ],
    u: "2668-fe0f",
    a: "0.6"
  },
  {
    n: [
      "carousel horse"
    ],
    u: "1f3a0",
    a: "0.6"
  },
  {
    n: [
      "playground slide"
    ],
    u: "1f6dd",
    a: "14.0"
  },
  {
    n: [
      "ferris wheel"
    ],
    u: "1f3a1",
    a: "0.6"
  },
  {
    n: [
      "roller coaster"
    ],
    u: "1f3a2",
    a: "0.6"
  },
  {
    n: [
      "barber",
      "barber pole"
    ],
    u: "1f488",
    a: "0.6"
  },
  {
    n: [
      "circus tent"
    ],
    u: "1f3aa",
    a: "0.6"
  },
  {
    n: [
      "steam locomotive"
    ],
    u: "1f682",
    a: "1.0"
  },
  {
    n: [
      "railway car"
    ],
    u: "1f683",
    a: "0.6"
  },
  {
    n: [
      "high-speed train",
      "bullettrain side"
    ],
    u: "1f684",
    a: "0.6"
  },
  {
    n: [
      "bullettrain front",
      "high-speed train with bullet nose"
    ],
    u: "1f685",
    a: "0.6"
  },
  {
    n: [
      "train",
      "train2"
    ],
    u: "1f686",
    a: "1.0"
  },
  {
    n: [
      "metro"
    ],
    u: "1f687",
    a: "0.6"
  },
  {
    n: [
      "light rail"
    ],
    u: "1f688",
    a: "1.0"
  },
  {
    n: [
      "station"
    ],
    u: "1f689",
    a: "0.6"
  },
  {
    n: [
      "tram"
    ],
    u: "1f68a",
    a: "1.0"
  },
  {
    n: [
      "monorail"
    ],
    u: "1f69d",
    a: "1.0"
  },
  {
    n: [
      "mountain railway"
    ],
    u: "1f69e",
    a: "1.0"
  },
  {
    n: [
      "train",
      "tram car"
    ],
    u: "1f68b",
    a: "1.0"
  },
  {
    n: [
      "bus"
    ],
    u: "1f68c",
    a: "0.6"
  },
  {
    n: [
      "oncoming bus"
    ],
    u: "1f68d",
    a: "0.7"
  },
  {
    n: [
      "trolleybus"
    ],
    u: "1f68e",
    a: "1.0"
  },
  {
    n: [
      "minibus"
    ],
    u: "1f690",
    a: "1.0"
  },
  {
    n: [
      "ambulance"
    ],
    u: "1f691",
    a: "0.6"
  },
  {
    n: [
      "fire engine"
    ],
    u: "1f692",
    a: "0.6"
  },
  {
    n: [
      "police car"
    ],
    u: "1f693",
    a: "0.6"
  },
  {
    n: [
      "oncoming police car"
    ],
    u: "1f694",
    a: "0.7"
  },
  {
    n: [
      "taxi"
    ],
    u: "1f695",
    a: "0.6"
  },
  {
    n: [
      "oncoming taxi"
    ],
    u: "1f696",
    a: "1.0"
  },
  {
    n: [
      "car",
      "red car",
      "automobile"
    ],
    u: "1f697",
    a: "0.6"
  },
  {
    n: [
      "oncoming automobile"
    ],
    u: "1f698",
    a: "0.7"
  },
  {
    n: [
      "blue car",
      "recreational vehicle"
    ],
    u: "1f699",
    a: "0.6"
  },
  {
    n: [
      "pickup truck"
    ],
    u: "1f6fb",
    a: "13.0"
  },
  {
    n: [
      "truck",
      "delivery truck"
    ],
    u: "1f69a",
    a: "0.6"
  },
  {
    n: [
      "articulated lorry"
    ],
    u: "1f69b",
    a: "1.0"
  },
  {
    n: [
      "tractor"
    ],
    u: "1f69c",
    a: "1.0"
  },
  {
    n: [
      "racing car"
    ],
    u: "1f3ce-fe0f",
    a: "0.7"
  },
  {
    n: [
      "motorcycle",
      "racing motorcycle"
    ],
    u: "1f3cd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "motor scooter"
    ],
    u: "1f6f5",
    a: "3.0"
  },
  {
    n: [
      "manual wheelchair"
    ],
    u: "1f9bd",
    a: "12.0"
  },
  {
    n: [
      "motorized wheelchair"
    ],
    u: "1f9bc",
    a: "12.0"
  },
  {
    n: [
      "auto rickshaw"
    ],
    u: "1f6fa",
    a: "12.0"
  },
  {
    n: [
      "bike",
      "bicycle"
    ],
    u: "1f6b2",
    a: "0.6"
  },
  {
    n: [
      "scooter"
    ],
    u: "1f6f4",
    a: "3.0"
  },
  {
    n: [
      "skateboard"
    ],
    u: "1f6f9",
    a: "11.0"
  },
  {
    n: [
      "roller skate"
    ],
    u: "1f6fc",
    a: "13.0"
  },
  {
    n: [
      "busstop",
      "bus stop"
    ],
    u: "1f68f",
    a: "0.6"
  },
  {
    n: [
      "motorway"
    ],
    u: "1f6e3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "railway track"
    ],
    u: "1f6e4-fe0f",
    a: "0.7"
  },
  {
    n: [
      "oil drum"
    ],
    u: "1f6e2-fe0f",
    a: "0.7"
  },
  {
    n: [
      "fuelpump",
      "fuel pump"
    ],
    u: "26fd",
    a: "0.6"
  },
  {
    n: [
      "wheel"
    ],
    u: "1f6de",
    a: "14.0"
  },
  {
    n: [
      "rotating light",
      "police cars revolving light"
    ],
    u: "1f6a8",
    a: "0.6"
  },
  {
    n: [
      "traffic light",
      "horizontal traffic light"
    ],
    u: "1f6a5",
    a: "0.6"
  },
  {
    n: [
      "vertical traffic light"
    ],
    u: "1f6a6",
    a: "1.0"
  },
  {
    n: [
      "octagonal sign"
    ],
    u: "1f6d1",
    a: "3.0"
  },
  {
    n: [
      "construction",
      "construction sign"
    ],
    u: "1f6a7",
    a: "0.6"
  },
  {
    n: [
      "anchor"
    ],
    u: "2693",
    a: "0.6"
  },
  {
    n: [
      "ring buoy"
    ],
    u: "1f6df",
    a: "14.0"
  },
  {
    n: [
      "boat",
      "sailboat"
    ],
    u: "26f5",
    a: "0.6"
  },
  {
    n: [
      "canoe"
    ],
    u: "1f6f6",
    a: "3.0"
  },
  {
    n: [
      "speedboat"
    ],
    u: "1f6a4",
    a: "0.6"
  },
  {
    n: [
      "passenger ship"
    ],
    u: "1f6f3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "ferry"
    ],
    u: "26f4-fe0f",
    a: "0.7"
  },
  {
    n: [
      "motor boat"
    ],
    u: "1f6e5-fe0f",
    a: "0.7"
  },
  {
    n: [
      "ship"
    ],
    u: "1f6a2",
    a: "0.6"
  },
  {
    n: [
      "airplane"
    ],
    u: "2708-fe0f",
    a: "0.6"
  },
  {
    n: [
      "small airplane"
    ],
    u: "1f6e9-fe0f",
    a: "0.7"
  },
  {
    n: [
      "airplane departure"
    ],
    u: "1f6eb",
    a: "1.0"
  },
  {
    n: [
      "airplane arriving"
    ],
    u: "1f6ec",
    a: "1.0"
  },
  {
    n: [
      "parachute"
    ],
    u: "1fa82",
    a: "12.0"
  },
  {
    n: [
      "seat"
    ],
    u: "1f4ba",
    a: "0.6"
  },
  {
    n: [
      "helicopter"
    ],
    u: "1f681",
    a: "1.0"
  },
  {
    n: [
      "suspension railway"
    ],
    u: "1f69f",
    a: "1.0"
  },
  {
    n: [
      "mountain cableway"
    ],
    u: "1f6a0",
    a: "1.0"
  },
  {
    n: [
      "aerial tramway"
    ],
    u: "1f6a1",
    a: "1.0"
  },
  {
    n: [
      "satellite"
    ],
    u: "1f6f0-fe0f",
    a: "0.7"
  },
  {
    n: [
      "rocket"
    ],
    u: "1f680",
    a: "0.6"
  },
  {
    n: [
      "flying saucer"
    ],
    u: "1f6f8",
    a: "5.0"
  },
  {
    n: [
      "bellhop bell"
    ],
    u: "1f6ce-fe0f",
    a: "0.7"
  },
  {
    n: [
      "luggage"
    ],
    u: "1f9f3",
    a: "11.0"
  },
  {
    n: [
      "hourglass"
    ],
    u: "231b",
    a: "0.6"
  },
  {
    n: [
      "hourglass flowing sand",
      "hourglass with flowing sand"
    ],
    u: "23f3",
    a: "0.6"
  },
  {
    n: [
      "watch"
    ],
    u: "231a",
    a: "0.6"
  },
  {
    n: [
      "alarm clock"
    ],
    u: "23f0",
    a: "0.6"
  },
  {
    n: [
      "stopwatch"
    ],
    u: "23f1-fe0f",
    a: "1.0"
  },
  {
    n: [
      "timer clock"
    ],
    u: "23f2-fe0f",
    a: "1.0"
  },
  {
    n: [
      "mantelpiece clock"
    ],
    u: "1f570-fe0f",
    a: "0.7"
  },
  {
    n: [
      "clock12",
      "clock face twelve oclock"
    ],
    u: "1f55b",
    a: "0.6"
  },
  {
    n: [
      "clock1230",
      "clock face twelve-thirty"
    ],
    u: "1f567",
    a: "0.7"
  },
  {
    n: [
      "clock1",
      "clock face one oclock"
    ],
    u: "1f550",
    a: "0.6"
  },
  {
    n: [
      "clock130",
      "clock face one-thirty"
    ],
    u: "1f55c",
    a: "0.7"
  },
  {
    n: [
      "clock2",
      "clock face two oclock"
    ],
    u: "1f551",
    a: "0.6"
  },
  {
    n: [
      "clock230",
      "clock face two-thirty"
    ],
    u: "1f55d",
    a: "0.7"
  },
  {
    n: [
      "clock3",
      "clock face three oclock"
    ],
    u: "1f552",
    a: "0.6"
  },
  {
    n: [
      "clock330",
      "clock face three-thirty"
    ],
    u: "1f55e",
    a: "0.7"
  },
  {
    n: [
      "clock4",
      "clock face four oclock"
    ],
    u: "1f553",
    a: "0.6"
  },
  {
    n: [
      "clock430",
      "clock face four-thirty"
    ],
    u: "1f55f",
    a: "0.7"
  },
  {
    n: [
      "clock5",
      "clock face five oclock"
    ],
    u: "1f554",
    a: "0.6"
  },
  {
    n: [
      "clock530",
      "clock face five-thirty"
    ],
    u: "1f560",
    a: "0.7"
  },
  {
    n: [
      "clock6",
      "clock face six oclock"
    ],
    u: "1f555",
    a: "0.6"
  },
  {
    n: [
      "clock630",
      "clock face six-thirty"
    ],
    u: "1f561",
    a: "0.7"
  },
  {
    n: [
      "clock7",
      "clock face seven oclock"
    ],
    u: "1f556",
    a: "0.6"
  },
  {
    n: [
      "clock730",
      "clock face seven-thirty"
    ],
    u: "1f562",
    a: "0.7"
  },
  {
    n: [
      "clock8",
      "clock face eight oclock"
    ],
    u: "1f557",
    a: "0.6"
  },
  {
    n: [
      "clock830",
      "clock face eight-thirty"
    ],
    u: "1f563",
    a: "0.7"
  },
  {
    n: [
      "clock9",
      "clock face nine oclock"
    ],
    u: "1f558",
    a: "0.6"
  },
  {
    n: [
      "clock930",
      "clock face nine-thirty"
    ],
    u: "1f564",
    a: "0.7"
  },
  {
    n: [
      "clock10",
      "clock face ten oclock"
    ],
    u: "1f559",
    a: "0.6"
  },
  {
    n: [
      "clock1030",
      "clock face ten-thirty"
    ],
    u: "1f565",
    a: "0.7"
  },
  {
    n: [
      "clock11",
      "clock face eleven oclock"
    ],
    u: "1f55a",
    a: "0.6"
  },
  {
    n: [
      "clock1130",
      "clock face eleven-thirty"
    ],
    u: "1f566",
    a: "0.7"
  },
  {
    n: [
      "new moon",
      "new moon symbol"
    ],
    u: "1f311",
    a: "0.6"
  },
  {
    n: [
      "waxing crescent moon",
      "waxing crescent moon symbol"
    ],
    u: "1f312",
    a: "1.0"
  },
  {
    n: [
      "first quarter moon",
      "first quarter moon symbol"
    ],
    u: "1f313",
    a: "0.6"
  },
  {
    n: [
      "moon",
      "waxing gibbous moon",
      "waxing gibbous moon symbol"
    ],
    u: "1f314",
    a: "0.6"
  },
  {
    n: [
      "full moon",
      "full moon symbol"
    ],
    u: "1f315",
    a: "0.6"
  },
  {
    n: [
      "waning gibbous moon",
      "waning gibbous moon symbol"
    ],
    u: "1f316",
    a: "1.0"
  },
  {
    n: [
      "last quarter moon",
      "last quarter moon symbol"
    ],
    u: "1f317",
    a: "1.0"
  },
  {
    n: [
      "waning crescent moon",
      "waning crescent moon symbol"
    ],
    u: "1f318",
    a: "1.0"
  },
  {
    n: [
      "crescent moon"
    ],
    u: "1f319",
    a: "0.6"
  },
  {
    n: [
      "new moon with face"
    ],
    u: "1f31a",
    a: "1.0"
  },
  {
    n: [
      "first quarter moon with face"
    ],
    u: "1f31b",
    a: "0.6"
  },
  {
    n: [
      "last quarter moon with face"
    ],
    u: "1f31c",
    a: "0.7"
  },
  {
    n: [
      "thermometer"
    ],
    u: "1f321-fe0f",
    a: "0.7"
  },
  {
    n: [
      "sunny",
      "black sun with rays"
    ],
    u: "2600-fe0f",
    a: "0.6"
  },
  {
    n: [
      "full moon with face"
    ],
    u: "1f31d",
    a: "1.0"
  },
  {
    n: [
      "sun with face"
    ],
    u: "1f31e",
    a: "1.0"
  },
  {
    n: [
      "ringed planet"
    ],
    u: "1fa90",
    a: "12.0"
  },
  {
    n: [
      "star",
      "white medium star"
    ],
    u: "2b50",
    a: "0.6"
  },
  {
    n: [
      "star2",
      "glowing star"
    ],
    u: "1f31f",
    a: "0.6"
  },
  {
    n: [
      "stars",
      "shooting star"
    ],
    u: "1f320",
    a: "0.6"
  },
  {
    n: [
      "milky way"
    ],
    u: "1f30c",
    a: "0.6"
  },
  {
    n: [
      "cloud"
    ],
    u: "2601-fe0f",
    a: "0.6"
  },
  {
    n: [
      "partly sunny",
      "sun behind cloud"
    ],
    u: "26c5",
    a: "0.6"
  },
  {
    n: [
      "thunder cloud and rain",
      "cloud with lightning and rain"
    ],
    u: "26c8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "mostly sunny",
      "sun small cloud",
      "sun behind small cloud"
    ],
    u: "1f324-fe0f",
    a: "0.7"
  },
  {
    n: [
      "barely sunny",
      "sun behind cloud",
      "sun behind large cloud"
    ],
    u: "1f325-fe0f",
    a: "0.7"
  },
  {
    n: [
      "partly sunny rain",
      "sun behind rain cloud"
    ],
    u: "1f326-fe0f",
    a: "0.7"
  },
  {
    n: [
      "rain cloud",
      "cloud with rain"
    ],
    u: "1f327-fe0f",
    a: "0.7"
  },
  {
    n: [
      "snow cloud",
      "cloud with snow"
    ],
    u: "1f328-fe0f",
    a: "0.7"
  },
  {
    n: [
      "lightning",
      "lightning cloud",
      "cloud with lightning"
    ],
    u: "1f329-fe0f",
    a: "0.7"
  },
  {
    n: [
      "tornado",
      "tornado cloud"
    ],
    u: "1f32a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "fog"
    ],
    u: "1f32b-fe0f",
    a: "0.7"
  },
  {
    n: [
      "wind face",
      "wind blowing face"
    ],
    u: "1f32c-fe0f",
    a: "0.7"
  },
  {
    n: [
      "cyclone"
    ],
    u: "1f300",
    a: "0.6"
  },
  {
    n: [
      "rainbow"
    ],
    u: "1f308",
    a: "0.6"
  },
  {
    n: [
      "closed umbrella"
    ],
    u: "1f302",
    a: "0.6"
  },
  {
    n: [
      "umbrella"
    ],
    u: "2602-fe0f",
    a: "0.7"
  },
  {
    n: [
      "umbrella with rain drops"
    ],
    u: "2614",
    a: "0.6"
  },
  {
    n: [
      "umbrella on ground"
    ],
    u: "26f1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "zap",
      "high voltage sign"
    ],
    u: "26a1",
    a: "0.6"
  },
  {
    n: [
      "snowflake"
    ],
    u: "2744-fe0f",
    a: "0.6"
  },
  {
    n: [
      "snowman"
    ],
    u: "2603-fe0f",
    a: "0.7"
  },
  {
    n: [
      "snowman without snow"
    ],
    u: "26c4",
    a: "0.6"
  },
  {
    n: [
      "comet"
    ],
    u: "2604-fe0f",
    a: "1.0"
  },
  {
    n: [
      "fire"
    ],
    u: "1f525",
    a: "0.6"
  },
  {
    n: [
      "droplet"
    ],
    u: "1f4a7",
    a: "0.6"
  },
  {
    n: [
      "ocean",
      "water wave"
    ],
    u: "1f30a",
    a: "0.6"
  }
], E2t = [
  {
    n: [
      "jack-o-lantern",
      "jack o lantern"
    ],
    u: "1f383",
    a: "0.6"
  },
  {
    n: [
      "christmas tree"
    ],
    u: "1f384",
    a: "0.6"
  },
  {
    n: [
      "fireworks"
    ],
    u: "1f386",
    a: "0.6"
  },
  {
    n: [
      "sparkler",
      "firework sparkler"
    ],
    u: "1f387",
    a: "0.6"
  },
  {
    n: [
      "firecracker"
    ],
    u: "1f9e8",
    a: "11.0"
  },
  {
    n: [
      "sparkles"
    ],
    u: "2728",
    a: "0.6"
  },
  {
    n: [
      "balloon"
    ],
    u: "1f388",
    a: "0.6"
  },
  {
    n: [
      "tada",
      "party popper"
    ],
    u: "1f389",
    a: "0.6"
  },
  {
    n: [
      "confetti ball"
    ],
    u: "1f38a",
    a: "0.6"
  },
  {
    n: [
      "tanabata tree"
    ],
    u: "1f38b",
    a: "0.6"
  },
  {
    n: [
      "bamboo",
      "pine decoration"
    ],
    u: "1f38d",
    a: "0.6"
  },
  {
    n: [
      "dolls",
      "japanese dolls"
    ],
    u: "1f38e",
    a: "0.6"
  },
  {
    n: [
      "flags",
      "carp streamer"
    ],
    u: "1f38f",
    a: "0.6"
  },
  {
    n: [
      "wind chime"
    ],
    u: "1f390",
    a: "0.6"
  },
  {
    n: [
      "rice scene",
      "moon viewing ceremony"
    ],
    u: "1f391",
    a: "0.6"
  },
  {
    n: [
      "red envelope",
      "red gift envelope"
    ],
    u: "1f9e7",
    a: "11.0"
  },
  {
    n: [
      "ribbon"
    ],
    u: "1f380",
    a: "0.6"
  },
  {
    n: [
      "gift",
      "wrapped present"
    ],
    u: "1f381",
    a: "0.6"
  },
  {
    n: [
      "reminder ribbon"
    ],
    u: "1f397-fe0f",
    a: "0.7"
  },
  {
    n: [
      "admission tickets"
    ],
    u: "1f39f-fe0f",
    a: "0.7"
  },
  {
    n: [
      "ticket"
    ],
    u: "1f3ab",
    a: "0.6"
  },
  {
    n: [
      "medal",
      "military medal"
    ],
    u: "1f396-fe0f",
    a: "0.7"
  },
  {
    n: [
      "trophy"
    ],
    u: "1f3c6",
    a: "0.6"
  },
  {
    n: [
      "sports medal"
    ],
    u: "1f3c5",
    a: "1.0"
  },
  {
    n: [
      "first place medal"
    ],
    u: "1f947",
    a: "3.0"
  },
  {
    n: [
      "second place medal"
    ],
    u: "1f948",
    a: "3.0"
  },
  {
    n: [
      "third place medal"
    ],
    u: "1f949",
    a: "3.0"
  },
  {
    n: [
      "soccer",
      "soccer ball"
    ],
    u: "26bd",
    a: "0.6"
  },
  {
    n: [
      "baseball"
    ],
    u: "26be",
    a: "0.6"
  },
  {
    n: [
      "softball"
    ],
    u: "1f94e",
    a: "11.0"
  },
  {
    n: [
      "basketball",
      "basketball and hoop"
    ],
    u: "1f3c0",
    a: "0.6"
  },
  {
    n: [
      "volleyball"
    ],
    u: "1f3d0",
    a: "1.0"
  },
  {
    n: [
      "football",
      "american football"
    ],
    u: "1f3c8",
    a: "0.6"
  },
  {
    n: [
      "rugby football"
    ],
    u: "1f3c9",
    a: "1.0"
  },
  {
    n: [
      "tennis",
      "tennis racquet and ball"
    ],
    u: "1f3be",
    a: "0.6"
  },
  {
    n: [
      "flying disc"
    ],
    u: "1f94f",
    a: "11.0"
  },
  {
    n: [
      "bowling"
    ],
    u: "1f3b3",
    a: "0.6"
  },
  {
    n: [
      "cricket bat and ball"
    ],
    u: "1f3cf",
    a: "1.0"
  },
  {
    n: [
      "field hockey stick and ball"
    ],
    u: "1f3d1",
    a: "1.0"
  },
  {
    n: [
      "ice hockey stick and puck"
    ],
    u: "1f3d2",
    a: "1.0"
  },
  {
    n: [
      "lacrosse",
      "lacrosse stick and ball"
    ],
    u: "1f94d",
    a: "11.0"
  },
  {
    n: [
      "table tennis paddle and ball"
    ],
    u: "1f3d3",
    a: "1.0"
  },
  {
    n: [
      "badminton racquet and shuttlecock"
    ],
    u: "1f3f8",
    a: "1.0"
  },
  {
    n: [
      "boxing glove"
    ],
    u: "1f94a",
    a: "3.0"
  },
  {
    n: [
      "martial arts uniform"
    ],
    u: "1f94b",
    a: "3.0"
  },
  {
    n: [
      "goal net"
    ],
    u: "1f945",
    a: "3.0"
  },
  {
    n: [
      "golf",
      "flag in hole"
    ],
    u: "26f3",
    a: "0.6"
  },
  {
    n: [
      "ice skate"
    ],
    u: "26f8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "fishing pole and fish"
    ],
    u: "1f3a3",
    a: "0.6"
  },
  {
    n: [
      "diving mask"
    ],
    u: "1f93f",
    a: "12.0"
  },
  {
    n: [
      "running shirt with sash"
    ],
    u: "1f3bd",
    a: "0.6"
  },
  {
    n: [
      "ski",
      "ski and ski boot"
    ],
    u: "1f3bf",
    a: "0.6"
  },
  {
    n: [
      "sled"
    ],
    u: "1f6f7",
    a: "5.0"
  },
  {
    n: [
      "curling stone"
    ],
    u: "1f94c",
    a: "5.0"
  },
  {
    n: [
      "dart",
      "direct hit"
    ],
    u: "1f3af",
    a: "0.6"
  },
  {
    n: [
      "yo-yo"
    ],
    u: "1fa80",
    a: "12.0"
  },
  {
    n: [
      "kite"
    ],
    u: "1fa81",
    a: "12.0"
  },
  {
    n: [
      "8ball",
      "billiards"
    ],
    u: "1f3b1",
    a: "0.6"
  },
  {
    n: [
      "crystal ball"
    ],
    u: "1f52e",
    a: "0.6"
  },
  {
    n: [
      "magic wand"
    ],
    u: "1fa84",
    a: "13.0"
  },
  {
    n: [
      "nazar amulet"
    ],
    u: "1f9ff",
    a: "11.0"
  },
  {
    n: [
      "hamsa"
    ],
    u: "1faac",
    a: "14.0"
  },
  {
    n: [
      "video game"
    ],
    u: "1f3ae",
    a: "0.6"
  },
  {
    n: [
      "joystick"
    ],
    u: "1f579-fe0f",
    a: "0.7"
  },
  {
    n: [
      "slot machine"
    ],
    u: "1f3b0",
    a: "0.6"
  },
  {
    n: [
      "game die"
    ],
    u: "1f3b2",
    a: "0.6"
  },
  {
    n: [
      "jigsaw",
      "jigsaw puzzle piece"
    ],
    u: "1f9e9",
    a: "11.0"
  },
  {
    n: [
      "teddy bear"
    ],
    u: "1f9f8",
    a: "11.0"
  },
  {
    n: [
      "pinata"
    ],
    u: "1fa85",
    a: "13.0"
  },
  {
    n: [
      "mirror ball"
    ],
    u: "1faa9",
    a: "14.0"
  },
  {
    n: [
      "nesting dolls"
    ],
    u: "1fa86",
    a: "13.0"
  },
  {
    n: [
      "spades",
      "black spade suit"
    ],
    u: "2660-fe0f",
    a: "0.6"
  },
  {
    n: [
      "hearts",
      "black heart suit"
    ],
    u: "2665-fe0f",
    a: "0.6"
  },
  {
    n: [
      "diamonds",
      "black diamond suit"
    ],
    u: "2666-fe0f",
    a: "0.6"
  },
  {
    n: [
      "clubs",
      "black club suit"
    ],
    u: "2663-fe0f",
    a: "0.6"
  },
  {
    n: [
      "chess pawn"
    ],
    u: "265f-fe0f",
    a: "11.0"
  },
  {
    n: [
      "black joker",
      "playing card black joker"
    ],
    u: "1f0cf",
    a: "0.6"
  },
  {
    n: [
      "mahjong",
      "mahjong tile red dragon"
    ],
    u: "1f004",
    a: "0.6"
  },
  {
    n: [
      "flower playing cards"
    ],
    u: "1f3b4",
    a: "0.6"
  },
  {
    n: [
      "performing arts"
    ],
    u: "1f3ad",
    a: "0.6"
  },
  {
    n: [
      "framed picture",
      "frame with picture"
    ],
    u: "1f5bc-fe0f",
    a: "0.7"
  },
  {
    n: [
      "art",
      "artist palette"
    ],
    u: "1f3a8",
    a: "0.6"
  },
  {
    n: [
      "thread",
      "spool of thread"
    ],
    u: "1f9f5",
    a: "11.0"
  },
  {
    n: [
      "sewing needle"
    ],
    u: "1faa1",
    a: "13.0"
  },
  {
    n: [
      "yarn",
      "ball of yarn"
    ],
    u: "1f9f6",
    a: "11.0"
  },
  {
    n: [
      "knot"
    ],
    u: "1faa2",
    a: "13.0"
  }
], j2t = [
  {
    n: [
      "eyeglasses"
    ],
    u: "1f453",
    a: "0.6"
  },
  {
    n: [
      "sunglasses",
      "dark sunglasses"
    ],
    u: "1f576-fe0f",
    a: "0.7"
  },
  {
    n: [
      "goggles"
    ],
    u: "1f97d",
    a: "11.0"
  },
  {
    n: [
      "lab coat"
    ],
    u: "1f97c",
    a: "11.0"
  },
  {
    n: [
      "safety vest"
    ],
    u: "1f9ba",
    a: "12.0"
  },
  {
    n: [
      "necktie"
    ],
    u: "1f454",
    a: "0.6"
  },
  {
    n: [
      "shirt",
      "tshirt",
      "t-shirt"
    ],
    u: "1f455",
    a: "0.6"
  },
  {
    n: [
      "jeans"
    ],
    u: "1f456",
    a: "0.6"
  },
  {
    n: [
      "scarf"
    ],
    u: "1f9e3",
    a: "5.0"
  },
  {
    n: [
      "gloves"
    ],
    u: "1f9e4",
    a: "5.0"
  },
  {
    n: [
      "coat"
    ],
    u: "1f9e5",
    a: "5.0"
  },
  {
    n: [
      "socks"
    ],
    u: "1f9e6",
    a: "5.0"
  },
  {
    n: [
      "dress"
    ],
    u: "1f457",
    a: "0.6"
  },
  {
    n: [
      "kimono"
    ],
    u: "1f458",
    a: "0.6"
  },
  {
    n: [
      "sari"
    ],
    u: "1f97b",
    a: "12.0"
  },
  {
    n: [
      "one-piece swimsuit"
    ],
    u: "1fa71",
    a: "12.0"
  },
  {
    n: [
      "briefs"
    ],
    u: "1fa72",
    a: "12.0"
  },
  {
    n: [
      "shorts"
    ],
    u: "1fa73",
    a: "12.0"
  },
  {
    n: [
      "bikini"
    ],
    u: "1f459",
    a: "0.6"
  },
  {
    n: [
      "womans clothes"
    ],
    u: "1f45a",
    a: "0.6"
  },
  {
    n: [
      "purse"
    ],
    u: "1f45b",
    a: "0.6"
  },
  {
    n: [
      "handbag"
    ],
    u: "1f45c",
    a: "0.6"
  },
  {
    n: [
      "pouch"
    ],
    u: "1f45d",
    a: "0.6"
  },
  {
    n: [
      "shopping bags"
    ],
    u: "1f6cd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "school satchel"
    ],
    u: "1f392",
    a: "0.6"
  },
  {
    n: [
      "thong sandal"
    ],
    u: "1fa74",
    a: "13.0"
  },
  {
    n: [
      "shoe",
      "mans shoe"
    ],
    u: "1f45e",
    a: "0.6"
  },
  {
    n: [
      "athletic shoe"
    ],
    u: "1f45f",
    a: "0.6"
  },
  {
    n: [
      "hiking boot"
    ],
    u: "1f97e",
    a: "11.0"
  },
  {
    n: [
      "flat shoe",
      "womans flat shoe"
    ],
    u: "1f97f",
    a: "11.0"
  },
  {
    n: [
      "high heel",
      "high-heeled shoe"
    ],
    u: "1f460",
    a: "0.6"
  },
  {
    n: [
      "sandal",
      "womans sandal"
    ],
    u: "1f461",
    a: "0.6"
  },
  {
    n: [
      "ballet shoes"
    ],
    u: "1fa70",
    a: "12.0"
  },
  {
    n: [
      "boot",
      "womans boots"
    ],
    u: "1f462",
    a: "0.6"
  },
  {
    n: [
      "crown"
    ],
    u: "1f451",
    a: "0.6"
  },
  {
    n: [
      "womans hat"
    ],
    u: "1f452",
    a: "0.6"
  },
  {
    n: [
      "tophat",
      "top hat"
    ],
    u: "1f3a9",
    a: "0.6"
  },
  {
    n: [
      "mortar board",
      "graduation cap"
    ],
    u: "1f393",
    a: "0.6"
  },
  {
    n: [
      "billed cap"
    ],
    u: "1f9e2",
    a: "5.0"
  },
  {
    n: [
      "military helmet"
    ],
    u: "1fa96",
    a: "13.0"
  },
  {
    n: [
      "rescue worker’s helmet",
      "helmet with white cross"
    ],
    u: "26d1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "prayer beads"
    ],
    u: "1f4ff",
    a: "1.0"
  },
  {
    n: [
      "lipstick"
    ],
    u: "1f484",
    a: "0.6"
  },
  {
    n: [
      "ring"
    ],
    u: "1f48d",
    a: "0.6"
  },
  {
    n: [
      "gem",
      "gem stone"
    ],
    u: "1f48e",
    a: "0.6"
  },
  {
    n: [
      "mute",
      "speaker with cancellation stroke"
    ],
    u: "1f507",
    a: "1.0"
  },
  {
    n: [
      "speaker"
    ],
    u: "1f508",
    a: "0.7"
  },
  {
    n: [
      "sound",
      "speaker with one sound wave"
    ],
    u: "1f509",
    a: "1.0"
  },
  {
    n: [
      "loud sound",
      "speaker with three sound waves"
    ],
    u: "1f50a",
    a: "0.6"
  },
  {
    n: [
      "loudspeaker",
      "public address loudspeaker"
    ],
    u: "1f4e2",
    a: "0.6"
  },
  {
    n: [
      "mega",
      "cheering megaphone"
    ],
    u: "1f4e3",
    a: "0.6"
  },
  {
    n: [
      "postal horn"
    ],
    u: "1f4ef",
    a: "1.0"
  },
  {
    n: [
      "bell"
    ],
    u: "1f514",
    a: "0.6"
  },
  {
    n: [
      "no bell",
      "bell with cancellation stroke"
    ],
    u: "1f515",
    a: "1.0"
  },
  {
    n: [
      "musical score"
    ],
    u: "1f3bc",
    a: "0.6"
  },
  {
    n: [
      "musical note"
    ],
    u: "1f3b5",
    a: "0.6"
  },
  {
    n: [
      "notes",
      "multiple musical notes"
    ],
    u: "1f3b6",
    a: "0.6"
  },
  {
    n: [
      "studio microphone"
    ],
    u: "1f399-fe0f",
    a: "0.7"
  },
  {
    n: [
      "level slider"
    ],
    u: "1f39a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "control knobs"
    ],
    u: "1f39b-fe0f",
    a: "0.7"
  },
  {
    n: [
      "microphone"
    ],
    u: "1f3a4",
    a: "0.6"
  },
  {
    n: [
      "headphone",
      "headphones"
    ],
    u: "1f3a7",
    a: "0.6"
  },
  {
    n: [
      "radio"
    ],
    u: "1f4fb",
    a: "0.6"
  },
  {
    n: [
      "saxophone"
    ],
    u: "1f3b7",
    a: "0.6"
  },
  {
    n: [
      "accordion"
    ],
    u: "1fa97",
    a: "13.0"
  },
  {
    n: [
      "guitar"
    ],
    u: "1f3b8",
    a: "0.6"
  },
  {
    n: [
      "musical keyboard"
    ],
    u: "1f3b9",
    a: "0.6"
  },
  {
    n: [
      "trumpet"
    ],
    u: "1f3ba",
    a: "0.6"
  },
  {
    n: [
      "violin"
    ],
    u: "1f3bb",
    a: "0.6"
  },
  {
    n: [
      "banjo"
    ],
    u: "1fa95",
    a: "12.0"
  },
  {
    n: [
      "drum with drumsticks"
    ],
    u: "1f941",
    a: "3.0"
  },
  {
    n: [
      "long drum"
    ],
    u: "1fa98",
    a: "13.0"
  },
  {
    n: [
      "iphone",
      "mobile phone"
    ],
    u: "1f4f1",
    a: "0.6"
  },
  {
    n: [
      "calling",
      "mobile phone with rightwards arrow at left"
    ],
    u: "1f4f2",
    a: "0.6"
  },
  {
    n: [
      "phone",
      "telephone",
      "black telephone"
    ],
    u: "260e-fe0f",
    a: "0.6"
  },
  {
    n: [
      "telephone receiver"
    ],
    u: "1f4de",
    a: "0.6"
  },
  {
    n: [
      "pager"
    ],
    u: "1f4df",
    a: "0.6"
  },
  {
    n: [
      "fax",
      "fax machine"
    ],
    u: "1f4e0",
    a: "0.6"
  },
  {
    n: [
      "battery"
    ],
    u: "1f50b",
    a: "0.6"
  },
  {
    n: [
      "low battery"
    ],
    u: "1faab",
    a: "14.0"
  },
  {
    n: [
      "electric plug"
    ],
    u: "1f50c",
    a: "0.6"
  },
  {
    n: [
      "computer",
      "personal computer"
    ],
    u: "1f4bb",
    a: "0.6"
  },
  {
    n: [
      "desktop computer"
    ],
    u: "1f5a5-fe0f",
    a: "0.7"
  },
  {
    n: [
      "printer"
    ],
    u: "1f5a8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "keyboard"
    ],
    u: "2328-fe0f",
    a: "1.0"
  },
  {
    n: [
      "computer mouse",
      "three button mouse"
    ],
    u: "1f5b1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "trackball"
    ],
    u: "1f5b2-fe0f",
    a: "0.7"
  },
  {
    n: [
      "minidisc"
    ],
    u: "1f4bd",
    a: "0.6"
  },
  {
    n: [
      "floppy disk"
    ],
    u: "1f4be",
    a: "0.6"
  },
  {
    n: [
      "cd",
      "optical disc"
    ],
    u: "1f4bf",
    a: "0.6"
  },
  {
    n: [
      "dvd"
    ],
    u: "1f4c0",
    a: "0.6"
  },
  {
    n: [
      "abacus"
    ],
    u: "1f9ee",
    a: "11.0"
  },
  {
    n: [
      "movie camera"
    ],
    u: "1f3a5",
    a: "0.6"
  },
  {
    n: [
      "film frames"
    ],
    u: "1f39e-fe0f",
    a: "0.7"
  },
  {
    n: [
      "film projector"
    ],
    u: "1f4fd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "clapper",
      "clapper board"
    ],
    u: "1f3ac",
    a: "0.6"
  },
  {
    n: [
      "tv",
      "television"
    ],
    u: "1f4fa",
    a: "0.6"
  },
  {
    n: [
      "camera"
    ],
    u: "1f4f7",
    a: "0.6"
  },
  {
    n: [
      "camera with flash"
    ],
    u: "1f4f8",
    a: "1.0"
  },
  {
    n: [
      "video camera"
    ],
    u: "1f4f9",
    a: "0.6"
  },
  {
    n: [
      "vhs",
      "videocassette"
    ],
    u: "1f4fc",
    a: "0.6"
  },
  {
    n: [
      "mag",
      "left-pointing magnifying glass"
    ],
    u: "1f50d",
    a: "0.6"
  },
  {
    n: [
      "mag right",
      "right-pointing magnifying glass"
    ],
    u: "1f50e",
    a: "0.6"
  },
  {
    n: [
      "candle"
    ],
    u: "1f56f-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bulb",
      "electric light bulb"
    ],
    u: "1f4a1",
    a: "0.6"
  },
  {
    n: [
      "flashlight",
      "electric torch"
    ],
    u: "1f526",
    a: "0.6"
  },
  {
    n: [
      "lantern",
      "izakaya lantern"
    ],
    u: "1f3ee",
    a: "0.6"
  },
  {
    n: [
      "diya lamp"
    ],
    u: "1fa94",
    a: "12.0"
  },
  {
    n: [
      "notebook with decorative cover"
    ],
    u: "1f4d4",
    a: "0.6"
  },
  {
    n: [
      "closed book"
    ],
    u: "1f4d5",
    a: "0.6"
  },
  {
    n: [
      "book",
      "open book"
    ],
    u: "1f4d6",
    a: "0.6"
  },
  {
    n: [
      "green book"
    ],
    u: "1f4d7",
    a: "0.6"
  },
  {
    n: [
      "blue book"
    ],
    u: "1f4d8",
    a: "0.6"
  },
  {
    n: [
      "orange book"
    ],
    u: "1f4d9",
    a: "0.6"
  },
  {
    n: [
      "books"
    ],
    u: "1f4da",
    a: "0.6"
  },
  {
    n: [
      "notebook"
    ],
    u: "1f4d3",
    a: "0.6"
  },
  {
    n: [
      "ledger"
    ],
    u: "1f4d2",
    a: "0.6"
  },
  {
    n: [
      "page with curl"
    ],
    u: "1f4c3",
    a: "0.6"
  },
  {
    n: [
      "scroll"
    ],
    u: "1f4dc",
    a: "0.6"
  },
  {
    n: [
      "page facing up"
    ],
    u: "1f4c4",
    a: "0.6"
  },
  {
    n: [
      "newspaper"
    ],
    u: "1f4f0",
    a: "0.6"
  },
  {
    n: [
      "rolled-up newspaper",
      "rolled up newspaper"
    ],
    u: "1f5de-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bookmark tabs"
    ],
    u: "1f4d1",
    a: "0.6"
  },
  {
    n: [
      "bookmark"
    ],
    u: "1f516",
    a: "0.6"
  },
  {
    n: [
      "label"
    ],
    u: "1f3f7-fe0f",
    a: "0.7"
  },
  {
    n: [
      "moneybag",
      "money bag"
    ],
    u: "1f4b0",
    a: "0.6"
  },
  {
    n: [
      "coin"
    ],
    u: "1fa99",
    a: "13.0"
  },
  {
    n: [
      "yen",
      "banknote with yen sign"
    ],
    u: "1f4b4",
    a: "0.6"
  },
  {
    n: [
      "dollar",
      "banknote with dollar sign"
    ],
    u: "1f4b5",
    a: "0.6"
  },
  {
    n: [
      "euro",
      "banknote with euro sign"
    ],
    u: "1f4b6",
    a: "1.0"
  },
  {
    n: [
      "pound",
      "banknote with pound sign"
    ],
    u: "1f4b7",
    a: "1.0"
  },
  {
    n: [
      "money with wings"
    ],
    u: "1f4b8",
    a: "0.6"
  },
  {
    n: [
      "credit card"
    ],
    u: "1f4b3",
    a: "0.6"
  },
  {
    n: [
      "receipt"
    ],
    u: "1f9fe",
    a: "11.0"
  },
  {
    n: [
      "chart",
      "chart with upwards trend and yen sign"
    ],
    u: "1f4b9",
    a: "0.6"
  },
  {
    n: [
      "email",
      "envelope"
    ],
    u: "2709-fe0f",
    a: "0.6"
  },
  {
    n: [
      "e-mail",
      "e-mail symbol"
    ],
    u: "1f4e7",
    a: "0.6"
  },
  {
    n: [
      "incoming envelope"
    ],
    u: "1f4e8",
    a: "0.6"
  },
  {
    n: [
      "envelope with arrow",
      "envelope with downwards arrow above"
    ],
    u: "1f4e9",
    a: "0.6"
  },
  {
    n: [
      "outbox tray"
    ],
    u: "1f4e4",
    a: "0.6"
  },
  {
    n: [
      "inbox tray"
    ],
    u: "1f4e5",
    a: "0.6"
  },
  {
    n: [
      "package"
    ],
    u: "1f4e6",
    a: "0.6"
  },
  {
    n: [
      "mailbox",
      "closed mailbox with raised flag"
    ],
    u: "1f4eb",
    a: "0.6"
  },
  {
    n: [
      "mailbox closed",
      "closed mailbox with lowered flag"
    ],
    u: "1f4ea",
    a: "0.6"
  },
  {
    n: [
      "mailbox with mail",
      "open mailbox with raised flag"
    ],
    u: "1f4ec",
    a: "0.7"
  },
  {
    n: [
      "mailbox with no mail",
      "open mailbox with lowered flag"
    ],
    u: "1f4ed",
    a: "0.7"
  },
  {
    n: [
      "postbox"
    ],
    u: "1f4ee",
    a: "0.6"
  },
  {
    n: [
      "ballot box with ballot"
    ],
    u: "1f5f3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "pencil",
      "pencil2"
    ],
    u: "270f-fe0f",
    a: "0.6"
  },
  {
    n: [
      "black nib"
    ],
    u: "2712-fe0f",
    a: "0.6"
  },
  {
    n: [
      "fountain pen",
      "lower left fountain pen"
    ],
    u: "1f58b-fe0f",
    a: "0.7"
  },
  {
    n: [
      "pen",
      "lower left ballpoint pen"
    ],
    u: "1f58a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "paintbrush",
      "lower left paintbrush"
    ],
    u: "1f58c-fe0f",
    a: "0.7"
  },
  {
    n: [
      "crayon",
      "lower left crayon"
    ],
    u: "1f58d-fe0f",
    a: "0.7"
  },
  {
    n: [
      "memo",
      "pencil"
    ],
    u: "1f4dd",
    a: "0.6"
  },
  {
    n: [
      "briefcase"
    ],
    u: "1f4bc",
    a: "0.6"
  },
  {
    n: [
      "file folder"
    ],
    u: "1f4c1",
    a: "0.6"
  },
  {
    n: [
      "open file folder"
    ],
    u: "1f4c2",
    a: "0.6"
  },
  {
    n: [
      "card index dividers"
    ],
    u: "1f5c2-fe0f",
    a: "0.7"
  },
  {
    n: [
      "date",
      "calendar"
    ],
    u: "1f4c5",
    a: "0.6"
  },
  {
    n: [
      "calendar",
      "tear-off calendar"
    ],
    u: "1f4c6",
    a: "0.6"
  },
  {
    n: [
      "spiral notepad",
      "spiral note pad"
    ],
    u: "1f5d2-fe0f",
    a: "0.7"
  },
  {
    n: [
      "spiral calendar",
      "spiral calendar pad"
    ],
    u: "1f5d3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "card index"
    ],
    u: "1f4c7",
    a: "0.6"
  },
  {
    n: [
      "chart with upwards trend"
    ],
    u: "1f4c8",
    a: "0.6"
  },
  {
    n: [
      "chart with downwards trend"
    ],
    u: "1f4c9",
    a: "0.6"
  },
  {
    n: [
      "bar chart"
    ],
    u: "1f4ca",
    a: "0.6"
  },
  {
    n: [
      "clipboard"
    ],
    u: "1f4cb",
    a: "0.6"
  },
  {
    n: [
      "pushpin"
    ],
    u: "1f4cc",
    a: "0.6"
  },
  {
    n: [
      "round pushpin"
    ],
    u: "1f4cd",
    a: "0.6"
  },
  {
    n: [
      "paperclip"
    ],
    u: "1f4ce",
    a: "0.6"
  },
  {
    n: [
      "linked paperclips"
    ],
    u: "1f587-fe0f",
    a: "0.7"
  },
  {
    n: [
      "straight ruler"
    ],
    u: "1f4cf",
    a: "0.6"
  },
  {
    n: [
      "triangular ruler"
    ],
    u: "1f4d0",
    a: "0.6"
  },
  {
    n: [
      "scissors",
      "black scissors"
    ],
    u: "2702-fe0f",
    a: "0.6"
  },
  {
    n: [
      "card file box"
    ],
    u: "1f5c3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "file cabinet"
    ],
    u: "1f5c4-fe0f",
    a: "0.7"
  },
  {
    n: [
      "wastebasket"
    ],
    u: "1f5d1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "lock"
    ],
    u: "1f512",
    a: "0.6"
  },
  {
    n: [
      "unlock",
      "open lock"
    ],
    u: "1f513",
    a: "0.6"
  },
  {
    n: [
      "lock with ink pen"
    ],
    u: "1f50f",
    a: "0.6"
  },
  {
    n: [
      "closed lock with key"
    ],
    u: "1f510",
    a: "0.6"
  },
  {
    n: [
      "key"
    ],
    u: "1f511",
    a: "0.6"
  },
  {
    n: [
      "old key"
    ],
    u: "1f5dd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "hammer"
    ],
    u: "1f528",
    a: "0.6"
  },
  {
    n: [
      "axe"
    ],
    u: "1fa93",
    a: "12.0"
  },
  {
    n: [
      "pick"
    ],
    u: "26cf-fe0f",
    a: "0.7"
  },
  {
    n: [
      "hammer and pick"
    ],
    u: "2692-fe0f",
    a: "1.0"
  },
  {
    n: [
      "hammer and wrench"
    ],
    u: "1f6e0-fe0f",
    a: "0.7"
  },
  {
    n: [
      "dagger",
      "dagger knife"
    ],
    u: "1f5e1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "crossed swords"
    ],
    u: "2694-fe0f",
    a: "1.0"
  },
  {
    n: [
      "gun",
      "pistol"
    ],
    u: "1f52b",
    a: "0.6"
  },
  {
    n: [
      "boomerang"
    ],
    u: "1fa83",
    a: "13.0"
  },
  {
    n: [
      "bow and arrow"
    ],
    u: "1f3f9",
    a: "1.0"
  },
  {
    n: [
      "shield"
    ],
    u: "1f6e1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "carpentry saw"
    ],
    u: "1fa9a",
    a: "13.0"
  },
  {
    n: [
      "wrench"
    ],
    u: "1f527",
    a: "0.6"
  },
  {
    n: [
      "screwdriver"
    ],
    u: "1fa9b",
    a: "13.0"
  },
  {
    n: [
      "nut and bolt"
    ],
    u: "1f529",
    a: "0.6"
  },
  {
    n: [
      "gear"
    ],
    u: "2699-fe0f",
    a: "1.0"
  },
  {
    n: [
      "clamp",
      "compression"
    ],
    u: "1f5dc-fe0f",
    a: "0.7"
  },
  {
    n: [
      "scales",
      "balance scale"
    ],
    u: "2696-fe0f",
    a: "1.0"
  },
  {
    n: [
      "probing cane"
    ],
    u: "1f9af",
    a: "12.0"
  },
  {
    n: [
      "link",
      "link symbol"
    ],
    u: "1f517",
    a: "0.6"
  },
  {
    n: [
      "chains"
    ],
    u: "26d3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "hook"
    ],
    u: "1fa9d",
    a: "13.0"
  },
  {
    n: [
      "toolbox"
    ],
    u: "1f9f0",
    a: "11.0"
  },
  {
    n: [
      "magnet"
    ],
    u: "1f9f2",
    a: "11.0"
  },
  {
    n: [
      "ladder"
    ],
    u: "1fa9c",
    a: "13.0"
  },
  {
    n: [
      "alembic"
    ],
    u: "2697-fe0f",
    a: "1.0"
  },
  {
    n: [
      "test tube"
    ],
    u: "1f9ea",
    a: "11.0"
  },
  {
    n: [
      "petri dish"
    ],
    u: "1f9eb",
    a: "11.0"
  },
  {
    n: [
      "dna",
      "dna double helix"
    ],
    u: "1f9ec",
    a: "11.0"
  },
  {
    n: [
      "microscope"
    ],
    u: "1f52c",
    a: "1.0"
  },
  {
    n: [
      "telescope"
    ],
    u: "1f52d",
    a: "1.0"
  },
  {
    n: [
      "satellite antenna"
    ],
    u: "1f4e1",
    a: "0.6"
  },
  {
    n: [
      "syringe"
    ],
    u: "1f489",
    a: "0.6"
  },
  {
    n: [
      "drop of blood"
    ],
    u: "1fa78",
    a: "12.0"
  },
  {
    n: [
      "pill"
    ],
    u: "1f48a",
    a: "0.6"
  },
  {
    n: [
      "adhesive bandage"
    ],
    u: "1fa79",
    a: "12.0"
  },
  {
    n: [
      "crutch"
    ],
    u: "1fa7c",
    a: "14.0"
  },
  {
    n: [
      "stethoscope"
    ],
    u: "1fa7a",
    a: "12.0"
  },
  {
    n: [
      "x-ray"
    ],
    u: "1fa7b",
    a: "14.0"
  },
  {
    n: [
      "door"
    ],
    u: "1f6aa",
    a: "0.6"
  },
  {
    n: [
      "elevator"
    ],
    u: "1f6d7",
    a: "13.0"
  },
  {
    n: [
      "mirror"
    ],
    u: "1fa9e",
    a: "13.0"
  },
  {
    n: [
      "window"
    ],
    u: "1fa9f",
    a: "13.0"
  },
  {
    n: [
      "bed"
    ],
    u: "1f6cf-fe0f",
    a: "0.7"
  },
  {
    n: [
      "couch and lamp"
    ],
    u: "1f6cb-fe0f",
    a: "0.7"
  },
  {
    n: [
      "chair"
    ],
    u: "1fa91",
    a: "12.0"
  },
  {
    n: [
      "toilet"
    ],
    u: "1f6bd",
    a: "0.6"
  },
  {
    n: [
      "plunger"
    ],
    u: "1faa0",
    a: "13.0"
  },
  {
    n: [
      "shower"
    ],
    u: "1f6bf",
    a: "1.0"
  },
  {
    n: [
      "bathtub"
    ],
    u: "1f6c1",
    a: "1.0"
  },
  {
    n: [
      "mouse trap"
    ],
    u: "1faa4",
    a: "13.0"
  },
  {
    n: [
      "razor"
    ],
    u: "1fa92",
    a: "12.0"
  },
  {
    n: [
      "lotion bottle"
    ],
    u: "1f9f4",
    a: "11.0"
  },
  {
    n: [
      "safety pin"
    ],
    u: "1f9f7",
    a: "11.0"
  },
  {
    n: [
      "broom"
    ],
    u: "1f9f9",
    a: "11.0"
  },
  {
    n: [
      "basket"
    ],
    u: "1f9fa",
    a: "11.0"
  },
  {
    n: [
      "roll of paper"
    ],
    u: "1f9fb",
    a: "11.0"
  },
  {
    n: [
      "bucket"
    ],
    u: "1faa3",
    a: "13.0"
  },
  {
    n: [
      "soap",
      "bar of soap"
    ],
    u: "1f9fc",
    a: "11.0"
  },
  {
    n: [
      "bubbles"
    ],
    u: "1fae7",
    a: "14.0"
  },
  {
    n: [
      "toothbrush"
    ],
    u: "1faa5",
    a: "13.0"
  },
  {
    n: [
      "sponge"
    ],
    u: "1f9fd",
    a: "11.0"
  },
  {
    n: [
      "fire extinguisher"
    ],
    u: "1f9ef",
    a: "11.0"
  },
  {
    n: [
      "shopping trolley"
    ],
    u: "1f6d2",
    a: "3.0"
  },
  {
    n: [
      "smoking",
      "smoking symbol"
    ],
    u: "1f6ac",
    a: "0.6"
  },
  {
    n: [
      "coffin"
    ],
    u: "26b0-fe0f",
    a: "1.0"
  },
  {
    n: [
      "headstone"
    ],
    u: "1faa6",
    a: "13.0"
  },
  {
    n: [
      "funeral urn"
    ],
    u: "26b1-fe0f",
    a: "1.0"
  },
  {
    n: [
      "moyai"
    ],
    u: "1f5ff",
    a: "0.6"
  },
  {
    n: [
      "placard"
    ],
    u: "1faa7",
    a: "13.0"
  },
  {
    n: [
      "identification card"
    ],
    u: "1faaa",
    a: "14.0"
  }
], N2t = [
  {
    n: [
      "atm",
      "automated teller machine"
    ],
    u: "1f3e7",
    a: "0.6"
  },
  {
    n: [
      "put litter in its place",
      "put litter in its place symbol"
    ],
    u: "1f6ae",
    a: "1.0"
  },
  {
    n: [
      "potable water",
      "potable water symbol"
    ],
    u: "1f6b0",
    a: "1.0"
  },
  {
    n: [
      "wheelchair",
      "wheelchair symbol"
    ],
    u: "267f",
    a: "0.6"
  },
  {
    n: [
      "mens",
      "mens symbol"
    ],
    u: "1f6b9",
    a: "0.6"
  },
  {
    n: [
      "womens",
      "womens symbol"
    ],
    u: "1f6ba",
    a: "0.6"
  },
  {
    n: [
      "restroom"
    ],
    u: "1f6bb",
    a: "0.6"
  },
  {
    n: [
      "baby symbol"
    ],
    u: "1f6bc",
    a: "0.6"
  },
  {
    n: [
      "wc",
      "water closet"
    ],
    u: "1f6be",
    a: "0.6"
  },
  {
    n: [
      "passport control"
    ],
    u: "1f6c2",
    a: "1.0"
  },
  {
    n: [
      "customs"
    ],
    u: "1f6c3",
    a: "1.0"
  },
  {
    n: [
      "baggage claim"
    ],
    u: "1f6c4",
    a: "1.0"
  },
  {
    n: [
      "left luggage"
    ],
    u: "1f6c5",
    a: "1.0"
  },
  {
    n: [
      "warning",
      "warning sign"
    ],
    u: "26a0-fe0f",
    a: "0.6"
  },
  {
    n: [
      "children crossing"
    ],
    u: "1f6b8",
    a: "1.0"
  },
  {
    n: [
      "no entry"
    ],
    u: "26d4",
    a: "0.6"
  },
  {
    n: [
      "no entry sign"
    ],
    u: "1f6ab",
    a: "0.6"
  },
  {
    n: [
      "no bicycles"
    ],
    u: "1f6b3",
    a: "1.0"
  },
  {
    n: [
      "no smoking",
      "no smoking symbol"
    ],
    u: "1f6ad",
    a: "0.6"
  },
  {
    n: [
      "do not litter",
      "do not litter symbol"
    ],
    u: "1f6af",
    a: "1.0"
  },
  {
    n: [
      "non-potable water",
      "non-potable water symbol"
    ],
    u: "1f6b1",
    a: "1.0"
  },
  {
    n: [
      "no pedestrians"
    ],
    u: "1f6b7",
    a: "1.0"
  },
  {
    n: [
      "no mobile phones"
    ],
    u: "1f4f5",
    a: "1.0"
  },
  {
    n: [
      "underage",
      "no one under eighteen symbol"
    ],
    u: "1f51e",
    a: "0.6"
  },
  {
    n: [
      "radioactive",
      "radioactive sign"
    ],
    u: "2622-fe0f",
    a: "1.0"
  },
  {
    n: [
      "biohazard",
      "biohazard sign"
    ],
    u: "2623-fe0f",
    a: "1.0"
  },
  {
    n: [
      "arrow up",
      "upwards black arrow"
    ],
    u: "2b06-fe0f",
    a: "0.6"
  },
  {
    n: [
      "north east arrow",
      "arrow upper right"
    ],
    u: "2197-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow right",
      "black rightwards arrow"
    ],
    u: "27a1-fe0f",
    a: "0.6"
  },
  {
    n: [
      "south east arrow",
      "arrow lower right"
    ],
    u: "2198-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow down",
      "downwards black arrow"
    ],
    u: "2b07-fe0f",
    a: "0.6"
  },
  {
    n: [
      "south west arrow",
      "arrow lower left"
    ],
    u: "2199-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow left",
      "leftwards black arrow"
    ],
    u: "2b05-fe0f",
    a: "0.6"
  },
  {
    n: [
      "north west arrow",
      "arrow upper left"
    ],
    u: "2196-fe0f",
    a: "0.6"
  },
  {
    n: [
      "up down arrow",
      "arrow up down"
    ],
    u: "2195-fe0f",
    a: "0.6"
  },
  {
    n: [
      "left right arrow"
    ],
    u: "2194-fe0f",
    a: "0.6"
  },
  {
    n: [
      "leftwards arrow with hook"
    ],
    u: "21a9-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow right hook",
      "rightwards arrow with hook"
    ],
    u: "21aa-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow heading up",
      "arrow pointing rightwards then curving upwards"
    ],
    u: "2934-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow heading down",
      "arrow pointing rightwards then curving downwards"
    ],
    u: "2935-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrows clockwise",
      "clockwise downwards and upwards open circle arrows"
    ],
    u: "1f503",
    a: "0.6"
  },
  {
    n: [
      "arrows counterclockwise",
      "anticlockwise downwards and upwards open circle arrows"
    ],
    u: "1f504",
    a: "1.0"
  },
  {
    n: [
      "back",
      "back with leftwards arrow above"
    ],
    u: "1f519",
    a: "0.6"
  },
  {
    n: [
      "end",
      "end with leftwards arrow above"
    ],
    u: "1f51a",
    a: "0.6"
  },
  {
    n: [
      "on",
      "on with exclamation mark with left right arrow above"
    ],
    u: "1f51b",
    a: "0.6"
  },
  {
    n: [
      "soon",
      "soon with rightwards arrow above"
    ],
    u: "1f51c",
    a: "0.6"
  },
  {
    n: [
      "top",
      "top with upwards arrow above"
    ],
    u: "1f51d",
    a: "0.6"
  },
  {
    n: [
      "place of worship"
    ],
    u: "1f6d0",
    a: "1.0"
  },
  {
    n: [
      "atom symbol"
    ],
    u: "269b-fe0f",
    a: "1.0"
  },
  {
    n: [
      "om",
      "om symbol"
    ],
    u: "1f549-fe0f",
    a: "0.7"
  },
  {
    n: [
      "star of david"
    ],
    u: "2721-fe0f",
    a: "0.7"
  },
  {
    n: [
      "wheel of dharma"
    ],
    u: "2638-fe0f",
    a: "0.7"
  },
  {
    n: [
      "yin yang"
    ],
    u: "262f-fe0f",
    a: "0.7"
  },
  {
    n: [
      "latin cross"
    ],
    u: "271d-fe0f",
    a: "0.7"
  },
  {
    n: [
      "orthodox cross"
    ],
    u: "2626-fe0f",
    a: "1.0"
  },
  {
    n: [
      "star and crescent"
    ],
    u: "262a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "peace symbol"
    ],
    u: "262e-fe0f",
    a: "1.0"
  },
  {
    n: [
      "menorah with nine branches"
    ],
    u: "1f54e",
    a: "1.0"
  },
  {
    n: [
      "six pointed star",
      "six pointed star with middle dot"
    ],
    u: "1f52f",
    a: "0.6"
  },
  {
    n: [
      "aries"
    ],
    u: "2648",
    a: "0.6"
  },
  {
    n: [
      "taurus"
    ],
    u: "2649",
    a: "0.6"
  },
  {
    n: [
      "gemini"
    ],
    u: "264a",
    a: "0.6"
  },
  {
    n: [
      "cancer"
    ],
    u: "264b",
    a: "0.6"
  },
  {
    n: [
      "leo"
    ],
    u: "264c",
    a: "0.6"
  },
  {
    n: [
      "virgo"
    ],
    u: "264d",
    a: "0.6"
  },
  {
    n: [
      "libra"
    ],
    u: "264e",
    a: "0.6"
  },
  {
    n: [
      "scorpius"
    ],
    u: "264f",
    a: "0.6"
  },
  {
    n: [
      "sagittarius"
    ],
    u: "2650",
    a: "0.6"
  },
  {
    n: [
      "capricorn"
    ],
    u: "2651",
    a: "0.6"
  },
  {
    n: [
      "aquarius"
    ],
    u: "2652",
    a: "0.6"
  },
  {
    n: [
      "pisces"
    ],
    u: "2653",
    a: "0.6"
  },
  {
    n: [
      "ophiuchus"
    ],
    u: "26ce",
    a: "0.6"
  },
  {
    n: [
      "twisted rightwards arrows"
    ],
    u: "1f500",
    a: "1.0"
  },
  {
    n: [
      "repeat",
      "clockwise rightwards and leftwards open circle arrows"
    ],
    u: "1f501",
    a: "1.0"
  },
  {
    n: [
      "repeat one",
      "clockwise rightwards and leftwards open circle arrows with circled one overlay"
    ],
    u: "1f502",
    a: "1.0"
  },
  {
    n: [
      "arrow forward",
      "black right-pointing triangle"
    ],
    u: "25b6-fe0f",
    a: "0.6"
  },
  {
    n: [
      "fast forward",
      "black right-pointing double triangle"
    ],
    u: "23e9",
    a: "0.6"
  },
  {
    n: [
      "next track button",
      "black right pointing double triangle with vertical bar"
    ],
    u: "23ed-fe0f",
    a: "0.7"
  },
  {
    n: [
      "play or pause button",
      "black right pointing triangle with double vertical bar"
    ],
    u: "23ef-fe0f",
    a: "1.0"
  },
  {
    n: [
      "arrow backward",
      "black left-pointing triangle"
    ],
    u: "25c0-fe0f",
    a: "0.6"
  },
  {
    n: [
      "rewind",
      "black left-pointing double triangle"
    ],
    u: "23ea",
    a: "0.6"
  },
  {
    n: [
      "last track button",
      "black left pointing double triangle with vertical bar"
    ],
    u: "23ee-fe0f",
    a: "0.7"
  },
  {
    n: [
      "arrow up small",
      "up-pointing small red triangle"
    ],
    u: "1f53c",
    a: "0.6"
  },
  {
    n: [
      "arrow double up",
      "black up-pointing double triangle"
    ],
    u: "23eb",
    a: "0.6"
  },
  {
    n: [
      "arrow down small",
      "down-pointing small red triangle"
    ],
    u: "1f53d",
    a: "0.6"
  },
  {
    n: [
      "arrow double down",
      "black down-pointing double triangle"
    ],
    u: "23ec",
    a: "0.6"
  },
  {
    n: [
      "pause button",
      "double vertical bar"
    ],
    u: "23f8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "stop button",
      "black square for stop"
    ],
    u: "23f9-fe0f",
    a: "0.7"
  },
  {
    n: [
      "record button",
      "black circle for record"
    ],
    u: "23fa-fe0f",
    a: "0.7"
  },
  {
    n: [
      "eject",
      "eject button"
    ],
    u: "23cf-fe0f",
    a: "1.0"
  },
  {
    n: [
      "cinema"
    ],
    u: "1f3a6",
    a: "0.6"
  },
  {
    n: [
      "low brightness",
      "low brightness symbol"
    ],
    u: "1f505",
    a: "1.0"
  },
  {
    n: [
      "high brightness",
      "high brightness symbol"
    ],
    u: "1f506",
    a: "1.0"
  },
  {
    n: [
      "signal strength",
      "antenna with bars"
    ],
    u: "1f4f6",
    a: "0.6"
  },
  {
    n: [
      "vibration mode"
    ],
    u: "1f4f3",
    a: "0.6"
  },
  {
    n: [
      "mobile phone off"
    ],
    u: "1f4f4",
    a: "0.6"
  },
  {
    n: [
      "female sign"
    ],
    u: "2640-fe0f",
    a: "4.0"
  },
  {
    n: [
      "male sign"
    ],
    u: "2642-fe0f",
    a: "4.0"
  },
  {
    n: [
      "transgender symbol"
    ],
    u: "26a7-fe0f",
    a: "13.0"
  },
  {
    n: [
      "heavy multiplication x"
    ],
    u: "2716-fe0f",
    a: "0.6"
  },
  {
    n: [
      "heavy plus sign"
    ],
    u: "2795",
    a: "0.6"
  },
  {
    n: [
      "heavy minus sign"
    ],
    u: "2796",
    a: "0.6"
  },
  {
    n: [
      "heavy division sign"
    ],
    u: "2797",
    a: "0.6"
  },
  {
    n: [
      "heavy equals sign"
    ],
    u: "1f7f0",
    a: "14.0"
  },
  {
    n: [
      "infinity"
    ],
    u: "267e-fe0f",
    a: "11.0"
  },
  {
    n: [
      "bangbang",
      "double exclamation mark"
    ],
    u: "203c-fe0f",
    a: "0.6"
  },
  {
    n: [
      "interrobang",
      "exclamation question mark"
    ],
    u: "2049-fe0f",
    a: "0.6"
  },
  {
    n: [
      "question",
      "black question mark ornament"
    ],
    u: "2753",
    a: "0.6"
  },
  {
    n: [
      "grey question",
      "white question mark ornament"
    ],
    u: "2754",
    a: "0.6"
  },
  {
    n: [
      "grey exclamation",
      "white exclamation mark ornament"
    ],
    u: "2755",
    a: "0.6"
  },
  {
    n: [
      "exclamation",
      "heavy exclamation mark",
      "heavy exclamation mark symbol"
    ],
    u: "2757",
    a: "0.6"
  },
  {
    n: [
      "wavy dash"
    ],
    u: "3030-fe0f",
    a: "0.6"
  },
  {
    n: [
      "currency exchange"
    ],
    u: "1f4b1",
    a: "0.6"
  },
  {
    n: [
      "heavy dollar sign"
    ],
    u: "1f4b2",
    a: "0.6"
  },
  {
    n: [
      "medical symbol",
      "staff of aesculapius"
    ],
    u: "2695-fe0f",
    a: "4.0"
  },
  {
    n: [
      "recycle",
      "black universal recycling symbol"
    ],
    u: "267b-fe0f",
    a: "0.6"
  },
  {
    n: [
      "fleur-de-lis",
      "fleur de lis"
    ],
    u: "269c-fe0f",
    a: "1.0"
  },
  {
    n: [
      "trident",
      "trident emblem"
    ],
    u: "1f531",
    a: "0.6"
  },
  {
    n: [
      "name badge"
    ],
    u: "1f4db",
    a: "0.6"
  },
  {
    n: [
      "beginner",
      "japanese symbol for beginner"
    ],
    u: "1f530",
    a: "0.6"
  },
  {
    n: [
      "o",
      "heavy large circle"
    ],
    u: "2b55",
    a: "0.6"
  },
  {
    n: [
      "white check mark",
      "white heavy check mark"
    ],
    u: "2705",
    a: "0.6"
  },
  {
    n: [
      "ballot box with check"
    ],
    u: "2611-fe0f",
    a: "0.6"
  },
  {
    n: [
      "heavy check mark"
    ],
    u: "2714-fe0f",
    a: "0.6"
  },
  {
    n: [
      "x",
      "cross mark"
    ],
    u: "274c",
    a: "0.6"
  },
  {
    n: [
      "negative squared cross mark"
    ],
    u: "274e",
    a: "0.6"
  },
  {
    n: [
      "curly loop"
    ],
    u: "27b0",
    a: "0.6"
  },
  {
    n: [
      "loop",
      "double curly loop"
    ],
    u: "27bf",
    a: "1.0"
  },
  {
    n: [
      "part alternation mark"
    ],
    u: "303d-fe0f",
    a: "0.6"
  },
  {
    n: [
      "eight spoked asterisk"
    ],
    u: "2733-fe0f",
    a: "0.6"
  },
  {
    n: [
      "eight pointed black star"
    ],
    u: "2734-fe0f",
    a: "0.6"
  },
  {
    n: [
      "sparkle"
    ],
    u: "2747-fe0f",
    a: "0.6"
  },
  {
    n: [
      "copyright",
      "copyright sign"
    ],
    u: "00a9-fe0f",
    a: "0.6"
  },
  {
    n: [
      "registered",
      "registered sign"
    ],
    u: "00ae-fe0f",
    a: "0.6"
  },
  {
    n: [
      "tm",
      "trade mark sign"
    ],
    u: "2122-fe0f",
    a: "0.6"
  },
  {
    n: [
      "hash",
      "hash key"
    ],
    u: "0023-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "keycap: *",
      "keycap star"
    ],
    u: "002a-fe0f-20e3",
    a: "2.0"
  },
  {
    n: [
      "zero",
      "keycap 0"
    ],
    u: "0030-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "one",
      "keycap 1"
    ],
    u: "0031-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "two",
      "keycap 2"
    ],
    u: "0032-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "three",
      "keycap 3"
    ],
    u: "0033-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "four",
      "keycap 4"
    ],
    u: "0034-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "five",
      "keycap 5"
    ],
    u: "0035-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "six",
      "keycap 6"
    ],
    u: "0036-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "seven",
      "keycap 7"
    ],
    u: "0037-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "eight",
      "keycap 8"
    ],
    u: "0038-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "nine",
      "keycap 9"
    ],
    u: "0039-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "keycap ten"
    ],
    u: "1f51f",
    a: "0.6"
  },
  {
    n: [
      "capital abcd",
      "input symbol for latin capital letters"
    ],
    u: "1f520",
    a: "0.6"
  },
  {
    n: [
      "abcd",
      "input symbol for latin small letters"
    ],
    u: "1f521",
    a: "0.6"
  },
  {
    n: [
      "1234",
      "input symbol for numbers"
    ],
    u: "1f522",
    a: "0.6"
  },
  {
    n: [
      "symbols",
      "input symbol for symbols"
    ],
    u: "1f523",
    a: "0.6"
  },
  {
    n: [
      "abc",
      "input symbol for latin letters"
    ],
    u: "1f524",
    a: "0.6"
  },
  {
    n: [
      "a",
      "negative squared latin capital letter a"
    ],
    u: "1f170-fe0f",
    a: "0.6"
  },
  {
    n: [
      "ab",
      "negative squared ab"
    ],
    u: "1f18e",
    a: "0.6"
  },
  {
    n: [
      "b",
      "negative squared latin capital letter b"
    ],
    u: "1f171-fe0f",
    a: "0.6"
  },
  {
    n: [
      "cl",
      "squared cl"
    ],
    u: "1f191",
    a: "0.6"
  },
  {
    n: [
      "cool",
      "squared cool"
    ],
    u: "1f192",
    a: "0.6"
  },
  {
    n: [
      "free",
      "squared free"
    ],
    u: "1f193",
    a: "0.6"
  },
  {
    n: [
      "information source"
    ],
    u: "2139-fe0f",
    a: "0.6"
  },
  {
    n: [
      "id",
      "squared id"
    ],
    u: "1f194",
    a: "0.6"
  },
  {
    n: [
      "m",
      "circled latin capital letter m"
    ],
    u: "24c2-fe0f",
    a: "0.6"
  },
  {
    n: [
      "new",
      "squared new"
    ],
    u: "1f195",
    a: "0.6"
  },
  {
    n: [
      "ng",
      "squared ng"
    ],
    u: "1f196",
    a: "0.6"
  },
  {
    n: [
      "o2",
      "negative squared latin capital letter o"
    ],
    u: "1f17e-fe0f",
    a: "0.6"
  },
  {
    n: [
      "ok",
      "squared ok"
    ],
    u: "1f197",
    a: "0.6"
  },
  {
    n: [
      "parking",
      "negative squared latin capital letter p"
    ],
    u: "1f17f-fe0f",
    a: "0.6"
  },
  {
    n: [
      "sos",
      "squared sos"
    ],
    u: "1f198",
    a: "0.6"
  },
  {
    n: [
      "up",
      "squared up with exclamation mark"
    ],
    u: "1f199",
    a: "0.6"
  },
  {
    n: [
      "vs",
      "squared vs"
    ],
    u: "1f19a",
    a: "0.6"
  },
  {
    n: [
      "koko",
      "squared katakana koko"
    ],
    u: "1f201",
    a: "0.6"
  },
  {
    n: [
      "sa",
      "squared katakana sa"
    ],
    u: "1f202-fe0f",
    a: "0.6"
  },
  {
    n: [
      "u6708",
      "squared cjk unified ideograph-6708"
    ],
    u: "1f237-fe0f",
    a: "0.6"
  },
  {
    n: [
      "u6709",
      "squared cjk unified ideograph-6709"
    ],
    u: "1f236",
    a: "0.6"
  },
  {
    n: [
      "u6307",
      "squared cjk unified ideograph-6307"
    ],
    u: "1f22f",
    a: "0.6"
  },
  {
    n: [
      "ideograph advantage",
      "circled ideograph advantage"
    ],
    u: "1f250",
    a: "0.6"
  },
  {
    n: [
      "u5272",
      "squared cjk unified ideograph-5272"
    ],
    u: "1f239",
    a: "0.6"
  },
  {
    n: [
      "u7121",
      "squared cjk unified ideograph-7121"
    ],
    u: "1f21a",
    a: "0.6"
  },
  {
    n: [
      "u7981",
      "squared cjk unified ideograph-7981"
    ],
    u: "1f232",
    a: "0.6"
  },
  {
    n: [
      "accept",
      "circled ideograph accept"
    ],
    u: "1f251",
    a: "0.6"
  },
  {
    n: [
      "u7533",
      "squared cjk unified ideograph-7533"
    ],
    u: "1f238",
    a: "0.6"
  },
  {
    n: [
      "u5408",
      "squared cjk unified ideograph-5408"
    ],
    u: "1f234",
    a: "0.6"
  },
  {
    n: [
      "u7a7a",
      "squared cjk unified ideograph-7a7a"
    ],
    u: "1f233",
    a: "0.6"
  },
  {
    n: [
      "congratulations",
      "circled ideograph congratulation"
    ],
    u: "3297-fe0f",
    a: "0.6"
  },
  {
    n: [
      "secret",
      "circled ideograph secret"
    ],
    u: "3299-fe0f",
    a: "0.6"
  },
  {
    n: [
      "u55b6",
      "squared cjk unified ideograph-55b6"
    ],
    u: "1f23a",
    a: "0.6"
  },
  {
    n: [
      "u6e80",
      "squared cjk unified ideograph-6e80"
    ],
    u: "1f235",
    a: "0.6"
  },
  {
    n: [
      "red circle",
      "large red circle"
    ],
    u: "1f534",
    a: "0.6"
  },
  {
    n: [
      "large orange circle"
    ],
    u: "1f7e0",
    a: "12.0"
  },
  {
    n: [
      "large yellow circle"
    ],
    u: "1f7e1",
    a: "12.0"
  },
  {
    n: [
      "large green circle"
    ],
    u: "1f7e2",
    a: "12.0"
  },
  {
    n: [
      "large blue circle"
    ],
    u: "1f535",
    a: "0.6"
  },
  {
    n: [
      "large purple circle"
    ],
    u: "1f7e3",
    a: "12.0"
  },
  {
    n: [
      "large brown circle"
    ],
    u: "1f7e4",
    a: "12.0"
  },
  {
    n: [
      "black circle",
      "medium black circle"
    ],
    u: "26ab",
    a: "0.6"
  },
  {
    n: [
      "white circle",
      "medium white circle"
    ],
    u: "26aa",
    a: "0.6"
  },
  {
    n: [
      "large red square"
    ],
    u: "1f7e5",
    a: "12.0"
  },
  {
    n: [
      "large orange square"
    ],
    u: "1f7e7",
    a: "12.0"
  },
  {
    n: [
      "large yellow square"
    ],
    u: "1f7e8",
    a: "12.0"
  },
  {
    n: [
      "large green square"
    ],
    u: "1f7e9",
    a: "12.0"
  },
  {
    n: [
      "large blue square"
    ],
    u: "1f7e6",
    a: "12.0"
  },
  {
    n: [
      "large purple square"
    ],
    u: "1f7ea",
    a: "12.0"
  },
  {
    n: [
      "large brown square"
    ],
    u: "1f7eb",
    a: "12.0"
  },
  {
    n: [
      "black large square"
    ],
    u: "2b1b",
    a: "0.6"
  },
  {
    n: [
      "white large square"
    ],
    u: "2b1c",
    a: "0.6"
  },
  {
    n: [
      "black medium square"
    ],
    u: "25fc-fe0f",
    a: "0.6"
  },
  {
    n: [
      "white medium square"
    ],
    u: "25fb-fe0f",
    a: "0.6"
  },
  {
    n: [
      "black medium small square"
    ],
    u: "25fe",
    a: "0.6"
  },
  {
    n: [
      "white medium small square"
    ],
    u: "25fd",
    a: "0.6"
  },
  {
    n: [
      "black small square"
    ],
    u: "25aa-fe0f",
    a: "0.6"
  },
  {
    n: [
      "white small square"
    ],
    u: "25ab-fe0f",
    a: "0.6"
  },
  {
    n: [
      "large orange diamond"
    ],
    u: "1f536",
    a: "0.6"
  },
  {
    n: [
      "large blue diamond"
    ],
    u: "1f537",
    a: "0.6"
  },
  {
    n: [
      "small orange diamond"
    ],
    u: "1f538",
    a: "0.6"
  },
  {
    n: [
      "small blue diamond"
    ],
    u: "1f539",
    a: "0.6"
  },
  {
    n: [
      "small red triangle",
      "up-pointing red triangle"
    ],
    u: "1f53a",
    a: "0.6"
  },
  {
    n: [
      "small red triangle down",
      "down-pointing red triangle"
    ],
    u: "1f53b",
    a: "0.6"
  },
  {
    n: [
      "diamond shape with a dot inside"
    ],
    u: "1f4a0",
    a: "0.6"
  },
  {
    n: [
      "radio button"
    ],
    u: "1f518",
    a: "0.6"
  },
  {
    n: [
      "white square button"
    ],
    u: "1f533",
    a: "0.6"
  },
  {
    n: [
      "black square button"
    ],
    u: "1f532",
    a: "0.6"
  }
], D2t = [
  {
    n: [
      "chequered flag",
      "checkered flag"
    ],
    u: "1f3c1",
    a: "0.6"
  },
  {
    n: [
      "triangular flag on post"
    ],
    u: "1f6a9",
    a: "0.6"
  },
  {
    n: [
      "crossed flags"
    ],
    u: "1f38c",
    a: "0.6"
  },
  {
    n: [
      "waving black flag"
    ],
    u: "1f3f4",
    a: "1.0"
  },
  {
    n: [
      "white flag",
      "waving white flag"
    ],
    u: "1f3f3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "rainbow flag",
      "rainbow-flag"
    ],
    u: "1f3f3-fe0f-200d-1f308",
    a: "4.0"
  },
  {
    n: [
      "transgender flag"
    ],
    u: "1f3f3-fe0f-200d-26a7-fe0f",
    a: "13.0"
  },
  {
    n: [
      "pirate flag"
    ],
    u: "1f3f4-200d-2620-fe0f",
    a: "11.0"
  },
  {
    n: [
      "flag-ac",
      "ascension island flag"
    ],
    u: "1f1e6-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-ad",
      "andorra flag"
    ],
    u: "1f1e6-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-ae",
      "united arab emirates flag"
    ],
    u: "1f1e6-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-af",
      "afghanistan flag"
    ],
    u: "1f1e6-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-ag",
      "antigua & barbuda flag"
    ],
    u: "1f1e6-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-ai",
      "anguilla flag"
    ],
    u: "1f1e6-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-al",
      "albania flag"
    ],
    u: "1f1e6-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-am",
      "armenia flag"
    ],
    u: "1f1e6-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-ao",
      "angola flag"
    ],
    u: "1f1e6-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-aq",
      "antarctica flag"
    ],
    u: "1f1e6-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-ar",
      "argentina flag"
    ],
    u: "1f1e6-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-as",
      "american samoa flag"
    ],
    u: "1f1e6-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-at",
      "austria flag"
    ],
    u: "1f1e6-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-au",
      "australia flag"
    ],
    u: "1f1e6-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-aw",
      "aruba flag"
    ],
    u: "1f1e6-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-ax",
      "åland islands flag"
    ],
    u: "1f1e6-1f1fd",
    a: "2.0"
  },
  {
    n: [
      "flag-az",
      "azerbaijan flag"
    ],
    u: "1f1e6-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ba",
      "bosnia & herzegovina flag"
    ],
    u: "1f1e7-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-bb",
      "barbados flag"
    ],
    u: "1f1e7-1f1e7",
    a: "2.0"
  },
  {
    n: [
      "flag-bd",
      "bangladesh flag"
    ],
    u: "1f1e7-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-be",
      "belgium flag"
    ],
    u: "1f1e7-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-bf",
      "burkina faso flag"
    ],
    u: "1f1e7-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-bg",
      "bulgaria flag"
    ],
    u: "1f1e7-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-bh",
      "bahrain flag"
    ],
    u: "1f1e7-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-bi",
      "burundi flag"
    ],
    u: "1f1e7-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-bj",
      "benin flag"
    ],
    u: "1f1e7-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-bl",
      "st. barthélemy flag"
    ],
    u: "1f1e7-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-bm",
      "bermuda flag"
    ],
    u: "1f1e7-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-bn",
      "brunei flag"
    ],
    u: "1f1e7-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-bo",
      "bolivia flag"
    ],
    u: "1f1e7-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-bq",
      "caribbean netherlands flag"
    ],
    u: "1f1e7-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-br",
      "brazil flag"
    ],
    u: "1f1e7-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-bs",
      "bahamas flag"
    ],
    u: "1f1e7-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-bt",
      "bhutan flag"
    ],
    u: "1f1e7-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-bv",
      "bouvet island flag"
    ],
    u: "1f1e7-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-bw",
      "botswana flag"
    ],
    u: "1f1e7-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-by",
      "belarus flag"
    ],
    u: "1f1e7-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-bz",
      "belize flag"
    ],
    u: "1f1e7-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ca",
      "canada flag"
    ],
    u: "1f1e8-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-cc",
      "cocos (keeling) islands flag"
    ],
    u: "1f1e8-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-cd",
      "congo - kinshasa flag"
    ],
    u: "1f1e8-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-cf",
      "central african republic flag"
    ],
    u: "1f1e8-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-cg",
      "congo - brazzaville flag"
    ],
    u: "1f1e8-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-ch",
      "switzerland flag"
    ],
    u: "1f1e8-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-ci",
      "côte d’ivoire flag"
    ],
    u: "1f1e8-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-ck",
      "cook islands flag"
    ],
    u: "1f1e8-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-cl",
      "chile flag"
    ],
    u: "1f1e8-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-cm",
      "cameroon flag"
    ],
    u: "1f1e8-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "cn",
      "flag-cn",
      "china flag"
    ],
    u: "1f1e8-1f1f3",
    a: "0.6"
  },
  {
    n: [
      "flag-co",
      "colombia flag"
    ],
    u: "1f1e8-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-cp",
      "clipperton island flag"
    ],
    u: "1f1e8-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "flag-cr",
      "costa rica flag"
    ],
    u: "1f1e8-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-cu",
      "cuba flag"
    ],
    u: "1f1e8-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-cv",
      "cape verde flag"
    ],
    u: "1f1e8-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-cw",
      "curaçao flag"
    ],
    u: "1f1e8-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-cx",
      "christmas island flag"
    ],
    u: "1f1e8-1f1fd",
    a: "2.0"
  },
  {
    n: [
      "flag-cy",
      "cyprus flag"
    ],
    u: "1f1e8-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-cz",
      "czechia flag"
    ],
    u: "1f1e8-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "de",
      "flag-de",
      "germany flag"
    ],
    u: "1f1e9-1f1ea",
    a: "0.6"
  },
  {
    n: [
      "flag-dg",
      "diego garcia flag"
    ],
    u: "1f1e9-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-dj",
      "djibouti flag"
    ],
    u: "1f1e9-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-dk",
      "denmark flag"
    ],
    u: "1f1e9-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-dm",
      "dominica flag"
    ],
    u: "1f1e9-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-do",
      "dominican republic flag"
    ],
    u: "1f1e9-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-dz",
      "algeria flag"
    ],
    u: "1f1e9-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ea",
      "ceuta & melilla flag"
    ],
    u: "1f1ea-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-ec",
      "ecuador flag"
    ],
    u: "1f1ea-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-ee",
      "estonia flag"
    ],
    u: "1f1ea-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-eg",
      "egypt flag"
    ],
    u: "1f1ea-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-eh",
      "western sahara flag"
    ],
    u: "1f1ea-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-er",
      "eritrea flag"
    ],
    u: "1f1ea-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "es",
      "flag-es",
      "spain flag"
    ],
    u: "1f1ea-1f1f8",
    a: "0.6"
  },
  {
    n: [
      "flag-et",
      "ethiopia flag"
    ],
    u: "1f1ea-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-eu",
      "european union flag"
    ],
    u: "1f1ea-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-fi",
      "finland flag"
    ],
    u: "1f1eb-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-fj",
      "fiji flag"
    ],
    u: "1f1eb-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-fk",
      "falkland islands flag"
    ],
    u: "1f1eb-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-fm",
      "micronesia flag"
    ],
    u: "1f1eb-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-fo",
      "faroe islands flag"
    ],
    u: "1f1eb-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "fr",
      "flag-fr",
      "france flag"
    ],
    u: "1f1eb-1f1f7",
    a: "0.6"
  },
  {
    n: [
      "flag-ga",
      "gabon flag"
    ],
    u: "1f1ec-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "gb",
      "uk",
      "flag-gb",
      "united kingdom flag"
    ],
    u: "1f1ec-1f1e7",
    a: "0.6"
  },
  {
    n: [
      "flag-gd",
      "grenada flag"
    ],
    u: "1f1ec-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-ge",
      "georgia flag"
    ],
    u: "1f1ec-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-gf",
      "french guiana flag"
    ],
    u: "1f1ec-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-gg",
      "guernsey flag"
    ],
    u: "1f1ec-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-gh",
      "ghana flag"
    ],
    u: "1f1ec-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-gi",
      "gibraltar flag"
    ],
    u: "1f1ec-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-gl",
      "greenland flag"
    ],
    u: "1f1ec-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-gm",
      "gambia flag"
    ],
    u: "1f1ec-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-gn",
      "guinea flag"
    ],
    u: "1f1ec-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-gp",
      "guadeloupe flag"
    ],
    u: "1f1ec-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "flag-gq",
      "equatorial guinea flag"
    ],
    u: "1f1ec-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-gr",
      "greece flag"
    ],
    u: "1f1ec-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-gs",
      "south georgia & south sandwich islands flag"
    ],
    u: "1f1ec-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-gt",
      "guatemala flag"
    ],
    u: "1f1ec-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-gu",
      "guam flag"
    ],
    u: "1f1ec-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-gw",
      "guinea-bissau flag"
    ],
    u: "1f1ec-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-gy",
      "guyana flag"
    ],
    u: "1f1ec-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-hk",
      "hong kong sar china flag"
    ],
    u: "1f1ed-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-hm",
      "heard & mcdonald islands flag"
    ],
    u: "1f1ed-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-hn",
      "honduras flag"
    ],
    u: "1f1ed-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-hr",
      "croatia flag"
    ],
    u: "1f1ed-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ht",
      "haiti flag"
    ],
    u: "1f1ed-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-hu",
      "hungary flag"
    ],
    u: "1f1ed-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-ic",
      "canary islands flag"
    ],
    u: "1f1ee-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-id",
      "indonesia flag"
    ],
    u: "1f1ee-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-ie",
      "ireland flag"
    ],
    u: "1f1ee-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-il",
      "israel flag"
    ],
    u: "1f1ee-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-im",
      "isle of man flag"
    ],
    u: "1f1ee-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-in",
      "india flag"
    ],
    u: "1f1ee-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-io",
      "british indian ocean territory flag"
    ],
    u: "1f1ee-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-iq",
      "iraq flag"
    ],
    u: "1f1ee-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-ir",
      "iran flag"
    ],
    u: "1f1ee-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-is",
      "iceland flag"
    ],
    u: "1f1ee-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "it",
      "flag-it",
      "italy flag"
    ],
    u: "1f1ee-1f1f9",
    a: "0.6"
  },
  {
    n: [
      "flag-je",
      "jersey flag"
    ],
    u: "1f1ef-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-jm",
      "jamaica flag"
    ],
    u: "1f1ef-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-jo",
      "jordan flag"
    ],
    u: "1f1ef-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "jp",
      "flag-jp",
      "japan flag"
    ],
    u: "1f1ef-1f1f5",
    a: "0.6"
  },
  {
    n: [
      "flag-ke",
      "kenya flag"
    ],
    u: "1f1f0-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-kg",
      "kyrgyzstan flag"
    ],
    u: "1f1f0-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-kh",
      "cambodia flag"
    ],
    u: "1f1f0-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-ki",
      "kiribati flag"
    ],
    u: "1f1f0-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-km",
      "comoros flag"
    ],
    u: "1f1f0-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-kn",
      "st. kitts & nevis flag"
    ],
    u: "1f1f0-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-kp",
      "north korea flag"
    ],
    u: "1f1f0-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "kr",
      "flag-kr",
      "south korea flag"
    ],
    u: "1f1f0-1f1f7",
    a: "0.6"
  },
  {
    n: [
      "flag-kw",
      "kuwait flag"
    ],
    u: "1f1f0-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-ky",
      "cayman islands flag"
    ],
    u: "1f1f0-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-kz",
      "kazakhstan flag"
    ],
    u: "1f1f0-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-la",
      "laos flag"
    ],
    u: "1f1f1-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-lb",
      "lebanon flag"
    ],
    u: "1f1f1-1f1e7",
    a: "2.0"
  },
  {
    n: [
      "flag-lc",
      "st. lucia flag"
    ],
    u: "1f1f1-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-li",
      "liechtenstein flag"
    ],
    u: "1f1f1-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-lk",
      "sri lanka flag"
    ],
    u: "1f1f1-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-lr",
      "liberia flag"
    ],
    u: "1f1f1-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ls",
      "lesotho flag"
    ],
    u: "1f1f1-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-lt",
      "lithuania flag"
    ],
    u: "1f1f1-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-lu",
      "luxembourg flag"
    ],
    u: "1f1f1-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-lv",
      "latvia flag"
    ],
    u: "1f1f1-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-ly",
      "libya flag"
    ],
    u: "1f1f1-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-ma",
      "morocco flag"
    ],
    u: "1f1f2-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-mc",
      "monaco flag"
    ],
    u: "1f1f2-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-md",
      "moldova flag"
    ],
    u: "1f1f2-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-me",
      "montenegro flag"
    ],
    u: "1f1f2-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-mf",
      "st. martin flag"
    ],
    u: "1f1f2-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-mg",
      "madagascar flag"
    ],
    u: "1f1f2-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-mh",
      "marshall islands flag"
    ],
    u: "1f1f2-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-mk",
      "north macedonia flag"
    ],
    u: "1f1f2-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-ml",
      "mali flag"
    ],
    u: "1f1f2-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-mm",
      "myanmar (burma) flag"
    ],
    u: "1f1f2-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-mn",
      "mongolia flag"
    ],
    u: "1f1f2-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-mo",
      "macao sar china flag"
    ],
    u: "1f1f2-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-mp",
      "northern mariana islands flag"
    ],
    u: "1f1f2-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "flag-mq",
      "martinique flag"
    ],
    u: "1f1f2-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-mr",
      "mauritania flag"
    ],
    u: "1f1f2-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ms",
      "montserrat flag"
    ],
    u: "1f1f2-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-mt",
      "malta flag"
    ],
    u: "1f1f2-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-mu",
      "mauritius flag"
    ],
    u: "1f1f2-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-mv",
      "maldives flag"
    ],
    u: "1f1f2-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-mw",
      "malawi flag"
    ],
    u: "1f1f2-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-mx",
      "mexico flag"
    ],
    u: "1f1f2-1f1fd",
    a: "2.0"
  },
  {
    n: [
      "flag-my",
      "malaysia flag"
    ],
    u: "1f1f2-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-mz",
      "mozambique flag"
    ],
    u: "1f1f2-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-na",
      "namibia flag"
    ],
    u: "1f1f3-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-nc",
      "new caledonia flag"
    ],
    u: "1f1f3-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-ne",
      "niger flag"
    ],
    u: "1f1f3-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-nf",
      "norfolk island flag"
    ],
    u: "1f1f3-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-ng",
      "nigeria flag"
    ],
    u: "1f1f3-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-ni",
      "nicaragua flag"
    ],
    u: "1f1f3-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-nl",
      "netherlands flag"
    ],
    u: "1f1f3-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-no",
      "norway flag"
    ],
    u: "1f1f3-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-np",
      "nepal flag"
    ],
    u: "1f1f3-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "flag-nr",
      "nauru flag"
    ],
    u: "1f1f3-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-nu",
      "niue flag"
    ],
    u: "1f1f3-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-nz",
      "new zealand flag"
    ],
    u: "1f1f3-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-om",
      "oman flag"
    ],
    u: "1f1f4-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-pa",
      "panama flag"
    ],
    u: "1f1f5-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-pe",
      "peru flag"
    ],
    u: "1f1f5-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-pf",
      "french polynesia flag"
    ],
    u: "1f1f5-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-pg",
      "papua new guinea flag"
    ],
    u: "1f1f5-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-ph",
      "philippines flag"
    ],
    u: "1f1f5-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-pk",
      "pakistan flag"
    ],
    u: "1f1f5-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-pl",
      "poland flag"
    ],
    u: "1f1f5-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-pm",
      "st. pierre & miquelon flag"
    ],
    u: "1f1f5-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-pn",
      "pitcairn islands flag"
    ],
    u: "1f1f5-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-pr",
      "puerto rico flag"
    ],
    u: "1f1f5-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ps",
      "palestinian territories flag"
    ],
    u: "1f1f5-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-pt",
      "portugal flag"
    ],
    u: "1f1f5-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-pw",
      "palau flag"
    ],
    u: "1f1f5-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-py",
      "paraguay flag"
    ],
    u: "1f1f5-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-qa",
      "qatar flag"
    ],
    u: "1f1f6-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-re",
      "réunion flag"
    ],
    u: "1f1f7-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-ro",
      "romania flag"
    ],
    u: "1f1f7-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-rs",
      "serbia flag"
    ],
    u: "1f1f7-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "ru",
      "flag-ru",
      "russia flag"
    ],
    u: "1f1f7-1f1fa",
    a: "0.6"
  },
  {
    n: [
      "flag-rw",
      "rwanda flag"
    ],
    u: "1f1f7-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-sa",
      "saudi arabia flag"
    ],
    u: "1f1f8-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-sb",
      "solomon islands flag"
    ],
    u: "1f1f8-1f1e7",
    a: "2.0"
  },
  {
    n: [
      "flag-sc",
      "seychelles flag"
    ],
    u: "1f1f8-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-sd",
      "sudan flag"
    ],
    u: "1f1f8-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-se",
      "sweden flag"
    ],
    u: "1f1f8-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-sg",
      "singapore flag"
    ],
    u: "1f1f8-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-sh",
      "st. helena flag"
    ],
    u: "1f1f8-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-si",
      "slovenia flag"
    ],
    u: "1f1f8-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-sj",
      "svalbard & jan mayen flag"
    ],
    u: "1f1f8-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-sk",
      "slovakia flag"
    ],
    u: "1f1f8-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-sl",
      "sierra leone flag"
    ],
    u: "1f1f8-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-sm",
      "san marino flag"
    ],
    u: "1f1f8-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-sn",
      "senegal flag"
    ],
    u: "1f1f8-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-so",
      "somalia flag"
    ],
    u: "1f1f8-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-sr",
      "suriname flag"
    ],
    u: "1f1f8-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ss",
      "south sudan flag"
    ],
    u: "1f1f8-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-st",
      "são tomé & príncipe flag"
    ],
    u: "1f1f8-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-sv",
      "el salvador flag"
    ],
    u: "1f1f8-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-sx",
      "sint maarten flag"
    ],
    u: "1f1f8-1f1fd",
    a: "2.0"
  },
  {
    n: [
      "flag-sy",
      "syria flag"
    ],
    u: "1f1f8-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-sz",
      "eswatini flag"
    ],
    u: "1f1f8-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ta",
      "tristan da cunha flag"
    ],
    u: "1f1f9-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-tc",
      "turks & caicos islands flag"
    ],
    u: "1f1f9-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-td",
      "chad flag"
    ],
    u: "1f1f9-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-tf",
      "french southern territories flag"
    ],
    u: "1f1f9-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-tg",
      "togo flag"
    ],
    u: "1f1f9-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-th",
      "thailand flag"
    ],
    u: "1f1f9-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-tj",
      "tajikistan flag"
    ],
    u: "1f1f9-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-tk",
      "tokelau flag"
    ],
    u: "1f1f9-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-tl",
      "timor-leste flag"
    ],
    u: "1f1f9-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-tm",
      "turkmenistan flag"
    ],
    u: "1f1f9-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-tn",
      "tunisia flag"
    ],
    u: "1f1f9-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-to",
      "tonga flag"
    ],
    u: "1f1f9-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-tr",
      "turkey flag"
    ],
    u: "1f1f9-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-tt",
      "trinidad & tobago flag"
    ],
    u: "1f1f9-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-tv",
      "tuvalu flag"
    ],
    u: "1f1f9-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-tw",
      "taiwan flag"
    ],
    u: "1f1f9-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-tz",
      "tanzania flag"
    ],
    u: "1f1f9-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ua",
      "ukraine flag"
    ],
    u: "1f1fa-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-ug",
      "uganda flag"
    ],
    u: "1f1fa-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-um",
      "u.s. outlying islands flag"
    ],
    u: "1f1fa-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-un",
      "united nations flag"
    ],
    u: "1f1fa-1f1f3",
    a: "4.0"
  },
  {
    n: [
      "us",
      "flag-us",
      "united states flag"
    ],
    u: "1f1fa-1f1f8",
    a: "0.6"
  },
  {
    n: [
      "flag-uy",
      "uruguay flag"
    ],
    u: "1f1fa-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-uz",
      "uzbekistan flag"
    ],
    u: "1f1fa-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-va",
      "vatican city flag"
    ],
    u: "1f1fb-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-vc",
      "st. vincent & grenadines flag"
    ],
    u: "1f1fb-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-ve",
      "venezuela flag"
    ],
    u: "1f1fb-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-vg",
      "british virgin islands flag"
    ],
    u: "1f1fb-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-vi",
      "u.s. virgin islands flag"
    ],
    u: "1f1fb-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-vn",
      "vietnam flag"
    ],
    u: "1f1fb-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-vu",
      "vanuatu flag"
    ],
    u: "1f1fb-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-wf",
      "wallis & futuna flag"
    ],
    u: "1f1fc-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-ws",
      "samoa flag"
    ],
    u: "1f1fc-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-xk",
      "kosovo flag"
    ],
    u: "1f1fd-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-ye",
      "yemen flag"
    ],
    u: "1f1fe-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-yt",
      "mayotte flag"
    ],
    u: "1f1fe-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-za",
      "south africa flag"
    ],
    u: "1f1ff-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-zm",
      "zambia flag"
    ],
    u: "1f1ff-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-zw",
      "zimbabwe flag"
    ],
    u: "1f1ff-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "england flag",
      "flag-england"
    ],
    u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
    a: "5.0"
  },
  {
    n: [
      "scotland flag",
      "flag-scotland"
    ],
    u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
    a: "5.0"
  },
  {
    n: [
      "wales flag",
      "flag-wales"
    ],
    u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
    a: "5.0"
  }
], Gh = {
  custom: C2t,
  smileys_people: A2t,
  animals_nature: S2t,
  food_drink: L2t,
  travel_places: T2t,
  activities: E2t,
  objects: j2t,
  symbols: N2t,
  flags: D2t
}, Uy = [Ga.NEUTRAL, Ga.LIGHT, Ga.MEDIUM_LIGHT, Ga.MEDIUM, Ga.MEDIUM_DARK, Ga.DARK], I2t = /* @__PURE__ */ Object.entries(Ga).reduce(function(t, e) {
  var n = e[0], r = e[1];
  return t[r] = n, t;
}, {}), P2t = /* @__PURE__ */ Uy.reduce(function(t, e) {
  var n;
  return Object.assign(t, (n = {}, n[e] = e, n));
}, {}), Aa;
(function(t) {
  t.name = "n", t.unified = "u", t.variations = "v", t.added_in = "a", t.imgUrl = "imgUrl";
})(Aa || (Aa = {}));
var rh = {};
setTimeout(function() {
  g6.reduce(function(t, e) {
    return xZ(e), t;
  }, rh);
});
function xZ(t) {
  var e = Mp(t).flat().join("").toLowerCase().replace(/[^a-zA-Z\d]/g, "").split("");
  e.forEach(function(n) {
    var r;
    rh[n] = (r = rh[n]) != null ? r : {}, rh[n][ci(t)] = t;
  });
}
function Mp(t) {
  var e;
  return (e = t[Aa.name]) != null ? e : [];
}
function z2t(t) {
  return parseFloat(t[Aa.added_in]);
}
function w9(t) {
  return t ? Mp(t)[0] : "";
}
function dC(t) {
  var e = t.split("-"), n = e.splice(1, 1), r = n[0];
  return P2t[r] ? e.join("-") : t;
}
function ci(t, e) {
  var n, r = t[Aa.unified];
  return !e || !Dd(t) ? r : (n = O2t(t, e)) != null ? n : r;
}
function R2t(t) {
  var e;
  return (e = Gh == null ? void 0 : Gh[t]) != null ? e : [];
}
function MZ(t, e) {
  return "" + M2t(e) + t + ".png";
}
function Cp(t) {
  var e;
  return (e = t[Aa.variations]) != null ? e : [];
}
function Dd(t) {
  return Cp(t).length > 0;
}
function O2t(t, e) {
  return e ? Cp(t).find(function(n) {
    return n.includes(e);
  }) : ci(t);
}
function K1(t) {
  if (t) {
    if (v1[t])
      return v1[t];
    var e = dC(t);
    return v1[e];
  }
}
var g6 = /* @__PURE__ */ Object.values(Gh).flat();
function B2t(t) {
  Gh[Yt.CUSTOM].length = 0, t.forEach(function(e) {
    var n = H2t(e);
    Gh[Yt.CUSTOM].push(n), !v1[n[Aa.unified]] && (g6.push(n), v1[n[Aa.unified]] = n, xZ(n));
  });
}
function H2t(t) {
  var e;
  return e = {}, e[Aa.name] = t.names.map(function(n) {
    return n.toLowerCase();
  }), e[Aa.unified] = t.id.toLowerCase(), e[Aa.added_in] = "0", e[Aa.imgUrl] = t.imgUrl, e;
}
var v1 = {};
setTimeout(function() {
  g6.reduce(function(t, e) {
    return t[ci(e)] = e, Dd(e) && Cp(e).forEach(function(n) {
      t[n] = e;
    }), t;
  }, v1);
});
function F2t(t) {
  var e = t.split("-"), n = e[1];
  return Uy.includes(n) ? n : null;
}
var _2t = ["2640-fe0f", "2642-fe0f", "2695-fe0f"], Wy = "Search", V2t = "No results found", CZ = " found. Use up and down arrow keys to navigate.", q2t = "1 result" + CZ, U2t = "%n results" + CZ;
function TN(t) {
  var e, n;
  t === void 0 && (t = {});
  var r = AZ(), i = Object.assign(r.previewConfig, (e = t.previewConfig) != null ? e : {}), a = Object.assign(r, t), o = v2t(t.categories, {
    suggestionMode: a.suggestedEmojisMode
  });
  a.hiddenEmojis.forEach(function(l) {
    a.unicodeToHide.add(l);
  }), B2t((n = a.customEmojis) != null ? n : []);
  var s = a.searchDisabled ? Y1.PREVIEW : a.skinTonePickerLocation;
  return Vn({}, a, {
    categories: o,
    previewConfig: i,
    skinTonePickerLocation: s
  });
}
function AZ() {
  return {
    autoFocusSearch: !0,
    categories: wZ(),
    className: "",
    customEmojis: [],
    defaultSkinTone: Ga.NEUTRAL,
    emojiStyle: Si.APPLE,
    emojiVersion: null,
    getEmojiUrl: MZ,
    height: 450,
    lazyLoadEmojis: !1,
    previewConfig: Vn({}, W2t),
    searchDisabled: !1,
    searchPlaceHolder: Wy,
    searchPlaceholder: Wy,
    skinTonePickerLocation: Y1.SEARCH,
    skinTonesDisabled: !1,
    style: {},
    suggestedEmojisMode: Wh.FREQUENT,
    theme: Zh.LIGHT,
    unicodeToHide: new Set(_2t),
    width: 350,
    reactionsDefaultOpen: !1,
    reactions: m2t,
    open: !0,
    allowExpandReactions: !0,
    hiddenEmojis: []
  };
}
var W2t = {
  defaultEmoji: "1f60a",
  defaultCaption: "What's your mood?",
  showPreview: !0
}, Z2t = ["children"], SZ = /* @__PURE__ */ xn(/* @__PURE__ */ AZ());
function G2t(t) {
  var e = t.children, n = gZ(t, Z2t), r = Y2t(n);
  return Ee(SZ.Provider, {
    value: r
  }, e);
}
function Y2t(t) {
  var e, n = De(function() {
    return TN(t);
  }), r = n[0], i = n[1];
  return ze(function() {
    vZ(r, t) || i(TN(t));
  }, [(e = t.customEmojis) == null ? void 0 : e.length, t.open, t.emojiVersion, t.reactionsDefaultOpen, t.searchPlaceHolder, t.searchPlaceholder, t.defaultSkinTone, t.skinTonesDisabled, t.autoFocusSearch, t.emojiStyle, t.theme, t.suggestedEmojisMode, t.lazyLoadEmojis, t.className, t.height, t.width, t.searchDisabled, t.skinTonePickerLocation, t.allowExpandReactions]), r;
}
function $n() {
  return Mt(SZ);
}
var LZ = /* @__PURE__ */ Ce.createContext({});
function TZ() {
  var t = Ce.useContext(LZ);
  return t;
}
function K2t(t) {
  var e = Ce.useRef({
    onEmojiClick: t.onEmojiClick || Pm,
    onReactionClick: t.onReactionClick || t.onEmojiClick,
    onSkinToneChange: t.onSkinToneChange || Pm
  });
  return Ce.useEffect(function() {
    e.current.onEmojiClick = t.onEmojiClick || Pm, e.current.onReactionClick = t.onReactionClick || t.onEmojiClick;
  }, [t.onEmojiClick, t.onReactionClick]), Ce.useEffect(function() {
    e.current.onSkinToneChange = t.onSkinToneChange || Pm;
  }, [t.onSkinToneChange]), e;
}
function Pm() {
}
var Yh;
(function(t) {
  t.REACTIONS = "reactions", t.PICKER = "picker";
})(Yh || (Yh = {}));
function $2t() {
  var t, e = $n(), n = e.searchPlaceHolder, r = e.searchPlaceholder;
  return (t = [n, r].find(function(i) {
    return i !== Wy;
  })) != null ? t : Wy;
}
function J2t() {
  var t = $n(), e = t.defaultSkinTone;
  return e;
}
function EZ() {
  var t = $n(), e = t.allowExpandReactions;
  return e;
}
function jZ() {
  var t = $n(), e = t.skinTonesDisabled;
  return e;
}
function M0() {
  var t = $n(), e = t.emojiStyle;
  return e;
}
function Q2t() {
  var t = $n(), e = t.autoFocusSearch;
  return e;
}
function NZ() {
  var t = $n(), e = t.categories;
  return e;
}
function X2t() {
  var t = $n(), e = t.customEmojis;
  return e;
}
function ept() {
  var t = $n(), e = t.open;
  return e;
}
function tpt(t) {
  var e, n = TZ(), r = n.current, i = (e = t === Yh.REACTIONS ? r.onReactionClick : r.onEmojiClick) != null ? e : r.onEmojiClick;
  return i || function() {
  };
}
function npt() {
  var t = TZ(), e = t.current;
  return e.onSkinToneChange || function() {
  };
}
function DZ() {
  var t = $n(), e = t.previewConfig;
  return e;
}
function rpt() {
  var t = $n(), e = t.theme;
  return e;
}
function ipt() {
  var t = $n(), e = t.suggestedEmojisMode;
  return e;
}
function apt() {
  var t = $n(), e = t.lazyLoadEmojis;
  return e;
}
function opt() {
  var t = $n(), e = t.className;
  return e;
}
function spt() {
  var t = $n(), e = t.height, n = t.width, r = t.style;
  return Vn({
    height: EN(e),
    width: EN(n)
  }, r);
}
function lpt() {
  var t = $n(), e = t.reactionsDefaultOpen;
  return e;
}
function cpt() {
  var t = $n(), e = t.emojiVersion;
  return e;
}
function IZ() {
  var t = $n(), e = t.searchDisabled;
  return e;
}
function PZ() {
  var t = $n(), e = t.skinTonePickerLocation;
  return e;
}
function upt() {
  var t = $n(), e = t.unicodeToHide;
  return e;
}
function dpt() {
  var t = $n(), e = t.reactions;
  return e;
}
function Id() {
  var t = $n(), e = t.getEmojiUrl;
  return e;
}
function EN(t) {
  return typeof t == "number" ? t + "px" : t;
}
function fpt(t) {
  var e = t > 0, n = t > 1;
  return e ? n ? U2t.replace("%n", t.toString()) : q2t : V2t;
}
function jN(t, e) {
  e === void 0 && (e = 0);
  var n = De(t), r = n[0], i = n[1], a = Ue(null);
  function o(s) {
    return new Promise(function(l) {
      var c;
      a.current && clearTimeout(a.current), a.current = (c = window) == null ? void 0 : c.setTimeout(function() {
        i(s), l(s);
      }, e);
    });
  }
  return [r, o];
}
function hpt() {
  var t = upt();
  return function(e) {
    return t.has(e);
  };
}
function zZ() {
  var t = Ue({}), e = cpt();
  return Ft(function() {
    var n = parseFloat("" + e);
    return !e || Number.isNaN(n) ? t.current : g6.reduce(function(r, i) {
      return mpt(i, n) && (r[ci(i)] = !0), r;
    }, t.current);
  }, [e]);
}
function ppt() {
  var t = zZ(), e = hpt();
  return function(n) {
    var r = dC(ci(n));
    return !!(t[r] || e(r));
  };
}
function mpt(t, e) {
  return z2t(t) > e;
}
function ypt(t) {
  ze(function() {
    t(!0);
  }, [t]);
}
function gpt(t) {
  var e = t.children, n = zZ(), r = J2t(), i = lpt(), a = Ue(rh), o = Ue(!1), s = Ue(!1), l = Ue(n), c = jN(Date.now(), 200), u = jN("", 100), d = De(!1), f = De(r), h = De(null), p = De(/* @__PURE__ */ new Set()), m = De(null), g = De(i), v = De(!1), k = v[0], w = v[1];
  return ypt(w), Ee(Fa.Provider, {
    value: {
      activeCategoryState: h,
      activeSkinTone: f,
      disallowClickRef: o,
      disallowMouseRef: s,
      disallowedEmojisRef: l,
      emojiVariationPickerState: m,
      emojisThatFailedToLoadState: p,
      filterRef: a,
      isPastInitialLoad: k,
      searchTerm: u,
      skinToneFanOpenState: d,
      suggestedUpdateState: c,
      reactionsModeState: g
    }
  }, e);
}
var Fa = /* @__PURE__ */ xn({
  activeCategoryState: [null, function() {
  }],
  activeSkinTone: [Ga.NEUTRAL, function() {
  }],
  disallowClickRef: {
    current: !1
  },
  disallowMouseRef: {
    current: !1
  },
  disallowedEmojisRef: {
    current: {}
  },
  emojiVariationPickerState: [null, function() {
  }],
  emojisThatFailedToLoadState: [/* @__PURE__ */ new Set(), function() {
  }],
  filterRef: {
    current: {}
  },
  isPastInitialLoad: !0,
  searchTerm: ["", function() {
    return new Promise(function() {
    });
  }],
  skinToneFanOpenState: [!1, function() {
  }],
  suggestedUpdateState: [/* @__PURE__ */ Date.now(), function() {
  }],
  reactionsModeState: [!1, function() {
  }]
});
function fC() {
  var t = Mt(Fa), e = t.filterRef;
  return e;
}
function vpt() {
  var t = Mt(Fa), e = t.disallowClickRef;
  return e;
}
function hC() {
  var t = Mt(Fa), e = t.disallowMouseRef;
  return e;
}
function v6() {
  var t = Mt(Fa), e = t.reactionsModeState;
  return e;
}
function b6() {
  var t = Mt(Fa), e = t.searchTerm;
  return e;
}
function pC() {
  var t = Mt(Fa), e = t.activeSkinTone;
  return e;
}
function RZ() {
  var t = Mt(Fa), e = t.emojisThatFailedToLoadState;
  return e;
}
function bpt() {
  var t = Mt(Fa), e = t.isPastInitialLoad;
  return e;
}
function Pd() {
  var t = Mt(Fa), e = t.emojiVariationPickerState;
  return e;
}
function Ap() {
  var t = Mt(Fa), e = t.skinToneFanOpenState;
  return e;
}
function OZ() {
  var t = Mt(Fa), e = t.suggestedUpdateState, n = e[0], r = e[1];
  return [n, function() {
    r(Date.now());
  }];
}
function w6() {
  var t = b6(), e = t[0];
  return !!e;
}
function oa(t) {
  t && requestAnimationFrame(function() {
    t.focus();
  });
}
function BZ(t) {
  if (t) {
    var e = t.previousElementSibling;
    oa(e);
  }
}
function HZ(t) {
  if (t) {
    var e = t.nextElementSibling;
    oa(e);
  }
}
function FZ(t) {
  if (t) {
    var e = t.firstElementChild;
    oa(e);
  }
}
function Kh() {
  return document.activeElement;
}
function wpt(t) {
  var e = t.children, n = Ue(null), r = Ue(null), i = Ue(null), a = Ue(null), o = Ue(null), s = Ue(null), l = Ue(null), c = Ue(null);
  return Ee(_Z.Provider, {
    value: {
      AnchoredEmojiRef: r,
      BodyRef: i,
      CategoryNavigationRef: s,
      PickerMainRef: n,
      SearchInputRef: a,
      SkinTonePickerRef: o,
      VariationPickerRef: l,
      ReactionsRef: c
    }
  }, e);
}
var _Z = /* @__PURE__ */ xn({
  AnchoredEmojiRef: /* @__PURE__ */ Dl(),
  BodyRef: /* @__PURE__ */ Dl(),
  CategoryNavigationRef: /* @__PURE__ */ Dl(),
  PickerMainRef: /* @__PURE__ */ Dl(),
  SearchInputRef: /* @__PURE__ */ Dl(),
  SkinTonePickerRef: /* @__PURE__ */ Dl(),
  VariationPickerRef: /* @__PURE__ */ Dl(),
  ReactionsRef: /* @__PURE__ */ Dl()
});
function Zc() {
  return Mt(_Z);
}
function Sp() {
  return Zc().PickerMainRef;
}
function k6() {
  return Zc().AnchoredEmojiRef;
}
function VZ() {
  var t = k6();
  return function(e) {
    e === null && t.current !== null && oa(t.current), t.current = e;
  };
}
function _a() {
  return Zc().BodyRef;
}
function kpt() {
  return Zc().ReactionsRef;
}
function Gc() {
  return Zc().SearchInputRef;
}
function mC() {
  return Zc().SkinTonePickerRef;
}
function yC() {
  return Zc().CategoryNavigationRef;
}
function xpt() {
  return Zc().VariationPickerRef;
}
function qZ(t, e) {
  e === void 0 && (e = 0);
  var n = iG(t);
  n && requestAnimationFrame(function() {
    n.scrollTop = e;
  });
}
function Mpt(t, e) {
  var n = iG(t);
  n && requestAnimationFrame(function() {
    n.scrollTop = n.scrollTop + e;
  });
}
function Cpt() {
  var t = _a();
  return nt(function(e) {
    requestAnimationFrame(function() {
      t.current && (t.current.scrollTop = e);
    });
  }, [t]);
}
function x6(t) {
  if (!(!t || !pmt(t)) && !t.closest($r($t.variationPicker))) {
    var e = oG(t), n = aG(t);
    Mpt(e, -(xC(Yc(t)) - n));
  }
}
function M6(t) {
  var e = SC(t);
  oa(e), x6(e);
}
function Apt(t) {
  var e = SC(t);
  oa(e), e == null || e.click();
}
function Spt(t) {
  oa(uG(t));
}
function Lpt(t) {
  if (t) {
    var e = dG(t);
    if (!e)
      return M6(A6(t));
    oa(e), x6(e);
  }
}
function Tpt(t) {
  if (t) {
    var e = AC(t);
    if (!e)
      return Spt(C6(t));
    oa(e), x6(e);
  }
}
function Ept(t, e) {
  if (t) {
    var n = Npt(t);
    if (!n)
      return e();
    oa(n), x6(n);
  }
}
function jpt(t) {
  if (t) {
    var e = Dpt(t);
    return oa(e);
  }
}
function Npt(t) {
  if (!t)
    return null;
  var e = fG(t), n = Yc(e), r = eG(e, t), i = tG(e, t), a = XZ(e, t);
  if (i === 0) {
    var o = C6(n);
    return o ? nG(
      $1(o),
      -1,
      // last row
      a,
      r
    ) : null;
  }
  return lmt($1(e), i, a, r);
}
function Dpt(t) {
  if (!t)
    return null;
  var e = fG(t), n = Yc(e), r = eG(e, t), i = tG(e, t), a = XZ(e, t);
  if (!amt(e, t)) {
    var o = A6(n);
    return o ? nG($1(o), 0, a, r) : null;
  }
  var s = smt($1(e), i, a, r);
  return s;
}
function C0() {
  var t = Pd(), e = t[0], n = t[1], r = Ap(), i = r[0], a = r[1], o = nt(function() {
    e && n(null), i && a(!1);
  }, [e, i, n, a]);
  return o;
}
function UZ() {
  var t = Pd(), e = t[0], n = Ap(), r = n[0];
  return function() {
    return !!e || r;
  };
}
function Ipt() {
  var t = hC();
  return function() {
    t.current = !0;
  };
}
function WZ() {
  var t = hC();
  return function() {
    t.current = !1;
  };
}
function ZZ() {
  var t = hC();
  return function() {
    return t.current;
  };
}
function Ppt() {
  var t = _a(), e = WZ(), n = ZZ();
  ze(function() {
    var r = t.current;
    r == null || r.addEventListener("mousemove", i, {
      passive: !0
    });
    function i() {
      n() && e();
    }
    return function() {
      r == null || r.removeEventListener("mousemove", i);
    };
  }, [t, e, n]);
}
function A0() {
  var t = Gc();
  return nt(function() {
    oa(t.current);
  }, [t]);
}
function zpt() {
  var t = mC();
  return nt(function() {
    t.current && FZ(t.current);
  }, [t]);
}
function GZ() {
  var t = yC();
  return nt(function() {
    t.current && FZ(t.current);
  }, [t]);
}
function Rpt() {
  var t = fC();
  return function e(n) {
    if (typeof n == "function")
      return e(n(t.current));
    t.current = n;
  };
}
function YZ() {
  var t = gC(), e = Gc(), n = A0();
  return function() {
    e.current && (e.current.value = ""), t(""), n();
  };
}
function Opt() {
  var t = Gc(), e = gC();
  return function(n) {
    t.current ? (t.current.value = "" + t.current.value + n, e(k9(t.current.value))) : e(k9(n));
  };
}
function Bpt() {
  var t = Gc(), e = fC(), n = Rpt(), r = gC(), i = b6(), a = i[0], o = Upt(e.current, a);
  return {
    onChange: s,
    searchTerm: a,
    SearchInputRef: t,
    statusSearchResults: o
  };
  function s(l) {
    var c = e.current, u = l.toLowerCase();
    if (c != null && c[u] || u.length <= 1)
      return r(u);
    var d = qpt(u, c);
    if (!d)
      return r(u);
    n(function(f) {
      var h;
      return Object.assign(f, (h = {}, h[u] = Hpt(d, u), h));
    }), r(u);
  }
}
function gC() {
  var t = b6(), e = t[1], n = Sp();
  return function(r) {
    requestAnimationFrame(function() {
      e(r && (r == null ? void 0 : r.toLowerCase())).then(function() {
        qZ(n.current, 0);
      });
    });
  };
}
function Hpt(t, e) {
  var n = {};
  for (var r in t) {
    var i = t[r];
    Fpt(i, e) && (n[r] = i);
  }
  return n;
}
function Fpt(t, e) {
  return Mp(t).some(function(n) {
    return n.includes(e);
  });
}
function _pt() {
  var t = fC(), e = t.current, n = b6(), r = n[0];
  return function(i) {
    return Vpt(i, e, r);
  };
}
function Vpt(t, e, n) {
  var r;
  return !e || !n ? !1 : !((r = e[n]) != null && r[t]);
}
function qpt(t, e) {
  if (!e)
    return null;
  if (e[t])
    return e[t];
  var n = Object.keys(e).sort(function(r, i) {
    return i.length - r.length;
  }).find(function(r) {
    return t.includes(r);
  });
  return n ? e[n] : null;
}
function k9(t) {
  return !t || typeof t != "string" ? "" : t.trim().toLowerCase();
}
function Upt(t, e) {
  var n;
  if (!(t != null && t[e])) return "";
  var r = ((n = Object.entries(t == null ? void 0 : t[e])) == null ? void 0 : n.length) || 0;
  return fpt(r);
}
function KZ() {
  var t = VZ(), e = Pd(), n = e[1];
  return function(r) {
    var i = kC(r), a = i[0];
    a && (t(r), n(a));
  };
}
function vC() {
  var t = PZ();
  return t === Y1.SEARCH;
}
function $Z() {
  var t = PZ();
  return t === Y1.PREVIEW;
}
var or;
(function(t) {
  t.ArrowDown = "ArrowDown", t.ArrowUp = "ArrowUp", t.ArrowLeft = "ArrowLeft", t.ArrowRight = "ArrowRight", t.Escape = "Escape", t.Enter = "Enter", t.Space = " ";
})(or || (or = {}));
function Wpt() {
  Zpt(), Gpt(), Ypt(), Kpt(), $pt();
}
function Zpt() {
  var t = Sp(), e = YZ(), n = Cpt(), r = Gc(), i = A0(), a = UZ(), o = Ipt(), s = C0(), l = Ft(function() {
    return function(c) {
      var u = c.key;
      switch (o(), u) {
        case or.Escape:
          if (c.preventDefault(), a()) {
            s();
            return;
          }
          e(), n(0), i();
          break;
      }
    };
  }, [n, e, s, i, a, o]);
  ze(function() {
    var c = t.current;
    if (c)
      return c.addEventListener("keydown", l), function() {
        c.removeEventListener("keydown", l);
      };
  }, [t, r, n, l]);
}
function Gpt() {
  var t = zpt(), e = Sp(), n = _a(), r = Gc(), i = Ap(), a = i[1], o = JZ(), s = vC(), l = Ft(function() {
    return function(c) {
      var u = c.key;
      switch (u) {
        case or.ArrowRight:
          if (!s)
            return;
          c.preventDefault(), a(!0), t();
          break;
        case or.ArrowDown:
          c.preventDefault(), o();
          break;
        case or.Enter:
          c.preventDefault(), Apt(n.current);
          break;
      }
    };
  }, [t, o, a, n, s]);
  ze(function() {
    var c = r.current;
    if (c)
      return c.addEventListener("keydown", l), function() {
        c.removeEventListener("keydown", l);
      };
  }, [e, r, l]);
}
function Ypt() {
  var t = mC(), e = A0(), n = Gc(), r = JZ(), i = Ap(), a = i[0], o = i[1], s = $Z(), l = vC(), c = bC(), u = Ft(function() {
    return (
      // eslint-disable-next-line complexity
      function(d) {
        var f = d.key;
        if (l)
          switch (f) {
            case or.ArrowLeft:
              if (d.preventDefault(), !a)
                return e();
              NN(e);
              break;
            case or.ArrowRight:
              if (d.preventDefault(), !a)
                return e();
              DN();
              break;
            case or.ArrowDown:
              d.preventDefault(), a && o(!1), r();
              break;
            default:
              c(d);
              break;
          }
        if (s)
          switch (f) {
            case or.ArrowUp:
              if (d.preventDefault(), !a)
                return e();
              NN(e);
              break;
            case or.ArrowDown:
              if (d.preventDefault(), !a)
                return e();
              DN();
              break;
            default:
              c(d);
              break;
          }
      }
    );
  }, [a, e, o, r, c, s, l]);
  ze(function() {
    var d = t.current;
    if (d)
      return d.addEventListener("keydown", u), function() {
        d.removeEventListener("keydown", u);
      };
  }, [t, n, a, u]);
}
function Kpt() {
  var t = A0(), e = yC(), n = _a(), r = bC(), i = Ft(function() {
    return function(a) {
      var o = a.key;
      switch (o) {
        case or.ArrowUp:
          a.preventDefault(), t();
          break;
        case or.ArrowRight:
          a.preventDefault(), HZ(Kh());
          break;
        case or.ArrowLeft:
          a.preventDefault(), BZ(Kh());
          break;
        case or.ArrowDown:
          a.preventDefault(), M6(n.current);
          break;
        default:
          r(a);
          break;
      }
    };
  }, [n, t, r]);
  ze(function() {
    var a = e.current;
    if (a)
      return a.addEventListener("keydown", i), function() {
        a.removeEventListener("keydown", i);
      };
  }, [e, n, i]);
}
function $pt() {
  var t = _a(), e = Jpt(), n = KZ(), r = UZ(), i = C0(), a = bC(), o = Ft(function() {
    return (
      // eslint-disable-next-line complexity
      function(s) {
        var l = s.key, c = eo(Kh());
        switch (l) {
          case or.ArrowRight:
            s.preventDefault(), Lpt(c);
            break;
          case or.ArrowLeft:
            s.preventDefault(), Tpt(c);
            break;
          case or.ArrowDown:
            if (s.preventDefault(), r()) {
              i();
              break;
            }
            jpt(c);
            break;
          case or.ArrowUp:
            if (s.preventDefault(), r()) {
              i();
              break;
            }
            Ept(c, e);
            break;
          case or.Space:
            s.preventDefault(), n(s.target);
            break;
          default:
            a(s);
            break;
        }
      }
    );
  }, [e, a, n, r, i]);
  ze(function() {
    var s = t.current;
    if (s)
      return s.addEventListener("keydown", o), function() {
        s.removeEventListener("keydown", o);
      };
  }, [t, o]);
}
function JZ() {
  var t = GZ(), e = w6(), n = _a();
  return nt(function() {
    return e ? M6(n.current) : t();
  }, [n, t, e]);
}
function Jpt() {
  var t = A0(), e = GZ(), n = w6();
  return nt(function() {
    return n ? t() : e();
  }, [t, n, e]);
}
function NN(t) {
  var e = Kh();
  e && (umt(e) || t(), HZ(e));
}
function DN() {
  var t = Kh();
  t && BZ(t);
}
function bC() {
  var t = Opt(), e = A0(), n = IZ(), r = C0();
  return function(i) {
    var a = i.key;
    Qpt(i) || n || a.match(/(^[a-zA-Z0-9]$){1}/) && (i.preventDefault(), r(), e(), t(a));
  };
}
function Qpt(t) {
  var e = t.metaKey, n = t.ctrlKey, r = t.altKey;
  return e || n || r;
}
function Xpt(t, e, n) {
  if (e && n !== Si.NATIVE) {
    var r = ci(e);
    IN.has(r) || (Cp(e).forEach(function(i) {
      var a = t(i, n);
      emt(a);
    }), IN.add(r));
  }
}
var IN = /* @__PURE__ */ new Set();
function emt(t) {
  var e = new Image();
  e.src = t;
}
function tmt() {
  var t = _a(), e = M0(), n = Id();
  ze(function() {
    if (e === Si.NATIVE)
      return;
    var r = t.current;
    return r == null || r.addEventListener("focusin", i), function() {
      r == null || r.removeEventListener("focusin", i);
    };
    function i(a) {
      var o = eo(a.target);
      if (o) {
        var s = kC(o), l = s[0];
        l && Dd(l) && Xpt(n, l, e);
      }
    }
  }, [t, e, n]);
}
var nmt = ["width", "height"], QZ = 40;
function rmt(t) {
  var e = t.children;
  return Ee(gpt, null, Ee(imt, null, e));
}
function imt(t) {
  var e, n = t.children, r = v6(), i = r[0], a = rpt(), o = w6(), s = Sp(), l = opt(), c = spt();
  Wpt(), tmt();
  var u = c || {}, d = u.width, f = u.height, h = gZ(u, nmt);
  return Ee("aside", {
    className: nn(uf.main, uf.baseVariables, a === Zh.DARK && uf.darkTheme, a === Zh.AUTO && uf.autoThemeDark, (e = {}, e[$t.searchActive] = o, e), i && uf.reactionsMenu, l),
    ref: s,
    style: Vn({}, h, !i && {
      height: f,
      width: d
    })
  }, n);
}
var PN = {
  "--epr-emoji-variation-picker-bg-color": "var(--epr-dark-emoji-variation-picker-bg-color)",
  "--epr-hover-bg-color-reduced-opacity": "var(--epr-dark-hover-bg-color-reduced-opacity)",
  "--epr-highlight-color": "var(--epr-dark-highlight-color)",
  "--epr-text-color": "var(--epr-dark-text-color)",
  "--epr-hover-bg-color": "var(--epr-dark-hover-bg-color)",
  "--epr-focus-bg-color": "var(--epr-dark-focus-bg-color)",
  "--epr-search-input-bg-color": "var(--epr-dark-search-input-bg-color)",
  "--epr-category-label-bg-color": "var(--epr-dark-category-label-bg-color)",
  "--epr-picker-border-color": "var(--epr-dark-picker-border-color)",
  "--epr-bg-color": "var(--epr-dark-bg-color)",
  "--epr-reactions-bg-color": "var(--epr-dark-reactions-bg-color)",
  "--epr-search-input-bg-color-active": "var(--epr-dark-search-input-bg-color-active)",
  "--epr-emoji-variation-indicator-color": "var(--epr-dark-emoji-variation-indicator-color)",
  "--epr-category-icon-active-color": "var(--epr-dark-category-icon-active-color)",
  "--epr-skin-tone-picker-menu-color": "var(--epr-dark-skin-tone-picker-menu-color)"
}, uf = /* @__PURE__ */ Nn.create({
  main: {
    ".": ["epr-main", $t.emojiPicker],
    position: "relative",
    display: "flex",
    flexDirection: "column",
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "var(--epr-picker-border-radius)",
    borderColor: "var(--epr-picker-border-color)",
    backgroundColor: "var(--epr-bg-color)",
    overflow: "hidden",
    transition: "all 0.3s ease-in-out, background-color 0.1s ease-in-out",
    "*": {
      boxSizing: "border-box",
      fontFamily: "sans-serif"
    }
  },
  baseVariables: {
    "--": {
      "--epr-highlight-color": "#007aeb",
      "--epr-hover-bg-color": "#f1f8ff",
      "--epr-hover-bg-color-reduced-opacity": "#f1f8ff80",
      "--epr-focus-bg-color": "#e0f0ff",
      "--epr-text-color": "#858585",
      "--epr-search-input-bg-color": "#f6f6f6",
      "--epr-picker-border-color": "#e7e7e7",
      "--epr-bg-color": "#fff",
      "--epr-reactions-bg-color": "#ffffff90",
      "--epr-category-icon-active-color": "#6aa8de",
      "--epr-skin-tone-picker-menu-color": "#ffffff95",
      "--epr-horizontal-padding": "10px",
      "--epr-picker-border-radius": "8px",
      /* Header */
      "--epr-search-border-color": "var(--epr-highlight-color)",
      "--epr-header-padding": "15px var(--epr-horizontal-padding)",
      /* Skin Tone Picker */
      "--epr-active-skin-tone-indicator-border-color": "var(--epr-highlight-color)",
      "--epr-active-skin-hover-color": "var(--epr-hover-bg-color)",
      /* Search */
      "--epr-search-input-bg-color-active": "var(--epr-search-input-bg-color)",
      "--epr-search-input-padding": "0 30px",
      "--epr-search-input-border-radius": "8px",
      "--epr-search-input-height": "40px",
      "--epr-search-input-text-color": "var(--epr-text-color)",
      "--epr-search-input-placeholder-color": "var(--epr-text-color)",
      "--epr-search-bar-inner-padding": "var(--epr-horizontal-padding)",
      /*  Category Navigation */
      "--epr-category-navigation-button-size": "30px",
      /* Variation Picker */
      "--epr-emoji-variation-picker-height": "45px",
      "--epr-emoji-variation-picker-bg-color": "var(--epr-bg-color)",
      /*  Preview */
      "--epr-preview-height": "70px",
      "--epr-preview-text-size": "14px",
      "--epr-preview-text-padding": "0 var(--epr-horizontal-padding)",
      "--epr-preview-border-color": "var(--epr-picker-border-color)",
      "--epr-preview-text-color": "var(--epr-text-color)",
      /* Category */
      "--epr-category-padding": "0 var(--epr-horizontal-padding)",
      /*  Category Label */
      "--epr-category-label-bg-color": "#ffffffe6",
      "--epr-category-label-text-color": "var(--epr-text-color)",
      "--epr-category-label-padding": "0 var(--epr-horizontal-padding)",
      "--epr-category-label-height": QZ + "px",
      /*  Emoji */
      "--epr-emoji-size": "30px",
      "--epr-emoji-padding": "5px",
      "--epr-emoji-fullsize": "calc(var(--epr-emoji-size) + var(--epr-emoji-padding) * 2)",
      "--epr-emoji-hover-color": "var(--epr-hover-bg-color)",
      "--epr-emoji-variation-indicator-color": "var(--epr-picker-border-color)",
      "--epr-emoji-variation-indicator-color-hover": "var(--epr-text-color)",
      /* Z-Index */
      "--epr-header-overlay-z-index": "3",
      "--epr-emoji-variations-indictator-z-index": "1",
      "--epr-category-label-z-index": "2",
      "--epr-skin-variation-picker-z-index": "5",
      "--epr-preview-z-index": "6",
      /* Dark Theme Variables */
      "--epr-dark": "#000",
      "--epr-dark-emoji-variation-picker-bg-color": "var(--epr-dark)",
      "--epr-dark-highlight-color": "#c0c0c0",
      "--epr-dark-text-color": "var(--epr-highlight-color)",
      "--epr-dark-hover-bg-color": "#363636f6",
      "--epr-dark-hover-bg-color-reduced-opacity": "#36363680",
      "--epr-dark-focus-bg-color": "#474747",
      "--epr-dark-search-input-bg-color": "#333333",
      "--epr-dark-category-label-bg-color": "#222222e6",
      "--epr-dark-picker-border-color": "#151617",
      "--epr-dark-bg-color": "#222222",
      "--epr-dark-reactions-bg-color": "#22222290",
      "--epr-dark-search-input-bg-color-active": "var(--epr-dark)",
      "--epr-dark-emoji-variation-indicator-color": "#444",
      "--epr-dark-category-icon-active-color": "#3271b7",
      "--epr-dark-skin-tone-picker-menu-color": "#22222295"
    }
  },
  autoThemeDark: {
    ".": $t.autoTheme,
    "@media (prefers-color-scheme: dark)": {
      "--": PN
    }
  },
  darkTheme: {
    ".": $t.darkTheme,
    "--": PN
  },
  reactionsMenu: {
    ".": "epr-reactions",
    height: "50px",
    display: "inline-flex",
    backgroundColor: "var(--epr-reactions-bg-color)",
    // @ts-ignore - backdropFilter is not recognized.
    backdropFilter: "blur(8px)",
    "--": {
      "--epr-picker-border-radius": "50px"
    }
  }
});
function XZ(t, e) {
  if (!t || !e)
    return 0;
  var n = t.getBoundingClientRect().width, r = e.getBoundingClientRect().width;
  return Math.floor(n / r);
}
function eG(t, e) {
  if (!t || !e)
    return 0;
  var n = e.getBoundingClientRect().width, r = e.getBoundingClientRect().left, i = t.getBoundingClientRect().left;
  return Math.floor((r - i) / n);
}
function tG(t, e) {
  if (!t || !e)
    return 0;
  var n = e.getBoundingClientRect().height, r = e.getBoundingClientRect().top, i = t.getBoundingClientRect().top;
  return Math.round((r - i) / n);
}
function amt(t, e) {
  if (!t || !e)
    return !1;
  var n = e.getBoundingClientRect().height, r = e.getBoundingClientRect().top, i = t.getBoundingClientRect().top, a = t.getBoundingClientRect().height;
  return Math.round(r - i + n) < a;
}
function wC(t, e, n) {
  if (e === -1) {
    var r = Math.floor((t.length - 1) / n), i = r * n, a = t.length - 1;
    return t.slice(i, a + 1);
  }
  return t.slice(e * n, (e + 1) * n);
}
function omt(t, e, n) {
  var r = e + 1;
  return r * n > t.length ? [] : wC(t, r, n);
}
function nG(t, e, n, r) {
  var i = wC(t, e, n);
  return i[r] || i[i.length - 1] || null;
}
function smt(t, e, n, r) {
  var i = omt(t, e, n);
  return i[r] || i[i.length - 1] || null;
}
function lmt(t, e, n, r) {
  var i = wC(t, e - 1, n);
  return i[r] || i[i.length - 1] || null;
}
function cmt(t, e, n) {
  if (!t || !e.length)
    return null;
  var r = t.getBoundingClientRect().top, i = t.getBoundingClientRect().bottom, a = r + dmt(t), o = e.find(function(s) {
    var l = s.getBoundingClientRect().top, c = s.getBoundingClientRect().bottom, u = s.clientHeight * n, d = l + u, f = c - u;
    return d < a ? !1 : d >= r && d <= i || f >= r && f <= i;
  });
  return o || null;
}
function umt(t) {
  return !!t.nextElementSibling;
}
function dmt(t) {
  for (var e = Array.from(t.querySelectorAll($r($t.label))), n = 0, r = e; n < r.length; n++) {
    var i = r[n], a = i.getBoundingClientRect().height;
    if (a > 0)
      return a;
  }
  return QZ;
}
var Zy = "button" + /* @__PURE__ */ $r($t.emoji), fmt = /* @__PURE__ */ [Zy, $r($t.visible), ":not(" + $r($t.hidden) + ")"].join("");
function eo(t) {
  var e;
  return (e = t == null ? void 0 : t.closest(Zy)) != null ? e : null;
}
function kC(t) {
  var e = sG(t), n = MC(t);
  if (!e)
    return [];
  var r = K1(n ?? e);
  return r ? [r, n] : [];
}
function hmt(t) {
  var e;
  return !!(t != null && t.matches(Zy) || !(t == null || (e = t.parentElement) == null) && e.matches(Zy));
}
function zN(t) {
  var e;
  return (e = t == null ? void 0 : t.clientHeight) != null ? e : 0;
}
function rG(t) {
  if (!t)
    return 0;
  var e = eo(t), n = Yc(e), r = xC(n);
  return RN(e) + RN(n) + r;
}
function xC(t) {
  var e, n;
  if (!t)
    return 0;
  var r = t.querySelector($r($t.categoryContent));
  return ((e = t == null ? void 0 : t.clientHeight) != null ? e : 0) - ((n = r == null ? void 0 : r.clientHeight) != null ? n : 0);
}
function pmt(t) {
  return t ? aG(t) < xC(Yc(t)) : !1;
}
function iG(t) {
  return t ? t.matches($r($t.scrollBody)) ? t : t.querySelector($r($t.scrollBody)) : null;
}
function aG(t) {
  var e, n;
  return t ? rG(t) - ((e = (n = oG(t)) == null ? void 0 : n.scrollTop) != null ? e : 0) : 0;
}
function oG(t) {
  var e;
  return t && (e = t.closest($r($t.scrollBody))) != null ? e : null;
}
function mmt(t) {
  var e = eo(t), n = Yc(e);
  return ON(e) + ON(n);
}
function RN(t) {
  var e;
  return (e = t == null ? void 0 : t.offsetTop) != null ? e : 0;
}
function ON(t) {
  var e;
  return (e = t == null ? void 0 : t.offsetLeft) != null ? e : 0;
}
function MC(t) {
  var e;
  return (e = ymt(eo(t), "unified")) != null ? e : null;
}
function sG(t) {
  var e = MC(t);
  return e ? dC(e) : null;
}
function lG(t) {
  return t ? {
    unified: MC(t),
    originalUnified: sG(t)
  } : {
    unified: null,
    originalUnified: null
  };
}
function ymt(t, e) {
  var n;
  return (n = gmt(t)[e]) != null ? n : null;
}
function gmt(t) {
  var e;
  return (e = t == null ? void 0 : t.dataset) != null ? e : {};
}
function CC(t) {
  return t.classList.contains($t.visible);
}
function cG(t) {
  return t ? t.classList.contains($t.hidden) : !0;
}
function $1(t) {
  return t ? Array.from(t.querySelectorAll(fmt)) : [];
}
function uG(t) {
  if (!t) return null;
  var e = $1(t), n = e.slice(-1), r = n[0];
  return r ? CC(r) ? r : AC(r) : null;
}
function dG(t) {
  var e = t.nextElementSibling;
  return e ? CC(e) ? e : dG(e) : SC(A6(t));
}
function AC(t) {
  var e = t.previousElementSibling;
  return e ? CC(e) ? e : AC(e) : uG(C6(t));
}
function SC(t) {
  if (!t)
    return null;
  var e = $1(t);
  return cmt(t, e, 0.1);
}
function C6(t) {
  var e = Yc(t);
  if (!e)
    return null;
  var n = e.previousElementSibling;
  return n ? cG(n) ? C6(n) : n : null;
}
function A6(t) {
  var e = Yc(t);
  if (!e)
    return null;
  var n = e.nextElementSibling;
  return n ? cG(n) ? A6(n) : n : null;
}
function Yc(t) {
  return t ? t.closest($r($t.category)) : null;
}
function fG(t) {
  return t ? t.closest($r($t.categoryContent)) : null;
}
function hG(t) {
  return t.split("-").map(function(e) {
    return String.fromCodePoint(parseInt(e, 16));
  }).join("");
}
var pG = "epr_suggested";
function mG(t) {
  try {
    var e, n, r;
    if (!((e = window) != null && e.localStorage))
      return [];
    var i = JSON.parse((n = (r = window) == null ? void 0 : r.localStorage.getItem(pG)) != null ? n : "[]");
    return t === Wh.FREQUENT ? i.sort(function(a, o) {
      return o.count - a.count;
    }) : i;
  } catch {
    return [];
  }
}
function vmt(t, e) {
  var n = mG(), r = ci(t, e), i = ci(t), a = n.find(function(l) {
    var c = l.unified;
    return c === r;
  }), o;
  a ? o = [a].concat(n.filter(function(l) {
    return l !== a;
  })) : (a = {
    unified: r,
    original: i,
    count: 0
  }, o = [a].concat(n)), a.count++, o.length = Math.min(o.length, 14);
  try {
    var s;
    (s = window) == null || s.localStorage.setItem(pG, JSON.stringify(o));
  } catch {
  }
}
function bmt(t) {
  return t.category === Yt.CUSTOM;
}
function yG(t) {
  return t.imgUrl !== void 0;
}
function gG(t, e) {
  var n = Ue(), r = KZ(), i = vpt(), a = Pd(), o = a[1], s = C0(), l = pC(), c = l[0], u = tpt(e), d = OZ(), f = d[1], h = Id(), p = M0(), m = nt(function(k) {
    if (!i.current) {
      s();
      var w = BN(k), b = w[0], x = w[1];
      if (!(!b || !x)) {
        var A = F2t(x) || c;
        f(), vmt(b, A), u(wmt(b, A, p, h), k);
      }
    }
  }, [c, s, i, u, f, h, p]), g = nt(function(k) {
    var w;
    n.current && clearTimeout(n.current);
    var b = BN(k), x = b[0];
    !x || !Dd(x) || (n.current = (w = window) == null ? void 0 : w.setTimeout(function() {
      i.current = !0, n.current = void 0, s(), r(k.target), o(x);
    }, 500));
  }, [i, s, r, o]), v = nt(function() {
    n.current ? (clearTimeout(n.current), n.current = void 0) : i.current && requestAnimationFrame(function() {
      i.current = !1;
    });
  }, [i]);
  ze(function() {
    if (t.current) {
      var k = t.current;
      return k.addEventListener("click", m, {
        passive: !0
      }), k.addEventListener("mousedown", g, {
        passive: !0
      }), k.addEventListener("mouseup", v, {
        passive: !0
      }), function() {
        k == null || k.removeEventListener("click", m), k == null || k.removeEventListener("mousedown", g), k == null || k.removeEventListener("mouseup", v);
      };
    }
  }, [t, m, g, v]);
}
function BN(t) {
  var e = t == null ? void 0 : t.target;
  return hmt(e) ? kC(e) : [];
}
function wmt(t, e, n, r) {
  var i = Mp(t);
  if (yG(t)) {
    var a = ci(t);
    return {
      activeSkinTone: e,
      emoji: a,
      getImageUrl: function() {
        return t.imgUrl;
      },
      imageUrl: t.imgUrl,
      isCustom: !0,
      names: i,
      unified: a,
      unifiedWithoutSkinTone: a
    };
  }
  var o = ci(t, e);
  return {
    activeSkinTone: e,
    emoji: hG(o),
    getImageUrl: function(s) {
      return s === void 0 && (s = n ?? Si.APPLE), r(o, s);
    },
    imageUrl: r(o, n ?? Si.APPLE),
    isCustom: !1,
    names: i,
    unified: o,
    unifiedWithoutSkinTone: ci(t)
  };
}
function Lp(t) {
  return Ee("button", Object.assign({
    type: "button"
  }, t, {
    className: nn(kmt.button, t.className)
  }), t.children);
}
var kmt = /* @__PURE__ */ Nn.create({
  button: {
    ".": "epr-btn",
    cursor: "pointer",
    border: "0",
    background: "none",
    outline: "none"
  }
});
function xmt(t) {
  var e, n = t.emojiNames, r = t.unified, i = t.hidden, a = t.hiddenOnSearch, o = t.showVariations, s = o === void 0 ? !0 : o, l = t.hasVariations, c = t.children, u = t.className, d = t.noBackground, f = d === void 0 ? !1 : d;
  return Ee(Lp, {
    className: nn(R8.emoji, i && cC.hidden, a && x0.hiddenOnSearch, (e = {}, e[$t.visible] = !i && !a, e), !!(l && s) && R8.hasVariations, f && R8.noBackground, u),
    "data-unified": r,
    "aria-label": Mmt(n),
    "data-full-name": n
  }, c);
}
function Mmt(t) {
  var e;
  return t[0].match("flag-") && (e = t[1]) != null ? e : t[0];
}
var R8 = /* @__PURE__ */ Nn.create({
  emoji: {
    ".": $t.emoji,
    position: "relative",
    width: "var(--epr-emoji-fullsize)",
    height: "var(--epr-emoji-fullsize)",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "var(--epr-emoji-fullsize)",
    maxHeight: "var(--epr-emoji-fullsize)",
    borderRadius: "8px",
    overflow: "hidden",
    transition: "background-color 0.2s",
    ":hover": {
      backgroundColor: "var(--epr-emoji-hover-color)"
    },
    ":focus": {
      backgroundColor: "var(--epr-focus-bg-color)"
    }
  },
  noBackground: {
    background: "none",
    ":hover": {
      backgroundColor: "transparent",
      background: "none"
    },
    ":focus": {
      backgroundColor: "transparent",
      background: "none"
    }
  },
  hasVariations: {
    ".": $t.emojiHasVariations,
    ":after": {
      content: "",
      display: "block",
      width: "0",
      height: "0",
      right: "0px",
      bottom: "1px",
      position: "absolute",
      borderLeft: "4px solid transparent",
      borderRight: "4px solid transparent",
      transform: "rotate(135deg)",
      borderBottom: "4px solid var(--epr-emoji-variation-indicator-color)",
      zIndex: "var(--epr-emoji-variations-indictator-z-index)"
    },
    ":hover:after": {
      borderBottom: "4px solid var(--epr-emoji-variation-indicator-color-hover)"
    }
  }
}), Gy = /* @__PURE__ */ Nn.create({
  external: {
    ".": $t.external,
    fontSize: "0"
  },
  common: {
    alignSelf: "center",
    justifySelf: "center",
    display: "block"
  }
});
function HN(t) {
  var e = t.emojiName, n = t.style, r = t.lazyLoad, i = r === void 0 ? !1 : r, a = t.imgUrl, o = t.onError, s = t.className;
  return Ee("img", {
    src: a,
    alt: e,
    className: nn(Cmt.emojiImag, Gy.external, Gy.common, s),
    loading: i ? "lazy" : "eager",
    onError: o,
    style: n
  });
}
var Cmt = /* @__PURE__ */ Nn.create({
  emojiImag: {
    ".": "epr-emoji-img",
    maxWidth: "var(--epr-emoji-fullsize)",
    maxHeight: "var(--epr-emoji-fullsize)",
    minWidth: "var(--epr-emoji-fullsize)",
    minHeight: "var(--epr-emoji-fullsize)",
    padding: "var(--epr-emoji-padding)"
  }
});
function Amt(t) {
  var e = t.unified, n = t.style, r = t.className;
  return Ee("span", {
    className: nn(Smt.nativeEmoji, Gy.common, Gy.external, r),
    "data-unified": e,
    style: n
  }, hG(e));
}
var Smt = /* @__PURE__ */ Nn.create({
  nativeEmoji: {
    ".": "epr-emoji-native",
    fontFamily: '"Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji"!important',
    position: "relative",
    lineHeight: "100%",
    fontSize: "var(--epr-emoji-size)",
    textAlign: "center",
    alignSelf: "center",
    justifySelf: "center",
    letterSpacing: "0",
    padding: "var(--epr-emoji-padding)"
  }
});
function x9(t) {
  var e = t.emoji, n = t.unified, r = t.emojiStyle, i = t.size, a = t.lazyLoad, o = t.getEmojiUrl, s = o === void 0 ? MZ : o, l = t.className, c = RZ(), u = c[1], d = {};
  i && (d.width = d.height = d.fontSize = i + "px");
  var f = e || K1(n);
  if (!f)
    return null;
  if (yG(f))
    return Ee(HN, {
      style: d,
      emojiName: n,
      emojiStyle: Si.NATIVE,
      lazyLoad: a,
      imgUrl: f.imgUrl,
      onError: h,
      className: l
    });
  return Ee(ds, null, r === Si.NATIVE ? Ee(Amt, {
    unified: n,
    style: d,
    className: l
  }) : Ee(HN, {
    style: d,
    emojiName: w9(f),
    emojiStyle: r,
    lazyLoad: a,
    imgUrl: s(n, r),
    onError: h,
    className: l
  }));
  function h() {
    u(function(p) {
      return new Set(p).add(n);
    });
  }
}
function S6(t) {
  var e = t.emoji, n = t.unified, r = t.hidden, i = t.hiddenOnSearch, a = t.emojiStyle, o = t.showVariations, s = o === void 0 ? !0 : o, l = t.size, c = t.lazyLoad, u = t.getEmojiUrl, d = t.className, f = t.noBackground, h = f === void 0 ? !1 : f, p = Dd(e);
  return Ee(xmt, {
    hasVariations: p,
    showVariations: s,
    hidden: r,
    hiddenOnSearch: i,
    emojiNames: Mp(e),
    unified: n,
    noBackground: h
  }, Ee(x9, {
    unified: n,
    emoji: e,
    size: l,
    emojiStyle: a,
    lazyLoad: c,
    getEmojiUrl: u,
    className: d
  }));
}
var Lmt = "data:image/svg+xml;base64,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";
function Tmt() {
  var t = v6(), e = t[1];
  return Ee(Lp, {
    "aria-label": "Show all Emojis",
    title: "Show all Emojis",
    tabIndex: 0,
    className: nn(Emt.plusSign),
    onClick: function() {
      return e(!1);
    }
  });
}
var Emt = /* @__PURE__ */ Nn.create(/* @__PURE__ */ Vn({
  plusSign: {
    fontSize: "20px",
    padding: "17px",
    color: "var(--epr-text-color)",
    borderRadius: "50%",
    textAlign: "center",
    lineHeight: "100%",
    width: "20px",
    height: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "background-color 0.2s ease-in-out",
    ":after": {
      content: "",
      minWidth: "20px",
      minHeight: "20px",
      backgroundImage: "url(" + Lmt + ")",
      backgroundColor: "transparent",
      backgroundRepeat: "no-repeat",
      backgroundSize: "20px",
      backgroundPositionY: "0"
    },
    ":hover": {
      color: "var(--epr-highlight-color)",
      backgroundColor: "var(--epr-hover-bg-color-reduced-opacity)",
      ":after": {
        backgroundPositionY: "-20px"
      }
    },
    ":focus": {
      color: "var(--epr-highlight-color)",
      backgroundColor: "var(--epr-hover-bg-color-reduced-opacity)",
      ":after": {
        backgroundPositionY: "-40px"
      }
    }
  }
}, /* @__PURE__ */ Mc("plusSign", {
  ":after": {
    backgroundPositionY: "-40px"
  },
  ":hover:after": {
    backgroundPositionY: "-60px"
  }
})));
function jmt() {
  var t = v6(), e = t[0], n = kpt(), r = dpt();
  gG(n, Yh.REACTIONS);
  var i = M0(), a = EZ();
  return e ? Ee("ul", {
    className: nn(FN.list, !e && cC.hidden),
    ref: n
  }, r.map(function(o) {
    return Ee("li", {
      key: o
    }, Ee(S6, {
      emoji: K1(o),
      emojiStyle: i,
      unified: o,
      showVariations: !1,
      className: nn(FN.emojiButton),
      noBackground: !0
    }));
  }), a ? Ee("li", null, Ee(Tmt, null)) : null) : null;
}
var FN = /* @__PURE__ */ Nn.create({
  list: {
    listStyle: "none",
    margin: "0",
    padding: "0 5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%"
  },
  emojiButton: {
    ":hover": {
      transform: "scale(1.2)"
    },
    ":focus": {
      transform: "scale(1.2)"
    },
    ":active": {
      transform: "scale(1.1)"
    },
    transition: "transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.5)"
  }
});
function Nmt(t) {
  var e = C0();
  ze(function() {
    var n = t.current;
    if (!n)
      return;
    n.addEventListener("scroll", r, {
      passive: !0
    });
    function r() {
      e();
    }
    return function() {
      n == null || n.removeEventListener("scroll", r);
    };
  }, [t, e]);
}
function Dmt() {
  var t = RZ(), e = t[0], n = _pt();
  return function(r) {
    var i = ci(r), a = e.has(i), o = n(i);
    return {
      failedToLoad: a,
      filteredOut: o,
      hidden: a || o
    };
  };
}
function vG(t) {
  var e = t.categoryConfig, n = t.children, r = t.hidden, i = t.hiddenOnSearch, a = uC(e), o = kZ(e);
  return Ee("li", {
    className: nn(O8.category, r && cC.hidden, i && x0.hiddenOnSearch),
    "data-name": a,
    "aria-label": o
  }, Ee("h2", {
    className: nn(O8.label)
  }, o), Ee("div", {
    className: nn(O8.categoryContent)
  }, n));
}
var O8 = /* @__PURE__ */ Nn.create({
  category: {
    ".": $t.category,
    ":not(:has(.epr-visible))": {
      display: "none"
    }
  },
  categoryContent: {
    ".": $t.categoryContent,
    display: "grid",
    gridGap: "0",
    gridTemplateColumns: "repeat(auto-fill, var(--epr-emoji-fullsize))",
    justifyContent: "space-between",
    margin: "var(--epr-category-padding)",
    position: "relative"
  },
  label: {
    ".": $t.label,
    alignItems: "center",
    // @ts-ignore - backdropFilter is not recognized.
    backdropFilter: "blur(3px)",
    backgroundColor: "var(--epr-category-label-bg-color)",
    color: "var(--epr-category-label-text-color)",
    display: "flex",
    fontSize: "16px",
    fontWeight: "bold",
    height: "var(--epr-category-label-height)",
    margin: "0",
    padding: "var(--epr-category-label-padding)",
    position: "sticky",
    textTransform: "capitalize",
    top: "0",
    width: "100%",
    zIndex: "var(--epr-category-label-z-index)"
  }
}), B8 = !1;
function Imt() {
  var t = De(B8), e = t[0], n = t[1];
  return ze(function() {
    n(!0), B8 = !0;
  }, []), e || B8;
}
function Pmt(t) {
  var e = t.categoryConfig, n = OZ(), r = n[0], i = Imt(), a = ipt(), o = Id(), s = Ft(
    function() {
      var c;
      return (c = mG(a)) != null ? c : [];
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, a]
  ), l = M0();
  return i ? Ee(vG, {
    categoryConfig: e,
    hiddenOnSearch: !0,
    hidden: s.length === 0
  }, s.map(function(c) {
    var u = K1(c.original);
    return u ? Ee(S6, {
      showVariations: !1,
      unified: c.unified,
      emojiStyle: l,
      emoji: u,
      key: c.unified,
      getEmojiUrl: o
    }) : null;
  })) : null;
}
function zmt() {
  var t = NZ(), e = Ue(0);
  return Ee("ul", {
    className: nn(Omt.emojiList)
  }, t.map(function(n) {
    var r = uC(n);
    return r === Yt.SUGGESTED ? Ee(Pmt, {
      key: r,
      categoryConfig: n
    }) : Ee(Cre, {
      key: r
    }, Ee(Rmt, {
      category: r,
      categoryConfig: n,
      renderdCategoriesCountRef: e
    }));
  }));
}
function Rmt(t) {
  var e = t.category, n = t.categoryConfig, r = t.renderdCategoriesCountRef, i = Dmt(), a = apt(), o = M0(), s = bpt(), l = pC(), c = l[0], u = ppt(), d = Id(), f = !jZ(), h = !s && r.current > 0 ? [] : R2t(e);
  h.length > 0 && r.current++;
  var p = 0, m = h.map(function(g) {
    var v = ci(g, c), k = i(g), w = k.failedToLoad, b = k.filteredOut, x = k.hidden, A = u(g);
    return (x || A) && p++, A ? null : Ee(S6, {
      showVariations: f,
      key: v,
      emoji: g,
      unified: v,
      hidden: w,
      hiddenOnSearch: b,
      emojiStyle: o,
      lazyLoad: a,
      getEmojiUrl: d
    });
  });
  return Ee(vG, {
    categoryConfig: n,
    // Indicates that there are no visible emojis
    // Hence, the category should be hidden
    hidden: p === m.length
  }, m);
}
var Omt = /* @__PURE__ */ Nn.create({
  emojiList: {
    ".": $t.emojiList,
    listStyle: "none",
    margin: "0",
    padding: "0"
  }
}), Bmt = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI1MHB4IgoJIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDUwIDE1IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MCAxNSIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnIGlkPSJMYXllcl8xIj4KPC9nPgo8ZyBpZD0iTGF5ZXJfMiI+Cgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiNFOEU3RTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTEuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KCTxwYXRoIGZpbGw9IiMwMTAyMDIiIHN0cm9rZT0iIzE1MTYxNyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMjYuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KPC9nPgo8L3N2Zz4=", b1;
(function(t) {
  t[t.Up = 0] = "Up", t[t.Down = 1] = "Down";
})(b1 || (b1 = {}));
function Hmt() {
  var t = k6(), e = xpt(), n = Pd(), r = n[0], i = M0(), a = _mt(e), o = a.getTop, s = a.getMenuDirection, l = VZ(), c = Fmt(e), u = Id(), d = eo(t.current), f = !!(r && d && Dd(r) && d.classList.contains($t.emojiHasVariations));
  ze(function() {
    f && M6(e.current);
  }, [e, f, t]);
  var h, p;
  return !f && t.current ? l(null) : (h = o(), p = c()), Ee("div", {
    ref: e,
    className: nn(zm.variationPicker, s() === b1.Down && zm.pointingUp, f && zm.visible),
    style: {
      top: h
    }
  }, f && r ? [ci(r)].concat(Cp(r)).slice(0, 6).map(function(m) {
    return Ee(S6, {
      key: m,
      emoji: r,
      unified: m,
      emojiStyle: i,
      showVariations: !1,
      getEmojiUrl: u
    });
  }) : null, Ee("div", {
    className: nn(zm.pointer),
    style: p
  }));
}
function Fmt(t) {
  var e = k6();
  return function() {
    var n = {};
    if (!t.current)
      return n;
    if (e.current) {
      var r = eo(e.current), i = mmt(r);
      if (!r)
        return n;
      n.left = i + (r == null ? void 0 : r.clientWidth) / 2;
    }
    return n;
  };
}
function _mt(t) {
  var e = k6(), n = _a(), r = b1.Up;
  return {
    getMenuDirection: i,
    getTop: a
  };
  function i() {
    return r;
  }
  function a() {
    r = b1.Up;
    var o = 0;
    if (!t.current)
      return 0;
    var s = zN(t.current);
    if (e.current) {
      var l, c = n.current, u = eo(e.current), d = zN(u);
      o = rG(u);
      var f = (l = c == null ? void 0 : c.scrollTop) != null ? l : 0;
      f > o - s && (r = b1.Down, o += d + s);
    }
    return o - s;
  }
}
var zm = /* @__PURE__ */ Nn.create(/* @__PURE__ */ Vn({
  variationPicker: {
    ".": $t.variationPicker,
    position: "absolute",
    right: "15px",
    left: "15px",
    padding: "5px",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
    borderRadius: "3px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    opacity: "0",
    visibility: "hidden",
    pointerEvents: "none",
    top: "-100%",
    border: "1px solid var(--epr-picker-border-color)",
    height: "var(--epr-emoji-variation-picker-height)",
    zIndex: "var(--epr-skin-variation-picker-z-index)",
    background: "var(--epr-emoji-variation-picker-bg-color)",
    transform: "scale(0.9)",
    transition: "transform 0.1s ease-out, opacity 0.2s ease-out"
  },
  visible: {
    opacity: "1",
    visibility: "visible",
    pointerEvents: "all",
    transform: "scale(1)"
  },
  pointingUp: {
    ".": "pointing-up",
    transformOrigin: "center 0%",
    transform: "scale(0.9)"
  },
  ".pointing-up": {
    pointer: {
      top: "0",
      transform: "rotate(180deg) translateY(100%) translateX(18px)"
    }
  },
  pointer: {
    ".": "epr-emoji-pointer",
    content: "",
    position: "absolute",
    width: "25px",
    height: "15px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "0 0",
    backgroundSize: "50px 15px",
    top: "100%",
    transform: "translateX(-18px)",
    backgroundImage: "url(" + Bmt + ")"
  }
}, /* @__PURE__ */ Mc("pointer", {
  backgroundPosition: "-25px 0"
})));
function Vmt() {
  var t = _a();
  return Nmt(t), gG(t, Yh.PICKER), Ppt(), Ee("div", {
    className: nn(qmt.body, x0.hiddenOnReactions),
    ref: t
  }, Ee(Hmt, null), Ee(zmt, null));
}
var qmt = /* @__PURE__ */ Nn.create({
  body: {
    ".": $t.scrollBody,
    flex: "1",
    overflowY: "scroll",
    overflowX: "hidden",
    position: "relative"
  }
});
function Umt(t, e) {
  if (!t || !e)
    return 0;
  var n = t.getBoundingClientRect(), r = e.getBoundingClientRect();
  return r.height - (n.y - r.y);
}
function Wmt(t, e) {
  var n = _a(), r = ZZ(), i = WZ();
  ze(function() {
    if (!t)
      return;
    var a = n.current;
    a == null || a.addEventListener("keydown", l, {
      passive: !0
    }), a == null || a.addEventListener("mouseover", c, !0), a == null || a.addEventListener("focus", o, !0), a == null || a.addEventListener("mouseout", s, {
      passive: !0
    }), a == null || a.addEventListener("blur", s, !0);
    function o(u) {
      var d = eo(u.target);
      if (!d)
        return s();
      var f = lG(d), h = f.unified, p = f.originalUnified;
      if (!h || !p)
        return s();
      e({
        unified: h,
        originalUnified: p
      });
    }
    function s(u) {
      if (u) {
        var d = u.relatedTarget;
        if (!eo(d))
          return e(null);
      }
      e(null);
    }
    function l(u) {
      u.key === "Escape" && e(null);
    }
    function c(u) {
      if (!r()) {
        var d = eo(u.target);
        if (d) {
          var f = Umt(d, a), h = d.getBoundingClientRect().height;
          if (f < h)
            return Zmt(d, e);
          oa(d);
        }
      }
    }
    return function() {
      a == null || a.removeEventListener("mouseover", c), a == null || a.removeEventListener("mouseout", s), a == null || a.removeEventListener("focus", o, !0), a == null || a.removeEventListener("blur", s, !0), a == null || a.removeEventListener("keydown", l);
    };
  }, [n, t, e, r, i]);
}
function Zmt(t, e) {
  var n, r = lG(t), i = r.unified, a = r.originalUnified;
  !i || !a || ((n = document.activeElement) == null || n.blur == null || n.blur(), e({
    unified: i,
    originalUnified: a
  }));
}
var Rm, $h;
(function(t) {
  t.ROW = "FlexRow", t.COLUMN = "FlexColumn";
})($h || ($h = {}));
function bG(t) {
  var e = t.children, n = t.className, r = t.style, i = r === void 0 ? {} : r, a = t.direction, o = a === void 0 ? $h.ROW : a;
  return Ee("div", {
    style: Vn({}, i),
    className: nn(_N.flex, n, _N[o])
  }, e);
}
var _N = /* @__PURE__ */ Nn.create((Rm = {
  flex: {
    display: "flex"
  }
}, Rm[$h.ROW] = {
  flexDirection: "row"
}, Rm[$h.COLUMN] = {
  flexDirection: "column"
}, Rm));
function Gmt(t) {
  var e = t.className, n = t.style, r = n === void 0 ? {} : n;
  return Ee("div", {
    style: Vn({
      flex: 1
    }, r),
    className: nn(e)
  });
}
function Ymt(t) {
  var e = t.children, n = t.className, r = t.style;
  return Ee("div", {
    style: Vn({}, r, {
      position: "absolute"
    }),
    className: n
  }, e);
}
function L6(t) {
  var e = t.children, n = t.className, r = t.style;
  return Ee("div", {
    style: Vn({}, r, {
      position: "relative"
    }),
    className: n
  }, e);
}
function Kmt(t) {
  var e = t.isOpen, n = t.onClick, r = t.isActive, i = t.skinToneVariation, a = t.style;
  return Ee(Lp, {
    style: a,
    onClick: n,
    className: nn("epr-tone-" + i, H8.tone, !e && H8.closedTone, r && H8.active),
    tabIndex: e ? 0 : -1,
    "aria-pressed": r,
    "aria-label": "Skin tone " + I2t[i]
  });
}
var H8 = /* @__PURE__ */ Nn.create({
  closedTone: {
    opacity: "0",
    zIndex: "0"
  },
  active: {
    ".": "epr-active",
    zIndex: "1",
    opacity: "1"
  },
  tone: {
    ".": "epr-tone",
    ":hover": {
      boxShadow: "0 0 0 3px var(--epr-active-skin-hover-color)"
    },
    ":focus": {
      boxShadow: "0 0 0 3px var(--epr-focus-bg-color)"
    },
    "&.epr-tone-neutral": {
      backgroundColor: "#ffd225"
    },
    "&.epr-tone-1f3fb": {
      backgroundColor: "#ffdfbd"
    },
    "&.epr-tone-1f3fc": {
      backgroundColor: "#e9c197"
    },
    "&.epr-tone-1f3fd": {
      backgroundColor: "#c88e62"
    },
    "&.epr-tone-1f3fe": {
      backgroundColor: "#a86637"
    },
    "&.epr-tone-1f3ff": {
      backgroundColor: "#60463a"
    }
  }
}), zf = 28;
function $mt() {
  return Ee(L6, {
    style: {
      height: zf
    }
  }, Ee(Ymt, {
    style: {
      bottom: 0,
      right: 0
    }
  }, Ee(wG, {
    direction: Jh.VERTICAL
  })));
}
function wG(t) {
  var e = t.direction, n = e === void 0 ? Jh.HORIZONTAL : e, r = mC(), i = jZ(), a = Ap(), o = a[0], s = a[1], l = pC(), c = l[0], u = l[1], d = npt(), f = C0(), h = A0();
  if (i)
    return null;
  var p = zf * Uy.length + "px", m = o ? p : zf + "px", g = n === Jh.VERTICAL;
  return Ee(L6, {
    className: nn(df.skinTones, g && df.vertical, o && df.open, g && o && df.verticalShadow),
    style: g ? {
      flexBasis: m,
      height: m
    } : {
      flexBasis: m
    }
  }, Ee("div", {
    className: nn(df.select),
    ref: r
  }, Uy.map(function(v, k) {
    var w = v === c;
    return Ee(Kmt, {
      key: v,
      skinToneVariation: v,
      isOpen: o,
      style: {
        transform: nn(g ? "translateY(-" + k * (o ? zf : 0) + "px)" : "translateX(-" + k * (o ? zf : 0) + "px)", o && w && "scale(1.3)")
      },
      isActive: w,
      onClick: function() {
        o ? (u(v), d(v), h()) : s(!0), f();
      }
    });
  })));
}
var Jh;
(function(t) {
  t.VERTICAL = "epr-vertical", t.HORIZONTAL = "epr-horizontal";
})(Jh || (Jh = {}));
var df = /* @__PURE__ */ Nn.create({
  skinTones: {
    ".": "epr-skin-tones",
    "--": {
      "--epr-skin-tone-size": "15px"
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    transition: "all 0.3s ease-in-out",
    padding: "10px 0"
  },
  vertical: {
    padding: "9px",
    alignItems: "flex-end",
    flexDirection: "column",
    borderRadius: "6px",
    border: "1px solid var(--epr-bg-color)"
  },
  verticalShadow: {
    boxShadow: "0px 0 7px var(--epr-picker-border-color)"
  },
  open: {
    // @ts-ignore - backdropFilter is not recognized.
    backdropFilter: "blur(5px)",
    background: "var(--epr-skin-tone-picker-menu-color)",
    ".epr-active:after": {
      content: "",
      position: "absolute",
      top: "-2px",
      left: "-2px",
      right: "-2px",
      bottom: "-2px",
      borderRadius: "5px",
      border: "1px solid var(--epr-active-skin-tone-indicator-border-color)"
    }
  },
  select: {
    ".": "epr-skin-tone-select",
    position: "relative",
    width: "var(--epr-skin-tone-size)",
    height: "var(--epr-skin-tone-size)",
    "> button": {
      width: "var(--epr-skin-tone-size)",
      display: "block",
      cursor: "pointer",
      borderRadius: "4px",
      height: "var(--epr-skin-tone-size)",
      position: "absolute",
      right: "0",
      transition: "transform 0.3s ease-in-out, opacity 0.35s ease-in-out",
      zIndex: "0",
      boxShadow: "0 0 0 0px var(--epr-active-skin-hover-color)"
    }
  }
});
function Jmt() {
  var t = DZ(), e = $Z();
  return t.showPreview ? Ee(bG, {
    className: nn(W4.preview, x0.hiddenOnReactions)
  }, Ee(Qmt, null), Ee(Gmt, null), e ? Ee($mt, null) : null) : null;
}
function Qmt() {
  var t, e = DZ(), n = De(null), r = n[0], i = n[1], a = M0(), o = Pd(), s = o[0], l = Id();
  Wmt(e.showPreview, i);
  var c = K1((t = r == null ? void 0 : r.unified) != null ? t : r == null ? void 0 : r.originalUnified), u = c != null && r != null;
  return Ee(d, null);
  function d() {
    var f = s ?? K1(e.defaultEmoji);
    if (!f)
      return null;
    var h = s ? w9(s) : e.defaultCaption;
    return Ee(ds, null, Ee("div", null, u ? Ee(x9, {
      unified: r == null ? void 0 : r.unified,
      emoji: c,
      emojiStyle: a,
      size: 45,
      getEmojiUrl: l,
      className: nn(W4.emoji)
    }) : f ? Ee(x9, {
      unified: ci(f),
      emoji: f,
      emojiStyle: a,
      size: 45,
      getEmojiUrl: l,
      className: nn(W4.emoji)
    }) : null), Ee("div", {
      className: nn(W4.label)
    }, u ? w9(c) : h));
  }
}
var W4 = /* @__PURE__ */ Nn.create({
  preview: {
    alignItems: "center",
    borderTop: "1px solid var(--epr-preview-border-color)",
    height: "var(--epr-preview-height)",
    padding: "0 var(--epr-horizontal-padding)",
    position: "relative",
    zIndex: "var(--epr-preview-z-index)"
  },
  label: {
    color: "var(--epr-preview-text-color)",
    fontSize: "var(--epr-preview-text-size)",
    padding: "var(--epr-preview-text-padding)",
    textTransform: "capitalize"
  },
  emoji: {
    padding: "0"
  }
});
function Xmt(t) {
  var e;
  return (e = t == null ? void 0 : t.getAttribute("data-name")) != null ? e : null;
}
function e4t(t) {
  var e = _a();
  ze(function() {
    var n = /* @__PURE__ */ new Map(), r = e.current, i = new IntersectionObserver(function(a) {
      if (r) {
        for (var o = h2t(a), s; !(s = o()).done; ) {
          var l = s.value, c = Xmt(l.target);
          n.set(c, l.intersectionRatio);
        }
        var u = Array.from(n), d = u[u.length - 1];
        if (d[1] == 1)
          return t(d[0]);
        for (var f = 0, h = u; f < h.length; f++) {
          var p = h[f], m = p[0], g = p[1];
          if (g) {
            t(m);
            break;
          }
        }
      }
    }, {
      threshold: [0, 1]
    });
    r == null || r.querySelectorAll($r($t.category)).forEach(function(a) {
      i.observe(a);
    });
  }, [e, t]);
}
function t4t() {
  var t = _a(), e = Sp();
  return function(n) {
    var r;
    if (t.current) {
      var i = (r = t.current) == null ? void 0 : r.querySelector('[data-name="' + n + '"]');
      if (i) {
        var a = i.offsetTop || 0;
        qZ(e.current, a);
      }
    }
  };
}
function n4t() {
  var t = X2t();
  return t ? t.length === 0 : !1;
}
var r4t = "data:image/svg+xml;base64,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";
function i4t(t) {
  var e, n = t.isActiveCategory, r = t.category, i = t.allowNavigation, a = t.categoryConfig, o = t.onClick;
  return Ee(Lp, {
    tabIndex: i ? 0 : -1,
    className: nn(o4t.catBtn, x0.categoryBtn, "epr-icn-" + r, (e = {}, e[$t.active] = n, e)),
    onClick: o,
    "aria-label": kZ(a),
    "aria-selected": n,
    role: "tab",
    "aria-controls": "epr-category-nav-id"
  });
}
var VN = {
  backgroundPositionY: "calc(var(--epr-category-navigation-button-size) * 3)"
}, a4t = {
  backgroundPositionY: "calc(var(--epr-category-navigation-button-size) * 2)"
}, qN = {
  ":not(.epr-search-active)": {
    catBtn: {
      ":hover": VN,
      "&.epr-active": VN
    }
  }
}, o4t = /* @__PURE__ */ Nn.create(/* @__PURE__ */ Vn({
  catBtn: {
    ".": "epr-cat-btn",
    display: "inline-block",
    transition: "opacity 0.2s ease-in-out",
    position: "relative",
    height: "var(--epr-category-navigation-button-size)",
    width: "var(--epr-category-navigation-button-size)",
    backgroundSize: "calc(var(--epr-category-navigation-button-size) * 10)",
    outline: "none",
    backgroundPosition: "0 0",
    backgroundImage: "url(" + r4t + ")",
    ":focus:before": {
      content: "",
      position: "absolute",
      top: "-2px",
      left: "-2px",
      right: "-2px",
      bottom: "-2px",
      border: "2px solid var(--epr-category-icon-active-color)",
      borderRadius: "50%"
    },
    "&.epr-icn-suggested": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -8)"
    },
    "&.epr-icn-custom": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -9)"
    },
    "&.epr-icn-activities": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -4)"
    },
    "&.epr-icn-animals_nature": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -1)"
    },
    "&.epr-icn-flags": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -7)"
    },
    "&.epr-icn-food_drink": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -2)"
    },
    "&.epr-icn-objects": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -5)"
    },
    "&.epr-icn-smileys_people": {
      backgroundPositionX: "0px"
    },
    "&.epr-icn-symbols": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -6)"
    },
    "&.epr-icn-travel_places": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -3)"
    }
  }
}, /* @__PURE__ */ Mc("catBtn", a4t), {
  ".epr-dark-theme": /* @__PURE__ */ Vn({}, qN),
  ".epr-auto-theme": /* @__PURE__ */ Vn({}, qN)
}));
function s4t() {
  var t = De(null), e = t[0], n = t[1], r = t4t();
  e4t(n);
  var i = w6(), a = NZ(), o = yC(), s = n4t();
  return Ee("div", {
    className: nn(l4t.nav),
    role: "tablist",
    "aria-label": "Category navigation",
    id: "epr-category-nav-id",
    ref: o
  }, a.map(function(l) {
    var c = uC(l), u = c === e;
    if (bmt(l) && s)
      return null;
    var d = !i && !u;
    return Ee(i4t, {
      key: c,
      category: c,
      isActiveCategory: u,
      allowNavigation: d,
      categoryConfig: l,
      onClick: function() {
        n(c), r(c);
      }
    });
  }));
}
var l4t = /* @__PURE__ */ Nn.create({
  nav: {
    ".": "epr-category-nav",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    padding: "var(--epr-header-padding)"
  },
  ".epr-search-active": {
    nav: {
      opacity: "0.3",
      cursor: "default",
      pointerEvents: "none"
    }
  },
  ".epr-main:has(input:not(:placeholder-shown))": {
    nav: {
      opacity: "0.3",
      cursor: "default",
      pointerEvents: "none"
    }
  }
}), kG = "data:image/svg+xml;base64,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";
function c4t() {
  var t = YZ();
  return Ee(Lp, {
    className: nn(UN.btnClearSearch, x0.visibleOnSearchOnly),
    onClick: t,
    "aria-label": "Clear",
    title: "Clear"
  }, Ee("div", {
    className: nn(UN.icnClearnSearch)
  }));
}
var u4t = {
  ":hover": {
    "> .epr-icn-clear-search": {
      backgroundPositionY: "-60px"
    }
  }
}, UN = /* @__PURE__ */ Nn.create(/* @__PURE__ */ Vn({
  btnClearSearch: {
    ".": "epr-btn-clear-search",
    position: "absolute",
    right: "var(--epr-search-bar-inner-padding)",
    height: "30px",
    width: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: "50%",
    transform: "translateY(-50%)",
    padding: "0",
    borderRadius: "50%",
    ":hover": {
      background: "var(--epr-hover-bg-color)"
    },
    ":focus": {
      background: "var(--epr-hover-bg-color)"
    }
  },
  icnClearnSearch: {
    ".": "epr-icn-clear-search",
    backgroundColor: "transparent",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px",
    height: "20px",
    width: "20px",
    backgroundImage: "url(" + kG + ")",
    ":hover": {
      backgroundPositionY: "-20px"
    },
    ":focus": {
      backgroundPositionY: "-20px"
    }
  }
}, /* @__PURE__ */ Mc("icnClearnSearch", {
  backgroundPositionY: "-40px"
}), /* @__PURE__ */ Mc("btnClearSearch", u4t))), F8 = /* @__PURE__ */ $r($t.emojiPicker) + " " + /* @__PURE__ */ $r($t.emojiList), xG = /* @__PURE__ */ ["button", $r($t.emoji)].join(""), d4t = /* @__PURE__ */ $r($t.category);
function f4t(t) {
  var e = t.value;
  if (!e)
    return null;
  var n = h4t(e);
  return Ee("style", null, `
    ` + F8 + " " + xG + ` {
      display: none;
    }


    ` + F8 + " " + n + ` {
      display: flex;
    }

    ` + F8 + " " + d4t + ":not(:has(" + n + `)) {
      display: none;
    }
  `);
}
function h4t(t) {
  return [xG, '[data-full-name*="', k9(t), '"]'].join("");
}
var p4t = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyMHB4IiBoZWlnaHQ9IjQwcHgiIHZpZXdCb3g9IjAgMCAyMCA0MCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjAgNDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzg2ODY4NiIgZD0iTTEyLDguODFjMCwyLjA4LTEuNjgsMy43Ni0zLjc2LDMuNzZjLTIuMDgsMC0zLjc2LTEuNjgtMy43Ni0zLjc2CgljMC0yLjA4LDEuNjgtMy43NiwzLjc2LTMuNzZDMTAuMzIsNS4wNSwxMiw2LjczLDEyLDguODF6IE0xMS4yMywxMi43MmMtMC44MywwLjY0LTEuODcsMS4wMS0yLjk5LDEuMDFjLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTIKCWMwLTIuNzIsMi4yLTQuOTIsNC45Mi00LjkyYzIuNzIsMCw0LjkyLDIuMiw0LjkyLDQuOTJjMCwxLjEzLTAuMzgsMi4xNi0xLjAxLDIuOTlsMy45NCwzLjkzYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyCgljLTAuMjUsMC4yNS0wLjY2LDAuMjUtMC45MiwwTDExLjIzLDEyLjcyeiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0MwQzBCRiIgZD0iTTEyLDI4LjgxYzAsMi4wOC0xLjY4LDMuNzYtMy43NiwzLjc2Yy0yLjA4LDAtMy43Ni0xLjY4LTMuNzYtMy43NgoJYzAtMi4wOCwxLjY4LTMuNzYsMy43Ni0zLjc2QzEwLjMyLDI1LjA1LDEyLDI2LjczLDEyLDI4LjgxeiBNMTEuMjMsMzIuNzJjLTAuODMsMC42NC0xLjg3LDEuMDEtMi45OSwxLjAxCgljLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTJjMC0yLjcyLDIuMi00LjkyLDQuOTItNC45MmMyLjcyLDAsNC45MiwyLjIsNC45Miw0LjkyYzAsMS4xMy0wLjM4LDIuMTYtMS4wMSwyLjk5bDMuOTQsMy45MwoJYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyYy0wLjI1LDAuMjUtMC42NiwwLjI1LTAuOTIsMEwxMS4yMywzMi43MnoiLz4KPC9zdmc+";
function m4t() {
  return Ee("div", {
    className: nn(y4t.icnSearch)
  });
}
var y4t = /* @__PURE__ */ Nn.create(/* @__PURE__ */ Vn({
  icnSearch: {
    ".": "epr-icn-search",
    content: "",
    position: "absolute",
    top: "50%",
    left: "var(--epr-search-bar-inner-padding)",
    transform: "translateY(-50%)",
    width: "20px",
    height: "20px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "0 0",
    backgroundSize: "20px",
    backgroundImage: "url(" + p4t + ")"
  }
}, /* @__PURE__ */ Mc("icnSearch", {
  backgroundPositionY: "-20px"
})));
function g4t() {
  var t = IZ(), e = vC();
  return t ? null : Ee(bG, {
    className: nn(Z4.overlay)
  }, Ee(v4t, null), e ? Ee(wG, null) : null);
}
function v4t() {
  var t = De(0), e = t[0], n = t[1], r = C0(), i = Gc(), a = $2t(), o = Q2t(), s = Bpt(), l = s.statusSearchResults, c = s.searchTerm, u = s.onChange, d = i == null ? void 0 : i.current, f = d == null ? void 0 : d.value;
  return Ee(L6, {
    className: nn(Z4.searchContainer)
  }, Ee(f4t, {
    value: f
  }), Ee("input", {
    // eslint-disable-next-line jsx-a11y/no-autofocus
    autoFocus: o,
    "aria-label": "Type to search for an emoji",
    onFocus: r,
    className: nn(Z4.search),
    type: "text",
    "aria-controls": "epr-search-id",
    placeholder: a,
    onChange: function(h) {
      n(e + 1), setTimeout(function() {
        var p, m;
        u((p = h == null || (m = h.target) == null ? void 0 : m.value) != null ? p : f);
      });
    },
    ref: i
  }), c ? Ee("div", {
    role: "status",
    className: nn("epr-status-search-results", Z4.visuallyHidden),
    "aria-live": "polite",
    id: "epr-search-id",
    "aria-atomic": "true"
  }, l) : null, Ee(m4t, null), Ee(c4t, null));
}
var Z4 = /* @__PURE__ */ Nn.create(/* @__PURE__ */ Vn({
  overlay: {
    padding: "var(--epr-header-padding)",
    zIndex: "var(--epr-header-overlay-z-index)"
  },
  searchContainer: {
    ".": "epr-search-container",
    flex: "1",
    display: "block",
    minWidth: "0"
  },
  visuallyHidden: {
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    overflow: "hidden",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  },
  search: {
    outline: "none",
    transition: "all 0.2s ease-in-out",
    color: "var(--epr-search-input-text-color)",
    borderRadius: "var(--epr-search-input-border-radius)",
    padding: "var(--epr-search-input-padding)",
    height: "var(--epr-search-input-height)",
    backgroundColor: "var(--epr-search-input-bg-color)",
    border: "1px solid var(--epr-search-input-bg-color)",
    width: "100%",
    ":focus": {
      backgroundColor: "var(--epr-search-input-bg-color-active)",
      border: "1px solid var(--epr-search-border-color)"
    },
    "::placeholder": {
      color: "var(--epr-search-input-placeholder-color)"
    }
  },
  btnClearSearch: {
    ".": "epr-btn-clear-search",
    position: "absolute",
    right: "var(--epr-search-bar-inner-padding)",
    height: "30px",
    width: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: "50%",
    transform: "translateY(-50%)",
    padding: "0",
    borderRadius: "50%",
    ":hover": {
      background: "var(--epr-hover-bg-color)"
    },
    ":focus": {
      background: "var(--epr-hover-bg-color)"
    }
  },
  icnClearnSearch: {
    ".": "epr-icn-clear-search",
    backgroundColor: "transparent",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px",
    height: "20px",
    width: "20px",
    backgroundImage: "url(" + kG + ")",
    ":hover": {
      backgroundPositionY: "-20px"
    },
    ":focus": {
      backgroundPositionY: "-20px"
    }
  }
}, /* @__PURE__ */ Mc("icnClearnSearch", {
  backgroundPositionY: "-40px"
}), /* @__PURE__ */ Mc("btnClearSearch", {
  ":hover > .epr-icn-clear-search": {
    backgroundPositionY: "-60px"
  }
})));
function b4t() {
  return Ee(L6, {
    className: nn("epr-header", x0.hiddenOnReactions)
  }, Ee(g4t, null), Ee(s4t, null));
}
function w4t(t) {
  return Ee(wpt, null, Ee(p2t, null), Ee(G2t, Object.assign({}, t), Ee(k4t, null)));
}
function k4t() {
  var t = v6(), e = t[0], n = EZ(), r = De(!e), i = r[0], a = r[1], o = ept();
  return ze(function() {
    e && !n || i || a(!0);
  }, [i, n, e]), o ? Ee(rmt, null, Ee(jmt, null), Ee(x4t, {
    renderAll: i
  })) : null;
}
function x4t(t) {
  var e = t.renderAll;
  return e ? Ee(ds, null, Ee(b4t, null), Ee(Vmt, null), Ee(Jmt, null)) : null;
}
var M4t = /* @__PURE__ */ QO(w4t, vZ), C4t = /* @__PURE__ */ function(t) {
  d2t(e, t);
  function e(r) {
    var i;
    return i = t.call(this, r) || this, i.state = {
      hasError: !1
    }, i;
  }
  e.getDerivedStateFromError = function() {
    return {
      hasError: !0
    };
  };
  var n = e.prototype;
  return n.componentDidCatch = function(r, i) {
    console.error("Emoji Picker React failed to render:", r, i);
  }, n.render = function() {
    return this.state.hasError ? null : this.props.children;
  }, e;
}(Wk);
function A4t(t) {
  var e = K2t({
    onEmojiClick: t.onEmojiClick,
    onReactionClick: t.onReactionClick,
    onSkinToneChange: t.onSkinToneChange
  });
  return Ee(C4t, null, Ee(LZ.Provider, {
    value: e
  }, Ee(M4t, Object.assign({}, t))));
}
en(
  ({ handleEmojiClick: t, handleAvatarInput: e, onRemove: n, className: r, ...i }, a) => {
    const [o, s] = De("emojiPicker"), l = Ue(null), c = () => {
      l.current && l.current.click();
    };
    return /* @__PURE__ */ T.jsx("div", { ref: a, className: r, ...i, children: /* @__PURE__ */ T.jsxs(
      E0t,
      {
        defaultValue: o,
        className: un(
          "px-4 pt-2 gap-4 rounded-lg shadow-elevation-4 w-[350px] bg-white pb-4",
          o === "emojiPicker" && "h-[400px]"
        ),
        children: [
          /* @__PURE__ */ T.jsxs(yq, { className: "w-full justify-between items-center border-b color-border-default rounded-none px-0", children: [
            /* @__PURE__ */ T.jsxs("div", { className: "w-full flex justify-start", children: [
              /* @__PURE__ */ T.jsx(
                i9,
                {
                  value: "emojiPicker",
                  onClick: () => s("emojiPicker"),
                  className: "w-full lg:w-auto gap-1 text-body-sm-bold data-[state=active]:color-text-default data-[state=active]:border-b-2 data-[state=active]:color-border-active color-text-default h-[38px] data-[state=inactive]:border-transparent",
                  children: "Emojis"
                }
              ),
              /* @__PURE__ */ T.jsx(
                i9,
                {
                  value: "customUpload",
                  onClick: () => s("customUpload"),
                  className: "w-full lg:w-auto gap-1 text-body-sm-bold data-[state=active]:color-text-default data-[state=active]:border-b-2 data-[state=active]:color-border-active color-text-default h-[38px] data-[state=inactive]:border-transparent",
                  children: "Custom"
                }
              )
            ] }),
            /* @__PURE__ */ T.jsx(
              Kt,
              {
                variant: "ghost",
                className: "min-w-fit bg-transparent hidden lg:block color-text-default",
                onClick: n,
                children: "Remove"
              }
            )
          ] }),
          /* @__PURE__ */ T.jsx(gq, { value: o, className: "w-full h-full", children: o === "emojiPicker" ? /* @__PURE__ */ T.jsx("div", { className: "w-full h-auto overflow-hidden absolute top-0 translate-y-12 left-0", children: /* @__PURE__ */ T.jsx(
            A4t,
            {
              previewConfig: {
                showPreview: !1
              },
              height: 340,
              className: "!border-none !rounded-none overflow-auto h-full",
              emojiStyle: Si.NATIVE,
              onEmojiClick: t
            }
          ) }) : /* @__PURE__ */ T.jsxs("div", { className: "w-full h-full mt-4 space-y-3", children: [
            /* @__PURE__ */ T.jsx(
              Kt,
              {
                size: "lg",
                variant: "secondary",
                className: "w-full",
                onClick: c,
                children: "Upload file"
              }
            ),
            /* @__PURE__ */ T.jsx(
              "input",
              {
                type: "file",
                accept: "image/*",
                ref: l,
                onChange: e,
                className: "hidden"
              }
            ),
            /* @__PURE__ */ T.jsx("p", { className: "text-helper-text-sm color-text-secondary text-center", children: "Recommended size is 256 x 256 pixels" })
          ] }) })
        ]
      }
    ) });
  }
);
const S4t = ({
  open: t,
  onOpenChange: e,
  title: n,
  description: r,
  content: i,
  primaryAction: a,
  secondaryAction: o,
  className: s,
  contentClassName: l,
  hasCloseIcon: c,
  headerClassName: u,
  footerClassName: d,
  overlayClasses: f,
  noOverlay: h
}) => /* @__PURE__ */ T.jsx(kp, { open: t, onOpenChange: (p) => e(p), children: /* @__PURE__ */ T.jsxs(
  l6,
  {
    className: be("w-full", s),
    hasCloseIcon: c,
    overlayClasses: be(f, { "bg-transparent": h }),
    children: [
      n && /* @__PURE__ */ T.jsx(c6, { className: be("px-4 pt-4", u), children: /* @__PURE__ */ T.jsx(u6, { className: "text-left text-heading-md", children: n }) }),
      /* @__PURE__ */ T.jsxs(
        "div",
        {
          className: be(
            "flex flex-col gap-4 w-full h-full border-t-[1px] text-body-sm color-text-default",
            {
              "px-4 pt-4 pb-2": !l
            },
            l
          ),
          children: [
            /* @__PURE__ */ T.jsx(XM, { className: "hidden" }),
            r && /* @__PURE__ */ T.jsx("p", { children: r }),
            i && i
          ]
        }
      ),
      /* @__PURE__ */ T.jsxs(QM, { className: be("px-5 pb-5 gap-2 w-full", d), children: [
        o && /* @__PURE__ */ T.jsx(s6, { asChild: !0, children: /* @__PURE__ */ T.jsx(
          Kt,
          {
            disabled: o == null ? void 0 : o.isLoading,
            isLoading: o == null ? void 0 : o.isLoading,
            className: o == null ? void 0 : o.className,
            variant: (o == null ? void 0 : o.variant) || "ghost",
            onClick: o == null ? void 0 : o.onClick,
            children: o == null ? void 0 : o.label
          }
        ) }),
        a && /* @__PURE__ */ T.jsx(
          Kt,
          {
            disabled: a == null ? void 0 : a.isLoading,
            isLoading: a == null ? void 0 : a.isLoading,
            className: a == null ? void 0 : a.className,
            variant: (a == null ? void 0 : a.variant) || "default",
            onClick: a == null ? void 0 : a.onClick,
            children: a == null ? void 0 : a.label
          }
        )
      ] })
    ]
  }
) });
var WN = 1, L4t = 0.9, T4t = 0.8, E4t = 0.17, _8 = 0.1, V8 = 0.999, j4t = 0.9999, N4t = 0.99, D4t = /[\\\/_+.#"@\[\(\{&]/, I4t = /[\\\/_+.#"@\[\(\{&]/g, P4t = /[\s-]/, MG = /[\s-]/g;
function M9(t, e, n, r, i, a, o) {
  if (a === e.length) return i === t.length ? WN : N4t;
  var s = `${i},${a}`;
  if (o[s] !== void 0) return o[s];
  for (var l = r.charAt(a), c = n.indexOf(l, i), u = 0, d, f, h, p; c >= 0; ) d = M9(t, e, n, r, c + 1, a + 1, o), d > u && (c === i ? d *= WN : D4t.test(t.charAt(c - 1)) ? (d *= T4t, h = t.slice(i, c - 1).match(I4t), h && i > 0 && (d *= Math.pow(V8, h.length))) : P4t.test(t.charAt(c - 1)) ? (d *= L4t, p = t.slice(i, c - 1).match(MG), p && i > 0 && (d *= Math.pow(V8, p.length))) : (d *= E4t, i > 0 && (d *= Math.pow(V8, c - i))), t.charAt(c) !== e.charAt(a) && (d *= j4t)), (d < _8 && n.charAt(c - 1) === r.charAt(a + 1) || r.charAt(a + 1) === r.charAt(a) && n.charAt(c - 1) !== r.charAt(a)) && (f = M9(t, e, n, r, c + 1, a + 2, o), f * _8 > d && (d = f * _8)), d > u && (u = d), c = n.indexOf(l, c + 1);
  return o[s] = u, u;
}
function ZN(t) {
  return t.toLowerCase().replace(MG, " ");
}
function z4t(t, e, n) {
  return t = n && n.length > 0 ? `${t + " " + n.join(" ")}` : t, M9(t, e, ZN(t), ZN(e), 0, 0, {});
}
function pi() {
  return pi = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, pi.apply(null, arguments);
}
function w1(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (t == null || t(r), n === !1 || !r.defaultPrevented) return e == null ? void 0 : e(r);
  };
}
function R4t(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function CG(...t) {
  return (e) => t.forEach(
    (n) => R4t(n, e)
  );
}
function Tp(...t) {
  return nt(CG(...t), t);
}
function O4t(t, e = []) {
  let n = [];
  function r(a, o) {
    const s = /* @__PURE__ */ xn(o), l = n.length;
    n = [
      ...n,
      o
    ];
    function c(d) {
      const { scope: f, children: h, ...p } = d, m = (f == null ? void 0 : f[t][l]) || s, g = Ft(
        () => p,
        Object.values(p)
      );
      return /* @__PURE__ */ Ee(m.Provider, {
        value: g
      }, h);
    }
    function u(d, f) {
      const h = (f == null ? void 0 : f[t][l]) || s, p = Mt(h);
      if (p) return p;
      if (o !== void 0) return o;
      throw new Error(`\`${d}\` must be used within \`${a}\``);
    }
    return c.displayName = a + "Provider", [
      c,
      u
    ];
  }
  const i = () => {
    const a = n.map((o) => /* @__PURE__ */ xn(o));
    return function(o) {
      const s = (o == null ? void 0 : o[t]) || a;
      return Ft(
        () => ({
          [`__scope${t}`]: {
            ...o,
            [t]: s
          }
        }),
        [
          o,
          s
        ]
      );
    };
  };
  return i.scopeName = t, [
    r,
    B4t(i, ...e)
  ];
}
function B4t(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const r = t.map(
      (i) => ({
        useScope: i(),
        scopeName: i.scopeName
      })
    );
    return function(i) {
      const a = r.reduce((o, { useScope: s, scopeName: l }) => {
        const c = s(i)[`__scope${l}`];
        return {
          ...o,
          ...c
        };
      }, {});
      return Ft(
        () => ({
          [`__scope${e.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = e.scopeName, n;
}
const C9 = globalThis != null && globalThis.document ? us : () => {
}, H4t = N.useId || (() => {
});
let F4t = 0;
function q8(t) {
  const [e, n] = N.useState(H4t());
  return C9(() => {
    n(
      (r) => r ?? String(F4t++)
    );
  }, [
    t
  ]), t || (e ? `radix-${e}` : "");
}
function e0(t) {
  const e = Ue(t);
  return ze(() => {
    e.current = t;
  }), Ft(
    () => (...n) => {
      var r;
      return (r = e.current) === null || r === void 0 ? void 0 : r.call(e, ...n);
    },
    []
  );
}
function _4t({ prop: t, defaultProp: e, onChange: n = () => {
} }) {
  const [r, i] = V4t({
    defaultProp: e,
    onChange: n
  }), a = t !== void 0, o = a ? t : r, s = e0(n), l = nt((c) => {
    if (a) {
      const u = typeof c == "function" ? c(t) : c;
      u !== t && s(u);
    } else i(c);
  }, [
    a,
    t,
    i,
    s
  ]);
  return [
    o,
    l
  ];
}
function V4t({ defaultProp: t, onChange: e }) {
  const n = De(t), [r] = n, i = Ue(r), a = e0(e);
  return ze(() => {
    i.current !== r && (a(r), i.current = r);
  }, [
    r,
    i,
    a
  ]), n;
}
const LC = /* @__PURE__ */ en((t, e) => {
  const { children: n, ...r } = t, i = Ws.toArray(n), a = i.find(U4t);
  if (a) {
    const o = a.props.children, s = i.map((l) => l === a ? Ws.count(o) > 1 ? Ws.only(null) : /* @__PURE__ */ N1(o) ? o.props.children : null : l);
    return /* @__PURE__ */ Ee(A9, pi({}, r, {
      ref: e
    }), /* @__PURE__ */ N1(o) ? /* @__PURE__ */ vd(o, void 0, s) : null);
  }
  return /* @__PURE__ */ Ee(A9, pi({}, r, {
    ref: e
  }), n);
});
LC.displayName = "Slot";
const A9 = /* @__PURE__ */ en((t, e) => {
  const { children: n, ...r } = t;
  return /* @__PURE__ */ N1(n) ? /* @__PURE__ */ vd(n, {
    ...W4t(r, n.props),
    ref: e ? CG(e, n.ref) : n.ref
  }) : Ws.count(n) > 1 ? Ws.only(null) : null;
});
A9.displayName = "SlotClone";
const q4t = ({ children: t }) => /* @__PURE__ */ Ee(ds, null, t);
function U4t(t) {
  return /* @__PURE__ */ N1(t) && t.type === q4t;
}
function W4t(t, e) {
  const n = {
    ...e
  };
  for (const r in e) {
    const i = t[r], a = e[r];
    /^on[A-Z]/.test(r) ? i && a ? n[r] = (...o) => {
      a(...o), i(...o);
    } : i && (n[r] = i) : r === "style" ? n[r] = {
      ...i,
      ...a
    } : r === "className" && (n[r] = [
      i,
      a
    ].filter(Boolean).join(" "));
  }
  return {
    ...t,
    ...n
  };
}
const Z4t = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Va = Z4t.reduce((t, e) => {
  const n = /* @__PURE__ */ en((r, i) => {
    const { asChild: a, ...o } = r, s = a ? LC : e;
    return ze(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ Ee(s, pi({}, o, {
      ref: i
    }));
  });
  return n.displayName = `Primitive.${e}`, {
    ...t,
    [e]: n
  };
}, {});
function G4t(t, e) {
  t && Zk(
    () => t.dispatchEvent(e)
  );
}
function Y4t(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = e0(t);
  ze(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return e.addEventListener("keydown", r), () => e.removeEventListener("keydown", r);
  }, [
    n,
    e
  ]);
}
const S9 = "dismissableLayer.update", K4t = "dismissableLayer.pointerDownOutside", $4t = "dismissableLayer.focusOutside";
let GN;
const J4t = /* @__PURE__ */ xn({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Q4t = /* @__PURE__ */ en((t, e) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: i, onPointerDownOutside: a, onFocusOutside: o, onInteractOutside: s, onDismiss: l, ...c } = t, u = Mt(J4t), [d, f] = De(null), h = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = De({}), m = Tp(
    e,
    (M) => f(M)
  ), g = Array.from(u.layers), [v] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), k = g.indexOf(v), w = d ? g.indexOf(d) : -1, b = u.layersWithOutsidePointerEventsDisabled.size > 0, x = w >= k, A = X4t((M) => {
    const j = M.target, D = [
      ...u.branches
    ].some(
      (z) => z.contains(j)
    );
    !x || D || (a == null || a(M), s == null || s(M), M.defaultPrevented || l == null || l());
  }, h), L = eyt((M) => {
    const j = M.target;
    [
      ...u.branches
    ].some(
      (D) => D.contains(j)
    ) || (o == null || o(M), s == null || s(M), M.defaultPrevented || l == null || l());
  }, h);
  return Y4t((M) => {
    w === u.layers.size - 1 && (i == null || i(M), !M.defaultPrevented && l && (M.preventDefault(), l()));
  }, h), ze(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (GN = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), YN(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = GN);
      };
  }, [
    d,
    h,
    r,
    u
  ]), ze(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), YN());
  }, [
    d,
    u
  ]), ze(() => {
    const M = () => p({});
    return document.addEventListener(S9, M), () => document.removeEventListener(S9, M);
  }, []), /* @__PURE__ */ Ee(Va.div, pi({}, c, {
    ref: m,
    style: {
      pointerEvents: b ? x ? "auto" : "none" : void 0,
      ...t.style
    },
    onFocusCapture: w1(t.onFocusCapture, L.onFocusCapture),
    onBlurCapture: w1(t.onBlurCapture, L.onBlurCapture),
    onPointerDownCapture: w1(t.onPointerDownCapture, A.onPointerDownCapture)
  }));
});
function X4t(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = e0(t), r = Ue(!1), i = Ue(() => {
  });
  return ze(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          AG(K4t, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = l, e.addEventListener("click", i.current, {
          once: !0
        })) : l();
      } else
        e.removeEventListener("click", i.current);
      r.current = !1;
    }, o = window.setTimeout(() => {
      e.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(o), e.removeEventListener("pointerdown", a), e.removeEventListener("click", i.current);
    };
  }, [
    e,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function eyt(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = e0(t), r = Ue(!1);
  return ze(() => {
    const i = (a) => {
      a.target && !r.current && AG($4t, n, {
        originalEvent: a
      }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [
    e,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function YN() {
  const t = new CustomEvent(S9);
  document.dispatchEvent(t);
}
function AG(t, e, n, { discrete: r }) {
  const i = n.originalEvent.target, a = new CustomEvent(t, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  e && i.addEventListener(t, e, {
    once: !0
  }), r ? G4t(i, a) : i.dispatchEvent(a);
}
const U8 = "focusScope.autoFocusOnMount", W8 = "focusScope.autoFocusOnUnmount", KN = {
  bubbles: !1,
  cancelable: !0
}, tyt = /* @__PURE__ */ en((t, e) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: a, ...o } = t, [s, l] = De(null), c = e0(i), u = e0(a), d = Ue(null), f = Tp(
    e,
    (m) => l(m)
  ), h = Ue({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  ze(() => {
    if (r) {
      let m = function(w) {
        if (h.paused || !s) return;
        const b = w.target;
        s.contains(b) ? d.current = b : ql(d.current, {
          select: !0
        });
      }, g = function(w) {
        if (h.paused || !s) return;
        const b = w.relatedTarget;
        b !== null && (s.contains(b) || ql(d.current, {
          select: !0
        }));
      }, v = function(w) {
        if (document.activeElement === document.body)
          for (const b of w) b.removedNodes.length > 0 && ql(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", g);
      const k = new MutationObserver(v);
      return s && k.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", g), k.disconnect();
      };
    }
  }, [
    r,
    s,
    h.paused
  ]), ze(() => {
    if (s) {
      JN.add(h);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const g = new CustomEvent(U8, KN);
        s.addEventListener(U8, c), s.dispatchEvent(g), g.defaultPrevented || (nyt(syt(SG(s)), {
          select: !0
        }), document.activeElement === m && ql(s));
      }
      return () => {
        s.removeEventListener(U8, c), setTimeout(() => {
          const g = new CustomEvent(W8, KN);
          s.addEventListener(W8, u), s.dispatchEvent(g), g.defaultPrevented || ql(m ?? document.body, {
            select: !0
          }), s.removeEventListener(W8, u), JN.remove(h);
        }, 0);
      };
    }
  }, [
    s,
    c,
    u,
    h
  ]);
  const p = nt((m) => {
    if (!n && !r || h.paused) return;
    const g = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, v = document.activeElement;
    if (g && v) {
      const k = m.currentTarget, [w, b] = ryt(k);
      w && b ? !m.shiftKey && v === b ? (m.preventDefault(), n && ql(w, {
        select: !0
      })) : m.shiftKey && v === w && (m.preventDefault(), n && ql(b, {
        select: !0
      })) : v === k && m.preventDefault();
    }
  }, [
    n,
    r,
    h.paused
  ]);
  return /* @__PURE__ */ Ee(Va.div, pi({
    tabIndex: -1
  }, o, {
    ref: f,
    onKeyDown: p
  }));
});
function nyt(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (ql(r, {
      select: e
    }), document.activeElement !== n) return;
}
function ryt(t) {
  const e = SG(t), n = $N(e, t), r = $N(e.reverse(), t);
  return [
    n,
    r
  ];
}
function SG(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function $N(t, e) {
  for (const n of t)
    if (!iyt(n, {
      upTo: e
    })) return n;
}
function iyt(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden") return !0;
  for (; t; ) {
    if (e !== void 0 && t === e) return !1;
    if (getComputedStyle(t).display === "none") return !0;
    t = t.parentElement;
  }
  return !1;
}
function ayt(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function ql(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({
      preventScroll: !0
    }), t !== n && ayt(t) && e && t.select();
  }
}
const JN = oyt();
function oyt() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = QN(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = QN(t, e), (n = t[0]) === null || n === void 0 || n.resume();
    }
  };
}
function QN(t, e) {
  const n = [
    ...t
  ], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function syt(t) {
  return t.filter(
    (e) => e.tagName !== "A"
  );
}
const lyt = /* @__PURE__ */ en((t, e) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...i } = t;
  return r ? /* @__PURE__ */ hg.createPortal(/* @__PURE__ */ Ee(Va.div, pi({}, i, {
    ref: e
  })), r) : null;
});
function cyt(t, e) {
  return Mre((n, r) => e[n][r] ?? n, t);
}
const T6 = (t) => {
  const { present: e, children: n } = t, r = uyt(e), i = typeof n == "function" ? n({
    present: r.isPresent
  }) : Ws.only(n), a = Tp(r.ref, i.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ vd(i, {
    ref: a
  }) : null;
};
T6.displayName = "Presence";
function uyt(t) {
  const [e, n] = De(), r = Ue({}), i = Ue(t), a = Ue("none"), o = t ? "mounted" : "unmounted", [s, l] = cyt(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return ze(() => {
    const c = Om(r.current);
    a.current = s === "mounted" ? c : "none";
  }, [
    s
  ]), C9(() => {
    const c = r.current, u = i.current;
    if (u !== t) {
      const d = a.current, f = Om(c);
      t ? l("MOUNT") : f === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && d !== f ? "ANIMATION_OUT" : "UNMOUNT"), i.current = t;
    }
  }, [
    t,
    l
  ]), C9(() => {
    if (e) {
      const c = (d) => {
        const f = Om(r.current).includes(d.animationName);
        d.target === e && f && Zk(
          () => l("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === e && (a.current = Om(r.current));
      };
      return e.addEventListener("animationstart", u), e.addEventListener("animationcancel", c), e.addEventListener("animationend", c), () => {
        e.removeEventListener("animationstart", u), e.removeEventListener("animationcancel", c), e.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [
    e,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: nt((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function Om(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
let Z8 = 0;
function dyt() {
  ze(() => {
    var t, e;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (t = n[0]) !== null && t !== void 0 ? t : XN()), document.body.insertAdjacentElement("beforeend", (e = n[1]) !== null && e !== void 0 ? e : XN()), Z8++, () => {
      Z8 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Z8--;
    };
  }, []);
}
function XN() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", t;
}
var LG = xq(), G8 = function() {
}, E6 = N.forwardRef(function(t, e) {
  var n = N.useRef(null), r = N.useState({
    onScrollCapture: G8,
    onWheelCapture: G8,
    onTouchMoveCapture: G8
  }), i = r[0], a = r[1], o = t.forwardProps, s = t.children, l = t.className, c = t.removeScrollBar, u = t.enabled, d = t.shards, f = t.sideCar, h = t.noIsolation, p = t.inert, m = t.allowPinchZoom, g = t.as, v = g === void 0 ? "div" : g, k = jM(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), w = f, b = kq([n, e]), x = Wr(Wr({}, k), i);
  return N.createElement(
    N.Fragment,
    null,
    u && N.createElement(w, { sideCar: LG, removeScrollBar: c, shards: d, noIsolation: h, inert: p, setCallbacks: a, allowPinchZoom: !!m, lockRef: n }),
    o ? N.cloneElement(N.Children.only(s), Wr(Wr({}, x), { ref: b })) : N.createElement(v, Wr({}, x, { className: l, ref: b }), s)
  );
});
E6.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
E6.classNames = {
  fullWidth: th,
  zeroRight: eh
};
var L9 = !1;
if (typeof window < "u")
  try {
    var Bm = Object.defineProperty({}, "passive", {
      get: function() {
        return L9 = !0, !0;
      }
    });
    window.addEventListener("test", Bm, Bm), window.removeEventListener("test", Bm, Bm);
  } catch {
    L9 = !1;
  }
var H0 = L9 ? { passive: !1 } : !1, fyt = function(t) {
  return t.tagName === "TEXTAREA";
}, TG = function(t, e) {
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !fyt(t) && n[e] === "visible")
  );
}, hyt = function(t) {
  return TG(t, "overflowY");
}, pyt = function(t) {
  return TG(t, "overflowX");
}, eD = function(t, e) {
  var n = e;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = EG(t, n);
    if (r) {
      var i = jG(t, n), a = i[1], o = i[2];
      if (a > o)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, myt = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, r = t.clientHeight;
  return [
    e,
    n,
    r
  ];
}, yyt = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, r = t.clientWidth;
  return [
    e,
    n,
    r
  ];
}, EG = function(t, e) {
  return t === "v" ? hyt(e) : pyt(e);
}, jG = function(t, e) {
  return t === "v" ? myt(e) : yyt(e);
}, gyt = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, vyt = function(t, e, n, r, i) {
  var a = gyt(t, window.getComputedStyle(e).direction), o = a * r, s = n.target, l = e.contains(s), c = !1, u = o > 0, d = 0, f = 0;
  do {
    var h = jG(t, s), p = h[0], m = h[1], g = h[2], v = m - g - a * p;
    (p || v) && EG(t, s) && (d += v, f += p), s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (e.contains(s) || e === s)
  );
  return (u && d === 0 || !u && f === 0) && (c = !0), c;
}, Hm = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, tD = function(t) {
  return [t.deltaX, t.deltaY];
}, nD = function(t) {
  return t && "current" in t ? t.current : t;
}, byt = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, wyt = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, kyt = 0, F0 = [];
function xyt(t) {
  var e = N.useRef([]), n = N.useRef([0, 0]), r = N.useRef(), i = N.useState(kyt++)[0], a = N.useState(function() {
    return NM();
  })[0], o = N.useRef(t);
  N.useEffect(function() {
    o.current = t;
  }, [t]), N.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var m = wq([t.lockRef.current], (t.shards || []).map(nD)).filter(Boolean);
      return m.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), m.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var s = N.useCallback(function(m, g) {
    if ("touches" in m && m.touches.length === 2)
      return !o.current.allowPinchZoom;
    var v = Hm(m), k = n.current, w = "deltaX" in m ? m.deltaX : k[0] - v[0], b = "deltaY" in m ? m.deltaY : k[1] - v[1], x, A = m.target, L = Math.abs(w) > Math.abs(b) ? "h" : "v";
    if ("touches" in m && L === "h" && A.type === "range")
      return !1;
    var M = eD(L, A);
    if (!M)
      return !0;
    if (M ? x = L : (x = L === "v" ? "h" : "v", M = eD(L, A)), !M)
      return !1;
    if (!r.current && "changedTouches" in m && (w || b) && (r.current = x), !x)
      return !0;
    var j = r.current || x;
    return vyt(j, g, m, j === "h" ? w : b);
  }, []), l = N.useCallback(function(m) {
    var g = m;
    if (!(!F0.length || F0[F0.length - 1] !== a)) {
      var v = "deltaY" in g ? tD(g) : Hm(g), k = e.current.filter(function(x) {
        return x.name === g.type && x.target === g.target && byt(x.delta, v);
      })[0];
      if (k && k.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!k) {
        var w = (o.current.shards || []).map(nD).filter(Boolean).filter(function(x) {
          return x.contains(g.target);
        }), b = w.length > 0 ? s(g, w[0]) : !o.current.noIsolation;
        b && g.cancelable && g.preventDefault();
      }
    }
  }, []), c = N.useCallback(function(m, g, v, k) {
    var w = { name: m, delta: g, target: v, should: k };
    e.current.push(w), setTimeout(function() {
      e.current = e.current.filter(function(b) {
        return b !== w;
      });
    }, 1);
  }, []), u = N.useCallback(function(m) {
    n.current = Hm(m), r.current = void 0;
  }, []), d = N.useCallback(function(m) {
    c(m.type, tD(m), m.target, s(m, t.lockRef.current));
  }, []), f = N.useCallback(function(m) {
    c(m.type, Hm(m), m.target, s(m, t.lockRef.current));
  }, []);
  N.useEffect(function() {
    return F0.push(a), t.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, H0), document.addEventListener("touchmove", l, H0), document.addEventListener("touchstart", u, H0), function() {
      F0 = F0.filter(function(m) {
        return m !== a;
      }), document.removeEventListener("wheel", l, H0), document.removeEventListener("touchmove", l, H0), document.removeEventListener("touchstart", u, H0);
    };
  }, []);
  var h = t.removeScrollBar, p = t.inert;
  return N.createElement(
    N.Fragment,
    null,
    p ? N.createElement(a, { styles: wyt(i) }) : null,
    h ? N.createElement(Sq, { gapMode: "margin" }) : null
  );
}
const Myt = Cq(LG, xyt);
var NG = N.forwardRef(function(t, e) {
  return N.createElement(E6, Wr({}, t, { ref: e, sideCar: Myt }));
});
NG.classNames = E6.classNames;
const DG = "Dialog", [IG, MGt] = O4t(DG), [Cyt, S0] = IG(DG), Ayt = (t) => {
  const { __scopeDialog: e, children: n, open: r, defaultOpen: i, onOpenChange: a, modal: o = !0 } = t, s = Ue(null), l = Ue(null), [c = !1, u] = _4t({
    prop: r,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ Ee(Cyt, {
    scope: e,
    triggerRef: s,
    contentRef: l,
    contentId: q8(),
    titleId: q8(),
    descriptionId: q8(),
    open: c,
    onOpenChange: u,
    onOpenToggle: nt(
      () => u(
        (d) => !d
      ),
      [
        u
      ]
    ),
    modal: o
  }, n);
}, PG = "DialogPortal", [Syt, zG] = IG(PG, {
  forceMount: void 0
}), Lyt = (t) => {
  const { __scopeDialog: e, forceMount: n, children: r, container: i } = t, a = S0(PG, e);
  return /* @__PURE__ */ Ee(Syt, {
    scope: e,
    forceMount: n
  }, Ws.map(
    r,
    (o) => /* @__PURE__ */ Ee(T6, {
      present: n || a.open
    }, /* @__PURE__ */ Ee(lyt, {
      asChild: !0,
      container: i
    }, o))
  ));
}, T9 = "DialogOverlay", Tyt = /* @__PURE__ */ en((t, e) => {
  const n = zG(T9, t.__scopeDialog), { forceMount: r = n.forceMount, ...i } = t, a = S0(T9, t.__scopeDialog);
  return a.modal ? /* @__PURE__ */ Ee(T6, {
    present: r || a.open
  }, /* @__PURE__ */ Ee(Eyt, pi({}, i, {
    ref: e
  }))) : null;
}), Eyt = /* @__PURE__ */ en((t, e) => {
  const { __scopeDialog: n, ...r } = t, i = S0(T9, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ Ee(NG, {
      as: LC,
      allowPinchZoom: !0,
      shards: [
        i.contentRef
      ]
    }, /* @__PURE__ */ Ee(Va.div, pi({
      "data-state": OG(i.open)
    }, r, {
      ref: e,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), Qh = "DialogContent", jyt = /* @__PURE__ */ en((t, e) => {
  const n = zG(Qh, t.__scopeDialog), { forceMount: r = n.forceMount, ...i } = t, a = S0(Qh, t.__scopeDialog);
  return /* @__PURE__ */ Ee(T6, {
    present: r || a.open
  }, a.modal ? /* @__PURE__ */ Ee(Nyt, pi({}, i, {
    ref: e
  })) : /* @__PURE__ */ Ee(Dyt, pi({}, i, {
    ref: e
  })));
}), Nyt = /* @__PURE__ */ en((t, e) => {
  const n = S0(Qh, t.__scopeDialog), r = Ue(null), i = Tp(e, n.contentRef, r);
  return ze(() => {
    const a = r.current;
    if (a) return t6(a);
  }, []), /* @__PURE__ */ Ee(RG, pi({}, t, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: w1(t.onCloseAutoFocus, (a) => {
      var o;
      a.preventDefault(), (o = n.triggerRef.current) === null || o === void 0 || o.focus();
    }),
    onPointerDownOutside: w1(t.onPointerDownOutside, (a) => {
      const o = a.detail.originalEvent, s = o.button === 0 && o.ctrlKey === !0;
      (o.button === 2 || s) && a.preventDefault();
    }),
    onFocusOutside: w1(
      t.onFocusOutside,
      (a) => a.preventDefault()
    )
  }));
}), Dyt = /* @__PURE__ */ en((t, e) => {
  const n = S0(Qh, t.__scopeDialog), r = Ue(!1), i = Ue(!1);
  return /* @__PURE__ */ Ee(RG, pi({}, t, {
    ref: e,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (a) => {
      var o;
      if ((o = t.onCloseAutoFocus) === null || o === void 0 || o.call(t, a), !a.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), a.preventDefault();
      }
      r.current = !1, i.current = !1;
    },
    onInteractOutside: (a) => {
      var o, s;
      (o = t.onInteractOutside) === null || o === void 0 || o.call(t, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (i.current = !0));
      const l = a.target;
      !((s = n.triggerRef.current) === null || s === void 0) && s.contains(l) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && i.current && a.preventDefault();
    }
  }));
}), RG = /* @__PURE__ */ en((t, e) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...o } = t, s = S0(Qh, n), l = Ue(null), c = Tp(e, l);
  return dyt(), /* @__PURE__ */ Ee(ds, null, /* @__PURE__ */ Ee(tyt, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: i,
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ Ee(Q4t, pi({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": OG(s.open)
  }, o, {
    ref: c,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
});
function OG(t) {
  return t ? "open" : "closed";
}
const Iyt = Ayt, Pyt = Lyt, zyt = Tyt, Ryt = jyt;
var ff = '[cmdk-group=""]', Y8 = '[cmdk-group-items=""]', Oyt = '[cmdk-group-heading=""]', TC = '[cmdk-item=""]', rD = `${TC}:not([aria-disabled="true"])`, E9 = "cmdk-item-select", gu = "data-value", Byt = (t, e, n) => z4t(t, e, n), BG = N.createContext(void 0), Ep = () => N.useContext(BG), HG = N.createContext(void 0), EC = () => N.useContext(HG), FG = N.createContext(void 0), _G = N.forwardRef((t, e) => {
  let n = J0(() => {
    var ae, fe;
    return { search: "", value: (fe = (ae = t.value) != null ? ae : t.defaultValue) != null ? fe : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = J0(() => /* @__PURE__ */ new Set()), i = J0(() => /* @__PURE__ */ new Map()), a = J0(() => /* @__PURE__ */ new Map()), o = J0(() => /* @__PURE__ */ new Set()), s = VG(t), { label: l, children: c, value: u, onValueChange: d, filter: f, shouldFilter: h, loop: p, disablePointerSelection: m = !1, vimBindings: g = !0, ...v } = t, k = N.useId(), w = N.useId(), b = N.useId(), x = N.useRef(null), A = Kyt();
  t0(() => {
    if (u !== void 0) {
      let ae = u.trim();
      n.current.value = ae, L.emit();
    }
  }, [u]), t0(() => {
    A(6, V);
  }, []);
  let L = N.useMemo(() => ({ subscribe: (ae) => (o.current.add(ae), () => o.current.delete(ae)), snapshot: () => n.current, setState: (ae, fe, me) => {
    var ge, $, se;
    if (!Object.is(n.current[ae], fe)) {
      if (n.current[ae] = fe, ae === "search") H(), D(), A(1, z);
      else if (ae === "value" && (me || A(5, V), ((ge = s.current) == null ? void 0 : ge.value) !== void 0)) {
        let xe = fe ?? "";
        (se = ($ = s.current).onValueChange) == null || se.call($, xe);
        return;
      }
      L.emit();
    }
  }, emit: () => {
    o.current.forEach((ae) => ae());
  } }), []), M = N.useMemo(() => ({ value: (ae, fe, me) => {
    var ge;
    fe !== ((ge = a.current.get(ae)) == null ? void 0 : ge.value) && (a.current.set(ae, { value: fe, keywords: me }), n.current.filtered.items.set(ae, j(fe, me)), A(2, () => {
      D(), L.emit();
    }));
  }, item: (ae, fe) => (r.current.add(ae), fe && (i.current.has(fe) ? i.current.get(fe).add(ae) : i.current.set(fe, /* @__PURE__ */ new Set([ae]))), A(3, () => {
    H(), D(), n.current.value || z(), L.emit();
  }), () => {
    a.current.delete(ae), r.current.delete(ae), n.current.filtered.items.delete(ae);
    let me = F();
    A(4, () => {
      H(), (me == null ? void 0 : me.getAttribute("id")) === ae && z(), L.emit();
    });
  }), group: (ae) => (i.current.has(ae) || i.current.set(ae, /* @__PURE__ */ new Set()), () => {
    a.current.delete(ae), i.current.delete(ae);
  }), filter: () => s.current.shouldFilter, label: l || t["aria-label"], disablePointerSelection: m, listId: k, inputId: b, labelId: w, listInnerRef: x }), []);
  function j(ae, fe) {
    var me, ge;
    let $ = (ge = (me = s.current) == null ? void 0 : me.filter) != null ? ge : Byt;
    return ae ? $(ae, n.current.search, fe) : 0;
  }
  function D() {
    if (!n.current.search || s.current.shouldFilter === !1) return;
    let ae = n.current.filtered.items, fe = [];
    n.current.filtered.groups.forEach((ge) => {
      let $ = i.current.get(ge), se = 0;
      $.forEach((xe) => {
        let Oe = ae.get(xe);
        se = Math.max(Oe, se);
      }), fe.push([ge, se]);
    });
    let me = x.current;
    _().sort((ge, $) => {
      var se, xe;
      let Oe = ge.getAttribute("id"), je = $.getAttribute("id");
      return ((se = ae.get(je)) != null ? se : 0) - ((xe = ae.get(Oe)) != null ? xe : 0);
    }).forEach((ge) => {
      let $ = ge.closest(Y8);
      $ ? $.appendChild(ge.parentElement === $ ? ge : ge.closest(`${Y8} > *`)) : me.appendChild(ge.parentElement === me ? ge : ge.closest(`${Y8} > *`));
    }), fe.sort((ge, $) => $[1] - ge[1]).forEach((ge) => {
      let $ = x.current.querySelector(`${ff}[${gu}="${encodeURIComponent(ge[0])}"]`);
      $ == null || $.parentElement.appendChild($);
    });
  }
  function z() {
    let ae = _().find((me) => me.getAttribute("aria-disabled") !== "true"), fe = ae == null ? void 0 : ae.getAttribute(gu);
    L.setState("value", fe || void 0);
  }
  function H() {
    var ae, fe, me, ge;
    if (!n.current.search || s.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let $ = 0;
    for (let se of r.current) {
      let xe = (fe = (ae = a.current.get(se)) == null ? void 0 : ae.value) != null ? fe : "", Oe = (ge = (me = a.current.get(se)) == null ? void 0 : me.keywords) != null ? ge : [], je = j(xe, Oe);
      n.current.filtered.items.set(se, je), je > 0 && $++;
    }
    for (let [se, xe] of i.current) for (let Oe of xe) if (n.current.filtered.items.get(Oe) > 0) {
      n.current.filtered.groups.add(se);
      break;
    }
    n.current.filtered.count = $;
  }
  function V() {
    var ae, fe, me;
    let ge = F();
    ge && (((ae = ge.parentElement) == null ? void 0 : ae.firstChild) === ge && ((me = (fe = ge.closest(ff)) == null ? void 0 : fe.querySelector(Oyt)) == null || me.scrollIntoView({ block: "nearest" })), ge.scrollIntoView({ block: "nearest" }));
  }
  function F() {
    var ae;
    return (ae = x.current) == null ? void 0 : ae.querySelector(`${TC}[aria-selected="true"]`);
  }
  function _() {
    var ae;
    return Array.from((ae = x.current) == null ? void 0 : ae.querySelectorAll(rD));
  }
  function W(ae) {
    let fe = _()[ae];
    fe && L.setState("value", fe.getAttribute(gu));
  }
  function G(ae) {
    var fe;
    let me = F(), ge = _(), $ = ge.findIndex((xe) => xe === me), se = ge[$ + ae];
    (fe = s.current) != null && fe.loop && (se = $ + ae < 0 ? ge[ge.length - 1] : $ + ae === ge.length ? ge[0] : ge[$ + ae]), se && L.setState("value", se.getAttribute(gu));
  }
  function Y(ae) {
    let fe = F(), me = fe == null ? void 0 : fe.closest(ff), ge;
    for (; me && !ge; ) me = ae > 0 ? Gyt(me, ff) : Yyt(me, ff), ge = me == null ? void 0 : me.querySelector(rD);
    ge ? L.setState("value", ge.getAttribute(gu)) : G(ae);
  }
  let Z = () => W(_().length - 1), oe = (ae) => {
    ae.preventDefault(), ae.metaKey ? Z() : ae.altKey ? Y(1) : G(1);
  }, ee = (ae) => {
    ae.preventDefault(), ae.metaKey ? W(0) : ae.altKey ? Y(-1) : G(-1);
  };
  return N.createElement(Va.div, { ref: e, tabIndex: -1, ...v, "cmdk-root": "", onKeyDown: (ae) => {
    var fe;
    if ((fe = v.onKeyDown) == null || fe.call(v, ae), !ae.defaultPrevented) switch (ae.key) {
      case "n":
      case "j": {
        g && ae.ctrlKey && oe(ae);
        break;
      }
      case "ArrowDown": {
        oe(ae);
        break;
      }
      case "p":
      case "k": {
        g && ae.ctrlKey && ee(ae);
        break;
      }
      case "ArrowUp": {
        ee(ae);
        break;
      }
      case "Home": {
        ae.preventDefault(), W(0);
        break;
      }
      case "End": {
        ae.preventDefault(), Z();
        break;
      }
      case "Enter":
        if (!ae.nativeEvent.isComposing && ae.keyCode !== 229) {
          ae.preventDefault();
          let me = F();
          if (me) {
            let ge = new Event(E9);
            me.dispatchEvent(ge);
          }
        }
    }
  } }, N.createElement("label", { "cmdk-label": "", htmlFor: M.inputId, id: M.labelId, style: Jyt }, l), j6(t, (ae) => N.createElement(HG.Provider, { value: L }, N.createElement(BG.Provider, { value: M }, ae))));
}), Hyt = N.forwardRef((t, e) => {
  var n, r;
  let i = N.useId(), a = N.useRef(null), o = N.useContext(FG), s = Ep(), l = VG(t), c = (r = (n = l.current) == null ? void 0 : n.forceMount) != null ? r : o == null ? void 0 : o.forceMount;
  t0(() => {
    if (!c) return s.item(i, o == null ? void 0 : o.id);
  }, [c]);
  let u = qG(i, a, [t.value, t.children, a], t.keywords), d = EC(), f = n0((A) => A.value && A.value === u.current), h = n0((A) => c || s.filter() === !1 ? !0 : A.search ? A.filtered.items.get(i) > 0 : !0);
  N.useEffect(() => {
    let A = a.current;
    if (!(!A || t.disabled)) return A.addEventListener(E9, p), () => A.removeEventListener(E9, p);
  }, [h, t.onSelect, t.disabled]);
  function p() {
    var A, L;
    m(), (L = (A = l.current).onSelect) == null || L.call(A, u.current);
  }
  function m() {
    d.setState("value", u.current, !0);
  }
  if (!h) return null;
  let { disabled: g, value: v, onSelect: k, forceMount: w, keywords: b, ...x } = t;
  return N.createElement(Va.div, { ref: Xh([a, e]), ...x, id: i, "cmdk-item": "", role: "option", "aria-disabled": !!g, "aria-selected": !!f, "data-disabled": !!g, "data-selected": !!f, onPointerMove: g || s.disablePointerSelection ? void 0 : m, onClick: g ? void 0 : p }, t.children);
}), Fyt = N.forwardRef((t, e) => {
  let { heading: n, children: r, forceMount: i, ...a } = t, o = N.useId(), s = N.useRef(null), l = N.useRef(null), c = N.useId(), u = Ep(), d = n0((h) => i || u.filter() === !1 ? !0 : h.search ? h.filtered.groups.has(o) : !0);
  t0(() => u.group(o), []), qG(o, s, [t.value, t.heading, l]);
  let f = N.useMemo(() => ({ id: o, forceMount: i }), [i]);
  return N.createElement(Va.div, { ref: Xh([s, e]), ...a, "cmdk-group": "", role: "presentation", hidden: d ? void 0 : !0 }, n && N.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: c }, n), j6(t, (h) => N.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? c : void 0 }, N.createElement(FG.Provider, { value: f }, h))));
}), _yt = N.forwardRef((t, e) => {
  let { alwaysRender: n, ...r } = t, i = N.useRef(null), a = n0((o) => !o.search);
  return !n && !a ? null : N.createElement(Va.div, { ref: Xh([i, e]), ...r, "cmdk-separator": "", role: "separator" });
}), Vyt = N.forwardRef((t, e) => {
  let { onValueChange: n, ...r } = t, i = t.value != null, a = EC(), o = n0((u) => u.search), s = n0((u) => u.value), l = Ep(), c = N.useMemo(() => {
    var u;
    let d = (u = l.listInnerRef.current) == null ? void 0 : u.querySelector(`${TC}[${gu}="${encodeURIComponent(s)}"]`);
    return d == null ? void 0 : d.getAttribute("id");
  }, []);
  return N.useEffect(() => {
    t.value != null && a.setState("search", t.value);
  }, [t.value]), N.createElement(Va.input, { ref: e, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": c, id: l.inputId, type: "text", value: i ? t.value : o, onChange: (u) => {
    i || a.setState("search", u.target.value), n == null || n(u.target.value);
  } });
}), qyt = N.forwardRef((t, e) => {
  let { children: n, label: r = "Suggestions", ...i } = t, a = N.useRef(null), o = N.useRef(null), s = Ep();
  return N.useEffect(() => {
    if (o.current && a.current) {
      let l = o.current, c = a.current, u, d = new ResizeObserver(() => {
        u = requestAnimationFrame(() => {
          let f = l.offsetHeight;
          c.style.setProperty("--cmdk-list-height", f.toFixed(1) + "px");
        });
      });
      return d.observe(l), () => {
        cancelAnimationFrame(u), d.unobserve(l);
      };
    }
  }, []), N.createElement(Va.div, { ref: Xh([a, e]), ...i, "cmdk-list": "", role: "listbox", "aria-label": r, id: s.listId }, j6(t, (l) => N.createElement("div", { ref: Xh([o, s.listInnerRef]), "cmdk-list-sizer": "" }, l)));
}), Uyt = N.forwardRef((t, e) => {
  let { open: n, onOpenChange: r, overlayClassName: i, contentClassName: a, container: o, ...s } = t;
  return N.createElement(Iyt, { open: n, onOpenChange: r }, N.createElement(Pyt, { container: o }, N.createElement(zyt, { "cmdk-overlay": "", className: i }), N.createElement(Ryt, { "aria-label": t.label, "cmdk-dialog": "", className: a }, N.createElement(_G, { ref: e, ...s }))));
}), Wyt = N.forwardRef((t, e) => n0((n) => n.filtered.count === 0) ? N.createElement(Va.div, { ref: e, ...t, "cmdk-empty": "", role: "presentation" }) : null), Zyt = N.forwardRef((t, e) => {
  let { progress: n, children: r, label: i = "Loading...", ...a } = t;
  return N.createElement(Va.div, { ref: e, ...a, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": i }, j6(t, (o) => N.createElement("div", { "aria-hidden": !0 }, o)));
}), Ri = Object.assign(_G, { List: qyt, Item: Hyt, Input: Vyt, Group: Fyt, Separator: _yt, Dialog: Uyt, Empty: Wyt, Loading: Zyt });
function Gyt(t, e) {
  let n = t.nextElementSibling;
  for (; n; ) {
    if (n.matches(e)) return n;
    n = n.nextElementSibling;
  }
}
function Yyt(t, e) {
  let n = t.previousElementSibling;
  for (; n; ) {
    if (n.matches(e)) return n;
    n = n.previousElementSibling;
  }
}
function VG(t) {
  let e = N.useRef(t);
  return t0(() => {
    e.current = t;
  }), e;
}
var t0 = typeof window > "u" ? N.useEffect : N.useLayoutEffect;
function J0(t) {
  let e = N.useRef();
  return e.current === void 0 && (e.current = t()), e;
}
function Xh(t) {
  return (e) => {
    t.forEach((n) => {
      typeof n == "function" ? n(e) : n != null && (n.current = e);
    });
  };
}
function n0(t) {
  let e = EC(), n = () => t(e.snapshot());
  return N.useSyncExternalStore(e.subscribe, n, n);
}
function qG(t, e, n, r = []) {
  let i = N.useRef(), a = Ep();
  return t0(() => {
    var o;
    let s = (() => {
      var c;
      for (let u of n) {
        if (typeof u == "string") return u.trim();
        if (typeof u == "object" && "current" in u) return u.current ? (c = u.current.textContent) == null ? void 0 : c.trim() : i.current;
      }
    })(), l = r.map((c) => c.trim());
    a.value(t, s, l), (o = e.current) == null || o.setAttribute(gu, s), i.current = s;
  }), i;
}
var Kyt = () => {
  let [t, e] = N.useState(), n = J0(() => /* @__PURE__ */ new Map());
  return t0(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [t]), (r, i) => {
    n.current.set(r, i), e({});
  };
};
function $yt(t) {
  let e = t.type;
  return typeof e == "function" ? e(t.props) : "render" in e ? e.render(t.props) : t;
}
function j6({ asChild: t, children: e }, n) {
  return t && N.isValidElement(e) ? N.cloneElement($yt(e), { ref: e.ref }, n(e.props.children)) : n(e);
}
var Jyt = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const UG = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  Ri,
  {
    ref: n,
    className: be(
      "flex h-full w-full flex-col overflow-hidden rounded-md color-bg-default color-text-default",
      t
    ),
    ...e
  }
));
UG.displayName = Ri.displayName;
const WG = N.forwardRef(({ className: t, disabledIcon: e = !1, inputWrapperClassName: n, ...r }, i) => /* @__PURE__ */ T.jsxs(
  "div",
  {
    className: be("flex items-center border-b px-3", n),
    "cmdk-input-wrapper": "",
    children: [
      !e && /* @__PURE__ */ T.jsx(jF, { size: 16, className: "mr-2 color-text-disabled", "aria-hidden": "true" }),
      /* @__PURE__ */ T.jsx(
        Ri.Input,
        {
          ref: i,
          className: be(
            "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:color-text-disabled disabled:cursor-not-allowed disabled:opacity-50",
            t
          ),
          ...r
        }
      )
    ]
  }
));
WG.displayName = Ri.Input.displayName;
const ZG = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  Ri.List,
  {
    ref: n,
    className: be("max-h-[300px] overflow-y-auto overflow-x-hidden", t),
    ...e
  }
));
ZG.displayName = Ri.List.displayName;
const GG = N.forwardRef((t, e) => /* @__PURE__ */ T.jsx(
  Ri.Empty,
  {
    ref: e,
    className: "py-6 text-center text-body-sm",
    ...t
  }
));
GG.displayName = Ri.Empty.displayName;
const YG = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  Ri.Group,
  {
    ref: n,
    className: be(
      "overflow-hidden p-1 color-text-default [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-helper-text-sm [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:color-text-disabled",
      t
    ),
    ...e
  }
));
YG.displayName = Ri.Group.displayName;
const Qyt = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  Ri.Separator,
  {
    ref: n,
    className: be("-mx-1 h-px color-border-default", t),
    ...e
  }
));
Qyt.displayName = Ri.Separator.displayName;
const KG = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  Ri.Item,
  {
    ref: n,
    className: be(
      "relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-body-sm outline-none aria-selected:color-bg-default-selected aria-selected:color-text-default",
      t
    ),
    ...e
  }
));
KG.displayName = Ri.Item.displayName;
en(({ count: t = 0 }, e) => {
  const n = t > 9;
  return /* @__PURE__ */ T.jsx(
    "div",
    {
      ref: e,
      className: be(
        "color-bg-tertiary color-text-default rounded-full h-[18px] !font-bold text-helper-text-sm flex justify-center items-center",
        {
          "aspect-square": !n,
          "w-auto p-2": n
        }
      ),
      children: t
    }
  );
});
const hn = ({ className: t, ...e }) => /* @__PURE__ */ T.jsx(
  "div",
  {
    className: be("animate-pulse rounded-md color-bg-disabled", t),
    ...e
  }
), Xyt = N.forwardRef(({ className: t, align: e = "center", sideOffset: n = 4, ...r }, i) => /* @__PURE__ */ T.jsx(
  dU,
  {
    ref: i,
    align: e,
    sideOffset: n,
    className: be(
      "z-50 w-64 rounded-md border color-bg-default color-text-default p-4 shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...r
  }
));
Xyt.displayName = dU.displayName;
var e3t = "ToastProvider", [$G, t3t, n3t] = Yg("Toast"), [JG, CGt] = ei("Toast", [n3t]), [AGt, N6] = JG(e3t), QG = "ToastViewport", r3t = ["F8"], j9 = "toast.viewportPause", N9 = "toast.viewportResume", XG = N.forwardRef(
  (t, e) => {
    const {
      __scopeToast: n,
      hotkey: r = r3t,
      label: i = "Notifications ({hotkey})",
      ...a
    } = t, o = N6(QG, n), s = t3t(n), l = N.useRef(null), c = N.useRef(null), u = N.useRef(null), d = N.useRef(null), f = Jt(e, d, o.onViewportChange), h = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), p = o.toastCount > 0;
    N.useEffect(() => {
      const g = (v) => {
        var k;
        r.every((w) => v[w] || v.code === w) && ((k = d.current) == null || k.focus());
      };
      return document.addEventListener("keydown", g), () => document.removeEventListener("keydown", g);
    }, [r]), N.useEffect(() => {
      const g = l.current, v = d.current;
      if (p && g && v) {
        const k = () => {
          if (!o.isClosePausedRef.current) {
            const A = new CustomEvent(j9);
            v.dispatchEvent(A), o.isClosePausedRef.current = !0;
          }
        }, w = () => {
          if (o.isClosePausedRef.current) {
            const A = new CustomEvent(N9);
            v.dispatchEvent(A), o.isClosePausedRef.current = !1;
          }
        }, b = (A) => {
          !g.contains(A.relatedTarget) && w();
        }, x = () => {
          g.contains(document.activeElement) || w();
        };
        return g.addEventListener("focusin", k), g.addEventListener("focusout", b), g.addEventListener("pointermove", k), g.addEventListener("pointerleave", x), window.addEventListener("blur", k), window.addEventListener("focus", w), () => {
          g.removeEventListener("focusin", k), g.removeEventListener("focusout", b), g.removeEventListener("pointermove", k), g.removeEventListener("pointerleave", x), window.removeEventListener("blur", k), window.removeEventListener("focus", w);
        };
      }
    }, [p, o.isClosePausedRef]);
    const m = N.useCallback(
      ({ tabbingDirection: g }) => {
        const v = s().map((k) => {
          const w = k.ref.current, b = [w, ...y3t(w)];
          return g === "forwards" ? b : b.reverse();
        });
        return (g === "forwards" ? v.reverse() : v).flat();
      },
      [s]
    );
    return N.useEffect(() => {
      const g = d.current;
      if (g) {
        const v = (k) => {
          var w, b, x;
          const A = k.altKey || k.ctrlKey || k.metaKey;
          if (k.key === "Tab" && !A) {
            const L = document.activeElement, M = k.shiftKey;
            if (k.target === g && M) {
              (w = c.current) == null || w.focus();
              return;
            }
            const j = m({ tabbingDirection: M ? "backwards" : "forwards" }), D = j.findIndex((z) => z === L);
            K8(j.slice(D + 1)) ? k.preventDefault() : M ? (b = c.current) == null || b.focus() : (x = u.current) == null || x.focus();
          }
        };
        return g.addEventListener("keydown", v), () => g.removeEventListener("keydown", v);
      }
    }, [s, m]), /* @__PURE__ */ T.jsxs(
      Jit,
      {
        ref: l,
        role: "region",
        "aria-label": i.replace("{hotkey}", h),
        tabIndex: -1,
        style: { pointerEvents: p ? void 0 : "none" },
        children: [
          p && /* @__PURE__ */ T.jsx(
            D9,
            {
              ref: c,
              onFocusFromOutsideViewport: () => {
                const g = m({
                  tabbingDirection: "forwards"
                });
                K8(g);
              }
            }
          ),
          /* @__PURE__ */ T.jsx($G.Slot, { scope: n, children: /* @__PURE__ */ T.jsx(Ct.ol, { tabIndex: -1, ...a, ref: f }) }),
          p && /* @__PURE__ */ T.jsx(
            D9,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const g = m({
                  tabbingDirection: "backwards"
                });
                K8(g);
              }
            }
          )
        ]
      }
    );
  }
);
XG.displayName = QG;
var eY = "ToastFocusProxy", D9 = N.forwardRef(
  (t, e) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...i } = t, a = N6(eY, n);
    return /* @__PURE__ */ T.jsx(
      cp,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...i,
        ref: e,
        style: { position: "fixed" },
        onFocus: (o) => {
          var s;
          const l = o.relatedTarget;
          !((s = a.viewport) != null && s.contains(l)) && r();
        }
      }
    );
  }
);
D9.displayName = eY;
var D6 = "Toast", i3t = "toast.swipeStart", a3t = "toast.swipeMove", o3t = "toast.swipeCancel", s3t = "toast.swipeEnd", tY = N.forwardRef(
  (t, e) => {
    const { forceMount: n, open: r, defaultOpen: i, onOpenChange: a, ...o } = t, [s = !0, l] = mo({
      prop: r,
      defaultProp: i,
      onChange: a
    });
    return /* @__PURE__ */ T.jsx(zi, { present: n || s, children: /* @__PURE__ */ T.jsx(
      u3t,
      {
        open: s,
        ...o,
        ref: e,
        onClose: () => l(!1),
        onPause: Di(t.onPause),
        onResume: Di(t.onResume),
        onSwipeStart: it(t.onSwipeStart, (c) => {
          c.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: it(t.onSwipeMove, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "move"), c.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${d}px`);
        }),
        onSwipeCancel: it(t.onSwipeCancel, (c) => {
          c.currentTarget.setAttribute("data-swipe", "cancel"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: it(t.onSwipeEnd, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "end"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${d}px`), l(!1);
        })
      }
    ) });
  }
);
tY.displayName = D6;
var [l3t, c3t] = JG(D6, {
  onClose() {
  }
}), u3t = N.forwardRef(
  (t, e) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: i,
      open: a,
      onClose: o,
      onEscapeKeyDown: s,
      onPause: l,
      onResume: c,
      onSwipeStart: u,
      onSwipeMove: d,
      onSwipeCancel: f,
      onSwipeEnd: h,
      ...p
    } = t, m = N6(D6, n), [g, v] = N.useState(null), k = Jt(e, (F) => v(F)), w = N.useRef(null), b = N.useRef(null), x = i || m.duration, A = N.useRef(0), L = N.useRef(x), M = N.useRef(0), { onToastAdd: j, onToastRemove: D } = m, z = Di(() => {
      var F;
      g != null && g.contains(document.activeElement) && ((F = m.viewport) == null || F.focus()), o();
    }), H = N.useCallback(
      (F) => {
        !F || F === 1 / 0 || (window.clearTimeout(M.current), A.current = (/* @__PURE__ */ new Date()).getTime(), M.current = window.setTimeout(z, F));
      },
      [z]
    );
    N.useEffect(() => {
      const F = m.viewport;
      if (F) {
        const _ = () => {
          H(L.current), c == null || c();
        }, W = () => {
          const G = (/* @__PURE__ */ new Date()).getTime() - A.current;
          L.current = L.current - G, window.clearTimeout(M.current), l == null || l();
        };
        return F.addEventListener(j9, W), F.addEventListener(N9, _), () => {
          F.removeEventListener(j9, W), F.removeEventListener(N9, _);
        };
      }
    }, [m.viewport, x, l, c, H]), N.useEffect(() => {
      a && !m.isClosePausedRef.current && H(x);
    }, [a, x, m.isClosePausedRef, H]), N.useEffect(() => (j(), () => D()), [j, D]);
    const V = N.useMemo(() => g ? lY(g) : null, [g]);
    return m.viewport ? /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
      V && /* @__PURE__ */ T.jsx(
        d3t,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: V
        }
      ),
      /* @__PURE__ */ T.jsx(l3t, { scope: n, onClose: z, children: wd.createPortal(
        /* @__PURE__ */ T.jsx($G.ItemSlot, { scope: n, children: /* @__PURE__ */ T.jsx(
          $it,
          {
            asChild: !0,
            onEscapeKeyDown: it(s, () => {
              m.isFocusedToastEscapeKeyDownRef.current || z(), m.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ T.jsx(
              Ct.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": m.swipeDirection,
                ...p,
                ref: k,
                style: { userSelect: "none", touchAction: "none", ...t.style },
                onKeyDown: it(t.onKeyDown, (F) => {
                  F.key === "Escape" && (s == null || s(F.nativeEvent), F.nativeEvent.defaultPrevented || (m.isFocusedToastEscapeKeyDownRef.current = !0, z()));
                }),
                onPointerDown: it(t.onPointerDown, (F) => {
                  F.button === 0 && (w.current = { x: F.clientX, y: F.clientY });
                }),
                onPointerMove: it(t.onPointerMove, (F) => {
                  if (!w.current) return;
                  const _ = F.clientX - w.current.x, W = F.clientY - w.current.y, G = !!b.current, Y = ["left", "right"].includes(m.swipeDirection), Z = ["left", "up"].includes(m.swipeDirection) ? Math.min : Math.max, oe = Y ? Z(0, _) : 0, ee = Y ? 0 : Z(0, W), ae = F.pointerType === "touch" ? 10 : 2, fe = { x: oe, y: ee }, me = { originalEvent: F, delta: fe };
                  G ? (b.current = fe, Fm(a3t, d, me, {
                    discrete: !1
                  })) : iD(fe, m.swipeDirection, ae) ? (b.current = fe, Fm(i3t, u, me, {
                    discrete: !1
                  }), F.target.setPointerCapture(F.pointerId)) : (Math.abs(_) > ae || Math.abs(W) > ae) && (w.current = null);
                }),
                onPointerUp: it(t.onPointerUp, (F) => {
                  const _ = b.current, W = F.target;
                  if (W.hasPointerCapture(F.pointerId) && W.releasePointerCapture(F.pointerId), b.current = null, w.current = null, _) {
                    const G = F.currentTarget, Y = { originalEvent: F, delta: _ };
                    iD(_, m.swipeDirection, m.swipeThreshold) ? Fm(s3t, h, Y, {
                      discrete: !0
                    }) : Fm(
                      o3t,
                      f,
                      Y,
                      {
                        discrete: !0
                      }
                    ), G.addEventListener("click", (Z) => Z.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        m.viewport
      ) })
    ] }) : null;
  }
), d3t = (t) => {
  const { __scopeToast: e, children: n, ...r } = t, i = N6(D6, e), [a, o] = N.useState(!1), [s, l] = N.useState(!1);
  return p3t(() => o(!0)), N.useEffect(() => {
    const c = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(c);
  }, []), s ? null : /* @__PURE__ */ T.jsx(Ld, { asChild: !0, children: /* @__PURE__ */ T.jsx(cp, { ...r, children: a && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    i.label,
    " ",
    n
  ] }) }) });
}, f3t = "ToastTitle", nY = N.forwardRef(
  (t, e) => {
    const { __scopeToast: n, ...r } = t;
    return /* @__PURE__ */ T.jsx(Ct.div, { ...r, ref: e });
  }
);
nY.displayName = f3t;
var h3t = "ToastDescription", rY = N.forwardRef(
  (t, e) => {
    const { __scopeToast: n, ...r } = t;
    return /* @__PURE__ */ T.jsx(Ct.div, { ...r, ref: e });
  }
);
rY.displayName = h3t;
var iY = "ToastAction", aY = N.forwardRef(
  (t, e) => {
    const { altText: n, ...r } = t;
    return n.trim() ? /* @__PURE__ */ T.jsx(sY, { altText: n, asChild: !0, children: /* @__PURE__ */ T.jsx(jC, { ...r, ref: e }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${iY}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
aY.displayName = iY;
var oY = "ToastClose", jC = N.forwardRef(
  (t, e) => {
    const { __scopeToast: n, ...r } = t, i = c3t(oY, n);
    return /* @__PURE__ */ T.jsx(sY, { asChild: !0, children: /* @__PURE__ */ T.jsx(
      Ct.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: it(t.onClick, i.onClose)
      }
    ) });
  }
);
jC.displayName = oY;
var sY = N.forwardRef((t, e) => {
  const { __scopeToast: n, altText: r, ...i } = t;
  return /* @__PURE__ */ T.jsx(
    Ct.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...i,
      ref: e
    }
  );
});
function lY(t) {
  const e = [];
  return Array.from(t.childNodes).forEach((n) => {
    if (n.nodeType === n.TEXT_NODE && n.textContent && e.push(n.textContent), m3t(n)) {
      const r = n.ariaHidden || n.hidden || n.style.display === "none", i = n.dataset.radixToastAnnounceExclude === "";
      if (!r)
        if (i) {
          const a = n.dataset.radixToastAnnounceAlt;
          a && e.push(a);
        } else
          e.push(...lY(n));
    }
  }), e;
}
function Fm(t, e, n, { discrete: r }) {
  const i = n.originalEvent.currentTarget, a = new CustomEvent(t, { bubbles: !0, cancelable: !0, detail: n });
  e && i.addEventListener(t, e, { once: !0 }), r ? IF(i, a) : i.dispatchEvent(a);
}
var iD = (t, e, n = 0) => {
  const r = Math.abs(t.x), i = Math.abs(t.y), a = r > i;
  return e === "left" || e === "right" ? a && r > n : !a && i > n;
};
function p3t(t = () => {
}) {
  const e = Di(t);
  Fr(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(e)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [e]);
}
function m3t(t) {
  return t.nodeType === t.ELEMENT_NODE;
}
function y3t(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function K8(t) {
  const e = document.activeElement;
  return t.some((n) => n === e ? !0 : (n.focus(), document.activeElement !== e));
}
var cY = XG, uY = tY, dY = nY, fY = rY, hY = aY, pY = jC;
const g3t = ({ duration: t, variant: e }) => {
  const [n, r] = De(100);
  return ze(() => {
    const i = Date.now(), a = setInterval(() => {
      const o = Date.now() - i, s = Math.max(0, 100 - o / t * 100);
      r(s), s <= 0 && clearInterval(a);
    }, 16);
    return () => clearInterval(a);
  }, [t]), /* @__PURE__ */ T.jsx(
    Ru.div,
    {
      className: be("absolute bottom-2 left-0 right-0 h-1", {
        "color-bg-default": e === "default",
        "color-bg-default-inverse": e === "secondary",
        "color-bg-danger": e === "danger",
        "bg-green-700": e === "success"
      }),
      initial: { width: "100%" },
      animate: { width: `${n}%` },
      transition: { duration: 0, ease: "linear" }
    }
  );
}, v3t = N.forwardRef(({ className: t, position: e = "bottom-right", ...n }, r) => /* @__PURE__ */ T.jsx(
  cY,
  {
    ref: r,
    className: be(
      "fixed z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:flex-col md:max-w-[420px]",
      {
        "top-0 right-0": e === "top-right",
        "top-0 left-0": e === "top-left",
        "bottom-0 right-0": e === "bottom-right",
        "bottom-0 left-0": e === "bottom-left",
        "top-0 left-1/2 -translate-x-1/2": e === "center-top",
        "bottom-0 left-1/2 -translate-x-1/2": e === "center-bottom"
      },
      t
    ),
    ...n
  }
));
v3t.displayName = cY.displayName;
const b3t = Ha(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80",
  {
    variants: {
      variant: {
        default: "default group color-bg-default-inverse color-text-inverse dark:text-[#363B3F]",
        secondary: "secondary group color-bg-secondary color-text-default color-border-default",
        danger: "danger group color-bg-danger-light color-text-danger color-border-danger",
        success: "success group color-bg-success-light color-text-success color-border-default"
      },
      position: {
        "top-right": "data-[state=open]:slide-in-from-top-full data-[state=closed]:slide-out-to-right-full data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]",
        "top-left": "data-[state=open]:slide-in-from-top-full data-[state=closed]:slide-out-to-left-full data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]",
        "bottom-right": "data-[state=open]:slide-in-from-bottom-full data-[state=closed]:slide-out-to-right-full data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]",
        "bottom-left": "data-[state=open]:slide-in-from-bottom-full data-[state=closed]:slide-out-to-left-full data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]",
        "center-top": "data-[state=open]:slide-in-from-top-full data-[state=closed]:slide-out-to-top-full data-[swipe=cancel]:translate-y-0 data-[swipe=end]:translate-y-[var(--radix-toast-swipe-end-y)] data-[swipe=move]:translate-y-[var(--radix-toast-swipe-move-y)]",
        "center-bottom": "data-[state=open]:slide-in-from-bottom-full data-[state=closed]:slide-out-to-bottom-full data-[swipe=cancel]:translate-y-0 data-[swipe=end]:translate-y-[var(--radix-toast-swipe-end-y)] data-[swipe=move]:translate-y-[var(--radix-toast-swipe-move-y)]"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), w3t = N.forwardRef(({ className: t, variant: e, position: n, duration: r, hasIcon: i = !1, ...a }, o) => /* @__PURE__ */ T.jsxs(
  uY,
  {
    ref: o,
    className: be(b3t({ variant: e, position: n }), t),
    ...a,
    children: [
      i && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
        e === "danger" && /* @__PURE__ */ T.jsx(Ye, { name: "CircleX", className: "min-w-5 aspect-square" }),
        e === "success" && /* @__PURE__ */ T.jsx(Ye, { name: "CircleCheck", className: "min-w-5 aspect-square" }),
        e === "default" && /* @__PURE__ */ T.jsx(Ye, { name: "TriangleAlert", className: "min-w-5 aspect-square" }),
        e === "secondary" && /* @__PURE__ */ T.jsx(Ye, { name: "Info", className: "min-w-5 aspect-square" })
      ] }),
      a.children,
      /* @__PURE__ */ T.jsx(g3t, { duration: r || 3e3, variant: e || "default" })
    ]
  }
));
w3t.displayName = uY.displayName;
const k3t = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  hY,
  {
    ref: n,
    className: be(
      "inline-flex h-8 shrink-0 items-center justify-center rounded border bg-transparent px-3 text-body-sm ring-offset-transparent transition-colors disabled:pointer-events-none disabled:opacity-50 group-hover:brightness-95",
      "group-[.danger]:color-border-danger group-[.danger]:hover:color-bg-danger-light group-[.danger]:hover:color-text-danger",
      "group-[.success]:color-border-hover group-[.success]:hover:color-bg-success-light group-[.success]:hover:color-text-success",
      "group-[.secondary]:color-border-hover group-[.secondary]:hover:color-bg-secondary group-[.secondary]:hover:color-text-default",
      "group-[.default]:color-border-default group-[.default]:hover:color-bg-default-inverse group-[.default]:hover:color-text-inverse",
      t
    ),
    ...e
  }
));
k3t.displayName = hY.displayName;
const x3t = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  pY,
  {
    ref: n,
    className: be(
      "absolute right-2 top-2 rounded-md p-1 opacity-0 transition-opacity focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100",
      "group-[.default]:color-bg-default-inverse group-[.default]:color-text-inverse",
      "group-[.secondary]:color-bg-secondary group-[.secondary]:color-text-default group-[.secondary]:color-border-default",
      "group-[.danger]:color-bg-danger-light group-[.danger]:color-text-danger group-[.danger]:color-border-danger",
      "group-[.success]:color-bg-success-light group-[.success]:color-text-success group-[.success]:color-border-default",
      t
    ),
    "toast-close": "",
    ...e,
    children: /* @__PURE__ */ T.jsx(Ye, { name: "X", className: "w-4 h-4" })
  }
));
x3t.displayName = pY.displayName;
const M3t = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  dY,
  {
    ref: n,
    className: be("text-heading-xsm-bold", t),
    ...e
  }
));
M3t.displayName = dY.displayName;
const C3t = N.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ T.jsx(
  fY,
  {
    ref: n,
    className: be("text-body-sm opacity-90", t),
    ...e
  }
));
C3t.displayName = fY.displayName;
const A3t = 1, S3t = 1e6;
let $8 = 0;
function L3t() {
  return $8 = ($8 + 1) % Number.MAX_SAFE_INTEGER, $8.toString();
}
const J8 = /* @__PURE__ */ new Map(), aD = (t) => {
  if (J8.has(t))
    return;
  const e = setTimeout(() => {
    J8.delete(t), G4({
      type: "REMOVE_TOAST",
      toastId: t
    });
  }, S3t);
  J8.set(t, e);
}, T3t = (t, e) => {
  switch (e.type) {
    case "ADD_TOAST":
      return {
        ...t,
        toasts: [e.toast, ...t.toasts].slice(0, A3t)
      };
    case "UPDATE_TOAST":
      return {
        ...t,
        toasts: t.toasts.map(
          (n) => n.id === e.toast.id ? { ...n, ...e.toast } : n
        )
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = e;
      return n ? aD(n) : t.toasts.forEach((r) => {
        aD(r.id);
      }), {
        ...t,
        toasts: t.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return e.toastId === void 0 ? {
        ...t,
        toasts: []
      } : {
        ...t,
        toasts: t.toasts.filter((n) => n.id !== e.toastId)
      };
  }
}, E3t = [];
let Q8 = { toasts: [] };
function G4(t) {
  Q8 = T3t(Q8, t), E3t.forEach((e) => {
    e(Q8);
  });
}
function uu({ ...t }) {
  const e = L3t(), n = (i) => G4({
    type: "UPDATE_TOAST",
    toast: { ...i, id: e }
  }), r = () => G4({ type: "DISMISS_TOAST", toastId: e });
  return G4({
    type: "ADD_TOAST",
    toast: {
      ...t,
      id: e,
      open: !0,
      onOpenChange: (i) => {
        i || r();
      }
    }
  }), {
    id: e,
    dismiss: r,
    update: n
  };
}
xn({
  theme: "light",
  toggleTheme: () => null
});
const r0 = ({
  direction: t = "horizontal",
  size: e = "lg",
  className: n,
  ...r
}) => {
  const i = {
    sm: "divider-x-sm",
    md: "divider-x-md",
    lg: "divider-x-lg",
    xlg: "divider-x-xlg"
  }, a = {
    sm: "divider-y-sm",
    md: "divider-y-md",
    lg: "divider-y-lg",
    xlg: "divider-y-xlg"
  };
  return /* @__PURE__ */ T.jsx(
    "div",
    {
      className: be(
        {
          [`${i[e]} mx-auto w-4`]: t === "horizontal",
          [`${a[e]} my-auto h-4`]: t === "vertical"
        },
        n
      ),
      ...r
    }
  );
};
r0.displayName = "Divider";
var I9 = /* @__PURE__ */ ((t) => (t.LIST = "LIST", t.CARD = "CARD", t))(I9 || {});
const j3t = ({
  delay: t = 2e3
}) => {
  const [e, n] = De(!1), [r, i] = De(!1), a = Ue(null), o = nt(() => {
    a.current && clearTimeout(a.current), a.current = setTimeout(() => {
      n(!0), i(!0);
    }, t);
  }, [t]), s = nt(() => {
    r || n(!1), a.current && clearTimeout(a.current), i(!1);
  }, [r]), l = nt(() => n(!0), []), c = nt(() => n(!1), []), u = nt(() => o(), [o]), d = nt(() => s(), [s]);
  return {
    onMouseEnter: l,
    onMouseLeave: c,
    onTouchStart: u,
    onTouchEnd: d,
    isActive: e
  };
};
var st = /* @__PURE__ */ ((t) => (t[t.NONE = 0] = "NONE", t[t.HEADING = 1] = "HEADING", t[t.TEXT_COLOR = 2] = "TEXT_COLOR", t[t.HIGHLIGHT = 3] = "HIGHLIGHT", t[t.LINK = 4] = "LINK", t[t.FONT_FAMILY = 5] = "FONT_FAMILY", t[t.ALIGNMENT = 6] = "ALIGNMENT", t[t.LIST = 7] = "LIST", t[t.TEXT_FORMATING = 8] = "TEXT_FORMATING", t[t.TEXT_COLOR_PICKER = 9] = "TEXT_COLOR_PICKER", t[t.LINK_POPUP = 10] = "LINK_POPUP", t[t.SCRIPTS = 11] = "SCRIPTS", t))(st || {});
function N3t(t) {
  const [e, n] = De(t), r = Ue(null), i = (a) => {
    r && r.current && !r.current.contains(a.target) && n(
      0
      /* NONE */
    );
  };
  return ze(() => (document.addEventListener("click", i, !0), () => {
    document.removeEventListener("click", i, !0);
  }), []), { ref: r, toolVisibility: e, setToolVisibility: n };
}
var NC = R3t, DC = H3t, Po = [], ba = [], D3t = typeof Uint8Array < "u" ? Uint8Array : Array, X8 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var _0 = 0, I3t = X8.length; _0 < I3t; ++_0)
  Po[_0] = X8[_0], ba[X8.charCodeAt(_0)] = _0;
ba[45] = 62;
ba[95] = 63;
function P3t(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = t.indexOf("=");
  n === -1 && (n = e);
  var r = n === e ? 0 : 4 - n % 4;
  return [n, r];
}
function z3t(t, e, n) {
  return (e + n) * 3 / 4 - n;
}
function R3t(t) {
  var e, n = P3t(t), r = n[0], i = n[1], a = new D3t(z3t(t, r, i)), o = 0, s = i > 0 ? r - 4 : r, l;
  for (l = 0; l < s; l += 4)
    e = ba[t.charCodeAt(l)] << 18 | ba[t.charCodeAt(l + 1)] << 12 | ba[t.charCodeAt(l + 2)] << 6 | ba[t.charCodeAt(l + 3)], a[o++] = e >> 16 & 255, a[o++] = e >> 8 & 255, a[o++] = e & 255;
  return i === 2 && (e = ba[t.charCodeAt(l)] << 2 | ba[t.charCodeAt(l + 1)] >> 4, a[o++] = e & 255), i === 1 && (e = ba[t.charCodeAt(l)] << 10 | ba[t.charCodeAt(l + 1)] << 4 | ba[t.charCodeAt(l + 2)] >> 2, a[o++] = e >> 8 & 255, a[o++] = e & 255), a;
}
function O3t(t) {
  return Po[t >> 18 & 63] + Po[t >> 12 & 63] + Po[t >> 6 & 63] + Po[t & 63];
}
function B3t(t, e, n) {
  for (var r, i = [], a = e; a < n; a += 3)
    r = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (t[a + 2] & 255), i.push(O3t(r));
  return i.join("");
}
function H3t(t) {
  for (var e, n = t.length, r = n % 3, i = [], a = 16383, o = 0, s = n - r; o < s; o += a)
    i.push(B3t(t, o, o + a > s ? s : o + a));
  return r === 1 ? (e = t[n - 1], i.push(
    Po[e >> 2] + Po[e << 4 & 63] + "=="
  )) : r === 2 && (e = (t[n - 2] << 8) + t[n - 1], i.push(
    Po[e >> 10] + Po[e >> 4 & 63] + Po[e << 2 & 63] + "="
  )), i.join("");
}
const mY = (t) => NC(t).buffer, yY = (t) => {
  const e = new Uint8Array(t);
  return DC(e);
}, gY = async () => {
  const t = await window.crypto.subtle.generateKey(
    {
      name: "RSA-OAEP",
      modulusLength: 2048,
      publicExponent: new Uint8Array([1, 0, 1]),
      hash: "SHA-256"
    },
    !0,
    ["encrypt", "decrypt"]
  ), e = await window.crypto.subtle.exportKey(
    "spki",
    t.publicKey
  ), n = await window.crypto.subtle.exportKey(
    "pkcs8",
    t.privateKey
  );
  return {
    publicKey: e,
    privateKey: new Uint8Array(n)
  };
}, F3t = async (t, e) => {
  const n = mY(t), r = await crypto.subtle.importKey(
    "pkcs8",
    e,
    {
      name: "RSA-OAEP",
      hash: { name: "SHA-256" }
    },
    !0,
    ["decrypt"]
  );
  return await crypto.subtle.decrypt(
    {
      name: "RSA-OAEP"
    },
    r,
    n
  );
}, _3t = async (t, e, n) => {
  const r = mY(n), i = await crypto.subtle.importKey(
    "raw",
    e,
    {
      name: "AES-CBC"
    },
    !0,
    ["decrypt"]
  );
  return await crypto.subtle.decrypt(
    {
      name: "AES-CBC",
      iv: r
    },
    i,
    t
  );
}, vY = async (t) => {
  try {
    const e = await fetch(t);
    if (!(e != null && e.ok)) {
      console.error("Failed to fetch image: ", e.statusText);
      return;
    }
    return await e.arrayBuffer();
  } catch (e) {
    console.error("Error during image fetch: ", e);
  }
}, bY = async ({
  encryptedKey: t,
  privateKey: e,
  iv: n,
  imageBuffer: r
}) => {
  try {
    const i = await F3t(t, e);
    return await _3t(r, i, n);
  } catch (i) {
    console.error("Error decrypting and displaying the image:", i);
  }
}, ih = new tn("upload-image"), V3t = () => new Wt({
  key: ih,
  state: {
    init() {
      return vn.empty;
    },
    apply(t, e) {
      e = e.map(t.mapping, t.doc);
      const n = t.getMeta(this);
      if (n && n.add) {
        const { id: r, pos: i, content: a } = n.add, o = document.createElement("div");
        o.setAttribute("class", "img-placeholder"), o.textContent = a;
        const s = hr.widget(i + 1, o, {
          id: r
        });
        e = e.add(t.doc, [s]);
      } else n && n.remove && (e = e.remove(
        e.find(
          void 0,
          void 0,
          (r) => r.id == n.remove.id
        )
      ));
      return e;
    }
  },
  props: {
    decorations(t) {
      return this.getState(t);
    }
  }
});
function oD(t, e) {
  const r = ih.getState(t).find(null, null, (i) => i.id == e);
  return r.length ? r[0].from : null;
}
async function e2(t, e, n, r) {
  try {
    if (!t.type.includes("image/")) {
      console.log("file is not an image");
      return;
    }
    const i = {}, a = e.state.tr;
    a.selection.empty || a.deleteSelection(), a.setMeta(ih, {
      add: {
        id: i,
        pos: n - 1,
        content: "Uploading image..."
      }
    }), e.dispatch(a);
    const { schema: o } = e.state;
    if (!oD(e.state, i)) return;
    if (r) {
      const { publicKey: l, privateKey: c } = await gY(), { key: u, url: d, iv: f } = await wY(
        r,
        t,
        l
      ), h = o.nodes.resizableMedia.create({
        encryptedKey: u,
        url: d,
        iv: f,
        privateKey: DC(c),
        "media-type": "secure-img",
        width: "100%",
        height: "auto"
      }), p = e.state.tr.replaceWith(n - 2, n + h.nodeSize, h).setMeta(ih, { remove: { id: i } });
      e.dispatch(p);
    } else {
      const l = new FileReader();
      l.readAsDataURL(t), l.onloadend = () => {
        const { schema: c } = e.state, u = oD(e.state, i);
        if (!u) return;
        const d = l.result, f = c.nodes.resizableMedia.create({
          src: d,
          "media-type": "img"
        }), h = e.state.tr.replaceWith(u - 2, u + f.nodeSize, f).setMeta(ih, { remove: { id: i } });
        e.dispatch(h);
      };
    }
  } catch (i) {
    console.error("Error during image upload: ", i);
  }
}
const q3t = async (t) => {
  const e = new FileReader();
  e.readAsDataURL(t);
  const n = qs.Extended;
  if (t.size > n.maxSize)
    throw e.abort(), new Error(n.errorMsg);
  return await new Promise((i) => {
    e.onload = () => {
      i(e.result);
    };
  });
}, wY = async (t, e, n) => {
  try {
    const r = yY(n), i = new FormData();
    i.append("file", e), i.append("publicKey", r);
    const a = await fetch(t, {
      method: "POST",
      body: i
    });
    return a != null && a.ok || console.error("Failed to upload file", a.statusText), await a.json();
  } catch (r) {
    console.error("Error during image upload: ", r);
  }
}, U3t = ({
  title: t,
  content: e,
  isOpen: n,
  setIsOpen: r,
  contentClassName: i,
  onCloseAutoFocus: a
}) => /* @__PURE__ */ C.jsx(kp, { open: n, onOpenChange: r, children: /* @__PURE__ */ C.jsxs(
  l6,
  {
    className: "w-full z-20",
    onCloseAutoFocus: a,
    children: [
      /* @__PURE__ */ C.jsx(c6, { className: "p-4", children: /* @__PURE__ */ C.jsxs(u6, { className: "flex justify-between items-center text-left sm:text-center text-base", children: [
        t,
        /* @__PURE__ */ C.jsx(s6, { children: /* @__PURE__ */ C.jsx(Ye, { name: "X", size: "sm" }) })
      ] }) }),
      /* @__PURE__ */ C.jsx(
        "div",
        {
          className: Lt(
            "flex flex-col gap-4 w-full h-full pb-4 text-base color-text-default",
            i
          ),
          children: e && e
        }
      )
    ]
  }
) });
function W3t(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function sD(t) {
  return W3t(t) || Array.isArray(t);
}
function Z3t() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function IC(t, e) {
  const n = Object.keys(t), r = Object.keys(e);
  if (n.length !== r.length) return !1;
  const i = JSON.stringify(Object.keys(t.breakpoints || {})), a = JSON.stringify(Object.keys(e.breakpoints || {}));
  return i !== a ? !1 : n.every((o) => {
    const s = t[o], l = e[o];
    return typeof s == "function" ? `${s}` == `${l}` : !sD(s) || !sD(l) ? s === l : IC(s, l);
  });
}
function lD(t) {
  return t.concat().sort((e, n) => e.name > n.name ? 1 : -1).map((e) => e.options);
}
function G3t(t, e) {
  if (t.length !== e.length) return !1;
  const n = lD(t), r = lD(e);
  return n.every((i, a) => {
    const o = r[a];
    return IC(i, o);
  });
}
function PC(t) {
  return typeof t == "number";
}
function P9(t) {
  return typeof t == "string";
}
function I6(t) {
  return typeof t == "boolean";
}
function cD(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Fn(t) {
  return Math.abs(t);
}
function zC(t) {
  return Math.sign(t);
}
function ah(t, e) {
  return Fn(t - e);
}
function Y3t(t, e) {
  if (t === 0 || e === 0 || Fn(t) <= Fn(e)) return 0;
  const n = ah(Fn(t), Fn(e));
  return Fn(n / t);
}
function K3t(t) {
  return Math.round(t * 100) / 100;
}
function t2(t) {
  return n2(t).map(Number);
}
function to(t) {
  return t[jp(t)];
}
function jp(t) {
  return Math.max(0, t.length - 1);
}
function RC(t, e) {
  return e === jp(t);
}
function uD(t, e = 0) {
  return Array.from(Array(t), (n, r) => e + r);
}
function n2(t) {
  return Object.keys(t);
}
function kY(t, e) {
  return [t, e].reduce((n, r) => (n2(r).forEach((i) => {
    const a = n[i], o = r[i], s = cD(a) && cD(o);
    n[i] = s ? kY(a, o) : o;
  }), n), {});
}
function z9(t, e) {
  return typeof e.MouseEvent < "u" && t instanceof e.MouseEvent;
}
function $3t(t, e) {
  const n = {
    start: r,
    center: i,
    end: a
  };
  function r() {
    return 0;
  }
  function i(l) {
    return a(l) / 2;
  }
  function a(l) {
    return e - l;
  }
  function o(l, c) {
    return P9(t) ? n[t](l) : t(e, l, c);
  }
  return {
    measure: o
  };
}
function r2() {
  let t = [];
  function e(i, a, o, s = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in i)
      i.addEventListener(a, o, s), l = () => i.removeEventListener(a, o, s);
    else {
      const c = i;
      c.addListener(o), l = () => c.removeListener(o);
    }
    return t.push(l), r;
  }
  function n() {
    t = t.filter((i) => i());
  }
  const r = {
    add: e,
    clear: n
  };
  return r;
}
function J3t(t, e, n, r) {
  const i = r2(), a = 1e3 / 60;
  let o = null, s = 0, l = 0;
  function c() {
    i.add(t, "visibilitychange", () => {
      t.hidden && p();
    });
  }
  function u() {
    h(), i.clear();
  }
  function d(g) {
    if (!l) return;
    o || (o = g, n(), n());
    const v = g - o;
    for (o = g, s += v; s >= a; )
      n(), s -= a;
    const k = s / a;
    r(k), l && (l = e.requestAnimationFrame(d));
  }
  function f() {
    l || (l = e.requestAnimationFrame(d));
  }
  function h() {
    e.cancelAnimationFrame(l), o = null, s = 0, l = 0;
  }
  function p() {
    o = null, s = 0;
  }
  return {
    init: c,
    destroy: u,
    start: f,
    stop: h,
    update: n,
    render: r
  };
}
function Q3t(t, e) {
  const n = e === "rtl", r = t === "y", i = r ? "y" : "x", a = r ? "x" : "y", o = !r && n ? -1 : 1, s = u(), l = d();
  function c(p) {
    const {
      height: m,
      width: g
    } = p;
    return r ? m : g;
  }
  function u() {
    return r ? "top" : n ? "right" : "left";
  }
  function d() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function f(p) {
    return p * o;
  }
  return {
    scroll: i,
    cross: a,
    startEdge: s,
    endEdge: l,
    measureSize: c,
    direction: f
  };
}
function i0(t = 0, e = 0) {
  const n = Fn(t - e);
  function r(c) {
    return c < t;
  }
  function i(c) {
    return c > e;
  }
  function a(c) {
    return r(c) || i(c);
  }
  function o(c) {
    return a(c) ? r(c) ? t : e : c;
  }
  function s(c) {
    return n ? c - n * Math.ceil((c - e) / n) : c;
  }
  return {
    length: n,
    max: e,
    min: t,
    constrain: o,
    reachedAny: a,
    reachedMax: i,
    reachedMin: r,
    removeOffset: s
  };
}
function xY(t, e, n) {
  const {
    constrain: r
  } = i0(0, t), i = t + 1;
  let a = o(e);
  function o(f) {
    return n ? Fn((i + f) % i) : r(f);
  }
  function s() {
    return a;
  }
  function l(f) {
    return a = o(f), d;
  }
  function c(f) {
    return u().set(s() + f);
  }
  function u() {
    return xY(t, s(), n);
  }
  const d = {
    get: s,
    set: l,
    add: c,
    clone: u
  };
  return d;
}
function X3t(t, e, n, r, i, a, o, s, l, c, u, d, f, h, p, m, g, v, k) {
  const {
    cross: w,
    direction: b
  } = t, x = ["INPUT", "SELECT", "TEXTAREA"], A = {
    passive: !1
  }, L = r2(), M = r2(), j = i0(50, 225).constrain(h.measure(20)), D = {
    mouse: 300,
    touch: 400
  }, z = {
    mouse: 500,
    touch: 600
  }, H = p ? 43 : 25;
  let V = !1, F = 0, _ = 0, W = !1, G = !1, Y = !1, Z = !1;
  function oe(he) {
    if (!k) return;
    function pe(K) {
      (I6(k) || k(he, K)) && $(K);
    }
    const J = e;
    L.add(J, "dragstart", (K) => K.preventDefault(), A).add(J, "touchmove", () => {
    }, A).add(J, "touchend", () => {
    }).add(J, "touchstart", pe).add(J, "mousedown", pe).add(J, "touchcancel", xe).add(J, "contextmenu", xe).add(J, "click", Oe, !0);
  }
  function ee() {
    L.clear(), M.clear();
  }
  function ae() {
    const he = Z ? n : e;
    M.add(he, "touchmove", se, A).add(he, "touchend", xe).add(he, "mousemove", se, A).add(he, "mouseup", xe);
  }
  function fe(he) {
    const pe = he.nodeName || "";
    return x.includes(pe);
  }
  function me() {
    return (p ? z : D)[Z ? "mouse" : "touch"];
  }
  function ge(he, pe) {
    const J = d.add(zC(he) * -1), K = u.byDistance(he, !p).distance;
    return p || Fn(he) < j ? K : g && pe ? K * 0.5 : u.byIndex(J.get(), 0).distance;
  }
  function $(he) {
    const pe = z9(he, r);
    Z = pe, Y = p && pe && !he.buttons && V, V = ah(i.get(), o.get()) >= 2, !(pe && he.button !== 0) && (fe(he.target) || (W = !0, a.pointerDown(he), c.useFriction(0).useDuration(0), i.set(o), ae(), F = a.readPoint(he), _ = a.readPoint(he, w), f.emit("pointerDown")));
  }
  function se(he) {
    if (!z9(he, r) && he.touches.length >= 2) return xe(he);
    const J = a.readPoint(he), K = a.readPoint(he, w), X = ah(J, F), re = ah(K, _);
    if (!G && !Z && (!he.cancelable || (G = X > re, !G)))
      return xe(he);
    const Ie = a.pointerMove(he);
    X > m && (Y = !0), c.useFriction(0.3).useDuration(0.75), s.start(), i.add(b(Ie)), he.preventDefault();
  }
  function xe(he) {
    const J = u.byDistance(0, !1).index !== d.get(), K = a.pointerUp(he) * me(), X = ge(b(K), J), re = Y3t(K, X), Ie = H - 10 * re, q = v + re / 50;
    G = !1, W = !1, M.clear(), c.useDuration(Ie).useFriction(q), l.distance(X, !p), Z = !1, f.emit("pointerUp");
  }
  function Oe(he) {
    Y && (he.stopPropagation(), he.preventDefault(), Y = !1);
  }
  function je() {
    return W;
  }
  return {
    init: oe,
    destroy: ee,
    pointerDown: je
  };
}
function egt(t, e) {
  let r, i;
  function a(d) {
    return d.timeStamp;
  }
  function o(d, f) {
    const p = `client${(f || t.scroll) === "x" ? "X" : "Y"}`;
    return (z9(d, e) ? d : d.touches[0])[p];
  }
  function s(d) {
    return r = d, i = d, o(d);
  }
  function l(d) {
    const f = o(d) - o(i), h = a(d) - a(r) > 170;
    return i = d, h && (r = d), f;
  }
  function c(d) {
    if (!r || !i) return 0;
    const f = o(i) - o(r), h = a(d) - a(r), p = a(d) - a(i) > 170, m = f / h;
    return h && !p && Fn(m) > 0.1 ? m : 0;
  }
  return {
    pointerDown: s,
    pointerMove: l,
    pointerUp: c,
    readPoint: o
  };
}
function tgt() {
  function t(n) {
    const {
      offsetTop: r,
      offsetLeft: i,
      offsetWidth: a,
      offsetHeight: o
    } = n;
    return {
      top: r,
      right: i + a,
      bottom: r + o,
      left: i,
      width: a,
      height: o
    };
  }
  return {
    measure: t
  };
}
function ngt(t) {
  function e(r) {
    return t * (r / 100);
  }
  return {
    measure: e
  };
}
function rgt(t, e, n, r, i, a, o) {
  const s = [t].concat(r);
  let l, c, u = [], d = !1;
  function f(g) {
    return i.measureSize(o.measure(g));
  }
  function h(g) {
    if (!a) return;
    c = f(t), u = r.map(f);
    function v(k) {
      for (const w of k) {
        if (d) return;
        const b = w.target === t, x = r.indexOf(w.target), A = b ? c : u[x], L = f(b ? t : r[x]);
        if (Fn(L - A) >= 0.5) {
          g.reInit(), e.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((k) => {
      (I6(a) || a(g, k)) && v(k);
    }), n.requestAnimationFrame(() => {
      s.forEach((k) => l.observe(k));
    });
  }
  function p() {
    d = !0, l && l.disconnect();
  }
  return {
    init: h,
    destroy: p
  };
}
function igt(t, e, n, r, i, a) {
  let o = 0, s = 0, l = i, c = a, u = t.get(), d = 0;
  function f() {
    const A = r.get() - t.get(), L = !l;
    let M = 0;
    return L ? (o = 0, n.set(r), t.set(r), M = A) : (n.set(t), o += A / l, o *= c, u += o, t.add(o), M = u - d), s = zC(M), d = u, x;
  }
  function h() {
    const A = r.get() - e.get();
    return Fn(A) < 1e-3;
  }
  function p() {
    return l;
  }
  function m() {
    return s;
  }
  function g() {
    return o;
  }
  function v() {
    return w(i);
  }
  function k() {
    return b(a);
  }
  function w(A) {
    return l = A, x;
  }
  function b(A) {
    return c = A, x;
  }
  const x = {
    direction: m,
    duration: p,
    velocity: g,
    seek: f,
    settled: h,
    useBaseFriction: k,
    useBaseDuration: v,
    useFriction: b,
    useDuration: w
  };
  return x;
}
function agt(t, e, n, r, i) {
  const a = i.measure(10), o = i.measure(50), s = i0(0.1, 0.99);
  let l = !1;
  function c() {
    return !(l || !t.reachedAny(n.get()) || !t.reachedAny(e.get()));
  }
  function u(h) {
    if (!c()) return;
    const p = t.reachedMin(e.get()) ? "min" : "max", m = Fn(t[p] - e.get()), g = n.get() - e.get(), v = s.constrain(m / o);
    n.subtract(g * v), !h && Fn(g) < a && (n.set(t.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function d(h) {
    l = !h;
  }
  return {
    shouldConstrain: c,
    constrain: u,
    toggleActive: d
  };
}
function ogt(t, e, n, r, i) {
  const a = i0(-e + t, 0), o = d(), s = u(), l = f();
  function c(p, m) {
    return ah(p, m) <= 1;
  }
  function u() {
    const p = o[0], m = to(o), g = o.lastIndexOf(p), v = o.indexOf(m) + 1;
    return i0(g, v);
  }
  function d() {
    return n.map((p, m) => {
      const {
        min: g,
        max: v
      } = a, k = a.constrain(p), w = !m, b = RC(n, m);
      return w ? v : b || c(g, k) ? g : c(v, k) ? v : k;
    }).map((p) => parseFloat(p.toFixed(3)));
  }
  function f() {
    if (e <= t + i) return [a.max];
    if (r === "keepSnaps") return o;
    const {
      min: p,
      max: m
    } = s;
    return o.slice(p, m);
  }
  return {
    snapsContained: l,
    scrollContainLimit: s
  };
}
function sgt(t, e, n) {
  const r = e[0], i = n ? r - t : to(e);
  return {
    limit: i0(i, r)
  };
}
function lgt(t, e, n, r) {
  const a = e.min + 0.1, o = e.max + 0.1, {
    reachedMin: s,
    reachedMax: l
  } = i0(a, o);
  function c(f) {
    return f === 1 ? l(n.get()) : f === -1 ? s(n.get()) : !1;
  }
  function u(f) {
    if (!c(f)) return;
    const h = t * (f * -1);
    r.forEach((p) => p.add(h));
  }
  return {
    loop: u
  };
}
function cgt(t) {
  const {
    max: e,
    length: n
  } = t;
  function r(a) {
    const o = a - e;
    return n ? o / -n : 0;
  }
  return {
    get: r
  };
}
function ugt(t, e, n, r, i) {
  const {
    startEdge: a,
    endEdge: o
  } = t, {
    groupSlides: s
  } = i, l = d().map(e.measure), c = f(), u = h();
  function d() {
    return s(r).map((m) => to(m)[o] - m[0][a]).map(Fn);
  }
  function f() {
    return r.map((m) => n[a] - m[a]).map((m) => -Fn(m));
  }
  function h() {
    return s(c).map((m) => m[0]).map((m, g) => m + l[g]);
  }
  return {
    snaps: c,
    snapsAligned: u
  };
}
function dgt(t, e, n, r, i, a) {
  const {
    groupSlides: o
  } = i, {
    min: s,
    max: l
  } = r, c = u();
  function u() {
    const f = o(a), h = !t || e === "keepSnaps";
    return n.length === 1 ? [a] : h ? f : f.slice(s, l).map((p, m, g) => {
      const v = !m, k = RC(g, m);
      if (v) {
        const w = to(g[0]) + 1;
        return uD(w);
      }
      if (k) {
        const w = jp(a) - to(g)[0] + 1;
        return uD(w, to(g)[0]);
      }
      return p;
    });
  }
  return {
    slideRegistry: c
  };
}
function fgt(t, e, n, r, i) {
  const {
    reachedAny: a,
    removeOffset: o,
    constrain: s
  } = r;
  function l(p) {
    return p.concat().sort((m, g) => Fn(m) - Fn(g))[0];
  }
  function c(p) {
    const m = t ? o(p) : s(p), g = e.map((k, w) => ({
      diff: u(k - m, 0),
      index: w
    })).sort((k, w) => Fn(k.diff) - Fn(w.diff)), {
      index: v
    } = g[0];
    return {
      index: v,
      distance: m
    };
  }
  function u(p, m) {
    const g = [p, p + n, p - n];
    if (!t) return p;
    if (!m) return l(g);
    const v = g.filter((k) => zC(k) === m);
    return v.length ? l(v) : to(g) - n;
  }
  function d(p, m) {
    const g = e[p] - i.get(), v = u(g, m);
    return {
      index: p,
      distance: v
    };
  }
  function f(p, m) {
    const g = i.get() + p, {
      index: v,
      distance: k
    } = c(g), w = !t && a(g);
    if (!m || w) return {
      index: v,
      distance: p
    };
    const b = e[v] - k, x = p + u(b, 0);
    return {
      index: v,
      distance: x
    };
  }
  return {
    byDistance: f,
    byIndex: d,
    shortcut: u
  };
}
function hgt(t, e, n, r, i, a, o) {
  function s(d) {
    const f = d.distance, h = d.index !== e.get();
    a.add(f), f && (r.duration() ? t.start() : (t.update(), t.render(1), t.update())), h && (n.set(e.get()), e.set(d.index), o.emit("select"));
  }
  function l(d, f) {
    const h = i.byDistance(d, f);
    s(h);
  }
  function c(d, f) {
    const h = e.clone().set(d), p = i.byIndex(h.get(), f);
    s(p);
  }
  return {
    distance: l,
    index: c
  };
}
function pgt(t, e, n, r, i, a, o, s) {
  const l = {
    passive: !0,
    capture: !0
  };
  let c = 0;
  function u(h) {
    if (!s) return;
    function p(m) {
      if ((/* @__PURE__ */ new Date()).getTime() - c > 10) return;
      o.emit("slideFocusStart"), t.scrollLeft = 0;
      const k = n.findIndex((w) => w.includes(m));
      PC(k) && (i.useDuration(0), r.index(k, 0), o.emit("slideFocus"));
    }
    a.add(document, "keydown", d, !1), e.forEach((m, g) => {
      a.add(m, "focus", (v) => {
        (I6(s) || s(h, v)) && p(g);
      }, l);
    });
  }
  function d(h) {
    h.code === "Tab" && (c = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: u
  };
}
function Rf(t) {
  let e = t;
  function n() {
    return e;
  }
  function r(l) {
    e = o(l);
  }
  function i(l) {
    e += o(l);
  }
  function a(l) {
    e -= o(l);
  }
  function o(l) {
    return PC(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: i,
    subtract: a
  };
}
function MY(t, e) {
  const n = t.scroll === "x" ? o : s, r = e.style;
  let i = null, a = !1;
  function o(f) {
    return `translate3d(${f}px,0px,0px)`;
  }
  function s(f) {
    return `translate3d(0px,${f}px,0px)`;
  }
  function l(f) {
    if (a) return;
    const h = K3t(t.direction(f));
    h !== i && (r.transform = n(h), i = h);
  }
  function c(f) {
    a = !f;
  }
  function u() {
    a || (r.transform = "", e.getAttribute("style") || e.removeAttribute("style"));
  }
  return {
    clear: u,
    to: l,
    toggleActive: c
  };
}
function mgt(t, e, n, r, i, a, o, s, l) {
  const u = t2(i), d = t2(i).reverse(), f = v().concat(k());
  function h(L, M) {
    return L.reduce((j, D) => j - i[D], M);
  }
  function p(L, M) {
    return L.reduce((j, D) => h(j, M) > 0 ? j.concat([D]) : j, []);
  }
  function m(L) {
    return a.map((M, j) => ({
      start: M - r[j] + 0.5 + L,
      end: M + e - 0.5 + L
    }));
  }
  function g(L, M, j) {
    const D = m(M);
    return L.map((z) => {
      const H = j ? 0 : -n, V = j ? n : 0, F = j ? "end" : "start", _ = D[z][F];
      return {
        index: z,
        loopPoint: _,
        slideLocation: Rf(-1),
        translate: MY(t, l[z]),
        target: () => s.get() > _ ? H : V
      };
    });
  }
  function v() {
    const L = o[0], M = p(d, L);
    return g(M, n, !1);
  }
  function k() {
    const L = e - o[0] - 1, M = p(u, L);
    return g(M, -n, !0);
  }
  function w() {
    return f.every(({
      index: L
    }) => {
      const M = u.filter((j) => j !== L);
      return h(M, e) <= 0.1;
    });
  }
  function b() {
    f.forEach((L) => {
      const {
        target: M,
        translate: j,
        slideLocation: D
      } = L, z = M();
      z !== D.get() && (j.to(z), D.set(z));
    });
  }
  function x() {
    f.forEach((L) => L.translate.clear());
  }
  return {
    canLoop: w,
    clear: x,
    loop: b,
    loopPoints: f
  };
}
function ygt(t, e, n) {
  let r, i = !1;
  function a(l) {
    if (!n) return;
    function c(u) {
      for (const d of u)
        if (d.type === "childList") {
          l.reInit(), e.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((u) => {
      i || (I6(n) || n(l, u)) && c(u);
    }), r.observe(t, {
      childList: !0
    });
  }
  function o() {
    r && r.disconnect(), i = !0;
  }
  return {
    init: a,
    destroy: o
  };
}
function ggt(t, e, n, r) {
  const i = {};
  let a = null, o = null, s, l = !1;
  function c() {
    s = new IntersectionObserver((p) => {
      l || (p.forEach((m) => {
        const g = e.indexOf(m.target);
        i[g] = m;
      }), a = null, o = null, n.emit("slidesInView"));
    }, {
      root: t.parentElement,
      threshold: r
    }), e.forEach((p) => s.observe(p));
  }
  function u() {
    s && s.disconnect(), l = !0;
  }
  function d(p) {
    return n2(i).reduce((m, g) => {
      const v = parseInt(g), {
        isIntersecting: k
      } = i[v];
      return (p && k || !p && !k) && m.push(v), m;
    }, []);
  }
  function f(p = !0) {
    if (p && a) return a;
    if (!p && o) return o;
    const m = d(p);
    return p && (a = m), p || (o = m), m;
  }
  return {
    init: c,
    destroy: u,
    get: f
  };
}
function vgt(t, e, n, r, i, a) {
  const {
    measureSize: o,
    startEdge: s,
    endEdge: l
  } = t, c = n[0] && i, u = p(), d = m(), f = n.map(o), h = g();
  function p() {
    if (!c) return 0;
    const k = n[0];
    return Fn(e[s] - k[s]);
  }
  function m() {
    if (!c) return 0;
    const k = a.getComputedStyle(to(r));
    return parseFloat(k.getPropertyValue(`margin-${l}`));
  }
  function g() {
    return n.map((k, w, b) => {
      const x = !w, A = RC(b, w);
      return x ? f[w] + u : A ? f[w] + d : b[w + 1][s] - k[s];
    }).map(Fn);
  }
  return {
    slideSizes: f,
    slideSizesWithGaps: h,
    startGap: u,
    endGap: d
  };
}
function bgt(t, e, n, r, i, a, o, s, l) {
  const {
    startEdge: c,
    endEdge: u,
    direction: d
  } = t, f = PC(n);
  function h(v, k) {
    return t2(v).filter((w) => w % k === 0).map((w) => v.slice(w, w + k));
  }
  function p(v) {
    return v.length ? t2(v).reduce((k, w, b) => {
      const x = to(k) || 0, A = x === 0, L = w === jp(v), M = i[c] - a[x][c], j = i[c] - a[w][u], D = !r && A ? d(o) : 0, z = !r && L ? d(s) : 0, H = Fn(j - z - (M + D));
      return b && H > e + l && k.push(w), L && k.push(v.length), k;
    }, []).map((k, w, b) => {
      const x = Math.max(b[w - 1] || 0);
      return v.slice(x, k);
    }) : [];
  }
  function m(v) {
    return f ? h(v, n) : p(v);
  }
  return {
    groupSlides: m
  };
}
function wgt(t, e, n, r, i, a, o) {
  const {
    align: s,
    axis: l,
    direction: c,
    startIndex: u,
    loop: d,
    duration: f,
    dragFree: h,
    dragThreshold: p,
    inViewThreshold: m,
    slidesToScroll: g,
    skipSnaps: v,
    containScroll: k,
    watchResize: w,
    watchSlides: b,
    watchDrag: x,
    watchFocus: A
  } = a, L = 2, M = tgt(), j = M.measure(e), D = n.map(M.measure), z = Q3t(l, c), H = z.measureSize(j), V = ngt(H), F = $3t(s, H), _ = !d && !!k, W = d || !!k, {
    slideSizes: G,
    slideSizesWithGaps: Y,
    startGap: Z,
    endGap: oe
  } = vgt(z, j, D, n, W, i), ee = bgt(z, H, g, d, j, D, Z, oe, L), {
    snaps: ae,
    snapsAligned: fe
  } = ugt(z, F, j, D, ee), me = -to(ae) + to(Y), {
    snapsContained: ge,
    scrollContainLimit: $
  } = ogt(H, me, fe, k, L), se = _ ? ge : fe, {
    limit: xe
  } = sgt(me, se, d), Oe = xY(jp(se), u, d), je = Oe.clone(), Me = t2(n), he = ({
    dragHandler: Ke,
    scrollBody: mt,
    scrollBounds: pt,
    options: {
      loop: Nt
    }
  }) => {
    Nt || pt.constrain(Ke.pointerDown()), mt.seek();
  }, pe = ({
    scrollBody: Ke,
    translate: mt,
    location: pt,
    offsetLocation: Nt,
    previousLocation: ye,
    scrollLooper: _e,
    slideLooper: we,
    dragHandler: $e,
    animation: Xe,
    eventHandler: Be,
    scrollBounds: et,
    options: {
      loop: dt
    }
  }, ut) => {
    const Pt = Ke.settled(), Vt = !et.shouldConstrain(), kt = dt ? Pt : Pt && Vt;
    kt && !$e.pointerDown() && (Xe.stop(), Be.emit("settle")), kt || Be.emit("scroll");
    const sn = pt.get() * ut + ye.get() * (1 - ut);
    Nt.set(sn), dt && (_e.loop(Ke.direction()), we.loop()), mt.to(Nt.get());
  }, J = J3t(r, i, () => he(Re), (Ke) => pe(Re, Ke)), K = 0.68, X = se[Oe.get()], re = Rf(X), Ie = Rf(X), q = Rf(X), S = Rf(X), P = igt(re, q, Ie, S, f, K), O = fgt(d, se, me, xe, S), ne = hgt(J, Oe, je, P, O, S, o), le = cgt(xe), de = r2(), Pe = ggt(e, n, o, m), {
    slideRegistry: ve
  } = dgt(_, k, se, $, ee, Me), Le = pgt(t, n, ve, ne, P, de, o, A), Re = {
    ownerDocument: r,
    ownerWindow: i,
    eventHandler: o,
    containerRect: j,
    slideRects: D,
    animation: J,
    axis: z,
    dragHandler: X3t(z, t, r, i, S, egt(z, i), re, J, ne, P, O, Oe, o, V, h, p, v, K, x),
    eventStore: de,
    percentOfView: V,
    index: Oe,
    indexPrevious: je,
    limit: xe,
    location: re,
    offsetLocation: q,
    previousLocation: Ie,
    options: a,
    resizeHandler: rgt(e, o, i, n, z, w, M),
    scrollBody: P,
    scrollBounds: agt(xe, q, S, P, V),
    scrollLooper: lgt(me, xe, q, [re, q, Ie, S]),
    scrollProgress: le,
    scrollSnapList: se.map(le.get),
    scrollSnaps: se,
    scrollTarget: O,
    scrollTo: ne,
    slideLooper: mgt(z, H, me, G, Y, ae, se, q, n),
    slideFocus: Le,
    slidesHandler: ygt(e, o, b),
    slidesInView: Pe,
    slideIndexes: Me,
    slideRegistry: ve,
    slidesToScroll: ee,
    target: S,
    translate: MY(z, e)
  };
  return Re;
}
function kgt() {
  let t = {}, e;
  function n(c) {
    e = c;
  }
  function r(c) {
    return t[c] || [];
  }
  function i(c) {
    return r(c).forEach((u) => u(e, c)), l;
  }
  function a(c, u) {
    return t[c] = r(c).concat([u]), l;
  }
  function o(c, u) {
    return t[c] = r(c).filter((d) => d !== u), l;
  }
  function s() {
    t = {};
  }
  const l = {
    init: n,
    emit: i,
    off: o,
    on: a,
    clear: s
  };
  return l;
}
const xgt = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Mgt(t) {
  function e(a, o) {
    return kY(a, o || {});
  }
  function n(a) {
    const o = a.breakpoints || {}, s = n2(o).filter((l) => t.matchMedia(l).matches).map((l) => o[l]).reduce((l, c) => e(l, c), {});
    return e(a, s);
  }
  function r(a) {
    return a.map((o) => n2(o.breakpoints || {})).reduce((o, s) => o.concat(s), []).map(t.matchMedia);
  }
  return {
    mergeOptions: e,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function Cgt(t) {
  let e = [];
  function n(a, o) {
    return e = o.filter(({
      options: s
    }) => t.optionsAtMedia(s).active !== !1), e.forEach((s) => s.init(a, t)), o.reduce((s, l) => Object.assign(s, {
      [l.name]: l
    }), {});
  }
  function r() {
    e = e.filter((a) => a.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function Yy(t, e, n) {
  const r = t.ownerDocument, i = r.defaultView, a = Mgt(i), o = Cgt(a), s = r2(), l = kgt(), {
    mergeOptions: c,
    optionsAtMedia: u,
    optionsMediaQueries: d
  } = a, {
    on: f,
    off: h,
    emit: p
  } = l, m = z;
  let g = !1, v, k = c(xgt, Yy.globalOptions), w = c(k), b = [], x, A, L;
  function M() {
    const {
      container: Me,
      slides: he
    } = w;
    A = (P9(Me) ? t.querySelector(Me) : Me) || t.children[0];
    const J = P9(he) ? A.querySelectorAll(he) : he;
    L = [].slice.call(J || A.children);
  }
  function j(Me) {
    const he = wgt(t, A, L, r, i, Me, l);
    if (Me.loop && !he.slideLooper.canLoop()) {
      const pe = Object.assign({}, Me, {
        loop: !1
      });
      return j(pe);
    }
    return he;
  }
  function D(Me, he) {
    g || (k = c(k, Me), w = u(k), b = he || b, M(), v = j(w), d([k, ...b.map(({
      options: pe
    }) => pe)]).forEach((pe) => s.add(pe, "change", z)), w.active && (v.translate.to(v.location.get()), v.animation.init(), v.slidesInView.init(), v.slideFocus.init(je), v.eventHandler.init(je), v.resizeHandler.init(je), v.slidesHandler.init(je), v.options.loop && v.slideLooper.loop(), A.offsetParent && L.length && v.dragHandler.init(je), x = o.init(je, b)));
  }
  function z(Me, he) {
    const pe = ee();
    H(), D(c({
      startIndex: pe
    }, Me), he), l.emit("reInit");
  }
  function H() {
    v.dragHandler.destroy(), v.eventStore.clear(), v.translate.clear(), v.slideLooper.clear(), v.resizeHandler.destroy(), v.slidesHandler.destroy(), v.slidesInView.destroy(), v.animation.destroy(), o.destroy(), s.clear();
  }
  function V() {
    g || (g = !0, s.clear(), H(), l.emit("destroy"), l.clear());
  }
  function F(Me, he, pe) {
    !w.active || g || (v.scrollBody.useBaseFriction().useDuration(he === !0 ? 0 : w.duration), v.scrollTo.index(Me, pe || 0));
  }
  function _(Me) {
    const he = v.index.add(1).get();
    F(he, Me, -1);
  }
  function W(Me) {
    const he = v.index.add(-1).get();
    F(he, Me, 1);
  }
  function G() {
    return v.index.add(1).get() !== ee();
  }
  function Y() {
    return v.index.add(-1).get() !== ee();
  }
  function Z() {
    return v.scrollSnapList;
  }
  function oe() {
    return v.scrollProgress.get(v.location.get());
  }
  function ee() {
    return v.index.get();
  }
  function ae() {
    return v.indexPrevious.get();
  }
  function fe() {
    return v.slidesInView.get();
  }
  function me() {
    return v.slidesInView.get(!1);
  }
  function ge() {
    return x;
  }
  function $() {
    return v;
  }
  function se() {
    return t;
  }
  function xe() {
    return A;
  }
  function Oe() {
    return L;
  }
  const je = {
    canScrollNext: G,
    canScrollPrev: Y,
    containerNode: xe,
    internalEngine: $,
    destroy: V,
    off: h,
    on: f,
    emit: p,
    plugins: ge,
    previousScrollSnap: ae,
    reInit: m,
    rootNode: se,
    scrollNext: _,
    scrollPrev: W,
    scrollProgress: oe,
    scrollSnapList: Z,
    scrollTo: F,
    selectedScrollSnap: ee,
    slideNodes: Oe,
    slidesInView: fe,
    slidesNotInView: me
  };
  return D(e, n), setTimeout(() => l.emit("init"), 0), je;
}
Yy.globalOptions = void 0;
function OC(t = {}, e = []) {
  const n = Ue(t), r = Ue(e), [i, a] = De(), [o, s] = De(), l = nt(() => {
    i && i.reInit(n.current, r.current);
  }, [i]);
  return ze(() => {
    IC(n.current, t) || (n.current = t, l());
  }, [t, l]), ze(() => {
    G3t(r.current, e) || (r.current = e, l());
  }, [e, l]), ze(() => {
    if (Z3t() && o) {
      Yy.globalOptions = OC.globalOptions;
      const c = Yy(o, n.current, r.current);
      return a(c), () => c.destroy();
    } else
      a(void 0);
  }, [o, a]), [s, i];
}
OC.globalOptions = void 0;
const CY = xn(null);
function Np() {
  const t = Mt(CY);
  if (!t)
    throw new Error("useCarousel must be used within a <Carousel />");
  return t;
}
const AY = en(
  ({
    orientation: t = "horizontal",
    opts: e,
    setApi: n,
    plugins: r,
    className: i,
    children: a,
    ...o
  }, s) => {
    const [l, c] = OC(
      {
        ...e,
        axis: t === "horizontal" ? "x" : "y"
      },
      r
    ), [u, d] = De(!1), [f, h] = De(!1), p = nt((k) => {
      k && (d(k.canScrollPrev()), h(k.canScrollNext()));
    }, []), m = nt(() => {
      c == null || c.scrollPrev();
    }, [c]), g = nt(() => {
      c == null || c.scrollNext();
    }, [c]), v = nt(
      (k) => {
        k.key === "ArrowLeft" ? (k.preventDefault(), m()) : k.key === "ArrowRight" && (k.preventDefault(), g());
      },
      [m, g]
    );
    return ze(() => {
      !c || !n || n(c);
    }, [c, n]), ze(() => {
      if (c)
        return p(c), c.on("reInit", p), c.on("select", p), () => {
          c == null || c.off("select", p);
        };
    }, [c, p]), /* @__PURE__ */ C.jsx(
      CY.Provider,
      {
        value: {
          carouselRef: l,
          api: c,
          opts: e,
          orientation: t || ((e == null ? void 0 : e.axis) === "y" ? "vertical" : "horizontal"),
          scrollPrev: m,
          scrollNext: g,
          canScrollPrev: u,
          canScrollNext: f
        },
        children: /* @__PURE__ */ C.jsx(
          "div",
          {
            ref: s,
            onKeyDownCapture: v,
            className: Lt("relative", i),
            role: "region",
            "aria-roledescription": "carousel",
            ...o,
            children: a
          }
        )
      }
    );
  }
);
AY.displayName = "Carousel";
const SY = en(({ className: t, ...e }, n) => {
  const { carouselRef: r, orientation: i } = Np();
  return /* @__PURE__ */ C.jsx("div", { ref: r, className: "overflow-hidden", children: /* @__PURE__ */ C.jsx(
    "div",
    {
      ref: n,
      className: Lt(
        "flex",
        i === "horizontal" ? "-ml-4" : "-mt-4 flex-col",
        t
      ),
      ...e
    }
  ) });
});
SY.displayName = "CarouselContent";
const R9 = en(
  ({ className: t, ...e }, n) => {
    const { orientation: r } = Np();
    return /* @__PURE__ */ C.jsx(
      "div",
      {
        ref: n,
        role: "group",
        "aria-roledescription": "slide",
        className: Lt(
          "min-w-0 shrink-0 grow-0 basis-full",
          r === "horizontal" ? "pl-4" : "pt-4",
          t
        ),
        ...e
      }
    );
  }
);
R9.displayName = "CarouselItem";
const LY = en(({ index: t, className: e, ...n }, r) => {
  const { api: i } = Np(), [a, o] = De(0), [, s] = De([]), l = nt(
    (f) => {
      i && i.scrollTo(f);
    },
    [i]
  ), c = nt((f) => {
    f && s(f.scrollSnapList());
  }, []), u = nt((f) => {
    f && o(f.selectedScrollSnap());
  }, []);
  ze(() => {
    i && (c(i), u(i), i.on("reInit", c), i.on("reInit", u), i.on("select", u));
  }, [i, c, u]);
  const d = a === t;
  return /* @__PURE__ */ C.jsx(
    "button",
    {
      ref: r,
      className: Lt(
        "w-2 h-2 transition-colors duration-200 rounded-full",
        d ? "bg-black" : "bg-[#E8EBEC] hover:bg-black/50",
        e
      ),
      onClick: () => l(t),
      ...n
    }
  );
});
LY.displayName = "CarouselIndicator";
const Agt = Ce.forwardRef(({ className: t, ...e }, n) => {
  const { scrollPrev: r, canScrollPrev: i } = Np();
  return /* @__PURE__ */ C.jsx(
    "button",
    {
      ref: n,
      className: Lt(
        "btn color-bg-default hover:color-bg-default-hover transition color-text-default flex items-center border-2 rounded h-9 px-4 py-2 text-sm font-medium disabled:bg-[#E8EBEC] disabled:text-[#A1AAB1]",
        t
      ),
      disabled: !i,
      onClick: r,
      ...e,
      children: /* @__PURE__ */ C.jsx("span", { children: "Back" })
    }
  );
});
Agt.displayName = "CarouselPrevious";
const Sgt = Ce.forwardRef(({ className: t, ...e }, n) => {
  const { scrollNext: r, canScrollNext: i } = Np();
  return /* @__PURE__ */ C.jsx(
    "button",
    {
      ref: n,
      className: Lt(
        "btn bg-black hover:bg-black color-text-default flex items-center border-2 rounded h-9 px-4 py-2 text-sm font-medium disabled:bg-[#E8EBEC] disabled:text-[#A1AAB1]",
        t
      ),
      disabled: !i,
      onClick: r,
      ...e,
      children: /* @__PURE__ */ C.jsx("span", { children: "Next" })
    }
  );
});
Sgt.displayName = "CarouselNext";
var Lgt = typeof Pr == "object" && Pr && Pr.Object === Object && Pr, Tgt = typeof self == "object" && self && self.Object === Object && self;
Lgt || Tgt || Function("return this")();
var TY = typeof window < "u" ? us : ze;
function Egt(t, e, n, r) {
  const i = Ue(e);
  TY(() => {
    i.current = e;
  }, [e]), ze(() => {
    const a = window;
    if (!(a && a.addEventListener))
      return;
    const o = (s) => {
      i.current(s);
    };
    return a.addEventListener(t, o, r), () => {
      a.removeEventListener(t, o, r);
    };
  }, [t, n, r]);
}
var jgt = typeof window > "u";
function ja(t, {
  defaultValue: e = !1,
  initializeWithValue: n = !0
} = {}) {
  const r = (s) => jgt ? e : window.matchMedia(s).matches, [i, a] = De(() => n ? r(t) : e);
  function o() {
    a(r(t));
  }
  return TY(() => {
    const s = window.matchMedia(t);
    return o(), s.addListener ? s.addListener(o) : s.addEventListener("change", o), () => {
      s.removeListener ? s.removeListener(o) : s.removeEventListener("change", o);
    };
  }, [t]), i;
}
function BC(t, e, n = "mousedown", r = {}) {
  Egt(
    n,
    (i) => {
      const a = i.target;
      if (!a || !a.isConnected)
        return;
      (Array.isArray(t) ? t.filter((s) => !!s.current).every((s) => s.current && !s.current.contains(a)) : t.current && !t.current.contains(a)) && e(i);
    },
    void 0,
    r
  );
}
const Ky = [
  { color: "#000000", code: "bg-[#000000]" },
  { color: "#434343", code: "bg-[#434343]" },
  { color: "#666666", code: "bg-[#666666]" },
  { color: "#999999", code: "bg-[#999999]" },
  { color: "#B7B7B7", code: "bg-[#B7B7B7]" },
  { color: "#CCCCCC", code: "bg-[#CCCCCC]" },
  { color: "#D9D9D9", code: "bg-[#D9D9D9]" },
  { color: "#EFEFEF", code: "bg-[#EFEFEF]" },
  { color: "#F3F3F3", code: "bg-[#F3F3F3]" },
  { color: "#FFFFFF", code: "bg-[#FFFFFF] border border-gray-200" },
  { color: "#980000", code: "bg-[#980000]" },
  { color: "#FF0000", code: "bg-[#FF0000]" },
  { color: "#FF9900", code: "bg-[#FF9900]" },
  { color: "#FFFF00", code: "bg-[#FFFF00]" },
  { color: "#00FF00", code: "bg-[#00FF00]" },
  { color: "#00FFFF", code: "bg-[#00FFFF]" },
  { color: "#4A86E8", code: "bg-[#4A86E8]" },
  { color: "#0000FF", code: "bg-[#0000FF]" },
  { color: "#9900FF", code: "bg-[#9900FF]" },
  { color: "#FF00FF", code: "bg-[#FF00FF]" },
  { color: "#E6B8AF", code: "bg-[#E6B8AF]" },
  { color: "#F4CCCC", code: "bg-[#F4CCCC]" },
  { color: "#FCE5CD", code: "bg-[#FCE5CD]" },
  { color: "#FFF2CC", code: "bg-[#FFF2CC]" },
  { color: "#D9EAD3", code: "bg-[#D9EAD3]" },
  { color: "#D0E0E3", code: "bg-[#D0E0E3]" },
  { color: "#C9DAF8", code: "bg-[#C9DAF8]" },
  { color: "#CFE2F3", code: "bg-[#CFE2F3]" },
  { color: "#D9D2E9", code: "bg-[#D9D2E9]" },
  { color: "#EAD1DC", code: "bg-[#EAD1DC]" },
  { color: "#DD7E6B", code: "bg-[#DD7E6B]" },
  { color: "#EA9999", code: "bg-[#EA9999]" },
  { color: "#F9CB9C", code: "bg-[#F9CB9C]" },
  { color: "#FFE599", code: "bg-[#FFE599]" },
  { color: "#B6D7A8", code: "bg-[#B6D7A8]" },
  { color: "#A2C4C9", code: "bg-[#A2C4C9]" },
  { color: "#A4C2F4", code: "bg-[#A4C2F4]" },
  { color: "#9FC5E8", code: "bg-[#9FC5E8]" },
  { color: "#B4A7D6", code: "bg-[#B4A7D6]" },
  { color: "#D5A6BD", code: "bg-[#D5A6BD]" },
  { color: "#CC4125", code: "bg-[#CC4125]" },
  { color: "#E06666", code: "bg-[#E06666]" },
  { color: "#F6B26B", code: "bg-[#F6B26B]" },
  { color: "#FFD966", code: "bg-[#FFD966]" },
  { color: "#93C47D", code: "bg-[#93C47D]" },
  { color: "#76A5AF", code: "bg-[#76A5AF]" },
  { color: "#6D9EEB", code: "bg-[#6D9EEB]" },
  { color: "#6FA8DC", code: "bg-[#6FA8DC]" },
  { color: "#8E7CC3", code: "bg-[#8E7CC3]" },
  { color: "#C27BA0", code: "bg-[#C27BA0]" },
  { color: "#A61C00", code: "bg-[#A61C00]" },
  { color: "#CC0000", code: "bg-[#CC0000]" },
  { color: "#E69138", code: "bg-[#E69138]" },
  { color: "#F1C232", code: "bg-[#F1C232]" },
  { color: "#6AA84F", code: "bg-[#6AA84F]" },
  { color: "#45818E", code: "bg-[#45818E]" },
  { color: "#3C78D8", code: "bg-[#3C78D8]" },
  { color: "#3D85C6", code: "bg-[#3D85C6]" },
  { color: "#674EA7", code: "bg-[#674EA7]" },
  { color: "#A64D79", code: "bg-[#A64D79]" },
  { color: "#85200C", code: "bg-[#85200C]" },
  { color: "#990000", code: "bg-[#990000]" },
  { color: "#B45F06", code: "bg-[#B45F06]" },
  { color: "#BF9000", code: "bg-[#BF9000]" },
  { color: "#38761D", code: "bg-[#38761D]" },
  { color: "#134F5C", code: "bg-[#134F5C]" },
  { color: "#1155CC", code: "bg-[#1155CC]" },
  { color: "#0B5394", code: "bg-[#0B5394]" },
  { color: "#351C75", code: "bg-[#351C75]" },
  { color: "#741B47", code: "bg-[#741B47]" },
  { color: "#5B0F00", code: "bg-[#5B0F00]" },
  { color: "#660000", code: "bg-[#660000]" },
  { color: "#783F04", code: "bg-[#783F04]" },
  { color: "#7F6000", code: "bg-[#7F6000]" },
  { color: "#274E13", code: "bg-[#274E13]" },
  { color: "#0C343D", code: "bg-[#0C343D]" },
  { color: "#1C4587", code: "bg-[#1C4587]" },
  { color: "#073763", code: "bg-[#073763]" },
  { color: "#20124D", code: "bg-[#20124D]" },
  { color: "#4C1130", code: "bg-[#4C1130]" }
], i2 = (t, e) => t.type.includes("image") && !["image/png", "image/jpeg", "image/gif"].includes(t.type) ? (e && typeof e == "function" && e("Invalid image type. Try PNG, JPEG or GIF."), !1) : !0, EY = (t) => {
  const n = `
        <!DOCTYPE html>
        <html>
            <head>
                <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet">
                <style>
                    @media print {
                        @page {
                            size: landscape;
                            margin: 0;
                        }
                        
                        body {
                            margin: 0;
                            font-family: 'Inter', sans-serif;
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }

                        .print-slide {
                            page-break-after: always;
                            width: 100vw;
                            height: 100vh;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #E8EBEC;
                        }

                        .slide-wrapper {
                            width: 1080px;
                            height: 100vh;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: white;
                            border-radius: 8px;
                            padding: 48px;
                            box-sizing: border-box;
                        }

                        .slide-content {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            padding: 0 64px;
                            box-sizing: border-box;
                            overflow: hidden;
                        }

                        /* Typography */
                        .ProseMirror h1 {
                            font-size: 82px;
                            font-weight: 700;
                            margin: 0 0 24px 0;
                            color: #0D0D0D;
                            line-height: 1.2;
                        }

                        .ProseMirror h2 {
                            font-size: 40px;
                            font-weight: 700;
                            margin: 0 0 16px 0;
                            color: #0D0D0D;
                            line-height: 1.2;
                        }

                        .ProseMirror h3 {
                            font-size: 24px;
                            font-weight: 600;
                            margin: 0 0 16px 0;
                            color: #0D0D0D;
                            line-height: 1.2;
                        }

                        .ProseMirror p {
                            font-size: 24px;
                            line-height: 1.5;
                            margin: 0 0 16px 0;
                            color: #0D0D0D;
                        }

                        /* Lists */
                        .ProseMirror ul,
                        .ProseMirror ol {
                            font-size: 24px;
                            line-height: 1.5;
                            margin: 0 0 16px 0;
                            padding-left: 24px;
                        }

                        .ProseMirror li {
                            margin-bottom: 8px;
                        }

                        /* Task List Styles */
                        input[type='checkbox'] {
                            -webkit-appearance: none;
                            appearance: none;
                            background-color: #fff;
                            margin: 0;
                            cursor: pointer;
                            width: 1.5em;
                            height: 1.5em;
                            position: relative;
                            border: 2px solid black;
                            margin-right: 0.5rem;
                            display: grid;
                            place-content: center;
                        }

                        input[type='checkbox']::before {
                            content: '';
                            width: 1em;
                            height: 1em;
                            transform: scale(0);
                            transition: 120ms transform ease-in-out;
                            box-shadow: inset 1em 1em;
                            transform-origin: center;
                            clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
                        }

                        input[type='checkbox']:checked::before {
                            transform: scale(1);
                        }

                        li:has(input[type="checkbox"]) {
                            list-style-type: none;
                            font-size: 24px;
                            display: flex;
                            align-items: center;
                            margin: 0 0 24px 0;
                        }

                        /* Tables */
                        .ProseMirror table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 16px 0;
                            font-size: 20px;
                        }

                        .ProseMirror th {
                            background: #F8F9FA;
                            font-weight: 600;
                            text-align: left;
                        }

                        .ProseMirror td,
                        .ProseMirror th {
                            border: 1px solid #E8EBEC;
                            padding: 12px;
                        }

                        /* Images */
                        .ProseMirror img {
                            max-width: 720px;
                            max-height: calc(100vh - 96px);
                            display: block;
                            margin: 16px auto;
                            position: relative;
                            box-sizing: border-box;
                            aspect-ratio: auto;
                        }

                        /* Code blocks */
                        .ProseMirror pre {
                            background: #F8F9FA;
                            padding: 16px;
                            border-radius: 4px;
                            font-family: monospace;
                            font-size: 16px;
                            margin: 16px 0;
                        }

                        /* Blockquotes */
                        .ProseMirror blockquote {
                            border-left: 4px solid #E8EBEC;
                            margin: 16px 0;
                            padding-left: 16px;
                            font-style: italic;
                        }

                        /* Flex containers */
                        .ProseMirror div[style*="display: flex"] {
                            display: flex !important;
                            gap: 16px;
                        }

                        .ProseMirror div[style*="flex-direction: row"] {
                            flex-direction: row !important;
                        }

                        .ProseMirror div[style*="flex-direction: column"] {
                            flex-direction: column !important;
                        }

                        /* Hide UI elements */
                        .preview-panel,
                        .toolbar,
                        .icon-button {
                            display: none !important;
                        }
                    }
                </style>
            </head>
            <body>
                ${t.map(
    (r) => `
        <div class="print-slide">
            <div class="slide-wrapper">
                <div class="slide-content ProseMirror presentation-mode">
                    ${r}
                </div>
            </div>
        </div>
    `
  ).join("")}
                <script>
                    window.onload = () => {
                        window.print();
                        window.onafterprint = () => window.close();
                    }
                <\/script>
            </body>
        </html>
    `;
  NY(n);
}, jY = (t) => {
  const e = document.createElement("div");
  e.innerHTML = t;
  const n = [];
  let r = [];
  if (Array.from(e.childNodes).forEach((o) => {
    if (o instanceof HTMLElement && (o.getAttribute("data-type") === "page-break" && o.getAttribute("data-page-break") === "true" || o.tagName.toLowerCase() === "br" && o.getAttribute("data-page-break") === "true")) {
      if (r.length > 0) {
        const s = document.createElement("div");
        r.forEach(
          (l) => s.appendChild(l.cloneNode(!0))
        ), n.push(s.innerHTML), r = [];
      }
    } else
      r.push(o.cloneNode(!0));
  }), r.length > 0) {
    const o = document.createElement("div");
    r.forEach((s) => o.appendChild(s.cloneNode(!0))), n.push(o.innerHTML);
  }
  const a = `
  <!DOCTYPE html>
  <html>
    <head>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet">
      <title>Print Preview</title>
      <style>
        @media print {
          @page { 
            margin: 0.25in 0.5in;
          }
          html {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          body:before, body:after,
          head:before, head:after,
          div:before, div:after {
            content: none !important;
            display: none !important;
          }
          html:before, html:after,
        }
        body {
          font-family: Arial, sans-serif;
          line-height: 1.6;
          margin: 0;
        }
        img {
          max-width: fit-content;
          height: auto;
          aspect-ratio: auto;
          display: block;
          margin-left: auto;
          margin-right: auto;
        }
        h3 {
          font-weight: 600;
          color: #0D0D0D;
          font-size: 20px;
          line-height: 1.2;
        }
        p {
          line-height: 1.5;
          color: #0D0D0D;
          font-size: 16px;
        }
        /* Lists */
        ul, ol {
          font-size: 16px;
          line-height: 1.5;
          margin: 0 0 16px 0;
          padding-left: 24px;
        }
        /* Task List Styles */
        input[type='checkbox'] {
            -webkit-appearance: none;
            appearance: none;
            background-color: #fff;
            margin: 0;
            font-family: 'Inter', sans-serif;
          }
          .print-page {
            page-break-after: always;
            box-sizing: border-box;
          }
          .print-page:last-child {
            page-break-after: auto;
          }
          
          img {
            max-width: 100%;
            height: auto;
          }
          h3 {
            font-weight: 600;
            color: #0D0D0D;
            font-size: 20px;
            line-height: 1.2;
          }
          p {
            line-height: 1.5;
            color: #0D0D0D;
            font-size: 16px;
          }
          /* Lists */
          ul, ol {
            font-size: 16px;
            line-height: 1.5;
            margin: 0 0 16px 0;
            padding-left: 24px;
          }
          /* Task List Styles */
          input[type='checkbox'] {
              -webkit-appearance: none;
              appearance: none;
              background-color: #fff;
              margin: 0;
              cursor: pointer;
              width: 1.5em;
              height: 1.5em;
              position: relative;
              border: 2px solid black;
              margin-right: 0.5rem;
              display: grid;
              place-content: center;
          }

          input[type='checkbox']::before {
              content: '';
              width: 1em;
              height: 1em;
              transform: scale(0);
              transition: 120ms transform ease-in-out;
              box-shadow: inset 1em 1em;
              transform-origin: center;
              clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
          }

          input[type='checkbox']:checked::before {
              transform: scale(1);
          }

          li:has(input[type="checkbox"]) {
              list-style-type: none;
              transform: translateX(-16px);
              font-size: 24px;
              display: flex;
              align-items: center;
          }
          ol {
            list-style-type: decimal;
          }
          ol ol {
            list-style-type: lower-latin;
          }
          ol ol ol {
            list-style-type: lower-roman;
          }
          /* Tables */
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 16px 0;
            font-size: 16px;
          }
          th {
            background: #F8F9FA;
            font-weight: 600;
            text-align: left;
          }
          td, th {
            border: 1px solid #E8EBEC;
            padding: 12px;
          }
          /* Code blocks */
          pre {
            background: #F8F9FA;
            padding: 16px;
            border-radius: 4px;
            font-family: monospace;
            font-size: 12px;
            margin: 16px 0;
          }
          /* Blockquotes */
          blockquote {
            border-left: 4px solid #E8EBEC;
            margin: 16px 0;
            padding-left: 16px;
            font-style: italic;
          }
        }
      </style>
    </head>
    <body>
      ${n.map(
    (o) => `
        <div class="print-page">
            ${o}
        </div>
    `
  ).join("")}
      <script>
        window.onload = () => {
          window.print();
          window.onafterprint = () => {
            window.close();
          };
        }
      <\/script>
    </body>
  </html>`;
  NY(a);
}, NY = (t) => {
  var a;
  const e = document.createElement("div");
  e.style.position = "fixed", e.style.top = "0", e.style.left = "0", e.style.width = "100%", e.style.height = "100%", e.style.backgroundColor = "rgba(0, 0, 0, 0.48)", e.style.zIndex = "9999", document.body.appendChild(e);
  const n = document.createElement("iframe");
  n.style.position = "fixed", n.style.border = "none", n.style.zIndex = "9999", document.body.appendChild(n);
  const r = n.contentDocument || ((a = n.contentWindow) == null ? void 0 : a.document);
  if (!r) return;
  r.open(), r.write(t), r.close();
  const i = n.contentWindow;
  i && (i.onafterprint = () => {
    document.body.removeChild(n), document.body.removeChild(e);
  });
};
function Ngt() {
  const t = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
  ];
  let e = [];
  for (let n = 0; n < 36; n++)
    n === 8 || n === 13 || n === 18 || n === 23 ? e[n] = "-" : e[n] = t[Math.ceil(Math.random() * t.length - 1)];
  return e.join("");
}
var Dgt = Ngt;
const oh = /* @__PURE__ */ kd(Dgt), Igt = "1.0.8";
let sa = class O9 extends Error {
  constructor(e, n = {}) {
    var o;
    const r = n.cause instanceof O9 ? n.cause.details : (o = n.cause) != null && o.message ? n.cause.message : n.details, i = n.cause instanceof O9 && n.cause.docsPath || n.docsPath, a = [
      e || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...i ? [`Docs: https://abitype.dev${i}`] : [],
      ...r ? [`Details: ${r}`] : [],
      `Version: abitype@${Igt}`
    ].join(`
`);
    super(a), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiTypeError"
    }), n.cause && (this.cause = n.cause), this.details = r, this.docsPath = i, this.metaMessages = n.metaMessages, this.shortMessage = e;
  }
};
function Al(t, e) {
  const n = t.exec(e);
  return n == null ? void 0 : n.groups;
}
const DY = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/, IY = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/, PY = /^\(.+?\).*?$/, dD = /^tuple(?<array>(\[(\d*)\])*)$/;
function B9(t) {
  let e = t.type;
  if (dD.test(t.type) && "components" in t) {
    e = "(";
    const n = t.components.length;
    for (let i = 0; i < n; i++) {
      const a = t.components[i];
      e += B9(a), i < n - 1 && (e += ", ");
    }
    const r = Al(dD, t.type);
    return e += `)${(r == null ? void 0 : r.array) ?? ""}`, B9({
      ...t,
      type: e
    });
  }
  return "indexed" in t && t.indexed && (e = `${e} indexed`), t.name ? `${e} ${t.name}` : e;
}
function hf(t) {
  let e = "";
  const n = t.length;
  for (let r = 0; r < n; r++) {
    const i = t[r];
    e += B9(i), r !== n - 1 && (e += ", ");
  }
  return e;
}
function $y(t) {
  var e;
  return t.type === "function" ? `function ${t.name}(${hf(t.inputs)})${t.stateMutability && t.stateMutability !== "nonpayable" ? ` ${t.stateMutability}` : ""}${(e = t.outputs) != null && e.length ? ` returns (${hf(t.outputs)})` : ""}` : t.type === "event" ? `event ${t.name}(${hf(t.inputs)})` : t.type === "error" ? `error ${t.name}(${hf(t.inputs)})` : t.type === "constructor" ? `constructor(${hf(t.inputs)})${t.stateMutability === "payable" ? " payable" : ""}` : t.type === "fallback" ? `fallback() external${t.stateMutability === "payable" ? " payable" : ""}` : "receive() external payable";
}
const zY = /^error (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function Pgt(t) {
  return zY.test(t);
}
function zgt(t) {
  return Al(zY, t);
}
const RY = /^event (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function Rgt(t) {
  return RY.test(t);
}
function Ogt(t) {
  return Al(RY, t);
}
const OY = /^function (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns\s?\((?<returns>.*?)\))?$/;
function Bgt(t) {
  return OY.test(t);
}
function Hgt(t) {
  return Al(OY, t);
}
const BY = /^struct (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*) \{(?<properties>.*?)\}$/;
function HC(t) {
  return BY.test(t);
}
function Fgt(t) {
  return Al(BY, t);
}
const HY = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/;
function _gt(t) {
  return HY.test(t);
}
function Vgt(t) {
  return Al(HY, t);
}
const FY = /^fallback\(\) external(?:\s(?<stateMutability>payable{1}))?$/;
function qgt(t) {
  return FY.test(t);
}
function Ugt(t) {
  return Al(FY, t);
}
const Wgt = /^receive\(\) external payable$/;
function Zgt(t) {
  return Wgt.test(t);
}
const Ggt = /* @__PURE__ */ new Set(["indexed"]), H9 = /* @__PURE__ */ new Set([
  "calldata",
  "memory",
  "storage"
]);
class Ygt extends sa {
  constructor({ signature: e }) {
    super("Failed to parse ABI item.", {
      details: `parseAbiItem(${JSON.stringify(e, null, 2)})`,
      docsPath: "/api/human#parseabiitem-1"
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAbiItemError"
    });
  }
}
class Kgt extends sa {
  constructor({ type: e }) {
    super("Unknown type.", {
      metaMessages: [
        `Type "${e}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownTypeError"
    });
  }
}
class $gt extends sa {
  constructor({ type: e }) {
    super("Unknown type.", {
      metaMessages: [`Type "${e}" is not a valid ABI type.`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownSolidityTypeError"
    });
  }
}
class Jgt extends sa {
  constructor({ param: e }) {
    super("Invalid ABI parameter.", {
      details: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParameterError"
    });
  }
}
class Qgt extends sa {
  constructor({ param: e, name: n }) {
    super("Invalid ABI parameter.", {
      details: e,
      metaMessages: [
        `"${n}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SolidityProtectedKeywordError"
    });
  }
}
class Xgt extends sa {
  constructor({ param: e, type: n, modifier: r }) {
    super("Invalid ABI parameter.", {
      details: e,
      metaMessages: [
        `Modifier "${r}" not allowed${n ? ` in "${n}" type` : ""}.`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidModifierError"
    });
  }
}
class e6t extends sa {
  constructor({ param: e, type: n, modifier: r }) {
    super("Invalid ABI parameter.", {
      details: e,
      metaMessages: [
        `Modifier "${r}" not allowed${n ? ` in "${n}" type` : ""}.`,
        `Data location can only be specified for array, struct, or mapping types, but "${r}" was given.`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidFunctionModifierError"
    });
  }
}
class t6t extends sa {
  constructor({ abiParameter: e }) {
    super("Invalid ABI parameter.", {
      details: JSON.stringify(e, null, 2),
      metaMessages: ["ABI parameter type is invalid."]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAbiTypeParameterError"
    });
  }
}
class zd extends sa {
  constructor({ signature: e, type: n }) {
    super(`Invalid ${n} signature.`, {
      details: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidSignatureError"
    });
  }
}
class n6t extends sa {
  constructor({ signature: e }) {
    super("Unknown signature.", {
      details: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownSignatureError"
    });
  }
}
class r6t extends sa {
  constructor({ signature: e }) {
    super("Invalid struct signature.", {
      details: e,
      metaMessages: ["No properties exist."]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidStructSignatureError"
    });
  }
}
class i6t extends sa {
  constructor({ type: e }) {
    super("Circular reference detected.", {
      metaMessages: [`Struct "${e}" is a circular reference.`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "CircularReferenceError"
    });
  }
}
class a6t extends sa {
  constructor({ current: e, depth: n }) {
    super("Unbalanced parentheses.", {
      metaMessages: [
        `"${e.trim()}" has too many ${n > 0 ? "opening" : "closing"} parentheses.`
      ],
      details: `Depth "${n}"`
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParenthesisError"
    });
  }
}
function o6t(t, e, n) {
  let r = "";
  if (n)
    for (const i of Object.entries(n)) {
      if (!i)
        continue;
      let a = "";
      for (const o of i[1])
        a += `[${o.type}${o.name ? `:${o.name}` : ""}]`;
      r += `(${i[0]}{${a}})`;
    }
  return e ? `${e}:${t}${r}` : t;
}
const ev = /* @__PURE__ */ new Map([
  // Unnamed
  ["address", { type: "address" }],
  ["bool", { type: "bool" }],
  ["bytes", { type: "bytes" }],
  ["bytes32", { type: "bytes32" }],
  ["int", { type: "int256" }],
  ["int256", { type: "int256" }],
  ["string", { type: "string" }],
  ["uint", { type: "uint256" }],
  ["uint8", { type: "uint8" }],
  ["uint16", { type: "uint16" }],
  ["uint24", { type: "uint24" }],
  ["uint32", { type: "uint32" }],
  ["uint64", { type: "uint64" }],
  ["uint96", { type: "uint96" }],
  ["uint112", { type: "uint112" }],
  ["uint160", { type: "uint160" }],
  ["uint192", { type: "uint192" }],
  ["uint256", { type: "uint256" }],
  // Named
  ["address owner", { type: "address", name: "owner" }],
  ["address to", { type: "address", name: "to" }],
  ["bool approved", { type: "bool", name: "approved" }],
  ["bytes _data", { type: "bytes", name: "_data" }],
  ["bytes data", { type: "bytes", name: "data" }],
  ["bytes signature", { type: "bytes", name: "signature" }],
  ["bytes32 hash", { type: "bytes32", name: "hash" }],
  ["bytes32 r", { type: "bytes32", name: "r" }],
  ["bytes32 root", { type: "bytes32", name: "root" }],
  ["bytes32 s", { type: "bytes32", name: "s" }],
  ["string name", { type: "string", name: "name" }],
  ["string symbol", { type: "string", name: "symbol" }],
  ["string tokenURI", { type: "string", name: "tokenURI" }],
  ["uint tokenId", { type: "uint256", name: "tokenId" }],
  ["uint8 v", { type: "uint8", name: "v" }],
  ["uint256 balance", { type: "uint256", name: "balance" }],
  ["uint256 tokenId", { type: "uint256", name: "tokenId" }],
  ["uint256 value", { type: "uint256", name: "value" }],
  // Indexed
  [
    "event:address indexed from",
    { type: "address", name: "from", indexed: !0 }
  ],
  ["event:address indexed to", { type: "address", name: "to", indexed: !0 }],
  [
    "event:uint indexed tokenId",
    { type: "uint256", name: "tokenId", indexed: !0 }
  ],
  [
    "event:uint256 indexed tokenId",
    { type: "uint256", name: "tokenId", indexed: !0 }
  ]
]);
function F9(t, e = {}) {
  if (Bgt(t))
    return s6t(t, e);
  if (Rgt(t))
    return l6t(t, e);
  if (Pgt(t))
    return c6t(t, e);
  if (_gt(t))
    return u6t(t, e);
  if (qgt(t))
    return d6t(t);
  if (Zgt(t))
    return {
      type: "receive",
      stateMutability: "payable"
    };
  throw new n6t({ signature: t });
}
function s6t(t, e = {}) {
  const n = Hgt(t);
  if (!n)
    throw new zd({ signature: t, type: "function" });
  const r = Ya(n.parameters), i = [], a = r.length;
  for (let s = 0; s < a; s++)
    i.push(a0(r[s], {
      modifiers: H9,
      structs: e,
      type: "function"
    }));
  const o = [];
  if (n.returns) {
    const s = Ya(n.returns), l = s.length;
    for (let c = 0; c < l; c++)
      o.push(a0(s[c], {
        modifiers: H9,
        structs: e,
        type: "function"
      }));
  }
  return {
    name: n.name,
    type: "function",
    stateMutability: n.stateMutability ?? "nonpayable",
    inputs: i,
    outputs: o
  };
}
function l6t(t, e = {}) {
  const n = Ogt(t);
  if (!n)
    throw new zd({ signature: t, type: "event" });
  const r = Ya(n.parameters), i = [], a = r.length;
  for (let o = 0; o < a; o++)
    i.push(a0(r[o], {
      modifiers: Ggt,
      structs: e,
      type: "event"
    }));
  return { name: n.name, type: "event", inputs: i };
}
function c6t(t, e = {}) {
  const n = zgt(t);
  if (!n)
    throw new zd({ signature: t, type: "error" });
  const r = Ya(n.parameters), i = [], a = r.length;
  for (let o = 0; o < a; o++)
    i.push(a0(r[o], { structs: e, type: "error" }));
  return { name: n.name, type: "error", inputs: i };
}
function u6t(t, e = {}) {
  const n = Vgt(t);
  if (!n)
    throw new zd({ signature: t, type: "constructor" });
  const r = Ya(n.parameters), i = [], a = r.length;
  for (let o = 0; o < a; o++)
    i.push(a0(r[o], { structs: e, type: "constructor" }));
  return {
    type: "constructor",
    stateMutability: n.stateMutability ?? "nonpayable",
    inputs: i
  };
}
function d6t(t) {
  const e = Ugt(t);
  if (!e)
    throw new zd({ signature: t, type: "fallback" });
  return {
    type: "fallback",
    stateMutability: e.stateMutability ?? "nonpayable"
  };
}
const f6t = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/, h6t = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/, p6t = /^u?int$/;
function a0(t, e) {
  var d, f;
  const n = o6t(t, e == null ? void 0 : e.type, e == null ? void 0 : e.structs);
  if (ev.has(n))
    return ev.get(n);
  const r = PY.test(t), i = Al(r ? h6t : f6t, t);
  if (!i)
    throw new Jgt({ param: t });
  if (i.name && y6t(i.name))
    throw new Qgt({ param: t, name: i.name });
  const a = i.name ? { name: i.name } : {}, o = i.modifier === "indexed" ? { indexed: !0 } : {}, s = (e == null ? void 0 : e.structs) ?? {};
  let l, c = {};
  if (r) {
    l = "tuple";
    const h = Ya(i.type), p = [], m = h.length;
    for (let g = 0; g < m; g++)
      p.push(a0(h[g], { structs: s }));
    c = { components: p };
  } else if (i.type in s)
    l = "tuple", c = { components: s[i.type] };
  else if (p6t.test(i.type))
    l = `${i.type}256`;
  else if (l = i.type, (e == null ? void 0 : e.type) !== "struct" && !_Y(l))
    throw new $gt({ type: l });
  if (i.modifier) {
    if (!((f = (d = e == null ? void 0 : e.modifiers) == null ? void 0 : d.has) != null && f.call(d, i.modifier)))
      throw new Xgt({
        param: t,
        type: e == null ? void 0 : e.type,
        modifier: i.modifier
      });
    if (H9.has(i.modifier) && !g6t(l, !!i.array))
      throw new e6t({
        param: t,
        type: e == null ? void 0 : e.type,
        modifier: i.modifier
      });
  }
  const u = {
    type: `${l}${i.array ?? ""}`,
    ...a,
    ...o,
    ...c
  };
  return ev.set(n, u), u;
}
function Ya(t, e = [], n = "", r = 0) {
  const i = t.trim().length;
  for (let a = 0; a < i; a++) {
    const o = t[a], s = t.slice(a + 1);
    switch (o) {
      case ",":
        return r === 0 ? Ya(s, [...e, n.trim()]) : Ya(s, e, `${n}${o}`, r);
      case "(":
        return Ya(s, e, `${n}${o}`, r + 1);
      case ")":
        return Ya(s, e, `${n}${o}`, r - 1);
      default:
        return Ya(s, e, `${n}${o}`, r);
    }
  }
  if (n === "")
    return e;
  if (r !== 0)
    throw new a6t({ current: n, depth: r });
  return e.push(n.trim()), e;
}
function _Y(t) {
  return t === "address" || t === "bool" || t === "function" || t === "string" || DY.test(t) || IY.test(t);
}
const m6t = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
function y6t(t) {
  return t === "address" || t === "bool" || t === "function" || t === "string" || t === "tuple" || DY.test(t) || IY.test(t) || m6t.test(t);
}
function g6t(t, e) {
  return e || t === "bytes" || t === "string" || t === "tuple";
}
function VY(t) {
  const e = {}, n = t.length;
  for (let o = 0; o < n; o++) {
    const s = t[o];
    if (!HC(s))
      continue;
    const l = Fgt(s);
    if (!l)
      throw new zd({ signature: s, type: "struct" });
    const c = l.properties.split(";"), u = [], d = c.length;
    for (let f = 0; f < d; f++) {
      const p = c[f].trim();
      if (!p)
        continue;
      const m = a0(p, {
        type: "struct"
      });
      u.push(m);
    }
    if (!u.length)
      throw new r6t({ signature: s });
    e[l.name] = u;
  }
  const r = {}, i = Object.entries(e), a = i.length;
  for (let o = 0; o < a; o++) {
    const [s, l] = i[o];
    r[s] = qY(l, e);
  }
  return r;
}
const v6t = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?$/;
function qY(t, e, n = /* @__PURE__ */ new Set()) {
  const r = [], i = t.length;
  for (let a = 0; a < i; a++) {
    const o = t[a];
    if (PY.test(o.type))
      r.push(o);
    else {
      const l = Al(v6t, o.type);
      if (!(l != null && l.type))
        throw new t6t({ abiParameter: o });
      const { array: c, type: u } = l;
      if (u in e) {
        if (n.has(u))
          throw new i6t({ type: u });
        r.push({
          ...o,
          type: `tuple${c ?? ""}`,
          components: qY(e[u] ?? [], e, /* @__PURE__ */ new Set([...n, u]))
        });
      } else if (_Y(u))
        r.push(o);
      else
        throw new Kgt({ type: u });
    }
  }
  return r;
}
function UY(t) {
  const e = VY(t), n = [], r = t.length;
  for (let i = 0; i < r; i++) {
    const a = t[i];
    HC(a) || n.push(F9(a, e));
  }
  return n;
}
function fD(t) {
  let e;
  if (typeof t == "string")
    e = F9(t);
  else {
    const n = VY(t), r = t.length;
    for (let i = 0; i < r; i++) {
      const a = t[i];
      if (!HC(a)) {
        e = F9(a, n);
        break;
      }
    }
  }
  if (!e)
    throw new Ygt({ signature: t });
  return e;
}
function zt(t, e, n) {
  const r = t[e.name];
  if (typeof r == "function")
    return r;
  const i = t[n];
  return typeof i == "function" ? i : (a) => e(t, a);
}
function ul(t, { includeName: e = !1 } = {}) {
  if (t.type !== "function" && t.type !== "event" && t.type !== "error")
    throw new N6t(t.type);
  return `${t.name}(${P6(t.inputs, { includeName: e })})`;
}
function P6(t, { includeName: e = !1 } = {}) {
  return t ? t.map((n) => b6t(n, { includeName: e })).join(e ? ", " : ",") : "";
}
function b6t(t, { includeName: e }) {
  return t.type.startsWith("tuple") ? `(${P6(t.components, { includeName: e })})${t.type.slice(5)}` : t.type + (e && t.name ? ` ${t.name}` : "");
}
function is(t, { strict: e = !0 } = {}) {
  return !t || typeof t != "string" ? !1 : e ? /^0x[0-9a-fA-F]*$/.test(t) : t.startsWith("0x");
}
function tr(t) {
  return is(t, { strict: !1 }) ? Math.ceil((t.length - 2) / 2) : t.length;
}
const WY = "2.24.1";
let pf = {
  getDocsUrl: ({ docsBaseUrl: t, docsPath: e = "", docsSlug: n }) => e ? `${t ?? "https://viem.sh"}${e}${n ? `#${n}` : ""}` : void 0,
  version: `viem@${WY}`
}, We = class _9 extends Error {
  constructor(e, n = {}) {
    var s;
    const r = (() => {
      var l;
      return n.cause instanceof _9 ? n.cause.details : (l = n.cause) != null && l.message ? n.cause.message : n.details;
    })(), i = n.cause instanceof _9 && n.cause.docsPath || n.docsPath, a = (s = pf.getDocsUrl) == null ? void 0 : s.call(pf, { ...n, docsPath: i }), o = [
      e || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...a ? [`Docs: ${a}`] : [],
      ...r ? [`Details: ${r}`] : [],
      ...pf.version ? [`Version: ${pf.version}`] : []
    ].join(`
`);
    super(o, n.cause ? { cause: n.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), this.details = r, this.docsPath = i, this.metaMessages = n.metaMessages, this.name = n.name ?? this.name, this.shortMessage = e, this.version = WY;
  }
  walk(e) {
    return ZY(this, e);
  }
};
function ZY(t, e) {
  return e != null && e(t) ? t : t && typeof t == "object" && "cause" in t && t.cause !== void 0 ? ZY(t.cause, e) : e ? null : t;
}
class w6t extends We {
  constructor({ docsPath: e }) {
    super([
      "A constructor was not found on the ABI.",
      "Make sure you are using the correct ABI and that the constructor exists on it."
    ].join(`
`), {
      docsPath: e,
      name: "AbiConstructorNotFoundError"
    });
  }
}
class hD extends We {
  constructor({ docsPath: e }) {
    super([
      "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
      "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
    ].join(`
`), {
      docsPath: e,
      name: "AbiConstructorParamsNotFoundError"
    });
  }
}
class GY extends We {
  constructor({ data: e, params: n, size: r }) {
    super([`Data size of ${r} bytes is too small for given parameters.`].join(`
`), {
      metaMessages: [
        `Params: (${P6(n, { includeName: !0 })})`,
        `Data:   ${e} (${r} bytes)`
      ],
      name: "AbiDecodingDataSizeTooSmallError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "params", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "size", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = e, this.params = n, this.size = r;
  }
}
class Dp extends We {
  constructor() {
    super('Cannot decode zero data ("0x") with ABI parameters.', {
      name: "AbiDecodingZeroDataError"
    });
  }
}
class k6t extends We {
  constructor({ expectedLength: e, givenLength: n, type: r }) {
    super([
      `ABI encoding array length mismatch for type ${r}.`,
      `Expected length: ${e}`,
      `Given length: ${n}`
    ].join(`
`), { name: "AbiEncodingArrayLengthMismatchError" });
  }
}
class x6t extends We {
  constructor({ expectedSize: e, value: n }) {
    super(`Size of bytes "${n}" (bytes${tr(n)}) does not match expected size (bytes${e}).`, { name: "AbiEncodingBytesSizeMismatchError" });
  }
}
class M6t extends We {
  constructor({ expectedLength: e, givenLength: n }) {
    super([
      "ABI encoding params/values length mismatch.",
      `Expected length (params): ${e}`,
      `Given length (values): ${n}`
    ].join(`
`), { name: "AbiEncodingLengthMismatchError" });
  }
}
class YY extends We {
  constructor(e, { docsPath: n }) {
    super([
      `Encoded error signature "${e}" not found on ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${e}.`
    ].join(`
`), {
      docsPath: n,
      name: "AbiErrorSignatureNotFoundError"
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.signature = e;
  }
}
class C6t extends We {
  constructor({ docsPath: e }) {
    super("Cannot extract event signature from empty topics.", {
      docsPath: e,
      name: "AbiEventSignatureEmptyTopicsError"
    });
  }
}
class KY extends We {
  constructor(e, { docsPath: n }) {
    super([
      `Encoded event signature "${e}" not found on ABI.`,
      "Make sure you are using the correct ABI and that the event exists on it.",
      `You can look up the signature here: https://openchain.xyz/signatures?query=${e}.`
    ].join(`
`), {
      docsPath: n,
      name: "AbiEventSignatureNotFoundError"
    });
  }
}
class pD extends We {
  constructor(e, { docsPath: n } = {}) {
    super([
      `Event ${e ? `"${e}" ` : ""}not found on ABI.`,
      "Make sure you are using the correct ABI and that the event exists on it."
    ].join(`
`), {
      docsPath: n,
      name: "AbiEventNotFoundError"
    });
  }
}
class Jy extends We {
  constructor(e, { docsPath: n } = {}) {
    super([
      `Function ${e ? `"${e}" ` : ""}not found on ABI.`,
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: n,
      name: "AbiFunctionNotFoundError"
    });
  }
}
class A6t extends We {
  constructor(e, { docsPath: n }) {
    super([
      `Function "${e}" does not contain any \`outputs\` on ABI.`,
      "Cannot decode function result without knowing what the parameter types are.",
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: n,
      name: "AbiFunctionOutputsNotFoundError"
    });
  }
}
class S6t extends We {
  constructor(e, n) {
    super("Found ambiguous types in overloaded ABI items.", {
      metaMessages: [
        `\`${e.type}\` in \`${ul(e.abiItem)}\`, and`,
        `\`${n.type}\` in \`${ul(n.abiItem)}\``,
        "",
        "These types encode differently and cannot be distinguished at runtime.",
        "Remove one of the ambiguous items in the ABI."
      ],
      name: "AbiItemAmbiguityError"
    });
  }
}
let L6t = class extends We {
  constructor({ expectedSize: e, givenSize: n }) {
    super(`Expected bytes${e}, got bytes${n}.`, {
      name: "BytesSizeMismatchError"
    });
  }
};
class a2 extends We {
  constructor({ abiItem: e, data: n, params: r, size: i }) {
    super([
      `Data size of ${i} bytes is too small for non-indexed event parameters.`
    ].join(`
`), {
      metaMessages: [
        `Params: (${P6(r, { includeName: !0 })})`,
        `Data:   ${n} (${i} bytes)`
      ],
      name: "DecodeLogDataMismatch"
    }), Object.defineProperty(this, "abiItem", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "params", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "size", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.abiItem = e, this.data = n, this.params = r, this.size = i;
  }
}
class z6 extends We {
  constructor({ abiItem: e, param: n }) {
    super([
      `Expected a topic for indexed event parameter${n.name ? ` "${n.name}"` : ""} on event "${ul(e, { includeName: !0 })}".`
    ].join(`
`), { name: "DecodeLogTopicsMismatch" }), Object.defineProperty(this, "abiItem", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.abiItem = e;
  }
}
class T6t extends We {
  constructor(e, { docsPath: n }) {
    super([
      `Type "${e}" is not a valid encoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: n, name: "InvalidAbiEncodingType" });
  }
}
class E6t extends We {
  constructor(e, { docsPath: n }) {
    super([
      `Type "${e}" is not a valid decoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: n, name: "InvalidAbiDecodingType" });
  }
}
let j6t = class extends We {
  constructor(e) {
    super([`Value "${e}" is not a valid array.`].join(`
`), {
      name: "InvalidArrayError"
    });
  }
};
class N6t extends We {
  constructor(e) {
    super([
      `"${e}" is not a valid definition type.`,
      'Valid types: "function", "event", "error"'
    ].join(`
`), { name: "InvalidDefinitionTypeError" });
  }
}
class D6t extends We {
  constructor(e) {
    super(`Filter type "${e}" is not supported.`, {
      name: "FilterTypeNotSupportedError"
    });
  }
}
let $Y = class extends We {
  constructor({ offset: e, position: n, size: r }) {
    super(`Slice ${n === "start" ? "starting" : "ending"} at offset "${e}" is out-of-bounds (size: ${r}).`, { name: "SliceOffsetOutOfBoundsError" });
  }
}, JY = class extends We {
  constructor({ size: e, targetSize: n, type: r }) {
    super(`${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()} size (${e}) exceeds padding size (${n}).`, { name: "SizeExceedsPaddingSizeError" });
  }
};
class mD extends We {
  constructor({ size: e, targetSize: n, type: r }) {
    super(`${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()} is expected to be ${n} ${r} long, but is ${e} ${r} long.`, { name: "InvalidBytesLengthError" });
  }
}
function Rd(t, { dir: e, size: n = 32 } = {}) {
  return typeof t == "string" ? pc(t, { dir: e, size: n }) : I6t(t, { dir: e, size: n });
}
function pc(t, { dir: e, size: n = 32 } = {}) {
  if (n === null)
    return t;
  const r = t.replace("0x", "");
  if (r.length > n * 2)
    throw new JY({
      size: Math.ceil(r.length / 2),
      targetSize: n,
      type: "hex"
    });
  return `0x${r[e === "right" ? "padEnd" : "padStart"](n * 2, "0")}`;
}
function I6t(t, { dir: e, size: n = 32 } = {}) {
  if (n === null)
    return t;
  if (t.length > n)
    throw new JY({
      size: t.length,
      targetSize: n,
      type: "bytes"
    });
  const r = new Uint8Array(n);
  for (let i = 0; i < n; i++) {
    const a = e === "right";
    r[a ? i : n - i - 1] = t[a ? i : t.length - i - 1];
  }
  return r;
}
let QY = class extends We {
  constructor({ max: e, min: n, signed: r, size: i, value: a }) {
    super(`Number "${a}" is not in safe ${i ? `${i * 8}-bit ${r ? "signed" : "unsigned"} ` : ""}integer range ${e ? `(${n} to ${e})` : `(above ${n})`}`, { name: "IntegerOutOfRangeError" });
  }
};
class P6t extends We {
  constructor(e) {
    super(`Bytes value "${e}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
      name: "InvalidBytesBooleanError"
    });
  }
}
class z6t extends We {
  constructor(e) {
    super(`Hex value "${e}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`, { name: "InvalidHexBooleanError" });
  }
}
let R6t = class extends We {
  constructor({ givenSize: e, maxSize: n }) {
    super(`Size cannot exceed ${n} bytes. Given size: ${e} bytes.`, { name: "SizeOverflowError" });
  }
};
function Ou(t, { dir: e = "left" } = {}) {
  let n = typeof t == "string" ? t.replace("0x", "") : t, r = 0;
  for (let i = 0; i < n.length - 1 && n[e === "left" ? i : n.length - i - 1].toString() === "0"; i++)
    r++;
  return n = e === "left" ? n.slice(r) : n.slice(0, n.length - r), typeof t == "string" ? (n.length === 1 && e === "right" && (n = `${n}0`), `0x${n.length % 2 === 1 ? `0${n}` : n}`) : n;
}
function vo(t, { size: e }) {
  if (tr(t) > e)
    throw new R6t({
      givenSize: tr(t),
      maxSize: e
    });
}
function as(t, e = {}) {
  const { signed: n } = e;
  e.size && vo(t, { size: e.size });
  const r = BigInt(t);
  if (!n)
    return r;
  const i = (t.length - 2) / 2, a = (1n << BigInt(i) * 8n - 1n) - 1n;
  return r <= a ? r : r - BigInt(`0x${"f".padStart(i * 2, "f")}`) - 1n;
}
function O6t(t, e = {}) {
  let n = t;
  if (e.size && (vo(n, { size: e.size }), n = Ou(n)), Ou(n) === "0x00")
    return !1;
  if (Ou(n) === "0x01")
    return !0;
  throw new z6t(n);
}
function dl(t, e = {}) {
  return Number(as(t, e));
}
const B6t = /* @__PURE__ */ Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function fl(t, e = {}) {
  return typeof t == "number" || typeof t == "bigint" ? jt(t, e) : typeof t == "string" ? o2(t, e) : typeof t == "boolean" ? XY(t, e) : mr(t, e);
}
function XY(t, e = {}) {
  const n = `0x${Number(t)}`;
  return typeof e.size == "number" ? (vo(n, { size: e.size }), Rd(n, { size: e.size })) : n;
}
function mr(t, e = {}) {
  let n = "";
  for (let i = 0; i < t.length; i++)
    n += B6t[t[i]];
  const r = `0x${n}`;
  return typeof e.size == "number" ? (vo(r, { size: e.size }), Rd(r, { dir: "right", size: e.size })) : r;
}
function jt(t, e = {}) {
  const { signed: n, size: r } = e, i = BigInt(t);
  let a;
  r ? n ? a = (1n << BigInt(r) * 8n - 1n) - 1n : a = 2n ** (BigInt(r) * 8n) - 1n : typeof t == "number" && (a = BigInt(Number.MAX_SAFE_INTEGER));
  const o = typeof a == "bigint" && n ? -a - 1n : 0;
  if (a && i > a || i < o) {
    const l = typeof t == "bigint" ? "n" : "";
    throw new QY({
      max: a ? `${a}${l}` : void 0,
      min: `${o}${l}`,
      signed: n,
      size: r,
      value: `${t}${l}`
    });
  }
  const s = `0x${(n && i < 0 ? (1n << BigInt(r * 8)) + BigInt(i) : i).toString(16)}`;
  return r ? Rd(s, { size: r }) : s;
}
const H6t = /* @__PURE__ */ new TextEncoder();
function o2(t, e = {}) {
  const n = H6t.encode(t);
  return mr(n, e);
}
const F6t = /* @__PURE__ */ new TextEncoder();
function Od(t, e = {}) {
  return typeof t == "number" || typeof t == "bigint" ? V6t(t, e) : typeof t == "boolean" ? _6t(t, e) : is(t) ? so(t, e) : Bu(t, e);
}
function _6t(t, e = {}) {
  const n = new Uint8Array(1);
  return n[0] = Number(t), typeof e.size == "number" ? (vo(n, { size: e.size }), Rd(n, { size: e.size })) : n;
}
const As = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function yD(t) {
  if (t >= As.zero && t <= As.nine)
    return t - As.zero;
  if (t >= As.A && t <= As.F)
    return t - (As.A - 10);
  if (t >= As.a && t <= As.f)
    return t - (As.a - 10);
}
function so(t, e = {}) {
  let n = t;
  e.size && (vo(n, { size: e.size }), n = Rd(n, { dir: "right", size: e.size }));
  let r = n.slice(2);
  r.length % 2 && (r = `0${r}`);
  const i = r.length / 2, a = new Uint8Array(i);
  for (let o = 0, s = 0; o < i; o++) {
    const l = yD(r.charCodeAt(s++)), c = yD(r.charCodeAt(s++));
    if (l === void 0 || c === void 0)
      throw new We(`Invalid byte sequence ("${r[s - 2]}${r[s - 1]}" in "${r}").`);
    a[o] = l * 16 + c;
  }
  return a;
}
function V6t(t, e) {
  const n = jt(t, e);
  return so(n);
}
function Bu(t, e = {}) {
  const n = F6t.encode(t);
  return typeof e.size == "number" ? (vo(n, { size: e.size }), Rd(n, { dir: "right", size: e.size })) : n;
}
function Qy(t) {
  if (!Number.isSafeInteger(t) || t < 0)
    throw new Error("positive integer expected, got " + t);
}
function q6t(t) {
  return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function Ip(t, ...e) {
  if (!q6t(t))
    throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(t.length))
    throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function U6t(t) {
  if (typeof t != "function" || typeof t.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  Qy(t.outputLen), Qy(t.blockLen);
}
function J1(t, e = !0) {
  if (t.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && t.finished)
    throw new Error("Hash#digest() has already been called");
}
function eK(t, e) {
  Ip(t);
  const n = e.outputLen;
  if (t.length < n)
    throw new Error("digestInto() expects output buffer of length at least " + n);
}
const _m = /* @__PURE__ */ BigInt(2 ** 32 - 1), gD = /* @__PURE__ */ BigInt(32);
function W6t(t, e = !1) {
  return e ? { h: Number(t & _m), l: Number(t >> gD & _m) } : { h: Number(t >> gD & _m) | 0, l: Number(t & _m) | 0 };
}
function Z6t(t, e = !1) {
  let n = new Uint32Array(t.length), r = new Uint32Array(t.length);
  for (let i = 0; i < t.length; i++) {
    const { h: a, l: o } = W6t(t[i], e);
    [n[i], r[i]] = [a, o];
  }
  return [n, r];
}
const G6t = (t, e, n) => t << n | e >>> 32 - n, Y6t = (t, e, n) => e << n | t >>> 32 - n, K6t = (t, e, n) => e << n - 32 | t >>> 64 - n, $6t = (t, e, n) => t << n - 32 | e >>> 64 - n, V0 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function J6t(t) {
  return new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4));
}
function tv(t) {
  return new DataView(t.buffer, t.byteOffset, t.byteLength);
}
function Ao(t, e) {
  return t << 32 - e | t >>> e;
}
const vD = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
function Q6t(t) {
  return t << 24 & 4278190080 | t << 8 & 16711680 | t >>> 8 & 65280 | t >>> 24 & 255;
}
function bD(t) {
  for (let e = 0; e < t.length; e++)
    t[e] = Q6t(t[e]);
}
function X6t(t) {
  if (typeof t != "string")
    throw new Error("utf8ToBytes expected string, got " + typeof t);
  return new Uint8Array(new TextEncoder().encode(t));
}
function R6(t) {
  return typeof t == "string" && (t = X6t(t)), Ip(t), t;
}
function e5t(...t) {
  let e = 0;
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    Ip(i), e += i.length;
  }
  const n = new Uint8Array(e);
  for (let r = 0, i = 0; r < t.length; r++) {
    const a = t[r];
    n.set(a, i), i += a.length;
  }
  return n;
}
let FC = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function tK(t) {
  const e = (r) => t().update(R6(r)).digest(), n = t();
  return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = () => t(), e;
}
function t5t(t = 32) {
  if (V0 && typeof V0.getRandomValues == "function")
    return V0.getRandomValues(new Uint8Array(t));
  if (V0 && typeof V0.randomBytes == "function")
    return V0.randomBytes(t);
  throw new Error("crypto.getRandomValues must be defined");
}
const nK = [], rK = [], iK = [], n5t = /* @__PURE__ */ BigInt(0), mf = /* @__PURE__ */ BigInt(1), r5t = /* @__PURE__ */ BigInt(2), i5t = /* @__PURE__ */ BigInt(7), a5t = /* @__PURE__ */ BigInt(256), o5t = /* @__PURE__ */ BigInt(113);
for (let t = 0, e = mf, n = 1, r = 0; t < 24; t++) {
  [n, r] = [r, (2 * n + 3 * r) % 5], nK.push(2 * (5 * r + n)), rK.push((t + 1) * (t + 2) / 2 % 64);
  let i = n5t;
  for (let a = 0; a < 7; a++)
    e = (e << mf ^ (e >> i5t) * o5t) % a5t, e & r5t && (i ^= mf << (mf << /* @__PURE__ */ BigInt(a)) - mf);
  iK.push(i);
}
const [s5t, l5t] = /* @__PURE__ */ Z6t(iK, !0), wD = (t, e, n) => n > 32 ? K6t(t, e, n) : G6t(t, e, n), kD = (t, e, n) => n > 32 ? $6t(t, e, n) : Y6t(t, e, n);
function c5t(t, e = 24) {
  const n = new Uint32Array(10);
  for (let r = 24 - e; r < 24; r++) {
    for (let o = 0; o < 10; o++)
      n[o] = t[o] ^ t[o + 10] ^ t[o + 20] ^ t[o + 30] ^ t[o + 40];
    for (let o = 0; o < 10; o += 2) {
      const s = (o + 8) % 10, l = (o + 2) % 10, c = n[l], u = n[l + 1], d = wD(c, u, 1) ^ n[s], f = kD(c, u, 1) ^ n[s + 1];
      for (let h = 0; h < 50; h += 10)
        t[o + h] ^= d, t[o + h + 1] ^= f;
    }
    let i = t[2], a = t[3];
    for (let o = 0; o < 24; o++) {
      const s = rK[o], l = wD(i, a, s), c = kD(i, a, s), u = nK[o];
      i = t[u], a = t[u + 1], t[u] = l, t[u + 1] = c;
    }
    for (let o = 0; o < 50; o += 10) {
      for (let s = 0; s < 10; s++)
        n[s] = t[o + s];
      for (let s = 0; s < 10; s++)
        t[o + s] ^= ~n[(s + 2) % 10] & n[(s + 4) % 10];
    }
    t[0] ^= s5t[r], t[1] ^= l5t[r];
  }
  n.fill(0);
}
let u5t = class aK extends FC {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, n, r, i = !1, a = 24) {
    if (super(), this.blockLen = e, this.suffix = n, this.outputLen = r, this.enableXOF = i, this.rounds = a, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, Qy(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = J6t(this.state);
  }
  keccak() {
    vD || bD(this.state32), c5t(this.state32, this.rounds), vD || bD(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    J1(this);
    const { blockLen: n, state: r } = this;
    e = R6(e);
    const i = e.length;
    for (let a = 0; a < i; ) {
      const o = Math.min(n - this.pos, i - a);
      for (let s = 0; s < o; s++)
        r[this.pos++] ^= e[a++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: e, suffix: n, pos: r, blockLen: i } = this;
    e[r] ^= n, n & 128 && r === i - 1 && this.keccak(), e[i - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    J1(this, !1), Ip(e), this.finish();
    const n = this.state, { blockLen: r } = this;
    for (let i = 0, a = e.length; i < a; ) {
      this.posOut >= r && this.keccak();
      const o = Math.min(r - this.posOut, a - i);
      e.set(n.subarray(this.posOut, this.posOut + o), i), this.posOut += o, i += o;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return Qy(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (eK(e, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(e) {
    const { blockLen: n, suffix: r, outputLen: i, rounds: a, enableXOF: o } = this;
    return e || (e = new aK(n, r, i, o, a)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = a, e.suffix = r, e.outputLen = i, e.enableXOF = o, e.destroyed = this.destroyed, e;
  }
};
const d5t = (t, e, n) => tK(() => new u5t(e, t, n)), f5t = /* @__PURE__ */ d5t(1, 136, 256 / 8);
function Or(t, e) {
  const n = e || "hex", r = f5t(is(t, { strict: !1 }) ? Od(t) : t);
  return n === "bytes" ? r : fl(r);
}
const h5t = (t) => Or(Od(t));
function p5t(t) {
  return h5t(t);
}
function m5t(t) {
  let e = !0, n = "", r = 0, i = "", a = !1;
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    if (["(", ")", ","].includes(s) && (e = !0), s === "(" && r++, s === ")" && r--, !!e) {
      if (r === 0) {
        if (s === " " && ["event", "function", ""].includes(i))
          i = "";
        else if (i += s, s === ")") {
          a = !0;
          break;
        }
        continue;
      }
      if (s === " ") {
        t[o - 1] !== "," && n !== "," && n !== ",(" && (n = "", e = !1);
        continue;
      }
      i += s, n += s;
    }
  }
  if (!a)
    throw new We("Unable to normalize signature.");
  return i;
}
const y5t = (t) => {
  const e = typeof t == "string" ? t : $y(t);
  return m5t(e);
};
function oK(t) {
  return p5t(y5t(t));
}
const O6 = oK;
let Cc = class extends We {
  constructor({ address: e }) {
    super(`Address "${e}" is invalid.`, {
      metaMessages: [
        "- Address must be a hex value of 20 bytes (40 hex characters).",
        "- Address must match its checksum counterpart."
      ],
      name: "InvalidAddressError"
    });
  }
}, _C = class extends Map {
  constructor(e) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = e;
  }
  get(e) {
    const n = super.get(e);
    return super.has(e) && n !== void 0 && (this.delete(e), super.set(e, n)), n;
  }
  set(e, n) {
    if (super.set(e, n), this.maxSize && this.size > this.maxSize) {
      const r = this.keys().next().value;
      r && this.delete(r);
    }
    return this;
  }
};
const nv = /* @__PURE__ */ new _C(8192);
function B6(t, e) {
  if (nv.has(`${t}.${e}`))
    return nv.get(`${t}.${e}`);
  const n = t.substring(2).toLowerCase(), r = Or(Bu(n), "bytes"), i = n.split("");
  for (let o = 0; o < 40; o += 2)
    r[o >> 1] >> 4 >= 8 && i[o] && (i[o] = i[o].toUpperCase()), (r[o >> 1] & 15) >= 8 && i[o + 1] && (i[o + 1] = i[o + 1].toUpperCase());
  const a = `0x${i.join("")}`;
  return nv.set(`${t}.${e}`, a), a;
}
function g5t(t, e) {
  if (!Ia(t, { strict: !1 }))
    throw new Cc({ address: t });
  return B6(t, e);
}
const v5t = /^0x[a-fA-F0-9]{40}$/, rv = /* @__PURE__ */ new _C(8192);
function Ia(t, e) {
  const { strict: n = !0 } = e ?? {}, r = `${t}.${n}`;
  if (rv.has(r))
    return rv.get(r);
  const i = v5t.test(t) ? t.toLowerCase() === t ? !0 : n ? B6(t) === t : !0 : !1;
  return rv.set(r, i), i;
}
function hl(t) {
  return typeof t[0] == "string" ? Pp(t) : b5t(t);
}
function b5t(t) {
  let e = 0;
  for (const i of t)
    e += i.length;
  const n = new Uint8Array(e);
  let r = 0;
  for (const i of t)
    n.set(i, r), r += i.length;
  return n;
}
function Pp(t) {
  return `0x${t.reduce((e, n) => e + n.replace("0x", ""), "")}`;
}
function Xy(t, e, n, { strict: r } = {}) {
  return is(t, { strict: !1 }) ? uK(t, e, n, {
    strict: r
  }) : cK(t, e, n, {
    strict: r
  });
}
function sK(t, e) {
  if (typeof e == "number" && e > 0 && e > tr(t) - 1)
    throw new $Y({
      offset: e,
      position: "start",
      size: tr(t)
    });
}
function lK(t, e, n) {
  if (typeof e == "number" && typeof n == "number" && tr(t) !== n - e)
    throw new $Y({
      offset: n,
      position: "end",
      size: tr(t)
    });
}
function cK(t, e, n, { strict: r } = {}) {
  sK(t, e);
  const i = t.slice(e, n);
  return r && lK(i, e, n), i;
}
function uK(t, e, n, { strict: r } = {}) {
  sK(t, e);
  const i = `0x${t.replace("0x", "").slice((e ?? 0) * 2, (n ?? t.length) * 2)}`;
  return r && lK(i, e, n), i;
}
const w5t = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/, dK = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
function Bd(t, e) {
  if (t.length !== e.length)
    throw new M6t({
      expectedLength: t.length,
      givenLength: e.length
    });
  const n = k5t({
    params: t,
    values: e
  }), r = qC(n);
  return r.length === 0 ? "0x" : r;
}
function k5t({ params: t, values: e }) {
  const n = [];
  for (let r = 0; r < t.length; r++)
    n.push(VC({ param: t[r], value: e[r] }));
  return n;
}
function VC({ param: t, value: e }) {
  const n = UC(t.type);
  if (n) {
    const [r, i] = n;
    return M5t(e, { length: r, param: { ...t, type: i } });
  }
  if (t.type === "tuple")
    return T5t(e, {
      param: t
    });
  if (t.type === "address")
    return x5t(e);
  if (t.type === "bool")
    return A5t(e);
  if (t.type.startsWith("uint") || t.type.startsWith("int")) {
    const r = t.type.startsWith("int"), [, , i = "256"] = dK.exec(t.type) ?? [];
    return S5t(e, {
      signed: r,
      size: Number(i)
    });
  }
  if (t.type.startsWith("bytes"))
    return C5t(e, { param: t });
  if (t.type === "string")
    return L5t(e);
  throw new T6t(t.type, {
    docsPath: "/docs/contract/encodeAbiParameters"
  });
}
function qC(t) {
  let e = 0;
  for (let a = 0; a < t.length; a++) {
    const { dynamic: o, encoded: s } = t[a];
    o ? e += 32 : e += tr(s);
  }
  const n = [], r = [];
  let i = 0;
  for (let a = 0; a < t.length; a++) {
    const { dynamic: o, encoded: s } = t[a];
    o ? (n.push(jt(e + i, { size: 32 })), r.push(s), i += tr(s)) : n.push(s);
  }
  return hl([...n, ...r]);
}
function x5t(t) {
  if (!Ia(t))
    throw new Cc({ address: t });
  return { dynamic: !1, encoded: pc(t.toLowerCase()) };
}
function M5t(t, { length: e, param: n }) {
  const r = e === null;
  if (!Array.isArray(t))
    throw new j6t(t);
  if (!r && t.length !== e)
    throw new k6t({
      expectedLength: e,
      givenLength: t.length,
      type: `${n.type}[${e}]`
    });
  let i = !1;
  const a = [];
  for (let o = 0; o < t.length; o++) {
    const s = VC({ param: n, value: t[o] });
    s.dynamic && (i = !0), a.push(s);
  }
  if (r || i) {
    const o = qC(a);
    if (r) {
      const s = jt(a.length, { size: 32 });
      return {
        dynamic: !0,
        encoded: a.length > 0 ? hl([s, o]) : s
      };
    }
    if (i)
      return { dynamic: !0, encoded: o };
  }
  return {
    dynamic: !1,
    encoded: hl(a.map(({ encoded: o }) => o))
  };
}
function C5t(t, { param: e }) {
  const [, n] = e.type.split("bytes"), r = tr(t);
  if (!n) {
    let i = t;
    return r % 32 !== 0 && (i = pc(i, {
      dir: "right",
      size: Math.ceil((t.length - 2) / 2 / 32) * 32
    })), {
      dynamic: !0,
      encoded: hl([pc(jt(r, { size: 32 })), i])
    };
  }
  if (r !== Number.parseInt(n))
    throw new x6t({
      expectedSize: Number.parseInt(n),
      value: t
    });
  return { dynamic: !1, encoded: pc(t, { dir: "right" }) };
}
function A5t(t) {
  if (typeof t != "boolean")
    throw new We(`Invalid boolean value: "${t}" (type: ${typeof t}). Expected: \`true\` or \`false\`.`);
  return { dynamic: !1, encoded: pc(XY(t)) };
}
function S5t(t, { signed: e, size: n = 256 }) {
  if (typeof n == "number") {
    const r = 2n ** (BigInt(n) - (e ? 1n : 0n)) - 1n, i = e ? -r - 1n : 0n;
    if (t > r || t < i)
      throw new QY({
        max: r.toString(),
        min: i.toString(),
        signed: e,
        size: n / 8,
        value: t.toString()
      });
  }
  return {
    dynamic: !1,
    encoded: jt(t, {
      size: 32,
      signed: e
    })
  };
}
function L5t(t) {
  const e = o2(t), n = Math.ceil(tr(e) / 32), r = [];
  for (let i = 0; i < n; i++)
    r.push(pc(Xy(e, i * 32, (i + 1) * 32), {
      dir: "right"
    }));
  return {
    dynamic: !0,
    encoded: hl([
      pc(jt(tr(e), { size: 32 })),
      ...r
    ])
  };
}
function T5t(t, { param: e }) {
  let n = !1;
  const r = [];
  for (let i = 0; i < e.components.length; i++) {
    const a = e.components[i], o = Array.isArray(t) ? i : a.name, s = VC({
      param: a,
      value: t[o]
    });
    r.push(s), s.dynamic && (n = !0);
  }
  return {
    dynamic: n,
    encoded: n ? qC(r) : hl(r.map(({ encoded: i }) => i))
  };
}
function UC(t) {
  const e = t.match(/^(.*)\[(\d+)?\]$/);
  return e ? (
    // Return `null` if the array is dynamic.
    [e[2] ? Number(e[2]) : null, e[1]]
  ) : void 0;
}
const WC = (t) => Xy(oK(t), 0, 4);
function zp(t) {
  const { abi: e, args: n = [], name: r } = t, i = is(r, { strict: !1 }), a = e.filter((s) => i ? s.type === "function" ? WC(s) === r : s.type === "event" ? O6(s) === r : !1 : "name" in s && s.name === r);
  if (a.length === 0)
    return;
  if (a.length === 1)
    return a[0];
  let o;
  for (const s of a) {
    if (!("inputs" in s))
      continue;
    if (!n || n.length === 0) {
      if (!s.inputs || s.inputs.length === 0)
        return s;
      continue;
    }
    if (!s.inputs || s.inputs.length === 0 || s.inputs.length !== n.length)
      continue;
    if (n.every((c, u) => {
      const d = "inputs" in s && s.inputs[u];
      return d ? V9(c, d) : !1;
    })) {
      if (o && "inputs" in o && o.inputs) {
        const c = fK(s.inputs, o.inputs, n);
        if (c)
          throw new S6t({
            abiItem: s,
            type: c[0]
          }, {
            abiItem: o,
            type: c[1]
          });
      }
      o = s;
    }
  }
  return o || a[0];
}
function V9(t, e) {
  const n = typeof t, r = e.type;
  switch (r) {
    case "address":
      return Ia(t, { strict: !1 });
    case "bool":
      return n === "boolean";
    case "function":
      return n === "string";
    case "string":
      return n === "string";
    default:
      return r === "tuple" && "components" in e ? Object.values(e.components).every((i, a) => V9(Object.values(t)[a], i)) : /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(r) ? n === "number" || n === "bigint" : /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(r) ? n === "string" || t instanceof Uint8Array : /[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(r) ? Array.isArray(t) && t.every((i) => V9(i, {
        ...e,
        // Pop off `[]` or `[M]` from end of type
        type: r.replace(/(\[[0-9]{0,}\])$/, "")
      })) : !1;
  }
}
function fK(t, e, n) {
  for (const r in t) {
    const i = t[r], a = e[r];
    if (i.type === "tuple" && a.type === "tuple" && "components" in i && "components" in a)
      return fK(i.components, a.components, n[r]);
    const o = [i.type, a.type];
    if (o.includes("address") && o.includes("bytes20") ? !0 : o.includes("address") && o.includes("string") ? Ia(n[r], { strict: !1 }) : o.includes("address") && o.includes("bytes") ? Ia(n[r], { strict: !1 }) : !1)
      return o;
  }
}
const xD = "/docs/contract/encodeEventTopics";
function Rp(t) {
  var l;
  const { abi: e, eventName: n, args: r } = t;
  let i = e[0];
  if (n) {
    const c = zp({ abi: e, name: n });
    if (!c)
      throw new pD(n, { docsPath: xD });
    i = c;
  }
  if (i.type !== "event")
    throw new pD(void 0, { docsPath: xD });
  const a = ul(i), o = O6(a);
  let s = [];
  if (r && "inputs" in i) {
    const c = (l = i.inputs) == null ? void 0 : l.filter((d) => "indexed" in d && d.indexed), u = Array.isArray(r) ? r : Object.values(r).length > 0 ? (c == null ? void 0 : c.map((d) => r[d.name])) ?? [] : [];
    u.length > 0 && (s = (c == null ? void 0 : c.map((d, f) => Array.isArray(u[f]) ? u[f].map((h, p) => MD({ param: d, value: u[f][p] })) : typeof u[f] < "u" && u[f] !== null ? MD({ param: d, value: u[f] }) : null)) ?? []);
  }
  return [o, ...s];
}
function MD({ param: t, value: e }) {
  if (t.type === "string" || t.type === "bytes")
    return Or(Od(e));
  if (t.type === "tuple" || t.type.match(/^(.*)\[(\d+)?\]$/))
    throw new D6t(t.type);
  return Bd([t], [e]);
}
function H6(t, { method: e }) {
  var r, i;
  const n = {};
  return t.transport.type === "fallback" && ((i = (r = t.transport).onResponse) == null || i.call(r, ({ method: a, response: o, status: s, transport: l }) => {
    s === "success" && e === a && (n[o] = l.request);
  })), (a) => n[a] || t.request;
}
async function hK(t, e) {
  const { address: n, abi: r, args: i, eventName: a, fromBlock: o, strict: s, toBlock: l } = e, c = H6(t, {
    method: "eth_newFilter"
  }), u = a ? Rp({
    abi: r,
    args: i,
    eventName: a
  }) : void 0, d = await t.request({
    method: "eth_newFilter",
    params: [
      {
        address: n,
        fromBlock: typeof o == "bigint" ? jt(o) : o,
        toBlock: typeof l == "bigint" ? jt(l) : l,
        topics: u
      }
    ]
  });
  return {
    abi: r,
    args: i,
    eventName: a,
    id: d,
    request: c(d),
    strict: !!s,
    type: "event"
  };
}
function bo(t) {
  return typeof t == "string" ? { address: t, type: "json-rpc" } : t;
}
const CD = "/docs/contract/encodeFunctionData";
function E5t(t) {
  const { abi: e, args: n, functionName: r } = t;
  let i = e[0];
  if (r) {
    const a = zp({
      abi: e,
      args: n,
      name: r
    });
    if (!a)
      throw new Jy(r, { docsPath: CD });
    i = a;
  }
  if (i.type !== "function")
    throw new Jy(void 0, { docsPath: CD });
  return {
    abi: [i],
    functionName: WC(ul(i))
  };
}
function hs(t) {
  const { args: e } = t, { abi: n, functionName: r } = (() => {
    var s;
    return t.abi.length === 1 && ((s = t.functionName) != null && s.startsWith("0x")) ? t : E5t(t);
  })(), i = n[0], a = r, o = "inputs" in i && i.inputs ? Bd(i.inputs, e ?? []) : void 0;
  return Pp([a, o ?? "0x"]);
}
const pK = {
  1: "An `assert` condition failed.",
  17: "Arithmetic operation resulted in underflow or overflow.",
  18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
  33: "Attempted to convert to an invalid type.",
  34: "Attempted to access a storage byte array that is incorrectly encoded.",
  49: "Performed `.pop()` on an empty array",
  50: "Array index is out of bounds.",
  65: "Allocated too much memory or created an array which is too large.",
  81: "Attempted to call a zero-initialized variable of internal function type."
}, j5t = {
  inputs: [
    {
      name: "message",
      type: "string"
    }
  ],
  name: "Error",
  type: "error"
}, N5t = {
  inputs: [
    {
      name: "reason",
      type: "uint256"
    }
  ],
  name: "Panic",
  type: "error"
};
class AD extends We {
  constructor({ offset: e }) {
    super(`Offset \`${e}\` cannot be negative.`, {
      name: "NegativeOffsetError"
    });
  }
}
class mK extends We {
  constructor({ length: e, position: n }) {
    super(`Position \`${n}\` is out of bounds (\`0 < position < ${e}\`).`, { name: "PositionOutOfBoundsError" });
  }
}
class D5t extends We {
  constructor({ count: e, limit: n }) {
    super(`Recursive read limit of \`${n}\` exceeded (recursive read count: \`${e}\`).`, { name: "RecursiveReadLimitExceededError" });
  }
}
const I5t = {
  bytes: new Uint8Array(),
  dataView: new DataView(new ArrayBuffer(0)),
  position: 0,
  positionReadCount: /* @__PURE__ */ new Map(),
  recursiveReadCount: 0,
  recursiveReadLimit: Number.POSITIVE_INFINITY,
  assertReadLimit() {
    if (this.recursiveReadCount >= this.recursiveReadLimit)
      throw new D5t({
        count: this.recursiveReadCount + 1,
        limit: this.recursiveReadLimit
      });
  },
  assertPosition(t) {
    if (t < 0 || t > this.bytes.length - 1)
      throw new mK({
        length: this.bytes.length,
        position: t
      });
  },
  decrementPosition(t) {
    if (t < 0)
      throw new AD({ offset: t });
    const e = this.position - t;
    this.assertPosition(e), this.position = e;
  },
  getReadCount(t) {
    return this.positionReadCount.get(t || this.position) || 0;
  },
  incrementPosition(t) {
    if (t < 0)
      throw new AD({ offset: t });
    const e = this.position + t;
    this.assertPosition(e), this.position = e;
  },
  inspectByte(t) {
    const e = t ?? this.position;
    return this.assertPosition(e), this.bytes[e];
  },
  inspectBytes(t, e) {
    const n = e ?? this.position;
    return this.assertPosition(n + t - 1), this.bytes.subarray(n, n + t);
  },
  inspectUint8(t) {
    const e = t ?? this.position;
    return this.assertPosition(e), this.bytes[e];
  },
  inspectUint16(t) {
    const e = t ?? this.position;
    return this.assertPosition(e + 1), this.dataView.getUint16(e);
  },
  inspectUint24(t) {
    const e = t ?? this.position;
    return this.assertPosition(e + 2), (this.dataView.getUint16(e) << 8) + this.dataView.getUint8(e + 2);
  },
  inspectUint32(t) {
    const e = t ?? this.position;
    return this.assertPosition(e + 3), this.dataView.getUint32(e);
  },
  pushByte(t) {
    this.assertPosition(this.position), this.bytes[this.position] = t, this.position++;
  },
  pushBytes(t) {
    this.assertPosition(this.position + t.length - 1), this.bytes.set(t, this.position), this.position += t.length;
  },
  pushUint8(t) {
    this.assertPosition(this.position), this.bytes[this.position] = t, this.position++;
  },
  pushUint16(t) {
    this.assertPosition(this.position + 1), this.dataView.setUint16(this.position, t), this.position += 2;
  },
  pushUint24(t) {
    this.assertPosition(this.position + 2), this.dataView.setUint16(this.position, t >> 8), this.dataView.setUint8(this.position + 2, t & 255), this.position += 3;
  },
  pushUint32(t) {
    this.assertPosition(this.position + 3), this.dataView.setUint32(this.position, t), this.position += 4;
  },
  readByte() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectByte();
    return this.position++, t;
  },
  readBytes(t, e) {
    this.assertReadLimit(), this._touch();
    const n = this.inspectBytes(t);
    return this.position += e ?? t, n;
  },
  readUint8() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectUint8();
    return this.position += 1, t;
  },
  readUint16() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectUint16();
    return this.position += 2, t;
  },
  readUint24() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectUint24();
    return this.position += 3, t;
  },
  readUint32() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectUint32();
    return this.position += 4, t;
  },
  get remaining() {
    return this.bytes.length - this.position;
  },
  setPosition(t) {
    const e = this.position;
    return this.assertPosition(t), this.position = t, () => this.position = e;
  },
  _touch() {
    if (this.recursiveReadLimit === Number.POSITIVE_INFINITY)
      return;
    const t = this.getReadCount();
    this.positionReadCount.set(this.position, t + 1), t > 0 && this.recursiveReadCount++;
  }
};
function ZC(t, { recursiveReadLimit: e = 8192 } = {}) {
  const n = Object.create(I5t);
  return n.bytes = t, n.dataView = new DataView(t.buffer, t.byteOffset, t.byteLength), n.positionReadCount = /* @__PURE__ */ new Map(), n.recursiveReadLimit = e, n;
}
function P5t(t, e = {}) {
  typeof e.size < "u" && vo(t, { size: e.size });
  const n = mr(t, e);
  return as(n, e);
}
function z5t(t, e = {}) {
  let n = t;
  if (typeof e.size < "u" && (vo(n, { size: e.size }), n = Ou(n)), n.length > 1 || n[0] > 1)
    throw new P6t(n);
  return !!n[0];
}
function Js(t, e = {}) {
  typeof e.size < "u" && vo(t, { size: e.size });
  const n = mr(t, e);
  return dl(n, e);
}
function R5t(t, e = {}) {
  let n = t;
  return typeof e.size < "u" && (vo(n, { size: e.size }), n = Ou(n, { dir: "right" })), new TextDecoder().decode(n);
}
function F6(t, e) {
  const n = typeof e == "string" ? so(e) : e, r = ZC(n);
  if (tr(n) === 0 && t.length > 0)
    throw new Dp();
  if (tr(e) && tr(e) < 32)
    throw new GY({
      data: typeof e == "string" ? e : mr(e),
      params: t,
      size: tr(e)
    });
  let i = 0;
  const a = [];
  for (let o = 0; o < t.length; ++o) {
    const s = t[o];
    r.setPosition(i);
    const [l, c] = k1(r, s, {
      staticPosition: 0
    });
    i += c, a.push(l);
  }
  return a;
}
function k1(t, e, { staticPosition: n }) {
  const r = UC(e.type);
  if (r) {
    const [i, a] = r;
    return B5t(t, { ...e, type: a }, { length: i, staticPosition: n });
  }
  if (e.type === "tuple")
    return V5t(t, e, { staticPosition: n });
  if (e.type === "address")
    return O5t(t);
  if (e.type === "bool")
    return H5t(t);
  if (e.type.startsWith("bytes"))
    return F5t(t, e, { staticPosition: n });
  if (e.type.startsWith("uint") || e.type.startsWith("int"))
    return _5t(t, e);
  if (e.type === "string")
    return q5t(t, { staticPosition: n });
  throw new E6t(e.type, {
    docsPath: "/docs/contract/decodeAbiParameters"
  });
}
const SD = 32, q9 = 32;
function O5t(t) {
  const e = t.readBytes(32);
  return [B6(mr(cK(e, -20))), 32];
}
function B5t(t, e, { length: n, staticPosition: r }) {
  if (!n) {
    const o = Js(t.readBytes(q9)), s = r + o, l = s + SD;
    t.setPosition(s);
    const c = Js(t.readBytes(SD)), u = s2(e);
    let d = 0;
    const f = [];
    for (let h = 0; h < c; ++h) {
      t.setPosition(l + (u ? h * 32 : d));
      const [p, m] = k1(t, e, {
        staticPosition: l
      });
      d += m, f.push(p);
    }
    return t.setPosition(r + 32), [f, 32];
  }
  if (s2(e)) {
    const o = Js(t.readBytes(q9)), s = r + o, l = [];
    for (let c = 0; c < n; ++c) {
      t.setPosition(s + c * 32);
      const [u] = k1(t, e, {
        staticPosition: s
      });
      l.push(u);
    }
    return t.setPosition(r + 32), [l, 32];
  }
  let i = 0;
  const a = [];
  for (let o = 0; o < n; ++o) {
    const [s, l] = k1(t, e, {
      staticPosition: r + i
    });
    i += l, a.push(s);
  }
  return [a, i];
}
function H5t(t) {
  return [z5t(t.readBytes(32), { size: 32 }), 32];
}
function F5t(t, e, { staticPosition: n }) {
  const [r, i] = e.type.split("bytes");
  if (!i) {
    const o = Js(t.readBytes(32));
    t.setPosition(n + o);
    const s = Js(t.readBytes(32));
    if (s === 0)
      return t.setPosition(n + 32), ["0x", 32];
    const l = t.readBytes(s);
    return t.setPosition(n + 32), [mr(l), 32];
  }
  return [mr(t.readBytes(Number.parseInt(i), 32)), 32];
}
function _5t(t, e) {
  const n = e.type.startsWith("int"), r = Number.parseInt(e.type.split("int")[1] || "256"), i = t.readBytes(32);
  return [
    r > 48 ? P5t(i, { signed: n }) : Js(i, { signed: n }),
    32
  ];
}
function V5t(t, e, { staticPosition: n }) {
  const r = e.components.length === 0 || e.components.some(({ name: o }) => !o), i = r ? [] : {};
  let a = 0;
  if (s2(e)) {
    const o = Js(t.readBytes(q9)), s = n + o;
    for (let l = 0; l < e.components.length; ++l) {
      const c = e.components[l];
      t.setPosition(s + a);
      const [u, d] = k1(t, c, {
        staticPosition: s
      });
      a += d, i[r ? l : c == null ? void 0 : c.name] = u;
    }
    return t.setPosition(n + 32), [i, 32];
  }
  for (let o = 0; o < e.components.length; ++o) {
    const s = e.components[o], [l, c] = k1(t, s, {
      staticPosition: n
    });
    i[r ? o : s == null ? void 0 : s.name] = l, a += c;
  }
  return [i, a];
}
function q5t(t, { staticPosition: e }) {
  const n = Js(t.readBytes(32)), r = e + n;
  t.setPosition(r);
  const i = Js(t.readBytes(32));
  if (i === 0)
    return t.setPosition(e + 32), ["", 32];
  const a = t.readBytes(i, 32), o = R5t(Ou(a));
  return t.setPosition(e + 32), [o, 32];
}
function s2(t) {
  var r;
  const { type: e } = t;
  if (e === "string" || e === "bytes" || e.endsWith("[]"))
    return !0;
  if (e === "tuple")
    return (r = t.components) == null ? void 0 : r.some(s2);
  const n = UC(t.type);
  return !!(n && s2({ ...t, type: n[1] }));
}
function U5t(t) {
  const { abi: e, data: n } = t, r = Xy(n, 0, 4);
  if (r === "0x")
    throw new Dp();
  const a = [...e || [], j5t, N5t].find((o) => o.type === "error" && r === WC(ul(o)));
  if (!a)
    throw new YY(r, {
      docsPath: "/docs/contract/decodeErrorResult"
    });
  return {
    abiItem: a,
    args: "inputs" in a && a.inputs && a.inputs.length > 0 ? F6(a.inputs, Xy(n, 4)) : void 0,
    errorName: a.name
  };
}
const Hr = (t, e, n) => JSON.stringify(t, (r, i) => typeof i == "bigint" ? i.toString() : i, n);
function yK({ abiItem: t, args: e, includeFunctionName: n = !0, includeName: r = !1 }) {
  if ("name" in t && "inputs" in t && t.inputs)
    return `${n ? t.name : ""}(${t.inputs.map((i, a) => `${r && i.name ? `${i.name}: ` : ""}${typeof e[a] == "object" ? Hr(e[a]) : e[a]}`).join(", ")})`;
}
const W5t = {
  gwei: 9,
  wei: 18
}, Z5t = {
  ether: -9,
  wei: 9
};
function gK(t, e) {
  let n = t.toString();
  const r = n.startsWith("-");
  r && (n = n.slice(1)), n = n.padStart(e, "0");
  let [i, a] = [
    n.slice(0, n.length - e),
    n.slice(n.length - e)
  ];
  return a = a.replace(/(0+)$/, ""), `${r ? "-" : ""}${i || "0"}${a ? `.${a}` : ""}`;
}
function vK(t, e = "wei") {
  return gK(t, W5t[e]);
}
function no(t, e = "wei") {
  return gK(t, Z5t[e]);
}
class G5t extends We {
  constructor({ address: e }) {
    super(`State for account "${e}" is set multiple times.`, {
      name: "AccountStateConflictError"
    });
  }
}
class Y5t extends We {
  constructor() {
    super("state and stateDiff are set on the same account.", {
      name: "StateAssignmentConflictError"
    });
  }
}
function LD(t) {
  return t.reduce((e, { slot: n, value: r }) => `${e}        ${n}: ${r}
`, "");
}
function K5t(t) {
  return t.reduce((e, { address: n, ...r }) => {
    let i = `${e}    ${n}:
`;
    return r.nonce && (i += `      nonce: ${r.nonce}
`), r.balance && (i += `      balance: ${r.balance}
`), r.code && (i += `      code: ${r.code}
`), r.state && (i += `      state:
`, i += LD(r.state)), r.stateDiff && (i += `      stateDiff:
`, i += LD(r.stateDiff)), i;
  }, `  State Override:
`).slice(0, -1);
}
function _6(t) {
  const e = Object.entries(t).map(([r, i]) => i === void 0 || i === !1 ? null : [r, i]).filter(Boolean), n = e.reduce((r, [i]) => Math.max(r, i.length), 0);
  return e.map(([r, i]) => `  ${`${r}:`.padEnd(n + 1)}  ${i}`).join(`
`);
}
class $5t extends We {
  constructor() {
    super([
      "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
      "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
    ].join(`
`), { name: "FeeConflictError" });
  }
}
class J5t extends We {
  constructor({ transaction: e }) {
    super("Cannot infer a transaction type from provided transaction.", {
      metaMessages: [
        "Provided Transaction:",
        "{",
        _6(e),
        "}",
        "",
        "To infer the type, either provide:",
        "- a `type` to the Transaction, or",
        "- an EIP-1559 Transaction with `maxFeePerGas`, or",
        "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
        "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
        "- an EIP-7702 Transaction with `authorizationList`, or",
        "- a Legacy Transaction with `gasPrice`"
      ],
      name: "InvalidSerializableTransactionError"
    });
  }
}
class bK extends We {
  constructor({ blockHash: e, blockNumber: n, blockTag: r, hash: i, index: a }) {
    let o = "Transaction";
    r && a !== void 0 && (o = `Transaction at block time "${r}" at index "${a}"`), e && a !== void 0 && (o = `Transaction at block hash "${e}" at index "${a}"`), n && a !== void 0 && (o = `Transaction at block number "${n}" at index "${a}"`), i && (o = `Transaction with hash "${i}"`), super(`${o} could not be found.`, {
      name: "TransactionNotFoundError"
    });
  }
}
class wK extends We {
  constructor({ hash: e }) {
    super(`Transaction receipt with hash "${e}" could not be found. The Transaction may not be processed on a block yet.`, {
      name: "TransactionReceiptNotFoundError"
    });
  }
}
class Q5t extends We {
  constructor({ hash: e }) {
    super(`Timed out while waiting for transaction with hash "${e}" to be confirmed.`, { name: "WaitForTransactionReceiptTimeoutError" });
  }
}
const X5t = (t) => t, GC = (t) => t;
class kK extends We {
  constructor(e, { account: n, docsPath: r, chain: i, data: a, gas: o, gasPrice: s, maxFeePerGas: l, maxPriorityFeePerGas: c, nonce: u, to: d, value: f, stateOverride: h }) {
    var g;
    const p = n ? bo(n) : void 0;
    let m = _6({
      from: p == null ? void 0 : p.address,
      to: d,
      value: typeof f < "u" && `${vK(f)} ${((g = i == null ? void 0 : i.nativeCurrency) == null ? void 0 : g.symbol) || "ETH"}`,
      data: a,
      gas: o,
      gasPrice: typeof s < "u" && `${no(s)} gwei`,
      maxFeePerGas: typeof l < "u" && `${no(l)} gwei`,
      maxPriorityFeePerGas: typeof c < "u" && `${no(c)} gwei`,
      nonce: u
    });
    h && (m += `
${K5t(h)}`), super(e.shortMessage, {
      cause: e,
      docsPath: r,
      metaMessages: [
        ...e.metaMessages ? [...e.metaMessages, " "] : [],
        "Raw Call Arguments:",
        m
      ].filter(Boolean),
      name: "CallExecutionError"
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.cause = e;
  }
}
class e8t extends We {
  constructor(e, { abi: n, args: r, contractAddress: i, docsPath: a, functionName: o, sender: s }) {
    const l = zp({ abi: n, args: r, name: o }), c = l ? yK({
      abiItem: l,
      args: r,
      includeFunctionName: !1,
      includeName: !1
    }) : void 0, u = l ? ul(l, { includeName: !0 }) : void 0, d = _6({
      address: i && X5t(i),
      function: u,
      args: c && c !== "()" && `${[...Array((o == null ? void 0 : o.length) ?? 0).keys()].map(() => " ").join("")}${c}`,
      sender: s
    });
    super(e.shortMessage || `An unknown error occurred while executing the contract function "${o}".`, {
      cause: e,
      docsPath: a,
      metaMessages: [
        ...e.metaMessages ? [...e.metaMessages, " "] : [],
        d && "Contract Call:",
        d
      ].filter(Boolean),
      name: "ContractFunctionExecutionError"
    }), Object.defineProperty(this, "abi", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "args", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "contractAddress", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "formattedArgs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "functionName", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "sender", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.abi = n, this.args = r, this.cause = e, this.contractAddress = i, this.functionName = o, this.sender = s;
  }
}
class U9 extends We {
  constructor({ abi: e, data: n, functionName: r, message: i }) {
    let a, o, s, l;
    if (n && n !== "0x")
      try {
        o = U5t({ abi: e, data: n });
        const { abiItem: u, errorName: d, args: f } = o;
        if (d === "Error")
          l = f[0];
        else if (d === "Panic") {
          const [h] = f;
          l = pK[h];
        } else {
          const h = u ? ul(u, { includeName: !0 }) : void 0, p = u && f ? yK({
            abiItem: u,
            args: f,
            includeFunctionName: !1,
            includeName: !1
          }) : void 0;
          s = [
            h ? `Error: ${h}` : "",
            p && p !== "()" ? `       ${[...Array((d == null ? void 0 : d.length) ?? 0).keys()].map(() => " ").join("")}${p}` : ""
          ];
        }
      } catch (u) {
        a = u;
      }
    else i && (l = i);
    let c;
    a instanceof YY && (c = a.signature, s = [
      `Unable to decode signature "${c}" as it was not found on the provided ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${c}.`
    ]), super(l && l !== "execution reverted" || c ? [
      `The contract function "${r}" reverted with the following ${c ? "signature" : "reason"}:`,
      l || c
    ].join(`
`) : `The contract function "${r}" reverted.`, {
      cause: a,
      metaMessages: s,
      name: "ContractFunctionRevertedError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "raw", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "reason", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = o, this.raw = n, this.reason = l, this.signature = c;
  }
}
class t8t extends We {
  constructor({ functionName: e }) {
    super(`The contract function "${e}" returned no data ("0x").`, {
      metaMessages: [
        "This could be due to any of the following:",
        `  - The contract does not have the function "${e}",`,
        "  - The parameters passed to the contract function may be invalid, or",
        "  - The address is not a contract."
      ],
      name: "ContractFunctionZeroDataError"
    });
  }
}
class n8t extends We {
  constructor({ factory: e }) {
    super(`Deployment for counterfactual contract call failed${e ? ` for factory "${e}".` : ""}`, {
      metaMessages: [
        "Please ensure:",
        "- The `factory` is a valid contract deployment factory (ie. Create2 Factory, ERC-4337 Factory, etc).",
        "- The `factoryData` is a valid encoded function call for contract deployment function on the factory."
      ],
      name: "CounterfactualDeploymentFailedError"
    });
  }
}
class V6 extends We {
  constructor({ data: e, message: n }) {
    super(n || "", { name: "RawContractError" }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 3
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = e;
  }
}
class sh extends We {
  constructor({ body: e, cause: n, details: r, headers: i, status: a, url: o }) {
    super("HTTP request failed.", {
      cause: n,
      details: r,
      metaMessages: [
        a && `Status: ${a}`,
        `URL: ${GC(o)}`,
        e && `Request body: ${Hr(e)}`
      ].filter(Boolean),
      name: "HttpRequestError"
    }), Object.defineProperty(this, "body", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "headers", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "status", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "url", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.body = e, this.headers = i, this.status = a, this.url = o;
  }
}
class YC extends We {
  constructor({ body: e, error: n, url: r }) {
    super("RPC Request failed.", {
      cause: n,
      details: n.message,
      metaMessages: [`URL: ${GC(r)}`, `Request body: ${Hr(e)}`],
      name: "RpcRequestError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.code = n.code, this.data = n.data;
  }
}
class TD extends We {
  constructor({ body: e, url: n }) {
    super("The request took too long to respond.", {
      details: "The request timed out.",
      metaMessages: [`URL: ${GC(n)}`, `Request body: ${Hr(e)}`],
      name: "TimeoutError"
    });
  }
}
const r8t = -1;
class Oi extends We {
  constructor(e, { code: n, docsPath: r, metaMessages: i, name: a, shortMessage: o }) {
    super(o, {
      cause: e,
      docsPath: r,
      metaMessages: i || (e == null ? void 0 : e.metaMessages),
      name: a || "RpcError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = a || e.name, this.code = e instanceof YC ? e.code : n ?? r8t;
  }
}
class Hd extends Oi {
  constructor(e, n) {
    super(e, n), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = n.data;
  }
}
class l2 extends Oi {
  constructor(e) {
    super(e, {
      code: l2.code,
      name: "ParseRpcError",
      shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    });
  }
}
Object.defineProperty(l2, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32700
});
class c2 extends Oi {
  constructor(e) {
    super(e, {
      code: c2.code,
      name: "InvalidRequestRpcError",
      shortMessage: "JSON is not a valid request object."
    });
  }
}
Object.defineProperty(c2, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32600
});
class u2 extends Oi {
  constructor(e, { method: n } = {}) {
    super(e, {
      code: u2.code,
      name: "MethodNotFoundRpcError",
      shortMessage: `The method${n ? ` "${n}"` : ""} does not exist / is not available.`
    });
  }
}
Object.defineProperty(u2, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32601
});
class d2 extends Oi {
  constructor(e) {
    super(e, {
      code: d2.code,
      name: "InvalidParamsRpcError",
      shortMessage: [
        "Invalid parameters were provided to the RPC method.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    });
  }
}
Object.defineProperty(d2, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32602
});
class o0 extends Oi {
  constructor(e) {
    super(e, {
      code: o0.code,
      name: "InternalRpcError",
      shortMessage: "An internal error was received."
    });
  }
}
Object.defineProperty(o0, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32603
});
class s0 extends Oi {
  constructor(e) {
    super(e, {
      code: s0.code,
      name: "InvalidInputRpcError",
      shortMessage: [
        "Missing or invalid parameters.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    });
  }
}
Object.defineProperty(s0, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32e3
});
class f2 extends Oi {
  constructor(e) {
    super(e, {
      code: f2.code,
      name: "ResourceNotFoundRpcError",
      shortMessage: "Requested resource not found."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ResourceNotFoundRpcError"
    });
  }
}
Object.defineProperty(f2, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32001
});
class h2 extends Oi {
  constructor(e) {
    super(e, {
      code: h2.code,
      name: "ResourceUnavailableRpcError",
      shortMessage: "Requested resource not available."
    });
  }
}
Object.defineProperty(h2, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32002
});
class p2 extends Oi {
  constructor(e) {
    super(e, {
      code: p2.code,
      name: "TransactionRejectedRpcError",
      shortMessage: "Transaction creation failed."
    });
  }
}
Object.defineProperty(p2, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32003
});
class Su extends Oi {
  constructor(e, { method: n } = {}) {
    super(e, {
      code: Su.code,
      name: "MethodNotSupportedRpcError",
      shortMessage: `Method${n ? ` "${n}"` : ""} is not supported.`
    });
  }
}
Object.defineProperty(Su, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32004
});
class Q1 extends Oi {
  constructor(e) {
    super(e, {
      code: Q1.code,
      name: "LimitExceededRpcError",
      shortMessage: "Request exceeds defined limit."
    });
  }
}
Object.defineProperty(Q1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32005
});
class m2 extends Oi {
  constructor(e) {
    super(e, {
      code: m2.code,
      name: "JsonRpcVersionUnsupportedError",
      shortMessage: "Version of JSON-RPC protocol is not supported."
    });
  }
}
Object.defineProperty(m2, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32006
});
class x1 extends Hd {
  constructor(e) {
    super(e, {
      code: x1.code,
      name: "UserRejectedRequestError",
      shortMessage: "User rejected the request."
    });
  }
}
Object.defineProperty(x1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4001
});
class y2 extends Hd {
  constructor(e) {
    super(e, {
      code: y2.code,
      name: "UnauthorizedProviderError",
      shortMessage: "The requested method and/or account has not been authorized by the user."
    });
  }
}
Object.defineProperty(y2, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4100
});
class g2 extends Hd {
  constructor(e, { method: n } = {}) {
    super(e, {
      code: g2.code,
      name: "UnsupportedProviderMethodError",
      shortMessage: `The Provider does not support the requested method${n ? ` " ${n}"` : ""}.`
    });
  }
}
Object.defineProperty(g2, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4200
});
class v2 extends Hd {
  constructor(e) {
    super(e, {
      code: v2.code,
      name: "ProviderDisconnectedError",
      shortMessage: "The Provider is disconnected from all chains."
    });
  }
}
Object.defineProperty(v2, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4900
});
class b2 extends Hd {
  constructor(e) {
    super(e, {
      code: b2.code,
      name: "ChainDisconnectedError",
      shortMessage: "The Provider is not connected to the requested chain."
    });
  }
}
Object.defineProperty(b2, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4901
});
class w2 extends Hd {
  constructor(e) {
    super(e, {
      code: w2.code,
      name: "SwitchChainError",
      shortMessage: "An error occurred when attempting to switch chain."
    });
  }
}
Object.defineProperty(w2, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4902
});
class i8t extends Oi {
  constructor(e) {
    super(e, {
      name: "UnknownRpcError",
      shortMessage: "An unknown RPC error occurred."
    });
  }
}
const a8t = 3;
function X1(t, { abi: e, address: n, args: r, docsPath: i, functionName: a, sender: o }) {
  const s = t instanceof V6 ? t : t instanceof We ? t.walk((p) => "data" in p) || t.walk() : {}, { code: l, data: c, details: u, message: d, shortMessage: f } = s, h = t instanceof Dp ? new t8t({ functionName: a }) : [a8t, o0.code].includes(l) && (c || u || d || f) ? new U9({
    abi: e,
    data: typeof c == "object" ? c.data : c,
    functionName: a,
    message: s instanceof YC ? u : f ?? d
  }) : t;
  return new e8t(h, {
    abi: e,
    args: r,
    contractAddress: n,
    docsPath: i,
    functionName: a,
    sender: o
  });
}
function o8t(t) {
  const e = Or(`0x${t.substring(4)}`).substring(26);
  return B6(`0x${e}`);
}
async function s8t({ hash: t, signature: e }) {
  const n = is(t) ? t : fl(t), { secp256k1: r } = await Promise.resolve().then(() => m9t);
  return `0x${(() => {
    if (typeof e == "object" && "r" in e && "s" in e) {
      const { r: c, s: u, v: d, yParity: f } = e, h = Number(f ?? d), p = ED(h);
      return new r.Signature(as(c), as(u)).addRecoveryBit(p);
    }
    const o = is(e) ? e : fl(e), s = dl(`0x${o.slice(130)}`), l = ED(s);
    return r.Signature.fromCompact(o.substring(2, 130)).addRecoveryBit(l);
  })().recoverPublicKey(n.substring(2)).toHex(!1)}`;
}
function ED(t) {
  if (t === 0 || t === 1)
    return t;
  if (t === 27)
    return 0;
  if (t === 28)
    return 1;
  throw new Error("Invalid yParityOrV value");
}
async function xK({ hash: t, signature: e }) {
  return o8t(await s8t({ hash: t, signature: e }));
}
function l8t(t, e = "hex") {
  const n = MK(t), r = ZC(new Uint8Array(n.length));
  return n.encode(r), e === "hex" ? mr(r.bytes) : r.bytes;
}
function MK(t) {
  return Array.isArray(t) ? c8t(t.map((e) => MK(e))) : u8t(t);
}
function c8t(t) {
  const e = t.reduce((i, a) => i + a.length, 0), n = CK(e);
  return {
    length: e <= 55 ? 1 + e : 1 + n + e,
    encode(i) {
      e <= 55 ? i.pushByte(192 + e) : (i.pushByte(247 + n), n === 1 ? i.pushUint8(e) : n === 2 ? i.pushUint16(e) : n === 3 ? i.pushUint24(e) : i.pushUint32(e));
      for (const { encode: a } of t)
        a(i);
    }
  };
}
function u8t(t) {
  const e = typeof t == "string" ? so(t) : t, n = CK(e.length);
  return {
    length: e.length === 1 && e[0] < 128 ? 1 : e.length <= 55 ? 1 + e.length : 1 + n + e.length,
    encode(i) {
      e.length === 1 && e[0] < 128 ? i.pushBytes(e) : e.length <= 55 ? (i.pushByte(128 + e.length), i.pushBytes(e)) : (i.pushByte(183 + n), n === 1 ? i.pushUint8(e.length) : n === 2 ? i.pushUint16(e.length) : n === 3 ? i.pushUint24(e.length) : i.pushUint32(e.length), i.pushBytes(e));
    }
  };
}
function CK(t) {
  if (t < 2 ** 8)
    return 1;
  if (t < 2 ** 16)
    return 2;
  if (t < 2 ** 24)
    return 3;
  if (t < 2 ** 32)
    return 4;
  throw new We("Length is too large.");
}
function d8t(t) {
  const { chainId: e, nonce: n, to: r } = t, i = t.contractAddress ?? t.address, a = Or(Pp([
    "0x05",
    l8t([
      e ? jt(e) : "0x",
      i,
      n ? jt(n) : "0x"
    ])
  ]));
  return r === "bytes" ? so(a) : a;
}
async function f8t(t) {
  const { authorization: e, signature: n } = t;
  return xK({
    hash: d8t(e),
    signature: n ?? e
  });
}
class h8t extends We {
  constructor(e, { account: n, docsPath: r, chain: i, data: a, gas: o, gasPrice: s, maxFeePerGas: l, maxPriorityFeePerGas: c, nonce: u, to: d, value: f }) {
    var p;
    const h = _6({
      from: n == null ? void 0 : n.address,
      to: d,
      value: typeof f < "u" && `${vK(f)} ${((p = i == null ? void 0 : i.nativeCurrency) == null ? void 0 : p.symbol) || "ETH"}`,
      data: a,
      gas: o,
      gasPrice: typeof s < "u" && `${no(s)} gwei`,
      maxFeePerGas: typeof l < "u" && `${no(l)} gwei`,
      maxPriorityFeePerGas: typeof c < "u" && `${no(c)} gwei`,
      nonce: u
    });
    super(e.shortMessage, {
      cause: e,
      docsPath: r,
      metaMessages: [
        ...e.metaMessages ? [...e.metaMessages, " "] : [],
        "Estimate Gas Arguments:",
        h
      ].filter(Boolean),
      name: "EstimateGasExecutionError"
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.cause = e;
  }
}
class o1 extends We {
  constructor({ cause: e, message: n } = {}) {
    var i;
    const r = (i = n == null ? void 0 : n.replace("execution reverted: ", "")) == null ? void 0 : i.replace("execution reverted", "");
    super(`Execution reverted ${r ? `with reason: ${r}` : "for an unknown reason"}.`, {
      cause: e,
      name: "ExecutionRevertedError"
    });
  }
}
Object.defineProperty(o1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 3
});
Object.defineProperty(o1, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /execution reverted/
});
class e3 extends We {
  constructor({ cause: e, maxFeePerGas: n } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${n ? ` = ${no(n)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
      cause: e,
      name: "FeeCapTooHighError"
    });
  }
}
Object.defineProperty(e3, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class W9 extends We {
  constructor({ cause: e, maxFeePerGas: n } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${n ? ` = ${no(n)}` : ""} gwei) cannot be lower than the block base fee.`, {
      cause: e,
      name: "FeeCapTooLowError"
    });
  }
}
Object.defineProperty(W9, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class Z9 extends We {
  constructor({ cause: e, nonce: n } = {}) {
    super(`Nonce provided for the transaction ${n ? `(${n}) ` : ""}is higher than the next one expected.`, { cause: e, name: "NonceTooHighError" });
  }
}
Object.defineProperty(Z9, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too high/
});
class G9 extends We {
  constructor({ cause: e, nonce: n } = {}) {
    super([
      `Nonce provided for the transaction ${n ? `(${n}) ` : ""}is lower than the current nonce of the account.`,
      "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
    ].join(`
`), { cause: e, name: "NonceTooLowError" });
  }
}
Object.defineProperty(G9, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too low|transaction already imported|already known/
});
class Y9 extends We {
  constructor({ cause: e, nonce: n } = {}) {
    super(`Nonce provided for the transaction ${n ? `(${n}) ` : ""}exceeds the maximum allowed nonce.`, { cause: e, name: "NonceMaxValueError" });
  }
}
Object.defineProperty(Y9, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce has max value/
});
class K9 extends We {
  constructor({ cause: e } = {}) {
    super([
      "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
    ].join(`
`), {
      cause: e,
      metaMessages: [
        "This error could arise when the account does not have enough funds to:",
        " - pay for the total gas fee,",
        " - pay for the value to send.",
        " ",
        "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
        " - `gas` is the amount of gas needed for transaction to execute,",
        " - `gas fee` is the gas fee,",
        " - `value` is the amount of ether to send to the recipient."
      ],
      name: "InsufficientFundsError"
    });
  }
}
Object.defineProperty(K9, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /insufficient funds|exceeds transaction sender account balance/
});
class $9 extends We {
  constructor({ cause: e, gas: n } = {}) {
    super(`The amount of gas ${n ? `(${n}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
      cause: e,
      name: "IntrinsicGasTooHighError"
    });
  }
}
Object.defineProperty($9, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too high|gas limit reached/
});
class J9 extends We {
  constructor({ cause: e, gas: n } = {}) {
    super(`The amount of gas ${n ? `(${n}) ` : ""}provided for the transaction is too low.`, {
      cause: e,
      name: "IntrinsicGasTooLowError"
    });
  }
}
Object.defineProperty(J9, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too low/
});
class Q9 extends We {
  constructor({ cause: e }) {
    super("The transaction type is not supported for this chain.", {
      cause: e,
      name: "TransactionTypeNotSupportedError"
    });
  }
}
Object.defineProperty(Q9, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /transaction type not valid/
});
class t3 extends We {
  constructor({ cause: e, maxPriorityFeePerGas: n, maxFeePerGas: r } = {}) {
    super([
      `The provided tip (\`maxPriorityFeePerGas\`${n ? ` = ${no(n)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${r ? ` = ${no(r)} gwei` : ""}).`
    ].join(`
`), {
      cause: e,
      name: "TipAboveFeeCapError"
    });
  }
}
Object.defineProperty(t3, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class q6 extends We {
  constructor({ cause: e }) {
    super(`An error occurred while executing: ${e == null ? void 0 : e.shortMessage}`, {
      cause: e,
      name: "UnknownNodeError"
    });
  }
}
function KC(t, e) {
  const n = (t.details || "").toLowerCase(), r = t instanceof We ? t.walk((i) => (i == null ? void 0 : i.code) === o1.code) : t;
  return r instanceof We ? new o1({
    cause: t,
    message: r.details
  }) : o1.nodeMessage.test(n) ? new o1({
    cause: t,
    message: t.details
  }) : e3.nodeMessage.test(n) ? new e3({
    cause: t,
    maxFeePerGas: e == null ? void 0 : e.maxFeePerGas
  }) : W9.nodeMessage.test(n) ? new W9({
    cause: t,
    maxFeePerGas: e == null ? void 0 : e.maxFeePerGas
  }) : Z9.nodeMessage.test(n) ? new Z9({ cause: t, nonce: e == null ? void 0 : e.nonce }) : G9.nodeMessage.test(n) ? new G9({ cause: t, nonce: e == null ? void 0 : e.nonce }) : Y9.nodeMessage.test(n) ? new Y9({ cause: t, nonce: e == null ? void 0 : e.nonce }) : K9.nodeMessage.test(n) ? new K9({ cause: t }) : $9.nodeMessage.test(n) ? new $9({ cause: t, gas: e == null ? void 0 : e.gas }) : J9.nodeMessage.test(n) ? new J9({ cause: t, gas: e == null ? void 0 : e.gas }) : Q9.nodeMessage.test(n) ? new Q9({ cause: t }) : t3.nodeMessage.test(n) ? new t3({
    cause: t,
    maxFeePerGas: e == null ? void 0 : e.maxFeePerGas,
    maxPriorityFeePerGas: e == null ? void 0 : e.maxPriorityFeePerGas
  }) : new q6({
    cause: t
  });
}
function p8t(t, { docsPath: e, ...n }) {
  const r = (() => {
    const i = KC(t, n);
    return i instanceof q6 ? t : i;
  })();
  return new h8t(r, {
    docsPath: e,
    ...n
  });
}
function $C(t, { format: e }) {
  if (!e)
    return {};
  const n = {};
  function r(a) {
    const o = Object.keys(a);
    for (const s of o)
      s in t && (n[s] = t[s]), a[s] && typeof a[s] == "object" && !Array.isArray(a[s]) && r(a[s]);
  }
  const i = e(t || {});
  return r(i), n;
}
const m8t = {
  legacy: "0x0",
  eip2930: "0x1",
  eip1559: "0x2",
  eip4844: "0x3",
  eip7702: "0x4"
};
function U6(t) {
  const e = {};
  return typeof t.authorizationList < "u" && (e.authorizationList = y8t(t.authorizationList)), typeof t.accessList < "u" && (e.accessList = t.accessList), typeof t.blobVersionedHashes < "u" && (e.blobVersionedHashes = t.blobVersionedHashes), typeof t.blobs < "u" && (typeof t.blobs[0] != "string" ? e.blobs = t.blobs.map((n) => mr(n)) : e.blobs = t.blobs), typeof t.data < "u" && (e.data = t.data), typeof t.from < "u" && (e.from = t.from), typeof t.gas < "u" && (e.gas = jt(t.gas)), typeof t.gasPrice < "u" && (e.gasPrice = jt(t.gasPrice)), typeof t.maxFeePerBlobGas < "u" && (e.maxFeePerBlobGas = jt(t.maxFeePerBlobGas)), typeof t.maxFeePerGas < "u" && (e.maxFeePerGas = jt(t.maxFeePerGas)), typeof t.maxPriorityFeePerGas < "u" && (e.maxPriorityFeePerGas = jt(t.maxPriorityFeePerGas)), typeof t.nonce < "u" && (e.nonce = jt(t.nonce)), typeof t.to < "u" && (e.to = t.to), typeof t.type < "u" && (e.type = m8t[t.type]), typeof t.value < "u" && (e.value = jt(t.value)), e;
}
function y8t(t) {
  return t.map((e) => ({
    address: e.address,
    r: e.r ? jt(BigInt(e.r)) : e.r,
    s: e.s ? jt(BigInt(e.s)) : e.s,
    chainId: jt(e.chainId),
    nonce: jt(e.nonce),
    ...typeof e.yParity < "u" ? { yParity: jt(e.yParity) } : {},
    ...typeof e.v < "u" && typeof e.yParity > "u" ? { v: jt(e.v) } : {}
  }));
}
function jD(t) {
  if (!(!t || t.length === 0))
    return t.reduce((e, { slot: n, value: r }) => {
      if (n.length !== 66)
        throw new mD({
          size: n.length,
          targetSize: 66,
          type: "hex"
        });
      if (r.length !== 66)
        throw new mD({
          size: r.length,
          targetSize: 66,
          type: "hex"
        });
      return e[n] = r, e;
    }, {});
}
function g8t(t) {
  const { balance: e, nonce: n, state: r, stateDiff: i, code: a } = t, o = {};
  if (a !== void 0 && (o.code = a), e !== void 0 && (o.balance = jt(e)), n !== void 0 && (o.nonce = jt(n)), r !== void 0 && (o.state = jD(r)), i !== void 0) {
    if (o.state)
      throw new Y5t();
    o.stateDiff = jD(i);
  }
  return o;
}
function JC(t) {
  if (!t)
    return;
  const e = {};
  for (const { address: n, ...r } of t) {
    if (!Ia(n, { strict: !1 }))
      throw new Cc({ address: n });
    if (e[n])
      throw new G5t({ address: n });
    e[n] = g8t(r);
  }
  return e;
}
const v8t = 2n ** 256n - 1n;
function Op(t) {
  const { account: e, gasPrice: n, maxFeePerGas: r, maxPriorityFeePerGas: i, to: a } = t, o = e ? bo(e) : void 0;
  if (o && !Ia(o.address))
    throw new Cc({ address: o.address });
  if (a && !Ia(a))
    throw new Cc({ address: a });
  if (typeof n < "u" && (typeof r < "u" || typeof i < "u"))
    throw new $5t();
  if (r && r > v8t)
    throw new e3({ maxFeePerGas: r });
  if (i && r && i > r)
    throw new t3({ maxFeePerGas: r, maxPriorityFeePerGas: i });
}
class b8t extends We {
  constructor() {
    super("`baseFeeMultiplier` must be greater than 1.", {
      name: "BaseFeeScalarError"
    });
  }
}
class QC extends We {
  constructor() {
    super("Chain does not support EIP-1559 fees.", {
      name: "Eip1559FeesNotSupportedError"
    });
  }
}
class w8t extends We {
  constructor({ maxPriorityFeePerGas: e }) {
    super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${no(e)} gwei).`, { name: "MaxFeePerGasTooLowError" });
  }
}
class AK extends We {
  constructor({ blockHash: e, blockNumber: n }) {
    let r = "Block";
    e && (r = `Block at hash "${e}"`), n && (r = `Block at number "${n}"`), super(`${r} could not be found.`, { name: "BlockNotFoundError" });
  }
}
const SK = {
  "0x0": "legacy",
  "0x1": "eip2930",
  "0x2": "eip1559",
  "0x3": "eip4844",
  "0x4": "eip7702"
};
function LK(t) {
  const e = {
    ...t,
    blockHash: t.blockHash ? t.blockHash : null,
    blockNumber: t.blockNumber ? BigInt(t.blockNumber) : null,
    chainId: t.chainId ? dl(t.chainId) : void 0,
    gas: t.gas ? BigInt(t.gas) : void 0,
    gasPrice: t.gasPrice ? BigInt(t.gasPrice) : void 0,
    maxFeePerBlobGas: t.maxFeePerBlobGas ? BigInt(t.maxFeePerBlobGas) : void 0,
    maxFeePerGas: t.maxFeePerGas ? BigInt(t.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: t.maxPriorityFeePerGas ? BigInt(t.maxPriorityFeePerGas) : void 0,
    nonce: t.nonce ? dl(t.nonce) : void 0,
    to: t.to ? t.to : null,
    transactionIndex: t.transactionIndex ? Number(t.transactionIndex) : null,
    type: t.type ? SK[t.type] : void 0,
    typeHex: t.type ? t.type : void 0,
    value: t.value ? BigInt(t.value) : void 0,
    v: t.v ? BigInt(t.v) : void 0
  };
  return t.authorizationList && (e.authorizationList = k8t(t.authorizationList)), e.yParity = (() => {
    if (t.yParity)
      return Number(t.yParity);
    if (typeof e.v == "bigint") {
      if (e.v === 0n || e.v === 27n)
        return 0;
      if (e.v === 1n || e.v === 28n)
        return 1;
      if (e.v >= 35n)
        return e.v % 2n === 0n ? 1 : 0;
    }
  })(), e.type === "legacy" && (delete e.accessList, delete e.maxFeePerBlobGas, delete e.maxFeePerGas, delete e.maxPriorityFeePerGas, delete e.yParity), e.type === "eip2930" && (delete e.maxFeePerBlobGas, delete e.maxFeePerGas, delete e.maxPriorityFeePerGas), e.type === "eip1559" && delete e.maxFeePerBlobGas, e;
}
function k8t(t) {
  return t.map((e) => ({
    address: e.address,
    chainId: Number(e.chainId),
    nonce: Number(e.nonce),
    r: e.r,
    s: e.s,
    yParity: Number(e.yParity)
  }));
}
function TK(t) {
  const e = (t.transactions ?? []).map((n) => typeof n == "string" ? n : LK(n));
  return {
    ...t,
    baseFeePerGas: t.baseFeePerGas ? BigInt(t.baseFeePerGas) : null,
    blobGasUsed: t.blobGasUsed ? BigInt(t.blobGasUsed) : void 0,
    difficulty: t.difficulty ? BigInt(t.difficulty) : void 0,
    excessBlobGas: t.excessBlobGas ? BigInt(t.excessBlobGas) : void 0,
    gasLimit: t.gasLimit ? BigInt(t.gasLimit) : void 0,
    gasUsed: t.gasUsed ? BigInt(t.gasUsed) : void 0,
    hash: t.hash ? t.hash : null,
    logsBloom: t.logsBloom ? t.logsBloom : null,
    nonce: t.nonce ? t.nonce : null,
    number: t.number ? BigInt(t.number) : null,
    size: t.size ? BigInt(t.size) : void 0,
    timestamp: t.timestamp ? BigInt(t.timestamp) : void 0,
    transactions: e,
    totalDifficulty: t.totalDifficulty ? BigInt(t.totalDifficulty) : null
  };
}
async function Bo(t, { blockHash: e, blockNumber: n, blockTag: r, includeTransactions: i } = {}) {
  var u, d, f;
  const a = r ?? "latest", o = i ?? !1, s = n !== void 0 ? jt(n) : void 0;
  let l = null;
  if (e ? l = await t.request({
    method: "eth_getBlockByHash",
    params: [e, o]
  }, { dedupe: !0 }) : l = await t.request({
    method: "eth_getBlockByNumber",
    params: [s || a, o]
  }, { dedupe: !!s }), !l)
    throw new AK({ blockHash: e, blockNumber: n });
  return (((f = (d = (u = t.chain) == null ? void 0 : u.formatters) == null ? void 0 : d.block) == null ? void 0 : f.format) || TK)(l);
}
async function XC(t) {
  const e = await t.request({
    method: "eth_gasPrice"
  });
  return BigInt(e);
}
async function x8t(t, e) {
  return EK(t, e);
}
async function EK(t, e) {
  var a, o;
  const { block: n, chain: r = t.chain, request: i } = e || {};
  try {
    const s = ((a = r == null ? void 0 : r.fees) == null ? void 0 : a.maxPriorityFeePerGas) ?? ((o = r == null ? void 0 : r.fees) == null ? void 0 : o.defaultPriorityFee);
    if (typeof s == "function") {
      const c = n || await zt(t, Bo, "getBlock")({}), u = await s({
        block: c,
        client: t,
        request: i
      });
      if (u === null)
        throw new Error();
      return u;
    }
    if (typeof s < "u")
      return s;
    const l = await t.request({
      method: "eth_maxPriorityFeePerGas"
    });
    return as(l);
  } catch {
    const [s, l] = await Promise.all([
      n ? Promise.resolve(n) : zt(t, Bo, "getBlock")({}),
      zt(t, XC, "getGasPrice")({})
    ]);
    if (typeof s.baseFeePerGas != "bigint")
      throw new QC();
    const c = l - s.baseFeePerGas;
    return c < 0n ? 0n : c;
  }
}
async function M8t(t, e) {
  return X9(t, e);
}
async function X9(t, e) {
  var f, h;
  const { block: n, chain: r = t.chain, request: i, type: a = "eip1559" } = e || {}, o = await (async () => {
    var p, m;
    return typeof ((p = r == null ? void 0 : r.fees) == null ? void 0 : p.baseFeeMultiplier) == "function" ? r.fees.baseFeeMultiplier({
      block: n,
      client: t,
      request: i
    }) : ((m = r == null ? void 0 : r.fees) == null ? void 0 : m.baseFeeMultiplier) ?? 1.2;
  })();
  if (o < 1)
    throw new b8t();
  const l = 10 ** (((f = o.toString().split(".")[1]) == null ? void 0 : f.length) ?? 0), c = (p) => p * BigInt(Math.ceil(o * l)) / BigInt(l), u = n || await zt(t, Bo, "getBlock")({});
  if (typeof ((h = r == null ? void 0 : r.fees) == null ? void 0 : h.estimateFeesPerGas) == "function") {
    const p = await r.fees.estimateFeesPerGas({
      block: n,
      client: t,
      multiply: c,
      request: i,
      type: a
    });
    if (p !== null)
      return p;
  }
  if (a === "eip1559") {
    if (typeof u.baseFeePerGas != "bigint")
      throw new QC();
    const p = typeof (i == null ? void 0 : i.maxPriorityFeePerGas) == "bigint" ? i.maxPriorityFeePerGas : await EK(t, {
      block: u,
      chain: r,
      request: i
    }), m = c(u.baseFeePerGas);
    return {
      maxFeePerGas: (i == null ? void 0 : i.maxFeePerGas) ?? m + p,
      maxPriorityFeePerGas: p
    };
  }
  return {
    gasPrice: (i == null ? void 0 : i.gasPrice) ?? c(await zt(t, XC, "getGasPrice")({}))
  };
}
async function jK(t, { address: e, blockTag: n = "latest", blockNumber: r }) {
  const i = await t.request({
    method: "eth_getTransactionCount",
    params: [e, r ? jt(r) : n]
  }, { dedupe: !!r });
  return dl(i);
}
function NK(t) {
  const { kzg: e } = t, n = t.to ?? (typeof t.blobs[0] == "string" ? "hex" : "bytes"), r = typeof t.blobs[0] == "string" ? t.blobs.map((a) => so(a)) : t.blobs, i = [];
  for (const a of r)
    i.push(Uint8Array.from(e.blobToKzgCommitment(a)));
  return n === "bytes" ? i : i.map((a) => mr(a));
}
function DK(t) {
  const { kzg: e } = t, n = t.to ?? (typeof t.blobs[0] == "string" ? "hex" : "bytes"), r = typeof t.blobs[0] == "string" ? t.blobs.map((o) => so(o)) : t.blobs, i = typeof t.commitments[0] == "string" ? t.commitments.map((o) => so(o)) : t.commitments, a = [];
  for (let o = 0; o < r.length; o++) {
    const s = r[o], l = i[o];
    a.push(Uint8Array.from(e.computeBlobKzgProof(s, l)));
  }
  return n === "bytes" ? a : a.map((o) => mr(o));
}
function C8t(t, e, n, r) {
  if (typeof t.setBigUint64 == "function")
    return t.setBigUint64(e, n, r);
  const i = BigInt(32), a = BigInt(4294967295), o = Number(n >> i & a), s = Number(n & a), l = r ? 4 : 0, c = r ? 0 : 4;
  t.setUint32(e + l, o, r), t.setUint32(e + c, s, r);
}
function A8t(t, e, n) {
  return t & e ^ ~t & n;
}
function S8t(t, e, n) {
  return t & e ^ t & n ^ e & n;
}
class L8t extends FC {
  constructor(e, n, r, i) {
    super(), this.blockLen = e, this.outputLen = n, this.padOffset = r, this.isLE = i, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = tv(this.buffer);
  }
  update(e) {
    J1(this);
    const { view: n, buffer: r, blockLen: i } = this;
    e = R6(e);
    const a = e.length;
    for (let o = 0; o < a; ) {
      const s = Math.min(i - this.pos, a - o);
      if (s === i) {
        const l = tv(e);
        for (; i <= a - o; o += i)
          this.process(l, o);
        continue;
      }
      r.set(e.subarray(o, o + s), this.pos), this.pos += s, o += s, this.pos === i && (this.process(n, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    J1(this), eK(e, this), this.finished = !0;
    const { buffer: n, view: r, blockLen: i, isLE: a } = this;
    let { pos: o } = this;
    n[o++] = 128, this.buffer.subarray(o).fill(0), this.padOffset > i - o && (this.process(r, 0), o = 0);
    for (let d = o; d < i; d++)
      n[d] = 0;
    C8t(r, i - 8, BigInt(this.length * 8), a), this.process(r, 0);
    const s = tv(e), l = this.outputLen;
    if (l % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const c = l / 4, u = this.get();
    if (c > u.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let d = 0; d < c; d++)
      s.setUint32(4 * d, u[d], a);
  }
  digest() {
    const { buffer: e, outputLen: n } = this;
    this.digestInto(e);
    const r = e.slice(0, n);
    return this.destroy(), r;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: n, buffer: r, length: i, finished: a, destroyed: o, pos: s } = this;
    return e.length = i, e.pos = s, e.finished = a, e.destroyed = o, i % n && e.buffer.set(r), e;
  }
}
const T8t = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), zl = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Rl = /* @__PURE__ */ new Uint32Array(64);
class E8t extends L8t {
  constructor() {
    super(64, 32, 8, !1), this.A = zl[0] | 0, this.B = zl[1] | 0, this.C = zl[2] | 0, this.D = zl[3] | 0, this.E = zl[4] | 0, this.F = zl[5] | 0, this.G = zl[6] | 0, this.H = zl[7] | 0;
  }
  get() {
    const { A: e, B: n, C: r, D: i, E: a, F: o, G: s, H: l } = this;
    return [e, n, r, i, a, o, s, l];
  }
  // prettier-ignore
  set(e, n, r, i, a, o, s, l) {
    this.A = e | 0, this.B = n | 0, this.C = r | 0, this.D = i | 0, this.E = a | 0, this.F = o | 0, this.G = s | 0, this.H = l | 0;
  }
  process(e, n) {
    for (let d = 0; d < 16; d++, n += 4)
      Rl[d] = e.getUint32(n, !1);
    for (let d = 16; d < 64; d++) {
      const f = Rl[d - 15], h = Rl[d - 2], p = Ao(f, 7) ^ Ao(f, 18) ^ f >>> 3, m = Ao(h, 17) ^ Ao(h, 19) ^ h >>> 10;
      Rl[d] = m + Rl[d - 7] + p + Rl[d - 16] | 0;
    }
    let { A: r, B: i, C: a, D: o, E: s, F: l, G: c, H: u } = this;
    for (let d = 0; d < 64; d++) {
      const f = Ao(s, 6) ^ Ao(s, 11) ^ Ao(s, 25), h = u + f + A8t(s, l, c) + T8t[d] + Rl[d] | 0, m = (Ao(r, 2) ^ Ao(r, 13) ^ Ao(r, 22)) + S8t(r, i, a) | 0;
      u = c, c = l, l = s, s = o + h | 0, o = a, a = i, i = r, r = h + m | 0;
    }
    r = r + this.A | 0, i = i + this.B | 0, a = a + this.C | 0, o = o + this.D | 0, s = s + this.E | 0, l = l + this.F | 0, c = c + this.G | 0, u = u + this.H | 0, this.set(r, i, a, o, s, l, c, u);
  }
  roundClean() {
    Rl.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const IK = /* @__PURE__ */ tK(() => new E8t());
function j8t(t, e) {
  return IK(is(t, { strict: !1 }) ? Od(t) : t);
}
function N8t(t) {
  const { commitment: e, version: n = 1 } = t, r = t.to ?? (typeof e == "string" ? "hex" : "bytes"), i = j8t(e);
  return i.set([n], 0), r === "bytes" ? i : mr(i);
}
function D8t(t) {
  const { commitments: e, version: n } = t, r = t.to, i = [];
  for (const a of e)
    i.push(N8t({
      commitment: a,
      to: r,
      version: n
    }));
  return i;
}
const ND = 6, PK = 32, eA = 4096, zK = PK * eA, DD = zK * ND - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * eA * ND;
class I8t extends We {
  constructor({ maxSize: e, size: n }) {
    super("Blob size is too large.", {
      metaMessages: [`Max: ${e} bytes`, `Given: ${n} bytes`],
      name: "BlobSizeTooLargeError"
    });
  }
}
class P8t extends We {
  constructor() {
    super("Blob data must not be empty.", { name: "EmptyBlobError" });
  }
}
function z8t(t) {
  const e = typeof t.data == "string" ? so(t.data) : t.data, n = tr(e);
  if (!n)
    throw new P8t();
  if (n > DD)
    throw new I8t({
      maxSize: DD,
      size: n
    });
  const r = [];
  let i = !0, a = 0;
  for (; i; ) {
    const o = ZC(new Uint8Array(zK));
    let s = 0;
    for (; s < eA; ) {
      const l = e.slice(a, a + (PK - 1));
      if (o.pushByte(0), o.pushBytes(l), l.length < 31) {
        o.pushByte(128), i = !1;
        break;
      }
      s++, a += 31;
    }
    r.push(o);
  }
  return r.map((o) => mr(o.bytes));
}
function R8t(t) {
  const { data: e, kzg: n, to: r } = t, i = t.blobs ?? z8t({ data: e }), a = t.commitments ?? NK({ blobs: i, kzg: n, to: r }), o = t.proofs ?? DK({ blobs: i, commitments: a, kzg: n, to: r }), s = [];
  for (let l = 0; l < i.length; l++)
    s.push({
      blob: i[l],
      commitment: a[l],
      proof: o[l]
    });
  return s;
}
function O8t(t) {
  if (t.type)
    return t.type;
  if (typeof t.authorizationList < "u")
    return "eip7702";
  if (typeof t.blobs < "u" || typeof t.blobVersionedHashes < "u" || typeof t.maxFeePerBlobGas < "u" || typeof t.sidecars < "u")
    return "eip4844";
  if (typeof t.maxFeePerGas < "u" || typeof t.maxPriorityFeePerGas < "u")
    return "eip1559";
  if (typeof t.gasPrice < "u")
    return typeof t.accessList < "u" ? "eip2930" : "legacy";
  throw new J5t({ transaction: t });
}
async function RK(t) {
  const e = await t.request({
    method: "eth_chainId"
  }, { dedupe: !0 });
  return dl(e);
}
const B8t = [
  "blobVersionedHashes",
  "chainId",
  "fees",
  "gas",
  "nonce",
  "type"
], ID = /* @__PURE__ */ new Map();
async function OK(t, e) {
  const { account: n = t.account, blobs: r, chain: i, gas: a, kzg: o, nonce: s, nonceManager: l, parameters: c = B8t, type: u } = e, d = n && bo(n), f = { ...e, ...d ? { from: d == null ? void 0 : d.address } : {} };
  let h;
  async function p() {
    return h || (h = await zt(t, Bo, "getBlock")({ blockTag: "latest" }), h);
  }
  let m;
  async function g() {
    return m || (i ? i.id : typeof e.chainId < "u" ? e.chainId : (m = await zt(t, RK, "getChainId")({}), m));
  }
  if (c.includes("nonce") && typeof s > "u" && d)
    if (l) {
      const v = await g();
      f.nonce = await l.consume({
        address: d.address,
        chainId: v,
        client: t
      });
    } else
      f.nonce = await zt(t, jK, "getTransactionCount")({
        address: d.address,
        blockTag: "pending"
      });
  if ((c.includes("blobVersionedHashes") || c.includes("sidecars")) && r && o) {
    const v = NK({ blobs: r, kzg: o });
    if (c.includes("blobVersionedHashes")) {
      const k = D8t({
        commitments: v,
        to: "hex"
      });
      f.blobVersionedHashes = k;
    }
    if (c.includes("sidecars")) {
      const k = DK({ blobs: r, commitments: v, kzg: o }), w = R8t({
        blobs: r,
        commitments: v,
        proofs: k,
        to: "hex"
      });
      f.sidecars = w;
    }
  }
  if (c.includes("chainId") && (f.chainId = await g()), (c.includes("fees") || c.includes("type")) && typeof u > "u")
    try {
      f.type = O8t(f);
    } catch {
      let v = ID.get(t.uid);
      if (typeof v > "u") {
        const k = await p();
        v = typeof (k == null ? void 0 : k.baseFeePerGas) == "bigint", ID.set(t.uid, v);
      }
      f.type = v ? "eip1559" : "legacy";
    }
  if (c.includes("fees"))
    if (f.type !== "legacy" && f.type !== "eip2930") {
      if (typeof f.maxFeePerGas > "u" || typeof f.maxPriorityFeePerGas > "u") {
        const v = await p(), { maxFeePerGas: k, maxPriorityFeePerGas: w } = await X9(t, {
          block: v,
          chain: i,
          request: f
        });
        if (typeof e.maxPriorityFeePerGas > "u" && e.maxFeePerGas && e.maxFeePerGas < w)
          throw new w8t({
            maxPriorityFeePerGas: w
          });
        f.maxPriorityFeePerGas = w, f.maxFeePerGas = k;
      }
    } else {
      if (typeof e.maxFeePerGas < "u" || typeof e.maxPriorityFeePerGas < "u")
        throw new QC();
      if (typeof e.gasPrice > "u") {
        const v = await p(), { gasPrice: k } = await X9(t, {
          block: v,
          chain: i,
          request: f,
          type: "legacy"
        });
        f.gasPrice = k;
      }
    }
  return c.includes("gas") && typeof a > "u" && (f.gas = await zt(t, tA, "estimateGas")({
    ...f,
    account: d && { address: d.address, type: "json-rpc" }
  })), Op(f), delete f.parameters, f;
}
async function BK(t, { address: e, blockNumber: n, blockTag: r = "latest" }) {
  const i = n ? jt(n) : void 0, a = await t.request({
    method: "eth_getBalance",
    params: [e, i || r]
  });
  return BigInt(a);
}
async function tA(t, e) {
  var i, a, o;
  const { account: n = t.account } = e, r = n ? bo(n) : void 0;
  try {
    let F = function(W) {
      const { block: G, request: Y, rpcStateOverride: Z } = W;
      return t.request({
        method: "eth_estimateGas",
        params: Z ? [Y, G ?? "latest", Z] : G ? [Y, G] : [Y]
      });
    };
    const { accessList: s, authorizationList: l, blobs: c, blobVersionedHashes: u, blockNumber: d, blockTag: f, data: h, gas: p, gasPrice: m, maxFeePerBlobGas: g, maxFeePerGas: v, maxPriorityFeePerGas: k, nonce: w, value: b, stateOverride: x, ...A } = await OK(t, {
      ...e,
      parameters: (
        // Some RPC Providers do not compute versioned hashes from blobs. We will need
        // to compute them.
        (r == null ? void 0 : r.type) === "local" ? void 0 : ["blobVersionedHashes"]
      )
    }), M = (d ? jt(d) : void 0) || f, j = JC(x), D = await (async () => {
      if (A.to)
        return A.to;
      if (l && l.length > 0)
        return await f8t({
          authorization: l[0]
        }).catch(() => {
          throw new We("`to` is required. Could not infer from `authorizationList`");
        });
    })();
    Op(e);
    const z = (o = (a = (i = t.chain) == null ? void 0 : i.formatters) == null ? void 0 : a.transactionRequest) == null ? void 0 : o.format, V = (z || U6)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...$C(A, { format: z }),
      from: r == null ? void 0 : r.address,
      accessList: s,
      authorizationList: l,
      blobs: c,
      blobVersionedHashes: u,
      data: h,
      gas: p,
      gasPrice: m,
      maxFeePerBlobGas: g,
      maxFeePerGas: v,
      maxPriorityFeePerGas: k,
      nonce: w,
      to: D,
      value: b
    });
    let _ = BigInt(await F({ block: M, request: V, rpcStateOverride: j }));
    if (l) {
      const W = await BK(t, { address: V.from }), G = await Promise.all(l.map(async (Y) => {
        const { address: Z } = Y, oe = await F({
          block: M,
          request: {
            authorizationList: void 0,
            data: h,
            from: r == null ? void 0 : r.address,
            to: Z,
            value: jt(W)
          },
          rpcStateOverride: j
        }).catch(() => 100000n);
        return 2n * BigInt(oe);
      }));
      _ += G.reduce((Y, Z) => Y + Z, 0n);
    }
    return _;
  } catch (s) {
    throw p8t(s, {
      ...e,
      account: r,
      chain: t.chain
    });
  }
}
async function H8t(t, e) {
  const { abi: n, address: r, args: i, functionName: a, dataSuffix: o, ...s } = e, l = hs({
    abi: n,
    args: i,
    functionName: a
  });
  try {
    return await zt(t, tA, "estimateGas")({
      data: `${l}${o ? o.replace("0x", "") : ""}`,
      to: r,
      ...s
    });
  } catch (c) {
    const u = s.account ? bo(s.account) : void 0;
    throw X1(c, {
      abi: n,
      address: r,
      args: i,
      docsPath: "/docs/contract/estimateContractGas",
      functionName: a,
      sender: u == null ? void 0 : u.address
    });
  }
}
function nA(t, e) {
  if (!Ia(t, { strict: !1 }))
    throw new Cc({ address: t });
  if (!Ia(e, { strict: !1 }))
    throw new Cc({ address: e });
  return t.toLowerCase() === e.toLowerCase();
}
const PD = "/docs/contract/decodeEventLog";
function rA(t) {
  const { abi: e, data: n, strict: r, topics: i } = t, a = r ?? !0, [o, ...s] = i;
  if (!o)
    throw new C6t({ docsPath: PD });
  const l = e.length === 1 ? e[0] : e.find((m) => m.type === "event" && o === O6(ul(m)));
  if (!(l && "name" in l) || l.type !== "event")
    throw new KY(o, { docsPath: PD });
  const { name: c, inputs: u } = l, d = u == null ? void 0 : u.some((m) => !("name" in m && m.name));
  let f = d ? [] : {};
  const h = u.filter((m) => "indexed" in m && m.indexed);
  for (let m = 0; m < h.length; m++) {
    const g = h[m], v = s[m];
    if (!v)
      throw new z6({
        abiItem: l,
        param: g
      });
    f[d ? m : g.name || m] = F8t({ param: g, value: v });
  }
  const p = u.filter((m) => !("indexed" in m && m.indexed));
  if (p.length > 0) {
    if (n && n !== "0x")
      try {
        const m = F6(p, n);
        if (m)
          if (d)
            f = [...f, ...m];
          else
            for (let g = 0; g < p.length; g++)
              f[p[g].name] = m[g];
      } catch (m) {
        if (a)
          throw m instanceof GY || m instanceof mK ? new a2({
            abiItem: l,
            data: n,
            params: p,
            size: tr(n)
          }) : m;
      }
    else if (a)
      throw new a2({
        abiItem: l,
        data: "0x",
        params: p,
        size: 0
      });
  }
  return {
    eventName: c,
    args: Object.values(f).length > 0 ? f : void 0
  };
}
function F8t({ param: t, value: e }) {
  return t.type === "string" || t.type === "bytes" || t.type === "tuple" || t.type.match(/^(.*)\[(\d+)?\]$/) ? e : (F6([t], e) || [])[0];
}
function iA(t) {
  const { abi: e, args: n, logs: r, strict: i = !0 } = t, a = (() => {
    if (t.eventName)
      return Array.isArray(t.eventName) ? t.eventName : [t.eventName];
  })();
  return r.map((o) => {
    var s;
    try {
      const l = e.find((u) => u.type === "event" && o.topics[0] === O6(u));
      if (!l)
        return null;
      const c = rA({
        ...o,
        abi: [l],
        strict: i
      });
      return a && !a.includes(c.eventName) || !_8t({
        args: c.args,
        inputs: l.inputs,
        matchArgs: n
      }) ? null : { ...c, ...o };
    } catch (l) {
      let c, u;
      if (l instanceof KY)
        return null;
      if (l instanceof a2 || l instanceof z6) {
        if (i)
          return null;
        c = l.abiItem.name, u = (s = l.abiItem.inputs) == null ? void 0 : s.some((d) => !("name" in d && d.name));
      }
      return { ...o, args: u ? [] : {}, eventName: c };
    }
  }).filter(Boolean);
}
function _8t(t) {
  const { args: e, inputs: n, matchArgs: r } = t;
  if (!r)
    return !0;
  if (!e)
    return !1;
  function i(a, o, s) {
    try {
      return a.type === "address" ? nA(o, s) : a.type === "string" || a.type === "bytes" ? Or(Od(o)) === s : o === s;
    } catch {
      return !1;
    }
  }
  return Array.isArray(e) && Array.isArray(r) ? r.every((a, o) => {
    if (a == null)
      return !0;
    const s = n[o];
    return s ? (Array.isArray(a) ? a : [a]).some((c) => i(s, c, e[o])) : !1;
  }) : typeof e == "object" && !Array.isArray(e) && typeof r == "object" && !Array.isArray(r) ? Object.entries(r).every(([a, o]) => {
    if (o == null)
      return !0;
    const s = n.find((c) => c.name === a);
    return s ? (Array.isArray(o) ? o : [o]).some((c) => i(s, c, e[a])) : !1;
  }) : !1;
}
function pl(t, { args: e, eventName: n } = {}) {
  return {
    ...t,
    blockHash: t.blockHash ? t.blockHash : null,
    blockNumber: t.blockNumber ? BigInt(t.blockNumber) : null,
    logIndex: t.logIndex ? Number(t.logIndex) : null,
    transactionHash: t.transactionHash ? t.transactionHash : null,
    transactionIndex: t.transactionIndex ? Number(t.transactionIndex) : null,
    ...n ? { args: e, eventName: n } : {}
  };
}
async function aA(t, { address: e, blockHash: n, fromBlock: r, toBlock: i, event: a, events: o, args: s, strict: l } = {}) {
  const c = l ?? !1, u = o ?? (a ? [a] : void 0);
  let d = [];
  u && (d = [u.flatMap((m) => Rp({
    abi: [m],
    eventName: m.name,
    args: o ? void 0 : s
  }))], a && (d = d[0]));
  let f;
  n ? f = await t.request({
    method: "eth_getLogs",
    params: [{ address: e, topics: d, blockHash: n }]
  }) : f = await t.request({
    method: "eth_getLogs",
    params: [
      {
        address: e,
        topics: d,
        fromBlock: typeof r == "bigint" ? jt(r) : r,
        toBlock: typeof i == "bigint" ? jt(i) : i
      }
    ]
  });
  const h = f.map((p) => pl(p));
  return u ? iA({
    abi: u,
    args: s,
    logs: h,
    strict: c
  }) : h;
}
async function HK(t, e) {
  const { abi: n, address: r, args: i, blockHash: a, eventName: o, fromBlock: s, toBlock: l, strict: c } = e, u = o ? zp({ abi: n, name: o }) : void 0, d = u ? void 0 : n.filter((f) => f.type === "event");
  return zt(t, aA, "getLogs")({
    address: r,
    args: i,
    blockHash: a,
    event: u,
    events: d,
    fromBlock: s,
    toBlock: l,
    strict: c
  });
}
const iv = "/docs/contract/decodeFunctionResult";
function L0(t) {
  const { abi: e, args: n, functionName: r, data: i } = t;
  let a = e[0];
  if (r) {
    const s = zp({ abi: e, args: n, name: r });
    if (!s)
      throw new Jy(r, { docsPath: iv });
    a = s;
  }
  if (a.type !== "function")
    throw new Jy(void 0, { docsPath: iv });
  if (!a.outputs)
    throw new A6t(a.name, { docsPath: iv });
  const o = F6(a.outputs, i);
  if (o && o.length > 1)
    return o;
  if (o && o.length === 1)
    return o[0];
}
const ew = [
  {
    inputs: [
      {
        components: [
          {
            name: "target",
            type: "address"
          },
          {
            name: "allowFailure",
            type: "bool"
          },
          {
            name: "callData",
            type: "bytes"
          }
        ],
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate3",
    outputs: [
      {
        components: [
          {
            name: "success",
            type: "bool"
          },
          {
            name: "returnData",
            type: "bytes"
          }
        ],
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
], FK = [
  {
    inputs: [],
    name: "ResolverNotFound",
    type: "error"
  },
  {
    inputs: [],
    name: "ResolverWildcardNotSupported",
    type: "error"
  },
  {
    inputs: [],
    name: "ResolverNotContract",
    type: "error"
  },
  {
    inputs: [
      {
        name: "returnData",
        type: "bytes"
      }
    ],
    name: "ResolverError",
    type: "error"
  },
  {
    inputs: [
      {
        components: [
          {
            name: "status",
            type: "uint16"
          },
          {
            name: "message",
            type: "string"
          }
        ],
        name: "errors",
        type: "tuple[]"
      }
    ],
    name: "HttpError",
    type: "error"
  }
], _K = [
  ...FK,
  {
    name: "resolve",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes" },
      { name: "data", type: "bytes" }
    ],
    outputs: [
      { name: "", type: "bytes" },
      { name: "address", type: "address" }
    ]
  },
  {
    name: "resolve",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes" },
      { name: "data", type: "bytes" },
      { name: "gateways", type: "string[]" }
    ],
    outputs: [
      { name: "", type: "bytes" },
      { name: "address", type: "address" }
    ]
  }
], V8t = [
  ...FK,
  {
    name: "reverse",
    type: "function",
    stateMutability: "view",
    inputs: [{ type: "bytes", name: "reverseName" }],
    outputs: [
      { type: "string", name: "resolvedName" },
      { type: "address", name: "resolvedAddress" },
      { type: "address", name: "reverseResolver" },
      { type: "address", name: "resolver" }
    ]
  },
  {
    name: "reverse",
    type: "function",
    stateMutability: "view",
    inputs: [
      { type: "bytes", name: "reverseName" },
      { type: "string[]", name: "gateways" }
    ],
    outputs: [
      { type: "string", name: "resolvedName" },
      { type: "address", name: "resolvedAddress" },
      { type: "address", name: "reverseResolver" },
      { type: "address", name: "resolver" }
    ]
  }
], zD = [
  {
    name: "text",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes32" },
      { name: "key", type: "string" }
    ],
    outputs: [{ name: "", type: "string" }]
  }
], RD = [
  {
    name: "addr",
    type: "function",
    stateMutability: "view",
    inputs: [{ name: "name", type: "bytes32" }],
    outputs: [{ name: "", type: "address" }]
  },
  {
    name: "addr",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes32" },
      { name: "coinType", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bytes" }]
  }
], OD = [
  {
    inputs: [
      {
        name: "_signer",
        type: "address"
      },
      {
        name: "_hash",
        type: "bytes32"
      },
      {
        name: "_signature",
        type: "bytes"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        name: "_signer",
        type: "address"
      },
      {
        name: "_hash",
        type: "bytes32"
      },
      {
        name: "_signature",
        type: "bytes"
      }
    ],
    outputs: [
      {
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function",
    name: "isValidSig"
  }
], q8t = "0x82ad56cb", VK = "0x608060405234801561001057600080fd5b5060405161018e38038061018e83398101604081905261002f91610124565b6000808351602085016000f59050803b61004857600080fd5b6000808351602085016000855af16040513d6000823e81610067573d81fd5b3d81f35b634e487b7160e01b600052604160045260246000fd5b600082601f83011261009257600080fd5b81516001600160401b038111156100ab576100ab61006b565b604051601f8201601f19908116603f011681016001600160401b03811182821017156100d9576100d961006b565b6040528181528382016020018510156100f157600080fd5b60005b82811015610110576020818601810151838301820152016100f4565b506000918101602001919091529392505050565b6000806040838503121561013757600080fd5b82516001600160401b0381111561014d57600080fd5b61015985828601610081565b602085015190935090506001600160401b0381111561017757600080fd5b61018385828601610081565b915050925092905056fe", U8t = "0x608060405234801561001057600080fd5b506040516102c03803806102c083398101604081905261002f916101e6565b836001600160a01b03163b6000036100e457600080836001600160a01b03168360405161005c9190610270565b6000604051808303816000865af19150503d8060008114610099576040519150601f19603f3d011682016040523d82523d6000602084013e61009e565b606091505b50915091508115806100b857506001600160a01b0386163b155b156100e1578060405163101bb98d60e01b81526004016100d8919061028c565b60405180910390fd5b50505b6000808451602086016000885af16040513d6000823e81610103573d81fd5b3d81f35b80516001600160a01b038116811461011e57600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60005b8381101561015457818101518382015260200161013c565b50506000910152565b600082601f83011261016e57600080fd5b81516001600160401b0381111561018757610187610123565b604051601f8201601f19908116603f011681016001600160401b03811182821017156101b5576101b5610123565b6040528181528382016020018510156101cd57600080fd5b6101de826020830160208701610139565b949350505050565b600080600080608085870312156101fc57600080fd5b61020585610107565b60208601519094506001600160401b0381111561022157600080fd5b61022d8782880161015d565b93505061023c60408601610107565b60608601519092506001600160401b0381111561025857600080fd5b6102648782880161015d565b91505092959194509250565b60008251610282818460208701610139565b9190910192915050565b60208152600082518060208401526102ab816040850160208701610139565b601f01601f1916919091016040019291505056fe", W8t = "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";
class tw extends We {
  constructor({ blockNumber: e, chain: n, contract: r }) {
    super(`Chain "${n.name}" does not support contract "${r.name}".`, {
      metaMessages: [
        "This could be due to any of the following:",
        ...e && r.blockCreated && r.blockCreated > e ? [
          `- The contract "${r.name}" was not deployed until block ${r.blockCreated} (current block ${e}).`
        ] : [
          `- The chain does not have the contract "${r.name}" configured.`
        ]
      ],
      name: "ChainDoesNotSupportContract"
    });
  }
}
class qK extends We {
  constructor() {
    super("No chain was provided to the Client.", {
      name: "ClientChainNotConfiguredError"
    });
  }
}
const av = "/docs/contract/encodeDeployData";
function oA(t) {
  const { abi: e, args: n, bytecode: r } = t;
  if (!n || n.length === 0)
    return r;
  const i = e.find((o) => "type" in o && o.type === "constructor");
  if (!i)
    throw new w6t({ docsPath: av });
  if (!("inputs" in i))
    throw new hD({ docsPath: av });
  if (!i.inputs || i.inputs.length === 0)
    throw new hD({ docsPath: av });
  const a = Bd(i.inputs, n);
  return Pp([r, a]);
}
function Fd({ blockNumber: t, chain: e, contract: n }) {
  var i;
  const r = (i = e == null ? void 0 : e.contracts) == null ? void 0 : i[n];
  if (!r)
    throw new tw({
      chain: e,
      contract: { name: n }
    });
  if (t && r.blockCreated && r.blockCreated > t)
    throw new tw({
      blockNumber: t,
      chain: e,
      contract: {
        name: n,
        blockCreated: r.blockCreated
      }
    });
  return r.address;
}
function UK(t, { docsPath: e, ...n }) {
  const r = (() => {
    const i = KC(t, n);
    return i instanceof q6 ? t : i;
  })();
  return new kK(r, {
    docsPath: e,
    ...n
  });
}
function WK() {
  let t = () => {
  }, e = () => {
  };
  return { promise: new Promise((r, i) => {
    t = r, e = i;
  }), resolve: t, reject: e };
}
const ov = /* @__PURE__ */ new Map();
function ZK({ fn: t, id: e, shouldSplitBatch: n, wait: r = 0, sort: i }) {
  const a = async () => {
    const u = l();
    o();
    const d = u.map(({ args: f }) => f);
    d.length !== 0 && t(d).then((f) => {
      i && Array.isArray(f) && f.sort(i);
      for (let h = 0; h < u.length; h++) {
        const { resolve: p } = u[h];
        p == null || p([f[h], f]);
      }
    }).catch((f) => {
      for (let h = 0; h < u.length; h++) {
        const { reject: p } = u[h];
        p == null || p(f);
      }
    });
  }, o = () => ov.delete(e), s = () => l().map(({ args: u }) => u), l = () => ov.get(e) || [], c = (u) => ov.set(e, [...l(), u]);
  return {
    flush: o,
    async schedule(u) {
      const { promise: d, resolve: f, reject: h } = WK();
      return (n == null ? void 0 : n([...s(), u])) && a(), l().length > 0 ? (c({ args: u, resolve: f, reject: h }), d) : (c({ args: u, resolve: f, reject: h }), setTimeout(a, r), d);
    }
  };
}
async function W6(t, e) {
  var z, H, V, F;
  const { account: n = t.account, batch: r = !!((z = t.batch) != null && z.multicall), blockNumber: i, blockTag: a = "latest", accessList: o, blobs: s, code: l, data: c, factory: u, factoryData: d, gas: f, gasPrice: h, maxFeePerBlobGas: p, maxFeePerGas: m, maxPriorityFeePerGas: g, nonce: v, to: k, value: w, stateOverride: b, ...x } = e, A = n ? bo(n) : void 0;
  if (l && (u || d))
    throw new We("Cannot provide both `code` & `factory`/`factoryData` as parameters.");
  if (l && k)
    throw new We("Cannot provide both `code` & `to` as parameters.");
  const L = l && c, M = u && d && k && c, j = L || M, D = L ? Y8t({
    code: l,
    data: c
  }) : M ? K8t({
    data: c,
    factory: u,
    factoryData: d,
    to: k
  }) : c;
  try {
    Op(e);
    const W = (i ? jt(i) : void 0) || a, G = JC(b), Y = (F = (V = (H = t.chain) == null ? void 0 : H.formatters) == null ? void 0 : V.transactionRequest) == null ? void 0 : F.format, oe = (Y || U6)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...$C(x, { format: Y }),
      from: A == null ? void 0 : A.address,
      accessList: o,
      blobs: s,
      data: D,
      gas: f,
      gasPrice: h,
      maxFeePerBlobGas: p,
      maxFeePerGas: m,
      maxPriorityFeePerGas: g,
      nonce: v,
      to: j ? void 0 : k,
      value: w
    });
    if (r && Z8t({ request: oe }) && !G)
      try {
        return await G8t(t, {
          ...oe,
          blockNumber: i,
          blockTag: a
        });
      } catch (ae) {
        if (!(ae instanceof qK) && !(ae instanceof tw))
          throw ae;
      }
    const ee = await t.request({
      method: "eth_call",
      params: G ? [
        oe,
        W,
        G
      ] : [oe, W]
    });
    return ee === "0x" ? { data: void 0 } : { data: ee };
  } catch (_) {
    const W = $8t(_), { offchainLookup: G, offchainLookupSignature: Y } = await import("./ccip-D4KYgw4G.mjs");
    if (t.ccipRead !== !1 && (W == null ? void 0 : W.slice(0, 10)) === Y && k)
      return { data: await G(t, { data: W, to: k }) };
    throw j && (W == null ? void 0 : W.slice(0, 10)) === "0x101bb98d" ? new n8t({ factory: u }) : UK(_, {
      ...e,
      account: A,
      chain: t.chain
    });
  }
}
function Z8t({ request: t }) {
  const { data: e, to: n, ...r } = t;
  return !(!e || e.startsWith(q8t) || !n || Object.values(r).filter((i) => typeof i < "u").length > 0);
}
async function G8t(t, e) {
  var m;
  const { batchSize: n = 1024, wait: r = 0 } = typeof ((m = t.batch) == null ? void 0 : m.multicall) == "object" ? t.batch.multicall : {}, { blockNumber: i, blockTag: a = "latest", data: o, multicallAddress: s, to: l } = e;
  let c = s;
  if (!c) {
    if (!t.chain)
      throw new qK();
    c = Fd({
      blockNumber: i,
      chain: t.chain,
      contract: "multicall3"
    });
  }
  const d = (i ? jt(i) : void 0) || a, { schedule: f } = ZK({
    id: `${t.uid}.${d}`,
    wait: r,
    shouldSplitBatch(g) {
      return g.reduce((k, { data: w }) => k + (w.length - 2), 0) > n * 2;
    },
    fn: async (g) => {
      const v = g.map((b) => ({
        allowFailure: !0,
        callData: b.data,
        target: b.to
      })), k = hs({
        abi: ew,
        args: [v],
        functionName: "aggregate3"
      }), w = await t.request({
        method: "eth_call",
        params: [
          {
            data: k,
            to: c
          },
          d
        ]
      });
      return L0({
        abi: ew,
        args: [v],
        functionName: "aggregate3",
        data: w || "0x"
      });
    }
  }), [{ returnData: h, success: p }] = await f({ data: o, to: l });
  if (!p)
    throw new V6({ data: h });
  return h === "0x" ? { data: void 0 } : { data: h };
}
function Y8t(t) {
  const { code: e, data: n } = t;
  return oA({
    abi: UY(["constructor(bytes, bytes)"]),
    bytecode: VK,
    args: [e, n]
  });
}
function K8t(t) {
  const { data: e, factory: n, factoryData: r, to: i } = t;
  return oA({
    abi: UY(["constructor(address, bytes, address, bytes)"]),
    bytecode: U8t,
    args: [i, e, n, r]
  });
}
function $8t(t) {
  var n;
  if (!(t instanceof We))
    return;
  const e = t.walk();
  return typeof (e == null ? void 0 : e.data) == "object" ? (n = e.data) == null ? void 0 : n.data : e.data;
}
async function ml(t, e) {
  const { abi: n, address: r, args: i, functionName: a, ...o } = e, s = hs({
    abi: n,
    args: i,
    functionName: a
  });
  try {
    const { data: l } = await zt(t, W6, "call")({
      ...o,
      data: s,
      to: r
    });
    return L0({
      abi: n,
      args: i,
      functionName: a,
      data: l || "0x"
    });
  } catch (l) {
    throw X1(l, {
      abi: n,
      address: r,
      args: i,
      docsPath: "/docs/contract/readContract",
      functionName: a
    });
  }
}
async function J8t(t, e) {
  const { abi: n, address: r, args: i, dataSuffix: a, functionName: o, ...s } = e, l = s.account ? bo(s.account) : t.account, c = hs({ abi: n, args: i, functionName: o });
  try {
    const { data: u } = await zt(t, W6, "call")({
      batch: !1,
      data: `${c}${a ? a.replace("0x", "") : ""}`,
      to: r,
      ...s,
      account: l
    }), d = L0({
      abi: n,
      args: i,
      functionName: o,
      data: u || "0x"
    }), f = n.filter((h) => "name" in h && h.name === e.functionName);
    return {
      result: d,
      request: {
        abi: f,
        address: r,
        args: i,
        dataSuffix: a,
        functionName: o,
        ...s,
        account: l
      }
    };
  } catch (u) {
    throw X1(u, {
      abi: n,
      address: r,
      args: i,
      docsPath: "/docs/contract/simulateContract",
      functionName: o,
      sender: l == null ? void 0 : l.address
    });
  }
}
const sv = /* @__PURE__ */ new Map(), BD = /* @__PURE__ */ new Map();
let Q8t = 0;
function Ac(t, e, n) {
  const r = ++Q8t, i = () => sv.get(t) || [], a = () => {
    const u = i();
    sv.set(t, u.filter((d) => d.id !== r));
  }, o = () => {
    const u = i();
    if (!u.some((f) => f.id === r))
      return;
    const d = BD.get(t);
    u.length === 1 && d && d(), a();
  }, s = i();
  if (sv.set(t, [
    ...s,
    { id: r, fns: e }
  ]), s && s.length > 0)
    return o;
  const l = {};
  for (const u in e)
    l[u] = (...d) => {
      var h, p;
      const f = i();
      if (f.length !== 0)
        for (const m of f)
          (p = (h = m.fns)[u]) == null || p.call(h, ...d);
    };
  const c = n(l);
  return typeof c == "function" && BD.set(t, c), o;
}
async function nw(t) {
  return new Promise((e) => setTimeout(e, t));
}
function Bp(t, { emitOnBegin: e, initialWaitTime: n, interval: r }) {
  let i = !0;
  const a = () => i = !1;
  return (async () => {
    let s;
    e && (s = await t({ unpoll: a }));
    const l = await (n == null ? void 0 : n(s)) ?? r;
    await nw(l);
    const c = async () => {
      i && (await t({ unpoll: a }), await nw(r), c());
    };
    c();
  })(), a;
}
const X8t = /* @__PURE__ */ new Map(), evt = /* @__PURE__ */ new Map();
function tvt(t) {
  const e = (i, a) => ({
    clear: () => a.delete(i),
    get: () => a.get(i),
    set: (o) => a.set(i, o)
  }), n = e(t, X8t), r = e(t, evt);
  return {
    clear: () => {
      n.clear(), r.clear();
    },
    promise: n,
    response: r
  };
}
async function nvt(t, { cacheKey: e, cacheTime: n = Number.POSITIVE_INFINITY }) {
  const r = tvt(e), i = r.response.get();
  if (i && n > 0 && (/* @__PURE__ */ new Date()).getTime() - i.created.getTime() < n)
    return i.data;
  let a = r.promise.get();
  a || (a = t(), r.promise.set(a));
  try {
    const o = await a;
    return r.response.set({ created: /* @__PURE__ */ new Date(), data: o }), o;
  } finally {
    r.promise.clear();
  }
}
const rvt = (t) => `blockNumber.${t}`;
async function Hp(t, { cacheTime: e = t.cacheTime } = {}) {
  const n = await nvt(() => t.request({
    method: "eth_blockNumber"
  }), { cacheKey: rvt(t.uid), cacheTime: e });
  return BigInt(n);
}
async function Z6(t, { filter: e }) {
  const n = "strict" in e && e.strict, r = await e.request({
    method: "eth_getFilterChanges",
    params: [e.id]
  });
  if (typeof r[0] == "string")
    return r;
  const i = r.map((a) => pl(a));
  return !("abi" in e) || !e.abi ? i : iA({
    abi: e.abi,
    logs: i,
    strict: n
  });
}
async function G6(t, { filter: e }) {
  return e.request({
    method: "eth_uninstallFilter",
    params: [e.id]
  });
}
function ivt(t, e) {
  const { abi: n, address: r, args: i, batch: a = !0, eventName: o, fromBlock: s, onError: l, onLogs: c, poll: u, pollingInterval: d = t.pollingInterval, strict: f } = e;
  return (typeof u < "u" ? u : typeof s == "bigint" ? !0 : !(t.transport.type === "webSocket" || t.transport.type === "fallback" && t.transport.transports[0].config.type === "webSocket")) ? (() => {
    const g = f ?? !1, v = Hr([
      "watchContractEvent",
      r,
      i,
      a,
      t.uid,
      o,
      d,
      g,
      s
    ]);
    return Ac(v, { onLogs: c, onError: l }, (k) => {
      let w;
      s !== void 0 && (w = s - 1n);
      let b, x = !1;
      const A = Bp(async () => {
        var L;
        if (!x) {
          try {
            b = await zt(t, hK, "createContractEventFilter")({
              abi: n,
              address: r,
              args: i,
              eventName: o,
              strict: g,
              fromBlock: s
            });
          } catch {
          }
          x = !0;
          return;
        }
        try {
          let M;
          if (b)
            M = await zt(t, Z6, "getFilterChanges")({ filter: b });
          else {
            const j = await zt(t, Hp, "getBlockNumber")({});
            w && w < j ? M = await zt(t, HK, "getContractEvents")({
              abi: n,
              address: r,
              args: i,
              eventName: o,
              fromBlock: w + 1n,
              toBlock: j,
              strict: g
            }) : M = [], w = j;
          }
          if (M.length === 0)
            return;
          if (a)
            k.onLogs(M);
          else
            for (const j of M)
              k.onLogs([j]);
        } catch (M) {
          b && M instanceof s0 && (x = !1), (L = k.onError) == null || L.call(k, M);
        }
      }, {
        emitOnBegin: !0,
        interval: d
      });
      return async () => {
        b && await zt(t, G6, "uninstallFilter")({ filter: b }), A();
      };
    });
  })() : (() => {
    const g = f ?? !1, v = Hr([
      "watchContractEvent",
      r,
      i,
      a,
      t.uid,
      o,
      d,
      g
    ]);
    let k = !0, w = () => k = !1;
    return Ac(v, { onLogs: c, onError: l }, (b) => ((async () => {
      try {
        const x = (() => {
          if (t.transport.type === "fallback") {
            const M = t.transport.transports.find((j) => j.config.type === "webSocket");
            return M ? M.value : t.transport;
          }
          return t.transport;
        })(), A = o ? Rp({
          abi: n,
          eventName: o,
          args: i
        }) : [], { unsubscribe: L } = await x.subscribe({
          params: ["logs", { address: r, topics: A }],
          onData(M) {
            var D;
            if (!k)
              return;
            const j = M.result;
            try {
              const { eventName: z, args: H } = rA({
                abi: n,
                data: j.data,
                topics: j.topics,
                strict: f
              }), V = pl(j, {
                args: H,
                eventName: z
              });
              b.onLogs([V]);
            } catch (z) {
              let H, V;
              if (z instanceof a2 || z instanceof z6) {
                if (f)
                  return;
                H = z.abiItem.name, V = (D = z.abiItem.inputs) == null ? void 0 : D.some((_) => !("name" in _ && _.name));
              }
              const F = pl(j, {
                args: V ? [] : {},
                eventName: H
              });
              b.onLogs([F]);
            }
          },
          onError(M) {
            var j;
            (j = b.onError) == null || j.call(b, M);
          }
        });
        w = L, k || w();
      } catch (x) {
        l == null || l(x);
      }
    })(), () => w()));
  })();
}
async function avt(t, { serializedTransaction: e }) {
  return t.request({
    method: "eth_sendRawTransaction",
    params: [e]
  }, { retryCount: 0 });
}
class ovt extends We {
  constructor({ address: e }) {
    super(`No EIP-712 domain found on contract "${e}".`, {
      metaMessages: [
        "Ensure that:",
        `- The contract is deployed at the address "${e}".`,
        "- `eip712Domain()` function exists on the contract.",
        "- `eip712Domain()` function matches signature to ERC-5267 specification."
      ],
      name: "Eip712DomainNotFoundError"
    });
  }
}
async function svt(t, e) {
  const { address: n, factory: r, factoryData: i } = e;
  try {
    const [a, o, s, l, c, u, d] = await zt(t, ml, "readContract")({
      abi: lvt,
      address: n,
      functionName: "eip712Domain",
      factory: r,
      factoryData: i
    });
    return {
      domain: {
        name: o,
        version: s,
        chainId: Number(l),
        verifyingContract: c,
        salt: u
      },
      extensions: d,
      fields: a
    };
  } catch (a) {
    const o = a;
    throw o.name === "ContractFunctionExecutionError" && o.cause.name === "ContractFunctionZeroDataError" ? new ovt({ address: n }) : o;
  }
}
const lvt = [
  {
    inputs: [],
    name: "eip712Domain",
    outputs: [
      { name: "fields", type: "bytes1" },
      { name: "name", type: "string" },
      { name: "version", type: "string" },
      { name: "chainId", type: "uint256" },
      { name: "verifyingContract", type: "address" },
      { name: "salt", type: "bytes32" },
      { name: "extensions", type: "uint256[]" }
    ],
    stateMutability: "view",
    type: "function"
  }
], rw = 256;
let Vm = rw, qm;
function GK(t = 11) {
  if (!qm || Vm + t > rw * 2) {
    qm = "", Vm = 0;
    for (let e = 0; e < rw; e++)
      qm += (256 + Math.random() * 256 | 0).toString(16).substring(1);
  }
  return qm.substring(Vm, Vm++ + t);
}
function cvt(t) {
  const { batch: e, cacheTime: n = t.pollingInterval ?? 4e3, ccipRead: r, key: i = "base", name: a = "Base Client", pollingInterval: o = 4e3, type: s = "base" } = t, l = t.chain, c = t.account ? bo(t.account) : void 0, { config: u, request: d, value: f } = t.transport({
    chain: l,
    pollingInterval: o
  }), h = { ...u, ...f }, p = {
    account: c,
    batch: e,
    cacheTime: n,
    ccipRead: r,
    chain: l,
    key: i,
    name: a,
    pollingInterval: o,
    request: d,
    transport: h,
    type: s,
    uid: GK()
  };
  function m(g) {
    return (v) => {
      const k = v(g);
      for (const b in p)
        delete k[b];
      const w = { ...g, ...k };
      return Object.assign(w, { extend: m(w) });
    };
  }
  return Object.assign(p, { extend: m(p) });
}
const Um = /* @__PURE__ */ new _C(8192);
function uvt(t, { enabled: e = !0, id: n }) {
  if (!e || !n)
    return t();
  if (Um.get(n))
    return Um.get(n);
  const r = t().finally(() => Um.delete(n));
  return Um.set(n, r), r;
}
function iw(t, { delay: e = 100, retryCount: n = 2, shouldRetry: r = () => !0 } = {}) {
  return new Promise((i, a) => {
    const o = async ({ count: s = 0 } = {}) => {
      const l = async ({ error: c }) => {
        const u = typeof e == "function" ? e({ count: s, error: c }) : e;
        u && await nw(u), o({ count: s + 1 });
      };
      try {
        const c = await t();
        i(c);
      } catch (c) {
        if (s < n && await r({ count: s, error: c }))
          return l({ error: c });
        a(c);
      }
    };
    o();
  });
}
function dvt(t, e = {}) {
  return async (n, r = {}) => {
    var d;
    const { dedupe: i = !1, methods: a, retryDelay: o = 150, retryCount: s = 3, uid: l } = {
      ...e,
      ...r
    }, { method: c } = n;
    if ((d = a == null ? void 0 : a.exclude) != null && d.includes(c))
      throw new Su(new Error("method not supported"), {
        method: c
      });
    if (a != null && a.include && !a.include.includes(c))
      throw new Su(new Error("method not supported"), {
        method: c
      });
    const u = i ? o2(`${l}.${Hr(n)}`) : void 0;
    return uvt(() => iw(async () => {
      try {
        return await t(n);
      } catch (f) {
        const h = f;
        switch (h.code) {
          case l2.code:
            throw new l2(h);
          case c2.code:
            throw new c2(h);
          case u2.code:
            throw new u2(h, { method: n.method });
          case d2.code:
            throw new d2(h);
          case o0.code:
            throw new o0(h);
          case s0.code:
            throw new s0(h);
          case f2.code:
            throw new f2(h);
          case h2.code:
            throw new h2(h);
          case p2.code:
            throw new p2(h);
          case Su.code:
            throw new Su(h, {
              method: n.method
            });
          case Q1.code:
            throw new Q1(h);
          case m2.code:
            throw new m2(h);
          case x1.code:
            throw new x1(h);
          case y2.code:
            throw new y2(h);
          case g2.code:
            throw new g2(h);
          case v2.code:
            throw new v2(h);
          case b2.code:
            throw new b2(h);
          case w2.code:
            throw new w2(h);
          case 5e3:
            throw new x1(h);
          default:
            throw f instanceof We ? f : new i8t(h);
        }
      }
    }, {
      delay: ({ count: f, error: h }) => {
        var p;
        if (h && h instanceof sh) {
          const m = (p = h == null ? void 0 : h.headers) == null ? void 0 : p.get("Retry-After");
          if (m != null && m.match(/\d/))
            return Number.parseInt(m) * 1e3;
        }
        return ~~(1 << f) * o;
      },
      retryCount: s,
      shouldRetry: ({ error: f }) => fvt(f)
    }), { enabled: i, id: u });
  };
}
function fvt(t) {
  return "code" in t && typeof t.code == "number" ? t.code === -1 || t.code === Q1.code || t.code === o0.code : t instanceof sh && t.status ? t.status === 403 || t.status === 408 || t.status === 413 || t.status === 429 || t.status === 500 || t.status === 502 || t.status === 503 || t.status === 504 : !0;
}
function hvt({ key: t, methods: e, name: n, request: r, retryCount: i = 3, retryDelay: a = 150, timeout: o, type: s }, l) {
  const c = GK();
  return {
    config: {
      key: t,
      methods: e,
      name: n,
      request: r,
      retryCount: i,
      retryDelay: a,
      timeout: o,
      type: s
    },
    request: dvt(r, { methods: e, retryCount: i, retryDelay: a, uid: c }),
    value: l
  };
}
class pvt extends We {
  constructor() {
    super("No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.", {
      docsPath: "/docs/clients/intro",
      name: "UrlRequiredError"
    });
  }
}
function mvt(t, { errorInstance: e = new Error("timed out"), timeout: n, signal: r }) {
  return new Promise((i, a) => {
    (async () => {
      let o;
      try {
        const s = new AbortController();
        n > 0 && (o = setTimeout(() => {
          r && s.abort();
        }, n)), i(await t({ signal: (s == null ? void 0 : s.signal) || null }));
      } catch (s) {
        (s == null ? void 0 : s.name) === "AbortError" && a(e), a(s);
      } finally {
        clearTimeout(o);
      }
    })();
  });
}
function yvt() {
  return {
    current: 0,
    take() {
      return this.current++;
    },
    reset() {
      this.current = 0;
    }
  };
}
const HD = /* @__PURE__ */ yvt();
function gvt(t, e = {}) {
  return {
    async request(n) {
      var d;
      const { body: r, onRequest: i = e.onRequest, onResponse: a = e.onResponse, timeout: o = e.timeout ?? 1e4 } = n, s = {
        ...e.fetchOptions ?? {},
        ...n.fetchOptions ?? {}
      }, { headers: l, method: c, signal: u } = s;
      try {
        const f = await mvt(async ({ signal: p }) => {
          const m = {
            ...s,
            body: Array.isArray(r) ? Hr(r.map((w) => ({
              jsonrpc: "2.0",
              id: w.id ?? HD.take(),
              ...w
            }))) : Hr({
              jsonrpc: "2.0",
              id: r.id ?? HD.take(),
              ...r
            }),
            headers: {
              "Content-Type": "application/json",
              ...l
            },
            method: c || "POST",
            signal: u || (o > 0 ? p : null)
          }, g = new Request(t, m), v = await (i == null ? void 0 : i(g, m)) ?? { ...m, url: t };
          return await fetch(v.url ?? t, v);
        }, {
          errorInstance: new TD({ body: r, url: t }),
          timeout: o,
          signal: !0
        });
        a && await a(f);
        let h;
        if ((d = f.headers.get("Content-Type")) != null && d.startsWith("application/json"))
          h = await f.json();
        else {
          h = await f.text();
          try {
            h = JSON.parse(h || "{}");
          } catch (p) {
            if (f.ok)
              throw p;
            h = { error: h };
          }
        }
        if (!f.ok)
          throw new sh({
            body: r,
            details: Hr(h.error) || f.statusText,
            headers: f.headers,
            status: f.status,
            url: t
          });
        return h;
      } catch (f) {
        throw f instanceof sh || f instanceof TD ? f : new sh({
          body: r,
          cause: f,
          url: t
        });
      }
    }
  };
}
function vvt(t, e = {}) {
  const { batch: n, fetchOptions: r, key: i = "http", methods: a, name: o = "HTTP JSON-RPC", onFetchRequest: s, onFetchResponse: l, retryDelay: c, raw: u } = e;
  return ({ chain: d, retryCount: f, timeout: h }) => {
    const { batchSize: p = 1e3, wait: m = 0 } = typeof n == "object" ? n : {}, g = e.retryCount ?? f, v = h ?? e.timeout ?? 1e4, k = t || (d == null ? void 0 : d.rpcUrls.default.http[0]);
    if (!k)
      throw new pvt();
    const w = gvt(k, {
      fetchOptions: r,
      onRequest: s,
      onResponse: l,
      timeout: v
    });
    return hvt({
      key: i,
      methods: a,
      name: o,
      async request({ method: b, params: x }) {
        const A = { method: b, params: x }, { schedule: L } = ZK({
          id: k,
          wait: m,
          shouldSplitBatch(z) {
            return z.length > p;
          },
          fn: (z) => w.request({
            body: z
          }),
          sort: (z, H) => z.id - H.id
        }), M = async (z) => n ? L(z) : [
          await w.request({
            body: z
          })
        ], [{ error: j, result: D }] = await M(A);
        if (u)
          return { error: j, result: D };
        if (j)
          throw new YC({
            body: A,
            error: j,
            url: k
          });
        return D;
      },
      retryCount: g,
      retryDelay: c,
      timeout: v,
      type: "http"
    }, {
      fetchOptions: r,
      url: k
    });
  };
}
function sA(t, e) {
  var r, i, a, o, s, l;
  if (!(t instanceof We))
    return !1;
  const n = t.walk((c) => c instanceof U9);
  return n instanceof U9 ? !!(((r = n.data) == null ? void 0 : r.errorName) === "ResolverNotFound" || ((i = n.data) == null ? void 0 : i.errorName) === "ResolverWildcardNotSupported" || ((a = n.data) == null ? void 0 : a.errorName) === "ResolverNotContract" || ((o = n.data) == null ? void 0 : o.errorName) === "ResolverError" || ((s = n.data) == null ? void 0 : s.errorName) === "HttpError" || (l = n.reason) != null && l.includes("Wildcard on non-extended resolvers is not supported") || e === "reverse" && n.reason === pK[50]) : !1;
}
function YK(t) {
  if (t.length !== 66 || t.indexOf("[") !== 0 || t.indexOf("]") !== 65)
    return null;
  const e = `0x${t.slice(1, 65)}`;
  return is(e) ? e : null;
}
function Y4(t) {
  let e = new Uint8Array(32).fill(0);
  if (!t)
    return mr(e);
  const n = t.split(".");
  for (let r = n.length - 1; r >= 0; r -= 1) {
    const i = YK(n[r]), a = i ? Od(i) : Or(Bu(n[r]), "bytes");
    e = Or(hl([e, a]), "bytes");
  }
  return mr(e);
}
function bvt(t) {
  return `[${t.slice(2)}]`;
}
function wvt(t) {
  const e = new Uint8Array(32).fill(0);
  return t ? YK(t) || Or(Bu(t)) : mr(e);
}
function Y6(t) {
  const e = t.replace(/^\.|\.$/gm, "");
  if (e.length === 0)
    return new Uint8Array(1);
  const n = new Uint8Array(Bu(e).byteLength + 2);
  let r = 0;
  const i = e.split(".");
  for (let a = 0; a < i.length; a++) {
    let o = Bu(i[a]);
    o.byteLength > 255 && (o = Bu(bvt(wvt(i[a])))), n[r] = o.length, n.set(o, r + 1), r += o.length + 1;
  }
  return n.byteLength !== r + 1 ? n.slice(0, r + 1) : n;
}
async function kvt(t, { blockNumber: e, blockTag: n, coinType: r, name: i, gatewayUrls: a, strict: o, universalResolverAddress: s }) {
  let l = s;
  if (!l) {
    if (!t.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    l = Fd({
      blockNumber: e,
      chain: t.chain,
      contract: "ensUniversalResolver"
    });
  }
  try {
    const c = hs({
      abi: RD,
      functionName: "addr",
      ...r != null ? { args: [Y4(i), BigInt(r)] } : { args: [Y4(i)] }
    }), u = {
      address: l,
      abi: _K,
      functionName: "resolve",
      args: [fl(Y6(i)), c],
      blockNumber: e,
      blockTag: n
    }, d = zt(t, ml, "readContract"), f = a ? await d({
      ...u,
      args: [...u.args, a]
    }) : await d(u);
    if (f[0] === "0x")
      return null;
    const h = L0({
      abi: RD,
      args: r != null ? [Y4(i), BigInt(r)] : void 0,
      functionName: "addr",
      data: f[0]
    });
    return h === "0x" || Ou(h) === "0x00" ? null : h;
  } catch (c) {
    if (o)
      throw c;
    if (sA(c, "resolve"))
      return null;
    throw c;
  }
}
class xvt extends We {
  constructor({ data: e }) {
    super("Unable to extract image from metadata. The metadata may be malformed or invalid.", {
      metaMessages: [
        "- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.",
        "",
        `Provided data: ${JSON.stringify(e)}`
      ],
      name: "EnsAvatarInvalidMetadataError"
    });
  }
}
class yf extends We {
  constructor({ reason: e }) {
    super(`ENS NFT avatar URI is invalid. ${e}`, {
      name: "EnsAvatarInvalidNftUriError"
    });
  }
}
class lA extends We {
  constructor({ uri: e }) {
    super(`Unable to resolve ENS avatar URI "${e}". The URI may be malformed, invalid, or does not respond with a valid image.`, { name: "EnsAvatarUriResolutionError" });
  }
}
class Mvt extends We {
  constructor({ namespace: e }) {
    super(`ENS NFT avatar namespace "${e}" is not supported. Must be "erc721" or "erc1155".`, { name: "EnsAvatarUnsupportedNamespaceError" });
  }
}
const Cvt = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/, Avt = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/, Svt = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/, Lvt = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
async function Tvt(t) {
  try {
    const e = await fetch(t, { method: "HEAD" });
    if (e.status === 200) {
      const n = e.headers.get("content-type");
      return n == null ? void 0 : n.startsWith("image/");
    }
    return !1;
  } catch (e) {
    return typeof e == "object" && typeof e.response < "u" || !globalThis.hasOwnProperty("Image") ? !1 : new Promise((n) => {
      const r = new Image();
      r.onload = () => {
        n(!0);
      }, r.onerror = () => {
        n(!1);
      }, r.src = t;
    });
  }
}
function FD(t, e) {
  return t ? t.endsWith("/") ? t.slice(0, -1) : t : e;
}
function KK({ uri: t, gatewayUrls: e }) {
  const n = Svt.test(t);
  if (n)
    return { uri: t, isOnChain: !0, isEncoded: n };
  const r = FD(e == null ? void 0 : e.ipfs, "https://ipfs.io"), i = FD(e == null ? void 0 : e.arweave, "https://arweave.net"), a = t.match(Cvt), { protocol: o, subpath: s, target: l, subtarget: c = "" } = (a == null ? void 0 : a.groups) || {}, u = o === "ipns:/" || s === "ipns/", d = o === "ipfs:/" || s === "ipfs/" || Avt.test(t);
  if (t.startsWith("http") && !u && !d) {
    let h = t;
    return e != null && e.arweave && (h = t.replace(/https:\/\/arweave.net/g, e == null ? void 0 : e.arweave)), { uri: h, isOnChain: !1, isEncoded: !1 };
  }
  if ((u || d) && l)
    return {
      uri: `${r}/${u ? "ipns" : "ipfs"}/${l}${c}`,
      isOnChain: !1,
      isEncoded: !1
    };
  if (o === "ar:/" && l)
    return {
      uri: `${i}/${l}${c || ""}`,
      isOnChain: !1,
      isEncoded: !1
    };
  let f = t.replace(Lvt, "");
  if (f.startsWith("<svg") && (f = `data:image/svg+xml;base64,${btoa(f)}`), f.startsWith("data:") || f.startsWith("{"))
    return {
      uri: f,
      isOnChain: !0,
      isEncoded: !1
    };
  throw new lA({ uri: t });
}
function $K(t) {
  if (typeof t != "object" || !("image" in t) && !("image_url" in t) && !("image_data" in t))
    throw new xvt({ data: t });
  return t.image || t.image_url || t.image_data;
}
async function Evt({ gatewayUrls: t, uri: e }) {
  try {
    const n = await fetch(e).then((i) => i.json());
    return await cA({
      gatewayUrls: t,
      uri: $K(n)
    });
  } catch {
    throw new lA({ uri: e });
  }
}
async function cA({ gatewayUrls: t, uri: e }) {
  const { uri: n, isOnChain: r } = KK({ uri: e, gatewayUrls: t });
  if (r || await Tvt(n))
    return n;
  throw new lA({ uri: e });
}
function jvt(t) {
  let e = t;
  e.startsWith("did:nft:") && (e = e.replace("did:nft:", "").replace(/_/g, "/"));
  const [n, r, i] = e.split("/"), [a, o] = n.split(":"), [s, l] = r.split(":");
  if (!a || a.toLowerCase() !== "eip155")
    throw new yf({ reason: "Only EIP-155 supported" });
  if (!o)
    throw new yf({ reason: "Chain ID not found" });
  if (!l)
    throw new yf({
      reason: "Contract address not found"
    });
  if (!i)
    throw new yf({ reason: "Token ID not found" });
  if (!s)
    throw new yf({ reason: "ERC namespace not found" });
  return {
    chainID: Number.parseInt(o),
    namespace: s.toLowerCase(),
    contractAddress: l,
    tokenID: i
  };
}
async function Nvt(t, { nft: e }) {
  if (e.namespace === "erc721")
    return ml(t, {
      address: e.contractAddress,
      abi: [
        {
          name: "tokenURI",
          type: "function",
          stateMutability: "view",
          inputs: [{ name: "tokenId", type: "uint256" }],
          outputs: [{ name: "", type: "string" }]
        }
      ],
      functionName: "tokenURI",
      args: [BigInt(e.tokenID)]
    });
  if (e.namespace === "erc1155")
    return ml(t, {
      address: e.contractAddress,
      abi: [
        {
          name: "uri",
          type: "function",
          stateMutability: "view",
          inputs: [{ name: "_id", type: "uint256" }],
          outputs: [{ name: "", type: "string" }]
        }
      ],
      functionName: "uri",
      args: [BigInt(e.tokenID)]
    });
  throw new Mvt({ namespace: e.namespace });
}
async function Dvt(t, { gatewayUrls: e, record: n }) {
  return /eip155:/i.test(n) ? Ivt(t, { gatewayUrls: e, record: n }) : cA({ uri: n, gatewayUrls: e });
}
async function Ivt(t, { gatewayUrls: e, record: n }) {
  const r = jvt(n), i = await Nvt(t, { nft: r }), { uri: a, isOnChain: o, isEncoded: s } = KK({ uri: i, gatewayUrls: e });
  if (o && (a.includes("data:application/json;base64,") || a.startsWith("{"))) {
    const c = s ? (
      // if it is encoded, decode it
      atob(a.replace("data:application/json;base64,", ""))
    ) : (
      // if it isn't encoded assume it is a JSON string, but it could be anything (it will error if it is)
      a
    ), u = JSON.parse(c);
    return cA({ uri: $K(u), gatewayUrls: e });
  }
  let l = r.tokenID;
  return r.namespace === "erc1155" && (l = l.replace("0x", "").padStart(64, "0")), Evt({
    gatewayUrls: e,
    uri: a.replace(/(?:0x)?{id}/, l)
  });
}
async function JK(t, { blockNumber: e, blockTag: n, name: r, key: i, gatewayUrls: a, strict: o, universalResolverAddress: s }) {
  let l = s;
  if (!l) {
    if (!t.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    l = Fd({
      blockNumber: e,
      chain: t.chain,
      contract: "ensUniversalResolver"
    });
  }
  try {
    const c = {
      address: l,
      abi: _K,
      functionName: "resolve",
      args: [
        fl(Y6(r)),
        hs({
          abi: zD,
          functionName: "text",
          args: [Y4(r), i]
        })
      ],
      blockNumber: e,
      blockTag: n
    }, u = zt(t, ml, "readContract"), d = a ? await u({
      ...c,
      args: [...c.args, a]
    }) : await u(c);
    if (d[0] === "0x")
      return null;
    const f = L0({
      abi: zD,
      functionName: "text",
      data: d[0]
    });
    return f === "" ? null : f;
  } catch (c) {
    if (o)
      throw c;
    if (sA(c, "resolve"))
      return null;
    throw c;
  }
}
async function Pvt(t, { blockNumber: e, blockTag: n, assetGatewayUrls: r, name: i, gatewayUrls: a, strict: o, universalResolverAddress: s }) {
  const l = await zt(t, JK, "getEnsText")({
    blockNumber: e,
    blockTag: n,
    key: "avatar",
    name: i,
    universalResolverAddress: s,
    gatewayUrls: a,
    strict: o
  });
  if (!l)
    return null;
  try {
    return await Dvt(t, {
      record: l,
      gatewayUrls: r
    });
  } catch {
    return null;
  }
}
async function zvt(t, { address: e, blockNumber: n, blockTag: r, gatewayUrls: i, strict: a, universalResolverAddress: o }) {
  let s = o;
  if (!s) {
    if (!t.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    s = Fd({
      blockNumber: n,
      chain: t.chain,
      contract: "ensUniversalResolver"
    });
  }
  const l = `${e.toLowerCase().substring(2)}.addr.reverse`;
  try {
    const c = {
      address: s,
      abi: V8t,
      functionName: "reverse",
      args: [fl(Y6(l))],
      blockNumber: n,
      blockTag: r
    }, u = zt(t, ml, "readContract"), [d, f] = i ? await u({
      ...c,
      args: [...c.args, i]
    }) : await u(c);
    return e.toLowerCase() !== f.toLowerCase() ? null : d;
  } catch (c) {
    if (a)
      throw c;
    if (sA(c, "reverse"))
      return null;
    throw c;
  }
}
async function Rvt(t, { blockNumber: e, blockTag: n, name: r, universalResolverAddress: i }) {
  let a = i;
  if (!a) {
    if (!t.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    a = Fd({
      blockNumber: e,
      chain: t.chain,
      contract: "ensUniversalResolver"
    });
  }
  const [o] = await zt(t, ml, "readContract")({
    address: a,
    abi: [
      {
        inputs: [{ type: "bytes" }],
        name: "findResolver",
        outputs: [{ type: "address" }, { type: "bytes32" }],
        stateMutability: "view",
        type: "function"
      }
    ],
    functionName: "findResolver",
    args: [fl(Y6(r))],
    blockNumber: e,
    blockTag: n
  });
  return o;
}
async function QK(t, e) {
  var g, v, k;
  const { account: n = t.account, blockNumber: r, blockTag: i = "latest", blobs: a, data: o, gas: s, gasPrice: l, maxFeePerBlobGas: c, maxFeePerGas: u, maxPriorityFeePerGas: d, to: f, value: h, ...p } = e, m = n ? bo(n) : void 0;
  try {
    Op(e);
    const b = (r ? jt(r) : void 0) || i, x = (k = (v = (g = t.chain) == null ? void 0 : g.formatters) == null ? void 0 : v.transactionRequest) == null ? void 0 : k.format, L = (x || U6)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...$C(p, { format: x }),
      from: m == null ? void 0 : m.address,
      blobs: a,
      data: o,
      gas: s,
      gasPrice: l,
      maxFeePerBlobGas: c,
      maxFeePerGas: u,
      maxPriorityFeePerGas: d,
      to: f,
      value: h
    }), M = await t.request({
      method: "eth_createAccessList",
      params: [L, b]
    });
    return {
      accessList: M.accessList,
      gasUsed: BigInt(M.gasUsed)
    };
  } catch (w) {
    throw UK(w, {
      ...e,
      account: m,
      chain: t.chain
    });
  }
}
async function Ovt(t) {
  const e = H6(t, {
    method: "eth_newBlockFilter"
  }), n = await t.request({
    method: "eth_newBlockFilter"
  });
  return { id: n, request: e(n), type: "block" };
}
async function XK(t, { address: e, args: n, event: r, events: i, fromBlock: a, strict: o, toBlock: s } = {}) {
  const l = i ?? (r ? [r] : void 0), c = H6(t, {
    method: "eth_newFilter"
  });
  let u = [];
  l && (u = [l.flatMap((h) => Rp({
    abi: [h],
    eventName: h.name,
    args: n
  }))], r && (u = u[0]));
  const d = await t.request({
    method: "eth_newFilter",
    params: [
      {
        address: e,
        fromBlock: typeof a == "bigint" ? jt(a) : a,
        toBlock: typeof s == "bigint" ? jt(s) : s,
        ...u.length ? { topics: u } : {}
      }
    ]
  });
  return {
    abi: l,
    args: n,
    eventName: r ? r.name : void 0,
    fromBlock: a,
    id: d,
    request: c(d),
    strict: !!o,
    toBlock: s,
    type: "event"
  };
}
async function e$(t) {
  const e = H6(t, {
    method: "eth_newPendingTransactionFilter"
  }), n = await t.request({
    method: "eth_newPendingTransactionFilter"
  });
  return { id: n, request: e(n), type: "transaction" };
}
async function Bvt(t) {
  const e = await t.request({
    method: "eth_blobBaseFee"
  });
  return BigInt(e);
}
async function Hvt(t, { blockHash: e, blockNumber: n, blockTag: r = "latest" } = {}) {
  const i = n !== void 0 ? jt(n) : void 0;
  let a;
  return e ? a = await t.request({
    method: "eth_getBlockTransactionCountByHash",
    params: [e]
  }, { dedupe: !0 }) : a = await t.request({
    method: "eth_getBlockTransactionCountByNumber",
    params: [i || r]
  }, { dedupe: !!i }), dl(a);
}
async function _D(t, { address: e, blockNumber: n, blockTag: r = "latest" }) {
  const i = n !== void 0 ? jt(n) : void 0, a = await t.request({
    method: "eth_getCode",
    params: [e, i || r]
  }, { dedupe: !!i });
  if (a !== "0x")
    return a;
}
function Fvt(t) {
  var e;
  return {
    baseFeePerGas: t.baseFeePerGas.map((n) => BigInt(n)),
    gasUsedRatio: t.gasUsedRatio,
    oldestBlock: BigInt(t.oldestBlock),
    reward: (e = t.reward) == null ? void 0 : e.map((n) => n.map((r) => BigInt(r)))
  };
}
async function _vt(t, { blockCount: e, blockNumber: n, blockTag: r = "latest", rewardPercentiles: i }) {
  const a = n ? jt(n) : void 0, o = await t.request({
    method: "eth_feeHistory",
    params: [
      jt(e),
      a || r,
      i
    ]
  }, { dedupe: !!a });
  return Fvt(o);
}
async function Vvt(t, { filter: e }) {
  const n = e.strict ?? !1, i = (await e.request({
    method: "eth_getFilterLogs",
    params: [e.id]
  })).map((a) => pl(a));
  return e.abi ? iA({
    abi: e.abi,
    logs: i,
    strict: n
  }) : i;
}
function qvt(t) {
  return {
    formatters: void 0,
    fees: void 0,
    serializers: void 0,
    ...t
  };
}
class Uvt extends We {
  constructor({ domain: e }) {
    super(`Invalid domain "${Hr(e)}".`, {
      metaMessages: ["Must be a valid EIP-712 domain."]
    });
  }
}
class Wvt extends We {
  constructor({ primaryType: e, types: n }) {
    super(`Invalid primary type \`${e}\` must be one of \`${JSON.stringify(Object.keys(n))}\`.`, {
      docsPath: "/api/glossary/Errors#typeddatainvalidprimarytypeerror",
      metaMessages: ["Check that the primary type is a key in `types`."]
    });
  }
}
class Zvt extends We {
  constructor({ type: e }) {
    super(`Struct type "${e}" is invalid.`, {
      metaMessages: ["Struct type must not be a Solidity type."],
      name: "InvalidStructTypeError"
    });
  }
}
function Gvt(t) {
  const { domain: e = {}, message: n, primaryType: r } = t, i = {
    EIP712Domain: Qvt({ domain: e }),
    ...t.types
  };
  Jvt({
    domain: e,
    message: n,
    primaryType: r,
    types: i
  });
  const a = ["0x1901"];
  return e && a.push(Yvt({
    domain: e,
    types: i
  })), r !== "EIP712Domain" && a.push(t$({
    data: n,
    primaryType: r,
    types: i
  })), Or(hl(a));
}
function Yvt({ domain: t, types: e }) {
  return t$({
    data: t,
    primaryType: "EIP712Domain",
    types: e
  });
}
function t$({ data: t, primaryType: e, types: n }) {
  const r = n$({
    data: t,
    primaryType: e,
    types: n
  });
  return Or(r);
}
function n$({ data: t, primaryType: e, types: n }) {
  const r = [{ type: "bytes32" }], i = [Kvt({ primaryType: e, types: n })];
  for (const a of n[e]) {
    const [o, s] = i$({
      types: n,
      name: a.name,
      type: a.type,
      value: t[a.name]
    });
    r.push(o), i.push(s);
  }
  return Bd(r, i);
}
function Kvt({ primaryType: t, types: e }) {
  const n = fl($vt({ primaryType: t, types: e }));
  return Or(n);
}
function $vt({ primaryType: t, types: e }) {
  let n = "";
  const r = r$({ primaryType: t, types: e });
  r.delete(t);
  const i = [t, ...Array.from(r).sort()];
  for (const a of i)
    n += `${a}(${e[a].map(({ name: o, type: s }) => `${s} ${o}`).join(",")})`;
  return n;
}
function r$({ primaryType: t, types: e }, n = /* @__PURE__ */ new Set()) {
  const r = t.match(/^\w*/u), i = r == null ? void 0 : r[0];
  if (n.has(i) || e[i] === void 0)
    return n;
  n.add(i);
  for (const a of e[i])
    r$({ primaryType: a.type, types: e }, n);
  return n;
}
function i$({ types: t, name: e, type: n, value: r }) {
  if (t[n] !== void 0)
    return [
      { type: "bytes32" },
      Or(n$({ data: r, primaryType: n, types: t }))
    ];
  if (n === "bytes")
    return r = `0x${(r.length % 2 ? "0" : "") + r.slice(2)}`, [{ type: "bytes32" }, Or(r)];
  if (n === "string")
    return [{ type: "bytes32" }, Or(fl(r))];
  if (n.lastIndexOf("]") === n.length - 1) {
    const i = n.slice(0, n.lastIndexOf("[")), a = r.map((o) => i$({
      name: e,
      type: i,
      types: t,
      value: o
    }));
    return [
      { type: "bytes32" },
      Or(Bd(a.map(([o]) => o), a.map(([, o]) => o)))
    ];
  }
  return [{ type: n }, r];
}
function Jvt(t) {
  const { domain: e, message: n, primaryType: r, types: i } = t, a = (o, s) => {
    for (const l of o) {
      const { name: c, type: u } = l, d = s[c], f = u.match(dK);
      if (f && (typeof d == "number" || typeof d == "bigint")) {
        const [m, g, v] = f;
        jt(d, {
          signed: g === "int",
          size: Number.parseInt(v) / 8
        });
      }
      if (u === "address" && typeof d == "string" && !Ia(d))
        throw new Cc({ address: d });
      const h = u.match(w5t);
      if (h) {
        const [m, g] = h;
        if (g && tr(d) !== Number.parseInt(g))
          throw new L6t({
            expectedSize: Number.parseInt(g),
            givenSize: tr(d)
          });
      }
      const p = i[u];
      p && (Xvt(u), a(p, d));
    }
  };
  if (i.EIP712Domain && e) {
    if (typeof e != "object")
      throw new Uvt({ domain: e });
    a(i.EIP712Domain, e);
  }
  if (r !== "EIP712Domain")
    if (i[r])
      a(i[r], n);
    else
      throw new Wvt({ primaryType: r, types: i });
}
function Qvt({ domain: t }) {
  return [
    typeof (t == null ? void 0 : t.name) == "string" && { name: "name", type: "string" },
    (t == null ? void 0 : t.version) && { name: "version", type: "string" },
    (typeof (t == null ? void 0 : t.chainId) == "number" || typeof (t == null ? void 0 : t.chainId) == "bigint") && {
      name: "chainId",
      type: "uint256"
    },
    (t == null ? void 0 : t.verifyingContract) && {
      name: "verifyingContract",
      type: "address"
    },
    (t == null ? void 0 : t.salt) && { name: "salt", type: "bytes32" }
  ].filter(Boolean);
}
function Xvt(t) {
  if (t === "address" || t === "bool" || t === "string" || t.startsWith("bytes") || t.startsWith("uint") || t.startsWith("int"))
    throw new Zvt({ type: t });
}
const ebt = {
  "0x0": "reverted",
  "0x1": "success"
};
function tbt(t) {
  const e = {
    ...t,
    blockNumber: t.blockNumber ? BigInt(t.blockNumber) : null,
    contractAddress: t.contractAddress ? t.contractAddress : null,
    cumulativeGasUsed: t.cumulativeGasUsed ? BigInt(t.cumulativeGasUsed) : null,
    effectiveGasPrice: t.effectiveGasPrice ? BigInt(t.effectiveGasPrice) : null,
    gasUsed: t.gasUsed ? BigInt(t.gasUsed) : null,
    logs: t.logs ? t.logs.map((n) => pl(n)) : null,
    to: t.to ? t.to : null,
    transactionIndex: t.transactionIndex ? dl(t.transactionIndex) : null,
    status: t.status ? ebt[t.status] : null,
    type: t.type ? SK[t.type] || t.type : null
  };
  return t.blobGasPrice && (e.blobGasPrice = BigInt(t.blobGasPrice)), t.blobGasUsed && (e.blobGasUsed = BigInt(t.blobGasUsed)), e;
}
const nbt = `Ethereum Signed Message:
`;
function rbt(t) {
  const e = typeof t == "string" ? o2(t) : typeof t.raw == "string" ? t.raw : mr(t.raw), n = o2(`${nbt}${tr(e)}`);
  return hl([n, e]);
}
function a$(t, e) {
  return Or(rbt(t), e);
}
const o$ = "0x6492649264926492649264926492649264926492649264926492649264926492";
function ibt(t) {
  return uK(t, -32) === o$;
}
function abt(t) {
  const { address: e, data: n, signature: r, to: i = "hex" } = t, a = Pp([
    Bd([{ type: "address" }, { type: "bytes" }, { type: "bytes" }], [e, n, r]),
    o$
  ]);
  return i === "hex" ? a : so(a);
}
function obt(t) {
  return t.map((e) => ({
    ...e,
    value: BigInt(e.value)
  }));
}
function sbt(t) {
  return {
    ...t,
    balance: t.balance ? BigInt(t.balance) : void 0,
    nonce: t.nonce ? dl(t.nonce) : void 0,
    storageProof: t.storageProof ? obt(t.storageProof) : void 0
  };
}
async function lbt(t, { address: e, blockNumber: n, blockTag: r, storageKeys: i }) {
  const a = r ?? "latest", o = n !== void 0 ? jt(n) : void 0, s = await t.request({
    method: "eth_getProof",
    params: [e, i, o || a]
  });
  return sbt(s);
}
async function cbt(t, { address: e, blockNumber: n, blockTag: r = "latest", slot: i }) {
  const a = n !== void 0 ? jt(n) : void 0;
  return await t.request({
    method: "eth_getStorageAt",
    params: [e, i, a || r]
  });
}
async function uA(t, { blockHash: e, blockNumber: n, blockTag: r, hash: i, index: a }) {
  var u, d, f;
  const o = r || "latest", s = n !== void 0 ? jt(n) : void 0;
  let l = null;
  if (i ? l = await t.request({
    method: "eth_getTransactionByHash",
    params: [i]
  }, { dedupe: !0 }) : e ? l = await t.request({
    method: "eth_getTransactionByBlockHashAndIndex",
    params: [e, jt(a)]
  }, { dedupe: !0 }) : l = await t.request({
    method: "eth_getTransactionByBlockNumberAndIndex",
    params: [s || o, jt(a)]
  }, { dedupe: !!s }), !l)
    throw new bK({
      blockHash: e,
      blockNumber: n,
      blockTag: o,
      hash: i,
      index: a
    });
  return (((f = (d = (u = t.chain) == null ? void 0 : u.formatters) == null ? void 0 : d.transaction) == null ? void 0 : f.format) || LK)(l);
}
async function ubt(t, { hash: e, transactionReceipt: n }) {
  const [r, i] = await Promise.all([
    zt(t, Hp, "getBlockNumber")({}),
    e ? zt(t, uA, "getTransaction")({ hash: e }) : void 0
  ]), a = (n == null ? void 0 : n.blockNumber) || (i == null ? void 0 : i.blockNumber);
  return a ? r - a + 1n : 0n;
}
async function aw(t, { hash: e }) {
  var i, a, o;
  const n = await t.request({
    method: "eth_getTransactionReceipt",
    params: [e]
  }, { dedupe: !0 });
  if (!n)
    throw new wK({ hash: e });
  return (((o = (a = (i = t.chain) == null ? void 0 : i.formatters) == null ? void 0 : a.transactionReceipt) == null ? void 0 : o.format) || tbt)(n);
}
async function dbt(t, e) {
  var g;
  const { allowFailure: n = !0, batchSize: r, blockNumber: i, blockTag: a, multicallAddress: o, stateOverride: s } = e, l = e.contracts, c = r ?? (typeof ((g = t.batch) == null ? void 0 : g.multicall) == "object" && t.batch.multicall.batchSize || 1024);
  let u = o;
  if (!u) {
    if (!t.chain)
      throw new Error("client chain not configured. multicallAddress is required.");
    u = Fd({
      blockNumber: i,
      chain: t.chain,
      contract: "multicall3"
    });
  }
  const d = [[]];
  let f = 0, h = 0;
  for (let v = 0; v < l.length; v++) {
    const { abi: k, address: w, args: b, functionName: x } = l[v];
    try {
      const A = hs({ abi: k, args: b, functionName: x });
      h += (A.length - 2) / 2, // Check if batching is enabled.
      c > 0 && // Check if the current size of the batch exceeds the size limit.
      h > c && // Check if the current chunk is not already empty.
      d[f].length > 0 && (f++, h = (A.length - 2) / 2, d[f] = []), d[f] = [
        ...d[f],
        {
          allowFailure: !0,
          callData: A,
          target: w
        }
      ];
    } catch (A) {
      const L = X1(A, {
        abi: k,
        address: w,
        args: b,
        docsPath: "/docs/contract/multicall",
        functionName: x
      });
      if (!n)
        throw L;
      d[f] = [
        ...d[f],
        {
          allowFailure: !0,
          callData: "0x",
          target: w
        }
      ];
    }
  }
  const p = await Promise.allSettled(d.map((v) => zt(t, ml, "readContract")({
    abi: ew,
    address: u,
    args: [v],
    blockNumber: i,
    blockTag: a,
    functionName: "aggregate3",
    stateOverride: s
  }))), m = [];
  for (let v = 0; v < p.length; v++) {
    const k = p[v];
    if (k.status === "rejected") {
      if (!n)
        throw k.reason;
      for (let b = 0; b < d[v].length; b++)
        m.push({
          status: "failure",
          error: k.reason,
          result: void 0
        });
      continue;
    }
    const w = k.value;
    for (let b = 0; b < w.length; b++) {
      const { returnData: x, success: A } = w[b], { callData: L } = d[v][b], { abi: M, address: j, functionName: D, args: z } = l[m.length];
      try {
        if (L === "0x")
          throw new Dp();
        if (!A)
          throw new V6({ data: x });
        const H = L0({
          abi: M,
          args: z,
          data: x,
          functionName: D
        });
        m.push(n ? { result: H, status: "success" } : H);
      } catch (H) {
        const V = X1(H, {
          abi: M,
          address: j,
          args: z,
          docsPath: "/docs/contract/multicall",
          functionName: D
        });
        if (!n)
          throw V;
        m.push({ error: V, result: void 0, status: "failure" });
      }
    }
  }
  if (m.length !== l.length)
    throw new We("multicall results mismatch");
  return m;
}
const fbt = "0.1.1";
function hbt() {
  return fbt;
}
class jn extends Error {
  constructor(e, n = {}) {
    const r = (() => {
      var l;
      if (n.cause instanceof jn) {
        if (n.cause.details)
          return n.cause.details;
        if (n.cause.shortMessage)
          return n.cause.shortMessage;
      }
      return (l = n.cause) != null && l.message ? n.cause.message : n.details;
    })(), i = n.cause instanceof jn && n.cause.docsPath || n.docsPath, o = `https://oxlib.sh${i ?? ""}`, s = [
      e || "An error occurred.",
      ...n.metaMessages ? ["", ...n.metaMessages] : [],
      ...r || i ? [
        "",
        r ? `Details: ${r}` : void 0,
        i ? `See: ${o}` : void 0
      ] : []
    ].filter((l) => typeof l == "string").join(`
`);
    super(s, n.cause ? { cause: n.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: `ox@${hbt()}`
    }), this.cause = n.cause, this.details = r, this.docs = o, this.docsPath = i, this.shortMessage = e;
  }
  walk(e) {
    return s$(this, e);
  }
}
function s$(t, e) {
  return e != null && e(t) ? t : t && typeof t == "object" && "cause" in t && t.cause ? s$(t.cause, e) : e ? null : t;
}
const pbt = "#__bigint";
function mbt(t, e, n) {
  return JSON.stringify(t, (r, i) => typeof i == "bigint" ? i.toString() + pbt : i, n);
}
function ybt(t, e) {
  if (qD(t) > e)
    throw new Sbt({
      givenSize: qD(t),
      maxSize: e
    });
}
const Ss = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function VD(t) {
  if (t >= Ss.zero && t <= Ss.nine)
    return t - Ss.zero;
  if (t >= Ss.A && t <= Ss.F)
    return t - (Ss.A - 10);
  if (t >= Ss.a && t <= Ss.f)
    return t - (Ss.a - 10);
}
function gbt(t, e = {}) {
  const { dir: n, size: r = 32 } = e;
  if (r === 0)
    return t;
  if (t.length > r)
    throw new Lbt({
      size: t.length,
      targetSize: r,
      type: "Bytes"
    });
  const i = new Uint8Array(r);
  for (let a = 0; a < r; a++) {
    const o = n === "right";
    i[o ? a : r - a - 1] = t[o ? a : t.length - a - 1];
  }
  return i;
}
function dA(t, e) {
  if (Pa(t) > e)
    throw new Dbt({
      givenSize: Pa(t),
      maxSize: e
    });
}
function vbt(t, e) {
  if (typeof e == "number" && e > 0 && e > Pa(t) - 1)
    throw new f$({
      offset: e,
      position: "start",
      size: Pa(t)
    });
}
function bbt(t, e, n) {
  if (typeof e == "number" && typeof n == "number" && Pa(t) !== n - e)
    throw new f$({
      offset: n,
      position: "end",
      size: Pa(t)
    });
}
function l$(t, e = {}) {
  const { dir: n, size: r = 32 } = e;
  if (r === 0)
    return t;
  const i = t.replace("0x", "");
  if (i.length > r * 2)
    throw new Ibt({
      size: Math.ceil(i.length / 2),
      targetSize: r,
      type: "Hex"
    });
  return `0x${i[n === "right" ? "padEnd" : "padStart"](r * 2, "0")}`;
}
const wbt = /* @__PURE__ */ new TextEncoder();
function kbt(t) {
  return t instanceof Uint8Array ? t : typeof t == "string" ? Mbt(t) : xbt(t);
}
function xbt(t) {
  return t instanceof Uint8Array ? t : new Uint8Array(t);
}
function Mbt(t, e = {}) {
  const { size: n } = e;
  let r = t;
  n && (dA(t, n), r = c0(t, n));
  let i = r.slice(2);
  i.length % 2 && (i = `0${i}`);
  const a = i.length / 2, o = new Uint8Array(a);
  for (let s = 0, l = 0; s < a; s++) {
    const c = VD(i.charCodeAt(l++)), u = VD(i.charCodeAt(l++));
    if (c === void 0 || u === void 0)
      throw new jn(`Invalid byte sequence ("${i[l - 2]}${i[l - 1]}" in "${i}").`);
    o[s] = c * 16 + u;
  }
  return o;
}
function Cbt(t, e = {}) {
  const { size: n } = e, r = wbt.encode(t);
  return typeof n == "number" ? (ybt(r, n), Abt(r, n)) : r;
}
function Abt(t, e) {
  return gbt(t, { dir: "right", size: e });
}
function qD(t) {
  return t.length;
}
let Sbt = class extends jn {
  constructor({ givenSize: e, maxSize: n }) {
    super(`Size cannot exceed \`${n}\` bytes. Given size: \`${e}\` bytes.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Bytes.SizeOverflowError"
    });
  }
}, Lbt = class extends jn {
  constructor({ size: e, targetSize: n, type: r }) {
    super(`${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()} size (\`${e}\`) exceeds padding size (\`${n}\`).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Bytes.SizeExceedsPaddingSizeError"
    });
  }
};
const Tbt = /* @__PURE__ */ new TextEncoder(), Ebt = /* @__PURE__ */ Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function jbt(t, e = {}) {
  const { strict: n = !1 } = e;
  if (!t)
    throw new UD(t);
  if (typeof t != "string")
    throw new UD(t);
  if (n && !/^0x[0-9a-fA-F]*$/.test(t))
    throw new WD(t);
  if (!t.startsWith("0x"))
    throw new WD(t);
}
function ss(...t) {
  return `0x${t.reduce((e, n) => e + n.replace("0x", ""), "")}`;
}
function c$(t, e = {}) {
  const n = `0x${Number(t)}`;
  return typeof e.size == "number" ? (dA(n, e.size), l0(n, e.size)) : n;
}
function u$(t, e = {}) {
  let n = "";
  for (let i = 0; i < t.length; i++)
    n += Ebt[t[i]];
  const r = `0x${n}`;
  return typeof e.size == "number" ? (dA(r, e.size), c0(r, e.size)) : r;
}
function ai(t, e = {}) {
  const { signed: n, size: r } = e, i = BigInt(t);
  let a;
  r ? n ? a = (1n << BigInt(r) * 8n - 1n) - 1n : a = 2n ** (BigInt(r) * 8n) - 1n : typeof t == "number" && (a = BigInt(Number.MAX_SAFE_INTEGER));
  const o = typeof a == "bigint" && n ? -a - 1n : 0;
  if (a && i > a || i < o) {
    const c = typeof t == "bigint" ? "n" : "";
    throw new d$({
      max: a ? `${a}${c}` : void 0,
      min: `${o}${c}`,
      signed: n,
      size: r,
      value: `${t}${c}`
    });
  }
  const l = `0x${(n && i < 0 ? (1n << BigInt(r * 8)) + BigInt(i) : i).toString(16)}`;
  return r ? l0(l, r) : l;
}
function fA(t, e = {}) {
  return u$(Tbt.encode(t), e);
}
function l0(t, e) {
  return l$(t, { dir: "left", size: e });
}
function c0(t, e) {
  return l$(t, { dir: "right", size: e });
}
function hA(t, e, n, r = {}) {
  const { strict: i } = r;
  vbt(t, e);
  const a = `0x${t.replace("0x", "").slice((e ?? 0) * 2, (n ?? t.length) * 2)}`;
  return i && bbt(a, e, n), a;
}
function Pa(t) {
  return Math.ceil((t.length - 2) / 2);
}
function Nbt(t, e = {}) {
  const { strict: n = !1 } = e;
  try {
    return jbt(t, { strict: n }), !0;
  } catch {
    return !1;
  }
}
class d$ extends jn {
  constructor({ max: e, min: n, signed: r, size: i, value: a }) {
    super(`Number \`${a}\` is not in safe${i ? ` ${i * 8}-bit` : ""}${r ? " signed" : " unsigned"} integer range ${e ? `(\`${n}\` to \`${e}\`)` : `(above \`${n}\`)`}`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Hex.IntegerOutOfRangeError"
    });
  }
}
class UD extends jn {
  constructor(e) {
    super(`Value \`${typeof e == "object" ? mbt(e) : e}\` of type \`${typeof e}\` is an invalid hex type.`, {
      metaMessages: ['Hex types must be represented as `"0x${string}"`.']
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Hex.InvalidHexTypeError"
    });
  }
}
class WD extends jn {
  constructor(e) {
    super(`Value \`${e}\` is an invalid hex value.`, {
      metaMessages: [
        'Hex values must start with `"0x"` and contain only hexadecimal characters (0-9, a-f, A-F).'
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Hex.InvalidHexValueError"
    });
  }
}
class Dbt extends jn {
  constructor({ givenSize: e, maxSize: n }) {
    super(`Size cannot exceed \`${n}\` bytes. Given size: \`${e}\` bytes.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Hex.SizeOverflowError"
    });
  }
}
class f$ extends jn {
  constructor({ offset: e, position: n, size: r }) {
    super(`Slice ${n === "start" ? "starting" : "ending"} at offset \`${e}\` is out-of-bounds (size: \`${r}\`).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Hex.SliceOffsetOutOfBoundsError"
    });
  }
}
class Ibt extends jn {
  constructor({ size: e, targetSize: n, type: r }) {
    super(`${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()} size (\`${e}\`) exceeds padding size (\`${n}\`).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Hex.SizeExceedsPaddingSizeError"
    });
  }
}
function Pbt(t) {
  return {
    address: t.address,
    amount: ai(t.amount),
    index: ai(t.index),
    validatorIndex: ai(t.validatorIndex)
  };
}
function zbt(t) {
  return {
    ...typeof t.baseFeePerGas == "bigint" && {
      baseFeePerGas: ai(t.baseFeePerGas)
    },
    ...typeof t.blobBaseFee == "bigint" && {
      blobBaseFee: ai(t.blobBaseFee)
    },
    ...typeof t.feeRecipient == "string" && {
      feeRecipient: t.feeRecipient
    },
    ...typeof t.gasLimit == "bigint" && {
      gasLimit: ai(t.gasLimit)
    },
    ...typeof t.number == "bigint" && {
      number: ai(t.number)
    },
    ...typeof t.prevRandao == "bigint" && {
      prevRandao: ai(t.prevRandao)
    },
    ...typeof t.time == "bigint" && {
      time: ai(t.time)
    },
    ...t.withdrawals && {
      withdrawals: t.withdrawals.map(Pbt)
    }
  };
}
async function ow(t, e) {
  const { blockNumber: n, blockTag: r = "latest", blocks: i, returnFullTransactions: a, traceTransfers: o, validation: s } = e;
  try {
    const l = [];
    for (const f of i) {
      const h = f.blockOverrides ? zbt(f.blockOverrides) : void 0, p = f.calls.map((g) => {
        const v = g, k = v.account ? bo(v.account) : void 0, w = {
          ...v,
          data: v.abi ? hs(v) : v.data,
          from: v.from ?? (k == null ? void 0 : k.address)
        };
        return Op(w), U6(w);
      }), m = f.stateOverrides ? JC(f.stateOverrides) : void 0;
      l.push({
        blockOverrides: h,
        calls: p,
        stateOverrides: m
      });
    }
    const u = (n ? jt(n) : void 0) || r;
    return (await t.request({
      method: "eth_simulateV1",
      params: [
        { blockStateCalls: l, returnFullTransactions: a, traceTransfers: o, validation: s },
        u
      ]
    })).map((f, h) => ({
      ...TK(f),
      calls: f.calls.map((p, m) => {
        var D, z;
        const { abi: g, args: v, functionName: k, to: w } = i[h].calls[m], b = ((D = p.error) == null ? void 0 : D.data) ?? p.returnData, x = BigInt(p.gasUsed), A = (z = p.logs) == null ? void 0 : z.map((H) => pl(H)), L = p.status === "0x1" ? "success" : "failure", M = g && L === "success" && b !== "0x" ? L0({
          abi: g,
          data: b,
          functionName: k
        }) : null, j = (() => {
          var V;
          if (L === "success")
            return;
          let H;
          if (((V = p.error) == null ? void 0 : V.data) === "0x" ? H = new Dp() : p.error && (H = new V6(p.error)), !!H)
            return X1(H, {
              abi: g ?? [],
              address: w,
              args: v,
              functionName: k ?? "<unknown>"
            });
        })();
        return {
          data: b,
          gasUsed: x,
          logs: A,
          status: L,
          ...L === "success" ? {
            result: M
          } : {
            error: j
          }
        };
      })
    }));
  } catch (l) {
    const c = l, u = KC(c, {});
    throw u instanceof q6 ? c : u;
  }
}
function ZD(t) {
  if (!Number.isSafeInteger(t) || t < 0)
    throw new Error("positive integer expected, got " + t);
}
function Rbt(t) {
  return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function pA(t, ...e) {
  if (!Rbt(t))
    throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(t.length))
    throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function GD(t, e = !0) {
  if (t.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && t.finished)
    throw new Error("Hash#digest() has already been called");
}
function Obt(t, e) {
  pA(t);
  const n = e.outputLen;
  if (t.length < n)
    throw new Error("digestInto() expects output buffer of length at least " + n);
}
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function Bbt(t) {
  return new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4));
}
const YD = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
function Hbt(t) {
  return t << 24 & 4278190080 | t << 8 & 16711680 | t >>> 8 & 65280 | t >>> 24 & 255;
}
function KD(t) {
  for (let e = 0; e < t.length; e++)
    t[e] = Hbt(t[e]);
}
function Fbt(t) {
  if (typeof t != "string")
    throw new Error("utf8ToBytes expected string, got " + typeof t);
  return new Uint8Array(new TextEncoder().encode(t));
}
function h$(t) {
  return typeof t == "string" && (t = Fbt(t)), pA(t), t;
}
class _bt {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function Vbt(t) {
  const e = (r) => t().update(h$(r)).digest(), n = t();
  return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = () => t(), e;
}
const Wm = /* @__PURE__ */ BigInt(2 ** 32 - 1), $D = /* @__PURE__ */ BigInt(32);
function qbt(t, e = !1) {
  return e ? { h: Number(t & Wm), l: Number(t >> $D & Wm) } : { h: Number(t >> $D & Wm) | 0, l: Number(t & Wm) | 0 };
}
function Ubt(t, e = !1) {
  let n = new Uint32Array(t.length), r = new Uint32Array(t.length);
  for (let i = 0; i < t.length; i++) {
    const { h: a, l: o } = qbt(t[i], e);
    [n[i], r[i]] = [a, o];
  }
  return [n, r];
}
const Wbt = (t, e, n) => t << n | e >>> 32 - n, Zbt = (t, e, n) => e << n | t >>> 32 - n, Gbt = (t, e, n) => e << n - 32 | t >>> 64 - n, Ybt = (t, e, n) => t << n - 32 | e >>> 64 - n, p$ = [], m$ = [], y$ = [], Kbt = /* @__PURE__ */ BigInt(0), gf = /* @__PURE__ */ BigInt(1), $bt = /* @__PURE__ */ BigInt(2), Jbt = /* @__PURE__ */ BigInt(7), Qbt = /* @__PURE__ */ BigInt(256), Xbt = /* @__PURE__ */ BigInt(113);
for (let t = 0, e = gf, n = 1, r = 0; t < 24; t++) {
  [n, r] = [r, (2 * n + 3 * r) % 5], p$.push(2 * (5 * r + n)), m$.push((t + 1) * (t + 2) / 2 % 64);
  let i = Kbt;
  for (let a = 0; a < 7; a++)
    e = (e << gf ^ (e >> Jbt) * Xbt) % Qbt, e & $bt && (i ^= gf << (gf << /* @__PURE__ */ BigInt(a)) - gf);
  y$.push(i);
}
const [e7t, t7t] = /* @__PURE__ */ Ubt(y$, !0), JD = (t, e, n) => n > 32 ? Gbt(t, e, n) : Wbt(t, e, n), QD = (t, e, n) => n > 32 ? Ybt(t, e, n) : Zbt(t, e, n);
function n7t(t, e = 24) {
  const n = new Uint32Array(10);
  for (let r = 24 - e; r < 24; r++) {
    for (let o = 0; o < 10; o++)
      n[o] = t[o] ^ t[o + 10] ^ t[o + 20] ^ t[o + 30] ^ t[o + 40];
    for (let o = 0; o < 10; o += 2) {
      const s = (o + 8) % 10, l = (o + 2) % 10, c = n[l], u = n[l + 1], d = JD(c, u, 1) ^ n[s], f = QD(c, u, 1) ^ n[s + 1];
      for (let h = 0; h < 50; h += 10)
        t[o + h] ^= d, t[o + h + 1] ^= f;
    }
    let i = t[2], a = t[3];
    for (let o = 0; o < 24; o++) {
      const s = m$[o], l = JD(i, a, s), c = QD(i, a, s), u = p$[o];
      i = t[u], a = t[u + 1], t[u] = l, t[u + 1] = c;
    }
    for (let o = 0; o < 50; o += 10) {
      for (let s = 0; s < 10; s++)
        n[s] = t[o + s];
      for (let s = 0; s < 10; s++)
        t[o + s] ^= ~n[(s + 2) % 10] & n[(s + 4) % 10];
    }
    t[0] ^= e7t[r], t[1] ^= t7t[r];
  }
  n.fill(0);
}
class mA extends _bt {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, n, r, i = !1, a = 24) {
    if (super(), this.blockLen = e, this.suffix = n, this.outputLen = r, this.enableXOF = i, this.rounds = a, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, ZD(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = Bbt(this.state);
  }
  keccak() {
    YD || KD(this.state32), n7t(this.state32, this.rounds), YD || KD(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    GD(this);
    const { blockLen: n, state: r } = this;
    e = h$(e);
    const i = e.length;
    for (let a = 0; a < i; ) {
      const o = Math.min(n - this.pos, i - a);
      for (let s = 0; s < o; s++)
        r[this.pos++] ^= e[a++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: e, suffix: n, pos: r, blockLen: i } = this;
    e[r] ^= n, n & 128 && r === i - 1 && this.keccak(), e[i - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    GD(this, !1), pA(e), this.finish();
    const n = this.state, { blockLen: r } = this;
    for (let i = 0, a = e.length; i < a; ) {
      this.posOut >= r && this.keccak();
      const o = Math.min(r - this.posOut, a - i);
      e.set(n.subarray(this.posOut, this.posOut + o), i), this.posOut += o, i += o;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return ZD(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (Obt(e, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(e) {
    const { blockLen: n, suffix: r, outputLen: i, rounds: a, enableXOF: o } = this;
    return e || (e = new mA(n, r, i, o, a)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = a, e.suffix = r, e.outputLen = i, e.enableXOF = o, e.destroyed = this.destroyed, e;
  }
}
const r7t = (t, e, n) => Vbt(() => new mA(e, t, n)), i7t = /* @__PURE__ */ r7t(1, 136, 256 / 8);
function g$(t, e = {}) {
  const { as: n = typeof t == "string" ? "Hex" : "Bytes" } = e, r = i7t(kbt(t));
  return n === "Bytes" ? r : u$(r);
}
class a7t extends Map {
  constructor(e) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = e;
  }
  get(e) {
    const n = super.get(e);
    return super.has(e) && n !== void 0 && (this.delete(e), super.set(e, n)), n;
  }
  set(e, n) {
    if (super.set(e, n), this.maxSize && this.size > this.maxSize) {
      const r = this.keys().next().value;
      r && this.delete(r);
    }
    return this;
  }
}
const o7t = {
  checksum: /* @__PURE__ */ new a7t(8192)
}, lv = o7t.checksum, s7t = /^0x[a-fA-F0-9]{40}$/;
function K6(t, e = {}) {
  const { strict: n = !0 } = e;
  if (!s7t.test(t))
    throw new XD({
      address: t,
      cause: new c7t()
    });
  if (n) {
    if (t.toLowerCase() === t)
      return;
    if (l7t(t) !== t)
      throw new XD({
        address: t,
        cause: new u7t()
      });
  }
}
function l7t(t) {
  if (lv.has(t))
    return lv.get(t);
  K6(t, { strict: !1 });
  const e = t.substring(2).toLowerCase(), n = g$(Cbt(e), { as: "Bytes" }), r = e.split("");
  for (let a = 0; a < 40; a += 2)
    n[a >> 1] >> 4 >= 8 && r[a] && (r[a] = r[a].toUpperCase()), (n[a >> 1] & 15) >= 8 && r[a + 1] && (r[a + 1] = r[a + 1].toUpperCase());
  const i = `0x${r.join("")}`;
  return lv.set(t, i), i;
}
function sw(t, e = {}) {
  const { strict: n = !0 } = e ?? {};
  try {
    return K6(t, { strict: n }), !0;
  } catch {
    return !1;
  }
}
class XD extends jn {
  constructor({ address: e, cause: n }) {
    super(`Address "${e}" is invalid.`, {
      cause: n
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Address.InvalidAddressError"
    });
  }
}
class c7t extends jn {
  constructor() {
    super("Address is not a 20 byte (40 hexadecimal character) value."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Address.InvalidInputError"
    });
  }
}
class u7t extends jn {
  constructor() {
    super("Address does not match its checksum counterpart."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Address.InvalidChecksumError"
    });
  }
}
function lw(t) {
  let e = !0, n = "", r = 0, i = "", a = !1;
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    if (["(", ")", ","].includes(s) && (e = !0), s === "(" && r++, s === ")" && r--, !!e) {
      if (r === 0) {
        if (s === " " && ["event", "function", "error", ""].includes(i))
          i = "";
        else if (i += s, s === ")") {
          a = !0;
          break;
        }
        continue;
      }
      if (s === " ") {
        t[o - 1] !== "," && n !== "," && n !== ",(" && (n = "", e = !1);
        continue;
      }
      i += s, n += s;
    }
  }
  if (!a)
    throw new jn("Unable to normalize signature.");
  return i;
}
function cw(t, e) {
  const n = typeof t, r = e.type;
  switch (r) {
    case "address":
      return sw(t, { strict: !1 });
    case "bool":
      return n === "boolean";
    case "function":
      return n === "string";
    case "string":
      return n === "string";
    default:
      return r === "tuple" && "components" in e ? Object.values(e.components).every((i, a) => cw(Object.values(t)[a], i)) : /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(r) ? n === "number" || n === "bigint" : /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(r) ? n === "string" || t instanceof Uint8Array : /[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(r) ? Array.isArray(t) && t.every((i) => cw(i, {
        ...e,
        // Pop off `[]` or `[M]` from end of type
        type: r.replace(/(\[[0-9]{0,}\])$/, "")
      })) : !1;
  }
}
function v$(t, e, n) {
  for (const r in t) {
    const i = t[r], a = e[r];
    if (i.type === "tuple" && a.type === "tuple" && "components" in i && "components" in a)
      return v$(i.components, a.components, n[r]);
    const o = [i.type, a.type];
    if (o.includes("address") && o.includes("bytes20") ? !0 : o.includes("address") && o.includes("string") ? sw(n[r], {
      strict: !1
    }) : o.includes("address") && o.includes("bytes") ? sw(n[r], {
      strict: !1
    }) : !1)
      return o;
  }
}
function b$(t, e = {}) {
  const { prepare: n = !0 } = e, r = Array.isArray(t) || typeof t == "string" ? fD(t) : t;
  return {
    ...r,
    ...n ? { hash: s1(r) } : {}
  };
}
function d7t(t, e, n) {
  const { args: r = [], prepare: i = !0 } = n ?? {}, a = Nbt(e, { strict: !1 }), o = t.filter((c) => a ? c.type === "function" || c.type === "error" ? w$(c) === hA(e, 0, 4) : c.type === "event" ? s1(c) === e : !1 : "name" in c && c.name === e);
  if (o.length === 0)
    throw new uw({ name: e });
  if (o.length === 1)
    return {
      ...o[0],
      ...i ? { hash: s1(o[0]) } : {}
    };
  let s;
  for (const c of o) {
    if (!("inputs" in c))
      continue;
    if (!r || r.length === 0) {
      if (!c.inputs || c.inputs.length === 0)
        return {
          ...c,
          ...i ? { hash: s1(c) } : {}
        };
      continue;
    }
    if (!c.inputs || c.inputs.length === 0 || c.inputs.length !== r.length)
      continue;
    if (r.every((d, f) => {
      const h = "inputs" in c && c.inputs[f];
      return h ? cw(d, h) : !1;
    })) {
      if (s && "inputs" in s && s.inputs) {
        const d = v$(c.inputs, s.inputs, r);
        if (d)
          throw new h7t({
            abiItem: c,
            type: d[0]
          }, {
            abiItem: s,
            type: d[1]
          });
      }
      s = c;
    }
  }
  const l = (() => {
    if (s)
      return s;
    const [c, ...u] = o;
    return { ...c, overloads: u };
  })();
  if (!l)
    throw new uw({ name: e });
  return {
    ...l,
    ...i ? { hash: s1(l) } : {}
  };
}
function w$(t) {
  return hA(s1(t), 0, 4);
}
function f7t(t) {
  const e = typeof t == "string" ? t : $y(t);
  return lw(e);
}
function s1(t) {
  return typeof t != "string" && "hash" in t && t.hash ? t.hash : g$(fA(f7t(t)));
}
class h7t extends jn {
  constructor(e, n) {
    super("Found ambiguous types in overloaded ABI Items.", {
      metaMessages: [
        // TODO: abitype to add support for signature-formatted ABI items.
        `\`${e.type}\` in \`${lw($y(e.abiItem))}\`, and`,
        `\`${n.type}\` in \`${lw($y(n.abiItem))}\``,
        "",
        "These types encode differently and cannot be distinguished at runtime.",
        "Remove one of the ambiguous items in the ABI."
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiItem.AmbiguityError"
    });
  }
}
class uw extends jn {
  constructor({ name: e, data: n, type: r = "item" }) {
    const i = e ? ` with name "${e}"` : n ? ` with data "${n}"` : "";
    super(`ABI ${r}${i} not found.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiItem.NotFoundError"
    });
  }
}
const p7t = /^(.*)\[([0-9]*)\]$/, m7t = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/, k$ = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
function y7t({ checksumAddress: t, parameters: e, values: n }) {
  const r = [];
  for (let i = 0; i < e.length; i++)
    r.push(yA({
      checksumAddress: t,
      parameter: e[i],
      value: n[i]
    }));
  return r;
}
function yA({ checksumAddress: t = !1, parameter: e, value: n }) {
  const r = e, i = C7t(r.type);
  if (i) {
    const [a, o] = i;
    return v7t(n, {
      checksumAddress: t,
      length: a,
      parameter: {
        ...r,
        type: o
      }
    });
  }
  if (r.type === "tuple")
    return M7t(n, {
      checksumAddress: t,
      parameter: r
    });
  if (r.type === "address")
    return g7t(n, {
      checksum: t
    });
  if (r.type === "bool")
    return w7t(n);
  if (r.type.startsWith("uint") || r.type.startsWith("int")) {
    const a = r.type.startsWith("int"), [, , o = "256"] = k$.exec(r.type) ?? [];
    return k7t(n, {
      signed: a,
      size: Number(o)
    });
  }
  if (r.type.startsWith("bytes"))
    return b7t(n, { type: r.type });
  if (r.type === "string")
    return x7t(n);
  throw new A$(r.type);
}
function gA(t) {
  let e = 0;
  for (let a = 0; a < t.length; a++) {
    const { dynamic: o, encoded: s } = t[a];
    o ? e += 32 : e += Pa(s);
  }
  const n = [], r = [];
  let i = 0;
  for (let a = 0; a < t.length; a++) {
    const { dynamic: o, encoded: s } = t[a];
    o ? (n.push(ai(e + i, { size: 32 })), r.push(s), i += Pa(s)) : n.push(s);
  }
  return ss(...n, ...r);
}
function g7t(t, e) {
  const { checksum: n = !1 } = e;
  return K6(t, { strict: n }), {
    dynamic: !1,
    encoded: l0(t.toLowerCase())
  };
}
function v7t(t, e) {
  const { checksumAddress: n, length: r, parameter: i } = e, a = r === null;
  if (!Array.isArray(t))
    throw new S7t(t);
  if (!a && t.length !== r)
    throw new A7t({
      expectedLength: r,
      givenLength: t.length,
      type: `${i.type}[${r}]`
    });
  let o = !1;
  const s = [];
  for (let l = 0; l < t.length; l++) {
    const c = yA({
      checksumAddress: n,
      parameter: i,
      value: t[l]
    });
    c.dynamic && (o = !0), s.push(c);
  }
  if (a || o) {
    const l = gA(s);
    if (a) {
      const c = ai(s.length, { size: 32 });
      return {
        dynamic: !0,
        encoded: s.length > 0 ? ss(c, l) : c
      };
    }
    if (o)
      return { dynamic: !0, encoded: l };
  }
  return {
    dynamic: !1,
    encoded: ss(...s.map(({ encoded: l }) => l))
  };
}
function b7t(t, { type: e }) {
  const [, n] = e.split("bytes"), r = Pa(t);
  if (!n) {
    let i = t;
    return r % 32 !== 0 && (i = c0(i, Math.ceil((t.length - 2) / 2 / 32) * 32)), {
      dynamic: !0,
      encoded: ss(l0(ai(r, { size: 32 })), i)
    };
  }
  if (r !== Number.parseInt(n))
    throw new M$({
      expectedSize: Number.parseInt(n),
      value: t
    });
  return { dynamic: !1, encoded: c0(t) };
}
function w7t(t) {
  if (typeof t != "boolean")
    throw new jn(`Invalid boolean value: "${t}" (type: ${typeof t}). Expected: \`true\` or \`false\`.`);
  return { dynamic: !1, encoded: l0(c$(t)) };
}
function k7t(t, { signed: e, size: n }) {
  if (typeof n == "number") {
    const r = 2n ** (BigInt(n) - (e ? 1n : 0n)) - 1n, i = e ? -r - 1n : 0n;
    if (t > r || t < i)
      throw new d$({
        max: r.toString(),
        min: i.toString(),
        signed: e,
        size: n / 8,
        value: t.toString()
      });
  }
  return {
    dynamic: !1,
    encoded: ai(t, {
      size: 32,
      signed: e
    })
  };
}
function x7t(t) {
  const e = fA(t), n = Math.ceil(Pa(e) / 32), r = [];
  for (let i = 0; i < n; i++)
    r.push(c0(hA(e, i * 32, (i + 1) * 32)));
  return {
    dynamic: !0,
    encoded: ss(c0(ai(Pa(e), { size: 32 })), ...r)
  };
}
function M7t(t, e) {
  const { checksumAddress: n, parameter: r } = e;
  let i = !1;
  const a = [];
  for (let o = 0; o < r.components.length; o++) {
    const s = r.components[o], l = Array.isArray(t) ? o : s.name, c = yA({
      checksumAddress: n,
      parameter: s,
      value: t[l]
    });
    a.push(c), c.dynamic && (i = !0);
  }
  return {
    dynamic: i,
    encoded: i ? gA(a) : ss(...a.map(({ encoded: o }) => o))
  };
}
function C7t(t) {
  const e = t.match(/^(.*)\[(\d+)?\]$/);
  return e ? (
    // Return `null` if the array is dynamic.
    [e[2] ? Number(e[2]) : null, e[1]]
  ) : void 0;
}
function x$(t, e, n) {
  const { checksumAddress: r = !1 } = {};
  if (t.length !== e.length)
    throw new C$({
      expectedLength: t.length,
      givenLength: e.length
    });
  const i = y7t({
    checksumAddress: r,
    parameters: t,
    values: e
  }), a = gA(i);
  return a.length === 0 ? "0x" : a;
}
function dw(t, e) {
  if (t.length !== e.length)
    throw new C$({
      expectedLength: t.length,
      givenLength: e.length
    });
  const n = [];
  for (let r = 0; r < t.length; r++) {
    const i = t[r], a = e[r];
    n.push(dw.encode(i, a));
  }
  return ss(...n);
}
(function(t) {
  function e(n, r, i = !1) {
    if (n === "address") {
      const l = r;
      return K6(l), l0(l.toLowerCase(), i ? 32 : 0);
    }
    if (n === "string")
      return fA(r);
    if (n === "bytes")
      return r;
    if (n === "bool")
      return l0(c$(r), i ? 32 : 1);
    const a = n.match(k$);
    if (a) {
      const [l, c, u = "256"] = a, d = Number.parseInt(u) / 8;
      return ai(r, {
        size: i ? 32 : d,
        signed: c === "int"
      });
    }
    const o = n.match(m7t);
    if (o) {
      const [l, c] = o;
      if (Number.parseInt(c) !== (r.length - 2) / 2)
        throw new M$({
          expectedSize: Number.parseInt(c),
          value: r
        });
      return c0(r, i ? 32 : 0);
    }
    const s = n.match(p7t);
    if (s && Array.isArray(r)) {
      const [l, c] = s, u = [];
      for (let d = 0; d < r.length; d++)
        u.push(e(c, r[d], !0));
      return u.length === 0 ? "0x" : ss(...u);
    }
    throw new A$(n);
  }
  t.encode = e;
})(dw || (dw = {}));
class A7t extends jn {
  constructor({ expectedLength: e, givenLength: n, type: r }) {
    super(`Array length mismatch for type \`${r}\`. Expected: \`${e}\`. Given: \`${n}\`.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiParameters.ArrayLengthMismatchError"
    });
  }
}
class M$ extends jn {
  constructor({ expectedSize: e, value: n }) {
    super(`Size of bytes "${n}" (bytes${Pa(n)}) does not match expected size (bytes${e}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiParameters.BytesSizeMismatchError"
    });
  }
}
class C$ extends jn {
  constructor({ expectedLength: e, givenLength: n }) {
    super([
      "ABI encoding parameters/values length mismatch.",
      `Expected length (parameters): ${e}`,
      `Given length (values): ${n}`
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiParameters.LengthMismatchError"
    });
  }
}
class S7t extends jn {
  constructor(e) {
    super(`Value \`${e}\` is not a valid array.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiParameters.InvalidArrayError"
    });
  }
}
class A$ extends jn {
  constructor(e) {
    super(`Type \`${e}\` is not a valid ABI Type.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiParameters.InvalidTypeError"
    });
  }
}
function L7t(t, e) {
  var i;
  const { bytecode: n, args: r } = e;
  return ss(n, (i = t.inputs) != null && i.length && (r != null && r.length) ? x$(t.inputs, r) : "0x");
}
function T7t(t) {
  return b$(t);
}
function E7t(t, ...e) {
  const { overloads: n } = t, r = n ? j7t([t, ...n], t.name, {
    args: e[0]
  }) : t, i = N7t(r), a = e.length > 0 ? x$(r.inputs, e[0]) : void 0;
  return a ? ss(i, a) : i;
}
function q0(t, e = {}) {
  return b$(t, e);
}
function j7t(t, e, n) {
  const r = d7t(t, e, n);
  if (r.type !== "function")
    throw new uw({ name: e, type: "function" });
  return r;
}
function N7t(t) {
  return w$(t);
}
const D7t = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", So = "0x0000000000000000000000000000000000000000", I7t = "0x6080604052348015600e575f80fd5b5061016d8061001c5f395ff3fe608060405234801561000f575f80fd5b5060043610610029575f3560e01c8063f8b2cb4f1461002d575b5f80fd5b610047600480360381019061004291906100db565b61005d565b604051610054919061011e565b60405180910390f35b5f8173ffffffffffffffffffffffffffffffffffffffff16319050919050565b5f80fd5b5f73ffffffffffffffffffffffffffffffffffffffff82169050919050565b5f6100aa82610081565b9050919050565b6100ba816100a0565b81146100c4575f80fd5b50565b5f813590506100d5816100b1565b92915050565b5f602082840312156100f0576100ef61007d565b5b5f6100fd848285016100c7565b91505092915050565b5f819050919050565b61011881610106565b82525050565b5f6020820190506101315f83018461010f565b9291505056fea26469706673582212203b9fe929fe995c7cf9887f0bdba8a36dd78e8b73f149b17d2d9ad7cd09d2dc6264736f6c634300081a0033";
async function P7t(t, e) {
  const { blockNumber: n, blockTag: r, calls: i, stateOverrides: a, traceAssetChanges: o, traceTransfers: s, validation: l } = e, c = e.account ? bo(e.account) : void 0;
  if (o && !c)
    throw new We("`account` is required when `traceAssetChanges` is true");
  const u = c ? L7t(T7t("constructor(bytes, bytes)"), {
    bytecode: VK,
    args: [
      I7t,
      E7t(q0("function getBalance(address)"), [c.address])
    ]
  }) : void 0, d = o ? await Promise.all(e.calls.map(async (Z) => {
    if (!Z.data && !Z.abi)
      return;
    const { accessList: oe } = await QK(t, {
      account: c.address,
      ...Z,
      data: Z.abi ? hs(Z) : Z.data
    });
    return oe.map(({ address: ee, storageKeys: ae }) => ae.length > 0 ? ee : null);
  })).then((Z) => Z.flat().filter(Boolean)) : [], f = a == null ? void 0 : a.map((Z) => Z.address === (c == null ? void 0 : c.address) ? {
    ...Z,
    nonce: 0
  } : Z), h = await ow(t, {
    blockNumber: n,
    blockTag: r,
    blocks: [
      ...o ? [
        // ETH pre balances
        {
          calls: [{ data: u }],
          stateOverrides: a
        },
        // Asset pre balances
        {
          calls: d.map((Z, oe) => ({
            abi: [
              q0("function balanceOf(address) returns (uint256)")
            ],
            functionName: "balanceOf",
            args: [c.address],
            to: Z,
            from: So,
            nonce: oe
          })),
          stateOverrides: [
            {
              address: So,
              nonce: 0
            }
          ]
        }
      ] : [],
      {
        calls: [...i, {}].map((Z, oe) => ({
          ...Z,
          from: c == null ? void 0 : c.address,
          nonce: oe
        })),
        stateOverrides: f
      },
      ...o ? [
        // ETH post balances
        {
          calls: [{ data: u }]
        },
        // Asset post balances
        {
          calls: d.map((Z, oe) => ({
            abi: [
              q0("function balanceOf(address) returns (uint256)")
            ],
            functionName: "balanceOf",
            args: [c.address],
            to: Z,
            from: So,
            nonce: oe
          })),
          stateOverrides: [
            {
              address: So,
              nonce: 0
            }
          ]
        },
        // Decimals
        {
          calls: d.map((Z, oe) => ({
            to: Z,
            abi: [
              q0("function decimals() returns (uint256)")
            ],
            functionName: "decimals",
            from: So,
            nonce: oe
          })),
          stateOverrides: [
            {
              address: So,
              nonce: 0
            }
          ]
        },
        // Token URI
        {
          calls: d.map((Z, oe) => ({
            to: Z,
            abi: [
              q0("function tokenURI(uint256) returns (string)")
            ],
            functionName: "tokenURI",
            args: [0n],
            from: So,
            nonce: oe
          })),
          stateOverrides: [
            {
              address: So,
              nonce: 0
            }
          ]
        },
        // Symbols
        {
          calls: d.map((Z, oe) => ({
            to: Z,
            abi: [q0("function symbol() returns (string)")],
            functionName: "symbol",
            from: So,
            nonce: oe
          })),
          stateOverrides: [
            {
              address: So,
              nonce: 0
            }
          ]
        }
      ] : []
    ],
    traceTransfers: s,
    validation: l
  }), p = o ? h[2] : h[0], [m, g, , v, k, w, b, x] = o ? h : [], { calls: A, ...L } = p, M = A.slice(0, -1) ?? [], j = (m == null ? void 0 : m.calls) ?? [], D = (g == null ? void 0 : g.calls) ?? [], z = [...j, ...D].map((Z) => Z.status === "success" ? as(Z.data) : null), H = (v == null ? void 0 : v.calls) ?? [], V = (k == null ? void 0 : k.calls) ?? [], F = [...H, ...V].map((Z) => Z.status === "success" ? as(Z.data) : null), _ = ((w == null ? void 0 : w.calls) ?? []).map((Z) => Z.status === "success" ? Z.result : null), W = ((x == null ? void 0 : x.calls) ?? []).map((Z) => Z.status === "success" ? Z.result : null), G = ((b == null ? void 0 : b.calls) ?? []).map((Z) => Z.status === "success" ? Z.result : null), Y = [];
  for (const [Z, oe] of F.entries()) {
    const ee = z[Z];
    if (typeof oe != "bigint" || typeof ee != "bigint")
      continue;
    const ae = _[Z - 1], fe = W[Z - 1], me = G[Z - 1], ge = Z === 0 ? {
      address: D7t,
      decimals: 18,
      symbol: "ETH"
    } : {
      address: d[Z - 1],
      decimals: me || ae ? Number(ae ?? 1) : void 0,
      symbol: fe ?? void 0
    };
    Y.some(($) => $.token.address === ge.address) || Y.push({
      token: ge,
      value: {
        pre: ee,
        post: oe,
        diff: oe - ee
      }
    });
  }
  return {
    assetChanges: Y,
    block: L,
    results: M
  };
}
class S$ extends FC {
  constructor(e, n) {
    super(), this.finished = !1, this.destroyed = !1, U6t(e);
    const r = R6(n);
    if (this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const i = this.blockLen, a = new Uint8Array(i);
    a.set(r.length > i ? e.create().update(r).digest() : r);
    for (let o = 0; o < a.length; o++)
      a[o] ^= 54;
    this.iHash.update(a), this.oHash = e.create();
    for (let o = 0; o < a.length; o++)
      a[o] ^= 106;
    this.oHash.update(a), a.fill(0);
  }
  update(e) {
    return J1(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    J1(this), Ip(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: n, iHash: r, finished: i, destroyed: a, blockLen: o, outputLen: s } = this;
    return e = e, e.finished = i, e.destroyed = a, e.blockLen = o, e.outputLen = s, e.oHash = n._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const L$ = (t, e, n) => new S$(t, e).update(n).digest();
L$.create = (t, e) => new S$(t, e);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const $6 = /* @__PURE__ */ BigInt(0), J6 = /* @__PURE__ */ BigInt(1), z7t = /* @__PURE__ */ BigInt(2);
function u0(t) {
  return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function Fp(t) {
  if (!u0(t))
    throw new Error("Uint8Array expected");
}
function ed(t, e) {
  if (typeof e != "boolean")
    throw new Error(t + " boolean expected, got " + e);
}
const R7t = /* @__PURE__ */ Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function td(t) {
  Fp(t);
  let e = "";
  for (let n = 0; n < t.length; n++)
    e += R7t[t[n]];
  return e;
}
function l1(t) {
  const e = t.toString(16);
  return e.length & 1 ? "0" + e : e;
}
function vA(t) {
  if (typeof t != "string")
    throw new Error("hex string expected, got " + typeof t);
  return t === "" ? $6 : BigInt("0x" + t);
}
const Ls = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function eI(t) {
  if (t >= Ls._0 && t <= Ls._9)
    return t - Ls._0;
  if (t >= Ls.A && t <= Ls.F)
    return t - (Ls.A - 10);
  if (t >= Ls.a && t <= Ls.f)
    return t - (Ls.a - 10);
}
function nd(t) {
  if (typeof t != "string")
    throw new Error("hex string expected, got " + typeof t);
  const e = t.length, n = e / 2;
  if (e % 2)
    throw new Error("hex string expected, got unpadded hex of length " + e);
  const r = new Uint8Array(n);
  for (let i = 0, a = 0; i < n; i++, a += 2) {
    const o = eI(t.charCodeAt(a)), s = eI(t.charCodeAt(a + 1));
    if (o === void 0 || s === void 0) {
      const l = t[a] + t[a + 1];
      throw new Error('hex string expected, got non-hex character "' + l + '" at index ' + a);
    }
    r[i] = o * 16 + s;
  }
  return r;
}
function Hu(t) {
  return vA(td(t));
}
function bA(t) {
  return Fp(t), vA(td(Uint8Array.from(t).reverse()));
}
function rd(t, e) {
  return nd(t.toString(16).padStart(e * 2, "0"));
}
function wA(t, e) {
  return rd(t, e).reverse();
}
function O7t(t) {
  return nd(l1(t));
}
function Wa(t, e, n) {
  let r;
  if (typeof e == "string")
    try {
      r = nd(e);
    } catch (a) {
      throw new Error(t + " must be hex string or Uint8Array, cause: " + a);
    }
  else if (u0(e))
    r = Uint8Array.from(e);
  else
    throw new Error(t + " must be hex string or Uint8Array");
  const i = r.length;
  if (typeof n == "number" && i !== n)
    throw new Error(t + " of length " + n + " expected, got " + i);
  return r;
}
function k2(...t) {
  let e = 0;
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    Fp(i), e += i.length;
  }
  const n = new Uint8Array(e);
  for (let r = 0, i = 0; r < t.length; r++) {
    const a = t[r];
    n.set(a, i), i += a.length;
  }
  return n;
}
function B7t(t, e) {
  if (t.length !== e.length)
    return !1;
  let n = 0;
  for (let r = 0; r < t.length; r++)
    n |= t[r] ^ e[r];
  return n === 0;
}
function H7t(t) {
  if (typeof t != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(t));
}
const cv = (t) => typeof t == "bigint" && $6 <= t;
function Q6(t, e, n) {
  return cv(t) && cv(e) && cv(n) && e <= t && t < n;
}
function Fu(t, e, n, r) {
  if (!Q6(e, n, r))
    throw new Error("expected valid " + t + ": " + n + " <= n < " + r + ", got " + e);
}
function T$(t) {
  let e;
  for (e = 0; t > $6; t >>= J6, e += 1)
    ;
  return e;
}
function F7t(t, e) {
  return t >> BigInt(e) & J6;
}
function _7t(t, e, n) {
  return t | (n ? J6 : $6) << BigInt(e);
}
const kA = (t) => (z7t << BigInt(t - 1)) - J6, uv = (t) => new Uint8Array(t), tI = (t) => Uint8Array.from(t);
function E$(t, e, n) {
  if (typeof t != "number" || t < 2)
    throw new Error("hashLen must be a number");
  if (typeof e != "number" || e < 2)
    throw new Error("qByteLen must be a number");
  if (typeof n != "function")
    throw new Error("hmacFn must be a function");
  let r = uv(t), i = uv(t), a = 0;
  const o = () => {
    r.fill(1), i.fill(0), a = 0;
  }, s = (...d) => n(i, r, ...d), l = (d = uv()) => {
    i = s(tI([0]), d), r = s(), d.length !== 0 && (i = s(tI([1]), d), r = s());
  }, c = () => {
    if (a++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let d = 0;
    const f = [];
    for (; d < e; ) {
      r = s();
      const h = r.slice();
      f.push(h), d += r.length;
    }
    return k2(...f);
  };
  return (d, f) => {
    o(), l(d);
    let h;
    for (; !(h = f(c())); )
      l();
    return o(), h;
  };
}
const V7t = {
  bigint: (t) => typeof t == "bigint",
  function: (t) => typeof t == "function",
  boolean: (t) => typeof t == "boolean",
  string: (t) => typeof t == "string",
  stringOrUint8Array: (t) => typeof t == "string" || u0(t),
  isSafeInteger: (t) => Number.isSafeInteger(t),
  array: (t) => Array.isArray(t),
  field: (t, e) => e.Fp.isValid(t),
  hash: (t) => typeof t == "function" && Number.isSafeInteger(t.outputLen)
};
function _p(t, e, n = {}) {
  const r = (i, a, o) => {
    const s = V7t[a];
    if (typeof s != "function")
      throw new Error("invalid validator function");
    const l = t[i];
    if (!(o && l === void 0) && !s(l, t))
      throw new Error("param " + String(i) + " is invalid. Expected " + a + ", got " + l);
  };
  for (const [i, a] of Object.entries(e))
    r(i, a, !1);
  for (const [i, a] of Object.entries(n))
    r(i, a, !0);
  return t;
}
const q7t = () => {
  throw new Error("not implemented");
};
function fw(t) {
  const e = /* @__PURE__ */ new WeakMap();
  return (n, ...r) => {
    const i = e.get(n);
    if (i !== void 0)
      return i;
    const a = t(n, ...r);
    return e.set(n, a), a;
  };
}
const U7t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  aInRange: Fu,
  abool: ed,
  abytes: Fp,
  bitGet: F7t,
  bitLen: T$,
  bitMask: kA,
  bitSet: _7t,
  bytesToHex: td,
  bytesToNumberBE: Hu,
  bytesToNumberLE: bA,
  concatBytes: k2,
  createHmacDrbg: E$,
  ensureBytes: Wa,
  equalBytes: B7t,
  hexToBytes: nd,
  hexToNumber: vA,
  inRange: Q6,
  isBytes: u0,
  memoized: fw,
  notImplemented: q7t,
  numberToBytesBE: rd,
  numberToBytesLE: wA,
  numberToHexUnpadded: l1,
  numberToVarBytesBE: O7t,
  utf8ToBytes: H7t,
  validateObject: _p
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Cr = BigInt(0), er = BigInt(1), vu = /* @__PURE__ */ BigInt(2), W7t = /* @__PURE__ */ BigInt(3), hw = /* @__PURE__ */ BigInt(4), nI = /* @__PURE__ */ BigInt(5), rI = /* @__PURE__ */ BigInt(8);
function xi(t, e) {
  const n = t % e;
  return n >= Cr ? n : e + n;
}
function Z7t(t, e, n) {
  if (e < Cr)
    throw new Error("invalid exponent, negatives unsupported");
  if (n <= Cr)
    throw new Error("invalid modulus");
  if (n === er)
    return Cr;
  let r = er;
  for (; e > Cr; )
    e & er && (r = r * t % n), t = t * t % n, e >>= er;
  return r;
}
function ha(t, e, n) {
  let r = t;
  for (; e-- > Cr; )
    r *= r, r %= n;
  return r;
}
function pw(t, e) {
  if (t === Cr)
    throw new Error("invert: expected non-zero number");
  if (e <= Cr)
    throw new Error("invert: expected positive modulus, got " + e);
  let n = xi(t, e), r = e, i = Cr, a = er;
  for (; n !== Cr; ) {
    const s = r / n, l = r % n, c = i - a * s;
    r = n, n = l, i = a, a = c;
  }
  if (r !== er)
    throw new Error("invert: does not exist");
  return xi(i, e);
}
function G7t(t) {
  const e = (t - er) / vu;
  let n, r, i;
  for (n = t - er, r = 0; n % vu === Cr; n /= vu, r++)
    ;
  for (i = vu; i < t && Z7t(i, e, t) !== t - er; i++)
    if (i > 1e3)
      throw new Error("Cannot find square root: likely non-prime P");
  if (r === 1) {
    const o = (t + er) / hw;
    return function(l, c) {
      const u = l.pow(c, o);
      if (!l.eql(l.sqr(u), c))
        throw new Error("Cannot find square root");
      return u;
    };
  }
  const a = (n + er) / vu;
  return function(s, l) {
    if (s.pow(l, e) === s.neg(s.ONE))
      throw new Error("Cannot find square root");
    let c = r, u = s.pow(s.mul(s.ONE, i), n), d = s.pow(l, a), f = s.pow(l, n);
    for (; !s.eql(f, s.ONE); ) {
      if (s.eql(f, s.ZERO))
        return s.ZERO;
      let h = 1;
      for (let m = s.sqr(f); h < c && !s.eql(m, s.ONE); h++)
        m = s.sqr(m);
      const p = s.pow(u, er << BigInt(c - h - 1));
      u = s.sqr(p), d = s.mul(d, p), f = s.mul(f, u), c = h;
    }
    return d;
  };
}
function Y7t(t) {
  if (t % hw === W7t) {
    const e = (t + er) / hw;
    return function(r, i) {
      const a = r.pow(i, e);
      if (!r.eql(r.sqr(a), i))
        throw new Error("Cannot find square root");
      return a;
    };
  }
  if (t % rI === nI) {
    const e = (t - nI) / rI;
    return function(r, i) {
      const a = r.mul(i, vu), o = r.pow(a, e), s = r.mul(i, o), l = r.mul(r.mul(s, vu), o), c = r.mul(s, r.sub(l, r.ONE));
      if (!r.eql(r.sqr(c), i))
        throw new Error("Cannot find square root");
      return c;
    };
  }
  return G7t(t);
}
const K7t = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function $7t(t) {
  const e = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, n = K7t.reduce((r, i) => (r[i] = "function", r), e);
  return _p(t, n);
}
function J7t(t, e, n) {
  if (n < Cr)
    throw new Error("invalid exponent, negatives unsupported");
  if (n === Cr)
    return t.ONE;
  if (n === er)
    return e;
  let r = t.ONE, i = e;
  for (; n > Cr; )
    n & er && (r = t.mul(r, i)), i = t.sqr(i), n >>= er;
  return r;
}
function Q7t(t, e) {
  const n = new Array(e.length), r = e.reduce((a, o, s) => t.is0(o) ? a : (n[s] = a, t.mul(a, o)), t.ONE), i = t.inv(r);
  return e.reduceRight((a, o, s) => t.is0(o) ? a : (n[s] = t.mul(a, n[s]), t.mul(a, o)), i), n;
}
function j$(t, e) {
  const n = e !== void 0 ? e : t.toString(2).length, r = Math.ceil(n / 8);
  return { nBitLength: n, nByteLength: r };
}
function N$(t, e, n = !1, r = {}) {
  if (t <= Cr)
    throw new Error("invalid field: expected ORDER > 0, got " + t);
  const { nBitLength: i, nByteLength: a } = j$(t, e);
  if (a > 2048)
    throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let o;
  const s = Object.freeze({
    ORDER: t,
    isLE: n,
    BITS: i,
    BYTES: a,
    MASK: kA(i),
    ZERO: Cr,
    ONE: er,
    create: (l) => xi(l, t),
    isValid: (l) => {
      if (typeof l != "bigint")
        throw new Error("invalid field element: expected bigint, got " + typeof l);
      return Cr <= l && l < t;
    },
    is0: (l) => l === Cr,
    isOdd: (l) => (l & er) === er,
    neg: (l) => xi(-l, t),
    eql: (l, c) => l === c,
    sqr: (l) => xi(l * l, t),
    add: (l, c) => xi(l + c, t),
    sub: (l, c) => xi(l - c, t),
    mul: (l, c) => xi(l * c, t),
    pow: (l, c) => J7t(s, l, c),
    div: (l, c) => xi(l * pw(c, t), t),
    // Same as above, but doesn't normalize
    sqrN: (l) => l * l,
    addN: (l, c) => l + c,
    subN: (l, c) => l - c,
    mulN: (l, c) => l * c,
    inv: (l) => pw(l, t),
    sqrt: r.sqrt || ((l) => (o || (o = Y7t(t)), o(s, l))),
    invertBatch: (l) => Q7t(s, l),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (l, c, u) => u ? c : l,
    toBytes: (l) => n ? wA(l, a) : rd(l, a),
    fromBytes: (l) => {
      if (l.length !== a)
        throw new Error("Field.fromBytes: expected " + a + " bytes, got " + l.length);
      return n ? bA(l) : Hu(l);
    }
  });
  return Object.freeze(s);
}
function D$(t) {
  if (typeof t != "bigint")
    throw new Error("field order must be bigint");
  const e = t.toString(2).length;
  return Math.ceil(e / 8);
}
function I$(t) {
  const e = D$(t);
  return e + Math.ceil(e / 2);
}
function X7t(t, e, n = !1) {
  const r = t.length, i = D$(e), a = I$(e);
  if (r < 16 || r < a || r > 1024)
    throw new Error("expected " + a + "-1024 bytes of input, got " + r);
  const o = n ? bA(t) : Hu(t), s = xi(o, e - er) + er;
  return n ? wA(s, i) : rd(s, i);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const iI = BigInt(0), Zm = BigInt(1);
function dv(t, e) {
  const n = e.negate();
  return t ? n : e;
}
function P$(t, e) {
  if (!Number.isSafeInteger(t) || t <= 0 || t > e)
    throw new Error("invalid window size, expected [1.." + e + "], got W=" + t);
}
function fv(t, e) {
  P$(t, e);
  const n = Math.ceil(e / t) + 1, r = 2 ** (t - 1);
  return { windows: n, windowSize: r };
}
function e9t(t, e) {
  if (!Array.isArray(t))
    throw new Error("array expected");
  t.forEach((n, r) => {
    if (!(n instanceof e))
      throw new Error("invalid point at index " + r);
  });
}
function t9t(t, e) {
  if (!Array.isArray(t))
    throw new Error("array of scalars expected");
  t.forEach((n, r) => {
    if (!e.isValid(n))
      throw new Error("invalid scalar at index " + r);
  });
}
const hv = /* @__PURE__ */ new WeakMap(), z$ = /* @__PURE__ */ new WeakMap();
function pv(t) {
  return z$.get(t) || 1;
}
function n9t(t, e) {
  return {
    constTimeNegate: dv,
    hasPrecomputes(n) {
      return pv(n) !== 1;
    },
    // non-const time multiplication ladder
    unsafeLadder(n, r, i = t.ZERO) {
      let a = n;
      for (; r > iI; )
        r & Zm && (i = i.add(a)), a = a.double(), r >>= Zm;
      return i;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param elm Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(n, r) {
      const { windows: i, windowSize: a } = fv(r, e), o = [];
      let s = n, l = s;
      for (let c = 0; c < i; c++) {
        l = s, o.push(l);
        for (let u = 1; u < a; u++)
          l = l.add(s), o.push(l);
        s = l.double();
      }
      return o;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(n, r, i) {
      const { windows: a, windowSize: o } = fv(n, e);
      let s = t.ZERO, l = t.BASE;
      const c = BigInt(2 ** n - 1), u = 2 ** n, d = BigInt(n);
      for (let f = 0; f < a; f++) {
        const h = f * o;
        let p = Number(i & c);
        i >>= d, p > o && (p -= u, i += Zm);
        const m = h, g = h + Math.abs(p) - 1, v = f % 2 !== 0, k = p < 0;
        p === 0 ? l = l.add(dv(v, r[m])) : s = s.add(dv(k, r[g]));
      }
      return { p: s, f: l };
    },
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(n, r, i, a = t.ZERO) {
      const { windows: o, windowSize: s } = fv(n, e), l = BigInt(2 ** n - 1), c = 2 ** n, u = BigInt(n);
      for (let d = 0; d < o; d++) {
        const f = d * s;
        if (i === iI)
          break;
        let h = Number(i & l);
        if (i >>= u, h > s && (h -= c, i += Zm), h === 0)
          continue;
        let p = r[f + Math.abs(h) - 1];
        h < 0 && (p = p.negate()), a = a.add(p);
      }
      return a;
    },
    getPrecomputes(n, r, i) {
      let a = hv.get(r);
      return a || (a = this.precomputeWindow(r, n), n !== 1 && hv.set(r, i(a))), a;
    },
    wNAFCached(n, r, i) {
      const a = pv(n);
      return this.wNAF(a, this.getPrecomputes(a, n, i), r);
    },
    wNAFCachedUnsafe(n, r, i, a) {
      const o = pv(n);
      return o === 1 ? this.unsafeLadder(n, r, a) : this.wNAFUnsafe(o, this.getPrecomputes(o, n, i), r, a);
    },
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    setWindowSize(n, r) {
      P$(r, e), z$.set(n, r), hv.delete(n);
    }
  };
}
function r9t(t, e, n, r) {
  if (e9t(n, t), t9t(r, e), n.length !== r.length)
    throw new Error("arrays of points and scalars must have equal length");
  const i = t.ZERO, a = T$(BigInt(n.length)), o = a > 12 ? a - 3 : a > 4 ? a - 2 : a ? 2 : 1, s = (1 << o) - 1, l = new Array(s + 1).fill(i), c = Math.floor((e.BITS - 1) / o) * o;
  let u = i;
  for (let d = c; d >= 0; d -= o) {
    l.fill(i);
    for (let h = 0; h < r.length; h++) {
      const p = r[h], m = Number(p >> BigInt(d) & BigInt(s));
      l[m] = l[m].add(n[h]);
    }
    let f = i;
    for (let h = l.length - 1, p = i; h > 0; h--)
      p = p.add(l[h]), f = f.add(p);
    if (u = u.add(f), d !== 0)
      for (let h = 0; h < o; h++)
        u = u.double();
  }
  return u;
}
function R$(t) {
  return $7t(t.Fp), _p(t, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...j$(t.n, t.nBitLength),
    ...t,
    p: t.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function aI(t) {
  t.lowS !== void 0 && ed("lowS", t.lowS), t.prehash !== void 0 && ed("prehash", t.prehash);
}
function i9t(t) {
  const e = R$(t);
  _p(e, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: n, Fp: r, a: i } = e;
  if (n) {
    if (!r.eql(i, r.ZERO))
      throw new Error("invalid endomorphism, can only be defined for Koblitz curves that have a=0");
    if (typeof n != "object" || typeof n.beta != "bigint" || typeof n.splitScalar != "function")
      throw new Error("invalid endomorphism, expected beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...e });
}
const { bytesToNumberBE: a9t, hexToBytes: o9t } = U7t;
class s9t extends Error {
  constructor(e = "") {
    super(e);
  }
}
const Rs = {
  // asn.1 DER encoding utils
  Err: s9t,
  // Basic building block is TLV (Tag-Length-Value)
  _tlv: {
    encode: (t, e) => {
      const { Err: n } = Rs;
      if (t < 0 || t > 256)
        throw new n("tlv.encode: wrong tag");
      if (e.length & 1)
        throw new n("tlv.encode: unpadded data");
      const r = e.length / 2, i = l1(r);
      if (i.length / 2 & 128)
        throw new n("tlv.encode: long form length too big");
      const a = r > 127 ? l1(i.length / 2 | 128) : "";
      return l1(t) + a + i + e;
    },
    // v - value, l - left bytes (unparsed)
    decode(t, e) {
      const { Err: n } = Rs;
      let r = 0;
      if (t < 0 || t > 256)
        throw new n("tlv.encode: wrong tag");
      if (e.length < 2 || e[r++] !== t)
        throw new n("tlv.decode: wrong tlv");
      const i = e[r++], a = !!(i & 128);
      let o = 0;
      if (!a)
        o = i;
      else {
        const l = i & 127;
        if (!l)
          throw new n("tlv.decode(long): indefinite length not supported");
        if (l > 4)
          throw new n("tlv.decode(long): byte length is too big");
        const c = e.subarray(r, r + l);
        if (c.length !== l)
          throw new n("tlv.decode: length bytes not complete");
        if (c[0] === 0)
          throw new n("tlv.decode(long): zero leftmost byte");
        for (const u of c)
          o = o << 8 | u;
        if (r += l, o < 128)
          throw new n("tlv.decode(long): not minimal encoding");
      }
      const s = e.subarray(r, r + o);
      if (s.length !== o)
        throw new n("tlv.decode: wrong value length");
      return { v: s, l: e.subarray(r + o) };
    }
  },
  // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
  // since we always use positive integers here. It must always be empty:
  // - add zero byte if exists
  // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
  _int: {
    encode(t) {
      const { Err: e } = Rs;
      if (t < Bs)
        throw new e("integer: negative integers are not allowed");
      let n = l1(t);
      if (Number.parseInt(n[0], 16) & 8 && (n = "00" + n), n.length & 1)
        throw new e("unexpected DER parsing assertion: unpadded hex");
      return n;
    },
    decode(t) {
      const { Err: e } = Rs;
      if (t[0] & 128)
        throw new e("invalid signature integer: negative");
      if (t[0] === 0 && !(t[1] & 128))
        throw new e("invalid signature integer: unnecessary leading zero");
      return a9t(t);
    }
  },
  toSig(t) {
    const { Err: e, _int: n, _tlv: r } = Rs, i = typeof t == "string" ? o9t(t) : t;
    Fp(i);
    const { v: a, l: o } = r.decode(48, i);
    if (o.length)
      throw new e("invalid signature: left bytes after parsing");
    const { v: s, l } = r.decode(2, a), { v: c, l: u } = r.decode(2, l);
    if (u.length)
      throw new e("invalid signature: left bytes after parsing");
    return { r: n.decode(s), s: n.decode(c) };
  },
  hexFromSig(t) {
    const { _tlv: e, _int: n } = Rs, r = e.encode(2, n.encode(t.r)), i = e.encode(2, n.encode(t.s)), a = r + i;
    return e.encode(48, a);
  }
}, Bs = BigInt(0), vr = BigInt(1);
BigInt(2);
const oI = BigInt(3);
BigInt(4);
function l9t(t) {
  const e = i9t(t), { Fp: n } = e, r = N$(e.n, e.nBitLength), i = e.toBytes || ((m, g, v) => {
    const k = g.toAffine();
    return k2(Uint8Array.from([4]), n.toBytes(k.x), n.toBytes(k.y));
  }), a = e.fromBytes || ((m) => {
    const g = m.subarray(1), v = n.fromBytes(g.subarray(0, n.BYTES)), k = n.fromBytes(g.subarray(n.BYTES, 2 * n.BYTES));
    return { x: v, y: k };
  });
  function o(m) {
    const { a: g, b: v } = e, k = n.sqr(m), w = n.mul(k, m);
    return n.add(n.add(w, n.mul(m, g)), v);
  }
  if (!n.eql(n.sqr(e.Gy), o(e.Gx)))
    throw new Error("bad generator point: equation left != right");
  function s(m) {
    return Q6(m, vr, e.n);
  }
  function l(m) {
    const { allowedPrivateKeyLengths: g, nByteLength: v, wrapPrivateKey: k, n: w } = e;
    if (g && typeof m != "bigint") {
      if (u0(m) && (m = td(m)), typeof m != "string" || !g.includes(m.length))
        throw new Error("invalid private key");
      m = m.padStart(v * 2, "0");
    }
    let b;
    try {
      b = typeof m == "bigint" ? m : Hu(Wa("private key", m, v));
    } catch {
      throw new Error("invalid private key, expected hex or " + v + " bytes, got " + typeof m);
    }
    return k && (b = xi(b, w)), Fu("private key", b, vr, w), b;
  }
  function c(m) {
    if (!(m instanceof f))
      throw new Error("ProjectivePoint expected");
  }
  const u = fw((m, g) => {
    const { px: v, py: k, pz: w } = m;
    if (n.eql(w, n.ONE))
      return { x: v, y: k };
    const b = m.is0();
    g == null && (g = b ? n.ONE : n.inv(w));
    const x = n.mul(v, g), A = n.mul(k, g), L = n.mul(w, g);
    if (b)
      return { x: n.ZERO, y: n.ZERO };
    if (!n.eql(L, n.ONE))
      throw new Error("invZ was invalid");
    return { x, y: A };
  }), d = fw((m) => {
    if (m.is0()) {
      if (e.allowInfinityPoint && !n.is0(m.py))
        return;
      throw new Error("bad point: ZERO");
    }
    const { x: g, y: v } = m.toAffine();
    if (!n.isValid(g) || !n.isValid(v))
      throw new Error("bad point: x or y not FE");
    const k = n.sqr(v), w = o(g);
    if (!n.eql(k, w))
      throw new Error("bad point: equation left != right");
    if (!m.isTorsionFree())
      throw new Error("bad point: not in prime-order subgroup");
    return !0;
  });
  class f {
    constructor(g, v, k) {
      if (this.px = g, this.py = v, this.pz = k, g == null || !n.isValid(g))
        throw new Error("x required");
      if (v == null || !n.isValid(v))
        throw new Error("y required");
      if (k == null || !n.isValid(k))
        throw new Error("z required");
      Object.freeze(this);
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(g) {
      const { x: v, y: k } = g || {};
      if (!g || !n.isValid(v) || !n.isValid(k))
        throw new Error("invalid affine point");
      if (g instanceof f)
        throw new Error("projective point not allowed");
      const w = (b) => n.eql(b, n.ZERO);
      return w(v) && w(k) ? f.ZERO : new f(v, k, n.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(g) {
      const v = n.invertBatch(g.map((k) => k.pz));
      return g.map((k, w) => k.toAffine(v[w])).map(f.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(g) {
      const v = f.fromAffine(a(Wa("pointHex", g)));
      return v.assertValidity(), v;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(g) {
      return f.BASE.multiply(l(g));
    }
    // Multiscalar Multiplication
    static msm(g, v) {
      return r9t(f, r, g, v);
    }
    // "Private method", don't use it directly
    _setWindowSize(g) {
      p.setWindowSize(this, g);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      d(this);
    }
    hasEvenY() {
      const { y: g } = this.toAffine();
      if (n.isOdd)
        return !n.isOdd(g);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(g) {
      c(g);
      const { px: v, py: k, pz: w } = this, { px: b, py: x, pz: A } = g, L = n.eql(n.mul(v, A), n.mul(b, w)), M = n.eql(n.mul(k, A), n.mul(x, w));
      return L && M;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new f(this.px, n.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: g, b: v } = e, k = n.mul(v, oI), { px: w, py: b, pz: x } = this;
      let A = n.ZERO, L = n.ZERO, M = n.ZERO, j = n.mul(w, w), D = n.mul(b, b), z = n.mul(x, x), H = n.mul(w, b);
      return H = n.add(H, H), M = n.mul(w, x), M = n.add(M, M), A = n.mul(g, M), L = n.mul(k, z), L = n.add(A, L), A = n.sub(D, L), L = n.add(D, L), L = n.mul(A, L), A = n.mul(H, A), M = n.mul(k, M), z = n.mul(g, z), H = n.sub(j, z), H = n.mul(g, H), H = n.add(H, M), M = n.add(j, j), j = n.add(M, j), j = n.add(j, z), j = n.mul(j, H), L = n.add(L, j), z = n.mul(b, x), z = n.add(z, z), j = n.mul(z, H), A = n.sub(A, j), M = n.mul(z, D), M = n.add(M, M), M = n.add(M, M), new f(A, L, M);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(g) {
      c(g);
      const { px: v, py: k, pz: w } = this, { px: b, py: x, pz: A } = g;
      let L = n.ZERO, M = n.ZERO, j = n.ZERO;
      const D = e.a, z = n.mul(e.b, oI);
      let H = n.mul(v, b), V = n.mul(k, x), F = n.mul(w, A), _ = n.add(v, k), W = n.add(b, x);
      _ = n.mul(_, W), W = n.add(H, V), _ = n.sub(_, W), W = n.add(v, w);
      let G = n.add(b, A);
      return W = n.mul(W, G), G = n.add(H, F), W = n.sub(W, G), G = n.add(k, w), L = n.add(x, A), G = n.mul(G, L), L = n.add(V, F), G = n.sub(G, L), j = n.mul(D, W), L = n.mul(z, F), j = n.add(L, j), L = n.sub(V, j), j = n.add(V, j), M = n.mul(L, j), V = n.add(H, H), V = n.add(V, H), F = n.mul(D, F), W = n.mul(z, W), V = n.add(V, F), F = n.sub(H, F), F = n.mul(D, F), W = n.add(W, F), H = n.mul(V, W), M = n.add(M, H), H = n.mul(G, W), L = n.mul(_, L), L = n.sub(L, H), H = n.mul(_, V), j = n.mul(G, j), j = n.add(j, H), new f(L, M, j);
    }
    subtract(g) {
      return this.add(g.negate());
    }
    is0() {
      return this.equals(f.ZERO);
    }
    wNAF(g) {
      return p.wNAFCached(this, g, f.normalizeZ);
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(g) {
      const { endo: v, n: k } = e;
      Fu("scalar", g, Bs, k);
      const w = f.ZERO;
      if (g === Bs)
        return w;
      if (this.is0() || g === vr)
        return this;
      if (!v || p.hasPrecomputes(this))
        return p.wNAFCachedUnsafe(this, g, f.normalizeZ);
      let { k1neg: b, k1: x, k2neg: A, k2: L } = v.splitScalar(g), M = w, j = w, D = this;
      for (; x > Bs || L > Bs; )
        x & vr && (M = M.add(D)), L & vr && (j = j.add(D)), D = D.double(), x >>= vr, L >>= vr;
      return b && (M = M.negate()), A && (j = j.negate()), j = new f(n.mul(j.px, v.beta), j.py, j.pz), M.add(j);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(g) {
      const { endo: v, n: k } = e;
      Fu("scalar", g, vr, k);
      let w, b;
      if (v) {
        const { k1neg: x, k1: A, k2neg: L, k2: M } = v.splitScalar(g);
        let { p: j, f: D } = this.wNAF(A), { p: z, f: H } = this.wNAF(M);
        j = p.constTimeNegate(x, j), z = p.constTimeNegate(L, z), z = new f(n.mul(z.px, v.beta), z.py, z.pz), w = j.add(z), b = D.add(H);
      } else {
        const { p: x, f: A } = this.wNAF(g);
        w = x, b = A;
      }
      return f.normalizeZ([w, b])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(g, v, k) {
      const w = f.BASE, b = (A, L) => L === Bs || L === vr || !A.equals(w) ? A.multiplyUnsafe(L) : A.multiply(L), x = b(this, v).add(b(g, k));
      return x.is0() ? void 0 : x;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(g) {
      return u(this, g);
    }
    isTorsionFree() {
      const { h: g, isTorsionFree: v } = e;
      if (g === vr)
        return !0;
      if (v)
        return v(f, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: g, clearCofactor: v } = e;
      return g === vr ? this : v ? v(f, this) : this.multiplyUnsafe(e.h);
    }
    toRawBytes(g = !0) {
      return ed("isCompressed", g), this.assertValidity(), i(f, this, g);
    }
    toHex(g = !0) {
      return ed("isCompressed", g), td(this.toRawBytes(g));
    }
  }
  f.BASE = new f(e.Gx, e.Gy, n.ONE), f.ZERO = new f(n.ZERO, n.ONE, n.ZERO);
  const h = e.nBitLength, p = n9t(f, e.endo ? Math.ceil(h / 2) : h);
  return {
    CURVE: e,
    ProjectivePoint: f,
    normPrivateKeyToScalar: l,
    weierstrassEquation: o,
    isWithinCurveOrder: s
  };
}
function c9t(t) {
  const e = R$(t);
  return _p(e, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...e });
}
function u9t(t) {
  const e = c9t(t), { Fp: n, n: r } = e, i = n.BYTES + 1, a = 2 * n.BYTES + 1;
  function o(F) {
    return xi(F, r);
  }
  function s(F) {
    return pw(F, r);
  }
  const { ProjectivePoint: l, normPrivateKeyToScalar: c, weierstrassEquation: u, isWithinCurveOrder: d } = l9t({
    ...e,
    toBytes(F, _, W) {
      const G = _.toAffine(), Y = n.toBytes(G.x), Z = k2;
      return ed("isCompressed", W), W ? Z(Uint8Array.from([_.hasEvenY() ? 2 : 3]), Y) : Z(Uint8Array.from([4]), Y, n.toBytes(G.y));
    },
    fromBytes(F) {
      const _ = F.length, W = F[0], G = F.subarray(1);
      if (_ === i && (W === 2 || W === 3)) {
        const Y = Hu(G);
        if (!Q6(Y, vr, n.ORDER))
          throw new Error("Point is not on curve");
        const Z = u(Y);
        let oe;
        try {
          oe = n.sqrt(Z);
        } catch (fe) {
          const me = fe instanceof Error ? ": " + fe.message : "";
          throw new Error("Point is not on curve" + me);
        }
        const ee = (oe & vr) === vr;
        return (W & 1) === 1 !== ee && (oe = n.neg(oe)), { x: Y, y: oe };
      } else if (_ === a && W === 4) {
        const Y = n.fromBytes(G.subarray(0, n.BYTES)), Z = n.fromBytes(G.subarray(n.BYTES, 2 * n.BYTES));
        return { x: Y, y: Z };
      } else {
        const Y = i, Z = a;
        throw new Error("invalid Point, expected length of " + Y + ", or uncompressed " + Z + ", got " + _);
      }
    }
  }), f = (F) => td(rd(F, e.nByteLength));
  function h(F) {
    const _ = r >> vr;
    return F > _;
  }
  function p(F) {
    return h(F) ? o(-F) : F;
  }
  const m = (F, _, W) => Hu(F.slice(_, W));
  class g {
    constructor(_, W, G) {
      this.r = _, this.s = W, this.recovery = G, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(_) {
      const W = e.nByteLength;
      return _ = Wa("compactSignature", _, W * 2), new g(m(_, 0, W), m(_, W, 2 * W));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(_) {
      const { r: W, s: G } = Rs.toSig(Wa("DER", _));
      return new g(W, G);
    }
    assertValidity() {
      Fu("r", this.r, vr, r), Fu("s", this.s, vr, r);
    }
    addRecoveryBit(_) {
      return new g(this.r, this.s, _);
    }
    recoverPublicKey(_) {
      const { r: W, s: G, recovery: Y } = this, Z = A(Wa("msgHash", _));
      if (Y == null || ![0, 1, 2, 3].includes(Y))
        throw new Error("recovery id invalid");
      const oe = Y === 2 || Y === 3 ? W + e.n : W;
      if (oe >= n.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const ee = Y & 1 ? "03" : "02", ae = l.fromHex(ee + f(oe)), fe = s(oe), me = o(-Z * fe), ge = o(G * fe), $ = l.BASE.multiplyAndAddUnsafe(ae, me, ge);
      if (!$)
        throw new Error("point at infinify");
      return $.assertValidity(), $;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return h(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new g(this.r, o(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return nd(this.toDERHex());
    }
    toDERHex() {
      return Rs.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return nd(this.toCompactHex());
    }
    toCompactHex() {
      return f(this.r) + f(this.s);
    }
  }
  const v = {
    isValidPrivateKey(F) {
      try {
        return c(F), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: c,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const F = I$(e.n);
      return X7t(e.randomBytes(F), e.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(F = 8, _ = l.BASE) {
      return _._setWindowSize(F), _.multiply(BigInt(3)), _;
    }
  };
  function k(F, _ = !0) {
    return l.fromPrivateKey(F).toRawBytes(_);
  }
  function w(F) {
    const _ = u0(F), W = typeof F == "string", G = (_ || W) && F.length;
    return _ ? G === i || G === a : W ? G === 2 * i || G === 2 * a : F instanceof l;
  }
  function b(F, _, W = !0) {
    if (w(F))
      throw new Error("first arg must be private key");
    if (!w(_))
      throw new Error("second arg must be public key");
    return l.fromHex(_).multiply(c(F)).toRawBytes(W);
  }
  const x = e.bits2int || function(F) {
    if (F.length > 8192)
      throw new Error("input is too large");
    const _ = Hu(F), W = F.length * 8 - e.nBitLength;
    return W > 0 ? _ >> BigInt(W) : _;
  }, A = e.bits2int_modN || function(F) {
    return o(x(F));
  }, L = kA(e.nBitLength);
  function M(F) {
    return Fu("num < 2^" + e.nBitLength, F, Bs, L), rd(F, e.nByteLength);
  }
  function j(F, _, W = D) {
    if (["recovered", "canonical"].some((xe) => xe in W))
      throw new Error("sign() legacy options not supported");
    const { hash: G, randomBytes: Y } = e;
    let { lowS: Z, prehash: oe, extraEntropy: ee } = W;
    Z == null && (Z = !0), F = Wa("msgHash", F), aI(W), oe && (F = Wa("prehashed msgHash", G(F)));
    const ae = A(F), fe = c(_), me = [M(fe), M(ae)];
    if (ee != null && ee !== !1) {
      const xe = ee === !0 ? Y(n.BYTES) : ee;
      me.push(Wa("extraEntropy", xe));
    }
    const ge = k2(...me), $ = ae;
    function se(xe) {
      const Oe = x(xe);
      if (!d(Oe))
        return;
      const je = s(Oe), Me = l.BASE.multiply(Oe).toAffine(), he = o(Me.x);
      if (he === Bs)
        return;
      const pe = o(je * o($ + he * fe));
      if (pe === Bs)
        return;
      let J = (Me.x === he ? 0 : 2) | Number(Me.y & vr), K = pe;
      return Z && h(pe) && (K = p(pe), J ^= 1), new g(he, K, J);
    }
    return { seed: ge, k2sig: se };
  }
  const D = { lowS: e.lowS, prehash: !1 }, z = { lowS: e.lowS, prehash: !1 };
  function H(F, _, W = D) {
    const { seed: G, k2sig: Y } = j(F, _, W), Z = e;
    return E$(Z.hash.outputLen, Z.nByteLength, Z.hmac)(G, Y);
  }
  l.BASE._setWindowSize(8);
  function V(F, _, W, G = z) {
    var J;
    const Y = F;
    _ = Wa("msgHash", _), W = Wa("publicKey", W);
    const { lowS: Z, prehash: oe, format: ee } = G;
    if (aI(G), "strict" in G)
      throw new Error("options.strict was renamed to lowS");
    if (ee !== void 0 && ee !== "compact" && ee !== "der")
      throw new Error("format must be compact or der");
    const ae = typeof Y == "string" || u0(Y), fe = !ae && !ee && typeof Y == "object" && Y !== null && typeof Y.r == "bigint" && typeof Y.s == "bigint";
    if (!ae && !fe)
      throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
    let me, ge;
    try {
      if (fe && (me = new g(Y.r, Y.s)), ae) {
        try {
          ee !== "compact" && (me = g.fromDER(Y));
        } catch (K) {
          if (!(K instanceof Rs.Err))
            throw K;
        }
        !me && ee !== "der" && (me = g.fromCompact(Y));
      }
      ge = l.fromHex(W);
    } catch {
      return !1;
    }
    if (!me || Z && me.hasHighS())
      return !1;
    oe && (_ = e.hash(_));
    const { r: $, s: se } = me, xe = A(_), Oe = s(se), je = o(xe * Oe), Me = o($ * Oe), he = (J = l.BASE.multiplyAndAddUnsafe(ge, je, Me)) == null ? void 0 : J.toAffine();
    return he ? o(he.x) === $ : !1;
  }
  return {
    CURVE: e,
    getPublicKey: k,
    getSharedSecret: b,
    sign: H,
    verify: V,
    ProjectivePoint: l,
    Signature: g,
    utils: v
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function d9t(t) {
  return {
    hash: t,
    hmac: (e, ...n) => L$(t, e, e5t(...n)),
    randomBytes: t5t
  };
}
function f9t(t, e) {
  const n = (r) => u9t({ ...t, ...d9t(r) });
  return { ...n(e), create: n };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const O$ = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), sI = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), h9t = BigInt(1), mw = BigInt(2), lI = (t, e) => (t + e / mw) / e;
function p9t(t) {
  const e = O$, n = BigInt(3), r = BigInt(6), i = BigInt(11), a = BigInt(22), o = BigInt(23), s = BigInt(44), l = BigInt(88), c = t * t * t % e, u = c * c * t % e, d = ha(u, n, e) * u % e, f = ha(d, n, e) * u % e, h = ha(f, mw, e) * c % e, p = ha(h, i, e) * h % e, m = ha(p, a, e) * p % e, g = ha(m, s, e) * m % e, v = ha(g, l, e) * g % e, k = ha(v, s, e) * m % e, w = ha(k, n, e) * u % e, b = ha(w, o, e) * p % e, x = ha(b, r, e) * c % e, A = ha(x, mw, e);
  if (!yw.eql(yw.sqr(A), t))
    throw new Error("Cannot find square root");
  return A;
}
const yw = N$(O$, void 0, void 0, { sqrt: p9t }), xA = f9t({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  Fp: yw,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: sI,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  endo: {
    // Endomorphism, see above
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (t) => {
      const e = sI, n = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), r = -h9t * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), i = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), a = n, o = BigInt("0x100000000000000000000000000000000"), s = lI(a * t, e), l = lI(-r * t, e);
      let c = xi(t - s * n - l * i, e), u = xi(-s * r - l * a, e);
      const d = c > o, f = u > o;
      if (d && (c = e - c), f && (u = e - u), c > o || u > o)
        throw new Error("splitScalar: Endomorphism failed, k=" + t);
      return { k1neg: d, k1: c, k2neg: f, k2: u };
    }
  }
}, IK);
BigInt(0);
xA.ProjectivePoint;
const m9t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  secp256k1: xA
}, Symbol.toStringTag, { value: "Module" }));
function y9t({ r: t, s: e, to: n = "hex", v: r, yParity: i }) {
  const a = (() => {
    if (i === 0 || i === 1)
      return i;
    if (r && (r === 27n || r === 28n || r >= 35n))
      return r % 2n === 0n ? 1 : 0;
    throw new Error("Invalid `v` or `yParity` value");
  })(), o = `0x${new xA.Signature(as(t), as(e)).toCompactHex()}${a === 0 ? "1b" : "1c"}`;
  return n === "hex" ? o : so(o);
}
async function MA(t, e) {
  var d, f, h;
  const { address: n, factory: r, factoryData: i, hash: a, signature: o, universalSignatureVerifierAddress: s = (h = (f = (d = t.chain) == null ? void 0 : d.contracts) == null ? void 0 : f.universalSignatureVerifier) == null ? void 0 : h.address, ...l } = e, c = is(o) ? o : typeof o == "object" && "r" in o && "s" in o ? y9t(o) : mr(o), u = await (async () => !r && !i || ibt(c) ? c : abt({
    address: r,
    data: i,
    signature: c
  }))();
  try {
    const p = s ? {
      to: s,
      data: hs({
        abi: OD,
        functionName: "isValidSig",
        args: [n, a, u]
      }),
      ...l
    } : {
      data: oA({
        abi: OD,
        args: [n, a, u],
        bytecode: W8t
      }),
      ...l
    }, { data: m } = await zt(t, W6, "call")(p);
    return O6t(m ?? "0x0");
  } catch (p) {
    try {
      if (nA(g5t(n), await xK({ hash: a, signature: o })))
        return !0;
    } catch {
    }
    if (p instanceof kK)
      return !1;
    throw p;
  }
}
async function g9t(t, { address: e, message: n, factory: r, factoryData: i, signature: a, ...o }) {
  const s = a$(n);
  return MA(t, {
    address: e,
    factory: r,
    factoryData: i,
    hash: s,
    signature: a,
    ...o
  });
}
async function v9t(t, e) {
  const { address: n, factory: r, factoryData: i, signature: a, message: o, primaryType: s, types: l, domain: c, ...u } = e, d = Gvt({ message: o, primaryType: s, types: l, domain: c });
  return MA(t, {
    address: n,
    factory: r,
    factoryData: i,
    hash: d,
    signature: a,
    ...u
  });
}
function B$(t, { emitOnBegin: e = !1, emitMissed: n = !1, onBlockNumber: r, onError: i, poll: a, pollingInterval: o = t.pollingInterval }) {
  const s = typeof a < "u" ? a : !(t.transport.type === "webSocket" || t.transport.type === "fallback" && t.transport.transports[0].config.type === "webSocket");
  let l;
  return s ? (() => {
    const d = Hr([
      "watchBlockNumber",
      t.uid,
      e,
      n,
      o
    ]);
    return Ac(d, { onBlockNumber: r, onError: i }, (f) => Bp(async () => {
      var h;
      try {
        const p = await zt(t, Hp, "getBlockNumber")({ cacheTime: 0 });
        if (l) {
          if (p === l)
            return;
          if (p - l > 1 && n)
            for (let m = l + 1n; m < p; m++)
              f.onBlockNumber(m, l), l = m;
        }
        (!l || p > l) && (f.onBlockNumber(p, l), l = p);
      } catch (p) {
        (h = f.onError) == null || h.call(f, p);
      }
    }, {
      emitOnBegin: e,
      interval: o
    }));
  })() : (() => {
    const d = Hr([
      "watchBlockNumber",
      t.uid,
      e,
      n
    ]);
    return Ac(d, { onBlockNumber: r, onError: i }, (f) => {
      let h = !0, p = () => h = !1;
      return (async () => {
        try {
          const m = (() => {
            if (t.transport.type === "fallback") {
              const v = t.transport.transports.find((k) => k.config.type === "webSocket");
              return v ? v.value : t.transport;
            }
            return t.transport;
          })(), { unsubscribe: g } = await m.subscribe({
            params: ["newHeads"],
            onData(v) {
              var w;
              if (!h)
                return;
              const k = as((w = v.result) == null ? void 0 : w.number);
              f.onBlockNumber(k, l), l = k;
            },
            onError(v) {
              var k;
              (k = f.onError) == null || k.call(f, v);
            }
          });
          p = g, h || p();
        } catch (m) {
          i == null || i(m);
        }
      })(), () => p();
    });
  })();
}
async function b9t(t, {
  confirmations: e = 1,
  hash: n,
  onReplaced: r,
  pollingInterval: i = t.pollingInterval,
  retryCount: a = 6,
  retryDelay: o = ({ count: l }) => ~~(1 << l) * 200,
  // exponential backoff
  timeout: s = 18e4
}) {
  const l = Hr(["waitForTransactionReceipt", t.uid, n]);
  let c, u, d, f = !1;
  const { promise: h, resolve: p, reject: m } = WK(), g = s ? setTimeout(() => m(new Q5t({ hash: n })), s) : void 0, v = Ac(l, { onReplaced: r, resolve: p, reject: m }, (k) => {
    const w = zt(t, B$, "watchBlockNumber")({
      emitMissed: !0,
      emitOnBegin: !0,
      poll: !0,
      pollingInterval: i,
      async onBlockNumber(b) {
        const x = (L) => {
          clearTimeout(g), w(), L(), v();
        };
        let A = b;
        if (!f)
          try {
            if (d) {
              if (e > 1 && (!d.blockNumber || A - d.blockNumber + 1n < e))
                return;
              x(() => k.resolve(d));
              return;
            }
            if (c || (f = !0, await iw(async () => {
              c = await zt(t, uA, "getTransaction")({ hash: n }), c.blockNumber && (A = c.blockNumber);
            }, {
              delay: o,
              retryCount: a
            }), f = !1), d = await zt(t, aw, "getTransactionReceipt")({ hash: n }), e > 1 && (!d.blockNumber || A - d.blockNumber + 1n < e))
              return;
            x(() => k.resolve(d));
          } catch (L) {
            if (L instanceof bK || L instanceof wK) {
              if (!c) {
                f = !1;
                return;
              }
              try {
                u = c, f = !0;
                const M = await iw(() => zt(t, Bo, "getBlock")({
                  blockNumber: A,
                  includeTransactions: !0
                }), {
                  delay: o,
                  retryCount: a,
                  shouldRetry: ({ error: z }) => z instanceof AK
                });
                f = !1;
                const j = M.transactions.find(({ from: z, nonce: H }) => z === u.from && H === u.nonce);
                if (!j || (d = await zt(t, aw, "getTransactionReceipt")({
                  hash: j.hash
                }), e > 1 && (!d.blockNumber || A - d.blockNumber + 1n < e)))
                  return;
                let D = "replaced";
                j.to === u.to && j.value === u.value && j.input === u.input ? D = "repriced" : j.from === j.to && j.value === 0n && (D = "cancelled"), x(() => {
                  var z;
                  (z = k.onReplaced) == null || z.call(k, {
                    reason: D,
                    replacedTransaction: u,
                    transaction: j,
                    transactionReceipt: d
                  }), k.resolve(d);
                });
              } catch (M) {
                x(() => k.reject(M));
              }
            } else
              x(() => k.reject(L));
          }
      }
    });
  });
  return h;
}
function w9t(t, { blockTag: e = "latest", emitMissed: n = !1, emitOnBegin: r = !1, onBlock: i, onError: a, includeTransactions: o, poll: s, pollingInterval: l = t.pollingInterval }) {
  const c = typeof s < "u" ? s : !(t.transport.type === "webSocket" || t.transport.type === "fallback" && t.transport.transports[0].config.type === "webSocket"), u = o ?? !1;
  let d;
  return c ? (() => {
    const p = Hr([
      "watchBlocks",
      t.uid,
      e,
      n,
      r,
      u,
      l
    ]);
    return Ac(p, { onBlock: i, onError: a }, (m) => Bp(async () => {
      var g;
      try {
        const v = await zt(t, Bo, "getBlock")({
          blockTag: e,
          includeTransactions: u
        });
        if (v.number && (d != null && d.number)) {
          if (v.number === d.number)
            return;
          if (v.number - d.number > 1 && n)
            for (let k = (d == null ? void 0 : d.number) + 1n; k < v.number; k++) {
              const w = await zt(t, Bo, "getBlock")({
                blockNumber: k,
                includeTransactions: u
              });
              m.onBlock(w, d), d = w;
            }
        }
        // If no previous block exists, emit.
        (!(d != null && d.number) || // If the block tag is "pending" with no block number, emit.
        e === "pending" && !(v != null && v.number) || // If the next block number is greater than the previous block number, emit.
        // We don't want to emit blocks in the past.
        v.number && v.number > d.number) && (m.onBlock(v, d), d = v);
      } catch (v) {
        (g = m.onError) == null || g.call(m, v);
      }
    }, {
      emitOnBegin: r,
      interval: l
    }));
  })() : (() => {
    let p = !0, m = !0, g = () => p = !1;
    return (async () => {
      try {
        r && zt(t, Bo, "getBlock")({
          blockTag: e,
          includeTransactions: u
        }).then((w) => {
          p && m && (i(w, void 0), m = !1);
        });
        const v = (() => {
          if (t.transport.type === "fallback") {
            const w = t.transport.transports.find((b) => b.config.type === "webSocket");
            return w ? w.value : t.transport;
          }
          return t.transport;
        })(), { unsubscribe: k } = await v.subscribe({
          params: ["newHeads"],
          async onData(w) {
            if (!p)
              return;
            const b = await zt(t, Bo, "getBlock")({
              blockNumber: w.blockNumber,
              includeTransactions: u
            }).catch(() => {
            });
            p && (i(b, d), m = !1, d = b);
          },
          onError(w) {
            a == null || a(w);
          }
        });
        g = k, p || g();
      } catch (v) {
        a == null || a(v);
      }
    })(), () => g();
  })();
}
function k9t(t, { address: e, args: n, batch: r = !0, event: i, events: a, fromBlock: o, onError: s, onLogs: l, poll: c, pollingInterval: u = t.pollingInterval, strict: d }) {
  const f = typeof c < "u" ? c : typeof o == "bigint" ? !0 : !(t.transport.type === "webSocket" || t.transport.type === "fallback" && t.transport.transports[0].config.type === "webSocket"), h = d ?? !1;
  return f ? (() => {
    const g = Hr([
      "watchEvent",
      e,
      n,
      r,
      t.uid,
      i,
      u,
      o
    ]);
    return Ac(g, { onLogs: l, onError: s }, (v) => {
      let k;
      o !== void 0 && (k = o - 1n);
      let w, b = !1;
      const x = Bp(async () => {
        var A;
        if (!b) {
          try {
            w = await zt(t, XK, "createEventFilter")({
              address: e,
              args: n,
              event: i,
              events: a,
              strict: h,
              fromBlock: o
            });
          } catch {
          }
          b = !0;
          return;
        }
        try {
          let L;
          if (w)
            L = await zt(t, Z6, "getFilterChanges")({ filter: w });
          else {
            const M = await zt(t, Hp, "getBlockNumber")({});
            k && k !== M ? L = await zt(t, aA, "getLogs")({
              address: e,
              args: n,
              event: i,
              events: a,
              fromBlock: k + 1n,
              toBlock: M
            }) : L = [], k = M;
          }
          if (L.length === 0)
            return;
          if (r)
            v.onLogs(L);
          else
            for (const M of L)
              v.onLogs([M]);
        } catch (L) {
          w && L instanceof s0 && (b = !1), (A = v.onError) == null || A.call(v, L);
        }
      }, {
        emitOnBegin: !0,
        interval: u
      });
      return async () => {
        w && await zt(t, G6, "uninstallFilter")({ filter: w }), x();
      };
    });
  })() : (() => {
    let g = !0, v = () => g = !1;
    return (async () => {
      try {
        const k = (() => {
          if (t.transport.type === "fallback") {
            const A = t.transport.transports.find((L) => L.config.type === "webSocket");
            return A ? A.value : t.transport;
          }
          return t.transport;
        })(), w = a ?? (i ? [i] : void 0);
        let b = [];
        w && (b = [w.flatMap((L) => Rp({
          abi: [L],
          eventName: L.name,
          args: n
        }))], i && (b = b[0]));
        const { unsubscribe: x } = await k.subscribe({
          params: ["logs", { address: e, topics: b }],
          onData(A) {
            var M;
            if (!g)
              return;
            const L = A.result;
            try {
              const { eventName: j, args: D } = rA({
                abi: w ?? [],
                data: L.data,
                topics: L.topics,
                strict: h
              }), z = pl(L, { args: D, eventName: j });
              l([z]);
            } catch (j) {
              let D, z;
              if (j instanceof a2 || j instanceof z6) {
                if (d)
                  return;
                D = j.abiItem.name, z = (M = j.abiItem.inputs) == null ? void 0 : M.some((V) => !("name" in V && V.name));
              }
              const H = pl(L, {
                args: z ? [] : {},
                eventName: D
              });
              l([H]);
            }
          },
          onError(A) {
            s == null || s(A);
          }
        });
        v = x, g || v();
      } catch (k) {
        s == null || s(k);
      }
    })(), () => v();
  })();
}
function x9t(t, { batch: e = !0, onError: n, onTransactions: r, poll: i, pollingInterval: a = t.pollingInterval }) {
  return (typeof i < "u" ? i : t.transport.type !== "webSocket") ? (() => {
    const c = Hr([
      "watchPendingTransactions",
      t.uid,
      e,
      a
    ]);
    return Ac(c, { onTransactions: r, onError: n }, (u) => {
      let d;
      const f = Bp(async () => {
        var h;
        try {
          if (!d)
            try {
              d = await zt(t, e$, "createPendingTransactionFilter")({});
              return;
            } catch (m) {
              throw f(), m;
            }
          const p = await zt(t, Z6, "getFilterChanges")({ filter: d });
          if (p.length === 0)
            return;
          if (e)
            u.onTransactions(p);
          else
            for (const m of p)
              u.onTransactions([m]);
        } catch (p) {
          (h = u.onError) == null || h.call(u, p);
        }
      }, {
        emitOnBegin: !0,
        interval: a
      });
      return async () => {
        d && await zt(t, G6, "uninstallFilter")({ filter: d }), f();
      };
    });
  })() : (() => {
    let c = !0, u = () => c = !1;
    return (async () => {
      try {
        const { unsubscribe: d } = await t.transport.subscribe({
          params: ["newPendingTransactions"],
          onData(f) {
            if (!c)
              return;
            const h = f.result;
            r([h]);
          },
          onError(f) {
            n == null || n(f);
          }
        });
        u = d, c || u();
      } catch (d) {
        n == null || n(d);
      }
    })(), () => u();
  })();
}
function M9t(t) {
  var d, f, h;
  const { scheme: e, statement: n, ...r } = ((d = t.match(C9t)) == null ? void 0 : d.groups) ?? {}, { chainId: i, expirationTime: a, issuedAt: o, notBefore: s, requestId: l, ...c } = ((f = t.match(A9t)) == null ? void 0 : f.groups) ?? {}, u = (h = t.split("Resources:")[1]) == null ? void 0 : h.split(`
- `).slice(1);
  return {
    ...r,
    ...c,
    ...i ? { chainId: Number(i) } : {},
    ...a ? { expirationTime: new Date(a) } : {},
    ...o ? { issuedAt: new Date(o) } : {},
    ...s ? { notBefore: new Date(s) } : {},
    ...l ? { requestId: l } : {},
    ...u ? { resources: u } : {},
    ...e ? { scheme: e } : {},
    ...n ? { statement: n } : {}
  };
}
const C9t = /^(?:(?<scheme>[a-zA-Z][a-zA-Z0-9+-.]*):\/\/)?(?<domain>[a-zA-Z0-9+-.]*(?::[0-9]{1,5})?) (?:wants you to sign in with your Ethereum account:\n)(?<address>0x[a-fA-F0-9]{40})\n\n(?:(?<statement>.*)\n\n)?/, A9t = /(?:URI: (?<uri>.+))\n(?:Version: (?<version>.+))\n(?:Chain ID: (?<chainId>\d+))\n(?:Nonce: (?<nonce>[a-zA-Z0-9]+))\n(?:Issued At: (?<issuedAt>.+))(?:\nExpiration Time: (?<expirationTime>.+))?(?:\nNot Before: (?<notBefore>.+))?(?:\nRequest ID: (?<requestId>.+))?/;
function S9t(t) {
  const { address: e, domain: n, message: r, nonce: i, scheme: a, time: o = /* @__PURE__ */ new Date() } = t;
  if (n && r.domain !== n || i && r.nonce !== i || a && r.scheme !== a || r.expirationTime && o >= r.expirationTime || r.notBefore && o < r.notBefore)
    return !1;
  try {
    if (!r.address || e && !nA(r.address, e))
      return !1;
  } catch {
    return !1;
  }
  return !0;
}
async function L9t(t, e) {
  const { address: n, domain: r, message: i, nonce: a, scheme: o, signature: s, time: l = /* @__PURE__ */ new Date(), ...c } = e, u = M9t(i);
  if (!u.address || !S9t({
    address: n,
    domain: r,
    message: u,
    nonce: a,
    scheme: o,
    time: l
  }))
    return !1;
  const f = a$(i);
  return MA(t, {
    address: u.address,
    hash: f,
    signature: s,
    ...c
  });
}
function T9t(t) {
  return {
    call: (e) => W6(t, e),
    createAccessList: (e) => QK(t, e),
    createBlockFilter: () => Ovt(t),
    createContractEventFilter: (e) => hK(t, e),
    createEventFilter: (e) => XK(t, e),
    createPendingTransactionFilter: () => e$(t),
    estimateContractGas: (e) => H8t(t, e),
    estimateGas: (e) => tA(t, e),
    getBalance: (e) => BK(t, e),
    getBlobBaseFee: () => Bvt(t),
    getBlock: (e) => Bo(t, e),
    getBlockNumber: (e) => Hp(t, e),
    getBlockTransactionCount: (e) => Hvt(t, e),
    getBytecode: (e) => _D(t, e),
    getChainId: () => RK(t),
    getCode: (e) => _D(t, e),
    getContractEvents: (e) => HK(t, e),
    getEip712Domain: (e) => svt(t, e),
    getEnsAddress: (e) => kvt(t, e),
    getEnsAvatar: (e) => Pvt(t, e),
    getEnsName: (e) => zvt(t, e),
    getEnsResolver: (e) => Rvt(t, e),
    getEnsText: (e) => JK(t, e),
    getFeeHistory: (e) => _vt(t, e),
    estimateFeesPerGas: (e) => M8t(t, e),
    getFilterChanges: (e) => Z6(t, e),
    getFilterLogs: (e) => Vvt(t, e),
    getGasPrice: () => XC(t),
    getLogs: (e) => aA(t, e),
    getProof: (e) => lbt(t, e),
    estimateMaxPriorityFeePerGas: (e) => x8t(t, e),
    getStorageAt: (e) => cbt(t, e),
    getTransaction: (e) => uA(t, e),
    getTransactionConfirmations: (e) => ubt(t, e),
    getTransactionCount: (e) => jK(t, e),
    getTransactionReceipt: (e) => aw(t, e),
    multicall: (e) => dbt(t, e),
    prepareTransactionRequest: (e) => OK(t, e),
    readContract: (e) => ml(t, e),
    sendRawTransaction: (e) => avt(t, e),
    simulate: (e) => ow(t, e),
    simulateBlocks: (e) => ow(t, e),
    simulateCalls: (e) => P7t(t, e),
    simulateContract: (e) => J8t(t, e),
    verifyMessage: (e) => g9t(t, e),
    verifySiweMessage: (e) => L9t(t, e),
    verifyTypedData: (e) => v9t(t, e),
    uninstallFilter: (e) => G6(t, e),
    waitForTransactionReceipt: (e) => b9t(t, e),
    watchBlocks: (e) => w9t(t, e),
    watchBlockNumber: (e) => B$(t, e),
    watchContractEvent: (e) => ivt(t, e),
    watchEvent: (e) => k9t(t, e),
    watchPendingTransactions: (e) => x9t(t, e)
  };
}
function E9t(t) {
  const { key: e = "public", name: n = "Public Client" } = t;
  return cvt({
    ...t,
    key: e,
    name: n,
    type: "publicClient"
  }).extend(T9t);
}
const j9t = /* @__PURE__ */ qvt({
  id: 1,
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://eth.merkle.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://etherscan.io",
      apiUrl: "https://api.etherscan.io/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
      blockCreated: 19258213
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), H$ = async (t, e) => {
  const n = {
    name: t,
    isEns: !1,
    resolved: !1
  };
  if (!e)
    throw new Error("cannot fetch ens name without a provider url");
  if (!Ia(t)) return n;
  try {
    const r = await N9t(t, e);
    r ? (n.name = r, n.isEns = !0, n.resolved = !0) : (n.name = t, n.isEns = !1, n.resolved = !0);
  } catch (r) {
    console.log(r);
  }
  return n;
}, N9t = async (t, e) => await F$.getClient(e).getEnsName({ address: t }), D9t = (t, e, n) => {
  if ((t == null ? void 0 : t.length) > n) {
    const r = t.substring(0, e), i = t.substring((t == null ? void 0 : t.length) - e);
    return `${r}...${i}`;
  }
  return t;
};
class F$ {
  static getClient(e) {
    return this.client ? this.client : (this.client = E9t({
      transport: vvt(e),
      chain: j9t
    }), this.client);
  }
}
ua(F$, "client");
const _$ = xn(void 0), I9t = ({
  children: t,
  editor: e,
  initialComments: n = [],
  setInitialComments: r,
  username: i,
  setUsername: a,
  activeCommentId: o,
  setActiveCommentId: s,
  focusCommentWithActiveId: l,
  onNewComment: c,
  onCommentReply: u,
  ensResolutionUrl: d,
  onResolveComment: f,
  onUnresolveComment: h,
  onDeleteComment: p,
  isConnected: m,
  connectViaWallet: g,
  isLoading: v,
  connectViaUsername: k,
  isDDocOwner: w,
  onInlineComment: b,
  onComment: x,
  setCommentDrawerOpen: A
}) => {
  const [L, M] = De(!0), [j, D] = De(""), [z, H] = De(""), [V, F] = De(null), _ = Ue(null), W = Ue(null), [G, Y] = De(""), [Z, oe] = De(!1), ee = Ue(null), ae = Ue(null), fe = Ue(null), me = e.isActive("comment"), ge = e.getAttributes("comment").resolved, [$, se] = De({
    inlineCommentText: "",
    handleClick: !1
  }), xe = localStorage.getItem("ensCache"), [Oe, je] = De(
    xe ? JSON.parse(xe) : {}
  ), [Me, he] = De([]), pe = nt(
    async (we, $e) => {
      if (Me.includes(we)) {
        $e({
          name: we || "Anonymous",
          isEns: !1
        });
        return;
      }
      if (we && Oe[we]) {
        $e({
          ...Oe[we]
        });
        return;
      }
      if (!we || !d) {
        $e({
          name: we || "Anonymous",
          isEns: !1
        });
        return;
      }
      try {
        he((dt) => [...dt, we]);
        const { name: Xe, isEns: Be, resolved: et } = await H$(
          we,
          d
          // Add definite assignment assertion if ensResolutionUrl is guaranteed
        );
        et && je((dt) => {
          const ut = {
            ...dt,
            [we]: { name: Xe, isEns: Be }
          };
          return localStorage.setItem("ensCache", JSON.stringify(ut)), ut;
        }), he(
          (dt) => dt.filter((ut) => ut !== we)
        ), $e({ name: Xe, isEns: Be });
      } catch (Xe) {
        console.error("Error fetching ENS name:", Xe), $e({
          name: we || "Anonymous",
          isEns: !1
        });
      }
    },
    [Me, Oe, d]
  ), J = Ft(
    () => n.find((we) => we.id === o),
    [n, o]
  );
  BC([ee, ae, fe], () => {
    Z && (e.chain().unsetHighlight().run(), oe(!1));
  });
  const K = nt(() => {
    const { state: we } = e, { from: $e, to: Xe } = we.selection, Be = we.doc.textBetween($e, Xe, " ");
    me ? J && Y(J.selectedContent || "") : Y(Be), oe(!0), b == null || b();
    const et = localStorage.getItem("theme") === "dark";
    e.chain().setHighlight({
      color: et ? "#15521d" : "#DDFBDF"
    }).run();
  }, [e, me, J, b]), X = nt(
    (we, $e = "", Xe) => ({
      id: `comment-${oh()}`,
      username: Xe,
      selectedContent: we,
      // Preserve line breaks in content
      content: $e || "",
      replies: [],
      createdAt: /* @__PURE__ */ new Date()
    }),
    []
  ), re = nt(
    (we, $e) => {
      if (!e) return;
      const { state: Xe } = e, { from: Be, to: et } = Xe.selection, dt = Xe.doc.textBetween(Be, et, " "), ut = X(
        dt,
        we,
        $e || i
      );
      return e == null || e.commands.setComment(ut.id || ""), s(ut.id || ""), setTimeout(l, 0), c == null || c(ut), ut.id;
    },
    [
      e,
      X,
      i,
      s,
      l,
      c
    ]
  ), Ie = nt(
    (we) => {
      e.commands.resolveComment(we), f == null || f(we);
    },
    [e, f]
  ), q = nt(
    (we) => {
      e.commands.unresolveComment(we), h == null || h(we);
    },
    [e, h]
  ), S = nt(
    (we) => {
      e.commands.unsetComment(we), p == null || p(we);
    },
    [e, p]
  ), P = nt(
    (we, $e, Xe) => {
      if (!$e.trim()) return;
      const Be = {
        id: `reply-${oh()}`,
        content: $e,
        username: i,
        replies: [],
        createdAt: /* @__PURE__ */ new Date(),
        selectedContent: ""
      };
      Xe == null || Xe(we, Be);
    },
    [i]
  ), O = nt(
    (we) => {
      var Xe;
      if (!e || !n.length) return;
      const $e = n.find((Be) => Be.id === we);
      if ($e) {
        if ($e.selectedContent) {
          const Be = e.view.dom.querySelector(
            `[data-comment-id="${we}"]`
          );
          if (Be) {
            const et = e.view.posAtDOM(Be, 0), dt = et + (((Xe = Be.textContent) == null ? void 0 : Xe.length) ?? 0);
            e.commands.setTextSelection({ from: et, to: dt });
            const Pt = [
              document.querySelector(".ProseMirror"),
              document.getElementById("editor-canvas"),
              Be.closest(".ProseMirror"),
              Be.closest('[class*="editor"]'),
              e.view.dom.parentElement
            ].filter((Vt) => Vt !== null).find(
              (Vt) => Vt && (Vt.scrollHeight > Vt.clientHeight || window.getComputedStyle(Vt).overflow === "auto" || window.getComputedStyle(Vt).overflowY === "auto")
            );
            Pt && requestAnimationFrame(() => {
              const Vt = Pt.getBoundingClientRect(), kt = Be.getBoundingClientRect(), sn = kt.top - Vt.top - Vt.height / 2 + kt.height / 2;
              Pt.scrollBy({
                top: sn,
                behavior: "smooth"
              });
            });
          }
        }
        s(we);
      }
    },
    [e, n, s]
  ), ne = nt(
    (we) => {
      const $e = we.target.value;
      D($e), $e || (we.target.style.height = "40px");
    },
    []
  ), le = nt(
    (we) => {
      const $e = we.target.value;
      H($e), $e || (we.target.style.height = "40px");
    },
    []
  ), de = nt(() => {
    if (e.chain().unsetHighlight().run(), !z.trim() || !i) return;
    const we = {
      id: `comment-${oh()}`,
      username: i,
      selectedContent: "",
      // Empty for generic comments
      content: z,
      replies: [],
      createdAt: /* @__PURE__ */ new Date()
    };
    c == null || c(we), s(we.id), H(""), x == null || x(), requestAnimationFrame(() => {
      _.current && _.current.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  }, [
    e,
    z,
    i,
    c,
    s,
    x,
    _
  ]), Pe = nt(
    (we) => {
      we.key === "Enter" && !we.shiftKey && (we.preventDefault(), de());
    },
    [de]
  ), ve = nt(() => {
    !o || !j.trim() || (P(o, j, u), D(""));
  }, [o, j, P, u]), Le = nt(
    (we) => {
      we.key === "Enter" && !we.shiftKey && (we.preventDefault(), ve());
    },
    [ve]
  ), Re = nt(() => {
    M((we) => !we);
  }, []), Ke = nt(
    (we, $e) => {
      we.currentTarget.style.height = "auto";
      const Xe = Math.min(
        Math.max(40, we.currentTarget.scrollHeight),
        $e.length > 30 || $e.includes(`
`) ? 96 : 40
      );
      we.currentTarget.style.height = `${Xe}px`;
    },
    []
  ), mt = Ft(
    () => n.filter(
      (we) => !we.resolved && we.selectedContent && we.selectedContent.length > 0 && !we.deleted
    ),
    [n]
  ), pt = Ft(
    () => mt.findIndex((we) => we.id === o),
    [mt, o]
  ), Nt = nt(() => {
    var we;
    if (pt > 0) {
      const $e = mt[pt - 1], Xe = e.view.dom.querySelector(
        `[data-comment-id="${$e.id}"]`
      );
      if (Xe) {
        const Be = e.view.posAtDOM(Xe, 0), et = Be + (((we = Xe.textContent) == null ? void 0 : we.length) ?? 0);
        e.commands.setTextSelection({ from: Be, to: et }), O($e.id || "");
      }
    }
  }, [pt, mt, e, O]), ye = nt(() => {
    var we;
    if (pt < mt.length - 1) {
      const $e = mt[pt + 1], Xe = e.view.dom.querySelector(
        `[data-comment-id="${$e.id}"]`
      );
      if (Xe) {
        const Be = e.view.posAtDOM(Xe, 0), et = Be + (((we = Xe.textContent) == null ? void 0 : we.length) ?? 0);
        e.commands.setTextSelection({ from: Be, to: et }), O($e.id || "");
      }
    }
  }, [pt, mt, e, O]), _e = Ft(
    () => ({
      comments: n,
      showResolved: L,
      editor: e,
      username: i,
      setUsername: a,
      setComments: r,
      setShowResolved: M,
      resolveComment: Ie,
      unresolveComment: q,
      deleteComment: S,
      handleAddReply: P,
      focusCommentInEditor: O,
      handleReplyChange: ne,
      handleCommentChange: le,
      handleCommentKeyDown: Pe,
      handleReplySubmit: ve,
      toggleResolved: Re,
      setOpenReplyId: F,
      handleReplyKeyDown: Le,
      openReplyId: V,
      commentsSectionRef: _,
      addComment: re,
      handleCommentSubmit: de,
      comment: z,
      reply: j,
      setComment: H,
      setReply: D,
      onPrevComment: Nt,
      onNextComment: ye,
      activeCommentIndex: pt,
      activeComment: J,
      selectedText: G,
      isCommentOpen: Z,
      handleInlineComment: K,
      portalRef: ee,
      buttonRef: ae,
      replySectionRef: W,
      dropdownRef: fe,
      activeComments: mt,
      handleInput: Ke,
      isCommentActive: me,
      isCommentResolved: ge,
      ensResolutionUrl: d,
      onCommentReply: u,
      isConnected: m,
      connectViaWallet: g,
      isLoading: v,
      connectViaUsername: k,
      isDDocOwner: w,
      onComment: x,
      setCommentDrawerOpen: A,
      inlineCommentData: $,
      setInlineCommentData: se,
      getEnsStatus: pe,
      ensCache: Oe
    }),
    [
      n,
      L,
      e,
      i,
      a,
      r,
      M,
      Ie,
      q,
      S,
      P,
      O,
      ne,
      le,
      Pe,
      ve,
      Re,
      F,
      Le,
      V,
      re,
      de,
      z,
      j,
      H,
      D,
      Nt,
      ye,
      pt,
      J,
      G,
      Z,
      K,
      mt,
      Ke,
      me,
      ge,
      d,
      u,
      m,
      g,
      v,
      k,
      w,
      x,
      A,
      $,
      se,
      pe,
      Oe
      // Note: refs (portalRef, buttonRef, replySectionRef, dropdownRef, commentsSectionRef) are stable and don't need to be dependencies
    ]
  );
  return /* @__PURE__ */ C.jsx(_$.Provider, { value: _e, children: t });
}, yl = () => {
  const t = Mt(_$);
  return t || {};
}, cI = {};
function P9t(t) {
  let e = cI[t];
  if (e)
    return e;
  e = cI[t] = [];
  for (let n = 0; n < 128; n++) {
    const r = String.fromCharCode(n);
    e.push(r);
  }
  for (let n = 0; n < t.length; n++) {
    const r = t.charCodeAt(n);
    e[r] = "%" + ("0" + r.toString(16).toUpperCase()).slice(-2);
  }
  return e;
}
function id(t, e) {
  typeof e != "string" && (e = id.defaultChars);
  const n = P9t(e);
  return t.replace(/(%[a-f0-9]{2})+/gi, function(r) {
    let i = "";
    for (let a = 0, o = r.length; a < o; a += 3) {
      const s = parseInt(r.slice(a + 1, a + 3), 16);
      if (s < 128) {
        i += n[s];
        continue;
      }
      if ((s & 224) === 192 && a + 3 < o) {
        const l = parseInt(r.slice(a + 4, a + 6), 16);
        if ((l & 192) === 128) {
          const c = s << 6 & 1984 | l & 63;
          c < 128 ? i += "��" : i += String.fromCharCode(c), a += 3;
          continue;
        }
      }
      if ((s & 240) === 224 && a + 6 < o) {
        const l = parseInt(r.slice(a + 4, a + 6), 16), c = parseInt(r.slice(a + 7, a + 9), 16);
        if ((l & 192) === 128 && (c & 192) === 128) {
          const u = s << 12 & 61440 | l << 6 & 4032 | c & 63;
          u < 2048 || u >= 55296 && u <= 57343 ? i += "���" : i += String.fromCharCode(u), a += 6;
          continue;
        }
      }
      if ((s & 248) === 240 && a + 9 < o) {
        const l = parseInt(r.slice(a + 4, a + 6), 16), c = parseInt(r.slice(a + 7, a + 9), 16), u = parseInt(r.slice(a + 10, a + 12), 16);
        if ((l & 192) === 128 && (c & 192) === 128 && (u & 192) === 128) {
          let d = s << 18 & 1835008 | l << 12 & 258048 | c << 6 & 4032 | u & 63;
          d < 65536 || d > 1114111 ? i += "����" : (d -= 65536, i += String.fromCharCode(55296 + (d >> 10), 56320 + (d & 1023))), a += 9;
          continue;
        }
      }
      i += "�";
    }
    return i;
  });
}
id.defaultChars = ";/?:@&=+$,#";
id.componentChars = "";
const uI = {};
function z9t(t) {
  let e = uI[t];
  if (e)
    return e;
  e = uI[t] = [];
  for (let n = 0; n < 128; n++) {
    const r = String.fromCharCode(n);
    /^[0-9a-z]$/i.test(r) ? e.push(r) : e.push("%" + ("0" + n.toString(16).toUpperCase()).slice(-2));
  }
  for (let n = 0; n < t.length; n++)
    e[t.charCodeAt(n)] = t[n];
  return e;
}
function Vp(t, e, n) {
  typeof e != "string" && (n = e, e = Vp.defaultChars), typeof n > "u" && (n = !0);
  const r = z9t(e);
  let i = "";
  for (let a = 0, o = t.length; a < o; a++) {
    const s = t.charCodeAt(a);
    if (n && s === 37 && a + 2 < o && /^[0-9a-f]{2}$/i.test(t.slice(a + 1, a + 3))) {
      i += t.slice(a, a + 3), a += 2;
      continue;
    }
    if (s < 128) {
      i += r[s];
      continue;
    }
    if (s >= 55296 && s <= 57343) {
      if (s >= 55296 && s <= 56319 && a + 1 < o) {
        const l = t.charCodeAt(a + 1);
        if (l >= 56320 && l <= 57343) {
          i += encodeURIComponent(t[a] + t[a + 1]), a++;
          continue;
        }
      }
      i += "%EF%BF%BD";
      continue;
    }
    i += encodeURIComponent(t[a]);
  }
  return i;
}
Vp.defaultChars = ";/?:@&=+$,-_.!~*'()#";
Vp.componentChars = "-_.!~*'()";
function CA(t) {
  let e = "";
  return e += t.protocol || "", e += t.slashes ? "//" : "", e += t.auth ? t.auth + "@" : "", t.hostname && t.hostname.indexOf(":") !== -1 ? e += "[" + t.hostname + "]" : e += t.hostname || "", e += t.port ? ":" + t.port : "", e += t.pathname || "", e += t.search || "", e += t.hash || "", e;
}
function n3() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
const R9t = /^([a-z0-9.+-]+:)/i, O9t = /:[0-9]*$/, B9t = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, H9t = ["<", ">", '"', "`", " ", "\r", `
`, "	"], F9t = ["{", "}", "|", "\\", "^", "`"].concat(H9t), _9t = ["'"].concat(F9t), dI = ["%", "/", "?", ";", "#"].concat(_9t), fI = ["/", "?", "#"], V9t = 255, hI = /^[+a-z0-9A-Z_-]{0,63}$/, q9t = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, pI = {
  javascript: !0,
  "javascript:": !0
}, mI = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function AA(t, e) {
  if (t && t instanceof n3) return t;
  const n = new n3();
  return n.parse(t, e), n;
}
n3.prototype.parse = function(t, e) {
  let n, r, i, a = t;
  if (a = a.trim(), !e && t.split("#").length === 1) {
    const c = B9t.exec(a);
    if (c)
      return this.pathname = c[1], c[2] && (this.search = c[2]), this;
  }
  let o = R9t.exec(a);
  if (o && (o = o[0], n = o.toLowerCase(), this.protocol = o, a = a.substr(o.length)), (e || o || a.match(/^\/\/[^@\/]+@[^@\/]+/)) && (i = a.substr(0, 2) === "//", i && !(o && pI[o]) && (a = a.substr(2), this.slashes = !0)), !pI[o] && (i || o && !mI[o])) {
    let c = -1;
    for (let p = 0; p < fI.length; p++)
      r = a.indexOf(fI[p]), r !== -1 && (c === -1 || r < c) && (c = r);
    let u, d;
    c === -1 ? d = a.lastIndexOf("@") : d = a.lastIndexOf("@", c), d !== -1 && (u = a.slice(0, d), a = a.slice(d + 1), this.auth = u), c = -1;
    for (let p = 0; p < dI.length; p++)
      r = a.indexOf(dI[p]), r !== -1 && (c === -1 || r < c) && (c = r);
    c === -1 && (c = a.length), a[c - 1] === ":" && c--;
    const f = a.slice(0, c);
    a = a.slice(c), this.parseHost(f), this.hostname = this.hostname || "";
    const h = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!h) {
      const p = this.hostname.split(/\./);
      for (let m = 0, g = p.length; m < g; m++) {
        const v = p[m];
        if (v && !v.match(hI)) {
          let k = "";
          for (let w = 0, b = v.length; w < b; w++)
            v.charCodeAt(w) > 127 ? k += "x" : k += v[w];
          if (!k.match(hI)) {
            const w = p.slice(0, m), b = p.slice(m + 1), x = v.match(q9t);
            x && (w.push(x[1]), b.unshift(x[2])), b.length && (a = b.join(".") + a), this.hostname = w.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > V9t && (this.hostname = ""), h && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  const s = a.indexOf("#");
  s !== -1 && (this.hash = a.substr(s), a = a.slice(0, s));
  const l = a.indexOf("?");
  return l !== -1 && (this.search = a.substr(l), a = a.slice(0, l)), a && (this.pathname = a), mI[n] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
n3.prototype.parseHost = function(t) {
  let e = O9t.exec(t);
  e && (e = e[0], e !== ":" && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
};
const U9t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: id,
  encode: Vp,
  format: CA,
  parse: AA
}, Symbol.toStringTag, { value: "Module" })), V$ = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, q$ = /[\0-\x1F\x7F-\x9F]/, W9t = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/, SA = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, U$ = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/, W$ = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/, Z9t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any: V$,
  Cc: q$,
  Cf: W9t,
  P: SA,
  S: U$,
  Z: W$
}, Symbol.toStringTag, { value: "Module" })), G9t = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((t) => t.charCodeAt(0))
), Y9t = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((t) => t.charCodeAt(0))
);
var mv;
const K9t = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), $9t = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (mv = String.fromCodePoint) !== null && mv !== void 0 ? mv : function(t) {
    let e = "";
    return t > 65535 && (t -= 65536, e += String.fromCharCode(t >>> 10 & 1023 | 55296), t = 56320 | t & 1023), e += String.fromCharCode(t), e;
  }
);
function J9t(t) {
  var e;
  return t >= 55296 && t <= 57343 || t > 1114111 ? 65533 : (e = K9t.get(t)) !== null && e !== void 0 ? e : t;
}
var Mr;
(function(t) {
  t[t.NUM = 35] = "NUM", t[t.SEMI = 59] = "SEMI", t[t.EQUALS = 61] = "EQUALS", t[t.ZERO = 48] = "ZERO", t[t.NINE = 57] = "NINE", t[t.LOWER_A = 97] = "LOWER_A", t[t.LOWER_F = 102] = "LOWER_F", t[t.LOWER_X = 120] = "LOWER_X", t[t.LOWER_Z = 122] = "LOWER_Z", t[t.UPPER_A = 65] = "UPPER_A", t[t.UPPER_F = 70] = "UPPER_F", t[t.UPPER_Z = 90] = "UPPER_Z";
})(Mr || (Mr = {}));
const Q9t = 32;
var ac;
(function(t) {
  t[t.VALUE_LENGTH = 49152] = "VALUE_LENGTH", t[t.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", t[t.JUMP_TABLE = 127] = "JUMP_TABLE";
})(ac || (ac = {}));
function gw(t) {
  return t >= Mr.ZERO && t <= Mr.NINE;
}
function X9t(t) {
  return t >= Mr.UPPER_A && t <= Mr.UPPER_F || t >= Mr.LOWER_A && t <= Mr.LOWER_F;
}
function ewt(t) {
  return t >= Mr.UPPER_A && t <= Mr.UPPER_Z || t >= Mr.LOWER_A && t <= Mr.LOWER_Z || gw(t);
}
function twt(t) {
  return t === Mr.EQUALS || ewt(t);
}
var gr;
(function(t) {
  t[t.EntityStart = 0] = "EntityStart", t[t.NumericStart = 1] = "NumericStart", t[t.NumericDecimal = 2] = "NumericDecimal", t[t.NumericHex = 3] = "NumericHex", t[t.NamedEntity = 4] = "NamedEntity";
})(gr || (gr = {}));
var Ql;
(function(t) {
  t[t.Legacy = 0] = "Legacy", t[t.Strict = 1] = "Strict", t[t.Attribute = 2] = "Attribute";
})(Ql || (Ql = {}));
class nwt {
  constructor(e, n, r) {
    this.decodeTree = e, this.emitCodePoint = n, this.errors = r, this.state = gr.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Ql.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(e) {
    this.decodeMode = e, this.state = gr.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(e, n) {
    switch (this.state) {
      case gr.EntityStart:
        return e.charCodeAt(n) === Mr.NUM ? (this.state = gr.NumericStart, this.consumed += 1, this.stateNumericStart(e, n + 1)) : (this.state = gr.NamedEntity, this.stateNamedEntity(e, n));
      case gr.NumericStart:
        return this.stateNumericStart(e, n);
      case gr.NumericDecimal:
        return this.stateNumericDecimal(e, n);
      case gr.NumericHex:
        return this.stateNumericHex(e, n);
      case gr.NamedEntity:
        return this.stateNamedEntity(e, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(e, n) {
    return n >= e.length ? -1 : (e.charCodeAt(n) | Q9t) === Mr.LOWER_X ? (this.state = gr.NumericHex, this.consumed += 1, this.stateNumericHex(e, n + 1)) : (this.state = gr.NumericDecimal, this.stateNumericDecimal(e, n));
  }
  addToNumericResult(e, n, r, i) {
    if (n !== r) {
      const a = r - n;
      this.result = this.result * Math.pow(i, a) + parseInt(e.substr(n, a), i), this.consumed += a;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(e, n) {
    const r = n;
    for (; n < e.length; ) {
      const i = e.charCodeAt(n);
      if (gw(i) || X9t(i))
        n += 1;
      else
        return this.addToNumericResult(e, r, n, 16), this.emitNumericEntity(i, 3);
    }
    return this.addToNumericResult(e, r, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(e, n) {
    const r = n;
    for (; n < e.length; ) {
      const i = e.charCodeAt(n);
      if (gw(i))
        n += 1;
      else
        return this.addToNumericResult(e, r, n, 10), this.emitNumericEntity(i, 2);
    }
    return this.addToNumericResult(e, r, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(e, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (e === Mr.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Ql.Strict)
      return 0;
    return this.emitCodePoint(J9t(this.result), this.consumed), this.errors && (e !== Mr.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(e, n) {
    const { decodeTree: r } = this;
    let i = r[this.treeIndex], a = (i & ac.VALUE_LENGTH) >> 14;
    for (; n < e.length; n++, this.excess++) {
      const o = e.charCodeAt(n);
      if (this.treeIndex = rwt(r, i, this.treeIndex + Math.max(1, a), o), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Ql.Attribute && // We shouldn't have consumed any characters after the entity,
        (a === 0 || // And there should be no invalid characters.
        twt(o)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (i = r[this.treeIndex], a = (i & ac.VALUE_LENGTH) >> 14, a !== 0) {
        if (o === Mr.SEMI)
          return this.emitNamedEntityData(this.treeIndex, a, this.consumed + this.excess);
        this.decodeMode !== Ql.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var e;
    const { result: n, decodeTree: r } = this, i = (r[n] & ac.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, i, this.consumed), (e = this.errors) === null || e === void 0 || e.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(e, n, r) {
    const { decodeTree: i } = this;
    return this.emitCodePoint(n === 1 ? i[e] & ~ac.VALUE_LENGTH : i[e + 1], r), n === 3 && this.emitCodePoint(i[e + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var e;
    switch (this.state) {
      case gr.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Ql.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case gr.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case gr.NumericHex:
        return this.emitNumericEntity(0, 3);
      case gr.NumericStart:
        return (e = this.errors) === null || e === void 0 || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case gr.EntityStart:
        return 0;
    }
  }
}
function Z$(t) {
  let e = "";
  const n = new nwt(t, (r) => e += $9t(r));
  return function(i, a) {
    let o = 0, s = 0;
    for (; (s = i.indexOf("&", s)) >= 0; ) {
      e += i.slice(o, s), n.startEntity(a);
      const c = n.write(
        i,
        // Skip the "&"
        s + 1
      );
      if (c < 0) {
        o = s + n.end();
        break;
      }
      o = s + c, s = c === 0 ? o + 1 : o;
    }
    const l = e + i.slice(o);
    return e = "", l;
  };
}
function rwt(t, e, n, r) {
  const i = (e & ac.BRANCH_LENGTH) >> 7, a = e & ac.JUMP_TABLE;
  if (i === 0)
    return a !== 0 && r === a ? n : -1;
  if (a) {
    const l = r - a;
    return l < 0 || l >= i ? -1 : t[n + l] - 1;
  }
  let o = n, s = o + i - 1;
  for (; o <= s; ) {
    const l = o + s >>> 1, c = t[l];
    if (c < r)
      o = l + 1;
    else if (c > r)
      s = l - 1;
    else
      return t[l + i];
  }
  return -1;
}
const iwt = Z$(G9t);
Z$(Y9t);
function G$(t, e = Ql.Legacy) {
  return iwt(t, e);
}
function awt(t) {
  return Object.prototype.toString.call(t);
}
function LA(t) {
  return awt(t) === "[object String]";
}
const owt = Object.prototype.hasOwnProperty;
function swt(t, e) {
  return owt.call(t, e);
}
function X6(t) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(n) {
    if (n) {
      if (typeof n != "object")
        throw new TypeError(n + "must be object");
      Object.keys(n).forEach(function(r) {
        t[r] = n[r];
      });
    }
  }), t;
}
function Y$(t, e, n) {
  return [].concat(t.slice(0, e), n, t.slice(e + 1));
}
function TA(t) {
  return !(t >= 55296 && t <= 57343 || t >= 64976 && t <= 65007 || (t & 65535) === 65535 || (t & 65535) === 65534 || t >= 0 && t <= 8 || t === 11 || t >= 14 && t <= 31 || t >= 127 && t <= 159 || t > 1114111);
}
function r3(t) {
  if (t > 65535) {
    t -= 65536;
    const e = 55296 + (t >> 10), n = 56320 + (t & 1023);
    return String.fromCharCode(e, n);
  }
  return String.fromCharCode(t);
}
const K$ = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, lwt = /&([a-z#][a-z0-9]{1,31});/gi, cwt = new RegExp(K$.source + "|" + lwt.source, "gi"), uwt = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function dwt(t, e) {
  if (e.charCodeAt(0) === 35 && uwt.test(e)) {
    const r = e[1].toLowerCase() === "x" ? parseInt(e.slice(2), 16) : parseInt(e.slice(1), 10);
    return TA(r) ? r3(r) : t;
  }
  const n = G$(t);
  return n !== t ? n : t;
}
function fwt(t) {
  return t.indexOf("\\") < 0 ? t : t.replace(K$, "$1");
}
function ad(t) {
  return t.indexOf("\\") < 0 && t.indexOf("&") < 0 ? t : t.replace(cwt, function(e, n, r) {
    return n || dwt(e, r);
  });
}
const hwt = /[&<>"]/, pwt = /[&<>"]/g, mwt = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;"
};
function ywt(t) {
  return mwt[t];
}
function Sc(t) {
  return hwt.test(t) ? t.replace(pwt, ywt) : t;
}
const gwt = /[.?*+^$[\]\\(){}|-]/g;
function vwt(t) {
  return t.replace(gwt, "\\$&");
}
function bn(t) {
  switch (t) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function x2(t) {
  if (t >= 8192 && t <= 8202)
    return !0;
  switch (t) {
    case 9:
    case 10:
    case 11:
    case 12:
    case 13:
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function M2(t) {
  return SA.test(t) || U$.test(t);
}
function C2(t) {
  switch (t) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function e5(t) {
  return t = t.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (t = t.replace(/ẞ/g, "ß")), t.toLowerCase().toUpperCase();
}
const bwt = { mdurl: U9t, ucmicro: Z9t }, wwt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayReplaceAt: Y$,
  assign: X6,
  escapeHtml: Sc,
  escapeRE: vwt,
  fromCodePoint: r3,
  has: swt,
  isMdAsciiPunct: C2,
  isPunctChar: M2,
  isSpace: bn,
  isString: LA,
  isValidEntityCode: TA,
  isWhiteSpace: x2,
  lib: bwt,
  normalizeReference: e5,
  unescapeAll: ad,
  unescapeMd: fwt
}, Symbol.toStringTag, { value: "Module" }));
function kwt(t, e, n) {
  let r, i, a, o;
  const s = t.posMax, l = t.pos;
  for (t.pos = e + 1, r = 1; t.pos < s; ) {
    if (a = t.src.charCodeAt(t.pos), a === 93 && (r--, r === 0)) {
      i = !0;
      break;
    }
    if (o = t.pos, t.md.inline.skipToken(t), a === 91) {
      if (o === t.pos - 1)
        r++;
      else if (n)
        return t.pos = l, -1;
    }
  }
  let c = -1;
  return i && (c = t.pos), t.pos = l, c;
}
function xwt(t, e, n) {
  let r, i = e;
  const a = {
    ok: !1,
    pos: 0,
    str: ""
  };
  if (t.charCodeAt(i) === 60) {
    for (i++; i < n; ) {
      if (r = t.charCodeAt(i), r === 10 || r === 60)
        return a;
      if (r === 62)
        return a.pos = i + 1, a.str = ad(t.slice(e + 1, i)), a.ok = !0, a;
      if (r === 92 && i + 1 < n) {
        i += 2;
        continue;
      }
      i++;
    }
    return a;
  }
  let o = 0;
  for (; i < n && (r = t.charCodeAt(i), !(r === 32 || r < 32 || r === 127)); ) {
    if (r === 92 && i + 1 < n) {
      if (t.charCodeAt(i + 1) === 32)
        break;
      i += 2;
      continue;
    }
    if (r === 40 && (o++, o > 32))
      return a;
    if (r === 41) {
      if (o === 0)
        break;
      o--;
    }
    i++;
  }
  return e === i || o !== 0 || (a.str = ad(t.slice(e, i)), a.pos = i, a.ok = !0), a;
}
function Mwt(t, e, n, r) {
  let i, a = e;
  const o = {
    // if `true`, this is a valid link title
    ok: !1,
    // if `true`, this link can be continued on the next line
    can_continue: !1,
    // if `ok`, it's the position of the first character after the closing marker
    pos: 0,
    // if `ok`, it's the unescaped title
    str: "",
    // expected closing marker character code
    marker: 0
  };
  if (r)
    o.str = r.str, o.marker = r.marker;
  else {
    if (a >= n)
      return o;
    let s = t.charCodeAt(a);
    if (s !== 34 && s !== 39 && s !== 40)
      return o;
    e++, a++, s === 40 && (s = 41), o.marker = s;
  }
  for (; a < n; ) {
    if (i = t.charCodeAt(a), i === o.marker)
      return o.pos = a + 1, o.str += ad(t.slice(e, a)), o.ok = !0, o;
    if (i === 40 && o.marker === 41)
      return o;
    i === 92 && a + 1 < n && a++, a++;
  }
  return o.can_continue = !0, o.str += ad(t.slice(e, a)), o;
}
const Cwt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  parseLinkDestination: xwt,
  parseLinkLabel: kwt,
  parseLinkTitle: Mwt
}, Symbol.toStringTag, { value: "Module" })), ps = {};
ps.code_inline = function(t, e, n, r, i) {
  const a = t[e];
  return "<code" + i.renderAttrs(a) + ">" + Sc(a.content) + "</code>";
};
ps.code_block = function(t, e, n, r, i) {
  const a = t[e];
  return "<pre" + i.renderAttrs(a) + "><code>" + Sc(t[e].content) + `</code></pre>
`;
};
ps.fence = function(t, e, n, r, i) {
  const a = t[e], o = a.info ? ad(a.info).trim() : "";
  let s = "", l = "";
  if (o) {
    const u = o.split(/(\s+)/g);
    s = u[0], l = u.slice(2).join("");
  }
  let c;
  if (n.highlight ? c = n.highlight(a.content, s, l) || Sc(a.content) : c = Sc(a.content), c.indexOf("<pre") === 0)
    return c + `
`;
  if (o) {
    const u = a.attrIndex("class"), d = a.attrs ? a.attrs.slice() : [];
    u < 0 ? d.push(["class", n.langPrefix + s]) : (d[u] = d[u].slice(), d[u][1] += " " + n.langPrefix + s);
    const f = {
      attrs: d
    };
    return `<pre><code${i.renderAttrs(f)}>${c}</code></pre>
`;
  }
  return `<pre><code${i.renderAttrs(a)}>${c}</code></pre>
`;
};
ps.image = function(t, e, n, r, i) {
  const a = t[e];
  return a.attrs[a.attrIndex("alt")][1] = i.renderInlineAsText(a.children, n, r), i.renderToken(t, e, n);
};
ps.hardbreak = function(t, e, n) {
  return n.xhtmlOut ? `<br />
` : `<br>
`;
};
ps.softbreak = function(t, e, n) {
  return n.breaks ? n.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
ps.text = function(t, e) {
  return Sc(t[e].content);
};
ps.html_block = function(t, e) {
  return t[e].content;
};
ps.html_inline = function(t, e) {
  return t[e].content;
};
function _d() {
  this.rules = X6({}, ps);
}
_d.prototype.renderAttrs = function(e) {
  let n, r, i;
  if (!e.attrs)
    return "";
  for (i = "", n = 0, r = e.attrs.length; n < r; n++)
    i += " " + Sc(e.attrs[n][0]) + '="' + Sc(e.attrs[n][1]) + '"';
  return i;
};
_d.prototype.renderToken = function(e, n, r) {
  const i = e[n];
  let a = "";
  if (i.hidden)
    return "";
  i.block && i.nesting !== -1 && n && e[n - 1].hidden && (a += `
`), a += (i.nesting === -1 ? "</" : "<") + i.tag, a += this.renderAttrs(i), i.nesting === 0 && r.xhtmlOut && (a += " /");
  let o = !1;
  if (i.block && (o = !0, i.nesting === 1 && n + 1 < e.length)) {
    const s = e[n + 1];
    (s.type === "inline" || s.hidden || s.nesting === -1 && s.tag === i.tag) && (o = !1);
  }
  return a += o ? `>
` : ">", a;
};
_d.prototype.renderInline = function(t, e, n) {
  let r = "";
  const i = this.rules;
  for (let a = 0, o = t.length; a < o; a++) {
    const s = t[a].type;
    typeof i[s] < "u" ? r += i[s](t, a, e, n, this) : r += this.renderToken(t, a, e);
  }
  return r;
};
_d.prototype.renderInlineAsText = function(t, e, n) {
  let r = "";
  for (let i = 0, a = t.length; i < a; i++)
    switch (t[i].type) {
      case "text":
        r += t[i].content;
        break;
      case "image":
        r += this.renderInlineAsText(t[i].children, e, n);
        break;
      case "html_inline":
      case "html_block":
        r += t[i].content;
        break;
      case "softbreak":
      case "hardbreak":
        r += `
`;
        break;
    }
  return r;
};
_d.prototype.render = function(t, e, n) {
  let r = "";
  const i = this.rules;
  for (let a = 0, o = t.length; a < o; a++) {
    const s = t[a].type;
    s === "inline" ? r += this.renderInline(t[a].children, e, n) : typeof i[s] < "u" ? r += i[s](t, a, e, n, this) : r += this.renderToken(t, a, e, n);
  }
  return r;
};
function Ii() {
  this.__rules__ = [], this.__cache__ = null;
}
Ii.prototype.__find__ = function(t) {
  for (let e = 0; e < this.__rules__.length; e++)
    if (this.__rules__[e].name === t)
      return e;
  return -1;
};
Ii.prototype.__compile__ = function() {
  const t = this, e = [""];
  t.__rules__.forEach(function(n) {
    n.enabled && n.alt.forEach(function(r) {
      e.indexOf(r) < 0 && e.push(r);
    });
  }), t.__cache__ = {}, e.forEach(function(n) {
    t.__cache__[n] = [], t.__rules__.forEach(function(r) {
      r.enabled && (n && r.alt.indexOf(n) < 0 || t.__cache__[n].push(r.fn));
    });
  });
};
Ii.prototype.at = function(t, e, n) {
  const r = this.__find__(t), i = n || {};
  if (r === -1)
    throw new Error("Parser rule not found: " + t);
  this.__rules__[r].fn = e, this.__rules__[r].alt = i.alt || [], this.__cache__ = null;
};
Ii.prototype.before = function(t, e, n, r) {
  const i = this.__find__(t), a = r || {};
  if (i === -1)
    throw new Error("Parser rule not found: " + t);
  this.__rules__.splice(i, 0, {
    name: e,
    enabled: !0,
    fn: n,
    alt: a.alt || []
  }), this.__cache__ = null;
};
Ii.prototype.after = function(t, e, n, r) {
  const i = this.__find__(t), a = r || {};
  if (i === -1)
    throw new Error("Parser rule not found: " + t);
  this.__rules__.splice(i + 1, 0, {
    name: e,
    enabled: !0,
    fn: n,
    alt: a.alt || []
  }), this.__cache__ = null;
};
Ii.prototype.push = function(t, e, n) {
  const r = n || {};
  this.__rules__.push({
    name: t,
    enabled: !0,
    fn: e,
    alt: r.alt || []
  }), this.__cache__ = null;
};
Ii.prototype.enable = function(t, e) {
  Array.isArray(t) || (t = [t]);
  const n = [];
  return t.forEach(function(r) {
    const i = this.__find__(r);
    if (i < 0) {
      if (e)
        return;
      throw new Error("Rules manager: invalid rule name " + r);
    }
    this.__rules__[i].enabled = !0, n.push(r);
  }, this), this.__cache__ = null, n;
};
Ii.prototype.enableOnly = function(t, e) {
  Array.isArray(t) || (t = [t]), this.__rules__.forEach(function(n) {
    n.enabled = !1;
  }), this.enable(t, e);
};
Ii.prototype.disable = function(t, e) {
  Array.isArray(t) || (t = [t]);
  const n = [];
  return t.forEach(function(r) {
    const i = this.__find__(r);
    if (i < 0) {
      if (e)
        return;
      throw new Error("Rules manager: invalid rule name " + r);
    }
    this.__rules__[i].enabled = !1, n.push(r);
  }, this), this.__cache__ = null, n;
};
Ii.prototype.getRules = function(t) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[t] || [];
};
function wo(t, e, n) {
  this.type = t, this.tag = e, this.attrs = null, this.map = null, this.nesting = n, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
wo.prototype.attrIndex = function(e) {
  if (!this.attrs)
    return -1;
  const n = this.attrs;
  for (let r = 0, i = n.length; r < i; r++)
    if (n[r][0] === e)
      return r;
  return -1;
};
wo.prototype.attrPush = function(e) {
  this.attrs ? this.attrs.push(e) : this.attrs = [e];
};
wo.prototype.attrSet = function(e, n) {
  const r = this.attrIndex(e), i = [e, n];
  r < 0 ? this.attrPush(i) : this.attrs[r] = i;
};
wo.prototype.attrGet = function(e) {
  const n = this.attrIndex(e);
  let r = null;
  return n >= 0 && (r = this.attrs[n][1]), r;
};
wo.prototype.attrJoin = function(e, n) {
  const r = this.attrIndex(e);
  r < 0 ? this.attrPush([e, n]) : this.attrs[r][1] = this.attrs[r][1] + " " + n;
};
function $$(t, e, n) {
  this.src = t, this.env = n, this.tokens = [], this.inlineMode = !1, this.md = e;
}
$$.prototype.Token = wo;
const Awt = /\r\n?|\n/g, Swt = /\0/g;
function Lwt(t) {
  let e;
  e = t.src.replace(Awt, `
`), e = e.replace(Swt, "�"), t.src = e;
}
function Twt(t) {
  let e;
  t.inlineMode ? (e = new t.Token("inline", "", 0), e.content = t.src, e.map = [0, 1], e.children = [], t.tokens.push(e)) : t.md.block.parse(t.src, t.md, t.env, t.tokens);
}
function Ewt(t) {
  const e = t.tokens;
  for (let n = 0, r = e.length; n < r; n++) {
    const i = e[n];
    i.type === "inline" && t.md.inline.parse(i.content, t.md, t.env, i.children);
  }
}
function jwt(t) {
  return /^<a[>\s]/i.test(t);
}
function Nwt(t) {
  return /^<\/a\s*>/i.test(t);
}
function Dwt(t) {
  const e = t.tokens;
  if (t.md.options.linkify)
    for (let n = 0, r = e.length; n < r; n++) {
      if (e[n].type !== "inline" || !t.md.linkify.pretest(e[n].content))
        continue;
      let i = e[n].children, a = 0;
      for (let o = i.length - 1; o >= 0; o--) {
        const s = i[o];
        if (s.type === "link_close") {
          for (o--; i[o].level !== s.level && i[o].type !== "link_open"; )
            o--;
          continue;
        }
        if (s.type === "html_inline" && (jwt(s.content) && a > 0 && a--, Nwt(s.content) && a++), !(a > 0) && s.type === "text" && t.md.linkify.test(s.content)) {
          const l = s.content;
          let c = t.md.linkify.match(l);
          const u = [];
          let d = s.level, f = 0;
          c.length > 0 && c[0].index === 0 && o > 0 && i[o - 1].type === "text_special" && (c = c.slice(1));
          for (let h = 0; h < c.length; h++) {
            const p = c[h].url, m = t.md.normalizeLink(p);
            if (!t.md.validateLink(m))
              continue;
            let g = c[h].text;
            c[h].schema ? c[h].schema === "mailto:" && !/^mailto:/i.test(g) ? g = t.md.normalizeLinkText("mailto:" + g).replace(/^mailto:/, "") : g = t.md.normalizeLinkText(g) : g = t.md.normalizeLinkText("http://" + g).replace(/^http:\/\//, "");
            const v = c[h].index;
            if (v > f) {
              const x = new t.Token("text", "", 0);
              x.content = l.slice(f, v), x.level = d, u.push(x);
            }
            const k = new t.Token("link_open", "a", 1);
            k.attrs = [["href", m]], k.level = d++, k.markup = "linkify", k.info = "auto", u.push(k);
            const w = new t.Token("text", "", 0);
            w.content = g, w.level = d, u.push(w);
            const b = new t.Token("link_close", "a", -1);
            b.level = --d, b.markup = "linkify", b.info = "auto", u.push(b), f = c[h].lastIndex;
          }
          if (f < l.length) {
            const h = new t.Token("text", "", 0);
            h.content = l.slice(f), h.level = d, u.push(h);
          }
          e[n].children = i = Y$(i, o, u);
        }
      }
    }
}
const J$ = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, Iwt = /\((c|tm|r)\)/i, Pwt = /\((c|tm|r)\)/ig, zwt = {
  c: "©",
  r: "®",
  tm: "™"
};
function Rwt(t, e) {
  return zwt[e.toLowerCase()];
}
function Owt(t) {
  let e = 0;
  for (let n = t.length - 1; n >= 0; n--) {
    const r = t[n];
    r.type === "text" && !e && (r.content = r.content.replace(Pwt, Rwt)), r.type === "link_open" && r.info === "auto" && e--, r.type === "link_close" && r.info === "auto" && e++;
  }
}
function Bwt(t) {
  let e = 0;
  for (let n = t.length - 1; n >= 0; n--) {
    const r = t[n];
    r.type === "text" && !e && J$.test(r.content) && (r.content = r.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), r.type === "link_open" && r.info === "auto" && e--, r.type === "link_close" && r.info === "auto" && e++;
  }
}
function Hwt(t) {
  let e;
  if (t.md.options.typographer)
    for (e = t.tokens.length - 1; e >= 0; e--)
      t.tokens[e].type === "inline" && (Iwt.test(t.tokens[e].content) && Owt(t.tokens[e].children), J$.test(t.tokens[e].content) && Bwt(t.tokens[e].children));
}
const Fwt = /['"]/, yI = /['"]/g, gI = "’";
function Gm(t, e, n) {
  return t.slice(0, e) + n + t.slice(e + 1);
}
function _wt(t, e) {
  let n;
  const r = [];
  for (let i = 0; i < t.length; i++) {
    const a = t[i], o = t[i].level;
    for (n = r.length - 1; n >= 0 && !(r[n].level <= o); n--)
      ;
    if (r.length = n + 1, a.type !== "text")
      continue;
    let s = a.content, l = 0, c = s.length;
    e:
      for (; l < c; ) {
        yI.lastIndex = l;
        const u = yI.exec(s);
        if (!u)
          break;
        let d = !0, f = !0;
        l = u.index + 1;
        const h = u[0] === "'";
        let p = 32;
        if (u.index - 1 >= 0)
          p = s.charCodeAt(u.index - 1);
        else
          for (n = i - 1; n >= 0 && !(t[n].type === "softbreak" || t[n].type === "hardbreak"); n--)
            if (t[n].content) {
              p = t[n].content.charCodeAt(t[n].content.length - 1);
              break;
            }
        let m = 32;
        if (l < c)
          m = s.charCodeAt(l);
        else
          for (n = i + 1; n < t.length && !(t[n].type === "softbreak" || t[n].type === "hardbreak"); n++)
            if (t[n].content) {
              m = t[n].content.charCodeAt(0);
              break;
            }
        const g = C2(p) || M2(String.fromCharCode(p)), v = C2(m) || M2(String.fromCharCode(m)), k = x2(p), w = x2(m);
        if (w ? d = !1 : v && (k || g || (d = !1)), k ? f = !1 : g && (w || v || (f = !1)), m === 34 && u[0] === '"' && p >= 48 && p <= 57 && (f = d = !1), d && f && (d = g, f = v), !d && !f) {
          h && (a.content = Gm(a.content, u.index, gI));
          continue;
        }
        if (f)
          for (n = r.length - 1; n >= 0; n--) {
            let b = r[n];
            if (r[n].level < o)
              break;
            if (b.single === h && r[n].level === o) {
              b = r[n];
              let x, A;
              h ? (x = e.md.options.quotes[2], A = e.md.options.quotes[3]) : (x = e.md.options.quotes[0], A = e.md.options.quotes[1]), a.content = Gm(a.content, u.index, A), t[b.token].content = Gm(
                t[b.token].content,
                b.pos,
                x
              ), l += A.length - 1, b.token === i && (l += x.length - 1), s = a.content, c = s.length, r.length = n;
              continue e;
            }
          }
        d ? r.push({
          token: i,
          pos: u.index,
          single: h,
          level: o
        }) : f && h && (a.content = Gm(a.content, u.index, gI));
      }
  }
}
function Vwt(t) {
  if (t.md.options.typographer)
    for (let e = t.tokens.length - 1; e >= 0; e--)
      t.tokens[e].type !== "inline" || !Fwt.test(t.tokens[e].content) || _wt(t.tokens[e].children, t);
}
function qwt(t) {
  let e, n;
  const r = t.tokens, i = r.length;
  for (let a = 0; a < i; a++) {
    if (r[a].type !== "inline") continue;
    const o = r[a].children, s = o.length;
    for (e = 0; e < s; e++)
      o[e].type === "text_special" && (o[e].type = "text");
    for (e = n = 0; e < s; e++)
      o[e].type === "text" && e + 1 < s && o[e + 1].type === "text" ? o[e + 1].content = o[e].content + o[e + 1].content : (e !== n && (o[n] = o[e]), n++);
    e !== n && (o.length = n);
  }
}
const yv = [
  ["normalize", Lwt],
  ["block", Twt],
  ["inline", Ewt],
  ["linkify", Dwt],
  ["replacements", Hwt],
  ["smartquotes", Vwt],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", qwt]
];
function EA() {
  this.ruler = new Ii();
  for (let t = 0; t < yv.length; t++)
    this.ruler.push(yv[t][0], yv[t][1]);
}
EA.prototype.process = function(t) {
  const e = this.ruler.getRules("");
  for (let n = 0, r = e.length; n < r; n++)
    e[n](t);
};
EA.prototype.State = $$;
function ms(t, e, n, r) {
  this.src = t, this.md = e, this.env = n, this.tokens = r, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
  const i = this.src;
  for (let a = 0, o = 0, s = 0, l = 0, c = i.length, u = !1; o < c; o++) {
    const d = i.charCodeAt(o);
    if (!u)
      if (bn(d)) {
        s++, d === 9 ? l += 4 - l % 4 : l++;
        continue;
      } else
        u = !0;
    (d === 10 || o === c - 1) && (d !== 10 && o++, this.bMarks.push(a), this.eMarks.push(o), this.tShift.push(s), this.sCount.push(l), this.bsCount.push(0), u = !1, s = 0, l = 0, a = o + 1);
  }
  this.bMarks.push(i.length), this.eMarks.push(i.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
ms.prototype.push = function(t, e, n) {
  const r = new wo(t, e, n);
  return r.block = !0, n < 0 && this.level--, r.level = this.level, n > 0 && this.level++, this.tokens.push(r), r;
};
ms.prototype.isEmpty = function(e) {
  return this.bMarks[e] + this.tShift[e] >= this.eMarks[e];
};
ms.prototype.skipEmptyLines = function(e) {
  for (let n = this.lineMax; e < n && !(this.bMarks[e] + this.tShift[e] < this.eMarks[e]); e++)
    ;
  return e;
};
ms.prototype.skipSpaces = function(e) {
  for (let n = this.src.length; e < n; e++) {
    const r = this.src.charCodeAt(e);
    if (!bn(r))
      break;
  }
  return e;
};
ms.prototype.skipSpacesBack = function(e, n) {
  if (e <= n)
    return e;
  for (; e > n; )
    if (!bn(this.src.charCodeAt(--e)))
      return e + 1;
  return e;
};
ms.prototype.skipChars = function(e, n) {
  for (let r = this.src.length; e < r && this.src.charCodeAt(e) === n; e++)
    ;
  return e;
};
ms.prototype.skipCharsBack = function(e, n, r) {
  if (e <= r)
    return e;
  for (; e > r; )
    if (n !== this.src.charCodeAt(--e))
      return e + 1;
  return e;
};
ms.prototype.getLines = function(e, n, r, i) {
  if (e >= n)
    return "";
  const a = new Array(n - e);
  for (let o = 0, s = e; s < n; s++, o++) {
    let l = 0;
    const c = this.bMarks[s];
    let u = c, d;
    for (s + 1 < n || i ? d = this.eMarks[s] + 1 : d = this.eMarks[s]; u < d && l < r; ) {
      const f = this.src.charCodeAt(u);
      if (bn(f))
        f === 9 ? l += 4 - (l + this.bsCount[s]) % 4 : l++;
      else if (u - c < this.tShift[s])
        l++;
      else
        break;
      u++;
    }
    l > r ? a[o] = new Array(l - r + 1).join(" ") + this.src.slice(u, d) : a[o] = this.src.slice(u, d);
  }
  return a.join("");
};
ms.prototype.Token = wo;
const Uwt = 65536;
function gv(t, e) {
  const n = t.bMarks[e] + t.tShift[e], r = t.eMarks[e];
  return t.src.slice(n, r);
}
function vI(t) {
  const e = [], n = t.length;
  let r = 0, i = t.charCodeAt(r), a = !1, o = 0, s = "";
  for (; r < n; )
    i === 124 && (a ? (s += t.substring(o, r - 1), o = r) : (e.push(s + t.substring(o, r)), s = "", o = r + 1)), a = i === 92, r++, i = t.charCodeAt(r);
  return e.push(s + t.substring(o)), e;
}
function Wwt(t, e, n, r) {
  if (e + 2 > n)
    return !1;
  let i = e + 1;
  if (t.sCount[i] < t.blkIndent || t.sCount[i] - t.blkIndent >= 4)
    return !1;
  let a = t.bMarks[i] + t.tShift[i];
  if (a >= t.eMarks[i])
    return !1;
  const o = t.src.charCodeAt(a++);
  if (o !== 124 && o !== 45 && o !== 58 || a >= t.eMarks[i])
    return !1;
  const s = t.src.charCodeAt(a++);
  if (s !== 124 && s !== 45 && s !== 58 && !bn(s) || o === 45 && bn(s))
    return !1;
  for (; a < t.eMarks[i]; ) {
    const b = t.src.charCodeAt(a);
    if (b !== 124 && b !== 45 && b !== 58 && !bn(b))
      return !1;
    a++;
  }
  let l = gv(t, e + 1), c = l.split("|");
  const u = [];
  for (let b = 0; b < c.length; b++) {
    const x = c[b].trim();
    if (!x) {
      if (b === 0 || b === c.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(x))
      return !1;
    x.charCodeAt(x.length - 1) === 58 ? u.push(x.charCodeAt(0) === 58 ? "center" : "right") : x.charCodeAt(0) === 58 ? u.push("left") : u.push("");
  }
  if (l = gv(t, e).trim(), l.indexOf("|") === -1 || t.sCount[e] - t.blkIndent >= 4)
    return !1;
  c = vI(l), c.length && c[0] === "" && c.shift(), c.length && c[c.length - 1] === "" && c.pop();
  const d = c.length;
  if (d === 0 || d !== u.length)
    return !1;
  if (r)
    return !0;
  const f = t.parentType;
  t.parentType = "table";
  const h = t.md.block.ruler.getRules("blockquote"), p = t.push("table_open", "table", 1), m = [e, 0];
  p.map = m;
  const g = t.push("thead_open", "thead", 1);
  g.map = [e, e + 1];
  const v = t.push("tr_open", "tr", 1);
  v.map = [e, e + 1];
  for (let b = 0; b < c.length; b++) {
    const x = t.push("th_open", "th", 1);
    u[b] && (x.attrs = [["style", "text-align:" + u[b]]]);
    const A = t.push("inline", "", 0);
    A.content = c[b].trim(), A.children = [], t.push("th_close", "th", -1);
  }
  t.push("tr_close", "tr", -1), t.push("thead_close", "thead", -1);
  let k, w = 0;
  for (i = e + 2; i < n && !(t.sCount[i] < t.blkIndent); i++) {
    let b = !1;
    for (let A = 0, L = h.length; A < L; A++)
      if (h[A](t, i, n, !0)) {
        b = !0;
        break;
      }
    if (b || (l = gv(t, i).trim(), !l) || t.sCount[i] - t.blkIndent >= 4 || (c = vI(l), c.length && c[0] === "" && c.shift(), c.length && c[c.length - 1] === "" && c.pop(), w += d - c.length, w > Uwt))
      break;
    if (i === e + 2) {
      const A = t.push("tbody_open", "tbody", 1);
      A.map = k = [e + 2, 0];
    }
    const x = t.push("tr_open", "tr", 1);
    x.map = [i, i + 1];
    for (let A = 0; A < d; A++) {
      const L = t.push("td_open", "td", 1);
      u[A] && (L.attrs = [["style", "text-align:" + u[A]]]);
      const M = t.push("inline", "", 0);
      M.content = c[A] ? c[A].trim() : "", M.children = [], t.push("td_close", "td", -1);
    }
    t.push("tr_close", "tr", -1);
  }
  return k && (t.push("tbody_close", "tbody", -1), k[1] = i), t.push("table_close", "table", -1), m[1] = i, t.parentType = f, t.line = i, !0;
}
function Zwt(t, e, n) {
  if (t.sCount[e] - t.blkIndent < 4)
    return !1;
  let r = e + 1, i = r;
  for (; r < n; ) {
    if (t.isEmpty(r)) {
      r++;
      continue;
    }
    if (t.sCount[r] - t.blkIndent >= 4) {
      r++, i = r;
      continue;
    }
    break;
  }
  t.line = i;
  const a = t.push("code_block", "code", 0);
  return a.content = t.getLines(e, i, 4 + t.blkIndent, !1) + `
`, a.map = [e, t.line], !0;
}
function Gwt(t, e, n, r) {
  let i = t.bMarks[e] + t.tShift[e], a = t.eMarks[e];
  if (t.sCount[e] - t.blkIndent >= 4 || i + 3 > a)
    return !1;
  const o = t.src.charCodeAt(i);
  if (o !== 126 && o !== 96)
    return !1;
  let s = i;
  i = t.skipChars(i, o);
  let l = i - s;
  if (l < 3)
    return !1;
  const c = t.src.slice(s, i), u = t.src.slice(i, a);
  if (o === 96 && u.indexOf(String.fromCharCode(o)) >= 0)
    return !1;
  if (r)
    return !0;
  let d = e, f = !1;
  for (; d++, !(d >= n || (i = s = t.bMarks[d] + t.tShift[d], a = t.eMarks[d], i < a && t.sCount[d] < t.blkIndent)); )
    if (t.src.charCodeAt(i) === o && !(t.sCount[d] - t.blkIndent >= 4) && (i = t.skipChars(i, o), !(i - s < l) && (i = t.skipSpaces(i), !(i < a)))) {
      f = !0;
      break;
    }
  l = t.sCount[e], t.line = d + (f ? 1 : 0);
  const h = t.push("fence", "code", 0);
  return h.info = u, h.content = t.getLines(e + 1, d, l, !0), h.markup = c, h.map = [e, t.line], !0;
}
function Ywt(t, e, n, r) {
  let i = t.bMarks[e] + t.tShift[e], a = t.eMarks[e];
  const o = t.lineMax;
  if (t.sCount[e] - t.blkIndent >= 4 || t.src.charCodeAt(i) !== 62)
    return !1;
  if (r)
    return !0;
  const s = [], l = [], c = [], u = [], d = t.md.block.ruler.getRules("blockquote"), f = t.parentType;
  t.parentType = "blockquote";
  let h = !1, p;
  for (p = e; p < n; p++) {
    const w = t.sCount[p] < t.blkIndent;
    if (i = t.bMarks[p] + t.tShift[p], a = t.eMarks[p], i >= a)
      break;
    if (t.src.charCodeAt(i++) === 62 && !w) {
      let x = t.sCount[p] + 1, A, L;
      t.src.charCodeAt(i) === 32 ? (i++, x++, L = !1, A = !0) : t.src.charCodeAt(i) === 9 ? (A = !0, (t.bsCount[p] + x) % 4 === 3 ? (i++, x++, L = !1) : L = !0) : A = !1;
      let M = x;
      for (s.push(t.bMarks[p]), t.bMarks[p] = i; i < a; ) {
        const j = t.src.charCodeAt(i);
        if (bn(j))
          j === 9 ? M += 4 - (M + t.bsCount[p] + (L ? 1 : 0)) % 4 : M++;
        else
          break;
        i++;
      }
      h = i >= a, l.push(t.bsCount[p]), t.bsCount[p] = t.sCount[p] + 1 + (A ? 1 : 0), c.push(t.sCount[p]), t.sCount[p] = M - x, u.push(t.tShift[p]), t.tShift[p] = i - t.bMarks[p];
      continue;
    }
    if (h)
      break;
    let b = !1;
    for (let x = 0, A = d.length; x < A; x++)
      if (d[x](t, p, n, !0)) {
        b = !0;
        break;
      }
    if (b) {
      t.lineMax = p, t.blkIndent !== 0 && (s.push(t.bMarks[p]), l.push(t.bsCount[p]), u.push(t.tShift[p]), c.push(t.sCount[p]), t.sCount[p] -= t.blkIndent);
      break;
    }
    s.push(t.bMarks[p]), l.push(t.bsCount[p]), u.push(t.tShift[p]), c.push(t.sCount[p]), t.sCount[p] = -1;
  }
  const m = t.blkIndent;
  t.blkIndent = 0;
  const g = t.push("blockquote_open", "blockquote", 1);
  g.markup = ">";
  const v = [e, 0];
  g.map = v, t.md.block.tokenize(t, e, p);
  const k = t.push("blockquote_close", "blockquote", -1);
  k.markup = ">", t.lineMax = o, t.parentType = f, v[1] = t.line;
  for (let w = 0; w < u.length; w++)
    t.bMarks[w + e] = s[w], t.tShift[w + e] = u[w], t.sCount[w + e] = c[w], t.bsCount[w + e] = l[w];
  return t.blkIndent = m, !0;
}
function Kwt(t, e, n, r) {
  const i = t.eMarks[e];
  if (t.sCount[e] - t.blkIndent >= 4)
    return !1;
  let a = t.bMarks[e] + t.tShift[e];
  const o = t.src.charCodeAt(a++);
  if (o !== 42 && o !== 45 && o !== 95)
    return !1;
  let s = 1;
  for (; a < i; ) {
    const c = t.src.charCodeAt(a++);
    if (c !== o && !bn(c))
      return !1;
    c === o && s++;
  }
  if (s < 3)
    return !1;
  if (r)
    return !0;
  t.line = e + 1;
  const l = t.push("hr", "hr", 0);
  return l.map = [e, t.line], l.markup = Array(s + 1).join(String.fromCharCode(o)), !0;
}
function bI(t, e) {
  const n = t.eMarks[e];
  let r = t.bMarks[e] + t.tShift[e];
  const i = t.src.charCodeAt(r++);
  if (i !== 42 && i !== 45 && i !== 43)
    return -1;
  if (r < n) {
    const a = t.src.charCodeAt(r);
    if (!bn(a))
      return -1;
  }
  return r;
}
function wI(t, e) {
  const n = t.bMarks[e] + t.tShift[e], r = t.eMarks[e];
  let i = n;
  if (i + 1 >= r)
    return -1;
  let a = t.src.charCodeAt(i++);
  if (a < 48 || a > 57)
    return -1;
  for (; ; ) {
    if (i >= r)
      return -1;
    if (a = t.src.charCodeAt(i++), a >= 48 && a <= 57) {
      if (i - n >= 10)
        return -1;
      continue;
    }
    if (a === 41 || a === 46)
      break;
    return -1;
  }
  return i < r && (a = t.src.charCodeAt(i), !bn(a)) ? -1 : i;
}
function $wt(t, e) {
  const n = t.level + 2;
  for (let r = e + 2, i = t.tokens.length - 2; r < i; r++)
    t.tokens[r].level === n && t.tokens[r].type === "paragraph_open" && (t.tokens[r + 2].hidden = !0, t.tokens[r].hidden = !0, r += 2);
}
function Jwt(t, e, n, r) {
  let i, a, o, s, l = e, c = !0;
  if (t.sCount[l] - t.blkIndent >= 4 || t.listIndent >= 0 && t.sCount[l] - t.listIndent >= 4 && t.sCount[l] < t.blkIndent)
    return !1;
  let u = !1;
  r && t.parentType === "paragraph" && t.sCount[l] >= t.blkIndent && (u = !0);
  let d, f, h;
  if ((h = wI(t, l)) >= 0) {
    if (d = !0, o = t.bMarks[l] + t.tShift[l], f = Number(t.src.slice(o, h - 1)), u && f !== 1) return !1;
  } else if ((h = bI(t, l)) >= 0)
    d = !1;
  else
    return !1;
  if (u && t.skipSpaces(h) >= t.eMarks[l])
    return !1;
  if (r)
    return !0;
  const p = t.src.charCodeAt(h - 1), m = t.tokens.length;
  d ? (s = t.push("ordered_list_open", "ol", 1), f !== 1 && (s.attrs = [["start", f]])) : s = t.push("bullet_list_open", "ul", 1);
  const g = [l, 0];
  s.map = g, s.markup = String.fromCharCode(p);
  let v = !1;
  const k = t.md.block.ruler.getRules("list"), w = t.parentType;
  for (t.parentType = "list"; l < n; ) {
    a = h, i = t.eMarks[l];
    const b = t.sCount[l] + h - (t.bMarks[l] + t.tShift[l]);
    let x = b;
    for (; a < i; ) {
      const _ = t.src.charCodeAt(a);
      if (_ === 9)
        x += 4 - (x + t.bsCount[l]) % 4;
      else if (_ === 32)
        x++;
      else
        break;
      a++;
    }
    const A = a;
    let L;
    A >= i ? L = 1 : L = x - b, L > 4 && (L = 1);
    const M = b + L;
    s = t.push("list_item_open", "li", 1), s.markup = String.fromCharCode(p);
    const j = [l, 0];
    s.map = j, d && (s.info = t.src.slice(o, h - 1));
    const D = t.tight, z = t.tShift[l], H = t.sCount[l], V = t.listIndent;
    if (t.listIndent = t.blkIndent, t.blkIndent = M, t.tight = !0, t.tShift[l] = A - t.bMarks[l], t.sCount[l] = x, A >= i && t.isEmpty(l + 1) ? t.line = Math.min(t.line + 2, n) : t.md.block.tokenize(t, l, n, !0), (!t.tight || v) && (c = !1), v = t.line - l > 1 && t.isEmpty(t.line - 1), t.blkIndent = t.listIndent, t.listIndent = V, t.tShift[l] = z, t.sCount[l] = H, t.tight = D, s = t.push("list_item_close", "li", -1), s.markup = String.fromCharCode(p), l = t.line, j[1] = l, l >= n || t.sCount[l] < t.blkIndent || t.sCount[l] - t.blkIndent >= 4)
      break;
    let F = !1;
    for (let _ = 0, W = k.length; _ < W; _++)
      if (k[_](t, l, n, !0)) {
        F = !0;
        break;
      }
    if (F)
      break;
    if (d) {
      if (h = wI(t, l), h < 0)
        break;
      o = t.bMarks[l] + t.tShift[l];
    } else if (h = bI(t, l), h < 0)
      break;
    if (p !== t.src.charCodeAt(h - 1))
      break;
  }
  return d ? s = t.push("ordered_list_close", "ol", -1) : s = t.push("bullet_list_close", "ul", -1), s.markup = String.fromCharCode(p), g[1] = l, t.line = l, t.parentType = w, c && $wt(t, m), !0;
}
function Qwt(t, e, n, r) {
  let i = t.bMarks[e] + t.tShift[e], a = t.eMarks[e], o = e + 1;
  if (t.sCount[e] - t.blkIndent >= 4 || t.src.charCodeAt(i) !== 91)
    return !1;
  function s(k) {
    const w = t.lineMax;
    if (k >= w || t.isEmpty(k))
      return null;
    let b = !1;
    if (t.sCount[k] - t.blkIndent > 3 && (b = !0), t.sCount[k] < 0 && (b = !0), !b) {
      const L = t.md.block.ruler.getRules("reference"), M = t.parentType;
      t.parentType = "reference";
      let j = !1;
      for (let D = 0, z = L.length; D < z; D++)
        if (L[D](t, k, w, !0)) {
          j = !0;
          break;
        }
      if (t.parentType = M, j)
        return null;
    }
    const x = t.bMarks[k] + t.tShift[k], A = t.eMarks[k];
    return t.src.slice(x, A + 1);
  }
  let l = t.src.slice(i, a + 1);
  a = l.length;
  let c = -1;
  for (i = 1; i < a; i++) {
    const k = l.charCodeAt(i);
    if (k === 91)
      return !1;
    if (k === 93) {
      c = i;
      break;
    } else if (k === 10) {
      const w = s(o);
      w !== null && (l += w, a = l.length, o++);
    } else if (k === 92 && (i++, i < a && l.charCodeAt(i) === 10)) {
      const w = s(o);
      w !== null && (l += w, a = l.length, o++);
    }
  }
  if (c < 0 || l.charCodeAt(c + 1) !== 58)
    return !1;
  for (i = c + 2; i < a; i++) {
    const k = l.charCodeAt(i);
    if (k === 10) {
      const w = s(o);
      w !== null && (l += w, a = l.length, o++);
    } else if (!bn(k)) break;
  }
  const u = t.md.helpers.parseLinkDestination(l, i, a);
  if (!u.ok)
    return !1;
  const d = t.md.normalizeLink(u.str);
  if (!t.md.validateLink(d))
    return !1;
  i = u.pos;
  const f = i, h = o, p = i;
  for (; i < a; i++) {
    const k = l.charCodeAt(i);
    if (k === 10) {
      const w = s(o);
      w !== null && (l += w, a = l.length, o++);
    } else if (!bn(k)) break;
  }
  let m = t.md.helpers.parseLinkTitle(l, i, a);
  for (; m.can_continue; ) {
    const k = s(o);
    if (k === null) break;
    l += k, i = a, a = l.length, o++, m = t.md.helpers.parseLinkTitle(l, i, a, m);
  }
  let g;
  for (i < a && p !== i && m.ok ? (g = m.str, i = m.pos) : (g = "", i = f, o = h); i < a; ) {
    const k = l.charCodeAt(i);
    if (!bn(k))
      break;
    i++;
  }
  if (i < a && l.charCodeAt(i) !== 10 && g)
    for (g = "", i = f, o = h; i < a; ) {
      const k = l.charCodeAt(i);
      if (!bn(k))
        break;
      i++;
    }
  if (i < a && l.charCodeAt(i) !== 10)
    return !1;
  const v = e5(l.slice(1, c));
  return v ? (r || (typeof t.env.references > "u" && (t.env.references = {}), typeof t.env.references[v] > "u" && (t.env.references[v] = { title: g, href: d }), t.line = o), !0) : !1;
}
const Xwt = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], ekt = "[a-zA-Z_:][a-zA-Z0-9:._-]*", tkt = "[^\"'=<>`\\x00-\\x20]+", nkt = "'[^']*'", rkt = '"[^"]*"', ikt = "(?:" + tkt + "|" + nkt + "|" + rkt + ")", akt = "(?:\\s+" + ekt + "(?:\\s*=\\s*" + ikt + ")?)", Q$ = "<[A-Za-z][A-Za-z0-9\\-]*" + akt + "*\\s*\\/?>", X$ = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", okt = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->", skt = "<[?][\\s\\S]*?[?]>", lkt = "<![A-Za-z][^>]*>", ckt = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", ukt = new RegExp("^(?:" + Q$ + "|" + X$ + "|" + okt + "|" + skt + "|" + lkt + "|" + ckt + ")"), dkt = new RegExp("^(?:" + Q$ + "|" + X$ + ")"), U0 = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + Xwt.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(dkt.source + "\\s*$"), /^$/, !1]
];
function fkt(t, e, n, r) {
  let i = t.bMarks[e] + t.tShift[e], a = t.eMarks[e];
  if (t.sCount[e] - t.blkIndent >= 4 || !t.md.options.html || t.src.charCodeAt(i) !== 60)
    return !1;
  let o = t.src.slice(i, a), s = 0;
  for (; s < U0.length && !U0[s][0].test(o); s++)
    ;
  if (s === U0.length)
    return !1;
  if (r)
    return U0[s][2];
  let l = e + 1;
  if (!U0[s][1].test(o)) {
    for (; l < n && !(t.sCount[l] < t.blkIndent); l++)
      if (i = t.bMarks[l] + t.tShift[l], a = t.eMarks[l], o = t.src.slice(i, a), U0[s][1].test(o)) {
        o.length !== 0 && l++;
        break;
      }
  }
  t.line = l;
  const c = t.push("html_block", "", 0);
  return c.map = [e, l], c.content = t.getLines(e, l, t.blkIndent, !0), !0;
}
function hkt(t, e, n, r) {
  let i = t.bMarks[e] + t.tShift[e], a = t.eMarks[e];
  if (t.sCount[e] - t.blkIndent >= 4)
    return !1;
  let o = t.src.charCodeAt(i);
  if (o !== 35 || i >= a)
    return !1;
  let s = 1;
  for (o = t.src.charCodeAt(++i); o === 35 && i < a && s <= 6; )
    s++, o = t.src.charCodeAt(++i);
  if (s > 6 || i < a && !bn(o))
    return !1;
  if (r)
    return !0;
  a = t.skipSpacesBack(a, i);
  const l = t.skipCharsBack(a, 35, i);
  l > i && bn(t.src.charCodeAt(l - 1)) && (a = l), t.line = e + 1;
  const c = t.push("heading_open", "h" + String(s), 1);
  c.markup = "########".slice(0, s), c.map = [e, t.line];
  const u = t.push("inline", "", 0);
  u.content = t.src.slice(i, a).trim(), u.map = [e, t.line], u.children = [];
  const d = t.push("heading_close", "h" + String(s), -1);
  return d.markup = "########".slice(0, s), !0;
}
function pkt(t, e, n) {
  const r = t.md.block.ruler.getRules("paragraph");
  if (t.sCount[e] - t.blkIndent >= 4)
    return !1;
  const i = t.parentType;
  t.parentType = "paragraph";
  let a = 0, o, s = e + 1;
  for (; s < n && !t.isEmpty(s); s++) {
    if (t.sCount[s] - t.blkIndent > 3)
      continue;
    if (t.sCount[s] >= t.blkIndent) {
      let h = t.bMarks[s] + t.tShift[s];
      const p = t.eMarks[s];
      if (h < p && (o = t.src.charCodeAt(h), (o === 45 || o === 61) && (h = t.skipChars(h, o), h = t.skipSpaces(h), h >= p))) {
        a = o === 61 ? 1 : 2;
        break;
      }
    }
    if (t.sCount[s] < 0)
      continue;
    let f = !1;
    for (let h = 0, p = r.length; h < p; h++)
      if (r[h](t, s, n, !0)) {
        f = !0;
        break;
      }
    if (f)
      break;
  }
  if (!a)
    return !1;
  const l = t.getLines(e, s, t.blkIndent, !1).trim();
  t.line = s + 1;
  const c = t.push("heading_open", "h" + String(a), 1);
  c.markup = String.fromCharCode(o), c.map = [e, t.line];
  const u = t.push("inline", "", 0);
  u.content = l, u.map = [e, t.line - 1], u.children = [];
  const d = t.push("heading_close", "h" + String(a), -1);
  return d.markup = String.fromCharCode(o), t.parentType = i, !0;
}
function mkt(t, e, n) {
  const r = t.md.block.ruler.getRules("paragraph"), i = t.parentType;
  let a = e + 1;
  for (t.parentType = "paragraph"; a < n && !t.isEmpty(a); a++) {
    if (t.sCount[a] - t.blkIndent > 3 || t.sCount[a] < 0)
      continue;
    let c = !1;
    for (let u = 0, d = r.length; u < d; u++)
      if (r[u](t, a, n, !0)) {
        c = !0;
        break;
      }
    if (c)
      break;
  }
  const o = t.getLines(e, a, t.blkIndent, !1).trim();
  t.line = a;
  const s = t.push("paragraph_open", "p", 1);
  s.map = [e, t.line];
  const l = t.push("inline", "", 0);
  return l.content = o, l.map = [e, t.line], l.children = [], t.push("paragraph_close", "p", -1), t.parentType = i, !0;
}
const Ym = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", Wwt, ["paragraph", "reference"]],
  ["code", Zwt],
  ["fence", Gwt, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", Ywt, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", Kwt, ["paragraph", "reference", "blockquote", "list"]],
  ["list", Jwt, ["paragraph", "reference", "blockquote"]],
  ["reference", Qwt],
  ["html_block", fkt, ["paragraph", "reference", "blockquote"]],
  ["heading", hkt, ["paragraph", "reference", "blockquote"]],
  ["lheading", pkt],
  ["paragraph", mkt]
];
function t5() {
  this.ruler = new Ii();
  for (let t = 0; t < Ym.length; t++)
    this.ruler.push(Ym[t][0], Ym[t][1], { alt: (Ym[t][2] || []).slice() });
}
t5.prototype.tokenize = function(t, e, n) {
  const r = this.ruler.getRules(""), i = r.length, a = t.md.options.maxNesting;
  let o = e, s = !1;
  for (; o < n && (t.line = o = t.skipEmptyLines(o), !(o >= n || t.sCount[o] < t.blkIndent)); ) {
    if (t.level >= a) {
      t.line = n;
      break;
    }
    const l = t.line;
    let c = !1;
    for (let u = 0; u < i; u++)
      if (c = r[u](t, o, n, !1), c) {
        if (l >= t.line)
          throw new Error("block rule didn't increment state.line");
        break;
      }
    if (!c) throw new Error("none of the block rules matched");
    t.tight = !s, t.isEmpty(t.line - 1) && (s = !0), o = t.line, o < n && t.isEmpty(o) && (s = !0, o++, t.line = o);
  }
};
t5.prototype.parse = function(t, e, n, r) {
  if (!t)
    return;
  const i = new this.State(t, e, n, r);
  this.tokenize(i, i.line, i.lineMax);
};
t5.prototype.State = ms;
function qp(t, e, n, r) {
  this.src = t, this.env = n, this.md = e, this.tokens = r, this.tokens_meta = Array(r.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
qp.prototype.pushPending = function() {
  const t = new wo("text", "", 0);
  return t.content = this.pending, t.level = this.pendingLevel, this.tokens.push(t), this.pending = "", t;
};
qp.prototype.push = function(t, e, n) {
  this.pending && this.pushPending();
  const r = new wo(t, e, n);
  let i = null;
  return n < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), r.level = this.level, n > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], i = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(r), this.tokens_meta.push(i), r;
};
qp.prototype.scanDelims = function(t, e) {
  const n = this.posMax, r = this.src.charCodeAt(t), i = t > 0 ? this.src.charCodeAt(t - 1) : 32;
  let a = t;
  for (; a < n && this.src.charCodeAt(a) === r; )
    a++;
  const o = a - t, s = a < n ? this.src.charCodeAt(a) : 32, l = C2(i) || M2(String.fromCharCode(i)), c = C2(s) || M2(String.fromCharCode(s)), u = x2(i), d = x2(s), f = !d && (!c || u || l), h = !u && (!l || d || c);
  return { can_open: f && (e || !h || l), can_close: h && (e || !f || c), length: o };
};
qp.prototype.Token = wo;
function ykt(t) {
  switch (t) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function gkt(t, e) {
  let n = t.pos;
  for (; n < t.posMax && !ykt(t.src.charCodeAt(n)); )
    n++;
  return n === t.pos ? !1 : (e || (t.pending += t.src.slice(t.pos, n)), t.pos = n, !0);
}
const vkt = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function bkt(t, e) {
  if (!t.md.options.linkify || t.linkLevel > 0) return !1;
  const n = t.pos, r = t.posMax;
  if (n + 3 > r || t.src.charCodeAt(n) !== 58 || t.src.charCodeAt(n + 1) !== 47 || t.src.charCodeAt(n + 2) !== 47) return !1;
  const i = t.pending.match(vkt);
  if (!i) return !1;
  const a = i[1], o = t.md.linkify.matchAtStart(t.src.slice(n - a.length));
  if (!o) return !1;
  let s = o.url;
  if (s.length <= a.length) return !1;
  s = s.replace(/\*+$/, "");
  const l = t.md.normalizeLink(s);
  if (!t.md.validateLink(l)) return !1;
  if (!e) {
    t.pending = t.pending.slice(0, -a.length);
    const c = t.push("link_open", "a", 1);
    c.attrs = [["href", l]], c.markup = "linkify", c.info = "auto";
    const u = t.push("text", "", 0);
    u.content = t.md.normalizeLinkText(s);
    const d = t.push("link_close", "a", -1);
    d.markup = "linkify", d.info = "auto";
  }
  return t.pos += s.length - a.length, !0;
}
function wkt(t, e) {
  let n = t.pos;
  if (t.src.charCodeAt(n) !== 10)
    return !1;
  const r = t.pending.length - 1, i = t.posMax;
  if (!e)
    if (r >= 0 && t.pending.charCodeAt(r) === 32)
      if (r >= 1 && t.pending.charCodeAt(r - 1) === 32) {
        let a = r - 1;
        for (; a >= 1 && t.pending.charCodeAt(a - 1) === 32; ) a--;
        t.pending = t.pending.slice(0, a), t.push("hardbreak", "br", 0);
      } else
        t.pending = t.pending.slice(0, -1), t.push("softbreak", "br", 0);
    else
      t.push("softbreak", "br", 0);
  for (n++; n < i && bn(t.src.charCodeAt(n)); )
    n++;
  return t.pos = n, !0;
}
const jA = [];
for (let t = 0; t < 256; t++)
  jA.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(t) {
  jA[t.charCodeAt(0)] = 1;
});
function kkt(t, e) {
  let n = t.pos;
  const r = t.posMax;
  if (t.src.charCodeAt(n) !== 92 || (n++, n >= r)) return !1;
  let i = t.src.charCodeAt(n);
  if (i === 10) {
    for (e || t.push("hardbreak", "br", 0), n++; n < r && (i = t.src.charCodeAt(n), !!bn(i)); )
      n++;
    return t.pos = n, !0;
  }
  let a = t.src[n];
  if (i >= 55296 && i <= 56319 && n + 1 < r) {
    const s = t.src.charCodeAt(n + 1);
    s >= 56320 && s <= 57343 && (a += t.src[n + 1], n++);
  }
  const o = "\\" + a;
  if (!e) {
    const s = t.push("text_special", "", 0);
    i < 256 && jA[i] !== 0 ? s.content = a : s.content = o, s.markup = o, s.info = "escape";
  }
  return t.pos = n + 1, !0;
}
function xkt(t, e) {
  let n = t.pos;
  if (t.src.charCodeAt(n) !== 96)
    return !1;
  const i = n;
  n++;
  const a = t.posMax;
  for (; n < a && t.src.charCodeAt(n) === 96; )
    n++;
  const o = t.src.slice(i, n), s = o.length;
  if (t.backticksScanned && (t.backticks[s] || 0) <= i)
    return e || (t.pending += o), t.pos += s, !0;
  let l = n, c;
  for (; (c = t.src.indexOf("`", l)) !== -1; ) {
    for (l = c + 1; l < a && t.src.charCodeAt(l) === 96; )
      l++;
    const u = l - c;
    if (u === s) {
      if (!e) {
        const d = t.push("code_inline", "code", 0);
        d.markup = o, d.content = t.src.slice(n, c).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
      }
      return t.pos = l, !0;
    }
    t.backticks[u] = c;
  }
  return t.backticksScanned = !0, e || (t.pending += o), t.pos += s, !0;
}
function Mkt(t, e) {
  const n = t.pos, r = t.src.charCodeAt(n);
  if (e || r !== 126)
    return !1;
  const i = t.scanDelims(t.pos, !0);
  let a = i.length;
  const o = String.fromCharCode(r);
  if (a < 2)
    return !1;
  let s;
  a % 2 && (s = t.push("text", "", 0), s.content = o, a--);
  for (let l = 0; l < a; l += 2)
    s = t.push("text", "", 0), s.content = o + o, t.delimiters.push({
      marker: r,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: t.tokens.length - 1,
      end: -1,
      open: i.can_open,
      close: i.can_close
    });
  return t.pos += i.length, !0;
}
function kI(t, e) {
  let n;
  const r = [], i = e.length;
  for (let a = 0; a < i; a++) {
    const o = e[a];
    if (o.marker !== 126 || o.end === -1)
      continue;
    const s = e[o.end];
    n = t.tokens[o.token], n.type = "s_open", n.tag = "s", n.nesting = 1, n.markup = "~~", n.content = "", n = t.tokens[s.token], n.type = "s_close", n.tag = "s", n.nesting = -1, n.markup = "~~", n.content = "", t.tokens[s.token - 1].type === "text" && t.tokens[s.token - 1].content === "~" && r.push(s.token - 1);
  }
  for (; r.length; ) {
    const a = r.pop();
    let o = a + 1;
    for (; o < t.tokens.length && t.tokens[o].type === "s_close"; )
      o++;
    o--, a !== o && (n = t.tokens[o], t.tokens[o] = t.tokens[a], t.tokens[a] = n);
  }
}
function Ckt(t) {
  const e = t.tokens_meta, n = t.tokens_meta.length;
  kI(t, t.delimiters);
  for (let r = 0; r < n; r++)
    e[r] && e[r].delimiters && kI(t, e[r].delimiters);
}
const eJ = {
  tokenize: Mkt,
  postProcess: Ckt
};
function Akt(t, e) {
  const n = t.pos, r = t.src.charCodeAt(n);
  if (e || r !== 95 && r !== 42)
    return !1;
  const i = t.scanDelims(t.pos, r === 42);
  for (let a = 0; a < i.length; a++) {
    const o = t.push("text", "", 0);
    o.content = String.fromCharCode(r), t.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: r,
      // Total length of these series of delimiters.
      //
      length: i.length,
      // A position of the token this delimiter corresponds to.
      //
      token: t.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: i.can_open,
      close: i.can_close
    });
  }
  return t.pos += i.length, !0;
}
function xI(t, e) {
  const n = e.length;
  for (let r = n - 1; r >= 0; r--) {
    const i = e[r];
    if (i.marker !== 95 && i.marker !== 42 || i.end === -1)
      continue;
    const a = e[i.end], o = r > 0 && e[r - 1].end === i.end + 1 && // check that first two markers match and adjacent
    e[r - 1].marker === i.marker && e[r - 1].token === i.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    e[i.end + 1].token === a.token + 1, s = String.fromCharCode(i.marker), l = t.tokens[i.token];
    l.type = o ? "strong_open" : "em_open", l.tag = o ? "strong" : "em", l.nesting = 1, l.markup = o ? s + s : s, l.content = "";
    const c = t.tokens[a.token];
    c.type = o ? "strong_close" : "em_close", c.tag = o ? "strong" : "em", c.nesting = -1, c.markup = o ? s + s : s, c.content = "", o && (t.tokens[e[r - 1].token].content = "", t.tokens[e[i.end + 1].token].content = "", r--);
  }
}
function Skt(t) {
  const e = t.tokens_meta, n = t.tokens_meta.length;
  xI(t, t.delimiters);
  for (let r = 0; r < n; r++)
    e[r] && e[r].delimiters && xI(t, e[r].delimiters);
}
const tJ = {
  tokenize: Akt,
  postProcess: Skt
};
function Lkt(t, e) {
  let n, r, i, a, o = "", s = "", l = t.pos, c = !0;
  if (t.src.charCodeAt(t.pos) !== 91)
    return !1;
  const u = t.pos, d = t.posMax, f = t.pos + 1, h = t.md.helpers.parseLinkLabel(t, t.pos, !0);
  if (h < 0)
    return !1;
  let p = h + 1;
  if (p < d && t.src.charCodeAt(p) === 40) {
    for (c = !1, p++; p < d && (n = t.src.charCodeAt(p), !(!bn(n) && n !== 10)); p++)
      ;
    if (p >= d)
      return !1;
    if (l = p, i = t.md.helpers.parseLinkDestination(t.src, p, t.posMax), i.ok) {
      for (o = t.md.normalizeLink(i.str), t.md.validateLink(o) ? p = i.pos : o = "", l = p; p < d && (n = t.src.charCodeAt(p), !(!bn(n) && n !== 10)); p++)
        ;
      if (i = t.md.helpers.parseLinkTitle(t.src, p, t.posMax), p < d && l !== p && i.ok)
        for (s = i.str, p = i.pos; p < d && (n = t.src.charCodeAt(p), !(!bn(n) && n !== 10)); p++)
          ;
    }
    (p >= d || t.src.charCodeAt(p) !== 41) && (c = !0), p++;
  }
  if (c) {
    if (typeof t.env.references > "u")
      return !1;
    if (p < d && t.src.charCodeAt(p) === 91 ? (l = p + 1, p = t.md.helpers.parseLinkLabel(t, p), p >= 0 ? r = t.src.slice(l, p++) : p = h + 1) : p = h + 1, r || (r = t.src.slice(f, h)), a = t.env.references[e5(r)], !a)
      return t.pos = u, !1;
    o = a.href, s = a.title;
  }
  if (!e) {
    t.pos = f, t.posMax = h;
    const m = t.push("link_open", "a", 1), g = [["href", o]];
    m.attrs = g, s && g.push(["title", s]), t.linkLevel++, t.md.inline.tokenize(t), t.linkLevel--, t.push("link_close", "a", -1);
  }
  return t.pos = p, t.posMax = d, !0;
}
function Tkt(t, e) {
  let n, r, i, a, o, s, l, c, u = "";
  const d = t.pos, f = t.posMax;
  if (t.src.charCodeAt(t.pos) !== 33 || t.src.charCodeAt(t.pos + 1) !== 91)
    return !1;
  const h = t.pos + 2, p = t.md.helpers.parseLinkLabel(t, t.pos + 1, !1);
  if (p < 0)
    return !1;
  if (a = p + 1, a < f && t.src.charCodeAt(a) === 40) {
    for (a++; a < f && (n = t.src.charCodeAt(a), !(!bn(n) && n !== 10)); a++)
      ;
    if (a >= f)
      return !1;
    for (c = a, s = t.md.helpers.parseLinkDestination(t.src, a, t.posMax), s.ok && (u = t.md.normalizeLink(s.str), t.md.validateLink(u) ? a = s.pos : u = ""), c = a; a < f && (n = t.src.charCodeAt(a), !(!bn(n) && n !== 10)); a++)
      ;
    if (s = t.md.helpers.parseLinkTitle(t.src, a, t.posMax), a < f && c !== a && s.ok)
      for (l = s.str, a = s.pos; a < f && (n = t.src.charCodeAt(a), !(!bn(n) && n !== 10)); a++)
        ;
    else
      l = "";
    if (a >= f || t.src.charCodeAt(a) !== 41)
      return t.pos = d, !1;
    a++;
  } else {
    if (typeof t.env.references > "u")
      return !1;
    if (a < f && t.src.charCodeAt(a) === 91 ? (c = a + 1, a = t.md.helpers.parseLinkLabel(t, a), a >= 0 ? i = t.src.slice(c, a++) : a = p + 1) : a = p + 1, i || (i = t.src.slice(h, p)), o = t.env.references[e5(i)], !o)
      return t.pos = d, !1;
    u = o.href, l = o.title;
  }
  if (!e) {
    r = t.src.slice(h, p);
    const m = [];
    t.md.inline.parse(
      r,
      t.md,
      t.env,
      m
    );
    const g = t.push("image", "img", 0), v = [["src", u], ["alt", ""]];
    g.attrs = v, g.children = m, g.content = r, l && v.push(["title", l]);
  }
  return t.pos = a, t.posMax = f, !0;
}
const Ekt = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, jkt = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function Nkt(t, e) {
  let n = t.pos;
  if (t.src.charCodeAt(n) !== 60)
    return !1;
  const r = t.pos, i = t.posMax;
  for (; ; ) {
    if (++n >= i) return !1;
    const o = t.src.charCodeAt(n);
    if (o === 60) return !1;
    if (o === 62) break;
  }
  const a = t.src.slice(r + 1, n);
  if (jkt.test(a)) {
    const o = t.md.normalizeLink(a);
    if (!t.md.validateLink(o))
      return !1;
    if (!e) {
      const s = t.push("link_open", "a", 1);
      s.attrs = [["href", o]], s.markup = "autolink", s.info = "auto";
      const l = t.push("text", "", 0);
      l.content = t.md.normalizeLinkText(a);
      const c = t.push("link_close", "a", -1);
      c.markup = "autolink", c.info = "auto";
    }
    return t.pos += a.length + 2, !0;
  }
  if (Ekt.test(a)) {
    const o = t.md.normalizeLink("mailto:" + a);
    if (!t.md.validateLink(o))
      return !1;
    if (!e) {
      const s = t.push("link_open", "a", 1);
      s.attrs = [["href", o]], s.markup = "autolink", s.info = "auto";
      const l = t.push("text", "", 0);
      l.content = t.md.normalizeLinkText(a);
      const c = t.push("link_close", "a", -1);
      c.markup = "autolink", c.info = "auto";
    }
    return t.pos += a.length + 2, !0;
  }
  return !1;
}
function Dkt(t) {
  return /^<a[>\s]/i.test(t);
}
function Ikt(t) {
  return /^<\/a\s*>/i.test(t);
}
function Pkt(t) {
  const e = t | 32;
  return e >= 97 && e <= 122;
}
function zkt(t, e) {
  if (!t.md.options.html)
    return !1;
  const n = t.posMax, r = t.pos;
  if (t.src.charCodeAt(r) !== 60 || r + 2 >= n)
    return !1;
  const i = t.src.charCodeAt(r + 1);
  if (i !== 33 && i !== 63 && i !== 47 && !Pkt(i))
    return !1;
  const a = t.src.slice(r).match(ukt);
  if (!a)
    return !1;
  if (!e) {
    const o = t.push("html_inline", "", 0);
    o.content = a[0], Dkt(o.content) && t.linkLevel++, Ikt(o.content) && t.linkLevel--;
  }
  return t.pos += a[0].length, !0;
}
const Rkt = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, Okt = /^&([a-z][a-z0-9]{1,31});/i;
function Bkt(t, e) {
  const n = t.pos, r = t.posMax;
  if (t.src.charCodeAt(n) !== 38 || n + 1 >= r) return !1;
  if (t.src.charCodeAt(n + 1) === 35) {
    const a = t.src.slice(n).match(Rkt);
    if (a) {
      if (!e) {
        const o = a[1][0].toLowerCase() === "x" ? parseInt(a[1].slice(1), 16) : parseInt(a[1], 10), s = t.push("text_special", "", 0);
        s.content = TA(o) ? r3(o) : r3(65533), s.markup = a[0], s.info = "entity";
      }
      return t.pos += a[0].length, !0;
    }
  } else {
    const a = t.src.slice(n).match(Okt);
    if (a) {
      const o = G$(a[0]);
      if (o !== a[0]) {
        if (!e) {
          const s = t.push("text_special", "", 0);
          s.content = o, s.markup = a[0], s.info = "entity";
        }
        return t.pos += a[0].length, !0;
      }
    }
  }
  return !1;
}
function MI(t) {
  const e = {}, n = t.length;
  if (!n) return;
  let r = 0, i = -2;
  const a = [];
  for (let o = 0; o < n; o++) {
    const s = t[o];
    if (a.push(0), (t[r].marker !== s.marker || i !== s.token - 1) && (r = o), i = s.token, s.length = s.length || 0, !s.close) continue;
    e.hasOwnProperty(s.marker) || (e[s.marker] = [-1, -1, -1, -1, -1, -1]);
    const l = e[s.marker][(s.open ? 3 : 0) + s.length % 3];
    let c = r - a[r] - 1, u = c;
    for (; c > l; c -= a[c] + 1) {
      const d = t[c];
      if (d.marker === s.marker && d.open && d.end < 0) {
        let f = !1;
        if ((d.close || s.open) && (d.length + s.length) % 3 === 0 && (d.length % 3 !== 0 || s.length % 3 !== 0) && (f = !0), !f) {
          const h = c > 0 && !t[c - 1].open ? a[c - 1] + 1 : 0;
          a[o] = o - c + h, a[c] = h, s.open = !1, d.end = o, d.close = !1, u = -1, i = -2;
          break;
        }
      }
    }
    u !== -1 && (e[s.marker][(s.open ? 3 : 0) + (s.length || 0) % 3] = u);
  }
}
function Hkt(t) {
  const e = t.tokens_meta, n = t.tokens_meta.length;
  MI(t.delimiters);
  for (let r = 0; r < n; r++)
    e[r] && e[r].delimiters && MI(e[r].delimiters);
}
function Fkt(t) {
  let e, n, r = 0;
  const i = t.tokens, a = t.tokens.length;
  for (e = n = 0; e < a; e++)
    i[e].nesting < 0 && r--, i[e].level = r, i[e].nesting > 0 && r++, i[e].type === "text" && e + 1 < a && i[e + 1].type === "text" ? i[e + 1].content = i[e].content + i[e + 1].content : (e !== n && (i[n] = i[e]), n++);
  e !== n && (i.length = n);
}
const vv = [
  ["text", gkt],
  ["linkify", bkt],
  ["newline", wkt],
  ["escape", kkt],
  ["backticks", xkt],
  ["strikethrough", eJ.tokenize],
  ["emphasis", tJ.tokenize],
  ["link", Lkt],
  ["image", Tkt],
  ["autolink", Nkt],
  ["html_inline", zkt],
  ["entity", Bkt]
], bv = [
  ["balance_pairs", Hkt],
  ["strikethrough", eJ.postProcess],
  ["emphasis", tJ.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", Fkt]
];
function Up() {
  this.ruler = new Ii();
  for (let t = 0; t < vv.length; t++)
    this.ruler.push(vv[t][0], vv[t][1]);
  this.ruler2 = new Ii();
  for (let t = 0; t < bv.length; t++)
    this.ruler2.push(bv[t][0], bv[t][1]);
}
Up.prototype.skipToken = function(t) {
  const e = t.pos, n = this.ruler.getRules(""), r = n.length, i = t.md.options.maxNesting, a = t.cache;
  if (typeof a[e] < "u") {
    t.pos = a[e];
    return;
  }
  let o = !1;
  if (t.level < i) {
    for (let s = 0; s < r; s++)
      if (t.level++, o = n[s](t, !0), t.level--, o) {
        if (e >= t.pos)
          throw new Error("inline rule didn't increment state.pos");
        break;
      }
  } else
    t.pos = t.posMax;
  o || t.pos++, a[e] = t.pos;
};
Up.prototype.tokenize = function(t) {
  const e = this.ruler.getRules(""), n = e.length, r = t.posMax, i = t.md.options.maxNesting;
  for (; t.pos < r; ) {
    const a = t.pos;
    let o = !1;
    if (t.level < i) {
      for (let s = 0; s < n; s++)
        if (o = e[s](t, !1), o) {
          if (a >= t.pos)
            throw new Error("inline rule didn't increment state.pos");
          break;
        }
    }
    if (o) {
      if (t.pos >= r)
        break;
      continue;
    }
    t.pending += t.src[t.pos++];
  }
  t.pending && t.pushPending();
};
Up.prototype.parse = function(t, e, n, r) {
  const i = new this.State(t, e, n, r);
  this.tokenize(i);
  const a = this.ruler2.getRules(""), o = a.length;
  for (let s = 0; s < o; s++)
    a[s](i);
};
Up.prototype.State = qp;
function _kt(t) {
  const e = {};
  t = t || {}, e.src_Any = V$.source, e.src_Cc = q$.source, e.src_Z = W$.source, e.src_P = SA.source, e.src_ZPCc = [e.src_Z, e.src_P, e.src_Cc].join("|"), e.src_ZCc = [e.src_Z, e.src_Cc].join("|");
  const n = "[><｜]";
  return e.src_pseudo_letter = "(?:(?!" + n + "|" + e.src_ZPCc + ")" + e.src_Any + ")", e.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", e.src_auth = "(?:(?:(?!" + e.src_ZCc + "|[@/\\[\\]()]).)+@)?", e.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", e.src_host_terminator = "(?=$|" + n + "|" + e.src_ZPCc + ")(?!" + (t["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + e.src_ZPCc + "))", e.src_path = "(?:[/?#](?:(?!" + e.src_ZCc + "|" + n + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + e.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + e.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + e.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + e.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + e.src_ZCc + "|[']).)+\\'|\\'(?=" + e.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + e.src_ZCc + "|[.]|$)|" + (t["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + // allow `,,,` in paths
  ",(?!" + e.src_ZCc + "|$)|;(?!" + e.src_ZCc + "|$)|\\!+(?!" + e.src_ZCc + "|[!]|$)|\\?(?!" + e.src_ZCc + "|[?]|$))+|\\/)?", e.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', e.src_xn = "xn--[a-z0-9\\-]{1,59}", e.src_domain_root = // Allow letters & digits (http://test1)
  "(?:" + e.src_xn + "|" + e.src_pseudo_letter + "{1,63})", e.src_domain = "(?:" + e.src_xn + "|(?:" + e.src_pseudo_letter + ")|(?:" + e.src_pseudo_letter + "(?:-|" + e.src_pseudo_letter + "){0,61}" + e.src_pseudo_letter + "))", e.src_host = "(?:(?:(?:(?:" + e.src_domain + ")\\.)*" + e.src_domain + "))", e.tpl_host_fuzzy = "(?:" + e.src_ip4 + "|(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%)))", e.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%))", e.src_host_strict = e.src_host + e.src_host_terminator, e.tpl_host_fuzzy_strict = e.tpl_host_fuzzy + e.src_host_terminator, e.src_host_port_strict = e.src_host + e.src_port + e.src_host_terminator, e.tpl_host_port_fuzzy_strict = e.tpl_host_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_port_no_ip_fuzzy_strict = e.tpl_host_no_ip_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + e.src_ZPCc + "|>|$))", e.tpl_email_fuzzy = "(^|" + n + '|"|\\(|' + e.src_ZCc + ")(" + e.src_email_name + "@" + e.tpl_host_fuzzy_strict + ")", e.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_fuzzy_strict + e.src_path + ")", e.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_no_ip_fuzzy_strict + e.src_path + ")", e;
}
function vw(t) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(n) {
    n && Object.keys(n).forEach(function(r) {
      t[r] = n[r];
    });
  }), t;
}
function n5(t) {
  return Object.prototype.toString.call(t);
}
function Vkt(t) {
  return n5(t) === "[object String]";
}
function qkt(t) {
  return n5(t) === "[object Object]";
}
function Ukt(t) {
  return n5(t) === "[object RegExp]";
}
function CI(t) {
  return n5(t) === "[object Function]";
}
function Wkt(t) {
  return t.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const nJ = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function Zkt(t) {
  return Object.keys(t || {}).reduce(function(e, n) {
    return e || nJ.hasOwnProperty(n);
  }, !1);
}
const Gkt = {
  "http:": {
    validate: function(t, e, n) {
      const r = t.slice(e);
      return n.re.http || (n.re.http = new RegExp(
        "^\\/\\/" + n.re.src_auth + n.re.src_host_port_strict + n.re.src_path,
        "i"
      )), n.re.http.test(r) ? r.match(n.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(t, e, n) {
      const r = t.slice(e);
      return n.re.no_http || (n.re.no_http = new RegExp(
        "^" + n.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + n.re.src_domain + ")\\.)+" + n.re.src_domain_root + ")" + n.re.src_port + n.re.src_host_terminator + n.re.src_path,
        "i"
      )), n.re.no_http.test(r) ? e >= 3 && t[e - 3] === ":" || e >= 3 && t[e - 3] === "/" ? 0 : r.match(n.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(t, e, n) {
      const r = t.slice(e);
      return n.re.mailto || (n.re.mailto = new RegExp(
        "^" + n.re.src_email_name + "@" + n.re.src_host_strict,
        "i"
      )), n.re.mailto.test(r) ? r.match(n.re.mailto)[0].length : 0;
    }
  }
}, Ykt = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", Kkt = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function $kt(t) {
  t.__index__ = -1, t.__text_cache__ = "";
}
function Jkt(t) {
  return function(e, n) {
    const r = e.slice(n);
    return t.test(r) ? r.match(t)[0].length : 0;
  };
}
function AI() {
  return function(t, e) {
    e.normalize(t);
  };
}
function i3(t) {
  const e = t.re = _kt(t.__opts__), n = t.__tlds__.slice();
  t.onCompile(), t.__tlds_replaced__ || n.push(Ykt), n.push(e.src_xn), e.src_tlds = n.join("|");
  function r(s) {
    return s.replace("%TLDS%", e.src_tlds);
  }
  e.email_fuzzy = RegExp(r(e.tpl_email_fuzzy), "i"), e.link_fuzzy = RegExp(r(e.tpl_link_fuzzy), "i"), e.link_no_ip_fuzzy = RegExp(r(e.tpl_link_no_ip_fuzzy), "i"), e.host_fuzzy_test = RegExp(r(e.tpl_host_fuzzy_test), "i");
  const i = [];
  t.__compiled__ = {};
  function a(s, l) {
    throw new Error('(LinkifyIt) Invalid schema "' + s + '": ' + l);
  }
  Object.keys(t.__schemas__).forEach(function(s) {
    const l = t.__schemas__[s];
    if (l === null)
      return;
    const c = { validate: null, link: null };
    if (t.__compiled__[s] = c, qkt(l)) {
      Ukt(l.validate) ? c.validate = Jkt(l.validate) : CI(l.validate) ? c.validate = l.validate : a(s, l), CI(l.normalize) ? c.normalize = l.normalize : l.normalize ? a(s, l) : c.normalize = AI();
      return;
    }
    if (Vkt(l)) {
      i.push(s);
      return;
    }
    a(s, l);
  }), i.forEach(function(s) {
    t.__compiled__[t.__schemas__[s]] && (t.__compiled__[s].validate = t.__compiled__[t.__schemas__[s]].validate, t.__compiled__[s].normalize = t.__compiled__[t.__schemas__[s]].normalize);
  }), t.__compiled__[""] = { validate: null, normalize: AI() };
  const o = Object.keys(t.__compiled__).filter(function(s) {
    return s.length > 0 && t.__compiled__[s];
  }).map(Wkt).join("|");
  t.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + o + ")", "i"), t.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + o + ")", "ig"), t.re.schema_at_start = RegExp("^" + t.re.schema_search.source, "i"), t.re.pretest = RegExp(
    "(" + t.re.schema_test.source + ")|(" + t.re.host_fuzzy_test.source + ")|@",
    "i"
  ), $kt(t);
}
function Qkt(t, e) {
  const n = t.__index__, r = t.__last_index__, i = t.__text_cache__.slice(n, r);
  this.schema = t.__schema__.toLowerCase(), this.index = n + e, this.lastIndex = r + e, this.raw = i, this.text = i, this.url = i;
}
function bw(t, e) {
  const n = new Qkt(t, e);
  return t.__compiled__[n.schema].normalize(n, t), n;
}
function ra(t, e) {
  if (!(this instanceof ra))
    return new ra(t, e);
  e || Zkt(t) && (e = t, t = {}), this.__opts__ = vw({}, nJ, e), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = vw({}, Gkt, t), this.__compiled__ = {}, this.__tlds__ = Kkt, this.__tlds_replaced__ = !1, this.re = {}, i3(this);
}
ra.prototype.add = function(e, n) {
  return this.__schemas__[e] = n, i3(this), this;
};
ra.prototype.set = function(e) {
  return this.__opts__ = vw(this.__opts__, e), this;
};
ra.prototype.test = function(e) {
  if (this.__text_cache__ = e, this.__index__ = -1, !e.length)
    return !1;
  let n, r, i, a, o, s, l, c, u;
  if (this.re.schema_test.test(e)) {
    for (l = this.re.schema_search, l.lastIndex = 0; (n = l.exec(e)) !== null; )
      if (a = this.testSchemaAt(e, n[2], l.lastIndex), a) {
        this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + a;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (c = e.search(this.re.host_fuzzy_test), c >= 0 && (this.__index__ < 0 || c < this.__index__) && (r = e.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (o = r.index + r[1].length, (this.__index__ < 0 || o < this.__index__) && (this.__schema__ = "", this.__index__ = o, this.__last_index__ = r.index + r[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (u = e.indexOf("@"), u >= 0 && (i = e.match(this.re.email_fuzzy)) !== null && (o = i.index + i[1].length, s = i.index + i[0].length, (this.__index__ < 0 || o < this.__index__ || o === this.__index__ && s > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = o, this.__last_index__ = s))), this.__index__ >= 0;
};
ra.prototype.pretest = function(e) {
  return this.re.pretest.test(e);
};
ra.prototype.testSchemaAt = function(e, n, r) {
  return this.__compiled__[n.toLowerCase()] ? this.__compiled__[n.toLowerCase()].validate(e, r, this) : 0;
};
ra.prototype.match = function(e) {
  const n = [];
  let r = 0;
  this.__index__ >= 0 && this.__text_cache__ === e && (n.push(bw(this, r)), r = this.__last_index__);
  let i = r ? e.slice(r) : e;
  for (; this.test(i); )
    n.push(bw(this, r)), i = i.slice(this.__last_index__), r += this.__last_index__;
  return n.length ? n : null;
};
ra.prototype.matchAtStart = function(e) {
  if (this.__text_cache__ = e, this.__index__ = -1, !e.length) return null;
  const n = this.re.schema_at_start.exec(e);
  if (!n) return null;
  const r = this.testSchemaAt(e, n[2], n[0].length);
  return r ? (this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + r, bw(this, 0)) : null;
};
ra.prototype.tlds = function(e, n) {
  return e = Array.isArray(e) ? e : [e], n ? (this.__tlds__ = this.__tlds__.concat(e).sort().filter(function(r, i, a) {
    return r !== a[i - 1];
  }).reverse(), i3(this), this) : (this.__tlds__ = e.slice(), this.__tlds_replaced__ = !0, i3(this), this);
};
ra.prototype.normalize = function(e) {
  e.schema || (e.url = "http://" + e.url), e.schema === "mailto:" && !/^mailto:/i.test(e.url) && (e.url = "mailto:" + e.url);
};
ra.prototype.onCompile = function() {
};
const M1 = 2147483647, Ho = 36, NA = 1, A2 = 26, Xkt = 38, ext = 700, rJ = 72, iJ = 128, aJ = "-", txt = /^xn--/, nxt = /[^\0-\x7F]/, rxt = /[\x2E\u3002\uFF0E\uFF61]/g, ixt = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, wv = Ho - NA, Fo = Math.floor, kv = String.fromCharCode;
function Gl(t) {
  throw new RangeError(ixt[t]);
}
function axt(t, e) {
  const n = [];
  let r = t.length;
  for (; r--; )
    n[r] = e(t[r]);
  return n;
}
function oJ(t, e) {
  const n = t.split("@");
  let r = "";
  n.length > 1 && (r = n[0] + "@", t = n[1]), t = t.replace(rxt, ".");
  const i = t.split("."), a = axt(i, e).join(".");
  return r + a;
}
function sJ(t) {
  const e = [];
  let n = 0;
  const r = t.length;
  for (; n < r; ) {
    const i = t.charCodeAt(n++);
    if (i >= 55296 && i <= 56319 && n < r) {
      const a = t.charCodeAt(n++);
      (a & 64512) == 56320 ? e.push(((i & 1023) << 10) + (a & 1023) + 65536) : (e.push(i), n--);
    } else
      e.push(i);
  }
  return e;
}
const oxt = (t) => String.fromCodePoint(...t), sxt = function(t) {
  return t >= 48 && t < 58 ? 26 + (t - 48) : t >= 65 && t < 91 ? t - 65 : t >= 97 && t < 123 ? t - 97 : Ho;
}, SI = function(t, e) {
  return t + 22 + 75 * (t < 26) - ((e != 0) << 5);
}, lJ = function(t, e, n) {
  let r = 0;
  for (t = n ? Fo(t / ext) : t >> 1, t += Fo(t / e); t > wv * A2 >> 1; r += Ho)
    t = Fo(t / wv);
  return Fo(r + (wv + 1) * t / (t + Xkt));
}, cJ = function(t) {
  const e = [], n = t.length;
  let r = 0, i = iJ, a = rJ, o = t.lastIndexOf(aJ);
  o < 0 && (o = 0);
  for (let s = 0; s < o; ++s)
    t.charCodeAt(s) >= 128 && Gl("not-basic"), e.push(t.charCodeAt(s));
  for (let s = o > 0 ? o + 1 : 0; s < n; ) {
    const l = r;
    for (let u = 1, d = Ho; ; d += Ho) {
      s >= n && Gl("invalid-input");
      const f = sxt(t.charCodeAt(s++));
      f >= Ho && Gl("invalid-input"), f > Fo((M1 - r) / u) && Gl("overflow"), r += f * u;
      const h = d <= a ? NA : d >= a + A2 ? A2 : d - a;
      if (f < h)
        break;
      const p = Ho - h;
      u > Fo(M1 / p) && Gl("overflow"), u *= p;
    }
    const c = e.length + 1;
    a = lJ(r - l, c, l == 0), Fo(r / c) > M1 - i && Gl("overflow"), i += Fo(r / c), r %= c, e.splice(r++, 0, i);
  }
  return String.fromCodePoint(...e);
}, uJ = function(t) {
  const e = [];
  t = sJ(t);
  const n = t.length;
  let r = iJ, i = 0, a = rJ;
  for (const l of t)
    l < 128 && e.push(kv(l));
  const o = e.length;
  let s = o;
  for (o && e.push(aJ); s < n; ) {
    let l = M1;
    for (const u of t)
      u >= r && u < l && (l = u);
    const c = s + 1;
    l - r > Fo((M1 - i) / c) && Gl("overflow"), i += (l - r) * c, r = l;
    for (const u of t)
      if (u < r && ++i > M1 && Gl("overflow"), u === r) {
        let d = i;
        for (let f = Ho; ; f += Ho) {
          const h = f <= a ? NA : f >= a + A2 ? A2 : f - a;
          if (d < h)
            break;
          const p = d - h, m = Ho - h;
          e.push(
            kv(SI(h + p % m, 0))
          ), d = Fo(p / m);
        }
        e.push(kv(SI(d, 0))), a = lJ(i, c, s === o), i = 0, ++s;
      }
    ++i, ++r;
  }
  return e.join("");
}, lxt = function(t) {
  return oJ(t, function(e) {
    return txt.test(e) ? cJ(e.slice(4).toLowerCase()) : e;
  });
}, cxt = function(t) {
  return oJ(t, function(e) {
    return nxt.test(e) ? "xn--" + uJ(e) : e;
  });
}, dJ = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.3.1",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: sJ,
    encode: oxt
  },
  decode: cJ,
  encode: uJ,
  toASCII: cxt,
  toUnicode: lxt
}, uxt = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 100
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, dxt = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, fxt = {
  options: {
    // Enable HTML tags in source
    html: !0,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !0,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, hxt = {
  default: uxt,
  zero: dxt,
  commonmark: fxt
}, pxt = /^(vbscript|javascript|file|data):/, mxt = /^data:image\/(gif|png|jpeg|webp);/;
function yxt(t) {
  const e = t.trim().toLowerCase();
  return pxt.test(e) ? mxt.test(e) : !0;
}
const fJ = ["http:", "https:", "mailto:"];
function gxt(t) {
  const e = AA(t, !0);
  if (e.hostname && (!e.protocol || fJ.indexOf(e.protocol) >= 0))
    try {
      e.hostname = dJ.toASCII(e.hostname);
    } catch {
    }
  return Vp(CA(e));
}
function vxt(t) {
  const e = AA(t, !0);
  if (e.hostname && (!e.protocol || fJ.indexOf(e.protocol) >= 0))
    try {
      e.hostname = dJ.toUnicode(e.hostname);
    } catch {
    }
  return id(CA(e), id.defaultChars + "%");
}
function _r(t, e) {
  if (!(this instanceof _r))
    return new _r(t, e);
  e || LA(t) || (e = t || {}, t = "default"), this.inline = new Up(), this.block = new t5(), this.core = new EA(), this.renderer = new _d(), this.linkify = new ra(), this.validateLink = yxt, this.normalizeLink = gxt, this.normalizeLinkText = vxt, this.utils = wwt, this.helpers = X6({}, Cwt), this.options = {}, this.configure(t), e && this.set(e);
}
_r.prototype.set = function(t) {
  return X6(this.options, t), this;
};
_r.prototype.configure = function(t) {
  const e = this;
  if (LA(t)) {
    const n = t;
    if (t = hxt[n], !t)
      throw new Error('Wrong `markdown-it` preset "' + n + '", check name');
  }
  if (!t)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return t.options && e.set(t.options), t.components && Object.keys(t.components).forEach(function(n) {
    t.components[n].rules && e[n].ruler.enableOnly(t.components[n].rules), t.components[n].rules2 && e[n].ruler2.enableOnly(t.components[n].rules2);
  }), this;
};
_r.prototype.enable = function(t, e) {
  let n = [];
  Array.isArray(t) || (t = [t]), ["core", "block", "inline"].forEach(function(i) {
    n = n.concat(this[i].ruler.enable(t, !0));
  }, this), n = n.concat(this.inline.ruler2.enable(t, !0));
  const r = t.filter(function(i) {
    return n.indexOf(i) < 0;
  });
  if (r.length && !e)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + r);
  return this;
};
_r.prototype.disable = function(t, e) {
  let n = [];
  Array.isArray(t) || (t = [t]), ["core", "block", "inline"].forEach(function(i) {
    n = n.concat(this[i].ruler.disable(t, !0));
  }, this), n = n.concat(this.inline.ruler2.disable(t, !0));
  const r = t.filter(function(i) {
    return n.indexOf(i) < 0;
  });
  if (r.length && !e)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + r);
  return this;
};
_r.prototype.use = function(t) {
  const e = [this].concat(Array.prototype.slice.call(arguments, 1));
  return t.apply(t, e), this;
};
_r.prototype.parse = function(t, e) {
  if (typeof t != "string")
    throw new Error("Input data should be a String");
  const n = new this.core.State(t, this, e);
  return this.core.process(n), n.tokens;
};
_r.prototype.render = function(t, e) {
  return e = e || {}, this.renderer.render(this.parse(t, e), this.options, e);
};
_r.prototype.parseInline = function(t, e) {
  const n = new this.core.State(t, this, e);
  return n.inlineMode = !0, this.core.process(n), n.tokens;
};
_r.prototype.renderInline = function(t, e) {
  return e = e || {}, this.renderer.render(this.parseInline(t, e), this.options, e);
};
/*! @license DOMPurify 3.2.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.4/LICENSE */
const {
  entries: hJ,
  setPrototypeOf: LI,
  isFrozen: bxt,
  getPrototypeOf: wxt,
  getOwnPropertyDescriptor: kxt
} = Object;
let {
  freeze: mi,
  seal: za,
  create: pJ
} = Object, {
  apply: ww,
  construct: kw
} = typeof Reflect < "u" && Reflect;
mi || (mi = function(e) {
  return e;
});
za || (za = function(e) {
  return e;
});
ww || (ww = function(e, n, r) {
  return e.apply(n, r);
});
kw || (kw = function(e, n) {
  return new e(...n);
});
const Km = yi(Array.prototype.forEach), xxt = yi(Array.prototype.lastIndexOf), TI = yi(Array.prototype.pop), vf = yi(Array.prototype.push), Mxt = yi(Array.prototype.splice), K4 = yi(String.prototype.toLowerCase), xv = yi(String.prototype.toString), EI = yi(String.prototype.match), bf = yi(String.prototype.replace), Cxt = yi(String.prototype.indexOf), Axt = yi(String.prototype.trim), qa = yi(Object.prototype.hasOwnProperty), ri = yi(RegExp.prototype.test), wf = Sxt(TypeError);
function yi(t) {
  return function(e) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    return ww(t, e, r);
  };
}
function Sxt(t) {
  return function() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return kw(t, n);
  };
}
function Xt(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : K4;
  LI && LI(t, null);
  let r = e.length;
  for (; r--; ) {
    let i = e[r];
    if (typeof i == "string") {
      const a = n(i);
      a !== i && (bxt(e) || (e[r] = a), i = a);
    }
    t[i] = !0;
  }
  return t;
}
function Lxt(t) {
  for (let e = 0; e < t.length; e++)
    qa(t, e) || (t[e] = null);
  return t;
}
function du(t) {
  const e = pJ(null);
  for (const [n, r] of hJ(t))
    qa(t, n) && (Array.isArray(r) ? e[n] = Lxt(r) : r && typeof r == "object" && r.constructor === Object ? e[n] = du(r) : e[n] = r);
  return e;
}
function kf(t, e) {
  for (; t !== null; ) {
    const r = kxt(t, e);
    if (r) {
      if (r.get)
        return yi(r.get);
      if (typeof r.value == "function")
        return yi(r.value);
    }
    t = wxt(t);
  }
  function n() {
    return null;
  }
  return n;
}
const jI = mi(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Mv = mi(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Cv = mi(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Txt = mi(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Av = mi(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Ext = mi(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), NI = mi(["#text"]), DI = mi(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Sv = mi(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), II = mi(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), $m = mi(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), jxt = za(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Nxt = za(/<%[\w\W]*|[\w\W]*%>/gm), Dxt = za(/\$\{[\w\W]*/gm), Ixt = za(/^data-[\-\w.\u00B7-\uFFFF]+$/), Pxt = za(/^aria-[\-\w]+$/), mJ = za(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), zxt = za(/^(?:\w+script|data):/i), Rxt = za(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), yJ = za(/^html$/i), Oxt = za(/^[a-z][.\w]*(-[.\w]+)+$/i);
var PI = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: Pxt,
  ATTR_WHITESPACE: Rxt,
  CUSTOM_ELEMENT: Oxt,
  DATA_ATTR: Ixt,
  DOCTYPE_NAME: yJ,
  ERB_EXPR: Nxt,
  IS_ALLOWED_URI: mJ,
  IS_SCRIPT_OR_DATA: zxt,
  MUSTACHE_EXPR: jxt,
  TMPLIT_EXPR: Dxt
});
const xf = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, Bxt = function() {
  return typeof window > "u" ? null : window;
}, Hxt = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, zI = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function gJ() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Bxt();
  const e = (Te) => gJ(Te);
  if (e.version = "3.2.4", e.removed = [], !t || !t.document || t.document.nodeType !== xf.document || !t.Element)
    return e.isSupported = !1, e;
  let {
    document: n
  } = t;
  const r = n, i = r.currentScript, {
    DocumentFragment: a,
    HTMLTemplateElement: o,
    Node: s,
    Element: l,
    NodeFilter: c,
    NamedNodeMap: u = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: d,
    DOMParser: f,
    trustedTypes: h
  } = t, p = l.prototype, m = kf(p, "cloneNode"), g = kf(p, "remove"), v = kf(p, "nextSibling"), k = kf(p, "childNodes"), w = kf(p, "parentNode");
  if (typeof o == "function") {
    const Te = n.createElement("template");
    Te.content && Te.content.ownerDocument && (n = Te.content.ownerDocument);
  }
  let b, x = "";
  const {
    implementation: A,
    createNodeIterator: L,
    createDocumentFragment: M,
    getElementsByTagName: j
  } = n, {
    importNode: D
  } = r;
  let z = zI();
  e.isSupported = typeof hJ == "function" && typeof w == "function" && A && A.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: H,
    ERB_EXPR: V,
    TMPLIT_EXPR: F,
    DATA_ATTR: _,
    ARIA_ATTR: W,
    IS_SCRIPT_OR_DATA: G,
    ATTR_WHITESPACE: Y,
    CUSTOM_ELEMENT: Z
  } = PI;
  let {
    IS_ALLOWED_URI: oe
  } = PI, ee = null;
  const ae = Xt({}, [...jI, ...Mv, ...Cv, ...Av, ...NI]);
  let fe = null;
  const me = Xt({}, [...DI, ...Sv, ...II, ...$m]);
  let ge = Object.seal(pJ(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), $ = null, se = null, xe = !0, Oe = !0, je = !1, Me = !0, he = !1, pe = !0, J = !1, K = !1, X = !1, re = !1, Ie = !1, q = !1, S = !0, P = !1;
  const O = "user-content-";
  let ne = !0, le = !1, de = {}, Pe = null;
  const ve = Xt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Le = null;
  const Re = Xt({}, ["audio", "video", "img", "source", "image", "track"]);
  let Ke = null;
  const mt = Xt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), pt = "http://www.w3.org/1998/Math/MathML", Nt = "http://www.w3.org/2000/svg", ye = "http://www.w3.org/1999/xhtml";
  let _e = ye, we = !1, $e = null;
  const Xe = Xt({}, [pt, Nt, ye], xv);
  let Be = Xt({}, ["mi", "mo", "mn", "ms", "mtext"]), et = Xt({}, ["annotation-xml"]);
  const dt = Xt({}, ["title", "style", "font", "a", "script"]);
  let ut = null;
  const Pt = ["application/xhtml+xml", "text/html"], Vt = "text/html";
  let kt = null, sn = null;
  const Sn = n.createElement("form"), ht = function(Q) {
    return Q instanceof RegExp || Q instanceof Function;
  }, gn = function() {
    let Q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(sn && sn === Q)) {
      if ((!Q || typeof Q != "object") && (Q = {}), Q = du(Q), ut = // eslint-disable-next-line unicorn/prefer-includes
      Pt.indexOf(Q.PARSER_MEDIA_TYPE) === -1 ? Vt : Q.PARSER_MEDIA_TYPE, kt = ut === "application/xhtml+xml" ? xv : K4, ee = qa(Q, "ALLOWED_TAGS") ? Xt({}, Q.ALLOWED_TAGS, kt) : ae, fe = qa(Q, "ALLOWED_ATTR") ? Xt({}, Q.ALLOWED_ATTR, kt) : me, $e = qa(Q, "ALLOWED_NAMESPACES") ? Xt({}, Q.ALLOWED_NAMESPACES, xv) : Xe, Ke = qa(Q, "ADD_URI_SAFE_ATTR") ? Xt(du(mt), Q.ADD_URI_SAFE_ATTR, kt) : mt, Le = qa(Q, "ADD_DATA_URI_TAGS") ? Xt(du(Re), Q.ADD_DATA_URI_TAGS, kt) : Re, Pe = qa(Q, "FORBID_CONTENTS") ? Xt({}, Q.FORBID_CONTENTS, kt) : ve, $ = qa(Q, "FORBID_TAGS") ? Xt({}, Q.FORBID_TAGS, kt) : {}, se = qa(Q, "FORBID_ATTR") ? Xt({}, Q.FORBID_ATTR, kt) : {}, de = qa(Q, "USE_PROFILES") ? Q.USE_PROFILES : !1, xe = Q.ALLOW_ARIA_ATTR !== !1, Oe = Q.ALLOW_DATA_ATTR !== !1, je = Q.ALLOW_UNKNOWN_PROTOCOLS || !1, Me = Q.ALLOW_SELF_CLOSE_IN_ATTR !== !1, he = Q.SAFE_FOR_TEMPLATES || !1, pe = Q.SAFE_FOR_XML !== !1, J = Q.WHOLE_DOCUMENT || !1, re = Q.RETURN_DOM || !1, Ie = Q.RETURN_DOM_FRAGMENT || !1, q = Q.RETURN_TRUSTED_TYPE || !1, X = Q.FORCE_BODY || !1, S = Q.SANITIZE_DOM !== !1, P = Q.SANITIZE_NAMED_PROPS || !1, ne = Q.KEEP_CONTENT !== !1, le = Q.IN_PLACE || !1, oe = Q.ALLOWED_URI_REGEXP || mJ, _e = Q.NAMESPACE || ye, Be = Q.MATHML_TEXT_INTEGRATION_POINTS || Be, et = Q.HTML_INTEGRATION_POINTS || et, ge = Q.CUSTOM_ELEMENT_HANDLING || {}, Q.CUSTOM_ELEMENT_HANDLING && ht(Q.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (ge.tagNameCheck = Q.CUSTOM_ELEMENT_HANDLING.tagNameCheck), Q.CUSTOM_ELEMENT_HANDLING && ht(Q.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (ge.attributeNameCheck = Q.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), Q.CUSTOM_ELEMENT_HANDLING && typeof Q.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (ge.allowCustomizedBuiltInElements = Q.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), he && (Oe = !1), Ie && (re = !0), de && (ee = Xt({}, NI), fe = [], de.html === !0 && (Xt(ee, jI), Xt(fe, DI)), de.svg === !0 && (Xt(ee, Mv), Xt(fe, Sv), Xt(fe, $m)), de.svgFilters === !0 && (Xt(ee, Cv), Xt(fe, Sv), Xt(fe, $m)), de.mathMl === !0 && (Xt(ee, Av), Xt(fe, II), Xt(fe, $m))), Q.ADD_TAGS && (ee === ae && (ee = du(ee)), Xt(ee, Q.ADD_TAGS, kt)), Q.ADD_ATTR && (fe === me && (fe = du(fe)), Xt(fe, Q.ADD_ATTR, kt)), Q.ADD_URI_SAFE_ATTR && Xt(Ke, Q.ADD_URI_SAFE_ATTR, kt), Q.FORBID_CONTENTS && (Pe === ve && (Pe = du(Pe)), Xt(Pe, Q.FORBID_CONTENTS, kt)), ne && (ee["#text"] = !0), J && Xt(ee, ["html", "head", "body"]), ee.table && (Xt(ee, ["tbody"]), delete $.tbody), Q.TRUSTED_TYPES_POLICY) {
        if (typeof Q.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw wf('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof Q.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw wf('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        b = Q.TRUSTED_TYPES_POLICY, x = b.createHTML("");
      } else
        b === void 0 && (b = Hxt(h, i)), b !== null && typeof x == "string" && (x = b.createHTML(""));
      mi && mi(Q), sn = Q;
    }
  }, Jn = Xt({}, [...Mv, ...Cv, ...Txt]), Er = Xt({}, [...Av, ...Ext]), ca = function(Q) {
    let Se = w(Q);
    (!Se || !Se.tagName) && (Se = {
      namespaceURI: _e,
      tagName: "template"
    });
    const Fe = K4(Q.tagName), Rt = K4(Se.tagName);
    return $e[Q.namespaceURI] ? Q.namespaceURI === Nt ? Se.namespaceURI === ye ? Fe === "svg" : Se.namespaceURI === pt ? Fe === "svg" && (Rt === "annotation-xml" || Be[Rt]) : !!Jn[Fe] : Q.namespaceURI === pt ? Se.namespaceURI === ye ? Fe === "math" : Se.namespaceURI === Nt ? Fe === "math" && et[Rt] : !!Er[Fe] : Q.namespaceURI === ye ? Se.namespaceURI === Nt && !et[Rt] || Se.namespaceURI === pt && !Be[Rt] ? !1 : !Er[Fe] && (dt[Fe] || !Jn[Fe]) : !!(ut === "application/xhtml+xml" && $e[Q.namespaceURI]) : !1;
  }, ur = function(Q) {
    vf(e.removed, {
      element: Q
    });
    try {
      w(Q).removeChild(Q);
    } catch {
      g(Q);
    }
  }, Co = function(Q, Se) {
    try {
      vf(e.removed, {
        attribute: Se.getAttributeNode(Q),
        from: Se
      });
    } catch {
      vf(e.removed, {
        attribute: null,
        from: Se
      });
    }
    if (Se.removeAttribute(Q), Q === "is")
      if (re || Ie)
        try {
          ur(Se);
        } catch {
        }
      else
        try {
          Se.setAttribute(Q, "");
        } catch {
        }
  }, jl = function(Q) {
    let Se = null, Fe = null;
    if (X)
      Q = "<remove></remove>" + Q;
    else {
      const Dt = EI(Q, /^[\r\n\t ]+/);
      Fe = Dt && Dt[0];
    }
    ut === "application/xhtml+xml" && _e === ye && (Q = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + Q + "</body></html>");
    const Rt = b ? b.createHTML(Q) : Q;
    if (_e === ye)
      try {
        Se = new f().parseFromString(Rt, ut);
      } catch {
      }
    if (!Se || !Se.documentElement) {
      Se = A.createDocument(_e, "template", null);
      try {
        Se.documentElement.innerHTML = we ? x : Rt;
      } catch {
      }
    }
    const Qt = Se.body || Se.documentElement;
    return Q && Fe && Qt.insertBefore(n.createTextNode(Fe), Qt.childNodes[0] || null), _e === ye ? j.call(Se, J ? "html" : "body")[0] : J ? Se.documentElement : Qt;
  }, Nl = function(Q) {
    return L.call(
      Q.ownerDocument || Q,
      Q,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, R = function(Q) {
    return Q instanceof d && (typeof Q.nodeName != "string" || typeof Q.textContent != "string" || typeof Q.removeChild != "function" || !(Q.attributes instanceof u) || typeof Q.removeAttribute != "function" || typeof Q.setAttribute != "function" || typeof Q.namespaceURI != "string" || typeof Q.insertBefore != "function" || typeof Q.hasChildNodes != "function");
  }, ue = function(Q) {
    return typeof s == "function" && Q instanceof s;
  };
  function Ae(Te, Q, Se) {
    Km(Te, (Fe) => {
      Fe.call(e, Q, Se, sn);
    });
  }
  const Ve = function(Q) {
    let Se = null;
    if (Ae(z.beforeSanitizeElements, Q, null), R(Q))
      return ur(Q), !0;
    const Fe = kt(Q.nodeName);
    if (Ae(z.uponSanitizeElement, Q, {
      tagName: Fe,
      allowedTags: ee
    }), Q.hasChildNodes() && !ue(Q.firstElementChild) && ri(/<[/\w]/g, Q.innerHTML) && ri(/<[/\w]/g, Q.textContent) || Q.nodeType === xf.progressingInstruction || pe && Q.nodeType === xf.comment && ri(/<[/\w]/g, Q.data))
      return ur(Q), !0;
    if (!ee[Fe] || $[Fe]) {
      if (!$[Fe] && yt(Fe) && (ge.tagNameCheck instanceof RegExp && ri(ge.tagNameCheck, Fe) || ge.tagNameCheck instanceof Function && ge.tagNameCheck(Fe)))
        return !1;
      if (ne && !Pe[Fe]) {
        const Rt = w(Q) || Q.parentNode, Qt = k(Q) || Q.childNodes;
        if (Qt && Rt) {
          const Dt = Qt.length;
          for (let Ln = Dt - 1; Ln >= 0; --Ln) {
            const vi = m(Qt[Ln], !0);
            vi.__removalCount = (Q.__removalCount || 0) + 1, Rt.insertBefore(vi, v(Q));
          }
        }
      }
      return ur(Q), !0;
    }
    return Q instanceof l && !ca(Q) || (Fe === "noscript" || Fe === "noembed" || Fe === "noframes") && ri(/<\/no(script|embed|frames)/i, Q.innerHTML) ? (ur(Q), !0) : (he && Q.nodeType === xf.text && (Se = Q.textContent, Km([H, V, F], (Rt) => {
      Se = bf(Se, Rt, " ");
    }), Q.textContent !== Se && (vf(e.removed, {
      element: Q.cloneNode()
    }), Q.textContent = Se)), Ae(z.afterSanitizeElements, Q, null), !1);
  }, ct = function(Q, Se, Fe) {
    if (S && (Se === "id" || Se === "name") && (Fe in n || Fe in Sn))
      return !1;
    if (!(Oe && !se[Se] && ri(_, Se))) {
      if (!(xe && ri(W, Se))) {
        if (!fe[Se] || se[Se]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(yt(Q) && (ge.tagNameCheck instanceof RegExp && ri(ge.tagNameCheck, Q) || ge.tagNameCheck instanceof Function && ge.tagNameCheck(Q)) && (ge.attributeNameCheck instanceof RegExp && ri(ge.attributeNameCheck, Se) || ge.attributeNameCheck instanceof Function && ge.attributeNameCheck(Se)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            Se === "is" && ge.allowCustomizedBuiltInElements && (ge.tagNameCheck instanceof RegExp && ri(ge.tagNameCheck, Fe) || ge.tagNameCheck instanceof Function && ge.tagNameCheck(Fe)))
          ) return !1;
        } else if (!Ke[Se]) {
          if (!ri(oe, bf(Fe, Y, ""))) {
            if (!((Se === "src" || Se === "xlink:href" || Se === "href") && Q !== "script" && Cxt(Fe, "data:") === 0 && Le[Q])) {
              if (!(je && !ri(G, bf(Fe, Y, "")))) {
                if (Fe)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, yt = function(Q) {
    return Q !== "annotation-xml" && EI(Q, Z);
  }, rt = function(Q) {
    Ae(z.beforeSanitizeAttributes, Q, null);
    const {
      attributes: Se
    } = Q;
    if (!Se || R(Q))
      return;
    const Fe = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: fe,
      forceKeepAttr: void 0
    };
    let Rt = Se.length;
    for (; Rt--; ) {
      const Qt = Se[Rt], {
        name: Dt,
        namespaceURI: Ln,
        value: vi
      } = Qt, xs = kt(Dt);
      let ni = Dt === "value" ? vi : Axt(vi);
      if (Fe.attrName = xs, Fe.attrValue = ni, Fe.keepAttr = !0, Fe.forceKeepAttr = void 0, Ae(z.uponSanitizeAttribute, Q, Fe), ni = Fe.attrValue, P && (xs === "id" || xs === "name") && (Co(Dt, Q), ni = O + ni), pe && ri(/((--!?|])>)|<\/(style|title)/i, ni)) {
        Co(Dt, Q);
        continue;
      }
      if (Fe.forceKeepAttr || (Co(Dt, Q), !Fe.keepAttr))
        continue;
      if (!Me && ri(/\/>/i, ni)) {
        Co(Dt, Q);
        continue;
      }
      he && Km([H, V, F], (ZL) => {
        ni = bf(ni, ZL, " ");
      });
      const WL = kt(Q.nodeName);
      if (ct(WL, xs, ni)) {
        if (b && typeof h == "object" && typeof h.getAttributeType == "function" && !Ln)
          switch (h.getAttributeType(WL, xs)) {
            case "TrustedHTML": {
              ni = b.createHTML(ni);
              break;
            }
            case "TrustedScriptURL": {
              ni = b.createScriptURL(ni);
              break;
            }
          }
        try {
          Ln ? Q.setAttributeNS(Ln, Dt, ni) : Q.setAttribute(Dt, ni), R(Q) ? ur(Q) : TI(e.removed);
        } catch {
        }
      }
    }
    Ae(z.afterSanitizeAttributes, Q, null);
  }, tt = function Te(Q) {
    let Se = null;
    const Fe = Nl(Q);
    for (Ae(z.beforeSanitizeShadowDOM, Q, null); Se = Fe.nextNode(); )
      Ae(z.uponSanitizeShadowNode, Se, null), Ve(Se), rt(Se), Se.content instanceof a && Te(Se.content);
    Ae(z.afterSanitizeShadowDOM, Q, null);
  };
  return e.sanitize = function(Te) {
    let Q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Se = null, Fe = null, Rt = null, Qt = null;
    if (we = !Te, we && (Te = "<!-->"), typeof Te != "string" && !ue(Te))
      if (typeof Te.toString == "function") {
        if (Te = Te.toString(), typeof Te != "string")
          throw wf("dirty is not a string, aborting");
      } else
        throw wf("toString is not a function");
    if (!e.isSupported)
      return Te;
    if (K || gn(Q), e.removed = [], typeof Te == "string" && (le = !1), le) {
      if (Te.nodeName) {
        const vi = kt(Te.nodeName);
        if (!ee[vi] || $[vi])
          throw wf("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Te instanceof s)
      Se = jl("<!---->"), Fe = Se.ownerDocument.importNode(Te, !0), Fe.nodeType === xf.element && Fe.nodeName === "BODY" || Fe.nodeName === "HTML" ? Se = Fe : Se.appendChild(Fe);
    else {
      if (!re && !he && !J && // eslint-disable-next-line unicorn/prefer-includes
      Te.indexOf("<") === -1)
        return b && q ? b.createHTML(Te) : Te;
      if (Se = jl(Te), !Se)
        return re ? null : q ? x : "";
    }
    Se && X && ur(Se.firstChild);
    const Dt = Nl(le ? Te : Se);
    for (; Rt = Dt.nextNode(); )
      Ve(Rt), rt(Rt), Rt.content instanceof a && tt(Rt.content);
    if (le)
      return Te;
    if (re) {
      if (Ie)
        for (Qt = M.call(Se.ownerDocument); Se.firstChild; )
          Qt.appendChild(Se.firstChild);
      else
        Qt = Se;
      return (fe.shadowroot || fe.shadowrootmode) && (Qt = D.call(r, Qt, !0)), Qt;
    }
    let Ln = J ? Se.outerHTML : Se.innerHTML;
    return J && ee["!doctype"] && Se.ownerDocument && Se.ownerDocument.doctype && Se.ownerDocument.doctype.name && ri(yJ, Se.ownerDocument.doctype.name) && (Ln = "<!DOCTYPE " + Se.ownerDocument.doctype.name + `>
` + Ln), he && Km([H, V, F], (vi) => {
      Ln = bf(Ln, vi, " ");
    }), b && q ? b.createHTML(Ln) : Ln;
  }, e.setConfig = function() {
    let Te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    gn(Te), K = !0;
  }, e.clearConfig = function() {
    sn = null, K = !1;
  }, e.isValidAttribute = function(Te, Q, Se) {
    sn || gn({});
    const Fe = kt(Te), Rt = kt(Q);
    return ct(Fe, Rt, Se);
  }, e.addHook = function(Te, Q) {
    typeof Q == "function" && vf(z[Te], Q);
  }, e.removeHook = function(Te, Q) {
    if (Q !== void 0) {
      const Se = xxt(z[Te], Q);
      return Se === -1 ? void 0 : Mxt(z[Te], Se, 1)[0];
    }
    return TI(z[Te]);
  }, e.removeHooks = function(Te) {
    z[Te] = [];
  }, e.removeAllHooks = function() {
    z = zI();
  }, e;
}
var vJ = gJ();
function Fxt(t, e, n, r) {
  const i = Number(t[e].meta.id + 1).toString();
  let a = "";
  return typeof r.docId == "string" && (a = `-${r.docId}-`), a + i;
}
function _xt(t, e) {
  let n = Number(t[e].meta.id + 1).toString();
  return t[e].meta.subId > 0 && (n += `:${t[e].meta.subId}`), `[${n}]`;
}
function Vxt(t, e, n, r, i) {
  const a = i.rules.footnote_anchor_name(t, e, n, r, i), o = i.rules.footnote_caption(t, e, n, r, i);
  let s = a;
  return t[e].meta.subId > 0 && (s += `:${t[e].meta.subId}`), `<sup class="footnote-ref"><a href="#fn${a}" id="fnref${s}">${o}</a></sup>`;
}
function qxt(t, e, n) {
  return (n.xhtmlOut ? `<hr class="footnotes-sep" />
` : `<hr class="footnotes-sep">
`) + `<section class="footnotes">
<ol class="footnotes-list">
`;
}
function Uxt() {
  return `</ol>
</section>
`;
}
function Wxt(t, e, n, r, i) {
  let a = i.rules.footnote_anchor_name(t, e, n, r, i);
  return t[e].meta.subId > 0 && (a += `:${t[e].meta.subId}`), `<li id="fn${a}" class="footnote-item">`;
}
function Zxt() {
  return `</li>
`;
}
function Gxt(t, e, n, r, i) {
  let a = i.rules.footnote_anchor_name(t, e, n, r, i);
  return t[e].meta.subId > 0 && (a += `:${t[e].meta.subId}`), ` <a href="#fnref${a}" class="footnote-backref">↩︎</a>`;
}
function bJ(t) {
  const e = t.helpers.parseLinkLabel, n = t.utils.isSpace;
  t.renderer.rules.footnote_ref = Vxt, t.renderer.rules.footnote_block_open = qxt, t.renderer.rules.footnote_block_close = Uxt, t.renderer.rules.footnote_open = Wxt, t.renderer.rules.footnote_close = Zxt, t.renderer.rules.footnote_anchor = Gxt, t.renderer.rules.footnote_caption = _xt, t.renderer.rules.footnote_anchor_name = Fxt;
  function r(s, l, c, u) {
    const d = s.bMarks[l] + s.tShift[l], f = s.eMarks[l];
    if (d + 4 > f || s.src.charCodeAt(d) !== 91 || s.src.charCodeAt(d + 1) !== 94) return !1;
    let h;
    for (h = d + 2; h < f; h++) {
      if (s.src.charCodeAt(h) === 32) return !1;
      if (s.src.charCodeAt(h) === 93)
        break;
    }
    if (h === d + 2 || h + 1 >= f || s.src.charCodeAt(++h) !== 58) return !1;
    if (u) return !0;
    h++, s.env.footnotes || (s.env.footnotes = {}), s.env.footnotes.refs || (s.env.footnotes.refs = {});
    const p = s.src.slice(d + 2, h - 2);
    s.env.footnotes.refs[`:${p}`] = -1;
    const m = new s.Token("footnote_reference_open", "", 1);
    m.meta = { label: p }, m.level = s.level++, s.tokens.push(m);
    const g = s.bMarks[l], v = s.tShift[l], k = s.sCount[l], w = s.parentType, b = h, x = s.sCount[l] + h - (s.bMarks[l] + s.tShift[l]);
    let A = x;
    for (; h < f; ) {
      const M = s.src.charCodeAt(h);
      if (n(M))
        M === 9 ? A += 4 - A % 4 : A++;
      else
        break;
      h++;
    }
    s.tShift[l] = h - b, s.sCount[l] = A - x, s.bMarks[l] = b, s.blkIndent += 4, s.parentType = "footnote", s.sCount[l] < s.blkIndent && (s.sCount[l] += s.blkIndent), s.md.block.tokenize(s, l, c, !0), s.parentType = w, s.blkIndent -= 4, s.tShift[l] = v, s.sCount[l] = k, s.bMarks[l] = g;
    const L = new s.Token("footnote_reference_close", "", -1);
    return L.level = --s.level, s.tokens.push(L), !0;
  }
  function i(s, l) {
    const c = s.posMax, u = s.pos;
    if (u + 2 >= c || s.src.charCodeAt(u) !== 94 || s.src.charCodeAt(u + 1) !== 91) return !1;
    const d = u + 2, f = e(s, u + 1);
    if (f < 0) return !1;
    if (!l) {
      s.env.footnotes || (s.env.footnotes = {}), s.env.footnotes.list || (s.env.footnotes.list = []);
      const h = s.env.footnotes.list.length, p = [];
      s.md.inline.parse(
        s.src.slice(d, f),
        s.md,
        s.env,
        p
      );
      const m = s.push("footnote_ref", "", 0);
      m.meta = { id: h }, s.env.footnotes.list[h] = {
        content: s.src.slice(d, f),
        tokens: p
      };
    }
    return s.pos = f + 1, s.posMax = c, !0;
  }
  function a(s, l) {
    const c = s.posMax, u = s.pos;
    if (u + 3 > c || !s.env.footnotes || !s.env.footnotes.refs || s.src.charCodeAt(u) !== 91 || s.src.charCodeAt(u + 1) !== 94) return !1;
    let d;
    for (d = u + 2; d < c; d++) {
      if (s.src.charCodeAt(d) === 32 || s.src.charCodeAt(d) === 10) return !1;
      if (s.src.charCodeAt(d) === 93)
        break;
    }
    if (d === u + 2 || d >= c) return !1;
    d++;
    const f = s.src.slice(u + 2, d - 1);
    if (typeof s.env.footnotes.refs[`:${f}`] > "u") return !1;
    if (!l) {
      s.env.footnotes.list || (s.env.footnotes.list = []);
      let h;
      s.env.footnotes.refs[`:${f}`] < 0 ? (h = s.env.footnotes.list.length, s.env.footnotes.list[h] = { label: f, count: 0 }, s.env.footnotes.refs[`:${f}`] = h) : h = s.env.footnotes.refs[`:${f}`];
      const p = s.env.footnotes.list[h].count;
      s.env.footnotes.list[h].count++;
      const m = s.push("footnote_ref", "", 0);
      m.meta = { id: h, subId: p, label: f };
    }
    return s.pos = d, s.posMax = c, !0;
  }
  function o(s) {
    let l, c, u, d = !1;
    const f = {};
    if (!s.env.footnotes || (s.tokens = s.tokens.filter(function(p) {
      return p.type === "footnote_reference_open" ? (d = !0, c = [], u = p.meta.label, !1) : p.type === "footnote_reference_close" ? (d = !1, f[":" + u] = c, !1) : (d && c.push(p), !d);
    }), !s.env.footnotes.list))
      return;
    const h = s.env.footnotes.list;
    s.tokens.push(new s.Token("footnote_block_open", "", 1));
    for (let p = 0, m = h.length; p < m; p++) {
      const g = new s.Token("footnote_open", "", 1);
      if (g.meta = { id: p, label: h[p].label }, s.tokens.push(g), h[p].tokens) {
        l = [];
        const w = new s.Token("paragraph_open", "p", 1);
        w.block = !0, l.push(w);
        const b = new s.Token("inline", "", 0);
        b.children = h[p].tokens, b.content = h[p].content, l.push(b);
        const x = new s.Token("paragraph_close", "p", -1);
        x.block = !0, l.push(x);
      } else h[p].label && (l = f[`:${h[p].label}`]);
      l && (s.tokens = s.tokens.concat(l));
      let v;
      s.tokens[s.tokens.length - 1].type === "paragraph_close" ? v = s.tokens.pop() : v = null;
      const k = h[p].count > 0 ? h[p].count : 1;
      for (let w = 0; w < k; w++) {
        const b = new s.Token("footnote_anchor", "", 0);
        b.meta = { id: p, subId: w, label: h[p].label }, s.tokens.push(b);
      }
      v && s.tokens.push(v), s.tokens.push(new s.Token("footnote_close", "", -1));
    }
    s.tokens.push(new s.Token("footnote_block_close", "", -1));
  }
  t.block.ruler.before("reference", "footnote_def", r, { alt: ["paragraph", "reference"] }), t.inline.ruler.after("image", "footnote_inline", i), t.inline.ruler.after("footnote_inline", "footnote_ref", a), t.core.ruler.after("inline", "footnote_tail", o);
}
function Yxt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      n.hasOwnProperty(r) && (t[r] = n[r]);
  }
  return t;
}
function xw(t, e) {
  return Array(e + 1).join(t);
}
function Kxt(t) {
  return t.replace(/^\n*/, "");
}
function $xt(t) {
  for (var e = t.length; e > 0 && t[e - 1] === `
`; ) e--;
  return t.substring(0, e);
}
var Jxt = [
  "ADDRESS",
  "ARTICLE",
  "ASIDE",
  "AUDIO",
  "BLOCKQUOTE",
  "BODY",
  "CANVAS",
  "CENTER",
  "DD",
  "DIR",
  "DIV",
  "DL",
  "DT",
  "FIELDSET",
  "FIGCAPTION",
  "FIGURE",
  "FOOTER",
  "FORM",
  "FRAMESET",
  "H1",
  "H2",
  "H3",
  "H4",
  "H5",
  "H6",
  "HEADER",
  "HGROUP",
  "HR",
  "HTML",
  "ISINDEX",
  "LI",
  "MAIN",
  "MENU",
  "NAV",
  "NOFRAMES",
  "NOSCRIPT",
  "OL",
  "OUTPUT",
  "P",
  "PRE",
  "SECTION",
  "TABLE",
  "TBODY",
  "TD",
  "TFOOT",
  "TH",
  "THEAD",
  "TR",
  "UL"
];
function DA(t) {
  return IA(t, Jxt);
}
var wJ = [
  "AREA",
  "BASE",
  "BR",
  "COL",
  "COMMAND",
  "EMBED",
  "HR",
  "IMG",
  "INPUT",
  "KEYGEN",
  "LINK",
  "META",
  "PARAM",
  "SOURCE",
  "TRACK",
  "WBR"
];
function kJ(t) {
  return IA(t, wJ);
}
function Qxt(t) {
  return MJ(t, wJ);
}
var xJ = [
  "A",
  "TABLE",
  "THEAD",
  "TBODY",
  "TFOOT",
  "TH",
  "TD",
  "IFRAME",
  "SCRIPT",
  "AUDIO",
  "VIDEO"
];
function Xxt(t) {
  return IA(t, xJ);
}
function eMt(t) {
  return MJ(t, xJ);
}
function IA(t, e) {
  return e.indexOf(t.nodeName) >= 0;
}
function MJ(t, e) {
  return t.getElementsByTagName && e.some(function(n) {
    return t.getElementsByTagName(n).length;
  });
}
var ti = {};
ti.paragraph = {
  filter: "p",
  replacement: function(t) {
    return `

` + t + `

`;
  }
};
ti.lineBreak = {
  filter: "br",
  replacement: function(t, e, n) {
    return n.br + `
`;
  }
};
ti.heading = {
  filter: ["h1", "h2", "h3", "h4", "h5", "h6"],
  replacement: function(t, e, n) {
    var r = Number(e.nodeName.charAt(1));
    if (n.headingStyle === "setext" && r < 3) {
      var i = xw(r === 1 ? "=" : "-", t.length);
      return `

` + t + `
` + i + `

`;
    } else
      return `

` + xw("#", r) + " " + t + `

`;
  }
};
ti.blockquote = {
  filter: "blockquote",
  replacement: function(t) {
    return t = t.replace(/^\n+|\n+$/g, ""), t = t.replace(/^/gm, "> "), `

` + t + `

`;
  }
};
ti.list = {
  filter: ["ul", "ol"],
  replacement: function(t, e) {
    var n = e.parentNode;
    return n.nodeName === "LI" && n.lastElementChild === e ? `
` + t : `

` + t + `

`;
  }
};
ti.listItem = {
  filter: "li",
  replacement: function(t, e, n) {
    t = t.replace(/^\n+/, "").replace(/\n+$/, `
`).replace(/\n/gm, `
    `);
    var r = n.bulletListMarker + "   ", i = e.parentNode;
    if (i.nodeName === "OL") {
      var a = i.getAttribute("start"), o = Array.prototype.indexOf.call(i.children, e);
      r = (a ? Number(a) + o : o + 1) + ".  ";
    }
    return r + t + (e.nextSibling && !/\n$/.test(t) ? `
` : "");
  }
};
ti.indentedCodeBlock = {
  filter: function(t, e) {
    return e.codeBlockStyle === "indented" && t.nodeName === "PRE" && t.firstChild && t.firstChild.nodeName === "CODE";
  },
  replacement: function(t, e, n) {
    return `

    ` + e.firstChild.textContent.replace(/\n/g, `
    `) + `

`;
  }
};
ti.fencedCodeBlock = {
  filter: function(t, e) {
    return e.codeBlockStyle === "fenced" && t.nodeName === "PRE" && t.firstChild && t.firstChild.nodeName === "CODE";
  },
  replacement: function(t, e, n) {
    for (var r = e.firstChild.getAttribute("class") || "", i = (r.match(/language-(\S+)/) || [null, ""])[1], a = e.firstChild.textContent, o = n.fence.charAt(0), s = 3, l = new RegExp("^" + o + "{3,}", "gm"), c; c = l.exec(a); )
      c[0].length >= s && (s = c[0].length + 1);
    var u = xw(o, s);
    return `

` + u + i + `
` + a.replace(/\n$/, "") + `
` + u + `

`;
  }
};
ti.horizontalRule = {
  filter: "hr",
  replacement: function(t, e, n) {
    return `

` + n.hr + `

`;
  }
};
ti.inlineLink = {
  filter: function(t, e) {
    return e.linkStyle === "inlined" && t.nodeName === "A" && t.getAttribute("href");
  },
  replacement: function(t, e) {
    var n = e.getAttribute("href");
    n && (n = n.replace(/([()])/g, "\\$1"));
    var r = a3(e.getAttribute("title"));
    return r && (r = ' "' + r.replace(/"/g, '\\"') + '"'), "[" + t + "](" + n + r + ")";
  }
};
ti.referenceLink = {
  filter: function(t, e) {
    return e.linkStyle === "referenced" && t.nodeName === "A" && t.getAttribute("href");
  },
  replacement: function(t, e, n) {
    var r = e.getAttribute("href"), i = a3(e.getAttribute("title"));
    i && (i = ' "' + i + '"');
    var a, o;
    switch (n.linkReferenceStyle) {
      case "collapsed":
        a = "[" + t + "][]", o = "[" + t + "]: " + r + i;
        break;
      case "shortcut":
        a = "[" + t + "]", o = "[" + t + "]: " + r + i;
        break;
      default:
        var s = this.references.length + 1;
        a = "[" + t + "][" + s + "]", o = "[" + s + "]: " + r + i;
    }
    return this.references.push(o), a;
  },
  references: [],
  append: function(t) {
    var e = "";
    return this.references.length && (e = `

` + this.references.join(`
`) + `

`, this.references = []), e;
  }
};
ti.emphasis = {
  filter: ["em", "i"],
  replacement: function(t, e, n) {
    return t.trim() ? n.emDelimiter + t + n.emDelimiter : "";
  }
};
ti.strong = {
  filter: ["strong", "b"],
  replacement: function(t, e, n) {
    return t.trim() ? n.strongDelimiter + t + n.strongDelimiter : "";
  }
};
ti.code = {
  filter: function(t) {
    var e = t.previousSibling || t.nextSibling, n = t.parentNode.nodeName === "PRE" && !e;
    return t.nodeName === "CODE" && !n;
  },
  replacement: function(t) {
    if (!t) return "";
    t = t.replace(/\r?\n|\r/g, " ");
    for (var e = /^`|^ .*?[^ ].* $|`$/.test(t) ? " " : "", n = "`", r = t.match(/`+/gm) || []; r.indexOf(n) !== -1; ) n = n + "`";
    return n + e + t + e + n;
  }
};
ti.image = {
  filter: "img",
  replacement: function(t, e) {
    var n = a3(e.getAttribute("alt")), r = e.getAttribute("src") || "", i = a3(e.getAttribute("title")), a = i ? ' "' + i + '"' : "";
    return r ? "![" + n + "](" + r + a + ")" : "";
  }
};
function a3(t) {
  return t ? t.replace(/(\n+\s*)+/g, `
`) : "";
}
function CJ(t) {
  this.options = t, this._keep = [], this._remove = [], this.blankRule = {
    replacement: t.blankReplacement
  }, this.keepReplacement = t.keepReplacement, this.defaultRule = {
    replacement: t.defaultReplacement
  }, this.array = [];
  for (var e in t.rules) this.array.push(t.rules[e]);
}
CJ.prototype = {
  add: function(t, e) {
    this.array.unshift(e);
  },
  keep: function(t) {
    this._keep.unshift({
      filter: t,
      replacement: this.keepReplacement
    });
  },
  remove: function(t) {
    this._remove.unshift({
      filter: t,
      replacement: function() {
        return "";
      }
    });
  },
  forNode: function(t) {
    if (t.isBlank) return this.blankRule;
    var e;
    return (e = Lv(this.array, t, this.options)) || (e = Lv(this._keep, t, this.options)) || (e = Lv(this._remove, t, this.options)) ? e : this.defaultRule;
  },
  forEach: function(t) {
    for (var e = 0; e < this.array.length; e++) t(this.array[e], e);
  }
};
function Lv(t, e, n) {
  for (var r = 0; r < t.length; r++) {
    var i = t[r];
    if (tMt(i, e, n)) return i;
  }
}
function tMt(t, e, n) {
  var r = t.filter;
  if (typeof r == "string") {
    if (r === e.nodeName.toLowerCase()) return !0;
  } else if (Array.isArray(r)) {
    if (r.indexOf(e.nodeName.toLowerCase()) > -1) return !0;
  } else if (typeof r == "function") {
    if (r.call(t, e, n)) return !0;
  } else
    throw new TypeError("`filter` needs to be a string, array, or function");
}
function nMt(t) {
  var e = t.element, n = t.isBlock, r = t.isVoid, i = t.isPre || function(d) {
    return d.nodeName === "PRE";
  };
  if (!(!e.firstChild || i(e))) {
    for (var a = null, o = !1, s = null, l = RI(s, e, i); l !== e; ) {
      if (l.nodeType === 3 || l.nodeType === 4) {
        var c = l.data.replace(/[ \r\n\t]+/g, " ");
        if ((!a || / $/.test(a.data)) && !o && c[0] === " " && (c = c.substr(1)), !c) {
          l = Tv(l);
          continue;
        }
        l.data = c, a = l;
      } else if (l.nodeType === 1)
        n(l) || l.nodeName === "BR" ? (a && (a.data = a.data.replace(/ $/, "")), a = null, o = !1) : r(l) || i(l) ? (a = null, o = !0) : a && (o = !1);
      else {
        l = Tv(l);
        continue;
      }
      var u = RI(s, l, i);
      s = l, l = u;
    }
    a && (a.data = a.data.replace(/ $/, ""), a.data || Tv(a));
  }
}
function Tv(t) {
  var e = t.nextSibling || t.parentNode;
  return t.parentNode.removeChild(t), e;
}
function RI(t, e, n) {
  return t && t.parentNode === e || n(e) ? e.nextSibling || e.parentNode : e.firstChild || e.nextSibling || e.parentNode;
}
var PA = typeof window < "u" ? window : {};
function rMt() {
  var t = PA.DOMParser, e = !1;
  try {
    new t().parseFromString("", "text/html") && (e = !0);
  } catch {
  }
  return e;
}
function iMt() {
  var t = function() {
  };
  return aMt() ? t.prototype.parseFromString = function(e) {
    var n = new window.ActiveXObject("htmlfile");
    return n.designMode = "on", n.open(), n.write(e), n.close(), n;
  } : t.prototype.parseFromString = function(e) {
    var n = document.implementation.createHTMLDocument("");
    return n.open(), n.write(e), n.close(), n;
  }, t;
}
function aMt() {
  var t = !1;
  try {
    document.implementation.createHTMLDocument("").open();
  } catch {
    PA.ActiveXObject && (t = !0);
  }
  return t;
}
var oMt = rMt() ? PA.DOMParser : iMt();
function sMt(t, e) {
  var n;
  if (typeof t == "string") {
    var r = lMt().parseFromString(
      // DOM parsers arrange elements in the <head> and <body>.
      // Wrapping in a custom element ensures elements are reliably arranged in
      // a single element.
      '<x-turndown id="turndown-root">' + t + "</x-turndown>",
      "text/html"
    );
    n = r.getElementById("turndown-root");
  } else
    n = t.cloneNode(!0);
  return nMt({
    element: n,
    isBlock: DA,
    isVoid: kJ,
    isPre: e.preformattedCode ? cMt : null
  }), n;
}
var Ev;
function lMt() {
  return Ev = Ev || new oMt(), Ev;
}
function cMt(t) {
  return t.nodeName === "PRE" || t.nodeName === "CODE";
}
function uMt(t, e) {
  return t.isBlock = DA(t), t.isCode = t.nodeName === "CODE" || t.parentNode.isCode, t.isBlank = dMt(t), t.flankingWhitespace = fMt(t, e), t;
}
function dMt(t) {
  return !kJ(t) && !Xxt(t) && /^\s*$/i.test(t.textContent) && !Qxt(t) && !eMt(t);
}
function fMt(t, e) {
  if (t.isBlock || e.preformattedCode && t.isCode)
    return { leading: "", trailing: "" };
  var n = hMt(t.textContent);
  return n.leadingAscii && OI("left", t, e) && (n.leading = n.leadingNonAscii), n.trailingAscii && OI("right", t, e) && (n.trailing = n.trailingNonAscii), { leading: n.leading, trailing: n.trailing };
}
function hMt(t) {
  var e = t.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
  return {
    leading: e[1],
    // whole string for whitespace-only strings
    leadingAscii: e[2],
    leadingNonAscii: e[3],
    trailing: e[4],
    // empty for whitespace-only strings
    trailingNonAscii: e[5],
    trailingAscii: e[6]
  };
}
function OI(t, e, n) {
  var r, i, a;
  return t === "left" ? (r = e.previousSibling, i = / $/) : (r = e.nextSibling, i = /^ /), r && (r.nodeType === 3 ? a = i.test(r.nodeValue) : n.preformattedCode && r.nodeName === "CODE" ? a = !1 : r.nodeType === 1 && !DA(r) && (a = i.test(r.textContent))), a;
}
var pMt = Array.prototype.reduce, mMt = [
  [/\\/g, "\\\\"],
  [/\*/g, "\\*"],
  [/^-/g, "\\-"],
  [/^\+ /g, "\\+ "],
  [/^(=+)/g, "\\$1"],
  [/^(#{1,6}) /g, "\\$1 "],
  [/`/g, "\\`"],
  [/^~~~/g, "\\~~~"],
  [/\[/g, "\\["],
  [/\]/g, "\\]"],
  [/^>/g, "\\>"],
  [/_/g, "\\_"],
  [/^(\d+)\. /g, "$1\\. "]
];
function o3(t) {
  if (!(this instanceof o3)) return new o3(t);
  var e = {
    rules: ti,
    headingStyle: "setext",
    hr: "* * *",
    bulletListMarker: "*",
    codeBlockStyle: "indented",
    fence: "```",
    emDelimiter: "_",
    strongDelimiter: "**",
    linkStyle: "inlined",
    linkReferenceStyle: "full",
    br: "  ",
    preformattedCode: !1,
    blankReplacement: function(n, r) {
      return r.isBlock ? `

` : "";
    },
    keepReplacement: function(n, r) {
      return r.isBlock ? `

` + r.outerHTML + `

` : r.outerHTML;
    },
    defaultReplacement: function(n, r) {
      return r.isBlock ? `

` + n + `

` : n;
    }
  };
  this.options = Yxt({}, e, t), this.rules = new CJ(this.options);
}
o3.prototype = {
  /**
   * The entry point for converting a string or DOM node to Markdown
   * @public
   * @param {String|HTMLElement} input The string or DOM node to convert
   * @returns A Markdown representation of the input
   * @type String
   */
  turndown: function(t) {
    if (!vMt(t))
      throw new TypeError(
        t + " is not a string, or an element/document/fragment node."
      );
    if (t === "") return "";
    var e = AJ.call(this, new sMt(t, this.options));
    return yMt.call(this, e);
  },
  /**
   * Add one or more plugins
   * @public
   * @param {Function|Array} plugin The plugin or array of plugins to add
   * @returns The Turndown instance for chaining
   * @type Object
   */
  use: function(t) {
    if (Array.isArray(t))
      for (var e = 0; e < t.length; e++) this.use(t[e]);
    else if (typeof t == "function")
      t(this);
    else
      throw new TypeError("plugin must be a Function or an Array of Functions");
    return this;
  },
  /**
   * Adds a rule
   * @public
   * @param {String} key The unique key of the rule
   * @param {Object} rule The rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  addRule: function(t, e) {
    return this.rules.add(t, e), this;
  },
  /**
   * Keep a node (as HTML) that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  keep: function(t) {
    return this.rules.keep(t), this;
  },
  /**
   * Remove a node that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  remove: function(t) {
    return this.rules.remove(t), this;
  },
  /**
   * Escapes Markdown syntax
   * @public
   * @param {String} string The string to escape
   * @returns A string with Markdown syntax escaped
   * @type String
   */
  escape: function(t) {
    return mMt.reduce(function(e, n) {
      return e.replace(n[0], n[1]);
    }, t);
  }
};
function AJ(t) {
  var e = this;
  return pMt.call(t.childNodes, function(n, r) {
    r = new uMt(r, e.options);
    var i = "";
    return r.nodeType === 3 ? i = r.isCode ? r.nodeValue : e.escape(r.nodeValue) : r.nodeType === 1 && (i = gMt.call(e, r)), SJ(n, i);
  }, "");
}
function yMt(t) {
  var e = this;
  return this.rules.forEach(function(n) {
    typeof n.append == "function" && (t = SJ(t, n.append(e.options)));
  }), t.replace(/^[\t\r\n]+/, "").replace(/[\t\r\n\s]+$/, "");
}
function gMt(t) {
  var e = this.rules.forNode(t), n = AJ.call(this, t), r = t.flankingWhitespace;
  return (r.leading || r.trailing) && (n = n.trim()), r.leading + e.replacement(n, t, this.options) + r.trailing;
}
function SJ(t, e) {
  var n = $xt(t), r = Kxt(e), i = Math.max(t.length - n.length, e.length - r.length), a = `

`.substring(0, i);
  return n + a + r;
}
function vMt(t) {
  return t != null && (typeof t == "string" || t.nodeType && (t.nodeType === 1 || t.nodeType === 9 || t.nodeType === 11));
}
const bMt = new _r().use(bJ), qn = new o3({
  headingStyle: "atx",
  codeBlockStyle: "fenced"
}), wMt = (t) => {
  if (!t.nodeName) return "";
  switch (t.nodeName) {
    case "H1":
      return "#";
    case "H2":
      return "##";
    case "H3":
      return "###";
    default:
      return "";
  }
};
qn.addRule("heading", {
  filter: ["h1", "h2", "h3"],
  replacement: function(t, e) {
    const n = wMt(e), r = t.replace(/\n\n===\n\n/g, "<br>");
    return `${n} ${r}`;
  }
});
qn.addRule("taskListItem", {
  filter: (t) => {
    const e = t.parentElement;
    return t.nodeName === "LI" && (e == null ? void 0 : e.getAttribute("data-type")) === "taskList";
  },
  replacement: function(t, e) {
    const n = e.getAttribute("data-checked") === "true";
    return t = t.replace(/^\n+/, "").replace(/\n+$/, "").replace(/\n\s*/gm, `
`).replace(/\n/gm, `
    `), `- [${n ? "x" : " "}] ${t}${e.nextSibling ? `
` : ""}`;
  }
});
qn.addRule("pageBreak", {
  filter: "br",
  replacement: function() {
    return `

===

`;
  }
});
qn.addRule("table", {
  filter: "table",
  replacement: function(t, e) {
    const n = e, r = Array.from(n.rows), i = Array.from(r[0].cells).map((d) => qn.turndown(d.innerHTML).trim()), a = i.map((d) => d.length), o = r.slice(1).map((d) => Array.from(d.cells).map((f, h) => {
      let p = f.innerHTML.trim();
      if (f.querySelector("ul, ol")) {
        const m = f.querySelector("ul") ? "ul" : "ol", g = Array.from(f.querySelectorAll("li")).map(
          (v) => {
            var k;
            return ((k = v.textContent) == null ? void 0 : k.trim()) || "";
          }
        );
        p = `<${m}><li>${g.join(
          "</li><li>"
        )}</li></${m}>`;
      } else
        p = qn.turndown(p);
      return a[h] = Math.max(
        a[h],
        p.length
      ), p;
    })), s = (d) => "| " + d.map((f, h) => {
      const p = " ".repeat(
        Math.max(0, a[h] - f.length)
      );
      return f + p;
    }).join(" | ") + " |", l = s(i), c = "| " + a.map((d) => "-".repeat(d)).join(" | ") + " |", u = o.map((d) => s(d));
    return `

${l}
${c}
${u.join(
      `
`
    )}

`;
  }
});
qn.addRule("inlineCode", {
  filter: function(t) {
    var e;
    return t.nodeName === "CODE" && ((e = t.parentNode) == null ? void 0 : e.nodeName) !== "PRE";
  },
  replacement: function(t) {
    return "`" + t + "`";
  }
});
qn.addRule("listItem", {
  filter: "li",
  replacement: function(t, e, n) {
    t = t.replace(/^\n+/, "").replace(/\n+$/, "").replace(/\n\s*\n/g, `
`).replace(/\n/gm, `
    `);
    let r = n.bulletListMarker + " ";
    const i = e.parentNode;
    if (i && i.nodeName === "OL") {
      const l = i.getAttribute("start"), c = Array.prototype.indexOf.call(i.children, e);
      r = (l ? Number(l) + c : c + 1) + ". ";
    }
    let a = 0, o = e.parentNode;
    for (; o && (o.nodeName === "UL" || o.nodeName === "OL"); )
      a++, o = o.parentNode;
    a > 1 && (r = "    ".repeat(a - 1) + r);
    const s = !e.nextSibling || a === 1;
    return r + t + (s ? `
` : "");
  }
});
qn.addRule("iframe", {
  filter: ["iframe"],
  replacement: function(t, e) {
    const n = e.getAttribute("src");
    return n ? `[${n}](${n})` : "";
  }
});
qn.addRule("superscript", {
  filter: "sup",
  replacement: function(t) {
    return "<sup>" + t + "</sup>";
  }
});
qn.addRule("subscript", {
  filter: "sub",
  replacement: function(t) {
    return "<sub>" + t + "</sub>";
  }
});
qn.addRule("img", {
  filter: ["img"],
  replacement: function(t, e) {
    const n = e.getAttribute("src"), r = e.getAttribute("alt") || "";
    return n ? `![${r}](${n})` : "";
  }
});
qn.addRule("strikethrough", {
  filter: "s",
  replacement: function(t) {
    return "<s>" + t + "</s>";
  }
});
const kMt = (t) => ln.create({
  name: "markdownPasteHandler",
  addProseMirrorPlugins() {
    return [
      new Wt({
        props: {
          handlePaste: (e, n) => {
            n.preventDefault();
            const r = n.clipboardData;
            if (!r) return !1;
            const i = r.getData("text/plain");
            return xMt(i) ? (BI(e, i, t), !0) : !1;
          }
        }
      })
    ];
  },
  addCommands() {
    return {
      uploadMarkdownFile: (e) => async ({ view: n }) => {
        const r = document.createElement("input");
        return r.type = "file", r.accept = ".md, text/markdown", r.onchange = async (i) => {
          const a = i.target.files;
          if (a.length > 0) {
            const o = a[0];
            if (o.type === "text/markdown" || o.name.endsWith(".md")) {
              const s = new FileReader();
              s.onload = async (l) => {
                var u;
                const c = (u = l.target) == null ? void 0 : u.result;
                await BI(
                  n,
                  c,
                  e
                );
              }, s.readAsText(o);
            }
          }
        }, r.click(), !0;
      },
      exportMarkdownFile: () => async ({ editor: e }) => {
        const n = e.state.doc, r = await zA(n), i = new np({
          extensions: e.extensionManager.extensions.filter(
            (c) => c.name !== "collaboration"
          ),
          content: r.toJSON()
        }), a = i.getHTML(), o = qn.turndown(a), s = new Blob([o], {
          type: "text/markdown;charset=utf-8"
        }), l = URL.createObjectURL(s);
        return i.destroy(), l;
      }
    };
  },
  addInputRules() {
    return [
      new Wi({
        find: /<sup>(.*?)<\/sup>/,
        handler: ({ state: e, range: n, match: r }) => {
          const { tr: i } = e, a = n.from, o = n.to, s = r[1];
          i.replaceWith(
            a,
            o,
            this.editor.schema.text(s, [
              this.editor.schema.marks.superscript.create()
            ])
          );
        }
      }),
      new Wi({
        find: /<sub>(.*?)<\/sub>/,
        handler: ({ state: e, range: n, match: r }) => {
          const { tr: i } = e, a = n.from, o = n.to, s = r[1];
          i.replaceWith(
            a,
            o,
            this.editor.schema.text(s, [
              this.editor.schema.marks.subscript.create()
            ])
          );
        }
      }),
      new Wi({
        // eslint-disable-next-line no-useless-escape
        find: /(\S*)\^((?:[^\^]|\\\^)+)\^/,
        handler: ({ state: e, range: n, match: r }) => {
          const { tr: i } = e, a = n.from + r[1].length, o = n.to, s = r[2].replace(/\\\^/g, "^");
          i.replaceWith(
            a,
            o,
            this.editor.schema.text(s, [
              this.editor.schema.marks.superscript.create()
            ])
          );
        }
      }),
      new Wi({
        find: /(\S*)~((?:[^~]|\\~)+)~/,
        handler: ({ state: e, range: n, match: r }) => {
          const { tr: i } = e, a = n.from + r[1].length, o = n.to, s = r[2].replace(/\\~/g, "~");
          i.replaceWith(
            a,
            o,
            this.editor.schema.text(s, [
              this.editor.schema.marks.subscript.create()
            ])
          );
        }
      }),
      new Wi({
        find: /(?:^|\s)\[([^\]]+)\]\((\S+)\)/,
        handler: ({ state: e, range: n, match: r }) => {
          var u;
          const { tr: i } = e, [a, o, s] = r, l = n.from, c = n.to;
          if (a) {
            const d = e.doc.resolve(l).nodeBefore, f = d && d.isText && ((u = d.text) == null ? void 0 : u.endsWith(" "));
            f && i.insertText(" ", l), i.replaceWith(
              f ? l + 1 : l,
              f ? c + 1 : c,
              this.editor.schema.text(o, [
                this.editor.schema.marks.link.create({ href: s })
              ])
            );
          }
        }
      }),
      new Wi({
        find: /===\s*$/m,
        handler: ({ state: e, range: n }) => {
          var s;
          const { tr: r } = e, i = n.from - 2, a = n.to;
          ((s = e.doc.nodeAt(i)) == null ? void 0 : s.type.name) === "dBlock" && r.replaceWith(
            i,
            a,
            this.editor.schema.nodes.pageBreak.create()
          );
        }
      })
    ];
  }
});
function xMt(t) {
  return t.match(/\$\$[^$]*\$\$/g) !== null || t.match(/\$[^$\n]*\$/g) !== null ? !1 : t.match(/^#{1,6}\s/) !== null || // Headings
  t.startsWith("*") || t.startsWith("-") || t.startsWith(">") || t.startsWith("```") || t.match(/\[.*\]\(.*\)/) !== null || // Links
  t.match(/!\[.*\]\(.*\)/) !== null || // Images
  t.match(/\*\*(.*?)\*\*/g) !== null || // Bold
  t.match(/\*(.*?)\*/g) !== null || // Italic
  t.match(/`{1,3}[^`]+`{1,3}/g) !== null || t.match(/<sup>(.*?)<\/sup>/g) !== null || t.match(/<sub>(.*?)<\/sub>/g) !== null || t.match(/\^(.*?)\^/g) !== null || // New superscript syntax
  t.match(/~(.*?)~/g) !== null || // New subscript syntax
  t.match(/^===\s*$/m) !== null;
}
function MMt(t, e) {
  const n = atob(t), r = n.length, i = new Uint8Array(r);
  for (let o = 0; o < r; o++)
    i[o] = n.charCodeAt(o);
  const a = new Blob([i], { type: e });
  return new File([a], "image", { type: e });
}
async function CMt(t, e) {
  const n = t.match(/^(data:(image\/[a-zA-Z]+);base64,)/);
  if (!n)
    throw new Error("Invalid base64 image string.");
  const r = n[2], i = t.slice(n[1].length), a = MMt(i, r), { publicKey: o, privateKey: s } = await gY(), { key: l, url: c, iv: u } = await wY(
    e,
    a,
    o
  );
  return {
    url: c,
    encryptedKey: l,
    iv: u,
    privateKey: DC(s),
    downloadUrl: URL.createObjectURL(a)
  };
}
async function BI(t, e, n) {
  var k, w, b, x, A;
  let r = bMt.render(e);
  const i = document.createElement("textarea");
  i.innerHTML = r, r = i.value;
  const a = new DOMParser(), o = a.parseFromString(r, "text/html"), s = o.getElementsByTagName("ul");
  for (let L = 0; L < s.length; L++) {
    const M = s[L], j = M.getElementsByTagName("li");
    let D = !1;
    for (let z = 0; z < j.length; z++) {
      const H = j[z], F = (H.textContent || "").match(/^\[([ x])\]\s*(.*)/i);
      if (F) {
        D = !0;
        const _ = F[1].toLowerCase() === "x", W = F[2];
        H.setAttribute("data-type", "taskItem"), H.setAttribute("data-checked", _.toString()), H.textContent = W;
      }
    }
    D && M.setAttribute("data-type", "taskList");
  }
  const l = o.getElementsByTagName("p");
  for (let L = l.length - 1; L >= 0; L--) {
    const M = l[L];
    if (M.childNodes.length === 1 && ((k = M.firstChild) == null ? void 0 : k.nodeName) === "IMG" && ((w = M.parentNode) == null || w.replaceChild(M.firstChild, M)), M.childNodes.length === 1 && ((x = (b = M.firstChild) == null ? void 0 : b.textContent) == null ? void 0 : x.trim()) === "===") {
      const j = o.createElement("div");
      j.setAttribute("data-type", "page-break"), j.setAttribute("data-page-break", "true"), (A = M.parentNode) == null || A.replaceChild(j, M);
    }
  }
  const c = Array.from(o.getElementsByTagName("img"));
  if (n)
    for (const L of c) {
      const M = L.getAttribute("src") || "";
      if (M.startsWith("data:image"))
        try {
          const j = await CMt(
            M,
            n
          );
          L.setAttribute("url", j.url), L.setAttribute("src", j.downloadUrl), L.setAttribute("media-type", "secure-img"), L.setAttribute("encryptedKey", j.encryptedKey), L.setAttribute("iv", j.iv), L.setAttribute("privateKey", j.privateKey);
        } catch (j) {
          console.error("Error uploading secure image to IPFS:", j);
        }
    }
  r = o.body.innerHTML;
  const u = /<(sup|sub)>(.*?)<\/\1>/g, d = /\^(.*?)\^/g, f = /~(.*?)~/g, h = /===\s*$/gm;
  r = r.replace(u, (L) => `${L}`), r = r.replace(
    d,
    '<sup data-type="sup">$1</sup>'
  ), r = r.replace(
    f,
    '<sub data-type="sub">$1</sub>'
  ), r = r.replace(
    h,
    '<div data-type="page-break" data-page-break="true"></div>'
  ), r = vJ.sanitize(r, {
    ADD_TAGS: ["div"],
    ADD_ATTR: [
      "data-type",
      "data-page-break",
      "url",
      "src",
      "media-type",
      "encryptedKey",
      "iv",
      "privateKey"
    ]
  });
  const p = a.parseFromString(r, "text/html").body, m = Uo.fromSchema(
    t.state.schema
  ).parse(p), g = t.state.tr;
  let v = 0;
  m.descendants((L, M) => {
    if (L.isText) {
      const j = p.childNodes[M];
      if (j && j.nodeType === Node.ELEMENT_NODE) {
        const D = j;
        D.dataset.type === "sup" ? g.addMark(
          M + v,
          M + v + L.nodeSize,
          t.state.schema.marks.superscript.create()
        ) : D.dataset.type === "sub" && g.addMark(
          M + v,
          M + v + L.nodeSize,
          t.state.schema.marks.subscript.create()
        );
      }
    } else if (L.type.name === "paragraph") {
      const j = p.childNodes[M];
      j && j.nodeType === Node.ELEMENT_NODE && j.dataset.type === "page-break" && (g.replaceWith(
        M + v,
        M + v + L.nodeSize,
        t.state.schema.nodes.pageBreak.create()
      ), v -= L.nodeSize - 1);
    }
  }), g.replaceSelectionWith(m, !1), t.dispatch(g);
}
async function AMt(t) {
  const { url: e, encryptedKey: n, iv: r, privateKey: i } = t.attrs;
  if (!e || !n || !r || !i) return t;
  try {
    const a = await vY(e);
    if (!a) return t;
    const o = await bY({
      encryptedKey: n,
      privateKey: NC(i),
      iv: r,
      imageBuffer: a
    });
    if (!o) return t;
    const l = `data:image/jpeg;base64,${yY(o)}`, c = {
      ...t.attrs,
      src: l
    };
    return t.type.createChecked(c, t.content, t.marks);
  } catch (a) {
    return console.error("Error decrypting image node:", a), t;
  }
}
async function zA(t) {
  const n = [{
    node: t,
    index: 0,
    childResults: [],
    parent: null
  }];
  for (; n.length > 0; ) {
    const r = n[n.length - 1];
    if (r.index < r.node.childCount) {
      const a = {
        node: r.node.child(r.index),
        index: 0,
        childResults: [],
        parent: r
      };
      r.index++, n.push(a);
      continue;
    }
    if (!r.newNode)
      if (r.node.attrs["media-type"] === "secure-img")
        r.newNode = await AMt(
          r.node
        );
      else {
        const i = Ne.fromArray(r.childResults);
        r.newNode = r.node.copy(i);
      }
    if (n.pop(), r.parent)
      r.parent.childResults.push(r.newNode);
    else
      return r.newNode;
  }
  throw new Error("transformDocIterative: unexpected stack exit");
}
const Mw = [
  {
    title: "Trebuchet MS",
    value: "Trebuchet MS, sans-serif",
    command: (t) => {
      t.chain().focus().setFontFamily("Trebuchet MS, sans-serif").run();
    }
  },
  {
    title: "Verdana",
    value: "Verdana, Geneva, sans-serif",
    command: (t) => {
      t.chain().focus().setFontFamily("Verdana, Geneva, sans-serif").run();
    }
  },
  {
    title: "Georgia",
    value: "Georgia, serif",
    command: (t) => {
      t.chain().focus().setFontFamily("Georgia, serif").run();
    }
  },
  {
    title: "Arial",
    value: "Arial, Helvetica, sans-serif",
    command: (t) => {
      t.chain().focus().setFontFamily("Arial, Helvetica, sans-serif").run();
    }
  },
  {
    title: "Comic Sans MS",
    value: "Comic Sans MS, Comic Sans",
    command: (t) => {
      t.chain().focus().setFontFamily("Comic Sans MS, Comic Sans").run();
    }
  },
  {
    title: "Impact",
    value: "Impact, Charcoal, sans-serif",
    command: (t) => {
      t.chain().focus().setFontFamily("Impact, Charcoal, sans-serif").run();
    }
  },
  {
    title: "Palatino",
    value: "Palatino Linotype, Book Antiqua, Palatino, serif",
    command: (t) => {
      t.chain().focus().setFontFamily("Palatino Linotype, Book Antiqua, Palatino, serif").run();
    }
  },
  {
    title: "Lucida Grande",
    value: "Lucida Sans Unicode, Lucida Grande, sans-serif",
    command: (t) => {
      t.chain().focus().setFontFamily("Lucida Sans Unicode, Lucida Grande, sans-serif").run();
    }
  },
  {
    title: "Serif",
    value: "serif",
    command: (t) => {
      t.chain().focus().setFontFamily("serif").run();
    }
  },
  {
    title: "Monospace",
    value: "monospace",
    command: (t) => {
      t.chain().focus().setFontFamily("monospace").run();
    }
  },
  {
    title: "Cursive",
    value: "cursive",
    command: (t) => {
      t.chain().focus().setFontFamily("cursive").run();
    }
  }
], qs = {
  Extended: {
    maxSize: 1024 * 1024 * 10,
    errorMsg: "Image size should be less than 10MB"
  },
  Base: {
    maxSize: 1024 * 100,
    errorMsg: "Image size should be less than 100kb"
  }
}, RA = ({
  editor: t,
  onError: e,
  secureImageUploadUrl: n,
  onMarkdownExport: r,
  onMarkdownImport: i,
  onPdfExport: a
}) => {
  const {
    ref: o,
    toolVisibility: s,
    setToolVisibility: l
  } = N3t(st.NONE), [c, u] = De(!1), [d, f] = De(!1), { buttonRef: h } = yl();
  ze(() => {
    if (t)
      return t.setOptions({
        editorProps: {
          handleKeyDown: (w, b) => {
            if (b.shiftKey && b.ctrlKey && b.key.toLowerCase() === "s" || b.altKey && b.shiftKey && (b.key === "5" || b.key === "%"))
              return b.preventDefault(), t.chain().focus().toggleStrike().run(), !0;
            if ((b.altKey || b.metaKey) && b.key === "Enter")
              return b.preventDefault(), l(st.LINK_POPUP), !0;
            if ((navigator.platform.includes("Mac") ? b.shiftKey && b.metaKey : (b.ctrlKey || b.metaKey) && b.altKey) && b.key.toLowerCase() === "m") {
              b.preventDefault();
              const { state: x } = t, { from: A, to: L } = x.selection;
              if (x.doc.textBetween(A, L, " ")) {
                const j = localStorage.getItem("theme") === "dark";
                t.chain().setHighlight({
                  color: j ? "#15521d" : "#DDFBDF"
                }).run(), h.current && h.current.click();
              }
              return !0;
            }
            return !1;
          }
        }
      }), () => {
        t && t.setOptions({
          editorProps: {}
        });
      };
  }, [t, l, h]);
  const p = [
    {
      icon: "Undo",
      title: "Undo",
      onClick: () => {
        t == null || t.chain().undo().run();
      },
      isActive: (t == null ? void 0 : t.can().undo()) || !1
    },
    {
      icon: "Redo",
      title: "Redo",
      onClick: () => {
        t == null || t.chain().redo().run();
      },
      isActive: (t == null ? void 0 : t.can().redo()) || !1
    },
    null
  ], m = [
    {
      icon: "Baseline",
      title: "Text Color",
      onClick: () => l(st.TEXT_COLOR),
      isActive: s === st.TEXT_COLOR
    },
    {
      icon: "Highlighter",
      title: "Highlight",
      onClick: () => l(st.HIGHLIGHT),
      isActive: s === st.HIGHLIGHT
    },
    null,
    {
      icon: "Bold",
      title: "Bold",
      onClick: () => t == null ? void 0 : t.chain().focus().toggleBold().run(),
      isActive: (t == null ? void 0 : t.isActive("bold")) || !1
    },
    {
      icon: "Italic",
      title: "Italic",
      onClick: () => t == null ? void 0 : t.chain().focus().toggleItalic().run(),
      isActive: (t == null ? void 0 : t.isActive("italic")) || !1
    },
    {
      icon: "Underline",
      title: "Underlined",
      onClick: () => t == null ? void 0 : t.chain().focus().toggleUnderline().run(),
      isActive: (t == null ? void 0 : t.isActive("underline")) || !1
    },
    {
      icon: "Strikethrough",
      title: "Strikethrough",
      onClick: () => t == null ? void 0 : t.chain().focus().toggleStrike().run(),
      isActive: (t == null ? void 0 : t.isActive("strike")) || !1
    },
    null,
    {
      icon: "List",
      title: "List",
      onClick: () => {
        if (!t) return;
        const { from: w, to: b, state: x, hasMultipleLists: A } = $a(t);
        if (A)
          return;
        if (t.isActive("bulletList")) {
          const M = t.chain().focus().command(
            (j) => Ja({ ...j, state: x, from: w, to: b })
          ).setTextSelection({ from: w, to: b }).focus().run();
          return l(st.NONE), M;
        }
        const L = t.chain().focus().command(
          (M) => Us({
            ...M,
            state: x,
            from: w,
            to: b,
            listConfig: {
              type: "bulletList",
              itemType: "listItem"
            }
          })
        ).setTextSelection({ from: w, to: b }).focus().run();
        return l(st.NONE), L;
      },
      isActive: (t == null ? void 0 : t.isActive("bulletList")) || !1
    },
    {
      icon: "ListOrdered",
      title: "Ordered List",
      onClick: () => {
        if (!t) return;
        const { from: w, to: b, state: x, hasMultipleLists: A } = $a(t);
        if (A)
          return;
        if (t.isActive("orderedList")) {
          const M = t.chain().focus().command(
            (j) => Ja({ ...j, state: x, from: w, to: b })
          ).setTextSelection({ from: w, to: b }).focus().run();
          return l(st.NONE), M;
        }
        const L = t.chain().focus().command(
          (M) => Us({
            ...M,
            state: x,
            from: w,
            to: b,
            listConfig: {
              type: "orderedList",
              itemType: "listItem"
            }
          })
        ).setTextSelection({ from: w, to: b }).focus().run();
        return l(st.NONE), L;
      },
      isActive: (t == null ? void 0 : t.isActive("orderedList")) || !1
    },
    {
      icon: "ListChecks",
      title: "To-do List",
      onClick: () => {
        if (!t) return;
        const { from: w, to: b, state: x, hasMultipleLists: A } = $a(t);
        if (A)
          return;
        if (t.isActive("taskList")) {
          const M = t.chain().focus().command(
            (j) => Ja({ ...j, state: x, from: w, to: b })
          ).setTextSelection({ from: w, to: b }).focus().run();
          return l(st.NONE), M;
        }
        const L = t.chain().focus().command(
          (M) => Us({
            ...M,
            state: x,
            from: w,
            to: b,
            listConfig: {
              type: "taskList",
              itemType: "taskItem",
              hasAttrs: !0
            }
          })
        ).setTextSelection({ from: w, to: b }).focus().run();
        return l(st.NONE), L;
      },
      isActive: (t == null ? void 0 : t.isActive("taskList")) || !1
    },
    {
      icon: "AlignLeft",
      title: "Alignment",
      onClick: () => l(st.ALIGNMENT),
      isActive: s === st.ALIGNMENT
    },
    {
      icon: "TextQuote",
      title: "Quote",
      onClick: () => t == null ? void 0 : t.chain().focus().toggleBlockquote().run(),
      isActive: (t == null ? void 0 : t.isActive("blockquote")) || !1
    },
    null,
    {
      icon: "Superscript",
      title: "Superscript",
      onClick: () => t == null ? void 0 : t.chain().focus().unsetSubscript().toggleSuperscript().run(),
      isActive: (t == null ? void 0 : t.isActive("superscript")) || !1
    },
    {
      icon: "Subscript",
      title: "Subscript",
      onClick: () => t == null ? void 0 : t.chain().focus().unsetSuperscript().toggleSubscript().run(),
      isActive: (t == null ? void 0 : t.isActive("subscript")) || !1
    },
    null,
    {
      icon: "Link",
      title: "Link",
      onClick: () => l(st.LINK),
      isActive: (t == null ? void 0 : t.isActive("link")) || !1
    },
    {
      icon: "ImagePlus",
      title: "Upload Image",
      onClick: () => {
        if (!t) return;
        t == null || t.chain().focus().deleteRange(t.state.selection).run();
        const w = document.createElement("input");
        w.type = "file", w.accept = "image/png, image/jpeg, image/gif", w.onchange = async () => {
          var b;
          if ((b = w.files) != null && b.length) {
            const x = w.files[0];
            if (!i2(x, e))
              return;
            const A = x.size, L = n ? qs.Extended : qs.Base;
            if (A > L.maxSize) {
              e && typeof e == "function" && e(L.errorMsg);
              return;
            }
            const M = t.view.state.selection.from;
            e2(x, t.view, M, n);
          }
        }, w.click();
      },
      isActive: !1,
      group: "More"
    },
    {
      icon: "Code",
      title: "Code",
      onClick: () => {
        t != null && t.isActive("codeBlock") && (t == null || t.chain().focus().toggleCodeBlock().run()), t == null || t.chain().focus().toggleCode().run();
      },
      isActive: (t == null ? void 0 : t.isActive("code")) || !1,
      group: "More"
    },
    {
      icon: "Braces",
      title: "Code Block",
      onClick: () => {
        t != null && t.isActive("code") && (t == null || t.chain().focus().toggleCode().run()), t == null || t.chain().focus().toggleCodeBlock().run();
      },
      isActive: (t == null ? void 0 : t.isActive("codeBlock")) || !1,
      group: "More"
    },
    {
      icon: "Table",
      title: "Add table",
      onClick: () => t == null ? void 0 : t.chain().focus().insertTable({ rows: 3, cols: 2, withHeaderRow: !0 }).run(),
      isActive: !1,
      group: "More"
    }
  ], g = [
    {
      icon: "FileExport",
      title: "Export PDF",
      onClick: () => {
        if (t) {
          const w = async () => {
            const b = t.state.doc, x = await zA(b), A = new np({
              extensions: t.extensionManager.extensions.filter(
                (M) => M.name !== "collaboration"
              ),
              content: x.toJSON()
            }), L = A.getHTML();
            jY(L), A.destroy();
          };
          f(!1), setTimeout(w, 200), a == null || a();
        }
      },
      isActive: !1
    }
  ], v = [
    {
      icon: "FileInput",
      title: "Import Markdown",
      onClick: async () => {
        await (t == null ? void 0 : t.commands.uploadMarkdownFile(n)), i == null || i();
      },
      isActive: !1
    },
    {
      icon: "FileOutput",
      title: "Export Markdown",
      onClick: () => {
        u(!0), r == null || r();
      },
      isActive: !1
    }
  ], k = [
    {
      icon: "Undo",
      title: "Undo",
      onClick: () => {
        t == null || t.chain().undo().run();
      },
      isActive: (t == null ? void 0 : t.can().undo()) || !1
    },
    {
      icon: "Redo",
      title: "Redo",
      onClick: () => {
        t == null || t.chain().redo().run();
      },
      isActive: (t == null ? void 0 : t.can().redo()) || !1
    },
    null,
    {
      icon: "Type",
      title: "Text formating",
      onClick: () => l(st.TEXT_FORMATING),
      isActive: s === st.TEXT_FORMATING
    },
    null,
    {
      icon: "Table",
      title: "Add table",
      onClick: () => t == null ? void 0 : t.chain().focus().insertTable({ rows: 3, cols: 2, withHeaderRow: !0 }).run(),
      isActive: !1
    },
    null,
    {
      icon: "ListChecks",
      title: "To-do list",
      onClick: () => {
        if (!t) return;
        const { from: w, to: b, state: x, hasMultipleLists: A } = $a(t);
        if (A)
          return;
        if (t.isActive("taskList")) {
          const M = t.chain().focus().command(
            (j) => Ja({ ...j, state: x, from: w, to: b })
          ).setTextSelection({ from: w, to: b }).focus().run();
          return l(st.NONE), M;
        }
        const L = t.chain().focus().command(
          (M) => Us({
            ...M,
            state: x,
            from: w,
            to: b,
            listConfig: {
              type: "taskList",
              itemType: "taskItem",
              hasAttrs: !0
            }
          })
        ).setTextSelection({ from: w, to: b }).focus().run();
        return l(st.NONE), L;
      },
      isActive: !1
    },
    null,
    {
      icon: "ImagePlus",
      title: "Add image",
      onClick: () => {
        if (!t) return;
        t == null || t.chain().focus().deleteRange(t.state.selection).run();
        const w = document.createElement("input");
        w.type = "file", w.accept = "image/png, image/jpeg, image/gif", w.onchange = async () => {
          var b;
          if ((b = w.files) != null && b.length) {
            const x = w.files[0];
            if (!i2(x, e))
              return;
            const A = x.size, L = n ? qs.Extended : qs.Base;
            if (A > L.maxSize) {
              e && typeof e == "function" && e(L.errorMsg);
              return;
            }
            const M = t.view.state.selection.from;
            e2(x, t.view, M, n);
          }
        }, w.click();
      },
      isActive: !1
    }
  ];
  return {
    undoRedoTools: p,
    toolbar: m,
    markdownOptions: v,
    pdfExportOption: g,
    bottomToolbar: k,
    toolRef: o,
    toolVisibility: s,
    setToolVisibility: l,
    isExportModalOpen: c,
    setIsExportModalOpen: u,
    fileExportsOpen: d,
    setFileExportsOpen: f
  };
}, LJ = ({
  editor: t,
  setVisibility: e,
  elementRef: n
}) => /* @__PURE__ */ C.jsxs(
  "div",
  {
    ref: n,
    className: "z-50 h-auto gap-0.5 flex flex-wrap max-h-[400px] w-[14.7rem] overflow-y-auto scroll-smooth rounded color-bg-default px-2 py-2 shadow-elevation-3 transition-all",
    children: [
      Ky.map((r) => /* @__PURE__ */ C.jsx(
        "div",
        {
          onClick: () => {
            t.chain().focus().toggleHighlight({ color: r.color }).run(), e(st.NONE);
          },
          className: Lt(
            "w-5 rounded-full flex items-center justify-center cursor-pointer ease-in duration-200 hover:scale-[1.05] h-5",
            r.code
          ),
          children: /* @__PURE__ */ C.jsx(
            Ye,
            {
              name: "Check",
              className: Lt(
                "w-[14px] aspect-square",
                t.isActive("textStyle", {
                  color: r.color
                }) ? "visible" : "invisible"
              )
            }
          )
        },
        r.color
      )),
      /* @__PURE__ */ C.jsxs(
        Kt,
        {
          variant: "ghost",
          onClick: () => {
            t.chain().focus().unsetHighlight().run(), e(st.NONE);
          },
          className: "w-full justify-start mt-2 gap-1 !p-1 h-fit",
          children: [
            /* @__PURE__ */ C.jsx(Ye, { name: "Ban", className: "w-[18px] aspect-square" }),
            /* @__PURE__ */ C.jsx("span", { children: "None" })
          ]
        }
      )
    ]
  }
), SMt = ({
  elementRef: t,
  editor: e,
  setToolVisibility: n
}) => /* @__PURE__ */ C.jsx(
  "div",
  {
    ref: t,
    className: Lt(
      "z-50 h-auto max-h-[330px] w-48 overflow-y-auto scroll-smooth color-bg-default px-1 py-2 shadow-elevation-1 transition-all rounded"
    ),
    children: Mw.map((r) => /* @__PURE__ */ C.jsx(
      "button",
      {
        onClick: () => {
          r.command(e), n(st.NONE);
        },
        style: {
          fontFamily: r.title
        },
        className: Lt(
          "flex w-full items-center space-x-2 rounded px-2 py-1 text-left text-sm color-text-default transition",
          e.isActive("textStyle", { fontFamily: r.value }) ? "color-bg-brand xl:hover:brightness-90 dark:text-[#363B3F]" : "hover:color-bg-default-hover"
        ),
        children: /* @__PURE__ */ C.jsx("p", { className: "font-medium", children: r.title })
      },
      r.title
    ))
  }
), TJ = ({
  elementRef: t,
  editor: e,
  setToolVisibility: n
}) => /* @__PURE__ */ C.jsxs(
  "div",
  {
    ref: t,
    className: "z-50 h-auto left-[47rem] flex flex-wrap gap-1 max-h-[330px] overflow-y-auto scroll-smooth rounded color-bg-default px-1 py-2 shadow-elevation-3 transition-all",
    children: [
      /* @__PURE__ */ C.jsx(
        "button",
        {
          onClick: () => {
            e == null || e.chain().focus().setTextAlign("left").run(), n(st.NONE);
          },
          className: Lt(
            "rounded w-8 h-8 p-1 flex justify-center items-center cursor-pointer transition",
            e.isActive({ textAlign: "left" }) ? "color-bg-brand xl:hover:brightness-90 dark:text-[#363B3F]" : "hover:color-bg-default-hover"
          ),
          children: /* @__PURE__ */ C.jsx(Ye, { name: "AlignLeft" })
        }
      ),
      /* @__PURE__ */ C.jsx(
        "button",
        {
          onClick: () => {
            e == null || e.chain().focus().setTextAlign("center").run(), n(st.NONE);
          },
          className: Lt(
            "rounded w-8 h-8 p-1 flex justify-center items-center cursor-pointer transition",
            e.isActive({ textAlign: "center" }) ? "color-bg-brand xl:hover:brightness-90 dark:text-[#363B3F]" : "hover:color-bg-default-hover"
          ),
          children: /* @__PURE__ */ C.jsx(Ye, { name: "AlignCenter" })
        }
      ),
      /* @__PURE__ */ C.jsx(
        "button",
        {
          onClick: () => {
            e == null || e.chain().focus().setTextAlign("right").run(), n(st.NONE);
          },
          className: Lt(
            "rounded w-8 h-8 p-1 flex justify-center items-center cursor-pointer transition",
            e.isActive({ textAlign: "right" }) ? "color-bg-brand xl:hover:brightness-90 dark:text-[#363B3F]" : "hover:color-bg-default-hover"
          ),
          children: /* @__PURE__ */ C.jsx(Ye, { name: "AlignRight" })
        }
      )
    ]
  }
), EJ = ({
  elementRef: t,
  editor: e,
  setToolVisibility: n,
  bubbleMenu: r,
  setIsLinkPopupOpen: i,
  onError: a
}) => {
  const [o, s] = De(e.getAttributes("link").href), l = nt(() => {
    if (o === "" || o === void 0) {
      e.chain().focus().extendMarkRange("link").unsetLink().run();
      return;
    }
    if (!/^(https?:\/\/)?([\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?|\w+@[\w.-]+\.\w+)$/i.test(o)) {
      a && typeof a == "function" && a("Invalid URL");
      return;
    }
    let u = o;
    !o.startsWith("http://") && !o.startsWith("https://") && (u = "https://" + o), e.chain().focus().extendMarkRange("link").setLink({ href: u }).run(), n(st.NONE), r && i && i(!1);
  }, [o, e, r, i, a, n]);
  return /* @__PURE__ */ C.jsxs(
    "div",
    {
      ref: t,
      className: "z-50 h-auto gap-2 items-center flex max-h-[330px] overflow-y-auto scroll-smooth rounded-lg color-bg-default p-2 shadow-elevation-1 transition-all",
      children: [
        /* @__PURE__ */ C.jsx(
          al,
          {
            onChange: (c) => s(c.target.value),
            className: "w-full",
            placeholder: "Add link here",
            value: o
          }
        ),
        /* @__PURE__ */ C.jsxs("div", { className: "h-full flex items-center gap-2", children: [
          /* @__PURE__ */ C.jsx(Kt, { onClick: () => l(), className: "min-w-fit h-[36px]", children: "Apply" }),
          /* @__PURE__ */ C.jsx(
            Kt,
            {
              variant: "secondary",
              onClick: () => e.chain().focus().unsetLink().run(),
              className: "min-w-fit h-[36px]",
              children: "Unset"
            }
          )
        ] })
      ]
    }
  );
}, LMt = ({
  elementRef: t,
  editor: e
}) => {
  const n = [
    {
      title: "Superscript",
      command: () => e.chain().focus().unsetSubscript().toggleSuperscript().run(),
      isActive: () => e.isActive("superscript"),
      icon: "Superscript"
    },
    {
      title: "Subscript",
      command: () => e.chain().focus().unsetSuperscript().toggleSubscript().run(),
      isActive: () => e.isActive("subscript"),
      icon: "Subscript"
    },
    {
      title: "None",
      command: () => e.chain().focus().unsetSuperscript().unsetSubscript().run(),
      isActive: () => !e.isActive("superscript") && !e.isActive("subscript"),
      icon: "RemoveFormatting"
    }
  ];
  return /* @__PURE__ */ C.jsx("div", { ref: t, className: "z-50 w-48 color-bg-default rounded p-1", children: /* @__PURE__ */ C.jsx("div", { className: "flex flex-col gap-1 justify-center w-fit sm:w-full transition-all", children: n.map((r) => /* @__PURE__ */ C.jsxs(
    Kt,
    {
      variant: "ghost",
      onClick: () => {
        r.command();
      },
      className: Lt(
        "flex items-center justify-between w-full px-2 py-1 text-body-sm",
        r.isActive() && "color-bg-brand hover:!bg-[#B6A02E] dark:text-[#363B3F]"
      ),
      children: [
        /* @__PURE__ */ C.jsxs("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ C.jsx("div", { className: "rounded color-bg-default color-text-default p-1", children: /* @__PURE__ */ C.jsx(Ye, { name: r.icon, size: "sm" }) }),
          /* @__PURE__ */ C.jsx("span", { children: r.title })
        ] }),
        r.isActive() && /* @__PURE__ */ C.jsx(Ye, { name: "Check", size: "sm", className: "ml-2" })
      ]
    },
    r.title
  )) }) });
}, jJ = ({
  editor: t,
  setVisibility: e,
  elementRef: n
}) => /* @__PURE__ */ C.jsxs(
  "div",
  {
    ref: n,
    className: "z-50 h-auto gap-0.5 flex flex-wrap max-h-[400px] w-[14.7rem] overflow-y-auto scroll-smooth rounded color-bg-default px-2 py-2 shadow-elevation-3 transition-all",
    children: [
      Ky.map((r) => /* @__PURE__ */ C.jsx(
        "div",
        {
          onClick: () => {
            t && (t.chain().focus().setColor(r.color).run(), e(st.NONE));
          },
          className: Lt(
            "w-5 rounded-full flex justify-center items-center cursor-pointer ease-in duration-200 hover:scale-[1.05] h-5",
            r.code
          ),
          children: /* @__PURE__ */ C.jsx(
            Ye,
            {
              name: "Check",
              className: Lt(
                "w-[14px] aspect-square",
                t != null && t.isActive("textStyle", {
                  color: r.color
                }) ? "visible" : "invisible"
              )
            }
          )
        },
        r.color
      )),
      /* @__PURE__ */ C.jsxs(
        Kt,
        {
          variant: "ghost",
          onClick: () => {
            t && (t.chain().focus().unsetColor().run(), e(st.NONE));
          },
          className: "w-full justify-start mt-2 gap-1 !p-1 h-fit",
          children: [
            /* @__PURE__ */ C.jsx(Ye, { name: "Ban", className: "w-[18px] aspect-square" }),
            /* @__PURE__ */ C.jsx("span", { children: "None" })
          ]
        }
      )
    ]
  }
), TMt = ({
  editor: t,
  setVisibility: e,
  elementRef: n
}) => {
  const r = [
    {
      title: "Text",
      description: "Normal",
      icon: "Type",
      command: (i) => i.chain().focus().toggleNode("paragraph", "paragraph").run(),
      isActive: () => t.isActive("paragraph") && !t.isActive("bulletList") && !t.isActive("orderedList")
    },
    {
      title: "Heading 1",
      description: "Big",
      icon: "Heading1",
      command: (i) => {
        i.chain().focus().toggleHeading({ level: 1 }).run();
      },
      isActive: () => t.isActive("heading", { level: 1 })
    },
    {
      title: "Heading 2",
      description: "Medium",
      icon: "Heading2",
      command: (i) => {
        i.chain().focus().toggleHeading({ level: 2 }).run();
      },
      isActive: () => t.isActive("heading", { level: 2 })
    },
    {
      title: "Heading 3",
      description: "Small",
      icon: "Heading3",
      command: (i) => {
        i.chain().focus().toggleHeading({ level: 3 }).run();
      },
      isActive: () => t.isActive("heading", { level: 3 })
    }
  ];
  return /* @__PURE__ */ C.jsx(
    "div",
    {
      ref: n,
      className: Lt(
        "z-50 flex w-48 flex-col overflow-hidden rounded color-bg-default p-1 shadow-elevation-1"
      ),
      children: r.map((i) => /* @__PURE__ */ C.jsxs(
        "button",
        {
          onClick: () => {
            i.command(t), e(st.NONE);
          },
          className: Lt(
            "flex w-full items-center space-x-2 rounded-md px-2 py-1 text-left text-sm color-text-default transition",
            {
              "color-bg-brand xl:hover:brightness-90 dark:text-[#363B3F]": i.isActive(),
              "hover:color-bg-default-hover": !i.isActive()
            }
          ),
          children: [
            /* @__PURE__ */ C.jsx("div", { className: "flex h-10 w-10 items-center justify-center rounded color-bg-default color-text-default", children: /* @__PURE__ */ C.jsx(Ye, { name: i.icon, size: "md" }) }),
            /* @__PURE__ */ C.jsxs("div", { children: [
              /* @__PURE__ */ C.jsx("p", { className: "font-medium", children: i.title }),
              /* @__PURE__ */ C.jsxs("p", { className: "text-xs text-stone-500", children: [
                " ",
                i.description,
                " "
              ] })
            ] })
          ]
        },
        i.title
      ))
    }
  );
}, EMt = ({
  editor: t,
  isOpen: e,
  setIsOpen: n,
  setToolVisibility: r
}) => {
  const i = [
    {
      title: "Text",
      description: "Normal",
      icon: "Type",
      command: (c) => {
        const { from: u, to: d, state: f, hasMultipleLists: h } = $a(c);
        if (h)
          return;
        if (c.isActive("bulletList") || c.isActive("orderedList") || c.isActive("taskList")) {
          const m = c.chain().focus().command(
            (g) => Ja({ ...g, state: f, from: u, to: d })
          ).setTextSelection({ from: u, to: d }).focus().run();
          return r(st.NONE), m;
        }
        const p = c.chain().focus().toggleNode("paragraph", "paragraph").setTextSelection({ from: u, to: d }).focus().run();
        return r(st.NONE), p;
      },
      isActive: () => (t == null ? void 0 : t.isActive("paragraph")) && !(t != null && t.isActive("bulletList")) && !(t != null && t.isActive("orderedList"))
    },
    {
      title: "Heading 1",
      description: "Big",
      icon: "Heading1",
      command: (c) => {
        c.chain().toggleHeading({ level: 1 }).run(), r(st.NONE);
      },
      isActive: () => t == null ? void 0 : t.isActive("heading", { level: 1 })
    },
    {
      title: "Heading 2",
      description: "Medium",
      icon: "Heading2",
      command: (c) => {
        c.chain().toggleHeading({ level: 2 }).run(), r(st.NONE);
      },
      isActive: () => t == null ? void 0 : t.isActive("heading", { level: 2 })
    },
    {
      title: "Heading 3",
      description: "Small",
      icon: "Heading3",
      command: (c) => {
        c.chain().toggleHeading({ level: 3 }).run(), r(st.NONE);
      },
      isActive: () => t == null ? void 0 : t.isActive("heading", { level: 3 })
    }
  ], a = [
    {
      title: "Left",
      description: "Left",
      icon: "AlignLeft",
      command: (c) => {
        c.chain().setTextAlign("left").focus().run(), r(st.NONE);
      },
      isActive: () => t == null ? void 0 : t.isActive({ textAlign: "left" })
    },
    {
      title: "Center",
      description: "Center",
      icon: "AlignCenter",
      command: (c) => {
        c.chain().setTextAlign("center").focus().run(), r(st.NONE);
      },
      isActive: () => t == null ? void 0 : t.isActive({ textAlign: "center" })
    },
    {
      title: "Right",
      description: "Right",
      icon: "AlignRight",
      command: (c) => {
        c.chain().setTextAlign("right").focus().run(), r(st.NONE);
      },
      isActive: () => t == null ? void 0 : t.isActive({ textAlign: "right" })
    }
  ], o = [
    {
      title: "Bold",
      description: "Bold text",
      icon: "Bold",
      command: (c) => c.chain().toggleBold().run(),
      isActive: () => t == null ? void 0 : t.isActive("bold")
    },
    {
      title: "Italic",
      description: "Italic text",
      icon: "Italic",
      command: (c) => c.chain().toggleItalic().run(),
      isActive: () => t == null ? void 0 : t.isActive("italic")
    },
    {
      title: "Underline",
      description: "Underline text",
      icon: "Underline",
      command: (c) => c.chain().toggleUnderline().run(),
      isActive: () => t == null ? void 0 : t.isActive("underline")
    },
    {
      title: "Strikethrough",
      description: "Strikethrough text",
      icon: "Strikethrough",
      command: (c) => c.chain().toggleStrike().run(),
      isActive: () => t == null ? void 0 : t.isActive("strike")
    },
    {
      title: "Superscript",
      description: "Superscript text",
      icon: "Superscript",
      command: (c) => c.chain().unsetSubscript().toggleSuperscript().run(),
      isActive: () => t == null ? void 0 : t.isActive("superscript")
    },
    {
      title: "Subscript",
      description: "Subscript text",
      icon: "Subscript",
      command: (c) => c.chain().unsetSuperscript().toggleSubscript().run(),
      isActive: () => t == null ? void 0 : t.isActive("subscript")
    }
  ], s = [
    {
      title: "Code",
      description: "Code",
      icon: "Code",
      command: (c) => c.chain().toggleCode().run(),
      isActive: () => t == null ? void 0 : t.isActive("code")
    },
    {
      title: "Link",
      description: "Link",
      icon: "Link",
      command: () => r(st.LINK_POPUP),
      isActive: () => !1
    },
    {
      title: "Quote",
      description: "Quote",
      icon: "TextQuote",
      command: (c) => c.chain().toggleBlockquote().run(),
      isActive: () => t == null ? void 0 : t.isActive("blockquote")
    }
  ], l = [
    {
      title: "Bullet List",
      description: "Bullet list",
      icon: "List",
      command: (c) => {
        const { from: u, to: d, state: f, hasMultipleLists: h } = $a(c);
        if (h)
          return;
        if (c.isActive("bulletList")) {
          const m = c.chain().focus().command(
            (g) => Ja({ ...g, state: f, from: u, to: d })
          ).setTextSelection({ from: u, to: d }).focus().run();
          return r(st.NONE), m;
        }
        const p = c.chain().focus().command(
          (m) => Us({
            ...m,
            state: f,
            from: u,
            to: d,
            listConfig: {
              type: "bulletList",
              itemType: "listItem"
            }
          })
        ).setTextSelection({ from: u, to: d }).focus().run();
        return r(st.NONE), p;
      },
      isActive: () => t == null ? void 0 : t.isActive("bulletList")
    },
    {
      title: "Ordered List",
      description: "Ordered list",
      icon: "ListOrdered",
      command: (c) => {
        const { from: u, to: d, state: f, hasMultipleLists: h } = $a(c);
        if (h)
          return;
        if (c.isActive("orderedList")) {
          const m = c.chain().focus().command(
            (g) => Ja({ ...g, state: f, from: u, to: d })
          ).setTextSelection({ from: u, to: d }).focus().run();
          return r(st.NONE), m;
        }
        const p = c.chain().focus().command(
          (m) => Us({
            ...m,
            state: f,
            from: u,
            to: d,
            listConfig: {
              type: "orderedList",
              itemType: "listItem"
            }
          })
        ).setTextSelection({ from: u, to: d }).focus().run();
        return r(st.NONE), p;
      },
      isActive: () => t == null ? void 0 : t.isActive("orderedList")
    },
    {
      title: "Code Block",
      description: "Code block",
      icon: "Braces",
      command: (c) => c.chain().toggleCodeBlock().run(),
      isActive: () => t == null ? void 0 : t.isActive("codeBlock")
    }
  ];
  return /* @__PURE__ */ C.jsx(
    U3t,
    {
      title: "Text formating",
      isOpen: e,
      setIsOpen: n,
      onCloseAutoFocus: () => {
        r((c) => c === st.TEXT_FORMATING ? st.NONE : c);
      },
      content: /* @__PURE__ */ C.jsxs("div", { className: "px-4 flex flex-col gap-2 w-full", children: [
        /* @__PURE__ */ C.jsx("div", { className: "flex justify-start sm:justify-center items-center gap-1", children: i.map((c) => /* @__PURE__ */ C.jsx(
          "button",
          {
            onClick: () => t && c.command(t),
            className: Lt(
              "flex w-fit items-center font-medium space-x-2 rounded p-2 text-center text-sm color-text-default transition",
              {
                "color-bg-brand xl:hover:brightness-90 dark:text-[#363B3F]": c.isActive(),
                "hover:color-bg-default-hover": !c.isActive()
              }
            ),
            children: c.title
          },
          c.title
        )) }),
        /* @__PURE__ */ C.jsxs("div", { className: "flex justify-between sm:justify-center items-center gap-1", children: [
          /* @__PURE__ */ C.jsx("div", { className: "mobile-util-btn-group rounded flex gap-1 justify-evenly w-full sm:w-fit p-1", children: a.map((c) => /* @__PURE__ */ C.jsx(
            "button",
            {
              onClick: () => t && c.command(t),
              className: Lt(
                "flex items-center space-x-2 rounded px-4 py-1 color-text-default transition h-9",
                {
                  "color-bg-brand xl:hover:brightness-90 dark:text-[#363B3F]": c.isActive(),
                  "hover:color-bg-default-hover": !c.isActive()
                }
              ),
              children: /* @__PURE__ */ C.jsx(Ye, { name: c.icon, size: "md" })
            },
            c.title
          )) }),
          /* @__PURE__ */ C.jsx("div", { className: "mobile-util-btn-group rounded flex gap-1 justify-evenly w-full sm:w-fit p-1", children: s.map((c) => /* @__PURE__ */ C.jsx(
            "button",
            {
              onClick: () => t && c.command(t),
              className: Lt(
                "flex items-center space-x-2 rounded px-4 py-1 color-text-default transition h-9",
                {
                  "color-bg-brand xl:hover:brightness-90 dark:text-[#363B3F]": c.isActive(),
                  "hover:color-bg-default-hover": !c.isActive()
                }
              ),
              children: /* @__PURE__ */ C.jsx(Ye, { name: c.icon, size: "md" })
            },
            c.title
          )) })
        ] }),
        /* @__PURE__ */ C.jsxs("div", { className: "flex gap-1 justify-center", children: [
          /* @__PURE__ */ C.jsx("div", { className: "mobile-util-btn-group rounded flex gap-1 justify-evenly p-1 w-full sm:w-fit ", children: o.slice(0, 4).map((c) => /* @__PURE__ */ C.jsx(
            "button",
            {
              onClick: () => t && c.command(t),
              className: Lt(
                "flex items-center space-x-2 rounded px-4 py-1 color-text-default transition h-9",
                {
                  "color-bg-brand xl:hover:brightness-90 dark:text-[#363B3F]": c.isActive(),
                  "hover:color-bg-default-hover": !c.isActive()
                }
              ),
              children: /* @__PURE__ */ C.jsx(Ye, { name: c.icon, size: "md" })
            },
            c.title
          )) }),
          /* @__PURE__ */ C.jsx("div", { className: "mobile-util-btn-group rounded flex gap-1 justify-evenly p-1 w-full sm:w-fit ", children: o.slice(4).map((c) => /* @__PURE__ */ C.jsx(
            "button",
            {
              onClick: () => t && c.command(t),
              className: Lt(
                "flex items-center space-x-2 rounded px-4 py-1 color-text-default transition h-9",
                {
                  "color-bg-brand xl:hover:brightness-90 dark:text-[#363B3F]": c.isActive(),
                  "hover:color-bg-default-hover": !c.isActive()
                }
              ),
              children: /* @__PURE__ */ C.jsx(Ye, { name: c.icon, size: "md" })
            },
            c.title
          )) })
        ] }),
        /* @__PURE__ */ C.jsx("div", { className: "mobile-util-btn-group rounded flex gap-1 justify-center self-center w-fit p-1", children: l.map((c) => /* @__PURE__ */ C.jsx(
          "button",
          {
            onClick: () => t && c.command(t),
            className: Lt(
              "flex items-center space-x-2 rounded px-4 py-1 color-text-default transition h-9",
              {
                "color-bg-brand xl:hover:brightness-90 dark:text-[#363B3F]": c.isActive(),
                "hover:color-bg-default-hover": !c.isActive()
              }
            ),
            children: /* @__PURE__ */ C.jsx(Ye, { name: c.icon, size: "md" })
          },
          c.title
        )) }),
        /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col gap-4 mt-4", children: [
          /* @__PURE__ */ C.jsx("p", { className: "text-left sm:text-center text-lg font-semibold leading-none tracking-tight", children: "Text color" }),
          /* @__PURE__ */ C.jsxs(
            AY,
            {
              opts: {
                align: "start",
                dragFree: !0,
                slidesToScroll: "auto"
              },
              className: "w-full max-w-md mx-auto",
              children: [
                /* @__PURE__ */ C.jsxs(SY, { children: [
                  /* @__PURE__ */ C.jsx(
                    R9,
                    {
                      style: {
                        flexBasis: "calc(100% / 12)"
                      },
                      children: /* @__PURE__ */ C.jsx(
                        "button",
                        {
                          className: "mb-1 drop-shadow flex justify-center items-center cursor-pointer transition",
                          onClick: () => {
                            t && t.chain().unsetColor().run();
                          },
                          children: /* @__PURE__ */ C.jsx(Ye, { name: "Ban", className: "w-6 h-6" })
                        }
                      )
                    }
                  ),
                  Ky.map((c, u) => /* @__PURE__ */ C.jsx(
                    R9,
                    {
                      style: {
                        flexBasis: "calc(100% / 12)"
                      },
                      children: /* @__PURE__ */ C.jsx(
                        "button",
                        {
                          onClick: () => {
                            t && t.chain().setColor(c.color).run();
                          },
                          className: Lt(
                            "w-6 h-6 mb-1 drop-shadow rounded-full flex justify-center items-center cursor-pointer transition",
                            c.code
                          ),
                          children: /* @__PURE__ */ C.jsx(
                            Ye,
                            {
                              name: "Check",
                              className: Lt(
                                "w-[14px] aspect-square",
                                t != null && t.isActive("textStyle", {
                                  color: c.color
                                }) ? "visible" : "invisible"
                              )
                            }
                          )
                        },
                        c.color
                      )
                    },
                    u
                  ))
                ] }),
                /* @__PURE__ */ C.jsx("div", { className: "flex justify-center gap-2 mt-4 w-full max-w-sm", children: Array.from({ length: Ky.length / 8 }).map((c, u) => /* @__PURE__ */ C.jsx(LY, { index: u }, u)) })
              ]
            }
          )
        ] })
      ] })
    }
  );
}, $a = (t) => {
  const { state: e } = t, { from: n, to: r } = e.selection, i = ["bulletList", "orderedList", "taskList"].filter(
    (l) => t.isActive(l)
  ), a = [], o = [];
  e.doc.nodesBetween(n, r, (l, c) => {
    if (l.type.name === "dBlock") {
      a.push(c);
      let u = !1;
      l.content.forEach((d) => {
        ["bulletList", "orderedList", "taskList"].includes(d.type.name) && (u = !0);
      }), u && o.push(c);
    }
  });
  const s = a.length > 1 && a.some((l) => {
    const c = e.doc.nodeAt(l);
    if (!c) return !1;
    const u = c.content.content.some(
      (f) => ["bulletList", "orderedList", "taskList"].includes(f.type.name)
    ), d = c.content.content.some(
      (f) => !["bulletList", "orderedList", "taskList"].includes(f.type.name)
    );
    return u && d || // Mixed content in same dBlock
    u && o.length < a.length;
  });
  return {
    activeListTypes: i,
    activeListDBlocks: o,
    activeDBlocks: a,
    from: n,
    to: r,
    state: e,
    hasMultipleLists: i.length > 1 || o.length > 1 && i.length === 1 || s
  };
}, jMt = (t) => {
  if (!t.content || !Array.isArray(t.content))
    return [];
  const e = (r, i) => ({
    type: "dBlock",
    content: [
      {
        type: "paragraph",
        attrs: { indent: i },
        // Add indentation level
        content: r
      }
    ]
  }), n = (r, i = 0) => {
    var o, s, l, c;
    const a = [];
    return (s = (o = r.content) == null ? void 0 : o[0]) != null && s.content && a.push(e(r.content[0].content, i)), (c = (l = r.content) == null ? void 0 : l.slice(1)) == null || c.forEach((u) => {
      ["bulletList", "orderedList", "taskList"].includes(u.type) && u.content.forEach((d) => {
        a.push(...n(d, i + 1));
      });
    }), a;
  };
  return t.content.flatMap((r) => n(r, 0));
}, Ja = ({
  tr: t,
  dispatch: e,
  state: n,
  from: r,
  to: i
}) => {
  if (!e) return !0;
  let a = -1, o = null;
  if (n.doc.nodesBetween(r, i, (c, u) => {
    if (c.type.name === "dBlock" && (a = u), c.type.name === "bulletList" || c.type.name === "orderedList" || c.type.name === "taskList")
      return o = c, !1;
  }), a === -1 || !o) return !1;
  const s = jMt(o.toJSON()), l = n.schema.nodeFromJSON({
    type: "doc",
    content: s
  }).content;
  return t.replaceWith(
    a,
    a + n.doc.nodeAt(a).nodeSize,
    l
  ), !0;
}, Us = ({
  tr: t,
  dispatch: e,
  state: n,
  from: r,
  to: i,
  listConfig: a
}) => {
  if (!e) return !0;
  let o = -1, s = -1, l = null;
  const c = [];
  if (n.doc.nodesBetween(r, i, (d, f) => {
    if (d.type.name === "dBlock" && (o === -1 && (o = f), s = f + d.nodeSize), d.type.name === "taskList" || d.type.name === "bulletList" || d.type.name === "orderedList")
      return l = d, !1;
    if (d.type.name === "paragraph" || d.type.name === "heading")
      if (d.type.name === "heading") {
        const h = n.schema.nodes.paragraph.create(
          null,
          d.content
        );
        c.push(h);
      } else
        c.push(d);
  }), o === -1) return !1;
  let u;
  if (l) {
    const d = l.toJSON();
    if (!(a != null && a.type) || !(a != null && a.itemType)) return !1;
    const f = (h) => h.map((p) => {
      const m = {
        type: a.itemType,
        ...a.hasAttrs ? { attrs: { checked: !1 } } : {},
        content: []
      };
      return p.content.forEach((g) => {
        g.type === "paragraph" ? m.content.push(g) : ["bulletList", "orderedList", "taskList"].includes(g.type) ? m.content.push({
          type: a.type,
          content: f(g.content)
        }) : m.content.push(g);
      }), m;
    });
    u = {
      type: "dBlock",
      content: [
        {
          type: a.type,
          content: f(d.content)
        }
      ]
    };
  } else if (c.length > 0)
    u = {
      type: "dBlock",
      content: [
        {
          type: a == null ? void 0 : a.type,
          content: c.map((d) => ({
            type: a == null ? void 0 : a.itemType,
            ...a != null && a.hasAttrs ? { attrs: { checked: !1 } } : {},
            content: [d.toJSON()]
          }))
        }
      ]
    };
  else
    return !1;
  return t.replaceWith(
    o,
    s,
    n.schema.nodeFromJSON(u)
  ), !0;
}, NMt = ({ editor: t, elementRef: e }) => {
  const n = [
    {
      name: "Text",
      icon: "Type",
      command: () => {
        const { from: i, to: a, state: o, hasMultipleLists: s } = $a(t);
        if (!s)
          return t.isActive("bulletList") || t.isActive("orderedList") || t.isActive("taskList") ? t.chain().focus().command(
            (l) => Ja({ ...l, state: o, from: i, to: a })
          ).setTextSelection({ from: i, to: a }).focus().run() : t.chain().focus().toggleNode("paragraph", "paragraph").setTextSelection({ from: i, to: a }).focus().run();
      },
      isActive: () => t.isActive("paragraph") && !t.isActive("bulletList") && !t.isActive("orderedList") && !t.isActive("taskList")
    },
    {
      name: "Heading 1",
      icon: "Heading1",
      command: () => t.chain().focus().toggleHeading({ level: 1 }).run(),
      isActive: () => t.isActive("heading", { level: 1 })
    },
    {
      name: "Heading 2",
      icon: "Heading2",
      command: () => t.chain().focus().toggleHeading({ level: 2 }).run(),
      isActive: () => t.isActive("heading", { level: 2 })
    },
    {
      name: "Heading 3",
      icon: "Heading3",
      command: () => t.chain().focus().toggleHeading({ level: 3 }).run(),
      isActive: () => t.isActive("heading", { level: 3 })
    },
    {
      name: "To-do List",
      icon: "ListChecks",
      command: () => {
        const { from: i, to: a, state: o, hasMultipleLists: s } = $a(t);
        if (!s)
          return t.isActive("taskList") ? t.chain().focus().command(
            (l) => Ja({ ...l, state: o, from: i, to: a })
          ).setTextSelection({ from: i, to: a }).focus().run() : t.chain().focus().command(
            (l) => Us({
              ...l,
              state: o,
              from: i,
              to: a,
              listConfig: {
                type: "taskList",
                itemType: "taskItem",
                hasAttrs: !0
              }
            })
          ).setTextSelection({ from: i, to: a }).focus().run();
      },
      isActive: () => t.isActive("taskItem")
    },
    {
      name: "Bullet List",
      icon: "ListOrdered",
      command: () => {
        const { from: i, to: a, state: o, hasMultipleLists: s } = $a(t);
        if (!s)
          return t.isActive("bulletList") ? t.chain().focus().command(
            (l) => Ja({ ...l, state: o, from: i, to: a })
          ).setTextSelection({ from: i, to: a }).focus().run() : t.chain().focus().command(
            (l) => Us({
              ...l,
              state: o,
              from: i,
              to: a,
              listConfig: {
                type: "bulletList",
                itemType: "listItem"
              }
            })
          ).setTextSelection({ from: i, to: a }).focus().run();
      },
      isActive: () => t.isActive("bulletList")
    },
    {
      name: "Numbered List",
      icon: "ListOrdered",
      command: () => {
        const { from: i, to: a, state: o, hasMultipleLists: s } = $a(t);
        if (!s)
          return t.isActive("orderedList") ? t.chain().focus().command(
            (l) => Ja({ ...l, state: o, from: i, to: a })
          ).setTextSelection({ from: i, to: a }).focus().run() : t.chain().focus().command(
            (l) => Us({
              ...l,
              state: o,
              from: i,
              to: a,
              listConfig: {
                type: "orderedList",
                itemType: "listItem"
              }
            })
          ).setTextSelection({ from: i, to: a }).focus().run();
      },
      isActive: () => t.isActive("orderedList")
    },
    {
      name: "Quote",
      icon: "TextQuote",
      command: () => t.chain().focus().toggleNode("paragraph", "paragraph").toggleBlockquote().run(),
      isActive: () => t.isActive("blockquote")
    },
    {
      name: "Code Block",
      icon: "Braces",
      command: () => t.chain().focus().toggleCodeBlock().run(),
      isActive: () => t.isActive("codeBlock")
    }
  ], r = n.filter((i) => i.isActive()).pop() ?? {
    name: "Multiple"
  };
  return /* @__PURE__ */ C.jsx(
    Mi,
    {
      sideOffset: 15,
      anchorTrigger: /* @__PURE__ */ C.jsxs("button", { className: "bg-transparent hover:!color-bg-default-hover color-text-default rounded p-1 flex items-center justify-between gap-2 w-fit max-w-36", children: [
        /* @__PURE__ */ C.jsx("span", { className: "text-body-sm truncate", children: r.name }),
        /* @__PURE__ */ C.jsx(Ye, { name: "ChevronDown", size: "sm", className: "mt-1" })
      ] }),
      className: "shadow-elevation-3",
      content: /* @__PURE__ */ C.jsx(
        "div",
        {
          ref: e,
          className: "h-auto flex w-48 flex-col gap-1 overflow-hidden rounded color-bg-default p-1 color-text-default transition-all",
          children: n.map((i, a) => /* @__PURE__ */ C.jsxs(
            "button",
            {
              onClick: () => {
                i.command();
              },
              className: Lt(
                "flex items-center justify-between rounded-sm px-2 py-1 text-body-sm hover:color-bg-default-hover transition-all",
                {
                  "color-bg-brand hover:color-bg-brand-hover dark:text-[#363B3F]": i.isActive()
                }
              ),
              children: [
                /* @__PURE__ */ C.jsxs("div", { className: "flex items-center space-x-2", children: [
                  /* @__PURE__ */ C.jsx("div", { className: "rounded color-bg-default color-text-default p-1", children: /* @__PURE__ */ C.jsx(Ye, { name: i.icon, size: "sm" }) }),
                  /* @__PURE__ */ C.jsx("span", { children: i.name })
                ] }),
                r.name === i.name && /* @__PURE__ */ C.jsx(Ye, { name: "Check", size: "sm" })
              ]
            },
            a
          ))
        }
      )
    },
    "NodeSelector"
  );
}, kr = en(({ icon: t, isActive: e, onClick: n, tooltip: r, classNames: i, disabled: a, size: o }, s) => r ? /* @__PURE__ */ C.jsx(En, { text: r, children: /* @__PURE__ */ C.jsx(
  mn,
  {
    ref: s,
    variant: "ghost",
    size: o || "md",
    icon: t,
    onClick: n,
    isActive: e,
    className: i,
    disabled: a
  }
) }) : /* @__PURE__ */ C.jsx(
  mn,
  {
    ref: s,
    variant: "ghost",
    size: o || "md",
    icon: t,
    onClick: n,
    isActive: e,
    className: i,
    disabled: a
  }
)), Wp = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cpath%20d='M0%2012C0%205.37258%205.37258%200%2012%200C18.6274%200%2024%205.37258%2024%2012C24%2018.6274%2018.6274%2024%2012%2024C5.37258%2024%200%2018.6274%200%2012Z'%20fill='url(%23pattern0_2594_44493)'/%3e%3cdefs%3e%3cpattern%20id='pattern0_2594_44493'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_2594_44493'%20transform='translate(0%20-0.0714286)%20scale(0.0102041)'/%3e%3c/pattern%3e%3cimage%20id='image0_2594_44493'%20width='98'%20height='112'%20xlink:href='data:image/png;base64,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'/%3e%3c/defs%3e%3c/svg%3e", OA = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEjSURBVHgBjZJBToNQEIb/NzTeoMbGjTeoN5Au1S7wBrqwyk5OoD1B46pRF9UbsEBc9nmEHsI08QhGZnxMpaGUEv4EwoP/mxnyj0GNTp++AoPORA+Gx+mo91r1mOJh+LL0WYwDqC8i/obJGCuSfRJ1bHLdtWtQIaY5WoiYBknYtZQfmOGjpTIvC7TAahTvpMksmUQCvK0A6itzNl1egmi2k2K+2gPsD+mvHGkh4MIVoPuSLYbIYxOk3YAJVRuktwd3DhjvggqRB0Slc3D+/D1Lw95DE5Rnq3E487ySXeyu4zooz/R9tD/QUYV5Ufke1HbKvW4RdFS9icRoKeKO1c7Fi+HUbQ/BzzPdXjmxDCy8TOIk7G2CZf1nqzEJfqOPm8Otif4AFnp3K1F5HHAAAAAASUVORK5CYII=", Jm = 43200, HI = 1440, FI = Symbol.for("constructDateFrom");
function r5(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && FI in t ? t[FI](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function lo(t, e) {
  return r5(t, t);
}
function DMt(t, e, n) {
  const r = lo(t);
  return isNaN(e) ? r5(t, NaN) : (r.setDate(r.getDate() + e), r);
}
let IMt = {};
function PMt() {
  return IMt;
}
function _I(t) {
  const e = lo(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function BA(t, ...e) {
  const n = r5.bind(
    null,
    t || e.find((r) => typeof r == "object")
  );
  return e.map(n);
}
function $4(t, e) {
  const n = +lo(t) - +lo(e);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function zMt(t) {
  return r5(t, Date.now());
}
function RMt(t, e, n) {
  const [r, i] = BA(
    n == null ? void 0 : n.in,
    t,
    e
  ), a = r.getFullYear() - i.getFullYear(), o = r.getMonth() - i.getMonth();
  return a * 12 + o;
}
function OMt(t) {
  return (e) => {
    const r = (t ? Math[t] : Math.trunc)(e);
    return r === 0 ? 0 : r;
  };
}
function BMt(t, e) {
  return +lo(t) - +lo(e);
}
function HMt(t, e) {
  const n = lo(t);
  return n.setHours(23, 59, 59, 999), n;
}
function FMt(t, e) {
  const n = lo(t), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function _Mt(t, e) {
  const n = lo(t);
  return +HMt(n) == +FMt(n);
}
function VMt(t, e, n) {
  const [r, i, a] = BA(
    n == null ? void 0 : n.in,
    t,
    t,
    e
  ), o = $4(i, a), s = Math.abs(
    RMt(i, a)
  );
  if (s < 1) return 0;
  i.getMonth() === 1 && i.getDate() > 27 && i.setDate(30), i.setMonth(i.getMonth() - o * s);
  let l = $4(i, a) === -o;
  _Mt(r) && s === 1 && $4(r, a) === 1 && (l = !1);
  const c = o * (s - +l);
  return c === 0 ? 0 : c;
}
function qMt(t, e, n) {
  const r = BMt(t, e) / 1e3;
  return OMt(n == null ? void 0 : n.roundingMethod)(r);
}
const UMt = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, WMt = (t, e, n) => {
  let r;
  const i = UMt[t];
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : r = i.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function jv(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const ZMt = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, GMt = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, YMt = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, KMt = {
  date: jv({
    formats: ZMt,
    defaultWidth: "full"
  }),
  time: jv({
    formats: GMt,
    defaultWidth: "full"
  }),
  dateTime: jv({
    formats: YMt,
    defaultWidth: "full"
  })
}, $Mt = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, JMt = (t, e, n, r) => $Mt[t];
function Mf(t) {
  return (e, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && t.formattingValues) {
      const o = t.defaultFormattingWidth || t.defaultWidth, s = n != null && n.width ? String(n.width) : o;
      i = t.formattingValues[s] || t.formattingValues[o];
    } else {
      const o = t.defaultWidth, s = n != null && n.width ? String(n.width) : t.defaultWidth;
      i = t.values[s] || t.values[o];
    }
    const a = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[a];
  };
}
const QMt = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, XMt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, eCt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, tCt = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, nCt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, rCt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, iCt = (t, e) => {
  const n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, aCt = {
  ordinalNumber: iCt,
  era: Mf({
    values: QMt,
    defaultWidth: "wide"
  }),
  quarter: Mf({
    values: XMt,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Mf({
    values: eCt,
    defaultWidth: "wide"
  }),
  day: Mf({
    values: tCt,
    defaultWidth: "wide"
  }),
  dayPeriod: Mf({
    values: nCt,
    defaultWidth: "wide",
    formattingValues: rCt,
    defaultFormattingWidth: "wide"
  })
};
function Cf(t) {
  return (e, n = {}) => {
    const r = n.width, i = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], a = e.match(i);
    if (!a)
      return null;
    const o = a[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? sCt(s, (d) => d.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      oCt(s, (d) => d.test(o))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = e.slice(o.length);
    return { value: c, rest: u };
  };
}
function oCt(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function sCt(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function lCt(t) {
  return (e, n = {}) => {
    const r = e.match(t.matchPattern);
    if (!r) return null;
    const i = r[0], a = e.match(t.parsePattern);
    if (!a) return null;
    let o = t.valueCallback ? t.valueCallback(a[0]) : a[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    const s = e.slice(i.length);
    return { value: o, rest: s };
  };
}
const cCt = /^(\d+)(th|st|nd|rd)?/i, uCt = /\d+/i, dCt = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, fCt = {
  any: [/^b/i, /^(a|c)/i]
}, hCt = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, pCt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, mCt = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, yCt = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, gCt = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, vCt = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, bCt = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, wCt = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, kCt = {
  ordinalNumber: lCt({
    matchPattern: cCt,
    parsePattern: uCt,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Cf({
    matchPatterns: dCt,
    defaultMatchWidth: "wide",
    parsePatterns: fCt,
    defaultParseWidth: "any"
  }),
  quarter: Cf({
    matchPatterns: hCt,
    defaultMatchWidth: "wide",
    parsePatterns: pCt,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Cf({
    matchPatterns: mCt,
    defaultMatchWidth: "wide",
    parsePatterns: yCt,
    defaultParseWidth: "any"
  }),
  day: Cf({
    matchPatterns: gCt,
    defaultMatchWidth: "wide",
    parsePatterns: vCt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Cf({
    matchPatterns: bCt,
    defaultMatchWidth: "any",
    parsePatterns: wCt,
    defaultParseWidth: "any"
  })
}, xCt = {
  code: "en-US",
  formatDistance: WMt,
  formatLong: KMt,
  formatRelative: JMt,
  localize: aCt,
  match: kCt,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function MCt(t, e, n) {
  const r = PMt(), i = (n == null ? void 0 : n.locale) ?? r.locale ?? xCt, a = 2520, o = $4(t, e);
  if (isNaN(o)) throw new RangeError("Invalid time value");
  const s = Object.assign({}, n, {
    addSuffix: n == null ? void 0 : n.addSuffix,
    comparison: o
  }), [l, c] = BA(
    n == null ? void 0 : n.in,
    ...o > 0 ? [e, t] : [t, e]
  ), u = qMt(c, l), d = (_I(c) - _I(l)) / 1e3, f = Math.round((u - d) / 60);
  let h;
  if (f < 2)
    return n != null && n.includeSeconds ? u < 5 ? i.formatDistance("lessThanXSeconds", 5, s) : u < 10 ? i.formatDistance("lessThanXSeconds", 10, s) : u < 20 ? i.formatDistance("lessThanXSeconds", 20, s) : u < 40 ? i.formatDistance("halfAMinute", 0, s) : u < 60 ? i.formatDistance("lessThanXMinutes", 1, s) : i.formatDistance("xMinutes", 1, s) : f === 0 ? i.formatDistance("lessThanXMinutes", 1, s) : i.formatDistance("xMinutes", f, s);
  if (f < 45)
    return i.formatDistance("xMinutes", f, s);
  if (f < 90)
    return i.formatDistance("aboutXHours", 1, s);
  if (f < HI) {
    const p = Math.round(f / 60);
    return i.formatDistance("aboutXHours", p, s);
  } else {
    if (f < a)
      return i.formatDistance("xDays", 1, s);
    if (f < Jm) {
      const p = Math.round(f / HI);
      return i.formatDistance("xDays", p, s);
    } else if (f < Jm * 2)
      return h = Math.round(f / Jm), i.formatDistance("aboutXMonths", h, s);
  }
  if (h = VMt(c, l), h < 12) {
    const p = Math.round(f / Jm);
    return i.formatDistance("xMonths", p, s);
  } else {
    const p = h % 12, m = Math.trunc(h / 12);
    return p < 3 ? i.formatDistance("aboutXYears", m, s) : p < 9 ? i.formatDistance("overXYears", m, s) : i.formatDistance("almostXYears", m + 1, s);
  }
}
function CCt(t, e) {
  return MCt(t, zMt(t), e);
}
function ACt(t, e) {
  return +lo(t) > +lo(e);
}
function SCt(t, e, n) {
  return DMt(t, -1);
}
const NJ = (t) => t && (t.length > 20 ? t.slice(0, 5) + "..." + t.slice(t.length - 5) : t), LCt = (t) => {
  const e = SCt(/* @__PURE__ */ new Date());
  return ACt(t, e) ? CCt(t, { addSuffix: !0 }) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    t.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
      hour12: !0
    }),
    /* @__PURE__ */ C.jsx("span", { children: "•" }),
    t.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric"
    })
  ] });
}, DJ = (t) => {
  const e = /(https?:\/\/[^\s]+)/g;
  return t.split(e).map((r, i) => r.match(e) ? /* @__PURE__ */ C.jsx(
    "a",
    {
      href: r,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "custom-text-link",
      children: r
    },
    i
  ) : r);
}, IJ = ({ size: t = "lg" }) => /* @__PURE__ */ C.jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ C.jsx(
  Ye,
  {
    name: "LoaderCircle",
    size: t,
    className: "animate-spin",
    fill: "transparent",
    stroke: "currentColor"
  }
) }), PJ = ({ username: t, createdAt: e }) => {
  const { getEnsStatus: n, ensCache: r } = yl(), [i, a] = De({
    name: t,
    isEns: !1
  });
  return ze(() => {
    n(t, a);
  }, [t, r]), /* @__PURE__ */ C.jsxs("div", { className: "flex justify-start items-center gap-2", children: [
    /* @__PURE__ */ C.jsx(
      ap,
      {
        src: i.isEns ? Wp : `https://api.dicebear.com/9.x/identicon/svg?seed=${encodeURIComponent(
          i.name
        )}`,
        size: "sm",
        className: "min-w-6"
      }
    ),
    /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ C.jsxs("span", { className: "text-body-sm-bold inline-flex items-center gap-1", children: [
        NJ(i.name),
        i.isEns && /* @__PURE__ */ C.jsx("img", { src: OA, alt: "verified", className: "w-3.5 h-3.5" })
      ] }),
      /* @__PURE__ */ C.jsx("span", { className: "text-helper-text-sm color-text-secondary inline-flex items-center gap-1", children: e && LCt(e) })
    ] })
  ] });
}, TCt = ({
  reply: t,
  username: e,
  createdAt: n,
  isLast: r
}) => /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col gap-2 relative pl-4 pb-3 last:pb-0", children: [
  /* @__PURE__ */ C.jsx(
    "div",
    {
      className: be("absolute left-0 top-0 h-full w-[1px] custom-border-bg", {
        hidden: r
      })
    }
  ),
  /* @__PURE__ */ C.jsx("div", { className: "absolute left-0 top-0 w-4", children: /* @__PURE__ */ C.jsx("div", { className: "w-[10px] h-[20px] border-l border-b rounded-bl-lg custom-border" }) }),
  /* @__PURE__ */ C.jsx(PJ, { username: e, createdAt: n }),
  /* @__PURE__ */ C.jsx("span", { className: "text-body-sm flex flex-col gap-2 ml-3 pl-4 border-l custom-border whitespace-pre-wrap break-words", children: DJ(t) })
] }), zJ = ({
  username: t,
  selectedContent: e,
  comment: n,
  createdAt: r,
  replies: i,
  onResolve: a,
  onDelete: o,
  onUnresolve: s,
  isResolved: l,
  isDropdown: c = !1,
  activeCommentId: u,
  id: d,
  isDisabled: f = !1,
  isCommentOwner: h,
  version: p,
  emptyComment: m
}) => {
  const g = Ue(null), [v, k] = De(!1), [w, b] = De(!1), x = Ue(null), { setOpenReplyId: A } = yl(), { getEnsStatus: L, ensCache: M } = yl(), [j, D] = De({
    name: t,
    isEns: !1
  });
  ze(() => {
    L(t, D);
  }, [t, M]), ze(() => {
    c && b(!0), d !== u && b(!1), x.current && i && x.current.scrollTo({
      top: x.current.scrollHeight,
      behavior: "smooth"
    });
  }, [c, u, d, i]);
  const z = () => {
    var _;
    if (a == null || a(d), (_ = g.current) != null && _.parentElement) {
      const W = g.current.closest('[role="dialog"]');
      W && W.remove();
    }
  }, H = () => {
    var _;
    if (o == null || o(d), (_ = g.current) != null && _.parentElement) {
      const W = g.current.closest('[role="dialog"]');
      W && W.remove();
    }
  }, V = () => {
    var _;
    if (s == null || s(d), (_ = g.current) != null && _.parentElement) {
      const W = g.current.closest('[role="dialog"]');
      W && W.remove();
    }
  }, F = nt(() => {
    if (!(i != null && i.length)) return null;
    let _ = i.sort(
      (W, G) => new Date(W.createdAt || /* @__PURE__ */ new Date()).getTime() - new Date(G.createdAt || /* @__PURE__ */ new Date()).getTime()
    );
    return !w && i.length > 3 && (_ = i.slice(-2)), /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col gap-0 ml-3 relative", children: [
      i.length > 3 && !w && /* @__PURE__ */ C.jsxs(
        "div",
        {
          onClick: () => b(!0),
          className: "text-helper-text-sm color-text-secondary hover:underline text-left pl-2 pb-3 border-l custom-border cursor-pointer flex items-center gap-1",
          children: [
            /* @__PURE__ */ C.jsx(
              mn,
              {
                icon: "ChevronDown",
                variant: "ghost",
                size: "sm",
                rounded: !0,
                className: "color-text-secondary border custom-border scale-[0.8]",
                onClick: () => b(!0)
              }
            ),
            /* @__PURE__ */ C.jsx("div", { className: "flex items-center -space-x-1", children: i.slice(0, 2).map((W) => /* @__PURE__ */ C.jsx(
              ap,
              {
                src: j.isEns ? Wp : `https://api.dicebear.com/9.x/identicon/svg?seed=${encodeURIComponent(
                  W.username || ""
                )}`,
                size: "sm",
                className: "w-4 h-4 last:z-10 bg-transparent",
                bordered: "border"
              },
              W.id
            )) }),
            i.length - 2,
            " more replies in this thread"
          ]
        }
      ),
      _.map((W, G) => /* @__PURE__ */ C.jsx(
        TCt,
        {
          reply: W.content || "",
          username: W.username || "",
          createdAt: W.createdAt || /* @__PURE__ */ new Date(),
          isLast: G === _.length - 1
        },
        W.id
      ))
    ] });
  }, [i, w]);
  return m ? /* @__PURE__ */ C.jsxs(
    "div",
    {
      ref: x,
      className: be(
        "flex flex-col gap-3 px-3 group comment-card",
        !c && "!px-6",
        c && "py-3"
      ),
      children: [
        /* @__PURE__ */ C.jsx("div", { className: "flex justify-start items-center", children: /* @__PURE__ */ C.jsx(ECt, {}) }),
        /* @__PURE__ */ C.jsx("div", { className: "flex flex-col gap-2 ml-3 pl-4 border-l custom-border", children: /* @__PURE__ */ C.jsxs("div", { className: "flex items-center gap-2 color-text-secondary", children: [
          /* @__PURE__ */ C.jsx(IJ, { size: "sm" }),
          /* @__PURE__ */ C.jsx("p", { className: "text-helper-text-sm", children: "Syncing onchain comments" })
        ] }) })
      ]
    }
  ) : /* @__PURE__ */ C.jsxs(
    "div",
    {
      ref: x,
      className: be(
        "flex flex-col gap-0 px-3 group comment-card",
        l && "opacity-70",
        !c && "!px-6",
        c && "py-3"
      ),
      children: [
        /* @__PURE__ */ C.jsxs("div", { className: "flex justify-between items-center", children: [
          /* @__PURE__ */ C.jsx(PJ, { username: t, createdAt: r }),
          p === "2" ? /* @__PURE__ */ C.jsx(
            En,
            {
              text: f ? "Available in a moment" : "",
              sideOffset: 0,
              position: "top",
              children: /* @__PURE__ */ C.jsxs(Bx, { className: "!space-x-0", children: [
                !c && i && i.length === 0 && /* @__PURE__ */ C.jsx(
                  En,
                  {
                    text: f ? "" : "Add reply",
                    sideOffset: 0,
                    position: "bottom",
                    children: /* @__PURE__ */ C.jsx(
                      mn,
                      {
                        variant: "ghost",
                        icon: "MessageSquarePlus",
                        size: "sm",
                        disabled: f,
                        className: "opacity-0 group-hover:opacity-100  transition-opacity duration-300 disabled:bg-transparent",
                        onClick: () => A(d)
                      }
                    )
                  }
                ),
                /* @__PURE__ */ C.jsx(
                  En,
                  {
                    text: f ? "" : "Coming soon",
                    sideOffset: 0,
                    position: "bottom",
                    children: /* @__PURE__ */ C.jsx(
                      mn,
                      {
                        variant: "ghost",
                        icon: "Smile",
                        disabled: !0,
                        size: "sm",
                        className: "opacity-0 group-hover:opacity-100  transition-opacity duration-300 disabled:bg-transparent"
                      }
                    )
                  }
                ),
                !c && h && /* @__PURE__ */ C.jsx(
                  Mi,
                  {
                    align: "end",
                    sideOffset: 4,
                    anchorTrigger: /* @__PURE__ */ C.jsx(
                      mn,
                      {
                        icon: "Ellipsis",
                        variant: "ghost",
                        disabled: f,
                        size: "sm",
                        className: be(
                          "opacity-0 group-hover:opacity-100  transition-opacity duration-300 disabled:bg-transparent"
                        )
                      }
                    ),
                    content: /* @__PURE__ */ C.jsxs(
                      "div",
                      {
                        ref: g,
                        className: "flex flex-col gap-1 p-2 w-40 shadow-elevation-3",
                        children: [
                          /* @__PURE__ */ C.jsxs(
                            "button",
                            {
                              className: be(
                                "flex items-center color-text-default text-sm font-medium gap-2 rounded p-2 transition-all hover:color-bg-default-hover w-full"
                              ),
                              onClick: l ? V : z,
                              children: [
                                /* @__PURE__ */ C.jsx(Ye, { name: "CircleCheck", size: "sm" }),
                                l ? "Unresolve" : "Resolve"
                              ]
                            }
                          ),
                          /* @__PURE__ */ C.jsxs(
                            "button",
                            {
                              className: "flex items-center color-text-danger text-sm font-medium gap-2 rounded p-2 transition-all hover:color-bg-default-hover w-full",
                              onClick: H,
                              children: [
                                /* @__PURE__ */ C.jsx(Ye, { name: "Trash2", size: "sm" }),
                                "Delete"
                              ]
                            }
                          )
                        ]
                      }
                    )
                  },
                  "comment-card-more-actions"
                )
              ] })
            }
          ) : /* @__PURE__ */ C.jsx(En, { text: "Actions are not supported for old comments", children: /* @__PURE__ */ C.jsx(
            mn,
            {
              icon: "Info",
              variant: "ghost",
              disabled: !0,
              size: "sm",
              className: be(
                "opacity-0 group-hover:opacity-100  transition-opacity duration-300 disabled:bg-transparent"
              )
            }
          ) })
        ] }),
        /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col gap-2 ml-3 pl-4 border-l custom-border py-3", children: [
          e && /* @__PURE__ */ C.jsx("div", { className: "highlight-comment-bg p-1 rounded-lg", children: /* @__PURE__ */ C.jsxs("div", { className: "relative", children: [
            /* @__PURE__ */ C.jsxs(
              "span",
              {
                className: be("text-body-sm italic block", {
                  "line-clamp-2": !v && e.length > 70
                }),
                children: [
                  '"',
                  e,
                  '"'
                ]
              }
            ),
            e.length > 70 && /* @__PURE__ */ C.jsx(
              "button",
              {
                onClick: () => k(!v),
                className: "text-helper-text-sm pt-1 color-text-secondary hover:underline",
                children: v ? "Show less" : "Show more"
              }
            )
          ] }) }),
          n && /* @__PURE__ */ C.jsx("div", { children: /* @__PURE__ */ C.jsx("span", { className: "text-body-sm whitespace-pre-wrap break-words", children: DJ(n) }) })
        ] }),
        i && F()
      ]
    }
  );
}, ECt = () => /* @__PURE__ */ C.jsxs("div", { className: "flex justify-start items-center gap-2", children: [
  /* @__PURE__ */ C.jsx(hn, { className: "w-6  h-6 rounded-full" }),
  /* @__PURE__ */ C.jsx(hn, { className: "w-32 h-4 rounded" })
] }), RJ = ({
  activeCommentId: t,
  initialComment: e = "",
  isBubbleMenu: n = !1,
  selectedContent: r,
  isDisabled: i,
  isCommentOwner: a
}) => {
  const [o, s] = De(e), [l, c] = De(""), [u, d] = De(!0), [f, h] = De(!!t), p = Ue(null), [m, g] = De(!1), {
    inlineCommentData: v,
    setInlineCommentData: k,
    addComment: w,
    comments: b,
    activeComments: x,
    username: A,
    activeComment: L,
    selectedText: M,
    dropdownRef: j,
    handleInput: D,
    isCommentActive: z,
    // onNextComment,
    // onPrevComment,
    // activeCommentIndex,
    onCommentReply: H,
    resolveComment: V,
    unresolveComment: F,
    deleteComment: _,
    isDDocOwner: W,
    onComment: G,
    isConnected: Y,
    setCommentDrawerOpen: Z,
    isLoading: oe,
    connectViaUsername: ee,
    connectViaWallet: ae,
    setUsername: fe
  } = yl(), me = !(L != null && L.content) && !(L != null && L.username) && !(L != null && L.createdAt), ge = (X) => {
    const re = X.target.value;
    s(re), re || (X.target.style.height = "40px");
  }, $ = (X) => {
    const re = X.target.value;
    c(re);
  }, se = async () => {
    if (!Y || !A) {
      const X = o.trim();
      Z(!0), k((re) => ({
        ...re,
        inlineCommentText: X,
        handleClick: !0
      })), g(!0);
      return;
    }
    o.trim() && (w(o, A), h(!0), G == null || G(), s(""), g(!0));
  }, xe = () => {
    if (!Y) {
      Z(!0);
      return;
    }
    const X = {
      id: `reply-${oh()}`,
      username: A,
      content: l,
      replies: [],
      createdAt: /* @__PURE__ */ new Date(),
      selectedContent: r
    };
    l.trim() && t && (H == null || H(t, X), c(""));
  }, Oe = (X) => {
    X.key === "Enter" && !X.shiftKey && (X.preventDefault(), !f && n ? xe() : se());
  }, je = () => {
    d((X) => !X);
  }, Me = () => {
    _(t);
  };
  ze(() => {
    t && (L ? s(L.content || "") : h(!1));
  }, [L, t, b]), ze(() => {
    p.current && (L != null && L.replies) && p.current.scrollTo({
      top: p.current.scrollHeight,
      behavior: "smooth"
    });
  }, [L == null ? void 0 : L.replies]), ze(() => {
    Y && A && v.handleClick && v.inlineCommentText && (k((X) => ({
      ...X,
      inlineCommentText: "",
      handleClick: !1
    })), m || (w(v.inlineCommentText, A), h(!0), G == null || G()), s(""), g(!0));
  }, [
    Y,
    A,
    v.handleClick,
    v.inlineCommentText
  ]);
  const he = () => /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col color-bg-secondary rounded-md", children: [
    /* @__PURE__ */ C.jsx("p", { className: "inline-flex gap-2 border-b color-border-default text-heading-xsm p-3", children: "What would you like to be identified with" }),
    /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col gap-2 p-3", children: [
      /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col gap-3", children: [
        /* @__PURE__ */ C.jsx(
          al,
          {
            type: "text",
            value: A,
            onChange: (X) => fe == null ? void 0 : fe(X.target.value),
            onKeyDown: (X) => {
              X.key === "Enter" && A && (ee == null || ee(A));
            },
            className: "font-normal",
            placeholder: "Enter a name"
          }
        ),
        /* @__PURE__ */ C.jsx(
          Kt,
          {
            onClick: () => ee == null ? void 0 : ee(A),
            disabled: !A || oe,
            isLoading: oe,
            className: "w-full",
            children: "Join"
          }
        )
      ] }),
      /* @__PURE__ */ C.jsxs("div", { className: "text-[12px] text-gray-400 flex items-center my-3", children: [
        /* @__PURE__ */ C.jsx(
          r0,
          {
            direction: "horizontal",
            size: "md",
            className: "flex-grow md:!mr-4"
          }
        ),
        "or join with your ",
        /* @__PURE__ */ C.jsx("span", { className: "font-semibold", children: ".eth " }),
        " domain",
        /* @__PURE__ */ C.jsx(
          r0,
          {
            direction: "horizontal",
            size: "md",
            className: "flex-grow md:!ml-4"
          }
        )
      ] }),
      /* @__PURE__ */ C.jsx("div", { className: "text-center", children: /* @__PURE__ */ C.jsxs(
        Kt,
        {
          onClick: !Y && (() => {
            ae(), k((X) => ({
              ...X,
              handleClick: !0
            }));
          }),
          disabled: oe,
          className: "custom-ens-button",
          children: [
            /* @__PURE__ */ C.jsx("img", { alt: "ens-logo", src: Wp }),
            " ",
            oe ? "Connecting with ENS ..." : "Continue with ENS"
          ]
        }
      ) })
    ] })
  ] }), pe = () => /* @__PURE__ */ C.jsxs("div", { className: "p-3 flex flex-col gap-2 color-bg-secondary rounded-md", children: [
    /* @__PURE__ */ C.jsx(
      Rh,
      {
        value: o,
        onChange: ge,
        onKeyDown: Oe,
        className: "color-bg-default w-full text-body-sm color-text-default min-h-[40px] max-h-[96px] overflow-y-auto no-scrollbar px-3 py-2 whitespace-pre-wrap",
        placeholder: "Type your comment",
        autoFocus: !0,
        onInput: (X) => D(X, o)
      }
    ),
    /* @__PURE__ */ C.jsx("div", { className: "h-full flex items-center justify-end", children: /* @__PURE__ */ C.jsx(
      Kt,
      {
        onClick: se,
        className: "px-4 py-2 w-20 min-w-20 h-9 font-medium text-sm",
        disabled: !o.trim(),
        children: "Send"
      }
    ) })
  ] }), J = () => /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs("div", { className: "flex justify-between items-center px-3 py-2 border-b color-border-default", children: [
      /* @__PURE__ */ C.jsxs("p", { className: "text-sm font-medium color-text-default", children: [
        "Highlighted Comments (",
        x.length,
        ")"
      ] }),
      /* @__PURE__ */ C.jsx("div", { className: "relative flex items-center gap-1", children: (W || a) && !me && /* @__PURE__ */ C.jsxs(
        En,
        {
          text: i ? "Available in a moment" : "",
          sideOffset: 0,
          position: "top",
          children: [
            /* @__PURE__ */ C.jsx(
              Mi,
              {
                align: "end",
                sideOffset: 4,
                anchorTrigger: /* @__PURE__ */ C.jsx(
                  mn,
                  {
                    onClick: je,
                    icon: "Ellipsis",
                    variant: "ghost",
                    disabled: i,
                    className: be({
                      "!bg-transparent": i
                    })
                  }
                ),
                content: u ? /* @__PURE__ */ C.jsx("div", { className: "flex flex-col gap-1 p-2 w-40 shadow-elevation-3", children: /* @__PURE__ */ C.jsxs(
                  "button",
                  {
                    className: "flex items-center color-text-danger text-sm font-medium gap-2 rounded p-2 transition-all hover:color-bg-default-hover w-full",
                    onClick: Me,
                    onTouchEnd: Me,
                    children: [
                      /* @__PURE__ */ C.jsx(Ye, { name: "Trash2", size: "sm" }),
                      "Delete thread"
                    ]
                  }
                ) }) : null
              },
              "more-actions"
            ),
            /* @__PURE__ */ C.jsx(
              En,
              {
                text: i ? "" : L != null && L.resolved ? "Unresolve" : "Resolve",
                sideOffset: 5,
                position: "bottom",
                children: /* @__PURE__ */ C.jsx(
                  mn,
                  {
                    icon: L != null && L.resolved ? "CircleCheck2" : "CircleCheck",
                    variant: "ghost",
                    disabled: i,
                    className: be({
                      "!bg-transparent": i
                    }),
                    onClick: () => L != null && L.resolved ? F(t) : V(t)
                  }
                )
              }
            )
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ C.jsx(
      "div",
      {
        ref: p,
        className: "max-h-[224px] overflow-y-auto no-scrollbar",
        children: /* @__PURE__ */ C.jsx(
          zJ,
          {
            username: L == null ? void 0 : L.username,
            selectedContent: (L == null ? void 0 : L.selectedContent) || M,
            comment: (L == null ? void 0 : L.content) || o,
            createdAt: L == null ? void 0 : L.createdAt,
            replies: L == null ? void 0 : L.replies,
            isResolved: L == null ? void 0 : L.resolved,
            isDropdown: !0,
            isDisabled: L && !Object.hasOwn(L, "commentIndex"),
            version: L == null ? void 0 : L.version,
            emptyComment: me
          }
        )
      }
    ),
    /* @__PURE__ */ C.jsxs("div", { className: "color-bg-secondary border-t color-border-default p-3 rounded-b", children: [
      /* @__PURE__ */ C.jsx(
        Rh,
        {
          value: l,
          onChange: $,
          onKeyDown: Oe,
          className: "color-bg-default text-body-sm color-text-default min-h-[40px] max-h-[96px] overflow-y-auto no-scrollbar px-3 py-2 whitespace-pre-wrap",
          placeholder: i ? "Available in a moment" : "Reply",
          autoFocus: !0,
          disabled: (L == null ? void 0 : L.resolved) || i || me,
          onInput: (X) => D(X, l)
        }
      ),
      /* @__PURE__ */ C.jsx("div", { className: "h-full flex justify-end pt-2", children: /* @__PURE__ */ C.jsx(
        Kt,
        {
          onClick: xe,
          className: "px-4 py-2 w-20 min-w-20 h-9",
          disabled: (L == null ? void 0 : L.resolved) || !l.trim(),
          children: "Send"
        }
      ) })
    ] })
  ] }), K = (X) => /* @__PURE__ */ C.jsx(
    "div",
    {
      ref: j,
      className: "w-[300px] color-bg-default shadow-elevation-4 md:shadow-none rounded-md select-text",
      children: X
    }
  );
  return n ? z ? K(J()) : null : !Y && !v.handleClick ? K(he()) : z ? null : K(pe());
};
var s3 = { exports: {} };
/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */
s3.exports;
(function(t, e) {
  (function() {
    var n = {
      function: !0,
      object: !0
    }, r = n[typeof window] && window || this, i = e, a = t && !t.nodeType && t, o = i && a && typeof Pr == "object" && Pr;
    o && (o.global === o || o.window === o || o.self === o) && (r = o);
    var s = Math.pow(2, 53) - 1, l = /\bOpera/, c = Object.prototype, u = c.hasOwnProperty, d = c.toString;
    function f(M) {
      return M = String(M), M.charAt(0).toUpperCase() + M.slice(1);
    }
    function h(M, j, D) {
      var z = {
        "10.0": "10",
        "6.4": "10 Technical Preview",
        "6.3": "8.1",
        "6.2": "8",
        "6.1": "Server 2008 R2 / 7",
        "6.0": "Server 2008 / Vista",
        "5.2": "Server 2003 / XP 64-bit",
        "5.1": "XP",
        "5.01": "2000 SP1",
        "5.0": "2000",
        "4.0": "NT",
        "4.90": "ME"
      };
      return j && D && /^Win/i.test(M) && !/^Windows Phone /i.test(M) && (z = z[/[\d.]+$/.exec(M)]) && (M = "Windows " + z), M = String(M), j && D && (M = M.replace(RegExp(j, "i"), D)), M = m(
        M.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]
      ), M;
    }
    function p(M, j) {
      var D = -1, z = M ? M.length : 0;
      if (typeof z == "number" && z > -1 && z <= s)
        for (; ++D < z; )
          j(M[D], D, M);
      else
        g(M, j);
    }
    function m(M) {
      return M = x(M), /^(?:webOS|i(?:OS|P))/.test(M) ? M : f(M);
    }
    function g(M, j) {
      for (var D in M)
        u.call(M, D) && j(M[D], D, M);
    }
    function v(M) {
      return M == null ? f(M) : d.call(M).slice(8, -1);
    }
    function k(M, j) {
      var D = M != null ? typeof M[j] : "number";
      return !/^(?:boolean|number|string|undefined)$/.test(D) && (D == "object" ? !!M[j] : !0);
    }
    function w(M) {
      return String(M).replace(/([ -])(?!$)/g, "$1?");
    }
    function b(M, j) {
      var D = null;
      return p(M, function(z, H) {
        D = j(D, z, H, M);
      }), D;
    }
    function x(M) {
      return String(M).replace(/^ +| +$/g, "");
    }
    function A(M) {
      var j = r, D = M && typeof M == "object" && v(M) != "String";
      D && (j = M, M = null);
      var z = j.navigator || {}, H = z.userAgent || "";
      M || (M = H);
      var V = D ? !!z.likeChrome : /\bChrome\b/.test(M) && !/internal|\n/i.test(d.toString()), F = "Object", _ = D ? F : "ScriptBridgingProxyObject", W = D ? F : "Environment", G = D && j.java ? "JavaPackage" : v(j.java), Y = D ? F : "RuntimeObject", Z = /\bJava/.test(G) && j.java, oe = Z && v(j.environment) == W, ee = Z ? "a" : "α", ae = Z ? "b" : "β", fe = j.document || {}, me = j.operamini || j.opera, ge = l.test(ge = D && me ? me["[[Class]]"] : v(me)) ? ge : me = null, $, se = M, xe = [], Oe = null, je = M == H, Me = je && me && typeof me.version == "function" && me.version(), he, pe = Ie([
        { label: "EdgeHTML", pattern: "Edge" },
        "Trident",
        { label: "WebKit", pattern: "AppleWebKit" },
        "iCab",
        "Presto",
        "NetFront",
        "Tasman",
        "KHTML",
        "Gecko"
      ]), J = S([
        "Adobe AIR",
        "Arora",
        "Avant Browser",
        "Breach",
        "Camino",
        "Electron",
        "Epiphany",
        "Fennec",
        "Flock",
        "Galeon",
        "GreenBrowser",
        "iCab",
        "Iceweasel",
        "K-Meleon",
        "Konqueror",
        "Lunascape",
        "Maxthon",
        { label: "Microsoft Edge", pattern: "(?:Edge|Edg|EdgA|EdgiOS)" },
        "Midori",
        "Nook Browser",
        "PaleMoon",
        "PhantomJS",
        "Raven",
        "Rekonq",
        "RockMelt",
        { label: "Samsung Internet", pattern: "SamsungBrowser" },
        "SeaMonkey",
        { label: "Silk", pattern: "(?:Cloud9|Silk-Accelerated)" },
        "Sleipnir",
        "SlimBrowser",
        { label: "SRWare Iron", pattern: "Iron" },
        "Sunrise",
        "Swiftfox",
        "Vivaldi",
        "Waterfox",
        "WebPositive",
        { label: "Yandex Browser", pattern: "YaBrowser" },
        { label: "UC Browser", pattern: "UCBrowser" },
        "Opera Mini",
        { label: "Opera Mini", pattern: "OPiOS" },
        "Opera",
        { label: "Opera", pattern: "OPR" },
        "Chromium",
        "Chrome",
        { label: "Chrome", pattern: "(?:HeadlessChrome)" },
        { label: "Chrome Mobile", pattern: "(?:CriOS|CrMo)" },
        { label: "Firefox", pattern: "(?:Firefox|Minefield)" },
        { label: "Firefox for iOS", pattern: "FxiOS" },
        { label: "IE", pattern: "IEMobile" },
        { label: "IE", pattern: "MSIE" },
        "Safari"
      ]), K = O([
        { label: "BlackBerry", pattern: "BB10" },
        "BlackBerry",
        { label: "Galaxy S", pattern: "GT-I9000" },
        { label: "Galaxy S2", pattern: "GT-I9100" },
        { label: "Galaxy S3", pattern: "GT-I9300" },
        { label: "Galaxy S4", pattern: "GT-I9500" },
        { label: "Galaxy S5", pattern: "SM-G900" },
        { label: "Galaxy S6", pattern: "SM-G920" },
        { label: "Galaxy S6 Edge", pattern: "SM-G925" },
        { label: "Galaxy S7", pattern: "SM-G930" },
        { label: "Galaxy S7 Edge", pattern: "SM-G935" },
        "Google TV",
        "Lumia",
        "iPad",
        "iPod",
        "iPhone",
        "Kindle",
        { label: "Kindle Fire", pattern: "(?:Cloud9|Silk-Accelerated)" },
        "Nexus",
        "Nook",
        "PlayBook",
        "PlayStation Vita",
        "PlayStation",
        "TouchPad",
        "Transformer",
        { label: "Wii U", pattern: "WiiU" },
        "Wii",
        "Xbox One",
        { label: "Xbox 360", pattern: "Xbox" },
        "Xoom"
      ]), X = q({
        Apple: { iPad: 1, iPhone: 1, iPod: 1 },
        Alcatel: {},
        Archos: {},
        Amazon: { Kindle: 1, "Kindle Fire": 1 },
        Asus: { Transformer: 1 },
        "Barnes & Noble": { Nook: 1 },
        BlackBerry: { PlayBook: 1 },
        Google: { "Google TV": 1, Nexus: 1 },
        HP: { TouchPad: 1 },
        HTC: {},
        Huawei: {},
        Lenovo: {},
        LG: {},
        Microsoft: { Xbox: 1, "Xbox One": 1 },
        Motorola: { Xoom: 1 },
        Nintendo: { "Wii U": 1, Wii: 1 },
        Nokia: { Lumia: 1 },
        Oppo: {},
        Samsung: { "Galaxy S": 1, "Galaxy S2": 1, "Galaxy S3": 1, "Galaxy S4": 1 },
        Sony: { PlayStation: 1, "PlayStation Vita": 1 },
        Xiaomi: { Mi: 1, Redmi: 1 }
      }), re = P([
        "Windows Phone",
        "KaiOS",
        "Android",
        "CentOS",
        { label: "Chrome OS", pattern: "CrOS" },
        "Debian",
        { label: "DragonFly BSD", pattern: "DragonFly" },
        "Fedora",
        "FreeBSD",
        "Gentoo",
        "Haiku",
        "Kubuntu",
        "Linux Mint",
        "OpenBSD",
        "Red Hat",
        "SuSE",
        "Ubuntu",
        "Xubuntu",
        "Cygwin",
        "Symbian OS",
        "hpwOS",
        "webOS ",
        "webOS",
        "Tablet OS",
        "Tizen",
        "Linux",
        "Mac OS X",
        "Macintosh",
        "Mac",
        "Windows 98;",
        "Windows "
      ]);
      function Ie(Pe) {
        return b(Pe, function(ve, Le) {
          return ve || RegExp("\\b" + (Le.pattern || w(Le)) + "\\b", "i").exec(M) && (Le.label || Le);
        });
      }
      function q(Pe) {
        return b(Pe, function(ve, Le, Re) {
          return ve || (Le[K] || Le[/^[a-z]+(?: +[a-z]+\b)*/i.exec(K)] || RegExp("\\b" + w(Re) + "(?:\\b|\\w*\\d)", "i").exec(M)) && Re;
        });
      }
      function S(Pe) {
        return b(Pe, function(ve, Le) {
          return ve || RegExp("\\b" + (Le.pattern || w(Le)) + "\\b", "i").exec(M) && (Le.label || Le);
        });
      }
      function P(Pe) {
        return b(Pe, function(ve, Le) {
          var Re = Le.pattern || w(Le);
          return !ve && (ve = RegExp("\\b" + Re + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(M)) && (ve = h(ve, Re, Le.label || Le)), ve;
        });
      }
      function O(Pe) {
        return b(Pe, function(ve, Le) {
          var Re = Le.pattern || w(Le);
          return !ve && (ve = RegExp("\\b" + Re + " *\\d+[.\\w_]*", "i").exec(M) || RegExp("\\b" + Re + " *\\w+-[\\w]*", "i").exec(M) || RegExp("\\b" + Re + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(M)) && ((ve = String(Le.label && !RegExp(Re, "i").test(Le.label) ? Le.label : ve).split("/"))[1] && !/[\d.]+/.test(ve[0]) && (ve[0] += " " + ve[1]), Le = Le.label || Le, ve = m(ve[0].replace(RegExp(Re, "i"), Le).replace(RegExp("; *(?:" + Le + "[_-])?", "i"), " ").replace(RegExp("(" + Le + ")[-_.]?(\\w)", "i"), "$1 $2"))), ve;
        });
      }
      function ne(Pe) {
        return b(Pe, function(ve, Le) {
          return ve || (RegExp(Le + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(M) || 0)[1] || null;
        });
      }
      function le() {
        return this.description || "";
      }
      if (pe && (pe = [pe]), /\bAndroid\b/.test(re) && !K && ($ = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(M)) && (K = x($[1]).replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null), X && !K ? K = O([X]) : X && K && (K = K.replace(RegExp("^(" + w(X) + ")[-_.\\s]", "i"), X + " ").replace(RegExp("^(" + w(X) + ")[-_.]?(\\w)", "i"), X + " $2")), ($ = /\bGoogle TV\b/.exec(K)) && (K = $[0]), /\bSimulator\b/i.test(M) && (K = (K ? K + " " : "") + "Simulator"), J == "Opera Mini" && /\bOPiOS\b/.test(M) && xe.push("running in Turbo/Uncompressed mode"), J == "IE" && /\blike iPhone OS\b/.test(M) ? ($ = A(M.replace(/like iPhone OS/, "")), X = $.manufacturer, K = $.product) : /^iP/.test(K) ? (J || (J = "Safari"), re = "iOS" + (($ = / OS ([\d_]+)/i.exec(M)) ? " " + $[1].replace(/_/g, ".") : "")) : J == "Konqueror" && /^Linux\b/i.test(re) ? re = "Kubuntu" : X && X != "Google" && (/Chrome/.test(J) && !/\bMobile Safari\b/i.test(M) || /\bVita\b/.test(K)) || /\bAndroid\b/.test(re) && /^Chrome/.test(J) && /\bVersion\//i.test(M) ? (J = "Android Browser", re = /\bAndroid\b/.test(re) ? re : "Android") : J == "Silk" ? (/\bMobi/i.test(M) || (re = "Android", xe.unshift("desktop mode")), /Accelerated *= *true/i.test(M) && xe.unshift("accelerated")) : J == "UC Browser" && /\bUCWEB\b/.test(M) ? xe.push("speed mode") : J == "PaleMoon" && ($ = /\bFirefox\/([\d.]+)\b/.exec(M)) ? xe.push("identifying as Firefox " + $[1]) : J == "Firefox" && ($ = /\b(Mobile|Tablet|TV)\b/i.exec(M)) ? (re || (re = "Firefox OS"), K || (K = $[1])) : !J || ($ = !/\bMinefield\b/i.test(M) && /\b(?:Firefox|Safari)\b/.exec(J)) ? (J && !K && /[\/,]|^[^(]+?\)/.test(M.slice(M.indexOf($ + "/") + 8)) && (J = null), ($ = K || X || re) && (K || X || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(re)) && (J = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(re) ? re : $) + " Browser")) : J == "Electron" && ($ = (/\bChrome\/([\d.]+)\b/.exec(M) || 0)[1]) && xe.push("Chromium " + $), Me || (Me = ne([
        "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
        "Version",
        w(J),
        "(?:Firefox|Minefield|NetFront)"
      ])), ($ = pe == "iCab" && parseFloat(Me) > 3 && "WebKit" || /\bOpera\b/.test(J) && (/\bOPR\b/.test(M) ? "Blink" : "Presto") || /\b(?:Midori|Nook|Safari)\b/i.test(M) && !/^(?:Trident|EdgeHTML)$/.test(pe) && "WebKit" || !pe && /\bMSIE\b/i.test(M) && (re == "Mac OS" ? "Tasman" : "Trident") || pe == "WebKit" && /\bPlayStation\b(?! Vita\b)/i.test(J) && "NetFront") && (pe = [$]), J == "IE" && ($ = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(M) || 0)[1]) ? (J += " Mobile", re = "Windows Phone " + (/\+$/.test($) ? $ : $ + ".x"), xe.unshift("desktop mode")) : /\bWPDesktop\b/i.test(M) ? (J = "IE Mobile", re = "Windows Phone 8.x", xe.unshift("desktop mode"), Me || (Me = (/\brv:([\d.]+)/.exec(M) || 0)[1])) : J != "IE" && pe == "Trident" && ($ = /\brv:([\d.]+)/.exec(M)) && (J && xe.push("identifying as " + J + (Me ? " " + Me : "")), J = "IE", Me = $[1]), je) {
        if (k(j, "global"))
          if (Z && ($ = Z.lang.System, se = $.getProperty("os.arch"), re = re || $.getProperty("os.name") + " " + $.getProperty("os.version")), oe) {
            try {
              Me = j.require("ringo/engine").version.join("."), J = "RingoJS";
            } catch {
              ($ = j.system) && $.global.system == j.system && (J = "Narwhal", re || (re = $[0].os || null));
            }
            J || (J = "Rhino");
          } else typeof j.process == "object" && !j.process.browser && ($ = j.process) && (typeof $.versions == "object" && (typeof $.versions.electron == "string" ? (xe.push("Node " + $.versions.node), J = "Electron", Me = $.versions.electron) : typeof $.versions.nw == "string" && (xe.push("Chromium " + Me, "Node " + $.versions.node), J = "NW.js", Me = $.versions.nw)), J || (J = "Node.js", se = $.arch, re = $.platform, Me = /[\d.]+/.exec($.version), Me = Me ? Me[0] : null));
        else v($ = j.runtime) == _ ? (J = "Adobe AIR", re = $.flash.system.Capabilities.os) : v($ = j.phantom) == Y ? (J = "PhantomJS", Me = ($ = $.version || null) && $.major + "." + $.minor + "." + $.patch) : typeof fe.documentMode == "number" && ($ = /\bTrident\/(\d+)/i.exec(M)) ? (Me = [Me, fe.documentMode], ($ = +$[1] + 4) != Me[1] && (xe.push("IE " + Me[1] + " mode"), pe && (pe[1] = ""), Me[1] = $), Me = J == "IE" ? String(Me[1].toFixed(1)) : Me[0]) : typeof fe.documentMode == "number" && /^(?:Chrome|Firefox)\b/.test(J) && (xe.push("masking as " + J + " " + Me), J = "IE", Me = "11.0", pe = ["Trident"], re = "Windows");
        re = re && m(re);
      }
      if (Me && ($ = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(Me) || /(?:alpha|beta)(?: ?\d)?/i.exec(M + ";" + (je && z.appMinorVersion)) || /\bMinefield\b/i.test(M) && "a") && (Oe = /b/i.test($) ? "beta" : "alpha", Me = Me.replace(RegExp($ + "\\+?$"), "") + (Oe == "beta" ? ae : ee) + (/\d+\+?/.exec($) || "")), J == "Fennec" || J == "Firefox" && /\b(?:Android|Firefox OS|KaiOS)\b/.test(re))
        J = "Firefox Mobile";
      else if (J == "Maxthon" && Me)
        Me = Me.replace(/\.[\d.]+/, ".x");
      else if (/\bXbox\b/i.test(K))
        K == "Xbox 360" && (re = null), K == "Xbox 360" && /\bIEMobile\b/.test(M) && xe.unshift("mobile mode");
      else if ((/^(?:Chrome|IE|Opera)$/.test(J) || J && !K && !/Browser|Mobi/.test(J)) && (re == "Windows CE" || /Mobi/i.test(M)))
        J += " Mobile";
      else if (J == "IE" && je)
        try {
          j.external === null && xe.unshift("platform preview");
        } catch {
          xe.unshift("embedded");
        }
      else (/\bBlackBerry\b/.test(K) || /\bBB10\b/.test(M)) && ($ = (RegExp(K.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(M) || 0)[1] || Me) ? ($ = [$, /BB10/.test(M)], re = ($[1] ? (K = null, X = "BlackBerry") : "Device Software") + " " + $[0], Me = null) : this != g && K != "Wii" && (je && me || /Opera/.test(J) && /\b(?:MSIE|Firefox)\b/i.test(M) || J == "Firefox" && /\bOS X (?:\d+\.){2,}/.test(re) || J == "IE" && (re && !/^Win/.test(re) && Me > 5.5 || /\bWindows XP\b/.test(re) && Me > 8 || Me == 8 && !/\bTrident\b/.test(M))) && !l.test($ = A.call(g, M.replace(l, "") + ";")) && $.name && ($ = "ing as " + $.name + (($ = $.version) ? " " + $ : ""), l.test(J) ? (/\bIE\b/.test($) && re == "Mac OS" && (re = null), $ = "identify" + $) : ($ = "mask" + $, ge ? J = m(ge.replace(/([a-z])([A-Z])/g, "$1 $2")) : J = "Opera", /\bIE\b/.test($) && (re = null), je || (Me = null)), pe = ["Presto"], xe.push($));
      ($ = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(M) || 0)[1]) && ($ = [parseFloat($.replace(/\.(\d)$/, ".0$1")), $], J == "Safari" && $[1].slice(-1) == "+" ? (J = "WebKit Nightly", Oe = "alpha", Me = $[1].slice(0, -1)) : (Me == $[1] || Me == ($[2] = (/\bSafari\/([\d.]+\+?)/i.exec(M) || 0)[1])) && (Me = null), $[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(M) || 0)[1], $[0] == 537.36 && $[2] == 537.36 && parseFloat($[1]) >= 28 && pe == "WebKit" && (pe = ["Blink"]), !je || !V && !$[1] ? (pe && (pe[1] = "like Safari"), $ = ($ = $[0], $ < 400 ? 1 : $ < 500 ? 2 : $ < 526 ? 3 : $ < 533 ? 4 : $ < 534 ? "4+" : $ < 535 ? 5 : $ < 537 ? 6 : $ < 538 ? 7 : $ < 601 ? 8 : $ < 602 ? 9 : $ < 604 ? 10 : $ < 606 ? 11 : $ < 608 ? 12 : "12")) : (pe && (pe[1] = "like Chrome"), $ = $[1] || ($ = $[0], $ < 530 ? 1 : $ < 532 ? 2 : $ < 532.05 ? 3 : $ < 533 ? 4 : $ < 534.03 ? 5 : $ < 534.07 ? 6 : $ < 534.1 ? 7 : $ < 534.13 ? 8 : $ < 534.16 ? 9 : $ < 534.24 ? 10 : $ < 534.3 ? 11 : $ < 535.01 ? 12 : $ < 535.02 ? "13+" : $ < 535.07 ? 15 : $ < 535.11 ? 16 : $ < 535.19 ? 17 : $ < 536.05 ? 18 : $ < 536.1 ? 19 : $ < 537.01 ? 20 : $ < 537.11 ? "21+" : $ < 537.13 ? 23 : $ < 537.18 ? 24 : $ < 537.24 ? 25 : $ < 537.36 ? 26 : pe != "Blink" ? "27" : "28")), pe && (pe[1] += " " + ($ += typeof $ == "number" ? ".x" : /[.+]/.test($) ? "" : "+")), J == "Safari" && (!Me || parseInt(Me) > 45) ? Me = $ : J == "Chrome" && /\bHeadlessChrome/i.test(M) && xe.unshift("headless")), J == "Opera" && ($ = /\bzbov|zvav$/.exec(re)) ? (J += " ", xe.unshift("desktop mode"), $ == "zvav" ? (J += "Mini", Me = null) : J += "Mobile", re = re.replace(RegExp(" *" + $ + "$"), "")) : J == "Safari" && /\bChrome\b/.exec(pe && pe[1]) ? (xe.unshift("desktop mode"), J = "Chrome Mobile", Me = null, /\bOS X\b/.test(re) ? (X = "Apple", re = "iOS 4.3+") : re = null) : /\bSRWare Iron\b/.test(J) && !Me && (Me = ne("Chrome")), Me && Me.indexOf($ = /[\d.]+$/.exec(re)) == 0 && M.indexOf("/" + $ + "-") > -1 && (re = x(re.replace($, ""))), re && re.indexOf(J) != -1 && !RegExp(J + " OS").test(re) && (re = re.replace(RegExp(" *" + w(J) + " *"), "")), pe && !/\b(?:Avant|Nook)\b/.test(J) && (/Browser|Lunascape|Maxthon/.test(J) || J != "Safari" && /^iOS/.test(re) && /\bSafari\b/.test(pe[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(J) && pe[1]) && ($ = pe[pe.length - 1]) && xe.push($), xe.length && (xe = ["(" + xe.join("; ") + ")"]), X && K && K.indexOf(X) < 0 && xe.push("on " + X), K && xe.push((/^on /.test(xe[xe.length - 1]) ? "" : "on ") + K), re && ($ = / ([\d.+]+)$/.exec(re), he = $ && re.charAt(re.length - $[0].length - 1) == "/", re = {
        architecture: 32,
        family: $ && !he ? re.replace($[0], "") : re,
        version: $ ? $[1] : null,
        toString: function() {
          var Pe = this.version;
          return this.family + (Pe && !he ? " " + Pe : "") + (this.architecture == 64 ? " 64-bit" : "");
        }
      }), ($ = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(se)) && !/\bi686\b/i.test(se) ? (re && (re.architecture = 64, re.family = re.family.replace(RegExp(" *" + $), "")), J && (/\bWOW64\b/i.test(M) || je && /\w(?:86|32)$/.test(z.cpuClass || z.platform) && !/\bWin64; x64\b/i.test(M)) && xe.unshift("32-bit")) : re && /^OS X/.test(re.family) && J == "Chrome" && parseFloat(Me) >= 39 && (re.architecture = 64), M || (M = null);
      var de = {};
      return de.description = M, de.layout = pe && pe[0], de.manufacturer = X, de.name = J, de.prerelease = Oe, de.product = K, de.ua = M, de.version = J && Me, de.os = re || {
        /**
         * The CPU architecture the OS is built for.
         *
         * @memberOf platform.os
         * @type number|null
         */
        architecture: null,
        /**
         * The family of the OS.
         *
         * Common values include:
         * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
         * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
         * "SuSE", "Android", "iOS" and "Windows Phone"
         *
         * @memberOf platform.os
         * @type string|null
         */
        family: null,
        /**
         * The version of the OS.
         *
         * @memberOf platform.os
         * @type string|null
         */
        version: null,
        /**
         * Returns the OS string.
         *
         * @memberOf platform.os
         * @returns {string} The OS string.
         */
        toString: function() {
          return "null";
        }
      }, de.parse = A, de.toString = le, de.version && xe.unshift(Me), de.name && xe.unshift(J), re && J && !(re == String(re).split(" ")[0] && (re == J.split(" ")[0] || K)) && xe.push(K ? "(" + re + ")" : "on " + re), xe.length && (de.description = xe.join(" ")), de;
    }
    var L = A();
    i && a ? g(L, function(M, j) {
      i[j] = M;
    }) : r.platform = L;
  }).call(Pr);
})(s3, s3.exports);
var jCt = s3.exports;
const NCt = /* @__PURE__ */ kd(jCt), Qm = () => {
  var t;
  return (t = NCt.os) == null ? void 0 : t.family;
}, Kc = () => {
  const t = ja("(max-width: 1280px)"), e = ja("(max-width: 1023px)"), n = ja("(max-width: 768px)"), r = Qm() === "iOS", i = Qm() === "iOS" || Qm() === "Android" || Qm() === "Windows Phone" || n;
  return {
    isBelow1024px: e,
    isBelow1280px: t,
    isMobileScreen: n,
    isNativeMobile: i,
    isIOS: r
  };
}, DCt = (t) => ({
  ...t,
  tippyOptions: {
    moveTransition: "transform 0.2s ease-in",
    duration: 200,
    animation: "shift-toward-subtle",
    zIndex: 50,
    appendTo: () => document.getElementById("editor-canvas"),
    popperOptions: {
      strategy: "fixed",
      modifiers: [
        {
          name: "flip",
          options: {
            fallbackPlacements: ["top"]
          }
        },
        {
          name: "preventOverflow",
          options: {
            altAxis: !0,
            tether: !1
          }
        }
      ]
    }
  }
}), ICt = ({ editor: t }) => {
  var d, f, h;
  const e = window.getSelection(), n = document.querySelectorAll(".comment-card");
  if (e) {
    for (const p of n)
      if (p.contains(e.anchorNode) || p.contains(e.focusNode))
        return !1;
  }
  const { from: r, to: i, empty: a } = t.state.selection, o = ((d = t.state.doc.nodeAt(r)) == null ? void 0 : d.type.name) === "resizableMedia" || t.isActive("image"), s = ((f = t.state.doc.nodeAt(r)) == null ? void 0 : f.type.name) === "iframe", l = t.isActive("codeBlock"), c = ((h = t.state.doc.nodeAt(r)) == null ? void 0 : h.type.name) === "pageBreak";
  if (a || o || l || s || c)
    return !1;
  let u = !1;
  return t.state.doc.nodesBetween(r, i, (p) => {
    p.marks && p.marks.forEach((m) => {
      m.type.name === "highlight" && m.attrs.color === "yellow" && (u = !0);
    });
  }), !u;
}, PCt = (t) => {
  const {
    editor: e,
    zoomLevel: n,
    onError: r,
    isPreviewMode: i,
    setCommentDrawerOpen: a,
    activeCommentId: o,
    isCollabDocumentPublished: s,
    disableInlineComment: l
  } = t, { isNativeMobile: c } = Kc(), { toolRef: u, setToolVisibility: d, toolVisibility: f } = RA({
    editor: e,
    onError: r
  }), {
    activeComment: h,
    isCommentOpen: p,
    handleInlineComment: m,
    portalRef: g,
    buttonRef: v,
    isCommentActive: k,
    isCommentResolved: w
  } = yl(), b = [
    {
      name: "Bold",
      isActive: () => e.isActive("bold"),
      command: () => e.chain().focus().toggleBold().run(),
      icon: "Bold"
    },
    {
      name: "Italic",
      isActive: () => e.isActive("italic"),
      command: () => e.chain().focus().toggleItalic().run(),
      icon: "Italic"
    },
    {
      name: "Underline",
      isActive: () => e.isActive("underline"),
      command: () => e.chain().focus().toggleUnderline().run(),
      icon: "Underline"
    },
    {
      name: "Strikethrough",
      isActive: () => e.isActive("strike"),
      command: () => e.chain().focus().toggleStrike().run(),
      icon: "Strikethrough"
    },
    {
      name: "Alignment",
      isActive: () => f === st.ALIGNMENT,
      command: () => d(st.ALIGNMENT),
      icon: "AlignLeft"
    },
    {
      name: "Code",
      isActive: () => e.isActive("code"),
      command: () => e.chain().focus().toggleCode().run(),
      icon: "Code"
    },
    {
      name: "Link",
      isActive: () => e.isActive("link"),
      command: () => {
      },
      icon: "Link"
    },
    {
      name: "Scripts",
      isActive: () => f === st.SCRIPTS,
      command: () => d(st.SCRIPTS),
      icon: "Superscript"
    },
    {
      name: "Comment",
      isActive: () => k,
      command: () => {
      },
      icon: "MessageSquarePlus"
    }
  ], x = (L) => {
    switch (L.name) {
      case "Alignment":
        return /* @__PURE__ */ C.jsx(
          TJ,
          {
            setToolVisibility: d,
            editor: e,
            elementRef: u
          }
        );
      case "Link":
        return /* @__PURE__ */ C.jsx(
          EJ,
          {
            setToolVisibility: d,
            editor: e,
            elementRef: u,
            bubbleMenu: !0,
            onError: r
          }
        );
      case "Comment":
        return /* @__PURE__ */ C.jsx(
          RJ,
          {
            activeCommentId: o,
            setCommentDrawerOpen: a,
            initialComment: L.initialComment,
            isDisabled: h && !Object.hasOwn(h, "commentIndex")
          }
        );
      case "Scripts":
        return /* @__PURE__ */ C.jsx(LMt, { editor: e, elementRef: u });
      default:
        return null;
    }
  }, A = /* @__PURE__ */ C.jsxs(Ce.Fragment, { children: [
    /* @__PURE__ */ C.jsx(
      kr,
      {
        ref: v,
        icon: "MessageSquarePlus",
        variant: "ghost",
        size: "sm",
        disabled: w || !s || l,
        isActive: k,
        onClick: m,
        classNames: "disabled:!bg-transparent"
      }
    ),
    p && eB(
      /* @__PURE__ */ C.jsx(
        "div",
        {
          ref: g,
          className: be(
            "fixed z-50 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/4 rounded-md border color-border-default color-bg-default shadow-elevation-3"
          ),
          children: x({
            name: "Comment",
            initialComment: (h == null ? void 0 : h.content) || ""
          })
        }
      ),
      document.body
    )
  ] });
  return /* @__PURE__ */ C.jsx(
    zx,
    {
      ...DCt(t),
      shouldShow: ICt,
      className: be(
        "flex gap-2 overflow-hidden rounded-lg min-w-fit w-full p-1 border color-bg-default items-center shadow-elevation-3",
        p ? "!invisible" : "!visible",
        c ? "!-translate-y-[120%]" : ""
      ),
      style: {
        transform: `scale(${1 / parseFloat(n)})`,
        transformOrigin: "center"
      },
      children: c ? /* @__PURE__ */ C.jsx(
        "div",
        {
          className: be(
            "relative",
            p ? "left-1/2 translate-x-1/2" : ""
          ),
          children: A
        }
      ) : /* @__PURE__ */ C.jsx(Ce.Fragment, { children: i ? /* @__PURE__ */ C.jsx(
        Mi,
        {
          side: "bottom",
          sideOffset: 15,
          alignOffset: -5,
          align: "end",
          className: "!z-[50] shadow-elevation-3",
          anchorTrigger: /* @__PURE__ */ C.jsx(
            kr,
            {
              icon: "MessageSquarePlus",
              variant: "ghost",
              size: "sm",
              tooltip: w ? "Comment resolved" : "",
              disabled: w || !s || l,
              isActive: k,
              onClick: m,
              classNames: "disabled:!bg-transparent"
            }
          ),
          content: k ? null : x({
            name: "Comment",
            initialComment: (h == null ? void 0 : h.content) || ""
          })
        },
        "Comment"
      ) : /* @__PURE__ */ C.jsxs(Ce.Fragment, { children: [
        /* @__PURE__ */ C.jsx(NMt, { editor: e, elementRef: u }),
        b.map((L, M) => L.name === "Bold" || L.name === "Italic" || L.name === "Underline" || L.name === "Strikethrough" || L.name === "Code" ? /* @__PURE__ */ C.jsxs("div", { className: "flex items-center", children: [
          /* @__PURE__ */ C.jsx(
            kr,
            {
              icon: L.icon,
              size: "sm",
              onClick: L.command,
              isActive: L.isActive()
            }
          ),
          M === 3 && /* @__PURE__ */ C.jsx("div", { className: "w-[1px] h-4 vertical-divider ml-2" })
        ] }, M) : L.name === "Alignment" ? /* @__PURE__ */ C.jsxs(Ce.Fragment, { children: [
          /* @__PURE__ */ C.jsx(
            Mi,
            {
              sideOffset: 15,
              anchorTrigger: /* @__PURE__ */ C.jsx(
                kr,
                {
                  icon: "Baseline",
                  size: "sm",
                  isActive: f === st.TEXT_COLOR
                }
              ),
              content: /* @__PURE__ */ C.jsx(
                jJ,
                {
                  setVisibility: d,
                  editor: e,
                  elementRef: u
                }
              )
            },
            st.TEXT_COLOR
          ),
          /* @__PURE__ */ C.jsx(
            Mi,
            {
              sideOffset: 15,
              anchorTrigger: /* @__PURE__ */ C.jsx(
                kr,
                {
                  icon: "Highlighter",
                  size: "sm",
                  isActive: f === st.HIGHLIGHT
                }
              ),
              content: /* @__PURE__ */ C.jsx(
                LJ,
                {
                  setVisibility: d,
                  editor: e,
                  elementRef: u
                }
              )
            },
            st.HIGHLIGHT
          ),
          /* @__PURE__ */ C.jsx("div", { className: "w-[1px] h-4 vertical-divider" }),
          /* @__PURE__ */ C.jsx(
            Mi,
            {
              sideOffset: 15,
              anchorTrigger: /* @__PURE__ */ C.jsx(
                kr,
                {
                  icon: L.icon,
                  variant: "ghost",
                  size: "sm",
                  onClick: () => d(st.ALIGNMENT)
                }
              ),
              className: "shadow-elevation-3",
              content: x(L)
            },
            L.name
          )
        ] }, M) : L.name === "Link" || L.name === "Scripts" ? /* @__PURE__ */ C.jsx(Ce.Fragment, { children: /* @__PURE__ */ C.jsx(
          Mi,
          {
            sideOffset: 15,
            anchorTrigger: /* @__PURE__ */ C.jsx(
              kr,
              {
                icon: L.icon,
                variant: "ghost",
                size: "sm"
              }
            ),
            className: "shadow-elevation-3",
            content: x(L)
          }
        ) }, L.name) : L.name === "Comment" ? /* @__PURE__ */ C.jsx(
          Mi,
          {
            side: "bottom",
            sideOffset: 15,
            alignOffset: -5,
            align: "end",
            className: "!z-[50] shadow-elevation-3",
            anchorTrigger: /* @__PURE__ */ C.jsx(
              kr,
              {
                ref: v,
                icon: "MessageSquarePlus",
                variant: "ghost",
                size: "sm",
                tooltip: w ? "Comment resolved" : "",
                disabled: w || !s || l,
                isActive: k,
                onClick: m,
                classNames: "disabled:!bg-transparent"
              }
            ),
            content: k ? null : x({
              name: "Comment",
              initialComment: (h == null ? void 0 : h.content) || ""
            })
          },
          "Comment"
        ) : null)
      ] }) })
    }
  );
}, OJ = Ht.create({
  name: "column",
  content: "dBlock+",
  isolating: !0,
  addAttributes() {
    return {
      position: {
        default: "",
        parseHTML: (t) => t.getAttribute("data-position"),
        renderHTML: (t) => ({ "data-position": t.position })
      }
    };
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "div",
      _t(t, { "data-type": "column" }),
      0
    ];
  },
  parseHTML() {
    return [
      {
        tag: 'div[data-type="column"]'
      }
    ];
  }
}), zCt = (t, e) => Array.from({ length: t }, (n, r) => e(r)), i5 = ({ type: t, content: e }) => e ? { type: t, content: e } : { type: t }, RCt = ({ content: t }) => i5({ type: "paragraph", content: t }), BJ = ({ content: t }) => i5({ type: "dBlock", content: t }), HJ = ({ content: t }) => i5({ type: "column", content: t }), VI = ({ content: t }) => i5({ type: "columns", content: t }), qI = (t) => {
  const e = [
    BJ({
      content: [RCt({})]
    })
  ];
  return zCt(t, () => HJ({ content: e }));
}, UI = (t, e) => {
  for (let n = t.depth; n > 0; n--) {
    const r = t.node(n), i = n > 0 ? t.before(n) : 0, a = t.start(n);
    if (e({ node: r, pos: i, start: a }))
      return {
        start: a,
        depth: n,
        node: r,
        pos: i
      };
  }
  throw Error("no ancestor found");
};
class l3 extends vt {
  constructor(n) {
    const { $from: r, $to: i } = n;
    super(r, i);
    ua(this, "_$from");
    ua(this, "_$to");
    this._$from = r, this._$to = i;
  }
  get $from() {
    return this._$from;
  }
  get $to() {
    return this._$to;
  }
  map() {
    return this;
  }
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  eq(n) {
    return n instanceof l3 && n.anchor == this.anchor;
  }
  toJSON() {
    return { type: "column", from: this.from, to: this.to };
  }
  expandSelection(n) {
    var l;
    const r = ({ pos: c, node: u }) => u.type.name === OJ.name ? !0 : n.resolve(c).depth <= 0, { pos: i } = UI(this.$from, r);
    this._$from = n.resolve(i);
    const { pos: a, node: o } = UI(
      this.$to,
      r
    );
    this._$to = n.resolve(a + o.nodeSize), ((l = this.getFirstNode()) == null ? void 0 : l.type.name) === c3.name && (this._$from = n.resolve(this.$from.pos + 2), this._$to = n.resolve(this.$to.pos + 2));
    const s = this;
    s.$anchor = this._$from, s.$head = this._$to, s.ranges = [new $k(this._$from, this._$to)];
  }
  /// Create a node selection from non-resolved positions.
  static create(n, r, i) {
    const a = n.resolve(r), o = n.resolve(i), s = new ot(a, o);
    return new l3(s);
  }
  getFirstNode() {
    return this.content().content.firstChild;
  }
}
var fu = /* @__PURE__ */ ((t) => (t.AlignLeft = "align-left", t.AlignRight = "align-right", t.AlignCenter = "align-center", t))(fu || {});
const c3 = Ht.create({
  name: "columns",
  group: "columns",
  content: "column{2,}",
  defining: !0,
  draggable: !0,
  isolating: !0,
  addAttributes() {
    return {
      layout: {
        default: "align-center"
        /* AlignCenter */
      }
    };
  },
  addCommands() {
    return {
      unsetColumns: () => ({ tr: t, dispatch: e }) => {
        try {
          if (!e)
            return;
          const n = t.selection.$from, i = xx(n, ({ node: l }) => !this.options.nestedColumns && l.type == this.type ? !0 : l.type == this.type);
          if (i === void 0)
            return;
          let a = [];
          i.node.descendants((l, c, u) => {
            (u == null ? void 0 : u.type.name) === c3.name && a.push(l);
          }), a = a.reverse().filter((l) => l.content.size > 0);
          const o = t.doc.resolve(i.pos), s = new gt(o);
          return t = t.setSelection(s), a.forEach((l) => t = t.insert(i.pos, l)), t = t.deleteSelection(), e(t);
        } catch (n) {
          console.error(n);
        }
      },
      setColumns: (t, e = !1) => ({ tr: n, dispatch: r }) => {
        try {
          const { doc: i, selection: a } = n;
          if (!r) {
            console.log("no dispatch");
            return;
          }
          const o = new l3(a);
          o.expandSelection(i);
          const { openStart: s, openEnd: l } = o.content();
          if (s !== l) {
            console.warn("failed depth check");
            return;
          }
          let c;
          if (e) {
            const h = o.content().toJSON(), p = HJ(h), m = qI(t - 1);
            c = VI({
              content: [p, ...m]
            });
          } else {
            const h = qI(t);
            c = VI({ content: h });
          }
          const u = i.type.schema.nodeFromJSON(
            BJ({ content: [c] })
          );
          if (u === null)
            return;
          const d = o.$anchor.parent.type;
          if (!((h) => !(!h.contentMatch.matchType(this.type) || !this.options.nestedColumns && h.name === c3.name))(d)) {
            console.warn("content not allowed");
            return;
          }
          return n = n.setSelection(o), n = n.replaceSelectionWith(u, !1), r(n);
        } catch (i) {
          console.error(i);
        }
      },
      setLayout: (t) => ({ commands: e }) => e.updateAttributes("columns", { layout: t })
    };
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "div",
      { "data-type": "columns", class: `layout-${t.layout}` },
      0
    ];
  },
  parseHTML() {
    return [
      {
        tag: 'div[data-type="columns"]'
      }
    ];
  }
}), OCt = (t, e) => {
  const {
    view: n,
    state: {
      selection: { from: r }
    }
  } = t, i = document.querySelectorAll(".has-focus"), a = i.length, s = i[a - 1];
  if (s && s.getAttribute("data-type") && s.getAttribute("data-type") === e || s && s.classList && s.classList.contains(e))
    return s;
  const l = n.domAtPos(r).node;
  let c = l;
  for (c.tagName || (c = l.parentElement); c && !(c.getAttribute("data-type") && c.getAttribute("data-type") === e) && !c.classList.contains(e); )
    c = c.parentElement;
  return c;
}, HA = en(
  ({ children: t, className: e, withShadow: n = !0, withBorder: r = !1, ...i }, a) => {
    const o = be(
      e,
      "color-bg-default rounded",
      n ? "shadow-lg" : "",
      r ? "border border-neutral-200" : ""
    );
    return /* @__PURE__ */ C.jsx("div", { className: o, ...i, ref: a, children: t });
  }
);
HA.displayName = "Surface";
const FJ = en(
  ({
    shouldShowContent: t = !0,
    children: e,
    isVertical: n = !1,
    className: r,
    ...i
  }, a) => {
    const o = Lt(
      "color-text-default inline-flex h-full leading-none gap-0.5",
      n ? "flex-col p-2" : "flex-row p-1 items-center",
      r
    );
    return t ? t && /* @__PURE__ */ C.jsx(HA, { className: o, ...i, ref: a, children: e }) : null;
  }
);
FJ.displayName = "Toolbar";
const BCt = en(
  ({ horizontal: t, className: e, ...n }, r) => {
    const i = Lt(
      "bg-neutral-200",
      t ? "w-full min-w-[1.5rem] h-[1px] my-1 first:mt-0 last:mt-0" : "h-full min-h-[1.5rem] w-[1px] mx-1 first:ml-0 last:mr-0",
      e
    );
    return /* @__PURE__ */ C.jsx("div", { className: i, ref: r, ...n });
  }
);
BCt.displayName = "Toolbar.Divider";
const HCt = {
  Wrapper: FJ
}, FCt = ({ editor: t, appendTo: e }) => {
  const n = nt(() => {
    const l = OCt(t, "columns");
    return (l == null ? void 0 : l.getBoundingClientRect()) || new DOMRect(-1e3, -1e3, 0, 0);
  }, [t]), r = nt(() => t.isActive("columns"), [t]), i = nt(() => {
    t.chain().focus().setLayout(fu.AlignLeft).run();
  }, [t]), a = nt(() => {
    t.chain().focus().setLayout(fu.AlignRight).run();
  }, [t]), o = nt(() => {
    t.chain().focus().setLayout(fu.AlignCenter).run();
  }, [t]), s = nt(() => {
    t.chain().focus().deleteNode("columns").run();
  }, [t]);
  return /* @__PURE__ */ C.jsx(
    zx,
    {
      editor: t,
      pluginKey: `columnsMenu-${oh()}`,
      shouldShow: r,
      updateDelay: 0,
      tippyOptions: {
        offset: [0, 8],
        popperOptions: {
          modifiers: [{ name: "flip", enabled: !1 }]
        },
        getReferenceClientRect: n,
        moveTransition: "transform 0.15s ease-out",
        duration: 200,
        animation: "shift-toward-subtle",
        appendTo: () => e == null ? void 0 : e.current,
        plugins: [zce],
        sticky: "popper"
      },
      children: /* @__PURE__ */ C.jsxs(HCt.Wrapper, { children: [
        /* @__PURE__ */ C.jsx(
          kr,
          {
            icon: "PanelLeft",
            tooltip: "Align left",
            isActive: t.isActive("columns", {
              layout: fu.AlignLeft
            }),
            onClick: i
          }
        ),
        /* @__PURE__ */ C.jsx(
          kr,
          {
            icon: "Columns2",
            tooltip: "Align center",
            isActive: t.isActive("columns", {
              layout: fu.AlignCenter
            }),
            onClick: o
          }
        ),
        /* @__PURE__ */ C.jsx(
          kr,
          {
            icon: "PanelRight",
            tooltip: "Align right",
            isActive: t.isActive("columns", {
              layout: fu.AlignRight
            }),
            onClick: a
          }
        ),
        /* @__PURE__ */ C.jsx(
          kr,
          {
            icon: "Trash2",
            tooltip: "Remove column",
            onClick: s,
            isActive: !1
          }
        )
      ] })
    }
  );
}, _J = xn({
  isPreviewMode: !1,
  isPresentationMode: !1
}), Zp = () => {
  const t = Mt(_J);
  if (!t)
    throw new Error("useEditingContext must be used within an EditingProvider");
  return t;
}, FA = ({
  children: t,
  isPreviewMode: e,
  isPresentationMode: n
}) => {
  const r = Ft(
    () => ({ isPreviewMode: e, isPresentationMode: n }),
    [e, n]
  );
  return /* @__PURE__ */ C.jsx(_J.Provider, { value: r, children: t });
}, _A = xn({});
function VA(t) {
  const e = Ue(null);
  return e.current === null && (e.current = t()), e.current;
}
const a5 = xn(null), qA = xn({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
});
class _Ct extends N.Component {
  getSnapshotBeforeUpdate(e) {
    const n = this.props.childRef.current;
    if (n && e.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function VCt({ children: t, isPresent: e }) {
  const n = bd(), r = Ue(null), i = Ue({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), { nonce: a } = Mt(qA);
  return fg(() => {
    const { width: o, height: s, top: l, left: c } = i.current;
    if (e || !r.current || !o || !s)
      return;
    r.current.dataset.motionPopId = n;
    const u = document.createElement("style");
    return a && (u.nonce = a), document.head.appendChild(u), u.sheet && u.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${o}px !important;
            height: ${s}px !important;
            top: ${l}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(u);
    };
  }, [e]), C.jsx(_Ct, { isPresent: e, childRef: r, sizeRef: i, children: N.cloneElement(t, { ref: r }) });
}
const qCt = ({ children: t, initial: e, isPresent: n, onExitComplete: r, custom: i, presenceAffectsLayout: a, mode: o }) => {
  const s = VA(UCt), l = bd(), c = nt((d) => {
    s.set(d, !0);
    for (const f of s.values())
      if (!f)
        return;
    r && r();
  }, [s, r]), u = Ft(
    () => ({
      id: l,
      initial: e,
      isPresent: n,
      custom: i,
      onExitComplete: c,
      register: (d) => (s.set(d, !1), () => s.delete(d))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    a ? [Math.random(), c] : [n, c]
  );
  return Ft(() => {
    s.forEach((d, f) => s.set(f, !1));
  }, [n]), N.useEffect(() => {
    !n && !s.size && r && r();
  }, [n]), o === "popLayout" && (t = C.jsx(VCt, { isPresent: n, children: t })), C.jsx(a5.Provider, { value: u, children: t });
};
function UCt() {
  return /* @__PURE__ */ new Map();
}
function VJ(t = !0) {
  const e = Mt(a5);
  if (e === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: i } = e, a = bd();
  ze(() => {
    t && i(a);
  }, [t]);
  const o = nt(() => t && r && r(a), [a, r, t]);
  return !n && r ? [!1, o] : [!0];
}
const Xm = (t) => t.key || "";
function WI(t) {
  const e = [];
  return Ws.forEach(t, (n) => {
    N1(n) && e.push(n);
  }), e;
}
const UA = typeof window < "u", qJ = UA ? us : ze, Gp = ({ children: t, custom: e, initial: n = !0, onExitComplete: r, presenceAffectsLayout: i = !0, mode: a = "sync", propagate: o = !1 }) => {
  const [s, l] = VJ(o), c = Ft(() => WI(t), [t]), u = o && !s ? [] : c.map(Xm), d = Ue(!0), f = Ue(c), h = VA(() => /* @__PURE__ */ new Map()), [p, m] = De(c), [g, v] = De(c);
  qJ(() => {
    d.current = !1, f.current = c;
    for (let b = 0; b < g.length; b++) {
      const x = Xm(g[b]);
      u.includes(x) ? h.delete(x) : h.get(x) !== !0 && h.set(x, !1);
    }
  }, [g, u.length, u.join("-")]);
  const k = [];
  if (c !== p) {
    let b = [...c];
    for (let x = 0; x < g.length; x++) {
      const A = g[x], L = Xm(A);
      u.includes(L) || (b.splice(x, 0, A), k.push(A));
    }
    a === "wait" && k.length && (b = k), v(WI(b)), m(c);
    return;
  }
  process.env.NODE_ENV !== "production" && a === "wait" && g.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: w } = Mt(_A);
  return C.jsx(C.Fragment, { children: g.map((b) => {
    const x = Xm(b), A = o && !s ? !1 : c === g || u.includes(x), L = () => {
      if (h.has(x))
        h.set(x, !0);
      else
        return;
      let M = !0;
      h.forEach((j) => {
        j || (M = !1);
      }), M && (w == null || w(), v(f.current), o && (l == null || l()), r && r());
    };
    return C.jsx(qCt, { isPresent: A, initial: !d.current || n ? void 0 : !1, custom: A ? void 0 : e, presenceAffectsLayout: i, mode: a, onExitComplete: A ? void 0 : L, children: b }, x);
  }) });
}, Ni = /* @__NO_SIDE_EFFECTS__ */ (t) => t;
let Vd = Ni, Lc = Ni;
process.env.NODE_ENV !== "production" && (Vd = (t, e) => {
  !t && typeof console < "u" && console.warn(e);
}, Lc = (t, e) => {
  if (!t)
    throw new Error(e);
});
// @__NO_SIDE_EFFECTS__
function WA(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const od = /* @__NO_SIDE_EFFECTS__ */ (t, e, n) => {
  const r = e - t;
  return r === 0 ? 1 : (n - t) / r;
}, Go = /* @__NO_SIDE_EFFECTS__ */ (t) => t * 1e3, Qs = /* @__NO_SIDE_EFFECTS__ */ (t) => t / 1e3, WCt = {
  useManualTiming: !1
};
function ZCt(t) {
  let e = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet();
  let o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function s(c) {
    a.has(c) && (l.schedule(c), t()), c(o);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, u = !1, d = !1) => {
      const h = d && r ? e : n;
      return u && a.add(c), h.has(c) || h.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      n.delete(c), a.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (o = c, r) {
        i = !0;
        return;
      }
      r = !0, [e, n] = [n, e], e.forEach(s), e.clear(), r = !1, i && (i = !1, l.process(c));
    }
  };
  return l;
}
const e4 = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], GCt = 40;
function UJ(t, e) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, a = () => n = !0, o = e4.reduce((v, k) => (v[k] = ZCt(a), v), {}), { read: s, resolveKeyframes: l, update: c, preRender: u, render: d, postRender: f } = o, h = () => {
    const v = performance.now();
    n = !1, i.delta = r ? 1e3 / 60 : Math.max(Math.min(v - i.timestamp, GCt), 1), i.timestamp = v, i.isProcessing = !0, s.process(i), l.process(i), c.process(i), u.process(i), d.process(i), f.process(i), i.isProcessing = !1, n && e && (r = !1, t(h));
  }, p = () => {
    n = !0, r = !0, i.isProcessing || t(h);
  };
  return { schedule: e4.reduce((v, k) => {
    const w = o[k];
    return v[k] = (b, x = !1, A = !1) => (n || p(), w.schedule(b, x, A)), v;
  }, {}), cancel: (v) => {
    for (let k = 0; k < e4.length; k++)
      o[e4[k]].cancel(v);
  }, state: i, steps: o };
}
const { schedule: An, cancel: Tc, state: Ir, steps: Nv } = UJ(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Ni, !0), WJ = xn({ strict: !1 }), ZI = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, sd = {};
for (const t in ZI)
  sd[t] = {
    isEnabled: (e) => ZI[t].some((n) => !!e[n])
  };
function YCt(t) {
  for (const e in t)
    sd[e] = {
      ...sd[e],
      ...t[e]
    };
}
const KCt = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function u3(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || KCt.has(t);
}
let ZJ = (t) => !u3(t);
function $Ct(t) {
  t && (ZJ = (e) => e.startsWith("on") ? !u3(e) : t(e));
}
try {
  $Ct(require("@emotion/is-prop-valid").default);
} catch {
}
function JCt(t, e, n) {
  const r = {};
  for (const i in t)
    i === "values" && typeof t.values == "object" || (ZJ(i) || n === !0 && u3(i) || !e && !u3(i) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && i.startsWith("onDrag")) && (r[i] = t[i]);
  return r;
}
const GI = /* @__PURE__ */ new Set();
function o5(t, e, n) {
  t || GI.has(e) || (console.warn(e), GI.add(e));
}
function QCt(t) {
  if (typeof Proxy > "u")
    return t;
  const e = /* @__PURE__ */ new Map(), n = (...r) => (process.env.NODE_ENV !== "production" && o5(!1, "motion() is deprecated. Use motion.create() instead."), t(...r));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, i) => i === "create" ? t : (e.has(i) || e.set(i, t(i)), e.get(i))
  });
}
const s5 = xn({});
function S2(t) {
  return typeof t == "string" || Array.isArray(t);
}
function l5(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
const ZA = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], GA = ["initial", ...ZA];
function c5(t) {
  return l5(t.animate) || GA.some((e) => S2(t[e]));
}
function GJ(t) {
  return !!(c5(t) || t.variants);
}
function XCt(t, e) {
  if (c5(t)) {
    const { initial: n, animate: r } = t;
    return {
      initial: n === !1 || S2(n) ? n : void 0,
      animate: S2(r) ? r : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function eAt(t) {
  const { initial: e, animate: n } = XCt(t, Mt(s5));
  return Ft(() => ({ initial: e, animate: n }), [YI(e), YI(n)]);
}
function YI(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const tAt = Symbol.for("motionComponentSymbol");
function c1(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function nAt(t, e, n) {
  return nt(
    (r) => {
      r && t.onMount && t.onMount(r), e && (r ? e.mount(r) : e.unmount()), n && (typeof n == "function" ? n(r) : c1(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
const YA = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), rAt = "framerAppearId", YJ = "data-" + YA(rAt), { schedule: KA } = UJ(queueMicrotask, !1), KJ = xn({});
function iAt(t, e, n, r, i) {
  var a, o;
  const { visualElement: s } = Mt(s5), l = Mt(WJ), c = Mt(a5), u = Mt(qA).reducedMotion, d = Ue(null);
  r = r || l.renderer, !d.current && r && (d.current = r(t, {
    visualState: e,
    parent: s,
    props: n,
    presenceContext: c,
    blockInitialAnimation: c ? c.initial === !1 : !1,
    reducedMotionConfig: u
  }));
  const f = d.current, h = Mt(KJ);
  f && !f.projection && i && (f.type === "html" || f.type === "svg") && aAt(d.current, n, i, h);
  const p = Ue(!1);
  fg(() => {
    f && p.current && f.update(n, c);
  });
  const m = n[YJ], g = Ue(!!m && !(!((a = window.MotionHandoffIsComplete) === null || a === void 0) && a.call(window, m)) && ((o = window.MotionHasOptimisedAnimation) === null || o === void 0 ? void 0 : o.call(window, m)));
  return qJ(() => {
    f && (p.current = !0, window.MotionIsMounted = !0, f.updateFeatures(), KA.render(f.render), g.current && f.animationState && f.animationState.animateChanges());
  }), ze(() => {
    f && (!g.current && f.animationState && f.animationState.animateChanges(), g.current && (queueMicrotask(() => {
      var v;
      (v = window.MotionHandoffMarkAsComplete) === null || v === void 0 || v.call(window, m);
    }), g.current = !1));
  }), f;
}
function aAt(t, e, n, r) {
  const { layoutId: i, layout: a, drag: o, dragConstraints: s, layoutScroll: l, layoutRoot: c } = e;
  t.projection = new n(t.latestValues, e["data-framer-portal-id"] ? void 0 : $J(t.parent)), t.projection.setOptions({
    layoutId: i,
    layout: a,
    alwaysMeasureLayout: !!o || s && c1(s),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: r,
    layoutScroll: l,
    layoutRoot: c
  });
}
function $J(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : $J(t.parent);
}
function oAt({ preloadedFeatures: t, createVisualElement: e, useRender: n, useVisualState: r, Component: i }) {
  var a, o;
  t && YCt(t);
  function s(c, u) {
    let d;
    const f = {
      ...Mt(qA),
      ...c,
      layoutId: sAt(c)
    }, { isStatic: h } = f, p = eAt(c), m = r(c, h);
    if (!h && UA) {
      lAt(f, t);
      const g = cAt(f);
      d = g.MeasureLayout, p.visualElement = iAt(i, m, f, e, g.ProjectionNode);
    }
    return C.jsxs(s5.Provider, { value: p, children: [d && p.visualElement ? C.jsx(d, { visualElement: p.visualElement, ...f }) : null, n(i, c, nAt(m, p.visualElement, u), m, h, p.visualElement)] });
  }
  s.displayName = `motion.${typeof i == "string" ? i : `create(${(o = (a = i.displayName) !== null && a !== void 0 ? a : i.name) !== null && o !== void 0 ? o : ""})`}`;
  const l = en(s);
  return l[tAt] = i, l;
}
function sAt({ layoutId: t }) {
  const e = Mt(_A).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function lAt(t, e) {
  const n = Mt(WJ).strict;
  if (process.env.NODE_ENV !== "production" && e && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? Vd(!1, r) : Lc(!1, r);
  }
}
function cAt(t) {
  const { drag: e, layout: n } = sd;
  if (!e && !n)
    return {};
  const r = { ...e, ...n };
  return {
    MeasureLayout: e != null && e.isEnabled(t) || n != null && n.isEnabled(t) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const uAt = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function $A(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(uAt.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(t))
    )
  );
}
function KI(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((n, r) => {
    e[0][r] = n.get(), e[1][r] = n.getVelocity();
  }), e;
}
function JA(t, e, n, r) {
  if (typeof e == "function") {
    const [i, a] = KI(r);
    e = e(n !== void 0 ? n : t.custom, i, a);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [i, a] = KI(r);
    e = e(n !== void 0 ? n : t.custom, i, a);
  }
  return e;
}
const Cw = (t) => Array.isArray(t), dAt = (t) => !!(t && typeof t == "object" && t.mix && t.toValue), fAt = (t) => Cw(t) ? t[t.length - 1] || 0 : t, Yr = (t) => !!(t && t.getVelocity);
function J4(t) {
  const e = Yr(t) ? t.get() : t;
  return dAt(e) ? e.toValue() : e;
}
function hAt({ scrapeMotionValuesFromProps: t, createRenderState: e, onUpdate: n }, r, i, a) {
  const o = {
    latestValues: pAt(r, i, a, t),
    renderState: e()
  };
  return n && (o.onMount = (s) => n({ props: r, current: s, ...o }), o.onUpdate = (s) => n(s)), o;
}
const JJ = (t) => (e, n) => {
  const r = Mt(s5), i = Mt(a5), a = () => hAt(t, e, r, i);
  return n ? a() : VA(a);
};
function pAt(t, e, n, r) {
  const i = {}, a = r(t, {});
  for (const f in a)
    i[f] = J4(a[f]);
  let { initial: o, animate: s } = t;
  const l = c5(t), c = GJ(t);
  e && c && !l && t.inherit !== !1 && (o === void 0 && (o = e.initial), s === void 0 && (s = e.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || o === !1;
  const d = u ? s : o;
  if (d && typeof d != "boolean" && !l5(d)) {
    const f = Array.isArray(d) ? d : [d];
    for (let h = 0; h < f.length; h++) {
      const p = JA(t, f[h]);
      if (p) {
        const { transitionEnd: m, transition: g, ...v } = p;
        for (const k in v) {
          let w = v[k];
          if (Array.isArray(w)) {
            const b = u ? w.length - 1 : 0;
            w = w[b];
          }
          w !== null && (i[k] = w);
        }
        for (const k in m)
          i[k] = m[k];
      }
    }
  }
  return i;
}
const qd = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], T0 = new Set(qd), QJ = (t) => (e) => typeof e == "string" && e.startsWith(t), XJ = /* @__PURE__ */ QJ("--"), mAt = /* @__PURE__ */ QJ("var(--"), QA = (t) => mAt(t) ? yAt.test(t.split("/*")[0].trim()) : !1, yAt = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, eQ = (t, e) => e && typeof t == "number" ? e.transform(t) : t, gl = (t, e, n) => n > e ? e : n < t ? t : n, Ud = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, L2 = {
  ...Ud,
  transform: (t) => gl(0, 1, t)
}, t4 = {
  ...Ud,
  default: 1
}, Yp = (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), Ul = /* @__PURE__ */ Yp("deg"), Yo = /* @__PURE__ */ Yp("%"), Et = /* @__PURE__ */ Yp("px"), gAt = /* @__PURE__ */ Yp("vh"), vAt = /* @__PURE__ */ Yp("vw"), $I = {
  ...Yo,
  parse: (t) => Yo.parse(t) / 100,
  transform: (t) => Yo.transform(t * 100)
}, bAt = {
  // Border props
  borderWidth: Et,
  borderTopWidth: Et,
  borderRightWidth: Et,
  borderBottomWidth: Et,
  borderLeftWidth: Et,
  borderRadius: Et,
  radius: Et,
  borderTopLeftRadius: Et,
  borderTopRightRadius: Et,
  borderBottomRightRadius: Et,
  borderBottomLeftRadius: Et,
  // Positioning props
  width: Et,
  maxWidth: Et,
  height: Et,
  maxHeight: Et,
  top: Et,
  right: Et,
  bottom: Et,
  left: Et,
  // Spacing props
  padding: Et,
  paddingTop: Et,
  paddingRight: Et,
  paddingBottom: Et,
  paddingLeft: Et,
  margin: Et,
  marginTop: Et,
  marginRight: Et,
  marginBottom: Et,
  marginLeft: Et,
  // Misc
  backgroundPositionX: Et,
  backgroundPositionY: Et
}, wAt = {
  rotate: Ul,
  rotateX: Ul,
  rotateY: Ul,
  rotateZ: Ul,
  scale: t4,
  scaleX: t4,
  scaleY: t4,
  scaleZ: t4,
  skew: Ul,
  skewX: Ul,
  skewY: Ul,
  distance: Et,
  translateX: Et,
  translateY: Et,
  translateZ: Et,
  x: Et,
  y: Et,
  z: Et,
  perspective: Et,
  transformPerspective: Et,
  opacity: L2,
  originX: $I,
  originY: $I,
  originZ: Et
}, JI = {
  ...Ud,
  transform: Math.round
}, XA = {
  ...bAt,
  ...wAt,
  zIndex: JI,
  size: Et,
  // SVG
  fillOpacity: L2,
  strokeOpacity: L2,
  numOctaves: JI
}, kAt = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, xAt = qd.length;
function MAt(t, e, n) {
  let r = "", i = !0;
  for (let a = 0; a < xAt; a++) {
    const o = qd[a], s = t[o];
    if (s === void 0)
      continue;
    let l = !0;
    if (typeof s == "number" ? l = s === (o.startsWith("scale") ? 1 : 0) : l = parseFloat(s) === 0, !l || n) {
      const c = eQ(s, XA[o]);
      if (!l) {
        i = !1;
        const u = kAt[o] || o;
        r += `${u}(${c}) `;
      }
      n && (e[o] = c);
    }
  }
  return r = r.trim(), n ? r = n(e, i ? "" : r) : i && (r = "none"), r;
}
function eS(t, e, n) {
  const { style: r, vars: i, transformOrigin: a } = t;
  let o = !1, s = !1;
  for (const l in e) {
    const c = e[l];
    if (T0.has(l)) {
      o = !0;
      continue;
    } else if (XJ(l)) {
      i[l] = c;
      continue;
    } else {
      const u = eQ(c, XA[l]);
      l.startsWith("origin") ? (s = !0, a[l] = u) : r[l] = u;
    }
  }
  if (e.transform || (o || n ? r.transform = MAt(e, t.transform, n) : r.transform && (r.transform = "none")), s) {
    const { originX: l = "50%", originY: c = "50%", originZ: u = 0 } = a;
    r.transformOrigin = `${l} ${c} ${u}`;
  }
}
const CAt = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, AAt = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function SAt(t, e, n = 1, r = 0, i = !0) {
  t.pathLength = 1;
  const a = i ? CAt : AAt;
  t[a.offset] = Et.transform(-r);
  const o = Et.transform(e), s = Et.transform(n);
  t[a.array] = `${o} ${s}`;
}
function QI(t, e, n) {
  return typeof t == "string" ? t : Et.transform(e + n * t);
}
function LAt(t, e, n) {
  const r = QI(e, t.x, t.width), i = QI(n, t.y, t.height);
  return `${r} ${i}`;
}
function tS(t, {
  attrX: e,
  attrY: n,
  attrScale: r,
  originX: i,
  originY: a,
  pathLength: o,
  pathSpacing: s = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, u, d) {
  if (eS(t, c, d), u) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: f, style: h, dimensions: p } = t;
  f.transform && (p && (h.transform = f.transform), delete f.transform), p && (i !== void 0 || a !== void 0 || h.transform) && (h.transformOrigin = LAt(p, i !== void 0 ? i : 0.5, a !== void 0 ? a : 0.5)), e !== void 0 && (f.x = e), n !== void 0 && (f.y = n), r !== void 0 && (f.scale = r), o !== void 0 && SAt(f, o, s, l, !1);
}
const nS = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), tQ = () => ({
  ...nS(),
  attrs: {}
}), rS = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function nQ(t, { style: e, vars: n }, r, i) {
  Object.assign(t.style, e, i && i.getProjectionStyles(r));
  for (const a in n)
    t.style.setProperty(a, n[a]);
}
const rQ = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function iQ(t, e, n, r) {
  nQ(t, e, void 0, r);
  for (const i in e.attrs)
    t.setAttribute(rQ.has(i) ? i : YA(i), e.attrs[i]);
}
const d3 = {};
function TAt(t) {
  Object.assign(d3, t);
}
function aQ(t, { layout: e, layoutId: n }) {
  return T0.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!d3[t] || t === "opacity");
}
function iS(t, e, n) {
  var r;
  const { style: i } = t, a = {};
  for (const o in i)
    (Yr(i[o]) || e.style && Yr(e.style[o]) || aQ(o, t) || ((r = n == null ? void 0 : n.getValue(o)) === null || r === void 0 ? void 0 : r.liveStyle) !== void 0) && (a[o] = i[o]);
  return a;
}
function oQ(t, e, n) {
  const r = iS(t, e, n);
  for (const i in t)
    if (Yr(t[i]) || Yr(e[i])) {
      const a = qd.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[a] = t[i];
    }
  return r;
}
function EAt(t, e) {
  try {
    e.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
  } catch {
    e.dimensions = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
}
const XI = ["x", "y", "width", "height", "cx", "cy", "r"], jAt = {
  useVisualState: JJ({
    scrapeMotionValuesFromProps: oQ,
    createRenderState: tQ,
    onUpdate: ({ props: t, prevProps: e, current: n, renderState: r, latestValues: i }) => {
      if (!n)
        return;
      let a = !!t.drag;
      if (!a) {
        for (const s in i)
          if (T0.has(s)) {
            a = !0;
            break;
          }
      }
      if (!a)
        return;
      let o = !e;
      if (e)
        for (let s = 0; s < XI.length; s++) {
          const l = XI[s];
          t[l] !== e[l] && (o = !0);
        }
      o && An.read(() => {
        EAt(n, r), An.render(() => {
          tS(r, i, rS(n.tagName), t.transformTemplate), iQ(n, r);
        });
      });
    }
  })
}, NAt = {
  useVisualState: JJ({
    scrapeMotionValuesFromProps: iS,
    createRenderState: nS
  })
};
function sQ(t, e, n) {
  for (const r in e)
    !Yr(e[r]) && !aQ(r, n) && (t[r] = e[r]);
}
function DAt({ transformTemplate: t }, e) {
  return Ft(() => {
    const n = nS();
    return eS(n, e, t), Object.assign({}, n.vars, n.style);
  }, [e]);
}
function IAt(t, e) {
  const n = t.style || {}, r = {};
  return sQ(r, n, t), Object.assign(r, DAt(t, e)), r;
}
function PAt(t, e) {
  const n = {}, r = IAt(t, e);
  return t.drag && t.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
function zAt(t, e, n, r) {
  const i = Ft(() => {
    const a = tQ();
    return tS(a, e, rS(r), t.transformTemplate), {
      ...a.attrs,
      style: { ...a.style }
    };
  }, [e]);
  if (t.style) {
    const a = {};
    sQ(a, t.style, t), i.style = { ...a, ...i.style };
  }
  return i;
}
function RAt(t = !1) {
  return (n, r, i, { latestValues: a }, o) => {
    const l = ($A(n) ? zAt : PAt)(r, a, o, n), c = JCt(r, typeof n == "string", t), u = n !== ds ? { ...c, ...l, ref: i } : {}, { children: d } = r, f = Ft(() => Yr(d) ? d.get() : d, [d]);
    return Ee(n, {
      ...u,
      children: f
    });
  };
}
function OAt(t, e) {
  return function(r, { forwardMotionProps: i } = { forwardMotionProps: !1 }) {
    const o = {
      ...$A(r) ? jAt : NAt,
      preloadedFeatures: t,
      useRender: RAt(i),
      createVisualElement: e,
      Component: r
    };
    return oAt(o);
  };
}
function lQ(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function u5(t, e, n) {
  const r = t.getProps();
  return JA(r, e, n !== void 0 ? n : r.custom, t);
}
const BAt = /* @__PURE__ */ WA(() => window.ScrollTimeline !== void 0);
class HAt {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((e) => "finished" in e ? e.finished : e));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][e] = n;
  }
  attachTimeline(e, n) {
    const r = this.animations.map((i) => {
      if (BAt() && i.attachTimeline)
        return i.attachTimeline(e);
      if (typeof n == "function")
        return n(i);
    });
    return () => {
      r.forEach((i, a) => {
        i && i(), this.animations[a].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let e = 0;
    for (let n = 0; n < this.animations.length; n++)
      e = Math.max(e, this.animations[n].duration);
    return e;
  }
  runAll(e) {
    this.animations.forEach((n) => n[e]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
class FAt extends HAt {
  then(e, n) {
    return Promise.all(this.animations).then(e).catch(n);
  }
}
function aS(t, e) {
  return t ? t[e] || t.default || t : void 0;
}
const Aw = 2e4;
function cQ(t) {
  let e = 0;
  const n = 50;
  let r = t.next(e);
  for (; !r.done && e < Aw; )
    e += n, r = t.next(e);
  return e >= Aw ? 1 / 0 : e;
}
function oS(t) {
  return typeof t == "function";
}
function eP(t, e) {
  t.timeline = e, t.onfinish = null;
}
const sS = (t) => Array.isArray(t) && typeof t[0] == "number", _At = {
  linearEasing: void 0
};
function VAt(t, e) {
  const n = /* @__PURE__ */ WA(t);
  return () => {
    var r;
    return (r = _At[e]) !== null && r !== void 0 ? r : n();
  };
}
const f3 = /* @__PURE__ */ VAt(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), uQ = (t, e, n = 10) => {
  let r = "";
  const i = Math.max(Math.round(e / n), 2);
  for (let a = 0; a < i; a++)
    r += t(/* @__PURE__ */ od(0, i - 1, a)) + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
};
function dQ(t) {
  return !!(typeof t == "function" && f3() || !t || typeof t == "string" && (t in Sw || f3()) || sS(t) || Array.isArray(t) && t.every(dQ));
}
const Of = ([t, e, n, r]) => `cubic-bezier(${t}, ${e}, ${n}, ${r})`, Sw = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Of([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Of([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Of([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Of([0.33, 1.53, 0.69, 0.99])
};
function fQ(t, e) {
  if (t)
    return typeof t == "function" && f3() ? uQ(t, e) : sS(t) ? Of(t) : Array.isArray(t) ? t.map((n) => fQ(n, e) || Sw.easeOut) : Sw[t];
}
const Ua = {
  x: !1,
  y: !1
};
function hQ() {
  return Ua.x || Ua.y;
}
function qAt(t, e, n) {
  var r;
  if (t instanceof Element)
    return [t];
  if (typeof t == "string") {
    let i = document;
    const a = (r = void 0) !== null && r !== void 0 ? r : i.querySelectorAll(t);
    return a ? Array.from(a) : [];
  }
  return Array.from(t);
}
function pQ(t, e) {
  const n = qAt(t), r = new AbortController(), i = {
    passive: !0,
    ...e,
    signal: r.signal
  };
  return [n, i, () => r.abort()];
}
function tP(t) {
  return (e) => {
    e.pointerType === "touch" || hQ() || t(e);
  };
}
function UAt(t, e, n = {}) {
  const [r, i, a] = pQ(t, n), o = tP((s) => {
    const { target: l } = s, c = e(s);
    if (typeof c != "function" || !l)
      return;
    const u = tP((d) => {
      c(d), l.removeEventListener("pointerleave", u);
    });
    l.addEventListener("pointerleave", u, i);
  });
  return r.forEach((s) => {
    s.addEventListener("pointerenter", o, i);
  }), a;
}
const mQ = (t, e) => e ? t === e ? !0 : mQ(t, e.parentElement) : !1, lS = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1, WAt = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function ZAt(t) {
  return WAt.has(t.tagName) || t.tabIndex !== -1;
}
const Bf = /* @__PURE__ */ new WeakSet();
function nP(t) {
  return (e) => {
    e.key === "Enter" && t(e);
  };
}
function Dv(t, e) {
  t.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
}
const GAt = (t, e) => {
  const n = t.currentTarget;
  if (!n)
    return;
  const r = nP(() => {
    if (Bf.has(n))
      return;
    Dv(n, "down");
    const i = nP(() => {
      Dv(n, "up");
    }), a = () => Dv(n, "cancel");
    n.addEventListener("keyup", i, e), n.addEventListener("blur", a, e);
  });
  n.addEventListener("keydown", r, e), n.addEventListener("blur", () => n.removeEventListener("keydown", r), e);
};
function rP(t) {
  return lS(t) && !hQ();
}
function YAt(t, e, n = {}) {
  const [r, i, a] = pQ(t, n), o = (s) => {
    const l = s.currentTarget;
    if (!rP(s) || Bf.has(l))
      return;
    Bf.add(l);
    const c = e(s), u = (h, p) => {
      window.removeEventListener("pointerup", d), window.removeEventListener("pointercancel", f), !(!rP(h) || !Bf.has(l)) && (Bf.delete(l), typeof c == "function" && c(h, { success: p }));
    }, d = (h) => {
      u(h, n.useGlobalTarget || mQ(l, h.target));
    }, f = (h) => {
      u(h, !1);
    };
    window.addEventListener("pointerup", d, i), window.addEventListener("pointercancel", f, i);
  };
  return r.forEach((s) => {
    !ZAt(s) && s.getAttribute("tabindex") === null && (s.tabIndex = 0), (n.useGlobalTarget ? window : s).addEventListener("pointerdown", o, i), s.addEventListener("focus", (c) => GAt(c, i), i);
  }), a;
}
function KAt(t) {
  return t === "x" || t === "y" ? Ua[t] ? null : (Ua[t] = !0, () => {
    Ua[t] = !1;
  }) : Ua.x || Ua.y ? null : (Ua.x = Ua.y = !0, () => {
    Ua.x = Ua.y = !1;
  });
}
const yQ = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...qd
]);
let Q4;
function $At() {
  Q4 = void 0;
}
const Ko = {
  now: () => (Q4 === void 0 && Ko.set(Ir.isProcessing || WCt.useManualTiming ? Ir.timestamp : performance.now()), Q4),
  set: (t) => {
    Q4 = t, queueMicrotask($At);
  }
};
function cS(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function uS(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
class dS {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return cS(this.subscriptions, e), () => uS(this.subscriptions, e);
  }
  notify(e, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](e, n, r);
      else
        for (let a = 0; a < i; a++) {
          const o = this.subscriptions[a];
          o && o(e, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function gQ(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const iP = 30, JAt = (t) => !isNaN(parseFloat(t));
class QAt {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(e, n = {}) {
    this.version = "11.18.2", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, i = !0) => {
      const a = Ko.now();
      this.updatedAt !== a && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), i && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = Ko.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = JAt(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && o5(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new dS());
    const r = this.events[e].add(n);
    return e === "change" ? () => {
      r(), An.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(e, n) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = Ko.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > iP)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, iP);
    return gQ(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function T2(t, e) {
  return new QAt(t, e);
}
function XAt(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, T2(n));
}
function eSt(t, e) {
  const n = u5(t, e);
  let { transitionEnd: r = {}, transition: i = {}, ...a } = n || {};
  a = { ...a, ...r };
  for (const o in a) {
    const s = fAt(a[o]);
    XAt(t, o, s);
  }
}
function tSt(t) {
  return !!(Yr(t) && t.add);
}
function Lw(t, e) {
  const n = t.getValue("willChange");
  if (tSt(n))
    return n.add(e);
}
function vQ(t) {
  return t.props[YJ];
}
const bQ = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, nSt = 1e-7, rSt = 12;
function iSt(t, e, n, r, i) {
  let a, o, s = 0;
  do
    o = e + (n - e) / 2, a = bQ(o, r, i) - t, a > 0 ? n = o : e = o;
  while (Math.abs(a) > nSt && ++s < rSt);
  return o;
}
function Kp(t, e, n, r) {
  if (t === e && n === r)
    return Ni;
  const i = (a) => iSt(a, 0, 1, t, n);
  return (a) => a === 0 || a === 1 ? a : bQ(i(a), e, r);
}
const wQ = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, kQ = (t) => (e) => 1 - t(1 - e), xQ = /* @__PURE__ */ Kp(0.33, 1.53, 0.69, 0.99), fS = /* @__PURE__ */ kQ(xQ), MQ = /* @__PURE__ */ wQ(fS), CQ = (t) => (t *= 2) < 1 ? 0.5 * fS(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), hS = (t) => 1 - Math.sin(Math.acos(t)), AQ = kQ(hS), SQ = wQ(hS), LQ = (t) => /^0[^.\s]+$/u.test(t);
function aSt(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || LQ(t) : !0;
}
const lh = (t) => Math.round(t * 1e5) / 1e5, pS = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function oSt(t) {
  return t == null;
}
const sSt = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, mS = (t, e) => (n) => !!(typeof n == "string" && sSt.test(n) && n.startsWith(t) || e && !oSt(n) && Object.prototype.hasOwnProperty.call(n, e)), TQ = (t, e, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, a, o, s] = r.match(pS);
  return {
    [t]: parseFloat(i),
    [e]: parseFloat(a),
    [n]: parseFloat(o),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, lSt = (t) => gl(0, 255, t), Iv = {
  ...Ud,
  transform: (t) => Math.round(lSt(t))
}, Lu = {
  test: /* @__PURE__ */ mS("rgb", "red"),
  parse: /* @__PURE__ */ TQ("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: r = 1 }) => "rgba(" + Iv.transform(t) + ", " + Iv.transform(e) + ", " + Iv.transform(n) + ", " + lh(L2.transform(r)) + ")"
};
function cSt(t) {
  let e = "", n = "", r = "", i = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7), i = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), r = t.substring(3, 4), i = t.substring(4, 5), e += e, n += n, r += r, i += i), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const Tw = {
  test: /* @__PURE__ */ mS("#"),
  parse: cSt,
  transform: Lu.transform
}, u1 = {
  test: /* @__PURE__ */ mS("hsl", "hue"),
  parse: /* @__PURE__ */ TQ("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(t) + ", " + Yo.transform(lh(e)) + ", " + Yo.transform(lh(n)) + ", " + lh(L2.transform(r)) + ")"
}, Ur = {
  test: (t) => Lu.test(t) || Tw.test(t) || u1.test(t),
  parse: (t) => Lu.test(t) ? Lu.parse(t) : u1.test(t) ? u1.parse(t) : Tw.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? Lu.transform(t) : u1.transform(t)
}, uSt = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function dSt(t) {
  var e, n;
  return isNaN(t) && typeof t == "string" && (((e = t.match(pS)) === null || e === void 0 ? void 0 : e.length) || 0) + (((n = t.match(uSt)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const EQ = "number", jQ = "color", fSt = "var", hSt = "var(", aP = "${}", pSt = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function E2(t) {
  const e = t.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let a = 0;
  const s = e.replace(pSt, (l) => (Ur.test(l) ? (r.color.push(a), i.push(jQ), n.push(Ur.parse(l))) : l.startsWith(hSt) ? (r.var.push(a), i.push(fSt), n.push(l)) : (r.number.push(a), i.push(EQ), n.push(parseFloat(l))), ++a, aP)).split(aP);
  return { values: n, split: s, indexes: r, types: i };
}
function NQ(t) {
  return E2(t).values;
}
function DQ(t) {
  const { split: e, types: n } = E2(t), r = e.length;
  return (i) => {
    let a = "";
    for (let o = 0; o < r; o++)
      if (a += e[o], i[o] !== void 0) {
        const s = n[o];
        s === EQ ? a += lh(i[o]) : s === jQ ? a += Ur.transform(i[o]) : a += i[o];
      }
    return a;
  };
}
const mSt = (t) => typeof t == "number" ? 0 : t;
function ySt(t) {
  const e = NQ(t);
  return DQ(t)(e.map(mSt));
}
const Ec = {
  test: dSt,
  parse: NQ,
  createTransformer: DQ,
  getAnimatableNone: ySt
}, gSt = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function vSt(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [r] = n.match(pS) || [];
  if (!r)
    return t;
  const i = n.replace(r, "");
  let a = gSt.has(e) ? 1 : 0;
  return r !== n && (a *= 100), e + "(" + a + i + ")";
}
const bSt = /\b([a-z-]*)\(.*?\)/gu, Ew = {
  ...Ec,
  getAnimatableNone: (t) => {
    const e = t.match(bSt);
    return e ? e.map(vSt).join(" ") : t;
  }
}, wSt = {
  ...XA,
  // Color props
  color: Ur,
  backgroundColor: Ur,
  outlineColor: Ur,
  fill: Ur,
  stroke: Ur,
  // Border props
  borderColor: Ur,
  borderTopColor: Ur,
  borderRightColor: Ur,
  borderBottomColor: Ur,
  borderLeftColor: Ur,
  filter: Ew,
  WebkitFilter: Ew
}, yS = (t) => wSt[t];
function IQ(t, e) {
  let n = yS(t);
  return n !== Ew && (n = Ec), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const kSt = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function xSt(t, e, n) {
  let r = 0, i;
  for (; r < t.length && !i; ) {
    const a = t[r];
    typeof a == "string" && !kSt.has(a) && E2(a).values.length && (i = t[r]), r++;
  }
  if (i && n)
    for (const a of e)
      t[a] = IQ(n, i);
}
const oP = (t) => t === Ud || t === Et, sP = (t, e) => parseFloat(t.split(", ")[e]), lP = (t, e) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const i = r.match(/^matrix3d\((.+)\)$/u);
  if (i)
    return sP(i[1], e);
  {
    const a = r.match(/^matrix\((.+)\)$/u);
    return a ? sP(a[1], t) : 0;
  }
}, MSt = /* @__PURE__ */ new Set(["x", "y", "z"]), CSt = qd.filter((t) => !MSt.has(t));
function ASt(t) {
  const e = [];
  return CSt.forEach((n) => {
    const r = t.getValue(n);
    r !== void 0 && (e.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const ld = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: lP(4, 13),
  y: lP(5, 14)
};
ld.translateX = ld.x;
ld.translateY = ld.y;
const _u = /* @__PURE__ */ new Set();
let jw = !1, Nw = !1;
function PQ() {
  if (Nw) {
    const t = Array.from(_u).filter((r) => r.needsMeasurement), e = new Set(t.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    e.forEach((r) => {
      const i = ASt(r);
      i.length && (n.set(r, i), r.render());
    }), t.forEach((r) => r.measureInitialState()), e.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([a, o]) => {
        var s;
        (s = r.getValue(a)) === null || s === void 0 || s.set(o);
      });
    }), t.forEach((r) => r.measureEndState()), t.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  Nw = !1, jw = !1, _u.forEach((t) => t.complete()), _u.clear();
}
function zQ() {
  _u.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (Nw = !0);
  });
}
function SSt() {
  zQ(), PQ();
}
class gS {
  constructor(e, n, r, i, a, o = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = r, this.motionValue = i, this.element = a, this.isAsync = o;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (_u.add(this), jw || (jw = !0, An.read(zQ), An.resolveKeyframes(PQ))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: r, motionValue: i } = this;
    for (let a = 0; a < e.length; a++)
      if (e[a] === null)
        if (a === 0) {
          const o = i == null ? void 0 : i.get(), s = e[e.length - 1];
          if (o !== void 0)
            e[0] = o;
          else if (r && n) {
            const l = r.readValue(n, s);
            l != null && (e[0] = l);
          }
          e[0] === void 0 && (e[0] = s), i && o === void 0 && i.set(e[0]);
        } else
          e[a] = e[a - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), _u.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, _u.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const RQ = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t), LSt = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function TSt(t) {
  const e = LSt.exec(t);
  if (!e)
    return [,];
  const [, n, r, i] = e;
  return [`--${n ?? r}`, i];
}
const ESt = 4;
function OQ(t, e, n = 1) {
  Lc(n <= ESt, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
  const [r, i] = TSt(t);
  if (!r)
    return;
  const a = window.getComputedStyle(e).getPropertyValue(r);
  if (a) {
    const o = a.trim();
    return RQ(o) ? parseFloat(o) : o;
  }
  return QA(i) ? OQ(i, e, n + 1) : i;
}
const BQ = (t) => (e) => e.test(t), jSt = {
  test: (t) => t === "auto",
  parse: (t) => t
}, HQ = [Ud, Et, Yo, Ul, vAt, gAt, jSt], cP = (t) => HQ.find(BQ(t));
class FQ extends gS {
  constructor(e, n, r, i, a) {
    super(e, n, r, i, a, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < e.length; l++) {
      let c = e[l];
      if (typeof c == "string" && (c = c.trim(), QA(c))) {
        const u = OQ(c, n.current);
        u !== void 0 && (e[l] = u), l === e.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !yQ.has(r) || e.length !== 2)
      return;
    const [i, a] = e, o = cP(i), s = cP(a);
    if (o !== s)
      if (oP(o) && oP(s))
        for (let l = 0; l < e.length; l++) {
          const c = e[l];
          typeof c == "string" && (e[l] = parseFloat(c));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this, r = [];
    for (let i = 0; i < e.length; i++)
      aSt(e[i]) && r.push(i);
    r.length && xSt(e, r, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: r } = this;
    if (!e || !e.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = ld[r](e.measureViewportBox(), window.getComputedStyle(e.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && e.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    var e;
    const { element: n, name: r, unresolvedKeyframes: i } = this;
    if (!n || !n.current)
      return;
    const a = n.getValue(r);
    a && a.jump(this.measuredOrigin, !1);
    const o = i.length - 1, s = i[o];
    i[o] = ld[r](n.measureViewportBox(), window.getComputedStyle(n.current)), s !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = s), !((e = this.removedTransforms) === null || e === void 0) && e.length && this.removedTransforms.forEach(([l, c]) => {
      n.getValue(l).set(c);
    }), this.resolveNoneKeyframes();
  }
}
const uP = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(Ec.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function NSt(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function DSt(t, e, n, r) {
  const i = t[0];
  if (i === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const a = t[t.length - 1], o = uP(i, e), s = uP(a, e);
  return Vd(o === s, `You are trying to animate ${e} from "${i}" to "${a}". ${i} is not an animatable value - to enable this animation set ${i} to a value animatable to ${a} via the \`style\` property.`), !o || !s ? !1 : NSt(t) || (n === "spring" || oS(n)) && r;
}
const ISt = (t) => t !== null;
function d5(t, { repeat: e, repeatType: n = "loop" }, r) {
  const i = t.filter(ISt), a = e && n !== "loop" && e % 2 === 1 ? 0 : i.length - 1;
  return !a || r === void 0 ? i[a] : r;
}
const PSt = 40;
class _Q {
  constructor({ autoplay: e = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: a = 0, repeatType: o = "loop", ...s }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = Ko.now(), this.options = {
      autoplay: e,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: a,
      repeatType: o,
      ...s
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > PSt ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && SSt(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(e, n) {
    this.resolvedAt = Ko.now(), this.hasAttemptedResolve = !0;
    const { name: r, type: i, velocity: a, delay: o, onComplete: s, onUpdate: l, isGenerator: c } = this.options;
    if (!c && !DSt(e, r, i, a))
      if (o)
        this.options.duration = 0;
      else {
        l && l(d5(e, this.options, n)), s && s(), this.resolveFinishedPromise();
        return;
      }
    const u = this.initPlayback(e, n);
    u !== !1 && (this._resolved = {
      keyframes: e,
      finalKeyframe: n,
      ...u
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.currentFinishedPromise.then(e, n);
  }
  flatten() {
    this.options.type = "keyframes", this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((e) => {
      this.resolveFinishedPromise = e;
    });
  }
}
const _n = (t, e, n) => t + (e - t) * n;
function Pv(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function zSt({ hue: t, saturation: e, lightness: n, alpha: r }) {
  t /= 360, e /= 100, n /= 100;
  let i = 0, a = 0, o = 0;
  if (!e)
    i = a = o = n;
  else {
    const s = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - s;
    i = Pv(l, s, t + 1 / 3), a = Pv(l, s, t), o = Pv(l, s, t - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(a * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
function h3(t, e) {
  return (n) => n > 0 ? e : t;
}
const zv = (t, e, n) => {
  const r = t * t, i = n * (e * e - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, RSt = [Tw, Lu, u1], OSt = (t) => RSt.find((e) => e.test(t));
function dP(t) {
  const e = OSt(t);
  if (Vd(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`), !e)
    return !1;
  let n = e.parse(t);
  return e === u1 && (n = zSt(n)), n;
}
const fP = (t, e) => {
  const n = dP(t), r = dP(e);
  if (!n || !r)
    return h3(t, e);
  const i = { ...n };
  return (a) => (i.red = zv(n.red, r.red, a), i.green = zv(n.green, r.green, a), i.blue = zv(n.blue, r.blue, a), i.alpha = _n(n.alpha, r.alpha, a), Lu.transform(i));
}, BSt = (t, e) => (n) => e(t(n)), $p = (...t) => t.reduce(BSt), Dw = /* @__PURE__ */ new Set(["none", "hidden"]);
function HSt(t, e) {
  return Dw.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
function FSt(t, e) {
  return (n) => _n(t, e, n);
}
function vS(t) {
  return typeof t == "number" ? FSt : typeof t == "string" ? QA(t) ? h3 : Ur.test(t) ? fP : qSt : Array.isArray(t) ? VQ : typeof t == "object" ? Ur.test(t) ? fP : _St : h3;
}
function VQ(t, e) {
  const n = [...t], r = n.length, i = t.map((a, o) => vS(a)(a, e[o]));
  return (a) => {
    for (let o = 0; o < r; o++)
      n[o] = i[o](a);
    return n;
  };
}
function _St(t, e) {
  const n = { ...t, ...e }, r = {};
  for (const i in n)
    t[i] !== void 0 && e[i] !== void 0 && (r[i] = vS(t[i])(t[i], e[i]));
  return (i) => {
    for (const a in r)
      n[a] = r[a](i);
    return n;
  };
}
function VSt(t, e) {
  var n;
  const r = [], i = { color: 0, var: 0, number: 0 };
  for (let a = 0; a < e.values.length; a++) {
    const o = e.types[a], s = t.indexes[o][i[o]], l = (n = t.values[s]) !== null && n !== void 0 ? n : 0;
    r[a] = l, i[o]++;
  }
  return r;
}
const qSt = (t, e) => {
  const n = Ec.createTransformer(e), r = E2(t), i = E2(e);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? Dw.has(t) && !i.values.length || Dw.has(e) && !r.values.length ? HSt(t, e) : $p(VQ(VSt(r, i), i.values), n) : (Vd(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), h3(t, e));
};
function qQ(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? _n(t, e, n) : vS(t)(t, e);
}
const USt = 5;
function UQ(t, e, n) {
  const r = Math.max(e - USt, 0);
  return gQ(n - t(r), e - r);
}
const zn = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, hP = 1e-3;
function WSt({ duration: t = zn.duration, bounce: e = zn.bounce, velocity: n = zn.velocity, mass: r = zn.mass }) {
  let i, a;
  Vd(t <= /* @__PURE__ */ Go(zn.maxDuration), "Spring duration must be 10 seconds or less");
  let o = 1 - e;
  o = gl(zn.minDamping, zn.maxDamping, o), t = gl(zn.minDuration, zn.maxDuration, /* @__PURE__ */ Qs(t)), o < 1 ? (i = (c) => {
    const u = c * o, d = u * t, f = u - n, h = Iw(c, o), p = Math.exp(-d);
    return hP - f / h * p;
  }, a = (c) => {
    const d = c * o * t, f = d * n + n, h = Math.pow(o, 2) * Math.pow(c, 2) * t, p = Math.exp(-d), m = Iw(Math.pow(c, 2), o);
    return (-i(c) + hP > 0 ? -1 : 1) * ((f - h) * p) / m;
  }) : (i = (c) => {
    const u = Math.exp(-c * t), d = (c - n) * t + 1;
    return -1e-3 + u * d;
  }, a = (c) => {
    const u = Math.exp(-c * t), d = (n - c) * (t * t);
    return u * d;
  });
  const s = 5 / t, l = GSt(i, a, s);
  if (t = /* @__PURE__ */ Go(t), isNaN(l))
    return {
      stiffness: zn.stiffness,
      damping: zn.damping,
      duration: t
    };
  {
    const c = Math.pow(l, 2) * r;
    return {
      stiffness: c,
      damping: o * 2 * Math.sqrt(r * c),
      duration: t
    };
  }
}
const ZSt = 12;
function GSt(t, e, n) {
  let r = n;
  for (let i = 1; i < ZSt; i++)
    r = r - t(r) / e(r);
  return r;
}
function Iw(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const YSt = ["duration", "bounce"], KSt = ["stiffness", "damping", "mass"];
function pP(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function $St(t) {
  let e = {
    velocity: zn.velocity,
    stiffness: zn.stiffness,
    damping: zn.damping,
    mass: zn.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!pP(t, KSt) && pP(t, YSt))
    if (t.visualDuration) {
      const n = t.visualDuration, r = 2 * Math.PI / (n * 1.2), i = r * r, a = 2 * gl(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(i);
      e = {
        ...e,
        mass: zn.mass,
        stiffness: i,
        damping: a
      };
    } else {
      const n = WSt(t);
      e = {
        ...e,
        ...n,
        mass: zn.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function WQ(t = zn.visualDuration, e = zn.bounce) {
  const n = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let { restSpeed: r, restDelta: i } = n;
  const a = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], s = { done: !1, value: a }, { stiffness: l, damping: c, mass: u, duration: d, velocity: f, isResolvedFromDuration: h } = $St({
    ...n,
    velocity: -/* @__PURE__ */ Qs(n.velocity || 0)
  }), p = f || 0, m = c / (2 * Math.sqrt(l * u)), g = o - a, v = /* @__PURE__ */ Qs(Math.sqrt(l / u)), k = Math.abs(g) < 5;
  r || (r = k ? zn.restSpeed.granular : zn.restSpeed.default), i || (i = k ? zn.restDelta.granular : zn.restDelta.default);
  let w;
  if (m < 1) {
    const x = Iw(v, m);
    w = (A) => {
      const L = Math.exp(-m * v * A);
      return o - L * ((p + m * v * g) / x * Math.sin(x * A) + g * Math.cos(x * A));
    };
  } else if (m === 1)
    w = (x) => o - Math.exp(-v * x) * (g + (p + v * g) * x);
  else {
    const x = v * Math.sqrt(m * m - 1);
    w = (A) => {
      const L = Math.exp(-m * v * A), M = Math.min(x * A, 300);
      return o - L * ((p + m * v * g) * Math.sinh(M) + x * g * Math.cosh(M)) / x;
    };
  }
  const b = {
    calculatedDuration: h && d || null,
    next: (x) => {
      const A = w(x);
      if (h)
        s.done = x >= d;
      else {
        let L = 0;
        m < 1 && (L = x === 0 ? /* @__PURE__ */ Go(p) : UQ(w, x, A));
        const M = Math.abs(L) <= r, j = Math.abs(o - A) <= i;
        s.done = M && j;
      }
      return s.value = s.done ? o : A, s;
    },
    toString: () => {
      const x = Math.min(cQ(b), Aw), A = uQ((L) => b.next(x * L).value, x, 30);
      return x + "ms " + A;
    }
  };
  return b;
}
function mP({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: a = 500, modifyTarget: o, min: s, max: l, restDelta: c = 0.5, restSpeed: u }) {
  const d = t[0], f = {
    done: !1,
    value: d
  }, h = (M) => s !== void 0 && M < s || l !== void 0 && M > l, p = (M) => s === void 0 ? l : l === void 0 || Math.abs(s - M) < Math.abs(l - M) ? s : l;
  let m = n * e;
  const g = d + m, v = o === void 0 ? g : o(g);
  v !== g && (m = v - d);
  const k = (M) => -m * Math.exp(-M / r), w = (M) => v + k(M), b = (M) => {
    const j = k(M), D = w(M);
    f.done = Math.abs(j) <= c, f.value = f.done ? v : D;
  };
  let x, A;
  const L = (M) => {
    h(f.value) && (x = M, A = WQ({
      keyframes: [f.value, p(f.value)],
      velocity: UQ(w, M, f.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: a,
      restDelta: c,
      restSpeed: u
    }));
  };
  return L(0), {
    calculatedDuration: null,
    next: (M) => {
      let j = !1;
      return !A && x === void 0 && (j = !0, b(M), L(M)), x !== void 0 && M >= x ? A.next(M - x) : (!j && b(M), f);
    }
  };
}
const JSt = /* @__PURE__ */ Kp(0.42, 0, 1, 1), QSt = /* @__PURE__ */ Kp(0, 0, 0.58, 1), ZQ = /* @__PURE__ */ Kp(0.42, 0, 0.58, 1), XSt = (t) => Array.isArray(t) && typeof t[0] != "number", yP = {
  linear: Ni,
  easeIn: JSt,
  easeInOut: ZQ,
  easeOut: QSt,
  circIn: hS,
  circInOut: SQ,
  circOut: AQ,
  backIn: fS,
  backInOut: MQ,
  backOut: xQ,
  anticipate: CQ
}, gP = (t) => {
  if (sS(t)) {
    Lc(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [e, n, r, i] = t;
    return Kp(e, n, r, i);
  } else if (typeof t == "string")
    return Lc(yP[t] !== void 0, `Invalid easing type '${t}'`), yP[t];
  return t;
};
function eLt(t, e, n) {
  const r = [], i = n || qQ, a = t.length - 1;
  for (let o = 0; o < a; o++) {
    let s = i(t[o], t[o + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[o] || Ni : e;
      s = $p(l, s);
    }
    r.push(s);
  }
  return r;
}
function tLt(t, e, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const a = t.length;
  if (Lc(a === e.length, "Both input and output ranges must be the same length"), a === 1)
    return () => e[0];
  if (a === 2 && e[0] === e[1])
    return () => e[1];
  const o = t[0] === t[1];
  t[0] > t[a - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const s = eLt(e, r, i), l = s.length, c = (u) => {
    if (o && u < t[0])
      return e[0];
    let d = 0;
    if (l > 1)
      for (; d < t.length - 2 && !(u < t[d + 1]); d++)
        ;
    const f = /* @__PURE__ */ od(t[d], t[d + 1], u);
    return s[d](f);
  };
  return n ? (u) => c(gl(t[0], t[a - 1], u)) : c;
}
function nLt(t, e) {
  const n = t[t.length - 1];
  for (let r = 1; r <= e; r++) {
    const i = /* @__PURE__ */ od(0, e, r);
    t.push(_n(n, 1, i));
  }
}
function rLt(t) {
  const e = [0];
  return nLt(e, t.length - 1), e;
}
function iLt(t, e) {
  return t.map((n) => n * e);
}
function aLt(t, e) {
  return t.map(() => e || ZQ).splice(0, t.length - 1);
}
function p3({ duration: t = 300, keyframes: e, times: n, ease: r = "easeInOut" }) {
  const i = XSt(r) ? r.map(gP) : gP(r), a = {
    done: !1,
    value: e[0]
  }, o = iLt(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : rLt(e),
    t
  ), s = tLt(o, e, {
    ease: Array.isArray(i) ? i : aLt(e, i)
  });
  return {
    calculatedDuration: t,
    next: (l) => (a.value = s(l), a.done = l >= t, a)
  };
}
const oLt = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: () => An.update(e, !0),
    stop: () => Tc(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Ir.isProcessing ? Ir.timestamp : Ko.now()
  };
}, sLt = {
  decay: mP,
  inertia: mP,
  tween: p3,
  keyframes: p3,
  spring: WQ
}, lLt = (t) => t / 100;
class bS extends _Q {
  constructor(e) {
    super(e), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: l } = this.options;
      l && l();
    };
    const { name: n, motionValue: r, element: i, keyframes: a } = this.options, o = (i == null ? void 0 : i.KeyframeResolver) || gS, s = (l, c) => this.onKeyframesResolved(l, c);
    this.resolver = new o(a, s, n, r, i), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(e) {
    const { type: n = "keyframes", repeat: r = 0, repeatDelay: i = 0, repeatType: a, velocity: o = 0 } = this.options, s = oS(n) ? n : sLt[n] || p3;
    let l, c;
    s !== p3 && typeof e[0] != "number" && (process.env.NODE_ENV !== "production" && Lc(e.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${e}`), l = $p(lLt, qQ(e[0], e[1])), e = [0, 100]);
    const u = s({ ...this.options, keyframes: e });
    a === "mirror" && (c = s({
      ...this.options,
      keyframes: [...e].reverse(),
      velocity: -o
    })), u.calculatedDuration === null && (u.calculatedDuration = cQ(u));
    const { calculatedDuration: d } = u, f = d + i, h = f * (r + 1) - i;
    return {
      generator: u,
      mirroredGenerator: c,
      mapPercentToKeyframes: l,
      calculatedDuration: d,
      resolvedDuration: f,
      totalDuration: h
    };
  }
  onPostResolved() {
    const { autoplay: e = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !e ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(e, n = !1) {
    const { resolved: r } = this;
    if (!r) {
      const { keyframes: M } = this.options;
      return { done: !0, value: M[M.length - 1] };
    }
    const { finalKeyframe: i, generator: a, mirroredGenerator: o, mapPercentToKeyframes: s, keyframes: l, calculatedDuration: c, totalDuration: u, resolvedDuration: d } = r;
    if (this.startTime === null)
      return a.next(0);
    const { delay: f, repeat: h, repeatType: p, repeatDelay: m, onUpdate: g } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - u / this.speed, this.startTime)), n ? this.currentTime = e : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(e - this.startTime) * this.speed;
    const v = this.currentTime - f * (this.speed >= 0 ? 1 : -1), k = this.speed >= 0 ? v < 0 : v > u;
    this.currentTime = Math.max(v, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = u);
    let w = this.currentTime, b = a;
    if (h) {
      const M = Math.min(this.currentTime, u) / d;
      let j = Math.floor(M), D = M % 1;
      !D && M >= 1 && (D = 1), D === 1 && j--, j = Math.min(j, h + 1), !!(j % 2) && (p === "reverse" ? (D = 1 - D, m && (D -= m / d)) : p === "mirror" && (b = o)), w = gl(0, 1, D) * d;
    }
    const x = k ? { done: !1, value: l[0] } : b.next(w);
    s && (x.value = s(x.value));
    let { done: A } = x;
    !k && c !== null && (A = this.speed >= 0 ? this.currentTime >= u : this.currentTime <= 0);
    const L = this.holdTime === null && (this.state === "finished" || this.state === "running" && A);
    return L && i !== void 0 && (x.value = d5(l, this.options, i)), g && g(x.value), L && this.finish(), x;
  }
  get duration() {
    const { resolved: e } = this;
    return e ? /* @__PURE__ */ Qs(e.calculatedDuration) : 0;
  }
  get time() {
    return /* @__PURE__ */ Qs(this.currentTime);
  }
  set time(e) {
    e = /* @__PURE__ */ Go(e), this.currentTime = e, this.holdTime !== null || this.speed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    const n = this.playbackSpeed !== e;
    this.playbackSpeed = e, n && (this.time = /* @__PURE__ */ Qs(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: e = oLt, onPlay: n, startTime: r } = this.options;
    this.driver || (this.driver = e((a) => this.tick(a))), n && n();
    const i = this.driver.now();
    this.holdTime !== null ? this.startTime = i - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = i) : this.startTime = r ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var e;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (e = this.currentTime) !== null && e !== void 0 ? e : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: e } = this.options;
    e && e();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
}
const cLt = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
function uLt(t, e, n, { delay: r = 0, duration: i = 300, repeat: a = 0, repeatType: o = "loop", ease: s = "easeInOut", times: l } = {}) {
  const c = { [e]: n };
  l && (c.offset = l);
  const u = fQ(s, i);
  return Array.isArray(u) && (c.easing = u), t.animate(c, {
    delay: r,
    duration: i,
    easing: Array.isArray(u) ? "linear" : u,
    fill: "both",
    iterations: a + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  });
}
const dLt = /* @__PURE__ */ WA(() => Object.hasOwnProperty.call(Element.prototype, "animate")), m3 = 10, fLt = 2e4;
function hLt(t) {
  return oS(t.type) || t.type === "spring" || !dQ(t.ease);
}
function pLt(t, e) {
  const n = new bS({
    ...e,
    keyframes: t,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let r = { done: !1, value: t[0] };
  const i = [];
  let a = 0;
  for (; !r.done && a < fLt; )
    r = n.sample(a), i.push(r.value), a += m3;
  return {
    times: void 0,
    keyframes: i,
    duration: a - m3,
    ease: "linear"
  };
}
const GQ = {
  anticipate: CQ,
  backInOut: MQ,
  circInOut: SQ
};
function mLt(t) {
  return t in GQ;
}
class vP extends _Q {
  constructor(e) {
    super(e);
    const { name: n, motionValue: r, element: i, keyframes: a } = this.options;
    this.resolver = new FQ(a, (o, s) => this.onKeyframesResolved(o, s), n, r, i), this.resolver.scheduleResolve();
  }
  initPlayback(e, n) {
    let { duration: r = 300, times: i, ease: a, type: o, motionValue: s, name: l, startTime: c } = this.options;
    if (!s.owner || !s.owner.current)
      return !1;
    if (typeof a == "string" && f3() && mLt(a) && (a = GQ[a]), hLt(this.options)) {
      const { onComplete: d, onUpdate: f, motionValue: h, element: p, ...m } = this.options, g = pLt(e, m);
      e = g.keyframes, e.length === 1 && (e[1] = e[0]), r = g.duration, i = g.times, a = g.ease, o = "keyframes";
    }
    const u = uLt(s.owner.current, l, e, { ...this.options, duration: r, times: i, ease: a });
    return u.startTime = c ?? this.calcStartTime(), this.pendingTimeline ? (eP(u, this.pendingTimeline), this.pendingTimeline = void 0) : u.onfinish = () => {
      const { onComplete: d } = this.options;
      s.set(d5(e, this.options, n)), d && d(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: u,
      duration: r,
      times: i,
      type: o,
      ease: a,
      keyframes: e
    };
  }
  get duration() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { duration: n } = e;
    return /* @__PURE__ */ Qs(n);
  }
  get time() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { animation: n } = e;
    return /* @__PURE__ */ Qs(n.currentTime || 0);
  }
  set time(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.currentTime = /* @__PURE__ */ Go(e);
  }
  get speed() {
    const { resolved: e } = this;
    if (!e)
      return 1;
    const { animation: n } = e;
    return n.playbackRate;
  }
  set speed(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.playbackRate = e;
  }
  get state() {
    const { resolved: e } = this;
    if (!e)
      return "idle";
    const { animation: n } = e;
    return n.playState;
  }
  get startTime() {
    const { resolved: e } = this;
    if (!e)
      return null;
    const { animation: n } = e;
    return n.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(e) {
    if (!this._resolved)
      this.pendingTimeline = e;
    else {
      const { resolved: n } = this;
      if (!n)
        return Ni;
      const { animation: r } = n;
      eP(r, e);
    }
    return Ni;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n, keyframes: r, duration: i, type: a, ease: o, times: s } = e;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: c, onUpdate: u, onComplete: d, element: f, ...h } = this.options, p = new bS({
        ...h,
        keyframes: r,
        duration: i,
        type: a,
        ease: o,
        times: s,
        isGenerator: !0
      }), m = /* @__PURE__ */ Go(this.time);
      c.setWithVelocity(p.sample(m - m3).value, p.sample(m).value, m3);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: e } = this;
    e && e.animation.finish();
  }
  cancel() {
    const { resolved: e } = this;
    e && e.animation.cancel();
  }
  static supports(e) {
    const { motionValue: n, name: r, repeatDelay: i, repeatType: a, damping: o, type: s } = e;
    if (!n || !n.owner || !(n.owner.current instanceof HTMLElement))
      return !1;
    const { onUpdate: l, transformTemplate: c } = n.owner.getProps();
    return dLt() && r && cLt.has(r) && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !l && !c && !i && a !== "mirror" && o !== 0 && s !== "inertia";
  }
}
const yLt = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, gLt = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), vLt = {
  type: "keyframes",
  duration: 0.8
}, bLt = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, wLt = (t, { keyframes: e }) => e.length > 2 ? vLt : T0.has(t) ? t.startsWith("scale") ? gLt(e[1]) : yLt : bLt;
function kLt({ when: t, delay: e, delayChildren: n, staggerChildren: r, staggerDirection: i, repeat: a, repeatType: o, repeatDelay: s, from: l, elapsed: c, ...u }) {
  return !!Object.keys(u).length;
}
const wS = (t, e, n, r = {}, i, a) => (o) => {
  const s = aS(r, t) || {}, l = s.delay || r.delay || 0;
  let { elapsed: c = 0 } = r;
  c = c - /* @__PURE__ */ Go(l);
  let u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...s,
    delay: -c,
    onUpdate: (f) => {
      e.set(f), s.onUpdate && s.onUpdate(f);
    },
    onComplete: () => {
      o(), s.onComplete && s.onComplete();
    },
    name: t,
    motionValue: e,
    element: a ? void 0 : i
  };
  kLt(s) || (u = {
    ...u,
    ...wLt(t, u)
  }), u.duration && (u.duration = /* @__PURE__ */ Go(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ Go(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let d = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (u.duration = 0, u.delay === 0 && (d = !0)), d && !a && e.get() !== void 0) {
    const f = d5(u.keyframes, s);
    if (f !== void 0)
      return An.update(() => {
        u.onUpdate(f), u.onComplete();
      }), new FAt([]);
  }
  return !a && vP.supports(u) ? new vP(u) : new bS(u);
};
function xLt({ protectedKeys: t, needsAnimating: e }, n) {
  const r = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, r;
}
function YQ(t, e, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  var a;
  let { transition: o = t.getDefaultTransition(), transitionEnd: s, ...l } = e;
  r && (o = r);
  const c = [], u = i && t.animationState && t.animationState.getState()[i];
  for (const d in l) {
    const f = t.getValue(d, (a = t.latestValues[d]) !== null && a !== void 0 ? a : null), h = l[d];
    if (h === void 0 || u && xLt(u, d))
      continue;
    const p = {
      delay: n,
      ...aS(o || {}, d)
    };
    let m = !1;
    if (window.MotionHandoffAnimation) {
      const v = vQ(t);
      if (v) {
        const k = window.MotionHandoffAnimation(v, d, An);
        k !== null && (p.startTime = k, m = !0);
      }
    }
    Lw(t, d), f.start(wS(d, f, h, t.shouldReduceMotion && yQ.has(d) ? { type: !1 } : p, t, m));
    const g = f.animation;
    g && c.push(g);
  }
  return s && Promise.all(c).then(() => {
    An.update(() => {
      s && eSt(t, s);
    });
  }), c;
}
function Pw(t, e, n = {}) {
  var r;
  const i = u5(t, e, n.type === "exit" ? (r = t.presenceContext) === null || r === void 0 ? void 0 : r.custom : void 0);
  let { transition: a = t.getDefaultTransition() || {} } = i || {};
  n.transitionOverride && (a = n.transitionOverride);
  const o = i ? () => Promise.all(YQ(t, i, n)) : () => Promise.resolve(), s = t.variantChildren && t.variantChildren.size ? (c = 0) => {
    const { delayChildren: u = 0, staggerChildren: d, staggerDirection: f } = a;
    return MLt(t, e, u + c, d, f, n);
  } : () => Promise.resolve(), { when: l } = a;
  if (l) {
    const [c, u] = l === "beforeChildren" ? [o, s] : [s, o];
    return c().then(() => u());
  } else
    return Promise.all([o(), s(n.delay)]);
}
function MLt(t, e, n = 0, r = 0, i = 1, a) {
  const o = [], s = (t.variantChildren.size - 1) * r, l = i === 1 ? (c = 0) => c * r : (c = 0) => s - c * r;
  return Array.from(t.variantChildren).sort(CLt).forEach((c, u) => {
    c.notify("AnimationStart", e), o.push(Pw(c, e, {
      ...a,
      delay: n + l(u)
    }).then(() => c.notify("AnimationComplete", e)));
  }), Promise.all(o);
}
function CLt(t, e) {
  return t.sortNodePosition(e);
}
function ALt(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let r;
  if (Array.isArray(e)) {
    const i = e.map((a) => Pw(t, a, n));
    r = Promise.all(i);
  } else if (typeof e == "string")
    r = Pw(t, e, n);
  else {
    const i = typeof e == "function" ? u5(t, e, n.custom) : e;
    r = Promise.all(YQ(t, i, n));
  }
  return r.then(() => {
    t.notify("AnimationComplete", e);
  });
}
const SLt = GA.length;
function KQ(t) {
  if (!t)
    return;
  if (!t.isControllingVariants) {
    const n = t.parent ? KQ(t.parent) || {} : {};
    return t.props.initial !== void 0 && (n.initial = t.props.initial), n;
  }
  const e = {};
  for (let n = 0; n < SLt; n++) {
    const r = GA[n], i = t.props[r];
    (S2(i) || i === !1) && (e[r] = i);
  }
  return e;
}
const LLt = [...ZA].reverse(), TLt = ZA.length;
function ELt(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: r }) => ALt(t, n, r)));
}
function jLt(t) {
  let e = ELt(t), n = bP(), r = !0;
  const i = (l) => (c, u) => {
    var d;
    const f = u5(t, u, l === "exit" ? (d = t.presenceContext) === null || d === void 0 ? void 0 : d.custom : void 0);
    if (f) {
      const { transition: h, transitionEnd: p, ...m } = f;
      c = { ...c, ...m, ...p };
    }
    return c;
  };
  function a(l) {
    e = l(t);
  }
  function o(l) {
    const { props: c } = t, u = KQ(t.parent) || {}, d = [], f = /* @__PURE__ */ new Set();
    let h = {}, p = 1 / 0;
    for (let g = 0; g < TLt; g++) {
      const v = LLt[g], k = n[v], w = c[v] !== void 0 ? c[v] : u[v], b = S2(w), x = v === l ? k.isActive : null;
      x === !1 && (p = g);
      let A = w === u[v] && w !== c[v] && b;
      if (A && r && t.manuallyAnimateOnMount && (A = !1), k.protectedKeys = { ...h }, // If it isn't active and hasn't *just* been set as inactive
      !k.isActive && x === null || // If we didn't and don't have any defined prop for this animation type
      !w && !k.prevProp || // Or if the prop doesn't define an animation
      l5(w) || typeof w == "boolean")
        continue;
      const L = NLt(k.prevProp, w);
      let M = L || // If we're making this variant active, we want to always make it active
      v === l && k.isActive && !A && b || // If we removed a higher-priority variant (i is in reverse order)
      g > p && b, j = !1;
      const D = Array.isArray(w) ? w : [w];
      let z = D.reduce(i(v), {});
      x === !1 && (z = {});
      const { prevResolvedValues: H = {} } = k, V = {
        ...H,
        ...z
      }, F = (G) => {
        M = !0, f.has(G) && (j = !0, f.delete(G)), k.needsAnimating[G] = !0;
        const Y = t.getValue(G);
        Y && (Y.liveStyle = !1);
      };
      for (const G in V) {
        const Y = z[G], Z = H[G];
        if (h.hasOwnProperty(G))
          continue;
        let oe = !1;
        Cw(Y) && Cw(Z) ? oe = !lQ(Y, Z) : oe = Y !== Z, oe ? Y != null ? F(G) : f.add(G) : Y !== void 0 && f.has(G) ? F(G) : k.protectedKeys[G] = !0;
      }
      k.prevProp = w, k.prevResolvedValues = z, k.isActive && (h = { ...h, ...z }), r && t.blockInitialAnimation && (M = !1), M && (!(A && L) || j) && d.push(...D.map((G) => ({
        animation: G,
        options: { type: v }
      })));
    }
    if (f.size) {
      const g = {};
      f.forEach((v) => {
        const k = t.getBaseTarget(v), w = t.getValue(v);
        w && (w.liveStyle = !0), g[v] = k ?? null;
      }), d.push({ animation: g });
    }
    let m = !!d.length;
    return r && (c.initial === !1 || c.initial === c.animate) && !t.manuallyAnimateOnMount && (m = !1), r = !1, m ? e(d) : Promise.resolve();
  }
  function s(l, c) {
    var u;
    if (n[l].isActive === c)
      return Promise.resolve();
    (u = t.variantChildren) === null || u === void 0 || u.forEach((f) => {
      var h;
      return (h = f.animationState) === null || h === void 0 ? void 0 : h.setActive(l, c);
    }), n[l].isActive = c;
    const d = o(l);
    for (const f in n)
      n[f].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: o,
    setActive: s,
    setAnimateFunction: a,
    getState: () => n,
    reset: () => {
      n = bP(), r = !0;
    }
  };
}
function NLt(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !lQ(e, t) : !1;
}
function nu(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function bP() {
  return {
    animate: nu(!0),
    whileInView: nu(),
    whileHover: nu(),
    whileTap: nu(),
    whileDrag: nu(),
    whileFocus: nu(),
    exit: nu()
  };
}
class $c {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
class DLt extends $c {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = jLt(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    l5(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) === null || e === void 0 || e.call(this);
  }
}
let ILt = 0;
class PLt extends $c {
  constructor() {
    super(...arguments), this.id = ILt++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === r)
      return;
    const i = this.node.animationState.setActive("exit", !e);
    n && !e && i.then(() => n(this.id));
  }
  mount() {
    const { register: e } = this.node.presenceContext || {};
    e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const zLt = {
  animation: {
    Feature: DLt
  },
  exit: {
    Feature: PLt
  }
};
function j2(t, e, n, r = { passive: !0 }) {
  return t.addEventListener(e, n, r), () => t.removeEventListener(e, n);
}
function Jp(t) {
  return {
    point: {
      x: t.pageX,
      y: t.pageY
    }
  };
}
const RLt = (t) => (e) => lS(e) && t(e, Jp(e));
function ch(t, e, n, r) {
  return j2(t, e, RLt(n), r);
}
const wP = (t, e) => Math.abs(t - e);
function OLt(t, e) {
  const n = wP(t.x, e.x), r = wP(t.y, e.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class $Q {
  constructor(e, n, { transformPagePoint: r, contextWindow: i, dragSnapToOrigin: a = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = Ov(this.lastMoveEventInfo, this.history), f = this.startEvent !== null, h = OLt(d.offset, { x: 0, y: 0 }) >= 3;
      if (!f && !h)
        return;
      const { point: p } = d, { timestamp: m } = Ir;
      this.history.push({ ...p, timestamp: m });
      const { onStart: g, onMove: v } = this.handlers;
      f || (g && g(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), v && v(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, f) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = Rv(f, this.transformPagePoint), An.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, f) => {
      this.end();
      const { onEnd: h, onSessionEnd: p, resumeAnimation: m } = this.handlers;
      if (this.dragSnapToOrigin && m && m(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const g = Ov(d.type === "pointercancel" ? this.lastMoveEventInfo : Rv(f, this.transformPagePoint), this.history);
      this.startEvent && h && h(d, g), p && p(d, g);
    }, !lS(e))
      return;
    this.dragSnapToOrigin = a, this.handlers = n, this.transformPagePoint = r, this.contextWindow = i || window;
    const o = Jp(e), s = Rv(o, this.transformPagePoint), { point: l } = s, { timestamp: c } = Ir;
    this.history = [{ ...l, timestamp: c }];
    const { onSessionStart: u } = n;
    u && u(e, Ov(s, this.history)), this.removeListeners = $p(ch(this.contextWindow, "pointermove", this.handlePointerMove), ch(this.contextWindow, "pointerup", this.handlePointerUp), ch(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), Tc(this.updatePoint);
  }
}
function Rv(t, e) {
  return e ? { point: e(t.point) } : t;
}
function kP(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function Ov({ point: t }, e) {
  return {
    point: t,
    delta: kP(t, JQ(e)),
    offset: kP(t, BLt(e)),
    velocity: HLt(e, 0.1)
  };
}
function BLt(t) {
  return t[0];
}
function JQ(t) {
  return t[t.length - 1];
}
function HLt(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let n = t.length - 1, r = null;
  const i = JQ(t);
  for (; n >= 0 && (r = t[n], !(i.timestamp - r.timestamp > /* @__PURE__ */ Go(e))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const a = /* @__PURE__ */ Qs(i.timestamp - r.timestamp);
  if (a === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (i.x - r.x) / a,
    y: (i.y - r.y) / a
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
const QQ = 1e-4, FLt = 1 - QQ, _Lt = 1 + QQ, XQ = 0.01, VLt = 0 - XQ, qLt = 0 + XQ;
function ia(t) {
  return t.max - t.min;
}
function ULt(t, e, n) {
  return Math.abs(t - e) <= n;
}
function xP(t, e, n, r = 0.5) {
  t.origin = r, t.originPoint = _n(e.min, e.max, t.origin), t.scale = ia(n) / ia(e), t.translate = _n(n.min, n.max, t.origin) - t.originPoint, (t.scale >= FLt && t.scale <= _Lt || isNaN(t.scale)) && (t.scale = 1), (t.translate >= VLt && t.translate <= qLt || isNaN(t.translate)) && (t.translate = 0);
}
function uh(t, e, n, r) {
  xP(t.x, e.x, n.x, r ? r.originX : void 0), xP(t.y, e.y, n.y, r ? r.originY : void 0);
}
function MP(t, e, n) {
  t.min = n.min + e.min, t.max = t.min + ia(e);
}
function WLt(t, e, n) {
  MP(t.x, e.x, n.x), MP(t.y, e.y, n.y);
}
function CP(t, e, n) {
  t.min = e.min - n.min, t.max = t.min + ia(e);
}
function dh(t, e, n) {
  CP(t.x, e.x, n.x), CP(t.y, e.y, n.y);
}
function ZLt(t, { min: e, max: n }, r) {
  return e !== void 0 && t < e ? t = r ? _n(e, t, r.min) : Math.max(t, e) : n !== void 0 && t > n && (t = r ? _n(n, t, r.max) : Math.min(t, n)), t;
}
function AP(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function GLt(t, { top: e, left: n, bottom: r, right: i }) {
  return {
    x: AP(t.x, n, i),
    y: AP(t.y, e, r)
  };
}
function SP(t, e) {
  let n = e.min - t.min, r = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([n, r] = [r, n]), { min: n, max: r };
}
function YLt(t, e) {
  return {
    x: SP(t.x, e.x),
    y: SP(t.y, e.y)
  };
}
function KLt(t, e) {
  let n = 0.5;
  const r = ia(t), i = ia(e);
  return i > r ? n = /* @__PURE__ */ od(e.min, e.max - r, t.min) : r > i && (n = /* @__PURE__ */ od(t.min, t.max - i, e.min)), gl(0, 1, n);
}
function $Lt(t, e) {
  const n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
const zw = 0.35;
function JLt(t = zw) {
  return t === !1 ? t = 0 : t === !0 && (t = zw), {
    x: LP(t, "left", "right"),
    y: LP(t, "top", "bottom")
  };
}
function LP(t, e, n) {
  return {
    min: TP(t, e),
    max: TP(t, n)
  };
}
function TP(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const EP = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), d1 = () => ({
  x: EP(),
  y: EP()
}), jP = () => ({ min: 0, max: 0 }), Xn = () => ({
  x: jP(),
  y: jP()
});
function ga(t) {
  return [t("x"), t("y")];
}
function eX({ top: t, left: e, right: n, bottom: r }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: r }
  };
}
function QLt({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function XLt(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), r = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function Bv(t) {
  return t === void 0 || t === 1;
}
function Rw({ scale: t, scaleX: e, scaleY: n }) {
  return !Bv(t) || !Bv(e) || !Bv(n);
}
function hu(t) {
  return Rw(t) || tX(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function tX(t) {
  return NP(t.x) || NP(t.y);
}
function NP(t) {
  return t && t !== "0%";
}
function y3(t, e, n) {
  const r = t - n, i = e * r;
  return n + i;
}
function DP(t, e, n, r, i) {
  return i !== void 0 && (t = y3(t, i, r)), y3(t, n, r) + e;
}
function Ow(t, e = 0, n = 1, r, i) {
  t.min = DP(t.min, e, n, r, i), t.max = DP(t.max, e, n, r, i);
}
function nX(t, { x: e, y: n }) {
  Ow(t.x, e.translate, e.scale, e.originPoint), Ow(t.y, n.translate, n.scale, n.originPoint);
}
const IP = 0.999999999999, PP = 1.0000000000001;
function eTt(t, e, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  e.x = e.y = 1;
  let a, o;
  for (let s = 0; s < i; s++) {
    a = n[s], o = a.projectionDelta;
    const { visualElement: l } = a.options;
    l && l.props.style && l.props.style.display === "contents" || (r && a.options.layoutScroll && a.scroll && a !== a.root && h1(t, {
      x: -a.scroll.offset.x,
      y: -a.scroll.offset.y
    }), o && (e.x *= o.x.scale, e.y *= o.y.scale, nX(t, o)), r && hu(a.latestValues) && h1(t, a.latestValues));
  }
  e.x < PP && e.x > IP && (e.x = 1), e.y < PP && e.y > IP && (e.y = 1);
}
function f1(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function zP(t, e, n, r, i = 0.5) {
  const a = _n(t.min, t.max, i);
  Ow(t, e, n, a, r);
}
function h1(t, e) {
  zP(t.x, e.x, e.scaleX, e.scale, e.originX), zP(t.y, e.y, e.scaleY, e.scale, e.originY);
}
function rX(t, e) {
  return eX(XLt(t.getBoundingClientRect(), e));
}
function tTt(t, e, n) {
  const r = rX(t, n), { scroll: i } = e;
  return i && (f1(r.x, i.offset.x), f1(r.y, i.offset.y)), r;
}
const iX = ({ current: t }) => t ? t.ownerDocument.defaultView : null, nTt = /* @__PURE__ */ new WeakMap();
class rTt {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Xn(), this.visualElement = e;
  }
  start(e, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const i = (u) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(Jp(u).point);
    }, a = (u, d) => {
      const { drag: f, dragPropagation: h, onDragStart: p } = this.getProps();
      if (f && !h && (this.openDragLock && this.openDragLock(), this.openDragLock = KAt(f), !this.openDragLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), ga((g) => {
        let v = this.getAxisMotionValue(g).get() || 0;
        if (Yo.test(v)) {
          const { projection: k } = this.visualElement;
          if (k && k.layout) {
            const w = k.layout.layoutBox[g];
            w && (v = ia(w) * (parseFloat(v) / 100));
          }
        }
        this.originPoint[g] = v;
      }), p && An.postRender(() => p(u, d)), Lw(this.visualElement, "transform");
      const { animationState: m } = this.visualElement;
      m && m.setActive("whileDrag", !0);
    }, o = (u, d) => {
      const { dragPropagation: f, dragDirectionLock: h, onDirectionLock: p, onDrag: m } = this.getProps();
      if (!f && !this.openDragLock)
        return;
      const { offset: g } = d;
      if (h && this.currentDirection === null) {
        this.currentDirection = iTt(g), this.currentDirection !== null && p && p(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, g), this.updateAxis("y", d.point, g), this.visualElement.render(), m && m(u, d);
    }, s = (u, d) => this.stop(u, d), l = () => ga((u) => {
      var d;
      return this.getAnimationState(u) === "paused" && ((d = this.getAxisMotionValue(u).animation) === null || d === void 0 ? void 0 : d.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new $Q(e, {
      onSessionStart: i,
      onStart: a,
      onMove: o,
      onSessionEnd: s,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      contextWindow: iX(this.visualElement)
    });
  }
  stop(e, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: i } = n;
    this.startAnimation(i);
    const { onDragEnd: a } = this.getProps();
    a && An.postRender(() => a(e, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: n } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(e, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !n4(e, i, this.currentDirection))
      return;
    const a = this.getAxisMotionValue(e);
    let o = this.originPoint[e] + r[e];
    this.constraints && this.constraints[e] && (o = ZLt(o, this.constraints[e], this.elastic[e])), a.set(o);
  }
  resolveConstraints() {
    var e;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (e = this.visualElement.projection) === null || e === void 0 ? void 0 : e.layout, a = this.constraints;
    n && c1(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && i ? this.constraints = GLt(i.layoutBox, n) : this.constraints = !1, this.elastic = JLt(r), a !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && ga((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = $Lt(i.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: n } = this.getProps();
    if (!e || !c1(e))
      return !1;
    const r = e.current;
    Lc(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const a = tTt(r, i.root, this.visualElement.getTransformPagePoint());
    let o = YLt(i.layout.layoutBox, a);
    if (n) {
      const s = n(QLt(o));
      this.hasMutatedConstraints = !!s, s && (o = eX(s));
    }
    return o;
  }
  startAnimation(e) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: a, dragSnapToOrigin: o, onDragTransitionEnd: s } = this.getProps(), l = this.constraints || {}, c = ga((u) => {
      if (!n4(u, n, this.currentDirection))
        return;
      let d = l && l[u] || {};
      o && (d = { min: 0, max: 0 });
      const f = i ? 200 : 1e6, h = i ? 40 : 1e7, p = {
        type: "inertia",
        velocity: r ? e[u] : 0,
        bounceStiffness: f,
        bounceDamping: h,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...a,
        ...d
      };
      return this.startAxisValueAnimation(u, p);
    });
    return Promise.all(c).then(s);
  }
  startAxisValueAnimation(e, n) {
    const r = this.getAxisMotionValue(e);
    return Lw(this.visualElement, e), r.start(wS(e, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    ga((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    ga((e) => {
      var n;
      return (n = this.getAxisMotionValue(e).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(e) {
    var n;
    return (n = this.getAxisMotionValue(e).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const n = `_drag${e.toUpperCase()}`, r = this.visualElement.getProps(), i = r[n];
    return i || this.visualElement.getValue(e, (r.initial ? r.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    ga((n) => {
      const { drag: r } = this.getProps();
      if (!n4(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, a = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: o, max: s } = i.layout.layoutBox[n];
        a.set(e[n] - _n(o, s, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!c1(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    ga((o) => {
      const s = this.getAxisMotionValue(o);
      if (s && this.constraints !== !1) {
        const l = s.get();
        i[o] = KLt({ min: l, max: l }, this.constraints[o]);
      }
    });
    const { transformTemplate: a } = this.visualElement.getProps();
    this.visualElement.current.style.transform = a ? a({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), ga((o) => {
      if (!n4(o, e, null))
        return;
      const s = this.getAxisMotionValue(o), { min: l, max: c } = this.constraints[o];
      s.set(_n(l, c, i[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    nTt.set(this.visualElement, this);
    const e = this.visualElement.current, n = ch(e, "pointerdown", (l) => {
      const { drag: c, dragListener: u = !0 } = this.getProps();
      c && u && this.start(l);
    }), r = () => {
      const { dragConstraints: l } = this.getProps();
      c1(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, a = i.addEventListener("measure", r);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), An.read(r);
    const o = j2(window, "resize", () => this.scalePositionWithinConstraints()), s = i.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && (ga((u) => {
        const d = this.getAxisMotionValue(u);
        d && (this.originPoint[u] += l[u].translate, d.set(d.get() + l[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), n(), a(), s && s();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: a = !1, dragElastic: o = zw, dragMomentum: s = !0 } = e;
    return {
      ...e,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: a,
      dragElastic: o,
      dragMomentum: s
    };
  }
}
function n4(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function iTt(t, e = 10) {
  let n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
class aTt extends $c {
  constructor(e) {
    super(e), this.removeGroupControls = Ni, this.removeListeners = Ni, this.controls = new rTt(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Ni;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const RP = (t) => (e, n) => {
  t && An.postRender(() => t(e, n));
};
class oTt extends $c {
  constructor() {
    super(...arguments), this.removePointerDownListener = Ni;
  }
  onPointerDown(e) {
    this.session = new $Q(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: iX(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: RP(e),
      onStart: RP(n),
      onMove: r,
      onEnd: (a, o) => {
        delete this.session, i && An.postRender(() => i(a, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = ch(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const X4 = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function OP(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const Af = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (Et.test(t))
        t = parseFloat(t);
      else
        return t;
    const n = OP(t, e.target.x), r = OP(t, e.target.y);
    return `${n}% ${r}%`;
  }
}, sTt = {
  correct: (t, { treeScale: e, projectionDelta: n }) => {
    const r = t, i = Ec.parse(t);
    if (i.length > 5)
      return r;
    const a = Ec.createTransformer(t), o = typeof i[0] != "number" ? 1 : 0, s = n.x.scale * e.x, l = n.y.scale * e.y;
    i[0 + o] /= s, i[1 + o] /= l;
    const c = _n(s, l, 0.5);
    return typeof i[2 + o] == "number" && (i[2 + o] /= c), typeof i[3 + o] == "number" && (i[3 + o] /= c), a(i);
  }
};
class lTt extends Wk {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: a } = e;
    TAt(cTt), a && (n.group && n.group.add(a), r && r.register && i && r.register(a), a.root.didUpdate(), a.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), a.setOptions({
      ...a.options,
      onExitComplete: () => this.safeToRemove()
    })), X4.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: a } = this.props, o = r.projection;
    return o && (o.isPresent = a, i || e.layoutDependency !== n || n === void 0 ? o.willUpdate() : this.safeToRemove(), e.isPresent !== a && (a ? o.promote() : o.relegate() || An.postRender(() => {
      const s = o.getStack();
      (!s || !s.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), KA.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = e;
    i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function aX(t) {
  const [e, n] = VJ(), r = Mt(_A);
  return C.jsx(lTt, { ...t, layoutGroup: r, switchLayoutGroup: Mt(KJ), isPresent: e, safeToRemove: n });
}
const cTt = {
  borderRadius: {
    ...Af,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Af,
  borderTopRightRadius: Af,
  borderBottomLeftRadius: Af,
  borderBottomRightRadius: Af,
  boxShadow: sTt
};
function uTt(t, e, n) {
  const r = Yr(t) ? t : T2(t);
  return r.start(wS("", r, e, n)), r.animation;
}
function dTt(t) {
  return t instanceof SVGElement && t.tagName !== "svg";
}
const fTt = (t, e) => t.depth - e.depth;
class hTt {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    cS(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    uS(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(fTt), this.isDirty = !1, this.children.forEach(e);
  }
}
function pTt(t, e) {
  const n = Ko.now(), r = ({ timestamp: i }) => {
    const a = i - n;
    a >= e && (Tc(r), t(a - e));
  };
  return An.read(r, !0), () => Tc(r);
}
const oX = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], mTt = oX.length, BP = (t) => typeof t == "string" ? parseFloat(t) : t, HP = (t) => typeof t == "number" || Et.test(t);
function yTt(t, e, n, r, i, a) {
  i ? (t.opacity = _n(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    gTt(r)
  ), t.opacityExit = _n(e.opacity !== void 0 ? e.opacity : 1, 0, vTt(r))) : a && (t.opacity = _n(e.opacity !== void 0 ? e.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let o = 0; o < mTt; o++) {
    const s = `border${oX[o]}Radius`;
    let l = FP(e, s), c = FP(n, s);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || HP(l) === HP(c) ? (t[s] = Math.max(_n(BP(l), BP(c), r), 0), (Yo.test(c) || Yo.test(l)) && (t[s] += "%")) : t[s] = c;
  }
  (e.rotate || n.rotate) && (t.rotate = _n(e.rotate || 0, n.rotate || 0, r));
}
function FP(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const gTt = /* @__PURE__ */ sX(0, 0.5, AQ), vTt = /* @__PURE__ */ sX(0.5, 0.95, Ni);
function sX(t, e, n) {
  return (r) => r < t ? 0 : r > e ? 1 : n(/* @__PURE__ */ od(t, e, r));
}
function _P(t, e) {
  t.min = e.min, t.max = e.max;
}
function pa(t, e) {
  _P(t.x, e.x), _P(t.y, e.y);
}
function VP(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
function qP(t, e, n, r, i) {
  return t -= e, t = y3(t, 1 / n, r), i !== void 0 && (t = y3(t, 1 / i, r)), t;
}
function bTt(t, e = 0, n = 1, r = 0.5, i, a = t, o = t) {
  if (Yo.test(e) && (e = parseFloat(e), e = _n(o.min, o.max, e / 100) - o.min), typeof e != "number")
    return;
  let s = _n(a.min, a.max, r);
  t === a && (s -= e), t.min = qP(t.min, e, n, s, i), t.max = qP(t.max, e, n, s, i);
}
function UP(t, e, [n, r, i], a, o) {
  bTt(t, e[n], e[r], e[i], e.scale, a, o);
}
const wTt = ["x", "scaleX", "originX"], kTt = ["y", "scaleY", "originY"];
function WP(t, e, n, r) {
  UP(t.x, e, wTt, n ? n.x : void 0, r ? r.x : void 0), UP(t.y, e, kTt, n ? n.y : void 0, r ? r.y : void 0);
}
function ZP(t) {
  return t.translate === 0 && t.scale === 1;
}
function lX(t) {
  return ZP(t.x) && ZP(t.y);
}
function GP(t, e) {
  return t.min === e.min && t.max === e.max;
}
function xTt(t, e) {
  return GP(t.x, e.x) && GP(t.y, e.y);
}
function YP(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function cX(t, e) {
  return YP(t.x, e.x) && YP(t.y, e.y);
}
function KP(t) {
  return ia(t.x) / ia(t.y);
}
function $P(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
class MTt {
  constructor() {
    this.members = [];
  }
  add(e) {
    cS(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (uS(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(e) {
    const n = this.members.findIndex((i) => e === i);
    if (n === 0)
      return !1;
    let r;
    for (let i = n; i >= 0; i--) {
      const a = this.members[i];
      if (a.isPresent !== !1) {
        r = a;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(e, n) {
    const r = this.lead;
    if (e !== r && (this.prevLead = r, this.lead = e, e.show(), r)) {
      r.instance && r.scheduleRender(), e.scheduleRender(), e.resumeFrom = r, n && (e.resumeFrom.preserveOpacity = !0), r.snapshot && (e.snapshot = r.snapshot, e.snapshot.latestValues = r.animationValues || r.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: i } = e.options;
      i === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: n, resumingFrom: r } = e;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function CTt(t, e, n) {
  let r = "";
  const i = t.x.translate / e.x, a = t.y.translate / e.y, o = (n == null ? void 0 : n.z) || 0;
  if ((i || a || o) && (r = `translate3d(${i}px, ${a}px, ${o}px) `), (e.x !== 1 || e.y !== 1) && (r += `scale(${1 / e.x}, ${1 / e.y}) `), n) {
    const { transformPerspective: c, rotate: u, rotateX: d, rotateY: f, skewX: h, skewY: p } = n;
    c && (r = `perspective(${c}px) ${r}`), u && (r += `rotate(${u}deg) `), d && (r += `rotateX(${d}deg) `), f && (r += `rotateY(${f}deg) `), h && (r += `skewX(${h}deg) `), p && (r += `skewY(${p}deg) `);
  }
  const s = t.x.scale * e.x, l = t.y.scale * e.y;
  return (s !== 1 || l !== 1) && (r += `scale(${s}, ${l})`), r || "none";
}
const pu = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
}, Hf = typeof window < "u" && window.MotionDebug !== void 0, Hv = ["", "X", "Y", "Z"], ATt = { visibility: "hidden" }, JP = 1e3;
let STt = 0;
function Fv(t, e, n, r) {
  const { latestValues: i } = e;
  i[t] && (n[t] = i[t], e.setStaticValue(t, 0), r && (r[t] = 0));
}
function uX(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t)
    return;
  const { visualElement: e } = t.options;
  if (!e)
    return;
  const n = vQ(e);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: a } = t.options;
    window.MotionCancelOptimisedAnimation(n, "transform", An, !(i || a));
  }
  const { parent: r } = t;
  r && !r.hasCheckedOptimisedAppear && uX(r);
}
function dX({ attachResizeListener: t, defaultParent: e, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(o = {}, s = e == null ? void 0 : e()) {
      this.id = STt++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, Hf && (pu.totalNodes = pu.resolvedTargetDeltas = pu.recalculatedProjection = 0), this.nodes.forEach(ETt), this.nodes.forEach(PTt), this.nodes.forEach(zTt), this.nodes.forEach(jTt), Hf && window.MotionDebug.record(pu);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = s ? s.root || s : this, this.path = s ? [...s.path, s] : [], this.parent = s, this.depth = s ? s.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new hTt());
    }
    addEventListener(o, s) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new dS()), this.eventHandlers.get(o).add(s);
    }
    notifyListeners(o, ...s) {
      const l = this.eventHandlers.get(o);
      l && l.notify(...s);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o, s = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = dTt(o), this.instance = o;
      const { layoutId: l, layout: c, visualElement: u } = this.options;
      if (u && !u.current && u.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), s && (c || l) && (this.isLayoutDirty = !0), t) {
        let d;
        const f = () => this.root.updateBlockedByResize = !1;
        t(o, () => {
          this.root.updateBlockedByResize = !0, d && d(), d = pTt(f, 250), X4.hasAnimatedSinceResize && (X4.hasAnimatedSinceResize = !1, this.nodes.forEach(XP));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && u && (l || c) && this.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: f, hasRelativeTargetChanged: h, layout: p }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const m = this.options.transition || u.getDefaultTransition() || FTt, { onLayoutAnimationStart: g, onLayoutAnimationComplete: v } = u.getProps(), k = !this.targetLayout || !cX(this.targetLayout, p) || h, w = !f && h;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || w || f && (k || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(d, w);
          const b = {
            ...aS(m, "layout"),
            onPlay: g,
            onComplete: v
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (b.delay = 0, b.type = !1), this.startAnimation(b);
        } else
          f || XP(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = p;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, Tc(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(RTt), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && uX(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        d.shouldResetTransform = !0, d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: s, layout: l } = this.options;
      if (s === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(QP);
        return;
      }
      this.isUpdating || this.nodes.forEach(DTt), this.isUpdating = !1, this.nodes.forEach(ITt), this.nodes.forEach(LTt), this.nodes.forEach(TTt), this.clearAllSnapshots();
      const s = Ko.now();
      Ir.delta = gl(0, 1e3 / 60, s - Ir.timestamp), Ir.timestamp = s, Ir.isProcessing = !0, Nv.update.process(Ir), Nv.preRender.process(Ir), Nv.render.process(Ir), Ir.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, KA.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(NTt), this.sharedNodes.forEach(OTt);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, An.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      An.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = Xn(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: s } = this.options;
      s && s.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let s = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (s = !1), s) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, s = this.projectionDelta && !lX(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, u = c !== this.prevTransformTemplateValue;
      o && (s || hu(this.latestValues) || u) && (i(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const s = this.measurePageBox();
      let l = this.removeElementScroll(s);
      return o && (l = this.removeTransform(l)), _Tt(l), {
        animationId: this.root.animationId,
        measuredBox: s,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var o;
      const { visualElement: s } = this.options;
      if (!s)
        return Xn();
      const l = s.measureViewportBox();
      if (!(((o = this.scroll) === null || o === void 0 ? void 0 : o.wasRoot) || this.path.some(VTt))) {
        const { scroll: u } = this.root;
        u && (f1(l.x, u.offset.x), f1(l.y, u.offset.y));
      }
      return l;
    }
    removeElementScroll(o) {
      var s;
      const l = Xn();
      if (pa(l, o), !((s = this.scroll) === null || s === void 0) && s.wasRoot)
        return l;
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c], { scroll: d, options: f } = u;
        u !== this.root && d && f.layoutScroll && (d.wasRoot && pa(l, o), f1(l.x, d.offset.x), f1(l.y, d.offset.y));
      }
      return l;
    }
    applyTransform(o, s = !1) {
      const l = Xn();
      pa(l, o);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        !s && u.options.layoutScroll && u.scroll && u !== u.root && h1(l, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), hu(u.latestValues) && h1(l, u.latestValues);
      }
      return hu(this.latestValues) && h1(l, this.latestValues), l;
    }
    removeTransform(o) {
      const s = Xn();
      pa(s, o);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        if (!c.instance || !hu(c.latestValues))
          continue;
        Rw(c.latestValues) && c.updateSnapshot();
        const u = Xn(), d = c.measurePageBox();
        pa(u, d), WP(s, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, u);
      }
      return hu(this.latestValues) && WP(s, this.latestValues), s;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Ir.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var s;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== l;
      if (!(o || c && this.isSharedProjectionDirty || this.isProjectionDirty || !((s = this.parent) === null || s === void 0) && s.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: d, layoutId: f } = this.options;
      if (!(!this.layout || !(d || f))) {
        if (this.resolvedRelativeTargetAt = Ir.timestamp, !this.targetDelta && !this.relativeTarget) {
          const h = this.getClosestProjectingParent();
          h && h.layout && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Xn(), this.relativeTargetOrigin = Xn(), dh(this.relativeTargetOrigin, this.layout.layoutBox, h.layout.layoutBox), pa(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = Xn(), this.targetWithTransforms = Xn()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), WLt(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : pa(this.target, this.layout.layoutBox), nX(this.target, this.targetDelta)) : pa(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const h = this.getClosestProjectingParent();
            h && !!h.resumingFrom == !!this.resumingFrom && !h.options.layoutScroll && h.target && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Xn(), this.relativeTargetOrigin = Xn(), dh(this.relativeTargetOrigin, this.target, h.target), pa(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          Hf && pu.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Rw(this.parent.latestValues) || tX(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var o;
      const s = this.getLead(), l = !!this.resumingFrom || this !== s;
      let c = !0;
      if ((this.isProjectionDirty || !((o = this.parent) === null || o === void 0) && o.isProjectionDirty) && (c = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === Ir.timestamp && (c = !1), c)
        return;
      const { layout: u, layoutId: d } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || d))
        return;
      pa(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, h = this.treeScale.y;
      eTt(this.layoutCorrected, this.treeScale, this.path, l), s.layout && !s.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (s.target = s.layout.layoutBox, s.targetWithTransforms = Xn());
      const { target: p } = s;
      if (!p) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (VP(this.prevProjectionDelta.x, this.projectionDelta.x), VP(this.prevProjectionDelta.y, this.projectionDelta.y)), uh(this.projectionDelta, this.layoutCorrected, p, this.latestValues), (this.treeScale.x !== f || this.treeScale.y !== h || !$P(this.projectionDelta.x, this.prevProjectionDelta.x) || !$P(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", p)), Hf && pu.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      var s;
      if ((s = this.options.visualElement) === null || s === void 0 || s.scheduleRender(), o) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = d1(), this.projectionDelta = d1(), this.projectionDeltaWithTransform = d1();
    }
    setAnimationOrigin(o, s = !1) {
      const l = this.snapshot, c = l ? l.latestValues : {}, u = { ...this.latestValues }, d = d1();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !s;
      const f = Xn(), h = l ? l.source : void 0, p = this.layout ? this.layout.source : void 0, m = h !== p, g = this.getStack(), v = !g || g.members.length <= 1, k = !!(m && !v && this.options.crossfade === !0 && !this.path.some(HTt));
      this.animationProgress = 0;
      let w;
      this.mixTargetDelta = (b) => {
        const x = b / 1e3;
        ez(d.x, o.x, x), ez(d.y, o.y, x), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (dh(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox), BTt(this.relativeTarget, this.relativeTargetOrigin, f, x), w && xTt(this.relativeTarget, w) && (this.isProjectionDirty = !1), w || (w = Xn()), pa(w, this.relativeTarget)), m && (this.animationValues = u, yTt(u, c, this.latestValues, x, k, v)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = x;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (Tc(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = An.update(() => {
        X4.hasAnimatedSinceResize = !0, this.currentAnimation = uTt(0, JP, {
          ...o,
          onUpdate: (s) => {
            this.mixTargetDelta(s), o.onUpdate && o.onUpdate(s);
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(JP), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: s, target: l, layout: c, latestValues: u } = o;
      if (!(!s || !l || !c)) {
        if (this !== o && this.layout && c && fX(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || Xn();
          const d = ia(this.layout.layoutBox.x);
          l.x.min = o.target.x.min, l.x.max = l.x.min + d;
          const f = ia(this.layout.layoutBox.y);
          l.y.min = o.target.y.min, l.y.max = l.y.min + f;
        }
        pa(s, l), h1(s, u), uh(this.projectionDeltaWithTransform, this.layoutCorrected, s, u);
      }
    }
    registerSharedNode(o, s) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new MTt()), this.sharedNodes.get(o).add(s);
      const c = s.options.initialPromotionConfig;
      s.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(s) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var o;
      const { layoutId: s } = this.options;
      return s ? ((o = this.getStack()) === null || o === void 0 ? void 0 : o.lead) || this : this;
    }
    getPrevLead() {
      var o;
      const { layoutId: s } = this.options;
      return s ? (o = this.getStack()) === null || o === void 0 ? void 0 : o.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: s, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), o && (this.projectionDelta = void 0, this.needsReset = !0), s && this.setOptions({ transition: s });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let s = !1;
      const { latestValues: l } = o;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (s = !0), !s)
        return;
      const c = {};
      l.z && Fv("z", o, c, this.animationValues);
      for (let u = 0; u < Hv.length; u++)
        Fv(`rotate${Hv[u]}`, o, c, this.animationValues), Fv(`skew${Hv[u]}`, o, c, this.animationValues);
      o.render();
      for (const u in c)
        o.setStaticValue(u, c[u]), this.animationValues && (this.animationValues[u] = c[u]);
      o.scheduleRender();
    }
    getProjectionStyles(o) {
      var s, l;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return ATt;
      const c = {
        visibility: ""
      }, u = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, c.opacity = "", c.pointerEvents = J4(o == null ? void 0 : o.pointerEvents) || "", c.transform = u ? u(this.latestValues, "") : "none", c;
      const d = this.getLead();
      if (!this.projectionDelta || !this.layout || !d.target) {
        const m = {};
        return this.options.layoutId && (m.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, m.pointerEvents = J4(o == null ? void 0 : o.pointerEvents) || ""), this.hasProjected && !hu(this.latestValues) && (m.transform = u ? u({}, "") : "none", this.hasProjected = !1), m;
      }
      const f = d.animationValues || d.latestValues;
      this.applyTransformsToTarget(), c.transform = CTt(this.projectionDeltaWithTransform, this.treeScale, f), u && (c.transform = u(f, c.transform));
      const { x: h, y: p } = this.projectionDelta;
      c.transformOrigin = `${h.origin * 100}% ${p.origin * 100}% 0`, d.animationValues ? c.opacity = d === this ? (l = (s = f.opacity) !== null && s !== void 0 ? s : this.latestValues.opacity) !== null && l !== void 0 ? l : 1 : this.preserveOpacity ? this.latestValues.opacity : f.opacityExit : c.opacity = d === this ? f.opacity !== void 0 ? f.opacity : "" : f.opacityExit !== void 0 ? f.opacityExit : 0;
      for (const m in d3) {
        if (f[m] === void 0)
          continue;
        const { correct: g, applyTo: v } = d3[m], k = c.transform === "none" ? f[m] : g(f[m], d);
        if (v) {
          const w = v.length;
          for (let b = 0; b < w; b++)
            c[v[b]] = k;
        } else
          c[m] = k;
      }
      return this.options.layoutId && (c.pointerEvents = d === this ? J4(o == null ? void 0 : o.pointerEvents) || "" : "none"), c;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var s;
        return (s = o.currentAnimation) === null || s === void 0 ? void 0 : s.stop();
      }), this.root.nodes.forEach(QP), this.root.sharedNodes.clear();
    }
  };
}
function LTt(t) {
  t.updateLayout();
}
function TTt(t) {
  var e;
  const n = ((e = t.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && n && t.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: i } = t.layout, { animationType: a } = t.options, o = n.source !== t.layout.source;
    a === "size" ? ga((d) => {
      const f = o ? n.measuredBox[d] : n.layoutBox[d], h = ia(f);
      f.min = r[d].min, f.max = f.min + h;
    }) : fX(a, n.layoutBox, r) && ga((d) => {
      const f = o ? n.measuredBox[d] : n.layoutBox[d], h = ia(r[d]);
      f.max = f.min + h, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[d].max = t.relativeTarget[d].min + h);
    });
    const s = d1();
    uh(s, r, n.layoutBox);
    const l = d1();
    o ? uh(l, t.applyTransform(i, !0), n.measuredBox) : uh(l, r, n.layoutBox);
    const c = !lX(s);
    let u = !1;
    if (!t.resumeFrom) {
      const d = t.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: f, layout: h } = d;
        if (f && h) {
          const p = Xn();
          dh(p, n.layoutBox, f.layoutBox);
          const m = Xn();
          dh(m, r, h.layoutBox), cX(p, m) || (u = !0), d.options.layoutRoot && (t.relativeTarget = m, t.relativeTargetOrigin = p, t.relativeParent = d);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: l,
      layoutDelta: s,
      hasLayoutChanged: c,
      hasRelativeTargetChanged: u
    });
  } else if (t.isLead()) {
    const { onExitComplete: r } = t.options;
    r && r();
  }
  t.options.transition = void 0;
}
function ETt(t) {
  Hf && pu.totalNodes++, t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function jTt(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function NTt(t) {
  t.clearSnapshot();
}
function QP(t) {
  t.clearMeasurements();
}
function DTt(t) {
  t.isLayoutDirty = !1;
}
function ITt(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function XP(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function PTt(t) {
  t.resolveTargetDelta();
}
function zTt(t) {
  t.calcProjection();
}
function RTt(t) {
  t.resetSkewAndRotation();
}
function OTt(t) {
  t.removeLeadSnapshot();
}
function ez(t, e, n) {
  t.translate = _n(e.translate, 0, n), t.scale = _n(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function tz(t, e, n, r) {
  t.min = _n(e.min, n.min, r), t.max = _n(e.max, n.max, r);
}
function BTt(t, e, n, r) {
  tz(t.x, e.x, n.x, r), tz(t.y, e.y, n.y, r);
}
function HTt(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const FTt = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, nz = (t) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t), rz = nz("applewebkit/") && !nz("chrome/") ? Math.round : Ni;
function iz(t) {
  t.min = rz(t.min), t.max = rz(t.max);
}
function _Tt(t) {
  iz(t.x), iz(t.y);
}
function fX(t, e, n) {
  return t === "position" || t === "preserve-aspect" && !ULt(KP(e), KP(n), 0.2);
}
function VTt(t) {
  var e;
  return t !== t.root && ((e = t.scroll) === null || e === void 0 ? void 0 : e.wasRoot);
}
const qTt = dX({
  attachResizeListener: (t, e) => j2(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), _v = {
  current: void 0
}, hX = dX({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!_v.current) {
      const t = new qTt({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), _v.current = t;
    }
    return _v.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), UTt = {
  pan: {
    Feature: oTt
  },
  drag: {
    Feature: aTt,
    ProjectionNode: hX,
    MeasureLayout: aX
  }
};
function az(t, e, n) {
  const { props: r } = t;
  t.animationState && r.whileHover && t.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, a = r[i];
  a && An.postRender(() => a(e, Jp(e)));
}
class WTt extends $c {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = UAt(e, (n) => (az(this.node, n, "Start"), (r) => az(this.node, r, "End"))));
  }
  unmount() {
  }
}
class ZTt extends $c {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = $p(j2(this.node.current, "focus", () => this.onFocus()), j2(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function oz(t, e, n) {
  const { props: r } = t;
  t.animationState && r.whileTap && t.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), a = r[i];
  a && An.postRender(() => a(e, Jp(e)));
}
class GTt extends $c {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = YAt(e, (n) => (oz(this.node, n, "Start"), (r, { success: i }) => oz(this.node, r, i ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const Bw = /* @__PURE__ */ new WeakMap(), Vv = /* @__PURE__ */ new WeakMap(), YTt = (t) => {
  const e = Bw.get(t.target);
  e && e(t);
}, KTt = (t) => {
  t.forEach(YTt);
};
function $Tt({ root: t, ...e }) {
  const n = t || document;
  Vv.has(n) || Vv.set(n, {});
  const r = Vv.get(n), i = JSON.stringify(e);
  return r[i] || (r[i] = new IntersectionObserver(KTt, { root: t, ...e })), r[i];
}
function JTt(t, e, n) {
  const r = $Tt(e);
  return Bw.set(t, n), r.observe(t), () => {
    Bw.delete(t), r.unobserve(t);
  };
}
const QTt = {
  some: 0,
  all: 1
};
class XTt extends $c {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: a } = e, o = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : QTt[i]
    }, s = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, a && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: u, onViewportLeave: d } = this.node.getProps(), f = c ? u : d;
      f && f(l);
    };
    return JTt(this.node.current, o, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(eEt(e, n)) && this.startObserver();
  }
  unmount() {
  }
}
function eEt({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const tEt = {
  inView: {
    Feature: XTt
  },
  tap: {
    Feature: GTt
  },
  focus: {
    Feature: ZTt
  },
  hover: {
    Feature: WTt
  }
}, nEt = {
  layout: {
    ProjectionNode: hX,
    MeasureLayout: aX
  }
}, Hw = { current: null }, pX = { current: !1 };
function rEt() {
  if (pX.current = !0, !!UA)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => Hw.current = t.matches;
      t.addListener(e), e();
    } else
      Hw.current = !1;
}
const iEt = [...HQ, Ur, Ec], aEt = (t) => iEt.find(BQ(t)), sz = /* @__PURE__ */ new WeakMap();
function oEt(t, e, n) {
  for (const r in e) {
    const i = e[r], a = n[r];
    if (Yr(i))
      t.addValue(r, i), process.env.NODE_ENV === "development" && o5(i.version === "11.18.2", `Attempting to mix Motion versions ${i.version} with 11.18.2 may not work as expected.`);
    else if (Yr(a))
      t.addValue(r, T2(i, { owner: t }));
    else if (a !== i)
      if (t.hasValue(r)) {
        const o = t.getValue(r);
        o.liveStyle === !0 ? o.jump(i) : o.hasAnimated || o.set(i);
      } else {
        const o = t.getStaticValue(r);
        t.addValue(r, T2(o !== void 0 ? o : i, { owner: t }));
      }
  }
  for (const r in n)
    e[r] === void 0 && t.removeValue(r);
  return e;
}
const lz = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class sEt {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n, r) {
    return {};
  }
  constructor({ parent: e, props: n, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: a, visualState: o }, s = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = gS, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const h = Ko.now();
      this.renderScheduledAt < h && (this.renderScheduledAt = h, An.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: c, onUpdate: u } = o;
    this.onUpdate = u, this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = c, this.parent = e, this.props = n, this.presenceContext = r, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = i, this.options = s, this.blockInitialAnimation = !!a, this.isControllingVariants = c5(n), this.isVariantNode = GJ(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: d, ...f } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const h in f) {
      const p = f[h];
      l[h] !== void 0 && Yr(p) && p.set(l[h], !1);
    }
  }
  mount(e) {
    this.current = e, sz.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), pX.current || rEt(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Hw.current, process.env.NODE_ENV !== "production" && o5(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    sz.delete(this.current), this.projection && this.projection.unmount(), Tc(this.notifyUpdate), Tc(this.render), this.valueSubscriptions.forEach((e) => e()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features) {
      const n = this.features[e];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(e, n) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const r = T0.has(e), i = n.on("change", (s) => {
      this.latestValues[e] = s, this.props.onUpdate && An.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), a = n.on("renderRequest", this.scheduleRender);
    let o;
    window.MotionCheckAppearSync && (o = window.MotionCheckAppearSync(this, e, n)), this.valueSubscriptions.set(e, () => {
      i(), a(), o && o(), n.owner && n.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in sd) {
      const n = sd[e];
      if (!n)
        continue;
      const { isEnabled: r, Feature: i } = n;
      if (!this.features[e] && i && r(this.props) && (this.features[e] = new i(this)), this.features[e]) {
        const a = this.features[e];
        a.isMounted ? a.update() : (a.mount(), a.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Xn();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < lz.length; r++) {
      const i = lz[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const a = "on" + i, o = e[a];
      o && (this.propEventSubscriptions[i] = this.on(i, o));
    }
    this.prevMotionValues = oEt(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue(), this.onUpdate && this.onUpdate(this);
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    const r = this.values.get(e);
    n !== r && (r && this.removeValue(e), this.bindToMotionValue(e, n), this.values.set(e, n), this.latestValues[e] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let r = this.values.get(e);
    return r === void 0 && n !== void 0 && (r = T2(n === null ? void 0 : n, { owner: this }), this.addValue(e, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, n) {
    var r;
    let i = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : (r = this.getBaseTargetFromProps(this.props, e)) !== null && r !== void 0 ? r : this.readValueFromInstance(this.current, e, this.options);
    return i != null && (typeof i == "string" && (RQ(i) || LQ(i)) ? i = parseFloat(i) : !aEt(i) && Ec.test(n) && (i = IQ(e, n)), this.setBaseTarget(e, Yr(i) ? i.get() : i)), Yr(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var n;
    const { initial: r } = this.props;
    let i;
    if (typeof r == "string" || typeof r == "object") {
      const o = JA(this.props, r, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      o && (i = o[e]);
    }
    if (r && i !== void 0)
      return i;
    const a = this.getBaseTargetFromProps(this.props, e);
    return a !== void 0 && !Yr(a) ? a : this.initialValues[e] !== void 0 && i === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new dS()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
}
class mX extends sEt {
  constructor() {
    super(...arguments), this.KeyframeResolver = FQ;
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: r }) {
    delete n[e], delete r[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    Yr(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function lEt(t) {
  return window.getComputedStyle(t);
}
class cEt extends mX {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = nQ;
  }
  readValueFromInstance(e, n) {
    if (T0.has(n)) {
      const r = yS(n);
      return r && r.default || 0;
    } else {
      const r = lEt(e), i = (XJ(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return rX(e, n);
  }
  build(e, n, r) {
    eS(e, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, r) {
    return iS(e, n, r);
  }
}
class uEt extends mX {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = Xn;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (T0.has(n)) {
      const r = yS(n);
      return r && r.default || 0;
    }
    return n = rQ.has(n) ? n : YA(n), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, r) {
    return oQ(e, n, r);
  }
  build(e, n, r) {
    tS(e, n, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(e, n, r, i) {
    iQ(e, n, r, i);
  }
  mount(e) {
    this.isSVGTag = rS(e.tagName), super.mount(e);
  }
}
const dEt = (t, e) => $A(t) ? new uEt(e) : new cEt(e, {
  allowProjection: t !== ds
}), fEt = /* @__PURE__ */ OAt({
  ...zLt,
  ...tEt,
  ...UTt,
  ...nEt
}, dEt), Qp = /* @__PURE__ */ QCt(fEt), hEt = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 }
}, Fi = (t, e) => /* @__PURE__ */ C.jsx(
  Qp.div,
  {
    variants: hEt,
    initial: "initial",
    animate: "animate",
    exit: "exit",
    transition: { duration: 1 },
    children: t
  },
  e
), pEt = {
  initial: { y: 10, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: -10, opacity: 0 }
}, _i = (t, e) => /* @__PURE__ */ C.jsx(
  Qp.div,
  {
    variants: pEt,
    initial: "initial",
    animate: "animate",
    exit: "exit",
    transition: { duration: 0.2 },
    children: t
  },
  e
), mEt = ({
  editor: t,
  onError: e,
  zoomLevel: n,
  setZoomLevel: r,
  isNavbarVisible: i,
  setIsNavbarVisible: a,
  secureImageUploadUrl: o,
  onMarkdownExport: s,
  onMarkdownImport: l,
  onPdfExport: c,
  isLoading: u
}) => {
  var V, F, _, W, G;
  const {
    toolRef: d,
    setToolVisibility: f,
    toolbar: h,
    undoRedoTools: p,
    markdownOptions: m,
    pdfExportOption: g,
    isExportModalOpen: v,
    setIsExportModalOpen: k,
    fileExportsOpen: w,
    setFileExportsOpen: b
  } = RA({
    editor: t,
    onError: e,
    secureImageUploadUrl: o,
    onMarkdownExport: s,
    onMarkdownImport: l,
    onPdfExport: c
  }), x = ja("(max-width: 1480px)"), [A, L] = De("exported_document.md"), M = [
    { title: "Fit", value: "1.4" },
    { title: "50%", value: "0.5" },
    { title: "75%", value: "0.75" },
    { title: "100%", value: "1" },
    { title: "150%", value: "1.5" },
    { title: "200%", value: "2" }
  ], [j, D] = De(!1), z = async () => {
    if (t) {
      const Y = await t.commands.exportMarkdownFile();
      if (Y) {
        const Z = Y, oe = document.createElement("a");
        oe.href = Z, oe.download = A, document.body.appendChild(oe), oe.click(), document.body.removeChild(oe), URL.revokeObjectURL(Z);
      }
    }
    k(!1);
  }, H = (Y) => {
    switch (Y.title) {
      case "Highlight":
        return /* @__PURE__ */ C.jsx(
          LJ,
          {
            setVisibility: f,
            editor: t,
            elementRef: d
          }
        );
      case "Text Color":
        return /* @__PURE__ */ C.jsx(
          jJ,
          {
            editor: t,
            setVisibility: f,
            elementRef: d
          }
        );
      case "Alignment":
        return /* @__PURE__ */ C.jsx(
          TJ,
          {
            setToolVisibility: f,
            editor: t,
            elementRef: d
          }
        );
      case "Link":
        return /* @__PURE__ */ C.jsx(
          EJ,
          {
            setToolVisibility: f,
            editor: t,
            elementRef: d,
            onError: e
          }
        );
      default:
        return null;
    }
  };
  return /* @__PURE__ */ C.jsx(Gp, { mode: "wait", children: /* @__PURE__ */ C.jsxs("div", { className: "w-full bg-transparent py-2 px-4 items-center h-9 flex justify-between relative", children: [
    /* @__PURE__ */ C.jsxs("div", { className: "flex h-9 items-center gap-1 justify-center", children: [
      u ? Fi(
        /* @__PURE__ */ C.jsx(hn, { className: "w-[36px] h-[36px] rounded-sm" }),
        "markdown-transition"
      ) : _i(
        /* @__PURE__ */ C.jsx(
          y9,
          {
            align: "start",
            controlled: !0,
            isOpen: w,
            onClose: () => b(!1),
            anchorTrigger: /* @__PURE__ */ C.jsx(En, { text: "Export/Import", children: /* @__PURE__ */ C.jsx(
              mn,
              {
                icon: "FileExport",
                variant: "ghost",
                size: "md",
                isActive: w,
                className: be(
                  "color-text-default",
                  w && "dark:text-[#363B3F]"
                ),
                onClick: () => {
                  b((Y) => !Y), D(!1);
                }
              }
            ) }),
            content: /* @__PURE__ */ C.jsxs("div", { className: "p-2 flex flex-col gap-1 text-body-sm scroll-smooth color-bg-default shadow-elevation-3 transition-all rounded color-text-default", children: [
              /* @__PURE__ */ C.jsxs("div", { children: [
                /* @__PURE__ */ C.jsx("span", { className: "text-[12px] px-2 font-normal color-text-secondary py-1", children: "PDF" }),
                g.length > 0 && /* @__PURE__ */ C.jsxs(
                  "button",
                  {
                    onClick: () => {
                      var Y;
                      (Y = g[0]) == null || Y.onClick(), b(!1);
                    },
                    className: "hover:color-bg-default-hover h-8 rounded p-2 w-full text-left flex items-center justify-start space-x-2 transition",
                    children: [
                      /* @__PURE__ */ C.jsx(
                        Ye,
                        {
                          name: (V = g[0]) == null ? void 0 : V.icon,
                          className: "w-5 h-5"
                        }
                      ),
                      /* @__PURE__ */ C.jsx("span", { className: "text-sm", children: (F = g[0]) == null ? void 0 : F.title })
                    ]
                  },
                  "pdf-0"
                )
              ] }),
              /* @__PURE__ */ C.jsxs("div", { children: [
                /* @__PURE__ */ C.jsx("span", { className: "text-[12px] px-2 font-normal color-text-secondary py-1", children: "Markdown" }),
                m.map((Y, Z) => /* @__PURE__ */ C.jsxs(
                  "button",
                  {
                    onClick: () => {
                      b(!1), Y == null || Y.onClick();
                    },
                    className: "hover:color-bg-default-hover h-8 rounded p-2 w-full text-left flex items-center justify-start space-x-2 transition",
                    children: [
                      /* @__PURE__ */ C.jsx(
                        Ye,
                        {
                          name: Y == null ? void 0 : Y.icon,
                          className: "w-5 h-5"
                        }
                      ),
                      /* @__PURE__ */ C.jsx("span", { className: "text-sm", children: Y == null ? void 0 : Y.title })
                    ]
                  },
                  Z
                ))
              ] })
            ] })
          },
          "Markdown"
        ),
        "markdown-dropdown-transition"
      ),
      /* @__PURE__ */ C.jsx("div", { className: "w-[1px] h-4 vertical-divider mx-1" }),
      /* @__PURE__ */ C.jsx("div", { className: "flex gap-1 justify-center items-center", children: p.map((Y, Z) => Y ? /* @__PURE__ */ C.jsx(En, { text: Y.title, children: u ? Fi(
        /* @__PURE__ */ C.jsx(
          hn,
          {
            className: "w-[36px] h-[36px] rounded-sm"
          }
        ),
        "redo-skeleton-transition"
      ) : _i(
        /* @__PURE__ */ C.jsx(
          mn,
          {
            className: "disabled:bg-transparent",
            variant: "ghost",
            icon: Y.icon,
            onClick: () => Y.onClick(),
            size: "md",
            disabled: !Y.isActive
          }
        ),
        "redo-tool-transition"
      ) }, Y.title) : /* @__PURE__ */ C.jsx(
        "div",
        {
          className: "w-[1px] h-4 vertical-divider mx-1"
        },
        Z
      )) }),
      u ? Fi(
        /* @__PURE__ */ C.jsx(hn, { className: "w-[80px] h-[36px] rounded-sm" }),
        "zoom-skeleton-transition"
      ) : _i(
        /* @__PURE__ */ C.jsx(
          y9,
          {
            align: "start",
            controlled: !0,
            isOpen: j,
            onClose: () => D(!1),
            anchorTrigger: /* @__PURE__ */ C.jsxs(
              "button",
              {
                className: "bg-transparent hover:!color-bg-default-hover rounded p-2 flex items-center justify-center gap-2 w-20",
                onClick: () => {
                  D((Y) => !Y), b(!1);
                },
                children: [
                  /* @__PURE__ */ C.jsx("span", { className: "text-body-sm line-clamp-1 w-fit", children: ((_ = M.find((Y) => Y.value === n)) == null ? void 0 : _.title) || "100%" }),
                  /* @__PURE__ */ C.jsx(Ye, { name: "ChevronDown", size: "sm" })
                ]
              }
            ),
            content: /* @__PURE__ */ C.jsx("div", { className: "zoom-level-options w-[110px] text-body-sm scroll-smooth color-bg-default px-1 py-2 shadow-elevation-3 transition-all rounded", children: M.map((Y) => /* @__PURE__ */ C.jsx(
              "button",
              {
                className: "hover:color-bg-default-hover h-8 rounded py-1 px-2 w-full text-left flex items-center space-x-2 text-sm color-text-default transition",
                onClick: () => {
                  r(Y.value), D(!1);
                },
                children: Y.title
              },
              Y.title
            )) })
          },
          "zoom-levels"
        ),
        "zoom-dropdown-transition"
      ),
      /* @__PURE__ */ C.jsx("div", { className: "w-[1px] h-4 vertical-divider mx-1" }),
      u ? Fi(
        /* @__PURE__ */ C.jsx(hn, { className: "w-[96px] h-[36px] rounded-sm" }),
        "font-family-skeleton"
      ) : _i(
        /* @__PURE__ */ C.jsx(
          Mi,
          {
            anchorTrigger: /* @__PURE__ */ C.jsxs(
              "button",
              {
                className: "bg-transparent hover:!color-bg-default-hover rounded p-2 flex items-center justify-center gap-2 w-24",
                onClick: () => f(st.FONT_FAMILY),
                children: [
                  /* @__PURE__ */ C.jsx(
                    "span",
                    {
                      className: "text-body-sm line-clamp-1",
                      style: {
                        fontFamily: (W = Mw.find(
                          (Y) => t == null ? void 0 : t.isActive("textStyle", {
                            fontFamily: Y.value
                          })
                        )) == null ? void 0 : W.value
                      },
                      children: ((G = Mw.find(
                        (Y) => t == null ? void 0 : t.isActive("textStyle", {
                          fontFamily: Y.value
                        })
                      )) == null ? void 0 : G.title) || "Font"
                    }
                  ),
                  /* @__PURE__ */ C.jsx(
                    Ye,
                    {
                      name: "ChevronDown",
                      size: "sm",
                      className: "min-w-fit"
                    }
                  )
                ]
              }
            ),
            content: /* @__PURE__ */ C.jsx(
              SMt,
              {
                editor: t,
                elementRef: d,
                setToolVisibility: f
              }
            )
          },
          st.FONT_FAMILY
        ),
        "font-dropdown-transiton"
      ),
      /* @__PURE__ */ C.jsx("div", { className: "w-[1px] h-4 vertical-divider mx-1" }),
      u ? Fi(
        /* @__PURE__ */ C.jsx(hn, { className: "w-[112px] h-[36px] rounded-sm" }),
        "heading-skeleton"
      ) : _i(
        /* @__PURE__ */ C.jsx(
          Mi,
          {
            anchorTrigger: /* @__PURE__ */ C.jsxs(
              "button",
              {
                className: "bg-transparent hover:!color-bg-default-hover rounded gap-2 p-2 flex items-center justify-center w-28",
                onClick: () => f(st.HEADING),
                children: [
                  /* @__PURE__ */ C.jsx("span", { className: "text-body-sm line-clamp-1", children: t != null && t.isActive("heading", { level: 1 }) ? "Heading 1" : t != null && t.isActive("heading", { level: 2 }) ? "Heading 2" : t != null && t.isActive("heading", { level: 3 }) ? "Heading 3" : "Text" }),
                  /* @__PURE__ */ C.jsx(Ye, { name: "ChevronDown", size: "sm" })
                ]
              }
            ),
            content: /* @__PURE__ */ C.jsx(
              TMt,
              {
                setVisibility: f,
                editor: t,
                elementRef: d
              }
            )
          },
          st.HEADING
        ),
        "heading-dropdown"
      ),
      /* @__PURE__ */ C.jsx("div", { className: "w-[1px] h-4 vertical-divider mx-1" }),
      /* @__PURE__ */ C.jsxs("div", { className: "flex gap-2 justify-center items-center", children: [
        h.map((Y, Z) => Y ? Y.title === "Highlight" || Y.title === "Text Color" || Y.title === "Alignment" || Y.title === "Link" ? u ? Fi(
          /* @__PURE__ */ C.jsx(hn, { className: "w-[36px] h-[36px] rounded-sm" }),
          Y.title + "skeleton"
        ) : _i(
          /* @__PURE__ */ C.jsx(
            Mi,
            {
              align: Y.title === "Link" ? "end" : "center",
              anchorTrigger: /* @__PURE__ */ C.jsx(En, { text: Y.title, children: /* @__PURE__ */ C.jsx(
                mn,
                {
                  icon: Y.icon,
                  variant: "ghost",
                  size: "md"
                }
              ) }),
              content: H(Y)
            },
            Y.title
          ),
          Y.title
        ) : Y.group === "More" && x ? h.findIndex((ee) => (ee == null ? void 0 : ee.group) === "More") === Z ? u ? Fi(
          /* @__PURE__ */ C.jsx(hn, { className: "w-[36px] h-[36px] rounded-sm" }),
          Y.title + "loader"
        ) : _i(
          /* @__PURE__ */ C.jsx(
            Mi,
            {
              align: "end",
              anchorTrigger: /* @__PURE__ */ C.jsx(En, { text: "More", children: /* @__PURE__ */ C.jsx(
                mn,
                {
                  icon: "Ellipsis",
                  variant: "ghost",
                  size: "md"
                }
              ) }),
              content: /* @__PURE__ */ C.jsx("div", { className: "flex p-1 gap-1", children: h.filter((ee) => (ee == null ? void 0 : ee.group) === "More").map((ee) => /* @__PURE__ */ C.jsx(
                kr,
                {
                  icon: ee == null ? void 0 : ee.icon,
                  onClick: (ee == null ? void 0 : ee.onClick) || (() => {
                  }),
                  isActive: (ee == null ? void 0 : ee.isActive) || !1
                },
                ee == null ? void 0 : ee.title
              )) })
            },
            "more-dropdown"
          ),
          Y.title
        ) : null : u ? Fi(
          /* @__PURE__ */ C.jsx(hn, { className: "w-[36px] h-[36px] rounded-sm" }),
          Y.title + "skeleton"
        ) : _i(
          /* @__PURE__ */ C.jsx(En, { text: Y.title, children: /* @__PURE__ */ C.jsx(
            kr,
            {
              icon: Y.icon,
              onClick: Y.onClick,
              isActive: Y.isActive
            }
          ) }, Y.title),
          Y.title
        ) : /* @__PURE__ */ C.jsx(
          "div",
          {
            className: "w-[1px] h-4 vertical-divider mx-1"
          },
          Z
        )),
        /* @__PURE__ */ C.jsx(
          PW,
          {
            open: v,
            onOpenChange: k,
            title: "Export Markdown",
            content: /* @__PURE__ */ C.jsx(
              al,
              {
                label: "Filename",
                value: A,
                onChange: (Y) => L(Y.target.value),
                placeholder: "Enter filename"
              }
            ),
            primaryAction: {
              label: "Export",
              onClick: z,
              className: "w-full md:w-auto"
            },
            secondaryAction: {
              label: "Cancel",
              onClick: () => k(!1),
              className: "w-full md:w-auto"
            }
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ C.jsxs("div", { className: "flex items-center gap-1", children: [
      /* @__PURE__ */ C.jsx("div", { className: "w-[1px] h-4 vertical-divider mx-2" }),
      u ? Fi(
        /* @__PURE__ */ C.jsx(hn, { className: "w-[36px] h-[36px] rounded-sm" }),
        "chevronUp-skeleton"
      ) : _i(
        /* @__PURE__ */ C.jsx(
          mn,
          {
            size: "md",
            variant: "ghost",
            icon: i ? "ChevronUp" : "ChevronDown",
            onClick: () => a((Y) => !Y)
          }
        ),
        "chevronUp"
      )
    ] })
  ] }) });
}, ui = () => /* @__PURE__ */ new Map(), Fw = (t) => {
  const e = ui();
  return t.forEach((n, r) => {
    e.set(r, n);
  }), e;
}, Pi = (t, e, n) => {
  let r = t.get(e);
  return r === void 0 && t.set(e, r = n()), r;
}, yEt = (t, e) => {
  const n = [];
  for (const [r, i] of t)
    n.push(e(i, r));
  return n;
}, gEt = (t, e) => {
  for (const [n, r] of t)
    if (e(r, n))
      return !0;
  return !1;
}, vl = () => /* @__PURE__ */ new Set(), qv = (t) => t[t.length - 1], vEt = (t, e) => {
  for (let n = 0; n < e.length; n++)
    t.push(e[n]);
}, bl = Array.from, bEt = (t, e) => {
  for (let n = 0; n < t.length; n++)
    if (e(t[n], n, t))
      return !0;
  return !1;
}, _w = Array.isArray;
class kS {
  constructor() {
    this._observers = ui();
  }
  /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */
  on(e, n) {
    return Pi(
      this._observers,
      /** @type {string} */
      e,
      vl
    ).add(n), n;
  }
  /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */
  once(e, n) {
    const r = (...i) => {
      this.off(
        e,
        /** @type {any} */
        r
      ), n(...i);
    };
    this.on(
      e,
      /** @type {any} */
      r
    );
  }
  /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */
  off(e, n) {
    const r = this._observers.get(e);
    r !== void 0 && (r.delete(n), r.size === 0 && this._observers.delete(e));
  }
  /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name The event name.
   * @param {Parameters<EVENTS[NAME]>} args The arguments that are applied to the event listener.
   */
  emit(e, n) {
    return bl((this._observers.get(e) || ui()).values()).forEach((r) => r(...n));
  }
  destroy() {
    this._observers = ui();
  }
}
class xS {
  constructor() {
    this._observers = ui();
  }
  /**
   * @param {N} name
   * @param {function} f
   */
  on(e, n) {
    Pi(this._observers, e, vl).add(n);
  }
  /**
   * @param {N} name
   * @param {function} f
   */
  once(e, n) {
    const r = (...i) => {
      this.off(e, r), n(...i);
    };
    this.on(e, r);
  }
  /**
   * @param {N} name
   * @param {function} f
   */
  off(e, n) {
    const r = this._observers.get(e);
    r !== void 0 && (r.delete(n), r.size === 0 && this._observers.delete(e));
  }
  /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @param {N} name The event name.
   * @param {Array<any>} args The arguments that are applied to the event listener.
   */
  emit(e, n) {
    return bl((this._observers.get(e) || ui()).values()).forEach((r) => r(...n));
  }
  destroy() {
    this._observers = ui();
  }
}
const co = Math.floor, ey = Math.abs, wEt = Math.log10, $o = (t, e) => t < e ? t : e, uo = (t, e) => t > e ? t : e, yX = (t) => t !== 0 ? t < 0 : 1 / t < 0, ls = Date.now, kEt = 1200, xEt = 2500, g3 = 3e4, Vw = (t) => {
  if (t.shouldConnect && t.ws === null) {
    const e = new WebSocket(t.url), n = t.binaryType;
    let r = null;
    n && (e.binaryType = n), t.ws = e, t.connecting = !0, t.connected = !1, e.onmessage = (o) => {
      t.lastMessageReceived = ls();
      const s = o.data, l = typeof s == "string" ? JSON.parse(s) : s;
      l && l.type === "pong" && (clearTimeout(r), r = setTimeout(a, g3 / 2)), t.emit("message", [l, t]);
    };
    const i = (o) => {
      t.ws !== null && (t.ws = null, t.connecting = !1, t.connected ? (t.connected = !1, t.emit("disconnect", [{ type: "disconnect", error: o }, t])) : t.unsuccessfulReconnects++, setTimeout(Vw, $o(wEt(t.unsuccessfulReconnects + 1) * kEt, xEt), t)), clearTimeout(r);
    }, a = () => {
      t.ws === e && t.send({
        type: "ping"
      });
    };
    e.onclose = () => i(null), e.onerror = (o) => i(o), e.onopen = () => {
      t.lastMessageReceived = ls(), t.connecting = !1, t.connected = !0, t.unsuccessfulReconnects = 0, t.emit("connect", [{ type: "connect" }, t]), r = setTimeout(a, g3 / 2);
    };
  }
};
class MEt extends xS {
  /**
   * @param {string} url
   * @param {object} opts
   * @param {'arraybuffer' | 'blob' | null} [opts.binaryType] Set `ws.binaryType`
   */
  constructor(e, { binaryType: n } = {}) {
    super(), this.url = e, this.ws = null, this.binaryType = n || null, this.connected = !1, this.connecting = !1, this.unsuccessfulReconnects = 0, this.lastMessageReceived = 0, this.shouldConnect = !0, this._checkInterval = setInterval(() => {
      this.connected && g3 < ls() - this.lastMessageReceived && this.ws.close();
    }, g3 / 2), Vw(this);
  }
  /**
   * @param {any} message
   */
  send(e) {
    this.ws && this.ws.send(JSON.stringify(e));
  }
  destroy() {
    clearInterval(this._checkInterval), this.disconnect(), super.destroy();
  }
  disconnect() {
    this.shouldConnect = !1, this.ws !== null && this.ws.close();
  }
  connect() {
    this.shouldConnect = !0, !this.connected && this.ws === null && Vw(this);
  }
}
const fo = (t) => new Error(t), ro = () => {
  throw fo("Method unimplemented");
}, aa = () => {
  throw fo("Unexpected case");
}, cz = 1, uz = 2, Uv = 4, Wv = 8, N2 = 32, Xs = 64, Xi = 128, f5 = 31, qw = 63, Vu = 127, CEt = 2147483647, AEt = crypto.getRandomValues.bind(crypto), gX = Math.random, vX = () => AEt(new Uint32Array(1))[0], SEt = (t) => t[co(gX() * t.length)], LEt = "10000000-1000-4000-8000" + -1e11, bX = () => LEt.replace(
  /[018]/g,
  /** @param {number} c */
  (t) => (t ^ vX() & 15 >> t / 4).toString(16)
), wX = Number.MAX_SAFE_INTEGER, TEt = Number.isInteger || ((t) => typeof t == "number" && isFinite(t) && co(t) === t), EEt = String.fromCharCode, jEt = (t) => t.toLowerCase(), NEt = /^\s*/g, DEt = (t) => t.replace(NEt, ""), IEt = /([A-Z])/g, dz = (t, e) => DEt(t.replace(IEt, (n) => `${e}${jEt(n)}`)), PEt = (t) => {
  const e = unescape(encodeURIComponent(t)), n = e.length, r = new Uint8Array(n);
  for (let i = 0; i < n; i++)
    r[i] = /** @type {number} */
    e.codePointAt(i);
  return r;
}, D2 = (
  /** @type {TextEncoder} */
  typeof TextEncoder < "u" ? new TextEncoder() : null
), zEt = (t) => D2.encode(t), Uw = D2 ? zEt : PEt;
let fh = typeof TextDecoder > "u" ? null : new TextDecoder("utf-8", { fatal: !0, ignoreBOM: !0 });
fh && fh.decode(new Uint8Array()).length === 1 && (fh = null);
class Xp {
  constructor() {
    this.cpos = 0, this.cbuf = new Uint8Array(100), this.bufs = [];
  }
}
const xr = () => new Xp(), REt = (t) => {
  let e = t.cpos;
  for (let n = 0; n < t.bufs.length; n++)
    e += t.bufs[n].length;
  return e;
}, Rn = (t) => {
  const e = new Uint8Array(REt(t));
  let n = 0;
  for (let r = 0; r < t.bufs.length; r++) {
    const i = t.bufs[r];
    e.set(i, n), n += i.length;
  }
  return e.set(new Uint8Array(t.cbuf.buffer, 0, t.cpos), n), e;
}, OEt = (t, e) => {
  const n = t.cbuf.length;
  n - t.cpos < e && (t.bufs.push(new Uint8Array(t.cbuf.buffer, 0, t.cpos)), t.cbuf = new Uint8Array(uo(n, e) * 2), t.cpos = 0);
}, br = (t, e) => {
  const n = t.cbuf.length;
  t.cpos === n && (t.bufs.push(t.cbuf), t.cbuf = new Uint8Array(n * 2), t.cpos = 0), t.cbuf[t.cpos++] = e;
}, I2 = br, bt = (t, e) => {
  for (; e > Vu; )
    br(t, Xi | Vu & e), e = co(e / 128);
  br(t, Vu & e);
}, MS = (t, e) => {
  const n = yX(e);
  for (n && (e = -e), br(t, (e > qw ? Xi : 0) | (n ? Xs : 0) | qw & e), e = co(e / 64); e > 0; )
    br(t, (e > Vu ? Xi : 0) | Vu & e), e = co(e / 128);
}, Ww = new Uint8Array(3e4), BEt = Ww.length / 3, HEt = (t, e) => {
  if (e.length < BEt) {
    const n = D2.encodeInto(e, Ww).written || 0;
    bt(t, n);
    for (let r = 0; r < n; r++)
      br(t, Ww[r]);
  } else
    Gn(t, Uw(e));
}, FEt = (t, e) => {
  const n = unescape(encodeURIComponent(e)), r = n.length;
  bt(t, r);
  for (let i = 0; i < r; i++)
    br(
      t,
      /** @type {number} */
      n.codePointAt(i)
    );
}, Jo = D2 && /** @type {any} */
D2.encodeInto ? HEt : FEt, h5 = (t, e) => {
  const n = t.cbuf.length, r = t.cpos, i = $o(n - r, e.length), a = e.length - i;
  t.cbuf.set(e.subarray(0, i), r), t.cpos += i, a > 0 && (t.bufs.push(t.cbuf), t.cbuf = new Uint8Array(uo(n * 2, a)), t.cbuf.set(e.subarray(i)), t.cpos = a);
}, Gn = (t, e) => {
  bt(t, e.byteLength), h5(t, e);
}, CS = (t, e) => {
  OEt(t, e);
  const n = new DataView(t.cbuf.buffer, t.cpos, e);
  return t.cpos += e, n;
}, _Et = (t, e) => CS(t, 4).setFloat32(0, e, !1), VEt = (t, e) => CS(t, 8).setFloat64(0, e, !1), qEt = (t, e) => (
  /** @type {any} */
  CS(t, 8).setBigInt64(0, e, !1)
), fz = new DataView(new ArrayBuffer(4)), UEt = (t) => (fz.setFloat32(0, t), fz.getFloat32(0) === t), cd = (t, e) => {
  switch (typeof e) {
    case "string":
      br(t, 119), Jo(t, e);
      break;
    case "number":
      TEt(e) && ey(e) <= CEt ? (br(t, 125), MS(t, e)) : UEt(e) ? (br(t, 124), _Et(t, e)) : (br(t, 123), VEt(t, e));
      break;
    case "bigint":
      br(t, 122), qEt(t, e);
      break;
    case "object":
      if (e === null)
        br(t, 126);
      else if (_w(e)) {
        br(t, 117), bt(t, e.length);
        for (let n = 0; n < e.length; n++)
          cd(t, e[n]);
      } else if (e instanceof Uint8Array)
        br(t, 116), Gn(t, e);
      else {
        br(t, 118);
        const n = Object.keys(e);
        bt(t, n.length);
        for (let r = 0; r < n.length; r++) {
          const i = n[r];
          Jo(t, i), cd(t, e[i]);
        }
      }
      break;
    case "boolean":
      br(t, e ? 120 : 121);
      break;
    default:
      br(t, 127);
  }
};
class hz extends Xp {
  /**
   * @param {function(Encoder, T):void} writer
   */
  constructor(e) {
    super(), this.w = e, this.s = null, this.count = 0;
  }
  /**
   * @param {T} v
   */
  write(e) {
    this.s === e ? this.count++ : (this.count > 0 && bt(this, this.count - 1), this.count = 1, this.w(this, e), this.s = e);
  }
}
const pz = (t) => {
  t.count > 0 && (MS(t.encoder, t.count === 1 ? t.s : -t.s), t.count > 1 && bt(t.encoder, t.count - 2));
};
class ty {
  constructor() {
    this.encoder = new Xp(), this.s = 0, this.count = 0;
  }
  /**
   * @param {number} v
   */
  write(e) {
    this.s === e ? this.count++ : (pz(this), this.count = 1, this.s = e);
  }
  /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */
  toUint8Array() {
    return pz(this), Rn(this.encoder);
  }
}
const mz = (t) => {
  if (t.count > 0) {
    const e = t.diff * 2 + (t.count === 1 ? 0 : 1);
    MS(t.encoder, e), t.count > 1 && bt(t.encoder, t.count - 2);
  }
};
class Zv {
  constructor() {
    this.encoder = new Xp(), this.s = 0, this.count = 0, this.diff = 0;
  }
  /**
   * @param {number} v
   */
  write(e) {
    this.diff === e - this.s ? (this.s = e, this.count++) : (mz(this), this.count = 1, this.diff = e - this.s, this.s = e);
  }
  /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */
  toUint8Array() {
    return mz(this), Rn(this.encoder);
  }
}
class WEt {
  constructor() {
    this.sarr = [], this.s = "", this.lensE = new ty();
  }
  /**
   * @param {string} string
   */
  write(e) {
    this.s += e, this.s.length > 19 && (this.sarr.push(this.s), this.s = ""), this.lensE.write(e.length);
  }
  toUint8Array() {
    const e = new Xp();
    return this.sarr.push(this.s), this.s = "", Jo(e, this.sarr.join("")), h5(e, this.lensE.toUint8Array()), Rn(e);
  }
}
const kX = fo("Unexpected end of array"), xX = fo("Integer out of Range");
class p5 {
  /**
   * @param {Uint8Array} uint8Array Binary data to decode
   */
  constructor(e) {
    this.arr = e, this.pos = 0;
  }
}
const ys = (t) => new p5(t), ZEt = (t) => t.pos !== t.arr.length, GEt = (t, e) => {
  const n = new Uint8Array(t.arr.buffer, t.pos + t.arr.byteOffset, e);
  return t.pos += e, n;
}, wr = (t) => GEt(t, Ot(t)), d0 = (t) => t.arr[t.pos++], Ot = (t) => {
  let e = 0, n = 1;
  const r = t.arr.length;
  for (; t.pos < r; ) {
    const i = t.arr[t.pos++];
    if (e = e + (i & Vu) * n, n *= 128, i < Xi)
      return e;
    if (e > wX)
      throw xX;
  }
  throw kX;
}, AS = (t) => {
  let e = t.arr[t.pos++], n = e & qw, r = 64;
  const i = (e & Xs) > 0 ? -1 : 1;
  if (!(e & Xi))
    return i * n;
  const a = t.arr.length;
  for (; t.pos < a; ) {
    if (e = t.arr[t.pos++], n = n + (e & Vu) * r, r *= 128, e < Xi)
      return i * n;
    if (n > wX)
      throw xX;
  }
  throw kX;
}, YEt = (t) => {
  let e = Ot(t);
  if (e === 0)
    return "";
  {
    let n = String.fromCodePoint(d0(t));
    if (--e < 100)
      for (; e--; )
        n += String.fromCodePoint(d0(t));
    else
      for (; e > 0; ) {
        const r = e < 1e4 ? e : 1e4, i = t.arr.subarray(t.pos, t.pos + r);
        t.pos += r, n += String.fromCodePoint.apply(
          null,
          /** @type {any} */
          i
        ), e -= r;
      }
    return decodeURIComponent(escape(n));
  }
}, KEt = (t) => (
  /** @type any */
  fh.decode(wr(t))
), el = fh ? KEt : YEt, SS = (t, e) => {
  const n = new DataView(t.arr.buffer, t.arr.byteOffset + t.pos, e);
  return t.pos += e, n;
}, $Et = (t) => SS(t, 4).getFloat32(0, !1), JEt = (t) => SS(t, 8).getFloat64(0, !1), QEt = (t) => (
  /** @type {any} */
  SS(t, 8).getBigInt64(0, !1)
), XEt = [
  (t) => {
  },
  // CASE 127: undefined
  (t) => null,
  // CASE 126: null
  AS,
  // CASE 125: integer
  $Et,
  // CASE 124: float32
  JEt,
  // CASE 123: float64
  QEt,
  // CASE 122: bigint
  (t) => !1,
  // CASE 121: boolean (false)
  (t) => !0,
  // CASE 120: boolean (true)
  el,
  // CASE 119: string
  (t) => {
    const e = Ot(t), n = {};
    for (let r = 0; r < e; r++) {
      const i = el(t);
      n[i] = ud(t);
    }
    return n;
  },
  (t) => {
    const e = Ot(t), n = [];
    for (let r = 0; r < e; r++)
      n.push(ud(t));
    return n;
  },
  wr
  // CASE 116: Uint8Array
], ud = (t) => XEt[127 - d0(t)](t);
class yz extends p5 {
  /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */
  constructor(e, n) {
    super(e), this.reader = n, this.s = null, this.count = 0;
  }
  read() {
    return this.count === 0 && (this.s = this.reader(this), ZEt(this) ? this.count = Ot(this) + 1 : this.count = -1), this.count--, /** @type {T} */
    this.s;
  }
}
class ny extends p5 {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor(e) {
    super(e), this.s = 0, this.count = 0;
  }
  read() {
    if (this.count === 0) {
      this.s = AS(this);
      const e = yX(this.s);
      this.count = 1, e && (this.s = -this.s, this.count = Ot(this) + 2);
    }
    return this.count--, /** @type {number} */
    this.s;
  }
}
class Gv extends p5 {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor(e) {
    super(e), this.s = 0, this.count = 0, this.diff = 0;
  }
  /**
   * @return {number}
   */
  read() {
    if (this.count === 0) {
      const e = AS(this), n = e & 1;
      this.diff = co(e / 2), this.count = 1, n && (this.count = Ot(this) + 2);
    }
    return this.s += this.diff, this.count--, this.s;
  }
}
class ejt {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor(e) {
    this.decoder = new ny(e), this.str = el(this.decoder), this.spos = 0;
  }
  /**
   * @return {string}
   */
  read() {
    const e = this.spos + this.decoder.read(), n = this.str.slice(this.spos, e);
    return this.spos = e, n;
  }
}
const gz = (t) => t === void 0 ? null : t;
class tjt {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  /**
   * @param {string} key
   * @param {any} newValue
   */
  setItem(e, n) {
    this.map.set(e, n);
  }
  /**
   * @param {string} key
   */
  getItem(e) {
    return this.map.get(e);
  }
}
let MX = new tjt(), LS = !0;
try {
  typeof localStorage < "u" && localStorage && (MX = localStorage, LS = !1);
} catch {
}
const CX = MX, njt = (t) => LS || addEventListener(
  "storage",
  /** @type {any} */
  t
), rjt = (t) => LS || removeEventListener(
  "storage",
  /** @type {any} */
  t
), ijt = Object.assign, TS = Object.keys, ajt = (t, e) => {
  for (const n in t)
    e(t[n], n);
}, vz = (t) => TS(t).length, bz = (t) => TS(t).length, ojt = (t) => {
  for (const e in t)
    return !1;
  return !0;
}, sjt = (t, e) => {
  for (const n in t)
    if (!e(t[n], n))
      return !1;
  return !0;
}, AX = (t, e) => Object.prototype.hasOwnProperty.call(t, e), ljt = (t, e) => t === e || bz(t) === bz(e) && sjt(t, (n, r) => (n !== void 0 || AX(e, r)) && e[r] === n), cjt = Object.freeze, SX = (t) => {
  for (const e in t) {
    const n = t[e];
    (typeof n == "object" || typeof n == "function") && SX(t[e]);
  }
  return cjt(t);
}, ES = (t, e, n = 0) => {
  try {
    for (; n < t.length; n++)
      t[n](...e);
  } finally {
    n < t.length && ES(t, e, n + 1);
  }
}, ujt = () => {
}, djt = (t) => t, fjt = (t, e) => t === e, hh = (t, e) => {
  if (t == null || e == null)
    return fjt(t, e);
  if (t.constructor !== e.constructor)
    return !1;
  if (t === e)
    return !0;
  switch (t.constructor) {
    case ArrayBuffer:
      t = new Uint8Array(t), e = new Uint8Array(e);
    case Uint8Array: {
      if (t.byteLength !== e.byteLength)
        return !1;
      for (let n = 0; n < t.length; n++)
        if (t[n] !== e[n])
          return !1;
      break;
    }
    case Set: {
      if (t.size !== e.size)
        return !1;
      for (const n of t)
        if (!e.has(n))
          return !1;
      break;
    }
    case Map: {
      if (t.size !== e.size)
        return !1;
      for (const n of t.keys())
        if (!e.has(n) || !hh(t.get(n), e.get(n)))
          return !1;
      break;
    }
    case Object:
      if (vz(t) !== vz(e))
        return !1;
      for (const n in t)
        if (!AX(t, n) || !hh(t[n], e[n]))
          return !1;
      break;
    case Array:
      if (t.length !== e.length)
        return !1;
      for (let n = 0; n < t.length; n++)
        if (!hh(t[n], e[n]))
          return !1;
      break;
    default:
      return !1;
  }
  return !0;
}, hjt = (t, e) => e.includes(t), dd = typeof process < "u" && process.release && /node|io\.js/.test(process.release.name) && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]", jS = typeof window < "u" && typeof document < "u" && !dd;
let Lo;
const pjt = () => {
  if (Lo === void 0)
    if (dd) {
      Lo = ui();
      const t = process.argv;
      let e = null;
      for (let n = 0; n < t.length; n++) {
        const r = t[n];
        r[0] === "-" ? (e !== null && Lo.set(e, ""), e = r) : e !== null && (Lo.set(e, r), e = null);
      }
      e !== null && Lo.set(e, "");
    } else typeof location == "object" ? (Lo = ui(), (location.search || "?").slice(1).split("&").forEach((t) => {
      if (t.length !== 0) {
        const [e, n] = t.split("=");
        Lo.set(`--${dz(e, "-")}`, n), Lo.set(`-${dz(e, "-")}`, n);
      }
    })) : Lo = ui();
  return Lo;
}, Zw = (t) => pjt().has(t), P2 = (t) => gz(dd ? process.env[t.toUpperCase().replaceAll("-", "_")] : CX.getItem(t)), LX = (t) => Zw("--" + t) || P2(t) !== null;
LX("production");
const mjt = dd && hjt(process.env.FORCE_COLOR, ["true", "1", "2"]), yjt = mjt || !Zw("--no-colors") && // @todo deprecate --no-colors
!LX("no-color") && (!dd || process.stdout.isTTY) && (!dd || Zw("--color") || P2("COLORTERM") !== null || (P2("TERM") || "").includes("color"));
class gjt {
  /**
   * @param {L} left
   * @param {R} right
   */
  constructor(e, n) {
    this.left = e, this.right = n;
  }
}
const Ts = (t, e) => new gjt(t, e), vjt = (
  /** @type {Document} */
  typeof document < "u" ? document : {}
);
typeof DOMParser < "u" && new DOMParser();
const bjt = (t) => yEt(t, (e, n) => `${n}:${e};`).join(""), wjt = JSON.stringify, kjt = (t) => class {
  /**
   * @param {number} timeoutId
   */
  constructor(n) {
    this._ = n;
  }
  destroy() {
    t(this._);
  }
}, xjt = kjt(clearTimeout), NS = (t, e) => new xjt(setTimeout(e, t)), Sl = Symbol, Sa = Sl(), f0 = Sl(), TX = Sl(), DS = Sl(), EX = Sl(), jX = Sl(), NX = Sl(), m5 = Sl(), y5 = Sl(), Mjt = (t) => {
  var i;
  t.length === 1 && ((i = t[0]) == null ? void 0 : i.constructor) === Function && (t = /** @type {Array<string|Symbol|Object|number>} */
  /** @type {[function]} */
  t[0]());
  const e = [], n = [];
  let r = 0;
  for (; r < t.length; r++) {
    const a = t[r];
    if (a === void 0)
      break;
    if (a.constructor === String || a.constructor === Number)
      e.push(a);
    else if (a.constructor === Object)
      break;
  }
  for (r > 0 && n.push(e.join("")); r < t.length; r++) {
    const a = t[r];
    a instanceof Symbol || n.push(a);
  }
  return n;
}, wz = [EX, NX, m5, TX];
let Yv = 0, kz = ls();
const Cjt = (t, e) => {
  const n = wz[Yv], r = P2("log"), i = r !== null && (r === "*" || r === "true" || new RegExp(r, "gi").test(e));
  return Yv = (Yv + 1) % wz.length, e += ": ", i ? (...a) => {
    var l;
    a.length === 1 && ((l = a[0]) == null ? void 0 : l.constructor) === Function && (a = a[0]());
    const o = ls(), s = o - kz;
    kz = o, t(
      n,
      e,
      y5,
      ...a.map((c) => {
        switch (c != null && c.constructor === Uint8Array && (c = Array.from(c)), typeof c) {
          case "string":
          case "symbol":
            return c;
          default:
            return wjt(c);
        }
      }),
      n,
      " +" + s + "ms"
    );
  } : ujt;
}, Ajt = {
  [Sa]: Ts("font-weight", "bold"),
  [f0]: Ts("font-weight", "normal"),
  [TX]: Ts("color", "blue"),
  [EX]: Ts("color", "green"),
  [DS]: Ts("color", "grey"),
  [jX]: Ts("color", "red"),
  [NX]: Ts("color", "purple"),
  [m5]: Ts("color", "orange"),
  // not well supported in chrome when debugging node with inspector - TODO: deprecate
  [y5]: Ts("color", "black")
}, Sjt = (t) => {
  var o;
  t.length === 1 && ((o = t[0]) == null ? void 0 : o.constructor) === Function && (t = /** @type {Array<string|Symbol|Object|number>} */
  /** @type {[function]} */
  t[0]());
  const e = [], n = [], r = ui();
  let i = [], a = 0;
  for (; a < t.length; a++) {
    const s = t[a], l = Ajt[s];
    if (l !== void 0)
      r.set(l.left, l.right);
    else {
      if (s === void 0)
        break;
      if (s.constructor === String || s.constructor === Number) {
        const c = bjt(r);
        a > 0 || c.length > 0 ? (e.push("%c" + s), n.push(c)) : e.push(s);
      } else
        break;
    }
  }
  for (a > 0 && (i = n, i.unshift(e.join(""))); a < t.length; a++) {
    const s = t[a];
    s instanceof Symbol || i.push(s);
  }
  return i;
}, DX = yjt ? Sjt : Mjt, IX = (...t) => {
  console.log(...DX(t)), zX.forEach((e) => e.print(t));
}, PX = (...t) => {
  console.warn(...DX(t)), t.unshift(m5), zX.forEach((e) => e.print(t));
}, zX = vl(), Ljt = (t) => Cjt(IX, t), fd = (t) => (
  /** @type {Promise<T>} */
  new Promise(t)
);
Promise.all.bind(Promise);
const Tjt = (t) => Promise.reject(t), IS = (t) => Promise.resolve(t), RX = (t) => new Uint8Array(t), Ejt = (t, e, n) => new Uint8Array(t, e, n), jjt = (t) => new Uint8Array(t), Njt = (t) => {
  let e = "";
  for (let n = 0; n < t.byteLength; n++)
    e += EEt(t[n]);
  return btoa(e);
}, Djt = (t) => Buffer.from(t.buffer, t.byteOffset, t.byteLength).toString("base64"), Ijt = (t) => {
  const e = atob(t), n = RX(e.length);
  for (let r = 0; r < e.length; r++)
    n[r] = e.charCodeAt(r);
  return n;
}, Pjt = (t) => {
  const e = Buffer.from(t, "base64");
  return Ejt(e.buffer, e.byteOffset, e.byteLength);
}, OX = jS ? Njt : Djt, BX = jS ? Ijt : Pjt, zjt = (t) => {
  const e = RX(t.byteLength);
  return e.set(t), e;
}, HX = /* @__PURE__ */ new Map();
class Rjt {
  /**
   * @param {string} room
   */
  constructor(e) {
    this.room = e, this.onmessage = null, this._onChange = (n) => n.key === e && this.onmessage !== null && this.onmessage({ data: BX(n.newValue || "") }), njt(this._onChange);
  }
  /**
   * @param {ArrayBuffer} buf
   */
  postMessage(e) {
    CX.setItem(this.room, OX(jjt(e)));
  }
  close() {
    rjt(this._onChange);
  }
}
const Ojt = typeof BroadcastChannel > "u" ? Rjt : BroadcastChannel, PS = (t) => Pi(HX, t, () => {
  const e = vl(), n = new Ojt(t);
  return n.onmessage = (r) => e.forEach((i) => i(r.data, "broadcastchannel")), {
    bc: n,
    subs: e
  };
}), Bjt = (t, e) => (PS(t).subs.add(e), e), Hjt = (t, e) => {
  const n = PS(t), r = n.subs.delete(e);
  return r && n.subs.size === 0 && (n.bc.close(), HX.delete(t)), r;
}, Fjt = (t, e, n = null) => {
  const r = PS(t);
  r.bc.postMessage(e), r.subs.forEach((i) => i(e, n));
}, FX = () => {
  let t = !0;
  return (e, n) => {
    if (t) {
      t = !1;
      try {
        e();
      } finally {
        t = !0;
      }
    } else n !== void 0 && n();
  };
}, _X = (t) => ({
  /**
   * @return {IterableIterator<T>}
   */
  [Symbol.iterator]() {
    return this;
  },
  // @ts-ignore
  next: t
}), _jt = (t, e) => _X(() => {
  let n;
  do
    n = t.next();
  while (!n.done && !e(n.value));
  return n;
}), Kv = (t, e) => _X(() => {
  const { done: n, value: r } = t.next();
  return { done: n, value: n ? void 0 : e(r) };
});
class zS {
  /**
   * @param {number} clock
   * @param {number} len
   */
  constructor(e, n) {
    this.clock = e, this.len = n;
  }
}
class Wd {
  constructor() {
    this.clients = /* @__PURE__ */ new Map();
  }
}
const jc = (t, e, n) => e.clients.forEach((r, i) => {
  const a = (
    /** @type {Array<GC|Item>} */
    t.doc.store.clients.get(i)
  );
  for (let o = 0; o < r.length; o++) {
    const s = r[o];
    tee(t, a, s.clock, s.len, n);
  }
}), Vjt = (t, e) => {
  let n = 0, r = t.length - 1;
  for (; n <= r; ) {
    const i = co((n + r) / 2), a = t[i], o = a.clock;
    if (o <= e) {
      if (e < o + a.len)
        return i;
      n = i + 1;
    } else
      r = i - 1;
  }
  return null;
}, Zd = (t, e) => {
  const n = t.clients.get(e.client);
  return n !== void 0 && Vjt(n, e.clock) !== null;
}, RS = (t) => {
  t.clients.forEach((e) => {
    e.sort((i, a) => i.clock - a.clock);
    let n, r;
    for (n = 1, r = 1; n < e.length; n++) {
      const i = e[r - 1], a = e[n];
      i.clock + i.len >= a.clock ? i.len = uo(i.len, a.clock + a.len - i.clock) : (r < n && (e[r] = a), r++);
    }
    e.length = r;
  });
}, Gw = (t) => {
  const e = new Wd();
  for (let n = 0; n < t.length; n++)
    t[n].clients.forEach((r, i) => {
      if (!e.clients.has(i)) {
        const a = r.slice();
        for (let o = n + 1; o < t.length; o++)
          vEt(a, t[o].clients.get(i) || []);
        e.clients.set(i, a);
      }
    });
  return RS(e), e;
}, z2 = (t, e, n, r) => {
  Pi(t.clients, e, () => (
    /** @type {Array<DeleteItem>} */
    []
  )).push(new zS(n, r));
}, VX = () => new Wd(), qX = (t) => {
  const e = VX();
  return t.clients.forEach((n, r) => {
    const i = [];
    for (let a = 0; a < n.length; a++) {
      const o = n[a];
      if (o.deleted) {
        const s = o.id.clock;
        let l = o.length;
        if (a + 1 < n.length)
          for (let c = n[a + 1]; a + 1 < n.length && c.deleted; c = n[++a + 1])
            l += c.length;
        i.push(new zS(s, l));
      }
    }
    i.length > 0 && e.clients.set(r, i);
  }), e;
}, Gd = (t, e) => {
  bt(t.restEncoder, e.clients.size), bl(e.clients.entries()).sort((n, r) => r[0] - n[0]).forEach(([n, r]) => {
    t.resetDsCurVal(), bt(t.restEncoder, n);
    const i = r.length;
    bt(t.restEncoder, i);
    for (let a = 0; a < i; a++) {
      const o = r[a];
      t.writeDsClock(o.clock), t.writeDsLen(o.len);
    }
  });
}, OS = (t) => {
  const e = new Wd(), n = Ot(t.restDecoder);
  for (let r = 0; r < n; r++) {
    t.resetDsCurVal();
    const i = Ot(t.restDecoder), a = Ot(t.restDecoder);
    if (a > 0) {
      const o = Pi(e.clients, i, () => (
        /** @type {Array<DeleteItem>} */
        []
      ));
      for (let s = 0; s < a; s++)
        o.push(new zS(t.readDsClock(), t.readDsLen()));
    }
  }
  return e;
}, xz = (t, e, n) => {
  const r = new Wd(), i = Ot(t.restDecoder);
  for (let a = 0; a < i; a++) {
    t.resetDsCurVal();
    const o = Ot(t.restDecoder), s = Ot(t.restDecoder), l = n.clients.get(o) || [], c = nr(n, o);
    for (let u = 0; u < s; u++) {
      const d = t.readDsClock(), f = d + t.readDsLen();
      if (d < c) {
        c < f && z2(r, o, c, f - c);
        let h = cs(l, d), p = l[h];
        for (!p.deleted && p.id.clock < d && (l.splice(h + 1, 0, C3(e, p, d - p.id.clock)), h++); h < l.length && (p = l[h++], p.id.clock < f); )
          p.deleted || (f < p.id.clock + p.length && l.splice(h, 0, C3(e, p, f - p.id.clock)), p.delete(e));
      } else
        z2(r, o, d, f - d);
    }
  }
  if (r.clients.size > 0) {
    const a = new h0();
    return bt(a.restEncoder, 0), Gd(a, r), a.toUint8Array();
  }
  return null;
}, UX = vX;
class Ll extends kS {
  /**
   * @param {DocOpts} opts configuration
   */
  constructor({ guid: e = bX(), collectionid: n = null, gc: r = !0, gcFilter: i = () => !0, meta: a = null, autoLoad: o = !1, shouldLoad: s = !0 } = {}) {
    super(), this.gc = r, this.gcFilter = i, this.clientID = UX(), this.guid = e, this.collectionid = n, this.share = /* @__PURE__ */ new Map(), this.store = new XX(), this._transaction = null, this._transactionCleanups = [], this.subdocs = /* @__PURE__ */ new Set(), this._item = null, this.shouldLoad = s, this.autoLoad = o, this.meta = a, this.isLoaded = !1, this.isSynced = !1, this.isDestroyed = !1, this.whenLoaded = fd((c) => {
      this.on("load", () => {
        this.isLoaded = !0, c(this);
      });
    });
    const l = () => fd((c) => {
      const u = (d) => {
        (d === void 0 || d === !0) && (this.off("sync", u), c());
      };
      this.on("sync", u);
    });
    this.on("sync", (c) => {
      c === !1 && this.isSynced && (this.whenSynced = l()), this.isSynced = c === void 0 || c === !0, this.isSynced && !this.isLoaded && this.emit("load", [this]);
    }), this.whenSynced = l();
  }
  /**
   * Notify the parent document that you request to load data into this subdocument (if it is a subdocument).
   *
   * `load()` might be used in the future to request any provider to load the most current data.
   *
   * It is safe to call `load()` multiple times.
   */
  load() {
    const e = this._item;
    e !== null && !this.shouldLoad && pn(
      /** @type {any} */
      e.parent.doc,
      (n) => {
        n.subdocsLoaded.add(this);
      },
      null,
      !0
    ), this.shouldLoad = !0;
  }
  getSubdocs() {
    return this.subdocs;
  }
  getSubdocGuids() {
    return new Set(bl(this.subdocs).map((e) => e.guid));
  }
  /**
   * Changes that happen inside of a transaction are bundled. This means that
   * the observer fires _after_ the transaction is finished and that all changes
   * that happened inside of the transaction are sent as one message to the
   * other peers.
   *
   * @template T
   * @param {function(Transaction):T} f The function that should be executed as a transaction
   * @param {any} [origin] Origin of who started the transaction. Will be stored on transaction.origin
   * @return T
   *
   * @public
   */
  transact(e, n = null) {
    return pn(this, e, n);
  }
  /**
   * Define a shared data type.
   *
   * Multiple calls of `ydoc.get(name, TypeConstructor)` yield the same result
   * and do not overwrite each other. I.e.
   * `ydoc.get(name, Y.Array) === ydoc.get(name, Y.Array)`
   *
   * After this method is called, the type is also available on `ydoc.share.get(name)`.
   *
   * *Best Practices:*
   * Define all types right after the Y.Doc instance is created and store them in a separate object.
   * Also use the typed methods `getText(name)`, `getArray(name)`, ..
   *
   * @template {typeof AbstractType<any>} Type
   * @example
   *   const ydoc = new Y.Doc(..)
   *   const appState = {
   *     document: ydoc.getText('document')
   *     comments: ydoc.getArray('comments')
   *   }
   *
   * @param {string} name
   * @param {Type} TypeConstructor The constructor of the type definition. E.g. Y.Text, Y.Array, Y.Map, ...
   * @return {InstanceType<Type>} The created type. Constructed with TypeConstructor
   *
   * @public
   */
  get(e, n = (
    /** @type {any} */
    Ar
  )) {
    const r = Pi(this.share, e, () => {
      const a = new n();
      return a._integrate(this, null), a;
    }), i = r.constructor;
    if (n !== Ar && i !== n)
      if (i === Ar) {
        const a = new n();
        a._map = r._map, r._map.forEach(
          /** @param {Item?} n */
          (o) => {
            for (; o !== null; o = o.left)
              o.parent = a;
          }
        ), a._start = r._start;
        for (let o = a._start; o !== null; o = o.right)
          o.parent = a;
        return a._length = r._length, this.share.set(e, a), a._integrate(this, null), /** @type {InstanceType<Type>} */
        a;
      } else
        throw new Error(`Type with the name ${e} has already been defined with a different constructor`);
    return (
      /** @type {InstanceType<Type>} */
      r
    );
  }
  /**
   * @template T
   * @param {string} [name]
   * @return {YArray<T>}
   *
   * @public
   */
  getArray(e = "") {
    return (
      /** @type {YArray<T>} */
      this.get(e, S1)
    );
  }
  /**
   * @param {string} [name]
   * @return {YText}
   *
   * @public
   */
  getText(e = "") {
    return this.get(e, Nc);
  }
  /**
   * @template T
   * @param {string} [name]
   * @return {YMap<T>}
   *
   * @public
   */
  getMap(e = "") {
    return (
      /** @type {YMap<T>} */
      this.get(e, pd)
    );
  }
  /**
   * @param {string} [name]
   * @return {YXmlElement}
   *
   * @public
   */
  getXmlElement(e = "") {
    return (
      /** @type {YXmlElement<{[key:string]:string}>} */
      this.get(e, si)
    );
  }
  /**
   * @param {string} [name]
   * @return {YXmlFragment}
   *
   * @public
   */
  getXmlFragment(e = "") {
    return this.get(e, m0);
  }
  /**
   * Converts the entire document into a js object, recursively traversing each yjs type
   * Doesn't log types that have not been defined (using ydoc.getType(..)).
   *
   * @deprecated Do not use this method and rather call toJSON directly on the shared types.
   *
   * @return {Object<string, any>}
   */
  toJSON() {
    const e = {};
    return this.share.forEach((n, r) => {
      e[r] = n.toJSON();
    }), e;
  }
  /**
   * Emit `destroy` event and unregister all event handlers.
   */
  destroy() {
    this.isDestroyed = !0, bl(this.subdocs).forEach((n) => n.destroy());
    const e = this._item;
    if (e !== null) {
      this._item = null;
      const n = (
        /** @type {ContentDoc} */
        e.content
      );
      n.doc = new Ll({ guid: this.guid, ...n.opts, shouldLoad: !1 }), n.doc._item = e, pn(
        /** @type {any} */
        e.parent.doc,
        (r) => {
          const i = n.doc;
          e.deleted || r.subdocsAdded.add(i), r.subdocsRemoved.add(this);
        },
        null,
        !0
      );
    }
    this.emit("destroyed", [!0]), this.emit("destroy", [this]), super.destroy();
  }
}
class WX {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor(e) {
    this.restDecoder = e;
  }
  resetDsCurVal() {
  }
  /**
   * @return {number}
   */
  readDsClock() {
    return Ot(this.restDecoder);
  }
  /**
   * @return {number}
   */
  readDsLen() {
    return Ot(this.restDecoder);
  }
}
class ZX extends WX {
  /**
   * @return {ID}
   */
  readLeftID() {
    return Bt(Ot(this.restDecoder), Ot(this.restDecoder));
  }
  /**
   * @return {ID}
   */
  readRightID() {
    return Bt(Ot(this.restDecoder), Ot(this.restDecoder));
  }
  /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */
  readClient() {
    return Ot(this.restDecoder);
  }
  /**
   * @return {number} info An unsigned 8-bit integer
   */
  readInfo() {
    return d0(this.restDecoder);
  }
  /**
   * @return {string}
   */
  readString() {
    return el(this.restDecoder);
  }
  /**
   * @return {boolean} isKey
   */
  readParentInfo() {
    return Ot(this.restDecoder) === 1;
  }
  /**
   * @return {number} info An unsigned 8-bit integer
   */
  readTypeRef() {
    return Ot(this.restDecoder);
  }
  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number} len
   */
  readLen() {
    return Ot(this.restDecoder);
  }
  /**
   * @return {any}
   */
  readAny() {
    return ud(this.restDecoder);
  }
  /**
   * @return {Uint8Array}
   */
  readBuf() {
    return zjt(wr(this.restDecoder));
  }
  /**
   * Legacy implementation uses JSON parse. We use any-decoding in v2.
   *
   * @return {any}
   */
  readJSON() {
    return JSON.parse(el(this.restDecoder));
  }
  /**
   * @return {string}
   */
  readKey() {
    return el(this.restDecoder);
  }
}
class qjt {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor(e) {
    this.dsCurrVal = 0, this.restDecoder = e;
  }
  resetDsCurVal() {
    this.dsCurrVal = 0;
  }
  /**
   * @return {number}
   */
  readDsClock() {
    return this.dsCurrVal += Ot(this.restDecoder), this.dsCurrVal;
  }
  /**
   * @return {number}
   */
  readDsLen() {
    const e = Ot(this.restDecoder) + 1;
    return this.dsCurrVal += e, e;
  }
}
class hd extends qjt {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor(e) {
    super(e), this.keys = [], Ot(e), this.keyClockDecoder = new Gv(wr(e)), this.clientDecoder = new ny(wr(e)), this.leftClockDecoder = new Gv(wr(e)), this.rightClockDecoder = new Gv(wr(e)), this.infoDecoder = new yz(wr(e), d0), this.stringDecoder = new ejt(wr(e)), this.parentInfoDecoder = new yz(wr(e), d0), this.typeRefDecoder = new ny(wr(e)), this.lenDecoder = new ny(wr(e));
  }
  /**
   * @return {ID}
   */
  readLeftID() {
    return new C1(this.clientDecoder.read(), this.leftClockDecoder.read());
  }
  /**
   * @return {ID}
   */
  readRightID() {
    return new C1(this.clientDecoder.read(), this.rightClockDecoder.read());
  }
  /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */
  readClient() {
    return this.clientDecoder.read();
  }
  /**
   * @return {number} info An unsigned 8-bit integer
   */
  readInfo() {
    return (
      /** @type {number} */
      this.infoDecoder.read()
    );
  }
  /**
   * @return {string}
   */
  readString() {
    return this.stringDecoder.read();
  }
  /**
   * @return {boolean}
   */
  readParentInfo() {
    return this.parentInfoDecoder.read() === 1;
  }
  /**
   * @return {number} An unsigned 8-bit integer
   */
  readTypeRef() {
    return this.typeRefDecoder.read();
  }
  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number}
   */
  readLen() {
    return this.lenDecoder.read();
  }
  /**
   * @return {any}
   */
  readAny() {
    return ud(this.restDecoder);
  }
  /**
   * @return {Uint8Array}
   */
  readBuf() {
    return wr(this.restDecoder);
  }
  /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @return {any}
   */
  readJSON() {
    return ud(this.restDecoder);
  }
  /**
   * @return {string}
   */
  readKey() {
    const e = this.keyClockDecoder.read();
    if (e < this.keys.length)
      return this.keys[e];
    {
      const n = this.stringDecoder.read();
      return this.keys.push(n), n;
    }
  }
}
class GX {
  constructor() {
    this.restEncoder = xr();
  }
  toUint8Array() {
    return Rn(this.restEncoder);
  }
  resetDsCurVal() {
  }
  /**
   * @param {number} clock
   */
  writeDsClock(e) {
    bt(this.restEncoder, e);
  }
  /**
   * @param {number} len
   */
  writeDsLen(e) {
    bt(this.restEncoder, e);
  }
}
class em extends GX {
  /**
   * @param {ID} id
   */
  writeLeftID(e) {
    bt(this.restEncoder, e.client), bt(this.restEncoder, e.clock);
  }
  /**
   * @param {ID} id
   */
  writeRightID(e) {
    bt(this.restEncoder, e.client), bt(this.restEncoder, e.clock);
  }
  /**
   * Use writeClient and writeClock instead of writeID if possible.
   * @param {number} client
   */
  writeClient(e) {
    bt(this.restEncoder, e);
  }
  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeInfo(e) {
    I2(this.restEncoder, e);
  }
  /**
   * @param {string} s
   */
  writeString(e) {
    Jo(this.restEncoder, e);
  }
  /**
   * @param {boolean} isYKey
   */
  writeParentInfo(e) {
    bt(this.restEncoder, e ? 1 : 0);
  }
  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeTypeRef(e) {
    bt(this.restEncoder, e);
  }
  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */
  writeLen(e) {
    bt(this.restEncoder, e);
  }
  /**
   * @param {any} any
   */
  writeAny(e) {
    cd(this.restEncoder, e);
  }
  /**
   * @param {Uint8Array} buf
   */
  writeBuf(e) {
    Gn(this.restEncoder, e);
  }
  /**
   * @param {any} embed
   */
  writeJSON(e) {
    Jo(this.restEncoder, JSON.stringify(e));
  }
  /**
   * @param {string} key
   */
  writeKey(e) {
    Jo(this.restEncoder, e);
  }
}
class YX {
  constructor() {
    this.restEncoder = xr(), this.dsCurrVal = 0;
  }
  toUint8Array() {
    return Rn(this.restEncoder);
  }
  resetDsCurVal() {
    this.dsCurrVal = 0;
  }
  /**
   * @param {number} clock
   */
  writeDsClock(e) {
    const n = e - this.dsCurrVal;
    this.dsCurrVal = e, bt(this.restEncoder, n);
  }
  /**
   * @param {number} len
   */
  writeDsLen(e) {
    e === 0 && aa(), bt(this.restEncoder, e - 1), this.dsCurrVal += e;
  }
}
class h0 extends YX {
  constructor() {
    super(), this.keyMap = /* @__PURE__ */ new Map(), this.keyClock = 0, this.keyClockEncoder = new Zv(), this.clientEncoder = new ty(), this.leftClockEncoder = new Zv(), this.rightClockEncoder = new Zv(), this.infoEncoder = new hz(I2), this.stringEncoder = new WEt(), this.parentInfoEncoder = new hz(I2), this.typeRefEncoder = new ty(), this.lenEncoder = new ty();
  }
  toUint8Array() {
    const e = xr();
    return bt(e, 0), Gn(e, this.keyClockEncoder.toUint8Array()), Gn(e, this.clientEncoder.toUint8Array()), Gn(e, this.leftClockEncoder.toUint8Array()), Gn(e, this.rightClockEncoder.toUint8Array()), Gn(e, Rn(this.infoEncoder)), Gn(e, this.stringEncoder.toUint8Array()), Gn(e, Rn(this.parentInfoEncoder)), Gn(e, this.typeRefEncoder.toUint8Array()), Gn(e, this.lenEncoder.toUint8Array()), h5(e, Rn(this.restEncoder)), Rn(e);
  }
  /**
   * @param {ID} id
   */
  writeLeftID(e) {
    this.clientEncoder.write(e.client), this.leftClockEncoder.write(e.clock);
  }
  /**
   * @param {ID} id
   */
  writeRightID(e) {
    this.clientEncoder.write(e.client), this.rightClockEncoder.write(e.clock);
  }
  /**
   * @param {number} client
   */
  writeClient(e) {
    this.clientEncoder.write(e);
  }
  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeInfo(e) {
    this.infoEncoder.write(e);
  }
  /**
   * @param {string} s
   */
  writeString(e) {
    this.stringEncoder.write(e);
  }
  /**
   * @param {boolean} isYKey
   */
  writeParentInfo(e) {
    this.parentInfoEncoder.write(e ? 1 : 0);
  }
  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeTypeRef(e) {
    this.typeRefEncoder.write(e);
  }
  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */
  writeLen(e) {
    this.lenEncoder.write(e);
  }
  /**
   * @param {any} any
   */
  writeAny(e) {
    cd(this.restEncoder, e);
  }
  /**
   * @param {Uint8Array} buf
   */
  writeBuf(e) {
    Gn(this.restEncoder, e);
  }
  /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @param {any} embed
   */
  writeJSON(e) {
    cd(this.restEncoder, e);
  }
  /**
   * Property keys are often reused. For example, in y-prosemirror the key `bold` might
   * occur very often. For a 3d application, the key `position` might occur very often.
   *
   * We cache these keys in a Map and refer to them via a unique number.
   *
   * @param {string} key
   */
  writeKey(e) {
    const n = this.keyMap.get(e);
    n === void 0 ? (this.keyClockEncoder.write(this.keyClock++), this.stringEncoder.write(e)) : this.keyClockEncoder.write(n);
  }
}
const Ujt = (t, e, n, r) => {
  r = uo(r, e[0].id.clock);
  const i = cs(e, r);
  bt(t.restEncoder, e.length - i), t.writeClient(n), bt(t.restEncoder, r);
  const a = e[i];
  a.write(t, r - a.id.clock);
  for (let o = i + 1; o < e.length; o++)
    e[o].write(t, 0);
}, BS = (t, e, n) => {
  const r = /* @__PURE__ */ new Map();
  n.forEach((i, a) => {
    nr(e, a) > i && r.set(a, i);
  }), nm(e).forEach((i, a) => {
    n.has(a) || r.set(a, 0);
  }), bt(t.restEncoder, r.size), bl(r.entries()).sort((i, a) => a[0] - i[0]).forEach(([i, a]) => {
    Ujt(
      t,
      /** @type {Array<GC|Item>} */
      e.clients.get(i),
      i,
      a
    );
  });
}, Wjt = (t, e) => {
  const n = ui(), r = Ot(t.restDecoder);
  for (let i = 0; i < r; i++) {
    const a = Ot(t.restDecoder), o = new Array(a), s = t.readClient();
    let l = Ot(t.restDecoder);
    n.set(s, { i: 0, refs: o });
    for (let c = 0; c < a; c++) {
      const u = t.readInfo();
      switch (f5 & u) {
        case 0: {
          const d = t.readLen();
          o[c] = new xa(Bt(s, l), d), l += d;
          break;
        }
        case 10: {
          const d = Ot(t.restDecoder);
          o[c] = new Ma(Bt(s, l), d), l += d;
          break;
        }
        default: {
          const d = (u & (Xs | Xi)) === 0, f = new wn(
            Bt(s, l),
            null,
            // left
            (u & Xi) === Xi ? t.readLeftID() : null,
            // origin
            null,
            // right
            (u & Xs) === Xs ? t.readRightID() : null,
            // right origin
            d ? t.readParentInfo() ? e.get(t.readString()) : t.readLeftID() : null,
            // parent
            d && (u & N2) === N2 ? t.readString() : null,
            // parentSub
            Mee(t, u)
            // item content
          );
          o[c] = f, l += f.length;
        }
      }
    }
  }
  return n;
}, Zjt = (t, e, n) => {
  const r = [];
  let i = bl(n.keys()).sort((h, p) => h - p);
  if (i.length === 0)
    return null;
  const a = () => {
    if (i.length === 0)
      return null;
    let h = (
      /** @type {{i:number,refs:Array<GC|Item>}} */
      n.get(i[i.length - 1])
    );
    for (; h.refs.length === h.i; )
      if (i.pop(), i.length > 0)
        h = /** @type {{i:number,refs:Array<GC|Item>}} */
        n.get(i[i.length - 1]);
      else
        return null;
    return h;
  };
  let o = a();
  if (o === null)
    return null;
  const s = new XX(), l = /* @__PURE__ */ new Map(), c = (h, p) => {
    const m = l.get(h);
    (m == null || m > p) && l.set(h, p);
  };
  let u = (
    /** @type {any} */
    o.refs[
      /** @type {any} */
      o.i++
    ]
  );
  const d = /* @__PURE__ */ new Map(), f = () => {
    for (const h of r) {
      const p = h.id.client, m = n.get(p);
      m ? (m.i--, s.clients.set(p, m.refs.slice(m.i)), n.delete(p), m.i = 0, m.refs = []) : s.clients.set(p, [h]), i = i.filter((g) => g !== p);
    }
    r.length = 0;
  };
  for (; ; ) {
    if (u.constructor !== Ma) {
      const p = Pi(d, u.id.client, () => nr(e, u.id.client)) - u.id.clock;
      if (p < 0)
        r.push(u), c(u.id.client, u.id.clock - 1), f();
      else {
        const m = u.getMissing(t, e);
        if (m !== null) {
          r.push(u);
          const g = n.get(
            /** @type {number} */
            m
          ) || { refs: [], i: 0 };
          if (g.refs.length === g.i)
            c(
              /** @type {number} */
              m,
              nr(e, m)
            ), f();
          else {
            u = g.refs[g.i++];
            continue;
          }
        } else (p === 0 || p < u.length) && (u.integrate(t, p), d.set(u.id.client, u.id.clock + u.length));
      }
    }
    if (r.length > 0)
      u = /** @type {GC|Item} */
      r.pop();
    else if (o !== null && o.i < o.refs.length)
      u = /** @type {GC|Item} */
      o.refs[o.i++];
    else {
      if (o = a(), o === null)
        break;
      u = /** @type {GC|Item} */
      o.refs[o.i++];
    }
  }
  if (s.clients.size > 0) {
    const h = new h0();
    return BS(h, s, /* @__PURE__ */ new Map()), bt(h.restEncoder, 0), { missing: l, update: h.toUint8Array() };
  }
  return null;
}, Gjt = (t, e) => BS(t, e.doc.store, e.beforeState), Yjt = (t, e, n, r = new hd(t)) => pn(e, (i) => {
  i.local = !1;
  let a = !1;
  const o = i.doc, s = o.store, l = Wjt(r, o), c = Zjt(i, s, l), u = s.pendingStructs;
  if (u) {
    for (const [f, h] of u.missing)
      if (h < nr(s, f)) {
        a = !0;
        break;
      }
    if (c) {
      for (const [f, h] of c.missing) {
        const p = u.missing.get(f);
        (p == null || p > h) && u.missing.set(f, h);
      }
      u.update = b3([u.update, c.update]);
    }
  } else
    s.pendingStructs = c;
  const d = xz(r, i, s);
  if (s.pendingDs) {
    const f = new hd(ys(s.pendingDs));
    Ot(f.restDecoder);
    const h = xz(f, i, s);
    d && h ? s.pendingDs = b3([d, h]) : s.pendingDs = d || h;
  } else
    s.pendingDs = d;
  if (a) {
    const f = (
      /** @type {{update: Uint8Array}} */
      s.pendingStructs.update
    );
    s.pendingStructs = null, v3(i.doc, f);
  }
}, n, !1), v3 = (t, e, n, r = hd) => {
  const i = ys(e);
  Yjt(i, t, n, new r(i));
}, p0 = (t, e, n) => v3(t, e, n, ZX), Kjt = (t, e, n = /* @__PURE__ */ new Map()) => {
  BS(t, e.store, n), Gd(t, qX(e.store));
}, $jt = (t, e = new Uint8Array([0]), n = new h0()) => {
  const r = KX(e);
  Kjt(n, t, r);
  const i = [n.toUint8Array()];
  if (t.store.pendingDs && i.push(t.store.pendingDs), t.store.pendingStructs && i.push(pNt(t.store.pendingStructs.update, e)), i.length > 1) {
    if (n.constructor === em)
      return H2(i.map((a, o) => o === 0 ? a : yNt(a)));
    if (n.constructor === h0)
      return b3(i);
  }
  return i[0];
}, tm = (t, e) => $jt(t, e, new em()), Jjt = (t) => {
  const e = /* @__PURE__ */ new Map(), n = Ot(t.restDecoder);
  for (let r = 0; r < n; r++) {
    const i = Ot(t.restDecoder), a = Ot(t.restDecoder);
    e.set(i, a);
  }
  return e;
}, KX = (t) => Jjt(new WX(ys(t))), $X = (t, e) => (bt(t.restEncoder, e.size), bl(e.entries()).sort((n, r) => r[0] - n[0]).forEach(([n, r]) => {
  bt(t.restEncoder, n), bt(t.restEncoder, r);
}), t), Qjt = (t, e) => $X(t, nm(e.store)), Xjt = (t, e = new YX()) => (t instanceof Map ? $X(e, t) : Qjt(e, t), e.toUint8Array()), eNt = (t) => Xjt(t, new GX());
class tNt {
  constructor() {
    this.l = [];
  }
}
const Mz = () => new tNt(), Cz = (t, e) => t.l.push(e), Az = (t, e) => {
  const n = t.l, r = n.length;
  t.l = n.filter((i) => e !== i), r === t.l.length && console.error("[yjs] Tried to remove event handler that doesn't exist.");
}, JX = (t, e, n) => ES(t.l, [e, n]);
class C1 {
  /**
   * @param {number} client client id
   * @param {number} clock unique per client id, continuous number
   */
  constructor(e, n) {
    this.client = e, this.clock = n;
  }
}
const p1 = (t, e) => t === e || t !== null && e !== null && t.client === e.client && t.clock === e.clock, Bt = (t, e) => new C1(t, e), R2 = (t) => {
  for (const [e, n] of t.doc.share.entries())
    if (n === t)
      return e;
  throw aa();
}, O2 = (t, e) => {
  for (; e !== null; ) {
    if (e.parent === t)
      return !0;
    e = /** @type {AbstractType<any>} */
    e.parent._item;
  }
  return !1;
};
class B2 {
  /**
   * @param {ID|null} type
   * @param {string|null} tname
   * @param {ID|null} item
   * @param {number} assoc
   */
  constructor(e, n, r, i = 0) {
    this.type = e, this.tname = n, this.item = r, this.assoc = i;
  }
}
const ph = (t) => new B2(t.type == null ? null : Bt(t.type.client, t.type.clock), t.tname ?? null, t.item == null ? null : Bt(t.item.client, t.item.clock), t.assoc == null ? 0 : t.assoc);
class nNt {
  /**
   * @param {AbstractType<any>} type
   * @param {number} index
   * @param {number} [assoc]
   */
  constructor(e, n, r = 0) {
    this.type = e, this.index = n, this.assoc = r;
  }
}
const rNt = (t, e, n = 0) => new nNt(t, e, n), r4 = (t, e, n) => {
  let r = null, i = null;
  return t._item === null ? i = R2(t) : r = Bt(t._item.id.client, t._item.id.clock), new B2(r, i, e, n);
}, $v = (t, e, n = 0) => {
  let r = t._start;
  if (n < 0) {
    if (e === 0)
      return r4(t, null, n);
    e--;
  }
  for (; r !== null; ) {
    if (!r.deleted && r.countable) {
      if (r.length > e)
        return r4(t, Bt(r.id.client, r.id.clock + e), n);
      e -= r.length;
    }
    if (r.right === null && n < 0)
      return r4(t, r.lastId, n);
    r = r.right;
  }
  return r4(t, null, n);
}, iNt = (t, e) => {
  const n = A1(t, e), r = e.clock - n.id.clock;
  return {
    item: n,
    diff: r
  };
}, aNt = (t, e, n = !0) => {
  const r = e.store, i = t.item, a = t.type, o = t.tname, s = t.assoc;
  let l = null, c = 0;
  if (i !== null) {
    if (nr(r, i.client) <= i.clock)
      return null;
    const u = n ? Jw(r, i) : iNt(r, i), d = u.item;
    if (!(d instanceof wn))
      return null;
    if (l = /** @type {AbstractType<any>} */
    d.parent, l._item === null || !l._item.deleted) {
      c = d.deleted || !d.countable ? 0 : u.diff + (s >= 0 ? 0 : 1);
      let f = d.left;
      for (; f !== null; )
        !f.deleted && f.countable && (c += f.length), f = f.left;
    }
  } else {
    if (o !== null)
      l = e.get(o);
    else if (a !== null) {
      if (nr(r, a.client) <= a.clock)
        return null;
      const { item: u } = n ? Jw(r, a) : { item: A1(r, a) };
      if (u instanceof wn && u.content instanceof ko)
        l = u.content.type;
      else
        return null;
    } else
      throw aa();
    s >= 0 ? c = l._length : c = 0;
  }
  return rNt(l, c, t.assoc);
}, Sz = (t, e) => t === e || t !== null && e !== null && t.tname === e.tname && p1(t.item, e.item) && p1(t.type, e.type) && t.assoc === e.assoc;
class HS {
  /**
   * @param {DeleteSet} ds
   * @param {Map<number,number>} sv state map
   */
  constructor(e, n) {
    this.ds = e, this.sv = n;
  }
}
const QX = (t, e) => new HS(t, e), Jv = (t) => QX(qX(t.store), nm(t.store)), bu = (t, e) => e === void 0 ? !t.deleted : e.sv.has(t.id.client) && (e.sv.get(t.id.client) || 0) > t.id.clock && !Zd(e.ds, t.id), Yw = (t, e) => {
  const n = Pi(t.meta, Yw, vl), r = t.doc.store;
  n.has(e) || (e.sv.forEach((i, a) => {
    i < nr(r, a) && Ai(t, Bt(a, i));
  }), jc(t, e.ds, (i) => {
  }), n.add(e));
};
class XX {
  constructor() {
    this.clients = /* @__PURE__ */ new Map(), this.pendingStructs = null, this.pendingDs = null;
  }
}
const nm = (t) => {
  const e = /* @__PURE__ */ new Map();
  return t.clients.forEach((n, r) => {
    const i = n[n.length - 1];
    e.set(r, i.id.clock + i.length);
  }), e;
}, nr = (t, e) => {
  const n = t.clients.get(e);
  if (n === void 0)
    return 0;
  const r = n[n.length - 1];
  return r.id.clock + r.length;
}, eee = (t, e) => {
  let n = t.clients.get(e.id.client);
  if (n === void 0)
    n = [], t.clients.set(e.id.client, n);
  else {
    const r = n[n.length - 1];
    if (r.id.clock + r.length !== e.id.clock)
      throw aa();
  }
  n.push(e);
}, cs = (t, e) => {
  let n = 0, r = t.length - 1, i = t[r], a = i.id.clock;
  if (a === e)
    return r;
  let o = co(e / (a + i.length - 1) * r);
  for (; n <= r; ) {
    if (i = t[o], a = i.id.clock, a <= e) {
      if (e < a + i.length)
        return o;
      n = o + 1;
    } else
      r = o - 1;
    o = co((n + r) / 2);
  }
  throw aa();
}, oNt = (t, e) => {
  const n = t.clients.get(e.client);
  return n[cs(n, e.clock)];
}, A1 = (
  /** @type {function(StructStore,ID):Item} */
  oNt
), Kw = (t, e, n) => {
  const r = cs(e, n), i = e[r];
  return i.id.clock < n && i instanceof wn ? (e.splice(r + 1, 0, C3(t, i, n - i.id.clock)), r + 1) : r;
}, Ai = (t, e) => {
  const n = (
    /** @type {Array<Item>} */
    t.doc.store.clients.get(e.client)
  );
  return n[Kw(t, n, e.clock)];
}, Lz = (t, e, n) => {
  const r = e.clients.get(n.client), i = cs(r, n.clock), a = r[i];
  return n.clock !== a.id.clock + a.length - 1 && a.constructor !== xa && r.splice(i + 1, 0, C3(t, a, n.clock - a.id.clock + 1)), a;
}, sNt = (t, e, n) => {
  const r = (
    /** @type {Array<GC|Item>} */
    t.clients.get(e.id.client)
  );
  r[cs(r, e.id.clock)] = n;
}, tee = (t, e, n, r, i) => {
  if (r === 0)
    return;
  const a = n + r;
  let o = Kw(t, e, n), s;
  do
    s = e[o++], a < s.id.clock + s.length && Kw(t, e, a), i(s);
  while (o < e.length && e[o].id.clock < a);
};
class lNt {
  /**
   * @param {Doc} doc
   * @param {any} origin
   * @param {boolean} local
   */
  constructor(e, n, r) {
    this.doc = e, this.deleteSet = new Wd(), this.beforeState = nm(e.store), this.afterState = /* @__PURE__ */ new Map(), this.changed = /* @__PURE__ */ new Map(), this.changedParentTypes = /* @__PURE__ */ new Map(), this._mergeStructs = [], this.origin = n, this.meta = /* @__PURE__ */ new Map(), this.local = r, this.subdocsAdded = /* @__PURE__ */ new Set(), this.subdocsRemoved = /* @__PURE__ */ new Set(), this.subdocsLoaded = /* @__PURE__ */ new Set(), this._needFormattingCleanup = !1;
  }
}
const Tz = (t, e) => e.deleteSet.clients.size === 0 && !gEt(e.afterState, (n, r) => e.beforeState.get(r) !== n) ? !1 : (RS(e.deleteSet), Gjt(t, e), Gd(t, e.deleteSet), !0), Ez = (t, e, n) => {
  const r = e._item;
  (r === null || r.id.clock < (t.beforeState.get(r.id.client) || 0) && !r.deleted) && Pi(t.changed, e, vl).add(n);
}, ry = (t, e) => {
  let n = t[e], r = t[e - 1], i = e;
  for (; i > 0; n = r, r = t[--i - 1]) {
    if (r.deleted === n.deleted && r.constructor === n.constructor && r.mergeWith(n)) {
      n instanceof wn && n.parentSub !== null && /** @type {AbstractType<any>} */
      n.parent._map.get(n.parentSub) === n && n.parent._map.set(
        n.parentSub,
        /** @type {Item} */
        r
      );
      continue;
    }
    break;
  }
  const a = e - i;
  return a && t.splice(e + 1 - a, a), a;
}, cNt = (t, e, n) => {
  for (const [r, i] of t.clients.entries()) {
    const a = (
      /** @type {Array<GC|Item>} */
      e.clients.get(r)
    );
    for (let o = i.length - 1; o >= 0; o--) {
      const s = i[o], l = s.clock + s.len;
      for (let c = cs(a, s.clock), u = a[c]; c < a.length && u.id.clock < l; u = a[++c]) {
        const d = a[c];
        if (s.clock + s.len <= d.id.clock)
          break;
        d instanceof wn && d.deleted && !d.keep && n(d) && d.gc(e, !1);
      }
    }
  }
}, uNt = (t, e) => {
  t.clients.forEach((n, r) => {
    const i = (
      /** @type {Array<GC|Item>} */
      e.clients.get(r)
    );
    for (let a = n.length - 1; a >= 0; a--) {
      const o = n[a], s = $o(i.length - 1, 1 + cs(i, o.clock + o.len - 1));
      for (let l = s, c = i[l]; l > 0 && c.id.clock >= o.clock; c = i[l])
        l -= 1 + ry(i, l);
    }
  });
}, nee = (t, e) => {
  if (e < t.length) {
    const n = t[e], r = n.doc, i = r.store, a = n.deleteSet, o = n._mergeStructs;
    try {
      RS(a), n.afterState = nm(n.doc.store), r.emit("beforeObserverCalls", [n, r]);
      const s = [];
      n.changed.forEach(
        (l, c) => s.push(() => {
          (c._item === null || !c._item.deleted) && c._callObserver(n, l);
        })
      ), s.push(() => {
        n.changedParentTypes.forEach((l, c) => {
          c._dEH.l.length > 0 && (c._item === null || !c._item.deleted) && (l = l.filter(
            (u) => u.target._item === null || !u.target._item.deleted
          ), l.forEach((u) => {
            u.currentTarget = c, u._path = null;
          }), l.sort((u, d) => u.path.length - d.path.length), JX(c._dEH, l, n));
        });
      }), s.push(() => r.emit("afterTransaction", [n, r])), ES(s, []), n._needFormattingCleanup && jNt(n);
    } finally {
      r.gc && cNt(a, i, r.gcFilter), uNt(a, i), n.afterState.forEach((u, d) => {
        const f = n.beforeState.get(d) || 0;
        if (f !== u) {
          const h = (
            /** @type {Array<GC|Item>} */
            i.clients.get(d)
          ), p = uo(cs(h, f), 1);
          for (let m = h.length - 1; m >= p; )
            m -= 1 + ry(h, m);
        }
      });
      for (let u = o.length - 1; u >= 0; u--) {
        const { client: d, clock: f } = o[u].id, h = (
          /** @type {Array<GC|Item>} */
          i.clients.get(d)
        ), p = cs(h, f);
        p + 1 < h.length && ry(h, p + 1) > 1 || p > 0 && ry(h, p);
      }
      if (!n.local && n.afterState.get(r.clientID) !== n.beforeState.get(r.clientID) && (IX(m5, Sa, "[yjs] ", f0, jX, "Changed the client-id because another client seems to be using it."), r.clientID = UX()), r.emit("afterTransactionCleanup", [n, r]), r._observers.has("update")) {
        const u = new em();
        Tz(u, n) && r.emit("update", [u.toUint8Array(), n.origin, r, n]);
      }
      if (r._observers.has("updateV2")) {
        const u = new h0();
        Tz(u, n) && r.emit("updateV2", [u.toUint8Array(), n.origin, r, n]);
      }
      const { subdocsAdded: s, subdocsLoaded: l, subdocsRemoved: c } = n;
      (s.size > 0 || c.size > 0 || l.size > 0) && (s.forEach((u) => {
        u.clientID = r.clientID, u.collectionid == null && (u.collectionid = r.collectionid), r.subdocs.add(u);
      }), c.forEach((u) => r.subdocs.delete(u)), r.emit("subdocs", [{ loaded: l, added: s, removed: c }, r, n]), c.forEach((u) => u.destroy())), t.length <= e + 1 ? (r._transactionCleanups = [], r.emit("afterAllTransactions", [r, t])) : nee(t, e + 1);
    }
  }
}, pn = (t, e, n = null, r = !0) => {
  const i = t._transactionCleanups;
  let a = !1, o = null;
  t._transaction === null && (a = !0, t._transaction = new lNt(t, n, r), i.push(t._transaction), i.length === 1 && t.emit("beforeAllTransactions", [t]), t.emit("beforeTransaction", [t._transaction, t]));
  try {
    o = e(t._transaction);
  } finally {
    if (a) {
      const s = t._transaction === i[0];
      t._transaction = null, s && nee(i, 0);
    }
  }
  return o;
};
class dNt {
  /**
   * @param {DeleteSet} deletions
   * @param {DeleteSet} insertions
   */
  constructor(e, n) {
    this.insertions = n, this.deletions = e, this.meta = /* @__PURE__ */ new Map();
  }
}
const jz = (t, e, n) => {
  jc(t, n.deletions, (r) => {
    r instanceof wn && e.scope.some((i) => i === t.doc || O2(
      /** @type {AbstractType<any>} */
      i,
      r
    )) && GS(r, !1);
  });
}, Nz = (t, e, n) => {
  let r = null;
  const i = t.doc, a = t.scope;
  pn(i, (s) => {
    for (; e.length > 0 && t.currStackItem === null; ) {
      const l = i.store, c = (
        /** @type {StackItem} */
        e.pop()
      ), u = /* @__PURE__ */ new Set(), d = [];
      let f = !1;
      jc(s, c.insertions, (h) => {
        if (h instanceof wn) {
          if (h.redone !== null) {
            let { item: p, diff: m } = Jw(l, h.id);
            m > 0 && (p = Ai(s, Bt(p.id.client, p.id.clock + m))), h = p;
          }
          !h.deleted && a.some((p) => p === s.doc || O2(
            /** @type {AbstractType<any>} */
            p,
            /** @type {Item} */
            h
          )) && d.push(h);
        }
      }), jc(s, c.deletions, (h) => {
        h instanceof wn && a.some((p) => p === s.doc || O2(
          /** @type {AbstractType<any>} */
          p,
          h
        )) && // Never redo structs in stackItem.insertions because they were created and deleted in the same capture interval.
        !Zd(c.insertions, h.id) && u.add(h);
      }), u.forEach((h) => {
        f = xee(s, h, u, c.insertions, t.ignoreRemoteMapChanges, t) !== null || f;
      });
      for (let h = d.length - 1; h >= 0; h--) {
        const p = d[h];
        t.deleteFilter(p) && (p.delete(s), f = !0);
      }
      t.currStackItem = f ? c : null;
    }
    s.changed.forEach((l, c) => {
      l.has(null) && c._searchMarker && (c._searchMarker.length = 0);
    }), r = s;
  }, t);
  const o = t.currStackItem;
  if (o != null) {
    const s = r.changedParentTypes;
    t.emit("stack-item-popped", [{ stackItem: o, type: n, changedParentTypes: s, origin: t }, t]), t.currStackItem = null;
  }
  return o;
};
class ree extends kS {
  /**
   * @param {Doc|AbstractType<any>|Array<AbstractType<any>>} typeScope Accepts either a single type, or an array of types
   * @param {UndoManagerOptions} options
   */
  constructor(e, {
    captureTimeout: n = 500,
    captureTransaction: r = (l) => !0,
    deleteFilter: i = () => !0,
    trackedOrigins: a = /* @__PURE__ */ new Set([null]),
    ignoreRemoteMapChanges: o = !1,
    doc: s = (
      /** @type {Doc} */
      _w(e) ? e[0].doc : e instanceof Ll ? e : e.doc
    )
  } = {}) {
    super(), this.scope = [], this.doc = s, this.addToScope(e), this.deleteFilter = i, a.add(this), this.trackedOrigins = a, this.captureTransaction = r, this.undoStack = [], this.redoStack = [], this.undoing = !1, this.redoing = !1, this.currStackItem = null, this.lastChange = 0, this.ignoreRemoteMapChanges = o, this.captureTimeout = n, this.afterTransactionHandler = (l) => {
      if (!this.captureTransaction(l) || !this.scope.some((g) => l.changedParentTypes.has(
        /** @type {AbstractType<any>} */
        g
      ) || g === this.doc) || !this.trackedOrigins.has(l.origin) && (!l.origin || !this.trackedOrigins.has(l.origin.constructor)))
        return;
      const c = this.undoing, u = this.redoing, d = c ? this.redoStack : this.undoStack;
      c ? this.stopCapturing() : u || this.clear(!1, !0);
      const f = new Wd();
      l.afterState.forEach((g, v) => {
        const k = l.beforeState.get(v) || 0, w = g - k;
        w > 0 && z2(f, v, k, w);
      });
      const h = ls();
      let p = !1;
      if (this.lastChange > 0 && h - this.lastChange < this.captureTimeout && d.length > 0 && !c && !u) {
        const g = d[d.length - 1];
        g.deletions = Gw([g.deletions, l.deleteSet]), g.insertions = Gw([g.insertions, f]);
      } else
        d.push(new dNt(l.deleteSet, f)), p = !0;
      !c && !u && (this.lastChange = h), jc(
        l,
        l.deleteSet,
        /** @param {Item|GC} item */
        (g) => {
          g instanceof wn && this.scope.some((v) => v === l.doc || O2(
            /** @type {AbstractType<any>} */
            v,
            g
          )) && GS(g, !0);
        }
      );
      const m = [{ stackItem: d[d.length - 1], origin: l.origin, type: c ? "redo" : "undo", changedParentTypes: l.changedParentTypes }, this];
      p ? this.emit("stack-item-added", m) : this.emit("stack-item-updated", m);
    }, this.doc.on("afterTransaction", this.afterTransactionHandler), this.doc.on("destroy", () => {
      this.destroy();
    });
  }
  /**
   * @param {Array<AbstractType<any> | Doc> | AbstractType<any> | Doc} ytypes
   */
  addToScope(e) {
    const n = new Set(this.scope);
    e = _w(e) ? e : [e], e.forEach((r) => {
      n.has(r) || (n.add(r), (r instanceof Ar ? r.doc !== this.doc : r !== this.doc) && PX("[yjs#509] Not same Y.Doc"), this.scope.push(r));
    });
  }
  /**
   * @param {any} origin
   */
  addTrackedOrigin(e) {
    this.trackedOrigins.add(e);
  }
  /**
   * @param {any} origin
   */
  removeTrackedOrigin(e) {
    this.trackedOrigins.delete(e);
  }
  clear(e = !0, n = !0) {
    (e && this.canUndo() || n && this.canRedo()) && this.doc.transact((r) => {
      e && (this.undoStack.forEach((i) => jz(r, this, i)), this.undoStack = []), n && (this.redoStack.forEach((i) => jz(r, this, i)), this.redoStack = []), this.emit("stack-cleared", [{ undoStackCleared: e, redoStackCleared: n }]);
    });
  }
  /**
   * UndoManager merges Undo-StackItem if they are created within time-gap
   * smaller than `options.captureTimeout`. Call `um.stopCapturing()` so that the next
   * StackItem won't be merged.
   *
   *
   * @example
   *     // without stopCapturing
   *     ytext.insert(0, 'a')
   *     ytext.insert(1, 'b')
   *     um.undo()
   *     ytext.toString() // => '' (note that 'ab' was removed)
   *     // with stopCapturing
   *     ytext.insert(0, 'a')
   *     um.stopCapturing()
   *     ytext.insert(0, 'b')
   *     um.undo()
   *     ytext.toString() // => 'a' (note that only 'b' was removed)
   *
   */
  stopCapturing() {
    this.lastChange = 0;
  }
  /**
   * Undo last changes on type.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */
  undo() {
    this.undoing = !0;
    let e;
    try {
      e = Nz(this, this.undoStack, "undo");
    } finally {
      this.undoing = !1;
    }
    return e;
  }
  /**
   * Redo last undo operation.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */
  redo() {
    this.redoing = !0;
    let e;
    try {
      e = Nz(this, this.redoStack, "redo");
    } finally {
      this.redoing = !1;
    }
    return e;
  }
  /**
   * Are undo steps available?
   *
   * @return {boolean} `true` if undo is possible
   */
  canUndo() {
    return this.undoStack.length > 0;
  }
  /**
   * Are redo steps available?
   *
   * @return {boolean} `true` if redo is possible
   */
  canRedo() {
    return this.redoStack.length > 0;
  }
  destroy() {
    this.trackedOrigins.delete(this), this.doc.off("afterTransaction", this.afterTransactionHandler), super.destroy();
  }
}
function* fNt(t) {
  const e = Ot(t.restDecoder);
  for (let n = 0; n < e; n++) {
    const r = Ot(t.restDecoder), i = t.readClient();
    let a = Ot(t.restDecoder);
    for (let o = 0; o < r; o++) {
      const s = t.readInfo();
      if (s === 10) {
        const l = Ot(t.restDecoder);
        yield new Ma(Bt(i, a), l), a += l;
      } else if (f5 & s) {
        const l = (s & (Xs | Xi)) === 0, c = new wn(
          Bt(i, a),
          null,
          // left
          (s & Xi) === Xi ? t.readLeftID() : null,
          // origin
          null,
          // right
          (s & Xs) === Xs ? t.readRightID() : null,
          // right origin
          // @ts-ignore Force writing a string here.
          l ? t.readParentInfo() ? t.readString() : t.readLeftID() : null,
          // parent
          l && (s & N2) === N2 ? t.readString() : null,
          // parentSub
          Mee(t, s)
          // item content
        );
        yield c, a += c.length;
      } else {
        const l = t.readLen();
        yield new xa(Bt(i, a), l), a += l;
      }
    }
  }
}
class FS {
  /**
   * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
   * @param {boolean} filterSkips
   */
  constructor(e, n) {
    this.gen = fNt(e), this.curr = null, this.done = !1, this.filterSkips = n, this.next();
  }
  /**
   * @return {Item | GC | Skip |null}
   */
  next() {
    do
      this.curr = this.gen.next().value || null;
    while (this.filterSkips && this.curr !== null && this.curr.constructor === Ma);
    return this.curr;
  }
}
class _S {
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  constructor(e) {
    this.currClient = 0, this.startClock = 0, this.written = 0, this.encoder = e, this.clientStructs = [];
  }
}
const H2 = (t) => b3(t, ZX, em), hNt = (t, e) => {
  if (t.constructor === xa) {
    const { client: n, clock: r } = t.id;
    return new xa(Bt(n, r + e), t.length - e);
  } else if (t.constructor === Ma) {
    const { client: n, clock: r } = t.id;
    return new Ma(Bt(n, r + e), t.length - e);
  } else {
    const n = (
      /** @type {Item} */
      t
    ), { client: r, clock: i } = n.id;
    return new wn(
      Bt(r, i + e),
      null,
      Bt(r, i + e - 1),
      null,
      n.rightOrigin,
      n.parent,
      n.parentSub,
      n.content.splice(e)
    );
  }
}, b3 = (t, e = hd, n = h0) => {
  if (t.length === 1)
    return t[0];
  const r = t.map((u) => new e(ys(u)));
  let i = r.map((u) => new FS(u, !0)), a = null;
  const o = new n(), s = new _S(o);
  for (; i = i.filter((f) => f.curr !== null), i.sort(
    /** @type {function(any,any):number} */
    (f, h) => {
      if (f.curr.id.client === h.curr.id.client) {
        const p = f.curr.id.clock - h.curr.id.clock;
        return p === 0 ? f.curr.constructor === h.curr.constructor ? 0 : f.curr.constructor === Ma ? 1 : -1 : p;
      } else
        return h.curr.id.client - f.curr.id.client;
    }
  ), i.length !== 0; ) {
    const u = i[0], d = (
      /** @type {Item | GC} */
      u.curr.id.client
    );
    if (a !== null) {
      let f = (
        /** @type {Item | GC | null} */
        u.curr
      ), h = !1;
      for (; f !== null && f.id.clock + f.length <= a.struct.id.clock + a.struct.length && f.id.client >= a.struct.id.client; )
        f = u.next(), h = !0;
      if (f === null || // current decoder is empty
      f.id.client !== d || // check whether there is another decoder that has has updates from `firstClient`
      h && f.id.clock > a.struct.id.clock + a.struct.length)
        continue;
      if (d !== a.struct.id.client)
        Xl(s, a.struct, a.offset), a = { struct: f, offset: 0 }, u.next();
      else if (a.struct.id.clock + a.struct.length < f.id.clock)
        if (a.struct.constructor === Ma)
          a.struct.length = f.id.clock + f.length - a.struct.id.clock;
        else {
          Xl(s, a.struct, a.offset);
          const p = f.id.clock - a.struct.id.clock - a.struct.length;
          a = { struct: new Ma(Bt(d, a.struct.id.clock + a.struct.length), p), offset: 0 };
        }
      else {
        const p = a.struct.id.clock + a.struct.length - f.id.clock;
        p > 0 && (a.struct.constructor === Ma ? a.struct.length -= p : f = hNt(f, p)), a.struct.mergeWith(
          /** @type {any} */
          f
        ) || (Xl(s, a.struct, a.offset), a = { struct: f, offset: 0 }, u.next());
      }
    } else
      a = { struct: (
        /** @type {Item | GC} */
        u.curr
      ), offset: 0 }, u.next();
    for (let f = u.curr; f !== null && f.id.client === d && f.id.clock === a.struct.id.clock + a.struct.length && f.constructor !== Ma; f = u.next())
      Xl(s, a.struct, a.offset), a = { struct: f, offset: 0 };
  }
  a !== null && (Xl(s, a.struct, a.offset), a = null), VS(s);
  const l = r.map((u) => OS(u)), c = Gw(l);
  return Gd(o, c), o.toUint8Array();
}, pNt = (t, e, n = hd, r = h0) => {
  const i = KX(e), a = new r(), o = new _S(a), s = new n(ys(t)), l = new FS(s, !1);
  for (; l.curr; ) {
    const u = l.curr, d = u.id.client, f = i.get(d) || 0;
    if (l.curr.constructor === Ma) {
      l.next();
      continue;
    }
    if (u.id.clock + u.length > f)
      for (Xl(o, u, uo(f - u.id.clock, 0)), l.next(); l.curr && l.curr.id.client === d; )
        Xl(o, l.curr, 0), l.next();
    else
      for (; l.curr && l.curr.id.client === d && l.curr.id.clock + l.curr.length <= f; )
        l.next();
  }
  VS(o);
  const c = OS(s);
  return Gd(a, c), a.toUint8Array();
}, iee = (t) => {
  t.written > 0 && (t.clientStructs.push({ written: t.written, restEncoder: Rn(t.encoder.restEncoder) }), t.encoder.restEncoder = xr(), t.written = 0);
}, Xl = (t, e, n) => {
  t.written > 0 && t.currClient !== e.id.client && iee(t), t.written === 0 && (t.currClient = e.id.client, t.encoder.writeClient(e.id.client), bt(t.encoder.restEncoder, e.id.clock + n)), e.write(t.encoder, n), t.written++;
}, VS = (t) => {
  iee(t);
  const e = t.encoder.restEncoder;
  bt(e, t.clientStructs.length);
  for (let n = 0; n < t.clientStructs.length; n++) {
    const r = t.clientStructs[n];
    bt(e, r.written), h5(e, r.restEncoder);
  }
}, mNt = (t, e, n, r) => {
  const i = new n(ys(t)), a = new FS(i, !1), o = new r(), s = new _S(o);
  for (let c = a.curr; c !== null; c = a.next())
    Xl(s, e(c), 0);
  VS(s);
  const l = OS(i);
  return Gd(o, l), o.toUint8Array();
}, yNt = (t) => mNt(t, djt, hd, em), Dz = "You must not compute changes after the event-handler fired.";
class g5 {
  /**
   * @param {T} target The changed type.
   * @param {Transaction} transaction
   */
  constructor(e, n) {
    this.target = e, this.currentTarget = e, this.transaction = n, this._changes = null, this._keys = null, this._delta = null, this._path = null;
  }
  /**
   * Computes the path from `y` to the changed type.
   *
   * @todo v14 should standardize on path: Array<{parent, index}> because that is easier to work with.
   *
   * The following property holds:
   * @example
   *   let type = y
   *   event.path.forEach(dir => {
   *     type = type.get(dir)
   *   })
   *   type === event.target // => true
   */
  get path() {
    return this._path || (this._path = gNt(this.currentTarget, this.target));
  }
  /**
   * Check if a struct is deleted by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */
  deletes(e) {
    return Zd(this.transaction.deleteSet, e.id);
  }
  /**
   * @type {Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
   */
  get keys() {
    if (this._keys === null) {
      if (this.transaction.doc._transactionCleanups.length === 0)
        throw fo(Dz);
      const e = /* @__PURE__ */ new Map(), n = this.target;
      /** @type Set<string|null> */
      this.transaction.changed.get(n).forEach((i) => {
        if (i !== null) {
          const a = (
            /** @type {Item} */
            n._map.get(i)
          );
          let o, s;
          if (this.adds(a)) {
            let l = a.left;
            for (; l !== null && this.adds(l); )
              l = l.left;
            if (this.deletes(a))
              if (l !== null && this.deletes(l))
                o = "delete", s = qv(l.content.getContent());
              else
                return;
            else
              l !== null && this.deletes(l) ? (o = "update", s = qv(l.content.getContent())) : (o = "add", s = void 0);
          } else if (this.deletes(a))
            o = "delete", s = qv(
              /** @type {Item} */
              a.content.getContent()
            );
          else
            return;
          e.set(i, { action: o, oldValue: s });
        }
      }), this._keys = e;
    }
    return this._keys;
  }
  /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {Array<{insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any>}>}
   */
  get delta() {
    return this.changes.delta;
  }
  /**
   * Check if a struct is added by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */
  adds(e) {
    return e.id.clock >= (this.transaction.beforeState.get(e.id.client) || 0);
  }
  /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */
  get changes() {
    let e = this._changes;
    if (e === null) {
      if (this.transaction.doc._transactionCleanups.length === 0)
        throw fo(Dz);
      const n = this.target, r = vl(), i = vl(), a = [];
      if (e = {
        added: r,
        deleted: i,
        delta: a,
        keys: this.keys
      }, /** @type Set<string|null> */
      this.transaction.changed.get(n).has(null)) {
        let s = null;
        const l = () => {
          s && a.push(s);
        };
        for (let c = n._start; c !== null; c = c.right)
          c.deleted ? this.deletes(c) && !this.adds(c) && ((s === null || s.delete === void 0) && (l(), s = { delete: 0 }), s.delete += c.length, i.add(c)) : this.adds(c) ? ((s === null || s.insert === void 0) && (l(), s = { insert: [] }), s.insert = s.insert.concat(c.content.getContent()), r.add(c)) : ((s === null || s.retain === void 0) && (l(), s = { retain: 0 }), s.retain += c.length);
        s !== null && s.retain === void 0 && l();
      }
      this._changes = e;
    }
    return (
      /** @type {any} */
      e
    );
  }
}
const gNt = (t, e) => {
  const n = [];
  for (; e._item !== null && e !== t; ) {
    if (e._item.parentSub !== null)
      n.unshift(e._item.parentSub);
    else {
      let r = 0, i = (
        /** @type {AbstractType<any>} */
        e._item.parent._start
      );
      for (; i !== e._item && i !== null; )
        !i.deleted && i.countable && (r += i.length), i = i.right;
      n.unshift(r);
    }
    e = /** @type {AbstractType<any>} */
    e._item.parent;
  }
  return n;
}, Kr = () => {
  PX("Invalid access: Add Yjs type to a document before reading data.");
}, aee = 80;
let qS = 0;
class vNt {
  /**
   * @param {Item} p
   * @param {number} index
   */
  constructor(e, n) {
    e.marker = !0, this.p = e, this.index = n, this.timestamp = qS++;
  }
}
const bNt = (t) => {
  t.timestamp = qS++;
}, oee = (t, e, n) => {
  t.p.marker = !1, t.p = e, e.marker = !0, t.index = n, t.timestamp = qS++;
}, wNt = (t, e, n) => {
  if (t.length >= aee) {
    const r = t.reduce((i, a) => i.timestamp < a.timestamp ? i : a);
    return oee(r, e, n), r;
  } else {
    const r = new vNt(e, n);
    return t.push(r), r;
  }
}, v5 = (t, e) => {
  if (t._start === null || e === 0 || t._searchMarker === null)
    return null;
  const n = t._searchMarker.length === 0 ? null : t._searchMarker.reduce((a, o) => ey(e - a.index) < ey(e - o.index) ? a : o);
  let r = t._start, i = 0;
  for (n !== null && (r = n.p, i = n.index, bNt(n)); r.right !== null && i < e; ) {
    if (!r.deleted && r.countable) {
      if (e < i + r.length)
        break;
      i += r.length;
    }
    r = r.right;
  }
  for (; r.left !== null && i > e; )
    r = r.left, !r.deleted && r.countable && (i -= r.length);
  for (; r.left !== null && r.left.id.client === r.id.client && r.left.id.clock + r.left.length === r.id.clock; )
    r = r.left, !r.deleted && r.countable && (i -= r.length);
  return n !== null && ey(n.index - i) < /** @type {YText|YArray<any>} */
  r.parent.length / aee ? (oee(n, r, i), n) : wNt(t._searchMarker, r, i);
}, F2 = (t, e, n) => {
  for (let r = t.length - 1; r >= 0; r--) {
    const i = t[r];
    if (n > 0) {
      let a = i.p;
      for (a.marker = !1; a && (a.deleted || !a.countable); )
        a = a.left, a && !a.deleted && a.countable && (i.index -= a.length);
      if (a === null || a.marker === !0) {
        t.splice(r, 1);
        continue;
      }
      i.p = a, a.marker = !0;
    }
    (e < i.index || n > 0 && e === i.index) && (i.index = uo(e, i.index + n));
  }
}, b5 = (t, e, n) => {
  const r = t, i = e.changedParentTypes;
  for (; Pi(i, t, () => []).push(n), t._item !== null; )
    t = /** @type {AbstractType<any>} */
    t._item.parent;
  JX(r._eH, n, e);
};
class Ar {
  constructor() {
    this._item = null, this._map = /* @__PURE__ */ new Map(), this._start = null, this.doc = null, this._length = 0, this._eH = Mz(), this._dEH = Mz(), this._searchMarker = null;
  }
  /**
   * @return {AbstractType<any>|null}
   */
  get parent() {
    return this._item ? (
      /** @type {AbstractType<any>} */
      this._item.parent
    ) : null;
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item|null} item
   */
  _integrate(e, n) {
    this.doc = e, this._item = n;
  }
  /**
   * @return {AbstractType<EventType>}
   */
  _copy() {
    throw ro();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {AbstractType<EventType>}
   */
  clone() {
    throw ro();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} _encoder
   */
  _write(e) {
  }
  /**
   * The first non-deleted item
   */
  get _first() {
    let e = this._start;
    for (; e !== null && e.deleted; )
      e = e.right;
    return e;
  }
  /**
   * Creates YEvent and calls all type observers.
   * Must be implemented by each type.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} _parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, n) {
    !e.local && this._searchMarker && (this._searchMarker.length = 0);
  }
  /**
   * Observe all events that are created on this type.
   *
   * @param {function(EventType, Transaction):void} f Observer function
   */
  observe(e) {
    Cz(this._eH, e);
  }
  /**
   * Observe all events that are created by this type and its children.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */
  observeDeep(e) {
    Cz(this._dEH, e);
  }
  /**
   * Unregister an observer function.
   *
   * @param {function(EventType,Transaction):void} f Observer function
   */
  unobserve(e) {
    Az(this._eH, e);
  }
  /**
   * Unregister an observer function.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */
  unobserveDeep(e) {
    Az(this._dEH, e);
  }
  /**
   * @abstract
   * @return {any}
   */
  toJSON() {
  }
}
const see = (t, e, n) => {
  t.doc ?? Kr(), e < 0 && (e = t._length + e), n < 0 && (n = t._length + n);
  let r = n - e;
  const i = [];
  let a = t._start;
  for (; a !== null && r > 0; ) {
    if (a.countable && !a.deleted) {
      const o = a.content.getContent();
      if (o.length <= e)
        e -= o.length;
      else {
        for (let s = e; s < o.length && r > 0; s++)
          i.push(o[s]), r--;
        e = 0;
      }
    }
    a = a.right;
  }
  return i;
}, lee = (t) => {
  t.doc ?? Kr();
  const e = [];
  let n = t._start;
  for (; n !== null; ) {
    if (n.countable && !n.deleted) {
      const r = n.content.getContent();
      for (let i = 0; i < r.length; i++)
        e.push(r[i]);
    }
    n = n.right;
  }
  return e;
}, cee = (t, e) => {
  const n = [];
  let r = t._start;
  for (; r !== null; ) {
    if (r.countable && bu(r, e)) {
      const i = r.content.getContent();
      for (let a = 0; a < i.length; a++)
        n.push(i[a]);
    }
    r = r.right;
  }
  return n;
}, _2 = (t, e) => {
  let n = 0, r = t._start;
  for (t.doc ?? Kr(); r !== null; ) {
    if (r.countable && !r.deleted) {
      const i = r.content.getContent();
      for (let a = 0; a < i.length; a++)
        e(i[a], n++, t);
    }
    r = r.right;
  }
}, uee = (t, e) => {
  const n = [];
  return _2(t, (r, i) => {
    n.push(e(r, i, t));
  }), n;
}, kNt = (t) => {
  let e = t._start, n = null, r = 0;
  return {
    [Symbol.iterator]() {
      return this;
    },
    next: () => {
      if (n === null) {
        for (; e !== null && e.deleted; )
          e = e.right;
        if (e === null)
          return {
            done: !0,
            value: void 0
          };
        n = e.content.getContent(), r = 0, e = e.right;
      }
      const i = n[r++];
      return n.length <= r && (n = null), {
        done: !1,
        value: i
      };
    }
  };
}, dee = (t, e) => {
  t.doc ?? Kr();
  const n = v5(t, e);
  let r = t._start;
  for (n !== null && (r = n.p, e -= n.index); r !== null; r = r.right)
    if (!r.deleted && r.countable) {
      if (e < r.length)
        return r.content.getContent()[e];
      e -= r.length;
    }
}, w3 = (t, e, n, r) => {
  let i = n;
  const a = t.doc, o = a.clientID, s = a.store, l = n === null ? e._start : n.right;
  let c = [];
  const u = () => {
    c.length > 0 && (i = new wn(Bt(o, nr(s, o)), i, i && i.lastId, l, l && l.id, e, null, new y0(c)), i.integrate(t, 0), c = []);
  };
  r.forEach((d) => {
    if (d === null)
      c.push(d);
    else
      switch (d.constructor) {
        case Number:
        case Object:
        case Boolean:
        case Array:
        case String:
          c.push(d);
          break;
        default:
          switch (u(), d.constructor) {
            case Uint8Array:
            case ArrayBuffer:
              i = new wn(Bt(o, nr(s, o)), i, i && i.lastId, l, l && l.id, e, null, new rm(new Uint8Array(
                /** @type {Uint8Array} */
                d
              ))), i.integrate(t, 0);
              break;
            case Ll:
              i = new wn(Bt(o, nr(s, o)), i, i && i.lastId, l, l && l.id, e, null, new im(
                /** @type {Doc} */
                d
              )), i.integrate(t, 0);
              break;
            default:
              if (d instanceof Ar)
                i = new wn(Bt(o, nr(s, o)), i, i && i.lastId, l, l && l.id, e, null, new ko(d)), i.integrate(t, 0);
              else
                throw new Error("Unexpected content type in insert operation");
          }
      }
  }), u();
}, fee = () => fo("Length exceeded!"), hee = (t, e, n, r) => {
  if (n > e._length)
    throw fee();
  if (n === 0)
    return e._searchMarker && F2(e._searchMarker, n, r.length), w3(t, e, null, r);
  const i = n, a = v5(e, n);
  let o = e._start;
  for (a !== null && (o = a.p, n -= a.index, n === 0 && (o = o.prev, n += o && o.countable && !o.deleted ? o.length : 0)); o !== null; o = o.right)
    if (!o.deleted && o.countable) {
      if (n <= o.length) {
        n < o.length && Ai(t, Bt(o.id.client, o.id.clock + n));
        break;
      }
      n -= o.length;
    }
  return e._searchMarker && F2(e._searchMarker, i, r.length), w3(t, e, o, r);
}, xNt = (t, e, n) => {
  let i = (e._searchMarker || []).reduce((a, o) => o.index > a.index ? o : a, { index: 0, p: e._start }).p;
  if (i)
    for (; i.right; )
      i = i.right;
  return w3(t, e, i, n);
}, pee = (t, e, n, r) => {
  if (r === 0)
    return;
  const i = n, a = r, o = v5(e, n);
  let s = e._start;
  for (o !== null && (s = o.p, n -= o.index); s !== null && n > 0; s = s.right)
    !s.deleted && s.countable && (n < s.length && Ai(t, Bt(s.id.client, s.id.clock + n)), n -= s.length);
  for (; r > 0 && s !== null; )
    s.deleted || (r < s.length && Ai(t, Bt(s.id.client, s.id.clock + r)), s.delete(t), r -= s.length), s = s.right;
  if (r > 0)
    throw fee();
  e._searchMarker && F2(
    e._searchMarker,
    i,
    -a + r
    /* in case we remove the above exception */
  );
}, k3 = (t, e, n) => {
  const r = e._map.get(n);
  r !== void 0 && r.delete(t);
}, US = (t, e, n, r) => {
  const i = e._map.get(n) || null, a = t.doc, o = a.clientID;
  let s;
  if (r == null)
    s = new y0([r]);
  else
    switch (r.constructor) {
      case Number:
      case Object:
      case Boolean:
      case Array:
      case String:
        s = new y0([r]);
        break;
      case Uint8Array:
        s = new rm(
          /** @type {Uint8Array} */
          r
        );
        break;
      case Ll:
        s = new im(
          /** @type {Doc} */
          r
        );
        break;
      default:
        if (r instanceof Ar)
          s = new ko(r);
        else
          throw new Error("Unexpected content type");
    }
  new wn(Bt(o, nr(a.store, o)), i, i && i.lastId, null, null, e, n, s).integrate(t, 0);
}, WS = (t, e) => {
  t.doc ?? Kr();
  const n = t._map.get(e);
  return n !== void 0 && !n.deleted ? n.content.getContent()[n.length - 1] : void 0;
}, mee = (t) => {
  const e = {};
  return t.doc ?? Kr(), t._map.forEach((n, r) => {
    n.deleted || (e[r] = n.content.getContent()[n.length - 1]);
  }), e;
}, yee = (t, e) => {
  t.doc ?? Kr();
  const n = t._map.get(e);
  return n !== void 0 && !n.deleted;
}, MNt = (t, e) => {
  const n = {};
  return t._map.forEach((r, i) => {
    let a = r;
    for (; a !== null && (!e.sv.has(a.id.client) || a.id.clock >= (e.sv.get(a.id.client) || 0)); )
      a = a.left;
    a !== null && bu(a, e) && (n[i] = a.content.getContent()[a.length - 1]);
  }), n;
}, i4 = (t) => (t.doc ?? Kr(), _jt(
  t._map.entries(),
  /** @param {any} entry */
  (e) => !e[1].deleted
));
class CNt extends g5 {
}
class S1 extends Ar {
  constructor() {
    super(), this._prelimContent = [], this._searchMarker = [];
  }
  /**
   * Construct a new YArray containing the specified items.
   * @template {Object<string,any>|Array<any>|number|null|string|Uint8Array} T
   * @param {Array<T>} items
   * @return {YArray<T>}
   */
  static from(e) {
    const n = new S1();
    return n.push(e), n;
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate(e, n) {
    super._integrate(e, n), this.insert(
      0,
      /** @type {Array<any>} */
      this._prelimContent
    ), this._prelimContent = null;
  }
  /**
   * @return {YArray<T>}
   */
  _copy() {
    return new S1();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YArray<T>}
   */
  clone() {
    const e = new S1();
    return e.insert(0, this.toArray().map(
      (n) => n instanceof Ar ? (
        /** @type {typeof el} */
        n.clone()
      ) : n
    )), e;
  }
  get length() {
    return this.doc ?? Kr(), this._length;
  }
  /**
   * Creates YArrayEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, n) {
    super._callObserver(e, n), b5(this, e, new CNt(this, e));
  }
  /**
   * Inserts new content at an index.
   *
   * Important: This function expects an array of content. Not just a content
   * object. The reason for this "weirdness" is that inserting several elements
   * is very efficient when it is done as a single operation.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  yarray.insert(0, ['a'])
   *  // Insert numbers 1, 2 at position 1
   *  yarray.insert(1, [1, 2])
   *
   * @param {number} index The index to insert content at.
   * @param {Array<T>} content The array of content
   */
  insert(e, n) {
    this.doc !== null ? pn(this.doc, (r) => {
      hee(
        r,
        this,
        e,
        /** @type {any} */
        n
      );
    }) : this._prelimContent.splice(e, 0, ...n);
  }
  /**
   * Appends content to this YArray.
   *
   * @param {Array<T>} content Array of content to append.
   *
   * @todo Use the following implementation in all types.
   */
  push(e) {
    this.doc !== null ? pn(this.doc, (n) => {
      xNt(
        n,
        this,
        /** @type {any} */
        e
      );
    }) : this._prelimContent.push(...e);
  }
  /**
   * Prepends content to this YArray.
   *
   * @param {Array<T>} content Array of content to prepend.
   */
  unshift(e) {
    this.insert(0, e);
  }
  /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} length The number of elements to remove. Defaults to 1.
   */
  delete(e, n = 1) {
    this.doc !== null ? pn(this.doc, (r) => {
      pee(r, this, e, n);
    }) : this._prelimContent.splice(e, n);
  }
  /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {T}
   */
  get(e) {
    return dee(this, e);
  }
  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<T>}
   */
  toArray() {
    return lee(this);
  }
  /**
   * Returns a portion of this YArray into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<T>}
   */
  slice(e = 0, n = this.length) {
    return see(this, e, n);
  }
  /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Array<any>}
   */
  toJSON() {
    return this.map((e) => e instanceof Ar ? e.toJSON() : e);
  }
  /**
   * Returns an Array with the result of calling a provided function on every
   * element of this YArray.
   *
   * @template M
   * @param {function(T,number,YArray<T>):M} f Function that produces an element of the new Array
   * @return {Array<M>} A new array with each element being the result of the
   *                 callback function
   */
  map(e) {
    return uee(
      this,
      /** @type {any} */
      e
    );
  }
  /**
   * Executes a provided function once on every element of this YArray.
   *
   * @param {function(T,number,YArray<T>):void} f A function to execute on every element of this YArray.
   */
  forEach(e) {
    _2(this, e);
  }
  /**
   * @return {IterableIterator<T>}
   */
  [Symbol.iterator]() {
    return kNt(this);
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write(e) {
    e.writeTypeRef(KNt);
  }
}
const ANt = (t) => new S1();
class SNt extends g5 {
  /**
   * @param {YMap<T>} ymap The YArray that changed.
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed.
   */
  constructor(e, n, r) {
    super(e, n), this.keysChanged = r;
  }
}
class pd extends Ar {
  /**
   *
   * @param {Iterable<readonly [string, any]>=} entries - an optional iterable to initialize the YMap
   */
  constructor(e) {
    super(), this._prelimContent = null, e === void 0 ? this._prelimContent = /* @__PURE__ */ new Map() : this._prelimContent = new Map(e);
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate(e, n) {
    super._integrate(e, n), this._prelimContent.forEach((r, i) => {
      this.set(i, r);
    }), this._prelimContent = null;
  }
  /**
   * @return {YMap<MapType>}
   */
  _copy() {
    return new pd();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YMap<MapType>}
   */
  clone() {
    const e = new pd();
    return this.forEach((n, r) => {
      e.set(r, n instanceof Ar ? (
        /** @type {typeof value} */
        n.clone()
      ) : n);
    }), e;
  }
  /**
   * Creates YMapEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, n) {
    b5(this, e, new SNt(this, e, n));
  }
  /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Object<string,any>}
   */
  toJSON() {
    this.doc ?? Kr();
    const e = {};
    return this._map.forEach((n, r) => {
      if (!n.deleted) {
        const i = n.content.getContent()[n.length - 1];
        e[r] = i instanceof Ar ? i.toJSON() : i;
      }
    }), e;
  }
  /**
   * Returns the size of the YMap (count of key/value pairs)
   *
   * @return {number}
   */
  get size() {
    return [...i4(this)].length;
  }
  /**
   * Returns the keys for each element in the YMap Type.
   *
   * @return {IterableIterator<string>}
   */
  keys() {
    return Kv(
      i4(this),
      /** @param {any} v */
      (e) => e[0]
    );
  }
  /**
   * Returns the values for each element in the YMap Type.
   *
   * @return {IterableIterator<MapType>}
   */
  values() {
    return Kv(
      i4(this),
      /** @param {any} v */
      (e) => e[1].content.getContent()[e[1].length - 1]
    );
  }
  /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */
  entries() {
    return Kv(
      i4(this),
      /** @param {any} v */
      (e) => (
        /** @type {any} */
        [e[0], e[1].content.getContent()[e[1].length - 1]]
      )
    );
  }
  /**
   * Executes a provided function on once on every key-value pair.
   *
   * @param {function(MapType,string,YMap<MapType>):void} f A function to execute on every element of this YArray.
   */
  forEach(e) {
    this.doc ?? Kr(), this._map.forEach((n, r) => {
      n.deleted || e(n.content.getContent()[n.length - 1], r, this);
    });
  }
  /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */
  [Symbol.iterator]() {
    return this.entries();
  }
  /**
   * Remove a specified element from this YMap.
   *
   * @param {string} key The key of the element to remove.
   */
  delete(e) {
    this.doc !== null ? pn(this.doc, (n) => {
      k3(n, this, e);
    }) : this._prelimContent.delete(e);
  }
  /**
   * Adds or updates an element with a specified key and value.
   * @template {MapType} VAL
   *
   * @param {string} key The key of the element to add to this YMap
   * @param {VAL} value The value of the element to add
   * @return {VAL}
   */
  set(e, n) {
    return this.doc !== null ? pn(this.doc, (r) => {
      US(
        r,
        this,
        e,
        /** @type {any} */
        n
      );
    }) : this._prelimContent.set(e, n), n;
  }
  /**
   * Returns a specified element from this YMap.
   *
   * @param {string} key
   * @return {MapType|undefined}
   */
  get(e) {
    return (
      /** @type {any} */
      WS(this, e)
    );
  }
  /**
   * Returns a boolean indicating whether the specified key exists or not.
   *
   * @param {string} key The key to test.
   * @return {boolean}
   */
  has(e) {
    return yee(this, e);
  }
  /**
   * Removes all elements from this YMap.
   */
  clear() {
    this.doc !== null ? pn(this.doc, (e) => {
      this.forEach(function(n, r, i) {
        k3(e, i, r);
      });
    }) : this._prelimContent.clear();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write(e) {
    e.writeTypeRef($Nt);
  }
}
const LNt = (t) => new pd(), oc = (t, e) => t === e || typeof t == "object" && typeof e == "object" && t && e && ljt(t, e);
class $w {
  /**
   * @param {Item|null} left
   * @param {Item|null} right
   * @param {number} index
   * @param {Map<string,any>} currentAttributes
   */
  constructor(e, n, r, i) {
    this.left = e, this.right = n, this.index = r, this.currentAttributes = i;
  }
  /**
   * Only call this if you know that this.right is defined
   */
  forward() {
    switch (this.right === null && aa(), this.right.content.constructor) {
      case lr:
        this.right.deleted || Yd(
          this.currentAttributes,
          /** @type {ContentFormat} */
          this.right.content
        );
        break;
      default:
        this.right.deleted || (this.index += this.right.length);
        break;
    }
    this.left = this.right, this.right = this.right.right;
  }
}
const Iz = (t, e, n) => {
  for (; e.right !== null && n > 0; ) {
    switch (e.right.content.constructor) {
      case lr:
        e.right.deleted || Yd(
          e.currentAttributes,
          /** @type {ContentFormat} */
          e.right.content
        );
        break;
      default:
        e.right.deleted || (n < e.right.length && Ai(t, Bt(e.right.id.client, e.right.id.clock + n)), e.index += e.right.length, n -= e.right.length);
        break;
    }
    e.left = e.right, e.right = e.right.right;
  }
  return e;
}, a4 = (t, e, n, r) => {
  const i = /* @__PURE__ */ new Map(), a = r ? v5(e, n) : null;
  if (a) {
    const o = new $w(a.p.left, a.p, a.index, i);
    return Iz(t, o, n - a.index);
  } else {
    const o = new $w(null, e._start, 0, i);
    return Iz(t, o, n);
  }
}, gee = (t, e, n, r) => {
  for (; n.right !== null && (n.right.deleted === !0 || n.right.content.constructor === lr && oc(
    r.get(
      /** @type {ContentFormat} */
      n.right.content.key
    ),
    /** @type {ContentFormat} */
    n.right.content.value
  )); )
    n.right.deleted || r.delete(
      /** @type {ContentFormat} */
      n.right.content.key
    ), n.forward();
  const i = t.doc, a = i.clientID;
  r.forEach((o, s) => {
    const l = n.left, c = n.right, u = new wn(Bt(a, nr(i.store, a)), l, l && l.lastId, c, c && c.id, e, null, new lr(s, o));
    u.integrate(t, 0), n.right = u, n.forward();
  });
}, Yd = (t, e) => {
  const { key: n, value: r } = e;
  r === null ? t.delete(n) : t.set(n, r);
}, vee = (t, e) => {
  for (; t.right !== null; ) {
    if (!(t.right.deleted || t.right.content.constructor === lr && oc(
      e[
        /** @type {ContentFormat} */
        t.right.content.key
      ] ?? null,
      /** @type {ContentFormat} */
      t.right.content.value
    ))) break;
    t.forward();
  }
}, bee = (t, e, n, r) => {
  const i = t.doc, a = i.clientID, o = /* @__PURE__ */ new Map();
  for (const s in r) {
    const l = r[s], c = n.currentAttributes.get(s) ?? null;
    if (!oc(c, l)) {
      o.set(s, c);
      const { left: u, right: d } = n;
      n.right = new wn(Bt(a, nr(i.store, a)), u, u && u.lastId, d, d && d.id, e, null, new lr(s, l)), n.right.integrate(t, 0), n.forward();
    }
  }
  return o;
}, Qv = (t, e, n, r, i) => {
  n.currentAttributes.forEach((f, h) => {
    i[h] === void 0 && (i[h] = null);
  });
  const a = t.doc, o = a.clientID;
  vee(n, i);
  const s = bee(t, e, n, i), l = r.constructor === String ? new ho(
    /** @type {string} */
    r
  ) : r instanceof Ar ? new ko(r) : new E0(r);
  let { left: c, right: u, index: d } = n;
  e._searchMarker && F2(e._searchMarker, n.index, l.getLength()), u = new wn(Bt(o, nr(a.store, o)), c, c && c.lastId, u, u && u.id, e, null, l), u.integrate(t, 0), n.right = u, n.index = d, n.forward(), gee(t, e, n, s);
}, Pz = (t, e, n, r, i) => {
  const a = t.doc, o = a.clientID;
  vee(n, i);
  const s = bee(t, e, n, i);
  e: for (; n.right !== null && (r > 0 || s.size > 0 && (n.right.deleted || n.right.content.constructor === lr)); ) {
    if (!n.right.deleted)
      switch (n.right.content.constructor) {
        case lr: {
          const { key: l, value: c } = (
            /** @type {ContentFormat} */
            n.right.content
          ), u = i[l];
          if (u !== void 0) {
            if (oc(u, c))
              s.delete(l);
            else {
              if (r === 0)
                break e;
              s.set(l, c);
            }
            n.right.delete(t);
          } else
            n.currentAttributes.set(l, c);
          break;
        }
        default:
          r < n.right.length && Ai(t, Bt(n.right.id.client, n.right.id.clock + r)), r -= n.right.length;
          break;
      }
    n.forward();
  }
  if (r > 0) {
    let l = "";
    for (; r > 0; r--)
      l += `
`;
    n.right = new wn(Bt(o, nr(a.store, o)), n.left, n.left && n.left.lastId, n.right, n.right && n.right.id, e, null, new ho(l)), n.right.integrate(t, 0), n.forward();
  }
  gee(t, e, n, s);
}, wee = (t, e, n, r, i) => {
  let a = e;
  const o = ui();
  for (; a && (!a.countable || a.deleted); ) {
    if (!a.deleted && a.content.constructor === lr) {
      const c = (
        /** @type {ContentFormat} */
        a.content
      );
      o.set(c.key, c);
    }
    a = a.right;
  }
  let s = 0, l = !1;
  for (; e !== a; ) {
    if (n === e && (l = !0), !e.deleted) {
      const c = e.content;
      switch (c.constructor) {
        case lr: {
          const { key: u, value: d } = (
            /** @type {ContentFormat} */
            c
          ), f = r.get(u) ?? null;
          (o.get(u) !== c || f === d) && (e.delete(t), s++, !l && (i.get(u) ?? null) === d && f !== d && (f === null ? i.delete(u) : i.set(u, f))), !l && !e.deleted && Yd(
            i,
            /** @type {ContentFormat} */
            c
          );
          break;
        }
      }
    }
    e = /** @type {Item} */
    e.right;
  }
  return s;
}, TNt = (t, e) => {
  for (; e && e.right && (e.right.deleted || !e.right.countable); )
    e = e.right;
  const n = /* @__PURE__ */ new Set();
  for (; e && (e.deleted || !e.countable); ) {
    if (!e.deleted && e.content.constructor === lr) {
      const r = (
        /** @type {ContentFormat} */
        e.content.key
      );
      n.has(r) ? e.delete(t) : n.add(r);
    }
    e = e.left;
  }
}, ENt = (t) => {
  let e = 0;
  return pn(
    /** @type {Doc} */
    t.doc,
    (n) => {
      let r = (
        /** @type {Item} */
        t._start
      ), i = t._start, a = ui();
      const o = Fw(a);
      for (; i; ) {
        if (i.deleted === !1)
          switch (i.content.constructor) {
            case lr:
              Yd(
                o,
                /** @type {ContentFormat} */
                i.content
              );
              break;
            default:
              e += wee(n, r, i, a, o), a = Fw(o), r = i;
              break;
          }
        i = i.right;
      }
    }
  ), e;
}, jNt = (t) => {
  const e = /* @__PURE__ */ new Set(), n = t.doc;
  for (const [r, i] of t.afterState.entries()) {
    const a = t.beforeState.get(r) || 0;
    i !== a && tee(
      t,
      /** @type {Array<Item|GC>} */
      n.store.clients.get(r),
      a,
      i,
      (o) => {
        !o.deleted && /** @type {Item} */
        o.content.constructor === lr && o.constructor !== xa && e.add(
          /** @type {any} */
          o.parent
        );
      }
    );
  }
  pn(n, (r) => {
    jc(t, t.deleteSet, (i) => {
      if (i instanceof xa || !/** @type {YText} */
      i.parent._hasFormatting || e.has(
        /** @type {YText} */
        i.parent
      ))
        return;
      const a = (
        /** @type {YText} */
        i.parent
      );
      i.content.constructor === lr ? e.add(a) : TNt(r, i);
    });
    for (const i of e)
      ENt(i);
  });
}, zz = (t, e, n) => {
  const r = n, i = Fw(e.currentAttributes), a = e.right;
  for (; n > 0 && e.right !== null; ) {
    if (e.right.deleted === !1)
      switch (e.right.content.constructor) {
        case ko:
        case E0:
        case ho:
          n < e.right.length && Ai(t, Bt(e.right.id.client, e.right.id.clock + n)), n -= e.right.length, e.right.delete(t);
          break;
      }
    e.forward();
  }
  a && wee(t, a, e.right, i, e.currentAttributes);
  const o = (
    /** @type {AbstractType<any>} */
    /** @type {Item} */
    (e.left || e.right).parent
  );
  return o._searchMarker && F2(o._searchMarker, e.index, -r + n), e;
};
class NNt extends g5 {
  /**
   * @param {YText} ytext
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed
   */
  constructor(e, n, r) {
    super(e, n), this.childListChanged = !1, this.keysChanged = /* @__PURE__ */ new Set(), r.forEach((i) => {
      i === null ? this.childListChanged = !0 : this.keysChanged.add(i);
    });
  }
  /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */
  get changes() {
    if (this._changes === null) {
      const e = {
        keys: this.keys,
        delta: this.delta,
        added: /* @__PURE__ */ new Set(),
        deleted: /* @__PURE__ */ new Set()
      };
      this._changes = e;
    }
    return (
      /** @type {any} */
      this._changes
    );
  }
  /**
   * Compute the changes in the delta format.
   * A {@link https://quilljs.com/docs/delta/|Quill Delta}) that represents the changes on the document.
   *
   * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
   *
   * @public
   */
  get delta() {
    if (this._delta === null) {
      const e = (
        /** @type {Doc} */
        this.target.doc
      ), n = [];
      pn(e, (r) => {
        const i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
        let o = this.target._start, s = null;
        const l = {};
        let c = "", u = 0, d = 0;
        const f = () => {
          if (s !== null) {
            let h = null;
            switch (s) {
              case "delete":
                d > 0 && (h = { delete: d }), d = 0;
                break;
              case "insert":
                (typeof c == "object" || c.length > 0) && (h = { insert: c }, i.size > 0 && (h.attributes = {}, i.forEach((p, m) => {
                  p !== null && (h.attributes[m] = p);
                }))), c = "";
                break;
              case "retain":
                u > 0 && (h = { retain: u }, ojt(l) || (h.attributes = ijt({}, l))), u = 0;
                break;
            }
            h && n.push(h), s = null;
          }
        };
        for (; o !== null; ) {
          switch (o.content.constructor) {
            case ko:
            case E0:
              this.adds(o) ? this.deletes(o) || (f(), s = "insert", c = o.content.getContent()[0], f()) : this.deletes(o) ? (s !== "delete" && (f(), s = "delete"), d += 1) : o.deleted || (s !== "retain" && (f(), s = "retain"), u += 1);
              break;
            case ho:
              this.adds(o) ? this.deletes(o) || (s !== "insert" && (f(), s = "insert"), c += /** @type {ContentString} */
              o.content.str) : this.deletes(o) ? (s !== "delete" && (f(), s = "delete"), d += o.length) : o.deleted || (s !== "retain" && (f(), s = "retain"), u += o.length);
              break;
            case lr: {
              const { key: h, value: p } = (
                /** @type {ContentFormat} */
                o.content
              );
              if (this.adds(o)) {
                if (!this.deletes(o)) {
                  const m = i.get(h) ?? null;
                  oc(m, p) ? p !== null && o.delete(r) : (s === "retain" && f(), oc(p, a.get(h) ?? null) ? delete l[h] : l[h] = p);
                }
              } else if (this.deletes(o)) {
                a.set(h, p);
                const m = i.get(h) ?? null;
                oc(m, p) || (s === "retain" && f(), l[h] = m);
              } else if (!o.deleted) {
                a.set(h, p);
                const m = l[h];
                m !== void 0 && (oc(m, p) ? m !== null && o.delete(r) : (s === "retain" && f(), p === null ? delete l[h] : l[h] = p));
              }
              o.deleted || (s === "insert" && f(), Yd(
                i,
                /** @type {ContentFormat} */
                o.content
              ));
              break;
            }
          }
          o = o.right;
        }
        for (f(); n.length > 0; ) {
          const h = n[n.length - 1];
          if (h.retain !== void 0 && h.attributes === void 0)
            n.pop();
          else
            break;
        }
      }), this._delta = n;
    }
    return (
      /** @type {any} */
      this._delta
    );
  }
}
class Nc extends Ar {
  /**
   * @param {String} [string] The initial value of the YText.
   */
  constructor(e) {
    super(), this._pending = e !== void 0 ? [() => this.insert(0, e)] : [], this._searchMarker = [], this._hasFormatting = !1;
  }
  /**
   * Number of characters of this text type.
   *
   * @type {number}
   */
  get length() {
    return this.doc ?? Kr(), this._length;
  }
  /**
   * @param {Doc} y
   * @param {Item} item
   */
  _integrate(e, n) {
    super._integrate(e, n);
    try {
      this._pending.forEach((r) => r());
    } catch (r) {
      console.error(r);
    }
    this._pending = null;
  }
  _copy() {
    return new Nc();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YText}
   */
  clone() {
    const e = new Nc();
    return e.applyDelta(this.toDelta()), e;
  }
  /**
   * Creates YTextEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, n) {
    super._callObserver(e, n);
    const r = new NNt(this, e, n);
    b5(this, e, r), !e.local && this._hasFormatting && (e._needFormattingCleanup = !0);
  }
  /**
   * Returns the unformatted string representation of this YText type.
   *
   * @public
   */
  toString() {
    this.doc ?? Kr();
    let e = "", n = this._start;
    for (; n !== null; )
      !n.deleted && n.countable && n.content.constructor === ho && (e += /** @type {ContentString} */
      n.content.str), n = n.right;
    return e;
  }
  /**
   * Returns the unformatted string representation of this YText type.
   *
   * @return {string}
   * @public
   */
  toJSON() {
    return this.toString();
  }
  /**
   * Apply a {@link Delta} on this shared YText type.
   *
   * @param {Array<any>} delta The changes to apply on this element.
   * @param {object}  opts
   * @param {boolean} [opts.sanitize] Sanitize input delta. Removes ending newlines if set to true.
   *
   *
   * @public
   */
  applyDelta(e, { sanitize: n = !0 } = {}) {
    this.doc !== null ? pn(this.doc, (r) => {
      const i = new $w(null, this._start, 0, /* @__PURE__ */ new Map());
      for (let a = 0; a < e.length; a++) {
        const o = e[a];
        if (o.insert !== void 0) {
          const s = !n && typeof o.insert == "string" && a === e.length - 1 && i.right === null && o.insert.slice(-1) === `
` ? o.insert.slice(0, -1) : o.insert;
          (typeof s != "string" || s.length > 0) && Qv(r, this, i, s, o.attributes || {});
        } else o.retain !== void 0 ? Pz(r, this, i, o.retain, o.attributes || {}) : o.delete !== void 0 && zz(r, i, o.delete);
      }
    }) : this._pending.push(() => this.applyDelta(e));
  }
  /**
   * Returns the Delta representation of this YText type.
   *
   * @param {Snapshot} [snapshot]
   * @param {Snapshot} [prevSnapshot]
   * @param {function('removed' | 'added', ID):any} [computeYChange]
   * @return {any} The Delta representation of this type.
   *
   * @public
   */
  toDelta(e, n, r) {
    this.doc ?? Kr();
    const i = [], a = /* @__PURE__ */ new Map(), o = (
      /** @type {Doc} */
      this.doc
    );
    let s = "", l = this._start;
    function c() {
      if (s.length > 0) {
        const d = {};
        let f = !1;
        a.forEach((p, m) => {
          f = !0, d[m] = p;
        });
        const h = { insert: s };
        f && (h.attributes = d), i.push(h), s = "";
      }
    }
    const u = () => {
      for (; l !== null; ) {
        if (bu(l, e) || n !== void 0 && bu(l, n))
          switch (l.content.constructor) {
            case ho: {
              const d = a.get("ychange");
              e !== void 0 && !bu(l, e) ? (d === void 0 || d.user !== l.id.client || d.type !== "removed") && (c(), a.set("ychange", r ? r("removed", l.id) : { type: "removed" })) : n !== void 0 && !bu(l, n) ? (d === void 0 || d.user !== l.id.client || d.type !== "added") && (c(), a.set("ychange", r ? r("added", l.id) : { type: "added" })) : d !== void 0 && (c(), a.delete("ychange")), s += /** @type {ContentString} */
              l.content.str;
              break;
            }
            case ko:
            case E0: {
              c();
              const d = {
                insert: l.content.getContent()[0]
              };
              if (a.size > 0) {
                const f = (
                  /** @type {Object<string,any>} */
                  {}
                );
                d.attributes = f, a.forEach((h, p) => {
                  f[p] = h;
                });
              }
              i.push(d);
              break;
            }
            case lr:
              bu(l, e) && (c(), Yd(
                a,
                /** @type {ContentFormat} */
                l.content
              ));
              break;
          }
        l = l.right;
      }
      c();
    };
    return e || n ? pn(o, (d) => {
      e && Yw(d, e), n && Yw(d, n), u();
    }, "cleanup") : u(), i;
  }
  /**
   * Insert text at a given index.
   *
   * @param {number} index The index at which to start inserting.
   * @param {String} text The text to insert at the specified position.
   * @param {TextAttributes} [attributes] Optionally define some formatting
   *                                    information to apply on the inserted
   *                                    Text.
   * @public
   */
  insert(e, n, r) {
    if (n.length <= 0)
      return;
    const i = this.doc;
    i !== null ? pn(i, (a) => {
      const o = a4(a, this, e, !r);
      r || (r = {}, o.currentAttributes.forEach((s, l) => {
        r[l] = s;
      })), Qv(a, this, o, n, r);
    }) : this._pending.push(() => this.insert(e, n, r));
  }
  /**
   * Inserts an embed at a index.
   *
   * @param {number} index The index to insert the embed at.
   * @param {Object | AbstractType<any>} embed The Object that represents the embed.
   * @param {TextAttributes} [attributes] Attribute information to apply on the
   *                                    embed
   *
   * @public
   */
  insertEmbed(e, n, r) {
    const i = this.doc;
    i !== null ? pn(i, (a) => {
      const o = a4(a, this, e, !r);
      Qv(a, this, o, n, r || {});
    }) : this._pending.push(() => this.insertEmbed(e, n, r || {}));
  }
  /**
   * Deletes text starting from an index.
   *
   * @param {number} index Index at which to start deleting.
   * @param {number} length The number of characters to remove. Defaults to 1.
   *
   * @public
   */
  delete(e, n) {
    if (n === 0)
      return;
    const r = this.doc;
    r !== null ? pn(r, (i) => {
      zz(i, a4(i, this, e, !0), n);
    }) : this._pending.push(() => this.delete(e, n));
  }
  /**
   * Assigns properties to a range of text.
   *
   * @param {number} index The position where to start formatting.
   * @param {number} length The amount of characters to assign properties to.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    text.
   *
   * @public
   */
  format(e, n, r) {
    if (n === 0)
      return;
    const i = this.doc;
    i !== null ? pn(i, (a) => {
      const o = a4(a, this, e, !1);
      o.right !== null && Pz(a, this, o, n, r);
    }) : this._pending.push(() => this.format(e, n, r));
  }
  /**
   * Removes an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */
  removeAttribute(e) {
    this.doc !== null ? pn(this.doc, (n) => {
      k3(n, this, e);
    }) : this._pending.push(() => this.removeAttribute(e));
  }
  /**
   * Sets or updates an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {any} attributeValue The attribute value that is to be set.
   *
   * @public
   */
  setAttribute(e, n) {
    this.doc !== null ? pn(this.doc, (r) => {
      US(r, this, e, n);
    }) : this._pending.push(() => this.setAttribute(e, n));
  }
  /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {any} The queried attribute value.
   *
   * @public
   */
  getAttribute(e) {
    return (
      /** @type {any} */
      WS(this, e)
    );
  }
  /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */
  getAttributes() {
    return mee(this);
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write(e) {
    e.writeTypeRef(JNt);
  }
}
const DNt = (t) => new Nc();
class Xv {
  /**
   * @param {YXmlFragment | YXmlElement} root
   * @param {function(AbstractType<any>):boolean} [f]
   */
  constructor(e, n = () => !0) {
    this._filter = n, this._root = e, this._currentNode = /** @type {Item} */
    e._start, this._firstCall = !0, e.doc ?? Kr();
  }
  [Symbol.iterator]() {
    return this;
  }
  /**
   * Get the next node.
   *
   * @return {IteratorResult<YXmlElement|YXmlText|YXmlHook>} The next node.
   *
   * @public
   */
  next() {
    let e = this._currentNode, n = e && e.content && /** @type {any} */
    e.content.type;
    if (e !== null && (!this._firstCall || e.deleted || !this._filter(n)))
      do
        if (n = /** @type {any} */
        e.content.type, !e.deleted && (n.constructor === si || n.constructor === m0) && n._start !== null)
          e = n._start;
        else
          for (; e !== null; ) {
            const r = e.next;
            if (r !== null) {
              e = r;
              break;
            } else e.parent === this._root ? e = null : e = /** @type {AbstractType<any>} */
            e.parent._item;
          }
      while (e !== null && (e.deleted || !this._filter(
        /** @type {ContentType} */
        e.content.type
      )));
    return this._firstCall = !1, e === null ? { value: void 0, done: !0 } : (this._currentNode = e, { value: (
      /** @type {any} */
      e.content.type
    ), done: !1 });
  }
}
class m0 extends Ar {
  constructor() {
    super(), this._prelimContent = [];
  }
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get firstChild() {
    const e = this._first;
    return e ? e.content.getContent()[0] : null;
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate(e, n) {
    super._integrate(e, n), this.insert(
      0,
      /** @type {Array<any>} */
      this._prelimContent
    ), this._prelimContent = null;
  }
  _copy() {
    return new m0();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlFragment}
   */
  clone() {
    const e = new m0();
    return e.insert(0, this.toArray().map((n) => n instanceof Ar ? n.clone() : n)), e;
  }
  get length() {
    return this.doc ?? Kr(), this._prelimContent === null ? this._length : this._prelimContent.length;
  }
  /**
   * Create a subtree of childNodes.
   *
   * @example
   * const walker = elem.createTreeWalker(dom => dom.nodeName === 'div')
   * for (let node in walker) {
   *   // `node` is a div node
   *   nop(node)
   * }
   *
   * @param {function(AbstractType<any>):boolean} filter Function that is called on each child element and
   *                          returns a Boolean indicating whether the child
   *                          is to be included in the subtree.
   * @return {YXmlTreeWalker} A subtree and a position within it.
   *
   * @public
   */
  createTreeWalker(e) {
    return new Xv(this, e);
  }
  /**
   * Returns the first YXmlElement that matches the query.
   * Similar to DOM's {@link querySelector}.
   *
   * Query support:
   *   - tagname
   * TODO:
   *   - id
   *   - attribute
   *
   * @param {CSS_Selector} query The query on the children.
   * @return {YXmlElement|YXmlText|YXmlHook|null} The first element that matches the query or null.
   *
   * @public
   */
  querySelector(e) {
    e = e.toUpperCase();
    const r = new Xv(this, (i) => i.nodeName && i.nodeName.toUpperCase() === e).next();
    return r.done ? null : r.value;
  }
  /**
   * Returns all YXmlElements that match the query.
   * Similar to Dom's {@link querySelectorAll}.
   *
   * @todo Does not yet support all queries. Currently only query by tagName.
   *
   * @param {CSS_Selector} query The query on the children
   * @return {Array<YXmlElement|YXmlText|YXmlHook|null>} The elements that match this query.
   *
   * @public
   */
  querySelectorAll(e) {
    return e = e.toUpperCase(), bl(new Xv(this, (n) => n.nodeName && n.nodeName.toUpperCase() === e));
  }
  /**
   * Creates YXmlEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, n) {
    b5(this, e, new zNt(this, n, e));
  }
  /**
   * Get the string representation of all the children of this YXmlFragment.
   *
   * @return {string} The string representation of all children.
   */
  toString() {
    return uee(this, (e) => e.toString()).join("");
  }
  /**
   * @return {string}
   */
  toJSON() {
    return this.toString();
  }
  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM(e = document, n = {}, r) {
    const i = e.createDocumentFragment();
    return r !== void 0 && r._createAssociation(i, this), _2(this, (a) => {
      i.insertBefore(a.toDOM(e, n, r), null);
    }), i;
  }
  /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {number} index The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */
  insert(e, n) {
    this.doc !== null ? pn(this.doc, (r) => {
      hee(r, this, e, n);
    }) : this._prelimContent.splice(e, 0, ...n);
  }
  /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {null|Item|YXmlElement|YXmlText} ref The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */
  insertAfter(e, n) {
    if (this.doc !== null)
      pn(this.doc, (r) => {
        const i = e && e instanceof Ar ? e._item : e;
        w3(r, this, i, n);
      });
    else {
      const r = (
        /** @type {Array<any>} */
        this._prelimContent
      ), i = e === null ? 0 : r.findIndex((a) => a === e) + 1;
      if (i === 0 && e !== null)
        throw fo("Reference item not found");
      r.splice(i, 0, ...n);
    }
  }
  /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} [length=1] The number of elements to remove. Defaults to 1.
   */
  delete(e, n = 1) {
    this.doc !== null ? pn(this.doc, (r) => {
      pee(r, this, e, n);
    }) : this._prelimContent.splice(e, n);
  }
  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<YXmlElement|YXmlText|YXmlHook>}
   */
  toArray() {
    return lee(this);
  }
  /**
   * Appends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to append.
   */
  push(e) {
    this.insert(this.length, e);
  }
  /**
   * Prepends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to prepend.
   */
  unshift(e) {
    this.insert(0, e);
  }
  /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {YXmlElement|YXmlText}
   */
  get(e) {
    return dee(this, e);
  }
  /**
   * Returns a portion of this YXmlFragment into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<YXmlElement|YXmlText>}
   */
  slice(e = 0, n = this.length) {
    return see(this, e, n);
  }
  /**
   * Executes a provided function on once on every child element.
   *
   * @param {function(YXmlElement|YXmlText,number, typeof self):void} f A function to execute on every element of this YArray.
   */
  forEach(e) {
    _2(this, e);
  }
  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write(e) {
    e.writeTypeRef(XNt);
  }
}
const INt = (t) => new m0();
class si extends m0 {
  constructor(e = "UNDEFINED") {
    super(), this.nodeName = e, this._prelimAttrs = /* @__PURE__ */ new Map();
  }
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get nextSibling() {
    const e = this._item ? this._item.next : null;
    return e ? (
      /** @type {YXmlElement|YXmlText} */
      /** @type {ContentType} */
      e.content.type
    ) : null;
  }
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get prevSibling() {
    const e = this._item ? this._item.prev : null;
    return e ? (
      /** @type {YXmlElement|YXmlText} */
      /** @type {ContentType} */
      e.content.type
    ) : null;
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate(e, n) {
    super._integrate(e, n), /** @type {Map<string, any>} */
    this._prelimAttrs.forEach((r, i) => {
      this.setAttribute(i, r);
    }), this._prelimAttrs = null;
  }
  /**
   * Creates an Item with the same effect as this Item (without position effect)
   *
   * @return {YXmlElement}
   */
  _copy() {
    return new si(this.nodeName);
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlElement<KV>}
   */
  clone() {
    const e = new si(this.nodeName), n = this.getAttributes();
    return ajt(n, (r, i) => {
      typeof r == "string" && e.setAttribute(i, r);
    }), e.insert(0, this.toArray().map((r) => r instanceof Ar ? r.clone() : r)), e;
  }
  /**
   * Returns the XML serialization of this YXmlElement.
   * The attributes are ordered by attribute-name, so you can easily use this
   * method to compare YXmlElements
   *
   * @return {string} The string representation of this type.
   *
   * @public
   */
  toString() {
    const e = this.getAttributes(), n = [], r = [];
    for (const s in e)
      r.push(s);
    r.sort();
    const i = r.length;
    for (let s = 0; s < i; s++) {
      const l = r[s];
      n.push(l + '="' + e[l] + '"');
    }
    const a = this.nodeName.toLocaleLowerCase(), o = n.length > 0 ? " " + n.join(" ") : "";
    return `<${a}${o}>${super.toString()}</${a}>`;
  }
  /**
   * Removes an attribute from this YXmlElement.
   *
   * @param {string} attributeName The attribute name that is to be removed.
   *
   * @public
   */
  removeAttribute(e) {
    this.doc !== null ? pn(this.doc, (n) => {
      k3(n, this, e);
    }) : this._prelimAttrs.delete(e);
  }
  /**
   * Sets or updates an attribute.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that is to be set.
   * @param {KV[KEY]} attributeValue The attribute value that is to be set.
   *
   * @public
   */
  setAttribute(e, n) {
    this.doc !== null ? pn(this.doc, (r) => {
      US(r, this, e, n);
    }) : this._prelimAttrs.set(e, n);
  }
  /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {KV[KEY]|undefined} The queried attribute value.
   *
   * @public
   */
  getAttribute(e) {
    return (
      /** @type {any} */
      WS(this, e)
    );
  }
  /**
   * Returns whether an attribute exists
   *
   * @param {string} attributeName The attribute name to check for existence.
   * @return {boolean} whether the attribute exists.
   *
   * @public
   */
  hasAttribute(e) {
    return (
      /** @type {any} */
      yee(this, e)
    );
  }
  /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @param {Snapshot} [snapshot]
   * @return {{ [Key in Extract<keyof KV,string>]?: KV[Key]}} A JSON Object that describes the attributes.
   *
   * @public
   */
  getAttributes(e) {
    return (
      /** @type {any} */
      e ? MNt(this, e) : mee(this)
    );
  }
  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM(e = document, n = {}, r) {
    const i = e.createElement(this.nodeName), a = this.getAttributes();
    for (const o in a) {
      const s = a[o];
      typeof s == "string" && i.setAttribute(o, s);
    }
    return _2(this, (o) => {
      i.appendChild(o.toDOM(e, n, r));
    }), r !== void 0 && r._createAssociation(i, this), i;
  }
  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write(e) {
    e.writeTypeRef(QNt), e.writeKey(this.nodeName);
  }
}
const PNt = (t) => new si(t.readKey());
class zNt extends g5 {
  /**
   * @param {YXmlElement|YXmlText|YXmlFragment} target The target on which the event is created.
   * @param {Set<string|null>} subs The set of changed attributes. `null` is included if the
   *                   child list changed.
   * @param {Transaction} transaction The transaction instance with which the
   *                                  change was created.
   */
  constructor(e, n, r) {
    super(e, r), this.childListChanged = !1, this.attributesChanged = /* @__PURE__ */ new Set(), n.forEach((i) => {
      i === null ? this.childListChanged = !0 : this.attributesChanged.add(i);
    });
  }
}
class x3 extends pd {
  /**
   * @param {string} hookName nodeName of the Dom Node.
   */
  constructor(e) {
    super(), this.hookName = e;
  }
  /**
   * Creates an Item with the same effect as this Item (without position effect)
   */
  _copy() {
    return new x3(this.hookName);
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlHook}
   */
  clone() {
    const e = new x3(this.hookName);
    return this.forEach((n, r) => {
      e.set(r, n);
    }), e;
  }
  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object.<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type
   * @return {Element} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM(e = document, n = {}, r) {
    const i = n[this.hookName];
    let a;
    return i !== void 0 ? a = i.createDom(this) : a = document.createElement(this.hookName), a.setAttribute("data-yjs-hook", this.hookName), r !== void 0 && r._createAssociation(a, this), a;
  }
  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write(e) {
    e.writeTypeRef(eDt), e.writeKey(this.hookName);
  }
}
const RNt = (t) => new x3(t.readKey());
class ea extends Nc {
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get nextSibling() {
    const e = this._item ? this._item.next : null;
    return e ? (
      /** @type {YXmlElement|YXmlText} */
      /** @type {ContentType} */
      e.content.type
    ) : null;
  }
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get prevSibling() {
    const e = this._item ? this._item.prev : null;
    return e ? (
      /** @type {YXmlElement|YXmlText} */
      /** @type {ContentType} */
      e.content.type
    ) : null;
  }
  _copy() {
    return new ea();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlText}
   */
  clone() {
    const e = new ea();
    return e.applyDelta(this.toDelta()), e;
  }
  /**
   * Creates a Dom Element that mirrors this YXmlText.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Text} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM(e = document, n, r) {
    const i = e.createTextNode(this.toString());
    return r !== void 0 && r._createAssociation(i, this), i;
  }
  toString() {
    return this.toDelta().map((e) => {
      const n = [];
      for (const i in e.attributes) {
        const a = [];
        for (const o in e.attributes[i])
          a.push({ key: o, value: e.attributes[i][o] });
        a.sort((o, s) => o.key < s.key ? -1 : 1), n.push({ nodeName: i, attrs: a });
      }
      n.sort((i, a) => i.nodeName < a.nodeName ? -1 : 1);
      let r = "";
      for (let i = 0; i < n.length; i++) {
        const a = n[i];
        r += `<${a.nodeName}`;
        for (let o = 0; o < a.attrs.length; o++) {
          const s = a.attrs[o];
          r += ` ${s.key}="${s.value}"`;
        }
        r += ">";
      }
      r += e.insert;
      for (let i = n.length - 1; i >= 0; i--)
        r += `</${n[i].nodeName}>`;
      return r;
    }).join("");
  }
  /**
   * @return {string}
   */
  toJSON() {
    return this.toString();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write(e) {
    e.writeTypeRef(tDt);
  }
}
const ONt = (t) => new ea();
class ZS {
  /**
   * @param {ID} id
   * @param {number} length
   */
  constructor(e, n) {
    this.id = e, this.length = n;
  }
  /**
   * @type {boolean}
   */
  get deleted() {
    throw ro();
  }
  /**
   * Merge this struct with the item to the right.
   * This method is already assuming that `this.id.clock + this.length === this.id.clock`.
   * Also this method does *not* remove right from StructStore!
   * @param {AbstractStruct} right
   * @return {boolean} whether this merged with right
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   * @param {number} encodingRef
   */
  write(e, n, r) {
    throw ro();
  }
  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate(e, n) {
    throw ro();
  }
}
const BNt = 0;
class xa extends ZS {
  get deleted() {
    return !0;
  }
  delete() {
  }
  /**
   * @param {GC} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.constructor !== e.constructor ? !1 : (this.length += e.length, !0);
  }
  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate(e, n) {
    n > 0 && (this.id.clock += n, this.length -= n), eee(e.doc.store, this);
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeInfo(BNt), e.writeLen(this.length - n);
  }
  /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing(e, n) {
    return null;
  }
}
class rm {
  /**
   * @param {Uint8Array} content
   */
  constructor(e) {
    this.content = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [this.content];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentBinary}
   */
  copy() {
    return new rm(this.content);
  }
  /**
   * @param {number} offset
   * @return {ContentBinary}
   */
  splice(e) {
    throw ro();
  }
  /**
   * @param {ContentBinary} right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeBuf(this.content);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 3;
  }
}
const HNt = (t) => new rm(t.readBuf());
class V2 {
  /**
   * @param {number} len
   */
  constructor(e) {
    this.len = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return this.len;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !1;
  }
  /**
   * @return {ContentDeleted}
   */
  copy() {
    return new V2(this.len);
  }
  /**
   * @param {number} offset
   * @return {ContentDeleted}
   */
  splice(e) {
    const n = new V2(this.len - e);
    return this.len = e, n;
  }
  /**
   * @param {ContentDeleted} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.len += e.len, !0;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
    z2(e.deleteSet, n.id.client, n.id.clock, this.len), n.markDeleted();
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeLen(this.len - n);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 1;
  }
}
const FNt = (t) => new V2(t.readLen()), kee = (t, e) => new Ll({ guid: t, ...e, shouldLoad: e.shouldLoad || e.autoLoad || !1 });
class im {
  /**
   * @param {Doc} doc
   */
  constructor(e) {
    e._item && console.error("This document was already integrated as a sub-document. You should create a second instance instead with the same guid."), this.doc = e;
    const n = {};
    this.opts = n, e.gc || (n.gc = !1), e.autoLoad && (n.autoLoad = !0), e.meta !== null && (n.meta = e.meta);
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [this.doc];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentDoc}
   */
  copy() {
    return new im(kee(this.doc.guid, this.opts));
  }
  /**
   * @param {number} offset
   * @return {ContentDoc}
   */
  splice(e) {
    throw ro();
  }
  /**
   * @param {ContentDoc} right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
    this.doc._item = n, e.subdocsAdded.add(this.doc), this.doc.shouldLoad && e.subdocsLoaded.add(this.doc);
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
    e.subdocsAdded.has(this.doc) ? e.subdocsAdded.delete(this.doc) : e.subdocsRemoved.add(this.doc);
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeString(this.doc.guid), e.writeAny(this.opts);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 9;
  }
}
const _Nt = (t) => new im(kee(t.readString(), t.readAny()));
class E0 {
  /**
   * @param {Object} embed
   */
  constructor(e) {
    this.embed = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [this.embed];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentEmbed}
   */
  copy() {
    return new E0(this.embed);
  }
  /**
   * @param {number} offset
   * @return {ContentEmbed}
   */
  splice(e) {
    throw ro();
  }
  /**
   * @param {ContentEmbed} right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeJSON(this.embed);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 5;
  }
}
const VNt = (t) => new E0(t.readJSON());
class lr {
  /**
   * @param {string} key
   * @param {Object} value
   */
  constructor(e, n) {
    this.key = e, this.value = n;
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !1;
  }
  /**
   * @return {ContentFormat}
   */
  copy() {
    return new lr(this.key, this.value);
  }
  /**
   * @param {number} _offset
   * @return {ContentFormat}
   */
  splice(e) {
    throw ro();
  }
  /**
   * @param {ContentFormat} _right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} _transaction
   * @param {Item} item
   */
  integrate(e, n) {
    const r = (
      /** @type {YText} */
      n.parent
    );
    r._searchMarker = null, r._hasFormatting = !0;
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeKey(this.key), e.writeJSON(this.value);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 6;
  }
}
const qNt = (t) => new lr(t.readKey(), t.readJSON());
class M3 {
  /**
   * @param {Array<any>} arr
   */
  constructor(e) {
    this.arr = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return this.arr.length;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return this.arr;
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentJSON}
   */
  copy() {
    return new M3(this.arr);
  }
  /**
   * @param {number} offset
   * @return {ContentJSON}
   */
  splice(e) {
    const n = new M3(this.arr.slice(e));
    return this.arr = this.arr.slice(0, e), n;
  }
  /**
   * @param {ContentJSON} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.arr = this.arr.concat(e.arr), !0;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    const r = this.arr.length;
    e.writeLen(r - n);
    for (let i = n; i < r; i++) {
      const a = this.arr[i];
      e.writeString(a === void 0 ? "undefined" : JSON.stringify(a));
    }
  }
  /**
   * @return {number}
   */
  getRef() {
    return 2;
  }
}
const UNt = (t) => {
  const e = t.readLen(), n = [];
  for (let r = 0; r < e; r++) {
    const i = t.readString();
    i === "undefined" ? n.push(void 0) : n.push(JSON.parse(i));
  }
  return new M3(n);
}, WNt = P2("node_env") === "development";
class y0 {
  /**
   * @param {Array<any>} arr
   */
  constructor(e) {
    this.arr = e, WNt && SX(e);
  }
  /**
   * @return {number}
   */
  getLength() {
    return this.arr.length;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return this.arr;
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentAny}
   */
  copy() {
    return new y0(this.arr);
  }
  /**
   * @param {number} offset
   * @return {ContentAny}
   */
  splice(e) {
    const n = new y0(this.arr.slice(e));
    return this.arr = this.arr.slice(0, e), n;
  }
  /**
   * @param {ContentAny} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.arr = this.arr.concat(e.arr), !0;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    const r = this.arr.length;
    e.writeLen(r - n);
    for (let i = n; i < r; i++) {
      const a = this.arr[i];
      e.writeAny(a);
    }
  }
  /**
   * @return {number}
   */
  getRef() {
    return 8;
  }
}
const ZNt = (t) => {
  const e = t.readLen(), n = [];
  for (let r = 0; r < e; r++)
    n.push(t.readAny());
  return new y0(n);
};
class ho {
  /**
   * @param {string} str
   */
  constructor(e) {
    this.str = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return this.str.length;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return this.str.split("");
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentString}
   */
  copy() {
    return new ho(this.str);
  }
  /**
   * @param {number} offset
   * @return {ContentString}
   */
  splice(e) {
    const n = new ho(this.str.slice(e));
    this.str = this.str.slice(0, e);
    const r = this.str.charCodeAt(e - 1);
    return r >= 55296 && r <= 56319 && (this.str = this.str.slice(0, e - 1) + "�", n.str = "�" + n.str.slice(1)), n;
  }
  /**
   * @param {ContentString} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.str += e.str, !0;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeString(n === 0 ? this.str : this.str.slice(n));
  }
  /**
   * @return {number}
   */
  getRef() {
    return 4;
  }
}
const GNt = (t) => new ho(t.readString()), YNt = [
  ANt,
  LNt,
  DNt,
  PNt,
  INt,
  RNt,
  ONt
], KNt = 0, $Nt = 1, JNt = 2, QNt = 3, XNt = 4, eDt = 5, tDt = 6;
class ko {
  /**
   * @param {AbstractType<any>} type
   */
  constructor(e) {
    this.type = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [this.type];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentType}
   */
  copy() {
    return new ko(this.type._copy());
  }
  /**
   * @param {number} offset
   * @return {ContentType}
   */
  splice(e) {
    throw ro();
  }
  /**
   * @param {ContentType} right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
    this.type._integrate(e.doc, n);
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
    let n = this.type._start;
    for (; n !== null; )
      n.deleted ? n.id.clock < (e.beforeState.get(n.id.client) || 0) && e._mergeStructs.push(n) : n.delete(e), n = n.right;
    this.type._map.forEach((r) => {
      r.deleted ? r.id.clock < (e.beforeState.get(r.id.client) || 0) && e._mergeStructs.push(r) : r.delete(e);
    }), e.changed.delete(this.type);
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
    let n = this.type._start;
    for (; n !== null; )
      n.gc(e, !0), n = n.right;
    this.type._start = null, this.type._map.forEach(
      /** @param {Item | null} item */
      (r) => {
        for (; r !== null; )
          r.gc(e, !0), r = r.left;
      }
    ), this.type._map = /* @__PURE__ */ new Map();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    this.type._write(e);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 7;
  }
}
const nDt = (t) => new ko(YNt[t.readTypeRef()](t)), Jw = (t, e) => {
  let n = e, r = 0, i;
  do
    r > 0 && (n = Bt(n.client, n.clock + r)), i = A1(t, n), r = n.clock - i.id.clock, n = i.redone;
  while (n !== null && i instanceof wn);
  return {
    item: i,
    diff: r
  };
}, GS = (t, e) => {
  for (; t !== null && t.keep !== e; )
    t.keep = e, t = /** @type {AbstractType<any>} */
    t.parent._item;
}, C3 = (t, e, n) => {
  const { client: r, clock: i } = e.id, a = new wn(
    Bt(r, i + n),
    e,
    Bt(r, i + n - 1),
    e.right,
    e.rightOrigin,
    e.parent,
    e.parentSub,
    e.content.splice(n)
  );
  return e.deleted && a.markDeleted(), e.keep && (a.keep = !0), e.redone !== null && (a.redone = Bt(e.redone.client, e.redone.clock + n)), e.right = a, a.right !== null && (a.right.left = a), t._mergeStructs.push(a), a.parentSub !== null && a.right === null && a.parent._map.set(a.parentSub, a), e.length = n, a;
}, Rz = (t, e) => bEt(
  t,
  /** @param {StackItem} s */
  (n) => Zd(n.deletions, e)
), xee = (t, e, n, r, i, a) => {
  const o = t.doc, s = o.store, l = o.clientID, c = e.redone;
  if (c !== null)
    return Ai(t, c);
  let u = (
    /** @type {AbstractType<any>} */
    e.parent._item
  ), d = null, f;
  if (u !== null && u.deleted === !0) {
    if (u.redone === null && (!n.has(u) || xee(t, u, n, r, i, a) === null))
      return null;
    for (; u.redone !== null; )
      u = Ai(t, u.redone);
  }
  const h = u === null ? (
    /** @type {AbstractType<any>} */
    e.parent
  ) : (
    /** @type {ContentType} */
    u.content.type
  );
  if (e.parentSub === null) {
    for (d = e.left, f = e; d !== null; ) {
      let v = d;
      for (; v !== null && /** @type {AbstractType<any>} */
      v.parent._item !== u; )
        v = v.redone === null ? null : Ai(t, v.redone);
      if (v !== null && /** @type {AbstractType<any>} */
      v.parent._item === u) {
        d = v;
        break;
      }
      d = d.left;
    }
    for (; f !== null; ) {
      let v = f;
      for (; v !== null && /** @type {AbstractType<any>} */
      v.parent._item !== u; )
        v = v.redone === null ? null : Ai(t, v.redone);
      if (v !== null && /** @type {AbstractType<any>} */
      v.parent._item === u) {
        f = v;
        break;
      }
      f = f.right;
    }
  } else if (f = null, e.right && !i) {
    for (d = e; d !== null && d.right !== null && (d.right.redone || Zd(r, d.right.id) || Rz(a.undoStack, d.right.id) || Rz(a.redoStack, d.right.id)); )
      for (d = d.right; d.redone; ) d = Ai(t, d.redone);
    if (d && d.right !== null)
      return null;
  } else
    d = h._map.get(e.parentSub) || null;
  const p = nr(s, l), m = Bt(l, p), g = new wn(
    m,
    d,
    d && d.lastId,
    f,
    f && f.id,
    h,
    e.parentSub,
    e.content.copy()
  );
  return e.redone = m, GS(g, !0), g.integrate(t, 0), g;
};
let wn = class Qw extends ZS {
  /**
   * @param {ID} id
   * @param {Item | null} left
   * @param {ID | null} origin
   * @param {Item | null} right
   * @param {ID | null} rightOrigin
   * @param {AbstractType<any>|ID|null} parent Is a type if integrated, is null if it is possible to copy parent from left or right, is ID before integration to search for it.
   * @param {string | null} parentSub
   * @param {AbstractContent} content
   */
  constructor(e, n, r, i, a, o, s, l) {
    super(e, l.getLength()), this.origin = r, this.left = n, this.right = i, this.rightOrigin = a, this.parent = o, this.parentSub = s, this.redone = null, this.content = l, this.info = this.content.isCountable() ? uz : 0;
  }
  /**
   * This is used to mark the item as an indexed fast-search marker
   *
   * @type {boolean}
   */
  set marker(e) {
    (this.info & Wv) > 0 !== e && (this.info ^= Wv);
  }
  get marker() {
    return (this.info & Wv) > 0;
  }
  /**
   * If true, do not garbage collect this Item.
   */
  get keep() {
    return (this.info & cz) > 0;
  }
  set keep(e) {
    this.keep !== e && (this.info ^= cz);
  }
  get countable() {
    return (this.info & uz) > 0;
  }
  /**
   * Whether this item was deleted or not.
   * @type {Boolean}
   */
  get deleted() {
    return (this.info & Uv) > 0;
  }
  set deleted(e) {
    this.deleted !== e && (this.info ^= Uv);
  }
  markDeleted() {
    this.info |= Uv;
  }
  /**
   * Return the creator clientID of the missing op or define missing items and return null.
   *
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing(e, n) {
    if (this.origin && this.origin.client !== this.id.client && this.origin.clock >= nr(n, this.origin.client))
      return this.origin.client;
    if (this.rightOrigin && this.rightOrigin.client !== this.id.client && this.rightOrigin.clock >= nr(n, this.rightOrigin.client))
      return this.rightOrigin.client;
    if (this.parent && this.parent.constructor === C1 && this.id.client !== this.parent.client && this.parent.clock >= nr(n, this.parent.client))
      return this.parent.client;
    if (this.origin && (this.left = Lz(e, n, this.origin), this.origin = this.left.lastId), this.rightOrigin && (this.right = Ai(e, this.rightOrigin), this.rightOrigin = this.right.id), this.left && this.left.constructor === xa || this.right && this.right.constructor === xa)
      this.parent = null;
    else if (!this.parent)
      this.left && this.left.constructor === Qw ? (this.parent = this.left.parent, this.parentSub = this.left.parentSub) : this.right && this.right.constructor === Qw && (this.parent = this.right.parent, this.parentSub = this.right.parentSub);
    else if (this.parent.constructor === C1) {
      const r = A1(n, this.parent);
      r.constructor === xa ? this.parent = null : this.parent = /** @type {ContentType} */
      r.content.type;
    }
    return null;
  }
  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate(e, n) {
    if (n > 0 && (this.id.clock += n, this.left = Lz(e, e.doc.store, Bt(this.id.client, this.id.clock - 1)), this.origin = this.left.lastId, this.content = this.content.splice(n), this.length -= n), this.parent) {
      if (!this.left && (!this.right || this.right.left !== null) || this.left && this.left.right !== this.right) {
        let r = this.left, i;
        if (r !== null)
          i = r.right;
        else if (this.parentSub !== null)
          for (i = /** @type {AbstractType<any>} */
          this.parent._map.get(this.parentSub) || null; i !== null && i.left !== null; )
            i = i.left;
        else
          i = /** @type {AbstractType<any>} */
          this.parent._start;
        const a = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set();
        for (; i !== null && i !== this.right; ) {
          if (o.add(i), a.add(i), p1(this.origin, i.origin)) {
            if (i.id.client < this.id.client)
              r = i, a.clear();
            else if (p1(this.rightOrigin, i.rightOrigin))
              break;
          } else if (i.origin !== null && o.has(A1(e.doc.store, i.origin)))
            a.has(A1(e.doc.store, i.origin)) || (r = i, a.clear());
          else
            break;
          i = i.right;
        }
        this.left = r;
      }
      if (this.left !== null) {
        const r = this.left.right;
        this.right = r, this.left.right = this;
      } else {
        let r;
        if (this.parentSub !== null)
          for (r = /** @type {AbstractType<any>} */
          this.parent._map.get(this.parentSub) || null; r !== null && r.left !== null; )
            r = r.left;
        else
          r = /** @type {AbstractType<any>} */
          this.parent._start, this.parent._start = this;
        this.right = r;
      }
      this.right !== null ? this.right.left = this : this.parentSub !== null && (this.parent._map.set(this.parentSub, this), this.left !== null && this.left.delete(e)), this.parentSub === null && this.countable && !this.deleted && (this.parent._length += this.length), eee(e.doc.store, this), this.content.integrate(e, this), Ez(
        e,
        /** @type {AbstractType<any>} */
        this.parent,
        this.parentSub
      ), /** @type {AbstractType<any>} */
      (this.parent._item !== null && /** @type {AbstractType<any>} */
      this.parent._item.deleted || this.parentSub !== null && this.right !== null) && this.delete(e);
    } else
      new xa(this.id, this.length).integrate(e, 0);
  }
  /**
   * Returns the next non-deleted item
   */
  get next() {
    let e = this.right;
    for (; e !== null && e.deleted; )
      e = e.right;
    return e;
  }
  /**
   * Returns the previous non-deleted item
   */
  get prev() {
    let e = this.left;
    for (; e !== null && e.deleted; )
      e = e.left;
    return e;
  }
  /**
   * Computes the last content address of this Item.
   */
  get lastId() {
    return this.length === 1 ? this.id : Bt(this.id.client, this.id.clock + this.length - 1);
  }
  /**
   * Try to merge two items
   *
   * @param {Item} right
   * @return {boolean}
   */
  mergeWith(e) {
    if (this.constructor === e.constructor && p1(e.origin, this.lastId) && this.right === e && p1(this.rightOrigin, e.rightOrigin) && this.id.client === e.id.client && this.id.clock + this.length === e.id.clock && this.deleted === e.deleted && this.redone === null && e.redone === null && this.content.constructor === e.content.constructor && this.content.mergeWith(e.content)) {
      const n = (
        /** @type {AbstractType<any>} */
        this.parent._searchMarker
      );
      return n && n.forEach((r) => {
        r.p === e && (r.p = this, !this.deleted && this.countable && (r.index -= this.length));
      }), e.keep && (this.keep = !0), this.right = e.right, this.right !== null && (this.right.left = this), this.length += e.length, !0;
    }
    return !1;
  }
  /**
   * Mark this Item as deleted.
   *
   * @param {Transaction} transaction
   */
  delete(e) {
    if (!this.deleted) {
      const n = (
        /** @type {AbstractType<any>} */
        this.parent
      );
      this.countable && this.parentSub === null && (n._length -= this.length), this.markDeleted(), z2(e.deleteSet, this.id.client, this.id.clock, this.length), Ez(e, n, this.parentSub), this.content.delete(e);
    }
  }
  /**
   * @param {StructStore} store
   * @param {boolean} parentGCd
   */
  gc(e, n) {
    if (!this.deleted)
      throw aa();
    this.content.gc(e), n ? sNt(e, this, new xa(this.id, this.length)) : this.content = new V2(this.length);
  }
  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   */
  write(e, n) {
    const r = n > 0 ? Bt(this.id.client, this.id.clock + n - 1) : this.origin, i = this.rightOrigin, a = this.parentSub, o = this.content.getRef() & f5 | (r === null ? 0 : Xi) | // origin is defined
    (i === null ? 0 : Xs) | // right origin is defined
    (a === null ? 0 : N2);
    if (e.writeInfo(o), r !== null && e.writeLeftID(r), i !== null && e.writeRightID(i), r === null && i === null) {
      const s = (
        /** @type {AbstractType<any>} */
        this.parent
      );
      if (s._item !== void 0) {
        const l = s._item;
        if (l === null) {
          const c = R2(s);
          e.writeParentInfo(!0), e.writeString(c);
        } else
          e.writeParentInfo(!1), e.writeLeftID(l.id);
      } else s.constructor === String ? (e.writeParentInfo(!0), e.writeString(s)) : s.constructor === C1 ? (e.writeParentInfo(!1), e.writeLeftID(s)) : aa();
      a !== null && e.writeString(a);
    }
    this.content.write(e, n);
  }
};
const Mee = (t, e) => rDt[e & f5](t), rDt = [
  () => {
    aa();
  },
  // GC is not ItemContent
  FNt,
  // 1
  UNt,
  // 2
  HNt,
  // 3
  GNt,
  // 4
  VNt,
  // 5
  qNt,
  // 6
  nDt,
  // 7
  ZNt,
  // 8
  _Nt,
  // 9
  () => {
    aa();
  }
  // 10 - Skip is not ItemContent
], iDt = 10;
class Ma extends ZS {
  get deleted() {
    return !0;
  }
  delete() {
  }
  /**
   * @param {Skip} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.constructor !== e.constructor ? !1 : (this.length += e.length, !0);
  }
  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate(e, n) {
    aa();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeInfo(iDt), bt(e.restEncoder, this.length - n);
  }
  /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing(e, n) {
    return null;
  }
}
const Cee = (
  /** @type {any} */
  typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : {}
), Aee = "__ $YJS$ __";
Cee[Aee] === !0 && console.error("Yjs was already imported. This breaks constructor checks and will lead to issues! - https://github.com/yjs/yjs/issues/438");
Cee[Aee] = !0;
function o4(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var See = { exports: {} };
(function(t, e) {
  (function(n) {
    t.exports = n();
  })(function() {
    var n = Math.floor, r = Math.abs, i = Math.pow;
    return (/* @__PURE__ */ function() {
      function a(o, s, l) {
        function c(f, h) {
          if (!s[f]) {
            if (!o[f]) {
              var p = typeof o4 == "function" && o4;
              if (!h && p) return p(f, !0);
              if (u) return u(f, !0);
              var m = new Error("Cannot find module '" + f + "'");
              throw m.code = "MODULE_NOT_FOUND", m;
            }
            var g = s[f] = { exports: {} };
            o[f][0].call(g.exports, function(v) {
              var k = o[f][1][v];
              return c(k || v);
            }, g, g.exports, a, o, s, l);
          }
          return s[f].exports;
        }
        for (var u = typeof o4 == "function" && o4, d = 0; d < l.length; d++) c(l[d]);
        return c;
      }
      return a;
    }())({ 1: [function(a, o, s) {
      function l(b) {
        var x = b.length;
        if (0 < x % 4) throw new Error("Invalid string. Length must be a multiple of 4");
        var A = b.indexOf("=");
        A === -1 && (A = x);
        var L = A === x ? 0 : 4 - A % 4;
        return [A, L];
      }
      function c(b, x, A) {
        return 3 * (x + A) / 4 - A;
      }
      function u(b) {
        var x, A, L = l(b), M = L[0], j = L[1], D = new g(c(b, M, j)), z = 0, H = 0 < j ? M - 4 : M;
        for (A = 0; A < H; A += 4) x = m[b.charCodeAt(A)] << 18 | m[b.charCodeAt(A + 1)] << 12 | m[b.charCodeAt(A + 2)] << 6 | m[b.charCodeAt(A + 3)], D[z++] = 255 & x >> 16, D[z++] = 255 & x >> 8, D[z++] = 255 & x;
        return j === 2 && (x = m[b.charCodeAt(A)] << 2 | m[b.charCodeAt(A + 1)] >> 4, D[z++] = 255 & x), j === 1 && (x = m[b.charCodeAt(A)] << 10 | m[b.charCodeAt(A + 1)] << 4 | m[b.charCodeAt(A + 2)] >> 2, D[z++] = 255 & x >> 8, D[z++] = 255 & x), D;
      }
      function d(b) {
        return p[63 & b >> 18] + p[63 & b >> 12] + p[63 & b >> 6] + p[63 & b];
      }
      function f(b, x, A) {
        for (var L, M = [], j = x; j < A; j += 3) L = (16711680 & b[j] << 16) + (65280 & b[j + 1] << 8) + (255 & b[j + 2]), M.push(d(L));
        return M.join("");
      }
      function h(b) {
        for (var x, A = b.length, L = A % 3, M = [], j = 16383, D = 0, z = A - L; D < z; D += j) M.push(f(b, D, D + j > z ? z : D + j));
        return L === 1 ? (x = b[A - 1], M.push(p[x >> 2] + p[63 & x << 4] + "==")) : L === 2 && (x = (b[A - 2] << 8) + b[A - 1], M.push(p[x >> 10] + p[63 & x >> 4] + p[63 & x << 2] + "=")), M.join("");
      }
      s.byteLength = function(b) {
        var x = l(b), A = x[0], L = x[1];
        return 3 * (A + L) / 4 - L;
      }, s.toByteArray = u, s.fromByteArray = h;
      for (var p = [], m = [], g = typeof Uint8Array > "u" ? Array : Uint8Array, v = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", k = 0, w = v.length; k < w; ++k) p[k] = v[k], m[v.charCodeAt(k)] = k;
      m[45] = 62, m[95] = 63;
    }, {}], 2: [function() {
    }, {}], 3: [function(a, o, s) {
      (function() {
        (function() {
          var l = String.fromCharCode, c = Math.min;
          function u(S) {
            if (2147483647 < S) throw new RangeError('The value "' + S + '" is invalid for option "size"');
            var P = new Uint8Array(S);
            return P.__proto__ = d.prototype, P;
          }
          function d(S, P, O) {
            if (typeof S == "number") {
              if (typeof P == "string") throw new TypeError('The "string" argument must be of type string. Received type number');
              return m(S);
            }
            return f(S, P, O);
          }
          function f(S, P, O) {
            if (typeof S == "string") return g(S, P);
            if (ArrayBuffer.isView(S)) return v(S);
            if (S == null) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof S);
            if (K(S, ArrayBuffer) || S && K(S.buffer, ArrayBuffer)) return k(S, P, O);
            if (typeof S == "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
            var ne = S.valueOf && S.valueOf();
            if (ne != null && ne !== S) return d.from(ne, P, O);
            var le = w(S);
            if (le) return le;
            if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof S[Symbol.toPrimitive] == "function") return d.from(S[Symbol.toPrimitive]("string"), P, O);
            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof S);
          }
          function h(S) {
            if (typeof S != "number") throw new TypeError('"size" argument must be of type number');
            if (0 > S) throw new RangeError('The value "' + S + '" is invalid for option "size"');
          }
          function p(S, P, O) {
            return h(S), 0 >= S || P === void 0 ? u(S) : typeof O == "string" ? u(S).fill(P, O) : u(S).fill(P);
          }
          function m(S) {
            return h(S), u(0 > S ? 0 : 0 | b(S));
          }
          function g(S, P) {
            if ((typeof P != "string" || P === "") && (P = "utf8"), !d.isEncoding(P)) throw new TypeError("Unknown encoding: " + P);
            var O = 0 | x(S, P), ne = u(O), le = ne.write(S, P);
            return le !== O && (ne = ne.slice(0, le)), ne;
          }
          function v(S) {
            for (var P = 0 > S.length ? 0 : 0 | b(S.length), O = u(P), ne = 0; ne < P; ne += 1) O[ne] = 255 & S[ne];
            return O;
          }
          function k(S, P, O) {
            if (0 > P || S.byteLength < P) throw new RangeError('"offset" is outside of buffer bounds');
            if (S.byteLength < P + (O || 0)) throw new RangeError('"length" is outside of buffer bounds');
            var ne;
            return ne = P === void 0 && O === void 0 ? new Uint8Array(S) : O === void 0 ? new Uint8Array(S, P) : new Uint8Array(S, P, O), ne.__proto__ = d.prototype, ne;
          }
          function w(S) {
            if (d.isBuffer(S)) {
              var P = 0 | b(S.length), O = u(P);
              return O.length === 0 || S.copy(O, 0, 0, P), O;
            }
            return S.length === void 0 ? S.type === "Buffer" && Array.isArray(S.data) ? v(S.data) : void 0 : typeof S.length != "number" || X(S.length) ? u(0) : v(S);
          }
          function b(S) {
            if (S >= 2147483647) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x7fffffff bytes");
            return 0 | S;
          }
          function x(S, P) {
            if (d.isBuffer(S)) return S.length;
            if (ArrayBuffer.isView(S) || K(S, ArrayBuffer)) return S.byteLength;
            if (typeof S != "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof S);
            var O = S.length, ne = 2 < arguments.length && arguments[2] === !0;
            if (!ne && O === 0) return 0;
            for (var le = !1; ; ) switch (P) {
              case "ascii":
              case "latin1":
              case "binary":
                return O;
              case "utf8":
              case "utf-8":
                return je(S).length;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return 2 * O;
              case "hex":
                return O >>> 1;
              case "base64":
                return pe(S).length;
              default:
                if (le) return ne ? -1 : je(S).length;
                P = ("" + P).toLowerCase(), le = !0;
            }
          }
          function A(S, P, O) {
            var ne = !1;
            if ((P === void 0 || 0 > P) && (P = 0), P > this.length || ((O === void 0 || O > this.length) && (O = this.length), 0 >= O) || (O >>>= 0, P >>>= 0, O <= P)) return "";
            for (S || (S = "utf8"); ; ) switch (S) {
              case "hex":
                return ee(this, P, O);
              case "utf8":
              case "utf-8":
                return G(this, P, O);
              case "ascii":
                return Z(this, P, O);
              case "latin1":
              case "binary":
                return oe(this, P, O);
              case "base64":
                return W(this, P, O);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return ae(this, P, O);
              default:
                if (ne) throw new TypeError("Unknown encoding: " + S);
                S = (S + "").toLowerCase(), ne = !0;
            }
          }
          function L(S, P, O) {
            var ne = S[P];
            S[P] = S[O], S[O] = ne;
          }
          function M(S, P, O, ne, le) {
            if (S.length === 0) return -1;
            if (typeof O == "string" ? (ne = O, O = 0) : 2147483647 < O ? O = 2147483647 : -2147483648 > O && (O = -2147483648), O = +O, X(O) && (O = le ? 0 : S.length - 1), 0 > O && (O = S.length + O), O >= S.length) {
              if (le) return -1;
              O = S.length - 1;
            } else if (0 > O) if (le) O = 0;
            else return -1;
            if (typeof P == "string" && (P = d.from(P, ne)), d.isBuffer(P)) return P.length === 0 ? -1 : j(S, P, O, ne, le);
            if (typeof P == "number") return P &= 255, typeof Uint8Array.prototype.indexOf == "function" ? le ? Uint8Array.prototype.indexOf.call(S, P, O) : Uint8Array.prototype.lastIndexOf.call(S, P, O) : j(S, [P], O, ne, le);
            throw new TypeError("val must be string, number or Buffer");
          }
          function j(S, P, O, ne, le) {
            function de(Nt, ye) {
              return Pe === 1 ? Nt[ye] : Nt.readUInt16BE(ye * Pe);
            }
            var Pe = 1, ve = S.length, Le = P.length;
            if (ne !== void 0 && (ne = (ne + "").toLowerCase(), ne === "ucs2" || ne === "ucs-2" || ne === "utf16le" || ne === "utf-16le")) {
              if (2 > S.length || 2 > P.length) return -1;
              Pe = 2, ve /= 2, Le /= 2, O /= 2;
            }
            var Re;
            if (le) {
              var Ke = -1;
              for (Re = O; Re < ve; Re++) if (de(S, Re) !== de(P, Ke === -1 ? 0 : Re - Ke)) Ke !== -1 && (Re -= Re - Ke), Ke = -1;
              else if (Ke === -1 && (Ke = Re), Re - Ke + 1 === Le) return Ke * Pe;
            } else for (O + Le > ve && (O = ve - Le), Re = O; 0 <= Re; Re--) {
              for (var mt = !0, pt = 0; pt < Le; pt++) if (de(S, Re + pt) !== de(P, pt)) {
                mt = !1;
                break;
              }
              if (mt) return Re;
            }
            return -1;
          }
          function D(S, P, O, ne) {
            O = +O || 0;
            var le = S.length - O;
            ne ? (ne = +ne, ne > le && (ne = le)) : ne = le;
            var de = P.length;
            ne > de / 2 && (ne = de / 2);
            for (var Pe, ve = 0; ve < ne; ++ve) {
              if (Pe = parseInt(P.substr(2 * ve, 2), 16), X(Pe)) return ve;
              S[O + ve] = Pe;
            }
            return ve;
          }
          function z(S, P, O, ne) {
            return J(je(P, S.length - O), S, O, ne);
          }
          function H(S, P, O, ne) {
            return J(Me(P), S, O, ne);
          }
          function V(S, P, O, ne) {
            return H(S, P, O, ne);
          }
          function F(S, P, O, ne) {
            return J(pe(P), S, O, ne);
          }
          function _(S, P, O, ne) {
            return J(he(P, S.length - O), S, O, ne);
          }
          function W(S, P, O) {
            return P === 0 && O === S.length ? re.fromByteArray(S) : re.fromByteArray(S.slice(P, O));
          }
          function G(S, P, O) {
            O = c(S.length, O);
            for (var ne = [], le = P; le < O; ) {
              var de = S[le], Pe = null, ve = 239 < de ? 4 : 223 < de ? 3 : 191 < de ? 2 : 1;
              if (le + ve <= O) {
                var Le, Re, Ke, mt;
                ve === 1 ? 128 > de && (Pe = de) : ve === 2 ? (Le = S[le + 1], (192 & Le) == 128 && (mt = (31 & de) << 6 | 63 & Le, 127 < mt && (Pe = mt))) : ve === 3 ? (Le = S[le + 1], Re = S[le + 2], (192 & Le) == 128 && (192 & Re) == 128 && (mt = (15 & de) << 12 | (63 & Le) << 6 | 63 & Re, 2047 < mt && (55296 > mt || 57343 < mt) && (Pe = mt))) : ve === 4 && (Le = S[le + 1], Re = S[le + 2], Ke = S[le + 3], (192 & Le) == 128 && (192 & Re) == 128 && (192 & Ke) == 128 && (mt = (15 & de) << 18 | (63 & Le) << 12 | (63 & Re) << 6 | 63 & Ke, 65535 < mt && 1114112 > mt && (Pe = mt)));
              }
              Pe === null ? (Pe = 65533, ve = 1) : 65535 < Pe && (Pe -= 65536, ne.push(55296 | 1023 & Pe >>> 10), Pe = 56320 | 1023 & Pe), ne.push(Pe), le += ve;
            }
            return Y(ne);
          }
          function Y(S) {
            var P = S.length;
            if (P <= 4096) return l.apply(String, S);
            for (var O = "", ne = 0; ne < P; ) O += l.apply(String, S.slice(ne, ne += 4096));
            return O;
          }
          function Z(S, P, O) {
            var ne = "";
            O = c(S.length, O);
            for (var le = P; le < O; ++le) ne += l(127 & S[le]);
            return ne;
          }
          function oe(S, P, O) {
            var ne = "";
            O = c(S.length, O);
            for (var le = P; le < O; ++le) ne += l(S[le]);
            return ne;
          }
          function ee(S, P, O) {
            var ne = S.length;
            (!P || 0 > P) && (P = 0), (!O || 0 > O || O > ne) && (O = ne);
            for (var le = "", de = P; de < O; ++de) le += Oe(S[de]);
            return le;
          }
          function ae(S, P, O) {
            for (var ne = S.slice(P, O), le = "", de = 0; de < ne.length; de += 2) le += l(ne[de] + 256 * ne[de + 1]);
            return le;
          }
          function fe(S, P, O) {
            if (S % 1 != 0 || 0 > S) throw new RangeError("offset is not uint");
            if (S + P > O) throw new RangeError("Trying to access beyond buffer length");
          }
          function me(S, P, O, ne, le, de) {
            if (!d.isBuffer(S)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (P > le || P < de) throw new RangeError('"value" argument is out of bounds');
            if (O + ne > S.length) throw new RangeError("Index out of range");
          }
          function ge(S, P, O, ne) {
            if (O + ne > S.length) throw new RangeError("Index out of range");
            if (0 > O) throw new RangeError("Index out of range");
          }
          function $(S, P, O, ne, le) {
            return P = +P, O >>>= 0, le || ge(S, P, O, 4), Ie.write(S, P, O, ne, 23, 4), O + 4;
          }
          function se(S, P, O, ne, le) {
            return P = +P, O >>>= 0, le || ge(S, P, O, 8), Ie.write(S, P, O, ne, 52, 8), O + 8;
          }
          function xe(S) {
            if (S = S.split("=")[0], S = S.trim().replace(q, ""), 2 > S.length) return "";
            for (; S.length % 4 != 0; ) S += "=";
            return S;
          }
          function Oe(S) {
            return 16 > S ? "0" + S.toString(16) : S.toString(16);
          }
          function je(S, P) {
            P = P || 1 / 0;
            for (var O, ne = S.length, le = null, de = [], Pe = 0; Pe < ne; ++Pe) {
              if (O = S.charCodeAt(Pe), 55295 < O && 57344 > O) {
                if (!le) {
                  if (56319 < O) {
                    -1 < (P -= 3) && de.push(239, 191, 189);
                    continue;
                  } else if (Pe + 1 === ne) {
                    -1 < (P -= 3) && de.push(239, 191, 189);
                    continue;
                  }
                  le = O;
                  continue;
                }
                if (56320 > O) {
                  -1 < (P -= 3) && de.push(239, 191, 189), le = O;
                  continue;
                }
                O = (le - 55296 << 10 | O - 56320) + 65536;
              } else le && -1 < (P -= 3) && de.push(239, 191, 189);
              if (le = null, 128 > O) {
                if (0 > (P -= 1)) break;
                de.push(O);
              } else if (2048 > O) {
                if (0 > (P -= 2)) break;
                de.push(192 | O >> 6, 128 | 63 & O);
              } else if (65536 > O) {
                if (0 > (P -= 3)) break;
                de.push(224 | O >> 12, 128 | 63 & O >> 6, 128 | 63 & O);
              } else if (1114112 > O) {
                if (0 > (P -= 4)) break;
                de.push(240 | O >> 18, 128 | 63 & O >> 12, 128 | 63 & O >> 6, 128 | 63 & O);
              } else throw new Error("Invalid code point");
            }
            return de;
          }
          function Me(S) {
            for (var P = [], O = 0; O < S.length; ++O) P.push(255 & S.charCodeAt(O));
            return P;
          }
          function he(S, P) {
            for (var O, ne, le, de = [], Pe = 0; Pe < S.length && !(0 > (P -= 2)); ++Pe) O = S.charCodeAt(Pe), ne = O >> 8, le = O % 256, de.push(le), de.push(ne);
            return de;
          }
          function pe(S) {
            return re.toByteArray(xe(S));
          }
          function J(S, P, O, ne) {
            for (var le = 0; le < ne && !(le + O >= P.length || le >= S.length); ++le) P[le + O] = S[le];
            return le;
          }
          function K(S, P) {
            return S instanceof P || S != null && S.constructor != null && S.constructor.name != null && S.constructor.name === P.name;
          }
          function X(S) {
            return S !== S;
          }
          var re = a("base64-js"), Ie = a("ieee754");
          s.Buffer = d, s.SlowBuffer = function(S) {
            return +S != S && (S = 0), d.alloc(+S);
          }, s.INSPECT_MAX_BYTES = 50, s.kMaxLength = 2147483647, d.TYPED_ARRAY_SUPPORT = function() {
            try {
              var S = new Uint8Array(1);
              return S.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
                return 42;
              } }, S.foo() === 42;
            } catch {
              return !1;
            }
          }(), d.TYPED_ARRAY_SUPPORT || typeof console > "u" || typeof console.error != "function" || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(d.prototype, "parent", { enumerable: !0, get: function() {
            return d.isBuffer(this) ? this.buffer : void 0;
          } }), Object.defineProperty(d.prototype, "offset", { enumerable: !0, get: function() {
            return d.isBuffer(this) ? this.byteOffset : void 0;
          } }), typeof Symbol < "u" && Symbol.species != null && d[Symbol.species] === d && Object.defineProperty(d, Symbol.species, { value: null, configurable: !0, enumerable: !1, writable: !1 }), d.poolSize = 8192, d.from = function(S, P, O) {
            return f(S, P, O);
          }, d.prototype.__proto__ = Uint8Array.prototype, d.__proto__ = Uint8Array, d.alloc = function(S, P, O) {
            return p(S, P, O);
          }, d.allocUnsafe = function(S) {
            return m(S);
          }, d.allocUnsafeSlow = function(S) {
            return m(S);
          }, d.isBuffer = function(S) {
            return S != null && S._isBuffer === !0 && S !== d.prototype;
          }, d.compare = function(S, P) {
            if (K(S, Uint8Array) && (S = d.from(S, S.offset, S.byteLength)), K(P, Uint8Array) && (P = d.from(P, P.offset, P.byteLength)), !d.isBuffer(S) || !d.isBuffer(P)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
            if (S === P) return 0;
            for (var O = S.length, ne = P.length, le = 0, de = c(O, ne); le < de; ++le) if (S[le] !== P[le]) {
              O = S[le], ne = P[le];
              break;
            }
            return O < ne ? -1 : ne < O ? 1 : 0;
          }, d.isEncoding = function(S) {
            switch ((S + "").toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, d.concat = function(S, P) {
            if (!Array.isArray(S)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (S.length === 0) return d.alloc(0);
            var O;
            if (P === void 0) for (P = 0, O = 0; O < S.length; ++O) P += S[O].length;
            var ne = d.allocUnsafe(P), le = 0;
            for (O = 0; O < S.length; ++O) {
              var de = S[O];
              if (K(de, Uint8Array) && (de = d.from(de)), !d.isBuffer(de)) throw new TypeError('"list" argument must be an Array of Buffers');
              de.copy(ne, le), le += de.length;
            }
            return ne;
          }, d.byteLength = x, d.prototype._isBuffer = !0, d.prototype.swap16 = function() {
            var S = this.length;
            if (S % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
            for (var P = 0; P < S; P += 2) L(this, P, P + 1);
            return this;
          }, d.prototype.swap32 = function() {
            var S = this.length;
            if (S % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
            for (var P = 0; P < S; P += 4) L(this, P, P + 3), L(this, P + 1, P + 2);
            return this;
          }, d.prototype.swap64 = function() {
            var S = this.length;
            if (S % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
            for (var P = 0; P < S; P += 8) L(this, P, P + 7), L(this, P + 1, P + 6), L(this, P + 2, P + 5), L(this, P + 3, P + 4);
            return this;
          }, d.prototype.toString = function() {
            var S = this.length;
            return S === 0 ? "" : arguments.length === 0 ? G(this, 0, S) : A.apply(this, arguments);
          }, d.prototype.toLocaleString = d.prototype.toString, d.prototype.equals = function(S) {
            if (!d.isBuffer(S)) throw new TypeError("Argument must be a Buffer");
            return this === S || d.compare(this, S) === 0;
          }, d.prototype.inspect = function() {
            var S = "", P = s.INSPECT_MAX_BYTES;
            return S = this.toString("hex", 0, P).replace(/(.{2})/g, "$1 ").trim(), this.length > P && (S += " ... "), "<Buffer " + S + ">";
          }, d.prototype.compare = function(S, P, O, ne, le) {
            if (K(S, Uint8Array) && (S = d.from(S, S.offset, S.byteLength)), !d.isBuffer(S)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof S);
            if (P === void 0 && (P = 0), O === void 0 && (O = S ? S.length : 0), ne === void 0 && (ne = 0), le === void 0 && (le = this.length), 0 > P || O > S.length || 0 > ne || le > this.length) throw new RangeError("out of range index");
            if (ne >= le && P >= O) return 0;
            if (ne >= le) return -1;
            if (P >= O) return 1;
            if (P >>>= 0, O >>>= 0, ne >>>= 0, le >>>= 0, this === S) return 0;
            for (var de = le - ne, Pe = O - P, ve = c(de, Pe), Le = this.slice(ne, le), Re = S.slice(P, O), Ke = 0; Ke < ve; ++Ke) if (Le[Ke] !== Re[Ke]) {
              de = Le[Ke], Pe = Re[Ke];
              break;
            }
            return de < Pe ? -1 : Pe < de ? 1 : 0;
          }, d.prototype.includes = function(S, P, O) {
            return this.indexOf(S, P, O) !== -1;
          }, d.prototype.indexOf = function(S, P, O) {
            return M(this, S, P, O, !0);
          }, d.prototype.lastIndexOf = function(S, P, O) {
            return M(this, S, P, O, !1);
          }, d.prototype.write = function(S, P, O, ne) {
            if (P === void 0) ne = "utf8", O = this.length, P = 0;
            else if (O === void 0 && typeof P == "string") ne = P, O = this.length, P = 0;
            else if (isFinite(P)) P >>>= 0, isFinite(O) ? (O >>>= 0, ne === void 0 && (ne = "utf8")) : (ne = O, O = void 0);
            else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            var le = this.length - P;
            if ((O === void 0 || O > le) && (O = le), 0 < S.length && (0 > O || 0 > P) || P > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            ne || (ne = "utf8");
            for (var de = !1; ; ) switch (ne) {
              case "hex":
                return D(this, S, P, O);
              case "utf8":
              case "utf-8":
                return z(this, S, P, O);
              case "ascii":
                return H(this, S, P, O);
              case "latin1":
              case "binary":
                return V(this, S, P, O);
              case "base64":
                return F(this, S, P, O);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return _(this, S, P, O);
              default:
                if (de) throw new TypeError("Unknown encoding: " + ne);
                ne = ("" + ne).toLowerCase(), de = !0;
            }
          }, d.prototype.toJSON = function() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          }, d.prototype.slice = function(S, P) {
            var O = this.length;
            S = ~~S, P = P === void 0 ? O : ~~P, 0 > S ? (S += O, 0 > S && (S = 0)) : S > O && (S = O), 0 > P ? (P += O, 0 > P && (P = 0)) : P > O && (P = O), P < S && (P = S);
            var ne = this.subarray(S, P);
            return ne.__proto__ = d.prototype, ne;
          }, d.prototype.readUIntLE = function(S, P, O) {
            S >>>= 0, P >>>= 0, O || fe(S, P, this.length);
            for (var ne = this[S], le = 1, de = 0; ++de < P && (le *= 256); ) ne += this[S + de] * le;
            return ne;
          }, d.prototype.readUIntBE = function(S, P, O) {
            S >>>= 0, P >>>= 0, O || fe(S, P, this.length);
            for (var ne = this[S + --P], le = 1; 0 < P && (le *= 256); ) ne += this[S + --P] * le;
            return ne;
          }, d.prototype.readUInt8 = function(S, P) {
            return S >>>= 0, P || fe(S, 1, this.length), this[S];
          }, d.prototype.readUInt16LE = function(S, P) {
            return S >>>= 0, P || fe(S, 2, this.length), this[S] | this[S + 1] << 8;
          }, d.prototype.readUInt16BE = function(S, P) {
            return S >>>= 0, P || fe(S, 2, this.length), this[S] << 8 | this[S + 1];
          }, d.prototype.readUInt32LE = function(S, P) {
            return S >>>= 0, P || fe(S, 4, this.length), (this[S] | this[S + 1] << 8 | this[S + 2] << 16) + 16777216 * this[S + 3];
          }, d.prototype.readUInt32BE = function(S, P) {
            return S >>>= 0, P || fe(S, 4, this.length), 16777216 * this[S] + (this[S + 1] << 16 | this[S + 2] << 8 | this[S + 3]);
          }, d.prototype.readIntLE = function(S, P, O) {
            S >>>= 0, P >>>= 0, O || fe(S, P, this.length);
            for (var ne = this[S], le = 1, de = 0; ++de < P && (le *= 256); ) ne += this[S + de] * le;
            return le *= 128, ne >= le && (ne -= i(2, 8 * P)), ne;
          }, d.prototype.readIntBE = function(S, P, O) {
            S >>>= 0, P >>>= 0, O || fe(S, P, this.length);
            for (var ne = P, le = 1, de = this[S + --ne]; 0 < ne && (le *= 256); ) de += this[S + --ne] * le;
            return le *= 128, de >= le && (de -= i(2, 8 * P)), de;
          }, d.prototype.readInt8 = function(S, P) {
            return S >>>= 0, P || fe(S, 1, this.length), 128 & this[S] ? -1 * (255 - this[S] + 1) : this[S];
          }, d.prototype.readInt16LE = function(S, P) {
            S >>>= 0, P || fe(S, 2, this.length);
            var O = this[S] | this[S + 1] << 8;
            return 32768 & O ? 4294901760 | O : O;
          }, d.prototype.readInt16BE = function(S, P) {
            S >>>= 0, P || fe(S, 2, this.length);
            var O = this[S + 1] | this[S] << 8;
            return 32768 & O ? 4294901760 | O : O;
          }, d.prototype.readInt32LE = function(S, P) {
            return S >>>= 0, P || fe(S, 4, this.length), this[S] | this[S + 1] << 8 | this[S + 2] << 16 | this[S + 3] << 24;
          }, d.prototype.readInt32BE = function(S, P) {
            return S >>>= 0, P || fe(S, 4, this.length), this[S] << 24 | this[S + 1] << 16 | this[S + 2] << 8 | this[S + 3];
          }, d.prototype.readFloatLE = function(S, P) {
            return S >>>= 0, P || fe(S, 4, this.length), Ie.read(this, S, !0, 23, 4);
          }, d.prototype.readFloatBE = function(S, P) {
            return S >>>= 0, P || fe(S, 4, this.length), Ie.read(this, S, !1, 23, 4);
          }, d.prototype.readDoubleLE = function(S, P) {
            return S >>>= 0, P || fe(S, 8, this.length), Ie.read(this, S, !0, 52, 8);
          }, d.prototype.readDoubleBE = function(S, P) {
            return S >>>= 0, P || fe(S, 8, this.length), Ie.read(this, S, !1, 52, 8);
          }, d.prototype.writeUIntLE = function(S, P, O, ne) {
            if (S = +S, P >>>= 0, O >>>= 0, !ne) {
              var le = i(2, 8 * O) - 1;
              me(this, S, P, O, le, 0);
            }
            var de = 1, Pe = 0;
            for (this[P] = 255 & S; ++Pe < O && (de *= 256); ) this[P + Pe] = 255 & S / de;
            return P + O;
          }, d.prototype.writeUIntBE = function(S, P, O, ne) {
            if (S = +S, P >>>= 0, O >>>= 0, !ne) {
              var le = i(2, 8 * O) - 1;
              me(this, S, P, O, le, 0);
            }
            var de = O - 1, Pe = 1;
            for (this[P + de] = 255 & S; 0 <= --de && (Pe *= 256); ) this[P + de] = 255 & S / Pe;
            return P + O;
          }, d.prototype.writeUInt8 = function(S, P, O) {
            return S = +S, P >>>= 0, O || me(this, S, P, 1, 255, 0), this[P] = 255 & S, P + 1;
          }, d.prototype.writeUInt16LE = function(S, P, O) {
            return S = +S, P >>>= 0, O || me(this, S, P, 2, 65535, 0), this[P] = 255 & S, this[P + 1] = S >>> 8, P + 2;
          }, d.prototype.writeUInt16BE = function(S, P, O) {
            return S = +S, P >>>= 0, O || me(this, S, P, 2, 65535, 0), this[P] = S >>> 8, this[P + 1] = 255 & S, P + 2;
          }, d.prototype.writeUInt32LE = function(S, P, O) {
            return S = +S, P >>>= 0, O || me(this, S, P, 4, 4294967295, 0), this[P + 3] = S >>> 24, this[P + 2] = S >>> 16, this[P + 1] = S >>> 8, this[P] = 255 & S, P + 4;
          }, d.prototype.writeUInt32BE = function(S, P, O) {
            return S = +S, P >>>= 0, O || me(this, S, P, 4, 4294967295, 0), this[P] = S >>> 24, this[P + 1] = S >>> 16, this[P + 2] = S >>> 8, this[P + 3] = 255 & S, P + 4;
          }, d.prototype.writeIntLE = function(S, P, O, ne) {
            if (S = +S, P >>>= 0, !ne) {
              var le = i(2, 8 * O - 1);
              me(this, S, P, O, le - 1, -le);
            }
            var de = 0, Pe = 1, ve = 0;
            for (this[P] = 255 & S; ++de < O && (Pe *= 256); ) 0 > S && ve === 0 && this[P + de - 1] !== 0 && (ve = 1), this[P + de] = 255 & (S / Pe >> 0) - ve;
            return P + O;
          }, d.prototype.writeIntBE = function(S, P, O, ne) {
            if (S = +S, P >>>= 0, !ne) {
              var le = i(2, 8 * O - 1);
              me(this, S, P, O, le - 1, -le);
            }
            var de = O - 1, Pe = 1, ve = 0;
            for (this[P + de] = 255 & S; 0 <= --de && (Pe *= 256); ) 0 > S && ve === 0 && this[P + de + 1] !== 0 && (ve = 1), this[P + de] = 255 & (S / Pe >> 0) - ve;
            return P + O;
          }, d.prototype.writeInt8 = function(S, P, O) {
            return S = +S, P >>>= 0, O || me(this, S, P, 1, 127, -128), 0 > S && (S = 255 + S + 1), this[P] = 255 & S, P + 1;
          }, d.prototype.writeInt16LE = function(S, P, O) {
            return S = +S, P >>>= 0, O || me(this, S, P, 2, 32767, -32768), this[P] = 255 & S, this[P + 1] = S >>> 8, P + 2;
          }, d.prototype.writeInt16BE = function(S, P, O) {
            return S = +S, P >>>= 0, O || me(this, S, P, 2, 32767, -32768), this[P] = S >>> 8, this[P + 1] = 255 & S, P + 2;
          }, d.prototype.writeInt32LE = function(S, P, O) {
            return S = +S, P >>>= 0, O || me(this, S, P, 4, 2147483647, -2147483648), this[P] = 255 & S, this[P + 1] = S >>> 8, this[P + 2] = S >>> 16, this[P + 3] = S >>> 24, P + 4;
          }, d.prototype.writeInt32BE = function(S, P, O) {
            return S = +S, P >>>= 0, O || me(this, S, P, 4, 2147483647, -2147483648), 0 > S && (S = 4294967295 + S + 1), this[P] = S >>> 24, this[P + 1] = S >>> 16, this[P + 2] = S >>> 8, this[P + 3] = 255 & S, P + 4;
          }, d.prototype.writeFloatLE = function(S, P, O) {
            return $(this, S, P, !0, O);
          }, d.prototype.writeFloatBE = function(S, P, O) {
            return $(this, S, P, !1, O);
          }, d.prototype.writeDoubleLE = function(S, P, O) {
            return se(this, S, P, !0, O);
          }, d.prototype.writeDoubleBE = function(S, P, O) {
            return se(this, S, P, !1, O);
          }, d.prototype.copy = function(S, P, O, ne) {
            if (!d.isBuffer(S)) throw new TypeError("argument should be a Buffer");
            if (O || (O = 0), ne || ne === 0 || (ne = this.length), P >= S.length && (P = S.length), P || (P = 0), 0 < ne && ne < O && (ne = O), ne === O || S.length === 0 || this.length === 0) return 0;
            if (0 > P) throw new RangeError("targetStart out of bounds");
            if (0 > O || O >= this.length) throw new RangeError("Index out of range");
            if (0 > ne) throw new RangeError("sourceEnd out of bounds");
            ne > this.length && (ne = this.length), S.length - P < ne - O && (ne = S.length - P + O);
            var le = ne - O;
            if (this === S && typeof Uint8Array.prototype.copyWithin == "function") this.copyWithin(P, O, ne);
            else if (this === S && O < P && P < ne) for (var de = le - 1; 0 <= de; --de) S[de + P] = this[de + O];
            else Uint8Array.prototype.set.call(S, this.subarray(O, ne), P);
            return le;
          }, d.prototype.fill = function(S, P, O, ne) {
            if (typeof S == "string") {
              if (typeof P == "string" ? (ne = P, P = 0, O = this.length) : typeof O == "string" && (ne = O, O = this.length), ne !== void 0 && typeof ne != "string") throw new TypeError("encoding must be a string");
              if (typeof ne == "string" && !d.isEncoding(ne)) throw new TypeError("Unknown encoding: " + ne);
              if (S.length === 1) {
                var le = S.charCodeAt(0);
                (ne === "utf8" && 128 > le || ne === "latin1") && (S = le);
              }
            } else typeof S == "number" && (S &= 255);
            if (0 > P || this.length < P || this.length < O) throw new RangeError("Out of range index");
            if (O <= P) return this;
            P >>>= 0, O = O === void 0 ? this.length : O >>> 0, S || (S = 0);
            var de;
            if (typeof S == "number") for (de = P; de < O; ++de) this[de] = S;
            else {
              var Pe = d.isBuffer(S) ? S : d.from(S, ne), ve = Pe.length;
              if (ve === 0) throw new TypeError('The value "' + S + '" is invalid for argument "value"');
              for (de = 0; de < O - P; ++de) this[de + P] = Pe[de % ve];
            }
            return this;
          };
          var q = /[^+/0-9A-Za-z-_]/g;
        }).call(this);
      }).call(this, a("buffer").Buffer);
    }, { "base64-js": 1, buffer: 3, ieee754: 9 }], 4: [function(a, o, s) {
      (function(l) {
        (function() {
          function c() {
            let d;
            try {
              d = s.storage.getItem("debug");
            } catch {
            }
            return !d && typeof l < "u" && "env" in l && (d = l.env.DEBUG), d;
          }
          s.formatArgs = function(d) {
            if (d[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + d[0] + (this.useColors ? "%c " : " ") + "+" + o.exports.humanize(this.diff), !this.useColors) return;
            const f = "color: " + this.color;
            d.splice(1, 0, f, "color: inherit");
            let h = 0, p = 0;
            d[0].replace(/%[a-zA-Z%]/g, (m) => {
              m === "%%" || (h++, m === "%c" && (p = h));
            }), d.splice(p, 0, f);
          }, s.save = function(d) {
            try {
              d ? s.storage.setItem("debug", d) : s.storage.removeItem("debug");
            } catch {
            }
          }, s.load = c, s.useColors = function() {
            return !!(typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) || !(typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) && (typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && 31 <= parseInt(RegExp.$1, 10) || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
          }, s.storage = function() {
            try {
              return localStorage;
            } catch {
            }
          }(), s.destroy = /* @__PURE__ */ (() => {
            let d = !1;
            return () => {
              d || (d = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
            };
          })(), s.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], s.log = console.debug || console.log || (() => {
          }), o.exports = a("./common")(s);
          const { formatters: u } = o.exports;
          u.j = function(d) {
            try {
              return JSON.stringify(d);
            } catch (f) {
              return "[UnexpectedJSONParseError]: " + f.message;
            }
          };
        }).call(this);
      }).call(this, a("_process"));
    }, { "./common": 5, _process: 12 }], 5: [function(a, o) {
      o.exports = function(s) {
        function l(d) {
          function f(...m) {
            if (!f.enabled) return;
            const g = f, v = +/* @__PURE__ */ new Date(), k = v - (h || v);
            g.diff = k, g.prev = h, g.curr = v, h = v, m[0] = l.coerce(m[0]), typeof m[0] != "string" && m.unshift("%O");
            let w = 0;
            m[0] = m[0].replace(/%([a-zA-Z%])/g, (x, A) => {
              if (x === "%%") return "%";
              w++;
              const L = l.formatters[A];
              if (typeof L == "function") {
                const M = m[w];
                x = L.call(g, M), m.splice(w, 1), w--;
              }
              return x;
            }), l.formatArgs.call(g, m), (g.log || l.log).apply(g, m);
          }
          let h, p = null;
          return f.namespace = d, f.useColors = l.useColors(), f.color = l.selectColor(d), f.extend = c, f.destroy = l.destroy, Object.defineProperty(f, "enabled", { enumerable: !0, configurable: !1, get: () => p === null ? l.enabled(d) : p, set: (m) => {
            p = m;
          } }), typeof l.init == "function" && l.init(f), f;
        }
        function c(d, f) {
          const h = l(this.namespace + (typeof f > "u" ? ":" : f) + d);
          return h.log = this.log, h;
        }
        function u(d) {
          return d.toString().substring(2, d.toString().length - 2).replace(/\.\*\?$/, "*");
        }
        return l.debug = l, l.default = l, l.coerce = function(d) {
          return d instanceof Error ? d.stack || d.message : d;
        }, l.disable = function() {
          const d = [...l.names.map(u), ...l.skips.map(u).map((f) => "-" + f)].join(",");
          return l.enable(""), d;
        }, l.enable = function(d) {
          l.save(d), l.names = [], l.skips = [];
          let f;
          const h = (typeof d == "string" ? d : "").split(/[\s,]+/), p = h.length;
          for (f = 0; f < p; f++) h[f] && (d = h[f].replace(/\*/g, ".*?"), d[0] === "-" ? l.skips.push(new RegExp("^" + d.substr(1) + "$")) : l.names.push(new RegExp("^" + d + "$")));
        }, l.enabled = function(d) {
          if (d[d.length - 1] === "*") return !0;
          let f, h;
          for (f = 0, h = l.skips.length; f < h; f++) if (l.skips[f].test(d)) return !1;
          for (f = 0, h = l.names.length; f < h; f++) if (l.names[f].test(d)) return !0;
          return !1;
        }, l.humanize = a("ms"), l.destroy = function() {
          console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }, Object.keys(s).forEach((d) => {
          l[d] = s[d];
        }), l.names = [], l.skips = [], l.formatters = {}, l.selectColor = function(d) {
          let f = 0;
          for (let h = 0; h < d.length; h++) f = (f << 5) - f + d.charCodeAt(h), f |= 0;
          return l.colors[r(f) % l.colors.length];
        }, l.enable(l.load()), l;
      };
    }, { ms: 11 }], 6: [function(a, o) {
      function s(l, c) {
        for (const u in c) Object.defineProperty(l, u, { value: c[u], enumerable: !0, configurable: !0 });
        return l;
      }
      o.exports = function(l, c, u) {
        if (!l || typeof l == "string") throw new TypeError("Please pass an Error to err-code");
        u || (u = {}), typeof c == "object" && (u = c, c = ""), c && (u.code = c);
        try {
          return s(l, u);
        } catch {
          u.message = l.message, u.stack = l.stack;
          const f = function() {
          };
          return f.prototype = Object.create(Object.getPrototypeOf(l)), s(new f(), u);
        }
      };
    }, {}], 7: [function(a, o) {
      function s(D) {
        console && console.warn && console.warn(D);
      }
      function l() {
        l.init.call(this);
      }
      function c(D) {
        if (typeof D != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof D);
      }
      function u(D) {
        return D._maxListeners === void 0 ? l.defaultMaxListeners : D._maxListeners;
      }
      function d(D, z, H, V) {
        var F, _, W;
        if (c(H), _ = D._events, _ === void 0 ? (_ = D._events = /* @__PURE__ */ Object.create(null), D._eventsCount = 0) : (_.newListener !== void 0 && (D.emit("newListener", z, H.listener ? H.listener : H), _ = D._events), W = _[z]), W === void 0) W = _[z] = H, ++D._eventsCount;
        else if (typeof W == "function" ? W = _[z] = V ? [H, W] : [W, H] : V ? W.unshift(H) : W.push(H), F = u(D), 0 < F && W.length > F && !W.warned) {
          W.warned = !0;
          var G = new Error("Possible EventEmitter memory leak detected. " + W.length + " " + (z + " listeners added. Use emitter.setMaxListeners() to increase limit"));
          G.name = "MaxListenersExceededWarning", G.emitter = D, G.type = z, G.count = W.length, s(G);
        }
        return D;
      }
      function f() {
        if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
      }
      function h(D, z, H) {
        var V = { fired: !1, wrapFn: void 0, target: D, type: z, listener: H }, F = f.bind(V);
        return F.listener = H, V.wrapFn = F, F;
      }
      function p(D, z, H) {
        var V = D._events;
        if (V === void 0) return [];
        var F = V[z];
        return F === void 0 ? [] : typeof F == "function" ? H ? [F.listener || F] : [F] : H ? k(F) : g(F, F.length);
      }
      function m(D) {
        var z = this._events;
        if (z !== void 0) {
          var H = z[D];
          if (typeof H == "function") return 1;
          if (H !== void 0) return H.length;
        }
        return 0;
      }
      function g(D, z) {
        for (var H = Array(z), V = 0; V < z; ++V) H[V] = D[V];
        return H;
      }
      function v(D, z) {
        for (; z + 1 < D.length; z++) D[z] = D[z + 1];
        D.pop();
      }
      function k(D) {
        for (var z = Array(D.length), H = 0; H < z.length; ++H) z[H] = D[H].listener || D[H];
        return z;
      }
      function w(D, z, H) {
        typeof D.on == "function" && b(D, "error", z, H);
      }
      function b(D, z, H, V) {
        if (typeof D.on == "function") V.once ? D.once(z, H) : D.on(z, H);
        else if (typeof D.addEventListener == "function") D.addEventListener(z, function F(_) {
          V.once && D.removeEventListener(z, F), H(_);
        });
        else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof D);
      }
      var x, A = typeof Reflect == "object" ? Reflect : null, L = A && typeof A.apply == "function" ? A.apply : function(D, z, H) {
        return Function.prototype.apply.call(D, z, H);
      };
      x = A && typeof A.ownKeys == "function" ? A.ownKeys : Object.getOwnPropertySymbols ? function(D) {
        return Object.getOwnPropertyNames(D).concat(Object.getOwnPropertySymbols(D));
      } : function(D) {
        return Object.getOwnPropertyNames(D);
      };
      var M = Number.isNaN || function(D) {
        return D !== D;
      };
      o.exports = l, o.exports.once = function(D, z) {
        return new Promise(function(H, V) {
          function F(W) {
            D.removeListener(z, _), V(W);
          }
          function _() {
            typeof D.removeListener == "function" && D.removeListener("error", F), H([].slice.call(arguments));
          }
          b(D, z, _, { once: !0 }), z !== "error" && w(D, F, { once: !0 });
        });
      }, l.EventEmitter = l, l.prototype._events = void 0, l.prototype._eventsCount = 0, l.prototype._maxListeners = void 0;
      var j = 10;
      Object.defineProperty(l, "defaultMaxListeners", { enumerable: !0, get: function() {
        return j;
      }, set: function(D) {
        if (typeof D != "number" || 0 > D || M(D)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + D + ".");
        j = D;
      } }), l.init = function() {
        (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
      }, l.prototype.setMaxListeners = function(D) {
        if (typeof D != "number" || 0 > D || M(D)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + D + ".");
        return this._maxListeners = D, this;
      }, l.prototype.getMaxListeners = function() {
        return u(this);
      }, l.prototype.emit = function(D) {
        for (var z = [], H = 1; H < arguments.length; H++) z.push(arguments[H]);
        var V = D === "error", F = this._events;
        if (F !== void 0) V = V && F.error === void 0;
        else if (!V) return !1;
        if (V) {
          var _;
          if (0 < z.length && (_ = z[0]), _ instanceof Error) throw _;
          var W = new Error("Unhandled error." + (_ ? " (" + _.message + ")" : ""));
          throw W.context = _, W;
        }
        var G = F[D];
        if (G === void 0) return !1;
        if (typeof G == "function") L(G, this, z);
        else for (var Y = G.length, Z = g(G, Y), H = 0; H < Y; ++H) L(Z[H], this, z);
        return !0;
      }, l.prototype.addListener = function(D, z) {
        return d(this, D, z, !1);
      }, l.prototype.on = l.prototype.addListener, l.prototype.prependListener = function(D, z) {
        return d(this, D, z, !0);
      }, l.prototype.once = function(D, z) {
        return c(z), this.on(D, h(this, D, z)), this;
      }, l.prototype.prependOnceListener = function(D, z) {
        return c(z), this.prependListener(D, h(this, D, z)), this;
      }, l.prototype.removeListener = function(D, z) {
        var H, V, F, _, W;
        if (c(z), V = this._events, V === void 0) return this;
        if (H = V[D], H === void 0) return this;
        if (H === z || H.listener === z) --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete V[D], V.removeListener && this.emit("removeListener", D, H.listener || z));
        else if (typeof H != "function") {
          for (F = -1, _ = H.length - 1; 0 <= _; _--) if (H[_] === z || H[_].listener === z) {
            W = H[_].listener, F = _;
            break;
          }
          if (0 > F) return this;
          F === 0 ? H.shift() : v(H, F), H.length === 1 && (V[D] = H[0]), V.removeListener !== void 0 && this.emit("removeListener", D, W || z);
        }
        return this;
      }, l.prototype.off = l.prototype.removeListener, l.prototype.removeAllListeners = function(D) {
        var z, H, V;
        if (H = this._events, H === void 0) return this;
        if (H.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : H[D] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete H[D]), this;
        if (arguments.length === 0) {
          var F, _ = Object.keys(H);
          for (V = 0; V < _.length; ++V) F = _[V], F !== "removeListener" && this.removeAllListeners(F);
          return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
        }
        if (z = H[D], typeof z == "function") this.removeListener(D, z);
        else if (z !== void 0) for (V = z.length - 1; 0 <= V; V--) this.removeListener(D, z[V]);
        return this;
      }, l.prototype.listeners = function(D) {
        return p(this, D, !0);
      }, l.prototype.rawListeners = function(D) {
        return p(this, D, !1);
      }, l.listenerCount = function(D, z) {
        return typeof D.listenerCount == "function" ? D.listenerCount(z) : m.call(D, z);
      }, l.prototype.listenerCount = m, l.prototype.eventNames = function() {
        return 0 < this._eventsCount ? x(this._events) : [];
      };
    }, {}], 8: [function(a, o) {
      o.exports = function() {
        if (typeof globalThis > "u") return null;
        var s = { RTCPeerConnection: globalThis.RTCPeerConnection || globalThis.mozRTCPeerConnection || globalThis.webkitRTCPeerConnection, RTCSessionDescription: globalThis.RTCSessionDescription || globalThis.mozRTCSessionDescription || globalThis.webkitRTCSessionDescription, RTCIceCandidate: globalThis.RTCIceCandidate || globalThis.mozRTCIceCandidate || globalThis.webkitRTCIceCandidate };
        return s.RTCPeerConnection ? s : null;
      };
    }, {}], 9: [function(a, o, s) {
      /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
      s.read = function(l, c, u, d, f) {
        var h, p, m = 8 * f - d - 1, g = (1 << m) - 1, v = g >> 1, k = -7, w = u ? f - 1 : 0, b = u ? -1 : 1, x = l[c + w];
        for (w += b, h = x & (1 << -k) - 1, x >>= -k, k += m; 0 < k; h = 256 * h + l[c + w], w += b, k -= 8) ;
        for (p = h & (1 << -k) - 1, h >>= -k, k += d; 0 < k; p = 256 * p + l[c + w], w += b, k -= 8) ;
        if (h === 0) h = 1 - v;
        else {
          if (h === g) return p ? NaN : (x ? -1 : 1) * (1 / 0);
          p += i(2, d), h -= v;
        }
        return (x ? -1 : 1) * p * i(2, h - d);
      }, s.write = function(l, c, u, d, f, h) {
        var p, m, g, v = Math.LN2, k = Math.log, w = 8 * h - f - 1, b = (1 << w) - 1, x = b >> 1, A = f === 23 ? i(2, -24) - i(2, -77) : 0, L = d ? 0 : h - 1, M = d ? 1 : -1, j = 0 > c || c === 0 && 0 > 1 / c ? 1 : 0;
        for (c = r(c), isNaN(c) || c === 1 / 0 ? (m = isNaN(c) ? 1 : 0, p = b) : (p = n(k(c) / v), 1 > c * (g = i(2, -p)) && (p--, g *= 2), c += 1 <= p + x ? A / g : A * i(2, 1 - x), 2 <= c * g && (p++, g /= 2), p + x >= b ? (m = 0, p = b) : 1 <= p + x ? (m = (c * g - 1) * i(2, f), p += x) : (m = c * i(2, x - 1) * i(2, f), p = 0)); 8 <= f; l[u + L] = 255 & m, L += M, m /= 256, f -= 8) ;
        for (p = p << f | m, w += f; 0 < w; l[u + L] = 255 & p, L += M, p /= 256, w -= 8) ;
        l[u + L - M] |= 128 * j;
      };
    }, {}], 10: [function(a, o) {
      o.exports = typeof Object.create == "function" ? function(s, l) {
        l && (s.super_ = l, s.prototype = Object.create(l.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }));
      } : function(s, l) {
        if (l) {
          s.super_ = l;
          var c = function() {
          };
          c.prototype = l.prototype, s.prototype = new c(), s.prototype.constructor = s;
        }
      };
    }, {}], 11: [function(a, o) {
      var s = Math.round;
      function l(f) {
        if (f += "", !(100 < f.length)) {
          var h = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(f);
          if (h) {
            var p = parseFloat(h[1]), m = (h[2] || "ms").toLowerCase();
            return m === "years" || m === "year" || m === "yrs" || m === "yr" || m === "y" ? 315576e5 * p : m === "weeks" || m === "week" || m === "w" ? 6048e5 * p : m === "days" || m === "day" || m === "d" ? 864e5 * p : m === "hours" || m === "hour" || m === "hrs" || m === "hr" || m === "h" ? 36e5 * p : m === "minutes" || m === "minute" || m === "mins" || m === "min" || m === "m" ? 6e4 * p : m === "seconds" || m === "second" || m === "secs" || m === "sec" || m === "s" ? 1e3 * p : m === "milliseconds" || m === "millisecond" || m === "msecs" || m === "msec" || m === "ms" ? p : void 0;
          }
        }
      }
      function c(f) {
        var h = r(f);
        return 864e5 <= h ? s(f / 864e5) + "d" : 36e5 <= h ? s(f / 36e5) + "h" : 6e4 <= h ? s(f / 6e4) + "m" : 1e3 <= h ? s(f / 1e3) + "s" : f + "ms";
      }
      function u(f) {
        var h = r(f);
        return 864e5 <= h ? d(f, h, 864e5, "day") : 36e5 <= h ? d(f, h, 36e5, "hour") : 6e4 <= h ? d(f, h, 6e4, "minute") : 1e3 <= h ? d(f, h, 1e3, "second") : f + " ms";
      }
      function d(f, h, p, m) {
        return s(f / p) + " " + m + (h >= 1.5 * p ? "s" : "");
      }
      o.exports = function(f, h) {
        h = h || {};
        var p = typeof f;
        if (p == "string" && 0 < f.length) return l(f);
        if (p === "number" && isFinite(f)) return h.long ? u(f) : c(f);
        throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(f));
      };
    }, {}], 12: [function(a, o) {
      function s() {
        throw new Error("setTimeout has not been defined");
      }
      function l() {
        throw new Error("clearTimeout has not been defined");
      }
      function c(A) {
        if (m === setTimeout) return setTimeout(A, 0);
        if ((m === s || !m) && setTimeout) return m = setTimeout, setTimeout(A, 0);
        try {
          return m(A, 0);
        } catch {
          try {
            return m.call(null, A, 0);
          } catch {
            return m.call(this, A, 0);
          }
        }
      }
      function u(A) {
        if (g === clearTimeout) return clearTimeout(A);
        if ((g === l || !g) && clearTimeout) return g = clearTimeout, clearTimeout(A);
        try {
          return g(A);
        } catch {
          try {
            return g.call(null, A);
          } catch {
            return g.call(this, A);
          }
        }
      }
      function d() {
        b && k && (b = !1, k.length ? w = k.concat(w) : x = -1, w.length && f());
      }
      function f() {
        if (!b) {
          var A = c(d);
          b = !0;
          for (var L = w.length; L; ) {
            for (k = w, w = []; ++x < L; ) k && k[x].run();
            x = -1, L = w.length;
          }
          k = null, b = !1, u(A);
        }
      }
      function h(A, L) {
        this.fun = A, this.array = L;
      }
      function p() {
      }
      var m, g, v = o.exports = {};
      (function() {
        try {
          m = typeof setTimeout == "function" ? setTimeout : s;
        } catch {
          m = s;
        }
        try {
          g = typeof clearTimeout == "function" ? clearTimeout : l;
        } catch {
          g = l;
        }
      })();
      var k, w = [], b = !1, x = -1;
      v.nextTick = function(A) {
        var L = Array(arguments.length - 1);
        if (1 < arguments.length) for (var M = 1; M < arguments.length; M++) L[M - 1] = arguments[M];
        w.push(new h(A, L)), w.length !== 1 || b || c(f);
      }, h.prototype.run = function() {
        this.fun.apply(null, this.array);
      }, v.title = "browser", v.browser = !0, v.env = {}, v.argv = [], v.version = "", v.versions = {}, v.on = p, v.addListener = p, v.once = p, v.off = p, v.removeListener = p, v.removeAllListeners = p, v.emit = p, v.prependListener = p, v.prependOnceListener = p, v.listeners = function() {
        return [];
      }, v.binding = function() {
        throw new Error("process.binding is not supported");
      }, v.cwd = function() {
        return "/";
      }, v.chdir = function() {
        throw new Error("process.chdir is not supported");
      }, v.umask = function() {
        return 0;
      };
    }, {}], 13: [function(a, o) {
      (function(s) {
        (function() {
          /*! queue-microtask. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
          let l;
          o.exports = typeof queueMicrotask == "function" ? queueMicrotask.bind(typeof window > "u" ? s : window) : (c) => (l || (l = Promise.resolve())).then(c).catch((u) => setTimeout(() => {
            throw u;
          }, 0));
        }).call(this);
      }).call(this, typeof Pr > "u" ? typeof self > "u" ? typeof window > "u" ? {} : window : self : Pr);
    }, {}], 14: [function(a, o) {
      (function(s, l) {
        (function() {
          var c = a("safe-buffer").Buffer, u = l.crypto || l.msCrypto;
          o.exports = u && u.getRandomValues ? function(d, f) {
            if (d > 4294967295) throw new RangeError("requested too many random bytes");
            var h = c.allocUnsafe(d);
            if (0 < d) if (65536 < d) for (var p = 0; p < d; p += 65536) u.getRandomValues(h.slice(p, p + 65536));
            else u.getRandomValues(h);
            return typeof f == "function" ? s.nextTick(function() {
              f(null, h);
            }) : h;
          } : function() {
            throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
          };
        }).call(this);
      }).call(this, a("_process"), typeof Pr > "u" ? typeof self > "u" ? typeof window > "u" ? {} : window : self : Pr);
    }, { _process: 12, "safe-buffer": 30 }], 15: [function(a, o) {
      function s(p, m) {
        p.prototype = Object.create(m.prototype), p.prototype.constructor = p, p.__proto__ = m;
      }
      function l(p, m, g) {
        function v(w, b, x) {
          return typeof m == "string" ? m : m(w, b, x);
        }
        g || (g = Error);
        var k = function(w) {
          function b(x, A, L) {
            return w.call(this, v(x, A, L)) || this;
          }
          return s(b, w), b;
        }(g);
        k.prototype.name = g.name, k.prototype.code = p, h[p] = k;
      }
      function c(p, m) {
        if (Array.isArray(p)) {
          var g = p.length;
          return p = p.map(function(v) {
            return v + "";
          }), 2 < g ? "one of ".concat(m, " ").concat(p.slice(0, g - 1).join(", "), ", or ") + p[g - 1] : g === 2 ? "one of ".concat(m, " ").concat(p[0], " or ").concat(p[1]) : "of ".concat(m, " ").concat(p[0]);
        }
        return "of ".concat(m, " ").concat(p + "");
      }
      function u(p, m, g) {
        return p.substr(0, m.length) === m;
      }
      function d(p, m, g) {
        return (g === void 0 || g > p.length) && (g = p.length), p.substring(g - m.length, g) === m;
      }
      function f(p, m, g) {
        return typeof g != "number" && (g = 0), !(g + m.length > p.length) && p.indexOf(m, g) !== -1;
      }
      var h = {};
      l("ERR_INVALID_OPT_VALUE", function(p, m) {
        return 'The value "' + m + '" is invalid for option "' + p + '"';
      }, TypeError), l("ERR_INVALID_ARG_TYPE", function(p, m, g) {
        var v;
        typeof m == "string" && u(m, "not ") ? (v = "must not be", m = m.replace(/^not /, "")) : v = "must be";
        var k;
        if (d(p, " argument")) k = "The ".concat(p, " ").concat(v, " ").concat(c(m, "type"));
        else {
          var w = f(p, ".") ? "property" : "argument";
          k = 'The "'.concat(p, '" ').concat(w, " ").concat(v, " ").concat(c(m, "type"));
        }
        return k += ". Received type ".concat(typeof g), k;
      }, TypeError), l("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), l("ERR_METHOD_NOT_IMPLEMENTED", function(p) {
        return "The " + p + " method is not implemented";
      }), l("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), l("ERR_STREAM_DESTROYED", function(p) {
        return "Cannot call " + p + " after a stream was destroyed";
      }), l("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), l("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), l("ERR_STREAM_WRITE_AFTER_END", "write after end"), l("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), l("ERR_UNKNOWN_ENCODING", function(p) {
        return "Unknown encoding: " + p;
      }, TypeError), l("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), o.exports.codes = h;
    }, {}], 16: [function(a, o) {
      (function(s) {
        (function() {
          function l(v) {
            return this instanceof l ? (f.call(this, v), h.call(this, v), this.allowHalfOpen = !0, void (v && (v.readable === !1 && (this.readable = !1), v.writable === !1 && (this.writable = !1), v.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", c))))) : new l(v);
          }
          function c() {
            this._writableState.ended || s.nextTick(u, this);
          }
          function u(v) {
            v.end();
          }
          var d = Object.keys || function(v) {
            var k = [];
            for (var w in v) k.push(w);
            return k;
          };
          o.exports = l;
          var f = a("./_stream_readable"), h = a("./_stream_writable");
          a("inherits")(l, f);
          for (var p, m = d(h.prototype), g = 0; g < m.length; g++) p = m[g], l.prototype[p] || (l.prototype[p] = h.prototype[p]);
          Object.defineProperty(l.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
            return this._writableState.highWaterMark;
          } }), Object.defineProperty(l.prototype, "writableBuffer", { enumerable: !1, get: function() {
            return this._writableState && this._writableState.getBuffer();
          } }), Object.defineProperty(l.prototype, "writableLength", { enumerable: !1, get: function() {
            return this._writableState.length;
          } }), Object.defineProperty(l.prototype, "destroyed", { enumerable: !1, get: function() {
            return this._readableState !== void 0 && this._writableState !== void 0 && this._readableState.destroyed && this._writableState.destroyed;
          }, set: function(v) {
            this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = v, this._writableState.destroyed = v);
          } });
        }).call(this);
      }).call(this, a("_process"));
    }, { "./_stream_readable": 18, "./_stream_writable": 20, _process: 12, inherits: 10 }], 17: [function(a, o) {
      function s(c) {
        return this instanceof s ? void l.call(this, c) : new s(c);
      }
      o.exports = s;
      var l = a("./_stream_transform");
      a("inherits")(s, l), s.prototype._transform = function(c, u, d) {
        d(null, c);
      };
    }, { "./_stream_transform": 19, inherits: 10 }], 18: [function(a, o) {
      (function(s, l) {
        (function() {
          function c(q) {
            return ae.from(q);
          }
          function u(q) {
            return ae.isBuffer(q) || q instanceof fe;
          }
          function d(q, S, P) {
            return typeof q.prependListener == "function" ? q.prependListener(S, P) : void (q._events && q._events[S] ? Array.isArray(q._events[S]) ? q._events[S].unshift(P) : q._events[S] = [P, q._events[S]] : q.on(S, P));
          }
          function f(q, S, P) {
            Y = Y || a("./_stream_duplex"), q = q || {}, typeof P != "boolean" && (P = S instanceof Y), this.objectMode = !!q.objectMode, P && (this.objectMode = this.objectMode || !!q.readableObjectMode), this.highWaterMark = Me(this, q, "readableHighWaterMark", P), this.buffer = new xe(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = q.emitClose !== !1, this.autoDestroy = !!q.autoDestroy, this.destroyed = !1, this.defaultEncoding = q.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, q.encoding && (!ge && (ge = a("string_decoder/").StringDecoder), this.decoder = new ge(q.encoding), this.encoding = q.encoding);
          }
          function h(q) {
            if (Y = Y || a("./_stream_duplex"), !(this instanceof h)) return new h(q);
            var S = this instanceof Y;
            this._readableState = new f(q, this, S), this.readable = !0, q && (typeof q.read == "function" && (this._read = q.read), typeof q.destroy == "function" && (this._destroy = q.destroy)), ee.call(this);
          }
          function p(q, S, P, O, ne) {
            Z("readableAddChunk", S);
            var le = q._readableState;
            if (S === null) le.reading = !1, w(q, le);
            else {
              var de;
              if (ne || (de = g(le, S)), de) re(q, de);
              else if (!(le.objectMode || S && 0 < S.length)) O || (le.reading = !1, A(q, le));
              else if (typeof S == "string" || le.objectMode || Object.getPrototypeOf(S) === ae.prototype || (S = c(S)), O) le.endEmitted ? re(q, new X()) : m(q, le, S, !0);
              else if (le.ended) re(q, new J());
              else {
                if (le.destroyed) return !1;
                le.reading = !1, le.decoder && !P ? (S = le.decoder.write(S), le.objectMode || S.length !== 0 ? m(q, le, S, !1) : A(q, le)) : m(q, le, S, !1);
              }
            }
            return !le.ended && (le.length < le.highWaterMark || le.length === 0);
          }
          function m(q, S, P, O) {
            S.flowing && S.length === 0 && !S.sync ? (S.awaitDrain = 0, q.emit("data", P)) : (S.length += S.objectMode ? 1 : P.length, O ? S.buffer.unshift(P) : S.buffer.push(P), S.needReadable && b(q)), A(q, S);
          }
          function g(q, S) {
            var P;
            return u(S) || typeof S == "string" || S === void 0 || q.objectMode || (P = new pe("chunk", ["string", "Buffer", "Uint8Array"], S)), P;
          }
          function v(q) {
            return 1073741824 <= q ? q = 1073741824 : (q--, q |= q >>> 1, q |= q >>> 2, q |= q >>> 4, q |= q >>> 8, q |= q >>> 16, q++), q;
          }
          function k(q, S) {
            return 0 >= q || S.length === 0 && S.ended ? 0 : S.objectMode ? 1 : q === q ? (q > S.highWaterMark && (S.highWaterMark = v(q)), q <= S.length ? q : S.ended ? S.length : (S.needReadable = !0, 0)) : S.flowing && S.length ? S.buffer.head.data.length : S.length;
          }
          function w(q, S) {
            if (Z("onEofChunk"), !S.ended) {
              if (S.decoder) {
                var P = S.decoder.end();
                P && P.length && (S.buffer.push(P), S.length += S.objectMode ? 1 : P.length);
              }
              S.ended = !0, S.sync ? b(q) : (S.needReadable = !1, !S.emittedReadable && (S.emittedReadable = !0, x(q)));
            }
          }
          function b(q) {
            var S = q._readableState;
            Z("emitReadable", S.needReadable, S.emittedReadable), S.needReadable = !1, S.emittedReadable || (Z("emitReadable", S.flowing), S.emittedReadable = !0, s.nextTick(x, q));
          }
          function x(q) {
            var S = q._readableState;
            Z("emitReadable_", S.destroyed, S.length, S.ended), !S.destroyed && (S.length || S.ended) && (q.emit("readable"), S.emittedReadable = !1), S.needReadable = !S.flowing && !S.ended && S.length <= S.highWaterMark, V(q);
          }
          function A(q, S) {
            S.readingMore || (S.readingMore = !0, s.nextTick(L, q, S));
          }
          function L(q, S) {
            for (; !S.reading && !S.ended && (S.length < S.highWaterMark || S.flowing && S.length === 0); ) {
              var P = S.length;
              if (Z("maybeReadMore read 0"), q.read(0), P === S.length) break;
            }
            S.readingMore = !1;
          }
          function M(q) {
            return function() {
              var S = q._readableState;
              Z("pipeOnDrain", S.awaitDrain), S.awaitDrain && S.awaitDrain--, S.awaitDrain === 0 && oe(q, "data") && (S.flowing = !0, V(q));
            };
          }
          function j(q) {
            var S = q._readableState;
            S.readableListening = 0 < q.listenerCount("readable"), S.resumeScheduled && !S.paused ? S.flowing = !0 : 0 < q.listenerCount("data") && q.resume();
          }
          function D(q) {
            Z("readable nexttick read 0"), q.read(0);
          }
          function z(q, S) {
            S.resumeScheduled || (S.resumeScheduled = !0, s.nextTick(H, q, S));
          }
          function H(q, S) {
            Z("resume", S.reading), S.reading || q.read(0), S.resumeScheduled = !1, q.emit("resume"), V(q), S.flowing && !S.reading && q.read(0);
          }
          function V(q) {
            var S = q._readableState;
            for (Z("flow", S.flowing); S.flowing && q.read() !== null; ) ;
          }
          function F(q, S) {
            if (S.length === 0) return null;
            var P;
            return S.objectMode ? P = S.buffer.shift() : !q || q >= S.length ? (P = S.decoder ? S.buffer.join("") : S.buffer.length === 1 ? S.buffer.first() : S.buffer.concat(S.length), S.buffer.clear()) : P = S.buffer.consume(q, S.decoder), P;
          }
          function _(q) {
            var S = q._readableState;
            Z("endReadable", S.endEmitted), S.endEmitted || (S.ended = !0, s.nextTick(W, S, q));
          }
          function W(q, S) {
            if (Z("endReadableNT", q.endEmitted, q.length), !q.endEmitted && q.length === 0 && (q.endEmitted = !0, S.readable = !1, S.emit("end"), q.autoDestroy)) {
              var P = S._writableState;
              (!P || P.autoDestroy && P.finished) && S.destroy();
            }
          }
          function G(q, S) {
            for (var P = 0, O = q.length; P < O; P++) if (q[P] === S) return P;
            return -1;
          }
          o.exports = h;
          var Y;
          h.ReadableState = f;
          var Z;
          a("events").EventEmitter;
          var oe = function(q, S) {
            return q.listeners(S).length;
          }, ee = a("./internal/streams/stream"), ae = a("buffer").Buffer, fe = l.Uint8Array || function() {
          }, me = a("util");
          Z = me && me.debuglog ? me.debuglog("stream") : function() {
          };
          var ge, $, se, xe = a("./internal/streams/buffer_list"), Oe = a("./internal/streams/destroy"), je = a("./internal/streams/state"), Me = je.getHighWaterMark, he = a("../errors").codes, pe = he.ERR_INVALID_ARG_TYPE, J = he.ERR_STREAM_PUSH_AFTER_EOF, K = he.ERR_METHOD_NOT_IMPLEMENTED, X = he.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
          a("inherits")(h, ee);
          var re = Oe.errorOrDestroy, Ie = ["error", "close", "destroy", "pause", "resume"];
          Object.defineProperty(h.prototype, "destroyed", { enumerable: !1, get: function() {
            return this._readableState !== void 0 && this._readableState.destroyed;
          }, set: function(q) {
            this._readableState && (this._readableState.destroyed = q);
          } }), h.prototype.destroy = Oe.destroy, h.prototype._undestroy = Oe.undestroy, h.prototype._destroy = function(q, S) {
            S(q);
          }, h.prototype.push = function(q, S) {
            var P, O = this._readableState;
            return O.objectMode ? P = !0 : typeof q == "string" && (S = S || O.defaultEncoding, S !== O.encoding && (q = ae.from(q, S), S = ""), P = !0), p(this, q, S, !1, P);
          }, h.prototype.unshift = function(q) {
            return p(this, q, null, !0, !1);
          }, h.prototype.isPaused = function() {
            return this._readableState.flowing === !1;
          }, h.prototype.setEncoding = function(q) {
            ge || (ge = a("string_decoder/").StringDecoder);
            var S = new ge(q);
            this._readableState.decoder = S, this._readableState.encoding = this._readableState.decoder.encoding;
            for (var P = this._readableState.buffer.head, O = ""; P !== null; ) O += S.write(P.data), P = P.next;
            return this._readableState.buffer.clear(), O !== "" && this._readableState.buffer.push(O), this._readableState.length = O.length, this;
          }, h.prototype.read = function(q) {
            Z("read", q), q = parseInt(q, 10);
            var S = this._readableState, P = q;
            if (q !== 0 && (S.emittedReadable = !1), q === 0 && S.needReadable && ((S.highWaterMark === 0 ? 0 < S.length : S.length >= S.highWaterMark) || S.ended)) return Z("read: emitReadable", S.length, S.ended), S.length === 0 && S.ended ? _(this) : b(this), null;
            if (q = k(q, S), q === 0 && S.ended) return S.length === 0 && _(this), null;
            var O = S.needReadable;
            Z("need readable", O), (S.length === 0 || S.length - q < S.highWaterMark) && (O = !0, Z("length less than watermark", O)), S.ended || S.reading ? (O = !1, Z("reading or ended", O)) : O && (Z("do read"), S.reading = !0, S.sync = !0, S.length === 0 && (S.needReadable = !0), this._read(S.highWaterMark), S.sync = !1, !S.reading && (q = k(P, S)));
            var ne;
            return ne = 0 < q ? F(q, S) : null, ne === null ? (S.needReadable = S.length <= S.highWaterMark, q = 0) : (S.length -= q, S.awaitDrain = 0), S.length === 0 && (!S.ended && (S.needReadable = !0), P !== q && S.ended && _(this)), ne !== null && this.emit("data", ne), ne;
          }, h.prototype._read = function() {
            re(this, new K("_read()"));
          }, h.prototype.pipe = function(q, S) {
            function P(_e, we) {
              Z("onunpipe"), _e === Re && we && we.hasUnpiped === !1 && (we.hasUnpiped = !0, ne());
            }
            function O() {
              Z("onend"), q.end();
            }
            function ne() {
              Z("cleanup"), q.removeListener("close", Pe), q.removeListener("finish", ve), q.removeListener("drain", Nt), q.removeListener("error", de), q.removeListener("unpipe", P), Re.removeListener("end", O), Re.removeListener("end", Le), Re.removeListener("data", le), ye = !0, Ke.awaitDrain && (!q._writableState || q._writableState.needDrain) && Nt();
            }
            function le(_e) {
              Z("ondata");
              var we = q.write(_e);
              Z("dest.write", we), we === !1 && ((Ke.pipesCount === 1 && Ke.pipes === q || 1 < Ke.pipesCount && G(Ke.pipes, q) !== -1) && !ye && (Z("false write response, pause", Ke.awaitDrain), Ke.awaitDrain++), Re.pause());
            }
            function de(_e) {
              Z("onerror", _e), Le(), q.removeListener("error", de), oe(q, "error") === 0 && re(q, _e);
            }
            function Pe() {
              q.removeListener("finish", ve), Le();
            }
            function ve() {
              Z("onfinish"), q.removeListener("close", Pe), Le();
            }
            function Le() {
              Z("unpipe"), Re.unpipe(q);
            }
            var Re = this, Ke = this._readableState;
            switch (Ke.pipesCount) {
              case 0:
                Ke.pipes = q;
                break;
              case 1:
                Ke.pipes = [Ke.pipes, q];
                break;
              default:
                Ke.pipes.push(q);
            }
            Ke.pipesCount += 1, Z("pipe count=%d opts=%j", Ke.pipesCount, S);
            var mt = (!S || S.end !== !1) && q !== s.stdout && q !== s.stderr, pt = mt ? O : Le;
            Ke.endEmitted ? s.nextTick(pt) : Re.once("end", pt), q.on("unpipe", P);
            var Nt = M(Re);
            q.on("drain", Nt);
            var ye = !1;
            return Re.on("data", le), d(q, "error", de), q.once("close", Pe), q.once("finish", ve), q.emit("pipe", Re), Ke.flowing || (Z("pipe resume"), Re.resume()), q;
          }, h.prototype.unpipe = function(q) {
            var S = this._readableState, P = { hasUnpiped: !1 };
            if (S.pipesCount === 0) return this;
            if (S.pipesCount === 1) return q && q !== S.pipes ? this : (q || (q = S.pipes), S.pipes = null, S.pipesCount = 0, S.flowing = !1, q && q.emit("unpipe", this, P), this);
            if (!q) {
              var O = S.pipes, ne = S.pipesCount;
              S.pipes = null, S.pipesCount = 0, S.flowing = !1;
              for (var le = 0; le < ne; le++) O[le].emit("unpipe", this, { hasUnpiped: !1 });
              return this;
            }
            var de = G(S.pipes, q);
            return de === -1 ? this : (S.pipes.splice(de, 1), S.pipesCount -= 1, S.pipesCount === 1 && (S.pipes = S.pipes[0]), q.emit("unpipe", this, P), this);
          }, h.prototype.on = function(q, S) {
            var P = ee.prototype.on.call(this, q, S), O = this._readableState;
            return q === "data" ? (O.readableListening = 0 < this.listenerCount("readable"), O.flowing !== !1 && this.resume()) : q == "readable" && !O.endEmitted && !O.readableListening && (O.readableListening = O.needReadable = !0, O.flowing = !1, O.emittedReadable = !1, Z("on readable", O.length, O.reading), O.length ? b(this) : !O.reading && s.nextTick(D, this)), P;
          }, h.prototype.addListener = h.prototype.on, h.prototype.removeListener = function(q, S) {
            var P = ee.prototype.removeListener.call(this, q, S);
            return q === "readable" && s.nextTick(j, this), P;
          }, h.prototype.removeAllListeners = function(q) {
            var S = ee.prototype.removeAllListeners.apply(this, arguments);
            return (q === "readable" || q === void 0) && s.nextTick(j, this), S;
          }, h.prototype.resume = function() {
            var q = this._readableState;
            return q.flowing || (Z("resume"), q.flowing = !q.readableListening, z(this, q)), q.paused = !1, this;
          }, h.prototype.pause = function() {
            return Z("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (Z("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
          }, h.prototype.wrap = function(q) {
            var S = this, P = this._readableState, O = !1;
            for (var ne in q.on("end", function() {
              if (Z("wrapped end"), P.decoder && !P.ended) {
                var de = P.decoder.end();
                de && de.length && S.push(de);
              }
              S.push(null);
            }), q.on("data", function(de) {
              if (Z("wrapped data"), P.decoder && (de = P.decoder.write(de)), !(P.objectMode && de == null) && (P.objectMode || de && de.length)) {
                var Pe = S.push(de);
                Pe || (O = !0, q.pause());
              }
            }), q) this[ne] === void 0 && typeof q[ne] == "function" && (this[ne] = /* @__PURE__ */ function(de) {
              return function() {
                return q[de].apply(q, arguments);
              };
            }(ne));
            for (var le = 0; le < Ie.length; le++) q.on(Ie[le], this.emit.bind(this, Ie[le]));
            return this._read = function(de) {
              Z("wrapped _read", de), O && (O = !1, q.resume());
            }, this;
          }, typeof Symbol == "function" && (h.prototype[Symbol.asyncIterator] = function() {
            return $ === void 0 && ($ = a("./internal/streams/async_iterator")), $(this);
          }), Object.defineProperty(h.prototype, "readableHighWaterMark", { enumerable: !1, get: function() {
            return this._readableState.highWaterMark;
          } }), Object.defineProperty(h.prototype, "readableBuffer", { enumerable: !1, get: function() {
            return this._readableState && this._readableState.buffer;
          } }), Object.defineProperty(h.prototype, "readableFlowing", { enumerable: !1, get: function() {
            return this._readableState.flowing;
          }, set: function(q) {
            this._readableState && (this._readableState.flowing = q);
          } }), h._fromList = F, Object.defineProperty(h.prototype, "readableLength", { enumerable: !1, get: function() {
            return this._readableState.length;
          } }), typeof Symbol == "function" && (h.from = function(q, S) {
            return se === void 0 && (se = a("./internal/streams/from")), se(h, q, S);
          });
        }).call(this);
      }).call(this, a("_process"), typeof Pr > "u" ? typeof self > "u" ? typeof window > "u" ? {} : window : self : Pr);
    }, { "../errors": 15, "./_stream_duplex": 16, "./internal/streams/async_iterator": 21, "./internal/streams/buffer_list": 22, "./internal/streams/destroy": 23, "./internal/streams/from": 25, "./internal/streams/state": 27, "./internal/streams/stream": 28, _process: 12, buffer: 3, events: 7, inherits: 10, "string_decoder/": 31, util: 2 }], 19: [function(a, o) {
      function s(v, k) {
        var w = this._transformState;
        w.transforming = !1;
        var b = w.writecb;
        if (b === null) return this.emit("error", new h());
        w.writechunk = null, w.writecb = null, k != null && this.push(k), b(v);
        var x = this._readableState;
        x.reading = !1, (x.needReadable || x.length < x.highWaterMark) && this._read(x.highWaterMark);
      }
      function l(v) {
        return this instanceof l ? (g.call(this, v), this._transformState = { afterTransform: s.bind(this), needTransform: !1, transforming: !1, writecb: null, writechunk: null, writeencoding: null }, this._readableState.needReadable = !0, this._readableState.sync = !1, v && (typeof v.transform == "function" && (this._transform = v.transform), typeof v.flush == "function" && (this._flush = v.flush)), void this.on("prefinish", c)) : new l(v);
      }
      function c() {
        var v = this;
        typeof this._flush != "function" || this._readableState.destroyed ? u(this, null, null) : this._flush(function(k, w) {
          u(v, k, w);
        });
      }
      function u(v, k, w) {
        if (k) return v.emit("error", k);
        if (w != null && v.push(w), v._writableState.length) throw new m();
        if (v._transformState.transforming) throw new p();
        return v.push(null);
      }
      o.exports = l;
      var d = a("../errors").codes, f = d.ERR_METHOD_NOT_IMPLEMENTED, h = d.ERR_MULTIPLE_CALLBACK, p = d.ERR_TRANSFORM_ALREADY_TRANSFORMING, m = d.ERR_TRANSFORM_WITH_LENGTH_0, g = a("./_stream_duplex");
      a("inherits")(l, g), l.prototype.push = function(v, k) {
        return this._transformState.needTransform = !1, g.prototype.push.call(this, v, k);
      }, l.prototype._transform = function(v, k, w) {
        w(new f("_transform()"));
      }, l.prototype._write = function(v, k, w) {
        var b = this._transformState;
        if (b.writecb = w, b.writechunk = v, b.writeencoding = k, !b.transforming) {
          var x = this._readableState;
          (b.needTransform || x.needReadable || x.length < x.highWaterMark) && this._read(x.highWaterMark);
        }
      }, l.prototype._read = function() {
        var v = this._transformState;
        v.writechunk === null || v.transforming ? v.needTransform = !0 : (v.transforming = !0, this._transform(v.writechunk, v.writeencoding, v.afterTransform));
      }, l.prototype._destroy = function(v, k) {
        g.prototype._destroy.call(this, v, function(w) {
          k(w);
        });
      };
    }, { "../errors": 15, "./_stream_duplex": 16, inherits: 10 }], 20: [function(a, o) {
      (function(s, l) {
        (function() {
          function c(K) {
            var X = this;
            this.next = null, this.entry = null, this.finish = function() {
              _(X, K);
            };
          }
          function u(K) {
            return Z.from(K);
          }
          function d(K) {
            return Z.isBuffer(K) || K instanceof oe;
          }
          function f() {
          }
          function h(K, X, re) {
            W = W || a("./_stream_duplex"), K = K || {}, typeof re != "boolean" && (re = X instanceof W), this.objectMode = !!K.objectMode, re && (this.objectMode = this.objectMode || !!K.writableObjectMode), this.highWaterMark = fe(this, K, "writableHighWaterMark", re), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
            var Ie = K.decodeStrings === !1;
            this.decodeStrings = !Ie, this.defaultEncoding = K.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(q) {
              A(X, q);
            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = K.emitClose !== !1, this.autoDestroy = !!K.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new c(this);
          }
          function p(K) {
            W = W || a("./_stream_duplex");
            var X = this instanceof W;
            return X || J.call(p, this) ? (this._writableState = new h(K, this, X), this.writable = !0, K && (typeof K.write == "function" && (this._write = K.write), typeof K.writev == "function" && (this._writev = K.writev), typeof K.destroy == "function" && (this._destroy = K.destroy), typeof K.final == "function" && (this._final = K.final)), void Y.call(this)) : new p(K);
          }
          function m(K, X) {
            var re = new Me();
            pe(K, re), s.nextTick(X, re);
          }
          function g(K, X, re, Ie) {
            var q;
            return re === null ? q = new je() : typeof re != "string" && !X.objectMode && (q = new ge("chunk", ["string", "Buffer"], re)), !q || (pe(K, q), s.nextTick(Ie, q), !1);
          }
          function v(K, X, re) {
            return K.objectMode || K.decodeStrings === !1 || typeof X != "string" || (X = Z.from(X, re)), X;
          }
          function k(K, X, re, Ie, q, S) {
            if (!re) {
              var P = v(X, Ie, q);
              Ie !== P && (re = !0, q = "buffer", Ie = P);
            }
            var O = X.objectMode ? 1 : Ie.length;
            X.length += O;
            var ne = X.length < X.highWaterMark;
            if (ne || (X.needDrain = !0), X.writing || X.corked) {
              var le = X.lastBufferedRequest;
              X.lastBufferedRequest = { chunk: Ie, encoding: q, isBuf: re, callback: S, next: null }, le ? le.next = X.lastBufferedRequest : X.bufferedRequest = X.lastBufferedRequest, X.bufferedRequestCount += 1;
            } else w(K, X, !1, O, Ie, q, S);
            return ne;
          }
          function w(K, X, re, Ie, q, S, P) {
            X.writelen = Ie, X.writecb = P, X.writing = !0, X.sync = !0, X.destroyed ? X.onwrite(new Oe("write")) : re ? K._writev(q, X.onwrite) : K._write(q, S, X.onwrite), X.sync = !1;
          }
          function b(K, X, re, Ie, q) {
            --X.pendingcb, re ? (s.nextTick(q, Ie), s.nextTick(V, K, X), K._writableState.errorEmitted = !0, pe(K, Ie)) : (q(Ie), K._writableState.errorEmitted = !0, pe(K, Ie), V(K, X));
          }
          function x(K) {
            K.writing = !1, K.writecb = null, K.length -= K.writelen, K.writelen = 0;
          }
          function A(K, X) {
            var re = K._writableState, Ie = re.sync, q = re.writecb;
            if (typeof q != "function") throw new se();
            if (x(re), X) b(K, re, Ie, X, q);
            else {
              var S = D(re) || K.destroyed;
              S || re.corked || re.bufferProcessing || !re.bufferedRequest || j(K, re), Ie ? s.nextTick(L, K, re, S, q) : L(K, re, S, q);
            }
          }
          function L(K, X, re, Ie) {
            re || M(K, X), X.pendingcb--, Ie(), V(K, X);
          }
          function M(K, X) {
            X.length === 0 && X.needDrain && (X.needDrain = !1, K.emit("drain"));
          }
          function j(K, X) {
            X.bufferProcessing = !0;
            var re = X.bufferedRequest;
            if (K._writev && re && re.next) {
              var Ie = X.bufferedRequestCount, q = Array(Ie), S = X.corkedRequestsFree;
              S.entry = re;
              for (var P = 0, O = !0; re; ) q[P] = re, re.isBuf || (O = !1), re = re.next, P += 1;
              q.allBuffers = O, w(K, X, !0, X.length, q, "", S.finish), X.pendingcb++, X.lastBufferedRequest = null, S.next ? (X.corkedRequestsFree = S.next, S.next = null) : X.corkedRequestsFree = new c(X), X.bufferedRequestCount = 0;
            } else {
              for (; re; ) {
                var ne = re.chunk, le = re.encoding, de = re.callback, Pe = X.objectMode ? 1 : ne.length;
                if (w(K, X, !1, Pe, ne, le, de), re = re.next, X.bufferedRequestCount--, X.writing) break;
              }
              re === null && (X.lastBufferedRequest = null);
            }
            X.bufferedRequest = re, X.bufferProcessing = !1;
          }
          function D(K) {
            return K.ending && K.length === 0 && K.bufferedRequest === null && !K.finished && !K.writing;
          }
          function z(K, X) {
            K._final(function(re) {
              X.pendingcb--, re && pe(K, re), X.prefinished = !0, K.emit("prefinish"), V(K, X);
            });
          }
          function H(K, X) {
            X.prefinished || X.finalCalled || (typeof K._final != "function" || X.destroyed ? (X.prefinished = !0, K.emit("prefinish")) : (X.pendingcb++, X.finalCalled = !0, s.nextTick(z, K, X)));
          }
          function V(K, X) {
            var re = D(X);
            if (re && (H(K, X), X.pendingcb === 0 && (X.finished = !0, K.emit("finish"), X.autoDestroy))) {
              var Ie = K._readableState;
              (!Ie || Ie.autoDestroy && Ie.endEmitted) && K.destroy();
            }
            return re;
          }
          function F(K, X, re) {
            X.ending = !0, V(K, X), re && (X.finished ? s.nextTick(re) : K.once("finish", re)), X.ended = !0, K.writable = !1;
          }
          function _(K, X, re) {
            var Ie = K.entry;
            for (K.entry = null; Ie; ) {
              var q = Ie.callback;
              X.pendingcb--, q(re), Ie = Ie.next;
            }
            X.corkedRequestsFree.next = K;
          }
          o.exports = p;
          var W;
          p.WritableState = h;
          var G = { deprecate: a("util-deprecate") }, Y = a("./internal/streams/stream"), Z = a("buffer").Buffer, oe = l.Uint8Array || function() {
          }, ee = a("./internal/streams/destroy"), ae = a("./internal/streams/state"), fe = ae.getHighWaterMark, me = a("../errors").codes, ge = me.ERR_INVALID_ARG_TYPE, $ = me.ERR_METHOD_NOT_IMPLEMENTED, se = me.ERR_MULTIPLE_CALLBACK, xe = me.ERR_STREAM_CANNOT_PIPE, Oe = me.ERR_STREAM_DESTROYED, je = me.ERR_STREAM_NULL_VALUES, Me = me.ERR_STREAM_WRITE_AFTER_END, he = me.ERR_UNKNOWN_ENCODING, pe = ee.errorOrDestroy;
          a("inherits")(p, Y), h.prototype.getBuffer = function() {
            for (var K = this.bufferedRequest, X = []; K; ) X.push(K), K = K.next;
            return X;
          }, function() {
            try {
              Object.defineProperty(h.prototype, "buffer", { get: G.deprecate(function() {
                return this.getBuffer();
              }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003") });
            } catch {
            }
          }();
          var J;
          typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (J = Function.prototype[Symbol.hasInstance], Object.defineProperty(p, Symbol.hasInstance, { value: function(K) {
            return !!J.call(this, K) || this === p && K && K._writableState instanceof h;
          } })) : J = function(K) {
            return K instanceof this;
          }, p.prototype.pipe = function() {
            pe(this, new xe());
          }, p.prototype.write = function(K, X, re) {
            var Ie = this._writableState, q = !1, S = !Ie.objectMode && d(K);
            return S && !Z.isBuffer(K) && (K = u(K)), typeof X == "function" && (re = X, X = null), S ? X = "buffer" : !X && (X = Ie.defaultEncoding), typeof re != "function" && (re = f), Ie.ending ? m(this, re) : (S || g(this, Ie, K, re)) && (Ie.pendingcb++, q = k(this, Ie, S, K, X, re)), q;
          }, p.prototype.cork = function() {
            this._writableState.corked++;
          }, p.prototype.uncork = function() {
            var K = this._writableState;
            K.corked && (K.corked--, !K.writing && !K.corked && !K.bufferProcessing && K.bufferedRequest && j(this, K));
          }, p.prototype.setDefaultEncoding = function(K) {
            if (typeof K == "string" && (K = K.toLowerCase()), !(-1 < ["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((K + "").toLowerCase()))) throw new he(K);
            return this._writableState.defaultEncoding = K, this;
          }, Object.defineProperty(p.prototype, "writableBuffer", { enumerable: !1, get: function() {
            return this._writableState && this._writableState.getBuffer();
          } }), Object.defineProperty(p.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
            return this._writableState.highWaterMark;
          } }), p.prototype._write = function(K, X, re) {
            re(new $("_write()"));
          }, p.prototype._writev = null, p.prototype.end = function(K, X, re) {
            var Ie = this._writableState;
            return typeof K == "function" ? (re = K, K = null, X = null) : typeof X == "function" && (re = X, X = null), K != null && this.write(K, X), Ie.corked && (Ie.corked = 1, this.uncork()), Ie.ending || F(this, Ie, re), this;
          }, Object.defineProperty(p.prototype, "writableLength", { enumerable: !1, get: function() {
            return this._writableState.length;
          } }), Object.defineProperty(p.prototype, "destroyed", { enumerable: !1, get: function() {
            return this._writableState !== void 0 && this._writableState.destroyed;
          }, set: function(K) {
            this._writableState && (this._writableState.destroyed = K);
          } }), p.prototype.destroy = ee.destroy, p.prototype._undestroy = ee.undestroy, p.prototype._destroy = function(K, X) {
            X(K);
          };
        }).call(this);
      }).call(this, a("_process"), typeof Pr > "u" ? typeof self > "u" ? typeof window > "u" ? {} : window : self : Pr);
    }, { "../errors": 15, "./_stream_duplex": 16, "./internal/streams/destroy": 23, "./internal/streams/state": 27, "./internal/streams/stream": 28, _process: 12, buffer: 3, inherits: 10, "util-deprecate": 32 }], 21: [function(a, o) {
      (function(s) {
        (function() {
          function l(M, j, D) {
            return j in M ? Object.defineProperty(M, j, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : M[j] = D, M;
          }
          function c(M, j) {
            return { value: M, done: j };
          }
          function u(M) {
            var j = M[m];
            if (j !== null) {
              var D = M[x].read();
              D !== null && (M[w] = null, M[m] = null, M[g] = null, j(c(D, !1)));
            }
          }
          function d(M) {
            s.nextTick(u, M);
          }
          function f(M, j) {
            return function(D, z) {
              M.then(function() {
                return j[k] ? void D(c(void 0, !0)) : void j[b](D, z);
              }, z);
            };
          }
          var h, p = a("./end-of-stream"), m = Symbol("lastResolve"), g = Symbol("lastReject"), v = Symbol("error"), k = Symbol("ended"), w = Symbol("lastPromise"), b = Symbol("handlePromise"), x = Symbol("stream"), A = Object.getPrototypeOf(function() {
          }), L = Object.setPrototypeOf((h = { get stream() {
            return this[x];
          }, next: function() {
            var M = this, j = this[v];
            if (j !== null) return Promise.reject(j);
            if (this[k]) return Promise.resolve(c(void 0, !0));
            if (this[x].destroyed) return new Promise(function(V, F) {
              s.nextTick(function() {
                M[v] ? F(M[v]) : V(c(void 0, !0));
              });
            });
            var D, z = this[w];
            if (z) D = new Promise(f(z, this));
            else {
              var H = this[x].read();
              if (H !== null) return Promise.resolve(c(H, !1));
              D = new Promise(this[b]);
            }
            return this[w] = D, D;
          } }, l(h, Symbol.asyncIterator, function() {
            return this;
          }), l(h, "return", function() {
            var M = this;
            return new Promise(function(j, D) {
              M[x].destroy(null, function(z) {
                return z ? void D(z) : void j(c(void 0, !0));
              });
            });
          }), h), A);
          o.exports = function(M) {
            var j, D = Object.create(L, (j = {}, l(j, x, { value: M, writable: !0 }), l(j, m, { value: null, writable: !0 }), l(j, g, { value: null, writable: !0 }), l(j, v, { value: null, writable: !0 }), l(j, k, { value: M._readableState.endEmitted, writable: !0 }), l(j, b, { value: function(z, H) {
              var V = D[x].read();
              V ? (D[w] = null, D[m] = null, D[g] = null, z(c(V, !1))) : (D[m] = z, D[g] = H);
            }, writable: !0 }), j));
            return D[w] = null, p(M, function(z) {
              if (z && z.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                var H = D[g];
                return H !== null && (D[w] = null, D[m] = null, D[g] = null, H(z)), void (D[v] = z);
              }
              var V = D[m];
              V !== null && (D[w] = null, D[m] = null, D[g] = null, V(c(void 0, !0))), D[k] = !0;
            }), M.on("readable", d.bind(null, D)), D;
          };
        }).call(this);
      }).call(this, a("_process"));
    }, { "./end-of-stream": 24, _process: 12 }], 22: [function(a, o) {
      function s(w, b) {
        var x = Object.keys(w);
        if (Object.getOwnPropertySymbols) {
          var A = Object.getOwnPropertySymbols(w);
          b && (A = A.filter(function(L) {
            return Object.getOwnPropertyDescriptor(w, L).enumerable;
          })), x.push.apply(x, A);
        }
        return x;
      }
      function l(w) {
        for (var b, x = 1; x < arguments.length; x++) b = arguments[x] == null ? {} : arguments[x], x % 2 ? s(Object(b), !0).forEach(function(A) {
          c(w, A, b[A]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(w, Object.getOwnPropertyDescriptors(b)) : s(Object(b)).forEach(function(A) {
          Object.defineProperty(w, A, Object.getOwnPropertyDescriptor(b, A));
        });
        return w;
      }
      function c(w, b, x) {
        return b in w ? Object.defineProperty(w, b, { value: x, enumerable: !0, configurable: !0, writable: !0 }) : w[b] = x, w;
      }
      function u(w, b) {
        if (!(w instanceof b)) throw new TypeError("Cannot call a class as a function");
      }
      function d(w, b) {
        for (var x, A = 0; A < b.length; A++) x = b[A], x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(w, x.key, x);
      }
      function f(w, b, x) {
        return b && d(w.prototype, b), w;
      }
      function h(w, b, x) {
        m.prototype.copy.call(w, b, x);
      }
      var p = a("buffer"), m = p.Buffer, g = a("util"), v = g.inspect, k = v && v.custom || "inspect";
      o.exports = function() {
        function w() {
          u(this, w), this.head = null, this.tail = null, this.length = 0;
        }
        return f(w, [{ key: "push", value: function(b) {
          var x = { data: b, next: null };
          0 < this.length ? this.tail.next = x : this.head = x, this.tail = x, ++this.length;
        } }, { key: "unshift", value: function(b) {
          var x = { data: b, next: this.head };
          this.length === 0 && (this.tail = x), this.head = x, ++this.length;
        } }, { key: "shift", value: function() {
          if (this.length !== 0) {
            var b = this.head.data;
            return this.head = this.length === 1 ? this.tail = null : this.head.next, --this.length, b;
          }
        } }, { key: "clear", value: function() {
          this.head = this.tail = null, this.length = 0;
        } }, { key: "join", value: function(b) {
          if (this.length === 0) return "";
          for (var x = this.head, A = "" + x.data; x = x.next; ) A += b + x.data;
          return A;
        } }, { key: "concat", value: function(b) {
          if (this.length === 0) return m.alloc(0);
          for (var x = m.allocUnsafe(b >>> 0), A = this.head, L = 0; A; ) h(A.data, x, L), L += A.data.length, A = A.next;
          return x;
        } }, { key: "consume", value: function(b, x) {
          var A;
          return b < this.head.data.length ? (A = this.head.data.slice(0, b), this.head.data = this.head.data.slice(b)) : b === this.head.data.length ? A = this.shift() : A = x ? this._getString(b) : this._getBuffer(b), A;
        } }, { key: "first", value: function() {
          return this.head.data;
        } }, { key: "_getString", value: function(b) {
          var x = this.head, A = 1, L = x.data;
          for (b -= L.length; x = x.next; ) {
            var M = x.data, j = b > M.length ? M.length : b;
            if (L += j === M.length ? M : M.slice(0, b), b -= j, b === 0) {
              j === M.length ? (++A, this.head = x.next ? x.next : this.tail = null) : (this.head = x, x.data = M.slice(j));
              break;
            }
            ++A;
          }
          return this.length -= A, L;
        } }, { key: "_getBuffer", value: function(b) {
          var x = m.allocUnsafe(b), A = this.head, L = 1;
          for (A.data.copy(x), b -= A.data.length; A = A.next; ) {
            var M = A.data, j = b > M.length ? M.length : b;
            if (M.copy(x, x.length - b, 0, j), b -= j, b === 0) {
              j === M.length ? (++L, this.head = A.next ? A.next : this.tail = null) : (this.head = A, A.data = M.slice(j));
              break;
            }
            ++L;
          }
          return this.length -= L, x;
        } }, { key: k, value: function(b, x) {
          return v(this, l({}, x, { depth: 0, customInspect: !1 }));
        } }]), w;
      }();
    }, { buffer: 3, util: 2 }], 23: [function(a, o) {
      (function(s) {
        (function() {
          function l(d, f) {
            u(d, f), c(d);
          }
          function c(d) {
            d._writableState && !d._writableState.emitClose || d._readableState && !d._readableState.emitClose || d.emit("close");
          }
          function u(d, f) {
            d.emit("error", f);
          }
          o.exports = { destroy: function(d, f) {
            var h = this, p = this._readableState && this._readableState.destroyed, m = this._writableState && this._writableState.destroyed;
            return p || m ? (f ? f(d) : d && (this._writableState ? !this._writableState.errorEmitted && (this._writableState.errorEmitted = !0, s.nextTick(u, this, d)) : s.nextTick(u, this, d)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(d || null, function(g) {
              !f && g ? h._writableState ? h._writableState.errorEmitted ? s.nextTick(c, h) : (h._writableState.errorEmitted = !0, s.nextTick(l, h, g)) : s.nextTick(l, h, g) : f ? (s.nextTick(c, h), f(g)) : s.nextTick(c, h);
            }), this);
          }, undestroy: function() {
            this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
          }, errorOrDestroy: function(d, f) {
            var h = d._readableState, p = d._writableState;
            h && h.autoDestroy || p && p.autoDestroy ? d.destroy(f) : d.emit("error", f);
          } };
        }).call(this);
      }).call(this, a("_process"));
    }, { _process: 12 }], 24: [function(a, o) {
      function s(f) {
        var h = !1;
        return function() {
          if (!h) {
            h = !0;
            for (var p = arguments.length, m = Array(p), g = 0; g < p; g++) m[g] = arguments[g];
            f.apply(this, m);
          }
        };
      }
      function l() {
      }
      function c(f) {
        return f.setHeader && typeof f.abort == "function";
      }
      function u(f, h, p) {
        if (typeof h == "function") return u(f, null, h);
        h || (h = {}), p = s(p || l);
        var m = h.readable || h.readable !== !1 && f.readable, g = h.writable || h.writable !== !1 && f.writable, v = function() {
          f.writable || w();
        }, k = f._writableState && f._writableState.finished, w = function() {
          g = !1, k = !0, m || p.call(f);
        }, b = f._readableState && f._readableState.endEmitted, x = function() {
          m = !1, b = !0, g || p.call(f);
        }, A = function(j) {
          p.call(f, j);
        }, L = function() {
          var j;
          return m && !b ? (f._readableState && f._readableState.ended || (j = new d()), p.call(f, j)) : g && !k ? (f._writableState && f._writableState.ended || (j = new d()), p.call(f, j)) : void 0;
        }, M = function() {
          f.req.on("finish", w);
        };
        return c(f) ? (f.on("complete", w), f.on("abort", L), f.req ? M() : f.on("request", M)) : g && !f._writableState && (f.on("end", v), f.on("close", v)), f.on("end", x), f.on("finish", w), h.error !== !1 && f.on("error", A), f.on("close", L), function() {
          f.removeListener("complete", w), f.removeListener("abort", L), f.removeListener("request", M), f.req && f.req.removeListener("finish", w), f.removeListener("end", v), f.removeListener("close", v), f.removeListener("finish", w), f.removeListener("end", x), f.removeListener("error", A), f.removeListener("close", L);
        };
      }
      var d = a("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
      o.exports = u;
    }, { "../../../errors": 15 }], 25: [function(a, o) {
      o.exports = function() {
        throw new Error("Readable.from is not available in the browser");
      };
    }, {}], 26: [function(a, o) {
      function s(k) {
        var w = !1;
        return function() {
          w || (w = !0, k.apply(void 0, arguments));
        };
      }
      function l(k) {
        if (k) throw k;
      }
      function c(k) {
        return k.setHeader && typeof k.abort == "function";
      }
      function u(k, w, b, x) {
        x = s(x);
        var A = !1;
        k.on("close", function() {
          A = !0;
        }), p === void 0 && (p = a("./end-of-stream")), p(k, { readable: w, writable: b }, function(M) {
          return M ? x(M) : (A = !0, void x());
        });
        var L = !1;
        return function(M) {
          if (!A) return L ? void 0 : (L = !0, c(k) ? k.abort() : typeof k.destroy == "function" ? k.destroy() : void x(M || new v("pipe")));
        };
      }
      function d(k) {
        k();
      }
      function f(k, w) {
        return k.pipe(w);
      }
      function h(k) {
        return k.length && typeof k[k.length - 1] == "function" ? k.pop() : l;
      }
      var p, m = a("../../../errors").codes, g = m.ERR_MISSING_ARGS, v = m.ERR_STREAM_DESTROYED;
      o.exports = function() {
        for (var k = arguments.length, w = Array(k), b = 0; b < k; b++) w[b] = arguments[b];
        var x = h(w);
        if (Array.isArray(w[0]) && (w = w[0]), 2 > w.length) throw new g("streams");
        var A, L = w.map(function(M, j) {
          var D = j < w.length - 1;
          return u(M, D, 0 < j, function(z) {
            A || (A = z), z && L.forEach(d), D || (L.forEach(d), x(A));
          });
        });
        return w.reduce(f);
      };
    }, { "../../../errors": 15, "./end-of-stream": 24 }], 27: [function(a, o) {
      function s(c, u, d) {
        return c.highWaterMark == null ? u ? c[d] : null : c.highWaterMark;
      }
      var l = a("../../../errors").codes.ERR_INVALID_OPT_VALUE;
      o.exports = { getHighWaterMark: function(c, u, d, f) {
        var h = s(u, f, d);
        if (h != null) {
          if (!(isFinite(h) && n(h) === h) || 0 > h) {
            var p = f ? d : "highWaterMark";
            throw new l(p, h);
          }
          return n(h);
        }
        return c.objectMode ? 16 : 16384;
      } };
    }, { "../../../errors": 15 }], 28: [function(a, o) {
      o.exports = a("events").EventEmitter;
    }, { events: 7 }], 29: [function(a, o, s) {
      s = o.exports = a("./lib/_stream_readable.js"), s.Stream = s, s.Readable = s, s.Writable = a("./lib/_stream_writable.js"), s.Duplex = a("./lib/_stream_duplex.js"), s.Transform = a("./lib/_stream_transform.js"), s.PassThrough = a("./lib/_stream_passthrough.js"), s.finished = a("./lib/internal/streams/end-of-stream.js"), s.pipeline = a("./lib/internal/streams/pipeline.js");
    }, { "./lib/_stream_duplex.js": 16, "./lib/_stream_passthrough.js": 17, "./lib/_stream_readable.js": 18, "./lib/_stream_transform.js": 19, "./lib/_stream_writable.js": 20, "./lib/internal/streams/end-of-stream.js": 24, "./lib/internal/streams/pipeline.js": 26 }], 30: [function(a, o, s) {
      function l(f, h) {
        for (var p in f) h[p] = f[p];
      }
      function c(f, h, p) {
        return d(f, h, p);
      }
      /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
      var u = a("buffer"), d = u.Buffer;
      d.from && d.alloc && d.allocUnsafe && d.allocUnsafeSlow ? o.exports = u : (l(u, s), s.Buffer = c), c.prototype = Object.create(d.prototype), l(d, c), c.from = function(f, h, p) {
        if (typeof f == "number") throw new TypeError("Argument must not be a number");
        return d(f, h, p);
      }, c.alloc = function(f, h, p) {
        if (typeof f != "number") throw new TypeError("Argument must be a number");
        var m = d(f);
        return h === void 0 ? m.fill(0) : typeof p == "string" ? m.fill(h, p) : m.fill(h), m;
      }, c.allocUnsafe = function(f) {
        if (typeof f != "number") throw new TypeError("Argument must be a number");
        return d(f);
      }, c.allocUnsafeSlow = function(f) {
        if (typeof f != "number") throw new TypeError("Argument must be a number");
        return u.SlowBuffer(f);
      };
    }, { buffer: 3 }], 31: [function(a, o, s) {
      function l(L) {
        if (!L) return "utf8";
        for (var M; ; ) switch (L) {
          case "utf8":
          case "utf-8":
            return "utf8";
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return "utf16le";
          case "latin1":
          case "binary":
            return "latin1";
          case "base64":
          case "ascii":
          case "hex":
            return L;
          default:
            if (M) return;
            L = ("" + L).toLowerCase(), M = !0;
        }
      }
      function c(L) {
        var M = l(L);
        if (typeof M != "string" && (x.isEncoding === A || !A(L))) throw new Error("Unknown encoding: " + L);
        return M || L;
      }
      function u(L) {
        this.encoding = c(L);
        var M;
        switch (this.encoding) {
          case "utf16le":
            this.text = m, this.end = g, M = 4;
            break;
          case "utf8":
            this.fillLast = p, M = 4;
            break;
          case "base64":
            this.text = v, this.end = k, M = 3;
            break;
          default:
            return this.write = w, void (this.end = b);
        }
        this.lastNeed = 0, this.lastTotal = 0, this.lastChar = x.allocUnsafe(M);
      }
      function d(L) {
        return 127 >= L ? 0 : L >> 5 == 6 ? 2 : L >> 4 == 14 ? 3 : L >> 3 == 30 ? 4 : L >> 6 == 2 ? -1 : -2;
      }
      function f(L, M, j) {
        var D = M.length - 1;
        if (D < j) return 0;
        var z = d(M[D]);
        return 0 <= z ? (0 < z && (L.lastNeed = z - 1), z) : --D < j || z === -2 ? 0 : (z = d(M[D]), 0 <= z ? (0 < z && (L.lastNeed = z - 2), z) : --D < j || z === -2 ? 0 : (z = d(M[D]), 0 <= z ? (0 < z && (z === 2 ? z = 0 : L.lastNeed = z - 3), z) : 0));
      }
      function h(L, M) {
        if ((192 & M[0]) != 128) return L.lastNeed = 0, "�";
        if (1 < L.lastNeed && 1 < M.length) {
          if ((192 & M[1]) != 128) return L.lastNeed = 1, "�";
          if (2 < L.lastNeed && 2 < M.length && (192 & M[2]) != 128) return L.lastNeed = 2, "�";
        }
      }
      function p(L) {
        var M = this.lastTotal - this.lastNeed, j = h(this, L);
        return j === void 0 ? this.lastNeed <= L.length ? (L.copy(this.lastChar, M, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (L.copy(this.lastChar, M, 0, L.length), void (this.lastNeed -= L.length)) : j;
      }
      function m(L, M) {
        if ((L.length - M) % 2 == 0) {
          var j = L.toString("utf16le", M);
          if (j) {
            var D = j.charCodeAt(j.length - 1);
            if (55296 <= D && 56319 >= D) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = L[L.length - 2], this.lastChar[1] = L[L.length - 1], j.slice(0, -1);
          }
          return j;
        }
        return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = L[L.length - 1], L.toString("utf16le", M, L.length - 1);
      }
      function g(L) {
        var M = L && L.length ? this.write(L) : "";
        if (this.lastNeed) {
          var j = this.lastTotal - this.lastNeed;
          return M + this.lastChar.toString("utf16le", 0, j);
        }
        return M;
      }
      function v(L, M) {
        var j = (L.length - M) % 3;
        return j == 0 ? L.toString("base64", M) : (this.lastNeed = 3 - j, this.lastTotal = 3, j == 1 ? this.lastChar[0] = L[L.length - 1] : (this.lastChar[0] = L[L.length - 2], this.lastChar[1] = L[L.length - 1]), L.toString("base64", M, L.length - j));
      }
      function k(L) {
        var M = L && L.length ? this.write(L) : "";
        return this.lastNeed ? M + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : M;
      }
      function w(L) {
        return L.toString(this.encoding);
      }
      function b(L) {
        return L && L.length ? this.write(L) : "";
      }
      var x = a("safe-buffer").Buffer, A = x.isEncoding || function(L) {
        switch (L = "" + L, L && L.toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
          case "raw":
            return !0;
          default:
            return !1;
        }
      };
      s.StringDecoder = u, u.prototype.write = function(L) {
        if (L.length === 0) return "";
        var M, j;
        if (this.lastNeed) {
          if (M = this.fillLast(L), M === void 0) return "";
          j = this.lastNeed, this.lastNeed = 0;
        } else j = 0;
        return j < L.length ? M ? M + this.text(L, j) : this.text(L, j) : M || "";
      }, u.prototype.end = function(L) {
        var M = L && L.length ? this.write(L) : "";
        return this.lastNeed ? M + "�" : M;
      }, u.prototype.text = function(L, M) {
        var j = f(this, L, M);
        if (!this.lastNeed) return L.toString("utf8", M);
        this.lastTotal = j;
        var D = L.length - (j - this.lastNeed);
        return L.copy(this.lastChar, 0, D), L.toString("utf8", M, D);
      }, u.prototype.fillLast = function(L) {
        return this.lastNeed <= L.length ? (L.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (L.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, L.length), void (this.lastNeed -= L.length));
      };
    }, { "safe-buffer": 30 }], 32: [function(a, o) {
      (function(s) {
        (function() {
          function l(c) {
            try {
              if (!s.localStorage) return !1;
            } catch {
              return !1;
            }
            var u = s.localStorage[c];
            return u != null && (u + "").toLowerCase() === "true";
          }
          o.exports = function(c, u) {
            function d() {
              if (!f) {
                if (l("throwDeprecation")) throw new Error(u);
                l("traceDeprecation") ? console.trace(u) : console.warn(u), f = !0;
              }
              return c.apply(this, arguments);
            }
            if (l("noDeprecation")) return c;
            var f = !1;
            return d;
          };
        }).call(this);
      }).call(this, typeof Pr > "u" ? typeof self > "u" ? typeof window > "u" ? {} : window : self : Pr);
    }, {}], "/": [function(a, o) {
      function s(k) {
        return k.replace(/a=ice-options:trickle\s\n/g, "");
      }
      function l(k) {
        console.warn(k);
      }
      /*! simple-peer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
      const c = a("debug")("simple-peer"), u = a("get-browser-rtc"), d = a("randombytes"), f = a("readable-stream"), h = a("queue-microtask"), p = a("err-code"), { Buffer: m } = a("buffer"), g = 65536;
      class v extends f.Duplex {
        constructor(w) {
          if (w = Object.assign({ allowHalfOpen: !1 }, w), super(w), this._id = d(4).toString("hex").slice(0, 7), this._debug("new peer %o", w), this.channelName = w.initiator ? w.channelName || d(20).toString("hex") : null, this.initiator = w.initiator || !1, this.channelConfig = w.channelConfig || v.channelConfig, this.channelNegotiated = this.channelConfig.negotiated, this.config = Object.assign({}, v.config, w.config), this.offerOptions = w.offerOptions || {}, this.answerOptions = w.answerOptions || {}, this.sdpTransform = w.sdpTransform || ((b) => b), this.streams = w.streams || (w.stream ? [w.stream] : []), this.trickle = w.trickle === void 0 || w.trickle, this.allowHalfTrickle = w.allowHalfTrickle !== void 0 && w.allowHalfTrickle, this.iceCompleteTimeout = w.iceCompleteTimeout || 5e3, this.destroyed = !1, this.destroying = !1, this._connected = !1, this.remoteAddress = void 0, this.remoteFamily = void 0, this.remotePort = void 0, this.localAddress = void 0, this.localFamily = void 0, this.localPort = void 0, this._wrtc = w.wrtc && typeof w.wrtc == "object" ? w.wrtc : u(), !this._wrtc) throw p(typeof window > "u" ? new Error("No WebRTC support: Specify `opts.wrtc` option in this environment") : new Error("No WebRTC support: Not a supported browser"), "ERR_WEBRTC_SUPPORT");
          this._pcReady = !1, this._channelReady = !1, this._iceComplete = !1, this._iceCompleteTimer = null, this._channel = null, this._pendingCandidates = [], this._isNegotiating = !1, this._firstNegotiation = !0, this._batchedNegotiation = !1, this._queuedNegotiation = !1, this._sendersAwaitingStable = [], this._senderMap = /* @__PURE__ */ new Map(), this._closingInterval = null, this._remoteTracks = [], this._remoteStreams = [], this._chunk = null, this._cb = null, this._interval = null;
          try {
            this._pc = new this._wrtc.RTCPeerConnection(this.config);
          } catch (b) {
            return void this.destroy(p(b, "ERR_PC_CONSTRUCTOR"));
          }
          this._isReactNativeWebrtc = typeof this._pc._peerConnectionId == "number", this._pc.oniceconnectionstatechange = () => {
            this._onIceStateChange();
          }, this._pc.onicegatheringstatechange = () => {
            this._onIceStateChange();
          }, this._pc.onconnectionstatechange = () => {
            this._onConnectionStateChange();
          }, this._pc.onsignalingstatechange = () => {
            this._onSignalingStateChange();
          }, this._pc.onicecandidate = (b) => {
            this._onIceCandidate(b);
          }, typeof this._pc.peerIdentity == "object" && this._pc.peerIdentity.catch((b) => {
            this.destroy(p(b, "ERR_PC_PEER_IDENTITY"));
          }), this.initiator || this.channelNegotiated ? this._setupData({ channel: this._pc.createDataChannel(this.channelName, this.channelConfig) }) : this._pc.ondatachannel = (b) => {
            this._setupData(b);
          }, this.streams && this.streams.forEach((b) => {
            this.addStream(b);
          }), this._pc.ontrack = (b) => {
            this._onTrack(b);
          }, this._debug("initial negotiation"), this._needsNegotiation(), this._onFinishBound = () => {
            this._onFinish();
          }, this.once("finish", this._onFinishBound);
        }
        get bufferSize() {
          return this._channel && this._channel.bufferedAmount || 0;
        }
        get connected() {
          return this._connected && this._channel.readyState === "open";
        }
        address() {
          return { port: this.localPort, family: this.localFamily, address: this.localAddress };
        }
        signal(w) {
          if (!this.destroying) {
            if (this.destroyed) throw p(new Error("cannot signal after peer is destroyed"), "ERR_DESTROYED");
            if (typeof w == "string") try {
              w = JSON.parse(w);
            } catch {
              w = {};
            }
            this._debug("signal()"), w.renegotiate && this.initiator && (this._debug("got request to renegotiate"), this._needsNegotiation()), w.transceiverRequest && this.initiator && (this._debug("got request for transceiver"), this.addTransceiver(w.transceiverRequest.kind, w.transceiverRequest.init)), w.candidate && (this._pc.remoteDescription && this._pc.remoteDescription.type ? this._addIceCandidate(w.candidate) : this._pendingCandidates.push(w.candidate)), w.sdp && this._pc.setRemoteDescription(new this._wrtc.RTCSessionDescription(w)).then(() => {
              this.destroyed || (this._pendingCandidates.forEach((b) => {
                this._addIceCandidate(b);
              }), this._pendingCandidates = [], this._pc.remoteDescription.type === "offer" && this._createAnswer());
            }).catch((b) => {
              this.destroy(p(b, "ERR_SET_REMOTE_DESCRIPTION"));
            }), w.sdp || w.candidate || w.renegotiate || w.transceiverRequest || this.destroy(p(new Error("signal() called with invalid signal data"), "ERR_SIGNALING"));
          }
        }
        _addIceCandidate(w) {
          const b = new this._wrtc.RTCIceCandidate(w);
          this._pc.addIceCandidate(b).catch((x) => {
            !b.address || b.address.endsWith(".local") ? l("Ignoring unsupported ICE candidate.") : this.destroy(p(x, "ERR_ADD_ICE_CANDIDATE"));
          });
        }
        send(w) {
          if (!this.destroying) {
            if (this.destroyed) throw p(new Error("cannot send after peer is destroyed"), "ERR_DESTROYED");
            this._channel.send(w);
          }
        }
        addTransceiver(w, b) {
          if (!this.destroying) {
            if (this.destroyed) throw p(new Error("cannot addTransceiver after peer is destroyed"), "ERR_DESTROYED");
            if (this._debug("addTransceiver()"), this.initiator) try {
              this._pc.addTransceiver(w, b), this._needsNegotiation();
            } catch (x) {
              this.destroy(p(x, "ERR_ADD_TRANSCEIVER"));
            }
            else this.emit("signal", { type: "transceiverRequest", transceiverRequest: { kind: w, init: b } });
          }
        }
        addStream(w) {
          if (!this.destroying) {
            if (this.destroyed) throw p(new Error("cannot addStream after peer is destroyed"), "ERR_DESTROYED");
            this._debug("addStream()"), w.getTracks().forEach((b) => {
              this.addTrack(b, w);
            });
          }
        }
        addTrack(w, b) {
          if (this.destroying) return;
          if (this.destroyed) throw p(new Error("cannot addTrack after peer is destroyed"), "ERR_DESTROYED");
          this._debug("addTrack()");
          const x = this._senderMap.get(w) || /* @__PURE__ */ new Map();
          let A = x.get(b);
          if (!A) A = this._pc.addTrack(w, b), x.set(b, A), this._senderMap.set(w, x), this._needsNegotiation();
          else throw A.removed ? p(new Error("Track has been removed. You should enable/disable tracks that you want to re-add."), "ERR_SENDER_REMOVED") : p(new Error("Track has already been added to that stream."), "ERR_SENDER_ALREADY_ADDED");
        }
        replaceTrack(w, b, x) {
          if (this.destroying) return;
          if (this.destroyed) throw p(new Error("cannot replaceTrack after peer is destroyed"), "ERR_DESTROYED");
          this._debug("replaceTrack()");
          const A = this._senderMap.get(w), L = A ? A.get(x) : null;
          if (!L) throw p(new Error("Cannot replace track that was never added."), "ERR_TRACK_NOT_ADDED");
          b && this._senderMap.set(b, A), L.replaceTrack == null ? this.destroy(p(new Error("replaceTrack is not supported in this browser"), "ERR_UNSUPPORTED_REPLACETRACK")) : L.replaceTrack(b);
        }
        removeTrack(w, b) {
          if (this.destroying) return;
          if (this.destroyed) throw p(new Error("cannot removeTrack after peer is destroyed"), "ERR_DESTROYED");
          this._debug("removeSender()");
          const x = this._senderMap.get(w), A = x ? x.get(b) : null;
          if (!A) throw p(new Error("Cannot remove track that was never added."), "ERR_TRACK_NOT_ADDED");
          try {
            A.removed = !0, this._pc.removeTrack(A);
          } catch (L) {
            L.name === "NS_ERROR_UNEXPECTED" ? this._sendersAwaitingStable.push(A) : this.destroy(p(L, "ERR_REMOVE_TRACK"));
          }
          this._needsNegotiation();
        }
        removeStream(w) {
          if (!this.destroying) {
            if (this.destroyed) throw p(new Error("cannot removeStream after peer is destroyed"), "ERR_DESTROYED");
            this._debug("removeSenders()"), w.getTracks().forEach((b) => {
              this.removeTrack(b, w);
            });
          }
        }
        _needsNegotiation() {
          this._debug("_needsNegotiation"), this._batchedNegotiation || (this._batchedNegotiation = !0, h(() => {
            this._batchedNegotiation = !1, this.initiator || !this._firstNegotiation ? (this._debug("starting batched negotiation"), this.negotiate()) : this._debug("non-initiator initial negotiation request discarded"), this._firstNegotiation = !1;
          }));
        }
        negotiate() {
          if (!this.destroying) {
            if (this.destroyed) throw p(new Error("cannot negotiate after peer is destroyed"), "ERR_DESTROYED");
            this.initiator ? this._isNegotiating ? (this._queuedNegotiation = !0, this._debug("already negotiating, queueing")) : (this._debug("start negotiation"), setTimeout(() => {
              this._createOffer();
            }, 0)) : this._isNegotiating ? (this._queuedNegotiation = !0, this._debug("already negotiating, queueing")) : (this._debug("requesting negotiation from initiator"), this.emit("signal", { type: "renegotiate", renegotiate: !0 })), this._isNegotiating = !0;
          }
        }
        destroy(w) {
          this._destroy(w, () => {
          });
        }
        _destroy(w, b) {
          this.destroyed || this.destroying || (this.destroying = !0, this._debug("destroying (error: %s)", w && (w.message || w)), h(() => {
            if (this.destroyed = !0, this.destroying = !1, this._debug("destroy (error: %s)", w && (w.message || w)), this.readable = this.writable = !1, this._readableState.ended || this.push(null), this._writableState.finished || this.end(), this._connected = !1, this._pcReady = !1, this._channelReady = !1, this._remoteTracks = null, this._remoteStreams = null, this._senderMap = null, clearInterval(this._closingInterval), this._closingInterval = null, clearInterval(this._interval), this._interval = null, this._chunk = null, this._cb = null, this._onFinishBound && this.removeListener("finish", this._onFinishBound), this._onFinishBound = null, this._channel) {
              try {
                this._channel.close();
              } catch {
              }
              this._channel.onmessage = null, this._channel.onopen = null, this._channel.onclose = null, this._channel.onerror = null;
            }
            if (this._pc) {
              try {
                this._pc.close();
              } catch {
              }
              this._pc.oniceconnectionstatechange = null, this._pc.onicegatheringstatechange = null, this._pc.onsignalingstatechange = null, this._pc.onicecandidate = null, this._pc.ontrack = null, this._pc.ondatachannel = null;
            }
            this._pc = null, this._channel = null, w && this.emit("error", w), this.emit("close"), b();
          }));
        }
        _setupData(w) {
          if (!w.channel) return this.destroy(p(new Error("Data channel event is missing `channel` property"), "ERR_DATA_CHANNEL"));
          this._channel = w.channel, this._channel.binaryType = "arraybuffer", typeof this._channel.bufferedAmountLowThreshold == "number" && (this._channel.bufferedAmountLowThreshold = g), this.channelName = this._channel.label, this._channel.onmessage = (x) => {
            this._onChannelMessage(x);
          }, this._channel.onbufferedamountlow = () => {
            this._onChannelBufferedAmountLow();
          }, this._channel.onopen = () => {
            this._onChannelOpen();
          }, this._channel.onclose = () => {
            this._onChannelClose();
          }, this._channel.onerror = (x) => {
            const A = x.error instanceof Error ? x.error : new Error(`Datachannel error: ${x.message} ${x.filename}:${x.lineno}:${x.colno}`);
            this.destroy(p(A, "ERR_DATA_CHANNEL"));
          };
          let b = !1;
          this._closingInterval = setInterval(() => {
            this._channel && this._channel.readyState === "closing" ? (b && this._onChannelClose(), b = !0) : b = !1;
          }, 5e3);
        }
        _read() {
        }
        _write(w, b, x) {
          if (this.destroyed) return x(p(new Error("cannot write after peer is destroyed"), "ERR_DATA_CHANNEL"));
          if (this._connected) {
            try {
              this.send(w);
            } catch (A) {
              return this.destroy(p(A, "ERR_DATA_CHANNEL"));
            }
            this._channel.bufferedAmount > g ? (this._debug("start backpressure: bufferedAmount %d", this._channel.bufferedAmount), this._cb = x) : x(null);
          } else this._debug("write before connect"), this._chunk = w, this._cb = x;
        }
        _onFinish() {
          if (!this.destroyed) {
            const w = () => {
              setTimeout(() => this.destroy(), 1e3);
            };
            this._connected ? w() : this.once("connect", w);
          }
        }
        _startIceCompleteTimeout() {
          this.destroyed || this._iceCompleteTimer || (this._debug("started iceComplete timeout"), this._iceCompleteTimer = setTimeout(() => {
            this._iceComplete || (this._iceComplete = !0, this._debug("iceComplete timeout completed"), this.emit("iceTimeout"), this.emit("_iceComplete"));
          }, this.iceCompleteTimeout));
        }
        _createOffer() {
          this.destroyed || this._pc.createOffer(this.offerOptions).then((w) => {
            if (this.destroyed) return;
            this.trickle || this.allowHalfTrickle || (w.sdp = s(w.sdp)), w.sdp = this.sdpTransform(w.sdp);
            const b = () => {
              if (!this.destroyed) {
                const x = this._pc.localDescription || w;
                this._debug("signal"), this.emit("signal", { type: x.type, sdp: x.sdp });
              }
            };
            this._pc.setLocalDescription(w).then(() => {
              this._debug("createOffer success"), this.destroyed || (this.trickle || this._iceComplete ? b() : this.once("_iceComplete", b));
            }).catch((x) => {
              this.destroy(p(x, "ERR_SET_LOCAL_DESCRIPTION"));
            });
          }).catch((w) => {
            this.destroy(p(w, "ERR_CREATE_OFFER"));
          });
        }
        _requestMissingTransceivers() {
          this._pc.getTransceivers && this._pc.getTransceivers().forEach((w) => {
            w.mid || !w.sender.track || w.requested || (w.requested = !0, this.addTransceiver(w.sender.track.kind));
          });
        }
        _createAnswer() {
          this.destroyed || this._pc.createAnswer(this.answerOptions).then((w) => {
            if (this.destroyed) return;
            this.trickle || this.allowHalfTrickle || (w.sdp = s(w.sdp)), w.sdp = this.sdpTransform(w.sdp);
            const b = () => {
              if (!this.destroyed) {
                const x = this._pc.localDescription || w;
                this._debug("signal"), this.emit("signal", { type: x.type, sdp: x.sdp }), this.initiator || this._requestMissingTransceivers();
              }
            };
            this._pc.setLocalDescription(w).then(() => {
              this.destroyed || (this.trickle || this._iceComplete ? b() : this.once("_iceComplete", b));
            }).catch((x) => {
              this.destroy(p(x, "ERR_SET_LOCAL_DESCRIPTION"));
            });
          }).catch((w) => {
            this.destroy(p(w, "ERR_CREATE_ANSWER"));
          });
        }
        _onConnectionStateChange() {
          this.destroyed || this._pc.connectionState === "failed" && this.destroy(p(new Error("Connection failed."), "ERR_CONNECTION_FAILURE"));
        }
        _onIceStateChange() {
          if (this.destroyed) return;
          const w = this._pc.iceConnectionState, b = this._pc.iceGatheringState;
          this._debug("iceStateChange (connection: %s) (gathering: %s)", w, b), this.emit("iceStateChange", w, b), (w === "connected" || w === "completed") && (this._pcReady = !0, this._maybeReady()), w === "failed" && this.destroy(p(new Error("Ice connection failed."), "ERR_ICE_CONNECTION_FAILURE")), w === "closed" && this.destroy(p(new Error("Ice connection closed."), "ERR_ICE_CONNECTION_CLOSED"));
        }
        getStats(w) {
          const b = (x) => (Object.prototype.toString.call(x.values) === "[object Array]" && x.values.forEach((A) => {
            Object.assign(x, A);
          }), x);
          this._pc.getStats.length === 0 || this._isReactNativeWebrtc ? this._pc.getStats().then((x) => {
            const A = [];
            x.forEach((L) => {
              A.push(b(L));
            }), w(null, A);
          }, (x) => w(x)) : 0 < this._pc.getStats.length ? this._pc.getStats((x) => {
            if (this.destroyed) return;
            const A = [];
            x.result().forEach((L) => {
              const M = {};
              L.names().forEach((j) => {
                M[j] = L.stat(j);
              }), M.id = L.id, M.type = L.type, M.timestamp = L.timestamp, A.push(b(M));
            }), w(null, A);
          }, (x) => w(x)) : w(null, []);
        }
        _maybeReady() {
          if (this._debug("maybeReady pc %s channel %s", this._pcReady, this._channelReady), this._connected || this._connecting || !this._pcReady || !this._channelReady) return;
          this._connecting = !0;
          const w = () => {
            this.destroyed || this.getStats((b, x) => {
              if (this.destroyed) return;
              b && (x = []);
              const A = {}, L = {}, M = {};
              let j = !1;
              x.forEach((z) => {
                (z.type === "remotecandidate" || z.type === "remote-candidate") && (A[z.id] = z), (z.type === "localcandidate" || z.type === "local-candidate") && (L[z.id] = z), (z.type === "candidatepair" || z.type === "candidate-pair") && (M[z.id] = z);
              });
              const D = (z) => {
                j = !0;
                let H = L[z.localCandidateId];
                H && (H.ip || H.address) ? (this.localAddress = H.ip || H.address, this.localPort = +H.port) : H && H.ipAddress ? (this.localAddress = H.ipAddress, this.localPort = +H.portNumber) : typeof z.googLocalAddress == "string" && (H = z.googLocalAddress.split(":"), this.localAddress = H[0], this.localPort = +H[1]), this.localAddress && (this.localFamily = this.localAddress.includes(":") ? "IPv6" : "IPv4");
                let V = A[z.remoteCandidateId];
                V && (V.ip || V.address) ? (this.remoteAddress = V.ip || V.address, this.remotePort = +V.port) : V && V.ipAddress ? (this.remoteAddress = V.ipAddress, this.remotePort = +V.portNumber) : typeof z.googRemoteAddress == "string" && (V = z.googRemoteAddress.split(":"), this.remoteAddress = V[0], this.remotePort = +V[1]), this.remoteAddress && (this.remoteFamily = this.remoteAddress.includes(":") ? "IPv6" : "IPv4"), this._debug("connect local: %s:%s remote: %s:%s", this.localAddress, this.localPort, this.remoteAddress, this.remotePort);
              };
              if (x.forEach((z) => {
                z.type === "transport" && z.selectedCandidatePairId && D(M[z.selectedCandidatePairId]), (z.type === "googCandidatePair" && z.googActiveConnection === "true" || (z.type === "candidatepair" || z.type === "candidate-pair") && z.selected) && D(z);
              }), !j && (!Object.keys(M).length || Object.keys(L).length)) return void setTimeout(w, 100);
              if (this._connecting = !1, this._connected = !0, this._chunk) {
                try {
                  this.send(this._chunk);
                } catch (H) {
                  return this.destroy(p(H, "ERR_DATA_CHANNEL"));
                }
                this._chunk = null, this._debug('sent chunk from "write before connect"');
                const z = this._cb;
                this._cb = null, z(null);
              }
              typeof this._channel.bufferedAmountLowThreshold != "number" && (this._interval = setInterval(() => this._onInterval(), 150), this._interval.unref && this._interval.unref()), this._debug("connect"), this.emit("connect");
            });
          };
          w();
        }
        _onInterval() {
          this._cb && this._channel && !(this._channel.bufferedAmount > g) && this._onChannelBufferedAmountLow();
        }
        _onSignalingStateChange() {
          this.destroyed || (this._pc.signalingState === "stable" && (this._isNegotiating = !1, this._debug("flushing sender queue", this._sendersAwaitingStable), this._sendersAwaitingStable.forEach((w) => {
            this._pc.removeTrack(w), this._queuedNegotiation = !0;
          }), this._sendersAwaitingStable = [], this._queuedNegotiation ? (this._debug("flushing negotiation queue"), this._queuedNegotiation = !1, this._needsNegotiation()) : (this._debug("negotiated"), this.emit("negotiated"))), this._debug("signalingStateChange %s", this._pc.signalingState), this.emit("signalingStateChange", this._pc.signalingState));
        }
        _onIceCandidate(w) {
          this.destroyed || (w.candidate && this.trickle ? this.emit("signal", { type: "candidate", candidate: { candidate: w.candidate.candidate, sdpMLineIndex: w.candidate.sdpMLineIndex, sdpMid: w.candidate.sdpMid } }) : !w.candidate && !this._iceComplete && (this._iceComplete = !0, this.emit("_iceComplete")), w.candidate && this._startIceCompleteTimeout());
        }
        _onChannelMessage(w) {
          if (this.destroyed) return;
          let b = w.data;
          b instanceof ArrayBuffer && (b = m.from(b)), this.push(b);
        }
        _onChannelBufferedAmountLow() {
          if (!this.destroyed && this._cb) {
            this._debug("ending backpressure: bufferedAmount %d", this._channel.bufferedAmount);
            const w = this._cb;
            this._cb = null, w(null);
          }
        }
        _onChannelOpen() {
          this._connected || this.destroyed || (this._debug("on channel open"), this._channelReady = !0, this._maybeReady());
        }
        _onChannelClose() {
          this.destroyed || (this._debug("on channel close"), this.destroy());
        }
        _onTrack(w) {
          this.destroyed || w.streams.forEach((b) => {
            this._debug("on track"), this.emit("track", w.track, b), this._remoteTracks.push({ track: w.track, stream: b }), this._remoteStreams.some((x) => x.id === b.id) || (this._remoteStreams.push(b), h(() => {
              this._debug("on stream"), this.emit("stream", b);
            }));
          });
        }
        _debug() {
          const w = [].slice.call(arguments);
          w[0] = "[" + this._id + "] " + w[0], c.apply(null, w);
        }
      }
      v.WEBRTC_SUPPORT = !!u(), v.config = { iceServers: [{ urls: ["stun:stun.l.google.com:19302", "stun:global.stun.twilio.com:3478"] }], sdpSemantics: "unified-plan" }, v.channelConfig = {}, o.exports = v;
    }, { buffer: 3, debug: 4, "err-code": 6, "get-browser-rtc": 8, "queue-microtask": 13, randombytes: 14, "readable-stream": 29 }] }, {}, [])("/");
  });
})(See);
var aDt = See.exports;
const oDt = /* @__PURE__ */ kd(aDt), YS = 0, KS = 1, Lee = 2, Tee = (t, e) => {
  bt(t, YS);
  const n = eNt(e);
  Gn(t, n);
}, Eee = (t, e, n) => {
  bt(t, KS), Gn(t, tm(e, n));
}, sDt = (t, e, n) => Eee(e, n, wr(t)), jee = (t, e, n) => {
  try {
    p0(e, wr(t), n);
  } catch (r) {
    console.error("Caught error while handling a Yjs update", r);
  }
}, lDt = (t, e) => {
  bt(t, Lee), Gn(t, e);
}, cDt = jee, uDt = (t, e, n, r) => {
  const i = Ot(t);
  switch (i) {
    case YS:
      sDt(t, e, n);
      break;
    case KS:
      jee(t, n, r);
      break;
    case Lee:
      cDt(t, n, r);
      break;
    default:
      throw new Error("Unknown message type");
  }
  return i;
}, eb = 3e4;
class dDt extends xS {
  /**
   * @param {Y.Doc} doc
   */
  constructor(e) {
    super(), this.doc = e, this.clientID = e.clientID, this.states = /* @__PURE__ */ new Map(), this.meta = /* @__PURE__ */ new Map(), this._checkInterval = /** @type {any} */
    setInterval(() => {
      const n = ls();
      this.getLocalState() !== null && eb / 2 <= n - /** @type {{lastUpdated:number}} */
      this.meta.get(this.clientID).lastUpdated && this.setLocalState(this.getLocalState());
      const r = [];
      this.meta.forEach((i, a) => {
        a !== this.clientID && eb <= n - i.lastUpdated && this.states.has(a) && r.push(a);
      }), r.length > 0 && Xw(this, r, "timeout");
    }, co(eb / 10)), e.on("destroy", () => {
      this.destroy();
    }), this.setLocalState({});
  }
  destroy() {
    this.emit("destroy", [this]), this.setLocalState(null), super.destroy(), clearInterval(this._checkInterval);
  }
  /**
   * @return {Object<string,any>|null}
   */
  getLocalState() {
    return this.states.get(this.clientID) || null;
  }
  /**
   * @param {Object<string,any>|null} state
   */
  setLocalState(e) {
    const n = this.clientID, r = this.meta.get(n), i = r === void 0 ? 0 : r.clock + 1, a = this.states.get(n);
    e === null ? this.states.delete(n) : this.states.set(n, e), this.meta.set(n, {
      clock: i,
      lastUpdated: ls()
    });
    const o = [], s = [], l = [], c = [];
    e === null ? c.push(n) : a == null ? e != null && o.push(n) : (s.push(n), hh(a, e) || l.push(n)), (o.length > 0 || l.length > 0 || c.length > 0) && this.emit("change", [{ added: o, updated: l, removed: c }, "local"]), this.emit("update", [{ added: o, updated: s, removed: c }, "local"]);
  }
  /**
   * @param {string} field
   * @param {any} value
   */
  setLocalStateField(e, n) {
    const r = this.getLocalState();
    r !== null && this.setLocalState({
      ...r,
      [e]: n
    });
  }
  /**
   * @return {Map<number,Object<string,any>>}
   */
  getStates() {
    return this.states;
  }
}
const Xw = (t, e, n) => {
  const r = [];
  for (let i = 0; i < e.length; i++) {
    const a = e[i];
    if (t.states.has(a)) {
      if (t.states.delete(a), a === t.clientID) {
        const o = (
          /** @type {MetaClientState} */
          t.meta.get(a)
        );
        t.meta.set(a, {
          clock: o.clock + 1,
          lastUpdated: ls()
        });
      }
      r.push(a);
    }
  }
  r.length > 0 && (t.emit("change", [{ added: [], updated: [], removed: r }, n]), t.emit("update", [{ added: [], updated: [], removed: r }, n]));
}, A3 = (t, e, n = t.states) => {
  const r = e.length, i = xr();
  bt(i, r);
  for (let a = 0; a < r; a++) {
    const o = e[a], s = n.get(o) || null, l = (
      /** @type {MetaClientState} */
      t.meta.get(o).clock
    );
    bt(i, o), bt(i, l), Jo(i, JSON.stringify(s));
  }
  return Rn(i);
}, fDt = (t, e, n) => {
  const r = ys(e), i = ls(), a = [], o = [], s = [], l = [], c = Ot(r);
  for (let u = 0; u < c; u++) {
    const d = Ot(r);
    let f = Ot(r);
    const h = JSON.parse(el(r)), p = t.meta.get(d), m = t.states.get(d), g = p === void 0 ? 0 : p.clock;
    (g < f || g === f && h === null && t.states.has(d)) && (h === null ? d === t.clientID && t.getLocalState() != null ? f++ : t.states.delete(d) : t.states.set(d, h), t.meta.set(d, {
      clock: f,
      lastUpdated: i
    }), p === void 0 && h !== null ? a.push(d) : p !== void 0 && h === null ? l.push(d) : h !== null && (hh(h, m) || s.push(d), o.push(d)));
  }
  (a.length > 0 || s.length > 0 || l.length > 0) && t.emit("change", [{
    added: a,
    updated: s,
    removed: l
  }, n]), (a.length > 0 || o.length > 0 || l.length > 0) && t.emit("update", [{
    added: a,
    updated: o,
    removed: l
  }, n]);
}, hDt = (t, e) => {
  const n = Uw(t).buffer, r = Uw(e).buffer;
  return crypto.subtle.importKey(
    "raw",
    n,
    "PBKDF2",
    !1,
    ["deriveKey"]
  ).then(
    (i) => crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt: r,
        iterations: 1e5,
        hash: "SHA-256"
      },
      i,
      {
        name: "AES-GCM",
        length: 256
      },
      !0,
      ["encrypt", "decrypt"]
    )
  );
}, Nee = (t, e) => {
  if (!e)
    return (
      /** @type {PromiseLike<Uint8Array>} */
      IS(t)
    );
  const n = crypto.getRandomValues(new Uint8Array(12));
  return crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: n
    },
    e,
    t
  ).then((r) => {
    const i = xr();
    return Jo(i, "AES-GCM"), Gn(i, n), Gn(i, new Uint8Array(r)), Rn(i);
  });
}, pDt = (t, e) => {
  const n = xr();
  return cd(n, t), Nee(Rn(n), e);
}, Dee = (t, e) => {
  if (!e)
    return (
      /** @type {PromiseLike<Uint8Array>} */
      IS(t)
    );
  const n = ys(t);
  el(n) !== "AES-GCM" && Tjt(fo("Unknown encryption algorithm"));
  const i = wr(n), a = wr(n);
  return crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: i
    },
    e,
    a
  ).then((o) => new Uint8Array(o));
}, mDt = (t, e) => Dee(t, e).then(
  (n) => ud(ys(new Uint8Array(n)))
), $i = Ljt("y-webrtc"), L1 = 0, Iee = 3, q2 = 1, $S = 4, S3 = /* @__PURE__ */ new Map(), qu = /* @__PURE__ */ new Map(), Pee = (t) => {
  let e = !0;
  t.webrtcConns.forEach((n) => {
    n.synced || (e = !1);
  }), (!e && t.synced || e && !t.synced) && (t.synced = e, t.provider.emit("synced", [{ synced: e }]), $i("synced ", Sa, t.name, f0, " with all peers"));
}, zee = (t, e, n) => {
  const r = ys(e), i = xr(), a = Ot(r);
  if (t === void 0)
    return null;
  const o = t.awareness, s = t.doc;
  let l = !1;
  switch (a) {
    case L1: {
      bt(i, L1);
      const c = uDt(r, i, s, t);
      c === KS && !t.synced && n(), c === YS && (l = !0);
      break;
    }
    case Iee:
      bt(i, q2), Gn(i, A3(o, Array.from(o.getStates().keys()))), l = !0;
      break;
    case q2:
      fDt(o, wr(r), t);
      break;
    case $S: {
      const c = d0(r) === 1, u = el(r);
      if (u !== t.peerId && (t.bcConns.has(u) && !c || !t.bcConns.has(u) && c)) {
        const d = [], f = [];
        c ? (t.bcConns.add(u), f.push(u)) : (t.bcConns.delete(u), d.push(u)), t.provider.emit("peers", [{
          added: f,
          removed: d,
          webrtcPeers: Array.from(t.webrtcConns.keys()),
          bcPeers: Array.from(t.bcConns)
        }]), Ree(t);
      }
      break;
    }
    default:
      return console.error("Unable to compute message"), i;
  }
  return l ? i : null;
}, yDt = (t, e) => {
  const n = t.room;
  return $i("received message from ", Sa, t.remotePeerId, DS, " (", n.name, ")", f0, y5), zee(n, e, () => {
    t.synced = !0, $i("synced ", Sa, n.name, f0, " with ", Sa, t.remotePeerId), Pee(n);
  });
}, tb = (t, e) => {
  $i("send message to ", Sa, t.remotePeerId, f0, DS, " (", t.room.name, ")", y5);
  try {
    t.peer.send(Rn(e));
  } catch {
  }
}, gDt = (t, e) => {
  $i("broadcast message in ", Sa, t.name, f0), t.webrtcConns.forEach((n) => {
    try {
      n.peer.send(e);
    } catch {
    }
  });
};
class Oz {
  /**
   * @param {SignalingConn} signalingConn
   * @param {boolean} initiator
   * @param {string} remotePeerId
   * @param {Room} room
   */
  constructor(e, n, r, i) {
    $i("establishing connection to ", Sa, r), this.room = i, this.remotePeerId = r, this.glareToken = void 0, this.closed = !1, this.connected = !1, this.synced = !1, this.peer = new oDt({ initiator: n, ...i.provider.peerOpts }), this.peer.on("signal", (a) => {
      this.glareToken === void 0 && (this.glareToken = Date.now() + Math.random()), JS(e, i, { to: r, from: i.peerId, type: "signal", token: this.glareToken, signal: a });
    }), this.peer.on("connect", () => {
      $i("connected to ", Sa, r), this.connected = !0;
      const o = i.provider.doc, s = i.awareness, l = xr();
      bt(l, L1), Tee(l, o), tb(this, l);
      const c = s.getStates();
      if (c.size > 0) {
        const u = xr();
        bt(u, q2), Gn(u, A3(s, Array.from(c.keys()))), tb(this, u);
      }
    }), this.peer.on("close", () => {
      this.connected = !1, this.closed = !0, i.webrtcConns.has(this.remotePeerId) && (i.webrtcConns.delete(this.remotePeerId), i.provider.emit("peers", [{
        removed: [this.remotePeerId],
        added: [],
        webrtcPeers: Array.from(i.webrtcConns.keys()),
        bcPeers: Array.from(i.bcConns)
      }])), Pee(i), this.peer.destroy(), $i("closed connection to ", Sa, r), ek(i);
    }), this.peer.on("error", (a) => {
      $i("Error in connection to ", Sa, r, ": ", a), ek(i);
    }), this.peer.on("data", (a) => {
      const o = yDt(this, a);
      o !== null && tb(this, o);
    });
  }
  destroy() {
    this.peer.destroy();
  }
}
const Yl = (t, e) => Nee(e, t.key).then(
  (n) => t.mux(
    () => Fjt(t.name, n)
  )
), Bz = (t, e) => {
  t.bcconnected && Yl(t, e), gDt(t, e);
}, ek = (t) => {
  S3.forEach((e) => {
    e.connected && (e.send({ type: "subscribe", topics: [t.name] }), t.webrtcConns.size < t.provider.maxConns && JS(e, t, { type: "announce", from: t.peerId }));
  });
}, Ree = (t) => {
  if (t.provider.filterBcConns) {
    const e = xr();
    bt(e, $S), I2(e, 1), Jo(e, t.peerId), Yl(t, Rn(e));
  }
};
class vDt {
  /**
   * @param {Y.Doc} doc
   * @param {WebrtcProvider} provider
   * @param {string} name
   * @param {CryptoKey|null} key
   */
  constructor(e, n, r, i) {
    this.peerId = bX(), this.doc = e, this.awareness = n.awareness, this.provider = n, this.synced = !1, this.name = r, this.key = i, this.webrtcConns = /* @__PURE__ */ new Map(), this.bcConns = /* @__PURE__ */ new Set(), this.mux = FX(), this.bcconnected = !1, this._bcSubscriber = (a) => Dee(new Uint8Array(a), i).then(
      (o) => this.mux(() => {
        const s = zee(this, o, () => {
        });
        s && Yl(this, Rn(s));
      })
    ), this._docUpdateHandler = (a, o) => {
      const s = xr();
      bt(s, L1), lDt(s, a), Bz(this, Rn(s));
    }, this._awarenessUpdateHandler = ({ added: a, updated: o, removed: s }, l) => {
      const c = a.concat(o).concat(s), u = xr();
      bt(u, q2), Gn(u, A3(this.awareness, c)), Bz(this, Rn(u));
    }, this._beforeUnloadHandler = () => {
      Xw(this.awareness, [e.clientID], "window unload"), qu.forEach((a) => {
        a.disconnect();
      });
    }, typeof window < "u" ? window.addEventListener("beforeunload", this._beforeUnloadHandler) : typeof process < "u" && process.on("exit", this._beforeUnloadHandler);
  }
  connect() {
    this.doc.on("update", this._docUpdateHandler), this.awareness.on("update", this._awarenessUpdateHandler), ek(this);
    const e = this.name;
    Bjt(e, this._bcSubscriber), this.bcconnected = !0, Ree(this);
    const n = xr();
    bt(n, L1), Tee(n, this.doc), Yl(this, Rn(n));
    const r = xr();
    bt(r, L1), Eee(r, this.doc), Yl(this, Rn(r));
    const i = xr();
    bt(i, Iee), Yl(this, Rn(i));
    const a = xr();
    bt(a, q2), Gn(a, A3(this.awareness, [this.doc.clientID])), Yl(this, Rn(a));
  }
  disconnect() {
    S3.forEach((n) => {
      n.connected && n.send({ type: "unsubscribe", topics: [this.name] });
    }), Xw(this.awareness, [this.doc.clientID], "disconnect");
    const e = xr();
    bt(e, $S), I2(e, 0), Jo(e, this.peerId), Yl(this, Rn(e)), Hjt(this.name, this._bcSubscriber), this.bcconnected = !1, this.doc.off("update", this._docUpdateHandler), this.awareness.off("update", this._awarenessUpdateHandler), this.webrtcConns.forEach((n) => n.destroy());
  }
  destroy() {
    this.disconnect(), typeof window < "u" ? window.removeEventListener("beforeunload", this._beforeUnloadHandler) : typeof process < "u" && process.off("exit", this._beforeUnloadHandler);
  }
}
const bDt = (t, e, n, r) => {
  if (qu.has(n))
    throw fo(`A Yjs Doc connected to room "${n}" already exists!`);
  const i = new vDt(t, e, n, r);
  return qu.set(
    n,
    /** @type {Room} */
    i
  ), i;
}, JS = (t, e, n) => {
  e.key ? pDt(n, e.key).then((r) => {
    t.send({ type: "publish", topic: e.name, data: OX(r) });
  }) : t.send({ type: "publish", topic: e.name, data: n });
};
class wDt extends MEt {
  constructor(e) {
    super(e), this.providers = /* @__PURE__ */ new Set(), this.on("connect", () => {
      $i(`connected (${e})`);
      const n = Array.from(qu.keys());
      this.send({ type: "subscribe", topics: n }), qu.forEach(
        (r) => JS(this, r, { type: "announce", from: r.peerId })
      );
    }), this.on("message", (n) => {
      switch (n.type) {
        case "publish": {
          const r = n.topic, i = qu.get(r);
          if (i == null || typeof r != "string")
            return;
          const a = (o) => {
            const s = i.webrtcConns, l = i.peerId;
            if (o == null || o.from === l || o.to !== void 0 && o.to !== l || i.bcConns.has(o.from))
              return;
            const c = s.has(o.from) ? () => {
            } : () => i.provider.emit("peers", [{
              removed: [],
              added: [o.from],
              webrtcPeers: Array.from(i.webrtcConns.keys()),
              bcPeers: Array.from(i.bcConns)
            }]);
            switch (o.type) {
              case "announce":
                s.size < i.provider.maxConns && (Pi(s, o.from, () => new Oz(this, !0, o.from, i)), c());
                break;
              case "signal":
                if (o.signal.type === "offer") {
                  const u = s.get(o.from);
                  if (u) {
                    const d = o.token, f = u.glareToken;
                    if (f && f > d) {
                      $i("offer rejected: ", o.from);
                      return;
                    }
                    u.glareToken = void 0;
                  }
                }
                if (o.signal.type === "answer") {
                  $i("offer answered by: ", o.from);
                  const u = s.get(o.from);
                  u.glareToken = void 0;
                }
                o.to === l && (Pi(s, o.from, () => new Oz(this, !1, o.from, i)).peer.signal(o.signal), c());
                break;
            }
          };
          i.key ? typeof n.data == "string" && mDt(BX(n.data), i.key).then(a) : a(n.data);
        }
      }
    }), this.on("disconnect", () => $i(`disconnect (${e})`));
  }
}
const nb = (t) => {
  t.emit("status", [{
    connected: t.connected
  }]);
};
class kDt extends kS {
  /**
   * @param {string} roomName
   * @param {Y.Doc} doc
   * @param {ProviderOptions?} opts
   */
  constructor(e, n, {
    signaling: r = ["wss://y-webrtc-eu.fly.dev"],
    password: i = null,
    awareness: a = new dDt(n),
    maxConns: o = 20 + co(gX() * 15),
    // the random factor reduces the chance that n clients form a cluster
    filterBcConns: s = !0,
    peerOpts: l = {}
    // simple-peer options. See https://github.com/feross/simple-peer#peer--new-peeropts
  } = {}) {
    super(), this.roomName = e, this.doc = n, this.filterBcConns = s, this.awareness = a, this.shouldConnect = !1, this.signalingUrls = r, this.signalingConns = [], this.maxConns = o, this.peerOpts = l, this.key = i ? hDt(i, e) : (
      /** @type {PromiseLike<null>} */
      IS(null)
    ), this.room = null, this.key.then((c) => {
      this.room = bDt(n, this, e, c), this.shouldConnect ? this.room.connect() : this.room.disconnect(), nb(this);
    }), this.connect(), this.destroy = this.destroy.bind(this), n.on("destroy", this.destroy);
  }
  /**
   * Indicates whether the provider is looking for other peers.
   *
   * Other peers can be found via signaling servers or via broadcastchannel (cross browser-tab
   * communication). You never know when you are connected to all peers. You also don't know if
   * there are other peers. connected doesn't mean that you are connected to any physical peers
   * working on the same resource as you. It does not change unless you call provider.disconnect()
   *
   * `this.on('status', (event) => { console.log(event.connected) })`
   *
   * @type {boolean}
   */
  get connected() {
    return this.room !== null && this.shouldConnect;
  }
  connect() {
    this.shouldConnect = !0, this.signalingUrls.forEach((e) => {
      const n = Pi(S3, e, () => new wDt(e));
      this.signalingConns.push(n), n.providers.add(this);
    }), this.room && (this.room.connect(), nb(this));
  }
  disconnect() {
    this.shouldConnect = !1, this.signalingConns.forEach((e) => {
      e.providers.delete(this), e.providers.size === 0 && (e.destroy(), S3.delete(e.url));
    }), this.room && (this.room.disconnect(), nb(this));
  }
  destroy() {
    this.doc.off("destroy", this.destroy), this.key.then(() => {
      this.room.destroy(), qu.delete(this.roomName);
    }), super.destroy();
  }
}
const xDt = {
  attributes: {
    class: "prose-lg prose-headings:font-display prose prose-p:my-2 prose-h1:my-2 prose-h2:my-2 prose-h3:my-2 prose-ul:my-2 prose-ol:my-2 max-w-none focus:outline-none w-full",
    spellcheck: "false",
    suppressContentEditableWarning: "true"
  }
}, MDt = /[\uD800-\uDBFF]/, CDt = /[\uDC00-\uDFFF]/, ADt = (t, e) => {
  let n = 0, r = 0;
  for (; n < t.length && n < e.length && t[n] === e[n]; )
    n++;
  for (n > 0 && MDt.test(t[n - 1]) && n--; r + n < t.length && r + n < e.length && t[t.length - r - 1] === e[e.length - r - 1]; )
    r++;
  return r > 0 && CDt.test(t[t.length - r]) && r--, {
    index: n,
    remove: t.length - n - r,
    insert: e.slice(n, e.length - r)
  };
}, SDt = ADt, On = new tn("y-sync"), tl = new tn("y-undo"), s4 = new tn("yjs-cursor"), L3 = (t, e) => e === void 0 ? !t.deleted : e.sv.has(t.id.client) && /** @type {number} */
e.sv.get(t.id.client) > t.id.clock && !Zd(e.ds, t.id), LDt = [{ light: "#ecd44433", dark: "#ecd444" }], TDt = (t, e, n) => {
  if (!t.has(n)) {
    if (t.size < e.length) {
      const r = vl();
      t.forEach((i) => r.add(i)), e = e.filter((i) => !r.has(i));
    }
    t.set(n, SEt(e));
  }
  return (
    /** @type {ColorDef} */
    t.get(n)
  );
}, EDt = (t, {
  colors: e = LDt,
  colorMapping: n = /* @__PURE__ */ new Map(),
  permanentUserData: r = null,
  onFirstRender: i = () => {
  },
  mapping: a
} = {}) => {
  let o = !1;
  const s = new NDt(t, a), l = new Wt({
    props: {
      editable: (c) => {
        const u = On.getState(c);
        return u.snapshot == null && u.prevSnapshot == null;
      }
    },
    key: On,
    state: {
      /**
       * @returns {any}
       */
      init: (c, u) => ({
        type: t,
        doc: t.doc,
        binding: s,
        snapshot: null,
        prevSnapshot: null,
        isChangeOrigin: !1,
        isUndoRedoOperation: !1,
        addToHistory: !0,
        colors: e,
        colorMapping: n,
        permanentUserData: r
      }),
      apply: (c, u) => {
        const d = c.getMeta(On);
        if (d !== void 0) {
          u = Object.assign({}, u);
          for (const f in d)
            u[f] = d[f];
        }
        return u.addToHistory = c.getMeta("addToHistory") !== !1, u.isChangeOrigin = d !== void 0 && !!d.isChangeOrigin, u.isUndoRedoOperation = d !== void 0 && !!d.isChangeOrigin && !!d.isUndoRedoOperation, s.prosemirrorView !== null && d !== void 0 && (d.snapshot != null || d.prevSnapshot != null) && NS(0, () => {
          s.prosemirrorView != null && (d.restore == null ? s._renderSnapshot(
            d.snapshot,
            d.prevSnapshot,
            u
          ) : (s._renderSnapshot(
            d.snapshot,
            d.snapshot,
            u
          ), delete u.restore, delete u.snapshot, delete u.prevSnapshot, s.mux(() => {
            s._prosemirrorChanged(
              s.prosemirrorView.state.doc
            );
          })));
        }), u;
      }
    },
    view: (c) => (s.initView(c), a == null && s._forceRerender(), i(), {
      update: () => {
        const u = l.getState(c.state);
        if (u.snapshot == null && u.prevSnapshot == null && // If the content doesn't change initially, we don't render anything to Yjs
        // If the content was cleared by a user action, we want to catch the change and
        // represent it in Yjs
        (o || c.state.doc.content.findDiffStart(
          c.state.doc.type.createAndFill().content
        ) !== null)) {
          if (o = !0, u.addToHistory === !1 && !u.isChangeOrigin) {
            const d = tl.getState(c.state), f = d && d.undoManager;
            f && f.stopCapturing();
          }
          s.mux(() => {
            u.doc.transact((d) => {
              d.meta.set("addToHistory", u.addToHistory), s._prosemirrorChanged(c.state.doc);
            }, On);
          });
        }
      },
      destroy: () => {
        s.destroy();
      }
    })
  });
  return l;
}, jDt = (t, e, n) => {
  if (e !== null && e.anchor !== null && e.head !== null)
    if (e.type === "all")
      t.setSelection(new Li(t.doc));
    else {
      const r = W2(
        n.doc,
        n.type,
        e.anchor,
        n.mapping
      ), i = W2(
        n.doc,
        n.type,
        e.head,
        n.mapping
      );
      r !== null && i !== null && (t = t.setSelection(ot.create(t.doc, r, i)));
    }
}, tk = (t, e) => ({
  type: e.selection.jsonID,
  anchor: E3(
    e.selection.anchor,
    t.type,
    t.mapping
  ),
  head: E3(
    e.selection.head,
    t.type,
    t.mapping
  )
});
class NDt {
  /**
   * @param {Y.XmlFragment} yXmlFragment The bind source
   * @param {ProsemirrorMapping} mapping
   */
  constructor(e, n = /* @__PURE__ */ new Map()) {
    this.type = e, this.prosemirrorView = null, this.mux = FX(), this.mapping = n, this._observeFunction = this._typeChanged.bind(this), this.doc = e.doc, this.beforeTransactionSelection = null, this.beforeAllTransactions = () => {
      this.beforeTransactionSelection === null && this.prosemirrorView != null && (this.beforeTransactionSelection = tk(
        this,
        this.prosemirrorView.state
      ));
    }, this.afterAllTransactions = () => {
      this.beforeTransactionSelection = null;
    }, this._domSelectionInView = null;
  }
  /**
   * Create a transaction for changing the prosemirror state.
   *
   * @returns
   */
  get _tr() {
    return this.prosemirrorView.state.tr.setMeta("addToHistory", !1);
  }
  _isLocalCursorInView() {
    return this.prosemirrorView.hasFocus() ? (jS && this._domSelectionInView === null && (NS(0, () => {
      this._domSelectionInView = null;
    }), this._domSelectionInView = this._isDomSelectionInView()), this._domSelectionInView) : !1;
  }
  _isDomSelectionInView() {
    const e = this.prosemirrorView._root.getSelection();
    if (e == null || e.anchorNode == null) return !1;
    const n = this.prosemirrorView._root.createRange();
    n.setStart(e.anchorNode, e.anchorOffset), n.setEnd(e.focusNode, e.focusOffset), n.getClientRects().length === 0 && n.startContainer && n.collapsed && n.selectNodeContents(n.startContainer);
    const i = n.getBoundingClientRect(), a = vjt.documentElement;
    return i.bottom >= 0 && i.right >= 0 && i.left <= (window.innerWidth || a.clientWidth || 0) && i.top <= (window.innerHeight || a.clientHeight || 0);
  }
  /**
   * @param {Y.Snapshot} snapshot
   * @param {Y.Snapshot} prevSnapshot
   */
  renderSnapshot(e, n) {
    n || (n = QX(VX(), /* @__PURE__ */ new Map())), this.prosemirrorView.dispatch(
      this._tr.setMeta(On, { snapshot: e, prevSnapshot: n })
    );
  }
  unrenderSnapshot() {
    this.mapping.clear(), this.mux(() => {
      const e = this.type.toArray().map(
        (r) => iy(
          /** @type {Y.XmlElement} */
          r,
          this.prosemirrorView.state.schema,
          this.mapping
        )
      ).filter((r) => r !== null), n = this._tr.replace(
        0,
        this.prosemirrorView.state.doc.content.size,
        new Je(Ne.from(e), 0, 0)
      );
      n.setMeta(On, { snapshot: null, prevSnapshot: null }), this.prosemirrorView.dispatch(n);
    });
  }
  _forceRerender() {
    this.mapping.clear(), this.mux(() => {
      const e = this.beforeTransactionSelection !== null ? null : this.prosemirrorView.state.selection, n = this.type.toArray().map(
        (i) => iy(
          /** @type {Y.XmlElement} */
          i,
          this.prosemirrorView.state.schema,
          this.mapping
        )
      ).filter((i) => i !== null), r = this._tr.replace(
        0,
        this.prosemirrorView.state.doc.content.size,
        new Je(Ne.from(n), 0, 0)
      );
      if (e) {
        const i = $o(uo(e.anchor, 0), r.doc.content.size), a = $o(uo(e.head, 0), r.doc.content.size);
        r.setSelection(ot.create(r.doc, i, a));
      }
      this.prosemirrorView.dispatch(
        r.setMeta(On, { isChangeOrigin: !0, binding: this })
      );
    });
  }
  /**
   * @param {Y.Snapshot|Uint8Array} snapshot
   * @param {Y.Snapshot|Uint8Array} prevSnapshot
   * @param {Object} pluginState
   */
  _renderSnapshot(e, n, r) {
    let i = this.doc;
    e || (e = Jv(this.doc)), (e instanceof Uint8Array || n instanceof Uint8Array) && ((!(e instanceof Uint8Array) || !(n instanceof Uint8Array)) && aa(), i = new Ll({ gc: !1 }), v3(i, n), n = Jv(i), v3(i, e), e = Jv(i)), this.mapping.clear(), this.mux(() => {
      i.transact((a) => {
        const o = r.permanentUserData;
        o && o.dss.forEach((u) => {
          jc(a, u, (d) => {
          });
        });
        const s = (u, d) => {
          const f = u === "added" ? o.getUserByClientId(d.client) : o.getUserByDeletedId(d);
          return {
            user: f,
            type: u,
            color: TDt(
              r.colorMapping,
              r.colors,
              f
            )
          };
        }, l = cee(
          this.type,
          new HS(n.ds, e.sv)
        ).map((u) => !u._item.deleted || L3(u._item, e) || L3(u._item, n) ? iy(
          u,
          this.prosemirrorView.state.schema,
          /* @__PURE__ */ new Map(),
          e,
          n,
          s
        ) : null).filter((u) => u !== null), c = this._tr.replace(
          0,
          this.prosemirrorView.state.doc.content.size,
          new Je(Ne.from(l), 0, 0)
        );
        this.prosemirrorView.dispatch(
          c.setMeta(On, { isChangeOrigin: !0 })
        );
      }, On);
    });
  }
  /**
   * @param {Array<Y.YEvent<any>>} events
   * @param {Y.Transaction} transaction
   */
  _typeChanged(e, n) {
    if (this.prosemirrorView == null) return;
    const r = On.getState(this.prosemirrorView.state);
    if (e.length === 0 || r.snapshot != null || r.prevSnapshot != null) {
      this.renderSnapshot(r.snapshot, r.prevSnapshot);
      return;
    }
    this.mux(() => {
      const i = (s, l) => this.mapping.delete(l);
      jc(
        n,
        n.deleteSet,
        (s) => {
          if (s.constructor === wn) {
            const l = (
              /** @type {Y.ContentType} */
              /** @type {Y.Item} */
              s.content.type
            );
            l && this.mapping.delete(l);
          }
        }
      ), n.changed.forEach(i), n.changedParentTypes.forEach(i);
      const a = this.type.toArray().map(
        (s) => Oee(
          /** @type {Y.XmlElement | Y.XmlHook} */
          s,
          this.prosemirrorView.state.schema,
          this.mapping
        )
      ).filter((s) => s !== null);
      let o = this._tr.replace(
        0,
        this.prosemirrorView.state.doc.content.size,
        new Je(Ne.from(a), 0, 0)
      );
      jDt(o, this.beforeTransactionSelection, this), o = o.setMeta(On, { isChangeOrigin: !0, isUndoRedoOperation: n.origin instanceof ree }), this.beforeTransactionSelection !== null && this._isLocalCursorInView() && o.scrollIntoView(), this.prosemirrorView.dispatch(o);
    });
  }
  _prosemirrorChanged(e) {
    this.doc.transact(() => {
      rk(this.doc, this.type, e, this.mapping), this.beforeTransactionSelection = tk(
        this,
        this.prosemirrorView.state
      );
    }, On);
  }
  /**
   * View is ready to listen to changes. Register observers.
   * @param {any} prosemirrorView
   */
  initView(e) {
    this.prosemirrorView != null && this.destroy(), this.prosemirrorView = e, this.doc.on("beforeAllTransactions", this.beforeAllTransactions), this.doc.on("afterAllTransactions", this.afterAllTransactions), this.type.observeDeep(this._observeFunction);
  }
  destroy() {
    this.prosemirrorView != null && (this.prosemirrorView = null, this.type.unobserveDeep(this._observeFunction), this.doc.off("beforeAllTransactions", this.beforeAllTransactions), this.doc.off("afterAllTransactions", this.afterAllTransactions));
  }
}
const Oee = (t, e, n, r, i, a) => {
  const o = (
    /** @type {PModel.Node} */
    n.get(t)
  );
  if (o === void 0) {
    if (t instanceof si)
      return iy(
        t,
        e,
        n,
        r,
        i,
        a
      );
    throw ro();
  }
  return o;
}, iy = (t, e, n, r, i, a) => {
  const o = [], s = (l) => {
    var c;
    if (l.constructor === si) {
      const u = Oee(
        l,
        e,
        n,
        r,
        i,
        a
      );
      u !== null && o.push(u);
    } else {
      const u = (c = l._item.right) == null ? void 0 : c.content.type;
      u instanceof Nc && !u._item.deleted && u._item.id.client === u.doc.clientID && (l.applyDelta([
        { retain: l.length },
        ...u.toDelta()
      ]), u.doc.transact((f) => {
        u._item.delete(f);
      }));
      const d = DDt(
        l,
        e,
        n,
        r,
        i,
        a
      );
      d !== null && d.forEach((f) => {
        f !== null && o.push(f);
      });
    }
  };
  r === void 0 || i === void 0 ? t.toArray().forEach(s) : cee(t, new HS(i.ds, r.sv)).forEach(s);
  try {
    const l = t.getAttributes(r);
    r !== void 0 && (L3(
      /** @type {Y.Item} */
      t._item,
      r
    ) ? L3(
      /** @type {Y.Item} */
      t._item,
      i
    ) || (l.ychange = a ? a(
      "added",
      /** @type {Y.Item} */
      t._item.id
    ) : { type: "added" }) : l.ychange = a ? a(
      "removed",
      /** @type {Y.Item} */
      t._item.id
    ) : { type: "removed" });
    const c = e.node(t.nodeName, l, o);
    return n.set(t, c), c;
  } catch {
    return t.doc.transact((c) => {
      t._item.delete(c);
    }, On), n.delete(t), null;
  }
}, DDt = (t, e, n, r, i, a) => {
  const o = [], s = t.toDelta(r, i, a);
  try {
    for (let l = 0; l < s.length; l++) {
      const c = s[l], u = [];
      for (const d in c.attributes)
        u.push(e.mark(d, c.attributes[d]));
      o.push(e.text(c.insert, u));
    }
  } catch {
    return t.doc.transact((c) => {
      t._item.delete(c);
    }, On), null;
  }
  return o;
}, IDt = (t, e) => {
  const n = new ea(), r = t.map((i) => ({
    // @ts-ignore
    insert: i.text,
    attributes: Hee(i.marks)
  }));
  return n.applyDelta(r), e.set(n, t), n;
}, PDt = (t, e) => {
  const n = new si(t.type.name);
  for (const r in t.attrs) {
    const i = t.attrs[r];
    i !== null && r !== "ychange" && n.setAttribute(r, i);
  }
  return n.insert(
    0,
    w5(t).map(
      (r) => nk(r, e)
    )
  ), e.set(n, t), n;
}, nk = (t, e) => t instanceof Array ? IDt(t, e) : PDt(t, e), Hz = (t) => typeof t == "object" && t !== null, QS = (t, e) => {
  const n = Object.keys(t).filter((i) => t[i] !== null);
  let r = n.length === Object.keys(e).filter((i) => e[i] !== null).length;
  for (let i = 0; i < n.length && r; i++) {
    const a = n[i], o = t[a], s = e[a];
    r = a === "ychange" || o === s || Hz(o) && Hz(s) && QS(o, s);
  }
  return r;
}, w5 = (t) => {
  const e = t.content.content, n = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    if (i.isText) {
      const a = [];
      for (let o = e[r]; r < e.length && o.isText; o = e[++r])
        a.push(o);
      r--, n.push(a);
    } else
      n.push(i);
  }
  return n;
}, Bee = (t, e) => {
  const n = t.toDelta();
  return n.length === e.length && n.every(
    (r, i) => r.insert === /** @type {any} */
    e[i].text && TS(r.attributes || {}).length === e[i].marks.length && e[i].marks.every(
      (a) => QS(r.attributes[a.type.name] || {}, a.attrs)
    )
  );
}, U2 = (t, e) => {
  if (t instanceof si && !(e instanceof Array) && ik(t, e)) {
    const n = w5(e);
    return t._length === n.length && QS(t.getAttributes(), e.attrs) && t.toArray().every(
      (r, i) => U2(r, n[i])
    );
  }
  return t instanceof ea && e instanceof Array && Bee(t, e);
}, T3 = (t, e) => t === e || t instanceof Array && e instanceof Array && t.length === e.length && t.every(
  (n, r) => e[r] === n
), Fz = (t, e, n) => {
  const r = t.toArray(), i = w5(e), a = i.length, o = r.length, s = $o(o, a);
  let l = 0, c = 0, u = !1;
  for (; l < s; l++) {
    const d = r[l], f = i[l];
    if (T3(n.get(d), f))
      u = !0;
    else if (!U2(d, f))
      break;
  }
  for (; l + c < s; c++) {
    const d = r[o - c - 1], f = i[a - c - 1];
    if (T3(n.get(d), f))
      u = !0;
    else if (!U2(d, f))
      break;
  }
  return {
    equalityFactor: l + c,
    foundMappedChild: u
  };
}, zDt = (t) => {
  let e = "", n = t._start;
  const r = {};
  for (; n !== null; )
    n.deleted || (n.countable && n.content instanceof ho ? e += n.content.str : n.content instanceof lr && (r[n.content.key] = null)), n = n.right;
  return {
    str: e,
    nAttrs: r
  };
}, RDt = (t, e, n) => {
  n.set(t, e);
  const { nAttrs: r, str: i } = zDt(t), a = e.map((c) => ({
    insert: (
      /** @type {any} */
      c.text
    ),
    attributes: Object.assign({}, r, Hee(c.marks))
  })), { insert: o, remove: s, index: l } = SDt(
    i,
    a.map((c) => c.insert).join("")
  );
  t.delete(l, s), t.insert(l, o), t.applyDelta(
    a.map((c) => ({ retain: c.insert.length, attributes: c.attributes }))
  );
}, Hee = (t) => {
  const e = {};
  return t.forEach((n) => {
    n.type.name !== "ychange" && (e[n.type.name] = n.attrs);
  }), e;
}, rk = (t, e, n, r) => {
  if (e instanceof si && e.nodeName !== n.type.name)
    throw new Error("node name mismatch!");
  if (r.set(e, n), e instanceof si) {
    const d = e.getAttributes(), f = n.attrs;
    for (const h in f)
      f[h] !== null ? d[h] !== f[h] && h !== "ychange" && e.setAttribute(h, f[h]) : e.removeAttribute(h);
    for (const h in d)
      f[h] === void 0 && e.removeAttribute(h);
  }
  const i = w5(n), a = i.length, o = e.toArray(), s = o.length, l = $o(a, s);
  let c = 0, u = 0;
  for (; c < l; c++) {
    const d = o[c], f = i[c];
    if (!T3(r.get(d), f))
      if (U2(d, f))
        r.set(d, f);
      else
        break;
  }
  for (; u + c + 1 < l; u++) {
    const d = o[s - u - 1], f = i[a - u - 1];
    if (!T3(r.get(d), f))
      if (U2(d, f))
        r.set(d, f);
      else
        break;
  }
  t.transact(() => {
    for (; s - c - u > 0 && a - c - u > 0; ) {
      const f = o[c], h = i[c], p = o[s - u - 1], m = i[a - u - 1];
      if (f instanceof ea && h instanceof Array)
        Bee(f, h) || RDt(f, h, r), c += 1;
      else {
        let g = f instanceof si && ik(f, h), v = p instanceof si && ik(p, m);
        if (g && v) {
          const k = Fz(
            /** @type {Y.XmlElement} */
            f,
            /** @type {PModel.Node} */
            h,
            r
          ), w = Fz(
            /** @type {Y.XmlElement} */
            p,
            /** @type {PModel.Node} */
            m,
            r
          );
          k.foundMappedChild && !w.foundMappedChild ? v = !1 : !k.foundMappedChild && w.foundMappedChild || k.equalityFactor < w.equalityFactor ? g = !1 : v = !1;
        }
        g ? (rk(
          t,
          /** @type {Y.XmlFragment} */
          f,
          /** @type {PModel.Node} */
          h,
          r
        ), c += 1) : v ? (rk(
          t,
          /** @type {Y.XmlFragment} */
          p,
          /** @type {PModel.Node} */
          m,
          r
        ), u += 1) : (r.delete(e.get(c)), e.delete(c, 1), e.insert(c, [
          nk(h, r)
        ]), c += 1);
      }
    }
    const d = s - c - u;
    if (s === 1 && a === 0 && o[0] instanceof ea ? (r.delete(o[0]), o[0].delete(0, o[0].length)) : d > 0 && (e.slice(c, c + d).forEach((f) => r.delete(f)), e.delete(c, d)), c + u < a) {
      const f = [];
      for (let h = c; h < a - u; h++)
        f.push(nk(i[h], r));
      e.insert(c, f);
    }
  }, On);
}, ik = (t, e) => !(e instanceof Array) && t.nodeName === e.type.name;
let mh = null;
const ODt = () => {
  const t = (
    /** @type {Map<EditorView, Map<any, any>>} */
    mh
  );
  mh = null, t.forEach((e, n) => {
    const r = n.state.tr, i = On.getState(n.state);
    i && i.binding && !i.binding.isDestroyed && (e.forEach((a, o) => {
      r.setMeta(o, a);
    }), n.dispatch(r));
  });
}, BDt = (t, e, n) => {
  mh || (mh = /* @__PURE__ */ new Map(), NS(0, ODt)), Pi(mh, t, ui).set(e, n);
}, E3 = (t, e, n) => {
  if (t === 0)
    return $v(e, 0, -1);
  let r = e._first === null ? null : (
    /** @type {Y.ContentType} */
    e._first.content.type
  );
  for (; r !== null && e !== r; ) {
    if (r instanceof ea) {
      if (r._length >= t)
        return $v(r, t, -1);
      if (t -= r._length, r._item !== null && r._item.next !== null)
        r = /** @type {Y.ContentType} */
        r._item.next.content.type;
      else {
        do
          r = r._item === null ? null : r._item.parent, t--;
        while (r !== e && r !== null && r._item !== null && r._item.next === null);
        r !== null && r !== e && (r = r._item === null ? null : (
          /** @type {Y.ContentType} */
          /** @type Y.Item */
          r._item.next.content.type
        ));
      }
    } else {
      const i = (
        /** @type {any} */
        (n.get(r) || { nodeSize: 0 }).nodeSize
      );
      if (r._first !== null && t < i)
        r = /** @type {Y.ContentType} */
        r._first.content.type, t--;
      else {
        if (t === 1 && r._length === 0 && i > 1)
          return new B2(r._item === null ? null : r._item.id, r._item === null ? R2(r) : null, null);
        if (t -= i, r._item !== null && r._item.next !== null)
          r = /** @type {Y.ContentType} */
          r._item.next.content.type;
        else {
          if (t === 0)
            return r = r._item === null ? r : r._item.parent, new B2(r._item === null ? null : r._item.id, r._item === null ? R2(r) : null, null);
          do
            r = /** @type {Y.Item} */
            r._item.parent, t--;
          while (r !== e && /** @type {Y.Item} */
          r._item.next === null);
          r !== e && (r = /** @type {Y.ContentType} */
          /** @type {Y.Item} */
          /** @type {Y.Item} */
          r._item.next.content.type);
        }
      }
    }
    if (r === null)
      throw aa();
    if (t === 0 && r.constructor !== ea && r !== e)
      return HDt(r._item.parent, r._item);
  }
  return $v(e, e._length, -1);
}, HDt = (t, e) => {
  let n = null, r = null;
  return t._item === null ? r = R2(t) : n = Bt(t._item.id.client, t._item.id.clock), new B2(n, r, e.id);
}, W2 = (t, e, n, r) => {
  const i = aNt(n, t);
  if (i === null || i.type !== e && !O2(e, i.type._item))
    return null;
  let a = i.type, o = 0;
  if (a.constructor === ea)
    o = i.index;
  else if (a._item === null || !a._item.deleted) {
    let s = a._first, l = 0;
    for (; l < a._length && l < i.index && s !== null; ) {
      if (!s.deleted) {
        const c = (
          /** @type {Y.ContentType} */
          s.content.type
        );
        l++, c instanceof ea ? o += c._length : o += /** @type {any} */
        r.get(c).nodeSize;
      }
      s = /** @type {Y.Item} */
      s.right;
    }
    o += 1;
  }
  for (; a !== e && a._item !== null; ) {
    const s = a._item.parent;
    if (s._item === null || !s._item.deleted) {
      o += 1;
      let l = (
        /** @type {Y.AbstractType} */
        s._first
      );
      for (; l !== null; ) {
        const c = (
          /** @type {Y.ContentType} */
          l.content.type
        );
        if (c === a)
          break;
        l.deleted || (c instanceof ea ? o += c._length : o += /** @type {any} */
        r.get(c).nodeSize), l = l.right;
      }
    }
    a = /** @type {Y.AbstractType} */
    s;
  }
  return o - 1;
};
function FDt(t) {
  const e = t.toArray();
  function n(r) {
    let i;
    if (!r.nodeName)
      i = r.toDelta().map((o) => {
        const s = {
          type: "text",
          text: o.insert
        };
        return o.attributes && (s.marks = Object.keys(o.attributes).map((l) => {
          const c = o.attributes[l], u = {
            type: l
          };
          return Object.keys(c) && (u.attrs = c), u;
        })), s;
      });
    else {
      i = {
        type: r.nodeName
      };
      const a = r.getAttributes();
      Object.keys(a).length && (i.attrs = a);
      const o = r.toArray();
      o.length && (i.content = o.map(n).flat());
    }
    return i;
  }
  return {
    type: "doc",
    content: e.map(n)
  };
}
const _Dt = (t, e, n) => t !== e, VDt = (t) => {
  const e = document.createElement("span");
  e.classList.add("ProseMirror-yjs-cursor"), e.setAttribute("style", `border-color: ${t.color}`);
  const n = document.createElement("div");
  n.setAttribute("style", `background-color: ${t.color}`), n.insertBefore(document.createTextNode(t.name), null);
  const r = document.createTextNode("⁠"), i = document.createTextNode("⁠");
  return e.insertBefore(r, null), e.insertBefore(n, null), e.insertBefore(i, null), e;
}, Fee = (t) => ({
  style: `background-color: ${t.color}70`,
  class: "ProseMirror-yjs-selection"
}), qDt = /^#[0-9a-fA-F]{6}$/, _z = (t, e, n, r, i) => {
  const a = On.getState(t), o = a.doc, s = [];
  return a.snapshot != null || a.prevSnapshot != null || a.binding.mapping.size === 0 ? vn.create(t.doc, []) : (e.getStates().forEach((l, c) => {
    if (n(o.clientID, c, l) && l.cursor != null) {
      const u = l.user || {};
      u.color == null ? u.color = "#ffa500" : qDt.test(u.color) || console.warn("A user uses an unsupported color format", u), u.name == null && (u.name = `User: ${c}`);
      let d = W2(
        o,
        a.type,
        ph(l.cursor.anchor),
        a.binding.mapping
      ), f = W2(
        o,
        a.type,
        ph(l.cursor.head),
        a.binding.mapping
      );
      if (d !== null && f !== null) {
        const h = uo(t.doc.content.size - 1, 0);
        d = $o(d, h), f = $o(f, h), s.push(
          hr.widget(f, () => r(u, c), {
            key: c + "",
            side: 10
          })
        );
        const p = $o(d, f), m = uo(d, f);
        s.push(
          hr.inline(p, m, i(u, c), {
            inclusiveEnd: !0,
            inclusiveStart: !1
          })
        );
      }
    }
  }), vn.create(t.doc, s));
}, UDt = (t, {
  awarenessStateFilter: e = _Dt,
  cursorBuilder: n = VDt,
  selectionBuilder: r = Fee,
  getSelection: i = (o) => o.selection
} = {}, a = "cursor") => new Wt({
  key: s4,
  state: {
    init(o, s) {
      return _z(
        s,
        t,
        e,
        n,
        r
      );
    },
    apply(o, s, l, c) {
      const u = On.getState(c), d = o.getMeta(s4);
      return u && u.isChangeOrigin || d && d.awarenessUpdated ? _z(
        c,
        t,
        e,
        n,
        r
      ) : s.map(o.mapping, o.doc);
    }
  },
  props: {
    decorations: (o) => s4.getState(o)
  },
  view: (o) => {
    const s = () => {
      o.docView && BDt(o, s4, { awarenessUpdated: !0 });
    }, l = () => {
      const c = On.getState(o.state), u = t.getLocalState() || {};
      if (o.hasFocus()) {
        const d = i(o.state), f = E3(
          d.anchor,
          c.type,
          c.binding.mapping
        ), h = E3(
          d.head,
          c.type,
          c.binding.mapping
        );
        (u.cursor == null || !Sz(
          ph(u.cursor.anchor),
          f
        ) || !Sz(
          ph(u.cursor.head),
          h
        )) && t.setLocalStateField(a, {
          anchor: f,
          head: h
        });
      } else u.cursor != null && W2(
        c.doc,
        c.type,
        ph(u.cursor.anchor),
        c.binding.mapping
      ) !== null && t.setLocalStateField(a, null);
    };
    return t.on("change", s), o.dom.addEventListener("focusin", l), o.dom.addEventListener("focusout", l), {
      update: l,
      destroy: () => {
        o.dom.removeEventListener("focusin", l), o.dom.removeEventListener("focusout", l), t.off("change", s), t.setLocalStateField(a, null);
      }
    };
  }
}), WDt = (t) => {
  const e = tl.getState(t).undoManager;
  if (e != null)
    return e.undo(), !0;
}, ZDt = (t) => {
  const e = tl.getState(t).undoManager;
  if (e != null)
    return e.redo(), !0;
}, GDt = /* @__PURE__ */ new Set(["paragraph"]), YDt = (t, e) => !(t instanceof wn) || !(t.content instanceof ko) || !(t.content.type instanceof Nc || t.content.type instanceof si && e.has(t.content.type.nodeName)) || t.content.type._length === 0, KDt = ({ protectedNodes: t = GDt, trackedOrigins: e = [], undoManager: n = null } = {}) => new Wt({
  key: tl,
  state: {
    init: (r, i) => {
      const a = On.getState(i), o = n || new ree(a.type, {
        trackedOrigins: new Set([On].concat(e)),
        deleteFilter: (s) => YDt(s, t),
        captureTransaction: (s) => s.meta.get("addToHistory") !== !1
      });
      return {
        undoManager: o,
        prevSel: null,
        hasUndoOps: o.undoStack.length > 0,
        hasRedoOps: o.redoStack.length > 0
      };
    },
    /**
     * @returns {any}
     */
    apply: (r, i, a, o) => {
      const s = On.getState(o).binding, l = i.undoManager, c = l.undoStack.length > 0, u = l.redoStack.length > 0;
      return s ? {
        undoManager: l,
        prevSel: tk(s, a),
        hasUndoOps: c,
        hasRedoOps: u
      } : c !== i.hasUndoOps || u !== i.hasRedoOps ? Object.assign({}, i, {
        hasUndoOps: l.undoStack.length > 0,
        hasRedoOps: l.redoStack.length > 0
      }) : i;
    }
  },
  view: (r) => {
    const i = On.getState(r.state), a = tl.getState(r.state).undoManager;
    return a.on("stack-item-added", ({ stackItem: o }) => {
      const s = i.binding;
      s && o.meta.set(s, tl.getState(r.state).prevSel);
    }), a.on("stack-item-popped", ({ stackItem: o }) => {
      const s = i.binding;
      s && (s.beforeTransactionSelection = o.meta.get(s) || s.beforeTransactionSelection);
    }), {
      destroy: () => {
        a.destroy();
      }
    };
  }
}), _ee = ln.create({
  name: "collaboration",
  priority: 1e3,
  addOptions() {
    return {
      document: null,
      field: "default",
      fragment: null
    };
  },
  addStorage() {
    return {
      isDisabled: !1
    };
  },
  onCreate() {
    this.editor.extensionManager.extensions.find((t) => t.name === "history") && console.warn('[tiptap warn]: "@tiptap/extension-collaboration" comes with its own history support and is not compatible with "@tiptap/extension-history".');
  },
  addCommands() {
    return {
      undo: () => ({ tr: t, state: e, dispatch: n }) => (t.setMeta("preventDispatch", !0), tl.getState(e).undoManager.undoStack.length === 0 ? !1 : n ? WDt(e) : !0),
      redo: () => ({ tr: t, state: e, dispatch: n }) => (t.setMeta("preventDispatch", !0), tl.getState(e).undoManager.redoStack.length === 0 ? !1 : n ? ZDt(e) : !0)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Mod-y": () => this.editor.commands.redo(),
      "Shift-Mod-z": () => this.editor.commands.redo()
    };
  },
  addProseMirrorPlugins() {
    var t;
    const e = this.options.fragment ? this.options.fragment : this.options.document.getXmlFragment(this.options.field), n = KDt(this.options.yUndoOptions), r = n.spec.view;
    n.spec.view = (o) => {
      const { undoManager: s } = tl.getState(o.state);
      s.restore && (s.restore(), s.restore = () => {
      });
      const l = r ? r(o) : void 0;
      return {
        destroy: () => {
          const c = s.trackedOrigins.has(s), u = s._observers;
          s.restore = () => {
            c && s.trackedOrigins.add(s), s.doc.on("afterTransaction", s.afterTransactionHandler), s._observers = u;
          }, l != null && l.destroy && l.destroy();
        }
      };
    };
    const i = {
      ...this.options.ySyncOptions,
      onFirstRender: this.options.onFirstRender
    }, a = EDt(e, i);
    return this.editor.options.enableContentCheck && ((t = e.doc) === null || t === void 0 || t.on("beforeTransaction", () => {
      try {
        const o = FDt(e);
        if (o.content.length === 0)
          return;
        this.editor.schema.nodeFromJSON(o).check();
      } catch (o) {
        return this.editor.emit("contentError", {
          error: o,
          editor: this.editor,
          disableCollaboration: () => {
            var s;
            (s = e.doc) === null || s === void 0 || s.destroy(), this.storage.isDisabled = !0;
          }
        }), !1;
      }
    })), [
      a,
      n,
      // Only add the filterInvalidContent plugin if content checking is enabled
      this.editor.options.enableContentCheck && new Wt({
        key: new tn("filterInvalidContent"),
        filterTransaction: () => {
          var o;
          return this.storage.isDisabled && ((o = e.doc) === null || o === void 0 || o.destroy()), !0;
        }
      })
    ].filter(Boolean);
  }
}), Vz = (t) => Array.from(t.entries()).map(([e, n]) => ({
  clientId: e,
  ...n.user
})), qz = () => null, $Dt = ln.create({
  name: "collaborationCursor",
  priority: 999,
  addOptions() {
    return {
      provider: null,
      user: {
        name: null,
        color: null
      },
      render: (t) => {
        const e = document.createElement("span");
        e.classList.add("collaboration-cursor__caret"), e.setAttribute("style", `border-color: ${t.color}`);
        const n = document.createElement("div");
        return n.classList.add("collaboration-cursor__label"), n.setAttribute("style", `background-color: ${t.color}`), n.insertBefore(document.createTextNode(t.name), null), e.insertBefore(n, null), e;
      },
      selectionRender: Fee,
      onUpdate: qz
    };
  },
  onCreate() {
    if (this.options.onUpdate !== qz && console.warn('[tiptap warn]: DEPRECATED: The "onUpdate" option is deprecated. Please use `editor.storage.collaborationCursor.users` instead. Read more: https://tiptap.dev/api/extensions/collaboration-cursor'), !this.options.provider)
      throw new Error('The "provider" option is required for the CollaborationCursor extension');
  },
  addStorage() {
    return {
      users: []
    };
  },
  addCommands() {
    return {
      updateUser: (t) => () => (this.options.user = t, this.options.provider.awareness.setLocalStateField("user", this.options.user), !0),
      user: (t) => ({ editor: e }) => (console.warn('[tiptap warn]: DEPRECATED: The "user" command is deprecated. Please use "updateUser" instead. Read more: https://tiptap.dev/api/extensions/collaboration-cursor'), e.commands.updateUser(t))
    };
  },
  addProseMirrorPlugins() {
    return [
      UDt(
        (this.options.provider.awareness.setLocalStateField("user", this.options.user), this.storage.users = Vz(this.options.provider.awareness.states), this.options.provider.awareness.on("update", () => {
          this.storage.users = Vz(this.options.provider.awareness.states);
        }), this.options.provider.awareness),
        // @ts-ignore
        {
          cursorBuilder: this.options.render,
          selectionBuilder: this.options.selectionRender
        }
      )
    ];
  }
});
function Vee(t) {
  const { state: e, transaction: n } = t;
  let { selection: r } = n, { doc: i } = n, { storedMarks: a } = n;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return a;
    },
    get selection() {
      return r;
    },
    get doc() {
      return i;
    },
    get tr() {
      return r = n.selection, i = n.doc, a = n.storedMarks, n;
    }
  };
}
class JDt {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: n, state: r } = this, { view: i } = n, { tr: a } = r, o = this.buildProps(a);
    return Object.fromEntries(Object.entries(e).map(([s, l]) => [s, (...u) => {
      const d = l(...u)(o);
      return !a.getMeta("preventDispatch") && !this.hasCustomState && i.dispatch(a), d;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, n = !0) {
    const { rawCommands: r, editor: i, state: a } = this, { view: o } = i, s = [], l = !!e, c = e || a.tr, u = () => (!l && n && !c.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(c), s.every((f) => f === !0)), d = {
      ...Object.fromEntries(Object.entries(r).map(([f, h]) => [f, (...m) => {
        const g = this.buildProps(c, n), v = h(...m)(g);
        return s.push(v), d;
      }])),
      run: u
    };
    return d;
  }
  createCan(e) {
    const { rawCommands: n, state: r } = this, i = !1, a = e || r.tr, o = this.buildProps(a, i);
    return {
      ...Object.fromEntries(Object.entries(n).map(([l, c]) => [l, (...u) => c(...u)({ ...o, dispatch: void 0 })])),
      chain: () => this.createChain(a, i)
    };
  }
  buildProps(e, n = !0) {
    const { rawCommands: r, editor: i, state: a } = this, { view: o } = i, s = {
      tr: e,
      editor: i,
      view: o,
      state: Vee({
        state: a,
        transaction: e
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(e, n),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([l, c]) => [l, (...u) => c(...u)(s)]));
      }
    };
    return s;
  }
}
function Qa(t, e, n) {
  return t.config[e] === void 0 && t.parent ? Qa(t.parent, e, n) : typeof t.config[e] == "function" ? t.config[e].bind({
    ...n,
    parent: t.parent ? Qa(t.parent, e, n) : null
  }) : t.config[e];
}
function QDt(t) {
  const e = t.filter((i) => i.type === "extension"), n = t.filter((i) => i.type === "node"), r = t.filter((i) => i.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: n,
    markExtensions: r
  };
}
function Jr(t, e) {
  if (typeof t == "string") {
    if (!e.nodes[t])
      throw Error(`There is no node type named '${t}'. Maybe you forgot to add the extension?`);
    return e.nodes[t];
  }
  return t;
}
function XDt(...t) {
  return t.filter((e) => !!e).reduce((e, n) => {
    const r = { ...e };
    return Object.entries(n).forEach(([i, a]) => {
      if (!r[i]) {
        r[i] = a;
        return;
      }
      if (i === "class") {
        const s = a ? String(a).split(" ") : [], l = r[i] ? r[i].split(" ") : [], c = s.filter((u) => !l.includes(u));
        r[i] = [...l, ...c].join(" ");
      } else if (i === "style") {
        const s = a ? a.split(";").map((u) => u.trim()).filter(Boolean) : [], l = r[i] ? r[i].split(";").map((u) => u.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [d, f] = u.split(":").map((h) => h.trim());
          c.set(d, f);
        }), s.forEach((u) => {
          const [d, f] = u.split(":").map((h) => h.trim());
          c.set(d, f);
        }), r[i] = Array.from(c.entries()).map(([u, d]) => `${u}: ${d}`).join("; ");
      } else
        r[i] = a;
    }), r;
  }, {});
}
function eIt(t) {
  return typeof t == "function";
}
function _o(t, e = void 0, ...n) {
  return eIt(t) ? e ? t.bind(e)(...n) : t(...n) : t;
}
function tIt(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}
class nIt {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
function rIt(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function l4(t) {
  return rIt(t) !== "Object" ? !1 : t.constructor === Object && Object.getPrototypeOf(t) === Object.prototype;
}
function XS(t, e) {
  const n = { ...t };
  return l4(t) && l4(e) && Object.keys(e).forEach((r) => {
    l4(e[r]) && l4(t[r]) ? n[r] = XS(t[r], e[r]) : n[r] = e[r];
  }), n;
}
class Ra {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = _o(Qa(this, "addOptions", {
      name: this.name
    }))), this.storage = _o(Qa(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Ra(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => XS(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new Ra({ ...this.config, ...e });
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = _o(Qa(n, "addOptions", {
      name: n.name
    })), n.storage = _o(Qa(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function iIt(t, e, n) {
  const { from: r, to: i } = e, { blockSeparator: a = `

`, textSerializers: o = {} } = n || {};
  let s = "";
  return t.nodesBetween(r, i, (l, c, u, d) => {
    var f;
    l.isBlock && c > r && (s += a);
    const h = o == null ? void 0 : o[l.type.name];
    if (h)
      return u && (s += h({
        node: l,
        pos: c,
        parent: u,
        index: d,
        range: e
      })), !1;
    l.isText && (s += (f = l == null ? void 0 : l.text) === null || f === void 0 ? void 0 : f.slice(Math.max(r, c) - c, i - c));
  }), s;
}
function aIt(t) {
  return Object.fromEntries(Object.entries(t.nodes).filter(([, e]) => e.spec.toText).map(([e, n]) => [e, n.spec.toText]));
}
Ra.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Wt({
        key: new tn("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: t } = this, { state: e, schema: n } = t, { doc: r, selection: i } = e, { ranges: a } = i, o = Math.min(...a.map((u) => u.$from.pos)), s = Math.max(...a.map((u) => u.$to.pos)), l = aIt(n);
            return iIt(r, { from: o, to: s }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
});
const oIt = () => ({ editor: t, view: e }) => (requestAnimationFrame(() => {
  var n;
  t.isDestroyed || (e.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), sIt = (t = !1) => ({ commands: e }) => e.setContent("", t), lIt = () => ({ state: t, tr: e, dispatch: n }) => {
  const { selection: r } = e, { ranges: i } = r;
  return n && i.forEach(({ $from: a, $to: o }) => {
    t.doc.nodesBetween(a.pos, o.pos, (s, l) => {
      if (s.type.isText)
        return;
      const { doc: c, mapping: u } = e, d = c.resolve(u.map(l)), f = c.resolve(u.map(l + s.nodeSize)), h = d.blockRange(f);
      if (!h)
        return;
      const p = b0(h);
      if (s.type.isTextblock) {
        const { defaultType: m } = d.parent.contentMatchAt(d.index());
        e.setNodeMarkup(h.start, m);
      }
      (p || p === 0) && e.lift(h, p);
    });
  }), !0;
}, cIt = (t) => (e) => t(e), uIt = () => ({ state: t, dispatch: e }) => yx(t, e), dIt = (t, e) => ({ editor: n, tr: r }) => {
  const { state: i } = n, a = i.doc.slice(t.from, t.to);
  r.deleteRange(t.from, t.to);
  const o = r.mapping.map(e);
  return r.insert(o, a.content), r.setSelection(new ot(r.doc.resolve(o - 1))), !0;
}, fIt = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const i = t.selection.$anchor;
  for (let a = i.depth; a > 0; a -= 1)
    if (i.node(a).type === r.type) {
      if (e) {
        const s = i.before(a), l = i.after(a);
        t.delete(s, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, hIt = (t) => ({ tr: e, state: n, dispatch: r }) => {
  const i = Jr(t, n.schema), a = e.selection.$anchor;
  for (let o = a.depth; o > 0; o -= 1)
    if (a.node(o).type === i) {
      if (r) {
        const l = a.before(o), c = a.after(o);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, pIt = (t) => ({ tr: e, dispatch: n }) => {
  const { from: r, to: i } = t;
  return n && e.delete(r, i), !0;
}, mIt = () => ({ state: t, dispatch: e }) => xg(t, e), yIt = () => ({ commands: t }) => t.keyboardShortcut("Enter"), gIt = () => ({ state: t, dispatch: e }) => wH(t, e);
function j3(t, e, n = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((i) => n.strict ? e[i] === t[i] : tIt(e[i]) ? e[i].test(t[i]) : e[i] === t[i]) : !0;
}
function qee(t, e, n = {}) {
  return t.find((r) => r.type === e && j3(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(n).map((i) => [i, r.attrs[i]])),
    n
  ));
}
function Uz(t, e, n = {}) {
  return !!qee(t, e, n);
}
function Uee(t, e, n) {
  var r;
  if (!t || !e)
    return;
  let i = t.parent.childAfter(t.parentOffset);
  if ((!i.node || !i.node.marks.some((u) => u.type === e)) && (i = t.parent.childBefore(t.parentOffset)), !i.node || !i.node.marks.some((u) => u.type === e) || (n = n || ((r = i.node.marks[0]) === null || r === void 0 ? void 0 : r.attrs), !qee([...i.node.marks], e, n)))
    return;
  let o = i.index, s = t.start() + i.offset, l = o + 1, c = s + i.node.nodeSize;
  for (; o > 0 && Uz([...t.parent.child(o - 1).marks], e, n); )
    o -= 1, s -= t.parent.child(o).nodeSize;
  for (; l < t.parent.childCount && Uz([...t.parent.child(l).marks], e, n); )
    c += t.parent.child(l).nodeSize, l += 1;
  return {
    from: s,
    to: c
  };
}
function Jc(t, e) {
  if (typeof t == "string") {
    if (!e.marks[t])
      throw Error(`There is no mark type named '${t}'. Maybe you forgot to add the extension?`);
    return e.marks[t];
  }
  return t;
}
const vIt = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const a = Jc(t, r.schema), { doc: o, selection: s } = n, { $from: l, from: c, to: u } = s;
  if (i) {
    const d = Uee(l, a, e);
    if (d && d.from <= c && d.to >= u) {
      const f = ot.create(o, d.from, d.to);
      n.setSelection(f);
    }
  }
  return !0;
}, bIt = (t) => (e) => {
  const n = typeof t == "function" ? t(e) : t;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](e))
      return !0;
  return !1;
};
function Wee(t) {
  return t instanceof ot;
}
function Tu(t = 0, e = 0, n = 0) {
  return Math.min(Math.max(t, e), n);
}
function wIt(t, e = null) {
  if (!e)
    return null;
  const n = vt.atStart(t), r = vt.atEnd(t);
  if (e === "start" || e === !0)
    return n;
  if (e === "end")
    return r;
  const i = n.from, a = r.to;
  return e === "all" ? ot.create(t, Tu(0, i, a), Tu(t.content.size, i, a)) : ot.create(t, Tu(e, i, a), Tu(e, i, a));
}
function kIt() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function eL() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const xIt = (t = null, e = {}) => ({ editor: n, view: r, tr: i, dispatch: a }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const o = () => {
    (eL() || kIt()) && r.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), e != null && e.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && t === null || t === !1)
    return !0;
  if (a && t === null && !Wee(n.state.selection))
    return o(), !0;
  const s = wIt(i.doc, t) || n.state.selection, l = n.state.selection.eq(s);
  return a && (l || i.setSelection(s), l && i.storedMarks && i.setStoredMarks(i.storedMarks), o()), !0;
}, MIt = (t, e) => (n) => t.every((r, i) => e(r, { ...n, index: i })), CIt = (t, e) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, t, e), Zee = (t) => {
  const e = t.childNodes;
  for (let n = e.length - 1; n >= 0; n -= 1) {
    const r = e[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? t.removeChild(r) : r.nodeType === 1 && Zee(r);
  }
  return t;
};
function c4(t) {
  const e = `<body>${t}</body>`, n = new window.DOMParser().parseFromString(e, "text/html").body;
  return Zee(n);
}
function N3(t, e, n) {
  if (t instanceof cc || t instanceof Ne)
    return t;
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof t == "object" && t !== null, i = typeof t == "string";
  if (r)
    try {
      if (Array.isArray(t) && t.length > 0)
        return Ne.fromArray(t.map((s) => e.nodeFromJSON(s)));
      const o = e.nodeFromJSON(t);
      return n.errorOnInvalidContent && o.check(), o;
    } catch (a) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: a });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", t, "Error:", a), N3("", e, n);
    }
  if (i) {
    if (n.errorOnInvalidContent) {
      let o = !1, s = "";
      const l = new mg({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (o = !0, s = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? Uo.fromSchema(l).parseSlice(c4(t), n.parseOptions) : Uo.fromSchema(l).parse(c4(t), n.parseOptions), n.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${s}`) });
    }
    const a = Uo.fromSchema(e);
    return n.slice ? a.parseSlice(c4(t), n.parseOptions).content : a.parse(c4(t), n.parseOptions);
  }
  return N3("", e, n);
}
function AIt(t, e, n) {
  const r = t.steps.length - 1;
  if (r < e)
    return;
  const i = t.steps[r];
  if (!(i instanceof fr || i instanceof pr))
    return;
  const a = t.mapping.maps[r];
  let o = 0;
  a.forEach((s, l, c, u) => {
    o === 0 && (o = u);
  }), t.setSelection(vt.near(t.doc.resolve(o), n));
}
const SIt = (t) => !("type" in t), LIt = (t, e, n) => ({ tr: r, dispatch: i, editor: a }) => {
  var o;
  if (i) {
    n = {
      parseOptions: a.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let s;
    try {
      s = N3(e, a.schema, {
        parseOptions: {
          preserveWhitespace: "full",
          ...n.parseOptions
        },
        errorOnInvalidContent: (o = n.errorOnInvalidContent) !== null && o !== void 0 ? o : a.options.enableContentCheck
      });
    } catch (p) {
      return a.emit("contentError", {
        editor: a,
        error: p,
        disableCollaboration: () => {
          a.storage.collaboration && (a.storage.collaboration.isDisabled = !0);
        }
      }), !1;
    }
    let { from: l, to: c } = typeof t == "number" ? { from: t, to: t } : { from: t.from, to: t.to }, u = !0, d = !0;
    if ((SIt(s) ? s : [s]).forEach((p) => {
      p.check(), u = u ? p.isText && p.marks.length === 0 : !1, d = d ? p.isBlock : !1;
    }), l === c && d) {
      const { parent: p } = r.doc.resolve(l);
      p.isTextblock && !p.type.spec.code && !p.childCount && (l -= 1, c += 1);
    }
    let h;
    if (u) {
      if (Array.isArray(e))
        h = e.map((p) => p.text || "").join("");
      else if (e instanceof Ne) {
        let p = "";
        e.forEach((m) => {
          m.text && (p += m.text);
        }), h = p;
      } else typeof e == "object" && e && e.text ? h = e.text : h = e;
      r.insertText(h, l, c);
    } else
      h = s, r.replaceWith(l, c, h);
    n.updateSelection && AIt(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: l, text: h }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: l, text: h });
  }
  return !0;
}, TIt = () => ({ state: t, dispatch: e }) => gH(t, e), EIt = () => ({ state: t, dispatch: e }) => vH(t, e), jIt = () => ({ state: t, dispatch: e }) => lx(t, e), NIt = () => ({ state: t, dispatch: e }) => dx(t, e), DIt = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = xd(t.doc, t.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, IIt = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = xd(t.doc, t.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, PIt = () => ({ state: t, dispatch: e }) => hH(t, e), zIt = () => ({ state: t, dispatch: e }) => pH(t, e);
function Gee() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function RIt(t) {
  const e = t.split(/-(?!$)/);
  let n = e[e.length - 1];
  n === "Space" && (n = " ");
  let r, i, a, o;
  for (let s = 0; s < e.length - 1; s += 1) {
    const l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      a = !0;
    else if (/^mod$/i.test(l))
      eL() || Gee() ? o = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (n = `Alt-${n}`), i && (n = `Ctrl-${n}`), o && (n = `Meta-${n}`), a && (n = `Shift-${n}`), n;
}
const OIt = (t) => ({ editor: e, view: n, tr: r, dispatch: i }) => {
  const a = RIt(t).split(/-(?!$)/), o = a.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), s = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: a.includes("Alt"),
    ctrlKey: a.includes("Ctrl"),
    metaKey: a.includes("Meta"),
    shiftKey: a.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    n.someProp("handleKeyDown", (c) => c(n, s));
  });
  return l == null || l.steps.forEach((c) => {
    const u = c.map(r.mapping);
    u && i && r.maybeStep(u);
  }), !0;
};
function tL(t, e, n = {}) {
  const { from: r, to: i, empty: a } = t.selection, o = e ? Jr(e, t.schema) : null, s = [];
  t.doc.nodesBetween(r, i, (d, f) => {
    if (d.isText)
      return;
    const h = Math.max(r, f), p = Math.min(i, f + d.nodeSize);
    s.push({
      node: d,
      from: h,
      to: p
    });
  });
  const l = i - r, c = s.filter((d) => o ? o.name === d.node.type.name : !0).filter((d) => j3(d.node.attrs, n, { strict: !1 }));
  return a ? !!c.length : c.reduce((d, f) => d + f.to - f.from, 0) >= l;
}
const BIt = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = Jr(t, n.schema);
  return tL(n, i, e) ? bH(n, r) : !1;
}, HIt = () => ({ state: t, dispatch: e }) => gx(t, e), FIt = (t) => ({ state: e, dispatch: n }) => {
  const r = Jr(t, e.schema);
  return TH(r)(e, n);
}, _It = () => ({ state: t, dispatch: e }) => px(t, e);
function Yee(t, e) {
  return e.nodes[t] ? "node" : e.marks[t] ? "mark" : null;
}
function Wz(t, e) {
  const n = typeof e == "string" ? [e] : e;
  return Object.keys(t).reduce((r, i) => (n.includes(i) || (r[i] = t[i]), r), {});
}
const VIt = (t, e) => ({ tr: n, state: r, dispatch: i }) => {
  let a = null, o = null;
  const s = Yee(typeof t == "string" ? t : t.name, r.schema);
  return s ? (s === "node" && (a = Jr(t, r.schema)), s === "mark" && (o = Jc(t, r.schema)), i && n.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      a && a === c.type && n.setNodeMarkup(u, void 0, Wz(c.attrs, e)), o && c.marks.length && c.marks.forEach((d) => {
        o === d.type && n.addMark(u, u + c.nodeSize, o.create(Wz(d.attrs, e)));
      });
    });
  }), !0) : !1;
}, qIt = () => ({ tr: t, dispatch: e }) => (e && t.scrollIntoView(), !0), UIt = () => ({ tr: t, dispatch: e }) => {
  if (e) {
    const n = new Li(t.doc);
    t.setSelection(n);
  }
  return !0;
}, WIt = () => ({ state: t, dispatch: e }) => cx(t, e), ZIt = () => ({ state: t, dispatch: e }) => fx(t, e), GIt = () => ({ state: t, dispatch: e }) => kH(t, e), YIt = () => ({ state: t, dispatch: e }) => AH(t, e), KIt = () => ({ state: t, dispatch: e }) => CH(t, e);
function $It(t, e, n = {}, r = {}) {
  return N3(t, e, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
const JIt = (t, e = !1, n = {}, r = {}) => ({ editor: i, tr: a, dispatch: o, commands: s }) => {
  var l, c;
  const { doc: u } = a;
  if (n.preserveWhitespace !== "full") {
    const d = $It(t, i.schema, n, {
      errorOnInvalidContent: (l = r.errorOnInvalidContent) !== null && l !== void 0 ? l : i.options.enableContentCheck
    });
    return o && a.replaceWith(0, u.content.size, d).setMeta("preventUpdate", !e), !0;
  }
  return o && a.setMeta("preventUpdate", !e), s.insertContentAt({ from: 0, to: u.content.size }, t, {
    parseOptions: n,
    errorOnInvalidContent: (c = r.errorOnInvalidContent) !== null && c !== void 0 ? c : i.options.enableContentCheck
  });
};
function QIt(t, e) {
  const n = Jc(e, t.schema), { from: r, to: i, empty: a } = t.selection, o = [];
  a ? (t.storedMarks && o.push(...t.storedMarks), o.push(...t.selection.$head.marks())) : t.doc.nodesBetween(r, i, (l) => {
    o.push(...l.marks);
  });
  const s = o.find((l) => l.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function XIt(t) {
  for (let e = 0; e < t.edgeCount; e += 1) {
    const { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function ePt(t, e) {
  for (let n = t.depth; n > 0; n -= 1) {
    const r = t.node(n);
    if (e(r))
      return {
        pos: n > 0 ? t.before(n) : 0,
        start: t.start(n),
        depth: n,
        node: r
      };
  }
}
function nL(t) {
  return (e) => ePt(e.$from, t);
}
function ay(t, e, n) {
  return Object.fromEntries(Object.entries(n).filter(([r]) => {
    const i = t.find((a) => a.type === e && a.name === r);
    return i ? i.attribute.keepOnSplit : !1;
  }));
}
function tPt(t, e, n = {}) {
  const { empty: r, ranges: i } = t.selection, a = e ? Jc(e, t.schema) : null;
  if (r)
    return !!(t.storedMarks || t.selection.$from.marks()).filter((d) => a ? a.name === d.type.name : !0).find((d) => j3(d.attrs, n, { strict: !1 }));
  let o = 0;
  const s = [];
  if (i.forEach(({ $from: d, $to: f }) => {
    const h = d.pos, p = f.pos;
    t.doc.nodesBetween(h, p, (m, g) => {
      if (!m.isText && !m.marks.length)
        return;
      const v = Math.max(h, g), k = Math.min(p, g + m.nodeSize), w = k - v;
      o += w, s.push(...m.marks.map((b) => ({
        mark: b,
        from: v,
        to: k
      })));
    });
  }), o === 0)
    return !1;
  const l = s.filter((d) => a ? a.name === d.mark.type.name : !0).filter((d) => j3(d.mark.attrs, n, { strict: !1 })).reduce((d, f) => d + f.to - f.from, 0), c = s.filter((d) => a ? d.mark.type !== a && d.mark.type.excludes(a) : !0).reduce((d, f) => d + f.to - f.from, 0);
  return (l > 0 ? l + c : l) >= o;
}
function Zz(t, e) {
  const { nodeExtensions: n } = QDt(e), r = n.find((o) => o.name === t);
  if (!r)
    return !1;
  const i = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, a = _o(Qa(r, "group", i));
  return typeof a != "string" ? !1 : a.split(" ").includes("list");
}
function Kee(t, { checkChildren: e = !0, ignoreWhitespace: n = !1 } = {}) {
  var r;
  if (n) {
    if (t.type.name === "hardBreak")
      return !0;
    if (t.isText)
      return /^\s*$/m.test((r = t.text) !== null && r !== void 0 ? r : "");
  }
  if (t.isText)
    return !t.text;
  if (t.isAtom || t.isLeaf)
    return !1;
  if (t.content.childCount === 0)
    return !0;
  if (e) {
    let i = !0;
    return t.content.forEach((a) => {
      i !== !1 && (Kee(a, { ignoreWhitespace: n, checkChildren: e }) || (i = !1));
    }), i;
  }
  return !1;
}
function nPt(t, e, n) {
  var r;
  const { selection: i } = e;
  let a = null;
  if (Wee(i) && (a = i.$cursor), a) {
    const s = (r = t.storedMarks) !== null && r !== void 0 ? r : a.marks();
    return !!n.isInSet(s) || !s.some((l) => l.type.excludes(n));
  }
  const { ranges: o } = i;
  return o.some(({ $from: s, $to: l }) => {
    let c = s.depth === 0 ? t.doc.inlineContent && t.doc.type.allowsMarkType(n) : !1;
    return t.doc.nodesBetween(s.pos, l.pos, (u, d, f) => {
      if (c)
        return !1;
      if (u.isInline) {
        const h = !f || f.type.allowsMarkType(n), p = !!n.isInSet(u.marks) || !u.marks.some((m) => m.type.excludes(n));
        c = h && p;
      }
      return !c;
    }), c;
  });
}
const rPt = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const { selection: a } = n, { empty: o, ranges: s } = a, l = Jc(t, r.schema);
  if (i)
    if (o) {
      const c = QIt(r, l);
      n.addStoredMark(l.create({
        ...c,
        ...e
      }));
    } else
      s.forEach((c) => {
        const u = c.$from.pos, d = c.$to.pos;
        r.doc.nodesBetween(u, d, (f, h) => {
          const p = Math.max(h, u), m = Math.min(h + f.nodeSize, d);
          f.marks.find((v) => v.type === l) ? f.marks.forEach((v) => {
            l === v.type && n.addMark(p, m, l.create({
              ...v.attrs,
              ...e
            }));
          }) : n.addMark(p, m, l.create(e));
        });
      });
  return nPt(r, n, l);
}, iPt = (t, e) => ({ tr: n }) => (n.setMeta(t, e), !0), aPt = (t, e = {}) => ({ state: n, dispatch: r, chain: i }) => {
  const a = Jr(t, n.schema);
  let o;
  return n.selection.$anchor.sameParent(n.selection.$head) && (o = n.selection.$anchor.parent.attrs), a.isTextblock ? i().command(({ commands: s }) => xy(a, { ...o, ...e })(n) ? !0 : s.clearNodes()).command(({ state: s }) => xy(a, { ...o, ...e })(s, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, oPt = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, i = Tu(t, 0, r.content.size), a = gt.create(r, i);
    e.setSelection(a);
  }
  return !0;
}, sPt = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, { from: i, to: a } = typeof t == "number" ? { from: t, to: t } : t, o = ot.atStart(r).from, s = ot.atEnd(r).to, l = Tu(i, o, s), c = Tu(a, o, s), u = ot.create(r, l, c);
    e.setSelection(u);
  }
  return !0;
}, lPt = (t) => ({ state: e, dispatch: n }) => {
  const r = Jr(t, e.schema);
  return EH(r)(e, n);
};
function Gz(t, e) {
  const n = t.storedMarks || t.selection.$to.parentOffset && t.selection.$from.marks();
  if (n) {
    const r = n.filter((i) => e == null ? void 0 : e.includes(i.type.name));
    t.tr.ensureMarks(r);
  }
}
const cPt = ({ keepMarks: t = !0 } = {}) => ({ tr: e, state: n, dispatch: r, editor: i }) => {
  const { selection: a, doc: o } = e, { $from: s, $to: l } = a, c = i.extensionManager.attributes, u = ay(c, s.node().type.name, s.node().attrs);
  if (a instanceof gt && a.node.isBlock)
    return !s.parentOffset || !Ji(o, s.pos) ? !1 : (r && (t && Gz(n, i.extensionManager.splittableMarks), e.split(s.pos).scrollIntoView()), !0);
  if (!s.parent.isBlock)
    return !1;
  const d = l.parentOffset === l.parent.content.size, f = s.depth === 0 ? void 0 : XIt(s.node(-1).contentMatchAt(s.indexAfter(-1)));
  let h = d && f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0, p = Ji(e.doc, e.mapping.map(s.pos), 1, h);
  if (!h && !p && Ji(e.doc, e.mapping.map(s.pos), 1, f ? [{ type: f }] : void 0) && (p = !0, h = f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0), r) {
    if (p && (a instanceof ot && e.deleteSelection(), e.split(e.mapping.map(s.pos), 1, h), f && !d && !s.parentOffset && s.parent.type !== f)) {
      const m = e.mapping.map(s.before()), g = e.doc.resolve(m);
      s.node(-1).canReplaceWith(g.index(), g.index() + 1, f) && e.setNodeMarkup(e.mapping.map(s.before()), f);
    }
    t && Gz(n, i.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, uPt = (t, e = {}) => ({ tr: n, state: r, dispatch: i, editor: a }) => {
  var o;
  const s = Jr(t, r.schema), { $from: l, $to: c } = r.selection, u = r.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const d = l.node(-1);
  if (d.type !== s)
    return !1;
  const f = a.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== s || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (i) {
      let v = Ne.empty;
      const k = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let M = l.depth - k; M >= l.depth - 3; M -= 1)
        v = Ne.from(l.node(M).copy(v));
      const w = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, b = {
        ...ay(f, l.node().type.name, l.node().attrs),
        ...e
      }, x = ((o = s.contentMatch.defaultType) === null || o === void 0 ? void 0 : o.createAndFill(b)) || void 0;
      v = v.append(Ne.from(s.createAndFill(null, x) || void 0));
      const A = l.before(l.depth - (k - 1));
      n.replace(A, l.after(-w), new Je(v, 4 - k, 0));
      let L = -1;
      n.doc.nodesBetween(A, n.doc.content.size, (M, j) => {
        if (L > -1)
          return !1;
        M.isTextblock && M.content.size === 0 && (L = j + 1);
      }), L > -1 && n.setSelection(ot.near(n.doc.resolve(L))), n.scrollIntoView();
    }
    return !0;
  }
  const h = c.pos === l.end() ? d.contentMatchAt(0).defaultType : null, p = {
    ...ay(f, d.type.name, d.attrs),
    ...e
  }, m = {
    ...ay(f, l.node().type.name, l.node().attrs),
    ...e
  };
  n.delete(l.pos, c.pos);
  const g = h ? [
    { type: s, attrs: p },
    { type: h, attrs: m }
  ] : [{ type: s, attrs: p }];
  if (!Ji(n.doc, l.pos, 2))
    return !1;
  if (i) {
    const { selection: v, storedMarks: k } = r, { splittableMarks: w } = a.extensionManager, b = k || v.$to.parentOffset && v.$from.marks();
    if (n.split(l.pos, 2, g).scrollIntoView(), !b || !i)
      return !0;
    const x = b.filter((A) => w.includes(A.type.name));
    n.ensureMarks(x);
  }
  return !0;
}, rb = (t, e) => {
  const n = nL((o) => o.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const i = t.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && po(t.doc, n.pos) && t.join(n.pos), !0;
}, ib = (t, e) => {
  const n = nL((o) => o.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const i = t.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && po(t.doc, r) && t.join(r), !0;
}, dPt = (t, e, n, r = {}) => ({ editor: i, tr: a, state: o, dispatch: s, chain: l, commands: c, can: u }) => {
  const { extensions: d, splittableMarks: f } = i.extensionManager, h = Jr(t, o.schema), p = Jr(e, o.schema), { selection: m, storedMarks: g } = o, { $from: v, $to: k } = m, w = v.blockRange(k), b = g || m.$to.parentOffset && m.$from.marks();
  if (!w)
    return !1;
  const x = nL((A) => Zz(A.type.name, d))(m);
  if (w.depth >= 1 && x && w.depth - x.depth <= 1) {
    if (x.node.type === h)
      return c.liftListItem(p);
    if (Zz(x.node.type.name, d) && h.validContent(x.node.content) && s)
      return l().command(() => (a.setNodeMarkup(x.pos, h), !0)).command(() => rb(a, h)).command(() => ib(a, h)).run();
  }
  return !n || !b || !s ? l().command(() => u().wrapInList(h, r) ? !0 : c.clearNodes()).wrapInList(h, r).command(() => rb(a, h)).command(() => ib(a, h)).run() : l().command(() => {
    const A = u().wrapInList(h, r), L = b.filter((M) => f.includes(M.type.name));
    return a.ensureMarks(L), A ? !0 : c.clearNodes();
  }).wrapInList(h, r).command(() => rb(a, h)).command(() => ib(a, h)).run();
}, fPt = (t, e = {}, n = {}) => ({ state: r, commands: i }) => {
  const { extendEmptyMarkRange: a = !1 } = n, o = Jc(t, r.schema);
  return tPt(r, o, e) ? i.unsetMark(o, { extendEmptyMarkRange: a }) : i.setMark(o, e);
}, hPt = (t, e, n = {}) => ({ state: r, commands: i }) => {
  const a = Jr(t, r.schema), o = Jr(e, r.schema), s = tL(r, a, n);
  let l;
  return r.selection.$anchor.sameParent(r.selection.$head) && (l = r.selection.$anchor.parent.attrs), s ? i.setNode(o, l) : i.setNode(a, { ...l, ...n });
}, pPt = (t, e = {}) => ({ state: n, commands: r }) => {
  const i = Jr(t, n.schema);
  return tL(n, i, e) ? r.lift(i) : r.wrapIn(i, e);
}, mPt = () => ({ state: t, dispatch: e }) => {
  const n = t.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const i = n[r];
    let a;
    if (i.spec.isInputRules && (a = i.getState(t))) {
      if (e) {
        const o = t.tr, s = a.transform;
        for (let l = s.steps.length - 1; l >= 0; l -= 1)
          o.step(s.steps[l].invert(s.docs[l]));
        if (a.text) {
          const l = o.doc.resolve(a.from).marks();
          o.replaceWith(a.from, a.to, t.schema.text(a.text, l));
        } else
          o.delete(a.from, a.to);
      }
      return !0;
    }
  }
  return !1;
}, yPt = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, { empty: r, ranges: i } = n;
  return r || e && i.forEach((a) => {
    t.removeMark(a.$from.pos, a.$to.pos);
  }), !0;
}, gPt = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  var a;
  const { extendEmptyMarkRange: o = !1 } = e, { selection: s } = n, l = Jc(t, r.schema), { $from: c, empty: u, ranges: d } = s;
  if (!i)
    return !0;
  if (u && o) {
    let { from: f, to: h } = s;
    const p = (a = c.marks().find((g) => g.type === l)) === null || a === void 0 ? void 0 : a.attrs, m = Uee(c, l, p);
    m && (f = m.from, h = m.to), n.removeMark(f, h, l);
  } else
    d.forEach((f) => {
      n.removeMark(f.$from.pos, f.$to.pos, l);
    });
  return n.removeStoredMark(l), !0;
}, vPt = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  let a = null, o = null;
  const s = Yee(typeof t == "string" ? t : t.name, r.schema);
  return s ? (s === "node" && (a = Jr(t, r.schema)), s === "mark" && (o = Jc(t, r.schema)), i && n.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    let d, f, h, p;
    n.selection.empty ? r.doc.nodesBetween(c, u, (m, g) => {
      a && a === m.type && (h = Math.max(g, c), p = Math.min(g + m.nodeSize, u), d = g, f = m);
    }) : r.doc.nodesBetween(c, u, (m, g) => {
      g < c && a && a === m.type && (h = Math.max(g, c), p = Math.min(g + m.nodeSize, u), d = g, f = m), g >= c && g <= u && (a && a === m.type && n.setNodeMarkup(g, void 0, {
        ...m.attrs,
        ...e
      }), o && m.marks.length && m.marks.forEach((v) => {
        if (o === v.type) {
          const k = Math.max(g, c), w = Math.min(g + m.nodeSize, u);
          n.addMark(k, w, o.create({
            ...v.attrs,
            ...e
          }));
        }
      }));
    }), f && (d !== void 0 && n.setNodeMarkup(d, void 0, {
      ...f.attrs,
      ...e
    }), o && f.marks.length && f.marks.forEach((m) => {
      o === m.type && n.addMark(h, p, o.create({
        ...m.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, bPt = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = Jr(t, n.schema);
  return SH(i, e)(n, r);
}, wPt = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = Jr(t, n.schema);
  return LH(i, e)(n, r);
};
var kPt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: oIt,
  clearContent: sIt,
  clearNodes: lIt,
  command: cIt,
  createParagraphNear: uIt,
  cut: dIt,
  deleteCurrentNode: fIt,
  deleteNode: hIt,
  deleteRange: pIt,
  deleteSelection: mIt,
  enter: yIt,
  exitCode: gIt,
  extendMarkRange: vIt,
  first: bIt,
  focus: xIt,
  forEach: MIt,
  insertContent: CIt,
  insertContentAt: LIt,
  joinBackward: jIt,
  joinDown: EIt,
  joinForward: NIt,
  joinItemBackward: DIt,
  joinItemForward: IIt,
  joinTextblockBackward: PIt,
  joinTextblockForward: zIt,
  joinUp: TIt,
  keyboardShortcut: OIt,
  lift: BIt,
  liftEmptyBlock: HIt,
  liftListItem: FIt,
  newlineInCode: _It,
  resetAttributes: VIt,
  scrollIntoView: qIt,
  selectAll: UIt,
  selectNodeBackward: WIt,
  selectNodeForward: ZIt,
  selectParentNode: GIt,
  selectTextblockEnd: YIt,
  selectTextblockStart: KIt,
  setContent: JIt,
  setMark: rPt,
  setMeta: iPt,
  setNode: aPt,
  setNodeSelection: oPt,
  setTextSelection: sPt,
  sinkListItem: lPt,
  splitBlock: cPt,
  splitListItem: uPt,
  toggleList: dPt,
  toggleMark: fPt,
  toggleNode: hPt,
  toggleWrap: pPt,
  undoInputRule: mPt,
  unsetAllMarks: yPt,
  unsetMark: gPt,
  updateAttributes: vPt,
  wrapIn: bPt,
  wrapInList: wPt
});
Ra.create({
  name: "commands",
  addCommands() {
    return {
      ...kPt
    };
  }
});
Ra.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Wt({
        key: new tn("tiptapDrop"),
        props: {
          handleDrop: (t, e, n, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: n,
              moved: r
            });
          }
        }
      })
    ];
  }
});
Ra.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Wt({
        key: new tn("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
});
const xPt = new tn("focusEvents");
Ra.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: t } = this;
    return [
      new Wt({
        key: xPt,
        props: {
          handleDOMEvents: {
            focus: (e, n) => {
              t.isFocused = !0;
              const r = t.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, n) => {
              t.isFocused = !1;
              const r = t.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
});
Ra.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const t = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: s }) => {
        const { selection: l, doc: c } = s, { empty: u, $anchor: d } = l, { pos: f, parent: h } = d, p = d.parent.isTextblock && f > 0 ? s.doc.resolve(f - 1) : d, m = p.parent.type.spec.isolating, g = d.pos - d.parentOffset, v = m && p.parent.childCount === 1 ? g === d.pos : vt.atStart(c).from === f;
        return !u || !h.type.isTextblock || h.textContent.length || !v || v && d.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: t,
      "Mod-Backspace": t,
      "Shift-Backspace": t,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...r
    }, a = {
      ...r,
      "Ctrl-h": t,
      "Alt-Backspace": t,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return eL() || Gee() ? a : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Wt({
        key: new tn("clearDocument"),
        appendTransaction: (t, e, n) => {
          if (t.some((m) => m.getMeta("composition")))
            return;
          const r = t.some((m) => m.docChanged) && !e.doc.eq(n.doc), i = t.some((m) => m.getMeta("preventClearDocument"));
          if (!r || i)
            return;
          const { empty: a, from: o, to: s } = e.selection, l = vt.atStart(e.doc).from, c = vt.atEnd(e.doc).to;
          if (a || !(o === l && s === c) || !Kee(n.doc))
            return;
          const f = n.tr, h = Vee({
            state: n,
            transaction: f
          }), { commands: p } = new JDt({
            editor: this.editor,
            state: h
          });
          if (p.clearNodes(), !!f.steps.length)
            return f;
        }
      })
    ];
  }
});
Ra.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Wt({
        key: new tn("tiptapPaste"),
        props: {
          handlePaste: (t, e, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: n
            });
          }
        }
      })
    ];
  }
});
Ra.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Wt({
        key: new tn("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
function Yz(t) {
  return new nIt({
    find: t.find,
    handler: ({ state: e, range: n, match: r, chain: i }) => {
      const a = _o(t.getAttributes, void 0, r) || {}, o = e.tr.delete(n.from, n.to), l = o.doc.resolve(n.from).blockRange(), c = l && yg(l, t.type, a);
      if (!c)
        return null;
      if (o.wrap(l, c), t.keepMarks && t.editor) {
        const { selection: d, storedMarks: f } = e, { splittableMarks: h } = t.editor.extensionManager, p = f || d.$to.parentOffset && d.$from.marks();
        if (p) {
          const m = p.filter((g) => h.includes(g.type.name));
          o.ensureMarks(m);
        }
      }
      if (t.keepAttributes) {
        const d = t.type.name === "bulletList" || t.type.name === "orderedList" ? "listItem" : "taskList";
        i().updateAttributes(d, a).run();
      }
      const u = o.doc.resolve(n.from - 1).nodeBefore;
      u && u.type === t.type && po(o.doc, n.from - 1) && (!t.joinPredicate || t.joinPredicate(r, u)) && o.join(n.from - 1);
    }
  });
}
let MPt = class ak {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = _o(Qa(this, "addOptions", {
      name: this.name
    }))), this.storage = _o(Qa(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new ak(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => XS(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new ak(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = _o(Qa(n, "addOptions", {
      name: n.name
    })), n.storage = _o(Qa(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
};
const CPt = /^\s*>\s$/, APt = Ht.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["blockquote", _t(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: t }) => t.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: t }) => t.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: t }) => t.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      O1({
        find: CPt,
        type: this.type
      })
    ];
  }
}), SPt = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, LPt = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, TPt = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, EPt = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, jPt = ir.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (t) => t.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (t) => /^(bold(er)?|[5-9]\d{2,})$/.test(t) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["strong", _t(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: t }) => t.setMark(this.name),
      toggleBold: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetBold: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      Yu({
        find: SPt,
        type: this.type
      }),
      Yu({
        find: TPt,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      gc({
        find: LPt,
        type: this.type
      }),
      gc({
        find: EPt,
        type: this.type
      })
    ];
  }
}), NPt = "listItem", Kz = "textStyle", $z = /^\s*([-+*])\s$/, DPt = MPt.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", XDt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(NPt, this.editor.getAttributes(Kz)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let t = Yz({
      find: $z,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = Yz({
      find: $z,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(Kz),
      editor: this.editor
    })), [
      t
    ];
  }
}), IPt = /(^|[^`])`([^`]+)`(?!`)/, PPt = /(^|[^`])`([^`]+)`(?!`)/g, zPt = ir.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["code", _t(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: t }) => t.setMark(this.name),
      toggleCode: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetCode: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      Yu({
        find: IPt,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      gc({
        find: PPt,
        type: this.type
      })
    ];
  }
}), RPt = /^```([a-z]+)?[\s\n]$/, OPt = /^~~~([a-z]+)?[\s\n]$/, BPt = Ht.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (t) => {
          var e;
          const { languageClassPrefix: n } = this.options, a = [...((e = t.firstElementChild) === null || e === void 0 ? void 0 : e.classList) || []].filter((o) => o.startsWith(n)).map((o) => o.replace(n, ""))[0];
          return a || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "pre",
      _t(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: t.attrs.language ? this.options.languageClassPrefix + t.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (t) => ({ commands: e }) => e.setNode(this.name, t),
      toggleCodeBlock: (t) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", t)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: t, $anchor: e } = this.editor.state.selection, n = e.pos === 1;
        return !t || e.parent.type.name !== this.name ? !1 : n || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: t }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = t, { selection: n } = e, { $from: r, empty: i } = n;
        if (!i || r.parent.type !== this.type)
          return !1;
        const a = r.parentOffset === r.parent.nodeSize - 2, o = r.parent.textContent.endsWith(`

`);
        return !a || !o ? !1 : t.chain().command(({ tr: s }) => (s.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: t }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = t, { selection: n, doc: r } = e, { $from: i, empty: a } = n;
        if (!a || i.parent.type !== this.type || !(i.parentOffset === i.parent.nodeSize - 2))
          return !1;
        const s = i.after();
        return s === void 0 ? !1 : r.nodeAt(s) ? t.commands.command(({ tr: c }) => (c.setSelection(vt.near(r.resolve(s))), !0)) : t.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      M7({
        find: RPt,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      }),
      M7({
        find: OPt,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Wt({
        key: new tn("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (t, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), i = r ? JSON.parse(r) : void 0, a = i == null ? void 0 : i.mode;
            if (!n || !a)
              return !1;
            const { tr: o, schema: s } = t.state, l = s.text(n.replace(/\r\n?/g, `
`));
            return o.replaceSelectionWith(this.type.create({ language: a }, l)), o.selection.$from.parent.type !== this.type && o.setSelection(ot.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.setMeta("paste", !0), t.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), $ee = Ht.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function HPt(t = {}) {
  return new Wt({
    view(e) {
      return new FPt(e, t);
    }
  });
}
class FPt {
  constructor(e, n) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = n.width) !== null && r !== void 0 ? r : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((i) => {
      let a = (o) => {
        this[i](o);
      };
      return e.dom.addEventListener(i, a), { name: i, handler: a };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: n }) => this.editorView.dom.removeEventListener(e, n));
  }
  update(e, n) {
    this.cursorPos != null && n.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), n = !e.parent.inlineContent, r;
    if (n) {
      let s = e.nodeBefore, l = e.nodeAfter;
      if (s || l) {
        let c = this.editorView.nodeDOM(this.cursorPos - (s ? s.nodeSize : 0));
        if (c) {
          let u = c.getBoundingClientRect(), d = s ? u.bottom : u.top;
          s && l && (d = (d + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), r = { left: u.left, right: u.right, top: d - this.width / 2, bottom: d + this.width / 2 };
        }
      }
    }
    if (!r) {
      let s = this.editorView.coordsAtPos(this.cursorPos);
      r = { left: s.left - this.width / 2, right: s.left + this.width / 2, top: s.top, bottom: s.bottom };
    }
    let i = this.editorView.dom.offsetParent;
    this.element || (this.element = i.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let a, o;
    if (!i || i == document.body && getComputedStyle(i).position == "static")
      a = -pageXOffset, o = -pageYOffset;
    else {
      let s = i.getBoundingClientRect();
      a = s.left - i.scrollLeft, o = s.top - i.scrollTop;
    }
    this.element.style.left = r.left - a + "px", this.element.style.top = r.top - o + "px", this.element.style.width = r.right - r.left + "px", this.element.style.height = r.bottom - r.top + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), i = r && r.type.spec.disableDropCursor, a = typeof i == "function" ? i(this.editorView, n, e) : i;
    if (n && !a) {
      let o = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let s = SB(this.editorView.state.doc, o, this.editorView.dragging.slice);
        s != null && (o = s);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    (e.target == this.editorView.dom || !this.editorView.dom.contains(e.relatedTarget)) && this.setCursor(null);
  }
}
const Jee = ln.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      HPt(this.options)
    ];
  }
});
class Yn extends vt {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    return Yn.valid(r) ? new Yn(r) : vt.near(r);
  }
  content() {
    return Je.empty;
  }
  eq(e) {
    return e instanceof Yn && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Yn(e.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new rL(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let n = e.parent;
    if (n.isTextblock || !_Pt(e) || !VPt(e))
      return !1;
    let r = n.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let i = n.contentMatchAt(e.index()).defaultType;
    return i && i.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, n, r = !1) {
    e: for (; ; ) {
      if (!r && Yn.valid(e))
        return e;
      let i = e.pos, a = null;
      for (let o = e.depth; ; o--) {
        let s = e.node(o);
        if (n > 0 ? e.indexAfter(o) < s.childCount : e.index(o) > 0) {
          a = s.child(n > 0 ? e.indexAfter(o) : e.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        i += n;
        let l = e.doc.resolve(i);
        if (Yn.valid(l))
          return l;
      }
      for (; ; ) {
        let o = n > 0 ? a.firstChild : a.lastChild;
        if (!o) {
          if (a.isAtom && !a.isText && !gt.isSelectable(a)) {
            e = e.doc.resolve(i + a.nodeSize * n), r = !1;
            continue e;
          }
          break;
        }
        a = o, i += n;
        let s = e.doc.resolve(i);
        if (Yn.valid(s))
          return s;
      }
      return null;
    }
  }
}
Yn.prototype.visible = !1;
Yn.findFrom = Yn.findGapCursorFrom;
vt.jsonID("gapcursor", Yn);
class rL {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new rL(e.map(this.pos));
  }
  resolve(e) {
    let n = e.resolve(this.pos);
    return Yn.valid(n) ? new Yn(n) : vt.near(n);
  }
}
function _Pt(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.index(e), r = t.node(e);
    if (n == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(n - 1); ; i = i.lastChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function VPt(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.indexAfter(e), r = t.node(e);
    if (n == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(n); ; i = i.firstChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function qPt() {
  return new Wt({
    props: {
      decorations: GPt,
      createSelectionBetween(t, e, n) {
        return e.pos == n.pos && Yn.valid(n) ? new Yn(n) : null;
      },
      handleClick: WPt,
      handleKeyDown: UPt,
      handleDOMEvents: { beforeinput: ZPt }
    }
  });
}
const UPt = sx({
  ArrowLeft: u4("horiz", -1),
  ArrowRight: u4("horiz", 1),
  ArrowUp: u4("vert", -1),
  ArrowDown: u4("vert", 1)
});
function u4(t, e) {
  const n = t == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, i, a) {
    let o = r.selection, s = e > 0 ? o.$to : o.$from, l = o.empty;
    if (o instanceof ot) {
      if (!a.endOfTextblock(n) || s.depth == 0)
        return !1;
      l = !1, s = r.doc.resolve(e > 0 ? s.after() : s.before());
    }
    let c = Yn.findGapCursorFrom(s, e, l);
    return c ? (i && i(r.tr.setSelection(new Yn(c))), !0) : !1;
  };
}
function WPt(t, e, n) {
  if (!t || !t.editable)
    return !1;
  let r = t.state.doc.resolve(e);
  if (!Yn.valid(r))
    return !1;
  let i = t.posAtCoords({ left: n.clientX, top: n.clientY });
  return i && i.inside > -1 && gt.isSelectable(t.state.doc.nodeAt(i.inside)) ? !1 : (t.dispatch(t.state.tr.setSelection(new Yn(r))), !0);
}
function ZPt(t, e) {
  if (e.inputType != "insertCompositionText" || !(t.state.selection instanceof Yn))
    return !1;
  let { $from: n } = t.state.selection, r = n.parent.contentMatchAt(n.index()).findWrapping(t.state.schema.nodes.text);
  if (!r)
    return !1;
  let i = Ne.empty;
  for (let o = r.length - 1; o >= 0; o--)
    i = Ne.from(r[o].createAndFill(null, i));
  let a = t.state.tr.replace(n.pos, n.pos, new Je(i, 0, 0));
  return a.setSelection(ot.near(a.doc.resolve(n.pos + 1))), t.dispatch(a), !1;
}
function GPt(t) {
  if (!(t.selection instanceof Yn))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", vn.create(t.doc, [hr.widget(t.selection.head, e, { key: "gapcursor" })]);
}
const Qee = ln.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      qPt()
    ];
  },
  extendNodeSchema(t) {
    var e;
    const n = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      allowGapCursor: (e = Gt(ft(t, "allowGapCursor", n))) !== null && e !== void 0 ? e : null
    };
  }
}), YPt = Ht.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["br", _t(this.options.HTMLAttributes, t)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: t, chain: e, state: n, editor: r }) => t.first([
        () => t.exitCode(),
        () => t.command(() => {
          const { selection: i, storedMarks: a } = n;
          if (i.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: s } = r.extensionManager, l = a || i.$to.parentOffset && i.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: c, dispatch: u }) => {
            if (u && l && o) {
              const d = l.filter((f) => s.includes(f.type.name));
              c.ensureMarks(d);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), KPt = Ht.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((t) => ({
      tag: `h${t}`,
      attrs: { level: t }
    }));
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(t.attrs.level) ? t.attrs.level : this.options.levels[0]}`, _t(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.setNode(this.name, t) : !1,
      toggleHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.toggleNode(this.name, "paragraph", t) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((t, e) => ({
      ...t,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((t) => M7({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${t}})\\s$`),
      type: this.type,
      getAttributes: {
        level: t
      }
    }));
  }
});
var D3 = 200, Sr = function() {
};
Sr.prototype.append = function(e) {
  return e.length ? (e = Sr.from(e), !this.length && e || e.length < D3 && this.leafAppend(e) || this.length < D3 && e.leafPrepend(this) || this.appendInner(e)) : this;
};
Sr.prototype.prepend = function(e) {
  return e.length ? Sr.from(e).append(this) : this;
};
Sr.prototype.appendInner = function(e) {
  return new $Pt(this, e);
};
Sr.prototype.slice = function(e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = this.length), e >= n ? Sr.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, n));
};
Sr.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
Sr.prototype.forEach = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length), n <= r ? this.forEachInner(e, n, r, 0) : this.forEachInvertedInner(e, n, r, 0);
};
Sr.prototype.map = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length);
  var i = [];
  return this.forEach(function(a, o) {
    return i.push(e(a, o));
  }, n, r), i;
};
Sr.from = function(e) {
  return e instanceof Sr ? e : e && e.length ? new Xee(e) : Sr.empty;
};
var Xee = /* @__PURE__ */ function(t) {
  function e(r) {
    t.call(this), this.values = r;
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(i, a) {
    return i == 0 && a == this.length ? this : new e(this.values.slice(i, a));
  }, e.prototype.getInner = function(i) {
    return this.values[i];
  }, e.prototype.forEachInner = function(i, a, o, s) {
    for (var l = a; l < o; l++)
      if (i(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(i, a, o, s) {
    for (var l = a - 1; l >= o; l--)
      if (i(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(i) {
    if (this.length + i.length <= D3)
      return new e(this.values.concat(i.flatten()));
  }, e.prototype.leafPrepend = function(i) {
    if (this.length + i.length <= D3)
      return new e(i.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, n), e;
}(Sr);
Sr.empty = new Xee([]);
var $Pt = /* @__PURE__ */ function(t) {
  function e(n, r) {
    t.call(this), this.left = n, this.right = r, this.length = n.length + r.length, this.depth = Math.max(n.depth, r.depth) + 1;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, i, a, o) {
    var s = this.left.length;
    if (i < s && this.left.forEachInner(r, i, Math.min(a, s), o) === !1 || a > s && this.right.forEachInner(r, Math.max(i - s, 0), Math.min(this.length, a) - s, o + s) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, i, a, o) {
    var s = this.left.length;
    if (i > s && this.right.forEachInvertedInner(r, i - s, Math.max(a, s) - s, o + s) === !1 || a < s && this.left.forEachInvertedInner(r, Math.min(i, s), a, o) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, i) {
    if (r == 0 && i == this.length)
      return this;
    var a = this.left.length;
    return i <= a ? this.left.slice(r, i) : r >= a ? this.right.slice(r - a, i - a) : this.left.slice(r, a).append(this.right.slice(0, i - a));
  }, e.prototype.leafAppend = function(r) {
    var i = this.right.leafAppend(r);
    if (i)
      return new e(this.left, i);
  }, e.prototype.leafPrepend = function(r) {
    var i = this.left.leafPrepend(r);
    if (i)
      return new e(i, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
}(Sr);
const JPt = 500;
class Ka {
  constructor(e, n) {
    this.items = e, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, n) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let i, a;
    n && (i = this.remapping(r, this.items.length), a = i.maps.length);
    let o = e.tr, s, l, c = [], u = [];
    return this.items.forEach((d, f) => {
      if (!d.step) {
        i || (i = this.remapping(r, f + 1), a = i.maps.length), a--, u.push(d);
        return;
      }
      if (i) {
        u.push(new To(d.map));
        let h = d.step.map(i.slice(a)), p;
        h && o.maybeStep(h).doc && (p = o.mapping.maps[o.mapping.maps.length - 1], c.push(new To(p, void 0, void 0, c.length + u.length))), a--, p && i.appendMap(p, a);
      } else
        o.maybeStep(d.step);
      if (d.selection)
        return s = i ? d.selection.map(i.slice(a)) : d.selection, l = new Ka(this.items.slice(0, r).append(u.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: o, selection: s };
  }
  // Create a new branch with the given transform added.
  addTransform(e, n, r, i) {
    let a = [], o = this.eventCount, s = this.items, l = !i && s.length ? s.get(s.length - 1) : null;
    for (let u = 0; u < e.steps.length; u++) {
      let d = e.steps[u].invert(e.docs[u]), f = new To(e.mapping.maps[u], d, n), h;
      (h = l && l.merge(f)) && (f = h, u ? a.pop() : s = s.slice(0, s.length - 1)), a.push(f), n && (o++, n = void 0), i || (l = f);
    }
    let c = o - r.depth;
    return c > XPt && (s = QPt(s, c), o -= c), new Ka(s.append(a), o);
  }
  remapping(e, n) {
    let r = new Sh();
    return this.items.forEach((i, a) => {
      let o = i.mirrorOffset != null && a - i.mirrorOffset >= e ? r.maps.length - i.mirrorOffset : void 0;
      r.appendMap(i.map, o);
    }, e, n), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Ka(this.items.append(e.map((n) => new To(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, n) {
    if (!this.eventCount)
      return this;
    let r = [], i = Math.max(0, this.items.length - n), a = e.mapping, o = e.steps.length, s = this.eventCount;
    this.items.forEach((f) => {
      f.selection && s--;
    }, i);
    let l = n;
    this.items.forEach((f) => {
      let h = a.getMirror(--l);
      if (h == null)
        return;
      o = Math.min(o, h);
      let p = a.maps[h];
      if (f.step) {
        let m = e.steps[h].invert(e.docs[h]), g = f.selection && f.selection.map(a.slice(l + 1, h));
        g && s++, r.push(new To(p, m, g));
      } else
        r.push(new To(p));
    }, i);
    let c = [];
    for (let f = n; f < o; f++)
      c.push(new To(a.maps[f]));
    let u = this.items.slice(0, i).append(c).append(r), d = new Ka(u, s);
    return d.emptyItemCount() > JPt && (d = d.compress(this.items.length - r.length)), d;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((n) => {
      n.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let n = this.remapping(0, e), r = n.maps.length, i = [], a = 0;
    return this.items.forEach((o, s) => {
      if (s >= e)
        i.push(o), o.selection && a++;
      else if (o.step) {
        let l = o.step.map(n.slice(r)), c = l && l.getMap();
        if (r--, c && n.appendMap(c, r), l) {
          let u = o.selection && o.selection.map(n.slice(r));
          u && a++;
          let d = new To(c.invert(), l, u), f, h = i.length - 1;
          (f = i.length && i[h].merge(d)) ? i[h] = f : i.push(d);
        }
      } else o.map && r--;
    }, this.items.length, 0), new Ka(Sr.from(i.reverse()), a);
  }
}
Ka.empty = new Ka(Sr.empty, 0);
function QPt(t, e) {
  let n;
  return t.forEach((r, i) => {
    if (r.selection && e-- == 0)
      return n = i, !1;
  }), t.slice(n);
}
class To {
  constructor(e, n, r, i) {
    this.map = e, this.step = n, this.selection = r, this.mirrorOffset = i;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let n = e.step.merge(this.step);
      if (n)
        return new To(n.getMap().invert(), n, this.selection);
    }
  }
}
class Kl {
  constructor(e, n, r, i, a) {
    this.done = e, this.undone = n, this.prevRanges = r, this.prevTime = i, this.prevComposition = a;
  }
}
const XPt = 20;
function ezt(t, e, n, r) {
  let i = n.getMeta(Uu), a;
  if (i)
    return i.historyState;
  n.getMeta(rzt) && (t = new Kl(t.done, t.undone, null, 0, -1));
  let o = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return t;
  if (o && o.getMeta(Uu))
    return o.getMeta(Uu).redo ? new Kl(t.done.addTransform(n, void 0, r, oy(e)), t.undone, Jz(n.mapping.maps), t.prevTime, t.prevComposition) : new Kl(t.done, t.undone.addTransform(n, void 0, r, oy(e)), null, t.prevTime, t.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let s = n.getMeta("composition"), l = t.prevTime == 0 || !o && t.prevComposition != s && (t.prevTime < (n.time || 0) - r.newGroupDelay || !tzt(n, t.prevRanges)), c = o ? ab(t.prevRanges, n.mapping) : Jz(n.mapping.maps);
    return new Kl(t.done.addTransform(n, l ? e.selection.getBookmark() : void 0, r, oy(e)), Ka.empty, c, n.time, s ?? t.prevComposition);
  } else return (a = n.getMeta("rebased")) ? new Kl(t.done.rebased(n, a), t.undone.rebased(n, a), ab(t.prevRanges, n.mapping), t.prevTime, t.prevComposition) : new Kl(t.done.addMaps(n.mapping.maps), t.undone.addMaps(n.mapping.maps), ab(t.prevRanges, n.mapping), t.prevTime, t.prevComposition);
}
function tzt(t, e) {
  if (!e)
    return !1;
  if (!t.docChanged)
    return !0;
  let n = !1;
  return t.mapping.maps[0].forEach((r, i) => {
    for (let a = 0; a < e.length; a += 2)
      r <= e[a + 1] && i >= e[a] && (n = !0);
  }), n;
}
function Jz(t) {
  let e = [];
  for (let n = t.length - 1; n >= 0 && e.length == 0; n--)
    t[n].forEach((r, i, a, o) => e.push(a, o));
  return e;
}
function ab(t, e) {
  if (!t)
    return null;
  let n = [];
  for (let r = 0; r < t.length; r += 2) {
    let i = e.map(t[r], 1), a = e.map(t[r + 1], -1);
    i <= a && n.push(i, a);
  }
  return n;
}
function nzt(t, e, n) {
  let r = oy(e), i = Uu.get(e).spec.config, a = (n ? t.undone : t.done).popEvent(e, r);
  if (!a)
    return null;
  let o = a.selection.resolve(a.transform.doc), s = (n ? t.done : t.undone).addTransform(a.transform, e.selection.getBookmark(), i, r), l = new Kl(n ? s : a.remaining, n ? a.remaining : s, null, 0, -1);
  return a.transform.setSelection(o).setMeta(Uu, { redo: n, historyState: l });
}
let ob = !1, Qz = null;
function oy(t) {
  let e = t.plugins;
  if (Qz != e) {
    ob = !1, Qz = e;
    for (let n = 0; n < e.length; n++)
      if (e[n].spec.historyPreserveItems) {
        ob = !0;
        break;
      }
  }
  return ob;
}
const Uu = new tn("history"), rzt = new tn("closeHistory");
function izt(t = {}) {
  return t = {
    depth: t.depth || 100,
    newGroupDelay: t.newGroupDelay || 500
  }, new Wt({
    key: Uu,
    state: {
      init() {
        return new Kl(Ka.empty, Ka.empty, null, 0, -1);
      },
      apply(e, n, r) {
        return ezt(n, r, e, t);
      }
    },
    config: t,
    props: {
      handleDOMEvents: {
        beforeinput(e, n) {
          let r = n.inputType, i = r == "historyUndo" ? tte : r == "historyRedo" ? nte : null;
          return i ? (n.preventDefault(), i(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function ete(t, e) {
  return (n, r) => {
    let i = Uu.getState(n);
    if (!i || (t ? i.undone : i.done).eventCount == 0)
      return !1;
    if (r) {
      let a = nzt(i, n, t);
      a && r(e ? a.scrollIntoView() : a);
    }
    return !0;
  };
}
const tte = ete(!1, !0), nte = ete(!0, !0), azt = ln.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: t, dispatch: e }) => tte(t, e),
      redo: () => ({ state: t, dispatch: e }) => nte(t, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      izt(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), rte = Ht.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["hr", _t(this.options.HTMLAttributes, t)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: t, state: e }) => {
        const { selection: n } = e, { $from: r, $to: i } = n, a = t();
        return r.parentOffset === 0 ? a.insertContentAt({
          from: Math.max(r.pos - 1, 0),
          to: i.pos
        }, {
          type: this.name
        }) : HH(n) ? a.insertContentAt(i.pos, {
          type: this.name
        }) : a.insertContent({ type: this.name }), a.command(({ tr: o, dispatch: s }) => {
          var l;
          if (s) {
            const { $to: c } = o.selection, u = c.end();
            if (c.nodeAfter)
              c.nodeAfter.isTextblock ? o.setSelection(ot.create(o.doc, c.pos + 1)) : c.nodeAfter.isBlock ? o.setSelection(gt.create(o.doc, c.pos)) : o.setSelection(ot.create(o.doc, c.pos));
            else {
              const d = (l = c.parent.type.contentMatch.defaultType) === null || l === void 0 ? void 0 : l.create();
              d && (o.insert(u, d), o.setSelection(ot.create(o.doc, u + 1)));
            }
            o.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      x7({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), ozt = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, szt = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, lzt = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, czt = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, uzt = ir.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (t) => t.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["em", _t(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: t }) => t.setMark(this.name),
      toggleItalic: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetItalic: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      Yu({
        find: ozt,
        type: this.type
      }),
      Yu({
        find: lzt,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      gc({
        find: szt,
        type: this.type
      }),
      gc({
        find: czt,
        type: this.type
      })
    ];
  }
}), ite = Ht.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["li", _t(this.options.HTMLAttributes, t), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), dzt = "listItem", Xz = "textStyle", eR = /^(\d+)\.\s$/, fzt = Ht.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (t) => t.hasAttribute("start") ? parseInt(t.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: void 0,
        parseHTML: (t) => t.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    const { start: e, ...n } = t;
    return e === 1 ? ["ol", _t(this.options.HTMLAttributes, n), 0] : ["ol", _t(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(dzt, this.editor.getAttributes(Xz)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let t = O1({
      find: eR,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = O1({
      find: eR,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(Xz) }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1],
      editor: this.editor
    })), [
      t
    ];
  }
}), hzt = Ht.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["p", _t(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: t }) => t.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), pzt = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, mzt = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, yzt = ir.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["s", _t(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: t }) => t.setMark(this.name),
      toggleStrike: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetStrike: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      Yu({
        find: pzt,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      gc({
        find: mzt,
        type: this.type
      })
    ];
  }
}), gzt = Ht.create({
  name: "text",
  group: "inline"
}), vzt = Ra.create({
  name: "starterKit",
  addExtensions() {
    var t, e, n, r, i, a, o, s, l, c, u, d, f, h, p, m, g, v;
    const k = [];
    return this.options.bold !== !1 && k.push(jPt.configure((t = this.options) === null || t === void 0 ? void 0 : t.bold)), this.options.blockquote !== !1 && k.push(APt.configure((e = this.options) === null || e === void 0 ? void 0 : e.blockquote)), this.options.bulletList !== !1 && k.push(DPt.configure((n = this.options) === null || n === void 0 ? void 0 : n.bulletList)), this.options.code !== !1 && k.push(zPt.configure((r = this.options) === null || r === void 0 ? void 0 : r.code)), this.options.codeBlock !== !1 && k.push(BPt.configure((i = this.options) === null || i === void 0 ? void 0 : i.codeBlock)), this.options.document !== !1 && k.push($ee.configure((a = this.options) === null || a === void 0 ? void 0 : a.document)), this.options.dropcursor !== !1 && k.push(Jee.configure((o = this.options) === null || o === void 0 ? void 0 : o.dropcursor)), this.options.gapcursor !== !1 && k.push(Qee.configure((s = this.options) === null || s === void 0 ? void 0 : s.gapcursor)), this.options.hardBreak !== !1 && k.push(YPt.configure((l = this.options) === null || l === void 0 ? void 0 : l.hardBreak)), this.options.heading !== !1 && k.push(KPt.configure((c = this.options) === null || c === void 0 ? void 0 : c.heading)), this.options.history !== !1 && k.push(azt.configure((u = this.options) === null || u === void 0 ? void 0 : u.history)), this.options.horizontalRule !== !1 && k.push(rte.configure((d = this.options) === null || d === void 0 ? void 0 : d.horizontalRule)), this.options.italic !== !1 && k.push(uzt.configure((f = this.options) === null || f === void 0 ? void 0 : f.italic)), this.options.listItem !== !1 && k.push(ite.configure((h = this.options) === null || h === void 0 ? void 0 : h.listItem)), this.options.orderedList !== !1 && k.push(fzt.configure((p = this.options) === null || p === void 0 ? void 0 : p.orderedList)), this.options.paragraph !== !1 && k.push(hzt.configure((m = this.options) === null || m === void 0 ? void 0 : m.paragraph)), this.options.strike !== !1 && k.push(yzt.configure((g = this.options) === null || g === void 0 ? void 0 : g.strike)), this.options.text !== !1 && k.push(gzt.configure((v = this.options) === null || v === void 0 ? void 0 : v.text)), k;
  }
}), bzt = ir.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (t) => t.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["span", _t(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: t, commands: e }) => {
        const n = kx(t, this.type);
        return Object.entries(n).some(([, i]) => !!i) ? !0 : e.unsetMark(this.name);
      }
    };
  }
}), wzt = ln.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (t) => {
              var e;
              return (e = t.style.fontFamily) === null || e === void 0 ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (t) => t.fontFamily ? {
              style: `font-family: ${t.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (t) => ({ chain: e }) => e().setMark("textStyle", { fontFamily: t }).run(),
      unsetFontFamily: () => ({ chain: t }) => t().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
}), kzt = ln.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: "left"
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (t) => {
              const e = t.style.textAlign || this.options.defaultAlignment;
              return this.options.alignments.includes(e) ? e : this.options.defaultAlignment;
            },
            renderHTML: (t) => t.textAlign === this.options.defaultAlignment ? {} : { style: `text-align: ${t.textAlign}` }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (t) => ({ commands: e }) => this.options.alignments.includes(t) ? this.options.types.map((n) => e.updateAttributes(n, { textAlign: t })).every((n) => n) : !1,
      unsetTextAlign: () => ({ commands: t }) => this.options.types.map((e) => t.resetAttributes(e, "textAlign")).every((e) => e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), xzt = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", Mzt = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", md = (t, e) => {
  for (const n in e)
    t[n] = e[n];
  return t;
}, ok = "numeric", sk = "ascii", lk = "alpha", yh = "asciinumeric", Ff = "alphanumeric", ck = "domain", ate = "emoji", Czt = "scheme", Azt = "slashscheme", sb = "whitespace";
function Szt(t, e) {
  return t in e || (e[t] = []), e[t];
}
function Eu(t, e, n) {
  e[ok] && (e[yh] = !0, e[Ff] = !0), e[sk] && (e[yh] = !0, e[lk] = !0), e[yh] && (e[Ff] = !0), e[lk] && (e[Ff] = !0), e[Ff] && (e[ck] = !0), e[ate] && (e[ck] = !0);
  for (const r in e) {
    const i = Szt(r, n);
    i.indexOf(t) < 0 && i.push(t);
  }
}
function Lzt(t, e) {
  const n = {};
  for (const r in e)
    e[r].indexOf(t) >= 0 && (n[r] = !0);
  return n;
}
function Ci(t = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = t;
}
Ci.groups = {};
Ci.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(t) {
    const e = this, n = e.j[t];
    if (n)
      return n;
    for (let r = 0; r < e.jr.length; r++) {
      const i = e.jr[r][0], a = e.jr[r][1];
      if (a && i.test(t))
        return a;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(t, e = !1) {
    return e ? t in this.j : !!this.go(t);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(t, e, n, r) {
    for (let i = 0; i < t.length; i++)
      this.tt(t[i], e, n, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(t, e, n, r) {
    r = r || Ci.groups;
    let i;
    return e && e.j ? i = e : (i = new Ci(e), n && r && Eu(e, n, r)), this.jr.push([t, i]), i;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(t, e, n, r) {
    let i = this;
    const a = t.length;
    if (!a)
      return i;
    for (let o = 0; o < a - 1; o++)
      i = i.tt(t[o]);
    return i.tt(t[a - 1], e, n, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(t, e, n, r) {
    r = r || Ci.groups;
    const i = this;
    if (e && e.j)
      return i.j[t] = e, e;
    const a = e;
    let o, s = i.go(t);
    if (s ? (o = new Ci(), md(o.j, s.j), o.jr.push.apply(o.jr, s.jr), o.jd = s.jd, o.t = s.t) : o = new Ci(), a) {
      if (r)
        if (o.t && typeof o.t == "string") {
          const l = md(Lzt(o.t, r), n);
          Eu(a, l, r);
        } else n && Eu(a, n, r);
      o.t = a;
    }
    return i.j[t] = o, o;
  }
};
const Zt = (t, e, n, r, i) => t.ta(e, n, r, i), Un = (t, e, n, r, i) => t.tr(e, n, r, i), tR = (t, e, n, r, i) => t.ts(e, n, r, i), Ze = (t, e, n, r, i) => t.tt(e, n, r, i), Ds = "WORD", uk = "UWORD", ote = "ASCIINUMERICAL", ste = "ALPHANUMERICAL", Z2 = "LOCALHOST", dk = "TLD", fk = "UTLD", sy = "SCHEME", Q0 = "SLASH_SCHEME", iL = "NUM", hk = "WS", aL = "NL", gh = "OPENBRACE", vh = "CLOSEBRACE", I3 = "OPENBRACKET", P3 = "CLOSEBRACKET", z3 = "OPENPAREN", R3 = "CLOSEPAREN", O3 = "OPENANGLEBRACKET", B3 = "CLOSEANGLEBRACKET", H3 = "FULLWIDTHLEFTPAREN", F3 = "FULLWIDTHRIGHTPAREN", _3 = "LEFTCORNERBRACKET", V3 = "RIGHTCORNERBRACKET", q3 = "LEFTWHITECORNERBRACKET", U3 = "RIGHTWHITECORNERBRACKET", W3 = "FULLWIDTHLESSTHAN", Z3 = "FULLWIDTHGREATERTHAN", G3 = "AMPERSAND", oL = "APOSTROPHE", Y3 = "ASTERISK", $l = "AT", K3 = "BACKSLASH", $3 = "BACKTICK", J3 = "CARET", ec = "COLON", sL = "COMMA", Q3 = "DOLLAR", Eo = "DOT", X3 = "EQUALS", lL = "EXCLAMATION", va = "HYPHEN", bh = "PERCENT", eg = "PIPE", tg = "PLUS", ng = "POUND", wh = "QUERY", cL = "QUOTE", lte = "FULLWIDTHMIDDLEDOT", uL = "SEMI", jo = "SLASH", kh = "TILDE", rg = "UNDERSCORE", cte = "EMOJI", ig = "SYM";
var ute = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: Ds,
  UWORD: uk,
  ASCIINUMERICAL: ote,
  ALPHANUMERICAL: ste,
  LOCALHOST: Z2,
  TLD: dk,
  UTLD: fk,
  SCHEME: sy,
  SLASH_SCHEME: Q0,
  NUM: iL,
  WS: hk,
  NL: aL,
  OPENBRACE: gh,
  CLOSEBRACE: vh,
  OPENBRACKET: I3,
  CLOSEBRACKET: P3,
  OPENPAREN: z3,
  CLOSEPAREN: R3,
  OPENANGLEBRACKET: O3,
  CLOSEANGLEBRACKET: B3,
  FULLWIDTHLEFTPAREN: H3,
  FULLWIDTHRIGHTPAREN: F3,
  LEFTCORNERBRACKET: _3,
  RIGHTCORNERBRACKET: V3,
  LEFTWHITECORNERBRACKET: q3,
  RIGHTWHITECORNERBRACKET: U3,
  FULLWIDTHLESSTHAN: W3,
  FULLWIDTHGREATERTHAN: Z3,
  AMPERSAND: G3,
  APOSTROPHE: oL,
  ASTERISK: Y3,
  AT: $l,
  BACKSLASH: K3,
  BACKTICK: $3,
  CARET: J3,
  COLON: ec,
  COMMA: sL,
  DOLLAR: Q3,
  DOT: Eo,
  EQUALS: X3,
  EXCLAMATION: lL,
  HYPHEN: va,
  PERCENT: bh,
  PIPE: eg,
  PLUS: tg,
  POUND: ng,
  QUERY: wh,
  QUOTE: cL,
  FULLWIDTHMIDDLEDOT: lte,
  SEMI: uL,
  SLASH: jo,
  TILDE: kh,
  UNDERSCORE: rg,
  EMOJI: cte,
  SYM: ig
});
const Es = /[a-z]/, Sf = new RegExp("\\p{L}", "u"), lb = new RegExp("\\p{Emoji}", "u"), js = /\d/, cb = /\s/, nR = "\r", ub = `
`, Tzt = "️", Ezt = "‍", db = "￼";
let d4 = null, f4 = null;
function jzt(t = []) {
  const e = {};
  Ci.groups = e;
  const n = new Ci();
  d4 == null && (d4 = rR(xzt)), f4 == null && (f4 = rR(Mzt)), Ze(n, "'", oL), Ze(n, "{", gh), Ze(n, "}", vh), Ze(n, "[", I3), Ze(n, "]", P3), Ze(n, "(", z3), Ze(n, ")", R3), Ze(n, "<", O3), Ze(n, ">", B3), Ze(n, "（", H3), Ze(n, "）", F3), Ze(n, "「", _3), Ze(n, "」", V3), Ze(n, "『", q3), Ze(n, "』", U3), Ze(n, "＜", W3), Ze(n, "＞", Z3), Ze(n, "&", G3), Ze(n, "*", Y3), Ze(n, "@", $l), Ze(n, "`", $3), Ze(n, "^", J3), Ze(n, ":", ec), Ze(n, ",", sL), Ze(n, "$", Q3), Ze(n, ".", Eo), Ze(n, "=", X3), Ze(n, "!", lL), Ze(n, "-", va), Ze(n, "%", bh), Ze(n, "|", eg), Ze(n, "+", tg), Ze(n, "#", ng), Ze(n, "?", wh), Ze(n, '"', cL), Ze(n, "/", jo), Ze(n, ";", uL), Ze(n, "~", kh), Ze(n, "_", rg), Ze(n, "\\", K3), Ze(n, "・", lte);
  const r = Un(n, js, iL, {
    [ok]: !0
  });
  Un(r, js, r);
  const i = Un(r, Es, ote, {
    [yh]: !0
  }), a = Un(r, Sf, ste, {
    [Ff]: !0
  }), o = Un(n, Es, Ds, {
    [sk]: !0
  });
  Un(o, js, i), Un(o, Es, o), Un(i, js, i), Un(i, Es, i);
  const s = Un(n, Sf, uk, {
    [lk]: !0
  });
  Un(s, Es), Un(s, js, a), Un(s, Sf, s), Un(a, js, a), Un(a, Es), Un(a, Sf, a);
  const l = Ze(n, ub, aL, {
    [sb]: !0
  }), c = Ze(n, nR, hk, {
    [sb]: !0
  }), u = Un(n, cb, hk, {
    [sb]: !0
  });
  Ze(n, db, u), Ze(c, ub, l), Ze(c, db, u), Un(c, cb, u), Ze(u, nR), Ze(u, ub), Un(u, cb, u), Ze(u, db, u);
  const d = Un(n, lb, cte, {
    [ate]: !0
  });
  Ze(d, "#"), Un(d, lb, d), Ze(d, Tzt, d);
  const f = Ze(d, Ezt);
  Ze(f, "#"), Un(f, lb, d);
  const h = [[Es, o], [js, i]], p = [[Es, null], [Sf, s], [js, a]];
  for (let m = 0; m < d4.length; m++)
    Ol(n, d4[m], dk, Ds, h);
  for (let m = 0; m < f4.length; m++)
    Ol(n, f4[m], fk, uk, p);
  Eu(dk, {
    tld: !0,
    ascii: !0
  }, e), Eu(fk, {
    utld: !0,
    alpha: !0
  }, e), Ol(n, "file", sy, Ds, h), Ol(n, "mailto", sy, Ds, h), Ol(n, "http", Q0, Ds, h), Ol(n, "https", Q0, Ds, h), Ol(n, "ftp", Q0, Ds, h), Ol(n, "ftps", Q0, Ds, h), Eu(sy, {
    scheme: !0,
    ascii: !0
  }, e), Eu(Q0, {
    slashscheme: !0,
    ascii: !0
  }, e), t = t.sort((m, g) => m[0] > g[0] ? 1 : -1);
  for (let m = 0; m < t.length; m++) {
    const g = t[m][0], k = t[m][1] ? {
      [Czt]: !0
    } : {
      [Azt]: !0
    };
    g.indexOf("-") >= 0 ? k[ck] = !0 : Es.test(g) ? js.test(g) ? k[yh] = !0 : k[sk] = !0 : k[ok] = !0, tR(n, g, g, k);
  }
  return tR(n, "localhost", Z2, {
    ascii: !0
  }), n.jd = new Ci(ig), {
    start: n,
    tokens: md({
      groups: e
    }, ute)
  };
}
function dte(t, e) {
  const n = Nzt(e.replace(/[A-Z]/g, (s) => s.toLowerCase())), r = n.length, i = [];
  let a = 0, o = 0;
  for (; o < r; ) {
    let s = t, l = null, c = 0, u = null, d = -1, f = -1;
    for (; o < r && (l = s.go(n[o])); )
      s = l, s.accepts() ? (d = 0, f = 0, u = s) : d >= 0 && (d += n[o].length, f++), c += n[o].length, a += n[o].length, o++;
    a -= d, o -= f, c -= d, i.push({
      t: u.t,
      // token type/name
      v: e.slice(a - c, a),
      // string value
      s: a - c,
      // start index
      e: a
      // end index (excluding)
    });
  }
  return i;
}
function Nzt(t) {
  const e = [], n = t.length;
  let r = 0;
  for (; r < n; ) {
    let i = t.charCodeAt(r), a, o = i < 55296 || i > 56319 || r + 1 === n || (a = t.charCodeAt(r + 1)) < 56320 || a > 57343 ? t[r] : t.slice(r, r + 2);
    e.push(o), r += o.length;
  }
  return e;
}
function Ol(t, e, n, r, i) {
  let a;
  const o = e.length;
  for (let s = 0; s < o - 1; s++) {
    const l = e[s];
    t.j[l] ? a = t.j[l] : (a = new Ci(r), a.jr = i.slice(), t.j[l] = a), t = a;
  }
  return a = new Ci(n), a.jr = i.slice(), t.j[e[o - 1]] = a, a;
}
function rR(t) {
  const e = [], n = [];
  let r = 0, i = "0123456789";
  for (; r < t.length; ) {
    let a = 0;
    for (; i.indexOf(t[r + a]) >= 0; )
      a++;
    if (a > 0) {
      e.push(n.join(""));
      for (let o = parseInt(t.substring(r, r + a), 10); o > 0; o--)
        n.pop();
      r += a;
    } else
      n.push(t[r]), r++;
  }
  return e;
}
const G2 = {
  defaultProtocol: "http",
  events: null,
  format: iR,
  formatHref: iR,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function dL(t, e = null) {
  let n = md({}, G2);
  t && (n = md(n, t instanceof dL ? t.o : t));
  const r = n.ignoreTags, i = [];
  for (let a = 0; a < r.length; a++)
    i.push(r[a].toUpperCase());
  this.o = n, e && (this.defaultRender = e), this.ignoreTags = i;
}
dL.prototype = {
  o: G2,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(t) {
    return t;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(t) {
    return this.get("validate", t.toString(), t);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(t, e, n) {
    const r = e != null;
    let i = this.o[t];
    return i && (typeof i == "object" ? (i = n.t in i ? i[n.t] : G2[t], typeof i == "function" && r && (i = i(e, n))) : typeof i == "function" && r && (i = i(e, n.t, n)), i);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(t, e, n) {
    let r = this.o[t];
    return typeof r == "function" && e != null && (r = r(e, n.t, n)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(t) {
    const e = t.render(this);
    return (this.get("render", null, t) || this.defaultRender)(e, t.t, t);
  }
};
function iR(t) {
  return t;
}
function fte(t, e) {
  this.t = "token", this.v = t, this.tk = e;
}
fte.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(t) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(t) {
    const e = this.toString(), n = t.get("truncate", e, this), r = t.get("format", e, this);
    return n && r.length > n ? r.substring(0, n) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(t) {
    return t.get("formatHref", this.toHref(t.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(t = G2.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(t) {
    return {
      type: this.t,
      value: this.toFormattedString(t),
      isLink: this.isLink,
      href: this.toFormattedHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(t) {
    return t.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(t) {
    const e = this, n = this.toHref(t.get("defaultProtocol")), r = t.get("formatHref", n, this), i = t.get("tagName", n, e), a = this.toFormattedString(t), o = {}, s = t.get("className", n, e), l = t.get("target", n, e), c = t.get("rel", n, e), u = t.getObj("attributes", n, e), d = t.getObj("events", n, e);
    return o.href = r, s && (o.class = s), l && (o.target = l), c && (o.rel = c), u && md(o, u), {
      tagName: i,
      attributes: o,
      content: a,
      eventListeners: d
    };
  }
};
function k5(t, e) {
  class n extends fte {
    constructor(i, a) {
      super(i, a), this.t = t;
    }
  }
  for (const r in e)
    n.prototype[r] = e[r];
  return n.t = t, n;
}
const aR = k5("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), oR = k5("text"), Dzt = k5("nl"), h4 = k5("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(t = G2.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${t}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const t = this.tk;
    return t.length >= 2 && t[0].t !== Z2 && t[1].t === ec;
  }
}), ma = (t) => new Ci(t);
function Izt({
  groups: t
}) {
  const e = t.domain.concat([G3, Y3, $l, K3, $3, J3, Q3, X3, va, iL, bh, eg, tg, ng, jo, ig, kh, rg]), n = [ec, sL, Eo, lL, bh, wh, cL, uL, O3, B3, gh, vh, P3, I3, z3, R3, H3, F3, _3, V3, q3, U3, W3, Z3], r = [G3, oL, Y3, K3, $3, J3, Q3, X3, va, gh, vh, bh, eg, tg, ng, wh, jo, ig, kh, rg], i = ma(), a = Ze(i, kh);
  Zt(a, r, a), Zt(a, t.domain, a);
  const o = ma(), s = ma(), l = ma();
  Zt(i, t.domain, o), Zt(i, t.scheme, s), Zt(i, t.slashscheme, l), Zt(o, r, a), Zt(o, t.domain, o);
  const c = Ze(o, $l);
  Ze(a, $l, c), Ze(s, $l, c), Ze(l, $l, c);
  const u = Ze(a, Eo);
  Zt(u, r, a), Zt(u, t.domain, a);
  const d = ma();
  Zt(c, t.domain, d), Zt(d, t.domain, d);
  const f = Ze(d, Eo);
  Zt(f, t.domain, d);
  const h = ma(aR);
  Zt(f, t.tld, h), Zt(f, t.utld, h), Ze(c, Z2, h);
  const p = Ze(d, va);
  Ze(p, va, p), Zt(p, t.domain, d), Zt(h, t.domain, d), Ze(h, Eo, f), Ze(h, va, p);
  const m = Ze(h, ec);
  Zt(m, t.numeric, aR);
  const g = Ze(o, va), v = Ze(o, Eo);
  Ze(g, va, g), Zt(g, t.domain, o), Zt(v, r, a), Zt(v, t.domain, o);
  const k = ma(h4);
  Zt(v, t.tld, k), Zt(v, t.utld, k), Zt(k, t.domain, o), Zt(k, r, a), Ze(k, Eo, v), Ze(k, va, g), Ze(k, $l, c);
  const w = Ze(k, ec), b = ma(h4);
  Zt(w, t.numeric, b);
  const x = ma(h4), A = ma();
  Zt(x, e, x), Zt(x, n, A), Zt(A, e, x), Zt(A, n, A), Ze(k, jo, x), Ze(b, jo, x);
  const L = Ze(s, ec), M = Ze(l, ec), j = Ze(M, jo), D = Ze(j, jo);
  Zt(s, t.domain, o), Ze(s, Eo, v), Ze(s, va, g), Zt(l, t.domain, o), Ze(l, Eo, v), Ze(l, va, g), Zt(L, t.domain, x), Ze(L, jo, x), Ze(L, wh, x), Zt(D, t.domain, x), Zt(D, e, x), Ze(D, jo, x);
  const z = [
    [gh, vh],
    // {}
    [I3, P3],
    // []
    [z3, R3],
    // ()
    [O3, B3],
    // <>
    [H3, F3],
    // （）
    [_3, V3],
    // 「」
    [q3, U3],
    // 『』
    [W3, Z3]
    // ＜＞
  ];
  for (let H = 0; H < z.length; H++) {
    const [V, F] = z[H], _ = Ze(x, V);
    Ze(A, V, _), Ze(_, F, x);
    const W = ma(h4);
    Zt(_, e, W);
    const G = ma();
    Zt(_, n), Zt(W, e, W), Zt(W, n, G), Zt(G, e, W), Zt(G, n, G), Ze(W, F, x), Ze(G, F, x);
  }
  return Ze(i, Z2, k), Ze(i, aL, Dzt), {
    start: i,
    tokens: ute
  };
}
function Pzt(t, e, n) {
  let r = n.length, i = 0, a = [], o = [];
  for (; i < r; ) {
    let s = t, l = null, c = null, u = 0, d = null, f = -1;
    for (; i < r && !(l = s.go(n[i].t)); )
      o.push(n[i++]);
    for (; i < r && (c = l || s.go(n[i].t)); )
      l = null, s = c, s.accepts() ? (f = 0, d = s) : f >= 0 && f++, i++, u++;
    if (f < 0)
      i -= u, i < r && (o.push(n[i]), i++);
    else {
      o.length > 0 && (a.push(fb(oR, e, o)), o = []), i -= f, u -= f;
      const h = d.t, p = n.slice(i - u, i);
      a.push(fb(h, e, p));
    }
  }
  return o.length > 0 && a.push(fb(oR, e, o)), a;
}
function fb(t, e, n) {
  const r = n[0].s, i = n[n.length - 1].e, a = e.slice(r, i);
  return new t(a, n);
}
const zzt = typeof console < "u" && console && console.warn || (() => {
}), Rzt = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", Cn = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function Ozt() {
  return Ci.groups = {}, Cn.scanner = null, Cn.parser = null, Cn.tokenQueue = [], Cn.pluginQueue = [], Cn.customSchemes = [], Cn.initialized = !1, Cn;
}
function sR(t, e = !1) {
  if (Cn.initialized && zzt(`linkifyjs: already initialized - will not register custom scheme "${t}" ${Rzt}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(t))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  Cn.customSchemes.push([t, e]);
}
function Bzt() {
  Cn.scanner = jzt(Cn.customSchemes);
  for (let t = 0; t < Cn.tokenQueue.length; t++)
    Cn.tokenQueue[t][1]({
      scanner: Cn.scanner
    });
  Cn.parser = Izt(Cn.scanner.tokens);
  for (let t = 0; t < Cn.pluginQueue.length; t++)
    Cn.pluginQueue[t][1]({
      scanner: Cn.scanner,
      parser: Cn.parser
    });
  return Cn.initialized = !0, Cn;
}
function fL(t) {
  return Cn.initialized || Bzt(), Pzt(Cn.parser.start, t, dte(Cn.scanner.start, t));
}
fL.scan = dte;
function hte(t, e = null, n = null) {
  if (e && typeof e == "object") {
    if (n)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    n = e, e = null;
  }
  const r = new dL(n), i = fL(t), a = [];
  for (let o = 0; o < i.length; o++) {
    const s = i[o];
    s.isLink && (!e || s.t === e) && r.check(s) && a.push(s.toFormattedObject(r));
  }
  return a;
}
function Hzt(t) {
  return t.length === 1 ? t[0].isLink : t.length === 3 && t[1].isLink ? ["()", "[]"].includes(t[0].value + t[2].value) : !1;
}
function Fzt(t) {
  return new Wt({
    key: new tn("autolink"),
    appendTransaction: (e, n, r) => {
      const i = e.some((c) => c.docChanged) && !n.doc.eq(r.doc), a = e.some((c) => c.getMeta("preventAutolink"));
      if (!i || a)
        return;
      const { tr: o } = r, s = wse(n.doc, [...e]);
      if (Lse(s).forEach(({ newRange: c }) => {
        const u = xse(r.doc, c, (h) => h.isTextblock);
        let d, f;
        if (u.length > 1 ? (d = u[0], f = r.doc.textBetween(d.pos, d.pos + d.node.nodeSize, void 0, " ")) : u.length && r.doc.textBetween(c.from, c.to, " ", " ").endsWith(" ") && (d = u[0], f = r.doc.textBetween(d.pos, c.to, void 0, " ")), d && f) {
          const h = f.split(" ").filter((v) => v !== "");
          if (h.length <= 0)
            return !1;
          const p = h[h.length - 1], m = d.pos + f.lastIndexOf(p);
          if (!p)
            return !1;
          const g = fL(p).map((v) => v.toObject(t.defaultProtocol));
          if (!Hzt(g))
            return !1;
          g.filter((v) => v.isLink).map((v) => ({
            ...v,
            from: m + v.start + 1,
            to: m + v.end + 1
          })).filter((v) => r.schema.marks.code ? !r.doc.rangeHasMark(v.from, v.to, r.schema.marks.code) : !0).filter((v) => t.validate(v.value)).forEach((v) => {
            Ax(v.from, v.to, r.doc).some((k) => k.mark.type === t.type) || o.addMark(v.from, v.to, t.type.create({
              href: v.href
            }));
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function _zt(t) {
  return new Wt({
    key: new tn("handleClickLink"),
    props: {
      handleClick: (e, n, r) => {
        var i, a;
        if (r.button !== 0 || !e.editable)
          return !1;
        let o = r.target;
        const s = [];
        for (; o.nodeName !== "DIV"; )
          s.push(o), o = o.parentNode;
        if (!s.find((f) => f.nodeName === "A"))
          return !1;
        const l = BH(e.state, t.type.name), c = r.target, u = (i = c == null ? void 0 : c.href) !== null && i !== void 0 ? i : l.href, d = (a = c == null ? void 0 : c.target) !== null && a !== void 0 ? a : l.target;
        return c && u ? (window.open(u, d), !0) : !1;
      }
    }
  });
}
function Vzt(t) {
  return new Wt({
    key: new tn("handlePasteLink"),
    props: {
      handlePaste: (e, n, r) => {
        const { state: i } = e, { selection: a } = i, { empty: o } = a;
        if (o)
          return !1;
        let s = "";
        r.content.forEach((c) => {
          s += c.textContent;
        });
        const l = hte(s, { defaultProtocol: t.defaultProtocol }).find((c) => c.isLink && c.value === s);
        return !s || !l ? !1 : (t.editor.commands.setMark(t.type, {
          href: l.href
        }), !0);
      }
    }
  });
}
const qzt = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g;
function lR(t, e) {
  const n = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  return e && e.forEach((r) => {
    const i = typeof r == "string" ? r : r.scheme;
    i && n.push(i);
  }), !t || t.replace(qzt, "").match(new RegExp(`^(?:(?:${n.join("|")}):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))`, "i"));
}
const Uzt = ir.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.protocols.forEach((t) => {
      if (typeof t == "string") {
        sR(t);
        return;
      }
      sR(t.scheme, t.optionalSlashes);
    });
  },
  onDestroy() {
    Ozt();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      validate: (t) => !!t
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(t) {
          return t.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [{
      tag: "a[href]",
      getAttrs: (t) => {
        const e = t.getAttribute("href");
        return !e || !lR(e, this.options.protocols) ? !1 : null;
      }
    }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return lR(t.href, this.options.protocols) ? ["a", _t(this.options.HTMLAttributes, t), 0] : ["a", _t(this.options.HTMLAttributes, { ...t, href: "" }), 0];
  },
  addCommands() {
    return {
      setLink: (t) => ({ chain: e }) => e().setMark(this.name, t).setMeta("preventAutolink", !0).run(),
      toggleLink: (t) => ({ chain: e }) => e().toggleMark(this.name, t, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run(),
      unsetLink: () => ({ chain: t }) => t().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      gc({
        find: (t) => {
          const e = [];
          if (t) {
            const { validate: n } = this.options, r = hte(t).filter((i) => i.isLink && n(i.value));
            r.length && r.forEach((i) => e.push({
              text: i.value,
              data: {
                href: i.href
              },
              index: i.start
            }));
          }
          return e;
        },
        type: this.type,
        getAttributes: (t) => {
          var e;
          return {
            href: (e = t.data) === null || e === void 0 ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const t = [];
    return this.options.autolink && t.push(Fzt({
      type: this.type,
      defaultProtocol: this.options.defaultProtocol,
      validate: this.options.validate
    })), this.options.openOnClick === !0 && t.push(_zt({
      type: this.type
    })), this.options.linkOnPaste && t.push(Vzt({
      editor: this.editor,
      defaultProtocol: this.options.defaultProtocol,
      type: this.type
    })), t;
  }
}), Wzt = ln.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new Wt({
        key: new tn("placeholder"),
        props: {
          decorations: ({ doc: t, selection: e }) => {
            const n = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: r } = e, i = [];
            if (!n)
              return null;
            const a = this.editor.isEmpty;
            return t.descendants((o, s) => {
              const l = r >= s && r <= s + o.nodeSize, c = !o.isLeaf && jg(o);
              if ((l || !this.options.showOnlyCurrent) && c) {
                const u = [this.options.emptyNodeClass];
                a && u.push(this.options.emptyEditorClass);
                const d = hr.node(s, s + o.nodeSize, {
                  class: u.join(" "),
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: o,
                    pos: s,
                    hasAnchor: l
                  }) : this.options.placeholder
                });
                i.push(d);
              }
              return this.options.includeChildren;
            }), vn.create(t, i);
          }
        }
      })
    ];
  }
}), Zzt = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/, Gzt = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g, Yzt = ir.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        parseHTML: (t) => t.getAttribute("data-color") || t.style.backgroundColor,
        renderHTML: (t) => t.color ? {
          "data-color": t.color,
          style: `background-color: ${t.color}; color: inherit`
        } : {}
      }
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["mark", _t(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setHighlight: (t) => ({ commands: e }) => e.setMark(this.name, t),
      toggleHighlight: (t) => ({ commands: e }) => e.toggleMark(this.name, t),
      unsetHighlight: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      Yu({
        find: Zzt,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      gc({
        find: Gzt,
        type: this.type
      })
    ];
  }
}), Kzt = Ht.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", _t(this.options.HTMLAttributes, t, { "data-type": this.name }), 0];
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: t }) => t.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
}), $zt = /^\s*(\[([( |x])?\])\s$/, Jzt = Ht.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList"
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (t) => {
          const e = t.getAttribute("data-checked");
          return e === "" || e === "true";
        },
        renderHTML: (t) => ({
          "data-checked": t.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "li",
      _t(this.options.HTMLAttributes, e, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: t.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  addKeyboardShortcuts() {
    const t = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...t,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : t;
  },
  addNodeView() {
    return ({ node: t, HTMLAttributes: e, getPos: n, editor: r }) => {
      const i = document.createElement("li"), a = document.createElement("label"), o = document.createElement("span"), s = document.createElement("input"), l = document.createElement("div");
      return a.contentEditable = "false", s.type = "checkbox", s.addEventListener("mousedown", (c) => c.preventDefault()), s.addEventListener("change", (c) => {
        if (!r.isEditable && !this.options.onReadOnlyChecked) {
          s.checked = !s.checked;
          return;
        }
        const { checked: u } = c.target;
        r.isEditable && typeof n == "function" && r.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: d }) => {
          const f = n();
          if (typeof f != "number")
            return !1;
          const h = d.doc.nodeAt(f);
          return d.setNodeMarkup(f, void 0, {
            ...h == null ? void 0 : h.attrs,
            checked: u
          }), !0;
        }).run(), !r.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(t, u) || (s.checked = !s.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([c, u]) => {
        i.setAttribute(c, u);
      }), i.dataset.checked = t.attrs.checked, t.attrs.checked && s.setAttribute("checked", "checked"), a.append(s, o), i.append(a, l), Object.entries(e).forEach(([c, u]) => {
        i.setAttribute(c, u);
      }), {
        dom: i,
        contentDOM: l,
        update: (c) => c.type !== this.type ? !1 : (i.dataset.checked = c.attrs.checked, c.attrs.checked ? s.setAttribute("checked", "checked") : s.removeAttribute("checked"), !0)
      };
    };
  },
  addInputRules() {
    return [
      O1({
        find: $zt,
        type: this.type,
        getAttributes: (t) => ({
          checked: t[t.length - 1] === "x"
        })
      })
    ];
  }
}), Qzt = ir.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["u", _t(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: t }) => t.setMark(this.name),
      toggleUnderline: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetUnderline: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), Xzt = rte.extend({
  renderHTML() {
    return [
      "div",
      _t(this.options.HTMLAttributes, { "data-type": this.name }),
      ["hr"]
    ];
  }
}), eRt = ln.create({
  name: "columnExtension",
  addExtensions() {
    const t = [];
    return this.options.column !== !1 && t.push(OJ), this.options.columns !== !1 && t.push(c3), t;
  }
}), tRt = ln.create({
  name: "CustomKeymap",
  addCommands() {
    return {
      selectTextWithinNodeBoundaries: () => ({ editor: t, commands: e }) => {
        const { state: n } = t, { tr: r } = n, i = r.selection.$from.start(), a = r.selection.$to.end();
        return e.setTextSelection({
          from: i,
          to: a
        });
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-a": ({ editor: t }) => {
        const { state: e } = t, { tr: n } = e, r = n.selection.from, i = n.selection.to, a = n.selection.$from.start(), o = n.selection.$to.end();
        return r > a || i < o ? (t.chain().selectTextWithinNodeBoundaries().run(), !0) : !1;
      }
    };
  }
}), nRt = ln.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (t) => {
              var e;
              return (e = t.style.color) === null || e === void 0 ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (t) => t.color ? {
              style: `color: ${t.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (t) => ({ chain: e }) => e().setMark("textStyle", { color: t }).run(),
      unsetColor: () => ({ chain: t }) => t().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), cR = [
  {
    tooltip: "Align left",
    action: (t) => t({
      dataAlign: "start",
      dataFloat: null
    }),
    icon: "AlignLeft",
    isActive: (t) => t.dataAlign === "start"
  },
  {
    tooltip: "Align center",
    action: (t) => t({
      dataAlign: "center",
      dataFloat: null
    }),
    icon: "AlignCenter",
    isActive: (t) => t.dataAlign === "center"
  },
  {
    tooltip: "Align right",
    action: (t) => t({
      dataAlign: "end",
      dataFloat: null
    }),
    icon: "AlignRight",
    isActive: (t) => t.dataAlign === "end"
  },
  {
    tooltip: "Add Caption",
    icon: "Captions",
    action: (t) => t({ showCaptionInput: !0 }),
    isActive: (t) => t.showCaptionInput === !0
  },
  {
    tooltip: "Delete",
    icon: "Trash2",
    delete: (t) => t()
  }
], rRt = en(
  ({
    encryptedKey: t,
    url: e,
    iv: n,
    privateKey: r,
    alt: i,
    // caption,
    className: a,
    width: o,
    height: s
  }, l) => {
    const [c, u] = De("");
    return ze(() => {
      const d = t && e && n && r;
      let f = !0, h = null;
      return d && (async () => {
        try {
          const m = await vY(e);
          if (!m || !f) return;
          const g = await bY({
            encryptedKey: t,
            privateKey: NC(r),
            iv: n,
            imageBuffer: m
          });
          if (!f || !g) return;
          const v = new Blob([g], {
            type: "image/jpeg"
          });
          h = URL.createObjectURL(v), f && u(h);
        } catch (m) {
          console.error("Error decrypting image:", m);
        }
      })(), () => {
        f = !1, h && URL.revokeObjectURL(h);
      };
    }, [t, e, n, r]), /* @__PURE__ */ C.jsx(
      "img",
      {
        src: c,
        alt: i,
        className: a,
        width: o,
        height: s,
        ref: l
      }
    );
  }
);
let W0;
const pte = ({
  node: t,
  updateAttributes: e,
  deleteNode: n
}) => {
  const { isPreviewMode: r } = Zp(), [i, a] = De(), [o, s] = De(0), [l, c] = De(0), [u, d] = De({}), f = Ue(null), [h, p] = De(!1), [m, g] = De(!1), [v, k] = De(null), w = Ue(null), b = () => {
    const oe = {};
    cR.forEach(({ tooltip: ee, isActive: ae }) => {
      oe[ee] = !!(ae != null && ae(t.attrs));
    }), d(oe);
  }, x = () => {
    const oe = document.querySelector(".ProseMirror");
    if (oe && c(oe == null ? void 0 : oe.clientWidth), !!f.current) {
      if (i === "video") {
        const ee = f.current;
        ee.addEventListener("loadeddata", function() {
          s(ee.videoWidth / ee.videoHeight), z("left", 0);
        });
      } else if (i === "iframe") {
        const ee = f.current;
        ee.onload = () => {
          s(ee.offsetWidth / ee.offsetHeight), z("left", 0);
        };
      } else
        f.current.onload = () => {
          s(
            f.current.naturalWidth / f.current.naturalHeight
          );
        };
      setTimeout(() => b(), 200);
    }
  }, A = (oe) => {
    W0 = oe;
  };
  ze(() => {
    x();
  }, []);
  const L = ({ width: oe, height: ee }) => oe < 200 || ee < 200, M = (oe) => {
    const ee = "touches" in oe ? oe.touches[0].clientX : oe.clientX;
    setTimeout(() => H(ee));
  }, j = (oe) => {
    oe.stopPropagation(), W0 = "touches" in oe ? oe.touches[0].clientX : oe.clientX, setTimeout(() => {
      document.addEventListener("mousemove", M), document.addEventListener("mouseup", D), document.addEventListener("touchmove", M), document.addEventListener("touchend", D);
    }), p(!0);
  }, D = () => {
    W0 = -1, document.removeEventListener("mousemove", M), document.removeEventListener("mouseup", D), p(!1);
  }, z = (oe, ee) => {
    var ge, $;
    if (!f.current) {
      console.error("Media ref is undefined|null", {
        resizableImg: f.current
      });
      return;
    }
    const ae = {
      width: (ge = f.current) == null ? void 0 : ge.width,
      height: ($ = f.current) == null ? void 0 : $.height
    }, fe = {
      width: -1,
      height: -1
    };
    let me = parseFloat(ae.width.toString());
    if (isNaN(me) && (me = 0), oe === "left" ? fe.width = me - Math.abs(ee) : fe.width = me + Math.abs(ee), fe.width > l && (fe.width = l), i === "iframe")
      fe.height = fe.width / (16 / 9);
    else {
      const se = isNaN(o) ? 1 : o;
      fe.height = fe.width / se;
    }
    fe.width = isNaN(fe.width) ? 0 : fe.width, fe.height = isNaN(fe.height) ? 0 : fe.height, !L(fe) && e(fe);
  }, H = (oe) => {
    if (W0 === -1) return;
    const ee = W0 - oe;
    if (ee === 0) return;
    const ae = ee > 0 ? "left" : "right";
    setTimeout(() => {
      z(ae, Math.abs(ee)), W0 = oe;
    });
  }, [V, F] = De(), [_, W] = De();
  ze(() => {
    a(t.attrs["media-type"]), b(), F(t.attrs.dataFloat), W(t.attrs.dataAlign);
  }, [t.attrs]);
  const G = (oe) => {
    oe.stopPropagation(), w.current = {
      x: oe.touches[0].clientX,
      y: oe.touches[0].clientY
    };
    const ee = setTimeout(() => {
      g(!0);
    }, 500);
    k(ee);
  }, Y = (oe) => {
    if (!m) {
      v && (clearTimeout(v), k(null));
      return;
    }
    oe.preventDefault(), oe.stopPropagation();
  }, Z = () => {
    v && (clearTimeout(v), k(null)), g(!1), w.current = null;
  };
  return ze(() => () => {
    v && clearTimeout(v);
  }, [v]), /* @__PURE__ */ C.jsx(
    $u,
    {
      as: "article",
      className: Lt(
        "media-node-view not-prose transition-all ease-in-out w-full",
        V && `f-${t.attrs.dataFloat}`,
        _ && `justify-${t.attrs.dataAlign}`
      ),
      children: /* @__PURE__ */ C.jsxs(
        "div",
        {
          draggable: m,
          "data-drag-handle": m,
          className: Lt(
            "w-fit flex flex-col relative group transition-all ease-in-out",
            m && "opacity-50"
          ),
          onTouchStart: G,
          onTouchMove: Y,
          onTouchEnd: Z,
          onTouchCancel: Z,
          children: [
            /* @__PURE__ */ C.jsxs(
              "div",
              {
                className: Lt(
                  "relative",
                  t.attrs.dataAlign === "start" && "self-start",
                  t.attrs.dataAlign === "center" && "self-center",
                  t.attrs.dataAlign === "end" && "self-end"
                ),
                children: [
                  i === "img" && /* @__PURE__ */ C.jsx(
                    "img",
                    {
                      src: t.attrs.src,
                      ref: f,
                      className: "rounded-lg",
                      alt: t.attrs.src,
                      width: t.attrs.width,
                      height: t.attrs.height
                    }
                  ),
                  i === "secure-img" && /* @__PURE__ */ C.jsx(
                    rRt,
                    {
                      encryptedKey: t.attrs.encryptedKey,
                      url: t.attrs.url,
                      iv: t.attrs.iv,
                      privateKey: t.attrs.privateKey,
                      alt: t.attrs.alt,
                      className: "rounded-lg",
                      width: t.attrs.width,
                      height: t.attrs.height,
                      ref: f
                    }
                  ),
                  i === "video" && /* @__PURE__ */ C.jsx(
                    "video",
                    {
                      ref: f,
                      className: "rounded-lg",
                      controls: !0,
                      width: t.attrs.width,
                      height: t.attrs.height,
                      children: /* @__PURE__ */ C.jsx("source", { src: t.attrs.src })
                    }
                  ),
                  i === "iframe" && /* @__PURE__ */ C.jsx(
                    "iframe",
                    {
                      ref: f,
                      className: Lt(
                        "rounded-lg max-w-full",
                        h && "pointer-events-none"
                      ),
                      src: t.attrs.src,
                      width: t.attrs.width,
                      height: t.attrs.height
                    }
                  ),
                  !r && /* @__PURE__ */ C.jsx(
                    "div",
                    {
                      className: "horizontal-resize-handle group-hover:bg-[#2E2E2E] group-hover:border-2 group-hover:border-[#E8EBEC]",
                      title: "Resize",
                      onClick: ({ clientX: oe }) => A(oe),
                      onMouseDown: (oe) => j(oe),
                      onMouseUp: D,
                      onTouchStart: (oe) => j(oe),
                      onTouchEnd: D
                    }
                  )
                ]
              }
            ),
            t.attrs.showCaptionInput && /* @__PURE__ */ C.jsx("div", { className: "caption-input-container", children: /* @__PURE__ */ C.jsx(
              "textarea",
              {
                placeholder: "Add a caption",
                value: t.attrs.caption || "",
                onChange: (oe) => {
                  let ee = oe.target.value;
                  ee.length > 300 && (ee = ee.substring(0, 300)), e({ caption: ee });
                  const ae = oe.target;
                  ae.style.height = "auto", ae.style.height = `${ae.scrollHeight}px`;
                },
                onPaste: (oe) => {
                  oe.preventDefault();
                  const ee = oe.clipboardData.getData("text"), fe = (oe.currentTarget.value + ee).substring(0, 300);
                  e({ caption: fe });
                  const me = oe.currentTarget;
                  me.style.height = "auto", me.style.height = `${me.scrollHeight}px`;
                },
                onBlur: () => {
                  t.attrs.caption || e({ showCaptionInput: !1 });
                },
                onInput: (oe) => {
                  const ee = oe.target;
                  ee.style.height = "auto", ee.style.height = `${ee.scrollHeight}px`;
                },
                onFocus: (oe) => {
                  const ee = oe.target;
                  ee.style.fontSize = "16px";
                },
                autoFocus: !0,
                className: Lt(
                  "color-bg-default color-text-secondary dark:!text-[#888888] resize-none !mt-2",
                  "placeholder-disabled",
                  {
                    "text-left": t.attrs.dataAlign === "start",
                    "text-center": t.attrs.dataAlign === "center",
                    "text-right": t.attrs.dataAlign === "end"
                  }
                )
              }
            ) }),
            t.attrs.caption && !t.attrs.showCaptionInput && /* @__PURE__ */ C.jsx("div", { className: "caption", children: t.attrs.caption }),
            !r && /* @__PURE__ */ C.jsx("span", { className: "absolute top-2 right-2 transition-all rounded-md overflow-hidden box-border border color-border-default color-bg-default shadow-elevation-3 opacity-0 group-hover:opacity-100 flex gap-1 p-1", children: cR.map((oe, ee) => /* @__PURE__ */ C.jsx(
              kr,
              {
                tooltip: oe.tooltip,
                isActive: u[oe.tooltip],
                onClick: () => {
                  var ae;
                  return oe.tooltip === "Delete" ? n() : (ae = oe.action) == null ? void 0 : ae.call(oe, e);
                },
                icon: oe.icon,
                classNames: "min-w-6 aspect-square",
                size: "sm"
              },
              ee
            )) })
          ]
        }
      )
    }
  );
}, iRt = Ht.create({
  name: "iframe",
  group: "block",
  atom: !0,
  draggable: !0,
  addOptions() {
    return {
      allowFullscreen: !0,
      HTMLAttributes: {
        class: "iframe-wrapper"
      }
    };
  },
  addAttributes() {
    return {
      src: {
        default: null
      },
      frameborder: {
        default: 0
      },
      allowfullscreen: {
        default: this.options.allowFullscreen,
        parseHTML: () => this.options.allowFullscreen
      },
      "media-type": {
        default: "iframe"
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: this.options.width
      },
      height: {
        default: this.options.height
      },
      dataAlign: {
        default: "left"
        // 'left' | 'center' | 'right'
      },
      dataFloat: {
        default: null
        // 'left' | 'right'
      }
    };
  },
  addNodeView() {
    return Hc(pte);
  },
  parseHTML() {
    return [
      {
        tag: "iframe"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "iframe",
      _t(this.options.HTMLAttributes, t)
    ];
  },
  addCommands() {
    return {
      setIframe: (t) => ({ tr: e, dispatch: n }) => {
        const { selection: r } = e, i = this.type.create(t);
        return n && e.replaceRangeWith(r.from - 1, r.to, i), !0;
      }
    };
  }
}), aRt = "_verified_lvyh0_1", hL = {
  verified: aRt
}, oRt = () => /* @__PURE__ */ C.jsx("svg", {
  viewBox: "0 0 24 24",
  "aria-label": "Verified account",
  role: "img",
  className: hL.verified,
  children: /* @__PURE__ */ C.jsx("g", {
    children: /* @__PURE__ */ C.jsx("path", {
      d: "M22.25 12c0-1.43-.88-2.67-2.19-3.34.46-1.39.2-2.9-.81-3.91s-2.52-1.27-3.91-.81c-.66-1.31-1.91-2.19-3.34-2.19s-2.67.88-3.33 2.19c-1.4-.46-2.91-.2-3.92.81s-1.26 2.52-.8 3.91c-1.31.67-2.2 1.91-2.2 3.34s.89 2.67 2.2 3.34c-.46 1.39-.21 2.9.8 3.91s2.52 1.26 3.91.81c.67 1.31 1.91 2.19 3.34 2.19s2.68-.88 3.34-2.19c1.39.45 2.9.2 3.91-.81s1.27-2.52.81-3.91c1.31-.67 2.19-1.91 2.19-3.34zm-11.71 4.2L6.8 12.46l1.41-1.42 2.26 2.26 4.8-5.23 1.47 1.36-6.2 6.77z"
    })
  })
}), sRt = () => /* @__PURE__ */ C.jsx("svg", {
  viewBox: "0 0 22 22",
  "aria-label": "Verified account",
  role: "img",
  className: hL.verified,
  children: /* @__PURE__ */ C.jsxs("g", {
    children: [
      /* @__PURE__ */ C.jsxs("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "0-a",
        x1: "4.411",
        x2: "18.083",
        y1: "2.495",
        y2: "21.508",
        children: [
          /* @__PURE__ */ C.jsx("stop", {
            offset: "0",
            stopColor: "#f4e72a"
          }),
          /* @__PURE__ */ C.jsx("stop", {
            offset: ".539",
            stopColor: "#cd8105"
          }),
          /* @__PURE__ */ C.jsx("stop", {
            offset: ".68",
            stopColor: "#cb7b00"
          }),
          /* @__PURE__ */ C.jsx("stop", {
            offset: "1",
            stopColor: "#f4ec26"
          }),
          /* @__PURE__ */ C.jsx("stop", {
            offset: "1",
            stopColor: "#f4e72a"
          })
        ]
      }),
      /* @__PURE__ */ C.jsxs("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "0-b",
        x1: "5.355",
        x2: "16.361",
        y1: "3.395",
        y2: "19.133",
        children: [
          /* @__PURE__ */ C.jsx("stop", {
            offset: "0",
            stopColor: "#f9e87f"
          }),
          /* @__PURE__ */ C.jsx("stop", {
            offset: ".406",
            stopColor: "#e2b719"
          }),
          /* @__PURE__ */ C.jsx("stop", {
            offset: ".989",
            stopColor: "#e2b719"
          })
        ]
      }),
      /* @__PURE__ */ C.jsxs("g", {
        clipRule: "evenodd",
        fillRule: "evenodd",
        children: [
          /* @__PURE__ */ C.jsx("path", {
            d: "M13.324 3.848L11 1.6 8.676 3.848l-3.201-.453-.559 3.184L2.06 8.095 3.48 11l-1.42 2.904 2.856 1.516.559 3.184 3.201-.452L11 20.4l2.324-2.248 3.201.452.559-3.184 2.856-1.516L18.52 11l1.42-2.905-2.856-1.516-.559-3.184zm-7.09 7.575l3.428 3.428 5.683-6.206-1.347-1.247-4.4 4.795-2.072-2.072z",
            fill: "url(#0-a)"
          }),
          /* @__PURE__ */ C.jsx("path", {
            d: "M13.101 4.533L11 2.5 8.899 4.533l-2.895-.41-.505 2.88-2.583 1.37L4.2 11l-1.284 2.627 2.583 1.37.505 2.88 2.895-.41L11 19.5l2.101-2.033 2.895.41.505-2.88 2.583-1.37L17.8 11l1.284-2.627-2.583-1.37-.505-2.88zm-6.868 6.89l3.429 3.428 5.683-6.206-1.347-1.247-4.4 4.795-2.072-2.072z",
            fill: "url(#0-b)"
          }),
          /* @__PURE__ */ C.jsx("path", {
            d: "M6.233 11.423l3.429 3.428 5.65-6.17.038-.033-.005 1.398-5.683 6.206-3.429-3.429-.003-1.405.005.003z",
            fill: "#d18800"
          })
        ]
      })
    ]
  })
}), lRt = () => /* @__PURE__ */ C.jsx("svg", {
  viewBox: "0 0 22 22",
  "aria-label": "Verified account",
  role: "img",
  className: hL.verified,
  children: /* @__PURE__ */ C.jsx("g", {
    children: /* @__PURE__ */ C.jsx("path", {
      clipRule: "evenodd",
      d: "M12.05 2.056c-.568-.608-1.532-.608-2.1 0l-1.393 1.49c-.284.303-.685.47-1.1.455L5.42 3.932c-.832-.028-1.514.654-1.486 1.486l.069 2.039c.014.415-.152.816-.456 1.1l-1.49 1.392c-.608.568-.608 1.533 0 2.101l1.49 1.393c.304.284.47.684.456 1.1l-.07 2.038c-.027.832.655 1.514 1.487 1.486l2.038-.069c.415-.014.816.152 1.1.455l1.392 1.49c.569.609 1.533.609 2.102 0l1.393-1.49c.283-.303.684-.47 1.099-.455l2.038.069c.832.028 1.515-.654 1.486-1.486L18 14.542c-.015-.415.152-.815.455-1.099l1.49-1.393c.608-.568.608-1.533 0-2.101l-1.49-1.393c-.303-.283-.47-.684-.455-1.1l.068-2.038c.029-.832-.654-1.514-1.486-1.486l-2.038.07c-.415.013-.816-.153-1.1-.456zm-5.817 9.367l3.429 3.428 5.683-6.206-1.347-1.247-4.4 4.795-2.072-2.072z",
      fillRule: "evenodd"
    })
  })
});
function mte(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number") r += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var i = t.length;
    for (e = 0; e < i; e++) t[e] && (n = mte(t[e])) && (r && (r += " "), r += n);
  } else for (n in t) t[n] && (r && (r += " "), r += n);
  return r;
}
function mc() {
  for (var t, e, n = 0, r = "", i = arguments.length; n < i; n++) (t = arguments[n]) && (e = mte(t)) && (r && (r += " "), r += e);
  return r;
}
const cRt = "_root_98iqw_1", uRt = "_article_98iqw_21", uR = {
  root: cRt,
  article: uRt
}, pL = ({ className: t, children: e }) => /* @__PURE__ */ C.jsx("div", {
  className: mc("react-tweet-theme", uR.root, t),
  children: /* @__PURE__ */ C.jsx("article", {
    className: uR.article,
    children: e
  })
}), yte = (t) => /* @__PURE__ */ C.jsx("img", {
  ...t
}), dRt = "_header_nqq4j_1", fRt = "_avatar_nqq4j_11", hRt = "_avatarOverflow_nqq4j_16", pRt = "_avatarSquare_nqq4j_23", mRt = "_avatarShadow_nqq4j_26", yRt = "_author_nqq4j_37", gRt = "_authorLink_nqq4j_44", vRt = "_authorVerified_nqq4j_53", bRt = "_authorLinkText_nqq4j_56", wRt = "_authorMeta_nqq4j_63", kRt = "_authorFollow_nqq4j_66", xRt = "_username_nqq4j_69", MRt = "_follow_nqq4j_74", CRt = "_separator_nqq4j_82", ARt = "_brand_nqq4j_86", SRt = "_twitterIcon_nqq4j_90", jr = {
  header: dRt,
  avatar: fRt,
  avatarOverflow: hRt,
  avatarSquare: pRt,
  avatarShadow: mRt,
  author: yRt,
  authorLink: gRt,
  authorVerified: vRt,
  authorLinkText: bRt,
  authorMeta: wRt,
  authorFollow: kRt,
  username: xRt,
  follow: MRt,
  separator: CRt,
  brand: ARt,
  twitterIcon: SRt
}, LRt = "_verifiedOld_lcna5_1", TRt = "_verifiedBlue_lcna5_4", ERt = "_verifiedGovernment_lcna5_7", hb = {
  verifiedOld: LRt,
  verifiedBlue: TRt,
  verifiedGovernment: ERt
}, gte = ({ user: t, className: e }) => {
  const n = t.verified || t.is_blue_verified || t.verified_type;
  let r = /* @__PURE__ */ C.jsx(oRt, {}), i = hb.verifiedBlue;
  if (n)
    switch (t.is_blue_verified || (i = hb.verifiedOld), t.verified_type) {
      case "Government":
        r = /* @__PURE__ */ C.jsx(lRt, {}), i = hb.verifiedGovernment;
        break;
      case "Business":
        r = /* @__PURE__ */ C.jsx(sRt, {}), i = null;
        break;
    }
  return n ? /* @__PURE__ */ C.jsx("div", {
    className: mc(e, i),
    children: r
  }) : null;
}, jRt = ({ tweet: t, components: e }) => {
  var n;
  const r = (n = e == null ? void 0 : e.AvatarImg) != null ? n : yte, { user: i } = t;
  return /* @__PURE__ */ C.jsxs("div", {
    className: jr.header,
    children: [
      /* @__PURE__ */ C.jsxs("a", {
        href: t.url,
        className: jr.avatar,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
          /* @__PURE__ */ C.jsx("div", {
            className: mc(jr.avatarOverflow, i.profile_image_shape === "Square" && jr.avatarSquare),
            children: /* @__PURE__ */ C.jsx(r, {
              src: i.profile_image_url_https,
              alt: i.name,
              width: 48,
              height: 48
            })
          }),
          /* @__PURE__ */ C.jsx("div", {
            className: jr.avatarOverflow,
            children: /* @__PURE__ */ C.jsx("div", {
              className: jr.avatarShadow
            })
          })
        ]
      }),
      /* @__PURE__ */ C.jsxs("div", {
        className: jr.author,
        children: [
          /* @__PURE__ */ C.jsxs("a", {
            href: t.url,
            className: jr.authorLink,
            target: "_blank",
            rel: "noopener noreferrer",
            children: [
              /* @__PURE__ */ C.jsx("div", {
                className: jr.authorLinkText,
                children: /* @__PURE__ */ C.jsx("span", {
                  title: i.name,
                  children: i.name
                })
              }),
              /* @__PURE__ */ C.jsx(gte, {
                user: i,
                className: jr.authorVerified
              })
            ]
          }),
          /* @__PURE__ */ C.jsxs("div", {
            className: jr.authorMeta,
            children: [
              /* @__PURE__ */ C.jsx("a", {
                href: t.url,
                className: jr.username,
                target: "_blank",
                rel: "noopener noreferrer",
                children: /* @__PURE__ */ C.jsxs("span", {
                  title: `@${i.screen_name}`,
                  children: [
                    "@",
                    i.screen_name
                  ]
                })
              }),
              /* @__PURE__ */ C.jsxs("div", {
                className: jr.authorFollow,
                children: [
                  /* @__PURE__ */ C.jsx("span", {
                    className: jr.separator,
                    children: "·"
                  }),
                  /* @__PURE__ */ C.jsx("a", {
                    href: i.follow_url,
                    className: jr.follow,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: "Follow"
                  })
                ]
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ C.jsx("a", {
        href: t.url,
        className: jr.brand,
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": "View on Twitter",
        children: /* @__PURE__ */ C.jsx("svg", {
          viewBox: "0 0 24 24",
          "aria-hidden": "true",
          className: jr.twitterIcon,
          children: /* @__PURE__ */ C.jsx("g", {
            children: /* @__PURE__ */ C.jsx("path", {
              d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
            })
          })
        })
      })
    ]
  });
}, NRt = "_root_1ec15_1", DRt = {
  root: NRt
}, IRt = ({ tweet: t }) => /* @__PURE__ */ C.jsxs("a", {
  href: t.in_reply_to_url,
  className: DRt.root,
  target: "_blank",
  rel: "noopener noreferrer",
  children: [
    "Replying to @",
    t.in_reply_to_screen_name
  ]
}), PRt = "_root_eihfa_1", zRt = {
  root: PRt
}, RRt = ({ href: t, children: e }) => /* @__PURE__ */ C.jsx("a", {
  href: t,
  className: zRt.root,
  target: "_blank",
  rel: "noopener noreferrer nofollow",
  children: e
}), ORt = "_root_1xq52_1", BRt = {
  root: ORt
}, HRt = ({ tweet: t }) => /* @__PURE__ */ C.jsx("p", {
  className: BRt.root,
  lang: t.lang,
  dir: "auto",
  children: t.entities.map((e, n) => {
    switch (e.type) {
      case "hashtag":
      case "mention":
      case "url":
      case "symbol":
        return /* @__PURE__ */ C.jsx(RRt, {
          href: e.href,
          children: e.text
        }, n);
      case "media":
        return;
      default:
        return /* @__PURE__ */ C.jsx("span", {
          dangerouslySetInnerHTML: {
            __html: e.text
          }
        }, n);
    }
  })
}), dR = (t) => `https://x.com/${t.user.screen_name}/status/${t.id_str}`, vte = (t) => `https://x.com/${typeof t == "string" ? t : t.user.screen_name}`, FRt = (t) => `https://x.com/intent/like?tweet_id=${t.id_str}`, _Rt = (t) => `https://x.com/intent/tweet?in_reply_to=${t.id_str}`, VRt = (t) => `https://x.com/intent/follow?screen_name=${t.user.screen_name}`, qRt = (t) => `https://x.com/hashtag/${t.text}`, URt = (t) => `https://x.com/search?q=%24${t.text}`, WRt = (t) => `https://x.com/${t.in_reply_to_screen_name}/status/${t.in_reply_to_status_id_str}`, bte = (t, e) => {
  const n = new URL(t.media_url_https), r = n.pathname.split(".").pop();
  return r ? (n.pathname = n.pathname.replace(`.${r}`, ""), n.searchParams.set("format", r), n.searchParams.set("name", e), n.toString()) : t.media_url_https;
}, ZRt = (t) => {
  const { variants: e } = t.video_info;
  return e.filter((r) => r.content_type === "video/mp4").sort((r, i) => {
    var a, o;
    return ((a = i.bitrate) != null ? a : 0) - ((o = r.bitrate) != null ? o : 0);
  });
}, GRt = (t) => {
  const e = ZRt(t);
  return e.length > 1 ? e[1] : e[0];
}, pk = (t) => t > 999999 ? `${(t / 1e6).toFixed(1)}M` : t > 999 ? `${(t / 1e3).toFixed(1)}K` : t.toString();
function fR(t) {
  const e = Array.from(t.text), n = [
    {
      indices: t.display_text_range,
      type: "text"
    }
  ];
  return Lf(n, "hashtag", t.entities.hashtags), Lf(n, "mention", t.entities.user_mentions), Lf(n, "url", t.entities.urls), Lf(n, "symbol", t.entities.symbols), t.entities.media && Lf(n, "media", t.entities.media), YRt(t, n), n.map((r) => {
    const i = e.slice(r.indices[0], r.indices[1]).join("");
    switch (r.type) {
      case "hashtag":
        return Object.assign(r, {
          href: qRt(r),
          text: i
        });
      case "mention":
        return Object.assign(r, {
          href: vte(r.screen_name),
          text: i
        });
      case "url":
      case "media":
        return Object.assign(r, {
          href: r.expanded_url,
          text: r.display_url
        });
      case "symbol":
        return Object.assign(r, {
          href: URt(r),
          text: i
        });
      default:
        return Object.assign(r, {
          text: i
        });
    }
  });
}
function Lf(t, e, n) {
  for (const r of n)
    for (const [i, a] of t.entries()) {
      if (a.indices[0] > r.indices[0] || a.indices[1] < r.indices[1])
        continue;
      const o = [
        {
          ...r,
          type: e
        }
      ];
      a.indices[0] < r.indices[0] && o.unshift({
        indices: [
          a.indices[0],
          r.indices[0]
        ],
        type: "text"
      }), a.indices[1] > r.indices[1] && o.push({
        indices: [
          r.indices[1],
          a.indices[1]
        ],
        type: "text"
      }), t.splice(i, 1, ...o);
      break;
    }
}
function YRt(t, e) {
  t.entities.media && t.entities.media[0].indices[0] < t.display_text_range[1] && (t.display_text_range[1] = t.entities.media[0].indices[0]);
  const n = e.at(-1);
  n && n.indices[1] > t.display_text_range[1] && (n.indices[1] = t.display_text_range[1]);
}
const KRt = (t) => ({
  ...t,
  url: dR(t),
  user: {
    ...t.user,
    url: vte(t),
    follow_url: VRt(t)
  },
  like_url: FRt(t),
  reply_url: _Rt(t),
  in_reply_to_url: t.in_reply_to_screen_name ? WRt(t) : void 0,
  entities: fR(t),
  quoted_tweet: t.quoted_tweet ? {
    ...t.quoted_tweet,
    url: dR(t.quoted_tweet),
    entities: fR(t.quoted_tweet)
  } : void 0
}), $Rt = "_root_g9tkv_1", JRt = "_rounded_g9tkv_6", QRt = "_mediaWrapper_g9tkv_10", XRt = "_grid2Columns_g9tkv_17", eOt = "_grid3_g9tkv_20", tOt = "_grid2x2_g9tkv_23", nOt = "_mediaContainer_g9tkv_26", rOt = "_mediaLink_g9tkv_34", iOt = "_skeleton_g9tkv_38", aOt = "_image_g9tkv_43", Hi = {
  root: $Rt,
  rounded: JRt,
  mediaWrapper: QRt,
  grid2Columns: XRt,
  grid3: eOt,
  grid2x2: tOt,
  mediaContainer: nOt,
  mediaLink: rOt,
  skeleton: iOt,
  image: aOt
}, oOt = "_anchor_fp31d_1", sOt = "_videoButton_fp31d_17", lOt = "_videoButtonIcon_fp31d_35", cOt = "_watchOnTwitter_fp31d_44", uOt = "_viewReplies_fp31d_60", Z0 = {
  anchor: oOt,
  videoButton: sOt,
  videoButtonIcon: lOt,
  watchOnTwitter: cOt,
  viewReplies: uOt
}, dOt = ({ tweet: t, media: e }) => {
  const [n, r] = De(!0), [i, a] = De(!1), [o, s] = De(!1), l = GRt(e);
  let c = 0;
  return /* @__PURE__ */ C.jsxs(C.Fragment, {
    children: [
      /* @__PURE__ */ C.jsx("video", {
        className: Hi.image,
        poster: bte(e, "small"),
        controls: !n,
        playsInline: !0,
        preload: "none",
        tabIndex: n ? -1 : 0,
        onPlay: () => {
          c && window.clearTimeout(c), i || a(!0), o && s(!1);
        },
        onPause: () => {
          c && window.clearTimeout(c), c = window.setTimeout(() => {
            i && a(!1), c = 0;
          }, 100);
        },
        onEnded: () => {
          s(!0);
        },
        children: /* @__PURE__ */ C.jsx("source", {
          src: l.url,
          type: l.content_type
        })
      }),
      n && /* @__PURE__ */ C.jsx("button", {
        type: "button",
        className: Z0.videoButton,
        "aria-label": "View video on X",
        onClick: (u) => {
          const d = u.currentTarget.previousSibling;
          u.preventDefault(), r(!1), d.load(), d.play().then(() => {
            a(!0), d.focus();
          }).catch((f) => {
            console.error("Error playing video:", f), r(!0), a(!1);
          });
        },
        children: /* @__PURE__ */ C.jsx("svg", {
          viewBox: "0 0 24 24",
          className: Z0.videoButtonIcon,
          "aria-hidden": "true",
          children: /* @__PURE__ */ C.jsx("g", {
            children: /* @__PURE__ */ C.jsx("path", {
              d: "M21 12L4 2v20l17-10z"
            })
          })
        })
      }),
      !i && !o && /* @__PURE__ */ C.jsx("div", {
        className: Z0.watchOnTwitter,
        children: /* @__PURE__ */ C.jsx("a", {
          href: t.url,
          className: Z0.anchor,
          target: "_blank",
          rel: "noopener noreferrer",
          children: n ? "Watch on X" : "Continue watching on X"
        })
      }),
      o && /* @__PURE__ */ C.jsx("a", {
        href: t.url,
        className: mc(Z0.anchor, Z0.viewReplies),
        target: "_blank",
        rel: "noopener noreferrer",
        children: "View replies"
      })
    ]
  });
}, fOt = (t) => /* @__PURE__ */ C.jsx("img", {
  ...t
}), hR = (t, e) => {
  let n = 56.25;
  return e === 1 && (n = 100 / t.original_info.width * t.original_info.height), e === 2 && (n = n * 2), {
    width: t.type === "photo" ? void 0 : "unset",
    paddingBottom: `${n}%`
  };
}, wte = ({ tweet: t, components: e, quoted: n }) => {
  var r, i, a;
  const o = (a = (r = t.mediaDetails) == null ? void 0 : r.length) != null ? a : 0;
  var s;
  const l = (s = e == null ? void 0 : e.MediaImg) != null ? s : fOt;
  return /* @__PURE__ */ C.jsx("div", {
    className: mc(Hi.root, !n && Hi.rounded),
    children: /* @__PURE__ */ C.jsx("div", {
      className: mc(Hi.mediaWrapper, o > 1 && Hi.grid2Columns, o === 3 && Hi.grid3, o > 4 && Hi.grid2x2),
      children: (i = t.mediaDetails) == null ? void 0 : i.map((c) => /* @__PURE__ */ C.jsx(ds, {
        children: c.type === "photo" ? /* @__PURE__ */ C.jsxs("a", {
          href: t.url,
          className: mc(Hi.mediaContainer, Hi.mediaLink),
          target: "_blank",
          rel: "noopener noreferrer",
          children: [
            /* @__PURE__ */ C.jsx("div", {
              className: Hi.skeleton,
              style: hR(c, o)
            }),
            /* @__PURE__ */ C.jsx(l, {
              src: bte(c, "small"),
              alt: c.ext_alt_text || "Image",
              className: Hi.image,
              draggable: !0
            })
          ]
        }, c.media_url_https) : /* @__PURE__ */ C.jsxs("div", {
          className: Hi.mediaContainer,
          children: [
            /* @__PURE__ */ C.jsx("div", {
              className: Hi.skeleton,
              style: hR(c, o)
            }),
            /* @__PURE__ */ C.jsx(dOt, {
              tweet: t,
              media: c
            })
          ]
        }, c.media_url_https)
      }, c.media_url_https))
    })
  });
}, hOt = {
  hour: "numeric",
  minute: "2-digit",
  hour12: !0,
  weekday: "short",
  month: "short",
  day: "numeric",
  year: "numeric"
}, pOt = new Intl.DateTimeFormat("en-US", hOt), mOt = (t) => {
  const e = {};
  for (const n of t)
    e[n.type] = n.value;
  return e;
}, yOt = (t) => {
  const e = mOt(pOt.formatToParts(t)), n = `${e.hour}:${e.minute} ${e.dayPeriod}`, r = `${e.month} ${e.day}, ${e.year}`;
  return `${n} · ${r}`;
}, gOt = "_root_i24yn_1", vOt = {
  root: gOt
}, bOt = ({ tweet: t }) => {
  const e = new Date(t.created_at), n = yOt(e);
  return /* @__PURE__ */ C.jsx("a", {
    className: vOt.root,
    href: t.url,
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": n,
    children: /* @__PURE__ */ C.jsx("time", {
      dateTime: e.toISOString(),
      children: n
    })
  });
}, wOt = "_info_19qcj_1", kOt = "_infoLink_19qcj_10", xOt = "_infoIcon_19qcj_30", pb = {
  info: wOt,
  infoLink: kOt,
  infoIcon: xOt
}, MOt = ({ tweet: t }) => /* @__PURE__ */ C.jsxs("div", {
  className: pb.info,
  children: [
    /* @__PURE__ */ C.jsx(bOt, {
      tweet: t
    }),
    /* @__PURE__ */ C.jsx("a", {
      className: pb.infoLink,
      href: "https://help.x.com/en/x-for-websites-ads-info-and-privacy",
      target: "_blank",
      rel: "noopener noreferrer",
      "aria-label": "Twitter for Websites, Ads Information and Privacy",
      children: /* @__PURE__ */ C.jsx("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        className: pb.infoIcon,
        children: /* @__PURE__ */ C.jsx("g", {
          children: /* @__PURE__ */ C.jsx("path", {
            d: "M13.5 8.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5S11.17 7 12 7s1.5.67 1.5 1.5zM13 17v-5h-2v5h2zm-1 5.25c5.66 0 10.25-4.59 10.25-10.25S17.66 1.75 12 1.75 1.75 6.34 1.75 12 6.34 22.25 12 22.25zM20.25 12c0 4.56-3.69 8.25-8.25 8.25S3.75 16.56 3.75 12 7.44 3.75 12 3.75s8.25 3.69 8.25 8.25z"
          })
        })
      })
    })
  ]
}), COt = "_actions_n2anf_1", AOt = "_like_n2anf_13", SOt = "_reply_n2anf_14", LOt = "_copy_n2anf_15", TOt = "_likeIconWrapper_n2anf_27", EOt = "_likeCount_n2anf_30", jOt = "_replyIconWrapper_n2anf_35", NOt = "_copyIconWrapper_n2anf_36", DOt = "_likeIcon_n2anf_27", IOt = "_replyIcon_n2anf_35", POt = "_copyIcon_n2anf_36", zOt = "_replyText_n2anf_56", ROt = "_copyText_n2anf_57", ki = {
  actions: COt,
  like: AOt,
  reply: SOt,
  copy: LOt,
  likeIconWrapper: TOt,
  likeCount: EOt,
  replyIconWrapper: jOt,
  copyIconWrapper: NOt,
  likeIcon: DOt,
  replyIcon: IOt,
  copyIcon: POt,
  replyText: zOt,
  copyText: ROt
}, OOt = ({ tweet: t }) => {
  const [e, n] = De(!1), r = () => {
    navigator.clipboard.writeText(t.url), n(!0);
  };
  return ze(() => {
    if (e) {
      const i = setTimeout(() => {
        n(!1);
      }, 6e3);
      return () => clearTimeout(i);
    }
  }, [
    e
  ]), /* @__PURE__ */ C.jsxs("button", {
    type: "button",
    className: ki.copy,
    "aria-label": "Copy link",
    onClick: r,
    children: [
      /* @__PURE__ */ C.jsx("div", {
        className: ki.copyIconWrapper,
        children: e ? /* @__PURE__ */ C.jsx("svg", {
          viewBox: "0 0 24 24",
          className: ki.copyIcon,
          "aria-hidden": "true",
          children: /* @__PURE__ */ C.jsx("g", {
            children: /* @__PURE__ */ C.jsx("path", {
              d: "M9.64 18.952l-5.55-4.861 1.317-1.504 3.951 3.459 8.459-10.948L19.4 6.32 9.64 18.952z"
            })
          })
        }) : /* @__PURE__ */ C.jsx("svg", {
          viewBox: "0 0 24 24",
          className: ki.copyIcon,
          "aria-hidden": "true",
          children: /* @__PURE__ */ C.jsx("g", {
            children: /* @__PURE__ */ C.jsx("path", {
              d: "M18.36 5.64c-1.95-1.96-5.11-1.96-7.07 0L9.88 7.05 8.46 5.64l1.42-1.42c2.73-2.73 7.16-2.73 9.9 0 2.73 2.74 2.73 7.17 0 9.9l-1.42 1.42-1.41-1.42 1.41-1.41c1.96-1.96 1.96-5.12 0-7.07zm-2.12 3.53l-7.07 7.07-1.41-1.41 7.07-7.07 1.41 1.41zm-12.02.71l1.42-1.42 1.41 1.42-1.41 1.41c-1.96 1.96-1.96 5.12 0 7.07 1.95 1.96 5.11 1.96 7.07 0l1.41-1.41 1.42 1.41-1.42 1.42c-2.73 2.73-7.16 2.73-9.9 0-2.73-2.74-2.73-7.17 0-9.9z"
            })
          })
        })
      }),
      /* @__PURE__ */ C.jsx("span", {
        className: ki.copyText,
        children: e ? "Copied!" : "Copy link"
      })
    ]
  });
}, BOt = ({ tweet: t }) => {
  const e = pk(t.favorite_count);
  return /* @__PURE__ */ C.jsxs("div", {
    className: ki.actions,
    children: [
      /* @__PURE__ */ C.jsxs("a", {
        className: ki.like,
        href: t.like_url,
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": `Like. This Tweet has ${e} likes`,
        children: [
          /* @__PURE__ */ C.jsx("div", {
            className: ki.likeIconWrapper,
            children: /* @__PURE__ */ C.jsx("svg", {
              viewBox: "0 0 24 24",
              className: ki.likeIcon,
              "aria-hidden": "true",
              children: /* @__PURE__ */ C.jsx("g", {
                children: /* @__PURE__ */ C.jsx("path", {
                  d: "M20.884 13.19c-1.351 2.48-4.001 5.12-8.379 7.67l-.503.3-.504-.3c-4.379-2.55-7.029-5.19-8.382-7.67-1.36-2.5-1.41-4.86-.514-6.67.887-1.79 2.647-2.91 4.601-3.01 1.651-.09 3.368.56 4.798 2.01 1.429-1.45 3.146-2.1 4.796-2.01 1.954.1 3.714 1.22 4.601 3.01.896 1.81.846 4.17-.514 6.67z"
                })
              })
            })
          }),
          /* @__PURE__ */ C.jsx("span", {
            className: ki.likeCount,
            children: e
          })
        ]
      }),
      /* @__PURE__ */ C.jsxs("a", {
        className: ki.reply,
        href: t.reply_url,
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": "Reply to this Tweet on Twitter",
        children: [
          /* @__PURE__ */ C.jsx("div", {
            className: ki.replyIconWrapper,
            children: /* @__PURE__ */ C.jsx("svg", {
              viewBox: "0 0 24 24",
              className: ki.replyIcon,
              "aria-hidden": "true",
              children: /* @__PURE__ */ C.jsx("g", {
                children: /* @__PURE__ */ C.jsx("path", {
                  d: "M1.751 10c0-4.42 3.584-8 8.005-8h4.366c4.49 0 8.129 3.64 8.129 8.13 0 2.96-1.607 5.68-4.196 7.11l-8.054 4.46v-3.69h-.067c-4.49.1-8.183-3.51-8.183-8.01z"
                })
              })
            })
          }),
          /* @__PURE__ */ C.jsx("span", {
            className: ki.replyText,
            children: "Reply"
          })
        ]
      }),
      /* @__PURE__ */ C.jsx(OOt, {
        tweet: t
      })
    ]
  });
}, HOt = "_replies_1cutb_1", FOt = "_link_1cutb_4", _Ot = "_text_1cutb_23", mb = {
  replies: HOt,
  link: FOt,
  text: _Ot
}, VOt = ({ tweet: t }) => /* @__PURE__ */ C.jsx("div", {
  className: mb.replies,
  children: /* @__PURE__ */ C.jsx("a", {
    className: mb.link,
    href: t.url,
    target: "_blank",
    rel: "noopener noreferrer",
    children: /* @__PURE__ */ C.jsx("span", {
      className: mb.text,
      children: t.conversation_count === 0 ? "Read more on X" : t.conversation_count === 1 ? `Read ${pk(t.conversation_count)} reply` : `Read ${pk(t.conversation_count)} replies`
    })
  })
}), qOt = "_root_q5799_1", UOt = "_article_q5799_16", pR = {
  root: qOt,
  article: UOt
}, WOt = ({ tweet: t, children: e }) => /* @__PURE__ */ C.jsx("div", {
  className: pR.root,
  onClick: (n) => {
    n.preventDefault(), window.open(t.url, "_blank");
  },
  children: /* @__PURE__ */ C.jsx("article", {
    className: pR.article,
    children: e
  })
}), ZOt = "_header_r31i5_1", GOt = "_avatar_r31i5_11", YOt = "_avatarSquare_r31i5_17", KOt = "_author_r31i5_21", $Ot = "_authorText_r31i5_26", JOt = "_username_r31i5_33", ru = {
  header: ZOt,
  avatar: GOt,
  avatarSquare: YOt,
  author: KOt,
  authorText: $Ot,
  username: JOt
}, QOt = ({ tweet: t }) => {
  const { user: e } = t;
  return /* @__PURE__ */ C.jsxs("div", {
    className: ru.header,
    children: [
      /* @__PURE__ */ C.jsx("a", {
        href: t.url,
        className: ru.avatar,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /* @__PURE__ */ C.jsx("div", {
          className: mc(ru.avatarOverflow, e.profile_image_shape === "Square" && ru.avatarSquare),
          children: /* @__PURE__ */ C.jsx(yte, {
            src: e.profile_image_url_https,
            alt: e.name,
            width: 20,
            height: 20
          })
        })
      }),
      /* @__PURE__ */ C.jsxs("div", {
        className: ru.author,
        children: [
          /* @__PURE__ */ C.jsx("div", {
            className: ru.authorText,
            children: /* @__PURE__ */ C.jsx("span", {
              title: e.name,
              children: e.name
            })
          }),
          /* @__PURE__ */ C.jsx(gte, {
            user: e
          }),
          /* @__PURE__ */ C.jsx("div", {
            className: ru.username,
            children: /* @__PURE__ */ C.jsxs("span", {
              title: `@${e.screen_name}`,
              children: [
                "@",
                e.screen_name
              ]
            })
          })
        ]
      })
    ]
  });
}, XOt = "_root_175ot_1", eBt = {
  root: XOt
}, tBt = ({ tweet: t }) => /* @__PURE__ */ C.jsx("p", {
  className: eBt.root,
  lang: t.lang,
  dir: "auto",
  children: t.entities.map((e, n) => /* @__PURE__ */ C.jsx("span", {
    dangerouslySetInnerHTML: {
      __html: e.text
    }
  }, n))
}), nBt = ({ tweet: t }) => {
  var e;
  return /* @__PURE__ */ C.jsxs(WOt, {
    tweet: t,
    children: [
      /* @__PURE__ */ C.jsx(QOt, {
        tweet: t
      }),
      /* @__PURE__ */ C.jsx(tBt, {
        tweet: t
      }),
      (e = t.mediaDetails) != null && e.length ? /* @__PURE__ */ C.jsx(wte, {
        quoted: !0,
        tweet: t
      }) : null
    ]
  });
}, kte = ({ tweet: t, components: e }) => {
  var n;
  const r = Ft(() => KRt(t), [
    t
  ]);
  return /* @__PURE__ */ C.jsxs(pL, {
    children: [
      /* @__PURE__ */ C.jsx(jRt, {
        tweet: r,
        components: e
      }),
      r.in_reply_to_status_id_str && /* @__PURE__ */ C.jsx(IRt, {
        tweet: r
      }),
      /* @__PURE__ */ C.jsx(HRt, {
        tweet: r
      }),
      (n = r.mediaDetails) != null && n.length ? /* @__PURE__ */ C.jsx(wte, {
        tweet: r,
        components: e
      }) : null,
      r.quoted_tweet && /* @__PURE__ */ C.jsx(nBt, {
        tweet: r.quoted_tweet
      }),
      /* @__PURE__ */ C.jsx(MOt, {
        tweet: r
      }),
      /* @__PURE__ */ C.jsx(BOt, {
        tweet: r
      }),
      /* @__PURE__ */ C.jsx(VOt, {
        tweet: r
      })
    ]
  });
}, rBt = "_root_16yxa_1", iBt = {
  root: rBt
}, aBt = (t) => /* @__PURE__ */ C.jsx(pL, {
  children: /* @__PURE__ */ C.jsxs("div", {
    className: iBt.root,
    children: [
      /* @__PURE__ */ C.jsx("h3", {
        children: "Tweet not found"
      }),
      /* @__PURE__ */ C.jsx("p", {
        children: "The embedded tweet could not be found…"
      })
    ]
  })
}), oBt = "_skeleton_oi7hr_1", sBt = {
  skeleton: oBt
}, p4 = ({ style: t }) => /* @__PURE__ */ C.jsx("span", {
  className: sBt.skeleton,
  style: t
}), lBt = "_root_17qqv_1", cBt = {
  root: lBt
}, uBt = () => /* @__PURE__ */ C.jsxs(pL, {
  className: cBt.root,
  children: [
    /* @__PURE__ */ C.jsx(p4, {
      style: {
        height: "3rem",
        marginBottom: "0.75rem"
      }
    }),
    /* @__PURE__ */ C.jsx(p4, {
      style: {
        height: "6rem",
        margin: "0.5rem 0"
      }
    }),
    /* @__PURE__ */ C.jsx("div", {
      style: {
        borderTop: "var(--tweet-border)",
        margin: "0.5rem 0"
      }
    }),
    /* @__PURE__ */ C.jsx(p4, {
      style: {
        height: "2rem"
      }
    }),
    /* @__PURE__ */ C.jsx(p4, {
      style: {
        height: "2rem",
        borderRadius: "9999px",
        marginTop: "0.5rem"
      }
    })
  ]
});
var mk = { exports: {} }, yb = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mR;
function dBt() {
  if (mR) return yb;
  mR = 1;
  var t = Ce;
  function e(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, i = t.useEffect, a = t.useLayoutEffect, o = t.useDebugValue;
  function s(d, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), m = p[0].inst, g = p[1];
    return a(
      function() {
        m.value = h, m.getSnapshot = f, l(m) && g({ inst: m });
      },
      [d, h, f]
    ), i(
      function() {
        return l(m) && g({ inst: m }), d(function() {
          l(m) && g({ inst: m });
        });
      },
      [d]
    ), o(h), h;
  }
  function l(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return yb.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, yb;
}
var gb = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yR;
function fBt() {
  return yR || (yR = 1, process.env.NODE_ENV !== "production" && function() {
    function t(h, p) {
      return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
    }
    function e(h, p) {
      u || i.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var m = p();
      if (!d) {
        var g = p();
        a(m, g) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      g = o({
        inst: { value: m, getSnapshot: p }
      });
      var v = g[0].inst, k = g[1];
      return l(
        function() {
          v.value = m, v.getSnapshot = p, n(v) && k({ inst: v });
        },
        [h, m, p]
      ), s(
        function() {
          return n(v) && k({ inst: v }), h(function() {
            n(v) && k({ inst: v });
          });
        },
        [h]
      ), c(m), m;
    }
    function n(h) {
      var p = h.getSnapshot;
      h = h.value;
      try {
        var m = p();
        return !a(h, m);
      } catch {
        return !0;
      }
    }
    function r(h, p) {
      return p();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = Ce, a = typeof Object.is == "function" ? Object.is : t, o = i.useState, s = i.useEffect, l = i.useLayoutEffect, c = i.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : e;
    gb.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), gb;
}
process.env.NODE_ENV === "production" ? mk.exports = dBt() : mk.exports = fBt();
var hBt = mk.exports;
const xte = 0, Mte = 1, Cte = 2, gR = 3;
var vR = Object.prototype.hasOwnProperty;
function yk(t, e) {
  var n, r;
  if (t === e) return !0;
  if (t && e && (n = t.constructor) === e.constructor) {
    if (n === Date) return t.getTime() === e.getTime();
    if (n === RegExp) return t.toString() === e.toString();
    if (n === Array) {
      if ((r = t.length) === e.length)
        for (; r-- && yk(t[r], e[r]); ) ;
      return r === -1;
    }
    if (!n || typeof t == "object") {
      r = 0;
      for (n in t)
        if (vR.call(t, n) && ++r && !vR.call(e, n) || !(n in e) || !yk(t[n], e[n])) return !1;
      return Object.keys(e).length === r;
    }
  }
  return t !== t && e !== e;
}
const Hs = /* @__PURE__ */ new WeakMap(), sc = () => {
}, oi = (
  /*#__NOINLINE__*/
  sc()
), gk = Object, an = (t) => t === oi, zo = (t) => typeof t == "function", Dc = (t, e) => ({
  ...t,
  ...e
}), Ate = (t) => zo(t.then), vb = {}, m4 = {}, mL = "undefined", am = typeof window != mL, vk = typeof document != mL, pBt = am && "Deno" in window, mBt = () => am && typeof window.requestAnimationFrame != mL, Ste = (t, e) => {
  const n = Hs.get(t);
  return [
    // Getter
    () => !an(e) && t.get(e) || vb,
    // Setter
    (r) => {
      if (!an(e)) {
        const i = t.get(e);
        e in m4 || (m4[e] = i), n[5](e, Dc(i, r), i || vb);
      }
    },
    // Subscriber
    n[6],
    // Get server cache snapshot
    () => !an(e) && e in m4 ? m4[e] : !an(e) && t.get(e) || vb
  ];
};
let bk = !0;
const yBt = () => bk, [wk, kk] = am && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  sc,
  sc
], gBt = () => {
  const t = vk && document.visibilityState;
  return an(t) || t !== "hidden";
}, vBt = (t) => (vk && document.addEventListener("visibilitychange", t), wk("focus", t), () => {
  vk && document.removeEventListener("visibilitychange", t), kk("focus", t);
}), bBt = (t) => {
  const e = () => {
    bk = !0, t();
  }, n = () => {
    bk = !1;
  };
  return wk("online", e), wk("offline", n), () => {
    kk("online", e), kk("offline", n);
  };
}, wBt = {
  isOnline: yBt,
  isVisible: gBt
}, kBt = {
  initFocus: vBt,
  initReconnect: bBt
}, bR = !Ce.useId, Y2 = !am || pBt, xBt = (t) => mBt() ? window.requestAnimationFrame(t) : setTimeout(t, 1), bb = Y2 ? ze : us, wb = typeof navigator < "u" && navigator.connection, wR = !Y2 && wb && ([
  "slow-2g",
  "2g"
].includes(wb.effectiveType) || wb.saveData), y4 = /* @__PURE__ */ new WeakMap(), kb = (t, e) => gk.prototype.toString.call(t) === `[object ${e}]`;
let MBt = 0;
const xk = (t) => {
  const e = typeof t, n = kb(t, "Date"), r = kb(t, "RegExp"), i = kb(t, "Object");
  let a, o;
  if (gk(t) === t && !n && !r) {
    if (a = y4.get(t), a) return a;
    if (a = ++MBt + "~", y4.set(t, a), Array.isArray(t)) {
      for (a = "@", o = 0; o < t.length; o++)
        a += xk(t[o]) + ",";
      y4.set(t, a);
    }
    if (i) {
      a = "#";
      const s = gk.keys(t).sort();
      for (; !an(o = s.pop()); )
        an(t[o]) || (a += o + ":" + xk(t[o]) + ",");
      y4.set(t, a);
    }
  } else
    a = n ? t.toJSON() : e == "symbol" ? t.toString() : e == "string" ? JSON.stringify(t) : "" + t;
  return a;
}, yL = (t) => {
  if (zo(t))
    try {
      t = t();
    } catch {
      t = "";
    }
  const e = t;
  return t = typeof t == "string" ? t : (Array.isArray(t) ? t.length : t) ? xk(t) : "", [
    t,
    e
  ];
};
let CBt = 0;
const Mk = () => ++CBt;
async function Lte(...t) {
  const [e, n, r, i] = t, a = Dc({
    populateCache: !0,
    throwOnError: !0
  }, typeof i == "boolean" ? {
    revalidate: i
  } : i || {});
  let o = a.populateCache;
  const s = a.rollbackOnError;
  let l = a.optimisticData;
  const c = (f) => typeof s == "function" ? s(f) : s !== !1, u = a.throwOnError;
  if (zo(n)) {
    const f = n, h = [], p = e.keys();
    for (const m of p)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(m) && f(e.get(m)._k) && h.push(m);
    return Promise.all(h.map(d));
  }
  return d(n);
  async function d(f) {
    const [h] = yL(f);
    if (!h) return;
    const [p, m] = Ste(e, h), [g, v, k, w] = Hs.get(e), b = () => {
      const V = g[h];
      return (zo(a.revalidate) ? a.revalidate(p().data, f) : a.revalidate !== !1) && (delete k[h], delete w[h], V && V[0]) ? V[0](Cte).then(() => p().data) : p().data;
    };
    if (t.length < 3)
      return b();
    let x = r, A;
    const L = Mk();
    v[h] = [
      L,
      0
    ];
    const M = !an(l), j = p(), D = j.data, z = j._c, H = an(z) ? D : z;
    if (M && (l = zo(l) ? l(H, D) : l, m({
      data: l,
      _c: H
    })), zo(x))
      try {
        x = x(H);
      } catch (V) {
        A = V;
      }
    if (x && Ate(x))
      if (x = await x.catch((V) => {
        A = V;
      }), L !== v[h][0]) {
        if (A) throw A;
        return x;
      } else A && M && c(A) && (o = !0, m({
        data: H,
        _c: oi
      }));
    if (o && !A)
      if (zo(o)) {
        const V = o(x, H);
        m({
          data: V,
          error: oi,
          _c: oi
        });
      } else
        m({
          data: x,
          error: oi,
          _c: oi
        });
    if (v[h][1] = Mk(), Promise.resolve(b()).then(() => {
      m({
        _c: oi
      });
    }), A) {
      if (u) throw A;
      return;
    }
    return x;
  }
}
const kR = (t, e) => {
  for (const n in t)
    t[n][0] && t[n][0](e);
}, ABt = (t, e) => {
  if (!Hs.has(t)) {
    const n = Dc(kBt, e), r = /* @__PURE__ */ Object.create(null), i = Lte.bind(oi, t);
    let a = sc;
    const o = /* @__PURE__ */ Object.create(null), s = (u, d) => {
      const f = o[u] || [];
      return o[u] = f, f.push(d), () => f.splice(f.indexOf(d), 1);
    }, l = (u, d, f) => {
      t.set(u, d);
      const h = o[u];
      if (h)
        for (const p of h)
          p(d, f);
    }, c = () => {
      if (!Hs.has(t) && (Hs.set(t, [
        r,
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        i,
        l,
        s
      ]), !Y2)) {
        const u = n.initFocus(setTimeout.bind(oi, kR.bind(oi, r, xte))), d = n.initReconnect(setTimeout.bind(oi, kR.bind(oi, r, Mte)));
        a = () => {
          u && u(), d && d(), Hs.delete(t);
        };
      }
    };
    return c(), [
      t,
      i,
      c,
      a
    ];
  }
  return [
    t,
    Hs.get(t)[4]
  ];
}, SBt = (t, e, n, r, i) => {
  const a = n.errorRetryCount, o = i.retryCount, s = ~~((Math.random() + 0.5) * (1 << (o < 8 ? o : 8))) * n.errorRetryInterval;
  !an(a) && o > a || setTimeout(r, s, i);
}, LBt = yk, [Tte, TBt] = ABt(/* @__PURE__ */ new Map()), EBt = Dc(
  {
    // events
    onLoadingSlow: sc,
    onSuccess: sc,
    onError: sc,
    onErrorRetry: SBt,
    onDiscarded: sc,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: wR ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: wR ? 5e3 : 3e3,
    // providers
    compare: LBt,
    isPaused: () => !1,
    cache: Tte,
    mutate: TBt,
    fallback: {}
  },
  // use web preset by default
  wBt
), jBt = (t, e) => {
  const n = Dc(t, e);
  if (e) {
    const { use: r, fallback: i } = t, { use: a, fallback: o } = e;
    r && a && (n.use = r.concat(a)), i && o && (n.fallback = Dc(i, o));
  }
  return n;
}, NBt = xn({}), DBt = "$inf$", Ete = am && window.__SWR_DEVTOOLS_USE__, IBt = Ete ? window.__SWR_DEVTOOLS_USE__ : [], PBt = () => {
  Ete && (window.__SWR_DEVTOOLS_REACT__ = Ce);
}, zBt = (t) => zo(t[1]) ? [
  t[0],
  t[1],
  t[2] || {}
] : [
  t[0],
  null,
  (t[1] === null ? t[2] : t[1]) || {}
], RBt = () => Dc(EBt, Mt(NBt)), OBt = (t) => (e, n, r) => t(e, n && ((...a) => {
  const [o] = yL(e), [, , , s] = Hs.get(Tte);
  if (o.startsWith(DBt))
    return n(...a);
  const l = s[o];
  return an(l) ? n(...a) : (delete s[o], l);
}), r), BBt = IBt.concat(OBt), HBt = (t) => function(...n) {
  const r = RBt(), [i, a, o] = zBt(n), s = jBt(r, o);
  let l = t;
  const { use: c } = s, u = (c || []).concat(BBt);
  for (let d = u.length; d--; )
    l = u[d](l);
  return l(i, a || s.fetcher || null, s);
}, FBt = (t, e, n) => {
  const r = e[t] || (e[t] = []);
  return r.push(n), () => {
    const i = r.indexOf(n);
    i >= 0 && (r[i] = r[r.length - 1], r.pop());
  };
};
PBt();
const xb = Ce.use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((t) => {
  switch (t.status) {
    case "pending":
      throw t;
    case "fulfilled":
      return t.value;
    case "rejected":
      throw t.reason;
    default:
      throw t.status = "pending", t.then((e) => {
        t.status = "fulfilled", t.value = e;
      }, (e) => {
        t.status = "rejected", t.reason = e;
      }), t;
  }
}), Mb = {
  dedupe: !0
}, _Bt = (t, e, n) => {
  const { cache: r, compare: i, suspense: a, fallbackData: o, revalidateOnMount: s, revalidateIfStale: l, refreshInterval: c, refreshWhenHidden: u, refreshWhenOffline: d, keepPreviousData: f } = n, [h, p, m, g] = Hs.get(r), [v, k] = yL(t), w = Ue(!1), b = Ue(!1), x = Ue(v), A = Ue(e), L = Ue(n), M = () => L.current, j = () => M().isVisible() && M().isOnline(), [D, z, H, V] = Ste(r, v), F = Ue({}).current, _ = an(o) ? an(n.fallback) ? oi : n.fallback[v] : o, W = (pe, J) => {
    for (const K in F) {
      const X = K;
      if (X === "data") {
        if (!i(pe[X], J[X]) && (!an(pe[X]) || !i(ge, J[X])))
          return !1;
      } else if (J[X] !== pe[X])
        return !1;
    }
    return !0;
  }, G = Ft(() => {
    const pe = !v || !e ? !1 : an(s) ? M().isPaused() || a ? !1 : l !== !1 : s, J = (S) => {
      const P = Dc(S);
      return delete P._k, pe ? {
        isValidating: !0,
        isLoading: !0,
        ...P
      } : P;
    }, K = D(), X = V(), re = J(K), Ie = K === X ? re : J(X);
    let q = re;
    return [
      () => {
        const S = J(D());
        return W(S, q) ? (q.data = S.data, q.isLoading = S.isLoading, q.isValidating = S.isValidating, q.error = S.error, q) : (q = S, S);
      },
      () => Ie
    ];
  }, [
    r,
    v
  ]), Y = hBt.useSyncExternalStore(nt(
    (pe) => H(v, (J, K) => {
      W(K, J) || pe();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      v
    ]
  ), G[0], G[1]), Z = !w.current, oe = h[v] && h[v].length > 0, ee = Y.data, ae = an(ee) ? _ && Ate(_) ? xb(_) : _ : ee, fe = Y.error, me = Ue(ae), ge = f ? an(ee) ? an(me.current) ? ae : me.current : ee : ae, $ = oe && !an(fe) ? !1 : Z && !an(s) ? s : M().isPaused() ? !1 : a ? an(ae) ? !1 : l : an(ae) || l, se = !!(v && e && Z && $), xe = an(Y.isValidating) ? se : Y.isValidating, Oe = an(Y.isLoading) ? se : Y.isLoading, je = nt(
    async (pe) => {
      const J = A.current;
      if (!v || !J || b.current || M().isPaused())
        return !1;
      let K, X, re = !0;
      const Ie = pe || {}, q = !m[v] || !Ie.dedupe, S = () => bR ? !b.current && v === x.current && w.current : v === x.current, P = {
        isValidating: !1,
        isLoading: !1
      }, O = () => {
        z(P);
      }, ne = () => {
        const de = m[v];
        de && de[1] === X && delete m[v];
      }, le = {
        isValidating: !0
      };
      an(D().data) && (le.isLoading = !0);
      try {
        if (q && (z(le), n.loadingTimeout && an(D().data) && setTimeout(() => {
          re && S() && M().onLoadingSlow(v, n);
        }, n.loadingTimeout), m[v] = [
          J(k),
          Mk()
        ]), [K, X] = m[v], K = await K, q && setTimeout(ne, n.dedupingInterval), !m[v] || m[v][1] !== X)
          return q && S() && M().onDiscarded(v), !1;
        P.error = oi;
        const de = p[v];
        if (!an(de) && // case 1
        (X <= de[0] || // case 2
        X <= de[1] || // case 3
        de[1] === 0))
          return O(), q && S() && M().onDiscarded(v), !1;
        const Pe = D().data;
        P.data = i(Pe, K) ? Pe : K, q && S() && M().onSuccess(K, v, n);
      } catch (de) {
        ne();
        const Pe = M(), { shouldRetryOnError: ve } = Pe;
        Pe.isPaused() || (P.error = de, q && S() && (Pe.onError(de, v, Pe), (ve === !0 || zo(ve) && ve(de)) && (!M().revalidateOnFocus || !M().revalidateOnReconnect || j()) && Pe.onErrorRetry(de, v, Pe, (Le) => {
          const Re = h[v];
          Re && Re[0] && Re[0](gR, Le);
        }, {
          retryCount: (Ie.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return re = !1, O(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      v,
      r
    ]
  ), Me = nt(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...pe) => Lte(r, x.current, ...pe),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (bb(() => {
    A.current = e, L.current = n, an(ee) || (me.current = ee);
  }), bb(() => {
    if (!v) return;
    const pe = je.bind(oi, Mb);
    let J = 0;
    M().revalidateOnFocus && (J = Date.now() + M().focusThrottleInterval);
    const X = FBt(v, h, (re, Ie = {}) => {
      if (re == xte) {
        const q = Date.now();
        M().revalidateOnFocus && q > J && j() && (J = q + M().focusThrottleInterval, pe());
      } else if (re == Mte)
        M().revalidateOnReconnect && j() && pe();
      else {
        if (re == Cte)
          return je();
        if (re == gR)
          return je(Ie);
      }
    });
    return b.current = !1, x.current = v, w.current = !0, z({
      _k: k
    }), $ && (an(ae) || Y2 ? pe() : xBt(pe)), () => {
      b.current = !0, X();
    };
  }, [
    v
  ]), bb(() => {
    let pe;
    function J() {
      const X = zo(c) ? c(D().data) : c;
      X && pe !== -1 && (pe = setTimeout(K, X));
    }
    function K() {
      !D().error && (u || M().isVisible()) && (d || M().isOnline()) ? je(Mb).then(J) : J();
    }
    return J(), () => {
      pe && (clearTimeout(pe), pe = -1);
    };
  }, [
    c,
    u,
    d,
    v
  ]), Uk(ge), a && an(ae) && v) {
    if (!bR && Y2)
      throw new Error("Fallback data is required when using Suspense in SSR.");
    A.current = e, L.current = n, b.current = !1;
    const pe = g[v];
    if (!an(pe)) {
      const J = Me(pe);
      xb(J);
    }
    if (an(fe)) {
      const J = je(Mb);
      an(ge) || (J.status = "fulfilled", J.value = !0), xb(J);
    } else
      throw fe;
  }
  return {
    mutate: Me,
    get data() {
      return F.data = !0, ge;
    },
    get error() {
      return F.error = !0, fe;
    },
    get isValidating() {
      return F.isValidating = !0, xe;
    },
    get isLoading() {
      return F.isLoading = !0, Oe;
    }
  };
}, xR = HBt(_Bt);
class VBt extends Error {
  constructor({ message: e, status: n, data: r }) {
    super(e), this.name = "TwitterApiError", this.status = n, this.data = r;
  }
}
const qBt = xR.default || xR, UBt = "https://react-tweet.vercel.app";
async function WBt([t, e]) {
  const n = await fetch(t, e), r = await n.json();
  if (n.ok) return r.data || null;
  throw new VBt({
    message: `Failed to fetch tweet at "${t}" with "${n.status}".`,
    data: r,
    status: n.status
  });
}
const ZBt = (t, e, n) => {
  const { isLoading: r, data: i, error: a } = qBt(() => e || t ? [
    e || t && `${UBt}/api/tweet/${t}`,
    n
  ] : null, WBt, {
    revalidateIfStale: !1,
    revalidateOnFocus: !1,
    shouldRetryOnError: !1
  });
  return {
    // If data is `undefined` then it might be the first render where SWR hasn't started doing
    // any work, so we set `isLoading` to `true`.
    isLoading: !!(r || i === void 0 && !a),
    data: i,
    error: a
  };
}, GBt = ({ id: t, apiUrl: e, fallback: n = /* @__PURE__ */ C.jsx(uBt, {}), components: r, fetchOptions: i, onError: a }) => {
  const { data: o, error: s, isLoading: l } = ZBt(t, e, i);
  if (l) return n;
  if (s || !o) {
    const c = (r == null ? void 0 : r.TweetNotFound) || aBt;
    return /* @__PURE__ */ C.jsx(c, {
      error: a ? a(s) : s
    });
  }
  return /* @__PURE__ */ C.jsx(kte, {
    tweet: o,
    components: r
  });
}, YBt = ({ node: t, editor: e }) => {
  const [n, r] = De(null);
  return ze(() => {
    e == null || e.chain().focus(), (async () => {
      try {
        const o = await (await fetch(
          `https://react-tweet.vercel.app/api/tweet/${t.attrs.tweetId}`
        )).json();
        r(o.data);
      } catch (a) {
        console.error("Error fetching tweet:", a);
      }
    })();
  }, [t.attrs.tweetId]), /* @__PURE__ */ C.jsx(
    $u,
    {
      as: "div",
      className: "flex gap-2 group w-full relative justify-center items-start",
      children: /* @__PURE__ */ C.jsx("div", { className: "w-full flex justify-center items-center min-h-[200px]", children: n ? /* @__PURE__ */ C.jsx(kte, { tweet: n }) : /* @__PURE__ */ C.jsx(GBt, { id: t.attrs.tweetId }) })
    }
  );
}, KBt = Ht.create({
  name: "embeddedTweet",
  group: "block",
  atom: !0,
  draggable: !0,
  addOptions() {
    return {
      HTMLAttributes: {
        class: ""
      }
    };
  },
  addAttributes() {
    return {
      tweetId: {
        default: null
      },
      align: {
        default: "center"
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-tweet-id]"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "div",
      _t(this.options.HTMLAttributes, t)
    ];
  },
  addNodeView() {
    return Hc(YBt);
  },
  addCommands() {
    return {
      setTweetEmbed: (t) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: {
          tweetId: t.tweetId,
          // directly set the tweetId attribute
          align: "center"
          // we can also set other attributes here
        },
        content: []
      })
    };
  }
});
function jte(t, e) {
  let n;
  return (...i) => {
    clearTimeout(n), n = setTimeout(() => t(...i), e);
  };
}
const $Bt = (t, e, n) => {
  const r = nt(() => {
    const s = t.chain();
    s.setNodeSelection(n).unsetAllMarks(), (e == null ? void 0 : e.type.name) !== "paragraph" && s.setParagraph(), s.run();
  }, [t, n, e == null ? void 0 : e.type.name]), i = nt(() => {
    t.commands.setNodeSelection(n);
    const { $anchor: s } = t.state.selection, l = s.node(1) || t.state.selection.node;
    t.chain().setMeta("hideDragHandle", !0).insertContentAt(
      n + ((e == null ? void 0 : e.nodeSize) || 0),
      l.toJSON()
    ).run();
  }, [t, n, e == null ? void 0 : e.nodeSize]), a = nt(() => {
    t.chain().setMeta("hideDragHandle", !0).setNodeSelection(n).run(), document.execCommand("copy"), uu({
      title: "Copied to clipboard",
      variant: "success"
    });
  }, [t, n]), o = nt(() => {
    t.chain().setMeta("hideDragHandle", !0).setNodeSelection(n).deleteSelection().run();
  }, [t, n]);
  return {
    resetTextFormatting: r,
    duplicateNode: i,
    copyNodeToClipboard: a,
    deleteNode: o
  };
};
function MR(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function Nte(...t) {
  return (e) => {
    let n = !1;
    const r = t.map((i) => {
      const a = MR(i, e);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const a = r[i];
          typeof a == "function" ? a() : MR(t[i], null);
        }
      };
  };
}
function JBt(...t) {
  return N.useCallback(Nte(...t), t);
}
var Dte = N.forwardRef((t, e) => {
  const { children: n, ...r } = t, i = N.Children.toArray(n), a = i.find(XBt);
  if (a) {
    const o = a.props.children, s = i.map((l) => l === a ? N.Children.count(o) > 1 ? N.Children.only(null) : N.isValidElement(o) ? o.props.children : null : l);
    return /* @__PURE__ */ C.jsx(Ck, { ...r, ref: e, children: N.isValidElement(o) ? N.cloneElement(o, void 0, s) : null });
  }
  return /* @__PURE__ */ C.jsx(Ck, { ...r, ref: e, children: n });
});
Dte.displayName = "Slot";
var Ck = N.forwardRef((t, e) => {
  const { children: n, ...r } = t;
  if (N.isValidElement(n)) {
    const i = tHt(n), a = eHt(r, n.props);
    return n.type !== N.Fragment && (a.ref = e ? Nte(e, i) : i), N.cloneElement(n, a);
  }
  return N.Children.count(n) > 1 ? N.Children.only(null) : null;
});
Ck.displayName = "SlotClone";
var QBt = ({ children: t }) => /* @__PURE__ */ C.jsx(C.Fragment, { children: t });
function XBt(t) {
  return N.isValidElement(t) && t.type === QBt;
}
function eHt(t, e) {
  const n = { ...e };
  for (const r in e) {
    const i = t[r], a = e[r];
    /^on[A-Z]/.test(r) ? i && a ? n[r] = (...s) => {
      a(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...a } : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function tHt(t) {
  var r, i;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (i = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var nHt = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], rHt = nHt.reduce((t, e) => {
  const n = N.forwardRef((r, i) => {
    const { asChild: a, ...o } = r, s = a ? Dte : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ C.jsx(s, { ...o, ref: i });
  });
  return n.displayName = `Primitive.${e}`, { ...t, [e]: n };
}, {});
function CR(t) {
  const e = N.useRef(t);
  return N.useEffect(() => {
    e.current = t;
  }), N.useMemo(() => (...n) => {
    var r;
    return (r = e.current) == null ? void 0 : r.call(e, ...n);
  }, []);
}
var Cb = "focusScope.autoFocusOnMount", Ab = "focusScope.autoFocusOnUnmount", AR = { bubbles: !1, cancelable: !0 }, iHt = "FocusScope", Ite = N.forwardRef((t, e) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: a,
    ...o
  } = t, [s, l] = N.useState(null), c = CR(i), u = CR(a), d = N.useRef(null), f = JBt(e, (m) => l(m)), h = N.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  N.useEffect(() => {
    if (r) {
      let m = function(w) {
        if (h.paused || !s) return;
        const b = w.target;
        s.contains(b) ? d.current = b : Wl(d.current, { select: !0 });
      }, g = function(w) {
        if (h.paused || !s) return;
        const b = w.relatedTarget;
        b !== null && (s.contains(b) || Wl(d.current, { select: !0 }));
      }, v = function(w) {
        if (document.activeElement === document.body)
          for (const x of w)
            x.removedNodes.length > 0 && Wl(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", g);
      const k = new MutationObserver(v);
      return s && k.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", g), k.disconnect();
      };
    }
  }, [r, s, h.paused]), N.useEffect(() => {
    if (s) {
      LR.add(h);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const v = new CustomEvent(Cb, AR);
        s.addEventListener(Cb, c), s.dispatchEvent(v), v.defaultPrevented || (aHt(uHt(Pte(s)), { select: !0 }), document.activeElement === m && Wl(s));
      }
      return () => {
        s.removeEventListener(Cb, c), setTimeout(() => {
          const v = new CustomEvent(Ab, AR);
          s.addEventListener(Ab, u), s.dispatchEvent(v), v.defaultPrevented || Wl(m ?? document.body, { select: !0 }), s.removeEventListener(Ab, u), LR.remove(h);
        }, 0);
      };
    }
  }, [s, c, u, h]);
  const p = N.useCallback(
    (m) => {
      if (!n && !r || h.paused) return;
      const g = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, v = document.activeElement;
      if (g && v) {
        const k = m.currentTarget, [w, b] = oHt(k);
        w && b ? !m.shiftKey && v === b ? (m.preventDefault(), n && Wl(w, { select: !0 })) : m.shiftKey && v === w && (m.preventDefault(), n && Wl(b, { select: !0 })) : v === k && m.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ C.jsx(rHt.div, { tabIndex: -1, ...o, ref: f, onKeyDown: p });
});
Ite.displayName = iHt;
function aHt(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (Wl(r, { select: e }), document.activeElement !== n) return;
}
function oHt(t) {
  const e = Pte(t), n = SR(e, t), r = SR(e.reverse(), t);
  return [n, r];
}
function Pte(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function SR(t, e) {
  for (const n of t)
    if (!sHt(n, { upTo: e })) return n;
}
function sHt(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden") return !0;
  for (; t; ) {
    if (e !== void 0 && t === e) return !1;
    if (getComputedStyle(t).display === "none") return !0;
    t = t.parentElement;
  }
  return !1;
}
function lHt(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Wl(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== n && lHt(t) && e && t.select();
  }
}
var LR = cHt();
function cHt() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = TR(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = TR(t, e), (n = t[0]) == null || n.resume();
    }
  };
}
function TR(t, e) {
  const n = [...t], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function uHt(t) {
  return t.filter((e) => e.tagName !== "A");
}
const Do = (t) => {
  switch (t) {
    case "meeting-notes":
      return {
        type: "doc",
        content: [
          {
            type: "dBlock",
            content: [
              {
                type: "heading",
                attrs: {
                  textAlign: "left",
                  level: 1
                },
                content: [
                  {
                    type: "text",
                    text: "[Date] | [Event]"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "heading",
                attrs: {
                  textAlign: "left",
                  level: 3
                },
                content: [
                  {
                    type: "text",
                    text: "Notes"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "bulletList",
                attrs: {
                  tight: !0
                },
                content: [
                  {
                    type: "listItem",
                    content: [
                      {
                        type: "paragraph",
                        attrs: {
                          textAlign: "left"
                        },
                        content: [
                          {
                            type: "text",
                            text: "Add note item"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "listItem",
                    content: [
                      {
                        type: "paragraph",
                        attrs: {
                          textAlign: "left"
                        },
                        content: [
                          {
                            type: "text",
                            text: "Add note item"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "heading",
                attrs: {
                  textAlign: "left",
                  level: 3
                },
                content: [
                  {
                    type: "text",
                    text: "Action items"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "taskList",
                content: [
                  {
                    type: "taskItem",
                    attrs: {
                      checked: !1
                    },
                    content: [
                      {
                        type: "paragraph",
                        attrs: {
                          textAlign: "left"
                        },
                        content: [
                          {
                            type: "text",
                            text: "Add action item"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "taskItem",
                    attrs: {
                      checked: !1
                    },
                    content: [
                      {
                        type: "paragraph",
                        attrs: {
                          textAlign: "left"
                        },
                        content: [
                          {
                            type: "text",
                            text: "Add action item"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ],
        title: "Meeting Notes"
      };
    case "todo-list":
      return {
        type: "doc",
        content: [
          {
            type: "dBlock",
            content: [
              {
                type: "heading",
                attrs: {
                  textAlign: "left",
                  level: 1
                },
                content: [
                  {
                    type: "text",
                    text: "📋 To-do List"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "table",
                content: [
                  {
                    type: "tableRow",
                    content: [
                      {
                        type: "tableHeader",
                        attrs: {
                          colspan: 1,
                          rowspan: 1,
                          colwidth: null
                        },
                        content: [
                          {
                            type: "paragraph",
                            attrs: {
                              textAlign: "left"
                            },
                            content: [
                              {
                                type: "text",
                                text: "Action item"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "tableHeader",
                        attrs: {
                          colspan: 1,
                          rowspan: 1,
                          colwidth: null
                        },
                        content: [
                          {
                            type: "paragraph",
                            attrs: {
                              textAlign: "left"
                            },
                            content: [
                              {
                                type: "text",
                                text: "Deadline"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "tableRow",
                    content: [
                      {
                        type: "tableCell",
                        attrs: {
                          colspan: 1,
                          rowspan: 1,
                          colwidth: null
                        },
                        content: [
                          {
                            type: "taskList",
                            content: [
                              {
                                type: "taskItem",
                                attrs: {
                                  checked: !1
                                },
                                content: [
                                  {
                                    type: "paragraph",
                                    attrs: {
                                      textAlign: "left"
                                    },
                                    content: [
                                      {
                                        type: "text",
                                        text: "Add action item"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "tableCell",
                        attrs: {
                          colspan: 1,
                          rowspan: 1,
                          colwidth: null
                        },
                        content: [
                          {
                            type: "paragraph",
                            attrs: {
                              textAlign: "left"
                            },
                            content: [
                              {
                                type: "text",
                                text: "DD.MM.YYYY"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "tableRow",
                    content: [
                      {
                        type: "tableCell",
                        attrs: {
                          colspan: 1,
                          rowspan: 1,
                          colwidth: null
                        },
                        content: [
                          {
                            type: "taskList",
                            content: [
                              {
                                type: "taskItem",
                                attrs: {
                                  checked: !1
                                },
                                content: [
                                  {
                                    type: "paragraph",
                                    attrs: {
                                      textAlign: "left"
                                    },
                                    content: [
                                      {
                                        type: "text",
                                        text: "Add action item"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "tableCell",
                        attrs: {
                          colspan: 1,
                          rowspan: 1,
                          colwidth: null
                        },
                        content: [
                          {
                            type: "paragraph",
                            attrs: {
                              textAlign: "left"
                            },
                            content: [
                              {
                                type: "text",
                                text: "DD.MM.YYYY"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "tableRow",
                    content: [
                      {
                        type: "tableCell",
                        attrs: {
                          colspan: 1,
                          rowspan: 1,
                          colwidth: null
                        },
                        content: [
                          {
                            type: "taskList",
                            content: [
                              {
                                type: "taskItem",
                                attrs: {
                                  checked: !1
                                },
                                content: [
                                  {
                                    type: "paragraph",
                                    attrs: {
                                      textAlign: "left"
                                    },
                                    content: [
                                      {
                                        type: "text",
                                        text: "Add action item"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "tableCell",
                        attrs: {
                          colspan: 1,
                          rowspan: 1,
                          colwidth: null
                        },
                        content: [
                          {
                            type: "paragraph",
                            attrs: {
                              textAlign: "left"
                            },
                            content: [
                              {
                                type: "text",
                                text: "DD.MM.YYYY"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ],
        title: "To-do List"
      };
    case "brainstorm":
      return {
        type: "doc",
        content: [
          {
            type: "dBlock",
            content: [
              {
                type: "heading",
                attrs: {
                  textAlign: "left",
                  level: 1
                },
                content: [
                  {
                    type: "text",
                    text: "💡 Brainstorming"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "heading",
                attrs: {
                  textAlign: "left",
                  level: 2
                },
                content: [
                  {
                    type: "text",
                    text: "[Issues & Goals]"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "bulletList",
                attrs: {
                  tight: !0
                },
                content: [
                  {
                    type: "listItem",
                    content: [
                      {
                        type: "paragraph",
                        attrs: {
                          textAlign: "left"
                        },
                        content: [
                          {
                            type: "text",
                            text: "First idea"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "listItem",
                    content: [
                      {
                        type: "paragraph",
                        attrs: {
                          textAlign: "left"
                        },
                        content: [
                          {
                            type: "text",
                            text: "Second idea"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "listItem",
                    content: [
                      {
                        type: "paragraph",
                        attrs: {
                          textAlign: "left"
                        },
                        content: [
                          {
                            type: "text",
                            text: "Third idea"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "heading",
                attrs: {
                  textAlign: "left",
                  level: 2
                },
                content: [
                  {
                    type: "text",
                    text: "Summaries:"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "bulletList",
                attrs: {
                  tight: !0
                },
                content: [
                  {
                    type: "listItem",
                    content: [
                      {
                        type: "paragraph",
                        attrs: {
                          textAlign: "left"
                        },
                        content: [
                          {
                            type: "text",
                            text: "Summary 1"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "listItem",
                    content: [
                      {
                        type: "paragraph",
                        attrs: {
                          textAlign: "left"
                        },
                        content: [
                          {
                            type: "text",
                            text: "Summary 2"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ],
        title: "Brainstorming"
      };
    case "breathe":
      return {
        type: "doc",
        content: [
          {
            type: "dBlock",
            content: [
              {
                type: "heading",
                attrs: {
                  textAlign: "center",
                  level: 1
                },
                content: [
                  {
                    type: "text",
                    text: "Take your time"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "paragraph",
                attrs: {
                  textAlign: "center"
                },
                content: [
                  {
                    type: "text",
                    text: "Just breathe"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "resizableMedia",
                attrs: {
                  src: "https://i.imgur.com/Huou7Gh.gif",
                  "media-type": "img",
                  alt: null,
                  title: null,
                  width: "100%",
                  height: "auto",
                  dataAlign: "center",
                  dataFloat: null
                }
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "heading",
                attrs: {
                  textAlign: "center",
                  level: 3
                },
                content: [
                  {
                    type: "text",
                    text: "Follow the breathing triangle, do it 5 times"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "paragraph",
                attrs: {
                  textAlign: "center"
                },
                content: [
                  {
                    type: "text",
                    text: "When you are overwhelmed at work… or after handling a tough situation... when the market plumets.. when everything goes wrong.. or you're having a simple writer's block"
                  }
                ]
              }
            ]
          }
        ],
        title: "Breathe"
      };
    case "pretend-to-work":
      return {
        type: "doc",
        content: [
          {
            type: "dBlock",
            content: [
              {
                type: "heading",
                attrs: {
                  textAlign: "left",
                  level: 1
                },
                content: [
                  {
                    type: "text",
                    marks: [
                      {
                        type: "textStyle",
                        attrs: {
                          fontFamily: "Georgia, serif",
                          color: ""
                        }
                      }
                    ],
                    text: "Some ways to use ZK-SNARKs for privacy"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "paragraph",
                attrs: {
                  textAlign: "left"
                },
                content: [
                  {
                    type: "text",
                    text: "ZK-SNARKs are a powerful cryptographic tool, and an increasingly important part of the applications that people are building both in the blockchain space and beyond. But they are complicated, both in terms of "
                  },
                  {
                    type: "text",
                    marks: [
                      {
                        type: "italic"
                      }
                    ],
                    text: "how they work"
                  },
                  {
                    type: "text",
                    text: ", and in terms of "
                  },
                  {
                    type: "text",
                    marks: [
                      {
                        type: "italic"
                      }
                    ],
                    text: "how you can use them"
                  },
                  {
                    type: "text",
                    text: "."
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "heading",
                attrs: {
                  textAlign: "left",
                  level: 2
                },
                content: [
                  {
                    type: "text",
                    text: "What does a ZK-SNARK do?"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "paragraph",
                attrs: {
                  textAlign: "left"
                },
                content: [
                  {
                    type: "text",
                    text: "Suppose that you have a public input x, a private input w, and a (public) function "
                  },
                  {
                    type: "text",
                    marks: [
                      {
                        type: "textStyle",
                        attrs: {
                          fontFamily: "MJXc-TeX-math-Iw",
                          color: ""
                        }
                      }
                    ],
                    text: "f(x,w)→{True,False}"
                  },
                  {
                    type: "text",
                    text: " that performs some kind of verification on the inputs. With a ZK-SNARK, you can prove that you know an w such that "
                  },
                  {
                    type: "text",
                    marks: [
                      {
                        type: "textStyle",
                        attrs: {
                          fontFamily: "MJXc-TeX-math-Iw",
                          color: ""
                        }
                      }
                    ],
                    text: "f(x,w)=True"
                  },
                  {
                    type: "text",
                    text: " for some given "
                  },
                  {
                    type: "text",
                    marks: [
                      {
                        type: "textStyle",
                        attrs: {
                          fontFamily: "MJXc-TeX-math-Iw",
                          color: ""
                        }
                      }
                    ],
                    text: "f"
                  },
                  {
                    type: "text",
                    text: " and "
                  },
                  {
                    type: "text",
                    marks: [
                      {
                        type: "textStyle",
                        attrs: {
                          fontFamily: "MJXc-TeX-math-Iw",
                          color: ""
                        }
                      }
                    ],
                    text: "x"
                  },
                  {
                    type: "text",
                    text: ", without revealing what "
                  },
                  {
                    type: "text",
                    marks: [
                      {
                        type: "textStyle",
                        attrs: {
                          fontFamily: "MJXc-TeX-math-Iw",
                          color: ""
                        }
                      }
                    ],
                    text: "w"
                  },
                  {
                    type: "text",
                    text: " is. Additionally, the verifier can verify the proof much faster than it would take for them to compute "
                  },
                  {
                    type: "text",
                    marks: [
                      {
                        type: "textStyle",
                        attrs: {
                          fontFamily: "MJXc-TeX-math-Iw",
                          color: ""
                        }
                      }
                    ],
                    text: "f(x,w)"
                  },
                  {
                    type: "text",
                    text: " themselves, even if they know "
                  },
                  {
                    type: "text",
                    marks: [
                      {
                        type: "textStyle",
                        attrs: {
                          fontFamily: "MJXc-TeX-math-Iw",
                          color: ""
                        }
                      }
                    ],
                    text: "w"
                  },
                  {
                    type: "text",
                    text: "."
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "resizableMedia",
                attrs: {
                  src: "https://vitalik.eth.limo/images/using_snarks/definition.png",
                  "media-type": "img",
                  alt: null,
                  title: null,
                  width: "100%",
                  height: "auto",
                  dataAlign: "center",
                  dataFloat: null
                }
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "paragraph",
                attrs: {
                  textAlign: "left"
                },
                content: [
                  {
                    type: "text",
                    text: "This gives the ZK-SNARK its two properties: "
                  },
                  {
                    type: "text",
                    marks: [
                      {
                        type: "bold"
                      }
                    ],
                    text: "privacy"
                  },
                  {
                    type: "text",
                    text: " and "
                  },
                  {
                    type: "text",
                    marks: [
                      {
                        type: "bold"
                      }
                    ],
                    text: "scalability"
                  },
                  {
                    type: "text",
                    text: ". As mentioned above, in this post our examples will focus on privacy."
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "heading",
                attrs: {
                  textAlign: "left",
                  level: 2
                },
                content: [
                  {
                    type: "text",
                    text: "Holding centralized parties accountable"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "paragraph",
                attrs: {
                  textAlign: "left"
                },
                content: [
                  {
                    type: "text",
                    text: `Sometimes, you need to build a scheme that has a central "operator" of some kind. This could be for many reasons: sometimes it's for scalability, and sometimes it's for privacy - specifically, the privacy of data held by the operator.`
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "paragraph",
                attrs: {
                  textAlign: "left"
                },
                content: [
                  {
                    type: "text",
                    text: "The MACI coercion-resistant voting system, for example, requires voters to submit their votes on-chain encrypted to a secret key held by a central operator. The operator would decrypt all the votes on-chain, count them up, and reveal the final result, along with a ZK-SNARK proving that they did everything correctly. This extra complexity is necessary to ensure a strong privacy property (called "
                  },
                  {
                    type: "text",
                    marks: [
                      {
                        type: "bold"
                      }
                    ],
                    text: "coercion-resistance"
                  },
                  {
                    type: "text",
                    text: "): that users cannot prove to others how they voted even if they wanted to."
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "paragraph",
                attrs: {
                  textAlign: "left"
                },
                content: [
                  {
                    type: "text",
                    text: "Thanks to blockchains and ZK-SNARKs, the amount of trust in the operator can be kept very low. A malicious operator could still break coercion resistance, but because votes are published on the blockchain, the operator cannot cheat by censoring votes, and because the operator must provide a ZK-SNARK, they cannot cheat by mis-calculating the result."
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "heading",
                attrs: {
                  textAlign: "left",
                  level: 2
                },
                content: [
                  {
                    type: "text",
                    text: "Combining ZK-SNARKs with MPC"
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "paragraph",
                attrs: {
                  textAlign: "left"
                },
                content: [
                  {
                    type: "text",
                    text: "A more advanced use of ZK-SNARKs involves making proofs over computations where the inputs are split between two or more parties, and we don't want each party to learn the other parties' inputs. You can satisfy the privacy requirement with "
                  },
                  {
                    type: "text",
                    marks: [
                      {
                        type: "link",
                        attrs: {
                          href: "https://vitalik.eth.limo/general/2020/03/21/garbled.html",
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: "custom-text-link"
                        }
                      }
                    ],
                    text: "garbled circuits"
                  },
                  {
                    type: "text",
                    text: " in the 2-party case, and more complicated multi-party computation protocols in the N-party case. ZK-SNARKs can be combined with these protocols to do verifiable multi-party computation."
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "paragraph",
                attrs: {
                  textAlign: "left"
                },
                content: [
                  {
                    type: "text",
                    text: "This could enable more advanced reputation systems where multiple participants can perform joint computations over their private inputs, it could enable privacy-preserving but authenticated data markets, and many other applications. That said, note that the math for doing this efficiently is still relatively in its infancy."
                  }
                ]
              }
            ]
          },
          {
            type: "dBlock",
            content: [
              {
                type: "blockquote",
                content: [
                  {
                    type: "paragraph",
                    attrs: {
                      textAlign: "left"
                    },
                    content: [
                      {
                        type: "text",
                        text: "Read the full article by "
                      },
                      {
                        type: "text",
                        marks: [
                          {
                            type: "link",
                            attrs: {
                              href: "https://vitalik.eth.limo/general/2021/01/26/snarks.html",
                              target: "_blank",
                              rel: "noopener noreferrer",
                              class: "custom-text-link"
                            }
                          }
                        ],
                        text: "Vitalik Buterin"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ],
        title: "Pretend To Work"
      };
    default:
      return null;
  }
}, ER = (t, e) => typeof t == "string" && NF[t] ? /* @__PURE__ */ C.jsx(
  Ye,
  {
    name: t,
    className: e
  }
) : typeof t == "string" ? /* @__PURE__ */ C.jsx("span", { className: e, children: t }) : null, dHt = (t) => [
  {
    label: "To-do",
    icon: "ListChecks",
    onClick: () => {
      const e = Do("todo-list");
      e && t(e);
    },
    content: Do("todo-list")
  },
  {
    label: "Breathe!",
    icon: "🧘‍♂️",
    onClick: () => {
      const e = Do("breathe");
      e && t(e);
    },
    content: Do("breathe")
  }
], fHt = (t) => [
  {
    label: "Meeting notes",
    icon: "NotepadText",
    onClick: () => {
      const e = Do("meeting-notes");
      e && t(e);
    },
    content: Do("meeting-notes")
  },
  {
    label: "Brainstorm",
    icon: "Lightbulb",
    onClick: () => {
      const e = Do("brainstorm");
      e && t(e);
    },
    content: Do("brainstorm")
  },
  {
    label: "Pretend to work",
    icon: "🏄🏻‍♂️",
    onClick: () => {
      const e = Do("pretend-to-work");
      e && t(e);
    },
    content: Do("pretend-to-work")
  }
], jR = (t, e, n, r, i) => /* @__PURE__ */ C.jsxs(Bx, { className: "template-buttons space-x-0 gap-2 absolute top-8 left-0 md:!left-[unset] md:-translate-y-1 md:!right-0 md:!top-0 z-40", children: [
  t.map((a, o) => /* @__PURE__ */ C.jsxs(
    Kt,
    {
      onClick: a.onClick,
      variant: "ghost",
      className: "gap-2 color-bg-default-hover text-body-sm color-text-default rounded-lg hover:brightness-95 transition-all min-w-fit",
      children: [
        ER(a.icon),
        /* @__PURE__ */ C.jsx("span", { children: a.label })
      ]
    },
    o
  )),
  /* @__PURE__ */ C.jsx(
    Mi,
    {
      align: "end",
      sideOffset: 10,
      anchorTrigger: /* @__PURE__ */ C.jsx(
        Kt,
        {
          variant: "ghost",
          className: "gap-2 color-bg-default-hover text-body-sm color-text-default rounded-lg hover:brightness-95 transition-all w-full min-w-0 !p-[10px]",
          children: /* @__PURE__ */ C.jsx(Ye, { name: "Ellipsis", className: "color-text-default" })
        }
      ),
      content: /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col gap-1 p-2 w-[12rem]", children: [
        /* @__PURE__ */ C.jsx("div", { className: "max-h-44 overflow-auto gap-1 flex flex-col", children: e.slice(0, n).map((a, o) => /* @__PURE__ */ C.jsxs(
          Kt,
          {
            onClick: a.onClick,
            variant: "ghost",
            className: "justify-start gap-2 text-body-sm color-text-default min-w-fit px-2 rounded-lg",
            children: [
              ER(a.icon),
              /* @__PURE__ */ C.jsx("span", { children: a.label })
            ]
          },
          o
        )) }),
        /* @__PURE__ */ C.jsx(r0, { className: "w-full !border-t-[1px]" }),
        /* @__PURE__ */ C.jsxs(
          Kt,
          {
            variant: "ghost",
            className: "justify-between gap-2 text-body-sm color-text-default min-w-fit px-2 rounded-lg",
            onClick: r,
            children: [
              /* @__PURE__ */ C.jsx("span", { children: i ? "Less" : "More" }),
              /* @__PURE__ */ C.jsx(
                Ye,
                {
                  name: "ChevronDown",
                  size: "sm",
                  className: be(i ? "rotate-180" : "")
                }
              )
            ]
          }
        )
      ] })
    },
    "More Templates"
  )
] });
function zte(t) {
  return t.split(/\s+/).slice(0, 10).join(" ").toLowerCase().trim().replace(/[^a-z0-9\s-]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
}
const hHt = ({
  node: t,
  getPos: e,
  editor: n,
  deleteNode: r,
  ...i
}) => {
  var $, se, xe, Oe, je, Me;
  const a = (se = ($ = i.extension) == null ? void 0 : $.options) == null ? void 0 : se.secureImageUploadUrl, o = (Oe = (xe = i.extension) == null ? void 0 : xe.options) == null ? void 0 : Oe.onCopyHeadingLink, [s, l] = De(!1), c = $Bt(n, t, e()), { isPreviewMode: u, isPresentationMode: d } = Zp(), f = () => {
    const { content: he } = t.content, pe = he[0].attrs.id, J = he[0].content.content[0].text, K = zte(J), X = pe.replace(/-/g, "").substring(0, 8), re = `heading=${K}-${X}`;
    o == null || o(re);
  }, h = Ft(() => {
    var pe;
    const { content: he } = t.content;
    return (pe = he == null ? void 0 : he[0]) == null ? void 0 : pe.attrs.textAlign;
  }, [t.content]), p = Ft(() => {
    var pe, J;
    const { content: he } = t.content;
    return ((J = (pe = he == null ? void 0 : he[0]) == null ? void 0 : pe.type) == null ? void 0 : J.name) === "heading";
  }, [t.content]), m = Ft(() => {
    const { content: he } = t.content;
    return he[0].type.name === "table";
  }, [t.content]), g = Ft(() => {
    var pe;
    const { content: he } = t.content;
    return (pe = he[0].content.content[0]) == null ? void 0 : pe.text;
  }, [t.content]), v = Ft(() => {
    var pe;
    const { content: he } = t.content;
    return (pe = he[0].content.content[1]) == null ? void 0 : pe.text;
  }, [t.content]), k = Ft(() => {
    const { content: he } = t.content;
    return he[0].content.content.find(
      (pe) => {
        var J;
        return (J = pe == null ? void 0 : pe.text) == null ? void 0 : J.match(/\/status\/([0-9]*)/);
      }
    );
  }, [t.content]), w = () => {
    var he, pe, J, K, X;
    if (g)
      try {
        const { content: re } = t.content, Ie = (X = (K = (J = (pe = (he = re[0]) == null ? void 0 : he.content) == null ? void 0 : pe.content[0]) == null ? void 0 : J.marks[0]) == null ? void 0 : K.attrs) == null ? void 0 : X.href;
        if (!Ie)
          return;
        if (Ie && /\.(jpeg|jpg|gif|png)$/i.test(Ie)) {
          b("img", Ie);
          return;
        }
        if (g.includes("<iframe")) {
          b("iframe", v);
          return;
        }
        const q = g.match(
          /youtu\.?be(?:\.com)?\/(?:.*v(?:\/|=)|(?:.*\/)?)([a-zA-Z0-9-_]+)/
        ) || Ie.match(
          /youtu\.?be(?:\.com)?\/(?:.*v(?:\/|=)|(?:.*\/)?)([a-zA-Z0-9-_]+)/
        );
        if (q) {
          const P = `https://www.youtube.com/embed/${q[1]}`;
          b("iframe", P);
          return;
        }
        const S = g.match(/vimeo\.com\/([a-zA-Z0-9-_]+)/);
        if (S) {
          const P = `https://player.vimeo.com/video/${S[1]}`;
          b("iframe", P);
          return;
        }
        console.warn("No matching media type found for:", g);
      } catch (re) {
        console.error("Error in mediaRender:", re);
      }
  }, b = (he, pe) => {
    const J = e(), K = J + t.nodeSize;
    he === "img" ? n == null || n.chain().focus(J).deleteRange({ from: J === 0 ? J : J + 1, to: K }).setMedia({ src: pe, "media-type": "img" }).run() : he === "secure-img" ? console.log("secureImageUploadUrl", a) : n == null || n.chain().focus(J).deleteRange({ from: J === 0 ? J : J + 1, to: K }).setIframe({ src: pe, width: 640, height: 360 }).run();
  }, x = (he) => {
    const pe = he.match(
      /(?:https?:\/\/)?(?:www\.)?(?:twitter\.com|x\.com)\/(?:#!\/)?(\w+)\/status\/(\d+)/
    );
    return pe && pe[2] ? pe[2] : null;
  }, A = () => {
    if (!g)
      return;
    let he = null;
    const pe = x(g);
    if (pe ? he = pe : k && (he = x(k.text)), he) {
      const J = e(), K = J + t.nodeSize;
      n == null || n.chain().focus(J).deleteRange({ from: J === 2 ? J : J + 1, to: K }).setTweetEmbed({ tweetId: he }).run();
    }
  }, L = () => {
    const he = e() + t.nodeSize;
    n.commands.insertContentAt(he, {
      type: "dBlock",
      content: [
        {
          type: "paragraph"
        }
      ]
    });
  }, M = () => {
    const he = e();
    n.commands.insertContentAt(he, {
      type: "dBlock",
      content: [
        {
          type: "paragraph"
        }
      ]
    });
  }, j = () => {
    r();
  }, D = (he) => {
    he.altKey ? H() : z();
  }, z = () => {
    L();
  }, H = () => {
    M();
  }, V = (he) => {
    he.altKey && j();
  }, _ = jte(() => {
    x(g) || k && x(k.text) ? A() : w();
  }, 1e3);
  ze(() => {
    g && _();
  }, [g]);
  const W = Ft(() => {
    var Ie, q, S, P;
    const { doc: he, selection: pe } = n.state, J = e(), K = he.nodeAt(J) === he.firstChild, X = ((Ie = he.nodeAt(J)) == null ? void 0 : Ie.type.name) === "dBlock" && ((S = (q = he.nodeAt(J)) == null ? void 0 : q.content.firstChild) == null ? void 0 : S.type.name) === "paragraph", re = pe.$anchor.pos >= J && pe.$anchor.pos <= J + (((P = he.nodeAt(J)) == null ? void 0 : P.nodeSize) || 0);
    return he.textContent === "" && K && X && re;
  }, [e, n.state]), G = (he) => {
    const pe = e() + t.nodeSize;
    n.commands.insertContentAt(pe - 4, he);
  }, Y = dHt(G), Z = fHt(G), [oe, ee] = De(!1), [ae, fe] = De(2), me = () => {
    ee(!oe), fe(oe ? 2 : Z.length);
  }, ge = Ft(() => {
    switch (h) {
      case "center":
        return "justify-center";
      case "left":
        return "justify-end";
      case "right":
        return "justify-start";
      default:
        return "justify-end";
    }
  }, [h]);
  return d && u ? /* @__PURE__ */ C.jsx(
    $u,
    {
      className: be(
        "flex px-4 md:px-[80px] gap-2 group w-full relative justify-center items-start",
        m && "pointer-events-auto"
      ),
      children: /* @__PURE__ */ C.jsx(
        I7,
        {
          className: be("node-view-content w-full relative", {
            "is-table": m,
            "invalid-content": (je = t.attrs) == null ? void 0 : je.isCorrupted,
            "pointer-events-none": u
          }),
          children: W && !u && jR(
            Y,
            Z,
            ae,
            me,
            oe
          )
        }
      )
    }
  ) : /* @__PURE__ */ C.jsxs(
    $u,
    {
      className: be(
        "flex px-4 md:px-8 lg:pr-[80px] lg:pl-[8px] gap-2 group w-full relative justify-center items-start",
        m && "pointer-events-auto"
        // shouldBeHidden && 'hidden',
      ),
      children: [
        /* @__PURE__ */ C.jsx(
          "section",
          {
            className: be("lg:flex gap-[2px] hidden min-w-16 justify-end"),
            "aria-label": "left-menu",
            contentEditable: !1,
            suppressContentEditableWarning: !0,
            children: u ? /* @__PURE__ */ C.jsx(C.Fragment, {}) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
              /* @__PURE__ */ C.jsx(
                En,
                {
                  text: /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col", children: [
                    /* @__PURE__ */ C.jsx("div", { className: "text-xs", children: "Click to add below" }),
                    /* @__PURE__ */ C.jsx("div", { className: "text-xs", children: "Opt + Click to add above" })
                  ] }),
                  position: "bottom",
                  children: /* @__PURE__ */ C.jsx(
                    "div",
                    {
                      className: be(
                        "d-block-button opacity-0 color-text-default hover:color-bg-default-hover aspect-square min-w-5",
                        !u && "group-hover:opacity-100"
                      ),
                      contentEditable: !1,
                      onClick: D,
                      children: /* @__PURE__ */ C.jsx(Ye, { name: "Plus", size: "sm" })
                    }
                  )
                }
              ),
              /* @__PURE__ */ C.jsx(
                Ite,
                {
                  onMountAutoFocus: (he) => he.preventDefault(),
                  trapped: !1,
                  children: /* @__PURE__ */ C.jsxs(h6, { open: s, onOpenChange: l, children: [
                    /* @__PURE__ */ C.jsx(p6, { children: /* @__PURE__ */ C.jsx(
                      En,
                      {
                        text: /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col", children: [
                          /* @__PURE__ */ C.jsx("div", { className: "text-xs", children: "Hold to drag" }),
                          /* @__PURE__ */ C.jsx("div", { className: "text-xs", children: "Opt + Click to delete" })
                        ] }),
                        position: "bottom",
                        children: /* @__PURE__ */ C.jsx(
                          "div",
                          {
                            className: be(
                              "d-block-button opacity-0 color-text-default hover:color-bg-default-hover aspect-square min-w-5",
                              !u && "group-hover:opacity-100"
                            ),
                            contentEditable: !1,
                            draggable: !0,
                            "data-drag-handle": !0,
                            onClick: V,
                            children: /* @__PURE__ */ C.jsx(Ye, { name: "GripVertical", size: "sm" })
                          }
                        )
                      }
                    ) }),
                    /* @__PURE__ */ C.jsx(
                      xp,
                      {
                        side: "bottom",
                        align: "start",
                        sideOffset: 8,
                        className: "z-10 shadow-elevation-3",
                        children: /* @__PURE__ */ C.jsxs(HA, { className: "p-2 flex flex-col min-w-[16rem]", children: [
                          /* @__PURE__ */ C.jsx(Im, { asChild: !0, children: /* @__PURE__ */ C.jsxs(
                            Kt,
                            {
                              variant: "ghost",
                              onClick: c.resetTextFormatting,
                              className: "justify-start gap-2",
                              children: [
                                /* @__PURE__ */ C.jsx(Ye, { name: "RemoveFormatting", size: "sm" }),
                                "Clear formatting"
                              ]
                            }
                          ) }),
                          /* @__PURE__ */ C.jsx(Im, { asChild: !0, children: /* @__PURE__ */ C.jsxs(
                            Kt,
                            {
                              variant: "ghost",
                              onClick: c.copyNodeToClipboard,
                              className: "justify-start gap-2",
                              children: [
                                /* @__PURE__ */ C.jsx(Ye, { name: "Clipboard", size: "sm" }),
                                "Copy to clipboard"
                              ]
                            }
                          ) }),
                          /* @__PURE__ */ C.jsx(Im, { asChild: !0, children: /* @__PURE__ */ C.jsxs(
                            Kt,
                            {
                              variant: "ghost",
                              onClick: c.duplicateNode,
                              className: "justify-start gap-2",
                              children: [
                                /* @__PURE__ */ C.jsx(Ye, { name: "Copy", size: "sm" }),
                                "Duplicate"
                              ]
                            }
                          ) }),
                          /* @__PURE__ */ C.jsx(Im, { asChild: !0, children: /* @__PURE__ */ C.jsxs(
                            Kt,
                            {
                              variant: "ghost",
                              onClick: c.deleteNode,
                              className: "justify-start gap-2 color-text-danger",
                              children: [
                                /* @__PURE__ */ C.jsx(Ye, { name: "Trash2", size: "sm" }),
                                "Delete"
                              ]
                            }
                          ) })
                        ] })
                      }
                    )
                  ] })
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ C.jsxs(
          I7,
          {
            className: be(
              "node-view-content w-full relative",
              {
                "is-table": m,
                "invalid-content": (Me = t.attrs) == null ? void 0 : Me.isCorrupted,
                "pointer-events-none": u && !p,
                "flex flex-row-reverse gap-2 items-center": p && u
              },
              p && u && ge
            ),
            children: [
              W && !u && jR(
                Y,
                Z,
                ae,
                me,
                oe
              ),
              p && u && /* @__PURE__ */ C.jsx("section", { children: /* @__PURE__ */ C.jsx(
                En,
                {
                  position: "bottom",
                  text: "Copy link to heading",
                  className: "!cursor-pointer",
                  children: /* @__PURE__ */ C.jsx(
                    "div",
                    {
                      className: be(
                        "d-block-button opacity-0 color-text-default hover:color-bg-default-hover aspect-square w-6 h-6",
                        "group-hover:opacity-100"
                      ),
                      contentEditable: !1,
                      onClick: () => {
                        f();
                      },
                      "data-test": "copy-heading-link-button",
                      children: /* @__PURE__ */ C.jsx(Ye, { name: "Link", size: "sm" })
                    }
                  )
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}, pHt = Ht.create({
  name: "dBlock",
  priority: 1e3,
  group: "dBlock",
  content: "(block|columns)",
  draggable: !0,
  selectable: !1,
  inline: !1,
  addOptions() {
    return {
      HTMLAttributes: {},
      secureImageUploadUrl: "",
      onCopyHeadingLink: void 0
    };
  },
  addAttributes() {
    return {
      isCorrupted: {
        default: !1
      }
    };
  },
  parseHTML() {
    return [{ tag: 'div[data-type="d-block"]' }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "div",
      _t(t, { "data-type": "d-block" }),
      0
    ];
  },
  addCommands() {
    return {
      setDBlock: (t) => ({ state: e, chain: n }) => {
        const {
          selection: { from: r }
        } = e, i = t !== void 0 || t !== null ? r : t;
        return n().insertContentAt(i, {
          type: this.name,
          content: [
            {
              type: "paragraph"
            }
          ]
        }).focus(i + 2).run();
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setDBlock(),
      Enter: ({ editor: t }) => {
        var d;
        const {
          selection: { $head: e, from: n, to: r },
          doc: i
        } = t.state, a = e.node(e.depth), o = e.node(e.depth - 1), s = e.node(e.depth - 2), u = e.toString().split("/").some((f) => f.includes("table"));
        if ((o == null ? void 0 : o.type.name) !== "dBlock" && u)
          return !1;
        if ((o == null ? void 0 : o.type.name) === "listItem" || (o == null ? void 0 : o.type.name) === "taskItem") {
          const f = a.textContent === "", h = s.childCount === 1, p = () => {
            let m = 0, g = e.depth;
            for (; g > 0; ) {
              const v = e.node(g - 1);
              ((v == null ? void 0 : v.type.name) === "listItem" || (v == null ? void 0 : v.type.name) === "taskItem") && m++, g--;
            }
            return a.type.name === "paragraph" && (o == null ? void 0 : o.type.name) === "listItem" && a.textContent === "" && m >= 2;
          };
          if (f) {
            if (p())
              return !1;
            const m = e.node(e.depth - 2), g = e.before(e.depth - 2), v = g + m.nodeSize;
            if (h)
              return t.chain().deleteRange({ from: n, to: r }).setDBlock().focus(n + 4).run();
            const k = [];
            if (k.push({
              type: "dBlock",
              content: [
                {
                  type: "paragraph"
                }
              ]
            }), m.content.size > 1) {
              const w = e.index(e.depth - 2), b = m.content.toJSON().slice(w + 1);
              b.length > 0 && k.push({
                type: "dBlock",
                content: [
                  {
                    type: s.type.name,
                    content: b
                  }
                ]
              });
            }
            return a.type.name === "paragraph" ? t.chain().command(({ tr: w, dispatch: b }) => {
              if (b) {
                w.replaceWith(
                  n,
                  v,
                  t.schema.nodeFromJSON({
                    type: "doc",
                    content: k
                  })
                );
                const x = g + 4;
                w.setSelection(ot.create(w.doc, x));
              }
              return !1;
            }).focus(n + 6).run() : t.chain().command(({ tr: w, dispatch: b }) => {
              if (b) {
                w.replaceWith(
                  n,
                  v,
                  t.schema.nodeFromJSON({
                    type: "doc",
                    content: k
                  })
                );
                const x = g + 4;
                w.setSelection(ot.create(w.doc, x));
              }
              return !1;
            }).focus(n + 6).run();
          }
          return !1;
        }
        if ((o == null ? void 0 : o.type.name) === "dBlock") {
          let f = -1, h = "";
          i.descendants((m, g) => {
            if (f !== -1) return !1;
            if (m.type.name === this.name) return;
            const [v, k] = [g, g + m.nodeSize];
            return v <= n && r <= k && (f = k, h = m.type.name), !1;
          });
          const p = (d = i.slice(n, f)) == null ? void 0 : d.toJSON().content;
          try {
            return h === "codeBlock" ? t.chain().newlineInCode().focus().run() : ["columns", "heading"].includes(h) ? t.chain().insertContent({
              type: "dBlock",
              content: [
                {
                  type: "paragraph"
                }
              ]
            }).focus(n + 4).run() : t.chain().insertContentAt(
              { from: n, to: f },
              {
                type: this.name,
                content: p
              }
            ).focus(n + 4).run();
          } catch (m) {
            return console.error(`Error inserting content into dBlock node: ${m}`), !1;
          }
        }
        return !1;
      },
      Backspace: ({ editor: t }) => {
        var f;
        const {
          selection: { $head: e, from: n, to: r },
          doc: i
        } = t.state;
        if (n !== r)
          return n <= 2 ? !1 : t.chain().deleteSelection().focus().run();
        const a = e.node(e.depth - 1), o = e.node(e.depth), l = e.start() === n;
        if (n === 2 && n === r)
          return t.chain().deleteNode(this.name).focus().run();
        const u = (a == null ? void 0 : a.type.name) === "listItem" || (a == null ? void 0 : a.type.name) === "taskItem", d = (o == null ? void 0 : o.textContent) === "";
        if ((a == null ? void 0 : a.type.name) !== "dBlock") {
          let h = !1, p = -1;
          if (i.descendants((m, g) => {
            if (p !== -1) return !1;
            m.type.name === "pageBreak" && g < n && (h = !0, p = g);
          }), h && d && n === p + 2)
            return !0;
          if (l && u) {
            const m = n > 4 ? ((f = i.nodeAt(n - 4)) == null ? void 0 : f.type.name) === "dBlock" : !1, g = e.node(e.depth - 2), v = e.index(e.depth - 2) === 0, k = g.childCount === 1, w = e.index(e.depth - 2) === g.childCount - 1, b = o.content.content.some(
              (M) => M.type.name === "bulletList" || M.type.name === "orderedList" || M.type.name === "taskList"
            ), x = n <= 4, A = v && x, L = () => {
              var z;
              const M = e.node(e.depth - 2), j = e.before(e.depth - 2), D = j + M.nodeSize;
              if (M.content && M.content.size > 0) {
                const H = M.content.firstChild, V = [];
                if (H) {
                  const F = ((z = H.content) == null ? void 0 : z.toJSON()) || [], _ = F.filter(
                    (G) => !["bulletList", "orderedList", "taskList"].includes(
                      G.type
                    )
                  );
                  V.push({
                    type: "dBlock",
                    content: _.length > 0 ? _ : [
                      {
                        type: "paragraph"
                      }
                    ]
                  });
                  const W = F.filter(
                    (G) => ["bulletList", "orderedList", "taskList"].includes(
                      G.type
                    )
                  );
                  if (W && W.length > 0 && W.forEach((G) => {
                    V.push({
                      type: "dBlock",
                      content: [G]
                    });
                  }), M.content.size > 1) {
                    const G = M.content.toJSON().slice(1);
                    G.length > 0 && V.push({
                      type: "dBlock",
                      content: [
                        {
                          type: M.type.name,
                          content: G
                        }
                      ]
                    });
                  }
                }
                return t.chain().command(({ tr: F, dispatch: _ }) => {
                  if (_) {
                    F.replaceWith(
                      j,
                      D,
                      t.schema.nodeFromJSON({
                        type: "doc",
                        content: V
                      })
                    );
                    const W = j + 4;
                    F.setSelection(
                      ot.create(F.doc, W)
                    );
                  }
                  return !1;
                }).run();
              }
              return !1;
            };
            if (A && n === 4 || d && b)
              return L();
            if (d && v && !b)
              return k && m ? L() : !1;
            if (d && !v)
              return b ? L() : !1;
            if (l)
              return v && m ? L() : !1;
            if (w && d && !b)
              return L();
          }
        }
        return !1;
      }
    };
  },
  addNodeView() {
    return Hc(hHt);
  }
});
let Ak, Sk;
if (typeof WeakMap < "u") {
  let t = /* @__PURE__ */ new WeakMap();
  Ak = (e) => t.get(e), Sk = (e, n) => (t.set(e, n), n);
} else {
  let t = [], e = 10, n = 0;
  Ak = (r) => {
    for (let i = 0; i < t.length; i += 2) if (t[i] == r) return t[i + 1];
  }, Sk = (r, i) => (n == e && (n = 0), t[n++] = r, t[n++] = i);
}
class yd {
  constructor(e, n, r, i) {
    this.left = e, this.top = n, this.right = r, this.bottom = i;
  }
}
class Kn {
  constructor(e, n, r, i) {
    this.width = e, this.height = n, this.map = r, this.problems = i;
  }
  // :: (number) → Rect
  // Find the dimensions of the cell at the given position.
  findCell(e) {
    for (let n = 0; n < this.map.length; n++) {
      let r = this.map[n];
      if (r != e) continue;
      let i = n % this.width, a = n / this.width | 0, o = i + 1, s = a + 1;
      for (let l = 1; o < this.width && this.map[n + l] == r; l++) o++;
      for (let l = 1; s < this.height && this.map[n + this.width * l] == r; l++) s++;
      return new yd(i, a, o, s);
    }
    throw new RangeError("No cell with offset " + e + " found");
  }
  // :: (number) → number
  // Find the left side of the cell at the given position.
  colCount(e) {
    for (let n = 0; n < this.map.length; n++) if (this.map[n] == e) return n % this.width;
    throw new RangeError("No cell with offset " + e + " found");
  }
  // :: (number, string, number) → ?number
  // Find the next cell in the given direction, starting from the cell
  // at `pos`, if any.
  nextCell(e, n, r) {
    let {
      left: i,
      right: a,
      top: o,
      bottom: s
    } = this.findCell(e);
    return n == "horiz" ? (r < 0 ? i == 0 : a == this.width) ? null : this.map[o * this.width + (r < 0 ? i - 1 : a)] : (r < 0 ? o == 0 : s == this.height) ? null : this.map[i + this.width * (r < 0 ? o - 1 : s)];
  }
  // :: (number, number) → Rect
  // Get the rectangle spanning the two given cells.
  rectBetween(e, n) {
    let {
      left: r,
      right: i,
      top: a,
      bottom: o
    } = this.findCell(e), {
      left: s,
      right: l,
      top: c,
      bottom: u
    } = this.findCell(n);
    return new yd(Math.min(r, s), Math.min(a, c), Math.max(i, l), Math.max(o, u));
  }
  // :: (Rect) → [number]
  // Return the position of all cells that have the top left corner in
  // the given rectangle.
  cellsInRect(e) {
    let n = [], r = {};
    for (let i = e.top; i < e.bottom; i++)
      for (let a = e.left; a < e.right; a++) {
        let o = i * this.width + a, s = this.map[o];
        r[s] || (r[s] = !0, (a != e.left || !a || this.map[o - 1] != s) && (i != e.top || !i || this.map[o - this.width] != s) && n.push(s));
      }
    return n;
  }
  // :: (number, number, Node) → number
  // Return the position at which the cell at the given row and column
  // starts, or would start, if a cell started there.
  positionAt(e, n, r) {
    for (let i = 0, a = 0; ; i++) {
      let o = a + r.child(i).nodeSize;
      if (i == e) {
        let s = n + e * this.width, l = (e + 1) * this.width;
        for (; s < l && this.map[s] < a; ) s++;
        return s == l ? o - 1 : this.map[s];
      }
      a = o;
    }
  }
  // :: (Node) → TableMap
  // Find the table map for the given table node.
  static get(e) {
    return Ak(e) || Sk(e, mHt(e));
  }
}
function mHt(t) {
  if (t.type.spec.tableRole != "table") throw new RangeError("Not a table node: " + t.type.name);
  let e = yHt(t), n = t.childCount, r = [], i = 0, a = null, o = [];
  for (let c = 0, u = e * n; c < u; c++) r[c] = 0;
  for (let c = 0, u = 0; c < n; c++) {
    let d = t.child(c);
    u++;
    for (let p = 0; ; p++) {
      for (; i < r.length && r[i] != 0; ) i++;
      if (p == d.childCount) break;
      let m = d.child(p), {
        colspan: g,
        rowspan: v,
        colwidth: k
      } = m.attrs;
      for (let w = 0; w < v; w++) {
        if (w + c >= n) {
          (a || (a = [])).push({
            type: "overlong_rowspan",
            pos: u,
            n: v - w
          });
          break;
        }
        let b = i + w * e;
        for (let x = 0; x < g; x++) {
          r[b + x] == 0 ? r[b + x] = u : (a || (a = [])).push({
            type: "collision",
            row: c,
            pos: u,
            n: g - x
          });
          let A = k && k[x];
          if (A) {
            let L = (b + x) % e * 2, M = o[L];
            M == null || M != A && o[L + 1] == 1 ? (o[L] = A, o[L + 1] = 1) : M == A && o[L + 1]++;
          }
        }
      }
      i += g, u += m.nodeSize;
    }
    let f = (c + 1) * e, h = 0;
    for (; i < f; ) r[i++] == 0 && h++;
    h && (a || (a = [])).push({
      type: "missing",
      row: c,
      n: h
    }), u++;
  }
  let s = new Kn(e, n, r, a), l = !1;
  for (let c = 0; !l && c < o.length; c += 2) o[c] != null && o[c + 1] < n && (l = !0);
  return l && gHt(s, o, t), s;
}
function yHt(t) {
  let e = -1, n = !1;
  for (let r = 0; r < t.childCount; r++) {
    let i = t.child(r), a = 0;
    if (n) for (let o = 0; o < r; o++) {
      let s = t.child(o);
      for (let l = 0; l < s.childCount; l++) {
        let c = s.child(l);
        o + c.attrs.rowspan > r && (a += c.attrs.colspan);
      }
    }
    for (let o = 0; o < i.childCount; o++) {
      let s = i.child(o);
      a += s.attrs.colspan, s.attrs.rowspan > 1 && (n = !0);
    }
    e == -1 ? e = a : e != a && (e = Math.max(e, a));
  }
  return e;
}
function gHt(t, e, n) {
  t.problems || (t.problems = []);
  for (let r = 0, i = {}; r < t.map.length; r++) {
    let a = t.map[r];
    if (i[a]) continue;
    i[a] = !0;
    let o = n.nodeAt(a), s = null;
    for (let l = 0; l < o.attrs.colspan; l++) {
      let c = (r + l) % t.width, u = e[c * 2];
      u != null && (!o.attrs.colwidth || o.attrs.colwidth[l] != u) && ((s || (s = vHt(o.attrs)))[l] = u);
    }
    s && t.problems.unshift({
      type: "colwidth mismatch",
      pos: a,
      colwidth: s
    });
  }
}
function vHt(t) {
  if (t.colwidth) return t.colwidth.slice();
  let e = [];
  for (let n = 0; n < t.colspan; n++) e.push(0);
  return e;
}
function Qr(t) {
  let e = t.cached.tableNodeTypes;
  if (!e) {
    e = t.cached.tableNodeTypes = {};
    for (let n in t.nodes) {
      let r = t.nodes[n], i = r.spec.tableRole;
      i && (e[i] = r);
    }
  }
  return e;
}
const tc = new tn("selectingCells");
function Kd(t) {
  for (let e = t.depth - 1; e > 0; e--) if (t.node(e).type.spec.tableRole == "row") return t.node(0).resolve(t.before(e + 1));
  return null;
}
function bHt(t) {
  for (let e = t.depth; e > 0; e--) {
    const n = t.node(e).type.spec.tableRole;
    if (n === "cell" || n === "header_cell") return t.node(e);
  }
  return null;
}
function xo(t) {
  let e = t.selection.$head;
  for (let n = e.depth; n > 0; n--) if (e.node(n).type.spec.tableRole == "row") return !0;
  return !1;
}
function x5(t) {
  let e = t.selection;
  return e.$anchorCell ? e.$anchorCell.pos > e.$headCell.pos ? e.$anchorCell : e.$headCell : e.node && e.node.type.spec.tableRole == "cell" ? e.$anchor : Kd(e.$head) || wHt(e.$head);
}
function wHt(t) {
  for (let e = t.nodeAfter, n = t.pos; e; e = e.firstChild, n++) {
    let r = e.type.spec.tableRole;
    if (r == "cell" || r == "header_cell") return t.doc.resolve(n);
  }
  for (let e = t.nodeBefore, n = t.pos; e; e = e.lastChild, n--) {
    let r = e.type.spec.tableRole;
    if (r == "cell" || r == "header_cell") return t.doc.resolve(n - e.nodeSize);
  }
}
function Lk(t) {
  return t.parent.type.spec.tableRole == "row" && t.nodeAfter;
}
function kHt(t) {
  return t.node(0).resolve(t.pos + t.nodeAfter.nodeSize);
}
function gL(t, e) {
  return t.depth == e.depth && t.pos >= e.start(-1) && t.pos <= e.end(-1);
}
function Rte(t, e, n) {
  let r = t.start(-1), a = Kn.get(t.node(-1)).nextCell(t.pos - r, e, n);
  return a == null ? null : t.node(0).resolve(r + a);
}
function Lr(t, e, n) {
  let r = {};
  for (let i in t) r[i] = t[i];
  return r[e] = n, r;
}
function g0(t, e, n = 1) {
  let r = Lr(t, "colspan", t.colspan - n);
  return r.colwidth && (r.colwidth = r.colwidth.slice(), r.colwidth.splice(e, n), r.colwidth.some((i) => i > 0) || (r.colwidth = null)), r;
}
function Ote(t, e, n = 1) {
  let r = Lr(t, "colspan", t.colspan + n);
  if (r.colwidth) {
    r.colwidth = r.colwidth.slice();
    for (let i = 0; i < n; i++) r.colwidth.splice(e, 0, 0);
  }
  return r;
}
function xHt(t, e, n) {
  let r = Qr(e.type.schema).header_cell;
  for (let i = 0; i < t.height; i++) if (e.nodeAt(t.map[n + i * t.width]).type != r) return !1;
  return !0;
}
class rn extends vt {
  // :: (ResolvedPos, ?ResolvedPos)
  // A table selection is identified by its anchor and head cells. The
  // positions given to this constructor should point _before_ two
  // cells in the same table. They may be the same, to select a single
  // cell.
  constructor(e, n = e) {
    let r = e.node(-1), i = Kn.get(r), a = e.start(-1), o = i.rectBetween(e.pos - a, n.pos - a), s = e.node(0), l = i.cellsInRect(o).filter((u) => u != n.pos - a);
    l.unshift(n.pos - a);
    let c = l.map((u) => {
      let d = r.nodeAt(u), f = u + a + 1;
      return new $k(s.resolve(f), s.resolve(f + d.content.size));
    });
    super(c[0].$from, c[0].$to, c), this.$anchorCell = e, this.$headCell = n;
  }
  map(e, n) {
    let r = e.resolve(n.map(this.$anchorCell.pos)), i = e.resolve(n.map(this.$headCell.pos));
    if (Lk(r) && Lk(i) && gL(r, i)) {
      let a = this.$anchorCell.node(-1) != r.node(-1);
      return a && this.isRowSelection() ? rn.rowSelection(r, i) : a && this.isColSelection() ? rn.colSelection(r, i) : new rn(r, i);
    }
    return ot.between(r, i);
  }
  // :: () → Slice
  // Returns a rectangular slice of table rows containing the selected
  // cells.
  content() {
    let e = this.$anchorCell.node(-1), n = Kn.get(e), r = this.$anchorCell.start(-1), i = n.rectBetween(this.$anchorCell.pos - r, this.$headCell.pos - r), a = {}, o = [];
    for (let l = i.top; l < i.bottom; l++) {
      let c = [];
      for (let u = l * n.width + i.left, d = i.left; d < i.right; d++, u++) {
        let f = n.map[u];
        if (!a[f]) {
          a[f] = !0;
          let h = n.findCell(f), p = e.nodeAt(f), m = i.left - h.left, g = h.right - i.right;
          if (m > 0 || g > 0) {
            let v = p.attrs;
            m > 0 && (v = g0(v, 0, m)), g > 0 && (v = g0(v, v.colspan - g, g)), h.left < i.left ? p = p.type.createAndFill(v) : p = p.type.create(v, p.content);
          }
          if (h.top < i.top || h.bottom > i.bottom) {
            let v = Lr(p.attrs, "rowspan", Math.min(h.bottom, i.bottom) - Math.max(h.top, i.top));
            h.top < i.top ? p = p.type.createAndFill(v) : p = p.type.create(v, p.content);
          }
          c.push(p);
        }
      }
      o.push(e.child(l).copy(Ne.from(c)));
    }
    const s = this.isColSelection() && this.isRowSelection() ? e : o;
    return new Je(Ne.from(s), 1, 1);
  }
  replace(e, n = Je.empty) {
    let r = e.steps.length, i = this.ranges;
    for (let o = 0; o < i.length; o++) {
      let {
        $from: s,
        $to: l
      } = i[o], c = e.mapping.slice(r);
      e.replace(c.map(s.pos), c.map(l.pos), o ? Je.empty : n);
    }
    let a = vt.findFrom(e.doc.resolve(e.mapping.slice(r).map(this.to)), -1);
    a && e.setSelection(a);
  }
  replaceWith(e, n) {
    this.replace(e, new Je(Ne.from(n), 0, 0));
  }
  forEachCell(e) {
    let n = this.$anchorCell.node(-1), r = Kn.get(n), i = this.$anchorCell.start(-1), a = r.cellsInRect(r.rectBetween(this.$anchorCell.pos - i, this.$headCell.pos - i));
    for (let o = 0; o < a.length; o++) e(n.nodeAt(a[o]), i + a[o]);
  }
  // :: () → bool
  // True if this selection goes all the way from the top to the
  // bottom of the table.
  isColSelection() {
    let e = this.$anchorCell.index(-1), n = this.$headCell.index(-1);
    if (Math.min(e, n) > 0) return !1;
    let r = e + this.$anchorCell.nodeAfter.attrs.rowspan, i = n + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(r, i) == this.$headCell.node(-1).childCount;
  }
  // :: (ResolvedPos, ?ResolvedPos) → CellSelection
  // Returns the smallest column selection that covers the given anchor
  // and head cell.
  static colSelection(e, n = e) {
    let r = Kn.get(e.node(-1)), i = e.start(-1), a = r.findCell(e.pos - i), o = r.findCell(n.pos - i), s = e.node(0);
    return a.top <= o.top ? (a.top > 0 && (e = s.resolve(i + r.map[a.left])), o.bottom < r.height && (n = s.resolve(i + r.map[r.width * (r.height - 1) + o.right - 1]))) : (o.top > 0 && (n = s.resolve(i + r.map[o.left])), a.bottom < r.height && (e = s.resolve(i + r.map[r.width * (r.height - 1) + a.right - 1]))), new rn(e, n);
  }
  // :: () → bool
  // True if this selection goes all the way from the left to the
  // right of the table.
  isRowSelection() {
    let e = Kn.get(this.$anchorCell.node(-1)), n = this.$anchorCell.start(-1), r = e.colCount(this.$anchorCell.pos - n), i = e.colCount(this.$headCell.pos - n);
    if (Math.min(r, i) > 0) return !1;
    let a = r + this.$anchorCell.nodeAfter.attrs.colspan, o = i + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(a, o) == e.width;
  }
  eq(e) {
    return e instanceof rn && e.$anchorCell.pos == this.$anchorCell.pos && e.$headCell.pos == this.$headCell.pos;
  }
  // :: (ResolvedPos, ?ResolvedPos) → CellSelection
  // Returns the smallest row selection that covers the given anchor
  // and head cell.
  static rowSelection(e, n = e) {
    let r = Kn.get(e.node(-1)), i = e.start(-1), a = r.findCell(e.pos - i), o = r.findCell(n.pos - i), s = e.node(0);
    return a.left <= o.left ? (a.left > 0 && (e = s.resolve(i + r.map[a.top * r.width])), o.right < r.width && (n = s.resolve(i + r.map[r.width * (o.top + 1) - 1]))) : (o.left > 0 && (n = s.resolve(i + r.map[o.top * r.width])), a.right < r.width && (e = s.resolve(i + r.map[r.width * (a.top + 1) - 1]))), new rn(e, n);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(e, n) {
    return new rn(e.resolve(n.anchor), e.resolve(n.head));
  }
  // :: (Node, number, ?number) → CellSelection
  static create(e, n, r = n) {
    return new rn(e.resolve(n), e.resolve(r));
  }
  getBookmark() {
    return new vL(this.$anchorCell.pos, this.$headCell.pos);
  }
}
rn.prototype.visible = !1;
vt.jsonID("cell", rn);
class vL {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new vL(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    let n = e.resolve(this.anchor), r = e.resolve(this.head);
    return n.parent.type.spec.tableRole == "row" && r.parent.type.spec.tableRole == "row" && n.index() < n.parent.childCount && r.index() < r.parent.childCount && gL(n, r) ? new rn(n, r) : vt.near(r, 1);
  }
}
function MHt(t) {
  if (!(t.selection instanceof rn)) return null;
  let e = [];
  return t.selection.forEachCell((n, r) => {
    e.push(hr.node(r, r + n.nodeSize, {
      class: "selectedCell"
    }));
  }), vn.create(t.doc, e);
}
function CHt({
  $from: t,
  $to: e
}) {
  if (t.pos == e.pos || t.pos < t.pos - 6) return !1;
  let n = t.pos, r = e.pos, i = t.depth;
  for (; i >= 0 && !(t.after(i + 1) < t.end(i)); i--, n++) ;
  for (let a = e.depth; a >= 0 && !(e.before(a + 1) > e.start(a)); a--, r--) ;
  return n == r && /row|table/.test(t.node(i).type.spec.tableRole);
}
function AHt({
  $from: t,
  $to: e
}) {
  let n, r;
  for (let i = t.depth; i > 0; i--) {
    let a = t.node(i);
    if (a.type.spec.tableRole === "cell" || a.type.spec.tableRole === "header_cell") {
      n = a;
      break;
    }
  }
  for (let i = e.depth; i > 0; i--) {
    let a = e.node(i);
    if (a.type.spec.tableRole === "cell" || a.type.spec.tableRole === "header_cell") {
      r = a;
      break;
    }
  }
  return n !== r && e.parentOffset === 0;
}
function SHt(t, e, n) {
  let r = (e || t).selection, i = (e || t).doc, a, o;
  if (r instanceof gt && (o = r.node.type.spec.tableRole)) {
    if (o == "cell" || o == "header_cell")
      a = rn.create(i, r.from);
    else if (o == "row") {
      let s = i.resolve(r.from + 1);
      a = rn.rowSelection(s, s);
    } else if (!n) {
      let s = Kn.get(r.node), l = r.from + 1, c = l + s.map[s.width * s.height - 1];
      a = rn.create(i, l + 1, c);
    }
  } else r instanceof ot && CHt(r) ? a = ot.create(i, r.from) : r instanceof ot && AHt(r) && (a = ot.create(i, r.$from.start(), r.$from.end()));
  return a && (e || (e = t.tr)).setSelection(a), e;
}
function LHt(t) {
  if (!t.size) return null;
  let {
    content: e,
    openStart: n,
    openEnd: r
  } = t;
  for (; e.childCount == 1 && (n > 0 && r > 0 || e.firstChild.type.spec.tableRole == "table"); )
    n--, r--, e = e.firstChild.content;
  let i = e.firstChild, a = i.type.spec.tableRole, o = i.type.schema, s = [];
  if (a == "row")
    for (let l = 0; l < e.childCount; l++) {
      let c = e.child(l).content, u = l ? 0 : Math.max(0, n - 1), d = l < e.childCount - 1 ? 0 : Math.max(0, r - 1);
      (u || d) && (c = Tk(Qr(o).row, new Je(c, u, d)).content), s.push(c);
    }
  else if (a == "cell" || a == "header_cell")
    s.push(n || r ? Tk(Qr(o).row, new Je(e, n, r)).content : e);
  else
    return null;
  return THt(o, s);
}
function THt(t, e) {
  let n = [];
  for (let i = 0; i < e.length; i++) {
    let a = e[i];
    for (let o = a.childCount - 1; o >= 0; o--) {
      let {
        rowspan: s,
        colspan: l
      } = a.child(o).attrs;
      for (let c = i; c < i + s; c++) n[c] = (n[c] || 0) + l;
    }
  }
  let r = 0;
  for (let i = 0; i < n.length; i++) r = Math.max(r, n[i]);
  for (let i = 0; i < n.length; i++)
    if (i >= e.length && e.push(Ne.empty), n[i] < r) {
      let a = Qr(t).cell.createAndFill(), o = [];
      for (let s = n[i]; s < r; s++) o.push(a);
      e[i] = e[i].append(Ne.from(o));
    }
  return {
    height: e.length,
    width: r,
    rows: e
  };
}
function Tk(t, e) {
  let n = t.createAndFill();
  return new Kk(n).replace(0, n.content.size, e).doc;
}
function EHt({
  width: t,
  height: e,
  rows: n
}, r, i) {
  if (t != r) {
    let a = [], o = [];
    for (let s = 0; s < n.length; s++) {
      let l = n[s], c = [];
      for (let u = a[s] || 0, d = 0; u < r; d++) {
        let f = l.child(d % l.childCount);
        u + f.attrs.colspan > r && (f = f.type.create(g0(f.attrs, f.attrs.colspan, u + f.attrs.colspan - r), f.content)), c.push(f), u += f.attrs.colspan;
        for (let h = 1; h < f.attrs.rowspan; h++) a[s + h] = (a[s + h] || 0) + f.attrs.colspan;
      }
      o.push(Ne.from(c));
    }
    n = o, t = r;
  }
  if (e != i) {
    let a = [];
    for (let o = 0, s = 0; o < i; o++, s++) {
      let l = [], c = n[s % e];
      for (let u = 0; u < c.childCount; u++) {
        let d = c.child(u);
        o + d.attrs.rowspan > i && (d = d.type.create(Lr(d.attrs, "rowspan", Math.max(1, i - d.attrs.rowspan)), d.content)), l.push(d);
      }
      a.push(Ne.from(l));
    }
    n = a, e = i;
  }
  return {
    width: t,
    height: e,
    rows: n
  };
}
function jHt(t, e, n, r, i, a, o) {
  let s = t.doc.type.schema, l = Qr(s), c, u;
  if (i > e.width)
    for (let d = 0, f = 0; d < e.height; d++) {
      let h = n.child(d);
      f += h.nodeSize;
      let p = [], m;
      h.lastChild == null || h.lastChild.type == l.cell ? m = c || (c = l.cell.createAndFill()) : m = u || (u = l.header_cell.createAndFill());
      for (let g = e.width; g < i; g++) p.push(m);
      t.insert(t.mapping.slice(o).map(f - 1 + r), p);
    }
  if (a > e.height) {
    let d = [];
    for (let p = 0, m = (e.height - 1) * e.width; p < Math.max(e.width, i); p++) {
      let g = p >= e.width ? !1 : n.nodeAt(e.map[m + p]).type == l.header_cell;
      d.push(g ? u || (u = l.header_cell.createAndFill()) : c || (c = l.cell.createAndFill()));
    }
    let f = l.row.create(null, Ne.from(d)), h = [];
    for (let p = e.height; p < a; p++) h.push(f);
    t.insert(t.mapping.slice(o).map(r + n.nodeSize - 2), h);
  }
  return !!(c || u);
}
function NR(t, e, n, r, i, a, o, s) {
  if (o == 0 || o == e.height) return !1;
  let l = !1;
  for (let c = i; c < a; c++) {
    let u = o * e.width + c, d = e.map[u];
    if (e.map[u - e.width] == d) {
      l = !0;
      let f = n.nodeAt(d), {
        top: h,
        left: p
      } = e.findCell(d);
      t.setNodeMarkup(t.mapping.slice(s).map(d + r), null, Lr(f.attrs, "rowspan", o - h)), t.insert(t.mapping.slice(s).map(e.positionAt(o, p, n)), f.type.createAndFill(Lr(f.attrs, "rowspan", h + f.attrs.rowspan - o))), c += f.attrs.colspan - 1;
    }
  }
  return l;
}
function DR(t, e, n, r, i, a, o, s) {
  if (o == 0 || o == e.width) return !1;
  let l = !1;
  for (let c = i; c < a; c++) {
    let u = c * e.width + o, d = e.map[u];
    if (e.map[u - 1] == d) {
      l = !0;
      let f = n.nodeAt(d), h = e.colCount(d), p = t.mapping.slice(s).map(d + r);
      t.setNodeMarkup(p, null, g0(f.attrs, o - h, f.attrs.colspan - (o - h))), t.insert(p + f.nodeSize, f.type.createAndFill(g0(f.attrs, 0, o - h))), c += f.attrs.rowspan - 1;
    }
  }
  return l;
}
function IR(t, e, n, r, i) {
  let a = n ? t.doc.nodeAt(n - 1) : t.doc, o = Kn.get(a), {
    top: s,
    left: l
  } = r, c = l + i.width, u = s + i.height, d = t.tr, f = 0;
  function h() {
    a = n ? d.doc.nodeAt(n - 1) : d.doc, o = Kn.get(a), f = d.mapping.maps.length;
  }
  jHt(d, o, a, n, c, u, f) && h(), NR(d, o, a, n, l, c, s, f) && h(), NR(d, o, a, n, l, c, u, f) && h(), DR(d, o, a, n, s, u, l, f) && h(), DR(d, o, a, n, s, u, c, f) && h();
  for (let p = s; p < u; p++) {
    let m = o.positionAt(p, l, a), g = o.positionAt(p, c, a);
    d.replace(d.mapping.slice(f).map(m + n), d.mapping.slice(f).map(g + n), new Je(i.rows[p - s], 0, 0));
  }
  h(), d.setSelection(new rn(d.doc.resolve(n + o.positionAt(s, l, a)), d.doc.resolve(n + o.positionAt(u - 1, c - 1, a)))), e(d);
}
const NHt = sx({
  ArrowLeft: g4("horiz", -1),
  ArrowRight: g4("horiz", 1),
  ArrowUp: g4("vert", -1),
  ArrowDown: g4("vert", 1),
  "Shift-ArrowLeft": v4("horiz", -1),
  "Shift-ArrowRight": v4("horiz", 1),
  "Shift-ArrowUp": v4("vert", -1),
  "Shift-ArrowDown": v4("vert", 1),
  Backspace: b4,
  "Mod-Backspace": b4,
  Delete: b4,
  "Mod-Delete": b4
});
function ly(t, e, n) {
  return n.eq(t.selection) ? !1 : (e && e(t.tr.setSelection(n).scrollIntoView()), !0);
}
function g4(t, e) {
  return (n, r, i) => {
    let a = n.selection;
    if (a instanceof rn)
      return ly(n, r, vt.near(a.$headCell, e));
    if (t != "horiz" && !a.empty) return !1;
    let o = Bte(i, t, e);
    if (o == null) return !1;
    if (t == "horiz")
      return ly(n, r, vt.near(n.doc.resolve(a.head + e), e));
    {
      let s = n.doc.resolve(o), l = Rte(s, t, e), c;
      return l ? c = vt.near(l, 1) : e < 0 ? c = vt.near(n.doc.resolve(s.before(-1)), -1) : c = vt.near(n.doc.resolve(s.after(-1)), 1), ly(n, r, c);
    }
  };
}
function v4(t, e) {
  return (n, r, i) => {
    let a = n.selection;
    if (!(a instanceof rn)) {
      let s = Bte(i, t, e);
      if (s == null) return !1;
      a = new rn(n.doc.resolve(s));
    }
    let o = Rte(a.$headCell, t, e);
    return o ? ly(n, r, new rn(a.$anchorCell, o)) : !1;
  };
}
function b4(t, e) {
  let n = t.selection;
  if (!(n instanceof rn)) return !1;
  if (e) {
    let r = t.tr, i = Qr(t.schema).cell.createAndFill().content;
    n.forEachCell((a, o) => {
      a.content.eq(i) || r.replace(r.mapping.map(o + 1), r.mapping.map(o + a.nodeSize - 1), new Je(i, 0, 0));
    }), r.docChanged && e(r);
  }
  return !0;
}
function DHt(t, e) {
  let n = t.state.doc, r = Kd(n.resolve(e));
  return r ? (t.dispatch(t.state.tr.setSelection(new rn(r))), !0) : !1;
}
function IHt(t, e, n) {
  if (!xo(t.state)) return !1;
  let r = LHt(n), i = t.state.selection;
  if (i instanceof rn) {
    r || (r = {
      width: 1,
      height: 1,
      rows: [Ne.from(Tk(Qr(t.state.schema).cell, n))]
    });
    let a = i.$anchorCell.node(-1), o = i.$anchorCell.start(-1), s = Kn.get(a).rectBetween(i.$anchorCell.pos - o, i.$headCell.pos - o);
    return r = EHt(r, s.right - s.left, s.bottom - s.top), IR(t.state, t.dispatch, o, s, r), !0;
  } else if (r) {
    let a = x5(t.state), o = a.start(-1);
    return IR(t.state, t.dispatch, o, Kn.get(a.node(-1)).findCell(a.pos - o), r), !0;
  } else
    return !1;
}
function PHt(t, e) {
  if (e.ctrlKey || e.metaKey) return;
  let n = PR(t, e.target), r;
  if (e.shiftKey && t.state.selection instanceof rn)
    i(t.state.selection.$anchorCell, e), e.preventDefault();
  else if (e.shiftKey && n && (r = Kd(t.state.selection.$anchor)) != null && Sb(t, e).pos != r.pos)
    i(r, e), e.preventDefault();
  else if (!n)
    return;
  function i(s, l) {
    let c = Sb(t, l), u = tc.getState(t.state) == null;
    if (!c || !gL(s, c))
      if (u) c = s;
      else return;
    let d = new rn(s, c);
    if (u || !t.state.selection.eq(d)) {
      let f = t.state.tr.setSelection(d);
      u && f.setMeta(tc, s.pos), t.dispatch(f);
    }
  }
  function a() {
    t.root.removeEventListener("mouseup", a), t.root.removeEventListener("dragstart", a), t.root.removeEventListener("mousemove", o), tc.getState(t.state) != null && t.dispatch(t.state.tr.setMeta(tc, -1));
  }
  function o(s) {
    let l = tc.getState(t.state), c;
    if (l != null)
      c = t.state.doc.resolve(l);
    else if (PR(t, s.target) != n && (c = Sb(t, e), !c))
      return a();
    c && i(c, s);
  }
  t.root.addEventListener("mouseup", a), t.root.addEventListener("dragstart", a), t.root.addEventListener("mousemove", o);
}
function Bte(t, e, n) {
  if (!(t.state.selection instanceof ot)) return null;
  let {
    $head: r
  } = t.state.selection;
  for (let i = r.depth - 1; i >= 0; i--) {
    let a = r.node(i);
    if ((n < 0 ? r.index(i) : r.indexAfter(i)) != (n < 0 ? 0 : a.childCount)) return null;
    if (a.type.spec.tableRole == "cell" || a.type.spec.tableRole == "header_cell") {
      let s = r.before(i), l = e == "vert" ? n > 0 ? "down" : "up" : n > 0 ? "right" : "left";
      return t.endOfTextblock(l) ? s : null;
    }
  }
  return null;
}
function PR(t, e) {
  for (; e && e != t.dom; e = e.parentNode) if (e.nodeName == "TD" || e.nodeName == "TH") return e;
}
function Sb(t, e) {
  let n = t.posAtCoords({
    left: e.clientX,
    top: e.clientY
  });
  return n && n ? Kd(t.state.doc.resolve(n.pos)) : null;
}
const zHt = new tn("fix-tables");
function Hte(t, e, n, r) {
  let i = t.childCount, a = e.childCount;
  e: for (let o = 0, s = 0; o < a; o++) {
    let l = e.child(o);
    for (let c = s, u = Math.min(i, o + 3); c < u; c++)
      if (t.child(c) == l) {
        s = c + 1, n += l.nodeSize;
        continue e;
      }
    r(l, n), s < i && t.child(s).sameMarkup(l) ? Hte(t.child(s), l, n + 1, r) : l.nodesBetween(0, l.content.size, r, n + 1), n += l.nodeSize;
  }
}
function Fte(t, e) {
  let n, r = (i, a) => {
    i.type.spec.tableRole == "table" && (n = RHt(t, i, a, n));
  };
  return e ? e.doc != t.doc && Hte(e.doc, t.doc, 0, r) : t.doc.descendants(r), n;
}
function RHt(t, e, n, r) {
  let i = Kn.get(e);
  if (!i.problems) return r;
  r || (r = t.tr);
  let a = [];
  for (let l = 0; l < i.height; l++) a.push(0);
  for (let l = 0; l < i.problems.length; l++) {
    let c = i.problems[l];
    if (c.type == "collision") {
      let u = e.nodeAt(c.pos);
      for (let d = 0; d < u.attrs.rowspan; d++) a[c.row + d] += c.n;
      r.setNodeMarkup(r.mapping.map(n + 1 + c.pos), null, g0(u.attrs, u.attrs.colspan - c.n, c.n));
    } else if (c.type == "missing")
      a[c.row] += c.n;
    else if (c.type == "overlong_rowspan") {
      let u = e.nodeAt(c.pos);
      r.setNodeMarkup(r.mapping.map(n + 1 + c.pos), null, Lr(u.attrs, "rowspan", u.attrs.rowspan - c.n));
    } else if (c.type == "colwidth mismatch") {
      let u = e.nodeAt(c.pos);
      r.setNodeMarkup(r.mapping.map(n + 1 + c.pos), null, Lr(u.attrs, "colwidth", c.colwidth));
    }
  }
  let o, s;
  for (let l = 0; l < a.length; l++) a[l] && (o == null && (o = l), s = l);
  for (let l = 0, c = n + 1; l < i.height; l++) {
    let u = e.child(l), d = c + u.nodeSize, f = a[l];
    if (f > 0) {
      let h = "cell";
      u.firstChild && (h = u.firstChild.type.spec.tableRole);
      let p = [];
      for (let g = 0; g < f; g++) p.push(Qr(t.schema)[h].createAndFill());
      let m = (l == 0 || o == l - 1) && s == l ? c + 1 : d - 1;
      r.insert(r.mapping.map(m), p);
    }
    c = d;
  }
  return r.setMeta(zHt, {
    fixTables: !0
  });
}
function gs(t) {
  let e = t.selection, n = x5(t), r = n.node(-1), i = n.start(-1), a = Kn.get(r), o;
  return e instanceof rn ? o = a.rectBetween(e.$anchorCell.pos - i, e.$headCell.pos - i) : o = a.findCell(n.pos - i), o.tableStart = i, o.map = a, o.table = r, o;
}
function _te(t, {
  map: e,
  tableStart: n,
  table: r
}, i) {
  let a = i > 0 ? -1 : 0;
  xHt(e, r, i + a) && (a = i == 0 || i == e.width ? null : 0);
  for (let o = 0; o < e.height; o++) {
    let s = o * e.width + i;
    if (i > 0 && i < e.width && e.map[s - 1] == e.map[s]) {
      let l = e.map[s], c = r.nodeAt(l);
      t.setNodeMarkup(t.mapping.map(n + l), null, Ote(c.attrs, i - e.colCount(l))), o += c.attrs.rowspan - 1;
    } else {
      let l = a == null ? Qr(r.type.schema).cell : r.nodeAt(e.map[s + a]).type, c = e.positionAt(o, i, r);
      t.insert(t.mapping.map(n + c), l.createAndFill());
    }
  }
  return t;
}
function OHt(t, e) {
  if (!xo(t)) return !1;
  if (e) {
    let n = gs(t);
    e(_te(t.tr, n, n.left));
  }
  return !0;
}
function BHt(t, e) {
  if (!xo(t)) return !1;
  if (e) {
    let n = gs(t);
    e(_te(t.tr, n, n.right));
  }
  return !0;
}
function HHt(t, {
  map: e,
  table: n,
  tableStart: r
}, i) {
  let a = t.mapping.maps.length;
  for (let o = 0; o < e.height; ) {
    let s = o * e.width + i, l = e.map[s], c = n.nodeAt(l);
    if (i > 0 && e.map[s - 1] == l || i < e.width - 1 && e.map[s + 1] == l)
      t.setNodeMarkup(t.mapping.slice(a).map(r + l), null, g0(c.attrs, i - e.colCount(l)));
    else {
      let u = t.mapping.slice(a).map(r + l);
      t.delete(u, u + c.nodeSize);
    }
    o += c.attrs.rowspan;
  }
}
function FHt(t, e) {
  if (!xo(t)) return !1;
  if (e) {
    let n = gs(t), r = t.tr;
    if (n.left == 0 && n.right == n.map.width) return !1;
    for (let i = n.right - 1; HHt(r, n, i), i != n.left; i--)
      n.table = n.tableStart ? r.doc.nodeAt(n.tableStart - 1) : r.doc, n.map = Kn.get(n.table);
    e(r);
  }
  return !0;
}
function _Ht(t, e, n) {
  let r = Qr(e.type.schema).header_cell;
  for (let i = 0; i < t.width; i++) if (e.nodeAt(t.map[i + n * t.width]).type != r) return !1;
  return !0;
}
function Vte(t, {
  map: e,
  tableStart: n,
  table: r
}, i) {
  let a = n;
  for (let l = 0; l < i; l++) a += r.child(l).nodeSize;
  let o = [], s = i > 0 ? -1 : 0;
  _Ht(e, r, i + s) && (s = i == 0 || i == e.height ? null : 0);
  for (let l = 0, c = e.width * i; l < e.width; l++, c++)
    if (i > 0 && i < e.height && e.map[c] == e.map[c - e.width]) {
      let u = e.map[c], d = r.nodeAt(u).attrs;
      t.setNodeMarkup(n + u, null, Lr(d, "rowspan", d.rowspan + 1)), l += d.colspan - 1;
    } else {
      let u = s == null ? Qr(r.type.schema).cell : r.nodeAt(e.map[c + s * e.width]).type;
      o.push(u.createAndFill());
    }
  return t.insert(a, Qr(r.type.schema).row.create(null, o)), t;
}
function VHt(t, e) {
  if (!xo(t)) return !1;
  if (e) {
    let n = gs(t);
    e(Vte(t.tr, n, n.top));
  }
  return !0;
}
function qHt(t, e) {
  if (!xo(t)) return !1;
  if (e) {
    let n = gs(t);
    e(Vte(t.tr, n, n.bottom));
  }
  return !0;
}
function UHt(t, {
  map: e,
  table: n,
  tableStart: r
}, i) {
  let a = 0;
  for (let l = 0; l < i; l++) a += n.child(l).nodeSize;
  let o = a + n.child(i).nodeSize, s = t.mapping.maps.length;
  t.delete(a + r, o + r);
  for (let l = 0, c = i * e.width; l < e.width; l++, c++) {
    let u = e.map[c];
    if (i > 0 && u == e.map[c - e.width]) {
      let d = n.nodeAt(u).attrs;
      t.setNodeMarkup(t.mapping.slice(s).map(u + r), null, Lr(d, "rowspan", d.rowspan - 1)), l += d.colspan - 1;
    } else if (i < e.width && u == e.map[c + e.width]) {
      let d = n.nodeAt(u), f = d.type.create(Lr(d.attrs, "rowspan", d.attrs.rowspan - 1), d.content), h = e.positionAt(i + 1, l, n);
      t.insert(t.mapping.slice(s).map(r + h), f), l += d.attrs.colspan - 1;
    }
  }
}
function WHt(t, e) {
  if (!xo(t)) return !1;
  if (e) {
    let n = gs(t), r = t.tr;
    if (n.top == 0 && n.bottom == n.map.height) return !1;
    for (let i = n.bottom - 1; UHt(r, n, i), i != n.top; i--)
      n.table = n.tableStart ? r.doc.nodeAt(n.tableStart - 1) : r.doc, n.map = Kn.get(n.table);
    e(r);
  }
  return !0;
}
function zR(t) {
  let e = t.content;
  return e.childCount == 1 && e.firstChild.isTextblock && e.firstChild.childCount == 0;
}
function ZHt({
  width: t,
  height: e,
  map: n
}, r) {
  let i = r.top * t + r.left, a = i, o = (r.bottom - 1) * t + r.left, s = i + (r.right - r.left - 1);
  for (let l = r.top; l < r.bottom; l++) {
    if (r.left > 0 && n[a] == n[a - 1] || r.right < t && n[s] == n[s + 1]) return !0;
    a += t, s += t;
  }
  for (let l = r.left; l < r.right; l++) {
    if (r.top > 0 && n[i] == n[i - t] || r.bottom < e && n[o] == n[o + t]) return !0;
    i++, o++;
  }
  return !1;
}
function RR(t, e) {
  let n = t.selection;
  if (!(n instanceof rn) || n.$anchorCell.pos == n.$headCell.pos) return !1;
  let r = gs(t), {
    map: i
  } = r;
  if (ZHt(i, r)) return !1;
  if (e) {
    let a = t.tr, o = {}, s = Ne.empty, l, c;
    for (let u = r.top; u < r.bottom; u++)
      for (let d = r.left; d < r.right; d++) {
        let f = i.map[u * i.width + d], h = r.table.nodeAt(f);
        if (!o[f])
          if (o[f] = !0, l == null)
            l = f, c = h;
          else {
            zR(h) || (s = s.append(h.content));
            let p = a.mapping.map(f + r.tableStart);
            a.delete(p, p + h.nodeSize);
          }
      }
    if (a.setNodeMarkup(l + r.tableStart, null, Lr(Ote(c.attrs, c.attrs.colspan, r.right - r.left - c.attrs.colspan), "rowspan", r.bottom - r.top)), s.size) {
      let u = l + 1 + c.content.size, d = zR(c) ? l + 1 : u;
      a.replaceWith(d + r.tableStart, u + r.tableStart, s);
    }
    a.setSelection(new rn(a.doc.resolve(l + r.tableStart))), e(a);
  }
  return !0;
}
function OR(t, e) {
  const n = Qr(t.schema);
  return GHt(({
    node: r
  }) => n[r.type.spec.tableRole])(t, e);
}
function GHt(t) {
  return (e, n) => {
    let r = e.selection, i, a;
    if (r instanceof rn) {
      if (r.$anchorCell.pos != r.$headCell.pos) return !1;
      i = r.$anchorCell.nodeAfter, a = r.$anchorCell.pos;
    } else {
      if (i = bHt(r.$from), !i) return !1;
      a = Kd(r.$from).pos;
    }
    if (i.attrs.colspan == 1 && i.attrs.rowspan == 1)
      return !1;
    if (n) {
      let o = i.attrs, s = [], l = o.colwidth;
      o.rowspan > 1 && (o = Lr(o, "rowspan", 1)), o.colspan > 1 && (o = Lr(o, "colspan", 1));
      let c = gs(e), u = e.tr;
      for (let f = 0; f < c.right - c.left; f++) s.push(l ? Lr(o, "colwidth", l && l[f] ? [l[f]] : null) : o);
      let d;
      for (let f = c.top; f < c.bottom; f++) {
        let h = c.map.positionAt(f, c.left, c.table);
        f == c.top && (h += i.nodeSize);
        for (let p = c.left, m = 0; p < c.right; p++, m++)
          p == c.left && f == c.top || u.insert(d = u.mapping.map(h + c.tableStart, 1), t({
            node: i,
            row: f,
            col: p
          }).createAndFill(s[m]));
      }
      u.setNodeMarkup(a, t({
        node: i,
        row: c.top,
        col: c.left
      }), s[0]), r instanceof rn && u.setSelection(new rn(u.doc.resolve(r.$anchorCell.pos), d && u.doc.resolve(d))), n(u);
    }
    return !0;
  };
}
function YHt(t, e) {
  return function(n, r) {
    if (!xo(n)) return !1;
    let i = x5(n);
    if (i.nodeAfter.attrs[t] === e) return !1;
    if (r) {
      let a = n.tr;
      n.selection instanceof rn ? n.selection.forEachCell((o, s) => {
        o.attrs[t] !== e && a.setNodeMarkup(s, null, Lr(o.attrs, t, e));
      }) : a.setNodeMarkup(i.pos, null, Lr(i.nodeAfter.attrs, t, e)), r(a);
    }
    return !0;
  };
}
function KHt(t) {
  return function(e, n) {
    if (!xo(e)) return !1;
    if (n) {
      let r = Qr(e.schema), i = gs(e), a = e.tr, o = i.map.cellsInRect(t == "column" ? new yd(i.left, 0, i.right, i.map.height) : t == "row" ? new yd(0, i.top, i.map.width, i.bottom) : i), s = o.map((l) => i.table.nodeAt(l));
      for (let l = 0; l < o.length; l++) s[l].type == r.header_cell && a.setNodeMarkup(i.tableStart + o[l], r.cell, s[l].attrs);
      if (a.steps.length == 0) for (let l = 0; l < o.length; l++) a.setNodeMarkup(i.tableStart + o[l], r.header_cell, s[l].attrs);
      n(a);
    }
    return !0;
  };
}
function BR(t, e, n) {
  const r = e.map.cellsInRect({
    left: 0,
    top: 0,
    right: t == "row" ? e.map.width : 1,
    bottom: t == "column" ? e.map.height : 1
  });
  for (let i = 0; i < r.length; i++) {
    const a = e.table.nodeAt(r[i]);
    if (a && a.type !== n.header_cell)
      return !1;
  }
  return !0;
}
function K2(t, e) {
  return e = e || {
    useDeprecatedLogic: !1
  }, e.useDeprecatedLogic ? KHt(t) : function(n, r) {
    if (!xo(n)) return !1;
    if (r) {
      let i = Qr(n.schema), a = gs(n), o = n.tr, s = BR("row", a, i), l = BR("column", a, i), u = (t === "column" ? s : t === "row" ? l : !1) ? 1 : 0, d = t == "column" ? new yd(0, u, 1, a.map.height) : t == "row" ? new yd(u, 0, a.map.width, 1) : a, f = t == "column" ? l ? i.cell : i.header_cell : t == "row" ? s ? i.cell : i.header_cell : i.cell;
      a.map.cellsInRect(d).forEach((h) => {
        const p = h + a.tableStart, m = o.doc.nodeAt(p);
        m && o.setNodeMarkup(p, f, m.attrs);
      }), r(o);
    }
    return !0;
  };
}
K2("row", {
  useDeprecatedLogic: !0
});
K2("column", {
  useDeprecatedLogic: !0
});
let $Ht = K2("cell", {
  useDeprecatedLogic: !0
});
function JHt(t, e) {
  if (e < 0) {
    let n = t.nodeBefore;
    if (n) return t.pos - n.nodeSize;
    for (let r = t.index(-1) - 1, i = t.before(); r >= 0; r--) {
      let a = t.node(-1).child(r);
      if (a.childCount) return i - 1 - a.lastChild.nodeSize;
      i -= a.nodeSize;
    }
  } else {
    if (t.index() < t.parent.childCount - 1) return t.pos + t.nodeAfter.nodeSize;
    let n = t.node(-1);
    for (let r = t.indexAfter(-1), i = t.after(); r < n.childCount; r++) {
      let a = n.child(r);
      if (a.childCount) return i + 1;
      i += a.nodeSize;
    }
  }
}
function HR(t) {
  return function(e, n) {
    if (!xo(e)) return !1;
    let r = JHt(x5(e), t);
    if (r != null) {
      if (n) {
        let i = e.doc.resolve(r);
        n(e.tr.setSelection(ot.between(i, kHt(i))).scrollIntoView());
      }
      return !0;
    }
  };
}
function QHt(t, e) {
  let n = t.selection.$anchor;
  for (let r = n.depth; r > 0; r--)
    if (n.node(r).type.spec.tableRole == "table")
      return e && e(t.tr.delete(n.before(r), n.after(r)).scrollIntoView()), !0;
  return !1;
}
let XHt = class {
  constructor(e, n) {
    this.node = e, this.cellMinWidth = n, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.colgroup = this.table.appendChild(document.createElement("colgroup")), Ek(e, this.colgroup, this.table, n), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(e) {
    return e.type != this.node.type ? !1 : (this.node = e, Ek(e, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(e) {
    return e.type == "attributes" && (e.target == this.table || this.colgroup.contains(e.target));
  }
};
function Ek(t, e, n, r, i, a) {
  let o = 0, s = !0, l = e.firstChild, c = t.firstChild;
  for (let u = 0, d = 0; u < c.childCount; u++) {
    let {
      colspan: f,
      colwidth: h
    } = c.child(u).attrs;
    for (let p = 0; p < f; p++, d++) {
      let m = i == d ? a : h && h[p], g = m ? m + "px" : "";
      o += m || r, m || (s = !1), l ? (l.style.width != g && (l.style.width = g), l = l.nextSibling) : e.appendChild(document.createElement("col")).style.width = g;
    }
  }
  for (; l; ) {
    let u = l.nextSibling;
    l.parentNode.removeChild(l), l = u;
  }
  s ? (n.style.width = o + "px", n.style.minWidth = "") : (n.style.width = "", n.style.minWidth = o + "px");
}
const Ca = new tn("tableColumnResizing");
function eFt({
  handleWidth: t = 5,
  cellMinWidth: e = 25,
  View: n = XHt,
  lastColumnResizable: r = !0
} = {}) {
  return new Wt({
    key: Ca,
    state: {
      init(a, o) {
        return this.spec.props.nodeViews[Qr(o.schema).table.name] = (s, l) => new n(s, e, l), new xh(-1, !1);
      },
      apply(a, o) {
        return o.apply(a);
      }
    },
    props: {
      attributes(a) {
        return Ca.getState(a).activeHandle > -1 ? {
          class: "resize-cursor"
        } : null;
      },
      handleDOMEvents: {
        mousemove(a, o) {
          tFt(a, o, t, e, r);
        },
        mouseleave(a) {
          nFt(a);
        },
        mousedown(a, o) {
          rFt(a, o, e);
        }
      },
      decorations(a) {
        let o = Ca.getState(a);
        if (o.activeHandle > -1) return cFt(a, o.activeHandle);
      },
      nodeViews: {}
    }
  });
}
class xh {
  constructor(e, n) {
    this.activeHandle = e, this.dragging = n;
  }
  apply(e) {
    let n = this, r = e.getMeta(Ca);
    if (r && r.setHandle != null) return new xh(r.setHandle, null);
    if (r && r.setDragging !== void 0) return new xh(n.activeHandle, r.setDragging);
    if (n.activeHandle > -1 && e.docChanged) {
      let i = e.mapping.map(n.activeHandle, -1);
      Lk(e.doc.resolve(i)) || (i = null), n = new xh(i, n.dragging);
    }
    return n;
  }
}
function tFt(t, e, n, r, i) {
  let a = Ca.getState(t.state);
  if (!a.dragging) {
    let o = aFt(e.target), s = -1;
    if (o) {
      let {
        left: l,
        right: c
      } = o.getBoundingClientRect();
      e.clientX - l <= n ? s = FR(t, e, "left") : c - e.clientX <= n && (s = FR(t, e, "right"));
    }
    if (s != a.activeHandle) {
      if (!i && s !== -1) {
        let l = t.state.doc.resolve(s), c = l.node(-1), u = Kn.get(c), d = l.start(-1);
        if (u.colCount(l.pos - d) + l.nodeAfter.attrs.colspan - 1 == u.width - 1)
          return;
      }
      qte(t, s);
    }
  }
}
function nFt(t) {
  let e = Ca.getState(t.state);
  e.activeHandle > -1 && !e.dragging && qte(t, -1);
}
function rFt(t, e, n) {
  let r = Ca.getState(t.state);
  if (r.activeHandle == -1 || r.dragging) return !1;
  let i = t.state.doc.nodeAt(r.activeHandle), a = iFt(t, r.activeHandle, i.attrs);
  t.dispatch(t.state.tr.setMeta(Ca, {
    setDragging: {
      startX: e.clientX,
      startWidth: a
    }
  }));
  function o(l) {
    window.removeEventListener("mouseup", o), window.removeEventListener("mousemove", s);
    let c = Ca.getState(t.state);
    c.dragging && (oFt(t, c.activeHandle, _R(c.dragging, l, n)), t.dispatch(t.state.tr.setMeta(Ca, {
      setDragging: null
    })));
  }
  function s(l) {
    if (!l.which) return o(l);
    let c = Ca.getState(t.state), u = _R(c.dragging, l, n);
    sFt(t, c.activeHandle, u, n);
  }
  return window.addEventListener("mouseup", o), window.addEventListener("mousemove", s), e.preventDefault(), !0;
}
function iFt(t, e, {
  colspan: n,
  colwidth: r
}) {
  let i = r && r[r.length - 1];
  if (i) return i;
  let a = t.domAtPos(e), s = a.node.childNodes[a.offset].offsetWidth, l = n;
  if (r) for (let c = 0; c < n; c++) r[c] && (s -= r[c], l--);
  return s / l;
}
function aFt(t) {
  for (; t && t.nodeName != "TD" && t.nodeName != "TH"; ) t = t.classList.contains("ProseMirror") ? null : t.parentNode;
  return t;
}
function FR(t, e, n) {
  let r = t.posAtCoords({
    left: e.clientX,
    top: e.clientY
  });
  if (!r) return -1;
  let {
    pos: i
  } = r, a = Kd(t.state.doc.resolve(i));
  if (!a) return -1;
  if (n == "right") return a.pos;
  let o = Kn.get(a.node(-1)), s = a.start(-1), l = o.map.indexOf(a.pos - s);
  return l % o.width == 0 ? -1 : s + o.map[l - 1];
}
function _R(t, e, n) {
  let r = e.clientX - t.startX;
  return Math.max(n, t.startWidth + r);
}
function qte(t, e) {
  t.dispatch(t.state.tr.setMeta(Ca, {
    setHandle: e
  }));
}
function oFt(t, e, n) {
  let r = t.state.doc.resolve(e), i = r.node(-1), a = Kn.get(i), o = r.start(-1), s = a.colCount(r.pos - o) + r.nodeAfter.attrs.colspan - 1, l = t.state.tr;
  for (let c = 0; c < a.height; c++) {
    let u = c * a.width + s;
    if (c && a.map[u] == a.map[u - a.width]) continue;
    let d = a.map[u], {
      attrs: f
    } = i.nodeAt(d), h = f.colspan == 1 ? 0 : s - a.colCount(d);
    if (f.colwidth && f.colwidth[h] == n) continue;
    let p = f.colwidth ? f.colwidth.slice() : lFt(f.colspan);
    p[h] = n, l.setNodeMarkup(o + d, null, Lr(f, "colwidth", p));
  }
  l.docChanged && t.dispatch(l);
}
function sFt(t, e, n, r) {
  let i = t.state.doc.resolve(e), a = i.node(-1), o = i.start(-1), s = Kn.get(a).colCount(i.pos - o) + i.nodeAfter.attrs.colspan - 1, l = t.domAtPos(i.start(-1)).node;
  for (; l.nodeName != "TABLE"; ) l = l.parentNode;
  Ek(a, l.firstChild, l, r, s, n);
}
function lFt(t) {
  let e = [];
  for (let n = 0; n < t; n++) e.push(0);
  return e;
}
function cFt(t, e) {
  let n = [], r = t.doc.resolve(e), i = r.node(-1), a = Kn.get(i), o = r.start(-1), s = a.colCount(r.pos - o) + r.nodeAfter.attrs.colspan;
  for (let l = 0; l < a.height; l++) {
    let c = s + l * a.width - 1;
    if ((s == a.width || a.map[c] != a.map[c + 1]) && (l == 0 || a.map[c - 1] != a.map[c - 1 - a.width])) {
      let u = a.map[c], d = o + u + i.nodeAt(u).nodeSize - 1, f = document.createElement("div");
      f.className = "column-resize-handle", n.push(hr.widget(d, f));
    }
  }
  return vn.create(t.doc, n);
}
function uFt({
  allowTableNodeSelection: t = !1
} = {}) {
  return new Wt({
    key: tc,
    // This piece of state is used to remember when a mouse-drag
    // cell-selection is happening, so that it can continue even as
    // transactions (which might move its anchor cell) come in.
    state: {
      init() {
        return null;
      },
      apply(e, n) {
        let r = e.getMeta(tc);
        if (r != null) return r == -1 ? null : r;
        if (n == null || !e.docChanged) return n;
        let {
          deleted: i,
          pos: a
        } = e.mapping.mapResult(n);
        return i ? null : a;
      }
    },
    props: {
      decorations: MHt,
      handleDOMEvents: {
        mousedown: PHt
      },
      createSelectionBetween(e) {
        if (tc.getState(e.state) != null) return e.state.selection;
      },
      handleTripleClick: DHt,
      handleKeyDown: NHt,
      handlePaste: IHt
    },
    appendTransaction(e, n, r) {
      return SHt(r, Fte(r, n), t);
    }
  });
}
function VR(t, e, n, r, i, a) {
  var u;
  let o = 0, s = !0, l = e.firstChild;
  const c = t.firstChild;
  if (c)
    for (let d = 0, f = 0; d < c.childCount; d += 1) {
      const { colspan: h, colwidth: p } = c.child(d).attrs;
      for (let m = 0; m < h; m += 1, f += 1) {
        const g = i === f ? a : p && p[m], v = g ? `${g}px` : "";
        o += g || r, g || (s = !1), l ? (l.style.width !== v && (l.style.width = v), l = l.nextSibling) : e.appendChild(document.createElement("col")).style.width = v;
      }
    }
  for (; l; ) {
    const d = l.nextSibling;
    (u = l == null ? void 0 : l.parentNode) == null || u.removeChild(l), l = d;
  }
  s ? (n.style.width = `${o}px`, n.style.minWidth = "") : (n.style.width = "", n.style.minWidth = `${o}px`);
}
class dFt {
  constructor(e, n) {
    ua(this, "node");
    ua(this, "cellMinWidth");
    ua(this, "dom");
    ua(this, "table");
    ua(this, "colgroup");
    ua(this, "contentDOM");
    this.node = e, this.cellMinWidth = n, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.colgroup = this.table.appendChild(document.createElement("colgroup")), VR(e, this.colgroup, this.table, n), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(e) {
    return e.type !== this.node.type ? !1 : (this.node = e, VR(e, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(e) {
    return e.type === "attributes" && (e.target === this.table || this.colgroup.contains(e.target));
  }
}
function qR(t, e) {
  return t.createAndFill();
}
function fFt(t) {
  if (t.cached.tableNodeTypes)
    return t.cached.tableNodeTypes;
  const e = {};
  return Object.keys(t.nodes).forEach((n) => {
    const r = t.nodes[n];
    r.spec.tableRole && (e[r.spec.tableRole] = r);
  }), t.cached.tableNodeTypes = e, e;
}
function hFt(t, e, n, r, i) {
  const a = fFt(t), o = [], s = [];
  for (let c = 0; c < n; c += 1) {
    const u = qR(a.cell);
    if (u && s.push(u), r) {
      const d = qR(a.header_cell);
      d && o.push(d);
    }
  }
  const l = [];
  for (let c = 0; c < e; c += 1)
    l.push(
      a.row.createChecked(
        null,
        r && c === 0 ? o : s
      )
    );
  return a.table.createChecked(null, l);
}
function pFt(t) {
  return t instanceof rn;
}
const w4 = ({
  editor: t
}) => {
  const { selection: e } = t.state;
  if (!pFt(e))
    return !1;
  let n = 0;
  const r = xx(
    e.ranges[0].$from,
    (a) => a.type.name === "table"
  );
  return r == null || r.node.descendants((a) => {
    if (a.type.name === "table")
      return !1;
    ["tableCell", "tableHeader"].includes(a.type.name) && (n += 1);
  }), n === e.ranges.length ? (t.commands.deleteTable(), !0) : !1;
}, Ute = Ht.create({
  name: "table",
  // @ts-ignore
  addOptions() {
    return {
      HTMLAttributes: {},
      resizable: !1,
      handleWidth: 5,
      cellMinWidth: 25,
      // TODO: fix
      View: dFt,
      lastColumnResizable: !0,
      allowTableNodeSelection: !1
    };
  },
  content: "tableRow+",
  tableRole: "table",
  isolating: !0,
  group: "block",
  parseHTML() {
    return [{ tag: "table" }];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    let n = 0, r = !0;
    try {
      t.content.firstChild.content.forEach((a) => {
        if (a.attrs.colwidth)
          a.attrs.colwidth.forEach((o) => {
            o ? n += o : (r = !1, n += this.options.cellMinWidth);
          });
        else {
          r = !1;
          const o = a.attrs.colspan ? a.attrs.colspan : 1;
          n += this.options.cellMinWidth * o;
        }
      });
    } catch {
      r = !1;
    }
    return r && n > 0 ? e.style = `width: ${n}px;` : n && n > 0 ? e.style = `min-width: ${n}px` : e.style = null, [
      "div",
      { class: "table-wrapper" },
      [
        "table",
        _t(this.options.HTMLAttributes, e),
        ["tbody", 0]
      ]
    ];
  },
  addCommands() {
    return {
      insertTable: ({ rows: t = 3, cols: e = 3, withHeaderRow: n = !0 } = {}) => ({ tr: r, dispatch: i, editor: a }) => {
        const { selection: o } = r, s = hFt(a.schema, t, e, n);
        if (i) {
          const l = r.selection.anchor + 1;
          r.replaceRangeWith(o.from - 1, o.to, s).scrollIntoView().setSelection(ot.near(r.doc.resolve(l)));
        }
        return !0;
      },
      addColumnBefore: () => ({ state: t, dispatch: e }) => OHt(t, e),
      addColumnAfter: () => ({ state: t, dispatch: e }) => BHt(t, e),
      deleteColumn: () => ({ state: t, dispatch: e }) => FHt(t, e),
      addRowBefore: () => ({ state: t, dispatch: e }) => VHt(t, e),
      addRowAfter: () => ({ state: t, dispatch: e }) => qHt(t, e),
      deleteRow: () => ({ state: t, dispatch: e }) => WHt(t, e),
      deleteTable: () => ({ state: t, dispatch: e }) => QHt(t, e),
      mergeCells: () => ({ state: t, dispatch: e }) => RR(t, e),
      splitCell: () => ({ state: t, dispatch: e }) => OR(t, e),
      toggleHeaderColumn: () => ({ state: t, dispatch: e }) => K2("column")(t, e),
      toggleHeaderRow: () => ({ state: t, dispatch: e }) => K2("row")(t, e),
      toggleHeaderCell: () => ({ state: t, dispatch: e }) => $Ht(t, e),
      mergeOrSplit: () => ({ state: t, dispatch: e }) => RR(t, e) ? !0 : OR(t, e),
      setCellAttribute: (t, e) => ({ state: n, dispatch: r }) => YHt(t, e)(n, r),
      goToNextCell: () => ({ state: t, dispatch: e }) => HR(1)(t, e),
      goToPreviousCell: () => ({ state: t, dispatch: e }) => HR(-1)(t, e),
      fixTables: () => ({ state: t, dispatch: e }) => (e && Fte(t), !0),
      setCellSelection: (t) => ({ tr: e, dispatch: n }) => {
        if (n) {
          const r = rn.create(
            e.doc,
            t.anchorCell,
            t.headCell
          );
          e.setSelection(r);
        }
        return !0;
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      Tab: () => this.editor.commands.goToNextCell() ? !0 : this.editor.can().addRowAfter() ? this.editor.chain().addRowAfter().goToNextCell().run() : !1,
      "Shift-Tab": () => this.editor.commands.goToPreviousCell(),
      Backspace: w4,
      "Mod-Backspace": w4,
      Delete: w4,
      "Mod-Delete": w4
    };
  },
  addProseMirrorPlugins() {
    return [
      ...this.options.resizable && this.editor.isEditable ? [
        eFt({
          handleWidth: this.options.handleWidth,
          cellMinWidth: this.options.cellMinWidth,
          View: this.options.View,
          // TODO: PR for @types/prosemirror-tables
          // @ts-ignore (incorrect type)
          lastColumnResizable: this.options.lastColumnResizable
        })
      ] : [],
      uFt({
        allowTableNodeSelection: this.options.allowTableNodeSelection
      })
    ];
  },
  extendNodeSchema(t) {
    const e = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      tableRole: Gt(
        ft(t, "tableRole", e)
      )
    };
  }
});
function Wte(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
var Zte = typeof window < "u" && typeof document < "u";
function jk(t, e) {
  t && (typeof t == "function" && t(e), {}.hasOwnProperty.call(t, "current") && (t.current = e));
}
function UR() {
  return Zte && document.createElement("div");
}
function mFt(t) {
  var e = {
    "data-placement": t.placement
  };
  return t.referenceHidden && (e["data-reference-hidden"] = ""), t.escaped && (e["data-escaped"] = ""), e;
}
function Gte(t, e) {
  if (t === e)
    return !0;
  if (typeof t == "object" && t != null && typeof e == "object" && e != null) {
    if (Object.keys(t).length !== Object.keys(e).length)
      return !1;
    for (var n in t)
      if (e.hasOwnProperty(n)) {
        if (!Gte(t[n], e[n]))
          return !1;
      } else
        return !1;
    return !0;
  } else
    return !1;
}
function yFt(t) {
  var e = [];
  return t.forEach(function(n) {
    e.find(function(r) {
      return Gte(n, r);
    }) || e.push(n);
  }), e;
}
function gFt(t, e) {
  var n, r;
  return Object.assign({}, e, {
    popperOptions: Object.assign({}, t.popperOptions, e.popperOptions, {
      modifiers: yFt([].concat(((n = t.popperOptions) == null ? void 0 : n.modifiers) || [], ((r = e.popperOptions) == null ? void 0 : r.modifiers) || []))
    })
  });
}
var Lb = Zte ? us : ze;
function vFt(t) {
  var e = Ue();
  return e.current || (e.current = typeof t == "function" ? t() : t), e.current;
}
function WR(t, e, n) {
  n.split(/\s+/).forEach(function(r) {
    r && t.classList[e](r);
  });
}
var bFt = {
  name: "className",
  defaultValue: "",
  fn: function(e) {
    var n = e.popper.firstElementChild, r = function() {
      var s;
      return !!((s = e.props.render) != null && s.$$tippy);
    };
    function i() {
      if (e.props.className && !r()) {
        process.env.NODE_ENV !== "production" && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
        return;
      }
      WR(n, "add", e.props.className);
    }
    function a() {
      r() && WR(n, "remove", e.props.className);
    }
    return {
      onCreate: i,
      onBeforeUpdate: a,
      onAfterUpdate: i
    };
  }
};
function wFt(t) {
  function e(n) {
    var r = n.children, i = n.content, a = n.visible, o = n.singleton, s = n.render, l = n.reference, c = n.disabled, u = c === void 0 ? !1 : c, d = n.ignoreAttributes, f = d === void 0 ? !0 : d;
    n.__source, n.__self;
    var h = Wte(n, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]), p = a !== void 0, m = o !== void 0, g = De(!1), v = g[0], k = g[1], w = De({}), b = w[0], x = w[1], A = De(), L = A[0], M = A[1], j = vFt(function() {
      return {
        container: UR(),
        renders: 1
      };
    }), D = Object.assign({
      ignoreAttributes: f
    }, h, {
      content: j.container
    });
    p && (process.env.NODE_ENV !== "production" && ["trigger", "hideOnClick", "showOnCreate"].forEach(function(F) {
      D[F] !== void 0 && console.warn(["@tippyjs/react: Cannot specify `" + F + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), D.trigger = "manual", D.hideOnClick = !1), m && (u = !0);
    var z = D, H = D.plugins || [];
    s && (z = Object.assign({}, D, {
      plugins: m && o.data != null ? [].concat(H, [{
        fn: function() {
          return {
            onTrigger: function(W, G) {
              var Y = o.data.children.find(function(Z) {
                var oe = Z.instance;
                return oe.reference === G.currentTarget;
              });
              W.state.$$activeSingletonInstance = Y.instance, M(Y.content);
            }
          };
        }
      }]) : H,
      render: function() {
        return {
          popper: j.container
        };
      }
    }));
    var V = [l].concat(r ? [r.type] : []);
    return Lb(function() {
      var F = l;
      l && l.hasOwnProperty("current") && (F = l.current);
      var _ = t(F || j.ref || UR(), Object.assign({}, z, {
        plugins: [bFt].concat(D.plugins || [])
      }));
      return j.instance = _, u && _.disable(), a && _.show(), m && o.hook({
        instance: _,
        content: i,
        props: z,
        setSingletonContent: M
      }), k(!0), function() {
        _.destroy(), o == null || o.cleanup(_);
      };
    }, V), Lb(function() {
      var F;
      if (j.renders === 1) {
        j.renders++;
        return;
      }
      var _ = j.instance;
      _.setProps(gFt(_.props, z)), (F = _.popperInstance) == null || F.forceUpdate(), u ? _.disable() : _.enable(), p && (a ? _.show() : _.hide()), m && o.hook({
        instance: _,
        content: i,
        props: z,
        setSingletonContent: M
      });
    }), Lb(function() {
      var F;
      if (s) {
        var _ = j.instance;
        _.setProps({
          popperOptions: Object.assign({}, _.props.popperOptions, {
            modifiers: [].concat((((F = _.props.popperOptions) == null ? void 0 : F.modifiers) || []).filter(function(W) {
              var G = W.name;
              return G !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function(G) {
                var Y, Z = G.state, oe = (Y = Z.modifiersData) == null ? void 0 : Y.hide;
                (b.placement !== Z.placement || b.referenceHidden !== (oe == null ? void 0 : oe.isReferenceHidden) || b.escaped !== (oe == null ? void 0 : oe.hasPopperEscaped)) && x({
                  placement: Z.placement,
                  referenceHidden: oe == null ? void 0 : oe.isReferenceHidden,
                  escaped: oe == null ? void 0 : oe.hasPopperEscaped
                }), Z.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [b.placement, b.referenceHidden, b.escaped].concat(V)), /* @__PURE__ */ Ce.createElement(Ce.Fragment, null, r ? /* @__PURE__ */ vd(r, {
      ref: function(_) {
        j.ref = _, jk(r.ref, _);
      }
    }) : null, v && /* @__PURE__ */ eB(s ? s(mFt(b), L, j.instance) : i, j.container));
  }
  return e;
}
var kFt = function(t, e) {
  return /* @__PURE__ */ en(function(r, i) {
    var a = r.children, o = Wte(r, ["children"]);
    return (
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      /* @__PURE__ */ Ce.createElement(t, Object.assign({}, e, o), a ? /* @__PURE__ */ vd(a, {
        ref: function(l) {
          jk(i, l), jk(a.ref, l);
        }
      }) : null)
    );
  });
}, xFt = /* @__PURE__ */ kFt(/* @__PURE__ */ wFt(w0));
const MFt = [
  {
    name: "Add row above",
    action: (t) => t.chain().focus().addRowBefore().run(),
    icon: /* @__PURE__ */ C.jsx("svg", { viewBox: "0 0 24 24", children: /* @__PURE__ */ C.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M22 14a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7h2v-2h4v2h2v-2h4v2h2v-2h4v2h2v-7M4 14h4v3H4v-3m6 0h4v3h-4v-3m10 0v3h-4v-3h4m-9-4h2V7h3V5h-3V2h-2v3H8v2h3v3Z"
      }
    ) })
  },
  {
    name: "Add row below",
    action: (t) => t.chain().focus().addRowAfter().run(),
    icon: /* @__PURE__ */ C.jsx("svg", { viewBox: "0 0 24 24", children: /* @__PURE__ */ C.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M22 10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3h2v2h4V3h2v2h4V3h2v2h4V3h2v7M4 10h4V7H4v3m6 0h4V7h-4v3m10 0V7h-4v3h4m-9 4h2v3h3v2h-3v3h-2v-3H8v-2h3v-3Z"
      }
    ) })
  },
  {
    name: "Add left column",
    action: (t) => t.chain().focus().addColumnBefore().run(),
    icon: /* @__PURE__ */ C.jsx("svg", { viewBox: "0 0 24 24", children: /* @__PURE__ */ C.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h9V2h-9m7 8v4h-7v-4h7m0 6v4h-7v-4h7m0-12v4h-7V4h7M9 11H6V8H4v3H1v2h3v3h2v-3h3v-2Z"
      }
    ) })
  },
  {
    name: "Add right column",
    action: (t) => t.chain().focus().addColumnAfter().run(),
    icon: /* @__PURE__ */ C.jsx("svg", { viewBox: "0 0 24 24", children: /* @__PURE__ */ C.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2V2h9m-7 8v4h7v-4H4m0 6v4h7v-4H4M4 4v4h7V4H4m11 7h3V8h2v3h3v2h-3v3h-2v-3h-3v-2Z"
      }
    ) })
  },
  {
    name: "Remove row",
    action: (t) => t.chain().focus().deleteRow().run(),
    icon: /* @__PURE__ */ C.jsx("svg", { viewBox: "0 0 24 24", children: /* @__PURE__ */ C.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.41 13L12 15.59L14.59 13L16 14.41L13.41 17L16 19.59L14.59 21L12 18.41L9.41 21L8 19.59L10.59 17L8 14.41L9.41 13M22 9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3M4 9h4V6H4v3m6 0h4V6h-4v3m6 0h4V6h-4v3Z"
      }
    ) })
  },
  {
    name: "Remove column",
    action: (t) => t.chain().focus().deleteColumn().run(),
    icon: /* @__PURE__ */ C.jsx("svg", { viewBox: "0 0 24 24", children: /* @__PURE__ */ C.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4 2h7a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 8v4h7v-4H4m0 6v4h7v-4H4M4 4v4h7V4H4m13.59 8L15 9.41L16.41 8L19 10.59L21.59 8L23 9.41L20.41 12L23 14.59L21.59 16L19 13.41L16.41 16L15 14.59L17.59 12Z"
      }
    ) })
  },
  {
    name: "Toggle header row",
    action: (t) => t.chain().focus().toggleHeaderRow().run(),
    icon: /* @__PURE__ */ C.jsx("svg", { viewBox: "0 0 24 24", children: /* @__PURE__ */ C.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M22 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4M4 14h4v-4H4v4m6 0h4v-4h-4v4m6 0h4v-4h-4v4Z"
      }
    ) })
  },
  {
    name: "Toggle header column",
    action: (t) => t.chain().focus().toggleHeaderColumn().run(),
    icon: /* @__PURE__ */ C.jsx("svg", { viewBox: "0 0 24 24", children: /* @__PURE__ */ C.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 8v4h8v-4H8m0 6v4h8v-4H8M8 4v4h8V4H8Z"
      }
    ) })
  },
  {
    name: "Toggle header cell",
    action: (t) => t.chain().focus().toggleHeaderCell().run(),
    icon: /* @__PURE__ */ C.jsx("svg", { viewBox: "0 0 24 24", children: /* @__PURE__ */ C.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M21 19a1 1 0 0 1-1 1h-1v-2h2v1m-6 1v-2h2v2h-2m-4 0v-2h2v2h-2m-4 0v-2h2v2H7m-3 0a1 1 0 0 1-1-1v-1h2v2H4M19 4H5a2 2 0 0 0-2 2v2h18V6c0-1.11-.89-2-2-2M5 14H3v2h2v-2m0-4H3v2h2v-2m16 0h-2v2h2v-2m0 4h-2v2h2v-2m-10 2v-2h2v2h-2m0-4v-2h2v2h-2"
      }
    ) })
  },
  {
    name: "Remove table",
    action: (t) => t.chain().focus().deleteTable().run(),
    icon: /* @__PURE__ */ C.jsx("svg", { viewBox: "0 0 24 24", children: /* @__PURE__ */ C.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12.35 20H10v-3h2.09c.12-.72.37-1.39.72-2H10v-3h4v1.54c.58-.54 1.25-.93 2-1.19V12h4v.35c.75.26 1.42.65 2 1.19V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h9.54c-.54-.58-.93-1.25-1.19-2M16 7h4v3h-4V7m-6 0h4v3h-4V7M8 20H4v-3h4v3m0-5H4v-3h4v3m0-5H4V7h4v3m6.46 5.88l1.42-1.42L18 16.59l2.12-2.13l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.13-2.12"
      }
    ) })
  }
], Yte = ({
  node: t,
  getPos: e,
  selected: n,
  editor: r
}) => {
  const [i, a] = De(!1), { isPreviewMode: o } = Zp(), s = Ue(null), l = () => {
    const { from: u, to: d } = r.state.selection, f = e(), h = f + t.nodeSize;
    a(f <= u && d <= h);
  };
  ze(() => (r.on("selectionUpdate", l), setTimeout(l, 100), () => {
    r.off("selectionUpdate", l);
  }));
  const c = () => {
    var f, h;
    let u = (f = s.current) == null ? void 0 : f.clientTop;
    u && (u += 5);
    let d = (h = s.current) == null ? void 0 : h.clientLeft;
    return d && (d += 5), {
      top: `${u}px`,
      left: `${d}px`
    };
  };
  return /* @__PURE__ */ C.jsxs($u, { className: "group", children: [
    /* @__PURE__ */ C.jsx(I7, { as: "span" }),
    (i || n) && /* @__PURE__ */ C.jsx(
      xFt,
      {
        appendTo: document.body,
        trigger: "click",
        interactive: !0,
        animation: "shift-toward-subtle",
        placement: "bottom-start",
        content: /* @__PURE__ */ C.jsx("article", { className: "w-screen lg:w-full", contentEditable: !1, children: /* @__PURE__ */ C.jsx(
          "div",
          {
            tabIndex: 1,
            className: "static z-50 top-8 right-1/2 translate-x-1/2 lg:-translate-x-full p-2 shadow-elevation-3 color-bg-default rounded-lg w-56 border color-border-default",
            style: c(),
            children: MFt.map((u) => /* @__PURE__ */ C.jsx("div", { children: /* @__PURE__ */ C.jsx(
              Kt,
              {
                variant: "ghost",
                className: "!items-center w-full !justify-start !font-[400]",
                onClick: () => u.action(r),
                children: /* @__PURE__ */ C.jsx("span", { children: u.name })
              }
            ) }, u.name))
          }
        ) }),
        children: /* @__PURE__ */ C.jsx(
          "label",
          {
            tabIndex: 0,
            className: Lt("trigger-button", { hidden: o }),
            contentEditable: !1,
            children: /* @__PURE__ */ C.jsx(
              Ye,
              {
                name: "Ellipsis",
                className: "color-text-default",
                size: "sm"
              }
            )
          }
        )
      }
    )
  ] });
}, CFt = Ht.create({
  name: "tableCell",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (t) => {
          const e = t.getAttribute("colwidth");
          return e ? [parseInt(e, 10)] : null;
        }
      }
    };
  },
  tableRole: "cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "td" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "td",
      _t(this.options.HTMLAttributes, t),
      0
    ];
  },
  addNodeView() {
    return Hc(Yte, {
      as: "td",
      className: "relative"
    });
  }
}), AFt = Ht.create({
  name: "tableHeader",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (t) => {
          const e = t.getAttribute("colwidth");
          return e ? [parseInt(e, 10)] : null;
        }
      }
    };
  },
  tableRole: "header_cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "th" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "th",
      _t(this.options.HTMLAttributes, t),
      0
    ];
  },
  addNodeView() {
    return Hc(Yte, {
      as: "th",
      className: "relative"
    });
  }
}), ZR = (t) => (t.stopPropagation(), t.preventDefault(), t), SFt = function(t) {
  const e = t.scrollHeight > t.clientHeight, r = window.getComputedStyle(t).overflowY.indexOf("hidden") !== -1;
  return e && !r;
}, Kte = function(t) {
  return !t || t === document.body ? document.body : SFt(t) ? t : Kte(t.parentNode);
}, Tb = (t, e, n) => {
  const r = document.createElement(t);
  if (!r) throw new Error(`Element with name ${t} can't be created.`);
  return e && Object.entries(e).forEach(([i, a]) => r.setAttribute(i, a)), n && Object.entries(n).forEach(
    ([i, a]) => r.addEventListener(i, a)
  ), r;
}, LFt = Ht.create({
  name: "tableRow",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "(tableCell | tableHeader)*",
  tableRole: "row",
  parseHTML() {
    return [{ tag: "tr" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "tr",
      _t(this.options.HTMLAttributes, t),
      0
    ];
  },
  addNodeView() {
    return ({ editor: t, HTMLAttributes: e, getPos: n }) => {
      const r = () => n(), i = Kte(
        t.options.element
      );
      let a = !1;
      const o = {
        deleteRow: () => {
          this.editor.chain().deleteNode("tableRow").focus().run();
        },
        selectRow: () => {
          const v = r(), k = t.state.doc.resolve(v), w = new gt(k);
          t.view.dispatch(t.state.tr.setSelection(w));
        }
      }, s = () => {
        a = !0;
      }, l = () => {
        a = !1;
      }, c = Tb(
        "section",
        {
          class: "",
          contenteditable: "false"
        },
        {
          click: (v) => {
            v && ZR(v), o.selectRow();
          },
          mouseenter: () => {
            s();
          },
          mouseover: () => {
            s();
          },
          mouseleave: () => {
            l(), f();
          }
        }
      ), u = Tb(
        "button",
        {
          class: "text-sm px-1 absolute -translate-x-[125%] hover:active:-translate-x-[125%] mr-2"
        },
        {
          click: (v) => {
            v && ZR(v), o.deleteRow();
          }
        }
      ), d = () => {
        m(), c.classList.remove("hidden");
      }, f = () => {
        setTimeout(() => {
          a || c.classList.add("hidden");
        }, 100);
      }, h = Tb(
        "tr",
        { ...e },
        {
          mouseenter: d,
          mouseover: d,
          mouseleave: f
        }
      );
      c.append(u), document.body.append(c);
      let p = "";
      const m = () => {
        setTimeout(() => {
          const v = h.getBoundingClientRect(), k = JSON.stringify(v);
          p !== k && (c.style.top = `${v.top + document.documentElement.scrollTop}px`, c.style.left = `${v.x + document.documentElement.scrollLeft - 8}px`, c.style.height = `${v.height + 1}px`, p = k);
        });
      };
      return setTimeout(() => {
        m();
      }, 100), t.on("selectionUpdate", m), t.on("update", m), i == null || i.addEventListener("scroll", m), document.addEventListener("scroll", m), {
        dom: h,
        contentDOM: h,
        destroy: () => {
          c.remove(), t.off("selectionUpdate", m), t.off("update", m), i == null || i.removeEventListener(
            "scroll",
            m
          ), document.removeEventListener("scroll", m);
        }
      };
    };
  }
}), TFt = [
  Ute.configure({
    resizable: !0
  }),
  CFt,
  AFt,
  LFt
], EFt = $ee.extend({
  content: "(dBlock|columns|pageBreak)+"
});
function GR({ types: t, node: e }) {
  return e != null && e.type ? Array.isArray(t) && t.includes(e.type) || e.type === t : !1;
}
const jFt = ln.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: "paragraph",
      notAfter: ["paragraph"]
    };
  },
  addProseMirrorPlugins() {
    const t = new tn(this.name), e = Object.entries(this.editor.schema.nodes).map(([, n]) => n).filter((n) => this.options.notAfter.includes(n.name));
    return [
      new Wt({
        key: t,
        appendTransaction: (n, r, i) => {
          const { doc: a, tr: o, schema: s } = i, l = t.getState(i), c = a.content.size, u = s.nodes[this.options.node];
          if (l)
            return o.insert(c, u.create());
        },
        state: {
          init: (n, r) => {
            const i = r.tr.doc.lastChild;
            return !GR({ node: i, types: e });
          },
          apply: (n, r) => {
            var a, o, s;
            if (!n.docChanged) return r;
            const i = (s = (o = (a = n.doc.lastChild) == null ? void 0 : a.content) == null ? void 0 : o.content) == null ? void 0 : s[0];
            return !GR({ node: i, types: e });
          }
        }
      })
    ];
  }
}), NFt = ({
  node: t,
  editor: e,
  getPos: n,
  deleteNode: r
}) => {
  const [i, a] = De(""), { isPreviewMode: o } = Zp(), s = ["https://twitter.com", "https://x.com"], l = () => {
    switch (t.attrs.data) {
      case "twitter":
        return /* @__PURE__ */ C.jsx(Ye, { name: "XSocial", size: "md" });
      case "iframe":
        return /* @__PURE__ */ C.jsx(Ye, { name: "Youtube", size: "md" });
      default:
        return /* @__PURE__ */ C.jsx(Ye, { name: "Sparkles", size: "md" });
    }
  }, c = () => {
    switch (t.attrs.data) {
      case "twitter":
        return "Embed a Twitter tweet";
      case "iframe":
        return "Embed a video";
      default:
        return "Paste an Youtube or Twitter/X link to embed";
    }
  }, u = () => {
    if (!i) {
      uu({
        title: "Please enter a valid URL",
        variant: "secondary"
      });
      return;
    }
    let g = i;
    if (i.includes("<iframe")) {
      const x = i.match(/src="([^"]*)"/);
      x && x.length > 0 && (g = x[1]);
    } else
      switch (!0) {
        case /youtu\.?be(?:\.com)?\/(?:.*v(?:\/|=)|(?:.*\/)?)([a-zA-Z0-9-_]+)/.test(
          i
        ): {
          const x = i.match(
            /youtu\.?be(?:\.com)?\/(?:.*v(?:\/|=)|(?:.*\/)?)([a-zA-Z0-9-_]+)/
          );
          x && x.length > 0 && (g = `https://www.youtube.com/embed/${x[1]}`);
          break;
        }
        case /vimeo\.com\/([a-zA-Z0-9-_]+)/.test(i): {
          const x = i.match(/vimeo\.com\/([a-zA-Z0-9-_]+)/);
          x && x.length > 0 && (g = `https://player.vimeo.com/video/${x[1]}`);
          break;
        }
        default: {
          uu({
            title: "Please enter a valid URL",
            variant: "secondary"
          });
          return;
        }
      }
    const v = 640, k = 360, w = n(), b = w + t.nodeSize;
    g && (e == null || e.chain().focus(w).deleteRange({ from: w, to: b }).setIframe({ src: g, width: v, height: k }).run());
  }, d = () => {
    if (!i) {
      uu({
        title: "Please enter a valid URL",
        variant: "secondary"
      });
      return;
    }
    let g = i;
    const v = s.some((A) => i.includes(A)), k = i.match(/\/status\/([0-9]*)/), w = k && k.length > 0;
    if (v && w)
      g = k[1];
    else {
      uu({
        title: "Please enter a valid URL",
        variant: "secondary"
      });
      return;
    }
    const b = n(), x = b + t.nodeSize;
    g && (e == null || e.chain().focus(b).deleteRange({ from: b, to: x }).setTweetEmbed({ tweetId: g }).run());
  }, f = () => {
    if (!i) {
      uu({
        title: "Please enter a valid URL",
        variant: "secondary"
      });
      return;
    }
    let g = i, v = "iframe";
    if (i.includes("<iframe")) {
      const A = i.match(/src="([^"]*)"/);
      A && A.length > 0 && (g = A[1]);
    } else
      switch (!0) {
        case /youtu\.?be(?:\.com)?\/(?:.*v(?:\/|=)|(?:.*\/)?)([a-zA-Z0-9-_]+)/.test(
          i
        ): {
          const A = i.match(
            /youtu\.?be(?:\.com)?\/(?:.*v(?:\/|=)|(?:.*\/)?)([a-zA-Z0-9-_]+)/
          );
          A && A.length > 0 && (g = `https://www.youtube.com/embed/${A[1]}`);
          break;
        }
        case /vimeo\.com\/([a-zA-Z0-9-_]+)/.test(i): {
          const A = i.match(/vimeo\.com\/([a-zA-Z0-9-_]+)/);
          A && A.length > 0 && (g = `https://player.vimeo.com/video/${A[1]}`);
          break;
        }
        case /(?:twitter|x)\.com\/(?:#!\/)?(\w+)\/status(es)?\/(\d+)/.test(
          i
        ): {
          const A = i.match(
            /(?:twitter|x)\.com\/(?:#!\/)?(\w+)\/status(es)?\/(\d+)/
          );
          A && A.length > 0 && (g = A[3], v = "twitter");
          break;
        }
        default: {
          uu({
            title: "Please enter a valid URL",
            variant: "secondary"
          });
          return;
        }
      }
    const k = 640, w = 360, b = n(), x = b + t.nodeSize;
    if (g) {
      const A = e == null ? void 0 : e.chain().focus(b).deleteRange({ from: b, to: x });
      v === "twitter" ? A == null || A.setTweetEmbed({ tweetId: g }) : A == null || A.setIframe({ src: g, width: k, height: w }), A == null || A.run();
    }
  }, p = jte(() => {
    switch (t.attrs.data) {
      case "twitter":
        d();
        break;
      case "iframe":
        u();
        break;
      default:
        f();
        break;
    }
  }, 1e3);
  ze(() => {
    i && p();
  }, [i]), ze(() => {
    e == null || e.chain().focus();
  }, []);
  const m = Ue(null);
  return ze(() => {
    const g = setTimeout(() => {
      var v;
      (v = m.current) == null || v.focus();
    }, 0);
    return () => clearTimeout(g);
  }, []), /* @__PURE__ */ C.jsx(
    $u,
    {
      as: "div",
      className: "flex gap-2 group w-full relative justify-center items-start",
      children: !o && /* @__PURE__ */ C.jsxs("div", { className: "relative w-full", children: [
        /* @__PURE__ */ C.jsx("div", { className: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none color-text-default", children: l() }),
        /* @__PURE__ */ C.jsx(
          al,
          {
            ref: m,
            value: i,
            placeholder: c(),
            onChange: (g) => a(g.target.value),
            onClick: (g) => g.stopPropagation(),
            className: "p-3 pl-10 w-full",
            autoFocus: !0,
            onKeyDown: (g) => {
              g.key === "Backspace" && i === "" && r();
            }
          }
        )
      ] })
    }
  );
}, DFt = Ht.create({
  name: "actionButton",
  group: "block",
  content: "block*",
  atom: !0,
  draggable: !0,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return {
      data: {
        default: null
      }
    };
  },
  addNodeView() {
    return Hc(NFt);
  },
  parseHTML() {
    return [
      {
        tag: "div[data-action-node]"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "div",
      _t(t, { "data-action-node": "" }),
      0
    ];
  },
  addCommands() {
    return {
      setActionButton: (t) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: {
          data: t
        },
        content: []
      })
    };
  }
}), IFt = "listItem", YR = "textStyle", KR = /^\s*([-+*])\s$/, PFt = Ht.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", _t(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(IFt, this.editor.getAttributes(YR)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let t = O1({
      find: KR,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = O1({
      find: KR,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(YR),
      editor: this.editor
    })), [
      t
    ];
  }
}), zFt = new mg({
  nodes: {
    doc: {
      content: "block+"
    },
    paragraph: {
      content: "inline*",
      group: "block",
      parseDOM: [{ tag: "p" }],
      toDOM() {
        return ["p", 0];
      }
    },
    blockquote: {
      content: "block+",
      group: "block",
      parseDOM: [{ tag: "blockquote" }],
      toDOM() {
        return ["blockquote", 0];
      }
    },
    horizontal_rule: {
      group: "block",
      parseDOM: [{ tag: "hr" }],
      toDOM() {
        return ["div", ["hr"]];
      }
    },
    heading: {
      attrs: { level: { default: 1 } },
      content: "(text | image)*",
      group: "block",
      defining: !0,
      parseDOM: [
        { tag: "h1", attrs: { level: 1 } },
        { tag: "h2", attrs: { level: 2 } },
        { tag: "h3", attrs: { level: 3 } },
        { tag: "h4", attrs: { level: 4 } },
        { tag: "h5", attrs: { level: 5 } },
        { tag: "h6", attrs: { level: 6 } }
      ],
      toDOM(t) {
        return ["h" + t.attrs.level, 0];
      }
    },
    code_block: {
      content: "text*",
      group: "block",
      code: !0,
      defining: !0,
      marks: "",
      attrs: { params: { default: "" } },
      parseDOM: [{ tag: "pre", preserveWhitespace: "full", getAttrs: (t) => ({ params: t.getAttribute("data-params") || "" }) }],
      toDOM(t) {
        return ["pre", t.attrs.params ? { "data-params": t.attrs.params } : {}, ["code", 0]];
      }
    },
    ordered_list: {
      content: "list_item+",
      group: "block",
      attrs: { order: { default: 1 }, tight: { default: !1 } },
      parseDOM: [{ tag: "ol", getAttrs(t) {
        return {
          order: t.hasAttribute("start") ? +t.getAttribute("start") : 1,
          tight: t.hasAttribute("data-tight")
        };
      } }],
      toDOM(t) {
        return ["ol", {
          start: t.attrs.order == 1 ? null : t.attrs.order,
          "data-tight": t.attrs.tight ? "true" : null
        }, 0];
      }
    },
    bullet_list: {
      content: "list_item+",
      group: "block",
      attrs: { tight: { default: !1 } },
      parseDOM: [{ tag: "ul", getAttrs: (t) => ({ tight: t.hasAttribute("data-tight") }) }],
      toDOM(t) {
        return ["ul", { "data-tight": t.attrs.tight ? "true" : null }, 0];
      }
    },
    list_item: {
      content: "block+",
      defining: !0,
      parseDOM: [{ tag: "li" }],
      toDOM() {
        return ["li", 0];
      }
    },
    text: {
      group: "inline"
    },
    image: {
      inline: !0,
      attrs: {
        src: {},
        alt: { default: null },
        title: { default: null }
      },
      group: "inline",
      draggable: !0,
      parseDOM: [{ tag: "img[src]", getAttrs(t) {
        return {
          src: t.getAttribute("src"),
          title: t.getAttribute("title"),
          alt: t.getAttribute("alt")
        };
      } }],
      toDOM(t) {
        return ["img", t.attrs];
      }
    },
    hard_break: {
      inline: !0,
      group: "inline",
      selectable: !1,
      parseDOM: [{ tag: "br" }],
      toDOM() {
        return ["br"];
      }
    }
  },
  marks: {
    em: {
      parseDOM: [
        { tag: "i" },
        { tag: "em" },
        { style: "font-style=italic" },
        { style: "font-style=normal", clearMark: (t) => t.type.name == "em" }
      ],
      toDOM() {
        return ["em"];
      }
    },
    strong: {
      parseDOM: [
        { tag: "strong" },
        { tag: "b", getAttrs: (t) => t.style.fontWeight != "normal" && null },
        { style: "font-weight=400", clearMark: (t) => t.type.name == "strong" },
        { style: "font-weight", getAttrs: (t) => /^(bold(er)?|[5-9]\d{2,})$/.test(t) && null }
      ],
      toDOM() {
        return ["strong"];
      }
    },
    link: {
      attrs: {
        href: {},
        title: { default: null }
      },
      inclusive: !1,
      parseDOM: [{ tag: "a[href]", getAttrs(t) {
        return { href: t.getAttribute("href"), title: t.getAttribute("title") };
      } }],
      toDOM(t) {
        return ["a", t.attrs];
      }
    },
    code: {
      code: !0,
      parseDOM: [{ tag: "code" }],
      toDOM() {
        return ["code"];
      }
    }
  }
});
function RFt(t, e) {
  if (t.isText && e.isText && dn.sameSet(t.marks, e.marks))
    return t.withText(t.text + e.text);
}
class OFt {
  constructor(e, n) {
    this.schema = e, this.tokenHandlers = n, this.stack = [{ type: e.topNodeType, attrs: null, content: [], marks: dn.none }];
  }
  top() {
    return this.stack[this.stack.length - 1];
  }
  push(e) {
    this.stack.length && this.top().content.push(e);
  }
  // Adds the given text to the current position in the document,
  // using the current marks as styling.
  addText(e) {
    if (!e)
      return;
    let n = this.top(), r = n.content, i = r[r.length - 1], a = this.schema.text(e, n.marks), o;
    i && (o = RFt(i, a)) ? r[r.length - 1] = o : r.push(a);
  }
  // Adds the given mark to the set of active marks.
  openMark(e) {
    let n = this.top();
    n.marks = e.addToSet(n.marks);
  }
  // Removes the given mark from the set of active marks.
  closeMark(e) {
    let n = this.top();
    n.marks = e.removeFromSet(n.marks);
  }
  parseTokens(e) {
    for (let n = 0; n < e.length; n++) {
      let r = e[n], i = this.tokenHandlers[r.type];
      if (!i)
        throw new Error("Token type `" + r.type + "` not supported by Markdown parser");
      i(this, r, e, n);
    }
  }
  // Add a node at the current position.
  addNode(e, n, r) {
    let i = this.top(), a = e.createAndFill(n, r, i ? i.marks : []);
    return a ? (this.push(a), a) : null;
  }
  // Wrap subsequent content in a node of the given type.
  openNode(e, n) {
    this.stack.push({ type: e, attrs: n, content: [], marks: dn.none });
  }
  // Close and return the node that is currently on top of the stack.
  closeNode() {
    let e = this.stack.pop();
    return this.addNode(e.type, e.attrs, e.content);
  }
}
function Tf(t, e, n, r) {
  return t.getAttrs ? t.getAttrs(e, n, r) : t.attrs instanceof Function ? t.attrs(e) : t.attrs;
}
function Eb(t, e) {
  return t.noCloseToken || e == "code_inline" || e == "code_block" || e == "fence";
}
function $R(t) {
  return t[t.length - 1] == `
` ? t.slice(0, t.length - 1) : t;
}
function jb() {
}
function BFt(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r in e) {
    let i = e[r];
    if (i.block) {
      let a = t.nodeType(i.block);
      Eb(i, r) ? n[r] = (o, s, l, c) => {
        o.openNode(a, Tf(i, s, l, c)), o.addText($R(s.content)), o.closeNode();
      } : (n[r + "_open"] = (o, s, l, c) => o.openNode(a, Tf(i, s, l, c)), n[r + "_close"] = (o) => o.closeNode());
    } else if (i.node) {
      let a = t.nodeType(i.node);
      n[r] = (o, s, l, c) => o.addNode(a, Tf(i, s, l, c));
    } else if (i.mark) {
      let a = t.marks[i.mark];
      Eb(i, r) ? n[r] = (o, s, l, c) => {
        o.openMark(a.create(Tf(i, s, l, c))), o.addText($R(s.content)), o.closeMark(a);
      } : (n[r + "_open"] = (o, s, l, c) => o.openMark(a.create(Tf(i, s, l, c))), n[r + "_close"] = (o) => o.closeMark(a));
    } else if (i.ignore)
      Eb(i, r) ? n[r] = jb : (n[r + "_open"] = jb, n[r + "_close"] = jb);
    else
      throw new RangeError("Unrecognized parsing spec " + JSON.stringify(i));
  }
  return n.text = (r, i) => r.addText(i.content), n.inline = (r, i) => r.parseTokens(i.children), n.softbreak = n.softbreak || ((r) => r.addText(" ")), n;
}
let HFt = class {
  /**
  Create a parser with the given configuration. You can configure
  the markdown-it parser to parse the dialect you want, and provide
  a description of the ProseMirror entities those tokens map to in
  the `tokens` object, which maps token names to descriptions of
  what to do with them. Such a description is an object, and may
  have the following properties:
  */
  constructor(e, n, r) {
    this.schema = e, this.tokenizer = n, this.tokens = r, this.tokenHandlers = BFt(e, r);
  }
  /**
  Parse a string as [CommonMark](http://commonmark.org/) markup,
  and create a ProseMirror document as prescribed by this parser's
  rules.
  
  The second argument, when given, is passed through to the
  [Markdown
  parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
  */
  parse(e, n = {}) {
    let r = new OFt(this.schema, this.tokenHandlers), i;
    r.parseTokens(this.tokenizer.parse(e, n));
    do
      i = r.closeNode();
    while (r.stack.length);
    return i || this.schema.topNodeType.createAndFill();
  }
};
function JR(t, e) {
  for (; ++e < t.length; )
    if (t[e].type != "list_item_open")
      return t[e].hidden;
  return !1;
}
new HFt(zFt, _r("commonmark", { html: !1 }), {
  blockquote: { block: "blockquote" },
  paragraph: { block: "paragraph" },
  list_item: { block: "list_item" },
  bullet_list: { block: "bullet_list", getAttrs: (t, e, n) => ({ tight: JR(e, n) }) },
  ordered_list: { block: "ordered_list", getAttrs: (t, e, n) => ({
    order: +t.attrGet("start") || 1,
    tight: JR(e, n)
  }) },
  heading: { block: "heading", getAttrs: (t) => ({ level: +t.tag.slice(1) }) },
  code_block: { block: "code_block", noCloseToken: !0 },
  fence: { block: "code_block", getAttrs: (t) => ({ params: t.info || "" }), noCloseToken: !0 },
  hr: { node: "horizontal_rule" },
  image: { node: "image", getAttrs: (t) => ({
    src: t.attrGet("src"),
    title: t.attrGet("title") || null,
    alt: t.children[0] && t.children[0].content || null
  }) },
  hardbreak: { node: "hard_break" },
  em: { mark: "em" },
  strong: { mark: "strong" },
  link: { mark: "link", getAttrs: (t) => ({
    href: t.attrGet("href"),
    title: t.attrGet("title") || null
  }) },
  code_inline: { mark: "code", noCloseToken: !0 }
});
const FFt = { open: "", close: "", mixable: !0 };
let _Ft = class {
  /**
  Construct a serializer with the given configuration. The `nodes`
  object should map node names in a given schema to function that
  take a serializer state and such a node, and serialize the node.
  */
  constructor(e, n, r = {}) {
    this.nodes = e, this.marks = n, this.options = r;
  }
  /**
  Serialize the content of the given node to
  [CommonMark](http://commonmark.org/).
  */
  serialize(e, n = {}) {
    n = Object.assign({}, this.options, n);
    let r = new $te(this.nodes, this.marks, n);
    return r.renderContent(e), r.out;
  }
};
const vs = new _Ft({
  blockquote(t, e) {
    t.wrapBlock("> ", null, e, () => t.renderContent(e));
  },
  code_block(t, e) {
    const n = e.textContent.match(/`{3,}/gm), r = n ? n.sort().slice(-1)[0] + "`" : "```";
    t.write(r + (e.attrs.params || "") + `
`), t.text(e.textContent, !1), t.write(`
`), t.write(r), t.closeBlock(e);
  },
  heading(t, e) {
    t.write(t.repeat("#", e.attrs.level) + " "), t.renderInline(e, !1), t.closeBlock(e);
  },
  horizontal_rule(t, e) {
    t.write(e.attrs.markup || "---"), t.closeBlock(e);
  },
  bullet_list(t, e) {
    t.renderList(e, "  ", () => (e.attrs.bullet || "*") + " ");
  },
  ordered_list(t, e) {
    let n = e.attrs.order || 1, r = String(n + e.childCount - 1).length, i = t.repeat(" ", r + 2);
    t.renderList(e, i, (a) => {
      let o = String(n + a);
      return t.repeat(" ", r - o.length) + o + ". ";
    });
  },
  list_item(t, e) {
    t.renderContent(e);
  },
  paragraph(t, e) {
    t.renderInline(e), t.closeBlock(e);
  },
  image(t, e) {
    t.write("![" + t.esc(e.attrs.alt || "") + "](" + e.attrs.src.replace(/[\(\)]/g, "\\$&") + (e.attrs.title ? ' "' + e.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
  },
  hard_break(t, e, n, r) {
    for (let i = r + 1; i < n.childCount; i++)
      if (n.child(i).type != e.type) {
        t.write(`\\
`);
        return;
      }
  },
  text(t, e) {
    t.text(e.text, !t.inAutolink);
  }
}, {
  em: { open: "*", close: "*", mixable: !0, expelEnclosingWhitespace: !0 },
  strong: { open: "**", close: "**", mixable: !0, expelEnclosingWhitespace: !0 },
  link: {
    open(t, e, n, r) {
      return t.inAutolink = VFt(e, n, r), t.inAutolink ? "<" : "[";
    },
    close(t, e, n, r) {
      let { inAutolink: i } = t;
      return t.inAutolink = void 0, i ? ">" : "](" + e.attrs.href.replace(/[\(\)"]/g, "\\$&") + (e.attrs.title ? ` "${e.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
    },
    mixable: !0
  },
  code: {
    open(t, e, n, r) {
      return QR(n.child(r), -1);
    },
    close(t, e, n, r) {
      return QR(n.child(r - 1), 1);
    },
    escape: !1
  }
});
function QR(t, e) {
  let n = /`+/g, r, i = 0;
  if (t.isText)
    for (; r = n.exec(t.text); )
      i = Math.max(i, r[0].length);
  let a = i > 0 && e > 0 ? " `" : "`";
  for (let o = 0; o < i; o++)
    a += "`";
  return i > 0 && e < 0 && (a += " "), a;
}
function VFt(t, e, n) {
  if (t.attrs.title || !/^\w+:/.test(t.attrs.href))
    return !1;
  let r = e.child(n);
  return !r.isText || r.text != t.attrs.href || r.marks[r.marks.length - 1] != t ? !1 : n == e.childCount - 1 || !t.isInSet(e.child(n + 1).marks);
}
let $te = class {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.nodes = e, this.marks = n, this.options = r, this.delim = "", this.out = "", this.closed = null, this.inAutolink = void 0, this.atBlockStart = !1, this.inTightList = !1, typeof this.options.tightLists > "u" && (this.options.tightLists = !1), typeof this.options.hardBreakNodeName > "u" && (this.options.hardBreakNodeName = "hard_break");
  }
  /**
  @internal
  */
  flushClose(e = 2) {
    if (this.closed) {
      if (this.atBlank() || (this.out += `
`), e > 1) {
        let n = this.delim, r = /\s+$/.exec(n);
        r && (n = n.slice(0, n.length - r[0].length));
        for (let i = 1; i < e; i++)
          this.out += n + `
`;
      }
      this.closed = null;
    }
  }
  /**
  @internal
  */
  getMark(e) {
    let n = this.marks[e];
    if (!n) {
      if (this.options.strict !== !1)
        throw new Error(`Mark type \`${e}\` not supported by Markdown renderer`);
      n = FFt;
    }
    return n;
  }
  /**
  Render a block, prefixing each line with `delim`, and the first
  line in `firstDelim`. `node` should be the node that is closed at
  the end of the block, and `f` is a function that renders the
  content of the block.
  */
  wrapBlock(e, n, r, i) {
    let a = this.delim;
    this.write(n ?? e), this.delim += e, i(), this.delim = a, this.closeBlock(r);
  }
  /**
  @internal
  */
  atBlank() {
    return /(^|\n)$/.test(this.out);
  }
  /**
  Ensure the current content ends with a newline.
  */
  ensureNewLine() {
    this.atBlank() || (this.out += `
`);
  }
  /**
  Prepare the state for writing output (closing closed paragraphs,
  adding delimiters, and so on), and then optionally add content
  (unescaped) to the output.
  */
  write(e) {
    this.flushClose(), this.delim && this.atBlank() && (this.out += this.delim), e && (this.out += e);
  }
  /**
  Close the block for the given node.
  */
  closeBlock(e) {
    this.closed = e;
  }
  /**
  Add the given text to the document. When escape is not `false`,
  it will be escaped.
  */
  text(e, n = !0) {
    let r = e.split(`
`);
    for (let i = 0; i < r.length; i++)
      this.write(), !n && r[i][0] == "[" && /(^|[^\\])\!$/.test(this.out) && (this.out = this.out.slice(0, this.out.length - 1) + "\\!"), this.out += n ? this.esc(r[i], this.atBlockStart) : r[i], i != r.length - 1 && (this.out += `
`);
  }
  /**
  Render the given node as a block.
  */
  render(e, n, r) {
    if (this.nodes[e.type.name])
      this.nodes[e.type.name](this, e, n, r);
    else {
      if (this.options.strict !== !1)
        throw new Error("Token type `" + e.type.name + "` not supported by Markdown renderer");
      e.type.isLeaf || (e.type.inlineContent ? this.renderInline(e) : this.renderContent(e), e.isBlock && this.closeBlock(e));
    }
  }
  /**
  Render the contents of `parent` as block nodes.
  */
  renderContent(e) {
    e.forEach((n, r, i) => this.render(n, e, i));
  }
  /**
  Render the contents of `parent` as inline content.
  */
  renderInline(e, n = !0) {
    this.atBlockStart = n;
    let r = [], i = "", a = (o, s, l) => {
      let c = o ? o.marks : [];
      o && o.type.name === this.options.hardBreakNodeName && (c = c.filter((m) => {
        if (l + 1 == e.childCount)
          return !1;
        let g = e.child(l + 1);
        return m.isInSet(g.marks) && (!g.isText || /\S/.test(g.text));
      }));
      let u = i;
      if (i = "", o && o.isText && c.some((m) => {
        let g = this.getMark(m.type.name);
        return g && g.expelEnclosingWhitespace && !m.isInSet(r);
      })) {
        let [m, g, v] = /^(\s*)(.*)$/m.exec(o.text);
        g && (u += g, o = v ? o.withText(v) : null, o || (c = r));
      }
      if (o && o.isText && c.some((m) => {
        let g = this.getMark(m.type.name);
        return g && g.expelEnclosingWhitespace && (l == e.childCount - 1 || !m.isInSet(e.child(l + 1).marks));
      })) {
        let [m, g, v] = /^(.*?)(\s*)$/m.exec(o.text);
        v && (i = v, o = g ? o.withText(g) : null, o || (c = r));
      }
      let d = c.length ? c[c.length - 1] : null, f = d && this.getMark(d.type.name).escape === !1, h = c.length - (f ? 1 : 0);
      e: for (let m = 0; m < h; m++) {
        let g = c[m];
        if (!this.getMark(g.type.name).mixable)
          break;
        for (let v = 0; v < r.length; v++) {
          let k = r[v];
          if (!this.getMark(k.type.name).mixable)
            break;
          if (g.eq(k)) {
            m > v ? c = c.slice(0, v).concat(g).concat(c.slice(v, m)).concat(c.slice(m + 1, h)) : v > m && (c = c.slice(0, m).concat(c.slice(m + 1, v)).concat(g).concat(c.slice(v, h)));
            continue e;
          }
        }
      }
      let p = 0;
      for (; p < Math.min(r.length, h) && c[p].eq(r[p]); )
        ++p;
      for (; p < r.length; )
        this.text(this.markString(r.pop(), !1, e, l), !1);
      if (u && this.text(u), o) {
        for (; r.length < h; ) {
          let m = c[r.length];
          r.push(m), this.text(this.markString(m, !0, e, l), !1), this.atBlockStart = !1;
        }
        f && o.isText ? this.text(this.markString(d, !0, e, l) + o.text + this.markString(d, !1, e, l + 1), !1) : this.render(o, e, l), this.atBlockStart = !1;
      }
      o != null && o.isText && o.nodeSize > 0 && (this.atBlockStart = !1);
    };
    e.forEach(a), a(null, 0, e.childCount), this.atBlockStart = !1;
  }
  /**
  Render a node's content as a list. `delim` should be the extra
  indentation added to all lines except the first in an item,
  `firstDelim` is a function going from an item index to a
  delimiter for the first line of the item.
  */
  renderList(e, n, r) {
    this.closed && this.closed.type == e.type ? this.flushClose(3) : this.inTightList && this.flushClose(1);
    let i = typeof e.attrs.tight < "u" ? e.attrs.tight : this.options.tightLists, a = this.inTightList;
    this.inTightList = i, e.forEach((o, s, l) => {
      l && i && this.flushClose(1), this.wrapBlock(n, r(l), e, () => this.render(o, e, l));
    }), this.inTightList = a;
  }
  /**
  Escape the given string so that it can safely appear in Markdown
  content. If `startOfLine` is true, also escape characters that
  have special meaning only at the start of the line.
  */
  esc(e, n = !1) {
    return e = e.replace(/[`*\\~\[\]_]/g, (r, i) => r == "_" && i > 0 && i + 1 < e.length && e[i - 1].match(/\w/) && e[i + 1].match(/\w/) ? r : "\\" + r), n && (e = e.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, "$1\\$2$3").replace(/^(\s*\d+)\.\s/, "$1\\. ")), this.options.escapeExtraCharacters && (e = e.replace(this.options.escapeExtraCharacters, "\\$&")), e;
  }
  /**
  @internal
  */
  quote(e) {
    let n = e.indexOf('"') == -1 ? '""' : e.indexOf("'") == -1 ? "''" : "()";
    return n[0] + e + n[1];
  }
  /**
  Repeat the given string `n` times.
  */
  repeat(e, n) {
    let r = "";
    for (let i = 0; i < n; i++)
      r += e;
    return r;
  }
  /**
  Get the markdown string for a given opening or closing mark.
  */
  markString(e, n, r, i) {
    let a = this.getMark(e.type.name), o = n ? a.open : a.close;
    return typeof o == "string" ? o : o(this, e, r, i);
  }
  /**
  Get leading and trailing whitespace from a string. Values of
  leading or trailing property of the return object will be undefined
  if there is no match.
  */
  getEnclosingWhitespace(e) {
    return {
      leading: (e.match(/^(\s+)/) || [void 0])[0],
      trailing: (e.match(/(\s+)$/) || [void 0])[0]
    };
  }
};
var Nk = !0, Jte = !1, Qte = !1, qFt = function(t, e) {
  e && (Nk = !e.enabled, Jte = !!e.label, Qte = !!e.labelAfter), t.core.ruler.after("inline", "github-task-lists", function(n) {
    for (var r = n.tokens, i = 2; i < r.length; i++)
      WFt(r, i) && (ZFt(r[i], n.Token), XR(r[i - 2], "class", "task-list-item" + (Nk ? "" : " enabled")), XR(r[UFt(r, i - 2)], "class", "contains-task-list"));
  });
};
function XR(t, e, n) {
  var r = t.attrIndex(e), i = [e, n];
  r < 0 ? t.attrPush(i) : t.attrs[r] = i;
}
function UFt(t, e) {
  for (var n = t[e].level - 1, r = e - 1; r >= 0; r--)
    if (t[r].level === n)
      return r;
  return -1;
}
function WFt(t, e) {
  return JFt(t[e]) && QFt(t[e - 1]) && XFt(t[e - 2]) && e_t(t[e]);
}
function ZFt(t, e) {
  if (t.children.unshift(GFt(t, e)), t.children[1].content = t.children[1].content.slice(3), t.content = t.content.slice(3), Jte)
    if (Qte) {
      t.children.pop();
      var n = "task-item-" + Math.ceil(Math.random() * (1e4 * 1e3) - 1e3);
      t.children[0].content = t.children[0].content.slice(0, -1) + ' id="' + n + '">', t.children.push($Ft(t.content, n, e));
    } else
      t.children.unshift(YFt(e)), t.children.push(KFt(e));
}
function GFt(t, e) {
  var n = new e("html_inline", "", 0), r = Nk ? ' disabled="" ' : "";
  return t.content.indexOf("[ ] ") === 0 ? n.content = '<input class="task-list-item-checkbox"' + r + 'type="checkbox">' : (t.content.indexOf("[x] ") === 0 || t.content.indexOf("[X] ") === 0) && (n.content = '<input class="task-list-item-checkbox" checked=""' + r + 'type="checkbox">'), n;
}
function YFt(t) {
  var e = new t("html_inline", "", 0);
  return e.content = "<label>", e;
}
function KFt(t) {
  var e = new t("html_inline", "", 0);
  return e.content = "</label>", e;
}
function $Ft(t, e, n) {
  var r = new n("html_inline", "", 0);
  return r.content = '<label class="task-list-item-label" for="' + e + '">' + t + "</label>", r.attrs = [{ for: e }], r;
}
function JFt(t) {
  return t.type === "inline";
}
function QFt(t) {
  return t.type === "paragraph_open";
}
function XFt(t) {
  return t.type === "list_item_open";
}
function e_t(t) {
  return t.content.indexOf("[ ] ") === 0 || t.content.indexOf("[x] ") === 0 || t.content.indexOf("[X] ") === 0;
}
const t_t = /* @__PURE__ */ kd(qFt);
var n_t = Object.defineProperty, r_t = (t, e, n) => e in t ? n_t(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, ag = (t, e, n) => (r_t(t, typeof e != "symbol" ? e + "" : e, n), n);
const i_t = ln.create({
  name: "markdownTightLists",
  addOptions: () => ({
    tight: !0,
    tightClass: "tight",
    listTypes: ["bulletList", "orderedList"]
  }),
  addGlobalAttributes() {
    return [{
      types: this.options.listTypes,
      attributes: {
        tight: {
          default: this.options.tight,
          parseHTML: (t) => t.getAttribute("data-tight") === "true" || !t.querySelector("p"),
          renderHTML: (t) => ({
            class: t.tight ? this.options.tightClass : null,
            "data-tight": t.tight ? "true" : null
          })
        }
      }
    }];
  },
  addCommands() {
    var t = this;
    return {
      toggleTight: function() {
        let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        return (n) => {
          let {
            editor: r,
            commands: i
          } = n;
          function a(o) {
            if (!r.isActive(o))
              return !1;
            const s = r.getAttributes(o);
            return i.updateAttributes(o, {
              tight: e ?? !(s != null && s.tight)
            });
          }
          return t.options.listTypes.some((o) => a(o));
        };
      }
    };
  }
}), eO = _r();
function Xte(t, e) {
  return eO.inline.State.prototype.scanDelims.call({
    src: t,
    posMax: t.length
  }), new eO.inline.State(t, null, null, []).scanDelims(e, !0);
}
function ene(t, e, n, r) {
  let i = t.substring(0, n) + t.substring(n + e.length);
  return i = i.substring(0, n + r) + e + i.substring(n + r), i;
}
function a_t(t, e, n, r) {
  let i = n, a = t;
  for (; i < r && !Xte(a, i).can_open; )
    a = ene(a, e, i, 1), i++;
  return {
    text: a,
    from: i,
    to: r
  };
}
function o_t(t, e, n, r) {
  let i = r, a = t;
  for (; i > n && !Xte(a, i).can_close; )
    a = ene(a, e, i, -1), i--;
  return {
    text: a,
    from: n,
    to: i
  };
}
function s_t(t, e, n, r) {
  let i = {
    text: t,
    from: n,
    to: r
  };
  return i = a_t(i.text, e, i.from, i.to), i = o_t(i.text, e, i.from, i.to), i.to - i.from < e.length + 1 && (i.text = i.text.substring(0, i.from) + i.text.substring(i.to + e.length)), i.text;
}
class l_t extends $te {
  constructor(e, n, r) {
    super(e, n, r ?? {}), ag(this, "inTable", !1), this.inlines = [];
  }
  render(e, n, r) {
    super.render(e, n, r);
    const i = this.inlines[this.inlines.length - 1];
    if (i != null && i.start && i !== null && i !== void 0 && i.end) {
      const {
        delimiter: a,
        start: o,
        end: s
      } = this.normalizeInline(i);
      this.out = s_t(this.out, a, o, s), this.inlines.pop();
    }
  }
  markString(e, n, r, i) {
    const a = this.marks[e.type.name];
    if (a.expelEnclosingWhitespace)
      if (n)
        this.inlines.push({
          start: this.out.length,
          delimiter: a.open
        });
      else {
        const o = this.inlines.pop();
        this.inlines.push({
          ...o,
          end: this.out.length
        });
      }
    return super.markString(e, n, r, i);
  }
  normalizeInline(e) {
    let {
      start: n,
      end: r
    } = e;
    for (; this.out.charAt(n).match(/\s/); )
      n++;
    return {
      ...e,
      start: n
    };
  }
}
const tne = ir.create({
  name: "markdownHTMLMark",
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: {
          open(t, e) {
            var n, r;
            return this.editor.storage.markdown.options.html ? (n = (r = tO(e)) === null || r === void 0 ? void 0 : r[0]) !== null && n !== void 0 ? n : "" : (console.warn(`Tiptap Markdown: "${e.type.name}" mark is only available in html mode`), "");
          },
          close(t, e) {
            var n, r;
            return this.editor.storage.markdown.options.html && (n = (r = tO(e)) === null || r === void 0 ? void 0 : r[1]) !== null && n !== void 0 ? n : "";
          }
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});
function tO(t) {
  const e = t.type.schema, n = e.text(" ", [t]), i = Cx(Ne.from(n), e).match(/^(<.*?>) (<\/.*?>)$/);
  return i ? [i[1], i[2]] : null;
}
function bL(t) {
  const e = `<body>${t}</body>`;
  return new window.DOMParser().parseFromString(e, "text/html").body;
}
function c_t(t) {
  return t == null ? void 0 : t.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function u_t(t) {
  const e = t.parentElement, n = e.cloneNode();
  for (; e.firstChild && e.firstChild !== t; )
    n.appendChild(e.firstChild);
  n.childNodes.length > 0 && e.parentElement.insertBefore(n, e), e.parentElement.insertBefore(t, e), e.childNodes.length === 0 && e.remove();
}
function d_t(t) {
  const e = t.parentNode;
  for (; t.firstChild; )
    e.insertBefore(t.firstChild, t);
  e.removeChild(t);
}
const M5 = Ht.create({
  name: "markdownHTMLNode",
  addStorage() {
    return {
      markdown: {
        serialize(t, e, n) {
          this.editor.storage.markdown.options.html ? t.write(f_t(e, n)) : (console.warn(`Tiptap Markdown: "${e.type.name}" node is only available in html mode`), t.write(`[${e.type.name}]`)), e.isBlock && t.closeBlock(e);
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});
function f_t(t, e) {
  const n = t.type.schema, r = Cx(Ne.from(t), n);
  return t.isBlock && (e instanceof Ne || e.type.name === n.topNodeType.name) ? h_t(r) : r;
}
function h_t(t) {
  const n = bL(t).firstElementChild;
  return n.innerHTML = n.innerHTML.trim() ? `
${n.innerHTML}
` : `
`, n.outerHTML;
}
const p_t = Ht.create({
  name: "blockquote"
}), m_t = p_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: vs.nodes.blockquote,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), y_t = Ht.create({
  name: "bulletList"
}), nne = y_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(t, e) {
          return t.renderList(e, "  ", () => (this.editor.storage.markdown.options.bulletListMarker || "-") + " ");
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), g_t = Ht.create({
  name: "codeBlock"
}), v_t = g_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(t, e) {
          t.write("```" + (e.attrs.language || "") + `
`), t.text(e.textContent, !1), t.ensureNewLine(), t.write("```"), t.closeBlock(e);
        },
        parse: {
          setup(t) {
            var e;
            t.set({
              langPrefix: (e = this.options.languageClassPrefix) !== null && e !== void 0 ? e : "language-"
            });
          },
          updateDOM(t) {
            t.innerHTML = t.innerHTML.replace(/\n<\/code><\/pre>/g, "</code></pre>");
          }
        }
      }
    };
  }
}), b_t = Ht.create({
  name: "hardBreak"
}), rne = b_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(t, e, n, r) {
          for (let i = r + 1; i < n.childCount; i++)
            if (n.child(i).type != e.type) {
              t.write(t.inTable ? M5.storage.markdown.serialize.call(this, t, e, n) : `\\
`);
              return;
            }
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), w_t = Ht.create({
  name: "heading"
}), k_t = w_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: vs.nodes.heading,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), x_t = Ht.create({
  name: "horizontalRule"
}), M_t = x_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: vs.nodes.horizontal_rule,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), C_t = Ht.create({
  name: "image"
}), A_t = C_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: vs.nodes.image,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), S_t = Ht.create({
  name: "listItem"
}), L_t = S_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: vs.nodes.list_item,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), T_t = Ht.create({
  name: "orderedList"
});
function E_t(t, e, n) {
  let r = 0;
  for (; n - r > 0 && e.child(n - r - 1).type.name === t.type.name; r++)
    ;
  return r;
}
const j_t = T_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(t, e, n, r) {
          const i = e.attrs.start || 1, a = String(i + e.childCount - 1).length, o = t.repeat(" ", a + 2), l = E_t(e, n, r) % 2 ? ") " : ". ";
          t.renderList(e, o, (c) => {
            const u = String(i + c);
            return t.repeat(" ", a - u.length) + u + l;
          });
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), N_t = Ht.create({
  name: "paragraph"
}), D_t = N_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: vs.nodes.paragraph,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});
function Nb(t) {
  var e, n;
  return (e = t == null || (n = t.content) === null || n === void 0 ? void 0 : n.content) !== null && e !== void 0 ? e : [];
}
const I_t = Ht.create({
  name: "table"
}), P_t = I_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(t, e, n) {
          if (!z_t(e)) {
            M5.storage.markdown.serialize.call(this, t, e, n);
            return;
          }
          t.inTable = !0, e.forEach((r, i, a) => {
            if (t.write("| "), r.forEach((o, s, l) => {
              l && t.write(" | ");
              const c = o.firstChild;
              c.textContent.trim() && t.renderInline(c);
            }), t.write(" |"), t.ensureNewLine(), !a) {
              const o = Array.from({
                length: r.childCount
              }).map(() => "---").join(" | ");
              t.write(`| ${o} |`), t.ensureNewLine();
            }
          }), t.closeBlock(e), t.inTable = !1;
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});
function nO(t) {
  return t.attrs.colspan > 1 || t.attrs.rowspan > 1;
}
function z_t(t) {
  const e = Nb(t), n = e[0], r = e.slice(1);
  return !(Nb(n).some((i) => i.type.name !== "tableHeader" || nO(i) || i.childCount > 1) || r.some((i) => Nb(i).some((a) => a.type.name === "tableHeader" || nO(a) || a.childCount > 1)));
}
const R_t = Ht.create({
  name: "taskItem"
}), O_t = R_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(t, e) {
          const n = e.attrs.checked ? "[x]" : "[ ]";
          t.write(`${n} `), t.renderContent(e);
        },
        parse: {
          updateDOM(t) {
            [...t.querySelectorAll(".task-list-item")].forEach((e) => {
              const n = e.querySelector("input");
              e.setAttribute("data-type", "taskItem"), n && (e.setAttribute("data-checked", n.checked), n.remove());
            });
          }
        }
      }
    };
  }
}), B_t = Ht.create({
  name: "taskList"
}), H_t = B_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: nne.storage.markdown.serialize,
        parse: {
          setup(t) {
            t.use(t_t);
          },
          updateDOM(t) {
            [...t.querySelectorAll(".contains-task-list")].forEach((e) => {
              e.setAttribute("data-type", "taskList");
            });
          }
        }
      }
    };
  }
}), F_t = Ht.create({
  name: "text"
}), __t = F_t.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(t, e) {
          t.text(c_t(e.text));
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), V_t = ir.create({
  name: "bold"
}), q_t = V_t.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: vs.marks.strong,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), U_t = ir.create({
  name: "code"
}), W_t = U_t.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: vs.marks.code,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), Z_t = ir.create({
  name: "italic"
}), G_t = Z_t.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: vs.marks.em,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), Y_t = ir.create({
  name: "link"
}), K_t = Y_t.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: vs.marks.link,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), $_t = ir.create({
  name: "strike"
}), J_t = $_t.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: {
          open: "~~",
          close: "~~",
          expelEnclosingWhitespace: !0
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), Q_t = [m_t, nne, v_t, rne, k_t, M_t, M5, A_t, L_t, j_t, D_t, P_t, O_t, H_t, __t, q_t, W_t, tne, G_t, K_t, J_t];
function og(t) {
  var e, n;
  const r = (e = t.storage) === null || e === void 0 ? void 0 : e.markdown, i = (n = Q_t.find((a) => a.name === t.name)) === null || n === void 0 ? void 0 : n.storage.markdown;
  return r || i ? {
    ...i,
    ...r
  } : null;
}
class X_t {
  constructor(e) {
    ag(this, "editor", null), this.editor = e;
  }
  serialize(e) {
    const n = new l_t(this.nodes, this.marks, {
      hardBreakNodeName: rne.name
    });
    return n.renderContent(e), n.out;
  }
  get nodes() {
    var e;
    return {
      ...Object.fromEntries(Object.keys(this.editor.schema.nodes).map((n) => [n, this.serializeNode(M5)])),
      ...Object.fromEntries((e = this.editor.extensionManager.extensions.filter((n) => n.type === "node" && this.serializeNode(n)).map((n) => [n.name, this.serializeNode(n)])) !== null && e !== void 0 ? e : [])
    };
  }
  get marks() {
    var e;
    return {
      ...Object.fromEntries(Object.keys(this.editor.schema.marks).map((n) => [n, this.serializeMark(tne)])),
      ...Object.fromEntries((e = this.editor.extensionManager.extensions.filter((n) => n.type === "mark" && this.serializeMark(n)).map((n) => [n.name, this.serializeMark(n)])) !== null && e !== void 0 ? e : [])
    };
  }
  serializeNode(e) {
    var n;
    return (n = og(e)) === null || n === void 0 || (n = n.serialize) === null || n === void 0 ? void 0 : n.bind({
      editor: this.editor,
      options: e.options
    });
  }
  serializeMark(e) {
    var n;
    const r = (n = og(e)) === null || n === void 0 ? void 0 : n.serialize;
    return r ? {
      ...r,
      open: typeof r.open == "function" ? r.open.bind({
        editor: this.editor,
        options: e.options
      }) : r.open,
      close: typeof r.close == "function" ? r.close.bind({
        editor: this.editor,
        options: e.options
      }) : r.close
    } : null;
  }
}
class eVt {
  constructor(e, n) {
    ag(this, "editor", null), ag(this, "md", null);
    let {
      html: r,
      linkify: i,
      breaks: a
    } = n;
    this.editor = e, this.md = this.withPatchedRenderer(_r({
      html: r,
      linkify: i,
      breaks: a
    }));
  }
  parse(e) {
    let {
      inline: n
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (typeof e == "string") {
      this.editor.extensionManager.extensions.forEach((a) => {
        var o;
        return (o = og(a)) === null || o === void 0 || (o = o.parse) === null || o === void 0 || (o = o.setup) === null || o === void 0 ? void 0 : o.call({
          editor: this.editor,
          options: a.options
        }, this.md);
      });
      const r = this.md.render(e), i = bL(r);
      return this.editor.extensionManager.extensions.forEach((a) => {
        var o;
        return (o = og(a)) === null || o === void 0 || (o = o.parse) === null || o === void 0 || (o = o.updateDOM) === null || o === void 0 ? void 0 : o.call({
          editor: this.editor,
          options: a.options
        }, i);
      }), this.normalizeDOM(i, {
        inline: n,
        content: e
      }), i.innerHTML;
    }
    return e;
  }
  normalizeDOM(e, n) {
    let {
      inline: r,
      content: i
    } = n;
    return this.normalizeBlocks(e), e.querySelectorAll("*").forEach((a) => {
      var o;
      ((o = a.nextSibling) === null || o === void 0 ? void 0 : o.nodeType) === Node.TEXT_NODE && !a.closest("pre") && (a.nextSibling.textContent = a.nextSibling.textContent.replace(/^\n/, ""));
    }), r && this.normalizeInline(e, i), e;
  }
  normalizeBlocks(e) {
    const r = Object.values(this.editor.schema.nodes).filter((i) => i.isBlock).map((i) => {
      var a;
      return (a = i.spec.parseDOM) === null || a === void 0 ? void 0 : a.map((o) => o.tag);
    }).flat().filter(Boolean).join(",");
    r && [...e.querySelectorAll(r)].forEach((i) => {
      i.parentElement.matches("p") && u_t(i);
    });
  }
  normalizeInline(e, n) {
    var r;
    if ((r = e.firstElementChild) !== null && r !== void 0 && r.matches("p")) {
      var i, a, o, s;
      const l = e.firstElementChild, {
        nextElementSibling: c
      } = l, u = (i = (a = n.match(/^\s+/)) === null || a === void 0 ? void 0 : a[0]) !== null && i !== void 0 ? i : "", d = c ? "" : (o = (s = n.match(/\s+$/)) === null || s === void 0 ? void 0 : s[0]) !== null && o !== void 0 ? o : "";
      if (n.match(/^\n\n/)) {
        l.innerHTML = `${l.innerHTML}${d}`;
        return;
      }
      d_t(l), e.innerHTML = `${u}${e.innerHTML}${d}`;
    }
  }
  /**
   * @param {markdownit} md
   */
  withPatchedRenderer(e) {
    const n = (r) => function() {
      const i = r(...arguments);
      return i === `
` ? i : i[i.length - 1] === `
` ? i.slice(0, -1) : i;
    };
    return e.renderer.rules.hardbreak = n(e.renderer.rules.hardbreak), e.renderer.rules.softbreak = n(e.renderer.rules.softbreak), e.renderer.rules.fence = n(e.renderer.rules.fence), e.renderer.rules.code_block = n(e.renderer.rules.code_block), e.renderer.renderToken = n(e.renderer.renderToken.bind(e.renderer)), e;
  }
}
const tVt = ln.create({
  name: "markdownClipboard",
  addOptions() {
    return {
      transformPastedText: !1,
      transformCopiedText: !1
    };
  },
  addProseMirrorPlugins() {
    return [new Wt({
      key: new tn("markdownClipboard"),
      props: {
        clipboardTextParser: (t, e, n) => {
          if (n || !this.options.transformPastedText)
            return null;
          const r = this.editor.storage.markdown.parser.parse(t, {
            inline: !0
          });
          return Uo.fromSchema(this.editor.schema).parseSlice(bL(r), {
            preserveWhitespace: !0,
            context: e
          });
        },
        /**
         * @param {import('prosemirror-model').Slice} slice
         */
        clipboardTextSerializer: (t) => this.options.transformCopiedText ? this.editor.storage.markdown.serializer.serialize(t.content) : null
      }
    })];
  }
}), nVt = ln.create({
  name: "markdown",
  priority: 50,
  addOptions() {
    return {
      html: !0,
      tightLists: !0,
      tightListClass: "tight",
      bulletListMarker: "-",
      linkify: !1,
      breaks: !1,
      transformPastedText: !1,
      transformCopiedText: !1
    };
  },
  addCommands() {
    const t = $se.Commands.config.addCommands();
    return {
      setContent: (e, n, r) => (i) => t.setContent(i.editor.storage.markdown.parser.parse(e), n, r)(i),
      insertContentAt: (e, n, r) => (i) => t.insertContentAt(e, i.editor.storage.markdown.parser.parse(n, {
        inline: !0
      }), r)(i)
    };
  },
  onBeforeCreate() {
    this.editor.storage.markdown = {
      options: {
        ...this.options
      },
      parser: new eVt(this.editor, this.options),
      serializer: new X_t(this.editor),
      getMarkdown: () => this.editor.storage.markdown.serializer.serialize(this.editor.state.doc)
    }, this.editor.options.initialContent = this.editor.options.content, this.editor.options.content = this.editor.storage.markdown.parser.parse(this.editor.options.content);
  },
  onCreate() {
    this.editor.options.content = this.editor.options.initialContent, delete this.editor.options.initialContent;
  },
  addStorage() {
    return {
      /// storage will be defined in onBeforeCreate() to prevent initial object overriding
    };
  },
  addExtensions() {
    return [i_t.configure({
      tight: this.options.tightLists,
      tightClass: this.options.tightListClass
    }), tVt.configure({
      transformPastedText: this.options.transformPastedText,
      transformCopiedText: this.options.transformCopiedText
    })];
  }
}), rVt = (t) => xt({
  find: /--$/,
  replace: t ?? "—"
}), iVt = (t) => xt({
  find: /\.\.\.$/,
  replace: t ?? "…"
}), aVt = (t) => xt({
  find: /(?:^|[\s{[(<'"\u2018\u201C])(")$/,
  replace: t ?? "“"
}), oVt = (t) => xt({
  find: /"$/,
  replace: t ?? "”"
}), sVt = (t) => xt({
  find: /(?:^|[\s{[(<'"\u2018\u201C])(')$/,
  replace: t ?? "‘"
}), lVt = (t) => xt({
  find: /'$/,
  replace: t ?? "’"
}), cVt = (t) => xt({
  find: /<-$/,
  replace: t ?? "←"
}), uVt = (t) => xt({
  find: /->$/,
  replace: t ?? "→"
}), dVt = (t) => xt({
  find: /\(c\)$/,
  replace: t ?? "©"
}), fVt = (t) => xt({
  find: /\(tm\)$/,
  replace: t ?? "™"
}), hVt = (t) => xt({
  find: /\(sm\)$/,
  replace: t ?? "℠"
}), pVt = (t) => xt({
  find: /\(r\)$/,
  replace: t ?? "®"
}), mVt = (t) => xt({
  find: /(?:^|\s)(1\/2)\s$/,
  replace: t ?? "½"
}), yVt = (t) => xt({
  find: /\+\/-$/,
  replace: t ?? "±"
}), gVt = (t) => xt({
  find: /!=$/,
  replace: t ?? "≠"
}), vVt = (t) => xt({
  find: /<<$/,
  replace: t ?? "«"
}), bVt = (t) => xt({
  find: />>$/,
  replace: t ?? "»"
}), wVt = (t) => xt({
  find: /\d+\s?([*x])\s?\d+$/,
  replace: t ?? "×"
}), kVt = (t) => xt({
  find: /\^2$/,
  replace: t ?? "²"
}), xVt = (t) => xt({
  find: /\^3$/,
  replace: t ?? "³"
}), MVt = (t) => xt({
  find: /(?:^|\s)(1\/4)\s$/,
  replace: t ?? "¼"
}), CVt = (t) => xt({
  find: /(?:^|\s)(3\/4)\s$/,
  replace: t ?? "¾"
}), AVt = ln.create({
  name: "typography",
  addOptions() {
    return {
      closeDoubleQuote: "”",
      closeSingleQuote: "’",
      copyright: "©",
      ellipsis: "…",
      emDash: "—",
      laquo: "«",
      leftArrow: "←",
      multiplication: "×",
      notEqual: "≠",
      oneHalf: "½",
      oneQuarter: "¼",
      openDoubleQuote: "“",
      openSingleQuote: "‘",
      plusMinus: "±",
      raquo: "»",
      registeredTrademark: "®",
      rightArrow: "→",
      servicemark: "℠",
      superscriptThree: "³",
      superscriptTwo: "²",
      threeQuarters: "¾",
      trademark: "™"
    };
  },
  addInputRules() {
    const t = [];
    return this.options.emDash !== !1 && t.push(rVt(this.options.emDash)), this.options.ellipsis !== !1 && t.push(iVt(this.options.ellipsis)), this.options.openDoubleQuote !== !1 && t.push(aVt(this.options.openDoubleQuote)), this.options.closeDoubleQuote !== !1 && t.push(oVt(this.options.closeDoubleQuote)), this.options.openSingleQuote !== !1 && t.push(sVt(this.options.openSingleQuote)), this.options.closeSingleQuote !== !1 && t.push(lVt(this.options.closeSingleQuote)), this.options.leftArrow !== !1 && t.push(cVt(this.options.leftArrow)), this.options.rightArrow !== !1 && t.push(uVt(this.options.rightArrow)), this.options.copyright !== !1 && t.push(dVt(this.options.copyright)), this.options.trademark !== !1 && t.push(fVt(this.options.trademark)), this.options.servicemark !== !1 && t.push(hVt(this.options.servicemark)), this.options.registeredTrademark !== !1 && t.push(pVt(this.options.registeredTrademark)), this.options.oneHalf !== !1 && t.push(mVt(this.options.oneHalf)), this.options.plusMinus !== !1 && t.push(yVt(this.options.plusMinus)), this.options.notEqual !== !1 && t.push(gVt(this.options.notEqual)), this.options.laquo !== !1 && t.push(vVt(this.options.laquo)), this.options.raquo !== !1 && t.push(bVt(this.options.raquo)), this.options.multiplication !== !1 && t.push(wVt(this.options.multiplication)), this.options.superscriptTwo !== !1 && t.push(kVt(this.options.superscriptTwo)), this.options.superscriptThree !== !1 && t.push(xVt(this.options.superscriptThree)), this.options.oneQuarter !== !1 && t.push(MVt(this.options.oneQuarter)), this.options.threeQuarters !== !1 && t.push(CVt(this.options.threeQuarters)), t;
  }
}), SVt = ln.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      mode: "textSize",
      textCounter: (t) => t.length,
      wordCounter: (t) => t.split(" ").filter((e) => e !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (t) => {
      const e = (t == null ? void 0 : t.node) || this.editor.state.doc;
      if (((t == null ? void 0 : t.mode) || this.options.mode) === "textSize") {
        const r = e.textBetween(0, e.content.size, void 0, " ");
        return this.options.textCounter(r);
      }
      return e.nodeSize;
    }, this.storage.words = (t) => {
      const e = (t == null ? void 0 : t.node) || this.editor.state.doc, n = e.textBetween(0, e.content.size, " ", " ");
      return this.options.wordCounter(n);
    };
  },
  addProseMirrorPlugins() {
    return [
      new Wt({
        key: new tn("characterCount"),
        filterTransaction: (t, e) => {
          const n = this.options.limit;
          if (!t.docChanged || n === 0 || n === null || n === void 0)
            return !0;
          const r = this.storage.characters({ node: e.doc }), i = this.storage.characters({ node: t.doc });
          if (i <= n || r > n && i > n && i <= r)
            return !0;
          if (r > n && i > n && i > r || !t.getMeta("paste"))
            return !1;
          const o = t.selection.$head.pos, s = i - n, l = o - s, c = o;
          return t.deleteRange(l, c), !(this.storage.characters({ node: t.doc }) > n);
        }
      })
    ];
  }
});
class Ui {
  // The + prefix indicates that these fields aren't writeable
  // Lexer holding the input string.
  // Start offset, zero-based inclusive.
  // End offset, zero-based exclusive.
  constructor(e, n, r) {
    this.lexer = void 0, this.start = void 0, this.end = void 0, this.lexer = e, this.start = n, this.end = r;
  }
  /**
   * Merges two `SourceLocation`s from location providers, given they are
   * provided in order of appearance.
   * - Returns the first one's location if only the first is provided.
   * - Returns a merged range of the first and the last if both are provided
   *   and their lexers match.
   * - Otherwise, returns null.
   */
  static range(e, n) {
    return n ? !e || !e.loc || !n.loc || e.loc.lexer !== n.loc.lexer ? null : new Ui(e.loc.lexer, e.loc.start, n.loc.end) : e && e.loc;
  }
}
let Qo = class ine {
  // don't expand the token
  // used in \noexpand
  constructor(e, n) {
    this.text = void 0, this.loc = void 0, this.noexpand = void 0, this.treatAsRelax = void 0, this.text = e, this.loc = n;
  }
  /**
   * Given a pair of tokens (this and endToken), compute a `Token` encompassing
   * the whole input range enclosed by these two.
   */
  range(e, n) {
    return new ine(n, Ui.range(this, e));
  }
};
class Ge {
  // Error start position based on passed-in Token or ParseNode.
  // Length of affected text based on passed-in Token or ParseNode.
  // The underlying error message without any context added.
  constructor(e, n) {
    this.name = void 0, this.position = void 0, this.length = void 0, this.rawMessage = void 0;
    var r = "KaTeX parse error: " + e, i, a, o = n && n.loc;
    if (o && o.start <= o.end) {
      var s = o.lexer.input;
      i = o.start, a = o.end, i === s.length ? r += " at end of input: " : r += " at position " + (i + 1) + ": ";
      var l = s.slice(i, a).replace(/[^]/g, "$&̲"), c;
      i > 15 ? c = "…" + s.slice(i - 15, i) : c = s.slice(0, i);
      var u;
      a + 15 < s.length ? u = s.slice(a, a + 15) + "…" : u = s.slice(a), r += c + l + u;
    }
    var d = new Error(r);
    return d.name = "ParseError", d.__proto__ = Ge.prototype, d.position = i, i != null && a != null && (d.length = a - i), d.rawMessage = e, d;
  }
}
Ge.prototype.__proto__ = Error.prototype;
var LVt = function(e, n) {
  return e.indexOf(n) !== -1;
}, TVt = function(e, n) {
  return e === void 0 ? n : e;
}, EVt = /([A-Z])/g, jVt = function(e) {
  return e.replace(EVt, "-$1").toLowerCase();
}, NVt = {
  "&": "&amp;",
  ">": "&gt;",
  "<": "&lt;",
  '"': "&quot;",
  "'": "&#x27;"
}, DVt = /[&><"']/g;
function IVt(t) {
  return String(t).replace(DVt, (e) => NVt[e]);
}
var ane = function t(e) {
  return e.type === "ordgroup" || e.type === "color" ? e.body.length === 1 ? t(e.body[0]) : e : e.type === "font" ? t(e.body) : e;
}, PVt = function(e) {
  var n = ane(e);
  return n.type === "mathord" || n.type === "textord" || n.type === "atom";
}, zVt = function(e) {
  if (!e)
    throw new Error("Expected non-null, but got " + String(e));
  return e;
}, RVt = function(e) {
  var n = /^[\x00-\x20]*([^\\/#?]*?)(:|&#0*58|&#x0*3a|&colon)/i.exec(e);
  return n ? n[2] !== ":" || !/^[a-zA-Z][a-zA-Z0-9+\-.]*$/.test(n[1]) ? null : n[1].toLowerCase() : "_relative";
}, wt = {
  contains: LVt,
  deflt: TVt,
  escape: IVt,
  hyphenate: jVt,
  getBaseElem: ane,
  isCharacterBox: PVt,
  protocolFromUrl: RVt
}, cy = {
  displayMode: {
    type: "boolean",
    description: "Render math in display mode, which puts the math in display style (so \\int and \\sum are large, for example), and centers the math on the page on its own line.",
    cli: "-d, --display-mode"
  },
  output: {
    type: {
      enum: ["htmlAndMathml", "html", "mathml"]
    },
    description: "Determines the markup language of the output.",
    cli: "-F, --format <type>"
  },
  leqno: {
    type: "boolean",
    description: "Render display math in leqno style (left-justified tags)."
  },
  fleqn: {
    type: "boolean",
    description: "Render display math flush left."
  },
  throwOnError: {
    type: "boolean",
    default: !0,
    cli: "-t, --no-throw-on-error",
    cliDescription: "Render errors (in the color given by --error-color) instead of throwing a ParseError exception when encountering an error."
  },
  errorColor: {
    type: "string",
    default: "#cc0000",
    cli: "-c, --error-color <color>",
    cliDescription: "A color string given in the format 'rgb' or 'rrggbb' (no #). This option determines the color of errors rendered by the -t option.",
    cliProcessor: (t) => "#" + t
  },
  macros: {
    type: "object",
    cli: "-m, --macro <def>",
    cliDescription: "Define custom macro of the form '\\foo:expansion' (use multiple -m arguments for multiple macros).",
    cliDefault: [],
    cliProcessor: (t, e) => (e.push(t), e)
  },
  minRuleThickness: {
    type: "number",
    description: "Specifies a minimum thickness, in ems, for fraction lines, `\\sqrt` top lines, `{array}` vertical lines, `\\hline`, `\\hdashline`, `\\underline`, `\\overline`, and the borders of `\\fbox`, `\\boxed`, and `\\fcolorbox`.",
    processor: (t) => Math.max(0, t),
    cli: "--min-rule-thickness <size>",
    cliProcessor: parseFloat
  },
  colorIsTextColor: {
    type: "boolean",
    description: "Makes \\color behave like LaTeX's 2-argument \\textcolor, instead of LaTeX's one-argument \\color mode change.",
    cli: "-b, --color-is-text-color"
  },
  strict: {
    type: [{
      enum: ["warn", "ignore", "error"]
    }, "boolean", "function"],
    description: "Turn on strict / LaTeX faithfulness mode, which throws an error if the input uses features that are not supported by LaTeX.",
    cli: "-S, --strict",
    cliDefault: !1
  },
  trust: {
    type: ["boolean", "function"],
    description: "Trust the input, enabling all HTML features such as \\url.",
    cli: "-T, --trust"
  },
  maxSize: {
    type: "number",
    default: 1 / 0,
    description: "If non-zero, all user-specified sizes, e.g. in \\rule{500em}{500em}, will be capped to maxSize ems. Otherwise, elements and spaces can be arbitrarily large",
    processor: (t) => Math.max(0, t),
    cli: "-s, --max-size <n>",
    cliProcessor: parseInt
  },
  maxExpand: {
    type: "number",
    default: 1e3,
    description: "Limit the number of macro expansions to the specified number, to prevent e.g. infinite macro loops. If set to Infinity, the macro expander will try to fully expand as in LaTeX.",
    processor: (t) => Math.max(0, t),
    cli: "-e, --max-expand <n>",
    cliProcessor: (t) => t === "Infinity" ? 1 / 0 : parseInt(t)
  },
  globalGroup: {
    type: "boolean",
    cli: !1
  }
};
function OVt(t) {
  if (t.default)
    return t.default;
  var e = t.type, n = Array.isArray(e) ? e[0] : e;
  if (typeof n != "string")
    return n.enum[0];
  switch (n) {
    case "boolean":
      return !1;
    case "string":
      return "";
    case "number":
      return 0;
    case "object":
      return {};
  }
}
class wL {
  constructor(e) {
    this.displayMode = void 0, this.output = void 0, this.leqno = void 0, this.fleqn = void 0, this.throwOnError = void 0, this.errorColor = void 0, this.macros = void 0, this.minRuleThickness = void 0, this.colorIsTextColor = void 0, this.strict = void 0, this.trust = void 0, this.maxSize = void 0, this.maxExpand = void 0, this.globalGroup = void 0, e = e || {};
    for (var n in cy)
      if (cy.hasOwnProperty(n)) {
        var r = cy[n];
        this[n] = e[n] !== void 0 ? r.processor ? r.processor(e[n]) : e[n] : OVt(r);
      }
  }
  /**
   * Report nonstrict (non-LaTeX-compatible) input.
   * Can safely not be called if `this.strict` is false in JavaScript.
   */
  reportNonstrict(e, n, r) {
    var i = this.strict;
    if (typeof i == "function" && (i = i(e, n, r)), !(!i || i === "ignore")) {
      if (i === !0 || i === "error")
        throw new Ge("LaTeX-incompatible input and strict mode is set to 'error': " + (n + " [" + e + "]"), r);
      i === "warn" ? typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (n + " [" + e + "]")) : typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + i + "': " + n + " [" + e + "]"));
    }
  }
  /**
   * Check whether to apply strict (LaTeX-adhering) behavior for unusual
   * input (like `\\`).  Unlike `nonstrict`, will not throw an error;
   * instead, "error" translates to a return value of `true`, while "ignore"
   * translates to a return value of `false`.  May still print a warning:
   * "warn" prints a warning and returns `false`.
   * This is for the second category of `errorCode`s listed in the README.
   */
  useStrictBehavior(e, n, r) {
    var i = this.strict;
    if (typeof i == "function")
      try {
        i = i(e, n, r);
      } catch {
        i = "error";
      }
    return !i || i === "ignore" ? !1 : i === !0 || i === "error" ? !0 : i === "warn" ? (typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (n + " [" + e + "]")), !1) : (typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + i + "': " + n + " [" + e + "]")), !1);
  }
  /**
   * Check whether to test potentially dangerous input, and return
   * `true` (trusted) or `false` (untrusted).  The sole argument `context`
   * should be an object with `command` field specifying the relevant LaTeX
   * command (as a string starting with `\`), and any other arguments, etc.
   * If `context` has a `url` field, a `protocol` field will automatically
   * get added by this function (changing the specified object).
   */
  isTrusted(e) {
    if (e.url && !e.protocol) {
      var n = wt.protocolFromUrl(e.url);
      if (n == null)
        return !1;
      e.protocol = n;
    }
    var r = typeof this.trust == "function" ? this.trust(e) : this.trust;
    return !!r;
  }
}
class Bl {
  constructor(e, n, r) {
    this.id = void 0, this.size = void 0, this.cramped = void 0, this.id = e, this.size = n, this.cramped = r;
  }
  /**
   * Get the style of a superscript given a base in the current style.
   */
  sup() {
    return Io[BVt[this.id]];
  }
  /**
   * Get the style of a subscript given a base in the current style.
   */
  sub() {
    return Io[HVt[this.id]];
  }
  /**
   * Get the style of a fraction numerator given the fraction in the current
   * style.
   */
  fracNum() {
    return Io[FVt[this.id]];
  }
  /**
   * Get the style of a fraction denominator given the fraction in the current
   * style.
   */
  fracDen() {
    return Io[_Vt[this.id]];
  }
  /**
   * Get the cramped version of a style (in particular, cramping a cramped style
   * doesn't change the style).
   */
  cramp() {
    return Io[VVt[this.id]];
  }
  /**
   * Get a text or display version of this style.
   */
  text() {
    return Io[qVt[this.id]];
  }
  /**
   * Return true if this style is tightly spaced (scriptstyle/scriptscriptstyle)
   */
  isTight() {
    return this.size >= 2;
  }
}
var kL = 0, sg = 1, T1 = 2, nl = 3, $2 = 4, La = 5, gd = 6, li = 7, Io = [new Bl(kL, 0, !1), new Bl(sg, 0, !0), new Bl(T1, 1, !1), new Bl(nl, 1, !0), new Bl($2, 2, !1), new Bl(La, 2, !0), new Bl(gd, 3, !1), new Bl(li, 3, !0)], BVt = [$2, La, $2, La, gd, li, gd, li], HVt = [La, La, La, La, li, li, li, li], FVt = [T1, nl, $2, La, gd, li, gd, li], _Vt = [nl, nl, La, La, li, li, li, li], VVt = [sg, sg, nl, nl, La, La, li, li], qVt = [kL, sg, T1, nl, T1, nl, T1, nl], St = {
  DISPLAY: Io[kL],
  TEXT: Io[T1],
  SCRIPT: Io[$2],
  SCRIPTSCRIPT: Io[gd]
}, Dk = [{
  // Latin characters beyond the Latin-1 characters we have metrics for.
  // Needed for Czech, Hungarian and Turkish text, for example.
  name: "latin",
  blocks: [
    [256, 591],
    // Latin Extended-A and Latin Extended-B
    [768, 879]
    // Combining Diacritical marks
  ]
}, {
  // The Cyrillic script used by Russian and related languages.
  // A Cyrillic subset used to be supported as explicitly defined
  // symbols in symbols.js
  name: "cyrillic",
  blocks: [[1024, 1279]]
}, {
  // Armenian
  name: "armenian",
  blocks: [[1328, 1423]]
}, {
  // The Brahmic scripts of South and Southeast Asia
  // Devanagari (0900–097F)
  // Bengali (0980–09FF)
  // Gurmukhi (0A00–0A7F)
  // Gujarati (0A80–0AFF)
  // Oriya (0B00–0B7F)
  // Tamil (0B80–0BFF)
  // Telugu (0C00–0C7F)
  // Kannada (0C80–0CFF)
  // Malayalam (0D00–0D7F)
  // Sinhala (0D80–0DFF)
  // Thai (0E00–0E7F)
  // Lao (0E80–0EFF)
  // Tibetan (0F00–0FFF)
  // Myanmar (1000–109F)
  name: "brahmic",
  blocks: [[2304, 4255]]
}, {
  name: "georgian",
  blocks: [[4256, 4351]]
}, {
  // Chinese and Japanese.
  // The "k" in cjk is for Korean, but we've separated Korean out
  name: "cjk",
  blocks: [
    [12288, 12543],
    // CJK symbols and punctuation, Hiragana, Katakana
    [19968, 40879],
    // CJK ideograms
    [65280, 65376]
    // Fullwidth punctuation
    // TODO: add halfwidth Katakana and Romanji glyphs
  ]
}, {
  // Korean
  name: "hangul",
  blocks: [[44032, 55215]]
}];
function UVt(t) {
  for (var e = 0; e < Dk.length; e++)
    for (var n = Dk[e], r = 0; r < n.blocks.length; r++) {
      var i = n.blocks[r];
      if (t >= i[0] && t <= i[1])
        return n.name;
    }
  return null;
}
var uy = [];
Dk.forEach((t) => t.blocks.forEach((e) => uy.push(...e)));
function one(t) {
  for (var e = 0; e < uy.length; e += 2)
    if (t >= uy[e] && t <= uy[e + 1])
      return !0;
  return !1;
}
var G0 = 80, WVt = function(e, n) {
  return "M95," + (622 + e + n) + `
c-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14
c0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54
c44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10
s173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429
c69,-144,104.5,-217.7,106.5,-221
l` + e / 2.075 + " -" + e + `
c5.3,-9.3,12,-14,20,-14
H400000v` + (40 + e) + `H845.2724
s-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7
c-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47z
M` + (834 + e) + " " + n + "h400000v" + (40 + e) + "h-400000z";
}, ZVt = function(e, n) {
  return "M263," + (601 + e + n) + `c0.7,0,18,39.7,52,119
c34,79.3,68.167,158.7,102.5,238c34.3,79.3,51.8,119.3,52.5,120
c340,-704.7,510.7,-1060.3,512,-1067
l` + e / 2.084 + " -" + e + `
c4.7,-7.3,11,-11,19,-11
H40000v` + (40 + e) + `H1012.3
s-271.3,567,-271.3,567c-38.7,80.7,-84,175,-136,283c-52,108,-89.167,185.3,-111.5,232
c-22.3,46.7,-33.8,70.3,-34.5,71c-4.7,4.7,-12.3,7,-23,7s-12,-1,-12,-1
s-109,-253,-109,-253c-72.7,-168,-109.3,-252,-110,-252c-10.7,8,-22,16.7,-34,26
c-22,17.3,-33.3,26,-34,26s-26,-26,-26,-26s76,-59,76,-59s76,-60,76,-60z
M` + (1001 + e) + " " + n + "h400000v" + (40 + e) + "h-400000z";
}, GVt = function(e, n) {
  return "M983 " + (10 + e + n) + `
l` + e / 3.13 + " -" + e + `
c4,-6.7,10,-10,18,-10 H400000v` + (40 + e) + `
H1013.1s-83.4,268,-264.1,840c-180.7,572,-277,876.3,-289,913c-4.7,4.7,-12.7,7,-24,7
s-12,0,-12,0c-1.3,-3.3,-3.7,-11.7,-7,-25c-35.3,-125.3,-106.7,-373.3,-214,-744
c-10,12,-21,25,-33,39s-32,39,-32,39c-6,-5.3,-15,-14,-27,-26s25,-30,25,-30
c26.7,-32.7,52,-63,76,-91s52,-60,52,-60s208,722,208,722
c56,-175.3,126.3,-397.3,211,-666c84.7,-268.7,153.8,-488.2,207.5,-658.5
c53.7,-170.3,84.5,-266.8,92.5,-289.5z
M` + (1001 + e) + " " + n + "h400000v" + (40 + e) + "h-400000z";
}, YVt = function(e, n) {
  return "M424," + (2398 + e + n) + `
c-1.3,-0.7,-38.5,-172,-111.5,-514c-73,-342,-109.8,-513.3,-110.5,-514
c0,-2,-10.7,14.3,-32,49c-4.7,7.3,-9.8,15.7,-15.5,25c-5.7,9.3,-9.8,16,-12.5,20
s-5,7,-5,7c-4,-3.3,-8.3,-7.7,-13,-13s-13,-13,-13,-13s76,-122,76,-122s77,-121,77,-121
s209,968,209,968c0,-2,84.7,-361.7,254,-1079c169.3,-717.3,254.7,-1077.7,256,-1081
l` + e / 4.223 + " -" + e + `c4,-6.7,10,-10,18,-10 H400000
v` + (40 + e) + `H1014.6
s-87.3,378.7,-272.6,1166c-185.3,787.3,-279.3,1182.3,-282,1185
c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2z M` + (1001 + e) + " " + n + `
h400000v` + (40 + e) + "h-400000z";
}, KVt = function(e, n) {
  return "M473," + (2713 + e + n) + `
c339.3,-1799.3,509.3,-2700,510,-2702 l` + e / 5.298 + " -" + e + `
c3.3,-7.3,9.3,-11,18,-11 H400000v` + (40 + e) + `H1017.7
s-90.5,478,-276.2,1466c-185.7,988,-279.5,1483,-281.5,1485c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2c0,-1.3,-5.3,-32,-16,-92c-50.7,-293.3,-119.7,-693.3,-207,-1200
c0,-1.3,-5.3,8.7,-16,30c-10.7,21.3,-21.3,42.7,-32,64s-16,33,-16,33s-26,-26,-26,-26
s76,-153,76,-153s77,-151,77,-151c0.7,0.7,35.7,202,105,604c67.3,400.7,102,602.7,104,
606zM` + (1001 + e) + " " + n + "h400000v" + (40 + e) + "H1017.7z";
}, $Vt = function(e) {
  var n = e / 2;
  return "M400000 " + e + " H0 L" + n + " 0 l65 45 L145 " + (e - 80) + " H400000z";
}, JVt = function(e, n, r) {
  var i = r - 54 - n - e;
  return "M702 " + (e + n) + "H400000" + (40 + e) + `
H742v` + i + `l-4 4-4 4c-.667.7 -2 1.5-4 2.5s-4.167 1.833-6.5 2.5-5.5 1-9.5 1
h-12l-28-84c-16.667-52-96.667 -294.333-240-727l-212 -643 -85 170
c-4-3.333-8.333-7.667-13 -13l-13-13l77-155 77-156c66 199.333 139 419.667
219 661 l218 661zM702 ` + n + "H400000v" + (40 + e) + "H742z";
}, QVt = function(e, n, r) {
  n = 1e3 * n;
  var i = "";
  switch (e) {
    case "sqrtMain":
      i = WVt(n, G0);
      break;
    case "sqrtSize1":
      i = ZVt(n, G0);
      break;
    case "sqrtSize2":
      i = GVt(n, G0);
      break;
    case "sqrtSize3":
      i = YVt(n, G0);
      break;
    case "sqrtSize4":
      i = KVt(n, G0);
      break;
    case "sqrtTall":
      i = JVt(n, G0, r);
  }
  return i;
}, XVt = function(e, n) {
  switch (e) {
    case "⎜":
      return "M291 0 H417 V" + n + " H291z M291 0 H417 V" + n + " H291z";
    case "∣":
      return "M145 0 H188 V" + n + " H145z M145 0 H188 V" + n + " H145z";
    case "∥":
      return "M145 0 H188 V" + n + " H145z M145 0 H188 V" + n + " H145z" + ("M367 0 H410 V" + n + " H367z M367 0 H410 V" + n + " H367z");
    case "⎟":
      return "M457 0 H583 V" + n + " H457z M457 0 H583 V" + n + " H457z";
    case "⎢":
      return "M319 0 H403 V" + n + " H319z M319 0 H403 V" + n + " H319z";
    case "⎥":
      return "M263 0 H347 V" + n + " H263z M263 0 H347 V" + n + " H263z";
    case "⎪":
      return "M384 0 H504 V" + n + " H384z M384 0 H504 V" + n + " H384z";
    case "⏐":
      return "M312 0 H355 V" + n + " H312z M312 0 H355 V" + n + " H312z";
    case "‖":
      return "M257 0 H300 V" + n + " H257z M257 0 H300 V" + n + " H257z" + ("M478 0 H521 V" + n + " H478z M478 0 H521 V" + n + " H478z");
    default:
      return "";
  }
}, rO = {
  // The doubleleftarrow geometry is from glyph U+21D0 in the font KaTeX Main
  doubleleftarrow: `M262 157
l10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3
 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28
 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5
c2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5
 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87
-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7
-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z
m8 0v40h399730v-40zm0 194v40h399730v-40z`,
  // doublerightarrow is from glyph U+21D2 in font KaTeX Main
  doublerightarrow: `M399738 392l
-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5
 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88
-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68
-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18
-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782
c-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3
-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z`,
  // leftarrow is from glyph U+2190 in font KaTeX Main
  leftarrow: `M400000 241H110l3-3c68.7-52.7 113.7-120
 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8
-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247
c-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208
 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3
 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202
 l-3-3h399890zM100 241v40h399900v-40z`,
  // overbrace is from glyphs U+23A9/23A8/23A7 in font KaTeX_Size4-Regular
  leftbrace: `M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117
-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7
 5-6 9-10 13-.7 1-7.3 1-20 1H6z`,
  leftbraceunder: `M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13
 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688
 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7
-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z`,
  // overgroup is from the MnSymbol package (public domain)
  leftgroup: `M400000 80
H435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0
 435 0h399565z`,
  leftgroupunder: `M400000 262
H435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219
 435 219h399565z`,
  // Harpoons are from glyph U+21BD in font KaTeX Main
  leftharpoon: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3
-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5
-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7
-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z`,
  leftharpoonplus: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5
 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3
-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7
-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z
m0 0v40h400000v-40z`,
  leftharpoondown: `M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333
 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5
 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667
-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z`,
  leftharpoondownplus: `M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12
 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7
-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0
v40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z`,
  // hook is from glyph U+21A9 in font KaTeX Main
  lefthook: `M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5
-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3
-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21
 71.5 23h399859zM103 281v-40h399897v40z`,
  leftlinesegment: `M40 281 V428 H0 V94 H40 V241 H400000 v40z
M40 281 V428 H0 V94 H40 V241 H400000 v40z`,
  leftmapsto: `M40 281 V448H0V74H40V241H400000v40z
M40 281 V448H0V74H40V241H400000v40z`,
  // tofrom is from glyph U+21C4 in font KaTeX AMS Regular
  leftToFrom: `M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23
-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8
c28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3
 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z`,
  longequal: `M0 50 h400000 v40H0z m0 194h40000v40H0z
M0 50 h400000 v40H0z m0 194h40000v40H0z`,
  midbrace: `M200428 334
c-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14
-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7
 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11
 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z`,
  midbraceunder: `M199572 214
c100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14
 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3
 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0
-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z`,
  oiintSize1: `M512.6 71.6c272.6 0 320.3 106.8 320.3 178.2 0 70.8-47.7 177.6
-320.3 177.6S193.1 320.6 193.1 249.8c0-71.4 46.9-178.2 319.5-178.2z
m368.1 178.2c0-86.4-60.9-215.4-368.1-215.4-306.4 0-367.3 129-367.3 215.4 0 85.8
60.9 214.8 367.3 214.8 307.2 0 368.1-129 368.1-214.8z`,
  oiintSize2: `M757.8 100.1c384.7 0 451.1 137.6 451.1 230 0 91.3-66.4 228.8
-451.1 228.8-386.3 0-452.7-137.5-452.7-228.8 0-92.4 66.4-230 452.7-230z
m502.4 230c0-111.2-82.4-277.2-502.4-277.2s-504 166-504 277.2
c0 110 84 276 504 276s502.4-166 502.4-276z`,
  oiiintSize1: `M681.4 71.6c408.9 0 480.5 106.8 480.5 178.2 0 70.8-71.6 177.6
-480.5 177.6S202.1 320.6 202.1 249.8c0-71.4 70.5-178.2 479.3-178.2z
m525.8 178.2c0-86.4-86.8-215.4-525.7-215.4-437.9 0-524.7 129-524.7 215.4 0
85.8 86.8 214.8 524.7 214.8 438.9 0 525.7-129 525.7-214.8z`,
  oiiintSize2: `M1021.2 53c603.6 0 707.8 165.8 707.8 277.2 0 110-104.2 275.8
-707.8 275.8-606 0-710.2-165.8-710.2-275.8C311 218.8 415.2 53 1021.2 53z
m770.4 277.1c0-131.2-126.4-327.6-770.5-327.6S248.4 198.9 248.4 330.1
c0 130 128.8 326.4 772.7 326.4s770.5-196.4 770.5-326.4z`,
  rightarrow: `M0 241v40h399891c-47.3 35.3-84 78-110 128
-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20
 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7
 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85
-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
 151.7 139 205zm0 0v40h399900v-40z`,
  rightbrace: `M400000 542l
-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5
s-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1
c124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z`,
  rightbraceunder: `M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3
 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237
-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z`,
  rightgroup: `M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0
 3-1 3-3v-38c-76-158-257-219-435-219H0z`,
  rightgroupunder: `M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18
 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z`,
  rightharpoon: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3
-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2
-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58
 69.2 92 94.5zm0 0v40h399900v-40z`,
  rightharpoonplus: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11
-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7
 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z
m0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z`,
  rightharpoondown: `M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8
 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5
-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95
-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z`,
  rightharpoondownplus: `M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8
 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3
 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3
-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z
m0-194v40h400000v-40zm0 0v40h400000v-40z`,
  righthook: `M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3
 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0
-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21
 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z`,
  rightlinesegment: `M399960 241 V94 h40 V428 h-40 V281 H0 v-40z
M399960 241 V94 h40 V428 h-40 V281 H0 v-40z`,
  rightToFrom: `M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23
 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32
-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142
-167z M100 147v40h399900v-40zM0 341v40h399900v-40z`,
  // twoheadleftarrow is from glyph U+219E in font KaTeX AMS Regular
  twoheadleftarrow: `M0 167c68 40
 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69
-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3
-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19
-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101
 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z`,
  twoheadrightarrow: `M400000 167
c-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3
 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42
 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333
-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70
 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z`,
  // tilde1 is a modified version of a glyph from the MnSymbol package
  tilde1: `M200 55.538c-77 0-168 73.953-177 73.953-3 0-7
-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0
 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0
 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128
-68.267.847-113-73.952-191-73.952z`,
  // ditto tilde2, tilde3, & tilde4
  tilde2: `M344 55.266c-142 0-300.638 81.316-311.5 86.418
-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9
 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114
c1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751
 181.476 676 181.476c-149 0-189-126.21-332-126.21z`,
  tilde3: `M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457
-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0
 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697
 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696
 -338 0-409-156.573-744-156.573z`,
  tilde4: `M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345
-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409
 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9
 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409
 -175.236-744-175.236z`,
  // vec is from glyph U+20D7 in font KaTeX Main
  vec: `M377 20c0-5.333 1.833-10 5.5-14S391 0 397 0c4.667 0 8.667 1.667 12 5
3.333 2.667 6.667 9 10 19 6.667 24.667 20.333 43.667 41 57 7.333 4.667 11
10.667 11 18 0 6-1 10-3 12s-6.667 5-14 9c-28.667 14.667-53.667 35.667-75 63
-1.333 1.333-3.167 3.5-5.5 6.5s-4 4.833-5 5.5c-1 .667-2.5 1.333-4.5 2s-4.333 1
-7 1c-4.667 0-9.167-1.833-13.5-5.5S337 184 337 178c0-12.667 15.667-32.333 47-59
H213l-171-1c-8.667-6-13-12.333-13-19 0-4.667 4.333-11.333 13-20h359
c-16-25.333-24-45-24-59z`,
  // widehat1 is a modified version of a glyph from the MnSymbol package
  widehat1: `M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22
c-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z`,
  // ditto widehat2, widehat3, & widehat4
  widehat2: `M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  widehat3: `M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  widehat4: `M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  // widecheck paths are all inverted versions of widehat
  widecheck1: `M529,159h5l519,-115c5,-1,9,-5,9,-10c0,-1,-1,-2,-1,-3l-4,-22c-1,
-5,-5,-9,-11,-9h-2l-512,92l-513,-92h-2c-5,0,-9,4,-11,9l-5,22c-1,6,2,12,8,13z`,
  widecheck2: `M1181,220h2l1171,-176c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,153l-1167,-153h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  widecheck3: `M1181,280h2l1171,-236c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,213l-1167,-213h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  widecheck4: `M1181,340h2l1171,-296c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,273l-1167,-273h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  // The next ten paths support reaction arrows from the mhchem package.
  // Arrows for \ce{<-->} are offset from xAxis by 0.22ex, per mhchem in LaTeX
  // baraboveleftarrow is mostly from glyph U+2190 in font KaTeX Main
  baraboveleftarrow: `M400000 620h-399890l3 -3c68.7 -52.7 113.7 -120 135 -202
c4 -14.7 6 -23 6 -25c0 -7.3 -7 -11 -21 -11c-8 0 -13.2 0.8 -15.5 2.5
c-2.3 1.7 -4.2 5.8 -5.5 12.5c-1.3 4.7 -2.7 10.3 -4 17c-12 48.7 -34.8 92 -68.5 130
s-74.2 66.3 -121.5 85c-10 4 -16 7.7 -18 11c0 8.7 6 14.3 18 17c47.3 18.7 87.8 47
121.5 85s56.5 81.3 68.5 130c0.7 2 1.3 5 2 9s1.2 6.7 1.5 8c0.3 1.3 1 3.3 2 6
s2.2 4.5 3.5 5.5c1.3 1 3.3 1.8 6 2.5s6 1 10 1c14 0 21 -3.7 21 -11
c0 -2 -2 -10.3 -6 -25c-20 -79.3 -65 -146.7 -135 -202l-3 -3h399890z
M100 620v40h399900v-40z M0 241v40h399900v-40zM0 241v40h399900v-40z`,
  // rightarrowabovebar is mostly from glyph U+2192, KaTeX Main
  rightarrowabovebar: `M0 241v40h399891c-47.3 35.3-84 78-110 128-16.7 32
-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20 11 8 0
13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7 39
-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85-40.5
-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
151.7 139 205zm96 379h399894v40H0zm0 0h399904v40H0z`,
  // The short left harpoon has 0.5em (i.e. 500 units) kern on the left end.
  // Ref from mhchem.sty: \rlap{\raisebox{-.22ex}{$\kern0.5em
  baraboveshortleftharpoon: `M507,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17
c2,0.7,5,1,9,1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21
c-32,-87.3,-82.7,-157.7,-152,-211c0,0,-3,-3,-3,-3l399351,0l0,-40
c-398570,0,-399437,0,-399437,0z M593 435 v40 H399500 v-40z
M0 281 v-40 H399908 v40z M0 281 v-40 H399908 v40z`,
  rightharpoonaboveshortbar: `M0,241 l0,40c399126,0,399993,0,399993,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M0 241 v40 H399908 v-40z M0 475 v-40 H399500 v40z M0 475 v-40 H399500 v40z`,
  shortbaraboveleftharpoon: `M7,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17c2,0.7,5,1,9,
1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21c-32,-87.3,-82.7,-157.7,
-152,-211c0,0,-3,-3,-3,-3l399907,0l0,-40c-399126,0,-399993,0,-399993,0z
M93 435 v40 H400000 v-40z M500 241 v40 H400000 v-40z M500 241 v40 H400000 v-40z`,
  shortrightharpoonabovebar: `M53,241l0,40c398570,0,399437,0,399437,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M500 241 v40 H399408 v-40z M500 435 v40 H400000 v-40z`
}, eqt = function(e, n) {
  switch (e) {
    case "lbrack":
      return "M403 1759 V84 H666 V0 H319 V1759 v" + n + ` v1759 h347 v-84
H403z M403 1759 V0 H319 V1759 v` + n + " v1759 h84z";
    case "rbrack":
      return "M347 1759 V0 H0 V84 H263 V1759 v" + n + ` v1759 H0 v84 H347z
M347 1759 V0 H263 V1759 v` + n + " v1759 h84z";
    case "vert":
      return "M145 15 v585 v" + n + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -n + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` + n + " v585 h43z";
    case "doublevert":
      return "M145 15 v585 v" + n + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -n + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` + n + ` v585 h43z
M367 15 v585 v` + n + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -n + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M410 15 H367 v585 v` + n + " v585 h43z";
    case "lfloor":
      return "M319 602 V0 H403 V602 v" + n + ` v1715 h263 v84 H319z
MM319 602 V0 H403 V602 v` + n + " v1715 H319z";
    case "rfloor":
      return "M319 602 V0 H403 V602 v" + n + ` v1799 H0 v-84 H319z
MM319 602 V0 H403 V602 v` + n + " v1715 H319z";
    case "lceil":
      return "M403 1759 V84 H666 V0 H319 V1759 v" + n + ` v602 h84z
M403 1759 V0 H319 V1759 v` + n + " v602 h84z";
    case "rceil":
      return "M347 1759 V0 H0 V84 H263 V1759 v" + n + ` v602 h84z
M347 1759 V0 h-84 V1759 v` + n + " v602 h84z";
    case "lparen":
      return `M863,9c0,-2,-2,-5,-6,-9c0,0,-17,0,-17,0c-12.7,0,-19.3,0.3,-20,1
c-5.3,5.3,-10.3,11,-15,17c-242.7,294.7,-395.3,682,-458,1162c-21.3,163.3,-33.3,349,
-36,557 l0,` + (n + 84) + `c0.2,6,0,26,0,60c2,159.3,10,310.7,24,454c53.3,528,210,
949.7,470,1265c4.7,6,9.7,11.7,15,17c0.7,0.7,7,1,19,1c0,0,18,0,18,0c4,-4,6,-7,6,-9
c0,-2.7,-3.3,-8.7,-10,-18c-135.3,-192.7,-235.5,-414.3,-300.5,-665c-65,-250.7,-102.5,
-544.7,-112.5,-882c-2,-104,-3,-167,-3,-189
l0,-` + (n + 92) + `c0,-162.7,5.7,-314,17,-454c20.7,-272,63.7,-513,129,-723c65.3,
-210,155.3,-396.3,270,-559c6.7,-9.3,10,-15.3,10,-18z`;
    case "rparen":
      return `M76,0c-16.7,0,-25,3,-25,9c0,2,2,6.3,6,13c21.3,28.7,42.3,60.3,
63,95c96.7,156.7,172.8,332.5,228.5,527.5c55.7,195,92.8,416.5,111.5,664.5
c11.3,139.3,17,290.7,17,454c0,28,1.7,43,3.3,45l0,` + (n + 9) + `
c-3,4,-3.3,16.7,-3.3,38c0,162,-5.7,313.7,-17,455c-18.7,248,-55.8,469.3,-111.5,664
c-55.7,194.7,-131.8,370.3,-228.5,527c-20.7,34.7,-41.7,66.3,-63,95c-2,3.3,-4,7,-6,11
c0,7.3,5.7,11,17,11c0,0,11,0,11,0c9.3,0,14.3,-0.3,15,-1c5.3,-5.3,10.3,-11,15,-17
c242.7,-294.7,395.3,-681.7,458,-1161c21.3,-164.7,33.3,-350.7,36,-558
l0,-` + (n + 144) + `c-2,-159.3,-10,-310.7,-24,-454c-53.3,-528,-210,-949.7,
-470,-1265c-4.7,-6,-9.7,-11.7,-15,-17c-0.7,-0.7,-6.7,-1,-18,-1z`;
    default:
      throw new Error("Unknown stretchy delimiter.");
  }
};
let om = class {
  // HtmlDomNode
  // Never used; needed for satisfying interface.
  constructor(e) {
    this.children = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, this.children = e, this.classes = [], this.height = 0, this.depth = 0, this.maxFontSize = 0, this.style = {};
  }
  hasClass(e) {
    return wt.contains(this.classes, e);
  }
  /** Convert the fragment into a node. */
  toNode() {
    for (var e = document.createDocumentFragment(), n = 0; n < this.children.length; n++)
      e.appendChild(this.children[n].toNode());
    return e;
  }
  /** Convert the fragment into HTML markup. */
  toMarkup() {
    for (var e = "", n = 0; n < this.children.length; n++)
      e += this.children[n].toMarkup();
    return e;
  }
  /**
   * Converts the math node into a string, similar to innerText. Applies to
   * MathDomNode's only.
   */
  toText() {
    var e = (n) => n.toText();
    return this.children.map(e).join("");
  }
};
var Vo = {
  "AMS-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.68889, 0, 0, 0.72222],
    66: [0, 0.68889, 0, 0, 0.66667],
    67: [0, 0.68889, 0, 0, 0.72222],
    68: [0, 0.68889, 0, 0, 0.72222],
    69: [0, 0.68889, 0, 0, 0.66667],
    70: [0, 0.68889, 0, 0, 0.61111],
    71: [0, 0.68889, 0, 0, 0.77778],
    72: [0, 0.68889, 0, 0, 0.77778],
    73: [0, 0.68889, 0, 0, 0.38889],
    74: [0.16667, 0.68889, 0, 0, 0.5],
    75: [0, 0.68889, 0, 0, 0.77778],
    76: [0, 0.68889, 0, 0, 0.66667],
    77: [0, 0.68889, 0, 0, 0.94445],
    78: [0, 0.68889, 0, 0, 0.72222],
    79: [0.16667, 0.68889, 0, 0, 0.77778],
    80: [0, 0.68889, 0, 0, 0.61111],
    81: [0.16667, 0.68889, 0, 0, 0.77778],
    82: [0, 0.68889, 0, 0, 0.72222],
    83: [0, 0.68889, 0, 0, 0.55556],
    84: [0, 0.68889, 0, 0, 0.66667],
    85: [0, 0.68889, 0, 0, 0.72222],
    86: [0, 0.68889, 0, 0, 0.72222],
    87: [0, 0.68889, 0, 0, 1],
    88: [0, 0.68889, 0, 0, 0.72222],
    89: [0, 0.68889, 0, 0, 0.72222],
    90: [0, 0.68889, 0, 0, 0.66667],
    107: [0, 0.68889, 0, 0, 0.55556],
    160: [0, 0, 0, 0, 0.25],
    165: [0, 0.675, 0.025, 0, 0.75],
    174: [0.15559, 0.69224, 0, 0, 0.94666],
    240: [0, 0.68889, 0, 0, 0.55556],
    295: [0, 0.68889, 0, 0, 0.54028],
    710: [0, 0.825, 0, 0, 2.33334],
    732: [0, 0.9, 0, 0, 2.33334],
    770: [0, 0.825, 0, 0, 2.33334],
    771: [0, 0.9, 0, 0, 2.33334],
    989: [0.08167, 0.58167, 0, 0, 0.77778],
    1008: [0, 0.43056, 0.04028, 0, 0.66667],
    8245: [0, 0.54986, 0, 0, 0.275],
    8463: [0, 0.68889, 0, 0, 0.54028],
    8487: [0, 0.68889, 0, 0, 0.72222],
    8498: [0, 0.68889, 0, 0, 0.55556],
    8502: [0, 0.68889, 0, 0, 0.66667],
    8503: [0, 0.68889, 0, 0, 0.44445],
    8504: [0, 0.68889, 0, 0, 0.66667],
    8513: [0, 0.68889, 0, 0, 0.63889],
    8592: [-0.03598, 0.46402, 0, 0, 0.5],
    8594: [-0.03598, 0.46402, 0, 0, 0.5],
    8602: [-0.13313, 0.36687, 0, 0, 1],
    8603: [-0.13313, 0.36687, 0, 0, 1],
    8606: [0.01354, 0.52239, 0, 0, 1],
    8608: [0.01354, 0.52239, 0, 0, 1],
    8610: [0.01354, 0.52239, 0, 0, 1.11111],
    8611: [0.01354, 0.52239, 0, 0, 1.11111],
    8619: [0, 0.54986, 0, 0, 1],
    8620: [0, 0.54986, 0, 0, 1],
    8621: [-0.13313, 0.37788, 0, 0, 1.38889],
    8622: [-0.13313, 0.36687, 0, 0, 1],
    8624: [0, 0.69224, 0, 0, 0.5],
    8625: [0, 0.69224, 0, 0, 0.5],
    8630: [0, 0.43056, 0, 0, 1],
    8631: [0, 0.43056, 0, 0, 1],
    8634: [0.08198, 0.58198, 0, 0, 0.77778],
    8635: [0.08198, 0.58198, 0, 0, 0.77778],
    8638: [0.19444, 0.69224, 0, 0, 0.41667],
    8639: [0.19444, 0.69224, 0, 0, 0.41667],
    8642: [0.19444, 0.69224, 0, 0, 0.41667],
    8643: [0.19444, 0.69224, 0, 0, 0.41667],
    8644: [0.1808, 0.675, 0, 0, 1],
    8646: [0.1808, 0.675, 0, 0, 1],
    8647: [0.1808, 0.675, 0, 0, 1],
    8648: [0.19444, 0.69224, 0, 0, 0.83334],
    8649: [0.1808, 0.675, 0, 0, 1],
    8650: [0.19444, 0.69224, 0, 0, 0.83334],
    8651: [0.01354, 0.52239, 0, 0, 1],
    8652: [0.01354, 0.52239, 0, 0, 1],
    8653: [-0.13313, 0.36687, 0, 0, 1],
    8654: [-0.13313, 0.36687, 0, 0, 1],
    8655: [-0.13313, 0.36687, 0, 0, 1],
    8666: [0.13667, 0.63667, 0, 0, 1],
    8667: [0.13667, 0.63667, 0, 0, 1],
    8669: [-0.13313, 0.37788, 0, 0, 1],
    8672: [-0.064, 0.437, 0, 0, 1.334],
    8674: [-0.064, 0.437, 0, 0, 1.334],
    8705: [0, 0.825, 0, 0, 0.5],
    8708: [0, 0.68889, 0, 0, 0.55556],
    8709: [0.08167, 0.58167, 0, 0, 0.77778],
    8717: [0, 0.43056, 0, 0, 0.42917],
    8722: [-0.03598, 0.46402, 0, 0, 0.5],
    8724: [0.08198, 0.69224, 0, 0, 0.77778],
    8726: [0.08167, 0.58167, 0, 0, 0.77778],
    8733: [0, 0.69224, 0, 0, 0.77778],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8737: [0, 0.69224, 0, 0, 0.72222],
    8738: [0.03517, 0.52239, 0, 0, 0.72222],
    8739: [0.08167, 0.58167, 0, 0, 0.22222],
    8740: [0.25142, 0.74111, 0, 0, 0.27778],
    8741: [0.08167, 0.58167, 0, 0, 0.38889],
    8742: [0.25142, 0.74111, 0, 0, 0.5],
    8756: [0, 0.69224, 0, 0, 0.66667],
    8757: [0, 0.69224, 0, 0, 0.66667],
    8764: [-0.13313, 0.36687, 0, 0, 0.77778],
    8765: [-0.13313, 0.37788, 0, 0, 0.77778],
    8769: [-0.13313, 0.36687, 0, 0, 0.77778],
    8770: [-0.03625, 0.46375, 0, 0, 0.77778],
    8774: [0.30274, 0.79383, 0, 0, 0.77778],
    8776: [-0.01688, 0.48312, 0, 0, 0.77778],
    8778: [0.08167, 0.58167, 0, 0, 0.77778],
    8782: [0.06062, 0.54986, 0, 0, 0.77778],
    8783: [0.06062, 0.54986, 0, 0, 0.77778],
    8785: [0.08198, 0.58198, 0, 0, 0.77778],
    8786: [0.08198, 0.58198, 0, 0, 0.77778],
    8787: [0.08198, 0.58198, 0, 0, 0.77778],
    8790: [0, 0.69224, 0, 0, 0.77778],
    8791: [0.22958, 0.72958, 0, 0, 0.77778],
    8796: [0.08198, 0.91667, 0, 0, 0.77778],
    8806: [0.25583, 0.75583, 0, 0, 0.77778],
    8807: [0.25583, 0.75583, 0, 0, 0.77778],
    8808: [0.25142, 0.75726, 0, 0, 0.77778],
    8809: [0.25142, 0.75726, 0, 0, 0.77778],
    8812: [0.25583, 0.75583, 0, 0, 0.5],
    8814: [0.20576, 0.70576, 0, 0, 0.77778],
    8815: [0.20576, 0.70576, 0, 0, 0.77778],
    8816: [0.30274, 0.79383, 0, 0, 0.77778],
    8817: [0.30274, 0.79383, 0, 0, 0.77778],
    8818: [0.22958, 0.72958, 0, 0, 0.77778],
    8819: [0.22958, 0.72958, 0, 0, 0.77778],
    8822: [0.1808, 0.675, 0, 0, 0.77778],
    8823: [0.1808, 0.675, 0, 0, 0.77778],
    8828: [0.13667, 0.63667, 0, 0, 0.77778],
    8829: [0.13667, 0.63667, 0, 0, 0.77778],
    8830: [0.22958, 0.72958, 0, 0, 0.77778],
    8831: [0.22958, 0.72958, 0, 0, 0.77778],
    8832: [0.20576, 0.70576, 0, 0, 0.77778],
    8833: [0.20576, 0.70576, 0, 0, 0.77778],
    8840: [0.30274, 0.79383, 0, 0, 0.77778],
    8841: [0.30274, 0.79383, 0, 0, 0.77778],
    8842: [0.13597, 0.63597, 0, 0, 0.77778],
    8843: [0.13597, 0.63597, 0, 0, 0.77778],
    8847: [0.03517, 0.54986, 0, 0, 0.77778],
    8848: [0.03517, 0.54986, 0, 0, 0.77778],
    8858: [0.08198, 0.58198, 0, 0, 0.77778],
    8859: [0.08198, 0.58198, 0, 0, 0.77778],
    8861: [0.08198, 0.58198, 0, 0, 0.77778],
    8862: [0, 0.675, 0, 0, 0.77778],
    8863: [0, 0.675, 0, 0, 0.77778],
    8864: [0, 0.675, 0, 0, 0.77778],
    8865: [0, 0.675, 0, 0, 0.77778],
    8872: [0, 0.69224, 0, 0, 0.61111],
    8873: [0, 0.69224, 0, 0, 0.72222],
    8874: [0, 0.69224, 0, 0, 0.88889],
    8876: [0, 0.68889, 0, 0, 0.61111],
    8877: [0, 0.68889, 0, 0, 0.61111],
    8878: [0, 0.68889, 0, 0, 0.72222],
    8879: [0, 0.68889, 0, 0, 0.72222],
    8882: [0.03517, 0.54986, 0, 0, 0.77778],
    8883: [0.03517, 0.54986, 0, 0, 0.77778],
    8884: [0.13667, 0.63667, 0, 0, 0.77778],
    8885: [0.13667, 0.63667, 0, 0, 0.77778],
    8888: [0, 0.54986, 0, 0, 1.11111],
    8890: [0.19444, 0.43056, 0, 0, 0.55556],
    8891: [0.19444, 0.69224, 0, 0, 0.61111],
    8892: [0.19444, 0.69224, 0, 0, 0.61111],
    8901: [0, 0.54986, 0, 0, 0.27778],
    8903: [0.08167, 0.58167, 0, 0, 0.77778],
    8905: [0.08167, 0.58167, 0, 0, 0.77778],
    8906: [0.08167, 0.58167, 0, 0, 0.77778],
    8907: [0, 0.69224, 0, 0, 0.77778],
    8908: [0, 0.69224, 0, 0, 0.77778],
    8909: [-0.03598, 0.46402, 0, 0, 0.77778],
    8910: [0, 0.54986, 0, 0, 0.76042],
    8911: [0, 0.54986, 0, 0, 0.76042],
    8912: [0.03517, 0.54986, 0, 0, 0.77778],
    8913: [0.03517, 0.54986, 0, 0, 0.77778],
    8914: [0, 0.54986, 0, 0, 0.66667],
    8915: [0, 0.54986, 0, 0, 0.66667],
    8916: [0, 0.69224, 0, 0, 0.66667],
    8918: [0.0391, 0.5391, 0, 0, 0.77778],
    8919: [0.0391, 0.5391, 0, 0, 0.77778],
    8920: [0.03517, 0.54986, 0, 0, 1.33334],
    8921: [0.03517, 0.54986, 0, 0, 1.33334],
    8922: [0.38569, 0.88569, 0, 0, 0.77778],
    8923: [0.38569, 0.88569, 0, 0, 0.77778],
    8926: [0.13667, 0.63667, 0, 0, 0.77778],
    8927: [0.13667, 0.63667, 0, 0, 0.77778],
    8928: [0.30274, 0.79383, 0, 0, 0.77778],
    8929: [0.30274, 0.79383, 0, 0, 0.77778],
    8934: [0.23222, 0.74111, 0, 0, 0.77778],
    8935: [0.23222, 0.74111, 0, 0, 0.77778],
    8936: [0.23222, 0.74111, 0, 0, 0.77778],
    8937: [0.23222, 0.74111, 0, 0, 0.77778],
    8938: [0.20576, 0.70576, 0, 0, 0.77778],
    8939: [0.20576, 0.70576, 0, 0, 0.77778],
    8940: [0.30274, 0.79383, 0, 0, 0.77778],
    8941: [0.30274, 0.79383, 0, 0, 0.77778],
    8994: [0.19444, 0.69224, 0, 0, 0.77778],
    8995: [0.19444, 0.69224, 0, 0, 0.77778],
    9416: [0.15559, 0.69224, 0, 0, 0.90222],
    9484: [0, 0.69224, 0, 0, 0.5],
    9488: [0, 0.69224, 0, 0, 0.5],
    9492: [0, 0.37788, 0, 0, 0.5],
    9496: [0, 0.37788, 0, 0, 0.5],
    9585: [0.19444, 0.68889, 0, 0, 0.88889],
    9586: [0.19444, 0.74111, 0, 0, 0.88889],
    9632: [0, 0.675, 0, 0, 0.77778],
    9633: [0, 0.675, 0, 0, 0.77778],
    9650: [0, 0.54986, 0, 0, 0.72222],
    9651: [0, 0.54986, 0, 0, 0.72222],
    9654: [0.03517, 0.54986, 0, 0, 0.77778],
    9660: [0, 0.54986, 0, 0, 0.72222],
    9661: [0, 0.54986, 0, 0, 0.72222],
    9664: [0.03517, 0.54986, 0, 0, 0.77778],
    9674: [0.11111, 0.69224, 0, 0, 0.66667],
    9733: [0.19444, 0.69224, 0, 0, 0.94445],
    10003: [0, 0.69224, 0, 0, 0.83334],
    10016: [0, 0.69224, 0, 0, 0.83334],
    10731: [0.11111, 0.69224, 0, 0, 0.66667],
    10846: [0.19444, 0.75583, 0, 0, 0.61111],
    10877: [0.13667, 0.63667, 0, 0, 0.77778],
    10878: [0.13667, 0.63667, 0, 0, 0.77778],
    10885: [0.25583, 0.75583, 0, 0, 0.77778],
    10886: [0.25583, 0.75583, 0, 0, 0.77778],
    10887: [0.13597, 0.63597, 0, 0, 0.77778],
    10888: [0.13597, 0.63597, 0, 0, 0.77778],
    10889: [0.26167, 0.75726, 0, 0, 0.77778],
    10890: [0.26167, 0.75726, 0, 0, 0.77778],
    10891: [0.48256, 0.98256, 0, 0, 0.77778],
    10892: [0.48256, 0.98256, 0, 0, 0.77778],
    10901: [0.13667, 0.63667, 0, 0, 0.77778],
    10902: [0.13667, 0.63667, 0, 0, 0.77778],
    10933: [0.25142, 0.75726, 0, 0, 0.77778],
    10934: [0.25142, 0.75726, 0, 0, 0.77778],
    10935: [0.26167, 0.75726, 0, 0, 0.77778],
    10936: [0.26167, 0.75726, 0, 0, 0.77778],
    10937: [0.26167, 0.75726, 0, 0, 0.77778],
    10938: [0.26167, 0.75726, 0, 0, 0.77778],
    10949: [0.25583, 0.75583, 0, 0, 0.77778],
    10950: [0.25583, 0.75583, 0, 0, 0.77778],
    10955: [0.28481, 0.79383, 0, 0, 0.77778],
    10956: [0.28481, 0.79383, 0, 0, 0.77778],
    57350: [0.08167, 0.58167, 0, 0, 0.22222],
    57351: [0.08167, 0.58167, 0, 0, 0.38889],
    57352: [0.08167, 0.58167, 0, 0, 0.77778],
    57353: [0, 0.43056, 0.04028, 0, 0.66667],
    57356: [0.25142, 0.75726, 0, 0, 0.77778],
    57357: [0.25142, 0.75726, 0, 0, 0.77778],
    57358: [0.41951, 0.91951, 0, 0, 0.77778],
    57359: [0.30274, 0.79383, 0, 0, 0.77778],
    57360: [0.30274, 0.79383, 0, 0, 0.77778],
    57361: [0.41951, 0.91951, 0, 0, 0.77778],
    57366: [0.25142, 0.75726, 0, 0, 0.77778],
    57367: [0.25142, 0.75726, 0, 0, 0.77778],
    57368: [0.25142, 0.75726, 0, 0, 0.77778],
    57369: [0.25142, 0.75726, 0, 0, 0.77778],
    57370: [0.13597, 0.63597, 0, 0, 0.77778],
    57371: [0.13597, 0.63597, 0, 0, 0.77778]
  },
  "Caligraphic-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.68333, 0, 0.19445, 0.79847],
    66: [0, 0.68333, 0.03041, 0.13889, 0.65681],
    67: [0, 0.68333, 0.05834, 0.13889, 0.52653],
    68: [0, 0.68333, 0.02778, 0.08334, 0.77139],
    69: [0, 0.68333, 0.08944, 0.11111, 0.52778],
    70: [0, 0.68333, 0.09931, 0.11111, 0.71875],
    71: [0.09722, 0.68333, 0.0593, 0.11111, 0.59487],
    72: [0, 0.68333, 965e-5, 0.11111, 0.84452],
    73: [0, 0.68333, 0.07382, 0, 0.54452],
    74: [0.09722, 0.68333, 0.18472, 0.16667, 0.67778],
    75: [0, 0.68333, 0.01445, 0.05556, 0.76195],
    76: [0, 0.68333, 0, 0.13889, 0.68972],
    77: [0, 0.68333, 0, 0.13889, 1.2009],
    78: [0, 0.68333, 0.14736, 0.08334, 0.82049],
    79: [0, 0.68333, 0.02778, 0.11111, 0.79611],
    80: [0, 0.68333, 0.08222, 0.08334, 0.69556],
    81: [0.09722, 0.68333, 0, 0.11111, 0.81667],
    82: [0, 0.68333, 0, 0.08334, 0.8475],
    83: [0, 0.68333, 0.075, 0.13889, 0.60556],
    84: [0, 0.68333, 0.25417, 0, 0.54464],
    85: [0, 0.68333, 0.09931, 0.08334, 0.62583],
    86: [0, 0.68333, 0.08222, 0, 0.61278],
    87: [0, 0.68333, 0.08222, 0.08334, 0.98778],
    88: [0, 0.68333, 0.14643, 0.13889, 0.7133],
    89: [0.09722, 0.68333, 0.08222, 0.08334, 0.66834],
    90: [0, 0.68333, 0.07944, 0.13889, 0.72473],
    160: [0, 0, 0, 0, 0.25]
  },
  "Fraktur-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69141, 0, 0, 0.29574],
    34: [0, 0.69141, 0, 0, 0.21471],
    38: [0, 0.69141, 0, 0, 0.73786],
    39: [0, 0.69141, 0, 0, 0.21201],
    40: [0.24982, 0.74947, 0, 0, 0.38865],
    41: [0.24982, 0.74947, 0, 0, 0.38865],
    42: [0, 0.62119, 0, 0, 0.27764],
    43: [0.08319, 0.58283, 0, 0, 0.75623],
    44: [0, 0.10803, 0, 0, 0.27764],
    45: [0.08319, 0.58283, 0, 0, 0.75623],
    46: [0, 0.10803, 0, 0, 0.27764],
    47: [0.24982, 0.74947, 0, 0, 0.50181],
    48: [0, 0.47534, 0, 0, 0.50181],
    49: [0, 0.47534, 0, 0, 0.50181],
    50: [0, 0.47534, 0, 0, 0.50181],
    51: [0.18906, 0.47534, 0, 0, 0.50181],
    52: [0.18906, 0.47534, 0, 0, 0.50181],
    53: [0.18906, 0.47534, 0, 0, 0.50181],
    54: [0, 0.69141, 0, 0, 0.50181],
    55: [0.18906, 0.47534, 0, 0, 0.50181],
    56: [0, 0.69141, 0, 0, 0.50181],
    57: [0.18906, 0.47534, 0, 0, 0.50181],
    58: [0, 0.47534, 0, 0, 0.21606],
    59: [0.12604, 0.47534, 0, 0, 0.21606],
    61: [-0.13099, 0.36866, 0, 0, 0.75623],
    63: [0, 0.69141, 0, 0, 0.36245],
    65: [0, 0.69141, 0, 0, 0.7176],
    66: [0, 0.69141, 0, 0, 0.88397],
    67: [0, 0.69141, 0, 0, 0.61254],
    68: [0, 0.69141, 0, 0, 0.83158],
    69: [0, 0.69141, 0, 0, 0.66278],
    70: [0.12604, 0.69141, 0, 0, 0.61119],
    71: [0, 0.69141, 0, 0, 0.78539],
    72: [0.06302, 0.69141, 0, 0, 0.7203],
    73: [0, 0.69141, 0, 0, 0.55448],
    74: [0.12604, 0.69141, 0, 0, 0.55231],
    75: [0, 0.69141, 0, 0, 0.66845],
    76: [0, 0.69141, 0, 0, 0.66602],
    77: [0, 0.69141, 0, 0, 1.04953],
    78: [0, 0.69141, 0, 0, 0.83212],
    79: [0, 0.69141, 0, 0, 0.82699],
    80: [0.18906, 0.69141, 0, 0, 0.82753],
    81: [0.03781, 0.69141, 0, 0, 0.82699],
    82: [0, 0.69141, 0, 0, 0.82807],
    83: [0, 0.69141, 0, 0, 0.82861],
    84: [0, 0.69141, 0, 0, 0.66899],
    85: [0, 0.69141, 0, 0, 0.64576],
    86: [0, 0.69141, 0, 0, 0.83131],
    87: [0, 0.69141, 0, 0, 1.04602],
    88: [0, 0.69141, 0, 0, 0.71922],
    89: [0.18906, 0.69141, 0, 0, 0.83293],
    90: [0.12604, 0.69141, 0, 0, 0.60201],
    91: [0.24982, 0.74947, 0, 0, 0.27764],
    93: [0.24982, 0.74947, 0, 0, 0.27764],
    94: [0, 0.69141, 0, 0, 0.49965],
    97: [0, 0.47534, 0, 0, 0.50046],
    98: [0, 0.69141, 0, 0, 0.51315],
    99: [0, 0.47534, 0, 0, 0.38946],
    100: [0, 0.62119, 0, 0, 0.49857],
    101: [0, 0.47534, 0, 0, 0.40053],
    102: [0.18906, 0.69141, 0, 0, 0.32626],
    103: [0.18906, 0.47534, 0, 0, 0.5037],
    104: [0.18906, 0.69141, 0, 0, 0.52126],
    105: [0, 0.69141, 0, 0, 0.27899],
    106: [0, 0.69141, 0, 0, 0.28088],
    107: [0, 0.69141, 0, 0, 0.38946],
    108: [0, 0.69141, 0, 0, 0.27953],
    109: [0, 0.47534, 0, 0, 0.76676],
    110: [0, 0.47534, 0, 0, 0.52666],
    111: [0, 0.47534, 0, 0, 0.48885],
    112: [0.18906, 0.52396, 0, 0, 0.50046],
    113: [0.18906, 0.47534, 0, 0, 0.48912],
    114: [0, 0.47534, 0, 0, 0.38919],
    115: [0, 0.47534, 0, 0, 0.44266],
    116: [0, 0.62119, 0, 0, 0.33301],
    117: [0, 0.47534, 0, 0, 0.5172],
    118: [0, 0.52396, 0, 0, 0.5118],
    119: [0, 0.52396, 0, 0, 0.77351],
    120: [0.18906, 0.47534, 0, 0, 0.38865],
    121: [0.18906, 0.47534, 0, 0, 0.49884],
    122: [0.18906, 0.47534, 0, 0, 0.39054],
    160: [0, 0, 0, 0, 0.25],
    8216: [0, 0.69141, 0, 0, 0.21471],
    8217: [0, 0.69141, 0, 0, 0.21471],
    58112: [0, 0.62119, 0, 0, 0.49749],
    58113: [0, 0.62119, 0, 0, 0.4983],
    58114: [0.18906, 0.69141, 0, 0, 0.33328],
    58115: [0.18906, 0.69141, 0, 0, 0.32923],
    58116: [0.18906, 0.47534, 0, 0, 0.50343],
    58117: [0, 0.69141, 0, 0, 0.33301],
    58118: [0, 0.62119, 0, 0, 0.33409],
    58119: [0, 0.47534, 0, 0, 0.50073]
  },
  "Main-Bold": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.35],
    34: [0, 0.69444, 0, 0, 0.60278],
    35: [0.19444, 0.69444, 0, 0, 0.95833],
    36: [0.05556, 0.75, 0, 0, 0.575],
    37: [0.05556, 0.75, 0, 0, 0.95833],
    38: [0, 0.69444, 0, 0, 0.89444],
    39: [0, 0.69444, 0, 0, 0.31944],
    40: [0.25, 0.75, 0, 0, 0.44722],
    41: [0.25, 0.75, 0, 0, 0.44722],
    42: [0, 0.75, 0, 0, 0.575],
    43: [0.13333, 0.63333, 0, 0, 0.89444],
    44: [0.19444, 0.15556, 0, 0, 0.31944],
    45: [0, 0.44444, 0, 0, 0.38333],
    46: [0, 0.15556, 0, 0, 0.31944],
    47: [0.25, 0.75, 0, 0, 0.575],
    48: [0, 0.64444, 0, 0, 0.575],
    49: [0, 0.64444, 0, 0, 0.575],
    50: [0, 0.64444, 0, 0, 0.575],
    51: [0, 0.64444, 0, 0, 0.575],
    52: [0, 0.64444, 0, 0, 0.575],
    53: [0, 0.64444, 0, 0, 0.575],
    54: [0, 0.64444, 0, 0, 0.575],
    55: [0, 0.64444, 0, 0, 0.575],
    56: [0, 0.64444, 0, 0, 0.575],
    57: [0, 0.64444, 0, 0, 0.575],
    58: [0, 0.44444, 0, 0, 0.31944],
    59: [0.19444, 0.44444, 0, 0, 0.31944],
    60: [0.08556, 0.58556, 0, 0, 0.89444],
    61: [-0.10889, 0.39111, 0, 0, 0.89444],
    62: [0.08556, 0.58556, 0, 0, 0.89444],
    63: [0, 0.69444, 0, 0, 0.54305],
    64: [0, 0.69444, 0, 0, 0.89444],
    65: [0, 0.68611, 0, 0, 0.86944],
    66: [0, 0.68611, 0, 0, 0.81805],
    67: [0, 0.68611, 0, 0, 0.83055],
    68: [0, 0.68611, 0, 0, 0.88194],
    69: [0, 0.68611, 0, 0, 0.75555],
    70: [0, 0.68611, 0, 0, 0.72361],
    71: [0, 0.68611, 0, 0, 0.90416],
    72: [0, 0.68611, 0, 0, 0.9],
    73: [0, 0.68611, 0, 0, 0.43611],
    74: [0, 0.68611, 0, 0, 0.59444],
    75: [0, 0.68611, 0, 0, 0.90138],
    76: [0, 0.68611, 0, 0, 0.69166],
    77: [0, 0.68611, 0, 0, 1.09166],
    78: [0, 0.68611, 0, 0, 0.9],
    79: [0, 0.68611, 0, 0, 0.86388],
    80: [0, 0.68611, 0, 0, 0.78611],
    81: [0.19444, 0.68611, 0, 0, 0.86388],
    82: [0, 0.68611, 0, 0, 0.8625],
    83: [0, 0.68611, 0, 0, 0.63889],
    84: [0, 0.68611, 0, 0, 0.8],
    85: [0, 0.68611, 0, 0, 0.88472],
    86: [0, 0.68611, 0.01597, 0, 0.86944],
    87: [0, 0.68611, 0.01597, 0, 1.18888],
    88: [0, 0.68611, 0, 0, 0.86944],
    89: [0, 0.68611, 0.02875, 0, 0.86944],
    90: [0, 0.68611, 0, 0, 0.70277],
    91: [0.25, 0.75, 0, 0, 0.31944],
    92: [0.25, 0.75, 0, 0, 0.575],
    93: [0.25, 0.75, 0, 0, 0.31944],
    94: [0, 0.69444, 0, 0, 0.575],
    95: [0.31, 0.13444, 0.03194, 0, 0.575],
    97: [0, 0.44444, 0, 0, 0.55902],
    98: [0, 0.69444, 0, 0, 0.63889],
    99: [0, 0.44444, 0, 0, 0.51111],
    100: [0, 0.69444, 0, 0, 0.63889],
    101: [0, 0.44444, 0, 0, 0.52708],
    102: [0, 0.69444, 0.10903, 0, 0.35139],
    103: [0.19444, 0.44444, 0.01597, 0, 0.575],
    104: [0, 0.69444, 0, 0, 0.63889],
    105: [0, 0.69444, 0, 0, 0.31944],
    106: [0.19444, 0.69444, 0, 0, 0.35139],
    107: [0, 0.69444, 0, 0, 0.60694],
    108: [0, 0.69444, 0, 0, 0.31944],
    109: [0, 0.44444, 0, 0, 0.95833],
    110: [0, 0.44444, 0, 0, 0.63889],
    111: [0, 0.44444, 0, 0, 0.575],
    112: [0.19444, 0.44444, 0, 0, 0.63889],
    113: [0.19444, 0.44444, 0, 0, 0.60694],
    114: [0, 0.44444, 0, 0, 0.47361],
    115: [0, 0.44444, 0, 0, 0.45361],
    116: [0, 0.63492, 0, 0, 0.44722],
    117: [0, 0.44444, 0, 0, 0.63889],
    118: [0, 0.44444, 0.01597, 0, 0.60694],
    119: [0, 0.44444, 0.01597, 0, 0.83055],
    120: [0, 0.44444, 0, 0, 0.60694],
    121: [0.19444, 0.44444, 0.01597, 0, 0.60694],
    122: [0, 0.44444, 0, 0, 0.51111],
    123: [0.25, 0.75, 0, 0, 0.575],
    124: [0.25, 0.75, 0, 0, 0.31944],
    125: [0.25, 0.75, 0, 0, 0.575],
    126: [0.35, 0.34444, 0, 0, 0.575],
    160: [0, 0, 0, 0, 0.25],
    163: [0, 0.69444, 0, 0, 0.86853],
    168: [0, 0.69444, 0, 0, 0.575],
    172: [0, 0.44444, 0, 0, 0.76666],
    176: [0, 0.69444, 0, 0, 0.86944],
    177: [0.13333, 0.63333, 0, 0, 0.89444],
    184: [0.17014, 0, 0, 0, 0.51111],
    198: [0, 0.68611, 0, 0, 1.04166],
    215: [0.13333, 0.63333, 0, 0, 0.89444],
    216: [0.04861, 0.73472, 0, 0, 0.89444],
    223: [0, 0.69444, 0, 0, 0.59722],
    230: [0, 0.44444, 0, 0, 0.83055],
    247: [0.13333, 0.63333, 0, 0, 0.89444],
    248: [0.09722, 0.54167, 0, 0, 0.575],
    305: [0, 0.44444, 0, 0, 0.31944],
    338: [0, 0.68611, 0, 0, 1.16944],
    339: [0, 0.44444, 0, 0, 0.89444],
    567: [0.19444, 0.44444, 0, 0, 0.35139],
    710: [0, 0.69444, 0, 0, 0.575],
    711: [0, 0.63194, 0, 0, 0.575],
    713: [0, 0.59611, 0, 0, 0.575],
    714: [0, 0.69444, 0, 0, 0.575],
    715: [0, 0.69444, 0, 0, 0.575],
    728: [0, 0.69444, 0, 0, 0.575],
    729: [0, 0.69444, 0, 0, 0.31944],
    730: [0, 0.69444, 0, 0, 0.86944],
    732: [0, 0.69444, 0, 0, 0.575],
    733: [0, 0.69444, 0, 0, 0.575],
    915: [0, 0.68611, 0, 0, 0.69166],
    916: [0, 0.68611, 0, 0, 0.95833],
    920: [0, 0.68611, 0, 0, 0.89444],
    923: [0, 0.68611, 0, 0, 0.80555],
    926: [0, 0.68611, 0, 0, 0.76666],
    928: [0, 0.68611, 0, 0, 0.9],
    931: [0, 0.68611, 0, 0, 0.83055],
    933: [0, 0.68611, 0, 0, 0.89444],
    934: [0, 0.68611, 0, 0, 0.83055],
    936: [0, 0.68611, 0, 0, 0.89444],
    937: [0, 0.68611, 0, 0, 0.83055],
    8211: [0, 0.44444, 0.03194, 0, 0.575],
    8212: [0, 0.44444, 0.03194, 0, 1.14999],
    8216: [0, 0.69444, 0, 0, 0.31944],
    8217: [0, 0.69444, 0, 0, 0.31944],
    8220: [0, 0.69444, 0, 0, 0.60278],
    8221: [0, 0.69444, 0, 0, 0.60278],
    8224: [0.19444, 0.69444, 0, 0, 0.51111],
    8225: [0.19444, 0.69444, 0, 0, 0.51111],
    8242: [0, 0.55556, 0, 0, 0.34444],
    8407: [0, 0.72444, 0.15486, 0, 0.575],
    8463: [0, 0.69444, 0, 0, 0.66759],
    8465: [0, 0.69444, 0, 0, 0.83055],
    8467: [0, 0.69444, 0, 0, 0.47361],
    8472: [0.19444, 0.44444, 0, 0, 0.74027],
    8476: [0, 0.69444, 0, 0, 0.83055],
    8501: [0, 0.69444, 0, 0, 0.70277],
    8592: [-0.10889, 0.39111, 0, 0, 1.14999],
    8593: [0.19444, 0.69444, 0, 0, 0.575],
    8594: [-0.10889, 0.39111, 0, 0, 1.14999],
    8595: [0.19444, 0.69444, 0, 0, 0.575],
    8596: [-0.10889, 0.39111, 0, 0, 1.14999],
    8597: [0.25, 0.75, 0, 0, 0.575],
    8598: [0.19444, 0.69444, 0, 0, 1.14999],
    8599: [0.19444, 0.69444, 0, 0, 1.14999],
    8600: [0.19444, 0.69444, 0, 0, 1.14999],
    8601: [0.19444, 0.69444, 0, 0, 1.14999],
    8636: [-0.10889, 0.39111, 0, 0, 1.14999],
    8637: [-0.10889, 0.39111, 0, 0, 1.14999],
    8640: [-0.10889, 0.39111, 0, 0, 1.14999],
    8641: [-0.10889, 0.39111, 0, 0, 1.14999],
    8656: [-0.10889, 0.39111, 0, 0, 1.14999],
    8657: [0.19444, 0.69444, 0, 0, 0.70277],
    8658: [-0.10889, 0.39111, 0, 0, 1.14999],
    8659: [0.19444, 0.69444, 0, 0, 0.70277],
    8660: [-0.10889, 0.39111, 0, 0, 1.14999],
    8661: [0.25, 0.75, 0, 0, 0.70277],
    8704: [0, 0.69444, 0, 0, 0.63889],
    8706: [0, 0.69444, 0.06389, 0, 0.62847],
    8707: [0, 0.69444, 0, 0, 0.63889],
    8709: [0.05556, 0.75, 0, 0, 0.575],
    8711: [0, 0.68611, 0, 0, 0.95833],
    8712: [0.08556, 0.58556, 0, 0, 0.76666],
    8715: [0.08556, 0.58556, 0, 0, 0.76666],
    8722: [0.13333, 0.63333, 0, 0, 0.89444],
    8723: [0.13333, 0.63333, 0, 0, 0.89444],
    8725: [0.25, 0.75, 0, 0, 0.575],
    8726: [0.25, 0.75, 0, 0, 0.575],
    8727: [-0.02778, 0.47222, 0, 0, 0.575],
    8728: [-0.02639, 0.47361, 0, 0, 0.575],
    8729: [-0.02639, 0.47361, 0, 0, 0.575],
    8730: [0.18, 0.82, 0, 0, 0.95833],
    8733: [0, 0.44444, 0, 0, 0.89444],
    8734: [0, 0.44444, 0, 0, 1.14999],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8739: [0.25, 0.75, 0, 0, 0.31944],
    8741: [0.25, 0.75, 0, 0, 0.575],
    8743: [0, 0.55556, 0, 0, 0.76666],
    8744: [0, 0.55556, 0, 0, 0.76666],
    8745: [0, 0.55556, 0, 0, 0.76666],
    8746: [0, 0.55556, 0, 0, 0.76666],
    8747: [0.19444, 0.69444, 0.12778, 0, 0.56875],
    8764: [-0.10889, 0.39111, 0, 0, 0.89444],
    8768: [0.19444, 0.69444, 0, 0, 0.31944],
    8771: [222e-5, 0.50222, 0, 0, 0.89444],
    8773: [0.027, 0.638, 0, 0, 0.894],
    8776: [0.02444, 0.52444, 0, 0, 0.89444],
    8781: [222e-5, 0.50222, 0, 0, 0.89444],
    8801: [222e-5, 0.50222, 0, 0, 0.89444],
    8804: [0.19667, 0.69667, 0, 0, 0.89444],
    8805: [0.19667, 0.69667, 0, 0, 0.89444],
    8810: [0.08556, 0.58556, 0, 0, 1.14999],
    8811: [0.08556, 0.58556, 0, 0, 1.14999],
    8826: [0.08556, 0.58556, 0, 0, 0.89444],
    8827: [0.08556, 0.58556, 0, 0, 0.89444],
    8834: [0.08556, 0.58556, 0, 0, 0.89444],
    8835: [0.08556, 0.58556, 0, 0, 0.89444],
    8838: [0.19667, 0.69667, 0, 0, 0.89444],
    8839: [0.19667, 0.69667, 0, 0, 0.89444],
    8846: [0, 0.55556, 0, 0, 0.76666],
    8849: [0.19667, 0.69667, 0, 0, 0.89444],
    8850: [0.19667, 0.69667, 0, 0, 0.89444],
    8851: [0, 0.55556, 0, 0, 0.76666],
    8852: [0, 0.55556, 0, 0, 0.76666],
    8853: [0.13333, 0.63333, 0, 0, 0.89444],
    8854: [0.13333, 0.63333, 0, 0, 0.89444],
    8855: [0.13333, 0.63333, 0, 0, 0.89444],
    8856: [0.13333, 0.63333, 0, 0, 0.89444],
    8857: [0.13333, 0.63333, 0, 0, 0.89444],
    8866: [0, 0.69444, 0, 0, 0.70277],
    8867: [0, 0.69444, 0, 0, 0.70277],
    8868: [0, 0.69444, 0, 0, 0.89444],
    8869: [0, 0.69444, 0, 0, 0.89444],
    8900: [-0.02639, 0.47361, 0, 0, 0.575],
    8901: [-0.02639, 0.47361, 0, 0, 0.31944],
    8902: [-0.02778, 0.47222, 0, 0, 0.575],
    8968: [0.25, 0.75, 0, 0, 0.51111],
    8969: [0.25, 0.75, 0, 0, 0.51111],
    8970: [0.25, 0.75, 0, 0, 0.51111],
    8971: [0.25, 0.75, 0, 0, 0.51111],
    8994: [-0.13889, 0.36111, 0, 0, 1.14999],
    8995: [-0.13889, 0.36111, 0, 0, 1.14999],
    9651: [0.19444, 0.69444, 0, 0, 1.02222],
    9657: [-0.02778, 0.47222, 0, 0, 0.575],
    9661: [0.19444, 0.69444, 0, 0, 1.02222],
    9667: [-0.02778, 0.47222, 0, 0, 0.575],
    9711: [0.19444, 0.69444, 0, 0, 1.14999],
    9824: [0.12963, 0.69444, 0, 0, 0.89444],
    9825: [0.12963, 0.69444, 0, 0, 0.89444],
    9826: [0.12963, 0.69444, 0, 0, 0.89444],
    9827: [0.12963, 0.69444, 0, 0, 0.89444],
    9837: [0, 0.75, 0, 0, 0.44722],
    9838: [0.19444, 0.69444, 0, 0, 0.44722],
    9839: [0.19444, 0.69444, 0, 0, 0.44722],
    10216: [0.25, 0.75, 0, 0, 0.44722],
    10217: [0.25, 0.75, 0, 0, 0.44722],
    10815: [0, 0.68611, 0, 0, 0.9],
    10927: [0.19667, 0.69667, 0, 0, 0.89444],
    10928: [0.19667, 0.69667, 0, 0, 0.89444],
    57376: [0.19444, 0.69444, 0, 0, 0]
  },
  "Main-BoldItalic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.11417, 0, 0.38611],
    34: [0, 0.69444, 0.07939, 0, 0.62055],
    35: [0.19444, 0.69444, 0.06833, 0, 0.94444],
    37: [0.05556, 0.75, 0.12861, 0, 0.94444],
    38: [0, 0.69444, 0.08528, 0, 0.88555],
    39: [0, 0.69444, 0.12945, 0, 0.35555],
    40: [0.25, 0.75, 0.15806, 0, 0.47333],
    41: [0.25, 0.75, 0.03306, 0, 0.47333],
    42: [0, 0.75, 0.14333, 0, 0.59111],
    43: [0.10333, 0.60333, 0.03306, 0, 0.88555],
    44: [0.19444, 0.14722, 0, 0, 0.35555],
    45: [0, 0.44444, 0.02611, 0, 0.41444],
    46: [0, 0.14722, 0, 0, 0.35555],
    47: [0.25, 0.75, 0.15806, 0, 0.59111],
    48: [0, 0.64444, 0.13167, 0, 0.59111],
    49: [0, 0.64444, 0.13167, 0, 0.59111],
    50: [0, 0.64444, 0.13167, 0, 0.59111],
    51: [0, 0.64444, 0.13167, 0, 0.59111],
    52: [0.19444, 0.64444, 0.13167, 0, 0.59111],
    53: [0, 0.64444, 0.13167, 0, 0.59111],
    54: [0, 0.64444, 0.13167, 0, 0.59111],
    55: [0.19444, 0.64444, 0.13167, 0, 0.59111],
    56: [0, 0.64444, 0.13167, 0, 0.59111],
    57: [0, 0.64444, 0.13167, 0, 0.59111],
    58: [0, 0.44444, 0.06695, 0, 0.35555],
    59: [0.19444, 0.44444, 0.06695, 0, 0.35555],
    61: [-0.10889, 0.39111, 0.06833, 0, 0.88555],
    63: [0, 0.69444, 0.11472, 0, 0.59111],
    64: [0, 0.69444, 0.09208, 0, 0.88555],
    65: [0, 0.68611, 0, 0, 0.86555],
    66: [0, 0.68611, 0.0992, 0, 0.81666],
    67: [0, 0.68611, 0.14208, 0, 0.82666],
    68: [0, 0.68611, 0.09062, 0, 0.87555],
    69: [0, 0.68611, 0.11431, 0, 0.75666],
    70: [0, 0.68611, 0.12903, 0, 0.72722],
    71: [0, 0.68611, 0.07347, 0, 0.89527],
    72: [0, 0.68611, 0.17208, 0, 0.8961],
    73: [0, 0.68611, 0.15681, 0, 0.47166],
    74: [0, 0.68611, 0.145, 0, 0.61055],
    75: [0, 0.68611, 0.14208, 0, 0.89499],
    76: [0, 0.68611, 0, 0, 0.69777],
    77: [0, 0.68611, 0.17208, 0, 1.07277],
    78: [0, 0.68611, 0.17208, 0, 0.8961],
    79: [0, 0.68611, 0.09062, 0, 0.85499],
    80: [0, 0.68611, 0.0992, 0, 0.78721],
    81: [0.19444, 0.68611, 0.09062, 0, 0.85499],
    82: [0, 0.68611, 0.02559, 0, 0.85944],
    83: [0, 0.68611, 0.11264, 0, 0.64999],
    84: [0, 0.68611, 0.12903, 0, 0.7961],
    85: [0, 0.68611, 0.17208, 0, 0.88083],
    86: [0, 0.68611, 0.18625, 0, 0.86555],
    87: [0, 0.68611, 0.18625, 0, 1.15999],
    88: [0, 0.68611, 0.15681, 0, 0.86555],
    89: [0, 0.68611, 0.19803, 0, 0.86555],
    90: [0, 0.68611, 0.14208, 0, 0.70888],
    91: [0.25, 0.75, 0.1875, 0, 0.35611],
    93: [0.25, 0.75, 0.09972, 0, 0.35611],
    94: [0, 0.69444, 0.06709, 0, 0.59111],
    95: [0.31, 0.13444, 0.09811, 0, 0.59111],
    97: [0, 0.44444, 0.09426, 0, 0.59111],
    98: [0, 0.69444, 0.07861, 0, 0.53222],
    99: [0, 0.44444, 0.05222, 0, 0.53222],
    100: [0, 0.69444, 0.10861, 0, 0.59111],
    101: [0, 0.44444, 0.085, 0, 0.53222],
    102: [0.19444, 0.69444, 0.21778, 0, 0.4],
    103: [0.19444, 0.44444, 0.105, 0, 0.53222],
    104: [0, 0.69444, 0.09426, 0, 0.59111],
    105: [0, 0.69326, 0.11387, 0, 0.35555],
    106: [0.19444, 0.69326, 0.1672, 0, 0.35555],
    107: [0, 0.69444, 0.11111, 0, 0.53222],
    108: [0, 0.69444, 0.10861, 0, 0.29666],
    109: [0, 0.44444, 0.09426, 0, 0.94444],
    110: [0, 0.44444, 0.09426, 0, 0.64999],
    111: [0, 0.44444, 0.07861, 0, 0.59111],
    112: [0.19444, 0.44444, 0.07861, 0, 0.59111],
    113: [0.19444, 0.44444, 0.105, 0, 0.53222],
    114: [0, 0.44444, 0.11111, 0, 0.50167],
    115: [0, 0.44444, 0.08167, 0, 0.48694],
    116: [0, 0.63492, 0.09639, 0, 0.385],
    117: [0, 0.44444, 0.09426, 0, 0.62055],
    118: [0, 0.44444, 0.11111, 0, 0.53222],
    119: [0, 0.44444, 0.11111, 0, 0.76777],
    120: [0, 0.44444, 0.12583, 0, 0.56055],
    121: [0.19444, 0.44444, 0.105, 0, 0.56166],
    122: [0, 0.44444, 0.13889, 0, 0.49055],
    126: [0.35, 0.34444, 0.11472, 0, 0.59111],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.69444, 0.11473, 0, 0.59111],
    176: [0, 0.69444, 0, 0, 0.94888],
    184: [0.17014, 0, 0, 0, 0.53222],
    198: [0, 0.68611, 0.11431, 0, 1.02277],
    216: [0.04861, 0.73472, 0.09062, 0, 0.88555],
    223: [0.19444, 0.69444, 0.09736, 0, 0.665],
    230: [0, 0.44444, 0.085, 0, 0.82666],
    248: [0.09722, 0.54167, 0.09458, 0, 0.59111],
    305: [0, 0.44444, 0.09426, 0, 0.35555],
    338: [0, 0.68611, 0.11431, 0, 1.14054],
    339: [0, 0.44444, 0.085, 0, 0.82666],
    567: [0.19444, 0.44444, 0.04611, 0, 0.385],
    710: [0, 0.69444, 0.06709, 0, 0.59111],
    711: [0, 0.63194, 0.08271, 0, 0.59111],
    713: [0, 0.59444, 0.10444, 0, 0.59111],
    714: [0, 0.69444, 0.08528, 0, 0.59111],
    715: [0, 0.69444, 0, 0, 0.59111],
    728: [0, 0.69444, 0.10333, 0, 0.59111],
    729: [0, 0.69444, 0.12945, 0, 0.35555],
    730: [0, 0.69444, 0, 0, 0.94888],
    732: [0, 0.69444, 0.11472, 0, 0.59111],
    733: [0, 0.69444, 0.11472, 0, 0.59111],
    915: [0, 0.68611, 0.12903, 0, 0.69777],
    916: [0, 0.68611, 0, 0, 0.94444],
    920: [0, 0.68611, 0.09062, 0, 0.88555],
    923: [0, 0.68611, 0, 0, 0.80666],
    926: [0, 0.68611, 0.15092, 0, 0.76777],
    928: [0, 0.68611, 0.17208, 0, 0.8961],
    931: [0, 0.68611, 0.11431, 0, 0.82666],
    933: [0, 0.68611, 0.10778, 0, 0.88555],
    934: [0, 0.68611, 0.05632, 0, 0.82666],
    936: [0, 0.68611, 0.10778, 0, 0.88555],
    937: [0, 0.68611, 0.0992, 0, 0.82666],
    8211: [0, 0.44444, 0.09811, 0, 0.59111],
    8212: [0, 0.44444, 0.09811, 0, 1.18221],
    8216: [0, 0.69444, 0.12945, 0, 0.35555],
    8217: [0, 0.69444, 0.12945, 0, 0.35555],
    8220: [0, 0.69444, 0.16772, 0, 0.62055],
    8221: [0, 0.69444, 0.07939, 0, 0.62055]
  },
  "Main-Italic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.12417, 0, 0.30667],
    34: [0, 0.69444, 0.06961, 0, 0.51444],
    35: [0.19444, 0.69444, 0.06616, 0, 0.81777],
    37: [0.05556, 0.75, 0.13639, 0, 0.81777],
    38: [0, 0.69444, 0.09694, 0, 0.76666],
    39: [0, 0.69444, 0.12417, 0, 0.30667],
    40: [0.25, 0.75, 0.16194, 0, 0.40889],
    41: [0.25, 0.75, 0.03694, 0, 0.40889],
    42: [0, 0.75, 0.14917, 0, 0.51111],
    43: [0.05667, 0.56167, 0.03694, 0, 0.76666],
    44: [0.19444, 0.10556, 0, 0, 0.30667],
    45: [0, 0.43056, 0.02826, 0, 0.35778],
    46: [0, 0.10556, 0, 0, 0.30667],
    47: [0.25, 0.75, 0.16194, 0, 0.51111],
    48: [0, 0.64444, 0.13556, 0, 0.51111],
    49: [0, 0.64444, 0.13556, 0, 0.51111],
    50: [0, 0.64444, 0.13556, 0, 0.51111],
    51: [0, 0.64444, 0.13556, 0, 0.51111],
    52: [0.19444, 0.64444, 0.13556, 0, 0.51111],
    53: [0, 0.64444, 0.13556, 0, 0.51111],
    54: [0, 0.64444, 0.13556, 0, 0.51111],
    55: [0.19444, 0.64444, 0.13556, 0, 0.51111],
    56: [0, 0.64444, 0.13556, 0, 0.51111],
    57: [0, 0.64444, 0.13556, 0, 0.51111],
    58: [0, 0.43056, 0.0582, 0, 0.30667],
    59: [0.19444, 0.43056, 0.0582, 0, 0.30667],
    61: [-0.13313, 0.36687, 0.06616, 0, 0.76666],
    63: [0, 0.69444, 0.1225, 0, 0.51111],
    64: [0, 0.69444, 0.09597, 0, 0.76666],
    65: [0, 0.68333, 0, 0, 0.74333],
    66: [0, 0.68333, 0.10257, 0, 0.70389],
    67: [0, 0.68333, 0.14528, 0, 0.71555],
    68: [0, 0.68333, 0.09403, 0, 0.755],
    69: [0, 0.68333, 0.12028, 0, 0.67833],
    70: [0, 0.68333, 0.13305, 0, 0.65277],
    71: [0, 0.68333, 0.08722, 0, 0.77361],
    72: [0, 0.68333, 0.16389, 0, 0.74333],
    73: [0, 0.68333, 0.15806, 0, 0.38555],
    74: [0, 0.68333, 0.14028, 0, 0.525],
    75: [0, 0.68333, 0.14528, 0, 0.76888],
    76: [0, 0.68333, 0, 0, 0.62722],
    77: [0, 0.68333, 0.16389, 0, 0.89666],
    78: [0, 0.68333, 0.16389, 0, 0.74333],
    79: [0, 0.68333, 0.09403, 0, 0.76666],
    80: [0, 0.68333, 0.10257, 0, 0.67833],
    81: [0.19444, 0.68333, 0.09403, 0, 0.76666],
    82: [0, 0.68333, 0.03868, 0, 0.72944],
    83: [0, 0.68333, 0.11972, 0, 0.56222],
    84: [0, 0.68333, 0.13305, 0, 0.71555],
    85: [0, 0.68333, 0.16389, 0, 0.74333],
    86: [0, 0.68333, 0.18361, 0, 0.74333],
    87: [0, 0.68333, 0.18361, 0, 0.99888],
    88: [0, 0.68333, 0.15806, 0, 0.74333],
    89: [0, 0.68333, 0.19383, 0, 0.74333],
    90: [0, 0.68333, 0.14528, 0, 0.61333],
    91: [0.25, 0.75, 0.1875, 0, 0.30667],
    93: [0.25, 0.75, 0.10528, 0, 0.30667],
    94: [0, 0.69444, 0.06646, 0, 0.51111],
    95: [0.31, 0.12056, 0.09208, 0, 0.51111],
    97: [0, 0.43056, 0.07671, 0, 0.51111],
    98: [0, 0.69444, 0.06312, 0, 0.46],
    99: [0, 0.43056, 0.05653, 0, 0.46],
    100: [0, 0.69444, 0.10333, 0, 0.51111],
    101: [0, 0.43056, 0.07514, 0, 0.46],
    102: [0.19444, 0.69444, 0.21194, 0, 0.30667],
    103: [0.19444, 0.43056, 0.08847, 0, 0.46],
    104: [0, 0.69444, 0.07671, 0, 0.51111],
    105: [0, 0.65536, 0.1019, 0, 0.30667],
    106: [0.19444, 0.65536, 0.14467, 0, 0.30667],
    107: [0, 0.69444, 0.10764, 0, 0.46],
    108: [0, 0.69444, 0.10333, 0, 0.25555],
    109: [0, 0.43056, 0.07671, 0, 0.81777],
    110: [0, 0.43056, 0.07671, 0, 0.56222],
    111: [0, 0.43056, 0.06312, 0, 0.51111],
    112: [0.19444, 0.43056, 0.06312, 0, 0.51111],
    113: [0.19444, 0.43056, 0.08847, 0, 0.46],
    114: [0, 0.43056, 0.10764, 0, 0.42166],
    115: [0, 0.43056, 0.08208, 0, 0.40889],
    116: [0, 0.61508, 0.09486, 0, 0.33222],
    117: [0, 0.43056, 0.07671, 0, 0.53666],
    118: [0, 0.43056, 0.10764, 0, 0.46],
    119: [0, 0.43056, 0.10764, 0, 0.66444],
    120: [0, 0.43056, 0.12042, 0, 0.46389],
    121: [0.19444, 0.43056, 0.08847, 0, 0.48555],
    122: [0, 0.43056, 0.12292, 0, 0.40889],
    126: [0.35, 0.31786, 0.11585, 0, 0.51111],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.66786, 0.10474, 0, 0.51111],
    176: [0, 0.69444, 0, 0, 0.83129],
    184: [0.17014, 0, 0, 0, 0.46],
    198: [0, 0.68333, 0.12028, 0, 0.88277],
    216: [0.04861, 0.73194, 0.09403, 0, 0.76666],
    223: [0.19444, 0.69444, 0.10514, 0, 0.53666],
    230: [0, 0.43056, 0.07514, 0, 0.71555],
    248: [0.09722, 0.52778, 0.09194, 0, 0.51111],
    338: [0, 0.68333, 0.12028, 0, 0.98499],
    339: [0, 0.43056, 0.07514, 0, 0.71555],
    710: [0, 0.69444, 0.06646, 0, 0.51111],
    711: [0, 0.62847, 0.08295, 0, 0.51111],
    713: [0, 0.56167, 0.10333, 0, 0.51111],
    714: [0, 0.69444, 0.09694, 0, 0.51111],
    715: [0, 0.69444, 0, 0, 0.51111],
    728: [0, 0.69444, 0.10806, 0, 0.51111],
    729: [0, 0.66786, 0.11752, 0, 0.30667],
    730: [0, 0.69444, 0, 0, 0.83129],
    732: [0, 0.66786, 0.11585, 0, 0.51111],
    733: [0, 0.69444, 0.1225, 0, 0.51111],
    915: [0, 0.68333, 0.13305, 0, 0.62722],
    916: [0, 0.68333, 0, 0, 0.81777],
    920: [0, 0.68333, 0.09403, 0, 0.76666],
    923: [0, 0.68333, 0, 0, 0.69222],
    926: [0, 0.68333, 0.15294, 0, 0.66444],
    928: [0, 0.68333, 0.16389, 0, 0.74333],
    931: [0, 0.68333, 0.12028, 0, 0.71555],
    933: [0, 0.68333, 0.11111, 0, 0.76666],
    934: [0, 0.68333, 0.05986, 0, 0.71555],
    936: [0, 0.68333, 0.11111, 0, 0.76666],
    937: [0, 0.68333, 0.10257, 0, 0.71555],
    8211: [0, 0.43056, 0.09208, 0, 0.51111],
    8212: [0, 0.43056, 0.09208, 0, 1.02222],
    8216: [0, 0.69444, 0.12417, 0, 0.30667],
    8217: [0, 0.69444, 0.12417, 0, 0.30667],
    8220: [0, 0.69444, 0.1685, 0, 0.51444],
    8221: [0, 0.69444, 0.06961, 0, 0.51444],
    8463: [0, 0.68889, 0, 0, 0.54028]
  },
  "Main-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.27778],
    34: [0, 0.69444, 0, 0, 0.5],
    35: [0.19444, 0.69444, 0, 0, 0.83334],
    36: [0.05556, 0.75, 0, 0, 0.5],
    37: [0.05556, 0.75, 0, 0, 0.83334],
    38: [0, 0.69444, 0, 0, 0.77778],
    39: [0, 0.69444, 0, 0, 0.27778],
    40: [0.25, 0.75, 0, 0, 0.38889],
    41: [0.25, 0.75, 0, 0, 0.38889],
    42: [0, 0.75, 0, 0, 0.5],
    43: [0.08333, 0.58333, 0, 0, 0.77778],
    44: [0.19444, 0.10556, 0, 0, 0.27778],
    45: [0, 0.43056, 0, 0, 0.33333],
    46: [0, 0.10556, 0, 0, 0.27778],
    47: [0.25, 0.75, 0, 0, 0.5],
    48: [0, 0.64444, 0, 0, 0.5],
    49: [0, 0.64444, 0, 0, 0.5],
    50: [0, 0.64444, 0, 0, 0.5],
    51: [0, 0.64444, 0, 0, 0.5],
    52: [0, 0.64444, 0, 0, 0.5],
    53: [0, 0.64444, 0, 0, 0.5],
    54: [0, 0.64444, 0, 0, 0.5],
    55: [0, 0.64444, 0, 0, 0.5],
    56: [0, 0.64444, 0, 0, 0.5],
    57: [0, 0.64444, 0, 0, 0.5],
    58: [0, 0.43056, 0, 0, 0.27778],
    59: [0.19444, 0.43056, 0, 0, 0.27778],
    60: [0.0391, 0.5391, 0, 0, 0.77778],
    61: [-0.13313, 0.36687, 0, 0, 0.77778],
    62: [0.0391, 0.5391, 0, 0, 0.77778],
    63: [0, 0.69444, 0, 0, 0.47222],
    64: [0, 0.69444, 0, 0, 0.77778],
    65: [0, 0.68333, 0, 0, 0.75],
    66: [0, 0.68333, 0, 0, 0.70834],
    67: [0, 0.68333, 0, 0, 0.72222],
    68: [0, 0.68333, 0, 0, 0.76389],
    69: [0, 0.68333, 0, 0, 0.68056],
    70: [0, 0.68333, 0, 0, 0.65278],
    71: [0, 0.68333, 0, 0, 0.78472],
    72: [0, 0.68333, 0, 0, 0.75],
    73: [0, 0.68333, 0, 0, 0.36111],
    74: [0, 0.68333, 0, 0, 0.51389],
    75: [0, 0.68333, 0, 0, 0.77778],
    76: [0, 0.68333, 0, 0, 0.625],
    77: [0, 0.68333, 0, 0, 0.91667],
    78: [0, 0.68333, 0, 0, 0.75],
    79: [0, 0.68333, 0, 0, 0.77778],
    80: [0, 0.68333, 0, 0, 0.68056],
    81: [0.19444, 0.68333, 0, 0, 0.77778],
    82: [0, 0.68333, 0, 0, 0.73611],
    83: [0, 0.68333, 0, 0, 0.55556],
    84: [0, 0.68333, 0, 0, 0.72222],
    85: [0, 0.68333, 0, 0, 0.75],
    86: [0, 0.68333, 0.01389, 0, 0.75],
    87: [0, 0.68333, 0.01389, 0, 1.02778],
    88: [0, 0.68333, 0, 0, 0.75],
    89: [0, 0.68333, 0.025, 0, 0.75],
    90: [0, 0.68333, 0, 0, 0.61111],
    91: [0.25, 0.75, 0, 0, 0.27778],
    92: [0.25, 0.75, 0, 0, 0.5],
    93: [0.25, 0.75, 0, 0, 0.27778],
    94: [0, 0.69444, 0, 0, 0.5],
    95: [0.31, 0.12056, 0.02778, 0, 0.5],
    97: [0, 0.43056, 0, 0, 0.5],
    98: [0, 0.69444, 0, 0, 0.55556],
    99: [0, 0.43056, 0, 0, 0.44445],
    100: [0, 0.69444, 0, 0, 0.55556],
    101: [0, 0.43056, 0, 0, 0.44445],
    102: [0, 0.69444, 0.07778, 0, 0.30556],
    103: [0.19444, 0.43056, 0.01389, 0, 0.5],
    104: [0, 0.69444, 0, 0, 0.55556],
    105: [0, 0.66786, 0, 0, 0.27778],
    106: [0.19444, 0.66786, 0, 0, 0.30556],
    107: [0, 0.69444, 0, 0, 0.52778],
    108: [0, 0.69444, 0, 0, 0.27778],
    109: [0, 0.43056, 0, 0, 0.83334],
    110: [0, 0.43056, 0, 0, 0.55556],
    111: [0, 0.43056, 0, 0, 0.5],
    112: [0.19444, 0.43056, 0, 0, 0.55556],
    113: [0.19444, 0.43056, 0, 0, 0.52778],
    114: [0, 0.43056, 0, 0, 0.39167],
    115: [0, 0.43056, 0, 0, 0.39445],
    116: [0, 0.61508, 0, 0, 0.38889],
    117: [0, 0.43056, 0, 0, 0.55556],
    118: [0, 0.43056, 0.01389, 0, 0.52778],
    119: [0, 0.43056, 0.01389, 0, 0.72222],
    120: [0, 0.43056, 0, 0, 0.52778],
    121: [0.19444, 0.43056, 0.01389, 0, 0.52778],
    122: [0, 0.43056, 0, 0, 0.44445],
    123: [0.25, 0.75, 0, 0, 0.5],
    124: [0.25, 0.75, 0, 0, 0.27778],
    125: [0.25, 0.75, 0, 0, 0.5],
    126: [0.35, 0.31786, 0, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    163: [0, 0.69444, 0, 0, 0.76909],
    167: [0.19444, 0.69444, 0, 0, 0.44445],
    168: [0, 0.66786, 0, 0, 0.5],
    172: [0, 0.43056, 0, 0, 0.66667],
    176: [0, 0.69444, 0, 0, 0.75],
    177: [0.08333, 0.58333, 0, 0, 0.77778],
    182: [0.19444, 0.69444, 0, 0, 0.61111],
    184: [0.17014, 0, 0, 0, 0.44445],
    198: [0, 0.68333, 0, 0, 0.90278],
    215: [0.08333, 0.58333, 0, 0, 0.77778],
    216: [0.04861, 0.73194, 0, 0, 0.77778],
    223: [0, 0.69444, 0, 0, 0.5],
    230: [0, 0.43056, 0, 0, 0.72222],
    247: [0.08333, 0.58333, 0, 0, 0.77778],
    248: [0.09722, 0.52778, 0, 0, 0.5],
    305: [0, 0.43056, 0, 0, 0.27778],
    338: [0, 0.68333, 0, 0, 1.01389],
    339: [0, 0.43056, 0, 0, 0.77778],
    567: [0.19444, 0.43056, 0, 0, 0.30556],
    710: [0, 0.69444, 0, 0, 0.5],
    711: [0, 0.62847, 0, 0, 0.5],
    713: [0, 0.56778, 0, 0, 0.5],
    714: [0, 0.69444, 0, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0, 0, 0.5],
    729: [0, 0.66786, 0, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.75],
    732: [0, 0.66786, 0, 0, 0.5],
    733: [0, 0.69444, 0, 0, 0.5],
    915: [0, 0.68333, 0, 0, 0.625],
    916: [0, 0.68333, 0, 0, 0.83334],
    920: [0, 0.68333, 0, 0, 0.77778],
    923: [0, 0.68333, 0, 0, 0.69445],
    926: [0, 0.68333, 0, 0, 0.66667],
    928: [0, 0.68333, 0, 0, 0.75],
    931: [0, 0.68333, 0, 0, 0.72222],
    933: [0, 0.68333, 0, 0, 0.77778],
    934: [0, 0.68333, 0, 0, 0.72222],
    936: [0, 0.68333, 0, 0, 0.77778],
    937: [0, 0.68333, 0, 0, 0.72222],
    8211: [0, 0.43056, 0.02778, 0, 0.5],
    8212: [0, 0.43056, 0.02778, 0, 1],
    8216: [0, 0.69444, 0, 0, 0.27778],
    8217: [0, 0.69444, 0, 0, 0.27778],
    8220: [0, 0.69444, 0, 0, 0.5],
    8221: [0, 0.69444, 0, 0, 0.5],
    8224: [0.19444, 0.69444, 0, 0, 0.44445],
    8225: [0.19444, 0.69444, 0, 0, 0.44445],
    8230: [0, 0.123, 0, 0, 1.172],
    8242: [0, 0.55556, 0, 0, 0.275],
    8407: [0, 0.71444, 0.15382, 0, 0.5],
    8463: [0, 0.68889, 0, 0, 0.54028],
    8465: [0, 0.69444, 0, 0, 0.72222],
    8467: [0, 0.69444, 0, 0.11111, 0.41667],
    8472: [0.19444, 0.43056, 0, 0.11111, 0.63646],
    8476: [0, 0.69444, 0, 0, 0.72222],
    8501: [0, 0.69444, 0, 0, 0.61111],
    8592: [-0.13313, 0.36687, 0, 0, 1],
    8593: [0.19444, 0.69444, 0, 0, 0.5],
    8594: [-0.13313, 0.36687, 0, 0, 1],
    8595: [0.19444, 0.69444, 0, 0, 0.5],
    8596: [-0.13313, 0.36687, 0, 0, 1],
    8597: [0.25, 0.75, 0, 0, 0.5],
    8598: [0.19444, 0.69444, 0, 0, 1],
    8599: [0.19444, 0.69444, 0, 0, 1],
    8600: [0.19444, 0.69444, 0, 0, 1],
    8601: [0.19444, 0.69444, 0, 0, 1],
    8614: [0.011, 0.511, 0, 0, 1],
    8617: [0.011, 0.511, 0, 0, 1.126],
    8618: [0.011, 0.511, 0, 0, 1.126],
    8636: [-0.13313, 0.36687, 0, 0, 1],
    8637: [-0.13313, 0.36687, 0, 0, 1],
    8640: [-0.13313, 0.36687, 0, 0, 1],
    8641: [-0.13313, 0.36687, 0, 0, 1],
    8652: [0.011, 0.671, 0, 0, 1],
    8656: [-0.13313, 0.36687, 0, 0, 1],
    8657: [0.19444, 0.69444, 0, 0, 0.61111],
    8658: [-0.13313, 0.36687, 0, 0, 1],
    8659: [0.19444, 0.69444, 0, 0, 0.61111],
    8660: [-0.13313, 0.36687, 0, 0, 1],
    8661: [0.25, 0.75, 0, 0, 0.61111],
    8704: [0, 0.69444, 0, 0, 0.55556],
    8706: [0, 0.69444, 0.05556, 0.08334, 0.5309],
    8707: [0, 0.69444, 0, 0, 0.55556],
    8709: [0.05556, 0.75, 0, 0, 0.5],
    8711: [0, 0.68333, 0, 0, 0.83334],
    8712: [0.0391, 0.5391, 0, 0, 0.66667],
    8715: [0.0391, 0.5391, 0, 0, 0.66667],
    8722: [0.08333, 0.58333, 0, 0, 0.77778],
    8723: [0.08333, 0.58333, 0, 0, 0.77778],
    8725: [0.25, 0.75, 0, 0, 0.5],
    8726: [0.25, 0.75, 0, 0, 0.5],
    8727: [-0.03472, 0.46528, 0, 0, 0.5],
    8728: [-0.05555, 0.44445, 0, 0, 0.5],
    8729: [-0.05555, 0.44445, 0, 0, 0.5],
    8730: [0.2, 0.8, 0, 0, 0.83334],
    8733: [0, 0.43056, 0, 0, 0.77778],
    8734: [0, 0.43056, 0, 0, 1],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8739: [0.25, 0.75, 0, 0, 0.27778],
    8741: [0.25, 0.75, 0, 0, 0.5],
    8743: [0, 0.55556, 0, 0, 0.66667],
    8744: [0, 0.55556, 0, 0, 0.66667],
    8745: [0, 0.55556, 0, 0, 0.66667],
    8746: [0, 0.55556, 0, 0, 0.66667],
    8747: [0.19444, 0.69444, 0.11111, 0, 0.41667],
    8764: [-0.13313, 0.36687, 0, 0, 0.77778],
    8768: [0.19444, 0.69444, 0, 0, 0.27778],
    8771: [-0.03625, 0.46375, 0, 0, 0.77778],
    8773: [-0.022, 0.589, 0, 0, 0.778],
    8776: [-0.01688, 0.48312, 0, 0, 0.77778],
    8781: [-0.03625, 0.46375, 0, 0, 0.77778],
    8784: [-0.133, 0.673, 0, 0, 0.778],
    8801: [-0.03625, 0.46375, 0, 0, 0.77778],
    8804: [0.13597, 0.63597, 0, 0, 0.77778],
    8805: [0.13597, 0.63597, 0, 0, 0.77778],
    8810: [0.0391, 0.5391, 0, 0, 1],
    8811: [0.0391, 0.5391, 0, 0, 1],
    8826: [0.0391, 0.5391, 0, 0, 0.77778],
    8827: [0.0391, 0.5391, 0, 0, 0.77778],
    8834: [0.0391, 0.5391, 0, 0, 0.77778],
    8835: [0.0391, 0.5391, 0, 0, 0.77778],
    8838: [0.13597, 0.63597, 0, 0, 0.77778],
    8839: [0.13597, 0.63597, 0, 0, 0.77778],
    8846: [0, 0.55556, 0, 0, 0.66667],
    8849: [0.13597, 0.63597, 0, 0, 0.77778],
    8850: [0.13597, 0.63597, 0, 0, 0.77778],
    8851: [0, 0.55556, 0, 0, 0.66667],
    8852: [0, 0.55556, 0, 0, 0.66667],
    8853: [0.08333, 0.58333, 0, 0, 0.77778],
    8854: [0.08333, 0.58333, 0, 0, 0.77778],
    8855: [0.08333, 0.58333, 0, 0, 0.77778],
    8856: [0.08333, 0.58333, 0, 0, 0.77778],
    8857: [0.08333, 0.58333, 0, 0, 0.77778],
    8866: [0, 0.69444, 0, 0, 0.61111],
    8867: [0, 0.69444, 0, 0, 0.61111],
    8868: [0, 0.69444, 0, 0, 0.77778],
    8869: [0, 0.69444, 0, 0, 0.77778],
    8872: [0.249, 0.75, 0, 0, 0.867],
    8900: [-0.05555, 0.44445, 0, 0, 0.5],
    8901: [-0.05555, 0.44445, 0, 0, 0.27778],
    8902: [-0.03472, 0.46528, 0, 0, 0.5],
    8904: [5e-3, 0.505, 0, 0, 0.9],
    8942: [0.03, 0.903, 0, 0, 0.278],
    8943: [-0.19, 0.313, 0, 0, 1.172],
    8945: [-0.1, 0.823, 0, 0, 1.282],
    8968: [0.25, 0.75, 0, 0, 0.44445],
    8969: [0.25, 0.75, 0, 0, 0.44445],
    8970: [0.25, 0.75, 0, 0, 0.44445],
    8971: [0.25, 0.75, 0, 0, 0.44445],
    8994: [-0.14236, 0.35764, 0, 0, 1],
    8995: [-0.14236, 0.35764, 0, 0, 1],
    9136: [0.244, 0.744, 0, 0, 0.412],
    9137: [0.244, 0.745, 0, 0, 0.412],
    9651: [0.19444, 0.69444, 0, 0, 0.88889],
    9657: [-0.03472, 0.46528, 0, 0, 0.5],
    9661: [0.19444, 0.69444, 0, 0, 0.88889],
    9667: [-0.03472, 0.46528, 0, 0, 0.5],
    9711: [0.19444, 0.69444, 0, 0, 1],
    9824: [0.12963, 0.69444, 0, 0, 0.77778],
    9825: [0.12963, 0.69444, 0, 0, 0.77778],
    9826: [0.12963, 0.69444, 0, 0, 0.77778],
    9827: [0.12963, 0.69444, 0, 0, 0.77778],
    9837: [0, 0.75, 0, 0, 0.38889],
    9838: [0.19444, 0.69444, 0, 0, 0.38889],
    9839: [0.19444, 0.69444, 0, 0, 0.38889],
    10216: [0.25, 0.75, 0, 0, 0.38889],
    10217: [0.25, 0.75, 0, 0, 0.38889],
    10222: [0.244, 0.744, 0, 0, 0.412],
    10223: [0.244, 0.745, 0, 0, 0.412],
    10229: [0.011, 0.511, 0, 0, 1.609],
    10230: [0.011, 0.511, 0, 0, 1.638],
    10231: [0.011, 0.511, 0, 0, 1.859],
    10232: [0.024, 0.525, 0, 0, 1.609],
    10233: [0.024, 0.525, 0, 0, 1.638],
    10234: [0.024, 0.525, 0, 0, 1.858],
    10236: [0.011, 0.511, 0, 0, 1.638],
    10815: [0, 0.68333, 0, 0, 0.75],
    10927: [0.13597, 0.63597, 0, 0, 0.77778],
    10928: [0.13597, 0.63597, 0, 0, 0.77778],
    57376: [0.19444, 0.69444, 0, 0, 0]
  },
  "Math-BoldItalic": {
    32: [0, 0, 0, 0, 0.25],
    48: [0, 0.44444, 0, 0, 0.575],
    49: [0, 0.44444, 0, 0, 0.575],
    50: [0, 0.44444, 0, 0, 0.575],
    51: [0.19444, 0.44444, 0, 0, 0.575],
    52: [0.19444, 0.44444, 0, 0, 0.575],
    53: [0.19444, 0.44444, 0, 0, 0.575],
    54: [0, 0.64444, 0, 0, 0.575],
    55: [0.19444, 0.44444, 0, 0, 0.575],
    56: [0, 0.64444, 0, 0, 0.575],
    57: [0.19444, 0.44444, 0, 0, 0.575],
    65: [0, 0.68611, 0, 0, 0.86944],
    66: [0, 0.68611, 0.04835, 0, 0.8664],
    67: [0, 0.68611, 0.06979, 0, 0.81694],
    68: [0, 0.68611, 0.03194, 0, 0.93812],
    69: [0, 0.68611, 0.05451, 0, 0.81007],
    70: [0, 0.68611, 0.15972, 0, 0.68889],
    71: [0, 0.68611, 0, 0, 0.88673],
    72: [0, 0.68611, 0.08229, 0, 0.98229],
    73: [0, 0.68611, 0.07778, 0, 0.51111],
    74: [0, 0.68611, 0.10069, 0, 0.63125],
    75: [0, 0.68611, 0.06979, 0, 0.97118],
    76: [0, 0.68611, 0, 0, 0.75555],
    77: [0, 0.68611, 0.11424, 0, 1.14201],
    78: [0, 0.68611, 0.11424, 0, 0.95034],
    79: [0, 0.68611, 0.03194, 0, 0.83666],
    80: [0, 0.68611, 0.15972, 0, 0.72309],
    81: [0.19444, 0.68611, 0, 0, 0.86861],
    82: [0, 0.68611, 421e-5, 0, 0.87235],
    83: [0, 0.68611, 0.05382, 0, 0.69271],
    84: [0, 0.68611, 0.15972, 0, 0.63663],
    85: [0, 0.68611, 0.11424, 0, 0.80027],
    86: [0, 0.68611, 0.25555, 0, 0.67778],
    87: [0, 0.68611, 0.15972, 0, 1.09305],
    88: [0, 0.68611, 0.07778, 0, 0.94722],
    89: [0, 0.68611, 0.25555, 0, 0.67458],
    90: [0, 0.68611, 0.06979, 0, 0.77257],
    97: [0, 0.44444, 0, 0, 0.63287],
    98: [0, 0.69444, 0, 0, 0.52083],
    99: [0, 0.44444, 0, 0, 0.51342],
    100: [0, 0.69444, 0, 0, 0.60972],
    101: [0, 0.44444, 0, 0, 0.55361],
    102: [0.19444, 0.69444, 0.11042, 0, 0.56806],
    103: [0.19444, 0.44444, 0.03704, 0, 0.5449],
    104: [0, 0.69444, 0, 0, 0.66759],
    105: [0, 0.69326, 0, 0, 0.4048],
    106: [0.19444, 0.69326, 0.0622, 0, 0.47083],
    107: [0, 0.69444, 0.01852, 0, 0.6037],
    108: [0, 0.69444, 88e-4, 0, 0.34815],
    109: [0, 0.44444, 0, 0, 1.0324],
    110: [0, 0.44444, 0, 0, 0.71296],
    111: [0, 0.44444, 0, 0, 0.58472],
    112: [0.19444, 0.44444, 0, 0, 0.60092],
    113: [0.19444, 0.44444, 0.03704, 0, 0.54213],
    114: [0, 0.44444, 0.03194, 0, 0.5287],
    115: [0, 0.44444, 0, 0, 0.53125],
    116: [0, 0.63492, 0, 0, 0.41528],
    117: [0, 0.44444, 0, 0, 0.68102],
    118: [0, 0.44444, 0.03704, 0, 0.56666],
    119: [0, 0.44444, 0.02778, 0, 0.83148],
    120: [0, 0.44444, 0, 0, 0.65903],
    121: [0.19444, 0.44444, 0.03704, 0, 0.59028],
    122: [0, 0.44444, 0.04213, 0, 0.55509],
    160: [0, 0, 0, 0, 0.25],
    915: [0, 0.68611, 0.15972, 0, 0.65694],
    916: [0, 0.68611, 0, 0, 0.95833],
    920: [0, 0.68611, 0.03194, 0, 0.86722],
    923: [0, 0.68611, 0, 0, 0.80555],
    926: [0, 0.68611, 0.07458, 0, 0.84125],
    928: [0, 0.68611, 0.08229, 0, 0.98229],
    931: [0, 0.68611, 0.05451, 0, 0.88507],
    933: [0, 0.68611, 0.15972, 0, 0.67083],
    934: [0, 0.68611, 0, 0, 0.76666],
    936: [0, 0.68611, 0.11653, 0, 0.71402],
    937: [0, 0.68611, 0.04835, 0, 0.8789],
    945: [0, 0.44444, 0, 0, 0.76064],
    946: [0.19444, 0.69444, 0.03403, 0, 0.65972],
    947: [0.19444, 0.44444, 0.06389, 0, 0.59003],
    948: [0, 0.69444, 0.03819, 0, 0.52222],
    949: [0, 0.44444, 0, 0, 0.52882],
    950: [0.19444, 0.69444, 0.06215, 0, 0.50833],
    951: [0.19444, 0.44444, 0.03704, 0, 0.6],
    952: [0, 0.69444, 0.03194, 0, 0.5618],
    953: [0, 0.44444, 0, 0, 0.41204],
    954: [0, 0.44444, 0, 0, 0.66759],
    955: [0, 0.69444, 0, 0, 0.67083],
    956: [0.19444, 0.44444, 0, 0, 0.70787],
    957: [0, 0.44444, 0.06898, 0, 0.57685],
    958: [0.19444, 0.69444, 0.03021, 0, 0.50833],
    959: [0, 0.44444, 0, 0, 0.58472],
    960: [0, 0.44444, 0.03704, 0, 0.68241],
    961: [0.19444, 0.44444, 0, 0, 0.6118],
    962: [0.09722, 0.44444, 0.07917, 0, 0.42361],
    963: [0, 0.44444, 0.03704, 0, 0.68588],
    964: [0, 0.44444, 0.13472, 0, 0.52083],
    965: [0, 0.44444, 0.03704, 0, 0.63055],
    966: [0.19444, 0.44444, 0, 0, 0.74722],
    967: [0.19444, 0.44444, 0, 0, 0.71805],
    968: [0.19444, 0.69444, 0.03704, 0, 0.75833],
    969: [0, 0.44444, 0.03704, 0, 0.71782],
    977: [0, 0.69444, 0, 0, 0.69155],
    981: [0.19444, 0.69444, 0, 0, 0.7125],
    982: [0, 0.44444, 0.03194, 0, 0.975],
    1009: [0.19444, 0.44444, 0, 0, 0.6118],
    1013: [0, 0.44444, 0, 0, 0.48333],
    57649: [0, 0.44444, 0, 0, 0.39352],
    57911: [0.19444, 0.44444, 0, 0, 0.43889]
  },
  "Math-Italic": {
    32: [0, 0, 0, 0, 0.25],
    48: [0, 0.43056, 0, 0, 0.5],
    49: [0, 0.43056, 0, 0, 0.5],
    50: [0, 0.43056, 0, 0, 0.5],
    51: [0.19444, 0.43056, 0, 0, 0.5],
    52: [0.19444, 0.43056, 0, 0, 0.5],
    53: [0.19444, 0.43056, 0, 0, 0.5],
    54: [0, 0.64444, 0, 0, 0.5],
    55: [0.19444, 0.43056, 0, 0, 0.5],
    56: [0, 0.64444, 0, 0, 0.5],
    57: [0.19444, 0.43056, 0, 0, 0.5],
    65: [0, 0.68333, 0, 0.13889, 0.75],
    66: [0, 0.68333, 0.05017, 0.08334, 0.75851],
    67: [0, 0.68333, 0.07153, 0.08334, 0.71472],
    68: [0, 0.68333, 0.02778, 0.05556, 0.82792],
    69: [0, 0.68333, 0.05764, 0.08334, 0.7382],
    70: [0, 0.68333, 0.13889, 0.08334, 0.64306],
    71: [0, 0.68333, 0, 0.08334, 0.78625],
    72: [0, 0.68333, 0.08125, 0.05556, 0.83125],
    73: [0, 0.68333, 0.07847, 0.11111, 0.43958],
    74: [0, 0.68333, 0.09618, 0.16667, 0.55451],
    75: [0, 0.68333, 0.07153, 0.05556, 0.84931],
    76: [0, 0.68333, 0, 0.02778, 0.68056],
    77: [0, 0.68333, 0.10903, 0.08334, 0.97014],
    78: [0, 0.68333, 0.10903, 0.08334, 0.80347],
    79: [0, 0.68333, 0.02778, 0.08334, 0.76278],
    80: [0, 0.68333, 0.13889, 0.08334, 0.64201],
    81: [0.19444, 0.68333, 0, 0.08334, 0.79056],
    82: [0, 0.68333, 773e-5, 0.08334, 0.75929],
    83: [0, 0.68333, 0.05764, 0.08334, 0.6132],
    84: [0, 0.68333, 0.13889, 0.08334, 0.58438],
    85: [0, 0.68333, 0.10903, 0.02778, 0.68278],
    86: [0, 0.68333, 0.22222, 0, 0.58333],
    87: [0, 0.68333, 0.13889, 0, 0.94445],
    88: [0, 0.68333, 0.07847, 0.08334, 0.82847],
    89: [0, 0.68333, 0.22222, 0, 0.58056],
    90: [0, 0.68333, 0.07153, 0.08334, 0.68264],
    97: [0, 0.43056, 0, 0, 0.52859],
    98: [0, 0.69444, 0, 0, 0.42917],
    99: [0, 0.43056, 0, 0.05556, 0.43276],
    100: [0, 0.69444, 0, 0.16667, 0.52049],
    101: [0, 0.43056, 0, 0.05556, 0.46563],
    102: [0.19444, 0.69444, 0.10764, 0.16667, 0.48959],
    103: [0.19444, 0.43056, 0.03588, 0.02778, 0.47697],
    104: [0, 0.69444, 0, 0, 0.57616],
    105: [0, 0.65952, 0, 0, 0.34451],
    106: [0.19444, 0.65952, 0.05724, 0, 0.41181],
    107: [0, 0.69444, 0.03148, 0, 0.5206],
    108: [0, 0.69444, 0.01968, 0.08334, 0.29838],
    109: [0, 0.43056, 0, 0, 0.87801],
    110: [0, 0.43056, 0, 0, 0.60023],
    111: [0, 0.43056, 0, 0.05556, 0.48472],
    112: [0.19444, 0.43056, 0, 0.08334, 0.50313],
    113: [0.19444, 0.43056, 0.03588, 0.08334, 0.44641],
    114: [0, 0.43056, 0.02778, 0.05556, 0.45116],
    115: [0, 0.43056, 0, 0.05556, 0.46875],
    116: [0, 0.61508, 0, 0.08334, 0.36111],
    117: [0, 0.43056, 0, 0.02778, 0.57246],
    118: [0, 0.43056, 0.03588, 0.02778, 0.48472],
    119: [0, 0.43056, 0.02691, 0.08334, 0.71592],
    120: [0, 0.43056, 0, 0.02778, 0.57153],
    121: [0.19444, 0.43056, 0.03588, 0.05556, 0.49028],
    122: [0, 0.43056, 0.04398, 0.05556, 0.46505],
    160: [0, 0, 0, 0, 0.25],
    915: [0, 0.68333, 0.13889, 0.08334, 0.61528],
    916: [0, 0.68333, 0, 0.16667, 0.83334],
    920: [0, 0.68333, 0.02778, 0.08334, 0.76278],
    923: [0, 0.68333, 0, 0.16667, 0.69445],
    926: [0, 0.68333, 0.07569, 0.08334, 0.74236],
    928: [0, 0.68333, 0.08125, 0.05556, 0.83125],
    931: [0, 0.68333, 0.05764, 0.08334, 0.77986],
    933: [0, 0.68333, 0.13889, 0.05556, 0.58333],
    934: [0, 0.68333, 0, 0.08334, 0.66667],
    936: [0, 0.68333, 0.11, 0.05556, 0.61222],
    937: [0, 0.68333, 0.05017, 0.08334, 0.7724],
    945: [0, 0.43056, 37e-4, 0.02778, 0.6397],
    946: [0.19444, 0.69444, 0.05278, 0.08334, 0.56563],
    947: [0.19444, 0.43056, 0.05556, 0, 0.51773],
    948: [0, 0.69444, 0.03785, 0.05556, 0.44444],
    949: [0, 0.43056, 0, 0.08334, 0.46632],
    950: [0.19444, 0.69444, 0.07378, 0.08334, 0.4375],
    951: [0.19444, 0.43056, 0.03588, 0.05556, 0.49653],
    952: [0, 0.69444, 0.02778, 0.08334, 0.46944],
    953: [0, 0.43056, 0, 0.05556, 0.35394],
    954: [0, 0.43056, 0, 0, 0.57616],
    955: [0, 0.69444, 0, 0, 0.58334],
    956: [0.19444, 0.43056, 0, 0.02778, 0.60255],
    957: [0, 0.43056, 0.06366, 0.02778, 0.49398],
    958: [0.19444, 0.69444, 0.04601, 0.11111, 0.4375],
    959: [0, 0.43056, 0, 0.05556, 0.48472],
    960: [0, 0.43056, 0.03588, 0, 0.57003],
    961: [0.19444, 0.43056, 0, 0.08334, 0.51702],
    962: [0.09722, 0.43056, 0.07986, 0.08334, 0.36285],
    963: [0, 0.43056, 0.03588, 0, 0.57141],
    964: [0, 0.43056, 0.1132, 0.02778, 0.43715],
    965: [0, 0.43056, 0.03588, 0.02778, 0.54028],
    966: [0.19444, 0.43056, 0, 0.08334, 0.65417],
    967: [0.19444, 0.43056, 0, 0.05556, 0.62569],
    968: [0.19444, 0.69444, 0.03588, 0.11111, 0.65139],
    969: [0, 0.43056, 0.03588, 0, 0.62245],
    977: [0, 0.69444, 0, 0.08334, 0.59144],
    981: [0.19444, 0.69444, 0, 0.08334, 0.59583],
    982: [0, 0.43056, 0.02778, 0, 0.82813],
    1009: [0.19444, 0.43056, 0, 0.08334, 0.51702],
    1013: [0, 0.43056, 0, 0.05556, 0.4059],
    57649: [0, 0.43056, 0, 0.02778, 0.32246],
    57911: [0.19444, 0.43056, 0, 0.08334, 0.38403]
  },
  "SansSerif-Bold": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.36667],
    34: [0, 0.69444, 0, 0, 0.55834],
    35: [0.19444, 0.69444, 0, 0, 0.91667],
    36: [0.05556, 0.75, 0, 0, 0.55],
    37: [0.05556, 0.75, 0, 0, 1.02912],
    38: [0, 0.69444, 0, 0, 0.83056],
    39: [0, 0.69444, 0, 0, 0.30556],
    40: [0.25, 0.75, 0, 0, 0.42778],
    41: [0.25, 0.75, 0, 0, 0.42778],
    42: [0, 0.75, 0, 0, 0.55],
    43: [0.11667, 0.61667, 0, 0, 0.85556],
    44: [0.10556, 0.13056, 0, 0, 0.30556],
    45: [0, 0.45833, 0, 0, 0.36667],
    46: [0, 0.13056, 0, 0, 0.30556],
    47: [0.25, 0.75, 0, 0, 0.55],
    48: [0, 0.69444, 0, 0, 0.55],
    49: [0, 0.69444, 0, 0, 0.55],
    50: [0, 0.69444, 0, 0, 0.55],
    51: [0, 0.69444, 0, 0, 0.55],
    52: [0, 0.69444, 0, 0, 0.55],
    53: [0, 0.69444, 0, 0, 0.55],
    54: [0, 0.69444, 0, 0, 0.55],
    55: [0, 0.69444, 0, 0, 0.55],
    56: [0, 0.69444, 0, 0, 0.55],
    57: [0, 0.69444, 0, 0, 0.55],
    58: [0, 0.45833, 0, 0, 0.30556],
    59: [0.10556, 0.45833, 0, 0, 0.30556],
    61: [-0.09375, 0.40625, 0, 0, 0.85556],
    63: [0, 0.69444, 0, 0, 0.51945],
    64: [0, 0.69444, 0, 0, 0.73334],
    65: [0, 0.69444, 0, 0, 0.73334],
    66: [0, 0.69444, 0, 0, 0.73334],
    67: [0, 0.69444, 0, 0, 0.70278],
    68: [0, 0.69444, 0, 0, 0.79445],
    69: [0, 0.69444, 0, 0, 0.64167],
    70: [0, 0.69444, 0, 0, 0.61111],
    71: [0, 0.69444, 0, 0, 0.73334],
    72: [0, 0.69444, 0, 0, 0.79445],
    73: [0, 0.69444, 0, 0, 0.33056],
    74: [0, 0.69444, 0, 0, 0.51945],
    75: [0, 0.69444, 0, 0, 0.76389],
    76: [0, 0.69444, 0, 0, 0.58056],
    77: [0, 0.69444, 0, 0, 0.97778],
    78: [0, 0.69444, 0, 0, 0.79445],
    79: [0, 0.69444, 0, 0, 0.79445],
    80: [0, 0.69444, 0, 0, 0.70278],
    81: [0.10556, 0.69444, 0, 0, 0.79445],
    82: [0, 0.69444, 0, 0, 0.70278],
    83: [0, 0.69444, 0, 0, 0.61111],
    84: [0, 0.69444, 0, 0, 0.73334],
    85: [0, 0.69444, 0, 0, 0.76389],
    86: [0, 0.69444, 0.01528, 0, 0.73334],
    87: [0, 0.69444, 0.01528, 0, 1.03889],
    88: [0, 0.69444, 0, 0, 0.73334],
    89: [0, 0.69444, 0.0275, 0, 0.73334],
    90: [0, 0.69444, 0, 0, 0.67223],
    91: [0.25, 0.75, 0, 0, 0.34306],
    93: [0.25, 0.75, 0, 0, 0.34306],
    94: [0, 0.69444, 0, 0, 0.55],
    95: [0.35, 0.10833, 0.03056, 0, 0.55],
    97: [0, 0.45833, 0, 0, 0.525],
    98: [0, 0.69444, 0, 0, 0.56111],
    99: [0, 0.45833, 0, 0, 0.48889],
    100: [0, 0.69444, 0, 0, 0.56111],
    101: [0, 0.45833, 0, 0, 0.51111],
    102: [0, 0.69444, 0.07639, 0, 0.33611],
    103: [0.19444, 0.45833, 0.01528, 0, 0.55],
    104: [0, 0.69444, 0, 0, 0.56111],
    105: [0, 0.69444, 0, 0, 0.25556],
    106: [0.19444, 0.69444, 0, 0, 0.28611],
    107: [0, 0.69444, 0, 0, 0.53056],
    108: [0, 0.69444, 0, 0, 0.25556],
    109: [0, 0.45833, 0, 0, 0.86667],
    110: [0, 0.45833, 0, 0, 0.56111],
    111: [0, 0.45833, 0, 0, 0.55],
    112: [0.19444, 0.45833, 0, 0, 0.56111],
    113: [0.19444, 0.45833, 0, 0, 0.56111],
    114: [0, 0.45833, 0.01528, 0, 0.37222],
    115: [0, 0.45833, 0, 0, 0.42167],
    116: [0, 0.58929, 0, 0, 0.40417],
    117: [0, 0.45833, 0, 0, 0.56111],
    118: [0, 0.45833, 0.01528, 0, 0.5],
    119: [0, 0.45833, 0.01528, 0, 0.74445],
    120: [0, 0.45833, 0, 0, 0.5],
    121: [0.19444, 0.45833, 0.01528, 0, 0.5],
    122: [0, 0.45833, 0, 0, 0.47639],
    126: [0.35, 0.34444, 0, 0, 0.55],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.69444, 0, 0, 0.55],
    176: [0, 0.69444, 0, 0, 0.73334],
    180: [0, 0.69444, 0, 0, 0.55],
    184: [0.17014, 0, 0, 0, 0.48889],
    305: [0, 0.45833, 0, 0, 0.25556],
    567: [0.19444, 0.45833, 0, 0, 0.28611],
    710: [0, 0.69444, 0, 0, 0.55],
    711: [0, 0.63542, 0, 0, 0.55],
    713: [0, 0.63778, 0, 0, 0.55],
    728: [0, 0.69444, 0, 0, 0.55],
    729: [0, 0.69444, 0, 0, 0.30556],
    730: [0, 0.69444, 0, 0, 0.73334],
    732: [0, 0.69444, 0, 0, 0.55],
    733: [0, 0.69444, 0, 0, 0.55],
    915: [0, 0.69444, 0, 0, 0.58056],
    916: [0, 0.69444, 0, 0, 0.91667],
    920: [0, 0.69444, 0, 0, 0.85556],
    923: [0, 0.69444, 0, 0, 0.67223],
    926: [0, 0.69444, 0, 0, 0.73334],
    928: [0, 0.69444, 0, 0, 0.79445],
    931: [0, 0.69444, 0, 0, 0.79445],
    933: [0, 0.69444, 0, 0, 0.85556],
    934: [0, 0.69444, 0, 0, 0.79445],
    936: [0, 0.69444, 0, 0, 0.85556],
    937: [0, 0.69444, 0, 0, 0.79445],
    8211: [0, 0.45833, 0.03056, 0, 0.55],
    8212: [0, 0.45833, 0.03056, 0, 1.10001],
    8216: [0, 0.69444, 0, 0, 0.30556],
    8217: [0, 0.69444, 0, 0, 0.30556],
    8220: [0, 0.69444, 0, 0, 0.55834],
    8221: [0, 0.69444, 0, 0, 0.55834]
  },
  "SansSerif-Italic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.05733, 0, 0.31945],
    34: [0, 0.69444, 316e-5, 0, 0.5],
    35: [0.19444, 0.69444, 0.05087, 0, 0.83334],
    36: [0.05556, 0.75, 0.11156, 0, 0.5],
    37: [0.05556, 0.75, 0.03126, 0, 0.83334],
    38: [0, 0.69444, 0.03058, 0, 0.75834],
    39: [0, 0.69444, 0.07816, 0, 0.27778],
    40: [0.25, 0.75, 0.13164, 0, 0.38889],
    41: [0.25, 0.75, 0.02536, 0, 0.38889],
    42: [0, 0.75, 0.11775, 0, 0.5],
    43: [0.08333, 0.58333, 0.02536, 0, 0.77778],
    44: [0.125, 0.08333, 0, 0, 0.27778],
    45: [0, 0.44444, 0.01946, 0, 0.33333],
    46: [0, 0.08333, 0, 0, 0.27778],
    47: [0.25, 0.75, 0.13164, 0, 0.5],
    48: [0, 0.65556, 0.11156, 0, 0.5],
    49: [0, 0.65556, 0.11156, 0, 0.5],
    50: [0, 0.65556, 0.11156, 0, 0.5],
    51: [0, 0.65556, 0.11156, 0, 0.5],
    52: [0, 0.65556, 0.11156, 0, 0.5],
    53: [0, 0.65556, 0.11156, 0, 0.5],
    54: [0, 0.65556, 0.11156, 0, 0.5],
    55: [0, 0.65556, 0.11156, 0, 0.5],
    56: [0, 0.65556, 0.11156, 0, 0.5],
    57: [0, 0.65556, 0.11156, 0, 0.5],
    58: [0, 0.44444, 0.02502, 0, 0.27778],
    59: [0.125, 0.44444, 0.02502, 0, 0.27778],
    61: [-0.13, 0.37, 0.05087, 0, 0.77778],
    63: [0, 0.69444, 0.11809, 0, 0.47222],
    64: [0, 0.69444, 0.07555, 0, 0.66667],
    65: [0, 0.69444, 0, 0, 0.66667],
    66: [0, 0.69444, 0.08293, 0, 0.66667],
    67: [0, 0.69444, 0.11983, 0, 0.63889],
    68: [0, 0.69444, 0.07555, 0, 0.72223],
    69: [0, 0.69444, 0.11983, 0, 0.59722],
    70: [0, 0.69444, 0.13372, 0, 0.56945],
    71: [0, 0.69444, 0.11983, 0, 0.66667],
    72: [0, 0.69444, 0.08094, 0, 0.70834],
    73: [0, 0.69444, 0.13372, 0, 0.27778],
    74: [0, 0.69444, 0.08094, 0, 0.47222],
    75: [0, 0.69444, 0.11983, 0, 0.69445],
    76: [0, 0.69444, 0, 0, 0.54167],
    77: [0, 0.69444, 0.08094, 0, 0.875],
    78: [0, 0.69444, 0.08094, 0, 0.70834],
    79: [0, 0.69444, 0.07555, 0, 0.73611],
    80: [0, 0.69444, 0.08293, 0, 0.63889],
    81: [0.125, 0.69444, 0.07555, 0, 0.73611],
    82: [0, 0.69444, 0.08293, 0, 0.64584],
    83: [0, 0.69444, 0.09205, 0, 0.55556],
    84: [0, 0.69444, 0.13372, 0, 0.68056],
    85: [0, 0.69444, 0.08094, 0, 0.6875],
    86: [0, 0.69444, 0.1615, 0, 0.66667],
    87: [0, 0.69444, 0.1615, 0, 0.94445],
    88: [0, 0.69444, 0.13372, 0, 0.66667],
    89: [0, 0.69444, 0.17261, 0, 0.66667],
    90: [0, 0.69444, 0.11983, 0, 0.61111],
    91: [0.25, 0.75, 0.15942, 0, 0.28889],
    93: [0.25, 0.75, 0.08719, 0, 0.28889],
    94: [0, 0.69444, 0.0799, 0, 0.5],
    95: [0.35, 0.09444, 0.08616, 0, 0.5],
    97: [0, 0.44444, 981e-5, 0, 0.48056],
    98: [0, 0.69444, 0.03057, 0, 0.51667],
    99: [0, 0.44444, 0.08336, 0, 0.44445],
    100: [0, 0.69444, 0.09483, 0, 0.51667],
    101: [0, 0.44444, 0.06778, 0, 0.44445],
    102: [0, 0.69444, 0.21705, 0, 0.30556],
    103: [0.19444, 0.44444, 0.10836, 0, 0.5],
    104: [0, 0.69444, 0.01778, 0, 0.51667],
    105: [0, 0.67937, 0.09718, 0, 0.23889],
    106: [0.19444, 0.67937, 0.09162, 0, 0.26667],
    107: [0, 0.69444, 0.08336, 0, 0.48889],
    108: [0, 0.69444, 0.09483, 0, 0.23889],
    109: [0, 0.44444, 0.01778, 0, 0.79445],
    110: [0, 0.44444, 0.01778, 0, 0.51667],
    111: [0, 0.44444, 0.06613, 0, 0.5],
    112: [0.19444, 0.44444, 0.0389, 0, 0.51667],
    113: [0.19444, 0.44444, 0.04169, 0, 0.51667],
    114: [0, 0.44444, 0.10836, 0, 0.34167],
    115: [0, 0.44444, 0.0778, 0, 0.38333],
    116: [0, 0.57143, 0.07225, 0, 0.36111],
    117: [0, 0.44444, 0.04169, 0, 0.51667],
    118: [0, 0.44444, 0.10836, 0, 0.46111],
    119: [0, 0.44444, 0.10836, 0, 0.68334],
    120: [0, 0.44444, 0.09169, 0, 0.46111],
    121: [0.19444, 0.44444, 0.10836, 0, 0.46111],
    122: [0, 0.44444, 0.08752, 0, 0.43472],
    126: [0.35, 0.32659, 0.08826, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.67937, 0.06385, 0, 0.5],
    176: [0, 0.69444, 0, 0, 0.73752],
    184: [0.17014, 0, 0, 0, 0.44445],
    305: [0, 0.44444, 0.04169, 0, 0.23889],
    567: [0.19444, 0.44444, 0.04169, 0, 0.26667],
    710: [0, 0.69444, 0.0799, 0, 0.5],
    711: [0, 0.63194, 0.08432, 0, 0.5],
    713: [0, 0.60889, 0.08776, 0, 0.5],
    714: [0, 0.69444, 0.09205, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0.09483, 0, 0.5],
    729: [0, 0.67937, 0.07774, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.73752],
    732: [0, 0.67659, 0.08826, 0, 0.5],
    733: [0, 0.69444, 0.09205, 0, 0.5],
    915: [0, 0.69444, 0.13372, 0, 0.54167],
    916: [0, 0.69444, 0, 0, 0.83334],
    920: [0, 0.69444, 0.07555, 0, 0.77778],
    923: [0, 0.69444, 0, 0, 0.61111],
    926: [0, 0.69444, 0.12816, 0, 0.66667],
    928: [0, 0.69444, 0.08094, 0, 0.70834],
    931: [0, 0.69444, 0.11983, 0, 0.72222],
    933: [0, 0.69444, 0.09031, 0, 0.77778],
    934: [0, 0.69444, 0.04603, 0, 0.72222],
    936: [0, 0.69444, 0.09031, 0, 0.77778],
    937: [0, 0.69444, 0.08293, 0, 0.72222],
    8211: [0, 0.44444, 0.08616, 0, 0.5],
    8212: [0, 0.44444, 0.08616, 0, 1],
    8216: [0, 0.69444, 0.07816, 0, 0.27778],
    8217: [0, 0.69444, 0.07816, 0, 0.27778],
    8220: [0, 0.69444, 0.14205, 0, 0.5],
    8221: [0, 0.69444, 316e-5, 0, 0.5]
  },
  "SansSerif-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.31945],
    34: [0, 0.69444, 0, 0, 0.5],
    35: [0.19444, 0.69444, 0, 0, 0.83334],
    36: [0.05556, 0.75, 0, 0, 0.5],
    37: [0.05556, 0.75, 0, 0, 0.83334],
    38: [0, 0.69444, 0, 0, 0.75834],
    39: [0, 0.69444, 0, 0, 0.27778],
    40: [0.25, 0.75, 0, 0, 0.38889],
    41: [0.25, 0.75, 0, 0, 0.38889],
    42: [0, 0.75, 0, 0, 0.5],
    43: [0.08333, 0.58333, 0, 0, 0.77778],
    44: [0.125, 0.08333, 0, 0, 0.27778],
    45: [0, 0.44444, 0, 0, 0.33333],
    46: [0, 0.08333, 0, 0, 0.27778],
    47: [0.25, 0.75, 0, 0, 0.5],
    48: [0, 0.65556, 0, 0, 0.5],
    49: [0, 0.65556, 0, 0, 0.5],
    50: [0, 0.65556, 0, 0, 0.5],
    51: [0, 0.65556, 0, 0, 0.5],
    52: [0, 0.65556, 0, 0, 0.5],
    53: [0, 0.65556, 0, 0, 0.5],
    54: [0, 0.65556, 0, 0, 0.5],
    55: [0, 0.65556, 0, 0, 0.5],
    56: [0, 0.65556, 0, 0, 0.5],
    57: [0, 0.65556, 0, 0, 0.5],
    58: [0, 0.44444, 0, 0, 0.27778],
    59: [0.125, 0.44444, 0, 0, 0.27778],
    61: [-0.13, 0.37, 0, 0, 0.77778],
    63: [0, 0.69444, 0, 0, 0.47222],
    64: [0, 0.69444, 0, 0, 0.66667],
    65: [0, 0.69444, 0, 0, 0.66667],
    66: [0, 0.69444, 0, 0, 0.66667],
    67: [0, 0.69444, 0, 0, 0.63889],
    68: [0, 0.69444, 0, 0, 0.72223],
    69: [0, 0.69444, 0, 0, 0.59722],
    70: [0, 0.69444, 0, 0, 0.56945],
    71: [0, 0.69444, 0, 0, 0.66667],
    72: [0, 0.69444, 0, 0, 0.70834],
    73: [0, 0.69444, 0, 0, 0.27778],
    74: [0, 0.69444, 0, 0, 0.47222],
    75: [0, 0.69444, 0, 0, 0.69445],
    76: [0, 0.69444, 0, 0, 0.54167],
    77: [0, 0.69444, 0, 0, 0.875],
    78: [0, 0.69444, 0, 0, 0.70834],
    79: [0, 0.69444, 0, 0, 0.73611],
    80: [0, 0.69444, 0, 0, 0.63889],
    81: [0.125, 0.69444, 0, 0, 0.73611],
    82: [0, 0.69444, 0, 0, 0.64584],
    83: [0, 0.69444, 0, 0, 0.55556],
    84: [0, 0.69444, 0, 0, 0.68056],
    85: [0, 0.69444, 0, 0, 0.6875],
    86: [0, 0.69444, 0.01389, 0, 0.66667],
    87: [0, 0.69444, 0.01389, 0, 0.94445],
    88: [0, 0.69444, 0, 0, 0.66667],
    89: [0, 0.69444, 0.025, 0, 0.66667],
    90: [0, 0.69444, 0, 0, 0.61111],
    91: [0.25, 0.75, 0, 0, 0.28889],
    93: [0.25, 0.75, 0, 0, 0.28889],
    94: [0, 0.69444, 0, 0, 0.5],
    95: [0.35, 0.09444, 0.02778, 0, 0.5],
    97: [0, 0.44444, 0, 0, 0.48056],
    98: [0, 0.69444, 0, 0, 0.51667],
    99: [0, 0.44444, 0, 0, 0.44445],
    100: [0, 0.69444, 0, 0, 0.51667],
    101: [0, 0.44444, 0, 0, 0.44445],
    102: [0, 0.69444, 0.06944, 0, 0.30556],
    103: [0.19444, 0.44444, 0.01389, 0, 0.5],
    104: [0, 0.69444, 0, 0, 0.51667],
    105: [0, 0.67937, 0, 0, 0.23889],
    106: [0.19444, 0.67937, 0, 0, 0.26667],
    107: [0, 0.69444, 0, 0, 0.48889],
    108: [0, 0.69444, 0, 0, 0.23889],
    109: [0, 0.44444, 0, 0, 0.79445],
    110: [0, 0.44444, 0, 0, 0.51667],
    111: [0, 0.44444, 0, 0, 0.5],
    112: [0.19444, 0.44444, 0, 0, 0.51667],
    113: [0.19444, 0.44444, 0, 0, 0.51667],
    114: [0, 0.44444, 0.01389, 0, 0.34167],
    115: [0, 0.44444, 0, 0, 0.38333],
    116: [0, 0.57143, 0, 0, 0.36111],
    117: [0, 0.44444, 0, 0, 0.51667],
    118: [0, 0.44444, 0.01389, 0, 0.46111],
    119: [0, 0.44444, 0.01389, 0, 0.68334],
    120: [0, 0.44444, 0, 0, 0.46111],
    121: [0.19444, 0.44444, 0.01389, 0, 0.46111],
    122: [0, 0.44444, 0, 0, 0.43472],
    126: [0.35, 0.32659, 0, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.67937, 0, 0, 0.5],
    176: [0, 0.69444, 0, 0, 0.66667],
    184: [0.17014, 0, 0, 0, 0.44445],
    305: [0, 0.44444, 0, 0, 0.23889],
    567: [0.19444, 0.44444, 0, 0, 0.26667],
    710: [0, 0.69444, 0, 0, 0.5],
    711: [0, 0.63194, 0, 0, 0.5],
    713: [0, 0.60889, 0, 0, 0.5],
    714: [0, 0.69444, 0, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0, 0, 0.5],
    729: [0, 0.67937, 0, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.66667],
    732: [0, 0.67659, 0, 0, 0.5],
    733: [0, 0.69444, 0, 0, 0.5],
    915: [0, 0.69444, 0, 0, 0.54167],
    916: [0, 0.69444, 0, 0, 0.83334],
    920: [0, 0.69444, 0, 0, 0.77778],
    923: [0, 0.69444, 0, 0, 0.61111],
    926: [0, 0.69444, 0, 0, 0.66667],
    928: [0, 0.69444, 0, 0, 0.70834],
    931: [0, 0.69444, 0, 0, 0.72222],
    933: [0, 0.69444, 0, 0, 0.77778],
    934: [0, 0.69444, 0, 0, 0.72222],
    936: [0, 0.69444, 0, 0, 0.77778],
    937: [0, 0.69444, 0, 0, 0.72222],
    8211: [0, 0.44444, 0.02778, 0, 0.5],
    8212: [0, 0.44444, 0.02778, 0, 1],
    8216: [0, 0.69444, 0, 0, 0.27778],
    8217: [0, 0.69444, 0, 0, 0.27778],
    8220: [0, 0.69444, 0, 0, 0.5],
    8221: [0, 0.69444, 0, 0, 0.5]
  },
  "Script-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.7, 0.22925, 0, 0.80253],
    66: [0, 0.7, 0.04087, 0, 0.90757],
    67: [0, 0.7, 0.1689, 0, 0.66619],
    68: [0, 0.7, 0.09371, 0, 0.77443],
    69: [0, 0.7, 0.18583, 0, 0.56162],
    70: [0, 0.7, 0.13634, 0, 0.89544],
    71: [0, 0.7, 0.17322, 0, 0.60961],
    72: [0, 0.7, 0.29694, 0, 0.96919],
    73: [0, 0.7, 0.19189, 0, 0.80907],
    74: [0.27778, 0.7, 0.19189, 0, 1.05159],
    75: [0, 0.7, 0.31259, 0, 0.91364],
    76: [0, 0.7, 0.19189, 0, 0.87373],
    77: [0, 0.7, 0.15981, 0, 1.08031],
    78: [0, 0.7, 0.3525, 0, 0.9015],
    79: [0, 0.7, 0.08078, 0, 0.73787],
    80: [0, 0.7, 0.08078, 0, 1.01262],
    81: [0, 0.7, 0.03305, 0, 0.88282],
    82: [0, 0.7, 0.06259, 0, 0.85],
    83: [0, 0.7, 0.19189, 0, 0.86767],
    84: [0, 0.7, 0.29087, 0, 0.74697],
    85: [0, 0.7, 0.25815, 0, 0.79996],
    86: [0, 0.7, 0.27523, 0, 0.62204],
    87: [0, 0.7, 0.27523, 0, 0.80532],
    88: [0, 0.7, 0.26006, 0, 0.94445],
    89: [0, 0.7, 0.2939, 0, 0.70961],
    90: [0, 0.7, 0.24037, 0, 0.8212],
    160: [0, 0, 0, 0, 0.25]
  },
  "Size1-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.35001, 0.85, 0, 0, 0.45834],
    41: [0.35001, 0.85, 0, 0, 0.45834],
    47: [0.35001, 0.85, 0, 0, 0.57778],
    91: [0.35001, 0.85, 0, 0, 0.41667],
    92: [0.35001, 0.85, 0, 0, 0.57778],
    93: [0.35001, 0.85, 0, 0, 0.41667],
    123: [0.35001, 0.85, 0, 0, 0.58334],
    125: [0.35001, 0.85, 0, 0, 0.58334],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.72222, 0, 0, 0.55556],
    732: [0, 0.72222, 0, 0, 0.55556],
    770: [0, 0.72222, 0, 0, 0.55556],
    771: [0, 0.72222, 0, 0, 0.55556],
    8214: [-99e-5, 0.601, 0, 0, 0.77778],
    8593: [1e-5, 0.6, 0, 0, 0.66667],
    8595: [1e-5, 0.6, 0, 0, 0.66667],
    8657: [1e-5, 0.6, 0, 0, 0.77778],
    8659: [1e-5, 0.6, 0, 0, 0.77778],
    8719: [0.25001, 0.75, 0, 0, 0.94445],
    8720: [0.25001, 0.75, 0, 0, 0.94445],
    8721: [0.25001, 0.75, 0, 0, 1.05556],
    8730: [0.35001, 0.85, 0, 0, 1],
    8739: [-599e-5, 0.606, 0, 0, 0.33333],
    8741: [-599e-5, 0.606, 0, 0, 0.55556],
    8747: [0.30612, 0.805, 0.19445, 0, 0.47222],
    8748: [0.306, 0.805, 0.19445, 0, 0.47222],
    8749: [0.306, 0.805, 0.19445, 0, 0.47222],
    8750: [0.30612, 0.805, 0.19445, 0, 0.47222],
    8896: [0.25001, 0.75, 0, 0, 0.83334],
    8897: [0.25001, 0.75, 0, 0, 0.83334],
    8898: [0.25001, 0.75, 0, 0, 0.83334],
    8899: [0.25001, 0.75, 0, 0, 0.83334],
    8968: [0.35001, 0.85, 0, 0, 0.47222],
    8969: [0.35001, 0.85, 0, 0, 0.47222],
    8970: [0.35001, 0.85, 0, 0, 0.47222],
    8971: [0.35001, 0.85, 0, 0, 0.47222],
    9168: [-99e-5, 0.601, 0, 0, 0.66667],
    10216: [0.35001, 0.85, 0, 0, 0.47222],
    10217: [0.35001, 0.85, 0, 0, 0.47222],
    10752: [0.25001, 0.75, 0, 0, 1.11111],
    10753: [0.25001, 0.75, 0, 0, 1.11111],
    10754: [0.25001, 0.75, 0, 0, 1.11111],
    10756: [0.25001, 0.75, 0, 0, 0.83334],
    10758: [0.25001, 0.75, 0, 0, 0.83334]
  },
  "Size2-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.65002, 1.15, 0, 0, 0.59722],
    41: [0.65002, 1.15, 0, 0, 0.59722],
    47: [0.65002, 1.15, 0, 0, 0.81111],
    91: [0.65002, 1.15, 0, 0, 0.47222],
    92: [0.65002, 1.15, 0, 0, 0.81111],
    93: [0.65002, 1.15, 0, 0, 0.47222],
    123: [0.65002, 1.15, 0, 0, 0.66667],
    125: [0.65002, 1.15, 0, 0, 0.66667],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.75, 0, 0, 1],
    732: [0, 0.75, 0, 0, 1],
    770: [0, 0.75, 0, 0, 1],
    771: [0, 0.75, 0, 0, 1],
    8719: [0.55001, 1.05, 0, 0, 1.27778],
    8720: [0.55001, 1.05, 0, 0, 1.27778],
    8721: [0.55001, 1.05, 0, 0, 1.44445],
    8730: [0.65002, 1.15, 0, 0, 1],
    8747: [0.86225, 1.36, 0.44445, 0, 0.55556],
    8748: [0.862, 1.36, 0.44445, 0, 0.55556],
    8749: [0.862, 1.36, 0.44445, 0, 0.55556],
    8750: [0.86225, 1.36, 0.44445, 0, 0.55556],
    8896: [0.55001, 1.05, 0, 0, 1.11111],
    8897: [0.55001, 1.05, 0, 0, 1.11111],
    8898: [0.55001, 1.05, 0, 0, 1.11111],
    8899: [0.55001, 1.05, 0, 0, 1.11111],
    8968: [0.65002, 1.15, 0, 0, 0.52778],
    8969: [0.65002, 1.15, 0, 0, 0.52778],
    8970: [0.65002, 1.15, 0, 0, 0.52778],
    8971: [0.65002, 1.15, 0, 0, 0.52778],
    10216: [0.65002, 1.15, 0, 0, 0.61111],
    10217: [0.65002, 1.15, 0, 0, 0.61111],
    10752: [0.55001, 1.05, 0, 0, 1.51112],
    10753: [0.55001, 1.05, 0, 0, 1.51112],
    10754: [0.55001, 1.05, 0, 0, 1.51112],
    10756: [0.55001, 1.05, 0, 0, 1.11111],
    10758: [0.55001, 1.05, 0, 0, 1.11111]
  },
  "Size3-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.95003, 1.45, 0, 0, 0.73611],
    41: [0.95003, 1.45, 0, 0, 0.73611],
    47: [0.95003, 1.45, 0, 0, 1.04445],
    91: [0.95003, 1.45, 0, 0, 0.52778],
    92: [0.95003, 1.45, 0, 0, 1.04445],
    93: [0.95003, 1.45, 0, 0, 0.52778],
    123: [0.95003, 1.45, 0, 0, 0.75],
    125: [0.95003, 1.45, 0, 0, 0.75],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.75, 0, 0, 1.44445],
    732: [0, 0.75, 0, 0, 1.44445],
    770: [0, 0.75, 0, 0, 1.44445],
    771: [0, 0.75, 0, 0, 1.44445],
    8730: [0.95003, 1.45, 0, 0, 1],
    8968: [0.95003, 1.45, 0, 0, 0.58334],
    8969: [0.95003, 1.45, 0, 0, 0.58334],
    8970: [0.95003, 1.45, 0, 0, 0.58334],
    8971: [0.95003, 1.45, 0, 0, 0.58334],
    10216: [0.95003, 1.45, 0, 0, 0.75],
    10217: [0.95003, 1.45, 0, 0, 0.75]
  },
  "Size4-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [1.25003, 1.75, 0, 0, 0.79167],
    41: [1.25003, 1.75, 0, 0, 0.79167],
    47: [1.25003, 1.75, 0, 0, 1.27778],
    91: [1.25003, 1.75, 0, 0, 0.58334],
    92: [1.25003, 1.75, 0, 0, 1.27778],
    93: [1.25003, 1.75, 0, 0, 0.58334],
    123: [1.25003, 1.75, 0, 0, 0.80556],
    125: [1.25003, 1.75, 0, 0, 0.80556],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.825, 0, 0, 1.8889],
    732: [0, 0.825, 0, 0, 1.8889],
    770: [0, 0.825, 0, 0, 1.8889],
    771: [0, 0.825, 0, 0, 1.8889],
    8730: [1.25003, 1.75, 0, 0, 1],
    8968: [1.25003, 1.75, 0, 0, 0.63889],
    8969: [1.25003, 1.75, 0, 0, 0.63889],
    8970: [1.25003, 1.75, 0, 0, 0.63889],
    8971: [1.25003, 1.75, 0, 0, 0.63889],
    9115: [0.64502, 1.155, 0, 0, 0.875],
    9116: [1e-5, 0.6, 0, 0, 0.875],
    9117: [0.64502, 1.155, 0, 0, 0.875],
    9118: [0.64502, 1.155, 0, 0, 0.875],
    9119: [1e-5, 0.6, 0, 0, 0.875],
    9120: [0.64502, 1.155, 0, 0, 0.875],
    9121: [0.64502, 1.155, 0, 0, 0.66667],
    9122: [-99e-5, 0.601, 0, 0, 0.66667],
    9123: [0.64502, 1.155, 0, 0, 0.66667],
    9124: [0.64502, 1.155, 0, 0, 0.66667],
    9125: [-99e-5, 0.601, 0, 0, 0.66667],
    9126: [0.64502, 1.155, 0, 0, 0.66667],
    9127: [1e-5, 0.9, 0, 0, 0.88889],
    9128: [0.65002, 1.15, 0, 0, 0.88889],
    9129: [0.90001, 0, 0, 0, 0.88889],
    9130: [0, 0.3, 0, 0, 0.88889],
    9131: [1e-5, 0.9, 0, 0, 0.88889],
    9132: [0.65002, 1.15, 0, 0, 0.88889],
    9133: [0.90001, 0, 0, 0, 0.88889],
    9143: [0.88502, 0.915, 0, 0, 1.05556],
    10216: [1.25003, 1.75, 0, 0, 0.80556],
    10217: [1.25003, 1.75, 0, 0, 0.80556],
    57344: [-499e-5, 0.605, 0, 0, 1.05556],
    57345: [-499e-5, 0.605, 0, 0, 1.05556],
    57680: [0, 0.12, 0, 0, 0.45],
    57681: [0, 0.12, 0, 0, 0.45],
    57682: [0, 0.12, 0, 0, 0.45],
    57683: [0, 0.12, 0, 0, 0.45]
  },
  "Typewriter-Regular": {
    32: [0, 0, 0, 0, 0.525],
    33: [0, 0.61111, 0, 0, 0.525],
    34: [0, 0.61111, 0, 0, 0.525],
    35: [0, 0.61111, 0, 0, 0.525],
    36: [0.08333, 0.69444, 0, 0, 0.525],
    37: [0.08333, 0.69444, 0, 0, 0.525],
    38: [0, 0.61111, 0, 0, 0.525],
    39: [0, 0.61111, 0, 0, 0.525],
    40: [0.08333, 0.69444, 0, 0, 0.525],
    41: [0.08333, 0.69444, 0, 0, 0.525],
    42: [0, 0.52083, 0, 0, 0.525],
    43: [-0.08056, 0.53055, 0, 0, 0.525],
    44: [0.13889, 0.125, 0, 0, 0.525],
    45: [-0.08056, 0.53055, 0, 0, 0.525],
    46: [0, 0.125, 0, 0, 0.525],
    47: [0.08333, 0.69444, 0, 0, 0.525],
    48: [0, 0.61111, 0, 0, 0.525],
    49: [0, 0.61111, 0, 0, 0.525],
    50: [0, 0.61111, 0, 0, 0.525],
    51: [0, 0.61111, 0, 0, 0.525],
    52: [0, 0.61111, 0, 0, 0.525],
    53: [0, 0.61111, 0, 0, 0.525],
    54: [0, 0.61111, 0, 0, 0.525],
    55: [0, 0.61111, 0, 0, 0.525],
    56: [0, 0.61111, 0, 0, 0.525],
    57: [0, 0.61111, 0, 0, 0.525],
    58: [0, 0.43056, 0, 0, 0.525],
    59: [0.13889, 0.43056, 0, 0, 0.525],
    60: [-0.05556, 0.55556, 0, 0, 0.525],
    61: [-0.19549, 0.41562, 0, 0, 0.525],
    62: [-0.05556, 0.55556, 0, 0, 0.525],
    63: [0, 0.61111, 0, 0, 0.525],
    64: [0, 0.61111, 0, 0, 0.525],
    65: [0, 0.61111, 0, 0, 0.525],
    66: [0, 0.61111, 0, 0, 0.525],
    67: [0, 0.61111, 0, 0, 0.525],
    68: [0, 0.61111, 0, 0, 0.525],
    69: [0, 0.61111, 0, 0, 0.525],
    70: [0, 0.61111, 0, 0, 0.525],
    71: [0, 0.61111, 0, 0, 0.525],
    72: [0, 0.61111, 0, 0, 0.525],
    73: [0, 0.61111, 0, 0, 0.525],
    74: [0, 0.61111, 0, 0, 0.525],
    75: [0, 0.61111, 0, 0, 0.525],
    76: [0, 0.61111, 0, 0, 0.525],
    77: [0, 0.61111, 0, 0, 0.525],
    78: [0, 0.61111, 0, 0, 0.525],
    79: [0, 0.61111, 0, 0, 0.525],
    80: [0, 0.61111, 0, 0, 0.525],
    81: [0.13889, 0.61111, 0, 0, 0.525],
    82: [0, 0.61111, 0, 0, 0.525],
    83: [0, 0.61111, 0, 0, 0.525],
    84: [0, 0.61111, 0, 0, 0.525],
    85: [0, 0.61111, 0, 0, 0.525],
    86: [0, 0.61111, 0, 0, 0.525],
    87: [0, 0.61111, 0, 0, 0.525],
    88: [0, 0.61111, 0, 0, 0.525],
    89: [0, 0.61111, 0, 0, 0.525],
    90: [0, 0.61111, 0, 0, 0.525],
    91: [0.08333, 0.69444, 0, 0, 0.525],
    92: [0.08333, 0.69444, 0, 0, 0.525],
    93: [0.08333, 0.69444, 0, 0, 0.525],
    94: [0, 0.61111, 0, 0, 0.525],
    95: [0.09514, 0, 0, 0, 0.525],
    96: [0, 0.61111, 0, 0, 0.525],
    97: [0, 0.43056, 0, 0, 0.525],
    98: [0, 0.61111, 0, 0, 0.525],
    99: [0, 0.43056, 0, 0, 0.525],
    100: [0, 0.61111, 0, 0, 0.525],
    101: [0, 0.43056, 0, 0, 0.525],
    102: [0, 0.61111, 0, 0, 0.525],
    103: [0.22222, 0.43056, 0, 0, 0.525],
    104: [0, 0.61111, 0, 0, 0.525],
    105: [0, 0.61111, 0, 0, 0.525],
    106: [0.22222, 0.61111, 0, 0, 0.525],
    107: [0, 0.61111, 0, 0, 0.525],
    108: [0, 0.61111, 0, 0, 0.525],
    109: [0, 0.43056, 0, 0, 0.525],
    110: [0, 0.43056, 0, 0, 0.525],
    111: [0, 0.43056, 0, 0, 0.525],
    112: [0.22222, 0.43056, 0, 0, 0.525],
    113: [0.22222, 0.43056, 0, 0, 0.525],
    114: [0, 0.43056, 0, 0, 0.525],
    115: [0, 0.43056, 0, 0, 0.525],
    116: [0, 0.55358, 0, 0, 0.525],
    117: [0, 0.43056, 0, 0, 0.525],
    118: [0, 0.43056, 0, 0, 0.525],
    119: [0, 0.43056, 0, 0, 0.525],
    120: [0, 0.43056, 0, 0, 0.525],
    121: [0.22222, 0.43056, 0, 0, 0.525],
    122: [0, 0.43056, 0, 0, 0.525],
    123: [0.08333, 0.69444, 0, 0, 0.525],
    124: [0.08333, 0.69444, 0, 0, 0.525],
    125: [0.08333, 0.69444, 0, 0, 0.525],
    126: [0, 0.61111, 0, 0, 0.525],
    127: [0, 0.61111, 0, 0, 0.525],
    160: [0, 0, 0, 0, 0.525],
    176: [0, 0.61111, 0, 0, 0.525],
    184: [0.19445, 0, 0, 0, 0.525],
    305: [0, 0.43056, 0, 0, 0.525],
    567: [0.22222, 0.43056, 0, 0, 0.525],
    711: [0, 0.56597, 0, 0, 0.525],
    713: [0, 0.56555, 0, 0, 0.525],
    714: [0, 0.61111, 0, 0, 0.525],
    715: [0, 0.61111, 0, 0, 0.525],
    728: [0, 0.61111, 0, 0, 0.525],
    730: [0, 0.61111, 0, 0, 0.525],
    770: [0, 0.61111, 0, 0, 0.525],
    771: [0, 0.61111, 0, 0, 0.525],
    776: [0, 0.61111, 0, 0, 0.525],
    915: [0, 0.61111, 0, 0, 0.525],
    916: [0, 0.61111, 0, 0, 0.525],
    920: [0, 0.61111, 0, 0, 0.525],
    923: [0, 0.61111, 0, 0, 0.525],
    926: [0, 0.61111, 0, 0, 0.525],
    928: [0, 0.61111, 0, 0, 0.525],
    931: [0, 0.61111, 0, 0, 0.525],
    933: [0, 0.61111, 0, 0, 0.525],
    934: [0, 0.61111, 0, 0, 0.525],
    936: [0, 0.61111, 0, 0, 0.525],
    937: [0, 0.61111, 0, 0, 0.525],
    8216: [0, 0.61111, 0, 0, 0.525],
    8217: [0, 0.61111, 0, 0, 0.525],
    8242: [0, 0.61111, 0, 0, 0.525],
    9251: [0.11111, 0.21944, 0, 0, 0.525]
  }
}, k4 = {
  slant: [0.25, 0.25, 0.25],
  // sigma1
  space: [0, 0, 0],
  // sigma2
  stretch: [0, 0, 0],
  // sigma3
  shrink: [0, 0, 0],
  // sigma4
  xHeight: [0.431, 0.431, 0.431],
  // sigma5
  quad: [1, 1.171, 1.472],
  // sigma6
  extraSpace: [0, 0, 0],
  // sigma7
  num1: [0.677, 0.732, 0.925],
  // sigma8
  num2: [0.394, 0.384, 0.387],
  // sigma9
  num3: [0.444, 0.471, 0.504],
  // sigma10
  denom1: [0.686, 0.752, 1.025],
  // sigma11
  denom2: [0.345, 0.344, 0.532],
  // sigma12
  sup1: [0.413, 0.503, 0.504],
  // sigma13
  sup2: [0.363, 0.431, 0.404],
  // sigma14
  sup3: [0.289, 0.286, 0.294],
  // sigma15
  sub1: [0.15, 0.143, 0.2],
  // sigma16
  sub2: [0.247, 0.286, 0.4],
  // sigma17
  supDrop: [0.386, 0.353, 0.494],
  // sigma18
  subDrop: [0.05, 0.071, 0.1],
  // sigma19
  delim1: [2.39, 1.7, 1.98],
  // sigma20
  delim2: [1.01, 1.157, 1.42],
  // sigma21
  axisHeight: [0.25, 0.25, 0.25],
  // sigma22
  // These font metrics are extracted from TeX by using tftopl on cmex10.tfm;
  // they correspond to the font parameters of the extension fonts (family 3).
  // See the TeXbook, page 441. In AMSTeX, the extension fonts scale; to
  // match cmex7, we'd use cmex7.tfm values for script and scriptscript
  // values.
  defaultRuleThickness: [0.04, 0.049, 0.049],
  // xi8; cmex7: 0.049
  bigOpSpacing1: [0.111, 0.111, 0.111],
  // xi9
  bigOpSpacing2: [0.166, 0.166, 0.166],
  // xi10
  bigOpSpacing3: [0.2, 0.2, 0.2],
  // xi11
  bigOpSpacing4: [0.6, 0.611, 0.611],
  // xi12; cmex7: 0.611
  bigOpSpacing5: [0.1, 0.143, 0.143],
  // xi13; cmex7: 0.143
  // The \sqrt rule width is taken from the height of the surd character.
  // Since we use the same font at all sizes, this thickness doesn't scale.
  sqrtRuleThickness: [0.04, 0.04, 0.04],
  // This value determines how large a pt is, for metrics which are defined
  // in terms of pts.
  // This value is also used in katex.scss; if you change it make sure the
  // values match.
  ptPerEm: [10, 10, 10],
  // The space between adjacent `|` columns in an array definition. From
  // `\showthe\doublerulesep` in LaTeX. Equals 2.0 / ptPerEm.
  doubleRuleSep: [0.2, 0.2, 0.2],
  // The width of separator lines in {array} environments. From
  // `\showthe\arrayrulewidth` in LaTeX. Equals 0.4 / ptPerEm.
  arrayRuleWidth: [0.04, 0.04, 0.04],
  // Two values from LaTeX source2e:
  fboxsep: [0.3, 0.3, 0.3],
  //        3 pt / ptPerEm
  fboxrule: [0.04, 0.04, 0.04]
  // 0.4 pt / ptPerEm
}, iO = {
  // Latin-1
  Å: "A",
  Ð: "D",
  Þ: "o",
  å: "a",
  ð: "d",
  þ: "o",
  // Cyrillic
  А: "A",
  Б: "B",
  В: "B",
  Г: "F",
  Д: "A",
  Е: "E",
  Ж: "K",
  З: "3",
  И: "N",
  Й: "N",
  К: "K",
  Л: "N",
  М: "M",
  Н: "H",
  О: "O",
  П: "N",
  Р: "P",
  С: "C",
  Т: "T",
  У: "y",
  Ф: "O",
  Х: "X",
  Ц: "U",
  Ч: "h",
  Ш: "W",
  Щ: "W",
  Ъ: "B",
  Ы: "X",
  Ь: "B",
  Э: "3",
  Ю: "X",
  Я: "R",
  а: "a",
  б: "b",
  в: "a",
  г: "r",
  д: "y",
  е: "e",
  ж: "m",
  з: "e",
  и: "n",
  й: "n",
  к: "n",
  л: "n",
  м: "m",
  н: "n",
  о: "o",
  п: "n",
  р: "p",
  с: "c",
  т: "o",
  у: "y",
  ф: "b",
  х: "x",
  ц: "n",
  ч: "n",
  ш: "w",
  щ: "w",
  ъ: "a",
  ы: "m",
  ь: "a",
  э: "e",
  ю: "m",
  я: "r"
};
function tqt(t, e) {
  Vo[t] = e;
}
function xL(t, e, n) {
  if (!Vo[e])
    throw new Error("Font metrics not found for font: " + e + ".");
  var r = t.charCodeAt(0), i = Vo[e][r];
  if (!i && t[0] in iO && (r = iO[t[0]].charCodeAt(0), i = Vo[e][r]), !i && n === "text" && one(r) && (i = Vo[e][77]), i)
    return {
      depth: i[0],
      height: i[1],
      italic: i[2],
      skew: i[3],
      width: i[4]
    };
}
var Db = {};
function nqt(t) {
  var e;
  if (t >= 5 ? e = 0 : t >= 3 ? e = 1 : e = 2, !Db[e]) {
    var n = Db[e] = {
      cssEmPerMu: k4.quad[e] / 18
    };
    for (var r in k4)
      k4.hasOwnProperty(r) && (n[r] = k4[r][e]);
  }
  return Db[e];
}
var rqt = [
  // Each element contains [textsize, scriptsize, scriptscriptsize].
  // The size mappings are taken from TeX with \normalsize=10pt.
  [1, 1, 1],
  // size1: [5, 5, 5]              \tiny
  [2, 1, 1],
  // size2: [6, 5, 5]
  [3, 1, 1],
  // size3: [7, 5, 5]              \scriptsize
  [4, 2, 1],
  // size4: [8, 6, 5]              \footnotesize
  [5, 2, 1],
  // size5: [9, 6, 5]              \small
  [6, 3, 1],
  // size6: [10, 7, 5]             \normalsize
  [7, 4, 2],
  // size7: [12, 8, 6]             \large
  [8, 6, 3],
  // size8: [14.4, 10, 7]          \Large
  [9, 7, 6],
  // size9: [17.28, 12, 10]        \LARGE
  [10, 8, 7],
  // size10: [20.74, 14.4, 12]     \huge
  [11, 10, 9]
  // size11: [24.88, 20.74, 17.28] \HUGE
], aO = [
  // fontMetrics.js:getGlobalMetrics also uses size indexes, so if
  // you change size indexes, change that function.
  0.5,
  0.6,
  0.7,
  0.8,
  0.9,
  1,
  1.2,
  1.44,
  1.728,
  2.074,
  2.488
], oO = function(e, n) {
  return n.size < 2 ? e : rqt[e - 1][n.size - 1];
};
class Os {
  // A font family applies to a group of fonts (i.e. SansSerif), while a font
  // represents a specific font (i.e. SansSerif Bold).
  // See: https://tex.stackexchange.com/questions/22350/difference-between-textrm-and-mathrm
  /**
   * The base size index.
   */
  constructor(e) {
    this.style = void 0, this.color = void 0, this.size = void 0, this.textSize = void 0, this.phantom = void 0, this.font = void 0, this.fontFamily = void 0, this.fontWeight = void 0, this.fontShape = void 0, this.sizeMultiplier = void 0, this.maxSize = void 0, this.minRuleThickness = void 0, this._fontMetrics = void 0, this.style = e.style, this.color = e.color, this.size = e.size || Os.BASESIZE, this.textSize = e.textSize || this.size, this.phantom = !!e.phantom, this.font = e.font || "", this.fontFamily = e.fontFamily || "", this.fontWeight = e.fontWeight || "", this.fontShape = e.fontShape || "", this.sizeMultiplier = aO[this.size - 1], this.maxSize = e.maxSize, this.minRuleThickness = e.minRuleThickness, this._fontMetrics = void 0;
  }
  /**
   * Returns a new options object with the same properties as "this".  Properties
   * from "extension" will be copied to the new options object.
   */
  extend(e) {
    var n = {
      style: this.style,
      size: this.size,
      textSize: this.textSize,
      color: this.color,
      phantom: this.phantom,
      font: this.font,
      fontFamily: this.fontFamily,
      fontWeight: this.fontWeight,
      fontShape: this.fontShape,
      maxSize: this.maxSize,
      minRuleThickness: this.minRuleThickness
    };
    for (var r in e)
      e.hasOwnProperty(r) && (n[r] = e[r]);
    return new Os(n);
  }
  /**
   * Return an options object with the given style. If `this.style === style`,
   * returns `this`.
   */
  havingStyle(e) {
    return this.style === e ? this : this.extend({
      style: e,
      size: oO(this.textSize, e)
    });
  }
  /**
   * Return an options object with a cramped version of the current style. If
   * the current style is cramped, returns `this`.
   */
  havingCrampedStyle() {
    return this.havingStyle(this.style.cramp());
  }
  /**
   * Return an options object with the given size and in at least `\textstyle`.
   * Returns `this` if appropriate.
   */
  havingSize(e) {
    return this.size === e && this.textSize === e ? this : this.extend({
      style: this.style.text(),
      size: e,
      textSize: e,
      sizeMultiplier: aO[e - 1]
    });
  }
  /**
   * Like `this.havingSize(BASESIZE).havingStyle(style)`. If `style` is omitted,
   * changes to at least `\textstyle`.
   */
  havingBaseStyle(e) {
    e = e || this.style.text();
    var n = oO(Os.BASESIZE, e);
    return this.size === n && this.textSize === Os.BASESIZE && this.style === e ? this : this.extend({
      style: e,
      size: n
    });
  }
  /**
   * Remove the effect of sizing changes such as \Huge.
   * Keep the effect of the current style, such as \scriptstyle.
   */
  havingBaseSizing() {
    var e;
    switch (this.style.id) {
      case 4:
      case 5:
        e = 3;
        break;
      case 6:
      case 7:
        e = 1;
        break;
      default:
        e = 6;
    }
    return this.extend({
      style: this.style.text(),
      size: e
    });
  }
  /**
   * Create a new options object with the given color.
   */
  withColor(e) {
    return this.extend({
      color: e
    });
  }
  /**
   * Create a new options object with "phantom" set to true.
   */
  withPhantom() {
    return this.extend({
      phantom: !0
    });
  }
  /**
   * Creates a new options object with the given math font or old text font.
   * @type {[type]}
   */
  withFont(e) {
    return this.extend({
      font: e
    });
  }
  /**
   * Create a new options objects with the given fontFamily.
   */
  withTextFontFamily(e) {
    return this.extend({
      fontFamily: e,
      font: ""
    });
  }
  /**
   * Creates a new options object with the given font weight
   */
  withTextFontWeight(e) {
    return this.extend({
      fontWeight: e,
      font: ""
    });
  }
  /**
   * Creates a new options object with the given font weight
   */
  withTextFontShape(e) {
    return this.extend({
      fontShape: e,
      font: ""
    });
  }
  /**
   * Return the CSS sizing classes required to switch from enclosing options
   * `oldOptions` to `this`. Returns an array of classes.
   */
  sizingClasses(e) {
    return e.size !== this.size ? ["sizing", "reset-size" + e.size, "size" + this.size] : [];
  }
  /**
   * Return the CSS sizing classes required to switch to the base size. Like
   * `this.havingSize(BASESIZE).sizingClasses(this)`.
   */
  baseSizingClasses() {
    return this.size !== Os.BASESIZE ? ["sizing", "reset-size" + this.size, "size" + Os.BASESIZE] : [];
  }
  /**
   * Return the font metrics for this size.
   */
  fontMetrics() {
    return this._fontMetrics || (this._fontMetrics = nqt(this.size)), this._fontMetrics;
  }
  /**
   * Gets the CSS color of the current options object
   */
  getColor() {
    return this.phantom ? "transparent" : this.color;
  }
}
Os.BASESIZE = 6;
var Ik = {
  // https://en.wikibooks.org/wiki/LaTeX/Lengths and
  // https://tex.stackexchange.com/a/8263
  pt: 1,
  // TeX point
  mm: 7227 / 2540,
  // millimeter
  cm: 7227 / 254,
  // centimeter
  in: 72.27,
  // inch
  bp: 803 / 800,
  // big (PostScript) points
  pc: 12,
  // pica
  dd: 1238 / 1157,
  // didot
  cc: 14856 / 1157,
  // cicero (12 didot)
  nd: 685 / 642,
  // new didot
  nc: 1370 / 107,
  // new cicero (12 new didot)
  sp: 1 / 65536,
  // scaled point (TeX's internal smallest unit)
  // https://tex.stackexchange.com/a/41371
  px: 803 / 800
  // \pdfpxdimen defaults to 1 bp in pdfTeX and LuaTeX
}, iqt = {
  ex: !0,
  em: !0,
  mu: !0
}, sne = function(e) {
  return typeof e != "string" && (e = e.unit), e in Ik || e in iqt || e === "ex";
}, Bn = function(e, n) {
  var r;
  if (e.unit in Ik)
    r = Ik[e.unit] / n.fontMetrics().ptPerEm / n.sizeMultiplier;
  else if (e.unit === "mu")
    r = n.fontMetrics().cssEmPerMu;
  else {
    var i;
    if (n.style.isTight() ? i = n.havingStyle(n.style.text()) : i = n, e.unit === "ex")
      r = i.fontMetrics().xHeight;
    else if (e.unit === "em")
      r = i.fontMetrics().quad;
    else
      throw new Ge("Invalid unit: '" + e.unit + "'");
    i !== n && (r *= i.sizeMultiplier / n.sizeMultiplier);
  }
  return Math.min(e.number * r, n.maxSize);
}, Qe = function(e) {
  return +e.toFixed(4) + "em";
}, Ic = function(e) {
  return e.filter((n) => n).join(" ");
}, lne = function(e, n, r) {
  if (this.classes = e || [], this.attributes = {}, this.height = 0, this.depth = 0, this.maxFontSize = 0, this.style = r || {}, n) {
    n.style.isTight() && this.classes.push("mtight");
    var i = n.getColor();
    i && (this.style.color = i);
  }
}, cne = function(e) {
  var n = document.createElement(e);
  n.className = Ic(this.classes);
  for (var r in this.style)
    this.style.hasOwnProperty(r) && (n.style[r] = this.style[r]);
  for (var i in this.attributes)
    this.attributes.hasOwnProperty(i) && n.setAttribute(i, this.attributes[i]);
  for (var a = 0; a < this.children.length; a++)
    n.appendChild(this.children[a].toNode());
  return n;
}, aqt = /[\s"'>/=\x00-\x1f]/, une = function(e) {
  var n = "<" + e;
  this.classes.length && (n += ' class="' + wt.escape(Ic(this.classes)) + '"');
  var r = "";
  for (var i in this.style)
    this.style.hasOwnProperty(i) && (r += wt.hyphenate(i) + ":" + this.style[i] + ";");
  r && (n += ' style="' + wt.escape(r) + '"');
  for (var a in this.attributes)
    if (this.attributes.hasOwnProperty(a)) {
      if (aqt.test(a))
        throw new Ge("Invalid attribute name '" + a + "'");
      n += " " + a + '="' + wt.escape(this.attributes[a]) + '"';
    }
  n += ">";
  for (var o = 0; o < this.children.length; o++)
    n += this.children[o].toMarkup();
  return n += "</" + e + ">", n;
};
class sm {
  constructor(e, n, r, i) {
    this.children = void 0, this.attributes = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.width = void 0, this.maxFontSize = void 0, this.style = void 0, lne.call(this, e, r, i), this.children = n || [];
  }
  /**
   * Sets an arbitrary attribute on the span. Warning: use this wisely. Not
   * all browsers support attributes the same, and having too many custom
   * attributes is probably bad.
   */
  setAttribute(e, n) {
    this.attributes[e] = n;
  }
  hasClass(e) {
    return wt.contains(this.classes, e);
  }
  toNode() {
    return cne.call(this, "span");
  }
  toMarkup() {
    return une.call(this, "span");
  }
}
class ML {
  constructor(e, n, r, i) {
    this.children = void 0, this.attributes = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, lne.call(this, n, i), this.children = r || [], this.setAttribute("href", e);
  }
  setAttribute(e, n) {
    this.attributes[e] = n;
  }
  hasClass(e) {
    return wt.contains(this.classes, e);
  }
  toNode() {
    return cne.call(this, "a");
  }
  toMarkup() {
    return une.call(this, "a");
  }
}
class oqt {
  constructor(e, n, r) {
    this.src = void 0, this.alt = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, this.alt = n, this.src = e, this.classes = ["mord"], this.style = r;
  }
  hasClass(e) {
    return wt.contains(this.classes, e);
  }
  toNode() {
    var e = document.createElement("img");
    e.src = this.src, e.alt = this.alt, e.className = "mord";
    for (var n in this.style)
      this.style.hasOwnProperty(n) && (e.style[n] = this.style[n]);
    return e;
  }
  toMarkup() {
    var e = '<img src="' + wt.escape(this.src) + '"' + (' alt="' + wt.escape(this.alt) + '"'), n = "";
    for (var r in this.style)
      this.style.hasOwnProperty(r) && (n += wt.hyphenate(r) + ":" + this.style[r] + ";");
    return n && (e += ' style="' + wt.escape(n) + '"'), e += "'/>", e;
  }
}
var sqt = {
  î: "ı̂",
  ï: "ı̈",
  í: "ı́",
  // 'ī': '\u0131\u0304', // enable when we add Extended Latin
  ì: "ı̀"
};
class Oa {
  constructor(e, n, r, i, a, o, s, l) {
    this.text = void 0, this.height = void 0, this.depth = void 0, this.italic = void 0, this.skew = void 0, this.width = void 0, this.maxFontSize = void 0, this.classes = void 0, this.style = void 0, this.text = e, this.height = n || 0, this.depth = r || 0, this.italic = i || 0, this.skew = a || 0, this.width = o || 0, this.classes = s || [], this.style = l || {}, this.maxFontSize = 0;
    var c = UVt(this.text.charCodeAt(0));
    c && this.classes.push(c + "_fallback"), /[îïíì]/.test(this.text) && (this.text = sqt[this.text]);
  }
  hasClass(e) {
    return wt.contains(this.classes, e);
  }
  /**
   * Creates a text node or span from a symbol node. Note that a span is only
   * created if it is needed.
   */
  toNode() {
    var e = document.createTextNode(this.text), n = null;
    this.italic > 0 && (n = document.createElement("span"), n.style.marginRight = Qe(this.italic)), this.classes.length > 0 && (n = n || document.createElement("span"), n.className = Ic(this.classes));
    for (var r in this.style)
      this.style.hasOwnProperty(r) && (n = n || document.createElement("span"), n.style[r] = this.style[r]);
    return n ? (n.appendChild(e), n) : e;
  }
  /**
   * Creates markup for a symbol node.
   */
  toMarkup() {
    var e = !1, n = "<span";
    this.classes.length && (e = !0, n += ' class="', n += wt.escape(Ic(this.classes)), n += '"');
    var r = "";
    this.italic > 0 && (r += "margin-right:" + this.italic + "em;");
    for (var i in this.style)
      this.style.hasOwnProperty(i) && (r += wt.hyphenate(i) + ":" + this.style[i] + ";");
    r && (e = !0, n += ' style="' + wt.escape(r) + '"');
    var a = wt.escape(this.text);
    return e ? (n += ">", n += a, n += "</span>", n) : a;
  }
}
class wl {
  constructor(e, n) {
    this.children = void 0, this.attributes = void 0, this.children = e || [], this.attributes = n || {};
  }
  toNode() {
    var e = "http://www.w3.org/2000/svg", n = document.createElementNS(e, "svg");
    for (var r in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, r) && n.setAttribute(r, this.attributes[r]);
    for (var i = 0; i < this.children.length; i++)
      n.appendChild(this.children[i].toNode());
    return n;
  }
  toMarkup() {
    var e = '<svg xmlns="http://www.w3.org/2000/svg"';
    for (var n in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, n) && (e += " " + n + '="' + wt.escape(this.attributes[n]) + '"');
    e += ">";
    for (var r = 0; r < this.children.length; r++)
      e += this.children[r].toMarkup();
    return e += "</svg>", e;
  }
}
class Pc {
  constructor(e, n) {
    this.pathName = void 0, this.alternate = void 0, this.pathName = e, this.alternate = n;
  }
  toNode() {
    var e = "http://www.w3.org/2000/svg", n = document.createElementNS(e, "path");
    return this.alternate ? n.setAttribute("d", this.alternate) : n.setAttribute("d", rO[this.pathName]), n;
  }
  toMarkup() {
    return this.alternate ? '<path d="' + wt.escape(this.alternate) + '"/>' : '<path d="' + wt.escape(rO[this.pathName]) + '"/>';
  }
}
class Pk {
  constructor(e) {
    this.attributes = void 0, this.attributes = e || {};
  }
  toNode() {
    var e = "http://www.w3.org/2000/svg", n = document.createElementNS(e, "line");
    for (var r in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, r) && n.setAttribute(r, this.attributes[r]);
    return n;
  }
  toMarkup() {
    var e = "<line";
    for (var n in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, n) && (e += " " + n + '="' + wt.escape(this.attributes[n]) + '"');
    return e += "/>", e;
  }
}
function sO(t) {
  if (t instanceof Oa)
    return t;
  throw new Error("Expected symbolNode but got " + String(t) + ".");
}
function lqt(t) {
  if (t instanceof sm)
    return t;
  throw new Error("Expected span<HtmlDomNode> but got " + String(t) + ".");
}
var cqt = {
  bin: 1,
  close: 1,
  inner: 1,
  open: 1,
  punct: 1,
  rel: 1
}, uqt = {
  "accent-token": 1,
  mathord: 1,
  "op-token": 1,
  spacing: 1,
  textord: 1
}, kn = {
  math: {},
  text: {}
};
function E(t, e, n, r, i, a) {
  kn[t][i] = {
    font: e,
    group: n,
    replace: r
  }, a && r && (kn[t][r] = kn[t][i]);
}
var I = "math", He = "text", B = "main", te = "ams", Dn = "accent-token", lt = "bin", gi = "close", $d = "inner", At = "mathord", cr = "op-token", la = "open", C5 = "punct", ie = "rel", Tl = "spacing", ce = "textord";
E(I, B, ie, "≡", "\\equiv", !0);
E(I, B, ie, "≺", "\\prec", !0);
E(I, B, ie, "≻", "\\succ", !0);
E(I, B, ie, "∼", "\\sim", !0);
E(I, B, ie, "⊥", "\\perp");
E(I, B, ie, "⪯", "\\preceq", !0);
E(I, B, ie, "⪰", "\\succeq", !0);
E(I, B, ie, "≃", "\\simeq", !0);
E(I, B, ie, "∣", "\\mid", !0);
E(I, B, ie, "≪", "\\ll", !0);
E(I, B, ie, "≫", "\\gg", !0);
E(I, B, ie, "≍", "\\asymp", !0);
E(I, B, ie, "∥", "\\parallel");
E(I, B, ie, "⋈", "\\bowtie", !0);
E(I, B, ie, "⌣", "\\smile", !0);
E(I, B, ie, "⊑", "\\sqsubseteq", !0);
E(I, B, ie, "⊒", "\\sqsupseteq", !0);
E(I, B, ie, "≐", "\\doteq", !0);
E(I, B, ie, "⌢", "\\frown", !0);
E(I, B, ie, "∋", "\\ni", !0);
E(I, B, ie, "∝", "\\propto", !0);
E(I, B, ie, "⊢", "\\vdash", !0);
E(I, B, ie, "⊣", "\\dashv", !0);
E(I, B, ie, "∋", "\\owns");
E(I, B, C5, ".", "\\ldotp");
E(I, B, C5, "⋅", "\\cdotp");
E(I, B, ce, "#", "\\#");
E(He, B, ce, "#", "\\#");
E(I, B, ce, "&", "\\&");
E(He, B, ce, "&", "\\&");
E(I, B, ce, "ℵ", "\\aleph", !0);
E(I, B, ce, "∀", "\\forall", !0);
E(I, B, ce, "ℏ", "\\hbar", !0);
E(I, B, ce, "∃", "\\exists", !0);
E(I, B, ce, "∇", "\\nabla", !0);
E(I, B, ce, "♭", "\\flat", !0);
E(I, B, ce, "ℓ", "\\ell", !0);
E(I, B, ce, "♮", "\\natural", !0);
E(I, B, ce, "♣", "\\clubsuit", !0);
E(I, B, ce, "℘", "\\wp", !0);
E(I, B, ce, "♯", "\\sharp", !0);
E(I, B, ce, "♢", "\\diamondsuit", !0);
E(I, B, ce, "ℜ", "\\Re", !0);
E(I, B, ce, "♡", "\\heartsuit", !0);
E(I, B, ce, "ℑ", "\\Im", !0);
E(I, B, ce, "♠", "\\spadesuit", !0);
E(I, B, ce, "§", "\\S", !0);
E(He, B, ce, "§", "\\S");
E(I, B, ce, "¶", "\\P", !0);
E(He, B, ce, "¶", "\\P");
E(I, B, ce, "†", "\\dag");
E(He, B, ce, "†", "\\dag");
E(He, B, ce, "†", "\\textdagger");
E(I, B, ce, "‡", "\\ddag");
E(He, B, ce, "‡", "\\ddag");
E(He, B, ce, "‡", "\\textdaggerdbl");
E(I, B, gi, "⎱", "\\rmoustache", !0);
E(I, B, la, "⎰", "\\lmoustache", !0);
E(I, B, gi, "⟯", "\\rgroup", !0);
E(I, B, la, "⟮", "\\lgroup", !0);
E(I, B, lt, "∓", "\\mp", !0);
E(I, B, lt, "⊖", "\\ominus", !0);
E(I, B, lt, "⊎", "\\uplus", !0);
E(I, B, lt, "⊓", "\\sqcap", !0);
E(I, B, lt, "∗", "\\ast");
E(I, B, lt, "⊔", "\\sqcup", !0);
E(I, B, lt, "◯", "\\bigcirc", !0);
E(I, B, lt, "∙", "\\bullet", !0);
E(I, B, lt, "‡", "\\ddagger");
E(I, B, lt, "≀", "\\wr", !0);
E(I, B, lt, "⨿", "\\amalg");
E(I, B, lt, "&", "\\And");
E(I, B, ie, "⟵", "\\longleftarrow", !0);
E(I, B, ie, "⇐", "\\Leftarrow", !0);
E(I, B, ie, "⟸", "\\Longleftarrow", !0);
E(I, B, ie, "⟶", "\\longrightarrow", !0);
E(I, B, ie, "⇒", "\\Rightarrow", !0);
E(I, B, ie, "⟹", "\\Longrightarrow", !0);
E(I, B, ie, "↔", "\\leftrightarrow", !0);
E(I, B, ie, "⟷", "\\longleftrightarrow", !0);
E(I, B, ie, "⇔", "\\Leftrightarrow", !0);
E(I, B, ie, "⟺", "\\Longleftrightarrow", !0);
E(I, B, ie, "↦", "\\mapsto", !0);
E(I, B, ie, "⟼", "\\longmapsto", !0);
E(I, B, ie, "↗", "\\nearrow", !0);
E(I, B, ie, "↩", "\\hookleftarrow", !0);
E(I, B, ie, "↪", "\\hookrightarrow", !0);
E(I, B, ie, "↘", "\\searrow", !0);
E(I, B, ie, "↼", "\\leftharpoonup", !0);
E(I, B, ie, "⇀", "\\rightharpoonup", !0);
E(I, B, ie, "↙", "\\swarrow", !0);
E(I, B, ie, "↽", "\\leftharpoondown", !0);
E(I, B, ie, "⇁", "\\rightharpoondown", !0);
E(I, B, ie, "↖", "\\nwarrow", !0);
E(I, B, ie, "⇌", "\\rightleftharpoons", !0);
E(I, te, ie, "≮", "\\nless", !0);
E(I, te, ie, "", "\\@nleqslant");
E(I, te, ie, "", "\\@nleqq");
E(I, te, ie, "⪇", "\\lneq", !0);
E(I, te, ie, "≨", "\\lneqq", !0);
E(I, te, ie, "", "\\@lvertneqq");
E(I, te, ie, "⋦", "\\lnsim", !0);
E(I, te, ie, "⪉", "\\lnapprox", !0);
E(I, te, ie, "⊀", "\\nprec", !0);
E(I, te, ie, "⋠", "\\npreceq", !0);
E(I, te, ie, "⋨", "\\precnsim", !0);
E(I, te, ie, "⪹", "\\precnapprox", !0);
E(I, te, ie, "≁", "\\nsim", !0);
E(I, te, ie, "", "\\@nshortmid");
E(I, te, ie, "∤", "\\nmid", !0);
E(I, te, ie, "⊬", "\\nvdash", !0);
E(I, te, ie, "⊭", "\\nvDash", !0);
E(I, te, ie, "⋪", "\\ntriangleleft");
E(I, te, ie, "⋬", "\\ntrianglelefteq", !0);
E(I, te, ie, "⊊", "\\subsetneq", !0);
E(I, te, ie, "", "\\@varsubsetneq");
E(I, te, ie, "⫋", "\\subsetneqq", !0);
E(I, te, ie, "", "\\@varsubsetneqq");
E(I, te, ie, "≯", "\\ngtr", !0);
E(I, te, ie, "", "\\@ngeqslant");
E(I, te, ie, "", "\\@ngeqq");
E(I, te, ie, "⪈", "\\gneq", !0);
E(I, te, ie, "≩", "\\gneqq", !0);
E(I, te, ie, "", "\\@gvertneqq");
E(I, te, ie, "⋧", "\\gnsim", !0);
E(I, te, ie, "⪊", "\\gnapprox", !0);
E(I, te, ie, "⊁", "\\nsucc", !0);
E(I, te, ie, "⋡", "\\nsucceq", !0);
E(I, te, ie, "⋩", "\\succnsim", !0);
E(I, te, ie, "⪺", "\\succnapprox", !0);
E(I, te, ie, "≆", "\\ncong", !0);
E(I, te, ie, "", "\\@nshortparallel");
E(I, te, ie, "∦", "\\nparallel", !0);
E(I, te, ie, "⊯", "\\nVDash", !0);
E(I, te, ie, "⋫", "\\ntriangleright");
E(I, te, ie, "⋭", "\\ntrianglerighteq", !0);
E(I, te, ie, "", "\\@nsupseteqq");
E(I, te, ie, "⊋", "\\supsetneq", !0);
E(I, te, ie, "", "\\@varsupsetneq");
E(I, te, ie, "⫌", "\\supsetneqq", !0);
E(I, te, ie, "", "\\@varsupsetneqq");
E(I, te, ie, "⊮", "\\nVdash", !0);
E(I, te, ie, "⪵", "\\precneqq", !0);
E(I, te, ie, "⪶", "\\succneqq", !0);
E(I, te, ie, "", "\\@nsubseteqq");
E(I, te, lt, "⊴", "\\unlhd");
E(I, te, lt, "⊵", "\\unrhd");
E(I, te, ie, "↚", "\\nleftarrow", !0);
E(I, te, ie, "↛", "\\nrightarrow", !0);
E(I, te, ie, "⇍", "\\nLeftarrow", !0);
E(I, te, ie, "⇏", "\\nRightarrow", !0);
E(I, te, ie, "↮", "\\nleftrightarrow", !0);
E(I, te, ie, "⇎", "\\nLeftrightarrow", !0);
E(I, te, ie, "△", "\\vartriangle");
E(I, te, ce, "ℏ", "\\hslash");
E(I, te, ce, "▽", "\\triangledown");
E(I, te, ce, "◊", "\\lozenge");
E(I, te, ce, "Ⓢ", "\\circledS");
E(I, te, ce, "®", "\\circledR");
E(He, te, ce, "®", "\\circledR");
E(I, te, ce, "∡", "\\measuredangle", !0);
E(I, te, ce, "∄", "\\nexists");
E(I, te, ce, "℧", "\\mho");
E(I, te, ce, "Ⅎ", "\\Finv", !0);
E(I, te, ce, "⅁", "\\Game", !0);
E(I, te, ce, "‵", "\\backprime");
E(I, te, ce, "▲", "\\blacktriangle");
E(I, te, ce, "▼", "\\blacktriangledown");
E(I, te, ce, "■", "\\blacksquare");
E(I, te, ce, "⧫", "\\blacklozenge");
E(I, te, ce, "★", "\\bigstar");
E(I, te, ce, "∢", "\\sphericalangle", !0);
E(I, te, ce, "∁", "\\complement", !0);
E(I, te, ce, "ð", "\\eth", !0);
E(He, B, ce, "ð", "ð");
E(I, te, ce, "╱", "\\diagup");
E(I, te, ce, "╲", "\\diagdown");
E(I, te, ce, "□", "\\square");
E(I, te, ce, "□", "\\Box");
E(I, te, ce, "◊", "\\Diamond");
E(I, te, ce, "¥", "\\yen", !0);
E(He, te, ce, "¥", "\\yen", !0);
E(I, te, ce, "✓", "\\checkmark", !0);
E(He, te, ce, "✓", "\\checkmark");
E(I, te, ce, "ℶ", "\\beth", !0);
E(I, te, ce, "ℸ", "\\daleth", !0);
E(I, te, ce, "ℷ", "\\gimel", !0);
E(I, te, ce, "ϝ", "\\digamma", !0);
E(I, te, ce, "ϰ", "\\varkappa");
E(I, te, la, "┌", "\\@ulcorner", !0);
E(I, te, gi, "┐", "\\@urcorner", !0);
E(I, te, la, "└", "\\@llcorner", !0);
E(I, te, gi, "┘", "\\@lrcorner", !0);
E(I, te, ie, "≦", "\\leqq", !0);
E(I, te, ie, "⩽", "\\leqslant", !0);
E(I, te, ie, "⪕", "\\eqslantless", !0);
E(I, te, ie, "≲", "\\lesssim", !0);
E(I, te, ie, "⪅", "\\lessapprox", !0);
E(I, te, ie, "≊", "\\approxeq", !0);
E(I, te, lt, "⋖", "\\lessdot");
E(I, te, ie, "⋘", "\\lll", !0);
E(I, te, ie, "≶", "\\lessgtr", !0);
E(I, te, ie, "⋚", "\\lesseqgtr", !0);
E(I, te, ie, "⪋", "\\lesseqqgtr", !0);
E(I, te, ie, "≑", "\\doteqdot");
E(I, te, ie, "≓", "\\risingdotseq", !0);
E(I, te, ie, "≒", "\\fallingdotseq", !0);
E(I, te, ie, "∽", "\\backsim", !0);
E(I, te, ie, "⋍", "\\backsimeq", !0);
E(I, te, ie, "⫅", "\\subseteqq", !0);
E(I, te, ie, "⋐", "\\Subset", !0);
E(I, te, ie, "⊏", "\\sqsubset", !0);
E(I, te, ie, "≼", "\\preccurlyeq", !0);
E(I, te, ie, "⋞", "\\curlyeqprec", !0);
E(I, te, ie, "≾", "\\precsim", !0);
E(I, te, ie, "⪷", "\\precapprox", !0);
E(I, te, ie, "⊲", "\\vartriangleleft");
E(I, te, ie, "⊴", "\\trianglelefteq");
E(I, te, ie, "⊨", "\\vDash", !0);
E(I, te, ie, "⊪", "\\Vvdash", !0);
E(I, te, ie, "⌣", "\\smallsmile");
E(I, te, ie, "⌢", "\\smallfrown");
E(I, te, ie, "≏", "\\bumpeq", !0);
E(I, te, ie, "≎", "\\Bumpeq", !0);
E(I, te, ie, "≧", "\\geqq", !0);
E(I, te, ie, "⩾", "\\geqslant", !0);
E(I, te, ie, "⪖", "\\eqslantgtr", !0);
E(I, te, ie, "≳", "\\gtrsim", !0);
E(I, te, ie, "⪆", "\\gtrapprox", !0);
E(I, te, lt, "⋗", "\\gtrdot");
E(I, te, ie, "⋙", "\\ggg", !0);
E(I, te, ie, "≷", "\\gtrless", !0);
E(I, te, ie, "⋛", "\\gtreqless", !0);
E(I, te, ie, "⪌", "\\gtreqqless", !0);
E(I, te, ie, "≖", "\\eqcirc", !0);
E(I, te, ie, "≗", "\\circeq", !0);
E(I, te, ie, "≜", "\\triangleq", !0);
E(I, te, ie, "∼", "\\thicksim");
E(I, te, ie, "≈", "\\thickapprox");
E(I, te, ie, "⫆", "\\supseteqq", !0);
E(I, te, ie, "⋑", "\\Supset", !0);
E(I, te, ie, "⊐", "\\sqsupset", !0);
E(I, te, ie, "≽", "\\succcurlyeq", !0);
E(I, te, ie, "⋟", "\\curlyeqsucc", !0);
E(I, te, ie, "≿", "\\succsim", !0);
E(I, te, ie, "⪸", "\\succapprox", !0);
E(I, te, ie, "⊳", "\\vartriangleright");
E(I, te, ie, "⊵", "\\trianglerighteq");
E(I, te, ie, "⊩", "\\Vdash", !0);
E(I, te, ie, "∣", "\\shortmid");
E(I, te, ie, "∥", "\\shortparallel");
E(I, te, ie, "≬", "\\between", !0);
E(I, te, ie, "⋔", "\\pitchfork", !0);
E(I, te, ie, "∝", "\\varpropto");
E(I, te, ie, "◀", "\\blacktriangleleft");
E(I, te, ie, "∴", "\\therefore", !0);
E(I, te, ie, "∍", "\\backepsilon");
E(I, te, ie, "▶", "\\blacktriangleright");
E(I, te, ie, "∵", "\\because", !0);
E(I, te, ie, "⋘", "\\llless");
E(I, te, ie, "⋙", "\\gggtr");
E(I, te, lt, "⊲", "\\lhd");
E(I, te, lt, "⊳", "\\rhd");
E(I, te, ie, "≂", "\\eqsim", !0);
E(I, B, ie, "⋈", "\\Join");
E(I, te, ie, "≑", "\\Doteq", !0);
E(I, te, lt, "∔", "\\dotplus", !0);
E(I, te, lt, "∖", "\\smallsetminus");
E(I, te, lt, "⋒", "\\Cap", !0);
E(I, te, lt, "⋓", "\\Cup", !0);
E(I, te, lt, "⩞", "\\doublebarwedge", !0);
E(I, te, lt, "⊟", "\\boxminus", !0);
E(I, te, lt, "⊞", "\\boxplus", !0);
E(I, te, lt, "⋇", "\\divideontimes", !0);
E(I, te, lt, "⋉", "\\ltimes", !0);
E(I, te, lt, "⋊", "\\rtimes", !0);
E(I, te, lt, "⋋", "\\leftthreetimes", !0);
E(I, te, lt, "⋌", "\\rightthreetimes", !0);
E(I, te, lt, "⋏", "\\curlywedge", !0);
E(I, te, lt, "⋎", "\\curlyvee", !0);
E(I, te, lt, "⊝", "\\circleddash", !0);
E(I, te, lt, "⊛", "\\circledast", !0);
E(I, te, lt, "⋅", "\\centerdot");
E(I, te, lt, "⊺", "\\intercal", !0);
E(I, te, lt, "⋒", "\\doublecap");
E(I, te, lt, "⋓", "\\doublecup");
E(I, te, lt, "⊠", "\\boxtimes", !0);
E(I, te, ie, "⇢", "\\dashrightarrow", !0);
E(I, te, ie, "⇠", "\\dashleftarrow", !0);
E(I, te, ie, "⇇", "\\leftleftarrows", !0);
E(I, te, ie, "⇆", "\\leftrightarrows", !0);
E(I, te, ie, "⇚", "\\Lleftarrow", !0);
E(I, te, ie, "↞", "\\twoheadleftarrow", !0);
E(I, te, ie, "↢", "\\leftarrowtail", !0);
E(I, te, ie, "↫", "\\looparrowleft", !0);
E(I, te, ie, "⇋", "\\leftrightharpoons", !0);
E(I, te, ie, "↶", "\\curvearrowleft", !0);
E(I, te, ie, "↺", "\\circlearrowleft", !0);
E(I, te, ie, "↰", "\\Lsh", !0);
E(I, te, ie, "⇈", "\\upuparrows", !0);
E(I, te, ie, "↿", "\\upharpoonleft", !0);
E(I, te, ie, "⇃", "\\downharpoonleft", !0);
E(I, B, ie, "⊶", "\\origof", !0);
E(I, B, ie, "⊷", "\\imageof", !0);
E(I, te, ie, "⊸", "\\multimap", !0);
E(I, te, ie, "↭", "\\leftrightsquigarrow", !0);
E(I, te, ie, "⇉", "\\rightrightarrows", !0);
E(I, te, ie, "⇄", "\\rightleftarrows", !0);
E(I, te, ie, "↠", "\\twoheadrightarrow", !0);
E(I, te, ie, "↣", "\\rightarrowtail", !0);
E(I, te, ie, "↬", "\\looparrowright", !0);
E(I, te, ie, "↷", "\\curvearrowright", !0);
E(I, te, ie, "↻", "\\circlearrowright", !0);
E(I, te, ie, "↱", "\\Rsh", !0);
E(I, te, ie, "⇊", "\\downdownarrows", !0);
E(I, te, ie, "↾", "\\upharpoonright", !0);
E(I, te, ie, "⇂", "\\downharpoonright", !0);
E(I, te, ie, "⇝", "\\rightsquigarrow", !0);
E(I, te, ie, "⇝", "\\leadsto");
E(I, te, ie, "⇛", "\\Rrightarrow", !0);
E(I, te, ie, "↾", "\\restriction");
E(I, B, ce, "‘", "`");
E(I, B, ce, "$", "\\$");
E(He, B, ce, "$", "\\$");
E(He, B, ce, "$", "\\textdollar");
E(I, B, ce, "%", "\\%");
E(He, B, ce, "%", "\\%");
E(I, B, ce, "_", "\\_");
E(He, B, ce, "_", "\\_");
E(He, B, ce, "_", "\\textunderscore");
E(I, B, ce, "∠", "\\angle", !0);
E(I, B, ce, "∞", "\\infty", !0);
E(I, B, ce, "′", "\\prime");
E(I, B, ce, "△", "\\triangle");
E(I, B, ce, "Γ", "\\Gamma", !0);
E(I, B, ce, "Δ", "\\Delta", !0);
E(I, B, ce, "Θ", "\\Theta", !0);
E(I, B, ce, "Λ", "\\Lambda", !0);
E(I, B, ce, "Ξ", "\\Xi", !0);
E(I, B, ce, "Π", "\\Pi", !0);
E(I, B, ce, "Σ", "\\Sigma", !0);
E(I, B, ce, "Υ", "\\Upsilon", !0);
E(I, B, ce, "Φ", "\\Phi", !0);
E(I, B, ce, "Ψ", "\\Psi", !0);
E(I, B, ce, "Ω", "\\Omega", !0);
E(I, B, ce, "A", "Α");
E(I, B, ce, "B", "Β");
E(I, B, ce, "E", "Ε");
E(I, B, ce, "Z", "Ζ");
E(I, B, ce, "H", "Η");
E(I, B, ce, "I", "Ι");
E(I, B, ce, "K", "Κ");
E(I, B, ce, "M", "Μ");
E(I, B, ce, "N", "Ν");
E(I, B, ce, "O", "Ο");
E(I, B, ce, "P", "Ρ");
E(I, B, ce, "T", "Τ");
E(I, B, ce, "X", "Χ");
E(I, B, ce, "¬", "\\neg", !0);
E(I, B, ce, "¬", "\\lnot");
E(I, B, ce, "⊤", "\\top");
E(I, B, ce, "⊥", "\\bot");
E(I, B, ce, "∅", "\\emptyset");
E(I, te, ce, "∅", "\\varnothing");
E(I, B, At, "α", "\\alpha", !0);
E(I, B, At, "β", "\\beta", !0);
E(I, B, At, "γ", "\\gamma", !0);
E(I, B, At, "δ", "\\delta", !0);
E(I, B, At, "ϵ", "\\epsilon", !0);
E(I, B, At, "ζ", "\\zeta", !0);
E(I, B, At, "η", "\\eta", !0);
E(I, B, At, "θ", "\\theta", !0);
E(I, B, At, "ι", "\\iota", !0);
E(I, B, At, "κ", "\\kappa", !0);
E(I, B, At, "λ", "\\lambda", !0);
E(I, B, At, "μ", "\\mu", !0);
E(I, B, At, "ν", "\\nu", !0);
E(I, B, At, "ξ", "\\xi", !0);
E(I, B, At, "ο", "\\omicron", !0);
E(I, B, At, "π", "\\pi", !0);
E(I, B, At, "ρ", "\\rho", !0);
E(I, B, At, "σ", "\\sigma", !0);
E(I, B, At, "τ", "\\tau", !0);
E(I, B, At, "υ", "\\upsilon", !0);
E(I, B, At, "ϕ", "\\phi", !0);
E(I, B, At, "χ", "\\chi", !0);
E(I, B, At, "ψ", "\\psi", !0);
E(I, B, At, "ω", "\\omega", !0);
E(I, B, At, "ε", "\\varepsilon", !0);
E(I, B, At, "ϑ", "\\vartheta", !0);
E(I, B, At, "ϖ", "\\varpi", !0);
E(I, B, At, "ϱ", "\\varrho", !0);
E(I, B, At, "ς", "\\varsigma", !0);
E(I, B, At, "φ", "\\varphi", !0);
E(I, B, lt, "∗", "*", !0);
E(I, B, lt, "+", "+");
E(I, B, lt, "−", "-", !0);
E(I, B, lt, "⋅", "\\cdot", !0);
E(I, B, lt, "∘", "\\circ", !0);
E(I, B, lt, "÷", "\\div", !0);
E(I, B, lt, "±", "\\pm", !0);
E(I, B, lt, "×", "\\times", !0);
E(I, B, lt, "∩", "\\cap", !0);
E(I, B, lt, "∪", "\\cup", !0);
E(I, B, lt, "∖", "\\setminus", !0);
E(I, B, lt, "∧", "\\land");
E(I, B, lt, "∨", "\\lor");
E(I, B, lt, "∧", "\\wedge", !0);
E(I, B, lt, "∨", "\\vee", !0);
E(I, B, ce, "√", "\\surd");
E(I, B, la, "⟨", "\\langle", !0);
E(I, B, la, "∣", "\\lvert");
E(I, B, la, "∥", "\\lVert");
E(I, B, gi, "?", "?");
E(I, B, gi, "!", "!");
E(I, B, gi, "⟩", "\\rangle", !0);
E(I, B, gi, "∣", "\\rvert");
E(I, B, gi, "∥", "\\rVert");
E(I, B, ie, "=", "=");
E(I, B, ie, ":", ":");
E(I, B, ie, "≈", "\\approx", !0);
E(I, B, ie, "≅", "\\cong", !0);
E(I, B, ie, "≥", "\\ge");
E(I, B, ie, "≥", "\\geq", !0);
E(I, B, ie, "←", "\\gets");
E(I, B, ie, ">", "\\gt", !0);
E(I, B, ie, "∈", "\\in", !0);
E(I, B, ie, "", "\\@not");
E(I, B, ie, "⊂", "\\subset", !0);
E(I, B, ie, "⊃", "\\supset", !0);
E(I, B, ie, "⊆", "\\subseteq", !0);
E(I, B, ie, "⊇", "\\supseteq", !0);
E(I, te, ie, "⊈", "\\nsubseteq", !0);
E(I, te, ie, "⊉", "\\nsupseteq", !0);
E(I, B, ie, "⊨", "\\models");
E(I, B, ie, "←", "\\leftarrow", !0);
E(I, B, ie, "≤", "\\le");
E(I, B, ie, "≤", "\\leq", !0);
E(I, B, ie, "<", "\\lt", !0);
E(I, B, ie, "→", "\\rightarrow", !0);
E(I, B, ie, "→", "\\to");
E(I, te, ie, "≱", "\\ngeq", !0);
E(I, te, ie, "≰", "\\nleq", !0);
E(I, B, Tl, " ", "\\ ");
E(I, B, Tl, " ", "\\space");
E(I, B, Tl, " ", "\\nobreakspace");
E(He, B, Tl, " ", "\\ ");
E(He, B, Tl, " ", " ");
E(He, B, Tl, " ", "\\space");
E(He, B, Tl, " ", "\\nobreakspace");
E(I, B, Tl, null, "\\nobreak");
E(I, B, Tl, null, "\\allowbreak");
E(I, B, C5, ",", ",");
E(I, B, C5, ";", ";");
E(I, te, lt, "⊼", "\\barwedge", !0);
E(I, te, lt, "⊻", "\\veebar", !0);
E(I, B, lt, "⊙", "\\odot", !0);
E(I, B, lt, "⊕", "\\oplus", !0);
E(I, B, lt, "⊗", "\\otimes", !0);
E(I, B, ce, "∂", "\\partial", !0);
E(I, B, lt, "⊘", "\\oslash", !0);
E(I, te, lt, "⊚", "\\circledcirc", !0);
E(I, te, lt, "⊡", "\\boxdot", !0);
E(I, B, lt, "△", "\\bigtriangleup");
E(I, B, lt, "▽", "\\bigtriangledown");
E(I, B, lt, "†", "\\dagger");
E(I, B, lt, "⋄", "\\diamond");
E(I, B, lt, "⋆", "\\star");
E(I, B, lt, "◃", "\\triangleleft");
E(I, B, lt, "▹", "\\triangleright");
E(I, B, la, "{", "\\{");
E(He, B, ce, "{", "\\{");
E(He, B, ce, "{", "\\textbraceleft");
E(I, B, gi, "}", "\\}");
E(He, B, ce, "}", "\\}");
E(He, B, ce, "}", "\\textbraceright");
E(I, B, la, "{", "\\lbrace");
E(I, B, gi, "}", "\\rbrace");
E(I, B, la, "[", "\\lbrack", !0);
E(He, B, ce, "[", "\\lbrack", !0);
E(I, B, gi, "]", "\\rbrack", !0);
E(He, B, ce, "]", "\\rbrack", !0);
E(I, B, la, "(", "\\lparen", !0);
E(I, B, gi, ")", "\\rparen", !0);
E(He, B, ce, "<", "\\textless", !0);
E(He, B, ce, ">", "\\textgreater", !0);
E(I, B, la, "⌊", "\\lfloor", !0);
E(I, B, gi, "⌋", "\\rfloor", !0);
E(I, B, la, "⌈", "\\lceil", !0);
E(I, B, gi, "⌉", "\\rceil", !0);
E(I, B, ce, "\\", "\\backslash");
E(I, B, ce, "∣", "|");
E(I, B, ce, "∣", "\\vert");
E(He, B, ce, "|", "\\textbar", !0);
E(I, B, ce, "∥", "\\|");
E(I, B, ce, "∥", "\\Vert");
E(He, B, ce, "∥", "\\textbardbl");
E(He, B, ce, "~", "\\textasciitilde");
E(He, B, ce, "\\", "\\textbackslash");
E(He, B, ce, "^", "\\textasciicircum");
E(I, B, ie, "↑", "\\uparrow", !0);
E(I, B, ie, "⇑", "\\Uparrow", !0);
E(I, B, ie, "↓", "\\downarrow", !0);
E(I, B, ie, "⇓", "\\Downarrow", !0);
E(I, B, ie, "↕", "\\updownarrow", !0);
E(I, B, ie, "⇕", "\\Updownarrow", !0);
E(I, B, cr, "∐", "\\coprod");
E(I, B, cr, "⋁", "\\bigvee");
E(I, B, cr, "⋀", "\\bigwedge");
E(I, B, cr, "⨄", "\\biguplus");
E(I, B, cr, "⋂", "\\bigcap");
E(I, B, cr, "⋃", "\\bigcup");
E(I, B, cr, "∫", "\\int");
E(I, B, cr, "∫", "\\intop");
E(I, B, cr, "∬", "\\iint");
E(I, B, cr, "∭", "\\iiint");
E(I, B, cr, "∏", "\\prod");
E(I, B, cr, "∑", "\\sum");
E(I, B, cr, "⨂", "\\bigotimes");
E(I, B, cr, "⨁", "\\bigoplus");
E(I, B, cr, "⨀", "\\bigodot");
E(I, B, cr, "∮", "\\oint");
E(I, B, cr, "∯", "\\oiint");
E(I, B, cr, "∰", "\\oiiint");
E(I, B, cr, "⨆", "\\bigsqcup");
E(I, B, cr, "∫", "\\smallint");
E(He, B, $d, "…", "\\textellipsis");
E(I, B, $d, "…", "\\mathellipsis");
E(He, B, $d, "…", "\\ldots", !0);
E(I, B, $d, "…", "\\ldots", !0);
E(I, B, $d, "⋯", "\\@cdots", !0);
E(I, B, $d, "⋱", "\\ddots", !0);
E(I, B, ce, "⋮", "\\varvdots");
E(He, B, ce, "⋮", "\\varvdots");
E(I, B, Dn, "ˊ", "\\acute");
E(I, B, Dn, "ˋ", "\\grave");
E(I, B, Dn, "¨", "\\ddot");
E(I, B, Dn, "~", "\\tilde");
E(I, B, Dn, "ˉ", "\\bar");
E(I, B, Dn, "˘", "\\breve");
E(I, B, Dn, "ˇ", "\\check");
E(I, B, Dn, "^", "\\hat");
E(I, B, Dn, "⃗", "\\vec");
E(I, B, Dn, "˙", "\\dot");
E(I, B, Dn, "˚", "\\mathring");
E(I, B, At, "", "\\@imath");
E(I, B, At, "", "\\@jmath");
E(I, B, ce, "ı", "ı");
E(I, B, ce, "ȷ", "ȷ");
E(He, B, ce, "ı", "\\i", !0);
E(He, B, ce, "ȷ", "\\j", !0);
E(He, B, ce, "ß", "\\ss", !0);
E(He, B, ce, "æ", "\\ae", !0);
E(He, B, ce, "œ", "\\oe", !0);
E(He, B, ce, "ø", "\\o", !0);
E(He, B, ce, "Æ", "\\AE", !0);
E(He, B, ce, "Œ", "\\OE", !0);
E(He, B, ce, "Ø", "\\O", !0);
E(He, B, Dn, "ˊ", "\\'");
E(He, B, Dn, "ˋ", "\\`");
E(He, B, Dn, "ˆ", "\\^");
E(He, B, Dn, "˜", "\\~");
E(He, B, Dn, "ˉ", "\\=");
E(He, B, Dn, "˘", "\\u");
E(He, B, Dn, "˙", "\\.");
E(He, B, Dn, "¸", "\\c");
E(He, B, Dn, "˚", "\\r");
E(He, B, Dn, "ˇ", "\\v");
E(He, B, Dn, "¨", '\\"');
E(He, B, Dn, "˝", "\\H");
E(He, B, Dn, "◯", "\\textcircled");
var dne = {
  "--": !0,
  "---": !0,
  "``": !0,
  "''": !0
};
E(He, B, ce, "–", "--", !0);
E(He, B, ce, "–", "\\textendash");
E(He, B, ce, "—", "---", !0);
E(He, B, ce, "—", "\\textemdash");
E(He, B, ce, "‘", "`", !0);
E(He, B, ce, "‘", "\\textquoteleft");
E(He, B, ce, "’", "'", !0);
E(He, B, ce, "’", "\\textquoteright");
E(He, B, ce, "“", "``", !0);
E(He, B, ce, "“", "\\textquotedblleft");
E(He, B, ce, "”", "''", !0);
E(He, B, ce, "”", "\\textquotedblright");
E(I, B, ce, "°", "\\degree", !0);
E(He, B, ce, "°", "\\degree");
E(He, B, ce, "°", "\\textdegree", !0);
E(I, B, ce, "£", "\\pounds");
E(I, B, ce, "£", "\\mathsterling", !0);
E(He, B, ce, "£", "\\pounds");
E(He, B, ce, "£", "\\textsterling", !0);
E(I, te, ce, "✠", "\\maltese");
E(He, te, ce, "✠", "\\maltese");
var lO = '0123456789/@."';
for (var Ib = 0; Ib < lO.length; Ib++) {
  var cO = lO.charAt(Ib);
  E(I, B, ce, cO, cO);
}
var uO = '0123456789!@*()-=+";:?/.,';
for (var Pb = 0; Pb < uO.length; Pb++) {
  var dO = uO.charAt(Pb);
  E(He, B, ce, dO, dO);
}
var lg = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
for (var zb = 0; zb < lg.length; zb++) {
  var x4 = lg.charAt(zb);
  E(I, B, At, x4, x4), E(He, B, ce, x4, x4);
}
E(I, te, ce, "C", "ℂ");
E(He, te, ce, "C", "ℂ");
E(I, te, ce, "H", "ℍ");
E(He, te, ce, "H", "ℍ");
E(I, te, ce, "N", "ℕ");
E(He, te, ce, "N", "ℕ");
E(I, te, ce, "P", "ℙ");
E(He, te, ce, "P", "ℙ");
E(I, te, ce, "Q", "ℚ");
E(He, te, ce, "Q", "ℚ");
E(I, te, ce, "R", "ℝ");
E(He, te, ce, "R", "ℝ");
E(I, te, ce, "Z", "ℤ");
E(He, te, ce, "Z", "ℤ");
E(I, B, At, "h", "ℎ");
E(He, B, At, "h", "ℎ");
var It = "";
for (var ii = 0; ii < lg.length; ii++) {
  var Wn = lg.charAt(ii);
  It = String.fromCharCode(55349, 56320 + ii), E(I, B, At, Wn, It), E(He, B, ce, Wn, It), It = String.fromCharCode(55349, 56372 + ii), E(I, B, At, Wn, It), E(He, B, ce, Wn, It), It = String.fromCharCode(55349, 56424 + ii), E(I, B, At, Wn, It), E(He, B, ce, Wn, It), It = String.fromCharCode(55349, 56580 + ii), E(I, B, At, Wn, It), E(He, B, ce, Wn, It), It = String.fromCharCode(55349, 56684 + ii), E(I, B, At, Wn, It), E(He, B, ce, Wn, It), It = String.fromCharCode(55349, 56736 + ii), E(I, B, At, Wn, It), E(He, B, ce, Wn, It), It = String.fromCharCode(55349, 56788 + ii), E(I, B, At, Wn, It), E(He, B, ce, Wn, It), It = String.fromCharCode(55349, 56840 + ii), E(I, B, At, Wn, It), E(He, B, ce, Wn, It), It = String.fromCharCode(55349, 56944 + ii), E(I, B, At, Wn, It), E(He, B, ce, Wn, It), ii < 26 && (It = String.fromCharCode(55349, 56632 + ii), E(I, B, At, Wn, It), E(He, B, ce, Wn, It), It = String.fromCharCode(55349, 56476 + ii), E(I, B, At, Wn, It), E(He, B, ce, Wn, It));
}
It = "𝕜";
E(I, B, At, "k", It);
E(He, B, ce, "k", It);
for (var iu = 0; iu < 10; iu++) {
  var Hl = iu.toString();
  It = String.fromCharCode(55349, 57294 + iu), E(I, B, At, Hl, It), E(He, B, ce, Hl, It), It = String.fromCharCode(55349, 57314 + iu), E(I, B, At, Hl, It), E(He, B, ce, Hl, It), It = String.fromCharCode(55349, 57324 + iu), E(I, B, At, Hl, It), E(He, B, ce, Hl, It), It = String.fromCharCode(55349, 57334 + iu), E(I, B, At, Hl, It), E(He, B, ce, Hl, It);
}
var zk = "ÐÞþ";
for (var Rb = 0; Rb < zk.length; Rb++) {
  var M4 = zk.charAt(Rb);
  E(I, B, At, M4, M4), E(He, B, ce, M4, M4);
}
var C4 = [
  ["mathbf", "textbf", "Main-Bold"],
  // A-Z bold upright
  ["mathbf", "textbf", "Main-Bold"],
  // a-z bold upright
  ["mathnormal", "textit", "Math-Italic"],
  // A-Z italic
  ["mathnormal", "textit", "Math-Italic"],
  // a-z italic
  ["boldsymbol", "boldsymbol", "Main-BoldItalic"],
  // A-Z bold italic
  ["boldsymbol", "boldsymbol", "Main-BoldItalic"],
  // a-z bold italic
  // Map fancy A-Z letters to script, not calligraphic.
  // This aligns with unicode-math and math fonts (except Cambria Math).
  ["mathscr", "textscr", "Script-Regular"],
  // A-Z script
  ["", "", ""],
  // a-z script.  No font
  ["", "", ""],
  // A-Z bold script. No font
  ["", "", ""],
  // a-z bold script. No font
  ["mathfrak", "textfrak", "Fraktur-Regular"],
  // A-Z Fraktur
  ["mathfrak", "textfrak", "Fraktur-Regular"],
  // a-z Fraktur
  ["mathbb", "textbb", "AMS-Regular"],
  // A-Z double-struck
  ["mathbb", "textbb", "AMS-Regular"],
  // k double-struck
  // Note that we are using a bold font, but font metrics for regular Fraktur.
  ["mathboldfrak", "textboldfrak", "Fraktur-Regular"],
  // A-Z bold Fraktur
  ["mathboldfrak", "textboldfrak", "Fraktur-Regular"],
  // a-z bold Fraktur
  ["mathsf", "textsf", "SansSerif-Regular"],
  // A-Z sans-serif
  ["mathsf", "textsf", "SansSerif-Regular"],
  // a-z sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // A-Z bold sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // a-z bold sans-serif
  ["mathitsf", "textitsf", "SansSerif-Italic"],
  // A-Z italic sans-serif
  ["mathitsf", "textitsf", "SansSerif-Italic"],
  // a-z italic sans-serif
  ["", "", ""],
  // A-Z bold italic sans. No font
  ["", "", ""],
  // a-z bold italic sans. No font
  ["mathtt", "texttt", "Typewriter-Regular"],
  // A-Z monospace
  ["mathtt", "texttt", "Typewriter-Regular"]
  // a-z monospace
], fO = [
  ["mathbf", "textbf", "Main-Bold"],
  // 0-9 bold
  ["", "", ""],
  // 0-9 double-struck. No KaTeX font.
  ["mathsf", "textsf", "SansSerif-Regular"],
  // 0-9 sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // 0-9 bold sans-serif
  ["mathtt", "texttt", "Typewriter-Regular"]
  // 0-9 monospace
], dqt = function(e, n) {
  var r = e.charCodeAt(0), i = e.charCodeAt(1), a = (r - 55296) * 1024 + (i - 56320) + 65536, o = n === "math" ? 0 : 1;
  if (119808 <= a && a < 120484) {
    var s = Math.floor((a - 119808) / 26);
    return [C4[s][2], C4[s][o]];
  } else if (120782 <= a && a <= 120831) {
    var l = Math.floor((a - 120782) / 10);
    return [fO[l][2], fO[l][o]];
  } else {
    if (a === 120485 || a === 120486)
      return [C4[0][2], C4[0][o]];
    if (120486 < a && a < 120782)
      return ["", ""];
    throw new Ge("Unsupported character: " + e);
  }
}, A5 = function(e, n, r) {
  return kn[r][e] && kn[r][e].replace && (e = kn[r][e].replace), {
    value: e,
    metrics: xL(e, n, r)
  };
}, Za = function(e, n, r, i, a) {
  var o = A5(e, n, r), s = o.metrics;
  e = o.value;
  var l;
  if (s) {
    var c = s.italic;
    (r === "text" || i && i.font === "mathit") && (c = 0), l = new Oa(e, s.height, s.depth, c, s.skew, s.width, a);
  } else
    typeof console < "u" && console.warn("No character metrics " + ("for '" + e + "' in style '" + n + "' and mode '" + r + "'")), l = new Oa(e, 0, 0, 0, 0, 0, a);
  if (i) {
    l.maxFontSize = i.sizeMultiplier, i.style.isTight() && l.classes.push("mtight");
    var u = i.getColor();
    u && (l.style.color = u);
  }
  return l;
}, fqt = function(e, n, r, i) {
  return i === void 0 && (i = []), r.font === "boldsymbol" && A5(e, "Main-Bold", n).metrics ? Za(e, "Main-Bold", n, r, i.concat(["mathbf"])) : e === "\\" || kn[n][e].font === "main" ? Za(e, "Main-Regular", n, r, i) : Za(e, "AMS-Regular", n, r, i.concat(["amsrm"]));
}, hqt = function(e, n, r, i, a) {
  return a !== "textord" && A5(e, "Math-BoldItalic", n).metrics ? {
    fontName: "Math-BoldItalic",
    fontClass: "boldsymbol"
  } : {
    fontName: "Main-Bold",
    fontClass: "mathbf"
  };
}, pqt = function(e, n, r) {
  var i = e.mode, a = e.text, o = ["mord"], s = i === "math" || i === "text" && n.font, l = s ? n.font : n.fontFamily, c = "", u = "";
  if (a.charCodeAt(0) === 55349 && ([c, u] = dqt(a, i)), c.length > 0)
    return Za(a, c, i, n, o.concat(u));
  if (l) {
    var d, f;
    if (l === "boldsymbol") {
      var h = hqt(a, i, n, o, r);
      d = h.fontName, f = [h.fontClass];
    } else s ? (d = pne[l].fontName, f = [l]) : (d = A4(l, n.fontWeight, n.fontShape), f = [l, n.fontWeight, n.fontShape]);
    if (A5(a, d, i).metrics)
      return Za(a, d, i, n, o.concat(f));
    if (dne.hasOwnProperty(a) && d.slice(0, 10) === "Typewriter") {
      for (var p = [], m = 0; m < a.length; m++)
        p.push(Za(a[m], d, i, n, o.concat(f)));
      return hne(p);
    }
  }
  if (r === "mathord")
    return Za(a, "Math-Italic", i, n, o.concat(["mathnormal"]));
  if (r === "textord") {
    var g = kn[i][a] && kn[i][a].font;
    if (g === "ams") {
      var v = A4("amsrm", n.fontWeight, n.fontShape);
      return Za(a, v, i, n, o.concat("amsrm", n.fontWeight, n.fontShape));
    } else if (g === "main" || !g) {
      var k = A4("textrm", n.fontWeight, n.fontShape);
      return Za(a, k, i, n, o.concat(n.fontWeight, n.fontShape));
    } else {
      var w = A4(g, n.fontWeight, n.fontShape);
      return Za(a, w, i, n, o.concat(w, n.fontWeight, n.fontShape));
    }
  } else
    throw new Error("unexpected type: " + r + " in makeOrd");
}, mqt = (t, e) => {
  if (Ic(t.classes) !== Ic(e.classes) || t.skew !== e.skew || t.maxFontSize !== e.maxFontSize)
    return !1;
  if (t.classes.length === 1) {
    var n = t.classes[0];
    if (n === "mbin" || n === "mord")
      return !1;
  }
  for (var r in t.style)
    if (t.style.hasOwnProperty(r) && t.style[r] !== e.style[r])
      return !1;
  for (var i in e.style)
    if (e.style.hasOwnProperty(i) && t.style[i] !== e.style[i])
      return !1;
  return !0;
}, yqt = (t) => {
  for (var e = 0; e < t.length - 1; e++) {
    var n = t[e], r = t[e + 1];
    n instanceof Oa && r instanceof Oa && mqt(n, r) && (n.text += r.text, n.height = Math.max(n.height, r.height), n.depth = Math.max(n.depth, r.depth), n.italic = r.italic, t.splice(e + 1, 1), e--);
  }
  return t;
}, CL = function(e) {
  for (var n = 0, r = 0, i = 0, a = 0; a < e.children.length; a++) {
    var o = e.children[a];
    o.height > n && (n = o.height), o.depth > r && (r = o.depth), o.maxFontSize > i && (i = o.maxFontSize);
  }
  e.height = n, e.depth = r, e.maxFontSize = i;
}, wi = function(e, n, r, i) {
  var a = new sm(e, n, r, i);
  return CL(a), a;
}, fne = (t, e, n, r) => new sm(t, e, n, r), gqt = function(e, n, r) {
  var i = wi([e], [], n);
  return i.height = Math.max(r || n.fontMetrics().defaultRuleThickness, n.minRuleThickness), i.style.borderBottomWidth = Qe(i.height), i.maxFontSize = 1, i;
}, vqt = function(e, n, r, i) {
  var a = new ML(e, n, r, i);
  return CL(a), a;
}, hne = function(e) {
  var n = new om(e);
  return CL(n), n;
}, bqt = function(e, n) {
  return e instanceof om ? wi([], [e], n) : e;
}, wqt = function(e) {
  if (e.positionType === "individualShift") {
    for (var n = e.children, r = [n[0]], i = -n[0].shift - n[0].elem.depth, a = i, o = 1; o < n.length; o++) {
      var s = -n[o].shift - a - n[o].elem.depth, l = s - (n[o - 1].elem.height + n[o - 1].elem.depth);
      a = a + s, r.push({
        type: "kern",
        size: l
      }), r.push(n[o]);
    }
    return {
      children: r,
      depth: i
    };
  }
  var c;
  if (e.positionType === "top") {
    for (var u = e.positionData, d = 0; d < e.children.length; d++) {
      var f = e.children[d];
      u -= f.type === "kern" ? f.size : f.elem.height + f.elem.depth;
    }
    c = u;
  } else if (e.positionType === "bottom")
    c = -e.positionData;
  else {
    var h = e.children[0];
    if (h.type !== "elem")
      throw new Error('First child must have type "elem".');
    if (e.positionType === "shift")
      c = -h.elem.depth - e.positionData;
    else if (e.positionType === "firstBaseline")
      c = -h.elem.depth;
    else
      throw new Error("Invalid positionType " + e.positionType + ".");
  }
  return {
    children: e.children,
    depth: c
  };
}, kqt = function(e, n) {
  for (var {
    children: r,
    depth: i
  } = wqt(e), a = 0, o = 0; o < r.length; o++) {
    var s = r[o];
    if (s.type === "elem") {
      var l = s.elem;
      a = Math.max(a, l.maxFontSize, l.height);
    }
  }
  a += 2;
  var c = wi(["pstrut"], []);
  c.style.height = Qe(a);
  for (var u = [], d = i, f = i, h = i, p = 0; p < r.length; p++) {
    var m = r[p];
    if (m.type === "kern")
      h += m.size;
    else {
      var g = m.elem, v = m.wrapperClasses || [], k = m.wrapperStyle || {}, w = wi(v, [c, g], void 0, k);
      w.style.top = Qe(-a - h - g.depth), m.marginLeft && (w.style.marginLeft = m.marginLeft), m.marginRight && (w.style.marginRight = m.marginRight), u.push(w), h += g.height + g.depth;
    }
    d = Math.min(d, h), f = Math.max(f, h);
  }
  var b = wi(["vlist"], u);
  b.style.height = Qe(f);
  var x;
  if (d < 0) {
    var A = wi([], []), L = wi(["vlist"], [A]);
    L.style.height = Qe(-d);
    var M = wi(["vlist-s"], [new Oa("​")]);
    x = [wi(["vlist-r"], [b, M]), wi(["vlist-r"], [L])];
  } else
    x = [wi(["vlist-r"], [b])];
  var j = wi(["vlist-t"], x);
  return x.length === 2 && j.classes.push("vlist-t2"), j.height = f, j.depth = -d, j;
}, xqt = (t, e) => {
  var n = wi(["mspace"], [], e), r = Bn(t, e);
  return n.style.marginRight = Qe(r), n;
}, A4 = function(e, n, r) {
  var i = "";
  switch (e) {
    case "amsrm":
      i = "AMS";
      break;
    case "textrm":
      i = "Main";
      break;
    case "textsf":
      i = "SansSerif";
      break;
    case "texttt":
      i = "Typewriter";
      break;
    default:
      i = e;
  }
  var a;
  return n === "textbf" && r === "textit" ? a = "BoldItalic" : n === "textbf" ? a = "Bold" : n === "textit" ? a = "Italic" : a = "Regular", i + "-" + a;
}, pne = {
  // styles
  mathbf: {
    variant: "bold",
    fontName: "Main-Bold"
  },
  mathrm: {
    variant: "normal",
    fontName: "Main-Regular"
  },
  textit: {
    variant: "italic",
    fontName: "Main-Italic"
  },
  mathit: {
    variant: "italic",
    fontName: "Main-Italic"
  },
  mathnormal: {
    variant: "italic",
    fontName: "Math-Italic"
  },
  mathsfit: {
    variant: "sans-serif-italic",
    fontName: "SansSerif-Italic"
  },
  // "boldsymbol" is missing because they require the use of multiple fonts:
  // Math-BoldItalic and Main-Bold.  This is handled by a special case in
  // makeOrd which ends up calling boldsymbol.
  // families
  mathbb: {
    variant: "double-struck",
    fontName: "AMS-Regular"
  },
  mathcal: {
    variant: "script",
    fontName: "Caligraphic-Regular"
  },
  mathfrak: {
    variant: "fraktur",
    fontName: "Fraktur-Regular"
  },
  mathscr: {
    variant: "script",
    fontName: "Script-Regular"
  },
  mathsf: {
    variant: "sans-serif",
    fontName: "SansSerif-Regular"
  },
  mathtt: {
    variant: "monospace",
    fontName: "Typewriter-Regular"
  }
}, mne = {
  //   path, width, height
  vec: ["vec", 0.471, 0.714],
  // values from the font glyph
  oiintSize1: ["oiintSize1", 0.957, 0.499],
  // oval to overlay the integrand
  oiintSize2: ["oiintSize2", 1.472, 0.659],
  oiiintSize1: ["oiiintSize1", 1.304, 0.499],
  oiiintSize2: ["oiiintSize2", 1.98, 0.659]
}, Mqt = function(e, n) {
  var [r, i, a] = mne[e], o = new Pc(r), s = new wl([o], {
    width: Qe(i),
    height: Qe(a),
    // Override CSS rule `.katex svg { width: 100% }`
    style: "width:" + Qe(i),
    viewBox: "0 0 " + 1e3 * i + " " + 1e3 * a,
    preserveAspectRatio: "xMinYMin"
  }), l = fne(["overlay"], [s], n);
  return l.height = a, l.style.height = Qe(a), l.style.width = Qe(i), l;
}, ke = {
  fontMap: pne,
  makeSymbol: Za,
  mathsym: fqt,
  makeSpan: wi,
  makeSvgSpan: fne,
  makeLineSpan: gqt,
  makeAnchor: vqt,
  makeFragment: hne,
  wrapFragment: bqt,
  makeVList: kqt,
  makeOrd: pqt,
  makeGlue: xqt,
  staticSvg: Mqt,
  svgData: mne,
  tryCombineChars: yqt
}, In = {
  number: 3,
  unit: "mu"
}, au = {
  number: 4,
  unit: "mu"
}, Ns = {
  number: 5,
  unit: "mu"
}, Cqt = {
  mord: {
    mop: In,
    mbin: au,
    mrel: Ns,
    minner: In
  },
  mop: {
    mord: In,
    mop: In,
    mrel: Ns,
    minner: In
  },
  mbin: {
    mord: au,
    mop: au,
    mopen: au,
    minner: au
  },
  mrel: {
    mord: Ns,
    mop: Ns,
    mopen: Ns,
    minner: Ns
  },
  mopen: {},
  mclose: {
    mop: In,
    mbin: au,
    mrel: Ns,
    minner: In
  },
  mpunct: {
    mord: In,
    mop: In,
    mrel: Ns,
    mopen: In,
    mclose: In,
    mpunct: In,
    minner: In
  },
  minner: {
    mord: In,
    mop: In,
    mbin: au,
    mrel: Ns,
    mopen: In,
    mpunct: In,
    minner: In
  }
}, Aqt = {
  mord: {
    mop: In
  },
  mop: {
    mord: In,
    mop: In
  },
  mbin: {},
  mrel: {},
  mopen: {},
  mclose: {
    mop: In
  },
  mpunct: {},
  minner: {
    mop: In
  }
}, yne = {}, cg = {}, ug = {};
function at(t) {
  for (var {
    type: e,
    names: n,
    props: r,
    handler: i,
    htmlBuilder: a,
    mathmlBuilder: o
  } = t, s = {
    type: e,
    numArgs: r.numArgs,
    argTypes: r.argTypes,
    allowedInArgument: !!r.allowedInArgument,
    allowedInText: !!r.allowedInText,
    allowedInMath: r.allowedInMath === void 0 ? !0 : r.allowedInMath,
    numOptionalArgs: r.numOptionalArgs || 0,
    infix: !!r.infix,
    primitive: !!r.primitive,
    handler: i
  }, l = 0; l < n.length; ++l)
    yne[n[l]] = s;
  e && (a && (cg[e] = a), o && (ug[e] = o));
}
function j0(t) {
  var {
    type: e,
    htmlBuilder: n,
    mathmlBuilder: r
  } = t;
  at({
    type: e,
    names: [],
    props: {
      numArgs: 0
    },
    handler() {
      throw new Error("Should never be called.");
    },
    htmlBuilder: n,
    mathmlBuilder: r
  });
}
var dg = function(e) {
  return e.type === "ordgroup" && e.body.length === 1 ? e.body[0] : e;
}, rr = function(e) {
  return e.type === "ordgroup" ? e.body : [e];
}, kl = ke.makeSpan, Sqt = ["leftmost", "mbin", "mopen", "mrel", "mop", "mpunct"], Lqt = ["rightmost", "mrel", "mclose", "mpunct"], Tqt = {
  display: St.DISPLAY,
  text: St.TEXT,
  script: St.SCRIPT,
  scriptscript: St.SCRIPTSCRIPT
}, Eqt = {
  mord: "mord",
  mop: "mop",
  mbin: "mbin",
  mrel: "mrel",
  mopen: "mopen",
  mclose: "mclose",
  mpunct: "mpunct",
  minner: "minner"
}, yr = function(e, n, r, i) {
  i === void 0 && (i = [null, null]);
  for (var a = [], o = 0; o < e.length; o++) {
    var s = on(e[o], n);
    if (s instanceof om) {
      var l = s.children;
      a.push(...l);
    } else
      a.push(s);
  }
  if (ke.tryCombineChars(a), !r)
    return a;
  var c = n;
  if (e.length === 1) {
    var u = e[0];
    u.type === "sizing" ? c = n.havingSize(u.size) : u.type === "styling" && (c = n.havingStyle(Tqt[u.style]));
  }
  var d = kl([i[0] || "leftmost"], [], n), f = kl([i[1] || "rightmost"], [], n), h = r === "root";
  return hO(a, (p, m) => {
    var g = m.classes[0], v = p.classes[0];
    g === "mbin" && wt.contains(Lqt, v) ? m.classes[0] = "mord" : v === "mbin" && wt.contains(Sqt, g) && (p.classes[0] = "mord");
  }, {
    node: d
  }, f, h), hO(a, (p, m) => {
    var g = Rk(m), v = Rk(p), k = g && v ? p.hasClass("mtight") ? Aqt[g][v] : Cqt[g][v] : null;
    if (k)
      return ke.makeGlue(k, c);
  }, {
    node: d
  }, f, h), a;
}, hO = function t(e, n, r, i, a) {
  i && e.push(i);
  for (var o = 0; o < e.length; o++) {
    var s = e[o], l = gne(s);
    if (l) {
      t(l.children, n, r, null, a);
      continue;
    }
    var c = !s.hasClass("mspace");
    if (c) {
      var u = n(s, r.node);
      u && (r.insertAfter ? r.insertAfter(u) : (e.unshift(u), o++));
    }
    c ? r.node = s : a && s.hasClass("newline") && (r.node = kl(["leftmost"])), r.insertAfter = /* @__PURE__ */ ((d) => (f) => {
      e.splice(d + 1, 0, f), o++;
    })(o);
  }
  i && e.pop();
}, gne = function(e) {
  return e instanceof om || e instanceof ML || e instanceof sm && e.hasClass("enclosing") ? e : null;
}, jqt = function t(e, n) {
  var r = gne(e);
  if (r) {
    var i = r.children;
    if (i.length) {
      if (n === "right")
        return t(i[i.length - 1], "right");
      if (n === "left")
        return t(i[0], "left");
    }
  }
  return e;
}, Rk = function(e, n) {
  return e ? (n && (e = jqt(e, n)), Eqt[e.classes[0]] || null) : null;
}, J2 = function(e, n) {
  var r = ["nulldelimiter"].concat(e.baseSizingClasses());
  return kl(n.concat(r));
}, on = function(e, n, r) {
  if (!e)
    return kl();
  if (cg[e.type]) {
    var i = cg[e.type](e, n);
    if (r && n.size !== r.size) {
      i = kl(n.sizingClasses(r), [i], n);
      var a = n.sizeMultiplier / r.sizeMultiplier;
      i.height *= a, i.depth *= a;
    }
    return i;
  } else
    throw new Ge("Got group of unknown type: '" + e.type + "'");
};
function S4(t, e) {
  var n = kl(["base"], t, e), r = kl(["strut"]);
  return r.style.height = Qe(n.height + n.depth), n.depth && (r.style.verticalAlign = Qe(-n.depth)), n.children.unshift(r), n;
}
function Ok(t, e) {
  var n = null;
  t.length === 1 && t[0].type === "tag" && (n = t[0].tag, t = t[0].body);
  var r = yr(t, e, "root"), i;
  r.length === 2 && r[1].hasClass("tag") && (i = r.pop());
  for (var a = [], o = [], s = 0; s < r.length; s++)
    if (o.push(r[s]), r[s].hasClass("mbin") || r[s].hasClass("mrel") || r[s].hasClass("allowbreak")) {
      for (var l = !1; s < r.length - 1 && r[s + 1].hasClass("mspace") && !r[s + 1].hasClass("newline"); )
        s++, o.push(r[s]), r[s].hasClass("nobreak") && (l = !0);
      l || (a.push(S4(o, e)), o = []);
    } else r[s].hasClass("newline") && (o.pop(), o.length > 0 && (a.push(S4(o, e)), o = []), a.push(r[s]));
  o.length > 0 && a.push(S4(o, e));
  var c;
  n ? (c = S4(yr(n, e, !0)), c.classes = ["tag"], a.push(c)) : i && a.push(i);
  var u = kl(["katex-html"], a);
  if (u.setAttribute("aria-hidden", "true"), c) {
    var d = c.children[0];
    d.style.height = Qe(u.height + u.depth), u.depth && (d.style.verticalAlign = Qe(-u.depth));
  }
  return u;
}
function vne(t) {
  return new om(t);
}
class Ki {
  constructor(e, n, r) {
    this.type = void 0, this.attributes = void 0, this.children = void 0, this.classes = void 0, this.type = e, this.attributes = {}, this.children = n || [], this.classes = r || [];
  }
  /**
   * Sets an attribute on a MathML node. MathML depends on attributes to convey a
   * semantic content, so this is used heavily.
   */
  setAttribute(e, n) {
    this.attributes[e] = n;
  }
  /**
   * Gets an attribute on a MathML node.
   */
  getAttribute(e) {
    return this.attributes[e];
  }
  /**
   * Converts the math node into a MathML-namespaced DOM element.
   */
  toNode() {
    var e = document.createElementNS("http://www.w3.org/1998/Math/MathML", this.type);
    for (var n in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, n) && e.setAttribute(n, this.attributes[n]);
    this.classes.length > 0 && (e.className = Ic(this.classes));
    for (var r = 0; r < this.children.length; r++)
      if (this.children[r] instanceof qo && this.children[r + 1] instanceof qo) {
        for (var i = this.children[r].toText() + this.children[++r].toText(); this.children[r + 1] instanceof qo; )
          i += this.children[++r].toText();
        e.appendChild(new qo(i).toNode());
      } else
        e.appendChild(this.children[r].toNode());
    return e;
  }
  /**
   * Converts the math node into an HTML markup string.
   */
  toMarkup() {
    var e = "<" + this.type;
    for (var n in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, n) && (e += " " + n + '="', e += wt.escape(this.attributes[n]), e += '"');
    this.classes.length > 0 && (e += ' class ="' + wt.escape(Ic(this.classes)) + '"'), e += ">";
    for (var r = 0; r < this.children.length; r++)
      e += this.children[r].toMarkup();
    return e += "</" + this.type + ">", e;
  }
  /**
   * Converts the math node into a string, similar to innerText, but escaped.
   */
  toText() {
    return this.children.map((e) => e.toText()).join("");
  }
}
class qo {
  constructor(e) {
    this.text = void 0, this.text = e;
  }
  /**
   * Converts the text node into a DOM text node.
   */
  toNode() {
    return document.createTextNode(this.text);
  }
  /**
   * Converts the text node into escaped HTML markup
   * (representing the text itself).
   */
  toMarkup() {
    return wt.escape(this.toText());
  }
  /**
   * Converts the text node into a string
   * (representing the text itself).
   */
  toText() {
    return this.text;
  }
}
class Nqt {
  /**
   * Create a Space node with width given in CSS ems.
   */
  constructor(e) {
    this.width = void 0, this.character = void 0, this.width = e, e >= 0.05555 && e <= 0.05556 ? this.character = " " : e >= 0.1666 && e <= 0.1667 ? this.character = " " : e >= 0.2222 && e <= 0.2223 ? this.character = " " : e >= 0.2777 && e <= 0.2778 ? this.character = "  " : e >= -0.05556 && e <= -0.05555 ? this.character = " ⁣" : e >= -0.1667 && e <= -0.1666 ? this.character = " ⁣" : e >= -0.2223 && e <= -0.2222 ? this.character = " ⁣" : e >= -0.2778 && e <= -0.2777 ? this.character = " ⁣" : this.character = null;
  }
  /**
   * Converts the math node into a MathML-namespaced DOM element.
   */
  toNode() {
    if (this.character)
      return document.createTextNode(this.character);
    var e = document.createElementNS("http://www.w3.org/1998/Math/MathML", "mspace");
    return e.setAttribute("width", Qe(this.width)), e;
  }
  /**
   * Converts the math node into an HTML markup string.
   */
  toMarkup() {
    return this.character ? "<mtext>" + this.character + "</mtext>" : '<mspace width="' + Qe(this.width) + '"/>';
  }
  /**
   * Converts the math node into a string, similar to innerText.
   */
  toText() {
    return this.character ? this.character : " ";
  }
}
var qe = {
  MathNode: Ki,
  TextNode: qo,
  SpaceNode: Nqt,
  newDocumentFragment: vne
}, Ba = function(e, n, r) {
  return kn[n][e] && kn[n][e].replace && e.charCodeAt(0) !== 55349 && !(dne.hasOwnProperty(e) && r && (r.fontFamily && r.fontFamily.slice(4, 6) === "tt" || r.font && r.font.slice(4, 6) === "tt")) && (e = kn[n][e].replace), new qe.TextNode(e);
}, AL = function(e) {
  return e.length === 1 ? e[0] : new qe.MathNode("mrow", e);
}, SL = function(e, n) {
  if (n.fontFamily === "texttt")
    return "monospace";
  if (n.fontFamily === "textsf")
    return n.fontShape === "textit" && n.fontWeight === "textbf" ? "sans-serif-bold-italic" : n.fontShape === "textit" ? "sans-serif-italic" : n.fontWeight === "textbf" ? "bold-sans-serif" : "sans-serif";
  if (n.fontShape === "textit" && n.fontWeight === "textbf")
    return "bold-italic";
  if (n.fontShape === "textit")
    return "italic";
  if (n.fontWeight === "textbf")
    return "bold";
  var r = n.font;
  if (!r || r === "mathnormal")
    return null;
  var i = e.mode;
  if (r === "mathit")
    return "italic";
  if (r === "boldsymbol")
    return e.type === "textord" ? "bold" : "bold-italic";
  if (r === "mathbf")
    return "bold";
  if (r === "mathbb")
    return "double-struck";
  if (r === "mathsfit")
    return "sans-serif-italic";
  if (r === "mathfrak")
    return "fraktur";
  if (r === "mathscr" || r === "mathcal")
    return "script";
  if (r === "mathsf")
    return "sans-serif";
  if (r === "mathtt")
    return "monospace";
  var a = e.text;
  if (wt.contains(["\\imath", "\\jmath"], a))
    return null;
  kn[i][a] && kn[i][a].replace && (a = kn[i][a].replace);
  var o = ke.fontMap[r].fontName;
  return xL(a, o, i) ? ke.fontMap[r].variant : null;
};
function Ob(t) {
  if (!t)
    return !1;
  if (t.type === "mi" && t.children.length === 1) {
    var e = t.children[0];
    return e instanceof qo && e.text === ".";
  } else if (t.type === "mo" && t.children.length === 1 && t.getAttribute("separator") === "true" && t.getAttribute("lspace") === "0em" && t.getAttribute("rspace") === "0em") {
    var n = t.children[0];
    return n instanceof qo && n.text === ",";
  } else
    return !1;
}
var Bi = function(e, n, r) {
  if (e.length === 1) {
    var i = yn(e[0], n);
    return r && i instanceof Ki && i.type === "mo" && (i.setAttribute("lspace", "0em"), i.setAttribute("rspace", "0em")), [i];
  }
  for (var a = [], o, s = 0; s < e.length; s++) {
    var l = yn(e[s], n);
    if (l instanceof Ki && o instanceof Ki) {
      if (l.type === "mtext" && o.type === "mtext" && l.getAttribute("mathvariant") === o.getAttribute("mathvariant")) {
        o.children.push(...l.children);
        continue;
      } else if (l.type === "mn" && o.type === "mn") {
        o.children.push(...l.children);
        continue;
      } else if (Ob(l) && o.type === "mn") {
        o.children.push(...l.children);
        continue;
      } else if (l.type === "mn" && Ob(o))
        l.children = [...o.children, ...l.children], a.pop();
      else if ((l.type === "msup" || l.type === "msub") && l.children.length >= 1 && (o.type === "mn" || Ob(o))) {
        var c = l.children[0];
        c instanceof Ki && c.type === "mn" && (c.children = [...o.children, ...c.children], a.pop());
      } else if (o.type === "mi" && o.children.length === 1) {
        var u = o.children[0];
        if (u instanceof qo && u.text === "̸" && (l.type === "mo" || l.type === "mi" || l.type === "mn")) {
          var d = l.children[0];
          d instanceof qo && d.text.length > 0 && (d.text = d.text.slice(0, 1) + "̸" + d.text.slice(1), a.pop());
        }
      }
    }
    a.push(l), o = l;
  }
  return a;
}, zc = function(e, n, r) {
  return AL(Bi(e, n, r));
}, yn = function(e, n) {
  if (!e)
    return new qe.MathNode("mrow");
  if (ug[e.type]) {
    var r = ug[e.type](e, n);
    return r;
  } else
    throw new Ge("Got group of unknown type: '" + e.type + "'");
};
function pO(t, e, n, r, i) {
  var a = Bi(t, n), o;
  a.length === 1 && a[0] instanceof Ki && wt.contains(["mrow", "mtable"], a[0].type) ? o = a[0] : o = new qe.MathNode("mrow", a);
  var s = new qe.MathNode("annotation", [new qe.TextNode(e)]);
  s.setAttribute("encoding", "application/x-tex");
  var l = new qe.MathNode("semantics", [o, s]), c = new qe.MathNode("math", [l]);
  c.setAttribute("xmlns", "http://www.w3.org/1998/Math/MathML"), r && c.setAttribute("display", "block");
  var u = i ? "katex" : "katex-mathml";
  return ke.makeSpan([u], [c]);
}
var bne = function(e) {
  return new Os({
    style: e.displayMode ? St.DISPLAY : St.TEXT,
    maxSize: e.maxSize,
    minRuleThickness: e.minRuleThickness
  });
}, wne = function(e, n) {
  if (n.displayMode) {
    var r = ["katex-display"];
    n.leqno && r.push("leqno"), n.fleqn && r.push("fleqn"), e = ke.makeSpan(r, [e]);
  }
  return e;
}, Dqt = function(e, n, r) {
  var i = bne(r), a;
  if (r.output === "mathml")
    return pO(e, n, i, r.displayMode, !0);
  if (r.output === "html") {
    var o = Ok(e, i);
    a = ke.makeSpan(["katex"], [o]);
  } else {
    var s = pO(e, n, i, r.displayMode, !1), l = Ok(e, i);
    a = ke.makeSpan(["katex"], [s, l]);
  }
  return wne(a, r);
}, Iqt = function(e, n, r) {
  var i = bne(r), a = Ok(e, i), o = ke.makeSpan(["katex"], [a]);
  return wne(o, r);
}, Pqt = {
  widehat: "^",
  widecheck: "ˇ",
  widetilde: "~",
  utilde: "~",
  overleftarrow: "←",
  underleftarrow: "←",
  xleftarrow: "←",
  overrightarrow: "→",
  underrightarrow: "→",
  xrightarrow: "→",
  underbrace: "⏟",
  overbrace: "⏞",
  overgroup: "⏠",
  undergroup: "⏡",
  overleftrightarrow: "↔",
  underleftrightarrow: "↔",
  xleftrightarrow: "↔",
  Overrightarrow: "⇒",
  xRightarrow: "⇒",
  overleftharpoon: "↼",
  xleftharpoonup: "↼",
  overrightharpoon: "⇀",
  xrightharpoonup: "⇀",
  xLeftarrow: "⇐",
  xLeftrightarrow: "⇔",
  xhookleftarrow: "↩",
  xhookrightarrow: "↪",
  xmapsto: "↦",
  xrightharpoondown: "⇁",
  xleftharpoondown: "↽",
  xrightleftharpoons: "⇌",
  xleftrightharpoons: "⇋",
  xtwoheadleftarrow: "↞",
  xtwoheadrightarrow: "↠",
  xlongequal: "=",
  xtofrom: "⇄",
  xrightleftarrows: "⇄",
  xrightequilibrium: "⇌",
  // Not a perfect match.
  xleftequilibrium: "⇋",
  // None better available.
  "\\cdrightarrow": "→",
  "\\cdleftarrow": "←",
  "\\cdlongequal": "="
}, zqt = function(e) {
  var n = new qe.MathNode("mo", [new qe.TextNode(Pqt[e.replace(/^\\/, "")])]);
  return n.setAttribute("stretchy", "true"), n;
}, Rqt = {
  //   path(s), minWidth, height, align
  overrightarrow: [["rightarrow"], 0.888, 522, "xMaxYMin"],
  overleftarrow: [["leftarrow"], 0.888, 522, "xMinYMin"],
  underrightarrow: [["rightarrow"], 0.888, 522, "xMaxYMin"],
  underleftarrow: [["leftarrow"], 0.888, 522, "xMinYMin"],
  xrightarrow: [["rightarrow"], 1.469, 522, "xMaxYMin"],
  "\\cdrightarrow": [["rightarrow"], 3, 522, "xMaxYMin"],
  // CD minwwidth2.5pc
  xleftarrow: [["leftarrow"], 1.469, 522, "xMinYMin"],
  "\\cdleftarrow": [["leftarrow"], 3, 522, "xMinYMin"],
  Overrightarrow: [["doublerightarrow"], 0.888, 560, "xMaxYMin"],
  xRightarrow: [["doublerightarrow"], 1.526, 560, "xMaxYMin"],
  xLeftarrow: [["doubleleftarrow"], 1.526, 560, "xMinYMin"],
  overleftharpoon: [["leftharpoon"], 0.888, 522, "xMinYMin"],
  xleftharpoonup: [["leftharpoon"], 0.888, 522, "xMinYMin"],
  xleftharpoondown: [["leftharpoondown"], 0.888, 522, "xMinYMin"],
  overrightharpoon: [["rightharpoon"], 0.888, 522, "xMaxYMin"],
  xrightharpoonup: [["rightharpoon"], 0.888, 522, "xMaxYMin"],
  xrightharpoondown: [["rightharpoondown"], 0.888, 522, "xMaxYMin"],
  xlongequal: [["longequal"], 0.888, 334, "xMinYMin"],
  "\\cdlongequal": [["longequal"], 3, 334, "xMinYMin"],
  xtwoheadleftarrow: [["twoheadleftarrow"], 0.888, 334, "xMinYMin"],
  xtwoheadrightarrow: [["twoheadrightarrow"], 0.888, 334, "xMaxYMin"],
  overleftrightarrow: [["leftarrow", "rightarrow"], 0.888, 522],
  overbrace: [["leftbrace", "midbrace", "rightbrace"], 1.6, 548],
  underbrace: [["leftbraceunder", "midbraceunder", "rightbraceunder"], 1.6, 548],
  underleftrightarrow: [["leftarrow", "rightarrow"], 0.888, 522],
  xleftrightarrow: [["leftarrow", "rightarrow"], 1.75, 522],
  xLeftrightarrow: [["doubleleftarrow", "doublerightarrow"], 1.75, 560],
  xrightleftharpoons: [["leftharpoondownplus", "rightharpoonplus"], 1.75, 716],
  xleftrightharpoons: [["leftharpoonplus", "rightharpoondownplus"], 1.75, 716],
  xhookleftarrow: [["leftarrow", "righthook"], 1.08, 522],
  xhookrightarrow: [["lefthook", "rightarrow"], 1.08, 522],
  overlinesegment: [["leftlinesegment", "rightlinesegment"], 0.888, 522],
  underlinesegment: [["leftlinesegment", "rightlinesegment"], 0.888, 522],
  overgroup: [["leftgroup", "rightgroup"], 0.888, 342],
  undergroup: [["leftgroupunder", "rightgroupunder"], 0.888, 342],
  xmapsto: [["leftmapsto", "rightarrow"], 1.5, 522],
  xtofrom: [["leftToFrom", "rightToFrom"], 1.75, 528],
  // The next three arrows are from the mhchem package.
  // In mhchem.sty, min-length is 2.0em. But these arrows might appear in the
  // document as \xrightarrow or \xrightleftharpoons. Those have
  // min-length = 1.75em, so we set min-length on these next three to match.
  xrightleftarrows: [["baraboveleftarrow", "rightarrowabovebar"], 1.75, 901],
  xrightequilibrium: [["baraboveshortleftharpoon", "rightharpoonaboveshortbar"], 1.75, 716],
  xleftequilibrium: [["shortbaraboveleftharpoon", "shortrightharpoonabovebar"], 1.75, 716]
}, Oqt = function(e) {
  return e.type === "ordgroup" ? e.body.length : 1;
}, Bqt = function(e, n) {
  function r() {
    var s = 4e5, l = e.label.slice(1);
    if (wt.contains(["widehat", "widecheck", "widetilde", "utilde"], l)) {
      var c = e, u = Oqt(c.base), d, f, h;
      if (u > 5)
        l === "widehat" || l === "widecheck" ? (d = 420, s = 2364, h = 0.42, f = l + "4") : (d = 312, s = 2340, h = 0.34, f = "tilde4");
      else {
        var p = [1, 1, 2, 2, 3, 3][u];
        l === "widehat" || l === "widecheck" ? (s = [0, 1062, 2364, 2364, 2364][p], d = [0, 239, 300, 360, 420][p], h = [0, 0.24, 0.3, 0.3, 0.36, 0.42][p], f = l + p) : (s = [0, 600, 1033, 2339, 2340][p], d = [0, 260, 286, 306, 312][p], h = [0, 0.26, 0.286, 0.3, 0.306, 0.34][p], f = "tilde" + p);
      }
      var m = new Pc(f), g = new wl([m], {
        width: "100%",
        height: Qe(h),
        viewBox: "0 0 " + s + " " + d,
        preserveAspectRatio: "none"
      });
      return {
        span: ke.makeSvgSpan([], [g], n),
        minWidth: 0,
        height: h
      };
    } else {
      var v = [], k = Rqt[l], [w, b, x] = k, A = x / 1e3, L = w.length, M, j;
      if (L === 1) {
        var D = k[3];
        M = ["hide-tail"], j = [D];
      } else if (L === 2)
        M = ["halfarrow-left", "halfarrow-right"], j = ["xMinYMin", "xMaxYMin"];
      else if (L === 3)
        M = ["brace-left", "brace-center", "brace-right"], j = ["xMinYMin", "xMidYMin", "xMaxYMin"];
      else
        throw new Error(`Correct katexImagesData or update code here to support
                    ` + L + " children.");
      for (var z = 0; z < L; z++) {
        var H = new Pc(w[z]), V = new wl([H], {
          width: "400em",
          height: Qe(A),
          viewBox: "0 0 " + s + " " + x,
          preserveAspectRatio: j[z] + " slice"
        }), F = ke.makeSvgSpan([M[z]], [V], n);
        if (L === 1)
          return {
            span: F,
            minWidth: b,
            height: A
          };
        F.style.height = Qe(A), v.push(F);
      }
      return {
        span: ke.makeSpan(["stretchy"], v, n),
        minWidth: b,
        height: A
      };
    }
  }
  var {
    span: i,
    minWidth: a,
    height: o
  } = r();
  return i.height = o, i.style.height = Qe(o), a > 0 && (i.style.minWidth = Qe(a)), i;
}, Hqt = function(e, n, r, i, a) {
  var o, s = e.height + e.depth + r + i;
  if (/fbox|color|angl/.test(n)) {
    if (o = ke.makeSpan(["stretchy", n], [], a), n === "fbox") {
      var l = a.color && a.getColor();
      l && (o.style.borderColor = l);
    }
  } else {
    var c = [];
    /^[bx]cancel$/.test(n) && c.push(new Pk({
      x1: "0",
      y1: "0",
      x2: "100%",
      y2: "100%",
      "stroke-width": "0.046em"
    })), /^x?cancel$/.test(n) && c.push(new Pk({
      x1: "0",
      y1: "100%",
      x2: "100%",
      y2: "0",
      "stroke-width": "0.046em"
    }));
    var u = new wl(c, {
      width: "100%",
      height: Qe(s)
    });
    o = ke.makeSvgSpan([], [u], a);
  }
  return o.height = s, o.style.height = Qe(s), o;
}, xl = {
  encloseSpan: Hqt,
  mathMLnode: zqt,
  svgSpan: Bqt
};
function Ut(t, e) {
  if (!t || t.type !== e)
    throw new Error("Expected node of type " + e + ", but got " + (t ? "node of type " + t.type : String(t)));
  return t;
}
function LL(t) {
  var e = S5(t);
  if (!e)
    throw new Error("Expected node of symbol group type, but got " + (t ? "node of type " + t.type : String(t)));
  return e;
}
function S5(t) {
  return t && (t.type === "atom" || uqt.hasOwnProperty(t.type)) ? t : null;
}
var TL = (t, e) => {
  var n, r, i;
  t && t.type === "supsub" ? (r = Ut(t.base, "accent"), n = r.base, t.base = n, i = lqt(on(t, e)), t.base = r) : (r = Ut(t, "accent"), n = r.base);
  var a = on(n, e.havingCrampedStyle()), o = r.isShifty && wt.isCharacterBox(n), s = 0;
  if (o) {
    var l = wt.getBaseElem(n), c = on(l, e.havingCrampedStyle());
    s = sO(c).skew;
  }
  var u = r.label === "\\c", d = u ? a.height + a.depth : Math.min(a.height, e.fontMetrics().xHeight), f;
  if (r.isStretchy)
    f = xl.svgSpan(r, e), f = ke.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: a
      }, {
        type: "elem",
        elem: f,
        wrapperClasses: ["svg-align"],
        wrapperStyle: s > 0 ? {
          width: "calc(100% - " + Qe(2 * s) + ")",
          marginLeft: Qe(2 * s)
        } : void 0
      }]
    }, e);
  else {
    var h, p;
    r.label === "\\vec" ? (h = ke.staticSvg("vec", e), p = ke.svgData.vec[1]) : (h = ke.makeOrd({
      mode: r.mode,
      text: r.label
    }, e, "textord"), h = sO(h), h.italic = 0, p = h.width, u && (d += h.depth)), f = ke.makeSpan(["accent-body"], [h]);
    var m = r.label === "\\textcircled";
    m && (f.classes.push("accent-full"), d = a.height);
    var g = s;
    m || (g -= p / 2), f.style.left = Qe(g), r.label === "\\textcircled" && (f.style.top = ".2em"), f = ke.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: a
      }, {
        type: "kern",
        size: -d
      }, {
        type: "elem",
        elem: f
      }]
    }, e);
  }
  var v = ke.makeSpan(["mord", "accent"], [f], e);
  return i ? (i.children[0] = v, i.height = Math.max(v.height, i.height), i.classes[0] = "mord", i) : v;
}, kne = (t, e) => {
  var n = t.isStretchy ? xl.mathMLnode(t.label) : new qe.MathNode("mo", [Ba(t.label, t.mode)]), r = new qe.MathNode("mover", [yn(t.base, e), n]);
  return r.setAttribute("accent", "true"), r;
}, Fqt = new RegExp(["\\acute", "\\grave", "\\ddot", "\\tilde", "\\bar", "\\breve", "\\check", "\\hat", "\\vec", "\\dot", "\\mathring"].map((t) => "\\" + t).join("|"));
at({
  type: "accent",
  names: ["\\acute", "\\grave", "\\ddot", "\\tilde", "\\bar", "\\breve", "\\check", "\\hat", "\\vec", "\\dot", "\\mathring", "\\widecheck", "\\widehat", "\\widetilde", "\\overrightarrow", "\\overleftarrow", "\\Overrightarrow", "\\overleftrightarrow", "\\overgroup", "\\overlinesegment", "\\overleftharpoon", "\\overrightharpoon"],
  props: {
    numArgs: 1
  },
  handler: (t, e) => {
    var n = dg(e[0]), r = !Fqt.test(t.funcName), i = !r || t.funcName === "\\widehat" || t.funcName === "\\widetilde" || t.funcName === "\\widecheck";
    return {
      type: "accent",
      mode: t.parser.mode,
      label: t.funcName,
      isStretchy: r,
      isShifty: i,
      base: n
    };
  },
  htmlBuilder: TL,
  mathmlBuilder: kne
});
at({
  type: "accent",
  names: ["\\'", "\\`", "\\^", "\\~", "\\=", "\\u", "\\.", '\\"', "\\c", "\\r", "\\H", "\\v", "\\textcircled"],
  props: {
    numArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    // unless in strict mode
    argTypes: ["primitive"]
  },
  handler: (t, e) => {
    var n = e[0], r = t.parser.mode;
    return r === "math" && (t.parser.settings.reportNonstrict("mathVsTextAccents", "LaTeX's accent " + t.funcName + " works only in text mode"), r = "text"), {
      type: "accent",
      mode: r,
      label: t.funcName,
      isStretchy: !1,
      isShifty: !0,
      base: n
    };
  },
  htmlBuilder: TL,
  mathmlBuilder: kne
});
at({
  type: "accentUnder",
  names: ["\\underleftarrow", "\\underrightarrow", "\\underleftrightarrow", "\\undergroup", "\\underlinesegment", "\\utilde"],
  props: {
    numArgs: 1
  },
  handler: (t, e) => {
    var {
      parser: n,
      funcName: r
    } = t, i = e[0];
    return {
      type: "accentUnder",
      mode: n.mode,
      label: r,
      base: i
    };
  },
  htmlBuilder: (t, e) => {
    var n = on(t.base, e), r = xl.svgSpan(t, e), i = t.label === "\\utilde" ? 0.12 : 0, a = ke.makeVList({
      positionType: "top",
      positionData: n.height,
      children: [{
        type: "elem",
        elem: r,
        wrapperClasses: ["svg-align"]
      }, {
        type: "kern",
        size: i
      }, {
        type: "elem",
        elem: n
      }]
    }, e);
    return ke.makeSpan(["mord", "accentunder"], [a], e);
  },
  mathmlBuilder: (t, e) => {
    var n = xl.mathMLnode(t.label), r = new qe.MathNode("munder", [yn(t.base, e), n]);
    return r.setAttribute("accentunder", "true"), r;
  }
});
var L4 = (t) => {
  var e = new qe.MathNode("mpadded", t ? [t] : []);
  return e.setAttribute("width", "+0.6em"), e.setAttribute("lspace", "0.3em"), e;
};
at({
  type: "xArrow",
  names: [
    "\\xleftarrow",
    "\\xrightarrow",
    "\\xLeftarrow",
    "\\xRightarrow",
    "\\xleftrightarrow",
    "\\xLeftrightarrow",
    "\\xhookleftarrow",
    "\\xhookrightarrow",
    "\\xmapsto",
    "\\xrightharpoondown",
    "\\xrightharpoonup",
    "\\xleftharpoondown",
    "\\xleftharpoonup",
    "\\xrightleftharpoons",
    "\\xleftrightharpoons",
    "\\xlongequal",
    "\\xtwoheadrightarrow",
    "\\xtwoheadleftarrow",
    "\\xtofrom",
    // The next 3 functions are here to support the mhchem extension.
    // Direct use of these functions is discouraged and may break someday.
    "\\xrightleftarrows",
    "\\xrightequilibrium",
    "\\xleftequilibrium",
    // The next 3 functions are here only to support the {CD} environment.
    "\\\\cdrightarrow",
    "\\\\cdleftarrow",
    "\\\\cdlongequal"
  ],
  props: {
    numArgs: 1,
    numOptionalArgs: 1
  },
  handler(t, e, n) {
    var {
      parser: r,
      funcName: i
    } = t;
    return {
      type: "xArrow",
      mode: r.mode,
      label: i,
      body: e[0],
      below: n[0]
    };
  },
  // Flow is unable to correctly infer the type of `group`, even though it's
  // unambiguously determined from the passed-in `type` above.
  htmlBuilder(t, e) {
    var n = e.style, r = e.havingStyle(n.sup()), i = ke.wrapFragment(on(t.body, r, e), e), a = t.label.slice(0, 2) === "\\x" ? "x" : "cd";
    i.classes.push(a + "-arrow-pad");
    var o;
    t.below && (r = e.havingStyle(n.sub()), o = ke.wrapFragment(on(t.below, r, e), e), o.classes.push(a + "-arrow-pad"));
    var s = xl.svgSpan(t, e), l = -e.fontMetrics().axisHeight + 0.5 * s.height, c = -e.fontMetrics().axisHeight - 0.5 * s.height - 0.111;
    (i.depth > 0.25 || t.label === "\\xleftequilibrium") && (c -= i.depth);
    var u;
    if (o) {
      var d = -e.fontMetrics().axisHeight + o.height + 0.5 * s.height + 0.111;
      u = ke.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: i,
          shift: c
        }, {
          type: "elem",
          elem: s,
          shift: l
        }, {
          type: "elem",
          elem: o,
          shift: d
        }]
      }, e);
    } else
      u = ke.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: i,
          shift: c
        }, {
          type: "elem",
          elem: s,
          shift: l
        }]
      }, e);
    return u.children[0].children[0].children[1].classes.push("svg-align"), ke.makeSpan(["mrel", "x-arrow"], [u], e);
  },
  mathmlBuilder(t, e) {
    var n = xl.mathMLnode(t.label);
    n.setAttribute("minsize", t.label.charAt(0) === "x" ? "1.75em" : "3.0em");
    var r;
    if (t.body) {
      var i = L4(yn(t.body, e));
      if (t.below) {
        var a = L4(yn(t.below, e));
        r = new qe.MathNode("munderover", [n, a, i]);
      } else
        r = new qe.MathNode("mover", [n, i]);
    } else if (t.below) {
      var o = L4(yn(t.below, e));
      r = new qe.MathNode("munder", [n, o]);
    } else
      r = L4(), r = new qe.MathNode("mover", [n, r]);
    return r;
  }
});
var _qt = ke.makeSpan;
function xne(t, e) {
  var n = yr(t.body, e, !0);
  return _qt([t.mclass], n, e);
}
function Mne(t, e) {
  var n, r = Bi(t.body, e);
  return t.mclass === "minner" ? n = new qe.MathNode("mpadded", r) : t.mclass === "mord" ? t.isCharacterBox ? (n = r[0], n.type = "mi") : n = new qe.MathNode("mi", r) : (t.isCharacterBox ? (n = r[0], n.type = "mo") : n = new qe.MathNode("mo", r), t.mclass === "mbin" ? (n.attributes.lspace = "0.22em", n.attributes.rspace = "0.22em") : t.mclass === "mpunct" ? (n.attributes.lspace = "0em", n.attributes.rspace = "0.17em") : t.mclass === "mopen" || t.mclass === "mclose" ? (n.attributes.lspace = "0em", n.attributes.rspace = "0em") : t.mclass === "minner" && (n.attributes.lspace = "0.0556em", n.attributes.width = "+0.1111em")), n;
}
at({
  type: "mclass",
  names: ["\\mathord", "\\mathbin", "\\mathrel", "\\mathopen", "\\mathclose", "\\mathpunct", "\\mathinner"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler(t, e) {
    var {
      parser: n,
      funcName: r
    } = t, i = e[0];
    return {
      type: "mclass",
      mode: n.mode,
      mclass: "m" + r.slice(5),
      // TODO(kevinb): don't prefix with 'm'
      body: rr(i),
      isCharacterBox: wt.isCharacterBox(i)
    };
  },
  htmlBuilder: xne,
  mathmlBuilder: Mne
});
var L5 = (t) => {
  var e = t.type === "ordgroup" && t.body.length ? t.body[0] : t;
  return e.type === "atom" && (e.family === "bin" || e.family === "rel") ? "m" + e.family : "mord";
};
at({
  type: "mclass",
  names: ["\\@binrel"],
  props: {
    numArgs: 2
  },
  handler(t, e) {
    var {
      parser: n
    } = t;
    return {
      type: "mclass",
      mode: n.mode,
      mclass: L5(e[0]),
      body: rr(e[1]),
      isCharacterBox: wt.isCharacterBox(e[1])
    };
  }
});
at({
  type: "mclass",
  names: ["\\stackrel", "\\overset", "\\underset"],
  props: {
    numArgs: 2
  },
  handler(t, e) {
    var {
      parser: n,
      funcName: r
    } = t, i = e[1], a = e[0], o;
    r !== "\\stackrel" ? o = L5(i) : o = "mrel";
    var s = {
      type: "op",
      mode: i.mode,
      limits: !0,
      alwaysHandleSupSub: !0,
      parentIsSupSub: !1,
      symbol: !1,
      suppressBaseShift: r !== "\\stackrel",
      body: rr(i)
    }, l = {
      type: "supsub",
      mode: a.mode,
      base: s,
      sup: r === "\\underset" ? null : a,
      sub: r === "\\underset" ? a : null
    };
    return {
      type: "mclass",
      mode: n.mode,
      mclass: o,
      body: [l],
      isCharacterBox: wt.isCharacterBox(l)
    };
  },
  htmlBuilder: xne,
  mathmlBuilder: Mne
});
at({
  type: "pmb",
  names: ["\\pmb"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(t, e) {
    var {
      parser: n
    } = t;
    return {
      type: "pmb",
      mode: n.mode,
      mclass: L5(e[0]),
      body: rr(e[0])
    };
  },
  htmlBuilder(t, e) {
    var n = yr(t.body, e, !0), r = ke.makeSpan([t.mclass], n, e);
    return r.style.textShadow = "0.02em 0.01em 0.04px", r;
  },
  mathmlBuilder(t, e) {
    var n = Bi(t.body, e), r = new qe.MathNode("mstyle", n);
    return r.setAttribute("style", "text-shadow: 0.02em 0.01em 0.04px"), r;
  }
});
var Vqt = {
  ">": "\\\\cdrightarrow",
  "<": "\\\\cdleftarrow",
  "=": "\\\\cdlongequal",
  A: "\\uparrow",
  V: "\\downarrow",
  "|": "\\Vert",
  ".": "no arrow"
}, mO = () => ({
  type: "styling",
  body: [],
  mode: "math",
  style: "display"
}), yO = (t) => t.type === "textord" && t.text === "@", qqt = (t, e) => (t.type === "mathord" || t.type === "atom") && t.text === e;
function Uqt(t, e, n) {
  var r = Vqt[t];
  switch (r) {
    case "\\\\cdrightarrow":
    case "\\\\cdleftarrow":
      return n.callFunction(r, [e[0]], [e[1]]);
    case "\\uparrow":
    case "\\downarrow": {
      var i = n.callFunction("\\\\cdleft", [e[0]], []), a = {
        type: "atom",
        text: r,
        mode: "math",
        family: "rel"
      }, o = n.callFunction("\\Big", [a], []), s = n.callFunction("\\\\cdright", [e[1]], []), l = {
        type: "ordgroup",
        mode: "math",
        body: [i, o, s]
      };
      return n.callFunction("\\\\cdparent", [l], []);
    }
    case "\\\\cdlongequal":
      return n.callFunction("\\\\cdlongequal", [], []);
    case "\\Vert": {
      var c = {
        type: "textord",
        text: "\\Vert",
        mode: "math"
      };
      return n.callFunction("\\Big", [c], []);
    }
    default:
      return {
        type: "textord",
        text: " ",
        mode: "math"
      };
  }
}
function Wqt(t) {
  var e = [];
  for (t.gullet.beginGroup(), t.gullet.macros.set("\\cr", "\\\\\\relax"), t.gullet.beginGroup(); ; ) {
    e.push(t.parseExpression(!1, "\\\\")), t.gullet.endGroup(), t.gullet.beginGroup();
    var n = t.fetch().text;
    if (n === "&" || n === "\\\\")
      t.consume();
    else if (n === "\\end") {
      e[e.length - 1].length === 0 && e.pop();
      break;
    } else
      throw new Ge("Expected \\\\ or \\cr or \\end", t.nextToken);
  }
  for (var r = [], i = [r], a = 0; a < e.length; a++) {
    for (var o = e[a], s = mO(), l = 0; l < o.length; l++)
      if (!yO(o[l]))
        s.body.push(o[l]);
      else {
        r.push(s), l += 1;
        var c = LL(o[l]).text, u = new Array(2);
        if (u[0] = {
          type: "ordgroup",
          mode: "math",
          body: []
        }, u[1] = {
          type: "ordgroup",
          mode: "math",
          body: []
        }, !("=|.".indexOf(c) > -1)) if ("<>AV".indexOf(c) > -1)
          for (var d = 0; d < 2; d++) {
            for (var f = !0, h = l + 1; h < o.length; h++) {
              if (qqt(o[h], c)) {
                f = !1, l = h;
                break;
              }
              if (yO(o[h]))
                throw new Ge("Missing a " + c + " character to complete a CD arrow.", o[h]);
              u[d].body.push(o[h]);
            }
            if (f)
              throw new Ge("Missing a " + c + " character to complete a CD arrow.", o[l]);
          }
        else
          throw new Ge('Expected one of "<>AV=|." after @', o[l]);
        var p = Uqt(c, u, t), m = {
          type: "styling",
          body: [p],
          mode: "math",
          style: "display"
          // CD is always displaystyle.
        };
        r.push(m), s = mO();
      }
    a % 2 === 0 ? r.push(s) : r.shift(), r = [], i.push(r);
  }
  t.gullet.endGroup(), t.gullet.endGroup();
  var g = new Array(i[0].length).fill({
    type: "align",
    align: "c",
    pregap: 0.25,
    // CD package sets \enskip between columns.
    postgap: 0.25
    // So pre and post each get half an \enskip, i.e. 0.25em.
  });
  return {
    type: "array",
    mode: "math",
    body: i,
    arraystretch: 1,
    addJot: !0,
    rowGaps: [null],
    cols: g,
    colSeparationType: "CD",
    hLinesBeforeRow: new Array(i.length + 1).fill([])
  };
}
at({
  type: "cdlabel",
  names: ["\\\\cdleft", "\\\\cdright"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var {
      parser: n,
      funcName: r
    } = t;
    return {
      type: "cdlabel",
      mode: n.mode,
      side: r.slice(4),
      label: e[0]
    };
  },
  htmlBuilder(t, e) {
    var n = e.havingStyle(e.style.sup()), r = ke.wrapFragment(on(t.label, n, e), e);
    return r.classes.push("cd-label-" + t.side), r.style.bottom = Qe(0.8 - r.depth), r.height = 0, r.depth = 0, r;
  },
  mathmlBuilder(t, e) {
    var n = new qe.MathNode("mrow", [yn(t.label, e)]);
    return n = new qe.MathNode("mpadded", [n]), n.setAttribute("width", "0"), t.side === "left" && n.setAttribute("lspace", "-1width"), n.setAttribute("voffset", "0.7em"), n = new qe.MathNode("mstyle", [n]), n.setAttribute("displaystyle", "false"), n.setAttribute("scriptlevel", "1"), n;
  }
});
at({
  type: "cdlabelparent",
  names: ["\\\\cdparent"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var {
      parser: n
    } = t;
    return {
      type: "cdlabelparent",
      mode: n.mode,
      fragment: e[0]
    };
  },
  htmlBuilder(t, e) {
    var n = ke.wrapFragment(on(t.fragment, e), e);
    return n.classes.push("cd-vert-arrow"), n;
  },
  mathmlBuilder(t, e) {
    return new qe.MathNode("mrow", [yn(t.fragment, e)]);
  }
});
at({
  type: "textord",
  names: ["\\@char"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(t, e) {
    for (var {
      parser: n
    } = t, r = Ut(e[0], "ordgroup"), i = r.body, a = "", o = 0; o < i.length; o++) {
      var s = Ut(i[o], "textord");
      a += s.text;
    }
    var l = parseInt(a), c;
    if (isNaN(l))
      throw new Ge("\\@char has non-numeric argument " + a);
    if (l < 0 || l >= 1114111)
      throw new Ge("\\@char with invalid code point " + a);
    return l <= 65535 ? c = String.fromCharCode(l) : (l -= 65536, c = String.fromCharCode((l >> 10) + 55296, (l & 1023) + 56320)), {
      type: "textord",
      mode: n.mode,
      text: c
    };
  }
});
var Cne = (t, e) => {
  var n = yr(t.body, e.withColor(t.color), !1);
  return ke.makeFragment(n);
}, Ane = (t, e) => {
  var n = Bi(t.body, e.withColor(t.color)), r = new qe.MathNode("mstyle", n);
  return r.setAttribute("mathcolor", t.color), r;
};
at({
  type: "color",
  names: ["\\textcolor"],
  props: {
    numArgs: 2,
    allowedInText: !0,
    argTypes: ["color", "original"]
  },
  handler(t, e) {
    var {
      parser: n
    } = t, r = Ut(e[0], "color-token").color, i = e[1];
    return {
      type: "color",
      mode: n.mode,
      color: r,
      body: rr(i)
    };
  },
  htmlBuilder: Cne,
  mathmlBuilder: Ane
});
at({
  type: "color",
  names: ["\\color"],
  props: {
    numArgs: 1,
    allowedInText: !0,
    argTypes: ["color"]
  },
  handler(t, e) {
    var {
      parser: n,
      breakOnTokenText: r
    } = t, i = Ut(e[0], "color-token").color;
    n.gullet.macros.set("\\current@color", i);
    var a = n.parseExpression(!0, r);
    return {
      type: "color",
      mode: n.mode,
      color: i,
      body: a
    };
  },
  htmlBuilder: Cne,
  mathmlBuilder: Ane
});
at({
  type: "cr",
  names: ["\\\\"],
  props: {
    numArgs: 0,
    numOptionalArgs: 0,
    allowedInText: !0
  },
  handler(t, e, n) {
    var {
      parser: r
    } = t, i = r.gullet.future().text === "[" ? r.parseSizeGroup(!0) : null, a = !r.settings.displayMode || !r.settings.useStrictBehavior("newLineInDisplayMode", "In LaTeX, \\\\ or \\newline does nothing in display mode");
    return {
      type: "cr",
      mode: r.mode,
      newLine: a,
      size: i && Ut(i, "size").value
    };
  },
  // The following builders are called only at the top level,
  // not within tabular/array environments.
  htmlBuilder(t, e) {
    var n = ke.makeSpan(["mspace"], [], e);
    return t.newLine && (n.classes.push("newline"), t.size && (n.style.marginTop = Qe(Bn(t.size, e)))), n;
  },
  mathmlBuilder(t, e) {
    var n = new qe.MathNode("mspace");
    return t.newLine && (n.setAttribute("linebreak", "newline"), t.size && n.setAttribute("height", Qe(Bn(t.size, e)))), n;
  }
});
var Bk = {
  "\\global": "\\global",
  "\\long": "\\\\globallong",
  "\\\\globallong": "\\\\globallong",
  "\\def": "\\gdef",
  "\\gdef": "\\gdef",
  "\\edef": "\\xdef",
  "\\xdef": "\\xdef",
  "\\let": "\\\\globallet",
  "\\futurelet": "\\\\globalfuture"
}, Sne = (t) => {
  var e = t.text;
  if (/^(?:[\\{}$&#^_]|EOF)$/.test(e))
    throw new Ge("Expected a control sequence", t);
  return e;
}, Zqt = (t) => {
  var e = t.gullet.popToken();
  return e.text === "=" && (e = t.gullet.popToken(), e.text === " " && (e = t.gullet.popToken())), e;
}, Lne = (t, e, n, r) => {
  var i = t.gullet.macros.get(n.text);
  i == null && (n.noexpand = !0, i = {
    tokens: [n],
    numArgs: 0,
    // reproduce the same behavior in expansion
    unexpandable: !t.gullet.isExpandable(n.text)
  }), t.gullet.macros.set(e, i, r);
};
at({
  type: "internal",
  names: [
    "\\global",
    "\\long",
    "\\\\globallong"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(t) {
    var {
      parser: e,
      funcName: n
    } = t;
    e.consumeSpaces();
    var r = e.fetch();
    if (Bk[r.text])
      return (n === "\\global" || n === "\\\\globallong") && (r.text = Bk[r.text]), Ut(e.parseFunction(), "internal");
    throw new Ge("Invalid token after macro prefix", r);
  }
});
at({
  type: "internal",
  names: ["\\def", "\\gdef", "\\edef", "\\xdef"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(t) {
    var {
      parser: e,
      funcName: n
    } = t, r = e.gullet.popToken(), i = r.text;
    if (/^(?:[\\{}$&#^_]|EOF)$/.test(i))
      throw new Ge("Expected a control sequence", r);
    for (var a = 0, o, s = [[]]; e.gullet.future().text !== "{"; )
      if (r = e.gullet.popToken(), r.text === "#") {
        if (e.gullet.future().text === "{") {
          o = e.gullet.future(), s[a].push("{");
          break;
        }
        if (r = e.gullet.popToken(), !/^[1-9]$/.test(r.text))
          throw new Ge('Invalid argument number "' + r.text + '"');
        if (parseInt(r.text) !== a + 1)
          throw new Ge('Argument number "' + r.text + '" out of order');
        a++, s.push([]);
      } else {
        if (r.text === "EOF")
          throw new Ge("Expected a macro definition");
        s[a].push(r.text);
      }
    var {
      tokens: l
    } = e.gullet.consumeArg();
    return o && l.unshift(o), (n === "\\edef" || n === "\\xdef") && (l = e.gullet.expandTokens(l), l.reverse()), e.gullet.macros.set(i, {
      tokens: l,
      numArgs: a,
      delimiters: s
    }, n === Bk[n]), {
      type: "internal",
      mode: e.mode
    };
  }
});
at({
  type: "internal",
  names: [
    "\\let",
    "\\\\globallet"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(t) {
    var {
      parser: e,
      funcName: n
    } = t, r = Sne(e.gullet.popToken());
    e.gullet.consumeSpaces();
    var i = Zqt(e);
    return Lne(e, r, i, n === "\\\\globallet"), {
      type: "internal",
      mode: e.mode
    };
  }
});
at({
  type: "internal",
  names: [
    "\\futurelet",
    "\\\\globalfuture"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(t) {
    var {
      parser: e,
      funcName: n
    } = t, r = Sne(e.gullet.popToken()), i = e.gullet.popToken(), a = e.gullet.popToken();
    return Lne(e, r, a, n === "\\\\globalfuture"), e.gullet.pushToken(a), e.gullet.pushToken(i), {
      type: "internal",
      mode: e.mode
    };
  }
});
var _f = function(e, n, r) {
  var i = kn.math[e] && kn.math[e].replace, a = xL(i || e, n, r);
  if (!a)
    throw new Error("Unsupported symbol " + e + " and font size " + n + ".");
  return a;
}, EL = function(e, n, r, i) {
  var a = r.havingBaseStyle(n), o = ke.makeSpan(i.concat(a.sizingClasses(r)), [e], r), s = a.sizeMultiplier / r.sizeMultiplier;
  return o.height *= s, o.depth *= s, o.maxFontSize = a.sizeMultiplier, o;
}, Tne = function(e, n, r) {
  var i = n.havingBaseStyle(r), a = (1 - n.sizeMultiplier / i.sizeMultiplier) * n.fontMetrics().axisHeight;
  e.classes.push("delimcenter"), e.style.top = Qe(a), e.height -= a, e.depth += a;
}, Gqt = function(e, n, r, i, a, o) {
  var s = ke.makeSymbol(e, "Main-Regular", a, i), l = EL(s, n, i, o);
  return r && Tne(l, i, n), l;
}, Yqt = function(e, n, r, i) {
  return ke.makeSymbol(e, "Size" + n + "-Regular", r, i);
}, Ene = function(e, n, r, i, a, o) {
  var s = Yqt(e, n, a, i), l = EL(ke.makeSpan(["delimsizing", "size" + n], [s], i), St.TEXT, i, o);
  return r && Tne(l, i, St.TEXT), l;
}, Bb = function(e, n, r) {
  var i;
  n === "Size1-Regular" ? i = "delim-size1" : i = "delim-size4";
  var a = ke.makeSpan(["delimsizinginner", i], [ke.makeSpan([], [ke.makeSymbol(e, n, r)])]);
  return {
    type: "elem",
    elem: a
  };
}, Hb = function(e, n, r) {
  var i = Vo["Size4-Regular"][e.charCodeAt(0)] ? Vo["Size4-Regular"][e.charCodeAt(0)][4] : Vo["Size1-Regular"][e.charCodeAt(0)][4], a = new Pc("inner", XVt(e, Math.round(1e3 * n))), o = new wl([a], {
    width: Qe(i),
    height: Qe(n),
    // Override CSS rule `.katex svg { width: 100% }`
    style: "width:" + Qe(i),
    viewBox: "0 0 " + 1e3 * i + " " + Math.round(1e3 * n),
    preserveAspectRatio: "xMinYMin"
  }), s = ke.makeSvgSpan([], [o], r);
  return s.height = n, s.style.height = Qe(n), s.style.width = Qe(i), {
    type: "elem",
    elem: s
  };
}, Hk = 8e-3, T4 = {
  type: "kern",
  size: -1 * Hk
}, Kqt = ["|", "\\lvert", "\\rvert", "\\vert"], $qt = ["\\|", "\\lVert", "\\rVert", "\\Vert"], jne = function(e, n, r, i, a, o) {
  var s, l, c, u, d = "", f = 0;
  s = c = u = e, l = null;
  var h = "Size1-Regular";
  e === "\\uparrow" ? c = u = "⏐" : e === "\\Uparrow" ? c = u = "‖" : e === "\\downarrow" ? s = c = "⏐" : e === "\\Downarrow" ? s = c = "‖" : e === "\\updownarrow" ? (s = "\\uparrow", c = "⏐", u = "\\downarrow") : e === "\\Updownarrow" ? (s = "\\Uparrow", c = "‖", u = "\\Downarrow") : wt.contains(Kqt, e) ? (c = "∣", d = "vert", f = 333) : wt.contains($qt, e) ? (c = "∥", d = "doublevert", f = 556) : e === "[" || e === "\\lbrack" ? (s = "⎡", c = "⎢", u = "⎣", h = "Size4-Regular", d = "lbrack", f = 667) : e === "]" || e === "\\rbrack" ? (s = "⎤", c = "⎥", u = "⎦", h = "Size4-Regular", d = "rbrack", f = 667) : e === "\\lfloor" || e === "⌊" ? (c = s = "⎢", u = "⎣", h = "Size4-Regular", d = "lfloor", f = 667) : e === "\\lceil" || e === "⌈" ? (s = "⎡", c = u = "⎢", h = "Size4-Regular", d = "lceil", f = 667) : e === "\\rfloor" || e === "⌋" ? (c = s = "⎥", u = "⎦", h = "Size4-Regular", d = "rfloor", f = 667) : e === "\\rceil" || e === "⌉" ? (s = "⎤", c = u = "⎥", h = "Size4-Regular", d = "rceil", f = 667) : e === "(" || e === "\\lparen" ? (s = "⎛", c = "⎜", u = "⎝", h = "Size4-Regular", d = "lparen", f = 875) : e === ")" || e === "\\rparen" ? (s = "⎞", c = "⎟", u = "⎠", h = "Size4-Regular", d = "rparen", f = 875) : e === "\\{" || e === "\\lbrace" ? (s = "⎧", l = "⎨", u = "⎩", c = "⎪", h = "Size4-Regular") : e === "\\}" || e === "\\rbrace" ? (s = "⎫", l = "⎬", u = "⎭", c = "⎪", h = "Size4-Regular") : e === "\\lgroup" || e === "⟮" ? (s = "⎧", u = "⎩", c = "⎪", h = "Size4-Regular") : e === "\\rgroup" || e === "⟯" ? (s = "⎫", u = "⎭", c = "⎪", h = "Size4-Regular") : e === "\\lmoustache" || e === "⎰" ? (s = "⎧", u = "⎭", c = "⎪", h = "Size4-Regular") : (e === "\\rmoustache" || e === "⎱") && (s = "⎫", u = "⎩", c = "⎪", h = "Size4-Regular");
  var p = _f(s, h, a), m = p.height + p.depth, g = _f(c, h, a), v = g.height + g.depth, k = _f(u, h, a), w = k.height + k.depth, b = 0, x = 1;
  if (l !== null) {
    var A = _f(l, h, a);
    b = A.height + A.depth, x = 2;
  }
  var L = m + w + b, M = Math.max(0, Math.ceil((n - L) / (x * v))), j = L + M * x * v, D = i.fontMetrics().axisHeight;
  r && (D *= i.sizeMultiplier);
  var z = j / 2 - D, H = [];
  if (d.length > 0) {
    var V = j - m - w, F = Math.round(j * 1e3), _ = eqt(d, Math.round(V * 1e3)), W = new Pc(d, _), G = (f / 1e3).toFixed(3) + "em", Y = (F / 1e3).toFixed(3) + "em", Z = new wl([W], {
      width: G,
      height: Y,
      viewBox: "0 0 " + f + " " + F
    }), oe = ke.makeSvgSpan([], [Z], i);
    oe.height = F / 1e3, oe.style.width = G, oe.style.height = Y, H.push({
      type: "elem",
      elem: oe
    });
  } else {
    if (H.push(Bb(u, h, a)), H.push(T4), l === null) {
      var ee = j - m - w + 2 * Hk;
      H.push(Hb(c, ee, i));
    } else {
      var ae = (j - m - w - b) / 2 + 2 * Hk;
      H.push(Hb(c, ae, i)), H.push(T4), H.push(Bb(l, h, a)), H.push(T4), H.push(Hb(c, ae, i));
    }
    H.push(T4), H.push(Bb(s, h, a));
  }
  var fe = i.havingBaseStyle(St.TEXT), me = ke.makeVList({
    positionType: "bottom",
    positionData: z,
    children: H
  }, fe);
  return EL(ke.makeSpan(["delimsizing", "mult"], [me], fe), St.TEXT, i, o);
}, Fb = 80, _b = 0.08, Vb = function(e, n, r, i, a) {
  var o = QVt(e, i, r), s = new Pc(e, o), l = new wl([s], {
    // Note: 1000:1 ratio of viewBox to document em width.
    width: "400em",
    height: Qe(n),
    viewBox: "0 0 400000 " + r,
    preserveAspectRatio: "xMinYMin slice"
  });
  return ke.makeSvgSpan(["hide-tail"], [l], a);
}, Jqt = function(e, n) {
  var r = n.havingBaseSizing(), i = Pne("\\surd", e * r.sizeMultiplier, Ine, r), a = r.sizeMultiplier, o = Math.max(0, n.minRuleThickness - n.fontMetrics().sqrtRuleThickness), s, l = 0, c = 0, u = 0, d;
  return i.type === "small" ? (u = 1e3 + 1e3 * o + Fb, e < 1 ? a = 1 : e < 1.4 && (a = 0.7), l = (1 + o + _b) / a, c = (1 + o) / a, s = Vb("sqrtMain", l, u, o, n), s.style.minWidth = "0.853em", d = 0.833 / a) : i.type === "large" ? (u = (1e3 + Fb) * Mh[i.size], c = (Mh[i.size] + o) / a, l = (Mh[i.size] + o + _b) / a, s = Vb("sqrtSize" + i.size, l, u, o, n), s.style.minWidth = "1.02em", d = 1 / a) : (l = e + o + _b, c = e + o, u = Math.floor(1e3 * e + o) + Fb, s = Vb("sqrtTall", l, u, o, n), s.style.minWidth = "0.742em", d = 1.056), s.height = c, s.style.height = Qe(l), {
    span: s,
    advanceWidth: d,
    // Calculate the actual line width.
    // This actually should depend on the chosen font -- e.g. \boldmath
    // should use the thicker surd symbols from e.g. KaTeX_Main-Bold, and
    // have thicker rules.
    ruleWidth: (n.fontMetrics().sqrtRuleThickness + o) * a
  };
}, Nne = ["(", "\\lparen", ")", "\\rparen", "[", "\\lbrack", "]", "\\rbrack", "\\{", "\\lbrace", "\\}", "\\rbrace", "\\lfloor", "\\rfloor", "⌊", "⌋", "\\lceil", "\\rceil", "⌈", "⌉", "\\surd"], Qqt = ["\\uparrow", "\\downarrow", "\\updownarrow", "\\Uparrow", "\\Downarrow", "\\Updownarrow", "|", "\\|", "\\vert", "\\Vert", "\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\lgroup", "\\rgroup", "⟮", "⟯", "\\lmoustache", "\\rmoustache", "⎰", "⎱"], Dne = ["<", ">", "\\langle", "\\rangle", "/", "\\backslash", "\\lt", "\\gt"], Mh = [0, 1.2, 1.8, 2.4, 3], Xqt = function(e, n, r, i, a) {
  if (e === "<" || e === "\\lt" || e === "⟨" ? e = "\\langle" : (e === ">" || e === "\\gt" || e === "⟩") && (e = "\\rangle"), wt.contains(Nne, e) || wt.contains(Dne, e))
    return Ene(e, n, !1, r, i, a);
  if (wt.contains(Qqt, e))
    return jne(e, Mh[n], !1, r, i, a);
  throw new Ge("Illegal delimiter: '" + e + "'");
}, eUt = [{
  type: "small",
  style: St.SCRIPTSCRIPT
}, {
  type: "small",
  style: St.SCRIPT
}, {
  type: "small",
  style: St.TEXT
}, {
  type: "large",
  size: 1
}, {
  type: "large",
  size: 2
}, {
  type: "large",
  size: 3
}, {
  type: "large",
  size: 4
}], tUt = [{
  type: "small",
  style: St.SCRIPTSCRIPT
}, {
  type: "small",
  style: St.SCRIPT
}, {
  type: "small",
  style: St.TEXT
}, {
  type: "stack"
}], Ine = [{
  type: "small",
  style: St.SCRIPTSCRIPT
}, {
  type: "small",
  style: St.SCRIPT
}, {
  type: "small",
  style: St.TEXT
}, {
  type: "large",
  size: 1
}, {
  type: "large",
  size: 2
}, {
  type: "large",
  size: 3
}, {
  type: "large",
  size: 4
}, {
  type: "stack"
}], nUt = function(e) {
  if (e.type === "small")
    return "Main-Regular";
  if (e.type === "large")
    return "Size" + e.size + "-Regular";
  if (e.type === "stack")
    return "Size4-Regular";
  throw new Error("Add support for delim type '" + e.type + "' here.");
}, Pne = function(e, n, r, i) {
  for (var a = Math.min(2, 3 - i.style.size), o = a; o < r.length && r[o].type !== "stack"; o++) {
    var s = _f(e, nUt(r[o]), "math"), l = s.height + s.depth;
    if (r[o].type === "small") {
      var c = i.havingBaseStyle(r[o].style);
      l *= c.sizeMultiplier;
    }
    if (l > n)
      return r[o];
  }
  return r[r.length - 1];
}, zne = function(e, n, r, i, a, o) {
  e === "<" || e === "\\lt" || e === "⟨" ? e = "\\langle" : (e === ">" || e === "\\gt" || e === "⟩") && (e = "\\rangle");
  var s;
  wt.contains(Dne, e) ? s = eUt : wt.contains(Nne, e) ? s = Ine : s = tUt;
  var l = Pne(e, n, s, i);
  return l.type === "small" ? Gqt(e, l.style, r, i, a, o) : l.type === "large" ? Ene(e, l.size, r, i, a, o) : jne(e, n, r, i, a, o);
}, rUt = function(e, n, r, i, a, o) {
  var s = i.fontMetrics().axisHeight * i.sizeMultiplier, l = 901, c = 5 / i.fontMetrics().ptPerEm, u = Math.max(n - s, r + s), d = Math.max(
    // In real TeX, calculations are done using integral values which are
    // 65536 per pt, or 655360 per em. So, the division here truncates in
    // TeX but doesn't here, producing different results. If we wanted to
    // exactly match TeX's calculation, we could do
    //   Math.floor(655360 * maxDistFromAxis / 500) *
    //    delimiterFactor / 655360
    // (To see the difference, compare
    //    x^{x^{\left(\rule{0.1em}{0.68em}\right)}}
    // in TeX and KaTeX)
    u / 500 * l,
    2 * u - c
  );
  return zne(e, d, !0, i, a, o);
}, rl = {
  sqrtImage: Jqt,
  sizedDelim: Xqt,
  sizeToMaxHeight: Mh,
  customSizedDelim: zne,
  leftRightDelim: rUt
}, gO = {
  "\\bigl": {
    mclass: "mopen",
    size: 1
  },
  "\\Bigl": {
    mclass: "mopen",
    size: 2
  },
  "\\biggl": {
    mclass: "mopen",
    size: 3
  },
  "\\Biggl": {
    mclass: "mopen",
    size: 4
  },
  "\\bigr": {
    mclass: "mclose",
    size: 1
  },
  "\\Bigr": {
    mclass: "mclose",
    size: 2
  },
  "\\biggr": {
    mclass: "mclose",
    size: 3
  },
  "\\Biggr": {
    mclass: "mclose",
    size: 4
  },
  "\\bigm": {
    mclass: "mrel",
    size: 1
  },
  "\\Bigm": {
    mclass: "mrel",
    size: 2
  },
  "\\biggm": {
    mclass: "mrel",
    size: 3
  },
  "\\Biggm": {
    mclass: "mrel",
    size: 4
  },
  "\\big": {
    mclass: "mord",
    size: 1
  },
  "\\Big": {
    mclass: "mord",
    size: 2
  },
  "\\bigg": {
    mclass: "mord",
    size: 3
  },
  "\\Bigg": {
    mclass: "mord",
    size: 4
  }
}, iUt = ["(", "\\lparen", ")", "\\rparen", "[", "\\lbrack", "]", "\\rbrack", "\\{", "\\lbrace", "\\}", "\\rbrace", "\\lfloor", "\\rfloor", "⌊", "⌋", "\\lceil", "\\rceil", "⌈", "⌉", "<", ">", "\\langle", "⟨", "\\rangle", "⟩", "\\lt", "\\gt", "\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\lgroup", "\\rgroup", "⟮", "⟯", "\\lmoustache", "\\rmoustache", "⎰", "⎱", "/", "\\backslash", "|", "\\vert", "\\|", "\\Vert", "\\uparrow", "\\Uparrow", "\\downarrow", "\\Downarrow", "\\updownarrow", "\\Updownarrow", "."];
function T5(t, e) {
  var n = S5(t);
  if (n && wt.contains(iUt, n.text))
    return n;
  throw n ? new Ge("Invalid delimiter '" + n.text + "' after '" + e.funcName + "'", t) : new Ge("Invalid delimiter type '" + t.type + "'", t);
}
at({
  type: "delimsizing",
  names: ["\\bigl", "\\Bigl", "\\biggl", "\\Biggl", "\\bigr", "\\Bigr", "\\biggr", "\\Biggr", "\\bigm", "\\Bigm", "\\biggm", "\\Biggm", "\\big", "\\Big", "\\bigg", "\\Bigg"],
  props: {
    numArgs: 1,
    argTypes: ["primitive"]
  },
  handler: (t, e) => {
    var n = T5(e[0], t);
    return {
      type: "delimsizing",
      mode: t.parser.mode,
      size: gO[t.funcName].size,
      mclass: gO[t.funcName].mclass,
      delim: n.text
    };
  },
  htmlBuilder: (t, e) => t.delim === "." ? ke.makeSpan([t.mclass]) : rl.sizedDelim(t.delim, t.size, e, t.mode, [t.mclass]),
  mathmlBuilder: (t) => {
    var e = [];
    t.delim !== "." && e.push(Ba(t.delim, t.mode));
    var n = new qe.MathNode("mo", e);
    t.mclass === "mopen" || t.mclass === "mclose" ? n.setAttribute("fence", "true") : n.setAttribute("fence", "false"), n.setAttribute("stretchy", "true");
    var r = Qe(rl.sizeToMaxHeight[t.size]);
    return n.setAttribute("minsize", r), n.setAttribute("maxsize", r), n;
  }
});
function vO(t) {
  if (!t.body)
    throw new Error("Bug: The leftright ParseNode wasn't fully parsed.");
}
at({
  type: "leftright-right",
  names: ["\\right"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (t, e) => {
    var n = t.parser.gullet.macros.get("\\current@color");
    if (n && typeof n != "string")
      throw new Ge("\\current@color set to non-string in \\right");
    return {
      type: "leftright-right",
      mode: t.parser.mode,
      delim: T5(e[0], t).text,
      color: n
      // undefined if not set via \color
    };
  }
});
at({
  type: "leftright",
  names: ["\\left"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (t, e) => {
    var n = T5(e[0], t), r = t.parser;
    ++r.leftrightDepth;
    var i = r.parseExpression(!1);
    --r.leftrightDepth, r.expect("\\right", !1);
    var a = Ut(r.parseFunction(), "leftright-right");
    return {
      type: "leftright",
      mode: r.mode,
      body: i,
      left: n.text,
      right: a.delim,
      rightColor: a.color
    };
  },
  htmlBuilder: (t, e) => {
    vO(t);
    for (var n = yr(t.body, e, !0, ["mopen", "mclose"]), r = 0, i = 0, a = !1, o = 0; o < n.length; o++)
      n[o].isMiddle ? a = !0 : (r = Math.max(n[o].height, r), i = Math.max(n[o].depth, i));
    r *= e.sizeMultiplier, i *= e.sizeMultiplier;
    var s;
    if (t.left === "." ? s = J2(e, ["mopen"]) : s = rl.leftRightDelim(t.left, r, i, e, t.mode, ["mopen"]), n.unshift(s), a)
      for (var l = 1; l < n.length; l++) {
        var c = n[l], u = c.isMiddle;
        u && (n[l] = rl.leftRightDelim(u.delim, r, i, u.options, t.mode, []));
      }
    var d;
    if (t.right === ".")
      d = J2(e, ["mclose"]);
    else {
      var f = t.rightColor ? e.withColor(t.rightColor) : e;
      d = rl.leftRightDelim(t.right, r, i, f, t.mode, ["mclose"]);
    }
    return n.push(d), ke.makeSpan(["minner"], n, e);
  },
  mathmlBuilder: (t, e) => {
    vO(t);
    var n = Bi(t.body, e);
    if (t.left !== ".") {
      var r = new qe.MathNode("mo", [Ba(t.left, t.mode)]);
      r.setAttribute("fence", "true"), n.unshift(r);
    }
    if (t.right !== ".") {
      var i = new qe.MathNode("mo", [Ba(t.right, t.mode)]);
      i.setAttribute("fence", "true"), t.rightColor && i.setAttribute("mathcolor", t.rightColor), n.push(i);
    }
    return AL(n);
  }
});
at({
  type: "middle",
  names: ["\\middle"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (t, e) => {
    var n = T5(e[0], t);
    if (!t.parser.leftrightDepth)
      throw new Ge("\\middle without preceding \\left", n);
    return {
      type: "middle",
      mode: t.parser.mode,
      delim: n.text
    };
  },
  htmlBuilder: (t, e) => {
    var n;
    if (t.delim === ".")
      n = J2(e, []);
    else {
      n = rl.sizedDelim(t.delim, 1, e, t.mode, []);
      var r = {
        delim: t.delim,
        options: e
      };
      n.isMiddle = r;
    }
    return n;
  },
  mathmlBuilder: (t, e) => {
    var n = t.delim === "\\vert" || t.delim === "|" ? Ba("|", "text") : Ba(t.delim, t.mode), r = new qe.MathNode("mo", [n]);
    return r.setAttribute("fence", "true"), r.setAttribute("lspace", "0.05em"), r.setAttribute("rspace", "0.05em"), r;
  }
});
var jL = (t, e) => {
  var n = ke.wrapFragment(on(t.body, e), e), r = t.label.slice(1), i = e.sizeMultiplier, a, o = 0, s = wt.isCharacterBox(t.body);
  if (r === "sout")
    a = ke.makeSpan(["stretchy", "sout"]), a.height = e.fontMetrics().defaultRuleThickness / i, o = -0.5 * e.fontMetrics().xHeight;
  else if (r === "phase") {
    var l = Bn({
      number: 0.6,
      unit: "pt"
    }, e), c = Bn({
      number: 0.35,
      unit: "ex"
    }, e), u = e.havingBaseSizing();
    i = i / u.sizeMultiplier;
    var d = n.height + n.depth + l + c;
    n.style.paddingLeft = Qe(d / 2 + l);
    var f = Math.floor(1e3 * d * i), h = $Vt(f), p = new wl([new Pc("phase", h)], {
      width: "400em",
      height: Qe(f / 1e3),
      viewBox: "0 0 400000 " + f,
      preserveAspectRatio: "xMinYMin slice"
    });
    a = ke.makeSvgSpan(["hide-tail"], [p], e), a.style.height = Qe(d), o = n.depth + l + c;
  } else {
    /cancel/.test(r) ? s || n.classes.push("cancel-pad") : r === "angl" ? n.classes.push("anglpad") : n.classes.push("boxpad");
    var m = 0, g = 0, v = 0;
    /box/.test(r) ? (v = Math.max(
      e.fontMetrics().fboxrule,
      // default
      e.minRuleThickness
      // User override.
    ), m = e.fontMetrics().fboxsep + (r === "colorbox" ? 0 : v), g = m) : r === "angl" ? (v = Math.max(e.fontMetrics().defaultRuleThickness, e.minRuleThickness), m = 4 * v, g = Math.max(0, 0.25 - n.depth)) : (m = s ? 0.2 : 0, g = m), a = xl.encloseSpan(n, r, m, g, e), /fbox|boxed|fcolorbox/.test(r) ? (a.style.borderStyle = "solid", a.style.borderWidth = Qe(v)) : r === "angl" && v !== 0.049 && (a.style.borderTopWidth = Qe(v), a.style.borderRightWidth = Qe(v)), o = n.depth + g, t.backgroundColor && (a.style.backgroundColor = t.backgroundColor, t.borderColor && (a.style.borderColor = t.borderColor));
  }
  var k;
  if (t.backgroundColor)
    k = ke.makeVList({
      positionType: "individualShift",
      children: [
        // Put the color background behind inner;
        {
          type: "elem",
          elem: a,
          shift: o
        },
        {
          type: "elem",
          elem: n,
          shift: 0
        }
      ]
    }, e);
  else {
    var w = /cancel|phase/.test(r) ? ["svg-align"] : [];
    k = ke.makeVList({
      positionType: "individualShift",
      children: [
        // Write the \cancel stroke on top of inner.
        {
          type: "elem",
          elem: n,
          shift: 0
        },
        {
          type: "elem",
          elem: a,
          shift: o,
          wrapperClasses: w
        }
      ]
    }, e);
  }
  return /cancel/.test(r) && (k.height = n.height, k.depth = n.depth), /cancel/.test(r) && !s ? ke.makeSpan(["mord", "cancel-lap"], [k], e) : ke.makeSpan(["mord"], [k], e);
}, NL = (t, e) => {
  var n = 0, r = new qe.MathNode(t.label.indexOf("colorbox") > -1 ? "mpadded" : "menclose", [yn(t.body, e)]);
  switch (t.label) {
    case "\\cancel":
      r.setAttribute("notation", "updiagonalstrike");
      break;
    case "\\bcancel":
      r.setAttribute("notation", "downdiagonalstrike");
      break;
    case "\\phase":
      r.setAttribute("notation", "phasorangle");
      break;
    case "\\sout":
      r.setAttribute("notation", "horizontalstrike");
      break;
    case "\\fbox":
      r.setAttribute("notation", "box");
      break;
    case "\\angl":
      r.setAttribute("notation", "actuarial");
      break;
    case "\\fcolorbox":
    case "\\colorbox":
      if (n = e.fontMetrics().fboxsep * e.fontMetrics().ptPerEm, r.setAttribute("width", "+" + 2 * n + "pt"), r.setAttribute("height", "+" + 2 * n + "pt"), r.setAttribute("lspace", n + "pt"), r.setAttribute("voffset", n + "pt"), t.label === "\\fcolorbox") {
        var i = Math.max(
          e.fontMetrics().fboxrule,
          // default
          e.minRuleThickness
          // user override
        );
        r.setAttribute("style", "border: " + i + "em solid " + String(t.borderColor));
      }
      break;
    case "\\xcancel":
      r.setAttribute("notation", "updiagonalstrike downdiagonalstrike");
      break;
  }
  return t.backgroundColor && r.setAttribute("mathbackground", t.backgroundColor), r;
};
at({
  type: "enclose",
  names: ["\\colorbox"],
  props: {
    numArgs: 2,
    allowedInText: !0,
    argTypes: ["color", "text"]
  },
  handler(t, e, n) {
    var {
      parser: r,
      funcName: i
    } = t, a = Ut(e[0], "color-token").color, o = e[1];
    return {
      type: "enclose",
      mode: r.mode,
      label: i,
      backgroundColor: a,
      body: o
    };
  },
  htmlBuilder: jL,
  mathmlBuilder: NL
});
at({
  type: "enclose",
  names: ["\\fcolorbox"],
  props: {
    numArgs: 3,
    allowedInText: !0,
    argTypes: ["color", "color", "text"]
  },
  handler(t, e, n) {
    var {
      parser: r,
      funcName: i
    } = t, a = Ut(e[0], "color-token").color, o = Ut(e[1], "color-token").color, s = e[2];
    return {
      type: "enclose",
      mode: r.mode,
      label: i,
      backgroundColor: o,
      borderColor: a,
      body: s
    };
  },
  htmlBuilder: jL,
  mathmlBuilder: NL
});
at({
  type: "enclose",
  names: ["\\fbox"],
  props: {
    numArgs: 1,
    argTypes: ["hbox"],
    allowedInText: !0
  },
  handler(t, e) {
    var {
      parser: n
    } = t;
    return {
      type: "enclose",
      mode: n.mode,
      label: "\\fbox",
      body: e[0]
    };
  }
});
at({
  type: "enclose",
  names: ["\\cancel", "\\bcancel", "\\xcancel", "\\sout", "\\phase"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var {
      parser: n,
      funcName: r
    } = t, i = e[0];
    return {
      type: "enclose",
      mode: n.mode,
      label: r,
      body: i
    };
  },
  htmlBuilder: jL,
  mathmlBuilder: NL
});
at({
  type: "enclose",
  names: ["\\angl"],
  props: {
    numArgs: 1,
    argTypes: ["hbox"],
    allowedInText: !1
  },
  handler(t, e) {
    var {
      parser: n
    } = t;
    return {
      type: "enclose",
      mode: n.mode,
      label: "\\angl",
      body: e[0]
    };
  }
});
var Rne = {};
function bs(t) {
  for (var {
    type: e,
    names: n,
    props: r,
    handler: i,
    htmlBuilder: a,
    mathmlBuilder: o
  } = t, s = {
    type: e,
    numArgs: r.numArgs || 0,
    allowedInText: !1,
    numOptionalArgs: 0,
    handler: i
  }, l = 0; l < n.length; ++l)
    Rne[n[l]] = s;
  a && (cg[e] = a), o && (ug[e] = o);
}
var One = {};
function U(t, e) {
  One[t] = e;
}
function bO(t) {
  var e = [];
  t.consumeSpaces();
  var n = t.fetch().text;
  for (n === "\\relax" && (t.consume(), t.consumeSpaces(), n = t.fetch().text); n === "\\hline" || n === "\\hdashline"; )
    t.consume(), e.push(n === "\\hdashline"), t.consumeSpaces(), n = t.fetch().text;
  return e;
}
var E5 = (t) => {
  var e = t.parser.settings;
  if (!e.displayMode)
    throw new Ge("{" + t.envName + "} can be used only in display mode.");
};
function DL(t) {
  if (t.indexOf("ed") === -1)
    return t.indexOf("*") === -1;
}
function Qc(t, e, n) {
  var {
    hskipBeforeAndAfter: r,
    addJot: i,
    cols: a,
    arraystretch: o,
    colSeparationType: s,
    autoTag: l,
    singleRow: c,
    emptySingleRow: u,
    maxNumCols: d,
    leqno: f
  } = e;
  if (t.gullet.beginGroup(), c || t.gullet.macros.set("\\cr", "\\\\\\relax"), !o) {
    var h = t.gullet.expandMacroAsText("\\arraystretch");
    if (h == null)
      o = 1;
    else if (o = parseFloat(h), !o || o < 0)
      throw new Ge("Invalid \\arraystretch: " + h);
  }
  t.gullet.beginGroup();
  var p = [], m = [p], g = [], v = [], k = l != null ? [] : void 0;
  function w() {
    l && t.gullet.macros.set("\\@eqnsw", "1", !0);
  }
  function b() {
    k && (t.gullet.macros.get("\\df@tag") ? (k.push(t.subparse([new Qo("\\df@tag")])), t.gullet.macros.set("\\df@tag", void 0, !0)) : k.push(!!l && t.gullet.macros.get("\\@eqnsw") === "1"));
  }
  for (w(), v.push(bO(t)); ; ) {
    var x = t.parseExpression(!1, c ? "\\end" : "\\\\");
    t.gullet.endGroup(), t.gullet.beginGroup(), x = {
      type: "ordgroup",
      mode: t.mode,
      body: x
    }, n && (x = {
      type: "styling",
      mode: t.mode,
      style: n,
      body: [x]
    }), p.push(x);
    var A = t.fetch().text;
    if (A === "&") {
      if (d && p.length === d) {
        if (c || s)
          throw new Ge("Too many tab characters: &", t.nextToken);
        t.settings.reportNonstrict("textEnv", "Too few columns specified in the {array} column argument.");
      }
      t.consume();
    } else if (A === "\\end") {
      b(), p.length === 1 && x.type === "styling" && x.body[0].body.length === 0 && (m.length > 1 || !u) && m.pop(), v.length < m.length + 1 && v.push([]);
      break;
    } else if (A === "\\\\") {
      t.consume();
      var L = void 0;
      t.gullet.future().text !== " " && (L = t.parseSizeGroup(!0)), g.push(L ? L.value : null), b(), v.push(bO(t)), p = [], m.push(p), w();
    } else
      throw new Ge("Expected & or \\\\ or \\cr or \\end", t.nextToken);
  }
  return t.gullet.endGroup(), t.gullet.endGroup(), {
    type: "array",
    mode: t.mode,
    addJot: i,
    arraystretch: o,
    body: m,
    cols: a,
    rowGaps: g,
    hskipBeforeAndAfter: r,
    hLinesBeforeRow: v,
    colSeparationType: s,
    tags: k,
    leqno: f
  };
}
function IL(t) {
  return t.slice(0, 1) === "d" ? "display" : "text";
}
var ws = function(e, n) {
  var r, i, a = e.body.length, o = e.hLinesBeforeRow, s = 0, l = new Array(a), c = [], u = Math.max(
    // From LaTeX \showthe\arrayrulewidth. Equals 0.04 em.
    n.fontMetrics().arrayRuleWidth,
    n.minRuleThickness
    // User override.
  ), d = 1 / n.fontMetrics().ptPerEm, f = 5 * d;
  if (e.colSeparationType && e.colSeparationType === "small") {
    var h = n.havingStyle(St.SCRIPT).sizeMultiplier;
    f = 0.2778 * (h / n.sizeMultiplier);
  }
  var p = e.colSeparationType === "CD" ? Bn({
    number: 3,
    unit: "ex"
  }, n) : 12 * d, m = 3 * d, g = e.arraystretch * p, v = 0.7 * g, k = 0.3 * g, w = 0;
  function b(Ie) {
    for (var q = 0; q < Ie.length; ++q)
      q > 0 && (w += 0.25), c.push({
        pos: w,
        isDashed: Ie[q]
      });
  }
  for (b(o[0]), r = 0; r < e.body.length; ++r) {
    var x = e.body[r], A = v, L = k;
    s < x.length && (s = x.length);
    var M = new Array(x.length);
    for (i = 0; i < x.length; ++i) {
      var j = on(x[i], n);
      L < j.depth && (L = j.depth), A < j.height && (A = j.height), M[i] = j;
    }
    var D = e.rowGaps[r], z = 0;
    D && (z = Bn(D, n), z > 0 && (z += k, L < z && (L = z), z = 0)), e.addJot && (L += m), M.height = A, M.depth = L, w += A, M.pos = w, w += L + z, l[r] = M, b(o[r + 1]);
  }
  var H = w / 2 + n.fontMetrics().axisHeight, V = e.cols || [], F = [], _, W, G = [];
  if (e.tags && e.tags.some((Ie) => Ie))
    for (r = 0; r < a; ++r) {
      var Y = l[r], Z = Y.pos - H, oe = e.tags[r], ee = void 0;
      oe === !0 ? ee = ke.makeSpan(["eqn-num"], [], n) : oe === !1 ? ee = ke.makeSpan([], [], n) : ee = ke.makeSpan([], yr(oe, n, !0), n), ee.depth = Y.depth, ee.height = Y.height, G.push({
        type: "elem",
        elem: ee,
        shift: Z
      });
    }
  for (
    i = 0, W = 0;
    // Continue while either there are more columns or more column
    // descriptions, so trailing separators don't get lost.
    i < s || W < V.length;
    ++i, ++W
  ) {
    for (var ae = V[W] || {}, fe = !0; ae.type === "separator"; ) {
      if (fe || (_ = ke.makeSpan(["arraycolsep"], []), _.style.width = Qe(n.fontMetrics().doubleRuleSep), F.push(_)), ae.separator === "|" || ae.separator === ":") {
        var me = ae.separator === "|" ? "solid" : "dashed", ge = ke.makeSpan(["vertical-separator"], [], n);
        ge.style.height = Qe(w), ge.style.borderRightWidth = Qe(u), ge.style.borderRightStyle = me, ge.style.margin = "0 " + Qe(-u / 2);
        var $ = w - H;
        $ && (ge.style.verticalAlign = Qe(-$)), F.push(ge);
      } else
        throw new Ge("Invalid separator type: " + ae.separator);
      W++, ae = V[W] || {}, fe = !1;
    }
    if (!(i >= s)) {
      var se = void 0;
      (i > 0 || e.hskipBeforeAndAfter) && (se = wt.deflt(ae.pregap, f), se !== 0 && (_ = ke.makeSpan(["arraycolsep"], []), _.style.width = Qe(se), F.push(_)));
      var xe = [];
      for (r = 0; r < a; ++r) {
        var Oe = l[r], je = Oe[i];
        if (je) {
          var Me = Oe.pos - H;
          je.depth = Oe.depth, je.height = Oe.height, xe.push({
            type: "elem",
            elem: je,
            shift: Me
          });
        }
      }
      xe = ke.makeVList({
        positionType: "individualShift",
        children: xe
      }, n), xe = ke.makeSpan(["col-align-" + (ae.align || "c")], [xe]), F.push(xe), (i < s - 1 || e.hskipBeforeAndAfter) && (se = wt.deflt(ae.postgap, f), se !== 0 && (_ = ke.makeSpan(["arraycolsep"], []), _.style.width = Qe(se), F.push(_)));
    }
  }
  if (l = ke.makeSpan(["mtable"], F), c.length > 0) {
    for (var he = ke.makeLineSpan("hline", n, u), pe = ke.makeLineSpan("hdashline", n, u), J = [{
      type: "elem",
      elem: l,
      shift: 0
    }]; c.length > 0; ) {
      var K = c.pop(), X = K.pos - H;
      K.isDashed ? J.push({
        type: "elem",
        elem: pe,
        shift: X
      }) : J.push({
        type: "elem",
        elem: he,
        shift: X
      });
    }
    l = ke.makeVList({
      positionType: "individualShift",
      children: J
    }, n);
  }
  if (G.length === 0)
    return ke.makeSpan(["mord"], [l], n);
  var re = ke.makeVList({
    positionType: "individualShift",
    children: G
  }, n);
  return re = ke.makeSpan(["tag"], [re], n), ke.makeFragment([l, re]);
}, aUt = {
  c: "center ",
  l: "left ",
  r: "right "
}, ks = function(e, n) {
  for (var r = [], i = new qe.MathNode("mtd", [], ["mtr-glue"]), a = new qe.MathNode("mtd", [], ["mml-eqn-num"]), o = 0; o < e.body.length; o++) {
    for (var s = e.body[o], l = [], c = 0; c < s.length; c++)
      l.push(new qe.MathNode("mtd", [yn(s[c], n)]));
    e.tags && e.tags[o] && (l.unshift(i), l.push(i), e.leqno ? l.unshift(a) : l.push(a)), r.push(new qe.MathNode("mtr", l));
  }
  var u = new qe.MathNode("mtable", r), d = e.arraystretch === 0.5 ? 0.1 : 0.16 + e.arraystretch - 1 + (e.addJot ? 0.09 : 0);
  u.setAttribute("rowspacing", Qe(d));
  var f = "", h = "";
  if (e.cols && e.cols.length > 0) {
    var p = e.cols, m = "", g = !1, v = 0, k = p.length;
    p[0].type === "separator" && (f += "top ", v = 1), p[p.length - 1].type === "separator" && (f += "bottom ", k -= 1);
    for (var w = v; w < k; w++)
      p[w].type === "align" ? (h += aUt[p[w].align], g && (m += "none "), g = !0) : p[w].type === "separator" && g && (m += p[w].separator === "|" ? "solid " : "dashed ", g = !1);
    u.setAttribute("columnalign", h.trim()), /[sd]/.test(m) && u.setAttribute("columnlines", m.trim());
  }
  if (e.colSeparationType === "align") {
    for (var b = e.cols || [], x = "", A = 1; A < b.length; A++)
      x += A % 2 ? "0em " : "1em ";
    u.setAttribute("columnspacing", x.trim());
  } else e.colSeparationType === "alignat" || e.colSeparationType === "gather" ? u.setAttribute("columnspacing", "0em") : e.colSeparationType === "small" ? u.setAttribute("columnspacing", "0.2778em") : e.colSeparationType === "CD" ? u.setAttribute("columnspacing", "0.5em") : u.setAttribute("columnspacing", "1em");
  var L = "", M = e.hLinesBeforeRow;
  f += M[0].length > 0 ? "left " : "", f += M[M.length - 1].length > 0 ? "right " : "";
  for (var j = 1; j < M.length - 1; j++)
    L += M[j].length === 0 ? "none " : M[j][0] ? "dashed " : "solid ";
  return /[sd]/.test(L) && u.setAttribute("rowlines", L.trim()), f !== "" && (u = new qe.MathNode("menclose", [u]), u.setAttribute("notation", f.trim())), e.arraystretch && e.arraystretch < 1 && (u = new qe.MathNode("mstyle", [u]), u.setAttribute("scriptlevel", "1")), u;
}, Bne = function(e, n) {
  e.envName.indexOf("ed") === -1 && E5(e);
  var r = [], i = e.envName.indexOf("at") > -1 ? "alignat" : "align", a = e.envName === "split", o = Qc(e.parser, {
    cols: r,
    addJot: !0,
    autoTag: a ? void 0 : DL(e.envName),
    emptySingleRow: !0,
    colSeparationType: i,
    maxNumCols: a ? 2 : void 0,
    leqno: e.parser.settings.leqno
  }, "display"), s, l = 0, c = {
    type: "ordgroup",
    mode: e.mode,
    body: []
  };
  if (n[0] && n[0].type === "ordgroup") {
    for (var u = "", d = 0; d < n[0].body.length; d++) {
      var f = Ut(n[0].body[d], "textord");
      u += f.text;
    }
    s = Number(u), l = s * 2;
  }
  var h = !l;
  o.body.forEach(function(v) {
    for (var k = 1; k < v.length; k += 2) {
      var w = Ut(v[k], "styling"), b = Ut(w.body[0], "ordgroup");
      b.body.unshift(c);
    }
    if (h)
      l < v.length && (l = v.length);
    else {
      var x = v.length / 2;
      if (s < x)
        throw new Ge("Too many math in a row: " + ("expected " + s + ", but got " + x), v[0]);
    }
  });
  for (var p = 0; p < l; ++p) {
    var m = "r", g = 0;
    p % 2 === 1 ? m = "l" : p > 0 && h && (g = 1), r[p] = {
      type: "align",
      align: m,
      pregap: g,
      postgap: 0
    };
  }
  return o.colSeparationType = h ? "align" : "alignat", o;
};
bs({
  type: "array",
  names: ["array", "darray"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var n = S5(e[0]), r = n ? [e[0]] : Ut(e[0], "ordgroup").body, i = r.map(function(o) {
      var s = LL(o), l = s.text;
      if ("lcr".indexOf(l) !== -1)
        return {
          type: "align",
          align: l
        };
      if (l === "|")
        return {
          type: "separator",
          separator: "|"
        };
      if (l === ":")
        return {
          type: "separator",
          separator: ":"
        };
      throw new Ge("Unknown column alignment: " + l, o);
    }), a = {
      cols: i,
      hskipBeforeAndAfter: !0,
      // \@preamble in lttab.dtx
      maxNumCols: i.length
    };
    return Qc(t.parser, a, IL(t.envName));
  },
  htmlBuilder: ws,
  mathmlBuilder: ks
});
bs({
  type: "array",
  names: ["matrix", "pmatrix", "bmatrix", "Bmatrix", "vmatrix", "Vmatrix", "matrix*", "pmatrix*", "bmatrix*", "Bmatrix*", "vmatrix*", "Vmatrix*"],
  props: {
    numArgs: 0
  },
  handler(t) {
    var e = {
      matrix: null,
      pmatrix: ["(", ")"],
      bmatrix: ["[", "]"],
      Bmatrix: ["\\{", "\\}"],
      vmatrix: ["|", "|"],
      Vmatrix: ["\\Vert", "\\Vert"]
    }[t.envName.replace("*", "")], n = "c", r = {
      hskipBeforeAndAfter: !1,
      cols: [{
        type: "align",
        align: n
      }]
    };
    if (t.envName.charAt(t.envName.length - 1) === "*") {
      var i = t.parser;
      if (i.consumeSpaces(), i.fetch().text === "[") {
        if (i.consume(), i.consumeSpaces(), n = i.fetch().text, "lcr".indexOf(n) === -1)
          throw new Ge("Expected l or c or r", i.nextToken);
        i.consume(), i.consumeSpaces(), i.expect("]"), i.consume(), r.cols = [{
          type: "align",
          align: n
        }];
      }
    }
    var a = Qc(t.parser, r, IL(t.envName)), o = Math.max(0, ...a.body.map((s) => s.length));
    return a.cols = new Array(o).fill({
      type: "align",
      align: n
    }), e ? {
      type: "leftright",
      mode: t.mode,
      body: [a],
      left: e[0],
      right: e[1],
      rightColor: void 0
      // \right uninfluenced by \color in array
    } : a;
  },
  htmlBuilder: ws,
  mathmlBuilder: ks
});
bs({
  type: "array",
  names: ["smallmatrix"],
  props: {
    numArgs: 0
  },
  handler(t) {
    var e = {
      arraystretch: 0.5
    }, n = Qc(t.parser, e, "script");
    return n.colSeparationType = "small", n;
  },
  htmlBuilder: ws,
  mathmlBuilder: ks
});
bs({
  type: "array",
  names: ["subarray"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var n = S5(e[0]), r = n ? [e[0]] : Ut(e[0], "ordgroup").body, i = r.map(function(o) {
      var s = LL(o), l = s.text;
      if ("lc".indexOf(l) !== -1)
        return {
          type: "align",
          align: l
        };
      throw new Ge("Unknown column alignment: " + l, o);
    });
    if (i.length > 1)
      throw new Ge("{subarray} can contain only one column");
    var a = {
      cols: i,
      hskipBeforeAndAfter: !1,
      arraystretch: 0.5
    };
    if (a = Qc(t.parser, a, "script"), a.body.length > 0 && a.body[0].length > 1)
      throw new Ge("{subarray} can contain only one column");
    return a;
  },
  htmlBuilder: ws,
  mathmlBuilder: ks
});
bs({
  type: "array",
  names: ["cases", "dcases", "rcases", "drcases"],
  props: {
    numArgs: 0
  },
  handler(t) {
    var e = {
      arraystretch: 1.2,
      cols: [{
        type: "align",
        align: "l",
        pregap: 0,
        // TODO(kevinb) get the current style.
        // For now we use the metrics for TEXT style which is what we were
        // doing before.  Before attempting to get the current style we
        // should look at TeX's behavior especially for \over and matrices.
        postgap: 1
        /* 1em quad */
      }, {
        type: "align",
        align: "l",
        pregap: 0,
        postgap: 0
      }]
    }, n = Qc(t.parser, e, IL(t.envName));
    return {
      type: "leftright",
      mode: t.mode,
      body: [n],
      left: t.envName.indexOf("r") > -1 ? "." : "\\{",
      right: t.envName.indexOf("r") > -1 ? "\\}" : ".",
      rightColor: void 0
    };
  },
  htmlBuilder: ws,
  mathmlBuilder: ks
});
bs({
  type: "array",
  names: ["align", "align*", "aligned", "split"],
  props: {
    numArgs: 0
  },
  handler: Bne,
  htmlBuilder: ws,
  mathmlBuilder: ks
});
bs({
  type: "array",
  names: ["gathered", "gather", "gather*"],
  props: {
    numArgs: 0
  },
  handler(t) {
    wt.contains(["gather", "gather*"], t.envName) && E5(t);
    var e = {
      cols: [{
        type: "align",
        align: "c"
      }],
      addJot: !0,
      colSeparationType: "gather",
      autoTag: DL(t.envName),
      emptySingleRow: !0,
      leqno: t.parser.settings.leqno
    };
    return Qc(t.parser, e, "display");
  },
  htmlBuilder: ws,
  mathmlBuilder: ks
});
bs({
  type: "array",
  names: ["alignat", "alignat*", "alignedat"],
  props: {
    numArgs: 1
  },
  handler: Bne,
  htmlBuilder: ws,
  mathmlBuilder: ks
});
bs({
  type: "array",
  names: ["equation", "equation*"],
  props: {
    numArgs: 0
  },
  handler(t) {
    E5(t);
    var e = {
      autoTag: DL(t.envName),
      emptySingleRow: !0,
      singleRow: !0,
      maxNumCols: 1,
      leqno: t.parser.settings.leqno
    };
    return Qc(t.parser, e, "display");
  },
  htmlBuilder: ws,
  mathmlBuilder: ks
});
bs({
  type: "array",
  names: ["CD"],
  props: {
    numArgs: 0
  },
  handler(t) {
    return E5(t), Wqt(t.parser);
  },
  htmlBuilder: ws,
  mathmlBuilder: ks
});
U("\\nonumber", "\\gdef\\@eqnsw{0}");
U("\\notag", "\\nonumber");
at({
  type: "text",
  // Doesn't matter what this is.
  names: ["\\hline", "\\hdashline"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !0
  },
  handler(t, e) {
    throw new Ge(t.funcName + " valid only within array environment");
  }
});
var wO = Rne;
at({
  type: "environment",
  names: ["\\begin", "\\end"],
  props: {
    numArgs: 1,
    argTypes: ["text"]
  },
  handler(t, e) {
    var {
      parser: n,
      funcName: r
    } = t, i = e[0];
    if (i.type !== "ordgroup")
      throw new Ge("Invalid environment name", i);
    for (var a = "", o = 0; o < i.body.length; ++o)
      a += Ut(i.body[o], "textord").text;
    if (r === "\\begin") {
      if (!wO.hasOwnProperty(a))
        throw new Ge("No such environment: " + a, i);
      var s = wO[a], {
        args: l,
        optArgs: c
      } = n.parseArguments("\\begin{" + a + "}", s), u = {
        mode: n.mode,
        envName: a,
        parser: n
      }, d = s.handler(u, l, c);
      n.expect("\\end", !1);
      var f = n.nextToken, h = Ut(n.parseFunction(), "environment");
      if (h.name !== a)
        throw new Ge("Mismatch: \\begin{" + a + "} matched by \\end{" + h.name + "}", f);
      return d;
    }
    return {
      type: "environment",
      mode: n.mode,
      name: a,
      nameGroup: i
    };
  }
});
var Hne = (t, e) => {
  var n = t.font, r = e.withFont(n);
  return on(t.body, r);
}, Fne = (t, e) => {
  var n = t.font, r = e.withFont(n);
  return yn(t.body, r);
}, kO = {
  "\\Bbb": "\\mathbb",
  "\\bold": "\\mathbf",
  "\\frak": "\\mathfrak",
  "\\bm": "\\boldsymbol"
};
at({
  type: "font",
  names: [
    // styles, except \boldsymbol defined below
    "\\mathrm",
    "\\mathit",
    "\\mathbf",
    "\\mathnormal",
    "\\mathsfit",
    // families
    "\\mathbb",
    "\\mathcal",
    "\\mathfrak",
    "\\mathscr",
    "\\mathsf",
    "\\mathtt",
    // aliases, except \bm defined below
    "\\Bbb",
    "\\bold",
    "\\frak"
  ],
  props: {
    numArgs: 1,
    allowedInArgument: !0
  },
  handler: (t, e) => {
    var {
      parser: n,
      funcName: r
    } = t, i = dg(e[0]), a = r;
    return a in kO && (a = kO[a]), {
      type: "font",
      mode: n.mode,
      font: a.slice(1),
      body: i
    };
  },
  htmlBuilder: Hne,
  mathmlBuilder: Fne
});
at({
  type: "mclass",
  names: ["\\boldsymbol", "\\bm"],
  props: {
    numArgs: 1
  },
  handler: (t, e) => {
    var {
      parser: n
    } = t, r = e[0], i = wt.isCharacterBox(r);
    return {
      type: "mclass",
      mode: n.mode,
      mclass: L5(r),
      body: [{
        type: "font",
        mode: n.mode,
        font: "boldsymbol",
        body: r
      }],
      isCharacterBox: i
    };
  }
});
at({
  type: "font",
  names: ["\\rm", "\\sf", "\\tt", "\\bf", "\\it", "\\cal"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: n,
      funcName: r,
      breakOnTokenText: i
    } = t, {
      mode: a
    } = n, o = n.parseExpression(!0, i), s = "math" + r.slice(1);
    return {
      type: "font",
      mode: a,
      font: s,
      body: {
        type: "ordgroup",
        mode: n.mode,
        body: o
      }
    };
  },
  htmlBuilder: Hne,
  mathmlBuilder: Fne
});
var _ne = (t, e) => {
  var n = e;
  return t === "display" ? n = n.id >= St.SCRIPT.id ? n.text() : St.DISPLAY : t === "text" && n.size === St.DISPLAY.size ? n = St.TEXT : t === "script" ? n = St.SCRIPT : t === "scriptscript" && (n = St.SCRIPTSCRIPT), n;
}, PL = (t, e) => {
  var n = _ne(t.size, e.style), r = n.fracNum(), i = n.fracDen(), a;
  a = e.havingStyle(r);
  var o = on(t.numer, a, e);
  if (t.continued) {
    var s = 8.5 / e.fontMetrics().ptPerEm, l = 3.5 / e.fontMetrics().ptPerEm;
    o.height = o.height < s ? s : o.height, o.depth = o.depth < l ? l : o.depth;
  }
  a = e.havingStyle(i);
  var c = on(t.denom, a, e), u, d, f;
  t.hasBarLine ? (t.barSize ? (d = Bn(t.barSize, e), u = ke.makeLineSpan("frac-line", e, d)) : u = ke.makeLineSpan("frac-line", e), d = u.height, f = u.height) : (u = null, d = 0, f = e.fontMetrics().defaultRuleThickness);
  var h, p, m;
  n.size === St.DISPLAY.size || t.size === "display" ? (h = e.fontMetrics().num1, d > 0 ? p = 3 * f : p = 7 * f, m = e.fontMetrics().denom1) : (d > 0 ? (h = e.fontMetrics().num2, p = f) : (h = e.fontMetrics().num3, p = 3 * f), m = e.fontMetrics().denom2);
  var g;
  if (u) {
    var k = e.fontMetrics().axisHeight;
    h - o.depth - (k + 0.5 * d) < p && (h += p - (h - o.depth - (k + 0.5 * d))), k - 0.5 * d - (c.height - m) < p && (m += p - (k - 0.5 * d - (c.height - m)));
    var w = -(k - 0.5 * d);
    g = ke.makeVList({
      positionType: "individualShift",
      children: [{
        type: "elem",
        elem: c,
        shift: m
      }, {
        type: "elem",
        elem: u,
        shift: w
      }, {
        type: "elem",
        elem: o,
        shift: -h
      }]
    }, e);
  } else {
    var v = h - o.depth - (c.height - m);
    v < p && (h += 0.5 * (p - v), m += 0.5 * (p - v)), g = ke.makeVList({
      positionType: "individualShift",
      children: [{
        type: "elem",
        elem: c,
        shift: m
      }, {
        type: "elem",
        elem: o,
        shift: -h
      }]
    }, e);
  }
  a = e.havingStyle(n), g.height *= a.sizeMultiplier / e.sizeMultiplier, g.depth *= a.sizeMultiplier / e.sizeMultiplier;
  var b;
  n.size === St.DISPLAY.size ? b = e.fontMetrics().delim1 : n.size === St.SCRIPTSCRIPT.size ? b = e.havingStyle(St.SCRIPT).fontMetrics().delim2 : b = e.fontMetrics().delim2;
  var x, A;
  return t.leftDelim == null ? x = J2(e, ["mopen"]) : x = rl.customSizedDelim(t.leftDelim, b, !0, e.havingStyle(n), t.mode, ["mopen"]), t.continued ? A = ke.makeSpan([]) : t.rightDelim == null ? A = J2(e, ["mclose"]) : A = rl.customSizedDelim(t.rightDelim, b, !0, e.havingStyle(n), t.mode, ["mclose"]), ke.makeSpan(["mord"].concat(a.sizingClasses(e)), [x, ke.makeSpan(["mfrac"], [g]), A], e);
}, zL = (t, e) => {
  var n = new qe.MathNode("mfrac", [yn(t.numer, e), yn(t.denom, e)]);
  if (!t.hasBarLine)
    n.setAttribute("linethickness", "0px");
  else if (t.barSize) {
    var r = Bn(t.barSize, e);
    n.setAttribute("linethickness", Qe(r));
  }
  var i = _ne(t.size, e.style);
  if (i.size !== e.style.size) {
    n = new qe.MathNode("mstyle", [n]);
    var a = i.size === St.DISPLAY.size ? "true" : "false";
    n.setAttribute("displaystyle", a), n.setAttribute("scriptlevel", "0");
  }
  if (t.leftDelim != null || t.rightDelim != null) {
    var o = [];
    if (t.leftDelim != null) {
      var s = new qe.MathNode("mo", [new qe.TextNode(t.leftDelim.replace("\\", ""))]);
      s.setAttribute("fence", "true"), o.push(s);
    }
    if (o.push(n), t.rightDelim != null) {
      var l = new qe.MathNode("mo", [new qe.TextNode(t.rightDelim.replace("\\", ""))]);
      l.setAttribute("fence", "true"), o.push(l);
    }
    return AL(o);
  }
  return n;
};
at({
  type: "genfrac",
  names: [
    "\\dfrac",
    "\\frac",
    "\\tfrac",
    "\\dbinom",
    "\\binom",
    "\\tbinom",
    "\\\\atopfrac",
    // can’t be entered directly
    "\\\\bracefrac",
    "\\\\brackfrac"
    // ditto
  ],
  props: {
    numArgs: 2,
    allowedInArgument: !0
  },
  handler: (t, e) => {
    var {
      parser: n,
      funcName: r
    } = t, i = e[0], a = e[1], o, s = null, l = null, c = "auto";
    switch (r) {
      case "\\dfrac":
      case "\\frac":
      case "\\tfrac":
        o = !0;
        break;
      case "\\\\atopfrac":
        o = !1;
        break;
      case "\\dbinom":
      case "\\binom":
      case "\\tbinom":
        o = !1, s = "(", l = ")";
        break;
      case "\\\\bracefrac":
        o = !1, s = "\\{", l = "\\}";
        break;
      case "\\\\brackfrac":
        o = !1, s = "[", l = "]";
        break;
      default:
        throw new Error("Unrecognized genfrac command");
    }
    switch (r) {
      case "\\dfrac":
      case "\\dbinom":
        c = "display";
        break;
      case "\\tfrac":
      case "\\tbinom":
        c = "text";
        break;
    }
    return {
      type: "genfrac",
      mode: n.mode,
      continued: !1,
      numer: i,
      denom: a,
      hasBarLine: o,
      leftDelim: s,
      rightDelim: l,
      size: c,
      barSize: null
    };
  },
  htmlBuilder: PL,
  mathmlBuilder: zL
});
at({
  type: "genfrac",
  names: ["\\cfrac"],
  props: {
    numArgs: 2
  },
  handler: (t, e) => {
    var {
      parser: n,
      funcName: r
    } = t, i = e[0], a = e[1];
    return {
      type: "genfrac",
      mode: n.mode,
      continued: !0,
      numer: i,
      denom: a,
      hasBarLine: !0,
      leftDelim: null,
      rightDelim: null,
      size: "display",
      barSize: null
    };
  }
});
at({
  type: "infix",
  names: ["\\over", "\\choose", "\\atop", "\\brace", "\\brack"],
  props: {
    numArgs: 0,
    infix: !0
  },
  handler(t) {
    var {
      parser: e,
      funcName: n,
      token: r
    } = t, i;
    switch (n) {
      case "\\over":
        i = "\\frac";
        break;
      case "\\choose":
        i = "\\binom";
        break;
      case "\\atop":
        i = "\\\\atopfrac";
        break;
      case "\\brace":
        i = "\\\\bracefrac";
        break;
      case "\\brack":
        i = "\\\\brackfrac";
        break;
      default:
        throw new Error("Unrecognized infix genfrac command");
    }
    return {
      type: "infix",
      mode: e.mode,
      replaceWith: i,
      token: r
    };
  }
});
var xO = ["display", "text", "script", "scriptscript"], MO = function(e) {
  var n = null;
  return e.length > 0 && (n = e, n = n === "." ? null : n), n;
};
at({
  type: "genfrac",
  names: ["\\genfrac"],
  props: {
    numArgs: 6,
    allowedInArgument: !0,
    argTypes: ["math", "math", "size", "text", "math", "math"]
  },
  handler(t, e) {
    var {
      parser: n
    } = t, r = e[4], i = e[5], a = dg(e[0]), o = a.type === "atom" && a.family === "open" ? MO(a.text) : null, s = dg(e[1]), l = s.type === "atom" && s.family === "close" ? MO(s.text) : null, c = Ut(e[2], "size"), u, d = null;
    c.isBlank ? u = !0 : (d = c.value, u = d.number > 0);
    var f = "auto", h = e[3];
    if (h.type === "ordgroup") {
      if (h.body.length > 0) {
        var p = Ut(h.body[0], "textord");
        f = xO[Number(p.text)];
      }
    } else
      h = Ut(h, "textord"), f = xO[Number(h.text)];
    return {
      type: "genfrac",
      mode: n.mode,
      numer: r,
      denom: i,
      continued: !1,
      hasBarLine: u,
      barSize: d,
      leftDelim: o,
      rightDelim: l,
      size: f
    };
  },
  htmlBuilder: PL,
  mathmlBuilder: zL
});
at({
  type: "infix",
  names: ["\\above"],
  props: {
    numArgs: 1,
    argTypes: ["size"],
    infix: !0
  },
  handler(t, e) {
    var {
      parser: n,
      funcName: r,
      token: i
    } = t;
    return {
      type: "infix",
      mode: n.mode,
      replaceWith: "\\\\abovefrac",
      size: Ut(e[0], "size").value,
      token: i
    };
  }
});
at({
  type: "genfrac",
  names: ["\\\\abovefrac"],
  props: {
    numArgs: 3,
    argTypes: ["math", "size", "math"]
  },
  handler: (t, e) => {
    var {
      parser: n,
      funcName: r
    } = t, i = e[0], a = zVt(Ut(e[1], "infix").size), o = e[2], s = a.number > 0;
    return {
      type: "genfrac",
      mode: n.mode,
      numer: i,
      denom: o,
      continued: !1,
      hasBarLine: s,
      barSize: a,
      leftDelim: null,
      rightDelim: null,
      size: "auto"
    };
  },
  htmlBuilder: PL,
  mathmlBuilder: zL
});
var Vne = (t, e) => {
  var n = e.style, r, i;
  t.type === "supsub" ? (r = t.sup ? on(t.sup, e.havingStyle(n.sup()), e) : on(t.sub, e.havingStyle(n.sub()), e), i = Ut(t.base, "horizBrace")) : i = Ut(t, "horizBrace");
  var a = on(i.base, e.havingBaseStyle(St.DISPLAY)), o = xl.svgSpan(i, e), s;
  if (i.isOver ? (s = ke.makeVList({
    positionType: "firstBaseline",
    children: [{
      type: "elem",
      elem: a
    }, {
      type: "kern",
      size: 0.1
    }, {
      type: "elem",
      elem: o
    }]
  }, e), s.children[0].children[0].children[1].classes.push("svg-align")) : (s = ke.makeVList({
    positionType: "bottom",
    positionData: a.depth + 0.1 + o.height,
    children: [{
      type: "elem",
      elem: o
    }, {
      type: "kern",
      size: 0.1
    }, {
      type: "elem",
      elem: a
    }]
  }, e), s.children[0].children[0].children[0].classes.push("svg-align")), r) {
    var l = ke.makeSpan(["mord", i.isOver ? "mover" : "munder"], [s], e);
    i.isOver ? s = ke.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: l
      }, {
        type: "kern",
        size: 0.2
      }, {
        type: "elem",
        elem: r
      }]
    }, e) : s = ke.makeVList({
      positionType: "bottom",
      positionData: l.depth + 0.2 + r.height + r.depth,
      children: [{
        type: "elem",
        elem: r
      }, {
        type: "kern",
        size: 0.2
      }, {
        type: "elem",
        elem: l
      }]
    }, e);
  }
  return ke.makeSpan(["mord", i.isOver ? "mover" : "munder"], [s], e);
}, oUt = (t, e) => {
  var n = xl.mathMLnode(t.label);
  return new qe.MathNode(t.isOver ? "mover" : "munder", [yn(t.base, e), n]);
};
at({
  type: "horizBrace",
  names: ["\\overbrace", "\\underbrace"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var {
      parser: n,
      funcName: r
    } = t;
    return {
      type: "horizBrace",
      mode: n.mode,
      label: r,
      isOver: /^\\over/.test(r),
      base: e[0]
    };
  },
  htmlBuilder: Vne,
  mathmlBuilder: oUt
});
at({
  type: "href",
  names: ["\\href"],
  props: {
    numArgs: 2,
    argTypes: ["url", "original"],
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: n
    } = t, r = e[1], i = Ut(e[0], "url").url;
    return n.settings.isTrusted({
      command: "\\href",
      url: i
    }) ? {
      type: "href",
      mode: n.mode,
      href: i,
      body: rr(r)
    } : n.formatUnsupportedCmd("\\href");
  },
  htmlBuilder: (t, e) => {
    var n = yr(t.body, e, !1);
    return ke.makeAnchor(t.href, [], n, e);
  },
  mathmlBuilder: (t, e) => {
    var n = zc(t.body, e);
    return n instanceof Ki || (n = new Ki("mrow", [n])), n.setAttribute("href", t.href), n;
  }
});
at({
  type: "href",
  names: ["\\url"],
  props: {
    numArgs: 1,
    argTypes: ["url"],
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: n
    } = t, r = Ut(e[0], "url").url;
    if (!n.settings.isTrusted({
      command: "\\url",
      url: r
    }))
      return n.formatUnsupportedCmd("\\url");
    for (var i = [], a = 0; a < r.length; a++) {
      var o = r[a];
      o === "~" && (o = "\\textasciitilde"), i.push({
        type: "textord",
        mode: "text",
        text: o
      });
    }
    var s = {
      type: "text",
      mode: n.mode,
      font: "\\texttt",
      body: i
    };
    return {
      type: "href",
      mode: n.mode,
      href: r,
      body: rr(s)
    };
  }
});
at({
  type: "hbox",
  names: ["\\hbox"],
  props: {
    numArgs: 1,
    argTypes: ["text"],
    allowedInText: !0,
    primitive: !0
  },
  handler(t, e) {
    var {
      parser: n
    } = t;
    return {
      type: "hbox",
      mode: n.mode,
      body: rr(e[0])
    };
  },
  htmlBuilder(t, e) {
    var n = yr(t.body, e, !1);
    return ke.makeFragment(n);
  },
  mathmlBuilder(t, e) {
    return new qe.MathNode("mrow", Bi(t.body, e));
  }
});
at({
  type: "html",
  names: ["\\htmlClass", "\\htmlId", "\\htmlStyle", "\\htmlData"],
  props: {
    numArgs: 2,
    argTypes: ["raw", "original"],
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: n,
      funcName: r,
      token: i
    } = t, a = Ut(e[0], "raw").string, o = e[1];
    n.settings.strict && n.settings.reportNonstrict("htmlExtension", "HTML extension is disabled on strict mode");
    var s, l = {};
    switch (r) {
      case "\\htmlClass":
        l.class = a, s = {
          command: "\\htmlClass",
          class: a
        };
        break;
      case "\\htmlId":
        l.id = a, s = {
          command: "\\htmlId",
          id: a
        };
        break;
      case "\\htmlStyle":
        l.style = a, s = {
          command: "\\htmlStyle",
          style: a
        };
        break;
      case "\\htmlData": {
        for (var c = a.split(","), u = 0; u < c.length; u++) {
          var d = c[u].split("=");
          if (d.length !== 2)
            throw new Ge("Error parsing key-value for \\htmlData");
          l["data-" + d[0].trim()] = d[1].trim();
        }
        s = {
          command: "\\htmlData",
          attributes: l
        };
        break;
      }
      default:
        throw new Error("Unrecognized html command");
    }
    return n.settings.isTrusted(s) ? {
      type: "html",
      mode: n.mode,
      attributes: l,
      body: rr(o)
    } : n.formatUnsupportedCmd(r);
  },
  htmlBuilder: (t, e) => {
    var n = yr(t.body, e, !1), r = ["enclosing"];
    t.attributes.class && r.push(...t.attributes.class.trim().split(/\s+/));
    var i = ke.makeSpan(r, n, e);
    for (var a in t.attributes)
      a !== "class" && t.attributes.hasOwnProperty(a) && i.setAttribute(a, t.attributes[a]);
    return i;
  },
  mathmlBuilder: (t, e) => zc(t.body, e)
});
at({
  type: "htmlmathml",
  names: ["\\html@mathml"],
  props: {
    numArgs: 2,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: n
    } = t;
    return {
      type: "htmlmathml",
      mode: n.mode,
      html: rr(e[0]),
      mathml: rr(e[1])
    };
  },
  htmlBuilder: (t, e) => {
    var n = yr(t.html, e, !1);
    return ke.makeFragment(n);
  },
  mathmlBuilder: (t, e) => zc(t.mathml, e)
});
var qb = function(e) {
  if (/^[-+]? *(\d+(\.\d*)?|\.\d+)$/.test(e))
    return {
      number: +e,
      unit: "bp"
    };
  var n = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(e);
  if (!n)
    throw new Ge("Invalid size: '" + e + "' in \\includegraphics");
  var r = {
    number: +(n[1] + n[2]),
    // sign + magnitude, cast to number
    unit: n[3]
  };
  if (!sne(r))
    throw new Ge("Invalid unit: '" + r.unit + "' in \\includegraphics.");
  return r;
};
at({
  type: "includegraphics",
  names: ["\\includegraphics"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1,
    argTypes: ["raw", "url"],
    allowedInText: !1
  },
  handler: (t, e, n) => {
    var {
      parser: r
    } = t, i = {
      number: 0,
      unit: "em"
    }, a = {
      number: 0.9,
      unit: "em"
    }, o = {
      number: 0,
      unit: "em"
    }, s = "";
    if (n[0])
      for (var l = Ut(n[0], "raw").string, c = l.split(","), u = 0; u < c.length; u++) {
        var d = c[u].split("=");
        if (d.length === 2) {
          var f = d[1].trim();
          switch (d[0].trim()) {
            case "alt":
              s = f;
              break;
            case "width":
              i = qb(f);
              break;
            case "height":
              a = qb(f);
              break;
            case "totalheight":
              o = qb(f);
              break;
            default:
              throw new Ge("Invalid key: '" + d[0] + "' in \\includegraphics.");
          }
        }
      }
    var h = Ut(e[0], "url").url;
    return s === "" && (s = h, s = s.replace(/^.*[\\/]/, ""), s = s.substring(0, s.lastIndexOf("."))), r.settings.isTrusted({
      command: "\\includegraphics",
      url: h
    }) ? {
      type: "includegraphics",
      mode: r.mode,
      alt: s,
      width: i,
      height: a,
      totalheight: o,
      src: h
    } : r.formatUnsupportedCmd("\\includegraphics");
  },
  htmlBuilder: (t, e) => {
    var n = Bn(t.height, e), r = 0;
    t.totalheight.number > 0 && (r = Bn(t.totalheight, e) - n);
    var i = 0;
    t.width.number > 0 && (i = Bn(t.width, e));
    var a = {
      height: Qe(n + r)
    };
    i > 0 && (a.width = Qe(i)), r > 0 && (a.verticalAlign = Qe(-r));
    var o = new oqt(t.src, t.alt, a);
    return o.height = n, o.depth = r, o;
  },
  mathmlBuilder: (t, e) => {
    var n = new qe.MathNode("mglyph", []);
    n.setAttribute("alt", t.alt);
    var r = Bn(t.height, e), i = 0;
    if (t.totalheight.number > 0 && (i = Bn(t.totalheight, e) - r, n.setAttribute("valign", Qe(-i))), n.setAttribute("height", Qe(r + i)), t.width.number > 0) {
      var a = Bn(t.width, e);
      n.setAttribute("width", Qe(a));
    }
    return n.setAttribute("src", t.src), n;
  }
});
at({
  type: "kern",
  names: ["\\kern", "\\mkern", "\\hskip", "\\mskip"],
  props: {
    numArgs: 1,
    argTypes: ["size"],
    primitive: !0,
    allowedInText: !0
  },
  handler(t, e) {
    var {
      parser: n,
      funcName: r
    } = t, i = Ut(e[0], "size");
    if (n.settings.strict) {
      var a = r[1] === "m", o = i.value.unit === "mu";
      a ? (o || n.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + r + " supports only mu units, " + ("not " + i.value.unit + " units")), n.mode !== "math" && n.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + r + " works only in math mode")) : o && n.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + r + " doesn't support mu units");
    }
    return {
      type: "kern",
      mode: n.mode,
      dimension: i.value
    };
  },
  htmlBuilder(t, e) {
    return ke.makeGlue(t.dimension, e);
  },
  mathmlBuilder(t, e) {
    var n = Bn(t.dimension, e);
    return new qe.SpaceNode(n);
  }
});
at({
  type: "lap",
  names: ["\\mathllap", "\\mathrlap", "\\mathclap"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: n,
      funcName: r
    } = t, i = e[0];
    return {
      type: "lap",
      mode: n.mode,
      alignment: r.slice(5),
      body: i
    };
  },
  htmlBuilder: (t, e) => {
    var n;
    t.alignment === "clap" ? (n = ke.makeSpan([], [on(t.body, e)]), n = ke.makeSpan(["inner"], [n], e)) : n = ke.makeSpan(["inner"], [on(t.body, e)]);
    var r = ke.makeSpan(["fix"], []), i = ke.makeSpan([t.alignment], [n, r], e), a = ke.makeSpan(["strut"]);
    return a.style.height = Qe(i.height + i.depth), i.depth && (a.style.verticalAlign = Qe(-i.depth)), i.children.unshift(a), i = ke.makeSpan(["thinbox"], [i], e), ke.makeSpan(["mord", "vbox"], [i], e);
  },
  mathmlBuilder: (t, e) => {
    var n = new qe.MathNode("mpadded", [yn(t.body, e)]);
    if (t.alignment !== "rlap") {
      var r = t.alignment === "llap" ? "-1" : "-0.5";
      n.setAttribute("lspace", r + "width");
    }
    return n.setAttribute("width", "0px"), n;
  }
});
at({
  type: "styling",
  names: ["\\(", "$"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1
  },
  handler(t, e) {
    var {
      funcName: n,
      parser: r
    } = t, i = r.mode;
    r.switchMode("math");
    var a = n === "\\(" ? "\\)" : "$", o = r.parseExpression(!1, a);
    return r.expect(a), r.switchMode(i), {
      type: "styling",
      mode: r.mode,
      style: "text",
      body: o
    };
  }
});
at({
  type: "text",
  // Doesn't matter what this is.
  names: ["\\)", "\\]"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1
  },
  handler(t, e) {
    throw new Ge("Mismatched " + t.funcName);
  }
});
var CO = (t, e) => {
  switch (e.style.size) {
    case St.DISPLAY.size:
      return t.display;
    case St.TEXT.size:
      return t.text;
    case St.SCRIPT.size:
      return t.script;
    case St.SCRIPTSCRIPT.size:
      return t.scriptscript;
    default:
      return t.text;
  }
};
at({
  type: "mathchoice",
  names: ["\\mathchoice"],
  props: {
    numArgs: 4,
    primitive: !0
  },
  handler: (t, e) => {
    var {
      parser: n
    } = t;
    return {
      type: "mathchoice",
      mode: n.mode,
      display: rr(e[0]),
      text: rr(e[1]),
      script: rr(e[2]),
      scriptscript: rr(e[3])
    };
  },
  htmlBuilder: (t, e) => {
    var n = CO(t, e), r = yr(n, e, !1);
    return ke.makeFragment(r);
  },
  mathmlBuilder: (t, e) => {
    var n = CO(t, e);
    return zc(n, e);
  }
});
var qne = (t, e, n, r, i, a, o) => {
  t = ke.makeSpan([], [t]);
  var s = n && wt.isCharacterBox(n), l, c;
  if (e) {
    var u = on(e, r.havingStyle(i.sup()), r);
    c = {
      elem: u,
      kern: Math.max(r.fontMetrics().bigOpSpacing1, r.fontMetrics().bigOpSpacing3 - u.depth)
    };
  }
  if (n) {
    var d = on(n, r.havingStyle(i.sub()), r);
    l = {
      elem: d,
      kern: Math.max(r.fontMetrics().bigOpSpacing2, r.fontMetrics().bigOpSpacing4 - d.height)
    };
  }
  var f;
  if (c && l) {
    var h = r.fontMetrics().bigOpSpacing5 + l.elem.height + l.elem.depth + l.kern + t.depth + o;
    f = ke.makeVList({
      positionType: "bottom",
      positionData: h,
      children: [{
        type: "kern",
        size: r.fontMetrics().bigOpSpacing5
      }, {
        type: "elem",
        elem: l.elem,
        marginLeft: Qe(-a)
      }, {
        type: "kern",
        size: l.kern
      }, {
        type: "elem",
        elem: t
      }, {
        type: "kern",
        size: c.kern
      }, {
        type: "elem",
        elem: c.elem,
        marginLeft: Qe(a)
      }, {
        type: "kern",
        size: r.fontMetrics().bigOpSpacing5
      }]
    }, r);
  } else if (l) {
    var p = t.height - o;
    f = ke.makeVList({
      positionType: "top",
      positionData: p,
      children: [{
        type: "kern",
        size: r.fontMetrics().bigOpSpacing5
      }, {
        type: "elem",
        elem: l.elem,
        marginLeft: Qe(-a)
      }, {
        type: "kern",
        size: l.kern
      }, {
        type: "elem",
        elem: t
      }]
    }, r);
  } else if (c) {
    var m = t.depth + o;
    f = ke.makeVList({
      positionType: "bottom",
      positionData: m,
      children: [{
        type: "elem",
        elem: t
      }, {
        type: "kern",
        size: c.kern
      }, {
        type: "elem",
        elem: c.elem,
        marginLeft: Qe(a)
      }, {
        type: "kern",
        size: r.fontMetrics().bigOpSpacing5
      }]
    }, r);
  } else
    return t;
  var g = [f];
  if (l && a !== 0 && !s) {
    var v = ke.makeSpan(["mspace"], [], r);
    v.style.marginRight = Qe(a), g.unshift(v);
  }
  return ke.makeSpan(["mop", "op-limits"], g, r);
}, Une = ["\\smallint"], Jd = (t, e) => {
  var n, r, i = !1, a;
  t.type === "supsub" ? (n = t.sup, r = t.sub, a = Ut(t.base, "op"), i = !0) : a = Ut(t, "op");
  var o = e.style, s = !1;
  o.size === St.DISPLAY.size && a.symbol && !wt.contains(Une, a.name) && (s = !0);
  var l;
  if (a.symbol) {
    var c = s ? "Size2-Regular" : "Size1-Regular", u = "";
    if ((a.name === "\\oiint" || a.name === "\\oiiint") && (u = a.name.slice(1), a.name = u === "oiint" ? "\\iint" : "\\iiint"), l = ke.makeSymbol(a.name, c, "math", e, ["mop", "op-symbol", s ? "large-op" : "small-op"]), u.length > 0) {
      var d = l.italic, f = ke.staticSvg(u + "Size" + (s ? "2" : "1"), e);
      l = ke.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: l,
          shift: 0
        }, {
          type: "elem",
          elem: f,
          shift: s ? 0.08 : 0
        }]
      }, e), a.name = "\\" + u, l.classes.unshift("mop"), l.italic = d;
    }
  } else if (a.body) {
    var h = yr(a.body, e, !0);
    h.length === 1 && h[0] instanceof Oa ? (l = h[0], l.classes[0] = "mop") : l = ke.makeSpan(["mop"], h, e);
  } else {
    for (var p = [], m = 1; m < a.name.length; m++)
      p.push(ke.mathsym(a.name[m], a.mode, e));
    l = ke.makeSpan(["mop"], p, e);
  }
  var g = 0, v = 0;
  return (l instanceof Oa || a.name === "\\oiint" || a.name === "\\oiiint") && !a.suppressBaseShift && (g = (l.height - l.depth) / 2 - e.fontMetrics().axisHeight, v = l.italic), i ? qne(l, n, r, e, o, v, g) : (g && (l.style.position = "relative", l.style.top = Qe(g)), l);
}, lm = (t, e) => {
  var n;
  if (t.symbol)
    n = new Ki("mo", [Ba(t.name, t.mode)]), wt.contains(Une, t.name) && n.setAttribute("largeop", "false");
  else if (t.body)
    n = new Ki("mo", Bi(t.body, e));
  else {
    n = new Ki("mi", [new qo(t.name.slice(1))]);
    var r = new Ki("mo", [Ba("⁡", "text")]);
    t.parentIsSupSub ? n = new Ki("mrow", [n, r]) : n = vne([n, r]);
  }
  return n;
}, sUt = {
  "∏": "\\prod",
  "∐": "\\coprod",
  "∑": "\\sum",
  "⋀": "\\bigwedge",
  "⋁": "\\bigvee",
  "⋂": "\\bigcap",
  "⋃": "\\bigcup",
  "⨀": "\\bigodot",
  "⨁": "\\bigoplus",
  "⨂": "\\bigotimes",
  "⨄": "\\biguplus",
  "⨆": "\\bigsqcup"
};
at({
  type: "op",
  names: ["\\coprod", "\\bigvee", "\\bigwedge", "\\biguplus", "\\bigcap", "\\bigcup", "\\intop", "\\prod", "\\sum", "\\bigotimes", "\\bigoplus", "\\bigodot", "\\bigsqcup", "\\smallint", "∏", "∐", "∑", "⋀", "⋁", "⋂", "⋃", "⨀", "⨁", "⨂", "⨄", "⨆"],
  props: {
    numArgs: 0
  },
  handler: (t, e) => {
    var {
      parser: n,
      funcName: r
    } = t, i = r;
    return i.length === 1 && (i = sUt[i]), {
      type: "op",
      mode: n.mode,
      limits: !0,
      parentIsSupSub: !1,
      symbol: !0,
      name: i
    };
  },
  htmlBuilder: Jd,
  mathmlBuilder: lm
});
at({
  type: "op",
  names: ["\\mathop"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (t, e) => {
    var {
      parser: n
    } = t, r = e[0];
    return {
      type: "op",
      mode: n.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      body: rr(r)
    };
  },
  htmlBuilder: Jd,
  mathmlBuilder: lm
});
var lUt = {
  "∫": "\\int",
  "∬": "\\iint",
  "∭": "\\iiint",
  "∮": "\\oint",
  "∯": "\\oiint",
  "∰": "\\oiiint"
};
at({
  type: "op",
  names: ["\\arcsin", "\\arccos", "\\arctan", "\\arctg", "\\arcctg", "\\arg", "\\ch", "\\cos", "\\cosec", "\\cosh", "\\cot", "\\cotg", "\\coth", "\\csc", "\\ctg", "\\cth", "\\deg", "\\dim", "\\exp", "\\hom", "\\ker", "\\lg", "\\ln", "\\log", "\\sec", "\\sin", "\\sinh", "\\sh", "\\tan", "\\tanh", "\\tg", "\\th"],
  props: {
    numArgs: 0
  },
  handler(t) {
    var {
      parser: e,
      funcName: n
    } = t;
    return {
      type: "op",
      mode: e.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      name: n
    };
  },
  htmlBuilder: Jd,
  mathmlBuilder: lm
});
at({
  type: "op",
  names: ["\\det", "\\gcd", "\\inf", "\\lim", "\\max", "\\min", "\\Pr", "\\sup"],
  props: {
    numArgs: 0
  },
  handler(t) {
    var {
      parser: e,
      funcName: n
    } = t;
    return {
      type: "op",
      mode: e.mode,
      limits: !0,
      parentIsSupSub: !1,
      symbol: !1,
      name: n
    };
  },
  htmlBuilder: Jd,
  mathmlBuilder: lm
});
at({
  type: "op",
  names: ["\\int", "\\iint", "\\iiint", "\\oint", "\\oiint", "\\oiiint", "∫", "∬", "∭", "∮", "∯", "∰"],
  props: {
    numArgs: 0
  },
  handler(t) {
    var {
      parser: e,
      funcName: n
    } = t, r = n;
    return r.length === 1 && (r = lUt[r]), {
      type: "op",
      mode: e.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !0,
      name: r
    };
  },
  htmlBuilder: Jd,
  mathmlBuilder: lm
});
var Wne = (t, e) => {
  var n, r, i = !1, a;
  t.type === "supsub" ? (n = t.sup, r = t.sub, a = Ut(t.base, "operatorname"), i = !0) : a = Ut(t, "operatorname");
  var o;
  if (a.body.length > 0) {
    for (var s = a.body.map((d) => {
      var f = d.text;
      return typeof f == "string" ? {
        type: "textord",
        mode: d.mode,
        text: f
      } : d;
    }), l = yr(s, e.withFont("mathrm"), !0), c = 0; c < l.length; c++) {
      var u = l[c];
      u instanceof Oa && (u.text = u.text.replace(/\u2212/, "-").replace(/\u2217/, "*"));
    }
    o = ke.makeSpan(["mop"], l, e);
  } else
    o = ke.makeSpan(["mop"], [], e);
  return i ? qne(o, n, r, e, e.style, 0, 0) : o;
}, cUt = (t, e) => {
  for (var n = Bi(t.body, e.withFont("mathrm")), r = !0, i = 0; i < n.length; i++) {
    var a = n[i];
    if (!(a instanceof qe.SpaceNode)) if (a instanceof qe.MathNode)
      switch (a.type) {
        case "mi":
        case "mn":
        case "ms":
        case "mspace":
        case "mtext":
          break;
        case "mo": {
          var o = a.children[0];
          a.children.length === 1 && o instanceof qe.TextNode ? o.text = o.text.replace(/\u2212/, "-").replace(/\u2217/, "*") : r = !1;
          break;
        }
        default:
          r = !1;
      }
    else
      r = !1;
  }
  if (r) {
    var s = n.map((u) => u.toText()).join("");
    n = [new qe.TextNode(s)];
  }
  var l = new qe.MathNode("mi", n);
  l.setAttribute("mathvariant", "normal");
  var c = new qe.MathNode("mo", [Ba("⁡", "text")]);
  return t.parentIsSupSub ? new qe.MathNode("mrow", [l, c]) : qe.newDocumentFragment([l, c]);
};
at({
  type: "operatorname",
  names: ["\\operatorname@", "\\operatornamewithlimits"],
  props: {
    numArgs: 1
  },
  handler: (t, e) => {
    var {
      parser: n,
      funcName: r
    } = t, i = e[0];
    return {
      type: "operatorname",
      mode: n.mode,
      body: rr(i),
      alwaysHandleSupSub: r === "\\operatornamewithlimits",
      limits: !1,
      parentIsSupSub: !1
    };
  },
  htmlBuilder: Wne,
  mathmlBuilder: cUt
});
U("\\operatorname", "\\@ifstar\\operatornamewithlimits\\operatorname@");
j0({
  type: "ordgroup",
  htmlBuilder(t, e) {
    return t.semisimple ? ke.makeFragment(yr(t.body, e, !1)) : ke.makeSpan(["mord"], yr(t.body, e, !0), e);
  },
  mathmlBuilder(t, e) {
    return zc(t.body, e, !0);
  }
});
at({
  type: "overline",
  names: ["\\overline"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var {
      parser: n
    } = t, r = e[0];
    return {
      type: "overline",
      mode: n.mode,
      body: r
    };
  },
  htmlBuilder(t, e) {
    var n = on(t.body, e.havingCrampedStyle()), r = ke.makeLineSpan("overline-line", e), i = e.fontMetrics().defaultRuleThickness, a = ke.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: n
      }, {
        type: "kern",
        size: 3 * i
      }, {
        type: "elem",
        elem: r
      }, {
        type: "kern",
        size: i
      }]
    }, e);
    return ke.makeSpan(["mord", "overline"], [a], e);
  },
  mathmlBuilder(t, e) {
    var n = new qe.MathNode("mo", [new qe.TextNode("‾")]);
    n.setAttribute("stretchy", "true");
    var r = new qe.MathNode("mover", [yn(t.body, e), n]);
    return r.setAttribute("accent", "true"), r;
  }
});
at({
  type: "phantom",
  names: ["\\phantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: n
    } = t, r = e[0];
    return {
      type: "phantom",
      mode: n.mode,
      body: rr(r)
    };
  },
  htmlBuilder: (t, e) => {
    var n = yr(t.body, e.withPhantom(), !1);
    return ke.makeFragment(n);
  },
  mathmlBuilder: (t, e) => {
    var n = Bi(t.body, e);
    return new qe.MathNode("mphantom", n);
  }
});
at({
  type: "hphantom",
  names: ["\\hphantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: n
    } = t, r = e[0];
    return {
      type: "hphantom",
      mode: n.mode,
      body: r
    };
  },
  htmlBuilder: (t, e) => {
    var n = ke.makeSpan([], [on(t.body, e.withPhantom())]);
    if (n.height = 0, n.depth = 0, n.children)
      for (var r = 0; r < n.children.length; r++)
        n.children[r].height = 0, n.children[r].depth = 0;
    return n = ke.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: n
      }]
    }, e), ke.makeSpan(["mord"], [n], e);
  },
  mathmlBuilder: (t, e) => {
    var n = Bi(rr(t.body), e), r = new qe.MathNode("mphantom", n), i = new qe.MathNode("mpadded", [r]);
    return i.setAttribute("height", "0px"), i.setAttribute("depth", "0px"), i;
  }
});
at({
  type: "vphantom",
  names: ["\\vphantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: n
    } = t, r = e[0];
    return {
      type: "vphantom",
      mode: n.mode,
      body: r
    };
  },
  htmlBuilder: (t, e) => {
    var n = ke.makeSpan(["inner"], [on(t.body, e.withPhantom())]), r = ke.makeSpan(["fix"], []);
    return ke.makeSpan(["mord", "rlap"], [n, r], e);
  },
  mathmlBuilder: (t, e) => {
    var n = Bi(rr(t.body), e), r = new qe.MathNode("mphantom", n), i = new qe.MathNode("mpadded", [r]);
    return i.setAttribute("width", "0px"), i;
  }
});
at({
  type: "raisebox",
  names: ["\\raisebox"],
  props: {
    numArgs: 2,
    argTypes: ["size", "hbox"],
    allowedInText: !0
  },
  handler(t, e) {
    var {
      parser: n
    } = t, r = Ut(e[0], "size").value, i = e[1];
    return {
      type: "raisebox",
      mode: n.mode,
      dy: r,
      body: i
    };
  },
  htmlBuilder(t, e) {
    var n = on(t.body, e), r = Bn(t.dy, e);
    return ke.makeVList({
      positionType: "shift",
      positionData: -r,
      children: [{
        type: "elem",
        elem: n
      }]
    }, e);
  },
  mathmlBuilder(t, e) {
    var n = new qe.MathNode("mpadded", [yn(t.body, e)]), r = t.dy.number + t.dy.unit;
    return n.setAttribute("voffset", r), n;
  }
});
at({
  type: "internal",
  names: ["\\relax"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(t) {
    var {
      parser: e
    } = t;
    return {
      type: "internal",
      mode: e.mode
    };
  }
});
at({
  type: "rule",
  names: ["\\rule"],
  props: {
    numArgs: 2,
    numOptionalArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    argTypes: ["size", "size", "size"]
  },
  handler(t, e, n) {
    var {
      parser: r
    } = t, i = n[0], a = Ut(e[0], "size"), o = Ut(e[1], "size");
    return {
      type: "rule",
      mode: r.mode,
      shift: i && Ut(i, "size").value,
      width: a.value,
      height: o.value
    };
  },
  htmlBuilder(t, e) {
    var n = ke.makeSpan(["mord", "rule"], [], e), r = Bn(t.width, e), i = Bn(t.height, e), a = t.shift ? Bn(t.shift, e) : 0;
    return n.style.borderRightWidth = Qe(r), n.style.borderTopWidth = Qe(i), n.style.bottom = Qe(a), n.width = r, n.height = i + a, n.depth = -a, n.maxFontSize = i * 1.125 * e.sizeMultiplier, n;
  },
  mathmlBuilder(t, e) {
    var n = Bn(t.width, e), r = Bn(t.height, e), i = t.shift ? Bn(t.shift, e) : 0, a = e.color && e.getColor() || "black", o = new qe.MathNode("mspace");
    o.setAttribute("mathbackground", a), o.setAttribute("width", Qe(n)), o.setAttribute("height", Qe(r));
    var s = new qe.MathNode("mpadded", [o]);
    return i >= 0 ? s.setAttribute("height", Qe(i)) : (s.setAttribute("height", Qe(i)), s.setAttribute("depth", Qe(-i))), s.setAttribute("voffset", Qe(i)), s;
  }
});
function Zne(t, e, n) {
  for (var r = yr(t, e, !1), i = e.sizeMultiplier / n.sizeMultiplier, a = 0; a < r.length; a++) {
    var o = r[a].classes.indexOf("sizing");
    o < 0 ? Array.prototype.push.apply(r[a].classes, e.sizingClasses(n)) : r[a].classes[o + 1] === "reset-size" + e.size && (r[a].classes[o + 1] = "reset-size" + n.size), r[a].height *= i, r[a].depth *= i;
  }
  return ke.makeFragment(r);
}
var AO = ["\\tiny", "\\sixptsize", "\\scriptsize", "\\footnotesize", "\\small", "\\normalsize", "\\large", "\\Large", "\\LARGE", "\\huge", "\\Huge"], uUt = (t, e) => {
  var n = e.havingSize(t.size);
  return Zne(t.body, n, e);
};
at({
  type: "sizing",
  names: AO,
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      breakOnTokenText: n,
      funcName: r,
      parser: i
    } = t, a = i.parseExpression(!1, n);
    return {
      type: "sizing",
      mode: i.mode,
      // Figure out what size to use based on the list of functions above
      size: AO.indexOf(r) + 1,
      body: a
    };
  },
  htmlBuilder: uUt,
  mathmlBuilder: (t, e) => {
    var n = e.havingSize(t.size), r = Bi(t.body, n), i = new qe.MathNode("mstyle", r);
    return i.setAttribute("mathsize", Qe(n.sizeMultiplier)), i;
  }
});
at({
  type: "smash",
  names: ["\\smash"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1,
    allowedInText: !0
  },
  handler: (t, e, n) => {
    var {
      parser: r
    } = t, i = !1, a = !1, o = n[0] && Ut(n[0], "ordgroup");
    if (o)
      for (var s = "", l = 0; l < o.body.length; ++l) {
        var c = o.body[l];
        if (s = c.text, s === "t")
          i = !0;
        else if (s === "b")
          a = !0;
        else {
          i = !1, a = !1;
          break;
        }
      }
    else
      i = !0, a = !0;
    var u = e[0];
    return {
      type: "smash",
      mode: r.mode,
      body: u,
      smashHeight: i,
      smashDepth: a
    };
  },
  htmlBuilder: (t, e) => {
    var n = ke.makeSpan([], [on(t.body, e)]);
    if (!t.smashHeight && !t.smashDepth)
      return n;
    if (t.smashHeight && (n.height = 0, n.children))
      for (var r = 0; r < n.children.length; r++)
        n.children[r].height = 0;
    if (t.smashDepth && (n.depth = 0, n.children))
      for (var i = 0; i < n.children.length; i++)
        n.children[i].depth = 0;
    var a = ke.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: n
      }]
    }, e);
    return ke.makeSpan(["mord"], [a], e);
  },
  mathmlBuilder: (t, e) => {
    var n = new qe.MathNode("mpadded", [yn(t.body, e)]);
    return t.smashHeight && n.setAttribute("height", "0px"), t.smashDepth && n.setAttribute("depth", "0px"), n;
  }
});
at({
  type: "sqrt",
  names: ["\\sqrt"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1
  },
  handler(t, e, n) {
    var {
      parser: r
    } = t, i = n[0], a = e[0];
    return {
      type: "sqrt",
      mode: r.mode,
      body: a,
      index: i
    };
  },
  htmlBuilder(t, e) {
    var n = on(t.body, e.havingCrampedStyle());
    n.height === 0 && (n.height = e.fontMetrics().xHeight), n = ke.wrapFragment(n, e);
    var r = e.fontMetrics(), i = r.defaultRuleThickness, a = i;
    e.style.id < St.TEXT.id && (a = e.fontMetrics().xHeight);
    var o = i + a / 4, s = n.height + n.depth + o + i, {
      span: l,
      ruleWidth: c,
      advanceWidth: u
    } = rl.sqrtImage(s, e), d = l.height - c;
    d > n.height + n.depth + o && (o = (o + d - n.height - n.depth) / 2);
    var f = l.height - n.height - o - c;
    n.style.paddingLeft = Qe(u);
    var h = ke.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: n,
        wrapperClasses: ["svg-align"]
      }, {
        type: "kern",
        size: -(n.height + f)
      }, {
        type: "elem",
        elem: l
      }, {
        type: "kern",
        size: c
      }]
    }, e);
    if (t.index) {
      var p = e.havingStyle(St.SCRIPTSCRIPT), m = on(t.index, p, e), g = 0.6 * (h.height - h.depth), v = ke.makeVList({
        positionType: "shift",
        positionData: -g,
        children: [{
          type: "elem",
          elem: m
        }]
      }, e), k = ke.makeSpan(["root"], [v]);
      return ke.makeSpan(["mord", "sqrt"], [k, h], e);
    } else
      return ke.makeSpan(["mord", "sqrt"], [h], e);
  },
  mathmlBuilder(t, e) {
    var {
      body: n,
      index: r
    } = t;
    return r ? new qe.MathNode("mroot", [yn(n, e), yn(r, e)]) : new qe.MathNode("msqrt", [yn(n, e)]);
  }
});
var SO = {
  display: St.DISPLAY,
  text: St.TEXT,
  script: St.SCRIPT,
  scriptscript: St.SCRIPTSCRIPT
};
at({
  type: "styling",
  names: ["\\displaystyle", "\\textstyle", "\\scriptstyle", "\\scriptscriptstyle"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(t, e) {
    var {
      breakOnTokenText: n,
      funcName: r,
      parser: i
    } = t, a = i.parseExpression(!0, n), o = r.slice(1, r.length - 5);
    return {
      type: "styling",
      mode: i.mode,
      // Figure out what style to use by pulling out the style from
      // the function name
      style: o,
      body: a
    };
  },
  htmlBuilder(t, e) {
    var n = SO[t.style], r = e.havingStyle(n).withFont("");
    return Zne(t.body, r, e);
  },
  mathmlBuilder(t, e) {
    var n = SO[t.style], r = e.havingStyle(n), i = Bi(t.body, r), a = new qe.MathNode("mstyle", i), o = {
      display: ["0", "true"],
      text: ["0", "false"],
      script: ["1", "false"],
      scriptscript: ["2", "false"]
    }, s = o[t.style];
    return a.setAttribute("scriptlevel", s[0]), a.setAttribute("displaystyle", s[1]), a;
  }
});
var dUt = function(e, n) {
  var r = e.base;
  if (r)
    if (r.type === "op") {
      var i = r.limits && (n.style.size === St.DISPLAY.size || r.alwaysHandleSupSub);
      return i ? Jd : null;
    } else if (r.type === "operatorname") {
      var a = r.alwaysHandleSupSub && (n.style.size === St.DISPLAY.size || r.limits);
      return a ? Wne : null;
    } else {
      if (r.type === "accent")
        return wt.isCharacterBox(r.base) ? TL : null;
      if (r.type === "horizBrace") {
        var o = !e.sub;
        return o === r.isOver ? Vne : null;
      } else
        return null;
    }
  else return null;
};
j0({
  type: "supsub",
  htmlBuilder(t, e) {
    var n = dUt(t, e);
    if (n)
      return n(t, e);
    var {
      base: r,
      sup: i,
      sub: a
    } = t, o = on(r, e), s, l, c = e.fontMetrics(), u = 0, d = 0, f = r && wt.isCharacterBox(r);
    if (i) {
      var h = e.havingStyle(e.style.sup());
      s = on(i, h, e), f || (u = o.height - h.fontMetrics().supDrop * h.sizeMultiplier / e.sizeMultiplier);
    }
    if (a) {
      var p = e.havingStyle(e.style.sub());
      l = on(a, p, e), f || (d = o.depth + p.fontMetrics().subDrop * p.sizeMultiplier / e.sizeMultiplier);
    }
    var m;
    e.style === St.DISPLAY ? m = c.sup1 : e.style.cramped ? m = c.sup3 : m = c.sup2;
    var g = e.sizeMultiplier, v = Qe(0.5 / c.ptPerEm / g), k = null;
    if (l) {
      var w = t.base && t.base.type === "op" && t.base.name && (t.base.name === "\\oiint" || t.base.name === "\\oiiint");
      (o instanceof Oa || w) && (k = Qe(-o.italic));
    }
    var b;
    if (s && l) {
      u = Math.max(u, m, s.depth + 0.25 * c.xHeight), d = Math.max(d, c.sub2);
      var x = c.defaultRuleThickness, A = 4 * x;
      if (u - s.depth - (l.height - d) < A) {
        d = A - (u - s.depth) + l.height;
        var L = 0.8 * c.xHeight - (u - s.depth);
        L > 0 && (u += L, d -= L);
      }
      var M = [{
        type: "elem",
        elem: l,
        shift: d,
        marginRight: v,
        marginLeft: k
      }, {
        type: "elem",
        elem: s,
        shift: -u,
        marginRight: v
      }];
      b = ke.makeVList({
        positionType: "individualShift",
        children: M
      }, e);
    } else if (l) {
      d = Math.max(d, c.sub1, l.height - 0.8 * c.xHeight);
      var j = [{
        type: "elem",
        elem: l,
        marginLeft: k,
        marginRight: v
      }];
      b = ke.makeVList({
        positionType: "shift",
        positionData: d,
        children: j
      }, e);
    } else if (s)
      u = Math.max(u, m, s.depth + 0.25 * c.xHeight), b = ke.makeVList({
        positionType: "shift",
        positionData: -u,
        children: [{
          type: "elem",
          elem: s,
          marginRight: v
        }]
      }, e);
    else
      throw new Error("supsub must have either sup or sub.");
    var D = Rk(o, "right") || "mord";
    return ke.makeSpan([D], [o, ke.makeSpan(["msupsub"], [b])], e);
  },
  mathmlBuilder(t, e) {
    var n = !1, r, i;
    t.base && t.base.type === "horizBrace" && (i = !!t.sup, i === t.base.isOver && (n = !0, r = t.base.isOver)), t.base && (t.base.type === "op" || t.base.type === "operatorname") && (t.base.parentIsSupSub = !0);
    var a = [yn(t.base, e)];
    t.sub && a.push(yn(t.sub, e)), t.sup && a.push(yn(t.sup, e));
    var o;
    if (n)
      o = r ? "mover" : "munder";
    else if (t.sub)
      if (t.sup) {
        var c = t.base;
        c && c.type === "op" && c.limits && e.style === St.DISPLAY || c && c.type === "operatorname" && c.alwaysHandleSupSub && (e.style === St.DISPLAY || c.limits) ? o = "munderover" : o = "msubsup";
      } else {
        var l = t.base;
        l && l.type === "op" && l.limits && (e.style === St.DISPLAY || l.alwaysHandleSupSub) || l && l.type === "operatorname" && l.alwaysHandleSupSub && (l.limits || e.style === St.DISPLAY) ? o = "munder" : o = "msub";
      }
    else {
      var s = t.base;
      s && s.type === "op" && s.limits && (e.style === St.DISPLAY || s.alwaysHandleSupSub) || s && s.type === "operatorname" && s.alwaysHandleSupSub && (s.limits || e.style === St.DISPLAY) ? o = "mover" : o = "msup";
    }
    return new qe.MathNode(o, a);
  }
});
j0({
  type: "atom",
  htmlBuilder(t, e) {
    return ke.mathsym(t.text, t.mode, e, ["m" + t.family]);
  },
  mathmlBuilder(t, e) {
    var n = new qe.MathNode("mo", [Ba(t.text, t.mode)]);
    if (t.family === "bin") {
      var r = SL(t, e);
      r === "bold-italic" && n.setAttribute("mathvariant", r);
    } else t.family === "punct" ? n.setAttribute("separator", "true") : (t.family === "open" || t.family === "close") && n.setAttribute("stretchy", "false");
    return n;
  }
});
var Gne = {
  mi: "italic",
  mn: "normal",
  mtext: "normal"
};
j0({
  type: "mathord",
  htmlBuilder(t, e) {
    return ke.makeOrd(t, e, "mathord");
  },
  mathmlBuilder(t, e) {
    var n = new qe.MathNode("mi", [Ba(t.text, t.mode, e)]), r = SL(t, e) || "italic";
    return r !== Gne[n.type] && n.setAttribute("mathvariant", r), n;
  }
});
j0({
  type: "textord",
  htmlBuilder(t, e) {
    return ke.makeOrd(t, e, "textord");
  },
  mathmlBuilder(t, e) {
    var n = Ba(t.text, t.mode, e), r = SL(t, e) || "normal", i;
    return t.mode === "text" ? i = new qe.MathNode("mtext", [n]) : /[0-9]/.test(t.text) ? i = new qe.MathNode("mn", [n]) : t.text === "\\prime" ? i = new qe.MathNode("mo", [n]) : i = new qe.MathNode("mi", [n]), r !== Gne[i.type] && i.setAttribute("mathvariant", r), i;
  }
});
var Ub = {
  "\\nobreak": "nobreak",
  "\\allowbreak": "allowbreak"
}, Wb = {
  " ": {},
  "\\ ": {},
  "~": {
    className: "nobreak"
  },
  "\\space": {},
  "\\nobreakspace": {
    className: "nobreak"
  }
};
j0({
  type: "spacing",
  htmlBuilder(t, e) {
    if (Wb.hasOwnProperty(t.text)) {
      var n = Wb[t.text].className || "";
      if (t.mode === "text") {
        var r = ke.makeOrd(t, e, "textord");
        return r.classes.push(n), r;
      } else
        return ke.makeSpan(["mspace", n], [ke.mathsym(t.text, t.mode, e)], e);
    } else {
      if (Ub.hasOwnProperty(t.text))
        return ke.makeSpan(["mspace", Ub[t.text]], [], e);
      throw new Ge('Unknown type of space "' + t.text + '"');
    }
  },
  mathmlBuilder(t, e) {
    var n;
    if (Wb.hasOwnProperty(t.text))
      n = new qe.MathNode("mtext", [new qe.TextNode(" ")]);
    else {
      if (Ub.hasOwnProperty(t.text))
        return new qe.MathNode("mspace");
      throw new Ge('Unknown type of space "' + t.text + '"');
    }
    return n;
  }
});
var LO = () => {
  var t = new qe.MathNode("mtd", []);
  return t.setAttribute("width", "50%"), t;
};
j0({
  type: "tag",
  mathmlBuilder(t, e) {
    var n = new qe.MathNode("mtable", [new qe.MathNode("mtr", [LO(), new qe.MathNode("mtd", [zc(t.body, e)]), LO(), new qe.MathNode("mtd", [zc(t.tag, e)])])]);
    return n.setAttribute("width", "100%"), n;
  }
});
var TO = {
  "\\text": void 0,
  "\\textrm": "textrm",
  "\\textsf": "textsf",
  "\\texttt": "texttt",
  "\\textnormal": "textrm"
}, EO = {
  "\\textbf": "textbf",
  "\\textmd": "textmd"
}, fUt = {
  "\\textit": "textit",
  "\\textup": "textup"
}, jO = (t, e) => {
  var n = t.font;
  if (n) {
    if (TO[n])
      return e.withTextFontFamily(TO[n]);
    if (EO[n])
      return e.withTextFontWeight(EO[n]);
    if (n === "\\emph")
      return e.fontShape === "textit" ? e.withTextFontShape("textup") : e.withTextFontShape("textit");
  } else return e;
  return e.withTextFontShape(fUt[n]);
};
at({
  type: "text",
  names: [
    // Font families
    "\\text",
    "\\textrm",
    "\\textsf",
    "\\texttt",
    "\\textnormal",
    // Font weights
    "\\textbf",
    "\\textmd",
    // Font Shapes
    "\\textit",
    "\\textup",
    "\\emph"
  ],
  props: {
    numArgs: 1,
    argTypes: ["text"],
    allowedInArgument: !0,
    allowedInText: !0
  },
  handler(t, e) {
    var {
      parser: n,
      funcName: r
    } = t, i = e[0];
    return {
      type: "text",
      mode: n.mode,
      body: rr(i),
      font: r
    };
  },
  htmlBuilder(t, e) {
    var n = jO(t, e), r = yr(t.body, n, !0);
    return ke.makeSpan(["mord", "text"], r, n);
  },
  mathmlBuilder(t, e) {
    var n = jO(t, e);
    return zc(t.body, n);
  }
});
at({
  type: "underline",
  names: ["\\underline"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(t, e) {
    var {
      parser: n
    } = t;
    return {
      type: "underline",
      mode: n.mode,
      body: e[0]
    };
  },
  htmlBuilder(t, e) {
    var n = on(t.body, e), r = ke.makeLineSpan("underline-line", e), i = e.fontMetrics().defaultRuleThickness, a = ke.makeVList({
      positionType: "top",
      positionData: n.height,
      children: [{
        type: "kern",
        size: i
      }, {
        type: "elem",
        elem: r
      }, {
        type: "kern",
        size: 3 * i
      }, {
        type: "elem",
        elem: n
      }]
    }, e);
    return ke.makeSpan(["mord", "underline"], [a], e);
  },
  mathmlBuilder(t, e) {
    var n = new qe.MathNode("mo", [new qe.TextNode("‾")]);
    n.setAttribute("stretchy", "true");
    var r = new qe.MathNode("munder", [yn(t.body, e), n]);
    return r.setAttribute("accentunder", "true"), r;
  }
});
at({
  type: "vcenter",
  names: ["\\vcenter"],
  props: {
    numArgs: 1,
    argTypes: ["original"],
    // In LaTeX, \vcenter can act only on a box.
    allowedInText: !1
  },
  handler(t, e) {
    var {
      parser: n
    } = t;
    return {
      type: "vcenter",
      mode: n.mode,
      body: e[0]
    };
  },
  htmlBuilder(t, e) {
    var n = on(t.body, e), r = e.fontMetrics().axisHeight, i = 0.5 * (n.height - r - (n.depth + r));
    return ke.makeVList({
      positionType: "shift",
      positionData: i,
      children: [{
        type: "elem",
        elem: n
      }]
    }, e);
  },
  mathmlBuilder(t, e) {
    return new qe.MathNode("mpadded", [yn(t.body, e)], ["vcenter"]);
  }
});
at({
  type: "verb",
  names: ["\\verb"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(t, e, n) {
    throw new Ge("\\verb ended by end of line instead of matching delimiter");
  },
  htmlBuilder(t, e) {
    for (var n = NO(t), r = [], i = e.havingStyle(e.style.text()), a = 0; a < n.length; a++) {
      var o = n[a];
      o === "~" && (o = "\\textasciitilde"), r.push(ke.makeSymbol(o, "Typewriter-Regular", t.mode, i, ["mord", "texttt"]));
    }
    return ke.makeSpan(["mord", "text"].concat(i.sizingClasses(e)), ke.tryCombineChars(r), i);
  },
  mathmlBuilder(t, e) {
    var n = new qe.TextNode(NO(t)), r = new qe.MathNode("mtext", [n]);
    return r.setAttribute("mathvariant", "monospace"), r;
  }
});
var NO = (t) => t.body.replace(/ /g, t.star ? "␣" : " "), lc = yne, Yne = `[ \r
	]`, hUt = "\\\\[a-zA-Z@]+", pUt = "\\\\[^\uD800-\uDFFF]", mUt = "(" + hUt + ")" + Yne + "*", yUt = `\\\\(
|[ \r	]+
?)[ \r	]*`, Fk = "[̀-ͯ]", gUt = new RegExp(Fk + "+$"), vUt = "(" + Yne + "+)|" + // whitespace
(yUt + "|") + // \whitespace
"([!-\\[\\]-‧‪-퟿豈-￿]" + // single codepoint
(Fk + "*") + // ...plus accents
"|[\uD800-\uDBFF][\uDC00-\uDFFF]" + // surrogate pair
(Fk + "*") + // ...plus accents
"|\\\\verb\\*([^]).*?\\4|\\\\verb([^*a-zA-Z]).*?\\5" + // \verb unstarred
("|" + mUt) + // \macroName + spaces
("|" + pUt + ")");
let DO = class {
  // Category codes. The lexer only supports comment characters (14) for now.
  // MacroExpander additionally distinguishes active (13).
  constructor(e, n) {
    this.input = void 0, this.settings = void 0, this.tokenRegex = void 0, this.catcodes = void 0, this.input = e, this.settings = n, this.tokenRegex = new RegExp(vUt, "g"), this.catcodes = {
      "%": 14,
      // comment character
      "~": 13
      // active character
    };
  }
  setCatcode(e, n) {
    this.catcodes[e] = n;
  }
  /**
   * This function lexes a single token.
   */
  lex() {
    var e = this.input, n = this.tokenRegex.lastIndex;
    if (n === e.length)
      return new Qo("EOF", new Ui(this, n, n));
    var r = this.tokenRegex.exec(e);
    if (r === null || r.index !== n)
      throw new Ge("Unexpected character: '" + e[n] + "'", new Qo(e[n], new Ui(this, n, n + 1)));
    var i = r[6] || r[3] || (r[2] ? "\\ " : " ");
    if (this.catcodes[i] === 14) {
      var a = e.indexOf(`
`, this.tokenRegex.lastIndex);
      return a === -1 ? (this.tokenRegex.lastIndex = e.length, this.settings.reportNonstrict("commentAtEnd", "% comment has no terminating newline; LaTeX would fail because of commenting the end of math mode (e.g. $)")) : this.tokenRegex.lastIndex = a + 1, this.lex();
    }
    return new Qo(i, new Ui(this, n, this.tokenRegex.lastIndex));
  }
};
class bUt {
  /**
   * Both arguments are optional.  The first argument is an object of
   * built-in mappings which never change.  The second argument is an object
   * of initial (global-level) mappings, which will constantly change
   * according to any global/top-level `set`s done.
   */
  constructor(e, n) {
    e === void 0 && (e = {}), n === void 0 && (n = {}), this.current = void 0, this.builtins = void 0, this.undefStack = void 0, this.current = n, this.builtins = e, this.undefStack = [];
  }
  /**
   * Start a new nested group, affecting future local `set`s.
   */
  beginGroup() {
    this.undefStack.push({});
  }
  /**
   * End current nested group, restoring values before the group began.
   */
  endGroup() {
    if (this.undefStack.length === 0)
      throw new Ge("Unbalanced namespace destruction: attempt to pop global namespace; please report this as a bug");
    var e = this.undefStack.pop();
    for (var n in e)
      e.hasOwnProperty(n) && (e[n] == null ? delete this.current[n] : this.current[n] = e[n]);
  }
  /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */
  endGroups() {
    for (; this.undefStack.length > 0; )
      this.endGroup();
  }
  /**
   * Detect whether `name` has a definition.  Equivalent to
   * `get(name) != null`.
   */
  has(e) {
    return this.current.hasOwnProperty(e) || this.builtins.hasOwnProperty(e);
  }
  /**
   * Get the current value of a name, or `undefined` if there is no value.
   *
   * Note: Do not use `if (namespace.get(...))` to detect whether a macro
   * is defined, as the definition may be the empty string which evaluates
   * to `false` in JavaScript.  Use `if (namespace.get(...) != null)` or
   * `if (namespace.has(...))`.
   */
  get(e) {
    return this.current.hasOwnProperty(e) ? this.current[e] : this.builtins[e];
  }
  /**
   * Set the current value of a name, and optionally set it globally too.
   * Local set() sets the current value and (when appropriate) adds an undo
   * operation to the undo stack.  Global set() may change the undo
   * operation at every level, so takes time linear in their number.
   * A value of undefined means to delete existing definitions.
   */
  set(e, n, r) {
    if (r === void 0 && (r = !1), r) {
      for (var i = 0; i < this.undefStack.length; i++)
        delete this.undefStack[i][e];
      this.undefStack.length > 0 && (this.undefStack[this.undefStack.length - 1][e] = n);
    } else {
      var a = this.undefStack[this.undefStack.length - 1];
      a && !a.hasOwnProperty(e) && (a[e] = this.current[e]);
    }
    n == null ? delete this.current[e] : this.current[e] = n;
  }
}
var wUt = One;
U("\\noexpand", function(t) {
  var e = t.popToken();
  return t.isExpandable(e.text) && (e.noexpand = !0, e.treatAsRelax = !0), {
    tokens: [e],
    numArgs: 0
  };
});
U("\\expandafter", function(t) {
  var e = t.popToken();
  return t.expandOnce(!0), {
    tokens: [e],
    numArgs: 0
  };
});
U("\\@firstoftwo", function(t) {
  var e = t.consumeArgs(2);
  return {
    tokens: e[0],
    numArgs: 0
  };
});
U("\\@secondoftwo", function(t) {
  var e = t.consumeArgs(2);
  return {
    tokens: e[1],
    numArgs: 0
  };
});
U("\\@ifnextchar", function(t) {
  var e = t.consumeArgs(3);
  t.consumeSpaces();
  var n = t.future();
  return e[0].length === 1 && e[0][0].text === n.text ? {
    tokens: e[1],
    numArgs: 0
  } : {
    tokens: e[2],
    numArgs: 0
  };
});
U("\\@ifstar", "\\@ifnextchar *{\\@firstoftwo{#1}}");
U("\\TextOrMath", function(t) {
  var e = t.consumeArgs(2);
  return t.mode === "text" ? {
    tokens: e[0],
    numArgs: 0
  } : {
    tokens: e[1],
    numArgs: 0
  };
});
var IO = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  a: 10,
  A: 10,
  b: 11,
  B: 11,
  c: 12,
  C: 12,
  d: 13,
  D: 13,
  e: 14,
  E: 14,
  f: 15,
  F: 15
};
U("\\char", function(t) {
  var e = t.popToken(), n, r = "";
  if (e.text === "'")
    n = 8, e = t.popToken();
  else if (e.text === '"')
    n = 16, e = t.popToken();
  else if (e.text === "`")
    if (e = t.popToken(), e.text[0] === "\\")
      r = e.text.charCodeAt(1);
    else {
      if (e.text === "EOF")
        throw new Ge("\\char` missing argument");
      r = e.text.charCodeAt(0);
    }
  else
    n = 10;
  if (n) {
    if (r = IO[e.text], r == null || r >= n)
      throw new Ge("Invalid base-" + n + " digit " + e.text);
    for (var i; (i = IO[t.future().text]) != null && i < n; )
      r *= n, r += i, t.popToken();
  }
  return "\\@char{" + r + "}";
});
var RL = (t, e, n, r) => {
  var i = t.consumeArg().tokens;
  if (i.length !== 1)
    throw new Ge("\\newcommand's first argument must be a macro name");
  var a = i[0].text, o = t.isDefined(a);
  if (o && !e)
    throw new Ge("\\newcommand{" + a + "} attempting to redefine " + (a + "; use \\renewcommand"));
  if (!o && !n)
    throw new Ge("\\renewcommand{" + a + "} when command " + a + " does not yet exist; use \\newcommand");
  var s = 0;
  if (i = t.consumeArg().tokens, i.length === 1 && i[0].text === "[") {
    for (var l = "", c = t.expandNextToken(); c.text !== "]" && c.text !== "EOF"; )
      l += c.text, c = t.expandNextToken();
    if (!l.match(/^\s*[0-9]+\s*$/))
      throw new Ge("Invalid number of arguments: " + l);
    s = parseInt(l), i = t.consumeArg().tokens;
  }
  return o && r || t.macros.set(a, {
    tokens: i,
    numArgs: s
  }), "";
};
U("\\newcommand", (t) => RL(t, !1, !0, !1));
U("\\renewcommand", (t) => RL(t, !0, !1, !1));
U("\\providecommand", (t) => RL(t, !0, !0, !0));
U("\\message", (t) => {
  var e = t.consumeArgs(1)[0];
  return console.log(e.reverse().map((n) => n.text).join("")), "";
});
U("\\errmessage", (t) => {
  var e = t.consumeArgs(1)[0];
  return console.error(e.reverse().map((n) => n.text).join("")), "";
});
U("\\show", (t) => {
  var e = t.popToken(), n = e.text;
  return console.log(e, t.macros.get(n), lc[n], kn.math[n], kn.text[n]), "";
});
U("\\bgroup", "{");
U("\\egroup", "}");
U("~", "\\nobreakspace");
U("\\lq", "`");
U("\\rq", "'");
U("\\aa", "\\r a");
U("\\AA", "\\r A");
U("\\textcopyright", "\\html@mathml{\\textcircled{c}}{\\char`©}");
U("\\copyright", "\\TextOrMath{\\textcopyright}{\\text{\\textcopyright}}");
U("\\textregistered", "\\html@mathml{\\textcircled{\\scriptsize R}}{\\char`®}");
U("ℬ", "\\mathscr{B}");
U("ℰ", "\\mathscr{E}");
U("ℱ", "\\mathscr{F}");
U("ℋ", "\\mathscr{H}");
U("ℐ", "\\mathscr{I}");
U("ℒ", "\\mathscr{L}");
U("ℳ", "\\mathscr{M}");
U("ℛ", "\\mathscr{R}");
U("ℭ", "\\mathfrak{C}");
U("ℌ", "\\mathfrak{H}");
U("ℨ", "\\mathfrak{Z}");
U("\\Bbbk", "\\Bbb{k}");
U("·", "\\cdotp");
U("\\llap", "\\mathllap{\\textrm{#1}}");
U("\\rlap", "\\mathrlap{\\textrm{#1}}");
U("\\clap", "\\mathclap{\\textrm{#1}}");
U("\\mathstrut", "\\vphantom{(}");
U("\\underbar", "\\underline{\\text{#1}}");
U("\\not", '\\html@mathml{\\mathrel{\\mathrlap\\@not}}{\\char"338}');
U("\\neq", "\\html@mathml{\\mathrel{\\not=}}{\\mathrel{\\char`≠}}");
U("\\ne", "\\neq");
U("≠", "\\neq");
U("\\notin", "\\html@mathml{\\mathrel{{\\in}\\mathllap{/\\mskip1mu}}}{\\mathrel{\\char`∉}}");
U("∉", "\\notin");
U("≘", "\\html@mathml{\\mathrel{=\\kern{-1em}\\raisebox{0.4em}{$\\scriptsize\\frown$}}}{\\mathrel{\\char`≘}}");
U("≙", "\\html@mathml{\\stackrel{\\tiny\\wedge}{=}}{\\mathrel{\\char`≘}}");
U("≚", "\\html@mathml{\\stackrel{\\tiny\\vee}{=}}{\\mathrel{\\char`≚}}");
U("≛", "\\html@mathml{\\stackrel{\\scriptsize\\star}{=}}{\\mathrel{\\char`≛}}");
U("≝", "\\html@mathml{\\stackrel{\\tiny\\mathrm{def}}{=}}{\\mathrel{\\char`≝}}");
U("≞", "\\html@mathml{\\stackrel{\\tiny\\mathrm{m}}{=}}{\\mathrel{\\char`≞}}");
U("≟", "\\html@mathml{\\stackrel{\\tiny?}{=}}{\\mathrel{\\char`≟}}");
U("⟂", "\\perp");
U("‼", "\\mathclose{!\\mkern-0.8mu!}");
U("∌", "\\notni");
U("⌜", "\\ulcorner");
U("⌝", "\\urcorner");
U("⌞", "\\llcorner");
U("⌟", "\\lrcorner");
U("©", "\\copyright");
U("®", "\\textregistered");
U("️", "\\textregistered");
U("\\ulcorner", '\\html@mathml{\\@ulcorner}{\\mathop{\\char"231c}}');
U("\\urcorner", '\\html@mathml{\\@urcorner}{\\mathop{\\char"231d}}');
U("\\llcorner", '\\html@mathml{\\@llcorner}{\\mathop{\\char"231e}}');
U("\\lrcorner", '\\html@mathml{\\@lrcorner}{\\mathop{\\char"231f}}');
U("\\vdots", "{\\varvdots\\rule{0pt}{15pt}}");
U("⋮", "\\vdots");
U("\\varGamma", "\\mathit{\\Gamma}");
U("\\varDelta", "\\mathit{\\Delta}");
U("\\varTheta", "\\mathit{\\Theta}");
U("\\varLambda", "\\mathit{\\Lambda}");
U("\\varXi", "\\mathit{\\Xi}");
U("\\varPi", "\\mathit{\\Pi}");
U("\\varSigma", "\\mathit{\\Sigma}");
U("\\varUpsilon", "\\mathit{\\Upsilon}");
U("\\varPhi", "\\mathit{\\Phi}");
U("\\varPsi", "\\mathit{\\Psi}");
U("\\varOmega", "\\mathit{\\Omega}");
U("\\substack", "\\begin{subarray}{c}#1\\end{subarray}");
U("\\colon", "\\nobreak\\mskip2mu\\mathpunct{}\\mathchoice{\\mkern-3mu}{\\mkern-3mu}{}{}{:}\\mskip6mu\\relax");
U("\\boxed", "\\fbox{$\\displaystyle{#1}$}");
U("\\iff", "\\DOTSB\\;\\Longleftrightarrow\\;");
U("\\implies", "\\DOTSB\\;\\Longrightarrow\\;");
U("\\impliedby", "\\DOTSB\\;\\Longleftarrow\\;");
U("\\dddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ...}}{#1}}");
U("\\ddddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ....}}{#1}}");
var PO = {
  ",": "\\dotsc",
  "\\not": "\\dotsb",
  // \keybin@ checks for the following:
  "+": "\\dotsb",
  "=": "\\dotsb",
  "<": "\\dotsb",
  ">": "\\dotsb",
  "-": "\\dotsb",
  "*": "\\dotsb",
  ":": "\\dotsb",
  // Symbols whose definition starts with \DOTSB:
  "\\DOTSB": "\\dotsb",
  "\\coprod": "\\dotsb",
  "\\bigvee": "\\dotsb",
  "\\bigwedge": "\\dotsb",
  "\\biguplus": "\\dotsb",
  "\\bigcap": "\\dotsb",
  "\\bigcup": "\\dotsb",
  "\\prod": "\\dotsb",
  "\\sum": "\\dotsb",
  "\\bigotimes": "\\dotsb",
  "\\bigoplus": "\\dotsb",
  "\\bigodot": "\\dotsb",
  "\\bigsqcup": "\\dotsb",
  "\\And": "\\dotsb",
  "\\longrightarrow": "\\dotsb",
  "\\Longrightarrow": "\\dotsb",
  "\\longleftarrow": "\\dotsb",
  "\\Longleftarrow": "\\dotsb",
  "\\longleftrightarrow": "\\dotsb",
  "\\Longleftrightarrow": "\\dotsb",
  "\\mapsto": "\\dotsb",
  "\\longmapsto": "\\dotsb",
  "\\hookrightarrow": "\\dotsb",
  "\\doteq": "\\dotsb",
  // Symbols whose definition starts with \mathbin:
  "\\mathbin": "\\dotsb",
  // Symbols whose definition starts with \mathrel:
  "\\mathrel": "\\dotsb",
  "\\relbar": "\\dotsb",
  "\\Relbar": "\\dotsb",
  "\\xrightarrow": "\\dotsb",
  "\\xleftarrow": "\\dotsb",
  // Symbols whose definition starts with \DOTSI:
  "\\DOTSI": "\\dotsi",
  "\\int": "\\dotsi",
  "\\oint": "\\dotsi",
  "\\iint": "\\dotsi",
  "\\iiint": "\\dotsi",
  "\\iiiint": "\\dotsi",
  "\\idotsint": "\\dotsi",
  // Symbols whose definition starts with \DOTSX:
  "\\DOTSX": "\\dotsx"
};
U("\\dots", function(t) {
  var e = "\\dotso", n = t.expandAfterFuture().text;
  return n in PO ? e = PO[n] : (n.slice(0, 4) === "\\not" || n in kn.math && wt.contains(["bin", "rel"], kn.math[n].group)) && (e = "\\dotsb"), e;
});
var OL = {
  // \rightdelim@ checks for the following:
  ")": !0,
  "]": !0,
  "\\rbrack": !0,
  "\\}": !0,
  "\\rbrace": !0,
  "\\rangle": !0,
  "\\rceil": !0,
  "\\rfloor": !0,
  "\\rgroup": !0,
  "\\rmoustache": !0,
  "\\right": !0,
  "\\bigr": !0,
  "\\biggr": !0,
  "\\Bigr": !0,
  "\\Biggr": !0,
  // \extra@ also tests for the following:
  $: !0,
  // \extrap@ checks for the following:
  ";": !0,
  ".": !0,
  ",": !0
};
U("\\dotso", function(t) {
  var e = t.future().text;
  return e in OL ? "\\ldots\\," : "\\ldots";
});
U("\\dotsc", function(t) {
  var e = t.future().text;
  return e in OL && e !== "," ? "\\ldots\\," : "\\ldots";
});
U("\\cdots", function(t) {
  var e = t.future().text;
  return e in OL ? "\\@cdots\\," : "\\@cdots";
});
U("\\dotsb", "\\cdots");
U("\\dotsm", "\\cdots");
U("\\dotsi", "\\!\\cdots");
U("\\dotsx", "\\ldots\\,");
U("\\DOTSI", "\\relax");
U("\\DOTSB", "\\relax");
U("\\DOTSX", "\\relax");
U("\\tmspace", "\\TextOrMath{\\kern#1#3}{\\mskip#1#2}\\relax");
U("\\,", "\\tmspace+{3mu}{.1667em}");
U("\\thinspace", "\\,");
U("\\>", "\\mskip{4mu}");
U("\\:", "\\tmspace+{4mu}{.2222em}");
U("\\medspace", "\\:");
U("\\;", "\\tmspace+{5mu}{.2777em}");
U("\\thickspace", "\\;");
U("\\!", "\\tmspace-{3mu}{.1667em}");
U("\\negthinspace", "\\!");
U("\\negmedspace", "\\tmspace-{4mu}{.2222em}");
U("\\negthickspace", "\\tmspace-{5mu}{.277em}");
U("\\enspace", "\\kern.5em ");
U("\\enskip", "\\hskip.5em\\relax");
U("\\quad", "\\hskip1em\\relax");
U("\\qquad", "\\hskip2em\\relax");
U("\\tag", "\\@ifstar\\tag@literal\\tag@paren");
U("\\tag@paren", "\\tag@literal{({#1})}");
U("\\tag@literal", (t) => {
  if (t.macros.get("\\df@tag"))
    throw new Ge("Multiple \\tag");
  return "\\gdef\\df@tag{\\text{#1}}";
});
U("\\bmod", "\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}\\mathbin{\\rm mod}\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}");
U("\\pod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern8mu}{\\mkern8mu}{\\mkern8mu}(#1)");
U("\\pmod", "\\pod{{\\rm mod}\\mkern6mu#1}");
U("\\mod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern12mu}{\\mkern12mu}{\\mkern12mu}{\\rm mod}\\,\\,#1");
U("\\newline", "\\\\\\relax");
U("\\TeX", "\\textrm{\\html@mathml{T\\kern-.1667em\\raisebox{-.5ex}{E}\\kern-.125emX}{TeX}}");
var Kne = Qe(Vo["Main-Regular"][84][1] - 0.7 * Vo["Main-Regular"][65][1]);
U("\\LaTeX", "\\textrm{\\html@mathml{" + ("L\\kern-.36em\\raisebox{" + Kne + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{LaTeX}}");
U("\\KaTeX", "\\textrm{\\html@mathml{" + ("K\\kern-.17em\\raisebox{" + Kne + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{KaTeX}}");
U("\\hspace", "\\@ifstar\\@hspacer\\@hspace");
U("\\@hspace", "\\hskip #1\\relax");
U("\\@hspacer", "\\rule{0pt}{0pt}\\hskip #1\\relax");
U("\\ordinarycolon", ":");
U("\\vcentcolon", "\\mathrel{\\mathop\\ordinarycolon}");
U("\\dblcolon", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-.9mu}\\vcentcolon}}{\\mathop{\\char"2237}}');
U("\\coloneqq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2254}}');
U("\\Coloneqq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2237\\char"3d}}');
U("\\coloneq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"3a\\char"2212}}');
U("\\Coloneq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"2237\\char"2212}}');
U("\\eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2255}}');
U("\\Eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"3d\\char"2237}}');
U("\\eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2239}}');
U("\\Eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"2212\\char"2237}}');
U("\\colonapprox", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"3a\\char"2248}}');
U("\\Colonapprox", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"2237\\char"2248}}');
U("\\colonsim", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"3a\\char"223c}}');
U("\\Colonsim", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"2237\\char"223c}}');
U("∷", "\\dblcolon");
U("∹", "\\eqcolon");
U("≔", "\\coloneqq");
U("≕", "\\eqqcolon");
U("⩴", "\\Coloneqq");
U("\\ratio", "\\vcentcolon");
U("\\coloncolon", "\\dblcolon");
U("\\colonequals", "\\coloneqq");
U("\\coloncolonequals", "\\Coloneqq");
U("\\equalscolon", "\\eqqcolon");
U("\\equalscoloncolon", "\\Eqqcolon");
U("\\colonminus", "\\coloneq");
U("\\coloncolonminus", "\\Coloneq");
U("\\minuscolon", "\\eqcolon");
U("\\minuscoloncolon", "\\Eqcolon");
U("\\coloncolonapprox", "\\Colonapprox");
U("\\coloncolonsim", "\\Colonsim");
U("\\simcolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
U("\\simcoloncolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\dblcolon}");
U("\\approxcolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
U("\\approxcoloncolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\dblcolon}");
U("\\notni", "\\html@mathml{\\not\\ni}{\\mathrel{\\char`∌}}");
U("\\limsup", "\\DOTSB\\operatorname*{lim\\,sup}");
U("\\liminf", "\\DOTSB\\operatorname*{lim\\,inf}");
U("\\injlim", "\\DOTSB\\operatorname*{inj\\,lim}");
U("\\projlim", "\\DOTSB\\operatorname*{proj\\,lim}");
U("\\varlimsup", "\\DOTSB\\operatorname*{\\overline{lim}}");
U("\\varliminf", "\\DOTSB\\operatorname*{\\underline{lim}}");
U("\\varinjlim", "\\DOTSB\\operatorname*{\\underrightarrow{lim}}");
U("\\varprojlim", "\\DOTSB\\operatorname*{\\underleftarrow{lim}}");
U("\\gvertneqq", "\\html@mathml{\\@gvertneqq}{≩}");
U("\\lvertneqq", "\\html@mathml{\\@lvertneqq}{≨}");
U("\\ngeqq", "\\html@mathml{\\@ngeqq}{≱}");
U("\\ngeqslant", "\\html@mathml{\\@ngeqslant}{≱}");
U("\\nleqq", "\\html@mathml{\\@nleqq}{≰}");
U("\\nleqslant", "\\html@mathml{\\@nleqslant}{≰}");
U("\\nshortmid", "\\html@mathml{\\@nshortmid}{∤}");
U("\\nshortparallel", "\\html@mathml{\\@nshortparallel}{∦}");
U("\\nsubseteqq", "\\html@mathml{\\@nsubseteqq}{⊈}");
U("\\nsupseteqq", "\\html@mathml{\\@nsupseteqq}{⊉}");
U("\\varsubsetneq", "\\html@mathml{\\@varsubsetneq}{⊊}");
U("\\varsubsetneqq", "\\html@mathml{\\@varsubsetneqq}{⫋}");
U("\\varsupsetneq", "\\html@mathml{\\@varsupsetneq}{⊋}");
U("\\varsupsetneqq", "\\html@mathml{\\@varsupsetneqq}{⫌}");
U("\\imath", "\\html@mathml{\\@imath}{ı}");
U("\\jmath", "\\html@mathml{\\@jmath}{ȷ}");
U("\\llbracket", "\\html@mathml{\\mathopen{[\\mkern-3.2mu[}}{\\mathopen{\\char`⟦}}");
U("\\rrbracket", "\\html@mathml{\\mathclose{]\\mkern-3.2mu]}}{\\mathclose{\\char`⟧}}");
U("⟦", "\\llbracket");
U("⟧", "\\rrbracket");
U("\\lBrace", "\\html@mathml{\\mathopen{\\{\\mkern-3.2mu[}}{\\mathopen{\\char`⦃}}");
U("\\rBrace", "\\html@mathml{\\mathclose{]\\mkern-3.2mu\\}}}{\\mathclose{\\char`⦄}}");
U("⦃", "\\lBrace");
U("⦄", "\\rBrace");
U("\\minuso", "\\mathbin{\\html@mathml{{\\mathrlap{\\mathchoice{\\kern{0.145em}}{\\kern{0.145em}}{\\kern{0.1015em}}{\\kern{0.0725em}}\\circ}{-}}}{\\char`⦵}}");
U("⦵", "\\minuso");
U("\\darr", "\\downarrow");
U("\\dArr", "\\Downarrow");
U("\\Darr", "\\Downarrow");
U("\\lang", "\\langle");
U("\\rang", "\\rangle");
U("\\uarr", "\\uparrow");
U("\\uArr", "\\Uparrow");
U("\\Uarr", "\\Uparrow");
U("\\N", "\\mathbb{N}");
U("\\R", "\\mathbb{R}");
U("\\Z", "\\mathbb{Z}");
U("\\alef", "\\aleph");
U("\\alefsym", "\\aleph");
U("\\Alpha", "\\mathrm{A}");
U("\\Beta", "\\mathrm{B}");
U("\\bull", "\\bullet");
U("\\Chi", "\\mathrm{X}");
U("\\clubs", "\\clubsuit");
U("\\cnums", "\\mathbb{C}");
U("\\Complex", "\\mathbb{C}");
U("\\Dagger", "\\ddagger");
U("\\diamonds", "\\diamondsuit");
U("\\empty", "\\emptyset");
U("\\Epsilon", "\\mathrm{E}");
U("\\Eta", "\\mathrm{H}");
U("\\exist", "\\exists");
U("\\harr", "\\leftrightarrow");
U("\\hArr", "\\Leftrightarrow");
U("\\Harr", "\\Leftrightarrow");
U("\\hearts", "\\heartsuit");
U("\\image", "\\Im");
U("\\infin", "\\infty");
U("\\Iota", "\\mathrm{I}");
U("\\isin", "\\in");
U("\\Kappa", "\\mathrm{K}");
U("\\larr", "\\leftarrow");
U("\\lArr", "\\Leftarrow");
U("\\Larr", "\\Leftarrow");
U("\\lrarr", "\\leftrightarrow");
U("\\lrArr", "\\Leftrightarrow");
U("\\Lrarr", "\\Leftrightarrow");
U("\\Mu", "\\mathrm{M}");
U("\\natnums", "\\mathbb{N}");
U("\\Nu", "\\mathrm{N}");
U("\\Omicron", "\\mathrm{O}");
U("\\plusmn", "\\pm");
U("\\rarr", "\\rightarrow");
U("\\rArr", "\\Rightarrow");
U("\\Rarr", "\\Rightarrow");
U("\\real", "\\Re");
U("\\reals", "\\mathbb{R}");
U("\\Reals", "\\mathbb{R}");
U("\\Rho", "\\mathrm{P}");
U("\\sdot", "\\cdot");
U("\\sect", "\\S");
U("\\spades", "\\spadesuit");
U("\\sub", "\\subset");
U("\\sube", "\\subseteq");
U("\\supe", "\\supseteq");
U("\\Tau", "\\mathrm{T}");
U("\\thetasym", "\\vartheta");
U("\\weierp", "\\wp");
U("\\Zeta", "\\mathrm{Z}");
U("\\argmin", "\\DOTSB\\operatorname*{arg\\,min}");
U("\\argmax", "\\DOTSB\\operatorname*{arg\\,max}");
U("\\plim", "\\DOTSB\\mathop{\\operatorname{plim}}\\limits");
U("\\bra", "\\mathinner{\\langle{#1}|}");
U("\\ket", "\\mathinner{|{#1}\\rangle}");
U("\\braket", "\\mathinner{\\langle{#1}\\rangle}");
U("\\Bra", "\\left\\langle#1\\right|");
U("\\Ket", "\\left|#1\\right\\rangle");
var $ne = (t) => (e) => {
  var n = e.consumeArg().tokens, r = e.consumeArg().tokens, i = e.consumeArg().tokens, a = e.consumeArg().tokens, o = e.macros.get("|"), s = e.macros.get("\\|");
  e.macros.beginGroup();
  var l = (d) => (f) => {
    t && (f.macros.set("|", o), i.length && f.macros.set("\\|", s));
    var h = d;
    if (!d && i.length) {
      var p = f.future();
      p.text === "|" && (f.popToken(), h = !0);
    }
    return {
      tokens: h ? i : r,
      numArgs: 0
    };
  };
  e.macros.set("|", l(!1)), i.length && e.macros.set("\\|", l(!0));
  var c = e.consumeArg().tokens, u = e.expandTokens([
    ...a,
    ...c,
    ...n
    // reversed
  ]);
  return e.macros.endGroup(), {
    tokens: u.reverse(),
    numArgs: 0
  };
};
U("\\bra@ket", $ne(!1));
U("\\bra@set", $ne(!0));
U("\\Braket", "\\bra@ket{\\left\\langle}{\\,\\middle\\vert\\,}{\\,\\middle\\vert\\,}{\\right\\rangle}");
U("\\Set", "\\bra@set{\\left\\{\\:}{\\;\\middle\\vert\\;}{\\;\\middle\\Vert\\;}{\\:\\right\\}}");
U("\\set", "\\bra@set{\\{\\,}{\\mid}{}{\\,\\}}");
U("\\angln", "{\\angl n}");
U("\\blue", "\\textcolor{##6495ed}{#1}");
U("\\orange", "\\textcolor{##ffa500}{#1}");
U("\\pink", "\\textcolor{##ff00af}{#1}");
U("\\red", "\\textcolor{##df0030}{#1}");
U("\\green", "\\textcolor{##28ae7b}{#1}");
U("\\gray", "\\textcolor{gray}{#1}");
U("\\purple", "\\textcolor{##9d38bd}{#1}");
U("\\blueA", "\\textcolor{##ccfaff}{#1}");
U("\\blueB", "\\textcolor{##80f6ff}{#1}");
U("\\blueC", "\\textcolor{##63d9ea}{#1}");
U("\\blueD", "\\textcolor{##11accd}{#1}");
U("\\blueE", "\\textcolor{##0c7f99}{#1}");
U("\\tealA", "\\textcolor{##94fff5}{#1}");
U("\\tealB", "\\textcolor{##26edd5}{#1}");
U("\\tealC", "\\textcolor{##01d1c1}{#1}");
U("\\tealD", "\\textcolor{##01a995}{#1}");
U("\\tealE", "\\textcolor{##208170}{#1}");
U("\\greenA", "\\textcolor{##b6ffb0}{#1}");
U("\\greenB", "\\textcolor{##8af281}{#1}");
U("\\greenC", "\\textcolor{##74cf70}{#1}");
U("\\greenD", "\\textcolor{##1fab54}{#1}");
U("\\greenE", "\\textcolor{##0d923f}{#1}");
U("\\goldA", "\\textcolor{##ffd0a9}{#1}");
U("\\goldB", "\\textcolor{##ffbb71}{#1}");
U("\\goldC", "\\textcolor{##ff9c39}{#1}");
U("\\goldD", "\\textcolor{##e07d10}{#1}");
U("\\goldE", "\\textcolor{##a75a05}{#1}");
U("\\redA", "\\textcolor{##fca9a9}{#1}");
U("\\redB", "\\textcolor{##ff8482}{#1}");
U("\\redC", "\\textcolor{##f9685d}{#1}");
U("\\redD", "\\textcolor{##e84d39}{#1}");
U("\\redE", "\\textcolor{##bc2612}{#1}");
U("\\maroonA", "\\textcolor{##ffbde0}{#1}");
U("\\maroonB", "\\textcolor{##ff92c6}{#1}");
U("\\maroonC", "\\textcolor{##ed5fa6}{#1}");
U("\\maroonD", "\\textcolor{##ca337c}{#1}");
U("\\maroonE", "\\textcolor{##9e034e}{#1}");
U("\\purpleA", "\\textcolor{##ddd7ff}{#1}");
U("\\purpleB", "\\textcolor{##c6b9fc}{#1}");
U("\\purpleC", "\\textcolor{##aa87ff}{#1}");
U("\\purpleD", "\\textcolor{##7854ab}{#1}");
U("\\purpleE", "\\textcolor{##543b78}{#1}");
U("\\mintA", "\\textcolor{##f5f9e8}{#1}");
U("\\mintB", "\\textcolor{##edf2df}{#1}");
U("\\mintC", "\\textcolor{##e0e5cc}{#1}");
U("\\grayA", "\\textcolor{##f6f7f7}{#1}");
U("\\grayB", "\\textcolor{##f0f1f2}{#1}");
U("\\grayC", "\\textcolor{##e3e5e6}{#1}");
U("\\grayD", "\\textcolor{##d6d8da}{#1}");
U("\\grayE", "\\textcolor{##babec2}{#1}");
U("\\grayF", "\\textcolor{##888d93}{#1}");
U("\\grayG", "\\textcolor{##626569}{#1}");
U("\\grayH", "\\textcolor{##3b3e40}{#1}");
U("\\grayI", "\\textcolor{##21242c}{#1}");
U("\\kaBlue", "\\textcolor{##314453}{#1}");
U("\\kaGreen", "\\textcolor{##71B307}{#1}");
var Jne = {
  "^": !0,
  // Parser.js
  _: !0,
  // Parser.js
  "\\limits": !0,
  // Parser.js
  "\\nolimits": !0
  // Parser.js
};
class kUt {
  constructor(e, n, r) {
    this.settings = void 0, this.expansionCount = void 0, this.lexer = void 0, this.macros = void 0, this.stack = void 0, this.mode = void 0, this.settings = n, this.expansionCount = 0, this.feed(e), this.macros = new bUt(wUt, n.macros), this.mode = r, this.stack = [];
  }
  /**
   * Feed a new input string to the same MacroExpander
   * (with existing macros etc.).
   */
  feed(e) {
    this.lexer = new DO(e, this.settings);
  }
  /**
   * Switches between "text" and "math" modes.
   */
  switchMode(e) {
    this.mode = e;
  }
  /**
   * Start a new group nesting within all namespaces.
   */
  beginGroup() {
    this.macros.beginGroup();
  }
  /**
   * End current group nesting within all namespaces.
   */
  endGroup() {
    this.macros.endGroup();
  }
  /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */
  endGroups() {
    this.macros.endGroups();
  }
  /**
   * Returns the topmost token on the stack, without expanding it.
   * Similar in behavior to TeX's `\futurelet`.
   */
  future() {
    return this.stack.length === 0 && this.pushToken(this.lexer.lex()), this.stack[this.stack.length - 1];
  }
  /**
   * Remove and return the next unexpanded token.
   */
  popToken() {
    return this.future(), this.stack.pop();
  }
  /**
   * Add a given token to the token stack.  In particular, this get be used
   * to put back a token returned from one of the other methods.
   */
  pushToken(e) {
    this.stack.push(e);
  }
  /**
   * Append an array of tokens to the token stack.
   */
  pushTokens(e) {
    this.stack.push(...e);
  }
  /**
   * Find an macro argument without expanding tokens and append the array of
   * tokens to the token stack. Uses Token as a container for the result.
   */
  scanArgument(e) {
    var n, r, i;
    if (e) {
      if (this.consumeSpaces(), this.future().text !== "[")
        return null;
      n = this.popToken(), {
        tokens: i,
        end: r
      } = this.consumeArg(["]"]);
    } else
      ({
        tokens: i,
        start: n,
        end: r
      } = this.consumeArg());
    return this.pushToken(new Qo("EOF", r.loc)), this.pushTokens(i), n.range(r, "");
  }
  /**
   * Consume all following space tokens, without expansion.
   */
  consumeSpaces() {
    for (; ; ) {
      var e = this.future();
      if (e.text === " ")
        this.stack.pop();
      else
        break;
    }
  }
  /**
   * Consume an argument from the token stream, and return the resulting array
   * of tokens and start/end token.
   */
  consumeArg(e) {
    var n = [], r = e && e.length > 0;
    r || this.consumeSpaces();
    var i = this.future(), a, o = 0, s = 0;
    do {
      if (a = this.popToken(), n.push(a), a.text === "{")
        ++o;
      else if (a.text === "}") {
        if (--o, o === -1)
          throw new Ge("Extra }", a);
      } else if (a.text === "EOF")
        throw new Ge("Unexpected end of input in a macro argument, expected '" + (e && r ? e[s] : "}") + "'", a);
      if (e && r)
        if ((o === 0 || o === 1 && e[s] === "{") && a.text === e[s]) {
          if (++s, s === e.length) {
            n.splice(-s, s);
            break;
          }
        } else
          s = 0;
    } while (o !== 0 || r);
    return i.text === "{" && n[n.length - 1].text === "}" && (n.pop(), n.shift()), n.reverse(), {
      tokens: n,
      start: i,
      end: a
    };
  }
  /**
   * Consume the specified number of (delimited) arguments from the token
   * stream and return the resulting array of arguments.
   */
  consumeArgs(e, n) {
    if (n) {
      if (n.length !== e + 1)
        throw new Ge("The length of delimiters doesn't match the number of args!");
      for (var r = n[0], i = 0; i < r.length; i++) {
        var a = this.popToken();
        if (r[i] !== a.text)
          throw new Ge("Use of the macro doesn't match its definition", a);
      }
    }
    for (var o = [], s = 0; s < e; s++)
      o.push(this.consumeArg(n && n[s + 1]).tokens);
    return o;
  }
  /**
   * Increment `expansionCount` by the specified amount.
   * Throw an error if it exceeds `maxExpand`.
   */
  countExpansion(e) {
    if (this.expansionCount += e, this.expansionCount > this.settings.maxExpand)
      throw new Ge("Too many expansions: infinite loop or need to increase maxExpand setting");
  }
  /**
   * Expand the next token only once if possible.
   *
   * If the token is expanded, the resulting tokens will be pushed onto
   * the stack in reverse order, and the number of such tokens will be
   * returned.  This number might be zero or positive.
   *
   * If not, the return value is `false`, and the next token remains at the
   * top of the stack.
   *
   * In either case, the next token will be on the top of the stack,
   * or the stack will be empty (in case of empty expansion
   * and no other tokens).
   *
   * Used to implement `expandAfterFuture` and `expandNextToken`.
   *
   * If expandableOnly, only expandable tokens are expanded and
   * an undefined control sequence results in an error.
   */
  expandOnce(e) {
    var n = this.popToken(), r = n.text, i = n.noexpand ? null : this._getExpansion(r);
    if (i == null || e && i.unexpandable) {
      if (e && i == null && r[0] === "\\" && !this.isDefined(r))
        throw new Ge("Undefined control sequence: " + r);
      return this.pushToken(n), !1;
    }
    this.countExpansion(1);
    var a = i.tokens, o = this.consumeArgs(i.numArgs, i.delimiters);
    if (i.numArgs) {
      a = a.slice();
      for (var s = a.length - 1; s >= 0; --s) {
        var l = a[s];
        if (l.text === "#") {
          if (s === 0)
            throw new Ge("Incomplete placeholder at end of macro body", l);
          if (l = a[--s], l.text === "#")
            a.splice(s + 1, 1);
          else if (/^[1-9]$/.test(l.text))
            a.splice(s, 2, ...o[+l.text - 1]);
          else
            throw new Ge("Not a valid argument number", l);
        }
      }
    }
    return this.pushTokens(a), a.length;
  }
  /**
   * Expand the next token only once (if possible), and return the resulting
   * top token on the stack (without removing anything from the stack).
   * Similar in behavior to TeX's `\expandafter\futurelet`.
   * Equivalent to expandOnce() followed by future().
   */
  expandAfterFuture() {
    return this.expandOnce(), this.future();
  }
  /**
   * Recursively expand first token, then return first non-expandable token.
   */
  expandNextToken() {
    for (; ; )
      if (this.expandOnce() === !1) {
        var e = this.stack.pop();
        return e.treatAsRelax && (e.text = "\\relax"), e;
      }
    throw new Error();
  }
  /**
   * Fully expand the given macro name and return the resulting list of
   * tokens, or return `undefined` if no such macro is defined.
   */
  expandMacro(e) {
    return this.macros.has(e) ? this.expandTokens([new Qo(e)]) : void 0;
  }
  /**
   * Fully expand the given token stream and return the resulting list of
   * tokens.  Note that the input tokens are in reverse order, but the
   * output tokens are in forward order.
   */
  expandTokens(e) {
    var n = [], r = this.stack.length;
    for (this.pushTokens(e); this.stack.length > r; )
      if (this.expandOnce(!0) === !1) {
        var i = this.stack.pop();
        i.treatAsRelax && (i.noexpand = !1, i.treatAsRelax = !1), n.push(i);
      }
    return this.countExpansion(n.length), n;
  }
  /**
   * Fully expand the given macro name and return the result as a string,
   * or return `undefined` if no such macro is defined.
   */
  expandMacroAsText(e) {
    var n = this.expandMacro(e);
    return n && n.map((r) => r.text).join("");
  }
  /**
   * Returns the expanded macro as a reversed array of tokens and a macro
   * argument count.  Or returns `null` if no such macro.
   */
  _getExpansion(e) {
    var n = this.macros.get(e);
    if (n == null)
      return n;
    if (e.length === 1) {
      var r = this.lexer.catcodes[e];
      if (r != null && r !== 13)
        return;
    }
    var i = typeof n == "function" ? n(this) : n;
    if (typeof i == "string") {
      var a = 0;
      if (i.indexOf("#") !== -1)
        for (var o = i.replace(/##/g, ""); o.indexOf("#" + (a + 1)) !== -1; )
          ++a;
      for (var s = new DO(i, this.settings), l = [], c = s.lex(); c.text !== "EOF"; )
        l.push(c), c = s.lex();
      l.reverse();
      var u = {
        tokens: l,
        numArgs: a
      };
      return u;
    }
    return i;
  }
  /**
   * Determine whether a command is currently "defined" (has some
   * functionality), meaning that it's a macro (in the current group),
   * a function, a symbol, or one of the special commands listed in
   * `implicitCommands`.
   */
  isDefined(e) {
    return this.macros.has(e) || lc.hasOwnProperty(e) || kn.math.hasOwnProperty(e) || kn.text.hasOwnProperty(e) || Jne.hasOwnProperty(e);
  }
  /**
   * Determine whether a command is expandable.
   */
  isExpandable(e) {
    var n = this.macros.get(e);
    return n != null ? typeof n == "string" || typeof n == "function" || !n.unexpandable : lc.hasOwnProperty(e) && !lc[e].primitive;
  }
}
var zO = /^[₊₋₌₍₎₀₁₂₃₄₅₆₇₈₉ₐₑₕᵢⱼₖₗₘₙₒₚᵣₛₜᵤᵥₓᵦᵧᵨᵩᵪ]/, E4 = Object.freeze({
  "₊": "+",
  "₋": "-",
  "₌": "=",
  "₍": "(",
  "₎": ")",
  "₀": "0",
  "₁": "1",
  "₂": "2",
  "₃": "3",
  "₄": "4",
  "₅": "5",
  "₆": "6",
  "₇": "7",
  "₈": "8",
  "₉": "9",
  "ₐ": "a",
  "ₑ": "e",
  "ₕ": "h",
  "ᵢ": "i",
  "ⱼ": "j",
  "ₖ": "k",
  "ₗ": "l",
  "ₘ": "m",
  "ₙ": "n",
  "ₒ": "o",
  "ₚ": "p",
  "ᵣ": "r",
  "ₛ": "s",
  "ₜ": "t",
  "ᵤ": "u",
  "ᵥ": "v",
  "ₓ": "x",
  "ᵦ": "β",
  "ᵧ": "γ",
  "ᵨ": "ρ",
  "ᵩ": "ϕ",
  "ᵪ": "χ",
  "⁺": "+",
  "⁻": "-",
  "⁼": "=",
  "⁽": "(",
  "⁾": ")",
  "⁰": "0",
  "¹": "1",
  "²": "2",
  "³": "3",
  "⁴": "4",
  "⁵": "5",
  "⁶": "6",
  "⁷": "7",
  "⁸": "8",
  "⁹": "9",
  "ᴬ": "A",
  "ᴮ": "B",
  "ᴰ": "D",
  "ᴱ": "E",
  "ᴳ": "G",
  "ᴴ": "H",
  "ᴵ": "I",
  "ᴶ": "J",
  "ᴷ": "K",
  "ᴸ": "L",
  "ᴹ": "M",
  "ᴺ": "N",
  "ᴼ": "O",
  "ᴾ": "P",
  "ᴿ": "R",
  "ᵀ": "T",
  "ᵁ": "U",
  "ⱽ": "V",
  "ᵂ": "W",
  "ᵃ": "a",
  "ᵇ": "b",
  "ᶜ": "c",
  "ᵈ": "d",
  "ᵉ": "e",
  "ᶠ": "f",
  "ᵍ": "g",
  ʰ: "h",
  "ⁱ": "i",
  ʲ: "j",
  "ᵏ": "k",
  ˡ: "l",
  "ᵐ": "m",
  ⁿ: "n",
  "ᵒ": "o",
  "ᵖ": "p",
  ʳ: "r",
  ˢ: "s",
  "ᵗ": "t",
  "ᵘ": "u",
  "ᵛ": "v",
  ʷ: "w",
  ˣ: "x",
  ʸ: "y",
  "ᶻ": "z",
  "ᵝ": "β",
  "ᵞ": "γ",
  "ᵟ": "δ",
  "ᵠ": "ϕ",
  "ᵡ": "χ",
  "ᶿ": "θ"
}), Zb = {
  "́": {
    text: "\\'",
    math: "\\acute"
  },
  "̀": {
    text: "\\`",
    math: "\\grave"
  },
  "̈": {
    text: '\\"',
    math: "\\ddot"
  },
  "̃": {
    text: "\\~",
    math: "\\tilde"
  },
  "̄": {
    text: "\\=",
    math: "\\bar"
  },
  "̆": {
    text: "\\u",
    math: "\\breve"
  },
  "̌": {
    text: "\\v",
    math: "\\check"
  },
  "̂": {
    text: "\\^",
    math: "\\hat"
  },
  "̇": {
    text: "\\.",
    math: "\\dot"
  },
  "̊": {
    text: "\\r",
    math: "\\mathring"
  },
  "̋": {
    text: "\\H"
  },
  "̧": {
    text: "\\c"
  }
}, RO = {
  á: "á",
  à: "à",
  ä: "ä",
  ǟ: "ǟ",
  ã: "ã",
  ā: "ā",
  ă: "ă",
  ắ: "ắ",
  ằ: "ằ",
  ẵ: "ẵ",
  ǎ: "ǎ",
  â: "â",
  ấ: "ấ",
  ầ: "ầ",
  ẫ: "ẫ",
  ȧ: "ȧ",
  ǡ: "ǡ",
  å: "å",
  ǻ: "ǻ",
  ḃ: "ḃ",
  ć: "ć",
  ḉ: "ḉ",
  č: "č",
  ĉ: "ĉ",
  ċ: "ċ",
  ç: "ç",
  ď: "ď",
  ḋ: "ḋ",
  ḑ: "ḑ",
  é: "é",
  è: "è",
  ë: "ë",
  ẽ: "ẽ",
  ē: "ē",
  ḗ: "ḗ",
  ḕ: "ḕ",
  ĕ: "ĕ",
  ḝ: "ḝ",
  ě: "ě",
  ê: "ê",
  ế: "ế",
  ề: "ề",
  ễ: "ễ",
  ė: "ė",
  ȩ: "ȩ",
  ḟ: "ḟ",
  ǵ: "ǵ",
  ḡ: "ḡ",
  ğ: "ğ",
  ǧ: "ǧ",
  ĝ: "ĝ",
  ġ: "ġ",
  ģ: "ģ",
  ḧ: "ḧ",
  ȟ: "ȟ",
  ĥ: "ĥ",
  ḣ: "ḣ",
  ḩ: "ḩ",
  í: "í",
  ì: "ì",
  ï: "ï",
  ḯ: "ḯ",
  ĩ: "ĩ",
  ī: "ī",
  ĭ: "ĭ",
  ǐ: "ǐ",
  î: "î",
  ǰ: "ǰ",
  ĵ: "ĵ",
  ḱ: "ḱ",
  ǩ: "ǩ",
  ķ: "ķ",
  ĺ: "ĺ",
  ľ: "ľ",
  ļ: "ļ",
  ḿ: "ḿ",
  ṁ: "ṁ",
  ń: "ń",
  ǹ: "ǹ",
  ñ: "ñ",
  ň: "ň",
  ṅ: "ṅ",
  ņ: "ņ",
  ó: "ó",
  ò: "ò",
  ö: "ö",
  ȫ: "ȫ",
  õ: "õ",
  ṍ: "ṍ",
  ṏ: "ṏ",
  ȭ: "ȭ",
  ō: "ō",
  ṓ: "ṓ",
  ṑ: "ṑ",
  ŏ: "ŏ",
  ǒ: "ǒ",
  ô: "ô",
  ố: "ố",
  ồ: "ồ",
  ỗ: "ỗ",
  ȯ: "ȯ",
  ȱ: "ȱ",
  ő: "ő",
  ṕ: "ṕ",
  ṗ: "ṗ",
  ŕ: "ŕ",
  ř: "ř",
  ṙ: "ṙ",
  ŗ: "ŗ",
  ś: "ś",
  ṥ: "ṥ",
  š: "š",
  ṧ: "ṧ",
  ŝ: "ŝ",
  ṡ: "ṡ",
  ş: "ş",
  ẗ: "ẗ",
  ť: "ť",
  ṫ: "ṫ",
  ţ: "ţ",
  ú: "ú",
  ù: "ù",
  ü: "ü",
  ǘ: "ǘ",
  ǜ: "ǜ",
  ǖ: "ǖ",
  ǚ: "ǚ",
  ũ: "ũ",
  ṹ: "ṹ",
  ū: "ū",
  ṻ: "ṻ",
  ŭ: "ŭ",
  ǔ: "ǔ",
  û: "û",
  ů: "ů",
  ű: "ű",
  ṽ: "ṽ",
  ẃ: "ẃ",
  ẁ: "ẁ",
  ẅ: "ẅ",
  ŵ: "ŵ",
  ẇ: "ẇ",
  ẘ: "ẘ",
  ẍ: "ẍ",
  ẋ: "ẋ",
  ý: "ý",
  ỳ: "ỳ",
  ÿ: "ÿ",
  ỹ: "ỹ",
  ȳ: "ȳ",
  ŷ: "ŷ",
  ẏ: "ẏ",
  ẙ: "ẙ",
  ź: "ź",
  ž: "ž",
  ẑ: "ẑ",
  ż: "ż",
  Á: "Á",
  À: "À",
  Ä: "Ä",
  Ǟ: "Ǟ",
  Ã: "Ã",
  Ā: "Ā",
  Ă: "Ă",
  Ắ: "Ắ",
  Ằ: "Ằ",
  Ẵ: "Ẵ",
  Ǎ: "Ǎ",
  Â: "Â",
  Ấ: "Ấ",
  Ầ: "Ầ",
  Ẫ: "Ẫ",
  Ȧ: "Ȧ",
  Ǡ: "Ǡ",
  Å: "Å",
  Ǻ: "Ǻ",
  Ḃ: "Ḃ",
  Ć: "Ć",
  Ḉ: "Ḉ",
  Č: "Č",
  Ĉ: "Ĉ",
  Ċ: "Ċ",
  Ç: "Ç",
  Ď: "Ď",
  Ḋ: "Ḋ",
  Ḑ: "Ḑ",
  É: "É",
  È: "È",
  Ë: "Ë",
  Ẽ: "Ẽ",
  Ē: "Ē",
  Ḗ: "Ḗ",
  Ḕ: "Ḕ",
  Ĕ: "Ĕ",
  Ḝ: "Ḝ",
  Ě: "Ě",
  Ê: "Ê",
  Ế: "Ế",
  Ề: "Ề",
  Ễ: "Ễ",
  Ė: "Ė",
  Ȩ: "Ȩ",
  Ḟ: "Ḟ",
  Ǵ: "Ǵ",
  Ḡ: "Ḡ",
  Ğ: "Ğ",
  Ǧ: "Ǧ",
  Ĝ: "Ĝ",
  Ġ: "Ġ",
  Ģ: "Ģ",
  Ḧ: "Ḧ",
  Ȟ: "Ȟ",
  Ĥ: "Ĥ",
  Ḣ: "Ḣ",
  Ḩ: "Ḩ",
  Í: "Í",
  Ì: "Ì",
  Ï: "Ï",
  Ḯ: "Ḯ",
  Ĩ: "Ĩ",
  Ī: "Ī",
  Ĭ: "Ĭ",
  Ǐ: "Ǐ",
  Î: "Î",
  İ: "İ",
  Ĵ: "Ĵ",
  Ḱ: "Ḱ",
  Ǩ: "Ǩ",
  Ķ: "Ķ",
  Ĺ: "Ĺ",
  Ľ: "Ľ",
  Ļ: "Ļ",
  Ḿ: "Ḿ",
  Ṁ: "Ṁ",
  Ń: "Ń",
  Ǹ: "Ǹ",
  Ñ: "Ñ",
  Ň: "Ň",
  Ṅ: "Ṅ",
  Ņ: "Ņ",
  Ó: "Ó",
  Ò: "Ò",
  Ö: "Ö",
  Ȫ: "Ȫ",
  Õ: "Õ",
  Ṍ: "Ṍ",
  Ṏ: "Ṏ",
  Ȭ: "Ȭ",
  Ō: "Ō",
  Ṓ: "Ṓ",
  Ṑ: "Ṑ",
  Ŏ: "Ŏ",
  Ǒ: "Ǒ",
  Ô: "Ô",
  Ố: "Ố",
  Ồ: "Ồ",
  Ỗ: "Ỗ",
  Ȯ: "Ȯ",
  Ȱ: "Ȱ",
  Ő: "Ő",
  Ṕ: "Ṕ",
  Ṗ: "Ṗ",
  Ŕ: "Ŕ",
  Ř: "Ř",
  Ṙ: "Ṙ",
  Ŗ: "Ŗ",
  Ś: "Ś",
  Ṥ: "Ṥ",
  Š: "Š",
  Ṧ: "Ṧ",
  Ŝ: "Ŝ",
  Ṡ: "Ṡ",
  Ş: "Ş",
  Ť: "Ť",
  Ṫ: "Ṫ",
  Ţ: "Ţ",
  Ú: "Ú",
  Ù: "Ù",
  Ü: "Ü",
  Ǘ: "Ǘ",
  Ǜ: "Ǜ",
  Ǖ: "Ǖ",
  Ǚ: "Ǚ",
  Ũ: "Ũ",
  Ṹ: "Ṹ",
  Ū: "Ū",
  Ṻ: "Ṻ",
  Ŭ: "Ŭ",
  Ǔ: "Ǔ",
  Û: "Û",
  Ů: "Ů",
  Ű: "Ű",
  Ṽ: "Ṽ",
  Ẃ: "Ẃ",
  Ẁ: "Ẁ",
  Ẅ: "Ẅ",
  Ŵ: "Ŵ",
  Ẇ: "Ẇ",
  Ẍ: "Ẍ",
  Ẋ: "Ẋ",
  Ý: "Ý",
  Ỳ: "Ỳ",
  Ÿ: "Ÿ",
  Ỹ: "Ỹ",
  Ȳ: "Ȳ",
  Ŷ: "Ŷ",
  Ẏ: "Ẏ",
  Ź: "Ź",
  Ž: "Ž",
  Ẑ: "Ẑ",
  Ż: "Ż",
  ά: "ά",
  ὰ: "ὰ",
  ᾱ: "ᾱ",
  ᾰ: "ᾰ",
  έ: "έ",
  ὲ: "ὲ",
  ή: "ή",
  ὴ: "ὴ",
  ί: "ί",
  ὶ: "ὶ",
  ϊ: "ϊ",
  ΐ: "ΐ",
  ῒ: "ῒ",
  ῑ: "ῑ",
  ῐ: "ῐ",
  ό: "ό",
  ὸ: "ὸ",
  ύ: "ύ",
  ὺ: "ὺ",
  ϋ: "ϋ",
  ΰ: "ΰ",
  ῢ: "ῢ",
  ῡ: "ῡ",
  ῠ: "ῠ",
  ώ: "ώ",
  ὼ: "ὼ",
  Ύ: "Ύ",
  Ὺ: "Ὺ",
  Ϋ: "Ϋ",
  Ῡ: "Ῡ",
  Ῠ: "Ῠ",
  Ώ: "Ώ",
  Ὼ: "Ὼ"
};
let Qne = class Xne {
  constructor(e, n) {
    this.mode = void 0, this.gullet = void 0, this.settings = void 0, this.leftrightDepth = void 0, this.nextToken = void 0, this.mode = "math", this.gullet = new kUt(e, n, this.mode), this.settings = n, this.leftrightDepth = 0;
  }
  /**
   * Checks a result to make sure it has the right type, and throws an
   * appropriate error otherwise.
   */
  expect(e, n) {
    if (n === void 0 && (n = !0), this.fetch().text !== e)
      throw new Ge("Expected '" + e + "', got '" + this.fetch().text + "'", this.fetch());
    n && this.consume();
  }
  /**
   * Discards the current lookahead token, considering it consumed.
   */
  consume() {
    this.nextToken = null;
  }
  /**
   * Return the current lookahead token, or if there isn't one (at the
   * beginning, or if the previous lookahead token was consume()d),
   * fetch the next token as the new lookahead token and return it.
   */
  fetch() {
    return this.nextToken == null && (this.nextToken = this.gullet.expandNextToken()), this.nextToken;
  }
  /**
   * Switches between "text" and "math" modes.
   */
  switchMode(e) {
    this.mode = e, this.gullet.switchMode(e);
  }
  /**
   * Main parsing function, which parses an entire input.
   */
  parse() {
    this.settings.globalGroup || this.gullet.beginGroup(), this.settings.colorIsTextColor && this.gullet.macros.set("\\color", "\\textcolor");
    try {
      var e = this.parseExpression(!1);
      return this.expect("EOF"), this.settings.globalGroup || this.gullet.endGroup(), e;
    } finally {
      this.gullet.endGroups();
    }
  }
  /**
   * Fully parse a separate sequence of tokens as a separate job.
   * Tokens should be specified in reverse order, as in a MacroDefinition.
   */
  subparse(e) {
    var n = this.nextToken;
    this.consume(), this.gullet.pushToken(new Qo("}")), this.gullet.pushTokens(e);
    var r = this.parseExpression(!1);
    return this.expect("}"), this.nextToken = n, r;
  }
  /**
   * Parses an "expression", which is a list of atoms.
   *
   * `breakOnInfix`: Should the parsing stop when we hit infix nodes? This
   *                 happens when functions have higher precedence han infix
   *                 nodes in implicit parses.
   *
   * `breakOnTokenText`: The text of the token that the expression should end
   *                     with, or `null` if something else should end the
   *                     expression.
   */
  parseExpression(e, n) {
    for (var r = []; ; ) {
      this.mode === "math" && this.consumeSpaces();
      var i = this.fetch();
      if (Xne.endOfExpression.indexOf(i.text) !== -1 || n && i.text === n || e && lc[i.text] && lc[i.text].infix)
        break;
      var a = this.parseAtom(n);
      if (a) {
        if (a.type === "internal")
          continue;
      } else break;
      r.push(a);
    }
    return this.mode === "text" && this.formLigatures(r), this.handleInfixNodes(r);
  }
  /**
   * Rewrites infix operators such as \over with corresponding commands such
   * as \frac.
   *
   * There can only be one infix operator per group.  If there's more than one
   * then the expression is ambiguous.  This can be resolved by adding {}.
   */
  handleInfixNodes(e) {
    for (var n = -1, r, i = 0; i < e.length; i++)
      if (e[i].type === "infix") {
        if (n !== -1)
          throw new Ge("only one infix operator per group", e[i].token);
        n = i, r = e[i].replaceWith;
      }
    if (n !== -1 && r) {
      var a, o, s = e.slice(0, n), l = e.slice(n + 1);
      s.length === 1 && s[0].type === "ordgroup" ? a = s[0] : a = {
        type: "ordgroup",
        mode: this.mode,
        body: s
      }, l.length === 1 && l[0].type === "ordgroup" ? o = l[0] : o = {
        type: "ordgroup",
        mode: this.mode,
        body: l
      };
      var c;
      return r === "\\\\abovefrac" ? c = this.callFunction(r, [a, e[n], o], []) : c = this.callFunction(r, [a, o], []), [c];
    } else
      return e;
  }
  /**
   * Handle a subscript or superscript with nice errors.
   */
  handleSupSubscript(e) {
    var n = this.fetch(), r = n.text;
    this.consume(), this.consumeSpaces();
    var i = this.parseGroup(e);
    if (!i)
      throw new Ge("Expected group after '" + r + "'", n);
    return i;
  }
  /**
   * Converts the textual input of an unsupported command into a text node
   * contained within a color node whose color is determined by errorColor
   */
  formatUnsupportedCmd(e) {
    for (var n = [], r = 0; r < e.length; r++)
      n.push({
        type: "textord",
        mode: "text",
        text: e[r]
      });
    var i = {
      type: "text",
      mode: this.mode,
      body: n
    }, a = {
      type: "color",
      mode: this.mode,
      color: this.settings.errorColor,
      body: [i]
    };
    return a;
  }
  /**
   * Parses a group with optional super/subscripts.
   */
  parseAtom(e) {
    var n = this.parseGroup("atom", e);
    if (this.mode === "text")
      return n;
    for (var r, i; ; ) {
      this.consumeSpaces();
      var a = this.fetch();
      if (a.text === "\\limits" || a.text === "\\nolimits") {
        if (n && n.type === "op") {
          var o = a.text === "\\limits";
          n.limits = o, n.alwaysHandleSupSub = !0;
        } else if (n && n.type === "operatorname")
          n.alwaysHandleSupSub && (n.limits = a.text === "\\limits");
        else
          throw new Ge("Limit controls must follow a math operator", a);
        this.consume();
      } else if (a.text === "^") {
        if (r)
          throw new Ge("Double superscript", a);
        r = this.handleSupSubscript("superscript");
      } else if (a.text === "_") {
        if (i)
          throw new Ge("Double subscript", a);
        i = this.handleSupSubscript("subscript");
      } else if (a.text === "'") {
        if (r)
          throw new Ge("Double superscript", a);
        var s = {
          type: "textord",
          mode: this.mode,
          text: "\\prime"
        }, l = [s];
        for (this.consume(); this.fetch().text === "'"; )
          l.push(s), this.consume();
        this.fetch().text === "^" && l.push(this.handleSupSubscript("superscript")), r = {
          type: "ordgroup",
          mode: this.mode,
          body: l
        };
      } else if (E4[a.text]) {
        var c = zO.test(a.text), u = [];
        for (u.push(new Qo(E4[a.text])), this.consume(); ; ) {
          var d = this.fetch().text;
          if (!E4[d] || zO.test(d) !== c)
            break;
          u.unshift(new Qo(E4[d])), this.consume();
        }
        var f = this.subparse(u);
        c ? i = {
          type: "ordgroup",
          mode: "math",
          body: f
        } : r = {
          type: "ordgroup",
          mode: "math",
          body: f
        };
      } else
        break;
    }
    return r || i ? {
      type: "supsub",
      mode: this.mode,
      base: n,
      sup: r,
      sub: i
    } : n;
  }
  /**
   * Parses an entire function, including its base and all of its arguments.
   */
  parseFunction(e, n) {
    var r = this.fetch(), i = r.text, a = lc[i];
    if (!a)
      return null;
    if (this.consume(), n && n !== "atom" && !a.allowedInArgument)
      throw new Ge("Got function '" + i + "' with no arguments" + (n ? " as " + n : ""), r);
    if (this.mode === "text" && !a.allowedInText)
      throw new Ge("Can't use function '" + i + "' in text mode", r);
    if (this.mode === "math" && a.allowedInMath === !1)
      throw new Ge("Can't use function '" + i + "' in math mode", r);
    var {
      args: o,
      optArgs: s
    } = this.parseArguments(i, a);
    return this.callFunction(i, o, s, r, e);
  }
  /**
   * Call a function handler with a suitable context and arguments.
   */
  callFunction(e, n, r, i, a) {
    var o = {
      funcName: e,
      parser: this,
      token: i,
      breakOnTokenText: a
    }, s = lc[e];
    if (s && s.handler)
      return s.handler(o, n, r);
    throw new Ge("No function handler for " + e);
  }
  /**
   * Parses the arguments of a function or environment
   */
  parseArguments(e, n) {
    var r = n.numArgs + n.numOptionalArgs;
    if (r === 0)
      return {
        args: [],
        optArgs: []
      };
    for (var i = [], a = [], o = 0; o < r; o++) {
      var s = n.argTypes && n.argTypes[o], l = o < n.numOptionalArgs;
      (n.primitive && s == null || // \sqrt expands into primitive if optional argument doesn't exist
      n.type === "sqrt" && o === 1 && a[0] == null) && (s = "primitive");
      var c = this.parseGroupOfType("argument to '" + e + "'", s, l);
      if (l)
        a.push(c);
      else if (c != null)
        i.push(c);
      else
        throw new Ge("Null argument, please report this as a bug");
    }
    return {
      args: i,
      optArgs: a
    };
  }
  /**
   * Parses a group when the mode is changing.
   */
  parseGroupOfType(e, n, r) {
    switch (n) {
      case "color":
        return this.parseColorGroup(r);
      case "size":
        return this.parseSizeGroup(r);
      case "url":
        return this.parseUrlGroup(r);
      case "math":
      case "text":
        return this.parseArgumentGroup(r, n);
      case "hbox": {
        var i = this.parseArgumentGroup(r, "text");
        return i != null ? {
          type: "styling",
          mode: i.mode,
          body: [i],
          style: "text"
          // simulate \textstyle
        } : null;
      }
      case "raw": {
        var a = this.parseStringGroup("raw", r);
        return a != null ? {
          type: "raw",
          mode: "text",
          string: a.text
        } : null;
      }
      case "primitive": {
        if (r)
          throw new Ge("A primitive argument cannot be optional");
        var o = this.parseGroup(e);
        if (o == null)
          throw new Ge("Expected group as " + e, this.fetch());
        return o;
      }
      case "original":
      case null:
      case void 0:
        return this.parseArgumentGroup(r);
      default:
        throw new Ge("Unknown group type as " + e, this.fetch());
    }
  }
  /**
   * Discard any space tokens, fetching the next non-space token.
   */
  consumeSpaces() {
    for (; this.fetch().text === " "; )
      this.consume();
  }
  /**
   * Parses a group, essentially returning the string formed by the
   * brace-enclosed tokens plus some position information.
   */
  parseStringGroup(e, n) {
    var r = this.gullet.scanArgument(n);
    if (r == null)
      return null;
    for (var i = "", a; (a = this.fetch()).text !== "EOF"; )
      i += a.text, this.consume();
    return this.consume(), r.text = i, r;
  }
  /**
   * Parses a regex-delimited group: the largest sequence of tokens
   * whose concatenated strings match `regex`. Returns the string
   * formed by the tokens plus some position information.
   */
  parseRegexGroup(e, n) {
    for (var r = this.fetch(), i = r, a = "", o; (o = this.fetch()).text !== "EOF" && e.test(a + o.text); )
      i = o, a += i.text, this.consume();
    if (a === "")
      throw new Ge("Invalid " + n + ": '" + r.text + "'", r);
    return r.range(i, a);
  }
  /**
   * Parses a color description.
   */
  parseColorGroup(e) {
    var n = this.parseStringGroup("color", e);
    if (n == null)
      return null;
    var r = /^(#[a-f0-9]{3}|#?[a-f0-9]{6}|[a-z]+)$/i.exec(n.text);
    if (!r)
      throw new Ge("Invalid color: '" + n.text + "'", n);
    var i = r[0];
    return /^[0-9a-f]{6}$/i.test(i) && (i = "#" + i), {
      type: "color-token",
      mode: this.mode,
      color: i
    };
  }
  /**
   * Parses a size specification, consisting of magnitude and unit.
   */
  parseSizeGroup(e) {
    var n, r = !1;
    if (this.gullet.consumeSpaces(), !e && this.gullet.future().text !== "{" ? n = this.parseRegexGroup(/^[-+]? *(?:$|\d+|\d+\.\d*|\.\d*) *[a-z]{0,2} *$/, "size") : n = this.parseStringGroup("size", e), !n)
      return null;
    !e && n.text.length === 0 && (n.text = "0pt", r = !0);
    var i = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(n.text);
    if (!i)
      throw new Ge("Invalid size: '" + n.text + "'", n);
    var a = {
      number: +(i[1] + i[2]),
      // sign + magnitude, cast to number
      unit: i[3]
    };
    if (!sne(a))
      throw new Ge("Invalid unit: '" + a.unit + "'", n);
    return {
      type: "size",
      mode: this.mode,
      value: a,
      isBlank: r
    };
  }
  /**
   * Parses an URL, checking escaped letters and allowed protocols,
   * and setting the catcode of % as an active character (as in \hyperref).
   */
  parseUrlGroup(e) {
    this.gullet.lexer.setCatcode("%", 13), this.gullet.lexer.setCatcode("~", 12);
    var n = this.parseStringGroup("url", e);
    if (this.gullet.lexer.setCatcode("%", 14), this.gullet.lexer.setCatcode("~", 13), n == null)
      return null;
    var r = n.text.replace(/\\([#$%&~_^{}])/g, "$1");
    return {
      type: "url",
      mode: this.mode,
      url: r
    };
  }
  /**
   * Parses an argument with the mode specified.
   */
  parseArgumentGroup(e, n) {
    var r = this.gullet.scanArgument(e);
    if (r == null)
      return null;
    var i = this.mode;
    n && this.switchMode(n), this.gullet.beginGroup();
    var a = this.parseExpression(!1, "EOF");
    this.expect("EOF"), this.gullet.endGroup();
    var o = {
      type: "ordgroup",
      mode: this.mode,
      loc: r.loc,
      body: a
    };
    return n && this.switchMode(i), o;
  }
  /**
   * Parses an ordinary group, which is either a single nucleus (like "x")
   * or an expression in braces (like "{x+y}") or an implicit group, a group
   * that starts at the current position, and ends right before a higher explicit
   * group ends, or at EOF.
   */
  parseGroup(e, n) {
    var r = this.fetch(), i = r.text, a;
    if (i === "{" || i === "\\begingroup") {
      this.consume();
      var o = i === "{" ? "}" : "\\endgroup";
      this.gullet.beginGroup();
      var s = this.parseExpression(!1, o), l = this.fetch();
      this.expect(o), this.gullet.endGroup(), a = {
        type: "ordgroup",
        mode: this.mode,
        loc: Ui.range(r, l),
        body: s,
        // A group formed by \begingroup...\endgroup is a semi-simple group
        // which doesn't affect spacing in math mode, i.e., is transparent.
        // https://tex.stackexchange.com/questions/1930/when-should-one-
        // use-begingroup-instead-of-bgroup
        semisimple: i === "\\begingroup" || void 0
      };
    } else if (a = this.parseFunction(n, e) || this.parseSymbol(), a == null && i[0] === "\\" && !Jne.hasOwnProperty(i)) {
      if (this.settings.throwOnError)
        throw new Ge("Undefined control sequence: " + i, r);
      a = this.formatUnsupportedCmd(i), this.consume();
    }
    return a;
  }
  /**
   * Form ligature-like combinations of characters for text mode.
   * This includes inputs like "--", "---", "``" and "''".
   * The result will simply replace multiple textord nodes with a single
   * character in each value by a single textord node having multiple
   * characters in its value.  The representation is still ASCII source.
   * The group will be modified in place.
   */
  formLigatures(e) {
    for (var n = e.length - 1, r = 0; r < n; ++r) {
      var i = e[r], a = i.text;
      a === "-" && e[r + 1].text === "-" && (r + 1 < n && e[r + 2].text === "-" ? (e.splice(r, 3, {
        type: "textord",
        mode: "text",
        loc: Ui.range(i, e[r + 2]),
        text: "---"
      }), n -= 2) : (e.splice(r, 2, {
        type: "textord",
        mode: "text",
        loc: Ui.range(i, e[r + 1]),
        text: "--"
      }), n -= 1)), (a === "'" || a === "`") && e[r + 1].text === a && (e.splice(r, 2, {
        type: "textord",
        mode: "text",
        loc: Ui.range(i, e[r + 1]),
        text: a + a
      }), n -= 1);
    }
  }
  /**
   * Parse a single symbol out of the string. Here, we handle single character
   * symbols and special functions like \verb.
   */
  parseSymbol() {
    var e = this.fetch(), n = e.text;
    if (/^\\verb[^a-zA-Z]/.test(n)) {
      this.consume();
      var r = n.slice(5), i = r.charAt(0) === "*";
      if (i && (r = r.slice(1)), r.length < 2 || r.charAt(0) !== r.slice(-1))
        throw new Ge(`\\verb assertion failed --
                    please report what input caused this bug`);
      return r = r.slice(1, -1), {
        type: "verb",
        mode: "text",
        body: r,
        star: i
      };
    }
    RO.hasOwnProperty(n[0]) && !kn[this.mode][n[0]] && (this.settings.strict && this.mode === "math" && this.settings.reportNonstrict("unicodeTextInMathMode", 'Accented Unicode text character "' + n[0] + '" used in math mode', e), n = RO[n[0]] + n.slice(1));
    var a = gUt.exec(n);
    a && (n = n.substring(0, a.index), n === "i" ? n = "ı" : n === "j" && (n = "ȷ"));
    var o;
    if (kn[this.mode][n]) {
      this.settings.strict && this.mode === "math" && zk.indexOf(n) >= 0 && this.settings.reportNonstrict("unicodeTextInMathMode", 'Latin-1/Unicode text character "' + n[0] + '" used in math mode', e);
      var s = kn[this.mode][n].group, l = Ui.range(e), c;
      if (cqt.hasOwnProperty(s)) {
        var u = s;
        c = {
          type: "atom",
          mode: this.mode,
          family: u,
          loc: l,
          text: n
        };
      } else
        c = {
          type: s,
          mode: this.mode,
          loc: l,
          text: n
        };
      o = c;
    } else if (n.charCodeAt(0) >= 128)
      this.settings.strict && (one(n.charCodeAt(0)) ? this.mode === "math" && this.settings.reportNonstrict("unicodeTextInMathMode", 'Unicode text character "' + n[0] + '" used in math mode', e) : this.settings.reportNonstrict("unknownSymbol", 'Unrecognized Unicode character "' + n[0] + '"' + (" (" + n.charCodeAt(0) + ")"), e)), o = {
        type: "textord",
        mode: "text",
        loc: Ui.range(e),
        text: n
      };
    else
      return null;
    if (this.consume(), a)
      for (var d = 0; d < a[0].length; d++) {
        var f = a[0][d];
        if (!Zb[f])
          throw new Ge("Unknown accent ' " + f + "'", e);
        var h = Zb[f][this.mode] || Zb[f].text;
        if (!h)
          throw new Ge("Accent " + f + " unsupported in " + this.mode + " mode", e);
        o = {
          type: "accent",
          mode: this.mode,
          loc: Ui.range(e),
          label: h,
          isStretchy: !1,
          isShifty: !0,
          // $FlowFixMe
          base: o
        };
      }
    return o;
  }
};
Qne.endOfExpression = ["}", "\\endgroup", "\\end", "\\right", "&"];
var BL = function(e, n) {
  if (!(typeof e == "string" || e instanceof String))
    throw new TypeError("KaTeX can only parse string typed expression");
  var r = new Qne(e, n);
  delete r.gullet.macros.current["\\df@tag"];
  var i = r.parse();
  if (delete r.gullet.macros.current["\\current@color"], delete r.gullet.macros.current["\\color"], r.gullet.macros.get("\\df@tag")) {
    if (!n.displayMode)
      throw new Ge("\\tag works only in display equations");
    i = [{
      type: "tag",
      mode: "text",
      body: i,
      tag: r.subparse([new Qo("\\df@tag")])
    }];
  }
  return i;
}, ere = function(e, n, r) {
  n.textContent = "";
  var i = HL(e, r).toNode();
  n.appendChild(i);
};
typeof document < "u" && document.compatMode !== "CSS1Compat" && (typeof console < "u" && console.warn("Warning: KaTeX doesn't work in quirks mode. Make sure your website has a suitable doctype."), ere = function() {
  throw new Ge("KaTeX doesn't work in quirks mode.");
});
var xUt = function(e, n) {
  var r = HL(e, n).toMarkup();
  return r;
}, MUt = function(e, n) {
  var r = new wL(n);
  return BL(e, r);
}, tre = function(e, n, r) {
  if (r.throwOnError || !(e instanceof Ge))
    throw e;
  var i = ke.makeSpan(["katex-error"], [new Oa(n)]);
  return i.setAttribute("title", e.toString()), i.setAttribute("style", "color:" + r.errorColor), i;
}, HL = function(e, n) {
  var r = new wL(n);
  try {
    var i = BL(e, r);
    return Dqt(i, e, r);
  } catch (a) {
    return tre(a, e, r);
  }
}, CUt = function(e, n) {
  var r = new wL(n);
  try {
    var i = BL(e, r);
    return Iqt(i, e, r);
  } catch (a) {
    return tre(a, e, r);
  }
}, AUt = "0.16.21", SUt = {
  Span: sm,
  Anchor: ML,
  SymbolNode: Oa,
  SvgNode: wl,
  PathNode: Pc,
  LineNode: Pk
}, LUt = {
  /**
   * Current KaTeX version
   */
  version: AUt,
  /**
   * Renders the given LaTeX into an HTML+MathML combination, and adds
   * it as a child to the specified DOM node.
   */
  render: ere,
  /**
   * Renders the given LaTeX into an HTML+MathML combination string,
   * for sending to the client.
   */
  renderToString: xUt,
  /**
   * KaTeX error, usually during parsing.
   */
  ParseError: Ge,
  /**
   * The schema of Settings
   */
  SETTINGS_SCHEMA: cy,
  /**
   * Parses the given LaTeX into KaTeX's internal parse tree structure,
   * without rendering to HTML or MathML.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __parse: MUt,
  /**
   * Renders the given LaTeX into an HTML+MathML internal DOM tree
   * representation, without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __renderToDomTree: HL,
  /**
   * Renders the given LaTeX into an HTML internal DOM tree representation,
   * without MathML and without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __renderToHTMLTree: CUt,
  /**
   * extends internal font metrics object with a new object
   * each key in the new object represents a font name
  */
  __setFontMetrics: tqt,
  /**
   * adds a new symbol to builtin symbols table
   */
  __defineSymbol: E,
  /**
   * adds a new function to builtin function list,
   * which directly produce parse tree elements
   * and have their own html/mathml builders
   */
  __defineFunction: at,
  /**
   * adds a new macro to builtin macro list
   */
  __defineMacro: U,
  /**
   * Expose the dom tree node types, which can be useful for type checking nodes.
   *
   * NOTE: These methods are not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __domTree: SUt
}, nre = {}, FL = {}, cm = {};
Object.defineProperty(cm, "__esModule", {
  value: !0
});
var TUt = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function EUt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var cn = function() {
  function t(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    EUt(this, t), this.type = e, this.value = n, this.name = null;
  }
  return TUt(t, [{
    key: "equals",
    value: function(n) {
      return this.type === n.type && this.value === n.value;
    }
  }, {
    key: "toString",
    value: function() {
      if (jUt.indexOf(this.type) >= 0)
        return this.type;
      var n = typeof this.value == "function" ? this.name : this.value;
      return this.type + "[" + n + "]";
    }
  }]), t;
}();
cn.TYPE_LPAREN = "LPAREN";
cn.TYPE_RPAREN = "RPAREN";
cn.TYPE_PLUS = "PLUS";
cn.TYPE_MINUS = "MINUS";
cn.TYPE_TIMES = "TIMES";
cn.TYPE_DIVIDE = "DIVIDE";
cn.TYPE_COMMAND = "COMMAND";
cn.TYPE_SYMBOL = "SYMBOL";
cn.TYPE_WHITESPACE = "WHITESPACE";
cn.TYPE_ABS = "ABSOLUTEVAL";
cn.TYPE_BANG = "BANG";
cn.TYPE_COMMA = "COMMA";
cn.TYPE_POWER = "POWER";
cn.TYPE_NUMBER = "NUMBER";
cn.patterns = /* @__PURE__ */ new Map([
  [cn.TYPE_LPAREN, /(\(|\[|{|\\left\(|\\left\[)/],
  // Match (, [, {, \left(, \left[
  [cn.TYPE_RPAREN, /(\)|]|}|\\right\)|\\right])/],
  // Match ), ], }, \right), \right]
  [cn.TYPE_PLUS, /\+/],
  [cn.TYPE_MINUS, /-/],
  [cn.TYPE_TIMES, /\*/],
  [cn.TYPE_DIVIDE, /\//],
  [cn.TYPE_COMMAND, /\\[A-Za-z]+/],
  [cn.TYPE_SYMBOL, /[A-Za-z_][A-Za-z_0-9]*/],
  [cn.TYPE_WHITESPACE, /\s+/],
  // Whitespace
  [cn.TYPE_ABS, /\|/],
  [cn.TYPE_BANG, /!/],
  [cn.TYPE_COMMA, /,/],
  [cn.TYPE_POWER, /\^/],
  [cn.TYPE_NUMBER, /\d+(\.\d+)?/]
]);
cm.default = cn;
var jUt = ["TPLUS", "TMINUS", "TTIMES", "TDIVIDE", "TWS", "TABS", "TBANG", "TCOMMA", "TPOWER"], j5 = {};
Object.defineProperty(j5, "__esModule", {
  value: !0
});
j5.default = {
  frac: 2,
  sqrt: 1,
  sin: 1,
  cos: 1,
  tan: 1,
  asin: 1,
  acos: 1,
  atan: 1,
  sec: 1,
  csc: 1,
  cot: 1,
  asec: 1,
  acsc: 1,
  acot: 1
};
var Mo = {};
Object.defineProperty(Mo, "__esModule", {
  value: !0
});
var NUt = Mo.fact = function(e) {
  e = Math.round(e);
  var n = 1;
  if (e < 0)
    throw "Can't factorial a negative.";
  for (e; e > 1; e--)
    n *= e;
  return n;
}, DUt = Mo.frac = function(e, n) {
  return e / n;
}, IUt = Mo.logn = function(e, n) {
  return Math.log(e) / Math.log(n);
}, PUt = Mo.rootn = function(e, n) {
  return Math.pow(e, 1 / n);
}, zUt = Mo.sec = function(e) {
  return 1 / Math.cos(e);
}, RUt = Mo.csc = function(e) {
  return 1 / Math.sin(e);
}, OUt = Mo.cot = function(e) {
  return 1 / Math.tan(e);
}, rre = { fact: NUt, frac: DUt, logn: IUt, rootn: PUt, sec: zUt, csc: RUt, cot: OUt }, Gb = !0, OO = !1, BO = void 0;
try {
  for (var Yb = Object.getOwnPropertyNames(Math)[Symbol.iterator](), HO; !(Gb = (HO = Yb.next()).done); Gb = !0) {
    var FO = HO.value;
    rre[FO] = Math[FO];
  }
} catch (t) {
  OO = !0, BO = t;
} finally {
  try {
    !Gb && Yb.return && Yb.return();
  } finally {
    if (OO)
      throw BO;
  }
}
Mo.default = rre;
var _L = {};
Object.defineProperty(_L, "__esModule", {
  value: !0
});
_L.default = FUt;
var BUt = cm, Kb = HUt(BUt);
function HUt(t) {
  return t && t.__esModule ? t : { default: t };
}
function FUt(t) {
  return t.type === Kb.default.TYPE_COMMAND && ["\\cdot", "\\times"].includes(t.value) ? new Kb.default(Kb.default.TYPE_TIMES, "*") : t;
}
Object.defineProperty(FL, "__esModule", {
  value: !0
});
var _Ut = /* @__PURE__ */ function() {
  function t(e, n) {
    var r = [], i = !0, a = !1, o = void 0;
    try {
      for (var s = e[Symbol.iterator](), l; !(i = (l = s.next()).done) && (r.push(l.value), !(n && r.length === n)); i = !0)
        ;
    } catch (c) {
      a = !0, o = c;
    } finally {
      try {
        !i && s.return && s.return();
      } finally {
        if (a) throw o;
      }
    }
    return r;
  }
  return function(e, n) {
    if (Array.isArray(e))
      return e;
    if (Symbol.iterator in Object(e))
      return t(e, n);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
}(), VUt = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
FL.default = XUt;
var qUt = cm, Vi = N5(qUt), UUt = j5, WUt = N5(UUt), ZUt = Mo, GUt = N5(ZUt), YUt = _L, KUt = N5(YUt);
function N5(t) {
  return t && t.__esModule ? t : { default: t };
}
function $Ut(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var JUt = [Vi.default.TYPE_POWER, Vi.default.TYPE_COMMAND], QUt = {
  latex: !1
};
function XUt(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : QUt, r = new eWt(t, e, n);
  return r.lex(), r.tokens.toString = function() {
    return r.tokens.map(function(i) {
      return i.toString();
    }).join(" ");
  }, r.tokens;
}
var eWt = function() {
  function t(e, n, r) {
    $Ut(this, t), this.buffer = e, this.constants = Object.assign({}, n, GUt.default), this.opts = r, this.tokens = [];
  }
  return VUt(t, [{
    key: "lex",
    value: function() {
      this.lexExpression(), this.replaceConstants(), this.replaceCommands();
    }
    /**
     * Lexes an expression or sub-expression.
     */
  }, {
    key: "lexExpression",
    value: function() {
      for (var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1; this.hasNext(); ) {
        var r = n ? this.nextCharToken() : this.next();
        if (this.tokens.push((0, KUt.default)(r)), this.opts.latex && tWt(r)) {
          var i = 1;
          r.type === Vi.default.TYPE_COMMAND && (i = WUt.default[r.value.substr(1).toLowerCase()]);
          for (var a = 0; a < i; a++)
            this.lexExpression(!0);
        } else nWt(r) && this.lexExpression(!1);
        if (n || rWt(r))
          return;
      }
    }
  }, {
    key: "hasNext",
    value: function() {
      return this.buffer.length > 0;
    }
    /**
     * Retrieves the next non-whitespace token from the buffer.
     * @param len
     * @returns {Token}
     */
  }, {
    key: "next",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
      if (this.skipWhitespace(), !this.hasNext())
        throw "Lexer error: reached end of stream";
      var r = !0, i = !1, a = void 0;
      try {
        for (var o = Vi.default.patterns[Symbol.iterator](), s; !(r = (s = o.next()).done); r = !0) {
          var l = s.value, c = _Ut(l, 2), u = c[0], d = c[1], f = new RegExp(/^/.source + d.source), h = f.exec(this.buffer.substr(0, n));
          if (h)
            return this.buffer = this.buffer.substr(h[0].length), new Vi.default(u, h[0]);
        }
      } catch (p) {
        i = !0, a = p;
      } finally {
        try {
          !r && o.return && o.return();
        } finally {
          if (i)
            throw a;
        }
      }
      throw "Lexer error: can't match any token";
    }
    /**
     * Tokenizes the next single character of the buffer, unless the following token is a LaTeX command, in which case the entire command is tokenized.
     */
  }, {
    key: "nextCharToken",
    value: function() {
      return this.skipWhitespace(), this.buffer.charAt(0) === "\\" ? this.next() : this.next(1);
    }
  }, {
    key: "replaceCommands",
    value: function() {
      var n = !0, r = !1, i = void 0;
      try {
        for (var a = this.tokens[Symbol.iterator](), o; !(n = (o = a.next()).done); n = !0) {
          var s = o.value;
          s.type === Vi.default.TYPE_COMMAND && (s.value = s.value.substr(1).toLowerCase(), s.name = s.value, s.value = this.constants[s.name]);
        }
      } catch (l) {
        r = !0, i = l;
      } finally {
        try {
          !n && a.return && a.return();
        } finally {
          if (r)
            throw i;
        }
      }
    }
  }, {
    key: "replaceConstants",
    value: function() {
      var n = !0, r = !1, i = void 0;
      try {
        for (var a = this.tokens[Symbol.iterator](), o; !(n = (o = a.next()).done); n = !0) {
          var s = o.value;
          s.type === Vi.default.TYPE_SYMBOL && (typeof this.constants[s.value] == "function" ? (s.type = Vi.default.TYPE_FUNCTION, s.name = s.value, s.value = this.constants[s.value]) : typeof this.constants[s.value] == "number" && (s.type = Vi.default.TYPE_NUMBER, s.value = s.fn = this.constants[s.value]));
        }
      } catch (l) {
        r = !0, i = l;
      } finally {
        try {
          !n && a.return && a.return();
        } finally {
          if (r)
            throw i;
        }
      }
    }
    /**
     * Removes whitespace from the beginning of the buffer.
     */
  }, {
    key: "skipWhitespace",
    value: function() {
      var n = new RegExp(/^/.source + Vi.default.patterns.get(Vi.default.TYPE_WHITESPACE).source);
      this.buffer = this.buffer.replace(n, "");
    }
  }]), t;
}();
function tWt(t) {
  return JUt.indexOf(t.type) !== -1;
}
function nWt(t) {
  return t.type === Vi.default.TYPE_LPAREN && t.value === "{";
}
function rWt(t) {
  return t.type === Vi.default.TYPE_RPAREN && t.value === "}";
}
var VL = {}, qL = {};
Object.defineProperty(qL, "__esModule", {
  value: !0
});
var iWt = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function aWt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var El = function() {
  function t(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    aWt(this, t), this.type = e, this.value = n, this.name = null, this.children = [];
  }
  return iWt(t, [{
    key: "addChild",
    value: function(n) {
      return this.children.push(n), this;
    }
    /**
     * Returns this Node's first child.
     */
  }, {
    key: "evaluate",
    /**
     * Evaluates this Node and all child nodes recursively, returning the numerical result of this Node.
     */
    value: function(n) {
      var r = 0;
      switch (this.type) {
        case t.TYPE_FUNCTION:
          var i = this.children.map(function(a) {
            return a.evaluate(n);
          });
          r = this.value.apply(this, i);
          break;
        case t.TYPE_INVERSE:
          r = 1 / this.child.evaluate(n);
          break;
        case t.TYPE_NEGATE:
          r = -this.child.evaluate(n);
          break;
        case t.TYPE_NUMBER:
          r = this.value;
          break;
        case t.TYPE_POWER:
          r = Math.pow(this.children[0].evaluate(n), this.children[1].evaluate(n));
          break;
        case t.TYPE_PRODUCT:
          r = this.children.reduce(function(a, o) {
            return a * o.evaluate(n);
          }, 1);
          break;
        case t.TYPE_SUM:
          r = this.children.reduce(function(a, o) {
            return a + o.evaluate(n);
          }, 0);
          break;
        case t.TYPE_SYMBOL:
          if (isFinite(n[this.value]))
            return n[this.value];
          throw new Error("Symbol " + this.value + " is undefined or not a number");
      }
      return r;
    }
    /**
     * Determines whether this Node is unary, i.e., whether it can have only one child.
     * @returns {boolean}
     */
  }, {
    key: "isUnary",
    value: function() {
      return oWt.indexOf(this.type) >= 0;
    }
  }, {
    key: "printTree",
    /**
     * Prints a tree-like representation of this Node and all child Nodes to the console.
     * Useful for debugging parser problems.
     * If printTree() is called on the root node, it prints the whole AST!
     * @param level (Integer, Optional) Initial level of indentation. You shouldn't need to use this.
     */
    value: function() {
      for (var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = "", i = "  ", a = 0; a < n; a++)
        r += i;
      console.log(r + this.toString());
      for (var o in this.children)
        this.children[o].printTree(n + 1);
    }
  }, {
    key: "simplify",
    value: function() {
      if (this.children.length > 1 || this.isUnary()) {
        var n = new t(this.type, this.value);
        for (var r in this.children)
          n.addChild(this.children[r].simplify());
        return n;
      } else return this.children.length === 1 ? this.children[0].simplify() : this;
    }
  }, {
    key: "toString",
    value: function() {
      var n = typeof this.value == "function" ? this.name : this.value;
      return this.children.length + " " + this.type + " [" + n + "]";
    }
  }, {
    key: "child",
    get: function() {
      return this.children[0];
    }
  }, {
    key: "nodeCount",
    get: function() {
      var n = 1, r = !0, i = !1, a = void 0;
      try {
        for (var o = this.children[Symbol.iterator](), s; !(r = (s = o.next()).done); r = !0) {
          var l = s.value;
          n += l.nodeCount;
        }
      } catch (c) {
        i = !0, a = c;
      } finally {
        try {
          !r && o.return && o.return();
        } finally {
          if (i)
            throw a;
        }
      }
      return n;
    }
  }]), t;
}();
El.TYPE_FUNCTION = "FUNCTION";
El.TYPE_INVERSE = "INVERSE";
El.TYPE_NEGATE = "NEGATE";
El.TYPE_NUMBER = "NUMBER";
El.TYPE_POWER = "POWER";
El.TYPE_PRODUCT = "PRODUCT";
El.TYPE_SUM = "SUM";
El.TYPE_SYMBOL = "SYMBOL";
qL.default = El;
var oWt = ["FACTORIAL", "FUNCTION", "INVERSE", "NEGATE"];
Object.defineProperty(VL, "__esModule", {
  value: !0
});
var sWt = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
VL.default = pWt;
var lWt = qL, Tn = UL(lWt), cWt = cm, Zn = UL(cWt), uWt = j5, dWt = UL(uWt), fWt = Mo;
function UL(t) {
  return t && t.__esModule ? t : { default: t };
}
function hWt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function pWt(t) {
  var e = new mWt(t);
  return e.parse();
}
var mWt = function() {
  function t() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    hWt(this, t), this.cursor = 0, this.tokens = e;
  }
  return sWt(t, [{
    key: "parse",
    value: function() {
      var n = this.sum();
      if (n = n.simplify(), this.currentToken !== void 0)
        throw console.log(n.printTree()), "Parsing error: Expected end of input, but got " + this.currentToken.type + " " + this.currentToken.value;
      return n;
    }
    //preprocess() {
    // This function used to contain procedures to remove whitespace
    // tokens and replace symbol tokens with functions, but that work
    // has been moved to the lexer in order to keep the parser more
    // lightweight.
    //}
    /**
     * Accepts the current token if it matches the given type.
     * If it does, the cursor is incremented and this method returns true.
     * If it doesn't, the cursor stays where it is and this method returns false.
     * @param type Type of token to accept.
     * @returns {boolean} True if the token was accepted.
     */
  }, {
    key: "accept",
    value: function(n) {
      return this.currentToken && this.currentToken.type === n ? (this.cursor++, !0) : !1;
    }
    /**
     * Accepts the current token if it matches the given type.
     * If it does, the cursor is incremented.
     * If it doesn't, an exception is raised.
     * @param type
     */
  }, {
    key: "expect",
    value: function(n) {
      if (!this.accept(n))
        throw "Expected " + n + " but got " + (this.currentToken ? this.currentToken.toString() : "end of input.");
    }
    // Rules
    // -----
    /**
     * Parses a math expression with
     */
  }, {
    key: "sum",
    value: function() {
      var n = new Tn.default(Tn.default.TYPE_SUM);
      for (n.addChild(this.product()); ; )
        if (this.accept(Zn.default.TYPE_PLUS))
          n.addChild(this.product());
        else if (this.accept(Zn.default.TYPE_MINUS))
          n.addChild(new Tn.default(Tn.default.TYPE_NEGATE).addChild(this.product()));
        else
          break;
      return n;
    }
  }, {
    key: "product",
    value: function() {
      var n = new Tn.default(Tn.default.TYPE_PRODUCT);
      for (n.addChild(this.power()); ; )
        if (this.accept(Zn.default.TYPE_TIMES))
          n.addChild(this.power());
        else if (this.accept(Zn.default.TYPE_DIVIDE))
          n.addChild(new Tn.default(Tn.default.TYPE_INVERSE).addChild(this.power()));
        else if (this.accept(Zn.default.TYPE_LPAREN))
          this.cursor--, n.addChild(this.power());
        else if (this.accept(Zn.default.TYPE_SYMBOL) || this.accept(Zn.default.TYPE_NUMBER) || this.accept(Zn.default.TYPE_FUNCTION))
          this.cursor--, n.addChild(this.power());
        else
          break;
      return n;
    }
  }, {
    key: "power",
    value: function() {
      var n = new Tn.default(Tn.default.TYPE_POWER);
      return n.addChild(this.val()), this.accept(Zn.default.TYPE_POWER) && n.addChild(this.power()), n;
    }
  }, {
    key: "val",
    value: function() {
      var n = {};
      if (this.accept(Zn.default.TYPE_SYMBOL))
        n = new Tn.default(Tn.default.TYPE_SYMBOL, this.prevToken.value);
      else if (this.accept(Zn.default.TYPE_NUMBER))
        n = new Tn.default(Tn.default.TYPE_NUMBER, parseFloat(this.prevToken.value));
      else if (this.accept(Zn.default.TYPE_COMMAND)) {
        var r = this.prevToken;
        n = new Tn.default(Tn.default.TYPE_FUNCTION, r.value), n.name = r.name;
        for (var i = 0; i < dWt.default[r.name]; i++)
          n.addChild(this.val());
      } else if (this.accept(Zn.default.TYPE_FUNCTION))
        if (n = new Tn.default(Tn.default.TYPE_FUNCTION, this.prevToken.value), n.name = this.prevToken.name, this.accept(Zn.default.TYPE_LPAREN)) {
          for (n.addChild(this.sum()); this.accept(Zn.default.TYPE_COMMA); )
            n.addChild(this.sum());
          this.expect(Zn.default.TYPE_RPAREN);
        } else
          n.addChild(this.power());
      else if (this.accept(Zn.default.TYPE_MINUS))
        n = new Tn.default(Tn.default.TYPE_NEGATE).addChild(this.power());
      else if (this.accept(Zn.default.TYPE_LPAREN))
        n = this.sum(), this.expect(Zn.default.TYPE_RPAREN);
      else if (this.accept(Zn.default.TYPE_ABS))
        n = new Tn.default(Tn.default.TYPE_FUNCTION, Math.abs), n.addChild(this.sum()), this.expect(Zn.default.TYPE_ABS);
      else
        throw "Unexpected " + this.currentToken.toString() + " at token " + this.cursor;
      if (this.accept(Zn.default.TYPE_BANG)) {
        var a = new Tn.default(Tn.default.TYPE_FUNCTION, fWt.fact);
        return a.addChild(n), a;
      }
      return n;
    }
  }, {
    key: "currentToken",
    get: function() {
      return this.tokens[this.cursor];
    }
  }, {
    key: "prevToken",
    get: function() {
      return this.tokens[this.cursor - 1];
    }
  }]), t;
}();
Object.defineProperty(nre, "__esModule", {
  value: !0
});
var yWt = nre.default = kWt, gWt = FL, vWt = ire(gWt), bWt = VL, wWt = ire(bWt);
function ire(t) {
  return t && t.__esModule ? t : { default: t };
}
function kWt(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = (0, vWt.default)(t, e, n), i = (0, wWt.default)(r).simplify(), a = function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return i.evaluate(s);
  };
  return a.ast = i, a.expression = t, a.tokens = r, a;
}
function are() {
  const t = [
    "A",
    "B",
    "C",
    "D",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
  ];
  let n = "";
  for (let r = 1; r <= 36; r++) {
    const i = t[Math.floor(Math.random() * t.length)];
    Math.random() > 0.5 ? n += i.toLowerCase() : n += i;
  }
  return n;
}
function _O(t, e, n) {
  try {
    const r = /\\pi({})?/g;
    let i = t.replace(r, "{PI}").trim(), a;
    const s = /^(.*)\s*:=\s*/.exec(i);
    s && s[0] && (i = i.substring(s[0].length), a = s[1].trim());
    const l = i.split("=");
    l[l.length - 1].length > 0 ? i = l[l.length - 1] : l.length >= 2 && (i = l[l.length - 2]);
    const c = {};
    let u, d = [];
    a && (d = xWt(a)), i = E1(i.replace("}", "}")), console.log({ aliases: d, changedLatex: i, variables: e });
    for (const m in e) {
      const g = e[m];
      c[m] = g.value;
      for (const v of g.aliases) {
        const k = v.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), w = new RegExp("(^|(?<=[^a-zA-Z]))" + k + "($|(?=[^a-zA-Z]))", "g");
        console.log("changedLatex before", i), i = i.replace(w, m), console.log("changedLatex after", i);
        for (const b of d)
          v === b && (u = m);
      }
    }
    const f = yWt(i, {}, { latex: !0 }), h = new Set(f.tokens.filter((m) => m.type === "SYMBOL").map((m) => m.value));
    console.log({ usedVars: h, res: f });
    const p = f(c);
    if (a !== void 0) {
      if (u === void 0 && (u = are()), h.has(u))
        return;
      e[u] = {
        value: p,
        aliases: d
      };
      const m = n[u];
      if (m != null)
        for (const g of m)
          g.onUpdate();
    }
    return {
      definedVariableID: u,
      variablesUsed: h,
      result: p
    };
  } catch (r) {
    console.log(r);
    return;
  }
}
function xWt(t) {
  return [E1(t), E1(t, !0)];
}
function ore(t, e = !1) {
  t = t.trim();
  let n = "main", r = 0, i = !1, a = "", o = "", s = "", l = "", c = !1;
  for (const h of t) {
    let p = !0;
    h === "\\" ? (!i && r === 0 && (c = !0), i = !i) : i = !1, h === " " && r === 0 && (c = !1), i || (h === "_" && r === 0 && n === "main" && (n = "sub", p = !1), h === "^" && r === 0 && n === "main" && (n = "sup", p = !1), h === "{" && r++, h === "}" && (r--, r === 0 && (c = !1))), n === "main" && h === " " && r === 0 && (n = "after", p = !1), n === "main" && h === "\\" && r === 0 && a != "" && (n = "after"), p && (n === "main" ? a += h : n === "sub" ? s += h : n === "sup" ? o += h : n === "after" && (l += h), (n === "sub" || n == "sup") && r === 0 && !c && (n = "main"));
  }
  o.startsWith("{") && o.endsWith("}") && (o = o.substring(1, o.length - 1)), s.startsWith("{") && s.endsWith("}") && (s = s.substring(1, s.length - 1));
  let u = s.trim(), d = o.trim();
  e && u.indexOf(" ") === -1 ? u = s !== "" ? `_${u}` : "" : u = s !== "" ? `_{${u}}` : "", e && d.indexOf(" ") === -1 ? d = o !== "" ? `^${o.trim()}` : "" : d = o !== "" ? `^{${o.trim()}}` : "";
  const f = l !== "" ? " " + ore(l) : "";
  return `${a}${u}${d}${f}`;
}
function E1(t, e = !1) {
  if (t = t.trim(), t.startsWith("{") && t.endsWith("}"))
    return E1(t.substring(1, t.length - 1));
  const n = /(?![^\\])\\color{\w*}/g;
  if (n.test(t))
    return E1(t.replace(n, " "));
  const r = /\\textcolor{\w*}/g;
  return r.test(t) ? E1(t.replace(r, " ")) : ore(t, e);
}
function MWt(t, e, n, r, i) {
  let a = _O(t, i.variables, i.variableListeners);
  const o = () => {
    var s;
    a != null && a.result ? ((s = a.result.toString().split(".")[1]) === null || s === void 0 ? void 0 : s.length) > 5 ? n.innerText = "=" + a.result.toFixed(4) : n.innerText = "=" + a.result.toString() : n.innerText = "=Error", r ? n.style.display = "inline-block" : n.style.display = "none";
  };
  if (o(), a != null && a.variablesUsed)
    for (const s of a.variablesUsed) {
      let l = i.variableListeners[s];
      l == null && (l = []), l.push({
        id: e,
        onUpdate: () => {
          a = _O(t, i.variables, i.variableListeners), o();
        }
      }), i.variableListeners[s] = l;
    }
  return a;
}
const sre = { addInlineMath: !0, evaluation: !1, delimiters: "dollar" }, CWt = Ht.create({
  name: "inlineMath",
  group: "inline",
  inline: !0,
  selectable: !0,
  atom: !0,
  addOptions() {
    return sre;
  },
  addAttributes() {
    return {
      latex: {
        default: "x_1",
        parseHTML: (t) => t.getAttribute("data-latex"),
        renderHTML: (t) => ({
          "data-latex": t.latex
        })
      },
      evaluate: {
        default: "no",
        parseHTML: (t) => t.getAttribute("data-evaluate"),
        renderHTML: (t) => ({
          "data-evaluate": t.evaluate
        })
      },
      display: {
        default: "no",
        parseHTML: (t) => t.getAttribute("data-display"),
        renderHTML: (t) => ({
          "data-display": t.display
        })
      }
    };
  },
  addInputRules() {
    const t = [], e = j4("block", this.options);
    e !== void 0 && t.push(new Wi({
      find: new RegExp(e, ""),
      handler: (r) => {
        let i = r.match[1];
        if (r.match[1].length === 0)
          return;
        const a = i.endsWith("=");
        a && (i = i.substring(0, i.length - 1));
        let o = [
          {
            type: "inlineMath",
            attrs: { latex: i, evaluate: a ? "yes" : "no", display: "yes" }
          }
        ];
        r.chain().insertContentAt({
          from: r.range.from,
          to: r.range.to
        }, o, { updateSelection: !0 }).run();
      }
    }));
    const n = j4("inline", this.options);
    return n !== void 0 && t.push(new Wi({
      find: new RegExp(n, ""),
      handler: (r) => {
        if (console.log({ props: r }), r.match[1].length === 0 || (this.options.delimiters === void 0 || this.options.delimiters === "dollar") && (r.match[1].startsWith("$") || r.match[0].startsWith("$$")))
          return;
        let i = r.match[1];
        i = i.trim();
        const a = i.endsWith("=");
        a && (i = i.substring(0, i.length - 1));
        let o = [
          {
            type: "inlineMath",
            attrs: { latex: i, evaluate: a ? "yes" : "no", display: "no" }
          }
        ];
        r.chain().insertContentAt({
          from: r.range.from,
          to: r.range.to
        }, o, { updateSelection: !0 }).run();
      }
    })), t;
  },
  addPasteRules() {
    const t = [], e = j4("block", this.options);
    e !== void 0 && t.push(new g7({
      find: new RegExp(e, "g"),
      handler: (r) => {
        const i = r.match[1];
        r.chain().insertContentAt({ from: r.range.from, to: r.range.to }, [
          {
            type: "inlineMath",
            attrs: { latex: i, evaluate: "no", display: "yes" }
          }
        ], { updateSelection: !0 }).run();
      }
    }));
    const n = j4("inline", this.options);
    return n !== void 0 && t.push(new g7({
      find: new RegExp(n, "g"),
      handler: (r) => {
        const i = r.match[1];
        r.chain().insertContentAt({ from: r.range.from, to: r.range.to }, [
          {
            type: "inlineMath",
            attrs: { latex: i, evaluate: "no", display: "no" }
          }
        ], { updateSelection: !0 }).run();
      }
    })), t;
  },
  parseHTML() {
    return [
      {
        tag: `span[data-type="${this.name}"]`
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    let n = "x";
    return t.attrs.latex && typeof t.attrs.latex == "string" && (n = t.attrs.latex), [
      "span",
      _t(e, {
        "data-type": this.name
      }),
      N4(t.attrs.display === "yes" ? "block" : "inline", "start", this.options) + n + N4(t.attrs.display === "yes" ? "block" : "inline", "end", this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      Backspace: () => this.editor.commands.command(({ tr: t, state: e }) => {
        let n = !1;
        const { selection: r } = e, { empty: i, anchor: a } = r;
        return i ? (e.doc.nodesBetween(a - 1, a, (o, s) => {
          if (o.type.name === this.name) {
            n = !0;
            const l = o.attrs.display === "yes", c = N4(l ? "block" : "inline", "start", this.options);
            let u = N4(l ? "block" : "inline", "end", this.options);
            u = u.substring(0, u.length - 1), t.insertText(c + (o.attrs.latex || "") + u, s, a);
          }
        }), n) : !1;
      })
    };
  },
  addNodeView() {
    return ({ HTMLAttributes: t, node: e, getPos: n, editor: r }) => {
      var i;
      const a = document.createElement("span"), o = document.createElement("span");
      a.appendChild(o);
      let s = "x_1";
      "data-latex" in t && typeof t["data-latex"] == "string" && (s = t["data-latex"]);
      let l = e.attrs.display === "yes";
      LUt.render(s, o, Object.assign({ displayMode: l, throwOnError: !1 }, (i = this.options.katexOptions) !== null && i !== void 0 ? i : {})), a.classList.add("tiptap-math", "latex");
      let c = e.attrs.evaluate === "yes";
      const u = are();
      if (this.options.evaluation) {
        a.title = "Click to toggle result", a.style.cursor = "pointer";
        const f = document.createElement("span");
        a.append(f), f.classList.add("tiptap-math", "result"), f.classList.add("katex");
        const h = MWt(s, u, f, c, this.editor.storage.inlineMath);
        return a.addEventListener("click", (p) => {
          r.isEditable && typeof n == "function" && r.chain().command(({ tr: m }) => {
            const g = n();
            return m.setNodeAttribute(g, "evaluate", c ? "no" : "yes"), !0;
          }).run(), p.preventDefault(), p.stopPropagation(), p.stopImmediatePropagation();
        }), {
          dom: a,
          destroy: () => {
            if (h != null && h.variablesUsed)
              for (const p of h.variablesUsed) {
                let m = this.editor.storage.inlineMath.variableListeners[p];
                m == null && (m = []), this.editor.storage.inlineMath.variableListeners[p] = m.filter((g) => g.id !== u);
              }
          }
        };
      } else
        return {
          dom: a
        };
    };
  },
  addStorage() {
    return {
      variables: {},
      variableListeners: {}
    };
  }
});
function j4(t, e) {
  return e.delimiters === void 0 || e.delimiters === "dollar" ? t === "inline" ? String.raw`(?<!\$)\$(?![$\s,.])((?:[^$\\]|\\\$|\\)+?(?<![\\\s(["]))\$` : String.raw`\$\$(?!\s)(.*?(?<!\\))\$\$` : e.delimiters === "bracket" ? t === "inline" ? String.raw`\\\((.*?[^\\])\\\)` : String.raw`\\\[(.*?[^\\])\\\]` : t === "inline" ? e.delimiters.inlineRegex : e.delimiters.blockRegex;
}
function N4(t, e, n) {
  var r, i, a, o;
  return n.delimiters === void 0 || n.delimiters === "dollar" ? t === "inline" ? "$" : "$$" : n.delimiters === "bracket" ? t === "inline" ? e === "start" ? String.raw`\(` : String.raw`\)` : e === "start" ? String.raw`\[` : String.raw`\]` : t === "inline" ? e === "start" ? (r = n.delimiters.inlineStart) !== null && r !== void 0 ? r : "$" : (i = n.delimiters.inlineEnd) !== null && i !== void 0 ? i : "$" : e === "start" ? (a = n.delimiters.blockStart) !== null && a !== void 0 ? a : "$$" : (o = n.delimiters.blockEnd) !== null && o !== void 0 ? o : "$$";
}
const AWt = "mathExtension", SWt = ln.create({
  name: AWt,
  addOptions() {
    return sre;
  },
  addExtensions() {
    const t = [];
    return this.options.addInlineMath !== !1 && t.push(CWt.configure(this.options)), t;
  }
}), LWt = Ht.create({
  name: "footnote",
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      {
        tag: "footnote"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["footnote", _t(t), 0];
  }
});
Ht.create({
  name: "footnoteRef",
  group: "inline",
  inline: !0,
  atom: !0,
  addAttributes() {
    return {
      id: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "footnote-ref"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["footnote-ref", _t(t)];
  }
});
const TWt = ir.create({
  name: "superscript",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "sup"
      },
      {
        style: "vertical-align",
        getAttrs(t) {
          return t !== "super" ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["sup", _t(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setSuperscript: () => ({ commands: t }) => t.setMark(this.name),
      toggleSuperscript: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetSuperscript: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-.": () => this.editor.commands.toggleSuperscript()
    };
  }
}), EWt = ir.create({
  name: "subscript",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "sub"
      },
      {
        style: "vertical-align",
        getAttrs(t) {
          return t !== "sub" ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["sub", _t(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setSubscript: () => ({ commands: t }) => t.setMark(this.name),
      toggleSubscript: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetSubscript: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-,": () => this.editor.commands.toggleSubscript()
    };
  }
}), jWt = (t, e, n) => new Wt({
  key: new tn("media-paste-drop"),
  props: {
    handlePaste(r, i) {
      var u, d;
      const a = Array.from(((u = i.clipboardData) == null ? void 0 : u.items) || []), o = (d = i.clipboardData) == null ? void 0 : d.files, s = r.state.selection.from;
      if (!s)
        return !1;
      const l = n ? qs.Extended : qs.Base;
      return Object.values(o ?? {}).some(
        (f) => (f == null ? void 0 : f.type.indexOf("image")) === 0
      ) && n ? (Object.values(o ?? {}).forEach((f) => {
        if ((f == null ? void 0 : f.type.indexOf("image")) === 0) {
          if (!i2(f, e))
            return;
          if (f.size > l.maxSize)
            throw e(l.errorMsg), new Error(l.errorMsg);
          e2(f, r, s, n);
        }
      }), !0) : (a.forEach((f) => {
        const h = f.getAsFile();
        if (((h == null ? void 0 : h.type.indexOf("image")) === 0 || (h == null ? void 0 : h.type.indexOf("video")) === 0) && (i.preventDefault(), h && h.size > l.maxSize))
          throw e(l.errorMsg), new Error(l.errorMsg);
      }), !1);
    },
    handleDrop(r, i) {
      var c;
      if (!(i.dataTransfer && i.dataTransfer.files && i.dataTransfer.files.length))
        return !1;
      const o = Array.from(
        ((c = i.dataTransfer) == null ? void 0 : c.files) ?? []
      ).filter(({ type: u }) => /image|video/i.test(u));
      if (o.length === 0) return !1;
      i.preventDefault();
      const { schema: s } = r.state, l = r.posAtCoords({
        left: i.clientX,
        top: i.clientY
      });
      return l ? (o.forEach(async (u) => {
        const d = new FileReader();
        if (i2(u, e))
          if (typeof t == "function")
            try {
              e2(
                u,
                r,
                l.pos,
                n
              );
            } catch (f) {
              throw e(f.message || "Error uploading media"), new Error(
                f.message || "Error uploading media"
              );
            }
          else
            d.onload = (f) => {
              var m;
              const h = s.nodes.resizableMedia.create({
                src: (m = f.target) == null ? void 0 : m.result,
                "media-type": u.type.includes("image") ? "img" : "video"
              }), p = r.state.tr.insert(l.pos, h);
              r.dispatch(p);
            }, d.readAsDataURL(u);
      }), !0) : !1;
    }
  }
}), NWt = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, DWt = /!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\)/, IWt = Ht.create({
  name: "resizableMedia",
  addOptions() {
    return {
      HTMLAttributes: {
        class: "rounded-lg border color-border-default"
      },
      uploadFn: async () => "",
      onError: () => {
        console.error("Error uploading media");
      },
      secureImageUploadUrl: ""
    };
  },
  inline: !1,
  group: "block",
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      "media-type": {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: "100%"
      },
      height: {
        default: "auto"
      },
      dataAlign: {
        default: "center"
        // 'left' | 'center' | 'right'
      },
      dataFloat: {
        default: null
        // 'left' | 'right'
      },
      encryptedKey: { default: null },
      url: { default: null },
      iv: { default: null },
      privateKey: { default: null },
      caption: { default: null },
      showCaptionInput: { default: !1 }
      // TODO: For figure caption later
      // caption: {
      //   default: null,
      // },
    };
  },
  selectable: !0,
  parseHTML() {
    return [
      {
        tag: "img",
        getAttrs: (t) => ({
          src: t.getAttribute("src"),
          "media-type": "img"
        })
      },
      {
        tag: "video",
        getAttrs: (t) => ({
          src: t.getAttribute("src"),
          "media-type": "video"
        })
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    const { "media-type": e } = t;
    return e === "img" ? [
      "img",
      _t(this.options.HTMLAttributes, t)
    ] : e === "secure-img" ? [
      "img",
      _t(this.options.HTMLAttributes, t)
    ] : e === "video" ? [
      "video",
      { controls: "true", style: "width: 100%", ...t },
      ["source", t]
    ] : (e || console.error(
      "TiptapMediaExtension-renderHTML method: Media Type not set, going default with image"
    ), [
      "img",
      _t(this.options.HTMLAttributes, t)
    ]);
  },
  addCommands() {
    return {
      setMedia: (t) => ({ commands: e }) => {
        const { "media-type": n } = t;
        return n === "img" ? e.insertContent({
          type: this.name,
          attrs: t
        }) : n === "video" ? e.insertContent({
          type: this.name,
          attrs: {
            ...t,
            controls: "true"
          }
        }) : (n || console.error(
          "TiptapMediaExtension-setMedia: Media Type not set, going default with image"
        ), e.insertContent({
          type: this.name,
          attrs: t
        }));
      }
    };
  },
  addNodeView() {
    return Hc(pte);
  },
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor: t }) => {
        const { selection: e } = t.state;
        if (e.empty)
          return !1;
        const n = e.$to.pos;
        return t.commands.insertContentAt(n, {
          type: "dBlock",
          content: [
            {
              type: "paragraph"
            }
          ]
        });
      }
    };
  },
  addInputRules() {
    return [
      x7({
        find: NWt,
        type: this.type,
        getAttributes: (t) => {
          const [, , e, n, r] = t;
          return {
            src: n,
            alt: e,
            title: r,
            "media-type": "img"
          };
        }
      }),
      x7({
        find: DWt,
        type: this.type,
        getAttributes: (t) => {
          const [, , e] = t;
          return {
            src: e,
            "media-type": "video"
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      jWt(
        this.options.uploadFn,
        this.options.onError,
        this.options.secureImageUploadUrl
      ),
      V3t()
    ];
  }
});
var _k, D4 = hg;
if (process.env.NODE_ENV === "production")
  _k = D4.createRoot, D4.hydrateRoot;
else {
  var VO = D4.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  _k = function(t, e) {
    VO.usingClientEntryPoint = !0;
    try {
      return D4.createRoot(t, e);
    } finally {
      VO.usingClientEntryPoint = !1;
    }
  };
}
const PWt = ({
  link: t,
  metadataProxyUrl: e,
  hoverEvent: n
}) => {
  const r = ja("(max-width:768px)"), [i, a] = De(null), [o, s] = De(!1), l = Ue(/* @__PURE__ */ new Map()), c = async (u) => {
    if (u) {
      if (l.current.has(u)) {
        a(l.current.get(u)), s(!1);
        return;
      }
      s(!0);
      try {
        const d = await fetch(
          `${e}/${encodeURIComponent(u)}`
        ), { metadata: f } = await d.json(), h = {
          title: f.title,
          description: f.description,
          image: f.image,
          favicon: f.favicon,
          link: u
        };
        l.current.set(u, h), a(h);
      } catch (d) {
        console.error("Error fetching link preview:", d), a(null);
      } finally {
        s(!1);
      }
    }
  };
  return ze(() => {
    t && c(t);
  }, [t]), ze(() => {
    const u = (d) => {
      d.detail ? l.current.has(t) ? (a(l.current.get(t)), s(!1)) : c(t) : (s(!0), a(null));
    };
    return n.addEventListener(
      "hoverStateChange",
      u
    ), () => {
      n.removeEventListener(
        "hoverStateChange",
        u
      );
    };
  }, [n, t]), r ? /* @__PURE__ */ C.jsx(C.Fragment, {}) : /* @__PURE__ */ C.jsx("div", { className: "w-[250px] border color-border-default shadow-elevation-3 rounded p-3 flex flex-col gap-2 justify-center hover-link-popup color-bg-default", children: o ? /* @__PURE__ */ C.jsx("p", { className: "text-helper-text-sm color-text-secondary", children: "Loading preview..." }) : i ? /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    i.image && /* @__PURE__ */ C.jsx(
      "img",
      {
        src: i.image,
        className: "w-[225px] h-[125px] object-contain rounded",
        alt: "Preview",
        onError: (u) => {
          u.currentTarget.style.display = "none";
        }
      }
    ),
    /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col gap-2", children: [
      (i.title || i.description) && /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col gap-[2px]", children: [
        i.title && /* @__PURE__ */ C.jsx("p", { className: "text-heading-xsm w-full truncate color-text-default select-text", children: i.title }),
        i.description && /* @__PURE__ */ C.jsx("p", { className: "text-helper-text-sm color-text-secondary w-full truncate select-text", children: i.description })
      ] }),
      /* @__PURE__ */ C.jsxs("div", { className: "flex gap-2", children: [
        i.favicon && /* @__PURE__ */ C.jsx(
          "img",
          {
            src: i.favicon,
            className: "w-[18px] aspect-square rounded",
            alt: "Favicon",
            onError: (u) => {
              u.currentTarget.style.display = "none";
            }
          }
        ),
        i.link && /* @__PURE__ */ C.jsx(
          "a",
          {
            href: i.link,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "text-helper-text-sm color-text-link w-full truncate hover:underline hover:cursor-pointer",
            children: i.link
          }
        )
      ] })
    ] })
  ] }) : /* @__PURE__ */ C.jsx("p", { className: "text-helper-text-sm color-text-secondary", children: "No preview available" }) });
}, zWt = ln.create({
  name: "linkPreview",
  addProseMirrorPlugins() {
    if (!this.options.metadataProxyUrl) return [];
    const t = new tn("link-preview");
    let e = null, n = null, r = null, i = null, a = null;
    const o = new EventTarget();
    return [
      new Wt({
        key: t,
        props: {
          handleDOMEvents: {
            mouseover: (s, l) => {
              const c = l.target, u = c.closest("a");
              if (!u && e && !e.contains(c) && c !== e && (i && clearTimeout(i), a && clearTimeout(a), a = setTimeout(() => {
                e && (e.style.display = "none", o.dispatchEvent(
                  new CustomEvent("hoverStateChange", { detail: !1 })
                ));
              }, 100)), u) {
                const d = u.getAttribute("href");
                if (!d) return !1;
                i && clearTimeout(i), a && clearTimeout(a), r = u, i = setTimeout(() => {
                  if (!r) return;
                  const f = r.getBoundingClientRect();
                  e || (e = document.createElement("div"), e.className = "hover-link-popup", e.style.position = "absolute", e.style.zIndex = "999", document.body.appendChild(e)), e.style.left = `${f.left}px`, e.style.top = `${f.bottom + 5}px`, e.style.display = "block", n || (n = _k(e)), n.render(
                    /* @__PURE__ */ C.jsx(
                      PWt,
                      {
                        link: d,
                        metadataProxyUrl: this.options.metadataProxyUrl,
                        hoverEvent: o
                      }
                    )
                  ), o.dispatchEvent(
                    new CustomEvent("hoverStateChange", { detail: !0 })
                  );
                }, 600);
              }
              return !1;
            },
            mouseout: (s, l) => {
              const c = l.relatedTarget;
              return i && clearTimeout(i), i = null, a && clearTimeout(a), a = setTimeout(() => {
                e && (!c || !e.contains(c) && c !== e) && (e.style.display = "none", o.dispatchEvent(
                  new CustomEvent("hoverStateChange", { detail: !1 })
                ));
              }, 100), !1;
            }
          }
        },
        view() {
          return {
            destroy() {
              e && (n == null || n.unmount(), e.remove(), e = null, n = null), i && clearTimeout(i), a && clearTimeout(a);
            }
          };
        }
      })
    ];
  }
}), lre = (t, e, n, r) => [
  wzt,
  vzt.configure({
    strike: {
      HTMLAttributes: {
        class: "select-text pointer-events-auto"
      }
    },
    bold: {
      HTMLAttributes: {
        class: "select-text pointer-events-auto"
      }
    },
    italic: {
      HTMLAttributes: {
        class: "select-text pointer-events-auto"
      }
    },
    heading: {
      HTMLAttributes: {
        class: "select-text pointer-events-auto"
      }
    },
    paragraph: {
      HTMLAttributes: {
        class: "select-text pointer-events-auto"
      }
    },
    orderedList: {
      HTMLAttributes: {
        class: "flex flex-col items-start list-decimal list-outside space-y-2 !ml-[1.25rem]"
      }
    },
    blockquote: {
      HTMLAttributes: {
        class: "pl-4 border-l-4 color-border-default italic color-text-secondary my-2"
      }
    },
    codeBlock: {
      HTMLAttributes: {
        class: "rounded-lg bg-transparent border color-border-default p-5 font-mono font-medium color-text-default select-text pointer-events-auto"
      },
      exitOnArrowDown: !0
    },
    code: {
      HTMLAttributes: {
        class: "rounded bg-transparent p-1.5 font-mono font-medium color-text-default text-body-sm",
        spellcheck: "false"
      }
    },
    history: !1,
    gapcursor: !1,
    dropcursor: !1,
    document: !1,
    horizontalRule: !1,
    bulletList: !1,
    listItem: !1
  }),
  AVt,
  kzt.configure({
    types: ["heading", "paragraph"]
  }),
  Xzt,
  Uzt.extend({
    exitable: !0,
    inclusive: !1
  }).configure({
    HTMLAttributes: {
      class: "custom-text-link",
      rel: "noopener noreferrer"
    },
    validate: (i) => /^https?:\/\//.test(i),
    openOnClick: !0,
    autolink: !0
  }),
  Wzt.configure({
    placeholder: () => "",
    includeChildren: !0,
    showOnlyCurrent: !0
  }),
  Yzt.configure({ multicolor: !0 }),
  Qzt.configure({
    HTMLAttributes: {
      class: "select-text pointer-events-auto"
    }
  }),
  bzt,
  nRt,
  Kzt.configure({
    HTMLAttributes: {
      class: "not-prose space-y-2 !ml-0"
    }
  }),
  Jzt.configure({
    HTMLAttributes: {
      class: "flex items-start"
    },
    nested: !0
  }),
  PFt.configure({
    HTMLAttributes: {
      class: "not-prose space-y-2 !ml-[1.25rem]"
    }
  }),
  ite.configure({
    HTMLAttributes: {
      class: "leading-normal w-full"
    }
  }),
  Jee.configure({
    width: 3,
    color: "#d1d5db"
  }),
  IWt.configure({
    uploadFn: q3t,
    onError: t,
    secureImageUploadUrl: e
  }),
  Qee,
  pHt.configure({
    secureImageUploadUrl: e,
    onCopyHeadingLink: r
  }),
  jFt,
  EFt,
  ...TFt,
  tRt,
  iRt,
  KBt,
  DFt,
  eRt,
  kMt(e),
  nVt.configure({
    html: !0,
    // Allow HTML input/output
    tightLists: !0,
    // No <p> inside <li> in markdown output
    tightListClass: "tight",
    // Add class to <ul> allowing you to remove <p> margins when tight
    bulletListMarker: "-",
    // <li> prefix in markdown output
    linkify: !0,
    // Create links from "https://..." text
    breaks: !0,
    // New lines (\n) in markdown input are converted to <br>
    transformPastedText: !0
    // Allow to paste markdown text in the editor
    // transformCopiedText: true, // Copied text is transformed to markdown
  }),
  SVt,
  SWt.configure({
    addInlineMath: !0,
    evaluation: !1,
    delimiters: "dollar",
    katexOptions: {
      throwOnError: !1,
      strict: !0
    }
  }),
  LWt,
  TWt.configure({
    HTMLAttributes: {
      class: "superscript"
    }
  }),
  EWt.configure({
    HTMLAttributes: {
      class: "subscript"
    }
  }),
  zWt.configure({
    metadataProxyUrl: n
  })
], RWt = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE/SURBVHgBhVJBTsJQEH3zMcElR+gRuIF6gwYPAOwkLoQTUE6ArEA3xbWJ4gnQE8gNwBuwhMR2fPNLk9o0ZZImM/P/e39e3wgqojPXXiPFJnFovw1kWT53xSKca3C70LXlr/eySYFdZ6Fb61eCePnBCb6VF3P21UA+WX+wv+086fgfyMbh4aPlqWJSZH2/k6EINlBEJI6tdxHG2tIDrsUqxYzsO5Qi+UXfNfwUPT7w49wRU1EyZWNFqIgV9REw84Wga+P1Uj7PsW5QE9pEZMT8Aq+JQmNcYl8HwgEtEvf9fc3RR4zrMCRe84WA6dJRz8upPwyftV0FOP3ugHqu0iZGzsSbF3bYUMRlgDdWMcyE4WvVl73XRC9CNiaqaHMDpkUQrYh8kmKUmy5lVpvdBNs2mOk0tptk9a5AVKHhzML+AZaSjR/r++n9AAAAAElFTkSuQmCC", OWt = (t) => {
  const e = document.createElement("span");
  e.classList.add("collaboration-cursor__caret"), e.setAttribute("style", `border-color: ${t.color}`);
  const n = document.createElement("div");
  return n.classList.add("collaboration-cursor__label"), n.setAttribute("style", `background-color: ${t.color}`), n.insertBefore(document.createTextNode(t.name), null), e.insertBefore(n, null), e;
}, BWt = (t) => {
  const e = document.createElement("span");
  e.classList.add("custom-cursor__caret"), e.setAttribute("style", `border-color: ${t.color}`);
  const n = document.createElement("div");
  n.classList.add("custom-cursor__label-container"), n.setAttribute("style", `border: 1px solid ${t.color}`);
  const r = document.createElement("img");
  r.src = RWt, r.classList.add("custom-cursor__icon");
  const i = document.createElement("div");
  i.classList.add("custom-cursor__label");
  const a = document.createElement("span");
  a.classList.add("custom-cursor__text"), a.textContent = t.name;
  const o = document.createElement("img");
  return o.src = OA, o.classList.add("custom-cursor__badge"), i.appendChild(a), n.appendChild(r), n.appendChild(i), n.appendChild(o), e.appendChild(n), e;
}, HWt = (t) => t.isEns ? BWt(t) : OWt(t), FWt = ({
  query: t,
  onError: e,
  secureImageUploadUrl: n
}) => [
  {
    title: "Text",
    description: "Just start typing with plain text.",
    searchTerms: ["p", "paragraph"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "Text", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => {
      r.chain().focus().deleteRange(i).toggleNode("paragraph", "paragraph").run();
    }
  },
  {
    title: "To-do List",
    description: "Track tasks with a to-do list.",
    searchTerms: ["todo", "task", "list", "check", "checkbox"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "ListChecks", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => {
      r.chain().focus().deleteRange(i).toggleTaskList().run();
    }
  },
  {
    title: "Heading 1",
    description: "Big section heading.",
    searchTerms: ["title", "big", "large"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "Heading1", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => {
      r.chain().focus().deleteRange(i).setNode("heading", { level: 1 }).run();
    }
  },
  {
    title: "Heading 2",
    description: "Medium section heading.",
    searchTerms: ["subtitle", "medium"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "Heading2", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => {
      r.chain().focus().deleteRange(i).setNode("heading", { level: 2 }).run();
    }
  },
  {
    title: "Heading 3",
    description: "Small section heading.",
    searchTerms: ["subtitle", "small"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "Heading3", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => {
      r.chain().focus().deleteRange(i).setNode("heading", { level: 3 }).run();
    }
  },
  {
    title: "Bullet List",
    description: "Create a simple bullet list.",
    searchTerms: ["unordered", "point"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "List", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => {
      r.chain().focus().deleteRange(i).toggleBulletList().run();
    }
  },
  {
    title: "Numbered List",
    description: "Create a list with numbering.",
    searchTerms: ["ordered"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "ListOrdered", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => {
      r.chain().focus().deleteRange(i).toggleOrderedList().run();
    }
  },
  {
    title: "Page breaker",
    description: "Insert page break that will split your document into pages.",
    searchTerms: ["pagebreak", "break", "line", "page"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "PageBreak", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => {
      r.chain().focus().deleteRange(i).setPageBreak().run();
    }
  },
  {
    title: "Divider",
    description: "Visually divide content.",
    searchTerms: ["hr", "divider", "break", "line", "delimiter"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "Minus", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => {
      r.chain().focus().deleteRange(i).setHorizontalRule().run();
    }
  },
  {
    title: "Quote",
    description: "Capture a quote.",
    searchTerms: ["blockquote"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "TextQuote", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => r.chain().focus().deleteRange(i).toggleNode("paragraph", "paragraph").toggleBlockquote().run()
  },
  {
    title: "Code",
    description: "Capture a code snippet.",
    searchTerms: ["codeblock"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "Code", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => r.chain().focus().deleteRange(i).toggleCodeBlock().run()
  },
  {
    title: "Table",
    description: "Create a table.",
    searchTerms: ["table"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "Table", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => r.chain().focus().deleteRange(i).insertTable({ rows: 3, cols: 2, withHeaderRow: !0 }).run()
  },
  {
    title: "Image",
    description: "Upload an image from your computer.",
    searchTerms: ["photo", "picture", "media"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "ImageUp", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => {
      r.chain().focus().deleteRange(i).run();
      const a = document.createElement("input");
      a.type = "file", a.accept = "image/png, image/jpeg, image/gif", a.onchange = async () => {
        var o;
        if ((o = a.files) != null && o.length) {
          const s = a.files[0];
          if (!i2(s, e))
            return;
          const l = s.size, c = n ? qs.Extended : qs.Base;
          if (l > c.maxSize) {
            e && typeof e == "function" && e(c.errorMsg);
            return;
          }
          const u = r.view.state.selection.from;
          e2(s, r.view, u, n);
        }
      }, a.click();
    }
  },
  {
    title: "Video Embed",
    description: "Embed a video from YouTube, Vimeo, etc.",
    searchTerms: ["iframe", "embed", "video", "youtube"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "Youtube", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => {
      r.chain().focus().deleteRange(i).setActionButton("iframe").run();
    }
  },
  {
    title: "Twitter",
    description: "Embed a Twitter tweet.",
    searchTerms: ["embed", "twitter", "tweet"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "XSocial", size: "md" }),
    image: "",
    command: ({ editor: r, range: i }) => {
      r.chain().focus().deleteRange(i).setActionButton("twitter").run();
    }
  },
  {
    title: "2 Columns",
    description: "Create 2 columns of block",
    searchTerms: ["col", "column", "2", "layout"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "Columns2", size: "md" }),
    image: "",
    command: ({ editor: r }) => {
      r.chain().focus().setColumns(2).focus(r.state.selection.head - 1).run();
    }
  },
  {
    title: "3 Columns",
    description: "Create 3 columns of block",
    searchTerms: ["col", "column", "3", "layout"],
    icon: /* @__PURE__ */ C.jsx(Ye, { name: "Columns3", size: "md" }),
    image: "",
    command: ({ editor: r }) => {
      r.chain().focus().setColumns(3).focus(r.state.selection.head - 1).run();
    }
  }
].filter((r) => {
  if (typeof t == "string" && t.length > 0) {
    const i = t.toLowerCase();
    return r.title.toLowerCase().includes(i) || r.description.toLowerCase().includes(i) || r.searchTerms && r.searchTerms.some((a) => a.includes(i));
  }
  return !0;
}), _Wt = (t, e) => {
  const n = t.offsetHeight, r = e ? e.offsetHeight : 0, i = e.offsetTop, a = i + r;
  i < t.scrollTop ? t.scrollTop -= t.scrollTop - i + 5 : a > n + t.scrollTop && (t.scrollTop += a - n - t.scrollTop + 5);
};
function VWt(t) {
  var e;
  const { char: n, allowSpaces: r, allowedPrefixes: i, startOfLine: a, $position: o } = t, s = tle(n), l = new RegExp(`\\s${s}$`), c = a ? "^" : "", u = r ? new RegExp(`${c}${s}.*?(?=\\s${s}|$)`, "gm") : new RegExp(`${c}(?:^)?${s}[^\\s${s}]*`, "gm"), d = ((e = o.nodeBefore) === null || e === void 0 ? void 0 : e.isText) && o.nodeBefore.text;
  if (!d)
    return null;
  const f = o.pos - d.length, h = Array.from(d.matchAll(u)).pop();
  if (!h || h.input === void 0 || h.index === void 0)
    return null;
  const p = h.input.slice(Math.max(0, h.index - 1), h.index), m = new RegExp(`^[${i == null ? void 0 : i.join("")}\0]?$`).test(p);
  if (i !== null && !m)
    return null;
  const g = f + h.index;
  let v = g + h[0].length;
  return r && l.test(d.slice(v - 1, v + 1)) && (h[0] += " ", v += 1), g < o.pos && v >= o.pos ? {
    range: {
      from: g,
      to: v
    },
    query: h[0].slice(n.length),
    text: h[0]
  } : null;
}
const qWt = new tn("suggestion");
function UWt({ pluginKey: t = qWt, editor: e, char: n = "@", allowSpaces: r = !1, allowedPrefixes: i = [" "], startOfLine: a = !1, decorationTag: o = "span", decorationClass: s = "suggestion", command: l = () => null, items: c = () => [], render: u = () => ({}), allow: d = () => !0, findSuggestionMatch: f = VWt }) {
  let h;
  const p = u == null ? void 0 : u(), m = new Wt({
    key: t,
    view() {
      return {
        update: async (g, v) => {
          var k, w, b, x, A, L, M;
          const j = (k = this.key) === null || k === void 0 ? void 0 : k.getState(v), D = (w = this.key) === null || w === void 0 ? void 0 : w.getState(g.state), z = j.active && D.active && j.range.from !== D.range.from, H = !j.active && D.active, V = j.active && !D.active, F = !H && !V && j.query !== D.query, _ = H || z && F, W = F || z, G = V || z && F;
          if (!_ && !W && !G)
            return;
          const Y = G && !_ ? j : D, Z = g.dom.querySelector(`[data-decoration-id="${Y.decorationId}"]`);
          h = {
            editor: e,
            range: Y.range,
            query: Y.query,
            text: Y.text,
            items: [],
            command: (oe) => l({
              editor: e,
              range: Y.range,
              props: oe
            }),
            decorationNode: Z,
            // virtual node for popper.js or tippy.js
            // this can be used for building popups without a DOM node
            clientRect: Z ? () => {
              var oe;
              const { decorationId: ee } = (oe = this.key) === null || oe === void 0 ? void 0 : oe.getState(e.state), ae = g.dom.querySelector(`[data-decoration-id="${ee}"]`);
              return (ae == null ? void 0 : ae.getBoundingClientRect()) || null;
            } : null
          }, _ && ((b = p == null ? void 0 : p.onBeforeStart) === null || b === void 0 || b.call(p, h)), W && ((x = p == null ? void 0 : p.onBeforeUpdate) === null || x === void 0 || x.call(p, h)), (W || _) && (h.items = await c({
            editor: e,
            query: Y.query
          })), G && ((A = p == null ? void 0 : p.onExit) === null || A === void 0 || A.call(p, h)), W && ((L = p == null ? void 0 : p.onUpdate) === null || L === void 0 || L.call(p, h)), _ && ((M = p == null ? void 0 : p.onStart) === null || M === void 0 || M.call(p, h));
        },
        destroy: () => {
          var g;
          h && ((g = p == null ? void 0 : p.onExit) === null || g === void 0 || g.call(p, h));
        }
      };
    },
    state: {
      // Initialize the plugin's internal state.
      init() {
        return {
          active: !1,
          range: {
            from: 0,
            to: 0
          },
          query: null,
          text: null,
          composing: !1
        };
      },
      // Apply changes to the plugin state from a view transaction.
      apply(g, v, k, w) {
        const { isEditable: b } = e, { composing: x } = e.view, { selection: A } = g, { empty: L, from: M } = A, j = { ...v };
        if (j.composing = x, b && (L || e.view.composing)) {
          (M < v.range.from || M > v.range.to) && !x && !v.composing && (j.active = !1);
          const D = f({
            char: n,
            allowSpaces: r,
            allowedPrefixes: i,
            startOfLine: a,
            $position: A.$from
          }), z = `id_${Math.floor(Math.random() * 4294967295)}`;
          D && d({
            editor: e,
            state: w,
            range: D.range,
            isActive: v.active
          }) ? (j.active = !0, j.decorationId = v.decorationId ? v.decorationId : z, j.range = D.range, j.query = D.query, j.text = D.text) : j.active = !1;
        } else
          j.active = !1;
        return j.active || (j.decorationId = null, j.range = { from: 0, to: 0 }, j.query = null, j.text = null), j;
      }
    },
    props: {
      // Call the keydown hook if suggestion is active.
      handleKeyDown(g, v) {
        var k;
        const { active: w, range: b } = m.getState(g.state);
        return w && ((k = p == null ? void 0 : p.onKeyDown) === null || k === void 0 ? void 0 : k.call(p, { view: g, event: v, range: b })) || !1;
      },
      // Setup decorator on the currently active suggestion.
      decorations(g) {
        const { active: v, range: k, decorationId: w } = m.getState(g);
        return v ? vn.create(g.doc, [
          hr.inline(k.from, k.to, {
            nodeName: o,
            class: s,
            "data-decoration-id": w
          })
        ]) : null;
      }
    }
  });
  return m;
}
const WWt = ln.create({
  name: "slash-command",
  addOptions() {
    return {
      suggestion: {
        char: "/",
        command: ({
          editor: t,
          range: e,
          props: n
        }) => {
          n.command({ editor: t, range: e });
        }
      }
    };
  },
  addProseMirrorPlugins() {
    return [
      UWt({
        editor: this.editor,
        ...this.options.suggestion
      })
    ];
  }
}), ZWt = ({
  items: t,
  command: e,
  editor: n
}) => {
  const [r, i] = De(0), [a, o] = De(t), s = ja("(max-width: 640px)"), l = nt(
    (u) => {
      const d = a[u];
      d && (d.title === "Continue writing" || e(d));
    },
    [e, n, a]
  );
  ze(() => {
    if (s) {
      const u = t.filter(
        (d) => !["2 Columns", "3 Columns", "Twitter", "Video Embed"].includes(
          d.title
        )
      );
      o(u);
    } else
      o(t);
  }, [t, s]), ze(() => {
    const u = ["ArrowUp", "ArrowDown", "Enter"], d = (f) => {
      if (u.includes(f.key))
        return f.preventDefault(), f.key === "ArrowUp" ? (i((r + a.length - 1) % a.length), !0) : f.key === "ArrowDown" ? (i((r + 1) % a.length), !0) : f.key === "Enter" ? (l(r), !0) : !1;
    };
    return document.addEventListener("keydown", d), () => {
      document.removeEventListener("keydown", d);
    };
  }, [a, r, i, l]), ze(() => {
    i(0);
  }, [a]);
  const c = Ue(null);
  return us(() => {
    const u = c == null ? void 0 : c.current, d = u == null ? void 0 : u.children[r];
    d && u && _Wt(u, d);
  }, [r]), a.length > 0 ? /* @__PURE__ */ C.jsx(
    "div",
    {
      id: "slash-command",
      ref: c,
      className: "z-50 h-auto max-h-[330px] w-72 overflow-y-auto scroll-smooth rounded-lg border color-border-default color-bg-default p-2 shadow-elevation-3 transition-all",
      children: a.map((u, d) => /* @__PURE__ */ C.jsxs(
        "button",
        {
          className: be(
            "flex w-full items-center space-x-2 rounded-md px-2 py-1 text-left text-sm hover:color-bg-default-hover border border-transparent transition-all",
            d === r && "color-bg-default-hover"
          ),
          onClick: () => l(d),
          children: [
            /* @__PURE__ */ C.jsx("div", { className: "flex h-10 w-10 items-center justify-center rounded-md border color-border-default color-bg-default", children: u.icon }),
            /* @__PURE__ */ C.jsxs("div", { className: "flex-1 min-w-0", children: [
              /* @__PURE__ */ C.jsx("p", { className: "font-medium", children: u.title }),
              /* @__PURE__ */ C.jsx("p", { className: "text-xs text-neutral-500", children: u.description })
            ] })
          ]
        },
        d
      ))
    }
  ) : null;
}, GWt = () => {
  let t = null, e = null;
  return {
    onStart: (n) => {
      t = new bF(ZWt, {
        props: n,
        editor: n.editor
      }), e = w0("body", {
        getReferenceClientRect: n.clientRect,
        appendTo: () => document.body,
        content: t.element,
        showOnCreate: !0,
        interactive: !0,
        trigger: "manual",
        placement: "bottom-start"
      });
    },
    onUpdate: (n) => {
      t == null || t.updateProps(n), e && e[0].setProps({
        getReferenceClientRect: n.clientRect
      });
    },
    onKeyDown: (n) => {
      var r;
      return n.event.key === "Escape" ? (e == null || e[0].hide(), !0) : (r = t == null ? void 0 : t.ref) == null ? void 0 : r.onKeyDown(n);
    },
    onExit: () => {
      e == null || e[0].destroy(), t == null || t.destroy();
    }
  };
}, YWt = (t, e) => {
  const n = ({ query: r }) => FWt({ query: r, onError: t, secureImageUploadUrl: e });
  return WWt.configure({
    suggestion: {
      items: n,
      render: GWt
    }
  });
}, cre = ln.create({
  name: "customTextInputRules",
  addInputRules() {
    return [
      xt({
        find: /1st\s$/,
        replace: "1ˢᵗ "
      }),
      xt({
        find: /2nd\s$/,
        replace: "2ⁿᵈ "
      }),
      xt({
        find: /3rd\s$/,
        replace: "3ʳᵈ "
      }),
      xt({
        find: /4th\s$/,
        replace: "4ᵗʰ "
      }),
      xt({
        find: /5th\s$/,
        replace: "5ᵗʰ "
      }),
      xt({
        find: /6th\s$/,
        replace: "6ᵗʰ "
      }),
      xt({
        find: /7th\s$/,
        replace: "7ᵗʰ "
      }),
      xt({
        find: /8th\s$/,
        replace: "8ᵗʰ "
      }),
      xt({
        find: /9th\s$/,
        replace: "9ᵗʰ "
      }),
      xt({
        find: /10th\s$/,
        replace: "10ᵗʰ "
      }),
      xt({
        find: /11th\s$/,
        replace: "11ᵗʰ "
      }),
      xt({
        find: /12th\s$/,
        replace: "12ᵗʰ "
      }),
      xt({
        find: /13th\s$/,
        replace: "13ᵗʰ "
      }),
      xt({
        find: /14th\s$/,
        replace: "14ᵗʰ "
      }),
      xt({
        find: /15th\s$/,
        replace: "15ᵗʰ "
      }),
      xt({
        find: /16th\s$/,
        replace: "16ᵗʰ "
      }),
      xt({
        find: /17th\s$/,
        replace: "17ᵗʰ "
      }),
      xt({
        find: /18th\s$/,
        replace: "18ᵗʰ "
      }),
      xt({
        find: /19th\s$/,
        replace: "19ᵗʰ "
      }),
      xt({
        find: /20th\s$/,
        replace: "20ᵗʰ "
      }),
      xt({
        find: /21st\s$/,
        replace: "21ˢᵗ "
      }),
      xt({
        find: /22nd\s$/,
        replace: "22ⁿᵈ "
      }),
      xt({
        find: /23rd\s$/,
        replace: "23ʳᵈ "
      }),
      xt({
        find: /24th\s$/,
        replace: "24ᵗʰ "
      }),
      xt({
        find: /25th\s$/,
        replace: "25ᵗʰ "
      }),
      xt({
        find: /26th\s$/,
        replace: "26ᵗʰ "
      }),
      xt({
        find: /27th\s$/,
        replace: "27ᵗʰ "
      }),
      xt({
        find: /28th\s$/,
        replace: "28ᵗʰ "
      }),
      xt({
        find: /29th\s$/,
        replace: "29ᵗʰ "
      }),
      xt({
        find: /30th\s$/,
        replace: "30ᵗʰ "
      }),
      xt({
        find: /31st\s$/,
        replace: "31ˢᵗ "
      })
      // textInputRule({ find: /-___- $/, replace: '😑 ' }),
      // textInputRule({ find: /:'-\) $/, replace: '😂 ' }),
      // textInputRule({ find: /':-\) $/, replace: '😅 ' }),
      // textInputRule({ find: /':-D $/, replace: '😅 ' }),
      // textInputRule({ find: />:-\) $/, replace: '😆 ' }),
      // textInputRule({ find: /-__- $/, replace: '😑 ' }),
      // textInputRule({ find: /':-\( $/, replace: '😓 ' }),
      // textInputRule({ find: /:'-\( $/, replace: '😢 ' }),
      // textInputRule({ find: />:-\( $/, replace: '😠 ' }),
      // textInputRule({ find: /O:-\) $/, replace: '😇 ' }),
      // textInputRule({ find: /0:-3 $/, replace: '😇 ' }),
      // textInputRule({ find: /0:-\) $/, replace: '😇 ' }),
      // textInputRule({ find: /0;\^\) $/, replace: '😇 ' }),
      // textInputRule({ find: /O;-\) $/, replace: '😇 ' }),
      // textInputRule({ find: /0;-\) $/, replace: '😇 ' }),
      // textInputRule({ find: /O:-3 $/, replace: '😇 ' }),
      // textInputRule({ find: /:'\) $/, replace: '😂 ' }),
      // textInputRule({ find: /:-D $/, replace: '😃 ' }),
      // textInputRule({ find: /':\) $/, replace: '😅 ' }),
      // textInputRule({ find: /'=\) $/, replace: '😅 ' }),
      // textInputRule({ find: /':D $/, replace: '😅 ' }),
      // textInputRule({ find: /'=D $/, replace: '😅 ' }),
      // textInputRule({ find: />:\) $/, replace: '😆 ' }),
      // textInputRule({ find: />;\) $/, replace: '😆 ' }),
      // textInputRule({ find: />=\) $/, replace: '😆 ' }),
      // textInputRule({ find: /;-\) $/, replace: '😉 ' }),
      // textInputRule({ find: /\*-\) $/, replace: '😉 ' }),
      // textInputRule({ find: /;-\] $/, replace: '😉 ' }),
      // textInputRule({ find: /;\^\) $/, replace: '😉 ' }),
      // textInputRule({ find: /B-\) $/, replace: '😎 ' }),
      // textInputRule({ find: /8-\) $/, replace: '😎 ' }),
      // textInputRule({ find: /B-D $/, replace: '😎 ' }),
      // textInputRule({ find: /8-D $/, replace: '😎 ' }),
      // textInputRule({ find: /:-\* $/, replace: '😘 ' }),
      // textInputRule({ find: /:\^\* $/, replace: '😘 ' }),
      // textInputRule({ find: /:-\) $/, replace: '🙂 ' }),
      // textInputRule({ find: /-_- $/, replace: '😑 ' }),
      // textInputRule({ find: /:-X $/, replace: '😶 ' }),
      // textInputRule({ find: /:-# $/, replace: '😶 ' }),
      // textInputRule({ find: /:-x $/, replace: '😶 ' }),
      // textInputRule({ find: />.< $/, replace: '😣 ' }),
      // textInputRule({ find: /:-O $/, replace: '😮 ' }),
      // textInputRule({ find: /:-o $/, replace: '😮 ' }),
      // textInputRule({ find: /O_O $/, replace: '😮 ' }),
      // textInputRule({ find: />:O $/, replace: '😮 ' }),
      // textInputRule({ find: /:-P $/, replace: '😛 ' }),
      // textInputRule({ find: /:-p $/, replace: '😛 ' }),
      // textInputRule({ find: /:-Þ $/, replace: '😛 ' }),
      // textInputRule({ find: /:-þ $/, replace: '😛 ' }),
      // textInputRule({ find: /:-b $/, replace: '😛 ' }),
      // textInputRule({ find: />:P $/, replace: '😜 ' }),
      // textInputRule({ find: /X-P $/, replace: '😜 ' }),
      // textInputRule({ find: /x-p $/, replace: '😜 ' }),
      // textInputRule({ find: /':\( $/, replace: '😓 ' }),
      // textInputRule({ find: /'=\( $/, replace: '😓 ' }),
      // textInputRule({ find: />:\\ $/, replace: '😕 ' }),
      // textInputRule({ find: />:\/ $/, replace: '😕 ' }),
      // textInputRule({ find: /:-\/ $/, replace: '😕 ' }),
      // textInputRule({ find: /:-. $/, replace: '😕 ' }),
      // textInputRule({ find: />:\[ $/, replace: '😞 ' }),
      // textInputRule({ find: /:-\( $/, replace: '😞 ' }),
      // textInputRule({ find: /:-\[ $/, replace: '😞 ' }),
      // textInputRule({ find: /:'\( $/, replace: '😢 ' }),
      // textInputRule({ find: /;-\( $/, replace: '😢 ' }),
      // textInputRule({ find: /#-\) $/, replace: '😵 ' }),
      // textInputRule({ find: /%-\) $/, replace: '😵 ' }),
      // textInputRule({ find: /X-\) $/, replace: '😵 ' }),
      // textInputRule({ find: />:\( $/, replace: '😠 ' }),
      // textInputRule({ find: /0:3 $/, replace: '😇 ' }),
      // textInputRule({ find: /0:\) $/, replace: '😇 ' }),
      // textInputRule({ find: /O:\) $/, replace: '😇 ' }),
      // textInputRule({ find: /O=\) $/, replace: '😇 ' }),
      // textInputRule({ find: /O:3 $/, replace: '😇 ' }),
      // textInputRule({ find: /<\/3 $/, replace: '💔 ' }),
      // textInputRule({ find: /:D $/, replace: '😃 ' }),
      // textInputRule({ find: /=D $/, replace: '😃 ' }),
      // textInputRule({ find: /;\) $/, replace: '😉 ' }),
      // textInputRule({ find: /\*\) $/, replace: '😉 ' }),
      // textInputRule({ find: /;\] $/, replace: '😉 ' }),
      // textInputRule({ find: /;D $/, replace: '😉 ' }),
      // textInputRule({ find: /B\) $/, replace: '😎 ' }),
      // textInputRule({ find: /8\) $/, replace: '😎 ' }),
      // textInputRule({ find: /:\* $/, replace: '😘 ' }),
      // textInputRule({ find: /=\* $/, replace: '😘 ' }),
      // textInputRule({ find: /:\) $/, replace: '🙂 ' }),
      // textInputRule({ find: /=\] $/, replace: '🙂 ' }),
      // textInputRule({ find: /=\) $/, replace: '🙂 ' }),
      // textInputRule({ find: /:\] $/, replace: '🙂 ' }),
      // textInputRule({ find: /:X $/, replace: '😶 ' }),
      // textInputRule({ find: /:# $/, replace: '😶 ' }),
      // textInputRule({ find: /=X $/, replace: '😶 ' }),
      // textInputRule({ find: /=x $/, replace: '😶 ' }),
      // textInputRule({ find: /:x $/, replace: '😶 ' }),
      // textInputRule({ find: /=# $/, replace: '😶 ' }),
      // textInputRule({ find: /:O $/, replace: '😮 ' }),
      // textInputRule({ find: /:o $/, replace: '😮 ' }),
      // textInputRule({ find: /:P $/, replace: '😛 ' }),
      // textInputRule({ find: /=P $/, replace: '😛 ' }),
      // textInputRule({ find: /:p $/, replace: '😛  ' }),
      // textInputRule({ find: /=p $/, replace: '😛 ' }),
      // textInputRule({ find: /:Þ $/, replace: '😛 ' }),
      // textInputRule({ find: /:þ $/, replace: '😛 ' }),
      // textInputRule({ find: /:b $/, replace: '😛 ' }),
      // textInputRule({ find: /d: $/, replace: '😛 ' }),
      // textInputRule({ find: /:\/ $/, replace: '😕 ' }),
      // textInputRule({ find: /:\\ $/, replace: '😕 ' }),
      // textInputRule({ find: /=\/ $/, replace: '😕 ' }),
      // textInputRule({ find: /=\\ $/, replace: '😕 ' }),
      // textInputRule({ find: /:L $/, replace: '😕 ' }),
      // textInputRule({ find: /=L $/, replace: '😕 ' }),
      // textInputRule({ find: /:\( $/, replace: '😞 ' }),
      // textInputRule({ find: /:\[ $/, replace: '😞 ' }),
      // textInputRule({ find: /=\( $/, replace: '😞 ' }),
      // textInputRule({ find: /;\( $/, replace: '😢 ' }),
      // textInputRule({ find: /D: $/, replace: '😨 ' }),
      // textInputRule({ find: /:\$ $/, replace: '😳 ' }),
      // textInputRule({ find: /=\$ $/, replace: '😳 ' }),
      // textInputRule({ find: /#\) $/, replace: '😵 ' }),
      // textInputRule({ find: /%\) $/, replace: '😵 ' }),
      // textInputRule({ find: /X\) $/, replace: '😵 ' }),
      // textInputRule({ find: /:@ $/, replace: '😠 ' }),
      // textInputRule({ find: /<3 $/, replace: '❤️ ' }),
      // textInputRule({ find: /\/shrug $/, replace: '¯\\_(ツ)_/¯' }),
      // textInputRule({ find: /;\) $/, replace: '😉 ' }),
      // textInputRule({ find: /:\)\] $/, replace: '🙂 ' })
    ];
  }
}), KWt = ({
  editor: t,
  deleteNode: e
}) => {
  const { isPreviewMode: n } = Zp(), r = () => {
    t.commands.unsetPageBreak(), e();
  };
  return /* @__PURE__ */ C.jsxs(
    $u,
    {
      className: Lt(
        "flex relative opacity-0 hover:opacity-100 transition-opacity duration-200 w-full h-full justify-center items-center"
      ),
      children: [
        /* @__PURE__ */ C.jsx(
          "br",
          {
            "data-type": "page-break",
            "data-page-break": "true",
            style: { pageBreakAfter: "always" }
          }
        ),
        !n && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsx("div", { className: "absolute top-[-15px] left-0 right-0 h-4", children: /* @__PURE__ */ C.jsx(
            "div",
            {
              className: "absolute inset-0 border-b-1 border-transparent",
              style: {
                background: "linear-gradient(to bottom, transparent, #FFDF0A33)"
              }
            }
          ) }),
          /* @__PURE__ */ C.jsx(En, { sideOffset: 5, position: "bottom", text: "Remove page breaker", children: /* @__PURE__ */ C.jsx(
            Ye,
            {
              name: "PageBreakRemove",
              onClick: r,
              className: "color-text-secondary cursor-pointer"
            }
          ) }),
          /* @__PURE__ */ C.jsx("div", { className: "absolute bottom-[-15px] left-0 right-0 h-4", children: /* @__PURE__ */ C.jsx(
            "div",
            {
              className: "absolute inset-0 border-b-1 border-transparent",
              style: {
                background: "linear-gradient(to bottom, #FFDF0A33, transparent)"
              }
            }
          ) })
        ] })
      ]
    }
  );
}, ure = Ht.create({
  name: "pageBreak",
  addOptions() {
    return {
      HTMLAttributes: {
        style: "page-break-after: always",
        "data-page-break": "true"
      }
    };
  },
  group: "pageBreak",
  parseHTML() {
    return [
      {
        tag: 'br[data-type="page-break"]'
      },
      {
        tag: 'div[data-type="page-break"]'
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["br", _t(this.options.HTMLAttributes, t)];
  },
  addCommands() {
    return {
      setPageBreak: () => ({ chain: t, state: e }) => {
        const n = e.selection.from, { $head: r } = e.selection, i = r.node(r.depth), a = (i == null ? void 0 : i.textContent) === "" && (i == null ? void 0 : i.type.name) === "paragraph";
        return t().insertContentAt(
          {
            from: n - (a ? 2 : 0),
            to: n
          },
          {
            type: this.name
          }
        ).focus().run();
      },
      unsetPageBreak: () => ({ chain: t }) => t().deleteSelection().deleteCurrentNode().run()
    };
  },
  addProseMirrorPlugins() {
    return [
      new Wt({
        key: new tn("pageBreakPlugin"),
        props: {
          handleClick: (t, e, n) => {
            if (n.target.classList.contains("remove-page-break-icon")) {
              const { state: i, dispatch: a } = t, o = i.doc.nodeAt(e);
              if ((o == null ? void 0 : o.type.name) === "pageBreak") {
                const s = i.tr, l = o.nodeSize;
                return s.delete(e, e + l), a(s.scrollIntoView()), !0;
              }
            }
            return !1;
          }
        }
      })
    ];
  },
  addNodeView() {
    return Hc(KWt);
  }
}), D5 = typeof Buffer == "function";
typeof TextDecoder == "function" && new TextDecoder();
typeof TextEncoder == "function" && new TextEncoder();
const $Wt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Vf = Array.prototype.slice.call($Wt), I4 = ((t) => {
  let e = {};
  return t.forEach((n, r) => e[n] = r), e;
})(Vf), JWt = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, dy = String.fromCharCode.bind(String), qO = typeof Uint8Array.from == "function" ? Uint8Array.from.bind(Uint8Array) : (t) => new Uint8Array(Array.prototype.slice.call(t, 0)), QWt = (t) => t.replace(/=/g, "").replace(/[+\/]/g, (e) => e == "+" ? "-" : "_"), dre = (t) => t.replace(/[^A-Za-z0-9\+\/]/g, ""), XWt = (t) => {
  let e, n, r, i, a = "";
  const o = t.length % 3;
  for (let s = 0; s < t.length; ) {
    if ((n = t.charCodeAt(s++)) > 255 || (r = t.charCodeAt(s++)) > 255 || (i = t.charCodeAt(s++)) > 255)
      throw new TypeError("invalid character found");
    e = n << 16 | r << 8 | i, a += Vf[e >> 18 & 63] + Vf[e >> 12 & 63] + Vf[e >> 6 & 63] + Vf[e & 63];
  }
  return o ? a.slice(0, o - 3) + "===".substring(o) : a;
}, eZt = typeof btoa == "function" ? (t) => btoa(t) : D5 ? (t) => Buffer.from(t, "binary").toString("base64") : XWt, UO = D5 ? (t) => Buffer.from(t).toString("base64") : (t) => {
  let n = [];
  for (let r = 0, i = t.length; r < i; r += 4096)
    n.push(dy.apply(null, t.subarray(r, r + 4096)));
  return eZt(n.join(""));
}, Q2 = (t, e = !1) => e ? QWt(UO(t)) : UO(t), tZt = (t) => {
  if (t = t.replace(/\s+/g, ""), !JWt.test(t))
    throw new TypeError("malformed base64.");
  t += "==".slice(2 - (t.length & 3));
  let e, n = "", r, i;
  for (let a = 0; a < t.length; )
    e = I4[t.charAt(a++)] << 18 | I4[t.charAt(a++)] << 12 | (r = I4[t.charAt(a++)]) << 6 | (i = I4[t.charAt(a++)]), n += r === 64 ? dy(e >> 16 & 255) : i === 64 ? dy(e >> 16 & 255, e >> 8 & 255) : dy(e >> 16 & 255, e >> 8 & 255, e & 255);
  return n;
}, nZt = typeof atob == "function" ? (t) => atob(dre(t)) : D5 ? (t) => Buffer.from(t, "base64").toString("binary") : tZt, rZt = D5 ? (t) => qO(Buffer.from(t, "base64")) : (t) => qO(nZt(t).split("").map((e) => e.charCodeAt(0))), j1 = (t) => rZt(iZt(t)), iZt = (t) => dre(t.replace(/[-_]/g, (e) => e == "-" ? "+" : "/")), N0 = (t) => fd((e, n) => {
  t.onerror = (r) => n(new Error(r.target.error)), t.onsuccess = (r) => e(r.target.result);
}), aZt = (t, e) => fd((n, r) => {
  const i = indexedDB.open(t);
  i.onupgradeneeded = (a) => e(a.target.result), i.onerror = (a) => r(fo(a.target.error)), i.onsuccess = (a) => {
    const o = a.target.result;
    o.onversionchange = () => {
      o.close();
    }, n(o);
  };
}), oZt = (t) => N0(indexedDB.deleteDatabase(t)), sZt = (t, e) => e.forEach(
  (n) => (
    // @ts-ignore
    t.createObjectStore.apply(t, n)
  )
), qf = (t, e, n = "readwrite") => {
  const r = t.transaction(e, n);
  return e.map((i) => mZt(r, i));
}, fre = (t, e) => N0(t.count(e)), lZt = (t, e) => N0(t.get(e)), hre = (t, e) => N0(t.delete(e)), cZt = (t, e, n) => N0(t.put(e, n)), Vk = (t, e) => N0(t.add(e)), uZt = (t, e, n) => N0(t.getAll(e, n)), dZt = (t, e, n) => {
  let r = null;
  return pZt(t, e, (i) => (r = i, !1), n).then(() => r);
}, fZt = (t, e = null) => dZt(t, e, "prev"), hZt = (t, e) => fd((n, r) => {
  t.onerror = r, t.onsuccess = async (i) => {
    const a = i.target.result;
    if (a === null || await e(a) === !1)
      return n();
    a.continue();
  };
}), pZt = (t, e, n, r = "next") => hZt(t.openKeyCursor(e, r), (i) => n(i.key)), mZt = (t, e) => t.objectStore(e), yZt = (t, e) => IDBKeyRange.upperBound(t, e), gZt = (t, e) => IDBKeyRange.lowerBound(t, e), $b = "custom", pre = "updates", mre = 500, yre = (t, e = () => {
}, n = () => {
}) => {
  const [r] = qf(
    /** @type {IDBDatabase} */
    t.db,
    [pre]
  );
  return uZt(r, gZt(t._dbref, !1)).then((i) => {
    t._destroyed || (e(r), pn(t.doc, () => {
      i.forEach((a) => p0(t.doc, a));
    }, t, !1), n(r));
  }).then(() => fZt(r).then((i) => {
    t._dbref = i + 1;
  })).then(() => fre(r).then((i) => {
    t._dbsize = i;
  })).then(() => r);
}, vZt = (t, e = !0) => yre(t).then((n) => {
  (e || t._dbsize >= mre) && Vk(n, tm(t.doc)).then(() => hre(n, yZt(t._dbref, !0))).then(() => fre(n).then((r) => {
    t._dbsize = r;
  }));
});
class bZt extends xS {
  /**
   * @param {string} name
   * @param {Y.Doc} doc
   */
  constructor(e, n) {
    super(), this.doc = n, this.name = e, this._dbref = 0, this._dbsize = 0, this._destroyed = !1, this.db = null, this.synced = !1, this._db = aZt(
      e,
      (r) => sZt(r, [
        ["updates", { autoIncrement: !0 }],
        ["custom"]
      ])
    ), this.whenSynced = fd((r) => this.on("synced", () => r(this))), this._db.then((r) => {
      this.db = r, yre(this, (o) => Vk(o, tm(n)), () => {
        if (this._destroyed) return this;
        this.synced = !0, this.emit("synced", [this]);
      });
    }), this._storeTimeout = 1e3, this._storeTimeoutId = null, this._storeUpdate = (r, i) => {
      if (this.db && i !== this) {
        const [a] = qf(
          /** @type {IDBDatabase} */
          this.db,
          [pre]
        );
        Vk(a, r), ++this._dbsize >= mre && (this._storeTimeoutId !== null && clearTimeout(this._storeTimeoutId), this._storeTimeoutId = setTimeout(() => {
          vZt(this, !1), this._storeTimeoutId = null;
        }, this._storeTimeout));
      }
    }, n.on("update", this._storeUpdate), this.destroy = this.destroy.bind(this), n.on("destroy", this.destroy);
  }
  destroy() {
    return this._storeTimeoutId && clearTimeout(this._storeTimeoutId), this.doc.off("update", this._storeUpdate), this.doc.off("destroy", this.destroy), this._destroyed = !0, this._db.then((e) => {
      e.close();
    });
  }
  /**
   * Destroys this instance and removes all data from indexeddb.
   *
   * @return {Promise<void>}
   */
  clearData() {
    return this.destroy().then(() => {
      oZt(this.name);
    });
  }
  /**
   * @param {String | number | ArrayBuffer | Date} key
   * @return {Promise<String | number | ArrayBuffer | Date | any>}
   */
  get(e) {
    return this._db.then((n) => {
      const [r] = qf(n, [$b], "readonly");
      return lZt(r, e);
    });
  }
  /**
   * @param {String | number | ArrayBuffer | Date} key
   * @param {String | number | ArrayBuffer | Date} value
   * @return {Promise<String | number | ArrayBuffer | Date>}
   */
  set(e, n) {
    return this._db.then((r) => {
      const [i] = qf(r, [$b]);
      return cZt(i, n, e);
    });
  }
  /**
   * @param {String | number | ArrayBuffer | Date} key
   * @return {Promise<undefined>}
   */
  del(e) {
    return this._db.then((n) => {
      const [r] = qf(n, [$b]);
      return hre(r, e);
    });
  }
}
function gre(t) {
  if (typeof t != "string")
    return !1;
  try {
    const e = JSON.parse(t);
    return typeof e == "object" && e !== null || Array.isArray(e);
  } catch {
    return !1;
  }
}
const wu = class wu {
  constructor() {
    ua(this, "_currentZoom", "1");
  }
  static getInstance() {
    return wu.instance || (wu.instance = new wu()), wu.instance;
  }
  get currentZoom() {
    return this._currentZoom;
  }
  setZoom(e) {
    this._currentZoom = e, document.querySelectorAll(".template-buttons").forEach((r) => {
      r instanceof HTMLElement && this.updateElementPosition(r, e);
    });
  }
  updateElementPosition(e, n) {
    const r = {
      "0.5": "-translate-x-0",
      "0.75": "-translate-x-[45%]",
      1: "-translate-x-[60%]",
      "1.4": "-translate-x-[120%]",
      "1.5": "-translate-x-[140%]",
      2: "-translate-x-[300%]"
    };
    e.classList.remove(
      ...Array.from(e.classList).filter(
        (i) => i.startsWith("-translate-x-")
      )
    ), !window.matchMedia("(max-width: 1280px)").matches && n in r && e.classList.add(r[n]);
  }
};
ua(wu, "instance");
let qk = wu;
const Jb = qk.getInstance(), wZt = (t) => ({
  type: "dBlock",
  attrs: { isCorrupted: !0 },
  content: [
    {
      type: "paragraph",
      attrs: { textAlign: "left" },
      content: [
        {
          type: "text",
          text: `Invalid content: "${t}", please delete this node`
        }
      ]
    }
  ]
}), kZt = (t) => typeof t == "number" || typeof t == "string" || typeof t == "boolean" || typeof t > "u" || t === null, vre = ({
  data: t,
  ignoreCorruptedData: e = !0,
  onInvalidContentError: n
}) => {
  var i;
  const r = { ...t };
  return r.content = (i = t.content) == null ? void 0 : i.map((a) => kZt(a) ? (console.error("corrupted data:", a), n == null || n("Invalid content: " + typeof a), e ? null : wZt(a)) : a).filter((a) => a !== null), r;
}, xZt = ir.create({
  name: "comment",
  addOptions() {
    return {
      HTMLAttributes: {},
      onCommentActivated: () => {
      }
    };
  },
  addAttributes() {
    return {
      commentId: {
        default: null,
        parseHTML: (t) => t.getAttribute("data-comment-id"),
        renderHTML: (t) => ({ "data-comment-id": t.commentId })
      },
      resolved: {
        default: !1,
        parseHTML: (t) => t.getAttribute("data-resolved"),
        renderHTML: (t) => ({
          "data-resolved": t.resolved,
          class: t.active ? "inline-comment--active" : t.resolved ? "inline-comment--resolved" : "inline-comment--unresolved"
        })
      },
      active: {
        default: !1,
        parseHTML: (t) => t.getAttribute("data-active") === "true",
        renderHTML: (t) => ({ "data-active": t.active })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "span[data-comment-id]",
        getAttrs: (t) => {
          var e;
          return !!((e = t.getAttribute("data-comment-id")) != null && e.trim()) && null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "span",
      _t(this.options.HTMLAttributes, t),
      0
    ];
  },
  onSelectionUpdate() {
    const { $from: t } = this.editor.state.selection, e = t.marks();
    if (!e.length) {
      this.storage.activeCommentId = null, this.options.onCommentActivated(this.storage.activeCommentId || "");
      return;
    }
    const n = this.editor.schema.marks.comment, r = e.find((i) => i.type === n);
    this.storage.activeCommentId = (r == null ? void 0 : r.attrs.commentId) || null, this.options.onCommentActivated(this.storage.activeCommentId || "");
  },
  addStorage() {
    return {
      activeCommentId: null
    };
  },
  addCommands() {
    return {
      setComment: (t) => ({ commands: e }) => t ? (e.setMark("comment", { commentId: t }), !0) : !1,
      unsetComment: (t) => ({ tr: e, dispatch: n }) => {
        var i, a;
        if (!t) return !1;
        const r = [];
        return e.doc.descendants((o, s) => {
          const l = o.marks.find(
            (c) => c.type.name === "comment" && c.attrs.commentId === t
          );
          l && r.push({
            mark: l,
            range: {
              from: s,
              to: s + o.nodeSize
            }
          });
        }), r.forEach(({ mark: o, range: s }) => {
          e.removeMark(s.from, s.to, o);
        }), (a = (i = this.options).onCommentDeleted) == null || a.call(i, t), n == null ? void 0 : n(e);
      },
      resolveComment: (t) => ({ tr: e, dispatch: n }) => {
        var i, a;
        if (!t) return !1;
        const r = [];
        return e.doc.descendants((o, s) => {
          const l = o.marks.find(
            (c) => c.type.name === "comment" && c.attrs.commentId === t
          );
          l && r.push({
            mark: l,
            range: {
              from: s,
              to: s + o.nodeSize
            }
          });
        }), r.forEach(({ range: o }) => {
          e.addMark(
            o.from,
            o.to,
            this.editor.schema.marks.comment.create({
              commentId: t,
              resolved: !0
            })
          );
        }), (a = (i = this.options).onCommentResolved) == null || a.call(i, t), n == null ? void 0 : n(e);
      },
      unresolveComment: (t) => ({ tr: e, dispatch: n }) => {
        var i, a;
        if (!t) return !1;
        const r = [];
        return e.doc.descendants((o, s) => {
          const l = o.marks.find(
            (c) => c.type.name === "comment" && c.attrs.commentId === t
          );
          l && r.push({
            mark: l,
            range: {
              from: s,
              to: s + o.nodeSize
            }
          });
        }), r.forEach(({ range: o }) => {
          e.addMark(
            o.from,
            o.to,
            this.editor.schema.marks.comment.create({
              commentId: t,
              resolved: !1
            })
          );
        }), (a = (i = this.options).onCommentUnresolved) == null || a.call(i, t), n == null ? void 0 : n(e);
      },
      setCommentActive: (t) => ({ tr: e, dispatch: n }) => t ? (e.doc.descendants((r, i) => {
        const a = r.marks.find(
          (o) => o.type.name === "comment"
        );
        a && e.addMark(
          i,
          i + r.nodeSize,
          this.editor.schema.marks.comment.create({
            ...a.attrs,
            active: a.attrs.commentId === t
          })
        );
      }), n == null ? void 0 : n(e)) : !1,
      unsetCommentActive: () => ({ tr: t, dispatch: e }) => (t.doc.descendants((n, r) => {
        const i = n.marks.find(
          (a) => a.type.name === "comment"
        );
        i && t.addMark(
          r,
          r + n.nodeSize,
          this.editor.schema.marks.comment.create({
            ...i.attrs,
            active: !1
          })
        );
      }), e == null ? void 0 : e(t))
    };
  }
}), WO = (t) => {
  if (t.startsWith("rgb")) {
    const r = t.match(/\d+/g);
    if (r && r.length === 3) {
      const [i, a, o] = r.map(Number);
      if (i === a && a === o)
        return i < 30 || i > 240 || i >= 60 && i <= 180;
    }
    return !1;
  }
  t = t.toLowerCase();
  const e = ["#000000", "#434343", "#666666", "#999999"].map(
    (r) => r.toLowerCase()
  ), n = [
    "#ffffff",
    "#f3f3f3",
    "#efefef",
    "#d9d9d9",
    "#cccccc",
    "#b7b7b7"
  ].map((r) => r.toLowerCase());
  return e.includes(t) || n.includes(t);
}, ZO = [
  "#30bced",
  "#6eeb83",
  "#fa69d1",
  "#ecd444",
  "#ee6352",
  "#db3041",
  "#0ad7f2",
  "#1bff39"
], bre = ({
  isPreviewMode: t,
  initialContent: e,
  enableCollaboration: n,
  collaborationId: r,
  walletAddress: i,
  username: a,
  onChange: o,
  onCollaboratorChange: s,
  onCommentInteraction: l,
  ensResolutionUrl: c,
  onError: u,
  setCharacterCount: d,
  setWordCount: f,
  secureImageUploadUrl: h,
  ddocId: p,
  enableIndexeddbSync: m,
  unFocused: g,
  zoomLevel: v,
  onInvalidContentError: k,
  ignoreCorruptedData: w,
  isPresentationMode: b,
  proExtensions: x,
  metadataProxyUrl: A,
  onCopyHeadingLink: L
}) => {
  var de, Pe;
  const [M] = De(new Ll()), [j, D] = De(null), z = Ue(null), H = (ve) => {
    if (!z.current) return;
    const Le = z.current.querySelector(`input#${ve}`);
    Le && Le.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center"
    });
  };
  ze(() => {
    j && H(j);
  }, [j]);
  const [V, F] = De([]), [_, W] = De([
    ...lre(
      (ve) => u == null ? void 0 : u(ve),
      h,
      A,
      L
    ),
    YWt((ve) => u == null ? void 0 : u(ve), h),
    cre,
    ure,
    xZt.configure({
      HTMLAttributes: {
        class: "inline-comment"
      },
      onCommentActivated: (ve) => {
        D(ve), ve && setTimeout(() => H(ve));
      }
    }),
    _ee.configure({
      document: M
    })
  ]);
  ze(() => {
    W((ve) => [
      ...ve.filter((Le) => Le.name !== "table"),
      Ute.configure({
        resizable: !t
      })
    ]);
  }, [t]);
  const G = Ue(!1), [Y, Z] = De(!0), [oe, ee] = De([]), ae = (ve, Le, Re) => {
    let Ke = !1;
    return ve.doc.nodesBetween(Le, Re, (mt) => {
      mt.marks && mt.marks.some(
        (pt) => pt.type.name === "highlight" && pt.attrs.color === "yellow"
      ) && (Ke = !0);
    }), Ke;
  }, fe = (ve, Le) => {
    var Ke;
    const Re = Le.target;
    if (Re && Re.nodeName === "MARK" && Re.dataset.color && ((Ke = Re == null ? void 0 : Re.dataset) == null ? void 0 : Ke.color) === "yellow") {
      const mt = Re.textContent, pt = ve.posAtCoords({ left: Le.clientX, top: Le.clientY });
      if (pt) {
        const { state: Nt } = ve;
        let ye = pt.pos, _e = pt.pos;
        if (Nt.doc.nodesBetween(ye, _e, (we, $e) => {
          we.marks && we.marks.length && we.marks.forEach((Xe) => {
            Xe.type.name === "highlight" && (ye = $e, _e = $e + we.nodeSize);
          });
        }), ye !== _e) {
          const we = {
            text: mt,
            from: ye,
            to: _e,
            isHighlightedYellow: ae(Nt, ye, _e)
          };
          l == null || l(we);
        }
      }
    }
  }, me = (ve, Le, Re) => {
    fe(ve, Re);
  }, ge = Ft(() => _, [_]), $ = Ue(null), se = mF(
    {
      extensions: ge,
      editorProps: {
        ...xDt,
        handleDOMEvents: {
          mouseover: fe,
          keydown: (ve, Le) => {
            if (["ArrowUp", "ArrowDown", "Enter"].includes(Le.key) && document.querySelector("#slash-command"))
              return !0;
          },
          blur: () => {
            se == null || se.commands.unsetCommentActive();
          }
        },
        handleClick: me
      },
      autofocus: g ? !1 : "start",
      immediatelyRender: !1,
      shouldRerenderOnTransaction: !1
    },
    [ge, b]
  );
  ze(() => (x != null && x.TableOfContents && !_.some((ve) => ve.name === "tableOfContents") && W([
    ..._.filter((ve) => ve.name !== "tableOfContents"),
    x.TableOfContents.configure({
      getIndex: x.getHierarchicalIndexes,
      onUpdate: (ve, Le) => {
        Le ? F(ve) : ($.current && clearTimeout($.current), $.current = window.setTimeout(() => {
          F(ve), $.current = null;
        }, 300));
      }
    })
  ]), () => {
    $.current && clearTimeout($.current);
  }), [x]), ze(() => {
    if (v) {
      Jb.setZoom(v);
      const ve = setTimeout(() => {
        Jb.setZoom(v);
      }, 100);
      return () => clearTimeout(ve);
    }
  }, [v, Y, e, se == null ? void 0 : se.isEmpty]);
  const xe = Ue(() => {
  }), Oe = (ve, Le = !1) => {
    if (!n || !r)
      throw new Error("docId or username is not provided");
    const Re = new kDt(r, M, {
      signaling: [
        "wss://fileverse-signaling-server-0529292ff51c.herokuapp.com/"
      ]
    });
    return W([
      ..._.filter((Ke) => Ke.name !== "history"),
      $Dt.configure({
        provider: Re,
        user: {
          name: ve && ve.length > 20 ? D9t(ve, 7, 15) : ve,
          color: ZO[Math.floor(Math.random() * ZO.length)],
          isEns: Le
        },
        render: HWt
      })
    ]), xe.current = () => {
      Re.destroy(), M.destroy();
    }, xe.current;
  }, je = Ue(null);
  ze(() => {
    se == null || se.setEditable(!t);
  }, [t, se]);
  const Me = Ue(null), he = async () => {
    const ve = Me.current;
    if (ve && await ve.destroy(), m && p) {
      const Le = new bZt(p, M);
      Me.current = Le;
    }
  }, pe = (ve) => {
    const Le = ve.map((Re) => j1(Re));
    p0(M, H2(Le), "self");
  }, J = (ve) => Array.isArray(ve) || typeof ve == "string" && !gre(ve), K = (ve) => ve === null, X = window.location.hash.startsWith("#") ? window.location.hash.substring(1) : window.location.hash, re = new URLSearchParams(X), Ie = re.get("heading"), q = Ie == null ? void 0 : Ie.split("-").pop(), { isNativeMobile: S } = Kc(), P = nt(
    (ve) => {
      if (se) {
        const Le = se.view.dom.querySelectorAll("[data-toc-id]"), Re = Array.from(Le).find(
          (we) => {
            var $e;
            return ($e = we.dataset.tocId) == null ? void 0 : $e.includes(ve);
          }
        );
        if (!Re) return;
        const Ke = zte(
          Re == null ? void 0 : Re.textContent
        ), mt = Ie == null ? void 0 : Ie.split("-").slice(0, -1).join("-");
        Ke !== mt && (re.set("heading", `${Ke}-${ve}`), window.location.hash = re.toString());
        const pt = se.view.posAtDOM(Re, 0), Nt = se.view.state.tr;
        Nt.setSelection(new ot(Nt.doc.resolve(pt))), se.view.dispatch(Nt);
        const _e = [
          document.querySelector(".ProseMirror"),
          document.getElementById("editor-canvas"),
          Re.closest(".ProseMirror"),
          Re.closest('[class*="editor"]'),
          se.view.dom.parentElement
        ].filter(Boolean).find(
          (we) => we && (we.scrollHeight > we.clientHeight || window.getComputedStyle(we).overflow === "auto" || window.getComputedStyle(we).overflowY === "auto")
        );
        _e && requestAnimationFrame(() => {
          const we = _e.getBoundingClientRect(), $e = Re.getBoundingClientRect(), Xe = $e.top - we.top - we.height / (S ? 5 : 7) + $e.height / (S ? 5 : 7);
          _e.scrollBy({
            top: Xe,
            behavior: "smooth"
          });
        });
      }
    },
    [se, S]
  );
  ze(() => {
    !t || !q || Y || setTimeout(() => {
      P(q);
    }, 100);
  }, [
    se,
    t,
    S,
    q,
    Y,
    P
  ]), ze(() => {
    const ve = (Le) => {
      (Le.ctrlKey || Le.metaKey) && Le.key === "p" && (Le.preventDefault(), se && (b ? EY(oe) : jY(se.getHTML())));
    };
    return window.addEventListener("keydown", ve), () => {
      window.removeEventListener("keydown", ve);
    };
  }, [se, b]), ze(() => {
    !K(e) && se && !G.current && M ? (Z(!0), queueMicrotask(() => {
      e !== "" && (J(e) ? Array.isArray(e) ? pe(e) : p0(
        M,
        j1(e),
        "self"
      ) : se.commands.setContent(
        vre({
          data: e,
          ignoreCorruptedData: w,
          onInvalidContentError: k
        })
      )), v && Jb.setZoom(v), he().then(() => {
        Z(!1);
      }).catch((ve) => {
        console.log(ve);
      });
    }), G.current = !0) : e !== null && Z(!1);
  }, [e, se, M]);
  const O = async () => {
    let ve = a, Le = !1;
    if (i && c) {
      const { name: Re, isEns: Ke } = await H$(
        i,
        c
      );
      ve = Re, Le = Ke;
    }
    if (!ve)
      throw new Error("Cannot start collaboration without a username");
    Oe(ve, Le);
  };
  ze(() => {
    n ? O() : xe.current();
  }, [n]), ze(() => {
    var ve, Le;
    s == null || s((Le = (ve = se == null ? void 0 : se.storage) == null ? void 0 : ve.collaborationCursor) == null ? void 0 : Le.users);
  }, [(Pe = (de = se == null ? void 0 : se.storage) == null ? void 0 : de.collaborationCursor) == null ? void 0 : Pe.users]), ze(() => {
    d && d(se == null ? void 0 : se.storage.characterCount.characters()), f && f(se == null ? void 0 : se.storage.characterCount.words());
  }, [
    se == null ? void 0 : se.storage.characterCount.characters(),
    se == null ? void 0 : se.storage.characterCount.words()
  ]), ze(() => {
    const ve = (Le, Re) => {
      Re !== "self" && (o == null || o(
        Q2(tm(M)),
        Q2(Le)
      ));
    };
    return M && M.on("update", ve), () => {
      M == null || M.off("update", ve);
    };
  }, [M]), ze(() => () => {
    se && se.destroy();
  }, [se]), ze(() => {
    if (!se) return;
    const ve = ({ editor: Le }) => {
      const Re = Le.state.selection.from;
      setTimeout(() => {
        const Ke = Le.state.selection.from, mt = [];
        Le.state.doc.nodesBetween(
          Re,
          Ke,
          (pt, Nt) => {
            pt.marks && pt.marks.forEach((ye) => {
              ye.type.name === "textStyle" && ye.attrs.color && mt.push({
                from: Nt,
                to: Nt + pt.nodeSize,
                mark: ye
              });
            });
          }
        ), Le.chain().setTextSelection({ from: Re, to: Ke }).setColor("").run(), mt.forEach(({ from: pt, to: Nt, mark: ye }) => {
          const _e = ye.attrs.color;
          WO(_e) || Le.chain().setTextSelection({ from: pt, to: Nt }).setColor(_e).run();
        }), Le.commands.setTextSelection(Ke);
      }, 0);
    };
    return se.on("paste", ve), () => {
      se.off("paste", ve);
    };
  }, [se]);
  const ne = Ue(localStorage.getItem("theme") !== null), le = Ue(!1);
  return ze(() => {
    if (!(!se || Y || !ne.current || le.current))
      if (e) {
        const ve = setTimeout(() => {
          if (!se) return;
          const { from: Le, to: Re } = se.state.selection, Ke = [];
          se.state.doc.descendants((mt, pt) => {
            mt.marks && mt.marks.forEach((Nt) => {
              Nt.type.name === "textStyle" && Nt.attrs.color && Ke.push({
                from: pt,
                to: pt + mt.nodeSize,
                mark: Nt
              });
            });
          }), Ke.length > 0 && (se.chain().selectAll().setColor("").run(), Ke.forEach(({ from: mt, to: pt, mark: Nt }) => {
            const ye = Nt.attrs.color;
            WO(ye) || se.chain().setTextSelection({ from: mt, to: pt }).setColor(ye).run();
          }), se.commands.setTextSelection({ from: Le, to: Re })), le.current = !0;
        }, 100);
        return () => clearTimeout(ve);
      } else
        le.current = !0;
  }, [se, e, Y]), {
    editor: se,
    isContentLoading: Y,
    ref: je,
    connect: Oe,
    ydoc: M,
    refreshYjsIndexedDbProvider: he,
    activeCommentId: j,
    setActiveCommentId: D,
    focusCommentWithActiveId: H,
    slides: oe,
    setSlides: ee,
    tocItems: V,
    setTocItems: F
  };
}, MZt = ({
  editor: t,
  onError: e,
  isKeyboardVisible: n,
  isNavbarVisible: r,
  setIsNavbarVisible: i,
  secureImageUploadUrl: a,
  isLoading: o
}) => {
  const { toolVisibility: s, setToolVisibility: l, bottomToolbar: c } = RA(
    {
      editor: t,
      onError: e,
      secureImageUploadUrl: a
    }
  ), [u, d] = De(""), [f, h] = De(""), [p, m] = De(!0), [g, v] = De(!0), k = () => {
    if (!t) return;
    if ((u === null || u === "") && (f === "" || f === null)) {
      l(st.NONE);
      return;
    }
    let b = u;
    if (b && !b.startsWith("http://") && !b.startsWith("https://") && (b = "https://" + b), b && !/^(https?:\/\/)?([\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?|\w+@[\w.-]+\.\w+)$/i.test(b)) {
      v(!1), e && e("Invalid URL");
      return;
    }
    const { from: A, to: L } = t.state.selection;
    t.state.doc.textBetween(A, L).length > 0 ? t.chain().focus().deleteSelection().insertContent({
      type: "text",
      text: f,
      marks: b ? [{ type: "link", attrs: { href: b } }] : []
    }).run() : f && t.chain().focus().insertContent({
      type: "text",
      text: f,
      marks: b ? [{ type: "link", attrs: { href: b } }] : []
    }).run(), v(!0), m(!0), l(st.NONE);
  }, w = () => {
    if (!t) return { text: "", url: "" };
    const { from: b, to: x } = t.state.selection, A = t.state.doc.textBetween(b, x), L = t.getAttributes("link");
    return {
      text: A || L.text || "",
      url: L.href || ""
    };
  };
  return ze(() => {
    if (!t) return;
    const b = (x) => {
      x.key === "k" && (x.metaKey || x.ctrlKey) && (x.preventDefault(), s !== st.LINK_POPUP ? l(st.LINK_POPUP) : l(st.NONE));
    };
    return document.addEventListener("keydown", b), () => {
      document.removeEventListener("keydown", b);
    };
  }, [t, s]), ze(() => {
    n && l(st.NONE);
  }, [n, l]), ze(() => {
    if (s === st.LINK_POPUP) {
      const { text: b, url: x } = w();
      h(b), d(x);
    }
  }, [s, t]), /* @__PURE__ */ C.jsxs(kp, { children: [
    /* @__PURE__ */ C.jsxs("div", { className: "flex w-full justify-between sm:justify-evenly items-center select-none", children: [
      c.map((b, x) => b ? /* @__PURE__ */ C.jsx("div", { className: "flex items-center", children: b.title === "Text formating" ? /* @__PURE__ */ C.jsx(CN, { asChild: !0, children: /* @__PURE__ */ C.jsx(Gp, { children: o ? Fi(
        /* @__PURE__ */ C.jsx(
          hn,
          {
            className: "w-[36px] h-[36px] rounded-sm"
          }
        ),
        "mobile" + b.title + "skeleton"
      ) : _i(
        /* @__PURE__ */ C.jsx(
          kr,
          {
            onClick: b.onClick,
            isActive: b.isActive,
            icon: b.icon
          }
        ),
        b.title + "mobile"
      ) }) }) : b.title === "Text color" ? /* @__PURE__ */ C.jsx(CN, { asChild: !0, children: o ? Fi(
        /* @__PURE__ */ C.jsx(
          hn,
          {
            className: "w-[36px] h-[36px] rounded-sm"
          }
        ),
        "mobile" + b.title
      ) : _i(
        /* @__PURE__ */ C.jsx(
          kr,
          {
            onClick: b.onClick,
            icon: b.icon,
            isActive: !1
          }
        ),
        "text-color-button"
      ) }) : o ? Fi(
        /* @__PURE__ */ C.jsx(hn, { className: "w-[36px] h-[36px] rounded-sm" }),
        "skeleton" + b.title
      ) : _i(
        /* @__PURE__ */ C.jsx(
          kr,
          {
            onClick: b.onClick,
            icon: b.icon,
            isActive: !1
          }
        ),
        "mobile-button" + b.title
      ) }, b.title) : /* @__PURE__ */ C.jsx(
        "div",
        {
          className: "w-[1px] h-4 vertical-divider mx-2"
        },
        x
      )),
      /* @__PURE__ */ C.jsx("div", { className: "w-[1px] h-4 vertical-divider mx-2" }),
      /* @__PURE__ */ C.jsx("div", { className: "w-9 h-9 flex justify-center items-center", children: /* @__PURE__ */ C.jsx(
        Ye,
        {
          size: "md",
          name: r ? "ChevronUp" : "ChevronDown",
          onClick: () => i((b) => !b)
        }
      ) })
    ] }),
    /* @__PURE__ */ C.jsx(
      EMt,
      {
        editor: t,
        isOpen: s === st.TEXT_FORMATING,
        setIsOpen: (b) => !b && l(st.NONE),
        setToolVisibility: l
      }
    ),
    /* @__PURE__ */ C.jsx(
      PW,
      {
        open: s === st.LINK_POPUP,
        onOpenChange: (b) => !b && l(st.NONE),
        title: "Link",
        content: /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col gap-4 w-full h-full text-base", children: [
          /* @__PURE__ */ C.jsx(
            al,
            {
              label: "Text",
              placeholder: "Link text",
              className: "w-full text-base",
              defaultValue: w().text,
              onChange: (b) => {
                b.preventDefault(), h(b.target.value);
              },
              isValid: p,
              message: p ? "" : "Invalid text"
            }
          ),
          /* @__PURE__ */ C.jsx(
            al,
            {
              label: "Link",
              placeholder: "Paste URL",
              className: "w-full text-base",
              defaultValue: w().url,
              onChange: (b) => {
                b.preventDefault(), d(b.target.value);
              },
              isValid: g,
              message: g ? "" : "Invalid URL"
            }
          )
        ] }),
        primaryAction: {
          label: "Save",
          onClick: () => k(),
          isLoading: !1,
          className: "w-full md:w-auto min-w-[80px]"
        },
        secondaryAction: {
          label: "Cancel",
          variant: "secondary",
          onClick: () => l(st.NONE),
          className: "w-full md:w-auto min-w-[80px]"
        }
      }
    )
  ] });
};
new _r({
  html: !0,
  linkify: !0,
  typographer: !0
}).enable("table");
qn.addRule("pageBreak", {
  filter: "br",
  replacement: function() {
    return `

===

`;
  }
});
const CZt = (t) => {
  if (!t.nodeName) return "";
  switch (t.nodeName) {
    case "H1":
      return "#";
    case "H2":
      return "##";
    case "H3":
      return "###";
    default:
      return "";
  }
};
qn.addRule("heading", {
  filter: ["h1", "h2", "h3"],
  replacement: function(t, e) {
    const n = CZt(e), r = t.replace(/\n\n===\n\n/g, "<br>");
    return `${n} ${r}`;
  }
});
qn.addRule("superscript", {
  filter: "sup",
  replacement: function(t) {
    return `<sup>${t}</sup>`;
  }
});
qn.addRule("subscript", {
  filter: "sub",
  replacement: function(t) {
    return `<sub>${t}</sub>`;
  }
});
qn.addRule("table", {
  filter: "table",
  replacement: function(t, e) {
    const n = e, r = Array.from(n.rows), i = Array.from(r[0].cells).map((d) => qn.turndown(d.innerHTML).trim()), a = i.map((d) => d.length), o = r.slice(1).map((d) => Array.from(d.cells).map((f, h) => {
      let p = f.innerHTML.trim();
      if (f.querySelector("ul, ol")) {
        const m = f.querySelector("ul") ? "ul" : "ol", g = Array.from(f.querySelectorAll("li")).map(
          (v) => {
            var k;
            return ((k = v.textContent) == null ? void 0 : k.trim()) || "";
          }
        );
        p = `<${m}><li>${g.join(
          "</li><li>"
        )}</li></${m}>`;
      } else
        p = qn.turndown(p);
      return a[h] = Math.max(
        a[h],
        p.length
      ), p;
    })), s = (d) => "| " + d.map((f, h) => {
      const p = " ".repeat(
        Math.max(0, a[h] - f.length)
      );
      return f + p;
    }).join(" | ") + " |", l = s(i), c = "| " + a.map((d) => "-".repeat(d)).join(" | ") + " |", u = o.map((d) => s(d));
    return `

${l}
${c}
${u.join(
      `
`
    )}

`;
  }
});
qn.addRule("taskListItem", {
  filter: (t) => {
    const e = t.parentElement;
    return t.nodeName === "LI" && (e == null ? void 0 : e.getAttribute("data-type")) === "taskList";
  },
  replacement: function(t, e) {
    const n = e.getAttribute("data-checked") === "true";
    return t = t.replace(/^\n+/, "").replace(/\n+$/, "").replace(/\n/gm, `
    `), `- [${n ? "x" : " "}] ${t}${e.nextSibling ? `
` : ""}`;
  }
});
const AZt = async (t) => {
  const e = t.state.doc, n = await zA(e), r = new np({
    extensions: t.extensionManager.extensions.filter(
      (o) => o.name !== "collaboration"
    ),
    content: n.toJSON()
  }), i = r.getHTML(), a = qn.turndown(i);
  return r.destroy(), a;
}, SZt = ({
  slides: t,
  currentSlide: e,
  setCurrentSlide: n
}) => {
  const r = Ue({}), i = Ue(null), { isNativeMobile: a } = Kc(), o = ja("(max-width: 1279px)");
  return ze(() => {
    var s;
    !o && r.current[e] && ((s = r.current[e]) == null || s.scrollIntoView({
      behavior: "smooth",
      block: "center"
    }));
  }, [e, o]), /* @__PURE__ */ C.jsxs(
    "div",
    {
      ref: i,
      className: be(
        "color-bg-default flex gap-3 py-4 px-4 color-border-default-hover relative",
        o ? "flex-row overflow-x-auto border-t min-h-[12rem] order-2 w-full pt-10 xl:pt-0" : "w-[251px] h-full overflow-y-auto overflow-x-hidden flex-col py-16 border-r",
        a && "min-h-[20rem]"
      ),
      children: [
        o && /* @__PURE__ */ C.jsxs("div", { className: "w-full text-helper-text-sm color-text-secondary absolute top-0 left-0 my-2.5 mx-5 z-20", children: [
          "Slides: ",
          /* @__PURE__ */ C.jsx("span", { className: "color-text-default", children: t.length })
        ] }),
        t.map((s, l) => /* @__PURE__ */ C.jsxs(
          "div",
          {
            ref: (c) => r.current[l] = c,
            className: be(
              "flex p-2 rounded-xl w-[219px] h-[122px] transition-all",
              e === l ? "color-bg-brand hover:color-bg-brand-hover" : "color-bg-default hover:color-bg-default-hover"
            ),
            children: [
              /* @__PURE__ */ C.jsx(
                "span",
                {
                  className: be(
                    "text-body-sm h-full w-[20px] pr-1 text-center",
                    e === l ? "color-text-default dark:text-[#363B3F]" : "color-text-default"
                  ),
                  children: l + 1
                }
              ),
              /* @__PURE__ */ C.jsx(
                "div",
                {
                  onClick: () => n(l),
                  className: be(
                    "border rounded-lg cursor-pointer transition-all transform overflow-hidden aspect-video w-[188px] h-[106px]",
                    e === l ? "border-[#FFDF0A]" : "color-border-default"
                  ),
                  children: /* @__PURE__ */ C.jsx(
                    "div",
                    {
                      className: "presentation-mode preview-slide color-bg-default w-[400%] h-[400%]",
                      dangerouslySetInnerHTML: { __html: s }
                    }
                  )
                }
              )
            ]
          },
          l
        ))
      ]
    }
  );
};
var LZt = function() {
  var t = document.getSelection();
  if (!t.rangeCount)
    return function() {
    };
  for (var e = document.activeElement, n = [], r = 0; r < t.rangeCount; r++)
    n.push(t.getRangeAt(r));
  switch (e.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      e.blur();
      break;
    default:
      e = null;
      break;
  }
  return t.removeAllRanges(), function() {
    t.type === "Caret" && t.removeAllRanges(), t.rangeCount || n.forEach(function(i) {
      t.addRange(i);
    }), e && e.focus();
  };
}, TZt = LZt, GO = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, EZt = "Copy to clipboard: #{key}, Enter";
function jZt(t) {
  var e = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return t.replace(/#{\s*key\s*}/g, e);
}
function NZt(t, e) {
  var n, r, i, a, o, s, l = !1;
  e || (e = {}), n = e.debug || !1;
  try {
    i = TZt(), a = document.createRange(), o = document.getSelection(), s = document.createElement("span"), s.textContent = t, s.ariaHidden = "true", s.style.all = "unset", s.style.position = "fixed", s.style.top = 0, s.style.clip = "rect(0, 0, 0, 0)", s.style.whiteSpace = "pre", s.style.webkitUserSelect = "text", s.style.MozUserSelect = "text", s.style.msUserSelect = "text", s.style.userSelect = "text", s.addEventListener("copy", function(u) {
      if (u.stopPropagation(), e.format)
        if (u.preventDefault(), typeof u.clipboardData > "u") {
          n && console.warn("unable to use e.clipboardData"), n && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var d = GO[e.format] || GO.default;
          window.clipboardData.setData(d, t);
        } else
          u.clipboardData.clearData(), u.clipboardData.setData(e.format, t);
      e.onCopy && (u.preventDefault(), e.onCopy(u.clipboardData));
    }), document.body.appendChild(s), a.selectNodeContents(s), o.addRange(a);
    var c = document.execCommand("copy");
    if (!c)
      throw new Error("copy command was unsuccessful");
    l = !0;
  } catch (u) {
    n && console.error("unable to copy using execCommand: ", u), n && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(e.format || "text", t), e.onCopy && e.onCopy(window.clipboardData), l = !0;
    } catch (d) {
      n && console.error("unable to copy using clipboardData: ", d), n && console.error("falling back to prompt"), r = jZt("message" in e ? e.message : EZt), window.prompt(r, t);
    }
  } finally {
    o && (typeof o.removeRange == "function" ? o.removeRange(a) : o.removeAllRanges()), s && document.body.removeChild(s), i();
  }
  return l;
}
var DZt = NZt;
const IZt = /* @__PURE__ */ kd(DZt), bi = new _r({
  html: !0,
  linkify: !0,
  typographer: !0
}).use(bJ).enable(["table", "list"]);
bi.renderer.rules.list_item_open = (t, e) => {
  const n = t[e + 2];
  if (n && n.content) {
    const r = n.content.match(/^\[([ xX])\]\s*(.*)$/);
    if (r) {
      const i = r[1].toLowerCase() === "x";
      return n.content = r[2], `<li class="task-list-item"><input type="checkbox" ${i ? "checked" : ""} disabled>`;
    }
  }
  return "<li>";
};
const PZt = (t, e, n) => {
  const r = [], i = e.reduce((o, s) => o + s.length, 0) / e.length, a = Math.min(
    n - 2,
    // Account for header and separator
    Math.floor(1e3 / i)
    // Estimate based on content length
  );
  for (let o = 0; o < e.length; o += a)
    r.push({
      headers: t,
      rows: e.slice(o, o + a)
    });
  return r;
}, YO = (t, e) => {
  if (t.length <= e)
    return [t];
  const n = [];
  let r = "";
  const i = t.split(new RegExp("(?<=[.!?])\\s+"));
  for (const a of i)
    if (r.length + a.length > e)
      if (r && n.push(r.trim()), a.length > e) {
        const o = a.split(/\s+/);
        r = "";
        for (const s of o)
          r.length + s.length + 1 > e ? (n.push(r.trim()), r = s) : r += (r ? " " : "") + s;
      } else
        r = a;
    else
      r += (r ? " " : "") + a;
  return r && n.push(r.trim()), n;
}, zZt = (t, e) => {
  const n = [], r = t[0].slice(3).trim(), i = t.slice(1, -1);
  for (let a = 0; a < i.length; a += e - 2) {
    const o = [
      `\`\`\`${r}`,
      ...i.slice(a, a + e - 2).map((s) => s),
      // Keep original line with indentation
      "```"
    ];
    n.push(o.join(`
`));
  }
  return n;
}, wre = (t) => /^[-*]\s*\[([ xX])\]\s*(.*)$/.test(t) ? !1 : (
  // Ordered list items
  /^\d+\.\s/.test(t) || // Unordered list items
  /^[-*+]\s/.test(t) || // Indented list items (nested)
  /^\s+[-*+]\s/.test(t) || /^\s+\d+\.\s/.test(t)
), RZt = (t, e) => {
  const n = [];
  let r = e;
  for (; r < t.length && (wre(t[r]) || t[r].trim() === ""); )
    n.push(t[r]), r++;
  return {
    listContent: n.join(`
`),
    endIndex: r - 1
  };
}, KO = (t, e = 10) => {
  const n = t.split(`
`), r = [];
  for (let i = 0; i < n.length; i += e)
    r.push(n.slice(i, i + e).join(`
`));
  return r;
};
function OZt(t, e = {}) {
  var w, b;
  const {
    preserveNewlines: n = !0,
    sanitize: r = !0,
    maxCharsPerSlide: i = 1e3,
    maxWordsPerSlide: a = 250,
    maxLinesPerSlide: o = 7
  } = e, s = [];
  let l = [], c = [], u = [];
  const d = (x) => x.trim().split(/\s+/).filter((A) => A.length > 0).length, f = (x, A) => {
    if (A.length === 1 && (A[0].type === "h2" || A[0].type === "h3"))
      return !1;
    const L = A.reduce((D, z) => D + z.content.length, 0) + x.length, M = A.reduce((D, z) => D + d(z.content), 0) + d(x), j = A.length + 1;
    return L > i || M > a || j > o;
  }, h = (x, A, L) => {
    const { maxCharsPerSlide: M = 1e3 } = L;
    if (A.length > 0 && (A[0].type === "h2" || A[0].type === "h3") && A.length === 1) {
      const D = YO(x, M);
      A.push({
        type: "content",
        content: bi.render(D[0])
      });
      for (let z = 1; z < D.length; z++)
        s.push(A), A = [
          {
            type: "content",
            content: bi.render(D[z])
          }
        ];
      return A;
    }
    if (x.startsWith("- [ ") || x.startsWith("* [ ") || x.startsWith("- [x") || x.startsWith("* [x") || x.startsWith("- [X") || x.startsWith("* [X")) {
      (!A.length || A[A.length - 1].type !== "content") && A.push({
        type: "content",
        content: ""
      });
      const D = x.match(/^[-*]\s*\[([ xX])\]\s*(.*)$/);
      if (D) {
        const z = D[1].toLowerCase() === "x", H = D[2];
        A[A.length - 1].content += `<li class="task-list-item"><input type="checkbox" ${z ? "checked" : ""} disabled>${H}</li>
`;
      }
    } else
      YO(x, M).forEach((z, H) => {
        (H > 0 || f(z, A)) && A.length > 0 && (s.push(A), A = []), A.push({
          type: "content",
          content: bi.render(z)
        });
      });
    return A;
  }, p = () => {
    l.length > 0 && (s.push(l), l = []);
  }, m = (x) => {
    const A = x.filter((z) => z.trim().length > 0);
    if (A.length < 2) return [""];
    const L = A[0].split("|").map((z) => z.trim()).filter(Boolean), M = A[1], j = A.slice(2);
    return A.length <= o ? [`<div class="table-wrapper">${bi.render(x.join(`
`))}</div>`] : PZt(L, j, o).map((z) => {
      const H = [
        `|${L.join("|")}|`,
        M,
        ...z.rows
      ].join(`
`);
      return `<div class="table-wrapper">${bi.render(H)}</div>`;
    });
  }, g = t.split(`
`);
  for (let x = 0; x < g.length; x++) {
    const A = g[x].trim();
    if (wre(A)) {
      const { listContent: L, endIndex: M } = RZt(g, x), j = L.split(`
`).filter((z) => z.trim()), D = j.reduce(
        (z, H) => z + d(H),
        0
      );
      j.length > 10 ? KO(L).forEach((H, V) => {
        (V > 0 || f(H, l)) && p(), l.push({
          type: "content",
          content: bi.render(H)
        });
      }) : j.length < 10 && D > 50 ? KO(L, 6).forEach((H, V) => {
        (V > 0 || f(H, l)) && p(), l.push({
          type: "content",
          content: bi.render(H)
        });
      }) : (f(L, l) && p(), l.push({
        type: "content",
        content: bi.render(L)
      })), x = M;
      continue;
    }
    if (A === "===") {
      if (c.length > 0) {
        const L = m(c);
        for (let M = 0; M < L.length; M++) {
          const j = L[M];
          j && ((M > 0 || f(j, l)) && p(), l.push({ type: "table", content: j }));
        }
        c = [];
      }
      p();
      continue;
    }
    if (A.startsWith("# ")) {
      if (c.length > 0) {
        const j = m(c);
        for (let D = 0; D < j.length; D++) {
          const z = j[D];
          z && ((D > 0 || f(z, l)) && p(), l.push({ type: "table", content: z }));
        }
        c = [];
      }
      p();
      const L = A.substring(2), M = bi.renderInline(L);
      s.push([{ type: "h1", content: M }]);
      continue;
    }
    if (A.startsWith("## ")) {
      if (c.length > 0) {
        const j = m(c);
        for (let D = 0; D < j.length; D++) {
          const z = j[D];
          z && ((D > 0 || f(z, l)) && p(), l.push({ type: "table", content: z }));
        }
        c = [];
      }
      p();
      const L = A.substring(3);
      l = [{ type: "h2", content: bi.renderInline(L) }];
      continue;
    }
    if (A.startsWith("|") || A.match(/^\s*[-|]+\s*$/)) {
      c.push(A);
      continue;
    } else if (c.length > 0) {
      const L = m(c);
      for (let M = 0; M < L.length; M++) {
        const j = L[M];
        j && ((M > 0 || f(j, l)) && p(), l.push({ type: "table", content: j }));
      }
      c = [];
    }
    if (A.startsWith("```")) {
      if (u.length === 0)
        u.push(A);
      else {
        if (u.push(A), u.length > o)
          zZt(u, 23).forEach((M, j) => {
            (j > 0 || f(M, l)) && p(), l.push({
              type: "content",
              content: bi.render(M)
            });
          });
        else {
          const L = u.join(`
`);
          f(L, l) && p(), l.push({
            type: "content",
            content: bi.render(L)
          });
        }
        u = [];
      }
      continue;
    }
    if (u.length > 0) {
      u.push(g[x]);
      continue;
    }
    if (A.match(/!\[.*\]\(.*\)/)) {
      const L = A.match(/!\[(.*)\]\((.*)\)/);
      if (L) {
        const M = l.length > 0 && l[0].type === "h2" && l.length > 1, D = l.reduce((z, H) => {
          if (H.type === "content") {
            const F = H.content.split(`
`).filter((_) => _.trim().length > 0).reduce((_, W) => {
              const G = W.replace(/<[^>]+>/g, ""), Y = Math.ceil(G.length / 200);
              return _ + Math.max(1, Y);
            }, 0);
            return z + F;
          }
          return z + 1;
        }, 0) > o - 3;
        (D || !M && l.some((z) => z.type === "image") || l.length === 0 && f(A, l)) && p(), l.push({ type: "image", content: L[2] }), (!M || D) && p();
      }
      continue;
    }
    if (A.length > 0) {
      const L = l.length === 1 && (l[0].type === "h2" || l[0].type === "h3"), M = A.includes("[ ]") || A.includes("[x]") || A.includes("[X]"), j = l.length > 0 ? (((b = (w = l[l.length - 1]) == null ? void 0 : w.content) == null ? void 0 : b.match(
        /<li class="task-list-item">/g
      )) || []).length : 0;
      (M && j >= 6 || !L && f(A, l)) && (l.length && l[l.length - 1].type === "content" && l[l.length - 1].content.includes(
        '<ul class="task-list">'
      ) && (l[l.length - 1].content += "</ul>"), p()), l = h(A, l, {
        maxCharsPerSlide: 1100
      });
    }
  }
  if (c.length > 0) {
    const x = m(c);
    for (let A = 0; A < x.length; A++) {
      const L = x[A];
      L && (f(L, l) && p(), l.push({ type: "table", content: L }));
    }
  }
  p();
  let k = s.map((x) => x.map((A) => {
    switch (A.type) {
      case "h1":
        return `<h1>${A.content}</h1>`;
      case "h2":
        return `<h2>${A.content}</h2>`;
      case "image":
        return `<img src="${A.content}" class="slide-image"/>`;
      case "table":
        return A.content;
      default:
        return bi.render(A.content);
    }
  }).filter(Boolean).join(`
`)).filter(Boolean).join(`
<div data-type="page-break" data-page-break="true"></div>
`);
  return n && (k = k.replace(/\n+/g, `
`).replace(/>\n+</g, `>
<`)), r && (k = vJ.sanitize(k)), k;
}
const BZt = ({
  content: t,
  editor: e,
  onTouchStart: n,
  onTouchMove: r,
  onTouchEnd: i,
  isFullscreen: a
}) => {
  const o = (s) => {
    const c = new DOMParser().parseFromString(s, "text/html");
    return !!c.querySelector("img.slide-image") && c.body.children.length === 1;
  };
  return ze(() => {
    setTimeout(() => {
      e.commands.setContent(t), o(t) ? e.view.dom.classList.add("solo-slide-image") : e.view.dom.classList.remove("solo-slide-image");
    });
  }, [t]), /* @__PURE__ */ C.jsx(
    Px,
    {
      editor: e,
      className: be("presentation-mode", {
        fullscreen: a
      }),
      onTouchStart: n,
      onTouchMove: r,
      onTouchEnd: i
    }
  );
}, HZt = ({
  editor: t,
  onClose: e,
  isFullscreen: n,
  setIsFullscreen: r,
  onError: i,
  setCommentDrawerOpen: a,
  sharedSlidesLink: o,
  isPreviewMode: s,
  documentName: l,
  onSlidesShare: c,
  slides: u,
  setSlides: d,
  renderThemeToggle: f
}) => {
  const [h, p] = De(!1), [m, g] = De(0), [v, k] = De(!0), { isNativeMobile: w } = Kc(), [b, x] = De(null), [A, L] = De(null), M = 50, [j, D] = De(
    "forward"
  ), z = mF(
    {
      extensions: t.extensionManager.extensions.filter(
        (Z) => Z.name !== "collaboration"
      ),
      editable: !1
    },
    []
  ), H = async () => {
    if (!t) return;
    if (t.view.dom.querySelector(".is-editor-empty")) {
      e(), i == null || i("Cannot enter presentation mode with empty content");
      return;
    }
    k(!0);
    const ee = await AZt(t), ae = OZt(ee, {
      preserveNewlines: !0,
      sanitize: !0,
      maxCharsPerSlide: 1e3,
      maxWordsPerSlide: 250,
      maxLinesPerSlide: 7
    }), fe = document.createElement("div");
    fe.innerHTML = ae;
    const me = [];
    let ge = [];
    if (fe.childNodes.forEach(($) => {
      if ($ instanceof HTMLElement && $.getAttribute("data-type") === "page-break" && $.getAttribute("data-page-break") === "true") {
        if (ge.length > 0) {
          const se = document.createElement("div");
          ge.forEach(
            (xe) => se.appendChild(xe.cloneNode(!0))
          ), me.push(se.innerHTML), ge = [];
        }
      } else
        ge.push($.cloneNode(!0));
    }), ge.length > 0) {
      const $ = document.createElement("div");
      ge.forEach(
        (se) => $.appendChild(se.cloneNode(!0))
      ), me.push($.innerHTML);
    }
    d(me.filter(($) => $.trim().length > 0)), k(!1);
  };
  ze(() => {
    H();
  }, [t]);
  const V = nt(() => {
    w ? r((Z) => !Z) : document.fullscreenElement ? document.exitFullscreen ? document.exitFullscreen().then(() => r(!1)).catch(() => {
      r(!1);
    }) : r(!1) : document.documentElement.requestFullscreen ? document.documentElement.requestFullscreen().then(() => r(!0)).catch(() => {
      r(!0);
    }) : r(!0);
  }, [w]), F = nt(
    (Z) => {
      Z.key === "ArrowRight" || Z.key === "ArrowDown" || Z.code === "Space" ? (Z.preventDefault(), Z.stopPropagation(), D("forward"), g((oe) => Math.min(oe + 1, u.length - 1))) : Z.key === "ArrowLeft" || Z.key === "ArrowUp" ? (D("backward"), g((oe) => Math.max(oe - 1, 0))) : Z.key === "Escape" ? !s && e() : (Z.key === "f" || Z.key === "F") && V();
    },
    [u.length, e, V]
  );
  ze(() => (window.addEventListener("keydown", F), () => window.removeEventListener("keydown", F)), [u.length, m]), ze(() => {
    const Z = () => {
      !w && !document.fullscreenElement && r(!1);
    };
    return document.addEventListener("fullscreenchange", Z), () => {
      document.removeEventListener("fullscreenchange", Z);
    };
  }, [w]);
  const _ = (Z) => {
    L(null), x(Z.targetTouches[0].clientX);
  }, W = (Z) => {
    L(Z.targetTouches[0].clientX);
  }, G = nt(() => {
    if (!b || !A) return;
    const Z = b - A, oe = Z > M, ee = Z < -50;
    oe && (D("forward"), g((ae) => Math.min(ae + 1, u.length - 1))), ee && (D("backward"), g((ae) => Math.max(ae - 1, 0)));
  }, [b, A, u.length, M]), Y = () => {
    if (o) {
      IZt(o), p(!0), c == null || c();
      const Z = setTimeout(() => {
        p(!1);
      }, 2e3);
      return () => clearTimeout(Z);
    }
  };
  return v ? /* @__PURE__ */ C.jsx("div", { className: "fixed inset-0 color-bg-default flex flex-col items-center justify-center w-screen h-screen z-50", children: /* @__PURE__ */ C.jsx("div", { className: "flex flex-col items-center gap-4", children: /* @__PURE__ */ C.jsx(
    Eft,
    {
      text: s ? "Loading slides..." : "Building slides..."
    }
  ) }) }) : u.length === 0 || !z ? null : /* @__PURE__ */ C.jsxs(
    "div",
    {
      className: be(
        "fixed inset-0 color-bg-secondary flex z-50",
        w ? "flex-col" : "flex-col xl:flex-row",
        "items-center justify-center w-screen h-screen"
      ),
      children: [
        !n && /* @__PURE__ */ C.jsx(
          SZt,
          {
            slides: u,
            currentSlide: m,
            setCurrentSlide: g
          }
        ),
        /* @__PURE__ */ C.jsxs(
          "div",
          {
            className: be(
              "flex-1 h-full flex flex-col items-center justify-center",
              {
                "w-full": n
              }
            ),
            children: [
              !n && /* @__PURE__ */ C.jsxs("div", { className: "absolute top-0 px-4 py-2 border-b color-border-default right-0 flex gap-2 color-bg-default w-full justify-between z-50", children: [
                s ? /* @__PURE__ */ C.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ C.jsx("p", { className: "max-w-[300px] truncate md:max-w-full w-full", children: l }) }) : /* @__PURE__ */ C.jsxs("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ C.jsx(
                    mn,
                    {
                      variant: "ghost",
                      onClick: e,
                      icon: "ChevronLeft",
                      size: "md"
                    }
                  ),
                  /* @__PURE__ */ C.jsx(k0, { className: "hidden xl:block text-body-sm-bold color-text-default", children: "Back to Editor" })
                ] }),
                /* @__PURE__ */ C.jsxs("div", { className: "flex justify-center items-center gap-2", children: [
                  f == null ? void 0 : f(),
                  !s && /* @__PURE__ */ C.jsx(En, { text: "Download", sideOffset: 10, children: /* @__PURE__ */ C.jsx(
                    mn,
                    {
                      variant: "ghost",
                      onClick: () => EY(u),
                      icon: "FilePdf",
                      size: "md"
                    }
                  ) }),
                  /* @__PURE__ */ C.jsx(En, { text: "Comments", sideOffset: 10, children: /* @__PURE__ */ C.jsx(
                    mn,
                    {
                      variant: "ghost",
                      icon: "MessageSquareText",
                      size: "md",
                      onClick: () => a == null ? void 0 : a((Z) => !Z)
                    }
                  ) }),
                  !s && /* @__PURE__ */ C.jsxs(
                    En,
                    {
                      text: o ? "Copy to Share" : "Link is preparing...",
                      sideOffset: 10,
                      children: [
                        /* @__PURE__ */ C.jsx(
                          mn,
                          {
                            variant: "ghost",
                            icon: "Link",
                            disabled: !o,
                            className: "disabled:!bg-transparent disabled:pointer-events-none",
                            size: "md",
                            onClick: Y
                          }
                        ),
                        h && /* @__PURE__ */ C.jsx(
                          y9,
                          {
                            align: "center",
                            sideOffset: 15,
                            controlled: !0,
                            isOpen: h,
                            onClose: () => p == null ? void 0 : p(!1),
                            content: /* @__PURE__ */ C.jsx("div", { className: "flex items-start gap-3 bg-black color-text-inverse rounded shadow-elevation-3 p-2 text-helper-text-sm", children: "Link copied" })
                          },
                          "link-copied"
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ C.jsx(En, { text: "Press F to toggle fullscreen", sideOffset: 10, children: /* @__PURE__ */ C.jsx(
                    mn,
                    {
                      variant: "ghost",
                      onClick: V,
                      icon: n ? "Minimize2" : "Play",
                      size: "md"
                    }
                  ) })
                ] })
              ] }),
              /* @__PURE__ */ C.jsx(
                "div",
                {
                  className: be(
                    "w-full flex items-center justify-center",
                    n ? "h-screen p-0" : "h-[75vh] p-8"
                  ),
                  children: /* @__PURE__ */ C.jsx(
                    "div",
                    {
                      className: be(
                        "w-full color-bg-default rounded-lg overflow-hidden relative",
                        n ? "h-full max-w-none flex items-start justify-center" : "px-8 md:px-0 scale-[0.35] md:scale-[0.75] xl:scale-100 min-w-[1080px] max-w-[1080px] aspect-video py-[48px]"
                      ),
                      style: {
                        transformOrigin: "center"
                      },
                      children: /* @__PURE__ */ C.jsx(FA, { isPreviewMode: !0, isPresentationMode: !0, children: n ? /* @__PURE__ */ C.jsx(Gp, { mode: "wait", children: /* @__PURE__ */ C.jsx(
                        Qp.div,
                        {
                          initial: {
                            opacity: 0,
                            x: j === "forward" ? 50 : -50
                          },
                          animate: { opacity: 1, x: 0 },
                          exit: {
                            opacity: 0,
                            x: j === "forward" ? -50 : 50
                          },
                          transition: { duration: 0.2 },
                          children: /* @__PURE__ */ C.jsx(
                            "div",
                            {
                              className: be(
                                "presentation-mode fullscreen w-full h-full"
                              ),
                              dangerouslySetInnerHTML: { __html: u[m] },
                              onTouchStart: _,
                              onTouchMove: W,
                              onTouchEnd: G
                            }
                          )
                        },
                        m
                      ) }) : /* @__PURE__ */ C.jsx(
                        BZt,
                        {
                          content: u[m],
                          editor: z,
                          onTouchStart: _,
                          onTouchMove: W,
                          onTouchEnd: G,
                          isFullscreen: n
                        }
                      ) })
                    }
                  )
                }
              ),
              n && /* @__PURE__ */ C.jsx("div", { className: "absolute bottom-8 left-[50%] translate-x-[-50%] z-50 opacity-0 transition-opacity duration-300 ease-in-out hover:opacity-100", children: /* @__PURE__ */ C.jsx("div", { className: "color-utility-overlay rounded-full px-4 py-2", children: /* @__PURE__ */ C.jsxs("p", { className: "color-text-inverse text-helper-text-sm", children: [
                "Press ",
                /* @__PURE__ */ C.jsx("strong", { children: "ESC" }),
                " to exit fullscreen"
              ] }) }) }),
              n && w && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
                /* @__PURE__ */ C.jsx("div", { className: "fixed top-2 right-4 z-50", children: /* @__PURE__ */ C.jsx(
                  mn,
                  {
                    variant: "ghost",
                    onClick: V,
                    icon: "X",
                    size: "md"
                  }
                ) }),
                /* @__PURE__ */ C.jsx("div", { className: "fixed bottom-4 right-4 z-50 flex items-center gap-2 color-utility-overlay px-3 py-1 rounded", children: /* @__PURE__ */ C.jsxs("span", { className: "color-text-default", children: [
                  m + 1,
                  " / ",
                  u.length
                ] }) })
              ] })
            ]
          }
        )
      ]
    }
  );
}, FZt = ({
  username: t,
  setUsername: e,
  isNavbarVisible: n,
  isConnected: r,
  connectViaUsername: i,
  connectViaWallet: a,
  isLoading: o
}) => /* @__PURE__ */ C.jsx(
  "div",
  {
    className: be(
      "flex flex-col h-screen xl:!h-[80vh] !color-bg-default !rounded-b-lg",
      !n && "xl:!h-[calc(100vh-150px)]"
    ),
    children: /* @__PURE__ */ C.jsxs(
      "div",
      {
        className: be(
          "w-full px-6 h-full flex flex-col justify-center items-center"
        ),
        children: [
          /* @__PURE__ */ C.jsxs("div", { className: "inline-flex gap-2", children: [
            /* @__PURE__ */ C.jsx(Ye, { name: "Users", className: "w-6 h-6" }),
            "What would you like to be identified with"
          ] }),
          /* @__PURE__ */ C.jsxs("div", { className: "pt-4 w-full", children: [
            " ",
            /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col gap-2", children: [
              /* @__PURE__ */ C.jsxs("div", { className: "flex gap-3 mt-2", children: [
                /* @__PURE__ */ C.jsx(
                  al,
                  {
                    type: "text",
                    value: t,
                    onChange: (s) => e == null ? void 0 : e(s.target.value),
                    onKeyDown: (s) => {
                      s.key === "Enter" && t && (i == null || i(t));
                    },
                    className: "font-normal",
                    placeholder: "Enter a name"
                  }
                ),
                /* @__PURE__ */ C.jsx(
                  Kt,
                  {
                    onClick: () => i == null ? void 0 : i(t),
                    disabled: !t || o,
                    isLoading: o,
                    className: "min-w-[80px]",
                    children: "Join"
                  }
                )
              ] }),
              /* @__PURE__ */ C.jsxs("div", { className: "text-[12px] text-gray-400 flex items-center my-3", children: [
                /* @__PURE__ */ C.jsx(
                  r0,
                  {
                    direction: "horizontal",
                    size: "md",
                    className: "flex-grow md:!mr-4"
                  }
                ),
                "or join with your ",
                /* @__PURE__ */ C.jsx("span", { className: "font-semibold", children: ".eth " }),
                " domain",
                /* @__PURE__ */ C.jsx(
                  r0,
                  {
                    direction: "horizontal",
                    size: "md",
                    className: "flex-grow md:!ml-4"
                  }
                )
              ] }),
              /* @__PURE__ */ C.jsx("div", { className: "text-center", children: /* @__PURE__ */ C.jsxs(
                Kt,
                {
                  onClick: r ? () => null : a,
                  disabled: o,
                  className: "custom-ens-button",
                  children: [
                    /* @__PURE__ */ C.jsx("img", { alt: "ens-logo", src: Wp }),
                    " ",
                    o ? "Connecting with ENS ..." : "Continue with ENS"
                  ]
                }
              ) })
            ] })
          ] })
        ]
      }
    )
  }
), _Zt = "data:image/svg+xml,%3csvg%20width='192'%20height='160'%20viewBox='0%200%20192%20160'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10%200.5H182C186.142%200.5%20189.5%203.85786%20189.5%208V40C189.5%2044.1421%20186.142%2047.5%20182%2047.5H10C5.85786%2047.5%202.5%2044.1421%202.5%2040V8C2.5%203.85787%205.85786%200.5%2010%200.5Z'%20fill='white'/%3e%3cpath%20d='M10%200.5H182C186.142%200.5%20189.5%203.85786%20189.5%208V40C189.5%2044.1421%20186.142%2047.5%20182%2047.5H10C5.85786%2047.5%202.5%2044.1421%202.5%2040V8C2.5%203.85787%205.85786%200.5%2010%200.5Z'%20stroke='%23E8EBEC'/%3e%3cpath%20d='M14%2024C14%2015.1634%2021.1634%208%2030%208V8C38.8366%208%2046%2015.1634%2046%2024V24C46%2032.8366%2038.8366%2040%2030%2040V40C21.1634%2040%2014%2032.8366%2014%2024V24Z'%20fill='%23E8EBEC'/%3e%3cpath%20d='M56%2015C56%2012.7909%2057.7909%2011%2060%2011H174C176.209%2011%20178%2012.7909%20178%2015V18C178%2020.2091%20176.209%2022%20174%2022H60C57.7909%2022%2056%2020.2091%2056%2018V15Z'%20fill='%23E8EBEC'/%3e%3cpath%20d='M56%2030C56%2027.7909%2057.7909%2026%2060%2026H112C114.209%2026%20116%2027.7909%20116%2030V33C116%2035.2091%20114.209%2037%20112%2037H60C57.7909%2037%2056%2035.2091%2056%2033V30Z'%20fill='%23E8EBEC'/%3e%3cg%20filter='url(%23filter0_d_4765_56257)'%3e%3cpath%20d='M2%2064C2%2059.5817%205.58172%2056%2010%2056H182C186.418%2056%20190%2059.5817%20190%2064V96C190%20100.418%20186.418%20104%20182%20104H10C5.58172%20104%202%20100.418%202%2096V64Z'%20fill='white'/%3e%3cpath%20d='M10%2056.5H182C186.142%2056.5%20189.5%2059.8579%20189.5%2064V96C189.5%20100.142%20186.142%20103.5%20182%20103.5H10C5.85786%20103.5%202.5%20100.142%202.5%2096V64C2.5%2059.8579%205.85786%2056.5%2010%2056.5Z'%20stroke='%23EFC703'/%3e%3cpath%20d='M14%2080C14%2071.1634%2021.1634%2064%2030%2064V64C38.8366%2064%2046%2071.1634%2046%2080V80C46%2088.8366%2038.8366%2096%2030%2096V96C21.1634%2096%2014%2088.8366%2014%2080V80Z'%20fill='%23E8EBEC'/%3e%3cpath%20d='M56%2071C56%2068.7909%2057.7909%2067%2060%2067H174C176.209%2067%20178%2068.7909%20178%2071V74C178%2076.2091%20176.209%2078%20174%2078H60C57.7909%2078%2056%2076.2091%2056%2074V71Z'%20fill='%23E8EBEC'/%3e%3cpath%20d='M56%2086C56%2083.7909%2057.7909%2082%2060%2082H112C114.209%2082%20116%2083.7909%20116%2086V89C116%2091.2091%20114.209%2093%20112%2093H60C57.7909%2093%2056%2091.2091%2056%2089V86Z'%20fill='%23E8EBEC'/%3e%3c/g%3e%3cpath%20d='M10%20112.5H182C186.142%20112.5%20189.5%20115.858%20189.5%20120V152C189.5%20156.142%20186.142%20159.5%20182%20159.5H10C5.85786%20159.5%202.5%20156.142%202.5%20152V120C2.5%20115.858%205.85786%20112.5%2010%20112.5Z'%20fill='white'/%3e%3cpath%20d='M10%20112.5H182C186.142%20112.5%20189.5%20115.858%20189.5%20120V152C189.5%20156.142%20186.142%20159.5%20182%20159.5H10C5.85786%20159.5%202.5%20156.142%202.5%20152V120C2.5%20115.858%205.85786%20112.5%2010%20112.5Z'%20stroke='%23E8EBEC'/%3e%3cpath%20d='M14%20136C14%20127.163%2021.1634%20120%2030%20120V120C38.8366%20120%2046%20127.163%2046%20136V136C46%20144.837%2038.8366%20152%2030%20152V152C21.1634%20152%2014%20144.837%2014%20136V136Z'%20fill='%23E8EBEC'/%3e%3cpath%20d='M56%20127C56%20124.791%2057.7909%20123%2060%20123H174C176.209%20123%20178%20124.791%20178%20127V130C178%20132.209%20176.209%20134%20174%20134H60C57.7909%20134%2056%20132.209%2056%20130V127Z'%20fill='%23E8EBEC'/%3e%3cpath%20d='M56%20142C56%20139.791%2057.7909%20138%2060%20138H112C114.209%20138%20116%20139.791%20116%20142V145C116%20147.209%20114.209%20149%20112%20149H60C57.7909%20149%2056%20147.209%2056%20145V142Z'%20fill='%23E8EBEC'/%3e%3crect%20x='2'%20width='188'%20height='56'%20fill='url(%23paint0_linear_4765_56257)'/%3e%3crect%20x='2'%20y='104'%20width='188'%20height='56'%20fill='url(%23paint1_linear_4765_56257)'/%3e%3cdefs%3e%3cfilter%20id='filter0_d_4765_56257'%20x='0'%20y='55'%20width='192'%20height='52'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='1'/%3e%3cfeGaussianBlur%20stdDeviation='1'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200.937255%200%200%200%200%200.780392%200%200%200%200%200.0117647%200%200%200%200.32%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow_4765_56257'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow_4765_56257'%20result='shape'/%3e%3c/filter%3e%3clinearGradient%20id='paint0_linear_4765_56257'%20x1='96'%20y1='0'%20x2='96'%20y2='56'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_4765_56257'%20x1='96'%20y1='160'%20x2='96'%20y2='104'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", VZt = "data:image/svg+xml,%3csvg%20width='192'%20height='160'%20viewBox='0%200%20192%20160'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M2.5%208C2.5%203.85787%205.85786%200.5%2010%200.5H182C186.142%200.5%20189.5%203.85786%20189.5%208V40C189.5%2044.1421%20186.142%2047.5%20182%2047.5H10C5.85786%2047.5%202.5%2044.1421%202.5%2040V8Z'%20fill='%232E2E2E'/%3e%3cpath%20d='M2.5%208C2.5%203.85787%205.85786%200.5%2010%200.5H182C186.142%200.5%20189.5%203.85786%20189.5%208V40C189.5%2044.1421%20186.142%2047.5%20182%2047.5H10C5.85786%2047.5%202.5%2044.1421%202.5%2040V8Z'%20stroke='%23404040'/%3e%3cpath%20d='M14%2024C14%2015.1634%2021.1634%208%2030%208C38.8366%208%2046%2015.1634%2046%2024C46%2032.8366%2038.8366%2040%2030%2040C21.1634%2040%2014%2032.8366%2014%2024Z'%20fill='%23404040'/%3e%3cpath%20d='M56%2015C56%2012.7909%2057.7909%2011%2060%2011H174C176.209%2011%20178%2012.7909%20178%2015V18C178%2020.2091%20176.209%2022%20174%2022H60C57.7909%2022%2056%2020.2091%2056%2018V15Z'%20fill='%23404040'/%3e%3cpath%20d='M56%2030C56%2027.7909%2057.7909%2026%2060%2026H112C114.209%2026%20116%2027.7909%20116%2030V33C116%2035.2091%20114.209%2037%20112%2037H60C57.7909%2037%2056%2035.2091%2056%2033V30Z'%20fill='%23404040'/%3e%3cg%20filter='url(%23filter0_d_5573_80525)'%3e%3cpath%20d='M2%2064C2%2059.5817%205.58172%2056%2010%2056H182C186.418%2056%20190%2059.5817%20190%2064V96C190%20100.418%20186.418%20104%20182%20104H10C5.58172%20104%202%20100.418%202%2096V64Z'%20fill='%232E2E2E'/%3e%3cpath%20d='M2.5%2064C2.5%2059.8579%205.85786%2056.5%2010%2056.5H182C186.142%2056.5%20189.5%2059.8579%20189.5%2064V96C189.5%20100.142%20186.142%20103.5%20182%20103.5H10C5.85786%20103.5%202.5%20100.142%202.5%2096V64Z'%20stroke='%23EFC703'/%3e%3cpath%20d='M14%2080C14%2071.1634%2021.1634%2064%2030%2064C38.8366%2064%2046%2071.1634%2046%2080C46%2088.8366%2038.8366%2096%2030%2096C21.1634%2096%2014%2088.8366%2014%2080Z'%20fill='%23404040'/%3e%3cpath%20d='M56%2071C56%2068.7909%2057.7909%2067%2060%2067H174C176.209%2067%20178%2068.7909%20178%2071V74C178%2076.2091%20176.209%2078%20174%2078H60C57.7909%2078%2056%2076.2091%2056%2074V71Z'%20fill='%23404040'/%3e%3cpath%20d='M56%2086C56%2083.7909%2057.7909%2082%2060%2082H112C114.209%2082%20116%2083.7909%20116%2086V89C116%2091.2091%20114.209%2093%20112%2093H60C57.7909%2093%2056%2091.2091%2056%2089V86Z'%20fill='%23404040'/%3e%3c/g%3e%3cpath%20d='M2.5%20120C2.5%20115.858%205.85786%20112.5%2010%20112.5H182C186.142%20112.5%20189.5%20115.858%20189.5%20120V152C189.5%20156.142%20186.142%20159.5%20182%20159.5H10C5.85786%20159.5%202.5%20156.142%202.5%20152V120Z'%20fill='%232E2E2E'/%3e%3cpath%20d='M2.5%20120C2.5%20115.858%205.85786%20112.5%2010%20112.5H182C186.142%20112.5%20189.5%20115.858%20189.5%20120V152C189.5%20156.142%20186.142%20159.5%20182%20159.5H10C5.85786%20159.5%202.5%20156.142%202.5%20152V120Z'%20stroke='%23404040'/%3e%3cpath%20d='M14%20136C14%20127.163%2021.1634%20120%2030%20120C38.8366%20120%2046%20127.163%2046%20136C46%20144.837%2038.8366%20152%2030%20152C21.1634%20152%2014%20144.837%2014%20136Z'%20fill='%23404040'/%3e%3cpath%20d='M56%20127C56%20124.791%2057.7909%20123%2060%20123H174C176.209%20123%20178%20124.791%20178%20127V130C178%20132.209%20176.209%20134%20174%20134H60C57.7909%20134%2056%20132.209%2056%20130V127Z'%20fill='%23404040'/%3e%3cpath%20d='M56%20142C56%20139.791%2057.7909%20138%2060%20138H112C114.209%20138%20116%20139.791%20116%20142V145C116%20147.209%20114.209%20149%20112%20149H60C57.7909%20149%2056%20147.209%2056%20145V142Z'%20fill='%23404040'/%3e%3crect%20x='2'%20width='188'%20height='56'%20fill='url(%23paint0_linear_5573_80525)'/%3e%3crect%20x='2'%20y='104'%20width='188'%20height='56'%20fill='url(%23paint1_linear_5573_80525)'/%3e%3cdefs%3e%3cfilter%20id='filter0_d_5573_80525'%20x='0'%20y='55'%20width='192'%20height='52'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='1'/%3e%3cfeGaussianBlur%20stdDeviation='1'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200.937255%200%200%200%200%200.780392%200%200%200%200%200.0117647%200%200%200%200.32%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow_5573_80525'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow_5573_80525'%20result='shape'/%3e%3c/filter%3e%3clinearGradient%20id='paint0_linear_5573_80525'%20x1='96'%20y1='0'%20x2='96'%20y2='56'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%232E2E2E'/%3e%3cstop%20offset='1'%20stop-color='%232E2E2E'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_5573_80525'%20x1='96'%20y1='160'%20x2='96'%20y2='104'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%232E2E2E'/%3e%3cstop%20offset='1'%20stop-color='%232E2E2E'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", qZt = () => {
  const [t, e] = De("light"), n = () => {
    const r = localStorage.getItem("theme");
    return r || "light";
  };
  return ze(() => {
    e(n());
    const r = (o) => {
      o.key === "theme" && o.newValue && e(o.newValue);
    }, i = new MutationObserver((o) => {
      o.forEach((s) => {
        s.type === "attributes" && s.attributeName === "data-theme" && s.target === document.documentElement && e(n());
      });
    });
    i.observe(document.documentElement, { attributes: !0 });
    const a = setInterval(() => {
      const o = n();
      o !== t && e(o);
    }, 0);
    return window.addEventListener("storage", r), () => {
      window.removeEventListener("storage", r), i.disconnect(), clearInterval(a);
    };
  }, [t]), /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col items-center justify-center h-full color-text-default", children: [
    /* @__PURE__ */ C.jsx(
      "img",
      {
        src: t === "dark" ? VZt : _Zt,
        alt: "empty comments"
      }
    ),
    /* @__PURE__ */ C.jsx("div", { className: "text-heading-xsm mt-4", children: "No comments yet" }),
    /* @__PURE__ */ C.jsx("p", { className: "text-body-sm color-text-secondary", children: "Add a comment on the text or in this window" })
  ] });
}, $O = ({
  activeCommentId: t,
  isNavbarVisible: e,
  isPresentationMode: n
}) => {
  const {
    comments: r,
    username: i,
    setUsername: a,
    focusCommentInEditor: o,
    handleReplyChange: s,
    handleCommentChange: l,
    handleCommentKeyDown: c,
    handleReplySubmit: u,
    setOpenReplyId: d,
    handleReplyKeyDown: f,
    openReplyId: h,
    showResolved: p,
    commentsSectionRef: m,
    replySectionRef: g,
    comment: v,
    reply: k,
    handleCommentSubmit: w,
    handleInput: b,
    resolveComment: x,
    unresolveComment: A,
    deleteComment: L,
    isConnected: M,
    connectViaWallet: j,
    isLoading: D,
    connectViaUsername: z,
    isDDocOwner: H,
    getEnsStatus: V,
    ensCache: F
  } = yl(), { isNativeMobile: _ } = Kc(), G = r.filter((ee) => !ee.deleted).filter((ee) => p ? !0 : !ee.resolved).sort(
    (ee, ae) => new Date(ae.createdAt).getTime() - new Date(ee.createdAt).getTime()
  ), Y = (ee) => {
    o(ee), h && h !== ee && d(null);
  }, [Z, oe] = De({
    name: i,
    isEns: !1
  });
  return ze(() => {
    V(i, oe);
  }, [i, F]), ze(() => {
    if (m.current && t) {
      const ee = m.current.querySelector(
        `[data-comment-id="${t}"]`
      );
      ee && setTimeout(() => {
        ee.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      });
    }
  }, [t, m]), M ? /* @__PURE__ */ C.jsxs(
    "div",
    {
      className: be(
        "flex flex-col h-[calc(100vh-120px)] sm:!h-[calc(100vh-40px)] xl:!h-[calc(100vh-210px)] !color-bg-default !rounded-b-lg",
        !e && "xl:!h-[calc(100vh-150px)]",
        n && "xl:!h-[86vh]"
      ),
      children: [
        G.length === 0 ? /* @__PURE__ */ C.jsx(qZt, {}) : /* @__PURE__ */ C.jsx(
          "div",
          {
            ref: m,
            className: "flex flex-col overflow-y-auto no-scrollbar flex-1",
            children: G.map((ee) => {
              var ae, fe;
              return /* @__PURE__ */ C.jsxs(
                "div",
                {
                  "data-comment-id": ee.id,
                  className: be(
                    "flex flex-col w-full box-border transition-all border-b color-border-default hover:color-bg-default-hover last:border-b-0 py-3",
                    ee.id === t && "color-bg-default-selected",
                    ((ae = ee.replies) == null ? void 0 : ae.length) > 0 && "gap-0"
                  ),
                  onClick: () => Y(ee.id),
                  children: [
                    /* @__PURE__ */ C.jsx(
                      zJ,
                      {
                        id: ee.id,
                        activeCommentId: t,
                        username: ee.username,
                        selectedContent: ee.selectedContent,
                        createdAt: ee.createdAt,
                        comment: ee.content,
                        replies: ee.replies,
                        onResolve: x,
                        onUnresolve: A,
                        onDelete: L,
                        isResolved: ee.resolved,
                        isDisabled: ee && !Object.hasOwn(ee, "commentIndex"),
                        isCommentOwner: ee.username === i || H,
                        version: ee.version,
                        emptyComment: !ee.content && !ee.username && !ee.createdAt
                      }
                    ),
                    /* @__PURE__ */ C.jsx(
                      "div",
                      {
                        ref: g,
                        className: be(
                          "pr-6 pl-8 flex flex-col gap-2",
                          h === ee.id && "ml-5 pl-4",
                          ee.resolved && "hidden"
                        ),
                        children: h !== ee.id ? /* @__PURE__ */ C.jsxs(
                          Kt,
                          {
                            onClick: (me) => {
                              me.stopPropagation(), d(ee.id);
                            },
                            className: be(
                              "w-full flex items-center justify-start gap-2 mt-3 hover:!bg-transparent pl-6",
                              ((fe = ee.replies) == null ? void 0 : fe.length) === 0 && "hidden"
                            ),
                            variant: "ghost",
                            children: [
                              /* @__PURE__ */ C.jsx(
                                Ye,
                                {
                                  name: "MessageSquarePlus",
                                  className: "color-text-secondary",
                                  size: "sm"
                                }
                              ),
                              /* @__PURE__ */ C.jsx("span", { className: "text-xs font-medium", children: "Reply to this thread" })
                            ]
                          }
                        ) : /* @__PURE__ */ C.jsxs("div", { className: "pl-4 animate-in fade-in-5 flex flex-col gap-2 duration-300 mt-3", children: [
                          /* @__PURE__ */ C.jsx(
                            Rh,
                            {
                              placeholder: "Reply",
                              value: k,
                              className: be(
                                "color-bg-default text-body-sm color-text-default min-h-[40px] max-h-[96px] overflow-y-auto no-scrollbar px-3 py-2 whitespace-pre-wrap",
                                ee.id === t && "color-bg-default"
                              ),
                              id: ee.id,
                              onChange: s,
                              onKeyDown: f,
                              autoFocus: _,
                              onInput: (me) => b(me, k)
                            }
                          ),
                          ee.id === t && /* @__PURE__ */ C.jsxs(Bx, { className: "w-full justify-end", children: [
                            /* @__PURE__ */ C.jsx(
                              Kt,
                              {
                                variant: "ghost",
                                className: "px-4 py-2 w-20 min-w-20 h-9",
                                onClick: (me) => {
                                  me.stopPropagation(), d(null);
                                },
                                children: "Cancel"
                              }
                            ),
                            /* @__PURE__ */ C.jsx(
                              Kt,
                              {
                                className: "px-4 py-2 w-20 min-w-20 h-9",
                                disabled: !k.trim(),
                                onClick: u,
                                children: "Reply"
                              }
                            )
                          ] })
                        ] })
                      }
                    )
                  ]
                },
                ee.id
              );
            })
          }
        ),
        /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col gap-3 color-bg-secondary border-t border-b color-border-default px-6 py-5 rounded-b-lg", children: [
          /* @__PURE__ */ C.jsxs("div", { className: "flex justify-start items-center gap-2", children: [
            /* @__PURE__ */ C.jsx(
              ap,
              {
                src: Z.isEns ? Wp : `https://api.dicebear.com/9.x/identicon/svg?seed=${encodeURIComponent(
                  Z.name
                )}`,
                size: "sm",
                className: "min-w-6"
              }
            ),
            /* @__PURE__ */ C.jsxs("span", { className: "text-body-sm-bold inline-flex items-center gap-1", children: [
              NJ(Z.name),
              Z.isEns && /* @__PURE__ */ C.jsx("img", { src: OA, alt: "verified", className: "w-3.5 h-3.5" })
            ] })
          ] }),
          /* @__PURE__ */ C.jsx(
            Rh,
            {
              value: v,
              onChange: l,
              onKeyDown: c,
              className: "color-bg-default w-full text-body-sm color-text-default min-h-[40px] max-h-[96px] overflow-y-auto no-scrollbar px-3 py-2 whitespace-pre-wrap",
              placeholder: "Type your comment",
              onInput: (ee) => b(ee, v)
            }
          ),
          /* @__PURE__ */ C.jsx("div", { className: "flex justify-end", children: /* @__PURE__ */ C.jsx(
            Kt,
            {
              onClick: w,
              className: "px-4 py-2 w-20 min-w-20 h-9",
              disabled: !v.trim() || !i,
              children: "Send"
            }
          ) })
        ] })
      ]
    }
  ) : /* @__PURE__ */ C.jsx(
    FZt,
    {
      connectViaWallet: j,
      username: i,
      setUsername: a,
      isNavbarVisible: e,
      connectViaUsername: z,
      isLoading: D
    }
  );
}, UZt = (t) => {
  const e = (n) => {
    n.key === "Escape" && t();
  };
  ze(() => (window.addEventListener("keydown", e), () => {
    window.removeEventListener("keydown", e);
  }), []);
}, WZt = ({
  isOpen: t,
  onClose: e,
  isNavbarVisible: n,
  isPresentationMode: r,
  activeCommentId: i,
  isPreviewMode: a
}) => {
  const { toggleResolved: o, showResolved: s, isConnected: l } = yl(), { isBelow1280px: c } = Kc();
  return UZt(() => {
    e();
  }), /* @__PURE__ */ C.jsx("div", { children: c ? /* @__PURE__ */ C.jsx(
    Uht,
    {
      open: t,
      onOpenChange: e,
      noOverlay: !0,
      side: "right",
      className: Lt(
        "p-0 !w-screen md:!w-[384px] !z-50 !color-bg-default",
        !l && "!h-screen"
      ),
      content: /* @__PURE__ */ C.jsxs(Ce.Fragment, { children: [
        /* @__PURE__ */ C.jsxs("div", { className: "flex p-4 border-b flex-row gap-4 items-center color-bg-default", children: [
          /* @__PURE__ */ C.jsx("p", { className: "text-heading-sm", children: "Comments" }),
          /* @__PURE__ */ C.jsx("div", { className: "absolute top-[2px] right-10 p-2", children: /* @__PURE__ */ C.jsx(
            En,
            {
              text: s ? "Hide resolved" : "Show resolved",
              sideOffset: 0,
              position: "bottom",
              children: /* @__PURE__ */ C.jsx(
                mn,
                {
                  icon: s ? "Eye" : "EyeOff",
                  variant: "ghost",
                  size: "md",
                  className: "p-1 !min-w-8 !w-8 !h-8 aspect-square",
                  onClick: o
                }
              )
            }
          ) })
        ] }),
        /* @__PURE__ */ C.jsx($O, { activeCommentId: i })
      ] })
    }
  ) : /* @__PURE__ */ C.jsx(
    Wht,
    {
      open: t,
      onOpenChange: e,
      side: "right",
      rounded: !0,
      dismissible: !0,
      className: Lt(
        "w-[calc(100vw-24px)] !z-40 md:w-[384px] right-0 shadow-elevation-4 rounded-lg border color-border-default",
        t && "right-2 md:!right-4",
        n ? `h-[calc(98vh-140px)] ${a ? "top-[4rem]" : "top-[7.25rem] "}` : "top-[4rem] h-[calc(100vh-90px)] xl:h-[calc(99vh-90px)]",
        r && "h-[calc(100vh-5rem)] top-[4rem] !z-[60]"
      ),
      headerClassName: "border-b color-border-default p-4 !color-bg-default !rounded-t-lg",
      contentClassName: "!rounded-lg p-0 !h-full select-text color-bg-default",
      title: "Comments",
      content: /* @__PURE__ */ C.jsxs(Ce.Fragment, { children: [
        /* @__PURE__ */ C.jsx("div", { className: "absolute -top-[2px] right-10 p-3", children: /* @__PURE__ */ C.jsx(
          En,
          {
            text: s ? "Hide resolved" : "Show resolved",
            sideOffset: 0,
            position: "bottom",
            children: /* @__PURE__ */ C.jsx(
              mn,
              {
                icon: s ? "Eye" : "EyeOff",
                variant: "ghost",
                size: "md",
                onClick: o,
                className: "p-1 !min-w-8 !w-8 !h-8 aspect-square"
              }
            )
          }
        ) }),
        /* @__PURE__ */ C.jsx(
          $O,
          {
            activeCommentId: i,
            isNavbarVisible: n,
            isPresentationMode: r
          }
        )
      ] })
    }
  ) });
}, ZZt = ({
  editor: t,
  activeCommentId: e,
  commentDrawerOpen: n,
  isCollabDocumentPublished: r
}) => {
  const { comments: i, username: a } = yl(), { isNativeMobile: o } = Kc(), s = i == null ? void 0 : i.find(
    (c) => c.id === e
  ), l = {
    shouldShow: ({ editor: c }) => {
      var f, h;
      const u = (f = c.getAttributes("comment")) == null ? void 0 : f.resolved, d = c.isActive("comment") && !u && r;
      if (d) {
        const p = (h = c.getAttributes("comment")) == null ? void 0 : h.commentId;
        c.commands.setCommentActive(p);
      } else
        c.commands.unsetCommentActive();
      return d;
    },
    onHide: ({ editor: c }) => {
      c.commands.unsetCommentActive();
    },
    tippyOptions: {
      moveTransition: o ? "transform 0.2s ease-in" : "none",
      duration: 200,
      animation: "shift-toward-subtle",
      zIndex: 40,
      offset: [0, 20],
      placement: "bottom",
      appendTo: () => document.getElementById("editor-canvas"),
      followCursor: "vertical",
      interactive: !0,
      inertia: !0,
      trigger: "manual",
      hideOnClick: !0,
      inlinePositioning: !0,
      popperOptions: {
        strategy: "fixed",
        modifiers: [
          {
            name: "flip",
            options: {
              fallbackPlacements: ["top"]
            }
          },
          {
            name: "preventOverflow",
            options: {
              altAxis: !0,
              tether: !1
            }
          }
        ]
      }
    }
  };
  return /* @__PURE__ */ C.jsx(
    zx,
    {
      ...l,
      editor: t,
      className: be(
        "shadow-elevation-4 rounded-lg color-bg-default border color-border-default",
        n && "hidden"
      ),
      children: /* @__PURE__ */ C.jsx(
        RJ,
        {
          activeCommentId: e,
          isBubbleMenu: !0,
          initialComment: s == null ? void 0 : s.content,
          selectedContent: s == null ? void 0 : s.selectedContent,
          isDisabled: s && !Object.hasOwn(s, "commentIndex"),
          isCommentOwner: (s == null ? void 0 : s.username) === a
        }
      )
    }
  );
}, GZt = ({
  item: t,
  onItemClick: e,
  index: n
  // onItemRemove,
}) => /* @__PURE__ */ C.jsx(
  "div",
  {
    "data-index": n,
    style: {
      paddingLeft: `${(t.level - 1) * 8}px`
    },
    className: be(
      "flex items-center transition-all text-body-sm-bold max-[1280px]:h-[32px] max-[1280px]:px-2 max-[1280px]:py-1 h-5 max-[1280px]:max-w-full xl:!max-w-[200px] min-[1440px]:!max-w-[280px] min-[1600px]:!max-w-[320px] xl:border-l-2",
      t.isActive ? "color-border-active color-text-default max-[1280px]:border-none max-[1280px]:bg-[#F8F9FA] max-[1280px]:rounded max-[1280px]:text-[#363B3F]" : "color-text-secondary border-transparent lg:hover:!brightness-90"
    ),
    children: /* @__PURE__ */ C.jsx(
      "a",
      {
        href: `#${t.id}`,
        onClick: (r) => e(r, t.id),
        "data-item-index": t.itemIndex,
        className: "flex items-center justify-between pl-2 gap-1 h-[32px] transition-all no-underline  w-full group",
        children: /* @__PURE__ */ C.jsx("span", { className: "truncate", children: t.textContent })
      }
    )
  }
), YZt = () => /* @__PURE__ */ C.jsx("div", { className: "p-4 text-center text-body-sm color-text-secondary select-none", children: /* @__PURE__ */ C.jsx("p", { children: "Start editing your document to see the outline." }) }), KZt = ({ items: t = [], editor: e, setItems: n }) => {
  const [r, i] = De(null), a = ja("(max-width: 1280px)");
  if (t.length === 0)
    return /* @__PURE__ */ C.jsx(YZt, {});
  const o = (l, c) => {
    if (l.preventDefault(), l.stopPropagation(), i(c), e) {
      const u = e.view.dom.querySelector(`[data-toc-id="${c}"]`);
      if (!u) return;
      const d = setTimeout(() => {
        const f = e.view.posAtDOM(u, 0), h = e.view.state.tr;
        h.setSelection(new ot(h.doc.resolve(f))), e.view.dispatch(h);
        const m = [
          document.querySelector(".ProseMirror"),
          document.getElementById("editor-canvas"),
          u.closest(".ProseMirror"),
          u.closest('[class*="editor"]'),
          e.view.dom.parentElement
        ].filter(Boolean).find(
          (g) => g && (g.scrollHeight > g.clientHeight || window.getComputedStyle(g).overflow === "auto" || window.getComputedStyle(g).overflowY === "auto")
        );
        m && requestAnimationFrame(() => {
          const g = m.getBoundingClientRect(), v = u.getBoundingClientRect(), k = v.top - g.top - g.height / (a ? 5 : 7) + v.height / (a ? 5 : 7);
          m.scrollBy({
            top: k,
            behavior: "smooth"
          });
        });
      }, 0);
      return () => clearTimeout(d);
    }
  }, s = (l, c) => {
    l.preventDefault(), l.stopPropagation(), n((u) => {
      var h;
      const d = u.findIndex((p) => p.id === c), f = u.filter((p) => p.id !== c);
      return c === r && f.length > 0 ? d === u.length - 1 ? o(l, f[f.length - 1].id) : o(l, (h = f[d]) == null ? void 0 : h.id) : f.length === 0 && i(null), f;
    });
  };
  return /* @__PURE__ */ C.jsx("div", { className: "flex flex-col max-[1280px]:gap-2 gap-4 overflow-auto no-scrollbar max-[1280px]:max-h-[168px] max-h-[calc(80vh-40px)] mb-3", children: t.map((l, c) => /* @__PURE__ */ C.jsx(
    GZt,
    {
      onItemClick: o,
      onItemRemove: s,
      item: {
        ...l,
        isActive: l.id === r
      },
      index: c + 1
    },
    l.id
  )) });
}, JO = Ce.memo(KZt), $Zt = ({
  editor: t,
  hasToC: e,
  items: n,
  setItems: r,
  showTOC: i,
  setShowTOC: a,
  isPreviewMode: o
}) => {
  const s = ja("(max-width:1280px)"), l = n.length < 2;
  return s ? /* @__PURE__ */ C.jsx(
    S4t,
    {
      open: i,
      onOpenChange: a,
      className: "w-full shadow-elevation-4",
      contentClassName: "w-full h-full !border-none !shadow-elevation-4 !gap-2",
      footerClassName: "hidden",
      noOverlay: !0,
      hasCloseIcon: !0,
      content: /* @__PURE__ */ C.jsxs(Ce.Fragment, { children: [
        /* @__PURE__ */ C.jsx("div", { className: "flex justify-between items-center p-4", children: /* @__PURE__ */ C.jsx("h2", { className: "text-heading-sm-bold", children: "Document outline" }) }),
        /* @__PURE__ */ C.jsx("div", { className: Lt("table-of-contents px-4"), children: /* @__PURE__ */ C.jsx(JO, { editor: t, items: n, setItems: r }) })
      ] })
    },
    "mobile-toc"
  ) : /* @__PURE__ */ C.jsxs(
    "div",
    {
      className: Lt(
        "flex flex-col gap-4 items-start justify-start absolute left-4",
        (!e || l) && "hidden",
        o ? "top-[4rem]" : "top-[7.3rem]"
      ),
      children: [
        /* @__PURE__ */ C.jsx(
          En,
          {
            text: i ? "Hide document outline" : "Show document outline",
            position: "right",
            children: /* @__PURE__ */ C.jsx(
              mn,
              {
                icon: i ? "ChevronLeft" : "List",
                variant: "ghost",
                size: "lg",
                onClick: () => a == null ? void 0 : a((d) => !d),
                className: "color-text-default min-w-9 h-9"
              }
            )
          }
        ),
        /* @__PURE__ */ C.jsx(
          "div",
          {
            className: Lt(
              "table-of-contents animate-in fade-in slide-in-from-left-5",
              i ? "block" : "hidden"
            ),
            children: /* @__PURE__ */ C.jsx(JO, { editor: t, items: n, setItems: r })
          }
        )
      ]
    }
  );
}, JZt = xn(null), QZt = ({
  children: t
}) => {
  const [e, n] = De(
    /* @__PURE__ */ new Set()
  ), r = Ft(
    () => ({
      collapsedHeadings: e,
      setCollapsedHeadings: n
    }),
    [e]
  );
  return /* @__PURE__ */ C.jsx(JZt.Provider, { value: r, children: t });
}, XZt = () => /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col gap-4", children: [
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-130px)] h-[20px] rounded-sm" }),
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-100px)] h-[20px] rounded-sm" }),
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-300px)] h-[20px] rounded-sm" }),
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-100px)] h-[20px] rounded-sm" }),
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-50px)] h-[20px] rounded-sm" }),
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-130px)] h-[20px] rounded-sm" }),
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-300px)] h-[20px] rounded-sm" }),
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-130px)] h-[20px] rounded-sm" }),
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-100px)] h-[20px] rounded-sm" }),
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-300px)] h-[20px] rounded-sm" }),
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-130px)] h-[20px] rounded-sm" }),
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-50px)] h-[20px] rounded-sm" }),
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-100px)] h-[20px] rounded-sm" }),
  /* @__PURE__ */ C.jsx(hn, { className: " w-[calc(100%-300px)] h-[20px] rounded-sm" })
] }), WGt = en(
  ({
    isPreviewMode: t = !1,
    initialContent: e,
    enableCollaboration: n,
    collaborationId: r,
    username: i,
    setUsername: a,
    renderNavbar: o,
    walletAddress: s,
    onChange: l,
    onCollaboratorChange: c,
    onTextSelection: u,
    onCommentInteraction: d,
    handleCommentButtonClick: f,
    showCommentButton: h,
    ensResolutionUrl: p,
    secureImageUploadUrl: m,
    disableBottomToolbar: g,
    onError: v,
    setCharacterCount: k,
    setWordCount: w,
    tags: b,
    selectedTags: x,
    setSelectedTags: A,
    isCommentSectionOpen: L,
    setIsCommentSectionOpen: M,
    setInlineCommentData: j,
    inlineCommentData: D,
    enableIndexeddbSync: z,
    ddocId: H,
    zoomLevel: V,
    setZoomLevel: F,
    isPresentationMode: _,
    setIsPresentationMode: W,
    isNavbarVisible: G,
    setIsNavbarVisible: Y,
    onComment: Z,
    onInlineComment: oe,
    onMarkdownExport: ee,
    onMarkdownImport: ae,
    onPdfExport: fe,
    editorCanvasClassNames: me,
    sharedSlidesLink: ge,
    documentName: $,
    onInvalidContentError: se,
    ignoreCorruptedData: xe,
    commentDrawerOpen: Oe,
    setCommentDrawerOpen: je,
    initialComments: Me = [],
    onNewComment: he,
    onCommentReply: pe,
    setInitialComments: J,
    onSlidesShare: K,
    onResolveComment: X,
    onUnresolveComment: re,
    onDeleteComment: Ie,
    showTOC: q,
    setShowTOC: S,
    proExtensions: P,
    isConnected: O,
    connectViaWallet: ne,
    isLoading: le,
    connectViaUsername: de,
    isDDocOwner: Pe,
    isCollabDocumentPublished: ve = !0,
    disableInlineComment: Le,
    renderThemeToggle: Re,
    metadataProxyUrl: Ke,
    onCopyHeadingLink: mt,
    footerHeight: pt
  }, Nt) => {
    const [ye, _e] = De(!1), [we, $e] = De(!1), Xe = Ue(null), Be = ja("(min-width: 1500px)"), et = ja("(min-width: 3000px)"), { isNativeMobile: dt, isIOS: ut } = Kc(), [Pt, Vt] = De(!1), kt = Ue(null), sn = (x == null ? void 0 : x.slice(0, 4)) || [], Sn = x ? Math.max(0, x.length - 4) : 0;
    BC(kt, () => {
      Vt(!1);
    }), ze(() => {
      x && x.length <= 4 && Vt(!1);
    }, [x]);
    const {
      editor: ht,
      ref: gn,
      isContentLoading: Jn,
      ydoc: Er,
      refreshYjsIndexedDbProvider: ca,
      activeCommentId: ur,
      setActiveCommentId: Co,
      focusCommentWithActiveId: jl,
      slides: Nl,
      setSlides: R,
      tocItems: ue,
      setTocItems: Ae
    } = bre({
      enableIndexeddbSync: z,
      ddocId: H,
      isPreviewMode: t,
      initialContent: e,
      enableCollaboration: n,
      collaborationId: r,
      walletAddress: s,
      username: i,
      onChange: l,
      onCollaboratorChange: c,
      onCommentInteraction: d,
      ensResolutionUrl: p,
      onError: v,
      setCharacterCount: k,
      setWordCount: w,
      secureImageUploadUrl: m,
      zoomLevel: V,
      onInvalidContentError: se,
      ignoreCorruptedData: xe,
      isPresentationMode: _,
      proExtensions: P,
      metadataProxyUrl: Ke,
      onCopyHeadingLink: mt
    });
    XO(
      Nt,
      () => ({
        getEditor: () => ht,
        getYdoc: () => Er,
        refreshYjsIndexedDbProvider: ca,
        mergeYjsContents: (Te) => {
          const Q = H2(
            Te.map((Se) => j1(Se))
          );
          return p0(Er, Q, "self"), Q2(Q);
        },
        exportContentAsMarkDown: async (Te) => {
          if (ht) {
            const Q = await ht.commands.exportMarkdownFile();
            if (Q) {
              const Se = Q, Fe = document.createElement("a");
              Fe.href = Se, Fe.download = Te, document.body.appendChild(Fe), Fe.click(), document.body.removeChild(Fe), URL.revokeObjectURL(Se);
            }
          }
        }
      }),
      [ht, Er]
    );
    const Ve = (Te) => {
      A == null || A((Q) => {
        if (Q.length >= 6)
          return Q;
        const Se = Te.name.split(",").map((Rt) => {
          const Qt = Rt.trim();
          return (b == null ? void 0 : b.find(
            (Ln) => Ln.name.toLowerCase() === Qt.toLowerCase()
          )) || { name: Qt, color: Te.color };
        }), Fe = [...Q];
        return Se.forEach((Rt) => {
          Fe.some(
            (Qt) => Qt.name.toLowerCase() === Rt.name.toLowerCase()
          ) || Fe.push(Rt);
        }), Fe.slice(0, 6);
      });
    }, ct = (Te) => {
      A == null || A(
        (Q) => Q.filter((Se) => Se.name !== Te)
      );
    }, yt = () => {
      W == null || W(!1);
      const Te = new URL(window.location.href), Q = Te.hash, [Se, Fe] = Q.split("&");
      Fe && Fe.startsWith("slides=") && (Te.hash = Se, window.history.replaceState({}, "", Te.toString()));
    };
    ze(() => {
      if (ht && dt) {
        const { selection: Te } = ht.state, Q = Lg(Te), Se = () => {
          _e(!0);
        }, Fe = () => {
          _e(!1);
        };
        return !Q && ht.on("focus", Se), Q && ht.on("blur", Fe), () => {
          ht.off("focus", Se), ht.off("blur", Fe);
        };
      }
    }, [dt, ht]), ze(() => {
      if (!ht) return;
      const Te = (Se) => {
        Se.key === "Enter" && ht.commands.scrollIntoView();
      }, Q = ht.view.dom;
      return Q.addEventListener("keydown", Te), () => {
        Q.removeEventListener("keydown", Te);
      };
    }, [ht]), ze(() => {
      if (!dt || !ht) return;
      const Te = () => {
        gn.current && gn.current.scrollIntoView();
      }, Q = ht.view.dom;
      return Q.addEventListener("resize", Te), () => {
        Q.removeEventListener("resize", Te);
      };
    }, [ht, gn, dt]);
    const rt = ja("(max-width: 768px)"), tt = () => /* @__PURE__ */ C.jsx(Gp, { children: /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      !t && /* @__PURE__ */ C.jsx(
        "div",
        {
          id: "toolbar",
          className: Lt(
            "z-50 hidden xl:flex items-center justify-center w-full h-[52px] fixed left-0 color-bg-default border-b color-border-default transition-transform duration-300 top-[3.5rem]",
            {
              "translate-y-0": G,
              "translate-y-[-108%]": !G
            }
          ),
          children: /* @__PURE__ */ C.jsx("div", { className: "justify-center items-center grow relative color-text-default", children: /* @__PURE__ */ C.jsx(
            mEt,
            {
              onError: v,
              editor: ht,
              zoomLevel: V,
              setZoomLevel: F,
              isNavbarVisible: G,
              setIsNavbarVisible: Y,
              secureImageUploadUrl: m,
              onMarkdownExport: ee,
              onMarkdownImport: ae,
              onPdfExport: fe,
              isLoading: !ht || Jn
            }
          ) })
        }
      ),
      _ && ht && /* @__PURE__ */ C.jsx(
        HZt,
        {
          editor: ht,
          onClose: yt,
          isFullscreen: we,
          setIsFullscreen: $e,
          onError: v,
          setCommentDrawerOpen: je,
          sharedSlidesLink: ge,
          isPreviewMode: t,
          documentName: $,
          onSlidesShare: K,
          slides: Nl,
          setSlides: R,
          renderThemeToggle: Re
        }
      ),
      ht && /* @__PURE__ */ C.jsx(
        $Zt,
        {
          editor: ht,
          hasToC: !0,
          items: ue,
          setItems: Ae,
          showTOC: q,
          setShowTOC: S,
          isPreviewMode: t || !G
        }
      ),
      /* @__PURE__ */ C.jsxs(
        "div",
        {
          className: Lt(
            "color-bg-default w-full mx-auto rounded",
            !t && (G ? "-mt-[1.5rem] md:!mt-[0.8rem] pt-0 md:pt-[5rem]" : "pt-0 md:pt-[1.5rem]"),
            t && "md:!mt-[1rem] pt-0 md:!pt-[5rem]",
            { "md:!mt-[0.7rem]": !t },
            {
              "-mt-[1.5rem] md:!mt-[0.7rem]": !G && !t
            },
            {
              "max-[1080px]:!mx-auto min-[1081px]:!ml-[18%] min-[1700px]:!mx-auto": L && !dt && V !== "0.5" && V !== "0.75" && V !== "1.4" && V !== "1.5" && V !== "2"
            },
            {
              "!mx-auto": !L || V === "0.5" || V === "0.75" || V === "1.4" || V === "1.5"
            },
            {
              "!ml-0": V === "2" && Be && !et
            },
            {
              "w-[700px] md:max-w-[700px] min-h-[150%]": V === "0.5"
            },
            {
              "w-[800px] md:max-w-[800px] min-h-[200%]": V === "0.75"
            },
            {
              "w-[850px] md:max-w-[850px] min-h-[100%]": V === "1"
            },
            { "w-[70%] md:max-w-[70%] min-h-[200%]": V === "1.4" },
            {
              "w-[1062.5px] md:max-w-[1062.5px] min-h-[100%]": V === "1.5"
            },
            { "w-[1548px] md:max-w-[1548px]": V === "2" }
          ),
          style: {
            transformOrigin: V === "2" && !et ? "left center" : "top center",
            transform: `scaleX(${V})`
          },
          children: [
            /* @__PURE__ */ C.jsxs(
              "div",
              {
                ref: gn,
                className: Lt(
                  "w-full h-full pt-8 md:pt-0",
                  { "custom-ios-padding": ut },
                  { "color-bg-default": V === "1.4" || "1.5" }
                ),
                style: {
                  transformOrigin: "top center",
                  transform: `scaleY(${V})`
                },
                children: [
                  /* @__PURE__ */ C.jsxs("div", { children: [
                    ht && /* @__PURE__ */ C.jsx(
                      PCt,
                      {
                        editor: ht,
                        onError: v,
                        zoomLevel: V,
                        disableInlineComment: Le || !1,
                        setIsCommentSectionOpen: M,
                        inlineCommentData: D,
                        setInlineCommentData: j,
                        isPreviewMode: t,
                        username: i,
                        walletAddress: s,
                        onInlineComment: oe,
                        activeCommentId: ur,
                        isCollabDocumentPublished: ve
                      }
                    ),
                    ht && /* @__PURE__ */ C.jsx(FCt, { editor: ht, appendTo: gn })
                  ] }),
                  !ht || Jn ? Fi(
                    /* @__PURE__ */ C.jsxs("div", { className: `${rt ? "mx-10 mt-10" : "mx-20"}`, children: [
                      /* @__PURE__ */ C.jsx(
                        hn,
                        {
                          className: `${t || rt ? "w-full" : "w-[400px]"}  h-[32px] rounded-sm mb-4`
                        }
                      ),
                      t && /* @__PURE__ */ C.jsx(XZt, {})
                    ] }),
                    "content-transition"
                  ) : _i(
                    /* @__PURE__ */ C.jsxs(FA, { isPreviewMode: t, children: [
                      b && b.length > 0 && /* @__PURE__ */ C.jsxs(
                        "div",
                        {
                          ref: kt,
                          className: Lt(
                            "flex flex-wrap px-4 md:px-8 lg:px-[80px] items-center gap-1 mb-4 mt-4 lg:!mt-0",
                            { "pt-12": t }
                          ),
                          children: [
                            sn.map((Te, Q) => /* @__PURE__ */ C.jsx(
                              Uh,
                              {
                                style: { backgroundColor: Te == null ? void 0 : Te.color },
                                onRemove: () => ct(Te == null ? void 0 : Te.name),
                                isRemovable: !t,
                                className: "!h-6 rounded",
                                children: Te == null ? void 0 : Te.name
                              },
                              Q
                            )),
                            Sn > 0 && !Pt && /* @__PURE__ */ C.jsxs(
                              Kt,
                              {
                                variant: "ghost",
                                className: "!h-6 rounded min-w-fit !px-2 color-bg-secondary text-helper-text-sm",
                                onClick: () => Vt(!0),
                                children: [
                                  "+",
                                  Sn
                                ]
                              }
                            ),
                            Pt && /* @__PURE__ */ C.jsx(
                              Qp.div,
                              {
                                initial: { opacity: 0, height: 0 },
                                animate: { opacity: 1, height: "auto" },
                                exit: { opacity: 0, height: 0 },
                                transition: { duration: 0.3 },
                                className: "flex flex-wrap items-center gap-1",
                                children: x == null ? void 0 : x.slice(4).map((Te, Q) => /* @__PURE__ */ C.jsx(
                                  Uh,
                                  {
                                    style: { backgroundColor: Te == null ? void 0 : Te.color },
                                    onRemove: () => ct(Te == null ? void 0 : Te.name),
                                    isRemovable: !t,
                                    className: "!h-6 rounded",
                                    children: Te == null ? void 0 : Te.name
                                  },
                                  Q + 4
                                ))
                              }
                            ),
                            x && (x == null ? void 0 : x.length) < 6 ? /* @__PURE__ */ C.jsx(
                              YV,
                              {
                                tags: b || [],
                                selectedTags: x,
                                onAddTag: Ve,
                                isPreviewMode: t
                              }
                            ) : null
                          ]
                        }
                      ),
                      /* @__PURE__ */ C.jsx(
                        Px,
                        {
                          editor: ht,
                          id: "editor",
                          className: "w-full h-auto py-4 color-bg-default"
                        }
                      )
                    ] }),
                    "editor-transition"
                  )
                ]
              }
            ),
            h && !dt && /* @__PURE__ */ C.jsx(
              Kt,
              {
                ref: Xe,
                onClick: () => {
                  ht && (f == null || f(ht));
                },
                variant: "ghost",
                className: Lt(
                  "absolute w-12 h-12 color-bg-default rounded-full shadow-xl top-[70px] right-[-23px]"
                ),
                children: /* @__PURE__ */ C.jsx(Ye, { name: "MessageSquareText", size: "sm" })
              }
            )
          ]
        }
      ),
      !t && !g && /* @__PURE__ */ C.jsx(
        "div",
        {
          className: Lt(
            "flex xl:hidden items-center w-full h-[52px] fixed left-0 z-10 px-4 color-bg-default transition-all duration-300 ease-in-out border-b border-color-default",
            ye && "hidden",
            { "top-14": G, "top-0": !G }
          ),
          children: /* @__PURE__ */ C.jsx(
            MZt,
            {
              onError: v,
              editor: ht,
              isKeyboardVisible: ye,
              isNavbarVisible: G,
              setIsNavbarVisible: Y,
              secureImageUploadUrl: m,
              isLoading: !ht || Jn
            }
          )
        }
      ),
      ht && /* @__PURE__ */ C.jsx(
        WZt,
        {
          isOpen: Oe,
          onClose: () => je == null ? void 0 : je(!1),
          isNavbarVisible: G,
          isPresentationMode: _,
          activeCommentId: ur,
          isPreviewMode: t
        }
      ),
      /* @__PURE__ */ C.jsx("div", { children: ht && /* @__PURE__ */ C.jsx(
        ZZt,
        {
          editor: ht,
          activeCommentId: ur,
          commentDrawerOpen: Oe,
          isCollabDocumentPublished: ve
        }
      ) })
    ] }) });
    return /* @__PURE__ */ C.jsx(QZt, { children: /* @__PURE__ */ C.jsx(
      "div",
      {
        className: Lt(
          "w-full",
          _ ? "color-bg-default" : "color-bg-secondary"
        ),
        style: {
          height: t ? `calc(100vh - 52px - ${pt || "0px"})` : G ? `calc(100vh - 108px - ${pt || "0px"})` : `calc(100vh - 52px - ${pt || "0px"})`
        },
        children: /* @__PURE__ */ C.jsxs(
          "div",
          {
            id: "editor-canvas",
            className: Lt(
              "h-[100%] w-full custom-scrollbar",
              !t && (G ? "mt-[6.7rem]" : "mt-[3.3rem]"),
              t && "mt-[3.5rem]",
              {
                "overflow-x-hidden": V !== "2",
                "overflow-x-auto scroll-container": V === "2"
              },
              _ ? "color-bg-default" : "color-bg-secondary",
              me
            ),
            children: [
              /* @__PURE__ */ C.jsx(
                "nav",
                {
                  id: "Navbar",
                  className: Lt(
                    "h-14 color-bg-default py-2 px-4 flex gap-2 items-center justify-between w-screen fixed left-0 top-0 border-b color-border-default z-50 transition-transform duration-300",
                    {
                      "translate-y-0": G,
                      "translate-y-[-100%]": !G || _
                    }
                  ),
                  children: ht && (o == null ? void 0 : o({ editor: ht.getJSON() }))
                }
              ),
              ht ? /* @__PURE__ */ C.jsx(
                I9t,
                {
                  editor: ht,
                  username: i,
                  setUsername: a,
                  activeCommentId: ur,
                  setActiveCommentId: Co,
                  focusCommentWithActiveId: jl,
                  initialComments: Me,
                  setInitialComments: J,
                  onNewComment: he,
                  onCommentReply: pe,
                  onResolveComment: X,
                  onUnresolveComment: re,
                  onDeleteComment: Ie,
                  ensResolutionUrl: p,
                  isConnected: O,
                  connectViaWallet: ne,
                  isLoading: le,
                  connectViaUsername: de,
                  isDDocOwner: Pe,
                  onInlineComment: oe,
                  onComment: Z,
                  setCommentDrawerOpen: je,
                  children: tt()
                }
              ) : tt()
            ]
          }
        )
      }
    ) });
  }
), ZGt = en(
  ({
    isPreviewMode: t = !1,
    initialContent: e,
    enableCollaboration: n,
    collaborationId: r,
    username: i,
    walletAddress: a,
    onChange: o,
    onCollaboratorChange: s,
    onTextSelection: l,
    onCommentInteraction: c,
    ensResolutionUrl: u,
    secureImageUploadUrl: d,
    onError: f,
    setCharacterCount: h,
    setWordCount: p,
    tags: m,
    selectedTags: g,
    setSelectedTags: v,
    className: k,
    unFocused: w
  }, b) => {
    const [x, A] = De(!1), L = Ue(null), M = (g == null ? void 0 : g.slice(0, 4)) || [], j = g ? Math.max(0, g.length - 4) : 0;
    BC(L, () => {
      A(!1);
    }), ze(() => {
      g && g.length <= 4 && A(!1);
    }, [g]);
    const {
      editor: D,
      ref: z,
      isContentLoading: H,
      ydoc: V
    } = bre({
      isPreviewMode: t,
      initialContent: e,
      enableCollaboration: n,
      collaborationId: r,
      walletAddress: a,
      username: i,
      onChange: o,
      onCollaboratorChange: s,
      onCommentInteraction: c,
      ensResolutionUrl: u,
      onError: f,
      setCharacterCount: h,
      setWordCount: p,
      secureImageUploadUrl: d,
      unFocused: w
    });
    XO(
      b,
      () => ({
        getEditor: () => D,
        getYdoc: () => V,
        exportContentAsMarkDown: async (W) => {
          if (D) {
            const G = await D.commands.exportMarkdownFile();
            if (G) {
              const Y = G, Z = document.createElement("a");
              Z.href = Y, Z.download = W, document.body.appendChild(Z), Z.click(), document.body.removeChild(Z), URL.revokeObjectURL(Y);
            }
          }
        }
      }),
      [D, V]
    );
    const F = (W) => {
      const G = W.name.split(",").map((Y) => {
        const Z = Y.trim();
        return (m == null ? void 0 : m.find(
          (ee) => ee.name.toLowerCase() === Z.toLowerCase()
        )) || { name: Z, color: W.color };
      });
      v == null || v((Y) => {
        const Z = [...Y];
        return G.forEach((oe) => {
          Z.some(
            (ee) => ee.name.toLowerCase() === oe.name.toLowerCase()
          ) || Z.push(oe);
        }), Z;
      });
    }, _ = (W) => {
      v == null || v(
        (G) => G.filter((Y) => Y.name !== W)
      );
    };
    return !D || H ? /* @__PURE__ */ C.jsxs("div", { className: "w-auto h-auto flex flex-col gap-4 justify-center items-center", children: [
      /* @__PURE__ */ C.jsx(IJ, {}),
      /* @__PURE__ */ C.jsx("p", { children: "Loading Editor..." })
    ] }) : /* @__PURE__ */ C.jsx("div", { ref: z, className: be("overflow-x-hidden", k), children: /* @__PURE__ */ C.jsxs(FA, { isPreviewMode: t, children: [
      m && m.length > 0 && /* @__PURE__ */ C.jsxs(
        "div",
        {
          ref: L,
          className: "flex flex-wrap px-4 md:px-[80px] lg:!px-[124px] items-center gap-1 mb-4 mt-4 lg:!mt-0",
          children: [
            M.map((W, G) => /* @__PURE__ */ C.jsx(
              Uh,
              {
                style: { backgroundColor: W == null ? void 0 : W.color },
                onRemove: () => _(W == null ? void 0 : W.name),
                isRemovable: !t,
                className: "!h-6 rounded",
                children: W == null ? void 0 : W.name
              },
              G
            )),
            j > 0 && !x && /* @__PURE__ */ C.jsxs(
              Kt,
              {
                variant: "ghost",
                className: "!h-6 rounded min-w-fit !px-2 color-bg-secondary text-helper-text-sm",
                onClick: () => A(!0),
                children: [
                  "+",
                  j
                ]
              }
            ),
            /* @__PURE__ */ C.jsx(Gp, { children: x && /* @__PURE__ */ C.jsx(
              Qp.div,
              {
                initial: { opacity: 0, height: 0 },
                animate: { opacity: 1, height: "auto" },
                exit: { opacity: 0, height: 0 },
                transition: { duration: 0.3 },
                className: "flex flex-wrap items-center gap-1",
                children: g == null ? void 0 : g.slice(4).map((W, G) => /* @__PURE__ */ C.jsx(
                  Uh,
                  {
                    style: { backgroundColor: W == null ? void 0 : W.color },
                    onRemove: () => _(W == null ? void 0 : W.name),
                    isRemovable: !t,
                    className: "!h-6 rounded",
                    children: W == null ? void 0 : W.name
                  },
                  G + 4
                ))
              }
            ) }),
            /* @__PURE__ */ C.jsx(
              YV,
              {
                tags: m || [],
                selectedTags: g,
                onAddTag: F,
                isPreviewMode: t
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ C.jsx(
        Px,
        {
          editor: D,
          id: "editor",
          className: "w-full h-auto py-4"
        }
      )
    ] }) });
  }
), GGt = () => {
  const t = () => {
    const s = new Ll(), l = [
      ...lre(() => null, "", "").filter(
        (u) => u.name !== "characterCount"
      ),
      cre,
      ure,
      _ee.configure({ document: s })
    ];
    return { editor: new np({ extensions: l, autofocus: !1 }), ydoc: s };
  }, e = (s) => Array.isArray(s) || typeof s == "string" && !gre(s), n = (s, l) => {
    const c = s.map((u) => j1(u));
    p0(l, H2(c));
  }, r = (s) => {
    const l = s.map((c) => j1(c));
    return Q2(H2(l));
  }, i = (s, l, c) => {
    if (!l) throw new Error("cannot set content without Editor");
    e(s) ? Array.isArray(s) ? n(s, c) : p0(c, j1(s)) : l.commands.setContent(
      vre({ data: s })
    );
  };
  return {
    setContent: i,
    getEditor: t,
    getYjsConvertor: () => {
      const { editor: s, ydoc: l } = t();
      return {
        convertJSONContentToYjsEncodedString: (c) => (i(c, s, l), Q2(tm(l))),
        cleanup: () => {
          s && s.destroy(), l && l.destroy();
        }
      };
    },
    downloadContentAsMd: async (s, l) => {
      const { editor: c, ydoc: u } = t();
      if (i(s, c, u), c) {
        const d = await c.commands.exportMarkdownFile();
        if (d) {
          const f = d, h = document.createElement("a");
          h.href = f, h.download = l + ".md", document.body.appendChild(h), h.click(), document.body.removeChild(h), URL.revokeObjectURL(f), c.destroy();
        } else
          throw new Error("Failed to generate download url");
      } else
        throw new Error("Editor is not available");
    },
    mergeYjsUpdates: r
  };
};
export {
  We as B,
  WGt as D,
  sh as H,
  ZGt as P,
  hl as a,
  is as b,
  W6 as c,
  U5t as d,
  Bd as e,
  GC as g,
  jY as h,
  nA as i,
  Hr as s,
  GGt as u
};
